(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 86894:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (memoize);


/***/ }),

/***/ 60710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Composite": function() { return /* binding */ Composite; },
  "CompositeItem": function() { return /* binding */ CompositeItem; },
  "FloatingArrow": function() { return /* binding */ FloatingArrow; },
  "FloatingDelayGroup": function() { return /* binding */ FloatingDelayGroup; },
  "FloatingFocusManager": function() { return /* binding */ FloatingFocusManager; },
  "FloatingList": function() { return /* binding */ FloatingList; },
  "FloatingNode": function() { return /* binding */ FloatingNode; },
  "FloatingOverlay": function() { return /* binding */ FloatingOverlay; },
  "FloatingPortal": function() { return /* binding */ FloatingPortal; },
  "FloatingTree": function() { return /* binding */ FloatingTree; },
  "arrow": function() { return /* reexport */ floating_ui_react_dom_arrow; },
  "autoPlacement": function() { return /* reexport */ floating_ui_react_dom_autoPlacement; },
  "autoUpdate": function() { return /* reexport */ autoUpdate; },
  "computePosition": function() { return /* reexport */ floating_ui_dom_computePosition; },
  "detectOverflow": function() { return /* reexport */ floating_ui_dom_detectOverflow; },
  "flip": function() { return /* reexport */ floating_ui_react_dom_flip; },
  "getOverflowAncestors": function() { return /* reexport */ getOverflowAncestors; },
  "hide": function() { return /* reexport */ floating_ui_react_dom_hide; },
  "inline": function() { return /* reexport */ floating_ui_react_dom_inline; },
  "inner": function() { return /* binding */ inner; },
  "limitShift": function() { return /* reexport */ floating_ui_react_dom_limitShift; },
  "offset": function() { return /* reexport */ floating_ui_react_dom_offset; },
  "platform": function() { return /* reexport */ platform; },
  "safePolygon": function() { return /* binding */ safePolygon; },
  "shift": function() { return /* reexport */ floating_ui_react_dom_shift; },
  "size": function() { return /* reexport */ floating_ui_react_dom_size; },
  "useClick": function() { return /* binding */ useClick; },
  "useClientPoint": function() { return /* binding */ useClientPoint; },
  "useDelayGroup": function() { return /* binding */ useDelayGroup; },
  "useDelayGroupContext": function() { return /* binding */ useDelayGroupContext; },
  "useDismiss": function() { return /* binding */ useDismiss; },
  "useFloating": function() { return /* binding */ floating_ui_react_esm_useFloating; },
  "useFloatingNodeId": function() { return /* binding */ useFloatingNodeId; },
  "useFloatingParentNodeId": function() { return /* binding */ useFloatingParentNodeId; },
  "useFloatingPortalNode": function() { return /* binding */ useFloatingPortalNode; },
  "useFloatingRootContext": function() { return /* binding */ useFloatingRootContext; },
  "useFloatingTree": function() { return /* binding */ useFloatingTree; },
  "useFocus": function() { return /* binding */ useFocus; },
  "useHover": function() { return /* binding */ useHover; },
  "useId": function() { return /* binding */ useId; },
  "useInnerOffset": function() { return /* binding */ useInnerOffset; },
  "useInteractions": function() { return /* binding */ useInteractions; },
  "useListItem": function() { return /* binding */ useListItem; },
  "useListNavigation": function() { return /* binding */ useListNavigation; },
  "useMergeRefs": function() { return /* binding */ useMergeRefs; },
  "useRole": function() { return /* binding */ useRole; },
  "useTransitionStatus": function() { return /* binding */ useTransitionStatus; },
  "useTransitionStyles": function() { return /* binding */ useTransitionStyles; },
  "useTypeahead": function() { return /* binding */ useTypeahead; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
;// CONCATENATED MODULE: ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = floating_ui_utils_dom_getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [':popover-open', ':modal'].some(selector => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? floating_ui_utils_dom_getComputedStyle(elementOrCss) : elementOrCss;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function floating_ui_utils_dom_getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}



;// CONCATENATED MODULE: ../../node_modules/@floating-ui/react/dist/floating-ui.react.utils.mjs


function activeElement(doc) {
  let activeElement = doc.activeElement;
  while (((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null) {
    var _activeElement;
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}
function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}
// Avoid Chrome DevTools blue warning.
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map(_ref => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(' ');
  }
  return navigator.userAgent;
}

// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function isVirtualClick(event) {
  // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
  // Try to find a workaround for this. `react-aria` source still has the check.
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  if (isAndroid() && event.pointerType) {
    return event.type === 'click' && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  if (isJSDOM()) return false;
  return !isAndroid() && event.width === 0 && event.height === 0 || isAndroid() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' ||
  // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function isSafari() {
  // Chrome DevTools does not complain about navigator.vendor
  return /apple/i.test(navigator.vendor);
}
function isAndroid() {
  const re = /android/i;
  return re.test(getPlatform()) || re.test(getUserAgent());
}
function isMac() {
  return getPlatform().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function isJSDOM() {
  return getUserAgent().includes('jsdom/');
}
function isMouseLikePointerType(pointerType, strict) {
  // On some Linux machines with Chromium, mouse inputs return a `pointerType`
  // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
  const values = ['mouse', 'pen'];
  if (!strict) {
    values.push('', undefined);
  }
  return values.includes(pointerType);
}
function isReactEvent(event) {
  return 'nativeEvent' in event;
}
function isRootElement(element) {
  return element.matches('html,body');
}
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  }

  // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
  const e = event;
  return e.target != null && node.contains(e.target);
}
function getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}
const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled])," + "[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
  return isHTMLElement(element) && element.matches(TYPEABLE_SELECTOR);
}
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
function isTypeableCombobox(element) {
  if (!element) return false;
  return element.getAttribute('role') === 'combobox' && isTypeableElement(element);
}



;// CONCATENATED MODULE: ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const sides = ['top', 'right', 'bottom', 'left'];
const alignments = ['start', 'end'];
const placements = /*#__PURE__*/sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}



;// CONCATENATED MODULE: ../../node_modules/@floating-ui/react/node_modules/tabbable/dist/index.esm.js
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || lookUp && node && isInert(node.parentNode); // recursive

  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};

/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */
var hasTabIndex = function hasTabIndex(node) {
  return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};

/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */
var getTabIndex = function getTabIndex(node) {
  if (!node) {
    throw new Error('No node provided');
  }
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};

/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */
var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled ||
  // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */(/* unused pure expression or super */ null && (candidateSelectors.concat('iframe').join(',')));
var isFocusable = function isFocusable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};


//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/@floating-ui/react-dom/node_modules/@floating-ui/core/dist/floating-ui.core.mjs



function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1 = alignment !== undefined || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = getAlignment(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      getAlignment(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$filter2;
                const placement = (_overflowsData$filter2 = overflowsData.filter(d => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = getSideAxis(d.placement);
                    return currentSideAxis === initialSideAxis ||
                    // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === 'y';
                  }
                  return true;
                }).map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

function getBoundingRect(rects) {
  const minX = min(...rects.map(rect => rect.left));
  const minY = min(...rects.map(rect => rect.top));
  const maxX = max(...rects.map(rect => rect.right));
  const maxY = max(...rects.map(rect => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(rect => rectToClientRect(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform,
        strategy
      } = state;
      // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
      // ClientRect's bounds, despite the event listener being triggered. A
      // padding of 2 seems to handle this issue.
      const {
        padding = 2,
        x,
        y
      } = evaluate(options, state);
      const nativeClientRects = Array.from((await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) || []);
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = rectToClientRect(getBoundingRect(nativeClientRects));
      const paddingObject = getPaddingObject(padding);
      function getBoundingClientRect() {
        // There are two rects and they are disjoined.
        if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
          // Find the first rect in which the point is fully inside.
          return clientRects.find(rect => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }

        // There are 2 or more connected rects.
        if (clientRects.length >= 2) {
          if (getSideAxis(placement) === 'y') {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = getSide(placement) === 'top';
            const top = firstRect.top;
            const bottom = lastRect.bottom;
            const left = isTop ? firstRect.left : lastRect.left;
            const right = isTop ? firstRect.right : lastRect.right;
            const width = right - left;
            const height = bottom - top;
            return {
              top,
              bottom,
              left,
              right,
              width,
              height,
              x: left,
              y: top
            };
          }
          const isLeftSide = getSide(placement) === 'left';
          const maxRight = max(...clientRects.map(rect => rect.right));
          const minLeft = min(...clientRects.map(rect => rect.left));
          const measureRects = clientRects.filter(rect => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          const left = minLeft;
          const right = maxRight;
          const width = right - left;
          const height = bottom - top;
          return {
            top,
            bottom,
            left,
            right,
            width,
            height,
            x: left,
            y: top
          };
        }
        return fallback;
      }
      const resetRects = await platform.getElementRects({
        reference: {
          getBoundingClientRect
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = ['top', 'left'].includes(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};



;// CONCATENATED MODULE: ../../node_modules/@floating-ui/react-dom/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs





function getCssDimensions(element) {
  const css = floating_ui_utils_dom_getComputedStyle(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = floating_ui_utils_dom_getComputedStyle(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}

function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 :
  // RTL <body> scrollbar.
  getWindowScrollBarX(documentElement, htmlRect));
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (floating_ui_utils_dom_getComputedStyle(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return floating_ui_utils_dom_getComputedStyle(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = floating_ui_utils_dom_getComputedStyle(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = floating_ui_utils_dom_getComputedStyle(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
      // Firefox with layout.scrollbar.side = 3 in about:config to test this.
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function isStaticPositioned(element) {
  return floating_ui_utils_dom_getComputedStyle(element).position === 'static';
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || floating_ui_utils_dom_getComputedStyle(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;

  // Firefox returns the <html> element as the offsetParent if it's non-static,
  // while Chrome and Safari return the <body> element. The <body> element must
  // be used to perform the correct calculations even if the <html> element is
  // non-static.
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};

function isRTL(element) {
  return floating_ui_utils_dom_getComputedStyle(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
const floating_ui_dom_detectOverflow = detectOverflow;

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const floating_ui_dom_offset = offset;

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const floating_ui_dom_autoPlacement = autoPlacement;

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const floating_ui_dom_shift = shift;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const floating_ui_dom_flip = flip;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const floating_ui_dom_size = size;

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const floating_ui_dom_hide = hide;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const floating_ui_dom_arrow = arrow;

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const floating_ui_dom_inline = inline;

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const floating_ui_dom_limitShift = limitShift;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const floating_ui_dom_computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};



;// CONCATENATED MODULE: ../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs






var index = typeof document !== 'undefined' ? react.useLayoutEffect : react.useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef(value) {
  const ref = react.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = react.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = react.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = react.useState(null);
  const [_floating, _setFloating] = react.useState(null);
  const setReference = react.useCallback(node => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = react.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = react.useRef(null);
  const floatingRef = react.useRef(null);
  const dataRef = react.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const openRef = useLatestRef(open);
  const update = react.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    floating_ui_dom_computePosition(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        react_dom.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = react.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = react.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = react.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = react.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return react.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return floating_ui_dom_arrow({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return floating_ui_dom_arrow({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const floating_ui_react_dom_offset = (options, deps) => ({
  ...floating_ui_dom_offset(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const floating_ui_react_dom_shift = (options, deps) => ({
  ...floating_ui_dom_shift(options),
  options: [options, deps]
});

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const floating_ui_react_dom_limitShift = (options, deps) => ({
  ...floating_ui_dom_limitShift(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const floating_ui_react_dom_flip = (options, deps) => ({
  ...floating_ui_dom_flip(options),
  options: [options, deps]
});

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const floating_ui_react_dom_size = (options, deps) => ({
  ...floating_ui_dom_size(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const floating_ui_react_dom_autoPlacement = (options, deps) => ({
  ...floating_ui_dom_autoPlacement(options),
  options: [options, deps]
});

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const floating_ui_react_dom_hide = (options, deps) => ({
  ...floating_ui_dom_hide(options),
  options: [options, deps]
});

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const floating_ui_react_dom_inline = (options, deps) => ({
  ...floating_ui_dom_inline(options),
  options: [options, deps]
});

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const floating_ui_react_dom_arrow = (options, deps) => ({
  ...arrow$1(options),
  options: [options, deps]
});



;// CONCATENATED MODULE: ../../node_modules/@floating-ui/react/dist/floating-ui.react.esm.js










/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */
function useMergeRefs(refs) {
  return react.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return value => {
      refs.forEach(ref => {
        if (typeof ref === 'function') {
          ref(value);
        } else if (ref != null) {
          ref.current = value;
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const SafeReact = {
  ...react_namespaceObject
};

const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function useEffectEvent(callback) {
  const ref = react.useRef(() => {
    if (false) {}
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return react.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
function isDifferentRow(index, cols, prevRow) {
  return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfBounds(listRef, index) {
  return index < 0 || index >= listRef.current.length;
}
function getMinIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    disabledIndices
  });
}
function getMaxIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices
  });
}
function findNonDisabledIndex(listRef, _temp) {
  let {
    startingIndex = -1,
    decrement = false,
    disabledIndices,
    amount = 1
  } = _temp === void 0 ? {} : _temp;
  const list = listRef.current;
  let index = startingIndex;
  do {
    index += decrement ? -amount : amount;
  } while (index >= 0 && index <= list.length - 1 && isDisabled(list, index, disabledIndices));
  return index;
}
function getGridNavigatedIndex(elementsRef, _ref) {
  let {
    event,
    orientation,
    loop,
    rtl,
    cols,
    disabledIndices,
    minIndex,
    maxIndex,
    prevIndex,
    stopEvent: stop = false
  } = _ref;
  let nextIndex = prevIndex;
  if (event.key === ARROW_UP) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = maxIndex;
    } else {
      nextIndex = findNonDisabledIndex(elementsRef, {
        startingIndex: nextIndex,
        amount: cols,
        decrement: true,
        disabledIndices
      });
      if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
        const col = prevIndex % cols;
        const maxCol = maxIndex % cols;
        const offset = maxIndex - (maxCol - col);
        if (maxCol === col) {
          nextIndex = maxIndex;
        } else {
          nextIndex = maxCol > col ? offset : offset - cols;
        }
      }
    }
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }
  if (event.key === ARROW_DOWN) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = minIndex;
    } else {
      nextIndex = findNonDisabledIndex(elementsRef, {
        startingIndex: prevIndex,
        amount: cols,
        disabledIndices
      });
      if (loop && prevIndex + cols > maxIndex) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex % cols - cols,
          amount: cols,
          disabledIndices
        });
      }
    }
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }

  // Remains on the same row/column.
  if (orientation === 'both') {
    const prevRow = floor(prevIndex / cols);
    if (event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT)) {
      stop && stopEvent(event);
      if (prevIndex % cols !== cols - 1) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex,
          disabledIndices
        });
        if (loop && isDifferentRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledIndex(elementsRef, {
            startingIndex: prevIndex - prevIndex % cols - 1,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      }
      if (isDifferentRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    if (event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT)) {
      stop && stopEvent(event);
      if (prevIndex % cols !== 0) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex,
          decrement: true,
          disabledIndices
        });
        if (loop && isDifferentRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledIndex(elementsRef, {
            startingIndex: prevIndex + (cols - prevIndex % cols),
            decrement: true,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex + (cols - prevIndex % cols),
          decrement: true,
          disabledIndices
        });
      }
      if (isDifferentRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    const lastRow = floor(maxIndex / cols) === prevRow;
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      if (loop && lastRow) {
        nextIndex = event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT) ? maxIndex : findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      } else {
        nextIndex = prevIndex;
      }
    }
  }
  return nextIndex;
}

/** For each cell index, gets the item index that occupies that cell */
function buildCellMap(sizes, cols, dense) {
  const cellMap = [];
  let startIndex = 0;
  sizes.forEach((_ref2, index) => {
    let {
      width,
      height
    } = _ref2;
    if (width > cols) {
      if (false) {}
    }
    let itemPlaced = false;
    if (dense) {
      startIndex = 0;
    }
    while (!itemPlaced) {
      const targetCells = [];
      for (let i = 0; i < width; i++) {
        for (let j = 0; j < height; j++) {
          targetCells.push(startIndex + i + j * cols);
        }
      }
      if (startIndex % cols + width <= cols && targetCells.every(cell => cellMap[cell] == null)) {
        targetCells.forEach(cell => {
          cellMap[cell] = index;
        });
        itemPlaced = true;
      } else {
        startIndex++;
      }
    }
  });

  // convert into a non-sparse array
  return [...cellMap];
}

/** Gets cell index of an item's corner or -1 when index is -1. */
function getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
  if (index === -1) return -1;
  const firstCellIndex = cellMap.indexOf(index);
  const sizeItem = sizes[index];
  switch (corner) {
    case 'tl':
      return firstCellIndex;
    case 'tr':
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + sizeItem.width - 1;
    case 'bl':
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + (sizeItem.height - 1) * cols;
    case 'br':
      return cellMap.lastIndexOf(index);
  }
}

/** Gets all cell indices that correspond to the specified indices */
function getCellIndices(indices, cellMap) {
  return cellMap.flatMap((index, cellIndex) => indices.includes(index) ? [cellIndex] : []);
}
function isDisabled(list, index, disabledIndices) {
  if (disabledIndices) {
    return disabledIndices.includes(index);
  }
  const element = list[index];
  return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}

var floating_ui_react_esm_index = typeof document !== 'undefined' ? react.useLayoutEffect : react.useEffect;

function sortByDocumentPosition(a, b) {
  const position = a.compareDocumentPosition(b);
  if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
    return -1;
  }
  if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) {
    return 1;
  }
  return 0;
}
function areMapsEqual(map1, map2) {
  if (map1.size !== map2.size) {
    return false;
  }
  for (const [key, value] of map1.entries()) {
    if (value !== map2.get(key)) {
      return false;
    }
  }
  return true;
}
const FloatingListContext = /*#__PURE__*/react.createContext({
  register: () => {},
  unregister: () => {},
  map: /*#__PURE__*/new Map(),
  elementsRef: {
    current: []
  }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */
function FloatingList(props) {
  const {
    children,
    elementsRef,
    labelsRef
  } = props;
  const [map, setMap] = react.useState(() => new Map());
  const register = react.useCallback(node => {
    setMap(prevMap => new Map(prevMap).set(node, null));
  }, []);
  const unregister = react.useCallback(node => {
    setMap(prevMap => {
      const map = new Map(prevMap);
      map.delete(node);
      return map;
    });
  }, []);
  floating_ui_react_esm_index(() => {
    const newMap = new Map(map);
    const nodes = Array.from(newMap.keys()).sort(sortByDocumentPosition);
    nodes.forEach((node, index) => {
      newMap.set(node, index);
    });
    if (!areMapsEqual(map, newMap)) {
      setMap(newMap);
    }
  }, [map]);
  return /*#__PURE__*/react.createElement(FloatingListContext.Provider, {
    value: react.useMemo(() => ({
      register,
      unregister,
      map,
      elementsRef,
      labelsRef
    }), [register, unregister, map, elementsRef, labelsRef])
  }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */
function useListItem(props) {
  if (props === void 0) {
    props = {};
  }
  const {
    label
  } = props;
  const {
    register,
    unregister,
    map,
    elementsRef,
    labelsRef
  } = react.useContext(FloatingListContext);
  const [index$1, setIndex] = react.useState(null);
  const componentRef = react.useRef(null);
  const ref = react.useCallback(node => {
    componentRef.current = node;
    if (index$1 !== null) {
      elementsRef.current[index$1] = node;
      if (labelsRef) {
        var _node$textContent;
        const isLabelDefined = label !== undefined;
        labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
      }
    }
  }, [index$1, elementsRef, labelsRef, label]);
  floating_ui_react_esm_index(() => {
    const node = componentRef.current;
    if (node) {
      register(node);
      return () => {
        unregister(node);
      };
    }
  }, [register, unregister]);
  floating_ui_react_esm_index(() => {
    const index = componentRef.current ? map.get(componentRef.current) : null;
    if (index != null) {
      setIndex(index);
    }
  }, [map]);
  return react.useMemo(() => ({
    ref,
    index: index$1 == null ? -1 : index$1
  }), [index$1, ref]);
}

function renderJsx(render, computedProps) {
  if (typeof render === 'function') {
    return render(computedProps);
  }
  if (render) {
    return /*#__PURE__*/react.cloneElement(render, computedProps);
  }
  return /*#__PURE__*/react.createElement("div", computedProps);
}
const CompositeContext = /*#__PURE__*/react.createContext({
  activeIndex: 0,
  onNavigate: () => {}
});
const horizontalKeys = [ARROW_LEFT, ARROW_RIGHT];
const verticalKeys = [ARROW_UP, ARROW_DOWN];
const allKeys = [...horizontalKeys, ...verticalKeys];

/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */
const Composite = /*#__PURE__*/react.forwardRef(function Composite(props, forwardedRef) {
  const {
    render,
    orientation = 'both',
    loop = true,
    rtl = false,
    cols = 1,
    disabledIndices,
    activeIndex: externalActiveIndex,
    onNavigate: externalSetActiveIndex,
    itemSizes,
    dense = false,
    ...domProps
  } = props;
  const [internalActiveIndex, internalSetActiveIndex] = react.useState(0);
  const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
  const onNavigate = useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
  const elementsRef = react.useRef([]);
  const renderElementProps = render && typeof render !== 'function' ? render.props : {};
  const contextValue = react.useMemo(() => ({
    activeIndex,
    onNavigate
  }), [activeIndex, onNavigate]);
  const isGrid = cols > 1;
  function handleKeyDown(event) {
    if (!allKeys.includes(event.key)) return;
    let nextIndex = activeIndex;
    const minIndex = getMinIndex(elementsRef, disabledIndices);
    const maxIndex = getMaxIndex(elementsRef, disabledIndices);
    const horizontalEndKey = rtl ? ARROW_LEFT : ARROW_RIGHT;
    const horizontalStartKey = rtl ? ARROW_RIGHT : ARROW_LEFT;
    if (isGrid) {
      const sizes = itemSizes || Array.from({
        length: elementsRef.current.length
      }, () => ({
        width: 1,
        height: 1
      }));
      // To calculate movements on the grid, we use hypothetical cell indices
      // as if every item was 1x1, then convert back to real indices.
      const cellMap = buildCellMap(sizes, cols, dense);
      const minGridIndex = cellMap.findIndex(index => index != null && !isDisabled(elementsRef.current, index, disabledIndices));
      // last enabled index
      const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex) => index != null && !isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
      const maybeNextIndex = cellMap[getGridNavigatedIndex({
        current: cellMap.map(itemIndex => itemIndex ? elementsRef.current[itemIndex] : null)
      }, {
        event,
        orientation,
        loop,
        rtl,
        cols,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getCellIndices([...(disabledIndices || elementsRef.current.map((_, index) => isDisabled(elementsRef.current, index) ? index : undefined)), undefined], cellMap),
        minIndex: minGridIndex,
        maxIndex: maxGridIndex,
        prevIndex: getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols,
        // use a corner matching the edge closest to the direction we're
        // moving in so we don't end up in the same item. Prefer
        // top/left over bottom/right.
        event.key === ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
      })];
      if (maybeNextIndex != null) {
        nextIndex = maybeNextIndex;
      }
    }
    const toEndKeys = {
      horizontal: [horizontalEndKey],
      vertical: [ARROW_DOWN],
      both: [horizontalEndKey, ARROW_DOWN]
    }[orientation];
    const toStartKeys = {
      horizontal: [horizontalStartKey],
      vertical: [ARROW_UP],
      both: [horizontalStartKey, ARROW_UP]
    }[orientation];
    const preventedKeys = isGrid ? allKeys : {
      horizontal: horizontalKeys,
      vertical: verticalKeys,
      both: allKeys
    }[orientation];
    if (nextIndex === activeIndex && [...toEndKeys, ...toStartKeys].includes(event.key)) {
      if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) {
        nextIndex = minIndex;
      } else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) {
        nextIndex = maxIndex;
      } else {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: nextIndex,
          decrement: toStartKeys.includes(event.key),
          disabledIndices
        });
      }
    }
    if (nextIndex !== activeIndex && !isIndexOutOfBounds(elementsRef, nextIndex)) {
      var _elementsRef$current$;
      event.stopPropagation();
      if (preventedKeys.includes(event.key)) {
        event.preventDefault();
      }
      onNavigate(nextIndex);
      (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
    }
  }
  const computedProps = {
    ...domProps,
    ...renderElementProps,
    ref: forwardedRef,
    'aria-orientation': orientation === 'both' ? undefined : orientation,
    onKeyDown(e) {
      domProps.onKeyDown == null || domProps.onKeyDown(e);
      renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
      handleKeyDown(e);
    }
  };
  return /*#__PURE__*/react.createElement(CompositeContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/react.createElement(FloatingList, {
    elementsRef: elementsRef
  }, renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */
const CompositeItem = /*#__PURE__*/react.forwardRef(function CompositeItem(props, forwardedRef) {
  const {
    render,
    ...domProps
  } = props;
  const renderElementProps = render && typeof render !== 'function' ? render.props : {};
  const {
    activeIndex,
    onNavigate
  } = react.useContext(CompositeContext);
  const {
    ref,
    index
  } = useListItem();
  const mergedRef = useMergeRefs([ref, forwardedRef, renderElementProps.ref]);
  const isActive = activeIndex === index;
  const computedProps = {
    ...domProps,
    ...renderElementProps,
    ref: mergedRef,
    tabIndex: isActive ? 0 : -1,
    'data-active': isActive ? '' : undefined,
    onFocus(e) {
      domProps.onFocus == null || domProps.onFocus(e);
      renderElementProps.onFocus == null || renderElementProps.onFocus(e);
      onNavigate(index);
    }
  };
  return renderJsx(render, computedProps);
});

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

let serverHandoffComplete = false;
let count = 0;
const genId = () => // Ensure the id is unique with multiple independent versions of Floating UI
// on <React 18
"floating-ui-" + Math.random().toString(36).slice(2, 6) + count++;
function useFloatingId() {
  const [id, setId] = react.useState(() => serverHandoffComplete ? genId() : undefined);
  floating_ui_react_esm_index(() => {
    if (id == null) {
      setId(genId());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  react.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id;
}
const useReactId = SafeReact.useId;

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */
const useId = useReactId || useFloatingId;

let devMessageSet;
if (false) {}
function warn() {
  var _devMessageSet;
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  const message = "Floating UI: " + messages.join(' ');
  if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message))) {
    var _devMessageSet2;
    (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message);
    console.warn(message);
  }
}
function error() {
  var _devMessageSet3;
  for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    messages[_key2] = arguments[_key2];
  }
  const message = "Floating UI: " + messages.join(' ');
  if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
    var _devMessageSet4;
    (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
    console.error(message);
  }
}

/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */
const FloatingArrow = /*#__PURE__*/react.forwardRef(function FloatingArrow(props, ref) {
  const {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow,
        shift
      }
    },
    width = 14,
    height = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = props;
  if (false) {}
  const clipPathId = useId();
  const [isRTL, setIsRTL] = react.useState(false);

  // https://github.com/floating-ui/floating-ui/issues/2932
  floating_ui_react_esm_index(() => {
    if (!floating) return;
    const isRTL = floating_ui_utils_dom_getComputedStyle(floating).direction === 'rtl';
    if (isRTL) {
      setIsRTL(true);
    }
  }, [floating]);
  if (!floating) {
    return null;
  }
  const [side, alignment] = placement.split('-');
  const isVerticalSide = side === 'top' || side === 'bottom';
  let computedStaticOffset = staticOffset;
  if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) {
    computedStaticOffset = null;
  }

  // Strokes must be double the border width, this ensures the stroke's width
  // works as you'd expect.
  const computedStrokeWidth = strokeWidth * 2;
  const halfStrokeWidth = computedStrokeWidth / 2;
  const svgX = width / 2 * (tipRadius / -8 + 1);
  const svgY = height / 2 * tipRadius / 4;
  const isCustomShape = !!d;
  const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
  let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
  if (computedStaticOffset && isRTL) {
    xOffsetProp = alignment === 'end' ? 'left' : 'right';
  }
  const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
  const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
  const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
  const rotation = {
    top: isCustomShape ? 'rotate(180deg)' : '',
    left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
    bottom: isCustomShape ? '' : 'rotate(180deg)',
    right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
  }[side];
  return /*#__PURE__*/react.createElement("svg", _extends({}, rest, {
    "aria-hidden": true,
    ref: ref,
    width: isCustomShape ? width : width + computedStrokeWidth,
    height: width,
    viewBox: "0 0 " + width + " " + (height > width ? height : width),
    style: {
      position: 'absolute',
      pointerEvents: 'none',
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
      transform: [rotation, transform].filter(t => !!t).join(' '),
      ...restStyle
    }
  }), computedStrokeWidth > 0 && /*#__PURE__*/react.createElement("path", {
    clipPath: "url(#" + clipPathId + ")",
    fill: "none",
    stroke: stroke
    // Account for the stroke on the fill path rendered below.
    ,
    strokeWidth: computedStrokeWidth + (d ? 0 : 1),
    d: dValue
  }), /*#__PURE__*/react.createElement("path", {
    stroke: computedStrokeWidth && !d ? rest.fill : 'none',
    d: dValue
  }), /*#__PURE__*/react.createElement("clipPath", {
    id: clipPathId
  }, /*#__PURE__*/react.createElement("rect", {
    x: -halfStrokeWidth,
    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
    width: width + computedStrokeWidth,
    height: width
  })));
});

function createPubSub() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach(handler => handler(data));
    },
    on(event, listener) {
      map.set(event, [...(map.get(event) || []), listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter(l => l !== listener)) || []);
    }
  };
}

const FloatingNodeContext = /*#__PURE__*/react.createContext(null);
const FloatingTreeContext = /*#__PURE__*/react.createContext(null);

/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = react.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};

/**
 * Returns the nearest floating tree context, if available.
 */
const useFloatingTree = () => react.useContext(FloatingTreeContext);

/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function useFloatingNodeId(customParentId) {
  const id = useId();
  const tree = useFloatingTree();
  const reactParentId = useFloatingParentNodeId();
  const parentId = customParentId || reactParentId;
  floating_ui_react_esm_index(() => {
    const node = {
      id,
      parentId
    };
    tree == null || tree.addNode(node);
    return () => {
      tree == null || tree.removeNode(node);
    };
  }, [tree, id, parentId]);
  return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingNode(props) {
  const {
    children,
    id
  } = props;
  const parentId = useFloatingParentNodeId();
  return /*#__PURE__*/react.createElement(FloatingNodeContext.Provider, {
    value: react.useMemo(() => ({
      id,
      parentId
    }), [id, parentId])
  }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingTree(props) {
  const {
    children
  } = props;
  const nodesRef = react.useRef([]);
  const addNode = react.useCallback(node => {
    nodesRef.current = [...nodesRef.current, node];
  }, []);
  const removeNode = react.useCallback(node => {
    nodesRef.current = nodesRef.current.filter(n => n !== node);
  }, []);
  const events = react.useState(() => createPubSub())[0];
  return /*#__PURE__*/react.createElement(FloatingTreeContext.Provider, {
    value: react.useMemo(() => ({
      nodesRef,
      addNode,
      removeNode,
      events
    }), [addNode, removeNode, events])
  }, children);
}

function createAttribute(name) {
  return "data-floating-ui-" + name;
}

function floating_ui_react_esm_useLatestRef(value) {
  const ref = (0,react.useRef)(value);
  floating_ui_react_esm_index(() => {
    ref.current = value;
  });
  return ref;
}

const safePolygonIdentifier = /*#__PURE__*/createAttribute('safe-polygon');
function getDelay(value, prop, pointerType) {
  if (pointerType && !isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */
function useHover(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    elements
  } = context;
  const {
    enabled = true,
    delay = 0,
    handleClose = null,
    mouseOnly = false,
    restMs = 0,
    move = true
  } = props;
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  const handleCloseRef = floating_ui_react_esm_useLatestRef(handleClose);
  const delayRef = floating_ui_react_esm_useLatestRef(delay);
  const openRef = floating_ui_react_esm_useLatestRef(open);
  const pointerTypeRef = react.useRef();
  const timeoutRef = react.useRef(-1);
  const handlerRef = react.useRef();
  const restTimeoutRef = react.useRef(-1);
  const blockMouseMoveRef = react.useRef(true);
  const performedPointerEventsMutationRef = react.useRef(false);
  const unbindMouseMoveRef = react.useRef(() => {});
  const restTimeoutPendingRef = react.useRef(false);
  const isHoverOpen = react.useCallback(() => {
    var _dataRef$current$open;
    const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
  }, [dataRef]);

  // When closing before opening, clear the delay timeouts to cancel it
  // from showing.
  react.useEffect(() => {
    if (!enabled) return;
    function onOpenChange(_ref) {
      let {
        open
      } = _ref;
      if (!open) {
        clearTimeout(timeoutRef.current);
        clearTimeout(restTimeoutRef.current);
        blockMouseMoveRef.current = true;
        restTimeoutPendingRef.current = false;
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
    };
  }, [enabled, events]);
  react.useEffect(() => {
    if (!enabled) return;
    if (!handleCloseRef.current) return;
    if (!open) return;
    function onLeave(event) {
      if (isHoverOpen()) {
        onOpenChange(false, event, 'hover');
      }
    }
    const html = getDocument(elements.floating).documentElement;
    html.addEventListener('mouseleave', onLeave);
    return () => {
      html.removeEventListener('mouseleave', onLeave);
    };
  }, [elements.floating, open, onOpenChange, enabled, handleCloseRef, isHoverOpen]);
  const closeWithDelay = react.useCallback(function (event, runElseBranch, reason) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }
    if (reason === void 0) {
      reason = 'hover';
    }
    const closeDelay = getDelay(delayRef.current, 'close', pointerTypeRef.current);
    if (closeDelay && !handlerRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => onOpenChange(false, event, reason), closeDelay);
    } else if (runElseBranch) {
      clearTimeout(timeoutRef.current);
      onOpenChange(false, event, reason);
    }
  }, [delayRef, onOpenChange]);
  const cleanupMouseMoveHandler = useEffectEvent(() => {
    unbindMouseMoveRef.current();
    handlerRef.current = undefined;
  });
  const clearPointerEvents = useEffectEvent(() => {
    if (performedPointerEventsMutationRef.current) {
      const body = getDocument(elements.floating).body;
      body.style.pointerEvents = '';
      body.removeAttribute(safePolygonIdentifier);
      performedPointerEventsMutationRef.current = false;
    }
  });
  const isClickLikeOpenEvent = useEffectEvent(() => {
    return dataRef.current.openEvent ? ['click', 'mousedown'].includes(dataRef.current.openEvent.type) : false;
  });

  // Registering the mouse events on the reference directly to bypass React's
  // delegation system. If the cursor was on a disabled element and then entered
  // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
  react.useEffect(() => {
    if (!enabled) return;
    function onMouseEnter(event) {
      clearTimeout(timeoutRef.current);
      blockMouseMoveRef.current = false;
      if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && !getDelay(delayRef.current, 'open')) {
        return;
      }
      const openDelay = getDelay(delayRef.current, 'open', pointerTypeRef.current);
      if (openDelay) {
        timeoutRef.current = window.setTimeout(() => {
          if (!openRef.current) {
            onOpenChange(true, event, 'hover');
          }
        }, openDelay);
      } else if (!open) {
        onOpenChange(true, event, 'hover');
      }
    }
    function onMouseLeave(event) {
      if (isClickLikeOpenEvent()) return;
      unbindMouseMoveRef.current();
      const doc = getDocument(elements.floating);
      clearTimeout(restTimeoutRef.current);
      restTimeoutPendingRef.current = false;
      if (handleCloseRef.current && dataRef.current.floatingContext) {
        // Prevent clearing `onScrollMouseLeave` timeout.
        if (!open) {
          clearTimeout(timeoutRef.current);
        }
        handlerRef.current = handleCloseRef.current({
          ...dataRef.current.floatingContext,
          tree,
          x: event.clientX,
          y: event.clientY,
          onClose() {
            clearPointerEvents();
            cleanupMouseMoveHandler();
            if (!isClickLikeOpenEvent()) {
              closeWithDelay(event, true, 'safe-polygon');
            }
          }
        });
        const handler = handlerRef.current;
        doc.addEventListener('mousemove', handler);
        unbindMouseMoveRef.current = () => {
          doc.removeEventListener('mousemove', handler);
        };
        return;
      }

      // Allow interactivity without `safePolygon` on touch devices. With a
      // pointer, a short close delay is an alternative, so it should work
      // consistently.
      const shouldClose = pointerTypeRef.current === 'touch' ? !contains(elements.floating, event.relatedTarget) : true;
      if (shouldClose) {
        closeWithDelay(event);
      }
    }

    // Ensure the floating element closes after scrolling even if the pointer
    // did not move.
    // https://github.com/floating-ui/floating-ui/discussions/1692
    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) return;
      if (!dataRef.current.floatingContext) return;
      handleCloseRef.current == null || handleCloseRef.current({
        ...dataRef.current.floatingContext,
        tree,
        x: event.clientX,
        y: event.clientY,
        onClose() {
          clearPointerEvents();
          cleanupMouseMoveHandler();
          if (!isClickLikeOpenEvent()) {
            closeWithDelay(event);
          }
        }
      })(event);
    }
    if (isElement(elements.domReference)) {
      var _elements$floating;
      const ref = elements.domReference;
      open && ref.addEventListener('mouseleave', onScrollMouseLeave);
      (_elements$floating = elements.floating) == null || _elements$floating.addEventListener('mouseleave', onScrollMouseLeave);
      move && ref.addEventListener('mousemove', onMouseEnter, {
        once: true
      });
      ref.addEventListener('mouseenter', onMouseEnter);
      ref.addEventListener('mouseleave', onMouseLeave);
      return () => {
        var _elements$floating2;
        open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
        (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener('mouseleave', onScrollMouseLeave);
        move && ref.removeEventListener('mousemove', onMouseEnter);
        ref.removeEventListener('mouseenter', onMouseEnter);
        ref.removeEventListener('mouseleave', onMouseLeave);
      };
    }
  }, [elements, enabled, context, mouseOnly, restMs, move, closeWithDelay, cleanupMouseMoveHandler, clearPointerEvents, onOpenChange, open, openRef, tree, delayRef, handleCloseRef, dataRef, isClickLikeOpenEvent]);

  // Block pointer-events of every element other than the reference and floating
  // while the floating element is open and has a `handleClose` handler. Also
  // handles nested floating elements.
  // https://github.com/floating-ui/floating-ui/issues/1722
  floating_ui_react_esm_index(() => {
    var _handleCloseRef$curre;
    if (!enabled) return;
    if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
      performedPointerEventsMutationRef.current = true;
      const floatingEl = elements.floating;
      if (isElement(elements.domReference) && floatingEl) {
        var _tree$nodesRef$curren;
        const body = getDocument(elements.floating).body;
        body.setAttribute(safePolygonIdentifier, '');
        const ref = elements.domReference;
        const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
        if (parentFloating) {
          parentFloating.style.pointerEvents = '';
        }
        body.style.pointerEvents = 'none';
        ref.style.pointerEvents = 'auto';
        floatingEl.style.pointerEvents = 'auto';
        return () => {
          body.style.pointerEvents = '';
          ref.style.pointerEvents = '';
          floatingEl.style.pointerEvents = '';
        };
      }
    }
  }, [enabled, open, parentId, elements, tree, handleCloseRef, isHoverOpen]);
  floating_ui_react_esm_index(() => {
    if (!open) {
      pointerTypeRef.current = undefined;
      restTimeoutPendingRef.current = false;
      cleanupMouseMoveHandler();
      clearPointerEvents();
    }
  }, [open, cleanupMouseMoveHandler, clearPointerEvents]);
  react.useEffect(() => {
    return () => {
      cleanupMouseMoveHandler();
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      clearPointerEvents();
    };
  }, [enabled, elements.domReference, cleanupMouseMoveHandler, clearPointerEvents]);
  const reference = react.useMemo(() => {
    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }
    return {
      onPointerDown: setPointerRef,
      onPointerEnter: setPointerRef,
      onMouseMove(event) {
        const {
          nativeEvent
        } = event;
        function handleMouseMove() {
          if (!blockMouseMoveRef.current && !openRef.current) {
            onOpenChange(true, nativeEvent, 'hover');
          }
        }
        if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current)) {
          return;
        }
        if (open || restMs === 0) {
          return;
        }

        // Ignore insignificant movements to account for tremors.
        if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) {
          return;
        }
        clearTimeout(restTimeoutRef.current);
        if (pointerTypeRef.current === 'touch') {
          handleMouseMove();
        } else {
          restTimeoutPendingRef.current = true;
          restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
        }
      }
    };
  }, [mouseOnly, onOpenChange, open, openRef, restMs]);
  const floating = react.useMemo(() => ({
    onMouseEnter() {
      clearTimeout(timeoutRef.current);
    },
    onMouseLeave(event) {
      if (!isClickLikeOpenEvent()) {
        closeWithDelay(event.nativeEvent, false);
      }
    }
  }), [closeWithDelay, isClickLikeOpenEvent]);
  return react.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}

const NOOP = () => {};
const FloatingDelayGroupContext = /*#__PURE__*/react.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: NOOP,
  setState: NOOP,
  isInstantPhase: false
});

/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */
const useDelayGroupContext = () => react.useContext(FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function FloatingDelayGroup(props) {
  const {
    children,
    delay,
    timeoutMs = 0
  } = props;
  const [state, setState] = react.useReducer((prev, next) => ({
    ...prev,
    ...next
  }), {
    delay,
    timeoutMs,
    initialDelay: delay,
    currentId: null,
    isInstantPhase: false
  });
  const initialCurrentIdRef = react.useRef(null);
  const setCurrentId = react.useCallback(currentId => {
    setState({
      currentId
    });
  }, []);
  floating_ui_react_esm_index(() => {
    if (state.currentId) {
      if (initialCurrentIdRef.current === null) {
        initialCurrentIdRef.current = state.currentId;
      } else if (!state.isInstantPhase) {
        setState({
          isInstantPhase: true
        });
      }
    } else {
      if (state.isInstantPhase) {
        setState({
          isInstantPhase: false
        });
      }
      initialCurrentIdRef.current = null;
    }
  }, [state.currentId, state.isInstantPhase]);
  return /*#__PURE__*/react.createElement(FloatingDelayGroupContext.Provider, {
    value: react.useMemo(() => ({
      ...state,
      setState,
      setCurrentId
    }), [state, setCurrentId])
  }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function useDelayGroup(context, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    open,
    onOpenChange,
    floatingId
  } = context;
  const {
    id: optionId,
    enabled = true
  } = options;
  const id = optionId != null ? optionId : floatingId;
  const groupContext = useDelayGroupContext();
  const {
    currentId,
    setCurrentId,
    initialDelay,
    setState,
    timeoutMs
  } = groupContext;
  floating_ui_react_esm_index(() => {
    if (!enabled) return;
    if (!currentId) return;
    setState({
      delay: {
        open: 1,
        close: getDelay(initialDelay, 'close')
      }
    });
    if (currentId !== id) {
      onOpenChange(false);
    }
  }, [enabled, id, onOpenChange, setState, currentId, initialDelay]);
  floating_ui_react_esm_index(() => {
    function unset() {
      onOpenChange(false);
      setState({
        delay: initialDelay,
        currentId: null
      });
    }
    if (!enabled) return;
    if (!currentId) return;
    if (!open && currentId === id) {
      if (timeoutMs) {
        const timeout = window.setTimeout(unset, timeoutMs);
        return () => {
          clearTimeout(timeout);
        };
      }
      unset();
    }
  }, [enabled, open, setState, currentId, id, onOpenChange, initialDelay, timeoutMs]);
  floating_ui_react_esm_index(() => {
    if (!enabled) return;
    if (setCurrentId === NOOP || !open) return;
    setCurrentId(id);
  }, [enabled, open, setCurrentId, id]);
  return groupContext;
}

let rafId = 0;
function enqueueFocus(el, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    preventScroll = false,
    cancelPrevious = true,
    sync = false
  } = options;
  cancelPrevious && cancelAnimationFrame(rafId);
  const exec = () => el == null ? void 0 : el.focus({
    preventScroll
  });
  if (sync) {
    exec();
  } else {
    rafId = requestAnimationFrame(exec);
  }
}

function getAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find(node => node.id === id)) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find(node => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}

function getChildren(nodes, id) {
  let allChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter(node => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(n => {
        var _node$context2;
        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}
function getDeepestNode(nodes, id) {
  let deepestNodeId;
  let maxDepth = -1;
  function findDeepest(nodeId, depth) {
    if (depth > maxDepth) {
      deepestNodeId = nodeId;
      maxDepth = depth;
    }
    const children = getChildren(nodes, nodeId);
    children.forEach(child => {
      findDeepest(child.id, depth + 1);
    });
  }
  findDeepest(id, 0);
  return nodes.find(node => node.id === deepestNodeId);
}

// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let counterMap = /*#__PURE__*/new WeakMap();
let uncontrolledElementsSet = /*#__PURE__*/new WeakSet();
let markerMap = {};
let lockCount$1 = 0;
const supportsInert = () => typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const unwrapHost = node => node && (node.host || unwrapHost(node.parentNode));
const correctElements = (parent, targets) => targets.map(target => {
  if (parent.contains(target)) {
    return target;
  }
  const correctedTarget = unwrapHost(target);
  if (parent.contains(correctedTarget)) {
    return correctedTarget;
  }
  return null;
}).filter(x => x != null);
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
  const markerName = 'data-floating-ui-inert';
  const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
  const avoidElements = correctElements(body, uncorrectedAvoidElements);
  const elementsToKeep = new Set();
  const elementsToStop = new Set(avoidElements);
  const hiddenElements = [];
  if (!markerMap[markerName]) {
    markerMap[markerName] = new WeakMap();
  }
  const markerCounter = markerMap[markerName];
  avoidElements.forEach(keep);
  deep(body);
  elementsToKeep.clear();
  function keep(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    el.parentNode && keep(el.parentNode);
  }
  function deep(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    [].forEach.call(parent.children, node => {
      if (getNodeName(node) === 'script') return;
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
        const alreadyHidden = attr !== null && attr !== 'false';
        const counterValue = (counterMap.get(node) || 0) + 1;
        const markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenElements.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledElementsSet.add(node);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, '');
        }
        if (!alreadyHidden && controlAttribute) {
          node.setAttribute(controlAttribute, 'true');
        }
      }
    });
  }
  lockCount$1++;
  return () => {
    hiddenElements.forEach(element => {
      const counterValue = (counterMap.get(element) || 0) - 1;
      const markerValue = (markerCounter.get(element) || 0) - 1;
      counterMap.set(element, counterValue);
      markerCounter.set(element, markerValue);
      if (!counterValue) {
        if (!uncontrolledElementsSet.has(element) && controlAttribute) {
          element.removeAttribute(controlAttribute);
        }
        uncontrolledElementsSet.delete(element);
      }
      if (!markerValue) {
        element.removeAttribute(markerName);
      }
    });
    lockCount$1--;
    if (!lockCount$1) {
      counterMap = new WeakMap();
      counterMap = new WeakMap();
      uncontrolledElementsSet = new WeakSet();
      markerMap = {};
    }
  };
}
function markOthers(avoidElements, ariaHidden, inert) {
  if (ariaHidden === void 0) {
    ariaHidden = false;
  }
  if (inert === void 0) {
    inert = false;
  }
  const body = getDocument(avoidElements[0]).body;
  return applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}

const getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck:
  // JSDOM does not support the `tabbable` library. To solve this we can
  // check if `ResizeObserver` is a real function (not polyfilled), which
  // determines if the current environment is JSDOM-like.
  typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
});
function getTabbableIn(container, direction) {
  const allTabbable = tabbable(container, getTabbableOptions());
  if (direction === 'prev') {
    allTabbable.reverse();
  }
  const activeIndex = allTabbable.indexOf(activeElement(getDocument(container)));
  const nextTabbableElements = allTabbable.slice(activeIndex + 1);
  return nextTabbableElements[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, 'next');
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, 'prev');
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach(element => {
    element.dataset.tabindex = element.getAttribute('tabindex') || '';
    element.setAttribute('tabindex', '-1');
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll('[data-tabindex]');
  elements.forEach(element => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute('tabindex', tabindex);
    } else {
      element.removeAttribute('tabindex');
    }
  });
}

// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx

const HIDDEN_STYLES = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'fixed',
  whiteSpace: 'nowrap',
  width: '1px',
  top: 0,
  left: 0
};
let timeoutId;
function setActiveElementOnTab(event) {
  if (event.key === 'Tab') {
    event.target;
    clearTimeout(timeoutId);
  }
}
const FocusGuard = /*#__PURE__*/react.forwardRef(function FocusGuard(props, ref) {
  const [role, setRole] = react.useState();
  floating_ui_react_esm_index(() => {
    if (isSafari()) {
      // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
      // on VoiceOver does trigger the onFocus event, so we can use the focus
      // trap element. On Safari, only buttons trigger the onFocus event.
      // NB: "group" role in the Sandbox no longer appears to work, must be a
      // button role.
      setRole('button');
    }
    document.addEventListener('keydown', setActiveElementOnTab);
    return () => {
      document.removeEventListener('keydown', setActiveElementOnTab);
    };
  }, []);
  const restProps = {
    ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role,
    'aria-hidden': role ? undefined : true,
    [createAttribute('focus-guard')]: '',
    style: HIDDEN_STYLES
  };
  return /*#__PURE__*/react.createElement("span", _extends({}, props, restProps));
});

const PortalContext = /*#__PURE__*/react.createContext(null);
const attr = /*#__PURE__*/createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */
function useFloatingPortalNode(props) {
  if (props === void 0) {
    props = {};
  }
  const {
    id,
    root
  } = props;
  const uniqueId = useId();
  const portalContext = usePortalContext();
  const [portalNode, setPortalNode] = react.useState(null);
  const portalNodeRef = react.useRef(null);
  floating_ui_react_esm_index(() => {
    return () => {
      portalNode == null || portalNode.remove();
      // Allow the subsequent layout effects to create a new node on updates.
      // The portal node will still be cleaned up on unmount.
      // https://github.com/floating-ui/floating-ui/issues/2454
      queueMicrotask(() => {
        portalNodeRef.current = null;
      });
    };
  }, [portalNode]);
  floating_ui_react_esm_index(() => {
    // Wait for the uniqueId to be generated before creating the portal node in
    // React <18 (using `useFloatingId` instead of the native `useId`).
    // https://github.com/floating-ui/floating-ui/issues/2778
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    const existingIdRoot = id ? document.getElementById(id) : null;
    if (!existingIdRoot) return;
    const subRoot = document.createElement('div');
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, '');
    existingIdRoot.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, uniqueId]);
  floating_ui_react_esm_index(() => {
    // Wait for the root to exist before creating the portal node. The root must
    // be stored in state, not a ref, for this to work reactively.
    if (root === null) return;
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
    if (container && !isElement(container)) container = container.current;
    container = container || document.body;
    let idWrapper = null;
    if (id) {
      idWrapper = document.createElement('div');
      idWrapper.id = id;
      container.appendChild(idWrapper);
    }
    const subRoot = document.createElement('div');
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, '');
    container = idWrapper || container;
    container.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, root, uniqueId, portalContext]);
  return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */
function FloatingPortal(props) {
  const {
    children,
    id,
    root,
    preserveTabOrder = true
  } = props;
  const portalNode = useFloatingPortalNode({
    id,
    root
  });
  const [focusManagerState, setFocusManagerState] = react.useState(null);
  const beforeOutsideRef = react.useRef(null);
  const afterOutsideRef = react.useRef(null);
  const beforeInsideRef = react.useRef(null);
  const afterInsideRef = react.useRef(null);
  const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
  const open = focusManagerState == null ? void 0 : focusManagerState.open;
  const shouldRenderGuards =
  // The FocusManager and therefore floating element are currently open/
  // rendered.
  !!focusManagerState &&
  // Guards are only for non-modal focus management.
  !focusManagerState.modal &&
  // Don't render if unmount is transitioning.
  focusManagerState.open && preserveTabOrder && !!(root || portalNode);

  // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
  react.useEffect(() => {
    if (!portalNode || !preserveTabOrder || modal) {
      return;
    }

    // Make sure elements inside the portal element are tabbable only when the
    // portal has already been focused, either by tabbing into a focus trap
    // element outside or using the mouse.
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === 'focusin';
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    // Listen to the event on the capture phase so they run before the focus
    // trap elements onFocus prop is called.
    portalNode.addEventListener('focusin', onFocus, true);
    portalNode.addEventListener('focusout', onFocus, true);
    return () => {
      portalNode.removeEventListener('focusin', onFocus, true);
      portalNode.removeEventListener('focusout', onFocus, true);
    };
  }, [portalNode, preserveTabOrder, modal]);
  react.useEffect(() => {
    if (!portalNode) return;
    if (open) return;
    enableFocusInside(portalNode);
  }, [open, portalNode]);
  return /*#__PURE__*/react.createElement(PortalContext.Provider, {
    value: react.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode])
  }, shouldRenderGuards && portalNode && /*#__PURE__*/react.createElement(FocusGuard, {
    "data-type": "outside",
    ref: beforeOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _beforeInsideRef$curr;
        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
      } else {
        const prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        prevTabbable == null || prevTabbable.focus();
      }
    }
  }), shouldRenderGuards && portalNode && /*#__PURE__*/react.createElement("span", {
    "aria-owns": portalNode.id,
    style: HIDDEN_STYLES
  }), portalNode && /*#__PURE__*/react_dom.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/react.createElement(FocusGuard, {
    "data-type": "outside",
    ref: afterOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _afterInsideRef$curre;
        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
      } else {
        const nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        nextTabbable == null || nextTabbable.focus();
        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
      }
    }
  }));
}
const usePortalContext = () => react.useContext(PortalContext);

const FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
function getFloatingFocusElement(floatingElement) {
  if (!floatingElement) {
    return null;
  }
  // Try to find the element that has `{...getFloatingProps()}` spread on it.
  // This indicates the floating element is acting as a positioning wrapper, and
  // so focus should be managed on the child element with the event handlers and
  // aria props.
  return floatingElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}

const LIST_LIMIT = 20;
let previouslyFocusedElements = [];
function addPreviouslyFocusedElement(element) {
  previouslyFocusedElements = previouslyFocusedElements.filter(el => el.isConnected);
  let tabbableEl = element;
  if (!tabbableEl || getNodeName(tabbableEl) === 'body') return;
  if (!isTabbable(tabbableEl, getTabbableOptions())) {
    const tabbableChild = tabbable(tabbableEl, getTabbableOptions())[0];
    if (tabbableChild) {
      tabbableEl = tabbableChild;
    }
  }
  previouslyFocusedElements.push(tabbableEl);
  if (previouslyFocusedElements.length > LIST_LIMIT) {
    previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT);
  }
}
function getPreviouslyFocusedElement() {
  return previouslyFocusedElements.slice().reverse().find(el => el.isConnected);
}
const VisuallyHiddenDismiss = /*#__PURE__*/react.forwardRef(function VisuallyHiddenDismiss(props, ref) {
  return /*#__PURE__*/react.createElement("button", _extends({}, props, {
    type: "button",
    ref: ref,
    tabIndex: -1,
    style: HIDDEN_STYLES
  }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */
function FloatingFocusManager(props) {
  const {
    context,
    children,
    disabled = false,
    order = ['content'],
    guards: _guards = true,
    initialFocus = 0,
    returnFocus = true,
    restoreFocus = false,
    modal = true,
    visuallyHiddenDismiss = false,
    closeOnFocusOut = true
  } = props;
  const {
    open,
    refs,
    nodeId,
    onOpenChange,
    events,
    dataRef,
    floatingId,
    elements: {
      domReference,
      floating
    }
  } = context;
  const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
  // If the reference is a combobox and is typeable (e.g. input/textarea),
  // there are different focus semantics. The guards should not be rendered, but
  // aria-hidden should be applied to all nodes still. Further, the visually
  // hidden dismiss button should only appear at the end of the list, not the
  // start.
  const isUntrappedTypeableCombobox = isTypeableCombobox(domReference) && ignoreInitialFocus;

  // Force the guards to be rendered if the `inert` attribute is not supported.
  const guards = supportsInert() ? _guards : true;
  const orderRef = floating_ui_react_esm_useLatestRef(order);
  const initialFocusRef = floating_ui_react_esm_useLatestRef(initialFocus);
  const returnFocusRef = floating_ui_react_esm_useLatestRef(returnFocus);
  const tree = useFloatingTree();
  const portalContext = usePortalContext();
  const startDismissButtonRef = react.useRef(null);
  const endDismissButtonRef = react.useRef(null);
  const preventReturnFocusRef = react.useRef(false);
  const isPointerDownRef = react.useRef(false);
  const tabbableIndexRef = react.useRef(-1);
  const isInsidePortal = portalContext != null;
  const floatingFocusElement = getFloatingFocusElement(floating);
  const getTabbableContent = useEffectEvent(function (container) {
    if (container === void 0) {
      container = floatingFocusElement;
    }
    return container ? tabbable(container, getTabbableOptions()) : [];
  });
  const getTabbableElements = useEffectEvent(container => {
    const content = getTabbableContent(container);
    return orderRef.current.map(type => {
      if (domReference && type === 'reference') {
        return domReference;
      }
      if (floatingFocusElement && type === 'floating') {
        return floatingFocusElement;
      }
      return content;
    }).filter(Boolean).flat();
  });
  react.useEffect(() => {
    if (disabled) return;
    if (!modal) return;
    function onKeyDown(event) {
      if (event.key === 'Tab') {
        // The focus guards have nothing to focus, so we need to stop the event.
        if (contains(floatingFocusElement, activeElement(getDocument(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) {
          stopEvent(event);
        }
        const els = getTabbableElements();
        const target = getTarget(event);
        if (orderRef.current[0] === 'reference' && target === domReference) {
          stopEvent(event);
          if (event.shiftKey) {
            enqueueFocus(els[els.length - 1]);
          } else {
            enqueueFocus(els[1]);
          }
        }
        if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
          stopEvent(event);
          enqueueFocus(els[0]);
        }
      }
    }
    const doc = getDocument(floatingFocusElement);
    doc.addEventListener('keydown', onKeyDown);
    return () => {
      doc.removeEventListener('keydown', onKeyDown);
    };
  }, [disabled, domReference, floatingFocusElement, modal, orderRef, isUntrappedTypeableCombobox, getTabbableContent, getTabbableElements]);
  react.useEffect(() => {
    if (disabled) return;
    if (!floating) return;
    function handleFocusIn(event) {
      const target = getTarget(event);
      const tabbableContent = getTabbableContent();
      const tabbableIndex = tabbableContent.indexOf(target);
      if (tabbableIndex !== -1) {
        tabbableIndexRef.current = tabbableIndex;
      }
    }
    floating.addEventListener('focusin', handleFocusIn);
    return () => {
      floating.removeEventListener('focusin', handleFocusIn);
    };
  }, [disabled, floating, getTabbableContent]);
  react.useEffect(() => {
    if (disabled) return;
    if (!closeOnFocusOut) return;

    // In Safari, buttons lose focus when pressing them.
    function handlePointerDown() {
      isPointerDownRef.current = true;
      setTimeout(() => {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusOutside(event) {
      const relatedTarget = event.relatedTarget;
      queueMicrotask(() => {
        const movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute('focus-guard')) || tree && (getChildren(tree.nodesRef.current, nodeId).find(node => {
          var _node$context, _node$context2;
          return contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
        }) || getAncestors(tree.nodesRef.current, nodeId).find(node => {
          var _node$context3, _node$context4;
          return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
        })));

        // Restore focus to the previous tabbable element index to prevent
        // focus from being lost outside the floating tree.
        if (restoreFocus && movedToUnrelatedNode && activeElement(getDocument(floatingFocusElement)) === getDocument(floatingFocusElement).body) {
          // Let `FloatingPortal` effect knows that focus is still inside the
          // floating tree.
          if (isHTMLElement(floatingFocusElement)) {
            floatingFocusElement.focus();
          }
          const prevTabbableIndex = tabbableIndexRef.current;
          const tabbableContent = getTabbableContent();
          const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
          if (isHTMLElement(nodeToFocus)) {
            nodeToFocus.focus();
          }
        }

        // Focus did not move inside the floating tree, and there are no tabbable
        // portal guards to handle closing.
        if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current &&
        // Fix React 18 Strict Mode returnFocus due to double rendering.
        relatedTarget !== getPreviouslyFocusedElement()) {
          preventReturnFocusRef.current = true;
          onOpenChange(false, event, 'focus-out');
        }
      });
    }
    if (floating && isHTMLElement(domReference)) {
      domReference.addEventListener('focusout', handleFocusOutside);
      domReference.addEventListener('pointerdown', handlePointerDown);
      floating.addEventListener('focusout', handleFocusOutside);
      return () => {
        domReference.removeEventListener('focusout', handleFocusOutside);
        domReference.removeEventListener('pointerdown', handlePointerDown);
        floating.removeEventListener('focusout', handleFocusOutside);
      };
    }
  }, [disabled, domReference, floating, floatingFocusElement, modal, nodeId, tree, portalContext, onOpenChange, closeOnFocusOut, restoreFocus, getTabbableContent, isUntrappedTypeableCombobox]);
  react.useEffect(() => {
    var _portalContext$portal;
    if (disabled) return;

    // Don't hide portals nested within the parent portal.
    const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute('portal') + "]")) || []);
    if (floating) {
      const insideElements = [floating, ...portalNodes, startDismissButtonRef.current, endDismissButtonRef.current, orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null].filter(x => x != null);
      const cleanup = modal || isUntrappedTypeableCombobox ? markOthers(insideElements, guards, !guards) : markOthers(insideElements);
      return () => {
        cleanup();
      };
    }
  }, [disabled, domReference, floating, modal, orderRef, portalContext, isUntrappedTypeableCombobox, guards]);
  floating_ui_react_esm_index(() => {
    if (disabled || !isHTMLElement(floatingFocusElement)) return;
    const doc = getDocument(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);

    // Wait for any layout effect state setters to execute to set `tabIndex`.
    queueMicrotask(() => {
      const focusableElements = getTabbableElements(floatingFocusElement);
      const initialFocusValue = initialFocusRef.current;
      const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
      const focusAlreadyInsideFloatingEl = contains(floatingFocusElement, previouslyFocusedElement);
      if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) {
        enqueueFocus(elToFocus, {
          preventScroll: elToFocus === floatingFocusElement
        });
      }
    });
  }, [disabled, open, floatingFocusElement, ignoreInitialFocus, getTabbableElements, initialFocusRef]);
  floating_ui_react_esm_index(() => {
    if (disabled || !floatingFocusElement) return;
    let preventReturnFocusScroll = false;
    const doc = getDocument(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);
    const contextData = dataRef.current;
    let openEvent = contextData.openEvent;
    addPreviouslyFocusedElement(previouslyFocusedElement);

    // Dismissing via outside press should always ignore `returnFocus` to
    // prevent unwanted scrolling.
    function onOpenChange(_ref) {
      let {
        open,
        reason,
        event,
        nested
      } = _ref;
      if (open) {
        openEvent = event;
      }
      if (reason === 'escape-key' && refs.domReference.current) {
        addPreviouslyFocusedElement(refs.domReference.current);
      }
      if (reason === 'hover' && event.type === 'mouseleave') {
        preventReturnFocusRef.current = true;
      }
      if (reason !== 'outside-press') return;
      if (nested) {
        preventReturnFocusRef.current = false;
        preventReturnFocusScroll = true;
      } else {
        preventReturnFocusRef.current = !(isVirtualClick(event) || isVirtualPointerEvent(event));
      }
    }
    events.on('openchange', onOpenChange);
    const fallbackEl = doc.createElement('span');
    fallbackEl.setAttribute('tabindex', '-1');
    fallbackEl.setAttribute('aria-hidden', 'true');
    Object.assign(fallbackEl.style, HIDDEN_STYLES);
    if (isInsidePortal && domReference) {
      domReference.insertAdjacentElement('afterend', fallbackEl);
    }
    function getReturnElement() {
      if (typeof returnFocusRef.current === 'boolean') {
        return getPreviouslyFocusedElement() || fallbackEl;
      }
      return returnFocusRef.current.current || fallbackEl;
    }
    return () => {
      events.off('openchange', onOpenChange);
      const activeEl = activeElement(doc);
      const isFocusInsideFloatingTree = contains(floating, activeEl) || tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
        var _node$context5;
        return contains((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
      });
      const shouldFocusReference = isFocusInsideFloatingTree || openEvent && ['click', 'mousedown'].includes(openEvent.type);
      if (shouldFocusReference && refs.domReference.current) {
        addPreviouslyFocusedElement(refs.domReference.current);
      }
      const returnElement = getReturnElement();
      queueMicrotask(() => {
        if (
        // eslint-disable-next-line react-hooks/exhaustive-deps
        returnFocusRef.current && !preventReturnFocusRef.current && isHTMLElement(returnElement) && (
        // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) {
          returnElement.focus({
            preventScroll: preventReturnFocusScroll
          });
        }
        fallbackEl.remove();
      });
    };
  }, [disabled, floating, floatingFocusElement, returnFocusRef, dataRef, refs, events, tree, nodeId, isInsidePortal, domReference]);
  react.useEffect(() => {
    // The `returnFocus` cleanup behavior is inside a microtask; ensure we
    // wait for it to complete before resetting the flag.
    queueMicrotask(() => {
      preventReturnFocusRef.current = false;
    });
  }, [disabled]);

  // Synchronize the `context` & `modal` value to the FloatingPortal context.
  // It will decide whether or not it needs to render its own guards.
  floating_ui_react_esm_index(() => {
    if (disabled) return;
    if (!portalContext) return;
    portalContext.setFocusManagerState({
      modal,
      closeOnFocusOut,
      open,
      onOpenChange,
      refs
    });
    return () => {
      portalContext.setFocusManagerState(null);
    };
  }, [disabled, portalContext, modal, open, onOpenChange, refs, closeOnFocusOut]);
  floating_ui_react_esm_index(() => {
    if (disabled) return;
    if (!floatingFocusElement) return;
    if (typeof MutationObserver !== 'function') return;
    if (ignoreInitialFocus) return;
    const handleMutation = () => {
      const tabIndex = floatingFocusElement.getAttribute('tabindex');
      const tabbableContent = getTabbableContent();
      const activeEl = activeElement(getDocument(floating));
      const tabbableIndex = tabbableContent.indexOf(activeEl);
      if (tabbableIndex !== -1) {
        tabbableIndexRef.current = tabbableIndex;
      }
      if (orderRef.current.includes('floating') || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
        if (tabIndex !== '0') {
          floatingFocusElement.setAttribute('tabindex', '0');
        }
      } else if (tabIndex !== '-1') {
        floatingFocusElement.setAttribute('tabindex', '-1');
      }
    };
    handleMutation();
    const observer = new MutationObserver(handleMutation);
    observer.observe(floatingFocusElement, {
      childList: true,
      subtree: true,
      attributes: true
    });
    return () => {
      observer.disconnect();
    };
  }, [disabled, floating, floatingFocusElement, refs, orderRef, getTabbableContent, ignoreInitialFocus]);
  function renderDismissButton(location) {
    if (disabled || !visuallyHiddenDismiss || !modal) {
      return null;
    }
    return /*#__PURE__*/react.createElement(VisuallyHiddenDismiss, {
      ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
      onClick: event => onOpenChange(false, event.nativeEvent)
    }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
  }
  const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
  return /*#__PURE__*/react.createElement(react.Fragment, null, shouldRenderGuards && /*#__PURE__*/react.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
    onFocus: event => {
      if (modal) {
        const els = getTabbableElements();
        enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        preventReturnFocusRef.current = false;
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const nextTabbable = getNextTabbable() || domReference;
          nextTabbable == null || nextTabbable.focus();
        } else {
          var _portalContext$before;
          (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
        }
      }
    }
  }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/react.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
    onFocus: event => {
      if (modal) {
        enqueueFocus(getTabbableElements()[0]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        if (closeOnFocusOut) {
          preventReturnFocusRef.current = true;
        }
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const prevTabbable = getPreviousTabbable() || domReference;
          prevTabbable == null || prevTabbable.focus();
        } else {
          var _portalContext$afterO;
          (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
        }
      }
    }
  }));
}

let lockCount = 0;
function enableScrollLock() {
  const isIOS = /iP(hone|ad|od)|iOS/.test(getPlatform());
  const bodyStyle = document.body.style;
  // RTL <body> scrollbar
  const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
  const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
  const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
  bodyStyle.overflow = 'hidden';
  if (scrollbarWidth) {
    bodyStyle[paddingProp] = scrollbarWidth + "px";
  }

  // Only iOS doesn't respect `overflow: hidden` on document.body, and this
  // technique has fewer side effects.
  if (isIOS) {
    var _window$visualViewpor, _window$visualViewpor2;
    // iOS 12 does not support `visualViewport`.
    const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
    const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
    Object.assign(bodyStyle, {
      position: 'fixed',
      top: -(scrollY - Math.floor(offsetTop)) + "px",
      left: -(scrollX - Math.floor(offsetLeft)) + "px",
      right: '0'
    });
  }
  return () => {
    Object.assign(bodyStyle, {
      overflow: '',
      [paddingProp]: ''
    });
    if (isIOS) {
      Object.assign(bodyStyle, {
        position: '',
        top: '',
        left: '',
        right: ''
      });
      window.scrollTo(scrollX, scrollY);
    }
  };
}
let cleanup = () => {};

/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */
const FloatingOverlay = /*#__PURE__*/react.forwardRef(function FloatingOverlay(props, ref) {
  const {
    lockScroll = false,
    ...rest
  } = props;
  floating_ui_react_esm_index(() => {
    if (!lockScroll) return;
    lockCount++;
    if (lockCount === 1) {
      cleanup = enableScrollLock();
    }
    return () => {
      lockCount--;
      if (lockCount === 0) {
        cleanup();
      }
    };
  }, [lockScroll]);
  return /*#__PURE__*/react.createElement("div", _extends({
    ref: ref
  }, rest, {
    style: {
      position: 'fixed',
      overflow: 'auto',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...rest.style
    }
  }));
});

function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */
function useClick(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    elements: {
      domReference
    }
  } = context;
  const {
    enabled = true,
    event: eventOption = 'click',
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true,
    stickIfOpen = true
  } = props;
  const pointerTypeRef = react.useRef();
  const didKeyDownRef = react.useRef(false);
  const reference = react.useMemo(() => ({
    onPointerDown(event) {
      pointerTypeRef.current = event.pointerType;
    },
    onMouseDown(event) {
      const pointerType = pointerTypeRef.current;

      // Ignore all buttons except for the "main" button.
      // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
      if (event.button !== 0) return;
      if (eventOption === 'click') return;
      if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
      if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) {
        onOpenChange(false, event.nativeEvent, 'click');
      } else {
        // Prevent stealing focus from the floating element
        event.preventDefault();
        onOpenChange(true, event.nativeEvent, 'click');
      }
    },
    onClick(event) {
      const pointerType = pointerTypeRef.current;
      if (eventOption === 'mousedown' && pointerTypeRef.current) {
        pointerTypeRef.current = undefined;
        return;
      }
      if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
      if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) {
        onOpenChange(false, event.nativeEvent, 'click');
      } else {
        onOpenChange(true, event.nativeEvent, 'click');
      }
    },
    onKeyDown(event) {
      pointerTypeRef.current = undefined;
      if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) {
        return;
      }
      if (event.key === ' ' && !isSpaceIgnored(domReference)) {
        // Prevent scrolling
        event.preventDefault();
        didKeyDownRef.current = true;
      }
      if (event.key === 'Enter') {
        if (open && toggle) {
          onOpenChange(false, event.nativeEvent, 'click');
        } else {
          onOpenChange(true, event.nativeEvent, 'click');
        }
      }
    },
    onKeyUp(event) {
      if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) {
        return;
      }
      if (event.key === ' ' && didKeyDownRef.current) {
        didKeyDownRef.current = false;
        if (open && toggle) {
          onOpenChange(false, event.nativeEvent, 'click');
        } else {
          onOpenChange(true, event.nativeEvent, 'click');
        }
      }
    }
  }), [dataRef, domReference, eventOption, ignoreMouse, keyboardHandlers, onOpenChange, open, stickIfOpen, toggle]);
  return react.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}

function createVirtualElement(domElement, data) {
  let offsetX = null;
  let offsetY = null;
  let isAutoUpdateEvent = false;
  return {
    contextElement: domElement || undefined,
    getBoundingClientRect() {
      var _data$dataRef$current;
      const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      };
      const isXAxis = data.axis === 'x' || data.axis === 'both';
      const isYAxis = data.axis === 'y' || data.axis === 'both';
      const canTrackCursorOnAutoUpdate = ['mouseenter', 'mousemove'].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
      let width = domRect.width;
      let height = domRect.height;
      let x = domRect.x;
      let y = domRect.y;
      if (offsetX == null && data.x && isXAxis) {
        offsetX = domRect.x - data.x;
      }
      if (offsetY == null && data.y && isYAxis) {
        offsetY = domRect.y - data.y;
      }
      x -= offsetX || 0;
      y -= offsetY || 0;
      width = 0;
      height = 0;
      if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
        width = data.axis === 'y' ? domRect.width : 0;
        height = data.axis === 'x' ? domRect.height : 0;
        x = isXAxis && data.x != null ? data.x : x;
        y = isYAxis && data.y != null ? data.y : y;
      } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
        height = data.axis === 'x' ? domRect.height : height;
        width = data.axis === 'y' ? domRect.width : width;
      }
      isAutoUpdateEvent = true;
      return {
        width,
        height,
        x,
        y,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x
      };
    }
  };
}
function isMouseBasedEvent(event) {
  return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */
function useClientPoint(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    dataRef,
    elements: {
      floating,
      domReference
    },
    refs
  } = context;
  const {
    enabled = true,
    axis = 'both',
    x = null,
    y = null
  } = props;
  const initialRef = react.useRef(false);
  const cleanupListenerRef = react.useRef(null);
  const [pointerType, setPointerType] = react.useState();
  const [reactive, setReactive] = react.useState([]);
  const setReference = useEffectEvent((x, y) => {
    if (initialRef.current) return;

    // Prevent setting if the open event was not a mouse-like one
    // (e.g. focus to open, then hover over the reference element).
    // Only apply if the event exists.
    if (dataRef.current.openEvent && !isMouseBasedEvent(dataRef.current.openEvent)) {
      return;
    }
    refs.setPositionReference(createVirtualElement(domReference, {
      x,
      y,
      axis,
      dataRef,
      pointerType
    }));
  });
  const handleReferenceEnterOrMove = useEffectEvent(event => {
    if (x != null || y != null) return;
    if (!open) {
      setReference(event.clientX, event.clientY);
    } else if (!cleanupListenerRef.current) {
      // If there's no cleanup, there's no listener, but we want to ensure
      // we add the listener if the cursor landed on the floating element and
      // then back on the reference (i.e. it's interactive).
      setReactive([]);
    }
  });

  // If the pointer is a mouse-like pointer, we want to continue following the
  // mouse even if the floating element is transitioning out. On touch
  // devices, this is undesirable because the floating element will move to
  // the dismissal touch point.
  const openCheck = isMouseLikePointerType(pointerType) ? floating : open;
  const addListener = react.useCallback(() => {
    // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
    if (!openCheck || !enabled || x != null || y != null) return;
    const win = getWindow(floating);
    function handleMouseMove(event) {
      const target = getTarget(event);
      if (!contains(floating, target)) {
        setReference(event.clientX, event.clientY);
      } else {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      }
    }
    if (!dataRef.current.openEvent || isMouseBasedEvent(dataRef.current.openEvent)) {
      win.addEventListener('mousemove', handleMouseMove);
      const cleanup = () => {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      };
      cleanupListenerRef.current = cleanup;
      return cleanup;
    }
    refs.setPositionReference(domReference);
  }, [openCheck, enabled, x, y, floating, dataRef, refs, domReference, setReference]);
  react.useEffect(() => {
    return addListener();
  }, [addListener, reactive]);
  react.useEffect(() => {
    if (enabled && !floating) {
      initialRef.current = false;
    }
  }, [enabled, floating]);
  react.useEffect(() => {
    if (!enabled && open) {
      initialRef.current = true;
    }
  }, [enabled, open]);
  floating_ui_react_esm_index(() => {
    if (enabled && (x != null || y != null)) {
      initialRef.current = false;
      setReference(x, y);
    }
  }, [enabled, x, y, setReference]);
  const reference = react.useMemo(() => {
    function setPointerTypeRef(_ref) {
      let {
        pointerType
      } = _ref;
      setPointerType(pointerType);
    }
    return {
      onPointerDown: setPointerTypeRef,
      onPointerEnter: setPointerTypeRef,
      onMouseMove: handleReferenceEnterOrMove,
      onMouseEnter: handleReferenceEnterOrMove
    };
  }, [handleReferenceEnterOrMove]);
  return react.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}

const bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
const captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};
const normalizeProp = normalizable => {
  var _normalizable$escapeK, _normalizable$outside;
  return {
    escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
    outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
  };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    elements,
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = 'pointerdown',
    referencePress = false,
    referencePressEvent = 'pointerdown',
    ancestorScroll = false,
    bubbles,
    capture
  } = props;
  const tree = useFloatingTree();
  const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = react.useRef(false);
  const endedOrStartedInsideRef = react.useRef(false);
  const {
    escapeKey: escapeKeyBubbles,
    outsidePress: outsidePressBubbles
  } = normalizeProp(bubbles);
  const {
    escapeKey: escapeKeyCapture,
    outsidePress: outsidePressCapture
  } = normalizeProp(capture);
  const isComposingRef = react.useRef(false);
  const closeOnEscapeKeyDown = useEffectEvent(event => {
    var _dataRef$current$floa;
    if (!open || !enabled || !escapeKey || event.key !== 'Escape') {
      return;
    }

    // Wait until IME is settled. Pressing `Escape` while composing should
    // close the compose menu, but not the floating element.
    if (isComposingRef.current) {
      return;
    }
    const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach(child => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event, 'escape-key');
  });
  const closeOnEscapeKeyDownCapture = useEffectEvent(event => {
    var _getTarget2;
    const callback = () => {
      var _getTarget;
      closeOnEscapeKeyDown(event);
      (_getTarget = getTarget(event)) == null || _getTarget.removeEventListener('keydown', callback);
    };
    (_getTarget2 = getTarget(event)) == null || _getTarget2.addEventListener('keydown', callback);
  });
  const closeOnPressOutside = useEffectEvent(event => {
    var _dataRef$current$floa2;
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = insideReactTreeRef.current;
    insideReactTreeRef.current = false;

    // When click outside is lazy (`click` event), handle dragging.
    // Don't close if:
    // - The click started inside the floating element.
    // - The click ended inside the floating element.
    const endedOrStartedInside = endedOrStartedInsideRef.current;
    endedOrStartedInsideRef.current = false;
    if (outsidePressEvent === 'click' && endedOrStartedInside) {
      return;
    }
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === 'function' && !outsidePress(event)) {
      return;
    }
    const target = getTarget(event);
    const inertSelector = "[" + createAttribute('inert') + "]";
    const markers = getDocument(elements.floating).querySelectorAll(inertSelector);
    let targetRootAncestor = isElement(target) ? target : null;
    while (targetRootAncestor && !isLastTraversableNode(targetRootAncestor)) {
      const nextParent = getParentNode(targetRootAncestor);
      if (isLastTraversableNode(nextParent) || !isElement(nextParent)) {
        break;
      }
      targetRootAncestor = nextParent;
    }

    // Check if the click occurred on a third-party element injected after the
    // floating element rendered.
    if (markers.length && isElement(target) && !isRootElement(target) &&
    // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !contains(target, elements.floating) &&
    // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(markers).every(marker => !contains(targetRootAncestor, marker))) {
      return;
    }

    // Check if the click occurred on the scrollbar
    if (isHTMLElement(target) && floating) {
      // In Firefox, `target.scrollWidth > target.clientWidth` for inline
      // elements.
      const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      let xCond = canScrollY && event.offsetX > target.clientWidth;

      // In some browsers it is possible to change the <body> (or window)
      // scrollbar to the left side, but is very rare and is difficult to
      // check for. Plus, for modal dialogs with backdrops, it is more
      // important that the backdrop is checked but not so much the window.
      if (canScrollY) {
        const isRTL = floating_ui_utils_dom_getComputedStyle(target).direction === 'rtl';
        if (isRTL) {
          xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
        }
      }
      if (xCond || canScrollX && event.offsetY > target.clientHeight) {
        return;
      }
    }
    const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
    const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, elements.floating) || isEventTargetWithin(event, elements.domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach(child => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    onOpenChange(false, event, 'outside-press');
  });
  const closeOnPressOutsideCapture = useEffectEvent(event => {
    var _getTarget4;
    const callback = () => {
      var _getTarget3;
      closeOnPressOutside(event);
      (_getTarget3 = getTarget(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
    };
    (_getTarget4 = getTarget(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
  });
  react.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    let compositionTimeout = -1;
    function onScroll(event) {
      onOpenChange(false, event, 'ancestor-scroll');
    }
    function handleCompositionStart() {
      window.clearTimeout(compositionTimeout);
      isComposingRef.current = true;
    }
    function handleCompositionEnd() {
      // Safari fires `compositionend` before `keydown`, so we need to wait
      // until the next tick to set `isComposing` to `false`.
      // https://bugs.webkit.org/show_bug.cgi?id=165004
      compositionTimeout = window.setTimeout(() => {
        isComposingRef.current = false;
      },
      // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
      // Only apply to WebKit for the test to remain 0ms.
      isWebKit() ? 5 : 0);
    }
    const doc = getDocument(elements.floating);
    if (escapeKey) {
      doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
      doc.addEventListener('compositionstart', handleCompositionStart);
      doc.addEventListener('compositionend', handleCompositionEnd);
    }
    outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
    let ancestors = [];
    if (ancestorScroll) {
      if (isElement(elements.domReference)) {
        ancestors = getOverflowAncestors(elements.domReference);
      }
      if (isElement(elements.floating)) {
        ancestors = ancestors.concat(getOverflowAncestors(elements.floating));
      }
      if (!isElement(elements.reference) && elements.reference && elements.reference.contextElement) {
        ancestors = ancestors.concat(getOverflowAncestors(elements.reference.contextElement));
      }
    }

    // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
    ancestors = ancestors.filter(ancestor => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(ancestor => {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return () => {
      if (escapeKey) {
        doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
        doc.removeEventListener('compositionstart', handleCompositionStart);
        doc.removeEventListener('compositionend', handleCompositionEnd);
      }
      outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
      ancestors.forEach(ancestor => {
        ancestor.removeEventListener('scroll', onScroll);
      });
      window.clearTimeout(compositionTimeout);
    };
  }, [dataRef, elements, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, escapeKeyCapture, closeOnEscapeKeyDownCapture, closeOnPressOutside, outsidePressCapture, closeOnPressOutsideCapture]);
  react.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  const reference = react.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    [bubbleHandlerKeys[referencePressEvent]]: event => {
      if (referencePress) {
        onOpenChange(false, event.nativeEvent, 'reference-press');
      }
    }
  }), [closeOnEscapeKeyDown, onOpenChange, referencePress, referencePressEvent]);
  const floating = react.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    onMouseDown() {
      endedOrStartedInsideRef.current = true;
    },
    onMouseUp() {
      endedOrStartedInsideRef.current = true;
    },
    [captureHandlerKeys[outsidePressEvent]]: () => {
      insideReactTreeRef.current = true;
    }
  }), [closeOnEscapeKeyDown, outsidePressEvent]);
  return react.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}

function useFloatingRootContext(options) {
  const {
    open = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options;
  const floatingId = useId();
  const dataRef = react.useRef({});
  const [events] = react.useState(() => createPubSub());
  const nested = useFloatingParentNodeId() != null;
  if (false) {}
  const [positionReference, setPositionReference] = react.useState(elementsProp.reference);
  const onOpenChange = useEffectEvent((open, event, reason) => {
    dataRef.current.openEvent = open ? event : undefined;
    events.emit('openchange', {
      open,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
  });
  const refs = react.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = react.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return react.useMemo(() => ({
    dataRef,
    open,
    onOpenChange,
    elements,
    events,
    floatingId,
    refs
  }), [open, onOpenChange, elements, events, floatingId, refs]);
}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */
function floating_ui_react_esm_useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    nodeId
  } = options;
  const internalRootContext = useFloatingRootContext({
    ...options,
    elements: {
      reference: null,
      floating: null,
      ...options.elements
    }
  });
  const rootContext = options.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = react.useState(null);
  const [positionReference, _setPositionReference] = react.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = react.useRef(null);
  const tree = useFloatingTree();
  floating_ui_react_esm_index(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position = useFloating({
    ...options,
    elements: {
      ...computedElements,
      ...(positionReference && {
        reference: positionReference
      })
    }
  });
  const setPositionReference = react.useCallback(node => {
    const computedPositionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    // Store the positionReference in state if the DOM reference is specified externally via the
    // `elements.reference` option. This ensures that it won't be overridden on future renders.
    _setPositionReference(computedPositionReference);
    position.refs.setReference(computedPositionReference);
  }, [position.refs]);
  const setReference = react.useCallback(node => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = react.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = react.useMemo(() => ({
    ...position.elements,
    domReference: domReference
  }), [position.elements, domReference]);
  const context = react.useMemo(() => ({
    ...position,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position, refs, elements, nodeId, rootContext]);
  floating_ui_react_esm_index(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return react.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}

/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */
function useFocus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    events,
    dataRef,
    elements
  } = context;
  const {
    enabled = true,
    visibleOnly = true
  } = props;
  const blockFocusRef = react.useRef(false);
  const timeoutRef = react.useRef();
  const keyboardModalityRef = react.useRef(true);
  react.useEffect(() => {
    if (!enabled) return;
    const win = getWindow(elements.domReference);

    // If the reference was focused and the user left the tab/window, and the
    // floating element was not open, the focus should be blocked when they
    // return to the tab/window.
    function onBlur() {
      if (!open && isHTMLElement(elements.domReference) && elements.domReference === activeElement(getDocument(elements.domReference))) {
        blockFocusRef.current = true;
      }
    }
    function onKeyDown() {
      keyboardModalityRef.current = true;
    }
    win.addEventListener('blur', onBlur);
    win.addEventListener('keydown', onKeyDown, true);
    return () => {
      win.removeEventListener('blur', onBlur);
      win.removeEventListener('keydown', onKeyDown, true);
    };
  }, [elements.domReference, open, enabled]);
  react.useEffect(() => {
    if (!enabled) return;
    function onOpenChange(_ref) {
      let {
        reason
      } = _ref;
      if (reason === 'reference-press' || reason === 'escape-key') {
        blockFocusRef.current = true;
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
    };
  }, [events, enabled]);
  react.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  const reference = react.useMemo(() => ({
    onPointerDown(event) {
      if (isVirtualPointerEvent(event.nativeEvent)) return;
      keyboardModalityRef.current = false;
    },
    onMouseLeave() {
      blockFocusRef.current = false;
    },
    onFocus(event) {
      if (blockFocusRef.current) return;
      const target = getTarget(event.nativeEvent);
      if (visibleOnly && isElement(target)) {
        try {
          // Mac Safari unreliably matches `:focus-visible` on the reference
          // if focus was outside the page initially - use the fallback
          // instead.
          if (isSafari() && isMac()) throw Error();
          if (!target.matches(':focus-visible')) return;
        } catch (e) {
          // Old browsers will throw an error when using `:focus-visible`.
          if (!keyboardModalityRef.current && !isTypeableElement(target)) {
            return;
          }
        }
      }
      onOpenChange(true, event.nativeEvent, 'focus');
    },
    onBlur(event) {
      blockFocusRef.current = false;
      const relatedTarget = event.relatedTarget;
      const nativeEvent = event.nativeEvent;

      // Hit the non-modal focus management portal guard. Focus will be
      // moved into the floating element immediately after.
      const movedToFocusGuard = isElement(relatedTarget) && relatedTarget.hasAttribute(createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';

      // Wait for the window blur listener to fire.
      timeoutRef.current = window.setTimeout(() => {
        var _dataRef$current$floa;
        const activeEl = activeElement(elements.domReference ? elements.domReference.ownerDocument : document);

        // Focus left the page, keep it open.
        if (!relatedTarget && activeEl === elements.domReference) return;

        // When focusing the reference element (e.g. regular click), then
        // clicking into the floating element, prevent it from hiding.
        // Note: it must be focusable, e.g. `tabindex="-1"`.
        // We can not rely on relatedTarget to point to the correct element
        // as it will only point to the shadow host of the newly focused element
        // and not the element that actually has received focus if it is located
        // inside a shadow root.
        if (contains((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || contains(elements.domReference, activeEl) || movedToFocusGuard) {
          return;
        }
        onOpenChange(false, nativeEvent, 'focus');
      });
    }
  }), [dataRef, elements.domReference, onOpenChange, visibleOnly]);
  return react.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}

const ACTIVE_KEY = 'active';
const SELECTED_KEY = 'selected';
function mergeProps(userProps, propsList, elementKey) {
  const map = new Map();
  const isItem = elementKey === 'item';
  let domUserProps = userProps;
  if (isItem && userProps) {
    const {
      [ACTIVE_KEY]: _,
      [SELECTED_KEY]: __,
      ...validProps
    } = userProps;
    domUserProps = validProps;
  }
  return {
    ...(elementKey === 'floating' && {
      tabIndex: -1,
      [FOCUSABLE_ATTRIBUTE]: ''
    }),
    ...domUserProps,
    ...propsList.map(value => {
      const propsOrGetProps = value ? value[elementKey] : null;
      if (typeof propsOrGetProps === 'function') {
        return userProps ? propsOrGetProps(userProps) : null;
      }
      return propsOrGetProps;
    }).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach(_ref => {
        let [key, value] = _ref;
        if (isItem && [ACTIVE_KEY, SELECTED_KEY].includes(key)) {
          return;
        }
        if (key.indexOf('on') === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === 'function') {
            var _map$get;
            (_map$get = map.get(key)) == null || _map$get.push(value);
            acc[key] = function () {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(fn => fn(...args)).find(val => val !== undefined);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  const referenceDeps = propsList.map(key => key == null ? void 0 : key.reference);
  const floatingDeps = propsList.map(key => key == null ? void 0 : key.floating);
  const itemDeps = propsList.map(key => key == null ? void 0 : key.item);
  const getReferenceProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'reference'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  referenceDeps);
  const getFloatingProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'floating'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  floatingDeps);
  const getItemProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'item'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  itemDeps);
  return react.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}

let isPreventScrollSupported = false;
function doSwitch(orientation, vertical, horizontal) {
  switch (orientation) {
    case 'vertical':
      return vertical;
    case 'horizontal':
      return horizontal;
    default:
      return vertical || horizontal;
  }
}
function isMainOrientationKey(key, orientation) {
  const vertical = key === ARROW_UP || key === ARROW_DOWN;
  const horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
  const vertical = key === ARROW_DOWN;
  const horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  const horizontal = key === ARROW_DOWN;
  return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
  const horizontal = key === ARROW_UP;
  return doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */
function useListNavigation(context, props) {
  const {
    open,
    onOpenChange,
    elements
  } = context;
  const {
    listRef,
    activeIndex,
    onNavigate: unstable_onNavigate = () => {},
    enabled = true,
    selectedIndex = null,
    allowEscape = false,
    loop = false,
    nested = false,
    rtl = false,
    virtual = false,
    focusItemOnOpen = 'auto',
    focusItemOnHover = true,
    openOnArrowKeyDown = true,
    disabledIndices = undefined,
    orientation = 'vertical',
    cols = 1,
    scrollItemIntoView = true,
    virtualItemRef,
    itemSizes,
    dense = false
  } = props;
  if (false) {}
  const floatingFocusElement = getFloatingFocusElement(elements.floating);
  const floatingFocusElementRef = floating_ui_react_esm_useLatestRef(floatingFocusElement);
  const parentId = useFloatingParentNodeId();
  const tree = useFloatingTree();
  const onNavigate = useEffectEvent(unstable_onNavigate);
  const typeableComboboxReference = isTypeableCombobox(elements.domReference);
  const focusItemOnOpenRef = react.useRef(focusItemOnOpen);
  const indexRef = react.useRef(selectedIndex != null ? selectedIndex : -1);
  const keyRef = react.useRef(null);
  const isPointerModalityRef = react.useRef(true);
  const previousOnNavigateRef = react.useRef(onNavigate);
  const previousMountedRef = react.useRef(!!elements.floating);
  const previousOpenRef = react.useRef(open);
  const forceSyncFocus = react.useRef(false);
  const forceScrollIntoViewRef = react.useRef(false);
  const disabledIndicesRef = floating_ui_react_esm_useLatestRef(disabledIndices);
  const latestOpenRef = floating_ui_react_esm_useLatestRef(open);
  const scrollItemIntoViewRef = floating_ui_react_esm_useLatestRef(scrollItemIntoView);
  const selectedIndexRef = floating_ui_react_esm_useLatestRef(selectedIndex);
  const [activeId, setActiveId] = react.useState();
  const [virtualId, setVirtualId] = react.useState();
  const focusItem = useEffectEvent(function (listRef, indexRef, forceScrollIntoView) {
    if (forceScrollIntoView === void 0) {
      forceScrollIntoView = false;
    }
    function runFocus(item) {
      if (virtual) {
        setActiveId(item.id);
        tree == null || tree.events.emit('virtualfocus', item);
        if (virtualItemRef) {
          virtualItemRef.current = item;
        }
      } else {
        enqueueFocus(item, {
          preventScroll: true,
          // Mac Safari does not move the virtual cursor unless the focus call
          // is sync. However, for the very first focus call, we need to wait
          // for the position to be ready in order to prevent unwanted
          // scrolling. This means the virtual cursor will not move to the first
          // item when first opening the floating element, but will on
          // subsequent calls. `preventScroll` is supported in modern Safari,
          // so we can use that instead.
          // iOS Safari must be async or the first item will not be focused.
          sync: isMac() && isSafari() ? isPreventScrollSupported || forceSyncFocus.current : false
        });
      }
    }
    const initialItem = listRef.current[indexRef.current];
    if (initialItem) {
      runFocus(initialItem);
    }
    requestAnimationFrame(() => {
      const waitedItem = listRef.current[indexRef.current] || initialItem;
      if (!waitedItem) return;
      if (!initialItem) {
        runFocus(waitedItem);
      }
      const scrollIntoViewOptions = scrollItemIntoViewRef.current;
      const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
      if (shouldScrollIntoView) {
        // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
        // by all browsers.
        waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
          block: 'nearest',
          inline: 'nearest'
        } : scrollIntoViewOptions);
      }
    });
  });
  floating_ui_react_esm_index(() => {
    document.createElement('div').focus({
      get preventScroll() {
        isPreventScrollSupported = true;
        return false;
      }
    });
  }, []);

  // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
  // element. Also, reset `activeIndex` upon closing the floating element.
  floating_ui_react_esm_index(() => {
    if (!enabled) return;
    if (open && elements.floating) {
      if (focusItemOnOpenRef.current && selectedIndex != null) {
        // Regardless of the pointer modality, we want to ensure the selected
        // item comes into view when the floating element is opened.
        forceScrollIntoViewRef.current = true;
        indexRef.current = selectedIndex;
        onNavigate(selectedIndex);
      }
    } else if (previousMountedRef.current) {
      // Since the user can specify `onNavigate` conditionally
      // (onNavigate: open ? setActiveIndex : setSelectedIndex),
      // we store and call the previous function.
      indexRef.current = -1;
      previousOnNavigateRef.current(null);
    }
  }, [enabled, open, elements.floating, selectedIndex, onNavigate]);

  // Sync `activeIndex` to be the focused item while the floating element is
  // open.
  floating_ui_react_esm_index(() => {
    if (!enabled) return;
    if (open && elements.floating) {
      if (activeIndex == null) {
        forceSyncFocus.current = false;
        if (selectedIndexRef.current != null) {
          return;
        }

        // Reset while the floating element was open (e.g. the list changed).
        if (previousMountedRef.current) {
          indexRef.current = -1;
          focusItem(listRef, indexRef);
        }

        // Initial sync.
        if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
          let runs = 0;
          const waitForListPopulated = () => {
            if (listRef.current[0] == null) {
              // Avoid letting the browser paint if possible on the first try,
              // otherwise use rAF. Don't try more than twice, since something
              // is wrong otherwise.
              if (runs < 2) {
                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                scheduler(waitForListPopulated);
              }
              runs++;
            } else {
              indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinIndex(listRef, disabledIndicesRef.current) : getMaxIndex(listRef, disabledIndicesRef.current);
              keyRef.current = null;
              onNavigate(indexRef.current);
            }
          };
          waitForListPopulated();
        }
      } else if (!isIndexOutOfBounds(listRef, activeIndex)) {
        indexRef.current = activeIndex;
        focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
        forceScrollIntoViewRef.current = false;
      }
    }
  }, [enabled, open, elements.floating, activeIndex, selectedIndexRef, nested, listRef, orientation, rtl, onNavigate, focusItem, disabledIndicesRef]);

  // Ensure the parent floating element has focus when a nested child closes
  // to allow arrow key navigation to work after the pointer leaves the child.
  floating_ui_react_esm_index(() => {
    var _nodes$find;
    if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) {
      return;
    }
    const nodes = tree.nodesRef.current;
    const parent = (_nodes$find = nodes.find(node => node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
    const activeEl = activeElement(getDocument(elements.floating));
    const treeContainsActiveEl = nodes.some(node => node.context && contains(node.context.elements.floating, activeEl));
    if (parent && !treeContainsActiveEl && isPointerModalityRef.current) {
      parent.focus({
        preventScroll: true
      });
    }
  }, [enabled, elements.floating, tree, parentId, virtual]);
  floating_ui_react_esm_index(() => {
    if (!enabled) return;
    if (!tree) return;
    if (!virtual) return;
    if (parentId) return;
    function handleVirtualFocus(item) {
      setVirtualId(item.id);
      if (virtualItemRef) {
        virtualItemRef.current = item;
      }
    }
    tree.events.on('virtualfocus', handleVirtualFocus);
    return () => {
      tree.events.off('virtualfocus', handleVirtualFocus);
    };
  }, [enabled, tree, virtual, parentId, virtualItemRef]);
  floating_ui_react_esm_index(() => {
    previousOnNavigateRef.current = onNavigate;
    previousMountedRef.current = !!elements.floating;
  });
  floating_ui_react_esm_index(() => {
    if (!open) {
      keyRef.current = null;
    }
  }, [open]);
  floating_ui_react_esm_index(() => {
    previousOpenRef.current = open;
  }, [open]);
  const hasActiveIndex = activeIndex != null;
  const item = react.useMemo(() => {
    function syncCurrentTarget(currentTarget) {
      if (!open) return;
      const index = listRef.current.indexOf(currentTarget);
      if (index !== -1) {
        onNavigate(index);
      }
    }
    const props = {
      onFocus(_ref) {
        let {
          currentTarget
        } = _ref;
        syncCurrentTarget(currentTarget);
      },
      onClick: _ref2 => {
        let {
          currentTarget
        } = _ref2;
        return currentTarget.focus({
          preventScroll: true
        });
      },
      // Safari
      ...(focusItemOnHover && {
        onMouseMove(_ref3) {
          let {
            currentTarget
          } = _ref3;
          syncCurrentTarget(currentTarget);
        },
        onPointerLeave(_ref4) {
          let {
            pointerType
          } = _ref4;
          if (!isPointerModalityRef.current || pointerType === 'touch') {
            return;
          }
          indexRef.current = -1;
          focusItem(listRef, indexRef);
          onNavigate(null);
          if (!virtual) {
            enqueueFocus(floatingFocusElementRef.current, {
              preventScroll: true
            });
          }
        }
      })
    };
    return props;
  }, [open, floatingFocusElementRef, focusItem, focusItemOnHover, listRef, onNavigate, virtual]);
  const commonOnKeyDown = useEffectEvent(event => {
    isPointerModalityRef.current = false;
    forceSyncFocus.current = true;

    // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
    // don't appear to suffer from this. `event.isComposing` is avoided due to
    // Safari not supporting it properly (although it's not needed in the first
    // place for Safari, just avoiding any possible issues).
    if (event.which === 229) {
      return;
    }

    // If the floating element is animating out, ignore navigation. Otherwise,
    // the `activeIndex` gets set to 0 despite not being open so the next time
    // the user ArrowDowns, the first item won't be focused.
    if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) {
      return;
    }
    if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl)) {
      stopEvent(event);
      onOpenChange(false, event.nativeEvent, 'list-navigation');
      if (isHTMLElement(elements.domReference)) {
        if (virtual) {
          tree == null || tree.events.emit('virtualfocus', elements.domReference);
        } else {
          elements.domReference.focus();
        }
      }
      return;
    }
    const currentIndex = indexRef.current;
    const minIndex = getMinIndex(listRef, disabledIndices);
    const maxIndex = getMaxIndex(listRef, disabledIndices);
    if (!typeableComboboxReference) {
      if (event.key === 'Home') {
        stopEvent(event);
        indexRef.current = minIndex;
        onNavigate(indexRef.current);
      }
      if (event.key === 'End') {
        stopEvent(event);
        indexRef.current = maxIndex;
        onNavigate(indexRef.current);
      }
    }

    // Grid navigation.
    if (cols > 1) {
      const sizes = itemSizes || Array.from({
        length: listRef.current.length
      }, () => ({
        width: 1,
        height: 1
      }));
      // To calculate movements on the grid, we use hypothetical cell indices
      // as if every item was 1x1, then convert back to real indices.
      const cellMap = buildCellMap(sizes, cols, dense);
      const minGridIndex = cellMap.findIndex(index => index != null && !isDisabled(listRef.current, index, disabledIndices));
      // last enabled index
      const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex) => index != null && !isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
      const index = cellMap[getGridNavigatedIndex({
        current: cellMap.map(itemIndex => itemIndex != null ? listRef.current[itemIndex] : null)
      }, {
        event,
        orientation,
        loop,
        rtl,
        cols,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getCellIndices([...(disabledIndices || listRef.current.map((_, index) => isDisabled(listRef.current, index) ? index : undefined)), undefined], cellMap),
        minIndex: minGridIndex,
        maxIndex: maxGridIndex,
        prevIndex: getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols,
        // use a corner matching the edge closest to the direction
        // we're moving in so we don't end up in the same item. Prefer
        // top/left over bottom/right.
        event.key === ARROW_DOWN ? 'bl' : event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT) ? 'tr' : 'tl'),
        stopEvent: true
      })];
      if (index != null) {
        indexRef.current = index;
        onNavigate(indexRef.current);
      }
      if (orientation === 'both') {
        return;
      }
    }
    if (isMainOrientationKey(event.key, orientation)) {
      stopEvent(event);

      // Reset the index if no item is focused.
      if (open && !virtual && activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
        indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
        onNavigate(indexRef.current);
        return;
      }
      if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
        if (loop) {
          indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            disabledIndices
          });
        } else {
          indexRef.current = Math.min(maxIndex, findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            disabledIndices
          }));
        }
      } else {
        if (loop) {
          indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices
          });
        } else {
          indexRef.current = Math.max(minIndex, findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices
          }));
        }
      }
      if (isIndexOutOfBounds(listRef, indexRef.current)) {
        onNavigate(null);
      } else {
        onNavigate(indexRef.current);
      }
    }
  });
  const ariaActiveDescendantProp = react.useMemo(() => {
    return virtual && open && hasActiveIndex && {
      'aria-activedescendant': virtualId || activeId
    };
  }, [virtual, open, hasActiveIndex, virtualId, activeId]);
  const floating = react.useMemo(() => {
    return {
      'aria-orientation': orientation === 'both' ? undefined : orientation,
      ...(!isTypeableCombobox(elements.domReference) && ariaActiveDescendantProp),
      onKeyDown: commonOnKeyDown,
      onPointerMove() {
        isPointerModalityRef.current = true;
      }
    };
  }, [ariaActiveDescendantProp, commonOnKeyDown, elements.domReference, orientation]);
  const reference = react.useMemo(() => {
    function checkVirtualMouse(event) {
      if (focusItemOnOpen === 'auto' && isVirtualClick(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    function checkVirtualPointer(event) {
      // `pointerdown` fires first, reset the state then perform the checks.
      focusItemOnOpenRef.current = focusItemOnOpen;
      if (focusItemOnOpen === 'auto' && isVirtualPointerEvent(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    return {
      ...ariaActiveDescendantProp,
      onKeyDown(event) {
        isPointerModalityRef.current = false;
        const isArrowKey = event.key.startsWith('Arrow');
        const isHomeOrEndKey = ['Home', 'End'].includes(event.key);
        const isMoveKey = isArrowKey || isHomeOrEndKey;
        const isCrossOpenKey = isCrossOrientationOpenKey(event.key, orientation, rtl);
        const isCrossCloseKey = isCrossOrientationCloseKey(event.key, orientation, rtl);
        const isMainKey = isMainOrientationKey(event.key, orientation);
        const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
        if (virtual && open) {
          const rootNode = tree == null ? void 0 : tree.nodesRef.current.find(node => node.parentId == null);
          const deepestNode = tree && rootNode ? getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
          if (isMoveKey && deepestNode && virtualItemRef) {
            const eventObject = new KeyboardEvent('keydown', {
              key: event.key,
              bubbles: true
            });
            if (isCrossOpenKey || isCrossCloseKey) {
              var _deepestNode$context, _deepestNode$context2;
              const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
              const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find(item => (item == null ? void 0 : item.id) === activeId) : null;
              if (dispatchItem) {
                stopEvent(event);
                dispatchItem.dispatchEvent(eventObject);
                setVirtualId(undefined);
              }
            }
            if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
              if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                var _deepestNode$context$;
                stopEvent(event);
                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                return;
              }
            }
          }
          return commonOnKeyDown(event);
        }

        // If a floating element should not open on arrow key down, avoid
        // setting `activeIndex` while it's closed.
        if (!open && !openOnArrowKeyDown && isArrowKey) {
          return;
        }
        if (isNavigationKey) {
          keyRef.current = nested && isMainKey ? null : event.key;
        }
        if (nested) {
          if (isCrossOpenKey) {
            stopEvent(event);
            if (open) {
              indexRef.current = getMinIndex(listRef, disabledIndicesRef.current);
              onNavigate(indexRef.current);
            } else {
              onOpenChange(true, event.nativeEvent, 'list-navigation');
            }
          }
          return;
        }
        if (isMainKey) {
          if (selectedIndex != null) {
            indexRef.current = selectedIndex;
          }
          stopEvent(event);
          if (!open && openOnArrowKeyDown) {
            onOpenChange(true, event.nativeEvent, 'list-navigation');
          } else {
            commonOnKeyDown(event);
          }
          if (open) {
            onNavigate(indexRef.current);
          }
        }
      },
      onFocus() {
        if (open && !virtual) {
          onNavigate(null);
        }
      },
      onPointerDown: checkVirtualPointer,
      onMouseDown: checkVirtualMouse,
      onClick: checkVirtualMouse
    };
  }, [activeId, ariaActiveDescendantProp, commonOnKeyDown, disabledIndicesRef, focusItemOnOpen, listRef, nested, onNavigate, onOpenChange, open, openOnArrowKeyDown, orientation, rtl, selectedIndex, tree, virtual, virtualItemRef]);
  return react.useMemo(() => enabled ? {
    reference,
    floating,
    item
  } : {}, [enabled, reference, floating, item]);
}

const componentRoleToAriaRoleMap = /*#__PURE__*/new Map([['select', 'listbox'], ['combobox', 'listbox'], ['label', false]]);

/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */
function useRole(context, props) {
  var _componentRoleToAriaR;
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    floatingId
  } = context;
  const {
    enabled = true,
    role = 'dialog'
  } = props;
  const ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
  const referenceId = useId();
  const parentId = useFloatingParentNodeId();
  const isNested = parentId != null;
  const reference = react.useMemo(() => {
    if (ariaRole === 'tooltip' || role === 'label') {
      return {
        ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
      };
    }
    return {
      'aria-expanded': open ? 'true' : 'false',
      'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
      'aria-controls': open ? floatingId : undefined,
      ...(ariaRole === 'listbox' && {
        role: 'combobox'
      }),
      ...(ariaRole === 'menu' && {
        id: referenceId
      }),
      ...(ariaRole === 'menu' && isNested && {
        role: 'menuitem'
      }),
      ...(role === 'select' && {
        'aria-autocomplete': 'none'
      }),
      ...(role === 'combobox' && {
        'aria-autocomplete': 'list'
      })
    };
  }, [ariaRole, floatingId, isNested, open, referenceId, role]);
  const floating = react.useMemo(() => {
    const floatingProps = {
      id: floatingId,
      ...(ariaRole && {
        role: ariaRole
      })
    };
    if (ariaRole === 'tooltip' || role === 'label') {
      return floatingProps;
    }
    return {
      ...floatingProps,
      ...(ariaRole === 'menu' && {
        'aria-labelledby': referenceId
      })
    };
  }, [ariaRole, floatingId, referenceId, role]);
  const item = react.useCallback(_ref => {
    let {
      active,
      selected
    } = _ref;
    const commonProps = {
      role: 'option',
      ...(active && {
        id: floatingId + "-option"
      })
    };

    // For `menu`, we are unable to tell if the item is a `menuitemradio`
    // or `menuitemcheckbox`. For backwards-compatibility reasons, also
    // avoid defaulting to `menuitem` as it may overwrite custom role props.
    switch (role) {
      case 'select':
        return {
          ...commonProps,
          'aria-selected': active && selected
        };
      case 'combobox':
        {
          return {
            ...commonProps,
            ...(active && {
              'aria-selected': true
            })
          };
        }
    }
    return {};
  }, [floatingId, role]);
  return react.useMemo(() => enabled ? {
    reference,
    floating,
    item
  } : {}, [enabled, reference, floating, item]);
}

// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const camelCaseToKebabCase = str => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
function execWithArgsOrReturn(valueOrFn, args) {
  return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
  const [isMounted, setIsMounted] = react.useState(open);
  if (open && !isMounted) {
    setIsMounted(true);
  }
  react.useEffect(() => {
    if (!open && isMounted) {
      const timeout = setTimeout(() => setIsMounted(false), durationMs);
      return () => clearTimeout(timeout);
    }
  }, [open, isMounted, durationMs]);
  return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */
function useTransitionStatus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    elements: {
      floating
    }
  } = context;
  const {
    duration = 250
  } = props;
  const isNumberDuration = typeof duration === 'number';
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [status, setStatus] = react.useState('unmounted');
  const isMounted = useDelayUnmount(open, closeDuration);
  if (!isMounted && status === 'close') {
    setStatus('unmounted');
  }
  floating_ui_react_esm_index(() => {
    if (!floating) return;
    if (open) {
      setStatus('initial');
      const frame = requestAnimationFrame(() => {
        setStatus('open');
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    }
    setStatus('close');
  }, [open, floating]);
  return {
    isMounted,
    status
  };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */
function useTransitionStyles(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    initial: unstable_initial = {
      opacity: 0
    },
    open: unstable_open,
    close: unstable_close,
    common: unstable_common,
    duration = 250
  } = props;
  const placement = context.placement;
  const side = placement.split('-')[0];
  const fnArgs = react.useMemo(() => ({
    side,
    placement
  }), [side, placement]);
  const isNumberDuration = typeof duration === 'number';
  const openDuration = (isNumberDuration ? duration : duration.open) || 0;
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [styles, setStyles] = react.useState(() => ({
    ...execWithArgsOrReturn(unstable_common, fnArgs),
    ...execWithArgsOrReturn(unstable_initial, fnArgs)
  }));
  const {
    isMounted,
    status
  } = useTransitionStatus(context, {
    duration
  });
  const initialRef = floating_ui_react_esm_useLatestRef(unstable_initial);
  const openRef = floating_ui_react_esm_useLatestRef(unstable_open);
  const closeRef = floating_ui_react_esm_useLatestRef(unstable_close);
  const commonRef = floating_ui_react_esm_useLatestRef(unstable_common);
  floating_ui_react_esm_index(() => {
    const initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
    const closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
    const commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
    const openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key) => {
      acc[key] = '';
      return acc;
    }, {});
    if (status === 'initial') {
      setStyles(styles => ({
        transitionProperty: styles.transitionProperty,
        ...commonStyles,
        ...initialStyles
      }));
    }
    if (status === 'open') {
      setStyles({
        transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(','),
        transitionDuration: openDuration + "ms",
        ...commonStyles,
        ...openStyles
      });
    }
    if (status === 'close') {
      const styles = closeStyles || initialStyles;
      setStyles({
        transitionProperty: Object.keys(styles).map(camelCaseToKebabCase).join(','),
        transitionDuration: closeDuration + "ms",
        ...commonStyles,
        ...styles
      });
    }
  }, [closeDuration, closeRef, initialRef, openRef, commonRef, openDuration, status, fnArgs]);
  return {
    isMounted,
    styles
  };
}

/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */
function useTypeahead(context, props) {
  var _ref;
  const {
    open,
    dataRef
  } = context;
  const {
    listRef,
    activeIndex,
    onMatch: unstable_onMatch,
    onTypingChange: unstable_onTypingChange,
    enabled = true,
    findMatch = null,
    resetMs = 750,
    ignoreKeys = [],
    selectedIndex = null
  } = props;
  const timeoutIdRef = react.useRef();
  const stringRef = react.useRef('');
  const prevIndexRef = react.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
  const matchIndexRef = react.useRef(null);
  const onMatch = useEffectEvent(unstable_onMatch);
  const onTypingChange = useEffectEvent(unstable_onTypingChange);
  const findMatchRef = floating_ui_react_esm_useLatestRef(findMatch);
  const ignoreKeysRef = floating_ui_react_esm_useLatestRef(ignoreKeys);
  floating_ui_react_esm_index(() => {
    if (open) {
      clearTimeout(timeoutIdRef.current);
      matchIndexRef.current = null;
      stringRef.current = '';
    }
  }, [open]);
  floating_ui_react_esm_index(() => {
    // Sync arrow key navigation but not typeahead navigation.
    if (open && stringRef.current === '') {
      var _ref2;
      prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
    }
  }, [open, selectedIndex, activeIndex]);
  const setTypingChange = useEffectEvent(value => {
    if (value) {
      if (!dataRef.current.typing) {
        dataRef.current.typing = value;
        onTypingChange(value);
      }
    } else {
      if (dataRef.current.typing) {
        dataRef.current.typing = value;
        onTypingChange(value);
      }
    }
  });
  const onKeyDown = useEffectEvent(event => {
    function getMatchingIndex(list, orderedList, string) {
      const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find(text => (text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
      return str ? list.indexOf(str) : -1;
    }
    const listContent = listRef.current;
    if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
      if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) {
        setTypingChange(false);
      } else if (event.key === ' ') {
        stopEvent(event);
      }
    }
    if (listContent == null || ignoreKeysRef.current.includes(event.key) ||
    // Character key.
    event.key.length !== 1 ||
    // Modifier key.
    event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }
    if (open && event.key !== ' ') {
      stopEvent(event);
      setTypingChange(true);
    }

    // Bail out if the list contains a word like "llama" or "aaron". TODO:
    // allow it in this case, too.
    const allowRapidSuccessionOfFirstLetter = listContent.every(text => {
      var _text$, _text$2;
      return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
    });

    // Allows the user to cycle through items that start with the same letter
    // in rapid succession.
    if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
      stringRef.current = '';
      prevIndexRef.current = matchIndexRef.current;
    }
    stringRef.current += event.key;
    clearTimeout(timeoutIdRef.current);
    timeoutIdRef.current = setTimeout(() => {
      stringRef.current = '';
      prevIndexRef.current = matchIndexRef.current;
      setTypingChange(false);
    }, resetMs);
    const prevIndex = prevIndexRef.current;
    const index = getMatchingIndex(listContent, [...listContent.slice((prevIndex || 0) + 1), ...listContent.slice(0, (prevIndex || 0) + 1)], stringRef.current);
    if (index !== -1) {
      onMatch(index);
      matchIndexRef.current = index;
    } else if (event.key !== ' ') {
      stringRef.current = '';
      setTypingChange(false);
    }
  });
  const reference = react.useMemo(() => ({
    onKeyDown
  }), [onKeyDown]);
  const floating = react.useMemo(() => {
    return {
      onKeyDown,
      onKeyUp(event) {
        if (event.key === ' ') {
          setTypingChange(false);
        }
      }
    };
  }, [onKeyDown, setTypingChange]);
  return react.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}

function getArgsWithCustomFloatingHeight(state, height) {
  return {
    ...state,
    rects: {
      ...state.rects,
      floating: {
        ...state.rects.floating,
        height
      }
    }
  };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */
const inner = props => ({
  name: 'inner',
  options: props,
  async fn(state) {
    const {
      listRef,
      overflowRef,
      onFallbackChange,
      offset: innerOffset = 0,
      index = 0,
      minItemsVisible = 4,
      referenceOverflowThreshold = 0,
      scrollRef,
      ...detectOverflowOptions
    } = evaluate(props, state);
    const {
      rects,
      elements: {
        floating
      }
    } = state;
    const item = listRef.current[index];
    const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;

    // Valid combinations:
    // 1. Floating element is the scrollRef and has a border (default)
    // 2. Floating element is not the scrollRef, floating element has a border
    // 3. Floating element is not the scrollRef, scrollRef has a border
    // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
    // allowed as VoiceOver doesn't work.
    const clientTop = floating.clientTop || scrollEl.clientTop;
    const floatingIsBordered = floating.clientTop !== 0;
    const scrollElIsBordered = scrollEl.clientTop !== 0;
    const floatingIsScrollEl = floating === scrollEl;
    if (false) {}
    if (!item) {
      return {};
    }
    const nextArgs = {
      ...state,
      ...(await floating_ui_react_dom_offset(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state))
    };
    const overflow = await floating_ui_dom_detectOverflow(getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
    const refOverflow = await floating_ui_dom_detectOverflow(nextArgs, {
      ...detectOverflowOptions,
      elementContext: 'reference'
    });
    const diffY = max(0, overflow.top);
    const nextY = nextArgs.y + diffY;
    const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
    const rounder = isScrollable ? v => v : round;
    const maxHeight = rounder(max(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - max(0, overflow.bottom)));
    scrollEl.style.maxHeight = maxHeight + "px";
    scrollEl.scrollTop = diffY;

    // There is not enough space, fallback to standard anchored positioning
    if (onFallbackChange) {
      const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * min(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
      react_dom.flushSync(() => onFallbackChange(shouldFallback));
    }
    if (overflowRef) {
      overflowRef.current = await floating_ui_dom_detectOverflow(getArgsWithCustomFloatingHeight({
        ...nextArgs,
        y: nextY
      }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
    }
    return {
      y: nextY
    };
  }
});
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */
function useInnerOffset(context, props) {
  const {
    open,
    elements
  } = context;
  const {
    enabled = true,
    overflowRef,
    scrollRef,
    onChange: unstable_onChange
  } = props;
  const onChange = useEffectEvent(unstable_onChange);
  const controlledScrollingRef = react.useRef(false);
  const prevScrollTopRef = react.useRef(null);
  const initialOverflowRef = react.useRef(null);
  react.useEffect(() => {
    if (!enabled) return;
    function onWheel(e) {
      if (e.ctrlKey || !el || overflowRef.current == null) {
        return;
      }
      const dY = e.deltaY;
      const isAtTop = overflowRef.current.top >= -0.5;
      const isAtBottom = overflowRef.current.bottom >= -0.5;
      const remainingScroll = el.scrollHeight - el.clientHeight;
      const sign = dY < 0 ? -1 : 1;
      const method = dY < 0 ? 'max' : 'min';
      if (el.scrollHeight <= el.clientHeight) {
        return;
      }
      if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
        e.preventDefault();
        react_dom.flushSync(() => {
          onChange(d => d + Math[method](dY, remainingScroll * sign));
        });
      } else if (/firefox/i.test(getUserAgent())) {
        // Needed to propagate scrolling during momentum scrolling phase once
        // it gets limited by the boundary. UX improvement, not critical.
        el.scrollTop += dY;
      }
    }
    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
    if (open && el) {
      el.addEventListener('wheel', onWheel);

      // Wait for the position to be ready.
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
        if (overflowRef.current != null) {
          initialOverflowRef.current = {
            ...overflowRef.current
          };
        }
      });
      return () => {
        prevScrollTopRef.current = null;
        initialOverflowRef.current = null;
        el.removeEventListener('wheel', onWheel);
      };
    }
  }, [enabled, open, elements.floating, overflowRef, scrollRef, onChange]);
  const floating = react.useMemo(() => ({
    onKeyDown() {
      controlledScrollingRef.current = true;
    },
    onWheel() {
      controlledScrollingRef.current = false;
    },
    onPointerMove() {
      controlledScrollingRef.current = false;
    },
    onScroll() {
      const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
      if (!overflowRef.current || !el || !controlledScrollingRef.current) {
        return;
      }
      if (prevScrollTopRef.current !== null) {
        const scrollDiff = el.scrollTop - prevScrollTopRef.current;
        if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) {
          react_dom.flushSync(() => onChange(d => d + scrollDiff));
        }
      }

      // [Firefox] Wait for the height change to have been applied.
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
      });
    }
  }), [elements.floating, onChange, overflowRef, scrollRef]);
  return react.useMemo(() => enabled ? {
    floating
  } : {}, [enabled, floating]);
}

function isPointInPolygon(point, polygon) {
  const [x, y] = point;
  let isInside = false;
  const length = polygon.length;
  for (let i = 0, j = length - 1; i < length; j = i++) {
    const [xi, yi] = polygon[i] || [0, 0];
    const [xj, yj] = polygon[j] || [0, 0];
    const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) {
      isInside = !isInside;
    }
  }
  return isInside;
}
function isInside(point, rect) {
  return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */
function safePolygon(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    buffer = 0.5,
    blockPointerEvents = false,
    requireIntent = true
  } = options;
  let timeoutId;
  let hasLanded = false;
  let lastX = null;
  let lastY = null;
  let lastCursorTime = performance.now();
  function getCursorSpeed(x, y) {
    const currentTime = performance.now();
    const elapsedTime = currentTime - lastCursorTime;
    if (lastX === null || lastY === null || elapsedTime === 0) {
      lastX = x;
      lastY = y;
      lastCursorTime = currentTime;
      return null;
    }
    const deltaX = x - lastX;
    const deltaY = y - lastY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    const speed = distance / elapsedTime; // px / ms

    lastX = x;
    lastY = y;
    lastCursorTime = currentTime;
    return speed;
  }
  const fn = _ref => {
    let {
      x,
      y,
      placement,
      elements,
      onClose,
      nodeId,
      tree
    } = _ref;
    return function onMouseMove(event) {
      function close() {
        clearTimeout(timeoutId);
        onClose();
      }
      clearTimeout(timeoutId);
      if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) {
        return;
      }
      const {
        clientX,
        clientY
      } = event;
      const clientPoint = [clientX, clientY];
      const target = getTarget(event);
      const isLeave = event.type === 'mouseleave';
      const isOverFloatingEl = contains(elements.floating, target);
      const isOverReferenceEl = contains(elements.domReference, target);
      const refRect = elements.domReference.getBoundingClientRect();
      const rect = elements.floating.getBoundingClientRect();
      const side = placement.split('-')[0];
      const cursorLeaveFromRight = x > rect.right - rect.width / 2;
      const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
      const isOverReferenceRect = isInside(clientPoint, refRect);
      const isFloatingWider = rect.width > refRect.width;
      const isFloatingTaller = rect.height > refRect.height;
      const left = (isFloatingWider ? refRect : rect).left;
      const right = (isFloatingWider ? refRect : rect).right;
      const top = (isFloatingTaller ? refRect : rect).top;
      const bottom = (isFloatingTaller ? refRect : rect).bottom;
      if (isOverFloatingEl) {
        hasLanded = true;
        if (!isLeave) {
          return;
        }
      }
      if (isOverReferenceEl) {
        hasLanded = false;
      }
      if (isOverReferenceEl && !isLeave) {
        hasLanded = true;
        return;
      }

      // Prevent overlapping floating element from being stuck in an open-close
      // loop: https://github.com/floating-ui/floating-ui/issues/1910
      if (isLeave && isElement(event.relatedTarget) && contains(elements.floating, event.relatedTarget)) {
        return;
      }

      // If any nested child is open, abort.
      if (tree && getChildren(tree.nodesRef.current, nodeId).some(_ref2 => {
        let {
          context
        } = _ref2;
        return context == null ? void 0 : context.open;
      })) {
        return;
      }

      // If the pointer is leaving from the opposite side, the "buffer" logic
      // creates a point where the floating element remains open, but should be
      // ignored.
      // A constant of 1 handles floating point rounding errors.
      if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) {
        return close();
      }

      // Ignore when the cursor is within the rectangular trough between the
      // two elements. Since the triangle is created from the cursor point,
      // which can start beyond the ref element's edge, traversing back and
      // forth from the ref to the floating element can cause it to close. This
      // ensures it always remains open in that case.
      let rectPoly = [];
      switch (side) {
        case 'top':
          rectPoly = [[left, refRect.top + 1], [left, rect.bottom - 1], [right, rect.bottom - 1], [right, refRect.top + 1]];
          break;
        case 'bottom':
          rectPoly = [[left, rect.top + 1], [left, refRect.bottom - 1], [right, refRect.bottom - 1], [right, rect.top + 1]];
          break;
        case 'left':
          rectPoly = [[rect.right - 1, bottom], [rect.right - 1, top], [refRect.left + 1, top], [refRect.left + 1, bottom]];
          break;
        case 'right':
          rectPoly = [[refRect.right - 1, bottom], [refRect.right - 1, top], [rect.left + 1, top], [rect.left + 1, bottom]];
          break;
      }
      function getPolygon(_ref3) {
        let [x, y] = _ref3;
        switch (side) {
          case 'top':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'bottom':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'left':
            {
              const cursorPointOne = [x + buffer + 1, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x + buffer + 1, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer, rect.bottom]];
              return [...commonPoints, cursorPointOne, cursorPointTwo];
            }
          case 'right':
            {
              const cursorPointOne = [x - buffer, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x - buffer, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer, rect.bottom]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
        }
      }
      if (isPointInPolygon([clientX, clientY], rectPoly)) {
        return;
      }
      if (hasLanded && !isOverReferenceRect) {
        return close();
      }
      if (!isLeave && requireIntent) {
        const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
        const cursorSpeedThreshold = 0.1;
        if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) {
          return close();
        }
      }
      if (!isPointInPolygon([clientX, clientY], getPolygon([x, y]))) {
        close();
      } else if (!hasLanded && requireIntent) {
        timeoutId = window.setTimeout(close, 40);
      }
    };
  };
  fn.__options = {
    blockPointerEvents
  };
  return fn;
}




/***/ }),

/***/ 92642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "av": function() { return /* binding */ setUser; },
/* harmony export */   "e": function() { return /* binding */ configureScope; },
/* harmony export */   "n_": function() { return /* binding */ addBreadcrumb; },
/* harmony export */   "uT": function() { return /* binding */ captureMessage; }
/* harmony export */ });
/* unused harmony exports captureEvent, setContext, setExtra, setExtras, setTag, setTags, startTransaction */
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66465);


// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return getCurrentHub().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return getCurrentHub().startTransaction({ ...context }, customSamplingContext);
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 66465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, getHubFromCarrier, makeMain, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58536);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90063);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4266);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51877);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48364);




const NIL_EVENT_ID = '00000000000000000000000000000000';

/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * A layer in the process stack.
 * @hidden
 */

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */
    __init() {this._stack = [{}];}

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope */ .s(),   _version = API_VERSION) {;this._version = _version;Hub.prototype.__init.call(this);
    this.getStackTop().scope = scope;
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint) {
    const syntheticException = new Error('Sentry syntheticException');
    this._lastEventId =
      this._withClient((client, scope) => {
        return client.captureException(
          exception,
          {
            originalException: exception,
            syntheticException,
            ...hint,
          },
          scope,
        );
      }) || NIL_EVENT_ID;
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const syntheticException = new Error(message);
    this._lastEventId =
      this._withClient((client, scope) => {
        return client.captureMessage(
          message,
          level,
          {
            originalException: message,
            syntheticException,
            ...hint,
          },
          scope,
        );
      }) || NIL_EVENT_ID;
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const clientId =
      this._withClient((client, scope) => {
        return client.captureEvent(event, { ...hint }, scope);
      }) || NIL_EVENT_ID;

    if (event.type !== 'transaction') {
      this._lastEventId = clientId;
    }

    return clientId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!scope || !client) return;

    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dateTimestampInSeconds */ .yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    const scope = this.getScope();
    if (scope) scope.setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    const scope = this.getScope();
    if (scope) scope.setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    const scope = this.getScope();
    if (scope) scope.setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    const scope = this.getScope();
    if (scope) scope.setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    const scope = this.getScope();
    if (scope) scope.setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    const scope = this.getScope();
    if (scope) scope.setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (scope && client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer && layer.scope;
    const session = scope && scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_3__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    if (scope) {
      scope.setSession();
    }
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

    const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_3__/* .makeSession */ .Hv)({
      release,
      environment,
      ...(scope && { user: scope.getUser() }),
      ...(userAgent && { userAgent }),
      ...context,
    });

    if (scope) {
      // End existing session if there's one
      const currentSession = scope.getSession && scope.getSession();
      if (currentSession && currentSession.status === 'ok') {
        (0,_session_js__WEBPACK_IMPORTED_MODULE_3__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
      }
      this.endSession();

      // Afterwards we set the new session on the scope
      scope.setSession(session);
    }

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();
    if (!scope) return;

    const session = scope.getSession();
    if (session) {
      if (client && client.captureSession) {
        client.captureSession(session);
      }
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    return client && callback(client, scope);
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .GLOBAL_OBJ */ .n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Prefer domains over global if they are there (applicable only to Node environment)
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isNodeEnv */ .KV)()) {
    return getHubFromActiveDomain(registry);
  }
  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
  try {
    const sentry = getMainCarrier().__SENTRY__;
    const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;

    // If there's no active domain, just return global hub
    if (!activeDomain) {
      return getHubFromCarrier(registry);
    }

    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
      const registryHubTopStack = getHubFromCarrier(registry).getStackTop();
      setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(registryHubTopStack.scope)));
    }

    // Return hub that lives on a domain
    return getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
  }
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalSingleton */ .YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 51877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81757);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97946);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58536);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63699);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90063);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48364);



/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transactionName = this._span.transaction && this._span.transaction.name;
      if (transactionName) {
        event.tags = { transaction: transactionName, ...event.tags };
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW((resolve, reject) => {
      const processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        const result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .arrayify */ .lE)(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 48364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63699);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21995);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  const session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 78900:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ addExtensionMethods; },
  "lb": function() { return /* binding */ startIdleTransaction; }
});

// UNUSED EXPORTS: _addTracingExtensions

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(66465);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(58536);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(81757);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(4266);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(64005);
// EXTERNAL MODULE: ../../node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(92517);
;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/errors.js



/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
  (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}


//# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(40564);
// EXTERNAL MODULE: ../../node_modules/@sentry/tracing/esm/transaction.js
var esm_transaction = __webpack_require__(18235);
;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/hubextensions.js
/* module decorator */ module = __webpack_require__.hmd(module);







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  const scope = this.getScope();
  if (scope) {
    const span = scope.getSpan();
    if (span) {
      return {
        'sentry-trace': span.toTraceparent(),
      };
    }
  }
  return {};
}

/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!(0,utils/* hasTracingEnabled */.zu)(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      sampleRate: Number(transaction.sampled),
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(

  transactionContext,
  customSamplingContext,
) {
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.error */.kg.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    transactionContext.sampled = false;
  }

  let transaction = new esm_transaction/* Transaction */.Y(transactionContext, this);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
) {
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  let transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * @private
 */
function _addTracingExtensions() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }
}

/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }

  const packageToIntegrationMapping = {
    mongodb() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo')

;
      return new integration.Mongo();
    },
    mongoose() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo')

;
      return new integration.Mongo({ mongoose: true });
    },
    mysql() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mysql')

;
      return new integration.Mysql();
    },
    pg() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/postgres')

;
      return new integration.Postgres();
    },
  };

  const mappedPackages = Object.keys(packageToIntegrationMapping)
    .filter(moduleName => !!(0,node/* loadModule */.$y)(moduleName))
    .map(pkg => {
      try {
        return packageToIntegrationMapping[pkg]();
      } catch (e) {
        return undefined;
      }
    })
    .filter(p => p) ;

  if (mappedPackages.length > 0) {
    carrier.__SENTRY__.integrations = [...(carrier.__SENTRY__.integrations || []), ...mappedPackages];
  }
}

/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
  _addTracingExtensions();

  // Detect and automatically load specified integrations.
  if ((0,node/* isNodeEnv */.KV)()) {
    _autoloadDatabaseIntegrations();
  }

  // If an error happens globally, we should make sure transaction status is set to error.
  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map


/***/ }),

/***/ 40564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hd": function() { return /* binding */ DEFAULT_HEARTBEAT_INTERVAL; },
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; },
/* harmony export */   "mg": function() { return /* binding */ DEFAULT_FINAL_TIMEOUT; },
/* harmony export */   "nT": function() { return /* binding */ DEFAULT_IDLE_TIMEOUT; }
/* harmony export */ });
/* unused harmony export IdleTransactionSpanRecorder */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58536);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28207);
/* harmony import */ var _transaction_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18235);




const DEFAULT_IDLE_TIMEOUT = 1000;
const DEFAULT_FINAL_TIMEOUT = 30000;
const DEFAULT_HEARTBEAT_INTERVAL = 5000;

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;;
  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends _transaction_js__WEBPACK_IMPORTED_MODULE_2__/* .Transaction */ .Y {
  // Activities store a list of active spans
   __init() {this.activities = {};}

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
   __init2() {this._heartbeatCounter = 0;}

  // We should not use heartbeat if we finished a transaction
   __init3() {this._finished = false;}

    __init4() {this._beforeFinishCallbacks = [];}

  /**
   * Timer that tracks Transaction idleTimeout
   */

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = DEFAULT_IDLE_TIMEOUT,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = DEFAULT_FINAL_TIMEOUT,
      _heartbeatInterval = DEFAULT_HEARTBEAT_INTERVAL,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;IdleTransaction.prototype.__init.call(this);IdleTransaction.prototype.__init2.call(this);IdleTransaction.prototype.__init3.call(this);IdleTransaction.prototype.__init4.call(this);;

    if (_onScope) {
      // There should only be one active transaction on the scope
      clearActiveTransaction(_idleHub);

      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._startIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)()) {
    this._finished = true;
    this.activities = {};

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const keepSpan = span.startTimestamp < endTimestamp;
        if (!keepSpan) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
              '[Tracing] discarding Span since it happened after Transaction was finished',
              JSON.stringify(span, undefined, 2),
            );
        }
        return keepSpan;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      clearActiveTransaction(this._idleHub);
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idletimeout, if there is one
   */
   _cancelIdleTimeout() {
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;
    }
  }

  /**
   * Creates an idletimeout
   */
   _startIdleTimeout(endTimestamp) {
    this._cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this._cancelIdleTimeout();
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      // We need to add the timeout here to have the real endtimestamp of the transaction
      // Remember timestampWithMs is in seconds, timeout is in ms
      const endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)() + this._idleTimeout / 1000;
      this._startIdleTimeout(endTimestamp);
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter += 1;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
  const scope = hub.getScope();
  if (scope) {
    const transaction = scope.getTransaction();
    if (transaction) {
      scope.setSpan(undefined);
    }
  }
}


//# sourceMappingURL=idletransaction.js.map


/***/ }),

/***/ 28207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var _sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12885);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63699);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58536);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21995);



/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {
   __init() {this.spans = [];}

   constructor(maxlen = 1000) {;SpanRecorder.prototype.__init.call(this);
    this._maxlen = maxlen;
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */
   __init2() {this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();}

  /**
   * @inheritDoc
   */
   __init3() {this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);}

  /**
   * @inheritDoc
   */

  /**
   * Internal keeper of the status
   */

  /**
   * @inheritDoc
   */

  /**
   * Timestamp in seconds when the span was created.
   */
   __init4() {this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();}

  /**
   * Timestamp in seconds when the span ended.
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   __init5() {this.tags = {};}

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   __init6() {this.data = {};}

  /**
   * List of spans that were finalized
   */

  /**
   * @inheritDoc
   */

  /**
   * The instrumenter that created this span.
   */
   __init7() {this.instrumenter = 'sentry';}

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext) {;Span.prototype.__init2.call(this);Span.prototype.__init3.call(this);Span.prototype.__init4.call(this);Span.prototype.__init5.call(this);Span.prototype.__init6.call(this);Span.prototype.__init7.call(this);
    if (!spanContext) {
      return this;
    }
    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }
    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }
    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.data) {
      this.data = spanContext.data;
    }
    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
    if (spanContext.instrumenter) {
      this.instrumenter = spanContext.instrumenter;
    }
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = childSpan.transaction.name || '< unknown name >';
      const idStr = childSpan.transaction.spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    const spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    let sampledString = '';
    if (this.sampled !== undefined) {
      sampledString = this.sampled ? '-1' : '-0';
    }
    return `${this.traceId}-${this.spanId}${sampledString}`;
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.data, () => ( {}));
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.spanId, () => ( this.spanId));
    this.startTimestamp = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.startTimestamp, () => ( this.startTimestamp));
    this.status = spanContext.status;
    this.tags = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.tags, () => ( {}));
    this.traceId = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.traceId, () => ( this.traceId));

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map


/***/ }),

/***/ 18235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var _sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12885);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66465);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58536);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21995);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28207);





/** JSDoc */
class Transaction extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .Span */ .Dr  {

  /**
   * The reference to the current hub.
   */

   __init() {this._measurements = {};}

   __init2() {this._contexts = {};}

   __init3() {this._frozenDynamicSamplingContext = undefined;}

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);Transaction.prototype.__init.call(this);Transaction.prototype.__init2.call(this);Transaction.prototype.__init3.call(this);;

    this._hub = hub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();

    this._name = transactionContext.name || '';

    this.metadata = {
      source: 'custom',
      ...transactionContext.metadata,
      spanMetadata: {},
      changes: [],
      propagations: 0,
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` as custom */
   set name(newName) {
    this.setName(newName);
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    // `source` could change without the name changing if we discover that an unparameterized route is actually
    // parameterized by virtue of having no parameters in its path
    if (name !== this.name || source !== this.metadata.source) {
      this.metadata.changes.push({
        // log previous source
        source: this.metadata.source,
        timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .ph)(),
        propagations: this.metadata.propagations,
      });
    }

    this._name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      const client = this._hub.getClient();
      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    const metadata = this.metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        dynamicSamplingContext: this.getDynamicSamplingContext(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
          changes: metadata.changes,
          propagations: metadata.propagations,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    const spanContext = super.toContext();

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_5__/* ._nullishCoalesce */ .h)(transactionContext.name, () => ( ''));

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext) {
      return this._frozenDynamicSamplingContext;
    }

    const hub = this._hub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
    const client = hub && hub.getClient();

    if (!client) return {};

    const { environment, release } = client.getOptions() || {};
    const { publicKey: public_key } = client.getDsn() || {};

    const maybeSampleRate = this.metadata.sampleRate;
    const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;

    const scope = hub.getScope();
    const { segment: user_segment } = (scope && scope.getUser()) || {};

    const source = this.metadata.source;

    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const transaction = source && source !== 'url' ? this.name : undefined;

    const dsc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
      environment,
      release,
      transaction,
      user_segment,
      public_key,
      trace_id: this.traceId,
      sample_rate,
    });

    // Uncomment if we want to make DSC immutable
    // this._frozenDynamicSamplingContext = dsc;

    return dsc;
  }
}


//# sourceMappingURL=transaction.js.map


/***/ }),

/***/ 92517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XL": function() { return /* binding */ msToSec; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; },
/* harmony export */   "zu": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* unused harmony export secToMs */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66465);



/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  const client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}

/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  const hub = maybeHub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  const scope = hub.getScope();
  return scope && (scope.getTransaction() );
}

/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
  return time * 1000;
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 54194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81757);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const MAX_OUTPUT_LEN = 80;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;

    // eslint-disable-next-line no-plusplus
    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector) ;
  }
  return null;
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 12885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ _nullishCoalesce; }
/* harmony export */ });
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */
function _nullishCoalesce(lhs, rhsFn) {
  // by checking for loose equality to `null`, we catch both `null` and `undefined`
  return lhs != null ? lhs : rhsFn();
}

// Sucrase version:
// function _nullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return rhsFn();
//   }
// }


//# sourceMappingURL=_nullishCoalesce.js.map


/***/ }),

/***/ 64005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ addInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81757);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58536);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21995);
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69038);
/* harmony import */ var _supports_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49798);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);







// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

const handlers = {};
const instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (const handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in WINDOW)) {
    return;
  }

  _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function (level) {
    if (!(level in WINDOW.console)) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(WINDOW.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsNativeFetch */ .t$)()) {
    return;
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW, 'fetch', function (originalFetch) {
    return function (...args) {
      const handlerData = {
        args,
        fetchData: {
          method: getFetchMethod(args),
          url: getFetchUrl(args),
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(WINDOW, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs = []) {
  if ('Request' in WINDOW && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
    return String(fetchArgs[0].method).toUpperCase();
  }
  if (fetchArgs[1] && fetchArgs[1].method) {
    return String(fetchArgs[1].method).toUpperCase();
  }
  return 'GET';
}

/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs = []) {
  if (typeof fetchArgs[0] === 'string') {
    return fetchArgs[0];
  }
  if ('Request' in WINDOW && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request)) {
    return fetchArgs[0].url;
  }
  return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in WINDOW)) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const xhr = this;
      const url = args[1];
      const xhrInfo = (xhr.__sentry_xhr__ = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
      });

      // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        xhr.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = function () {
        if (xhr.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = xhr.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr,
          });
        }
      };

      if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
        (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhr, 'onreadystatechange', function (original) {
          return function (...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(xhr, readyStateArgs);
          };
        });
      } else {
        xhr.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      return originalOpen.apply(xhr, args);
    };
  });

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      if (this.__sentry_xhr__ && args[0] !== undefined) {
        this.__sentry_xhr__.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsHistory */ .Bf)()) {
    return;
  }

  const oldOnPopState = WINDOW.onpopstate;
  WINDOW.onpopstate = function ( ...args) {
    const to = WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.history, 'pushState', historyReplacementFunction);
  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.history, 'replaceState', historyReplacementFunction);
}

const debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    const target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = WINDOW.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in WINDOW)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (WINDOW )[target] && (WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount += 1;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount -= 1;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = WINDOW.onerror;

  WINDOW.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = WINDOW.onunhandledrejection;

  WINDOW.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 81757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 58536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const originalConsole = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    const originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('logger', makeLogger);
} else {
  logger = makeLogger();
}


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 63699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21995);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  const lineno = frame.lineno || 0;
  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 4266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; },
  "$y": function() { return /* binding */ loadModule; }
});

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}


//# sourceMappingURL=env.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(34406);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !isBrowserBundle() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 21995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54194);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81757);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39660);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  const proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(
  value,
)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_1__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 69038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */


const STACKTRACE_LIMIT = 50;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];

    for (const line of stack.split('\n').slice(skipFirst)) {
      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = line.replace(/\(error: (.*)\)/, '$1');

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  let localStack = stack;

  const firstFrameFunction = localStack[0].function || '';
  const lastFrameFunction = localStack[localStack.length - 1].function || '';

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
    localStack = localStack.slice(1);
  }

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
    localStack = localStack.slice(0, -1);
  }

  // The frame where the crash happened, should be the last entry in the array
  return localStack
    .slice(0, STACKTRACE_LIMIT)
    .map(frame => ({
      ...frame,
      filename: frame.filename || localStack[0].filename,
      function: frame.function || '?',
    }))
    .reverse();
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

// eslint-disable-next-line complexity
function node(getModule) {
  const FILENAME_MATCH = /^\s*[-]{4,}$/;
  const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;

  // eslint-disable-next-line complexity
  return (line) => {
    if (line.match(FILENAME_MATCH)) {
      return {
        filename: line,
      };
    }

    const lineMatch = line.match(FULL_MATCH);
    if (!lineMatch) {
      return undefined;
    }

    let object;
    let method;
    let functionName;
    let typeName;
    let methodName;

    if (lineMatch[1]) {
      functionName = lineMatch[1];

      let methodStart = functionName.lastIndexOf('.');
      if (functionName[methodStart - 1] === '.') {
        // eslint-disable-next-line no-plusplus
        methodStart--;
      }

      if (methodStart > 0) {
        object = functionName.substr(0, methodStart);
        method = functionName.substr(methodStart + 1);
        const objectEnd = object.indexOf('.Module');
        if (objectEnd > 0) {
          functionName = functionName.substr(objectEnd + 1);
          object = object.substr(0, objectEnd);
        }
      }
      typeName = undefined;
    }

    if (method) {
      typeName = object;
      methodName = method;
    }

    if (method === '<anonymous>') {
      methodName = undefined;
      functionName = undefined;
    }

    if (functionName === undefined) {
      methodName = methodName || '<anonymous>';
      functionName = typeName ? `${typeName}.${methodName}` : methodName;
    }

    const filename = _optionalChain([lineMatch, 'access', _ => _[2], 'optionalAccess', _2 => _2.startsWith, 'call', _3 => _3('file://')]) ? lineMatch[2].substr(7) : lineMatch[2];
    const isNative = lineMatch[5] === 'native';
    const isInternal =
      isNative || (filename && !filename.startsWith('/') && !filename.startsWith('.') && filename.indexOf(':\\') !== 1);

    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    const in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');

    return {
      filename,
      module: _optionalChain([getModule, 'optionalCall', _4 => _4(filename)]),
      function: functionName,
      lineno: parseInt(lineMatch[3], 10) || undefined,
      colno: parseInt(lineMatch[4], 10) || undefined,
      in_app,
    };
  };
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 39660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony exports escapeStringForRegex, isMatchingPattern, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81757);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.substr(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}

/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
  // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
  // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
  return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 49798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Bf": function() { return /* binding */ supportsHistory; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy, supportsReportingObserver */
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58536);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chrome = (WINDOW ).chrome;
  const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supports.js.map


/***/ }),

/***/ 97946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81757);


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}

   constructor(
    executor,
  ) {;SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 7790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4266);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

// Re-exported with an old name for backwards-compatibility.
const timestampWithMs = timestampInSeconds;

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 90063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 24458:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var _global = (typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1.164.0"};

/***/ }),

/***/ 12533:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 95766:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(95766)
var ieee754 = __webpack_require__(62333)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 45936:
/***/ (function(module) {

module.exports = clamp

function clamp(value, min, max) {
  return min < max
    ? (value < min ? min : value > max ? max : value)
    : (value < max ? max : value > min ? min : value)
}


/***/ }),

/***/ 72779:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 87944:
/***/ (function(module) {

function r(e){var o,t,f="";if("string"==typeof e||"number"==typeof e)f+=e;else if("object"==typeof e)if(Array.isArray(e)){var n=e.length;for(o=0;o<n;o++)e[o]&&(t=r(e[o]))&&(f&&(f+=" "),f+=t)}else for(t in e)e[t]&&(f&&(f+=" "),f+=t);return f}function e(){for(var e,o,t=0,f="",n=arguments.length;t<n;t++)(e=arguments[t])&&(o=r(e))&&(f&&(f+=" "),f+=o);return f}module.exports=e,module.exports.clsx=e;

/***/ }),

/***/ 13421:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 35196:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.checkCookies = exports.hasCookie = exports.removeCookies = exports.deleteCookie = exports.setCookies = exports.setCookie = exports.getCookie = exports.getCookies = void 0;
var cookie_1 = __webpack_require__(13421);
var isClientSide = function () { return typeof window !== 'undefined'; };
var processValue = function (value) {
    if (value === 'true')
        return true;
    if (value === 'false')
        return false;
    if (value === 'undefined')
        return undefined;
    if (value === 'null')
        return null;
    return value;
};
var stringify = function (value) {
    if (value === void 0) { value = ''; }
    try {
        var result = JSON.stringify(value);
        return (/^[\{\[]/.test(result)) ? result : value;
    }
    catch (e) {
        return value;
    }
};
var decode = function (str) {
    if (!str)
        return str;
    return str.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
};
var getCookies = function (options) {
    var req;
    if (options)
        req = options.req;
    if (!isClientSide()) {
        // if cookie-parser is used in project get cookies from ctx.req.cookies
        // if cookie-parser isn't used in project get cookies from ctx.req.headers.cookie
        if (req && req.cookies)
            return req.cookies;
        if (req && req.headers && req.headers.cookie)
            return (0, cookie_1.parse)(req.headers.cookie);
        return {};
    }
    var _cookies = {};
    var documentCookies = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0, len = documentCookies.length; i < len; i++) {
        var cookieParts = documentCookies[i].split('=');
        var _cookie = cookieParts.slice(1).join('=');
        var name_1 = cookieParts[0];
        _cookies[name_1] = _cookie;
    }
    return _cookies;
};
exports.getCookies = getCookies;
var getCookie = function (key, options) {
    var _cookies = (0, exports.getCookies)(options);
    var value = _cookies[key];
    if (value === undefined)
        return undefined;
    return processValue(decode(value));
};
exports.getCookie = getCookie;
var setCookie = function (key, data, options) {
    var _cookieOptions;
    var _req;
    var _res;
    if (options) {
        var req = options.req, res = options.res, _options = __rest(options, ["req", "res"]);
        _req = req;
        _res = res;
        _cookieOptions = _options;
    }
    var cookieStr = (0, cookie_1.serialize)(key, stringify(data), __assign({ path: '/' }, _cookieOptions));
    if (!isClientSide()) {
        if (_res && _req) {
            var currentCookies = _res.getHeader('Set-Cookie');
            if (!Array.isArray(currentCookies)) {
                currentCookies = !currentCookies ? [] : [String(currentCookies)];
            }
            _res.setHeader('Set-Cookie', currentCookies.concat(cookieStr));
            if (_req && _req.cookies) {
                var _cookies = _req.cookies;
                data === '' ? delete _cookies[key] : _cookies[key] = stringify(data);
            }
            if (_req && _req.headers && _req.headers.cookie) {
                var _cookies = (0, cookie_1.parse)(_req.headers.cookie);
                data === '' ? delete _cookies[key] : _cookies[key] = stringify(data);
                _req.headers.cookie = Object.entries(_cookies).reduce(function (accum, item) {
                    return accum.concat("".concat(item[0], "=").concat(item[1], ";"));
                }, '');
            }
        }
    }
    else {
        document.cookie = cookieStr;
    }
};
exports.setCookie = setCookie;
var setCookies = function (key, data, options) {
    console.warn('[WARN]: setCookies was deprecated. It will be deleted in the new version. Use setCookie instead.');
    return (0, exports.setCookie)(key, data, options);
};
exports.setCookies = setCookies;
var deleteCookie = function (key, options) {
    return (0, exports.setCookie)(key, '', __assign(__assign({}, options), { maxAge: -1 }));
};
exports.deleteCookie = deleteCookie;
var removeCookies = function (key, options) {
    console.warn('[WARN]: removeCookies was deprecated. It will be deleted in the new version. Use deleteCookie instead.');
    return (0, exports.deleteCookie)(key, options);
};
exports.removeCookies = removeCookies;
var hasCookie = function (key, options) {
    if (!key)
        return false;
    var cookie = (0, exports.getCookies)(options);
    return cookie.hasOwnProperty(key);
};
exports.hasCookie = hasCookie;
var checkCookies = function (key, options) {
    console.warn('[WARN]: checkCookies was deprecated. It will be deleted in the new version. Use hasCookie instead.');
    return (0, exports.hasCookie)(key, options);
};
exports.checkCookies = checkCookies;


/***/ }),

/***/ 2291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var cardTypes = __webpack_require__(89244);
var add_matching_cards_to_results_1 = __webpack_require__(2418);
var is_valid_input_type_1 = __webpack_require__(99361);
var find_best_match_1 = __webpack_require__(23551);
var clone_1 = __webpack_require__(46228);
var customCards = {};
var cardNames = {
    VISA: "visa",
    MASTERCARD: "mastercard",
    AMERICAN_EXPRESS: "american-express",
    DINERS_CLUB: "diners-club",
    DISCOVER: "discover",
    JCB: "jcb",
    UNIONPAY: "unionpay",
    MAESTRO: "maestro",
    ELO: "elo",
    MIR: "mir",
    HIPER: "hiper",
    HIPERCARD: "hipercard",
};
var ORIGINAL_TEST_ORDER = [
    cardNames.VISA,
    cardNames.MASTERCARD,
    cardNames.AMERICAN_EXPRESS,
    cardNames.DINERS_CLUB,
    cardNames.DISCOVER,
    cardNames.JCB,
    cardNames.UNIONPAY,
    cardNames.MAESTRO,
    cardNames.ELO,
    cardNames.MIR,
    cardNames.HIPER,
    cardNames.HIPERCARD,
];
var testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
function findType(cardType) {
    return customCards[cardType] || cardTypes[cardType];
}
function getAllCardTypes() {
    return testOrder.map(function (cardType) { return clone_1.clone(findType(cardType)); });
}
function getCardPosition(name, ignoreErrorForNotExisting) {
    if (ignoreErrorForNotExisting === void 0) { ignoreErrorForNotExisting = false; }
    var position = testOrder.indexOf(name);
    if (!ignoreErrorForNotExisting && position === -1) {
        throw new Error('"' + name + '" is not a supported card type.');
    }
    return position;
}
function creditCardType(cardNumber) {
    var results = [];
    if (!is_valid_input_type_1.isValidInputType(cardNumber)) {
        return results;
    }
    if (cardNumber.length === 0) {
        return getAllCardTypes();
    }
    testOrder.forEach(function (cardType) {
        var cardConfiguration = findType(cardType);
        add_matching_cards_to_results_1.addMatchingCardsToResults(cardNumber, cardConfiguration, results);
    });
    var bestMatch = find_best_match_1.findBestMatch(results);
    if (bestMatch) {
        return [bestMatch];
    }
    return results;
}
creditCardType.getTypeInfo = function (cardType) {
    return clone_1.clone(findType(cardType));
};
creditCardType.removeCard = function (name) {
    var position = getCardPosition(name);
    testOrder.splice(position, 1);
};
creditCardType.addCard = function (config) {
    var existingCardPosition = getCardPosition(config.type, true);
    customCards[config.type] = config;
    if (existingCardPosition === -1) {
        testOrder.push(config.type);
    }
};
creditCardType.updateCard = function (cardType, updates) {
    var originalObject = customCards[cardType] || cardTypes[cardType];
    if (!originalObject) {
        throw new Error("\"" + cardType + "\" is not a recognized type. Use `addCard` instead.'");
    }
    if (updates.type && originalObject.type !== updates.type) {
        throw new Error("Cannot overwrite type parameter.");
    }
    var clonedCard = clone_1.clone(originalObject);
    clonedCard = __assign(__assign({}, clonedCard), updates);
    customCards[clonedCard.type] = clonedCard;
};
creditCardType.changeOrder = function (name, position) {
    var currentPosition = getCardPosition(name);
    testOrder.splice(currentPosition, 1);
    testOrder.splice(position, 0, name);
};
creditCardType.resetModifications = function () {
    testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
    customCards = {};
};
creditCardType.types = cardNames;
module.exports = creditCardType;


/***/ }),

/***/ 2418:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addMatchingCardsToResults = void 0;
var clone_1 = __webpack_require__(46228);
var matches_1 = __webpack_require__(77318);
function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
    var i, patternLength;
    for (i = 0; i < cardConfiguration.patterns.length; i++) {
        var pattern = cardConfiguration.patterns[i];
        if (!matches_1.matches(cardNumber, pattern)) {
            continue;
        }
        var clonedCardConfiguration = clone_1.clone(cardConfiguration);
        if (Array.isArray(pattern)) {
            patternLength = String(pattern[0]).length;
        }
        else {
            patternLength = String(pattern).length;
        }
        if (cardNumber.length >= patternLength) {
            clonedCardConfiguration.matchStrength = patternLength;
        }
        results.push(clonedCardConfiguration);
        break;
    }
}
exports.addMatchingCardsToResults = addMatchingCardsToResults;


/***/ }),

/***/ 89244:
/***/ (function(module) {

"use strict";

var cardTypes = {
    visa: {
        niceType: "Visa",
        type: "visa",
        patterns: [4],
        gaps: [4, 8, 12],
        lengths: [16, 18, 19],
        code: {
            name: "CVV",
            size: 3,
        },
    },
    mastercard: {
        niceType: "Mastercard",
        type: "mastercard",
        patterns: [[51, 55], [2221, 2229], [223, 229], [23, 26], [270, 271], 2720],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3,
        },
    },
    "american-express": {
        niceType: "American Express",
        type: "american-express",
        patterns: [34, 37],
        gaps: [4, 10],
        lengths: [15],
        code: {
            name: "CID",
            size: 4,
        },
    },
    "diners-club": {
        niceType: "Diners Club",
        type: "diners-club",
        patterns: [[300, 305], 36, 38, 39],
        gaps: [4, 10],
        lengths: [14, 16, 19],
        code: {
            name: "CVV",
            size: 3,
        },
    },
    discover: {
        niceType: "Discover",
        type: "discover",
        patterns: [6011, [644, 649], 65],
        gaps: [4, 8, 12],
        lengths: [16, 19],
        code: {
            name: "CID",
            size: 3,
        },
    },
    jcb: {
        niceType: "JCB",
        type: "jcb",
        patterns: [2131, 1800, [3528, 3589]],
        gaps: [4, 8, 12],
        lengths: [16, 17, 18, 19],
        code: {
            name: "CVV",
            size: 3,
        },
    },
    unionpay: {
        niceType: "UnionPay",
        type: "unionpay",
        patterns: [
            620,
            [624, 626],
            [62100, 62182],
            [62184, 62187],
            [62185, 62197],
            [62200, 62205],
            [622010, 622999],
            622018,
            [622019, 622999],
            [62207, 62209],
            [622126, 622925],
            [623, 626],
            6270,
            6272,
            6276,
            [627700, 627779],
            [627781, 627799],
            [6282, 6289],
            6291,
            6292,
            810,
            [8110, 8131],
            [8132, 8151],
            [8152, 8163],
            [8164, 8171],
        ],
        gaps: [4, 8, 12],
        lengths: [14, 15, 16, 17, 18, 19],
        code: {
            name: "CVN",
            size: 3,
        },
    },
    maestro: {
        niceType: "Maestro",
        type: "maestro",
        patterns: [
            493698,
            [500000, 504174],
            [504176, 506698],
            [506779, 508999],
            [56, 59],
            63,
            67,
            6,
        ],
        gaps: [4, 8, 12],
        lengths: [12, 13, 14, 15, 16, 17, 18, 19],
        code: {
            name: "CVC",
            size: 3,
        },
    },
    elo: {
        niceType: "Elo",
        type: "elo",
        patterns: [
            401178,
            401179,
            438935,
            457631,
            457632,
            431274,
            451416,
            457393,
            504175,
            [506699, 506778],
            [509000, 509999],
            627780,
            636297,
            636368,
            [650031, 650033],
            [650035, 650051],
            [650405, 650439],
            [650485, 650538],
            [650541, 650598],
            [650700, 650718],
            [650720, 650727],
            [650901, 650978],
            [651652, 651679],
            [655000, 655019],
            [655021, 655058],
        ],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVE",
            size: 3,
        },
    },
    mir: {
        niceType: "Mir",
        type: "mir",
        patterns: [[2200, 2204]],
        gaps: [4, 8, 12],
        lengths: [16, 17, 18, 19],
        code: {
            name: "CVP2",
            size: 3,
        },
    },
    hiper: {
        niceType: "Hiper",
        type: "hiper",
        patterns: [637095, 63737423, 63743358, 637568, 637599, 637609, 637612],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3,
        },
    },
    hipercard: {
        niceType: "Hipercard",
        type: "hipercard",
        patterns: [606282],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3,
        },
    },
};
module.exports = cardTypes;


/***/ }),

/***/ 46228:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.clone = void 0;
function clone(originalObject) {
    if (!originalObject) {
        return null;
    }
    return JSON.parse(JSON.stringify(originalObject));
}
exports.clone = clone;


/***/ }),

/***/ 23551:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.findBestMatch = void 0;
function hasEnoughResultsToDetermineBestMatch(results) {
    var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) { return result.matchStrength; }).length;
    /*
     * if all possible results have a maxStrength property that means the card
     * number is sufficiently long enough to determine conclusively what the card
     * type is
     * */
    return (numberOfResultsWithMaxStrengthProperty > 0 &&
        numberOfResultsWithMaxStrengthProperty === results.length);
}
function findBestMatch(results) {
    if (!hasEnoughResultsToDetermineBestMatch(results)) {
        return null;
    }
    return results.reduce(function (bestMatch, result) {
        if (!bestMatch) {
            return result;
        }
        /*
         * If the current best match pattern is less specific than this result, set
         * the result as the new best match
         * */
        if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) {
            return result;
        }
        return bestMatch;
    });
}
exports.findBestMatch = findBestMatch;


/***/ }),

/***/ 99361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isValidInputType = void 0;
function isValidInputType(cardNumber) {
    return typeof cardNumber === "string" || cardNumber instanceof String;
}
exports.isValidInputType = isValidInputType;


/***/ }),

/***/ 77318:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/*
 * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
 * */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.matches = void 0;
function matchesRange(cardNumber, min, max) {
    var maxLengthToCheck = String(min).length;
    var substr = cardNumber.substr(0, maxLengthToCheck);
    var integerRepresentationOfCardNumber = parseInt(substr, 10);
    min = parseInt(String(min).substr(0, substr.length), 10);
    max = parseInt(String(max).substr(0, substr.length), 10);
    return (integerRepresentationOfCardNumber >= min &&
        integerRepresentationOfCardNumber <= max);
}
function matchesPattern(cardNumber, pattern) {
    pattern = String(pattern);
    return (pattern.substring(0, cardNumber.length) ===
        cardNumber.substring(0, pattern.length));
}
function matches(cardNumber, pattern) {
    if (Array.isArray(pattern)) {
        return matchesRange(cardNumber, pattern[0], pattern[1]);
    }
    return matchesPattern(cardNumber, pattern);
}
exports.matches = matches;


/***/ }),

/***/ 88535:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.addLeadingZeros = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}


/***/ }),

/***/ 2015:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "defaultLocale", ({
  enumerable: true,
  get: function () {
    return _index.enUS;
  },
}));
var _index = __webpack_require__(21332);


/***/ }),

/***/ 92949:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.getDefaultOptions = getDefaultOptions;
exports.setDefaultOptions = setDefaultOptions;

let defaultOptions = {};

function getDefaultOptions() {
  return defaultOptions;
}

function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}


/***/ }),

/***/ 9351:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatters = void 0;
var _index = __webpack_require__(45741);
var _index2 = __webpack_require__(69513);
var _index3 = __webpack_require__(95303);
var _index4 = __webpack_require__(32901);
var _index5 = __webpack_require__(38180);

var _index6 = __webpack_require__(88535);
var _index7 = __webpack_require__(56808);

const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night",
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

const formatters = (exports.formatters = {
  // Era
  G: function (date, token, localize) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize.era(era, { width: "wide" });
    }
  },

  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === "yo") {
      const signedYear = date.getFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, { unit: "year" });
    }

    return _index7.lightFormatters.y(date, token);
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    const signedWeekYear = (0, _index5.getWeekYear)(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return (0, _index6.addLeadingZeros)(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === "Yo") {
      return localize.ordinalNumber(weekYear, { unit: "year" });
    }

    // Padding
    return (0, _index6.addLeadingZeros)(weekYear, token.length);
  },

  // ISO week-numbering year
  R: function (date, token) {
    const isoWeekYear = (0, _index3.getISOWeekYear)(date);

    // Padding
    return (0, _index6.addLeadingZeros)(isoWeekYear, token.length);
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    const year = date.getFullYear();
    return (0, _index6.addLeadingZeros)(year, token.length);
  },

  // Quarter
  Q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return (0, _index6.addLeadingZeros)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "formatting",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return (0, _index6.addLeadingZeros)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "standalone",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // Month
  M: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return _index7.lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize.month(month, {
          width: "abbreviated",
          context: "formatting",
        });
      // J, F, ..., D
      case "MMMMM":
        return localize.month(month, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize.month(month, { width: "wide", context: "formatting" });
    }
  },

  // Stand-alone month
  L: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return (0, _index6.addLeadingZeros)(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize.month(month, {
          width: "abbreviated",
          context: "standalone",
        });
      // J, F, ..., D
      case "LLLLL":
        return localize.month(month, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize.month(month, { width: "wide", context: "standalone" });
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    const week = (0, _index4.getWeek)(date, options);

    if (token === "wo") {
      return localize.ordinalNumber(week, { unit: "week" });
    }

    return (0, _index6.addLeadingZeros)(week, token.length);
  },

  // ISO week of year
  I: function (date, token, localize) {
    const isoWeek = (0, _index2.getISOWeek)(date);

    if (token === "Io") {
      return localize.ordinalNumber(isoWeek, { unit: "week" });
    }

    return (0, _index6.addLeadingZeros)(isoWeek, token.length);
  },

  // Day of the month
  d: function (date, token, localize) {
    if (token === "do") {
      return localize.ordinalNumber(date.getDate(), { unit: "date" });
    }

    return _index7.lightFormatters.d(date, token);
  },

  // Day of year
  D: function (date, token, localize) {
    const dayOfYear = (0, _index.getDayOfYear)(date);

    if (token === "Do") {
      return localize.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }

    return (0, _index6.addLeadingZeros)(dayOfYear, token.length);
  },

  // Day of week
  E: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "EEEEE":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "EEEE":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return (0, _index6.addLeadingZeros)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "eeeee":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "eeee":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return (0, _index6.addLeadingZeros)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone",
        });
      // T
      case "ccccc":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "standalone",
        });
      // Tuesday
      case "cccc":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // ISO day of week
  i: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return (0, _index6.addLeadingZeros)(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "iiiii":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "iiiiii":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "iiii":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "aaa":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "aaaaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }

    switch (token) {
      case "b":
      case "bb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "bbb":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "bbbbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "BBBBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return _index7.lightFormatters.h(date, token);
  },

  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === "Ho") {
      return localize.ordinalNumber(date.getHours(), { unit: "hour" });
    }

    return _index7.lightFormatters.H(date, token);
  },

  // Hour [0-11]
  K: function (date, token, localize) {
    const hours = date.getHours() % 12;

    if (token === "Ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return (0, _index6.addLeadingZeros)(hours, token.length);
  },

  // Hour [1-24]
  k: function (date, token, localize) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;

    if (token === "ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return (0, _index6.addLeadingZeros)(hours, token.length);
  },

  // Minute
  m: function (date, token, localize) {
    if (token === "mo") {
      return localize.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }

    return _index7.lightFormatters.m(date, token);
  },

  // Second
  s: function (date, token, localize) {
    if (token === "so") {
      return localize.ordinalNumber(date.getSeconds(), { unit: "second" });
    }

    return _index7.lightFormatters.s(date, token);
  },

  // Fraction of second
  S: function (date, token) {
    return _index7.lightFormatters.S(date, token);
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return "Z";
    }

    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (GMT)
  O: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Seconds timestamp
  t: function (date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1000);
    return (0, _index6.addLeadingZeros)(timestamp, token.length);
  },

  // Milliseconds timestamp
  T: function (date, token, _localize) {
    const timestamp = date.getTime();
    return (0, _index6.addLeadingZeros)(timestamp, token.length);
  },
});

function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return (
    sign + String(hours) + delimiter + (0, _index6.addLeadingZeros)(minutes, 2)
  );
}

function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + (0, _index6.addLeadingZeros)(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}

function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = (0, _index6.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
  const minutes = (0, _index6.addLeadingZeros)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}


/***/ }),

/***/ 56808:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.lightFormatters = void 0;
var _index = __webpack_require__(88535);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

const lightFormatters = (exports.lightFormatters = {
  // Year
  y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    const signedYear = date.getFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0, _index.addLeadingZeros)(
      token === "yy" ? year % 100 : year,
      token.length,
    );
  },

  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M"
      ? String(month + 1)
      : (0, _index.addLeadingZeros)(month + 1, 2);
  },

  // Day of the month
  d(date, token) {
    return (0, _index.addLeadingZeros)(date.getDate(), token.length);
  },

  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },

  // Hour [1-12]
  h(date, token) {
    return (0, _index.addLeadingZeros)(
      date.getHours() % 12 || 12,
      token.length,
    );
  },

  // Hour [0-23]
  H(date, token) {
    return (0, _index.addLeadingZeros)(date.getHours(), token.length);
  },

  // Minute
  m(date, token) {
    return (0, _index.addLeadingZeros)(date.getMinutes(), token.length);
  },

  // Second
  s(date, token) {
    return (0, _index.addLeadingZeros)(date.getSeconds(), token.length);
  },

  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3),
    );
    return (0, _index.addLeadingZeros)(fractionalSeconds, token.length);
  },
});


/***/ }),

/***/ 43191:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.longFormatters = void 0;

const dateLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "P":
      return formatLong.date({ width: "short" });
    case "PP":
      return formatLong.date({ width: "medium" });
    case "PPP":
      return formatLong.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong.date({ width: "full" });
  }
};

const timeLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "p":
      return formatLong.time({ width: "short" });
    case "pp":
      return formatLong.time({ width: "medium" });
    case "ppp":
      return formatLong.time({ width: "long" });
    case "pppp":
    default:
      return formatLong.time({ width: "full" });
  }
};

const dateTimeLongFormatter = (pattern, formatLong) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  let dateTimeFormat;

  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong.dateTime({ width: "full" });
      break;
  }

  return dateTimeFormat
    .replace("{{date}}", dateLongFormatter(datePattern, formatLong))
    .replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};

const longFormatters = (exports.longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter,
});


/***/ }),

/***/ 37814:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.getRoundingMethod = getRoundingMethod;

function getRoundingMethod(method) {
  return (number) => {
    const round = method ? Math[method] : Math.trunc;
    const result = round(number);
    // Prevent negative zero
    return result === 0 ? 0 : result;
  };
}


/***/ }),

/***/ 1527:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getTimezoneOffsetInMilliseconds = getTimezoneOffsetInMilliseconds;
var _index = __webpack_require__(44724);

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  const _date = (0, _index.toDate)(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds(),
    ),
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}


/***/ }),

/***/ 97963:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.warnOrThrowProtectedError = warnOrThrowProtectedError;
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;

const throwTokens = ["D", "DD", "YY", "YYYY"];

function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}

function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}

function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}

function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/***/ }),

/***/ 33857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.add = add;
var _index = __webpack_require__(83978);
var _index2 = __webpack_require__(48991);
var _index3 = __webpack_require__(4589);
var _index4 = __webpack_require__(44724);

/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */
function add(date, duration) {
  const {
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = duration;

  // Add years and months
  const _date = (0, _index4.toDate)(date);
  const dateWithMonths =
    months || years
      ? (0, _index2.addMonths)(_date, months + years * 12)
      : _date;

  // Add weeks and days
  const dateWithDays =
    days || weeks
      ? (0, _index.addDays)(dateWithMonths, days + weeks * 7)
      : dateWithMonths;

  // Add days, hours, minutes and seconds
  const minutesToAdd = minutes + hours * 60;
  const secondsToAdd = seconds + minutesToAdd * 60;
  const msToAdd = secondsToAdd * 1000;
  const finalDate = (0, _index3.constructFrom)(
    date,
    dateWithDays.getTime() + msToAdd,
  );

  return finalDate;
}


/***/ }),

/***/ 87178:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addBusinessDays = addBusinessDays;
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(52365);
var _index3 = __webpack_require__(59136);
var _index4 = __webpack_require__(60991);
var _index5 = __webpack_require__(44724);

/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */
function addBusinessDays(date, amount) {
  const _date = (0, _index5.toDate)(date);
  const startedOnWeekend = (0, _index4.isWeekend)(_date);

  if (isNaN(amount)) return (0, _index.constructFrom)(date, NaN);

  const hours = _date.getHours();
  const sign = amount < 0 ? -1 : 1;
  const fullWeeks = Math.trunc(amount / 5);

  _date.setDate(_date.getDate() + fullWeeks * 7);

  // Get remaining days not part of a full week
  let restDays = Math.abs(amount % 5);

  // Loops over remaining days
  while (restDays > 0) {
    _date.setDate(_date.getDate() + sign);
    if (!(0, _index4.isWeekend)(_date)) restDays -= 1;
  }

  // If the date is a weekend day and we reduce a dividable of
  // 5 from it, we land on a weekend date.
  // To counter this, we add days accordingly to land on the next business day
  if (startedOnWeekend && (0, _index4.isWeekend)(_date) && amount !== 0) {
    // If we're reducing days, we want to add days until we land on a weekday
    // If we're adding days we want to reduce days until we land on a weekday
    if ((0, _index2.isSaturday)(_date))
      _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
    if ((0, _index3.isSunday)(_date))
      _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
  }

  // Restore hours to avoid DST lag
  _date.setHours(hours);

  return _date;
}


/***/ }),

/***/ 83978:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addDays = addDays;
var _index = __webpack_require__(44724);
var _index2 = __webpack_require__(4589);

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(date, amount) {
  const _date = (0, _index.toDate)(date);
  if (isNaN(amount)) return (0, _index2.constructFrom)(date, NaN);
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}


/***/ }),

/***/ 41278:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addHours = addHours;
var _index = __webpack_require__(67106);
var _index2 = __webpack_require__(53679);

/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours(date, amount) {
  return (0, _index.addMilliseconds)(date, amount * _index2.millisecondsInHour);
}


/***/ }),

/***/ 77673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addISOWeekYears = addISOWeekYears;
var _index = __webpack_require__(95303);
var _index2 = __webpack_require__(58985);

/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */
function addISOWeekYears(date, amount) {
  return (0, _index2.setISOWeekYear)(
    date,
    (0, _index.getISOWeekYear)(date) + amount,
  );
}


/***/ }),

/***/ 67106:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addMilliseconds = addMilliseconds;
var _index = __webpack_require__(44724);
var _index2 = __webpack_require__(4589);

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(date, amount) {
  const timestamp = +(0, _index.toDate)(date);
  return (0, _index2.constructFrom)(date, timestamp + amount);
}


/***/ }),

/***/ 5157:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addMinutes = addMinutes;
var _index = __webpack_require__(67106);
var _index2 = __webpack_require__(53679);

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes(date, amount) {
  return (0, _index.addMilliseconds)(
    date,
    amount * _index2.millisecondsInMinute,
  );
}


/***/ }),

/***/ 48991:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addMonths = addMonths;
var _index = __webpack_require__(44724);
var _index2 = __webpack_require__(4589);

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */
function addMonths(date, amount) {
  const _date = (0, _index.toDate)(date);
  if (isNaN(amount)) return (0, _index2.constructFrom)(date, NaN);
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  const dayOfMonth = _date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  const endOfDesiredMonth = (0, _index2.constructFrom)(date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth,
    );
    return _date;
  }
}


/***/ }),

/***/ 53893:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addQuarters = addQuarters;
var _index = __webpack_require__(48991);

/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters(date, amount) {
  const months = amount * 3;
  return (0, _index.addMonths)(date, months);
}


/***/ }),

/***/ 41488:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addSeconds = addSeconds;
var _index = __webpack_require__(67106);

/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds(date, amount) {
  return (0, _index.addMilliseconds)(date, amount * 1000);
}


/***/ }),

/***/ 75978:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addWeeks = addWeeks;
var _index = __webpack_require__(83978);

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(date, amount) {
  const days = amount * 7;
  return (0, _index.addDays)(date, days);
}


/***/ }),

/***/ 83366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addYears = addYears;
var _index = __webpack_require__(48991);

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(date, amount) {
  return (0, _index.addMonths)(date, amount * 12);
}


/***/ }),

/***/ 45801:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.areIntervalsOverlapping = areIntervalsOverlapping;
var _index = __webpack_require__(44724);

/**
 * The {@link areIntervalsOverlapping} function options.
 */

/**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */
function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
  const [leftStartTime, leftEndTime] = [
    +(0, _index.toDate)(intervalLeft.start),
    +(0, _index.toDate)(intervalLeft.end),
  ].sort((a, b) => a - b);
  const [rightStartTime, rightEndTime] = [
    +(0, _index.toDate)(intervalRight.start),
    +(0, _index.toDate)(intervalRight.end),
  ].sort((a, b) => a - b);

  if (options?.inclusive)
    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;

  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}


/***/ }),

/***/ 73635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.clamp = clamp;
var _index = __webpack_require__(25518);
var _index2 = __webpack_require__(55463);

/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */
function clamp(date, interval) {
  return (0, _index2.min)([
    (0, _index.max)([date, interval.start]),
    interval.end,
  ]);
}


/***/ }),

/***/ 52649:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.closestIndexTo = closestIndexTo;
var _index = __webpack_require__(44724);

/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo(dateToCompare, dates) {
  const date = (0, _index.toDate)(dateToCompare);

  if (isNaN(Number(date))) return NaN;

  const timeToCompare = date.getTime();

  let result;
  let minDistance;
  dates.forEach(function (dirtyDate, index) {
    const currentDate = (0, _index.toDate)(dirtyDate);

    if (isNaN(Number(currentDate))) {
      result = NaN;
      minDistance = NaN;
      return;
    }

    const distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result == null || distance < minDistance) {
      result = index;
      minDistance = distance;
    }
  });

  return result;
}


/***/ }),

/***/ 45099:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.closestTo = closestTo;
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(44724);

/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo(dateToCompare, dates) {
  const date = (0, _index2.toDate)(dateToCompare);

  if (isNaN(Number(date))) return (0, _index.constructFrom)(dateToCompare, NaN);

  const timeToCompare = date.getTime();

  let result;
  let minDistance;
  dates.forEach((dirtyDate) => {
    const currentDate = (0, _index2.toDate)(dirtyDate);

    if (isNaN(Number(currentDate))) {
      result = (0, _index.constructFrom)(dateToCompare, NaN);
      minDistance = NaN;
      return;
    }

    const distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result == null || distance < minDistance) {
      result = currentDate;
      minDistance = distance;
    }
  });

  return result;
}


/***/ }),

/***/ 22835:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.compareAsc = compareAsc;
var _index = __webpack_require__(44724);

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc(dateLeft, dateRight) {
  const _dateLeft = (0, _index.toDate)(dateLeft);
  const _dateRight = (0, _index.toDate)(dateRight);

  const diff = _dateLeft.getTime() - _dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}


/***/ }),

/***/ 32023:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.compareDesc = compareDesc;
var _index = __webpack_require__(44724);

/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc(dateLeft, dateRight) {
  const _dateLeft = (0, _index.toDate)(dateLeft);
  const _dateRight = (0, _index.toDate)(dateRight);

  const diff = _dateLeft.getTime() - _dateRight.getTime();

  if (diff > 0) {
    return -1;
  } else if (diff < 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}


/***/ }),

/***/ 53679:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.secondsInYear =
  exports.secondsInWeek =
  exports.secondsInQuarter =
  exports.secondsInMonth =
  exports.secondsInMinute =
  exports.secondsInHour =
  exports.secondsInDay =
  exports.quartersInYear =
  exports.monthsInYear =
  exports.monthsInQuarter =
  exports.minutesInYear =
  exports.minutesInMonth =
  exports.minutesInHour =
  exports.minutesInDay =
  exports.minTime =
  exports.millisecondsInWeek =
  exports.millisecondsInSecond =
  exports.millisecondsInMinute =
  exports.millisecondsInHour =
  exports.millisecondsInDay =
  exports.maxTime =
  exports.daysInYear =
  exports.daysInWeek =
    void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */

/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */
const daysInWeek = (exports.daysInWeek = 7);

/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */
const daysInYear = (exports.daysInYear = 365.2425);

/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */
const maxTime = (exports.maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000);

/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */
const minTime = (exports.minTime = -maxTime);

/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */
const millisecondsInWeek = (exports.millisecondsInWeek = 604800000);

/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */
const millisecondsInDay = (exports.millisecondsInDay = 86400000);

/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */
const millisecondsInMinute = (exports.millisecondsInMinute = 60000);

/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */
const millisecondsInHour = (exports.millisecondsInHour = 3600000);

/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */
const millisecondsInSecond = (exports.millisecondsInSecond = 1000);

/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */
const minutesInYear = (exports.minutesInYear = 525600);

/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */
const minutesInMonth = (exports.minutesInMonth = 43200);

/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */
const minutesInDay = (exports.minutesInDay = 1440);

/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */
const minutesInHour = (exports.minutesInHour = 60);

/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */
const monthsInQuarter = (exports.monthsInQuarter = 3);

/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */
const monthsInYear = (exports.monthsInYear = 12);

/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */
const quartersInYear = (exports.quartersInYear = 4);

/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */
const secondsInHour = (exports.secondsInHour = 3600);

/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */
const secondsInMinute = (exports.secondsInMinute = 60);

/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */
const secondsInDay = (exports.secondsInDay = secondsInHour * 24);

/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */
const secondsInWeek = (exports.secondsInWeek = secondsInDay * 7);

/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */
const secondsInYear = (exports.secondsInYear = secondsInDay * daysInYear);

/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */
const secondsInMonth = (exports.secondsInMonth = secondsInYear / 12);

/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */
const secondsInQuarter = (exports.secondsInQuarter = secondsInMonth * 3);


/***/ }),

/***/ 4589:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.constructFrom = constructFrom;

/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}


/***/ }),

/***/ 84244:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.constructNow = constructNow;
var _index = __webpack_require__(4589);

/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */
function constructNow(date) {
  return (0, _index.constructFrom)(date, Date.now());
}


/***/ }),

/***/ 56675:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.daysToWeeks = daysToWeeks;
var _index = __webpack_require__(53679);

/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */
function daysToWeeks(days) {
  const weeks = days / _index.daysInWeek;
  const result = Math.trunc(weeks);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}


/***/ }),

/***/ 614:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInBusinessDays = differenceInBusinessDays;
var _index = __webpack_require__(83978);
var _index2 = __webpack_require__(45672);
var _index3 = __webpack_require__(10098);
var _index4 = __webpack_require__(74390);
var _index5 = __webpack_require__(60991);
var _index6 = __webpack_require__(44724);

/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */
function differenceInBusinessDays(dateLeft, dateRight) {
  const _dateLeft = (0, _index6.toDate)(dateLeft);
  let _dateRight = (0, _index6.toDate)(dateRight);

  if (!(0, _index4.isValid)(_dateLeft) || !(0, _index4.isValid)(_dateRight))
    return NaN;

  const calendarDifference = (0, _index2.differenceInCalendarDays)(
    _dateLeft,
    _dateRight,
  );
  const sign = calendarDifference < 0 ? -1 : 1;

  const weeks = Math.trunc(calendarDifference / 7);

  let result = weeks * 5;
  _dateRight = (0, _index.addDays)(_dateRight, weeks * 7);

  // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
  while (!(0, _index3.isSameDay)(_dateLeft, _dateRight)) {
    // sign is used to account for both negative and positive differences
    result += (0, _index5.isWeekend)(_dateRight) ? 0 : sign;
    _dateRight = (0, _index.addDays)(_dateRight, sign);
  }

  // Prevent negative zero
  return result === 0 ? 0 : result;
}


/***/ }),

/***/ 45672:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInCalendarDays = differenceInCalendarDays;
var _index = __webpack_require__(53679);
var _index2 = __webpack_require__(72274);
var _index3 = __webpack_require__(1527);

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = (0, _index2.startOfDay)(dateLeft);
  const startOfDayRight = (0, _index2.startOfDay)(dateRight);

  const timestampLeft =
    +startOfDayLeft -
    (0, _index3.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
  const timestampRight =
    +startOfDayRight -
    (0, _index3.getTimezoneOffsetInMilliseconds)(startOfDayRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a day is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(
    (timestampLeft - timestampRight) / _index.millisecondsInDay,
  );
}


/***/ }),

/***/ 22375:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInCalendarISOWeekYears = differenceInCalendarISOWeekYears;
var _index = __webpack_require__(95303);

/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOWeekYears(dateLeft, dateRight) {
  return (
    (0, _index.getISOWeekYear)(dateLeft) - (0, _index.getISOWeekYear)(dateRight)
  );
}


/***/ }),

/***/ 52087:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInCalendarISOWeeks = differenceInCalendarISOWeeks;
var _index = __webpack_require__(53679);
var _index2 = __webpack_require__(89301);
var _index3 = __webpack_require__(1527);

/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks(dateLeft, dateRight) {
  const startOfISOWeekLeft = (0, _index2.startOfISOWeek)(dateLeft);
  const startOfISOWeekRight = (0, _index2.startOfISOWeek)(dateRight);

  const timestampLeft =
    +startOfISOWeekLeft -
    (0, _index3.getTimezoneOffsetInMilliseconds)(startOfISOWeekLeft);
  const timestampRight =
    +startOfISOWeekRight -
    (0, _index3.getTimezoneOffsetInMilliseconds)(startOfISOWeekRight);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(
    (timestampLeft - timestampRight) / _index.millisecondsInWeek,
  );
}


/***/ }),

/***/ 96719:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInCalendarMonths = differenceInCalendarMonths;
var _index = __webpack_require__(44724);

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dateLeft, dateRight) {
  const _dateLeft = (0, _index.toDate)(dateLeft);
  const _dateRight = (0, _index.toDate)(dateRight);

  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();

  return yearDiff * 12 + monthDiff;
}


/***/ }),

/***/ 66393:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInCalendarQuarters = differenceInCalendarQuarters;
var _index = __webpack_require__(23350);
var _index2 = __webpack_require__(44724);

/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters(dateLeft, dateRight) {
  const _dateLeft = (0, _index2.toDate)(dateLeft);
  const _dateRight = (0, _index2.toDate)(dateRight);

  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const quarterDiff =
    (0, _index.getQuarter)(_dateLeft) - (0, _index.getQuarter)(_dateRight);

  return yearDiff * 4 + quarterDiff;
}


/***/ }),

/***/ 25049:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInCalendarWeeks = differenceInCalendarWeeks;
var _index = __webpack_require__(53679);
var _index2 = __webpack_require__(83877);

var _index3 = __webpack_require__(1527);

/**
 * The {@link differenceInCalendarWeeks} function options.
 */

/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */
function differenceInCalendarWeeks(dateLeft, dateRight, options) {
  const startOfWeekLeft = (0, _index2.startOfWeek)(dateLeft, options);
  const startOfWeekRight = (0, _index2.startOfWeek)(dateRight, options);

  const timestampLeft =
    +startOfWeekLeft -
    (0, _index3.getTimezoneOffsetInMilliseconds)(startOfWeekLeft);
  const timestampRight =
    +startOfWeekRight -
    (0, _index3.getTimezoneOffsetInMilliseconds)(startOfWeekRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a days is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(
    (timestampLeft - timestampRight) / _index.millisecondsInWeek,
  );
}


/***/ }),

/***/ 85878:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInCalendarYears = differenceInCalendarYears;
var _index = __webpack_require__(44724);

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears(dateLeft, dateRight) {
  const _dateLeft = (0, _index.toDate)(dateLeft);
  const _dateRight = (0, _index.toDate)(dateRight);

  return _dateLeft.getFullYear() - _dateRight.getFullYear();
}


/***/ }),

/***/ 31581:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInDays = differenceInDays;
var _index = __webpack_require__(45672);
var _index2 = __webpack_require__(44724);

/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */
function differenceInDays(dateLeft, dateRight) {
  const _dateLeft = (0, _index2.toDate)(dateLeft);
  const _dateRight = (0, _index2.toDate)(dateRight);

  const sign = compareLocalAsc(_dateLeft, _dateRight);
  const difference = Math.abs(
    (0, _index.differenceInCalendarDays)(_dateLeft, _dateRight),
  );

  _dateLeft.setDate(_dateLeft.getDate() - sign * difference);

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  const isLastDayNotFull = Number(
    compareLocalAsc(_dateLeft, _dateRight) === -sign,
  );
  const result = sign * (difference - isLastDayNotFull);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}

// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
  const diff =
    dateLeft.getFullYear() - dateRight.getFullYear() ||
    dateLeft.getMonth() - dateRight.getMonth() ||
    dateLeft.getDate() - dateRight.getDate() ||
    dateLeft.getHours() - dateRight.getHours() ||
    dateLeft.getMinutes() - dateRight.getMinutes() ||
    dateLeft.getSeconds() - dateRight.getSeconds() ||
    dateLeft.getMilliseconds() - dateRight.getMilliseconds();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}


/***/ }),

/***/ 39288:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInHours = differenceInHours;
var _index = __webpack_require__(37814);
var _index2 = __webpack_require__(53679);
var _index3 = __webpack_require__(69737);

/**
 * The {@link differenceInHours} function options.
 */

/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours(dateLeft, dateRight, options) {
  const diff =
    (0, _index3.differenceInMilliseconds)(dateLeft, dateRight) /
    _index2.millisecondsInHour;
  return (0, _index.getRoundingMethod)(options?.roundingMethod)(diff);
}


/***/ }),

/***/ 30870:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInISOWeekYears = differenceInISOWeekYears;
var _index = __webpack_require__(22835);
var _index2 = __webpack_require__(22375);
var _index3 = __webpack_require__(76081);
var _index4 = __webpack_require__(44724);

/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOWeekYears(dateLeft, dateRight) {
  let _dateLeft = (0, _index4.toDate)(dateLeft);
  const _dateRight = (0, _index4.toDate)(dateRight);

  const sign = (0, _index.compareAsc)(_dateLeft, _dateRight);
  const difference = Math.abs(
    (0, _index2.differenceInCalendarISOWeekYears)(_dateLeft, _dateRight),
  );
  _dateLeft = (0, _index3.subISOWeekYears)(_dateLeft, sign * difference);

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  const isLastISOWeekYearNotFull = Number(
    (0, _index.compareAsc)(_dateLeft, _dateRight) === -sign,
  );
  const result = sign * (difference - isLastISOWeekYearNotFull);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}


/***/ }),

/***/ 69737:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInMilliseconds = differenceInMilliseconds;
var _index = __webpack_require__(44724);

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds(dateLeft, dateRight) {
  return +(0, _index.toDate)(dateLeft) - +(0, _index.toDate)(dateRight);
}


/***/ }),

/***/ 56034:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInMinutes = differenceInMinutes;
var _index = __webpack_require__(37814);
var _index2 = __webpack_require__(53679);
var _index3 = __webpack_require__(69737);

/**
 * The {@link differenceInMinutes} function options.
 */

/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */
function differenceInMinutes(dateLeft, dateRight, options) {
  const diff =
    (0, _index3.differenceInMilliseconds)(dateLeft, dateRight) /
    _index2.millisecondsInMinute;
  return (0, _index.getRoundingMethod)(options?.roundingMethod)(diff);
}


/***/ }),

/***/ 47555:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInMonths = differenceInMonths;
var _index = __webpack_require__(22835);
var _index2 = __webpack_require__(96719);
var _index3 = __webpack_require__(47752);
var _index4 = __webpack_require__(44724);

/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */
function differenceInMonths(dateLeft, dateRight) {
  const _dateLeft = (0, _index4.toDate)(dateLeft);
  const _dateRight = (0, _index4.toDate)(dateRight);

  const sign = (0, _index.compareAsc)(_dateLeft, _dateRight);
  const difference = Math.abs(
    (0, _index2.differenceInCalendarMonths)(_dateLeft, _dateRight),
  );
  let result;

  // Check for the difference of less than month
  if (difference < 1) {
    result = 0;
  } else {
    if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      _dateLeft.setDate(30);
    }

    _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);

    // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value
    let isLastMonthNotFull =
      (0, _index.compareAsc)(_dateLeft, _dateRight) === -sign;

    // Check for cases of one full calendar month
    if (
      (0, _index3.isLastDayOfMonth)((0, _index4.toDate)(dateLeft)) &&
      difference === 1 &&
      (0, _index.compareAsc)(dateLeft, _dateRight) === 1
    ) {
      isLastMonthNotFull = false;
    }

    result = sign * (difference - Number(isLastMonthNotFull));
  }

  // Prevent negative zero
  return result === 0 ? 0 : result;
}


/***/ }),

/***/ 41591:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInQuarters = differenceInQuarters;
var _index = __webpack_require__(37814);
var _index2 = __webpack_require__(47555);

/**
 * The {@link differenceInQuarters} function options.
 */

/**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */
function differenceInQuarters(dateLeft, dateRight, options) {
  const diff = (0, _index2.differenceInMonths)(dateLeft, dateRight) / 3;
  return (0, _index.getRoundingMethod)(options?.roundingMethod)(diff);
}


/***/ }),

/***/ 9480:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInSeconds = differenceInSeconds;
var _index = __webpack_require__(37814);
var _index2 = __webpack_require__(69737);

/**
 * The {@link differenceInSeconds} function options.
 */

/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds(dateLeft, dateRight, options) {
  const diff =
    (0, _index2.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
  return (0, _index.getRoundingMethod)(options?.roundingMethod)(diff);
}


/***/ }),

/***/ 46733:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInWeeks = differenceInWeeks;
var _index = __webpack_require__(37814);
var _index2 = __webpack_require__(31581);

/**
 * The {@link differenceInWeeks} function options.
 */

/**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */
function differenceInWeeks(dateLeft, dateRight, options) {
  const diff = (0, _index2.differenceInDays)(dateLeft, dateRight) / 7;
  return (0, _index.getRoundingMethod)(options?.roundingMethod)(diff);
}


/***/ }),

/***/ 90103:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInYears = differenceInYears;
var _index = __webpack_require__(22835);
var _index2 = __webpack_require__(85878);
var _index3 = __webpack_require__(44724);

/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */
function differenceInYears(dateLeft, dateRight) {
  const _dateLeft = (0, _index3.toDate)(dateLeft);
  const _dateRight = (0, _index3.toDate)(dateRight);

  const sign = (0, _index.compareAsc)(_dateLeft, _dateRight);
  const difference = Math.abs(
    (0, _index2.differenceInCalendarYears)(_dateLeft, _dateRight),
  );

  // Set both dates to a valid leap year for accurate comparison when dealing
  // with leap days
  _dateLeft.setFullYear(1584);
  _dateRight.setFullYear(1584);

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  const isLastYearNotFull =
    (0, _index.compareAsc)(_dateLeft, _dateRight) === -sign;
  const result = sign * (difference - +isLastYearNotFull);

  // Prevent negative zero
  return result === 0 ? 0 : result;
}


/***/ }),

/***/ 92453:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.eachDayOfInterval = eachDayOfInterval;
var _index = __webpack_require__(44724);

/**
 * The {@link eachDayOfInterval} function options.
 */

/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDayOfInterval(interval, options) {
  const startDate = (0, _index.toDate)(interval.start);
  const endDate = (0, _index.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  const currentDate = reversed ? endDate : startDate;
  currentDate.setHours(0, 0, 0, 0);

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push((0, _index.toDate)(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return reversed ? dates.reverse() : dates;
}


/***/ }),

/***/ 19025:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.eachHourOfInterval = eachHourOfInterval;
var _index = __webpack_require__(41278);
var _index2 = __webpack_require__(44724);

/**
 * The {@link eachHourOfInterval} function options.
 */

/**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */
function eachHourOfInterval(interval, options) {
  const startDate = (0, _index2.toDate)(interval.start);
  const endDate = (0, _index2.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  let currentDate = reversed ? endDate : startDate;
  currentDate.setMinutes(0, 0, 0);

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push((0, _index2.toDate)(currentDate));
    currentDate = (0, _index.addHours)(currentDate, step);
  }

  return reversed ? dates.reverse() : dates;
}


/***/ }),

/***/ 85522:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.eachMinuteOfInterval = eachMinuteOfInterval;
var _index = __webpack_require__(5157);
var _index2 = __webpack_require__(52881);
var _index3 = __webpack_require__(44724);

/**
 * The {@link eachMinuteOfInterval} function options.
 */

/**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */
function eachMinuteOfInterval(interval, options) {
  const startDate = (0, _index2.startOfMinute)(
    (0, _index3.toDate)(interval.start),
  );
  const endDate = (0, _index3.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  let currentDate = reversed ? endDate : startDate;

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push((0, _index3.toDate)(currentDate));
    currentDate = (0, _index.addMinutes)(currentDate, step);
  }

  return reversed ? dates.reverse() : dates;
}


/***/ }),

/***/ 76745:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.eachMonthOfInterval = eachMonthOfInterval;
var _index = __webpack_require__(44724);

/**
 * The {@link eachMonthOfInterval} function options.
 */

/**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */
function eachMonthOfInterval(interval, options) {
  const startDate = (0, _index.toDate)(interval.start);
  const endDate = (0, _index.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  const currentDate = reversed ? endDate : startDate;
  currentDate.setHours(0, 0, 0, 0);
  currentDate.setDate(1);

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push((0, _index.toDate)(currentDate));
    currentDate.setMonth(currentDate.getMonth() + step);
  }

  return reversed ? dates.reverse() : dates;
}


/***/ }),

/***/ 59190:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.eachQuarterOfInterval = eachQuarterOfInterval;
var _index = __webpack_require__(53893);
var _index2 = __webpack_require__(6831);
var _index3 = __webpack_require__(44724);

/**
 * The {@link eachQuarterOfInterval} function options.
 */

/**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */
function eachQuarterOfInterval(interval, options) {
  const startDate = (0, _index3.toDate)(interval.start);
  const endDate = (0, _index3.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed
    ? +(0, _index2.startOfQuarter)(startDate)
    : +(0, _index2.startOfQuarter)(endDate);
  let currentDate = reversed
    ? (0, _index2.startOfQuarter)(endDate)
    : (0, _index2.startOfQuarter)(startDate);

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push((0, _index3.toDate)(currentDate));
    currentDate = (0, _index.addQuarters)(currentDate, step);
  }

  return reversed ? dates.reverse() : dates;
}


/***/ }),

/***/ 34553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.eachWeekOfInterval = eachWeekOfInterval;
var _index = __webpack_require__(75978);
var _index2 = __webpack_require__(83877);
var _index3 = __webpack_require__(44724);

/**
 * The {@link eachWeekOfInterval} function options.
 */

/**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */
function eachWeekOfInterval(interval, options) {
  const startDate = (0, _index3.toDate)(interval.start);
  const endDate = (0, _index3.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const startDateWeek = reversed
    ? (0, _index2.startOfWeek)(endDate, options)
    : (0, _index2.startOfWeek)(startDate, options);
  const endDateWeek = reversed
    ? (0, _index2.startOfWeek)(startDate, options)
    : (0, _index2.startOfWeek)(endDate, options);

  // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
  startDateWeek.setHours(15);
  endDateWeek.setHours(15);

  const endTime = +endDateWeek.getTime();
  let currentDate = startDateWeek;

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    currentDate.setHours(0);
    dates.push((0, _index3.toDate)(currentDate));
    currentDate = (0, _index.addWeeks)(currentDate, step);
    currentDate.setHours(15);
  }

  return reversed ? dates.reverse() : dates;
}


/***/ }),

/***/ 1161:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.eachWeekendOfInterval = eachWeekendOfInterval;
var _index = __webpack_require__(92453);
var _index2 = __webpack_require__(60991);

/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */
function eachWeekendOfInterval(interval) {
  const dateInterval = (0, _index.eachDayOfInterval)(interval);
  const weekends = [];
  let index = 0;
  while (index < dateInterval.length) {
    const date = dateInterval[index++];
    if ((0, _index2.isWeekend)(date)) weekends.push(date);
  }
  return weekends;
}


/***/ }),

/***/ 78857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.eachWeekendOfMonth = eachWeekendOfMonth;
var _index = __webpack_require__(1161);
var _index2 = __webpack_require__(92335);
var _index3 = __webpack_require__(23266);

/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */
function eachWeekendOfMonth(date) {
  const start = (0, _index3.startOfMonth)(date);
  const end = (0, _index2.endOfMonth)(date);
  return (0, _index.eachWeekendOfInterval)({ start, end });
}


/***/ }),

/***/ 47150:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.eachWeekendOfYear = eachWeekendOfYear;
var _index = __webpack_require__(1161);
var _index2 = __webpack_require__(53689);
var _index3 = __webpack_require__(90821);

/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */
function eachWeekendOfYear(date) {
  const start = (0, _index3.startOfYear)(date);
  const end = (0, _index2.endOfYear)(date);
  return (0, _index.eachWeekendOfInterval)({ start, end });
}


/***/ }),

/***/ 51885:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.eachYearOfInterval = eachYearOfInterval;
var _index = __webpack_require__(44724);

/**
 * The {@link eachYearOfInterval} function options.
 */

/**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */
function eachYearOfInterval(interval, options) {
  const startDate = (0, _index.toDate)(interval.start);
  const endDate = (0, _index.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  const currentDate = reversed ? endDate : startDate;
  currentDate.setHours(0, 0, 0, 0);
  currentDate.setMonth(0, 1);

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push((0, _index.toDate)(currentDate));
    currentDate.setFullYear(currentDate.getFullYear() + step);
  }

  return reversed ? dates.reverse() : dates;
}


/***/ }),

/***/ 48443:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfDay = endOfDay;
var _index = __webpack_require__(44724);

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(date) {
  const _date = (0, _index.toDate)(date);
  _date.setHours(23, 59, 59, 999);
  return _date;
}


/***/ }),

/***/ 22665:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfDecade = endOfDecade;
var _index = __webpack_require__(44724);

/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */
function endOfDecade(date) {
  // TODO: Switch to more technical definition in of decades that start with 1
  // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
  // change, so it can only be done in 4.0.
  const _date = (0, _index.toDate)(date);
  const year = _date.getFullYear();
  const decade = 9 + Math.floor(year / 10) * 10;
  _date.setFullYear(decade, 11, 31);
  _date.setHours(23, 59, 59, 999);
  return _date;
}


/***/ }),

/***/ 59012:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfHour = endOfHour;
var _index = __webpack_require__(44724);

/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour(date) {
  const _date = (0, _index.toDate)(date);
  _date.setMinutes(59, 59, 999);
  return _date;
}


/***/ }),

/***/ 29403:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfISOWeek = endOfISOWeek;
var _index = __webpack_require__(67786);

/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek(date) {
  return (0, _index.endOfWeek)(date, { weekStartsOn: 1 });
}


/***/ }),

/***/ 33367:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfISOWeekYear = endOfISOWeekYear;
var _index = __webpack_require__(95303);
var _index2 = __webpack_require__(89301);
var _index3 = __webpack_require__(4589);

/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOWeekYear(date) {
  const year = (0, _index.getISOWeekYear)(date);
  const fourthOfJanuaryOfNextYear = (0, _index3.constructFrom)(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const _date = (0, _index2.startOfISOWeek)(fourthOfJanuaryOfNextYear);
  _date.setMilliseconds(_date.getMilliseconds() - 1);
  return _date;
}


/***/ }),

/***/ 75836:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfMinute = endOfMinute;
var _index = __webpack_require__(44724);

/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute(date) {
  const _date = (0, _index.toDate)(date);
  _date.setSeconds(59, 999);
  return _date;
}


/***/ }),

/***/ 92335:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfMonth = endOfMonth;
var _index = __webpack_require__(44724);

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(date) {
  const _date = (0, _index.toDate)(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}


/***/ }),

/***/ 87181:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfQuarter = endOfQuarter;
var _index = __webpack_require__(44724);

/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter(date) {
  const _date = (0, _index.toDate)(date);
  const currentMonth = _date.getMonth();
  const month = currentMonth - (currentMonth % 3) + 3;
  _date.setMonth(month, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}


/***/ }),

/***/ 50372:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfSecond = endOfSecond;
var _index = __webpack_require__(44724);

/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond(date) {
  const _date = (0, _index.toDate)(date);
  _date.setMilliseconds(999);
  return _date;
}


/***/ }),

/***/ 59660:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfToday = endOfToday;
var _index = __webpack_require__(48443);

/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday() {
  return (0, _index.endOfDay)(Date.now());
}


/***/ }),

/***/ 40776:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.endOfTomorrow = endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  const date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(23, 59, 59, 999);
  return date;
}


/***/ }),

/***/ 67786:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfWeek = endOfWeek;
var _index = __webpack_require__(44724);

var _index2 = __webpack_require__(92949);

/**
 * The {@link endOfWeek} function options.
 */

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(date, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0, _index.toDate)(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);

  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}


/***/ }),

/***/ 53689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfYear = endOfYear;
var _index = __webpack_require__(44724);

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear(date) {
  const _date = (0, _index.toDate)(date);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}


/***/ }),

/***/ 25268:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.endOfYesterday = endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  const date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(23, 59, 59, 999);
  return date;
}


/***/ }),

/***/ 24173:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.format = exports.formatDate = format;
Object.defineProperty(exports, "formatters", ({
  enumerable: true,
  get: function () {
    return _index3.formatters;
  },
}));
Object.defineProperty(exports, "longFormatters", ({
  enumerable: true,
  get: function () {
    return _index4.longFormatters;
  },
}));
var _index = __webpack_require__(2015);
var _index2 = __webpack_require__(92949);
var _index3 = __webpack_require__(9351);
var _index4 = __webpack_require__(43191);
var _index5 = __webpack_require__(97963);

var _index6 = __webpack_require__(74390);
var _index7 = __webpack_require__(44724);

// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * The {@link format} function options.
 */

/**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format(date, formatStr, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index.defaultLocale;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const originalDate = (0, _index7.toDate)(date);

  if (!(0, _index6.isValid)(originalDate)) {
    throw new RangeError("Invalid time value");
  }

  let parts = formatStr
    .match(longFormattingTokensRegExp)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        const longFormatter = _index4.longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp)
    .map((substring) => {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return { isToken: false, value: "'" };
      }

      const firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return { isToken: false, value: cleanEscapedString(substring) };
      }

      if (_index3.formatters[firstCharacter]) {
        return { isToken: true, value: substring };
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      return { isToken: false, value: substring };
    });

  // invoke localize preprocessor (only for french locales at the moment)
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }

  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  return parts
    .map((part) => {
      if (!part.isToken) return part.value;

      const token = part.value;

      if (
        (!options?.useAdditionalWeekYearTokens &&
          (0, _index5.isProtectedWeekYearToken)(token)) ||
        (!options?.useAdditionalDayOfYearTokens &&
          (0, _index5.isProtectedDayOfYearToken)(token))
      ) {
        (0, _index5.warnOrThrowProtectedError)(token, formatStr, String(date));
      }

      const formatter = _index3.formatters[token[0]];
      return formatter(originalDate, token, locale.localize, formatterOptions);
    })
    .join("");
}

function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}


/***/ }),

/***/ 4677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatDistance = formatDistance;
var _index = __webpack_require__(22835);
var _index2 = __webpack_require__(53679);
var _index3 = __webpack_require__(47555);
var _index4 = __webpack_require__(9480);
var _index5 = __webpack_require__(44724);

var _index6 = __webpack_require__(2015);
var _index7 = __webpack_require__(92949);
var _index8 = __webpack_require__(1527);

/**
 * The {@link formatDistance} function options.
 */

/**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */

function formatDistance(date, baseDate, options) {
  const defaultOptions = (0, _index7.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index6.defaultLocale;
  const minutesInAlmostTwoDays = 2520;

  const comparison = (0, _index.compareAsc)(date, baseDate);

  if (isNaN(comparison)) {
    throw new RangeError("Invalid time value");
  }

  const localizeOptions = Object.assign({}, options, {
    addSuffix: options?.addSuffix,
    comparison: comparison,
  });

  let dateLeft;
  let dateRight;
  if (comparison > 0) {
    dateLeft = (0, _index5.toDate)(baseDate);
    dateRight = (0, _index5.toDate)(date);
  } else {
    dateLeft = (0, _index5.toDate)(date);
    dateRight = (0, _index5.toDate)(baseDate);
  }

  const seconds = (0, _index4.differenceInSeconds)(dateRight, dateLeft);
  const offsetInSeconds =
    ((0, _index8.getTimezoneOffsetInMilliseconds)(dateRight) -
      (0, _index8.getTimezoneOffsetInMilliseconds)(dateLeft)) /
    1000;
  const minutes = Math.round((seconds - offsetInSeconds) / 60);
  let months;

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options?.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance("halfAMinute", 0, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
      } else {
        return locale.formatDistance("xMinutes", 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
      } else {
        return locale.formatDistance("xMinutes", minutes, localizeOptions);
      }
    }

    // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return locale.formatDistance("xMinutes", minutes, localizeOptions);

    // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return locale.formatDistance("aboutXHours", 1, localizeOptions);

    // 1.5 hrs up to 24 hrs
  } else if (minutes < _index2.minutesInDay) {
    const hours = Math.round(minutes / 60);
    return locale.formatDistance("aboutXHours", hours, localizeOptions);

    // 1 day up to 1.75 days
  } else if (minutes < minutesInAlmostTwoDays) {
    return locale.formatDistance("xDays", 1, localizeOptions);

    // 1.75 days up to 30 days
  } else if (minutes < _index2.minutesInMonth) {
    const days = Math.round(minutes / _index2.minutesInDay);
    return locale.formatDistance("xDays", days, localizeOptions);

    // 1 month up to 2 months
  } else if (minutes < _index2.minutesInMonth * 2) {
    months = Math.round(minutes / _index2.minutesInMonth);
    return locale.formatDistance("aboutXMonths", months, localizeOptions);
  }

  months = (0, _index3.differenceInMonths)(dateRight, dateLeft);

  // 2 months up to 12 months
  if (months < 12) {
    const nearestMonth = Math.round(minutes / _index2.minutesInMonth);
    return locale.formatDistance("xMonths", nearestMonth, localizeOptions);

    // 1 year up to max Date
  } else {
    const monthsSinceStartOfYear = months % 12;
    const years = Math.trunc(months / 12);

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance("aboutXYears", years, localizeOptions);

      // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance("overXYears", years, localizeOptions);

      // N years 9 months up to N year 12 months
    } else {
      return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
  }
}


/***/ }),

/***/ 64112:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatDistanceStrict = formatDistanceStrict;
var _index = __webpack_require__(2015);
var _index2 = __webpack_require__(92949);
var _index3 = __webpack_require__(37814);
var _index4 = __webpack_require__(1527);
var _index5 = __webpack_require__(22835);
var _index6 = __webpack_require__(53679);

var _index7 = __webpack_require__(44724);

/**
 * The {@link formatDistanceStrict} function options.
 */

/**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */

/**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */

function formatDistanceStrict(date, baseDate, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index.defaultLocale;

  const comparison = (0, _index5.compareAsc)(date, baseDate);

  if (isNaN(comparison)) {
    throw new RangeError("Invalid time value");
  }

  const localizeOptions = Object.assign({}, options, {
    addSuffix: options?.addSuffix,
    comparison: comparison,
  });

  let dateLeft;
  let dateRight;
  if (comparison > 0) {
    dateLeft = (0, _index7.toDate)(baseDate);
    dateRight = (0, _index7.toDate)(date);
  } else {
    dateLeft = (0, _index7.toDate)(date);
    dateRight = (0, _index7.toDate)(baseDate);
  }

  const roundingMethod = (0, _index3.getRoundingMethod)(
    options?.roundingMethod ?? "round",
  );

  const milliseconds = dateRight.getTime() - dateLeft.getTime();
  const minutes = milliseconds / _index6.millisecondsInMinute;

  const timezoneOffset =
    (0, _index4.getTimezoneOffsetInMilliseconds)(dateRight) -
    (0, _index4.getTimezoneOffsetInMilliseconds)(dateLeft);

  // Use DST-normalized difference in minutes for years, months and days;
  // use regular difference in minutes for hours, minutes and seconds.
  const dstNormalizedMinutes =
    (milliseconds - timezoneOffset) / _index6.millisecondsInMinute;

  const defaultUnit = options?.unit;
  let unit;
  if (!defaultUnit) {
    if (minutes < 1) {
      unit = "second";
    } else if (minutes < 60) {
      unit = "minute";
    } else if (minutes < _index6.minutesInDay) {
      unit = "hour";
    } else if (dstNormalizedMinutes < _index6.minutesInMonth) {
      unit = "day";
    } else if (dstNormalizedMinutes < _index6.minutesInYear) {
      unit = "month";
    } else {
      unit = "year";
    }
  } else {
    unit = defaultUnit;
  }

  // 0 up to 60 seconds
  if (unit === "second") {
    const seconds = roundingMethod(milliseconds / 1000);
    return locale.formatDistance("xSeconds", seconds, localizeOptions);

    // 1 up to 60 mins
  } else if (unit === "minute") {
    const roundedMinutes = roundingMethod(minutes);
    return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);

    // 1 up to 24 hours
  } else if (unit === "hour") {
    const hours = roundingMethod(minutes / 60);
    return locale.formatDistance("xHours", hours, localizeOptions);

    // 1 up to 30 days
  } else if (unit === "day") {
    const days = roundingMethod(dstNormalizedMinutes / _index6.minutesInDay);
    return locale.formatDistance("xDays", days, localizeOptions);

    // 1 up to 12 months
  } else if (unit === "month") {
    const months = roundingMethod(
      dstNormalizedMinutes / _index6.minutesInMonth,
    );
    return months === 12 && defaultUnit !== "month"
      ? locale.formatDistance("xYears", 1, localizeOptions)
      : locale.formatDistance("xMonths", months, localizeOptions);

    // 1 year up to max Date
  } else {
    const years = roundingMethod(dstNormalizedMinutes / _index6.minutesInYear);
    return locale.formatDistance("xYears", years, localizeOptions);
  }
}


/***/ }),

/***/ 96276:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatDistanceToNow = formatDistanceToNow;
var _index = __webpack_require__(84244);

var _index2 = __webpack_require__(4677);

/**
 * The {@link formatDistanceToNow} function options.
 */

/**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function formatDistanceToNow(date, options) {
  return (0, _index2.formatDistance)(
    date,
    (0, _index.constructNow)(date),
    options,
  );
}


/***/ }),

/***/ 39865:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatDistanceToNowStrict = formatDistanceToNowStrict;
var _index = __webpack_require__(64112);
var _index2 = __webpack_require__(84244);

/**
 * The {@link formatDistanceToNowStrict} function options.
 */

/**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function formatDistanceToNowStrict(date, options) {
  return (0, _index.formatDistanceStrict)(
    date,
    (0, _index2.constructNow)(date),
    options,
  );
}


/***/ }),

/***/ 96408:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatDuration = formatDuration;

var _index = __webpack_require__(2015);
var _index2 = __webpack_require__(92949);

/**
 * The {@link formatDuration} function options.
 */

const defaultFormat = [
  "years",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
];

/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */
function formatDuration(duration, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index.defaultLocale;
  const format = options?.format ?? defaultFormat;
  const zero = options?.zero ?? false;
  const delimiter = options?.delimiter ?? " ";

  if (!locale.formatDistance) {
    return "";
  }

  const result = format
    .reduce((acc, unit) => {
      const token = `x${unit.replace(/(^.)/, (m) => m.toUpperCase())}`;
      const value = duration[unit];
      if (value !== undefined && (zero || duration[unit])) {
        return acc.concat(locale.formatDistance(token, value));
      }
      return acc;
    }, [])
    .join(delimiter);

  return result;
}


/***/ }),

/***/ 20519:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatISO = formatISO;
var _index = __webpack_require__(44724);

var _index2 = __webpack_require__(88535);

/**
 * The {@link formatISO} function options.
 */

/**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */
function formatISO(date, options) {
  const _date = (0, _index.toDate)(date);

  if (isNaN(_date.getTime())) {
    throw new RangeError("Invalid time value");
  }

  const format = options?.format ?? "extended";
  const representation = options?.representation ?? "complete";

  let result = "";
  let tzOffset = "";

  const dateDelimiter = format === "extended" ? "-" : "";
  const timeDelimiter = format === "extended" ? ":" : "";

  // Representation is either 'date' or 'complete'
  if (representation !== "time") {
    const day = (0, _index2.addLeadingZeros)(_date.getDate(), 2);
    const month = (0, _index2.addLeadingZeros)(_date.getMonth() + 1, 2);
    const year = (0, _index2.addLeadingZeros)(_date.getFullYear(), 4);

    // yyyyMMdd or yyyy-MM-dd.
    result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
  }

  // Representation is either 'time' or 'complete'
  if (representation !== "date") {
    // Add the timezone.
    const offset = _date.getTimezoneOffset();

    if (offset !== 0) {
      const absoluteOffset = Math.abs(offset);
      const hourOffset = (0, _index2.addLeadingZeros)(
        Math.trunc(absoluteOffset / 60),
        2,
      );
      const minuteOffset = (0, _index2.addLeadingZeros)(absoluteOffset % 60, 2);
      // If less than 0, the sign is +, because it is ahead of time.
      const sign = offset < 0 ? "+" : "-";

      tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
    } else {
      tzOffset = "Z";
    }

    const hour = (0, _index2.addLeadingZeros)(_date.getHours(), 2);
    const minute = (0, _index2.addLeadingZeros)(_date.getMinutes(), 2);
    const second = (0, _index2.addLeadingZeros)(_date.getSeconds(), 2);

    // If there's also date, separate it with time with 'T'
    const separator = result === "" ? "" : "T";

    // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
    const time = [hour, minute, second].join(timeDelimiter);

    // HHmmss or HH:mm:ss.
    result = `${result}${separator}${time}${tzOffset}`;
  }

  return result;
}


/***/ }),

/***/ 72742:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatISO9075 = formatISO9075;
var _index = __webpack_require__(74390);
var _index2 = __webpack_require__(44724);

var _index3 = __webpack_require__(88535);

/**
 * The {@link formatISO9075} function options.
 */

/**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */
function formatISO9075(date, options) {
  const _date = (0, _index2.toDate)(date);

  if (!(0, _index.isValid)(_date)) {
    throw new RangeError("Invalid time value");
  }

  const format = options?.format ?? "extended";
  const representation = options?.representation ?? "complete";

  let result = "";

  const dateDelimiter = format === "extended" ? "-" : "";
  const timeDelimiter = format === "extended" ? ":" : "";

  // Representation is either 'date' or 'complete'
  if (representation !== "time") {
    const day = (0, _index3.addLeadingZeros)(_date.getDate(), 2);
    const month = (0, _index3.addLeadingZeros)(_date.getMonth() + 1, 2);
    const year = (0, _index3.addLeadingZeros)(_date.getFullYear(), 4);

    // yyyyMMdd or yyyy-MM-dd.
    result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
  }

  // Representation is either 'time' or 'complete'
  if (representation !== "date") {
    const hour = (0, _index3.addLeadingZeros)(_date.getHours(), 2);
    const minute = (0, _index3.addLeadingZeros)(_date.getMinutes(), 2);
    const second = (0, _index3.addLeadingZeros)(_date.getSeconds(), 2);

    // If there's also date, separate it with time with a space
    const separator = result === "" ? "" : " ";

    // HHmmss or HH:mm:ss.
    result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
  }

  return result;
}


/***/ }),

/***/ 50561:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.formatISODuration = formatISODuration;

/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */
function formatISODuration(duration) {
  const {
    years = 0,
    months = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = duration;

  return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}


/***/ }),

/***/ 71931:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatRFC3339 = formatRFC3339;
var _index = __webpack_require__(74390);
var _index2 = __webpack_require__(44724);
var _index3 = __webpack_require__(88535);

/**
 * The {@link formatRFC3339} function options.
 */

/**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */
function formatRFC3339(date, options) {
  const _date = (0, _index2.toDate)(date);

  if (!(0, _index.isValid)(_date)) {
    throw new RangeError("Invalid time value");
  }

  const fractionDigits = options?.fractionDigits ?? 0;

  const day = (0, _index3.addLeadingZeros)(_date.getDate(), 2);
  const month = (0, _index3.addLeadingZeros)(_date.getMonth() + 1, 2);
  const year = _date.getFullYear();

  const hour = (0, _index3.addLeadingZeros)(_date.getHours(), 2);
  const minute = (0, _index3.addLeadingZeros)(_date.getMinutes(), 2);
  const second = (0, _index3.addLeadingZeros)(_date.getSeconds(), 2);

  let fractionalSecond = "";
  if (fractionDigits > 0) {
    const milliseconds = _date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, fractionDigits - 3),
    );
    fractionalSecond =
      "." + (0, _index3.addLeadingZeros)(fractionalSeconds, fractionDigits);
  }

  let offset = "";
  const tzOffset = _date.getTimezoneOffset();

  if (tzOffset !== 0) {
    const absoluteOffset = Math.abs(tzOffset);
    const hourOffset = (0, _index3.addLeadingZeros)(
      Math.trunc(absoluteOffset / 60),
      2,
    );
    const minuteOffset = (0, _index3.addLeadingZeros)(absoluteOffset % 60, 2);
    // If less than 0, the sign is +, because it is ahead of time.
    const sign = tzOffset < 0 ? "+" : "-";

    offset = `${sign}${hourOffset}:${minuteOffset}`;
  } else {
    offset = "Z";
  }

  return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}


/***/ }),

/***/ 29813:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatRFC7231 = formatRFC7231;
var _index = __webpack_require__(74390);
var _index2 = __webpack_require__(44724);
var _index3 = __webpack_require__(88535);

const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */
function formatRFC7231(date) {
  const _date = (0, _index2.toDate)(date);

  if (!(0, _index.isValid)(_date)) {
    throw new RangeError("Invalid time value");
  }

  const dayName = days[_date.getUTCDay()];
  const dayOfMonth = (0, _index3.addLeadingZeros)(_date.getUTCDate(), 2);
  const monthName = months[_date.getUTCMonth()];
  const year = _date.getUTCFullYear();

  const hour = (0, _index3.addLeadingZeros)(_date.getUTCHours(), 2);
  const minute = (0, _index3.addLeadingZeros)(_date.getUTCMinutes(), 2);
  const second = (0, _index3.addLeadingZeros)(_date.getUTCSeconds(), 2);

  // Result variables.
  return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}


/***/ }),

/***/ 99283:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatRelative = formatRelative;
var _index = __webpack_require__(45672);
var _index2 = __webpack_require__(24173);

var _index3 = __webpack_require__(44724);

var _index4 = __webpack_require__(2015);
var _index5 = __webpack_require__(92949);

/**
 * The {@link formatRelative} function options.
 */

/**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */
function formatRelative(date, baseDate, options) {
  const _date = (0, _index3.toDate)(date);
  const _baseDate = (0, _index3.toDate)(baseDate);

  const defaultOptions = (0, _index5.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index4.defaultLocale;
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const diff = (0, _index.differenceInCalendarDays)(_date, _baseDate);

  if (isNaN(diff)) {
    throw new RangeError("Invalid time value");
  }

  let token;
  if (diff < -6) {
    token = "other";
  } else if (diff < -1) {
    token = "lastWeek";
  } else if (diff < 0) {
    token = "yesterday";
  } else if (diff < 1) {
    token = "today";
  } else if (diff < 2) {
    token = "tomorrow";
  } else if (diff < 7) {
    token = "nextWeek";
  } else {
    token = "other";
  }

  const formatStr = locale.formatRelative(token, _date, _baseDate, {
    locale,
    weekStartsOn,
  });
  return (0, _index2.format)(_date, formatStr, { locale, weekStartsOn });
}


/***/ }),

/***/ 86738:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.fromUnixTime = fromUnixTime;
var _index = __webpack_require__(44724);

/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */
function fromUnixTime(unixTime) {
  return (0, _index.toDate)(unixTime * 1000);
}


/***/ }),

/***/ 44172:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getDate = getDate;
var _index = __webpack_require__(44724);

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate(date) {
  const _date = (0, _index.toDate)(date);
  const dayOfMonth = _date.getDate();
  return dayOfMonth;
}


/***/ }),

/***/ 49288:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getDay = getDay;
var _index = __webpack_require__(44724);

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay(date) {
  const _date = (0, _index.toDate)(date);
  const day = _date.getDay();
  return day;
}


/***/ }),

/***/ 45741:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getDayOfYear = getDayOfYear;
var _index = __webpack_require__(45672);
var _index2 = __webpack_require__(90821);
var _index3 = __webpack_require__(44724);

/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(date) {
  const _date = (0, _index3.toDate)(date);
  const diff = (0, _index.differenceInCalendarDays)(
    _date,
    (0, _index2.startOfYear)(_date),
  );
  const dayOfYear = diff + 1;
  return dayOfYear;
}


/***/ }),

/***/ 74922:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getDaysInMonth = getDaysInMonth;
var _index = __webpack_require__(44724);
var _index2 = __webpack_require__(4589);

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(date) {
  const _date = (0, _index.toDate)(date);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = (0, _index2.constructFrom)(date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}


/***/ }),

/***/ 40270:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getDaysInYear = getDaysInYear;
var _index = __webpack_require__(7890);
var _index2 = __webpack_require__(44724);

/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear(date) {
  const _date = (0, _index2.toDate)(date);

  if (String(new Date(_date)) === "Invalid Date") {
    return NaN;
  }

  return (0, _index.isLeapYear)(_date) ? 366 : 365;
}


/***/ }),

/***/ 94462:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getDecade = getDecade;
var _index = __webpack_require__(44724);

/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */
function getDecade(date) {
  // TODO: Switch to more technical definition in of decades that start with 1
  // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
  // change, so it can only be done in 4.0.
  const _date = (0, _index.toDate)(date);
  const year = _date.getFullYear();
  const decade = Math.floor(year / 10) * 10;
  return decade;
}


/***/ }),

/***/ 63453:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getDefaultOptions = getDefaultOptions;

var _index = __webpack_require__(92949);

/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */
function getDefaultOptions() {
  return Object.assign({}, (0, _index.getDefaultOptions)());
}


/***/ }),

/***/ 71544:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getHours = getHours;
var _index = __webpack_require__(44724);

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours(date) {
  const _date = (0, _index.toDate)(date);
  const hours = _date.getHours();
  return hours;
}


/***/ }),

/***/ 29064:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getISODay = getISODay;
var _index = __webpack_require__(44724);

/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay(date) {
  const _date = (0, _index.toDate)(date);
  let day = _date.getDay();

  if (day === 0) {
    day = 7;
  }

  return day;
}


/***/ }),

/***/ 69513:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getISOWeek = getISOWeek;
var _index = __webpack_require__(53679);
var _index2 = __webpack_require__(89301);
var _index3 = __webpack_require__(85860);
var _index4 = __webpack_require__(44724);

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(date) {
  const _date = (0, _index4.toDate)(date);
  const diff =
    +(0, _index2.startOfISOWeek)(_date) -
    +(0, _index3.startOfISOWeekYear)(_date);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / _index.millisecondsInWeek) + 1;
}


/***/ }),

/***/ 95303:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getISOWeekYear = getISOWeekYear;
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(89301);
var _index3 = __webpack_require__(44724);

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(date) {
  const _date = (0, _index3.toDate)(date);
  const year = _date.getFullYear();

  const fourthOfJanuaryOfNextYear = (0, _index.constructFrom)(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = (0, _index2.startOfISOWeek)(
    fourthOfJanuaryOfNextYear,
  );

  const fourthOfJanuaryOfThisYear = (0, _index.constructFrom)(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = (0, _index2.startOfISOWeek)(
    fourthOfJanuaryOfThisYear,
  );

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}


/***/ }),

/***/ 82781:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getISOWeeksInYear = getISOWeeksInYear;
var _index = __webpack_require__(75978);
var _index2 = __webpack_require__(53679);
var _index3 = __webpack_require__(85860);

/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear(date) {
  const thisYear = (0, _index3.startOfISOWeekYear)(date);
  const nextYear = (0, _index3.startOfISOWeekYear)(
    (0, _index.addWeeks)(thisYear, 60),
  );
  const diff = +nextYear - +thisYear;

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / _index2.millisecondsInWeek);
}


/***/ }),

/***/ 26240:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getMilliseconds = getMilliseconds;
var _index = __webpack_require__(44724);

/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds(date) {
  const _date = (0, _index.toDate)(date);
  const milliseconds = _date.getMilliseconds();
  return milliseconds;
}


/***/ }),

/***/ 57552:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getMinutes = getMinutes;
var _index = __webpack_require__(44724);

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes(date) {
  const _date = (0, _index.toDate)(date);
  const minutes = _date.getMinutes();
  return minutes;
}


/***/ }),

/***/ 98825:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getMonth = getMonth;
var _index = __webpack_require__(44724);

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth(date) {
  const _date = (0, _index.toDate)(date);
  const month = _date.getMonth();
  return month;
}


/***/ }),

/***/ 29112:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getOverlappingDaysInIntervals = getOverlappingDaysInIntervals;
var _index = __webpack_require__(1527);
var _index2 = __webpack_require__(53679);
var _index3 = __webpack_require__(44724);

/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */

function getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
  const [leftStart, leftEnd] = [
    +(0, _index3.toDate)(intervalLeft.start),
    +(0, _index3.toDate)(intervalLeft.end),
  ].sort((a, b) => a - b);
  const [rightStart, rightEnd] = [
    +(0, _index3.toDate)(intervalRight.start),
    +(0, _index3.toDate)(intervalRight.end),
  ].sort((a, b) => a - b);

  // Prevent NaN result if intervals don't overlap at all.
  const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
  if (!isOverlapping) return 0;

  // Remove the timezone offset to negate the DST effect on calculations.
  const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
  const left =
    overlapLeft - (0, _index.getTimezoneOffsetInMilliseconds)(overlapLeft);
  const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
  const right =
    overlapRight - (0, _index.getTimezoneOffsetInMilliseconds)(overlapRight);

  // Ceil the number to include partial days too.
  return Math.ceil((right - left) / _index2.millisecondsInDay);
}


/***/ }),

/***/ 23350:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getQuarter = getQuarter;
var _index = __webpack_require__(44724);

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter(date) {
  const _date = (0, _index.toDate)(date);
  const quarter = Math.trunc(_date.getMonth() / 3) + 1;
  return quarter;
}


/***/ }),

/***/ 73701:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getSeconds = getSeconds;
var _index = __webpack_require__(44724);

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds(date) {
  const _date = (0, _index.toDate)(date);
  const seconds = _date.getSeconds();
  return seconds;
}


/***/ }),

/***/ 97013:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getTime = getTime;
var _index = __webpack_require__(44724);

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime(date) {
  const _date = (0, _index.toDate)(date);
  const timestamp = _date.getTime();
  return timestamp;
}


/***/ }),

/***/ 14079:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getUnixTime = getUnixTime;
var _index = __webpack_require__(44724);

/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */
function getUnixTime(date) {
  return Math.trunc(+(0, _index.toDate)(date) / 1000);
}


/***/ }),

/***/ 32901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getWeek = getWeek;
var _index = __webpack_require__(53679);
var _index2 = __webpack_require__(83877);
var _index3 = __webpack_require__(50237);
var _index4 = __webpack_require__(44724);

/**
 * The {@link getWeek} function options.
 */

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(date, options) {
  const _date = (0, _index4.toDate)(date);
  const diff =
    +(0, _index2.startOfWeek)(_date, options) -
    +(0, _index3.startOfWeekYear)(_date, options);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / _index.millisecondsInWeek) + 1;
}


/***/ }),

/***/ 73252:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getWeekOfMonth = getWeekOfMonth;
var _index = __webpack_require__(44172);
var _index2 = __webpack_require__(49288);
var _index3 = __webpack_require__(23266);

var _index4 = __webpack_require__(92949);

/**
 * The {@link getWeekOfMonth} function options.
 */

/**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */
function getWeekOfMonth(date, options) {
  const defaultOptions = (0, _index4.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const currentDayOfMonth = (0, _index.getDate)(date);
  if (isNaN(currentDayOfMonth)) return NaN;

  const startWeekDay = (0, _index2.getDay)((0, _index3.startOfMonth)(date));

  let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
  if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;

  const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}


/***/ }),

/***/ 38180:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getWeekYear = getWeekYear;
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(83877);
var _index3 = __webpack_require__(44724);

var _index4 = __webpack_require__(92949);

/**
 * The {@link getWeekYear} function options.
 */

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(date, options) {
  const _date = (0, _index3.toDate)(date);
  const year = _date.getFullYear();

  const defaultOptions = (0, _index4.getDefaultOptions)();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const firstWeekOfNextYear = (0, _index.constructFrom)(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = (0, _index2.startOfWeek)(
    firstWeekOfNextYear,
    options,
  );

  const firstWeekOfThisYear = (0, _index.constructFrom)(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = (0, _index2.startOfWeek)(
    firstWeekOfThisYear,
    options,
  );

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}


/***/ }),

/***/ 42078:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getWeeksInMonth = getWeeksInMonth;
var _index = __webpack_require__(25049);
var _index2 = __webpack_require__(85226);
var _index3 = __webpack_require__(23266);

/**
 * The {@link getWeeksInMonth} function options.
 */

/**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */
function getWeeksInMonth(date, options) {
  return (
    (0, _index.differenceInCalendarWeeks)(
      (0, _index2.lastDayOfMonth)(date),
      (0, _index3.startOfMonth)(date),
      options,
    ) + 1
  );
}


/***/ }),

/***/ 50227:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getYear = getYear;
var _index = __webpack_require__(44724);

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear(date) {
  return (0, _index.toDate)(date).getFullYear();
}


/***/ }),

/***/ 85150:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.hoursToMilliseconds = hoursToMilliseconds;
var _index = __webpack_require__(53679);

/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */
function hoursToMilliseconds(hours) {
  return Math.trunc(hours * _index.millisecondsInHour);
}


/***/ }),

/***/ 3227:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.hoursToMinutes = hoursToMinutes;
var _index = __webpack_require__(53679);

/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */
function hoursToMinutes(hours) {
  return Math.trunc(hours * _index.minutesInHour);
}


/***/ }),

/***/ 36021:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.hoursToSeconds = hoursToSeconds;
var _index = __webpack_require__(53679);

/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */
function hoursToSeconds(hours) {
  return Math.trunc(hours * _index.secondsInHour);
}


/***/ }),

/***/ 25155:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__(33857);
Object.keys(_index).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index[key];
    },
  });
});
var _index2 = __webpack_require__(87178);
Object.keys(_index2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index2[key];
    },
  });
});
var _index3 = __webpack_require__(83978);
Object.keys(_index3).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index3[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index3[key];
    },
  });
});
var _index4 = __webpack_require__(41278);
Object.keys(_index4).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index4[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index4[key];
    },
  });
});
var _index5 = __webpack_require__(77673);
Object.keys(_index5).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index5[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index5[key];
    },
  });
});
var _index6 = __webpack_require__(67106);
Object.keys(_index6).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index6[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index6[key];
    },
  });
});
var _index7 = __webpack_require__(5157);
Object.keys(_index7).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index7[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index7[key];
    },
  });
});
var _index8 = __webpack_require__(48991);
Object.keys(_index8).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index8[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index8[key];
    },
  });
});
var _index9 = __webpack_require__(53893);
Object.keys(_index9).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index9[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index9[key];
    },
  });
});
var _index10 = __webpack_require__(41488);
Object.keys(_index10).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index10[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index10[key];
    },
  });
});
var _index11 = __webpack_require__(75978);
Object.keys(_index11).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index11[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index11[key];
    },
  });
});
var _index12 = __webpack_require__(83366);
Object.keys(_index12).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index12[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index12[key];
    },
  });
});
var _index13 = __webpack_require__(45801);
Object.keys(_index13).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index13[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index13[key];
    },
  });
});
var _index14 = __webpack_require__(73635);
Object.keys(_index14).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index14[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index14[key];
    },
  });
});
var _index15 = __webpack_require__(52649);
Object.keys(_index15).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index15[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index15[key];
    },
  });
});
var _index16 = __webpack_require__(45099);
Object.keys(_index16).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index16[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index16[key];
    },
  });
});
var _index17 = __webpack_require__(22835);
Object.keys(_index17).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index17[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index17[key];
    },
  });
});
var _index18 = __webpack_require__(32023);
Object.keys(_index18).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index18[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index18[key];
    },
  });
});
var _index19 = __webpack_require__(4589);
Object.keys(_index19).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index19[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index19[key];
    },
  });
});
var _index20 = __webpack_require__(84244);
Object.keys(_index20).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index20[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index20[key];
    },
  });
});
var _index21 = __webpack_require__(56675);
Object.keys(_index21).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index21[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index21[key];
    },
  });
});
var _index22 = __webpack_require__(614);
Object.keys(_index22).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index22[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index22[key];
    },
  });
});
var _index23 = __webpack_require__(45672);
Object.keys(_index23).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index23[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index23[key];
    },
  });
});
var _index24 = __webpack_require__(22375);
Object.keys(_index24).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index24[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index24[key];
    },
  });
});
var _index25 = __webpack_require__(52087);
Object.keys(_index25).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index25[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index25[key];
    },
  });
});
var _index26 = __webpack_require__(96719);
Object.keys(_index26).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index26[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index26[key];
    },
  });
});
var _index27 = __webpack_require__(66393);
Object.keys(_index27).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index27[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index27[key];
    },
  });
});
var _index28 = __webpack_require__(25049);
Object.keys(_index28).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index28[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index28[key];
    },
  });
});
var _index29 = __webpack_require__(85878);
Object.keys(_index29).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index29[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index29[key];
    },
  });
});
var _index30 = __webpack_require__(31581);
Object.keys(_index30).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index30[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index30[key];
    },
  });
});
var _index31 = __webpack_require__(39288);
Object.keys(_index31).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index31[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index31[key];
    },
  });
});
var _index32 = __webpack_require__(30870);
Object.keys(_index32).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index32[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index32[key];
    },
  });
});
var _index33 = __webpack_require__(69737);
Object.keys(_index33).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index33[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index33[key];
    },
  });
});
var _index34 = __webpack_require__(56034);
Object.keys(_index34).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index34[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index34[key];
    },
  });
});
var _index35 = __webpack_require__(47555);
Object.keys(_index35).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index35[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index35[key];
    },
  });
});
var _index36 = __webpack_require__(41591);
Object.keys(_index36).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index36[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index36[key];
    },
  });
});
var _index37 = __webpack_require__(9480);
Object.keys(_index37).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index37[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index37[key];
    },
  });
});
var _index38 = __webpack_require__(46733);
Object.keys(_index38).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index38[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index38[key];
    },
  });
});
var _index39 = __webpack_require__(90103);
Object.keys(_index39).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index39[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index39[key];
    },
  });
});
var _index40 = __webpack_require__(92453);
Object.keys(_index40).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index40[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index40[key];
    },
  });
});
var _index41 = __webpack_require__(19025);
Object.keys(_index41).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index41[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index41[key];
    },
  });
});
var _index42 = __webpack_require__(85522);
Object.keys(_index42).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index42[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index42[key];
    },
  });
});
var _index43 = __webpack_require__(76745);
Object.keys(_index43).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index43[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index43[key];
    },
  });
});
var _index44 = __webpack_require__(59190);
Object.keys(_index44).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index44[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index44[key];
    },
  });
});
var _index45 = __webpack_require__(34553);
Object.keys(_index45).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index45[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index45[key];
    },
  });
});
var _index46 = __webpack_require__(1161);
Object.keys(_index46).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index46[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index46[key];
    },
  });
});
var _index47 = __webpack_require__(78857);
Object.keys(_index47).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index47[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index47[key];
    },
  });
});
var _index48 = __webpack_require__(47150);
Object.keys(_index48).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index48[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index48[key];
    },
  });
});
var _index49 = __webpack_require__(51885);
Object.keys(_index49).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index49[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index49[key];
    },
  });
});
var _index50 = __webpack_require__(48443);
Object.keys(_index50).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index50[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index50[key];
    },
  });
});
var _index51 = __webpack_require__(22665);
Object.keys(_index51).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index51[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index51[key];
    },
  });
});
var _index52 = __webpack_require__(59012);
Object.keys(_index52).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index52[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index52[key];
    },
  });
});
var _index53 = __webpack_require__(29403);
Object.keys(_index53).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index53[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index53[key];
    },
  });
});
var _index54 = __webpack_require__(33367);
Object.keys(_index54).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index54[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index54[key];
    },
  });
});
var _index55 = __webpack_require__(75836);
Object.keys(_index55).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index55[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index55[key];
    },
  });
});
var _index56 = __webpack_require__(92335);
Object.keys(_index56).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index56[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index56[key];
    },
  });
});
var _index57 = __webpack_require__(87181);
Object.keys(_index57).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index57[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index57[key];
    },
  });
});
var _index58 = __webpack_require__(50372);
Object.keys(_index58).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index58[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index58[key];
    },
  });
});
var _index59 = __webpack_require__(59660);
Object.keys(_index59).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index59[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index59[key];
    },
  });
});
var _index60 = __webpack_require__(40776);
Object.keys(_index60).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index60[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index60[key];
    },
  });
});
var _index61 = __webpack_require__(67786);
Object.keys(_index61).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index61[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index61[key];
    },
  });
});
var _index62 = __webpack_require__(53689);
Object.keys(_index62).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index62[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index62[key];
    },
  });
});
var _index63 = __webpack_require__(25268);
Object.keys(_index63).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index63[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index63[key];
    },
  });
});
var _index64 = __webpack_require__(24173);
Object.keys(_index64).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index64[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index64[key];
    },
  });
});
var _index65 = __webpack_require__(4677);
Object.keys(_index65).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index65[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index65[key];
    },
  });
});
var _index66 = __webpack_require__(64112);
Object.keys(_index66).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index66[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index66[key];
    },
  });
});
var _index67 = __webpack_require__(96276);
Object.keys(_index67).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index67[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index67[key];
    },
  });
});
var _index68 = __webpack_require__(39865);
Object.keys(_index68).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index68[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index68[key];
    },
  });
});
var _index69 = __webpack_require__(96408);
Object.keys(_index69).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index69[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index69[key];
    },
  });
});
var _index70 = __webpack_require__(20519);
Object.keys(_index70).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index70[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index70[key];
    },
  });
});
var _index71 = __webpack_require__(72742);
Object.keys(_index71).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index71[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index71[key];
    },
  });
});
var _index72 = __webpack_require__(50561);
Object.keys(_index72).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index72[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index72[key];
    },
  });
});
var _index73 = __webpack_require__(71931);
Object.keys(_index73).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index73[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index73[key];
    },
  });
});
var _index74 = __webpack_require__(29813);
Object.keys(_index74).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index74[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index74[key];
    },
  });
});
var _index75 = __webpack_require__(99283);
Object.keys(_index75).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index75[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index75[key];
    },
  });
});
var _index76 = __webpack_require__(86738);
Object.keys(_index76).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index76[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index76[key];
    },
  });
});
var _index77 = __webpack_require__(44172);
Object.keys(_index77).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index77[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index77[key];
    },
  });
});
var _index78 = __webpack_require__(49288);
Object.keys(_index78).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index78[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index78[key];
    },
  });
});
var _index79 = __webpack_require__(45741);
Object.keys(_index79).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index79[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index79[key];
    },
  });
});
var _index80 = __webpack_require__(74922);
Object.keys(_index80).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index80[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index80[key];
    },
  });
});
var _index81 = __webpack_require__(40270);
Object.keys(_index81).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index81[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index81[key];
    },
  });
});
var _index82 = __webpack_require__(94462);
Object.keys(_index82).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index82[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index82[key];
    },
  });
});
var _index83 = __webpack_require__(63453);
Object.keys(_index83).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index83[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index83[key];
    },
  });
});
var _index84 = __webpack_require__(71544);
Object.keys(_index84).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index84[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index84[key];
    },
  });
});
var _index85 = __webpack_require__(29064);
Object.keys(_index85).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index85[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index85[key];
    },
  });
});
var _index86 = __webpack_require__(69513);
Object.keys(_index86).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index86[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index86[key];
    },
  });
});
var _index87 = __webpack_require__(95303);
Object.keys(_index87).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index87[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index87[key];
    },
  });
});
var _index88 = __webpack_require__(82781);
Object.keys(_index88).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index88[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index88[key];
    },
  });
});
var _index89 = __webpack_require__(26240);
Object.keys(_index89).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index89[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index89[key];
    },
  });
});
var _index90 = __webpack_require__(57552);
Object.keys(_index90).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index90[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index90[key];
    },
  });
});
var _index91 = __webpack_require__(98825);
Object.keys(_index91).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index91[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index91[key];
    },
  });
});
var _index92 = __webpack_require__(29112);
Object.keys(_index92).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index92[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index92[key];
    },
  });
});
var _index93 = __webpack_require__(23350);
Object.keys(_index93).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index93[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index93[key];
    },
  });
});
var _index94 = __webpack_require__(73701);
Object.keys(_index94).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index94[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index94[key];
    },
  });
});
var _index95 = __webpack_require__(97013);
Object.keys(_index95).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index95[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index95[key];
    },
  });
});
var _index96 = __webpack_require__(14079);
Object.keys(_index96).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index96[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index96[key];
    },
  });
});
var _index97 = __webpack_require__(32901);
Object.keys(_index97).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index97[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index97[key];
    },
  });
});
var _index98 = __webpack_require__(73252);
Object.keys(_index98).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index98[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index98[key];
    },
  });
});
var _index99 = __webpack_require__(38180);
Object.keys(_index99).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index99[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index99[key];
    },
  });
});
var _index100 = __webpack_require__(42078);
Object.keys(_index100).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index100[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index100[key];
    },
  });
});
var _index101 = __webpack_require__(50227);
Object.keys(_index101).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index101[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index101[key];
    },
  });
});
var _index102 = __webpack_require__(85150);
Object.keys(_index102).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index102[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index102[key];
    },
  });
});
var _index103 = __webpack_require__(3227);
Object.keys(_index103).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index103[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index103[key];
    },
  });
});
var _index104 = __webpack_require__(36021);
Object.keys(_index104).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index104[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index104[key];
    },
  });
});
var _index105 = __webpack_require__(91760);
Object.keys(_index105).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index105[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index105[key];
    },
  });
});
var _index106 = __webpack_require__(52201);
Object.keys(_index106).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index106[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index106[key];
    },
  });
});
var _index107 = __webpack_require__(89620);
Object.keys(_index107).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index107[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index107[key];
    },
  });
});
var _index108 = __webpack_require__(91466);
Object.keys(_index108).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index108[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index108[key];
    },
  });
});
var _index109 = __webpack_require__(2129);
Object.keys(_index109).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index109[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index109[key];
    },
  });
});
var _index110 = __webpack_require__(78);
Object.keys(_index110).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index110[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index110[key];
    },
  });
});
var _index111 = __webpack_require__(43215);
Object.keys(_index111).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index111[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index111[key];
    },
  });
});
var _index112 = __webpack_require__(13195);
Object.keys(_index112).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index112[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index112[key];
    },
  });
});
var _index113 = __webpack_require__(67500);
Object.keys(_index113).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index113[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index113[key];
    },
  });
});
var _index114 = __webpack_require__(11059);
Object.keys(_index114).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index114[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index114[key];
    },
  });
});
var _index115 = __webpack_require__(41315);
Object.keys(_index115).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index115[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index115[key];
    },
  });
});
var _index116 = __webpack_require__(87675);
Object.keys(_index116).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index116[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index116[key];
    },
  });
});
var _index117 = __webpack_require__(47752);
Object.keys(_index117).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index117[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index117[key];
    },
  });
});
var _index118 = __webpack_require__(7890);
Object.keys(_index118).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index118[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index118[key];
    },
  });
});
var _index119 = __webpack_require__(92609);
Object.keys(_index119).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index119[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index119[key];
    },
  });
});
var _index120 = __webpack_require__(29019);
Object.keys(_index120).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index120[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index120[key];
    },
  });
});
var _index121 = __webpack_require__(29796);
Object.keys(_index121).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index121[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index121[key];
    },
  });
});
var _index122 = __webpack_require__(10098);
Object.keys(_index122).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index122[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index122[key];
    },
  });
});
var _index123 = __webpack_require__(1421);
Object.keys(_index123).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index123[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index123[key];
    },
  });
});
var _index124 = __webpack_require__(14792);
Object.keys(_index124).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index124[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index124[key];
    },
  });
});
var _index125 = __webpack_require__(76551);
Object.keys(_index125).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index125[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index125[key];
    },
  });
});
var _index126 = __webpack_require__(4908);
Object.keys(_index126).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index126[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index126[key];
    },
  });
});
var _index127 = __webpack_require__(29548);
Object.keys(_index127).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index127[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index127[key];
    },
  });
});
var _index128 = __webpack_require__(45154);
Object.keys(_index128).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index128[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index128[key];
    },
  });
});
var _index129 = __webpack_require__(81849);
Object.keys(_index129).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index129[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index129[key];
    },
  });
});
var _index130 = __webpack_require__(89439);
Object.keys(_index130).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index130[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index130[key];
    },
  });
});
var _index131 = __webpack_require__(55033);
Object.keys(_index131).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index131[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index131[key];
    },
  });
});
var _index132 = __webpack_require__(52365);
Object.keys(_index132).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index132[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index132[key];
    },
  });
});
var _index133 = __webpack_require__(59136);
Object.keys(_index133).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index133[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index133[key];
    },
  });
});
var _index134 = __webpack_require__(88910);
Object.keys(_index134).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index134[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index134[key];
    },
  });
});
var _index135 = __webpack_require__(22055);
Object.keys(_index135).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index135[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index135[key];
    },
  });
});
var _index136 = __webpack_require__(12172);
Object.keys(_index136).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index136[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index136[key];
    },
  });
});
var _index137 = __webpack_require__(83874);
Object.keys(_index137).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index137[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index137[key];
    },
  });
});
var _index138 = __webpack_require__(27207);
Object.keys(_index138).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index138[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index138[key];
    },
  });
});
var _index139 = __webpack_require__(84779);
Object.keys(_index139).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index139[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index139[key];
    },
  });
});
var _index140 = __webpack_require__(50450);
Object.keys(_index140).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index140[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index140[key];
    },
  });
});
var _index141 = __webpack_require__(2620);
Object.keys(_index141).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index141[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index141[key];
    },
  });
});
var _index142 = __webpack_require__(61164);
Object.keys(_index142).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index142[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index142[key];
    },
  });
});
var _index143 = __webpack_require__(62172);
Object.keys(_index143).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index143[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index143[key];
    },
  });
});
var _index144 = __webpack_require__(30620);
Object.keys(_index144).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index144[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index144[key];
    },
  });
});
var _index145 = __webpack_require__(99971);
Object.keys(_index145).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index145[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index145[key];
    },
  });
});
var _index146 = __webpack_require__(74390);
Object.keys(_index146).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index146[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index146[key];
    },
  });
});
var _index147 = __webpack_require__(41185);
Object.keys(_index147).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index147[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index147[key];
    },
  });
});
var _index148 = __webpack_require__(60991);
Object.keys(_index148).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index148[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index148[key];
    },
  });
});
var _index149 = __webpack_require__(18901);
Object.keys(_index149).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index149[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index149[key];
    },
  });
});
var _index150 = __webpack_require__(38956);
Object.keys(_index150).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index150[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index150[key];
    },
  });
});
var _index151 = __webpack_require__(36542);
Object.keys(_index151).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index151[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index151[key];
    },
  });
});
var _index152 = __webpack_require__(9816);
Object.keys(_index152).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index152[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index152[key];
    },
  });
});
var _index153 = __webpack_require__(50587);
Object.keys(_index153).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index153[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index153[key];
    },
  });
});
var _index154 = __webpack_require__(85226);
Object.keys(_index154).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index154[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index154[key];
    },
  });
});
var _index155 = __webpack_require__(82013);
Object.keys(_index155).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index155[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index155[key];
    },
  });
});
var _index156 = __webpack_require__(17376);
Object.keys(_index156).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index156[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index156[key];
    },
  });
});
var _index157 = __webpack_require__(66199);
Object.keys(_index157).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index157[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index157[key];
    },
  });
});
var _index158 = __webpack_require__(10905);
Object.keys(_index158).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index158[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index158[key];
    },
  });
});
var _index159 = __webpack_require__(25518);
Object.keys(_index159).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index159[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index159[key];
    },
  });
});
var _index160 = __webpack_require__(37180);
Object.keys(_index160).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index160[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index160[key];
    },
  });
});
var _index161 = __webpack_require__(29304);
Object.keys(_index161).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index161[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index161[key];
    },
  });
});
var _index162 = __webpack_require__(77114);
Object.keys(_index162).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index162[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index162[key];
    },
  });
});
var _index163 = __webpack_require__(30634);
Object.keys(_index163).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index163[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index163[key];
    },
  });
});
var _index164 = __webpack_require__(55463);
Object.keys(_index164).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index164[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index164[key];
    },
  });
});
var _index165 = __webpack_require__(82023);
Object.keys(_index165).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index165[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index165[key];
    },
  });
});
var _index166 = __webpack_require__(94621);
Object.keys(_index166).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index166[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index166[key];
    },
  });
});
var _index167 = __webpack_require__(63667);
Object.keys(_index167).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index167[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index167[key];
    },
  });
});
var _index168 = __webpack_require__(22305);
Object.keys(_index168).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index168[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index168[key];
    },
  });
});
var _index169 = __webpack_require__(14999);
Object.keys(_index169).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index169[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index169[key];
    },
  });
});
var _index170 = __webpack_require__(98495);
Object.keys(_index170).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index170[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index170[key];
    },
  });
});
var _index171 = __webpack_require__(93059);
Object.keys(_index171).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index171[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index171[key];
    },
  });
});
var _index172 = __webpack_require__(50486);
Object.keys(_index172).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index172[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index172[key];
    },
  });
});
var _index173 = __webpack_require__(84623);
Object.keys(_index173).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index173[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index173[key];
    },
  });
});
var _index174 = __webpack_require__(53847);
Object.keys(_index174).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index174[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index174[key];
    },
  });
});
var _index175 = __webpack_require__(19082);
Object.keys(_index175).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index175[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index175[key];
    },
  });
});
var _index176 = __webpack_require__(46232);
Object.keys(_index176).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index176[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index176[key];
    },
  });
});
var _index177 = __webpack_require__(137);
Object.keys(_index177).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index177[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index177[key];
    },
  });
});
var _index178 = __webpack_require__(86103);
Object.keys(_index178).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index178[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index178[key];
    },
  });
});
var _index179 = __webpack_require__(14485);
Object.keys(_index179).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index179[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index179[key];
    },
  });
});
var _index180 = __webpack_require__(77864);
Object.keys(_index180).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index180[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index180[key];
    },
  });
});
var _index181 = __webpack_require__(73189);
Object.keys(_index181).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index181[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index181[key];
    },
  });
});
var _index182 = __webpack_require__(35420);
Object.keys(_index182).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index182[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index182[key];
    },
  });
});
var _index183 = __webpack_require__(65042);
Object.keys(_index183).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index183[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index183[key];
    },
  });
});
var _index184 = __webpack_require__(73802);
Object.keys(_index184).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index184[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index184[key];
    },
  });
});
var _index185 = __webpack_require__(54215);
Object.keys(_index185).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index185[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index185[key];
    },
  });
});
var _index186 = __webpack_require__(61663);
Object.keys(_index186).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index186[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index186[key];
    },
  });
});
var _index187 = __webpack_require__(42941);
Object.keys(_index187).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index187[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index187[key];
    },
  });
});
var _index188 = __webpack_require__(43529);
Object.keys(_index188).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index188[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index188[key];
    },
  });
});
var _index189 = __webpack_require__(31078);
Object.keys(_index189).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index189[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index189[key];
    },
  });
});
var _index190 = __webpack_require__(1890);
Object.keys(_index190).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index190[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index190[key];
    },
  });
});
var _index191 = __webpack_require__(54931);
Object.keys(_index191).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index191[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index191[key];
    },
  });
});
var _index192 = __webpack_require__(79122);
Object.keys(_index192).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index192[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index192[key];
    },
  });
});
var _index193 = __webpack_require__(88634);
Object.keys(_index193).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index193[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index193[key];
    },
  });
});
var _index194 = __webpack_require__(6179);
Object.keys(_index194).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index194[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index194[key];
    },
  });
});
var _index195 = __webpack_require__(59399);
Object.keys(_index195).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index195[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index195[key];
    },
  });
});
var _index196 = __webpack_require__(53304);
Object.keys(_index196).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index196[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index196[key];
    },
  });
});
var _index197 = __webpack_require__(28296);
Object.keys(_index197).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index197[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index197[key];
    },
  });
});
var _index198 = __webpack_require__(4729);
Object.keys(_index198).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index198[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index198[key];
    },
  });
});
var _index199 = __webpack_require__(47055);
Object.keys(_index199).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index199[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index199[key];
    },
  });
});
var _index200 = __webpack_require__(96820);
Object.keys(_index200).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index200[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index200[key];
    },
  });
});
var _index201 = __webpack_require__(24269);
Object.keys(_index201).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index201[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index201[key];
    },
  });
});
var _index202 = __webpack_require__(70337);
Object.keys(_index202).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index202[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index202[key];
    },
  });
});
var _index203 = __webpack_require__(70596);
Object.keys(_index203).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index203[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index203[key];
    },
  });
});
var _index204 = __webpack_require__(58985);
Object.keys(_index204).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index204[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index204[key];
    },
  });
});
var _index205 = __webpack_require__(85558);
Object.keys(_index205).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index205[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index205[key];
    },
  });
});
var _index206 = __webpack_require__(14728);
Object.keys(_index206).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index206[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index206[key];
    },
  });
});
var _index207 = __webpack_require__(82650);
Object.keys(_index207).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index207[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index207[key];
    },
  });
});
var _index208 = __webpack_require__(3646);
Object.keys(_index208).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index208[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index208[key];
    },
  });
});
var _index209 = __webpack_require__(24562);
Object.keys(_index209).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index209[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index209[key];
    },
  });
});
var _index210 = __webpack_require__(52561);
Object.keys(_index210).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index210[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index210[key];
    },
  });
});
var _index211 = __webpack_require__(86593);
Object.keys(_index211).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index211[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index211[key];
    },
  });
});
var _index212 = __webpack_require__(22490);
Object.keys(_index212).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index212[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index212[key];
    },
  });
});
var _index213 = __webpack_require__(72274);
Object.keys(_index213).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index213[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index213[key];
    },
  });
});
var _index214 = __webpack_require__(23114);
Object.keys(_index214).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index214[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index214[key];
    },
  });
});
var _index215 = __webpack_require__(25281);
Object.keys(_index215).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index215[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index215[key];
    },
  });
});
var _index216 = __webpack_require__(89301);
Object.keys(_index216).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index216[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index216[key];
    },
  });
});
var _index217 = __webpack_require__(85860);
Object.keys(_index217).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index217[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index217[key];
    },
  });
});
var _index218 = __webpack_require__(52881);
Object.keys(_index218).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index218[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index218[key];
    },
  });
});
var _index219 = __webpack_require__(23266);
Object.keys(_index219).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index219[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index219[key];
    },
  });
});
var _index220 = __webpack_require__(6831);
Object.keys(_index220).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index220[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index220[key];
    },
  });
});
var _index221 = __webpack_require__(73320);
Object.keys(_index221).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index221[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index221[key];
    },
  });
});
var _index222 = __webpack_require__(48285);
Object.keys(_index222).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index222[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index222[key];
    },
  });
});
var _index223 = __webpack_require__(75616);
Object.keys(_index223).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index223[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index223[key];
    },
  });
});
var _index224 = __webpack_require__(83877);
Object.keys(_index224).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index224[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index224[key];
    },
  });
});
var _index225 = __webpack_require__(50237);
Object.keys(_index225).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index225[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index225[key];
    },
  });
});
var _index226 = __webpack_require__(90821);
Object.keys(_index226).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index226[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index226[key];
    },
  });
});
var _index227 = __webpack_require__(75747);
Object.keys(_index227).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index227[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index227[key];
    },
  });
});
var _index228 = __webpack_require__(47686);
Object.keys(_index228).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index228[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index228[key];
    },
  });
});
var _index229 = __webpack_require__(94347);
Object.keys(_index229).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index229[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index229[key];
    },
  });
});
var _index230 = __webpack_require__(86584);
Object.keys(_index230).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index230[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index230[key];
    },
  });
});
var _index231 = __webpack_require__(39169);
Object.keys(_index231).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index231[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index231[key];
    },
  });
});
var _index232 = __webpack_require__(76081);
Object.keys(_index232).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index232[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index232[key];
    },
  });
});
var _index233 = __webpack_require__(44566);
Object.keys(_index233).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index233[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index233[key];
    },
  });
});
var _index234 = __webpack_require__(31160);
Object.keys(_index234).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index234[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index234[key];
    },
  });
});
var _index235 = __webpack_require__(10260);
Object.keys(_index235).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index235[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index235[key];
    },
  });
});
var _index236 = __webpack_require__(4286);
Object.keys(_index236).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index236[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index236[key];
    },
  });
});
var _index237 = __webpack_require__(35882);
Object.keys(_index237).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index237[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index237[key];
    },
  });
});
var _index238 = __webpack_require__(35619);
Object.keys(_index238).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index238[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index238[key];
    },
  });
});
var _index239 = __webpack_require__(26663);
Object.keys(_index239).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index239[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index239[key];
    },
  });
});
var _index240 = __webpack_require__(44724);
Object.keys(_index240).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index240[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index240[key];
    },
  });
});
var _index241 = __webpack_require__(46225);
Object.keys(_index241).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index241[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index241[key];
    },
  });
});
var _index242 = __webpack_require__(4388);
Object.keys(_index242).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index242[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index242[key];
    },
  });
});
var _index243 = __webpack_require__(85345);
Object.keys(_index243).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index243[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index243[key];
    },
  });
});
var _index244 = __webpack_require__(99893);
Object.keys(_index244).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index244[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index244[key];
    },
  });
});
var _index245 = __webpack_require__(32416);
Object.keys(_index245).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index245[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index245[key];
    },
  });
});


/***/ }),

/***/ 91760:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.interval = interval;
var _index = __webpack_require__(44724);

/**
 * The {@link interval} function options.
 */

/**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */
function interval(start, end, options) {
  const _start = (0, _index.toDate)(start);
  if (isNaN(+_start)) throw new TypeError("Start date is invalid");

  const _end = (0, _index.toDate)(end);
  if (isNaN(+_end)) throw new TypeError("End date is invalid");

  if (options?.assertPositive && +_start > +_end)
    throw new TypeError("End date must be after start date");

  return { start: _start, end: _end };
}


/***/ }),

/***/ 52201:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.intervalToDuration = intervalToDuration;
var _index = __webpack_require__(33857);
var _index2 = __webpack_require__(31581);
var _index3 = __webpack_require__(39288);
var _index4 = __webpack_require__(56034);
var _index5 = __webpack_require__(47555);
var _index6 = __webpack_require__(9480);
var _index7 = __webpack_require__(90103);
var _index8 = __webpack_require__(44724);

/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */
function intervalToDuration(interval) {
  const start = (0, _index8.toDate)(interval.start);
  const end = (0, _index8.toDate)(interval.end);

  const duration = {};

  const years = (0, _index7.differenceInYears)(end, start);
  if (years) duration.years = years;

  const remainingMonths = (0, _index.add)(start, { years: duration.years });

  const months = (0, _index5.differenceInMonths)(end, remainingMonths);
  if (months) duration.months = months;

  const remainingDays = (0, _index.add)(remainingMonths, {
    months: duration.months,
  });

  const days = (0, _index2.differenceInDays)(end, remainingDays);
  if (days) duration.days = days;

  const remainingHours = (0, _index.add)(remainingDays, {
    days: duration.days,
  });

  const hours = (0, _index3.differenceInHours)(end, remainingHours);
  if (hours) duration.hours = hours;

  const remainingMinutes = (0, _index.add)(remainingHours, {
    hours: duration.hours,
  });

  const minutes = (0, _index4.differenceInMinutes)(end, remainingMinutes);
  if (minutes) duration.minutes = minutes;

  const remainingSeconds = (0, _index.add)(remainingMinutes, {
    minutes: duration.minutes,
  });

  const seconds = (0, _index6.differenceInSeconds)(end, remainingSeconds);
  if (seconds) duration.seconds = seconds;

  return duration;
}


/***/ }),

/***/ 89620:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.intlFormat = intlFormat;
var _index = __webpack_require__(44724);

/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */

/**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */

/**
 * The locale options.
 */

/**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */

/**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */

/**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */

/**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */

function intlFormat(date, formatOrLocale, localeOptions) {
  let formatOptions;

  if (isFormatOptions(formatOrLocale)) {
    formatOptions = formatOrLocale;
  } else {
    localeOptions = formatOrLocale;
  }

  return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format(
    (0, _index.toDate)(date),
  );
}

function isFormatOptions(opts) {
  return opts !== undefined && !("locale" in opts);
}


/***/ }),

/***/ 91466:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.intlFormatDistance = intlFormatDistance;
var _index = __webpack_require__(53679);

var _index2 = __webpack_require__(45672);
var _index3 = __webpack_require__(96719);
var _index4 = __webpack_require__(66393);
var _index5 = __webpack_require__(25049);
var _index6 = __webpack_require__(85878);
var _index7 = __webpack_require__(39288);
var _index8 = __webpack_require__(56034);
var _index9 = __webpack_require__(9480);
var _index10 = __webpack_require__(44724);

/**
 * The {@link intlFormatDistance} function options.
 */

/**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */

/**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */
function intlFormatDistance(date, baseDate, options) {
  let value = 0;
  let unit;
  const dateLeft = (0, _index10.toDate)(date);
  const dateRight = (0, _index10.toDate)(baseDate);

  if (!options?.unit) {
    // Get the unit based on diffInSeconds calculations if no unit is specified
    const diffInSeconds = (0, _index9.differenceInSeconds)(dateLeft, dateRight); // The smallest unit

    if (Math.abs(diffInSeconds) < _index.secondsInMinute) {
      value = (0, _index9.differenceInSeconds)(dateLeft, dateRight);
      unit = "second";
    } else if (Math.abs(diffInSeconds) < _index.secondsInHour) {
      value = (0, _index8.differenceInMinutes)(dateLeft, dateRight);
      unit = "minute";
    } else if (
      Math.abs(diffInSeconds) < _index.secondsInDay &&
      Math.abs((0, _index2.differenceInCalendarDays)(dateLeft, dateRight)) < 1
    ) {
      value = (0, _index7.differenceInHours)(dateLeft, dateRight);
      unit = "hour";
    } else if (
      Math.abs(diffInSeconds) < _index.secondsInWeek &&
      (value = (0, _index2.differenceInCalendarDays)(dateLeft, dateRight)) &&
      Math.abs(value) < 7
    ) {
      unit = "day";
    } else if (Math.abs(diffInSeconds) < _index.secondsInMonth) {
      value = (0, _index5.differenceInCalendarWeeks)(dateLeft, dateRight);
      unit = "week";
    } else if (Math.abs(diffInSeconds) < _index.secondsInQuarter) {
      value = (0, _index3.differenceInCalendarMonths)(dateLeft, dateRight);
      unit = "month";
    } else if (Math.abs(diffInSeconds) < _index.secondsInYear) {
      if ((0, _index4.differenceInCalendarQuarters)(dateLeft, dateRight) < 4) {
        // To filter out cases that are less than a year but match 4 quarters
        value = (0, _index4.differenceInCalendarQuarters)(dateLeft, dateRight);
        unit = "quarter";
      } else {
        value = (0, _index6.differenceInCalendarYears)(dateLeft, dateRight);
        unit = "year";
      }
    } else {
      value = (0, _index6.differenceInCalendarYears)(dateLeft, dateRight);
      unit = "year";
    }
  } else {
    // Get the value if unit is specified
    unit = options?.unit;
    if (unit === "second") {
      value = (0, _index9.differenceInSeconds)(dateLeft, dateRight);
    } else if (unit === "minute") {
      value = (0, _index8.differenceInMinutes)(dateLeft, dateRight);
    } else if (unit === "hour") {
      value = (0, _index7.differenceInHours)(dateLeft, dateRight);
    } else if (unit === "day") {
      value = (0, _index2.differenceInCalendarDays)(dateLeft, dateRight);
    } else if (unit === "week") {
      value = (0, _index5.differenceInCalendarWeeks)(dateLeft, dateRight);
    } else if (unit === "month") {
      value = (0, _index3.differenceInCalendarMonths)(dateLeft, dateRight);
    } else if (unit === "quarter") {
      value = (0, _index4.differenceInCalendarQuarters)(dateLeft, dateRight);
    } else if (unit === "year") {
      value = (0, _index6.differenceInCalendarYears)(dateLeft, dateRight);
    }
  }

  const rtf = new Intl.RelativeTimeFormat(options?.locale, {
    localeMatcher: options?.localeMatcher,
    numeric: options?.numeric || "auto",
    style: options?.style,
  });

  return rtf.format(value, unit);
}


/***/ }),

/***/ 2129:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isAfter = isAfter;
var _index = __webpack_require__(44724);

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(date, dateToCompare) {
  const _date = (0, _index.toDate)(date);
  const _dateToCompare = (0, _index.toDate)(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}


/***/ }),

/***/ 78:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isBefore = isBefore;
var _index = __webpack_require__(44724);

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(date, dateToCompare) {
  const _date = (0, _index.toDate)(date);
  const _dateToCompare = (0, _index.toDate)(dateToCompare);
  return +_date < +_dateToCompare;
}


/***/ }),

/***/ 43215:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.isDate = isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  return (
    value instanceof Date ||
    (typeof value === "object" &&
      Object.prototype.toString.call(value) === "[object Date]")
  );
}


/***/ }),

/***/ 13195:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isEqual = isEqual;
var _index = __webpack_require__(44724);

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual(leftDate, rightDate) {
  const _dateLeft = (0, _index.toDate)(leftDate);
  const _dateRight = (0, _index.toDate)(rightDate);
  return +_dateLeft === +_dateRight;
}


/***/ }),

/***/ 67500:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.isExists = isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */
function isExists(year, month, day) {
  const date = new Date(year, month, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month &&
    date.getDate() === day
  );
}


/***/ }),

/***/ 11059:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isFirstDayOfMonth = isFirstDayOfMonth;
var _index = __webpack_require__(44724);

/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth(date) {
  return (0, _index.toDate)(date).getDate() === 1;
}


/***/ }),

/***/ 41315:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isFriday = isFriday;
var _index = __webpack_require__(44724);

/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday(date) {
  return (0, _index.toDate)(date).getDay() === 5;
}


/***/ }),

/***/ 87675:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isFuture = isFuture;
var _index = __webpack_require__(44724);

/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture(date) {
  return +(0, _index.toDate)(date) > Date.now();
}


/***/ }),

/***/ 47752:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isLastDayOfMonth = isLastDayOfMonth;
var _index = __webpack_require__(48443);
var _index2 = __webpack_require__(92335);
var _index3 = __webpack_require__(44724);

/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth(date) {
  const _date = (0, _index3.toDate)(date);
  return +(0, _index.endOfDay)(_date) === +(0, _index2.endOfMonth)(_date);
}


/***/ }),

/***/ 7890:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isLeapYear = isLeapYear;
var _index = __webpack_require__(44724);

/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear(date) {
  const _date = (0, _index.toDate)(date);
  const year = _date.getFullYear();
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}


/***/ }),

/***/ 92609:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isMatch = isMatch;
var _index = __webpack_require__(74390);
var _index2 = __webpack_require__(86103);

/**
 * The {@link isMatch} function options.
 */

/**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */
function isMatch(dateStr, formatStr, options) {
  return (0, _index.isValid)(
    (0, _index2.parse)(dateStr, formatStr, new Date(), options),
  );
}


/***/ }),

/***/ 29019:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isMonday = isMonday;
var _index = __webpack_require__(44724);

/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday(date) {
  return (0, _index.toDate)(date).getDay() === 1;
}


/***/ }),

/***/ 29796:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isPast = isPast;
var _index = __webpack_require__(44724);

/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast(date) {
  return +(0, _index.toDate)(date) < Date.now();
}


/***/ }),

/***/ 10098:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameDay = isSameDay;
var _index = __webpack_require__(72274);

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dateLeft, dateRight) {
  const dateLeftStartOfDay = (0, _index.startOfDay)(dateLeft);
  const dateRightStartOfDay = (0, _index.startOfDay)(dateRight);

  return +dateLeftStartOfDay === +dateRightStartOfDay;
}


/***/ }),

/***/ 1421:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameHour = isSameHour;
var _index = __webpack_require__(25281);

/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */
function isSameHour(dateLeft, dateRight) {
  const dateLeftStartOfHour = (0, _index.startOfHour)(dateLeft);
  const dateRightStartOfHour = (0, _index.startOfHour)(dateRight);

  return +dateLeftStartOfHour === +dateRightStartOfHour;
}


/***/ }),

/***/ 14792:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameISOWeek = isSameISOWeek;
var _index = __webpack_require__(89439);

/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */
function isSameISOWeek(dateLeft, dateRight) {
  return (0, _index.isSameWeek)(dateLeft, dateRight, { weekStartsOn: 1 });
}


/***/ }),

/***/ 76551:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameISOWeekYear = isSameISOWeekYear;
var _index = __webpack_require__(85860);

/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */
function isSameISOWeekYear(dateLeft, dateRight) {
  const dateLeftStartOfYear = (0, _index.startOfISOWeekYear)(dateLeft);
  const dateRightStartOfYear = (0, _index.startOfISOWeekYear)(dateRight);

  return +dateLeftStartOfYear === +dateRightStartOfYear;
}


/***/ }),

/***/ 4908:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameMinute = isSameMinute;
var _index = __webpack_require__(52881);

/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */
function isSameMinute(dateLeft, dateRight) {
  const dateLeftStartOfMinute = (0, _index.startOfMinute)(dateLeft);
  const dateRightStartOfMinute = (0, _index.startOfMinute)(dateRight);

  return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}


/***/ }),

/***/ 29548:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameMonth = isSameMonth;
var _index = __webpack_require__(44724);

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dateLeft, dateRight) {
  const _dateLeft = (0, _index.toDate)(dateLeft);
  const _dateRight = (0, _index.toDate)(dateRight);
  return (
    _dateLeft.getFullYear() === _dateRight.getFullYear() &&
    _dateLeft.getMonth() === _dateRight.getMonth()
  );
}


/***/ }),

/***/ 45154:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameQuarter = isSameQuarter;
var _index = __webpack_require__(6831);

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameQuarter(dateLeft, dateRight) {
  const dateLeftStartOfQuarter = (0, _index.startOfQuarter)(dateLeft);
  const dateRightStartOfQuarter = (0, _index.startOfQuarter)(dateRight);

  return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}


/***/ }),

/***/ 81849:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameSecond = isSameSecond;
var _index = __webpack_require__(73320);

/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */
function isSameSecond(dateLeft, dateRight) {
  const dateLeftStartOfSecond = (0, _index.startOfSecond)(dateLeft);
  const dateRightStartOfSecond = (0, _index.startOfSecond)(dateRight);

  return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}


/***/ }),

/***/ 89439:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameWeek = isSameWeek;
var _index = __webpack_require__(83877);

/**
 * The {@link isSameWeek} function options.
 */

/**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameWeek(dateLeft, dateRight, options) {
  const dateLeftStartOfWeek = (0, _index.startOfWeek)(dateLeft, options);
  const dateRightStartOfWeek = (0, _index.startOfWeek)(dateRight, options);

  return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}


/***/ }),

/***/ 55033:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameYear = isSameYear;
var _index = __webpack_require__(44724);

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dateLeft, dateRight) {
  const _dateLeft = (0, _index.toDate)(dateLeft);
  const _dateRight = (0, _index.toDate)(dateRight);
  return _dateLeft.getFullYear() === _dateRight.getFullYear();
}


/***/ }),

/***/ 52365:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSaturday = isSaturday;
var _index = __webpack_require__(44724);

/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday(date) {
  return (0, _index.toDate)(date).getDay() === 6;
}


/***/ }),

/***/ 59136:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSunday = isSunday;
var _index = __webpack_require__(44724);

/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday(date) {
  return (0, _index.toDate)(date).getDay() === 0;
}


/***/ }),

/***/ 88910:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isThisHour = isThisHour;
var _index = __webpack_require__(84244);
var _index2 = __webpack_require__(1421);

/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour(date) {
  return (0, _index2.isSameHour)(date, (0, _index.constructNow)(date));
}


/***/ }),

/***/ 22055:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isThisISOWeek = isThisISOWeek;
var _index = __webpack_require__(84244);
var _index2 = __webpack_require__(14792);

/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */

function isThisISOWeek(date) {
  return (0, _index2.isSameISOWeek)(date, (0, _index.constructNow)(date));
}


/***/ }),

/***/ 12172:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isThisMinute = isThisMinute;
var _index = __webpack_require__(84244);
var _index2 = __webpack_require__(4908);

/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */

function isThisMinute(date) {
  return (0, _index2.isSameMinute)(date, (0, _index.constructNow)(date));
}


/***/ }),

/***/ 83874:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isThisMonth = isThisMonth;
var _index = __webpack_require__(84244);
var _index2 = __webpack_require__(29548);

/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */

function isThisMonth(date) {
  return (0, _index2.isSameMonth)(date, (0, _index.constructNow)(date));
}


/***/ }),

/***/ 27207:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isThisQuarter = isThisQuarter;
var _index = __webpack_require__(84244);
var _index2 = __webpack_require__(45154);

/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter(date) {
  return (0, _index2.isSameQuarter)(date, (0, _index.constructNow)(date));
}


/***/ }),

/***/ 84779:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isThisSecond = isThisSecond;
var _index = __webpack_require__(84244);
var _index2 = __webpack_require__(81849);

/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond(date) {
  return (0, _index2.isSameSecond)(date, (0, _index.constructNow)(date));
}


/***/ }),

/***/ 50450:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isThisWeek = isThisWeek;
var _index = __webpack_require__(84244);
var _index2 = __webpack_require__(89439);

/**
 * The {@link isThisWeek} function options.
 */

/**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */
function isThisWeek(date, options) {
  return (0, _index2.isSameWeek)(date, (0, _index.constructNow)(date), options);
}


/***/ }),

/***/ 2620:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isThisYear = isThisYear;
var _index = __webpack_require__(84244);
var _index2 = __webpack_require__(55033);

/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear(date) {
  return (0, _index2.isSameYear)(date, (0, _index.constructNow)(date));
}


/***/ }),

/***/ 61164:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isThursday = isThursday;
var _index = __webpack_require__(44724);

/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday(date) {
  return (0, _index.toDate)(date).getDay() === 4;
}


/***/ }),

/***/ 62172:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isToday = isToday;
var _index = __webpack_require__(84244);
var _index2 = __webpack_require__(10098);

/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday(date) {
  return (0, _index2.isSameDay)(date, (0, _index.constructNow)(date));
}


/***/ }),

/***/ 30620:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isTomorrow = isTomorrow;
var _index = __webpack_require__(83978);
var _index2 = __webpack_require__(84244);
var _index3 = __webpack_require__(10098);

/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow(date) {
  return (0, _index3.isSameDay)(
    date,
    (0, _index.addDays)((0, _index2.constructNow)(date), 1),
  );
}


/***/ }),

/***/ 99971:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isTuesday = isTuesday;
var _index = __webpack_require__(44724);

/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday(date) {
  return (0, _index.toDate)(date).getDay() === 2;
}


/***/ }),

/***/ 74390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isValid = isValid;
var _index = __webpack_require__(43215);
var _index2 = __webpack_require__(44724);

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(date) {
  if (!(0, _index.isDate)(date) && typeof date !== "number") {
    return false;
  }
  const _date = (0, _index2.toDate)(date);
  return !isNaN(Number(_date));
}


/***/ }),

/***/ 41185:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isWednesday = isWednesday;
var _index = __webpack_require__(44724);

/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday(date) {
  return (0, _index.toDate)(date).getDay() === 3;
}


/***/ }),

/***/ 60991:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isWeekend = isWeekend;
var _index = __webpack_require__(44724);

/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend(date) {
  const day = (0, _index.toDate)(date).getDay();
  return day === 0 || day === 6;
}


/***/ }),

/***/ 18901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isWithinInterval = isWithinInterval;
var _index = __webpack_require__(44724);

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */
function isWithinInterval(date, interval) {
  const time = +(0, _index.toDate)(date);
  const [startTime, endTime] = [
    +(0, _index.toDate)(interval.start),
    +(0, _index.toDate)(interval.end),
  ].sort((a, b) => a - b);

  return time >= startTime && time <= endTime;
}


/***/ }),

/***/ 38956:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isYesterday = isYesterday;
var _index = __webpack_require__(84244);
var _index2 = __webpack_require__(10098);
var _index3 = __webpack_require__(86584);

/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday(date) {
  return (0, _index2.isSameDay)(
    date,
    (0, _index3.subDays)((0, _index.constructNow)(date), 1),
  );
}


/***/ }),

/***/ 36542:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.lastDayOfDecade = lastDayOfDecade;
var _index = __webpack_require__(44724);

/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */
function lastDayOfDecade(date) {
  // TODO: Switch to more technical definition in of decades that start with 1
  // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
  // change, so it can only be done in 4.0.
  const _date = (0, _index.toDate)(date);
  const year = _date.getFullYear();
  const decade = 9 + Math.floor(year / 10) * 10;
  _date.setFullYear(decade + 1, 0, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 9816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.lastDayOfISOWeek = lastDayOfISOWeek;
var _index = __webpack_require__(17376);

/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek(date) {
  return (0, _index.lastDayOfWeek)(date, { weekStartsOn: 1 });
}


/***/ }),

/***/ 50587:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.lastDayOfISOWeekYear = lastDayOfISOWeekYear;
var _index = __webpack_require__(95303);
var _index2 = __webpack_require__(89301);
var _index3 = __webpack_require__(4589);

/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOWeekYear(date) {
  const year = (0, _index.getISOWeekYear)(date);
  const fourthOfJanuary = (0, _index3.constructFrom)(date, 0);
  fourthOfJanuary.setFullYear(year + 1, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  const _date = (0, _index2.startOfISOWeek)(fourthOfJanuary);
  _date.setDate(_date.getDate() - 1);
  return _date;
}


/***/ }),

/***/ 85226:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.lastDayOfMonth = lastDayOfMonth;
var _index = __webpack_require__(44724);

/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth(date) {
  const _date = (0, _index.toDate)(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 82013:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.lastDayOfQuarter = lastDayOfQuarter;
var _index = __webpack_require__(44724);

/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter(date) {
  const _date = (0, _index.toDate)(date);
  const currentMonth = _date.getMonth();
  const month = currentMonth - (currentMonth % 3) + 3;
  _date.setMonth(month, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 17376:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.lastDayOfWeek = lastDayOfWeek;
var _index = __webpack_require__(44724);

var _index2 = __webpack_require__(92949);

/**
 * The {@link lastDayOfWeek} function options.
 */

/**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek(date, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0, _index.toDate)(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);

  _date.setHours(0, 0, 0, 0);
  _date.setDate(_date.getDate() + diff);
  return _date;
}


/***/ }),

/***/ 66199:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.lastDayOfYear = lastDayOfYear;
var _index = __webpack_require__(44724);

/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear(date) {
  const _date = (0, _index.toDate)(date);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 10905:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.lightFormat = lightFormat;
Object.defineProperty(exports, "lightFormatters", ({
  enumerable: true,
  get: function () {
    return _index3.lightFormatters;
  },
}));
var _index = __webpack_require__(74390);
var _index2 = __webpack_require__(44724);
var _index3 = __webpack_require__(56808);

// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874

// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @private
 */

/**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */
function lightFormat(date, formatStr) {
  const _date = (0, _index2.toDate)(date);

  if (!(0, _index.isValid)(_date)) {
    throw new RangeError("Invalid time value");
  }

  const tokens = formatStr.match(formattingTokensRegExp);

  // The only case when formattingTokensRegExp doesn't match the string is when it's empty
  if (!tokens) return "";

  const result = tokens
    .map((substring) => {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return "'";
      }

      const firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return cleanEscapedString(substring);
      }

      const formatter = _index3.lightFormatters[firstCharacter];
      if (formatter) {
        return formatter(_date, substring);
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      return substring;
    })
    .join("");

  return result;
}

function cleanEscapedString(input) {
  const matches = input.match(escapedStringRegExp);

  if (!matches) {
    return input;
  }

  return matches[1].replace(doubleQuoteRegExp, "'");
}


/***/ }),

/***/ 36938:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.buildFormatLongFn = buildFormatLongFn;

function buildFormatLongFn(args) {
  return (options = {}) => {
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}


/***/ }),

/***/ 60205:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.buildLocalizeFn = buildLocalizeFn; /* eslint-disable no-unused-vars */

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";

    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;

      valuesArray =
        args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}


/***/ }),

/***/ 68649:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.buildMatchFn = buildMatchFn;

function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;

    const matchPattern =
      (width && args.matchPatterns[width]) ||
      args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];

    const parsePatterns =
      (width && args.parsePatterns[width]) ||
      args.parsePatterns[args.defaultParseWidth];

    const key = Array.isArray(parsePatterns)
      ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString))
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        findKey(parsePatterns, (pattern) => pattern.test(matchedString));

    let value;

    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        options.valueCallback(value)
      : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

function findKey(object, predicate) {
  for (const key in object) {
    if (
      Object.prototype.hasOwnProperty.call(object, key) &&
      predicate(object[key])
    ) {
      return key;
    }
  }
  return undefined;
}

function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}


/***/ }),

/***/ 5479:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.buildMatchPatternFn = buildMatchPatternFn;

function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];

    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback
      ? args.valueCallback(parseResult[0])
      : parseResult[0];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}


/***/ }),

/***/ 21332:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.enUS = void 0;
var _index = __webpack_require__(57683);
var _index2 = __webpack_require__(17682);
var _index3 = __webpack_require__(86109);
var _index4 = __webpack_require__(39028);
var _index5 = __webpack_require__(85658);

/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const enUS = (exports.enUS = {
  code: "en-US",
  formatDistance: _index.formatDistance,
  formatLong: _index2.formatLong,
  formatRelative: _index3.formatRelative,
  localize: _index4.localize,
  match: _index5.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});


/***/ }),

/***/ 57683:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.formatDistance = void 0;

const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds",
  },

  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds",
  },

  halfAMinute: "half a minute",

  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes",
  },

  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours",
  },

  xHours: {
    one: "1 hour",
    other: "{{count}} hours",
  },

  xDays: {
    one: "1 day",
    other: "{{count}} days",
  },

  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks",
  },

  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months",
  },

  xMonths: {
    one: "1 month",
    other: "{{count}} months",
  },

  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years",
  },

  xYears: {
    one: "1 year",
    other: "{{count}} years",
  },

  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years",
  },

  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years",
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }

  return result;
};
exports.formatDistance = formatDistance;


/***/ }),

/***/ 17682:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatLong = void 0;
var _index = __webpack_require__(36938);

const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong = (exports.formatLong = {
  date: (0, _index.buildFormatLongFn)({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: (0, _index.buildFormatLongFn)({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: (0, _index.buildFormatLongFn)({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
});


/***/ }),

/***/ 86109:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.formatRelative = void 0;

const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) =>
  formatRelativeLocale[token];
exports.formatRelative = formatRelative;


/***/ }),

/***/ 39028:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.localize = void 0;
var _index = __webpack_require__(60205);

const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
};

const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
};

const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};

const localize = (exports.localize = {
  ordinalNumber,

  era: (0, _index.buildLocalizeFn)({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: (0, _index.buildLocalizeFn)({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index.buildLocalizeFn)({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: (0, _index.buildLocalizeFn)({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index.buildLocalizeFn)({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
});


/***/ }),

/***/ 85658:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.match = void 0;

var _index = __webpack_require__(68649);
var _index2 = __webpack_require__(5479);

const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i,
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

const match = (exports.match = {
  ordinalNumber: (0, _index2.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index.buildMatchFn)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index.buildMatchFn)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index.buildMatchFn)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: (0, _index.buildMatchFn)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
});


/***/ }),

/***/ 25518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.max = max;
var _index = __webpack_require__(44724);

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max(dates) {
  let result;
  dates.forEach(function (dirtyDate) {
    const currentDate = (0, _index.toDate)(dirtyDate);

    if (
      result === undefined ||
      result < currentDate ||
      isNaN(Number(currentDate))
    ) {
      result = currentDate;
    }
  });

  return result || new Date(NaN);
}


/***/ }),

/***/ 37180:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.milliseconds = milliseconds;
var _index = __webpack_require__(53679);

/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */
function milliseconds({ years, months, weeks, days, hours, minutes, seconds }) {
  let totalDays = 0;

  if (years) totalDays += years * _index.daysInYear;
  if (months) totalDays += months * (_index.daysInYear / 12);
  if (weeks) totalDays += weeks * 7;
  if (days) totalDays += days;

  let totalSeconds = totalDays * 24 * 60 * 60;

  if (hours) totalSeconds += hours * 60 * 60;
  if (minutes) totalSeconds += minutes * 60;
  if (seconds) totalSeconds += seconds;

  return Math.trunc(totalSeconds * 1000);
}


/***/ }),

/***/ 29304:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.millisecondsToHours = millisecondsToHours;
var _index = __webpack_require__(53679);

/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */
function millisecondsToHours(milliseconds) {
  const hours = milliseconds / _index.millisecondsInHour;
  return Math.trunc(hours);
}


/***/ }),

/***/ 77114:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.millisecondsToMinutes = millisecondsToMinutes;
var _index = __webpack_require__(53679);

/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */
function millisecondsToMinutes(milliseconds) {
  const minutes = milliseconds / _index.millisecondsInMinute;
  return Math.trunc(minutes);
}


/***/ }),

/***/ 30634:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.millisecondsToSeconds = millisecondsToSeconds;
var _index = __webpack_require__(53679);

/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */
function millisecondsToSeconds(milliseconds) {
  const seconds = milliseconds / _index.millisecondsInSecond;
  return Math.trunc(seconds);
}


/***/ }),

/***/ 55463:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.min = min;
var _index = __webpack_require__(44724);

/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min(dates) {
  let result;

  dates.forEach((dirtyDate) => {
    const date = (0, _index.toDate)(dirtyDate);
    if (!result || result > date || isNaN(+date)) {
      result = date;
    }
  });

  return result || new Date(NaN);
}


/***/ }),

/***/ 82023:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.minutesToHours = minutesToHours;
var _index = __webpack_require__(53679);

/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */
function minutesToHours(minutes) {
  const hours = minutes / _index.minutesInHour;
  return Math.trunc(hours);
}


/***/ }),

/***/ 94621:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.minutesToMilliseconds = minutesToMilliseconds;
var _index = __webpack_require__(53679);

/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */
function minutesToMilliseconds(minutes) {
  return Math.trunc(minutes * _index.millisecondsInMinute);
}


/***/ }),

/***/ 63667:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.minutesToSeconds = minutesToSeconds;
var _index = __webpack_require__(53679);

/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */
function minutesToSeconds(minutes) {
  return Math.trunc(minutes * _index.secondsInMinute);
}


/***/ }),

/***/ 22305:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.monthsToQuarters = monthsToQuarters;
var _index = __webpack_require__(53679);

/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */
function monthsToQuarters(months) {
  const quarters = months / _index.monthsInQuarter;
  return Math.trunc(quarters);
}


/***/ }),

/***/ 14999:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.monthsToYears = monthsToYears;
var _index = __webpack_require__(53679);

/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */
function monthsToYears(months) {
  const years = months / _index.monthsInYear;
  return Math.trunc(years);
}


/***/ }),

/***/ 98495:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.nextDay = nextDay;
var _index = __webpack_require__(83978);
var _index2 = __webpack_require__(49288);

/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */
function nextDay(date, day) {
  let delta = day - (0, _index2.getDay)(date);
  if (delta <= 0) delta += 7;

  return (0, _index.addDays)(date, delta);
}


/***/ }),

/***/ 93059:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.nextFriday = nextFriday;
var _index = __webpack_require__(98495);

/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */
function nextFriday(date) {
  return (0, _index.nextDay)(date, 5);
}


/***/ }),

/***/ 50486:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.nextMonday = nextMonday;
var _index = __webpack_require__(98495);

/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */
function nextMonday(date) {
  return (0, _index.nextDay)(date, 1);
}


/***/ }),

/***/ 84623:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.nextSaturday = nextSaturday;
var _index = __webpack_require__(98495);

/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */
function nextSaturday(date) {
  return (0, _index.nextDay)(date, 6);
}


/***/ }),

/***/ 53847:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.nextSunday = nextSunday;
var _index = __webpack_require__(98495);

/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */
function nextSunday(date) {
  return (0, _index.nextDay)(date, 0);
}


/***/ }),

/***/ 19082:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.nextThursday = nextThursday;
var _index = __webpack_require__(98495);

/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */
function nextThursday(date) {
  return (0, _index.nextDay)(date, 4);
}


/***/ }),

/***/ 46232:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.nextTuesday = nextTuesday;
var _index = __webpack_require__(98495);

/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */
function nextTuesday(date) {
  return (0, _index.nextDay)(date, 2);
}


/***/ }),

/***/ 137:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.nextWednesday = nextWednesday;
var _index = __webpack_require__(98495);

/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */
function nextWednesday(date) {
  return (0, _index.nextDay)(date, 3);
}


/***/ }),

/***/ 86103:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "longFormatters", ({
  enumerable: true,
  get: function () {
    return _index5.longFormatters;
  },
}));
exports.parse = parse;
Object.defineProperty(exports, "parsers", ({
  enumerable: true,
  get: function () {
    return _index7.parsers;
  },
}));
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(63453);
var _index3 = __webpack_require__(2015);
var _index4 = __webpack_require__(44724);

var _index5 = __webpack_require__(43191);
var _index6 = __webpack_require__(97963);

var _index7 = __webpack_require__(2158);

var _Setter = __webpack_require__(98082);

// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874

/**
 * The {@link parse} function options.
 */

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;

const notWhitespaceRegExp = /\S/;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(dateStr, formatStr, referenceDate, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index3.defaultLocale;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  if (formatStr === "") {
    if (dateStr === "") {
      return (0, _index4.toDate)(referenceDate);
    } else {
      return (0, _index.constructFrom)(referenceDate, NaN);
    }
  }

  const subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  // If timezone isn't specified, it will be set to the system timezone
  const setters = [new _Setter.DateToSystemTimezoneSetter()];

  const tokens = formatStr
    .match(longFormattingTokensRegExp)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter in _index5.longFormatters) {
        const longFormatter = _index5.longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp);

  const usedTokens = [];

  for (let token of tokens) {
    if (
      !options?.useAdditionalWeekYearTokens &&
      (0, _index6.isProtectedWeekYearToken)(token)
    ) {
      (0, _index6.warnOrThrowProtectedError)(token, formatStr, dateStr);
    }
    if (
      !options?.useAdditionalDayOfYearTokens &&
      (0, _index6.isProtectedDayOfYearToken)(token)
    ) {
      (0, _index6.warnOrThrowProtectedError)(token, formatStr, dateStr);
    }

    const firstCharacter = token[0];
    const parser = _index7.parsers[firstCharacter];
    if (parser) {
      const { incompatibleTokens } = parser;
      if (Array.isArray(incompatibleTokens)) {
        const incompatibleToken = usedTokens.find(
          (usedToken) =>
            incompatibleTokens.includes(usedToken.token) ||
            usedToken.token === firstCharacter,
        );
        if (incompatibleToken) {
          throw new RangeError(
            `The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`,
          );
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError(
          `The format string mustn't contain \`${token}\` and any other token at the same time`,
        );
      }

      usedTokens.push({ token: firstCharacter, fullToken: token });

      const parseResult = parser.run(
        dateStr,
        token,
        locale.match,
        subFnOptions,
      );

      if (!parseResult) {
        return (0, _index.constructFrom)(referenceDate, NaN);
      }

      setters.push(parseResult.setter);

      dateStr = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      // Replace two single quote characters with one single quote character
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      }

      // Cut token from string, or, if string doesn't match the token, return Invalid Date
      if (dateStr.indexOf(token) === 0) {
        dateStr = dateStr.slice(token.length);
      } else {
        return (0, _index.constructFrom)(referenceDate, NaN);
      }
    }
  }

  // Check if the remaining input contains something other than whitespace
  if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) {
    return (0, _index.constructFrom)(referenceDate, NaN);
  }

  const uniquePrioritySetters = setters
    .map((setter) => setter.priority)
    .sort((a, b) => b - a)
    .filter((priority, index, array) => array.indexOf(priority) === index)
    .map((priority) =>
      setters
        .filter((setter) => setter.priority === priority)
        .sort((a, b) => b.subPriority - a.subPriority),
    )
    .map((setterArray) => setterArray[0]);

  let date = (0, _index4.toDate)(referenceDate);

  if (isNaN(date.getTime())) {
    return (0, _index.constructFrom)(referenceDate, NaN);
  }

  const flags = {};
  for (const setter of uniquePrioritySetters) {
    if (!setter.validate(date, subFnOptions)) {
      return (0, _index.constructFrom)(referenceDate, NaN);
    }

    const result = setter.set(date, flags, subFnOptions);
    // Result is tuple (date, flags)
    if (Array.isArray(result)) {
      date = result[0];
      Object.assign(flags, result[1]);
      // Result is date
    } else {
      date = result;
    }
  }

  return (0, _index.constructFrom)(referenceDate, date);
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}


/***/ }),

/***/ 95245:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.Parser = void 0;
var _Setter = __webpack_require__(98082);

class Parser {
  run(dateString, token, match, options) {
    const result = this.parse(dateString, token, match, options);
    if (!result) {
      return null;
    }

    return {
      setter: new _Setter.ValueSetter(
        result.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority,
      ),
      rest: result.rest,
    };
  }

  validate(_utcDate, _value, _options) {
    return true;
  }
}
exports.Parser = Parser;


/***/ }),

/***/ 98082:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ValueSetter =
  exports.Setter =
  exports.DateToSystemTimezoneSetter =
    void 0;
var _index = __webpack_require__(46225);
var _index2 = __webpack_require__(4589);

const TIMEZONE_UNIT_PRIORITY = 10;

class Setter {
  subPriority = 0;

  validate(_utcDate, _options) {
    return true;
  }
}
exports.Setter = Setter;

class ValueSetter extends Setter {
  constructor(
    value,

    validateValue,

    setValue,

    priority,
    subPriority,
  ) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }

  validate(date, options) {
    return this.validateValue(date, this.value, options);
  }

  set(date, flags, options) {
    return this.setValue(date, flags, this.value, options);
  }
}
exports.ValueSetter = ValueSetter;

class DateToSystemTimezoneSetter extends Setter {
  priority = TIMEZONE_UNIT_PRIORITY;
  subPriority = -1;
  set(date, flags) {
    if (flags.timestampIsSet) return date;
    return (0, _index2.constructFrom)(date, (0, _index.transpose)(date, Date));
  }
}
exports.DateToSystemTimezoneSetter = DateToSystemTimezoneSetter;


/***/ }),

/***/ 53322:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.timezonePatterns = exports.numericPatterns = void 0;
const numericPatterns = (exports.numericPatterns = {
  month: /^(1[0-2]|0?\d)/, // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/, // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/, // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/, // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/, // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/, // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/, // 0 to 12
  minute: /^[0-5]?\d/, // 0 to 59
  second: /^[0-5]?\d/, // 0 to 59

  singleDigit: /^\d/, // 0 to 9
  twoDigits: /^\d{1,2}/, // 0 to 99
  threeDigits: /^\d{1,3}/, // 0 to 999
  fourDigits: /^\d{1,4}/, // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/, // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/, // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/, // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/, // 0 to 9999, -0 to -9999
});

const timezonePatterns = (exports.timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/,
});


/***/ }),

/***/ 2158:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.parsers = void 0;
var _EraParser = __webpack_require__(83921);
var _YearParser = __webpack_require__(60731);
var _LocalWeekYearParser = __webpack_require__(71708);
var _ISOWeekYearParser = __webpack_require__(37124);
var _ExtendedYearParser = __webpack_require__(26387);
var _QuarterParser = __webpack_require__(54196);
var _StandAloneQuarterParser = __webpack_require__(67864);
var _MonthParser = __webpack_require__(29795);
var _StandAloneMonthParser = __webpack_require__(81336);
var _LocalWeekParser = __webpack_require__(51348);
var _ISOWeekParser = __webpack_require__(77073);
var _DateParser = __webpack_require__(83197);
var _DayOfYearParser = __webpack_require__(4711);
var _DayParser = __webpack_require__(32001);
var _LocalDayParser = __webpack_require__(26469);
var _StandAloneLocalDayParser = __webpack_require__(11655);
var _ISODayParser = __webpack_require__(99838);
var _AMPMParser = __webpack_require__(49990);
var _AMPMMidnightParser = __webpack_require__(93953);
var _DayPeriodParser = __webpack_require__(14748);
var _Hour1to12Parser = __webpack_require__(54864);
var _Hour0to23Parser = __webpack_require__(98882);
var _Hour0To11Parser = __webpack_require__(16677);
var _Hour1To24Parser = __webpack_require__(75097);
var _MinuteParser = __webpack_require__(96734);
var _SecondParser = __webpack_require__(95043);
var _FractionOfSecondParser = __webpack_require__(43588);
var _ISOTimezoneWithZParser = __webpack_require__(73748);
var _ISOTimezoneParser = __webpack_require__(19205);
var _TimestampSecondsParser = __webpack_require__(40668);
var _TimestampMillisecondsParser = __webpack_require__(34874);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const parsers = (exports.parsers = {
  G: new _EraParser.EraParser(),
  y: new _YearParser.YearParser(),
  Y: new _LocalWeekYearParser.LocalWeekYearParser(),
  R: new _ISOWeekYearParser.ISOWeekYearParser(),
  u: new _ExtendedYearParser.ExtendedYearParser(),
  Q: new _QuarterParser.QuarterParser(),
  q: new _StandAloneQuarterParser.StandAloneQuarterParser(),
  M: new _MonthParser.MonthParser(),
  L: new _StandAloneMonthParser.StandAloneMonthParser(),
  w: new _LocalWeekParser.LocalWeekParser(),
  I: new _ISOWeekParser.ISOWeekParser(),
  d: new _DateParser.DateParser(),
  D: new _DayOfYearParser.DayOfYearParser(),
  E: new _DayParser.DayParser(),
  e: new _LocalDayParser.LocalDayParser(),
  c: new _StandAloneLocalDayParser.StandAloneLocalDayParser(),
  i: new _ISODayParser.ISODayParser(),
  a: new _AMPMParser.AMPMParser(),
  b: new _AMPMMidnightParser.AMPMMidnightParser(),
  B: new _DayPeriodParser.DayPeriodParser(),
  h: new _Hour1to12Parser.Hour1to12Parser(),
  H: new _Hour0to23Parser.Hour0to23Parser(),
  K: new _Hour0To11Parser.Hour0To11Parser(),
  k: new _Hour1To24Parser.Hour1To24Parser(),
  m: new _MinuteParser.MinuteParser(),
  s: new _SecondParser.SecondParser(),
  S: new _FractionOfSecondParser.FractionOfSecondParser(),
  X: new _ISOTimezoneWithZParser.ISOTimezoneWithZParser(),
  x: new _ISOTimezoneParser.ISOTimezoneParser(),
  t: new _TimestampSecondsParser.TimestampSecondsParser(),
  T: new _TimestampMillisecondsParser.TimestampMillisecondsParser(),
});


/***/ }),

/***/ 93953:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.AMPMMidnightParser = void 0;
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class AMPMMidnightParser extends _Parser.Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "b":
      case "bb":
      case "bbb":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "bbbbb":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
exports.AMPMMidnightParser = AMPMMidnightParser;


/***/ }),

/***/ 49990:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.AMPMParser = void 0;
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class AMPMParser extends _Parser.Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "a":
      case "aa":
      case "aaa":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "aaaaa":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
exports.AMPMParser = AMPMParser;


/***/ }),

/***/ 83197:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.DateParser = void 0;
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const DAYS_IN_MONTH_LEAP_YEAR = [
  31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
];

// Day of the month
class DateParser extends _Parser.Parser {
  priority = 90;
  subPriority = 1;

  parse(dateString, token, match) {
    switch (token) {
      case "d":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.date,
          dateString,
        );
      case "do":
        return match.ordinalNumber(dateString, { unit: "date" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear = (0, _utils.isLeapYearIndex)(year);
    const month = date.getMonth();
    if (isLeapYear) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
  }

  set(date, _flags, value) {
    date.setDate(value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.DateParser = DateParser;


/***/ }),

/***/ 4711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.DayOfYearParser = void 0;
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class DayOfYearParser extends _Parser.Parser {
  priority = 90;

  subpriority = 1;

  parse(dateString, token, match) {
    switch (token) {
      case "D":
      case "DD":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.dayOfYear,
          dateString,
        );
      case "Do":
        return match.ordinalNumber(dateString, { unit: "date" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear = (0, _utils.isLeapYearIndex)(year);
    if (isLeapYear) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }

  set(date, _flags, value) {
    date.setMonth(0, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.DayOfYearParser = DayOfYearParser;


/***/ }),

/***/ 32001:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.DayParser = void 0;
var _index = __webpack_require__(4729);
var _Parser = __webpack_require__(95245);

// Day of week
class DayParser extends _Parser.Parser {
  priority = 90;

  parse(dateString, token, match) {
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // T
      case "EEEEE":
        return match.day(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return (
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // Tuesday
      case "EEEE":
      default:
        return (
          match.day(dateString, { width: "wide", context: "formatting" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = (0, _index.setDay)(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
exports.DayParser = DayParser;


/***/ }),

/***/ 14748:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.DayPeriodParser = void 0;
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

// in the morning, in the afternoon, in the evening, at night
class DayPeriodParser extends _Parser.Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "BBBBB":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "t", "T"];
}
exports.DayPeriodParser = DayPeriodParser;


/***/ }),

/***/ 83921:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.EraParser = void 0;

var _Parser = __webpack_require__(95245);

class EraParser extends _Parser.Parser {
  priority = 140;

  parse(dateString, token, match) {
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return (
          match.era(dateString, { width: "abbreviated" }) ||
          match.era(dateString, { width: "narrow" })
        );

      // A, B
      case "GGGGG":
        return match.era(dateString, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return (
          match.era(dateString, { width: "wide" }) ||
          match.era(dateString, { width: "abbreviated" }) ||
          match.era(dateString, { width: "narrow" })
        );
    }
  }

  set(date, flags, value) {
    flags.era = value;
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["R", "u", "t", "T"];
}
exports.EraParser = EraParser;


/***/ }),

/***/ 26387:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ExtendedYearParser = void 0;
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class ExtendedYearParser extends _Parser.Parser {
  priority = 130;

  parse(dateString, token) {
    if (token === "u") {
      return (0, _utils.parseNDigitsSigned)(4, dateString);
    }

    return (0, _utils.parseNDigitsSigned)(token.length, dateString);
  }

  set(date, _flags, value) {
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
exports.ExtendedYearParser = ExtendedYearParser;


/***/ }),

/***/ 43588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.FractionOfSecondParser = void 0;
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class FractionOfSecondParser extends _Parser.Parser {
  priority = 30;

  parse(dateString, token) {
    const valueCallback = (value) =>
      Math.trunc(value * Math.pow(10, -token.length + 3));
    return (0, _utils.mapValue)(
      (0, _utils.parseNDigits)(token.length, dateString),
      valueCallback,
    );
  }

  set(date, _flags, value) {
    date.setMilliseconds(value);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}
exports.FractionOfSecondParser = FractionOfSecondParser;


/***/ }),

/***/ 16677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.Hour0To11Parser = void 0;
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class Hour0To11Parser extends _Parser.Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "K":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.hour11h,
          dateString,
        );
      case "Ko":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }

  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
exports.Hour0To11Parser = Hour0To11Parser;


/***/ }),

/***/ 98882:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.Hour0to23Parser = void 0;
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class Hour0to23Parser extends _Parser.Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "H":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.hour23h,
          dateString,
        );
      case "Ho":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 23;
  }

  set(date, _flags, value) {
    date.setHours(value, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
exports.Hour0to23Parser = Hour0to23Parser;


/***/ }),

/***/ 75097:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.Hour1To24Parser = void 0;
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class Hour1To24Parser extends _Parser.Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "k":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.hour24h,
          dateString,
        );
      case "ko":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 24;
  }

  set(date, _flags, value) {
    const hours = value <= 24 ? value % 24 : value;
    date.setHours(hours, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
exports.Hour1To24Parser = Hour1To24Parser;


/***/ }),

/***/ 54864:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.Hour1to12Parser = void 0;
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class Hour1to12Parser extends _Parser.Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "h":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.hour12h,
          dateString,
        );
      case "ho":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 12;
  }

  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date.setHours(0, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }

  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
exports.Hour1to12Parser = Hour1to12Parser;


/***/ }),

/***/ 99838:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ISODayParser = void 0;
var _index = __webpack_require__(70337);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

// ISO day of week
class ISODayParser extends _Parser.Parser {
  priority = 90;

  parse(dateString, token, match) {
    const valueCallback = (value) => {
      if (value === 0) {
        return 7;
      }
      return value;
    };

    switch (token) {
      // 2
      case "i":
      case "ii": // 02
        return (0, _utils.parseNDigits)(token.length, dateString);
      // 2nd
      case "io":
        return match.ordinalNumber(dateString, { unit: "day" });
      // Tue
      case "iii":
        return (0, _utils.mapValue)(
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "short",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
      // T
      case "iiiii":
        return (0, _utils.mapValue)(
          match.day(dateString, {
            width: "narrow",
            context: "formatting",
          }),
          valueCallback,
        );
      // Tu
      case "iiiiii":
        return (0, _utils.mapValue)(
          match.day(dateString, {
            width: "short",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
      // Tuesday
      case "iiii":
      default:
        return (0, _utils.mapValue)(
          match.day(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "abbreviated",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "short",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 7;
  }

  set(date, _flags, value) {
    date = (0, _index.setISODay)(date, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.ISODayParser = ISODayParser;


/***/ }),

/***/ 19205:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ISOTimezoneParser = void 0;
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(1527);
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

// Timezone (ISO-8601)
class ISOTimezoneParser extends _Parser.Parser {
  priority = 10;

  parse(dateString, token) {
    switch (token) {
      case "x":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.basicOptionalMinutes,
          dateString,
        );
      case "xx":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.basic,
          dateString,
        );
      case "xxxx":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.basicOptionalSeconds,
          dateString,
        );
      case "xxxxx":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.extendedOptionalSeconds,
          dateString,
        );
      case "xxx":
      default:
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.extended,
          dateString,
        );
    }
  }

  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return (0, _index.constructFrom)(
      date,
      date.getTime() -
        (0, _index2.getTimezoneOffsetInMilliseconds)(date) -
        value,
    );
  }

  incompatibleTokens = ["t", "T", "X"];
}
exports.ISOTimezoneParser = ISOTimezoneParser;


/***/ }),

/***/ 73748:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ISOTimezoneWithZParser = void 0;
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(1527);
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

// Timezone (ISO-8601. +00:00 is `'Z'`)
class ISOTimezoneWithZParser extends _Parser.Parser {
  priority = 10;

  parse(dateString, token) {
    switch (token) {
      case "X":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.basicOptionalMinutes,
          dateString,
        );
      case "XX":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.basic,
          dateString,
        );
      case "XXXX":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.basicOptionalSeconds,
          dateString,
        );
      case "XXXXX":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.extendedOptionalSeconds,
          dateString,
        );
      case "XXX":
      default:
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.extended,
          dateString,
        );
    }
  }

  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return (0, _index.constructFrom)(
      date,
      date.getTime() -
        (0, _index2.getTimezoneOffsetInMilliseconds)(date) -
        value,
    );
  }

  incompatibleTokens = ["t", "T", "x"];
}
exports.ISOTimezoneWithZParser = ISOTimezoneWithZParser;


/***/ }),

/***/ 77073:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ISOWeekParser = void 0;
var _index = __webpack_require__(70596);
var _index2 = __webpack_require__(89301);
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

// ISO week of year
class ISOWeekParser extends _Parser.Parser {
  priority = 100;

  parse(dateString, token, match) {
    switch (token) {
      case "I":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.week,
          dateString,
        );
      case "Io":
        return match.ordinalNumber(dateString, { unit: "week" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 53;
  }

  set(date, _flags, value) {
    return (0, _index2.startOfISOWeek)((0, _index.setISOWeek)(date, value));
  }

  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.ISOWeekParser = ISOWeekParser;


/***/ }),

/***/ 37124:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ISOWeekYearParser = void 0;
var _index = __webpack_require__(89301);
var _index2 = __webpack_require__(4589);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

// ISO week-numbering year
class ISOWeekYearParser extends _Parser.Parser {
  priority = 130;

  parse(dateString, token) {
    if (token === "R") {
      return (0, _utils.parseNDigitsSigned)(4, dateString);
    }

    return (0, _utils.parseNDigitsSigned)(token.length, dateString);
  }

  set(date, _flags, value) {
    const firstWeekOfYear = (0, _index2.constructFrom)(date, 0);
    firstWeekOfYear.setFullYear(value, 0, 4);
    firstWeekOfYear.setHours(0, 0, 0, 0);
    return (0, _index.startOfISOWeek)(firstWeekOfYear);
  }

  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.ISOWeekYearParser = ISOWeekYearParser;


/***/ }),

/***/ 26469:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.LocalDayParser = void 0;
var _index = __webpack_require__(4729);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

// Local day of week
class LocalDayParser extends _Parser.Parser {
  priority = 90;
  parse(dateString, token, match, options) {
    const valueCallback = (value) => {
      // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return ((value + options.weekStartsOn + 6) % 7) + wholeWeekDays;
    };

    switch (token) {
      // 3
      case "e":
      case "ee": // 03
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(token.length, dateString),
          valueCallback,
        );
      // 3rd
      case "eo":
        return (0, _utils.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "day",
          }),
          valueCallback,
        );
      // Tue
      case "eee":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // T
      case "eeeee":
        return match.day(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return (
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // Tuesday
      case "eeee":
      default:
        return (
          match.day(dateString, { width: "wide", context: "formatting" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = (0, _index.setDay)(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T",
  ];
}
exports.LocalDayParser = LocalDayParser;


/***/ }),

/***/ 51348:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.LocalWeekParser = void 0;
var _index = __webpack_require__(52561);
var _index2 = __webpack_require__(83877);
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

// Local week of year
class LocalWeekParser extends _Parser.Parser {
  priority = 100;

  parse(dateString, token, match) {
    switch (token) {
      case "w":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.week,
          dateString,
        );
      case "wo":
        return match.ordinalNumber(dateString, { unit: "week" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 53;
  }

  set(date, _flags, value, options) {
    return (0, _index2.startOfWeek)(
      (0, _index.setWeek)(date, value, options),
      options,
    );
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T",
  ];
}
exports.LocalWeekParser = LocalWeekParser;


/***/ }),

/***/ 71708:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.LocalWeekYearParser = void 0;
var _index = __webpack_require__(38180);

var _index2 = __webpack_require__(83877);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

// Local week-numbering year
class LocalWeekYearParser extends _Parser.Parser {
  priority = 130;

  parse(dateString, token, match) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "YY",
    });

    switch (token) {
      case "Y":
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(4, dateString),
          valueCallback,
        );
      case "Yo":
        return (0, _utils.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "year",
          }),
          valueCallback,
        );
      default:
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(token.length, dateString),
          valueCallback,
        );
    }
  }

  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }

  set(date, flags, value, options) {
    const currentYear = (0, _index.getWeekYear)(date, options);

    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(
        value.year,
        currentYear,
      );
      date.setFullYear(
        normalizedTwoDigitYear,
        0,
        options.firstWeekContainsDate,
      );
      date.setHours(0, 0, 0, 0);
      return (0, _index2.startOfWeek)(date, options);
    }

    const year =
      !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, options.firstWeekContainsDate);
    date.setHours(0, 0, 0, 0);
    return (0, _index2.startOfWeek)(date, options);
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T",
  ];
}
exports.LocalWeekYearParser = LocalWeekYearParser;


/***/ }),

/***/ 96734:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.MinuteParser = void 0;
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class MinuteParser extends _Parser.Parser {
  priority = 60;

  parse(dateString, token, match) {
    switch (token) {
      case "m":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.minute,
          dateString,
        );
      case "mo":
        return match.ordinalNumber(dateString, { unit: "minute" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 59;
  }

  set(date, _flags, value) {
    date.setMinutes(value, 0, 0);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}
exports.MinuteParser = MinuteParser;


/***/ }),

/***/ 29795:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.MonthParser = void 0;
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class MonthParser extends _Parser.Parser {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];

  priority = 110;

  parse(dateString, token, match) {
    const valueCallback = (value) => value - 1;

    switch (token) {
      // 1, 2, ..., 12
      case "M":
        return (0, _utils.mapValue)(
          (0, _utils.parseNumericPattern)(
            _constants.numericPatterns.month,
            dateString,
          ),
          valueCallback,
        );
      // 01, 02, ..., 12
      case "MM":
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(2, dateString),
          valueCallback,
        );
      // 1st, 2nd, ..., 12th
      case "Mo":
        return (0, _utils.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "month",
          }),
          valueCallback,
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return (
          match.month(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.month(dateString, { width: "narrow", context: "formatting" })
        );

      // J, F, ..., D
      case "MMMMM":
        return match.month(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return (
          match.month(dateString, { width: "wide", context: "formatting" }) ||
          match.month(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.month(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
exports.MonthParser = MonthParser;


/***/ }),

/***/ 54196:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.QuarterParser = void 0;
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class QuarterParser extends _Parser.Parser {
  priority = 120;

  parse(dateString, token, match) {
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ": // 01, 02, 03, 04
        return (0, _utils.parseNDigits)(token.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return match.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return (
          match.quarter(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return match.quarter(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return (
          match.quarter(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 4;
  }

  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.QuarterParser = QuarterParser;


/***/ }),

/***/ 95043:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.SecondParser = void 0;
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class SecondParser extends _Parser.Parser {
  priority = 50;

  parse(dateString, token, match) {
    switch (token) {
      case "s":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.second,
          dateString,
        );
      case "so":
        return match.ordinalNumber(dateString, { unit: "second" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 59;
  }

  set(date, _flags, value) {
    date.setSeconds(value, 0);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}
exports.SecondParser = SecondParser;


/***/ }),

/***/ 11655:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.StandAloneLocalDayParser = void 0;
var _index = __webpack_require__(4729);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

// Stand-alone local day of week
class StandAloneLocalDayParser extends _Parser.Parser {
  priority = 90;

  parse(dateString, token, match, options) {
    const valueCallback = (value) => {
      // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return ((value + options.weekStartsOn + 6) % 7) + wholeWeekDays;
    };

    switch (token) {
      // 3
      case "c":
      case "cc": // 03
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(token.length, dateString),
          valueCallback,
        );
      // 3rd
      case "co":
        return (0, _utils.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "day",
          }),
          valueCallback,
        );
      // Tue
      case "ccc":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );

      // T
      case "ccccc":
        return match.day(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return (
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );

      // Tuesday
      case "cccc":
      default:
        return (
          match.day(dateString, { width: "wide", context: "standalone" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = (0, _index.setDay)(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T",
  ];
}
exports.StandAloneLocalDayParser = StandAloneLocalDayParser;


/***/ }),

/***/ 81336:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.StandAloneMonthParser = void 0;
var _constants = __webpack_require__(53322);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class StandAloneMonthParser extends _Parser.Parser {
  priority = 110;

  parse(dateString, token, match) {
    const valueCallback = (value) => value - 1;

    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return (0, _utils.mapValue)(
          (0, _utils.parseNumericPattern)(
            _constants.numericPatterns.month,
            dateString,
          ),
          valueCallback,
        );
      // 01, 02, ..., 12
      case "LL":
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(2, dateString),
          valueCallback,
        );
      // 1st, 2nd, ..., 12th
      case "Lo":
        return (0, _utils.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "month",
          }),
          valueCallback,
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return (
          match.month(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.month(dateString, { width: "narrow", context: "standalone" })
        );

      // J, F, ..., D
      case "LLLLL":
        return match.month(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return (
          match.month(dateString, { width: "wide", context: "standalone" }) ||
          match.month(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.month(dateString, { width: "narrow", context: "standalone" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.StandAloneMonthParser = StandAloneMonthParser;


/***/ }),

/***/ 67864:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.StandAloneQuarterParser = void 0;
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class StandAloneQuarterParser extends _Parser.Parser {
  priority = 120;

  parse(dateString, token, match) {
    switch (token) {
      // 1, 2, 3, 4
      case "q":
      case "qq": // 01, 02, 03, 04
        return (0, _utils.parseNDigits)(token.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return match.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return (
          match.quarter(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "standalone",
          })
        );

      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return match.quarter(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return (
          match.quarter(dateString, {
            width: "wide",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "standalone",
          })
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 4;
  }

  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.StandAloneQuarterParser = StandAloneQuarterParser;


/***/ }),

/***/ 34874:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.TimestampMillisecondsParser = void 0;
var _index = __webpack_require__(4589);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class TimestampMillisecondsParser extends _Parser.Parser {
  priority = 20;

  parse(dateString) {
    return (0, _utils.parseAnyDigitsSigned)(dateString);
  }

  set(date, _flags, value) {
    return [(0, _index.constructFrom)(date, value), { timestampIsSet: true }];
  }

  incompatibleTokens = "*";
}
exports.TimestampMillisecondsParser = TimestampMillisecondsParser;


/***/ }),

/***/ 40668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.TimestampSecondsParser = void 0;
var _index = __webpack_require__(4589);
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

class TimestampSecondsParser extends _Parser.Parser {
  priority = 40;

  parse(dateString) {
    return (0, _utils.parseAnyDigitsSigned)(dateString);
  }

  set(date, _flags, value) {
    return [
      (0, _index.constructFrom)(date, value * 1000),
      { timestampIsSet: true },
    ];
  }

  incompatibleTokens = "*";
}
exports.TimestampSecondsParser = TimestampSecondsParser;


/***/ }),

/***/ 60731:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.YearParser = void 0;
var _Parser = __webpack_require__(95245);

var _utils = __webpack_require__(26166);

// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class YearParser extends _Parser.Parser {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];

  parse(dateString, token, match) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "yy",
    });

    switch (token) {
      case "y":
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(4, dateString),
          valueCallback,
        );
      case "yo":
        return (0, _utils.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "year",
          }),
          valueCallback,
        );
      default:
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(token.length, dateString),
          valueCallback,
        );
    }
  }

  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }

  set(date, flags, value) {
    const currentYear = date.getFullYear();

    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(
        value.year,
        currentYear,
      );
      date.setFullYear(normalizedTwoDigitYear, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    const year =
      !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
exports.YearParser = YearParser;


/***/ }),

/***/ 26166:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.dayPeriodEnumToHours = dayPeriodEnumToHours;
exports.isLeapYearIndex = isLeapYearIndex;
exports.mapValue = mapValue;
exports.normalizeTwoDigitYear = normalizeTwoDigitYear;
exports.parseAnyDigitsSigned = parseAnyDigitsSigned;
exports.parseNDigits = parseNDigits;
exports.parseNDigitsSigned = parseNDigitsSigned;
exports.parseNumericPattern = parseNumericPattern;
exports.parseTimezonePattern = parseTimezonePattern;
var _index = __webpack_require__(53679);

var _constants = __webpack_require__(53322);

function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }

  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest,
  };
}

function parseNumericPattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length),
  };
}

function parseTimezonePattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1),
    };
  }

  const sign = matchResult[1] === "+" ? 1 : -1;
  const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;

  return {
    value:
      sign *
      (hours * _index.millisecondsInHour +
        minutes * _index.millisecondsInMinute +
        seconds * _index.millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length),
  };
}

function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(
    _constants.numericPatterns.anyDigitsSigned,
    dateString,
  );
}

function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(
        _constants.numericPatterns.singleDigit,
        dateString,
      );
    case 2:
      return parseNumericPattern(
        _constants.numericPatterns.twoDigits,
        dateString,
      );
    case 3:
      return parseNumericPattern(
        _constants.numericPatterns.threeDigits,
        dateString,
      );
    case 4:
      return parseNumericPattern(
        _constants.numericPatterns.fourDigits,
        dateString,
      );
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}

function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(
        _constants.numericPatterns.singleDigitSigned,
        dateString,
      );
    case 2:
      return parseNumericPattern(
        _constants.numericPatterns.twoDigitsSigned,
        dateString,
      );
    case 3:
      return parseNumericPattern(
        _constants.numericPatterns.threeDigitsSigned,
        dateString,
      );
    case 4:
      return parseNumericPattern(
        _constants.numericPatterns.fourDigitsSigned,
        dateString,
      );
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}

function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  const isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;

  let result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    const rangeEnd = absCurrentYear + 50;
    const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
    const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}


/***/ }),

/***/ 14485:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.parseISO = parseISO;
var _index = __webpack_require__(53679);

/**
 * The {@link parseISO} function options.
 */

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  const additionalDigits = options?.additionalDigits ?? 2;
  const dateStrings = splitDateString(argument);

  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  const timestamp = date.getTime();
  let time = 0;
  let offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    const dirtyDate = new Date(timestamp + time);
    // JS parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    const result = new Date(0);
    result.setFullYear(
      dirtyDate.getUTCFullYear(),
      dirtyDate.getUTCMonth(),
      dirtyDate.getUTCDate(),
    );
    result.setHours(
      dirtyDate.getUTCHours(),
      dirtyDate.getUTCMinutes(),
      dirtyDate.getUTCSeconds(),
      dirtyDate.getUTCMilliseconds(),
    );
    return result;
  }

  return new Date(timestamp + time + offset);
}

const patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/,
};

const dateRegex =
  /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const timeRegex =
  /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns.dateTimeDelimiter);
  let timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(
        dateStrings.date.length,
        dateString.length,
      );
    }
  }

  if (timeString) {
    const token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], "");
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  const regex = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" +
      (4 + additionalDigits) +
      "})|(\\d{2}|[+-]\\d{" +
      (2 + additionalDigits) +
      "})$)",
  );

  const captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return { year: NaN, restDateString: "" };

  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length),
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);

  const captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);

  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit(captures[1]);
  const month = parseDateUnit(captures[2]) - 1;
  const day = parseDateUnit(captures[3]);
  const week = parseDateUnit(captures[4]);
  const dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    const date = new Date(0);
    if (
      !validateDate(year, month, day) ||
      !validateDayOfYearDate(year, dayOfYear)
    ) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  const captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  const hours = parseTimeUnit(captures[1]);
  const minutes = parseTimeUnit(captures[2]);
  const seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return (
    hours * _index.millisecondsInHour +
    minutes * _index.millisecondsInMinute +
    seconds * 1000
  );
}

function parseTimeUnit(value) {
  return (value && parseFloat(value.replace(",", "."))) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;

  const captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;

  const sign = captures[1] === "+" ? -1 : 1;
  const hours = parseInt(captures[2]);
  const minutes = (captures[3] && parseInt(captures[3])) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return (
    sign *
    (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute)
  );
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  const date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
const daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

function validateDate(year, month, date) {
  return (
    month >= 0 &&
    month <= 11 &&
    date >= 1 &&
    date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28))
  );
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return (
    seconds >= 0 &&
    seconds < 60 &&
    minutes >= 0 &&
    minutes < 60 &&
    hours >= 0 &&
    hours < 25
  );
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}


/***/ }),

/***/ 77864:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.parseJSON = parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */
function parseJSON(dateStr) {
  const parts = dateStr.match(
    /(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/,
  );
  if (parts) {
    // Group 8 matches the sign
    return new Date(
      Date.UTC(
        +parts[1],
        +parts[2] - 1,
        +parts[3],
        +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1),
        +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1),
        +parts[6],
        +((parts[7] || "0") + "00").substring(0, 3),
      ),
    );
  }
  return new Date(NaN);
}


/***/ }),

/***/ 73189:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.previousDay = previousDay;
var _index = __webpack_require__(49288);
var _index2 = __webpack_require__(86584);

/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */
function previousDay(date, day) {
  let delta = (0, _index.getDay)(date) - day;
  if (delta <= 0) delta += 7;

  return (0, _index2.subDays)(date, delta);
}


/***/ }),

/***/ 35420:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.previousFriday = previousFriday;
var _index = __webpack_require__(73189);

/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */
function previousFriday(date) {
  return (0, _index.previousDay)(date, 5);
}


/***/ }),

/***/ 65042:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.previousMonday = previousMonday;
var _index = __webpack_require__(73189);

/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */
function previousMonday(date) {
  return (0, _index.previousDay)(date, 1);
}


/***/ }),

/***/ 73802:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.previousSaturday = previousSaturday;
var _index = __webpack_require__(73189);

/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */
function previousSaturday(date) {
  return (0, _index.previousDay)(date, 6);
}


/***/ }),

/***/ 54215:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.previousSunday = previousSunday;
var _index = __webpack_require__(73189);

/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */
function previousSunday(date) {
  return (0, _index.previousDay)(date, 0);
}


/***/ }),

/***/ 61663:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.previousThursday = previousThursday;
var _index = __webpack_require__(73189);

/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */
function previousThursday(date) {
  return (0, _index.previousDay)(date, 4);
}


/***/ }),

/***/ 42941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.previousTuesday = previousTuesday;
var _index = __webpack_require__(73189);

/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */
function previousTuesday(date) {
  return (0, _index.previousDay)(date, 2);
}


/***/ }),

/***/ 43529:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.previousWednesday = previousWednesday;
var _index = __webpack_require__(73189);

/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */
function previousWednesday(date) {
  return (0, _index.previousDay)(date, 3);
}


/***/ }),

/***/ 31078:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.quartersToMonths = quartersToMonths;
var _index = __webpack_require__(53679);

/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */
function quartersToMonths(quarters) {
  return Math.trunc(quarters * _index.monthsInQuarter);
}


/***/ }),

/***/ 1890:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.quartersToYears = quartersToYears;
var _index = __webpack_require__(53679);

/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */
function quartersToYears(quarters) {
  const years = quarters / _index.quartersInYear;
  return Math.trunc(years);
}


/***/ }),

/***/ 54931:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.roundToNearestHours = roundToNearestHours;
var _index = __webpack_require__(37814);
var _index2 = __webpack_require__(4589);
var _index3 = __webpack_require__(44724);

/**
 * The {@link roundToNearestHours} function options.
 */

/**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */
function roundToNearestHours(date, options) {
  const nearestTo = options?.nearestTo ?? 1;

  if (nearestTo < 1 || nearestTo > 12)
    return (0, _index2.constructFrom)(date, NaN);

  const _date = (0, _index3.toDate)(date);
  const fractionalMinutes = _date.getMinutes() / 60;
  const fractionalSeconds = _date.getSeconds() / 60 / 60;
  const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
  const hours =
    _date.getHours() +
    fractionalMinutes +
    fractionalSeconds +
    fractionalMilliseconds;

  // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
  const method = options?.roundingMethod ?? "round";
  const roundingMethod = (0, _index.getRoundingMethod)(method);

  // nearestTo option does not care daylight savings time
  const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;

  const result = (0, _index2.constructFrom)(date, _date);
  result.setHours(roundedHours, 0, 0, 0);
  return result;
}


/***/ }),

/***/ 79122:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.roundToNearestMinutes = roundToNearestMinutes;
var _index = __webpack_require__(37814);
var _index2 = __webpack_require__(4589);
var _index3 = __webpack_require__(44724);

/**
 * The {@link roundToNearestMinutes} function options.
 */

/**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */
function roundToNearestMinutes(date, options) {
  const nearestTo = options?.nearestTo ?? 1;

  if (nearestTo < 1 || nearestTo > 30)
    return (0, _index2.constructFrom)(date, NaN);

  const _date = (0, _index3.toDate)(date);
  const fractionalSeconds = _date.getSeconds() / 60;
  const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
  const minutes =
    _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;

  // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
  const method = options?.roundingMethod ?? "round";
  const roundingMethod = (0, _index.getRoundingMethod)(method);

  const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;

  const result = (0, _index2.constructFrom)(date, _date);
  result.setMinutes(roundedMinutes, 0, 0);
  return result;
}


/***/ }),

/***/ 88634:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.secondsToHours = secondsToHours;
var _index = __webpack_require__(53679);

/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */
function secondsToHours(seconds) {
  const hours = seconds / _index.secondsInHour;
  return Math.trunc(hours);
}


/***/ }),

/***/ 6179:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.secondsToMilliseconds = secondsToMilliseconds;
var _index = __webpack_require__(53679);

/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */
function secondsToMilliseconds(seconds) {
  return seconds * _index.millisecondsInSecond;
}


/***/ }),

/***/ 59399:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.secondsToMinutes = secondsToMinutes;
var _index = __webpack_require__(53679);

/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */
function secondsToMinutes(seconds) {
  const minutes = seconds / _index.secondsInMinute;
  return Math.trunc(minutes);
}


/***/ }),

/***/ 53304:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.set = set;
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(82650);
var _index3 = __webpack_require__(44724);

/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */

function set(date, values) {
  let _date = (0, _index3.toDate)(date);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(+_date)) {
    return (0, _index.constructFrom)(date, NaN);
  }

  if (values.year != null) {
    _date.setFullYear(values.year);
  }

  if (values.month != null) {
    _date = (0, _index2.setMonth)(_date, values.month);
  }

  if (values.date != null) {
    _date.setDate(values.date);
  }

  if (values.hours != null) {
    _date.setHours(values.hours);
  }

  if (values.minutes != null) {
    _date.setMinutes(values.minutes);
  }

  if (values.seconds != null) {
    _date.setSeconds(values.seconds);
  }

  if (values.milliseconds != null) {
    _date.setMilliseconds(values.milliseconds);
  }

  return _date;
}


/***/ }),

/***/ 28296:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setDate = setDate;
var _index = __webpack_require__(44724);

/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate(date, dayOfMonth) {
  const _date = (0, _index.toDate)(date);
  _date.setDate(dayOfMonth);
  return _date;
}


/***/ }),

/***/ 4729:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setDay = setDay;
var _index = __webpack_require__(83978);
var _index2 = __webpack_require__(44724);

var _index3 = __webpack_require__(92949);

/**
 * The {@link setDay} function options.
 */

/**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay(date, day, options) {
  const defaultOptions = (0, _index3.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0, _index2.toDate)(date);
  const currentDay = _date.getDay();

  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;

  const delta = 7 - weekStartsOn;
  const diff =
    day < 0 || day > 6
      ? day - ((currentDay + delta) % 7)
      : ((dayIndex + delta) % 7) - ((currentDay + delta) % 7);
  return (0, _index.addDays)(_date, diff);
}


/***/ }),

/***/ 47055:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setDayOfYear = setDayOfYear;
var _index = __webpack_require__(44724);

/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear(date, dayOfYear) {
  const _date = (0, _index.toDate)(date);
  _date.setMonth(0);
  _date.setDate(dayOfYear);
  return _date;
}


/***/ }),

/***/ 96820:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setDefaultOptions = setDefaultOptions;

var _index = __webpack_require__(92949);

/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */
function setDefaultOptions(options) {
  const result = {};
  const defaultOptions = (0, _index.getDefaultOptions)();

  for (const property in defaultOptions) {
    if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      result[property] = defaultOptions[property];
    }
  }

  for (const property in options) {
    if (Object.prototype.hasOwnProperty.call(options, property)) {
      if (options[property] === undefined) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
      }
    }
  }

  (0, _index.setDefaultOptions)(result);
}


/***/ }),

/***/ 24269:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setHours = setHours;
var _index = __webpack_require__(44724);

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours(date, hours) {
  const _date = (0, _index.toDate)(date);
  _date.setHours(hours);
  return _date;
}


/***/ }),

/***/ 70337:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setISODay = setISODay;
var _index = __webpack_require__(83978);
var _index2 = __webpack_require__(29064);
var _index3 = __webpack_require__(44724);

/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay(date, day) {
  const _date = (0, _index3.toDate)(date);
  const currentDay = (0, _index2.getISODay)(_date);
  const diff = day - currentDay;
  return (0, _index.addDays)(_date, diff);
}


/***/ }),

/***/ 70596:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setISOWeek = setISOWeek;
var _index = __webpack_require__(69513);
var _index2 = __webpack_require__(44724);

/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek(date, week) {
  const _date = (0, _index2.toDate)(date);
  const diff = (0, _index.getISOWeek)(_date) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}


/***/ }),

/***/ 58985:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setISOWeekYear = setISOWeekYear;
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(45672);
var _index3 = __webpack_require__(85860);
var _index4 = __webpack_require__(44724);

/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOWeekYear(date, weekYear) {
  let _date = (0, _index4.toDate)(date);
  const diff = (0, _index2.differenceInCalendarDays)(
    _date,
    (0, _index3.startOfISOWeekYear)(_date),
  );
  const fourthOfJanuary = (0, _index.constructFrom)(date, 0);
  fourthOfJanuary.setFullYear(weekYear, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  _date = (0, _index3.startOfISOWeekYear)(fourthOfJanuary);
  _date.setDate(_date.getDate() + diff);
  return _date;
}


/***/ }),

/***/ 85558:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setMilliseconds = setMilliseconds;
var _index = __webpack_require__(44724);

/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds(date, milliseconds) {
  const _date = (0, _index.toDate)(date);
  _date.setMilliseconds(milliseconds);
  return _date;
}


/***/ }),

/***/ 14728:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setMinutes = setMinutes;
var _index = __webpack_require__(44724);

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes(date, minutes) {
  const _date = (0, _index.toDate)(date);
  _date.setMinutes(minutes);
  return _date;
}


/***/ }),

/***/ 82650:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setMonth = setMonth;
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(74922);
var _index3 = __webpack_require__(44724);

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(date, month) {
  const _date = (0, _index3.toDate)(date);
  const year = _date.getFullYear();
  const day = _date.getDate();

  const dateWithDesiredMonth = (0, _index.constructFrom)(date, 0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  const daysInMonth = (0, _index2.getDaysInMonth)(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  _date.setMonth(month, Math.min(day, daysInMonth));
  return _date;
}


/***/ }),

/***/ 3646:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setQuarter = setQuarter;
var _index = __webpack_require__(82650);
var _index2 = __webpack_require__(44724);

/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter(date, quarter) {
  const _date = (0, _index2.toDate)(date);
  const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
  const diff = quarter - oldQuarter;
  return (0, _index.setMonth)(_date, _date.getMonth() + diff * 3);
}


/***/ }),

/***/ 24562:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setSeconds = setSeconds;
var _index = __webpack_require__(44724);

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds(date, seconds) {
  const _date = (0, _index.toDate)(date);
  _date.setSeconds(seconds);
  return _date;
}


/***/ }),

/***/ 52561:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setWeek = setWeek;
var _index = __webpack_require__(32901);
var _index2 = __webpack_require__(44724);

/**
 * The {@link setWeek} function options.
 */

/**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */
function setWeek(date, week, options) {
  const _date = (0, _index2.toDate)(date);
  const diff = (0, _index.getWeek)(_date, options) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}


/***/ }),

/***/ 86593:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setWeekYear = setWeekYear;
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(45672);
var _index3 = __webpack_require__(50237);
var _index4 = __webpack_require__(44724);

var _index5 = __webpack_require__(92949);

/**
 * The {@link setWeekYear} function options.
 */

/**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */
function setWeekYear(date, weekYear, options) {
  const defaultOptions = (0, _index5.getDefaultOptions)();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  let _date = (0, _index4.toDate)(date);
  const diff = (0, _index2.differenceInCalendarDays)(
    _date,
    (0, _index3.startOfWeekYear)(_date, options),
  );
  const firstWeek = (0, _index.constructFrom)(date, 0);
  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  _date = (0, _index3.startOfWeekYear)(firstWeek, options);
  _date.setDate(_date.getDate() + diff);
  return _date;
}


/***/ }),

/***/ 22490:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setYear = setYear;
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(44724);

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(date, year) {
  const _date = (0, _index2.toDate)(date);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(+_date)) {
    return (0, _index.constructFrom)(date, NaN);
  }

  _date.setFullYear(year);
  return _date;
}


/***/ }),

/***/ 72274:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfDay = startOfDay;
var _index = __webpack_require__(44724);

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(date) {
  const _date = (0, _index.toDate)(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 23114:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfDecade = startOfDecade;
var _index = __webpack_require__(44724);

/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */
function startOfDecade(date) {
  // TODO: Switch to more technical definition in of decades that start with 1
  // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
  // change, so it can only be done in 4.0.
  const _date = (0, _index.toDate)(date);
  const year = _date.getFullYear();
  const decade = Math.floor(year / 10) * 10;
  _date.setFullYear(decade, 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 25281:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfHour = startOfHour;
var _index = __webpack_require__(44724);

/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour(date) {
  const _date = (0, _index.toDate)(date);
  _date.setMinutes(0, 0, 0);
  return _date;
}


/***/ }),

/***/ 89301:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfISOWeek = startOfISOWeek;
var _index = __webpack_require__(83877);

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(date) {
  return (0, _index.startOfWeek)(date, { weekStartsOn: 1 });
}


/***/ }),

/***/ 85860:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfISOWeekYear = startOfISOWeekYear;
var _index = __webpack_require__(95303);
var _index2 = __webpack_require__(89301);
var _index3 = __webpack_require__(4589);

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(date) {
  const year = (0, _index.getISOWeekYear)(date);
  const fourthOfJanuary = (0, _index3.constructFrom)(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return (0, _index2.startOfISOWeek)(fourthOfJanuary);
}


/***/ }),

/***/ 52881:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfMinute = startOfMinute;
var _index = __webpack_require__(44724);

/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute(date) {
  const _date = (0, _index.toDate)(date);
  _date.setSeconds(0, 0);
  return _date;
}


/***/ }),

/***/ 23266:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfMonth = startOfMonth;
var _index = __webpack_require__(44724);

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(date) {
  const _date = (0, _index.toDate)(date);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 6831:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfQuarter = startOfQuarter;
var _index = __webpack_require__(44724);

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter(date) {
  const _date = (0, _index.toDate)(date);
  const currentMonth = _date.getMonth();
  const month = currentMonth - (currentMonth % 3);
  _date.setMonth(month, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 73320:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfSecond = startOfSecond;
var _index = __webpack_require__(44724);

/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond(date) {
  const _date = (0, _index.toDate)(date);
  _date.setMilliseconds(0);
  return _date;
}


/***/ }),

/***/ 48285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfToday = startOfToday;
var _index = __webpack_require__(72274);

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday() {
  return (0, _index.startOfDay)(Date.now());
}


/***/ }),

/***/ 75616:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.startOfTomorrow = startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  const date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(0, 0, 0, 0);
  return date;
}


/***/ }),

/***/ 83877:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfWeek = startOfWeek;
var _index = __webpack_require__(44724);

var _index2 = __webpack_require__(92949);

/**
 * The {@link startOfWeek} function options.
 */

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(date, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0, _index.toDate)(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 50237:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfWeekYear = startOfWeekYear;
var _index = __webpack_require__(4589);
var _index2 = __webpack_require__(38180);
var _index3 = __webpack_require__(83877);

var _index4 = __webpack_require__(92949);

/**
 * The {@link startOfWeekYear} function options.
 */

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(date, options) {
  const defaultOptions = (0, _index4.getDefaultOptions)();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const year = (0, _index2.getWeekYear)(date, options);
  const firstWeek = (0, _index.constructFrom)(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = (0, _index3.startOfWeek)(firstWeek, options);
  return _date;
}


/***/ }),

/***/ 90821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfYear = startOfYear;
var _index = __webpack_require__(44724);
var _index2 = __webpack_require__(4589);

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(date) {
  const cleanDate = (0, _index.toDate)(date);
  const _date = (0, _index2.constructFrom)(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 75747:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.startOfYesterday = startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  const date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(0, 0, 0, 0);
  return date;
}


/***/ }),

/***/ 47686:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.sub = sub;
var _index = __webpack_require__(86584);
var _index2 = __webpack_require__(10260);

var _index3 = __webpack_require__(4589);

/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */
function sub(date, duration) {
  const {
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = duration;

  // Subtract years and months
  const dateWithoutMonths = (0, _index2.subMonths)(date, months + years * 12);

  // Subtract weeks and days
  const dateWithoutDays = (0, _index.subDays)(
    dateWithoutMonths,
    days + weeks * 7,
  );

  // Subtract hours, minutes and seconds
  const minutestoSub = minutes + hours * 60;
  const secondstoSub = seconds + minutestoSub * 60;
  const mstoSub = secondstoSub * 1000;
  const finalDate = (0, _index3.constructFrom)(
    date,
    dateWithoutDays.getTime() - mstoSub,
  );

  return finalDate;
}


/***/ }),

/***/ 94347:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subBusinessDays = subBusinessDays;
var _index = __webpack_require__(87178);

/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */
function subBusinessDays(date, amount) {
  return (0, _index.addBusinessDays)(date, -amount);
}


/***/ }),

/***/ 86584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subDays = subDays;
var _index = __webpack_require__(83978);

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(date, amount) {
  return (0, _index.addDays)(date, -amount);
}


/***/ }),

/***/ 39169:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subHours = subHours;
var _index = __webpack_require__(41278);

/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours(date, amount) {
  return (0, _index.addHours)(date, -amount);
}


/***/ }),

/***/ 76081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subISOWeekYears = subISOWeekYears;
var _index = __webpack_require__(77673);

/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOWeekYears(date, amount) {
  return (0, _index.addISOWeekYears)(date, -amount);
}


/***/ }),

/***/ 44566:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subMilliseconds = subMilliseconds;
var _index = __webpack_require__(67106);

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(date, amount) {
  return (0, _index.addMilliseconds)(date, -amount);
}


/***/ }),

/***/ 31160:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subMinutes = subMinutes;
var _index = __webpack_require__(5157);

/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes(date, amount) {
  return (0, _index.addMinutes)(date, -amount);
}


/***/ }),

/***/ 10260:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subMonths = subMonths;
var _index = __webpack_require__(48991);

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(date, amount) {
  return (0, _index.addMonths)(date, -amount);
}


/***/ }),

/***/ 4286:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subQuarters = subQuarters;
var _index = __webpack_require__(53893);

/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters(date, amount) {
  return (0, _index.addQuarters)(date, -amount);
}


/***/ }),

/***/ 35882:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subSeconds = subSeconds;
var _index = __webpack_require__(41488);

/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds(date, amount) {
  return (0, _index.addSeconds)(date, -amount);
}


/***/ }),

/***/ 35619:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subWeeks = subWeeks;
var _index = __webpack_require__(75978);

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks(date, amount) {
  return (0, _index.addWeeks)(date, -amount);
}


/***/ }),

/***/ 26663:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subYears = subYears;
var _index = __webpack_require__(83366);

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears(date, amount) {
  return (0, _index.addYears)(date, -amount);
}


/***/ }),

/***/ 44724:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.toDate = toDate;

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (
    argument instanceof Date ||
    (typeof argument === "object" && argStr === "[object Date]")
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
  } else if (
    typeof argument === "number" ||
    argStr === "[object Number]" ||
    typeof argument === "string" ||
    argStr === "[object String]"
  ) {
    // TODO: Can we get rid of as?
    return new Date(argument);
  } else {
    // TODO: Can we get rid of as?
    return new Date(NaN);
  }
}


/***/ }),

/***/ 46225:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.transpose = transpose;
var _index = __webpack_require__(4589);

/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */
function transpose(fromDate, constructor) {
  const date =
    constructor instanceof Date
      ? (0, _index.constructFrom)(constructor, 0)
      : new constructor(0);
  date.setFullYear(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate(),
  );
  date.setHours(
    fromDate.getHours(),
    fromDate.getMinutes(),
    fromDate.getSeconds(),
    fromDate.getMilliseconds(),
  );
  return date;
}


/***/ }),

/***/ 4388:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.weeksToDays = weeksToDays;
var _index = __webpack_require__(53679);

/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */
function weeksToDays(weeks) {
  return Math.trunc(weeks * _index.daysInWeek);
}


/***/ }),

/***/ 85345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.yearsToDays = yearsToDays;
var _index = __webpack_require__(53679);

/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */
function yearsToDays(years) {
  return Math.trunc(years * _index.daysInYear);
}


/***/ }),

/***/ 99893:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.yearsToMonths = yearsToMonths;
var _index = __webpack_require__(53679);

/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */
function yearsToMonths(years) {
  return Math.trunc(years * _index.monthsInYear);
}


/***/ }),

/***/ 32416:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.yearsToQuarters = yearsToQuarters;
var _index = __webpack_require__(53679);

/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */
function yearsToQuarters(years) {
  return Math.trunc(years * _index.quartersInYear);
}


/***/ }),

/***/ 39714:
/***/ (function(module) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 63510:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var detectHover = {
  update: function update() {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      detectHover.hover = window.matchMedia('(hover: hover)').matches;
      detectHover.none = window.matchMedia('(hover: none)').matches || window.matchMedia('(hover: on-demand)').matches;
      detectHover.anyHover = window.matchMedia('(any-hover: hover)').matches;
      detectHover.anyNone = window.matchMedia('(any-hover: none)').matches || window.matchMedia('(any-hover: on-demand)').matches;
    }
  }
};

detectHover.update();
exports["default"] = detectHover;

/***/ }),

/***/ 35878:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _detectHover = __webpack_require__(63510);

var _detectHover2 = _interopRequireDefault(_detectHover);

var _detectPointer = __webpack_require__(52425);

var _detectPointer2 = _interopRequireDefault(_detectPointer);

var _detectTouchEvents = __webpack_require__(15441);

var _detectTouchEvents2 = _interopRequireDefault(_detectTouchEvents);

var _detectPassiveEvents = __webpack_require__(54301);

var _detectPassiveEvents2 = _interopRequireDefault(_detectPassiveEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * detectIt object structure
 * const detectIt = {
 *   deviceType: 'mouseOnly' / 'touchOnly' / 'hybrid',
 *   passiveEvents: boolean,
 *   hasTouch: boolean,
 *   hasMouse: boolean,
 *   maxTouchPoints: number,
 *   primaryHover: 'hover' / 'none',
 *   primaryPointer: 'fine' / 'coarse' / 'none',
 *   state: {
 *     detectHover,
 *     detectPointer,
 *     detectTouchEvents,
 *     detectPassiveEvents,
 *   },
 *   update() {...},
 * }
 */

function determineDeviceType(hasTouch, anyHover, anyFine, state) {
  // A hybrid device is one that both hasTouch and any input device can hover
  // or has a fine pointer.
  if (hasTouch && (anyHover || anyFine)) return 'hybrid';

  // workaround for browsers that have the touch events api,
  // and have implemented Level 4 media queries but not the
  // hover and pointer media queries, so the tests are all false (notable Firefox)
  // if it hasTouch, no pointer and hover support, and on an android assume it's touchOnly
  // if it hasTouch, no pointer and hover support, and not on an android assume it's a hybrid
  if (hasTouch && Object.keys(state.detectHover).filter(function (key) {
    return key !== 'update';
  }).every(function (key) {
    return state.detectHover[key] === false;
  }) && Object.keys(state.detectPointer).filter(function (key) {
    return key !== 'update';
  }).every(function (key) {
    return state.detectPointer[key] === false;
  })) {
    if (window.navigator && /android/.test(window.navigator.userAgent.toLowerCase())) {
      return 'touchOnly';
    }
    return 'hybrid';
  }

  // In almost all cases a device that doesn’t support touch will have a mouse,
  // but there may be rare exceptions. Note that it doesn’t work to do additional tests
  // based on hover and pointer media queries as older browsers don’t support these.
  // Essentially, 'mouseOnly' is the default.
  return hasTouch ? 'touchOnly' : 'mouseOnly';
}

var detectIt = {
  state: {
    detectHover: _detectHover2.default,
    detectPointer: _detectPointer2.default,
    detectTouchEvents: _detectTouchEvents2.default,
    detectPassiveEvents: _detectPassiveEvents2.default
  },
  update: function update() {
    detectIt.state.detectHover.update();
    detectIt.state.detectPointer.update();
    detectIt.state.detectTouchEvents.update();
    detectIt.state.detectPassiveEvents.update();
    detectIt.updateOnlyOwnProperties();
  },
  updateOnlyOwnProperties: function updateOnlyOwnProperties() {
    if (typeof window !== 'undefined') {
      detectIt.passiveEvents = detectIt.state.detectPassiveEvents.hasSupport || false;

      detectIt.hasTouch = detectIt.state.detectTouchEvents.hasSupport || false;

      detectIt.deviceType = determineDeviceType(detectIt.hasTouch, detectIt.state.detectHover.anyHover, detectIt.state.detectPointer.anyFine, detectIt.state);

      detectIt.hasMouse = detectIt.deviceType !== 'touchOnly';

      detectIt.primaryInput = detectIt.deviceType === 'mouseOnly' && 'mouse' || detectIt.deviceType === 'touchOnly' && 'touch' ||
      // deviceType is hybrid:
      detectIt.state.detectHover.hover && 'mouse' || detectIt.state.detectHover.none && 'touch' ||
      // if there's no support for hover media queries but detectIt determined it's
      // a hybrid  device, then assume it's a mouse first device
      'mouse';

      // issue with Windows Chrome on hybrid devices starting in version 59 where
      // media queries represent a touch only device, so if the browser is an
      // affected Windows Chrome version and hasTouch,
      // then assume it's a hybrid with primaryInput mouse
      // see https://github.com/rafrex/detect-it/issues/8
      var isAffectedWindowsChromeVersion = /windows/.test(window.navigator.userAgent.toLowerCase()) && /chrome/.test(window.navigator.userAgent.toLowerCase()) && parseInt(/Chrome\/([0-9.]+)/.exec(navigator.userAgent)[1], 10) >= 59;

      if (isAffectedWindowsChromeVersion && detectIt.hasTouch) {
        detectIt.deviceType = 'hybrid';
        detectIt.hasMouse = true;
        detectIt.primaryInput = 'mouse';
      }
    }
  }
};

detectIt.updateOnlyOwnProperties();
exports.Z = detectIt;

/***/ }),

/***/ 54301:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
var detectPassiveEvents = {
  update: function update() {
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      var passive = false;
      var options = Object.defineProperty({}, 'passive', {
        get: function get() {
          passive = true;
        }
      });
      // note: have to set and remove a no-op listener instead of null
      // (which was used previously), becasue Edge v15 throws an error
      // when providing a null callback.
      // https://github.com/rafgraph/detect-passive-events/pull/3
      var noop = function noop() {};
      window.addEventListener('testPassiveEventSupport', noop, options);
      window.removeEventListener('testPassiveEventSupport', noop, options);
      detectPassiveEvents.hasSupport = passive;
    }
  }
};

detectPassiveEvents.update();
exports["default"] = detectPassiveEvents;

/***/ }),

/***/ 52425:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var detectPointer = {
  update: function update() {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      detectPointer.fine = window.matchMedia('(pointer: fine)').matches;
      detectPointer.coarse = window.matchMedia('(pointer: coarse)').matches;
      detectPointer.none = window.matchMedia('(pointer: none)').matches;
      detectPointer.anyFine = window.matchMedia('(any-pointer: fine)').matches;
      detectPointer.anyCoarse = window.matchMedia('(any-pointer: coarse)').matches;
      detectPointer.anyNone = window.matchMedia('(any-pointer: none)').matches;
    }
  }
};

detectPointer.update();
exports["default"] = detectPointer;

/***/ }),

/***/ 15441:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var detectTouchEvents = {
  update: function update() {
    if (typeof window !== 'undefined') {
      detectTouchEvents.hasSupport = 'ontouchstart' in window;
      detectTouchEvents.browserSupportsApi = Boolean(window.TouchEvent);
    }
  }
};

detectTouchEvents.update();
exports["default"] = detectTouchEvents;

/***/ }),

/***/ 29874:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var QueryHandler = __webpack_require__(96156);
var each = (__webpack_require__(79704).each);

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),

/***/ 72683:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MediaQuery = __webpack_require__(29874);
var Util = __webpack_require__(79704);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),

/***/ 96156:
/***/ (function(module) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),

/***/ 79704:
/***/ (function(module) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),

/***/ 40746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(72683);
module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 85978:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),

/***/ 87201:
/***/ (function(module) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ 14983:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ 73463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(73887);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 43459:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 73887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(43459);
} else {}


/***/ }),

/***/ 31763:
/***/ (function(module) {

/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
     true ? module.exports = factory() :
    0;
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = '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';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = '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';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
                    }
                }
                else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            }
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    return html2canvas;

})));
//# sourceMappingURL=html2canvas.js.map


/***/ }),

/***/ 62333:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 15690:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(98558);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),

/***/ 98558:
/***/ (function(module) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),

/***/ 5546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(30627);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ 9599:
/***/ (function(module) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),

/***/ 80594:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 98357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;


/***/ }),

/***/ 36631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["default"] = (memoizeOne);


/***/ }),

/***/ 16483:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.BroadcastChannel = BroadcastChannel;
exports.apiBaseUrl = apiBaseUrl;
exports.fetchData = fetchData;
exports.now = now;

var _regenerator = _interopRequireDefault(__webpack_require__(82841));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(26290));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(91461));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function fetchData(_x, _x2, _x3) {
  return _fetchData.apply(this, arguments);
}

function _fetchData() {
  _fetchData = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(path, __NEXTAUTH, logger) {
    var _ref,
        ctx,
        _ref$req,
        req,
        url,
        _req$headers,
        options,
        res,
        data,
        _args = arguments;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 3 && _args[3] !== undefined ? _args[3] : {}, ctx = _ref.ctx, _ref$req = _ref.req, req = _ref$req === void 0 ? ctx === null || ctx === void 0 ? void 0 : ctx.req : _ref$req;
            url = "".concat(apiBaseUrl(__NEXTAUTH), "/").concat(path);
            _context.prev = 2;
            options = {
              headers: _objectSpread({
                "Content-Type": "application/json"
              }, req !== null && req !== void 0 && (_req$headers = req.headers) !== null && _req$headers !== void 0 && _req$headers.cookie ? {
                cookie: req.headers.cookie
              } : {})
            };

            if (req !== null && req !== void 0 && req.body) {
              options.body = JSON.stringify(req.body);
              options.method = "POST";
            }

            _context.next = 7;
            return fetch(url, options);

          case 7:
            res = _context.sent;
            _context.next = 10;
            return res.json();

          case 10:
            data = _context.sent;

            if (res.ok) {
              _context.next = 13;
              break;
            }

            throw data;

          case 13:
            return _context.abrupt("return", Object.keys(data).length > 0 ? data : null);

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](2);
            logger.error("CLIENT_FETCH_ERROR", {
              error: _context.t0,
              url: url
            });
            return _context.abrupt("return", null);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 16]]);
  }));
  return _fetchData.apply(this, arguments);
}

function apiBaseUrl(__NEXTAUTH) {
  if (typeof window === "undefined") {
    return "".concat(__NEXTAUTH.baseUrlServer).concat(__NEXTAUTH.basePathServer);
  }

  return __NEXTAUTH.basePath;
}

function now() {
  return Math.floor(Date.now() / 1000);
}

function BroadcastChannel() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "nextauth.message";
  return {
    receive: function receive(onReceive) {
      var handler = function handler(event) {
        var _event$newValue;

        if (event.key !== name) return;
        var message = JSON.parse((_event$newValue = event.newValue) !== null && _event$newValue !== void 0 ? _event$newValue : "{}");
        if ((message === null || message === void 0 ? void 0 : message.event) !== "session" || !(message !== null && message !== void 0 && message.data)) return;
        onReceive(message);
      };

      window.addEventListener("storage", handler);
      return function () {
        return window.removeEventListener("storage", handler);
      };
    },
    post: function post(message) {
      if (typeof window === "undefined") return;

      try {
        localStorage.setItem(name, JSON.stringify(_objectSpread(_objectSpread({}, message), {}, {
          timestamp: now()
        })));
      } catch (_unused) {}
    }
  };
}

/***/ }),

/***/ 67693:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.UnsupportedStrategy = exports.UnknownError = exports.OAuthCallbackError = exports.MissingSecret = exports.MissingAuthorize = exports.MissingAdapterMethods = exports.MissingAdapter = exports.MissingAPIRoute = exports.InvalidCallbackUrl = exports.AccountNotLinkedError = void 0;
exports.adapterErrorHandler = adapterErrorHandler;
exports.capitalize = capitalize;
exports.eventsErrorHandler = eventsErrorHandler;
exports.upperSnake = upperSnake;

var _regenerator = _interopRequireDefault(__webpack_require__(82841));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(91461));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(85297));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(26290));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(53100));

var _createClass2 = _interopRequireDefault(__webpack_require__(98870));

var _inherits2 = _interopRequireDefault(__webpack_require__(68230));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(60421));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1147));

var _wrapNativeSuper2 = _interopRequireDefault(__webpack_require__(78365));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var UnknownError = function (_Error) {
  (0, _inherits2.default)(UnknownError, _Error);

  var _super = _createSuper(UnknownError);

  function UnknownError(error) {
    var _message;

    var _this;

    (0, _classCallCheck2.default)(this, UnknownError);
    _this = _super.call(this, (_message = error === null || error === void 0 ? void 0 : error.message) !== null && _message !== void 0 ? _message : error);
    _this.name = "UnknownError";
    _this.code = error.code;

    if (error instanceof Error) {
      _this.stack = error.stack;
    }

    return _this;
  }

  (0, _createClass2.default)(UnknownError, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        name: this.name,
        message: this.message,
        stack: this.stack
      };
    }
  }]);
  return UnknownError;
}((0, _wrapNativeSuper2.default)(Error));

exports.UnknownError = UnknownError;

var OAuthCallbackError = function (_UnknownError) {
  (0, _inherits2.default)(OAuthCallbackError, _UnknownError);

  var _super2 = _createSuper(OAuthCallbackError);

  function OAuthCallbackError() {
    var _this2;

    (0, _classCallCheck2.default)(this, OAuthCallbackError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "name", "OAuthCallbackError");
    return _this2;
  }

  return (0, _createClass2.default)(OAuthCallbackError);
}(UnknownError);

exports.OAuthCallbackError = OAuthCallbackError;

var AccountNotLinkedError = function (_UnknownError2) {
  (0, _inherits2.default)(AccountNotLinkedError, _UnknownError2);

  var _super3 = _createSuper(AccountNotLinkedError);

  function AccountNotLinkedError() {
    var _this3;

    (0, _classCallCheck2.default)(this, AccountNotLinkedError);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "name", "AccountNotLinkedError");
    return _this3;
  }

  return (0, _createClass2.default)(AccountNotLinkedError);
}(UnknownError);

exports.AccountNotLinkedError = AccountNotLinkedError;

var MissingAPIRoute = function (_UnknownError3) {
  (0, _inherits2.default)(MissingAPIRoute, _UnknownError3);

  var _super4 = _createSuper(MissingAPIRoute);

  function MissingAPIRoute() {
    var _this4;

    (0, _classCallCheck2.default)(this, MissingAPIRoute);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this4), "name", "MissingAPIRouteError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this4), "code", "MISSING_NEXTAUTH_API_ROUTE_ERROR");
    return _this4;
  }

  return (0, _createClass2.default)(MissingAPIRoute);
}(UnknownError);

exports.MissingAPIRoute = MissingAPIRoute;

var MissingSecret = function (_UnknownError4) {
  (0, _inherits2.default)(MissingSecret, _UnknownError4);

  var _super5 = _createSuper(MissingSecret);

  function MissingSecret() {
    var _this5;

    (0, _classCallCheck2.default)(this, MissingSecret);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this5), "name", "MissingSecretError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this5), "code", "NO_SECRET");
    return _this5;
  }

  return (0, _createClass2.default)(MissingSecret);
}(UnknownError);

exports.MissingSecret = MissingSecret;

var MissingAuthorize = function (_UnknownError5) {
  (0, _inherits2.default)(MissingAuthorize, _UnknownError5);

  var _super6 = _createSuper(MissingAuthorize);

  function MissingAuthorize() {
    var _this6;

    (0, _classCallCheck2.default)(this, MissingAuthorize);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this6 = _super6.call.apply(_super6, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this6), "name", "MissingAuthorizeError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this6), "code", "CALLBACK_CREDENTIALS_HANDLER_ERROR");
    return _this6;
  }

  return (0, _createClass2.default)(MissingAuthorize);
}(UnknownError);

exports.MissingAuthorize = MissingAuthorize;

var MissingAdapter = function (_UnknownError6) {
  (0, _inherits2.default)(MissingAdapter, _UnknownError6);

  var _super7 = _createSuper(MissingAdapter);

  function MissingAdapter() {
    var _this7;

    (0, _classCallCheck2.default)(this, MissingAdapter);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this7 = _super7.call.apply(_super7, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this7), "name", "MissingAdapterError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this7), "code", "EMAIL_REQUIRES_ADAPTER_ERROR");
    return _this7;
  }

  return (0, _createClass2.default)(MissingAdapter);
}(UnknownError);

exports.MissingAdapter = MissingAdapter;

var MissingAdapterMethods = function (_UnknownError7) {
  (0, _inherits2.default)(MissingAdapterMethods, _UnknownError7);

  var _super8 = _createSuper(MissingAdapterMethods);

  function MissingAdapterMethods() {
    var _this8;

    (0, _classCallCheck2.default)(this, MissingAdapterMethods);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this8 = _super8.call.apply(_super8, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this8), "name", "MissingAdapterMethodsError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this8), "code", "MISSING_ADAPTER_METHODS_ERROR");
    return _this8;
  }

  return (0, _createClass2.default)(MissingAdapterMethods);
}(UnknownError);

exports.MissingAdapterMethods = MissingAdapterMethods;

var UnsupportedStrategy = function (_UnknownError8) {
  (0, _inherits2.default)(UnsupportedStrategy, _UnknownError8);

  var _super9 = _createSuper(UnsupportedStrategy);

  function UnsupportedStrategy() {
    var _this9;

    (0, _classCallCheck2.default)(this, UnsupportedStrategy);

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this9 = _super9.call.apply(_super9, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this9), "name", "UnsupportedStrategyError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this9), "code", "CALLBACK_CREDENTIALS_JWT_ERROR");
    return _this9;
  }

  return (0, _createClass2.default)(UnsupportedStrategy);
}(UnknownError);

exports.UnsupportedStrategy = UnsupportedStrategy;

var InvalidCallbackUrl = function (_UnknownError9) {
  (0, _inherits2.default)(InvalidCallbackUrl, _UnknownError9);

  var _super10 = _createSuper(InvalidCallbackUrl);

  function InvalidCallbackUrl() {
    var _this10;

    (0, _classCallCheck2.default)(this, InvalidCallbackUrl);

    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    _this10 = _super10.call.apply(_super10, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this10), "name", "InvalidCallbackUrl");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this10), "code", "INVALID_CALLBACK_URL_ERROR");
    return _this10;
  }

  return (0, _createClass2.default)(InvalidCallbackUrl);
}(UnknownError);

exports.InvalidCallbackUrl = InvalidCallbackUrl;

function upperSnake(s) {
  return s.replace(/([A-Z])/g, "_$1").toUpperCase();
}

function capitalize(s) {
  return "".concat(s[0].toUpperCase()).concat(s.slice(1));
}

function eventsErrorHandler(methods, logger) {
  return Object.keys(methods).reduce(function (acc, name) {
    acc[name] = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
      var method,
          _args = arguments;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              method = methods[name];
              _context.next = 4;
              return method.apply(void 0, _args);

            case 4:
              return _context.abrupt("return", _context.sent);

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              logger.error("".concat(upperSnake(name), "_EVENT_ERROR"), _context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));
    return acc;
  }, {});
}

function adapterErrorHandler(adapter, logger) {
  if (!adapter) return;
  return Object.keys(adapter).reduce(function (acc, name) {
    acc[name] = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
      var _len10,
          args,
          _key10,
          method,
          e,
          _args2 = arguments;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              for (_len10 = _args2.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
                args[_key10] = _args2[_key10];
              }

              logger.debug("adapter_".concat(name), {
                args: args
              });
              method = adapter[name];
              _context2.next = 6;
              return method.apply(void 0, args);

            case 6:
              return _context2.abrupt("return", _context2.sent);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              logger.error("adapter_error_".concat(name), _context2.t0);
              e = new UnknownError(_context2.t0);
              e.name = "".concat(capitalize(name), "Error");
              throw e;

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));
    return acc;
  }, {});
}

/***/ }),

/***/ 23848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34406);


var _interopRequireDefault = __webpack_require__(71600);

var _typeof = __webpack_require__(67425);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _exportNames = {
  SessionContext: true,
  useSession: true,
  getSession: true,
  getCsrfToken: true,
  getProviders: true,
  signIn: true,
  signOut: true,
  SessionProvider: true
};
exports.SessionContext = void 0;
exports.SessionProvider = SessionProvider;
exports.getCsrfToken = getCsrfToken;
exports.getProviders = getProviders;
exports.getSession = getSession;
exports.signIn = signIn;
exports.signOut = signOut;
exports.useSession = useSession;

var _regenerator = _interopRequireDefault(__webpack_require__(82841));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(26290));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(91461));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(43681));

var React = _interopRequireWildcard(__webpack_require__(2784));

var _logger2 = _interopRequireWildcard(__webpack_require__(74339));

var _parseUrl = _interopRequireDefault(__webpack_require__(18203));

var _utils = __webpack_require__(16483);

var _jsxRuntime = __webpack_require__(52322);

var _types = __webpack_require__(92878);

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

var _process$env$NEXTAUTH, _ref, _process$env$NEXTAUTH2, _process$env$NEXTAUTH3, _React$createContext;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __NEXTAUTH = {
  baseUrl: (0, _parseUrl.default)((_process$env$NEXTAUTH = process.env.NEXTAUTH_URL) !== null && _process$env$NEXTAUTH !== void 0 ? _process$env$NEXTAUTH : process.env.VERCEL_URL).origin,
  basePath: (0, _parseUrl.default)(process.env.NEXTAUTH_URL).path,
  baseUrlServer: (0, _parseUrl.default)((_ref = (_process$env$NEXTAUTH2 = process.env.NEXTAUTH_URL_INTERNAL) !== null && _process$env$NEXTAUTH2 !== void 0 ? _process$env$NEXTAUTH2 : process.env.NEXTAUTH_URL) !== null && _ref !== void 0 ? _ref : process.env.VERCEL_URL).origin,
  basePathServer: (0, _parseUrl.default)((_process$env$NEXTAUTH3 = process.env.NEXTAUTH_URL_INTERNAL) !== null && _process$env$NEXTAUTH3 !== void 0 ? _process$env$NEXTAUTH3 : process.env.NEXTAUTH_URL).path,
  _lastSync: 0,
  _session: undefined,
  _getSession: function _getSession() {}
};
var broadcast = (0, _utils.BroadcastChannel)();
var logger = (0, _logger2.proxyLogger)(_logger2.default, __NEXTAUTH.basePath);

function useOnline() {
  var _React$useState = React.useState(typeof navigator !== "undefined" ? navigator.onLine : false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      isOnline = _React$useState2[0],
      setIsOnline = _React$useState2[1];

  var setOnline = function setOnline() {
    return setIsOnline(true);
  };

  var setOffline = function setOffline() {
    return setIsOnline(false);
  };

  React.useEffect(function () {
    window.addEventListener("online", setOnline);
    window.addEventListener("offline", setOffline);
    return function () {
      window.removeEventListener("online", setOnline);
      window.removeEventListener("offline", setOffline);
    };
  }, []);
  return isOnline;
}

var SessionContext = (_React$createContext = React.createContext) === null || _React$createContext === void 0 ? void 0 : _React$createContext.call(React, undefined);
exports.SessionContext = SessionContext;

function useSession(options) {
  if (!SessionContext) {
    throw new Error("React Context is unavailable in Server Components");
  }

  var value = React.useContext(SessionContext);

  if (!value && "production" !== "production") {}

  var _ref2 = options !== null && options !== void 0 ? options : {},
      required = _ref2.required,
      onUnauthenticated = _ref2.onUnauthenticated;

  var requiredAndNotLoading = required && value.status === "unauthenticated";
  React.useEffect(function () {
    if (requiredAndNotLoading) {
      var url = "/api/auth/signin?".concat(new URLSearchParams({
        error: "SessionRequired",
        callbackUrl: window.location.href
      }));
      if (onUnauthenticated) onUnauthenticated();else window.location.href = url;
    }
  }, [requiredAndNotLoading, onUnauthenticated]);

  if (requiredAndNotLoading) {
    return {
      data: value.data,
      update: value.update,
      status: "loading"
    };
  }

  return value;
}

function getSession(_x) {
  return _getSession2.apply(this, arguments);
}

function _getSession2() {
  _getSession2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(params) {
    var _params$broadcast;

    var session;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _utils.fetchData)("session", __NEXTAUTH, logger, params);

          case 2:
            session = _context3.sent;

            if ((_params$broadcast = params === null || params === void 0 ? void 0 : params.broadcast) !== null && _params$broadcast !== void 0 ? _params$broadcast : true) {
              broadcast.post({
                event: "session",
                data: {
                  trigger: "getSession"
                }
              });
            }

            return _context3.abrupt("return", session);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getSession2.apply(this, arguments);
}

function getCsrfToken(_x2) {
  return _getCsrfToken.apply(this, arguments);
}

function _getCsrfToken() {
  _getCsrfToken = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4(params) {
    var response;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return (0, _utils.fetchData)("csrf", __NEXTAUTH, logger, params);

          case 2:
            response = _context4.sent;
            return _context4.abrupt("return", response === null || response === void 0 ? void 0 : response.csrfToken);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getCsrfToken.apply(this, arguments);
}

function getProviders() {
  return _getProviders.apply(this, arguments);
}

function _getProviders() {
  _getProviders = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee5() {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return (0, _utils.fetchData)("providers", __NEXTAUTH, logger);

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getProviders.apply(this, arguments);
}

function signIn(_x3, _x4, _x5) {
  return _signIn.apply(this, arguments);
}

function _signIn() {
  _signIn = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee6(provider, options, authorizationParams) {
    var _ref5, _ref5$callbackUrl, callbackUrl, _ref5$redirect, redirect, baseUrl, providers, isCredentials, isEmail, isSupportingReturn, signInUrl, _signInUrl, res, data, _data$url, url, error;

    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _ref5 = options !== null && options !== void 0 ? options : {}, _ref5$callbackUrl = _ref5.callbackUrl, callbackUrl = _ref5$callbackUrl === void 0 ? window.location.href : _ref5$callbackUrl, _ref5$redirect = _ref5.redirect, redirect = _ref5$redirect === void 0 ? true : _ref5$redirect;
            baseUrl = (0, _utils.apiBaseUrl)(__NEXTAUTH);
            _context6.next = 4;
            return getProviders();

          case 4:
            providers = _context6.sent;

            if (providers) {
              _context6.next = 8;
              break;
            }

            window.location.href = "".concat(baseUrl, "/error");
            return _context6.abrupt("return");

          case 8:
            if (!(!provider || !(provider in providers))) {
              _context6.next = 11;
              break;
            }

            window.location.href = "".concat(baseUrl, "/signin?").concat(new URLSearchParams({
              callbackUrl: callbackUrl
            }));
            return _context6.abrupt("return");

          case 11:
            isCredentials = providers[provider].type === "credentials";
            isEmail = providers[provider].type === "email";
            isSupportingReturn = isCredentials || isEmail;
            signInUrl = "".concat(baseUrl, "/").concat(isCredentials ? "callback" : "signin", "/").concat(provider);
            _signInUrl = "".concat(signInUrl).concat(authorizationParams ? "?".concat(new URLSearchParams(authorizationParams)) : "");
            _context6.t0 = fetch;
            _context6.t1 = _signInUrl;
            _context6.t2 = {
              "Content-Type": "application/x-www-form-urlencoded"
            };
            _context6.t3 = URLSearchParams;
            _context6.t4 = _objectSpread;
            _context6.t5 = _objectSpread({}, options);
            _context6.t6 = {};
            _context6.next = 25;
            return getCsrfToken();

          case 25:
            _context6.t7 = _context6.sent;
            _context6.t8 = callbackUrl;
            _context6.t9 = {
              csrfToken: _context6.t7,
              callbackUrl: _context6.t8,
              json: true
            };
            _context6.t10 = (0, _context6.t4)(_context6.t5, _context6.t6, _context6.t9);
            _context6.t11 = new _context6.t3(_context6.t10);
            _context6.t12 = {
              method: "post",
              headers: _context6.t2,
              body: _context6.t11
            };
            _context6.next = 33;
            return (0, _context6.t0)(_context6.t1, _context6.t12);

          case 33:
            res = _context6.sent;
            _context6.next = 36;
            return res.json();

          case 36:
            data = _context6.sent;

            if (!(redirect || !isSupportingReturn)) {
              _context6.next = 42;
              break;
            }

            url = (_data$url = data.url) !== null && _data$url !== void 0 ? _data$url : callbackUrl;
            window.location.href = url;
            if (url.includes("#")) window.location.reload();
            return _context6.abrupt("return");

          case 42:
            error = new URL(data.url).searchParams.get("error");

            if (!res.ok) {
              _context6.next = 46;
              break;
            }

            _context6.next = 46;
            return __NEXTAUTH._getSession({
              event: "storage"
            });

          case 46:
            return _context6.abrupt("return", {
              error: error,
              status: res.status,
              ok: res.ok,
              url: error ? null : data.url
            });

          case 47:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _signIn.apply(this, arguments);
}

function signOut(_x6) {
  return _signOut.apply(this, arguments);
}

function _signOut() {
  _signOut = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee7(options) {
    var _options$redirect;

    var _ref6, _ref6$callbackUrl, callbackUrl, baseUrl, fetchOptions, res, data, _data$url2, url;

    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _ref6 = options !== null && options !== void 0 ? options : {}, _ref6$callbackUrl = _ref6.callbackUrl, callbackUrl = _ref6$callbackUrl === void 0 ? window.location.href : _ref6$callbackUrl;
            baseUrl = (0, _utils.apiBaseUrl)(__NEXTAUTH);
            _context7.t0 = {
              "Content-Type": "application/x-www-form-urlencoded"
            };
            _context7.t1 = URLSearchParams;
            _context7.next = 6;
            return getCsrfToken();

          case 6:
            _context7.t2 = _context7.sent;
            _context7.t3 = callbackUrl;
            _context7.t4 = {
              csrfToken: _context7.t2,
              callbackUrl: _context7.t3,
              json: true
            };
            _context7.t5 = new _context7.t1(_context7.t4);
            fetchOptions = {
              method: "post",
              headers: _context7.t0,
              body: _context7.t5
            };
            _context7.next = 13;
            return fetch("".concat(baseUrl, "/signout"), fetchOptions);

          case 13:
            res = _context7.sent;
            _context7.next = 16;
            return res.json();

          case 16:
            data = _context7.sent;
            broadcast.post({
              event: "session",
              data: {
                trigger: "signout"
              }
            });

            if (!((_options$redirect = options === null || options === void 0 ? void 0 : options.redirect) !== null && _options$redirect !== void 0 ? _options$redirect : true)) {
              _context7.next = 23;
              break;
            }

            url = (_data$url2 = data.url) !== null && _data$url2 !== void 0 ? _data$url2 : callbackUrl;
            window.location.href = url;
            if (url.includes("#")) window.location.reload();
            return _context7.abrupt("return");

          case 23:
            _context7.next = 25;
            return __NEXTAUTH._getSession({
              event: "storage"
            });

          case 25:
            return _context7.abrupt("return", data);

          case 26:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _signOut.apply(this, arguments);
}

function SessionProvider(props) {
  if (!SessionContext) {
    throw new Error("React Context is unavailable in Server Components");
  }

  var children = props.children,
      basePath = props.basePath,
      refetchInterval = props.refetchInterval,
      refetchWhenOffline = props.refetchWhenOffline;
  if (basePath) __NEXTAUTH.basePath = basePath;
  var hasInitialSession = props.session !== undefined;
  __NEXTAUTH._lastSync = hasInitialSession ? (0, _utils.now)() : 0;

  var _React$useState3 = React.useState(function () {
    if (hasInitialSession) __NEXTAUTH._session = props.session;
    return props.session;
  }),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      session = _React$useState4[0],
      setSession = _React$useState4[1];

  var _React$useState5 = React.useState(!hasInitialSession),
      _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
      loading = _React$useState6[0],
      setLoading = _React$useState6[1];

  React.useEffect(function () {
    __NEXTAUTH._getSession = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
      var _ref4,
          event,
          storageEvent,
          _args = arguments;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref4 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, event = _ref4.event;
              _context.prev = 1;
              storageEvent = event === "storage";

              if (!(storageEvent || __NEXTAUTH._session === undefined)) {
                _context.next = 10;
                break;
              }

              __NEXTAUTH._lastSync = (0, _utils.now)();
              _context.next = 7;
              return getSession({
                broadcast: !storageEvent
              });

            case 7:
              __NEXTAUTH._session = _context.sent;
              setSession(__NEXTAUTH._session);
              return _context.abrupt("return");

            case 10:
              if (!(!event || __NEXTAUTH._session === null || (0, _utils.now)() < __NEXTAUTH._lastSync)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return");

            case 12:
              __NEXTAUTH._lastSync = (0, _utils.now)();
              _context.next = 15;
              return getSession();

            case 15:
              __NEXTAUTH._session = _context.sent;
              setSession(__NEXTAUTH._session);
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](1);
              logger.error("CLIENT_SESSION_ERROR", _context.t0);

            case 22:
              _context.prev = 22;
              setLoading(false);
              return _context.finish(22);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 19, 22, 25]]);
    }));

    __NEXTAUTH._getSession();

    return function () {
      __NEXTAUTH._lastSync = 0;
      __NEXTAUTH._session = undefined;

      __NEXTAUTH._getSession = function () {};
    };
  }, []);
  React.useEffect(function () {
    var unsubscribe = broadcast.receive(function () {
      return __NEXTAUTH._getSession({
        event: "storage"
      });
    });
    return function () {
      return unsubscribe();
    };
  }, []);
  React.useEffect(function () {
    var _props$refetchOnWindo = props.refetchOnWindowFocus,
        refetchOnWindowFocus = _props$refetchOnWindo === void 0 ? true : _props$refetchOnWindo;

    var visibilityHandler = function visibilityHandler() {
      if (refetchOnWindowFocus && document.visibilityState === "visible") __NEXTAUTH._getSession({
        event: "visibilitychange"
      });
    };

    document.addEventListener("visibilitychange", visibilityHandler, false);
    return function () {
      return document.removeEventListener("visibilitychange", visibilityHandler, false);
    };
  }, [props.refetchOnWindowFocus]);
  var isOnline = useOnline();
  var shouldRefetch = refetchWhenOffline !== false || isOnline;
  React.useEffect(function () {
    if (refetchInterval && shouldRefetch) {
      var refetchIntervalTimer = setInterval(function () {
        if (__NEXTAUTH._session) {
          __NEXTAUTH._getSession({
            event: "poll"
          });
        }
      }, refetchInterval * 1000);
      return function () {
        return clearInterval(refetchIntervalTimer);
      };
    }
  }, [refetchInterval, shouldRefetch]);
  var value = React.useMemo(function () {
    return {
      data: session,
      status: loading ? "loading" : session ? "authenticated" : "unauthenticated",
      update: function update(data) {
        return (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
          var newSession;
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(loading || !session)) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return");

                case 2:
                  setLoading(true);
                  _context2.t0 = _utils.fetchData;
                  _context2.t1 = __NEXTAUTH;
                  _context2.t2 = logger;
                  _context2.next = 8;
                  return getCsrfToken();

                case 8:
                  _context2.t3 = _context2.sent;
                  _context2.t4 = data;
                  _context2.t5 = {
                    csrfToken: _context2.t3,
                    data: _context2.t4
                  };
                  _context2.t6 = {
                    body: _context2.t5
                  };
                  _context2.t7 = {
                    req: _context2.t6
                  };
                  _context2.next = 15;
                  return (0, _context2.t0)("session", _context2.t1, _context2.t2, _context2.t7);

                case 15:
                  newSession = _context2.sent;
                  setLoading(false);

                  if (newSession) {
                    setSession(newSession);
                    broadcast.post({
                      event: "session",
                      data: {
                        trigger: "getSession"
                      }
                    });
                  }

                  return _context2.abrupt("return", newSession);

                case 19:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }
    };
  }, [session, loading]);
  return (0, _jsxRuntime.jsx)(SessionContext.Provider, {
    value: value,
    children: children
  });
}

/***/ }),

/***/ 92878:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

/***/ }),

/***/ 74339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
exports.proxyLogger = proxyLogger;
exports.setLogger = setLogger;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(26290));

var _errors = __webpack_require__(67693);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function formatError(o) {
  if (o instanceof Error && !(o instanceof _errors.UnknownError)) {
    return {
      message: o.message,
      stack: o.stack,
      name: o.name
    };
  }

  if (hasErrorProperty(o)) {
    var _o$message;

    o.error = formatError(o.error);
    o.message = (_o$message = o.message) !== null && _o$message !== void 0 ? _o$message : o.error.message;
  }

  return o;
}

function hasErrorProperty(x) {
  return !!(x !== null && x !== void 0 && x.error);
}

var _logger = {
  error: function error(code, metadata) {
    metadata = formatError(metadata);
    console.error("[next-auth][error][".concat(code, "]"), "\nhttps://next-auth.js.org/errors#".concat(code.toLowerCase()), metadata.message, metadata);
  },
  warn: function warn(code) {
    console.warn("[next-auth][warn][".concat(code, "]"), "\nhttps://next-auth.js.org/warnings#".concat(code.toLowerCase()));
  },
  debug: function debug(code, metadata) {
    console.log("[next-auth][debug][".concat(code, "]"), metadata);
  }
};

function setLogger() {
  var newLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var debug = arguments.length > 1 ? arguments[1] : undefined;
  if (!debug) _logger.debug = function () {};
  if (newLogger.error) _logger.error = newLogger.error;
  if (newLogger.warn) _logger.warn = newLogger.warn;
  if (newLogger.debug) _logger.debug = newLogger.debug;
}

var _default = _logger;
exports["default"] = _default;

function proxyLogger() {
  var logger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _logger;
  var basePath = arguments.length > 1 ? arguments[1] : undefined;

  try {
    if (typeof window === "undefined") {
      return logger;
    }

    var clientLogger = {};

    var _loop = function _loop(level) {
      clientLogger[level] = function (code, metadata) {
        _logger[level](code, metadata);

        if (level === "error") {
          metadata = formatError(metadata);
        }

        ;
        metadata.client = true;
        var url = "".concat(basePath, "/_log");
        var body = new URLSearchParams(_objectSpread({
          level: level,
          code: code
        }, metadata));

        if (navigator.sendBeacon) {
          return navigator.sendBeacon(url, body);
        }

        return fetch(url, {
          method: "POST",
          body: body,
          keepalive: true
        });
      };
    };

    for (var level in logger) {
      _loop(level);
    }

    return clientLogger;
  } catch (_unused) {
    return _logger;
  }
}

/***/ }),

/***/ 18203:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = parseUrl;

function parseUrl(url) {
  var _url2;

  const defaultUrl = new URL("http://localhost:3000/api/auth");

  if (url && !url.startsWith("http")) {
    url = `https://${url}`;
  }

  const _url = new URL((_url2 = url) !== null && _url2 !== void 0 ? _url2 : defaultUrl);

  const path = (_url.pathname === "/" ? defaultUrl.pathname : _url.pathname).replace(/\/$/, "");
  const base = `${_url.origin}${path}`;
  return {
    origin: _url.origin,
    host: _url.host,
    path,
    base,
    toString: () => base
  };
}

/***/ }),

/***/ 4079:
/***/ (function(module) {

"use strict";

var assign = Object.assign.bind(Object);
module.exports = assign;
module.exports["default"] = module.exports;

//# sourceMappingURL=object-assign.js.map

/***/ }),

/***/ 86570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(29830);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "reportWebVitals": function() { return /* binding */ reportWebVitals; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/application/context/BranchLocationContext.tsx
var BranchLocationContext = __webpack_require__(64462);
// EXTERNAL MODULE: ../../packages/application/context/CookiesContext.tsx
var CookiesContext = __webpack_require__(38672);
// EXTERNAL MODULE: ../../packages/application/context/Identity/index.ts + 1 modules
var Identity = __webpack_require__(24846);
// EXTERNAL MODULE: ../../packages/application/context/state.tsx + 1 modules
var state = __webpack_require__(14366);
// EXTERNAL MODULE: ../../packages/components/index.tsx + 205 modules
var components = __webpack_require__(88033);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../packages/infra/index.ts + 47 modules
var infra = __webpack_require__(11338);
// EXTERNAL MODULE: ../../node_modules/next-auth/react/index.js
var react = __webpack_require__(23848);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var node_modules_react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__(4147);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
;// CONCATENATED MODULE: ./src/styles/index.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n\n    ::-moz-selection { /* Code for Firefox */\n      color: ",
        ";\n      background: ",
        ";\n\n    }\n\n    ::selection {\n      color:",
        ";\n      background: ",
        ";\n\n    }\n  }\n\n  html, body {\n    font-family: 'Chivo', Arial, Helvetica, sans-serif;\n    font-size: ",
        ";\n    font-weight: 500;\n    font-style: normal;\n    scroll-behavior: smooth;\n    scroll-snap-align: center;\n    margin: 0 auto;\n    width: auto;\n    -webkit-font-smoothing: antialiased;\n\n    & * {\n      font-family: 'Chivo', Arial, Helvetica, sans-serif;\n    }\n  }\n\n  :focus {\n    outline: none;\n  }\n\n  a, a:link, button {\n    -webkit-tap-highlight-color: rgba(218, 8, 18, 0.2);\n  }\n\n  a, a:link {\n    text-decoration: none;\n    font-family: 'Chivo', sans-serif;\n    outline: 0;\n  }\n\n  .carousel .control-dots {\n    z-index: 1;\n    bottom: 0px;\n  }\n\n  .carousel .control-dots .dot {\n    border-radius: 3px !important;\n    width: ",
        ";\n    height: 5px;\n    background: rgba(189,189,189,0.5);\n    box-shadow: none;\n  }\n\n  .carousel .control-dots .selected {\n    width: 30px;\n    background: ",
        ";\n  }\n\n  main {\n    background-color: ",
        ";\n  }\n\n  path, rect, circle {\n    transition: stroke .2s ease-in;\n  }\n\n  .slick-prev:before {\n    display: none;\n  }\n\n  .slick-next:before {\n    display: none;\n  }\n\n  .slick-disabled {\n    background: ",
        ";\n    opacity: 1;\n    visibility: visible;\n\n    &:hover {\n      background: ",
        ";\n    }\n    cursor: default;\n\n    path {\n      stroke: ",
        ";\n    }\n\n    &:hover path {\n      stroke: ",
        ";\n    }\n  }\n\n  .slick-dots {\n    display: flex !important;\n    flex-direction: row;\n    gap: 8px;\n    justify-content: center;\n  }\n\n  .slick-dots li {\n    width: initial;\n    height: initial;\n    margin: 0;\n    padding: 0;\n  }\n\n  .ReactModal__Overlay {\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n  }\n\n  .ReactModal__Overlay--after-open {\n    opacity: 1;\n    overflow: hidden;\n  }\n\n  .ReactModal__Overlay--before-close {\n    opacity: 0;\n  }\n\n\n  .swiper-initialized {\n    display: flex;\n    align-items: center;\n    .swiper-button-next, .swiper-button-prev{\n            top: 40%;\n          }\n  }\n\n  .swiper-button-next {\n    height: 60px;\n    width: 60px;\n    border-radius: 35px;\n    right: 10px;\n\n\n    padding: 0px 0px 0px 4px;\n\n    background: ",
        ";\n\n    box-shadow: 0px 2px 2px ",
        ";\n\n    &:hover path {\n      stroke: ",
        "\n    }\n\n    &:hover {\n      background: ",
        ';\n      transition: 0.8s;\n    }\n\n    &::after{\n      content: "";\n      width: 13px;\n      height: 13px;\n      border: 3px solid ',
        ";\n      border-radius: 2px;\n      display: block;\n      position: absolute;\n      top: 21px;\n      right: 25px;\n      border-top: 0;\n      border-right: 0;\n      transform: rotate(-135deg);\n      transition: all 0.3s ease-in-out;\n    }\n\n    &:hover::after{\n      border-color: white;\n      border-top: 0;\n      border-right: 0;\n    }\n\n\n    @media ",
        "{\n      display: none;\n    }\n  }\n\n  .swiper-button-prev {\n    display: flex;\n    justify-content: center;\n\n    height: 60px;\n    width: 60px;\n\n    border-radius: 35px;\n    padding: 0px 0px 0px 4px;\n    background: ",
        ";\n\n    &:hover {\n      background: ",
        ";\n      transition: 0.8s;\n    }\n\n    &:hover path {\n      stroke: ",
        "\n    }\n\n    svg {\n      margin-top: 15px;\n      margin-left: 15px;\n    }\n\n    box-shadow: 0px 2px 2px ",
        ';\n\n    &::after{\n      content: "";\n      width: 13px;\n      height: 13px;\n      border: 3px solid ',
        ";\n      border-radius: 2px;\n      display: block;\n      position: absolute;\n      top: 21px;\n      right: 20px;\n      border-top: 0;\n      border-right: 0;\n      transform: rotate(45deg);\n      transition: all 0.3s ease-in-out;\n    }\n\n    &:hover::after{\n      border-color: white;\n      border-top: 0;\n      border-right: 0;\n    }\n\n    @media ",
        "{\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GlobalStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject(), ui.theme.colors.neutral.white, ui.theme.colors.primary[200], ui.theme.colors.neutral.white, ui.theme.colors.primary[200], ui.theme.typography.fontSize.sm.x3, ui.theme.space.x5, ui.theme.colors.primary[200], ui.theme.colors.neutral[25], ui.theme.colors.neutral[50], ui.theme.colors.neutral[50], ui.theme.colors.neutral[99], ui.theme.colors.neutral[99], ui.theme.colors.neutral.white, ui.theme.colors.neutral["999-opacity-25"], ui.theme.colors.neutral.white, ui.theme.colors.primary[200], ui.theme.colors.neutral[450], ui.theme.device.desktopFirst.tablet, ui.theme.colors.neutral.white, ui.theme.colors.primary[200], ui.theme.colors.neutral.white, ui.theme.colors.neutral["999-opacity-25"], ui.theme.colors.neutral[450], ui.theme.device.desktopFirst.tablet);

// EXTERNAL MODULE: ./src/styles/fonts.css
var fonts = __webpack_require__(38942);
;// CONCATENATED MODULE: ./pages/_app.tsx





















var ToastProvider = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 26052)).then(function(module) {
        return module.ToastProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26052)
            ];
        }
    }
});
var PopUpAlertConfirm = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 15261)).then(function(module) {
        return module.PopUpAlertConfirm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15261)
            ];
        }
    }
});
var PurchaseProvider = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 25371)).then(function(module) {
        return module.PurchaseProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25371)
            ];
        }
    }
});
var CookiesModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4044).then(__webpack_require__.bind(__webpack_require__, 84044)).then(function(module) {
        return module.CookiesModal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84044)
            ];
        }
    }
});
var ModalGroup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7362).then(__webpack_require__.bind(__webpack_require__, 27362)).then(function(module) {
        return module.ModalGroup;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27362)
            ];
        }
    }
});
var CardsProvider = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79203)).then(function(module) {
        return module.CardsProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79203)
            ];
        }
    }
});
var CountdownProvider = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 48561)).then(function(module) {
        return module.CountdownProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48561)
            ];
        }
    }
});
var EventListenerProvider = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 44278)).then(function(module) {
        return module.EventListenerProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44278)
            ];
        }
    }
});
var ModalGroupProvider = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 81898)).then(function(module) {
        return module.ModalGroupProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81898)
            ];
        }
    }
});
var NotificationProvider = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 12093)).then(function(module) {
        return module.NotificationProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12093)
            ];
        }
    }
});
var RecaptchaContextProvider = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 13638)).then(function(module) {
        return module.RecaptchaContextProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13638)
            ];
        }
    }
});
var WebSocketContextProvider = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 91393)).then(function(module) {
        return module.WebSocketContextProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91393)
            ];
        }
    }
});
function reportWebVitals(metric) {
    if (false) {}
}
var MyApp = function(_param) {
    var Component = _param.Component, session = _param.pageProps.session, pageProps = (0,_object_without_properties/* default */.Z)(_param.pageProps, [
        "session"
    ]);
    var ref = (0,node_modules_react.useState)(false), showChild = ref[0], setShowChild = ref[1];
    var router = (0,next_router.useRouter)();
    var hostEnv = "production";
    var _NEXT_PUBLIC_ENCRYPTION_KEY;
    var encryptionKey = (_NEXT_PUBLIC_ENCRYPTION_KEY = "b473abf8f0a26f6962cbc91fffd710f288be39ad40ec6e56614f702feadb439b") !== null && _NEXT_PUBLIC_ENCRYPTION_KEY !== void 0 ? _NEXT_PUBLIC_ENCRYPTION_KEY : "";
    var _NEXT_PUBLIC_IV_KEY;
    var ivKey = (_NEXT_PUBLIC_IV_KEY = "db9fe633630793a7701a75ed00a668ff") !== null && _NEXT_PUBLIC_IV_KEY !== void 0 ? _NEXT_PUBLIC_IV_KEY : "";
    (0,node_modules_react.useEffect)(function() {
        var addToCartFn = function addToCartFn(productId, quantity) {
            (0,application/* sendItemToCartByServer */.VVF)({
                productId: productId,
                quantity: quantity,
                shoppingApi: implementations/* shoppingApi */.B
            });
        };
        window.addToCart = addToCartFn;
        window.version = package_0/* version */.i8;
    }, []);
    (0,node_modules_react.useEffect)(function() {
        var handleRouteChange = function(url) {
            implementations/* gtag.pageview */.SX.pageview(url);
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router.events
    ]);
    (0,node_modules_react.useEffect)(function() {
        setShowChild(true);
    }, []);
    (0,application/* useInitializeAllConfigs */.b2j)(implementations/* envsApi */.qn);
    implementations/* encrypt.initialize */.HI.initialize(encryptionKey, ivKey);
    if (!showChild) {
        return null;
    }
    if (false) {}
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://ferreiracosta.api.useinsider.com/ins.js?id=".concat((0,application/* obfuscate */.H6d)(implementations/* crm.insiderId */.XE.insiderId || "")),
                strategy: "afterInteractive"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "lazyOnload",
                src: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/scripts/google-tag-manager/gtag.js?id=".concat((0,application/* obfuscate */.H6d)(implementations/* gtag.GA_TRACKING_ID */.SX.GA_TRACKING_ID || ""))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "google-tag-manager",
                strategy: "lazyOnload",
                children: "\n        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src=\n        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n        })(window,document,'script','dataLayer','".concat((0,application/* obfuscate */.H6d)(implementations/* gtag.GTM_ID */.SX.GTM_ID || ""), "');\n      ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "google-tag-script",
                strategy: "lazyOnload",
                dangerouslySetInnerHTML: {
                    __html: "\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n\n            gtag('config', '".concat((0,application/* obfuscate */.H6d)(implementations/* gtag.GA_TRACKING_ID */.SX.GA_TRACKING_ID || ""), "', { 'debug_mode': ").concat(hostEnv !== "production" && hostEnv !== "qas", " });\n\n            gtag('config', '").concat((0,application/* obfuscate */.H6d)(implementations/* gtag.GTM_ID */.SX.GTM_ID || ""), "', { 'debug_mode': ").concat(hostEnv !== "production" && hostEnv !== "qas", " });\n\n          ").concat(hostEnv !== "production" && hostEnv !== "qas" && "\n            gtag('config', '".concat((0,application/* obfuscate */.H6d)(implementations/* gtag.GA_TRACKING_ID_DEV */.SX.GA_TRACKING_ID_DEV || ""), "', { 'debug_mode': true });"), "\n          ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/scripts/standout/standout-ferreiracosta.js",
                strategy: "lazyOnload"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(infra/* GenesysChatBot.Script */.M$.Script, {
                jwtDecoder: implementations/* jwtDecoder */._X,
                purchaseApi: implementations/* purchaseApi */.dv
            }),
            implementations/* heatmapClient.Script */.sO.Script ? /*#__PURE__*/ (0,jsx_runtime.jsx)(implementations/* heatmapClient.Script */.sO.Script, {}) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
                theme: ui.theme,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownProvider, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastProvider, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecaptchaContextProvider, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.SessionProvider, {
                                session: session,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGroupProvider, {
                                    cookie: implementations/* cookie */.pR,
                                    identityApi: implementations/* identityApi */.IJ,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebSocketContextProvider, {
                                        webSocketClient: implementations/* webSocketClient */.Uq,
                                        appMonitoringClient: implementations/* appMonitoringClient */.pE,
                                        eventEmitter: implementations/* eventEmitter */.TB,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(application/* BroadcastChannelProvider */.MEm, {
                                            broadcastChannelClient: implementations/* browserBroadcast */.wi,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Identity/* AuthProvider */.Ho, {
                                                identityApi: implementations/* identityApi */.IJ,
                                                appMonitoringClient: implementations/* appMonitoringClient */.pE,
                                                cookie: implementations/* cookie */.pR,
                                                jwtDecoder: implementations/* jwtDecoder */._X,
                                                heatmapClient: implementations/* heatmapClient */.sO,
                                                purchaseApi: implementations/* purchaseApi */.dv,
                                                profileApi: implementations/* profileApi */.c_,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Identity/* UserProvider */.dr, {
                                                    profileApi: implementations/* profileApi */.c_,
                                                    crm: implementations/* crm */.XE,
                                                    cookie: implementations/* cookie */.pR,
                                                    jwtDecoder: implementations/* jwtDecoder */._X,
                                                    appMonitoringClient: implementations/* appMonitoringClient */.pE,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsProvider, {
                                                        paymentApi: implementations/* paymentApi */.Yw,
                                                        appMonitoringClient: implementations/* appMonitoringClient */.pE,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(state/* AppWrapper */.O, {
                                                            catalogApi: implementations/* catalogApi */.dZ,
                                                            stateManager: implementations/* stateManager */.m1,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BranchLocationContext/* BranchLocationProvider */.Zt, {
                                                                cookie: implementations/* cookie */.pR,
                                                                appMonitoringClient: implementations/* appMonitoringClient */.pE,
                                                                shippingApi: implementations/* shippingApi */.JK,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CookiesContext/* CookiesProvider */.c, {
                                                                    cookie: implementations/* cookie */.pR,
                                                                    heatmapClient: implementations/* heatmapClient */.sO,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(application/* CartProvider */.ZlT, {
                                                                        cookie: implementations/* cookie */.pR,
                                                                        jwtDecoder: implementations/* jwtDecoder */._X,
                                                                        shoppingApi: implementations/* shoppingApi */.B,
                                                                        catalogApi: implementations/* catalogApi */.dZ,
                                                                        PopUpAlertConfirm: PopUpAlertConfirm,
                                                                        appMonitoringClient: implementations/* appMonitoringClient */.pE,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseProvider, {
                                                                            purchaseApi: implementations/* purchaseApi */.dv,
                                                                            paymentApi: implementations/* paymentApi */.Yw,
                                                                            shippingApi: implementations/* shippingApi */.JK,
                                                                            clearSaleFingerprint: implementations/* clearSaleFingerprint */.hI,
                                                                            allowMeFingerprint: implementations/* allowMeFingerprint */.I$,
                                                                            appMonitoringClient: implementations/* appMonitoringClient */.pE,
                                                                            clientIp: implementations/* clientIp */.jY,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationProvider, {
                                                                                notificationApi: implementations/* notificationApi */.E8,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(application/* HeaderProvider */.I7y, {
                                                                                    backofficeApi: implementations/* backofficeApi */.X3,
                                                                                    cookie: implementations/* cookie */.pR,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListenerProvider, {
                                                                                        cookie: implementations/* cookie */.pR,
                                                                                        children: Component.getLayout ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                            children: [
                                                                                                Component.getLayout(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CookiesModal, {}),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGroup, {})
                                                                                            ]
                                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Layout */.Ar, {
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGroup, {}),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CookiesModal, {})
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 26011:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/version.js
const SDK_VERSION = '7.21.1';


//# sourceMappingURL=version.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(58536);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(63699);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(39660);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integrations/inboundfilters.js


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */
   __init() {this.name = InboundFilters.id;}

   constructor(  _options = {}) {;this._options = _options;InboundFilters.prototype.__init.call(this);}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcess = (event) => {
      const hub = getCurrentHub();
      if (hub) {
        const self = hub.getIntegration(InboundFilters);
        if (self) {
          const client = hub.getClient();
          const clientOptions = client ? client.getOptions() : {};
          const options = _mergeOptions(self._options, clientOptions);
          return _shouldDropEvent(event, options) ? null : event;
        }
      }
      return event;
    };

    eventProcess.id = this.name;
    addGlobalEventProcessor(eventProcess);
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...DEFAULT_IGNORE_ERRORS,
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  if (!ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => (0,string/* stringMatchesSomePattern */.U0)(message, ignoreErrors));
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,string/* stringMatchesSomePattern */.U0)(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,string/* stringMatchesSomePattern */.U0)(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }
  if (event.exception) {
    try {
      const { type = '', value = '' } = (event.exception.values && event.exception.values[0]) || {};
      return [`${value}`, `${type}: ${value}`];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract message for event ${(0,misc/* getEventDescription */.jH)(event)}`);
      return [];
    }
  }
  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(21995);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integrations/functiontostring.js


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {constructor() { FunctionToString.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */
   __init() {this.name = FunctionToString.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalFunctionToString = Function.prototype.toString;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Function.prototype.toString = function ( ...args) {
      const context = (0,object/* getOriginalFunction */.HK)(this) || this;
      return originalFunctionToString.apply(context, args);
    };
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(66465);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/scope.js
var esm_scope = __webpack_require__(51877);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integration.js




const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.values(integrationsByName);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = (0,misc/* arrayify */.lE)(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = finalIntegrations.findIndex(integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    integrationIndex[integration.name] = integration;

    if (installedIntegrations.indexOf(integration.name) === -1) {
      integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
      installedIntegrations.push(integration.name);
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Integration installed: ${integration.name}`);
    }
  });

  return integrationIndex;
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      esm_logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      // eslint-disable-next-line no-console
      console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  if (scope) {
    scope.update(options.initialScope);
  }

  const client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(69038);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(49798);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(64005);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;;

    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    throw new SentryError(`Invalid Sentry Dsn: ${str}`);
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  requiredComponents.forEach(component => {
    if (!dsn[component]) {
      throw new SentryError(`Invalid Sentry Dsn: ${component} missing`);
    }
  });

  if (!projectId.match(/^\d+$/)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
  }

  if (!isValidProtocol(protocol)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
  }

  if (port && isNaN(parseInt(port, 10))) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid port ${port}`);
  }

  return true;
}

/** The Sentry Dsn, identifying a Sentry instance and project. */
function dsn_makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  validateDsn(components);
  return components;
}


//# sourceMappingURL=dsn.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(81757);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(97946);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = +Infinity, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We're also done if we've reached the max depth
  if (depth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, depth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);

    numAdded += 1;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
    if (value === void 0) {
      return '[undefined]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    return `[object ${(Object.getPrototypeOf(value) ).constructor.name}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/envelope.js



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];
  envelopeItems.forEach((envelopeItem) => {
    const envelopeItemType = envelopeItem[0].type;
    callback(envelopeItem, envelopeItemType);
  });
}

function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify(normalize(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,object/* dropUndefinedKeys */.Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(7790);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/api.js


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,object/* urlEncode */._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = makeDsn(dsnLike);
  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/envelope.js


/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(metadata) {
  if (!metadata || !metadata.sdk) {
    return;
  }
  const { name, version } = metadata.sdk;
  return { name, version };
}

/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const eventType = event.type || 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}

function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;

  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
    ...(event.type === 'transaction' &&
      dynamicSamplingContext && {
        trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }),
      }),
  };
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(48364);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/baseclient.js







const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */
   __init() {this._integrations = {};}

  /** Indicates whether this client's integrations have been set up. */
   __init2() {this._integrationsInitialized = false;}

  /** Number of calls being processed */
   __init3() {this._numProcessing = 0;}

  /** Holds flushable  */
   __init4() {this._outcomes = {};}

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {;BaseClient.prototype.__init.call(this);BaseClient.prototype.__init2.call(this);BaseClient.prototype.__init3.call(this);BaseClient.prototype.__init4.call(this);
    this._options = options;
    if (options.dsn) {
      this._dsn = dsn_makeDsn(options.dsn);
      const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('No DSN provided, client will not do anything.');
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId;
    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId;

    const promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
      return;
    }

    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations() {
    if (this._isEnabled() && !this._integrationsInitialized) {
      this._integrations = setupIntegrations(this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    if (this._dsn) {
      let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

      for (const attachment of hint.attachments || []) {
        env = addItemToEnvelope(
          env,
          createAttachmentEnvelopeItem(
            attachment,
            this._options.transportOptions && this._options.transportOptions.textEncoder,
          ),
        );
      }

      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    if (this._dsn) {
      const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category) {
    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a valid Dsn is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = this.getOptions();
    const prepared = {
      ...event,
      event_id: event.event_id || hint.event_id || (0,misc/* uuid4 */.DM)(),
      timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
    };

    this._applyClientOptions(prepared);
    this._applyIntegrationsMetadata(prepared);

    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) {
      finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
    }

    // We prepare the result here with a resolved Event.
    let result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);

    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    //
    // We need to check for the existence of `finalScope.getAttachments`
    // because `getAttachments` can be undefined if users are using an older version
    // of `@sentry/core` that does not have the `getAttachments` method.
    // See: https://github.com/getsentry/sentry-javascript/issues/5229
    if (finalScope && finalScope.getAttachments) {
      // Collect attachments from the hint and scope
      const attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }

      // In case we have a hub we reassign it.
      result = finalScope.applyToEvent(prepared, hint);
    }

    return result.then(evt => {
      if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
        return this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
      }
      return evt;
    });
  }

  /**
   * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
   * Normalized keys:
   * - `breadcrumbs.data`
   * - `user`
   * - `contexts`
   * - `extra`
   * @param event Event
   * @returns Normalized event
   */
   _normalizeEvent(event, depth, maxBreadth) {
    if (!event) {
      return null;
    }

    const normalized = {
      ...event,
      ...(event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(b => ({
          ...b,
          ...(b.data && {
            data: normalize(b.data, depth, maxBreadth),
          }),
        })),
      }),
      ...(event.user && {
        user: normalize(event.user, depth, maxBreadth),
      }),
      ...(event.contexts && {
        contexts: normalize(event.contexts, depth, maxBreadth),
      }),
      ...(event.extra && {
        extra: normalize(event.extra, depth, maxBreadth),
      }),
    };

    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
      normalized.contexts.trace = event.contexts.trace;

      // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
      if (event.contexts.trace.data) {
        normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
      }
    }

    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) {
      normalized.spans = event.spans.map(span => {
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) {
          span.data = normalize(span.data, depth, maxBreadth);
        }
        return span;
      });
    }

    return normalized;
  }

  /**
   *  Enhances event using the client configuration.
   *  It takes care of all "static" values like environment, release and `dist`,
   *  as well as truncating overly long values.
   * @param event event instance to be enhanced
   */
   _applyClientOptions(event) {
    const options = this.getOptions();
    const { environment, release, dist, maxValueLength = 250 } = options;

    if (!('environment' in event)) {
      event.environment = 'environment' in options ? environment : 'production';
    }

    if (event.release === undefined && release !== undefined) {
      event.release = release;
    }

    if (event.dist === undefined && dist !== undefined) {
      event.dist = dist;
    }

    if (event.message) {
      event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
    }

    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) {
      exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
    }

    const request = event.request;
    if (request && request.url) {
      request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
    }
  }

  /**
   * This function adds all used integrations to the SDK info in the event.
   * @param event The event that will be filled with all integrations.
   */
   _applyIntegrationsMetadata(event) {
    const integrationsArray = Object.keys(this._integrations);
    if (integrationsArray.length > 0) {
      event.sdk = event.sdk || {};
      event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationsArray];
    }
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            esm_logger/* logger.log */.kg.log(sentryError.message);
          } else {
            esm_logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    if (!this._isEnabled()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('SDK not enabled, will not capture event.', 'log'));
    }

    const isTransaction = event.type === 'transaction';
    const beforeSendProcessorName = isTransaction ? 'beforeSendTransaction' : 'beforeSend';
    const beforeSendProcessor = options[beforeSendProcessorName];

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error');
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', event.type || 'error');
          throw new SentryError('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException || !beforeSendProcessor) {
          return prepared;
        }

        const beforeSendResult = beforeSendProcessor(prepared, hint);
        return _validateBeforeSendResult(beforeSendResult, beforeSendProcessorName);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', event.type || 'error');
          throw new SentryError(`\`${beforeSendProcessorName}\` returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
            changes: [
              ...transactionInfo.changes,
              {
                source,
                // use the same timestamp as the processed event.
                timestamp: processedEvent.timestamp ,
                propagations: transactionInfo.propagations,
              },
            ],
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason ,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing += 1;
    void promise.then(
      value => {
        this._numProcessing -= 1;
        return value;
      },
      reason => {
        this._numProcessing -= 1;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    if (this._transport && this._dsn) {
      this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendProcessorName,
) {
  const invalidValueError = `\`${beforeSendProcessorName}\` must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
          throw new SentryError(invalidValueError);
        }
        return event;
      },
      e => {
        throw new SentryError(`\`${beforeSendProcessorName}\` rejected with ${e}`);
      },
    );
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}


//# sourceMappingURL=baseclient.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/eventbuilder.js



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: `Non-Error ${
            isUnhandledRejection ? 'promise rejection' : 'exception'
          } captured with keys: ${(0,object/* extractExceptionKeysForMessage */.zf)(exception)}`,
        },
      ],
    },
    extra: {
      __serialized__: normalizeToSize(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,is/* isErrorEvent */.VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception ) || (0,is/* isDOMException */.fm)(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  const event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}


//# sourceMappingURL=eventbuilder.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(92642);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(90063);
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/helpers.js



const helpers_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError += 1;
  setTimeout(() => {
    ignoreOnError -= 1;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if ((0,object/* getOriginalFunction */.HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,esm_exports/* withScope */.$e)((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
            (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,esm_exports/* captureException */.Tb)(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);

  (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(54194);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url)

 {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/breadcrumbs.js




/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */

const BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = BREADCRUMB_INTEGRATION_ID;}

  /**
   * @inheritDoc
   */
   __init() {this.name = Breadcrumbs.id;}

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.

  /**
   * @inheritDoc
   */
   constructor(options) {;Breadcrumbs.prototype.__init.call(this);
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      (0,instrument/* addInstrumentationHandler */.o)('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      (0,instrument/* addInstrumentationHandler */.o)('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      (0,instrument/* addInstrumentationHandler */.o)('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      (0,instrument/* addInstrumentationHandler */.o)('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      (0,instrument/* addInstrumentationHandler */.o)('history', _historyBreadcrumb);
    }
  }
} Breadcrumbs.__initStatic();

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      target = handlerData.event.target
        ? (0,browser/* htmlTreeAsString */.Rt)(handlerData.event.target , keyAttrs)
        : (0,browser/* htmlTreeAsString */.Rt)(handlerData.event , keyAttrs);
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
  // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
  // console warnings. This happens when a Vue template is rendered with
  // an undeclared variable, which we try to stringify, ultimately causing
  // Vue to issue another warning which repeats indefinitely.
  // see: https://github.com/getsentry/sentry-javascript/pull/6010
  // see: https://github.com/getsentry/sentry-javascript/issues/5916
  for (let i = 0; i < handlerData.args.length; i++) {
    if (handlerData.args[i] === 'ref=Ref<') {
      handlerData.args[i + 1] = 'viewRef';
      break;
    }
  }
  const breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
  if (handlerData.endTimestamp) {
    // We only capture complete, non-sentry requests
    if (handlerData.xhr.__sentry_own_request__) {
      return;
    }

    const { method, url, status_code, body } = handlerData.xhr.__sentry_xhr__ || {};

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'xhr',
        data: {
          method,
          url,
          status_code,
        },
        type: 'http',
      },
      {
        xhr: handlerData.xhr,
        input: body,
      },
    );

    return;
  }
}

/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
  // We only capture complete fetch requests
  if (!handlerData.endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: handlerData.fetchData,
        level: 'error',
        type: 'http',
      },
      {
        data: handlerData.error,
        input: handlerData.args,
      },
    );
  } else {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: {
          ...handlerData.fetchData,
          status_code: handlerData.response.status,
        },
        type: 'http',
      },
      {
        input: handlerData.args,
        response: handlerData.response,
      },
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
  let from = handlerData.from;
  let to = handlerData.to;
  const parsedLoc = parseUrl(helpers_WINDOW.location.href);
  let parsedFrom = parseUrl(from);
  const parsedTo = parseUrl(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/client.js






/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: 'npm:@sentry/browser',
          version: SDK_VERSION,
        },
      ],
      version: SDK_VERSION,
    };

    super(options);

    if (options.sendClientReports && helpers_WINDOW.document) {
      helpers_WINDOW.document.addEventListener('visibilitychange', () => {
        if (helpers_WINDOW.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint) {
    // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
    // activated its `sentry` option.
    // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
    // bundles, if it is not used by the SDK.
    // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
    // way for now.
    const breadcrumbIntegration = this.getIntegrationById(BREADCRUMB_INTEGRATION_ID) ;
    if (
      breadcrumbIntegration &&
      // We check for definedness of `options`, even though it is not strictly necessary, because that access to
      // `.sentry` below does not throw, in case users provided their own integration with id "Breadcrumbs" that does
      // not have an`options` field
      breadcrumbIntegration.options &&
      breadcrumbIntegration.options.sentry
    ) {
      (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
        {
          category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
          event_id: event.event_id,
          level: event.level,
          message: (0,misc/* getEventDescription */.jH)(event),
        },
        {
          event,
        },
      );
    }

    super.sendEvent(event, hint);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, this._options);
    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));

    try {
      const isRealNavigator = Object.prototype.toString.call(helpers_WINDOW && helpers_WINDOW.navigator) === '[object Navigator]';
      const hasSendBeacon = isRealNavigator && typeof helpers_WINDOW.navigator.sendBeacon === 'function';
      // Make sure beacon is not used if user configures custom transport options
      if (hasSendBeacon && !this._options.transportOptions) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        const sendBeacon = helpers_WINDOW.navigator.sendBeacon.bind(helpers_WINDOW.navigator);
        sendBeacon(url, serializeEnvelope(envelope));
      } else {
        // If beacon is not supported or if they are using the tunnel option
        // use our regular transport to send client reports to Sentry.
        this._sendEnvelope(envelope);
      }
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(e);
    }
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    // All browser frames are considered in_app
    in_app: true,
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.*\).*?|.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

const chrome = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex =
  /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = (0,stacktrace/* createStackParser */.pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/trycatch.js



const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */
   __init() {this.name = TryCatch.id;}

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {;TryCatch.prototype.__init.call(this);
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    if (this._options.setTimeout) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && "XMLHttpRequest" in helpers_WINDOW) {
      (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    const eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: (0,stacktrace/* getFunctionName */.$P)(original) },
        handled: true,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,stacktrace/* getFunctionName */.$P)(original),
          },
          handled: true,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,object/* fill */.hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,stacktrace/* getFunctionName */.$P)(original),
              },
              handled: true,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = helpers_WINDOW ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,object/* fill */.hl)(proto, 'addEventListener', function (original)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                target,
              },
              handled: true,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,stacktrace/* getFunctionName */.$P)(fn),
              target,
            },
            handled: true,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,object/* fill */.hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/globalhandlers.js





/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GlobalHandlers.id;}

  /** JSDoc */

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
   __init2() {this._installFunc = {
    onerror: _installGlobalOnErrorHandler,
    onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
  };}

  /** JSDoc */
   constructor(options) {;GlobalHandlers.prototype.__init.call(this);GlobalHandlers.prototype.__init2.call(this);
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    const options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
    // eslint-disable-next-line guard-for-in
    for (const key in options) {
      const installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'error',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return;
      }

      const event =
        error === undefined && (0,is/* isString */.HD)(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'unhandledrejection',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return true;
      }

      const event = (0,is/* isPrimitive */.pt)(error)
        ? _eventFromRejectionWithPrimitive(error)
        : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  (0,misc/* addExceptionMechanism */.EG)(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/linkederrors.js




const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */
    __init() {this.name = LinkedErrors.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {;LinkedErrors.prototype.__init.call(this);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    if (!client) {
      return;
    }
    (0,esm_scope/* addGlobalEventProcessor */.c)((event, hint) => {
      const self = (0,esm_hub/* getCurrentHub */.Gd)().getIntegration(LinkedErrors);
      return self ? _handler(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
    });
  }
} LinkedErrors.__initStatic();

/**
 * @inheritDoc
 */
function _handler(
  parser,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return event;
  }
  const linkedErrors = _walkErrorTree(parser, limit, hint.originalException , key);
  event.exception.values = [...linkedErrors, ...event.exception.values];
  return event;
}

/**
 * JSDOC
 */
function _walkErrorTree(
  parser,
  limit,
  error,
  key,
  stack = [],
) {
  if (!(0,is/* isInstanceOf */.V9)(error[key], Error) || stack.length + 1 >= limit) {
    return stack;
  }
  const exception = exceptionFromError(parser, error[key]);
  return _walkErrorTree(parser, limit, error[key], key, [exception, ...stack]);
}


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
class Dedupe  {constructor() { Dedupe.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Dedupe.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcessor = currentEvent => {
      const self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        // Juuust in case something goes wrong
        try {
          if (dedupe_shouldDropEvent(currentEvent, self._previousEvent)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
            return null;
          }
        } catch (_oO) {
          return (self._previousEvent = currentEvent);
        }

        return (self._previousEvent = currentEvent);
      }
      return currentEvent;
    };

    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
} Dedupe.__initStatic();

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-ignore Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/httpcontext.js



/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {constructor() { HttpContext.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */
   __init() {this.name = HttpContext.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    (0,esm_scope/* addGlobalEventProcessor */.c)((event) => {
      if ((0,esm_hub/* getCurrentHub */.Gd)().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!helpers_WINDOW.navigator && !helpers_WINDOW.location && !helpers_WINDOW.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        const url = (event.request && event.request.url) || (helpers_WINDOW.location && helpers_WINDOW.location.href);
        const { referrer } = helpers_WINDOW.document || {};
        const { userAgent } = helpers_WINDOW.navigator || {};

        const headers = {
          ...(event.request && event.request.headers),
          ...(referrer && { Referer: referrer }),
          ...(userAgent && { 'User-Agent': userAgent }),
        };
        const request = { ...(url && { url }), headers };

        return { ...event, request };
      }
      return event;
    });
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          // eslint-disable-next-line no-plusplus
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that given category is disabled until for rate limiting
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 * Returns true if headers contains a non-empty rate limiting header.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/transports/base.js


const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE),
) {
  let rateLimits = {};

  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      const envelopeItemDataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (_, type) => {
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type));
      });
    };

    const requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
        },
        error => {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Failed while sending event:', error);
          recordEnvelopeLoss('network_error');
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  return {
    send,
    flush,
  };
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/utils.js



let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if ((0,supports/* isNativeFetch */.Du)(helpers_WINDOW.fetch)) {
    return (cachedFetchImpl = helpers_WINDOW.fetch.bind(helpers_WINDOW));
  }

  const document = helpers_WINDOW.document;
  let fetchImpl = helpers_WINDOW.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers_WINDOW));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  function makeRequest(request) {
    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch), a request with `keepalive: true`
      //   and a content length of > 64 kibibytes returns a network error. We will therefore only activate the flag when
      //   we're below that limit.
      keepalive: request.body.length <= 65536,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => ({
        statusCode: response.status,
        headers: {
          'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
          'retry-after': response.headers.get('Retry-After'),
        },
      }));
    } catch (e) {
      clearCachedFetchImplementation();
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/sdk.js
















const defaultIntegrations = [
  new InboundFilters(),
  new FunctionToString(),
  new TryCatch(),
  new Breadcrumbs(),
  new GlobalHandlers(),
  new LinkedErrors(),
  new Dedupe(),
  new HttpContext(),
];

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    // This supports the variable that sentry-webpack-plugin injects
    if (helpers_WINDOW.SENTRY_RELEASE && helpers_WINDOW.SENTRY_RELEASE.id) {
      options.release = helpers_WINDOW.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || ((0,supports/* supportsFetch */.Ak)() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = getCurrentHub()) {
  // doesn't work without a document (React Native)
  if (!WINDOW.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  const script = WINDOW.document.createElement('script');
  script.async = true;
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
  }

  const injectionPoint = WINDOW.document.head || WINDOW.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return getCurrentHub().lastEventId();
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers_WINDOW.document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  (0,instrument/* addInstrumentationHandler */.o)('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
    }
  });
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function sdk_init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: SDK_VERSION,
      },
    ],
    version: SDK_VERSION,
  };
  init(options);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/tracing/esm/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(78900);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/tracing.js
const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  const matches = traceparent.match(TRACEPARENT_REGEXP);

  if (!traceparent || !matches) {
    // empty string or no matches is invalid traceparent data
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}


//# sourceMappingURL=tracing.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/baggage.js



const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,is/* isString */.HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(40564);
// EXTERNAL MODULE: ../../node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(92517);
;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/types.js


const types_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (types_WINDOW && types_WINDOW.document) {
    types_WINDOW.document.addEventListener('visibilitychange', () => {
      const activeTransaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (types_WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/buildPolyfills/_nullishCoalesce.js
var _nullishCoalesce = __webpack_require__(12885);
;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = types_WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = types_WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (types_WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      types_WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return types_WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if (types_WINDOW.document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || types_WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (onReport, opts = {}) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric, opts.reportAllChanges);

    onHidden(() => {
      handleEntries(po.takeRecords() );
      report(true);
    });
  }
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  return types_WINDOW.document.visibilityState === 'hidden' && !types_WINDOW.document.prerendering ? 0 : Infinity;
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport, opts = {}) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric, opts.reportAllChanges);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */
const onLCP = (onReport, opts = {}) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric, opts.reportAllChanges);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);
  }
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/metrics/index.js











function getBrowserPerformanceAPI() {
  return types_WINDOW && types_WINDOW.addEventListener && types_WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 */
function startTrackingWebVitals(reportAllChanges = false) {
  const performance = getBrowserPerformanceAPI();
  if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
    if (performance.mark) {
      types_WINDOW.performance.mark('sentry-tracing-init');
    }
    _trackCLS();
    _trackLCP(reportAllChanges);
    _trackFID();
  }
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (!transaction) {
        return;
      }
      const startTime = (0,utils/* msToSec */.XL)((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = (0,utils/* msToSec */.XL)(entry.duration);

      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  };

  observe('longtask', entryHandler);
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  // See:
  // https://web.dev/evolving-cls/
  // https://web.dev/cls-web-tooling/
  onCLS(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP(reportAllChanges) {
  onLCP(
    metric => {
      const entry = metric.entries.pop();
      if (!entry) {
        return;
      }

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP');
      _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
      _lcpEntry = entry ;
    },
    { reportAllChanges },
  );
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  onFID(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    const timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !types_WINDOW.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    const duration = (0,utils/* msToSec */.XL)(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart);
        requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        const resourceName = (entry.name ).replace(types_WINDOW.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      default:
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      const delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + (0,utils/* msToSec */.XL)(_measurements['fid'].value),
        op: 'ui.action',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    description: (0,_nullishCoalesce/* _nullishCoalesce */.h)(description, () => ( event)),
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(start),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    description: 'request',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    description: 'response',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  if ('transferSize' in entry) {
    data['Transfer Size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['Encoded Body Size'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['Decoded Body Size'] = entry.decodedBodySize;
  }

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = types_WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/request.js



const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\//];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  // eslint-disable-next-line deprecation/deprecation
  const { traceFetch, traceXHR, tracePropagationTargets, tracingOrigins, shouldCreateSpanForRequest } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    (0,instrument/* addInstrumentationHandler */.o)('fetch', (handlerData) => {
      fetchCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }

  if (traceXHR) {
    (0,instrument/* addInstrumentationHandler */.o)('xhr', (handlerData) => {
      xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return (0,string/* stringMatchesSomePattern */.U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track fetch request spans
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (!(0,utils/* hasTracingEnabled */.zu)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
    return;
  }

  if (handlerData.endTimestamp) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        span.setHttpStatus(handlerData.response.status);
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const span = activeTransaction.startChild({
      data: {
        ...handlerData.fetchData,
        type: 'fetch',
      },
      description: `${handlerData.fetchData.method} ${handlerData.fetchData.url}`,
      op: 'http.client',
    });

    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;

    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    if (shouldAttachHeaders(handlerData.fetchData.url)) {
      options.headers = addTracingHeadersToFetchRequest(
        request,
        activeTransaction.getDynamicSamplingContext(),
        span,
        options,
      );

      activeTransaction.metadata.propagations += 1;
    }
  }
}

function addTracingHeadersToFetchRequest(
  request,
  dynamicSamplingContext,
  span,
  options

,
) {
  const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);
  const sentryTraceHeader = span.toTraceparent();

  const headers =
    typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request) ? (request ).headers : options.headers;

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended miultiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([BAGGAGE_HEADER_NAME, sentryBaggageHeader]);
    }

    return newHeaders;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

/**
 * Create and track xhr request spans
 */
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (
    !(0,utils/* hasTracingEnabled */.zu)() ||
    (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
    !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))
  ) {
    return;
  }

  const xhr = handlerData.xhr.__sentry_xhr__;

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp) {
    const spanId = handlerData.xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      span.setHttpStatus(xhr.status_code);
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  // if not, create a new span to track it
  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const span = activeTransaction.startChild({
      data: {
        ...xhr.data,
        type: 'xhr',
        method: xhr.method,
        url: xhr.url,
      },
      description: `${xhr.method} ${xhr.url}`,
      op: 'http.client',
    });

    handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[handlerData.xhr.__sentry_xhr_span_id__] = span;

    if (handlerData.xhr.setRequestHeader && shouldAttachHeaders(handlerData.xhr.__sentry_xhr__.url)) {
      try {
        handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());

        const dynamicSamplingContext = activeTransaction.getDynamicSamplingContext();
        const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);

        if (sentryBaggageHeader) {
          // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
          // We can therefore simply set a baggage header without checking what was there before
          // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
          handlerData.xhr.setRequestHeader(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
        }

        activeTransaction.metadata.propagations += 1;
      } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
      }
    }
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!types_WINDOW || !types_WINDOW.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = types_WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: types_WINDOW.location.pathname,
      op: 'pageload',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,instrument/* addInstrumentationHandler */.o)('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: types_WINDOW.location.pathname,
          op: 'navigation',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/browsertracing.js











const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  idleTimeout: idletransaction/* DEFAULT_IDLE_TIMEOUT */.nT,
  finalTimeout: idletransaction/* DEFAULT_FINAL_TIMEOUT */.mg,
  heartbeatInterval: idletransaction/* DEFAULT_HEARTBEAT_INTERVAL */.hd,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  _experiments: { enableLongTask: true },
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */
   __init() {this.name = BROWSER_TRACING_INTEGRATION_ID;}

   constructor(_options) {;BrowserTracing.prototype.__init.call(this);
    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    const { _metricOptions } = this.options;
    startTrackingWebVitals(_metricOptions && _metricOptions._reportAllChanges);
    if (_optionalChain([this, 'access', _2 => _2.options, 'access', _3 => _3._experiments, 'optionalAccess', _4 => _4.enableLongTask])) {
      startTrackingLongTasks();
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;

    // eslint-disable-next-line @typescript-eslint/unbound-method
    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
    } = this.options;

    instrumentRouting(
      (context) => this._createRouteTransaction(context),
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    instrumentOutgoingRequests({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    const sentryTraceMetaTagValue = isPageloadTransaction ? getMetaContent('sentry-trace') : null;
    const baggageMetaTagValue = isPageloadTransaction ? getMetaContent('baggage') : null;

    const traceParentData = sentryTraceMetaTagValue ? extractTraceparentData(sentryTraceMetaTagValue) : undefined;
    const dynamicSamplingContext = baggageMetaTagValue
      ? baggageHeaderToDynamicSamplingContext(baggageMetaTagValue)
      : undefined;

    const expandedContext = {
      ...context,
      ...traceParentData,
      metadata: {
        ...context.metadata,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
      trimEnd: true,
    };

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const hub = this._getCurrentHub();
    const { location } = types_WINDOW;

    const idleTransaction = (0,hubextensions/* startIdleTransaction */.lb)(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );
    idleTransaction.registerBeforeFinishCallback(transaction => {
      addPerformanceEntries(transaction);
      transaction.setTag(
        'sentry_reportAllChanges',
        Boolean(this.options._metricOptions && this.options._metricOptions._reportAllChanges),
      );
    });

    return idleTransaction ;
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : null;
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/index.js














;
;

// Treeshakable guard to remove all code related to tracing

// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
  // We are patching the global object with our hub extension methods
  (0,hubextensions/* addExtensionMethods */.ro)();
}
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/performance/client.js





const globalObject = helpers_WINDOW

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    if (props.pageProps._sentryBaggage) {
      nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
    }

    if (props.pageProps._sentryTraceData) {
      nextDataTagInfo.traceParentData = extractTraceparentData(props.pageProps._sentryTraceData);
    }
  }

  return nextDataTagInfo;
}

const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const { route, traceParentData, baggage, params } = extractNextDataTagInformation();
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    const dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

    activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      tags: DEFAULT_TAGS,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceParentData,
      metadata: {
        source,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    });
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const matchedRoute = getNextRouteFromPathname(stripUrlQueryAndFragment(navigationTarget));

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = navigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.finish();
      }

      const navigationTransaction = startTransactionCb({
        name: transactionName,
        op: 'navigation',
        tags,
        metadata: { source: transactionSource },
      });

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          description: 'Next.js Route Change',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.finish();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/utils/metadata.js


const PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: SDK_VERSION,
      })),
      version: SDK_VERSION,
    } );
}


//# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/utils/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  const match = keyPath.match(/([a-z_]+)\.(.*)/i);
  // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
  if (match === null) {
    obj[keyPath] = value;
  } else {
    // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
    const innerObj = obj[match[1]];
    setNestedKey(innerObj, match[2], value);
  }
}

/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 */
function addOrUpdateIntegration(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions = {},
) {
  return (
    Array.isArray(userIntegrations)
      ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions)
      : addOrUpdateIntegrationInFunction(
          defaultIntegrationInstance,
          // Somehow TS can't figure out that not being an array makes this necessarily a function
          userIntegrations ,
          forcedOptions,
        )
  ) ;
}

function addOrUpdateIntegrationInArray(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions,
) {
  const userInstance = userIntegrations.find(integration => integration.name === defaultIntegrationInstance.name);

  if (userInstance) {
    for (const [keyPath, value] of Object.entries(forcedOptions)) {
      setNestedKey(userInstance, keyPath, value);
    }

    return userIntegrations;
  }

  return [...userIntegrations, defaultIntegrationInstance];
}

function addOrUpdateIntegrationInFunction(
  defaultIntegrationInstance,
  userIntegrationsFunc,
  forcedOptions,
) {
  const wrapper = defaultIntegrations => {
    const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);

    // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
    // would do by providing a function which filters out the integration in question. If that's happened in one of
    // those cases, don't add our default back in.
    if (defaultIntegrationInstance.allowExclusionByUser) {
      const userFinalInstance = userFinalIntegrations.find(
        integration => integration.name === defaultIntegrationInstance.name,
      );
      if (!userFinalInstance) {
        return userFinalIntegrations;
      }
    }

    return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
  };

  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/index.client.js











// Treeshakable guard to remove all code related to tracing

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function index_client_init(options) {
  buildMetadata(options, ['nextjs', 'react']);
  options.environment = options.environment || "production";

  let integrations = options.integrations;

  // Guard below evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false"
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    // Only add BrowserTracing if a tracesSampleRate or tracesSampler is set
    if (options.tracesSampleRate !== undefined || options.tracesSampler !== undefined) {
      integrations = createClientIntegrations(options.integrations);
    }
  }

  sdk_init({
    ...options,
    integrations,
  });

  (0,esm_exports/* configureScope */.e)(scope => {
    scope.setTag('runtime', 'browser');
    const filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);
  });
}

function createClientIntegrations(userIntegrations = []) {
  const defaultBrowserTracingIntegration = new BrowserTracing({
    // eslint-disable-next-line deprecation/deprecation
    tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
    routingInstrumentation: nextRouterInstrumentation,
  });

  return addOrUpdateIntegration(defaultBrowserTracingIntegration, userIntegrations, {
    'options.routingInstrumentation': nextRouterInstrumentation,
  });
}


//# sourceMappingURL=index.client.js.map

// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__(4147);
;// CONCATENATED MODULE: ./sentry.client.config.js
/* provided dependency */ var process = __webpack_require__(34406);
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/





var SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN || "https://0b589ad6c5af46cdb3018e3de21bd1b1@o4504957609836544.ingest.sentry.io/4505071155871744";
var hostEnv = "production" || 0;
var nodeEnv = "production";
var enableSentry = hostEnv !== "development" && nodeEnv === "production";
index_client_init({
    // enabled: false,
    enabled: enableSentry,
    environment: hostEnv,
    dsn: SENTRY_DSN,
    // integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.1,
    sampleRate: 0.1,
    debug: hostEnv === "development",
    beforeSend: function beforeSend(event) {
        var request = event.request, breadcrumbs = event.breadcrumbs;
        var user = (event === null || event === void 0 ? void 0 : event.user) || {};
        var data = (request === null || request === void 0 ? void 0 : request.data) || {};
        var cookies = (request === null || request === void 0 ? void 0 : request.cookies) || {};
        var headers = (request === null || request === void 0 ? void 0 : request.headers) || {};
        var ref = (0,application/* anonymizeUserData */.inu)(data, user, cookies, headers), anonymizedData = ref.anonymizedData, anonymizedUserData = ref.anonymizedUserData, anonymizedCookies = ref.anonymizedCookies, anonymizedHeaders = ref.anonymizedHeaders;
        breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.forEach(function(breadcrumb) {
            var ref;
            if (breadcrumb === null || breadcrumb === void 0 ? void 0 : (ref = breadcrumb.message) === null || ref === void 0 ? void 0 : ref.includes("can reduce performance")) {
                breadcrumbs.splice(breadcrumbs.indexOf(breadcrumb), 1);
            }
        });
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event), {
            request: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, request), {
                data: anonymizedData,
                cookies: anonymizedCookies,
                headers: anonymizedHeaders
            }),
            user: anonymizedUserData
        });
    },
    beforeSendTransaction: function beforeSendTransaction(transaction) {
        var request = transaction.request;
        var user = (transaction === null || transaction === void 0 ? void 0 : transaction.user) || {};
        var data = (request === null || request === void 0 ? void 0 : request.data) || {};
        var cookies = (request === null || request === void 0 ? void 0 : request.cookies) || {};
        var headers = (request === null || request === void 0 ? void 0 : request.headers) || {};
        var ref = (0,application/* anonymizeUserData */.inu)(data, user, cookies, headers), anonymizedData = ref.anonymizedData, anonymizedUserData = ref.anonymizedUserData, anonymizedCookies = ref.anonymizedCookies, anonymizedHeaders = ref.anonymizedHeaders;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transaction), {
            request: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, request), {
                data: anonymizedData,
                cookies: anonymizedCookies,
                headers: anonymizedHeaders
            }),
            user: anonymizedUserData
        });
    },
    beforeBreadcrumb: function beforeBreadcrumb(breadcrumb) {
        var ref;
        if (breadcrumb === null || breadcrumb === void 0 ? void 0 : (ref = breadcrumb.message) === null || ref === void 0 ? void 0 : ref.includes("can reduce performance")) {
            return null;
        }
        return breadcrumb;
    },
    release: package_0/* version */.i8,
    sendDefaultPii: true,
    ignoreErrors: application/* dropListTerms */.PZS,
    tracesSampler: function(param) {
        var name = param.name, parentSampled = param.parentSampled;
        if (name === null || name === void 0 ? void 0 : name.includes("healthcheck")) {
            return 0.2;
        }
        if (name === null || name === void 0 ? void 0 : name.includes("auth")) {
            return 1;
        }
        // These are less important or happen much more frequently - only take 1%
        if (name === null || name === void 0 ? void 0 : name.includes("comment")) {
            return 0.01;
        }
        // Continue trace decision, if there is any parentSampled information
        if (typeof parentSampled === "boolean") {
            return parentSampled;
        }
        // eslint-disable-next-line array-callback-return, consistent-return
        application/* dropListTerms.map */.PZS.map(function(term) {
            if (name === null || name === void 0 ? void 0 : name.includes(term)) {
                return false;
            }
        });
        return 0.3;
    }
});


/***/ }),

/***/ 65253:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 33718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(12533)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(9788)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(30199)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(15154)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(2784));
var _head = _interop_require_default(__webpack_require__(75913));
var _imageConfig = __webpack_require__(18113);
var _useIntersection = __webpack_require__(22030);
var _imageConfigContext = __webpack_require__(20001);
var _utils = __webpack_require__(34750);
var _normalizeTrailingSlash = __webpack_require__(60583);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 39296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(19178)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(15154)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _router = __webpack_require__(29918);
var _addLocale = __webpack_require__(94400);
var _routerContext = __webpack_require__(33220);
var _appRouterContext = __webpack_require__(64069);
var _useIntersection = __webpack_require__(22030);
var _getDomainLocale = __webpack_require__(65253);
var _addBasePath = __webpack_require__(73952);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 22030:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(2784);
var _requestIdleCallback = __webpack_require__(49071);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 64069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( true ? __webpack_require__(2784) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 64462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zt": function() { return /* binding */ BranchLocationProvider; },
/* harmony export */   "vK": function() { return /* binding */ useBranchLocation; }
/* harmony export */ });
/* unused harmony export BranchLocationContext */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50853);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90162);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _hooks_Toast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26052);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83428);
/* harmony import */ var _BroadcastChannel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25320);
/* harmony import */ var _WebSocket__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91393);









var BranchLocationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var BranchLocationProvider = function(param) {
    var children = param.children, cookie = param.cookie, appMonitoringClient = param.appMonitoringClient, shippingApi = param.shippingApi;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), locationBranches = ref[0], setLocationBranches = ref[1];
    var addToast = (0,_hooks_Toast__WEBPACK_IMPORTED_MODULE_2__.useToast)().addToast;
    var emitEvent = (0,_WebSocket__WEBPACK_IMPORTED_MODULE_5__.useWebSocket)().emitEvent;
    var ref1 = (0,_BroadcastChannel__WEBPACK_IMPORTED_MODULE_4__/* .useBrowserBroadcast */ .X)(), createChannel = ref1.createChannel, postMessage = ref1.postMessage, onMessage = ref1.onMessage, isChannelOpen = ref1.isChannelOpen, getChannelName = ref1.getChannelName;
    var ref2 = shippingApi.getBranches(), branches = ref2.data;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref3[0], setIsOpen = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), statementDropdownBranchLocation = ref4[0], setStatementDropdownBranchLocation = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isChangingClientLocation = ref5[0], setIsChangingClientLocation = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), regionClientLocation = ref6[0], setRegionClientLocation = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), clientLocation = ref7[0], setClientLocation = ref7[1];
    var onOpenModalBranchLocation = function() {
        setIsOpen(true);
    };
    var onCloseModalBranchLocation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(cookieImpl, branchId) {
        cookieImpl.setCookie({
            name: _utils__WEBPACK_IMPORTED_MODULE_3__/* .cookieModalBranchLocationStr */ .wW,
            value: branchId !== null && branchId !== void 0 ? branchId : "2",
            options: _utils__WEBPACK_IMPORTED_MODULE_3__/* .optionsMaxAgeEqualOneYear.options */ .AW.options
        });
        setIsOpen(false);
    }, []);
    var otherRegionsStr = "Demais Regi\xf5es";
    var defineClientLocation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(location) {
        setIsChangingClientLocation(true);
        cookie.setCookie({
            name: _utils__WEBPACK_IMPORTED_MODULE_3__/* .cookieBranchLocationStr */ .NL,
            value: "".concat(location === null || location === void 0 ? void 0 : location.clientBranchId),
            options: _utils__WEBPACK_IMPORTED_MODULE_3__/* .optionsMaxAgeEqualOneYear.options */ .AW.options
        });
        cookie.setCookie({
            name: _utils__WEBPACK_IMPORTED_MODULE_3__/* .cookieRegionStr */ .us,
            value: "".concat(location === null || location === void 0 ? void 0 : location.clientLocation),
            options: _utils__WEBPACK_IMPORTED_MODULE_3__/* .optionsMaxAgeEqualOneYear.options */ .AW.options
        });
        setClientLocation(location);
        onCloseModalBranchLocation(cookie, String(location === null || location === void 0 ? void 0 : location.clientBranchId));
        setRegionClientLocation(location === null || location === void 0 ? void 0 : location.clientLocation);
    }, [
        cookie,
        onCloseModalBranchLocation
    ]);
    var applyClientLocation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(defaultRouter) {
        if (defaultRouter) {
            var ref, ref1;
            var currentUrlWithoutQueryParams = (ref1 = (ref = defaultRouter.asPath) === null || ref === void 0 ? void 0 : ref.split("?")) === null || ref1 === void 0 ? void 0 : ref1[0];
            defaultRouter.replace(currentUrlWithoutQueryParams);
            setTimeout(function() {
                defaultRouter.reload();
                setIsChangingClientLocation(false);
            }, 250);
        } else {
            var currentUrlWithoutQueryParams1 = window.location.href.split("?")[0];
            window.location.replace(currentUrlWithoutQueryParams1);
            setTimeout(function() {
                window.location.reload();
                setIsChangingClientLocation(false);
            }, 250);
        }
    }, []);
    var setDefaultBranchLocation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(branchId) {
        var ref;
        var locationName = branchId ? ((ref = locationBranches === null || locationBranches === void 0 ? void 0 : locationBranches.find(function(locationBranch) {
            return (locationBranch === null || locationBranch === void 0 ? void 0 : locationBranch.branchId) === Number(branchId);
        })) === null || ref === void 0 ? void 0 : ref.city) || otherRegionsStr : otherRegionsStr;
        var locationBranchId = branchId || "2";
        if (branchId && locationName !== otherRegionsStr) {
            setRegionClientLocation(locationName);
        }
        cookie.setCookie({
            name: _utils__WEBPACK_IMPORTED_MODULE_3__/* .cookieBranchLocationStr */ .NL,
            value: locationBranchId,
            options: _utils__WEBPACK_IMPORTED_MODULE_3__/* .optionsMaxAgeEqualOneYear.options */ .AW.options
        });
        cookie.setCookie({
            name: _utils__WEBPACK_IMPORTED_MODULE_3__/* .cookieRegionStr */ .us,
            value: locationName,
            options: _utils__WEBPACK_IMPORTED_MODULE_3__/* .optionsMaxAgeEqualOneYear.options */ .AW.options
        });
    }, [
        cookie,
        locationBranches
    ]);
    var onShowDropdown = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var hadVisualization = cookie.getCookie({
            name: _utils__WEBPACK_IMPORTED_MODULE_3__/* .cookieBranchLocationStr */ .NL
        });
        if (!hadVisualization) {
            setStatementDropdownBranchLocation(true);
        }
    }, [
        cookie
    ]);
    var getLocationBranch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(formattedClientLocation, city) {
        var ref;
        var clientBranchId = (ref = locationBranches === null || locationBranches === void 0 ? void 0 : locationBranches.find(function(locationBranch) {
            var ref;
            return (locationBranch === null || locationBranch === void 0 ? void 0 : (ref = locationBranch.city) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (city === null || city === void 0 ? void 0 : city.toLowerCase());
        })) === null || ref === void 0 ? void 0 : ref.branchId;
        if (!clientBranchId) {
            return {
                clientBranchId: 2,
                clientLocation: formattedClientLocation
            };
        }
        return {
            clientBranchId: clientBranchId,
            clientLocation: formattedClientLocation
        };
    }, [
        locationBranches
    ]);
    var getBranchLocationClient = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var branchLocation = cookie.getCookie({
            name: _utils__WEBPACK_IMPORTED_MODULE_3__/* .cookieBranchLocationStr */ .NL
        });
        if (!branchLocation) {
            return "2";
        }
        return branchLocation;
    }, [
        cookie
    ]);
    var handleClientLocationByHimCurrentLocation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(defaultRouter) {
        var onClientSelectHimCurrentLocation = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                var ref;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                    navigator === null || navigator === void 0 ? void 0 : (ref = navigator.geolocation) === null || ref === void 0 ? void 0 : ref.getCurrentPosition(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                        var data, ref, clientBranchId, currentClientLocation, location, lastBranchLocationId;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    // `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=YOUR_API_KEY`
                                    setIsChangingClientLocation(true);
                                    return [
                                        4,
                                        axios__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get("https://ipapi.co/json/")
                                    ];
                                case 1:
                                    data = _state.sent().data;
                                    ref = getLocationBranch("".concat(data.city, " - ").concat(data.region_code), data.city), clientBranchId = ref.clientBranchId, currentClientLocation = ref.clientLocation;
                                    location = {
                                        clientBranchId: clientBranchId,
                                        clientLocation: currentClientLocation,
                                        clientPostalCode: data.postal
                                    };
                                    lastBranchLocationId = cookie.getCookie({
                                        name: _utils__WEBPACK_IMPORTED_MODULE_3__/* .cookieBranchLocationStr */ .NL
                                    });
                                    defineClientLocation(location);
                                    if (lastBranchLocationId === String(clientBranchId)) {
                                        setIsChangingClientLocation(false);
                                        return [
                                            2
                                        ];
                                    }
                                    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("clientBranchIdChangedMessage", "Alteramos o seu carrinho para ".concat(location === null || location === void 0 ? void 0 : location.clientLocation));
                                    emitEvent("branchChanged", location);
                                    postMessage(JSON.stringify(location));
                                    applyClientLocation(defaultRouter);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }), function(error) {
                        appMonitoringClient.captureException(error, {
                            level: "error",
                            tags: {
                                fcx_labs_error_source: "navigator_geolocation_getCurrentPosition"
                            }
                        });
                    });
                    return [
                        2
                    ];
                });
            });
            return function onClientSelectHimCurrentLocation() {
                return _ref.apply(this, arguments);
            };
        }();
        onClientSelectHimCurrentLocation();
    }, [
        appMonitoringClient,
        applyClientLocation,
        cookie,
        defineClientLocation,
        emitEvent,
        getLocationBranch,
        postMessage, 
    ]);
    var handleLocationBySubmit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(zipCode, cityAndState, clientBranchId, defaultRouter) {
        var fetchZipCode = function() {
            setIsChangingClientLocation(true);
            var currentClientLocation = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .formatLocationName */ .mX)(cityAndState);
            var lastBranchLocationId = cookie.getCookie({
                name: _utils__WEBPACK_IMPORTED_MODULE_3__/* .cookieBranchLocationStr */ .NL
            });
            var location = {
                clientBranchId: clientBranchId,
                clientLocation: currentClientLocation,
                clientPostalCode: zipCode || ""
            };
            defineClientLocation(location);
            if (lastBranchLocationId === String(clientBranchId)) {
                setIsChangingClientLocation(false);
                return;
            }
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("clientBranchIdChangedMessage", "Alteramos o seu carrinho para ".concat(location === null || location === void 0 ? void 0 : location.clientLocation));
            emitEvent("branchChanged", location);
            postMessage(JSON.stringify(location));
            applyClientLocation(defaultRouter);
        };
        fetchZipCode();
    }, [
        applyClientLocation,
        cookie,
        defineClientLocation,
        emitEvent,
        postMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        setLocationBranches(branches);
    }, [
        branches
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return onShowDropdown();
    }, [
        onShowDropdown
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var getRegionClient = function() {
            var region = cookie.getCookie({
                name: _utils__WEBPACK_IMPORTED_MODULE_3__/* .cookieRegionStr */ .us
            });
            if (!region) {
                return null;
            }
            return region;
        };
        setRegionClientLocation(getRegionClient());
    }, [
        cookie
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isChannelOpen) {
            onMessage(function(message) {
                var broadCastedLocation = JSON.parse(message);
                if (broadCastedLocation.clientLocation !== clientLocation.clientLocation) {
                    addToast({
                        title: "Alteramos o seu carrinho para outra regi\xe3o",
                        type: "info",
                        timerInMilliseconds: 3500
                    });
                    defineClientLocation(broadCastedLocation);
                    setIsChangingClientLocation(false);
                    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("clientBranchIdChangedMessage", "Alteramos o seu carrinho para ".concat(broadCastedLocation === null || broadCastedLocation === void 0 ? void 0 : broadCastedLocation.clientLocation));
                    applyClientLocation();
                }
            });
        }
    }, [
        addToast,
        applyClientLocation,
        clientLocation.clientBranchId,
        clientLocation.clientLocation,
        defineClientLocation,
        isChannelOpen,
        onMessage, 
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var clientBranchIdChangedMessage = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("clientBranchIdChangedMessage");
        var clientHasCartItems = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("clientHasCartItems");
        if (clientBranchIdChangedMessage) {
            if (clientHasCartItems && clientHasCartItems === "true") {
                setTimeout(function() {
                    addToast({
                        title: clientBranchIdChangedMessage,
                        type: "info",
                        timerInMilliseconds: 3500
                    });
                }, 400);
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem("clientHasCartItems");
            }
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem("clientBranchIdChangedMessage");
        }
    }, [
        addToast
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isChannelOpen && getChannelName() !== "user-branch") {
            createChannel("user-branch");
        }
    }, [
        createChannel,
        getChannelName,
        isChannelOpen
    ]);
    var branchLocationContextProviderValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            clientLocation: clientLocation,
            isOpen: isOpen,
            statementDropdownBranchLocation: statementDropdownBranchLocation,
            onOpenModalBranchLocation: onOpenModalBranchLocation,
            onCloseModalBranchLocation: onCloseModalBranchLocation,
            handleClientLocationByHimCurrentLocation: handleClientLocationByHimCurrentLocation,
            handleLocationBySubmit: handleLocationBySubmit,
            regionClientLocation: regionClientLocation,
            setDefaultBranchLocation: setDefaultBranchLocation,
            getBranchLocationClient: getBranchLocationClient,
            setRegionClientLocation: setRegionClientLocation,
            isChangingClientLocation: isChangingClientLocation
        };
    }, [
        clientLocation,
        isOpen,
        statementDropdownBranchLocation,
        onCloseModalBranchLocation,
        handleClientLocationByHimCurrentLocation,
        handleLocationBySubmit,
        regionClientLocation,
        setDefaultBranchLocation,
        getBranchLocationClient,
        isChangingClientLocation, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BranchLocationContext.Provider, {
        value: branchLocationContextProviderValue,
        children: children
    });
};
var useBranchLocation = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(BranchLocationContext);
    if (!context) {
        throw new Error("useBranchLocation must be used within an BranchLocationProvider");
    }
    return context;
};


/***/ }),

/***/ 25320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ME": function() { return /* binding */ BroadcastChannelProvider; },
/* harmony export */   "X": function() { return /* binding */ useBrowserBroadcast; }
/* harmony export */ });
/* unused harmony export BroadcastChannelContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var BroadcastChannelContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var BroadcastChannelProvider = function(param) {
    var children = param.children, broadcastChannelClient = param.broadcastChannelClient;
    var createChannel = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(channelName) {
        broadcastChannelClient.createChannel(channelName);
    }, [
        broadcastChannelClient
    ]);
    var closeChannel = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        broadcastChannelClient.closeChannel();
    }, [
        broadcastChannelClient
    ]);
    var postMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(message) {
        broadcastChannelClient.postMessage(message);
    }, [
        broadcastChannelClient
    ]);
    var onMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(callback) {
        broadcastChannelClient.onMessage(callback);
    }, [
        broadcastChannelClient
    ]);
    var getChannelName = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return broadcastChannelClient.getChannelName();
    }, [
        broadcastChannelClient
    ]);
    var isChannelOpen = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return broadcastChannelClient.getIsChannelOpen();
    }, [
        broadcastChannelClient
    ]);
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            createChannel: createChannel,
            closeChannel: closeChannel,
            postMessage: postMessage,
            onMessage: onMessage,
            getChannelName: getChannelName,
            isChannelOpen: isChannelOpen
        };
    }, [
        createChannel,
        closeChannel,
        postMessage,
        onMessage,
        getChannelName,
        isChannelOpen, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BroadcastChannelContext.Provider, {
        value: contextValue,
        children: children
    });
};
var useBrowserBroadcast = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(BroadcastChannelContext);
    if (!context) {
        throw new Error("useBrowserBroadcast must be used within an BroadcastChannelContext");
    }
    return context;
};


/***/ }),

/***/ 79203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CardsProvider": function() { return /* binding */ CardsProvider; },
/* harmony export */   "useCards": function() { return /* binding */ useCards; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50853);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _Identity_AuthContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24452);
/* harmony import */ var _hooks_Toast__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26052);








var CardsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({});
var CardsProvider = function(param) {
    var children = param.children, paymentApi = param.paymentApi, appMonitoringClient = param.appMonitoringClient;
    var ref;
    var getTokens = (0,_Identity_AuthContext__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .aC)().getTokens;
    var addToast = (0,_hooks_Toast__WEBPACK_IMPORTED_MODULE_4__.useToast)().addToast;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), setHadFetchCreateCreditCard = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isCreatingCreditCard = ref2[0], setIsCreatingCreditCard = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), setIsCreateCardOpen = ref3[0];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var allowedRoutesToGetCards = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return [
            "/conta/meus-cartoes",
            "/checkout/pagamento",
            "/checkout/pagamento/[groupId]", 
        ];
    }, []);
    var ref4 = paymentApi.getCards(accessToken, appMonitoringClient, !!accessToken && (allowedRoutesToGetCards === null || allowedRoutesToGetCards === void 0 ? void 0 : allowedRoutesToGetCards.includes(router.pathname))), cards = ref4.data, error = ref4.error, isLoading = ref4.isLoading, triggerGetCards = ref4.trigger;
    var cardsResponse = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            cards: cards,
            error: error,
            isLoading: isLoading
        };
    }, [
        cards,
        error,
        isLoading
    ]);
    var onManagementStateToRenderSetCards = function() {
        setHadFetchCreateCreditCard(function(state) {
            return !state;
        });
    };
    var createCreditCard = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(item) {
            var isShouldTrigger, ref, ref1, ref2, ref3, ref4, card, cardIdFC, createCardResponseErrorMessage, createCardResponseAnotherErrorMessage, errorMessage;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isShouldTrigger = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                        setIsCreatingCreditCard(true);
                        if (item.expYear.length === 2) {
                            // eslint-disable-next-line no-param-reassign
                            item.expYear = "20".concat(item.expYear);
                        }
                        return [
                            4,
                            paymentApi.createCard((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, item, item.expYear.length === 2 && {
                                expYear: "20".concat(item.expYear)
                            }), (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token)
                        ];
                    case 1:
                        card = _state.sent();
                        setIsCreatingCreditCard(false);
                        cardIdFC = card.cardIdFC;
                        createCardResponseErrorMessage = card === null || card === void 0 ? void 0 : (ref1 = card.errors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Messages) === null || ref2 === void 0 ? void 0 : ref2[0];
                        createCardResponseAnotherErrorMessage = card === null || card === void 0 ? void 0 : (ref3 = card.errors) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.errorMessage;
                        errorMessage = createCardResponseErrorMessage || createCardResponseAnotherErrorMessage;
                        if (!cardIdFC || errorMessage) {
                            addToast({
                                title: errorMessage || "Algo deu errado ao criar o cart\xe3o",
                                showProgressBar: true,
                                timerInMilliseconds: 5000,
                                type: "error"
                            });
                            return [
                                2,
                                0
                            ];
                        }
                        if (isShouldTrigger && triggerGetCards) {
                            triggerGetCards();
                        }
                        onManagementStateToRenderSetCards();
                        if (cardIdFC) {
                            addToast({
                                title: "Cart\xe3o adicionado com sucesso!",
                                description: "Seu cart\xe3o foi registrado com sucesso.",
                                type: "success",
                                isNewToast: true,
                                newToastTheme: "light",
                                timerInMilliseconds: 3000
                            });
                        }
                        return [
                            2,
                            cardIdFC
                        ];
                }
            });
        });
        return function(item) {
            return _ref.apply(this, arguments);
        };
    }(), [
        paymentApi,
        getTokens,
        triggerGetCards,
        addToast
    ]);
    var deleteCreditCard = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(id) {
            var message, responseDelete;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        message = "Voc\xea tem certeza que deseja excluir este cart\xe3o?";
                        if (!(window === null || window === void 0 ? void 0 : window.confirm(message))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            paymentApi.deleteCard(id, accessToken)
                        ];
                    case 1:
                        responseDelete = _state.sent();
                        if (triggerGetCards) {
                            triggerGetCards();
                        }
                        if (responseDelete) {
                            addToast({
                                title: "Cart\xe3o deletado com sucesso!",
                                type: "success"
                            });
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(), [
        paymentApi,
        accessToken,
        triggerGetCards,
        addToast
    ]);
    var cardsProviderValues = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            cardsResponse: cardsResponse,
            createCreditCard: createCreditCard,
            deleteCreditCard: deleteCreditCard,
            isCreatingCreditCard: isCreatingCreditCard,
            setIsCreateCardOpen: setIsCreateCardOpen
        };
    }, [
        cardsResponse,
        createCreditCard,
        deleteCreditCard,
        isCreatingCreditCard,
        setIsCreateCardOpen, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsContext.Provider, {
        value: cardsProviderValues,
        children: children
    });
};
var useCards = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(CardsContext);
    if (!context) {
        throw new Error("useCards must be used within CardsProvider");
    }
    return context;
};


/***/ }),

/***/ 38672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ CookiesProvider; },
/* harmony export */   "f": function() { return /* binding */ useCookies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var cookieForCookies = "@FC:Ecom:Cookie:HadVisualization";
var optionsMaxAgeEqualOneYear = {
    options: {
        maxAge: 60 * 60 * 24 * 365
    }
};
var CookiesContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var CookiesProvider = function(param) {
    var children = param.children, cookie = param.cookie, heatmapClient = param.heatmapClient;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), statementCookiesModal = ref[0], setStatementCookiesModal = ref[1];
    var handleCloseCookiesModal = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setStatementCookiesModal(false);
        heatmapClient.cookieConsent();
        cookie.setCookie({
            name: cookieForCookies,
            value: String(true),
            options: optionsMaxAgeEqualOneYear.options
        });
    }, [
        cookie,
        heatmapClient
    ]);
    var onShowCookiesModal = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var hadVisualization = cookie.getCookie({
            name: cookieForCookies
        });
        if (!hadVisualization) {
            setStatementCookiesModal(true);
        }
    }, [
        cookie
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return onShowCookiesModal();
    }, [
        onShowCookiesModal
    ]);
    var cookiesContextProviderValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            statementCookiesModal: statementCookiesModal,
            handleCloseCookiesModal: handleCloseCookiesModal
        };
    }, [
        handleCloseCookiesModal,
        statementCookiesModal
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CookiesContext.Provider, {
        value: cookiesContextProviderValue,
        children: children
    });
};
var useCookies = function() {
    var cookiesContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CookiesContext);
    if (!cookiesContext) {
        throw new Error("useCookies must be used within an CookiesProvider");
    }
    return cookiesContext;
};


/***/ }),

/***/ 44278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EventListenerContext": function() { return /* binding */ EventListenerContext; },
/* harmony export */   "EventListenerProvider": function() { return /* binding */ EventListenerProvider; },
/* harmony export */   "useEventListener": function() { return /* binding */ useEventListener; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _hooks_Toast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26052);
/* harmony import */ var _utils_misc_branchLocation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2709);
/* harmony import */ var _Purchase_PurchaseContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25371);
/* harmony import */ var _ShoppingHookContext_CartContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9521);
/* harmony import */ var _WebSocket__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91393);
/* harmony import */ var _BranchLocationContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64462);









var checkoutPaymentUrlPath = "/checkout/pagamento";
var defaultLocation = "Demais Regi\xf5es";
var EventListenerContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(null);
var EventListenerProvider = function(param) {
    var children = param.children, cookie = param.cookie;
    var ref = (0,_Purchase_PurchaseContext__WEBPACK_IMPORTED_MODULE_5__.usePurchase)(), step = ref.step, changeStep = ref.changeStep, clearPackageShipping = ref.clearPackageShipping;
    var fetchCart = (0,_ShoppingHookContext_CartContext__WEBPACK_IMPORTED_MODULE_6__/* .useCartContext */ .iQ)().fetchCart;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var addToast = (0,_hooks_Toast__WEBPACK_IMPORTED_MODULE_3__.useToast)().addToast;
    var ref1 = (0,_WebSocket__WEBPACK_IMPORTED_MODULE_7__.useWebSocket)(), subscribeToEvents = ref1.subscribeToEvents, unsubscribeFromEvents = ref1.unsubscribeFromEvents;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isFirstRender = ref2[0], setIsFirstRender = ref2[1];
    var triggerGetCartOptions = (0,_Purchase_PurchaseContext__WEBPACK_IMPORTED_MODULE_5__.usePurchase)().triggerGetCartOptions;
    var setRegionClientLocation = (0,_BranchLocationContext__WEBPACK_IMPORTED_MODULE_8__/* .useBranchLocation */ .vK)().setRegionClientLocation;
    var handleChangesOnClientBranch = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var _clientLocation = param.clientLocation, clientLocation = _clientLocation === void 0 ? undefined : _clientLocation, _clientPostalCode = param.clientPostalCode, clientPostalCode = _clientPostalCode === void 0 ? undefined : _clientPostalCode, _clientBranchId = param.clientBranchId, clientBranchId = _clientBranchId === void 0 ? undefined : _clientBranchId, shouldRedirectToHome = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, currentPathname = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        var ref = (0,_utils_misc_branchLocation__WEBPACK_IMPORTED_MODULE_4__/* .getClientLocationDetails */ .tK)(cookie), currentClientLocation = ref.clientLocation, currentClientPostalCode = ref.clientPostalCode, currentClientBranchId = ref.clientBranchId;
        setRegionClientLocation(clientLocation || currentClientLocation || defaultLocation);
        if (clientLocation !== undefined && clientLocation !== currentClientLocation) {
            cookie.setCookie({
                name: _utils_misc_branchLocation__WEBPACK_IMPORTED_MODULE_4__/* .cookieRegionStr */ .us,
                value: "".concat(clientLocation || defaultLocation),
                options: _utils_misc_branchLocation__WEBPACK_IMPORTED_MODULE_4__/* .optionsMaxAgeEqualOneYear.options */ .AW.options
            });
        }
        if (clientPostalCode !== undefined && clientPostalCode !== currentClientPostalCode) {
            cookie.setCookie({
                name: _utils_misc_branchLocation__WEBPACK_IMPORTED_MODULE_4__/* .cookiePostalCodeStr */ .em,
                value: "".concat(clientPostalCode),
                options: _utils_misc_branchLocation__WEBPACK_IMPORTED_MODULE_4__/* .optionsMaxAgeEqualOneYear.options */ .AW.options
            });
        }
        if (clientBranchId !== undefined && Number(clientBranchId) !== currentClientBranchId) {
            cookie.setCookie({
                name: _utils_misc_branchLocation__WEBPACK_IMPORTED_MODULE_4__/* .cookieBranchLocationStr */ .NL,
                value: "".concat(clientBranchId),
                options: _utils_misc_branchLocation__WEBPACK_IMPORTED_MODULE_4__/* .optionsMaxAgeEqualOneYear.options */ .AW.options
            });
            if (shouldRedirectToHome) {
                router.push("/");
            }
            if (currentPathname === null || currentPathname === void 0 ? void 0 : currentPathname.includes("/produto/")) {
                router.replace(currentPathname, undefined, {
                    shallow: true
                });
            }
            setTimeout(function() {
                router.reload();
            }, 3000);
            return clientLocation || "";
        }
        return "";
    }, [
        cookie,
        router,
        setRegionClientLocation
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isFirstRender) {
            subscribeToEvents([
                "cartModified",
                "branchChanged",
                "login"
            ], function(data) {
                var ref;
                fetchCart(true);
                var currentPathname = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname;
                if (currentPathname === checkoutPaymentUrlPath) {
                    clearPackageShipping();
                    changeStep(2);
                    if (triggerGetCartOptions) {
                        triggerGetCartOptions();
                    }
                }
                var formattedData = data;
                var newClientLocation = handleChangesOnClientBranch((formattedData === null || formattedData === void 0 ? void 0 : formattedData.detail) || {}, [
                    checkoutPaymentUrlPath
                ].includes(currentPathname), currentPathname);
                addToast({
                    title: newClientLocation ? "O seu carrinho foi alterado para ".concat(newClientLocation) : "O seu carrinho foi atualizado",
                    type: "info",
                    timerInMilliseconds: 3000
                });
            });
            setIsFirstRender(false);
        }
    }, [
        addToast,
        changeStep,
        clearPackageShipping,
        cookie,
        fetchCart,
        handleChangesOnClientBranch,
        isFirstRender,
        router,
        step,
        subscribeToEvents,
        triggerGetCartOptions,
        unsubscribeFromEvents, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EventListenerContext.Provider, {
        value: null,
        children: children
    });
};
var useEventListener = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(EventListenerContext);
    if (!context) {
        throw new Error("useEventListener must be used within an EventListenerProvider");
    }
    return context;
};


/***/ }),

/***/ 24452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ho": function() { return /* binding */ AuthProvider; },
/* harmony export */   "aC": function() { return /* binding */ useAuth; }
/* harmony export */ });
/* unused harmony export AuthContext */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50853);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23848);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var zustand_react_shallow__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94534);
/* harmony import */ var _hooks_Countdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48561);
/* harmony import */ var _hooks_Toast__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26052);
/* harmony import */ var _state_manager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74224);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83428);
/* harmony import */ var _ModalGroupContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81898);
/* harmony import */ var _ShoppingHookContext_utilsCart__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61485);
/* harmony import */ var _WebSocket__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91393);
















var cookieModalToConfirmEmail = "@FC:Ecom:ModalToConfirmEmail:HadVisualization";
var cookieStoreCEP = "@FC:Ecom:Dropdown:Cep";
var keyZipCode = "@FC:Ecom:Dropdown:Cep";
// deepcode ignore HardcodedNonCryptoSecret: não é uma secret, apenas o valor da key que terá o secret como value
var accessTokenCookieKey = "@FC:Ecom:Token:Access";
// deepcode ignore HardcodedNonCryptoSecret: não é uma secret, apenas o valor da key que terá o secret como value
var refreshTokenCookieKey = "@FC:Ecom:Token:Refresh";
// deepcode ignore HardcodedNonCryptoSecret: não é uma secret, apenas o valor da key que terá o secret como value
var accessTokenGoogleCookieKey = "@FC:Ecom:Token:Access:google";
// deepcode ignore HardcodedNonCryptoSecret: não é uma secret, apenas o valor da key que terá o secret como value
var accessTokenAppleCookieKey = "@FC:Ecom:Token:Access:apple";
var myPanelStr = "meu-painel";
var googleTagManagerEmailUser = "ECO-UserEmail";
var optionsMaxAgeEqualSixMonth = {
    options: {
        maxAge: 60 * 60 * 24 * 182
    }
};
var optionsMaxAgeEqualOneYear = {
    options: {
        maxAge: 60 * 60 * 24 * 365
    }
};
var AuthContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createContext)({});
var useAuth = function() {
    var authContext = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(AuthContext);
    if (!authContext) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return authContext;
};
// interface AuthWindowProps {
//   provider: oAuth;
//   status: "authenticated" | "loading" | "unauthenticated";
// }
// const providerUrl = {
//   google: "/sign-in/google",
//   apple: "/sign-in/apple",
// };
// const AuthWindow = ({ provider, status }: AuthWindowProps) => {
//   const oAuthWindowRef = useRef<boolean | null>(null);
//   const { onChangeStateFromInitial } = useAuth();
//   const handleCloseNewAuthWindow = useCallback(() => {
//     if (oAuthWindowRef.current) {
//       onChangeStateFromInitial();
//       oAuthWindowRef.current = null;
//     }
//   }, [onChangeStateFromInitial]);
//   useEffect(() => {
//     if (provider === "apple" && status === "authenticated") window.close();
//   }, [provider, status]);
//   useEffect(() => {
//     if (provider) {
//       oAuthWindowRef.current = true;
//     }
//     document.body.addEventListener("click", handleCloseNewAuthWindow, true);
//   }, [provider, handleCloseNewAuthWindow]);
//   return (
//     <AuthWindowContainer
//       ref={oAuthWindowRef as unknown as Ref<NewWindow>}
//       url={providerUrl[provider as "google" | "apple"]}
//     />
//   );
// };
var AuthProvider = function(param) {
    var children = param.children, identityApi = param.identityApi, appMonitoringClient = param.appMonitoringClient, cookie = param.cookie, purchaseApi = param.purchaseApi, jwtDecoder = param.jwtDecoder, heatmapClient = param.heatmapClient, profileApi = param.profileApi;
    var ref = (0,_state_manager__WEBPACK_IMPORTED_MODULE_6__/* .useChatbot */ .dp)((0,zustand_react_shallow__WEBPACK_IMPORTED_MODULE_11__/* .useShallow */ .N)(function(state) {
        return {
            setShowChatbot: state.setShowChatbot,
            setShowSaleChatbot: state.setShowSaleChatbot
        };
    })), setShowChatbot = ref.setShowChatbot, setShowSaleChatbot = ref.setShowSaleChatbot;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}), userData = ref1[0], setUserData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(undefined), isAuthenticated = ref2[0], setIsAuthenticated = ref2[1];
    // const [isToOpenNewOAuthWindow, setIsToOpenNewOAuthWindow] =
    //   useState<boolean>(false);
    var allConfigs = (0,_state_manager__WEBPACK_IMPORTED_MODULE_6__/* .useEnvs */ .HS)(function(state) {
        return state.allConfigs;
    });
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), authWindowProvider = ref3[0], setAuthWindowProvider = ref3[1];
    var ref4 = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.useSession)(), session = ref4.data, status = ref4.status;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var addToast = (0,_hooks_Toast__WEBPACK_IMPORTED_MODULE_5__.useToast)().addToast;
    var ref5 = (0,_ModalGroupContext__WEBPACK_IMPORTED_MODULE_8__.useModalGroup)(), handleTriggerModalEmailConfirmation = ref5.handleTriggerModalEmailConfirmation, handleTriggerModalChangePassword = ref5.handleTriggerModalChangePassword;
    var changeConditionToStartCountdown = (0,_hooks_Countdown__WEBPACK_IMPORTED_MODULE_4__.useCountdown)().changeConditionToStartCountdown;
    var setUserCrmId = (0,_state_manager__WEBPACK_IMPORTED_MODULE_6__/* .useCrm */ .K3)(function(state) {
        return state.setUserCrmId;
    });
    var ref6 = (0,_WebSocket__WEBPACK_IMPORTED_MODULE_10__.useWebSocket)(), createWebSocketConnection = ref6.createWebSocketConnection, destroyWebSocketConnection = ref6.destroyWebSocketConnection, emitEventClientLogin = ref6.emitEventClientLogin;
    var ref7 = (0,_state_manager__WEBPACK_IMPORTED_MODULE_6__/* .useRegisterPhoneNumber */ .KH)((0,zustand_react_shallow__WEBPACK_IMPORTED_MODULE_11__/* .useShallow */ .N)(function(state) {
        return {
            setIsRegisterPhoneNumberModalOpen: state.setIsRegisterPhoneNumberModalOpen,
            changeCurrentStep: state.changeCurrentStep
        };
    })), setIsRegisterPhoneNumberModalOpen = ref7.setIsRegisterPhoneNumberModalOpen, changeCurrentStep = ref7.changeCurrentStep;
    var setIsValidationActive = (0,_state_manager__WEBPACK_IMPORTED_MODULE_6__/* .useTwoFactor */ .kD)((0,zustand_react_shallow__WEBPACK_IMPORTED_MODULE_11__/* .useShallow */ .N)(function(state) {
        return {
            setIsValidationActive: state.setIsValidationActive
        };
    })).setIsValidationActive;
    var ref8 = (0,_state_manager__WEBPACK_IMPORTED_MODULE_6__/* .useLoginAuthentication */ .VQ)((0,zustand_react_shallow__WEBPACK_IMPORTED_MODULE_11__/* .useShallow */ .N)(function(state) {
        return {
            setIsLoginAuthenticationModalOpen: state.setIsLoginAuthenticationModalOpen,
            changeLoginStep: state.changeLoginStep,
            setIsPhoneValidationModalOpen: state.setIsPhoneValidationModalOpen,
            changeValidationStep: state.changeValidationStep
        };
    })), setIsLoginAuthenticationModalOpen = ref8.setIsLoginAuthenticationModalOpen, changeLoginStep = ref8.changeLoginStep, setIsPhoneValidationModalOpen = ref8.setIsPhoneValidationModalOpen, changeValidationStep = ref8.changeValidationStep;
    var ref9 = (0,_state_manager__WEBPACK_IMPORTED_MODULE_6__/* .useUniqueClient */ .NG)((0,zustand_react_shallow__WEBPACK_IMPORTED_MODULE_11__/* .useShallow */ .N)(function(state) {
        return {
            setIsUniqueClientModalOpen: state.setIsUniqueClientModalOpen,
            setUniqueClientInfo: state.setUniqueClientInfo,
            changeUniqueClientStep: state.changeUniqueClientStep
        };
    })), setIsUniqueClientModalOpen = ref9.setIsUniqueClientModalOpen, setUniqueClientInfo = ref9.setUniqueClientInfo, changeUniqueClientStep = ref9.changeUniqueClientStep;
    var setAvailableMethods = (0,_state_manager__WEBPACK_IMPORTED_MODULE_6__/* .useConfirmationTypes */ .wA)((0,zustand_react_shallow__WEBPACK_IMPORTED_MODULE_11__/* .useShallow */ .N)(function(state) {
        return {
            setAvailableMethods: state.setAvailableMethods
        };
    })).setAvailableMethods;
    var setDataInUser = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(token) {
        var userDataDecoded = jwtDecoder.decode(token);
        setUserData(userDataDecoded);
        if ((allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isWebsocketAvailable) === "true") {
            createWebSocketConnection(userDataDecoded === null || userDataDecoded === void 0 ? void 0 : userDataDecoded.email, token);
        }
        sessionStorage.setItem(googleTagManagerEmailUser, (userDataDecoded === null || userDataDecoded === void 0 ? void 0 : userDataDecoded.email) || "");
        appMonitoringClient.configureScope({
            email: userDataDecoded.email
        }, token);
        if (userDataDecoded === null || userDataDecoded === void 0 ? void 0 : userDataDecoded.email) {
            heatmapClient.customIdentifiers(userDataDecoded === null || userDataDecoded === void 0 ? void 0 : userDataDecoded.email, userDataDecoded === null || userDataDecoded === void 0 ? void 0 : userDataDecoded.client_id);
        }
        setIsAuthenticated(true);
        setAuthWindowProvider("");
        var shouldRenderModalEmailConfirmation = cookie.getCookie({
            name: cookieModalToConfirmEmail
        });
        if ((allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isEmailConfirmationAvailable) === "true") {
            if (!(userDataDecoded === null || userDataDecoded === void 0 ? void 0 : userDataDecoded.email_verified) && !shouldRenderModalEmailConfirmation) {
                handleTriggerModalEmailConfirmation(userDataDecoded === null || userDataDecoded === void 0 ? void 0 : userDataDecoded.email_verified, userDataDecoded === null || userDataDecoded === void 0 ? void 0 : userDataDecoded.email);
                return null;
            }
            if ((userDataDecoded === null || userDataDecoded === void 0 ? void 0 : userDataDecoded.email_verified) && (userDataDecoded === null || userDataDecoded === void 0 ? void 0 : userDataDecoded.need_update)) {
                handleTriggerModalChangePassword(userDataDecoded === null || userDataDecoded === void 0 ? void 0 : userDataDecoded.need_update);
                return null;
            }
        }
        return null;
    }, [
        jwtDecoder,
        allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isWebsocketAvailable,
        allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isEmailConfirmationAvailable,
        appMonitoringClient,
        cookie,
        heatmapClient,
        createWebSocketConnection,
        handleTriggerModalEmailConfirmation,
        handleTriggerModalChangePassword, 
    ]);
    var fetchConfirmationTypes = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var _ref = // eslint-disable-next-line sonarjs/cognitive-complexity
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(token, email, cpf) {
            var accessToken, ref, dataClient, ref1, ref2, confirmationTypesResponse, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, clientInfo, needsToValidateEmail, needsToValidatePhoneNumber, isPhoneNumberValidated, isEmailValidated, shouldShowUniqueClientModal, shouldShowRegisterPhoneNumberModal, show2faModal, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        accessToken = cookie.getCookie({
                            name: accessTokenCookieKey
                        });
                        return [
                            4,
                            profileApi.fetchClient(token)
                        ];
                    case 1:
                        ref = _state.sent(), dataClient = ref.data;
                        return [
                            4,
                            identityApi.receiveConfirmationTypes({
                                cpf: (ref1 = cpf !== null && cpf !== void 0 ? cpf : dataClient === null || dataClient === void 0 ? void 0 : dataClient.cpf) !== null && ref1 !== void 0 ? ref1 : "",
                                email: (ref2 = email !== null && email !== void 0 ? email : dataClient === null || dataClient === void 0 ? void 0 : dataClient.email) !== null && ref2 !== void 0 ? ref2 : "",
                                jwt: token !== null && token !== void 0 ? token : accessToken
                            })
                        ];
                    case 2:
                        confirmationTypesResponse = _state.sent();
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            7,
                            ,
                            8
                        ]);
                        if (!((router === null || router === void 0 ? void 0 : router.pathname) === "/" || (router === null || router === void 0 ? void 0 : router.pathname) === "/login")) return [
                            3,
                            6
                        ];
                        if (!((allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isUniqueClientAvailable) === "true")) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            purchaseApi.getVerifyUniqueClient(token !== null && token !== void 0 ? token : accessToken)
                        ];
                    case 4:
                        ref19 = _state.sent(), clientInfo = ref19.data;
                        setUniqueClientInfo(clientInfo);
                        needsToValidateEmail = (clientInfo === null || clientInfo === void 0 ? void 0 : (ref9 = clientInfo.emailValidation) === null || ref9 === void 0 ? void 0 : ref9.isSameInPhysicalStoreAndEcommerce) && !(clientInfo === null || clientInfo === void 0 ? void 0 : (ref10 = clientInfo.emailValidation) === null || ref10 === void 0 ? void 0 : ref10.isEmailVerified);
                        needsToValidatePhoneNumber = (clientInfo === null || clientInfo === void 0 ? void 0 : (ref11 = clientInfo.phoneNumberValidation) === null || ref11 === void 0 ? void 0 : ref11.isSameInPhysicalStoreAndEcommerce) && !(clientInfo === null || clientInfo === void 0 ? void 0 : (ref12 = clientInfo.phoneNumberValidation) === null || ref12 === void 0 ? void 0 : ref12.isPhoneNumberVerified);
                        isPhoneNumberValidated = (clientInfo === null || clientInfo === void 0 ? void 0 : (ref13 = clientInfo.phoneNumberValidation) === null || ref13 === void 0 ? void 0 : ref13.isPhoneNumberVerified) && (clientInfo === null || clientInfo === void 0 ? void 0 : (ref14 = clientInfo.phoneNumberValidation) === null || ref14 === void 0 ? void 0 : ref14.isSameInPhysicalStoreAndEcommerce);
                        isEmailValidated = (clientInfo === null || clientInfo === void 0 ? void 0 : (ref15 = clientInfo.emailValidation) === null || ref15 === void 0 ? void 0 : ref15.isEmailVerified) && (clientInfo === null || clientInfo === void 0 ? void 0 : (ref16 = clientInfo.emailValidation) === null || ref16 === void 0 ? void 0 : ref16.isSameInPhysicalStoreAndEcommerce);
                        shouldShowUniqueClientModal = (clientInfo === null || clientInfo === void 0 ? void 0 : clientInfo.isCustomerEligible) && (needsToValidateEmail && needsToValidatePhoneNumber || needsToValidateEmail && (!(clientInfo === null || clientInfo === void 0 ? void 0 : (ref17 = clientInfo.phoneNumberValidation) === null || ref17 === void 0 ? void 0 : ref17.isSameInPhysicalStoreAndEcommerce) || !isPhoneNumberValidated) || needsToValidatePhoneNumber && (!(clientInfo === null || clientInfo === void 0 ? void 0 : (ref18 = clientInfo.emailValidation) === null || ref18 === void 0 ? void 0 : ref18.isSameInPhysicalStoreAndEcommerce) || !isEmailValidated));
                        if (shouldShowUniqueClientModal) {
                            changeUniqueClientStep("modalCall");
                            setIsUniqueClientModalOpen(true);
                            return [
                                2
                            ];
                        }
                        _state.label = 5;
                    case 5:
                        setAvailableMethods(confirmationTypesResponse === null || confirmationTypesResponse === void 0 ? void 0 : confirmationTypesResponse.data);
                        shouldShowRegisterPhoneNumberModal = (confirmationTypesResponse === null || confirmationTypesResponse === void 0 ? void 0 : confirmationTypesResponse.data) && ((confirmationTypesResponse === null || confirmationTypesResponse === void 0 ? void 0 : (ref3 = confirmationTypesResponse.data) === null || ref3 === void 0 ? void 0 : ref3.phoneNumber) === "" || !(confirmationTypesResponse === null || confirmationTypesResponse === void 0 ? void 0 : (ref4 = confirmationTypesResponse.data) === null || ref4 === void 0 ? void 0 : ref4.phoneNumber)) && !(dataClient === null || dataClient === void 0 ? void 0 : dataClient.phoneNumber) || !!(0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .validatePhoneNumber */ .Y0)(dataClient === null || dataClient === void 0 ? void 0 : dataClient.phoneNumber) && (dataClient === null || dataClient === void 0 ? void 0 : dataClient.phoneNumber);
                        if (shouldShowRegisterPhoneNumberModal) {
                            changeCurrentStep("modalCall");
                            changeValidationStep("modalCall");
                            setIsRegisterPhoneNumberModalOpen(true);
                            return [
                                2
                            ];
                        }
                        show2faModal = (confirmationTypesResponse === null || confirmationTypesResponse === void 0 ? void 0 : (ref5 = confirmationTypesResponse.data) === null || ref5 === void 0 ? void 0 : ref5.emailConfirmed) === false && (confirmationTypesResponse === null || confirmationTypesResponse === void 0 ? void 0 : (ref6 = confirmationTypesResponse.data) === null || ref6 === void 0 ? void 0 : ref6.phoneNumberConfirmed) === false;
                        if (show2faModal) {
                            changeLoginStep("firstStep");
                            setIsValidationActive(true);
                            setIsLoginAuthenticationModalOpen(true);
                            return [
                                2
                            ];
                        }
                        if (!(confirmationTypesResponse === null || confirmationTypesResponse === void 0 ? void 0 : (ref7 = confirmationTypesResponse.data) === null || ref7 === void 0 ? void 0 : ref7.phoneNumberConfirmed) && (confirmationTypesResponse === null || confirmationTypesResponse === void 0 ? void 0 : (ref8 = confirmationTypesResponse.data) === null || ref8 === void 0 ? void 0 : ref8.phoneNumber)) {
                            changeCurrentStep("modalCall");
                            setIsPhoneValidationModalOpen(true);
                        }
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        appMonitoringClient.captureException(error);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function(token, email, cpf) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router === null || router === void 0 ? void 0 : router.pathname,
        identityApi,
        setAvailableMethods,
        allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isUniqueClientAvailable,
        purchaseApi,
        changeCurrentStep,
        cookie,
        setIsRegisterPhoneNumberModalOpen,
        setUniqueClientInfo,
        changeUniqueClientStep,
        setIsUniqueClientModalOpen,
        changeLoginStep,
        setIsValidationActive,
        setIsLoginAuthenticationModalOpen,
        changeValidationStep,
        setIsPhoneValidationModalOpen,
        appMonitoringClient,
        profileApi, 
    ]);
    var keepUserLoggedIn = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(data) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        cookie.setCookie({
                            name: accessTokenCookieKey,
                            value: data.token,
                            options: optionsMaxAgeEqualSixMonth.options
                        });
                        cookie.setCookie({
                            name: refreshTokenCookieKey,
                            value: (data === null || data === void 0 ? void 0 : data.refreshToken) || "",
                            options: optionsMaxAgeEqualOneYear.options
                        });
                        if (!data.accessToken) return [
                            3,
                            2
                        ];
                        cookie.setCookie({
                            name: "@FC:Ecom:Auth:".concat(data.providerType),
                            value: data.accessToken,
                            options: optionsMaxAgeEqualSixMonth.options
                        });
                        /**
         * O hook signOut está presente aqui com o motivo de remover os cookies inseridos pela lib (next-auth)
         * - Caso for remover o hook validar com infra/cloud como vai ficar com o nginx
         */ return [
                            4,
                            (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signOut)({
                                redirect: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setDataInUser(data.token);
                        setShowChatbot(true);
                        setIsAuthenticated(true);
                        return [
                            2
                        ];
                }
            });
        // setIsToOpenNewOAuthWindow(false);
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cookie,
        setDataInUser,
        setShowChatbot
    ]);
    // const handleManagementModalOAuth = () => {
    //   setIsToOpenNewOAuthWindow((state) => !state);
    // };
    // const onChangeStateFromInitial = useCallback(() => {
    //   setIsToOpenNewOAuthWindow(false);
    // }, []);
    var getTokens = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var token = cookie.getCookie({
            name: accessTokenCookieKey
        });
        var refreshToken = cookie.getCookie({
            name: refreshTokenCookieKey
        });
        if (!token) return;
        if (!refreshToken) return;
        // eslint-disable-next-line consistent-return
        return {
            token: token,
            refreshToken: refreshToken
        };
    }, [
        cookie
    ]);
    var onAuthenticateUser = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(param) {
            var login, password, location, ref, ref1, data, clientLocation, routesMatch, isCPF, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        login = param.login, password = param.password, location = param.location;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            identityApi.getToken({
                                login: login,
                                password: password,
                                cookieIdCart: (0,_ShoppingHookContext_utilsCart__WEBPACK_IMPORTED_MODULE_9__/* .getTokenCartANONYMOUS */ .rv)(cookie),
                                location: location
                            }, jwtDecoder)
                        ];
                    case 2:
                        data = _state.sent();
                        if (!(data === null || data === void 0 ? void 0 : data.access_token) && router.route === "/cadastro") {
                            router.push("/login");
                        }
                        if (!(data === null || data === void 0 ? void 0 : data.access_token) || !data) return [
                            2,
                            null
                        ];
                        (0,_ShoppingHookContext_utilsCart__WEBPACK_IMPORTED_MODULE_9__/* .deleteTokenCartANONYMOUS */ .q$)(cookie);
                        return [
                            4,
                            keepUserLoggedIn({
                                providerType: "identity",
                                token: data.access_token,
                                refreshToken: data.refresh_token,
                                accessToken: null
                            })
                        ];
                    case 3:
                        _state.sent();
                        clientLocation = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .getClientLocationDetails */ .tK)(cookie);
                        localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem(keyZipCode);
                        emitEventClientLogin(clientLocation);
                        routesMatch = [
                            "/cadastro",
                            "/login"
                        ].some(function(route) {
                            return route === router.route;
                        });
                        isCPF = login.replace(/\D/g, "").length >= 11 && !login.includes("@");
                        fetchConfirmationTypes(data.access_token, isCPF ? "" : login, isCPF ? login : "");
                        // artur.castro validar essa lógica que inseri abaixo. O reload é necessário em qual cenário e quando o usuário se deslogar e estiver em que rota? Qual o propósito desse reload? Fazer reload sempre que o usuário desloga trás uma experiência que não é muito legal.
                        if (routesMatch && !(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.redirectTo)) {
                            router.replace("/");
                        } else if (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.redirectTo) {
                            router.reload();
                        }
                        return [
                            2,
                            data
                        ];
                    case 4:
                        error = _state.sent();
                        appMonitoringClient.captureException(error);
                        return [
                            2,
                            null
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        appMonitoringClient,
        cookie,
        emitEventClientLogin,
        identityApi,
        jwtDecoder,
        keepUserLoggedIn,
        router,
        fetchConfirmationTypes, 
    ]);
    // eslint-disable-next-line sonarjs/cognitive-complexity
    var onConnectToIdentityApi = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
        var token, body, _tmp, _, data, addressRouterSignUp, userDoesNotExist, userDoesNotExistAccessByPageSignUp, userDoesNotExistAccessAnyOtherPageDifferentFromSignUp, ref, ref1, clientLocation, routesMatch;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!session) return [
                        2
                    ];
                    token = session.token;
                    _tmp = {
                        idToken: token === null || token === void 0 ? void 0 : token.id_token,
                        provider: token === null || token === void 0 ? void 0 : token.provider,
                        cookieIdCart: (0,_ShoppingHookContext_utilsCart__WEBPACK_IMPORTED_MODULE_9__/* .getTokenCartANONYMOUS */ .rv)(cookie)
                    };
                    _ = JSON.stringify;
                    return [
                        4,
                        (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .getGeolocation */ .Yt)()
                    ];
                case 1:
                    body = (_tmp.location = _.apply(JSON, [
                        _state.sent()
                    ]), _tmp);
                    appMonitoringClient.captureMessage("Usu\xe1rio ser\xe1 conectado com API Identity", {
                        level: "info",
                        tags: {
                            idToken: token === null || token === void 0 ? void 0 : token.id_token,
                            provider: token === null || token === void 0 ? void 0 : token.provider
                        }
                    });
                    return [
                        4,
                        identityApi.getTokenOAuth(body, jwtDecoder)
                    ];
                case 2:
                    data = _state.sent();
                    (0,_ShoppingHookContext_utilsCart__WEBPACK_IMPORTED_MODULE_9__/* .deleteTokenCartANONYMOUS */ .q$)(cookie);
                    if (!!data) return [
                        3,
                        4
                    ];
                    // setIsToOpenNewOAuthWindow(false);
                    setAuthWindowProvider("");
                    addToast({
                        title: "Ops! Algo deu errado :(",
                        type: "error"
                    });
                    return [
                        4,
                        (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signOut)({
                            redirect: false
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
                case 4:
                    appMonitoringClient.captureMessage("Usu\xe1rio ser\xe1 conectado com API Identity", {
                        level: "info",
                        tags: {
                            idToken: token === null || token === void 0 ? void 0 : token.id_token,
                            provider: token === null || token === void 0 ? void 0 : token.provider,
                            accessToken: data === null || data === void 0 ? void 0 : data.access_token
                        }
                    });
                    addressRouterSignUp = "/cadastro";
                    if (!(router.route === addressRouterSignUp)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signOut)({
                            redirect: false
                        })
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    userDoesNotExist = data === "invalid_grant";
                    userDoesNotExistAccessByPageSignUp = userDoesNotExist && router.route === addressRouterSignUp;
                    userDoesNotExistAccessAnyOtherPageDifferentFromSignUp = userDoesNotExist && router.route !== addressRouterSignUp;
                    if (userDoesNotExistAccessByPageSignUp) {
                        // setIsToOpenNewOAuthWindow(false);
                        return [
                            2
                        ];
                    }
                    if (userDoesNotExistAccessAnyOtherPageDifferentFromSignUp) {
                        // setIsToOpenNewOAuthWindow(false);
                        router.push(addressRouterSignUp);
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signOut)({
                            redirect: false
                        })
                    ];
                case 7:
                    _state.sent();
                    if (!((data === null || data === void 0 ? void 0 : data.access_token) && (data === null || data === void 0 ? void 0 : data.refresh_token))) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        keepUserLoggedIn({
                            providerType: authWindowProvider,
                            token: data === null || data === void 0 ? void 0 : data.access_token,
                            accessToken: token.accessToken,
                            refreshToken: data === null || data === void 0 ? void 0 : data.refresh_token
                        })
                    ];
                case 8:
                    _state.sent();
                    clientLocation = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .getClientLocationDetails */ .tK)(cookie);
                    emitEventClientLogin(clientLocation);
                    if (!(data === null || data === void 0 ? void 0 : data.access_token)) {
                        return [
                            2
                        ];
                    }
                    fetchConfirmationTypes(data === null || data === void 0 ? void 0 : data.access_token);
                    routesMatch = [
                        "/cadastro",
                        "/login"
                    ].some(function(route) {
                        return route === router.route;
                    });
                    // artur.castro validar essa lógica que inseri abaixo. O reload é necessário em qual cenário e quando o usuário se deslogar e estiver em que rota? Qual o propósito desse reload? Fazer reload sempre que o usuário desloga trás uma experiência que não é muito legal.
                    if (routesMatch && !(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.redirectTo)) {
                        router.replace("/");
                        return [
                            2
                        ];
                    }
                    if (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.redirectTo) {
                        router.reload();
                    }
                    _state.label = 9;
                case 9:
                    return [
                        2
                    ];
            }
        });
    }), [
        session,
        cookie,
        appMonitoringClient,
        identityApi,
        jwtDecoder,
        router,
        addToast,
        keepUserLoggedIn,
        authWindowProvider,
        emitEventClientLogin,
        fetchConfirmationTypes, 
    ]);
    var onAuthenticateUserOAuth = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(provider) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(provider === "google")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signIn)("google")
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        if (!(provider === "apple")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signIn)("apple")
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(provider) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var verifyAccessToken = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var isUserAuthenticated = cookie.getCookie({
            name: accessTokenCookieKey
        });
        if (!isUserAuthenticated) {
            setIsAuthenticated(false);
            return;
        }
        setShowChatbot(true);
        setDataInUser(isUserAuthenticated);
    }, [
        cookie,
        setDataInUser,
        setShowChatbot
    ]);
    var signOutAccount = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(cookieImpl) {
            var ref, refreshToken, routesMatch, disconnectingSession, ref1, ref2, ref3;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        refreshToken = ((ref = getTokens()) === null || ref === void 0 ? void 0 : ref.refreshToken) || "";
                        routesMatch = [
                            "/cadastro"
                        ].some(function(route) {
                            return route === router.route;
                        });
                        return [
                            4,
                            identityApi.disconnectSession(refreshToken)
                        ];
                    case 1:
                        disconnectingSession = _state.sent();
                        sessionStorage.setItem(googleTagManagerEmailUser, "");
                        setShowSaleChatbot(false);
                        setShowChatbot(false);
                        localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem(keyZipCode);
                        if (!(!routesMatch && disconnectingSession.success)) return [
                            3,
                            4
                        ];
                        cookieImpl.deleteCookie({
                            name: accessTokenCookieKey
                        });
                        cookieImpl.deleteCookie({
                            name: refreshTokenCookieKey
                        });
                        cookieImpl.deleteCookie({
                            name: accessTokenGoogleCookieKey
                        });
                        cookieImpl.deleteCookie({
                            name: accessTokenAppleCookieKey
                        });
                        cookieImpl.deleteCookie({
                            name: cookieStoreCEP
                        });
                        cookieImpl.deleteCookie({
                            name: "@FC:Ecom:Token:userList"
                        });
                        cookieImpl.deleteCookie({
                            name: "@FC:Ecom:ModalToConfirmEmail:HadVisualization"
                        });
                        return [
                            4,
                            fetch("/api/profile/change-password/remove-validation-cookie", {
                                method: "POST"
                            })
                        ];
                    case 2:
                        _state.sent();
                        heatmapClient.resetCustomIdentifiers();
                        changeConditionToStartCountdown(false);
                        setUserCrmId(null);
                        return [
                            4,
                            (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signOut)({
                                redirect: false
                            })
                        ];
                    case 3:
                        _state.sent();
                        setIsAuthenticated(false);
                        setUserData({});
                        destroyWebSocketConnection();
                        appMonitoringClient.configureScope(null);
                        // artur.castro validar essa lógica que inseri abaixo. O reload é necessário em qual cenário e quando o usuário se deslogar e estiver em que rota? Qual o propósito desse reload? Fazer reload sempre que o usuário desloga trás uma experiência que não é muito legal.
                        if (((ref1 = router.route) === null || ref1 === void 0 ? void 0 : ref1.includes("checkout")) || ((ref2 = router.route) === null || ref2 === void 0 ? void 0 : ref2.includes(myPanelStr)) || ((ref3 = router.route) === null || ref3 === void 0 ? void 0 : ref3.includes("conta"))) {
                            router.reload();
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(cookieImpl) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getTokens,
        identityApi,
        setShowSaleChatbot,
        setShowChatbot,
        router,
        heatmapClient,
        changeConditionToStartCountdown,
        setUserCrmId,
        destroyWebSocketConnection,
        appMonitoringClient, 
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        verifyAccessToken();
    }, [
        isAuthenticated,
        verifyAccessToken
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (session && status === "authenticated") {
            if (!userData) {
                setIsAuthenticated(true);
                setUserData(function(prevUserData) {
                    var ref, ref1;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, prevUserData), {
                        email: (session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.email) || "",
                        name: (session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
                    });
                });
            }
            onConnectToIdentityApi();
        }
    }, [
        session,
        onConnectToIdentityApi,
        status,
        userData
    ]);
    var authContextProviderValue = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return {
            userData: userData,
            isAuthenticated: isAuthenticated,
            onAuthenticateUser: onAuthenticateUser,
            onAuthenticateUserOAuth: onAuthenticateUserOAuth,
            signOutAccount: signOutAccount,
            keepUserLoggedIn: keepUserLoggedIn,
            // onChangeStateFromInitial,
            authWindowProvider: authWindowProvider,
            getTokens: getTokens
        };
    }, [
        userData,
        isAuthenticated,
        onAuthenticateUser,
        onAuthenticateUserOAuth,
        signOutAccount,
        keepUserLoggedIn,
        // onChangeStateFromInitial,
        authWindowProvider,
        getTokens, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuthContext.Provider, {
        value: authContextProviderValue,
        children: children
    });
};


/***/ }),

/***/ 24846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ho": function() { return /* reexport */ AuthContext/* AuthProvider */.Ho; },
  "dr": function() { return /* reexport */ UserProvider; },
  "aC": function() { return /* reexport */ AuthContext/* useAuth */.aC; },
  "aF": function() { return /* reexport */ useUser; }
});

// UNUSED EXPORTS: AuthContext, UserContext

// EXTERNAL MODULE: ../../packages/application/context/Identity/AuthContext.tsx
var AuthContext = __webpack_require__(24452);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/utils/index.tsx + 44 modules
var utils = __webpack_require__(83428);
// EXTERNAL MODULE: ../../packages/application/context/CookiesContext.tsx
var CookiesContext = __webpack_require__(38672);
// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
// EXTERNAL MODULE: ../../packages/application/utils/http/refresh-token/expiration-date/index.ts
var expiration_date = __webpack_require__(83367);
;// CONCATENATED MODULE: ../../packages/application/context/Identity/UserContext.tsx









var cookieForCookies = "@FC:Ecom:Cookie:HadVisualization";
var userBranchLocation = "@FC:Ecom:Dropdown:BranchLocation";
var cookieRegionStr = "@FC:Ecom:Dropdown:Region";
var UserContext = /*#__PURE__*/ (0,react.createContext)({});
var useUser = function() {
    var userContext = (0,react.useContext)(UserContext);
    if (!userContext) {
        throw new Error("useUser must be used within an userProvider");
    }
    return userContext;
};
var UserProvider = function(param) {
    var children = param.children, profileApi = param.profileApi, appMonitoringClient = param.appMonitoringClient, cookie = param.cookie, crm = param.crm, jwtDecoder = param.jwtDecoder;
    var ref, ref1, ref2, ref3, ref4;
    var statementCookiesModal = (0,CookiesContext/* useCookies */.f)().statementCookiesModal;
    var userHasViewedCookieModal = cookie.getCookie({
        name: cookieForCookies
    });
    var userBranch = cookie.getCookie({
        name: userBranchLocation
    });
    var clientState = (ref2 = (ref1 = (ref = cookie.getCookie({
        name: cookieRegionStr
    })) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref1 === void 0 ? void 0 : ref1.split(" - ")) === null || ref2 === void 0 ? void 0 : ref2[1];
    var ref5 = (0,AuthContext/* useAuth */.aC)(), isAuthenticated = ref5.isAuthenticated, getTokens = ref5.getTokens;
    var accessToken = (ref3 = getTokens()) === null || ref3 === void 0 ? void 0 : ref3.token;
    var timeToRefreshAccessTokenBeforeItExpiresInSeconds = 120;
    var accessTokenDecoded = function() {
        if (accessToken) {
            return jwtDecoder.decode(accessToken);
        }
        return null;
    };
    var isAccessTokenExpired = (0,expiration_date/* validateAccessTokenIsExpired */.L)(Number((ref4 = accessTokenDecoded()) === null || ref4 === void 0 ? void 0 : ref4.exp), timeToRefreshAccessTokenBeforeItExpiresInSeconds);
    var ref6 = profileApi.getClient(accessToken, !!accessToken && isAuthenticated && !isAccessTokenExpired), loggedClient = ref6.data, error = ref6.error, triggerLoggedClient = ref6.trigger, isLoadingLoggedClient = ref6.isLoading;
    if (error) {
        appMonitoringClient.captureException(error);
    }
    var setUserCrmId = (0,state_manager/* useCrm */.K3)(function(state) {
        return state.setUserCrmId;
    });
    var handleSetUserCrmId = (0,react.useCallback)(function() {
        var spUID = JSON.parse(localStorage.getItem("spUID") || "null");
        setUserCrmId((spUID === null || spUID === void 0 ? void 0 : spUID.data) || null);
    }, [
        setUserCrmId
    ]);
    var setCrmUserObject = (0,react.useCallback)(function(loggedUser) {
        if (loggedUser) {
            var ref;
            var name = (0,utils/* getUserFirstName */.ng)(loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.name);
            var surname = (0,utils/* getUserSurname */.Fo)(loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.name);
            var userAddressDefault = loggedUser === null || loggedUser === void 0 ? void 0 : (ref = loggedUser.addresses) === null || ref === void 0 ? void 0 : ref.find(function(address) {
                return address.isDefault === true;
            });
            var birthdateToFormat = (loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.birthdate) ? new Date(loggedUser.birthdate) : "";
            var birthdate = (0,utils/* formatDateToShortCrm */.H8)(birthdateToFormat);
            var loggedClientParams = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                uuid: loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.cpf,
                phone_number: "+55".concat(loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.phoneNumber),
                email: loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.email,
                login: true,
                name: name || "",
                surname: surname || ""
            }, userHasViewedCookieModal && {
                gdpr_optin: true
            }), {
                sms_optin: loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.acceptedTermsUse,
                email_optin: loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.acceptedTermsUse,
                whatsapp_optin: loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.acceptedTermsUse,
                gender: loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.gender,
                birthday: birthdate,
                custom: {
                    branch: userBranch || "",
                    city: (userAddressDefault === null || userAddressDefault === void 0 ? void 0 : userAddressDefault.city) || "",
                    state: (userAddressDefault === null || userAddressDefault === void 0 ? void 0 : userAddressDefault.state) || clientState
                }
            });
            crm.userObject(loggedClientParams);
            if (loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.cpf) {
                handleSetUserCrmId();
            }
        } else {
            var anonymousClientParams = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                login: false
            }, !statementCookiesModal && {
                gdpr_optin: true
            }), {
                custom: {
                    branch: userBranch || ""
                }
            });
            setUserCrmId(null);
            crm.userObject(anonymousClientParams);
        }
    // crm.reinitializeTag();
    }, [
        clientState,
        crm,
        handleSetUserCrmId,
        setUserCrmId,
        statementCookiesModal,
        userBranch,
        userHasViewedCookieModal, 
    ]);
    (0,react.useEffect)(function() {
        setCrmUserObject(loggedClient);
    }, [
        loggedClient,
        setCrmUserObject
    ]);
    var ref7 = profileApi.getClient(accessToken, !!accessToken), userData = ref7.data, userDataError = ref7.error;
    var acceptedWhatsapp = (0,react.useMemo)(function() {
        return !!(userData === null || userData === void 0 ? void 0 : userData.acceptedWhatsapp);
    }, [
        userData
    ]);
    if (userDataError) {
        appMonitoringClient.captureException(userDataError);
    }
    var userContextProviderValue = (0,react.useMemo)(function() {
        return {
            loggedClient: loggedClient,
            setCrmUserObject: setCrmUserObject,
            triggerLoggedClient: triggerLoggedClient,
            isLoadingLoggedClient: isLoadingLoggedClient,
            acceptedWhatsapp: acceptedWhatsapp
        };
    }, [
        loggedClient,
        setCrmUserObject,
        isLoadingLoggedClient,
        triggerLoggedClient,
        acceptedWhatsapp, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserContext.Provider, {
        value: userContextProviderValue,
        children: children
    });
};

;// CONCATENATED MODULE: ../../packages/application/context/Identity/index.ts




/***/ }),

/***/ 81898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ModalGroupProvider": function() { return /* binding */ ModalGroupProvider; },
/* harmony export */   "useModalGroup": function() { return /* binding */ useModalGroup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50853);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_Countdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48561);






var cookieModalToConfirmEmail = "@FC:Ecom:ModalToConfirmEmail:HadVisualization";
var optionsMaxAgeEqualOneYear = {
    options: {
        maxAge: 60 * 60 * 24 * 365
    }
};
var ModalGroupContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var ModalGroupProvider = function(param) {
    var children = param.children, cookie = param.cookie, identityApi = param.identityApi;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), modalToConfirmEmail = ref[0], setModalToConfirmEmail = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), modalChangePassword = ref1[0], setModalChangePassword = ref1[1];
    var changeConditionToStartCountdown = (0,_hooks_Countdown__WEBPACK_IMPORTED_MODULE_3__.useCountdown)().changeConditionToStartCountdown;
    var getCookieEmailWasConfirmed = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var response = cookie.getCookie({
            name: "@FC:EmailWasConfirmed"
        });
        if (response === undefined) return null;
        return Boolean(response !== null && response !== void 0 ? response : false);
    }, [
        cookie
    ]);
    var handleOpenModalChangePassword = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setModalChangePassword(true);
    }, []);
    var handleCloseModalChangePassword = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setModalChangePassword(false);
    }, []);
    var handleOpenModalToConfirmEmail = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var currentPath, hadVisualizationModalToConfirmEmailInActualSession;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            currentPath = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "";
            cookie.setCookie({
                name: "@FC:Ecom:Destination:ConfirmEmail",
                value: router.asPath
            });
            changeConditionToStartCountdown(true);
            if (!currentPath) {
                hadVisualizationModalToConfirmEmailInActualSession = cookie.getCookie({
                    name: cookieModalToConfirmEmail
                });
                if (!hadVisualizationModalToConfirmEmailInActualSession) {
                    setModalToConfirmEmail(true);
                    cookie.setCookie({
                        name: cookieModalToConfirmEmail,
                        value: String(true),
                        options: optionsMaxAgeEqualOneYear.options
                    });
                }
            } else {
                setModalToConfirmEmail(true);
            }
            return [
                2
            ];
        });
    }), [
        changeConditionToStartCountdown,
        cookie,
        router
    ]);
    var handleCloseModalToConfirmEmail = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setModalToConfirmEmail(false);
    }, []);
    var sendOrResendEmailConfirmation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(email) {
            var condition, data;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        condition = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                        if (!condition) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            identityApi.sendEmailConfirmation(email)
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null) return [
                            2,
                            null
                        ];
                        return [
                            2,
                            data
                        ];
                    case 2:
                        return [
                            2,
                            null
                        ];
                }
            });
        });
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }(), [
        identityApi
    ]);
    var handleTriggerModalEmailConfirmation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(emailVerified, email) {
            var routesMatch, emailIsNotVerifiedAndEmail;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                routesMatch = [
                    "/cadastro",
                    "/login"
                ].some(function(route) {
                    return route === router.route;
                });
                emailIsNotVerifiedAndEmail = !emailVerified;
                if (emailIsNotVerifiedAndEmail && routesMatch) {
                    router.events.on("routeChangeStart", function(url) {
                        if (url !== "/cadastro" || url !== "/login") {
                            handleOpenModalToConfirmEmail();
                            sendOrResendEmailConfirmation(email);
                        }
                    });
                    return [
                        2,
                        function() {
                            router.events.off("routeChangeStart", function() {
                                handleOpenModalToConfirmEmail();
                                sendOrResendEmailConfirmation(email);
                            });
                        }
                    ];
                }
                if (emailIsNotVerifiedAndEmail && !routesMatch) {
                    handleOpenModalToConfirmEmail();
                    sendOrResendEmailConfirmation(email);
                }
                return [
                    2,
                    null
                ];
            });
        });
        return function(emailVerified, email) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleOpenModalToConfirmEmail,
        router.events,
        router.route,
        sendOrResendEmailConfirmation, 
    ]);
    var handleTriggerModalChangePassword = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(isWeakPassword) {
            var routesMatch, routesShouldNotOpenModalChangePasswordMatch;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                routesMatch = [
                    "/login"
                ].some(function(route) {
                    return route === router.route;
                });
                routesShouldNotOpenModalChangePasswordMatch = [
                    "/checkout/meu-carrinho",
                    "/checkout/pagamento",
                    "/checkout/done"
                ].some(function(route) {
                    return route === router.route;
                });
                if (isWeakPassword && routesMatch) {
                    router.events.on("routeChangeStart", function(url) {
                        if (url !== "/login") {
                            handleOpenModalChangePassword();
                        }
                    });
                    return [
                        2,
                        function() {
                            router.events.off("routeChangeStart", function() {
                                handleOpenModalChangePassword();
                            });
                        }
                    ];
                }
                if (isWeakPassword && !routesMatch && !routesShouldNotOpenModalChangePasswordMatch) {
                    handleOpenModalChangePassword();
                }
                return [
                    2,
                    null
                ];
            });
        });
        return function(isWeakPassword) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleOpenModalChangePassword,
        router.events,
        router.route
    ]);
    var modalGroupContextProviderValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            modalToConfirmEmail: modalToConfirmEmail,
            modalChangePassword: modalChangePassword,
            handleCloseModalToConfirmEmail: handleCloseModalToConfirmEmail,
            handleOpenModalToConfirmEmail: handleOpenModalToConfirmEmail,
            handleTriggerModalChangePassword: handleTriggerModalChangePassword,
            sendOrResendEmailConfirmation: sendOrResendEmailConfirmation,
            handleTriggerModalEmailConfirmation: handleTriggerModalEmailConfirmation,
            getCookieEmailWasConfirmed: getCookieEmailWasConfirmed,
            handleCloseModalChangePassword: handleCloseModalChangePassword
        };
    }, [
        modalToConfirmEmail,
        modalChangePassword,
        handleCloseModalToConfirmEmail,
        handleOpenModalToConfirmEmail,
        handleTriggerModalChangePassword,
        sendOrResendEmailConfirmation,
        handleTriggerModalEmailConfirmation,
        getCookieEmailWasConfirmed,
        handleCloseModalChangePassword, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalGroupContext.Provider, {
        value: modalGroupContextProviderValue,
        children: children
    });
};
var useModalGroup = function() {
    var modalGroupContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ModalGroupContext);
    if (!modalGroupContext) {
        throw new Error("useModalGroup must be used within an ModalGroupProvider");
    }
    return modalGroupContext;
};


/***/ }),

/***/ 12093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NotificationContext": function() { return /* binding */ NotificationContext; },
/* harmony export */   "NotificationProvider": function() { return /* binding */ NotificationProvider; },
/* harmony export */   "useNotification": function() { return /* binding */ useNotification; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50853);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Identity_AuthContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24452);
/* harmony import */ var _state_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74224);







var NotificationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var NotificationProvider = function(param) {
    var children = param.children, notificationApi = param.notificationApi;
    var getTokens = (0,_Identity_AuthContext__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .aC)().getTokens;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), codeHasError = ref[0], setCodeHasError = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isUserBlocked = ref1[0], setIsUserBlocked = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isCodeValid = ref2[0], setIsCodeValid = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isValidationActive = ref3[0], setIsValidationActive = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), counterTimeContext = ref4[0], setCounterTimeContext = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isUserBlockedFromReceiveMessages = ref5[0], setIsUserBlockedFromReceiveMessages = ref5[1];
    var setSentSMSToken = (0,_state_manager__WEBPACK_IMPORTED_MODULE_4__/* .useGiftCard */ .CE)(function(state) {
        return state.setSentSMSToken;
    });
    var changeIsUserBlockedFromReceiveMessages = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setIsUserBlockedFromReceiveMessages(value);
    }, []);
    var changeCodeHasError = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setCodeHasError(value);
    }, []);
    var changeIsUserBlocked = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setIsUserBlocked(value);
    }, []);
    var changeIsValidationActive = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setIsValidationActive(value);
    }, []);
    var changeIsCodeValid = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setIsCodeValid(value);
    }, []);
    var initializeValidationCounter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setCounterTimeContext(value !== null && value !== void 0 ? value : 120);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var idTime = setTimeout(function() {
            if (counterTimeContext) {
                setCounterTimeContext(counterTimeContext - 1);
            }
        }, 1000);
        return function() {
            return clearTimeout(idTime);
        };
    }, [
        counterTimeContext
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if ((router === null || router === void 0 ? void 0 : router.pathname) !== "/checkout/pagamento" && isCodeValid) {
            changeIsCodeValid(false);
        }
    }, [
        changeIsCodeValid,
        isCodeValid,
        router === null || router === void 0 ? void 0 : router.pathname
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            setSentSMSToken(null);
        };
    }, [
        router === null || router === void 0 ? void 0 : router.pathname,
        setSentSMSToken
    ]);
    var validateTwoFactorSMS = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(type, token) {
            var ref, ref1, data, isLoading, error, status, errors;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            notificationApi.validateTwoFactorSMS(type, token, (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token)
                        ];
                    case 1:
                        ref1 = _state.sent(), data = ref1.data, isLoading = ref1.isLoading, error = ref1.error, status = ref1.status, errors = ref1.errors;
                        setSentSMSToken(token);
                        return [
                            2,
                            {
                                data: data,
                                error: error,
                                isLoading: isLoading,
                                status: status,
                                errors: errors
                            }
                        ];
                }
            });
        });
        return function(type, token) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getTokens,
        notificationApi,
        setSentSMSToken
    ]);
    var notificationContextProviderValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            codeHasError: codeHasError,
            isUserBlocked: isUserBlocked,
            isValidationActive: isValidationActive,
            isCodeValid: isCodeValid,
            isUserBlockedFromReceiveMessages: isUserBlockedFromReceiveMessages,
            counterTimeContext: counterTimeContext,
            changeIsCodeValid: changeIsCodeValid,
            changeIsValidationActive: changeIsValidationActive,
            changeCodeHasError: changeCodeHasError,
            changeIsUserBlocked: changeIsUserBlocked,
            validateTwoFactorSMS: validateTwoFactorSMS,
            changeIsUserBlockedFromReceiveMessages: changeIsUserBlockedFromReceiveMessages,
            initializeValidationCounter: initializeValidationCounter
        };
    }, [
        codeHasError,
        isUserBlocked,
        isValidationActive,
        isCodeValid,
        isUserBlockedFromReceiveMessages,
        counterTimeContext,
        changeIsCodeValid,
        changeIsValidationActive,
        changeCodeHasError,
        changeIsUserBlocked,
        validateTwoFactorSMS,
        changeIsUserBlockedFromReceiveMessages,
        initializeValidationCounter, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NotificationContext.Provider, {
        value: notificationContextProviderValue,
        children: children
    });
};
var useNotification = function() {
    var notificationContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(NotificationContext);
    if (!notificationContext) {
        throw new Error("useNotification must be used within an NotificationProvider");
    }
    return notificationContext;
};


/***/ }),

/***/ 25371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PurchaseContext": function() { return /* binding */ PurchaseContext; },
/* harmony export */   "PurchaseProvider": function() { return /* binding */ PurchaseProvider; },
/* harmony export */   "usePurchase": function() { return /* binding */ usePurchase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50930);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50853);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38665);
/* harmony import */ var _state_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74224);
/* harmony import */ var _BranchLocationContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64462);
/* harmony import */ var _Identity_AuthContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24452);
/* harmony import */ var _ShoppingHookContext_CartContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9521);













var PurchaseContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var PurchaseProvider = function(param) {
    var children = param.children, purchaseApi = param.purchaseApi, paymentApi = param.paymentApi, allowMeFingerprint = param.allowMeFingerprint, clearSaleFingerprint = param.clearSaleFingerprint, shippingApi = param.shippingApi, appMonitoringClient = param.appMonitoringClient, clientIp = param.clientIp;
    var ref;
    var ref1 = (0,_ShoppingHookContext_CartContext__WEBPACK_IMPORTED_MODULE_7__/* .useCartContext */ .iQ)(), cartItems = ref1.cartItems, cartId = ref1.id, handleEmitEventCartModified = ref1.handleEmitEventCartModified, quantityOfItemsInCart = ref1.quantityOfItemsInCart;
    var getBranchLocationClient = (0,_BranchLocationContext__WEBPACK_IMPORTED_MODULE_5__/* .useBranchLocation */ .vK)().getBranchLocationClient;
    var ref2 = (0,_Identity_AuthContext__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .aC)(), getTokens = ref2.getTokens, userData = ref2.userData;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), step = ref3[0], setStep = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), orderByPhone = ref4[0], setOrderByPhone = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), totalPackage = ref5[0], setTotalPackage = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        balance: 0,
        couponMovementId: ""
    }), couponApplied = ref6[0], setCouponApplied = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), optionPayment = ref7[0], setOptionPayment = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), addressSelected = ref8[0], setAddressSelected = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), newCards = ref9[0], setNewCards = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), brideAndGroom = ref10[0], setBrideAndGroom = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), giftMessages = ref11[0], setGiftMessages = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), shippingOptions = ref12[0], setShippingOptions = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        balance: 0,
        cardNumber: ""
    }), giftCardApplied = ref13[0], setGiftCardApplied = ref13[1];
    var responsiblePickUp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return [];
    }, []);
    var setResponsiblePickUp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(data, index) {
        if (index && index < 0) return;
        if (index) {
            responsiblePickUp["".concat(index - 1)] = data;
            return;
        }
        responsiblePickUp.push(data);
    }, [
        responsiblePickUp
    ]);
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        one: 0,
        two: 0
    }), chargeTotal = ref14[0], setChargeTotal = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        quantityGiftItems: 0,
        quantityProductItems: 0
    }), quantityProducts = ref15[0], setQuantityProducts = ref15[1];
    var onChangeChargeTotalContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(totalPrice, chargeTotalContext, formId) {
        setChargeTotal(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                one: formId === 1 ? chargeTotalContext : totalPrice - chargeTotalContext,
                two: formId === 2 ? chargeTotalContext : totalPrice - chargeTotalContext
            });
        });
    }, []);
    var ref16 = (0,_state_manager__WEBPACK_IMPORTED_MODULE_4__/* .usePurchaseStore */ .tm)((0,_state_manager__WEBPACK_IMPORTED_MODULE_4__/* .useShallow */ .NL)(function(state) {
        return {
            purchaseProduct: state.purchaseProduct,
            setProductsFromCart: state.setProductsFromCart,
            setBranchLocation: state.setBranchLocation,
            clearPurchaseProducts: state.clearPurchaseProducts
        };
    })), purchaseProduct = ref16.purchaseProduct, setBranchLocation = ref16.setBranchLocation, setProductsFromCart = ref16.setProductsFromCart, clearPurchaseProducts = ref16.clearPurchaseProducts;
    setProductsFromCart(cartItems);
    setBranchLocation(Number(getBranchLocationClient() || 2));
    var changeAddressSelected = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setAddressSelected(value);
    }, []);
    var changeStep = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setStep(value);
    }, []);
    var changeQuantityProducts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setQuantityProducts((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, value));
    }, []);
    var validateResponsiblePickUp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(isPickUpInStore, type) {
        var packageNumber = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
        var index = packageNumber - 1;
        switch(type){
            case "name":
                var ref;
                return isPickUpInStore ? ((ref = responsiblePickUp["".concat(index)]) === null || ref === void 0 ? void 0 : ref.name) || userData.name : "";
            case "cpf":
                var ref1;
                return isPickUpInStore ? ((ref1 = responsiblePickUp["".concat(index)]) === null || ref1 === void 0 ? void 0 : ref1.cpf) || userData.cpf : "";
            case "email":
                var ref2;
                return isPickUpInStore ? ((ref2 = responsiblePickUp["".concat(index)]) === null || ref2 === void 0 ? void 0 : ref2.email) || userData.email : "";
            default:
                return "";
        }
    }, [
        responsiblePickUp,
        userData
    ]);
    var changePackageShipping = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(selectedShippingOption, products, packages) {
        var shippingIsNotEqual = shippingOptions.filter(function(item) {
            var ref, ref1;
            return ((ref = item.shippingDetails) === null || ref === void 0 ? void 0 : (ref1 = ref.deliveryOptions) === null || ref1 === void 0 ? void 0 : ref1[0].package) !== packages;
        });
        var conditionToCheckAtPickUpOption = (selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : selectedShippingOption.pickUpInStore) && (selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : selectedShippingOption.branchId) === 0;
        var shippingDetails = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Array.isArray(selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : selectedShippingOption.shippingDetails) ? selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : selectedShippingOption.shippingDetails : []);
        var deliveryOptions = products.map(function(param) {
            var productId = param.productId, sellerId = param.sellerId;
            var ref, ref1;
            var currentShippingDetailIndex = shippingDetails.findIndex(function(shippingDetail) {
                return (shippingDetail === null || shippingDetail === void 0 ? void 0 : shippingDetail.code) === String(productId);
            });
            var currentShippingDetail = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (ref = shippingDetails.splice(currentShippingDetailIndex, 1)) === null || ref === void 0 ? void 0 : ref[0]);
            return {
                productId: String(productId),
                deliveryTypeId: selectedShippingOption.deliveryTypeId,
                package: packages,
                packaging: conditionToCheckAtPickUpOption ? "0" : Number((currentShippingDetail === null || currentShippingDetail === void 0 ? void 0 : currentShippingDetail.packaging) || "0"),
                sellerId: sellerId,
                addressId: conditionToCheckAtPickUpOption ? String(0) : String(currentShippingDetail === null || currentShippingDetail === void 0 ? void 0 : currentShippingDetail.addressId),
                branchProduct: (currentShippingDetail === null || currentShippingDetail === void 0 ? void 0 : currentShippingDetail.branchId) || 0,
                isPickupStore: selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : selectedShippingOption.pickUpInStore,
                pickupBranch: (selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : selectedShippingOption.pickUpInStore) ? selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : (ref1 = selectedShippingOption.pickUpInStoreLocation) === null || ref1 === void 0 ? void 0 : ref1.branchIdForPickup : 0,
                namePickupInStore: validateResponsiblePickUp(selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : selectedShippingOption.pickUpInStore, "name", packages),
                emailPickupInStore: validateResponsiblePickUp(selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : selectedShippingOption.pickUpInStore, "email", packages),
                cpfPickupInStore: validateResponsiblePickUp(selectedShippingOption === null || selectedShippingOption === void 0 ? void 0 : selectedShippingOption.pickUpInStore, "cpf", packages)
            };
        });
        var newShippingDetails = {
            addressId: addressSelected.id,
            deliveryOptions: deliveryOptions
        };
        var newShippingOption = {
            description: selectedShippingOption.description,
            branchId: selectedShippingOption.branchId,
            value: selectedShippingOption.value,
            arrives: selectedShippingOption.arrives,
            arrivesText: selectedShippingOption.arrivesText,
            arrivesTextShort: selectedShippingOption.arrivesTextShort,
            pickUpInStore: selectedShippingOption.pickUpInStore,
            pickUpInStoreLocation: selectedShippingOption.pickUpInStoreLocation,
            shippingDetails: newShippingDetails,
            deliveryTypeId: selectedShippingOption.deliveryTypeId,
            package: selectedShippingOption.package
        };
        var updatedShippingOptions = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(shippingIsNotEqual).concat([
            newShippingOption
        ]);
        if ((updatedShippingOptions === null || updatedShippingOptions === void 0 ? void 0 : updatedShippingOptions.length) !== (shippingOptions === null || shippingOptions === void 0 ? void 0 : shippingOptions.length)) {
            setShippingOptions(updatedShippingOptions);
            return;
        }
        var hasShippingOptionsChanges = shippingOptions.find(function(param, index) {
            var arrives = param.arrives, arrivesText = param.arrivesText, branchId = param.branchId, deliveryTypeId = param.deliveryTypeId, description = param.description, shippingOptionsPackage = param.package, pickUpInStore = param.pickUpInStore;
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            return arrives !== (updatedShippingOptions === null || updatedShippingOptions === void 0 ? void 0 : (ref = updatedShippingOptions["".concat(index)]) === null || ref === void 0 ? void 0 : ref.arrives) || arrivesText !== (updatedShippingOptions === null || updatedShippingOptions === void 0 ? void 0 : (ref1 = updatedShippingOptions["".concat(index)]) === null || ref1 === void 0 ? void 0 : ref1.arrivesText) || branchId !== (updatedShippingOptions === null || updatedShippingOptions === void 0 ? void 0 : (ref2 = updatedShippingOptions["".concat(index)]) === null || ref2 === void 0 ? void 0 : ref2.branchId) || deliveryTypeId !== (updatedShippingOptions === null || updatedShippingOptions === void 0 ? void 0 : (ref3 = updatedShippingOptions["".concat(index)]) === null || ref3 === void 0 ? void 0 : ref3.deliveryTypeId) || description !== (updatedShippingOptions === null || updatedShippingOptions === void 0 ? void 0 : (ref4 = updatedShippingOptions["".concat(index)]) === null || ref4 === void 0 ? void 0 : ref4.description) || shippingOptionsPackage !== (updatedShippingOptions === null || updatedShippingOptions === void 0 ? void 0 : (ref5 = updatedShippingOptions["".concat(index)]) === null || ref5 === void 0 ? void 0 : ref5.package) || pickUpInStore !== (updatedShippingOptions === null || updatedShippingOptions === void 0 ? void 0 : (ref6 = updatedShippingOptions["".concat(index)]) === null || ref6 === void 0 ? void 0 : ref6.pickUpInStore);
        });
        if (hasShippingOptionsChanges) {
            setShippingOptions(updatedShippingOptions);
        }
    }, [
        addressSelected,
        shippingOptions,
        validateResponsiblePickUp
    ]);
    var changeAllParamsInShippingOptionsToNull = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var shippingDetailsAllParamsNull = {
            addressId: 0,
            deliveryOptions: []
        };
        var allParamsEmpty = [
            {
                description: null,
                branchId: null,
                value: null,
                arrives: null,
                arrivesText: null,
                arrivesTextShort: null,
                pickUpInStore: null,
                pickUpInStoreLocation: null,
                shippingDetails: shippingDetailsAllParamsNull,
                deliveryTypeId: null,
                package: null
            }, 
        ];
        setShippingOptions(allParamsEmpty);
    }, []);
    var clearPackageShipping = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setShippingOptions([]);
    }, []);
    var clearCouponApplied = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setCouponApplied({
            balance: 0,
            couponMovementId: ""
        });
    }, []);
    var updateResponsiblePickUp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(newResponsible, packageIndex) {
        setResponsiblePickUp(newResponsible, packageIndex);
        setShippingOptions(function(previousShippingOptions) {
            return previousShippingOptions === null || previousShippingOptions === void 0 ? void 0 : previousShippingOptions.map(function(shippingOption, index) {
                if (index + 1 === packageIndex) {
                    var ref, ref1;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, shippingOption), {
                        shippingDetails: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, shippingOption === null || shippingOption === void 0 ? void 0 : shippingOption.shippingDetails), {
                            deliveryOptions: shippingOption === null || shippingOption === void 0 ? void 0 : (ref = shippingOption.shippingDetails) === null || ref === void 0 ? void 0 : (ref1 = ref.deliveryOptions) === null || ref1 === void 0 ? void 0 : ref1.map(function(deliveryOption) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deliveryOption), {
                                    namePickupInStore: newResponsible === null || newResponsible === void 0 ? void 0 : newResponsible.name,
                                    emailPickupInStore: newResponsible === null || newResponsible === void 0 ? void 0 : newResponsible.email,
                                    cpfPickupInStore: newResponsible === null || newResponsible === void 0 ? void 0 : newResponsible.cpf.replace(/[^0-9]/g, "")
                                });
                            })
                        })
                    });
                }
                return shippingOption;
            });
        });
    }, [
        setResponsiblePickUp
    ]);
    var changeTotalPackage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setTotalPackage(value);
    }, []);
    var changeOptionPayment = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setOptionPayment(value);
    }, []);
    var changeDiscountCoupon = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setCouponApplied(value);
    }, []);
    var changeGiftCardApplied = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setGiftCardApplied(value);
    }, []);
    var changeNewCards = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        var cardAlreadyExists = newCards.some(function(card) {
            return card.cardNumber === value.cardNumber;
        });
        if (cardAlreadyExists) return;
        setNewCards(function(card) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(card).concat([
                value
            ]);
        });
    }, [
        newCards
    ]);
    var clearNewCards = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setNewCards([]);
    }, []);
    var changeGiftMessages = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        var foundGiftMessage = giftMessages === null || giftMessages === void 0 ? void 0 : giftMessages.find(function(param) {
            var listId = param.listId;
            return listId === (value === null || value === void 0 ? void 0 : value.listId);
        });
        var updatedGiftMessages = giftMessages === null || giftMessages === void 0 ? void 0 : giftMessages.map(function(item) {
            if ((item === null || item === void 0 ? void 0 : item.listId) === (value === null || value === void 0 ? void 0 : value.listId)) {
                return {
                    listId: value === null || value === void 0 ? void 0 : value.listId,
                    message: value === null || value === void 0 ? void 0 : value.message
                };
            }
            return item;
        });
        if (foundGiftMessage) {
            setGiftMessages(updatedGiftMessages);
            return;
        }
        setGiftMessages((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(giftMessages).concat([
            value
        ]));
    }, [
        giftMessages
    ]);
    var changeBrideAndGroom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setBrideAndGroom(value);
    }, []);
    var priceSendPackages = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return shippingOptions.reduce(function(accumulator, shipping) {
            accumulator.shippingPrice += shipping.value;
            return accumulator;
        }, {
            shippingPrice: 0
        });
    }, [
        shippingOptions
    ]);
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var sentSMSToken = (0,_state_manager__WEBPACK_IMPORTED_MODULE_4__/* .useGiftCard */ .CE)(function(state) {
        return state.sentSMSToken;
    });
    var createOrder = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(order, cartItemsList) {
            var usedClearSaleFingerprint, usedAllowMeFingerprint, usedClientIp, sessionId, fingerprint, ip, updatedGtagItems, totalShipping, ref, data, error, isLoading;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        usedClearSaleFingerprint = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : clearSaleFingerprint, usedAllowMeFingerprint = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : allowMeFingerprint, usedClientIp = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : clientIp;
                        return [
                            4,
                            usedClearSaleFingerprint.collect()
                        ];
                    case 1:
                        sessionId = String.apply(void 0, [
                            _state.sent() || ""
                        ]);
                        return [
                            4,
                            usedAllowMeFingerprint.collect("purchase")
                        ];
                    case 2:
                        fingerprint = String.apply(void 0, [
                            _state.sent() || ""
                        ]);
                        ip = usedClientIp.getClientIp();
                        updatedGtagItems = cartItemsList.map(function(item) {
                            var ref, ref1, ref2, ref3, ref4, ref5;
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, item), {
                                itemVariant: (ref4 = (ref = cartItems[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.productFamilies) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.families) === null || ref3 === void 0 ? void 0 : ref3.find(function(variant) {
                                    return variant === null || variant === void 0 ? void 0 : variant.selectedValue;
                                })) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.color) === null || ref5 === void 0 ? void 0 : ref5.name
                            });
                        });
                        totalShipping = shippingOptions.reduce(function(acc, option) {
                            return acc + ((option === null || option === void 0 ? void 0 : option.value) || 0);
                        }, 0);
                        return [
                            4,
                            purchaseApi.createOrder({
                                cartId: order.cartId,
                                giftMessages: order.giftMessages,
                                couponMovementId: order.couponMovementId,
                                jwt: accessToken,
                                payment: order.payment,
                                shippingOptions: order.shippingOptions,
                                quantity: quantityOfItemsInCart,
                                shipping: totalShipping,
                                gtagItems: updatedGtagItems,
                                sessionId: sessionId,
                                fingerprint: fingerprint,
                                clientIp: ip,
                                giftCardSMSToken: sentSMSToken
                            })
                        ];
                    case 3:
                        ref = _state.sent(), data = ref.data, error = ref.error, isLoading = ref.isLoading;
                        handleEmitEventCartModified();
                        return [
                            2,
                            {
                                data: data,
                                error: error,
                                isLoading: isLoading
                            }
                        ];
                }
            });
        });
        return function(order, cartItemsList) {
            return _ref.apply(this, arguments);
        };
    }(), [
        clearSaleFingerprint,
        allowMeFingerprint,
        clientIp,
        shippingOptions,
        purchaseApi,
        accessToken,
        quantityOfItemsInCart,
        handleEmitEventCartModified,
        sentSMSToken,
        cartItems, 
    ]);
    var doPaymentByPhone = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(param) {
            var orderId, payment, data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        orderId = param.orderId, payment = param.payment;
                        return [
                            4,
                            paymentApi.postPaymentOrder(accessToken, orderId || orderByPhone.orderId, payment, "payment_by_phone")
                        ];
                    case 1:
                        data = _state.sent();
                        handleEmitEventCartModified();
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        accessToken,
        handleEmitEventCartModified,
        orderByPhone.orderId,
        paymentApi
    ]);
    var changeOrderByPhone = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setOrderByPhone(value);
    }, []);
    var clearOrderByPhone = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setOrderByPhone({});
    }, []);
    var useHandleGetCartOptionsError = function(getCartOptionsError) {
        var addToast = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useToast */ .pm)().addToast;
        var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
            if ((getCartOptionsError === null || getCartOptionsError === void 0 ? void 0 : getCartOptionsError.status) && (getCartOptionsError === null || getCartOptionsError === void 0 ? void 0 : getCartOptionsError.status) === 400 && router.pathname !== "/checkout/pagamento/[groupId]") {
                var ref, ref1;
                var errorMessage = (getCartOptionsError === null || getCartOptionsError === void 0 ? void 0 : (ref = getCartOptionsError.errors) === null || ref === void 0 ? void 0 : (ref1 = ref.CartId) === null || ref1 === void 0 ? void 0 : ref1[0]) || "Ocorreu um erro ao obter os itens do seu carrinho";
                addToast({
                    title: errorMessage,
                    type: "error",
                    timerInMilliseconds: 3000
                });
                appMonitoringClient.captureMessage(errorMessage, {
                    level: "error",
                    tags: {
                        fcx_labs_event: "get_cart_options",
                        fcx_labs_error_source: "shopping_api"
                    }
                });
                router.push("/");
                setTimeout(function() {
                    router.reload();
                }, 3000);
            }
        }, [
            addToast,
            getCartOptionsError,
            router
        ]);
    };
    var ref17 = shippingApi.getCartOptions(accessToken, cartId, addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.zipCode, !!(accessToken && cartId && (addressSelected === null || addressSelected === void 0 ? void 0 : addressSelected.zipCode))), cartOptions = ref17.data, triggerGetCartOptions = ref17.trigger;
    useHandleGetCartOptionsError(cartOptions);
    var purchaseContextProviderValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            addressSelected: addressSelected,
            changeAddressSelected: changeAddressSelected,
            changeStep: changeStep,
            step: step,
            shippingOptions: shippingOptions,
            changePackageShipping: changePackageShipping,
            clearPackageShipping: clearPackageShipping,
            totalPackage: totalPackage,
            changeTotalPackage: changeTotalPackage,
            purchaseProduct: purchaseProduct,
            priceSendPackages: priceSendPackages,
            changeOptionPayment: changeOptionPayment,
            optionPayment: optionPayment,
            changeDiscountCoupon: changeDiscountCoupon,
            couponApplied: couponApplied,
            createOrder: createOrder,
            responsiblePickUp: responsiblePickUp,
            clearPurchaseProducts: clearPurchaseProducts,
            giftCardApplied: giftCardApplied,
            changeGiftCardApplied: changeGiftCardApplied,
            changeNewCards: changeNewCards,
            newCards: newCards,
            clearNewCards: clearNewCards,
            chargeTotal: chargeTotal,
            onChangeChargeTotalContext: onChangeChargeTotalContext,
            updateResponsiblePickUp: updateResponsiblePickUp,
            changeOrderByPhone: changeOrderByPhone,
            orderByPhone: orderByPhone,
            doPaymentByPhone: doPaymentByPhone,
            changeBrideAndGroom: changeBrideAndGroom,
            brideAndGroom: brideAndGroom,
            giftMessages: giftMessages,
            changeGiftMessages: changeGiftMessages,
            quantityProducts: quantityProducts,
            changeQuantityProducts: changeQuantityProducts,
            clearCouponApplied: clearCouponApplied,
            changeAllParamsInShippingOptionsToNull: changeAllParamsInShippingOptionsToNull,
            clearOrderByPhone: clearOrderByPhone,
            cartOptions: cartOptions,
            triggerGetCartOptions: triggerGetCartOptions
        };
    }, [
        addressSelected,
        changeAddressSelected,
        changeStep,
        step,
        shippingOptions,
        changePackageShipping,
        clearPackageShipping,
        totalPackage,
        changeTotalPackage,
        purchaseProduct,
        priceSendPackages,
        changeOptionPayment,
        optionPayment,
        changeDiscountCoupon,
        couponApplied,
        createOrder,
        responsiblePickUp,
        clearPurchaseProducts,
        giftCardApplied,
        changeGiftCardApplied,
        changeNewCards,
        newCards,
        clearNewCards,
        chargeTotal,
        onChangeChargeTotalContext,
        updateResponsiblePickUp,
        changeOrderByPhone,
        orderByPhone,
        doPaymentByPhone,
        brideAndGroom,
        giftMessages,
        changeGiftMessages,
        changeBrideAndGroom,
        quantityProducts,
        changeQuantityProducts,
        clearCouponApplied,
        changeAllParamsInShippingOptionsToNull,
        clearOrderByPhone,
        cartOptions,
        triggerGetCartOptions, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PurchaseContext.Provider, {
        value: purchaseContextProviderValue,
        children: children
    });
};
var usePurchase = function() {
    var purchaseContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PurchaseContext);
    if (!purchaseContext) {
        throw new Error("usePurchase must be used within an PurchaseProvider");
    }
    return purchaseContext;
};


/***/ }),

/***/ 13638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RecaptchaContext": function() { return /* binding */ RecaptchaContext; },
/* harmony export */   "RecaptchaContextProvider": function() { return /* binding */ RecaptchaContextProvider; },
/* harmony export */   "useRecaptcha": function() { return /* binding */ useRecaptcha; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var RecaptchaContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var RecaptchaContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), checkIfTheCustomerIsNotARobotSignUp = ref[0], setCheckIfTheCustomerIsNotARobotSignUp = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), checkIfTheCustomerIsNotARobotSignIn = ref1[0], setCheckIfTheCustomerIsNotARobotSignIn = ref1[1];
    var handleCheckIfTheCustomerIsNotARobotSignUp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setCheckIfTheCustomerIsNotARobotSignUp(value);
    }, []);
    var handleCheckIfTheCustomerIsNotARobotSignIn = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setCheckIfTheCustomerIsNotARobotSignIn(value);
    }, []);
    var recaptchaContextProviderValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            checkIfTheCustomerIsNotARobotSignUp: checkIfTheCustomerIsNotARobotSignUp,
            checkIfTheCustomerIsNotARobotSignIn: checkIfTheCustomerIsNotARobotSignIn,
            handleCheckIfTheCustomerIsNotARobotSignUp: handleCheckIfTheCustomerIsNotARobotSignUp,
            handleCheckIfTheCustomerIsNotARobotSignIn: handleCheckIfTheCustomerIsNotARobotSignIn
        };
    }, [
        checkIfTheCustomerIsNotARobotSignIn,
        checkIfTheCustomerIsNotARobotSignUp,
        handleCheckIfTheCustomerIsNotARobotSignIn,
        handleCheckIfTheCustomerIsNotARobotSignUp, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RecaptchaContext.Provider, {
        value: recaptchaContextProviderValue,
        children: children
    });
};
var useRecaptcha = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(RecaptchaContext);
    if (!context) {
        throw new Error("useRecaptcha must be used within an RecaptchaContext");
    }
    return context;
};


/***/ }),

/***/ 9521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zl": function() { return /* binding */ CartProvider; },
  "iQ": function() { return /* binding */ useCartContext; }
});

// UNUSED EXPORTS: cartIdCookie

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/application/hooks/index.ts + 19 modules
var hooks = __webpack_require__(38665);
// EXTERNAL MODULE: ../../packages/application/services/apis/Shopping/data.ts
var data = __webpack_require__(219);
// EXTERNAL MODULE: ../../packages/application/utils/index.tsx + 44 modules
var utils = __webpack_require__(83428);
// EXTERNAL MODULE: ../../packages/application/context/BranchLocationContext.tsx
var BranchLocationContext = __webpack_require__(64462);
// EXTERNAL MODULE: ../../packages/application/context/Identity/AuthContext.tsx
var AuthContext = __webpack_require__(24452);
// EXTERNAL MODULE: ../../packages/application/context/WebSocket/index.tsx
var WebSocket = __webpack_require__(91393);
;// CONCATENATED MODULE: ../../packages/application/context/ShoppingHookContext/shoppingApi.ts
var createCartAuth = function(branchId, jwt, appMonitoringClient, shoppingApi) {
    return shoppingApi.createdCartAuthenticated(branchId, appMonitoringClient, jwt);
};
var createNewCartAnonymous = function(branchId, shoppingApi, appMonitoringClient) {
    return shoppingApi.createCartAnonymous(branchId, appMonitoringClient);
};
var useGetCartAuth = function(jwt, shoppingApi, appMonitoringClient, condition, fallbackData) {
    return shoppingApi.getCartAuthenticated(jwt, appMonitoringClient, condition, fallbackData);
};
var useFetchCartAnonymous = function(cookie, shoppingApi, appMonitoringClient, condition) {
    return shoppingApi.getCartAnonymous(cookie, appMonitoringClient, condition);
};
var setItemCartAction = function(args, shoppingApi, appMonitoringClient, jwt) {
    return shoppingApi.addItemsCart(args, appMonitoringClient, jwt);
};
var removeItemCartAction = function(args, shoppingApi, appMonitoringClient, jwt) {
    return shoppingApi.removeItemCart(args, appMonitoringClient, jwt);
};
var updateQuantityItemCartAction = function(args, shoppingApi, appMonitoringClient, jwt) {
    return shoppingApi.updateQuantityItemCart(args, appMonitoringClient, jwt);
};

// EXTERNAL MODULE: ../../packages/application/context/ShoppingHookContext/utilsCart.ts
var utilsCart = __webpack_require__(61485);
// EXTERNAL MODULE: ../../packages/application/utils/http/refresh-token/expiration-date/index.ts
var expiration_date = __webpack_require__(83367);
;// CONCATENATED MODULE: ../../packages/application/context/ShoppingHookContext/CartContext.tsx

















var cartIdCookie = "@FC:Ecom:Cart:Id";
var reducer = function(state, action) {
    switch(action.type){
        case "NEW_CART_DATA":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action.payload), {
                isLoading: false,
                oldItemCartUpdate: null,
                cartItems: (0,utilsCart/* persistFromLimitOnCartItem */.GU)(state.cartItems, action.payload.cartItems)
            });
        case "ADD_NEW_ITEM":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                cartItems: (0,utilsCart/* addItemList */.J9)(state.cartItems, action.payload)
            });
        case "IS_LOADING":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: action.payload
            });
        case "IS_LOADING_INITIAL_PAGE":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: action.payload
            });
        case "IS_UPDATE_QUANTITY_ITEM":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                cartItems: (0,utilsCart/* isUpdateQuantityAction */.y)(state.cartItems, action.payload),
                isLoading: false
            });
        case "QUANTITY_LIMIT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                cartItems: (0,utilsCart/* setItemLimit */.$t)(state.cartItems, action.payload),
                isLoading: false
            });
        default:
            throw new Error();
    }
};
var initState = function() {
    return {
        id: 0,
        clientId: 0,
        cookieId: "",
        branchId: 0,
        quantityOfItemsInCart: 0,
        totalSpotPrice: 0,
        totalSalePrice: 0,
        maxNumberOfInstallments: 0,
        minInstallmentValue: 0,
        cartItems: [],
        isLoading: false,
        oldItemCartUpdate: null
    };
};
var CartContext = /*#__PURE__*/ (0,react.createContext)({});
var CartProvider = function(param) {
    var children = param.children, shoppingApi = param.shoppingApi, catalogApi = param.catalogApi, cookie = param.cookie, appMonitoringClient = param.appMonitoringClient, PopUpAlertConfirm = param.PopUpAlertConfirm, jwtDecoder = param.jwtDecoder;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var addToast = (0,hooks/* useToast */.pm)().addToast;
    var getTokens = (0,AuthContext/* useAuth */.aC)().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var ref2 = (0,BranchLocationContext/* useBranchLocation */.vK)(), getBranchLocationClient = ref2.getBranchLocationClient, setRegionClientLocation = ref2.setRegionClientLocation;
    var BRANCH_LOCATION = getBranchLocationClient();
    var TOKEN_COOKIE_ANONYMOUS = (0,utilsCart/* getTokenCartANONYMOUS */.rv)(cookie);
    var ref3 = (0,react.useState)(""), messageError = ref3[0], setMessageError = ref3[1];
    var ref4 = (0,react.useState)(false), isSearchCEPButtonLoading = ref4[0], setIsSearchCEPButtonLoading = ref4[1];
    var ref5 = (0,react.useState)(0), limitItemsPerCpf = ref5[0], setLimitItemsPerCpf = ref5[1];
    var ref6 = (0,react.useState)(false), isRemoveProductPopUpOpen = ref6[0], setIsRemoveProductPopUpOpen = ref6[1];
    var ref7 = (0,react.useState)(false), isAddProductPopUpOpen = ref7[0], setIsAddProductPopUpOpen = ref7[1];
    var errorDescriptionMessage = "Ocorreu um erro inesperado. Por favor, tente novamente em instantes.";
    var ref8 = (0,react.useReducer)(reducer, {
        id: 0,
        clientId: 0,
        cookieId: "",
        branchId: 0,
        quantityOfItemsInCart: 0,
        totalSpotPrice: 0,
        totalSalePrice: 0,
        maxNumberOfInstallments: 0,
        minInstallmentValue: 0,
        cartItems: [],
        isLoading: false,
        oldItemCartUpdate: null
    }, initState), stateCart = ref8[0], dispatch = ref8[1];
    var accessTokenDecoded = function() {
        if (accessToken) {
            return jwtDecoder.decode(accessToken);
        }
        return null;
    };
    var isAccessTokenExpired = (0,expiration_date/* validateAccessTokenIsExpired */.L)(Number((ref1 = accessTokenDecoded()) === null || ref1 === void 0 ? void 0 : ref1.exp), 120);
    var errorCallback = (0,react.useCallback)(function(productId, cartId) {
        addToast({
            title: "Houve um erro ao adicionar o produto ao carrinho",
            description: "N\xe3o foi poss\xedvel adicionar o produto em quest\xe3o ao seu carrinho. Por favor tente novamente",
            isNewToast: true,
            newToastTheme: "light",
            type: "error"
        });
        if (productId || cartId) {
            appMonitoringClient.captureMessage("Falha ao adicionar o produto ".concat(productId, " ao carrinho. Cartid inv\xe1lido: ").concat(cartId));
        }
    }, [
        addToast,
        appMonitoringClient
    ]);
    var cartIdValue = (0,react.useMemo)(function() {
        return stateCart.id || Number(cookie.getCookie({
            name: cartIdCookie
        }));
    }, [
        cookie,
        stateCart.id
    ]);
    var ref9 = useGetCartAuth(accessToken !== null && accessToken !== void 0 ? accessToken : "", shoppingApi, appMonitoringClient, Boolean(accessToken && !isAccessTokenExpired)), dataGetCart = ref9.data, isLoadingAuth = ref9.isLoading, triggerGetCartAuth = ref9.trigger;
    var ref10 = useFetchCartAnonymous(TOKEN_COOKIE_ANONYMOUS || "", shoppingApi, appMonitoringClient, Boolean(TOKEN_COOKIE_ANONYMOUS)), dataFetchCartAnonymous = ref10.data, isLoadingAnonymous = ref10.isLoading, triggerCartAnonymous = ref10.trigger;
    (0,react.useEffect)(function() {
        if (dataGetCart) {
            cookie.setCookie({
                name: cartIdCookie,
                value: String(dataGetCart.id)
            });
            return;
        }
        if (dataFetchCartAnonymous) {
            cookie.setCookie({
                name: cartIdCookie,
                value: String(dataFetchCartAnonymous.id)
            });
        }
    }, [
        cookie,
        dataFetchCartAnonymous,
        dataGetCart
    ]);
    var emitEvent = (0,WebSocket.useWebSocket)().emitEvent;
    var handleEmitEventCartModified = (0,react.useCallback)(function() {
        var clientLocation = (0,utils/* getClientLocationDetails */.tK)(cookie);
        emitEvent("cartModified", clientLocation);
    }, [
        cookie,
        emitEvent
    ]);
    var createdCartAuthAction = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        createCartAuth(Number(BRANCH_LOCATION), accessToken !== null && accessToken !== void 0 ? accessToken : "", appMonitoringClient, shoppingApi)
                    ];
                case 1:
                    response = _state.sent();
                    if (response) {
                        dispatch({
                            type: "NEW_CART_DATA",
                            payload: response
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        BRANCH_LOCATION,
        accessToken,
        appMonitoringClient,
        shoppingApi
    ]);
    // A lógica abaixo tem a pretensão de criar um novo carrinho sempre que o branchId for alterado. Se o usuário estiver logado, uma requisição PUT é feita para criar um novo carrinho com o branchId atualizado. Se o usuário não estiver logado, o token do carrinho anônimo é deletado e um novo carrinho é criado.
    (0,react.useEffect)(function() {
        if (stateCart.branchId !== 0 && stateCart.branchId !== Number(BRANCH_LOCATION)) {
            if (accessToken) {
                createdCartAuthAction();
            } else {
                (0,utilsCart/* deleteTokenCartANONYMOUS */.q$)(cookie);
            }
        }
    }, [
        BRANCH_LOCATION,
        accessToken,
        cookie,
        createdCartAuthAction,
        stateCart.branchId, 
    ]);
    var initialCartAnonymous = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var response, cookieId;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        createNewCartAnonymous(Number(BRANCH_LOCATION), shoppingApi, appMonitoringClient)
                    ];
                case 1:
                    response = _state.sent();
                    if (response) {
                        cookieId = response.cookieId;
                        dispatch({
                            type: "NEW_CART_DATA",
                            payload: response
                        });
                        (0,utilsCart/* createTokenCartANONYMOUS */.cK)(cookie, "".concat(cookieId));
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        BRANCH_LOCATION,
        appMonitoringClient,
        cookie,
        shoppingApi
    ]);
    var ref11 = (0,react.useState)(false), isFetchingCartFromEventListener = ref11[0], setIsFetchingCartFromEventListener = ref11[1];
    var fetchCart = (0,react.useCallback)(function() {
        var fromEventListener = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (accessToken && triggerGetCartAuth) {
            triggerGetCartAuth();
            if (fromEventListener) {
                setIsFetchingCartFromEventListener(true);
            }
        } else if (!TOKEN_COOKIE_ANONYMOUS) {
            initialCartAnonymous();
        } else if (triggerCartAnonymous) {
            triggerCartAnonymous();
        }
    }, [
        accessToken,
        TOKEN_COOKIE_ANONYMOUS,
        initialCartAnonymous,
        triggerGetCartAuth,
        triggerCartAnonymous, 
    ]);
    var setInitialStateCart = (0,react.useCallback)(function(stateCartDto) {
        if (!stateCartDto) {
            return;
        }
        dispatch({
            type: "NEW_CART_DATA",
            payload: stateCartDto
        });
    }, []);
    var handleAddCartItemError = (0,react.useCallback)(function(errorData, limitItemsPerCpfStr) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
        if (errorData === null || errorData === void 0 ? void 0 : (ref = errorData.errors) === null || ref === void 0 ? void 0 : (ref1 = ref["0"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.errorMessage) === null || ref2 === void 0 ? void 0 : ref2.includes("limite")) {
            var ref18, ref19, ref20;
            var ref21;
            var limitItemsPerCpfStrMessage = (ref21 = errorData === null || errorData === void 0 ? void 0 : (ref18 = errorData.errors) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.errorMessage) === null || ref20 === void 0 ? void 0 : ref20.replace(/\D/g, "")) !== null && ref21 !== void 0 ? ref21 : limitItemsPerCpfStr;
            setMessageError("Este item possui um limite de ".concat(limitItemsPerCpfStrMessage, " unidade(s) por cliente."));
            return limitItemsPerCpfStrMessage;
        }
        if (errorData === null || errorData === void 0 ? void 0 : (ref3 = errorData.errors) === null || ref3 === void 0 ? void 0 : (ref4 = ref3["0"]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.errorMessage) === null || ref5 === void 0 ? void 0 : ref5.includes("PackingQuantity")) {
            setMessageError("A quantidade de pacotes do produto deve ser maior que 0.");
            return null;
        }
        if (errorData === null || errorData === void 0 ? void 0 : (ref6 = errorData.errors) === null || ref6 === void 0 ? void 0 : (ref7 = ref6["0"]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.errorMessage) === null || ref8 === void 0 ? void 0 : ref8.includes("indispon\xedvel")) {
            setMessageError("Essa oferta est\xe1 esgotada no momento.");
            return null;
        }
        if (errorData === null || errorData === void 0 ? void 0 : (ref9 = errorData.errors) === null || ref9 === void 0 ? void 0 : (ref10 = ref9["0"]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.errorMessage) === null || ref11 === void 0 ? void 0 : ref11.includes("informada")) {
            setMessageError("A filial precisa ser informada.");
            return null;
        }
        if (errorData === null || errorData === void 0 ? void 0 : (ref12 = errorData.errors) === null || ref12 === void 0 ? void 0 : (ref13 = ref12["0"]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.errorMessage) === null || ref14 === void 0 ? void 0 : ref14.includes("excede")) {
            var ref22, ref23;
            setMessageError((errorData === null || errorData === void 0 ? void 0 : (ref22 = errorData.errors) === null || ref22 === void 0 ? void 0 : (ref23 = ref22["0"]) === null || ref23 === void 0 ? void 0 : ref23.errorMessage) || "");
            return null;
        }
        if (errorData === null || errorData === void 0 ? void 0 : (ref15 = errorData.errors) === null || ref15 === void 0 ? void 0 : (ref16 = ref15["0"]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.errorMessage) === null || ref17 === void 0 ? void 0 : ref17.includes("carrinho")) {
            setMessageError("A filial do produto deve ser a mesma do carrinho.");
            return null;
        }
        setMessageError(errorDescriptionMessage);
        return null;
    }, [
        setMessageError
    ]);
    var addNewItemCart = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var productId, quantity, packageItem, packingQuantity, sellerId, price, _cartId, cartId, listId, branchId, _shouldValidateIfBranchIdIsChanged, shouldValidateIfBranchIdIsChanged, _showPopUp, showPopUp, reliableCartId, returnData, errorData, ref, isBranchIdChanged, updatedBranchId, ref1, ref2, ref3, TOTAL_ITEMS_LIMIT;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        productId = param.productId, quantity = param.quantity, packageItem = param.package, packingQuantity = param.packingQuantity, sellerId = param.sellerId, price = param.price, _cartId = param.cartId, cartId = _cartId === void 0 ? cartIdValue : _cartId, listId = param.listId, branchId = param.branchId, _shouldValidateIfBranchIdIsChanged = param.shouldValidateIfBranchIdIsChanged, shouldValidateIfBranchIdIsChanged = _shouldValidateIfBranchIdIsChanged === void 0 ? true : _shouldValidateIfBranchIdIsChanged, _showPopUp = param.showPopUp, showPopUp = _showPopUp === void 0 ? true : _showPopUp;
                        reliableCartId = cartId || cartIdValue;
                        if (!reliableCartId) {
                            errorCallback(productId, reliableCartId);
                            return [
                                2,
                                {}
                            ];
                        }
                        return [
                            4,
                            setItemCartAction({
                                cartId: reliableCartId,
                                productId: productId,
                                quantity: quantity,
                                package: packageItem,
                                packingQuantity: packingQuantity,
                                sellerId: sellerId,
                                price: price,
                                branchId: branchId,
                                listId: listId
                            }, shoppingApi, appMonitoringClient, accessToken)
                        ];
                    case 1:
                        returnData = _state.sent();
                        errorData = returnData;
                        if (!shouldValidateIfBranchIdIsChanged) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,utilsCart/* handleCartHasChanges */.Fw)("add", errorData, accessToken, shoppingApi, cookie, appMonitoringClient, branchId)
                        ];
                    case 2:
                        ref = _state.sent(), isBranchIdChanged = ref.isBranchIdChanged, updatedBranchId = ref.branchId;
                        if (isBranchIdChanged) {
                            return [
                                2,
                                addNewItemCart({
                                    productId: productId,
                                    quantity: quantity,
                                    package: packageItem,
                                    packingQuantity: packingQuantity,
                                    sellerId: sellerId,
                                    price: price,
                                    cartId: reliableCartId,
                                    listId: listId,
                                    branchId: updatedBranchId,
                                    shouldValidateIfBranchIdIsChanged: false
                                })
                            ];
                        }
                        _state.label = 3;
                    case 3:
                        if ("isValid" in errorData && !(errorData === null || errorData === void 0 ? void 0 : errorData.isValid) || !("id" in errorData)) {
                            ;
                            if (errorData === null || errorData === void 0 ? void 0 : (ref1 = errorData.errors) === null || ref1 === void 0 ? void 0 : ref1.length) {
                                (0,data/* handleCartError */.p)(errorData, appMonitoringClient, "add_item_to_cart");
                            }
                            TOTAL_ITEMS_LIMIT = handleAddCartItemError(errorData, limitItemsPerCpf);
                            if (showPopUp) {
                                setIsAddProductPopUpOpen(true);
                            }
                            return [
                                2,
                                {
                                    limitTotalItens: TOTAL_ITEMS_LIMIT,
                                    hasError: !!(errorData === null || errorData === void 0 ? void 0 : (ref2 = errorData.errors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2["0"]) === null || ref3 === void 0 ? void 0 : ref3.errorMessage) || false
                                }
                            ];
                        }
                        dispatch({
                            type: "ADD_NEW_ITEM",
                            payload: returnData
                        });
                        fetchCart();
                        handleEmitEventCartModified();
                        return [
                            2,
                            {}
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        accessToken,
        appMonitoringClient,
        cartIdValue,
        cookie,
        errorCallback,
        fetchCart,
        handleAddCartItemError,
        handleEmitEventCartModified,
        limitItemsPerCpf,
        shoppingApi, 
    ]);
    var updateQuantityItemCart = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
            var _showPopUp, showPopUp, args, returnRequestUpdate, ref, isBranchIdChanged, hasSomeError, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, TOTAL_ITEMS_LIMIT;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _showPopUp = _param.showPopUp, showPopUp = _showPopUp === void 0 ? true : _showPopUp, args = (0,_object_without_properties/* default */.Z)(_param, [
                            "showPopUp"
                        ]);
                        return [
                            4,
                            updateQuantityItemCartAction(args, shoppingApi, appMonitoringClient, accessToken)
                        ];
                    case 1:
                        returnRequestUpdate = _state.sent();
                        return [
                            4,
                            (0,utilsCart/* handleCartHasChanges */.Fw)("update", returnRequestUpdate, accessToken, shoppingApi, cookie, appMonitoringClient, Number(BRANCH_LOCATION))
                        ];
                    case 2:
                        ref = _state.sent(), isBranchIdChanged = ref.isBranchIdChanged, hasSomeError = ref.hasSomeError;
                        if (isBranchIdChanged) {
                            setRegionClientLocation(null);
                        }
                        if (hasSomeError) {
                            fetchCart();
                            addToast({
                                title: isBranchIdChanged ? "O seu carrinho foi atualizado" : "Esse item j\xe1 foi exclu\xeddo do seu carrinho",
                                type: "info",
                                timerInMilliseconds: 3000
                            });
                            return [
                                2,
                                undefined
                            ];
                        }
                        if (returnRequestUpdate && "isValid" in returnRequestUpdate && !(returnRequestUpdate === null || returnRequestUpdate === void 0 ? void 0 : returnRequestUpdate.isValid) || returnRequestUpdate && !("id" in returnRequestUpdate)) {
                            ;
                            (0,data/* handleCartError */.p)(returnRequestUpdate, appMonitoringClient, "update_item_to_cart");
                            if (returnRequestUpdate === null || returnRequestUpdate === void 0 ? void 0 : (ref1 = returnRequestUpdate.errors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.errorMessage) === null || ref3 === void 0 ? void 0 : ref3.includes("limite")) {
                                ;
                                TOTAL_ITEMS_LIMIT = returnRequestUpdate === null || returnRequestUpdate === void 0 ? void 0 : (ref4 = returnRequestUpdate.errors) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.errorMessage) === null || ref6 === void 0 ? void 0 : ref6.replace(/\D/g, "");
                                dispatch({
                                    type: "QUANTITY_LIMIT",
                                    payload: {
                                        limitItemCart: Number(TOTAL_ITEMS_LIMIT || 1),
                                        productIdCart: args.idProductCart
                                    }
                                });
                                setMessageError((returnRequestUpdate === null || returnRequestUpdate === void 0 ? void 0 : (ref7 = returnRequestUpdate.errors) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.errorMessage) || "Ops! Voc\xea atingiu o limite m\xe1ximo de quantidade permitida por compra.");
                            }
                            if (showPopUp) {
                                setIsAddProductPopUpOpen(true);
                            }
                            return [
                                2,
                                {
                                    hasError: true
                                }
                            ];
                        }
                        dispatch({
                            type: "IS_UPDATE_QUANTITY_ITEM",
                            payload: {
                                productIdCart: args.idProductCart,
                                quantityItem: args.quantity
                            }
                        });
                        fetchCart();
                        handleEmitEventCartModified();
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }(), [
        BRANCH_LOCATION,
        accessToken,
        addToast,
        appMonitoringClient,
        cookie,
        fetchCart,
        handleEmitEventCartModified,
        setRegionClientLocation,
        shoppingApi, 
    ]);
    var addProductToControlledCart = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var productId, quantity, packageItem, packingQuantity, sellerId, price, _cartId, cartId, _listId, listId, showPopUp, reliableCartId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                productId = param.productId, quantity = param.quantity, packageItem = param.package, packingQuantity = param.packingQuantity, sellerId = param.sellerId, price = param.price, _cartId = param.cartId, cartId = _cartId === void 0 ? cartIdValue : _cartId, _listId = param.listId, listId = _listId === void 0 ? 0 : _listId, showPopUp = param.showPopUp;
                reliableCartId = cartId || cartIdValue;
                if (!reliableCartId) {
                    errorCallback(productId, reliableCartId);
                }
                return [
                    2,
                    addNewItemCart({
                        productId: productId,
                        branchId: Number(BRANCH_LOCATION),
                        quantity: quantity,
                        package: packageItem,
                        packingQuantity: packingQuantity,
                        sellerId: sellerId,
                        price: price,
                        cartId: reliableCartId,
                        listId: listId,
                        showPopUp: showPopUp
                    })
                ];
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        BRANCH_LOCATION,
        addNewItemCart,
        cartIdValue,
        errorCallback
    ]);
    var removeItemCart = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(args) {
            var hasErrorOnItemRemoval;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            removeItemCartAction(args, shoppingApi, appMonitoringClient, accessToken)
                        ];
                    case 1:
                        hasErrorOnItemRemoval = _state.sent();
                        if (hasErrorOnItemRemoval) {
                            setMessageError(errorDescriptionMessage);
                            setIsRemoveProductPopUpOpen(true);
                        }
                        handleEmitEventCartModified();
                        return [
                            2,
                            fetchCart()
                        ];
                }
            });
        });
        return function(args) {
            return _ref.apply(this, arguments);
        };
    }(), [
        accessToken,
        appMonitoringClient,
        fetchCart,
        handleEmitEventCartModified,
        shoppingApi, 
    ]);
    (0,react.useEffect)(function() {
        if (dataGetCart) {
            dispatch({
                type: "NEW_CART_DATA",
                payload: (0,_object_spread/* default */.Z)({}, dataGetCart)
            });
        }
        if (dataFetchCartAnonymous) {
            dispatch({
                type: "NEW_CART_DATA",
                payload: (0,_object_spread/* default */.Z)({}, dataFetchCartAnonymous)
            });
        }
    }, [
        dataFetchCartAnonymous,
        dataGetCart
    ]);
    (0,react.useEffect)(function() {
        if (isFetchingCartFromEventListener && !isLoadingAuth && dataGetCart) {
            setIsFetchingCartFromEventListener(false);
        }
    }, [
        dataGetCart,
        isFetchingCartFromEventListener,
        isLoadingAuth
    ]);
    (0,react.useEffect)(function() {
        dispatch({
            type: "IS_LOADING",
            payload: isLoadingAnonymous || isLoadingAuth
        });
    }, [
        isLoadingAnonymous,
        isLoadingAuth
    ]);
    (0,react.useEffect)(function() {
        fetchCart();
    }, [
        TOKEN_COOKIE_ANONYMOUS,
        accessToken,
        fetchCart
    ]);
    (0,react.useEffect)(function() {
        var handleClientHasCartItems = function() {
            var ref, ref1;
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("clientHasCartItems", "".concat(Boolean((dataFetchCartAnonymous === null || dataFetchCartAnonymous === void 0 ? void 0 : (ref = dataFetchCartAnonymous.cartItems) === null || ref === void 0 ? void 0 : ref.length) || (dataGetCart === null || dataGetCart === void 0 ? void 0 : (ref1 = dataGetCart.cartItems) === null || ref1 === void 0 ? void 0 : ref1.length))));
        };
        window.addEventListener("beforeunload", handleClientHasCartItems);
        return function() {
            window.removeEventListener("beforeunload", handleClientHasCartItems);
        };
    }, [
        dataFetchCartAnonymous === null || dataFetchCartAnonymous === void 0 ? void 0 : dataFetchCartAnonymous.cartItems,
        dataGetCart === null || dataGetCart === void 0 ? void 0 : dataGetCart.cartItems
    ]);
    /**
   * artur.castro Encontrar melhor solução para depois
   */ (0,react.useEffect)(function() {
        var routeChangeHandler = function() {
            if (router.pathname !== "/produto/[idProduct]/[nameProduct]") {
                setMessageError("");
            }
        };
        router.events.on("routeChangeStart", routeChangeHandler);
        // Solução temporária para forçar a exclusão do token do carrinho anônimo, quando o usuário já estiver logado
        if (accessToken && (0,utilsCart/* getTokenCartANONYMOUS */.rv)(cookie)) {
            (0,utilsCart/* deleteTokenCartANONYMOUS */.q$)(cookie);
        }
        return function() {
            router.events.off("routeChangeStart", routeChangeHandler);
        };
    }, [
        accessToken,
        cookie,
        router
    ]);
    var ref12 = (0,react.useState)([]), cartProductsList = ref12[0], setCartProductsList = ref12[1];
    var getCartProductsList = (0,react.useCallback)(function(cartItems) {
        var ref, ref1;
        var productIdsList = cartItems === null || cartItems === void 0 ? void 0 : cartItems.map(function(item) {
            return item.productId;
        });
        var productListString = productIdsList === null || productIdsList === void 0 ? void 0 : productIdsList.join(",");
        var ref2 = catalogApi.getProductList(productListString, String(cartItems === null || cartItems === void 0 ? void 0 : (ref = cartItems[0]) === null || ref === void 0 ? void 0 : ref.branchId), !!(productListString && (cartItems === null || cartItems === void 0 ? void 0 : (ref1 = cartItems[0]) === null || ref1 === void 0 ? void 0 : ref1.branchId))), productsList = ref2.data, isLoading = ref2.isLoading;
        var formattedProductsList = productsList === null || productsList === void 0 ? void 0 : productsList.map(function(item) {
            var quantity = (0,utils/* getProductQuantity */.z1)(item === null || item === void 0 ? void 0 : item.id, cartItems);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                quantity: quantity
            });
        });
        var hasCartProductsListChanges = formattedProductsList === null || formattedProductsList === void 0 ? void 0 : formattedProductsList.find(function(param, index) {
            var id = param.id, quantity = param.quantity;
            var ref, ref1;
            return id !== (cartProductsList === null || cartProductsList === void 0 ? void 0 : (ref = cartProductsList["".concat(index)]) === null || ref === void 0 ? void 0 : ref.id) || quantity !== (cartProductsList === null || cartProductsList === void 0 ? void 0 : (ref1 = cartProductsList["".concat(index)]) === null || ref1 === void 0 ? void 0 : ref1.quantity);
        });
        if (hasCartProductsListChanges) {
            setCartProductsList(formattedProductsList);
        }
        return {
            productsList: formattedProductsList,
            isLoadingProductInfo: isLoading
        };
    }, [
        cartProductsList,
        catalogApi
    ]);
    var removeProductsFromCartProductsList = (0,react.useCallback)(function(productIdsList, currentCartItemsList) {
        var updatedCartItemsList = currentCartItemsList === null || currentCartItemsList === void 0 ? void 0 : currentCartItemsList.filter(function(param) {
            var id = param.id;
            return !(productIdsList === null || productIdsList === void 0 ? void 0 : productIdsList.includes(id));
        });
        setCartProductsList(updatedCartItemsList);
        handleEmitEventCartModified();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var cartProviderValues = (0,react.useMemo)(function() {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stateCart), {
            createdCartAuthAction: createdCartAuthAction,
            initialCartAnonymous: initialCartAnonymous,
            addNewItemCart: addNewItemCart,
            updateQuantityItemCart: updateQuantityItemCart,
            addProductToControlledCart: addProductToControlledCart,
            setInitialStateCart: setInitialStateCart,
            removeItemCart: removeItemCart,
            fetchCart: fetchCart,
            isSearchCEPButtonLoading: isSearchCEPButtonLoading,
            setIsSearchCEPButtonLoading: setIsSearchCEPButtonLoading,
            messageError: messageError,
            handleEmitEventCartModified: handleEmitEventCartModified,
            getCartProductsList: getCartProductsList,
            cartProductsList: cartProductsList,
            removeProductsFromCartProductsList: removeProductsFromCartProductsList,
            setLimitItemsPerCpf: setLimitItemsPerCpf,
            isFetchingCartFromEventListener: isFetchingCartFromEventListener,
            isGetCartLoading: isLoadingAuth || isLoadingAnonymous
        });
    }, [
        stateCart,
        createdCartAuthAction,
        initialCartAnonymous,
        addNewItemCart,
        updateQuantityItemCart,
        addProductToControlledCart,
        setInitialStateCart,
        removeItemCart,
        fetchCart,
        isSearchCEPButtonLoading,
        messageError,
        handleEmitEventCartModified,
        getCartProductsList,
        cartProductsList,
        removeProductsFromCartProductsList,
        isFetchingCartFromEventListener,
        isLoadingAuth,
        isLoadingAnonymous, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartContext.Provider, {
        value: cartProviderValues,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpAlertConfirm, {
                textHeader: "Falha ao adicionar produto ao carrinho.",
                descriptionBody: "".concat(messageError),
                isOpen: isAddProductPopUpOpen,
                actionCloseButton: function() {
                    setIsAddProductPopUpOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpAlertConfirm, {
                textHeader: "Falha ao remover produto do carrinho.",
                descriptionBody: messageError,
                isOpen: isRemoveProductPopUpOpen,
                actionCloseButton: function() {
                    setIsRemoveProductPopUpOpen(false);
                }
            })
        ]
    });
};
var useCartContext = function() {
    return (0,react.useContext)(CartContext);
};


/***/ }),

/***/ 61485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ setItemLimit; },
/* harmony export */   "Fw": function() { return /* binding */ handleCartHasChanges; },
/* harmony export */   "GU": function() { return /* binding */ persistFromLimitOnCartItem; },
/* harmony export */   "J9": function() { return /* binding */ addItemList; },
/* harmony export */   "cK": function() { return /* binding */ createTokenCartANONYMOUS; },
/* harmony export */   "q$": function() { return /* binding */ deleteTokenCartANONYMOUS; },
/* harmony export */   "rv": function() { return /* binding */ getTokenCartANONYMOUS; },
/* harmony export */   "y": function() { return /* binding */ isUpdateQuantityAction; }
/* harmony export */ });
/* unused harmony exports removeItemAction, restoreItemInListAction, findItemCart */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50853);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83428);





var NAME_COOKIE_TOKEN_ANONYMOUS = "@FC:Ecom:TokenAnonymous";
var deleteTokenCartANONYMOUS = function(cookieControl) {
    return cookieControl.deleteCookie({
        name: NAME_COOKIE_TOKEN_ANONYMOUS
    });
};
var getTokenCartANONYMOUS = function(cookieControl) {
    return cookieControl.getCookie({
        name: NAME_COOKIE_TOKEN_ANONYMOUS
    });
};
var createTokenCartANONYMOUS = function(cookieControl, value) {
    return cookieControl.setCookie({
        name: NAME_COOKIE_TOKEN_ANONYMOUS,
        value: value
    });
};
var removeItemAction = function(itemsList, payload) {
    return itemsList.filter(function(item) {
        return item.id !== payload.productIdCart;
    });
};
var restoreItemInListAction = function(itemsList, itemOldCart) {
    // console.log(itemOldCart, itemsList);
    if (!itemOldCart) {
        return itemsList;
    }
    return itemsList.map(function(item) {
        if (item.id === itemOldCart.id) {
            return itemOldCart;
        }
        return item;
    });
};
var setItemLimit = function(productList, payload) {
    return productList.map(function(item) {
        if (item.id === payload.productIdCart) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item), {
                limitTotalItens: payload.limitItemCart
            });
        }
        return item;
    });
};
var isUpdateQuantityAction = function(itemsList, payload) {
    return itemsList.map(function(item) {
        if (item.id === payload.productIdCart) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item), {
                quantity: payload.quantityItem || 1
            });
        }
        return item;
    });
};
var findItemCart = function(itemsList, param) {
    var productIdCart = param.productIdCart;
    return itemsList.find(function(item) {
        return item.id === productIdCart;
    });
};
var addItemList = function(itemsList, payload) {
    itemsList.push(payload);
    return itemsList;
};
var persistFromLimitOnCartItem = function(currentCartItems, payload) {
    return payload === null || payload === void 0 ? void 0 : payload.map(function(product) {
        var productFound = currentCartItems === null || currentCartItems === void 0 ? void 0 : currentCartItems.find(function(currentProduct) {
            return currentProduct.id === product.id && "limitTotalItens" in currentProduct;
        });
        if (productFound) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, product), {
                limitTotalItens: productFound.limitTotalItens
            });
        }
        return product;
    });
};
var sendErrorToAppMonitoringClient = function(actionType, appMonitoringClient) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "branch_id_changed";
    var message = {
        add: "Usu\xe1rio tentou adicionar item no carrinho com uma branch diferente da branch do carrinho",
        update: "Usu\xe1rio tentou atualizar um item que n\xe3o existe mais no carrinho"
    }["".concat(actionType)];
    var event = {
        add: "add_item_to_cart",
        update: "update_item_to_cart"
    }["".concat(actionType)];
    appMonitoringClient.captureMessage(message, {
        level: "error",
        tags: {
            fcx_labs_event: event,
            fcx_labs_error_source: "shopping_api",
            fcx_labs_error_reason: reason
        }
    });
};
var handleCartHasChanges = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(actionType, error, accessToken, shoppingApi, cookie, appMonitoringClient, clientBranchId) {
        var ref, ref1, isAddItemError, isUpdateItemError, hasSomeError, data, isBranchIdChanged;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isAddItemError = actionType === "add" && "isValid" in error && !(error === null || error === void 0 ? void 0 : error.isValid) && (error === null || error === void 0 ? void 0 : (ref = error.errors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.propertyName) === "CartItemToAddInCart.BranchId";
                    isUpdateItemError = actionType === "update" && (error === null || error === void 0 ? void 0 : error.status) === 404;
                    hasSomeError = isAddItemError || isUpdateItemError;
                    if (!hasSomeError) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        shoppingApi.fetchCartAuthenticated(accessToken)
                    ];
                case 1:
                    data = _state.sent().data;
                    isBranchIdChanged = isAddItemError || clientBranchId !== (data === null || data === void 0 ? void 0 : data.branchId);
                    if (isBranchIdChanged) {
                        cookie.setCookie({
                            name: _utils__WEBPACK_IMPORTED_MODULE_0__/* .cookieBranchLocationStr */ .NL,
                            value: "".concat(data === null || data === void 0 ? void 0 : data.branchId),
                            options: _utils__WEBPACK_IMPORTED_MODULE_0__/* .optionsMaxAgeEqualOneYear.options */ .AW.options
                        });
                        cookie.deleteCookie({
                            name: _utils__WEBPACK_IMPORTED_MODULE_0__/* .cookieRegionStr */ .us
                        });
                        cookie.deleteCookie({
                            name: _utils__WEBPACK_IMPORTED_MODULE_0__/* .cookiePostalCodeStr */ .em
                        });
                    }
                    sendErrorToAppMonitoringClient(actionType, appMonitoringClient, isBranchIdChanged ? undefined : "item_does_not_exist");
                    return [
                        2,
                        {
                            isBranchIdChanged: isBranchIdChanged,
                            branchId: data === null || data === void 0 ? void 0 : data.branchId,
                            hasSomeError: hasSomeError
                        }
                    ];
                case 2:
                    return [
                        2,
                        {
                            isBranchIdChanged: false
                        }
                    ];
            }
        });
    });
    return function handleCartHasChanges(actionType, error, accessToken, shoppingApi, cookie, appMonitoringClient, clientBranchId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 91393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WebSocketContext": function() { return /* binding */ WebSocketContext; },
/* harmony export */   "WebSocketContextProvider": function() { return /* binding */ WebSocketContextProvider; },
/* harmony export */   "useWebSocket": function() { return /* binding */ useWebSocket; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var WebSocketContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var WebSocketContextProvider = function(param) {
    var children = param.children, webSocketClient = param.webSocketClient, appMonitoringClient = param.appMonitoringClient, eventEmitter = param.eventEmitter;
    var handleMessageCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(message) {
        var messageData = JSON.parse(message === null || message === void 0 ? void 0 : message.data);
        if ([
            "login",
            "cartModified",
            "branchChanged"
        ].includes(messageData === null || messageData === void 0 ? void 0 : messageData.event)) {
            eventEmitter.emit(messageData === null || messageData === void 0 ? void 0 : messageData.event, messageData === null || messageData === void 0 ? void 0 : messageData.metadata);
        }
    }, [
        eventEmitter
    ]);
    var emitEvent = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(eventAction, metadata) {
        try {
            webSocketClient.emitEvent(eventAction, metadata);
        } catch (err) {
            appMonitoringClient.captureException(err, {
                level: "error",
                tags: {
                    fcx_labs_event: "emit_event",
                    fcx_labs_error_source: "web_socket"
                }
            });
        }
    }, [
        appMonitoringClient,
        webSocketClient
    ]);
    var emitEventClientLogin = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(clientLocation) {
        var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var timeout = setTimeout(function() {
            if (count === 10) {
                clearTimeout(timeout);
                return;
            }
            if (!(webSocketClient === null || webSocketClient === void 0 ? void 0 : webSocketClient.getUserEmail())) {
                emitEventClientLogin(clientLocation, count + 1);
            }
            emitEvent("login", clientLocation);
            clearTimeout(timeout);
        }, 1000);
    }, [
        emitEvent,
        webSocketClient
    ]);
    var createWebSocketConnection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(userEmail, accessToken) {
        webSocketClient.createSocketInstance(userEmail, accessToken).then(function() {
            webSocketClient.onReceiveMessage("message", handleMessageCallback);
        });
    }, [
        handleMessageCallback,
        webSocketClient
    ]);
    var destroyWebSocketConnection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        webSocketClient.destroySocketInstance();
    }, [
        webSocketClient
    ]);
    var subscribeToEvents = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(eventsList, callback) {
        eventsList.forEach(function(event) {
            eventEmitter.subscribe(event, callback);
        });
    }, [
        eventEmitter
    ]);
    var unsubscribeFromEvents = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(eventsList, callback) {
        eventsList.forEach(function(event) {
            eventEmitter.unsubscribe(event, callback);
        });
    }, [
        eventEmitter
    ]);
    var webSocketContextProviderValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            createWebSocketConnection: createWebSocketConnection,
            destroyWebSocketConnection: destroyWebSocketConnection,
            emitEvent: emitEvent,
            subscribeToEvents: subscribeToEvents,
            unsubscribeFromEvents: unsubscribeFromEvents,
            emitEventClientLogin: emitEventClientLogin
        };
    }, [
        createWebSocketConnection,
        destroyWebSocketConnection,
        emitEvent,
        subscribeToEvents,
        unsubscribeFromEvents,
        emitEventClientLogin, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WebSocketContext.Provider, {
        value: webSocketContextProviderValue,
        children: children
    });
};
var useWebSocket = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(WebSocketContext);
    if (!context) {
        throw new Error("useWebSocket must be used within an WebSocketContext");
    }
    return context;
};


/***/ }),

/***/ 14366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ AppWrapper; },
  "b": function() { return /* binding */ useAppContext; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/hooks/userClient.ts + 37 modules
var userClient = __webpack_require__(2180);
;// CONCATENATED MODULE: ../../packages/application/context/category.ts
var getCategories = function(catalogApi, stateManager) {
    var response = catalogApi.getHomeCategories();
    return stateManager.produceNewState(response, function(param) {
        var data = param.data;
        data === null || data === void 0 ? void 0 : data.forEach(function(secondLevel) {
            var ref;
            (ref = secondLevel.categories) === null || ref === void 0 ? void 0 : ref.forEach(function(thirdLevel) {
                var ref;
                (ref = thirdLevel.categories) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
                    return a.ordination - b.ordination;
                });
            });
        });
    });
};

;// CONCATENATED MODULE: ../../packages/application/context/state.tsx




var AppContext = /*#__PURE__*/ (0,react.createContext)({});
var AppWrapper = function(param) {
    var children = param.children, catalogApi = param.catalogApi, stateManager = param.stateManager;
    var ref = (0,react.useState)(false), isOpenedLogin = ref[0], setIsOpenedLogin = ref[1];
    var ref1 = (0,react.useState)(false), isOpenedDropdownUser = ref1[0], setIsOpenedDropdownUser = ref1[1];
    var ref2 = (0,react.useState)(false), isPageWeddingList = ref2[0], setIsPageWeddingList = ref2[1];
    var ref3 = (0,react.useState)(false), focusOnInputSearch = ref3[0], setFocusOnInputSearch = ref3[1];
    var ref4 = (0,react.useState)(false), isShowModalForgotPassword = ref4[0], setIsShowModalForgotPassword = ref4[1];
    var ref5 = (0,react.useState)(false), showComponentForgotPassword = ref5[0], setShowComponentForgotPassword = ref5[1];
    var ref6 = (0,react.useState)(false), isSidebarMenuOpened = ref6[0], setIsSidebarMenuOpened = ref6[1];
    var ref7 = (0,react.useState)(false), closeCategoriesDropDown = ref7[0], setCloseCategoriesDropDown = ref7[1];
    var ref8 = (0,react.useState)(false), isBlackTheme = ref8[0], setIsBlackTheme = ref8[1];
    var ref9 = (0,react.useState)(false), isViewMorePaymentMethodsOpen = ref9[0], setIsViewMorePaymentMethodsOpen = ref9[1];
    var withBlackTheme = (0,react.useCallback)(function(value) {
        setIsBlackTheme(value);
    }, []);
    var isClientLaptop = (0,userClient/* useIsClientLaptop */.dN)();
    var isClientLaptopS = (0,userClient/* useIsClientLaptopS */.XR)();
    var isClientTabletXL = (0,userClient/* useIsClientTabletXL */.zq)();
    var isClientTabletL = (0,userClient/* useIsClientTabletL */.xB)();
    var isClientTablet = (0,userClient/* useIsClientTablet */.dL)();
    var isClientTabletSmall = (0,userClient/* useIsClientTabletSmall */.aM)();
    var isClientMobile = (0,userClient/* useIsClientMobile */._I)();
    var isClientMobileS = (0,userClient/* useIsClientMobileS */.kL)();
    var isClientMobileXS = (0,userClient/* useIsClientMobileXS */.p3)();
    var isClientTabletML = (0,userClient/* useIsClientTabletML */.$Q)();
    var isClientMobileM = (0,userClient/* useIsClientMobileM */.yG)();
    var isClientMobileL = (0,userClient/* useIsClientMobileL */.tZ)();
    var isClientTabletM = (0,userClient/* useIsClientTabletM */.q4)();
    var isClientTabletXM = (0,userClient/* useIsClientTabletXM */.lg)();
    var isClientLaptopL = (0,userClient/* useIsClientLaptopL */.Ph)();
    var isClientLaptopXL = (0,userClient/* useIsClientLaptopXL */.Mw)();
    var isClientLaptopM = (0,userClient/* useIsClientLaptopM */.TF)();
    var isClientDesktopS = (0,userClient/* useIsClientDesktopS */.tk)();
    var isClientDesktop = (0,userClient/* useIsClientDesktop */.z9)();
    var isOnlyClientLaptop = (0,userClient/* useIsOnlyClientLaptop */.dF)();
    var isOnlyClientTablet = (0,userClient/* useIsOnlyClientTablet */.lC)();
    var isOnlyClientMobile = (0,userClient/* useIsOnlyClientMobile */.d5)();
    var isOnlyMobileXSToLaptop = (0,userClient/* useIsOnlyMobileXSToLaptop */.iF)();
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var isFirefox = /^((?!chrome|android).)*firefox/i.test(navigator.userAgent);
    var categories = getCategories(catalogApi, stateManager);
    var ref10 = (0,react.useState)({
        home: "default",
        category: "default",
        highlight: "default",
        searchResult: "default",
        login: "default",
        product: "default",
        cart: "default",
        myAddresses: "default",
        myOrders: "default",
        myWeddingLists: "default",
        myCreditCards: "default",
        changePassword: "default",
        myOrdersByPhone: "default",
        detailedOrder: "default",
        myData: "default"
    }), pageThemeMap = ref10[0], setPageThemeMap = ref10[1];
    var handleFocusInputSearch = function() {
        setFocusOnInputSearch(function(state) {
            return !state;
        });
    };
    var onPageWeddingList = function() {
        setIsPageWeddingList(true);
    };
    var onManagementOpenOrClosedForgotPasswordModal = (0,react.useCallback)(function() {
        setIsShowModalForgotPassword(function(state) {
            return !state;
        });
    }, []);
    var onManagementOpenOrClosedForgotPasswordComponent = (0,react.useCallback)(function() {
        setShowComponentForgotPassword(function(state) {
            return !state;
        });
    }, []);
    var onOpenForgotPasswordModal = (0,react.useCallback)(function() {
        setIsShowModalForgotPassword(true);
    }, []);
    var onCloseForgotPasswordModal = (0,react.useCallback)(function() {
        setIsShowModalForgotPassword(false);
    }, []);
    var onCloseForgotPasswordComponent = (0,react.useCallback)(function() {
        setShowComponentForgotPassword(true);
    }, []);
    var appContextProviderValue = (0,react.useMemo)(function() {
        return {
            isPageWeddingList: isPageWeddingList,
            onPageWeddingList: onPageWeddingList,
            categories: categories,
            isBlackTheme: isBlackTheme,
            withBlackTheme: withBlackTheme,
            isClientLaptop: isClientLaptop,
            isClientTabletXL: isClientTabletXL,
            isClientTabletL: isClientTabletL,
            isClientTablet: isClientTablet,
            isClientTabletSmall: isClientTabletSmall,
            isClientMobile: isClientMobile,
            isClientMobileS: isClientMobileS,
            isClientMobileXS: isClientMobileXS,
            isClientMobileM: isClientMobileM,
            isClientMobileL: isClientMobileL,
            isClientTabletML: isClientTabletML,
            isClientTabletM: isClientTabletM,
            isClientTabletXM: isClientTabletXM,
            isClientLaptopL: isClientLaptopL,
            isClientLaptopXL: isClientLaptopXL,
            isClientLaptopM: isClientLaptopM,
            isClientLaptopS: isClientLaptopS,
            isClientDesktopS: isClientDesktopS,
            isClientDesktop: isClientDesktop,
            isOnlyClientLaptop: isOnlyClientLaptop,
            isOnlyClientTablet: isOnlyClientTablet,
            isOnlyClientMobile: isOnlyClientMobile,
            isOnlyMobileXSToLaptop: isOnlyMobileXSToLaptop,
            focusOnInputSearch: focusOnInputSearch,
            handleFocusInputSearch: handleFocusInputSearch,
            isOpenedLogin: isOpenedLogin,
            setIsOpenedLogin: setIsOpenedLogin,
            isOpenedDropdownUser: isOpenedDropdownUser,
            setIsOpenedDropdownUser: setIsOpenedDropdownUser,
            isShowModalForgotPassword: isShowModalForgotPassword,
            showComponentForgotPassword: showComponentForgotPassword,
            onOpenForgotPasswordModal: onOpenForgotPasswordModal,
            onCloseForgotPasswordModal: onCloseForgotPasswordModal,
            onCloseForgotPasswordComponent: onCloseForgotPasswordComponent,
            onManagementOpenOrClosedForgotPasswordModal: onManagementOpenOrClosedForgotPasswordModal,
            onManagementOpenOrClosedForgotPasswordComponent: onManagementOpenOrClosedForgotPasswordComponent,
            isSidebarMenuOpened: isSidebarMenuOpened,
            setIsSidebarMenuOpened: setIsSidebarMenuOpened,
            isSafari: isSafari,
            closeCategoriesDropDown: closeCategoriesDropDown,
            setCloseCategoriesDropDown: setCloseCategoriesDropDown,
            isFirefox: isFirefox,
            pageThemeMap: pageThemeMap,
            setPageThemeMap: setPageThemeMap,
            setIsViewMorePaymentMethodsOpen: setIsViewMorePaymentMethodsOpen,
            isViewMorePaymentMethodsOpen: isViewMorePaymentMethodsOpen
        };
    }, [
        isPageWeddingList,
        categories,
        isBlackTheme,
        withBlackTheme,
        isClientLaptop,
        isClientLaptopS,
        isClientTabletXL,
        isClientTabletL,
        isClientTablet,
        isClientTabletSmall,
        isClientMobile,
        isClientMobileS,
        isClientMobileXS,
        isClientMobileM,
        isClientMobileL,
        isClientTabletML,
        isClientTabletM,
        isClientTabletXM,
        isClientLaptopL,
        isClientLaptopXL,
        isClientLaptopM,
        isClientDesktopS,
        isClientDesktop,
        isOnlyClientLaptop,
        isOnlyClientTablet,
        isOnlyClientMobile,
        isOnlyMobileXSToLaptop,
        focusOnInputSearch,
        isOpenedLogin,
        isOpenedDropdownUser,
        isShowModalForgotPassword,
        showComponentForgotPassword,
        onOpenForgotPasswordModal,
        onCloseForgotPasswordModal,
        onCloseForgotPasswordComponent,
        onManagementOpenOrClosedForgotPasswordModal,
        onManagementOpenOrClosedForgotPasswordComponent,
        isSidebarMenuOpened,
        isSafari,
        closeCategoriesDropDown,
        isFirefox,
        pageThemeMap,
        setIsViewMorePaymentMethodsOpen,
        isViewMorePaymentMethodsOpen, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppContext.Provider, {
        value: appContextProviderValue,
        children: children
    });
};
var useAppContext = function() {
    return (0,react.useContext)(AppContext);
};


/***/ }),

/***/ 48561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CountdownProvider": function() { return /* binding */ CountdownProvider; },
/* harmony export */   "useCountdown": function() { return /* binding */ useCountdown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var CountdownContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var CountdownProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(60), timeInSeconds = ref[0], setTimeInSeconds = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasFinishedCountdown = ref1[0], setHasFinishedCountdown = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), conditionToStartCountdown = ref2[0], setConditionToStartCountdown = ref2[1];
    var timeFormatted = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var minutes = Math.floor(timeInSeconds / 60);
        var seconds = timeInSeconds % 60;
        var secondsFormmated = seconds < 10 ? "0".concat(seconds) : seconds;
        return "".concat(minutes, ":").concat(secondsFormmated);
    }, [
        timeInSeconds
    ]);
    var changeTimeInSeconds = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setTimeInSeconds(value);
    }, []);
    var changeHasFinishedCountdown = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setHasFinishedCountdown(value);
    }, []);
    var changeConditionToStartCountdown = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setConditionToStartCountdown(value);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (timeInSeconds > 0 && conditionToStartCountdown) {
            setTimeout(function() {
                setTimeInSeconds(timeInSeconds - 1);
            }, 1000);
        } else if (timeInSeconds === 0) {
            setHasFinishedCountdown(true);
        }
    }, [
        timeInSeconds,
        conditionToStartCountdown
    ]);
    var providerMemo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            timeInSeconds: timeInSeconds,
            hasFinishedCountdown: hasFinishedCountdown,
            timeFormatted: timeFormatted,
            changeTimeInSeconds: changeTimeInSeconds,
            changeHasFinishedCountdown: changeHasFinishedCountdown,
            changeConditionToStartCountdown: changeConditionToStartCountdown
        };
    }, [
        hasFinishedCountdown,
        timeInSeconds,
        timeFormatted,
        changeTimeInSeconds,
        changeHasFinishedCountdown,
        changeConditionToStartCountdown, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CountdownContext.Provider, {
        value: providerMemo,
        children: children
    });
};
var useCountdown = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CountdownContext);
    if (!context) {
        throw new Error("useToast must be used within an CountdownProvider");
    }
    return context;
};


/***/ }),

/***/ 26052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ToastProvider": function() { return /* binding */ ToastProvider; },
  "useToast": function() { return /* binding */ useToast; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/application/hooks/Toast/ToastContainer/Toast/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 0;\n    top: 0px;\n  }\n\n  to {\n    opacity: 1;\n    top: 14px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      min-height: 5.165rem;\n      left: 99.5% !important;\n      width: 33.25rem;\n      justify-content: flex-start;\n      padding-left: 2.165rem;\n      gap: ",
        ";\n      border-radius: 8px 8px 4px 4px;\n      box-shadow: -3px 7px 7px ",
        ";\n      -webkit-backdrop-filter: none;\n      transform: translateX(-100%);\n\n      @media ",
        " {\n        left: 50% !important;\n        transform: translateX(-50%);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  opacity: ",
        ";\n  align-items: center;\n  justify-content: space-evenly;\n  position: fixed;\n  z-index: 9999;\n  top: 14px;\n  left: 50%;\n  padding: 0.5rem 1rem;\n  transform: translateX(-50%);\n  width: auto;\n  height: fit-content;\n  border-radius: 4px;\n  background: ",
        ";\n  box-shadow: 0 0.25rem 1rem 0 ",
        ";\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  animation: ",
        " 0.4s normal;\n\n  & + & {\n    margin-top: 4.5rem;\n  }\n\n  &:last-child {\n    margin-top: 4.5rem;\n  }\n\n  @media ",
        " {\n    width: 90vw;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 1.45rem;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-left: 0.5rem;\n  width: fit-content;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    width: 100%;\n  }\n\n  100% {\n    width: 0%;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: 0;\n  left: 2px;\n  height: 4px;\n  border-radius: 4px;\n  background: ",
        ";\n  animation: ",
        " ",
        "s forwards\n    cubic-bezier(0, 0, 0, 0);\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var typeColors = {
    success: ui.theme.colors.secondary[200],
    error: ui.theme.colors.primary[200],
    info: ui.theme.colors.tertiary[200],
    default: ui.theme.colors.neutral[325]
};
var newToastThemeColors = {
    light: ui.theme.colors.neutral.white,
    dark: ui.theme.colors.neutral[680]
};
var lineProgressBarColors = {
    success: ui.theme.colors.secondary[250],
    error: ui.theme.colors.primary[350],
    info: ui.theme.colors.neutral.white,
    default: ui.theme.colors.neutral.white
};
var appearContainer = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var ToastContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ToastContainer",
    componentId: "sc-fa4a79b2-0"
})(_templateObject2(), function(param) {
    var hasClose = param.hasClose;
    return hasClose ? "none" : "flex";
}, function(param) {
    var hasClose = param.hasClose;
    return hasClose ? 0 : 1;
}, function(param) {
    var type = param.type, isNewToast = param.isNewToast, newToastTheme = param.newToastTheme;
    return !isNewToast && type ? typeColors["".concat(type)] : newToastThemeColors[newToastTheme];
}, ui.theme.colors.neutral[700], appearContainer, ui.theme.device.desktopFirst.tabletS, function(param) {
    var isNewToast = param.isNewToast;
    return isNewToast && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), ui.theme.space.x8, ui.theme.colors.neutral["999-opacity-60"], ui.theme.device.desktopFirst.mobileXL);
});
var TextContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TextContent",
    componentId: "sc-fa4a79b2-1"
})(_templateObject3(), ui.theme.space["x1.5"]);
var DescriptionToast = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DescriptionToast",
    componentId: "sc-fa4a79b2-2"
})(_templateObject4(), ui.theme.typography.fontSize.sm.x3, function(param) {
    var newToastTheme = param.newToastTheme;
    return newToastTheme === "light" ? "".concat(ui.theme.colors.neutral[350]) : "".concat(ui.theme.colors.neutral[580]);
}, ui.theme.typography.fontWeight[400]);
var IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__IconContainer",
    componentId: "sc-fa4a79b2-3"
})(_templateObject5());
var TitleToast = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TitleToast",
    componentId: "sc-fa4a79b2-4"
})(_templateObject6(), ui.theme.colors.neutral.white);
var TitleNewToast = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TitleNewToast",
    componentId: "sc-fa4a79b2-5"
})(_templateObject7(), function(param) {
    var newToastTheme = param.newToastTheme;
    return newToastTheme === "light" ? "".concat(ui.theme.colors.neutral[999]) : "".concat(ui.theme.colors.neutral.white);
}, ui.theme.typography.fontWeight[400], ui.theme.typography.fontSize.sm.x5);
var WrapperIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__WrapperIcon",
    componentId: "sc-fa4a79b2-6"
})(_templateObject8());
var CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.CloseIcon).attrs({
    width: "1.875rem",
    height: "1.875rem",
    color: ui.theme.colors.neutral.white
}).withConfig({
    displayName: "styles__CloseIcon",
    componentId: "sc-fa4a79b2-7"
})(_templateObject9());
var progressBarAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject10());
var LineProgressBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LineProgressBar",
    componentId: "sc-fa4a79b2-8"
})(_templateObject11(), function(param) {
    var type = param.type, isNewToast = param.isNewToast;
    return isNewToast ? lineProgressBarColors[type] : ui.theme.colors.neutral.white;
}, progressBarAnimation, function(param) {
    var time = param.time;
    return time;
});

// EXTERNAL MODULE: ../../packages/application/utils/index.tsx + 44 modules
var utils = __webpack_require__(83428);
;// CONCATENATED MODULE: ../../packages/application/hooks/Toast/ToastContainer/Toast/index.tsx







var Toast = function(param) {
    var id = param.id, title = param.title, description = param.description, type = param.type, _timerInMilliseconds = param.timerInMilliseconds, timerInMilliseconds = _timerInMilliseconds === void 0 ? 3500 : _timerInMilliseconds, _showProgressBar = param.showProgressBar, showProgressBar = _showProgressBar === void 0 ? true : _showProgressBar, newToastTheme = param.newToastTheme, _isNewToast = param.isNewToast, isNewToast = _isNewToast === void 0 ? false : _isNewToast;
    var ref = (0,react.useState)(false), isHasClose = ref[0], setIsHasClose = ref[1];
    var timerInSeconds = timerInMilliseconds / 1000;
    var handleCloseToast = function() {
        setIsHasClose(true);
    };
    (0,react.useEffect)(function() {
        if (showProgressBar) {
            setTimeout(function() {
                handleCloseToast();
            }, timerInMilliseconds);
        }
    }, [
        showProgressBar,
        timerInMilliseconds
    ]);
    var themeColor = newToastTheme === "light" ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[680];
    return isNewToast ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToastContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isNewToast: isNewToast,
        id: id,
        type: type,
        hasClose: isHasClose,
        newToastTheme: newToastTheme
    }, (0,utils/* buildTestIds */.Fe)("toast-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* buildTestIds */.Fe)("icon-container")), {
                children: type === "success" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SuccessIcon, {
                    secondColor: themeColor
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ErrorIcon, {
                    secondColor: themeColor
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleNewToast, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* buildTestIds */.Fe)("title-new-toast")), {
                        newToastTheme: newToastTheme,
                        children: title
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionToast, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* buildTestIds */.Fe)("description-toast")), {
                        newToastTheme: newToastTheme,
                        children: description
                    }))
                ]
            }),
            showProgressBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(LineProgressBar, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* buildTestIds */.Fe)("line-progress-bar")), {
                isNewToast: true,
                type: type,
                time: timerInSeconds
            }))
        ]
    })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToastContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: id,
        hasClose: isHasClose,
        type: type
    }, (0,utils/* buildTestIds */.Fe)("container-toast")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleToast, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* buildTestIds */.Fe)("title-toast")), {
                children: title
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* buildTestIds */.Fe)("toast-close-button")), {
                onClick: function() {
                    return handleCloseToast();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {})
            })),
            showProgressBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(LineProgressBar, {
                isNewToast: false,
                time: timerInSeconds
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/application/hooks/Toast/ToastContainer/index.tsx


var ToastContainer_ToastContainer = function(param) {
    var toastProps = param.toastProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: toastProps.map(function(toast) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast, {
                id: toast.id,
                title: toast.title,
                type: toast.type,
                isNewToast: toast.isNewToast,
                description: toast.description,
                timerInMilliseconds: toast.timerInMilliseconds,
                showProgressBar: toast.showProgressBar,
                newToastTheme: toast.newToastTheme
            }, toast.id);
        })
    });
};


;// CONCATENATED MODULE: ../../packages/application/hooks/Toast/index.tsx




var ToastContext = /*#__PURE__*/ (0,react.createContext)({});
var ToastProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)([]), triggerToast = ref[0], setTriggerToast = ref[1];
    var addToast = (0,react.useCallback)(function(param) {
        var title = param.title, type = param.type, timerInMilliseconds = param.timerInMilliseconds, showProgressBar = param.showProgressBar, description = param.description, isNewToast = param.isNewToast, newToastTheme = param.newToastTheme;
        var id = String(Math.floor(Math.random() * 1000));
        var progressTimeInMilliseconds = (title === null || title === void 0 ? void 0 : title.length) > 50 ? 12000 : timerInMilliseconds || 3500;
        var toast = {
            id: id,
            title: title,
            type: type,
            description: description,
            isNewToast: isNewToast,
            timerInMilliseconds: progressTimeInMilliseconds,
            showProgressBar: showProgressBar,
            newToastTheme: newToastTheme
        };
        setTriggerToast(function(oldToasts) {
            return (0,_to_consumable_array/* default */.Z)(oldToasts).concat([
                toast
            ]);
        });
    }, []);
    var removeToast = (0,react.useCallback)(function(id) {
        setTriggerToast(function(oldToast) {
            return oldToast.filter(function(toast) {
                return toast.id !== id;
            });
        });
    }, []);
    var providerMemo = (0,react.useMemo)(function() {
        return {
            addToast: addToast,
            removeToast: removeToast
        };
    }, [
        addToast,
        removeToast
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToastContext.Provider, {
        value: providerMemo,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastContainer_ToastContainer, {
                toastProps: triggerToast
            })
        ]
    });
};
var useToast = function() {
    var context = (0,react.useContext)(ToastContext);
    if (!context) {
        throw new Error("useToast must be used within an ToastProvider");
    }
    return context;
};


/***/ }),

/***/ 38665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Mv": function() { return /* reexport */ getBranchAddress; },
  "AD": function() { return /* reexport */ useAddItemToCart; },
  "E$": function() { return /* reexport */ useAddressSorter; },
  "O8": function() { return /* reexport */ useClickOutside; },
  "au": function() { return /* reexport */ Countdown.useCountdown; },
  "Y0": function() { return /* reexport */ useCurrentPathName; },
  "Nr": function() { return /* reexport */ useDebounce; },
  "RO": function() { return /* reexport */ useGetFiscalNote; },
  "b2": function() { return /* reexport */ useInitializeAllConfigs; },
  "u6": function() { return /* reexport */ useInitializeTwoFactor; },
  "oO": function() { return /* reexport */ useMapCrmTransactionObject; },
  "fg": function() { return /* reexport */ usePersistDataInUrl; },
  "zN": function() { return /* reexport */ useProductsRecommendation; },
  "LF": function() { return /* reexport */ useScrollVisibility; },
  "PS": function() { return /* reexport */ useShowRegisterPhoneNumberModal; },
  "J7": function() { return /* reexport */ useTimer; },
  "pm": function() { return /* reexport */ Toast.useToast; },
  "B8": function() { return /* reexport */ useValidateClientBranchChange; },
  "fT": function() { return /* reexport */ useValidatePassword; }
});

// UNUSED EXPORTS: CountdownProvider, ToastProvider, useIsClientDesktop, useIsClientDesktopS, useIsClientLaptop, useIsClientLaptopL, useIsClientLaptopM, useIsClientLaptopS, useIsClientLaptopXL, useIsClientMobile, useIsClientMobileL, useIsClientMobileM, useIsClientMobileS, useIsClientMobileXS, useIsClientTablet, useIsClientTabletL, useIsClientTabletM, useIsClientTabletML, useIsClientTabletSmall, useIsClientTabletXL, useIsClientTabletXM, useIsOnlyClientLaptop, useIsOnlyClientMobile, useIsOnlyClientTablet, useIsOnlyMobileXSToLaptop, useSlider

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/application/hooks/2fa/index.ts

var useInitializeTwoFactor = function(param) {
    var clientAction = param.clientAction, email = param.email, phoneNumber = param.phoneNumber, canChooseAnotherTwoFactorMethod = param.canChooseAnotherTwoFactorMethod, setClientAction = param.setClientAction, setEmail = param.setEmail, setPhoneNumber = param.setPhoneNumber, setCanChooseAnotherTwoFactorMethod = param.setCanChooseAnotherTwoFactorMethod, options = param.options;
    (0,react.useEffect)(function() {
        setClientAction(clientAction);
        setCanChooseAnotherTwoFactorMethod(canChooseAnotherTwoFactorMethod);
        if (email) {
            setEmail(email);
        }
        if (phoneNumber) {
            setPhoneNumber(phoneNumber);
        }
    }, [
        canChooseAnotherTwoFactorMethod,
        clientAction,
        email,
        options,
        phoneNumber,
        setCanChooseAnotherTwoFactorMethod,
        setClientAction,
        setEmail,
        setPhoneNumber, 
    ]);
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
;// CONCATENATED MODULE: ../../packages/application/hooks/addItemToCart/index.tsx



var useAddItemToCart = function(param) {
    var cart = param.cart, useToast = param.useToast, router = param.router, _stayOnPage = param.stayOnPage, stayOnPage = _stayOnPage === void 0 ? false : _stayOnPage;
    var ref = (0,react.useState)(false), isSendingItemToCart = ref[0], setIsSendingItemToCart = ref[1];
    var addToast = useToast().addToast;
    var sendItemToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var packingLevel, quantity, productId, price, ref, cartProductItem;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        packingLevel = param.packingLevel, quantity = param.quantity, productId = param.productId, price = param.price;
                        setIsSendingItemToCart(true);
                        cartProductItem = cart === null || cart === void 0 ? void 0 : (ref = cart.cartItems) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                            return (item === null || item === void 0 ? void 0 : item.productId) === productId;
                        });
                        if (!cartProductItem) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            cart.updateQuantityItemCart({
                                idProductCart: cartProductItem.id,
                                quantity: cartProductItem.quantity + 1,
                                cartId: cartProductItem.cartId,
                                showPopUp: false
                            }).then(function(res) {
                                var response = res;
                                if (response === null || response === void 0 ? void 0 : response.hasError) {
                                    addToast({
                                        isNewToast: true,
                                        title: "Ops, ocorreu um erro ao atualizar seu carrinho. Por favor, tente novamente em instantes.",
                                        type: "error",
                                        newToastTheme: "light"
                                    });
                                    return;
                                }
                                if (!stayOnPage) {
                                    router.push("/checkout/meu-carrinho");
                                }
                                addToast({
                                    isNewToast: true,
                                    title: "Carrinho atualizado com sucesso!",
                                    type: "success",
                                    newToastTheme: "light"
                                });
                            }).catch(function() {
                                addToast({
                                    isNewToast: true,
                                    title: "Erro ao atualizar seu carrinho. Por favor tente novamente mais tarde",
                                    type: "error",
                                    newToastTheme: "light"
                                });
                            }).finally(function() {
                                setIsSendingItemToCart(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        return [
                            4,
                            cart.addProductToControlledCart({
                                productId: productId,
                                quantity: 1,
                                package: packingLevel || 0,
                                packingQuantity: quantity || 1,
                                sellerId: 0,
                                price: Number(price) || 0,
                                showPopUp: false,
                                cartId: cart.id
                            }).then(function(res) {
                                var response = res;
                                if ((response === null || response === void 0 ? void 0 : response.limitTotalItens) === null) {
                                    addToast({
                                        isNewToast: true,
                                        title: "Ops, ocorreu um erro inesperado. Por favor, tente novamente em instantes.",
                                        type: "error",
                                        newToastTheme: "light"
                                    });
                                    return;
                                }
                                if (!stayOnPage) {
                                    router.push("/checkout/meu-carrinho");
                                }
                                addToast({
                                    isNewToast: true,
                                    title: "Produto adicionado ao carrinho com sucesso!",
                                    type: "success",
                                    newToastTheme: "light"
                                });
                            }).catch(function() {
                                addToast({
                                    isNewToast: true,
                                    title: "Ops, ocorreu um erro inesperado. Por favor, tente novamente em instantes.",
                                    type: "error",
                                    newToastTheme: "light"
                                });
                            }).finally(function() {
                                setIsSendingItemToCart(false);
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function sendItemToCart(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        sendItemToCart: sendItemToCart,
        isSendingItemToCart: isSendingItemToCart
    };
};


;// CONCATENATED MODULE: ../../packages/application/hooks/addressSorter/index.tsx
var useAddressSorter = function() {
    var addressList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (!(addressList === null || addressList === void 0 ? void 0 : addressList.length)) {
        return {
            sortedAddresses: []
        };
    }
    var sortedAddresses = addressList.filter(function(address) {
        return !address.isDefault;
    }).sort(function(a, b) {
        return (a.id - b.id) * -1;
    });
    var defaultAddress = addressList.find(function(address) {
        return address === null || address === void 0 ? void 0 : address.isDefault;
    });
    if (defaultAddress) {
        sortedAddresses.unshift(defaultAddress);
    }
    return {
        sortedAddresses: sortedAddresses
    };
};

;// CONCATENATED MODULE: ../../packages/application/hooks/clickOutside.ts

var useClickOutside = function(param) {
    var ref = param.ref, extraRef = param.extraRef, callback = param.callback;
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            var ref1;
            var extraCondition = extraRef ? !(extraRef === null || extraRef === void 0 ? void 0 : extraRef.current).contains(event.target) : true;
            if ((ref === null || ref === void 0 ? void 0 : ref.current) && !((ref1 = ref === null || ref === void 0 ? void 0 : ref.current) === null || ref1 === void 0 ? void 0 : ref1.contains(event.target)) && extraCondition) {
                callback();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        callback,
        extraRef,
        ref
    ]);
};

// EXTERNAL MODULE: ../../packages/application/hooks/Countdown/index.tsx
var Countdown = __webpack_require__(48561);
;// CONCATENATED MODULE: ../../packages/application/hooks/currentPathName.ts

var useCurrentPathName = function() {
    var ref = (0,react.useState)(""), currentPathname = ref[0], setCurrentPathname = ref[1];
    (0,react.useEffect)(function() {
        setCurrentPathname(window.location.pathname);
    // O eslint disable abaixo é justamente para que haja uma modificação no state currentPathName sempre que o window.location.pathname seja alterado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        window.location.pathname
    ]);
    return currentPathname;
};


;// CONCATENATED MODULE: ../../packages/application/hooks/debounce.ts

var useDebounce = function(value, delay) {
    var ref = (0,react.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react.useEffect)(function() {
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, value ? delay : 0);
        return function() {
            clearTimeout(handler);
        };
    }, [
        delay,
        value
    ]);
    return debouncedValue;
};

;// CONCATENATED MODULE: ../../packages/application/hooks/getBranchAdresses/index.tsx
var getBranchAddress = function(branchIdAdress) {
    switch(branchIdAdress){
        case "1":
            return "Av. Santo Ant\xf4nio, 515 \xb7 Centro, Garanhuns - PE, CEP 55293-909";
        case "2":
            return "Av. Mal. Mascarenhas De Morais, n\xba 2929/2967 \xb7 Imbiribeira, Recife, PE, CEP 51150-905";
        case "3":
            return "Av. Lu\xeds Viana Filho, 6180 \xb7 Paralela, Salvador - BA, CEP 41730-101";
        case "4":
            return "R. C\xf4nego Barata, 275 \xb7 Tamarineira, Recife - PE, CEP 52051-020";
        case "5":
            return "Av. Pres. Tancredo Neves, 2695 \xb7 In\xe1cio Barbosa, Aracaju - SE, CEP 49040-490";
        case "6":
            return "R. Edgar S\xe1les Miranda Henriques, 345 \xb7 Lot. Morada Nova, Cabedelo - PB, CEP 58310-000";
        case "7":
            return "Av. Engenheiro Roberto Freire, 142 \xb7 Capim Macio, Natal - RN, CEP 59078-600";
        case "8":
            return "Av. dos Estados, 129 \xb7 Nova Caruaru, Caruaru - PE, CEP 55014-560";
        case "9":
            return "Av. Vale dos Barris, 125 \xb7 Barris, Salvador - BA, CEP 40070-055";
        case "92":
            return "BR-101, 30 \xb7 Distrito Industrial Santo Estev\xe3o, Cabo de Santo Agostinho - PE";
        case "93":
            return "R. Nossa Sra. da Assun\xe7\xe3o, 169 \xb7 Alhandra - PB, CEP 58320-000";
        default:
            return "Av. Mal. Mascarenhas De Morais, n\xba 2929/2967 \xb7 Imbiribeira, Recife, PE, CEP 51150-905";
    }
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../packages/application/utils/index.tsx + 44 modules
var utils = __webpack_require__(83428);
// EXTERNAL MODULE: ../../packages/application/hooks/Toast/index.tsx + 3 modules
var Toast = __webpack_require__(26052);
;// CONCATENATED MODULE: ../../packages/application/hooks/getFiscalNote/index.tsx







var useGetFiscalNote = function(purchaseApi, accessToken, appMonitoringClient, documentType) {
    var ref = (0,react.useState)({
        url: "",
        filename: "",
        isLoading: false
    }), fiscalNote = ref[0], setFiscalNote = ref[1];
    var addToast = (0,Toast.useToast)().addToast;
    var getFiscalNote = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(packageId, branchIdForNfe) {
            var showToast, shouldDownloadFile, isStoreOrder;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                showToast = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true, shouldDownloadFile = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false, isStoreOrder = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : false;
                if (showToast) {
                    addToast({
                        title: "Aguarde, sua nota fiscal est\xe1 sendo carregada...",
                        description: "",
                        timerInMilliseconds: 8000,
                        type: "success",
                        newToastTheme: "light",
                        isNewToast: true
                    });
                }
                setFiscalNote(function(prev) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        isLoading: true
                    });
                });
                purchaseApi.getFiscalDocument(packageId, accessToken !== null && accessToken !== void 0 ? accessToken : "", String(branchIdForNfe), documentType, isStoreOrder).then(function(response) {
                    setFiscalNote({
                        url: String((response === null || response === void 0 ? void 0 : response.data) || ""),
                        filename: response === null || response === void 0 ? void 0 : response.fileName,
                        isLoading: false
                    });
                    if (response.error) {
                        addToast({
                            title: "Opa! Encontramos um problema ao abrir a nota fiscal",
                            description: "Por favor, tente novamente mais tarde ou entre em contato com o suporte para obter ajuda",
                            type: "error",
                            newToastTheme: "light",
                            isNewToast: true
                        });
                        appMonitoringClient.captureException(response.error);
                    }
                    if (shouldDownloadFile && !response.error) {
                        (0,utils/* getFileByLink */._9)(String(response === null || response === void 0 ? void 0 : response.data), response === null || response === void 0 ? void 0 : response.fileName);
                    }
                }).catch(function(error) {
                    appMonitoringClient.captureException(error);
                    addToast({
                        title: "Opa! Encontramos um problema ao abrir a nota fiscal",
                        description: "Por favor, tente novamente mais tarde ou entre em contato com o suporte para obter ajuda",
                        type: "error",
                        newToastTheme: "light",
                        isNewToast: true
                    });
                });
                return [
                    2
                ];
            });
        });
        return function(packageId, branchIdForNfe) {
            return _ref.apply(this, arguments);
        };
    }(), [
        accessToken,
        addToast,
        appMonitoringClient,
        documentType,
        purchaseApi
    ]);
    return {
        fiscalNote: fiscalNote,
        getFiscalNote: getFiscalNote
    };
};

// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
;// CONCATENATED MODULE: ../../packages/application/hooks/initializeAllConfigs/index.tsx




var useInitializeAllConfigs = function(envsApi) {
    var ref = (0,state_manager/* useEnvs */.HS)((0,state_manager/* useShallow */.NL)(function(state) {
        return state;
    })), allConfigs = ref.allConfigs, setAllConfigs = ref.setAllConfigs;
    (0,react.useEffect)(function() {
        if (!allConfigs) {
            var handleSetAllEnvs = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var ref, _data, data;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    envsApi.getAllConfigs()
                                ];
                            case 1:
                                ref = _state.sent(), _data = ref.data, data = _data === void 0 ? null : _data;
                                setAllConfigs(data);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function handleSetAllEnvs() {
                    return _ref.apply(this, arguments);
                };
            }();
            handleSetAllEnvs();
        }
    }, [
        allConfigs,
        envsApi,
        setAllConfigs
    ]);
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
;// CONCATENATED MODULE: ../../packages/application/hooks/mapCrmTransactionObject/index.ts




var useMapCrmTransactionObject = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(order, catalogApi, crm, envsApi) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, firstRender, orderBranchId, transactionProducts, transactionProductIdsList, productList, productListPromise, productsInfo, productBreadcrumbs, orderInfo, deliveryAddress, deliveryObjectParams, transactionProductsInfo, lineItems, transactionObjectParams;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    firstRender = true;
                    if (!order) return [
                        2,
                        null
                    ];
                    orderBranchId = ((ref1 = order === null || order === void 0 ? void 0 : (ref = order.packages) === null || ref === void 0 ? void 0 : ref.at(0)) === null || ref1 === void 0 ? void 0 : ref1.branchId.toString()) || "2";
                    transactionProducts = order === null || order === void 0 ? void 0 : (ref2 = order.packages) === null || ref2 === void 0 ? void 0 : ref2.map(function(packageItem) {
                        return packageItem.orderItems[0];
                    });
                    transactionProductIdsList = transactionProducts === null || transactionProducts === void 0 ? void 0 : transactionProducts.map(function(param) {
                        var productId = param.productId;
                        return productId;
                    });
                    productList = transactionProductIdsList === null || transactionProductIdsList === void 0 ? void 0 : transactionProductIdsList.join(",");
                    productListPromise = catalogApi.getProductListServerSide(productList, orderBranchId);
                    return [
                        4,
                        Promise.all([
                            productListPromise
                        ]).then(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), data = _param[0].data;
                            return data;
                        })
                    ];
                case 1:
                    productsInfo = _state.sent();
                    if (!(productsInfo === null || productsInfo === void 0 ? void 0 : productsInfo.length)) return [
                        2,
                        null
                    ];
                    productBreadcrumbs = productsInfo === null || productsInfo === void 0 ? void 0 : productsInfo.map(function(param) {
                        var breadCrumbs = param.breadCrumbs;
                        return Object.values(breadCrumbs).reverse().map(function(param) {
                            var name = param.name;
                            return name;
                        });
                    });
                    orderInfo = order === null || order === void 0 ? void 0 : (ref3 = order.packages) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(accumulator, param) {
                        var shippingValue = param.shippingValue, totalPackagePrice = param.totalPrice;
                        var reliableShippingValue = shippingValue || 0;
                        return {
                            shippingTotal: accumulator.shippingTotal + (shippingValue || 0),
                            totalPackagesPrice: accumulator.totalPackagesPrice + (totalPackagePrice || 0),
                            totalPrice: accumulator.totalPrice + reliableShippingValue + totalPackagePrice
                        };
                    }, {
                        shippingTotal: 0,
                        totalPackagesPrice: 0,
                        totalPrice: 0
                    });
                    deliveryAddress = order === null || order === void 0 ? void 0 : (ref4 = order.client) === null || ref4 === void 0 ? void 0 : ref4.address;
                    deliveryObjectParams = {
                        country: "BR",
                        city: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.city,
                        district: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.district
                    };
                    transactionProductsInfo = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(usedEnvsApi) {
                            var ref, allConfigs;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            usedEnvsApi.getAllConfigs()
                                        ];
                                    case 1:
                                        ref = _state.sent(), allConfigs = ref.data;
                                        return [
                                            2,
                                            transactionProducts === null || transactionProducts === void 0 ? void 0 : transactionProducts.map(function(lineItem, index) {
                                                var ref, ref1;
                                                var productUrl = "".concat(allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.siteUrl, "produto/").concat(lineItem === null || lineItem === void 0 ? void 0 : lineItem.productId, "/").concat((0,utils/* formatStringUrl */.Es)((lineItem === null || lineItem === void 0 ? void 0 : lineItem.description) || ""));
                                                var productImage = (ref1 = lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.mediaLink) === null || ref === void 0 ? void 0 : ref.at(0)) === null || ref1 === void 0 ? void 0 : ref1.imageUrl;
                                                var productSubtotal = lineItem.price * lineItem.quantity;
                                                return {
                                                    product: {
                                                        id: "".concat(lineItem === null || lineItem === void 0 ? void 0 : lineItem.productId, ".").concat(orderBranchId),
                                                        name: lineItem === null || lineItem === void 0 ? void 0 : lineItem.description,
                                                        taxonomy: productBreadcrumbs === null || productBreadcrumbs === void 0 ? void 0 : productBreadcrumbs.at(index),
                                                        currency: "BRL",
                                                        unit_price: lineItem === null || lineItem === void 0 ? void 0 : lineItem.price,
                                                        unit_sale_price: lineItem === null || lineItem === void 0 ? void 0 : lineItem.price,
                                                        url: productUrl,
                                                        product_image_url: productImage
                                                    },
                                                    quantity: lineItem === null || lineItem === void 0 ? void 0 : lineItem.quantity,
                                                    subtotal: productSubtotal
                                                };
                                            })
                                        ];
                                }
                            });
                        });
                        return function transactionProductsInfo(usedEnvsApi) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return [
                        4,
                        transactionProductsInfo(envsApi)
                    ];
                case 2:
                    lineItems = _state.sent();
                    transactionObjectParams = {
                        order_id: order === null || order === void 0 ? void 0 : (ref5 = order.groupId) === null || ref5 === void 0 ? void 0 : ref5.toString(),
                        currency: "BRL",
                        total: Number(orderInfo === null || orderInfo === void 0 ? void 0 : (ref6 = orderInfo.totalPrice) === null || ref6 === void 0 ? void 0 : ref6.toFixed(2)),
                        shipping_cost: Number(orderInfo === null || orderInfo === void 0 ? void 0 : (ref7 = orderInfo.shippingTotal) === null || ref7 === void 0 ? void 0 : ref7.toFixed(2)),
                        delivery: deliveryObjectParams,
                        line_items: lineItems,
                        payment_type: (ref9 = order === null || order === void 0 ? void 0 : (ref8 = order.payments) === null || ref8 === void 0 ? void 0 : ref8.at(0)) === null || ref9 === void 0 ? void 0 : ref9.paymentType
                    };
                    if (firstRender) {
                        crm.transactionObject(transactionObjectParams);
                        firstRender = false;
                    }
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function useMapCrmTransactionObject(order, catalogApi, crm, envsApi) {
        return _ref.apply(this, arguments);
    };
}();


// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ../../packages/application/hooks/persistDataInUrl/index.tsx



var usePersistDataInUrl = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(new URL(window.location.href)), newUrl = ref[0], setNewUrl = ref[1];
    var formatQuery = (0,react.useCallback)(function(data) {
        var draftUrl = new URL("".concat(window.location.origin).concat(window.location.pathname));
        Object.entries(data).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            var isArray = Array.isArray(value);
            var hasValue = isArray ? Boolean(value.length) : Boolean(value);
            if (key && hasValue) {
                draftUrl.searchParams.append(key, isArray ? value.join(",") : value);
            }
        });
        setNewUrl(draftUrl);
        return draftUrl;
    }, []);
    var save = (0,react.useCallback)(function(data) {
        var nextUrl = formatQuery(data).toString();
        router.replace(nextUrl, undefined, {
            scroll: true
        });
        return nextUrl;
    }, [
        formatQuery,
        router
    ]);
    var getAll = (0,react.useCallback)(function() {
        if (!newUrl) {
            setNewUrl(new URL(window.location.href));
        }
        var searchParams = newUrl.searchParams;
        return Object.fromEntries(searchParams);
    }, [
        newUrl
    ]);
    var get = (0,react.useCallback)(function(key) {
        if (!newUrl) {
            setNewUrl(new URL(window.location.href));
        }
        var searchParams = newUrl.searchParams;
        return searchParams.get(key);
    }, [
        newUrl
    ]);
    var clear = (0,react.useCallback)(function() {
        var clearedUrl = new URL("".concat(window.location.origin).concat(window.location.pathname)).toString();
        router.replace(clearedUrl, undefined, {
            scroll: true
        });
        return clearedUrl;
    }, [
        router
    ]);
    var update = (0,react.useCallback)(function(key, value) {
        if (!key) return;
        var draftUrl = new URL(window.location.href);
        // Remove existing value for this key
        draftUrl.searchParams.delete(key);
        // Add new value if it exists
        var isArray = Array.isArray(value);
        var hasValue = isArray ? Boolean(value.length) : Boolean(value);
        if (hasValue) {
            draftUrl.searchParams.append(key, isArray ? value.join(",") : String(value));
        }
        setNewUrl(draftUrl);
        router.replace(draftUrl.toString());
    }, [
        router
    ]);
    return {
        save: save,
        get: get,
        getAll: getAll,
        clear: clear,
        size: newUrl === null || newUrl === void 0 ? void 0 : newUrl.searchParams.size,
        update: update
    };
};

;// CONCATENATED MODULE: ../../packages/application/hooks/productsRecommendation/data.ts

var insiderEndPoints = [
    {
        endPoint: "/top-sellers",
        needId: false
    },
    {
        endPoint: "/most-popular",
        needId: false
    },
    {
        endPoint: "/trending",
        needId: false
    },
    {
        endPoint: "/viewed-together",
        needId: false
    },
    {
        endPoint: "/recently-viewed",
        needId: true
    },
    {
        endPoint: "/user-based",
        needId: true
    },
    {
        endPoint: "/chef",
        needId: false
    },
    {
        endPoint: "/complementary",
        needId: false
    },
    {
        endPoint: "/highest-discounted",
        needId: false
    },
    {
        endPoint: "/manual-merchandising",
        needId: false
    },
    {
        endPoint: "/mixed",
        needId: false
    },
    {
        endPoint: "/mixed",
        needId: false
    },
    {
        endPoint: "/most-valuable",
        needId: false
    },
    {
        endPoint: "/new-arrivals",
        needId: false
    },
    {
        endPoint: "/new-arrivals",
        needId: false
    },
    {
        endPoint: "/purchased-together",
        needId: true
    },
    {
        endPoint: "/last-purchased-together",
        needId: true
    },
    {
        endPoint: "/substitute",
        needId: false
    }, 
];
var useOderCrmProducts = function(productCards, crmProductIdsList, quantity) {
    var ref = (0,react.useState)([]), orderedProductCards = ref[0], setOrderedProductCards = ref[1];
    (0,react.useEffect)(function() {
        if ((productCards === null || productCards === void 0 ? void 0 : productCards.length) && (crmProductIdsList === null || crmProductIdsList === void 0 ? void 0 : crmProductIdsList.length) && quantity) {
            var tempOrderedProductCards = crmProductIdsList.reduce(function(result, productId) {
                var productCard = productCards.find(function(param) {
                    var id = param.id;
                    return id === productId;
                });
                if (productCard) {
                    result.push(productCard);
                }
                return result;
            }, []);
            tempOrderedProductCards.splice(quantity);
            setOrderedProductCards(tempOrderedProductCards);
        }
    }, [
        productCards,
        quantity,
        crmProductIdsList
    ]);
    return orderedProductCards;
};

;// CONCATENATED MODULE: ../../packages/application/hooks/productsRecommendation/index.tsx





var useProductsRecommendation = function(crm, props, cookie, catalogApi, appMonitoringClient) {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)([]), productIdsList = ref3[0], setProductIdsList = ref3[1];
    var ref4 = (0,react.useState)(null), componentCrmProps = ref4[0], setComponentCrmProps = ref4[1];
    var ref5 = (0,react.useState)(false), isCrmComponent = ref5[0], setIsCrmComponent = ref5[1];
    var ref6 = (0,react.useState)(true), isLoading = ref6[0], setIsLoading = ref6[1];
    var userId = (0,state_manager/* useCrm */.K3)(function(state) {
        return state.userCrmId;
    });
    var ref7 = (0,react.useState)(false), isProductsListEmpty = ref7[0], setIsProductsListEmpty = ref7[1];
    var ref8 = (0,react.useState)(true), isFirstRequest = ref8[0], setIsFirstRequest = ref8[1];
    var quantity = (ref1 = props === null || props === void 0 ? void 0 : (ref = props.properties) === null || ref === void 0 ? void 0 : ref.find(function(param) {
        var key = param.key;
        return key === "quantity";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var clientBranchId = cookie.getCookie({
        name: "@FC:Ecom:Dropdown:BranchLocation"
    }) || "2";
    var accessToken = cookie.getCookie({
        name: "@FC:Ecom:Token:Access"
    });
    var branches = (0,react.useMemo)(function() {
        var ref;
        return (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.branches) || [];
    }, [
        props === null || props === void 0 ? void 0 : (ref2 = props.config) === null || ref2 === void 0 ? void 0 : ref2.branches
    ]);
    var crmEndpoint = (0,react.useMemo)(function() {
        var ref;
        return (ref = branches === null || branches === void 0 ? void 0 : branches.find(function(param) {
            var id = param.id;
            return id === clientBranchId;
        })) === null || ref === void 0 ? void 0 : ref.linkUrl;
    }, [
        branches,
        clientBranchId
    ]);
    var needCrmUserId = (0,react.useMemo)(function() {
        var ref;
        return (ref = insiderEndPoints.find(function(param) {
            var endPoint = param.endPoint;
            return endPoint === crmEndpoint;
        })) === null || ref === void 0 ? void 0 : ref.needId;
    }, [
        crmEndpoint
    ]);
    var shouldWaitForUserCrmId = (0,react.useMemo)(function() {
        return needCrmUserId && (!accessToken || !userId);
    }, [
        accessToken,
        needCrmUserId,
        userId
    ]);
    var canGetProductCards = !!(productIdsList === null || productIdsList === void 0 ? void 0 : productIdsList.length);
    var ref9 = catalogApi.getProductCards(Number(clientBranchId), productIdsList, undefined, undefined, 0, canGetProductCards), productCards = ref9.data, isLoadingProductCards = ref9.isLoading;
    var availableProducts = (0,react.useMemo)(function() {
        var ref;
        return (ref = productCards === null || productCards === void 0 ? void 0 : productCards.filter(function(product) {
            var ref;
            return product.maximumStockPerBranch > 0 && !((ref = product.tag) === null || ref === void 0 ? void 0 : ref.isUnavailable);
        })) !== null && ref !== void 0 ? ref : [];
    }, [
        productCards
    ]);
    var orderedProductCards = useOderCrmProducts(availableProducts, productIdsList, quantity);
    (0,react.useEffect)(function() {
        if (shouldWaitForUserCrmId) {
            setIsProductsListEmpty(true);
            setProductIdsList([]);
            setIsFirstRequest(true);
        }
    }, [
        shouldWaitForUserCrmId
    ]);
    (0,react.useEffect)(function() {
        if ((canGetProductCards || isProductsListEmpty) && !isLoadingProductCards && isLoading) {
            setIsLoading(false);
        }
    }, [
        canGetProductCards,
        isLoading,
        isLoadingProductCards,
        isProductsListEmpty, 
    ]);
    var handleRecommendedProducts = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(passedCrmEndpoint, needCrm, passedUserId, passedClientBranchId) {
            var ref, recommendedProducts;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            crm.getRecommendedProducts(passedCrmEndpoint, String(passedUserId), passedClientBranchId, !needCrmUserId, appMonitoringClient)
                        ];
                    case 1:
                        recommendedProducts = _state.sent();
                        if ((recommendedProducts === null || recommendedProducts === void 0 ? void 0 : (ref = recommendedProducts.data) === null || ref === void 0 ? void 0 : ref.length) && (recommendedProducts === null || recommendedProducts === void 0 ? void 0 : recommendedProducts.success)) {
                            setProductIdsList(recommendedProducts.data.map(function(id) {
                                return id.split(".")[0];
                            }));
                        } else {
                            setIsProductsListEmpty(true);
                        }
                        setComponentCrmProps({
                            recommendedProductsId: productIdsList.splice(quantity),
                            needCrmUserId: needCrm
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(passedCrmEndpoint, needCrm, passedUserId, passedClientBranchId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        appMonitoringClient,
        crm,
        needCrmUserId,
        productIdsList,
        quantity
    ]);
    var handleSetRecommendedProducts = (0,react.useCallback)(function(passedBranches, passedUserId) {
        if (!(productIdsList === null || productIdsList === void 0 ? void 0 : productIdsList.length) && passedBranches.length && isFirstRequest) {
            var ref;
            var tempIsCrmComponent = ((ref = passedBranches === null || passedBranches === void 0 ? void 0 : passedBranches.find(function(param) {
                var id = param.id;
                return id === clientBranchId;
            })) === null || ref === void 0 ? void 0 : ref.typeLink) === "insider";
            setIsCrmComponent(tempIsCrmComponent);
            if (tempIsCrmComponent && !shouldWaitForUserCrmId) {
                setIsFirstRequest(false);
                handleRecommendedProducts(crmEndpoint, needCrmUserId, passedUserId, accessToken ? clientBranchId : "2");
            }
        }
    }, [
        accessToken,
        clientBranchId,
        crmEndpoint,
        handleRecommendedProducts,
        isFirstRequest,
        needCrmUserId,
        productIdsList === null || productIdsList === void 0 ? void 0 : productIdsList.length,
        shouldWaitForUserCrmId, 
    ]);
    (0,react.useEffect)(function() {
        handleSetRecommendedProducts(branches, userId);
    }, [
        branches,
        handleSetRecommendedProducts,
        userId
    ]);
    orderedProductCards === null || orderedProductCards === void 0 ? void 0 : orderedProductCards.splice(quantity);
    return {
        productCards: orderedProductCards,
        isLoading: isLoading,
        componentCrmProps: componentCrmProps,
        isCrmComponent: isCrmComponent
    };
};

;// CONCATENATED MODULE: ../../packages/application/hooks/scrollVisibility/index.tsx

/**
 * Hook personalizado para controlar a visibilidade da barra de rolagem
 * @param options Opções de configuração
 * @param options.timeout Tempo em ms para ocultar a barra após inatividade (padrão: 1500ms)
 * @param options.showInitially Se a barra deve estar visível inicialmente (padrão: false)
 * @returns Um objeto com as propriedades e refs necessárias para implementar o comportamento
 */ var useScrollVisibility = function(options) {
    var ref = options || {}, _timeout = ref.timeout, timeout = _timeout === void 0 ? 1500 : _timeout, _showInitially = ref.showInitially, showInitially = _showInitially === void 0 ? false : _showInitially;
    var ref1 = (0,react.useState)(showInitially), isScrolling = ref1[0], setIsScrolling = ref1[1];
    var scrollTimerRef = (0,react.useRef)(null);
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var container = containerRef.current;
        if (!container) return;
        var handleScroll = function() {
            // Ativa o estado de rolagem
            setIsScrolling(true);
            // Limpa o timer anterior se existir
            if (scrollTimerRef.current !== null) {
                window.clearTimeout(scrollTimerRef.current);
            }
            // Define um novo timer para desativar o estado de rolagem após o tempo definido
            scrollTimerRef.current = window.setTimeout(function() {
                setIsScrolling(false);
            }, timeout);
        };
        // Adiciona evento de scroll ao container
        container.addEventListener("scroll", handleScroll);
        // Função de limpeza para remover listeners e timers quando o componente for desmontado
        // eslint-disable-next-line consistent-return
        return function() {
            container.removeEventListener("scroll", handleScroll);
            if (scrollTimerRef.current !== null) {
                window.clearTimeout(scrollTimerRef.current);
            }
        };
    }, [
        timeout
    ]);
    return {
        isScrolling: isScrolling,
        containerRef: containerRef
    };
};

;// CONCATENATED MODULE: ../../packages/application/hooks/showRegisterPhoneNumberModal.tsx

var useShowRegisterPhoneNumberModal = function(isLoadingUserPhoneNumber, userHasValidPhoneNumberRegistered) {
    var ref = (0,react.useState)(false), isRegisterPhoneNumberModalOpen = ref[0], setIsRegisterPhoneNumberModalOpen = ref[1];
    (0,react.useEffect)(function() {
        if (isLoadingUserPhoneNumber !== undefined && isLoadingUserPhoneNumber === false && !userHasValidPhoneNumberRegistered && !(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("loggedUserHasRegisteredPhoneNumber"))) {
            setIsRegisterPhoneNumberModalOpen(true);
        }
    }, [
        isLoadingUserPhoneNumber,
        userHasValidPhoneNumberRegistered
    ]);
    return isRegisterPhoneNumberModalOpen;
};


;// CONCATENATED MODULE: ../../packages/application/hooks/slider/index.tsx

var useSlider = function(param) {
    var appliedFilterItemsRef = param.appliedFilterItemsRef, activeFilters = param.activeFilters;
    var ref = useState(0), scrollPosition = ref[0], setScrollPosition = ref[1];
    var ref1 = useState(false), showPrevButton = ref1[0], setShowPrevButton = ref1[1];
    var ref2 = useState(false), showNextButton = ref2[0], setShowNextButton = ref2[1];
    var appliedFilterItems = appliedFilterItemsRef === null || appliedFilterItemsRef === void 0 ? void 0 : appliedFilterItemsRef.current;
    var handleNextFiltersClick = useCallback(function() {
        if (appliedFilterItems) {
            var ref;
            var itemWidth = (appliedFilterItems === null || appliedFilterItems === void 0 ? void 0 : (ref = appliedFilterItems.lastElementChild) === null || ref === void 0 ? void 0 : ref.clientWidth) || 0;
            var visibleItems = Math.floor(appliedFilterItems.clientWidth / itemWidth);
            var targetScrollPosition = Math.min(appliedFilterItems.scrollWidth - appliedFilterItems.clientWidth, scrollPosition + itemWidth * visibleItems);
            setScrollPosition(targetScrollPosition);
            appliedFilterItems === null || appliedFilterItems === void 0 ? void 0 : appliedFilterItems.scrollTo({
                left: targetScrollPosition,
                behavior: "smooth"
            });
            setShowPrevButton(true);
        }
    }, [
        appliedFilterItems,
        scrollPosition
    ]);
    var handlePrevFiltersClick = useCallback(function() {
        setShowNextButton(true);
        if (appliedFilterItems) {
            var ref;
            var itemWidth = (appliedFilterItems === null || appliedFilterItems === void 0 ? void 0 : (ref = appliedFilterItems.lastElementChild) === null || ref === void 0 ? void 0 : ref.clientWidth) || 0;
            var visibleItems = Math.floor(appliedFilterItems.clientWidth / itemWidth);
            var targetScrollPosition = Math.max(0, scrollPosition - itemWidth * visibleItems);
            setScrollPosition(targetScrollPosition);
            appliedFilterItems === null || appliedFilterItems === void 0 ? void 0 : appliedFilterItems.scrollTo({
                left: targetScrollPosition,
                behavior: "smooth"
            });
            if (targetScrollPosition === 0) {
                setShowPrevButton(false);
            }
        }
    }, [
        appliedFilterItems,
        scrollPosition
    ]);
    useEffect(function() {
        if (appliedFilterItems && (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length)) {
            setShowNextButton((appliedFilterItems === null || appliedFilterItems === void 0 ? void 0 : appliedFilterItems.scrollWidth) > (appliedFilterItems === null || appliedFilterItems === void 0 ? void 0 : appliedFilterItems.clientWidth));
        }
    }, [
        activeFilters,
        appliedFilterItems,
        scrollPosition
    ]);
    return {
        showPrevButton: showPrevButton,
        showNextButton: showNextButton,
        handleNextFiltersClick: handleNextFiltersClick,
        handlePrevFiltersClick: handlePrevFiltersClick
    };
};


;// CONCATENATED MODULE: ../../packages/application/hooks/Timer/index.tsx

var useTimer = function(initialTime) {
    var ref = (0,react.useState)(0), remainingTime = ref[0], setRemainingTime = ref[1];
    var ref1 = (0,react.useState)(""), formattedTime = ref1[0], setFormattedTime = ref1[1];
    (0,react.useEffect)(function() {
        setRemainingTime(initialTime);
    }, [
        initialTime
    ]);
    (0,react.useEffect)(function() {
        var formatTime = function(totalSeconds) {
            var minutes = Math.floor(totalSeconds / 60);
            var seconds = Math.floor(totalSeconds % 60);
            var formattedMinutes = String(minutes).padStart(2, "0");
            var formattedSeconds = String(seconds).padStart(2, "0");
            return "".concat(formattedMinutes, ":").concat(formattedSeconds);
        };
        var idTime = setTimeout(function() {
            if (remainingTime) {
                setRemainingTime(remainingTime - 1);
                setFormattedTime(formatTime(remainingTime));
            }
        }, 1000);
        return function() {
            return clearTimeout(idTime);
        };
    }, [
        initialTime,
        remainingTime
    ]);
    return {
        formattedTime: formattedTime,
        remainingTime: remainingTime
    };
};


// EXTERNAL MODULE: ../../packages/application/hooks/userClient.ts + 37 modules
var userClient = __webpack_require__(2180);
// EXTERNAL MODULE: ../../packages/application/context/BranchLocationContext.tsx
var BranchLocationContext = __webpack_require__(64462);
// EXTERNAL MODULE: ../../packages/application/context/WebSocket/index.tsx
var WebSocket = __webpack_require__(91393);
// EXTERNAL MODULE: ../../packages/application/hooks/validateClientBranchChange/pageReload.ts
var pageReload = __webpack_require__(33757);
;// CONCATENATED MODULE: ../../packages/application/hooks/validateClientBranchChange/index.tsx








var cookieBranchLocationStr = "@FC:Ecom:Dropdown:BranchLocation";
var cookieRegionStr = "@FC:Ecom:Dropdown:Region";
var cookieOptionsMaxAgeEqualOneYear = {
    options: {
        maxAge: 60 * 60 * 24 * 365
    }
};
var otherRegionStr = "Demais Regi\xf5es";
// const handleChangeClientLocation = (
//   cookie: ICookie,
//   clientLocation: string,
//   setRegionClientLocation: Dispatch<SetStateAction<string | null>>
// ) => {
//   if (clientLocation !== otherRegionStr) {
//     cookie.setCookie({
//       name: cookieRegionStr,
//       value: clientLocation,
//       options: cookieOptionsMaxAgeEqualOneYear.options,
//     });
//     setRegionClientLocation(clientLocation);
//   }
// };
// const handleIsToReloadPage = (
//   isToReloadPage: boolean,
//   currentPathname: string,
//   clientLocation: Omit<LocationProps, "clientBranchId"> & {
//     clientBranchId: string;
//   },
//   setIsToReloadPage: Dispatch<SetStateAction<boolean>>,
//   setIsReloadingPage: Dispatch<SetStateAction<boolean>>,
//   emitEvent: (
//     event: WebSocketEventAction,
//     metadata: WebSocketEventMetadata
//   ) => void,
//   router: NextRouter
// ) => {
//   if (isToReloadPage) {
//     setIsToReloadPage(false);
//     localStorage?.setItem("isPageReloadByZipCodeSearch", "true");
//     router.replace(currentPathname, undefined, { shallow: true });
//     emitEvent("branchChanged", clientLocation);
//     router.reload();
//     setIsReloadingPage(true);
//   }
// };
var useValidateClientBranchChange = function(searchedZipCode, shippingApi, cookie) {
    var ref = (0,BranchLocationContext/* useBranchLocation */.vK)(), setRegionClientLocation = ref.setRegionClientLocation, isChangingClientLocation = ref.isChangingClientLocation;
    var ref1 = (0,react.useState)(false), isToReloadPage = ref1[0], setIsToReloadPage = ref1[1];
    var ref2 = (0,react.useState)(false), isReloadingPage = ref2[0], setIsReloadingPage = ref2[1];
    var currentPathname = useCurrentPathName();
    var router = (0,next_router.useRouter)();
    var emitEvent = (0,WebSocket.useWebSocket)().emitEvent;
    var shouldDoRequests = !!searchedZipCode && !isReloadingPage && !isChangingClientLocation;
    var ref3 = shippingApi.getBranchIdByZipCode(searchedZipCode, shouldDoRequests), branchIdByZipCode = ref3.data;
    if (branchIdByZipCode === null || branchIdByZipCode === void 0 ? void 0 : branchIdByZipCode.branchId) {
        var lastClientBranchId = cookie.getCookie({
            name: cookieBranchLocationStr
        });
        if (String(branchIdByZipCode === null || branchIdByZipCode === void 0 ? void 0 : branchIdByZipCode.branchId) !== lastClientBranchId) {
            setIsToReloadPage(true);
            cookie.setCookie({
                name: cookieBranchLocationStr,
                value: String(branchIdByZipCode.branchId),
                options: cookieOptionsMaxAgeEqualOneYear.options
            });
        }
    }
    var ref4 = shippingApi.getAddressByZipCode(searchedZipCode, shouldDoRequests), addressByZipCode = ref4.data, isLoadingAddressByZipCode = ref4.isLoading;
    if (shouldDoRequests && !isLoadingAddressByZipCode) {
        var currentClientLocation = otherRegionStr;
        if ((addressByZipCode === null || addressByZipCode === void 0 ? void 0 : addressByZipCode.city) && (addressByZipCode === null || addressByZipCode === void 0 ? void 0 : addressByZipCode.uf)) {
            currentClientLocation = "".concat(addressByZipCode.city, " - ").concat(addressByZipCode.uf);
            cookie.setCookie({
                name: cookieRegionStr,
                value: currentClientLocation,
                options: cookieOptionsMaxAgeEqualOneYear.options
            });
            setRegionClientLocation(currentClientLocation);
        } else {
            cookie.deleteCookie({
                name: cookieRegionStr
            });
        }
        if (isToReloadPage) {
            (0,pageReload/* setIsPageReloadByZipCodeSearch */.B)(true);
            router.replace(currentPathname, undefined, {
                shallow: true
            });
            emitEvent("branchChanged", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (branchIdByZipCode === null || branchIdByZipCode === void 0 ? void 0 : branchIdByZipCode.branchId) && {
                clientBranchId: branchIdByZipCode === null || branchIdByZipCode === void 0 ? void 0 : branchIdByZipCode.branchId
            }, currentClientLocation && {
                clientLocation: currentClientLocation
            }), {
                clientPostalCode: searchedZipCode
            }));
            setTimeout(function() {
                router.reload();
            }, 250);
            setIsReloadingPage(true);
        }
    }
    return {
        branchIdByZipCode: branchIdByZipCode,
        addressByZipCode: addressByZipCode,
        isToReloadPage: isToReloadPage,
        isChangingClientLocation: isChangingClientLocation
    };
};


;// CONCATENATED MODULE: ../../packages/application/hooks/validatePassword/index.ts
var useValidatePassword = function(param) {
    var userPassword = param.userPassword, userConfirmPassword = param.userConfirmPassword;
    var ref, ref1;
    var passwordHasNumbers = !!(userPassword === null || userPassword === void 0 ? void 0 : userPassword.match(/\d+/g));
    var passwordHasLowerCaseLetters = !!(userPassword === null || userPassword === void 0 ? void 0 : userPassword.match(/[a-z]+/g));
    var passwordHasUpperCaseLetters = !!(userPassword === null || userPassword === void 0 ? void 0 : userPassword.match(/[A-Z]+/g));
    var passwordHasMoreThanSevenCharacters = (userPassword === null || userPassword === void 0 ? void 0 : userPassword.length) > 7;
    var passwordsMatch = !(userPassword !== userConfirmPassword || (userPassword === null || userPassword === void 0 ? void 0 : userPassword.length) === 0 || (userConfirmPassword === null || userConfirmPassword === void 0 ? void 0 : userConfirmPassword.length) === 0);
    var strongPassword = userPassword === null || userPassword === void 0 ? void 0 : userPassword.match(/^(?=.*[A-Z].*[A-Z])(?=.*[!@#$&*])(?=.*[0-9].*[0-9])(?=.*[a-z].*[a-z].*[a-z])/);
    var validatePassword = {
        passwordHasNumbers: passwordHasNumbers,
        passwordHasLowerCaseLetters: passwordHasLowerCaseLetters,
        passwordHasUpperCaseLetters: passwordHasUpperCaseLetters,
        passwordHasMoreThanSevenCharacters: passwordHasMoreThanSevenCharacters,
        passwordsMatch: passwordsMatch
    };
    var validItems = (ref1 = (ref = Object.values(validatePassword)) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return item === true;
    })) === null || ref1 === void 0 ? void 0 : ref1.length;
    return {
        passwordHasLowerCaseLetters: passwordHasLowerCaseLetters,
        passwordHasMoreThanSevenCharacters: passwordHasMoreThanSevenCharacters,
        passwordHasNumbers: passwordHasNumbers,
        passwordHasUpperCaseLetters: passwordHasUpperCaseLetters,
        passwordsMatch: passwordsMatch,
        strongPassword: strongPassword,
        validItems: validItems
    };
};

;// CONCATENATED MODULE: ../../packages/application/hooks/index.ts









// eslint-disable-next-line import/no-cycle














/***/ }),

/***/ 2180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z9": function() { return /* binding */ useIsClientDesktop; },
  "tk": function() { return /* binding */ useIsClientDesktopS; },
  "dN": function() { return /* binding */ useIsClientLaptop; },
  "Ph": function() { return /* binding */ useIsClientLaptopL; },
  "TF": function() { return /* binding */ useIsClientLaptopM; },
  "XR": function() { return /* binding */ useIsClientLaptopS; },
  "Mw": function() { return /* binding */ useIsClientLaptopXL; },
  "_I": function() { return /* binding */ useIsClientMobile; },
  "tZ": function() { return /* binding */ useIsClientMobileL; },
  "yG": function() { return /* binding */ useIsClientMobileM; },
  "kL": function() { return /* binding */ useIsClientMobileS; },
  "p3": function() { return /* binding */ useIsClientMobileXS; },
  "dL": function() { return /* binding */ useIsClientTablet; },
  "xB": function() { return /* binding */ useIsClientTabletL; },
  "q4": function() { return /* binding */ useIsClientTabletM; },
  "$Q": function() { return /* binding */ useIsClientTabletML; },
  "aM": function() { return /* binding */ useIsClientTabletSmall; },
  "zq": function() { return /* binding */ useIsClientTabletXL; },
  "lg": function() { return /* binding */ useIsClientTabletXM; },
  "dF": function() { return /* binding */ useIsOnlyClientLaptop; },
  "d5": function() { return /* binding */ useIsOnlyClientMobile; },
  "lC": function() { return /* binding */ useIsOnlyClientTablet; },
  "iF": function() { return /* binding */ useIsOnlyMobileXSToLaptop; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useBoolean/useBoolean.js

function useBoolean_useBoolean(defaultValue) {
    const [value, setValue] = useState(!!defaultValue);
    const setTrue = useCallback(() => setValue(true), []);
    const setFalse = useCallback(() => setValue(false), []);
    const toggle = useCallback(() => setValue(x => !x), []);
    return { value, setValue, setTrue, setFalse, toggle };
}
/* harmony default export */ var esm_useBoolean_useBoolean = ((/* unused pure expression or super */ null && (useBoolean_useBoolean)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useClickAnyWhere/useClickAnyWhere.js

function useClickAnyWhere(handler) {
    useEventListener('click', event => {
        handler(event);
    });
}
/* harmony default export */ var useClickAnyWhere_useClickAnyWhere = ((/* unused pure expression or super */ null && (useClickAnyWhere)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useCopyToClipboard/useCopyToClipboard.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function useCopyToClipboard() {
    const [copiedText, setCopiedText] = useState(null);
    const copy = (text) => __awaiter(this, void 0, void 0, function* () {
        if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
            console.warn('Clipboard not supported');
            return false;
        }
        try {
            yield navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        }
        catch (error) {
            console.warn('Copy failed', error);
            setCopiedText(null);
            return false;
        }
    });
    return [copiedText, copy];
}
/* harmony default export */ var useCopyToClipboard_useCopyToClipboard = ((/* unused pure expression or super */ null && (useCopyToClipboard)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useCountdown/useCountdown.js


function useCountdown(countdownOption) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ('seconds' in countdownOption) {
        console.warn('[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.');
        isDeprecated = true;
        countStart = countdownOption.seconds;
        intervalMs = countdownOption.interval;
        isIncrement = countdownOption.isIncrement;
    }
    else {
        ;
        ({ countStart, intervalMs, isIncrement, countStop } = countdownOption);
    }
    intervalMs = intervalMs !== null && intervalMs !== void 0 ? intervalMs : 1000;
    isIncrement = isIncrement !== null && isIncrement !== void 0 ? isIncrement : false;
    countStop = countStop !== null && countStop !== void 0 ? countStop : 0;
    const { count, increment, decrement, reset: resetCounter, } = useCounter(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown, } = useBoolean(false);
    const resetCountdown = () => {
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = useCallback(() => {
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) {
            increment();
        }
        else {
            decrement();
        }
    }, [count, countStop, decrement, increment, isIncrement, stopCountdown]);
    useInterval(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated
        ? [
            count,
            {
                start: startCountdown,
                stop: stopCountdown,
                reset: resetCountdown,
            },
        ]
        : [
            count,
            {
                startCountdown,
                stopCountdown,
                resetCountdown,
            },
        ];
}
/* harmony default export */ var useCountdown_useCountdown = ((/* unused pure expression or super */ null && (useCountdown)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useCounter/useCounter.js

function useCounter_useCounter(initialValue) {
    const [count, setCount] = useState(initialValue || 0);
    const increment = () => setCount(x => x + 1);
    const decrement = () => setCount(x => x - 1);
    const reset = () => setCount(initialValue || 0);
    return {
        count,
        increment,
        decrement,
        reset,
        setCount,
    };
}
/* harmony default export */ var esm_useCounter_useCounter = ((/* unused pure expression or super */ null && (useCounter_useCounter)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useDarkMode/useDarkMode.js

const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useDarkMode(defaultValue) {
    var _a;
    const isDarkOS = useMediaQuery(COLOR_SCHEME_QUERY);
    const [isDarkMode, setDarkMode] = useLocalStorage('usehooks-ts-dark-mode', (_a = defaultValue !== null && defaultValue !== void 0 ? defaultValue : isDarkOS) !== null && _a !== void 0 ? _a : false);
    useUpdateEffect(() => {
        setDarkMode(isDarkOS);
    }, [isDarkOS]);
    return {
        isDarkMode,
        toggle: () => setDarkMode(prev => !prev),
        enable: () => setDarkMode(true),
        disable: () => setDarkMode(false),
    };
}
/* harmony default export */ var useDarkMode_useDarkMode = ((/* unused pure expression or super */ null && (useDarkMode)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useDebounce/useDebounce.js

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay || 500);
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return debouncedValue;
}
/* harmony default export */ var useDebounce_useDebounce = ((/* unused pure expression or super */ null && (useDebounce)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useDocumentTitle/useDocumentTitle.js

function useDocumentTitle(title) {
    useIsomorphicLayoutEffect(() => {
        window.document.title = title;
    }, [title]);
}
/* harmony default export */ var useDocumentTitle_useDocumentTitle = ((/* unused pure expression or super */ null && (useDocumentTitle)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useEffectOnce/useEffectOnce.js

function useEffectOnce(effect) {
    useEffect(effect, []);
}
/* harmony default export */ var useEffectOnce_useEffectOnce = ((/* unused pure expression or super */ null && (useEffectOnce)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useElementSize/useElementSize.js


function useElementSize() {
    const [ref, setRef] = useState(null);
    const [size, setSize] = useState({
        width: 0,
        height: 0,
    });
    const handleSize = useCallback(() => {
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0,
        });
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    useEventListener('resize', handleSize);
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    return [setRef, size];
}
/* harmony default export */ var useElementSize_useElementSize = ((/* unused pure expression or super */ null && (useElementSize)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useEventCallback/useEventCallback.js


function useEventCallback_useEventCallback(fn) {
    const ref = useRef(() => {
        throw new Error('Cannot call an event handler while rendering.');
    });
    useIsomorphicLayoutEffect(() => {
        ref.current = fn;
    }, [fn]);
    return useCallback((...args) => ref.current(...args), [ref]);
}

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useEventListener/useEventListener.js


function useEventListener_useEventListener(eventName, handler, element, options) {
    const savedHandler = useRef(handler);
    useIsomorphicLayoutEffect(() => {
        savedHandler.current = handler;
    }, [handler]);
    useEffect(() => {
        var _a;
        const targetElement = (_a = element === null || element === void 0 ? void 0 : element.current) !== null && _a !== void 0 ? _a : window;
        if (!(targetElement && targetElement.addEventListener))
            return;
        const listener = event => savedHandler.current(event);
        targetElement.addEventListener(eventName, listener, options);
        return () => {
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [eventName, element, options]);
}
/* harmony default export */ var esm_useEventListener_useEventListener = ((/* unused pure expression or super */ null && (useEventListener_useEventListener)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useFetch/useFetch.js
var useFetch_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function useFetch(url, options) {
    const cache = useRef({});
    const cancelRequest = useRef(false);
    const initialState = {
        error: undefined,
        data: undefined,
    };
    const fetchReducer = (state, action) => {
        switch (action.type) {
            case 'loading':
                return Object.assign({}, initialState);
            case 'fetched':
                return Object.assign(Object.assign({}, initialState), { data: action.payload });
            case 'error':
                return Object.assign(Object.assign({}, initialState), { error: action.payload });
            default:
                return state;
        }
    };
    const [state, dispatch] = useReducer(fetchReducer, initialState);
    useEffect(() => {
        if (!url)
            return;
        cancelRequest.current = false;
        const fetchData = () => useFetch_awaiter(this, void 0, void 0, function* () {
            dispatch({ type: 'loading' });
            if (cache.current[url]) {
                dispatch({ type: 'fetched', payload: cache.current[url] });
                return;
            }
            try {
                const response = yield fetch(url, options);
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                const data = (yield response.json());
                cache.current[url] = data;
                if (cancelRequest.current)
                    return;
                dispatch({ type: 'fetched', payload: data });
            }
            catch (error) {
                if (cancelRequest.current)
                    return;
                dispatch({ type: 'error', payload: error });
            }
        });
        void fetchData();
        return () => {
            cancelRequest.current = true;
        };
    }, [url]);
    return state;
}
/* harmony default export */ var useFetch_useFetch = ((/* unused pure expression or super */ null && (useFetch)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useHover/useHover.js


function useHover(elementRef) {
    const [value, setValue] = useState(false);
    const handleMouseEnter = () => setValue(true);
    const handleMouseLeave = () => setValue(false);
    useEventListener('mouseenter', handleMouseEnter, elementRef);
    useEventListener('mouseleave', handleMouseLeave, elementRef);
    return value;
}
/* harmony default export */ var useHover_useHover = ((/* unused pure expression or super */ null && (useHover)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useImageOnLoad/useImageOnLoad.js

function useImageOnLoad() {
    const [isLoaded, setIsLoaded] = useState(false);
    const handleImageOnLoad = () => {
        setIsLoaded(true);
    };
    const css = {
        thumbnail: {
            visibility: isLoaded ? 'hidden' : 'visible',
            filter: 'blur(8px)',
            transition: 'visibility 0ms ease-out 500ms',
        },
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: 'opacity 500ms ease-in 0ms',
        },
    };
    return { handleImageOnLoad, css };
}
/* harmony default export */ var useImageOnLoad_useImageOnLoad = ((/* unused pure expression or super */ null && (useImageOnLoad)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useIntersectionObserver/useIntersectionObserver.js

function useIntersectionObserver(elementRef, { threshold = 0, root = null, rootMargin = '0%', freezeOnceVisible = false, }) {
    const [entry, setEntry] = useState();
    const frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    const updateEntry = ([entry]) => {
        setEntry(entry);
    };
    useEffect(() => {
        const node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        const hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node)
            return;
        const observerParams = { threshold, root, rootMargin };
        const observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return () => observer.disconnect();
    }, [elementRef === null || elementRef === void 0 ? void 0 : elementRef.current, JSON.stringify(threshold), root, rootMargin, frozen]);
    return entry;
}
/* harmony default export */ var useIntersectionObserver_useIntersectionObserver = ((/* unused pure expression or super */ null && (useIntersectionObserver)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useInterval/useInterval.js


function useInterval_useInterval(callback, delay) {
    const savedCallback = useRef(callback);
    useIsomorphicLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setInterval(() => savedCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay]);
}
/* harmony default export */ var esm_useInterval_useInterval = ((/* unused pure expression or super */ null && (useInterval_useInterval)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useIsClient/useIsClient.js

function useIsClient() {
    const [isClient, setClient] = useState(false);
    useEffect(() => {
        setClient(true);
    }, []);
    return isClient;
}
/* harmony default export */ var useIsClient_useIsClient = ((/* unused pure expression or super */ null && (useIsClient)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useIsFirstRender/useIsFirstRender.js

function useIsFirstRender_useIsFirstRender() {
    const isFirst = useRef(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
/* harmony default export */ var esm_useIsFirstRender_useIsFirstRender = ((/* unused pure expression or super */ null && (useIsFirstRender_useIsFirstRender)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useIsMounted/useIsMounted.js

function useIsMounted() {
    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return useCallback(() => isMounted.current, []);
}
/* harmony default export */ var useIsMounted_useIsMounted = ((/* unused pure expression or super */ null && (useIsMounted)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.js

const useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ var esm_useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = ((/* unused pure expression or super */ null && (useIsomorphicLayoutEffect_useIsomorphicLayoutEffect)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useLocalStorage/useLocalStorage.js


function useLocalStorage_useLocalStorage(key, initialValue) {
    const readValue = useCallback(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);
    const [storedValue, setStoredValue] = useState(readValue);
    const setValue = useEventCallback(value => {
        if (typeof window === 'undefined') {
            console.warn(`Tried setting localStorage key “${key}” even though environment is not a client`);
        }
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.localStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('local-storage'));
        }
        catch (error) {
            console.warn(`Error setting localStorage key “${key}”:`, error);
        }
    });
    useEffect(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = useCallback((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    useEventListener('storage', handleStorageChange);
    useEventListener('local-storage', handleStorageChange);
    return [storedValue, setValue];
}
/* harmony default export */ var esm_useLocalStorage_useLocalStorage = ((/* unused pure expression or super */ null && (useLocalStorage_useLocalStorage)));
function parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        console.log('parsing error on', { value });
        return undefined;
    }
}

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useLockedBody/useLockedBody.js


function useLockedBody(initialLocked = false, rootId = '___gatsby') {
    const [locked, setLocked] = useState(initialLocked);
    useIsomorphicLayoutEffect(() => {
        if (!locked) {
            return;
        }
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = 'hidden';
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) {
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        }
        return () => {
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) {
                document.body.style.paddingRight = originalPaddingRight;
            }
        };
    }, [locked]);
    useEffect(() => {
        if (locked !== initialLocked) {
            setLocked(initialLocked);
        }
    }, [initialLocked]);
    return [locked, setLocked];
}
/* harmony default export */ var useLockedBody_useLockedBody = ((/* unused pure expression or super */ null && (useLockedBody)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useMap/useMap.js

function useMap(initialState = new Map()) {
    const [map, setMap] = useState(new Map(initialState));
    const actions = {
        set: useCallback((key, value) => {
            setMap(prev => {
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: useCallback(entries => {
            setMap(() => new Map(entries));
        }, []),
        remove: useCallback(key => {
            setMap(prev => {
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: useCallback(() => {
            setMap(() => new Map());
        }, []),
    };
    return [map, actions];
}
/* harmony default export */ var useMap_useMap = ((/* unused pure expression or super */ null && (useMap)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useMediaQuery/useMediaQuery.js

function useMediaQuery_useMediaQuery(query) {
    const getMatches = (query) => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    };
    const [matches, setMatches] = (0,react.useState)(getMatches(query));
    function handleChange() {
        setMatches(getMatches(query));
    }
    (0,react.useEffect)(() => {
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) {
            matchMedia.addListener(handleChange);
        }
        else {
            matchMedia.addEventListener('change', handleChange);
        }
        return () => {
            if (matchMedia.removeListener) {
                matchMedia.removeListener(handleChange);
            }
            else {
                matchMedia.removeEventListener('change', handleChange);
            }
        };
    }, [query]);
    return matches;
}
/* harmony default export */ var esm_useMediaQuery_useMediaQuery = (useMediaQuery_useMediaQuery);

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useOnClickOutside/useOnClickOutside.js

function useOnClickOutside(ref, handler, mouseEvent = 'mousedown') {
    useEventListener(mouseEvent, event => {
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!el || el.contains(event.target)) {
            return;
        }
        handler(event);
    });
}
/* harmony default export */ var useOnClickOutside_useOnClickOutside = ((/* unused pure expression or super */ null && (useOnClickOutside)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useReadLocalStorage/useReadLocalStorage.js


function useReadLocalStorage(key) {
    const readValue = useCallback(() => {
        if (typeof window === 'undefined') {
            return null;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return null;
        }
    }, [key]);
    const [storedValue, setStoredValue] = useState(readValue);
    useEffect(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = useCallback((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    useEventListener('storage', handleStorageChange);
    useEventListener('local-storage', handleStorageChange);
    return storedValue;
}
/* harmony default export */ var useReadLocalStorage_useReadLocalStorage = ((/* unused pure expression or super */ null && (useReadLocalStorage)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useScreen/useScreen.js


function useScreen() {
    const getScreen = () => {
        if (typeof window !== 'undefined' && window.screen) {
            return window.screen;
        }
        return undefined;
    };
    const [screen, setScreen] = useState(getScreen());
    function handleSize() {
        setScreen(getScreen());
    }
    useEventListener('resize', handleSize);
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, []);
    return screen;
}
/* harmony default export */ var useScreen_useScreen = ((/* unused pure expression or super */ null && (useScreen)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useScript/useScript.js

const cachedScriptStatuses = {};
function getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node === null || node === void 0 ? void 0 : node.getAttribute('data-status');
    return {
        node,
        status,
    };
}
function useScript(src, options) {
    const [status, setStatus] = useState(() => {
        var _a;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
            return 'idle';
        }
        if (typeof window === 'undefined') {
            return 'loading';
        }
        return (_a = cachedScriptStatuses[src]) !== null && _a !== void 0 ? _a : 'loading';
    });
    useEffect(() => {
        var _a, _b;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
            return;
        }
        const cachedScriptStatus = cachedScriptStatuses[src];
        if (cachedScriptStatus === 'ready' || cachedScriptStatus === 'error') {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement('script');
            scriptNode.src = src;
            scriptNode.async = true;
            scriptNode.setAttribute('data-status', 'loading');
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event) => {
                const scriptStatus = event.type === 'load' ? 'ready' : 'error';
                scriptNode === null || scriptNode === void 0 ? void 0 : scriptNode.setAttribute('data-status', scriptStatus);
            };
            scriptNode.addEventListener('load', setAttributeFromEvent);
            scriptNode.addEventListener('error', setAttributeFromEvent);
        }
        else {
            setStatus((_b = (_a = script.status) !== null && _a !== void 0 ? _a : cachedScriptStatus) !== null && _b !== void 0 ? _b : 'loading');
        }
        const setStateFromEvent = (event) => {
            const newStatus = event.type === 'load' ? 'ready' : 'error';
            setStatus(newStatus);
            cachedScriptStatuses[src] = newStatus;
        };
        scriptNode.addEventListener('load', setStateFromEvent);
        scriptNode.addEventListener('error', setStateFromEvent);
        return () => {
            if (scriptNode) {
                scriptNode.removeEventListener('load', setStateFromEvent);
                scriptNode.removeEventListener('error', setStateFromEvent);
            }
            if (scriptNode && (options === null || options === void 0 ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
            }
        };
    }, [src, options === null || options === void 0 ? void 0 : options.shouldPreventLoad, options === null || options === void 0 ? void 0 : options.removeOnUnmount]);
    return status;
}
/* harmony default export */ var useScript_useScript = ((/* unused pure expression or super */ null && (useScript)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useSessionStorage/useSessionStorage.js


function useSessionStorage(key, initialValue) {
    const readValue = useCallback(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? useSessionStorage_parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading sessionStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);
    const [storedValue, setStoredValue] = useState(readValue);
    const setValue = useEventCallback(value => {
        if (typeof window == 'undefined') {
            console.warn(`Tried setting sessionStorage key “${key}” even though environment is not a client`);
        }
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.sessionStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('session-storage'));
        }
        catch (error) {
            console.warn(`Error setting sessionStorage key “${key}”:`, error);
        }
    });
    useEffect(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = useCallback((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    useEventListener('storage', handleStorageChange);
    useEventListener('session-storage', handleStorageChange);
    return [storedValue, setValue];
}
/* harmony default export */ var useSessionStorage_useSessionStorage = ((/* unused pure expression or super */ null && (useSessionStorage)));
function useSessionStorage_parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        console.log('parsing error on', { value });
        return undefined;
    }
}

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useStep/useStep.js

function useStep(maxStep) {
    const [currentStep, setCurrentStep] = useState(1);
    const canGoToNextStep = useMemo(() => currentStep + 1 <= maxStep, [currentStep, maxStep]);
    const canGoToPrevStep = useMemo(() => currentStep - 1 >= 1, [currentStep]);
    const setStep = useCallback(step => {
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error('Step not valid');
    }, [maxStep, currentStep]);
    const goToNextStep = useCallback(() => {
        if (canGoToNextStep) {
            setCurrentStep(step => step + 1);
        }
    }, [canGoToNextStep]);
    const goToPrevStep = useCallback(() => {
        if (canGoToPrevStep) {
            setCurrentStep(step => step - 1);
        }
    }, [canGoToPrevStep]);
    const reset = useCallback(() => {
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep,
            goToPrevStep,
            canGoToNextStep,
            canGoToPrevStep,
            setStep,
            reset,
        },
    ];
}
/* harmony default export */ var useStep_useStep = ((/* unused pure expression or super */ null && (useStep)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useTernaryDarkMode/useTernaryDarkMode.js


const useTernaryDarkMode_COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useTernaryDarkMode() {
    const isDarkOS = useMediaQuery(useTernaryDarkMode_COLOR_SCHEME_QUERY);
    const [ternaryDarkMode, setTernaryDarkMode] = useLocalStorage('usehooks-ts-ternary-dark-mode', 'system');
    const [isDarkMode, setDarkMode] = useState(isDarkOS);
    useUpdateEffect(() => {
        if (ternaryDarkMode === 'system') {
            setDarkMode(isDarkOS);
        }
    }, [isDarkOS]);
    useEffect(() => {
        switch (ternaryDarkMode) {
            case 'light':
                setDarkMode(false);
                break;
            case 'system':
                setDarkMode(isDarkOS);
                break;
            case 'dark':
                setDarkMode(true);
                break;
        }
    }, [ternaryDarkMode, isDarkOS]);
    function toggleTernaryDarkMode() {
        const toggleDict = {
            light: 'system',
            system: 'dark',
            dark: 'light',
        };
        setTernaryDarkMode(prevMode => toggleDict[prevMode]);
    }
    return {
        isDarkMode,
        ternaryDarkMode,
        setTernaryDarkMode,
        toggleTernaryDarkMode,
    };
}
/* harmony default export */ var useTernaryDarkMode_useTernaryDarkMode = ((/* unused pure expression or super */ null && (useTernaryDarkMode)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useTimeout/useTimeout.js


function useTimeout(callback, delay) {
    const savedCallback = useRef(callback);
    useIsomorphicLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setTimeout(() => savedCallback.current(), delay);
        return () => clearTimeout(id);
    }, [delay]);
}
/* harmony default export */ var useTimeout_useTimeout = ((/* unused pure expression or super */ null && (useTimeout)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useToggle/useToggle.js

function useToggle(defaultValue) {
    const [value, setValue] = useState(!!defaultValue);
    const toggle = useCallback(() => setValue(x => !x), []);
    return [value, toggle, setValue];
}
/* harmony default export */ var useToggle_useToggle = ((/* unused pure expression or super */ null && (useToggle)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useUpdateEffect/useUpdateEffect.js


function useUpdateEffect_useUpdateEffect(effect, deps) {
    const isFirst = useIsFirstRender();
    useEffect(() => {
        if (!isFirst) {
            return effect();
        }
    }, deps);
}
/* harmony default export */ var esm_useUpdateEffect_useUpdateEffect = ((/* unused pure expression or super */ null && (useUpdateEffect_useUpdateEffect)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/useWindowSize/useWindowSize.js


function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: 0,
        height: 0,
    });
    const handleSize = () => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };
    useEventListener('resize', handleSize);
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, []);
    return windowSize;
}
/* harmony default export */ var useWindowSize_useWindowSize = ((/* unused pure expression or super */ null && (useWindowSize)));

;// CONCATENATED MODULE: ../../node_modules/usehooks-ts/dist/esm/index.js











































































;// CONCATENATED MODULE: ../../packages/application/hooks/userClient.ts

var useIsClientDesktop = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 2560px)");
};
var useIsClientDesktopS = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 1980px)");
};
var useIsClientLaptopXL = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 1600px)");
};
var useIsClientLaptopL = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 1440px)");
};
var useIsClientLaptopM = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 1280px)");
};
var useIsClientLaptop = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 1024px)");
};
var useIsClientLaptopS = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 924px)");
};
var useIsClientTabletXL = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 850px)");
};
var useIsClientTabletL = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 826px)");
};
var useIsClientTablet = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 768px)");
};
var useIsClientTabletXM = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 700px)");
};
var useIsClientTabletML = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 678px)");
};
var useIsClientTabletM = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 600px)");
};
var useIsClientTabletSmall = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 576px)");
};
var useIsClientMobile = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 480px)");
};
var useIsClientMobileL = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 425px)");
};
var useIsClientMobileM = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 375px)");
};
var useIsClientMobileS = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 320px)");
};
var useIsClientMobileXS = function() {
    return esm_useMediaQuery_useMediaQuery("(max-width: 280px)");
};
// Only breakpoints
var useIsOnlyClientLaptop = function() {
    return esm_useMediaQuery_useMediaQuery("(min-width: 769px) and (max-width: 1024px)");
};
var useIsOnlyClientTablet = function() {
    return esm_useMediaQuery_useMediaQuery("(min-width: 481px) and (max-width: 768px)");
};
var useIsOnlyClientMobile = function() {
    return esm_useMediaQuery_useMediaQuery("(min-width: 320px) and (max-width: 480px)");
};
var useIsOnlyMobileXSToLaptop = function() {
    return esm_useMediaQuery_useMediaQuery("(min-width: 280px) and (max-width: 1023px)");
};


/***/ }),

/***/ 33757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ setIsPageReloadByZipCodeSearch; },
/* harmony export */   "q": function() { return /* binding */ isPageReloadByZipCodeSearch; }
/* harmony export */ });
var isPageReloadByZipCodeSearch = function() {
    return localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("isPageReloadByZipCodeSearch");
};
var setIsPageReloadByZipCodeSearch = function(value) {
    if (value) {
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("isPageReloadByZipCodeSearch", "true");
        return;
    }
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem("isPageReloadByZipCodeSearch");
};



/***/ }),

/***/ 430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MEm": function() { return /* reexport */ BroadcastChannel/* BroadcastChannelProvider */.ME; },
  "ZlT": function() { return /* reexport */ CartContext/* CartProvider */.Zl; },
  "UGY": function() { return /* reexport */ FormAddressSchema; },
  "I7y": function() { return /* reexport */ HeaderProvider; },
  "inu": function() { return /* reexport */ utils/* anonymizeUserData */["in"]; },
  "xVL": function() { return /* reexport */ utils/* brazilianStates */.xV; },
  "Fek": function() { return /* reexport */ utils/* buildTestIds */.Fe; },
  "vs9": function() { return /* reexport */ utils/* calculateDiscountPercentage */.vs; },
  "kC2": function() { return /* reexport */ utils/* capitalize */.kC; },
  "R0u": function() { return /* reexport */ utils/* capitalizeAll */.R0; },
  "G4p": function() { return /* reexport */ utils/* capitalizeFirstLetterAndLowercaseRest */.G4; },
  "emg": function() { return /* reexport */ utils/* cookiePostalCodeStr */.em; },
  "Bas": function() { return /* reexport */ utils/* defaultHeaders */.B; },
  "mVl": function() { return /* reexport */ utils/* descriptionParcelsText */.mV; },
  "PZS": function() { return /* reexport */ utils/* dropListTerms */.PZ; },
  "hhk": function() { return /* reexport */ utils/* extractTimeFromUTC */.hh; },
  "Pbg": function() { return /* reexport */ utils/* filterStoreOrders */.Pb; },
  "IJK": function() { return /* reexport */ utils/* filterValueProductPricePackage */.IJ; },
  "p0S": function() { return /* reexport */ utils/* formatCountdownTimer */.p0; },
  "w3F": function() { return /* reexport */ utils/* formatCpf */.w3; },
  "xGv": function() { return /* reexport */ utils/* formatCurrency */.xG; },
  "p6d": function() { return /* reexport */ utils/* formatDate */.p6; },
  "D_e": function() { return /* reexport */ utils/* formatDatePhrase */.D_; },
  "XCW": function() { return /* reexport */ utils/* formatEmailToShowOnlyFourCharactersAndDomain */.XC; },
  "ufS": function() { return /* reexport */ utils/* formatNumber */.uf; },
  "unW": function() { return /* reexport */ utils/* formatPhoneNumber */.un; },
  "RZb": function() { return /* reexport */ utils/* formatShortenDateWithoutYear */.RZ; },
  "Ess": function() { return /* reexport */ utils/* formatStringUrl */.Es; },
  "c$e": function() { return /* reexport */ utils/* formatTestId */.c$; },
  "WL0": function() { return /* reexport */ utils/* formatUTCToShort */.WL; },
  "BDI": function() { return /* reexport */ utils/* formatUserName */.BD; },
  "MvN": function() { return /* reexport */ hooks/* getBranchAddress */.Mv; },
  "R0G": function() { return /* reexport */ utils/* getClientBranchId */.rx; },
  "tKK": function() { return /* reexport */ utils/* getClientLocationDetails */.tK; },
  "sul": function() { return /* reexport */ utils/* getComponentTheme */.su; },
  "rYd": function() { return /* reexport */ utils/* getDiscountMessage */.rY; },
  "$Q4": function() { return /* reexport */ utils/* getDiscountPercentage */.$Q; },
  "Yt8": function() { return /* reexport */ utils/* getGeolocation */.Yt; },
  "aY_": function() { return /* reexport */ utils/* getInstallmentsText */.aY; },
  "T1P": function() { return /* reexport */ utils/* getIsListInactive */.T1; },
  "ZSL": function() { return /* reexport */ utils/* getMappedCard */.ZS; },
  "dfG": function() { return /* reexport */ utils/* getMaxInstallments */.df; },
  "pYZ": function() { return /* reexport */ utils/* getMeasuredUnit */.pY; },
  "Wuf": function() { return /* reexport */ utils/* getObjectLength */.Wu; },
  "cOK": function() { return /* reexport */ utils/* getPaymentIcon */.cO; },
  "V7P": function() { return /* reexport */ utils/* getPaymentOptions */.V7; },
  "pgP": function() { return /* reexport */ utils/* getPhoneNumberInvalidInformation */.pg; },
  "D7": function() { return /* reexport */ utils/* getPriceList */.D7; },
  "COg": function() { return /* reexport */ utils/* getProductBreadcrumbItems */.CO; },
  "Gai": function() { return /* reexport */ utils/* getProductImageUrl */.G; },
  "E8Y": function() { return /* reexport */ utils/* getProductPosition */.E8; },
  "KAs": function() { return /* reexport */ utils/* getSaleChannel */.KA; },
  "FlL": function() { return /* reexport */ utils/* getSalePrice */.Fl; },
  "YJL": function() { return /* reexport */ utils/* getSmallMappedCard */.YJ; },
  "$XT": function() { return /* reexport */ utils/* getSpotPrice */.$X; },
  "ZhG": function() { return /* reexport */ utils/* getUserInitials */.Zh; },
  "A42": function() { return /* reexport */ utils/* handleOnErrorRetry */.A4; },
  "Rnl": function() { return /* reexport */ utils/* handleProductTag */.Rn; },
  "Wu_": function() { return /* reexport */ utils/* handleRefreshUserAccessToken */.P2; },
  "REm": function() { return /* reexport */ utils/* installmentsOptionsFormatted */.RE; },
  "CGm": function() { return /* reexport */ utils/* isAttentionStatus */.CG; },
  "y8l": function() { return /* reexport */ utils/* isVisibleOnDesktop */.y8; },
  "tIi": function() { return /* reexport */ utils/* isVisibleOnMobile */.tI; },
  "jfz": function() { return /* reexport */ utils/* lazyLoading */.jf; },
  "H6d": function() { return /* reexport */ utils/* obfuscate */.H6; },
  "A2V": function() { return /* reexport */ utils/* removeSpecialCharacters */.A2; },
  "sMx": function() { return /* reexport */ utils/* replaceImageBaseUrl */.sM; },
  "VVF": function() { return /* reexport */ sendItemToCartByServer; },
  "Hzx": function() { return /* reexport */ utils/* shareText */.Hz; },
  "ES0": function() { return /* reexport */ utils/* sortListShipping */.ES; },
  "ADk": function() { return /* reexport */ hooks/* useAddItemToCart */.AD; },
  "E$y": function() { return /* reexport */ hooks/* useAddressSorter */.E$; },
  "VYq": function() { return /* reexport */ state_manager/* useAlert */.VY; },
  "bp4": function() { return /* reexport */ state/* useAppContext */.b; },
  "aCi": function() { return /* reexport */ Identity/* useAuth */.aC; },
  "JLf": function() { return /* reexport */ state_manager/* useAuthentication */.JL; },
  "R4_": function() { return /* reexport */ state_manager/* useBlackFriday */.R4; },
  "vKz": function() { return /* reexport */ BranchLocationContext/* useBranchLocation */.vK; },
  "Kj": function() { return /* reexport */ CardsContext.useCards; },
  "iQs": function() { return /* reexport */ CartContext/* useCartContext */.iQ; },
  "L_s": function() { return /* reexport */ state_manager/* useCategories */.L_; },
  "dpv": function() { return /* reexport */ state_manager/* useChatbot */.dp; },
  "O8h": function() { return /* reexport */ hooks/* useClickOutside */.O8; },
  "au2": function() { return /* reexport */ hooks/* useCountdown */.au; },
  "Cfk": function() { return /* reexport */ state_manager/* useCounter */.Cf; },
  "Y0L": function() { return /* reexport */ hooks/* useCurrentPathName */.Y0; },
  "NrF": function() { return /* reexport */ hooks/* useDebounce */.Nr; },
  "HSW": function() { return /* reexport */ state_manager/* useEnvs */.HS; },
  "L0T": function() { return /* reexport */ state_manager/* useFilter */.L0; },
  "ROs": function() { return /* reexport */ hooks/* useGetFiscalNote */.RO; },
  "Jv3": function() { return /* reexport */ useHeaderContext; },
  "b2j": function() { return /* reexport */ hooks/* useInitializeAllConfigs */.b2; },
  "u6o": function() { return /* reexport */ hooks/* useInitializeTwoFactor */.u6; },
  "oON": function() { return /* reexport */ hooks/* useMapCrmTransactionObject */.oO; },
  "IzY": function() { return /* reexport */ ModalGroupContext.useModalGroup; },
  "lmA": function() { return /* reexport */ NotificationContext.useNotification; },
  "Lq5": function() { return /* reexport */ state_manager/* useOrderStore */.Lq; },
  "fgV": function() { return /* reexport */ hooks/* usePersistDataInUrl */.fg; },
  "zN7": function() { return /* reexport */ hooks/* useProductsRecommendation */.zN; },
  "ZNz": function() { return /* reexport */ PurchaseContext.usePurchase; },
  "KHp": function() { return /* reexport */ state_manager/* useRegisterPhoneNumber */.KH; },
  "LF8": function() { return /* reexport */ hooks/* useScrollVisibility */.LF; },
  "NL6": function() { return /* reexport */ state_manager/* useShallow */.NL; },
  "PSi": function() { return /* reexport */ hooks/* useShowRegisterPhoneNumberModal */.PS; },
  "J7i": function() { return /* reexport */ hooks/* useTimer */.J7; },
  "pmc": function() { return /* reexport */ hooks/* useToast */.pm; },
  "kD7": function() { return /* reexport */ state_manager/* useTwoFactor */.kD; },
  "NGB": function() { return /* reexport */ state_manager/* useUniqueClient */.NG; },
  "aFb": function() { return /* reexport */ Identity/* useUser */.aF; },
  "B8K": function() { return /* reexport */ hooks/* useValidateClientBranchChange */.B8; },
  "fTF": function() { return /* reexport */ hooks/* useValidatePassword */.fT; },
  "sOn": function() { return /* reexport */ WebSocket.useWebSocket; },
  "GuQ": function() { return /* reexport */ utils/* userAuthenticatedActions */.Gu; },
  "nlr": function() { return /* reexport */ utils/* validCpfRegex */.oM; },
  "C2y": function() { return /* reexport */ utils/* validEmailRegex */.C2; },
  "D4_": function() { return /* reexport */ utils/* validateCardNumber */.D4; },
  "S$0": function() { return /* reexport */ utils/* validateConfirmPassword */.S$; },
  "cyc": function() { return /* reexport */ utils/* validateCpf */.cy; },
  "mET": function() { return /* reexport */ utils/* validateCreditCardCVV */.mE; },
  "m2s": function() { return /* reexport */ utils/* validateCreditCardDueDate */.m2; },
  "oH0": function() { return /* reexport */ utils/* validateEmail */.oH; },
  "Olw": function() { return /* reexport */ utils/* validateName */.Ol; },
  "uo4": function() { return /* reexport */ utils/* validatePassword */.uo; },
  "Y08": function() { return /* reexport */ utils/* validatePhoneNumber */.Y0; },
  "xLP": function() { return /* reexport */ utils/* validateSecurityCode */.VW; },
  "zrv": function() { return /* reexport */ utils/* valueProduct */.zr; }
});

// UNUSED EXPORTS: AppWrapper, AuthContext, AuthProvider, BackofficeApi, BranchLocationContext, BranchLocationProvider, BroadcastChannelContext, CardsProvider, CatalogApi, CookiesProvider, CountdownProvider, ERROR_MESSAGES_BIRTHDATE, EnvsApi, EventListenerContext, EventListenerProvider, GoogleAuthenticateApi, IdentityApi, ModalGroupProvider, NotificationApi, NotificationContext, NotificationProvider, PaymentApi, ProfileApi, PurchaseApi, PurchaseContext, PurchaseProvider, RecaptchaContext, RecaptchaContextProvider, ShippingApi, ShoppingApi, SupportContactApi, ToastProvider, UserContext, UserProvider, UtilInfoApi, WebSocketContext, WebSocketContextProvider, WeddingGiftListApi, cartIdCookie, convertStoreOrderToDigital, cookieBranchLocationStr, cookieModalBranchLocationStr, cookieRegionStr, createSessionId, createStore, dataInsiderAPI, dateFormatForCardMessage, formatBranchId, formatDateAndTime, formatDateToShortCrm, formatDueDateCreditCard, formatLocationName, formatShortenDate, generateId, getApisUrlFallback, getBranchName, getCategories, getCustomHeader, getDiscountValue, getFileByLink, getHighlightCategories, getInstallmentValue, getPageCacheControlInfo, getProductQuantity, getRequestPath, getSessionId, getUserFirstName, getUserSurname, handleBackofficeContent, handleCreditCardCvvMask, handleCreditCardCvvPlaceholder, handleCreditCardNumberMask, handleEmailValidation, handleNameValidation, handlePreloadComponents, handleResponse, handleResponseError, highlightCategoriesMapper, isFebruaryInvalid, isLeapYear, isObjectEmpty, isSpecialStatus, lastThirtyDaysValue, linkOptionsData, mapFilterProductsByPlaylistToSearchByTerm, mockedBlackFridayTheme, mockedDefaultPageThemeMap, mockedHeatmapClient, mockedHeatmapClientMap, mockedPageThemeMap, optionsMaxAgeEqualOneYear, paymentOptionsData, quantityOfDaysIsBiggerThanThirty, removeCharactersSpecials, removeItensNullOrUndefinedObject, searchValueInObject, selectDateValue, serverSideDeviceDetection, setEnvByServer, sortingFavoritesStoresList, sumYears, supportContactHandlers, thisYearValue, useBrowserBroadcast, useConfirmationTypes, useCookies, useCreateSessionId, useCrm, useEventListener, useGiftCard, useIsClientDesktop, useIsClientDesktopS, useIsClientLaptop, useIsClientLaptopL, useIsClientLaptopM, useIsClientLaptopS, useIsClientLaptopXL, useIsClientMobile, useIsClientMobileL, useIsClientMobileM, useIsClientMobileS, useIsClientMobileXS, useIsClientTablet, useIsClientTabletL, useIsClientTabletM, useIsClientTabletML, useIsClientTabletSmall, useIsClientTabletXL, useIsClientTabletXM, useIsOnlyClientLaptop, useIsOnlyClientMobile, useIsOnlyClientTablet, useIsOnlyMobileXSToLaptop, useLoginAuthentication, useMyCards, usePurchaseShallow, usePurchaseStore, useRecaptcha, useSecurityStore, useSlider, useWeddingList, utilInfoHandlers, validateBirthdate, validateEmailFormWeddingList, validateFirstName, validateLettersAndNumbers, validateNameFormWeddingList, validateWeddingDate, validateWeddingList

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
;// CONCATENATED MODULE: ../../packages/application/actions/setEnvByServer/index.ts


var setEnvByServer = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(envKey, envClient, apiClient, request) {
        var actualEnv, storedEnv;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                actualEnv = envClient.getRawEnvImmediately(envKey);
                storedEnv = request.cookies["".concat(envKey)];
                if (!actualEnv && storedEnv) {
                    return [
                        2,
                        Promise.resolve(function() {
                            apiClient.setBaseUrl(storedEnv);
                        })
                    ];
                }
                return [
                    2,
                    Promise.resolve()
                ];
            } catch (error) {
                return [
                    2,
                    Promise.resolve()
                ];
            }
            return [
                2
            ];
        });
    });
    return function setEnvByServer(envKey, envClient, apiClient, request) {
        return _ref.apply(this, arguments);
    };
}();


;// CONCATENATED MODULE: ../../packages/application/actions/sendItemToCart/index.ts


var sendItemToCartByServer = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var productId, _quantity, quantity, shoppingApi, accessToken, branchId, cartId;
        function getCookie(cname) {
            var name = "".concat(cname, "=");
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // eslint-disable-next-line no-restricted-syntax
                for(var _iterator = ca[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var element = _step.value;
                    var c = element;
                    while(c.startsWith(" ")){
                        c = c.substring(1);
                    }
                    if (c.startsWith(name)) {
                        return c.substring(name.length, c.length);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return "";
        }
        return (0,tslib_es6.__generator)(this, function(_state) {
            productId = param.productId, _quantity = param.quantity, quantity = _quantity === void 0 ? 1 : _quantity, shoppingApi = param.shoppingApi;
            accessToken = getCookie("@FC:Ecom:Token:Access");
            branchId = getCookie("@FC:Ecom:Dropdown:BranchLocation") || getCookie("@FC:Ecom:Modal:BranchLocation") || "2";
            cartId = getCookie("@FC:Ecom:Cart:Id");
            if (cartId && branchId) {
                shoppingApi.addItemsCartByServer({
                    cartId: Number(cartId),
                    productId: productId,
                    quantity: quantity,
                    package: 0,
                    packingQuantity: 1,
                    sellerId: 0,
                    price: 0,
                    branchId: Number(branchId),
                    listId: 0
                }, accessToken || "").then(function(res) {
                    var ref;
                    if (res === null || res === void 0 ? void 0 : (ref = res.status) === null || ref === void 0 ? void 0 : ref.toString().startsWith("2")) {
                        // eslint-disable-next-line no-console
                        console.log("Insider - Produto adicionando com sucesso!");
                        window.location.reload();
                    } else {
                        // eslint-disable-next-line no-console
                        console.log("Insider - Erro ao adicionar o produto.");
                    }
                });
            } else {
                // eslint-disable-next-line no-console
                console.log("Insider - N\xe3o foi poss\xedvel adicionar o produto ao carrinho: ".concat(!cartId ? "CartId n\xe3o encontrado" : "", " ").concat(!branchId ? "BranchId n\xe3o encontrado" : "", "\n      "));
            }
            return [
                2
            ];
        });
    });
    return function sendItemToCartByServer(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ../../packages/application/actions/index.ts



// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/application/context/Header/get-custom-header.ts
var getCustomHeaderHttpRequest = function(backofficeApi, cookie) {
    var ref;
    var branchId = (ref = cookie.getCookie({
        name: "@FC:Ecom:Dropdown:BranchLocation"
    })) !== null && ref !== void 0 ? ref : "2";
    return backofficeApi.getCustomHeader(branchId, !!branchId);
};
var getCustomHeader = function(backofficeApi, cookie) {
    var ref, ref1;
    var ref2 = getCustomHeaderHttpRequest(backofficeApi, cookie), component = ref2.data, isLoadingCustomHeader = ref2.isLoading;
    var customHeaderError = component;
    var customHeaderData = component;
    var customHeader = (customHeaderError === null || customHeaderError === void 0 ? void 0 : customHeaderError.status) && ((ref1 = customHeaderError === null || customHeaderError === void 0 ? void 0 : (ref = customHeaderError.status) === null || ref === void 0 ? void 0 : ref.toString()) === null || ref1 === void 0 ? void 0 : ref1.startsWith("4")) ? null : customHeaderData === null || customHeaderData === void 0 ? void 0 : customHeaderData[0];
    return {
        customHeader: customHeader,
        isLoadingCustomHeader: isLoadingCustomHeader
    };
};

;// CONCATENATED MODULE: ../../packages/application/context/Header/highlight-categories-mapper.ts
var highlightCategoriesMapper = function(subComponents) {
    if (!(subComponents === null || subComponents === void 0 ? void 0 : subComponents.length)) {
        return null;
    }
    //   console.log("subComponents: ", subComponents);
    return subComponents.map(function(subComponent) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        var name = ((ref1 = subComponent === null || subComponent === void 0 ? void 0 : (ref = subComponent.properties) === null || ref === void 0 ? void 0 : ref.find(function(property) {
            return (property === null || property === void 0 ? void 0 : property.key) === "title";
        })) === null || ref1 === void 0 ? void 0 : ref1.value) || "";
        var branchId = Number((subComponent === null || subComponent === void 0 ? void 0 : (ref2 = subComponent.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.branches) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.id) || 0);
        var descriptionUrl = (subComponent === null || subComponent === void 0 ? void 0 : (ref5 = subComponent.config) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.branches) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.linkUrl) || (subComponent === null || subComponent === void 0 ? void 0 : (ref8 = subComponent.config) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.branches) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : ref10.linkId) || "";
        return {
            id: 0,
            name: name,
            level: 0,
            ordination: 0,
            branchId: branchId,
            titleSeo: "",
            descriptionSeo: "",
            descriptionUrl: descriptionUrl
        };
    });
};


;// CONCATENATED MODULE: ../../packages/application/context/Header/state.tsx




var HeaderContext = /*#__PURE__*/ (0,react.createContext)({});
var HeaderProvider = function(param) {
    var children = param.children, backofficeApi = param.backofficeApi, cookie = param.cookie;
    var ref = getCustomHeader(backofficeApi, cookie), customHeader = ref.customHeader, isLoadingCustomHeader = ref.isLoadingCustomHeader;
    // const { highlightCategories, isLoadingHighlightCategories } =
    //   getHighlightCategories(catalogApi, cookie);
    var isLoadingHighlightCategories = isLoadingCustomHeader;
    var highlightCategories = highlightCategoriesMapper(customHeader === null || customHeader === void 0 ? void 0 : customHeader.subComponents);
    var headerContextProviderValue = (0,react.useMemo)(function() {
        return {
            customHeader: customHeader,
            isLoadingCustomHeader: isLoadingCustomHeader,
            highlightCategories: highlightCategories,
            isLoadingHighlightCategories: isLoadingHighlightCategories
        };
    }, [
        customHeader,
        isLoadingCustomHeader,
        highlightCategories,
        isLoadingHighlightCategories, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContext.Provider, {
        value: headerContextProviderValue,
        children: children
    });
};
var useHeaderContext = function() {
    return (0,react.useContext)(HeaderContext);
};

;// CONCATENATED MODULE: ../../packages/application/context/Header/index.ts





// EXTERNAL MODULE: ../../packages/application/context/BranchLocationContext.tsx
var BranchLocationContext = __webpack_require__(64462);
// EXTERNAL MODULE: ../../packages/application/context/CardsContext.tsx
var CardsContext = __webpack_require__(79203);
// EXTERNAL MODULE: ../../packages/application/context/CookiesContext.tsx
var CookiesContext = __webpack_require__(38672);
// EXTERNAL MODULE: ../../packages/application/context/EventListener/index.tsx
var EventListener = __webpack_require__(44278);
// EXTERNAL MODULE: ../../packages/application/context/Identity/index.ts + 1 modules
var Identity = __webpack_require__(24846);
// EXTERNAL MODULE: ../../packages/application/context/ShoppingHookContext/CartContext.tsx + 1 modules
var CartContext = __webpack_require__(9521);
// EXTERNAL MODULE: ../../packages/application/context/state.tsx + 1 modules
var state = __webpack_require__(14366);
// EXTERNAL MODULE: ../../packages/application/context/Purchase/PurchaseContext.tsx
var PurchaseContext = __webpack_require__(25371);
// EXTERNAL MODULE: ../../packages/application/context/ModalGroupContext.tsx
var ModalGroupContext = __webpack_require__(81898);
// EXTERNAL MODULE: ../../packages/application/context/Notification/NotificationContext.tsx
var NotificationContext = __webpack_require__(12093);
// EXTERNAL MODULE: ../../packages/application/context/Recaptcha/index.tsx
var Recaptcha = __webpack_require__(13638);
// EXTERNAL MODULE: ../../packages/application/context/WebSocket/index.tsx
var WebSocket = __webpack_require__(91393);
// EXTERNAL MODULE: ../../packages/application/context/BroadcastChannel/index.tsx
var BroadcastChannel = __webpack_require__(25320);
;// CONCATENATED MODULE: ../../packages/application/context/index.ts
















// EXTERNAL MODULE: ../../packages/application/hooks/index.ts + 19 modules
var hooks = __webpack_require__(38665);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ../../packages/application/schemas/FormAddress/index.ts
// eslint-disable-next-line import/no-extraneous-dependencies

var FormAddressSchema = lib.z.object({
    addressComplement: lib.z.string().trim().nullish(),
    city: lib.z.string({
        required_error: "O nome da cidade \xe9 obrigat\xf3rio.",
        invalid_type_error: "O nome da cidade deve ser um texto v\xe1lido."
    }),
    district: lib.z.string({
        required_error: "O nome do bairro \xe9 obrigat\xf3rio.",
        invalid_type_error: "O nome do bairro deve ser um texto v\xe1lido."
    }),
    noNumber: lib.z.boolean({
        invalid_type_error: "A op\xe7\xe3o 'Sem n\xfamero' deve ser verdadeira ou falsa."
    }).default(false).optional(),
    number: lib.z.number().nonnegative("O n\xfamero do endere\xe7o deve ser um valor positivo.").lte(999999, "O n\xfamero do endere\xe7o deve ter no m\xe1ximo 6 d\xedgitos.").or(lib.z.string().max(6, "O n\xfamero do endere\xe7o deve ter no m\xe1ximo 6 d\xedgitos.").regex(/^\d*$/, "O n\xfamero do endere\xe7o n\xe3o pode receber letras ou caracteres especiais").nullish()).nullish(),
    recipient: lib.z.string({
        required_error: "O nome do destinat\xe1rio \xe9 obrigat\xf3rio.",
        invalid_type_error: "O nome do destinat\xe1rio deve ser um texto v\xe1lido."
    }),
    referencePoint: lib.z.string().max(100, "O ponto de refer\xeancia deve conter no m\xe1ximo 100 caracteres.").nullish(),
    state: lib.z.string({
        required_error: "O estado \xe9 obrigat\xf3rio.",
        invalid_type_error: "O estado deve ser um texto v\xe1lido."
    }),
    street: lib.z.string({
        required_error: "O nome da rua \xe9 obrigat\xf3rio.",
        invalid_type_error: "O nome da rua deve ser um texto v\xe1lido."
    }),
    zipCode: lib.z.string({
        required_error: "O CEP \xe9 obrigat\xf3rio.",
        invalid_type_error: "O CEP deve ser um texto v\xe1lido."
    })
});

;// CONCATENATED MODULE: ../../packages/application/schemas/index.ts


// EXTERNAL MODULE: ../../packages/application/services/apis/index.ts + 13 modules
var apis = __webpack_require__(11780);
// EXTERNAL MODULE: ../../packages/application/services/mocks/index.ts + 5 modules
var mocks = __webpack_require__(49294);
;// CONCATENATED MODULE: ../../packages/application/services/index.tsx



// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
// EXTERNAL MODULE: ../../packages/application/utils/index.tsx + 44 modules
var utils = __webpack_require__(83428);
;// CONCATENATED MODULE: ../../packages/application/index.tsx













/***/ }),

/***/ 32817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ EnvsApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50853);
/* provided dependency */ var process = __webpack_require__(34406);



var EnvsApi = /*#__PURE__*/ function() {
    "use strict";
    function EnvsApi(cookie) {
        var preloadAllConfigs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, EnvsApi);
        this.cookie = cookie;
        this.allConfigs = null;
        this.getEnvEndpoint = function(envKey) {
            return "".concat(_this.baseUrl, "?envKey=").concat(envKey);
        };
        var _this1 = this;
        this.getEnv = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(envKey) {
                var response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(_this1.getEnvEndpoint(envKey), {
                                    method: "GET"
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(envKey) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = this;
        this.getAwaitAllConfigs = /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
            var timeout, retryTimes;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                timeout = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 250, retryTimes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0;
                if (!_this2.allConfigs && retryTimes < 30) {
                    return [
                        2,
                        new Promise(function(resolve) {
                            setTimeout(function() {
                                resolve(_this2.getAwaitAllConfigs(timeout, retryTimes + 1));
                            }, timeout);
                        })
                    ];
                }
                return [
                    2,
                    _this2.allConfigs
                ];
            });
        });
        var _this3 = this;
        this.getAllConfigs = /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
            var response, allConfigsResponse, _data, data, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (_this3.allConfigs) {
                            return [
                                2,
                                {
                                    data: _this3.allConfigs,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch("".concat(_this3.baseUrl, "/configs"), {
                                method: "GET"
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        allConfigsResponse = _state.sent();
                        _data = allConfigsResponse.data, data = _data === void 0 ? null : _data;
                        _this3.allConfigs = data;
                        return [
                            2,
                            allConfigsResponse
                        ];
                    case 4:
                        e = _state.sent();
                        return [
                            2,
                            {
                                data: null,
                                isLoading: false,
                                error: null
                            }
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        this.// eslint-disable-next-line class-methods-use-this
        getRawEnv = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(envKey) {
                var envVariable;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    envVariable = process.env["".concat(envKey)];
                    return [
                        2,
                        Promise.resolve({
                            data: envVariable,
                            error: null,
                            isLoading: false
                        })
                    ];
                });
            // try {
            //   const response = await fetch(this.getEnvEndpoint(envKey), {
            //     method: "GET",
            //   });
            //   return response.json() as unknown as IHttpResponse<string, unknown>;
            // } catch {
            //   return null;
            // }
            });
            return function(envKey) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getRawEnvImmediately = function(envKey) {
            if (process === null || process === void 0 ? void 0 : true) {
                // const data =
                //   (document.getElementById("apisBaseUrl") as HTMLInputElement)?.value ||
                //   "";
                var data = _this.cookie.getCookie({
                    name: "@FC:Ecom:".concat(envKey)
                });
                if (!data && envKey === "APIS_BASE_URL") {
                    data = process.env.NEXT_PUBLIC_APIS_BASE_URL;
                }
                return {
                    data: data,
                    isLoading: false,
                    error: null
                };
            }
            var rawEnv = process.env["".concat(envKey)];
            return {
                data: rawEnv,
                isLoading: false,
                error: null
            };
        };
        this.baseUrl = "/api/envs";
        if (preloadAllConfigs) {
            this.getAllConfigs();
        }
    }
    var _proto = EnvsApi.prototype;
    // eslint-disable-next-line class-methods-use-this
    _proto.setBaseUrl = function setBaseUrl(url) {
        // eslint-disable-next-line no-console
        console.error("Method not implemented ".concat(url !== null && url !== void 0 ? url : ""));
    };
    return EnvsApi;
}();



/***/ }),

/***/ 219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ handleCartError; }
/* harmony export */ });
var handleCartError = function(error, appMonitoringClient, eventError) {
    if (error) {
        appMonitoringClient.captureException(error, {
            level: "error",
            tags: {
                fcx_labs_event: eventError,
                fcx_labs_error_source: "shopping_api"
            }
        });
    }
};



/***/ }),

/***/ 11780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iQ": function() { return /* reexport */ BackofficeApi; },
  "jx": function() { return /* reexport */ CatalogApi; },
  "vX": function() { return /* reexport */ Envs/* EnvsApi */.v; },
  "xm": function() { return /* reexport */ IdentityApi; },
  "mj": function() { return /* reexport */ NotificationApi; },
  "gY": function() { return /* reexport */ PaymentApi; },
  "R5": function() { return /* reexport */ ProfileApi; },
  "K$": function() { return /* reexport */ PurchaseApi; },
  "J_": function() { return /* reexport */ ShippingApi; },
  "R$": function() { return /* reexport */ ShoppingApi; },
  "tc": function() { return /* reexport */ SupportContactApi; },
  "Ny": function() { return /* reexport */ UtilInfoApi; },
  "AT": function() { return /* reexport */ WeddingGiftListApi; }
});

// UNUSED EXPORTS: GoogleAuthenticateApi

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../packages/application/utils/index.tsx + 44 modules
var utils = __webpack_require__(83428);
// EXTERNAL MODULE: ../../packages/application/utils/http/index.tsx + 6 modules
var http = __webpack_require__(60143);
;// CONCATENATED MODULE: ../../packages/application/services/apis/Backoffice/index.ts
/* provided dependency */ var process = __webpack_require__(34406);







var BackofficeApi = /*#__PURE__*/ function() {
    "use strict";
    function BackofficeApi(httpClient, envsApi) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, BackofficeApi);
        this.httpClient = httpClient;
        this.envsApi = envsApi;
        this.baseUrl = "";
        this.siteUrl = "";
        this.getPageTemplateEndpoint = function(playlistUrlType, branchId, currentPage, playlistUrl, pageSize) {
            var formattedBranchId = (0,utils/* formatBranchId */.f)(branchId);
            return "".concat(_this.baseUrl, "v1/template/url/").concat(playlistUrlType, "?branchId=").concat(formattedBranchId, "&currentPage=").concat(currentPage).concat(playlistUrl ? "&playlistUrl=".concat(playlistUrl, "&PageSize=").concat(pageSize) : "&PageSize=".concat(pageSize));
        };
        var _this1 = this;
        this.getPageTemplate = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(playlistUrlType, branchId, playlistUrl) {
                var currentPage, condition, pageSize, ref, ref1, data, error, isLoading, ref2, response, formattedError, data1, e, err;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            currentPage = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 1, condition = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : true, pageSize = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : "46";
                            if (true) {
                                ;
                                ref1 = _this1.httpClient.useGet(_this1.getPageTemplateEndpoint(playlistUrlType, branchId, currentPage, playlistUrl, pageSize), {
                                    headers: {
                                        "Accept-Encoding": "gzip, deflate",
                                        origin: "".concat((ref = _this1.siteUrl) === null || ref === void 0 ? void 0 : ref.replace(/\/$/, ""))
                                    }
                                }, !!condition), data = ref1.data, error = ref1.error, isLoading = ref1.isLoading;
                                return [
                                    2,
                                    {
                                        data: data,
                                        isLoading: isLoading,
                                        error: error
                                    }
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4,
                                fetch(_this1.getPageTemplateEndpoint(playlistUrlType, branchId, currentPage, playlistUrl), {
                                    headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, http/* defaultHeaders */.B), {
                                        origin: "".concat((ref2 = _this1.siteUrl) === null || ref2 === void 0 ? void 0 : ref2.replace(/\/$/, ""))
                                    })
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            formattedError = {
                                data: null,
                                isLoading: false,
                                error: "A http request para buscar o template cujo tipo \xe9 ".concat(playlistUrlType, ", cuja url \xe9 ").concat(playlistUrl, " e cuja branchId \xe9 ").concat(branchId, " n\xe3o retornou nenhuma informa\xe7\xe3o")
                            };
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                response.json()
                            ];
                        case 4:
                            data1 = _state.sent();
                            if (!data1 || !response.ok) {
                                return [
                                    2,
                                    formattedError
                                ];
                            }
                            return [
                                2,
                                {
                                    data: data1,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 5:
                            e = _state.sent();
                            return [
                                2,
                                formattedError
                            ];
                        case 6:
                            return [
                                3,
                                8
                            ];
                        case 7:
                            err = _state.sent();
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: err
                                }
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(playlistUrlType, branchId, playlistUrl) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getCustomHeaderEndpoint = function(branchId) {
            var formattedBranchId = (0,utils/* formatBranchId */.f)(branchId);
            return "".concat(_this.baseUrl, "v1/template/global-header/").concat(formattedBranchId);
        };
        this.getCustomHeader = function(branchId) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var ref;
            var ref1 = _this.httpClient.useGet(_this.getCustomHeaderEndpoint(branchId), {
                headers: {
                    "Accept-Encoding": "gzip, deflate",
                    origin: "".concat((ref = _this.siteUrl) === null || ref === void 0 ? void 0 : ref.replace(/\/$/, ""))
                }
            }, !!condition), data = ref1.data, error = ref1.error, isLoading = ref1.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getBlackFridayThemeEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/draft/black-theme");
        };
        var _this2 = this;
        this.getBlackFridayTheme = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var response, _tmp, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            fetch(_this2.getBlackFridayThemeEndpoint(), {
                                headers: (0,_object_spread/* default */.Z)({}, http/* defaultHeaders */.B)
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (!!response.ok) return [
                            3,
                            3
                        ];
                        _tmp = {
                            data: null,
                            isLoading: false
                        };
                        return [
                            4,
                            response.text()
                        ];
                    case 2:
                        return [
                            2,
                            (_tmp.error = _state.sent(), _tmp)
                        ];
                    case 3:
                        return [
                            4,
                            response.json()
                        ];
                    case 4:
                        data = _state.sent();
                        return [
                            2,
                            {
                                data: data,
                                isLoading: false,
                                error: null
                            }
                        ];
                    case 5:
                        error = _state.sent();
                        return [
                            2,
                            {
                                data: null,
                                isLoading: false,
                                error: error
                            }
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        if (!this.baseUrl) {
            var ref = this.envsApi.getRawEnvImmediately("APIS_BASE_URL"), apisBaseUrl = ref.data;
            var ref1 = this.envsApi.getRawEnvImmediately("SITE_URL"), currentUrl = ref1.data;
            var fallback = (0,utils/* getApisUrlFallback */.TW)(process.env.HOST_ENV);
            this.baseUrl = "".concat(apisBaseUrl || fallback, "backoffice-api/");
            this.siteUrl = currentUrl || "";
        }
    }
    var _proto = BackofficeApi.prototype;
    _proto.setBaseUrl = function setBaseUrl(url) {
        this.baseUrl = url;
    };
    return BackofficeApi;
}();

;// CONCATENATED MODULE: ../../packages/application/services/apis/Catalog/index.ts
/* provided dependency */ var Catalog_process = __webpack_require__(34406);







var headerPaginationTotalResultsStr = "x-pagination-totalresults";
var CatalogApi = /*#__PURE__*/ function() {
    "use strict";
    function CatalogApi(httpClient, appMonitoringClient, envsApi) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, CatalogApi);
        this.httpClient = httpClient;
        this.appMonitoringClient = appMonitoringClient;
        this.envsApi = envsApi;
        this.baseUrl = "";
        this.baseUrlV2 = "";
        this.getHomeCategoriesEndpoint = function() {
            var parentId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
            return "".concat(_this.baseUrl, "v1/playlist/home-categories?Platform=1&ParentId=").concat(parentId, "&Level=").concat(level);
        };
        this.getHomeCategories = function() {
            var parentId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
            var ref = _this.httpClient.useGet(_this.getHomeCategoriesEndpoint(parentId, level), {
                headers: {
                    "Accept-Encoding": "gzip, deflate"
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.getPlaylistProductsEndpoint = function(param) {
            var playlistId = param.playlistId, branchId = param.branchId, _currentPage = param.currentPage, currentPage = _currentPage === void 0 ? "1" : _currentPage, _pageSize = param.pageSize, pageSize = _pageSize === void 0 ? "45" : _pageSize, category = param.category, brand = param.brand, model = param.model, attrAgg = param.attrAgg, sortBy = param.sortBy;
            var categoryQueryParam = category ? "&Category=".concat(category) : "";
            var brandQueryParam = brand ? "&Brand=".concat(brand) : "";
            var modelQueryParam = model ? "&Model=".concat(model) : "";
            var attrAggQueryParam = attrAgg ? "&AttrAgg=".concat(attrAgg) : "";
            var sortByQueryParam = sortBy ? "&SortBy=".concat(sortBy) : "";
            var branchIdValue = (0,utils/* formatBranchId */.f)(branchId);
            return "".concat(_this.baseUrl, "v1/playlist/home-category-products?PlaylistId=").concat(playlistId, "&BranchId=").concat(branchIdValue, "&PageIndex=").concat(currentPage, "&PageSize=").concat(pageSize).concat(categoryQueryParam).concat(brandQueryParam).concat(modelQueryParam).concat(attrAggQueryParam).concat(sortByQueryParam);
        };
        this.getPlaylistProducts = function(playlistProductsFIlter) {
            return fetch(_this.getPlaylistProductsEndpoint(playlistProductsFIlter), {
                headers: (0,_object_spread/* default */.Z)({}, http/* defaultHeaders */.B)
            }).then(function(response) {
                if ((response === null || response === void 0 ? void 0 : response.status) === 204 || (response === null || response === void 0 ? void 0 : response.status) === 404) {
                    return {
                        data: null,
                        error: "Nenhum produto foi retornado nessa playlist",
                        totalRows: 0
                    };
                }
                return response.json().then(function(responseJson) {
                    var jsonResponse = responseJson;
                    var data = (0,utils/* mapFilterProductsByPlaylistToSearchByTerm */.x$)(jsonResponse);
                    return {
                        data: data,
                        totalRows: Number(response.headers.get(headerPaginationTotalResultsStr)) || 0,
                        error: null
                    };
                }).catch(function(error) {
                    return {
                        data: null,
                        error: JSON.stringify(error),
                        totalRows: 0
                    };
                });
            }).catch(function(error) {
                _this.appMonitoringClient.captureException(error);
                return {
                    data: null,
                    error: JSON.stringify(error),
                    totalRows: 0
                };
            });
        };
        this.getPlaylistProductsByTypeAndUrlEndpoint = function(playlistType, playlistUrl, branchId, pageIndex) {
            var pageSize = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "45";
            var formattedBranchId = (0,utils/* formatBranchId */.f)(branchId);
            return "".concat(_this.baseUrl, "v1/playlist/").concat(playlistType, "/").concat(playlistUrl, "?branchId=").concat(formattedBranchId, "&pageIndex=").concat(pageIndex, "&PageSize=").concat(pageSize);
        };
        var _this1 = this;
        this.getPlaylistProductsByTypeAndUrl = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(playlistType, playlistUrl, branchId, pageIndex, pageSize) {
                var response, jsonResponse, data, _tmp, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                fetch(_this1.getPlaylistProductsByTypeAndUrlEndpoint(playlistType, playlistUrl, branchId, pageIndex, pageSize), {
                                    headers: (0,_object_spread/* default */.Z)({}, http/* defaultHeaders */.B)
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            if (response.status === 204 || response.status === 404) {
                                return [
                                    2,
                                    {
                                        data: null,
                                        error: "Nenhum produto foi retornado nessa playlist",
                                        totalRows: 0
                                    }
                                ];
                            }
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            jsonResponse = _state.sent();
                            data = (0,utils/* mapFilterProductsByPlaylistToSearchByTerm */.x$)(jsonResponse);
                            _tmp = {
                                data: data
                            };
                            return [
                                4,
                                response.headers.get(headerPaginationTotalResultsStr)
                            ];
                        case 3:
                            return [
                                2,
                                (_tmp.totalRows = Number.apply(void 0, [
                                    _state.sent()
                                ]) || 0, _tmp.error = null, _tmp)
                            ];
                        case 4:
                            err = _state.sent();
                            _this1.appMonitoringClient.captureException(err);
                            return [
                                2,
                                {
                                    data: null,
                                    error: JSON.stringify(err),
                                    totalRows: 0
                                }
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(playlistType, playlistUrl, branchId, pageIndex, pageSize) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getPlaylistProductsByTypeAndUrlFilterEndpoint = function(playlistType, playlistUrl, branchId, category, brand, model, attrAgg, pageIndex, sortBy) {
            var pageSize = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : "45";
            var categoryParam = category ? "&Category=".concat(category) : "";
            var brandParam = brand ? "&Brand=".concat(brand) : "";
            var modelParam = model ? "&Model=".concat(model) : "";
            var attrAggParam = attrAgg ? "&AttrAgg=".concat(attrAgg) : "";
            var sortByParam = sortBy ? "&SortBy=".concat(sortBy) : "";
            var formattedBranchId = (0,utils/* formatBranchId */.f)(branchId);
            return "".concat(_this.baseUrl, "v1/playlist/").concat(playlistType, "/").concat(playlistUrl, "?branchId=").concat(formattedBranchId).concat(categoryParam).concat(brandParam).concat(modelParam).concat(attrAggParam, "&PageIndex=").concat(pageIndex).concat(sortByParam, "&PageSize=").concat(pageSize);
        };
        var _this2 = this;
        this.getPlaylistProductsByTypeAndUrlFilter = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(playlistType, playlistUrl, branchId, category, brand, model, attrAgg, pageIndex, sortBy) {
                var pageSize, response, jsonResponse, data, _tmp, err;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            pageSize = _arguments.length > 9 && _arguments[9] !== void 0 ? _arguments[9] : "45";
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                fetch(_this2.getPlaylistProductsByTypeAndUrlFilterEndpoint(playlistType, playlistUrl, branchId, category, brand, model, attrAgg, pageIndex, sortBy, pageSize), {
                                    headers: (0,_object_spread/* default */.Z)({}, http/* defaultHeaders */.B)
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            jsonResponse = _state.sent();
                            data = (0,utils/* mapFilterProductsByPlaylistToSearchByTerm */.x$)(jsonResponse);
                            _tmp = {
                                data: data
                            };
                            return [
                                4,
                                response.headers.get(headerPaginationTotalResultsStr)
                            ];
                        case 4:
                            return [
                                2,
                                (_tmp.totalRows = _state.sent(), _tmp.isLoading = false, _tmp.error = null, _tmp)
                            ];
                        case 5:
                            err = _state.sent();
                            _this2.appMonitoringClient.captureException(err);
                            return [
                                2,
                                {
                                    data: [],
                                    totalRows: 0,
                                    isLoading: false,
                                    error: err
                                }
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(playlistType, playlistUrl, branchId, category, brand, model, attrAgg, pageIndex, sortBy) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getProductSpecsEndpoint = function(productId) {
            return "".concat(_this.baseUrl, "v1/products/").concat(productId, "/specs");
        };
        this.getProductSpecs = function(productId) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var ref = _this.httpClient.useGet(_this.getProductSpecsEndpoint(productId), {}, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getProductDimensionEndpoint = function(productId) {
            return "".concat(_this.baseUrl, "v1/products/").concat(productId, "/dimensions");
        };
        this.getProductDimension = function(productId) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var ref = _this.httpClient.useGet(_this.getProductDimensionEndpoint(productId), {}, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getProductUseLinksEndpoint = function(productId) {
            return "".concat(_this.baseUrl, "v1/products/").concat(productId, "/useful-links");
        };
        this.getProductUseLinks = function(productId) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var ref = _this.httpClient.useGet(_this.getProductUseLinksEndpoint(productId), {}, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getRelatedCategoryEndpoint = function(productId, branchId) {
            var formattedBranchId = (0,utils/* formatBranchId */.f)(branchId);
            return "".concat(_this.baseUrl, "v1/products/").concat(productId, "/related-category?BranchId=").concat(formattedBranchId);
        };
        this.getRelatedCategory = function(productId, branchId) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
            var ref = _this.httpClient.useGet(_this.getRelatedCategoryEndpoint(productId, branchId), {}, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getProductsListEndpoint = function(productIds, branchId) {
            var formattedBranchId = (0,utils/* formatBranchId */.f)(branchId);
            return "".concat(_this.baseUrl, "v1/products/list?productIds=").concat(productIds, "&branchId=").concat(formattedBranchId);
        };
        this.getProductList = function(productIds, branchId) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ref = _this.httpClient.useGet(_this.getProductsListEndpoint(productIds, branchId), {}, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        var _this3 = this;
        this.getProductListServerSide = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(categoryId, branchId) {
                var response, _tmp, error, errorMessage;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(_this3.getProductsListEndpoint(categoryId, branchId), {
                                    headers: (0,_object_spread/* default */.Z)({}, http/* defaultHeaders */.B)
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            _tmp = {};
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            return [
                                2,
                                (_tmp.data = _state.sent(), _tmp.isLoading = false, _tmp.error = null, _tmp)
                            ];
                        case 3:
                            error = _state.sent();
                            errorMessage = "Ocorreu um erro ao obter os dados da branchId: ".concat(branchId, " e os produtos de IDs: ").concat(categoryId, " n\xe3o foram preenchidos no transaction object para mapeamento da Insider.");
                            _this3.appMonitoringClient.captureMessage(errorMessage, {
                                level: "warning",
                                tags: {
                                    fcx_labs_event: "get_product_list",
                                    fcx_labs_error_source: "api"
                                }
                            });
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: error
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(categoryId, branchId) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getRelatedProductsEndpoint = function(productId, branchId, categoryId, pageIndex, pageSize) {
            var formattedBranchId = (0,utils/* formatBranchId */.f)(branchId);
            return "".concat(_this.baseUrl, "v1/products/").concat(productId, "/related-products?BranchId=").concat(formattedBranchId, "&CategoryId=").concat(categoryId, "&PageIndex=").concat(pageIndex, "&PageSize=").concat(pageSize);
        };
        this.getRelatedProducts = function(productId, branchId, categoryId, pageIndex, pageSize) {
            var condition = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true;
            var ref = _this.httpClient.useGet(_this.getRelatedProductsEndpoint(productId, branchId, categoryId, pageIndex, pageSize), {}, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getProductCardsEndpoint = function(branchId, productIdsList, pageIndex, pageSize, categoryId) {
            var productIdsListStr = "";
            (productIdsList || []).forEach(function(productId) {
                productIdsListStr += "&ProductsIdsList=".concat(productId);
            });
            var branchIdValue = (0,utils/* formatBranchId */.f)(branchId.toString());
            return "".concat(_this.baseUrl, "v1/products/cards?BranchId=").concat(branchIdValue).concat(pageIndex ? "&PageIndex=".concat(pageIndex) : "").concat(pageSize ? "&PageSize=".concat(pageSize) : "").concat(categoryId ? "&CategoryId=".concat(categoryId) : "").concat(productIdsListStr);
        };
        this.getProductCards = function(branchId, productIdsList, pageIndex, pageSize, categoryId) {
            var condition = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
            var ref = _this.httpClient.useGet(_this.getProductCardsEndpoint(branchId, productIdsList, pageIndex, pageSize, categoryId), {}, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getProductPricesEndpoint = function(productId) {
            var branchId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, packingLevel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, sellerId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
            var branchIdValue = (0,utils/* formatBranchId */.f)(branchId.toString());
            return "".concat(_this.baseUrl, "v1/products/").concat(productId, "/prices?BranchId=").concat(branchIdValue, "&PackingLevel=").concat(packingLevel, "&SellerId=").concat(sellerId);
        };
        this.getProductPrices = function(productId, branchId, packingLevel, sellerId) {
            var condition = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
            var ref = _this.httpClient.useGet(_this.getProductPricesEndpoint(productId, branchId, packingLevel, sellerId), {}, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getProductEndpoint = function(productId) {
            var branchId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
            var sanitizedProductId = String(productId).split(".")[0];
            var branchIdValue = (0,utils/* formatBranchId */.f)(branchId.toString());
            return "".concat(_this.baseUrl, "v1/products/id/").concat(sanitizedProductId, "?branchId=").concat(branchIdValue);
        };
        var _this4 = this;
        this.fetchProduct = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(productId, branchId) {
                var response, errorText, data, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                fetch(_this4.getProductEndpoint(productId, branchId), {
                                    headers: (0,_object_spread/* default */.Z)({}, http/* defaultHeaders */.B)
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            if (!!(response === null || response === void 0 ? void 0 : response.ok)) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                response.text()
                            ];
                        case 2:
                            errorText = _state.sent();
                            throw new Error(errorText);
                        case 3:
                            if ((response === null || response === void 0 ? void 0 : response.status) === 204) {
                                return [
                                    2,
                                    {
                                        data: null,
                                        isLoading: false,
                                        error: null
                                    }
                                ];
                            }
                            return [
                                4,
                                response.json()
                            ];
                        case 4:
                            data = _state.sent();
                            return [
                                2,
                                {
                                    data: data,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 5:
                            err = _state.sent();
                            _this4.appMonitoringClient.captureException(err, {
                                level: "error",
                                tags: {
                                    fcx_labs_event: "get_product",
                                    fcx_labs_error_source: "catalog_api"
                                }
                            });
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: err
                                }
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(productId, branchId) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getProduct = function(productId, branchId) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, fallbackData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined;
            var ref = _this.httpClient.useGet(_this.getProductEndpoint(productId, branchId), {}, condition, fallbackData), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getSuggestionsEndpoint = function(searchProduct, branchId) {
            var branchIdValue = (0,utils/* formatBranchId */.f)(branchId.toString());
            return "".concat(_this.baseUrlV2, "suggestion?term=").concat(searchProduct, "&branchId=").concat(branchIdValue);
        };
        this.getSuggestions = function(searchProduct, branchId) {
            var ref = _this.httpClient.useGet(_this.getSuggestionsEndpoint(searchProduct, branchId), undefined, !!searchProduct), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getProductsSearchByTermsTotalRowsEndpoint = function(branchId, term) {
            var formattedBranchId = (0,utils/* formatBranchId */.f)(branchId);
            return "".concat(_this.baseUrl, "v1/products/search?BranchId=").concat(formattedBranchId, "&SearchByTerm=").concat(term);
        };
        var _this5 = this;
        this.getProductsSearchByTermsTotalRows = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(branchId, term) {
                var ref, data, error, isLoading, response, _tmp, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (Catalog_process === null || Catalog_process === void 0 ? void 0 : true) {
                                ref = _this5.httpClient.useGet(_this5.getProductsSearchByTermsTotalRowsEndpoint(branchId, term), undefined, !!term), data = ref.data, error = ref.error, isLoading = ref.isLoading;
                                return [
                                    2,
                                    {
                                        data: data,
                                        isLoading: isLoading,
                                        error: error
                                    }
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                fetch(_this5.getProductsSearchByTermsTotalRowsEndpoint(branchId, term), {
                                    headers: (0,_object_spread/* default */.Z)({}, http/* defaultHeaders */.B)
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            _tmp = {};
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            return [
                                2,
                                (_tmp.data = _state.sent(), _tmp.isLoading = false, _tmp.error = null, _tmp)
                            ];
                        case 4:
                            err = _state.sent();
                            _this5.appMonitoringClient.captureException(err);
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: err
                                }
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(branchId, term) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getProductsSearchByTermsEndpoint = function(branchId, term, pageIndex) {
            var pageSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "45";
            var formattedBranchId = (0,utils/* formatBranchId */.f)(branchId);
            var paginationIndex = pageIndex || 1;
            return "".concat(_this.baseUrl, "v1/products/search?BranchId=").concat(formattedBranchId, "&SearchByTerm=").concat(term, "&PageIndex=").concat(paginationIndex, "&PageSize=").concat(pageSize);
        };
        this.getProductsSearchByTerm = function(branchId, term, pageIndex) {
            var condition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, fallbackData = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : undefined;
            var ref = _this.httpClient.useGet(_this.getProductsSearchByTermsEndpoint(branchId, term, pageIndex), {}, condition, fallbackData), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        var _this6 = this;
        this.getProductsSearchByTerms = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(branchId, term, pageIndex, pageSize) {
                var response, _tmp, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                fetch(_this6.getProductsSearchByTermsEndpoint(branchId, term, pageIndex, pageSize), {
                                    headers: (0,_object_spread/* default */.Z)({}, http/* defaultHeaders */.B)
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            if ((response === null || response === void 0 ? void 0 : response.status) === 500) {
                                _this6.appMonitoringClient.captureMessage('A requisi\xe7\xe3o "'.concat(_this6.getProductsSearchByTermsEndpoint(branchId, term, pageIndex), ' retornou erro 500"'), {
                                    level: "error",
                                    tags: {
                                        fcx_labs_error_source: "api"
                                    }
                                });
                                return [
                                    2,
                                    {
                                        data: null,
                                        totalRows: 0,
                                        isLoading: false
                                    }
                                ];
                            }
                            if ((response === null || response === void 0 ? void 0 : response.status) === 404) {
                                return [
                                    2,
                                    {
                                        data: null,
                                        totalRows: 0,
                                        isLoading: false
                                    }
                                ];
                            }
                            _tmp = {};
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            _tmp.data = _state.sent();
                            return [
                                4,
                                response.headers.get(headerPaginationTotalResultsStr)
                            ];
                        case 3:
                            return [
                                2,
                                (_tmp.totalRows = _state.sent(), _tmp.isLoading = false, _tmp.error = null, _tmp)
                            ];
                        case 4:
                            err = _state.sent();
                            _this6.appMonitoringClient.captureException(err);
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: err
                                }
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(branchId, term, pageIndex, pageSize) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getProductsSearchByTermsFilterEndpoint = function(branchId, term, category, brand, model, attrAgg, pageIndex, sortBy) {
            var pageSize = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "45";
            var attrAggParam = attrAgg ? "&AttrAgg=".concat(attrAgg) : "";
            var brandParam = brand ? "&Brand=".concat(encodeURIComponent(brand)) : "";
            var categoryParam = category ? "&Category=".concat(encodeURIComponent(category)) : "";
            var formattedBranchId = (0,utils/* formatBranchId */.f)(branchId);
            var modelParam = model ? "&Model=".concat(encodeURIComponent(model)) : "";
            var paginationIndex = pageIndex || 1;
            var sortByParam = sortBy ? "&SortBy=".concat(sortBy) : "";
            var termParam = term ? "".concat(encodeURIComponent(term)) : "";
            return "".concat(_this.baseUrl, "v1/products/search?BranchId=").concat(formattedBranchId, "&SearchByTerm=").concat(termParam).concat(categoryParam).concat(brandParam).concat(modelParam).concat(attrAggParam, "&PageIndex=").concat(paginationIndex).concat(sortByParam, "&PageSize=").concat(pageSize);
        };
        this.getProductsSearchByTermsFilter = function(branchId, term, category, brand, model, attrAgg, pageIndex, sortBy, pageSize) {
            var condition = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : true, fallbackData = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : undefined;
            var ref = _this.httpClient.useGet(_this.getProductsSearchByTermsFilterEndpoint(branchId, term, category, brand, model, attrAgg, pageIndex, sortBy, pageSize), undefined, condition, fallbackData), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getHighlightCategoriesEndpoint = function(branchId) {
            var formattedBranchId = (0,utils/* formatBranchId */.f)(branchId);
            return "".concat(_this.baseUrl, "v1/playlist/highlight-categories?branchId=").concat(formattedBranchId);
        };
        this.getHighlightCategories = function(branchId) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var ref = _this.httpClient.useGet(_this.getHighlightCategoriesEndpoint(branchId), {
                headers: {
                    "Accept-Encoding": "gzip, deflate"
                }
            }, !!condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.fetchSchemaEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/products/product-schema-by-id");
        };
        var _this7 = this;
        this.fetchSchema = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(productData) {
                var response, errorText, schema, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                fetch(_this7.fetchSchemaEndpoint(), {
                                    headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, http/* defaultHeaders */.B), {
                                        "Content-Type": "application/json"
                                    }),
                                    method: "POST",
                                    body: JSON.stringify((0,_object_spread/* default */.Z)({}, productData))
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            if (!!(response === null || response === void 0 ? void 0 : response.ok)) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                response.text()
                            ];
                        case 2:
                            errorText = _state.sent();
                            throw new Error(errorText);
                        case 3:
                            if ((response === null || response === void 0 ? void 0 : response.status) === 204) {
                                return [
                                    2,
                                    {
                                        data: null,
                                        isLoading: false,
                                        error: null
                                    }
                                ];
                            }
                            return [
                                4,
                                response.json()
                            ];
                        case 4:
                            schema = _state.sent();
                            return [
                                2,
                                {
                                    data: schema,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 5:
                            err = _state.sent();
                            _this7.appMonitoringClient.captureException(err, {
                                level: "error",
                                tags: {
                                    fcx_labs_event: "fetch_schema",
                                    fcx_labs_error_source: "product_api"
                                }
                            });
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: err
                                }
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(productData) {
                return _ref.apply(this, arguments);
            };
        }();
        if (!this.baseUrl || !this.baseUrlV2) {
            var ref = this.envsApi.getRawEnvImmediately("APIS_BASE_URL"), apisBaseUrl = ref.data;
            var fallback = (0,utils/* getApisUrlFallback */.TW)(Catalog_process.env.HOST_ENV);
            this.baseUrl = "".concat(apisBaseUrl || fallback, "catalog/");
            this.baseUrlV2 = "".concat(apisBaseUrl || fallback, "bff-site/catalog/");
        }
        this.appMonitoringClient = appMonitoringClient;
    }
    var _proto = CatalogApi.prototype;
    _proto.setBaseUrl = function setBaseUrl(url) {
        this.baseUrl = url;
    };
    return CatalogApi;
}();

// EXTERNAL MODULE: ../../packages/application/services/apis/Envs/index.ts
var Envs = __webpack_require__(32817);
;// CONCATENATED MODULE: ../../packages/application/services/apis/Shipping/index.ts
/* provided dependency */ var Shipping_process = __webpack_require__(34406);


var ShippingApi = /*#__PURE__*/ function() {
    "use strict";
    function ShippingApi(httpClient, envsApi) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, ShippingApi);
        this.httpClient = httpClient;
        this.envsApi = envsApi;
        this.baseUrl = "";
        this.getZipCodeAvailabilityEndpoint = function(productId, productQuantity, packingLevel, zipCode, branchId, sellerId) {
            var formattedBranchId = (0,utils/* formatBranchId */.f)(branchId);
            var sellerVerification = sellerId ? "&SellerId=".concat(sellerId) : "";
            var branchIdVerification = branchId ? "&BranchId=".concat(formattedBranchId) : "";
            return "".concat(_this.baseUrl, "v1/options?ProductId=").concat(productId, "&Quantity=").concat(productQuantity, "&Package=").concat(packingLevel, "&ZipCode=").concat(zipCode).concat(sellerVerification).concat(branchIdVerification);
        };
        this.getZipCodeAvailability = function(productId, productQuantity, packingLevel, zipCode, branchId, sellerId, condition) {
            var ref = _this.httpClient.useGet(_this.getZipCodeAvailabilityEndpoint(productId, productQuantity, packingLevel, zipCode, branchId, sellerId), undefined, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getAddressByCityEndpoint = function(city) {
            var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
            return "".concat(_this.baseUrl, "v1/address/city?city=").concat(city, "&size=").concat(size);
        };
        this.getAddressByCity = function(city, size, condition) {
            var ref = _this.httpClient.useGet(_this.getAddressByCityEndpoint(city, size), {}, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getAddressByZipCodeEndpoint = function(zipCode) {
            return "".concat(_this.baseUrl, "v1/address?zipCode=").concat(zipCode);
        };
        this.getAddressByZipCode = function(zipCode, condition) {
            var ref = _this.httpClient.useGet(_this.getAddressByZipCodeEndpoint(zipCode === null || zipCode === void 0 ? void 0 : zipCode.replace("-", "")), {}, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getCartOptionsEndpoint = function(cartId, zipCode) {
            return "".concat(_this.baseUrl, "v1/options/cart-options?CartId=").concat(cartId, "&ZipCode=").concat(zipCode);
        };
        this.getCartOptions = function(jwt, cartId, zipCode) {
            var condition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, cartOptions = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : undefined;
            var ref = _this.httpClient.useGet(_this.getCartOptionsEndpoint(cartId, zipCode), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }, condition, cartOptions), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.getOptionsEndpoint = function(param) {
            var productId = param.productId, quantity = param.quantity, pricePackage = param.pricePackage, zipCode = param.zipCode, branchId = param.branchId, sellerId = param.sellerId;
            var branchIdQueryParam = branchId ? "&BranchId=".concat((0,utils/* formatBranchId */.f)(branchId.toString())) : "";
            return "".concat(_this.baseUrl, "v1/options?ProductId=").concat(productId, "&Quantity=").concat(quantity, "&Package=").concat(pricePackage, "&ZipCode=").concat(zipCode, "&SellerId=").concat(sellerId).concat(branchIdQueryParam);
        };
        this.getOptions = function(param) {
            var productId = param.productId, quantity = param.quantity, pricePackage = param.pricePackage, zipCode = param.zipCode, branchId = param.branchId, sellerId = param.sellerId, condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var ref = _this.httpClient.useGet(_this.getOptionsEndpoint({
                productId: productId,
                quantity: quantity,
                pricePackage: pricePackage,
                zipCode: zipCode,
                branchId: branchId,
                sellerId: sellerId
            }), {}, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getBranchesEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/branch/branches");
        };
        this.getBranches = function() {
            var ref = _this.httpClient.useGet(_this.getBranchesEndpoint(), undefined), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getBranchIdByZipCodeEndpoint = function(zipCode) {
            return "".concat(_this.baseUrl, "v1/branch?cep=").concat(zipCode);
        };
        this.getBranchIdByZipCode = function(zipCode) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var ref = _this.httpClient.useGet(_this.getBranchIdByZipCodeEndpoint(zipCode), undefined, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getDistrictsEndPoint = function() {
            return "".concat(_this.baseUrl, "v1/address/states");
        };
        this.getDistricts = function() {
            var ref = _this.httpClient.useGet(_this.getDistrictsEndPoint()), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getMetropolisEndpoint = function(acronym) {
            return "".concat(_this.baseUrl, "v1/address/districts/").concat(acronym);
        };
        this.getMetropolis = function(acronym) {
            var ref = _this.httpClient.useGet(_this.getMetropolisEndpoint(acronym)), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        if (!this.baseUrl) {
            var ref = this.envsApi.getRawEnvImmediately("APIS_BASE_URL"), apisBaseUrl = ref.data;
            var fallback = (0,utils/* getApisUrlFallback */.TW)(Shipping_process.env.HOST_ENV);
            this.baseUrl = "".concat(apisBaseUrl || fallback, "shipping/");
        }
    }
    var _proto = ShippingApi.prototype;
    _proto.setBaseUrl = function setBaseUrl(url) {
        this.baseUrl = url;
    };
    return ShippingApi;
}();

// EXTERNAL MODULE: ../../node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(90162);
;// CONCATENATED MODULE: ../../packages/application/services/apis/Identity/index.ts
/* provided dependency */ var Identity_process = __webpack_require__(34406);





var contentType = "application/json";
var IdentityApi = /*#__PURE__*/ function() {
    "use strict";
    function IdentityApi(httpClient, appMonitoringClient, gtag, envsApi) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, IdentityApi);
        this.httpClient = httpClient;
        this.appMonitoringClient = appMonitoringClient;
        this.gtag = gtag;
        this.envsApi = envsApi;
        this.baseUrl = "";
        this.baseUrlV2 = "";
        this.middlewareBaseUrl = "/api/identity/";
        this.siteUrl = "";
        this.verifyClientEndpoint = function() {
            return "".concat(_this.baseUrl, "connect/token");
        };
        var _this1 = this;
        this.verifyClient = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
                var e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this1.httpClient.usePost(_this1.verifyClientEndpoint(), body)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            e = _state.sent();
                            return [
                                2,
                                null
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(body) {
                return _ref.apply(this, arguments);
            };
        }();
        this.changePasswordEndpoint = function() {
            return "".concat(_this.baseUrl, "api/ecommerce-users/change-password");
        };
        this.defaultError = "Ocorreu um erro inesperado, tente novamente";
        this.changePasswordMappedErrors = function(status) {
            return ({
                "400": "A senha que voc\xea informou n\xe3o \xe9 a mesma da sua conta. Por favor, digite sua senha atual.",
                "500": _this.defaultError
            })["".concat(status)] || _this.defaultError;
        };
        var _this2 = this;
        this.changePassword = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(accessToken, param) {
                var email, currentPassword, newPassword, ref, response, responseStatus, error, err, error1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            email = param.email, currentPassword = param.currentPassword, newPassword = param.newPassword;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this2.httpClient.usePost("".concat(_this2.changePasswordEndpoint()), {
                                    email: email,
                                    currentPassword: currentPassword,
                                    newPassword: newPassword
                                }, {
                                    headers: {
                                        Authorization: "Bearer ".concat(accessToken),
                                        "Content-Type": contentType
                                    }
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            responseStatus = response === null || response === void 0 ? void 0 : (ref = response.status) === null || ref === void 0 ? void 0 : ref.toString();
                            if (responseStatus) {
                                error = _this2.changePasswordMappedErrors(responseStatus);
                                return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                            }
                            return [
                                2,
                                {
                                    data: response,
                                    error: null
                                }
                            ];
                        case 3:
                            err = _state.sent();
                            error1 = (0,utils/* isObjectEmpty */.nK)(err) ? null : JSON.stringify(err);
                            return [
                                2,
                                {
                                    data: null,
                                    error: error1
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(accessToken, _) {
                return _ref.apply(this, arguments);
            };
        }();
        this.sendEmailConfirmationEndpoint = function(emailAddress) {
            return "".concat(_this.baseUrl, "api/ecommerce-users/resend-email-confirmation/").concat(emailAddress);
        };
        var _this3 = this;
        this.sendEmailConfirmation = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(emailAddress) {
                var response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this3.httpClient.usePost("".concat(_this3.sendEmailConfirmationEndpoint(emailAddress)), {}, {})
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                {
                                    data: response,
                                    error: null
                                }
                            ];
                        case 2:
                            error = _state.sent();
                            _this3.appMonitoringClient.captureException(error, {
                                level: "error",
                                tags: {
                                    fcx_labs_error_source: "identity_api"
                                }
                            });
                            return [
                                2,
                                {
                                    data: null,
                                    error: error
                                }
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(emailAddress) {
                return _ref.apply(this, arguments);
            };
        }();
        this.emailConfirmationEndpoint = function(emailAddress, tokenFromUrl) {
            return "".concat(_this.baseUrl, "api/ecommerce-users/email-confirmation/").concat(emailAddress, "/").concat(tokenFromUrl);
        };
        var _this4 = this;
        this.emailConfirmation = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(emailAddress, tokenFromUrl) {
                var response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(_this4.emailConfirmationEndpoint(emailAddress, tokenFromUrl), {
                                    method: "POST"
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response === null || response === void 0 ? void 0 : response.ok
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            error = _state.sent();
                            _this4.appMonitoringClient.captureException(error, {
                                level: "error",
                                tags: {
                                    fcx_labs_error_source: "identity_api"
                                }
                            });
                            return [
                                2,
                                null
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(emailAddress, tokenFromUrl) {
                return _ref.apply(this, arguments);
            };
        }();
        this.receiveConfirmationTypesEndpoint = function() {
            return "".concat(_this.baseUrl, "api/ecommerce-users/receive-confirmation-types");
        };
        var _this5 = this;
        this.receiveConfirmationTypes = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var email, cpf, jwt, response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            email = param.email, cpf = param.cpf, jwt = param.jwt;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this5.httpClient.usePost("".concat(_this5.receiveConfirmationTypesEndpoint()), {
                                    email: email,
                                    cpf: cpf
                                }, {
                                    headers: {
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            return [
                                2,
                                {
                                    data: response,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 3:
                            error = _state.sent();
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: error
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        this.receiveConfirmationTypesPublicEndpoint = function() {
            return "".concat(_this.baseUrl, "api/ecommerce-users/public/receive-confirmation-types");
        };
        this.recoverAccountEndpoint = function() {
            return "".concat(_this.middlewareBaseUrl, "recover-account");
        };
        var _this6 = this;
        this.updatePassword = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var token, faType, email, phoneNumber, cpf, channel, oldPassword, newPassword, jwt, location, response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            token = param.token, faType = param.faType, email = param.email, phoneNumber = param.phoneNumber, cpf = param.cpf, channel = param.channel, oldPassword = param.oldPassword, newPassword = param.newPassword, jwt = param.jwt, location = param.location;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this6.httpClient.usePost("".concat(_this6.siteUrl, "api/profile/change-password"), {
                                    token: token,
                                    faType: faType,
                                    email: email,
                                    phoneNumber: phoneNumber,
                                    cpf: cpf,
                                    channel: channel,
                                    oldPassword: oldPassword,
                                    newPassword: newPassword,
                                    location: location
                                }, {
                                    headers: {
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            if (String(response === null || response === void 0 ? void 0 : response.status).startsWith("5")) {
                                throw new Error("Houve um erro ao atualizar senha");
                            }
                            return [
                                2,
                                {
                                    data: response
                                }
                            ];
                        case 3:
                            error = _state.sent();
                            _this6.appMonitoringClient.captureException(error, {
                                level: "error",
                                tags: {
                                    fcx_labs_error_source: "identity_api"
                                }
                            });
                            return [
                                2,
                                {
                                    data: null,
                                    error: error,
                                    isLoading: false
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getSessionEndpoint = function() {
            return "".concat(_this.baseUrl, "api/sessions");
        };
        var _this7 = this;
        this.fetchSessionData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jwt) {
                var response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(_this7.getSessionEndpoint(), {
                                    headers: {
                                        Authorization: "Bearer ".concat(jwt),
                                        "Content-Type": contentType
                                    }
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            error = _state.sent();
                            _this7.appMonitoringClient.captureException(error, {
                                level: "error",
                                tags: {
                                    fcx_labs_error_source: "identity_api"
                                }
                            });
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2,
                                null
                            ];
                    }
                });
            });
            return function(jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.handleSetAttributes();
        this.appMonitoringClient = appMonitoringClient;
        axios/* default.interceptors.response.use */.Z.interceptors.response.use(function(response) {
            return response;
        }, function(error) {
            var ref;
            var errorStatus = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status;
            if (errorStatus && errorStatus !== 400) {
                appMonitoringClient.captureException(error || _this.defaultError, {
                    level: "error",
                    tags: {
                        fcx_labs_error_source: "identity_api"
                    }
                });
            }
            return Promise.reject(error);
        });
    }
    var _proto = IdentityApi.prototype;
    _proto.setBaseUrl = function setBaseUrl(url) {
        this.baseUrl = url;
    };
    _proto.handleSetAttributes = function handleSetAttributes() {
        var ref = this.envsApi.getRawEnvImmediately("APIS_BASE_URL"), apisBaseUrl = ref.data;
        var ref1 = this.envsApi.getRawEnvImmediately("IDENTITY_BASE_URL"), identityBaseUrl = ref1.data;
        var fallback = (0,utils/* getApisUrlFallback */.TW)(Identity_process.env.HOST_ENV);
        this.baseUrl = identityBaseUrl || "".concat(apisBaseUrl || fallback, "identity/");
        this.baseUrlV2 = "".concat(apisBaseUrl || fallback, "bff-site/identity/");
    };
    _proto.getToken = function getToken(param, jwtDecoder) {
        var login = param.login, password = param.password, _cookieIdCart = param.cookieIdCart, cookieIdCart = _cookieIdCart === void 0 ? "" : _cookieIdCart, location = param.location;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, response, ref2, tmp, profileId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.httpClient.usePost("".concat(_this.middlewareBaseUrl, "login"), {
                                login: login,
                                password: password,
                                cookieIdCart: cookieIdCart,
                                location: location
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.access_token) {
                            ref2 = jwtDecoder.decode(response.data.access_token), tmp = ref2.profile_id, profileId = tmp === void 0 ? "" : tmp;
                            _this.gtag.login("password", profileId);
                        }
                        if (response === null || response === void 0 ? void 0 : (ref1 = response.errors) === null || ref1 === void 0 ? void 0 : ref1.Messages) {
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2,
                            (response === null || response === void 0 ? void 0 : response.data) || null
                        ];
                }
            });
        })();
    };
    _proto.refreshToken = function refreshToken(refreshToken1) {
        var response = this.httpClient.usePost("".concat(this.middlewareBaseUrl, "token/refresh"), {
            refreshToken: refreshToken1
        });
        return response;
    };
    _proto.getTokenOAuth = function getTokenOAuth(param, jwtDecoder) {
        var idToken = param.idToken, provider = param.provider, cookieIdCart = param.cookieIdCart, location = param.location;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var response, successData, ref, tmp, profileId, invalidUserData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.httpClient.usePost("".concat(_this.middlewareBaseUrl, "login/social"), {
                                idToken: idToken,
                                provider: provider,
                                cookieIdCart: cookieIdCart,
                                location: location
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        successData = response === null || response === void 0 ? void 0 : response.data;
                        if (successData === null || successData === void 0 ? void 0 : successData.access_token) {
                            ref = jwtDecoder.decode(successData.access_token), tmp = ref.profile_id, profileId = tmp === void 0 ? "" : tmp;
                            _this.gtag.login("".concat(provider), profileId);
                            return [
                                2,
                                successData
                            ];
                        }
                        invalidUserData = response === null || response === void 0 ? void 0 : response.data;
                        if ((invalidUserData === null || invalidUserData === void 0 ? void 0 : invalidUserData.error) === "invalid_grant") {
                            return [
                                2,
                                invalidUserData.error
                            ];
                        }
                        return [
                            2,
                            null
                        ];
                }
            });
        })();
    };
    _proto.resetPassword = function resetPassword(data) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* default.post */.Z.post("".concat(_this.baseUrl, "api/ecommerce-users/reset-password"), data)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.recoverPassword = function recoverPassword(email) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            axios/* default.post */.Z.post("".concat(_this.baseUrl, "api/ecommerce-users/reset-password/").concat(email))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            ""
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.receiveConfirmationTypesPublic = function receiveConfirmationTypesPublic(param) {
        var email = param.email, cpf = param.cpf;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePost("".concat(_this.receiveConfirmationTypesPublicEndpoint()), {
                                email: email,
                                cpf: cpf
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (String(response === null || response === void 0 ? void 0 : response.status).startsWith("5")) {
                            throw new Error("Houve um erro ao tentar verificar a sua conta.");
                        }
                        if (String(response === null || response === void 0 ? void 0 : response.status).startsWith("4")) {
                            throw new Error("Conta inexistente, por favor insira um ".concat(email ? "email" : cpf ? "cpf" : "email ou cpf", " de uma conta existente."));
                        }
                        return [
                            2,
                            {
                                data: response,
                                error: null,
                                isLoading: false
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error, {
                            level: "error",
                            tags: {
                                fcx_labs_error_source: "identity_api"
                            }
                        });
                        return [
                            2,
                            {
                                data: null,
                                error: {
                                    isValid: false,
                                    errors: {
                                        Messages: [
                                            error.message
                                        ]
                                    }
                                },
                                isLoading: false
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.recoverAccount = function recoverAccount(param) {
        var email = param.email, cpf = param.cpf, phoneNumber = param.phoneNumber, newPassword = param.newPassword, token = param.token, faType = param.faType, channel = param.channel, _saleChannel = param.saleChannel, saleChannel = _saleChannel === void 0 ? "2" : _saleChannel, location = param.location;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePost("".concat(_this.recoverAccountEndpoint()), {
                                email: email,
                                cpf: cpf,
                                phoneNumber: phoneNumber,
                                newPassword: newPassword,
                                token: token,
                                faType: faType,
                                channel: channel,
                                saleChannel: saleChannel,
                                location: location
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            {
                                data: response,
                                error: null,
                                isLoading: false
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error, {
                            level: "error",
                            tags: {
                                fcx_labs_error_source: "identity_api"
                            }
                        });
                        return [
                            2,
                            {
                                data: null,
                                error: error,
                                isLoading: false
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.disconnectAllSessions = function disconnectAllSessions(jwt) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            fetch("".concat(_this.baseUrl, "api/sessions/logout-all-devices"), {
                                headers: {
                                    Authorization: "Bearer ".concat(jwt),
                                    "Content-Type": contentType
                                },
                                method: "DELETE"
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.status === 204) {
                            return [
                                2,
                                true
                            ];
                        }
                        throw new Error("Failed to delete all session. HTTP status: ".concat(response.status));
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error, {
                            level: "error",
                            tags: {
                                fcx_labs_error_source: "identity_api"
                            }
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            false
                        ];
                }
            });
        })();
    };
    _proto.disconnectSession = function disconnectSession(refreshToken) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.httpClient.usePost("".concat(_this.middlewareBaseUrl, "logout"), {
                                refreshToken: refreshToken
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                            return [
                                2,
                                {
                                    success: true,
                                    message: null
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                success: false,
                                message: (response === null || response === void 0 ? void 0 : (ref = response.errors) === null || ref === void 0 ? void 0 : (ref1 = ref.message) === null || ref1 === void 0 ? void 0 : ref1[0]) || ""
                            }
                        ];
                }
            });
        })();
    };
    _proto.deleteSession = function deleteSession(jwt, sessionId) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            fetch("".concat(_this.baseUrl, "api/sessions/logout-device?sessionId=").concat(sessionId), {
                                headers: {
                                    Authorization: "Bearer ".concat(jwt),
                                    "Content-Type": contentType
                                },
                                method: "DELETE"
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.status === 204) {
                            return [
                                2,
                                true
                            ];
                        }
                        throw new Error("Failed to delete session. HTTP status: ".concat(response.status));
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error, {
                            level: "error",
                            tags: {
                                fcx_labs_error_source: "identity_api"
                            }
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            false
                        ];
                }
            });
        })();
    };
    return IdentityApi;
}();


;// CONCATENATED MODULE: ../../packages/application/services/apis/Profile/index.ts
/* provided dependency */ var Profile_process = __webpack_require__(34406);
/* eslint-disable class-methods-use-this */ 



var Profile_contentType = "application/json-patch+json";
var accept = "application/json";
var ProfileApi = /*#__PURE__*/ function() {
    "use strict";
    function ProfileApi(httpClient, appMonitoringClient, gtag, envsApi) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, ProfileApi);
        this.httpClient = httpClient;
        this.appMonitoringClient = appMonitoringClient;
        this.gtag = gtag;
        this.envsApi = envsApi;
        this.baseUrl = "";
        this.baseUrlV2 = "";
        this.middlewareBaseUrl = "/api/profile/";
        this.defaultError = "Ocorreu um erro inesperado, tente novamente";
        this.// eslint-disable-next-line class-methods-use-this
        serverClientsEndpoint = function() {
            return "/api/clients";
        };
        this.postBFFClientsEndpoint = function() {
            return "".concat(_this.baseUrlV2, "create-client");
        };
        var _this1 = this;
        this.createClient = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(body, provider) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    try {
                        _this1.gtag.signUp(provider);
                        return [
                            2,
                            _this1.httpClient.usePost(_this1.serverClientsEndpoint(), body)
                        ];
                    } catch (error) {
                        _this1.appMonitoringClient.captureException(error);
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2
                    ];
                });
            });
            return function(body, provider) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = this;
        this.createBFFClient = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(body, provider) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    try {
                        _this2.gtag.signUp(provider);
                        return [
                            2,
                            _this2.httpClient.usePost("".concat(_this2.middlewareBaseUrl, "create-client"), body)
                        ];
                    } catch (error) {
                        _this2.appMonitoringClient.captureException(error);
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2
                    ];
                });
            });
            return function(body, provider) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getClientEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/clients");
        };
        this.getClient = function(accessToken) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var ref = _this.httpClient.useGet(_this.getClientEndpoint(), {
                headers: {
                    Authorization: "Bearer ".concat(accessToken)
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        var _this3 = this;
        this.fetchClient = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(accessToken) {
                var response, data, err, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(_this3.getClientEndpoint(), {
                                    headers: {
                                        Authorization: "Bearer ".concat(accessToken)
                                    }
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            return [
                                2,
                                {
                                    data: data,
                                    error: null
                                }
                            ];
                        case 3:
                            err = _state.sent();
                            error = (0,utils/* isObjectEmpty */.nK)(err) ? null : JSON.stringify(err);
                            _this3.appMonitoringClient.captureException(error !== null && error !== void 0 ? error : _this3.defaultError);
                            return [
                                2,
                                {
                                    data: null,
                                    error: error
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(accessToken) {
                return _ref.apply(this, arguments);
            };
        }();
        this.changeUserDataEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/clients");
        };
        this.// eslint-disable-next-line class-methods-use-this
        constructChangePhoneBody = function(newPhoneNumber) {
            var phoneBody = {
                op: "replace",
                path: "/PhoneNumber",
                value: newPhoneNumber
            };
            return [
                phoneBody
            ];
        };
        this.// eslint-disable-next-line class-methods-use-this
        constructChangeNameBody = function(newName) {
            var nameBody = {
                op: "replace",
                path: "/Name",
                value: newName
            };
            return [
                nameBody
            ];
        };
        this.changePhoneMappedErrors = function(status) {
            return ({
                "400": _this.defaultError,
                "500": _this.defaultError
            })["".concat(status)] || _this.defaultError;
        };
        var _this4 = this;
        this.changePhone = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(accessToken, changePhoneDto) {
                var ref, newPhoneNumber, response, responseStatus, error, err, error1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            newPhoneNumber = changePhoneDto.newPhoneNumber;
                            return [
                                4,
                                _this4.httpClient.usePatch("".concat(_this4.changeUserDataEndpoint()), {
                                    accept: accept,
                                    Authorization: "Bearer ".concat(accessToken),
                                    "Content-Type": Profile_contentType
                                }, _this4.constructChangePhoneBody(newPhoneNumber))
                            ];
                        case 1:
                            response = _state.sent();
                            responseStatus = response === null || response === void 0 ? void 0 : (ref = response.status) === null || ref === void 0 ? void 0 : ref.toString();
                            if (responseStatus) {
                                error = _this4.changePhoneMappedErrors(responseStatus);
                                return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                            }
                            return [
                                2,
                                {
                                    data: response,
                                    error: null
                                }
                            ];
                        case 2:
                            err = _state.sent();
                            error1 = (0,utils/* isObjectEmpty */.nK)(err) ? null : JSON.stringify(err);
                            _this4.appMonitoringClient.captureException(error1 !== null && error1 !== void 0 ? error1 : _this4.defaultError);
                            return [
                                2,
                                {
                                    data: null,
                                    error: error1
                                }
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(accessToken, changePhoneDto) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this5 = this;
        this.changeName = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(accessToken, newName) {
                var response, err, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this5.httpClient.usePatch("".concat(_this5.changeUserDataEndpoint()), {
                                    accept: accept,
                                    Authorization: "Bearer ".concat(accessToken),
                                    "Content-Type": Profile_contentType
                                }, _this5.constructChangeNameBody(newName))
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                {
                                    data: response,
                                    error: null
                                }
                            ];
                        case 2:
                            err = _state.sent();
                            error = (0,utils/* isObjectEmpty */.nK)(err) ? null : JSON.stringify(err);
                            _this5.appMonitoringClient.captureException(error !== null && error !== void 0 ? error : _this5.defaultError);
                            return [
                                2,
                                {
                                    data: null,
                                    error: error
                                }
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(accessToken, newName) {
                return _ref.apply(this, arguments);
            };
        }();
        this.clientsAddressEndpoint = function(pageSize) {
            return "".concat(_this.baseUrl, "v1/addresses").concat(pageSize ? "?PageSize=".concat(pageSize) : "");
        };
        this.getAllAddresses = function(jwt) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var ref = _this.httpClient.useGet(_this.clientsAddressEndpoint(30), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            return {
                data: data,
                error: error,
                isLoading: isLoading,
                trigger: trigger
            };
        };
        var _this6 = this;
        this.// private createClientMappedErrors = (status: string) => {
        //   return (
        //     {
        //       "400": this.defaultError,
        //       "500": this.defaultError,
        //     }[`${status}`] || this.defaultError
        //   );
        // };
        createClientAddress = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(body, jwt) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this6.httpClient.usePost("/api/clients/addresses", body, {
                                    headers: {
                                        "Content-Type": accept,
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this6.appMonitoringClient.captureException(error);
                            return [
                                2,
                                error
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(body, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.deleteClientAddressEndPoint = function(clientAddresses) {
            return "".concat(_this.baseUrl, "v1/addresses/").concat(clientAddresses);
        };
        var _this7 = this;
        this.deleteClientAddresses = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jwt, clientAddresses, body) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this7.httpClient.useDelete(_this7.deleteClientAddressEndPoint(clientAddresses), {
                                    Authorization: "Bearer ".concat(jwt)
                                }, body)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this7.appMonitoringClient.captureException(error);
                            return [
                                2,
                                null
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(jwt, clientAddresses, body) {
                return _ref.apply(this, arguments);
            };
        }();
        this.editClientAddressEndPoint = function(clientAddresses) {
            return "".concat(_this.baseUrl, "v1/addresses/").concat(clientAddresses);
        };
        var _this8 = this;
        this.editClientAddresses = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jwt, clientAddressId, body) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this8.httpClient.usePatch(_this8.editClientAddressEndPoint(clientAddressId), {
                                    "Content-Type": Profile_contentType,
                                    Authorization: "Bearer ".concat(jwt)
                                }, body)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this8.appMonitoringClient.captureException(error);
                            return [
                                2,
                                null
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(jwt, clientAddressId, body) {
                return _ref.apply(this, arguments);
            };
        }();
        this.changePasswordEndpoint = function() {
            return "/api/profile/change-password";
        };
        var _this9 = this;
        this.changePassword = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var email, cpf, faType, channel, jwt, token, phoneNumber, oldPassword, newPassword, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            email = param.email, cpf = param.cpf, faType = param.faType, channel = param.channel, jwt = param.jwt, token = param.token, phoneNumber = param.phoneNumber, oldPassword = param.oldPassword, newPassword = param.newPassword;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this9.httpClient.usePost(_this9.changePasswordEndpoint(), {
                                    email: email,
                                    cpf: cpf,
                                    faType: faType,
                                    channel: channel,
                                    token: token,
                                    phoneNumber: phoneNumber,
                                    oldPassword: oldPassword,
                                    newPassword: newPassword
                                }, {
                                    headers: {
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            error = _state.sent();
                            _this9.appMonitoringClient.captureException(error);
                            return [
                                2,
                                error
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        this.editDataEndpoint = function() {
            return "/api/profile/update-data";
        };
        var _this10 = this;
        this.editData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(body, jwt) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this10.httpClient.usePost("/api/profile/update-data", body, {
                                    headers: {
                                        "Content-Type": accept,
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this10.appMonitoringClient.captureException(error);
                            return [
                                2,
                                error
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(body, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.passwordChangeDuePurchaseTimeEndpoint = function(identifier) {
            return "".concat(_this.baseUrl, "v1/clients/password-change-due-purchase-time?identifier=").concat(identifier);
        };
        var _this11 = this;
        this.passwordChangeDuePurchaseTime = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(identifier) {
                var response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch("".concat(_this11.passwordChangeDuePurchaseTimeEndpoint(identifier)))
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            error = _state.sent();
                            _this11.appMonitoringClient.captureException(error);
                            return [
                                2,
                                error
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(identifier) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this12 = this;
        this.deleteAccount = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var body, jwt, response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            body = param.body, jwt = param.jwt;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this12.httpClient.useDelete(_this12.serverClientsEndpoint(), {
                                    Authorization: "Bearer ".concat(jwt)
                                }, body)
                            ];
                        case 2:
                            response = _state.sent();
                            return [
                                2,
                                {
                                    data: response === null || response === void 0 ? void 0 : response.data,
                                    error: null,
                                    statusCode: response.statusCode
                                }
                            ];
                        case 3:
                            error = _state.sent();
                            _this12.appMonitoringClient.captureException(error);
                            return [
                                2,
                                {
                                    data: null,
                                    error: error
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        if (!this.baseUrl) {
            var ref = this.envsApi.getRawEnvImmediately("APIS_BASE_URL"), apisBaseUrl = ref.data;
            var fallback = (0,utils/* getApisUrlFallback */.TW)(Profile_process.env.HOST_ENV);
            this.baseUrl = "".concat(apisBaseUrl || fallback, "profile/");
            this.baseUrlV2 = "".concat(apisBaseUrl || fallback, "bff-site/profile/");
        }
        this.appMonitoringClient = appMonitoringClient;
    }
    var _proto = ProfileApi.prototype;
    _proto.setBaseUrl = function setBaseUrl(url) {
        this.baseUrl = url;
    };
    return ProfileApi;
}();


;// CONCATENATED MODULE: ../../packages/application/services/apis/SupportContact/index.ts



var SupportContactApi = /*#__PURE__*/ function() {
    "use strict";
    function SupportContactApi(httpClient) {
        (0,_class_call_check/* default */.Z)(this, SupportContactApi);
        this.httpClient = httpClient;
        this.baseUrl = "";
        var _this = this;
        this.getOptions = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.httpClient.useGet("/support-contact/options")
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            {
                                data: response.data,
                                isLoading: false,
                                error: false
                            }
                        ];
                }
            });
        });
        this.httpClient = httpClient;
    }
    var _proto = SupportContactApi.prototype;
    _proto.setBaseUrl = function setBaseUrl(url) {
        this.baseUrl = url;
    };
    return SupportContactApi;
}();


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ../../packages/application/services/apis/UtilInfo/index.ts
/* provided dependency */ var UtilInfo_process = __webpack_require__(34406);





var UtilInfoApi = /*#__PURE__*/ function() {
    "use strict";
    function UtilInfoApi(httpClient, envsApi) {
        (0,_class_call_check/* default */.Z)(this, UtilInfoApi);
        this.httpClient = httpClient;
        this.envsApi = envsApi;
        this.baseUrl = "";
        var _this = this;
        this.getPaymentOptions = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.httpClient.useGet("/util-info/payment-options")
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            {
                                data: response.data,
                                isLoading: false,
                                error: false
                            }
                        ];
                }
            });
        });
        var _this1 = this;
        this.getLinkOptions = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(isBranchJPA, isBlackFridayOffersAvailable) {
                var response, data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this1.httpClient.useGet("/util-info/link-options")
                            ];
                        case 1:
                            response = _state.sent();
                            data = isBranchJPA && isBlackFridayOffersAvailable ? response.data.flatMap(function(item) {
                                if (item.title === "D\xfavidas") {
                                    var newItem = {
                                        title: item.title,
                                        icon: item.icon,
                                        style: item.style,
                                        options: (0,_to_consumable_array/* default */.Z)(item.options).concat([
                                            {
                                                title: "Ofertas Black Friday",
                                                link: {
                                                    title: "Ofertas Black Friday",
                                                    href: "https://www.ferreiracosta.com/Destaque/produtos-ofertados-black-friday-jpa"
                                                }
                                            }, 
                                        ])
                                    };
                                    return newItem;
                                }
                                return item;
                            }) : response.data;
                            return [
                                2,
                                {
                                    data: data,
                                    isLoading: false,
                                    error: false
                                }
                            ];
                    }
                });
            });
            return function(isBranchJPA, isBlackFridayOffersAvailable) {
                return _ref.apply(this, arguments);
            };
        }();
        if (!this.baseUrl) {
            var ref = this.envsApi.getRawEnvImmediately("APIS_BASE_URL"), apisBaseUrl = ref.data;
            var fallback = (0,utils/* getApisUrlFallback */.TW)(UtilInfo_process.env.HOST_ENV);
            this.baseUrl = "".concat(apisBaseUrl || fallback);
        }
    }
    var _proto = UtilInfoApi.prototype;
    // private getPaymentOptionsEndpoint = () => {
    //     return `${this.baseUrl}util-info/payment-options`;
    // };
    _proto.setBaseUrl = function setBaseUrl(url) {
        this.baseUrl = url;
    };
    return UtilInfoApi;
}();


;// CONCATENATED MODULE: ../../packages/application/services/apis/WeddingGiftList/index.ts
/* provided dependency */ var WeddingGiftList_process = __webpack_require__(34406);






var applicationJsonStr = "application/json";
var WeddingGiftListApi = /*#__PURE__*/ function() {
    "use strict";
    function WeddingGiftListApi(httpClient, appMonitoringClient, envsApi) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, WeddingGiftListApi);
        this.httpClient = httpClient;
        this.appMonitoringClient = appMonitoringClient;
        this.envsApi = envsApi;
        this.baseUrl = "";
        this.getWeddingListNameEndPoint = function(name) {
            return "".concat(_this.baseUrl, "?name=").concat(name);
        };
        var _this1 = this;
        this.getWeddingListName = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(name) {
                var response, _tmp, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(_this1.getWeddingListNameEndPoint(name), {
                                    headers: (0,_object_spread/* default */.Z)({}, http/* defaultHeaders */.B)
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            _tmp = {};
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            return [
                                2,
                                (_tmp.data = _state.sent(), _tmp.isLoading = false, _tmp.error = null, _tmp)
                            ];
                        case 3:
                            error = _state.sent();
                            _this1.appMonitoringClient.captureException(error);
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: error
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(name) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getWeddingListFilterEndPoint = function(name, startDate, endDate, pageIndex, pageSize, status) {
            return "".concat(_this.baseUrl, "?name=").concat(name, "&status=").concat(status, "&startDate=").concat(startDate, "&endDate=").concat(endDate, "&pageIndex=").concat(pageIndex, "&pageSize=").concat(pageSize);
        };
        this.getWeddingListFilter = function(name, startDate, endDate, pageIndex, pageSize, status) {
            var condition = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : true;
            try {
                var ref;
                var ref1 = _this.httpClient.useGet(_this.getWeddingListFilterEndPoint(name, startDate, endDate, pageIndex, pageSize, status), {}, condition), data = ref1.data, _$error = ref1.error, isLoading = ref1.isLoading, trigger = ref1.trigger;
                return {
                    data: data,
                    pagination: data ? (ref = data[0]) === null || ref === void 0 ? void 0 : ref.headers : undefined,
                    error: _$error,
                    isLoading: isLoading,
                    trigger: trigger
                };
            } catch (error) {
                _this.appMonitoringClient.captureException(error);
                return {
                    data: null,
                    isLoading: false,
                    error: error
                };
            }
        };
        this.getLinkRecommendationEndPoint = function(primaryHostName, secondaryHostName) {
            return "".concat(_this.baseUrl, "/list-link-recommendation?primaryHostName=").concat(primaryHostName, "&secondaryHostName=").concat(secondaryHostName);
        };
        this.getLinkRecommendation = function(accessToken, primaryHostName, secondaryHostName) {
            var ref = _this.httpClient.useGet(_this.getLinkRecommendationEndPoint(primaryHostName || "", secondaryHostName || ""), {
                headers: {
                    Authorization: "Bearer ".concat(accessToken)
                }
            }, (primaryHostName === null || primaryHostName === void 0 ? void 0 : primaryHostName.length) > 0 && (secondaryHostName === null || secondaryHostName === void 0 ? void 0 : secondaryHostName.length) > 0), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.getWeddingListEndpoint = function(listId) {
            return "".concat(_this.baseUrl, "/").concat(listId || "user", "?originSystem=Site");
        };
        this.getWeddingList = function(accessToken) {
            var listId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined, condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
            if (WeddingGiftList_process === null || WeddingGiftList_process === void 0 ? void 0 : true) {
                var ref = _this.httpClient.useGet(_this.getWeddingListEndpoint(listId), {
                    headers: {
                        Authorization: "Bearer ".concat(accessToken)
                    }
                }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
                return {
                    data: data,
                    isLoading: isLoading,
                    error: error,
                    trigger: trigger
                };
            }
            return fetch(_this.getWeddingListEndpoint(listId), {
                headers: {
                    Authorization: "Bearer ".concat(accessToken)
                }
            }).then(function(response) {
                return response.json().then(function(data) {
                    return {
                        data: data,
                        isLoading: false,
                        error: null
                    };
                }).catch(function(error) {
                    _this.appMonitoringClient.captureException(error);
                    return {
                        data: null,
                        isLoading: false,
                        error: error
                    };
                });
            }).catch(function(error) {
                _this.appMonitoringClient.captureException(error);
                return {
                    data: null,
                    isLoading: false,
                    error: error
                };
            });
        };
        this.getCardNumberEndpoint = function(listId) {
            return "".concat(_this.baseUrl, "/user/giftcardNumber/").concat(listId);
        };
        this.getCardNumber = function(accessToken, listId) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ref = _this.httpClient.useGet(_this.getCardNumberEndpoint(listId), {
                headers: {
                    Authorization: "Bearer ".concat(accessToken)
                }
            }, !!condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            return {
                data: data,
                error: error,
                isLoading: isLoading,
                trigger: trigger
            };
        };
        this.getGiftAllMessagesEndpoint = function(listId, pageSize, currentPage) {
            if (pageSize) {
                return "".concat(_this.baseUrl, "/messages/all-messages?listId=").concat(listId, "&pageIndex=").concat(currentPage, "&pageSize=").concat(pageSize);
            }
            return "".concat(_this.baseUrl, "/messages/all-messages?listId=").concat(listId);
        };
        this.getGiftAllMessages = function(accessToken, listId, pageSize, currentPage) {
            var condition = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
            try {
                var ref = _this.httpClient.useGet(_this.getGiftAllMessagesEndpoint(listId, pageSize, currentPage), {
                    headers: {
                        Authorization: "Bearer ".concat(accessToken)
                    }
                }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
                return {
                    data: data,
                    error: error,
                    isLoading: isLoading,
                    trigger: trigger
                };
            } catch (err) {
                _this.appMonitoringClient.captureException(err);
                return {
                    data: null,
                    isLoading: false,
                    error: err
                };
            }
        };
        this.deleteGiftMessageEndpoint = function(orderId) {
            return "".concat(_this.baseUrl, "/messages/change-status?orderId=").concat(orderId);
        };
        this.deleteGiftMessage = function(orderId, jwt) {
            try {
                return _this.httpClient.usePut(_this.deleteGiftMessageEndpoint(orderId), {
                    Authorization: "Bearer ".concat(jwt)
                }, {});
            } catch (error) {
                _this.appMonitoringClient.captureException(error);
                return null;
            }
        // getWeddingListsEndpoint;
        };
        this.getGiftsReportEndpoint = function(listId) {
            return "".concat(_this.baseUrl, "/giftorders?ListId=").concat(listId, "&Status=All&PageSize=160");
        };
        this.getGiftsReport = function(accessToken, listId) {
            var ref = _this.httpClient.useGet(_this.getGiftsReportEndpoint(listId), {
                headers: {
                    Authorization: "Bearer ".concat(accessToken)
                }
            }, !!listId), data = ref.data, isLoading = ref.isLoading, error = ref.error, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.addProductsToWeddingListEndpoint = function() {
            return "".concat(_this.baseUrl, "/products");
        };
        var _this2 = this;
        this.addProductsToWeddingList = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(accessToken, listProducts) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.httpClient.usePost(_this2.addProductsToWeddingListEndpoint(), listProducts, {
                                    headers: {
                                        Authorization: "Bearer ".concat(accessToken)
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(accessToken, listProducts) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this3 = this;
        this.closeList = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jwt, listId) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this3.httpClient.usePut("".concat(_this3.baseUrl, "/close?listId=").concat(listId), {
                                    Authorization: "Bearer ".concat(jwt)
                                }, listId)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this3.appMonitoringClient.captureException(error);
                            return [
                                2,
                                error
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(jwt, listId) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getGiftsAndCredits = function(accessToken, listId, condition) {
            var ref = _this.httpClient.useGet("".concat(_this.baseUrl, "/giftcards/wallet/").concat(listId), {
                headers: {
                    Authorization: "Bearer ".concat(accessToken)
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.deleteListEndpoint = function(listId) {
            return "".concat(_this.baseUrl, "/delete?listId=").concat(listId);
        };
        var _this4 = this;
        this.deleteList = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jwt, listId) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this4.httpClient.useDelete(_this4.deleteListEndpoint(listId), {
                                    Authorization: "Bearer ".concat(jwt)
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this4.appMonitoringClient.captureException(error);
                            return [
                                2,
                                error
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(jwt, listId) {
                return _ref.apply(this, arguments);
            };
        }();
        this.verifyUserEndpoint = function(userEmail) {
            return "".concat(_this.baseUrl, "/verify-user?userEmail=").concat(userEmail);
        };
        this.verifyUser = function(jwt, userEmail) {
            var ref = _this.httpClient.useGet(_this.verifyUserEndpoint(userEmail), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }), data = ref.data, isLoading = ref.isLoading, error = ref.error, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.getGiftsVoucherEndpoint = function() {
            return "".concat(_this.baseUrl, "/gift-voucher");
        };
        this.getGiftsVoucher = function(jwt) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var ref = _this.httpClient.useGet(_this.getGiftsVoucherEndpoint(), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }, condition), data = ref.data, isLoading = ref.isLoading, error = ref.error, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.getStatementActivityHistory = function(jwt, listId, pageSize, pageIndex, typeOperation) {
            var condition = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
            var ref;
            var ref1 = _this.httpClient.useGet("".concat(_this.baseUrl, "/giftcards/statement?ListId=").concat(listId, "&PageIndex=").concat(pageIndex, "&PageSize=").concat(pageSize, "&TypeOperation=").concat(typeOperation, "&FrontOffice=Yes"), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }, condition), data = ref1.data, trigger = ref1.trigger, error = ref1.error, isLoading = ref1.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                pagination: data ? (ref = data[0]) === null || ref === void 0 ? void 0 : ref.headers : undefined,
                trigger: trigger
            };
        };
        this.updateGiftsEndpoint = function(listId) {
            return "".concat(_this.baseUrl, "/products?listId=").concat(listId);
        };
        var _this5 = this;
        this.updateGifts = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(listId, body, jwt) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this5.httpClient.usePut(_this5.updateGiftsEndpoint(listId), {
                                    Authorization: "Bearer ".concat(jwt),
                                    "Content-Type": "".concat(applicationJsonStr, "-patch+json")
                                }, body)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this5.appMonitoringClient.captureException(error);
                            return [
                                2,
                                null
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(listId, body, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.createGiftEndpoint = function() {
            return "".concat(_this.baseUrl, "/products");
        };
        var _this6 = this;
        this.createGift = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(body, jwt) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this6.httpClient.usePost(_this6.createGiftEndpoint(), body, {
                                    headers: {
                                        accept: applicationJsonStr,
                                        Authorization: "Bearer ".concat(jwt),
                                        "Content-Type": "".concat(applicationJsonStr, "-patch+json")
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this6.appMonitoringClient.captureException(error);
                            return [
                                2,
                                null
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(body, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.giftsReceivedEndpoint = function(listId) {
            return "".concat(_this.baseUrl, "/giftorders/pdf-gifts-received?listId=").concat(listId);
        };
        var _this7 = this;
        this.giftsReceived = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jwt, listId) {
                var response, data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(_this7.giftsReceivedEndpoint(listId), {
                                    headers: {
                                        Authorization: "Bearer ".concat(jwt)
                                    },
                                    method: "POST"
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            return [
                                2,
                                data
                            ];
                        case 3:
                            error = _state.sent();
                            _this7.appMonitoringClient.captureException(error);
                            return [
                                2,
                                null
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(jwt, listId) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getEnvironmentsEndpoint = function(ListId) {
            return "".concat(_this.baseUrl, "/environments?listId=").concat(ListId);
        };
        this.getEnvironments = function(// accessToken: string,
        listId) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var ref = _this.httpClient.useGet(_this.getEnvironmentsEndpoint(listId), {}, condition), data = ref.data, isLoading = ref.isLoading, error = ref.error, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.getEnvironmentsByListLink = function(listLink) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            try {
                var ref = _this.httpClient.useGet(_this.getEnvironmentsByListLinkEndpoint(listLink), {}, condition), data = ref.data, isLoading = ref.isLoading, error = ref.error, trigger = ref.trigger;
                return {
                    data: data,
                    isLoading: isLoading,
                    error: error,
                    trigger: trigger
                };
            } catch (err) {
                _this.appMonitoringClient.captureException(err);
                return {
                    data: null,
                    isLoading: false,
                    error: err
                };
            }
        };
        this.getEnvironmentsByListLinkEndpoint = function(listLink) {
            return "".concat(_this.baseUrl, "/environments?").concat(listLink);
        };
        this.getFilteredGiftsEndpoint = function(ListId, category, brand, model) {
            return "".concat(_this.baseUrl, "/environments?listId=").concat(ListId, "&Category=").concat(category, "&Brand=").concat(brand, "&Model=").concat(model);
        };
        this.getFilteredGifts = function(// accessToken: string,
        listId, category, brand, model) {
            var condition = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
            var ref = _this.httpClient.useGet(_this.getFilteredGiftsEndpoint(listId, category, brand, model), {}, condition), data = ref.data, isLoading = ref.isLoading, error = ref.error, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.getWeddingLists = function(jwt) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var ref = _this.httpClient.useGet(_this.getWeddingListsEndpoint(), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }, condition), data = ref.data, isLoading = ref.isLoading, error = ref.error, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.defaultError = "Ocorreu um erro inesperado, tente novamente";
        this.sendMyListMappedErrors = function(status) {
            return ({
                "400": "Voc\xea precisa preencher os campos obrigat\xf3rios.",
                "500": _this.defaultError
            })["".concat(status)] || _this.defaultError;
        };
        var _this8 = this;
        this.sendMyListForEmail = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var accessToken, listId, emails, message, ref, response, responseStatus, error, err, error1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            accessToken = param.accessToken, listId = param.listId, emails = param.emails, message = param.message;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this8.httpClient.usePost("".concat(_this8.sendMyListForEmailEndpoint(listId)), {
                                    emails: emails,
                                    message: message
                                }, {
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: "Bearer ".concat(accessToken)
                                    }
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            responseStatus = response === null || response === void 0 ? void 0 : (ref = response.status) === null || ref === void 0 ? void 0 : ref.toString();
                            if (responseStatus) {
                                error = _this8.sendMyListMappedErrors(responseStatus);
                                return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                            }
                            return [
                                2,
                                {
                                    data: response,
                                    error: null
                                }
                            ];
                        case 3:
                            err = _state.sent();
                            error1 = (0,utils/* isObjectEmpty */.nK)(err) ? null : JSON.stringify(err);
                            _this8.appMonitoringClient.captureException(error1 !== null && error1 !== void 0 ? error1 : _this8.defaultError);
                            return [
                                2,
                                {
                                    data: null,
                                    error: error1
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        this.createWeddingListEndPoint = function() {
            return "".concat(_this.baseUrl, "/");
        };
        var _this9 = this;
        this.createWeddingList = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(body, jwt) {
                var error, errorObj;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this9.httpClient.usePost(_this9.createWeddingListEndPoint(), body, {
                                    headers: {
                                        "Content-Type": applicationJsonStr,
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this9.appMonitoringClient.captureException(error);
                            errorObj = {
                                error: error
                            };
                            throw new Error("Erro ao criar lista de casamento: ".concat(errorObj));
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(body, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.environmentsEndpoint = function() {
            return "".concat(_this.baseUrl, "/environments");
        };
        var _this10 = this;
        this.createEnvironment = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(body, jwt) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this10.httpClient.usePost(_this10.environmentsEndpoint(), body, {
                                    headers: {
                                        "Content-Type": applicationJsonStr,
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this10.appMonitoringClient.captureException(error);
                            return [
                                2,
                                error
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(body, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this11 = this;
        this.renameEnvironment = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(body, jwt) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this11.httpClient.usePut("".concat(_this11.environmentsEndpoint(), "/rename/").concat(body.id), {
                                    "Content-Type": applicationJsonStr,
                                    Authorization: "Bearer ".concat(jwt)
                                }, body.name)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this11.appMonitoringClient.captureException(error);
                            return [
                                2,
                                error
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(body, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getBarCodeEndpoint = function(listId) {
            return "".concat(_this.baseUrl, "/giftcards/").concat(listId);
        };
        this.getBarCode = function(jwt, listId) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
            var ref = _this.httpClient.useGet(_this.getBarCodeEndpoint(listId), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.getIdByListLinkEndpoint = function(listLink) {
            return "".concat(_this.baseUrl, "/link/").concat(listLink);
        };
        this.getIdByListLink = function(listLink) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            if (WeddingGiftList_process === null || WeddingGiftList_process === void 0 ? void 0 : true) {
                var ref = _this.httpClient.useGet(_this.getIdByListLinkEndpoint(listLink), undefined, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
                return {
                    data: data,
                    isLoading: isLoading,
                    error: error,
                    trigger: trigger
                };
            }
            return fetch(_this.getIdByListLinkEndpoint(listLink)).then(function(response) {
                return response.json().then(function(data) {
                    return {
                        data: data,
                        isLoading: false,
                        error: null
                    };
                }).catch(function(error) {
                    _this.appMonitoringClient.captureException(error);
                    return {
                        data: null,
                        isLoading: false,
                        error: error
                    };
                });
            }).catch(function(error) {
                _this.appMonitoringClient.captureException(error);
                return {
                    data: null,
                    isLoading: false,
                    error: error
                };
            });
        };
        this.getValidateLinkEndPoint = function(link) {
            return "".concat(_this.baseUrl, "/validate-link/").concat(link);
        };
        this.getValidateLink = function(jwt, link) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            try {
                var ref = _this.httpClient.useGet(_this.getValidateLinkEndPoint(link), {
                    headers: {
                        Authorization: "Bearer ".concat(jwt)
                    }
                }, condition), data = ref.data, _$error = ref.error, isLoading = ref.isLoading;
                _this.appMonitoringClient.captureException(_$error);
                return {
                    data: data,
                    isLoading: isLoading,
                    error: _$error
                };
            } catch (error) {
                _this.appMonitoringClient.captureException(error);
                return {
                    data: null,
                    isLoading: false,
                    error: error
                };
            }
        };
        this.editInformationEndpoint = function() {
            return "".concat(_this.baseUrl, "/");
        };
        var _this12 = this;
        this.editInformation = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(body, jwt) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this12.httpClient.usePut(_this12.editInformationEndpoint(), {
                                    Authorization: "Bearer ".concat(jwt)
                                }, body)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this12.appMonitoringClient.captureException(error);
                            return [
                                2,
                                null
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(body, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.headerInfosEndpoint = function(listId) {
            return "".concat(_this.baseUrl, "/header/").concat(listId);
        };
        this.fetchHeaderInfos = function(listId) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var ref = _this.httpClient.useGet(_this.headerInfosEndpoint(listId), {}, condition), data = ref.data, isLoading = ref.isLoading, error = ref.error, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        var _this13 = this;
        this.deleteEnvironment = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(id, jwt) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this13.httpClient.useDelete("".concat(_this13.environmentsEndpoint(), "/").concat(id), {
                                    Authorization: "Bearer ".concat(jwt)
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this13.appMonitoringClient.captureException(error);
                            return [
                                2,
                                error
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(id, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.updateImageEndpoint = function(listId, imageType) {
            return "".concat(_this.baseUrl, "/images/").concat(listId, "?imageType=").concat(imageType);
        };
        var _this14 = this;
        this.updateImage = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(listId, imageType, updateImage, accessToken) {
                var formData, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            formData = new FormData();
                            formData.append("file", updateImage);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this14.httpClient.usePut(_this14.updateImageEndpoint(listId, imageType), {
                                    Authorization: "Bearer ".concat(accessToken)
                                }, formData, "file")
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            error = _state.sent();
                            _this14.appMonitoringClient.captureException(error);
                            return [
                                2,
                                error
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(listId, imageType, updateImage, accessToken) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getGiftProductEndpoint = function(giftProductsParams) {
            return "".concat(_this.baseUrl, "/products?getProductsDTO=").concat(JSON.stringify(giftProductsParams));
        };
        this.getGiftProduct = function(giftProductsParams, jwt) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
            var ref = _this.httpClient.useGet(_this.getGiftProductEndpoint(giftProductsParams), jwt ? {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            } : {}, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.httpClient = httpClient;
        this.appMonitoringClient = appMonitoringClient;
        if (!this.baseUrl) {
            var ref = this.envsApi.getRawEnvImmediately("APIS_BASE_URL"), apisBaseUrl = ref.data;
            var fallback = (0,utils/* getApisUrlFallback */.TW)(WeddingGiftList_process.env.HOST_ENV);
            this.baseUrl = "".concat(apisBaseUrl || fallback, "weddinglist/v1");
        }
    }
    var _proto = WeddingGiftListApi.prototype;
    _proto.setBaseUrl = function setBaseUrl(url) {
        this.baseUrl = url;
    };
    _proto.getWeddingListsEndpoint = function getWeddingListsEndpoint() {
        return "".concat(this.baseUrl, "/wedding-lists");
    };
    _proto.sendMyListForEmailEndpoint = function sendMyListForEmailEndpoint(listId) {
        return "".concat(this.baseUrl, "/share/").concat(listId);
    };
    return WeddingGiftListApi;
}();


;// CONCATENATED MODULE: ../../packages/application/services/apis/Payment/data.ts
var handleGetCardsError = function(getCardsError, appMonitoringClient) {
    if (getCardsError) {
        appMonitoringClient.captureException(getCardsError, {
            level: "error",
            tags: {
                fcx_labs_event: "get_cards",
                fcx_labs_error_source: "payment_api"
            }
        });
    }
};
var handleGetGiftError = function(getGiftError, appMonitoringClient) {
    var ref;
    if (getGiftError && (getGiftError === null || getGiftError === void 0 ? void 0 : (ref = getGiftError.props) === null || ref === void 0 ? void 0 : ref.statusCode) !== 404) {
        appMonitoringClient.captureException(getGiftError, {
            level: "error",
            tags: {
                fcx_labs_event: "get_gift",
                fcx_labs_error_source: "payment_api"
            }
        });
    }
};
var handleOrderPaymentError = function(orderPaymentError, appMonitoringClient, eventError) {
    if (orderPaymentError) {
        appMonitoringClient.captureException(orderPaymentError, {
            level: "error",
            tags: {
                fcx_labs_event: eventError,
                fcx_labs_error_source: "payment_api"
            }
        });
    }
};


;// CONCATENATED MODULE: ../../packages/application/services/apis/Purchase/index.ts
/* provided dependency */ var Purchase_process = __webpack_require__(34406);








var PurchaseApi = /*#__PURE__*/ function() {
    "use strict";
    function PurchaseApi(httpClient, appMonitoringClient, gtag, envsApi) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, PurchaseApi);
        this.httpClient = httpClient;
        this.appMonitoringClient = appMonitoringClient;
        this.gtag = gtag;
        this.envsApi = envsApi;
        this.baseUrl = "";
        this.bffBaseUrl = "";
        this.serverSideUrl = "";
        this.getOrdersEndpoint = function(param) {
            var pageSize = param.pageSize, status = param.status, search = param.search, startDate = param.startDate, endDate = param.endDate, isGift = param.isGift, saleChannel = param.saleChannel, currentPage = param.currentPage, _getOmnichannel = param.getOmnichannel, getOmnichannel = _getOmnichannel === void 0 ? false : _getOmnichannel, filters = param.filters;
            var filtersFormatted = (filters === null || filters === void 0 ? void 0 : filters.length) ? filters.map(function(filter, index) {
                return "".concat(index === 0 ? "&" : "", "Filters=").concat(filter);
            }).join("&") : "";
            var searchFormatted = search ? "&Search=".concat(search) : "";
            var startDateFormatted = startDate ? "&StartDate=".concat(startDate) : "";
            var endDateFormatted = endDate ? "&EndDate=".concat(endDate) : "";
            var isGiftFormatted = isGift ? "&IsGift=".concat(isGift) : "";
            var saleChannelFormatted = saleChannel && !filtersFormatted ? "&SaleChannel=".concat(saleChannel) : "";
            var statusFormatted = status && !filtersFormatted.length ? "&Status=".concat(status) : "";
            return "".concat(_this.baseUrl, "v1/orders?getOnlyOmnichannel=").concat(getOmnichannel, "&CurrentPage=").concat(currentPage, "&PageSize=").concat(pageSize).concat(statusFormatted).concat(searchFormatted).concat(startDateFormatted).concat(endDateFormatted).concat(isGiftFormatted).concat(saleChannelFormatted).concat(filtersFormatted);
        };
        this.getOrders = function(param) {
            var jwt = param.jwt, search = param.search, startDate = param.startDate, endDate = param.endDate, isGift = param.isGift, saleChannel = param.saleChannel, getOmnichannel = param.getOmnichannel, _pageSize = param.pageSize, pageSize = _pageSize === void 0 ? 5 : _pageSize, _status = param.status, status = _status === void 0 ? "All" : _status, _currentPage = param.currentPage, currentPage = _currentPage === void 0 ? 0 : _currentPage, _condition = param.condition, condition = _condition === void 0 ? false : _condition, filters = param.filters;
            // const hasFiltersApplied = Boolean(
            //   Boolean(filters && filters?.length > 0) ||
            //     search ||
            //     startDate ||
            //     endDate ||
            //     isGift ||
            //     saleChannel
            // );
            // if (fallback && !hasFiltersApplied) {
            //   return {
            //     data: fallback,
            //     isLoading: false,
            //     error: null,
            //   };
            // }
            var ref = _this.httpClient.useGet(_this.getOrdersEndpoint({
                jwt: jwt,
                pageSize: pageSize,
                status: status,
                search: search,
                startDate: startDate,
                endDate: endDate,
                isGift: isGift,
                saleChannel: saleChannel,
                currentPage: currentPage,
                getOmnichannel: getOmnichannel,
                filters: filters
            }), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        var _this1 = this;
        this.getOrdersByServer = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var jwt, search, startDate, endDate, isGift, saleChannel, getOmnichannel, _pageSize, pageSize, _status, status, _currentPage, currentPage, filters, response, formattedError, data, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            jwt = param.jwt, search = param.search, startDate = param.startDate, endDate = param.endDate, isGift = param.isGift, saleChannel = param.saleChannel, getOmnichannel = param.getOmnichannel, _pageSize = param.pageSize, pageSize = _pageSize === void 0 ? 5 : _pageSize, _status = param.status, status = _status === void 0 ? "All" : _status, _currentPage = param.currentPage, currentPage = _currentPage === void 0 ? 0 : _currentPage, filters = param.filters;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                fetch(_this1.getOrdersEndpoint({
                                    jwt: jwt,
                                    pageSize: pageSize,
                                    status: status,
                                    search: search,
                                    startDate: startDate,
                                    endDate: endDate,
                                    isGift: isGift,
                                    saleChannel: saleChannel,
                                    currentPage: currentPage,
                                    getOmnichannel: getOmnichannel,
                                    filters: filters
                                }), {
                                    headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, http/* defaultHeaders */.B), {
                                        Authorization: "Bearer ".concat(jwt)
                                    })
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            formattedError = {
                                data: null,
                                isLoading: false,
                                error: "Houve um erro ao carregar os pedidos eletr\xf4nicos"
                            };
                            if (!response.body) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            data = _state.sent();
                            _state.label = 4;
                        case 4:
                            if (!response.ok) {
                                return [
                                    2,
                                    formattedError
                                ];
                            }
                            return [
                                2,
                                {
                                    data: data,
                                    status: response.status,
                                    isLoading: false,
                                    error: ""
                                }
                            ];
                        case 5:
                            err = _state.sent();
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: JSON.stringify(err)
                                }
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = this;
        this.fetchOrdersDetails = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jwt, groupId) {
                var isStoreOrder, data, response, tempData, error;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            isStoreOrder = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4,
                                fetch(_this2.getOrdersDetailsEndpoint(groupId, isStoreOrder), {
                                    headers: {
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            if (!response.ok) {
                                return [
                                    2,
                                    {
                                        data: null,
                                        isLoading: false,
                                        error: [
                                            "Houve um erro ao carregar os detalhes do pedido"
                                        ]
                                    }
                                ];
                            }
                            if (!isStoreOrder) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            tempData = _state.sent();
                            data = (0,utils/* convertStoreOrderToDigital */.r5)(tempData);
                            return [
                                3,
                                6
                            ];
                        case 4:
                            return [
                                4,
                                response.json()
                            ];
                        case 5:
                            data = _state.sent();
                            _state.label = 6;
                        case 6:
                            return [
                                2,
                                {
                                    data: data,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 7:
                            error = _state.sent();
                            _this2.appMonitoringClient.captureException(error);
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: [
                                        error
                                    ]
                                }
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(jwt, groupId) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getOrdersDetails = function(jwt, groupId) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isStoreOrder = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
            var ref = _this.httpClient.useGet(_this.getOrdersDetailsEndpoint(groupId, isStoreOrder), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }, condition), data = ref.data, isLoading = ref.isLoading, error = ref.error, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        var _this3 = this;
        this.getOrdersDetailsByPhone = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jwt, groupId) {
                var condition, isStoreOrder, ref, data, isLoading, _$error, trigger, response, data1, error;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            condition = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true, isStoreOrder = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false;
                            if (Purchase_process === null || Purchase_process === void 0 ? void 0 : true) {
                                ref = _this3.httpClient.useGet(_this3.getOrdersDetailsEndpoint(groupId, isStoreOrder), {
                                    headers: {
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                }, condition), data = ref.data, isLoading = ref.isLoading, _$error = ref.error, trigger = ref.trigger;
                                return [
                                    2,
                                    {
                                        data: data,
                                        isLoading: isLoading,
                                        error: _$error,
                                        trigger: trigger
                                    }
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                fetch(_this3.getOrdersDetailsEndpoint(groupId, isStoreOrder), {
                                    headers: {
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            data1 = _state.sent();
                            return [
                                2,
                                {
                                    data: data1,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 4:
                            error = _state.sent();
                            _this3.appMonitoringClient.captureMessage(JSON.stringify(error));
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: error
                                }
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(jwt, groupId) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getOrdersDetailsEndpoint = function(groupId, isStoreOrder) {
            var storyType = isStoreOrder ? "orders-store" : "orders";
            return "".concat(_this.baseUrl, "v1/").concat(storyType, "/details/").concat(groupId);
        };
        this.postCancelOrderEndpoint = function(orderHash) {
            return "".concat(_this.baseUrl, "v1/orders/").concat(orderHash, "/cancel-order");
        };
        var _this4 = this;
        this.cancelOrder = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(orderHash, body, jwt) {
                var response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this4.httpClient.usePost(_this4.postCancelOrderEndpoint(orderHash), body, {
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                {
                                    data: response,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 2:
                            error = _state.sent();
                            _this4.appMonitoringClient.captureException(error);
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: error
                                }
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(orderHash, body, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.postOrderEndpoint = function() {
            return "".concat(_this.bffBaseUrl, "order");
        };
        var _this5 = this;
        this.createOrder = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param, condition) {
                var jwt, cartId, couponMovementId, payment, shippingOptions, shipping, giftMessages, gtagItems, quantity, sessionId, fingerprint, clientIp, giftCardSMSToken, response, formattedData, data, isLoading, _$error, total, packageItem, ref, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            jwt = param.jwt, cartId = param.cartId, couponMovementId = param.couponMovementId, payment = param.payment, shippingOptions = param.shippingOptions, shipping = param.shipping, giftMessages = param.giftMessages, gtagItems = param.gtagItems, quantity = param.quantity, sessionId = param.sessionId, fingerprint = param.fingerprint, clientIp = param.clientIp, giftCardSMSToken = param.giftCardSMSToken;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this5.httpClient.usePost(_this5.postOrderEndpoint(), (0,_object_spread/* default */.Z)({
                                    cartId: cartId,
                                    payment: payment,
                                    shippingOptions: shippingOptions,
                                    couponMovementId: couponMovementId,
                                    giftMessages: giftMessages
                                }, giftCardSMSToken && {
                                    giftCardSMSToken: giftCardSMSToken
                                }), {
                                    headers: (0,_object_spread/* default */.Z)({
                                        "Content-Type": "application/json",
                                        Authorization: "Bearer ".concat(jwt)
                                    }, sessionId && {
                                        clearSale: sessionId
                                    }, fingerprint && {
                                        allowMe: fingerprint
                                    }, clientIp && {
                                        "X-Client-Ip": clientIp
                                    }),
                                    timeout: "62000"
                                }, condition)
                            ];
                        case 2:
                            response = _state.sent();
                            formattedData = response;
                            if ((formattedData === null || formattedData === void 0 ? void 0 : formattedData.statusCode) && formattedData.statusCode === 400) {
                                handleOrderPaymentError(formattedData, _this5.appMonitoringClient, "payment");
                                return [
                                    2,
                                    {
                                        data: null,
                                        isLoading: false,
                                        error: formattedData === null || formattedData === void 0 ? void 0 : formattedData.validationProblemDetails
                                    }
                                ];
                            }
                            data = response.data, isLoading = response.isLoading, _$error = response.error;
                            total = data === null || data === void 0 ? void 0 : data.reduce(function(previousOrder, currentOrder) {
                                return previousOrder + currentOrder.totalPrice;
                            }, shipping);
                            packageItem = data === null || data === void 0 ? void 0 : data.at(0);
                            if (!(data === null || data === void 0 ? void 0 : data.groupId) || !(data === null || data === void 0 ? void 0 : data.clientId) || _$error) _this5.appMonitoringClient.captureMessage("O endpoint de bff-site/purchase/order n\xe3o est\xe1 retornando o valor de ".concat(!(packageItem === null || packageItem === void 0 ? void 0 : packageItem.groupId) ? "groupId" : "").concat(!(packageItem === null || packageItem === void 0 ? void 0 : packageItem.clientId) ? "| clientId" : "", ":\n Response: {clientId: ").concat(data === null || data === void 0 ? void 0 : data.clientId, ", groupId: ").concat(packageItem === null || packageItem === void 0 ? void 0 : packageItem.groupId, ", hash: ").concat(packageItem === null || packageItem === void 0 ? void 0 : packageItem.ordertHash, ", totalPrice: ").concat(packageItem === null || packageItem === void 0 ? void 0 : packageItem.totalPrice, "}\n error: ").concat(_$error, "\n"), {
                                level: "error"
                            });
                            _this5.gtag.purchase(total, shipping, String((ref = packageItem === null || packageItem === void 0 ? void 0 : packageItem.groupId) !== null && ref !== void 0 ? ref : ""), gtagItems, quantity, Number(packageItem === null || packageItem === void 0 ? void 0 : packageItem.clientId), "BRL");
                            return [
                                2,
                                {
                                    data: data,
                                    isLoading: isLoading,
                                    error: _$error
                                }
                            ];
                        case 3:
                            error = _state.sent();
                            handleOrderPaymentError(error, _this5.appMonitoringClient, "payment");
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: error
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_, condition) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getVerifyUniqueClientEndpoint = function() {
            return "/api/purchase";
        };
        var _this6 = this;
        this.getVerifyUniqueClient = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jwt) {
                var ref, ref1, response, data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(_this6.getVerifyUniqueClientEndpoint(), {
                                    headers: {
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            if (((ref = String(response === null || response === void 0 ? void 0 : response.status)) === null || ref === void 0 ? void 0 : ref.startsWith("4")) || ((ref1 = String(response === null || response === void 0 ? void 0 : response.status)) === null || ref1 === void 0 ? void 0 : ref1.startsWith("5"))) {
                                return [
                                    2,
                                    {
                                        data: null,
                                        isLoading: false,
                                        error: data
                                    }
                                ];
                            }
                            return [
                                2,
                                {
                                    data: data,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 3:
                            error = _state.sent();
                            _this6.appMonitoringClient.captureException(error);
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: error
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getOrdersStatusEndpoint = function(orderId) {
            return "".concat(_this.baseUrl, "v1/order-status/").concat(orderId);
        };
        this.getOrdersStatus = function(accessToken, orderId) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ref = _this.httpClient.useGet(_this.getOrdersStatusEndpoint(orderId), {
                headers: {
                    Authorization: "Bearer ".concat(accessToken)
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.getChatEligibleForClientEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/customer-orders/chat-eligible-for-client");
        };
        this.getChatEligibleForClient = function(accessToken) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var ref = _this.httpClient.useGet(_this.getChatEligibleForClientEndpoint(), {
                headers: {
                    Authorization: "Bearer ".concat(accessToken)
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getAlertStatusEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/orders/alert-status");
        };
        this.getAlertStatus = function(accessToken) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var ref = _this.httpClient.useGet(_this.getAlertStatusEndpoint(), {
                headers: {
                    Authorization: "Bearer ".concat(accessToken)
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.getFiscalDocumentEndpoint = function(orderId, branchId, typeDocument) {
            var isStoreOrder = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
            return "".concat(_this.baseUrl, "v1/orders/fiscal-document?numOrder=").concat(orderId, "&branchid=").concat(branchId, "&typeDocument=").concat(typeDocument, "&saleChannel=").concat(isStoreOrder ? "1" : "2");
        };
        var _this7 = this;
        this.getFiscalDocument = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(orderId, accessToken, branchId) {
                var typeDocument, isStoreOrder, ref, ref1, response, responseToBlob, invoiceLink, ref2, err;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            typeDocument = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : "Danfe", isStoreOrder = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : false;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                fetch(_this7.getFiscalDocumentEndpoint(orderId, branchId, typeDocument, isStoreOrder), {
                                    headers: {
                                        Authorization: "Bearer ".concat(accessToken),
                                        "Content-Type": "application/pdf"
                                    }
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            return [
                                4,
                                response.blob()
                            ];
                        case 3:
                            responseToBlob = _state.sent();
                            invoiceLink = response.status === 200 ? window.URL.createObjectURL(responseToBlob) : "";
                            if (response.status !== 200) {
                                return [
                                    2,
                                    {
                                        data: [],
                                        fileName: "",
                                        isLoading: false,
                                        error: "Houve um erro ao obter a nota fiscal, status code: ".concat(response.status)
                                    }
                                ];
                            }
                            return [
                                2,
                                {
                                    data: invoiceLink,
                                    fileName: (ref2 = (ref1 = (ref = response.headers) === null || ref === void 0 ? void 0 : ref.get("Content-Disposition")) === null || ref1 === void 0 ? void 0 : ref1.split("filename=")[1].split(";")[0]) !== null && ref2 !== void 0 ? ref2 : "",
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 4:
                            err = _state.sent();
                            _this7.appMonitoringClient.captureException(err);
                            return [
                                2,
                                {
                                    data: [],
                                    fileName: "",
                                    isLoading: false,
                                    error: err
                                }
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(orderId, accessToken, branchId) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getOrderTrackingTMSEndpoint = function(trackingCode) {
            return "".concat(_this.bffBaseUrl, "get-order-tracking?trackingCode=").concat(trackingCode);
        };
        this.getOrderTrackingTMS = function(accessToken, trackingCode) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ref = _this.httpClient.useGet(_this.getOrderTrackingTMSEndpoint(trackingCode), {
                headers: {
                    Authorization: "Bearer ".concat(accessToken)
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.getOrderFiltersEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/filters");
        };
        this.getOrderFilters = function(shouldFetch, fallbackFilters) {
            try {
                var ref;
                var response = _this.httpClient.useGet(_this.getOrderFiltersEndpoint(), undefined, shouldFetch, fallbackFilters);
                if (!((ref = response.data) === null || ref === void 0 ? void 0 : ref.length)) {
                    return {
                        data: null,
                        isLoading: false,
                        error: "N\xe3o h\xe1 filtros dispon\xedveis"
                    };
                }
                return (0,_object_spread/* default */.Z)({}, response);
            } catch (error) {
                return {
                    data: null,
                    isLoading: false,
                    error: error
                };
            }
        };
        this.serverSideUrl = "/api/purchase/";
        if (!this.baseUrl || !this.bffBaseUrl) {
            var ref = this.envsApi.getRawEnvImmediately("APIS_BASE_URL"), apisBaseUrl = ref.data;
            var fallback = (0,utils/* getApisUrlFallback */.TW)(Purchase_process.env.HOST_ENV);
            this.baseUrl = "".concat(apisBaseUrl || fallback, "purchase/");
            this.bffBaseUrl = "".concat(apisBaseUrl || fallback, "bff-site/purchase/");
        }
        this.appMonitoringClient = appMonitoringClient;
    }
    var _proto = PurchaseApi.prototype;
    _proto.setBaseUrl = function setBaseUrl(url) {
        this.baseUrl = url;
    };
    return PurchaseApi;
}();

;// CONCATENATED MODULE: ../../packages/application/services/apis/Payment/index.ts
/* provided dependency */ var Payment_process = __webpack_require__(34406);
/* eslint-disable class-methods-use-this */ 




var PaymentApi = /*#__PURE__*/ function() {
    "use strict";
    function PaymentApi(httpClient, appMonitoringClient, envsApi) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, PaymentApi);
        this.httpClient = httpClient;
        this.appMonitoringClient = appMonitoringClient;
        this.envsApi = envsApi;
        this.baseUrl = "";
        this.SALE_CHANNEL = Number("".concat(Payment_process.env.SITE_ECOMMERCE_SALE_CHANNEL || "2"));
        this.JSON_CONTENT_TYPE = "application/json";
        this.getCardsEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/cards?PageSize=30");
        };
        this.getCards = function(jwt, appMonitoringClient, condition) {
            var ref = _this.httpClient.useGet(_this.getCardsEndpoint(), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            handleGetCardsError(error, appMonitoringClient);
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.postCardsEndpoint = function() {
            return "/api/clients/cards";
        };
        var _this1 = this;
        this.createCard = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(body, jwt) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this1.httpClient.usePost(_this1.postCardsEndpoint(), body, {
                                    headers: {
                                        "Content-Type": _this1.JSON_CONTENT_TYPE,
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this1.appMonitoringClient.captureException(error);
                            return [
                                2,
                                null
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(body, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.deleteCardEndPoint = function(cardId) {
            return "".concat(_this.baseUrl, "v1/cards/").concat(cardId);
        };
        var _this2 = this;
        this.deleteCard = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(cardId, jwt, body) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this2.httpClient.useDelete(_this2.deleteCardEndPoint(cardId), {
                                    Authorization: "Bearer ".concat(jwt)
                                }, body)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this2.appMonitoringClient.captureException(error);
                            return [
                                2,
                                null
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(cardId, jwt, body) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getPixEndpoint = function(orderGroupId) {
            return "".concat(_this.baseUrl, "v1/pix/").concat(orderGroupId);
        };
        this.getPix = function(jwt, orderGroupId) {
            var ref = _this.httpClient.useGet(_this.getPixEndpoint(orderGroupId), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.postBookingCouponEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/coupons/booking-coupon");
        };
        var _this3 = this;
        this.postBookingCoupon = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var couponName, cpf, groupOrderId, branchId, couponProducts, jwt, condition, response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            couponName = param.couponName, cpf = param.cpf, groupOrderId = param.groupOrderId, branchId = param.branchId, couponProducts = param.couponProducts, jwt = param.jwt, condition = param.condition;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this3.httpClient.usePost(_this3.postBookingCouponEndpoint(), {
                                    couponName: couponName,
                                    groupOrderId: groupOrderId,
                                    branchId: branchId,
                                    cpf: cpf,
                                    couponProducts: couponProducts,
                                    saleChannel: _this3.SALE_CHANNEL
                                }, {
                                    headers: {
                                        "Content-Type": _this3.JSON_CONTENT_TYPE,
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                }, condition)
                            ];
                        case 2:
                            response = _state.sent();
                            return [
                                2,
                                {
                                    data: response,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 3:
                            error = _state.sent();
                            _this3.appMonitoringClient.captureException(error);
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: error
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getGiftEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/gift");
        };
        this.getGift = function(jwt, appMonitoringClient) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ref = _this.httpClient.useGet(_this.getGiftEndpoint(), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }, condition), data = ref.data, isLoading = ref.isLoading, error = ref.error;
            handleGetGiftError(error, appMonitoringClient);
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        var _this4 = this;
        this.postPaymentOrder = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jwt, orderId, payment, event) {
                var condition, response, error;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            condition = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : true;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this4.httpClient.usePost(_this4.postPaymentOrderEndpoint(orderId), payment, {
                                    headers: {
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                }, condition)
                            ];
                        case 2:
                            response = _state.sent();
                            if (!(response === null || response === void 0 ? void 0 : response.isValid)) {
                                handleOrderPaymentError(response, _this4.appMonitoringClient, event);
                            }
                            return [
                                2,
                                response
                            ];
                        case 3:
                            error = _state.sent();
                            handleOrderPaymentError(error, _this4.appMonitoringClient, event);
                            return [
                                2,
                                null
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(jwt, orderId, payment, event) {
                return _ref.apply(this, arguments);
            };
        }();
        this.revalidateCardEndPoint = function() {
            return "".concat(_this.baseUrl, "v1/cards");
        };
        var _this5 = this;
        this.putRevalidateCard = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(body, accessToken) {
                var response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this5.httpClient.usePut(_this5.revalidateCardEndPoint(), {
                                    "Content-Type": _this5.JSON_CONTENT_TYPE,
                                    Authorization: "Bearer ".concat(accessToken)
                                }, body)
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                {
                                    data: response,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 2:
                            error = _state.sent();
                            _this5.appMonitoringClient.captureException(error);
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: error
                                }
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(body, accessToken) {
                return _ref.apply(this, arguments);
            };
        }();
        if (!this.baseUrl) {
            var ref = this.envsApi.getRawEnvImmediately("APIS_BASE_URL"), apisBaseUrl = ref.data;
            var fallback = (0,utils/* getApisUrlFallback */.TW)(Payment_process.env.HOST_ENV);
            this.baseUrl = "".concat(apisBaseUrl || fallback, "payment/");
        }
        this.appMonitoringClient = appMonitoringClient;
    }
    var _proto = PaymentApi.prototype;
    _proto.setBaseUrl = function setBaseUrl(url) {
        this.baseUrl = url;
    };
    _proto.postPaymentOrderEndpoint = function postPaymentOrderEndpoint(orderId) {
        return "".concat(this.baseUrl, "v1/payment/").concat(orderId);
    };
    return PaymentApi;
}();

;// CONCATENATED MODULE: ../../packages/application/services/apis/Notification/index.ts
/* provided dependency */ var Notification_process = __webpack_require__(34406);
/* eslint-disable camelcase */ 




var NotificationApi = /*#__PURE__*/ function() {
    "use strict";
    function NotificationApi(httpClient, appMonitoringClient, envsApi) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, NotificationApi);
        this.httpClient = httpClient;
        this.appMonitoringClient = appMonitoringClient;
        this.envsApi = envsApi;
        this.baseUrl = "";
        this.rootBaseUrl = "";
        this.getUserNotificationsSettingsEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/notification/user-notification-settings");
        };
        this.getUserNotificationsSettings = function(accessToken) {
            var condition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var ref = _this.httpClient.useGet(_this.getUserNotificationsSettingsEndpoint(), {
                headers: {
                    Authorization: "Bearer ".concat(accessToken)
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading;
            return {
                data: data,
                isLoading: isLoading,
                error: error
            };
        };
        this.sendTwoFactorSMSEndpoint = function(type) {
            return "".concat(_this.baseUrl, "v1/2fa/type/").concat(type, "/send");
        };
        this.sendTwoFactorEmailEndpoint = function(type, email) {
            return "".concat(_this.baseUrl, "v1/2fa/type/").concat(type, "/email/").concat(email, "/send");
        };
        this.validateTwoFactorTokenEmailEndpoint = function(type, email, token) {
            return "".concat(_this.baseUrl, "v1/2fa/type/").concat(type, "/email/").concat(token, "/validate?email=").concat(email);
        };
        this.validateTwoFactorSMSEndpoint = function(type, token) {
            return "".concat(_this.baseUrl, "v1/2fa/type/").concat(type, "/").concat(token, "/validate");
        };
        this.sendTwoFactorCodePublicEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/2fa/public/FAType/channel/send-token");
        };
        this.sendTwoFactorCodeEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/2fa/FAType/channel/send-token");
        };
        this.sendTokenForSMSEndpoint = function(type, phone) {
            return "".concat(_this.baseUrl, "v1/2fa/type/").concat(type, "/phone/").concat(phone, "/send");
        };
        var _this1 = this;
        this.sendTokenForSMS = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(type, phone) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this1.httpClient.usePost(_this1.sendTokenForSMSEndpoint(type, phone), {})
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            _this1.appMonitoringClient.captureException(error);
                            return [
                                2,
                                error
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(type, phone) {
                return _ref.apply(this, arguments);
            };
        }();
        this.validateTwoFactorCodePublicEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/2fa/public/FAType/token/validate-token");
        };
        this.// eslint-disable-next-line class-methods-use-this
        validateTwoFactorCodePublicOnServerEndpoint = function() {
            return "/api/notification/validation-public";
        };
        this.validateTwoFactorCodeEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/2fa/FAType/token/validate-token");
        };
        this.// eslint-disable-next-line class-methods-use-this
        validateTwoFactorCodeOnServerEndpoint = function() {
            return "/api/notification/validation";
        };
        this.getVerifyTokenEndpoint = function(token, identifier, faType) {
            return "".concat(_this.baseUrl, "v1/2fa/verifyToken/").concat(token, "/").concat(identifier, "/").concat(faType);
        };
        this.sendTwoFactorTokenByChannelEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/2fa/FAType/channel/send-token");
        };
        this.reportSecurityProblemEndpoint = "/api/notification/report-security-issue";
        this.// eslint-disable-next-line class-methods-use-this
        changeResponsiblePickupEndpoint = function() {
            return "/api/notification/change-responsible-for-pickup";
        };
        var _this2 = this;
        this.changeResponsiblePickup = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var jwt, email, faType, token, channel, newResponsibleForPickup, oldResponsibleForPickup, location, response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            jwt = param.jwt, email = param.email, faType = param.faType, token = param.token, channel = param.channel, newResponsibleForPickup = param.newResponsibleForPickup, oldResponsibleForPickup = param.oldResponsibleForPickup, location = param.location;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this2.httpClient.usePost(_this2.changeResponsiblePickupEndpoint(), {
                                    email: email,
                                    channel: channel,
                                    phoneNumber: "",
                                    faType: faType,
                                    token: token,
                                    location: location,
                                    newResponsibleForPickup: newResponsibleForPickup,
                                    oldResponsibleForPickup: oldResponsibleForPickup
                                }, {
                                    headers: {
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            return [
                                2,
                                {
                                    data: {
                                        isValid: response.isValid
                                    },
                                    error: {
                                        errors: response === null || response === void 0 ? void 0 : response.errors
                                    },
                                    isLoading: false,
                                    status: response.status
                                }
                            ];
                        case 3:
                            error = _state.sent();
                            _this2.appMonitoringClient.captureException(error);
                            return [
                                2,
                                {
                                    data: {
                                        isValid: false
                                    },
                                    error: {
                                        errors: {
                                            Reason: error
                                        }
                                    },
                                    isLoading: false,
                                    status: 400
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        if (!this.baseUrl) {
            var ref = this.envsApi.getRawEnvImmediately("APIS_BASE_URL"), apisBaseUrl = ref.data;
            var fallback = (0,utils/* getApisUrlFallback */.TW)(Notification_process.env.HOST_ENV);
            this.baseUrl = "".concat(apisBaseUrl || fallback, "notification/");
            this.rootBaseUrl = apisBaseUrl || fallback;
        }
        this.appMonitoringClient = appMonitoringClient;
    }
    var _proto = NotificationApi.prototype;
    _proto.setBaseUrl = function setBaseUrl(url) {
        this.baseUrl = url;
    };
    _proto.setUserNotificationsSettingsWhatsAppEndpoint = function setUserNotificationsSettingsWhatsAppEndpoint() {
        return "".concat(this.baseUrl, "v1/notification/user-notification-settings");
    };
    _proto.setUserNotificationsSettingsWhatsApp = function setUserNotificationsSettingsWhatsApp(user, data) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var response, err, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePut(_this.setUserNotificationsSettingsWhatsAppEndpoint(), {
                                Authorization: "".concat(user.token_type, " ").concat(user.access_token)
                            }, {
                                notificationChannelId: data.notificationChannelId,
                                notificationTypeId: data.notificationTypeId,
                                receiveNotification: data.receiveNotification
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            {
                                data: response,
                                error: null
                            }
                        ];
                    case 2:
                        err = _state.sent();
                        error = (0,utils/* isObjectEmpty */.nK)(err) ? null : JSON.stringify(err);
                        _this.appMonitoringClient.captureException(error !== null && error !== void 0 ? error : "Erro ao salvar aceite de termos de acompanhar pedido por WhatsApp");
                        return [
                            2,
                            {
                                data: null,
                                error: error
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.sendTwoFactorSMS = function sendTwoFactorSMS(type, jwt) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePost(_this.sendTwoFactorSMSEndpoint(type), {
                                type: type,
                                jwt: jwt
                            }, {
                                headers: {
                                    Authorization: "Bearer ".concat(jwt)
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response
                        ];
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error);
                        return [
                            2,
                            {
                                data: null,
                                status: ""
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.sendTwoFactorEmail = function sendTwoFactorEmail(type, email) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePost(_this.sendTwoFactorEmailEndpoint(type, email), {
                                type: type,
                                email: email
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            {
                                isValidEmail: response === null || response === void 0 ? void 0 : (ref = response.validationResult) === null || ref === void 0 ? void 0 : ref.isValid,
                                isLoading: false,
                                data: response
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error);
                        return [
                            2,
                            {
                                isValidEmail: false,
                                isLoading: false,
                                error: error
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.validateTwoFactorTokenEmail = function validateTwoFactorTokenEmail(type, email, token) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePost(_this.validateTwoFactorTokenEmailEndpoint(type, email, token), {
                                type: type,
                                email: email
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if ((response === null || response === void 0 ? void 0 : response.isValid) === true) {
                            return [
                                2,
                                {
                                    isValidEmail: true
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                isValidEmail: false
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error);
                        return [
                            2,
                            {
                                isValidEmail: false
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.validateTwoFactorSMS = function validateTwoFactorSMS(type, token, jwt) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePost(_this.validateTwoFactorSMSEndpoint(type, token), {
                                type: type,
                                token: token,
                                jwt: jwt
                            }, {
                                headers: {
                                    Authorization: "Bearer ".concat(jwt)
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error);
                        return [
                            2,
                            {
                                data: null,
                                error: error,
                                isLoading: false,
                                status: "",
                                errors: {
                                    Messages: [
                                        ""
                                    ]
                                }
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.sendTwoFactorCodePublic = function sendTwoFactorCodePublic(param) {
        var channel = param.channel, faType = param.faType, cpf = param.cpf, email = param.email, phoneNumber = param.phoneNumber, token = param.token, _canSendToken = param.canSendToken, canSendToken = _canSendToken === void 0 ? true : _canSendToken;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePost(_this.sendTwoFactorCodePublicEndpoint(), {
                                email: email,
                                cpf: cpf,
                                faType: faType,
                                channel: channel,
                                phoneNumber: phoneNumber,
                                token: token
                            }, {}, canSendToken)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error);
                        return [
                            2,
                            error
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.sendTwoFactorCode = function sendTwoFactorCode(param) {
        var channel = param.channel, faType = param.faType, cpf = param.cpf, email = param.email, phoneNumber = param.phoneNumber, token = param.token;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePost(_this.sendTwoFactorCodeEndpoint(), {
                                email: email,
                                cpf: cpf,
                                faType: faType,
                                channel: channel,
                                phoneNumber: phoneNumber
                            }, {
                                headers: {
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.errors) {
                            throw new Error(response.errors.Messages[0]);
                        }
                        return [
                            2,
                            {
                                data: (0,_object_spread/* default */.Z)({}, response),
                                error: null,
                                isLoading: false,
                                status: 200
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error);
                        return [
                            2,
                            {
                                data: {
                                    validationResult: {
                                        isValid: false
                                    }
                                },
                                error: error,
                                isLoading: false,
                                status: 400
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.validateTwoFactorCodePublic = function validateTwoFactorCodePublic(param) {
        var email = param.email, cpf = param.cpf, faType = param.faType, channel = param.channel, token = param.token, phoneNumber = param.phoneNumber, location = param.location, needsToLog = param.needsToLog;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePost(needsToLog ? _this.validateTwoFactorCodePublicOnServerEndpoint() : _this.validateTwoFactorCodePublicEndpoint(), {
                                email: email,
                                cpf: cpf,
                                faType: faType,
                                channel: channel,
                                token: token,
                                phoneNumber: phoneNumber,
                                location: location
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error);
                        return [
                            2,
                            error
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.validateTwoFactorCode = function validateTwoFactorCode(param) {
        var email = param.email, cpf = param.cpf, faType = param.faType, channel = param.channel, token = param.token, phoneNumber = param.phoneNumber, jwt = param.jwt, location = param.location, needsToLog = param.needsToLog;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePost(needsToLog ? _this.validateTwoFactorCodeOnServerEndpoint() : _this.validateTwoFactorCodeEndpoint(), {
                                email: email,
                                cpf: cpf,
                                faType: faType,
                                channel: channel,
                                token: token,
                                phoneNumber: phoneNumber,
                                location: location
                            }, {
                                headers: {
                                    Authorization: "Bearer ".concat(jwt)
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error);
                        return [
                            2,
                            error
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.getVerifyToken = function getVerifyToken(token, identifier, faType) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var response, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch(_this.getVerifyTokenEndpoint(token, identifier, faType))
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        data = _state.sent();
                        if (!response.ok) {
                            return [
                                2,
                                {
                                    data: null,
                                    error: response === null || response === void 0 ? void 0 : response.status,
                                    isLoading: false
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                data: data,
                                isLoading: false,
                                error: null
                            }
                        ];
                }
            });
        })();
    };
    _proto.sendTwoFactorTokenByChannel = function sendTwoFactorTokenByChannel(jwt, body) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePost(_this.sendTwoFactorTokenByChannelEndpoint(), body, {
                                headers: {
                                    Authorization: "Bearer ".concat(jwt)
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error);
                        return [
                            2,
                            {
                                isValid: false,
                                isLoading: false
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.reportSecurityProblem = function reportSecurityProblem(param) {
        var name = param.name, cpf = param.cpf, email = param.email, phoneNumber = param.phoneNumber, reason = param.reason, token = param.token, channel = param.channel, faType = param.faType, jwt = param.jwt, _shouldReportProblem = param.shouldReportProblem, shouldReportProblem = _shouldReportProblem === void 0 ? false : _shouldReportProblem;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.httpClient.usePost(_this.reportSecurityProblemEndpoint, {
                                name: name,
                                email: email,
                                cpf: cpf,
                                phoneNumber: phoneNumber,
                                reason: reason,
                                channel: channel,
                                token: token,
                                faType: faType
                            }, {
                                headers: {
                                    Authorization: "Bearer ".concat(jwt)
                                }
                            }, shouldReportProblem)
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            {
                                data: response,
                                error: {
                                    errors: response === null || response === void 0 ? void 0 : response.errors,
                                    status: response === null || response === void 0 ? void 0 : response.status
                                },
                                isLoading: false
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        _this.appMonitoringClient.captureException(error);
                        return [
                            2,
                            {
                                data: {
                                    status: 400
                                },
                                error: {
                                    errors: {
                                        Reason: error
                                    }
                                },
                                isLoading: false
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return NotificationApi;
}();


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../packages/application/services/apis/Shopping/data.ts
var Shopping_data = __webpack_require__(219);
;// CONCATENATED MODULE: ../../packages/application/services/apis/Shopping/index.ts
/* provided dependency */ var Shopping_process = __webpack_require__(34406);








var applicationJson = "application/json";
var aplicationJsonPatch = "application/json-patch+json";
var ShoppingApi = /*#__PURE__*/ function() {
    "use strict";
    function ShoppingApi(httpClient, appMonitoringClient, envsApi) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, ShoppingApi);
        this.httpClient = httpClient;
        this.appMonitoringClient = appMonitoringClient;
        this.envsApi = envsApi;
        this.baseUrl = "";
        this.createdCartAuthenticatedEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/carts");
        };
        this.getCart = function(jwt, condition) {
            var ref = _this.httpClient.useGet(_this.createdCartAuthenticatedEndpoint(), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }, condition), data = ref.data, error = ref.error, isLoading = ref.isLoading, trigger = ref.trigger;
            return {
                data: data,
                isLoading: isLoading,
                error: error,
                trigger: trigger
            };
        };
        this.createdCartAuthenticated = function(branchId, appMonitoringClient, jwt) {
            var branchIdValue = (0,utils/* formatBranchId */.f)(branchId.toString());
            try {
                return _this.httpClient.usePut(_this.createdCartAuthenticatedEndpoint(), {
                    Authorization: "Bearer ".concat(jwt)
                }, {
                    branchId: Number(branchIdValue)
                });
            } catch (error) {
                (0,Shopping_data/* handleCartError */.p)(error, appMonitoringClient, "create_cart_authenticated");
                return null;
            }
        };
        this.getCartAuthEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/carts?originSystem=Site");
        };
        var _this1 = this;
        this.fetchCartAuthenticated = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(jwt) {
                var response, data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(_this1.getCartAuthEndpoint(), {
                                    headers: {
                                        Authorization: "Bearer ".concat(jwt)
                                    }
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            return [
                                2,
                                {
                                    data: data,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 3:
                            error = _state.sent();
                            _this1.appMonitoringClient.captureMessage(JSON.stringify(error));
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: error
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getCartAuthenticated = function(jwt, appMonitoringClient) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, fallbackData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined;
            var ref = _this.httpClient.useGet(_this.getCartAuthEndpoint(), {
                headers: {
                    Authorization: "Bearer ".concat(jwt)
                }
            }, condition, fallbackData), data = ref.data, isLoading = ref.isLoading, trigger = ref.trigger, error = ref.error;
            (0,Shopping_data/* handleCartError */.p)(error, appMonitoringClient, "get_cart_authenticated");
            return {
                data: data,
                isLoading: isLoading,
                trigger: trigger,
                error: error
            };
        };
        this.getCartAnonymousEndpoint = function(cookieId) {
            return "".concat(_this.baseUrl, "v1/carts/anonymous?cookieId=").concat(cookieId, "&originSystem=Site");
        };
        var _this2 = this;
        this.fetchCartAnonymous = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(cookieId) {
                var response, data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(_this2.getCartAnonymousEndpoint(cookieId), {
                                    headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, utils/* defaultHeaders */.B), {
                                        "content-type": applicationJson
                                    })
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            return [
                                2,
                                {
                                    data: data,
                                    isLoading: false,
                                    error: null
                                }
                            ];
                        case 3:
                            error = _state.sent();
                            _this2.appMonitoringClient.captureMessage(JSON.stringify(error));
                            return [
                                2,
                                {
                                    data: null,
                                    isLoading: false,
                                    error: error
                                }
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(cookieId) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getCartAnonymous = function(cookieId, appMonitoringClient) {
            var condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
            var ref = _this.httpClient.useGet(_this.getCartAnonymousEndpoint(cookieId), {}, condition), data = ref.data, isLoading = ref.isLoading, trigger = ref.trigger, error = ref.error;
            (0,Shopping_data/* handleCartError */.p)(error, appMonitoringClient, "get_cart_anonymous");
            return {
                data: data,
                isLoading: isLoading,
                trigger: trigger,
                error: error
            };
        };
        this.createCartAnonymousEndpoint = function() {
            return "".concat(_this.baseUrl, "v1/carts/anonymous");
        };
        var _this3 = this;
        this.createCartAnonymous = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(branchId, appMonitoringClient) {
                var branchIdValue, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            branchIdValue = (0,utils/* formatBranchId */.f)(branchId.toString());
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this3.httpClient.usePost(_this3.createCartAnonymousEndpoint(), {
                                    branchId: Number(branchIdValue)
                                })
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            error = _state.sent();
                            (0,Shopping_data/* handleCartError */.p)(error, appMonitoringClient, "create_cart_anonymous");
                            return [
                                2,
                                null
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(branchId, appMonitoringClient) {
                return _ref.apply(this, arguments);
            };
        }();
        this.addItemsCartEndpoint = function(cartId) {
            return "".concat(_this.baseUrl, "v1/carts/").concat(cartId, "/cart-items");
        };
        var _this4 = this;
        this.addItemsCart = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(_param, appMonitoringClient, jwt) {
                var cartId, args, headers, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cartId = _param.cartId, args = (0,_object_without_properties/* default */.Z)(_param, [
                                "cartId"
                            ]);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            headers = {
                                "Content-Type": applicationJson
                            };
                            if (jwt) {
                                headers.Authorization = "Bearer ".concat(jwt);
                            }
                            return [
                                4,
                                _this4.httpClient.usePost(_this4.addItemsCartEndpoint(cartId), (0,_object_spread/* default */.Z)({
                                    cartId: cartId
                                }, args), {
                                    headers: headers
                                })
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            error = _state.sent();
                            (0,Shopping_data/* handleCartError */.p)(error, appMonitoringClient, "add_item_to_cart");
                            return [
                                2,
                                null
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_param, appMonitoringClient, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this5 = this;
        this.addItemsCartByServer = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(_param, jwt) {
                var cartId, args, headers, response, data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cartId = _param.cartId, args = (0,_object_without_properties/* default */.Z)(_param, [
                                "cartId"
                            ]);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            headers = {
                                "Content-Type": applicationJson
                            };
                            if (jwt) {
                                headers.Authorization = "Bearer ".concat(jwt);
                            }
                            return [
                                4,
                                fetch(_this5.addItemsCartEndpoint(cartId !== null && cartId !== void 0 ? cartId : 0), {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": applicationJson,
                                        Authorization: "Bearer ".concat(jwt)
                                    },
                                    body: JSON.stringify((0,_object_spread/* default */.Z)({
                                        cartId: cartId
                                    }, args))
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            data = _state.sent();
                            return [
                                2,
                                {
                                    data: data,
                                    error: null,
                                    isLoading: false,
                                    status: response.status,
                                    statusCode: response.status
                                }
                            ];
                        case 4:
                            error = _state.sent();
                            return [
                                2,
                                null
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_param, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.updateQuantityItemEndpoint = function(cartId, cartItemId) {
            return "".concat(_this.baseUrl, "v1/carts/").concat(cartId, "/cart-items/").concat(cartItemId);
        };
        var _this6 = this;
        this.updateQuantityItemCart = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param, appMonitoringClient, jwt) {
                var cartId, idProductCart, quantity, body, headers, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cartId = param.cartId, idProductCart = param.idProductCart, quantity = param.quantity;
                            body = [
                                {
                                    op: "replace",
                                    path: "/Quantity",
                                    value: quantity
                                }
                            ];
                            headers = {
                                "Content-Type": aplicationJsonPatch
                            };
                            if (jwt) {
                                headers.Authorization = "Bearer ".concat(jwt);
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this6.httpClient.usePatch(_this6.updateQuantityItemEndpoint(cartId, idProductCart), headers, body)
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            error = _state.sent();
                            (0,Shopping_data/* handleCartError */.p)(error, appMonitoringClient, "update_item_to_cart");
                            return [
                                2,
                                null
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_, appMonitoringClient, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this7 = this;
        this.updateQuantityItemCartByServer = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param, appMonitoringClient, jwt) {
                var cartId, idProductCart, quantity, body, headers, response, data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cartId = param.cartId, idProductCart = param.idProductCart, quantity = param.quantity;
                            body = [
                                {
                                    op: "replace",
                                    path: "/Quantity",
                                    value: quantity
                                }
                            ];
                            headers = {
                                "Content-Type": aplicationJsonPatch
                            };
                            if (jwt) {
                                headers.Authorization = "Bearer ".concat(jwt);
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            response = fetch(_this7.updateQuantityItemEndpoint(cartId, idProductCart), {
                                method: "PATCH",
                                headers: {
                                    "Content-Type": aplicationJsonPatch,
                                    Authorization: "Bearer ".concat(jwt)
                                },
                                body: JSON.stringify(body)
                            });
                            return [
                                4,
                                response
                            ];
                        case 2:
                            data = _state.sent().json();
                            return [
                                2,
                                {
                                    data: data,
                                    error: null,
                                    isLoading: false
                                }
                            ];
                        case 3:
                            error = _state.sent();
                            (0,Shopping_data/* handleCartError */.p)(error, appMonitoringClient, "update_item_to_cart");
                            return [
                                2,
                                null
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_, appMonitoringClient, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.removeItemCartEndpoint = function(cartId, cartItemId) {
            return "".concat(_this.baseUrl, "v1/carts/").concat(cartId, "/cart-items/").concat(cartItemId);
        };
        var _this8 = this;
        this.removeItemCart = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param, appMonitoringClient, jwt) {
                var cartId, idProductCart, headers, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cartId = param.cartId, idProductCart = param.idProductCart;
                            headers = {};
                            if (jwt) {
                                headers.Authorization = "Bearer ".concat(jwt);
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this8.httpClient.useDelete(_this8.removeItemCartEndpoint(cartId, idProductCart), headers, {
                                    id: idProductCart,
                                    cartId: cartId
                                })
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            error = _state.sent();
                            (0,Shopping_data/* handleCartError */.p)(error, appMonitoringClient, "remove_item_from_cart");
                            return [
                                2,
                                !!error
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_, appMonitoringClient, jwt) {
                return _ref.apply(this, arguments);
            };
        }();
        this.deleteProductsCartEndpoint = function(cartId) {
            return "".concat(_this.baseUrl, "v1/carts/").concat(cartId, "/cart-items/package");
        };
        var _this9 = this;
        this.deleteProductsCart = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(cartId, appMonitoringClient, productIdList, accessToken) {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this9.httpClient.useDelete(_this9.deleteProductsCartEndpoint(cartId), {
                                    Authorization: "Bearer ".concat(accessToken)
                                }, productIdList)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            (0,Shopping_data/* handleCartError */.p)(error, appMonitoringClient, "delete_item_in_payment");
                            return [
                                2,
                                !!error
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(cartId, appMonitoringClient, productIdList, accessToken) {
                return _ref.apply(this, arguments);
            };
        }();
        if (!this.baseUrl) {
            var ref = this.envsApi.getRawEnvImmediately("APIS_BASE_URL"), apisBaseUrl = ref.data;
            var fallback = (0,utils/* getApisUrlFallback */.TW)(Shopping_process.env.HOST_ENV);
            this.baseUrl = "".concat(apisBaseUrl || fallback, "shopping/");
        }
        this.appMonitoringClient = appMonitoringClient;
    }
    var _proto = ShoppingApi.prototype;
    _proto.setBaseUrl = function setBaseUrl(url) {
        this.baseUrl = url;
    };
    return ShoppingApi;
}();


;// CONCATENATED MODULE: ../../packages/application/services/apis/index.ts
















/***/ }),

/***/ 25990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JR": function() { return /* binding */ paymentOptionsData; }
/* harmony export */ });
/* unused harmony export linkOptionsData */
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26365);

var paymentOptionsData = [
    {
        title: "Formas de pagamento",
        options: [
            {
                title: "Cr\xe9dito",
                images: [
                    {
                        src: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/pagamentos/bandeiras/Visa.svg",
                        alt: "Visa",
                        width: "41px",
                        height: "27px"
                    },
                    {
                        src: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/pagamentos/bandeiras/MasterCard.svg",
                        alt: "MasterCard",
                        width: "41px",
                        height: "27px"
                    },
                    {
                        src: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/pagamentos/bandeiras/Elo.svg",
                        alt: "Elo",
                        width: "41px",
                        height: "27px"
                    },
                    {
                        src: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/pagamentos/bandeiras/Hipercard.svg",
                        alt: "Hipercard",
                        width: "41px",
                        height: "27px"
                    },
                    {
                        src: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/pagamentos/bandeiras/Amex.svg",
                        alt: "Amex",
                        width: "41px",
                        height: "27px"
                    },
                    {
                        src: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/pagamentos/bandeiras/dinners.svg",
                        alt: "Dinners",
                        width: "41px",
                        height: "27px"
                    }, 
                ]
            },
            {
                title: "Pix",
                images: [
                    {
                        src: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/pagamentos/icon_pix.png",
                        alt: "Pix",
                        width: "24px",
                        height: "24px"
                    }, 
                ]
            }, 
        ]
    }, 
];
var linkOptionsData = [
    {
        title: "Lojas e Servi\xe7os",
        style: {
            borderBottom: true
        },
        icon: {
            title: "store",
            color: ui__WEBPACK_IMPORTED_MODULE_0__.theme.colors.primary[200],
            width: 24,
            height: 24
        },
        options: [
            {
                title: "Nossas Lojas",
                link: {
                    title: "Nossas Lojas",
                    href: "https://ferreiracosta.movidesk.com/kb/article/156436/nossas-lojas?ticketId=&q="
                }
            },
            {
                title: "Lista de Casamento",
                link: {
                    title: "Lista de Casamento",
                    href: "/lista-de-casamento"
                }
            },
            {
                title: "Clube do Profissional",
                link: {
                    title: "Clube do Profissional",
                    href: "https://clubedoprofissional.ferreiracosta.com/"
                }
            },
            {
                title: "Trabalhe Conosco",
                link: {
                    title: "Trabalhe Conosco",
                    href: "https://carreiras.ferreiracosta.com"
                }
            },
            {
                title: "Televendas",
                link: {
                    title: "Televendas",
                    href: "https://ferreiracosta.movidesk.com/kb/article/156443/qual-o-horario-de-funcionamento-e-contatos-do-vendas-corporativa?ticketId=&q="
                }
            },
            {
                title: "Institucional",
                link: {
                    title: "Institucional",
                    href: "https://ferreiracosta.movidesk.com/kb/pt-br/category/institucional?ticketId=&q=&kbCategoryId=50244"
                }
            }, 
        ]
    },
    {
        title: "D\xfavidas",
        style: {
            borderBottom: true
        },
        icon: {
            title: "headPhone",
            color: ui__WEBPACK_IMPORTED_MODULE_0__.theme.colors.primary[200],
            width: 24,
            height: 24
        },
        options: [
            {
                title: "Central de Atendimento",
                link: {
                    title: "Central de Atendimento",
                    href: "https://ferreiracosta.movidesk.com/kb/"
                }
            },
            {
                title: "Condi\xe7\xf5es de Uso do Site",
                link: {
                    title: "Condi\xe7\xf5es de Uso do Site",
                    href: "https://ferreiracosta.movidesk.com/kb/article/156348/termos-e-condicoes-de-uso-do-site?ticketId=&q="
                }
            },
            {
                title: "Pol\xedtica de Entrega",
                link: {
                    title: "Pol\xedtica de Entrega",
                    href: "https://ferreiracosta.movidesk.com/kb/article/156345/politica-de-entrega-da-ferreira-costa?ticketId=&q="
                }
            },
            {
                title: "Pol\xedtica de Privacidade",
                link: {
                    title: "Pol\xedtica de Privacidade",
                    href: "https://ferreiracosta.movidesk.com/kb/article/158335/politica-de-privacidade-do-site-da-ferreira-costa?ticketId=&q="
                }
            },
            {
                title: "Pol\xedtica de Trocas e Devolu\xe7\xf5es",
                link: {
                    title: "Pol\xedtica de Trocas e Devolu\xe7\xf5es",
                    href: "https://ferreiracosta.movidesk.com/kb/article/156334/politica-de-troca-e-devolucao-de-produtos-da-ferreira-costa"
                }
            },
            {
                title: "C\xf3digo de \xc9tica e Conduta",
                link: {
                    title: "C\xf3digo de \xc9tica e Conduta",
                    href: "https://relatoconfidencial.com.br/ferreiracosta/codigo_de_etica_conduta.pdf"
                }
            },
            {
                title: "Canal de \xc9tica e Conduta",
                link: {
                    title: "Canal de \xc9tica e Conduta",
                    href: "https://relatoconfidencial.com.br/ferreiracosta/"
                }
            }, 
        ]
    },
    {
        title: "Redes Sociais",
        style: {
            borderBottom: true
        },
        icon: {
            title: "share",
            color: ui__WEBPACK_IMPORTED_MODULE_0__.theme.colors.primary[200],
            width: 24,
            height: 24
        },
        options: [
            {
                title: "Facebook",
                link: {
                    title: "Facebook",
                    href: "https://www.facebook.com/FerreiraCosta"
                }
            },
            {
                title: "Instagram",
                link: {
                    title: "Instagram",
                    href: "https://www.instagram.com/ferreiracosta/"
                }
            },
            {
                title: "Spotify",
                link: {
                    title: "Spotify",
                    href: "https://open.spotify.com/user/kbze0z3zou1bdqjlws8a04egl?si=e1DSfrsMQqWv50B9oIf0-w"
                }
            },
            {
                title: "LinkedIn",
                link: {
                    title: "LinkedIn",
                    href: "https://www.linkedin.com/company/ferreiracosta/"
                }
            }, 
        ]
    }, 
];
var allData = {
    linkOptionsData: linkOptionsData,
    paymentOptionsData: paymentOptionsData
};

/* harmony default export */ __webpack_exports__["ZP"] = (allData);


/***/ }),

/***/ 49294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oA": function() { return /* reexport */ supportContactHandlers; },
  "H8": function() { return /* reexport */ utilInfoHandlers; }
});

// UNUSED EXPORTS: dataInsiderAPI, linkOptionsData, paymentOptionsData

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
;// CONCATENATED MODULE: ../../packages/application/services/mocks/utils.ts


var mockAsyncHttpRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    return(// eslint-disable-next-line no-promise-executor-return
                    setTimeout(function() {
                        resolve(data);
                    }, Math.floor(Math.random() * 750)));
                })
            ];
        });
    });
    return function mockAsyncHttpRequest(data) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ../../packages/application/services/mocks/SupportContact/data.ts
var data = [
    {
        mainIcon: {
            title: "phone"
        },
        title: "Compre por telefone",
        description: "Nosso servi\xe7o de televendas est\xe1 dispon\xedvel",
        link: {
            title: "saiba mais >",
            href: "https://ferreiracosta.movidesk.com/kb/article/156443/qual-o-horario-de-funcionamento-e-contatos-do-vendas-corporativa?ticketId=&q="
        }
    },
    {
        mainIcon: {
            title: "headPhone"
        },
        title: "Central de Atendimento",
        description: "Tire suas d\xfavidas sobre qualquer assunto",
        link: {
            title: "acesse a central >",
            href: "https://ferreiracosta.movidesk.com/kb/"
        }
    },
    {
        mainIcon: {
            title: "share"
        },
        title: "Nossas redes sociais",
        secondaryIcons: [
            {
                title: "facebook",
                link: "https://www.facebook.com/FerreiraCosta"
            },
            {
                title: "instagram",
                link: "https://www.instagram.com/ferreiracosta/"
            },
            {
                title: "spotify",
                link: "https://open.spotify.com/user/kbze0z3zou1bdqjlws8a04egl?si=e1DSfrsMQqWv50B9oIf0-w"
            },
            {
                title: "linkedIn",
                link: "https://www.linkedin.com/company/ferreiracosta/"
            },
            {
                title: "pinterest",
                link: "https://br.pinterest.com/homecenterferreiracosta/"
            },
            {
                title: "youtube",
                link: "https://www.youtube.com/@CanalFerreiraCosta"
            }, 
        ]
    }, 
];
/* harmony default export */ var SupportContact_data = (data);

;// CONCATENATED MODULE: ../../packages/application/services/mocks/SupportContact/index.ts
// import { rest } from "msw";




// export const supportContactHandlers = [
//     rest.get("/support-contact/options", (req, res, ctx) => {
//         return res(ctx.json(data));
//     }),
// ];
var supportContactHandlers = {
    "/support-contact/options": /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                mockAsyncHttpRequest(SupportContact_data)
            ];
        });
    })
};

// EXTERNAL MODULE: ../../packages/application/services/mocks/UtilInfo/data.ts
var UtilInfo_data = __webpack_require__(25990);
;// CONCATENATED MODULE: ../../packages/application/services/mocks/UtilInfo/index.ts
// import { rest } from "msw";




var paymentOptionsData = UtilInfo_data/* default.paymentOptionsData */.ZP.paymentOptionsData, linkOptionsData = UtilInfo_data/* default.linkOptionsData */.ZP.linkOptionsData;
// export const utilInfoHandlers = [
//     rest.get("/util-info/payment-options", (req, res, ctx) => {
//         return res(ctx.json(paymentOptionsData));
//     }),
//     rest.get("/util-info/link-options", (req, res, ctx) => {
//         return res(ctx.json(linkOptionsData));
//     }),
// ];

var utilInfoHandlers = {
    "/util-info/payment-options": /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                mockAsyncHttpRequest(paymentOptionsData)
            ];
        });
    }),
    "/util-info/link-options": /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                mockAsyncHttpRequest(linkOptionsData)
            ];
        });
    })
};

;// CONCATENATED MODULE: ../../packages/application/services/mocks/RecommendedProductsInsider/index.tsx
var dataInsiderAPI = {
    campaignId: 121,
    products: [
        {
            item_id: "214"
        },
        {
            item_id: "231597"
        },
        {
            item_id: "461331"
        },
        {
            item_id: "342859"
        },
        {
            item_id: "451578"
        },
        {
            item_id: "460760"
        },
        {
            item_id: "252611"
        },
        {
            item_id: "443128"
        },
        {
            item_id: "450326"
        },
        {
            item_id: "342884"
        }, 
    ],
    variationId: 248
};

;// CONCATENATED MODULE: ../../packages/application/services/mocks/index.ts





/***/ }),

/***/ 80759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ createStore; },
/* harmony export */   "N": function() { return /* binding */ useShallow; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40624);
/* harmony import */ var zustand_react_shallow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94534);


var createStore = zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue;
var useShallow = zustand_react_shallow__WEBPACK_IMPORTED_MODULE_1__/* .useShallow */ .N;



/***/ }),

/***/ 74224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VY": function() { return /* reexport */ useAlert; },
  "JL": function() { return /* reexport */ useAuthentication; },
  "R4": function() { return /* reexport */ useBlackFriday; },
  "L_": function() { return /* reexport */ useCategories; },
  "dp": function() { return /* reexport */ useChatbot; },
  "wA": function() { return /* reexport */ useConfirmationTypes; },
  "Cf": function() { return /* reexport */ useCounter; },
  "K3": function() { return /* reexport */ useCrm; },
  "HS": function() { return /* reexport */ useEnvs; },
  "L0": function() { return /* reexport */ useFilter; },
  "CE": function() { return /* reexport */ useGiftCard; },
  "VQ": function() { return /* reexport */ useLoginAuthentication; },
  "_I": function() { return /* reexport */ useMyCards; },
  "Lq": function() { return /* reexport */ useOrderStore; },
  "tm": function() { return /* reexport */ usePurchaseStore; },
  "KH": function() { return /* reexport */ useRegisterPhoneNumber; },
  "Yu": function() { return /* reexport */ security/* useSecurityStore */.Y; },
  "NL": function() { return /* reexport */ adapter/* useShallow */.N; },
  "kD": function() { return /* reexport */ useTwoFactor; },
  "NG": function() { return /* reexport */ useUniqueClient; }
});

// UNUSED EXPORTS: createStore, usePurchaseShallow, useWeddingList

// EXTERNAL MODULE: ../../packages/application/state-manager/adapter.ts
var adapter = __webpack_require__(80759);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
;// CONCATENATED MODULE: ../../packages/application/state-manager/authentication/index.ts


var useAuthentication = (0,adapter/* createStore */.M)(function(set) {
    return {
        isAuthenticationDropdownActive: false,
        isAuthenticationModalActive: false,
        setIsAuthenticationDropdownActive: function(value) {
            set((0,_object_spread/* default */.Z)({
                isAuthenticationDropdownActive: value
            }, !value && {
                currentStep: "login"
            }));
        },
        currentStep: "login",
        changeCurrentStep: function(value) {
            set({
                currentStep: value
            });
        },
        closeAuthenticationModal: function() {
            return set({
                currentStep: "login",
                isAuthenticationDropdownActive: false,
                isAuthenticationModalActive: false
            });
        },
        setIsAuthenticationModalActive: function(value) {
            set((0,_object_spread/* default */.Z)({
                isAuthenticationModalActive: value
            }, !value && {
                currentStep: "login"
            }));
        },
        userIdentification: "",
        setUserIdentification: function(value) {
            return set({
                userIdentification: value
            });
        },
        identificationType: "email",
        setIdentificationType: function(value) {
            return set({
                identificationType: value
            });
        },
        isChangePasswordDueToPurchase: false,
        setChangePasswordDueToPurchase: function(value) {
            return set({
                isChangePasswordDueToPurchase: value
            });
        }
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/blackFriday/index.ts

var useBlackFriday = (0,adapter/* createStore */.M)(function(set) {
    return {
        isBlackFridayTheme: false,
        setIsBlackFridayTheme: function(value) {
            return set({
                isBlackFridayTheme: value
            });
        }
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/chatbot/index.ts

var useChatbot = (0,adapter/* createStore */.M)(function(set) {
    return {
        showChatbot: false,
        setShowChatbot: function(value) {
            set({
                showChatbot: value
            });
        },
        showSaleChatbot: false,
        setShowSaleChatbot: function(value) {
            set({
                showSaleChatbot: value
            });
        }
    };
});


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
;// CONCATENATED MODULE: ../../packages/application/state-manager/confirmationTypes/index.ts



var useConfirmationTypes = (0,adapter/* createStore */.M)(function(set, get) {
    return {
        hasPendency: false,
        isLoading: false,
        canChooseAnotherMethod: false,
        availableMethods: null,
        setAvailableMethods: function(value) {
            set({
                hasPendency: !(value === null || value === void 0 ? void 0 : value.emailConfirmed) || !(value === null || value === void 0 ? void 0 : value.phoneNumberConfirmed),
                availableMethods: value,
                canChooseAnotherMethod: (value === null || value === void 0 ? void 0 : value.emailConfirmed) && (value === null || value === void 0 ? void 0 : value.phoneNumberConfirmed) || !(value === null || value === void 0 ? void 0 : value.emailConfirmed) && !(value === null || value === void 0 ? void 0 : value.phoneNumberConfirmed)
            });
        },
        getAvailableMethods: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(accessToken, identityApi, email, cpf) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    try {
                        if (accessToken) {
                            set({
                                isLoading: true
                            });
                            identityApi.receiveConfirmationTypes({
                                email: String(email),
                                cpf: String(cpf),
                                jwt: String(accessToken)
                            }).then(function(param) {
                                var data = param.data;
                                get().setAvailableMethods(data || null);
                                return data || null;
                            });
                        }
                        return [
                            2,
                            null
                        ];
                    } catch (e) {
                        set({
                            availableMethods: null,
                            canChooseAnotherMethod: false
                        });
                        return [
                            2,
                            undefined
                        ];
                    } finally{
                        set({
                            isLoading: false
                        });
                    }
                    return [
                        2
                    ];
                });
            });
            return function(accessToken, identityApi, email, cpf) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/counter/index.ts

var useCounter = (0,adapter/* createStore */.M)(function(set) {
    return {
        isCodeTimerActive: false,
        setCodeTimerActive: function(value) {
            return set({
                isCodeTimerActive: value
            });
        },
        isSendCodeAvailable: true,
        setIsSendCodeAvailable: function(value) {
            return set({
                isSendCodeAvailable: value
            });
        },
        initTimer: false,
        setInitTimer: function(initTimer) {
            return set({
                initTimer: initTimer
            });
        },
        countdownTime: 0,
        setCountdownTime: function(countdownTime) {
            return set({
                countdownTime: countdownTime
            });
        },
        updateTimer: function(faType, channel, retryTokenDate) {
            var retryTime = new Date(new Date(retryTokenDate).getTime() - 3 * 60 * 60 * 1000);
            var remainingTime = Math.floor((retryTime.getTime() - Date.now()) / 1000);
            set({
                countdownTime: remainingTime
            });
            localStorage.setItem("countdownTime_".concat(faType, "_").concat(channel), remainingTime.toString());
            localStorage.setItem("countdownTimeTimestamp_".concat(faType, "_").concat(channel), Date.now().toString());
        }
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/crm/index.ts
// import { IStateManager } from "../../entities";

var useCrm = (0,adapter/* createStore */.M)(function(set, get) {
    return {
        userCrmId: null,
        setUserCrmId: function(userCrmId) {
            if (get().userCrmId !== userCrmId) {
                set({
                    userCrmId: userCrmId
                });
            }
        }
    };
});
// type StateCallback<T> = (state: CrmProps) => T;
// let crmStore: <T>(state: StateCallback<T>) => T;
// let crmStore: CrmProps | undefined;
// const useCrm = (stateManager: IStateManager) => {
//   const createCrmStore = (usedStateManager: IStateManager) => {
//     return usedStateManager.createStore<CrmProps, CrmState>((set) => ({
//       userId: "",
//       userEmail: "",
//       setUserId: (userId: string) => {
//         set({
//           userId,
//         });
//       },
//       setUserEmail: (userEmail: string) => set({ userEmail }),
//     }));
//   };
//   if (crmStore) {
//     return crmStore;
//   }
//   crmStore = createCrmStore(stateManager) as <T>(state: StateCallback<T>) => T;
//   Object.freeze(crmStore);
//   return crmStore;
// };


;// CONCATENATED MODULE: ../../packages/application/state-manager/envs/index.tsx

var useEnvs = (0,adapter/* createStore */.M)(function(set) {
    return {
        allConfigs: null,
        setAllConfigs: function(allConfigs) {
            return set({
                allConfigs: allConfigs
            });
        }
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/gift-card/index.ts

var useGiftCard = (0,adapter/* createStore */.M)(function(set) {
    return {
        sentSMSToken: null,
        setSentSMSToken: function(sentSMSToken) {
            set({
                sentSMSToken: sentSMSToken
            });
        }
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/loginAuthentication/index.ts

var useLoginAuthentication = (0,adapter/* createStore */.M)(function(set) {
    return {
        currentStep: "firstStep",
        isLoginAuthenticationModalOpen: false,
        changeLoginStep: function(value) {
            set({
                currentStep: value
            });
        },
        setIsLoginAuthenticationModalOpen: function(value) {
            return set({
                isLoginAuthenticationModalOpen: value
            });
        },
        isPhoneValidationModalOpen: false,
        setIsPhoneValidationModalOpen: function(value) {
            return set({
                isPhoneValidationModalOpen: value
            });
        },
        validationStep: "modalCall",
        changeValidationStep: function(value) {
            set({
                validationStep: value
            });
        }
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/myCards/index.ts

var useMyCards = (0,adapter/* createStore */.M)(function(set) {
    return {
        createdAddress: null,
        setCreatedAddress: function(createdAddress) {
            set({
                createdAddress: createdAddress
            });
        }
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/orderAlert/index.ts

var useAlert = (0,adapter/* createStore */.M)(function(set) {
    return {
        isAlertOpen: false,
        setIsAlertOpen: function(value) {
            set({
                isAlertOpen: value
            });
        },
        hasPendingOrders: false,
        setHasPendingOrders: function(value) {
            set({
                hasPendingOrders: value
            });
        }
    };
});


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ../../packages/application/constraints/index.ts
var lastThirtyDaysValue = [
    "\xdaltimos 30 dias",
    "Este m\xeas"
];
var thisYearValue = [
    "Este ano",
    "Esse ano"
];
var selectDateValue = [
    "Selecionar per\xedodo",
    "Selecionar o ano"
];

// EXTERNAL MODULE: ../../packages/application/utils/index.tsx + 44 modules
var utils = __webpack_require__(83428);
;// CONCATENATED MODULE: ../../packages/application/state-manager/orderFilter/index.ts




var DATE_FILTERS = {
    0: "",
    1: "\xdaLTIMOS 30 DIAS",
    3: "\xdaLTIMOS 3 MESES",
    6: "\xdaLTIMOS 6 MESES",
    12: "ESTE ANO"
};
var getStatus = function(status) {
    switch(status){
        case "em transporte":
            return "Shipping";
        case "pagamento aprovado":
            return "InProgress";
        case "aguardando pagamento":
            return "Pending";
        case "em manuten\xe7\xe3o":
            return "Pending";
        case "entregue":
        case "retirado":
            return "Concluded";
        case "cancelado":
            return "Cancelled";
        case "entrega prevista":
        case "pronto para retirada":
            return "Shipping";
        default:
            return "All";
    }
};
var getDate = function(date, selectedYear) {
    var ref;
    var today = new Date();
    var formatDateFilter = (ref = date.split("-")) === null || ref === void 0 ? void 0 : ref[0];
    if (lastThirtyDaysValue.includes(formatDateFilter)) {
        var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        return {
            startDate: (0,utils/* formatDate */.p6)(firstDayOfMonth),
            endDate: (0,utils/* formatDate */.p6)(today)
        };
    }
    if (formatDateFilter === null || formatDateFilter === void 0 ? void 0 : formatDateFilter.includes("M\xeas passado")) {
        var firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        var lastDayOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        return {
            startDate: (0,utils/* formatDate */.p6)(firstDayOfLastMonth),
            endDate: (0,utils/* formatDate */.p6)(lastDayOfLastMonth)
        };
    }
    if (formatDateFilter === null || formatDateFilter === void 0 ? void 0 : formatDateFilter.includes("\xdaltimos 3 meses")) {
        var firstDayOfLastThreeMonths = new Date(today.getFullYear(), today.getMonth() - 3, 1);
        return {
            startDate: (0,utils/* formatDate */.p6)(firstDayOfLastThreeMonths),
            endDate: (0,utils/* formatDate */.p6)(today)
        };
    }
    if (thisYearValue.includes(formatDateFilter)) {
        var firstDayOfYear = new Date(today.getFullYear(), 0, 1);
        return {
            startDate: (0,utils/* formatDate */.p6)(firstDayOfYear),
            endDate: (0,utils/* formatDate */.p6)(today)
        };
    }
    if (selectDateValue.includes(formatDateFilter) && selectedYear) {
        var firstDayOfYear1 = new Date(selectedYear, 0, 1);
        var lastDayOfYear = new Date(selectedYear, 11, 31);
        return {
            startDate: (0,utils/* formatDate */.p6)(firstDayOfYear1),
            endDate: (0,utils/* formatDate */.p6)(lastDayOfYear)
        };
    }
    return {
        startDate: undefined,
        endDate: undefined
    };
};
var useFilter = (0,adapter/* createStore */.M)(function(set, get) {
    return {
        removeFilter: function(filter) {
            set(function(state) {
                var updatedFilters = state.selectedFilters.filter(function(selectedFilter) {
                    return selectedFilter !== filter;
                });
                return {
                    selectedFilters: updatedFilters
                };
            });
        },
        currentPage: 1,
        setCurrentPage: function setCurrentPage(page) {
            set({
                currentPage: page
            });
        },
        handleCheckboxChange: function(optionText, isChecked) {
            set(function(state) {
                var updatedFilters = (0,_to_consumable_array/* default */.Z)(state.selectedFilters);
                var categories = [
                    {
                        regex: /status/i,
                        name: "status"
                    },
                    {
                        regex: /data/i,
                        name: "data"
                    },
                    {
                        regex: /onde comprei/i,
                        name: "onde comprei"
                    },
                    {
                        regex: /tipo de pedido/i,
                        name: "tipo de pedido"
                    }, 
                ];
                if (isChecked) {
                    var selectedColumn = categories.find(function(param) {
                        var regex = param.regex;
                        return regex.test(optionText);
                    });
                    if (selectedColumn) {
                        var regex = selectedColumn.regex;
                        var existingOption = updatedFilters.findIndex(function(filter) {
                            return regex.test(filter);
                        });
                        if (existingOption !== -1) {
                            updatedFilters[parseInt(String(existingOption), 10)] = optionText;
                        } else {
                            updatedFilters = updatedFilters.filter(function(filter) {
                                return !regex.test(filter);
                            });
                            updatedFilters.push(optionText);
                        }
                    }
                } else {
                    updatedFilters.splice(updatedFilters.indexOf(optionText), 1);
                }
                return {
                    selectedFilters: updatedFilters
                };
            });
        },
        hasFiltersApplied: false,
        applyFilters: function(isNewFilter) {
            set(function(state) {
                var ref, ref1, ref2, ref3;
                var allValue = isNewFilter ? "Todos" : "All";
                var statusFilter = (ref1 = (ref = state.selectedFilters.find(function(value) {
                    return value.toLowerCase().includes("status");
                })) === null || ref === void 0 ? void 0 : ref.split("-")) === null || ref1 === void 0 ? void 0 : ref1[0];
                var dateFilter = state.selectedFilters.find(function(value) {
                    return value.includes("Data");
                });
                var orderTypeFilter = state.selectedFilters.find(function(value) {
                    return value.includes("Tipo de pedido");
                });
                var saleChannelFilter = state.selectedFilters.find(function(value) {
                    return value.includes("Onde comprei");
                });
                var filterStatus = isNewFilter ? statusFilter : getStatus(statusFilter === null || statusFilter === void 0 ? void 0 : statusFilter.toLowerCase());
                var selectedSaleChannel = function() {
                    var ref;
                    var saleChannel = (ref = saleChannelFilter === null || saleChannelFilter === void 0 ? void 0 : saleChannelFilter.split("-")) === null || ref === void 0 ? void 0 : ref[0];
                    if (saleChannel === "Loja") {
                        return 1;
                    }
                    if (saleChannel === "Site") {
                        return 2;
                    }
                    if (saleChannel === "App") {
                        return 4;
                    }
                    return undefined;
                };
                var filterCollection = state.selectedFilters.filter(function(filter) {
                    var type = filter.split("-")[1].toLowerCase();
                    return type === "status" || type === "onde comprei";
                }).map(function(filter) {
                    return filter.split("-")[0];
                });
                var validateFiltersApplied = statusFilter !== allValue || dateFilter || orderTypeFilter || saleChannelFilter;
                if (validateFiltersApplied) {
                    state.defineLabelTexts({});
                }
                return {
                    status: statusFilter ? filterStatus : allValue,
                    isGift: orderTypeFilter ? ((ref2 = orderTypeFilter.split("-")) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === "lista de casamento" : undefined,
                    saleChannel: selectedSaleChannel(),
                    startDate: dateFilter ? getDate(dateFilter, state.selectedYear).startDate : undefined,
                    endDate: dateFilter ? getDate(dateFilter, state.selectedYear).endDate : undefined,
                    hasFiltersApplied: validateFiltersApplied,
                    filtersToSend: filterCollection,
                    currentPage: 1
                };
            });
            return {
                currentPage: get().currentPage,
                status: get().status,
                isGift: get().isGift,
                saleChannel: get().saleChannel,
                startDate: get().startDate,
                endDate: get().endDate,
                filters: get().filtersToSend
            };
        },
        clearFilters: function(options) {
            set(function(state) {
                if (options === null || options === void 0 ? void 0 : options.monthsReturned) {
                    state.defineLabelTexts({
                        periodOfLastPurchase: options === null || options === void 0 ? void 0 : options.monthsReturned
                    });
                }
                return {
                    selectedFilters: [],
                    filtersApplied: [],
                    isOpen: false,
                    selectedYear: null,
                    startDate: undefined,
                    endDate: undefined,
                    status: "All",
                    isGift: undefined,
                    saleChannel: undefined,
                    currentPage: 1,
                    hasFiltersApplied: false,
                    filtersToSend: undefined
                };
            });
        },
        filtersApplied: [],
        setFiltersApplied: function() {
            set(function(state) {
                return {
                    filtersApplied: state.filtersApplied
                };
            });
        },
        isOpen: false,
        setIsOpen: function(value) {
            set({
                isOpen: value
            });
        },
        closeFilter: function() {
            set({
                isOpen: false
            });
        },
        selectedYear: null,
        setSelectedYear: function(year) {
            set({
                selectedYear: year
            });
        },
        setFilters: function setFilters(filters) {
            set({
                filters: filters
            });
        },
        filters: [],
        selectedFilters: [],
        startDate: undefined,
        endDate: undefined,
        saleChannel: undefined,
        status: "All",
        isGift: undefined,
        showSelectYearDropdown: false,
        setShowSelectYearDropdown: function(isSelected) {
            set({
                showSelectYearDropdown: isSelected
            });
        },
        labelTexts: {
            resultText: ""
        },
        setLabelTexts: function setLabelTexts(resultText) {
            set({
                labelTexts: {
                    resultText: resultText
                }
            });
        },
        // eslint-disable-next-line sonarjs/cognitive-complexity
        defineLabelTexts: function defineLabelTexts(param) {
            var periodOfLastPurchase = param.periodOfLastPurchase, typedTerm = param.typedTerm;
            set(function(state) {
                var ref;
                var preSelectedDataFilter = periodOfLastPurchase ? DATE_FILTERS["".concat(periodOfLastPurchase)] : "";
                var dateFilterSelected = ((ref = state.selectedFilters) === null || ref === void 0 ? void 0 : ref.filter(function(filter) {
                    return filter.toLowerCase().includes("data");
                })[0]) || "";
                var dateFilter = (0,utils/* capitalize */.kC)(dateFilterSelected.split("-")[0]);
                var isSelectYearSelected = Boolean((dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.toLowerCase().includes("selecionar")) && state.selectedYear);
                var hasTypedTerm = Boolean(typedTerm !== "" && typeof typedTerm !== "undefined");
                var hasDateFilterSelected = Boolean(!dateFilter.toLowerCase().includes("selecionar") && dateFilter);
                var hasPreSelectedDataFilter = preSelectedDataFilter !== "" && typeof preSelectedDataFilter !== "undefined";
                var dateIndicatorText = hasTypedTerm ? 'Resultado para: "'.concat(typedTerm, '"') : isSelectYearSelected ? 'Resultados para "'.concat(state.selectedYear, '"') : hasDateFilterSelected ? dateFilter : hasPreSelectedDataFilter ? (0,utils/* capitalize */.kC)(preSelectedDataFilter) : "Resultado";
                return {
                    labelTexts: {
                        resultText: dateIndicatorText
                    }
                };
            });
        },
        setSelectedFilters: function setSelectedFilters(filters) {
            if (filters) {
                set({
                    selectedFilters: filters
                });
            }
        }
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/orders/index.ts

var useOrderStore = (0,adapter/* createStore */.M)(function(set, get) {
    return {
        isTrackingModalOpen: false,
        shouldShowMinimalistProductList: false,
        shouldShowVerticalProductList: false,
        url: "",
        order: null,
        isLoading: true,
        setShouldShowMinimalistProductList: function(shouldShowMinimalistProductList) {
            if (get().shouldShowMinimalistProductList !== shouldShowMinimalistProductList) {
                set({
                    shouldShowMinimalistProductList: shouldShowMinimalistProductList
                });
            }
        },
        setShouldShowVerticalProductList: function(shouldShowVerticalProductList) {
            if (get().shouldShowVerticalProductList !== shouldShowVerticalProductList) {
                set({
                    shouldShowVerticalProductList: shouldShowVerticalProductList
                });
            }
        },
        setIsTrackingModalOpen: function(isTrackingModalOpen) {
            if (get().isTrackingModalOpen !== isTrackingModalOpen) {
                set({
                    isTrackingModalOpen: isTrackingModalOpen
                });
            }
        },
        packageId: 0,
        setPackageId: function(packageId) {
            if (get().packageId !== packageId) {
                set({
                    packageId: packageId
                });
            }
        },
        orderHash: null,
        setOrderHash: function(orderHash) {
            if (get().orderHash !== orderHash) {
                set({
                    orderHash: orderHash
                });
            }
        },
        setOrder: function setOrder(order) {
            set({
                order: order
            });
        },
        setUrl: function setUrl(url) {
            set({
                url: url
            });
        },
        setIsLoading: function setIsLoading(isLoading) {
            if (get().isLoading !== isLoading) {
                set({
                    isLoading: isLoading
                });
            }
        }
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/purchase/index.ts


var usePurchaseStore = (0,adapter/* createStore */.M)(function(set, get) {
    return {
        purchaseProduct: [],
        productsFromCart: [],
        userBranchLocation: 0,
        setProductsFromCart: function(products) {
            if (get().productsFromCart !== products) {
                set({
                    productsFromCart: products
                });
            }
        },
        setBranchLocation: function(branchLocation) {
            if (get().userBranchLocation !== branchLocation) {
                set({
                    userBranchLocation: branchLocation
                });
            }
        },
        changePurchaseProducts: function(product, quantity) {
            var packaging = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            var ref;
            var productItem = product;
            var productGift = product;
            var idProduct = (productItem === null || productItem === void 0 ? void 0 : productItem.id) || (productGift === null || productGift === void 0 ? void 0 : productGift.productId);
            var cartItem = get().productsFromCart.find(function(productCart) {
                return productCart.productId === idProduct && productCart.package === packaging;
            });
            var purchaseProductAlreadyExists = get().purchaseProduct.some(function(productToPurchase) {
                return productToPurchase.productId === (cartItem === null || cartItem === void 0 ? void 0 : cartItem.productId) && productToPurchase.packaging === (cartItem === null || cartItem === void 0 ? void 0 : cartItem.package);
            });
            var ref1;
            var productPrice = (productItem === null || productItem === void 0 ? void 0 : (ref = productItem.prices) === null || ref === void 0 ? void 0 : ref.length) ? productItem === null || productItem === void 0 ? void 0 : productItem.prices[(ref1 = cartItem === null || cartItem === void 0 ? void 0 : cartItem.package) !== null && ref1 !== void 0 ? ref1 : packaging] : productGift === null || productGift === void 0 ? void 0 : productGift.price;
            if (!purchaseProductAlreadyExists && cartItem) {
                set(function(state) {
                    return {
                        purchaseProduct: (0,_to_consumable_array/* default */.Z)(state.purchaseProduct).concat([
                            {
                                idFamily: product === null || product === void 0 ? void 0 : product.family,
                                branchProduct: get().userBranchLocation,
                                description: (productItem === null || productItem === void 0 ? void 0 : productItem.description) || (productGift === null || productGift === void 0 ? void 0 : productGift.productName),
                                packaging: Number(cartItem === null || cartItem === void 0 ? void 0 : cartItem.package),
                                packagingQuantity: Number(cartItem === null || cartItem === void 0 ? void 0 : cartItem.packingQuantity),
                                price: productPrice,
                                productId: idProduct,
                                factPackaged: productItem === null || productItem === void 0 ? void 0 : productItem.factPackaged,
                                quantity: quantity
                            }, 
                        ])
                    };
                });
            }
        },
        clearPurchaseProducts: function() {
            set({
                purchaseProduct: []
            });
        }
    };
});


// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/application/state-manager/registerPhoneNumber/index.tsx


var useRegisterPhoneNumber = (0,adapter/* createStore */.M)(function(set) {
    return {
        isRegisterPhoneNumberModalOpen: false,
        currentStep: "modalCall",
        steps: [],
        setIsRegisterPhoneNumberModalOpen: function(value) {
            return set({
                isRegisterPhoneNumberModalOpen: value
            });
        },
        changeCurrentStep: function(value) {
            var newSteps = [
                {
                    name: "modalCall",
                    statusColor: value === "modalCall" ? "".concat(ui.theme.colors.secondary[380]) : "".concat(ui.theme.colors.secondary[37])
                },
                {
                    name: "validation",
                    statusColor: value === "validation" ? "".concat(ui.theme.colors.secondary[380]) : undefined
                }, 
            ];
            set({
                currentStep: value,
                steps: newSteps
            });
        },
        setSteps: function(value) {
            return set({
                steps: value
            });
        },
        phoneNumber: "",
        setPhoneNumber: function(value) {
            return set({
                phoneNumber: value
            });
        },
        openCheckoutModal: false,
        setOpenCheckoutModal: function(value) {
            return set({
                openCheckoutModal: value
            });
        }
    };
});


// EXTERNAL MODULE: ../../packages/application/state-manager/security/index.ts
var security = __webpack_require__(92073);
;// CONCATENATED MODULE: ../../packages/application/state-manager/twoFactorAuthentication/index.ts




var useTwoFactor = (0,adapter/* createStore */.M)(function(set, get) {
    return {
        initTimer: false,
        email: "",
        isValidatingCode: false,
        phoneNumber: "",
        tokenCode: "",
        isEmailDifferent: false,
        isTokenCodeValid: null,
        isBlockedToSendCode: false,
        isValidationActive: false,
        isSendCodeAvailable: true,
        validateCode: false,
        isUnderAction: false,
        isCodeTimerActive: false,
        isCodeComplete: false,
        hasAuthenticationMethodChanged: false,
        clientAction: null,
        canChooseAnotherTwoFactorMethod: false,
        setInitTimer: function(value) {
            return set({
                initTimer: value
            });
        },
        setIsEmailDifferent: function(value) {
            return set({
                isEmailDifferent: value
            });
        },
        setEmail: function(email) {
            return set(function(state) {
                return {
                    email: email,
                    isEmailDifferent: state.email !== email && state.email !== ""
                };
            });
        },
        setPhoneNumber: function(phoneNumber) {
            return set({
                phoneNumber: phoneNumber
            });
        },
        setIsValidationActive: function(isValidationActive) {
            return set({
                isValidationActive: isValidationActive
            });
        },
        setTokenCode: function(tokenCode) {
            return set({
                tokenCode: tokenCode
            });
        },
        setIsUnderAction: function(isUnderAction) {
            return set({
                isUnderAction: isUnderAction
            });
        },
        setIsCodeComplete: function(isCodeComplete) {
            return set({
                isCodeComplete: isCodeComplete
            });
        },
        setIsTokenCodeValid: function(value) {
            return set({
                isTokenCodeValid: value
            });
        },
        setIsBlockedToSendCode: function(value) {
            return set({
                isBlockedToSendCode: value
            });
        },
        setValidateCode: function(value) {
            return set({
                validateCode: value
            });
        },
        setClientAction: function(clientAction) {
            return set({
                clientAction: clientAction
            });
        },
        setCanChooseAnotherTwoFactorMethod: function(value) {
            return set({
                canChooseAnotherTwoFactorMethod: value
            });
        },
        resetInfo: function() {
            set({
                isValidationActive: false,
                email: "",
                phoneNumber: "",
                isTokenCodeValid: false,
                clientAction: null
            });
        },
        sendCode: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var sendCodeType, notificationApi, addToast, infoValue, errorTitle, faType, email, cpf, phoneNumber, token, ref, ref1, ref2, ref3, ref4, ref5, ref6, hasValidResult, storagedTime, actualTime, diffTime, result, ref7, result1, ref8, result2, ref9, ref10, ref11, ref12, requestBody, response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            sendCodeType = param.sendCodeType, notificationApi = param.notificationApi, addToast = param.addToast, infoValue = param.infoValue, errorTitle = param.errorTitle, faType = param.faType, email = param.email, cpf = param.cpf, phoneNumber = param.phoneNumber, token = param.token;
                            hasValidResult = false;
                            storagedTime = localStorage.getItem("timeSent_".concat(faType, "_").concat(get().channelSelected));
                            actualTime = Date.now();
                            diffTime = Math.floor(Number(storagedTime) - Number(actualTime) / 1000);
                            if (diffTime && diffTime > 0 && storagedTime) {
                                get().setIsValidationActive(true);
                                if (get().currentStep === "chooseAnotherMethod") {
                                    get().changeCurrentStep("verifyIdentity");
                                }
                            }
                            set({
                                isUnderAction: true
                            });
                            if (!(sendCodeType === "email" && ![
                                "loginValidation",
                                "changeEmail",
                                "changePassword",
                                "changePhoneNumber",
                                "requestExclusionAccount",
                                "editData",
                                "requestSecurityIssue"
                            ].includes(String((ref = get()) === null || ref === void 0 ? void 0 : ref.clientAction)))) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                notificationApi.sendTwoFactorEmail(faType !== null && faType !== void 0 ? faType : 5, infoValue)
                            ];
                        case 1:
                            result = _state.sent();
                            hasValidResult = result.isValidEmail;
                            _state.label = 2;
                        case 2:
                            if (!(sendCodeType === "sms" && ((ref1 = get()) === null || ref1 === void 0 ? void 0 : ref1.faType) === 6 && ![
                                "loginValidation",
                                "changeEmail",
                                "changePassword",
                                "changePhoneNumber",
                                "requestExclusionAccount",
                                "editData",
                                "requestSecurityIssue"
                            ].includes(String((ref2 = get()) === null || ref2 === void 0 ? void 0 : ref2.clientAction)))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                notificationApi.sendTokenForSMS(Number(faType), infoValue)
                            ];
                        case 3:
                            result1 = _state.sent();
                            hasValidResult = !!(result1 === null || result1 === void 0 ? void 0 : (ref7 = result1.validationResult) === null || ref7 === void 0 ? void 0 : ref7.isValid);
                            _state.label = 4;
                        case 4:
                            if (!(sendCodeType === "sms" && ((ref3 = get()) === null || ref3 === void 0 ? void 0 : ref3.faType) !== 6 && ((ref4 = get()) === null || ref4 === void 0 ? void 0 : ref4.faType) !== 13 && ![
                                "loginValidation",
                                "changeEmail",
                                "changePassword",
                                "changePhoneNumber",
                                "requestExclusionAccount",
                                "editData",
                                "requestSecurityIssue"
                            ].includes(String((ref5 = get()) === null || ref5 === void 0 ? void 0 : ref5.clientAction)))) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                notificationApi.sendTwoFactorSMS(2, infoValue)
                            ];
                        case 5:
                            result2 = _state.sent();
                            hasValidResult = !!(result2 === null || result2 === void 0 ? void 0 : (ref8 = result2.validationResult) === null || ref8 === void 0 ? void 0 : ref8.isValid);
                            return [
                                3,
                                8
                            ];
                        case 6:
                            if (!(sendCodeType === "new2FA" || [
                                "loginValidation",
                                "changeEmail",
                                "changePassword",
                                "changePhoneNumber",
                                "requestExclusionAccount",
                                "editData",
                                "requestSecurityIssue"
                            ].includes(String((ref6 = get()) === null || ref6 === void 0 ? void 0 : ref6.clientAction)))) return [
                                3,
                                8
                            ];
                            requestBody = {
                                email: email,
                                cpf: cpf,
                                faType: (ref12 = (ref9 = get()) === null || ref9 === void 0 ? void 0 : ref9.faType) !== null && ref12 !== void 0 ? ref12 : null,
                                channel: (ref10 = get()) === null || ref10 === void 0 ? void 0 : ref10.channelSelected,
                                phoneNumber: phoneNumber
                            };
                            return [
                                4,
                                notificationApi.sendTwoFactorTokenByChannel(String(token), requestBody)
                            ];
                        case 7:
                            response = _state.sent();
                            hasValidResult = response === null || response === void 0 ? void 0 : (ref11 = response.validationResult) === null || ref11 === void 0 ? void 0 : ref11.isValid;
                            _state.label = 8;
                        case 8:
                            set({
                                tokenCode: "",
                                isBlockedToSendCode: !hasValidResult,
                                validateCode: false,
                                isUnderAction: false
                            });
                            if (hasValidResult) {
                                addToast({
                                    title: "C\xf3digo enviado!",
                                    isNewToast: true,
                                    newToastTheme: "light",
                                    type: "success",
                                    timerInMilliseconds: 3000
                                });
                                set({
                                    isSendCodeAvailable: false
                                });
                                setTimeout(function() {
                                    set({
                                        isSendCodeAvailable: true
                                    });
                                }, 60000);
                            } else {
                                addToast({
                                    isNewToast: true,
                                    newToastTheme: "light",
                                    title: errorTitle,
                                    description: "Voc\xea excedeu o limite de tentativas de valida\xe7\xe3o do c\xf3digo de verifica\xe7\xe3o.",
                                    type: "error",
                                    timerInMilliseconds: 3000
                                });
                            }
                            return [
                                2,
                                hasValidResult
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        validateToken: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var token, notificationApi, addToast, accessToken, ref, ref1, dataName, ref2, isValid, errors, ref3, ref4;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            token = param.token, notificationApi = param.notificationApi, addToast = param.addToast, accessToken = param.accessToken;
                            dataName = get().channelSelected === 1 ? "Telefone" : get().channelSelected === 2 ? "e-mail" : "";
                            return [
                                4,
                                notificationApi.validateTwoFactorCode({
                                    channel: get().channelSelected,
                                    faType: Number(get().faType),
                                    cpf: String(get().cpf),
                                    email: String(get().email),
                                    phoneNumber: String(get().phoneNumber),
                                    token: token,
                                    jwt: accessToken
                                })
                            ];
                        case 1:
                            ref2 = _state.sent(), isValid = ref2.isValid, errors = ref2.errors;
                            if (!isValid && (errors === null || errors === void 0 ? void 0 : (ref = errors.statusCode) === null || ref === void 0 ? void 0 : ref.includes("222"))) {
                                get().setIsBlockedToSendCode(true);
                                get().setIsValidationActive(true);
                                localStorage.removeItem("timeSent_".concat(get().faType, "_").concat(get().channelSelected));
                                localStorage.removeItem("countdownTime_".concat(get().faType, "_").concat(get().channelSelected));
                                localStorage.removeItem("countdownTimeTimestamp_".concat(get().faType, "_").concat(get().channelSelected));
                                return [
                                    2
                                ];
                            }
                            if (!isValid && !(errors === null || errors === void 0 ? void 0 : (ref1 = errors.statusCode) === null || ref1 === void 0 ? void 0 : ref1.includes("222"))) {
                                ;
                                get().setIsTokenCodeValid(false);
                                get().setValidateCode(true);
                                ;
                                addToast({
                                    type: "error",
                                    isNewToast: true,
                                    newToastTheme: "light",
                                    title: "Erro ao validar ".concat(dataName),
                                    description: (ref4 = errors === null || errors === void 0 ? void 0 : (ref3 = errors.messages) === null || ref3 === void 0 ? void 0 : ref3[0]) !== null && ref4 !== void 0 ? ref4 : "Erro ao validar c\xf3digo"
                                });
                                localStorage.removeItem("timeSent_".concat(get().faType, "_").concat(get().channelSelected));
                                localStorage.removeItem("countdownTime_".concat(get().faType, "_").concat(get().channelSelected));
                                localStorage.removeItem("countdownTimeTimestamp_".concat(get().faType, "_").concat(get().channelSelected));
                                return [
                                    2
                                ];
                            }
                            get().setIsValidationActive(false);
                            addToast({
                                type: "success",
                                isNewToast: true,
                                newToastTheme: "light",
                                title: "".concat(dataName, " validado com sucesso"),
                                description: "Parab\xe9ns, sua conta est\xe1 mais segura ap\xf3s a valida\xe7\xe3o do seu ".concat(dataName, ".")
                            });
                            localStorage.removeItem("timeSent_".concat(get().faType, "_").concat(get().channelSelected));
                            localStorage.removeItem("countdownTime_".concat(get().faType, "_").concat(get().channelSelected));
                            localStorage.removeItem("countdownTimeTimestamp_".concat(get().faType, "_").concat(get().channelSelected));
                            get().setIsChangingAvailableMethods(true);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        channelSelected: 2,
        setChannelSelected: function(channelSelected) {
            return set({
                channelSelected: channelSelected
            });
        },
        availableMethods: {},
        setAvailableMethods: function(availableMethods) {
            return set({
                availableMethods: availableMethods
            });
        },
        setCodeTimerActive: function(value) {
            return set({
                isCodeTimerActive: value
            });
        },
        setIsSendCodeAvailable: function(value) {
            return set({
                isSendCodeAvailable: value
            });
        },
        clipboardText: "",
        setClipboardText: function(clipboardText) {
            return set({
                clipboardText: clipboardText
            });
        },
        setIsValidatingCode: function(isValidatingCode) {
            return set({
                isValidatingCode: isValidatingCode
            });
        },
        userIdentification: "",
        setUserIdentification: function(userIdentification) {
            return set({
                userIdentification: userIdentification
            });
        },
        faType: undefined,
        setFaType: function(faType) {
            return set({
                faType: faType
            });
        },
        openEditDataModal: false,
        setOpenEditDataModal: function(openEditDataModal) {
            return set({
                openEditDataModal: openEditDataModal
            });
        },
        steps: [],
        setSteps: function(steps) {
            return set({
                steps: steps
            });
        },
        currentStep: "verifyIdentity",
        changeCurrentStep: function(value) {
            var newSteps = [
                {
                    name: "verifyIdentity",
                    statusColor: value === "verifyIdentity" || value === "chooseAnotherMethod" ? "".concat(ui.theme.colors.secondary[380]) : "".concat(ui.theme.colors.secondary[37])
                },
                {
                    name: "updatePhoneNumber",
                    statusColor: value === "editData" ? "".concat(ui.theme.colors.secondary[380]) : value === "verifyCode" ? "".concat(ui.theme.colors.secondary[37]) : undefined
                },
                {
                    name: "verifyPhoneNumber",
                    statusColor: value === "verifyCode" ? "".concat(ui.theme.colors.secondary[380]) : undefined
                }, 
            ];
            set({
                currentStep: value,
                steps: newSteps
            });
        },
        openValidateDataModal: false,
        setOpenValidateDataModal: function(openValidateDataModal) {
            return set({
                openValidateDataModal: openValidateDataModal
            });
        },
        changeDataTitle: "",
        setChangeDataTitle: function(changeDataTitle) {
            return set({
                changeDataTitle: changeDataTitle
            });
        },
        changeDataDescription: "",
        setChangeDataDescription: function(changeDataDescription) {
            return set({
                changeDataDescription: changeDataDescription
            });
        },
        buttonCta: {
            label: "",
            onClick: function() {
                return [];
            }
        },
        changeButtonCta: function(buttonCta) {
            return set({
                buttonCta: buttonCta
            });
        },
        cpf: "",
        setCpf: function(cpf) {
            return set({
                cpf: cpf
            });
        },
        isClientNotFound: false,
        setIsClientNotFound: function(value) {
            return set({
                isClientNotFound: value
            });
        },
        isChangingAvailableMethods: true,
        setIsChangingAvailableMethods: function(value) {
            return set({
                isChangingAvailableMethods: value
            });
        },
        isValidatingOnMobile: false,
        setIsValidatingOnMobile: function(value) {
            return set({
                isValidatingOnMobile: value
            });
        },
        setHasAuthenticationMethodChanged: function(value) {
            return set({
                hasAuthenticationMethodChanged: value
            });
        },
        clearTimer: function(faType, channel, blockRequest) {
            get().setInitTimer(false);
            get().setCodeTimerActive(false);
            get().setIsValidatingCode(false);
            get().setIsSendCodeAvailable(!blockRequest);
            get().setIsTokenCodeValid(!blockRequest);
            get().setIsBlockedToSendCode(!!blockRequest);
            localStorage.removeItem("timeSent_".concat(faType, "_").concat(channel));
            localStorage.removeItem("countdownTime_".concat(faType, "_").concat(channel));
            localStorage.removeItem("countdownTimeTimestamp_".concat(faType, "_").concat(channel));
        },
        getTimer: function(faType, channel, changeValidateState) {
            var storagedTime = localStorage.getItem("timeSent_".concat(faType, "_").concat(channel));
            var actualTime = Date.now();
            var diffTime = Math.floor(Number(storagedTime) - Number(actualTime) / 1000);
            var timeRunning = Boolean(diffTime && diffTime > 0 && storagedTime);
            if (changeValidateState) get().setIsValidationActive(timeRunning);
            if (diffTime && diffTime <= 0) get().clearTimer(faType, channel);
            return {
                isTimerRunning: timeRunning
            };
        },
        isRequesting: false,
        setIsRequesting: function(isRequesting) {
            return set({
                isRequesting: isRequesting
            });
        },
        handleStartStep: function(param) {
            var sendTokenCallback = param.sendTokenCallback, availableMethods = param.availableMethods, isRequesting = param.isRequesting, setIsValidationActive = param.setIsValidationActive, changeCurrentStep = param.changeCurrentStep, isValidationActive = param.isValidationActive, isBlockedToSendCode = param.isBlockedToSendCode, setIsBlockedToSendCode = param.setIsBlockedToSendCode;
            if (!availableMethods || isRequesting) return;
            var emailConfirmed = availableMethods.emailConfirmed, phoneNumberConfirmed = availableMethods.phoneNumberConfirmed;
            if (!emailConfirmed && phoneNumberConfirmed) {
                sendTokenCallback(1);
                return;
            }
            if (emailConfirmed && !phoneNumberConfirmed) {
                sendTokenCallback(2);
                return;
            }
            if (emailConfirmed && phoneNumberConfirmed || !emailConfirmed && !phoneNumberConfirmed) {
                setIsValidationActive(true);
                changeCurrentStep("verifyIdentity");
                if (!isValidationActive && isBlockedToSendCode) {
                    setIsBlockedToSendCode(false);
                    changeCurrentStep("verifyIdentity");
                }
            }
        },
        isPhoneNumberInvalid: false,
        setIsPhoneNumberInvalid: function(isPhoneNumberInvalid) {
            return set({
                isPhoneNumberInvalid: isPhoneNumberInvalid
            });
        }
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/uniqueClient/index.ts



var useUniqueClient = (0,adapter/* createStore */.M)(function(set) {
    return {
        currentStep: "modalCall",
        isUniqueClientModalOpen: false,
        needsToValidateEmail: false,
        needsToValidatePhoneNumber: false,
        hasError: false,
        isLoading: true,
        changeUniqueClientStep: function(value) {
            set({
                currentStep: value
            });
        },
        setIsUniqueClientModalOpen: function(value) {
            set({
                isUniqueClientModalOpen: value
            });
        },
        uniqueClientInfo: {
            isCustomerEligible: false,
            emailValidation: {
                isEmailVerified: false,
                isSameInPhysicalStoreAndEcommerce: false
            },
            phoneNumberValidation: {
                isPhoneNumberVerified: false,
                isSameInPhysicalStoreAndEcommerce: false
            }
        },
        setUniqueClientInfo: function(value) {
            set({
                uniqueClientInfo: value
            });
        },
        setNeedsToValidatePhoneNumber: function(value) {
            set({
                needsToValidatePhoneNumber: value
            });
        },
        setNeedsToValidateEmail: function(value) {
            set({
                needsToValidateEmail: value
            });
        },
        getClientInfo: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(purchaseApi, token) {
                var ref, ref1, ref2, ref3, ref4, clientInfo, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                purchaseApi.getVerifyUniqueClient(token)
                            ];
                        case 1:
                            ref4 = _state.sent(), clientInfo = ref4.data, error = ref4.error;
                            if (clientInfo || error) {
                                set({
                                    isLoading: false
                                });
                            }
                            set({
                                uniqueClientInfo: clientInfo,
                                needsToValidateEmail: (clientInfo === null || clientInfo === void 0 ? void 0 : (ref = clientInfo.emailValidation) === null || ref === void 0 ? void 0 : ref.isSameInPhysicalStoreAndEcommerce) && !(clientInfo === null || clientInfo === void 0 ? void 0 : (ref1 = clientInfo.emailValidation) === null || ref1 === void 0 ? void 0 : ref1.isEmailVerified),
                                needsToValidatePhoneNumber: (clientInfo === null || clientInfo === void 0 ? void 0 : (ref2 = clientInfo.phoneNumberValidation) === null || ref2 === void 0 ? void 0 : ref2.isSameInPhysicalStoreAndEcommerce) && !(clientInfo === null || clientInfo === void 0 ? void 0 : (ref3 = clientInfo.phoneNumberValidation) === null || ref3 === void 0 ? void 0 : ref3.isPhoneNumberVerified),
                                hasError: clientInfo === null
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(purchaseApi, token) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/wedding-list/index.tsx

var useWeddingList = (0,adapter/* createStore */.M)(function(set) {
    return {
        coupleLink: "",
        setCoupleLink: function(coupleLink) {
            return set({
                coupleLink: coupleLink
            });
        }
    };
});


;// CONCATENATED MODULE: ../../packages/application/state-manager/categories/index.tsx

var useCategories = (0,adapter/* createStore */.M)(function(set) {
    return {
        selectedCategory: null,
        categoryTitle: "",
        categoryUrl: "",
        setSelectedCategory: function(category) {
            return set({
                selectedCategory: category
            });
        },
        setCategoryTitle: function(title) {
            return set({
                categoryTitle: title
            });
        },
        setCategoryUrl: function(url) {
            return set({
                categoryUrl: url
            });
        },
        setThirdLevelCategory: function(category) {
            return set({
                thirdLevelCategory: category
            });
        },
        thirdLevelCategory: null,
        thirdLevelTitle: "",
        thirdLevelUrl: "",
        setThirdLevelTitle: function(title) {
            return set({
                thirdLevelTitle: title
            });
        },
        setThirdLevelUrl: function(url) {
            return set({
                thirdLevelUrl: url
            });
        }
    };
});

;// CONCATENATED MODULE: ../../packages/application/state-manager/index.ts























/***/ }),

/***/ 92073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useSecurityStore; }
/* harmony export */ });
/* harmony import */ var _adapter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80759);

var useSecurityStore = (0,_adapter__WEBPACK_IMPORTED_MODULE_0__/* .createStore */ .M)(function(set) {
    return {
        openModal: false,
        hasError: false,
        setOpenModal: function(value) {
            return set({
                openModal: value
            });
        },
        type: "modal",
        setType: function(value) {
            return set({
                type: value
            });
        },
        setHasError: function(value) {
            return set({
                hasError: value
            });
        },
        sendCodeType: "email",
        setCodeType: function(value) {
            return set({
                sendCodeType: value
            });
        },
        workflow: null,
        setWorkflow: function(value) {
            return set({
                workflow: value
            });
        },
        isInvalidPhoneNumber: false
    };
});


/***/ }),

/***/ 60143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ defaultHeaders; },
  "A4": function() { return /* binding */ handleOnErrorRetry; },
  "Wu": function() { return /* reexport */ handleRefreshUserAccessToken; }
});

// UNUSED EXPORTS: getRequestPath, handleResponse, handleResponseError

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../packages/application/services/apis/Envs/index.ts
var Envs = __webpack_require__(32817);
// EXTERNAL MODULE: ../../packages/application/utils/http/refresh-token/expiration-date/index.ts
var expiration_date = __webpack_require__(83367);
;// CONCATENATED MODULE: ../../packages/application/utils/http/refresh-token/logged-user-cookies/index.ts
// deepcode ignore HardcodedNonCryptoSecret: não é uma secret, apenas o valor da key que terá o secret como value
var accessTokenGoogleCookieKey = "@FC:Ecom:Token:Access:google";
// deepcode ignore HardcodedNonCryptoSecret: não é uma secret, apenas o valor da key que terá o secret como value
var accessTokenAppleCookieKey = "@FC:Ecom:Token:Access:apple";
var deleteLoggedUserCookies = function(cookie, accessTokenCookieKey, refreshTokenCookieKey) {
    cookie.deleteCookie({
        name: accessTokenCookieKey
    });
    cookie.deleteCookie({
        name: refreshTokenCookieKey
    });
    cookie.deleteCookie({
        name: accessTokenGoogleCookieKey
    });
    cookie.deleteCookie({
        name: accessTokenAppleCookieKey
    });
    cookie.deleteCookie({
        name: "@FC:Ecom:Token:userList"
    });
};
var updateLoggedUserTokens = function(cookie, authentication) {
    if (authentication === null || authentication === void 0 ? void 0 : authentication.access_token) {
        cookie.setCookie({
            name: "@FC:Ecom:Token:Access",
            value: authentication === null || authentication === void 0 ? void 0 : authentication.access_token
        });
    }
    if (authentication === null || authentication === void 0 ? void 0 : authentication.refresh_token) {
        cookie.setCookie({
            name: "@FC:Ecom:Token:Refresh",
            value: authentication === null || authentication === void 0 ? void 0 : authentication.refresh_token
        });
    }
};


;// CONCATENATED MODULE: ../../packages/application/utils/http/refresh-token/keys/index.ts
// deepcode ignore HardcodedNonCryptoSecret: não é uma secret, apenas o valor da key que terá o secret como value
var accessTokenCookieKey = "@FC:Ecom:Token:Access";
// deepcode ignore HardcodedNonCryptoSecret: não é uma secret, apenas o valor da key que terá o secret como value
var refreshTokenCookieKey = "@FC:Ecom:Token:Refresh";


;// CONCATENATED MODULE: ../../packages/application/utils/http/refresh-token/issuer/index.ts




var isAccessTokenIssuerValid = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(issuer, envsApi, cookie, appMonitoringClient) {
        var ref, allConfigs, identityIssuer, ref1, ref2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        envsApi.getAllConfigs()
                    ];
                case 1:
                    ref = _state.sent(), allConfigs = ref.data;
                    identityIssuer = (allConfigs || {
                        identityIssuer: ""
                    }).identityIssuer;
                    if (identityIssuer && issuer !== identityIssuer) {
                        ;
                        deleteLoggedUserCookies(cookie, accessTokenCookieKey, refreshTokenCookieKey);
                        appMonitoringClient.captureException("O access token do usu\xe1rio possui um issuer inv\xe1lido (diferente de ".concat(identityIssuer, ")"), {
                            level: "error",
                            tags: {
                                fcx_labs_error_source: "access_token"
                            }
                        });
                        window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.replace("/login?redirectTo=".concat(window === null || window === void 0 ? void 0 : (ref2 = window.location) === null || ref2 === void 0 ? void 0 : ref2.pathname));
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        2,
                        true
                    ];
            }
        });
    });
    return function isAccessTokenIssuerValid(issuer, envsApi, cookie, appMonitoringClient) {
        return _ref.apply(this, arguments);
    };
}();


;// CONCATENATED MODULE: ../../packages/application/utils/http/refresh-token/redirects/index.ts
var redirectBasedOnProtectedRoutes = function(protectedRoutes) {
    var shouldRedirectToLogin = protectedRoutes.some(function(route) {
        var ref, ref1;
        return window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.pathname) === null || ref1 === void 0 ? void 0 : ref1.includes(route);
    });
    if (shouldRedirectToLogin) {
        var ref, ref1;
        window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.replace("/login?redirectTo=".concat(window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.pathname));
    } else {
        var ref2;
        window === null || window === void 0 ? void 0 : (ref2 = window.location) === null || ref2 === void 0 ? void 0 : ref2.reload();
    }
};


;// CONCATENATED MODULE: ../../packages/application/utils/http/refresh-token/refresh-access-token/index.ts


// const requestsWaitingForRefreshedAccessToken: string[] = [];
// const isRequestAlreadyBeingDone = (requestPath: string) => {
//   return requestsWaitingForRefreshedAccessToken?.includes(requestPath);
// };
// const addRequestToWaitRefreshAccessToken = (requestPath: string) => {
//   requestsWaitingForRefreshedAccessToken.push(requestPath);
// };
// const removeRequestFromWaitRefreshAccessToken = (requestPath: string) => {
//   const requestPathIndex = requestsWaitingForRefreshedAccessToken.findIndex(
//     (currentRequest) => currentRequest === requestPath
//   );
//   if (requestPathIndex > -1) {
//     requestsWaitingForRefreshedAccessToken.splice(requestPathIndex, 1);
//   }
// };
var isValidatingAccessToken = function() {
    return !!(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("isValidatingAccessToken"));
};
var setIsValidatingAccessToken = function(value) {
    if (value) {
        sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem("isValidatingAccessToken", String(value));
        return;
    }
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.removeItem("isValidatingAccessToken");
};
var refreshAccessToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(refreshToken) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("/api/identity/token/refresh", {
                            method: "POST",
                            body: JSON.stringify({
                                refreshToken: refreshToken
                            })
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.json()
                    ];
            }
        });
    });
    return function refreshAccessToken(refreshToken) {
        return _ref.apply(this, arguments);
    };
}();


;// CONCATENATED MODULE: ../../packages/application/utils/http/refresh-token/index.ts









var shouldRetry = function(retryCount) {
    return isValidatingAccessToken() && retryCount < 3;
};
var envsApi = null;
var handleRefreshUserAccessToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(cookie, appMonitoringClient, jwtDecoder) {
        var authorization, timeToRefreshAccessTokenBeforeItExpiresInSeconds, retryCount, accessToken, accessTokenDecoded, isIssuerValid, isAccessTokenExpired, refreshToken, ref, ref1, data, refreshTokenIsNotValid, authenticationProps, err;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authorization = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : "", timeToRefreshAccessTokenBeforeItExpiresInSeconds = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : 120, retryCount = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : 0;
                    if (!authorization) {
                        return [
                            2,
                            {
                                refreshingAccessToken: false
                            }
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    if (isValidatingAccessToken()) {
                        return [
                            2,
                            new Promise(function(resolve) {
                                setTimeout(function() {
                                    if (shouldRetry(retryCount)) {
                                        return resolve(handleRefreshUserAccessToken(cookie, appMonitoringClient, jwtDecoder, authorization, timeToRefreshAccessTokenBeforeItExpiresInSeconds, retryCount + 1));
                                    }
                                    setIsValidatingAccessToken(false);
                                    return resolve({
                                        refreshingAccessToken: false,
                                        refreshedAccessToken: cookie.getCookie({
                                            name: accessTokenCookieKey
                                        })
                                    });
                                }, 1500);
                            })
                        ];
                    }
                    setIsValidatingAccessToken(true);
                    accessToken = cookie.getCookie({
                        name: accessTokenCookieKey
                    });
                    accessTokenDecoded = jwtDecoder.decode(accessToken);
                    if (!envsApi) {
                        envsApi = new Envs/* EnvsApi */.v(cookie);
                    }
                    return [
                        4,
                        isAccessTokenIssuerValid((accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.iss) || "", envsApi, cookie, appMonitoringClient)
                    ];
                case 2:
                    isIssuerValid = _state.sent();
                    if (!isIssuerValid) {
                        setIsValidatingAccessToken(false);
                        return [
                            2,
                            {
                                refreshingAccessToken: false,
                                cancelRequest: true
                            }
                        ];
                    }
                    isAccessTokenExpired = (0,expiration_date/* validateAccessTokenIsExpired */.L)(accessTokenDecoded.exp, timeToRefreshAccessTokenBeforeItExpiresInSeconds);
                    if (!isAccessTokenExpired) return [
                        3,
                        4
                    ];
                    refreshToken = cookie.getCookie({
                        name: refreshTokenCookieKey
                    });
                    if (!refreshToken) {
                        ;
                        deleteLoggedUserCookies(cookie, accessTokenCookieKey, refreshTokenCookieKey);
                        appMonitoringClient.captureException("O access token do usu\xe1rio expirou e n\xe3o existe um cookie (".concat(refreshTokenCookieKey, ") com o refresh token do usu\xe1rio para que seja gerado um novo access token"), {
                            level: "error",
                            tags: {
                                fcx_labs_error_source: "refresh_access_token"
                            }
                        });
                        setIsValidatingAccessToken(false);
                        window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.replace("/login?redirectTo=".concat(window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.pathname));
                        return [
                            2,
                            {
                                refreshingAccessToken: false,
                                cancelRequest: true
                            }
                        ];
                    }
                    return [
                        4,
                        refreshAccessToken(refreshToken)
                    ];
                case 3:
                    data = _state.sent();
                    refreshTokenIsNotValid = (data === null || data === void 0 ? void 0 : data.status) === 400;
                    if (refreshTokenIsNotValid) {
                        deleteLoggedUserCookies(cookie, accessTokenCookieKey, refreshTokenCookieKey);
                        appMonitoringClient.captureException("Chamada a API do Identity com refresh token retornou 400", {
                            level: "error",
                            tags: {
                                fcx_labs_error_source: "refresh_access_token"
                            }
                        });
                        setIsValidatingAccessToken(false);
                        redirectBasedOnProtectedRoutes([
                            "/checkout",
                            "/conta",
                            "/meu-painel"
                        ]);
                        return [
                            2,
                            {
                                refreshingAccessToken: false,
                                cancelRequest: true
                            }
                        ];
                    }
                    authenticationProps = data;
                    updateLoggedUserTokens(cookie, authenticationProps);
                    setIsValidatingAccessToken(false);
                    appMonitoringClient.configureScope({
                        email: accessTokenDecoded.email
                    }, authenticationProps === null || authenticationProps === void 0 ? void 0 : authenticationProps.access_token);
                    return [
                        2,
                        {
                            refreshingAccessToken: false,
                            refreshedAccessToken: authenticationProps === null || authenticationProps === void 0 ? void 0 : authenticationProps.access_token
                        }
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    err = _state.sent();
                    appMonitoringClient.captureException(err, {
                        level: "error",
                        tags: {
                            fcx_labs_error_source: "refresh_access_token"
                        }
                    });
                    setIsValidatingAccessToken(false);
                    return [
                        2,
                        {
                            refreshingAccessToken: false,
                            refreshedAccessToken: cookie.getCookie({
                                name: accessTokenCookieKey
                            })
                        }
                    ];
                case 6:
                    setIsValidatingAccessToken(false);
                    return [
                        2,
                        {
                            refreshingAccessToken: false
                        }
                    ];
            }
        });
    });
    return function handleRefreshUserAccessToken(cookie, appMonitoringClient, jwtDecoder) {
        return _ref.apply(this, arguments);
    };
}();


;// CONCATENATED MODULE: ../../packages/application/utils/http/index.tsx



var defaultHeaders = {
    saleChannel: "2",
    version: "1.28.0"
};
var handleResponseError = function(error, appMonitoringClient, param) {
    var event = param.event, errorSource = param.errorSource;
    appMonitoringClient.captureException(error, {
        level: "error",
        tags: {
            fcx_labs_event: event,
            fcx_labs_error_source: errorSource
        }
    });
};
var handleResponse = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(fetchResponse, appMonitoringClient, param) {
        var defaultErrorMessage, event, errorSource, _authorization, authorization, responseAsJson, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    defaultErrorMessage = param.defaultErrorMessage, event = param.event, errorSource = param.errorSource, _authorization = param.authorization, authorization = _authorization === void 0 ? "" : _authorization;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    if (!(fetchResponse.status !== 204)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        fetchResponse.json()
                    ];
                case 2:
                    responseAsJson = _state.sent();
                    _state.label = 3;
                case 3:
                    if (!(fetchResponse === null || fetchResponse === void 0 ? void 0 : fetchResponse.ok)) {
                        handleResponseError(responseAsJson, appMonitoringClient, {
                            event: event,
                            errorSource: errorSource,
                            authorization: authorization
                        });
                    }
                    return [
                        2,
                        {
                            status: fetchResponse.status,
                            response: responseAsJson
                        }
                    ];
                case 4:
                    e = _state.sent();
                    handleResponseError(defaultErrorMessage, appMonitoringClient, {
                        event: event,
                        errorSource: errorSource,
                        authorization: authorization
                    });
                    return [
                        2,
                        {
                            status: fetchResponse.status,
                            response: {
                                errors: {
                                    Messages: [
                                        defaultErrorMessage
                                    ]
                                }
                            }
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleResponse(fetchResponse, appMonitoringClient, _) {
        return _ref.apply(this, arguments);
    };
}();
var handleOnErrorRetry = function(param) {
    var retryCount = param.retryCount, doRequestAgain = param.doRequestAgain, status = param.status, _retryCountThreshold = param.retryCountThreshold, retryCountThreshold = _retryCountThreshold === void 0 ? 4 : _retryCountThreshold, _doRequestAgainTimeout = param.doRequestAgainTimeout, doRequestAgainTimeout = _doRequestAgainTimeout === void 0 ? 5000 : _doRequestAgainTimeout;
    if (retryCount >= retryCountThreshold) return;
    if (status === 500) return;
    if (/5[0-9][0-9]/.test(String(status)) && retryCount >= 2) {
        return;
    }
    if (status === 401 && retryCount >= 2) {
        return;
    }
    setTimeout(function() {
        doRequestAgain({
            retryCount: retryCount
        });
    }, doRequestAgainTimeout);
};
var getRequestPath = function(input) {
    var ref, ref1;
    return ((ref1 = (ref = String(input)) === null || ref === void 0 ? void 0 : ref.split("?")) === null || ref1 === void 0 ? void 0 : ref1[0]) || "";
};



/***/ }),

/***/ 83367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ validateAccessTokenIsExpired; }
/* harmony export */ });
var validateAccessTokenIsExpired = function(expirationDateTime, timeToRefreshAccessTokenBeforeItExpiresInSeconds) {
    var tokenExpirationTimeInMilliseconds = expirationDateTime * 1000;
    var timeToRefreshAccessTokenBeforeItExpiresInMilliseconds = timeToRefreshAccessTokenBeforeItExpiresInSeconds * 1000;
    var thresholdTime = tokenExpirationTimeInMilliseconds - timeToRefreshAccessTokenBeforeItExpiresInMilliseconds;
    var nowDateTime = new Date().getTime();
    return nowDateTime >= thresholdTime;
};



/***/ }),

/***/ 83428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "in": function() { return /* reexport */ anonymizeUserData; },
  "xV": function() { return /* reexport */ brazilianStates; },
  "Fe": function() { return /* reexport */ buildTestIds; },
  "vs": function() { return /* reexport */ calculateDiscountPercentage; },
  "kC": function() { return /* reexport */ capitalize; },
  "R0": function() { return /* reexport */ capitalizeAll; },
  "G4": function() { return /* reexport */ capitalizeFirstLetterAndLowercaseRest; },
  "r5": function() { return /* reexport */ convertStoreOrderToDigital; },
  "NL": function() { return /* reexport */ branchLocation/* cookieBranchLocationStr */.NL; },
  "wW": function() { return /* reexport */ branchLocation/* cookieModalBranchLocationStr */.wW; },
  "em": function() { return /* reexport */ branchLocation/* cookiePostalCodeStr */.em; },
  "us": function() { return /* reexport */ branchLocation/* cookieRegionStr */.us; },
  "B": function() { return /* reexport */ http/* defaultHeaders */.B; },
  "mV": function() { return /* reexport */ descriptionParcelsText; },
  "PZ": function() { return /* reexport */ dropListTerms; },
  "hh": function() { return /* reexport */ extractTimeFromUTC; },
  "Pb": function() { return /* reexport */ filterStoreOrders; },
  "IJ": function() { return /* reexport */ filterValueProductPricePackage; },
  "f": function() { return /* reexport */ formatBranchId; },
  "p0": function() { return /* reexport */ formatCountdownTimer; },
  "w3": function() { return /* reexport */ formatCpf; },
  "xG": function() { return /* reexport */ formatCurrency; },
  "p6": function() { return /* reexport */ formatDate; },
  "D_": function() { return /* reexport */ formatDatePhrase; },
  "H8": function() { return /* reexport */ formatDateToShortCrm; },
  "XC": function() { return /* reexport */ formatEmailToShowOnlyFourCharactersAndDomain; },
  "mX": function() { return /* reexport */ formatLocationName; },
  "uf": function() { return /* reexport */ formatNumber; },
  "un": function() { return /* reexport */ formatPhoneNumber; },
  "RZ": function() { return /* reexport */ formatShortenDateWithoutYear; },
  "Es": function() { return /* reexport */ formatStringUrl; },
  "c$": function() { return /* reexport */ formatTestId; },
  "WL": function() { return /* reexport */ formatUTCToShort; },
  "BD": function() { return /* reexport */ formatUserName; },
  "TW": function() { return /* reexport */ getApisUrlFallback; },
  "rx": function() { return /* reexport */ getClientBranchId; },
  "tK": function() { return /* reexport */ branchLocation/* getClientLocationDetails */.tK; },
  "su": function() { return /* reexport */ getComponentTheme; },
  "rY": function() { return /* reexport */ getDiscountMessage; },
  "$Q": function() { return /* reexport */ getDiscountPercentage; },
  "_9": function() { return /* reexport */ getFileByLink; },
  "Yt": function() { return /* reexport */ getGeolocation; },
  "aY": function() { return /* reexport */ getInstallmentsText; },
  "T1": function() { return /* reexport */ getIsListInactive; },
  "ZS": function() { return /* reexport */ getMappedCard; },
  "df": function() { return /* reexport */ getMaxInstallments; },
  "pY": function() { return /* reexport */ getMeasuredUnit; },
  "Wu": function() { return /* reexport */ getObjectLength; },
  "cO": function() { return /* reexport */ getPaymentIcon; },
  "V7": function() { return /* reexport */ getPaymentOptions; },
  "pg": function() { return /* reexport */ getPhoneNumberInvalidInformation; },
  "D7": function() { return /* reexport */ getPriceList; },
  "CO": function() { return /* reexport */ getProductBreadcrumbItems; },
  "G": function() { return /* reexport */ getProductImageUrl; },
  "E8": function() { return /* reexport */ getProductPosition; },
  "z1": function() { return /* reexport */ getProductQuantity; },
  "KA": function() { return /* reexport */ getSaleChannel; },
  "Fl": function() { return /* reexport */ getSalePrice; },
  "YJ": function() { return /* reexport */ getSmallMappedCard; },
  "$X": function() { return /* reexport */ getSpotPrice; },
  "ng": function() { return /* reexport */ getUserFirstName; },
  "Zh": function() { return /* reexport */ getUserInitials; },
  "Fo": function() { return /* reexport */ getUserSurname; },
  "A4": function() { return /* reexport */ http/* handleOnErrorRetry */.A4; },
  "Rn": function() { return /* reexport */ handleProductTag; },
  "P2": function() { return /* reexport */ http/* handleRefreshUserAccessToken */.Wu; },
  "RE": function() { return /* reexport */ installmentsOptionsFormatted; },
  "CG": function() { return /* reexport */ isAttentionStatus; },
  "nK": function() { return /* reexport */ isObjectEmpty; },
  "y8": function() { return /* reexport */ isVisibleOnDesktop; },
  "tI": function() { return /* reexport */ isVisibleOnMobile; },
  "jf": function() { return /* reexport */ lazyLoading; },
  "x$": function() { return /* reexport */ mapFilterProductsByPlaylistToSearchByTerm; },
  "H6": function() { return /* reexport */ obfuscate; },
  "AW": function() { return /* reexport */ branchLocation/* optionsMaxAgeEqualOneYear */.AW; },
  "A2": function() { return /* reexport */ removeSpecialCharacters; },
  "sM": function() { return /* reexport */ replaceImageBaseUrl; },
  "Hz": function() { return /* reexport */ shareText; },
  "ES": function() { return /* reexport */ sortListShipping; },
  "Gu": function() { return /* reexport */ userAuthenticatedActions; },
  "oM": function() { return /* reexport */ validations/* validCpfRegex */.oM; },
  "C2": function() { return /* reexport */ validations/* validEmailRegex */.C2; },
  "D4": function() { return /* reexport */ validations/* validateCardNumber */.D4; },
  "S$": function() { return /* reexport */ validations/* validateConfirmPassword */.S$; },
  "cy": function() { return /* reexport */ validations/* validateCpf */.cy; },
  "mE": function() { return /* reexport */ validations/* validateCreditCardCVV */.mE; },
  "m2": function() { return /* reexport */ validations/* validateCreditCardDueDate */.m2; },
  "oH": function() { return /* reexport */ validations/* validateEmail */.oH; },
  "Ol": function() { return /* reexport */ validations/* validateName */.Ol; },
  "uo": function() { return /* reexport */ validations/* validatePassword */.uo; },
  "Y0": function() { return /* reexport */ validations/* validatePhoneNumber */.Y0; },
  "VW": function() { return /* reexport */ validations/* validateSecurityCode */.VW; },
  "zr": function() { return /* reexport */ valueProduct; }
});

// UNUSED EXPORTS: ERROR_MESSAGES_BIRTHDATE, createSessionId, dateFormatForCardMessage, formatDateAndTime, formatDueDateCreditCard, formatShortenDate, generateId, getBranchName, getDiscountValue, getInstallmentValue, getPageCacheControlInfo, getRequestPath, getSessionId, handleBackofficeContent, handleCreditCardCvvMask, handleCreditCardCvvPlaceholder, handleCreditCardNumberMask, handleEmailValidation, handleNameValidation, handlePreloadComponents, handleResponse, handleResponseError, isFebruaryInvalid, isLeapYear, isSpecialStatus, mockedBlackFridayTheme, mockedDefaultPageThemeMap, mockedHeatmapClient, mockedHeatmapClientMap, mockedPageThemeMap, quantityOfDaysIsBiggerThanThirty, removeCharactersSpecials, removeItensNullOrUndefinedObject, searchValueInObject, serverSideDeviceDetection, sortingFavoritesStoresList, sumYears, useCreateSessionId, validateBirthdate, validateEmailFormWeddingList, validateFirstName, validateLettersAndNumbers, validateNameFormWeddingList, validateWeddingDate, validateWeddingList

;// CONCATENATED MODULE: ../../packages/application/utils/backoffice/index.tsx
var isVisibleOnDesktop = function(component) {
    var ref, ref1, ref2, ref3, ref4;
    return ((ref = [
        "stories",
        "imagesGrid",
        "carousel",
        "dynamicBanner",
        "gridPlaylists", 
    ]) === null || ref === void 0 ? void 0 : ref.includes(component === null || component === void 0 ? void 0 : component.type)) ? component === null || component === void 0 ? void 0 : (ref1 = component.subComponents) === null || ref1 === void 0 ? void 0 : ref1.some(function(subComponent) {
        var ref, ref1, ref2;
        return subComponent === null || subComponent === void 0 ? void 0 : (ref = subComponent.config) === null || ref === void 0 ? void 0 : (ref1 = ref.branches) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.visibleOnDesktop;
    }) : component === null || component === void 0 ? void 0 : (ref2 = component.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.branches) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.visibleOnDesktop;
};
var isVisibleOnMobile = function(component) {
    var ref, ref1, ref2, ref3, ref4;
    return ((ref = [
        "stories",
        "imagesGrid",
        "carousel",
        "dynamicBanner",
        "gridPlaylists", 
    ]) === null || ref === void 0 ? void 0 : ref.includes(component === null || component === void 0 ? void 0 : component.type)) ? component === null || component === void 0 ? void 0 : (ref1 = component.subComponents) === null || ref1 === void 0 ? void 0 : ref1.some(function(subComponent) {
        var ref, ref1, ref2;
        return subComponent === null || subComponent === void 0 ? void 0 : (ref = subComponent.config) === null || ref === void 0 ? void 0 : (ref1 = ref.branches) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.visibleOnMobile;
    }) : component === null || component === void 0 ? void 0 : (ref2 = component.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.branches) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.visibleOnMobile;
};



// EXTERNAL MODULE: ../../packages/application/utils/http/index.tsx + 6 modules
var http = __webpack_require__(60143);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ../../packages/application/utils/lazy-loading/index.tsx

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var lazyLoading = function(callbackFunc, options) {
    if (options) {
        var loading = options.loading;
        return dynamic_default()(callbackFunc, {
            loading: loading
        });
    }
    return dynamic_default()(callbackFunc);
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/application/utils/misc/formatCurrency/index.ts
var formatCurrency = function(value) {
    try {
        if (typeof value !== "number" || Number.isNaN(value)) {
            return "";
        }
        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL"
        }).format(value);
    } catch (e) {
        return "";
    }
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/getProductImageUrl/index.ts
var getProductImageUrl = function(product) {
    try {
        var ref;
        if (!(product === null || product === void 0 ? void 0 : product.id)) throw new Error("productImageUrl: product must be an instance of ProductCardDto or an instance of Product");
        var result = product === null || product === void 0 ? void 0 : (ref = product.mediaLinks) === null || ref === void 0 ? void 0 : ref.find(function(mediaLink) {
            return (mediaLink === null || mediaLink === void 0 ? void 0 : mediaLink.linkType) === "THUMB" && (mediaLink === null || mediaLink === void 0 ? void 0 : mediaLink.isDefault) === true;
        });
        return (result === null || result === void 0 ? void 0 : result.imageUrl) || "";
    } catch (e) {
        return "";
    }
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/descriptionParcelsText/index.tsx

var descriptionParcelsText = function(param) {
    var maxNumberInstallments = param.maxNumberInstallments, spotPrice = param.spotPrice, salePrice = param.salePrice, _shortDescription = param.shortDescription, shortDescription = _shortDescription === void 0 ? false : _shortDescription;
    var hasSpotPriceDescriptionText = spotPrice && spotPrice !== salePrice && spotPrice <= salePrice;
    var maxNumberInstallmentsEnforced = maxNumberInstallments || 0;
    var formattedSalePrice = formatCurrency(salePrice || 0);
    var formattedInstallmentPrice = formatCurrency((salePrice || 0) / +maxNumberInstallmentsEnforced);
    if (shortDescription) {
        return hasSpotPriceDescriptionText ? "ou ".concat(maxNumberInstallmentsEnforced, "x de ").concat(formattedInstallmentPrice, " s/ juros") : "em ".concat(maxNumberInstallmentsEnforced, "x de ").concat(formattedInstallmentPrice, " s/ juros");
    }
    return hasSpotPriceDescriptionText ? "ou ".concat(formattedSalePrice, " em at\xe9 ").concat(maxNumberInstallmentsEnforced, "x de ").concat(formattedInstallmentPrice, " sem juros") : "em at\xe9 ".concat(maxNumberInstallmentsEnforced, "x de ").concat(formattedInstallmentPrice, " sem juros");
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/discount/index.ts
var getDiscountValue = function() {
    var spotPrice = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, priceList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, salePrice = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var finalPrice = spotPrice || salePrice;
    var discountValue = spotPrice || salePrice ? priceList - finalPrice : 0;
    var roundedDiscountValue = Number(discountValue.toFixed(2));
    return roundedDiscountValue >= 0 ? roundedDiscountValue : 0;
};
var calculateDiscountPercentage = function(discountValue) {
    if (!discountValue) {
        return 0;
    }
    var numericValue = parseFloat(discountValue);
    return numericValue / 100;
};
var getDiscountPercentage = function(product) {
    var ref, ref1, ref2, ref3;
    var prices = (product === null || product === void 0 ? void 0 : product.prices) || [];
    var ref4, ref5;
    var priceWithDiscount = prices.find(function(price) {
        return (price === null || price === void 0 ? void 0 : price.packingQuantity) === 1 && Number((ref4 = price === null || price === void 0 ? void 0 : price.discountPercentage) !== null && ref4 !== void 0 ? ref4 : 0) > 0;
    }) || prices.find(function(price) {
        return Number((ref5 = price === null || price === void 0 ? void 0 : price.discountPercentage) !== null && ref5 !== void 0 ? ref5 : 0) > 0;
    });
    if ((product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.priceList) !== (product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.salePrice) && priceWithDiscount) {
        return priceWithDiscount.discountPercentage;
    }
    return null;
};
var getDiscountMessage = function(coupon) {
    if (coupon === null || coupon === void 0 ? void 0 : coupon.discountPercentage) {
        return "".concat(coupon.discountPercentage, "% OFF");
    }
    if (coupon === null || coupon === void 0 ? void 0 : coupon.discountValue) {
        return "R$ ".concat(coupon.discountValue, " OFF");
    }
    return "";
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(87394);
;// CONCATENATED MODULE: ../../packages/application/utils/misc/formatLocationName/index.tsx

var formatLocationName = function(cityAndState) {
    var ref, ref1, ref2;
    if (typeof cityAndState !== "string") {
        return "";
    }
    var alwaysInLowerCaseWords = [
        "da",
        "das",
        "de",
        "do",
        "dos"
    ];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(cityAndState.trim().split("-"), 2), city = ref3[0], state = ref3[1];
    if (!city) {
        return "";
    }
    var cityInLowerCase = (ref = city === null || city === void 0 ? void 0 : city.toLowerCase()) === null || ref === void 0 ? void 0 : ref.trim();
    var formattedCity = (ref2 = (ref1 = cityInLowerCase === null || cityInLowerCase === void 0 ? void 0 : cityInLowerCase.split(/\s+/)) === null || ref1 === void 0 ? void 0 : ref1.map(function(cityWord) {
        var ref, ref1;
        var firstLetter = (alwaysInLowerCaseWords === null || alwaysInLowerCaseWords === void 0 ? void 0 : alwaysInLowerCaseWords.includes(cityWord)) ? cityWord === null || cityWord === void 0 ? void 0 : cityWord[0] : (cityWord === null || cityWord === void 0 ? void 0 : cityWord[0]) === "(" ? "".concat(cityWord === null || cityWord === void 0 ? void 0 : cityWord[0]).concat(cityWord === null || cityWord === void 0 ? void 0 : (ref = cityWord[1]) === null || ref === void 0 ? void 0 : ref.toUpperCase()) : cityWord === null || cityWord === void 0 ? void 0 : (ref1 = cityWord[0]) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase();
        var restOfLetters = cityWord.substring((firstLetter === null || firstLetter === void 0 ? void 0 : firstLetter.startsWith("(")) ? 2 : 1);
        return "".concat(firstLetter).concat(restOfLetters);
    })) === null || ref2 === void 0 ? void 0 : ref2.join(" ");
    var formattedState = state ? " - ".concat(state === null || state === void 0 ? void 0 : state.trim()) : "";
    return "".concat(formattedCity).concat(formattedState);
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/obfuscate/index.ts
var obfuscate = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", sizeHexaDecimal = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16;
    if (typeof value !== "string") return "";
    if (!value) return "value obfuscate is empty";
    var obfuscated = "";
    for(var index = 0; index < (value === null || value === void 0 ? void 0 : value.length); index += 1){
        var ref;
        obfuscated += "\\u00".concat((ref = value === null || value === void 0 ? void 0 : value.charCodeAt(index)) === null || ref === void 0 ? void 0 : ref.toString(sizeHexaDecimal));
    }
    return obfuscated;
};
function obfuscateText(data) {
    if (typeof data === "number") {
        return "*".repeat(data.toString().length);
    }
    return data.replace(/./g, "*");
}
var obfuscateObject = function(data) {
    var obfuscatedObject = {};
    Object.keys(data).forEach(function(key) {
        obfuscatedObject["".concat(key)] = String(data["".concat(key)]).replace(/./g, "*");
    });
    return obfuscatedObject;
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/valueProduct/index.tsx
var valueProduct = function(price) {
    if (!(price === null || price === void 0 ? void 0 : price.spotPrice)) {
        return (price === null || price === void 0 ? void 0 : price.priceList) !== (price === null || price === void 0 ? void 0 : price.salePrice) && (price === null || price === void 0 ? void 0 : price.salePrice) ? price === null || price === void 0 ? void 0 : price.salePrice : (price === null || price === void 0 ? void 0 : price.priceList) || 0;
    }
    return (price === null || price === void 0 ? void 0 : price.spotPrice) > (price === null || price === void 0 ? void 0 : price.salePrice) && (price === null || price === void 0 ? void 0 : price.salePrice) ? price === null || price === void 0 ? void 0 : price.salePrice : price === null || price === void 0 ? void 0 : price.spotPrice;
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/anonymizeUserData/index.ts

var anonymizeUserData = function(data, user, cookie, headers) {
    var anonymizedData = data;
    var anonymizedUserData = user;
    var anonymizedCookies = cookie;
    var anonymizedHeaders = headers;
    var dataParams = [
        "login",
        "password",
        "email",
        "token",
        "cardNumber",
        "idToken",
        "refreshToken",
        "accessToken",
        "cvv",
        "holderCPF",
        "holderEmail",
        "number",
        "fcx_labs_user_access_token", 
    ];
    var userParams = [
        "email",
        "username"
    ];
    var cookiesParams = [
        "@FC:Ecom:Token:Access",
        "@FC:Ecom:Token:Refresh"
    ];
    var headersParams = [
        "Authorization"
    ];
    if (anonymizedData) {
        dataParams.forEach(function(param) {
            if (typeof anonymizedData["".concat(param)] === "string") {
                anonymizedData["".concat(param)] = obfuscateText(data["".concat(param)]);
            }
        });
    }
    if (anonymizedUserData) {
        userParams.forEach(function(param) {
            if (typeof anonymizedUserData["".concat(param)] === "string") {
                anonymizedUserData["".concat(param)] = obfuscateText(user["".concat(param)]);
            }
        });
    }
    if (anonymizedCookies) {
        cookiesParams.forEach(function(param) {
            if (typeof anonymizedCookies["".concat(param)] === "string") {
                anonymizedCookies["".concat(param)] = obfuscateText(cookie["".concat(param)]);
            }
        });
    }
    if (anonymizedHeaders) {
        headersParams.forEach(function(param) {
            if (typeof anonymizedHeaders["".concat(param)] === "string") {
                anonymizedHeaders["".concat(param)] = obfuscateText(headers["".concat(param)]);
            }
        });
    }
    return {
        anonymizedData: anonymizedData,
        anonymizedUserData: anonymizedUserData,
        anonymizedCookies: anonymizedCookies,
        anonymizedHeaders: anonymizedHeaders
    };
};

// EXTERNAL MODULE: ../../packages/application/utils/misc/branchLocation/index.ts
var branchLocation = __webpack_require__(2709);
;// CONCATENATED MODULE: ../../packages/application/utils/misc/buildTestIds/index.ts
var buildTestIds = function(id) {
    if (typeof id !== "string") {
        return {
            "data-cy": "",
            "data-testid": ""
        };
    }
    return {
        "data-cy": id,
        "data-testid": id
    };
};

;// CONCATENATED MODULE: ../../packages/application/utils/misc/capitalize/index.tsx
var capitalize = function(text) {
    try {
        if (typeof text !== "string") throw new Error("capitalize: text must be a string");
        return (text === null || text === void 0 ? void 0 : text[0]) ? text[0].toUpperCase() + text.substring(1).toLowerCase() : text;
    } catch (e) {
        return "";
    }
};
var capitalizeAll = function(text) {
    try {
        if (typeof text !== "string") throw new Error("capitalizeAll: text must be a string");
        return text.split(" ").map(function(word) {
            return (word === null || word === void 0 ? void 0 : word[0]) ? word[0].toUpperCase() + word.substring(1).toLowerCase() : "";
        }).join(" ");
    } catch (e) {
        return "";
    }
};
var capitalizeFirstLetterAndLowercaseRest = function(text) {
    try {
        var ref, ref1;
        if (typeof text !== "string") throw new Error("capitalizeFirstLetterAndLowercaseRest: text must be a string");
        if (!(text === null || text === void 0 ? void 0 : text.length)) return "";
        return (ref1 = (ref = text === null || text === void 0 ? void 0 : text.split(" ")) === null || ref === void 0 ? void 0 : ref.map(function(word, index) {
            var ref, ref1;
            return index !== 0 ? word === null || word === void 0 ? void 0 : word.toLocaleLowerCase() : "".concat(word === null || word === void 0 ? void 0 : (ref = word[0]) === null || ref === void 0 ? void 0 : ref.toLocaleUpperCase()).concat((ref1 = word === null || word === void 0 ? void 0 : word.slice(1)) === null || ref1 === void 0 ? void 0 : ref1.toLocaleLowerCase());
        })) === null || ref1 === void 0 ? void 0 : ref1.join(" ");
    } catch (e) {
        return "";
    }
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/getBranchName/index.ts
var getBranchName = function(branchId) {
    switch(Number(branchId)){
        case 1:
            return "Garanhuns";
        case 2:
            return "Imbiribeira";
        case 3:
            return "Paralela";
        case 4:
            return "Tamarineira";
        case 5:
            return "Aracaju";
        case 6:
            return "Jo\xe3o Pessoa";
        case 7:
            return "Ponta Negra";
        case 8:
            return "Caruaru";
        default:
            return "Imbiribeira";
    }
};

;// CONCATENATED MODULE: ../../packages/application/utils/misc/convertStoreOrderToDigital/index.ts

function convertStoreOrderToDigital(source) {
    return {
        client: null,
        groupId: 0,
        saleChannel: 1,
        hasTaxDocument: source === null || source === void 0 ? void 0 : source.hasTaxDocument,
        payments: source.payments.map(function(payment) {
            return {
                card: null,
                installments: 0,
                installmentValue: 0,
                orderId: source.orderId,
                paymentType: payment.paymentType,
                totalValue: payment.totalValue
            };
        }),
        packages: source.packages.map(function(pkg) {
            return {
                branchId: source.branchId,
                canCancel: false,
                carrierId: 0,
                createdOn: source.createdOn,
                faturadoOn: source.createdOn,
                isActiveIntelipost: Boolean(pkg.orderRemoteId),
                isActiveSode: false,
                isGift: false,
                isInStorePayment: true,
                lastUpdateOn: source.createdOn,
                totalPrice: pkg.totalValue,
                totalValue: pkg.totalValue,
                orderItems: pkg.product.map(function(item) {
                    return {
                        descriptionPackagingUnitPlural: item.descriptionPackagingUnitPlural,
                        descriptionPackagingUnitSingular: item.descriptionPackagingUnitSingular,
                        id: item.productId,
                        isPickUpInStore: false,
                        measuredUnity: item.measuredUnity,
                        mediaLink: [
                            {
                                defaultImage: item.imageUrl,
                                description: item.description,
                                imageUrl: item.imageUrl,
                                videoUrl: ""
                            }, 
                        ],
                        packaging: 0,
                        packagingQuantity: Number(item.packagingQuantity),
                        price: item.price,
                        quantity: item.quantity,
                        branchIdForPickup: pkg.branchIdForNfe,
                        productId: item.productId,
                        description: item.description,
                        paintColor: item.paintColor,
                        codeColor: item.codeColor
                    };
                }),
                branchIdForNfe: pkg.branchIdForNfe,
                deliveryDate: source.createdOn,
                detailDescriptionStatus: "Compra realizada na unidade ".concat(getBranchName(source.branchId)),
                forecastDateDescription: "",
                omniChannelId: 0,
                ordertHash: "",
                id: Number(pkg.packageId),
                orderId: source.orderId,
                statusForShow: "Entregue",
                trackingStatus: "Entregue",
                weddingList: null,
                sequential: 0,
                orderRemoteId: pkg.orderRemoteId,
                status: {
                    currentStatus: "Entregue"
                }
            };
        })
    };
}

;// CONCATENATED MODULE: ../../packages/application/utils/misc/formatBranchId/index.tsx
var formatBranchId = function(branchId) {
    var parsedBranchId = Number(branchId);
    if (!Number.isNaN(parsedBranchId)) {
        return branchId;
    }
    return "2";
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/formatDate/index.ts
var formatDate = function(data, IsformateBr) {
    var year = data.getFullYear();
    var month = (data.getMonth() + 1).toString().padStart(2, "0");
    var day = data.getDate().toString().padStart(2, "0");
    var hour = data.getHours().toString().padStart(2, "0");
    var minutes = data.getMinutes().toString().padStart(2, "0");
    var seconds = data.getSeconds().toString().padStart(2, "0");
    if (IsformateBr) {
        return "".concat(day, "/").concat(month, "/").concat(year);
    }
    return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minutes, ":").concat(seconds);
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/formatNumber/index.tsx
var formatNumber = function(value) {
    try {
        if (typeof value !== "number" || Number.isNaN(value)) throw new Error("formatNumber: Value must be a number");
        return new Intl.NumberFormat("pt-BR").format(value);
    } catch (e) {
        return "";
    }
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/formatPhoneNumber/index.tsx
var formatPhoneNumber = function(phoneNumber) {
    if (!phoneNumber || phoneNumber.length < 11) return false;
    var regex = /^(\d{2})(\d{5})(\d{4})$/;
    return phoneNumber.replace(regex, "($1) $2-$3");
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/formatStringUrl/index.tsx
var formatStringUrl = function(text) {
    if (typeof text !== "string") return "";
    var mapaAcentos = {
        á: "a",
        é: "e",
        í: "i",
        ó: "o",
        ú: "u",
        ã: "a",
        õ: "o",
        â: "a",
        ê: "e",
        î: "i",
        ô: "o",
        û: "u",
        à: "a",
        è: "e",
        ì: "i",
        ò: "o",
        ù: "u",
        ç: "c"
    };
    var newText = text.replace(" - ", "-");
    newText = newText.replace(/\s/g, "-");
    newText = newText.replace(/[ÀÁÂÃÄÅ]/g, "A");
    newText = newText.replace(/[àáâãäå]/g, "a");
    newText = newText.replace(/[ÈÉÊË]/g, "E");
    newText = newText.replace(/[/]/g, "");
    newText = newText.replace(/%/g, "");
    newText = newText.replace(/[áéíóúãõâêîôûàèìòùç]/gi, function(match) {
        return mapaAcentos[match] || match;
    });
    return newText.replace(/%/g, "").toLowerCase();
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/geoLocation/index.tsx
var getGeolocation = function() {
    return new Promise(function(resolve, reject) {
        if (false) {}
        if (!navigator.geolocation) {
            reject(new Error("Geolocaliza\xe7\xe3o n\xe3o \xe9 suportada pelo seu navegador."));
            return;
        }
        navigator.geolocation.getCurrentPosition(function(position) {
            var ref, ref1;
            return resolve({
                latitude: position === null || position === void 0 ? void 0 : (ref = position.coords) === null || ref === void 0 ? void 0 : ref.latitude,
                longitude: position === null || position === void 0 ? void 0 : (ref1 = position.coords) === null || ref1 === void 0 ? void 0 : ref1.longitude
            });
        }, function(error) {
            return resolve({
                latitude: "",
                longitude: "",
                message: error.message,
                code: error.code
            });
        });
    });
};

;// CONCATENATED MODULE: ../../packages/application/utils/misc/getClientBranchId/index.tsx
var getClientBranchId = function(cookie) {
    if (typeof cookie !== "object") return "2";
    return cookie.getCookie({
        name: "@FC:Ecom:Dropdown:BranchLocation"
    }) || "2";
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/getComponentTheme/index.ts
var getComponentTheme = function(themeValue, componentBlackFridayTheme) {
    var blackFridayTheme = componentBlackFridayTheme;
    if (themeValue && typeof themeValue.value === "string") {
        try {
            blackFridayTheme = JSON.parse(themeValue.value);
        } catch (error) {
            blackFridayTheme = undefined;
        }
    }
    return blackFridayTheme;
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/getFileByLink/index.ts
var getFileByLink = function(link, fileName) {
    var linkComponent = document.createElement("a");
    linkComponent.href = link;
    linkComponent.setAttribute("data-testid", "temporary-download-link");
    linkComponent.setAttribute("download", fileName);
    document.body.appendChild(linkComponent);
    linkComponent.click();
    linkComponent.remove();
};

;// CONCATENATED MODULE: ../../packages/application/utils/misc/getMeasuredUnit/index.tsx
var getMeasuredUnit = function(measuredUnity) {
    if (measuredUnity === "m\xb2") {
        return "/".concat(measuredUnity);
    }
    if (measuredUnity === "Rl") {
        return "/rolo";
    }
    return "";
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/getObjectLength/index.ts
var ref;
var getObjectLength = function(object) {
    return (ref = object === null || object === void 0 ? void 0 : object.length) !== null && ref !== void 0 ? ref : 0;
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/getSmallMappedCard/index.tsx


var getSmallMappedCard = function(cardName) {
    var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 24;
    if (typeof cardName !== "string" && typeof cardName !== "undefined") {
        return null;
    }
    switch(cardName){
        case "Mastercard":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Mastercard, {
                width: size,
                height: size
            });
        case "Visa":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Visa, {
                width: size,
                height: size
            });
        case "Hiper":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Hiper, {
                width: size,
                height: size
            });
        case "Elo":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Elo, {
                width: size,
                height: size
            });
        case "Amex":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Amex, {
                width: size,
                height: size
            });
        case "Jcb":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Jcb, {
                width: size,
                height: size
            });
        case "Diners":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Diners, {
                width: size,
                height: size
            });
        case "Hipercard":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Hipercard, {
                width: size,
                height: size
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.DefaultCard, {
                width: size,
                height: size
            });
    }
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/getPaymentIcon/index.tsx



var getPaymentIcon = function(paymentMethod, banner) {
    var payment = paymentMethod.toLowerCase();
    switch(payment){
        case "cash":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Banknote, {});
        case "downpayment":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.DownPayment, {});
        case "others":
        case "googlepay":
        case "giftcard":
        case "cupom":
        case "boleto":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.OthersPayments, {});
        case "pix":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.PixIconWithBG, {});
        default:
            return getSmallMappedCard(banner);
    }
};

// EXTERNAL MODULE: ../../packages/application/services/mocks/UtilInfo/data.ts
var data = __webpack_require__(25990);
;// CONCATENATED MODULE: ../../packages/application/utils/misc/getPaymentOptions/index.ts

var getPaymentOptions = function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5;
    return {
        creditCards: (ref = data/* paymentOptionsData */.JR === null || data/* paymentOptionsData */.JR === void 0 ? void 0 : data/* paymentOptionsData.0.options */.JR[0].options) === null || ref === void 0 ? void 0 : ref[0].images,
        pix: (ref5 = data/* paymentOptionsData */.JR === null || data/* paymentOptionsData */.JR === void 0 ? void 0 : (ref1 = data/* paymentOptionsData.0 */.JR[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.options) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[1]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.images) === null || ref4 === void 0 ? void 0 : ref4[0]) !== null && ref5 !== void 0 ? ref5 : null
    };
};

;// CONCATENATED MODULE: ../../packages/application/utils/misc/getPhoneNumberInvalidInformation/index.tsx
var getPhoneNumberInvalidInformation = function() {
    return {
        title: "N\xfamero de telefone inv\xe1lido",
        description: "Detectamos que o n\xfamero de telefone da sua conta n\xe3o segue o formato correto para o envio do c\xf3digo de verifica\xe7\xe3o. Para que voc\xea possa concluir a altera\xe7\xe3o de senha, pedimos que entre em contato com o SAC para atualizar seu n\xfamero de telefone para o formato (XX) XXXXX-XXXX. Assim que o n\xfamero for registrado corretamente, voc\xea poder\xe1 fazer a verifica\xe7\xe3o via SMS.",
        buttonText: "Alterar telefone",
        buttonAction: "https://ferreiracosta.movidesk.com/kb/"
    };
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/getSaleChannel/index.ts
var getSaleChannel = function(saleChannel) {
    if (saleChannel === 1) {
        return "loja";
    }
    if (saleChannel === 2) {
        return "site";
    }
    if (saleChannel === 4) {
        return "app";
    }
    return "site";
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/getSpotPrice/index.tsx
var getSpotPrice = function(product) {
    var ref, ref1, ref2, ref3;
    if (Number.isNaN(product)) return "R$\xa00";
    var spotPrice = ((ref1 = product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref.find(function(price) {
        return (price === null || price === void 0 ? void 0 : price.packingQuantity) === 1;
    })) === null || ref1 === void 0 ? void 0 : ref1.spotPrice) || (product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.spotPrice) || null;
    return (spotPrice === null || spotPrice === void 0 ? void 0 : spotPrice.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
    })) || null;
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/getUserInitials/index.ts
var getUserInitials = function(name) {
    var ref, ref1, ref2, ref3;
    if (!name) return null;
    var userNamesList = name.trimEnd().trimStart().split(" ");
    if (userNamesList.length === 1) {
        var ref4;
        var firstChar = (ref4 = userNamesList === null || userNamesList === void 0 ? void 0 : userNamesList.at(0)) === null || ref4 === void 0 ? void 0 : ref4.at(0);
        return firstChar ? firstChar.toUpperCase() : null;
    }
    var firstInitial = (ref1 = (ref = userNamesList === null || userNamesList === void 0 ? void 0 : userNamesList.at(0)) === null || ref === void 0 ? void 0 : ref.at(0)) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase();
    var lastInitial = (ref3 = (ref2 = userNamesList === null || userNamesList === void 0 ? void 0 : userNamesList.at(-1)) === null || ref2 === void 0 ? void 0 : ref2.at(0)) === null || ref3 === void 0 ? void 0 : ref3.toUpperCase();
    return "".concat(firstInitial).concat(lastInitial);
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/isObjectEmpty/index.tsx
var isObjectEmpty = function(passedObject) {
    try {
        var ref;
        if (typeof passedObject !== "object") throw new Error("Passed object is not an object");
        return !!(!passedObject || !((ref = Object.keys(passedObject)) === null || ref === void 0 ? void 0 : ref.length));
    } catch (e) {
        return true;
    }
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/removeSpecialCharacters/index.ts
function removeSpecialCharacters(text) {
    return text === null || text === void 0 ? void 0 : text.replace(/[^a-zA-Z0-9 ]/g, "");
}

;// CONCATENATED MODULE: ../../packages/application/utils/misc/shareText/index.tsx
var shareText = function(text) {
    if (navigator.share) {
        return navigator.share({
            text: text
        }).catch(function(error) {
            return error;
        });
    }
    return undefined;
};

;// CONCATENATED MODULE: ../../packages/application/utils/misc/trackingOrder/index.ts
var isSpecialStatus = function(idStatus) {
    var specialStatus = [
        3,
        25,
        251,
        5,
        94,
        394,
        13,
        108
    ];
    return specialStatus === null || specialStatus === void 0 ? void 0 : specialStatus.includes(idStatus);
};
var isAttentionStatus = function(idStatus) {
    var attentionStatus = [
        20,
        103,
        188,
        341,
        335,
        19,
        186,
        196,
        21,
        303,
        342
    ];
    return attentionStatus === null || attentionStatus === void 0 ? void 0 : attentionStatus.includes(idStatus);
};


;// CONCATENATED MODULE: ../../packages/application/utils/misc/getProductPosition/index.tsx
var getProductPosition = function(productPosition, totalProducts, pageIndex) {
    if (totalProducts && pageIndex) {
        return productPosition + totalProducts * (pageIndex - 1);
    }
    return productPosition;
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ../../packages/application/utils/misc/filterStoreOrders/index.ts


function filterStoreOrders(source, isUniqueClientAvailable) {
    if (!isUniqueClientAvailable) {
        var ref, ref1;
        var reliableOrders = source === null || source === void 0 ? void 0 : (ref = source.items) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.saleChannel) !== 1;
        });
        var storeOrders = source === null || source === void 0 ? void 0 : (ref1 = source.items) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.saleChannel) === 1;
        });
        var totalResults = (source === null || source === void 0 ? void 0 : source.totalResults) || 0;
        var storeOrdersLength = (storeOrders === null || storeOrders === void 0 ? void 0 : storeOrders.length) || 0;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, source), {
            items: reliableOrders,
            totalResults: totalResults - storeOrdersLength
        });
    }
    return source;
}

;// CONCATENATED MODULE: ../../packages/application/utils/misc/getUserActions/index.tsx


var userAuthenticatedActions = function(allConfigs) {
    return [
        {
            id: 8,
            title: "Minha conta",
            path: "/conta/",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[680];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.MyAccountIcon, {
                    color: color
                });
            }
        },
        {
            id: 5,
            title: "Meus cart\xf5es",
            path: "/conta/meus-cartoes",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[680];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.MyCardsIcon, {
                    color: color
                });
            }
        },
        {
            id: 1,
            title: "Meus pedidos",
            path: "/conta/meus-pedidos",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[680];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.MyOrdersIcon, {
                    color: color
                });
            }
        },
        {
            id: 3,
            title: "Meus dados",
            path: "/conta/meus-dados",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[680];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.MyDataIcon, {
                    color: color
                });
            }
        },
        {
            id: 7,
            title: "Minhas listas",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[680];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.MyListsIcon, {
                    width: 20,
                    height: 20,
                    color: color
                });
            },
            path: "/conta/minhas-listas"
        },
        {
            id: 8,
            title: "Lista de Casamento",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[680];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.WeddingRingIcon, {
                    width: 20,
                    height: 20,
                    color: color
                });
            },
            path: "/lista-de-casamento"
        },
        {
            id: 4,
            title: "Seguran\xe7a",
            path: (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isSecurityPageAvailable) === "true" ? "/conta/seguranca" : "/conta/seguranca/alterar-senha",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[680];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.MySecurityIcon, {
                    color: color
                });
            }
        },
        {
            id: 6,
            title: "Meus endere\xe7os",
            path: "/conta/meus-enderecos",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[680];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.AddressListIcon, {
                    width: 20,
                    height: 20,
                    color: color
                });
            }
        }, 
    ];
};

;// CONCATENATED MODULE: ../../packages/application/utils/misc/index.tsx














var sortListShipping = function(ListData) {
    try {
        return ListData === null || ListData === void 0 ? void 0 : ListData.reduce(function(previousItens, currentItem) {
            var itens = previousItens;
            if (currentItem.pickUpInStore) {
                itens.pickUpAtTheStore.push(currentItem);
                return itens;
            }
            itens.delivery.push(currentItem);
            return itens;
        }, {
            delivery: [],
            pickUpAtTheStore: []
        });
    } catch (e) {
        return {
            delivery: [],
            pickUpAtTheStore: []
        };
    }
};
var searchValueInObject = function(object, valueSearch) {
    var listValues = Object.entries(object);
    return listValues.find(function(item) {
        return item.includes(valueSearch);
    });
};
var removeItensNullOrUndefinedObject = function(obj) {
    return Object.fromEntries(Object.entries(obj).filter(function(param) {
        var _param = _sliced_to_array(param, 2), value = _param[1];
        return value !== null && value !== undefined;
    }));
};
var filterValueProductPricePackage = function(price) {
    return (price === null || price === void 0 ? void 0 : price.spotPrice) || ((price === null || price === void 0 ? void 0 : price.priceList) !== (price === null || price === void 0 ? void 0 : price.salePrice) ? price === null || price === void 0 ? void 0 : price.salePrice : price === null || price === void 0 ? void 0 : price.priceList);
};
var formatUTCToShort = function(date) {
    return String(new Date(date).toLocaleDateString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    }));
};
var formatDateToShortCrm = function(date) {
    var day = date ? date.getDate().toString().padStart(2, "0") : "";
    var month = date ? (date.getMonth() + 1).toString().padStart(2, "0") : "";
    var year = date ? date.getFullYear() : "";
    return date ? "".concat(year, "/").concat(month, "/").concat(day) : "";
};
var formatShortenDate = function(date) {
    if (date) {
        var dateObj = new Date(date);
        var day = dateObj.getDate().toString().padStart(2, "0");
        var month = dateObj.toLocaleString("pt-BR", {
            month: "short"
        }).replace(/^\w/, function(c) {
            return c.toUpperCase();
        });
        var year = dateObj.getFullYear().toString().slice(-2);
        return "".concat(day, " ").concat(month.replace(".", ","), " ").concat(year);
    }
    return date;
};
var formatShortenDateWithoutYear = function(date) {
    if (date) {
        var dateObj = new Date(date);
        var day = dateObj.getDate().toString().padStart(2, "0");
        var month = dateObj.toLocaleString("pt-BR", {
            month: "short"
        }).replace(/^\w/, function(c) {
            return c.toUpperCase();
        });
        return "".concat(day, " ").concat(month.replace(".", ""), " ");
    }
    return date;
};
var extractTimeFromUTC = function(dateTimeString) {
    if (dateTimeString) {
        var dataObj = new Date(dateTimeString);
        var hours = dataObj.getHours();
        var minutes = dataObj.getMinutes();
        return "".concat(hours.toString().padStart(2, "0"), ":").concat(minutes.toString().padStart(2, "0"));
    }
    return null;
};
var formatDateAndTime = function(date) {
    try {
        if (!_instanceof(date, Date)) {
            throw new Error("formatDateAndTime: date must be a date");
        }
        return String(new Date(date).toLocaleDateString("pt-BR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        }));
    } catch (e) {
        return "";
    }
};
var dateFormatForCardMessage = function(dateTransform) {
    var updateOnDate = formatUTCToShort(dateTransform);
    var date = new Date().getDate();
    var currentDate = date < 10 ? "0".concat(date) : date;
    if (currentDate === updateOnDate) {
        return "hoje";
    }
    return updateOnDate;
};
var getMappedCard = function(cardName) {
    switch(cardName){
        case "Mastercard":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Mastercard, {});
        case "Visa":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Visa, {});
        case "Hiper":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Hiper, {});
        case "Elo":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Elo, {});
        case "Amex":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Amex, {});
        case "Jcb":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Jcb, {});
        case "Diners":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Diners, {});
        case "Hipercard":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Hipercard, {});
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.DefaultCard, {});
    }
};
var brazilianStates = [
    {
        state: "AC"
    },
    {
        state: "AL"
    },
    {
        state: "AM"
    },
    {
        state: "AP"
    },
    {
        state: "BA"
    },
    {
        state: "CE"
    },
    {
        state: "DF"
    },
    {
        state: "ES"
    },
    {
        state: "GO"
    },
    {
        state: "MA"
    },
    {
        state: "MG"
    },
    {
        state: "MS"
    },
    {
        state: "MT"
    },
    {
        state: "PA"
    },
    {
        state: "PB"
    },
    {
        state: "PE"
    },
    {
        state: "PI"
    },
    {
        state: "PR"
    },
    {
        state: "RJ"
    },
    {
        state: "RN"
    },
    {
        state: "RO"
    },
    {
        state: "RR"
    },
    {
        state: "RS"
    },
    {
        state: "SC"
    },
    {
        state: "SE"
    },
    {
        state: "SP"
    },
    {
        state: "TO"
    }, 
];
var getUserFirstName = function(fullname) {
    var fullName = fullname === null || fullname === void 0 ? void 0 : fullname.split(" ");
    return fullName === null || fullName === void 0 ? void 0 : fullName[0];
};
var getUserSurname = function(fullname) {
    var fullName = fullname === null || fullname === void 0 ? void 0 : fullname.split(" ");
    return fullName === null || fullName === void 0 ? void 0 : fullName[1];
};
var formatCpf = function(cpf) {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
};
var removeCharactersSpecials = function(value) {
    return value.replace(/[^0-9]/g, "");
};
var getPriceList = function(product) {
    var ignoreDiscountPercentageValidation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var priceList = (product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.priceList) !== (product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.salePrice) ? (product === null || product === void 0 ? void 0 : (ref4 = product.prices) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.priceList) || ((ref7 = product === null || product === void 0 ? void 0 : (ref6 = product.prices) === null || ref6 === void 0 ? void 0 : ref6.find(function(price) {
        return ignoreDiscountPercentageValidation || (price === null || price === void 0 ? void 0 : price.discountPercentage) !== "0";
    })) === null || ref7 === void 0 ? void 0 : ref7.priceList) || null : null;
    return (priceList === null || priceList === void 0 ? void 0 : priceList.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
    })) || null;
};
var getSalePrice = function(product, appMonitoringClient) {
    var ref, ref1, ref2, ref3;
    var salePrice = ((ref1 = product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref.find(function(price) {
        return (price === null || price === void 0 ? void 0 : price.packingQuantity) === 1;
    })) === null || ref1 === void 0 ? void 0 : ref1.salePrice) || (product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.salePrice) || null;
    if (!salePrice) {
        appMonitoringClient === null || appMonitoringClient === void 0 ? void 0 : appMonitoringClient.captureMessage("O produto ".concat(product === null || product === void 0 ? void 0 : product.id, " n\xe3o possui salePrice"), "warning");
        return null;
    }
    return salePrice === null || salePrice === void 0 ? void 0 : salePrice.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
    });
};
var getMaxInstallments = function(product) {
    var ref, ref1, ref2, ref3;
    return ((ref1 = product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref.find(function(price) {
        return (price === null || price === void 0 ? void 0 : price.packingQuantity) === 1;
    })) === null || ref1 === void 0 ? void 0 : ref1.maxNumberInstallments) || (product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.maxNumberInstallments) || null;
};
var getInstallmentValue = function(product, appMonitoringClient) {
    var ref, ref1;
    var priceObject = (product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref.find(function(price) {
        return price.packingQuantity === 1;
    })) || (product === null || product === void 0 ? void 0 : (ref1 = product.prices) === null || ref1 === void 0 ? void 0 : ref1[0]) || null;
    if (!(priceObject === null || priceObject === void 0 ? void 0 : priceObject.salePrice)) {
        appMonitoringClient === null || appMonitoringClient === void 0 ? void 0 : appMonitoringClient.captureMessage("O produto ".concat(product === null || product === void 0 ? void 0 : product.id, " n\xe3o possui salePrice"), "warning");
        return null;
    }
    if (!(priceObject === null || priceObject === void 0 ? void 0 : priceObject.maxNumberInstallments)) {
        appMonitoringClient === null || appMonitoringClient === void 0 ? void 0 : appMonitoringClient.captureMessage("O produto ".concat(product === null || product === void 0 ? void 0 : product.id, " n\xe3o possui maxNumberInstallments"), "warning");
        return null;
    }
    var installment = priceObject.salePrice / priceObject.maxNumberInstallments;
    return installment.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
    });
};
var getInstallmentsText = function(product) {
    var textOption = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return ({
        1: "ou at\xe9 ".concat(getMaxInstallments(product), "x de ").concat(getInstallmentValue(product), " s/juros"),
        2: "ou at\xe9 ".concat(getMaxInstallments(product), "x ").concat(getInstallmentValue(product), " sem juros"),
        3: "ou at\xe9 ".concat(getMaxInstallments(product), "x ").concat(getInstallmentValue(product), " s/ juros"),
        4: "ou ".concat(getMaxInstallments(product), "x de ").concat(getInstallmentValue(product), " s/ juros")
    })["".concat(textOption)];
};
var formatDatePhrase = function(date) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "full";
    if (date) {
        var data = new Date(date);
        var options = (0,_object_spread/* default */.Z)({
            day: "numeric",
            month: "long"
        }, type === "full" && {
            year: "numeric"
        });
        return data.toLocaleDateString("pt-BR", options);
    }
    return date;
};
var mapFilterProductsByPlaylistToSearchByTerm = function(data) {
    var ref, ref1;
    return {
        products: data === null || data === void 0 ? void 0 : data.products,
        facets: data === null || data === void 0 ? void 0 : (ref = data.facetsResponse) === null || ref === void 0 ? void 0 : (ref1 = ref.aggregations) === null || ref1 === void 0 ? void 0 : ref1.topk,
        title: data === null || data === void 0 ? void 0 : data.title,
        instructions: data === null || data === void 0 ? void 0 : data.instructions
    };
};
var installmentsOptionsFormatted = function(param) {
    var maxNumberOfInstallments = param.maxNumberOfInstallments, totalSalePrice = param.totalSalePrice, totalSpotPrice = param.totalSpotPrice;
    return Array.from({
        length: maxNumberOfInstallments || 1
    }, function(_, index) {
        var installmentNumber = index + 1;
        var isFirstPositionAtArray = index === 0;
        var installment = Number(isFirstPositionAtArray ? totalSpotPrice : totalSalePrice / installmentNumber);
        var installmentPrice = formatCurrency(installment);
        return "".concat(installmentNumber, "x de ").concat(installmentPrice, " ").concat(isFirstPositionAtArray ? "\xe0 vista" : "sem juros");
    });
};
var getProductBreadcrumbItems = function(product) {
    if (!(product === null || product === void 0 ? void 0 : product.breadCrumbs)) {
        return null;
    }
    var _breadCrumbs = product.breadCrumbs, _category = _breadCrumbs.category, tmp = _category.name, categoryName = tmp === void 0 ? "" : tmp, tmp1 = _category.link, categoryLink = tmp1 === void 0 ? "" : tmp1, _fatherCategory = _breadCrumbs.fatherCategory, tmp2 = _fatherCategory.name, fatherCategoryName = tmp2 === void 0 ? "" : tmp2, tmp3 = _fatherCategory.link, fatherCategoryLink = tmp3 === void 0 ? "" : tmp3, _grandFatherCategory = _breadCrumbs.grandFatherCategory, tmp4 = _grandFatherCategory.name, grandFatherCategoryName = tmp4 === void 0 ? "" : tmp4, tmp5 = _grandFatherCategory.link, grandFatherCategoryLink = tmp5 === void 0 ? "" : tmp5, _description = product.description, description = _description === void 0 ? "" : _description;
    return {
        items: {
            common: [
                {
                    description: grandFatherCategoryName,
                    url: "/".concat(grandFatherCategoryLink)
                },
                {
                    description: fatherCategoryName,
                    url: "/".concat(fatherCategoryLink)
                },
                {
                    description: categoryName,
                    url: "/".concat(categoryLink)
                },
                {
                    description: description
                }, 
            ],
            mobile: {
                description: categoryName,
                url: "/".concat(categoryLink)
            }
        }
    };
};
var handleProductTag = function(productId, productTag, appMonitoringClient) {
    if (productTag) {
        var ref;
        if (!(productTag === null || productTag === void 0 ? void 0 : productTag.icon)) {
            appMonitoringClient.captureMessage("O produto de COD: ".concat(productId, " n\xe3o possui um \xedcone para a tag customizada."), {
                level: "warning",
                tags: {
                    fcx_labs_error_source: "api"
                }
            });
        }
        if ((productTag === null || productTag === void 0 ? void 0 : productTag.icon) && typeof productTag.icon !== "string" && !((ref = productTag === null || productTag === void 0 ? void 0 : productTag.icon) === null || ref === void 0 ? void 0 : ref.imageUrl)) {
            appMonitoringClient.captureMessage("O produto de COD: ".concat(productId, " n\xe3o possui um link para imagem do \xedcone da tag customizada."), {
                level: "warning",
                tags: {
                    fcx_labs_error_source: "api"
                }
            });
        }
    }
};
var getProductQuantity = function(id, cartItems) {
    var foundItem = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(item) {
        return (item === null || item === void 0 ? void 0 : item.productId) === String(id);
    });
    return foundItem === null || foundItem === void 0 ? void 0 : foundItem.quantity;
};
var formatCountdownTimer = function(date) {
    var DAYS_IN_SECONDS = 60 * 60 * 24;
    var HOURS_IN_SECONDS = 60 * 60;
    var MINUTES_IN_SECONDS = 60;
    var dateNow = new Date();
    var futureDate = new Date(date);
    var timestamp = dateNow.getTime();
    var futureTimestamp = futureDate.getTime();
    var diffInSeconds = (futureTimestamp - timestamp) / 1000;
    var days = 0;
    if (futureTimestamp > timestamp) {
        days = Math.floor(diffInSeconds / DAYS_IN_SECONDS);
        diffInSeconds -= days * DAYS_IN_SECONDS;
    } else {
        diffInSeconds = 0;
    }
    var hours = Math.floor(diffInSeconds / HOURS_IN_SECONDS);
    diffInSeconds -= hours * HOURS_IN_SECONDS;
    var minutes = Math.floor(diffInSeconds / MINUTES_IN_SECONDS);
    diffInSeconds -= minutes * MINUTES_IN_SECONDS;
    var seconds = Math.floor(diffInSeconds);
    return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
};
var getPageCacheControlInfo = function(envValue) {
    var staleWhileRevalidateEnv = Number(envValue);
    var staleWhileRevalidate = !Number.isNaN(staleWhileRevalidateEnv) ? staleWhileRevalidateEnv : 300;
    var maxAge = staleWhileRevalidate - 30;
    return {
        staleWhileRevalidate: staleWhileRevalidate,
        maxAge: maxAge
    };
};
var generateId = function(type, idGenerator) {
    if (type === "uuid") {
        return idGenerator.generateUUID();
    }
    return "";
};
var formatEmailToShowOnlyFourCharactersAndDomain = function(email) {
    var characterSpecial = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "*";
    var ref;
    var regexToGetDomain = /^.{4}.*@(.+)$/;
    var domain = (ref = email === null || email === void 0 ? void 0 : email.match(regexToGetDomain)) === null || ref === void 0 ? void 0 : ref[1];
    var firstFourthCharactersFromEmail = email === null || email === void 0 ? void 0 : email.substring(0, 4);
    var regexToRemoveDomainAndFirstFourDigits = /^.{4}(.+?)@.+/;
    var result = email === null || email === void 0 ? void 0 : email.replace(regexToRemoveDomainAndFirstFourDigits, "$1");
    var restOfEmailWithCharacter = characterSpecial.repeat(result === null || result === void 0 ? void 0 : result.length);
    return "".concat(firstFourthCharactersFromEmail).concat(restOfEmailWithCharacter, "@").concat(domain);
};
var formatTestId = function(testId) {
    if (!testId) {
        return "";
    }
    var newTestId = testId.replace(/\s/g, "-");
    return newTestId.toLowerCase();
};
var replaceImageBaseUrl = function(imageUrl) {
    return imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.replace(/fercos-backoffice.s3.us-east-1.amazonaws.com|fercos-s3-ecommerce.s3.amazonaws.com/, "fcx-s3-fercos-backoffice.ferreiracosta.com");
};
var formatUserName = function(clientName) {
    var ref;
    if (!clientName) return "";
    var names = (ref = clientName === null || clientName === void 0 ? void 0 : clientName.trim()) === null || ref === void 0 ? void 0 : ref.split(" ");
    var formattedNames = names.map(function(name) {
        return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    });
    return formattedNames.join(" ");
};


































;// CONCATENATED MODULE: ../../packages/application/utils/mocks/index.tsx
var mockedBlackFridayTheme = function() {
    var isBlackTheme = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return {
        id: "mocked_id",
        isBlackTheme: isBlackTheme,
        startAt: "",
        endAt: ""
    };
};
var mockedDefaultPageThemeMap = {
    home: "default",
    category: "default",
    highlight: "default",
    searchResult: "default",
    login: "default",
    product: "default",
    cart: "default",
    myAddresses: "default",
    myOrders: "default",
    myWeddingLists: "default",
    myCreditCards: "default",
    changePassword: "default",
    myOrdersByPhone: "default",
    detailedOrder: "default",
    myData: "default"
};
var mockedPageThemeMap = function(param) {
    var _home = param.home, home = _home === void 0 ? "default" : _home, _category = param.category, category = _category === void 0 ? "default" : _category, _highlight = param.highlight, highlight = _highlight === void 0 ? "default" : _highlight, _searchResult = param.searchResult, searchResult = _searchResult === void 0 ? "default" : _searchResult, _login = param.login, login = _login === void 0 ? "default" : _login, _product = param.product, product = _product === void 0 ? "default" : _product, _cart = param.cart, cart = _cart === void 0 ? "default" : _cart, _myAddresses = param.myAddresses, myAddresses = _myAddresses === void 0 ? "default" : _myAddresses, _myOrders = param.myOrders, myOrders = _myOrders === void 0 ? "default" : _myOrders, _myWeddingLists = param.myWeddingLists, myWeddingLists = _myWeddingLists === void 0 ? "default" : _myWeddingLists, _myCreditCards = param.myCreditCards, myCreditCards = _myCreditCards === void 0 ? "default" : _myCreditCards, _changePassword = param.changePassword, changePassword = _changePassword === void 0 ? "default" : _changePassword, _myOrdersByPhone = param.myOrdersByPhone, myOrdersByPhone = _myOrdersByPhone === void 0 ? "default" : _myOrdersByPhone, _detailedOrder = param.detailedOrder, detailedOrder = _detailedOrder === void 0 ? "default" : _detailedOrder, _myData = param.myData, myData = _myData === void 0 ? "default" : _myData;
    return {
        home: home,
        category: category,
        highlight: highlight,
        searchResult: searchResult,
        login: login,
        product: product,
        cart: cart,
        myAddresses: myAddresses,
        myOrders: myOrders,
        myWeddingLists: myWeddingLists,
        myCreditCards: myCreditCards,
        changePassword: changePassword,
        myOrdersByPhone: myOrdersByPhone,
        detailedOrder: detailedOrder,
        myData: myData
    };
};
var mockedHeatmapClientMap = new Map();
var mockedHeatmapClient = {
    Id: function Id() {
        return "mocked_heatmapClient_id";
    },
    cookieConsent: function cookieConsent() {
        mockedHeatmapClientMap.set("consent", {});
    },
    customIdentifiers: function customIdentifiers(customId, customSessionId, customPageId, friendlyName) {
        mockedHeatmapClientMap.set("identify", {
            customId: customId,
            customSessionId: customSessionId,
            customPageId: customPageId,
            friendlyName: friendlyName
        });
    },
    customTags: function customTags(key, value) {
        mockedHeatmapClientMap.set("set", {
            key: key,
            value: value
        });
    },
    upgradeSession: function upgradeSession(upgradeReason) {
        mockedHeatmapClientMap.set("upgrade", {
            upgradeReason: upgradeReason
        });
    },
    resetCustomIdentifiers: function resetCustomIdentifiers() {
        mockedHeatmapClientMap.set("identify", {
            customId: "",
            customSessionId: ""
        });
    }
};

var dropListTerms = [
    /Failed to fetch/,
    "Invalid data: Key Name",
    "<unknown>",
    "aD",
    "Response served by service worker is an error",
    /TypeError/, 
];

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/application/utils/sessionId/index.tsx

var clientSessionIdStr = "@FC:Ecom:Client:sessionId";
var useCreateSessionId = function(idGenerator) {
    var ref = useState(""), clientSessionId = ref[0], setClientSessionId = ref[1];
    var ref1 = useState(true), isFirstRender = ref1[0], setIsFirstRender = ref1[1];
    useEffect(function() {
        if (isFirstRender) {
            var alreadyExistentSessionId = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(clientSessionIdStr);
            if (alreadyExistentSessionId) {
                setClientSessionId(alreadyExistentSessionId);
                return;
            }
            var generatedId = idGenerator.generateUUID();
            setClientSessionId(generatedId);
            sessionStorage.setItem(clientSessionIdStr, String(generatedId));
            setIsFirstRender(false);
        }
    }, [
        idGenerator,
        isFirstRender
    ]);
    return clientSessionId;
};
var getSessionId = function() {
    return (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(clientSessionIdStr)) || "";
};
var createSessionId = function(idGenerator) {
    var alreadyExistentSessionId = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(clientSessionIdStr);
    if (alreadyExistentSessionId) {
        return alreadyExistentSessionId;
    }
    var generatedId = idGenerator.generateUUID();
    sessionStorage.setItem(clientSessionIdStr, String(generatedId));
    return generatedId;
};


// EXTERNAL MODULE: ../../packages/application/utils/validations/index.ts + 8 modules
var validations = __webpack_require__(12747);
// EXTERNAL MODULE: ../../packages/typing/index.tsx + 7 modules
var typing = __webpack_require__(96915);
;// CONCATENATED MODULE: ../../packages/application/utils/wedding-list/index.tsx

var getIsListInactive = function(weddingList) {
    var isOpenList = typing/* StatusGiftList.Open */.$1.Open;
    return (weddingList === null || weddingList === void 0 ? void 0 : weddingList.listStatusId) !== isOpenList;
};
var sortingFavoritesStoresList = function(array) {
    return array === null || array === void 0 ? void 0 : array.sort(function(a, b) {
        var citiesList = a.city.localeCompare(b.city);
        if (citiesList === 0) {
            return a.district.localeCompare(b.district);
        }
        return citiesList;
    });
};


;// CONCATENATED MODULE: ../../packages/application/utils/fallback/index.ts
var getApisUrlFallback = function(env) {
    switch(env){
        case "development":
            return "https://fcxlabs-ecommerce-dev-api.ferreiracosta.com/";
        case "qas":
            return "https://fcxlabs-ecommerce-qas-api.ferreiracosta.com/";
        case "production":
            return "https://fcxlabs-ecommerce-api.ferreiracosta.com/";
        default:
            return "https://fcxlabs-ecommerce-api.ferreiracosta.com/";
    }
};

;// CONCATENATED MODULE: ../../packages/application/utils/index.tsx











/***/ }),

/***/ 2709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ optionsMaxAgeEqualOneYear; },
/* harmony export */   "NL": function() { return /* binding */ cookieBranchLocationStr; },
/* harmony export */   "em": function() { return /* binding */ cookiePostalCodeStr; },
/* harmony export */   "tK": function() { return /* binding */ getClientLocationDetails; },
/* harmony export */   "us": function() { return /* binding */ cookieRegionStr; },
/* harmony export */   "wW": function() { return /* binding */ cookieModalBranchLocationStr; }
/* harmony export */ });
var cookieModalBranchLocationStr = "@FC:Ecom:Modal:BranchLocation";
var cookieBranchLocationStr = "@FC:Ecom:Dropdown:BranchLocation";
var cookieRegionStr = "@FC:Ecom:Dropdown:Region";
var cookiePostalCodeStr = "@FC:Ecom:Dropdown:Cep";
var optionsMaxAgeEqualOneYear = {
    options: {
        maxAge: 60 * 60 * 24 * 365
    }
};
var getClientLocationDetails = function(cookie) {
    var clientLocation = cookie.getCookie({
        name: cookieRegionStr
    }) || "";
    var clientPostalCode = (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(cookiePostalCodeStr)) || "";
    var clientBranchId = Number(cookie.getCookie({
        name: cookieBranchLocationStr
    }) || 2);
    return {
        clientLocation: clientLocation,
        clientBranchId: clientBranchId,
        clientPostalCode: clientPostalCode
    };
};



/***/ }),

/***/ 12747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n5": function() { return /* reexport */ handleCreditCardCvvMask; },
  "n0": function() { return /* reexport */ handleCreditCardCvvPlaceholder; },
  "nl": function() { return /* reexport */ handleCreditCardNumberMask; },
  "oM": function() { return /* reexport */ validCpfRegex; },
  "C2": function() { return /* reexport */ validEmailRegex; },
  "a9": function() { return /* reexport */ validateBirthdate; },
  "D4": function() { return /* reexport */ validateCardNumber; },
  "S$": function() { return /* reexport */ validateConfirmPassword; },
  "cy": function() { return /* reexport */ validateCpf; },
  "mE": function() { return /* reexport */ validateCreditCardCVV; },
  "m2": function() { return /* reexport */ validateCreditCardDueDate; },
  "oH": function() { return /* reexport */ validateEmail; },
  "Ol": function() { return /* reexport */ validateName; },
  "uo": function() { return /* reexport */ validatePassword; },
  "Y0": function() { return /* reexport */ validatePhoneNumber; },
  "VW": function() { return /* reexport */ validateSecurityCode; }
});

// UNUSED EXPORTS: ERROR_MESSAGES_BIRTHDATE, handleEmailValidation, handleNameValidation, isFebruaryInvalid, isLeapYear, quantityOfDaysIsBiggerThanThirty, sumYears, validateEmailFormWeddingList, validateFirstName, validateLettersAndNumbers, validateNameFormWeddingList, validateWeddingDate, validateWeddingList

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
;// CONCATENATED MODULE: ../../packages/application/utils/validations/birthdate/index.ts

var ERROR_MESSAGES_BIRTHDATE = {
    birthdateRequired: "O campo data de nascimento \xe9 obrigat\xf3rio!",
    birthdateInvalid: "Data no formato inv\xe1lido!",
    birthdateMinDate: "A data de nascimento n\xe3o pode ser anterior ao ano de 1901.",
    birthdateMajority: "\xc9 necessario ter mais de 18 anos para se cadastrar.",
    birthdateMaxDate: "A data de nascimento n\xe3o pode ser maior que a data atual."
};
var MAJORITY_AGE = 18;
var birthdate_isFebruaryInvalid = function(day, month, year) {
    return Number(month) === 2 && (Number(day) > 28 && Number(year) % 4 !== 0 || Number(day) > 29 && Number(year) % 4 === 0);
};
var birthdate_quantityOfDaysIsBiggerThanThirty = function(day, month) {
    return (Number(month) === 4 || Number(month) === 11 || Number(month) === 6 || Number(month) === 9) && Number(day) > 30;
};
var validateBirthdate = function(birthdate) {
    if (typeof birthdate !== "string" || birthdate === "") return "";
    var ref = (0,_sliced_to_array/* default */.Z)(birthdate.split("/"), 3), day = ref[0], month = ref[1], year = ref[2];
    if (Number(year) < 1901) return ERROR_MESSAGES_BIRTHDATE.birthdateMinDate;
    if (Number(day) > 31 || Number(day) === 0) return ERROR_MESSAGES_BIRTHDATE.birthdateInvalid;
    if (Number(month) > 12 || Number(month) === 0) return ERROR_MESSAGES_BIRTHDATE.birthdateInvalid;
    if (birthdate_quantityOfDaysIsBiggerThanThirty(day, month) || birthdate_isFebruaryInvalid(day, month, year)) return ERROR_MESSAGES_BIRTHDATE.birthdateInvalid;
    var birthdateDate = new Date("".concat(year, "-").concat(month, "-").concat(day, " 00:00:00"));
    var oldDate = new Date("1900-12-31");
    var todayDate = new Date();
    if (birthdateDate <= oldDate) return ERROR_MESSAGES_BIRTHDATE.birthdateMinDate;
    if (birthdateDate >= todayDate) return ERROR_MESSAGES_BIRTHDATE.birthdateMaxDate;
    var currentYear = todayDate.getFullYear();
    var birthYear = Number(year);
    if (currentYear - birthYear < MAJORITY_AGE) {
        return ERROR_MESSAGES_BIRTHDATE.birthdateMajority;
    }
    return "";
};

;// CONCATENATED MODULE: ../../packages/application/utils/validations/date/index.ts

var isLeapYear = function(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
var sumYears = function(date, quantity) {
    var year = date.getFullYear();
    var yearsInMillisecondsToSum = 0;
    for(var i = 0; i < quantity; i += 1){
        if (isLeapYear(year)) {
            yearsInMillisecondsToSum += 1000 * 60 * 60 * 24 * 366;
        } else {
            yearsInMillisecondsToSum += 1000 * 60 * 60 * 24 * 365;
        }
        year += 1;
    }
    return new Date(date.getTime() + yearsInMillisecondsToSum);
};
var validateWeddingDate = function(dateString) {
    var dateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
    var matches = dateString === null || dateString === void 0 ? void 0 : dateString.match(dateRegex);
    if (!matches) {
        return {
            hasError: true,
            errorMessage: "Data no formato inv\xe1lido!"
        };
    }
    var day = parseInt(matches[1], 10);
    var month = parseInt(matches[2], 10);
    var year = parseInt(matches[3], 10);
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth() + 1;
    var currentDay = currentDate.getDate();
    if (month < 1 || month > 12 || day < 1 || isFebruaryInvalid(day, month, year) || quantityOfDaysIsBiggerThanThirty(day, month)) {
        return {
            hasError: true,
            errorMessage: "Data no formato inv\xe1lido!"
        };
    }
    if (year < currentYear || year === currentYear && month < currentMonth || year === currentYear && month === currentMonth && day < currentDay) {
        var formattedCurrentDate = "".concat(currentDay.toString().padStart(2, "0"), "/").concat(currentMonth.toString().padStart(2, "0"), "/").concat(currentYear);
        return {
            hasError: true,
            errorMessage: "A data do evento deve ser maior que a data atual ".concat(formattedCurrentDate)
        };
    }
    var maxDate = sumYears(new Date(), 1);
    if (year > maxDate.getFullYear() || year === maxDate.getFullYear() && new Date(year, month - 1, day) > maxDate) {
        var formattedMaxDate = "".concat(maxDate.getDate().toString().padStart(2, "0"), "/").concat((maxDate.getMonth() + 1).toString().padStart(2, "0"), "/").concat(maxDate.getFullYear());
        return {
            hasError: true,
            errorMessage: "A data do evento deve ser menor que ".concat(formattedMaxDate)
        };
    }
    return {
        hasError: false,
        errorMessage: ""
    };
};

;// CONCATENATED MODULE: ../../packages/application/utils/validations/card/index.ts

var validateCardNumber = function(cardNumber, secondCardNumber) {
    if (typeof cardNumber !== "string") return "O n\xfamero do cart\xe3o \xe9 inv\xe1lido!";
    var cardMinLengthMessage = "O n\xfamero do cart\xe3o precisa ter a quantidade m\xednima de 13 d\xedgitos";
    var cardMaxLengthMessage = "O n\xfamero do cart\xe3o precisa ter a quantidade m\xe1xima de 16 d\xedgitos";
    var sameCardNumberMessage = "Os n\xfameros dos cart\xf5es s\xe3o iguais";
    if (cardNumber === secondCardNumber) return sameCardNumberMessage;
    var formattedFirstCardNumber = cardNumber.replace(/[\s_]/g, "");
    if (formattedFirstCardNumber.length && formattedFirstCardNumber.length < 13) return cardMinLengthMessage;
    if (formattedFirstCardNumber.length > 16) return cardMaxLengthMessage;
    return "";
};
var validateSecurityCode = function(securityCode) {
    var invalid = "CVV inv\xe1lido";
    if (!securityCode || typeof securityCode !== "string") return invalid;
    return securityCode.length < 3 || securityCode.length > 4 ? invalid : "";
};
var validateCreditCardDueDate = function(dueDate) {
    var ref;
    var invalidDate = "Data inv\xe1lida";
    var invalidYear = "Ano inv\xe1lido";
    var invalidMonth = "M\xeas inv\xe1lido";
    var invalidExpiration = "Vencimento inv\xe1lido";
    if (typeof dueDate !== "string") {
        return invalidDate;
    }
    if (!((ref = dueDate === null || dueDate === void 0 ? void 0 : dueDate.replace(/[^0-9]/g, "")) === null || ref === void 0 ? void 0 : ref.length)) {
        return "";
    }
    var ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((ref1 = dueDate === null || dueDate === void 0 ? void 0 : dueDate.match(/\d+/g)) !== null && ref1 !== void 0 ? ref1 : [
        null,
        null
    ], 2), month = ref2[0], originalYear = ref2[1];
    var year = "20".concat(originalYear);
    if (!month && !originalYear) {
        return "";
    }
    var currentDate = new Date();
    if (!month || !originalYear) {
        return invalidDate;
    }
    if (Number(month) < 1 || Number(month) > 12) {
        return invalidMonth;
    }
    if (Number(year) < currentDate.getFullYear()) {
        return invalidYear;
    }
    if (Number(year) === currentDate.getFullYear() && Number(month) < currentDate.getMonth() + 1) {
        return invalidExpiration;
    }
    return "";
};
var handleCreditCardNumberMask = function(creditCardBrand) {
    var defaultMask = "9999 9999 9999 9999";
    if (typeof creditCardBrand !== "string" && creditCardBrand !== null) return defaultMask;
    return creditCardBrand ? creditCardBrand === "Amex" ? "9999 999999 99999" : creditCardBrand === "Diners" ? "9999 999999 9999" : defaultMask : defaultMask;
};
var handleCreditCardCvvMask = function(creditCardBrand) {
    var defaultMask = "999";
    if (typeof creditCardBrand !== "string" && creditCardBrand !== null) return defaultMask;
    if (!(creditCardBrand === "Visa" || creditCardBrand === "Mastercard" || creditCardBrand === "Diners" || creditCardBrand === "Amex" || creditCardBrand === "Hiper" || creditCardBrand === "Hipercard" || creditCardBrand === "Elo" || creditCardBrand === "Jcb" || !creditCardBrand)) return defaultMask;
    return creditCardBrand ? creditCardBrand === "Amex" ? "9999" : defaultMask : defaultMask;
};
var handleCreditCardCvvPlaceholder = function(creditCardBrand) {
    var defaultMask = "000";
    if (typeof creditCardBrand !== "string" && creditCardBrand !== null) return defaultMask;
    if (!(creditCardBrand === "Visa" || creditCardBrand === "Mastercard" || creditCardBrand === "Diners" || creditCardBrand === "Amex" || creditCardBrand === "Hiper" || creditCardBrand === "Hipercard" || creditCardBrand === "Elo" || creditCardBrand === "Jcb" || !creditCardBrand)) return defaultMask;
    return creditCardBrand ? creditCardBrand === "Amex" ? "0000" : defaultMask : defaultMask;
};
var validateCreditCardCVV = function(cvv, creditCardBrand) {
    var invalid = "CVV inv\xe1lido";
    var invalidAmexCVV = "CVV inv\xe1lido para cart\xf5es Amex";
    var invalidCvvLength = "CVV precisa ter 3 ou 4 d\xedgitos";
    if (!cvv || typeof cvv !== "string") return invalid;
    if (creditCardBrand === "Amex" && cvv.length !== 4) {
        return invalidAmexCVV;
    }
    if (cvv.length < 3 || cvv.length > 4) return invalidCvvLength;
    return "";
};

;// CONCATENATED MODULE: ../../packages/application/utils/validations/cpf/index.ts
var validateCpf = function(cpf) {
    var isRequired = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var cpfRequiredMessage = "O campo cpf \xe9 obrigat\xf3rio";
    var cpfInvalidMessage = "CPF inv\xe1lido";
    if (!isRequired && !cpf) return "";
    if (!cpf) return cpfRequiredMessage;
    if ((cpf === null || cpf === void 0 ? void 0 : cpf.length) !== 11 || cpf === "00000000000" || cpf === "11111111111" || cpf === "22222222222" || cpf === "33333333333" || cpf === "44444444444" || cpf === "55555555555" || cpf === "66666666666" || cpf === "77777777777" || cpf === "88888888888" || cpf === "99999999999") return cpfInvalidMessage;
    var sum = 0;
    var rest = 0;
    for(var i = 0; i < 9; i += 1)sum += parseInt(cpf === null || cpf === void 0 ? void 0 : cpf.charAt(i), 10) * (10 - i);
    rest = 11 - sum % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(cpf === null || cpf === void 0 ? void 0 : cpf.charAt(9), 10)) return cpfInvalidMessage;
    sum = 0;
    for(var i1 = 0; i1 < 10; i1 += 1)sum += parseInt(cpf === null || cpf === void 0 ? void 0 : cpf.charAt(i1), 10) * (11 - i1);
    rest = 11 - sum % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(cpf === null || cpf === void 0 ? void 0 : cpf.charAt(10), 10)) return cpfInvalidMessage;
    return "";
};

;// CONCATENATED MODULE: ../../packages/application/utils/validations/email/index.ts
var validEmailRegex = // eslint-disable-next-line security/detect-unsafe-regex, no-useless-escape
RegExp('^(([^<>()[\\]~^?\xb0`\xb4\xaa\xba\'/!%\\\\@#$\xa8&*\xa3\xa2\xac\xb9\xb2\xb3"=\xa7\xe1\xe9\xed\xf3\xfa\xe0\xe8\xec\xf2\xf9\xe2\xea\xee\xf4\xfb\xe3\xf5\xe4\xeb\xef\xf6\xfc\xe7\xa1\xbf\xe3\xf5|,;:\\s@"]+(\\.[^<>()[\\]\\.,;:\\s@\\._~^?\xb0`\xb4\xaa\xba\'/!@#$\xa8&*\xa3\xa2\xac\xb9\xb2\xb3%"+=\xa7\xe1\xe9\xed\xf3\xfa\xe0\xe8\xec\xf2\xf9\xe2\xea\xee\xf4\xfb\xe3\xf5\xe4\xeb\xef\xf6\xfc\xe7\xa1\xbf\xe3\xf5\\\\|"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+(?<![-])\\.)*(?!-)[^<>()[\\]\\.,;:\\s@\\"]{1}([^-][^<>()[\\]\\.,;:\\s@\\"]+)*(?<!-)\\.[^<>()[\\]\\.,;:\\s@\\"]{2,})$', "i");
var validCpfRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
var validateEmail = function(email, currentEmail) {
    var isRequired = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var emailValidated = email !== null && email !== void 0 ? email : "";
    var blank = "";
    var emailStatus = {
        emailIsRequired: "O campo e-mail \xe9 obrigat\xf3rio!",
        emailIsInvalid: "E-mail n\xe3o \xe9 v\xe1lido",
        emailIsTheSame: "O E-mail precisa ser diferente do atual cadastrado"
    };
    if (isRequired && !email) {
        return emailStatus.emailIsRequired;
    }
    if (isRequired && !(email === null || email === void 0 ? void 0 : email.match(validEmailRegex))) {
        return emailStatus.emailIsInvalid;
    }
    if (!isRequired && (emailValidated === null || emailValidated === void 0 ? void 0 : emailValidated.length) > 0 && !(email === null || email === void 0 ? void 0 : email.match(validEmailRegex))) {
        return emailStatus.emailIsInvalid;
    }
    if (email === currentEmail) {
        return emailStatus.emailIsTheSame;
    }
    return blank;
};
var handleEmailValidation = function(email) {
    var textError = email ? validateEmail(email, undefined, false) : "";
    var hasError = email && email.length === 0 ? false : !!textError;
    var hasSuccessfully = email && email.length > 0 && !validateEmail(email);
    return {
        textError: textError,
        hasError: hasError,
        hasSuccessfully: hasSuccessfully
    };
};
var validateEmailFormWeddingList = function(email) {
    var isValidEmail = validateEmail(email, undefined, false);
    return isValidEmail === "";
};

;// CONCATENATED MODULE: ../../packages/application/utils/validations/name/index.ts
var validateName = function(name) {
    var isRequired = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var nameRequired = "O campo nome \xe9 obrigat\xf3rio!";
    var nameShouldHaveSurname = "O campo nome precisa ter um sobrenome";
    var nameContainsNumbers = "O campo nome n\xe3o permite n\xfameros!";
    var nameShouldHaveMaxLengthTwentySix = "O campo deve ter o m\xe1ximo de 50 caracteres";
    var blank = " ";
    if (!isRequired && !name) return "";
    if (!name || typeof name !== "string") return nameRequired;
    if (name.length < 1 && name !== undefined) return nameShouldHaveSurname;
    if (name.length > 50) return nameShouldHaveMaxLengthTwentySix;
    if (name.match(/\d/)) return nameContainsNumbers;
    var removedSpaceBlankFromName = name.trim();
    var fullName = removedSpaceBlankFromName.split(blank);
    if ((fullName === null || fullName === void 0 ? void 0 : fullName.length) < 2) return nameShouldHaveSurname;
    return "";
};
var validateFirstName = function(name) {
    var mandatory = "O campo \xe9 obrigat\xf3rio!";
    var cantNumber = "O campo n\xe3o permite n\xfameros!";
    var cantSpecialChars = "O campo n\xe3o permite caracteres especiais!";
    var valid = "";
    var mustBeAtLeastThreeCharacters = "\xc9 necess\xe1rio ter no m\xednimo tr\xeas caracteres";
    if (!name || typeof name !== "string") return mandatory;
    if (name.match(/\d/)) return cantNumber;
    if (!name.match(/^[a-zA-ZÀ-ÿç\s]*$/)) return cantSpecialChars;
    if (name.length < 3) return mustBeAtLeastThreeCharacters;
    return valid;
};
var handleNameValidation = function(name) {
    var textError = name ? validateFirstName(name) : "";
    var hasError = !name ? false : !name.match(/^\D{20,}$/);
    var hasSuccessfully = /^[a-zA-ZÀ-ÿ\s]{3,}$/.test(name !== null && name !== void 0 ? name : "");
    return {
        textError: textError,
        hasError: hasError,
        hasSuccessfully: hasSuccessfully
    };
};
var validateWeddingList = function(value) {
    var isNameValid = validateFirstName(value);
    return !!(isNameValid === "");
};
var validateNameFormWeddingList = function(value) {
    var invalidateName = /[0-9]|@|#|&|\$|!|\*|\[|\]|\{|\}|\/|\||\\|%|\(|\)|\+|-|_|\.|"/g;
    if (value === null || value === void 0 ? void 0 : value.match(invalidateName)) {
        return "";
    }
    return value;
};

;// CONCATENATED MODULE: ../../packages/application/utils/validations/password/index.ts
var validatePassword = function(password) {
    var passwordStrengthTextError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "A sua senha deve conter pelo menos 8 caracteres";
    var passwordIsRequired = "O campo senha \xe9 obrigat\xf3rio!";
    var invalidPassword = "Senha inv\xe1lida!";
    var passwordShouldContainEightCharacters = passwordStrengthTextError;
    var mustContainNumber = "A senha deve conter pelo menos um n\xfamero!";
    var mustContainUppercase = "A senha deve conter pelo menos uma letra mai\xfascula!";
    var mustContainLowercase = "A senha deve conter pelo menos uma letra min\xfascula!";
    var blank = "";
    if (typeof password !== "string") return invalidPassword;
    if (!password) return passwordIsRequired;
    if ((password === null || password === void 0 ? void 0 : password.length) < 8) return passwordShouldContainEightCharacters;
    if (!/\d/.test(password)) return mustContainNumber;
    if (!/[A-Z]/.test(password)) return mustContainUppercase;
    if (!/[a-z]/.test(password)) return mustContainLowercase;
    return blank;
};
var validateConfirmPassword = function(password, confirmPassword) {
    var passwordStrengthTextError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Senha incorreta, tente novamente!";
    var passwordShouldMatch = passwordStrengthTextError;
    var blank = "";
    if ((password === null || password === void 0 ? void 0 : password.length) > 0 && confirmPassword && password !== confirmPassword || (password === null || password === void 0 ? void 0 : password.length) === 0 && (confirmPassword === null || confirmPassword === void 0 ? void 0 : confirmPassword.length) > 0) return passwordShouldMatch;
    return blank;
};

;// CONCATENATED MODULE: ../../packages/application/utils/validations/phoneNumber/index.ts
var isInvalidAreaCode = function(phoneNumberAreaCode) {
    return !(phoneNumberAreaCode === null || phoneNumberAreaCode === void 0 ? void 0 : phoneNumberAreaCode.match(/(1[1-9])|([2-9][0-9])/));
};
var isRepeatingSameNumberManyTimes = function(phoneNumber) {
    return /(1{8})|(2{8})|(3{8})|(4{8})|(5{8})|(6{8})|(7{8})|(8{8})|(9{8})/.test(phoneNumber);
};
var isNonexistentPhoneNumber = function(phoneNumber) {
    return [
        1,
        2,
        3,
        4
    ].indexOf(Number(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber[3])) > -1;
};
var formatPhoneNumber = function(phoneNumber) {
    return phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/\D/g, "");
};
var validatePhoneNumber = function(phoneNumber, currentPhoneNumber) {
    var blank = "";
    var phoneNumberStatus = {
        phoneNumberIsRequired: "O campo celular \xe9 obrigat\xf3rio!",
        phoneNumberIsRequiredElevenDigits: "O telefone precisa ter 11 d\xedgitos (xx) x xxxx-xxxx",
        phoneNumberIsInvalid: "O telefone \xe9 inv\xe1lido!",
        phoneNumberIsTheSame: "O telefone precisa ser diferente do atual cadastrado"
    };
    if (!phoneNumber) return phoneNumberStatus.phoneNumberIsRequired;
    if (typeof phoneNumber !== "string") return phoneNumberStatus.phoneNumberIsInvalid;
    var formattedPhoneNumber = formatPhoneNumber(phoneNumber);
    if (formattedPhoneNumber.length !== 11) {
        return phoneNumberStatus.phoneNumberIsRequiredElevenDigits;
    }
    var phoneNumberIncludesLetters = formattedPhoneNumber === null || formattedPhoneNumber === void 0 ? void 0 : formattedPhoneNumber.match(/[a-zA-Z]/);
    var isPhoneNumberInvalid = !(formattedPhoneNumber === null || formattedPhoneNumber === void 0 ? void 0 : formattedPhoneNumber.match(/\(\d{2}\)\s\d{5}-\d{4}/)) && !(formattedPhoneNumber === null || formattedPhoneNumber === void 0 ? void 0 : formattedPhoneNumber.match(/\d{11}/)) || isInvalidAreaCode(formattedPhoneNumber === null || formattedPhoneNumber === void 0 ? void 0 : formattedPhoneNumber.substring(0, 2)) || isRepeatingSameNumberManyTimes(formattedPhoneNumber) || isNonexistentPhoneNumber(formattedPhoneNumber) || phoneNumberIncludesLetters;
    if (isPhoneNumberInvalid) {
        return phoneNumberStatus.phoneNumberIsInvalid;
    }
    if (phoneNumber.replace(/\D/g, "") === currentPhoneNumber) {
        return phoneNumberStatus.phoneNumberIsTheSame;
    }
    return blank;
};

;// CONCATENATED MODULE: ../../packages/application/utils/validations/index.ts











/***/ }),

/***/ 73105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getMinutesAndSeconds; }
/* harmony export */ });
var getMinutesAndSeconds = function(dateString) {
    if (!dateString) {
        return 120;
    }
    var date = new Date(dateString);
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var currentDate = new Date();
    var currentMinutes = currentDate.getMinutes();
    var currentSeconds = currentDate.getSeconds();
    var providedTotalSeconds = minutes * 60 + seconds;
    var currentTotalSeconds = currentMinutes * 60 + currentSeconds;
    return providedTotalSeconds - currentTotalSeconds;
};


/***/ }),

/***/ 60985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TwoFactorButton": function() { return /* binding */ TwoFactorButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(430);
/* harmony import */ var application_state_manager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74224);
/* harmony import */ var application_state_manager_adapter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80759);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26365);
/* harmony import */ var _Register_Form_Body_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59899);










var TwoFactorButton = function(param) {
    var title = param.title, isDisabled = param.isDisabled, handleOnClick = param.handleOnClick;
    var isClientMobile = (0,application__WEBPACK_IMPORTED_MODULE_1__/* .useAppContext */ .bp4)().isClientMobile;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,application_state_manager__WEBPACK_IMPORTED_MODULE_2__/* .useTwoFactor */ .kD)((0,application_state_manager_adapter__WEBPACK_IMPORTED_MODULE_7__/* .useShallow */ .N)(function(state) {
        return {
            isUnderAction: state.isUnderAction,
            setIsValidationActive: state.setIsValidationActive
        };
    })), isUnderAction = ref.isUnderAction, setIsValidationActive = ref.setIsValidationActive;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (isClientMobile && router.pathname !== "/") {
            setIsValidationActive(false);
        }
    }, [
        router.pathname,
        isClientMobile,
        setIsValidationActive
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Register_Form_Body_styles__WEBPACK_IMPORTED_MODULE_6__/* .SignUpFormButton */ .EH, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("two-factor-button")), {
        text: title,
        buttonType: "submit",
        preventDefault: true,
        onClickAction: handleOnClick,
        isDisabled: !!(isDisabled || isUnderAction),
        fontWeight: ui__WEBPACK_IMPORTED_MODULE_5__.theme.typography.fontWeight[400],
        color: "".concat(ui__WEBPACK_IMPORTED_MODULE_5__.theme.colors.secondary[380]),
        hoveredColor: "".concat(ui__WEBPACK_IMPORTED_MODULE_5__.theme.colors.secondary[350])
    }));
};



/***/ }),

/***/ 53886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ maskPhoneNumber; },
/* harmony export */   "o": function() { return /* binding */ maskEmail; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77149);


var maskEmail = function(email) {
    if (!email) {
        return "";
    }
    var atIndex = email === null || email === void 0 ? void 0 : email.indexOf("@");
    if (atIndex !== -1) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(email === null || email === void 0 ? void 0 : email.split("@"), 2), username = ref[0], domain = ref[1];
        var ref1 = (0,_swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(domain === null || domain === void 0 ? void 0 : domain.split(".")), domainName = ref1[0], extensions = ref1.slice(1);
        var hiddenUsername = username.substring(0, 2) + "*".repeat((username === null || username === void 0 ? void 0 : username.length) - 4) + username.slice(-1);
        var visibleDomain = "".concat(domainName[0]).concat("*".repeat(domainName.length - 2)).concat(domainName.slice(-1), ".").concat(extensions.join("."));
        return "".concat(hiddenUsername, "@").concat(visibleDomain);
    }
    return email;
};
var maskPhoneNumber = function(phoneNumber) {
    var trimmedPhoneNumber = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.trim();
    var prefix = "(".concat(trimmedPhoneNumber === null || trimmedPhoneNumber === void 0 ? void 0 : trimmedPhoneNumber.substring(0, 2), ")");
    var suffix = "*****-**".concat(trimmedPhoneNumber === null || trimmedPhoneNumber === void 0 ? void 0 : trimmedPhoneNumber.substring(9));
    return "".concat(prefix, " ").concat(suffix);
};



/***/ }),

/***/ 83650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TwoFactorButton": function() { return /* reexport */ Button.TwoFactorButton; },
  "TwoFactorContent": function() { return /* reexport */ TwoFactorContent; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../packages/application/state-manager/adapter.ts
var adapter = __webpack_require__(80759);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/components/ModalGeneral/index.tsx + 1 modules
var ModalGeneral = __webpack_require__(89459);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../packages/components/InputCodeValidation/index.tsx + 3 modules
var InputCodeValidation = __webpack_require__(4247);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
;// CONCATENATED MODULE: ../../packages/components/2fa/PasteCode/data.tsx




var usePasteText = function() {
    var ref = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            clipboardText: state.clipboardText,
            setClipboardText: state.setClipboardText
        };
    })), clipboardText = ref.clipboardText, setClipboardText = ref.setClipboardText;
    var handlePasteText = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var text, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            navigator.clipboard.readText()
                        ];
                    case 1:
                        text = _state.sent();
                        setClipboardText(text);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        implementations/* appMonitoringClient.captureException */.pE.captureException(err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePasteText() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        clipboardText: clipboardText,
        handlePasteText: handlePasteText
    };
};


// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/2fa/PasteCode/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  width: 16px;\n  height: 16px;\n\n  svg {\n    path {\n      stroke: ",
        " !important;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-size: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var PasteCodeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PasteCodeContainer",
    componentId: "sc-e8c1fc3-0"
})(_templateObject(), ui.theme.colors.neutral[110], ui.theme.space.x1);
var PasteCodeIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PasteCodeIcon",
    componentId: "sc-e8c1fc3-1"
})(_templateObject1(), ui.theme.colors.neutral[110], ui.theme.colors.neutral[110]);
var ClipboardText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ClipboardText",
    componentId: "sc-e8c1fc3-2"
})(_templateObject2(), ui.theme.colors.neutral[110], ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontFamily.chivo);

;// CONCATENATED MODULE: ../../packages/components/2fa/PasteCode/ui.tsx






var PasteCodeUI = function(param) {
    var handlePaste = param.handlePaste;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PasteCodeContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClick: handlePaste
    }, (0,application/* buildTestIds */.Fek)("paste-code-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasteCodeIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("paste-code-icon")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.PasteIcon, {
                    width: 16,
                    height: 16
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipboardText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("paste-code-text")), {
                children: "Colar c\xf3digo"
            }))
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/2fa/PasteCode/index.tsx



var PasteCode = function() {
    var handlePasteText = usePasteText().handlePasteText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PasteCodeUI, {
        handlePaste: handlePasteText
    });
};


// EXTERNAL MODULE: ../../packages/components/ButtonSubmit/index.tsx
var ButtonSubmit = __webpack_require__(42942);
;// CONCATENATED MODULE: ../../packages/components/2fa/Content/View/Body/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1.33rem;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  font-size: 1.16667rem;\n  font-weight: ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  display: flex;\n  justify-content: center;\n  cursor: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: ",
        " !important;\n  justify-content: center;\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  white-space: wrap;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-self: center;\n  color: ",
        " !important;\n  font-size: ",
        ";\n  text-decoration: underline;\n  cursor: pointer;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var TwoFactorContentBodyContainer = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "styles__TwoFactorContentBodyContainer",
    componentId: "sc-153190e3-0"
})(styles_templateObject());
var CodeInfosContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CodeInfosContainer",
    componentId: "sc-153190e3-1"
})(styles_templateObject1(), ui.theme.typography.fontWeight[400]);
var ResendCode = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ResendCode",
    componentId: "sc-153190e3-2"
})(styles_templateObject2(), function(activeTimer) {
    return activeTimer.activeTimer ? ui.theme.colors.neutral[110] : ui.theme.colors.primary[350];
}, function(activeTimer) {
    return activeTimer.activeTimer ? "default" : "pointer";
});
var styles_PasteCode = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PasteCode",
    componentId: "sc-153190e3-3"
})(_templateObject3(), ui.theme.colors.neutral[110]);
var VerificationCodeInfo = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__VerificationCodeInfo",
    componentId: "sc-153190e3-4"
})(_templateObject4(), ui.theme.colors.neutral[330], ui.theme.space.x3, ui.theme.typography.fontWeight[400]);
var SelectAnotherTwoFactorType = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__SelectAnotherTwoFactorType",
    componentId: "sc-153190e3-5"
})(_templateObject5(), ui.theme.colors.neutral[330], ui.theme.space["x3.5"]);
var TwoFactorContentBodyButtonSubmit = (0,styled_components_browser_esm/* default */.ZP)(ButtonSubmit/* ButtonSubmit */.G).attrs(function(param) {
    var height = param.height, borderRadius = param.borderRadius;
    return {
        fontSize: ui.theme.typography.fontSize.sm.x7,
        height: height !== null && height !== void 0 ? height : ui.theme.space["x11.5"],
        borderRadius: borderRadius !== null && borderRadius !== void 0 ? borderRadius : ui.theme.space.x1,
        fontWeight: ui.theme.typography.fontWeight[400],
        fontFamily: ui.theme.typography.fontFamily.chivo,
        width: "100%"
    };
}).withConfig({
    displayName: "styles__TwoFactorContentBodyButtonSubmit",
    componentId: "sc-153190e3-6"
})(_templateObject6());

;// CONCATENATED MODULE: ../../packages/components/2fa/Content/View/Body/Button/index.tsx







var TwoFactorContentBodyButton = function(param) {
    var height = param.height, borderRadius = param.borderRadius, handleFinishTwoFactorAction = param.handleFinishTwoFactorAction, preventDefault = param.preventDefault;
    var ref = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            isCodeComplete: state.isCodeComplete,
            isUnderAction: state.isUnderAction
        };
    })), isCodeComplete = ref.isCodeComplete, isUnderAction = ref.isUnderAction;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorContentBodyButtonSubmit, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-content-body-button")), {
        text: "Continuar",
        height: height,
        borderRadius: borderRadius,
        buttonType: "submit",
        preventDefault: preventDefault,
        textUnderAction: "Aguarde...",
        underAction: isUnderAction,
        onClickAction: handleFinishTwoFactorAction,
        isDisabled: !isCodeComplete || isUnderAction,
        fontWeight: ui.theme.typography.fontWeight[400],
        color: "".concat(ui.theme.colors.secondary[380]),
        hoveredColor: "".concat(ui.theme.colors.secondary[350])
    }));
};


;// CONCATENATED MODULE: ../../packages/components/2fa/Content/View/Body/Counter/styles.ts

function Counter_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  display: flex;\n  justify-content: center;\n  cursor: ",
        ";\n"
    ]);
    Counter_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var styles_ResendCode = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ResendCode",
    componentId: "sc-6d8c9fde-0"
})(Counter_styles_templateObject(), function(activeTimer) {
    return activeTimer.activeTimer ? ui.theme.colors.neutral[110] : ui.theme.colors.primary[350];
}, function(activeTimer) {
    return activeTimer.activeTimer ? "default" : "pointer";
});

;// CONCATENATED MODULE: ../../packages/components/2fa/Content/View/Body/Counter/index.tsx








var Counter = function(param) {
    var faType = param.faType, sendCodeType = param.sendCodeType, channel = param.channel;
    var ref;
    var loggedClient = (0,application/* useUser */.aFb)().loggedClient;
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var ref1 = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            email: state.email,
            phoneNumber: state.phoneNumber,
            sendCode: state.sendCode
        };
    })), email = ref1.email, phoneNumber = ref1.phoneNumber, sendCode = ref1.sendCode;
    var ref2 = (0,state_manager/* useCounter */.Cf)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            initTimer: state.initTimer,
            setInitTimer: state.setInitTimer
        };
    })), initTimer = ref2.initTimer, setInitTimer = ref2.setInitTimer;
    var ref3 = (0,react.useState)(function() {
        var storedCountdownTime = localStorage.getItem("countdownTime_".concat(faType, "_").concat(channel));
        var storedTimestamp = localStorage.getItem("countdownTimeTimestamp_".concat(faType, "_").concat(channel));
        if (storedCountdownTime && storedTimestamp) {
            var elapsedTime = Math.floor((Date.now() - parseInt(storedTimestamp, 10)) / 1000);
            var remainingTime = parseInt(storedCountdownTime, 10) - elapsedTime;
            if (remainingTime > 0) {
                return remainingTime;
            }
        }
        return 0;
    }), countdownTime = ref3[0], setCountdownTime = ref3[1];
    var formatTime = function(seconds) {
        var minutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;
        return "".concat(minutes, ":").concat(remainingSeconds < 10 ? "0" : "").concat(remainingSeconds);
    };
    var getInfoValue = (0,react.useCallback)(function(passedSendCodeType, passedEmail, passedPhoneNumber) {
        if (passedSendCodeType === "email") {
            return passedEmail === null || passedEmail === void 0 ? void 0 : passedEmail.replace(/@/g, "%40");
        }
        return passedPhoneNumber;
    }, []);
    var handleResendCode = (0,react.useCallback)(function(param) {
        var passedSendCodeType = param.sendCodeType, passedNotificationApi = param.notificationApi, passedAddToast = param.addToast, infoValue = param.infoValue, errorTitle = param.errorTitle;
        if (countdownTime === 0) {
            setInitTimer(true);
            sendCode({
                faType: faType,
                sendCodeType: passedSendCodeType,
                notificationApi: passedNotificationApi,
                addToast: passedAddToast,
                infoValue: infoValue,
                errorTitle: errorTitle,
                email: email,
                cpf: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf,
                phoneNumber: phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/\D/g, ""),
                token: accessToken
            });
        }
    }, [
        countdownTime,
        setInitTimer,
        sendCode,
        faType,
        email,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf,
        phoneNumber,
        accessToken, 
    ]);
    (0,react.useEffect)(function() {
        if (!initTimer && countdownTime === 0 && faType && channel) {
            setInitTimer(true);
            localStorage.setItem("timeSent_".concat(faType, "_").concat(channel), Date.now().toString());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (faType && channel) {
            localStorage.setItem("countdownTime_".concat(faType, "_").concat(channel), countdownTime.toString());
            localStorage.setItem("countdownTimeTimestamp_".concat(faType, "_").concat(channel), Date.now().toString());
        }
    }, [
        countdownTime,
        faType,
        channel
    ]);
    (0,react.useEffect)(function() {
        if (countdownTime > 0) {
            var intervalId = setInterval(function() {
                setCountdownTime(function(current) {
                    return current - 1;
                });
            }, 1000);
            return function() {
                return clearInterval(intervalId);
            };
        }
        if (initTimer && countdownTime === 0 && faType && channel) {
            setCountdownTime(120);
            setInitTimer(false);
            localStorage.setItem("timeSent_".concat(faType, "_").concat(channel), (Date.now() / 1000 + 120).toString());
        }
        return undefined;
    }, [
        channel,
        countdownTime,
        faType,
        initTimer,
        setInitTimer
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ResendCode, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("resend-code")), {
        activeTimer: countdownTime > 0,
        onClick: function() {
            return handleResendCode({
                sendCodeType: sendCodeType,
                notificationApi: implementations/* notificationApi */.E8,
                infoValue: getInfoValue(sendCodeType, email, phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/\D/g, "")),
                addToast: addToast,
                cpf: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf,
                email: email,
                phoneNumber: phoneNumber,
                faType: faType,
                errorTitle: "Erro ao realizar a a\xe7\xe3o"
            });
        },
        children: countdownTime === 0 ? "Reenviar c\xf3digo" : "Reenviar c\xf3digo em ".concat(formatTime(countdownTime))
    }));
};
/* harmony default export */ var Body_Counter = (Counter);

;// CONCATENATED MODULE: ../../packages/components/2fa/Content/View/Body/index.tsx













var TwoFactorContentBody = function(param) {
    var isClientMobileS = param.isClientMobileS, sendCodeType = param.sendCodeType, buttonBorderRadius = param.buttonBorderRadius, buttonHeight = param.buttonHeight, preventDefault = param.preventDefault, handleFinishTwoFactorAction = param.handleFinishTwoFactorAction, handleSelectAnotherTwoFactorType = param.handleSelectAnotherTwoFactorType, _showButton = param.showButton, showButton = _showButton === void 0 ? true : _showButton;
    var ref;
    var ref1 = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            email: state.email,
            phoneNumber: state.phoneNumber,
            canChooseAnotherTwoFactorMethod: state.canChooseAnotherTwoFactorMethod,
            isCodeTimerActive: state.isCodeTimerActive,
            setCodeTimerActive: state.setCodeTimerActive,
            setIsSendCodeAvailable: state.setIsSendCodeAvailable,
            sendCode: state.sendCode,
            isEmailDifferent: state.isEmailDifferent,
            setIsEmailDifferent: state.setIsEmailDifferent,
            setInitTimer: state.setInitTimer,
            initTimer: state.initTimer,
            faType: state.faType,
            setHasAuthenticationMethodChanged: state.setHasAuthenticationMethodChanged,
            hasAuthenticationMethodChanged: state.hasAuthenticationMethodChanged
        };
    })), email = ref1.email, phoneNumber = ref1.phoneNumber, canChooseAnotherTwoFactorMethod = ref1.canChooseAnotherTwoFactorMethod, sendCode = ref1.sendCode, isCodeTimerActive = ref1.isCodeTimerActive, setCodeTimerActive = ref1.setCodeTimerActive, setIsSendCodeAvailable = ref1.setIsSendCodeAvailable, isEmailDifferent = ref1.isEmailDifferent, setIsEmailDifferent = ref1.setIsEmailDifferent, setInitTimer = ref1.setInitTimer, initTimer = ref1.initTimer, faType = ref1.faType, setHasAuthenticationMethodChanged = ref1.setHasAuthenticationMethodChanged, hasAuthenticationMethodChanged = ref1.hasAuthenticationMethodChanged;
    var maxTimeValue = 120;
    var ref2 = (0,react.useState)(function() {
        var storedCountdownTime = localStorage.getItem("countdownTime");
        var storedTimestamp = localStorage.getItem("countdownTimeTimestamp");
        if (storedCountdownTime && storedTimestamp) {
            var elapsedTime = Math.floor((Date.now() - parseInt(storedTimestamp, 10)) / 1000);
            var remainingTime = parseInt(storedCountdownTime, 10) - elapsedTime;
            if (remainingTime > 0) {
                return remainingTime;
            }
        }
        return 0;
    }), countdownTime = ref2[0], setCountdownTime = ref2[1];
    var addToast = (0,application/* useToast */.pmc)().addToast;
    (0,react.useEffect)(function() {
        localStorage.setItem("countdownTime", countdownTime.toString());
        localStorage.setItem("countdownTimeTimestamp", Date.now().toString());
    }, [
        countdownTime
    ]);
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var loggedClient = (0,application/* useUser */.aFb)().loggedClient;
    (0,react.useEffect)(function() {
        if (isCodeTimerActive && !initTimer && countdownTime === 0) {
            setInitTimer(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (countdownTime > 0 && !isEmailDifferent && !hasAuthenticationMethodChanged) {
            setCodeTimerActive(true);
            var intervalId = setInterval(function() {
                setCountdownTime(function(current) {
                    return current - 1;
                });
            }, 1000);
            setIsSendCodeAvailable(false);
            return function() {
                return clearInterval(intervalId);
            };
        }
        if (initTimer && countdownTime === 0 || isEmailDifferent || hasAuthenticationMethodChanged) {
            setCountdownTime(maxTimeValue);
            setInitTimer(false);
            setIsEmailDifferent(false);
            setHasAuthenticationMethodChanged(false);
        }
        if (countdownTime === 0) {
            setIsSendCodeAvailable(true);
            setCodeTimerActive(false);
        }
        return undefined;
    }, [
        countdownTime,
        hasAuthenticationMethodChanged,
        initTimer,
        isEmailDifferent,
        setCodeTimerActive,
        setHasAuthenticationMethodChanged,
        setInitTimer,
        setIsEmailDifferent,
        setIsSendCodeAvailable, 
    ]);
    var handleResendCode = (0,react.useCallback)(function(param) {
        var passedSendCodeType = param.sendCodeType, passedNotificationApi = param.notificationApi, passedAddToast = param.addToast, infoValue = param.infoValue, errorTitle = param.errorTitle;
        if (countdownTime === 0) {
            setInitTimer(true);
            sendCode({
                faType: faType !== null && faType !== void 0 ? faType : 5,
                sendCodeType: passedSendCodeType,
                notificationApi: passedNotificationApi,
                addToast: passedAddToast,
                infoValue: infoValue,
                errorTitle: errorTitle,
                email: email,
                cpf: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf,
                phoneNumber: phoneNumber.replace(/\D/g, ""),
                token: accessToken
            });
            setCodeTimerActive(false);
        }
    }, [
        countdownTime,
        faType,
        sendCode,
        setCodeTimerActive,
        setInitTimer,
        email,
        loggedClient,
        phoneNumber,
        accessToken, 
    ]);
    var formatTime = function(seconds) {
        var minutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;
        return "".concat(minutes, ":").concat(remainingSeconds < 10 ? "0" : "").concat(remainingSeconds);
    };
    var getInfoValue = (0,react.useCallback)(function(passedSendCodeType, passedEmail, passedPhoneNumber) {
        if (passedSendCodeType === "email") {
            return passedEmail === null || passedEmail === void 0 ? void 0 : passedEmail.replace(/@/g, "%40");
        }
        return passedPhoneNumber;
    }, []);
    var pathname = (0,next_router.useRouter)().pathname;
    var isAccountCreation = pathname === null || pathname === void 0 ? void 0 : pathname.includes("/cadastro");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TwoFactorContentBodyContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-content-body-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCodeValidation/* InputBoxValidation */.q, {
                numberType: 2,
                width: isClientMobileS ? "39px" : "47px",
                height: "64px",
                flexDirection: "column",
                typeItem: "SendEmailCode",
                bottomSubtitle: true,
                noTopSubtitle: true
            }),
            sendCodeType !== "app" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CodeInfosContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("code-infos-container")), {
                children: [
                    isAccountCreation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResendCode, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("resend-code")), {
                        activeTimer: countdownTime > 0,
                        onClick: function() {
                            return handleResendCode({
                                sendCodeType: sendCodeType,
                                notificationApi: implementations/* notificationApi */.E8,
                                infoValue: getInfoValue(sendCodeType, email, phoneNumber.replace(/\D/g, "")),
                                addToast: addToast,
                                cpf: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf,
                                email: email,
                                phoneNumber: phoneNumber,
                                faType: faType !== null && faType !== void 0 ? faType : 5,
                                errorTitle: "Erro ao realizar a a\xe7\xe3o"
                            });
                        },
                        children: countdownTime === 0 ? "Reenviar c\xf3digo" : "Reenviar c\xf3digo em ".concat(formatTime(countdownTime))
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Body_Counter, {
                        channel: sendCodeType === "email" ? 2 : 1,
                        faType: faType,
                        sendCodeType: sendCodeType
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PasteCode, {})
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerificationCodeInfo, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("verification-code-info")), {
                children: "O c\xf3digo de verifica\xe7\xe3o expira em 10 minutos e pode ser reenviado at\xe9 5 vezes por dia."
            })),
            canChooseAnotherTwoFactorMethod && handleSelectAnotherTwoFactorType && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectAnotherTwoFactorType, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("select-another-two-factor-type")), {
                onClick: handleSelectAnotherTwoFactorType,
                children: "Use outro m\xe9todo para receber o c\xf3digo"
            })),
            showButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorContentBodyButton, {
                height: buttonHeight,
                borderRadius: buttonBorderRadius,
                handleFinishTwoFactorAction: handleFinishTwoFactorAction,
                preventDefault: preventDefault || false
            })
        ]
    }));
};


// EXTERNAL MODULE: ../../packages/components/2fa/Content/useTwoFactorContent/index.tsx
var useTwoFactorContent = __webpack_require__(53886);
;// CONCATENATED MODULE: ../../packages/components/2fa/Content/View/DescriptionText/styles.ts

function DescriptionText_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-size: 1.16667rem;\n  font-weight: ",
        ";\n  display: inline;\n  margin: ",
        ";\n"
    ]);
    DescriptionText_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DescriptionText_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  white-space: wrap;\n"
    ]);
    DescriptionText_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DescriptionText_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  cursor: pointer;\n  margin-left: ",
        ";\n"
    ]);
    DescriptionText_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-weight: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var DescriptionContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__DescriptionContainer",
    componentId: "sc-d65b8a8a-0"
})(DescriptionText_styles_templateObject(), ui.theme.colors.neutral[525], ui.theme.typography.fontWeight[400], function(param) {
    var marginDescription = param.marginDescription;
    return marginDescription || "0";
});
var ClientInfoContent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ClientInfoContent",
    componentId: "sc-d65b8a8a-1"
})(DescriptionText_styles_templateObject1(), ui.theme.colors.neutral[525]);
var InvalidClientInfo = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__InvalidClientInfo",
    componentId: "sc-d65b8a8a-2"
})(DescriptionText_styles_templateObject2(), ui.theme.colors.primary[350], ui.theme.space.x1);
var InfoValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__InfoValue",
    componentId: "sc-d65b8a8a-3"
})(styles_templateObject3(), ui.theme.colors.neutral[525], ui.theme.typography.fontWeight[700], ui.theme.space.x2);

;// CONCATENATED MODULE: ../../packages/components/2fa/Content/View/DescriptionText/index.tsx









var InfoValueElement = function(param) {
    var value = param.value;
    if (!value) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoValue, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("info-value")), {
        children: [
            value,
            "."
        ]
    }));
};
var TwoFactorDescriptionText = function(param) {
    var sendCodeType = param.sendCodeType, onClickIsInvalidClientInfo = param.onClickIsInvalidClientInfo, marginDescription = param.marginDescription, shouldMask = param.shouldMask;
    var ref = (0,state_manager/* useTwoFactor */.kD)((0,adapter/* useShallow */.N)(function(state) {
        return {
            email: state.email,
            phoneNumber: state.phoneNumber,
            clientAction: state.clientAction,
            resetInfo: state.resetInfo
        };
    })), email = ref.email, phoneNumber = ref.phoneNumber, clientAction = ref.clientAction, resetInfo = ref.resetInfo;
    var handleClickIsInvalidClientInfo = (0,react.useCallback)(function() {
        if (onClickIsInvalidClientInfo) {
            onClickIsInvalidClientInfo(clientAction, sendCodeType);
            resetInfo();
        }
    }, [
        clientAction,
        onClickIsInvalidClientInfo,
        resetInfo,
        sendCodeType
    ]);
    var getSendCodeTypeInfos = (0,react.useCallback)(function(passedSendCodeType, passedEmail, passedPhoneNumber) {
        if (passedSendCodeType === "email") {
            return {
                text: "e-mail",
                auxText: "enviamos um c\xf3digo de 6 d\xedgitos para o e-mail",
                value: shouldMask ? (0,useTwoFactorContent/* maskEmail */.o)(passedEmail) : passedEmail
            };
        }
        if (passedSendCodeType === "sms") {
            return {
                text: "n\xfamero",
                auxText: "enviamos um c\xf3digo de 6 d\xedgitos para o n\xfamero",
                value: shouldMask ? (0,useTwoFactorContent/* maskPhoneNumber */.Y)(passedPhoneNumber) : passedPhoneNumber
            };
        }
        return {
            text: "app autenticador",
            auxText: "Preencha o c\xf3digo informado no seu aplicativo autenticador",
            value: null
        };
    }, [
        shouldMask
    ]);
    // eslint-disable-next-line sonarjs/cognitive-complexity
    var clientActionInfos = (0,react.useMemo)(function() {
        var ref;
        if (!clientAction) {
            return null;
        }
        var ref1 = getSendCodeTypeInfos(sendCodeType, email, phoneNumber), text = ref1.text, auxText = ref1.auxText, value = ref1.value;
        var invalidValueText = sendCodeType !== "app" ? "N\xe3o \xe9 seu ".concat(text, "?") : null;
        if (clientAction === "createUser") {
            var formattedText = sendCodeType !== "app" ? "Para finalizar seu cadastro, ".concat(auxText) : "".concat(auxText);
            return {
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        formattedText,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoValueElement, {
                            value: value
                        })
                    ]
                }),
                invalidValueText: invalidValueText
            };
        }
        if (clientAction === "forgotPassword") {
            var formattedText1 = sendCodeType !== "app" ? "Digite abaixo o c\xf3digo recebido no ".concat(text) : "".concat(auxText);
            return {
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        formattedText1,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoValueElement, {
                            value: value
                        })
                    ]
                }),
                invalidValueText: null
            };
        }
        if (clientAction === "changePassword") {
            var formattedText2 = sendCodeType !== "app" ? "Para garantir a sua seguran\xe7a, enviamos um c\xf3digo de 6 d\xedgitos para o seu ".concat(text) : "".concat(auxText);
            return {
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        formattedText2,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoValueElement, {
                            value: value
                        })
                    ]
                }),
                invalidValueText: null
            };
        }
        if ([
            "validateIdentity",
            "changePhoneNumber",
            "changeEmail",
            "loginValidation", 
        ].includes(clientAction)) {
            var formattedText3 = sendCodeType !== "app" ? "Para garantir a sua seguran\xe7a, ".concat(auxText) : "".concat(auxText);
            return {
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        formattedText3,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoValueElement, {
                            value: value
                        })
                    ]
                }),
                invalidValueText: clientAction === "changePhoneNumber" || clientAction === "changeEmail" || clientAction === "loginValidation" ? null : invalidValueText
            };
        }
        if ((ref = [
            "verifyIdentity",
            "registerPhoneNumber"
        ]) === null || ref === void 0 ? void 0 : ref.includes(clientAction)) {
            var formattedText4 = sendCodeType !== "app" ? "Digite o c\xf3digo enviado para o ".concat(text) : "".concat(auxText);
            return {
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        formattedText4,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoValueElement, {
                            value: value
                        })
                    ]
                }),
                invalidValueText: null
            };
        }
        if (clientAction === "createAddress") {
            var formattedText5 = sendCodeType !== "app" ? "Para adicionar o novo endere\xe7o, ".concat(auxText) : "".concat(auxText);
            return {
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        formattedText5,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoValueElement, {
                            value: value
                        })
                    ]
                }),
                invalidValueText: invalidValueText
            };
        }
        if ([
            "validateIdentity",
            "requestExclusionAccount"
        ].includes(clientAction)) {
            var formattedText6 = sendCodeType !== "app" ? "Para garantir a sua seguran\xe7a, ".concat(auxText) : "".concat(auxText);
            return {
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        formattedText6,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoValueElement, {
                            value: value
                        })
                    ]
                }),
                invalidValueText: null
            };
        }
        return {
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    auxText ? auxText.charAt(0).toUpperCase() + auxText.slice(1) : "",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoValueElement, {
                        value: value
                    })
                ]
            })
        };
    }, [
        clientAction,
        email,
        getSendCodeTypeInfos,
        phoneNumber,
        sendCodeType
    ]);
    if (!clientActionInfos) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DescriptionContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        marginDescription: marginDescription
    }, (0,application/* buildTestIds */.Fek)("two-factor-content-description-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientInfoContent, {
                children: clientActionInfos.content
            }),
            clientActionInfos.invalidValueText && /*#__PURE__*/ (0,jsx_runtime.jsx)(InvalidClientInfo, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("invalid-client-info")), {
                onClick: handleClickIsInvalidClientInfo,
                children: clientActionInfos.invalidValueText
            }))
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/2fa/Content/View/styles.ts

function View_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width: 100%;\n  display: flex;\n  flex-direction: column !important;\n"
    ]);
    View_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function View_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        " !important;\n"
    ]);
    View_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function View_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    View_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function View_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        " !important;\n  margin: ",
        " ",
        ";\n"
    ]);
    View_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: ",
        ";\n  align-items: center;\n  gap: 0.66667rem;\n  color: ",
        ";\n\n  padding-bottom: ",
        ";\n  font-weight: ",
        ";\n  font-size: 1.33333rem;\n\n  @media (max-width: 480px) {\n    justify-content: start;\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 100%;\n  margin-top: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-size: 1.16667rem;\n  font-weight: ",
        ";\n  white-space: wrap;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var TwoFactorViewContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TwoFactorViewContainer",
    componentId: "sc-a85632ca-0"
})(View_styles_templateObject(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
});
var TwoFactorTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__TwoFactorTitle",
    componentId: "sc-a85632ca-1"
})(View_styles_templateObject1(), ui.theme.typography.fontSize.sm.x7, ui.theme.colors.neutral[750]);
var TwoFactorInformation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TwoFactorInformation",
    componentId: "sc-a85632ca-2"
})(View_styles_templateObject2(), ui.theme.space.x2);
var TwoFactorDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__TwoFactorDescription",
    componentId: "sc-a85632ca-3"
})(View_styles_templateObject3(), ui.theme.typography.fontSize.sm.x3, ui.theme.colors.neutral[550], ui.theme.space.x2, ui.theme.space.x0);
var FailureTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FailureTitle",
    componentId: "sc-a85632ca-4"
})(styles_templateObject4(), function(param) {
    var isDefault = param.isDefault;
    return isDefault ? "center" : "start";
}, function(param) {
    var isDefault = param.isDefault;
    return isDefault ? "".concat(ui.theme.colors.primary[150], " !important") : "".concat(ui.theme.colors.neutral[750], " !important");
}, ui.theme.space.x2, ui.theme.typography.fontWeight[600], ui.theme.space.x8);
var FailureButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonSubmit/* ButtonSubmit */.G).attrs({
    fontSize: ui.theme.typography.fontSize.sm.x7,
    height: ui.theme.space["x11.5"],
    fontWeight: ui.theme.typography.fontWeight[400],
    fontFamily: ui.theme.typography.fontFamily.chivo,
    width: "100%"
}).withConfig({
    displayName: "styles__FailureButton",
    componentId: "sc-a85632ca-5"
})(styles_templateObject5(), ui.theme.space.x8);
var FailureText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__FailureText",
    componentId: "sc-a85632ca-6"
})(styles_templateObject6(), ui.theme.colors.neutral[525], ui.theme.typography.fontWeight[400]);
var FailureContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FailureContainer",
    componentId: "sc-a85632ca-7"
})(_templateObject7());

;// CONCATENATED MODULE: ../../packages/components/2fa/Content/View/index.tsx












var ViewTwoFactorContent = /*#__PURE__*/ (0,react.memo)(function(param) {
    var title = param.title, sendCodeType = param.sendCodeType, viewType = param.viewType, onCallAction = param.onCallAction, onClickIsInvalidClientInfo = param.onClickIsInvalidClientInfo, buttonBorderRadius = param.buttonBorderRadius, buttonHeight = param.buttonHeight, marginDescription = param.marginDescription, showButton = param.showButton, shouldMask = param.shouldMask, handleSelectAnotherTwoFactorType = param.handleSelectAnotherTwoFactorType, noTitle = param.noTitle, backgroundColor = param.backgroundColor, onClickOnCloseButton = param.onClickOnCloseButton, _preventDefault = param.preventDefault, preventDefault = _preventDefault === void 0 ? false : _preventDefault;
    var isClientMobileS = (0,application/* useAppContext */.bp4)().isClientMobileS;
    var router = (0,next_router.useRouter)();
    var ref = (0,state_manager/* useTwoFactor */.kD)((0,adapter/* useShallow */.N)(function(state) {
        return {
            isValidationActive: state.isValidationActive,
            setIsValidationActive: state.setIsValidationActive,
            setIsBlockedToSendCode: state.setIsBlockedToSendCode
        };
    })), isValidationActive = ref.isValidationActive, setIsValidationActive = ref.setIsValidationActive, setIsBlockedToSendCode = ref.setIsBlockedToSendCode;
    (0,react.useEffect)(function() {
        var closeValidation = function() {
            setIsValidationActive(false);
            setIsBlockedToSendCode(false);
        };
        router.events.on("routeChangeStart", closeValidation);
        return function() {
            return router.events.off("routeChangeStart", closeValidation);
        };
    }, [
        router,
        setIsBlockedToSendCode,
        setIsValidationActive
    ]);
    if (viewType === "component") {
        return isValidationActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(TwoFactorViewContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            backgroundColor: backgroundColor
        }, (0,application/* buildTestIds */.Fek)("two-factor-view-container")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TwoFactorInformation, {
                    children: [
                        !noTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-title")), {
                            children: title
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorDescriptionText, {
                            sendCodeType: sendCodeType,
                            marginDescription: marginDescription,
                            shouldMask: shouldMask,
                            onClickIsInvalidClientInfo: onClickIsInvalidClientInfo
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorContentBody, {
                    showButton: showButton,
                    buttonBorderRadius: buttonBorderRadius,
                    buttonHeight: buttonHeight,
                    sendCodeType: sendCodeType,
                    isClientMobileS: isClientMobileS,
                    handleFinishTwoFactorAction: onCallAction,
                    handleSelectAnotherTwoFactorType: handleSelectAnotherTwoFactorType,
                    preventDefault: preventDefault
                })
            ]
        })) : null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGeneral.ModalGeneral, {
        ariaHideApp: false,
        isOpen: isValidationActive,
        onCloseModal: function() {
            setIsValidationActive(false);
            if (onClickOnCloseButton) onClickOnCloseButton();
        },
        ariaLabelForModal: title,
        title: title,
        bodyDescription: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorDescriptionText, {
            sendCodeType: sendCodeType,
            shouldMask: shouldMask,
            onClickIsInvalidClientInfo: onClickIsInvalidClientInfo
        }),
        maxWidth: "489px",
        bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorContentBody, {
            showButton: showButton,
            buttonBorderRadius: buttonBorderRadius,
            buttonHeight: buttonHeight,
            sendCodeType: sendCodeType,
            handleFinishTwoFactorAction: onCallAction,
            handleSelectAnotherTwoFactorType: handleSelectAnotherTwoFactorType,
            preventDefault: preventDefault
        }),
        hasTitleBorder: false,
        containerGap: "0"
    });
});
ViewTwoFactorContent.displayName = "ViewTwoFactorContent";


;// CONCATENATED MODULE: ../../packages/components/2fa/Content/View/failure.tsx









var ViewTwoFactorContentFailure = function(param) {
    var title = param.title, viewType = param.viewType, _text = param.text, text = _text === void 0 ? "Parece que voc\xea atingiu o limite de envios de c\xf3digo por dia. Para sua seguran\xe7a, pausamos temporariamente as tentativas de envio do c\xf3digo de verifica\xe7\xe3o. Por favor, aguarde 24 horas antes de tentar novamente. Agradecemos sua compreens\xe3o." : _text, buttonText = param.buttonText, _hasHeader = param.hasHeader, hasHeader = _hasHeader === void 0 ? true : _hasHeader, onClickFailureButton = param.onClickFailureButton, _showButton = param.showButton, showButton = _showButton === void 0 ? true : _showButton, _hasModalHeader = param.hasModalHeader, hasModalHeader = _hasModalHeader === void 0 ? true : _hasModalHeader, titleFailure = param.titleFailure, illustration = param.illustration;
    var ref = (0,state_manager/* useTwoFactor */.kD)((0,adapter/* useShallow */.N)(function(state) {
        return {
            isValidationActive: state.isValidationActive,
            setIsValidationActive: state.setIsValidationActive
        };
    })), isValidationActive = ref.isValidationActive, setIsValidationActive = ref.setIsValidationActive;
    var handleAction = function() {
        setIsValidationActive(false);
        if (onClickFailureButton) {
            onClickFailureButton();
        }
    };
    if (viewType === "component") {
        return isValidationActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FailureContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-content-failure-container")), {
            children: [
                hasHeader ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FailureTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-content-failure-container-title")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.FailureIcon, {}),
                        " ",
                        title
                    ]
                })) : null,
                titleFailure ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FailureTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    isDefault: false
                }, (0,application/* buildTestIds */.Fek)("two-factor-content-failure-container-title")), {
                    children: titleFailure
                })) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FailureText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-content-failure-container-text")), {
                    children: text
                })),
                onClickFailureButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FailureButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-content-failure-content-button")), {
                    text: buttonText,
                    textUnderAction: "Aguarde...",
                    // underAction={formUnderAction}
                    buttonType: "submit",
                    onClickAction: handleAction,
                    fontWeight: ui.theme.typography.fontWeight[400],
                    color: "".concat(ui.theme.colors.secondary[380]),
                    hoveredColor: "".concat(ui.theme.colors.secondary[350])
                })) : null
            ]
        })) : null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGeneral.ModalGeneral, {
        ariaHideApp: false,
        isOpen: isValidationActive,
        hasHeader: hasModalHeader,
        onCloseModal: function() {
            return setIsValidationActive(false);
        },
        ariaLabelForModal: title,
        illustration: illustration,
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FailureTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-modal-failure-title")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.FailureIcon, {}),
                " ",
                title
            ]
        })),
        bodyDescription: text,
        maxWidth: "489px",
        bodyContent: showButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FailureButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-modal-failure-button")), {
            text: buttonText,
            textUnderAction: "Aguarde...",
            // underAction={formUnderAction}
            buttonType: "submit",
            onClickAction: handleAction,
            fontWeight: ui.theme.typography.fontWeight[400],
            color: "".concat(ui.theme.colors.secondary[380]),
            hoveredColor: "".concat(ui.theme.colors.secondary[350])
        })) : undefined,
        contentGap: "0",
        noCloseButton: true
    });
};


;// CONCATENATED MODULE: ../../packages/components/2fa/Options/styles.ts

function Options_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    Options_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Options_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* display: ",
        "; */\n  display: flex;\n  width: 100%;\n  align-items: center;\n  height: 80px;\n  padding: 8px 10px;\n  justify-content: space-between;\n  border-bottom: 1px solid ",
        ";\n  cursor: pointer;\n"
    ]);
    Options_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Options_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    Options_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Options_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 43px;\n  background-color: ",
        " !important;\n  width: 60px;\n  height: 60px;\n"
    ]);
    Options_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Options_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    Options_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Options_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  color: ",
        " !important;\n"
    ]);
    Options_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Options_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  color: ",
        " !important;\n"
    ]);
    Options_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var TwoFactorOptionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TwoFactorOptionsContainer",
    componentId: "sc-8e364c98-0"
})(Options_styles_templateObject());
var TwoFactorOptionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TwoFactorOptionContainer",
    componentId: "sc-8e364c98-1"
})(Options_styles_templateObject1(), function(param) {
    var isValid = param.isValid;
    return isValid ? "flex" : "none";
}, ui.theme.colors.neutral[150]);
var TwoFactorOptionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TwoFactorOptionWrapper",
    componentId: "sc-8e364c98-2"
})(Options_styles_templateObject2(), ui.theme.space["x4.5"]);
var TwoFactorOptionIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TwoFactorOptionIconWrapper",
    componentId: "sc-8e364c98-3"
})(Options_styles_templateObject3(), ui.theme.colors.secondary[28]);
var TwoFactorOptionInformation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TwoFactorOptionInformation",
    componentId: "sc-8e364c98-4"
})(Options_styles_templateObject4(), ui.theme.space.x2);
var TwoFactorOptionTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TwoFactorOptionTitle",
    componentId: "sc-8e364c98-5"
})(Options_styles_templateObject5(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[500], ui.theme.typography.fontFamily.chivo, ui.theme.colors.neutral[550]);
var TwoFactorOptionDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TwoFactorOptionDescription",
    componentId: "sc-8e364c98-6"
})(Options_styles_templateObject6(), ui.theme.typography.fontSize.sm.x3, ui.theme.typography.fontWeight[400], ui.theme.typography.fontFamily.chivo, ui.theme.colors.neutral[330]);
var TwoFactorOptionArrowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TwoFactorOptionArrowWrapper",
    componentId: "sc-8e364c98-7"
})(styles_templateObject7());

;// CONCATENATED MODULE: ../../packages/components/2fa/Options/index.tsx







var TwoFactorOptions = function(param) {
    var options = param.options;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorOptionsContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-options-container")), {
        children: options === null || options === void 0 ? void 0 : options.map(function(option) {
            /*#__PURE__*/ return (0,react.createElement)(TwoFactorOptionContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onClick: option === null || option === void 0 ? void 0 : option.handleOptionAction
            }, (0,application/* buildTestIds */.Fek)("two-factor-option-container")), {
                isValid: option === null || option === void 0 ? void 0 : option.isValid,
                key: option === null || option === void 0 ? void 0 : option.title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TwoFactorOptionWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-option-wrapper")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorOptionIconWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-option-icon-wrapper")), {
                                children: option === null || option === void 0 ? void 0 : option.icon
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TwoFactorOptionInformation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-option-information")), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorOptionTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-option-title")), {
                                        children: option === null || option === void 0 ? void 0 : option.title
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorOptionDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-option-description")), {
                                        children: option === null || option === void 0 ? void 0 : option.description
                                    }))
                                ]
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorOptionArrowWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-option-arrow-wrapper")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowRight, {
                            color: ui.theme.colors.neutral[550]
                        })
                    }))
                ]
            }));
        })
    }));
};


;// CONCATENATED MODULE: ../../packages/components/2fa/Content/View/verifyIdentity.tsx







var ViewTwoFactorVerifyIdentityContent = /*#__PURE__*/ (0,react.memo)(function(param) {
    var title = param.title, options = param.options, viewType = param.viewType, _hasTitleBorder = param.hasTitleBorder, hasTitleBorder = _hasTitleBorder === void 0 ? false : _hasTitleBorder, _hasDescriptionOnMobile = param.hasDescriptionOnMobile, hasDescriptionOnMobile = _hasDescriptionOnMobile === void 0 ? false : _hasDescriptionOnMobile, noTitle = param.noTitle, backgroundColor = param.backgroundColor, _description = param.description, description = _description === void 0 ? "Para garantir a sua seguran\xe7a, escolha um modo para autenticar a sua identidade." : _description;
    var ref = (0,state_manager/* useTwoFactor */.kD)((0,adapter/* useShallow */.N)(function(state) {
        return {
            isValidationActive: state.isValidationActive,
            setIsValidationActive: state.setIsValidationActive
        };
    })), isValidationActive = ref.isValidationActive, setIsValidationActive = ref.setIsValidationActive;
    if (viewType === "component") {
        return isValidationActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(TwoFactorViewContainer, {
            backgroundColor: backgroundColor,
            children: [
                !noTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorTitle, {
                    children: title
                }),
                description && hasDescriptionOnMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorDescription, {
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorOptions, {
                    options: options
                })
            ]
        }) : null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGeneral.ModalGeneral, {
        ariaHideApp: false,
        isOpen: isValidationActive,
        onCloseModal: function() {
            return setIsValidationActive(false);
        },
        ariaLabelForModal: title !== null && title !== void 0 ? title : "",
        title: title !== null && title !== void 0 ? title : "",
        bodyDescription: description,
        maxWidth: "489px",
        bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorViewContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorOptions, {
                options: options
            })
        }),
        hasTitleBorder: hasTitleBorder,
        containerGap: "0"
    });
});
ViewTwoFactorVerifyIdentityContent.displayName = "ViewTwoFactorVerifyIdentityContent";


;// CONCATENATED MODULE: ../../packages/components/2fa/Content/index.tsx







var TwoFactorContent = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _sendCodeType = param.sendCodeType, sendCodeType = _sendCodeType === void 0 ? "sms" : _sendCodeType, _successTitle = param.successTitle, successTitle = _successTitle === void 0 ? "Verifica\xe7\xe3o de identidade" : _successTitle, _errorTitle = param.errorTitle, errorTitle = _errorTitle === void 0 ? "Falha na verifica\xe7\xe3o de identidade" : _errorTitle, _errorButtonText = param.errorButtonText, errorButtonText = _errorButtonText === void 0 ? "Voltar para p\xe1gina inicial" : _errorButtonText, viewType = param.viewType, clientAction = param.clientAction, email = param.email, phoneNumber = param.phoneNumber, hasError = param.hasError, canChooseAnotherTwoFactorMethod = param.canChooseAnotherTwoFactorMethod, isUnderAction = param.isUnderAction, onClickFailureButton = param.onClickFailureButton, onCallAction = param.onCallAction, onClickIsInvalidClientInfo = param.onClickIsInvalidClientInfo, isVerifyIdentity = param.isVerifyIdentity, verifyIdentityDescription = param.verifyIdentityDescription, verifyIdentityTitle = param.verifyIdentityTitle, handleSelectAnotherTwoFactorType = param.handleSelectAnotherTwoFactorType, options = param.options, buttonBorderRadius = param.buttonBorderRadius, buttonHeight = param.buttonHeight, hasHeader = param.hasHeader, hasModalHeader = param.hasModalHeader, hasDescriptionOnMobile = param.hasDescriptionOnMobile, failureIllustration = param.failureIllustration, marginDescription = param.marginDescription, showButton = param.showButton, failureText = param.failureText, noTitle = param.noTitle, onClickOnCloseButton = param.onClickOnCloseButton, titleFailure = param.titleFailure, optionsBackgroundColor = param.optionsBackgroundColor, _shouldMask = param.shouldMask, shouldMask = _shouldMask === void 0 ? true : _shouldMask, _preventDefault = param.preventDefault, preventDefault = _preventDefault === void 0 ? false : _preventDefault, _hasTitleBorder = param.hasTitleBorder, hasTitleBorder = _hasTitleBorder === void 0 ? false : _hasTitleBorder;
    var ref = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            isBlockedToSendCode: state.isBlockedToSendCode,
            setClientAction: state.setClientAction,
            setEmail: state.setEmail,
            setPhoneNumber: state.setPhoneNumber,
            setCanChooseAnotherTwoFactorMethod: state.setCanChooseAnotherTwoFactorMethod,
            setIsUnderAction: state.setIsUnderAction
        };
    })), isBlockedToSendCode = ref.isBlockedToSendCode, setClientAction = ref.setClientAction, setEmail = ref.setEmail, setPhoneNumber = ref.setPhoneNumber, setCanChooseAnotherTwoFactorMethod = ref.setCanChooseAnotherTwoFactorMethod, setIsUnderAction = ref.setIsUnderAction;
    (0,react.useEffect)(function() {
        setIsUnderAction(isUnderAction);
    }, [
        isUnderAction,
        setIsUnderAction
    ]);
    (0,application/* useInitializeTwoFactor */.u6o)({
        clientAction: clientAction,
        email: email,
        phoneNumber: phoneNumber,
        canChooseAnotherTwoFactorMethod: canChooseAnotherTwoFactorMethod,
        setClientAction: setClientAction,
        setEmail: setEmail,
        setPhoneNumber: setPhoneNumber,
        setCanChooseAnotherTwoFactorMethod: setCanChooseAnotherTwoFactorMethod,
        options: options
    });
    if (hasError || isBlockedToSendCode) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewTwoFactorContentFailure, {
            titleFailure: titleFailure,
            hasHeader: hasHeader,
            title: errorTitle,
            viewType: viewType,
            buttonText: errorButtonText,
            onClickFailureButton: onClickFailureButton,
            hasModalHeader: hasModalHeader,
            illustration: failureIllustration,
            showButton: showButton,
            text: failureText
        });
    }
    if (isVerifyIdentity) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewTwoFactorVerifyIdentityContent, {
            noTitle: noTitle,
            options: options,
            description: verifyIdentityDescription,
            title: verifyIdentityTitle,
            viewType: viewType,
            hasTitleBorder: hasTitleBorder,
            hasDescriptionOnMobile: hasDescriptionOnMobile,
            backgroundColor: optionsBackgroundColor
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewTwoFactorContent, {
        noTitle: noTitle,
        title: successTitle,
        sendCodeType: sendCodeType,
        showButton: showButton,
        marginDescription: marginDescription,
        viewType: viewType,
        shouldMask: shouldMask,
        onCallAction: onCallAction,
        buttonBorderRadius: buttonBorderRadius,
        backgroundColor: optionsBackgroundColor,
        buttonHeight: buttonHeight,
        onClickIsInvalidClientInfo: onClickIsInvalidClientInfo,
        handleSelectAnotherTwoFactorType: handleSelectAnotherTwoFactorType,
        preventDefault: preventDefault,
        onClickOnCloseButton: onClickOnCloseButton
    });
});
TwoFactorContent.displayName = "TwoFactorContent";


// EXTERNAL MODULE: ../../packages/components/2fa/Button/index.tsx
var Button = __webpack_require__(60985);
;// CONCATENATED MODULE: ../../packages/components/2fa/index.ts




/***/ }),

/***/ 59797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ AddToHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var infra_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62911);


var AddToHead = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(infra_components__WEBPACK_IMPORTED_MODULE_1__/* .Head */ .Fb, {
        children: children
    });
};


/***/ }),

/***/ 33082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ BottomSheet; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(430);
/* harmony import */ var infra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11338);




var BottomSheet = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(infra__WEBPACK_IMPORTED_MODULE_2__/* .ReactSpringBottomSheet */ .sN, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("react-spring-bottom-sheet"), props));
};



/***/ }),

/***/ 90350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Breadcrumb; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58013);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var infra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11338);




var Breadcrumb = function(_param) {
    var restProps = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(infra__WEBPACK_IMPORTED_MODULE_1__/* .NextjsBreadcrumbs */ .jp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, restProps));
};



/***/ }),

/***/ 42942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ButtonSubmit; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(430);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38879);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46644);







var ButtonSubmit = function(_param) {
    var text = _param.text, textUnderAction = _param.textUnderAction, underAction = _param.underAction, onClickAction = _param.onClickAction, _buttonType = _param.buttonType, buttonType = _buttonType === void 0 ? "submit" : _buttonType, color = _param.color, contentColor = _param.contentColor, hoveredColor = _param.hoveredColor, _isDisabled = _param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, form = _param.form, padding = _param.padding, fontWeight = _param.fontWeight, textDecoration = _param.textDecoration, height = _param.height, borderRadius = _param.borderRadius, _alternativeButton = _param.alternativeButton, alternativeButton = _alternativeButton === void 0 ? false : _alternativeButton, preventDefault = _param.preventDefault, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "text",
        "textUnderAction",
        "underAction",
        "onClickAction",
        "buttonType",
        "color",
        "contentColor",
        "hoveredColor",
        "isDisabled",
        "form",
        "padding",
        "fontWeight",
        "textDecoration",
        "height",
        "borderRadius",
        "alternativeButton",
        "preventDefault"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_style__WEBPACK_IMPORTED_MODULE_3__/* .StyledButtonSubmit */ .N, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("component-button-submit")), {
        type: buttonType,
        onClick: function(e) {
            if (!isDisabled && onClickAction) {
                onClickAction();
            }
            if (preventDefault) {
                e.preventDefault();
            }
        },
        underAction: underAction,
        color: color !== null && color !== void 0 ? color : undefined,
        contentColor: contentColor !== null && contentColor !== void 0 ? contentColor : undefined,
        hoveredColor: hoveredColor !== null && hoveredColor !== void 0 ? hoveredColor : undefined,
        padding: padding,
        form: form,
        isDisabled: isDisabled,
        disabled: isDisabled,
        onKeyDown: !isDisabled && onClickAction ? onClickAction : undefined,
        fontWeight: fontWeight,
        textDecoration: textDecoration,
        height: height,
        borderRadius: borderRadius,
        "aria-disabled": isDisabled
    }), props), {
        children: [
            underAction && !alternativeButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_2__/* .Loading */ .g, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("component-button-submit-loading")), {
                size: "medium"
            })) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_style__WEBPACK_IMPORTED_MODULE_3__/* .ButtonSubmitText */ .k, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("button-submit-text")), {
                children: underAction ? textUnderAction : text
            }))
        ]
    }));
};



/***/ }),

/***/ 46644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ StyledButtonSubmit; },
/* harmony export */   "k": function() { return /* binding */ ButtonSubmitText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  justify-content: center;\n  padding: ",
        ";\n  cursor: ",
        ";\n  opacity: ",
        ";\n  align-self: ",
        ";\n  text-decoration: ",
        ";\n  border: ",
        ";\n  border-color: ",
        ";\n  border-radius: ",
        ";\n  width: 100%;\n  min-width: ",
        ";\n  max-width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  border: ",
        ';\n  font-family: "Chivo", sans-serif;\n  transition: 0.2s ease-in-out;\n  margin: ',
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledButtonSubmit = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "style__StyledButtonSubmit",
    componentId: "sc-47e07efc-0"
})(_templateObject(), function(param) {
    var underAction = param.underAction;
    return underAction ? "0.75rem" : 0;
}, function(param) {
    var underAction = param.underAction, isDisabled = param.isDisabled;
    return underAction || isDisabled ? "default" : "pointer";
}, function(param) {
    var underAction = param.underAction, isDisabled = param.isDisabled;
    return underAction || isDisabled ? "0.5" : "1";
}, function(param) {
    var alignSelf = param.alignSelf;
    return alignSelf || "flex-start";
}, function(param) {
    var textDecoration = param.textDecoration;
    return textDecoration || "none";
}, function(param) {
    var border = param.border;
    return border || "none";
}, function(param) {
    var borderColor = param.borderColor;
    return borderColor || "initial";
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius || "4px";
}, function(param) {
    var minWidth = param.minWidth;
    return minWidth || "90px";
}, function(param) {
    var maxWidth = param.maxWidth;
    return maxWidth || "max-content";
}, function(param) {
    var height = param.height;
    return height || "4rem";
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize || "1.2rem";
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight || "initial";
}, function(param) {
    var color = param.color;
    return color || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200];
}, function(param) {
    var contentColor = param.contentColor;
    return contentColor || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white;
}, function(param) {
    var border = param.border;
    return border || "transparent";
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var isDisabled = param.isDisabled, underAction = param.underAction, hoveredColor = param.hoveredColor;
    return !isDisabled && !underAction && "&:not(:disabled):hover { background: ".concat(hoveredColor || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[300], "; }");
});
var ButtonSubmitText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "style__ButtonSubmitText",
    componentId: "sc-47e07efc-1"
})(_templateObject1());


/***/ }),

/***/ 80712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ ChangePassword; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/components/Form/index.tsx + 12 modules
var Form = __webpack_require__(29043);
// EXTERNAL MODULE: ../../packages/components/PasswordValidation/index.tsx + 1 modules
var PasswordValidation = __webpack_require__(4043);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/components/ButtonSubmit/index.tsx
var ButtonSubmit = __webpack_require__(42942);
;// CONCATENATED MODULE: ../../packages/components/ChangePassword/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 100%;\n  width: 100% !important;\n  height: 3.75rem;\n  padding: 0.65rem 4.9125rem;\n  text-align: center;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin-top: ",
        ";\n\n  border-radius: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  cursor: pointer;\n  transition: background 0.2s ease-in-out;\n  border: 0;\n\n  &:hover {\n    background: ",
        " !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n  margin-bottom: ",
        ";\n\n  @media ",
        " {\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var ChangePasswordContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ChangePasswordContainer",
    componentId: "sc-4e823271-0"
})(_templateObject());
var ButtonConfirmModalPasswordChange = (0,styled_components_browser_esm/* default */.ZP)(ButtonSubmit/* ButtonSubmit */.G).withConfig({
    displayName: "styles__ButtonConfirmModalPasswordChange",
    componentId: "sc-4e823271-1"
})(_templateObject1(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x7, ui.theme.typography.fontWeight[400], ui.theme.space.x6, ui.theme.space.x2, ui.theme.colors.neutral.white, ui.theme.colors.secondary[250], ui.theme.colors.secondary[380]);
var ChangePasswordForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "styles__ChangePasswordForm",
    componentId: "sc-4e823271-2"
})(_templateObject2(), ui.theme.space.x6, ui.theme.space.x4, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x4);
var InputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__InputWrapper",
    componentId: "sc-4e823271-3"
})(_templateObject3());
var PasswordValidationWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PasswordValidationWrapper",
    componentId: "sc-4e823271-4"
})(_templateObject4());
var EyeOpenIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.NewEyeOpenIcon).attrs({
    width: 20,
    height: 18
}).withConfig({
    displayName: "styles__EyeOpenIcon",
    componentId: "sc-4e823271-5"
})(_templateObject5());
var EyeCloseIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.NewEyeCloseIcon).withConfig({
    displayName: "styles__EyeCloseIcon",
    componentId: "sc-4e823271-6"
})(_templateObject6());

;// CONCATENATED MODULE: ../../packages/components/ChangePassword/index.tsx










var ChangePassword = function(param) {
    var onChangePassword = param.onChangePassword, _isUnderAction = param.isUnderAction, isUnderAction = _isUnderAction === void 0 ? false : _isUnderAction;
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, setValue = ref.setValue, watch = ref.watch;
    var ref1 = (0,react.useState)(0), passwordStrength = ref1[0], setPasswordStrength = ref1[1];
    var ref2 = (0,react.useState)("password"), newPasswordType = ref2[0], setNewPasswordType = ref2[1];
    var ref3 = (0,react.useState)("password"), confirmNewPasswordType = ref3[0], setConfirmNewPasswordType = ref3[1];
    var newPasswordWatcher = watch("newPassword");
    var confirmNewPasswordWatcher = watch("confirmNewPassword");
    var changePasswordVisibility = function(type) {
        return type === "password" ? "text" : "password";
    };
    var changePasswordIcon = function(type) {
        return type === "password" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeCloseIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeOpenIcon, {});
    };
    var isInvalidNewPassword = (0,application/* validatePassword */.uo4)(newPasswordWatcher);
    var isInvalidConfirmPassword = (0,application/* validateConfirmPassword */.S$0)(newPasswordWatcher, confirmNewPasswordWatcher);
    var isFormInvalid = isInvalidNewPassword || isInvalidConfirmPassword || !newPasswordWatcher || !confirmNewPasswordWatcher || passwordStrength !== 5;
    var isNewPasswordValid = (newPasswordWatcher === null || newPasswordWatcher === void 0 ? void 0 : newPasswordWatcher.length) > 0;
    var verifyNewPassword = isInvalidNewPassword && isNewPasswordValid;
    var isConfirmPasswordValid = (confirmNewPasswordWatcher === null || confirmNewPasswordWatcher === void 0 ? void 0 : confirmNewPasswordWatcher.length) > 0;
    var verifyConfirmPassword = isInvalidConfirmPassword && isConfirmPasswordValid;
    var handleChangePassword = (0,react.useCallback)(function() {
        onChangePassword(newPasswordWatcher);
    }, [
        newPasswordWatcher,
        onChangePassword
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChangePasswordContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChangePasswordForm, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("change-password-form")), {
                onSubmit: handleSubmit(handleChangePassword),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("new-password-input-wrapper")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Label */.__, {
                                htmlFor: "new-password",
                                text: "Senha",
                                color: "".concat(ui.theme.colors.neutral[585], " !important"),
                                fontSize: ui.theme.typography.fontSize.sm.x5,
                                typeFontWeight: ui.theme.typography.fontWeight[400]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                id: "new-password",
                                name: "newPassword",
                                type: newPasswordType,
                                placeholder: "Digite uma senha v\xe1lida",
                                register: register,
                                disabled: isUnderAction,
                                hasError: verifyNewPassword,
                                hasSuccessfully: isNewPasswordValid && !verifyNewPassword,
                                width: "100%"
                            }, (0,application/* buildTestIds */.Fek)("new-password-input")), {
                                onChange: function(param) {
                                    var target = param.target;
                                    return setValue("newPassword", target === null || target === void 0 ? void 0 : target.value);
                                },
                                height: "45px",
                                padding: "1rem",
                                hasIcon: true,
                                paddingInfo: "0px",
                                paddingErrorMessage: "0px",
                                onClickIcon: function() {
                                    return setNewPasswordType(changePasswordVisibility(newPasswordType));
                                },
                                icon: changePasswordIcon(newPasswordType),
                                fontSizeInfo: ui.theme.typography.fontSize.sm.x3,
                                colorInfo: "".concat(ui.theme.colors.neutral[550], " !important"),
                                textError: isInvalidNewPassword,
                                margin: "".concat(ui.theme.space.x2, " 0px 0px")
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-new-password-input-wrapper")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Label */.__, {
                                htmlFor: "confirm-new-password",
                                text: "Confirme sua senha",
                                color: "".concat(ui.theme.colors.neutral[585], " !important"),
                                fontSize: ui.theme.typography.fontSize.sm.x5,
                                typeFontWeight: ui.theme.typography.fontWeight[400]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                id: "confirm-new-password",
                                name: "confirmNewPassword",
                                type: confirmNewPasswordType,
                                placeholder: "Digite novamente a senha",
                                register: register,
                                disabled: isUnderAction,
                                hasError: verifyConfirmPassword,
                                hasSuccessfully: isConfirmPasswordValid && !verifyConfirmPassword,
                                textError: isInvalidConfirmPassword,
                                width: "100%"
                            }, (0,application/* buildTestIds */.Fek)("confirm-new-password-input")), {
                                onChange: function(param) {
                                    var target = param.target;
                                    return setValue("confirmNewPassword", target === null || target === void 0 ? void 0 : target.value);
                                },
                                hasIcon: true,
                                paddingInfo: "0px",
                                paddingErrorMessage: "0px",
                                onClickIcon: function() {
                                    return setConfirmNewPasswordType(changePasswordVisibility(confirmNewPasswordType));
                                },
                                icon: changePasswordIcon(confirmNewPasswordType),
                                fontSizeInfo: ui.theme.typography.fontSize.sm.x3,
                                colorInfo: ui.theme.colors.neutral[550],
                                height: "45px",
                                padding: "1rem",
                                margin: "".concat(ui.theme.space.x2, " 0px 0px")
                            }))
                        ]
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordValidationWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("password-validation-wrapper")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordValidation/* PasswordValidation */.T, {
                    showComponent: isNewPasswordValid,
                    userConfirmPassword: confirmNewPasswordWatcher,
                    userPassword: newPasswordWatcher,
                    onChangePasswordStrength: function(strength) {
                        return setPasswordStrength(strength);
                    }
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirmModalPasswordChange, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("change-password-button")), {
                isDisabled: !!isFormInvalid,
                text: "Alterar senha",
                textUnderAction: "Alterando senha...",
                underAction: isUnderAction,
                onClickAction: handleSubmit(handleChangePassword)
            }))
        ]
    });
};



/***/ }),

/***/ 88484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CodeExpiration; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(430);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61882);




var CodeExpiration = function(param) {
    var codeCountdown = param.codeCountdown;
    var counterTimeContext = (0,application__WEBPACK_IMPORTED_MODULE_2__/* .useNotification */ .lmA)().counterTimeContext;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), codeTimeout = ref[0], setCodeTimeOut = ref[1];
    var seconds = codeTimeout % 60;
    var minutes = Math.floor(codeTimeout / 60);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var idTime = setTimeout(function() {
            if (codeTimeout) {
                setCodeTimeOut(codeTimeout - 1);
            }
        }, 1000);
        return function() {
            return clearTimeout(idTime);
        };
    }, [
        codeTimeout
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (codeCountdown) {
            codeCountdown(codeTimeout);
        }
    }, [
        codeTimeout,
        codeCountdown
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (counterTimeContext) {
            setCodeTimeOut(counterTimeContext);
        }
    }, [
        counterTimeContext
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Countdown */ .I, {
        children: [
            "Reenviar c\xf3digo em ",
            minutes,
            ":",
            seconds < 10 ? "0".concat(seconds) : seconds
        ]
    });
};



/***/ }),

/***/ 61882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Countdown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Countdown = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__Countdown",
    componentId: "sc-e05e4793-0"
})(_templateObject(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x3);


/***/ }),

/***/ 93240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ne": function() { return /* binding */ BlockScreen; },
/* harmony export */   "qO": function() { return /* binding */ ButtonContainer; }
/* harmony export */ });
/* unused harmony exports ActionLink, ConfirmPaymentBody, ConfirmPaymentHeader, ConfirmPaymentFieldSet, ConfirmPaymentFieldSetLegend */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17335);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ",
        ";\n  z-index: 9999;\n\n  transition: all 0.4s ease-in-out;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  width: ",
        ";\n  border-radius: 6px;\n  padding: 0.75rem 1.25rem;\n  cursor: ",
        ";\n  opacity: ",
        ";\n  font-size: 1.25rem;\n  font-family: ",
        ", sans-serif;\n  font-weight: 500;\n  text-shadow: 0 1px 0 ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  border: 0;\n  transition: all 0.2s ease;\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 1.5rem;\n  width: 100%;\n  max-width: 50rem;\n  align-items: flex-start;\n  justify-content: center;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  min-width: 17rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  text-align: start;\n  font-weight: 600;\n  color: ",
        ";\n  font-size: ",
        ";\n  gap: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border-radius: 4px;\n  gap: ",
        ";\n  color: ",
        ";\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: start;\n  width: 100%;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: 400;\n  @media ",
        " {\n    margin-left: 0;\n  }\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var BlockScreen = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__BlockScreen",
    componentId: "sc-fd478a91-0"
})(_templateObject(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral["999-opacity-15"]);
var ButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "styles__ButtonContainer",
    componentId: "sc-fd478a91-1"
})(_templateObject1(), function(param) {
    var isClientMobile = param.isClientMobile;
    return isClientMobile ? "100%" : "11.5rem";
}, function(param) {
    var isButtonDisabled = param.isButtonDisabled;
    return isButtonDisabled ? "default" : "pointer";
}, function(param) {
    var isButtonDisabled = param.isButtonDisabled;
    return isButtonDisabled ? "0.5" : "1";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.barlow, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[830], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.secondary[360], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.secondary[420]);
var ActionLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r).withConfig({
    displayName: "styles__ActionLink",
    componentId: "sc-fd478a91-2"
})(_templateObject2());
var ConfirmPaymentBody = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__ConfirmPaymentBody",
    componentId: "sc-fd478a91-3"
})(_templateObject3(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2);
var ConfirmPaymentHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__ConfirmPaymentHeader",
    componentId: "sc-fd478a91-4"
})(_templateObject4(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[550], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x7, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileS, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x5);
var ConfirmPaymentFieldSet = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__ConfirmPaymentFieldSet",
    componentId: "sc-fd478a91-5"
})(_templateObject5(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[520]);
var ConfirmPaymentFieldSetLegend = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].legend.withConfig */ .ZP.legend.withConfig({
    displayName: "styles__ConfirmPaymentFieldSetLegend",
    componentId: "sc-fd478a91-6"
})(_templateObject6(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[520], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x5, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileM, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileS, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x5);


/***/ }),

/***/ 49911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ CountdownCircleTimer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var infra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11338);


var CountdownCircleTimer = function(param) {
    var _isPlaying = param.isPlaying, isPlaying = _isPlaying === void 0 ? true : _isPlaying, duration = param.duration, size = param.size, onComplete = param.onComplete, onUpdate = param.onUpdate, children = param.children, initialRemainingTime = param.initialRemainingTime;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(infra__WEBPACK_IMPORTED_MODULE_1__/* .ReactCountdownCircleTimer */ .IM, {
        colors: [
            "#74b740",
            "#d9a900",
            "#aa0e27",
            "#d9d9d9"
        ],
        colorsTime: [
            duration,
            duration * 0.66,
            duration * 0.33,
            0
        ],
        isPlaying: isPlaying,
        strokeWidth: 10,
        isSmoothColorTransition: false,
        strokeLinecap: "butt",
        rotation: "counterclockwise",
        duration: duration,
        size: size,
        onComplete: onComplete,
        onUpdate: onUpdate,
        initialRemainingTime: initialRemainingTime,
        children: children
    });
};


/***/ }),

/***/ 54874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ FCTextArea; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/FCTextArea/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1rem;\n  width: 100%;\n  border: 1px solid ",
        ";\n  border-radius: 5px;\n  padding: 0.8rem;\n\n  transition: border-width 0.2s ease-in-out;\n  transition: border-width 0.2s ease-in-out;\n\n  &:focus-within {\n    border-width: 2px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  resize: none;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-top: 2rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  text-align: left;\n  font-weight: bold;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-98910efb-0"
})(_templateObject(), ui.theme.colors.neutral["999-opacity-75"]);
var TextArea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
    displayName: "styles__TextArea",
    componentId: "sc-98910efb-1"
})(_templateObject1());
var LabelContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LabelContainer",
    componentId: "sc-98910efb-2"
})(_templateObject2());
var LabelText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__LabelText",
    componentId: "sc-98910efb-3"
})(_templateObject3(), ui.theme.colors.neutral[465], ui.theme.typography.fontWeight[700], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x3);
var TextAreaMessageError = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TextAreaMessageError",
    componentId: "sc-98910efb-4"
})(_templateObject4(), ui.theme.typography.fontFamily.chivo, ui.theme.colors.primary[200]);
var CharacterCounter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CharacterCounter",
    componentId: "sc-98910efb-5"
})(_templateObject5(), function(param) {
    var maxLengthOfMessage = param.maxLengthOfMessage;
    return maxLengthOfMessage ? "".concat(ui.theme.colors.primary[200]) : "".concat(ui.theme.colors.neutral[465]);
});

;// CONCATENATED MODULE: ../../packages/components/FCTextArea/index.tsx






var FCTextArea = function(param) {
    var _error = param.error, error = _error === void 0 ? false : _error, _helperTextError = param.helperTextError, helperTextError = _helperTextError === void 0 ? " " : _helperTextError, handleOnChange = param.handleOnChange, labelOptional = param.labelOptional, label = param.label, _maxLength = param.maxLength, maxLength = _maxLength === void 0 ? 500 : _maxLength, _maxLengthOfMessage = param.maxLengthOfMessage, maxLengthOfMessage = _maxLengthOfMessage === void 0 ? false : _maxLengthOfMessage, placeholder = param.placeholder, _rows = param.rows, rows = _rows === void 0 ? 5 : _rows, _testId = param.testId, testId = _testId === void 0 ? "TextArea" : _testId, _testIdLabel = param.testIdLabel, testIdLabel = _testIdLabel === void 0 ? "Label" : _testIdLabel;
    var ref = (0,react.useState)(""), text = ref[0], setText = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)(testIdLabel)), {
                        children: label
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText, {
                        children: labelOptional
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                maxLengthOfMessage: maxLengthOfMessage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, (0,_object_spread/* default */.Z)({
                        id: "charCounter",
                        rows: rows,
                        maxLength: maxLength,
                        onChange: function(e) {
                            handleOnChange(e.target.value);
                            setText(e.target.value);
                        },
                        value: text,
                        placeholder: placeholder
                    }, (0,application/* buildTestIds */.Fek)(testId))),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CharacterCounter, {
                        maxLengthOfMessage: maxLengthOfMessage,
                        children: [
                            text.length,
                            "/",
                            maxLength
                        ]
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAreaMessageError, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("text-area-error")), {
                children: helperTextError
            })) : null
        ]
    });
};



/***/ }),

/***/ 92041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_FacetsFilterList; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/Skeleton/index.tsx
var Skeleton = __webpack_require__(44860);
;// CONCATENATED MODULE: ../../packages/components/FacetsFilterList/hooks.ts


var useScreenResizeSkeleton = function() {
    var ref = (0,application/* useAppContext */.bp4)(), isClientLaptop = ref.isClientLaptop, isClientTablet = ref.isClientTablet, isClientMobile = ref.isClientMobile;
    var ref1 = (0,react.useState)({
        width: "170px",
        marginBottom: "10px"
    }), screenResizeSkeleton = ref1[0], setScreenResizeSkeleton = ref1[1];
    (0,react.useEffect)(function() {
        if (isClientLaptop && !isClientTablet) {
            setScreenResizeSkeleton({
                width: "130px",
                marginBottom: "10px"
            });
            return;
        }
        if (isClientTablet && !isClientMobile) {
            setScreenResizeSkeleton({
                width: "320px",
                marginBottom: "10px"
            });
            return;
        }
        if (isClientMobile) {
            setScreenResizeSkeleton({
                width: "220px",
                marginBottom: "10px"
            });
            return;
        }
        setScreenResizeSkeleton({
            width: "170px",
            marginBottom: "10px"
        });
    }, [
        isClientLaptop,
        isClientMobile,
        isClientTablet
    ]);
    return screenResizeSkeleton;
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/FacetsFilterList/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n\n  font-size: 1.3rem;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.active {\n    height: auto;\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n    transition: all 0.4s ease-in-out, visibility 0.4s;\n  }\n\n  &.inactive {\n    height: 0;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-20px);\n    transition: all 0.4s ease-in-out, visibility 0.4s;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 0.8rem;\n  margin-bottom: 1rem;\n  border-left: 2px solid ",
        ";\n  cursor: pointer;\n\n  &.active {\n    color: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 82%;\n  line-height: 1.4;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: thin solid ",
        ";\n  padding: 0.1rem 0.5rem;\n  color: ",
        ";\n  border-radius: 50px;\n\n  &.active {\n    background-color: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 50px;\n  display: inline-flex;\n  justify-content: center;\n  padding: 0.4rem;\n  min-height: 2rem;\n  background-color: ",
        ";\n  font-size: 1rem;\n  cursor: pointer;\n  border: none;\n  margin-bottom: 5px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        color: ",
        ";\n\n        > svg > path {\n          fill: ",
        ";\n        }\n      }\n\n      ",
        " {\n        color: ",
        ";\n        border-left-color: ",
        ";\n        position: relative;\n        width: 100%;\n\n        &.active {\n          width: 100%;\n          height: 100%;\n          position: relative;\n          overflow: visible;\n          color: ",
        ";\n          border-left-color: ",
        ';\n\n          &:before {\n            content: "";\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            top: 0;\n            left: 0;\n            opacity: 0.2;\n            border-radius: 0 30px 30px 0;\n          }\n\n          ',
        " {\n            color: ",
        ";\n            background: ",
        ";\n            border-color: ",
        ";\n          }\n        }\n      }\n\n      ",
        " {\n        color: ",
        ";\n        background: ",
        ";\n        border-color: ",
        ";\n      }\n\n      ",
        " {\n        color: ",
        ";\n        background: ",
        ";\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var SidebarFilterListHeader = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__SidebarFilterListHeader",
    componentId: "sc-ca2ce3e6-0"
})(_templateObject());
var SidebarFilterListDrop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SidebarFilterListDrop",
    componentId: "sc-ca2ce3e6-1"
})(_templateObject1());
var SidebarFilterListItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SidebarFilterListItem",
    componentId: "sc-ca2ce3e6-2"
})(_templateObject2(), ui.theme.colors.neutral[320], ui.theme.colors.primary[200], ui.theme.colors.primary[200]);
var FilterText = (0,styled_components_browser_esm/* default */.ZP)(ui.Text).withConfig({
    displayName: "styles__FilterText",
    componentId: "sc-ca2ce3e6-3"
})(_templateObject3());
var FilterCounter = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__FilterCounter",
    componentId: "sc-ca2ce3e6-4"
})(_templateObject4(), ui.theme.colors.neutral.white, ui.theme.colors.neutral[320], ui.theme.colors.neutral[450], ui.theme.colors.primary[200], ui.theme.colors.primary[200], ui.theme.colors.neutral.white);
var ViewMoreButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ViewMoreButton",
    componentId: "sc-ca2ce3e6-5"
})(_templateObject5(), ui.theme.colors.neutral.white, ui.theme.colors.neutral.white);
var SidebarFilterList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SidebarFilterList",
    componentId: "sc-ca2ce3e6-6"
})(_templateObject7(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), SidebarFilterListHeader, ui.theme.colors.neutral[25], ui.theme.colors.neutral.white, SidebarFilterListItem, ui.theme.colors.neutral[25], ui.theme.colors.neutral[25], ui.theme.colors.secondary[380], ui.theme.colors.secondary[250], FilterCounter, ui.theme.colors.neutral.white, ui.theme.colors.neutral[25], ui.theme.colors.secondary[250], FilterCounter, ui.theme.colors.neutral[999], ui.theme.colors.neutral[25], ui.theme.colors.neutral.white, ViewMoreButton, ui.theme.colors.neutral[999], ui.theme.colors.neutral[25]);
});

;// CONCATENATED MODULE: ../../packages/components/FacetsFilterList/index.tsx










var FacetsFilterList = function(param) {
    var filterTitle = param.filterTitle, filterOptions = param.filterOptions, activeOptions = param.activeOptions, isLoadingFacets = param.isLoadingFacets, hasFacets = param.hasFacets, isBlackTheme = param.isBlackTheme, handleTitleFilter = param.handleTitleFilter, handleOptionFilter = param.handleOptionFilter, _hasPreSelectFilter = param.hasPreSelectFilter, hasPreSelectFilter = _hasPreSelectFilter === void 0 ? false : _hasPreSelectFilter;
    var INITIAL_MAX_HEIGHT = 1000;
    var collapseMenuRef = (0,react.useRef)(null);
    var isFirstRender = (0,react.useRef)(true);
    var maxHeightRef = (0,react.useRef)(INITIAL_MAX_HEIGHT);
    var prevFilterOptionsRef = (0,react.useRef)([]);
    var ref = (0,react.useState)(true), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(false), isOpenMore = ref1[0], setIsOpenMore = ref1[1];
    var ref2 = (0,react.useState)(5), showItems = ref2[0], setShowItems = ref2[1];
    var ref3 = (0,react.useState)(function() {
        return filterOptions.map(function(item) {
            return !!activeOptions.includes(item.key);
        });
    }), activeIndexes = ref3[0], setActiveIndexes = ref3[1];
    var prevFilterOptions = prevFilterOptionsRef.current;
    var handleShowMore = function() {
        setIsOpenMore(function(openMore) {
            return !openMore;
        });
        setShowItems(function(showMoreItems) {
            return showMoreItems >= (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.length) ? showMoreItems : showMoreItems + 25;
        });
    };
    (0,react.useEffect)(function() {
        return setActiveIndexes(filterOptions.map(function(item) {
            return !!activeOptions.includes(item.key);
        }));
    }, [
        activeOptions,
        filterOptions
    ]);
    var ref4 = (0,react.useState)(""), facetTitle = ref4[0], setFacetTitle = ref4[1];
    (0,react.useEffect)(function() {
        var getMappedTitle = {
            category: "Categoria",
            brand: "Marcas",
            model: "Modelos"
        };
        var getFilterTitle = function() {
            if (filterTitle) {
                var title = filterTitle;
                setFacetTitle(getMappedTitle["".concat(title)] || filterTitle);
            }
        };
        getFilterTitle();
    }, [
        facetTitle,
        filterTitle
    ]);
    (0,react.useEffect)(function() {
        if (collapseMenuRef.current && !isFirstRender.current) {
            if (maxHeightRef.current > collapseMenuRef.current.offsetHeight && maxHeightRef.current !== INITIAL_MAX_HEIGHT) {
                return;
            }
            maxHeightRef.current = collapseMenuRef.current.offsetHeight;
        }
        if (isOpen && isOpenMore && isFirstRender.current) {
            isFirstRender.current = false;
        }
    }, [
        isOpen,
        isOpenMore
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        prevFilterOptionsRef.current = filterOptions;
        if (((ref = prevFilterOptions[0]) === null || ref === void 0 ? void 0 : ref.key) !== ((ref1 = filterOptions[0]) === null || ref1 === void 0 ? void 0 : ref1.key) && hasPreSelectFilter && filterOptions.length === 1) {
            handleOptionFilter(filterOptions[0].key);
        }
    }, [
        filterOptions,
        handleOptionFilter,
        hasPreSelectFilter,
        prevFilterOptions, 
    ]);
    var screenResizeSkeleton = useScreenResizeSkeleton();
    if (isLoadingFacets) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("skeleton")), {
            type: "sidebarFilters",
            count: 5,
            style: screenResizeSkeleton,
            gap: "10px",
            width: "100%",
            hasMargin: false
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarFilterList, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sidebar-filter-list")), {
        isBlackTheme: isBlackTheme,
        children: (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.length) && filterTitle && hasFacets ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarFilterListHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sidebar-filter-list-header")), {
                    onClick: function() {
                        return setIsOpen(function(open) {
                            return !open;
                        });
                    },
                    children: [
                        facetTitle,
                        " ",
                        isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowUp, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowDown, {})
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Accordion, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("accordion")), {
                    ref: collapseMenuRef,
                    show: isOpen,
                    maxHeight: isOpen ? "".concat(maxHeightRef.current, "px") : "0",
                    children: [
                        filterOptions.slice(0, showItems).map(function(option, index) {
                            /*#__PURE__*/ return (0,react.createElement)(SidebarFilterListItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sidebar-filter-list-item")), {
                                key: "".concat(option === null || option === void 0 ? void 0 : option.key, "#").concat(option === null || option === void 0 ? void 0 : option.docCount),
                                // eslint-disable-next-line sonarjs/no-nested-template-literals
                                className: "".concat(activeIndexes["".concat(index)] ? "active" : ""),
                                onClick: function() {
                                    setActiveIndexes(activeIndexes.map(function(bool, activeIndex) {
                                        return activeIndex === index ? !bool : bool;
                                    }));
                                    handleTitleFilter(facetTitle);
                                    handleOptionFilter(option.key);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("filter-text")), {
                                        fontSize: "1rem",
                                        margin: "0",
                                        children: option.key
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterCounter, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("filter-counter")), {
                                        // eslint-disable-next-line sonarjs/no-nested-template-literals
                                        className: "".concat(activeIndexes["".concat(index)] ? "active" : ""),
                                        children: option.docCount
                                    }))
                                ]
                            }));
                        }),
                        showItems < (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewMoreButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("view-more-button")), {
                            onClick: function() {
                                return handleShowMore();
                            },
                            children: [
                                "ver +",
                                filterOptions.length - showItems
                            ]
                        }))
                    ]
                }))
            ]
        }) : null
    }));
};
/* harmony default export */ var components_FacetsFilterList = (FacetsFilterList);


/***/ }),

/***/ 47852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form_Checkbox; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/Form/Checkbox/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          flex-direction: ",
        ";\n          justify-content: ",
        ";\n          align-items: ",
        ";\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  cursor: ",
        ";\n  gap: ",
        ";\n  width: 100%;\n  transition: all 0.2s ease-in-out;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  cursor: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-color: ",
        ";\n        border-radius: 50%;\n        left: 3.5px;\n        top: 3px;\n        width: ",
        ";\n        height: ",
        ";\n        transform: none;\n        border: none;\n\n        @media ",
        " {\n          left: 1.8px;\n          top: 1.5px;\n          width: 11.1px;\n          height: 11.9px;\n        }\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        left: 1.8px;\n        top: 1.5px;\n        width: 11.1px;\n        height: 11.9px;\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  -webkit-appearance: none;\n  appearance: none;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  border: ",
        " solid\n    ",
        ";\n  outline: none;\n  cursor: pointer;\n  pointer-events: initial;\n  transition: all 0.2s ease-in;\n  background-color: ",
        ";\n\n  &:hover {\n    border: ",
        " solid\n      ",
        ";\n  }\n\n  &:checked {\n    border: ",
        " solid\n      ",
        ";\n    position: relative;\n    background-color: ",
        ';\n  }\n\n  &:checked::before {\n    content: "";\n    font-size: ',
        ";\n    color: ",
        ";\n    position: absolute;\n    left: ",
        ";\n    top: -4px;\n    width: ",
        ";\n    height: ",
        ";\n    border-style: solid;\n    transform-origin: bottom left;\n    border-width: 0 3px 3px 0;\n    transform: rotate(45deg);\n\n    ",
        "\n\n    ",
        "\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var CheckboxWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__CheckboxWrapper",
    componentId: "sc-c66883d7-0"
})(_templateObject(), function(param) {
    var cursor = param.cursor;
    return cursor !== null && cursor !== void 0 ? cursor : "default";
}, function(param) {
    var checkboxWrapperWidth = param.checkboxWrapperWidth;
    return checkboxWrapperWidth !== null && checkboxWrapperWidth !== void 0 ? checkboxWrapperWidth : "auto";
});
var CheckboxLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "style__CheckboxLabel",
    componentId: "sc-c66883d7-1"
})(_templateObject2(), function(param) {
    var display = param.display;
    return display !== null && display !== void 0 ? display : "block";
}, function(param) {
    var cursor = param.cursor;
    return cursor !== null && cursor !== void 0 ? cursor : "auto";
}, function(param) {
    var gap = param.gap;
    return gap !== null && gap !== void 0 ? gap : "".concat(ui.theme.space.x2);
}, function(param) {
    var display = param.display, flexDirection = param.flexDirection, justifyContent = param.justifyContent, alignItems = param.alignItems;
    return display === "flex" ? (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), flexDirection, justifyContent, alignItems) : "";
});
var CheckboxSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__CheckboxSpan",
    componentId: "sc-c66883d7-2"
})(_templateObject3(), function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : "".concat(ui.theme.colors.neutral[550]);
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "".concat(ui.theme.typography.fontSize.sm.x5);
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight !== null && fontWeight !== void 0 ? fontWeight : "".concat(ui.theme.typography.fontWeight[400]);
}, function(param) {
    var fontFamily = param.fontFamily;
    return fontFamily !== null && fontFamily !== void 0 ? fontFamily : "".concat(ui.theme.typography.fontFamily.chivo);
}, function(param) {
    var cursor = param.cursor;
    return cursor !== null && cursor !== void 0 ? cursor : "pointer";
});
var StyledCheckbox = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "style__StyledCheckbox",
    componentId: "sc-c66883d7-3"
})(_templateObject6(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "1.6em";
}, function(param) {
    var height = param.height;
    return height !== null && height !== void 0 ? height : "1.6em";
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius !== null && borderRadius !== void 0 ? borderRadius : "".concat(ui.theme.space["x0.5"]);
}, ui.theme.space.xpx, function(param) {
    var borderColor = param.borderColor;
    return borderColor !== null && borderColor !== void 0 ? borderColor : "".concat(ui.theme.colors.neutral[300]);
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
}, ui.theme.space.xpx, function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui.theme.colors.primary[200];
}, ui.theme.space.xpx, function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui.theme.colors.primary[200];
}, function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui.theme.colors.primary[200];
}, function(param) {
    var sizeChecked = param.sizeChecked;
    return sizeChecked !== null && sizeChecked !== void 0 ? sizeChecked : "1.5em";
}, ui.theme.colors.neutral.white, function(param) {
    var left = param.left;
    return left !== null && left !== void 0 ? left : "2px";
}, function(param) {
    var widthChecked = param.widthChecked;
    return widthChecked !== null && widthChecked !== void 0 ? widthChecked : "11px";
}, function(param) {
    var heightChecked = param.heightChecked;
    return heightChecked !== null && heightChecked !== void 0 ? heightChecked : "11px";
}, function(param) {
    var isRounded = param.isRounded;
    return isRounded && (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), ui.theme.colors.neutral.white, ui.theme.space.x3, ui.theme.space.x3, ui.theme.device.desktopFirst.mobileXL);
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
});
var CheckboxContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__CheckboxContent",
    componentId: "sc-c66883d7-4"
})(_templateObject7());

;// CONCATENATED MODULE: ../../packages/components/Form/Checkbox/index.tsx







var Checkbox = function(_param) {
    var id = _param.id, register = _param.register, required = _param.required, name = _param.name, label = _param.label, checked = _param.checked, onBlur = _param.onBlur, isCheckedEvent = _param.isCheckedEvent, width = _param.width, height = _param.height, borderColor = _param.borderColor, borderRadius = _param.borderRadius, left = _param.left, sizeChecked = _param.sizeChecked, widthChecked = _param.widthChecked, heightChecked = _param.heightChecked, display = _param.display, alignItems = _param.alignItems, gap = _param.gap, flexDirection = _param.flexDirection, justifyContent = _param.justifyContent, cursor = _param.cursor, optionComponent = _param.optionComponent, onChange = _param.onChange, checkboxWrapperWidth = _param.checkboxWrapperWidth, isRounded = _param.isRounded, backgroundColor = _param.backgroundColor, labelColor = _param.labelColor, labelWeight = _param.labelWeight, props = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "register",
        "required",
        "name",
        "label",
        "checked",
        "onBlur",
        "isCheckedEvent",
        "width",
        "height",
        "borderColor",
        "borderRadius",
        "left",
        "sizeChecked",
        "widthChecked",
        "heightChecked",
        "display",
        "alignItems",
        "gap",
        "flexDirection",
        "justifyContent",
        "cursor",
        "optionComponent",
        "onChange",
        "checkboxWrapperWidth",
        "isRounded",
        "backgroundColor",
        "labelColor",
        "labelWeight"
    ]);
    var ref = (0,react.useState)(Boolean(checked)), isChecked = ref[0], setIsChecked = ref[1];
    var handleCheckboxState = (0,react.useCallback)(function() {
        setIsChecked(function(prev) {
            return !prev;
        });
        if (isCheckedEvent) isCheckedEvent(!isChecked);
    }, [
        isChecked,
        isCheckedEvent
    ]);
    (0,react.useEffect)(function() {
        setIsChecked(Boolean(checked));
    }, [
        checked
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        checkboxWrapperWidth: checkboxWrapperWidth,
        cursor: cursor
    }, (0,application/* buildTestIds */.Fek)("checkbox-wrapper")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckboxContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckboxLabel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    display: display,
                    alignItems: alignItems,
                    gap: gap,
                    flexDirection: flexDirection !== null && flexDirection !== void 0 ? flexDirection : "row",
                    justifyContent: justifyContent !== null && justifyContent !== void 0 ? justifyContent : "start",
                    cursor: cursor !== null && cursor !== void 0 ? cursor : "auto"
                }, (0,application/* buildTestIds */.Fek)("checkbox-label")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheckbox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("styled-checkbox")), {
                            width: width,
                            borderColor: borderColor,
                            borderRadius: borderRadius,
                            height: height,
                            sizeChecked: sizeChecked,
                            widthChecked: widthChecked,
                            left: left,
                            heightChecked: heightChecked,
                            id: id,
                            checked: isChecked,
                            backgroundColor: backgroundColor
                        }), props, register(name, {
                            required: required
                        })), {
                            onChange: onChange || handleCheckboxState,
                            onBlur: onBlur,
                            isRounded: isRounded
                        })),
                        label && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxSpan, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            color: labelColor,
                            fontWeight: labelWeight
                        }, (0,application/* buildTestIds */.Fek)("checkbox-span")), {
                            children: label
                        }))
                    ]
                })),
                optionComponent
            ]
        })
    }));
};
/* harmony default export */ var Form_Checkbox = (Checkbox);


/***/ }),

/***/ 67803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form_FieldError; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/Form/FieldError/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-size: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledFieldError = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__StyledFieldError",
    componentId: "sc-7ca764bd-0"
})(_templateObject(), function(param) {
    var color = param.color;
    return color || ui.theme.colors.primary[200];
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize || ui.theme.typography.fontSize.sm.x3;
}, function(param) {
    var padding = param.padding;
    return padding || "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x2);
});

;// CONCATENATED MODULE: ../../packages/components/Form/FieldError/index.tsx






var FieldError = function(_param) {
    var text = _param.text, props = (0,_object_without_properties/* default */.Z)(_param, [
        "text"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFieldError, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("styled-field-error-".concat((0,application/* formatTestId */.c$e)(text))), props), {
        children: text
    }));
};
/* harmony default export */ var Form_FieldError = (FieldError);


/***/ }),

/***/ 97268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ FieldInfo; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/Form/FieldInfo/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledFieldInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__StyledFieldInfo",
    componentId: "sc-6e64eb80-0"
})(_templateObject(), function(param) {
    var color = param.color;
    return color || ui.theme.colors.neutral[450];
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize || ui.theme.typography.fontSize.sm.x3;
}, function(param) {
    var padding = param.padding;
    return padding || "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x2);
});


;// CONCATENATED MODULE: ../../packages/components/Form/FieldInfo/index.tsx





var FieldInfo = function(_param) {
    var text = _param.text, props = (0,_object_without_properties/* default */.Z)(_param, [
        "text"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFieldInfo, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: text
    }));
};



/***/ }),

/***/ 59556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form_Input; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/react-input-mask/index.js
var react_input_mask = __webpack_require__(98738);
var react_input_mask_default = /*#__PURE__*/__webpack_require__.n(react_input_mask);
// EXTERNAL MODULE: ../../packages/components/Form/FieldError/index.tsx + 1 modules
var FieldError = __webpack_require__(67803);
// EXTERNAL MODULE: ../../packages/components/Form/FieldInfo/index.tsx + 1 modules
var FieldInfo = __webpack_require__(97268);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/Form/Input/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      pointer-events: none;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-color: ",
        " !important;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border-radius: ",
        " ",
        " ",
        "\n              ",
        ";\n            border-right: 1px solid ",
        " !important;\n          "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border-radius: ",
        " ",
        " ",
        "\n              ",
        ";\n            border-right: none !important;\n          "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n\n  ",
        "\n\n  input {\n    width: ",
        ";\n    height: ",
        ";\n    padding: ",
        ";\n    margin: ",
        ";\n    border: ",
        ";\n    border-radius: ",
        ";\n    border-width: ",
        ";\n    background-color: ",
        ";\n    border-color: ",
        ";\n\n    &::placeholder {\n      color: ",
        " !important;\n      font-size: ",
        ";\n    }\n\n    ",
        "\n\n    border-color: ",
        ";\n    box-sizing: border-box;\n\n    &:focus {\n      outline: none;\n    }\n\n    &:hover {\n      color: ",
        " !important;\n    }\n\n    @media ",
        " {\n      &:hover {\n        border: ",
        ";\n      }\n    }\n\n    ",
        "\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-color: ",
        " !important;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  min-width: 40px;\n  max-width: 40px;\n  width: 100%;\n  cursor: ",
        ";\n  border-left: none;\n  margin: ",
        ";\n\n  border-width: 1px 1px 1px 0;\n  border-style: solid;\n  border-color: ",
        ";\n  border-radius: 0px 4px 4px 0px;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      pointer-events: none;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: flex;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n\n  input {\n    &: hover {\n      color: initial !important;\n    }\n  }\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var StyledInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__StyledInput",
    componentId: "sc-1521c2b1-0"
})(_templateObject5(), function(param) {
    var width = param.width;
    return width || "initial";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
}, function(param) {
    var width = param.width;
    return width || "initial";
}, function(param) {
    var height = param.height;
    return height || "auto";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "".concat(ui.theme.space.x4, " ").concat(ui.theme.space.x5);
}, function(param) {
    var margin = param.margin;
    return margin || "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0);
}, "".concat(ui.theme.space.xpx, " solid ").concat(ui.theme.colors.neutral[200]), function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius || "".concat(ui.theme.space.x2);
}, function(param) {
    var borderWidth = param.borderWidth;
    return borderWidth || "".concat(ui.theme.space.xpx);
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
}, function(param) {
    var borderColor = param.borderColor;
    return borderColor;
}, function(param) {
    var color = param.color;
    return color;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var hasSuccessfully = param.hasSuccessfully;
    return hasSuccessfully && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), ui.theme.colors.secondary[200]);
}, function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[200];
}, function(param) {
    var color = param.color;
    return color;
}, ui.theme.device.desktopFirst.mobileL, function(param) {
    var hasError = param.hasError, borderColor = param.borderColor;
    return "1px solid ".concat(hasError ? ui.theme.colors.primary[200] : borderColor || "none");
}, function(param) {
    var hasIcon = param.hasIcon, hasIconBorder = param.hasIconBorder;
    return hasIcon && hasIconBorder ? (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), ui.theme.space.x1, ui.theme.space.x0, ui.theme.space.x0, ui.theme.space.x1, ui.theme.colors.neutral[580]) : hasIcon && !hasIconBorder ? (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), ui.theme.space.x1, ui.theme.space.x0, ui.theme.space.x0, ui.theme.space.x1) : (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
});
var IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__IconContainer",
    componentId: "sc-1521c2b1-1"
})(_templateObject7(), function(param) {
    var cursor = param.cursor;
    return cursor || "pointer";
}, function(param) {
    var margin = param.margin;
    return margin || "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0);
}, function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[580];
}, function(param) {
    var hasSuccessfully = param.hasSuccessfully;
    return hasSuccessfully && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), ui.theme.colors.secondary[200]);
});
var InputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__InputContainer",
    componentId: "sc-1521c2b1-2"
})(_templateObject10(), function(param) {
    var width = param.width;
    return width || "initial";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject8());
}, function(param) {
    var hasIcon = param.hasIcon;
    return hasIcon && (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
});

;// CONCATENATED MODULE: ../../packages/components/Form/Input/index.tsx









var Input = function(_param) {
    var id = _param.id, type = _param.type, mask = _param.mask, _maskChar = _param.maskChar, maskChar = _maskChar === void 0 ? "_" : _maskChar, label = _param.label, padding = _param.padding, paddingErrorMessage = _param.paddingErrorMessage, hasError = _param.hasError, hasSuccessfully = _param.hasSuccessfully, width = _param.width, color = _param.color, fontSize = _param.fontSize, borderRadius = _param.borderRadius, borderWidth = _param.borderWidth, hasIcon = _param.hasIcon, autoComplete = _param.autoComplete, margin = _param.margin, register = _param.register, setValue = _param.setValue, _hasIconBorder = _param.hasIconBorder, hasIconBorder = _hasIconBorder === void 0 ? true : _hasIconBorder, onChange = _param.onChange, onBlur = _param.onBlur, required = _param.required, pattern = _param.pattern, minLength = _param.minLength, maxLength = _param.maxLength, name = _param.name, textError = _param.textError, textInfo = _param.textInfo, paddingInfo = _param.paddingInfo, max = _param.max, onKeyUp = _param.onKeyUp, onKeyDown = _param.onKeyDown, inputMode = _param.inputMode, onMouseOver = _param.onMouseOver, height = _param.height, onClickIcon = _param.onClickIcon, icon = _param.icon, backgroundColor = _param.backgroundColor, fontSizeInfo = _param.fontSizeInfo, colorInfo = _param.colorInfo, cursor = _param.cursor, disabled = _param.disabled, borderColor = _param.borderColor, ref = _param.ref, value = _param.value, props = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "type",
        "mask",
        "maskChar",
        "label",
        "padding",
        "paddingErrorMessage",
        "hasError",
        "hasSuccessfully",
        "width",
        "color",
        "fontSize",
        "borderRadius",
        "borderWidth",
        "hasIcon",
        "autoComplete",
        "margin",
        "register",
        "setValue",
        "hasIconBorder",
        "onChange",
        "onBlur",
        "required",
        "pattern",
        "minLength",
        "maxLength",
        "name",
        "textError",
        "textInfo",
        "paddingInfo",
        "max",
        "onKeyUp",
        "onKeyDown",
        "inputMode",
        "onMouseOver",
        "height",
        "onClickIcon",
        "icon",
        "backgroundColor",
        "fontSizeInfo",
        "colorInfo",
        "cursor",
        "disabled",
        "borderColor",
        "ref",
        "value"
    ]);
    var handleClick = function(e) {
        if (type !== "tel") return;
        var input = e.target;
        var selectionStart = input.selectionStart;
        var emptyInputWithMask = /^\(_{2}\) _{5}-_{4}$/;
        var hasAnyInputNumber = input.selectionStart !== 0 && emptyInputWithMask.test(input.value);
        if (hasAnyInputNumber) {
            input.setSelectionRange(1, 0);
        } else {
            var newPosition = selectionStart && selectionStart > 0 ? selectionStart : 0;
            input.setSelectionRange(newPosition, newPosition);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hasSuccessfully: hasSuccessfully,
        hasError: hasError,
        width: width || "initial",
        height: height,
        hasIcon: hasIcon,
        borderRadius: borderRadius,
        borderWidth: borderWidth,
        borderColor: borderColor,
        padding: padding,
        margin: margin,
        color: color,
        fontSize: fontSize,
        backgroundColor: backgroundColor,
        hasIconBorder: hasIconBorder
    }, (0,application/* buildTestIds */.Fek)("form-styled-input-".concat(id))), {
        isDisabled: disabled,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                htmlFor: id
            }, (0,application/* buildTestIds */.Fek)("form-input-label-".concat(id))), {
                children: label
            })),
            mask ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-container-mask-".concat(id))), {
                        width: width,
                        hasIcon: hasIcon,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_input_mask_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-mask-".concat(id))), {
                                mask: mask,
                                id: id,
                                type: type || "text",
                                maskChar: maskChar,
                                value: value,
                                inputMode: inputMode,
                                autoComplete: autoComplete
                            }), props, setValue, register(String(name), {
                                required: required,
                                pattern: pattern,
                                minLength: minLength,
                                maxLength: maxLength
                            })), {
                                ref: ref,
                                onChange: onChange,
                                onKeyDown: onKeyDown,
                                onBlur: onBlur,
                                onMouseOver: onMouseOver,
                                onClick: handleClick
                            })),
                            hasIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                cursor: cursor,
                                hasSuccessfully: hasSuccessfully,
                                margin: margin,
                                hasError: hasError,
                                onClick: onClickIcon,
                                children: icon
                            })
                        ]
                    })),
                    textError && hasError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldError/* default */.Z, {
                        text: textError,
                        padding: paddingErrorMessage,
                        fontSize: fontSizeInfo,
                        "data-cy": "error-".concat(id),
                        "data-testid": "form-field-error-input-".concat(id)
                    }) : null,
                    textInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInfo/* FieldInfo */.y, {
                        padding: paddingInfo,
                        text: textInfo,
                        fontSize: fontSizeInfo,
                        color: colorInfo,
                        "data-cy": "info-".concat(id),
                        "data-testid": "form-field-info-input-".concat(id)
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-container-".concat(id))), {
                        width: width,
                        hasIcon: hasIcon,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                autoComplete: autoComplete,
                                height: height,
                                id: id,
                                value: value
                            }, (0,application/* buildTestIds */.Fek)("form-input-".concat(id))), {
                                type: type || "text",
                                inputMode: inputMode
                            }), props, setValue, register(String(name), {
                                required: required,
                                pattern: pattern,
                                minLength: minLength,
                                maxLength: maxLength
                            })), {
                                onChange: onChange,
                                onKeyUp: onKeyUp,
                                onKeyDown: onKeyDown,
                                onBlur: onBlur,
                                maxLength: maxLength,
                                max: max,
                                disabled: disabled,
                                onClick: handleClick
                            })),
                            hasIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                cursor: cursor,
                                hasSuccessfully: hasSuccessfully,
                                margin: margin,
                                hasError: hasError,
                                onClick: onClickIcon,
                                children: icon
                            })
                        ]
                    })),
                    textError && hasError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldError/* default */.Z, {
                        text: textError,
                        "data-cy": "error-".concat(id),
                        padding: paddingErrorMessage,
                        fontSize: fontSizeInfo,
                        "data-testid": "form-field-error-input-".concat(id)
                    }) : null,
                    textInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInfo/* FieldInfo */.y, {
                        text: textInfo,
                        "data-cy": "info-".concat(id),
                        fontSize: fontSizeInfo,
                        color: colorInfo,
                        "data-testid": "form-field-info-input-".concat(id),
                        padding: paddingInfo
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Form_Input = (Input);


/***/ }),

/***/ 3355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form_Label; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/Form/Label/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  display: ",
        " !important;\n  justify-content: ",
        " !important;\n  padding-left: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        " !important;\n  justify-content: ",
        " !important;\n  flex-direction: row;\n  align-items: end;\n  gap: 0.5rem;\n  max-width: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  letter-spacing: -0.2px;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "style__StyledLabel",
    componentId: "sc-d4bc8027-0"
})(_templateObject(), function(param) {
    var color = param.color;
    return color || ui.theme.colors.neutral[999];
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var display = param.display;
    return display;
}, function(param) {
    var justifyContent = param.justifyContent;
    return justifyContent;
}, function(param) {
    var paddingLeft = param.paddingLeft;
    return paddingLeft || "initial";
}, function(param) {
    var typeFontFamily = param.typeFontFamily;
    return typeFontFamily || ui.theme.typography.fontFamily.chivo;
}, function(param) {
    var typeFontWeight = param.typeFontWeight;
    return typeFontWeight || ui.theme.typography.fontWeight[500];
});
var LabelContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "style__LabelContainer",
    componentId: "sc-d4bc8027-1"
})(_templateObject1(), function(param) {
    var display = param.display;
    return display;
}, function(param) {
    var justifyContent = param.justifyContent;
    return justifyContent;
}, function(param) {
    var maxWidth = param.maxWidth;
    return maxWidth || "initial";
});
var OptionalText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__OptionalText",
    componentId: "sc-d4bc8027-2"
})(_templateObject2(), ui.theme.colors.neutral[585], ui.theme.typography.fontSize.sm.x1, ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[400]);
var RequiredFieldSignal = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__RequiredFieldSignal",
    componentId: "sc-d4bc8027-3"
})(_templateObject3(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[600], ui.theme.colors.primary[225]);

;// CONCATENATED MODULE: ../../packages/components/Form/Label/index.tsx







var Label = function(_param) {
    var text = _param.text, _hasSuccessfully = _param.hasSuccessfully, hasSuccessfully = _hasSuccessfully === void 0 ? false : _hasSuccessfully, color = _param.color, fontSize = _param.fontSize, display = _param.display, justifyContent = _param.justifyContent, paddingLeft = _param.paddingLeft, maxWidth = _param.maxWidth, typeFontFamily = _param.typeFontFamily, typeFontWeight = _param.typeFontWeight, showOptionalText = _param.showOptionalText, children = _param.children, isRequired = _param.isRequired, props = (0,_object_without_properties/* default */.Z)(_param, [
        "text",
        "hasSuccessfully",
        "color",
        "fontSize",
        "display",
        "justifyContent",
        "paddingLeft",
        "maxWidth",
        "typeFontFamily",
        "typeFontWeight",
        "showOptionalText",
        "children",
        "isRequired"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        display: "flex",
        justifyContent: justifyContent,
        maxWidth: maxWidth
    }, props, (0,application/* buildTestIds */.Fek)("label-container-".concat(text))), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                paddingLeft: paddingLeft,
                typeFontFamily: typeFontFamily,
                color: color,
                fontSize: fontSize,
                display: display,
                justifyContent: justifyContent,
                typeFontWeight: typeFontWeight
            }, props, (0,application/* buildTestIds */.Fek)("form-label-".concat(text !== null && text !== void 0 ? text : "label"))), {
                children: children || text
            })),
            isRequired && !hasSuccessfully && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredFieldSignal, {
                children: "*"
            }),
            hasSuccessfully && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CheckDone, (0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("check-done-icon"))),
            showOptionalText && !hasSuccessfully && !isRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionalText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("optional-text")), {
                children: "Opcional"
            }))
        ]
    }));
};
/* harmony default export */ var Form_Label = (Label);


/***/ }),

/***/ 29043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XZ": function() { return /* reexport */ Checkbox/* default */.Z; },
  "AP": function() { return /* reexport */ CustomSelect; },
  "yx": function() { return /* reexport */ FieldInfo/* FieldInfo */.y; },
  "l0": function() { return /* binding */ Form; },
  "II": function() { return /* reexport */ Input/* default */.Z; },
  "__": function() { return /* reexport */ Label/* default */.Z; },
  "Xx": function() { return /* reexport */ MonetaryInput; },
  "xg": function() { return /* reexport */ NewCustomInput; },
  "Kx": function() { return /* reexport */ Form_TextArea; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/components/Form/Checkbox/index.tsx + 1 modules
var Checkbox = __webpack_require__(47852);
// EXTERNAL MODULE: ../../packages/components/Form/Input/index.tsx + 1 modules
var Input = __webpack_require__(59556);
// EXTERNAL MODULE: ../../packages/components/Form/Label/index.tsx + 1 modules
var Label = __webpack_require__(3355);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/components/Form/FieldError/index.tsx + 1 modules
var FieldError = __webpack_require__(67803);
// EXTERNAL MODULE: ../../packages/components/Form/FieldInfo/index.tsx + 1 modules
var FieldInfo = __webpack_require__(97268);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/Form/TextArea/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-color: ",
        " !important;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  textarea {\n    width: ",
        ";\n    padding: ",
        ";\n    margin: ",
        " ",
        ";\n    border: ",
        ";\n    border-radius: ",
        ";\n\n    ",
        "\n\n    border-color: ",
        ";\n    border-color: ",
        ";\n    box-sizing: border-box;\n    resize: none;\n\n    &:focus {\n      outline: none;\n    }\n\n    @media ",
        " {\n      &:hover {\n        border: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__StyledInput",
    componentId: "sc-56534ec-0"
})(_templateObject1(), function(param) {
    var width = param.width;
    return width || "initial";
}, function(param) {
    var width = param.width;
    return width || "initial";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "".concat(ui.theme.space.x4, " ").concat(ui.theme.space.x5);
}, ui.theme.space.x2, ui.theme.space.x0, "".concat(ui.theme.space.xpx, " solid ").concat(ui.theme.colors.neutral[200]), ui.theme.space.x2, function(param) {
    var hasSuccessfully = param.hasSuccessfully;
    return hasSuccessfully && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), ui.theme.colors.secondary[200]);
}, ui.theme.colors.neutral[200], function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[200];
}, ui.theme.device.desktopFirst.mobileL, function(param) {
    var hasError = param.hasError;
    return "".concat(ui.theme.space["x0.5"], " solid ").concat(hasError ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[999]);
});

;// CONCATENATED MODULE: ../../packages/components/Form/TextArea/index.tsx







var TextArea = function(_param) {
    var id = _param.id, label = _param.label, padding = _param.padding, paddingErrorMessage = _param.paddingErrorMessage, hasError = _param.hasError, hasSuccessfully = _param.hasSuccessfully, width = _param.width, register = _param.register, setValue = _param.setValue, onChange = _param.onChange, onBlur = _param.onBlur, required = _param.required, pattern = _param.pattern, minLength = _param.minLength, maxLength = _param.maxLength, name = _param.name, textError = _param.textError, textInfo = _param.textInfo, onKeyUp = _param.onKeyUp, onKeyDown = _param.onKeyDown, props = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "label",
        "padding",
        "paddingErrorMessage",
        "hasError",
        "hasSuccessfully",
        "width",
        "register",
        "setValue",
        "onChange",
        "onBlur",
        "required",
        "pattern",
        "minLength",
        "maxLength",
        "name",
        "textError",
        "textInfo",
        "onKeyUp",
        "onKeyDown"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInput, {
        hasSuccessfully: hasSuccessfully,
        hasError: hasError,
        width: width || "initial",
        padding: padding,
        "data-testid": "form-styled-input-".concat(id),
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: id,
                "data-testid": "form-input-label-".concat(id),
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        id: id,
                        "data-testid": "form-input-".concat(id)
                    }, props, setValue, register(name, {
                        required: required,
                        pattern: pattern,
                        minLength: minLength,
                        maxLength: maxLength
                    })), {
                        onChange: onChange,
                        onKeyUp: onKeyUp,
                        onKeyDown: onKeyDown,
                        onBlur: onBlur
                    })),
                    textError && hasError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldError/* default */.Z, {
                        text: textError,
                        "data-cy": "error-".concat(id),
                        "data-testid": "form-field-error-input-".concat(id)
                    }) : null,
                    textInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInfo/* FieldInfo */.y, {
                        text: textInfo,
                        "data-cy": "info-".concat(id),
                        "data-testid": "form-field-info-input-".concat(id),
                        padding: paddingErrorMessage
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var Form_TextArea = (TextArea);

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
;// CONCATENATED MODULE: ../../packages/components/Form/CustomSelect/style.ts

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      pointer-events: none;\n    "
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-color: ",
        " !important;\n      "
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border-radius: ",
        " ",
        " ",
        "\n              ",
        ";\n            border-right: 1px solid ",
        " !important;\n          "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border-radius: ",
        " ",
        " ",
        "\n              ",
        ";\n            border-right: none !important;\n          "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  max-width: ",
        ";\n  ",
        "\n\n  select {\n    width: ",
        ";\n    height: ",
        ";\n    max-width: ",
        ";\n    padding: ",
        ";\n    margin: ",
        ";\n    border: ",
        ";\n    border-radius: ",
        ";\n    border-width: ",
        ";\n    background-color: ",
        ";\n    border-color: ",
        ";\n\n    &::placeholder {\n      color: ",
        " !important;\n      font-size: ",
        ";\n    }\n\n    ",
        "\n\n    border-color: ",
        ";\n    box-sizing: border-box;\n\n    &:focus {\n      outline: none;\n    }\n\n    &:hover {\n      color: ",
        " !important;\n    }\n\n    @media ",
        " {\n      &:hover {\n        border: ",
        ";\n      }\n    }\n\n    ",
        "\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-color: ",
        " !important;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  min-width: 40px;\n  max-width: 40px;\n  width: 100%;\n  cursor: ",
        ";\n  border-left: none;\n  margin: ",
        ";\n\n  border-width: 1px 1px 1px 0;\n  border-style: solid;\n  border-color: ",
        ";\n  border-radius: 0px 4px 4px 0px;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      pointer-events: none;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: flex;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n\n  select {\n    hover {\n      color: initial !important;\n    }\n  }\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var StyledSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__StyledSelect",
    componentId: "sc-63aea39b-0"
})(_templateObject5(), function(param) {
    var width = param.width;
    return width ? "100%" : "initial";
}, function(param) {
    var width = param.width;
    return width || "200px";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(style_templateObject());
}, function(param) {
    var width = param.width;
    return width ? "100%" : "initial";
}, function(param) {
    var height = param.height;
    return height || "auto";
}, function(param) {
    var width = param.width;
    return width || "initial";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "".concat(ui.theme.space.x4, " ").concat(ui.theme.space.x5);
}, function(param) {
    var margin = param.margin;
    return margin || "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0);
}, "".concat(ui.theme.space.xpx, " solid ").concat(ui.theme.colors.neutral[200]), function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius || "".concat(ui.theme.space.x2);
}, function(param) {
    var borderWidth = param.borderWidth;
    return borderWidth || "".concat(ui.theme.space.xpx);
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "transparent";
}, function(param) {
    var borderColor = param.borderColor;
    return borderColor;
}, function(param) {
    var color = param.color;
    return color;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var hasSuccessfully = param.hasSuccessfully;
    return hasSuccessfully && (0,styled_components_browser_esm/* css */.iv)(style_templateObject1(), ui.theme.colors.secondary[200]);
}, function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[200];
}, function(param) {
    var color = param.color;
    return color;
}, ui.theme.device.desktopFirst.mobileL, function(param) {
    var hasError = param.hasError, borderColor = param.borderColor;
    return "1px solid ".concat(hasError ? ui.theme.colors.primary[200] : borderColor !== null && borderColor !== void 0 ? borderColor : "none");
}, function(param) {
    var hasIcon = param.hasIcon, hasIconBorder = param.hasIconBorder;
    return hasIcon && hasIconBorder ? (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), ui.theme.space.x1, ui.theme.space.x0, ui.theme.space.x0, ui.theme.space.x1, ui.theme.colors.neutral[580]) : hasIcon && !hasIconBorder ? (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), ui.theme.space.x1, ui.theme.space.x0, ui.theme.space.x0, ui.theme.space.x1) : (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
});
var IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__IconContainer",
    componentId: "sc-63aea39b-1"
})(_templateObject7(), function(param) {
    var cursor = param.cursor;
    return cursor !== null && cursor !== void 0 ? cursor : "pointer";
}, function(param) {
    var margin = param.margin;
    return margin !== null && margin !== void 0 ? margin : "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0);
}, function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[580];
}, function(param) {
    var hasSuccessfully = param.hasSuccessfully;
    return hasSuccessfully && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), ui.theme.colors.secondary[200]);
});
var SelectContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__SelectContainer",
    componentId: "sc-63aea39b-2"
})(_templateObject10(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "initial";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject8());
}, function(param) {
    var hasIcon = param.hasIcon;
    return hasIcon && (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
});
var Select = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    displayName: "style__Select",
    componentId: "sc-63aea39b-3"
})(_templateObject11());
var Option = styled_components_browser_esm/* default.option.withConfig */.ZP.option.withConfig({
    displayName: "style__Option",
    componentId: "sc-63aea39b-4"
})(_templateObject12());

;// CONCATENATED MODULE: ../../packages/components/Form/CustomSelect/index.tsx











var CustomSelect = function(props) {
    var ref, ref1, ref2;
    var name = props.name, autoComplete = props.autoComplete, backgroundColor = props.backgroundColor, borderColor = props.borderColor, borderRadius = props.borderRadius, borderWidth = props.borderWidth, color = props.color, colorInfo = props.colorInfo, cursor = props.cursor, fontSize = props.fontSize, fontSizeInfo = props.fontSizeInfo, hasError = props.hasError, hasIcon = props.hasIcon, hasIconBorder = props.hasIconBorder, hasSuccessfully = props.hasSuccessfully, icon = props.icon, label = props.label, margin = props.margin, onClickIcon = props.onClickIcon, padding = props.padding, paddingErrorMessage = props.paddingErrorMessage, paddingInfo = props.paddingInfo, textError = props.textError, textInfo = props.textInfo, width = props.width, control = props.control, defaultValue = props.defaultValue, required = props.required, rules = props.rules, shouldUnregister = props.shouldUnregister, disabled = props.disabled, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseOut = props.onMouseOut, onMouseOver = props.onMouseOver, placeholder = props.placeholder, role = props.role, value = props.value, height = props.height, id = props.id, ref3 = props.ref, showOptionalText = props.showOptionalText, optionsList = props.optionsList, deps = props.deps, limit = props.limit, multiple = props.multiple;
    var requiredText = (0,react.useMemo)(function() {
        return typeof required === "string" ? required : "Campo obrigat\xf3rio";
    }, [
        required
    ]);
    var ref4 = (0,index_esm/* useController */.bc)({
        name: name,
        control: control,
        defaultValue: defaultValue,
        rules: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rules), {
            required: {
                value: required,
                message: requiredText
            },
            onChange: onChange,
            onBlur: onBlur,
            shouldUnregister: shouldUnregister,
            value: value,
            deps: deps
        }),
        shouldUnregister: shouldUnregister
    }), field = ref4.field, fieldState = ref4.fieldState;
    var hasSuccessState = (0,react.useMemo)(function() {
        return hasSuccessfully || Boolean(field.value);
    }, [
        field.value,
        hasSuccessfully
    ]);
    var hasErrorState = (0,react.useMemo)(function() {
        return Boolean(hasError || Boolean(fieldState.error || fieldState.invalid)) && !hasSuccessState;
    }, [
        fieldState.error,
        fieldState.invalid,
        hasError,
        hasSuccessState
    ]);
    var ref5, ref6;
    var errorMessageText = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        return (ref6 = (ref5 = textError !== null && textError !== void 0 ? textError : (ref = fieldState.error) === null || ref === void 0 ? void 0 : (ref1 = ref.root) === null || ref1 === void 0 ? void 0 : ref1.message) !== null && ref5 !== void 0 ? ref5 : (ref2 = fieldState.error) === null || ref2 === void 0 ? void 0 : ref2.message) !== null && ref6 !== void 0 ? ref6 : requiredText;
    }, [
        (ref = fieldState.error) === null || ref === void 0 ? void 0 : ref.message,
        (ref1 = fieldState.error) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.root) === null || ref2 === void 0 ? void 0 : ref2.message,
        requiredText,
        textError, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hasSuccessfully: hasSuccessState,
        hasError: hasErrorState,
        width: width,
        height: height,
        hasIcon: hasIcon,
        borderRadius: borderRadius,
        borderWidth: borderWidth,
        borderColor: borderColor,
        padding: padding,
        margin: margin,
        color: color,
        fontSize: fontSize,
        backgroundColor: backgroundColor,
        hasIconBorder: hasIconBorder
    }, (0,application/* buildTestIds */.Fek)("form-styled-select-".concat(id))), {
        isDisabled: disabled,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, (0,_object_spread/* default */.Z)({
                text: label,
                isRequired: Boolean(required),
                hasSuccessfully: hasSuccessState,
                htmlFor: id,
                showOptionalText: showOptionalText,
                typeFontWeight: 400
            }, (0,application/* buildTestIds */.Fek)("form-select-label-".concat(id)))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectContainer, {
                width: width,
                hasIcon: hasIcon,
                children: [
                    hasIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        cursor: cursor,
                        hasSuccessfully: hasSuccessfully,
                        margin: margin,
                        hasError: hasError,
                        onClick: onClickIcon
                    }, (0,application/* buildTestIds */.Fek)("form-icon-container-".concat(id))), {
                        children: icon
                    })),
                    /*#__PURE__*/ (0,react.createElement)(Select, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                        id: id,
                        autoComplete: autoComplete,
                        onChange: function(e) {
                            if (onChange) onChange(e);
                            if (field) field.onChange(e);
                        },
                        onBlur: function(e) {
                            if (onBlur) onBlur(e);
                            if (field) field.onBlur();
                        },
                        onMouseOut: onMouseOut,
                        onMouseOver: onMouseOver,
                        onFocus: onFocus,
                        required: Boolean(required),
                        disabled: disabled,
                        placeholder: placeholder,
                        role: role,
                        value: value || field.value,
                        key: id,
                        ref: ref3,
                        multiple: multiple,
                        size: limit
                    }), (0,application/* buildTestIds */.Fek)("form-select-".concat(id))), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                value: "",
                                children: placeholder !== null && placeholder !== void 0 ? placeholder : "Selecione uma op\xe7\xe3o"
                            }, 0),
                            optionsList.map(function(option) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                    value: option.value,
                                    children: option.label
                                }, option.index);
                            })
                        ]
                    }))
                ]
            }),
            errorMessageText && hasErrorState && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldError/* default */.Z, (0,_object_spread/* default */.Z)({
                text: errorMessageText,
                padding: paddingErrorMessage,
                fontSize: fontSizeInfo
            }, (0,application/* buildTestIds */.Fek)("form-field-error-select-".concat(id)))),
            textInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInfo/* FieldInfo */.y, (0,_object_spread/* default */.Z)({
                padding: paddingInfo,
                text: textInfo,
                fontSize: fontSizeInfo,
                color: colorInfo
            }, (0,application/* buildTestIds */.Fek)("form-field-info-select-".concat(id))))
        ]
    }));
};

;// CONCATENATED MODULE: ../../packages/components/Form/MonetaryInput/style.ts

function MonetaryInput_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      pointer-events: none;\n    "
    ]);
    MonetaryInput_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MonetaryInput_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: flex;\n    "
    ]);
    MonetaryInput_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: fit-content;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      pointer-events: none;\n    "
    ]);
    style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-radius: ",
        " ",
        " ",
        "\n          ",
        ";\n        border-right: 1px solid ",
        " !important;\n      "
    ]);
    style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        opacity: 0.5;\n        pointer-events: none;\n      "
    ]);
    style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-color: ",
        " !important;\n      "
    ]);
    style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n\n  ",
        "\n\n  input {\n    width: 100%;\n    height: ",
        ";\n    padding: ",
        ";\n    border-radius: ",
        ";\n    border: none;\n\n    &::placeholder {\n      color: ",
        ";\n      font-size: ",
        ";\n    }\n\n    &:focus {\n      outline: none;\n    }\n\n    @media ",
        " {\n      &:hover {\n        border: ",
        ";\n      }\n    }\n\n    ",
        "\n  }\n\n  ",
        " {\n    margin: ",
        ";\n    border: ",
        ";\n    border-radius: ",
        ";\n    background-color: ",
        ";\n    border-color: ",
        ";\n\n    ",
        "\n\n    ",
        "\n\n    border-color: ",
        ";\n  }\n"
    ]);
    style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-color: ",
        " !important;\n    "
    ]);
    style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function style_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  width: 40px;\n  cursor: ",
        ";\n  border-left: none;\n  margin: ",
        ";\n\n  border-width: 1px 1px 1px 0;\n  border-style: solid;\n  border-color: ",
        ";\n  border-radius: 0px 4px 4px 0px;\n\n  ",
        "\n"
    ]);
    style_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function style_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  color: ",
        ";\n"
    ]);
    style_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var InputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__InputContainer",
    componentId: "sc-c82bbb32-0"
})(style_templateObject2(), function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(MonetaryInput_style_templateObject());
}, function(param) {
    var hasIcon = param.hasIcon;
    return hasIcon && (0,styled_components_browser_esm/* css */.iv)(MonetaryInput_style_templateObject1());
});
var style_StyledInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__StyledInput",
    componentId: "sc-c82bbb32-1"
})(style_templateObject7(), function(param) {
    var width = param.width;
    return width || "initial";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(style_templateObject3());
}, function(param) {
    var height = param.height;
    return height || "auto";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "".concat(ui.theme.space["x3.5"], " ").concat(ui.theme.space.x5);
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius || "".concat(ui.theme.space.x2);
}, function(param) {
    var color = param.color;
    return color;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, ui.theme.device.desktopFirst.mobileL, function(param) {
    var hasError = param.hasError, borderColor = param.borderColor;
    return "1px solid ".concat(hasError ? ui.theme.colors.primary[200] : borderColor || "none");
}, function(param) {
    var hasIcon = param.hasIcon;
    return hasIcon && (0,styled_components_browser_esm/* css */.iv)(style_templateObject4(), ui.theme.space.x1, ui.theme.space.x0, ui.theme.space.x0, ui.theme.space.x1, ui.theme.colors.neutral[580]);
}, InputContainer, function(param) {
    var margin = param.margin;
    return margin || "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0);
}, "".concat(ui.theme.space.xpx, " solid ").concat(ui.theme.colors.neutral[200]), function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius || "".concat(ui.theme.space.x2);
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
}, function(param) {
    var borderColor = param.borderColor;
    return borderColor;
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(style_templateObject5());
}, function(param) {
    var hasSuccessfully = param.hasSuccessfully;
    return hasSuccessfully && (0,styled_components_browser_esm/* css */.iv)(style_templateObject6(), ui.theme.colors.secondary[200]);
}, function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[200];
});
var style_IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__IconContainer",
    componentId: "sc-c82bbb32-2"
})(style_templateObject9(), ui.theme.colors.neutral.white, function(param) {
    var cursor = param.cursor;
    return cursor || "pointer";
}, function(param) {
    var margin = param.margin;
    return margin || "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0);
}, function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[580];
}, function(param) {
    var hasSuccessfully = param.hasSuccessfully;
    return hasSuccessfully && (0,styled_components_browser_esm/* css */.iv)(style_templateObject8(), ui.theme.colors.secondary[200]);
});
var MonetaryPrefixWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__MonetaryPrefixWrapper",
    componentId: "sc-c82bbb32-3"
})(style_templateObject10(), ui.theme.colors.neutral[570]);

;// CONCATENATED MODULE: ../../packages/components/Form/MonetaryInput/index.tsx








var MonetaryInput = function(_param) {
    var id = _param.id, label = _param.label, padding = _param.padding, paddingErrorMessage = _param.paddingErrorMessage, hasError = _param.hasError, hasSuccessfully = _param.hasSuccessfully, width = _param.width, color = _param.color, fontSize = _param.fontSize, borderRadius = _param.borderRadius, hasIcon = _param.hasIcon, margin = _param.margin, register = _param.register, setValue = _param.setValue, onChange = _param.onChange, onBlur = _param.onBlur, required = _param.required, pattern = _param.pattern, minLength = _param.minLength, maxLength = _param.maxLength, name = _param.name, textError = _param.textError, textInfo = _param.textInfo, paddingInfo = _param.paddingInfo, max = _param.max, onKeyUp = _param.onKeyUp, onKeyDown = _param.onKeyDown, height = _param.height, backgroundColor = _param.backgroundColor, fontSizeInfo = _param.fontSizeInfo, colorInfo = _param.colorInfo, disabled = _param.disabled, borderColor = _param.borderColor, props = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "label",
        "padding",
        "paddingErrorMessage",
        "hasError",
        "hasSuccessfully",
        "width",
        "color",
        "fontSize",
        "borderRadius",
        "hasIcon",
        "margin",
        "register",
        "setValue",
        "onChange",
        "onBlur",
        "required",
        "pattern",
        "minLength",
        "maxLength",
        "name",
        "textError",
        "textInfo",
        "paddingInfo",
        "max",
        "onKeyUp",
        "onKeyDown",
        "height",
        "backgroundColor",
        "fontSizeInfo",
        "colorInfo",
        "disabled",
        "borderColor"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_StyledInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hasSuccessfully: hasSuccessfully,
        hasError: hasError,
        width: width,
        height: height,
        hasIcon: hasIcon,
        borderRadius: borderRadius,
        borderColor: borderColor,
        padding: padding,
        margin: margin,
        color: color,
        fontSize: fontSize,
        backgroundColor: backgroundColor
    }, (0,application/* buildTestIds */.Fek)("form-styled-input-".concat(id))), {
        isDisabled: disabled,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                htmlFor: id
            }, (0,application/* buildTestIds */.Fek)("form-input-label-".concat(id))), {
                children: label
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
                width: width,
                hasIcon: hasIcon,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MonetaryPrefixWrapper, {
                        children: "R$"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        height: height,
                        id: id
                    }, (0,application/* buildTestIds */.Fek)("form-input-".concat(id))), {
                        type: "tel",
                        inputMode: "numeric"
                    }), props, setValue, register(name, {
                        required: required,
                        pattern: pattern,
                        minLength: minLength,
                        maxLength: maxLength
                    })), {
                        onChange: onChange,
                        onKeyUp: onKeyUp,
                        onKeyDown: onKeyDown,
                        onBlur: onBlur,
                        maxLength: maxLength,
                        max: max,
                        disabled: disabled
                    }))
                ]
            }),
            textError && hasError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldError/* default */.Z, {
                text: textError,
                "data-cy": "error-".concat(id),
                padding: paddingErrorMessage,
                fontSize: fontSizeInfo,
                "data-testid": "form-field-error-input-".concat(id)
            }) : null,
            textInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInfo/* FieldInfo */.y, {
                text: textInfo,
                "data-cy": "info-".concat(id),
                fontSize: fontSizeInfo,
                color: colorInfo,
                "data-testid": "form-field-info-input-".concat(id),
                padding: paddingInfo
            })
        ]
    }));
};


// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../node_modules/react-input-mask/index.js
var react_input_mask = __webpack_require__(98738);
var react_input_mask_default = /*#__PURE__*/__webpack_require__.n(react_input_mask);
;// CONCATENATED MODULE: ../../packages/components/Form/NewCustomInput/components/MaskedInput/index.tsx






var MaskedInput = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var type = props.type, required = props.required, onBlur = props.onBlur, onChange = props.onChange, value = props.value, id = props.id, ref = props.ref, field = props.field;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_input_mask_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-mask-".concat(id)), field, props), {
        type: type !== null && type !== void 0 ? type : "text",
        ref: ref || field.ref,
        onChange: function(e) {
            if (onChange) onChange(e);
            if (field) field.onChange(e);
        },
        onBlur: function(e) {
            if (onBlur) onBlur(e);
            if (field) field.onBlur();
        },
        required: Boolean(required),
        value: value || field.value
    }));
};

;// CONCATENATED MODULE: ../../packages/components/Form/NewCustomInput/components/PrincipalInput/index.tsx




var PrincipalInput = function(props) {
    var type = props.type, required = props.required, onBlur = props.onBlur, onChange = props.onChange, value = props.value, id = props.id, ref = props.ref, field = props.field;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field, props), {
        type: type !== null && type !== void 0 ? type : "text",
        onChange: function(e) {
            if (onChange) onChange(e);
            if (field) field.onChange(e);
        },
        onBlur: function(e) {
            if (onBlur) onBlur(e);
            if (field) field.onBlur();
        },
        required: Boolean(required),
        ref: ref || field.ref,
        value: value || field.value
    }), (0,application/* buildTestIds */.Fek)("form-input-".concat(id))));
};

;// CONCATENATED MODULE: ../../packages/components/Form/NewCustomInput/components/index.tsx



;// CONCATENATED MODULE: ../../packages/components/Form/NewCustomInput/style.ts

function NewCustomInput_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-color: ",
        " !important;\n    "
    ]);
    NewCustomInput_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewCustomInput_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  min-width: 40px;\n  max-width: 40px;\n  width: 100%;\n  cursor: ",
        ";\n  border-left: none;\n  margin: ",
        ";\n\n  border-width: 1px 1px 1px 0;\n  border-style: solid;\n  border-color: ",
        ";\n  border-radius: 0px 4px 4px 0px;\n\n  ",
        ";\n"
    ]);
    NewCustomInput_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NewCustomInput_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      pointer-events: none;\n    "
    ]);
    NewCustomInput_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NewCustomInput_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-color: ",
        " !important;\n      "
    ]);
    NewCustomInput_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NewCustomInput_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border-radius: ",
        " ",
        " ",
        "\n              ",
        ";\n            border-right: 1px solid ",
        " !important;\n          "
    ]);
    NewCustomInput_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NewCustomInput_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border-radius: ",
        " ",
        " ",
        "\n              ",
        ";\n            border-right: none !important;\n          "
    ]);
    NewCustomInput_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NewCustomInput_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    NewCustomInput_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NewCustomInput_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  max-width: ",
        ";\n  ",
        "\n\n  input {\n    width: ",
        ";\n    height: ",
        ";\n    max-width: ",
        ";\n    padding: ",
        ";\n    margin: ",
        ";\n    border: ",
        ";\n    border-radius: ",
        ";\n    border-width: ",
        ";\n    background-color: ",
        ";\n    border-color: ",
        ";\n\n    &::placeholder {\n      color: ",
        " !important;\n      font-size: ",
        ";\n    }\n\n    ",
        "\n\n    border-color: ",
        ";\n    box-sizing: border-box;\n\n    &:focus {\n      outline: none;\n    }\n\n    &:hover {\n      color: ",
        " !important;\n    }\n\n    @media ",
        " {\n      &:hover {\n        border: ",
        ";\n      }\n    }\n\n    ",
        "\n  }\n"
    ]);
    NewCustomInput_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function NewCustomInput_style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      pointer-events: none;\n    "
    ]);
    NewCustomInput_style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function NewCustomInput_style_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: flex;\n    "
    ]);
    NewCustomInput_style_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function NewCustomInput_style_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n\n  input {\n    hover {\n      color: initial !important;\n    }\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    NewCustomInput_style_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var NewCustomInput_style_IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__IconContainer",
    componentId: "sc-8393d141-0"
})(NewCustomInput_style_templateObject1(), function(param) {
    var cursor = param.cursor;
    return cursor || "pointer";
}, function(param) {
    var margin = param.margin;
    return margin || "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0);
}, function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[580];
}, function(param) {
    var hasSuccessfully = param.hasSuccessfully;
    return hasSuccessfully && (0,styled_components_browser_esm/* css */.iv)(NewCustomInput_style_templateObject(), ui.theme.colors.secondary[200]);
});
var NewCustomInput_style_StyledInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__StyledInput",
    componentId: "sc-8393d141-1"
})(NewCustomInput_style_templateObject7(), function(param) {
    var width = param.width;
    return width ? "100%" : "initial";
}, function(param) {
    var width = param.width;
    return width || "200px";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(NewCustomInput_style_templateObject2());
}, function(param) {
    var width = param.width;
    return width ? "100%" : "initial";
}, function(param) {
    var height = param.height;
    return height || "auto";
}, function(param) {
    var width = param.width;
    return width || "initial";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "".concat(ui.theme.space.x4, " ").concat(ui.theme.space.x5);
}, function(param) {
    var margin = param.margin;
    return margin || "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0);
}, "".concat(ui.theme.space.xpx, " solid ").concat(ui.theme.colors.neutral[200]), function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius || "".concat(ui.theme.space.x2);
}, function(param) {
    var borderWidth = param.borderWidth;
    return borderWidth || "".concat(ui.theme.space.xpx);
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
}, function(param) {
    var borderColor = param.borderColor;
    return borderColor;
}, function(param) {
    var color = param.color;
    return color;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var hasSuccessfully = param.hasSuccessfully;
    return hasSuccessfully && (0,styled_components_browser_esm/* css */.iv)(NewCustomInput_style_templateObject3(), ui.theme.colors.secondary[200]);
}, function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[200];
}, function(param) {
    var color = param.color;
    return color;
}, ui.theme.device.desktopFirst.mobileL, function(param) {
    var hasError = param.hasError, borderColor = param.borderColor;
    return "1px solid ".concat(hasError ? ui.theme.colors.primary[200] : borderColor || "none");
}, function(param) {
    var hasIcon = param.hasIcon, hasIconBorder = param.hasIconBorder;
    return hasIcon && hasIconBorder ? (0,styled_components_browser_esm/* css */.iv)(NewCustomInput_style_templateObject4(), ui.theme.space.x1, ui.theme.space.x0, ui.theme.space.x0, ui.theme.space.x1, ui.theme.colors.neutral[580]) : hasIcon && !hasIconBorder ? (0,styled_components_browser_esm/* css */.iv)(NewCustomInput_style_templateObject5(), ui.theme.space.x1, ui.theme.space.x0, ui.theme.space.x0, ui.theme.space.x1) : (0,styled_components_browser_esm/* css */.iv)(NewCustomInput_style_templateObject6());
});
var style_InputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__InputContainer",
    componentId: "sc-8393d141-2"
})(NewCustomInput_style_templateObject10(), function(param) {
    var width = param.width;
    return width || "initial";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(NewCustomInput_style_templateObject8());
}, function(param) {
    var hasIcon = param.hasIcon;
    return hasIcon && (0,styled_components_browser_esm/* css */.iv)(NewCustomInput_style_templateObject9());
});

// EXTERNAL MODULE: ../../packages/infra/index.ts + 47 modules
var infra = __webpack_require__(11338);
;// CONCATENATED MODULE: ../../packages/components/DatePicker/index.tsx



var DatePicker = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(infra/* ReactDatePicker */.jL, (0,_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../packages/components/Form/NewCustomInput/index.tsx














var NewCustomInput = function(props) {
    var ref, ref1, ref2;
    var name = props.name, autoComplete = props.autoComplete, backgroundColor = props.backgroundColor, borderColor = props.borderColor, borderRadius = props.borderRadius, borderWidth = props.borderWidth, color = props.color, colorInfo = props.colorInfo, cursor = props.cursor, fontSize = props.fontSize, fontSizeInfo = props.fontSizeInfo, hasError = props.hasError, hasIcon = props.hasIcon, hasIconBorder = props.hasIconBorder, hasSuccessfully = props.hasSuccessfully, icon = props.icon, inputMode = props.inputMode, label = props.label, margin = props.margin, mask = props.mask, maskChar = props.maskChar, onClickIcon = props.onClickIcon, padding = props.padding, paddingErrorMessage = props.paddingErrorMessage, paddingInfo = props.paddingInfo, textError = props.textError, textInfo = props.textInfo, type = props.type, width = props.width, control = props.control, defaultValue = props.defaultValue, required = props.required, rules = props.rules, shouldUnregister = props.shouldUnregister, disabled = props.disabled, maxLength = props.maxLength, minLength = props.minLength, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onKeyUp = props.onKeyUp, onKeyDown = props.onKeyDown, onMouseOut = props.onMouseOut, onMouseOver = props.onMouseOver, pattern = props.pattern, placeholder = props.placeholder, role = props.role, value = props.value, height = props.height, min = props.min, id = props.id, max = props.max, ref3 = props.ref, showOptionalText = props.showOptionalText;
    var requiredText = (0,react.useMemo)(function() {
        return typeof required === "string" ? required : "Campo obrigat\xf3rio";
    }, [
        required
    ]);
    var ref4 = (0,index_esm/* useController */.bc)({
        name: name,
        control: control,
        defaultValue: defaultValue,
        rules: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rules), {
            maxLength: maxLength ? {
                value: maxLength,
                message: "M\xe1ximo de caracteres excedido"
            } : undefined,
            minLength: minLength ? {
                value: minLength,
                message: "M\xednimo de caracteres n\xe3o atingido"
            } : undefined,
            required: {
                value: required,
                message: requiredText
            },
            onChange: onChange,
            onBlur: onBlur,
            max: max ? {
                value: max,
                message: "Valor m\xe1ximo excedido"
            } : undefined,
            min: min ? {
                value: min,
                message: "Valor m\xednimo n\xe3o atingido"
            } : undefined,
            shouldUnregister: shouldUnregister
        }),
        shouldUnregister: shouldUnregister
    }), field = ref4.field, fieldState = ref4.fieldState;
    var dateFieldSuccessValidation = field.value !== undefined && field.value !== null && field.value !== "";
    var hasSuccessState = (0,react.useMemo)(function() {
        return Boolean(hasSuccessfully && dateFieldSuccessValidation);
    }, [
        hasSuccessfully,
        dateFieldSuccessValidation
    ]);
    var hasErrorState = (0,react.useMemo)(function() {
        return Boolean(hasError || Boolean(fieldState.error || fieldState.invalid)) && !hasSuccessState;
    }, [
        fieldState.error,
        fieldState.invalid,
        hasError,
        hasSuccessState
    ]);
    var ref5, ref6;
    var errorMessageText = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        return (ref6 = (ref5 = textError !== null && textError !== void 0 ? textError : (ref = fieldState.error) === null || ref === void 0 ? void 0 : (ref1 = ref.root) === null || ref1 === void 0 ? void 0 : ref1.message) !== null && ref5 !== void 0 ? ref5 : (ref2 = fieldState.error) === null || ref2 === void 0 ? void 0 : ref2.message) !== null && ref6 !== void 0 ? ref6 : requiredText;
    }, [
        (ref = fieldState.error) === null || ref === void 0 ? void 0 : ref.message,
        (ref1 = fieldState.error) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.root) === null || ref2 === void 0 ? void 0 : ref2.message,
        requiredText,
        textError, 
    ]);
    var ref7 = (0,react.useState)(false), isOpen = ref7[0], setIsOpen = ref7[1];
    var handleIconClick = function() {
        setIsOpen(!isOpen);
        if (onClickIcon) onClickIcon();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewCustomInput_style_StyledInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hasSuccessfully: hasSuccessState,
        hasError: hasErrorState,
        width: width,
        height: height,
        hasIcon: hasIcon,
        borderRadius: borderRadius,
        borderWidth: borderWidth,
        borderColor: borderColor,
        padding: padding,
        margin: margin,
        color: color,
        fontSize: fontSize,
        backgroundColor: backgroundColor,
        hasIconBorder: hasIconBorder
    }, (0,application/* buildTestIds */.Fek)("form-styled-input-".concat(id))), {
        isDisabled: disabled,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, (0,_object_spread/* default */.Z)({
                text: label,
                isRequired: Boolean(required),
                hasSuccessfully: hasSuccessState,
                htmlFor: id,
                showOptionalText: showOptionalText,
                typeFontWeight: 400
            }, (0,application/* buildTestIds */.Fek)("form-input-label-".concat(id)))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_InputContainer, {
                width: width,
                hasIcon: hasIcon,
                children: [
                    mask ? /*#__PURE__*/ (0,react.createElement)(MaskedInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-mask-".concat(id))), {
                        mask: mask,
                        id: id,
                        type: type,
                        maskChar: maskChar,
                        inputMode: inputMode,
                        autoComplete: autoComplete
                    }), props), {
                        ref: ref3,
                        onChange: onChange,
                        onKeyDown: onKeyDown,
                        onKeyUp: onKeyUp,
                        onMouseOut: onMouseOut,
                        onBlur: onBlur,
                        onMouseOver: onMouseOver,
                        min: min,
                        max: max,
                        required: Boolean(required),
                        disabled: disabled,
                        placeholder: placeholder,
                        role: role,
                        value: value,
                        pattern: pattern,
                        defaultValue: defaultValue,
                        field: field,
                        key: id
                    })) : type === "date" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-date-picker-input-".concat(id))), {
                        onChange: field.onChange,
                        selected: field.value,
                        onBlur: field.onBlur,
                        placeholder: placeholder,
                        control: control,
                        required: Boolean(required),
                        value: field.value,
                        open: isOpen,
                        onInputClick: handleIconClick,
                        onClickOutside: function() {
                            return setIsOpen(false);
                        },
                        onInputChangesMonitoringErrors: function(error) {
                            implementations/* appMonitoringClient.captureException */.pE.captureException(error);
                        }
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PrincipalInput, (0,_object_spread/* default */.Z)({
                        field: field,
                        id: id,
                        type: type,
                        inputMode: inputMode,
                        autoComplete: autoComplete,
                        onChange: onChange,
                        onKeyDown: onKeyDown,
                        onKeyUp: onKeyUp,
                        onMouseOut: onMouseOut,
                        onBlur: onBlur,
                        onMouseOver: onMouseOver,
                        min: min,
                        onFocus: onFocus,
                        minLength: minLength,
                        maxLength: maxLength,
                        max: max,
                        required: Boolean(required),
                        disabled: disabled,
                        placeholder: placeholder,
                        role: role,
                        value: value,
                        pattern: pattern,
                        ref: ref3
                    }, (0,application/* buildTestIds */.Fek)("form-input-".concat(id))), id),
                    hasIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewCustomInput_style_IconContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        cursor: cursor,
                        hasSuccessfully: hasSuccessState,
                        margin: margin,
                        hasError: hasError,
                        onClick: type === "date" ? handleIconClick : onClickIcon
                    }, (0,application/* buildTestIds */.Fek)("form-icon-container-".concat(id))), {
                        children: icon
                    }))
                ]
            }),
            errorMessageText && hasErrorState && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldError/* default */.Z, (0,_object_spread/* default */.Z)({
                text: errorMessageText,
                padding: paddingErrorMessage,
                fontSize: fontSizeInfo
            }, (0,application/* buildTestIds */.Fek)("form-field-error-input-".concat(id)))),
            textInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInfo/* FieldInfo */.y, (0,_object_spread/* default */.Z)({
                padding: paddingInfo,
                text: textInfo,
                fontSize: fontSizeInfo,
                color: colorInfo
            }, (0,application/* buildTestIds */.Fek)("form-field-info-input-".concat(id))))
        ]
    }));
};

;// CONCATENATED MODULE: ../../packages/components/Form/index.tsx

function Form_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Form_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "Form",
    componentId: "sc-769567c1-0"
})(Form_templateObject());






/***/ }),

/***/ 43119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
// EXTERNAL MODULE: ../../packages/application/state-manager/adapter.ts
var adapter = __webpack_require__(80759);
// EXTERNAL MODULE: ../../packages/infra/index.ts + 47 modules
var infra = __webpack_require__(11338);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/backoffice/hooks/index.tsx + 6 modules
var hooks = __webpack_require__(51646);
// EXTERNAL MODULE: ../../packages/components/patterns/LinkRedirectHome/index.tsx
var LinkRedirectHome = __webpack_require__(98277);
// EXTERNAL MODULE: ../../packages/components/Skeleton/index.tsx
var Skeleton = __webpack_require__(44860);
// EXTERNAL MODULE: ../../packages/components/StatusProgress/index.tsx + 1 modules
var StatusProgress = __webpack_require__(70020);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/Header/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  width: 5rem;\n  margin-left: 4.5rem;\n  height: 3.835rem;\n  border: none;\n  border-radius: 4px;\n  background-color: ",
        ";\n\n  @media ",
        " {\n    width: 3.675rem;\n    height: 3.085rem;\n    margin-left: 1.5rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 50%;\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 4.5rem;\n\n  @media ",
        " {\n    padding-right: 1.5rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  height: 7rem;\n  width: 100%;\n  margin-bottom: ",
        ";\n  background-color: ",
        ";\n\n  @media ",
        " {\n    margin-bottom: 2rem;\n    height: 5.175rem;\n  }\n\n  @media ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: 0px 2px 4px 0px ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var BackButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__BackButton",
    componentId: "sc-5e3b92d1-0"
})(_templateObject(), ui.theme.colors.primary[350], ui.theme.device.desktopFirst.mobileXL);
var ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ImageContainer",
    componentId: "sc-5e3b92d1-1"
})(_templateObject1(), ui.theme.device.desktopFirst.mobileXL);
var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HeaderContainer",
    componentId: "sc-5e3b92d1-2"
})(_templateObject3(), function(param) {
    var marginBottom = param.marginBottom;
    return marginBottom !== null && marginBottom !== void 0 ? marginBottom : "5.95rem";
}, ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.tabletXM, ui.theme.device.desktopFirst.mobileXL, function(param) {
    var marginBottom = param.marginBottom;
    return marginBottom !== null && marginBottom !== void 0 ? marginBottom : "2rem";
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), ui.theme.colors.blackFriday[175]);
});
var HeaderWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__HeaderWrapper",
    componentId: "sc-5e3b92d1-3"
})(_templateObject4(), ui.theme.colors.neutral["999-opacity-10"]);

;// CONCATENATED MODULE: ../../packages/components/Header/index.tsx














var Header = function(param) {
    var isBlackTheme = param.isBlackTheme, marginBottom = param.marginBottom, hasStepper = param.hasStepper, steps = param.steps, icon = param.icon, stepTitle = param.stepTitle, goBackAction = param.goBackAction;
    var router = (0,next_router.useRouter)();
    var ref = (0,application/* useAppContext */.bp4)(), isClientMobile = ref.isClientMobile, isClientTablet = ref.isClientTablet, isPageWeddingList = ref.isPageWeddingList;
    var ref1 = (0,state_manager/* useAuthentication */.JL)((0,adapter/* useShallow */.N)(function(state) {
        return {
            closeAuthenticationModal: state.closeAuthenticationModal,
            currentStep: state.currentStep,
            changeCurrentStep: state.changeCurrentStep
        };
    })), closeAuthenticationModal = ref1.closeAuthenticationModal, currentStep = ref1.currentStep, changeCurrentStep = ref1.changeCurrentStep;
    var ref2 = (0,state_manager/* useTwoFactor */.kD)((0,adapter/* useShallow */.N)(function(state) {
        return {
            setIsValidationActive: state.setIsValidationActive,
            myDataStep: state.currentStep,
            setUserIdentification: state.setUserIdentification
        };
    })), setIsValidationActive = ref2.setIsValidationActive, myDataStep = ref2.myDataStep, setUserIdentification = ref2.setUserIdentification;
    var ref3 = (0,application/* useHeaderContext */.Jv3)(), customHeader = ref3.customHeader, isLoadingCustomHeader = ref3.isLoadingCustomHeader;
    var customHeaderComponent = (0,hooks/* useMappedBackofficeComponent */.J)(customHeader, {
        isPageWeddingList: isPageWeddingList,
        isClientMobile: isClientMobile,
        isClientTablet: isClientTablet,
        isLoading: isLoadingCustomHeader
    });
    var handleTwoFactorRouterLogic = function(passedIsClientMobile) {
        var ref;
        setIsValidationActive(false);
        if (myDataStep === "editData") {
            setIsValidationActive(false);
            setUserIdentification("");
            return;
        }
        if ((ref = [
            "changePasswordDuePurchaseTime",
            "forgotPassword",
            "verifyCode",
            "verifyIdentify", 
        ]) === null || ref === void 0 ? void 0 : ref.includes(currentStep)) {
            changeCurrentStep("login");
            return;
        }
        if (!passedIsClientMobile || [
            "login",
            "securityIssueForm",
            "exclusionAccountForm"
        ].includes(currentStep)) {
            closeAuthenticationModal();
            router.back();
            return;
        }
        router.back();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isLoadingCustomHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
                count: 1,
                hasMargin: false
            }) : customHeaderComponent,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-wrapper")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        isBlackTheme: !!isBlackTheme,
                        marginBottom: marginBottom
                    }, (0,application/* buildTestIds */.Fek)("header-container")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-back-button")), {
                                onClick: function() {
                                    if (goBackAction) {
                                        goBackAction();
                                        return;
                                    }
                                    handleTwoFactorRouterLogic(isClientMobile);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowLeft, {
                                    color: "".concat(ui.theme.colors.neutral.white)
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                                onClick: closeAuthenticationModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRedirectHome/* LinkRedirectHome */.x, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(infra/* Image */.Ee, {
                                        src: "https://d2urakutajlof6.cloudfront.net/logo/logo_fc.svg",
                                        width: isClientMobile ? "96px" : "132px",
                                        height: isClientMobile ? "36px" : "49px",
                                        alt: "Ferreira Costa",
                                        layout: "fixed",
                                        "data-cy": "logo-ferreira-costa"
                                    })
                                })
                            })
                        ]
                    })),
                    hasStepper && steps ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusProgress/* StatusProgress */.M, {
                        hasIcon: false,
                        icon: icon,
                        stepTitle: stepTitle,
                        statusStep: steps
                    }) : null
                ]
            }))
        ]
    });
};


/***/ }),

/***/ 25926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(430);
/* harmony import */ var infra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11338);






var Image = function(_param) {
    var src = _param.src, alt = _param.alt, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var formattedImageSrc = (0,application__WEBPACK_IMPORTED_MODULE_1__/* .replaceImageBaseUrl */ .sMx)(src);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(infra__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("image-".concat(alt))), {
        src: formattedImageSrc,
        alt: alt,
        "aria-label": alt
    }), props), {
        quality: 100
    }));
};



/***/ }),

/***/ 4247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ InputBoxValidation; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
// EXTERNAL MODULE: ../../packages/application/state-manager/adapter.ts
var adapter = __webpack_require__(80759);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/CodeExpiration/index.tsx
var CodeExpiration = __webpack_require__(88484);
// EXTERNAL MODULE: ../../packages/components/SendCodeAgain/index.tsx + 1 modules
var SendCodeAgain = __webpack_require__(6499);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/InputCodeValidation/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  display: flex;\n  justify-content: end;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var InputCodeValidationContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__InputCodeValidationContainer",
    componentId: "sc-35cf4d76-0"
})(_templateObject(), ui.theme.colors.primary[155], function(param) {
    var flexDirection = param.flexDirection;
    return flexDirection;
});
var IncorrectCode = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__IncorrectCode",
    componentId: "sc-35cf4d76-1"
})(_templateObject1(), ui.theme.colors.primary[155], ui.theme.space.x3, ui.theme.typography.fontWeight[400]);

;// CONCATENATED MODULE: ../../packages/components/InputCodeValidation/InputCode/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border: ",
        ";\n  border-radius: ",
        ";\n  text-align: center;\n  font-size: ",
        ";\n  color: ",
        " !important;\n  :focus {\n    border: 2px solid ",
        ";\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n\n  width: 100%;\n  margin: ",
        " ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  display: ",
        ";\n  justify-content: space-between;\n  width: 100%;\n  margin: ",
        " ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 24px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 4px;\n  margin: 24px 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  gap: ",
        ";\n  align-items: center;\n  padding-bottom: 0.8rem;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  border-radius: ",
        ";\n  border-color: 1px solid ",
        ";\n  width: 100%;\n  gap: ",
        ";\n  padding: 0.6rem 1rem;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var ValidationInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "styles__ValidationInput",
    componentId: "sc-c24e7531-0"
})(styles_templateObject(), function(param) {
    var width = param.width;
    return width || "39px";
}, function(param) {
    var height = param.height;
    return height || "50px";
}, function(param) {
    var border = param.border;
    return border;
}, ui.theme.space.x2, ui.theme.typography.fontSize.sm.x7, ui.theme.colors.neutral[999], ui.theme.colors.neutral[999]);
var InputCodeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__InputCodeContainer",
    componentId: "sc-c24e7531-1"
})(styles_templateObject1(), ui.theme.colors.neutral[999], ui.theme.space.x1, ui.theme.space.x0);
var Inputs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Inputs",
    componentId: "sc-c24e7531-2"
})(_templateObject2(), ui.theme.colors.neutral[999], function(param) {
    var display = param.display;
    return display;
}, ui.theme.space.x2, ui.theme.space.x0);
var MessageErrorWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MessageErrorWrapper",
    componentId: "sc-c24e7531-3"
})(_templateObject3());
var SupportWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SupportWrapper",
    componentId: "sc-c24e7531-4"
})(_templateObject4());
var Contact = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Contact",
    componentId: "sc-c24e7531-5"
})(_templateObject5(), ui.theme.space.x2);
var SupportText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__SupportText",
    componentId: "sc-c24e7531-6"
})(_templateObject6(), ui.theme.typography.fontSize.sm.x5, ui.theme.colors.neutral[550]);
var MessageError = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MessageError",
    componentId: "sc-c24e7531-7"
})(_templateObject7(), ui.theme.space.x2);
var MoreInformation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MoreInformation",
    componentId: "sc-c24e7531-8"
})(_templateObject8(), ui.theme.space.x2, ui.theme.colors.neutral[150], ui.theme.space.x2);
var InformationText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__InformationText",
    componentId: "sc-c24e7531-9"
})(_templateObject9(), ui.theme.colors.neutral[350], ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[400]);
var MessageSuccess = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MessageSuccess",
    componentId: "sc-c24e7531-10"
})(_templateObject10(), ui.theme.space.x2);

;// CONCATENATED MODULE: ../../packages/components/InputCodeValidation/InputCode/index.tsx















var InputCode = function(param) {
    var length = param.length, height = param.height, width = param.width, numberType = param.numberType, typeItem = param.typeItem, noTopSubtitle = param.noTopSubtitle, bottomSubtitle = param.bottomSubtitle;
    var ref = (0,application/* useNotification */.lmA)(), changeIsCodeValid = ref.changeIsCodeValid, changeCodeHasError = ref.changeCodeHasError, changeIsUserBlocked = ref.changeIsUserBlocked, validateTwoFactorSMS = ref.validateTwoFactorSMS;
    var ref1 = (0,react.useState)(0), countdown = ref1[0], setCountdown = ref1[1];
    var ref2 = (0,state_manager/* useTwoFactor */.kD)((0,adapter/* useShallow */.N)(function(state) {
        return {
            setTokenCode: state.setTokenCode,
            tokenCode: state.tokenCode,
            isTokenCodeValid: state.isTokenCodeValid,
            email: state.email,
            validateCode: state.validateCode,
            setIsCodeComplete: state.setIsCodeComplete,
            setIsTokenCodeValid: state.setIsTokenCodeValid,
            clipboardText: state.clipboardText,
            setClipboardText: state.setClipboardText,
            setValidateCode: state.setValidateCode
        };
    })), setTokenCode = ref2.setTokenCode, isTokenCodeValid = ref2.isTokenCodeValid, setIsTokenCodeValid = ref2.setIsTokenCodeValid, tokenCode = ref2.tokenCode, email = ref2.email, validateCode = ref2.validateCode, setIsCodeComplete = ref2.setIsCodeComplete, clipboardText = ref2.clipboardText, setClipboardText = ref2.setClipboardText, setValidateCode = ref2.setValidateCode;
    var ref3 = (0,react.useState)(""), messageError = ref3[0], setMessageError = ref3[1];
    var ref4 = (0,react.useState)(""), validCode = ref4[0], setValidCode = ref4[1];
    var ref5 = (0,react.useState)(false), hasError = ref5[0], setHasError = ref5[1];
    var ref6 = (0,react.useState)(false), codeSent = ref6[0], setCodeSent = ref6[1];
    var ref7 = (0,react.useState)(false), isUserBlocked = ref7[0], setIsUserBlocked = ref7[1];
    var ref8 = (0,react.useState)(false), disappearCountdown = ref8[0], setDisappearCountdown = ref8[1];
    var ref9 = (0,react.useState)(false), codeIsValid = ref9[0], setCodeIsValid = ref9[1];
    (0,react.useEffect)(function() {
        changeCodeHasError(hasError);
        changeIsUserBlocked(isUserBlocked);
        changeIsCodeValid(codeIsValid);
    }, [
        isUserBlocked,
        hasError,
        codeIsValid,
        changeIsCodeValid,
        changeCodeHasError,
        changeIsUserBlocked, 
    ]);
    var onSendCode = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(type, token) {
            var ref, ref1, ref2, ref3, ref4, ref5, status, errors, ref6, ref7, ref8, ref9, ref10;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            validateTwoFactorSMS(type, token)
                        ];
                    case 1:
                        ref5 = _state.sent(), status = ref5.status, errors = ref5.errors;
                        if ((errors === null || errors === void 0 ? void 0 : (ref = errors.ErrorCodes) === null || ref === void 0 ? void 0 : ref.includes("555")) && !(errors === null || errors === void 0 ? void 0 : (ref1 = errors.ErrorCodes) === null || ref1 === void 0 ? void 0 : ref1.includes("222"))) {
                            ;
                            setCodeSent(true);
                            setHasError(true);
                            setMessageError(errors === null || errors === void 0 ? void 0 : (ref6 = errors.Messages) === null || ref6 === void 0 ? void 0 : ref6[0]);
                            setValidateCode(true);
                            return [
                                2
                            ];
                        }
                        if (errors === null || errors === void 0 ? void 0 : (ref2 = errors.ErrorCodes) === null || ref2 === void 0 ? void 0 : ref2.includes("222")) {
                            setCodeSent(true);
                            setHasError(true);
                            setMessageError("Seus cr\xe9ditos foram bloqueados temporariamente devido a tentativas excessivas de valida\xe7\xe3o do c\xf3digo de seguran\xe7a. Entre em contato com o suporte para regularizar a situa\xe7\xe3o.");
                            setIsUserBlocked(true);
                            return [
                                2
                            ];
                        }
                        if (((ref3 = status === null || status === void 0 ? void 0 : status.toString()) === null || ref3 === void 0 ? void 0 : ref3.startsWith("4")) || ((ref4 = status === null || status === void 0 ? void 0 : status.toString()) === null || ref4 === void 0 ? void 0 : ref4.startsWith("5"))) {
                            ;
                            setHasError(true);
                            setCodeSent(true);
                            setMessageError((errors === null || errors === void 0 ? void 0 : (ref7 = errors.Messages) === null || ref7 === void 0 ? void 0 : ref7.length) === 2 ? errors === null || errors === void 0 ? void 0 : (ref8 = errors.Messages) === null || ref8 === void 0 ? void 0 : ref8[1] : (errors === null || errors === void 0 ? void 0 : (ref9 = errors.Messages) === null || ref9 === void 0 ? void 0 : ref9[0]) || "Ocorreu um erro");
                            if (errors === null || errors === void 0 ? void 0 : (ref10 = errors.Messages) === null || ref10 === void 0 ? void 0 : ref10[1]) {
                                setIsUserBlocked(true);
                            }
                            return [
                                2
                            ];
                        }
                        if (!(errors === null || errors === void 0 ? void 0 : errors.Messages)) {
                            setValidCode("C\xf3digo v\xe1lido");
                            setHasError(false);
                            setCodeSent(true);
                            setDisappearCountdown(true);
                            setCodeIsValid(true);
                            return [
                                2
                            ];
                        }
                        setMessageError("Ocorreu um erro");
                        setHasError(true);
                        setCodeSent(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function(type, token) {
            return _ref.apply(this, arguments);
        };
    }(), [
        validateTwoFactorSMS,
        setValidateCode
    ]);
    var ref10 = (0,react.useState)(Array(length).fill("")), code = ref10[0], setCode = ref10[1];
    var isCodeComplete = code.every(function(digit) {
        return digit !== "";
    });
    var inputs = (0,react.useRef)([]);
    var clearInputFields = (0,react.useCallback)(function() {
        var ref;
        var newPin = Array(length).fill("");
        setCode(newPin);
        (ref = inputs === null || inputs === void 0 ? void 0 : inputs.current[0]) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        length
    ]);
    var isIncorrectCode = !isTokenCodeValid && isCodeComplete && validateCode;
    var handleKeyDown = (0,react.useCallback)(function(e, index) {
        if ((e === null || e === void 0 ? void 0 : e.key) === "ArrowLeft" && index > 0) {
            var ref;
            (ref = inputs === null || inputs === void 0 ? void 0 : inputs.current[index - 1]) === null || ref === void 0 ? void 0 : ref.focus();
        }
        if ((e === null || e === void 0 ? void 0 : e.key) === "ArrowRight" && index < length - 1) {
            var ref1;
            (ref1 = inputs === null || inputs === void 0 ? void 0 : inputs.current[index + 1]) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
        if ((e === null || e === void 0 ? void 0 : e.key) === "Backspace") {
            var newPin = (0,_to_consumable_array/* default */.Z)(code);
            if (newPin[index]) {
                newPin[index] = "";
                setCode(newPin);
            } else if (index > 0) {
                var ref2;
                newPin[index - 1] = "";
                setCode(newPin);
                (ref2 = inputs === null || inputs === void 0 ? void 0 : inputs.current[index - 1]) === null || ref2 === void 0 ? void 0 : ref2.focus();
            }
        }
        var value = e.key;
        if (/^\d$/.test(value)) {
            var newPin1 = (0,_to_consumable_array/* default */.Z)(code);
            newPin1[index] = value;
            setCode(newPin1);
            if (index < length - 1) {
                var ref3;
                (ref3 = inputs === null || inputs === void 0 ? void 0 : inputs.current[index + 1]) === null || ref3 === void 0 ? void 0 : ref3.focus();
            }
        }
    }, [
        length,
        code
    ]);
    var codeReceived = code.toString().replace(/[^0-9]/g, "");
    (0,react.useEffect)(function() {
        if (codeReceived.length === 6 && typeItem === "SendEmailCode") {
            setTokenCode(codeReceived);
        }
        if (codeReceived.length < 6) {
            setIsTokenCodeValid(null);
        }
    }, [
        codeReceived,
        email,
        tokenCode,
        isCodeComplete,
        setTokenCode,
        typeItem,
        setIsTokenCodeValid, 
    ]);
    (0,react.useEffect)(function() {
        if (codeReceived.length === 6 && typeItem !== "SendEmailCode") {
            onSendCode(numberType, codeReceived);
        }
    }, [
        codeReceived,
        numberType,
        onSendCode,
        typeItem
    ]);
    (0,react.useEffect)(function() {
        if (clipboardText) {
            var newCode = clipboardText.replace(/\D/g, "").split("").concat(Array(length).fill("")).slice(0, length);
            setCode(newCode);
            setClipboardText("");
        }
    }, [
        clipboardText,
        length,
        setClipboardText
    ]);
    (0,react.useEffect)(function() {
        setIsCodeComplete(isCodeComplete);
    }, [
        isCodeComplete,
        setIsCodeComplete
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputCodeContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("input-code-container")), {
        children: [
            hasError && codeSent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageErrorWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageError, {
                    children: [
                        typeItem === "ResendCodeComponent" && isUserBlocked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.WarningIcon, {
                            height: 60,
                            width: 60
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.WarningIcon, {}),
                        messageError
                    ]
                })
            }) : codeSent && codeIsValid && !noTopSubtitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageSuccess, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ValidIcon, {}),
                    validCode
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                display: isUserBlocked ? "none" : "flex"
            }, (0,application/* buildTestIds */.Fek)("inputs")), {
                children: code.map(function(num, index) {
                    var key = index + 1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ValidationInput, {
                        height: height,
                        width: width,
                        role: "textbox",
                        disabled: codeIsValid,
                        border: hasError && codeSent || validateCode && isTokenCodeValid === false && isCodeComplete ? "2px solid ".concat(ui.theme.colors.primary[150]) : codeSent || isTokenCodeValid ? "2px solid ".concat(ui.theme.colors.secondary[380], " ") : "1px solid ".concat(ui.theme.colors.neutral[240]),
                        type: "tel",
                        maxLength: 1,
                        value: num,
                        onFocus: function() {
                            if (isIncorrectCode) {
                                clearInputFields();
                            }
                        },
                        onChange: function() {
                            return [];
                        },
                        autoFocus: !code[0].length && index === 0,
                        onKeyDown: function(e) {
                            return handleKeyDown(e, index);
                        },
                        ref: function(ref) {
                            return inputs.current.push(ref);
                        }
                    }, key);
                })
            })),
            typeItem === "ResendCodeComponent" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs, {
                display: isUserBlocked || disappearCountdown ? "none" : "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeExpiration/* CodeExpiration */.K, {
                        codeCountdown: function(time) {
                            return setCountdown(time);
                        }
                    }),
                    countdown === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SendCodeAgain/* SendCodeAgain */.V, {
                        color: "".concat(ui.theme.colors.primary[150]),
                        typeSMS: numberType
                    }) : null
                ]
            }) : null,
            isUserBlocked ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SupportWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Contact, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.PhoneCallIcon, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportText, {
                                        children: "0800 8383 083"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Contact, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.AtEmailIcon, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportText, {
                                        children: "sac@ferreiracosta.com.br"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MoreInformation, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CartIcon, {
                                height: 45,
                                width: 45,
                                strokeWidth: "2",
                                color: "".concat(ui.theme.colors.secondary[380])
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationText, {
                                children: "Voc\xea ainda pode finalizar sua compra com cart\xe3o de cr\xe9dito ou PIX."
                            })
                        ]
                    })
                ]
            }) : null,
            bottomSubtitle && isIncorrectCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(IncorrectCode, {
                children: "C\xf3digo incorreto"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/InputCodeValidation/index.tsx






var InputBoxValidation = function(param) {
    var height = param.height, width = param.width, numberType = param.numberType, typeItem = param.typeItem, flexDirection = param.flexDirection, bottomSubtitle = param.bottomSubtitle, noTopSubtitle = param.noTopSubtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCodeValidationContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("input-code-validation-container")), {
        flexDirection: flexDirection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCode, {
            height: height,
            width: width,
            length: 6,
            numberType: numberType,
            typeItem: typeItem,
            noTopSubtitle: noTopSubtitle,
            bottomSubtitle: bottomSubtitle
        })
    }));
};



/***/ }),

/***/ 17335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(430);
/* harmony import */ var _StyledLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85922);







var Link = function(_param) {
    var children = _param.children, href = _param.href, _scroll = _param.scroll, scroll = _scroll === void 0 ? true : _scroll, mouseOver = _param.mouseOver, id = _param.id, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "href",
        "scroll",
        "mouseOver",
        "id"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        scroll: scroll,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StyledLink__WEBPACK_IMPORTED_MODULE_3__/* .CustomStyledLink */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_2__/* .buildTestIds */ .Fek)("custom-styled-link-".concat(id || ""))), {
            mouseOver: mouseOver
        }), props), {
            children: children
        }))
    });
};



/***/ }),

/***/ 38879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ Loading; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/Loading/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: inline-block;\n  width: ",
        ";\n  height: ",
        ";\n  vertical-align: -0.125em;\n  border: 0.25em ",
        " currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  -webkit-animation: ",
        "\n    ",
        " linear infinite;\n  animation: ",
        "\n    ",
        " linear infinite;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var rotateKeyframes = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var getWidthOrHeight = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "medium";
    return ({
        small: "1rem",
        medium: "1.5rem",
        large: "2rem",
        extraLarge: "10rem"
    })["".concat(size)];
};
var LoadingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LoadingContainer",
    componentId: "sc-d708aba8-0"
})(_templateObject1(), function(param) {
    var color = param.color;
    return color || "currentColor";
}, function(param) {
    var size = param.size;
    return getWidthOrHeight(size);
}, function(param) {
    var size = param.size;
    return getWidthOrHeight(size);
}, function(param) {
    var type = param.type;
    return type !== null && type !== void 0 ? type : "solid";
}, rotateKeyframes, function(param) {
    var type = param.type;
    return type === "dotted" ? "1s" : "0.75s";
}, rotateKeyframes, function(param) {
    var type = param.type;
    return type === "dotted" ? "1s" : "0.75s";
});

;// CONCATENATED MODULE: ../../packages/components/Loading/index.tsx





var Loading = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingContainer, (0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("loading-container"), props));
};



/***/ }),

/***/ 40752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O$": function() { return /* binding */ ContentModalAlert; },
/* harmony export */   "SB": function() { return /* binding */ TitleModal; },
/* harmony export */   "aQ": function() { return /* binding */ BodyModal; },
/* harmony export */   "fb": function() { return /* binding */ ButtonClose; },
/* harmony export */   "ge": function() { return /* binding */ HeaderModal; },
/* harmony export */   "mH": function() { return /* binding */ ButtonLine; },
/* harmony export */   "no": function() { return /* binding */ FooterModal; },
/* harmony export */   "oe": function() { return /* binding */ ButtonSolid; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  width: fit-content;\n  height: fit-content;\n  padding: ",
        ";\n  border-radius: ",
        ";\n\n  position: fixed;\n  left: 50%;\n  top: 40%;\n  transform: translate(-50%, -50%);\n  z-index: 99999;\n\n  box-shadow: 4px 4px 14px 0px ",
        ";\n  border: 2px solid;\n  border-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 50%;\n  max-height: 3rem;\n  max-width: 3rem;\n  padding: 0.5rem;\n\n  position: absolute;\n  top: -1rem;\n  right: -1rem;\n  cursor: pointer;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: ",
        ";\n\n  border: 2px solid;\n  border-color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  background: none;\n\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n  font-size: ",
        ";\n  font-weight: 500;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  background: ",
        ";\n\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n  font-size: ",
        ";\n  font-weight: 500;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  border-bottom: ",
        ";\n  padding-bottom: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-top: ",
        ";\n  margin-top: 1.2rem;\n  border-top: 0.05rem solid ",
        ";\n\n  display: flex;\n  justify-content: flex-end;\n  gap: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var COLOR_TYPE_INFO = {
    info: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.tertiary[300],
    warn: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.yellow[600],
    error: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200],
    success: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.secondary[400]
};
var ContentModalAlert = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__ContentModalAlert",
    componentId: "sc-4a7f248a-0"
})(_templateObject(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white;
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[600], function(param) {
    var typeInfo = param.typeInfo;
    return typeInfo && typeInfo in COLOR_TYPE_INFO ? COLOR_TYPE_INFO[typeInfo || "info"] : COLOR_TYPE_INFO.warn;
});
var HeaderModal = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    displayName: "styles__HeaderModal",
    componentId: "sc-4a7f248a-1"
})(_templateObject1());
var ButtonClose = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "styles__ButtonClose",
    componentId: "sc-4a7f248a-2"
})(_templateObject2(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white;
}, function(param) {
    var typeInfo = param.typeInfo;
    return typeInfo && typeInfo in COLOR_TYPE_INFO ? COLOR_TYPE_INFO[typeInfo || "info"] : COLOR_TYPE_INFO.warn;
});
var ButtonLine = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "styles__ButtonLine",
    componentId: "sc-4a7f248a-3"
})(_templateObject3(), function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.secondary[200];
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "1.2rem";
}, function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.secondary[200];
});
var ButtonSolid = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "styles__ButtonSolid",
    componentId: "sc-4a7f248a-4"
})(_templateObject4(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.secondary[200];
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "1.2rem";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white);
var TitleModal = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    displayName: "styles__TitleModal",
    componentId: "sc-4a7f248a-5"
})(_templateObject5(), function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "1.4rem";
}, function(param) {
    var lowerContent = param.lowerContent;
    return lowerContent ? "0.05rem solid ".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[400]) : "none";
}, function(param) {
    var lowerContent = param.lowerContent;
    return lowerContent ? "1rem" : "0";
}, function(param) {
    var lowerContent = param.lowerContent;
    return lowerContent ? "1rem" : "0";
});
var BodyModal = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__BodyModal",
    componentId: "sc-4a7f248a-6"
})(_templateObject6(), function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "1.3rem";
});
var FooterModal = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__FooterModal",
    componentId: "sc-4a7f248a-7"
})(_templateObject7(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[400], ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4);


/***/ }),

/***/ 51345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var infra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11338);





var Modal = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(infra__WEBPACK_IMPORTED_MODULE_1__/* .ReactModal */ .Fv, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        children: children
    }));
};



/***/ }),

/***/ 51637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ModalConfirmEmailError": function() { return /* binding */ ModalConfirmEmailError; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/components/ModalGeneral/index.tsx + 1 modules
var ModalGeneral = __webpack_require__(89459);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/ModalConfirmEmailError/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 100%;\n  height: 3.75rem;\n  padding: 0.65rem 4.9125rem;\n  text-align: center;\n  font-family: ",
        ";\n  font-size: 1.15rem;\n  font-weight: ",
        ";\n  line-height: 1.3125rem;\n  letter-spacing: 0.005rem;\n\n  border-radius: 4px;\n  color: ",
        ";\n  background: ",
        ";\n  cursor: pointer;\n  border: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background: ",
        ";\n  transition: background 0.2s ease-in-out;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n\n  /* transition: background 0.2s ease-in-out; */\n  /* &:hover {\n    background: ",
        ";\n  } */\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var BaseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__BaseButton",
    componentId: "sc-a24a159d-0"
})(_templateObject(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[400], ui.theme.colors.neutral.white, ui.theme.colors.primary[350]);
var ButtonResendModalConfirmEmailError = (0,styled_components_browser_esm/* default */.ZP)(BaseButton).withConfig({
    displayName: "styles__ButtonResendModalConfirmEmailError",
    componentId: "sc-a24a159d-1"
})(_templateObject1(), ui.theme.colors.neutral.white, ui.theme.colors.primary[350], ui.theme.colors.primary[400]);
var ButtonCloseModalConfirmEmailError = (0,styled_components_browser_esm/* default */.ZP)(BaseButton).withConfig({
    displayName: "styles__ButtonCloseModalConfirmEmailError",
    componentId: "sc-a24a159d-2"
})(_templateObject2(), ui.theme.colors.primary[350], ui.theme.colors.neutral.white, ui.theme.colors.primary[350], ui.theme.colors.primary[400]);

;// CONCATENATED MODULE: ../../packages/components/ModalConfirmEmailError/index.tsx








var ModalConfirmEmailError = function(param) {
    var isOpen = param.isOpen, onCloseModal = param.onCloseModal, ariaHideApp = param.ariaHideApp;
    var userData = (0,application/* useAuth */.aCi)().userData;
    var sendOrResendEmailConfirmation = (0,application/* useModalGroup */.IzY)().sendOrResendEmailConfirmation;
    var email = userData === null || userData === void 0 ? void 0 : userData.email;
    var handleResendEmail = (0,react.useCallback)(function() {
        sendOrResendEmailConfirmation(email);
    }, [
        sendOrResendEmailConfirmation,
        email
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGeneral.ModalGeneral, {
        ariaHideApp: ariaHideApp,
        isOpen: isOpen,
        onCloseModal: onCloseModal,
        ariaLabelForModal: "Erro na confirma\xe7\xe3o de e-mail",
        title: "Erro na confirma\xe7\xe3o de e-mail",
        bodyDescription: "N\xe3o foi poss\xedvel confirmar o seu e-mail. Para continuar de maneira segura, tente novamente.",
        illustration: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.DeviceCheckError, {}),
        bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonResendModalConfirmEmailError, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-resend-confirm-email-error")), {
                    onClick: handleResendEmail,
                    children: "Reenviar e-email"
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCloseModalConfirmEmailError, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-close-confirm-email-error")), {
                    onClick: onCloseModal,
                    children: "Deixar para mais tarde"
                }))
            ]
        })
    });
};



/***/ }),

/***/ 27294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ModalConfirmedEmail": function() { return /* binding */ ModalConfirmedEmail; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/components/ModalGeneral/index.tsx + 1 modules
var ModalGeneral = __webpack_require__(89459);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/ModalConfirmedEmail/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 100%;\n  height: 3.75rem;\n  padding: 0.65rem 4.9125rem;\n  text-align: center;\n  font-family: ",
        ";\n  font-size: 1.15rem;\n  font-weight: ",
        ";\n  line-height: 1.3125rem;\n  letter-spacing: 0.005rem;\n\n  border-radius: 4px;\n  color: ",
        ";\n  background: ",
        ";\n  cursor: pointer;\n  transition: background 0.2s ease-in-out;\n  border: 0;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ButtonCloseModalConfirmedEmail = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonCloseModalConfirmedEmail",
    componentId: "sc-cad68fb8-0"
})(_templateObject(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[400], ui.theme.colors.neutral.white, ui.theme.colors.secondary[380], ui.theme.colors.secondary[360]);

;// CONCATENATED MODULE: ../../packages/components/ModalConfirmedEmail/index.tsx








var ModalConfirmedEmail = function(param) {
    var isOpen = param.isOpen, onCloseModal = param.onCloseModal, ariaHideApp = param.ariaHideApp, isPasswordWeak = param.isPasswordWeak, onClickAction = param.onClickAction;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGeneral.ModalGeneral, {
        isOpen: isOpen,
        ariaHideApp: ariaHideApp,
        onCloseModal: onCloseModal,
        ariaLabelForModal: "E-mail confirmado",
        title: "E-mail confirmado",
        bodyDescription: isPasswordWeak ? "Voc\xea est\xe1 quase l\xe1. Seu e-mail j\xe1 foi confirmado, agora est\xe1 na hora de atualizar sua senha para garantir a sua seguran\xe7a." : "Seu e-mail foi confirmado com sucesso! Agora voc\xea pode aproveitar as ofertas em nosso site com seguran\xe7a.",
        illustration: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.DeviceCheck, {}),
        bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: isPasswordWeak ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCloseModalConfirmedEmail, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-close-confirmed-email")), {
                onClick: onClickAction,
                children: "Garantir minha seguran\xe7a"
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCloseModalConfirmedEmail, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-close-confirmed-email")), {
                onClick: onCloseModal,
                children: "Fechar"
            }))
        }, "body-content")
    });
};



/***/ }),

/***/ 89459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ModalGeneral": function() { return /* binding */ ModalGeneral; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/Modal/index.tsx
var Modal = __webpack_require__(51345);
;// CONCATENATED MODULE: ../../packages/components/ModalGeneral/styles.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: flex;\n  flex-direction: column;\n  align-items: "center";\n  justify-content: center;\n  width: 100%;\n  min-width: 500px;\n  max-width: ',
        ";\n  padding: ",
        ";\n  gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-bottom: 1px solid ",
        ";\n      margin-bottom: ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  padding: 0.65rem 0rem;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  display: ",
        ";\n  width: ",
        ";\n  justify-content: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: ",
        ";\n  gap: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-align: ",
        ";\n  letter-spacing: -0.025rem;\n  line-height: 140%;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var stylesModalGeneral = function(value) {
    var overlayStyle = {
        overlay: {
            backgroundColor: ui.theme.colors.neutral["900-opacity-25"],
            zIndex: 999
        }
    };
    var contentStyle = {
        padding: "0",
        borderRadius: "6px",
        boxShadow: "7px 7px 7px 0px ".concat(ui.theme.colors.neutral["999-opacity-60"])
    };
    return value ? (0,_object_spread/* default */.Z)({
        content: (0,_object_spread/* default */.Z)({
            top: "none",
            left: "none",
            right: "none",
            position: "absolute",
            bottom: "0",
            marginRight: "none",
            transform: "none"
        }, contentStyle)
    }, overlayStyle) : (0,_object_spread/* default */.Z)({
        content: (0,_object_spread/* default */.Z)({
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)"
        }, contentStyle)
    }, overlayStyle);
};
var ModalGeneralRoot = (0,styled_components_browser_esm/* default */.ZP)(Modal/* Modal */.u).withConfig({
    displayName: "styles__ModalGeneralRoot",
    componentId: "sc-c4ddf56e-0"
})(_templateObject());
var ModalGeneralContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ModalGeneralContainer",
    componentId: "sc-c4ddf56e-1"
})(_templateObject1(), function(param) {
    var maxWidth = param.maxWidth;
    return maxWidth || "38rem";
}, function(param) {
    var padding = param.padding;
    return padding || "1rem 2rem 2rem 2rem";
}, function(param) {
    var containerGap = param.containerGap;
    return containerGap;
});
var HeaderModalGeneralContainer = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__HeaderModalGeneralContainer",
    componentId: "sc-c4ddf56e-2"
})(_templateObject3(), function(param) {
    var hasTitleBorder = param.hasTitleBorder;
    return hasTitleBorder && (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), ui.theme.colors.neutral[150], ui.theme.space.x2);
});
var TitleModalGeneral = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__TitleModalGeneral",
    componentId: "sc-c4ddf56e-3"
})(_templateObject4(), ui.theme.colors.neutral[550], ui.theme.typography.fontFamily.chivo, function(param) {
    var titleFontSize = param.titleFontSize;
    return titleFontSize || "1.35rem";
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight || "".concat(ui.theme.typography.fontWeight[700]);
}, function(param) {
    var centeredTitle = param.centeredTitle;
    return centeredTitle ? "flex" : "block";
}, function(param) {
    var centeredTitle = param.centeredTitle;
    return centeredTitle && "100%";
}, function(param) {
    var centeredTitle = param.centeredTitle;
    return centeredTitle && "center";
});
var CloseModalGeneralWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CloseModalGeneralWrapper",
    componentId: "sc-c4ddf56e-4"
})(_templateObject6(), function(param) {
    var closeModalSize = param.closeModalSize;
    return closeModalSize ? "".concat(closeModalSize, "px") : "2.65rem";
}, function(param) {
    var closeModalSize = param.closeModalSize;
    return closeModalSize ? "".concat(closeModalSize, "px") : "2.65rem";
}, function(param) {
    var hideCloseButton = param.hideCloseButton;
    return hideCloseButton && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
});
var CloseModalGeneralIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.CloseIcon).attrs(function(param) {
    var closeButtonSize = param.closeButtonSize;
    return {
        width: closeButtonSize !== null && closeButtonSize !== void 0 ? closeButtonSize : 24,
        height: closeButtonSize !== null && closeButtonSize !== void 0 ? closeButtonSize : 24,
        color: ui.theme.colors.neutral[550],
        strokeWidth: "1"
    };
}).withConfig({
    displayName: "styles__CloseModalGeneralIcon",
    componentId: "sc-c4ddf56e-5"
})(_templateObject7());
var ModalGeneralContent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ModalGeneralContent",
    componentId: "sc-c4ddf56e-6"
})(_templateObject8(), function(param) {
    var alignItems = param.alignItems;
    return alignItems !== null && alignItems !== void 0 ? alignItems : "center";
}, function(param) {
    var contentGap = param.contentGap;
    return contentGap !== null && contentGap !== void 0 ? contentGap : "1.33rem";
});
var IllustrationModalGeneralWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__IllustrationModalGeneralWrapper",
    componentId: "sc-c4ddf56e-7"
})(_templateObject9());
var DescriptionModalGeneral = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DescriptionModalGeneral",
    componentId: "sc-c4ddf56e-8"
})(_templateObject10(), function(param) {
    var descriptionColor = param.descriptionColor;
    return descriptionColor || "".concat(ui.theme.colors.neutral[525]);
}, ui.theme.typography.fontFamily.chivo, function(param) {
    var descriptionFontSize = param.descriptionFontSize;
    return descriptionFontSize || "1.15rem";
}, ui.theme.typography.fontWeight[400], function(param) {
    var textAlign = param.textAlign;
    return textAlign || "start";
});

;// CONCATENATED MODULE: ../../packages/components/ModalGeneral/index.tsx





var ModalGeneral = function(param) {
    var title = param.title, bodyDescription = param.bodyDescription, ariaLabelForModal = param.ariaLabelForModal, illustration = param.illustration, bodyContent = param.bodyContent, footerContent = param.footerContent, isOpen = param.isOpen, onCloseModal = param.onCloseModal, ariaHideApp = param.ariaHideApp, maxWidth = param.maxWidth, titleFontSize = param.titleFontSize, descriptionFontSize = param.descriptionFontSize, padding = param.padding, descriptionColor = param.descriptionColor, textAlign = param.textAlign, hideCloseButton = param.hideCloseButton, alignItems = param.alignItems, contentGap = param.contentGap, noCloseButton = param.noCloseButton, centeredTitle = param.centeredTitle, fontWeight = param.fontWeight, closeButtonSize = param.closeButtonSize, _hasTitleBorder = param.hasTitleBorder, hasTitleBorder = _hasTitleBorder === void 0 ? true : _hasTitleBorder, _containerGap = param.containerGap, containerGap = _containerGap === void 0 ? "1rem" : _containerGap, _hasHeader = param.hasHeader, hasHeader = _hasHeader === void 0 ? true : _hasHeader, _shouldCloseOnOverlayClick = param.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _shouldCloseOnOverlayClick === void 0 ? true : _shouldCloseOnOverlayClick;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGeneralRoot, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isOpen: isOpen,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        contentLabel: ariaLabelForModal,
        onCloseModal: onCloseModal,
        styles: stylesModalGeneral(isClientMobile),
        ariaHideApp: ariaHideApp,
        testId: "modal-general-root"
    }, (0,application/* buildTestIds */.Fek)("modal-general-root")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalGeneralContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            padding: padding,
            maxWidth: maxWidth,
            containerGap: containerGap
        }, (0,application/* buildTestIds */.Fek)("modal-general-container")), {
            children: [
                hasHeader && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderModalGeneralContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-modal-general-container")), {
                    hasTitleBorder: hasTitleBorder,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleModalGeneral, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            fontWeight: fontWeight,
                            centeredTitle: centeredTitle,
                            titleFontSize: titleFontSize
                        }, (0,application/* buildTestIds */.Fek)("title-modal-general")), {
                            children: title
                        })),
                        !noCloseButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseModalGeneralWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("close-modal-general-wrapper")), {
                            onClick: onCloseModal,
                            closeModalSize: closeButtonSize,
                            hideCloseButton: hideCloseButton,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseModalGeneralIcon, {
                                closeButtonSize: closeButtonSize
                            })
                        }))
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalGeneralContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    alignItems: alignItems,
                    contentGap: contentGap
                }, (0,application/* buildTestIds */.Fek)("modal-general-content")), {
                    children: [
                        illustration && /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationModalGeneralWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("illustration-modal-general-wrapper")), {
                            children: illustration
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionModalGeneral, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            descriptionColor: descriptionColor,
                            textAlign: textAlign,
                            descriptionFontSize: descriptionFontSize
                        }, (0,application/* buildTestIds */.Fek)("description-modal-general")), {
                            children: bodyDescription
                        })),
                        bodyContent
                    ]
                })),
                footerContent
            ]
        }))
    }));
};



/***/ }),

/***/ 68546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ModalPasswordChange": function() { return /* binding */ ModalPasswordChange; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../packages/components/ModalGeneral/index.tsx + 1 modules
var ModalGeneral = __webpack_require__(89459);
// EXTERNAL MODULE: ../../packages/components/Form/index.tsx + 12 modules
var Form = __webpack_require__(29043);
// EXTERNAL MODULE: ../../packages/components/PasswordValidation/index.tsx + 1 modules
var PasswordValidation = __webpack_require__(4043);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/components/ButtonSubmit/index.tsx
var ButtonSubmit = __webpack_require__(42942);
;// CONCATENATED MODULE: ../../packages/components/ModalPasswordChange/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 100%;\n  width: 100% !important;\n  height: 3.75rem;\n  padding: 0.65rem 4.9125rem;\n  text-align: center;\n  font-family: ",
        ";\n  font-size: 1.15rem;\n  font-weight: ",
        ";\n  line-height: 1.3125rem;\n  letter-spacing: 0.005rem;\n\n  border-radius: 4px;\n  color: ",
        ";\n  background: ",
        ";\n  cursor: pointer;\n  transition: background 0.2s ease-in-out;\n  border: 0;\n\n  &:hover {\n    background: ",
        " !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1.35rem;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var ButtonConfirmModalPasswordChange = (0,styled_components_browser_esm/* default */.ZP)(ButtonSubmit/* ButtonSubmit */.G).withConfig({
    displayName: "styles__ButtonConfirmModalPasswordChange",
    componentId: "sc-74a303ee-0"
})(_templateObject(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[400], ui.theme.colors.neutral.white, ui.theme.colors.secondary[380], ui.theme.colors.secondary[360]);
var ChangePasswordForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "styles__ChangePasswordForm",
    componentId: "sc-74a303ee-1"
})(_templateObject1());
var InputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__InputWrapper",
    componentId: "sc-74a303ee-2"
})(_templateObject2());
var PasswordValidationWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PasswordValidationWrapper",
    componentId: "sc-74a303ee-3"
})(_templateObject3());
var EyeOpenIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.NewEyeOpenIcon).attrs({
    width: 20,
    height: 18
}).withConfig({
    displayName: "styles__EyeOpenIcon",
    componentId: "sc-74a303ee-4"
})(_templateObject4());
var EyeCloseIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.NewEyeCloseIcon).withConfig({
    displayName: "styles__EyeCloseIcon",
    componentId: "sc-74a303ee-5"
})(_templateObject5());

;// CONCATENATED MODULE: ../../packages/components/ModalPasswordChange/index.tsx














var ModalPasswordChange = function(param) {
    var isOpen = param.isOpen, ariaHideApp = param.ariaHideApp, onBeforeCloseModalAction = param.onBeforeCloseModalAction, onCloseModal = param.onCloseModal;
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var accessToken = implementations/* cookie.getCookie */.pR.getCookie({
        name: "@FC:Ecom:Token:Access"
    });
    var ref = implementations/* profileApi.getClient */.c_.getClient(accessToken, !!accessToken), data = ref.data, profileError = ref.error;
    var ref1 = (0,react.useState)(false), changingPassword = ref1[0], setChangingPassword = ref1[1];
    var ref2 = (0,index_esm/* useForm */.cI)(), register = ref2.register, handleSubmit = ref2.handleSubmit, setValue = ref2.setValue, watch = ref2.watch;
    var ref3 = (0,react.useState)(0), passwordStrength = ref3[0], setPasswordStrength = ref3[1];
    var ref4 = (0,react.useState)("password"), currentPasswordType = ref4[0], setCurrentPasswordType = ref4[1];
    var ref5 = (0,react.useState)("password"), newPasswordType = ref5[0], setNewPasswordType = ref5[1];
    var ref6 = (0,react.useState)("password"), confirmNewPasswordType = ref6[0], setConfirmNewPasswordType = ref6[1];
    var currentPasswordWatcher = watch("currentPassword");
    var newPasswordWatcher = watch("newPassword");
    var confirmNewPasswordWatcher = watch("confirmNewPassword");
    if (profileError) {
        implementations/* appMonitoringClient.captureException */.pE.captureException(profileError);
    }
    var changePasswordVisibility = function(type) {
        return type === "password" ? "text" : "password";
    };
    var changePasswordIcon = function(type) {
        return type === "password" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeCloseIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeOpenIcon, {});
    };
    var isInvalidNewPassword = (0,application/* validatePassword */.uo4)(newPasswordWatcher);
    var isInvalidConfirmPassword = (0,application/* validateConfirmPassword */.S$0)(newPasswordWatcher, confirmNewPasswordWatcher);
    var isFormInvalid = !currentPasswordWatcher || isInvalidNewPassword || isInvalidConfirmPassword || !newPasswordWatcher || !confirmNewPasswordWatcher || passwordStrength !== 5;
    var resetForm = (0,react.useCallback)(function() {
        setValue("password", "");
        setValue("currentPassword", "");
        setCurrentPasswordType("password");
        setValue("newPassword", "");
        setNewPasswordType("password");
        setValue("confirmNewPassword", "");
        setConfirmNewPasswordType("password");
    }, [
        setValue
    ]);
    var onSaveNewPassword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var currentPassword, newPassword, changePasswordBody, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentPassword = param.currentPassword, newPassword = param.newPassword;
                        if (!accessToken) return [
                            3,
                            2
                        ];
                        setChangingPassword(true);
                        changePasswordBody = {
                            email: (data === null || data === void 0 ? void 0 : data.email) || "",
                            currentPassword: currentPassword,
                            newPassword: newPassword
                        };
                        return [
                            4,
                            implementations/* identityApi.changePassword */.IJ.changePassword(accessToken, changePasswordBody)
                        ];
                    case 1:
                        error = _state.sent().error;
                        setChangingPassword(false);
                        if (error) {
                            addToast({
                                title: "Erro ao tentar alterar senha",
                                description: error,
                                type: "error",
                                newToastTheme: "light",
                                isNewToast: true
                            });
                            return [
                                2
                            ];
                        }
                        resetForm();
                        onCloseModal();
                        onBeforeCloseModalAction();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSaveNewPassword(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var isNewPasswordValid = (newPasswordWatcher === null || newPasswordWatcher === void 0 ? void 0 : newPasswordWatcher.length) > 0;
    var verifyNewPassword = isInvalidNewPassword && isNewPasswordValid;
    var isConfirmPasswordValid = (confirmNewPasswordWatcher === null || confirmNewPasswordWatcher === void 0 ? void 0 : confirmNewPasswordWatcher.length) > 0;
    var verifyConfirmPassword = isInvalidConfirmPassword && isConfirmPasswordValid;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGeneral.ModalGeneral, {
        ariaHideApp: ariaHideApp,
        isOpen: isOpen,
        onCloseModal: onCloseModal,
        ariaLabelForModal: "Alterar senha",
        title: "Alterar senha",
        bodyDescription: "Percebemos que sua senha pode ser mais segura. Vamos atualiz\xe1-la para garantir a prote\xe7\xe3o de sua conta?",
        illustration: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.DevicePasswordChange, {}),
        bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChangePasswordForm, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("change-password-form")), {
                    onSubmit: handleSubmit(onSaveNewPassword),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("current-password-input-wrapper")), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Label */.__, {
                                    htmlFor: "currentPassword",
                                    text: "Senha atual",
                                    color: ui.theme.colors.neutral[750],
                                    fontSize: ui.theme.typography.fontSize.sm.x7,
                                    typeFontWeight: ui.theme.typography.fontWeight[400]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    id: "current-password",
                                    name: "currentPassword",
                                    type: currentPasswordType,
                                    placeholder: "Digite sua senha",
                                    register: register,
                                    disabled: changingPassword,
                                    hasError: (0,application/* validatePassword */.uo4)(currentPasswordWatcher) && (currentPasswordWatcher === null || currentPasswordWatcher === void 0 ? void 0 : currentPasswordWatcher.length) > 0,
                                    textError: (0,application/* validatePassword */.uo4)(currentPasswordWatcher),
                                    width: "100%"
                                }, (0,application/* buildTestIds */.Fek)("current-password-input")), {
                                    onChange: function(param) {
                                        var target = param.target;
                                        return setValue("currentPassword", target === null || target === void 0 ? void 0 : target.value);
                                    },
                                    height: "45px",
                                    padding: "1rem",
                                    margin: "".concat(ui.theme.space["x2.5"], " 0px 0px 0px"),
                                    hasIcon: true,
                                    onClickIcon: function() {
                                        return setCurrentPasswordType(changePasswordVisibility(currentPasswordType));
                                    },
                                    icon: changePasswordIcon(currentPasswordType)
                                }))
                            ]
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("new-password-input-wrapper")), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Label */.__, {
                                    htmlFor: "new-password",
                                    text: "Senha",
                                    color: ui.theme.colors.neutral[750],
                                    fontSize: ui.theme.typography.fontSize.sm.x7,
                                    typeFontWeight: ui.theme.typography.fontWeight[400]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    id: "new-password",
                                    name: "newPassword",
                                    type: newPasswordType,
                                    placeholder: "Digite sua senha",
                                    register: register,
                                    disabled: changingPassword,
                                    hasError: verifyNewPassword,
                                    hasSuccessfully: isNewPasswordValid && !verifyNewPassword,
                                    width: "100%"
                                }, (0,application/* buildTestIds */.Fek)("new-password-input")), {
                                    onChange: function(param) {
                                        var target = param.target;
                                        return setValue("newPassword", target === null || target === void 0 ? void 0 : target.value);
                                    },
                                    height: "45px",
                                    padding: "1rem",
                                    hasIcon: true,
                                    paddingInfo: "0px",
                                    paddingErrorMessage: "0px",
                                    onClickIcon: function() {
                                        return setNewPasswordType(changePasswordVisibility(newPasswordType));
                                    },
                                    icon: changePasswordIcon(newPasswordType),
                                    fontSizeInfo: ui.theme.typography.fontSize.sm.x3,
                                    colorInfo: ui.theme.colors.neutral[550],
                                    textError: isInvalidNewPassword,
                                    margin: "".concat(ui.theme.space["x2.5"], " 0px 0px 0px")
                                }))
                            ]
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-new-password-input-wrapper")), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Label */.__, {
                                    htmlFor: "confirm-new-password",
                                    text: "Confirme a senha",
                                    color: ui.theme.colors.neutral[750],
                                    fontSize: ui.theme.typography.fontSize.sm.x7,
                                    typeFontWeight: ui.theme.typography.fontWeight[400]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    id: "confirm-new-password",
                                    name: "confirmNewPassword",
                                    type: confirmNewPasswordType,
                                    placeholder: "Digite sua senha",
                                    register: register,
                                    disabled: changingPassword,
                                    hasError: verifyConfirmPassword,
                                    hasSuccessfully: isConfirmPasswordValid && !verifyConfirmPassword,
                                    textError: isInvalidConfirmPassword,
                                    width: "100%"
                                }, (0,application/* buildTestIds */.Fek)("confirm-new-password-input")), {
                                    onChange: function(param) {
                                        var target = param.target;
                                        return setValue("confirmNewPassword", target === null || target === void 0 ? void 0 : target.value);
                                    },
                                    hasIcon: true,
                                    paddingInfo: "0px",
                                    paddingErrorMessage: "0px",
                                    onClickIcon: function() {
                                        return setConfirmNewPasswordType(changePasswordVisibility(confirmNewPasswordType));
                                    },
                                    icon: changePasswordIcon(confirmNewPasswordType),
                                    fontSizeInfo: ui.theme.typography.fontSize.sm.x3,
                                    colorInfo: ui.theme.colors.neutral[550],
                                    height: "45px",
                                    padding: "1rem",
                                    margin: "".concat(ui.theme.space["x2.5"], " 0px 0px 0px")
                                }))
                            ]
                        }))
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordValidationWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("password-validation-wrapper")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordValidation/* PasswordValidation */.T, {
                        showComponent: isNewPasswordValid,
                        userConfirmPassword: confirmNewPasswordWatcher,
                        userPassword: newPasswordWatcher,
                        onChangePasswordStrength: function(strength) {
                            return setPasswordStrength(strength);
                        }
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirmModalPasswordChange, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("change-password-button")), {
                    isDisabled: !!isFormInvalid,
                    text: "Confirmar",
                    textUnderAction: "Confirmando...",
                    underAction: changingPassword,
                    onClickAction: handleSubmit(onSaveNewPassword)
                }))
            ]
        })
    });
};



/***/ }),

/***/ 91285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ModalPasswordChanged": function() { return /* binding */ ModalPasswordChanged; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/components/ModalGeneral/index.tsx + 1 modules
var ModalGeneral = __webpack_require__(89459);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/ModalPasswordChanged/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 100%;\n  height: 3.75rem;\n  padding: 0.65rem 4.9125rem;\n  text-align: center;\n  font-family: ",
        ";\n  font-size: 1.15rem;\n  font-weight: ",
        ";\n  line-height: 1.3125rem;\n  letter-spacing: 0.005rem;\n\n  border-radius: 4px;\n  color: ",
        ";\n  background: ",
        ";\n  cursor: pointer;\n  transition: background 0.2s ease-in-out;\n  border: 0;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ButtonConfirmModalPasswordChanged = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonConfirmModalPasswordChanged",
    componentId: "sc-331e9c38-0"
})(_templateObject(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[400], ui.theme.colors.neutral.white, ui.theme.colors.secondary[380], ui.theme.colors.secondary[360]);

;// CONCATENATED MODULE: ../../packages/components/ModalPasswordChanged/index.tsx







var ModalPasswordChanged = function(param) {
    var isOpen = param.isOpen, ariaHideApp = param.ariaHideApp, onCloseModal = param.onCloseModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGeneral.ModalGeneral, {
        ariaHideApp: ariaHideApp,
        isOpen: isOpen,
        onCloseModal: onCloseModal,
        ariaLabelForModal: "Senha alterada com sucesso",
        title: "Senha alterada com sucesso",
        bodyDescription: "Sua senha e seu e-mail foram confirmados com sucesso! Agora voc\xea pode aproveitar as ofertas em nosso site com seguran\xe7a.",
        illustration: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.DevicePasswordChanged, {}),
        bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirmModalPasswordChanged, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-confirm-modal-password-changed")), {
            onClick: onCloseModal,
            children: "Fechar"
        }))
    });
};



/***/ }),

/***/ 38677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NoOrders": function() { return /* binding */ NoOrders; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/NoOrders/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: -40px;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n  height: 440px;\n  padding: ",
        ";\n\n  @media ",
        " {\n    margin-top: ",
        ";\n  }\n\n  @media ",
        " {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var NoOrderContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__NoOrderContainer",
    componentId: "sc-7bebb044-0"
})(_templateObject(), ui.theme.space.x6, ui.theme.space.x4, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "0";
}, ui.theme.device.desktopFirst.tabletL, ui.theme.space.x4, ui.theme.device.mobileFirst.laptop, ui.theme.space.x8);
var NoOrderIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__NoOrderIcon",
    componentId: "sc-7bebb044-1"
})(_templateObject1());
var NoOrderTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__NoOrderTitle",
    componentId: "sc-7bebb044-2"
})(_templateObject2(), ui.theme.colors.neutral[550], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.md.x1, ui.theme.typography.fontWeight[600]);
var NoOrderDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__NoOrderDescription",
    componentId: "sc-7bebb044-3"
})(_templateObject3(), ui.theme.colors.neutral[350], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[400]);
var ActionOptionsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ActionOptionsWrapper",
    componentId: "sc-7bebb044-4"
})(_templateObject4(), ui.theme.space.x4);
var DescriptionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DescriptionContainer",
    componentId: "sc-7bebb044-5"
})(_templateObject5(), ui.theme.space.x2);
var ActionOptionsText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ActionOptionsText",
    componentId: "sc-7bebb044-6"
})(_templateObject6(), ui.theme.colors.neutral[340], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[700]);
var OptionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__OptionsContainer",
    componentId: "sc-7bebb044-7"
})(_templateObject7(), ui.theme.space.x4);
var Option = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Option",
    componentId: "sc-7bebb044-8"
})(_templateObject8(), ui.theme.space.x2);
var OptionText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__OptionText",
    componentId: "sc-7bebb044-9"
})(_templateObject9(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[400], ui.theme.colors.secondary[380]);
var OptionIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__OptionIcon",
    componentId: "sc-7bebb044-10"
})(_templateObject10());

;// CONCATENATED MODULE: ../../packages/components/NoOrders/index.tsx








var NoOrders = function(param) {
    var icon = param.icon, title = param.title, description = param.description, termSearched = param.termSearched, clearSearch = param.clearSearch, padding = param.padding;
    var router = (0,next_router.useRouter)();
    var clearSearchTerm = (0,react.useCallback)(function() {
        if (clearSearch) {
            clearSearch("");
        }
    }, [
        clearSearch
    ]);
    var renderOptions = function() {
        if (termSearched === null || termSearched === void 0 ? void 0 : termSearched.length) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-clear-search")), {
                        onClick: clearSearchTerm,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-icon-clear-search")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.EraseIcon, {})
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-text-clear-search")), {
                                children: "Limpar pesquisa"
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-search-for-term-on-site")), {
                        onClick: function() {
                            return router.push("/pesquisa/".concat(termSearched));
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-icon-search-for-term-on-site")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Search, {
                                    width: 16,
                                    height: 16,
                                    strokeWidth: "2",
                                    color: ui.theme.colors.secondary[380]
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-text-search-for-term-on-site")), {
                                children: [
                                    'Pesquisar "',
                                    termSearched,
                                    '" no site'
                                ]
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-turn-back-to-home-search")), {
                        onClick: function() {
                            return router.push("/");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-icon-turn-back-to-home-search")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.House, {
                                    width: 14,
                                    height: 14,
                                    color: ui.theme.colors.secondary[380]
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-text-turn-back-to-home-search")), {
                                children: "Ir para p\xe1gina inicial"
                            }))
                        ]
                    }))
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-turn-back-to-previous-page")), {
                    onClick: function() {
                        return router.back();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-icon-turn-back-to-previous-page")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowLeft, {
                                width: 16,
                                height: 16,
                                color: ui.theme.colors.secondary[380]
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-text-turn-back-to-previous-page")), {
                            children: "Voltar para a p\xe1gina anterior"
                        }))
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-turn-back-to-home")), {
                    onClick: function() {
                        return router.push("/");
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-icon-turn-back-to-home")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.House, {
                                width: 14,
                                height: 14,
                                color: ui.theme.colors.secondary[380]
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-text-turn-back-to-home")), {
                            children: "Ir para p\xe1gina inicial"
                        }))
                    ]
                }))
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoOrderContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        padding: padding
    }, (0,application/* buildTestIds */.Fek)("no-order-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoOrderIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("no-order-icon")), {
                children: icon
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DescriptionContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("description-container")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoOrderTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("no-order-title")), {
                        children: title
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoOrderDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("no-order-description")), {
                        children: description
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionOptionsWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("action-options-wrapper")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionOptionsText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("action-options-text")), {
                        children: "O que voc\xea pode fazer?"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("options-container")), {
                        children: renderOptions()
                    }))
                ]
            }))
        ]
    }));
};



/***/ }),

/***/ 49926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ Paginator; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/Paginator/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 2.3rem;\n  height: 2.3rem;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 0;\n  background-color: ",
        ";\n  border-radius: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    svg {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 3px 4px -1px rgba(0, 0, 0, 0.16);\n  margin: 0 1rem;\n  border-radius: 4px;\n  overflow: hidden;\n\n  &:last-of-child {\n    cursor: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      pointer-events: none;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 4rem;\n  height: 3.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  color: ",
        ";\n  transition: ease-in-out 0.2s;\n\n  ",
        ";\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        background-color: ",
        ";\n\n        &:hover {\n          svg > path {\n            fill: ",
        ";\n          }\n        }\n      }\n\n      ",
        " {\n        color: ",
        ";\n        background-color: ",
        ";\n\n        &.page-number-selected {\n          color: ",
        ";\n          background-color: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  width: calc(100% - 7px);\n  height: 60px;\n  margin-left: 7px;\n  align-items: center;\n  justify-content: center;\n  margin: 15px 0;\n\n  @media ",
        " {\n    width: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var PageChangeButton = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__PageChangeButton",
    componentId: "sc-d60321a6-0"
})(_templateObject(), ui.theme.colors.neutral.white, ui.theme.colors.neutral.white);
var PageCounter = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "styles__PageCounter",
    componentId: "sc-d60321a6-1"
})(_templateObject1());
var Page = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__Page",
    componentId: "sc-d60321a6-2"
})(_templateObject3(), ui.theme.colors.neutral[450], function(param) {
    var ellipsis = param.ellipsis;
    return ellipsis ? "cursor: default !important;\n        color: ".concat(ui.theme.colors.neutral[450], " !important;\n        background-color: ").concat(ui.theme.colors.neutral.white) : "";
}, function(param) {
    var isSelected = param.isSelected;
    return isSelected ? "\n      background-color: ".concat(ui.theme.colors.primary[200], ";\n      color: ").concat(ui.theme.colors.neutral.white, ";\n      cursor: default;") : "&:hover {\n        background-color: ".concat(ui.theme.colors.primary[200], ";\n        color: ").concat(ui.theme.colors.neutral.white, ";\n        cursor: pointer;\n        }");
}, function(param) {
    var isLoading = param.isLoading;
    return isLoading && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
});
var ArrowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ArrowWrapper",
    componentId: "sc-d60321a6-3"
})(_templateObject4());
var Counter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Counter",
    componentId: "sc-d60321a6-4"
})(_templateObject5(), ui.theme.typography.fontSize.sm.x5, ui.theme.colors.neutral[999]);
var PaginatorContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__PaginatorContainer",
    componentId: "sc-d60321a6-5"
})(_templateObject7(), ui.theme.device.desktopFirst.mobileL, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), PageChangeButton, ui.theme.colors.neutral[670], ui.theme.colors.neutral.white, Page, ui.theme.colors.neutral[88], ui.theme.colors.neutral[670], ui.theme.colors.neutral["white-075"], ui.theme.colors.primary[200]);
});

;// CONCATENATED MODULE: ../../packages/components/Paginator/index.tsx









var Paginator = function(param) {
    var _identifier = param.identifier, identifier = _identifier === void 0 ? "default" : _identifier, visiblePages = param.visiblePages, pageSize = param.pageSize, totalRows = param.totalRows, justifyContent = param.justifyContent, loading = param.loading, page = param.page, pageChangeHandler = param.pageChangeHandler, pageClickHandler = param.pageClickHandler, _indexBased = param.indexBased, indexBased = _indexBased === void 0 ? 1 : _indexBased, filteredLabel = param.filteredLabel, isBlackTheme = param.isBlackTheme;
    var ref = (0,react.useState)(Math.ceil(totalRows / pageSize)), totalPages = ref[0], setTotalPages = ref[1];
    var ref1 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(new Array(totalPages))), pagesArray = ref1[0], setPagesArray = ref1[1];
    var cookiesKey = "currentPage_".concat(identifier);
    (0,react.useEffect)(function() {
        if (identifier === "default") {
            implementations/* cookie.setCookie */.pR.setCookie({
                name: cookiesKey,
                value: "",
                options: {
                    maxAge: 600
                }
            });
        }
    }, [
        cookiesKey,
        identifier
    ]);
    var storedPage = implementations/* cookie.getCookie */.pR.getCookie({
        name: cookiesKey
    });
    var backToTopPage = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var ref2 = (0,react.useState)(function() {
        return storedPage ? parseInt(storedPage, 10) : page;
    }), currentPage = ref2[0], setCurrentPage = ref2[1];
    var ref3 = (0,react.useState)(filteredLabel), previousFilteredLabel = ref3[0], setPreviousFilteredLabel = ref3[1];
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    (0,react.useEffect)(function() {
        if (totalRows) {
            var newTotalPages = Math.ceil(totalRows / pageSize);
            setTotalPages(newTotalPages);
            setPagesArray((0,_to_consumable_array/* default */.Z)(new Array(newTotalPages)));
            if (currentPage > newTotalPages) {
                setCurrentPage(newTotalPages);
            }
        } else {
            setTotalPages(0);
            setPagesArray([]);
            setCurrentPage(indexBased);
        }
    }, [
        totalRows,
        pageSize,
        currentPage,
        totalPages,
        indexBased
    ]);
    (0,react.useEffect)(function() {
        if (filteredLabel !== previousFilteredLabel) {
            setCurrentPage(indexBased);
            setPreviousFilteredLabel(filteredLabel);
        }
    }, [
        filteredLabel,
        indexBased,
        previousFilteredLabel
    ]);
    var onNextPage = (0,react.useCallback)(function() {
        setCurrentPage(function(current) {
            return current + 1;
        });
        backToTopPage();
    }, []);
    var onPrevPage = (0,react.useCallback)(function() {
        setCurrentPage(function(current) {
            return current - 1;
        });
        backToTopPage();
    }, []);
    var onPageSelect = (0,react.useCallback)(function(pageNumber) {
        setCurrentPage(pageNumber);
        backToTopPage();
    }, []);
    var ref4 = (0,react.useState)([]), visiblePagesArray = ref4[0], setVisiblePagesArray = ref4[1];
    var handleVisiblePages = function(newCurrentPage) {
        var middleNumber = Math.floor(visiblePages / 2);
        var tempVisiblePagesArray = [];
        var count = 0;
        if (newCurrentPage <= middleNumber) {
            count = indexBased;
            while(count <= visiblePages){
                tempVisiblePagesArray.push(count);
                count += 1;
            }
            setVisiblePagesArray(tempVisiblePagesArray);
            return;
        }
        if (newCurrentPage > middleNumber && newCurrentPage < totalPages - middleNumber) {
            count = newCurrentPage - middleNumber;
            while(count <= newCurrentPage + middleNumber){
                tempVisiblePagesArray.push(count);
                count += 1;
            }
            setVisiblePagesArray(tempVisiblePagesArray);
            return;
        }
        if (newCurrentPage >= totalPages - middleNumber) {
            count = totalPages - visiblePages + 1;
            while(count <= totalPages){
                tempVisiblePagesArray.push(count);
                count += 1;
            }
            setVisiblePagesArray(tempVisiblePagesArray);
        }
    };
    (0,react.useEffect)(function() {
        if (!Number.isNaN(currentPage)) {
            if (pageChangeHandler) {
                pageChangeHandler(currentPage);
            }
            handleVisiblePages(currentPage);
        }
    // Remover o eslint-disable abaixo e resolver dependências do useEffect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginatorContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("paginator-container")), {
        isBlackTheme: isBlackTheme,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.FlexContainer, {
            "data-testid": "paginator-flex-container",
            "flex-flexDirection": "row",
            alignItems: "center",
            justifyContent: justifyContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageChangeButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("paginator-back-button")), {
                    onClick: function() {
                        onPrevPage();
                        if (pageClickHandler) {
                            pageClickHandler();
                        }
                    },
                    isDisabled: loading || currentPage === indexBased,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowLeft, {
                        color: ui.theme.colors.neutral[450],
                        "data-testid": "component-paginator-arrow-left"
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageCounter, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("page-counter")), {
                    children: [
                        currentPage > indexBased + 2 && totalPages > indexBased + 4 && !isClientMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            isSelected: false,
                            isLoading: loading,
                            ellipsis: true
                        }, (0,application/* buildTestIds */.Fek)("page-ellipsis-left")), {
                            children: "..."
                        })),
                        pagesArray.map(function(num, index) {
                            return visiblePagesArray.includes(index + indexBased) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                isSelected: currentPage === index + indexBased
                            }, (0,application/* buildTestIds */.Fek)(currentPage === index + indexBased ? "page-selected" : "page-".concat(index + 1))), {
                                isLoading: loading,
                                onClick: function() {
                                    onPageSelect(index + indexBased);
                                    if (pageClickHandler) {
                                        pageClickHandler();
                                    }
                                },
                                className: currentPage === index + indexBased ? "page-number-selected" : "page-number",
                                children: index + 1
                            }), index.toString()) : null;
                        }),
                        pagesArray.length - indexBased - 1 > currentPage && totalPages > indexBased + 4 && !isClientMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            isSelected: false,
                            isLoading: loading,
                            ellipsis: true
                        }, (0,application/* buildTestIds */.Fek)("page-ellipsis-right")), {
                            children: "..."
                        }))
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageChangeButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("paginator-forward-button")), {
                    isDisabled: loading || (indexBased === 1 ? currentPage === totalPages : currentPage + 1 === totalPages),
                    onClick: function() {
                        onNextPage();
                        if (pageClickHandler) {
                            pageClickHandler();
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("paginator-arrow-right")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowRight, {
                            color: ui.theme.colors.neutral[450],
                            "data-testid": "component-paginator-arrow-right"
                        })
                    }))
                }))
            ]
        })
    }));
};



/***/ }),

/***/ 4043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ PasswordValidation; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/PasswordValidation/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 0.4rem;\n  font-size: ",
        ";\n  color: ",
        " !important;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: initial !important;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  flex-direction: column;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-size: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var PasswordValidationContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PasswordValidationContainer",
    componentId: "sc-8df5b2dc-0"
})(_templateObject(), function(param) {
    var marginTop = param.marginTop;
    return marginTop;
}, ui.theme.space.x2);
var StrengthIndicator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StrengthIndicator",
    componentId: "sc-8df5b2dc-1"
})(_templateObject1(), ui.theme.typography.fontSize.sm.x5, ui.theme.colors.neutral[550], ui.theme.space.x2);
var PasswordStrength = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__PasswordStrength",
    componentId: "sc-8df5b2dc-2"
})(_templateObject2(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[600]);
var StrengthIndicatorItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StrengthIndicatorItems",
    componentId: "sc-8df5b2dc-3"
})(_templateObject3(), ui.theme.space.x2);
var StrengthIndicatorItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StrengthIndicatorItem",
    componentId: "sc-8df5b2dc-4"
})(_templateObject4(), ui.theme.space.x2);
var StrengthIndicatorText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__StrengthIndicatorText",
    componentId: "sc-8df5b2dc-5"
})(_templateObject5(), function(param) {
    var color = param.color;
    return color;
}, ui.theme.typography.fontSize.sm.x5);

;// CONCATENATED MODULE: ../../packages/components/PasswordValidation/index.tsx







var PasswordValidation = function(param) {
    var userPassword = param.userPassword, userConfirmPassword = param.userConfirmPassword, marginTop = param.marginTop, showComponent = param.showComponent, onChangePasswordStrength = param.onChangePasswordStrength;
    var ref = (0,application/* useValidatePassword */.fTF)({
        userPassword: userPassword,
        userConfirmPassword: userConfirmPassword
    }), passwordHasLowerCaseLetters = ref.passwordHasLowerCaseLetters, passwordHasMoreThanSevenCharacters = ref.passwordHasMoreThanSevenCharacters, passwordHasNumbers = ref.passwordHasNumbers, passwordHasUpperCaseLetters = ref.passwordHasUpperCaseLetters, passwordsMatch = ref.passwordsMatch, validItems = ref.validItems, strongPassword = ref.strongPassword;
    var verifyPasswordStrength = function() {
        if (strongPassword) return "forte";
        if (validItems === 5) return "m\xe9dia";
        return "baixa";
    };
    var iconVerification = function(verification) {
        return verification ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CircleCheckIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CircleErrorIcon, {});
    };
    var textColor = function(verification) {
        return verification ? ui.theme.colors.secondary[380] : ui.theme.colors.primary[155];
    };
    (0,react.useEffect)(function() {
        onChangePasswordStrength(validItems);
    }, [
        onChangePasswordStrength,
        validItems
    ]);
    if (!showComponent) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PasswordValidationContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("password-validation-container")), {
        marginTop: marginTop,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StrengthIndicator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("strength-indicator")), {
                children: [
                    "For\xe7a da senha:",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordStrength, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("password-strength")), {
                        children: verifyPasswordStrength()
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StrengthIndicatorItems, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("strength-indicator-items")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StrengthIndicatorItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("strength-indicator-characters")), {
                        children: [
                            iconVerification(passwordHasMoreThanSevenCharacters),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StrengthIndicatorText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                color: textColor(passwordHasMoreThanSevenCharacters)
                            }, (0,application/* buildTestIds */.Fek)("strength-indicator-characters-text")), {
                                children: "Cont\xe9m pelo menos 8 caracteres"
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StrengthIndicatorItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("strength-indicator-numbers")), {
                        children: [
                            iconVerification(passwordHasNumbers),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StrengthIndicatorText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("strength-indicator-numbers-text")), {
                                color: textColor(passwordHasNumbers),
                                children: "Cont\xe9m n\xfamero"
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StrengthIndicatorItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("strength-indicator-upper-case-letters")), {
                        children: [
                            iconVerification(passwordHasUpperCaseLetters),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StrengthIndicatorText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("strength-indicator-upper-case-letters-text")), {
                                color: textColor(passwordHasUpperCaseLetters),
                                children: "Cont\xe9m letra mai\xfascula"
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StrengthIndicatorItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("strength-indicator-lower-case-letters")), {
                        children: [
                            iconVerification(passwordHasLowerCaseLetters),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StrengthIndicatorText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("strength-indicator-lower-case-letters-text")), {
                                color: textColor(passwordHasLowerCaseLetters),
                                children: "Cont\xe9m letra min\xfascula"
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StrengthIndicatorItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("strength-indicator-passwords-match")), {
                        children: [
                            iconVerification(passwordsMatch),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StrengthIndicatorText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("strength-indicator-passwords-match-text")), {
                                color: textColor(passwordsMatch),
                                children: "Senhas correspondem"
                            }))
                        ]
                    }))
                ]
            }))
        ]
    }));
};



/***/ }),

/***/ 57073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Playlist; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/ProductCard/index.tsx
var ProductCard = __webpack_require__(95770);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/components/ProductCard/styles.ts
var styles = __webpack_require__(3483);
;// CONCATENATED MODULE: ../../packages/components/Playlist/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 7px;\n  width: ",
        ";\n  align-items: center;\n  justify-content: flex-start;\n  place-items: center;\n\n  //artur.castro essa \xe9 uma media query especifica para o comportamento\n  @media (max-width: 1280px) {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 7px;\n  }\n\n  @media ",
        " {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 7px;\n  }\n\n  @media ",
        " {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 7px;\n  }\n\n  //artur.castro essa \xe9 uma media query especifica para o comportamento\n  @media (max-width: 620px) {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 7px;\n  }\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 50%);\n    gap: 0px;\n    column-gap: ",
        ";\n  }\n\n  @media ",
        " {\n    grid-template-columns: repeat(1, calc(100% - 2px));\n    gap: 0px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-height: 100%;\n  height: 100%;\n  max-height: 100%;\n\n  ",
        " {\n    height: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PlaylistStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PlaylistStyled",
    componentId: "sc-f436b775-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width || "100%";
}, ui.theme.device.desktopFirst.laptop, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL, function(param) {
    var isProductPage = param.isProductPage;
    return isProductPage ? "8px" : "0";
}, ui.theme.device.desktopFirst.mobileS);
var CardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CardContainer",
    componentId: "sc-f436b775-1"
})(_templateObject1(), styles/* ProductCardContainer */.hd);

;// CONCATENATED MODULE: ../../packages/components/Playlist/index.tsx









var Playlist = function(param) {
    var productCards = param.productCards, searchTerm = param.searchTerm, playlistName = param.playlistName, playlistId = param.playlistId, _preloadComponent = param.preloadComponent, preloadComponent = _preloadComponent === void 0 ? false : _preloadComponent;
    var router = (0,next_router.useRouter)();
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var isProductPage = (router === null || router === void 0 ? void 0 : router.route) === "/produto/[idProduct]/[nameProduct]";
    return /*#__PURE__*/ (0,react.createElement)(PlaylistStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("playlist-styled-component")), {
        key: "playlist-styled-".concat(playlistId),
        isProductPage: isProductPage
    }), productCards ? productCards === null || productCards === void 0 ? void 0 : productCards.map(function(item, index) {
        /*#__PURE__*/ return (0,react.createElement)(CardContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("card-container-".concat(index))), {
            key: item === null || item === void 0 ? void 0 : item.id
        }), /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-card-".concat(index))), {
            playlistId: playlistId,
            playlistName: playlistName,
            searchTerm: searchTerm,
            item: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                index: (0,application/* getProductPosition */.E8Y)(index)
            }),
            shouldShowInGridOnMobile: isClientMobile,
            index: index,
            isPlaylist: true,
            preloadComponent: preloadComponent && index < 5
        })));
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("result-not-found-text")), {
        children: "Resultado n\xe3o encontrado."
    })));
};
/* harmony default export */ var components_Playlist = (Playlist);


/***/ }),

/***/ 15261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PopUpAlertConfirm": function() { return /* binding */ PopUpAlertConfirm; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/PopUpAlertConfirm/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-itens: center;\n  background-color: ",
        ";\n  width: fit-content;\n  height: fit-content;\n  padding: ",
        ";\n  border-radius: ",
        ";\n\n  position: fixed;\n  left: ",
        ";\n  top: ",
        ";\n  transform: translate(-50%, -50%);\n  z-index: 99999;\n\n  box-shadow: 4px 4px 8px 0px ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 3rem;\n  max-width: 3rem;\n  padding: 0.5rem;\n  cursor: pointer;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: none;\n  border: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  width: fit-content;\n  height: fit-content;\n  padding: ",
        ";\n  border-radius: ",
        ";\n\n  position: fixed;\n  left: ",
        ";\n  top: ",
        ";\n  transform: translate(-50%, -50%);\n  z-index: 99999;\n\n  box-shadow: 4px 4px 14px 0px ",
        ";\n  border: 2px solid;\n  border-color: ",
        ";\n  min-width: 24rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // padding-bottom: 1rem;\n  position: relative;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n  max-height: 3rem;\n  max-width: 3rem;\n  padding: 0.5rem;\n\n  position: absolute;\n  top: -1rem;\n  right: -1rem;\n  cursor: pointer;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: ",
        ";\n\n  border: 2px solid;\n  border-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  background: none;\n\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n  font-size: ",
        ";\n  font-weight: 500;\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  background: ",
        ";\n\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n  font-size: ",
        ";\n  font-weight: 500;\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  border-bottom: ",
        ";\n  padding-bottom: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n  margin-top: 1.2rem;\n  border-top: 0.05rem solid ",
        ";\n\n  display: flex;\n  justify-content: flex-end;\n  gap: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var COLOR_TYPE_INFO = {
    info: ui.theme.colors.tertiary[300],
    warn: ui.theme.colors.yellow[600],
    error: ui.theme.colors.primary[200],
    success: ui.theme.colors.secondary[400]
};
var LOCATION_HORIZONTAL = {
    left: "10%",
    center: "50%",
    right: "90%"
};
var LOCATION_VERTICAL = {
    bottom: "90%",
    center: "50%",
    top: "10%"
};
var ContentModalAlert = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ContentModalAlert",
    componentId: "sc-4cf23a37-0"
})(_templateObject(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : ui.theme.colors.neutral[50];
}, ui.theme.space.x1, ui.theme.space.x3, function(param) {
    var locationHorizontal = param.locationHorizontal;
    return locationHorizontal && locationHorizontal in LOCATION_HORIZONTAL ? LOCATION_HORIZONTAL[locationHorizontal || "center"] : LOCATION_HORIZONTAL.center;
}, function(param) {
    var locationVertical = param.locationVertical;
    return locationVertical && locationVertical in LOCATION_VERTICAL ? LOCATION_VERTICAL[locationVertical || "center"] : LOCATION_VERTICAL.center;
}, ui.theme.colors.neutral[600]);
var ButtonCloseAlert = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonCloseAlert",
    componentId: "sc-4cf23a37-1"
})(_templateObject1());
var BodyModalAlert = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BodyModalAlert",
    componentId: "sc-4cf23a37-2"
})(_templateObject2(), function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "1.3rem";
}, ui.theme.space.x2);
var ContentModalConfirm = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ContentModalConfirm",
    componentId: "sc-4cf23a37-3"
})(_templateObject3(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : ui.theme.colors.neutral.white;
}, ui.theme.space.x4, ui.theme.space.x3, function(param) {
    var locationHorizontal = param.locationHorizontal;
    return locationHorizontal && locationHorizontal in LOCATION_HORIZONTAL ? LOCATION_HORIZONTAL[locationHorizontal || "center"] : LOCATION_HORIZONTAL.center;
}, function(param) {
    var locationVertical = param.locationVertical;
    return locationVertical && locationVertical in LOCATION_VERTICAL ? LOCATION_VERTICAL[locationVertical || "center"] : LOCATION_VERTICAL.center;
}, ui.theme.colors.neutral[600], function(param) {
    var typeInfo = param.typeInfo;
    return typeInfo && typeInfo in COLOR_TYPE_INFO ? COLOR_TYPE_INFO[typeInfo || "info"] : COLOR_TYPE_INFO.warn;
});
var HeaderModal = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__HeaderModal",
    componentId: "sc-4cf23a37-4"
})(_templateObject4());
var ButtonClose = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonClose",
    componentId: "sc-4cf23a37-5"
})(_templateObject5(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : ui.theme.colors.neutral.white;
}, function(param) {
    var typeInfo = param.typeInfo;
    return typeInfo && typeInfo in COLOR_TYPE_INFO ? COLOR_TYPE_INFO[typeInfo || "info"] : COLOR_TYPE_INFO.warn;
});
var ButtonLine = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonLine",
    componentId: "sc-4cf23a37-6"
})(_templateObject6(), function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui.theme.colors.secondary[200];
}, ui.theme.space.x2, ui.theme.space.x4, ui.theme.space.x2, function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "1.2rem";
}, function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui.theme.colors.secondary[200];
});
var ButtonSolid = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonSolid",
    componentId: "sc-4cf23a37-7"
})(_templateObject7(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : ui.theme.colors.secondary[200];
}, ui.theme.space.x2, ui.theme.space.x4, ui.theme.space.x2, function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "1.2rem";
}, ui.theme.colors.neutral.white);
var TitleModal = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__TitleModal",
    componentId: "sc-4cf23a37-8"
})(_templateObject8(), function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "1.4rem";
}, function(param) {
    var lowerContent = param.lowerContent;
    return lowerContent ? "0.05rem solid ".concat(ui.theme.colors.neutral[400]) : "none";
}, function(param) {
    var lowerContent = param.lowerContent;
    return lowerContent ? "1rem" : "0";
}, function(param) {
    var lowerContent = param.lowerContent;
    return lowerContent ? "1rem" : "0";
});
var BodyModal = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BodyModal",
    componentId: "sc-4cf23a37-9"
})(_templateObject9(), function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "1.3rem";
});
var FooterModal = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__FooterModal",
    componentId: "sc-4cf23a37-10"
})(_templateObject10(), ui.theme.space.x4, ui.theme.colors.neutral[400], ui.theme.space.x4);

;// CONCATENATED MODULE: ../../packages/components/PopUpAlertConfirm/index.tsx






var PopUpAlertConfirm = function(param) {
    var isOpen = param.isOpen, typeInfo = param.typeInfo, backgroundColor = param.backgroundColor, textHeader = param.textHeader, descriptionBody = param.descriptionBody, actionCloseButton = param.actionCloseButton, footerProps = param.footerProps, _typeModal = param.typeModal, typeModal = _typeModal === void 0 ? "confirm" : _typeModal, locationHorizontal = param.locationHorizontal, locationVertical = param.locationVertical;
    if (!isOpen) {
        return null;
    }
    if (typeModal === "alert") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentModalAlert, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pop-up-alert-modal")), {
            backgroundColor: backgroundColor,
            locationHorizontal: locationHorizontal,
            locationVertical: locationVertical,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyModalAlert, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pop-up-alert-body-modal")), {
                    children: descriptionBody
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCloseAlert, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pop-up-alert-button-close-modal")), {
                    onClick: actionCloseButton,
                    typeInfo: typeInfo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {
                        alt: "Fechar",
                        height: 25,
                        width: 25
                    })
                }))
            ]
        }));
    }
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentModalConfirm, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        typeInfo: typeInfo,
        backgroundColor: backgroundColor,
        locationHorizontal: locationHorizontal,
        locationVertical: locationVertical
    }, (0,application/* buildTestIds */.Fek)("pop-up-alert-modal")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClose, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onClick: actionCloseButton,
                typeInfo: typeInfo
            }, (0,application/* buildTestIds */.Fek)("pop-up-alert-button-close-modal")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {
                    height: 25,
                    width: 25
                })
            })),
            textHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pop-up-alert-header-modal")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pop-up-alert-title-modal")), {
                    lowerContent: Boolean(descriptionBody),
                    children: textHeader
                }))
            })),
            descriptionBody && /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pop-up-alert-body-modal")), {
                children: descriptionBody
            })),
            (footerProps === null || footerProps === void 0 ? void 0 : footerProps.isActive) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pop-up-alert-footer-modal")), {
                children: (footerProps === null || footerProps === void 0 ? void 0 : footerProps.children) ? footerProps.children : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        (footerProps === null || footerProps === void 0 ? void 0 : footerProps.buttonLine) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLine, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pop-up-alert-button-line-modal")), {
                            onClick: footerProps === null || footerProps === void 0 ? void 0 : footerProps.actionButtonLine,
                            children: (ref = footerProps === null || footerProps === void 0 ? void 0 : footerProps.textButtonLine) !== null && ref !== void 0 ? ref : "Cancelar"
                        })),
                        (footerProps === null || footerProps === void 0 ? void 0 : footerProps.buttonSolid) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSolid, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("pop-up-alert-button-solid-modal")), {
                            onClick: footerProps === null || footerProps === void 0 ? void 0 : footerProps.actionButtonSolid,
                            children: (ref1 = footerProps === null || footerProps === void 0 ? void 0 : footerProps.textButtonSolid) !== null && ref1 !== void 0 ? ref1 : "Confirmar"
                        }))
                    ]
                })
            })) : null
        ]
    }));
};



/***/ }),

/***/ 18494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreloadImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(430);
/* harmony import */ var _AddToHead__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59797);



var PreloadImage = function(param) {
    var imgSrc = param.imgSrc;
    if (!imgSrc) {
        return null;
    }
    var formattedImgSrc = (0,application__WEBPACK_IMPORTED_MODULE_1__/* .replaceImageBaseUrl */ .sMx)(imgSrc);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddToHead__WEBPACK_IMPORTED_MODULE_2__/* .AddToHead */ .o, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "preload",
            as: "image",
            href: formattedImgSrc
        })
    });
};



/***/ }),

/***/ 41729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TX": function() { return /* binding */ handleSelectItemGtag; },
/* harmony export */   "U3": function() { return /* binding */ useGetProductCardInfo; },
/* harmony export */   "Yd": function() { return /* binding */ DynamicProductCardImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(430);
/* harmony import */ var implementations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32202);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3483);








var getItemListId = function(param) {
    var isSearchPath = param.isSearchPath, isExpandedPlaylistPath = param.isExpandedPlaylistPath, playlistId = param.playlistId, searchTerm = param.searchTerm;
    return isSearchPath ? "search_".concat(searchTerm) : isExpandedPlaylistPath ? "expanded_playlist_".concat(playlistId) : "preview_playlist_".concat(playlistId);
};
var getItemListValue = function(param) {
    var isSearchPath = param.isSearchPath, playlistId = param.playlistId, searchTerm = param.searchTerm;
    return isSearchPath ? "".concat(searchTerm) : "".concat(playlistId);
};
var useGetProductCardInfo = function(productCard, isCardVertical) {
    var cardIndexInPlaylist = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var isClientMobile = (0,application__WEBPACK_IMPORTED_MODULE_1__/* .useAppContext */ .bp4)().isClientMobile;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var isSearchPath = (router === null || router === void 0 ? void 0 : router.pathname) === "/pesquisa/[term]";
    var isExpandedPlaylistPath = (router === null || router === void 0 ? void 0 : router.pathname) === "/Destaque/[url]" || (router === null || router === void 0 ? void 0 : router.pathname) === "/Categoria/[url]";
    var isProductScreen = router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.includes("produto");
    var hideSecondBorderRightOnMobile = Number(cardIndexInPlaylist) % 2 === 0;
    var hasInstallments = (productCard === null || productCard === void 0 ? void 0 : (ref1 = productCard.prices) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.maxNumberInstallments) > 1;
    var productTagColor = (productCard === null || productCard === void 0 ? void 0 : (ref3 = productCard.tag) === null || ref3 === void 0 ? void 0 : ref3.color) || (productCard === null || productCard === void 0 ? void 0 : (ref4 = productCard.tagProduct) === null || ref4 === void 0 ? void 0 : ref4.color);
    var productTagTitle = (productCard === null || productCard === void 0 ? void 0 : (ref5 = productCard.tag) === null || ref5 === void 0 ? void 0 : ref5.title) || (productCard === null || productCard === void 0 ? void 0 : (ref6 = productCard.tagProduct) === null || ref6 === void 0 ? void 0 : ref6.title);
    var productCardVertical = Boolean(isCardVertical && isClientMobile && router.route !== "/pesquisa/[term]");
    return {
        isSearchPath: isSearchPath,
        isExpandedPlaylistPath: isExpandedPlaylistPath,
        hideSecondBorderRightOnMobile: hideSecondBorderRightOnMobile,
        hasInstallments: hasInstallments,
        productTagColor: productTagColor,
        productTagTitle: productTagTitle,
        productCardVertical: productCardVertical,
        isProductScreen: isProductScreen
    };
};
var handleSelectItemGtag = function(param) {
    var item = param.item, isSearchPath = param.isSearchPath, searchTerm = param.searchTerm, playlistName = param.playlistName, playlistId = param.playlistId;
    var itemListId = getItemListId({
        isSearchPath: isSearchPath,
        isExpandedPlaylistPath: isSearchPath,
        playlistId: playlistId,
        searchTerm: searchTerm
    });
    var itemListValue = getItemListValue({
        isSearchPath: isSearchPath,
        isExpandedPlaylistPath: isSearchPath,
        playlistId: playlistId,
        searchTerm: searchTerm
    });
    if (!item) {
        implementations__WEBPACK_IMPORTED_MODULE_2__/* .appMonitoringClient.captureMessage */ .pE.captureMessage("Nenhum produto foi retornado.");
    }
    (0,application__WEBPACK_IMPORTED_MODULE_1__/* .handleProductTag */ .Rnl)(item === null || item === void 0 ? void 0 : item.id, (item === null || item === void 0 ? void 0 : item.tag) || (item === null || item === void 0 ? void 0 : item.tagProduct), implementations__WEBPACK_IMPORTED_MODULE_2__/* .appMonitoringClient */ .pE);
    return function() {
        var ref, ref1, ref2, ref3, ref4;
        if (!item) {
            return;
        }
        var id = item.id, description = item.description, prices = item.prices;
        var discountValue = (0,application__WEBPACK_IMPORTED_MODULE_1__/* .calculateDiscountPercentage */ .vs9)(prices === null || prices === void 0 ? void 0 : (ref = prices[0]) === null || ref === void 0 ? void 0 : ref.discountPercentage);
        var itemListName = isSearchPath ? searchTerm : playlistName;
        implementations__WEBPACK_IMPORTED_MODULE_2__/* .gtag.selectItem */ .SX.selectItem((prices === null || prices === void 0 ? void 0 : (ref1 = prices[0]) === null || ref1 === void 0 ? void 0 : ref1.spotPrice) || (prices === null || prices === void 0 ? void 0 : (ref2 = prices[0]) === null || ref2 === void 0 ? void 0 : ref2.salePrice), {
            itemId: id,
            itemName: description,
            price: (prices === null || prices === void 0 ? void 0 : (ref3 = prices[0]) === null || ref3 === void 0 ? void 0 : ref3.spotPrice) || (prices === null || prices === void 0 ? void 0 : (ref4 = prices[0]) === null || ref4 === void 0 ? void 0 : ref4.salePrice),
            itemListId: itemListId,
            itemListName: itemListName,
            itemListValue: itemListValue,
            index: (item === null || item === void 0 ? void 0 : item.index) || 0
        }, discountValue, "BRL");
    };
};
var DynamicProductCardImage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var imageUrl = param.imageUrl, description = param.description, preloadComponent = param.preloadComponent;
    return imageUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ImageProduct */ .Zk, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-dynamic-image")), {
        src: imageUrl,
        alt: description,
        width: 170,
        height: 170,
        objectFit: "contain",
        priority: preloadComponent
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .DefaultProductImageContainer */ .ip, {});
});
DynamicProductCardImage.displayName = "DynamicProductCardImage";



/***/ }),

/***/ 95770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductCardComponent */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(430);
/* harmony import */ var implementations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32202);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26365);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3483);
/* harmony import */ var _data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41729);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17335);










var ProductCard = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(function(param) {
    var item = param.item, playlistId = param.playlistId, playlistName = param.playlistName, searchTerm = param.searchTerm, isVertical = param.isVertical, shouldShowInGridOnMobile = param.shouldShowInGridOnMobile, index = param.index, isPlaylist = param.isPlaylist, className = param.className, _preloadComponent = param.preloadComponent, preloadComponent = _preloadComponent === void 0 ? false : _preloadComponent;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,_data__WEBPACK_IMPORTED_MODULE_6__/* .useGetProductCardInfo */ .U3)(item, !!isVertical, index), isSearchPath = ref9.isSearchPath, isExpandedPlaylistPath = ref9.isExpandedPlaylistPath, hideSecondBorderRightOnMobile = ref9.hideSecondBorderRightOnMobile, hasInstallments = ref9.hasInstallments, productTagColor = ref9.productTagColor, productTagTitle = ref9.productTagTitle, productCardVertical = ref9.productCardVertical, isProductScreen = ref9.isProductScreen;
    var selectItemGtag = (0,_data__WEBPACK_IMPORTED_MODULE_6__/* .handleSelectItemGtag */ .TX)({
        item: item,
        isSearchPath: isSearchPath,
        searchTerm: searchTerm,
        playlistName: playlistName,
        isExpandedPlaylistPath: isExpandedPlaylistPath,
        playlistId: playlistId
    });
    var maxNumberInstallments = (0,application__WEBPACK_IMPORTED_MODULE_1__/* .getMaxInstallments */ .dfG)(item) || 0;
    var salePrice = ((ref1 = item === null || item === void 0 ? void 0 : (ref = item.prices) === null || ref === void 0 ? void 0 : ref.find(function(price) {
        return (price === null || price === void 0 ? void 0 : price.packingQuantity) === 1;
    })) === null || ref1 === void 0 ? void 0 : ref1.salePrice) || (item === null || item === void 0 ? void 0 : (ref2 = item.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.salePrice) || 0;
    var spotPrice = ((ref5 = item === null || item === void 0 ? void 0 : (ref4 = item.prices) === null || ref4 === void 0 ? void 0 : ref4.find(function(price) {
        return (price === null || price === void 0 ? void 0 : price.packingQuantity) === 1;
    })) === null || ref5 === void 0 ? void 0 : ref5.spotPrice) || (item === null || item === void 0 ? void 0 : (ref6 = item.prices) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.spotPrice) || null;
    var handleLinkClick = function(event) {
        var ref, ref1;
        event.preventDefault();
        var destination = event === null || event === void 0 ? void 0 : (ref = event.currentTarget) === null || ref === void 0 ? void 0 : ref.getAttribute("href");
        if (destination && window && (window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href) !== destination) {
            implementations__WEBPACK_IMPORTED_MODULE_2__/* .cookie.setCookie */ .pR.setCookie({
                name: "currentPage_default",
                value: "1",
                options: {
                    maxAge: 600
                }
            });
            window.location.href = destination;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardContainer */ .hd, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        className: className
    }, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-container".concat(isProductScreen ? "-as-tag-link" : "-as-component-link"))), {
        as: _Link__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .r,
        target: "_blank",
        onClick: function(event) {
            handleLinkClick(event);
            selectItemGtag();
        },
        href: "/produto/".concat(item === null || item === void 0 ? void 0 : item.id, "/").concat((0,application__WEBPACK_IMPORTED_MODULE_1__/* .formatStringUrl */ .Ess)(item === null || item === void 0 ? void 0 : item.description)),
        shouldShowInGridOnMobile: shouldShowInGridOnMobile,
        hideSecondBorderRightOnMobile: hideSecondBorderRightOnMobile,
        productCardVertical: productCardVertical,
        isPlaylist: isPlaylist,
        children: [
            (item === null || item === void 0 ? void 0 : (ref8 = item.coupons) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .CouponTagWrapper */ .Lc, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-coupon-tag-wrapper")), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui__WEBPACK_IMPORTED_MODULE_4__.CouponTag, {
                    alt: "cupom"
                })
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardContent */ .vS, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                productCardVertical: productCardVertical
            }, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-content")), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardImageContainer */ .td, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-image")), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardImageContent */ .TW, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-image-content")), {
                            productCardVertical: productCardVertical,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_data__WEBPACK_IMPORTED_MODULE_6__/* .DynamicProductCardImage */ .Yd, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-dynamic-image")), {
                                imageUrl: (0,application__WEBPACK_IMPORTED_MODULE_1__/* .getProductImageUrl */ .Gai)(item),
                                description: item === null || item === void 0 ? void 0 : item.description,
                                preloadComponent: preloadComponent
                            }))
                        }))
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardInfoArea */ .fO, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-info-area")), {
                        productCardVertical: productCardVertical,
                        children: [
                            (item === null || item === void 0 ? void 0 : item.isBlackFriday) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .TagCampaignProductCardContainer */ .WD, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("tag-campaign-product-card-black-friday-container")), {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .TagCampaignProductCard */ .WJ, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                                    background: ui__WEBPACK_IMPORTED_MODULE_4__.theme.colors.blackFriday[125]
                                }, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("tag-campaign-product-card-black-friday")), {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .TagTextCampaignProductCard */ .dY, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("tag-text-campaign-product-card-black-friday")), {
                                        children: "Oferta Black Friday"
                                    }))
                                }))
                            })) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardInfoContainer */ .Ag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-info-container")), {
                                productCardVertical: productCardVertical,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardTitle */ .Uw, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-title")), {
                                        hasDiscountPercentage: !(0,application__WEBPACK_IMPORTED_MODULE_1__/* .getDiscountPercentage */ .$Q4)(item)
                                    }), (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-title")), {
                                        children: item === null || item === void 0 ? void 0 : item.description
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardDiscountPriceContainerSpace */ .es, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-discount-price-container-space")), {
                                        hasDiscountPercentage: !(0,application__WEBPACK_IMPORTED_MODULE_1__/* .getDiscountPercentage */ .$Q4)(item),
                                        children: (0,application__WEBPACK_IMPORTED_MODULE_1__/* .getDiscountPercentage */ .$Q4)(item) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardDiscountPriceContainer */ .J8, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-discount-price-container")), {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardDiscountPriceText */ .WS, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-discount-price-text")), {
                                                    children: (0,application__WEBPACK_IMPORTED_MODULE_1__/* .getPriceList */ .D7)(item)
                                                })),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardDiscountPercentageContainer */ .jS, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-discount-percentage-container")), {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardDiscountPercentageDot */ .Xr, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-discount-percentage-dot"))),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardDiscountPercentageText */ .LU, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-discount-percentage-text")), {
                                                            children: [
                                                                (0,application__WEBPACK_IMPORTED_MODULE_1__/* .getDiscountPercentage */ .$Q4)(item),
                                                                "% OFF"
                                                            ]
                                                        }))
                                                    ]
                                                }))
                                            ]
                                        })) : null
                                    })),
                                    (0,application__WEBPACK_IMPORTED_MODULE_1__/* .getSpotPrice */ .$XT)(item) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardCurrentPrice */ .jb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-current-price")), {
                                                children: (0,application__WEBPACK_IMPORTED_MODULE_1__/* .getSpotPrice */ .$XT)(item)
                                            })),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardSpotPriceDescription */ .kR, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-spot-price-description")), {
                                                children: "\xe0 vista no pix ou no cart\xe3o"
                                            }))
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardCurrentPrice */ .jb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-current-price")), {
                                        children: (0,application__WEBPACK_IMPORTED_MODULE_1__/* .getSalePrice */ .FlL)(item, implementations__WEBPACK_IMPORTED_MODULE_2__/* .appMonitoringClient */ .pE)
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardInstallmentsTextContainer */ .eO, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-installments-text-container")), {
                                        children: hasInstallments ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardInstallmentsText */ .um, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-installments-text")), {
                                            children: (0,application__WEBPACK_IMPORTED_MODULE_1__/* .descriptionParcelsText */ .mVl)({
                                                shortDescription: true,
                                                maxNumberInstallments: maxNumberInstallments,
                                                salePrice: salePrice,
                                                spotPrice: spotPrice
                                            })
                                        })) : null
                                    })),
                                    productTagTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardTagPriceOnlySiteContainer */ .H$, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-tag-price-only-site-container")), {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .ProductCardTagPriceOnlySiteText */ .U1, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("product-card-tag-price-only-site-text")), {
                                            children: productTagTitle
                                        }))
                                    })) : null
                                ]
                            }))
                        ]
                    }))
                ]
            })),
            shouldShowInGridOnMobile ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_5__/* .TagBorderLine */ .vI, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_1__/* .buildTestIds */ .Fek)("tag-border-line")), {
                tagColor: productTagColor
            }))
        ]
    }));
});
ProductCard.displayName = "ProductCard";
/* harmony default export */ __webpack_exports__["Z"] = (ProductCard);



/***/ }),

/***/ 3483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ag": function() { return /* binding */ ProductCardInfoContainer; },
/* harmony export */   "H$": function() { return /* binding */ ProductCardTagPriceOnlySiteContainer; },
/* harmony export */   "J8": function() { return /* binding */ ProductCardDiscountPriceContainer; },
/* harmony export */   "LU": function() { return /* binding */ ProductCardDiscountPercentageText; },
/* harmony export */   "Lc": function() { return /* binding */ CouponTagWrapper; },
/* harmony export */   "TW": function() { return /* binding */ ProductCardImageContent; },
/* harmony export */   "U1": function() { return /* binding */ ProductCardTagPriceOnlySiteText; },
/* harmony export */   "Uw": function() { return /* binding */ ProductCardTitle; },
/* harmony export */   "WD": function() { return /* binding */ TagCampaignProductCardContainer; },
/* harmony export */   "WJ": function() { return /* binding */ TagCampaignProductCard; },
/* harmony export */   "WS": function() { return /* binding */ ProductCardDiscountPriceText; },
/* harmony export */   "Xr": function() { return /* binding */ ProductCardDiscountPercentageDot; },
/* harmony export */   "Zk": function() { return /* binding */ ImageProduct; },
/* harmony export */   "dY": function() { return /* binding */ TagTextCampaignProductCard; },
/* harmony export */   "eO": function() { return /* binding */ ProductCardInstallmentsTextContainer; },
/* harmony export */   "es": function() { return /* binding */ ProductCardDiscountPriceContainerSpace; },
/* harmony export */   "fO": function() { return /* binding */ ProductCardInfoArea; },
/* harmony export */   "hd": function() { return /* binding */ ProductCardContainer; },
/* harmony export */   "ip": function() { return /* binding */ DefaultProductImageContainer; },
/* harmony export */   "jS": function() { return /* binding */ ProductCardDiscountPercentageContainer; },
/* harmony export */   "jb": function() { return /* binding */ ProductCardCurrentPrice; },
/* harmony export */   "kR": function() { return /* binding */ ProductCardSpotPriceDescription; },
/* harmony export */   "td": function() { return /* binding */ ProductCardImageContainer; },
/* harmony export */   "um": function() { return /* binding */ ProductCardInstallmentsText; },
/* harmony export */   "vI": function() { return /* binding */ TagBorderLine; },
/* harmony export */   "vS": function() { return /* binding */ ProductCardContent; }
/* harmony export */ });
/* unused harmony exports ProductCardDiscount, FavoriteContainer, Heart */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25926);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  content: "";\n  position: absolute;\n  width: calc(100% + 4px);\n  height: calc(100% + 3px);\n  border: 2px solid ',
        ";\n  border-radius: 8px;\n  transition: all 0.2s ease-in-out;\n  transform: scale(1.05);\n  opacity: 0;\n  visibility: hidden;\n  top: -1px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  bottom: 0.6875rem;\n  right: 0.1875rem;\n  transform: scale(0.9);\n\n  @media ",
        " {\n    top: 0.5rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  transition: all 0.2s linear;\n  max-height: 170px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          height: 100%;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          width: 11.75rem;\n          height: 100vh;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 170px;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px auto 0px auto !important;\n  transition: all 0.2s linear;\n  transform: scale(0.9);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          min-height: 16rem;\n          height: auto;\n          max-height: 31rem;\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          height: 31rem;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          @media ",
        " {\n            border-top: 0px;\n            border-bottom: 1px solid ",
        ";\n            border-left: 0px;\n            border-radius: 0;\n          }\n\n          @media ",
        " {\n            border-right: none;\n          }\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border: 1px solid ",
        ";\n          border-radius: 8px;\n        "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          min-width: 100% !important;\n          max-height: 16.45rem !important;\n          padding: 0.85rem 0.65rem 1rem 1rem !important;\n        "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 1rem 1rem 1.35rem 1rem;\n  min-width: 100%;\n  margin-left: 2px;\n  width: ",
        ";\n  /* min-height: 25.45rem; */\n\n  cursor: pointer !important;\n\n  background: ",
        ";\n\n  user-select: none;\n  -webkit-user-drag: none;\n  position: relative;\n  -webkit-tap-highlight-color: transparent !important;\n  transition: all 0.2s ease-in-out;\n  // artur.castro transferir o border-right para a condi\xe7\xe3o da linha onde 'e utilizado o css\n  border-right: ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  &:hover {\n    ",
        " {\n      transform: scale(1.1);\n    }\n\n    ",
        " {\n      opacity: ",
        ";\n      visibility: ",
        ";\n      transform: scale(1);\n    }\n  }\n\n  @media ",
        " {\n    margin-left: 0px;\n  }\n\n  @media ",
        " {\n    min-width: ",
        ";\n    width: 100%;\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: -6px;\n  right: 16px;\n  z-index: 2;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 100%;\n  min-height: 24px;\n  z-index: 2;\n  position: relative;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0.25rem 0.65rem;\n  border-radius: 6px;\n  background: ",
        ";\n  max-width: fit-content;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1rem;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          max-width: max-content;\n          margin-top: 0px;\n          padding-left: 16px;\n        "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n\n  font-size: 1.15rem;\n  font-family: ",
        ";\n  font-weight: ",
        ";\n\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: ",
        ";\n  white-space: pre-wrap;\n\n  max-width: 170px;\n  min-width: 100%;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 8px;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1rem;\n  font-weight: ",
        ";\n  line-height: 150%;\n  text-decoration: line-through;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 5.5rem;\n  height: 1.5rem;\n  padding: 0 0.35rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.35rem;\n\n  border-radius: 1rem 0.35rem 0.35rem 1rem;\n  background: ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 0.5rem;\n  height: 0.5rem;\n  border-radius: 50%;\n  background: ",
        ";\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1rem;\n  font-weight: ",
        ";\n  line-height: 150%;\n  letter-spacing: -0.02rem;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1.75rem;\n  font-weight: ",
        ";\n  letter-spacing: -0.05783rem;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 0.875rem;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 168px;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1rem;\n  font-weight: ",
        ";\n\n  min-width: 164px;\n\n  @media ",
        " {\n    font-size: 0.975rem;\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  padding: 0.3075rem 0.35rem 0.35rem 0.35rem;\n  align-items: flex-start;\n  gap: 0.875rem;\n  margin-top: 0.25rem;\n  border-radius: 0.35rem;\n  background: ",
        ";\n  max-width: fit-content;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1rem;\n  font-weight: ",
        ";\n  line-height: 0.92rem;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  border-radius: 100px;\n  background-color: ",
        ";\n  z-index: 2;\n  right: 8px;\n  top: 8px;\n  height: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  animation: ",
        ";\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}



var heartColors = function(param) {
    var isClicked = param.isClicked, isHovered = param.isHovered;
    if (isClicked) {
        return {
            color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[350],
            secondColor: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[350]
        };
    }
    if (isHovered) {
        return {
            color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[60]
        };
    }
    return {
        color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white,
        secondColor: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[580]
    };
};
var TagBorderLine = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__TagBorderLine",
    componentId: "sc-ab92a1d-0"
})(_templateObject(), function(param) {
    var tagColor = param.tagColor;
    return tagColor || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200];
});
var DefaultProductImageContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.DefaultProductImage).attrs({
    height: 170,
    width: 170
}).withConfig({
    displayName: "styles__DefaultProductImageContainer",
    componentId: "sc-ab92a1d-1"
})(_templateObject1(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileL);
var ProductCardImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].figure.withConfig */ .ZP.figure.withConfig({
    displayName: "styles__ProductCardImageContainer",
    componentId: "sc-ab92a1d-2"
})(_templateObject2());
var ProductCardInfoArea = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__ProductCardInfoArea",
    componentId: "sc-ab92a1d-3"
})(_templateObject4(), function(param) {
    var productCardVertical = param.productCardVertical;
    return productCardVertical ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3()) : null;
});
var ProductCardImageContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ProductCardImageContent",
    componentId: "sc-ab92a1d-4"
})(_templateObject6(), function(param) {
    var productCardVertical = param.productCardVertical;
    return productCardVertical ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5()) : null;
});
var ImageProduct = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Image__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E).withConfig({
    displayName: "styles__ImageProduct",
    componentId: "sc-ab92a1d-5"
})(_templateObject7());
var ProductCardContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__ProductCardContainer",
    componentId: "sc-ab92a1d-6"
})(_templateObject13(), function(param) {
    var width = param.width;
    return width || "100%";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, function(param) {
    var shouldShowInGridOnMobile = param.shouldShowInGridOnMobile, hideSecondBorderRightOnMobile = param.hideSecondBorderRightOnMobile;
    return shouldShowInGridOnMobile ? hideSecondBorderRightOnMobile ? "1px solid ".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[105]) : "0px" : null;
}, function(param) {
    var isPlaylist = param.isPlaylist;
    return isPlaylist ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9());
}, function(param) {
    var shouldShowInGridOnMobile = param.shouldShowInGridOnMobile;
    return shouldShowInGridOnMobile ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[105], ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileS) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject11(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[105]);
}, function(param) {
    var productCardVertical = param.productCardVertical;
    return productCardVertical ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject12()) : null;
}, ProductCardImageContainer, TagBorderLine, function(param) {
    var shouldShowInGridOnMobile = param.shouldShowInGridOnMobile;
    return shouldShowInGridOnMobile ? 0 : 1;
}, function(param) {
    var shouldShowInGridOnMobile = param.shouldShowInGridOnMobile;
    return shouldShowInGridOnMobile ? "hidden" : "visible";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL, function(param) {
    var shouldShowInGridOnMobile = param.shouldShowInGridOnMobile;
    return shouldShowInGridOnMobile ? "calc(50vw - 12px)" : "226px";
}, function(param) {
    var shouldShowInGridOnMobile = param.shouldShowInGridOnMobile;
    return shouldShowInGridOnMobile ? "100%" : "328px";
});
var CouponTagWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CouponTagWrapper",
    componentId: "sc-ab92a1d-7"
})(_templateObject14());
var ProductCardContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__ProductCardContent",
    componentId: "sc-ab92a1d-8"
})(_templateObject15(), function(param) {
    var productCardVertical = param.productCardVertical;
    return productCardVertical ? "row" : "column";
});
var TagCampaignProductCardContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__TagCampaignProductCardContainer",
    componentId: "sc-ab92a1d-9"
})(_templateObject16());
var TagCampaignProductCard = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__TagCampaignProductCard",
    componentId: "sc-ab92a1d-10"
})(_templateObject17(), function(param) {
    var background = param.background;
    return background || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[999];
});
var TagTextCampaignProductCard = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__TagTextCampaignProductCard",
    componentId: "sc-ab92a1d-11"
})(_templateObject18(), function(param) {
    var color = param.color;
    return color || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white;
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[600]);
var ProductCardInfoContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ProductCardInfoContainer",
    componentId: "sc-ab92a1d-12"
})(_templateObject20(), function(param) {
    var productCardVertical = param.productCardVertical;
    return productCardVertical ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject19()) : null;
});
var ProductCardTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.Title).withConfig({
    displayName: "styles__ProductCardTitle",
    componentId: "sc-ab92a1d-13"
})(_templateObject21(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[520], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400], function(param) {
    var hasDiscountPercentage = param.hasDiscountPercentage;
    return hasDiscountPercentage ? 3 : 2;
});
var ProductCardDiscountPriceContainerSpace = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__ProductCardDiscountPriceContainerSpace",
    componentId: "sc-ab92a1d-14"
})(_templateObject22(), function(param) {
    var hasDiscountPercentage = param.hasDiscountPercentage;
    return hasDiscountPercentage ? "0" : "18px";
});
var ProductCardDiscountPriceContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__ProductCardDiscountPriceContainer",
    componentId: "sc-ab92a1d-15"
})(_templateObject23());
var ProductCardDiscountPriceText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__ProductCardDiscountPriceText",
    componentId: "sc-ab92a1d-16"
})(_templateObject24(), function(param) {
    var color = param.color;
    return color || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[350];
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400]);
var ProductCardDiscountPercentageContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__ProductCardDiscountPercentageContainer",
    componentId: "sc-ab92a1d-17"
})(_templateObject25(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.tertiary[930]);
var ProductCardDiscountPercentageDot = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ProductCardDiscountPercentageDot",
    componentId: "sc-ab92a1d-18"
})(_templateObject26(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white);
var ProductCardDiscountPercentageText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__ProductCardDiscountPercentageText",
    componentId: "sc-ab92a1d-19"
})(_templateObject27(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.tertiary[150], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[600]);
var ProductCardCurrentPrice = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__ProductCardCurrentPrice",
    componentId: "sc-ab92a1d-20"
})(_templateObject28(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[700]);
var ProductCardSpotPriceDescription = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__ProductCardSpotPriceDescription",
    componentId: "sc-ab92a1d-21"
})(_templateObject29(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400]);
var ProductCardInstallmentsTextContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ProductCardInstallmentsTextContainer",
    componentId: "sc-ab92a1d-22"
})(_templateObject30());
var ProductCardInstallmentsText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__ProductCardInstallmentsText",
    componentId: "sc-ab92a1d-23"
})(_templateObject31(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[805], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400], ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet);
var ProductCardTagPriceOnlySiteContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ProductCardTagPriceOnlySiteContainer",
    componentId: "sc-ab92a1d-24"
})(_templateObject32(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.secondary[28]);
var ProductCardTagPriceOnlySiteText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__ProductCardTagPriceOnlySiteText",
    componentId: "sc-ab92a1d-25"
})(_templateObject33(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.secondary[380], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[600]);
var ProductCardDiscount = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ProductCardDiscount",
    componentId: "sc-ab92a1d-26"
})(_templateObject34());
var FavoriteContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__FavoriteContainer",
    componentId: "sc-ab92a1d-27"
})(_templateObject35(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral["white-opacity-50"], ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x8, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x8);
var Heart = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.HeartIcon).attrs(function(param) {
    var isHovered = param.isHovered, isClicked = param.isClicked;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, heartColors({
        isClicked: isClicked,
        isHovered: isHovered
    })), {
        height: ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6,
        width: ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6
    });
}).withConfig({
    displayName: "styles__Heart",
    componentId: "sc-ab92a1d-28"
})(_templateObject36(), function(param) {
    var isClicked = param.isClicked;
    return isClicked ? "0.5s ease-in-out" : "none";
});


/***/ }),

/***/ 37952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ productsRecommendationDetails; }
/* harmony export */ });
var productsRecommendationDetails = function(branchId, crmUrl, crmLinkId, crm, productCards) {
    var productQuantity = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 10;
    return {
        type: "productList",
        subComponents: null,
        displayName: "Lista de Produtos",
        config: {
            branches: [
                {
                    typeLink: "insider",
                    linkUrl: crmUrl !== null && crmUrl !== void 0 ? crmUrl : null,
                    id: branchId,
                    linkId: crmLinkId !== null && crmLinkId !== void 0 ? crmLinkId : "0",
                    visibleOnDesktop: true,
                    visibleOnMobile: true
                }, 
            ]
        },
        crm: crm,
        productCards: productCards,
        properties: [
            {
                key: "quantity",
                value: productQuantity
            },
            {
                key: "showCta",
                value: "true"
            },
            {
                key: "ctaText",
                value: "Ver todos"
            },
            {
                key: "showTitle",
                value: "true"
            },
            {
                key: "title",
                value: "Mais populares"
            },
            {
                key: "showArrows",
                value: "true"
            }, 
        ]
    };
};



/***/ }),

/***/ 49234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_RecommendationCarouselProductCard; }
});

// UNUSED EXPORTS: RecommendationCarouselProductCardComponent

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/components/Image/index.tsx
var Image = __webpack_require__(25926);
// EXTERNAL MODULE: ../../packages/components/ProductCard/styles.ts
var styles = __webpack_require__(3483);
;// CONCATENATED MODULE: ../../packages/components/RecommendationCarouselProductCard/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  content: "";\n  position: absolute;\n  width: calc(100% + 4px);\n  height: calc(100% + 3px);\n  border: 2px solid ',
        ";\n  border-radius: 8px;\n  transition: all 0.2s ease-in-out;\n  transform: scale(1.05);\n  opacity: 0;\n  visibility: hidden;\n  top: -1px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  bottom: 0.6875rem;\n  right: 0.1875rem;\n  transform: scale(0.9);\n\n  @media ",
        " {\n    top: 0.5rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n  transition: all 0.2s linear;\n  padding: ",
        ";\n  max-height: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media ",
        " {\n    padding: 0px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 162px;\n  height: 100%;\n  padding: ",
        ";\n\n  @media ",
        " {\n    padding: 0px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100px;\n  height: 100vh;\n  max-height: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  > svg {\n    max-width: 100%;\n  }\n\n  @media ",
        " {\n    max-width: ",
        ";\n    max-height: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px auto 0px auto !important;\n  transition: all 0.2s linear;\n  transform: scale(0.9);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-width: 104px;\n  max-width: 100%;\n  cursor: pointer !important;\n\n  background: ",
        ";\n\n  user-select: none;\n  -webkit-user-drag: none;\n  position: relative;\n  -webkit-tap-highlight-color: transparent !important;\n  transition: all 0.2s ease-in-out;\n  // artur.castro transferir o border-right para a condi\xe7\xe3o da linha onde 'e utilizado o css\n\n  min-height: ",
        ";\n  height: auto;\n  max-height: ",
        ";\n\n  &:hover {\n    ",
        " {\n      transform: scale(1.1);\n    }\n\n    ",
        " {\n      opacity: 1;\n      visibility: visible;\n      transform: scale(1);\n    }\n  }\n\n  @media ",
        " {\n    min-width: ",
        ";\n    width: 100%;\n    max-width: ",
        ";\n    min-height: ",
        ";\n    height: auto;\n    max-height: 31rem;\n    border: ",
        ";\n    border-radius: 8px;\n    padding: 1rem;\n  }\n\n  @media ",
        " {\n    margin-left: 0px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -6px;\n  right: 16px;\n  z-index: 2;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: ",
        ";\n  flex-direction: ",
        ";\n\n  @media ",
        " {\n    flex-direction: column;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-width: max-content;\n  margin-top: 0px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  line-height: 16px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  white-space: pre-wrap;\n  word-break: break-word;\n\n  max-width: 170px;\n  min-width: 100%;\n\n  @media ",
        " {\n    -webkit-line-clamp: 3;\n    font-size: ",
        ";\n    min-height: 4rem;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 18px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 8px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 0.875rem;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: ",
        ";\n  border-radius: ",
        ";\n  margin-top: ",
        ";\n  width: 130px;\n  align-items: center;\n  height: 24px;\n  gap: ",
        ";\n  justify-content: center;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  text-transform: uppercase;\n  transition: background-color 0.3s ease-in-out;\n  transition: border-color 0.3s ease-in-out;\n  padding: ",
        " ",
        ";\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  color: ",
        ";\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  &:disabled {\n    background: ",
        ";\n  }\n\n  @media ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}





var TagBorderLine = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TagBorderLine",
    componentId: "sc-f549b98d-0"
})(_templateObject(), function(param) {
    var tagColor = param.tagColor;
    return tagColor || ui.theme.colors.primary[200];
});
var RecommendationDefaultProductImageContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.DefaultProductImage).attrs({
    width: 100,
    height: 100
}).withConfig({
    displayName: "styles__RecommendationDefaultProductImageContainer",
    componentId: "sc-f549b98d-1"
})(_templateObject1(), ui.theme.device.desktopFirst.mobileL);
var RecommendationProductCardImageContainer = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "styles__RecommendationProductCardImageContainer",
    componentId: "sc-f549b98d-2"
})(_templateObject2(), function(param) {
    var isMinimalist = param.isMinimalist;
    return !isMinimalist ? "0.667rem 0 0.667rem 0.667rem" : "1rem";
}, function(param) {
    var isMinimalist = param.isMinimalist;
    return isMinimalist ? "90px" : "160px";
}, ui.theme.device.desktopFirst.tabletL);
var RecommendationProductCardInfoArea = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__RecommendationProductCardInfoArea",
    componentId: "sc-f549b98d-3"
})(_templateObject3(), function(param) {
    var isMinimalist = param.isMinimalist;
    return !isMinimalist ? "0.667rem" : "1rem";
}, ui.theme.device.desktopFirst.tabletL);
var RecommendationProductCardImageContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RecommendationProductCardImageContent",
    componentId: "sc-f549b98d-4"
})(_templateObject4(), function(param) {
    var isMinimalist = param.isMinimalist;
    return isMinimalist ? "80px" : "100px";
}, ui.theme.device.desktopFirst.tabletL, function(param) {
    var isMinimalist = param.isMinimalist;
    return isMinimalist ? "80px" : "160px";
}, function(param) {
    var isMinimalist = param.isMinimalist;
    return isMinimalist ? "80px" : "160px";
});
var ImageProduct = (0,styled_components_browser_esm/* default */.ZP)(Image/* Image */.E).withConfig({
    displayName: "styles__ImageProduct",
    componentId: "sc-f549b98d-5"
})(_templateObject5());
var RecommendationProductCardContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__RecommendationProductCardContainer",
    componentId: "sc-f549b98d-6"
})(_templateObject6(), ui.theme.colors.neutral.white, function(param) {
    var isMinimalist = param.isMinimalist;
    return isMinimalist ? "7rem" : "8.75rem";
}, function(param) {
    var isMinimalist = param.isMinimalist;
    return isMinimalist ? "10rem" : "8.75rem";
}, RecommendationProductCardImageContainer, TagBorderLine, ui.theme.device.desktopFirst.tabletL, function(param) {
    var isMinimalist = param.isMinimalist;
    return isMinimalist ? "80px" : "190px";
}, function(param) {
    var isMinimalist = param.isMinimalist;
    return isMinimalist ? "120px" : "190px";
}, function(param) {
    var isMinimalist = param.isMinimalist;
    return isMinimalist ? "9rem" : "12rem";
}, function(param) {
    var isMinimalist = param.isMinimalist;
    return isMinimalist ? "none" : "1px solid ".concat(ui.theme.colors.neutral[105]);
}, ui.theme.device.desktopFirst.tablet);
var CouponTagWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CouponTagWrapper",
    componentId: "sc-f549b98d-7"
})(_templateObject7());
var RecommendationProductCardContent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__RecommendationProductCardContent",
    componentId: "sc-f549b98d-8"
})(_templateObject8(), function(param) {
    var isMinimalist = param.isMinimalist;
    return isMinimalist ? "center" : "auto";
}, function(param) {
    var isMinimalist = param.isMinimalist;
    return isMinimalist ? "column" : "row";
}, ui.theme.device.desktopFirst.tabletL, ui.theme.space.x4);
var RecommendationProductCardInfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RecommendationProductCardInfoContainer",
    componentId: "sc-f549b98d-9"
})(_templateObject9());
var RecommendationProductCardTitle = (0,styled_components_browser_esm/* default */.ZP)(ui.Title).withConfig({
    displayName: "styles__RecommendationProductCardTitle",
    componentId: "sc-f549b98d-10"
})(_templateObject10(), ui.theme.colors.neutral[520], ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[400], ui.theme.device.desktopFirst.tabletL, ui.theme.typography.fontSize.sm.x5);
var ProductCardDiscountPriceContainerSpace = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ProductCardDiscountPriceContainerSpace",
    componentId: "sc-f549b98d-11"
})(_templateObject11());
var ProductCardDiscountPriceContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ProductCardDiscountPriceContainer",
    componentId: "sc-f549b98d-12"
})(_templateObject12());
var RecommendationProductCardCurrentPrice = (0,styled_components_browser_esm/* default */.ZP)(styles/* ProductCardCurrentPrice */.jb).withConfig({
    displayName: "styles__RecommendationProductCardCurrentPrice",
    componentId: "sc-f549b98d-13"
})(_templateObject13(), ui.theme.typography.fontSize.md.x1);
var ProductCardSpotPriceDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ProductCardSpotPriceDescription",
    componentId: "sc-f549b98d-14"
})(_templateObject14(), ui.theme.colors.primary[200], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[400]);
var AddToCartButton = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__AddToCartButton",
    componentId: "sc-f549b98d-15"
})(_templateObject15(), ui.theme.space.x0, ui.theme.space.x1, ui.theme.space.x1, ui.theme.space.x1, ui.theme.typography.fontSize.sm.x1, ui.theme.space.x4, ui.theme.typography.fontWeight[700], ui.theme.typography.fontFamily.chivo, ui.theme.space.x1, ui.theme.space.x2, ui.theme.colors.neutral.white, ui.theme.colors.secondary[930], ui.theme.colors.secondary[357], ui.theme.colors.secondary[28], ui.theme.colors.neutral["760-opacity-23"], ui.theme.device.desktopFirst.tabletL);

// EXTERNAL MODULE: ../../packages/components/ProductCard/data.tsx
var data = __webpack_require__(41729);
;// CONCATENATED MODULE: ../../packages/components/RecommendationCarouselProductCard/data.tsx






var mockedRecommendationType = [
    {
        recommendationTypeAbbreviation: "mp",
        recommendationTypeText: "Mais comprados"
    },
    {
        recommendationTypeAbbreviation: "hd",
        recommendationTypeText: "Desconto imperd\xedvel"
    },
    {
        recommendationTypeAbbreviation: "tp",
        recommendationTypeText: "Em alta"
    }, 
];
var DynamicRecommendationProductCardVerticalImage = /*#__PURE__*/ (0,react.memo)(function(param) {
    var imageUrl = param.imageUrl, description = param.description, preloadComponent = param.preloadComponent;
    return imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageProduct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-card-dynamic-image")), {
        src: imageUrl,
        alt: description,
        width: 170,
        height: 170,
        objectFit: "contain",
        priority: preloadComponent
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationDefaultProductImageContainer, {});
});
DynamicRecommendationProductCardVerticalImage.displayName = "DynamicRecommendationProductCardVerticalImage";


;// CONCATENATED MODULE: ../../packages/components/RecommendationCarouselProductCard/components/RecommendationTypeBadge/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 104px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  border-radius: 0 0 8px 8px;\n  overflow: hidden;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var RecommendationTypeBadgeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RecommendationTypeBadgeContainer",
    componentId: "sc-1a140922-0"
})(styles_templateObject(), ui.theme.typography.fontSize.sm.x1, ui.theme.typography.fontWeight[400]);

;// CONCATENATED MODULE: ../../packages/components/RecommendationCarouselProductCard/components/RecommendationTypeBadge/HighestDiscountedBadge/styles.ts

function HighestDiscountedBadge_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: ",
        " 0;\n"
    ]);
    HighestDiscountedBadge_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var HighestDiscountedBadgeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HighestDiscountedBadgeContainer",
    componentId: "sc-d4542479-0"
})(HighestDiscountedBadge_styles_templateObject(), ui.theme.colors.yellow[850], ui.theme.colors.yellow[80], ui.theme.space["x1.5"]);

;// CONCATENATED MODULE: ../../packages/components/RecommendationCarouselProductCard/components/RecommendationTypeBadge/HighestDiscountedBadge/index.tsx






var HighestDiscountedBadge = /*#__PURE__*/ (0,react.memo)(function(param) {
    var recommendationTypeText = param.recommendationTypeText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HighestDiscountedBadgeContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-type-badge-content")), {
        children: recommendationTypeText
    }));
});
HighestDiscountedBadge.displayName = "HighestDiscountedBadge";
/* harmony default export */ var RecommendationTypeBadge_HighestDiscountedBadge = (HighestDiscountedBadge);

;// CONCATENATED MODULE: ../../packages/components/RecommendationCarouselProductCard/components/RecommendationTypeBadge/MostPurchasedBadge/styles.ts

function MostPurchasedBadge_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: ",
        " 0;\n"
    ]);
    MostPurchasedBadge_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var styles_HighestDiscountedBadgeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HighestDiscountedBadgeContainer",
    componentId: "sc-951e14a1-0"
})(MostPurchasedBadge_styles_templateObject(), ui.theme.colors.secondary[28], ui.theme.colors.secondary[380], ui.theme.space["x1.5"]);

;// CONCATENATED MODULE: ../../packages/components/RecommendationCarouselProductCard/components/RecommendationTypeBadge/MostPurchasedBadge/index.tsx






var MostPurchasedBadge = /*#__PURE__*/ (0,react.memo)(function(param) {
    var recommendationTypeText = param.recommendationTypeText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_HighestDiscountedBadgeContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-type-badge-content")), {
        children: recommendationTypeText
    }));
});
MostPurchasedBadge.displayName = "MostPurchasedBadge";
/* harmony default export */ var RecommendationTypeBadge_MostPurchasedBadge = (MostPurchasedBadge);

;// CONCATENATED MODULE: ../../packages/components/RecommendationCarouselProductCard/components/RecommendationTypeBadge/TrendingProductsBadge/styles.ts

function TrendingProductsBadge_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: ",
        " 0;\n"
    ]);
    TrendingProductsBadge_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TrendingProductsBadge_styles_HighestDiscountedBadgeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HighestDiscountedBadgeContainer",
    componentId: "sc-41f0fe31-0"
})(TrendingProductsBadge_styles_templateObject(), ui.theme.colors.secondary[850], ui.theme.colors.secondary[950], ui.theme.space["x1.5"]);

;// CONCATENATED MODULE: ../../packages/components/RecommendationCarouselProductCard/components/RecommendationTypeBadge/TrendingProductsBadge/index.tsx






var TrendingProductsBadge = /*#__PURE__*/ (0,react.memo)(function(param) {
    var recommendationTypeText = param.recommendationTypeText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingProductsBadge_styles_HighestDiscountedBadgeContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-type-badge-content")), {
        children: recommendationTypeText
    }));
});
TrendingProductsBadge.displayName = "TrendingProductsBadge";
/* harmony default export */ var RecommendationTypeBadge_TrendingProductsBadge = (TrendingProductsBadge);

;// CONCATENATED MODULE: ../../packages/components/RecommendationCarouselProductCard/components/RecommendationTypeBadge/index.tsx









var RecommendationTypeBadge = /*#__PURE__*/ (0,react.memo)(function(param) {
    var recommendationTypeAbbreviation = param.recommendationTypeAbbreviation, recommendationTypeText = param.recommendationTypeText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationTypeBadgeContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-type-badge-container")), {
        children: recommendationTypeAbbreviation === "hd" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationTypeBadge_HighestDiscountedBadge, {
            recommendationTypeText: recommendationTypeText
        }) : recommendationTypeAbbreviation === "mp" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationTypeBadge_MostPurchasedBadge, {
            recommendationTypeText: recommendationTypeText
        }) : recommendationTypeAbbreviation === "tp" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationTypeBadge_TrendingProductsBadge, {
            recommendationTypeText: recommendationTypeText
        }) : null
    }));
});
RecommendationTypeBadge.displayName = "RecommendationTypeBadge";
/* harmony default export */ var components_RecommendationTypeBadge = (RecommendationTypeBadge);

;// CONCATENATED MODULE: ../../packages/components/RecommendationCarouselProductCard/index.tsx













var RecommendationCarouselProductCard = /*#__PURE__*/ (0,react.memo)(function(param) {
    var item = param.item, playlistId = param.playlistId, playlistName = param.playlistName, searchTerm = param.searchTerm, isVertical = param.isVertical, index = param.index, isPlaylist = param.isPlaylist, className = param.className, _preloadComponent = param.preloadComponent, preloadComponent = _preloadComponent === void 0 ? false : _preloadComponent, isMinimalist = param.isMinimalist, _hasCta = param.hasCta, hasCta = _hasCta === void 0 ? true : _hasCta, recommendationType = param.recommendationType;
    var ref;
    var router = (0,next_router.useRouter)();
    var cart = (0,application/* useCartContext */.iQs)();
    var stayOnPage = true;
    var ref1 = (0,application/* useAddItemToCart */.ADk)({
        router: router,
        cart: cart,
        useToast: application/* useToast */.pmc,
        stayOnPage: stayOnPage
    }), sendItemToCart = ref1.sendItemToCart, isSendingItemToCart = ref1.isSendingItemToCart;
    var ref2 = (0,data/* useGetProductCardInfo */.U3)(item, !!isVertical, index), isSearchPath = ref2.isSearchPath, isExpandedPlaylistPath = ref2.isExpandedPlaylistPath, isProductScreen = ref2.isProductScreen;
    var selectItemGtag = (0,data/* handleSelectItemGtag */.TX)({
        item: item,
        isSearchPath: isSearchPath,
        searchTerm: searchTerm,
        playlistName: playlistName,
        isExpandedPlaylistPath: isExpandedPlaylistPath,
        playlistId: playlistId
    });
    var handleLinkClick = function(event) {
        var ref, ref1;
        event.preventDefault();
        var destination = event === null || event === void 0 ? void 0 : (ref = event.currentTarget) === null || ref === void 0 ? void 0 : ref.getAttribute("href");
        if (destination && window && (window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href) !== destination) {
            implementations/* cookie.setCookie */.pR.setCookie({
                name: "currentPage_default",
                value: "1",
                options: {
                    maxAge: 600
                }
            });
            window.location.href = destination;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecommendationProductCardContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, (0,application/* buildTestIds */.Fek)("recommendation-product-card-container".concat(isProductScreen ? "-as-tag-link" : "-as-component-link"))), {
        isPlaylist: isPlaylist,
        isMinimalist: isMinimalist,
        children: [
            (item === null || item === void 0 ? void 0 : (ref = item.coupons) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponTagWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-product-card-coupon-tag-wrapper")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CouponTag, {
                    alt: "cupom"
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecommendationProductCardContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-product-card-content")), {
                isMinimalist: isMinimalist,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationProductCardImageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        href: "/produto/".concat(item === null || item === void 0 ? void 0 : item.id, "/").concat((0,application/* formatStringUrl */.Ess)(item === null || item === void 0 ? void 0 : item.description)),
                        target: "_self"
                    }, (0,application/* buildTestIds */.Fek)("recommendation-product-card-image")), {
                        isMinimalist: isMinimalist,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationProductCardImageContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-product-card-image-content")), {
                            isMinimalist: isMinimalist,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicRecommendationProductCardVerticalImage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-product-card-dynamic-image")), {
                                imageUrl: (0,application/* getProductImageUrl */.Gai)(item),
                                description: item === null || item === void 0 ? void 0 : item.description,
                                preloadComponent: preloadComponent
                            }))
                        }))
                    })),
                    !isMinimalist ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationProductCardInfoArea, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-product-card-info-area")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecommendationProductCardInfoContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-product-card-info-container")), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationProductCardTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-product-card-title")), {
                                    as: isProductScreen ? "a" : Link/* Link */.r,
                                    href: "/produto/".concat(item === null || item === void 0 ? void 0 : item.id, "/").concat((0,application/* formatStringUrl */.Ess)(item === null || item === void 0 ? void 0 : item.description)),
                                    target: "_self",
                                    onClick: function(event) {
                                        handleLinkClick(event);
                                        selectItemGtag();
                                    },
                                    children: item === null || item === void 0 ? void 0 : item.description
                                })),
                                (0,application/* getSpotPrice */.$XT)(item) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationProductCardCurrentPrice, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-product-card-current-price")), {
                                    children: (0,application/* getSpotPrice */.$XT)(item)
                                })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationProductCardCurrentPrice, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommendation-product-card-current-price")), {
                                    children: (0,application/* getSalePrice */.FlL)(item, implementations/* appMonitoringClient */.pE)
                                })),
                                hasCta ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddToCartButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    onClick: function() {
                                        return sendItemToCart({
                                            quantity: item === null || item === void 0 ? void 0 : item.quantity,
                                            price: (0,application/* getSpotPrice */.$XT)(item),
                                            productId: item === null || item === void 0 ? void 0 : item.id
                                        });
                                    },
                                    isDisabled: isSendingItemToCart
                                }, (0,application/* buildTestIds */.Fek)("add-to-cart-button")), {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CartOutlineIcon, {
                                            color: "".concat(ui.theme.colors.secondary[357]),
                                            width: "16px",
                                            height: "16px"
                                        }),
                                        "Adicionar"
                                    ]
                                })) : null
                            ]
                        }))
                    })) : recommendationType ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RecommendationTypeBadge, {
                        recommendationTypeAbbreviation: recommendationType === null || recommendationType === void 0 ? void 0 : recommendationType.recommendationTypeAbbreviation,
                        recommendationTypeText: recommendationType === null || recommendationType === void 0 ? void 0 : recommendationType.recommendationTypeText
                    }) : null
                ]
            }))
        ]
    }));
});
RecommendationCarouselProductCard.displayName = "RecommendationCarouselProductCard";
/* harmony default export */ var components_RecommendationCarouselProductCard = (RecommendationCarouselProductCard);



/***/ }),

/***/ 59899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AX": function() { return /* binding */ WrapperInput; },
/* harmony export */   "EH": function() { return /* binding */ SignUpFormButton; },
/* harmony export */   "JP": function() { return /* binding */ EyeCloseIcon; },
/* harmony export */   "Qt": function() { return /* binding */ FormFooterWrapper; },
/* harmony export */   "S": function() { return /* binding */ CheckboxCustom; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "Wb": function() { return /* binding */ WrapperDivider; },
/* harmony export */   "ef": function() { return /* binding */ CreateAccountButtonContainer; },
/* harmony export */   "hs": function() { return /* binding */ EyeOpenIcon; },
/* harmony export */   "iz": function() { return /* binding */ Divider; },
/* harmony export */   "kV": function() { return /* binding */ TwoFactorContainer; },
/* harmony export */   "mt": function() { return /* binding */ UserData; },
/* harmony export */   "tp": function() { return /* binding */ CheckboxContainer; },
/* harmony export */   "u6": function() { return /* binding */ LinkText; },
/* harmony export */   "uN": function() { return /* binding */ FormHeaderContainer; },
/* harmony export */   "we": function() { return /* binding */ BodyContainer; },
/* harmony export */   "wj": function() { return /* binding */ PrivacyPolicyLink; },
/* harmony export */   "yB": function() { return /* binding */ WhatsAppIcon; },
/* harmony export */   "z4": function() { return /* binding */ LabelCustom; }
/* harmony export */ });
/* unused harmony exports createAccountTitle, RowCustom, WrapperRadioButton, Separator, RecaptchaWrapper, OptionText */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);
/* harmony import */ var _ButtonSubmit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42942);
/* harmony import */ var _Form_Label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3355);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17335);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: ",
        ";\n\n  @media ",
        " {\n    flex-wrap: wrap;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-weight: 400;\n  font-size: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: ",
        ";\n  flex-direction: column;\n\n  @media ",
        " {\n    gap: ",
        ";\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 406px;\n  margin-bottom: ",
        ";\n\n  @media ",
        " {\n    max-width: 324px;\n    min-width: 324px;\n  }\n\n  @media ",
        " {\n    min-width: 100%;\n    max-width: 100%;\n  }\n\n  @media ",
        " {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media ",
        " {\n    min-width: 324px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  -webkit-appearance: none;\n  appearance: none;\n  width: 1.6rem;\n  height: 1.6rem;\n  padding: 0.8175rem;\n  border-radius: ",
        ";\n  margin-right: 0.5em;\n  border: ",
        ";\n  outline: none;\n  cursor: pointer;\n  pointer-events: initial;\n  transition: all 0.2s ease-in;\n\n  &:hover {\n    border: ",
        ";\n  }\n\n  &:checked {\n    border: ",
        ";\n\n    position: relative;\n    background-color: ",
        ';\n  }\n\n  &:checked::before {\n    content: "";\n    font-size: 1.5em;\n    color: ',
        ";\n    position: absolute;\n    left: 2px;\n    top: -4px;\n    width: 6px;\n    height: 11px;\n    border-width: 0 3px 3px 0;\n    border-style: solid;\n    transform-origin: bottom left;\n    transform: rotate(45deg);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 406px;\n  align-items: center;\n  gap: ",
        ";\n\n  @media ",
        " {\n    margin-bottom: ",
        ";\n    width: 100%;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 0.6rem;\n  background-color: ",
        ";\n  height: 1px;\n  border: 0;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  @media ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  letter-spacing: -0.4px;\n  font-weight: ",
        ";\n  margin-left: 0.45rem;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline !important;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        " ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: initial;\n  background-color: ",
        ";\n  height: 1px;\n  width: 100%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding-bottom: ",
        ";\n  display: flex;\n  align-items: center;\n\n  @media ",
        " {\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}





var BodyContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__BodyContainer",
    componentId: "sc-4161a57-0"
})(_templateObject());
var CreateAccountButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__CreateAccountButtonContainer",
    componentId: "sc-4161a57-1"
})(_templateObject1());
var createAccountTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.Text).withConfig({
    displayName: "styles__createAccountTitle",
    componentId: "sc-4161a57-2"
})(_templateObject2(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[520]);
var TwoFactorContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__TwoFactorContainer",
    componentId: "sc-4161a57-3"
})(_templateObject3());
var RowCustom = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.Row).attrs({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0
}).withConfig({
    displayName: "styles__RowCustom",
    componentId: "sc-4161a57-4"
})(_templateObject4());
var WhatsAppIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.WhatsApp).attrs({
    width: 38,
    height: 38
}).withConfig({
    displayName: "styles__WhatsAppIcon",
    componentId: "sc-4161a57-5"
})(_templateObject5());
var UserData = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__UserData",
    componentId: "sc-4161a57-6"
})(_templateObject6(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tabletM, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0);
var EyeOpenIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.NewEyeOpenIcon).attrs({
    width: 16,
    height: 16,
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[550]
}).withConfig({
    displayName: "styles__EyeOpenIcon",
    componentId: "sc-4161a57-7"
})(_templateObject7());
var EyeCloseIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.NewEyeCloseIcon).attrs({
    width: 16,
    height: 16,
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[550]
}).withConfig({
    displayName: "styles__EyeCloseIcon",
    componentId: "sc-4161a57-8"
})(_templateObject8());
var LabelCustom = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_Form_Label__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    displayName: "styles__LabelCustom",
    componentId: "sc-4161a57-9"
})(_templateObject9(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[750], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x7);
var WrapperRadioButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.FlexContainer).withConfig({
    displayName: "styles__WrapperRadioButton",
    componentId: "sc-4161a57-10"
})(_templateObject10(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tabletM, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3);
var WrapperInput = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__WrapperInput",
    componentId: "sc-4161a57-11"
})(_templateObject11(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tabletXL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tabletM, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4);
var SignUpFormButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_ButtonSubmit__WEBPACK_IMPORTED_MODULE_2__/* .ButtonSubmit */ .G).attrs({
    minWidth: "406px",
    fontSize: ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x7,
    height: "3.75rem",
    fontWeight: ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400],
    fontFamily: ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo
}).withConfig({
    displayName: "styles__SignUpFormButton",
    componentId: "sc-4161a57-12"
})(_templateObject12(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tabletM);
var CheckboxCustom = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].input.attrs */ .ZP.input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "styles__CheckboxCustom",
    componentId: "sc-4161a57-13"
})(_templateObject13(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1, "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.xpx, " solid ").concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[300]), function(param) {
    var color = param.color;
    return "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.xpx, " solid ").concat(color !== null && color !== void 0 ? color : ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200]);
}, function(param) {
    var color = param.color;
    return "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.xpx, " solid ").concat(color !== null && color !== void 0 ? color : ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200]);
}, function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200];
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-4161a57-14"
})(_templateObject14(), function(param) {
    var isHidden = param.isHidden;
    return " ".concat(isHidden ? "none" : "block");
});
var FormHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__FormHeaderContainer",
    componentId: "sc-4161a57-15"
})(_templateObject15(), function(param) {
    var isHidden = param.isHidden;
    return " ".concat(isHidden ? "none" : "block");
});
var CheckboxContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CheckboxContainer",
    componentId: "sc-4161a57-16"
})(_templateObject16(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tabletM, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4);
var Separator = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
    displayName: "styles__Separator",
    componentId: "sc-4161a57-17"
})(_templateObject17(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[200]);
var FormFooterWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.SpaceWrapper).attrs({
    margin: "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, " ").concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, " ").concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, " ").concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0)
}).withConfig({
    displayName: "styles__FormFooterWrapper",
    componentId: "sc-4161a57-18"
})(_templateObject18(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tabletM, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0);
var RecaptchaWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__RecaptchaWrapper",
    componentId: "sc-4161a57-19"
})(_templateObject19());
var PrivacyPolicyLink = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__PrivacyPolicyLink",
    componentId: "sc-4161a57-20"
})(_templateObject20(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400]);
var LinkText = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_Link__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .r).withConfig({
    displayName: "styles__LinkText",
    componentId: "sc-4161a57-21"
})(_templateObject21());
var OptionText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "styles__OptionText",
    componentId: "sc-4161a57-22"
})(_templateObject22(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x5, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[350], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo);
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Divider",
    componentId: "sc-4161a57-23"
})(_templateObject23(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[580]);
var WrapperDivider = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].aside.withConfig */ .ZP.aside.withConfig({
    displayName: "styles__WrapperDivider",
    componentId: "sc-4161a57-24"
})(_templateObject24(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4);


/***/ }),

/***/ 22948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ Register; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
// EXTERNAL MODULE: ../../packages/components/Header/index.tsx + 1 modules
var Header = __webpack_require__(43119);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../packages/components/2fa/index.ts + 18 modules
var _2fa = __webpack_require__(83650);
// EXTERNAL MODULE: ../../packages/components/Form/index.tsx + 12 modules
var Form = __webpack_require__(29043);
// EXTERNAL MODULE: ../../packages/components/PasswordValidation/index.tsx + 1 modules
var PasswordValidation = __webpack_require__(4043);
// EXTERNAL MODULE: ../../packages/application/context/Identity/AuthContext.tsx
var AuthContext = __webpack_require__(24452);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/Register/Form/Header/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  justify-content: center;\n  width: 100%;\n  padding: ",
        " ",
        " ",
        ";\n\n  @media ",
        " {\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 100px;\n  border: 0.5px solid ",
        ";\n  gap: 0.75rem;\n  cursor: pointer;\n\n  background: ",
        ";\n\n  transition: 0.2s ease-in-out;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: initial;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var WrapperOAuthButtons = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__WrapperOAuthButtons",
    componentId: "sc-bec0a881-0"
})(_templateObject(), ui.theme.space.x6, ui.theme.space.x4, ui.theme.space.x0, ui.theme.space.x6, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x4);
var ButtonAuthenticationOAuth = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonAuthenticationOAuth",
    componentId: "sc-bec0a881-1"
})(_templateObject1(), ui.theme.colors.neutral[330], function(param) {
    var provider = param.provider;
    return provider !== "google" ? ui.theme.colors.neutral[999] : ui.theme.colors.neutral.white;
}, function(param) {
    var provider = param.provider;
    return provider === "google" && ui.theme.colors.neutral["999-opacity-15"];
});
var AppleOAuthIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.Apple).attrs(function(param) {
    var isHovered = param.isHovered;
    return {
        color: isHovered ? ui.theme.colors.neutral[580] : ui.theme.colors.neutral.white,
        height: 20,
        width: 20
    };
}).withConfig({
    displayName: "styles__AppleOAuthIcon",
    componentId: "sc-bec0a881-2"
})(_templateObject2());
var GoogleOAuthIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.GoogleColored).attrs({
    color: ui.theme.colors.neutral.white,
    height: 22,
    width: 22
}).withConfig({
    displayName: "styles__GoogleOAuthIcon",
    componentId: "sc-bec0a881-3"
})(_templateObject3());

;// CONCATENATED MODULE: ../../packages/components/Register/Form/Header/index.tsx




var FormHeader = function() {
    var onAuthenticateUserOAuth = (0,AuthContext/* useAuth */.aC)().onAuthenticateUserOAuth;
    var ref = (0,react.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    var handleMouseEnter = function() {
        setIsHovered(true);
    };
    var handleMouseLeave = function() {
        setIsHovered(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperOAuthButtons, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAuthenticationOAuth, {
                type: "button",
                provider: "google",
                onClick: function() {
                    return onAuthenticateUserOAuth("google");
                },
                "data-cy": "button-auth-google",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleOAuthIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAuthenticationOAuth, {
                type: "button",
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                provider: "apple",
                onClick: function() {
                    return onAuthenticateUserOAuth("apple");
                },
                "data-cy": "button-auth-apple",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppleOAuthIcon, {
                    isHovered: isHovered
                })
            })
        ]
    });
};
/* harmony default export */ var Form_Header = (FormHeader);

// EXTERNAL MODULE: ../../packages/application/hooks/Toast/index.tsx + 3 modules
var Toast = __webpack_require__(26052);
;// CONCATENATED MODULE: ../../packages/components/Register/Form/Body/components/PropsToastRegister/index.tsx



var PropsToastRegister = function(param) {
    var condition = param.condition, title = param.title, type = param.type;
    var addToast = (0,Toast.useToast)().addToast;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: condition ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: addToast({
                title: title,
                type: type
            })
        }) : null
    }, title);
};


;// CONCATENATED MODULE: ../../packages/components/Register/Form/Body/data/index.ts
var handleCleanInputData = function(clientAction, sendCodeType, emailRef, phoneNumberRef, setValue, setFocus) {
    if (clientAction === "createUser") {
        if (sendCodeType === "email" && (emailRef === null || emailRef === void 0 ? void 0 : emailRef.current)) {
            emailRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
            setValue("email", "");
            setFocus("email");
        }
        if (sendCodeType === "sms" && (phoneNumberRef === null || phoneNumberRef === void 0 ? void 0 : phoneNumberRef.current)) {
            phoneNumberRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
            setValue("phoneNumber", "");
            setFocus("phoneNumber");
        }
    }
};


// EXTERNAL MODULE: ../../packages/components/Register/Form/Body/styles.ts
var styles = __webpack_require__(59899);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../packages/application/context/BranchLocationContext.tsx
var BranchLocationContext = __webpack_require__(64462);
// EXTERNAL MODULE: ../../packages/application/state-manager/adapter.ts
var adapter = __webpack_require__(80759);
// EXTERNAL MODULE: ../../packages/application/utils/validations/index.ts + 8 modules
var validations = __webpack_require__(12747);
// EXTERNAL MODULE: ../../packages/infra/index.ts + 47 modules
var infra = __webpack_require__(11338);
// EXTERNAL MODULE: ../../node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(23848);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ../../packages/components/Register/Form/Body/schema/index.tsx


var registerFormValidateSchema = lib/* object */.Ry({
    name: lib/* string */.Z_().superRefine(function(value, context) {
        var response = (0,validations/* validateName */.Ol)(value);
        var received = response;
        if (response) context.addIssue({
            code: "invalid_type",
            expected: "string",
            received: received,
            message: "".concat(response)
        });
    }),
    cpf: lib/* string */.Z_().superRefine(function(value, context) {
        var response = (0,validations/* validateCpf */.cy)(value);
        var received = response;
        if (response) context.addIssue({
            code: "invalid_type",
            expected: "string",
            received: received,
            message: "".concat(response)
        });
    }),
    birthdate: lib/* string */.Z_().superRefine(function(value, context) {
        var response = (0,validations/* validateBirthdate */.a9)(value);
        var received = response;
        if (response) context.addIssue({
            code: "invalid_type",
            expected: "string",
            received: received,
            message: "".concat(response)
        });
    }),
    phoneNumber: lib/* string */.Z_().superRefine(function(value, context) {
        var response = (0,validations/* validatePhoneNumber */.Y0)(value);
        var received = response;
        if (response) {
            context.addIssue({
                code: "invalid_type",
                expected: "string",
                received: received,
                message: "".concat(response)
            });
        }
    }),
    email: lib/* string */.Z_().superRefine(function(value, context) {
        var response = (0,validations/* validateEmail */.oH)(value);
        var received = response;
        if (response) {
            context.addIssue({
                code: "invalid_type",
                expected: "string",
                received: received,
                message: "".concat(response)
            });
        }
    }),
    password: lib/* string */.Z_().superRefine(function(value, context) {
        var response = (0,validations/* validatePassword */.uo)(value);
        var received = response;
        if (response) {
            context.addIssue({
                code: "invalid_type",
                expected: "string",
                received: received,
                message: "".concat(response)
            });
        }
    }),
    confirmPassword: lib/* string */.Z_().superRefine(function(value, context) {
        var response = (0,validations/* validatePassword */.uo)(value);
        var received = response;
        if (response) {
            context.addIssue({
                code: "invalid_type",
                expected: "string",
                received: received,
                message: "".concat(response)
            });
        }
    }),
    trackerOrderByWhatsApp: lib/* boolean */.O7().optional(),
    acceptedTermsUse: lib/* literal */.i0(true, {
        required_error: "\xc9 necess\xe1rio aceitar os termos de uso e privacidade"
    })
});

;// CONCATENATED MODULE: ../../packages/components/Register/Form/Body/useFormBody/index.tsx


















var useFormBody = function(profileApi) {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,state_manager/* useTwoFactor */.kD)((0,adapter/* useShallow */.N)(function(state) {
        return {
            setIsBlockedToSendCode: state.setIsBlockedToSendCode,
            setIsTokenCodeValid: state.setIsTokenCodeValid,
            setValidateCode: state.setValidateCode,
            setIsValidationActive: state.setIsValidationActive,
            sendCode: state.sendCode,
            tokenCode: state.tokenCode,
            isValidationActive: state.isValidationActive,
            setCodeTimerActive: state.setCodeTimerActive,
            isSendCodeAvailable: state.isSendCodeAvailable,
            isEmailDifferent: state.isEmailDifferent,
            setIsEmailDifferent: state.setIsEmailDifferent
        };
    })), setIsBlockedToSendCode = ref4.setIsBlockedToSendCode, setIsTokenCodeValid = ref4.setIsTokenCodeValid, setValidateCode = ref4.setValidateCode, setIsValidationActive = ref4.setIsValidationActive, sendCode = ref4.sendCode, setCodeTimerActive = ref4.setCodeTimerActive, tokenCode = ref4.tokenCode, isValidationActive = ref4.isValidationActive, isSendCodeAvailable = ref4.isSendCodeAvailable, isEmailDifferent = ref4.isEmailDifferent;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var showTwoFactorButton = !isClientMobile || !isValidationActive;
    var hideFormComponents = isValidationActive && isClientMobile;
    var toastErrorTitle = "Erro ao criar conta";
    var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
        return state.allConfigs;
    });
    var router = (0,next_router.useRouter)();
    var ref5 = (0,react.useState)(false), showPasswordValidation = ref5[0], setShowPasswordValidation = ref5[1];
    var ref6 = (0,next_auth_react.useSession)(), session = ref6.data;
    var addToast = (0,Toast.useToast)().addToast;
    var ref7 = (0,react.useState)({}), oAuthForm = ref7[0], setOAuthForm = ref7[1];
    var ref8 = (0,react.useState)(""), hasDisabledInputEmailByOAuth = ref8[0], setHasDisabledInputEmailByOAuth = ref8[1];
    var ref9 = (0,react.useState)("password"), typeInputPassword = ref9[0], setTypeInputPassword = ref9[1];
    var ref10 = (0,react.useState)("password"), typeInputConfirmPassword = ref10[0], setTypeInputConfirmPassword = ref10[1];
    var ref11 = (0,react.useState)(0), passwordStrength = ref11[0], setPasswordStrength = ref11[1];
    var ref12 = (0,react.useState)(false), formSubmitted = ref12[0], setFormSubmitted = ref12[1];
    var ref13 = (0,react.useState)(false), formUnderAction = ref13[0], setFormUnderAction = ref13[1];
    var successOnCreateAccountTitle = "Sua conta foi cadastrada com sucesso!";
    var idToken = session === null || session === void 0 ? void 0 : (ref = session.token) === null || ref === void 0 ? void 0 : ref.id_token;
    var providerAuth = session === null || session === void 0 ? void 0 : (ref1 = session.token) === null || ref1 === void 0 ? void 0 : ref1.provider;
    var ref14 = (0,AuthContext/* useAuth */.aC)(), keepUserLoggedIn = ref14.keepUserLoggedIn, isAuthenticated = ref14.isAuthenticated, signOutAccount = ref14.signOutAccount, onAuthenticateUser = ref14.onAuthenticateUser, userData = ref14.userData;
    var getBranchLocationClient = (0,BranchLocationContext/* useBranchLocation */.vK)().getBranchLocationClient;
    var ref15 = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(registerFormValidateSchema)
    }), register = ref15.register, handleSubmit = ref15.handleSubmit, setValue = ref15.setValue, watch = ref15.watch, _formState = ref15.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, setFocus = ref15.setFocus, control = ref15.control;
    var nameWatcher = watch("name");
    var cpfWatcher = watch("cpf");
    var birthdateWatcher = watch("birthdate");
    var phoneNumberWatcher = watch("phoneNumber");
    var emailWatcher = watch("email");
    var passwordWatcher = watch("password");
    var confirmPasswordWatcher = watch("confirmPassword");
    var acceptedTermsUseWatcher = watch("acceptedTermsUse");
    var trackerOrderByWhatsAppWatcher = watch("trackerOrderByWhatsApp");
    var formatDate = function(dateStr) {
        var date = new Date(dateStr);
        if (Number.isNaN(date.getTime())) {
            return "";
        }
        var day = String(date.getUTCDate()).padStart(2, "0");
        var month = String(date.getUTCMonth() + 1).padStart(2, "0");
        var year = date.getUTCFullYear();
        return "".concat(day, "/").concat(month, "/").concat(year);
    };
    var handleManagementInputPasswordType = function(type) {
        setTypeInputPassword(type);
    };
    var handleManagementInputConfirmPasswordType = function(type) {
        setTypeInputConfirmPassword(type);
    };
    var fetchAPINotificationTrackerOrderByWhatsApp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(tokenType, accessTokenIdentityAPI) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            implementations/* notificationApi.setUserNotificationsSettingsWhatsApp */.E8.setUserNotificationsSettingsWhatsApp({
                                token_type: tokenType,
                                access_token: accessTokenIdentityAPI
                            }, {
                                notificationChannelId: 5,
                                notificationTypeId: 1,
                                receiveNotification: true
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchAPINotificationTrackerOrderByWhatsApp(tokenType, accessTokenIdentityAPI) {
            return _ref.apply(this, arguments);
        };
    }();
    var createSessionForUserOAuth = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(token, error, trackerOrderByWhatsApp) {
            var ref, ref1, response, _, _tmp, _1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (error) {
                            ;
                            addToast({
                                title: toastErrorTitle,
                                description: "".concat(error === null || error === void 0 ? void 0 : (ref = error.errors) === null || ref === void 0 ? void 0 : (ref1 = ref.Messages) === null || ref1 === void 0 ? void 0 : ref1[0]),
                                type: "error",
                                isNewToast: true,
                                newToastTheme: "light"
                            });
                            return [
                                2
                            ];
                        }
                        _ = implementations/* identityApi.getTokenOAuth */.IJ.getTokenOAuth;
                        _tmp = {
                            idToken: idToken,
                            provider: providerAuth || hasDisabledInputEmailByOAuth
                        };
                        _1 = JSON.stringify;
                        return [
                            4,
                            (0,application/* getGeolocation */.Yt8)()
                        ];
                    case 1:
                        return [
                            4,
                            _.apply(implementations/* identityApi */.IJ, [
                                (_tmp.location = _1.apply(JSON, [
                                    _state.sent()
                                ]), _tmp),
                                implementations/* jwtDecoder */._X
                            ])
                        ];
                    case 2:
                        response = _state.sent();
                        if (!trackerOrderByWhatsApp) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            fetchAPINotificationTrackerOrderByWhatsApp(response.token_type, response.access_token)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        keepUserLoggedIn({
                            providerType: providerAuth || hasDisabledInputEmailByOAuth,
                            token: token,
                            accessToken: response.access_token,
                            refreshToken: response.refresh_token
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(token, error, trackerOrderByWhatsApp) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addToast,
        hasDisabledInputEmailByOAuth,
        idToken,
        keepUserLoggedIn,
        providerAuth, 
    ]);
    var createSessionForUser = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var credentials, response, trackerOrderByWhatsApp, ref, ref1, ref2, ref3, data, _tmp, _;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        credentials = param.credentials, response = param.response, trackerOrderByWhatsApp = param.trackerOrderByWhatsApp;
                        if (response === null || response === void 0 ? void 0 : (ref = response.errors) === null || ref === void 0 ? void 0 : ref.Messages) {
                            ;
                            addToast({
                                title: toastErrorTitle,
                                description: "".concat(response === null || response === void 0 ? void 0 : (ref2 = response.errors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Messages) === null || ref3 === void 0 ? void 0 : ref3[0]),
                                type: "error",
                                isNewToast: true,
                                newToastTheme: "light"
                            });
                            return [
                                2
                            ];
                        }
                        _tmp = {
                            login: credentials.login,
                            password: credentials.password
                        };
                        _ = JSON.stringify;
                        return [
                            4,
                            (0,application/* getGeolocation */.Yt8)()
                        ];
                    case 1:
                        return [
                            4,
                            onAuthenticateUser.apply(void 0, [
                                (_tmp.location = _.apply(JSON, [
                                    _state.sent()
                                ]), _tmp)
                            ])
                        ];
                    case 2:
                        data = _state.sent();
                        if (!trackerOrderByWhatsApp) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            fetchAPINotificationTrackerOrderByWhatsApp(data.token_type, data.access_token)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if ((router === null || router === void 0 ? void 0 : (ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.includes("pagamento")) && data) {
                            setTimeout(function() {
                                router.push("/checkout/pagamento");
                            }, 9000);
                            return [
                                2
                            ];
                        }
                        if (data === null || data === void 0 ? void 0 : data.access_token) {
                            router.push("/");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addToast,
        onAuthenticateUser,
        router
    ]);
    // 2FA
    var handleInsertClientSuccessResponse = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(res, body, token) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!token) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            createSessionForUser({
                                credentials: {
                                    login: body.email,
                                    password: body.password
                                },
                                response: res,
                                trackerOrderByWhatsApp: body.trackerOrderByWhatsApp
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        if (!token) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            createSessionForUserOAuth(token, res, body.trackerOrderByWhatsApp)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        implementations/* gtag.signUp */.SX.signUp("password");
                        addToast({
                            title: successOnCreateAccountTitle,
                            type: "success",
                            isNewToast: true,
                            newToastTheme: "light"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(res, body, token) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addToast,
        createSessionForUser,
        createSessionForUserOAuth
    ]);
    var handleInsertClientErrorResponse = (0,react.useCallback)(function(res) {
        var ref;
        if ((res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.status) === 400) {
            var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
            if ((ref3 = res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.detail) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === null || ref3 === void 0 ? void 0 : ref3.includes("0 tentativas")) {
                setIsBlockedToSendCode(true);
                return;
            }
            addToast({
                title: toastErrorTitle,
                description: res === null || res === void 0 ? void 0 : res.data.detail,
                type: "error",
                isNewToast: true,
                newToastTheme: "light"
            });
            if ((ref6 = res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.detail) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) === null || ref6 === void 0 ? void 0 : ref6.includes("j\xe1 est\xe1 cadastrado")) {
                setIsValidationActive(false);
                return;
            }
            if (res === null || res === void 0 ? void 0 : (ref7 = res.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.detail) === null || ref8 === void 0 ? void 0 : ref8.includes("C\xf3digo inv\xe1lido")) {
                setIsTokenCodeValid(false);
            }
        } else {
            addToast({
                title: "Ocorreu um erro ao cadastrar o usu\xe1rio. Favor, tente novamente",
                type: "error",
                isNewToast: true,
                newToastTheme: "light"
            });
        }
    }, [
        addToast,
        setIsTokenCodeValid,
        setIsBlockedToSendCode,
        setIsValidationActive, 
    ]);
    (0,react.useEffect)(function() {
        if (!router) return;
        var handleRouteChange = function() {
            setIsValidationActive(false);
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        // eslint-disable-next-line consistent-return
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router,
        setIsValidationActive
    ]);
    var insertClient = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            profileApi.createBFFClient(body, hasDisabledInputEmailByOAuth || "password").then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(res) {
                                    var ref, response, createdClient;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                response = res;
                                                createdClient = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.id;
                                                if (!(createdClient && res)) return [
                                                    3,
                                                    2
                                                ];
                                                infra/* InsiderObject.sendEvent */.xp.sendEvent("events", [
                                                    {
                                                        event_name: "sign_up"
                                                    }
                                                ]);
                                                return [
                                                    4,
                                                    handleInsertClientSuccessResponse(res, body)
                                                ];
                                            case 1:
                                                _state.sent();
                                                setFormUnderAction(false);
                                                setIsValidationActive(false);
                                                return [
                                                    2
                                                ];
                                            case 2:
                                                handleInsertClientErrorResponse(res);
                                                setFormUnderAction(false);
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(res) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(error) {
                                implementations/* appMonitoringClient.captureException */.pE.captureException(error);
                                setFormUnderAction(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(body) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleInsertClientErrorResponse,
        handleInsertClientSuccessResponse,
        hasDisabledInputEmailByOAuth,
        profileApi,
        setIsValidationActive, 
    ]);
    var validateToken = (0,react.useCallback)(function() {
        var ref, ref1;
        var branchLocation = getBranchLocationClient();
        var ref2;
        var data = {
            name: (0,application/* formatUserName */.BDI)((ref2 = session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.name) !== null && ref2 !== void 0 ? ref2 : ""),
            email: (session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.email) || "",
            birthdate: "",
            phoneNumber: "",
            cpf: "",
            password: "",
            acceptedTermsUse: false,
            trackerOrderByWhatsApp: false,
            defaultBranchId: Number(branchLocation)
        };
        setOAuthForm(data);
        implementations/* gtag.signUp */.SX.signUp("apple");
    }, [
        getBranchLocationClient,
        session === null || session === void 0 ? void 0 : (ref2 = session.user) === null || ref2 === void 0 ? void 0 : ref2.email,
        session === null || session === void 0 ? void 0 : (ref3 = session.user) === null || ref3 === void 0 ? void 0 : ref3.name
    ]);
    var handleUserGoogleAuthenticate = (0,react.useCallback)(function() {
        if (session && !isAuthenticated) {
            var ref, ref1;
            var branchLocation = getBranchLocationClient();
            var user = {
                name: (0,application/* formatUserName */.BDI)((session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.name) || ""),
                email: (session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.email) || "",
                birthdate: "",
                phoneNumber: "",
                cpf: "",
                password: "",
                acceptedTermsUse: false,
                trackerOrderByWhatsApp: false,
                defaultBranchId: Number(branchLocation)
            };
            setOAuthForm(user);
            implementations/* gtag.signUp */.SX.signUp("google");
        }
    }, [
        getBranchLocationClient,
        isAuthenticated,
        session
    ]);
    // 2FA
    var handleSignUp = (0,react.useCallback)(function() {
        setFormUnderAction(true);
        var branchLocation = getBranchLocationClient();
        var formatDateFromWatcher = formatDate(birthdateWatcher);
        var ref = (0,_sliced_to_array/* default */.Z)(formatDateFromWatcher.toString().split("/"), 3), day = ref[0], month = ref[1], year = ref[2];
        var formattedBirthDate = new Date("".concat(year, "-").concat(month, "-").concat(day)).toISOString();
        var body = {
            name: (0,application/* formatUserName */.BDI)(nameWatcher),
            cpf: cpfWatcher,
            birthdate: formattedBirthDate,
            email: emailWatcher,
            password: passwordWatcher,
            phoneNumber: phoneNumberWatcher,
            acceptedTermsUse: acceptedTermsUseWatcher,
            trackerOrderByWhatsApp: !!trackerOrderByWhatsAppWatcher,
            defaultBranchId: Number(branchLocation),
            // faType = 5 significa validação feita por email
            faType: 5,
            tokenValidation: tokenCode
        };
        setOAuthForm(body);
        insertClient(body);
        setValidateCode(true);
    }, [
        acceptedTermsUseWatcher,
        birthdateWatcher,
        cpfWatcher,
        emailWatcher,
        getBranchLocationClient,
        insertClient,
        nameWatcher,
        passwordWatcher,
        phoneNumberWatcher,
        setValidateCode,
        tokenCode,
        trackerOrderByWhatsAppWatcher, 
    ]);
    var insertClientWithoutTwoFA = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(body, token) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            profileApi.createClient(body, hasDisabledInputEmailByOAuth || "password").then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(res) {
                                    var ref, ref1, ref2, ref3, err;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (res === null || res === void 0 ? void 0 : (ref = res.errors) === null || ref === void 0 ? void 0 : (ref1 = ref.Messages) === null || ref1 === void 0 ? void 0 : ref1[0]) {
                                                    ;
                                                    addToast({
                                                        title: res === null || res === void 0 ? void 0 : (ref2 = res.errors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Messages) === null || ref3 === void 0 ? void 0 : ref3[0],
                                                        type: "error",
                                                        isNewToast: true,
                                                        newToastTheme: "light"
                                                    });
                                                    setFormUnderAction(false);
                                                    return [
                                                        2
                                                    ];
                                                }
                                                if (!res) {
                                                    addToast({
                                                        title: "Ocorreu um erro inesperado, tente novamente",
                                                        type: "error",
                                                        isNewToast: true,
                                                        newToastTheme: "light"
                                                    });
                                                    setFormUnderAction(false);
                                                    return [
                                                        2
                                                    ];
                                                }
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    6,
                                                    ,
                                                    7
                                                ]);
                                                if (!!token) return [
                                                    3,
                                                    3
                                                ];
                                                return [
                                                    4,
                                                    createSessionForUser({
                                                        credentials: {
                                                            login: body.email,
                                                            password: body.password
                                                        },
                                                        response: res,
                                                        trackerOrderByWhatsApp: body.trackerOrderByWhatsApp
                                                    })
                                                ];
                                            case 2:
                                                _state.sent();
                                                _state.label = 3;
                                            case 3:
                                                if (!token) return [
                                                    3,
                                                    5
                                                ];
                                                return [
                                                    4,
                                                    createSessionForUserOAuth(token, res, body.trackerOrderByWhatsApp)
                                                ];
                                            case 4:
                                                _state.sent();
                                                _state.label = 5;
                                            case 5:
                                                setFormUnderAction(false);
                                                infra/* InsiderObject.sendEvent */.xp.sendEvent("events", [
                                                    {
                                                        event_name: "sign_up"
                                                    }
                                                ]);
                                                addToast({
                                                    title: successOnCreateAccountTitle,
                                                    type: "success",
                                                    isNewToast: true,
                                                    newToastTheme: "light"
                                                });
                                                implementations/* gtag.signUp */.SX.signUp("password");
                                                router.push("/");
                                                return [
                                                    3,
                                                    7
                                                ];
                                            case 6:
                                                err = _state.sent();
                                                setFormUnderAction(false);
                                                addToast({
                                                    title: successOnCreateAccountTitle,
                                                    type: "success",
                                                    isNewToast: true,
                                                    newToastTheme: "light"
                                                });
                                                implementations/* gtag.signUp */.SX.signUp("password");
                                                router.push("/");
                                                return [
                                                    3,
                                                    7
                                                ];
                                            case 7:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(res) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(error) {
                                implementations/* appMonitoringClient.captureException */.pE.captureException(error);
                                setFormUnderAction(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function insertClientWithoutTwoFA(body, token) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSignUpWithoutTwoFA = function(formData) {
        setFormUnderAction(true);
        var branchLocation = getBranchLocationClient();
        var formatDateFromWatcher = formatDate(birthdateWatcher);
        var ref = (0,_sliced_to_array/* default */.Z)(formatDateFromWatcher.toString().split("/"), 3), day = ref[0], month = ref[1], year = ref[2];
        var formattedBirthDate = new Date("".concat(year, "-").concat(month, "-").concat(day)).toISOString();
        var _trackerOrderByWhatsApp;
        var body = {
            name: (0,application/* formatUserName */.BDI)(formData.name),
            cpf: formData.cpf,
            birthdate: formattedBirthDate,
            email: formData.email,
            password: formData.password,
            phoneNumber: formData.phoneNumber,
            acceptedTermsUse: formData.acceptedTermsUse,
            trackerOrderByWhatsApp: (_trackerOrderByWhatsApp = formData.trackerOrderByWhatsApp) !== null && _trackerOrderByWhatsApp !== void 0 ? _trackerOrderByWhatsApp : false,
            defaultBranchId: Number(branchLocation)
        };
        setOAuthForm(body);
        insertClientWithoutTwoFA(body);
    };
    var removeSessionOnIncomingSignUpPage = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            if ((userData === null || userData === void 0 ? void 0 : userData.name) && (oAuthForm === null || oAuthForm === void 0 ? void 0 : oAuthForm.email)) {
                signOutAccount(implementations/* cookie */.pR);
                setOAuthForm({});
            }
            return [
                2
            ];
        });
    }), [
        oAuthForm.email,
        signOutAccount,
        userData === null || userData === void 0 ? void 0 : userData.name
    ]);
    (0,react.useEffect)(function() {
        removeSessionOnIncomingSignUpPage();
    }, [
        removeSessionOnIncomingSignUpPage
    ]);
    (0,react.useEffect)(function() {
        if (providerAuth === "google") {
            setHasDisabledInputEmailByOAuth("google");
            handleUserGoogleAuthenticate();
            setValue("name", (0,application/* formatUserName */.BDI)(oAuthForm === null || oAuthForm === void 0 ? void 0 : oAuthForm.name));
            setValue("email", oAuthForm.email);
        }
    }, [
        handleUserGoogleAuthenticate,
        setValue,
        oAuthForm.name,
        oAuthForm.email,
        providerAuth,
        hasDisabledInputEmailByOAuth, 
    ]);
    (0,react.useEffect)(function() {
        if (providerAuth === "apple") {
            setHasDisabledInputEmailByOAuth("apple");
            validateToken();
            var _name;
            setValue("name", (0,application/* formatUserName */.BDI)((_name = oAuthForm.name) !== null && _name !== void 0 ? _name : ""));
            setValue("email", oAuthForm.email);
        }
    }, [
        oAuthForm.email,
        oAuthForm.name,
        providerAuth,
        hasDisabledInputEmailByOAuth,
        setValue,
        validateToken, 
    ]);
    var sanitizeBirthdateWatcher = formatDate(birthdateWatcher);
    var isInvalidNameAndSurname = (0,validations/* validateName */.Ol)(nameWatcher);
    var isInvalidCpf = (0,validations/* validateCpf */.cy)(cpfWatcher);
    var isInvalidBirthdate = (0,validations/* validateBirthdate */.a9)(sanitizeBirthdateWatcher);
    var isInvalidPhoneNumber = (0,validations/* validatePhoneNumber */.Y0)(phoneNumberWatcher);
    var isInvalidEmail = (0,validations/* validateEmail */.oH)(emailWatcher);
    var isInvalidPassword = (0,validations/* validatePassword */.uo)(passwordWatcher);
    var isInvalidConfirmPassword = (0,validations/* validateConfirmPassword */.S$)(passwordWatcher, confirmPasswordWatcher);
    var isDisabled = isInvalidNameAndSurname || isInvalidBirthdate || isInvalidCpf || isInvalidEmail || isInvalidPhoneNumber || !acceptedTermsUseWatcher || passwordStrength !== 5;
    var validateInputValue = function(type) {
        switch(type){
            case "name":
                return Boolean(isInvalidNameAndSurname);
            case "cpf":
                return Boolean(isInvalidCpf);
            case "birthdate":
                return Boolean(isInvalidBirthdate);
            case "phoneNumber":
                return Boolean(isInvalidPhoneNumber);
            case "email":
                return Boolean(isInvalidEmail);
            case "password":
                return Boolean(isInvalidPassword);
            case "confirmPassword":
                return Boolean(isInvalidConfirmPassword);
            default:
                return false;
        }
    };
    var basicFieldValidation = function(field) {
        var ref, ref1;
        return validateInputValue(field) && ((ref = watch(field)) === null || ref === void 0 ? void 0 : ref.length) || formSubmitted && !((ref1 = watch(field)) === null || ref1 === void 0 ? void 0 : ref1.length);
    };
    var handleFormFieldError = function(field) {
        switch(field){
            case "email":
                var ref;
                return validateInputValue(field) && ((ref = watch(field)) === null || ref === void 0 ? void 0 : ref.length) > 1;
            case "name":
                var ref1;
                return validateInputValue(field) && ((ref1 = watch(field)) === null || ref1 === void 0 ? void 0 : ref1.length) || !!errors.name;
            case "cpf":
                return basicFieldValidation(field);
            case "birthdate":
                return validateInputValue("birthdate");
            case "password":
                var ref2;
                return validateInputValue(field) && ((ref2 = watch(field)) === null || ref2 === void 0 ? void 0 : ref2.length) || !!(errors === null || errors === void 0 ? void 0 : errors.password);
            case "phoneNumber":
                var ref3;
                return validateInputValue(field) && ((ref3 = watch(field)) === null || ref3 === void 0 ? void 0 : ref3.length) || !!(errors === null || errors === void 0 ? void 0 : errors.phoneNumber);
            case "confirmPassword":
                var ref4;
                return validateInputValue(field) && ((ref4 = watch(field)) === null || ref4 === void 0 ? void 0 : ref4.length) || !!(errors === null || errors === void 0 ? void 0 : errors.confirmPassword);
            default:
                return false;
        }
    };
    var onlyNumbers = "Apenas n\xfameros";
    (0,react.useEffect)(function() {
        var ref;
        if ((router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("pagamento")) && isAuthenticated) {
            router.push("checkout/pagamento");
        }
    }, [
        isAuthenticated,
        router
    ]);
    var handleValidateTwoFactorTokenEmail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(type, emailValidate, token) {
            var sanitizedEmail, result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sanitizedEmail = emailValidate.replace(/@/g, "%40");
                        return [
                            4,
                            implementations/* notificationApi.validateTwoFactorTokenEmail */.E8.validateTwoFactorTokenEmail(type, sanitizedEmail, token)
                        ];
                    case 1:
                        result = _state.sent();
                        setIsTokenCodeValid(result.isValidEmail);
                        setValidateCode(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleValidateTwoFactorTokenEmail(type, emailValidate, token) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref16 = (0,react.useState)(null), clientInfo = ref16[0], setClientInfo = ref16[1];
    var ref17 = (0,react.useState)(false), isCodeSent = ref17[0], setIsCodeSent = ref17[1];
    var handleContinueRegister = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var sendCodeResult;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(isSendCodeAvailable || isEmailDifferent)) return [
                            3,
                            2
                        ];
                        setClientInfo({
                            name: (0,application/* formatUserName */.BDI)(nameWatcher),
                            cpf: cpfWatcher,
                            birthdate: birthdateWatcher,
                            phoneNumber: phoneNumberWatcher,
                            email: emailWatcher,
                            password: passwordWatcher,
                            acceptedTermsUse: acceptedTermsUseWatcher,
                            trackerOrderByWhatsAppState: !!trackerOrderByWhatsAppWatcher
                        });
                        return [
                            4,
                            sendCode({
                                sendCodeType: "email",
                                notificationApi: implementations/* notificationApi */.E8,
                                infoValue: emailWatcher === null || emailWatcher === void 0 ? void 0 : emailWatcher.replace(/@/g, "%40"),
                                addToast: addToast,
                                errorTitle: toastErrorTitle
                            })
                        ];
                    case 1:
                        sendCodeResult = _state.sent();
                        setIsCodeSent(sendCodeResult);
                        setIsValidationActive(true);
                        setCodeTimerActive(true);
                        return [
                            2,
                            sendCodeResult
                        ];
                    case 2:
                        setIsValidationActive(true);
                        setCodeTimerActive(true);
                        return [
                            2,
                            false
                        ];
                }
            });
        });
        return function handleContinueRegister() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        allConfigs: allConfigs,
        handleContinueRegister: handleContinueRegister,
        showPasswordValidation: showPasswordValidation,
        setShowPasswordValidation: setShowPasswordValidation,
        typeInputPassword: typeInputPassword,
        typeInputConfirmPassword: typeInputConfirmPassword,
        setPasswordStrength: setPasswordStrength,
        setFormSubmitted: setFormSubmitted,
        formSubmitted: formSubmitted,
        formUnderAction: formUnderAction,
        onlyNumbers: onlyNumbers,
        idToken: idToken,
        providerAuth: providerAuth,
        register: register,
        handleSubmit: handleSubmit,
        setValue: setValue,
        setFocus: setFocus,
        watch: watch,
        errors: errors,
        isSubmitting: isSubmitting,
        nameWatcher: nameWatcher,
        cpfWatcher: cpfWatcher,
        birthdateWatcher: birthdateWatcher,
        phoneNumberWatcher: phoneNumberWatcher,
        emailWatcher: emailWatcher,
        passwordWatcher: passwordWatcher,
        confirmPasswordWatcher: confirmPasswordWatcher,
        acceptedTermsUseWatcher: acceptedTermsUseWatcher,
        handleManagementInputPasswordType: handleManagementInputPasswordType,
        handleManagementInputConfirmPasswordType: handleManagementInputConfirmPasswordType,
        handleSignUp: handleSignUp,
        handleSignUpWithoutTwoFA: handleSignUpWithoutTwoFA,
        isDisabled: isDisabled,
        handleFormFieldError: handleFormFieldError,
        isInvalidNameAndSurname: isInvalidNameAndSurname,
        isInvalidCpf: isInvalidCpf,
        isInvalidBirthdate: isInvalidBirthdate,
        isInvalidPhoneNumber: isInvalidPhoneNumber,
        isInvalidEmail: isInvalidEmail,
        isInvalidPassword: isInvalidPassword,
        oAuthForm: oAuthForm,
        hasDisabledInputEmailByOAuth: hasDisabledInputEmailByOAuth,
        validateInputValue: validateInputValue,
        handleValidateTwoFactorTokenEmail: handleValidateTwoFactorTokenEmail,
        insertClient: insertClient,
        insertClientWithoutTwoFA: insertClientWithoutTwoFA,
        clientInfo: clientInfo,
        isCodeSent: isCodeSent,
        isClientMobile: isClientMobile,
        showTwoFactorButton: showTwoFactorButton,
        hideFormComponents: hideFormComponents,
        router: router,
        control: control
    };
};


;// CONCATENATED MODULE: ../../packages/components/Register/Form/Body/useFormInputRefs/index.ts

var useFormInputRefs = function() {
    var emailRef = (0,react.useRef)(null);
    var phoneNumberRef = (0,react.useRef)(null);
    return {
        emailRef: emailRef,
        phoneNumberRef: phoneNumberRef
    };
};


;// CONCATENATED MODULE: ../../packages/components/Register/Form/Body/index.tsx














var TwoFactorButton = (0,application/* lazyLoading */.jfz)(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 60985)).then(function(module) {
        return module.TwoFactorButton;
    });
});
var InputWidth = function(input) {
    var ref = (0,application/* useAppContext */.bp4)(), isClientTabletXL = ref.isClientTabletXL, isClientTabletM = ref.isClientTabletM;
    var defaultWidth = "100%";
    var widthBigOnTabletXL = "324px";
    var widthSmallOnTabletXL = "279px";
    var defaultWidthOnTabletM = function() {
        return isClientTabletM && defaultWidth;
    };
    var widthBig = function() {
        return isClientTabletXL ? widthBigOnTabletXL : defaultWidth;
    };
    var widthSmall = function() {
        return isClientTabletXL ? widthSmallOnTabletXL : defaultWidth;
    };
    switch(input){
        case "big":
            return defaultWidthOnTabletM() || widthBig();
        case "small":
            return defaultWidthOnTabletM() || widthSmall();
        default:
            return defaultWidth;
    }
};
var FormBody = function(param) {
    var profileApi = param.profileApi;
    var ref = useFormBody(profileApi), allConfigs = ref.allConfigs, showPasswordValidation = ref.showPasswordValidation, setShowPasswordValidation = ref.setShowPasswordValidation, typeInputPassword = ref.typeInputPassword, typeInputConfirmPassword = ref.typeInputConfirmPassword, setPasswordStrength = ref.setPasswordStrength, setFormSubmitted = ref.setFormSubmitted, formUnderAction = ref.formUnderAction, onlyNumbers = ref.onlyNumbers, register = ref.register, handleSubmit = ref.handleSubmit, setValue = ref.setValue, setFocus = ref.setFocus, errors = ref.errors, isSubmitting = ref.isSubmitting, passwordWatcher = ref.passwordWatcher, confirmPasswordWatcher = ref.confirmPasswordWatcher, acceptedTermsUseWatcher = ref.acceptedTermsUseWatcher, handleManagementInputPasswordType = ref.handleManagementInputPasswordType, handleManagementInputConfirmPasswordType = ref.handleManagementInputConfirmPasswordType, handleSignUp = ref.handleSignUp, handleSignUpWithoutTwoFA = ref.handleSignUpWithoutTwoFA, isDisabled = ref.isDisabled, handleFormFieldError = ref.handleFormFieldError, isInvalidNameAndSurname = ref.isInvalidNameAndSurname, isInvalidCpf = ref.isInvalidCpf, isInvalidBirthdate = ref.isInvalidBirthdate, isInvalidPhoneNumber = ref.isInvalidPhoneNumber, isInvalidEmail = ref.isInvalidEmail, isInvalidPassword = ref.isInvalidPassword, oAuthForm = ref.oAuthForm, hasDisabledInputEmailByOAuth = ref.hasDisabledInputEmailByOAuth, validateInputValue = ref.validateInputValue, handleContinueRegister = ref.handleContinueRegister, emailWatcher = ref.emailWatcher, isCodeSent = ref.isCodeSent, isClientMobile = ref.isClientMobile, showTwoFactorButton = ref.showTwoFactorButton, hideFormComponents = ref.hideFormComponents, router = ref.router, control = ref.control;
    var ref1 = useFormInputRefs(), emailRef = ref1.emailRef, phoneNumberRef = ref1.phoneNumberRef;
    var focusBirthDate = function() {
        var birthDate = document.querySelector("#birthdate");
        birthDate === null || birthDate === void 0 ? void 0 : birthDate.focus();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* BodyContainer */.we, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PropsToastRegister, {
                condition: isSubmitting && !acceptedTermsUseWatcher,
                title: "\xc9 necess\xe1rio aceitar os termos de uso e privacidade",
                type: "error"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* FormHeaderContainer */.uN, {
                isHidden: hideFormComponents,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Title, {
                        color: ui.theme.colors.neutral[525],
                        fontSize: ui.theme.typography.fontSize.md.x1,
                        children: "Crie sua conta"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Header, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* WrapperDivider */.Wb, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Divider */.iz, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, {
                margin: "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x0, " ").concat(ui.theme.space.x4, " ").concat(ui.theme.space.x0),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, {
                    margin: "".concat(ui.theme.space.x0),
                    padding: "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x0),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        id: "sign-up-form"
                    }, (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isTwoFactorAuthenticationAvailable) !== "true" && {
                        onSubmit: handleSubmit(handleSignUpWithoutTwoFA)
                    }), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Container */.W2, {
                                isHidden: hideFormComponents,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* UserData */.mt, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* WrapperInput */.AX, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                                                        xs: "6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* LabelCustom */.z4, {
                                                            htmlFor: "name",
                                                            text: "Nome e Sobrenome",
                                                            "data-cy": "label-name"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Input */.II, {
                                                            required: true,
                                                            id: "name",
                                                            name: "name",
                                                            type: "text",
                                                            height: "45px",
                                                            autoComplete: "off",
                                                            placeholder: "Digite seu nome e sobrenome",
                                                            register: register,
                                                            hasError: handleFormFieldError("name"),
                                                            textError: isInvalidNameAndSurname,
                                                            paddingInfo: "0px",
                                                            paddingErrorMessage: "0px",
                                                            width: InputWidth("big"),
                                                            margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
                                                            borderRadius: "".concat(ui.theme.space.x1),
                                                            onBlur: function(param) {
                                                                var target = param.target;
                                                                return setValue("name", target.value.trim());
                                                            },
                                                            "data-cy": "input-name",
                                                            color: "".concat(ui.theme.colors.neutral[350]),
                                                            hasSuccessfully: !validateInputValue("name"),
                                                            borderColor: ui.theme.colors.neutral[580],
                                                            colorInfo: ui.theme.colors.neutral[550]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* WrapperInput */.AX, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                                                        xs: "6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* LabelCustom */.z4, {
                                                            htmlFor: "cpf",
                                                            text: "CPF",
                                                            "data-cy": "label-cpf"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Input */.II, {
                                                            id: "cpf",
                                                            type: "tel",
                                                            mask: "999.999.999-99",
                                                            name: "cpf",
                                                            height: "45px",
                                                            placeholder: "Digite seu CPF",
                                                            hasSuccessfully: !validateInputValue("cpf"),
                                                            textError: isInvalidCpf,
                                                            onBlur: function(param) {
                                                                var target = param.target;
                                                                return setValue("cpf", target.value.replace(/[^0-9]/g, ""));
                                                            },
                                                            colorInfo: ui.theme.colors.neutral[550],
                                                            textInfo: !handleFormFieldError("cpf") && onlyNumbers,
                                                            margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
                                                            hasError: handleFormFieldError("cpf"),
                                                            paddingInfo: "0px",
                                                            paddingErrorMessage: "0px",
                                                            "data-cy": "input-cpf",
                                                            register: register,
                                                            width: InputWidth("small"),
                                                            borderRadius: "".concat(ui.theme.space.x1),
                                                            borderColor: ui.theme.colors.neutral[580]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* UserData */.mt, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* WrapperInput */.AX, {
                                                ref: emailRef,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                                                        xs: "6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* LabelCustom */.z4, {
                                                            htmlFor: "email",
                                                            text: "E-mail",
                                                            "data-cy": "label-email"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Input */.II, {
                                                            id: "email",
                                                            name: "email",
                                                            type: "email",
                                                            role: "presentation",
                                                            height: "45px",
                                                            autoComplete: "off",
                                                            placeholder: "Digite seu e-mail",
                                                            hasSuccessfully: !validateInputValue("email"),
                                                            onBlur: function(param) {
                                                                var target = param.target;
                                                                var ref;
                                                                setValue("email", (ref = target.value.trim()) !== null && ref !== void 0 ? ref : oAuthForm === null || oAuthForm === void 0 ? void 0 : oAuthForm.email);
                                                            },
                                                            paddingInfo: "0px",
                                                            paddingErrorMessage: "0px",
                                                            hasError: handleFormFieldError("email"),
                                                            textError: isInvalidEmail,
                                                            "data-cy": "input-email",
                                                            register: register,
                                                            disabled: hasDisabledInputEmailByOAuth ? !!(oAuthForm === null || oAuthForm === void 0 ? void 0 : oAuthForm.email) : false,
                                                            width: InputWidth("big"),
                                                            margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
                                                            borderRadius: "".concat(ui.theme.space.x1),
                                                            borderColor: ui.theme.colors.neutral[580],
                                                            colorInfo: ui.theme.colors.neutral[550]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* WrapperInput */.AX, {
                                                ref: phoneNumberRef,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                                                        xs: "6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* LabelCustom */.z4, {
                                                            htmlFor: "phoneNumber",
                                                            text: "Celular",
                                                            "data-cy": "label-phoneNumber"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Input */.II, {
                                                            id: "phoneNumber",
                                                            name: "phoneNumber",
                                                            type: "tel",
                                                            mask: "(99) 99999-9999",
                                                            placeholder: "(81) 98888-9999",
                                                            register: register,
                                                            hasError: false,
                                                            textError: isInvalidPhoneNumber,
                                                            width: InputWidth("small"),
                                                            height: "45px",
                                                            paddingInfo: "0px",
                                                            paddingErrorMessage: "0px",
                                                            textInfo: !handleFormFieldError("phoneNumber") && onlyNumbers,
                                                            borderRadius: "".concat(ui.theme.space.x1),
                                                            onBlur: function(param) {
                                                                var target = param.target;
                                                                return setValue("phoneNumber", target.value.replace(/\D/g, ""));
                                                            },
                                                            margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
                                                            hasSuccessfully: !validateInputValue("phoneNumber"),
                                                            "data-cy": "input-phoneNumber",
                                                            borderColor: ui.theme.colors.neutral[580],
                                                            colorInfo: ui.theme.colors.neutral[550]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* UserData */.mt, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* WrapperInput */.AX, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                                                    xs: "6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* LabelCustom */.z4, {
                                                        htmlFor: "birthdate",
                                                        text: "Data de Nascimento",
                                                        "data-cy": "label-birthdate"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* NewCustomInput */.xg, {
                                                    "data-cy": "input-birthdate",
                                                    name: "birthdate",
                                                    placeholder: "Escolha a data",
                                                    control: control,
                                                    id: "birthdate",
                                                    type: "date",
                                                    hasIcon: true,
                                                    hasIconBorder: true,
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CalendarIcon, {
                                                        width: 40
                                                    }),
                                                    textInfo: !handleFormFieldError("birthdate"),
                                                    textError: isInvalidBirthdate,
                                                    hasError: handleFormFieldError("birthdate"),
                                                    hasSuccessfully: !validateInputValue("birthdate"),
                                                    width: isClientMobile ? "100%" : "204px",
                                                    paddingInfo: "0px",
                                                    paddingErrorMessage: "0px",
                                                    height: "45px",
                                                    borderColor: ui.theme.colors.neutral[580],
                                                    margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
                                                    padding: "1.2rem 2.875rem 1.2rem 0.9rem !important",
                                                    colorInfo: ui.theme.colors.neutral[550],
                                                    onClickIcon: focusBirthDate,
                                                    onChange: function(param) {
                                                        var target = param.target;
                                                        setValue("birthdate", target === null || target === void 0 ? void 0 : target.value);
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* UserData */.mt, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* WrapperInput */.AX, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                                                        xs: "6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* LabelCustom */.z4, {
                                                            htmlFor: "password",
                                                            text: "Senha",
                                                            "data-cy": "label-password"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Input */.II, {
                                                        id: "password",
                                                        name: "password",
                                                        type: typeInputPassword,
                                                        role: "presentation",
                                                        autoComplete: "off",
                                                        placeholder: "Digite uma senha v\xe1lida",
                                                        register: register,
                                                        onKeyDown: function() {
                                                            return setShowPasswordValidation(true);
                                                        },
                                                        height: "45px",
                                                        paddingInfo: "0px",
                                                        paddingErrorMessage: "0px",
                                                        width: InputWidth("big"),
                                                        textInfo: !handleFormFieldError("password"),
                                                        borderRadius: "".concat(ui.theme.space.x1),
                                                        hasError: handleFormFieldError("password"),
                                                        textError: isInvalidPassword,
                                                        "data-cy": "input-password",
                                                        onChange: function(param) {
                                                            var target = param.target;
                                                            return setValue("password", target.value);
                                                        },
                                                        icon: typeInputPassword === "password" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* EyeCloseIcon */.JP, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* EyeOpenIcon */.hs, {}),
                                                        onClickIcon: function() {
                                                            return handleManagementInputPasswordType(typeInputPassword === "password" ? "text" : "password");
                                                        },
                                                        margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
                                                        padding: "1.2rem 2.875rem 1.2rem 0.9rem !important",
                                                        hasSuccessfully: !validateInputValue("password"),
                                                        hasIcon: true,
                                                        borderColor: ui.theme.colors.neutral[580],
                                                        colorInfo: ui.theme.colors.neutral[550]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* WrapperInput */.AX, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                                                        xs: "6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* LabelCustom */.z4, {
                                                            htmlFor: "password",
                                                            text: "Confirme a senha",
                                                            "data-cy": "label-password"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Input */.II, {
                                                        id: "confirmPassword",
                                                        name: "confirmPassword",
                                                        type: typeInputConfirmPassword,
                                                        role: "presentation",
                                                        autoComplete: "off",
                                                        height: "45px",
                                                        placeholder: "Repita a senha",
                                                        register: register,
                                                        width: InputWidth("small"),
                                                        hasError: handleFormFieldError("confirmPassword"),
                                                        paddingInfo: "0px",
                                                        paddingErrorMessage: "0px",
                                                        textInfo: !handleFormFieldError("confirmPassword"),
                                                        onClickIcon: function() {
                                                            return handleManagementInputConfirmPasswordType(typeInputConfirmPassword === "password" ? "text" : "password");
                                                        },
                                                        icon: typeInputConfirmPassword === "password" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* EyeCloseIcon */.JP, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* EyeOpenIcon */.hs, {}),
                                                        "data-cy": "input-confirm-password",
                                                        onChange: function(param) {
                                                            var target = param.target;
                                                            return setValue("confirmPassword", target.value);
                                                        },
                                                        margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
                                                        hasIcon: true,
                                                        padding: "1.2rem 2.875rem 1.2rem 0.9rem !important",
                                                        borderRadius: "".concat(ui.theme.space.x1),
                                                        hasSuccessfully: !validateInputValue("confirmPassword") && (confirmPasswordWatcher === null || confirmPasswordWatcher === void 0 ? void 0 : confirmPasswordWatcher.length) > 1,
                                                        borderColor: ui.theme.colors.neutral[580],
                                                        colorInfo: ui.theme.colors.neutral[550]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordValidation/* PasswordValidation */.T, {
                                        onChangePasswordStrength: function(strength) {
                                            return setPasswordStrength(strength);
                                        },
                                        userConfirmPassword: confirmPasswordWatcher,
                                        userPassword: passwordWatcher,
                                        showComponent: showPasswordValidation
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* UserData */.mt, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CheckboxContainer */.tp, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* CheckboxCustom */.S, (0,_object_spread/* default */.Z)({
                                                        id: "acceptedTermsUse",
                                                        checked: !!acceptedTermsUseWatcher,
                                                        hasError: !!errors.acceptedTermsUse,
                                                        "data-cy": "checkbox-accept-form"
                                                    }, register("acceptedTermsUse", {
                                                        required: true
                                                    }))),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Text, {
                                                        fontSize: ui.theme.typography.fontSize.sm.x4,
                                                        color: ui.theme.colors.neutral[750],
                                                        letterSpacing: "-0.24px",
                                                        children: [
                                                            "Li e aceito os",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* PrivacyPolicyLink */.wj, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* LinkText */.u6, {
                                                                        id: "termsOfUse",
                                                                        color: ui.theme.colors.neutral[750],
                                                                        fontWeight: String(ui.theme.typography.fontWeight[500]),
                                                                        fontSize: ui.theme.typography.fontSize.sm.x4,
                                                                        href: "https://ferreiracosta.movidesk.com/kb/pt-br/article/156348/termos-e-condicoes-de-uso-do-site",
                                                                        children: "termos e condi\xe7\xf5es de uso"
                                                                    }),
                                                                    " ",
                                                                    "e",
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* LinkText */.u6, {
                                                                        id: "termsOfPrivacy",
                                                                        color: ui.theme.colors.neutral[750],
                                                                        fontWeight: String(ui.theme.typography.fontWeight[500]),
                                                                        fontSize: ui.theme.typography.fontSize.sm.x4,
                                                                        href: "https://ferreiracosta.movidesk.com/kb/article/158335/politica-de-privacidade-do-site-da-ferreira-costa",
                                                                        children: "politica de privacidade"
                                                                    }),
                                                                    " "
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CheckboxContainer */.tp, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* CheckboxCustom */.S, (0,_object_spread/* default */.Z)({
                                                        id: "trackerOrderByWhatsApp",
                                                        "data-cy": "checkbox-tracker-order",
                                                        required: false,
                                                        hasError: false
                                                    }, register("trackerOrderByWhatsApp"))),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* WhatsAppIcon */.yB, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, {
                                                        fontSize: ui.theme.typography.fontSize.sm.x3,
                                                        color: ui.theme.colors.neutral[750],
                                                        children: "Desejo acompanhar meus pedidos e receber notifica\xe7\xf5es via Whatsapp"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* FormFooterWrapper */.Qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* CreateAccountButtonContainer */.ef, {
                                    children: (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isTwoFactorAuthenticationAvailable) === "true" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TwoFactorContainer */.kV, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(_2fa.TwoFactorContent, {
                                                options: null,
                                                sendCodeType: "email",
                                                clientAction: "createUser",
                                                email: emailWatcher,
                                                preventDefault: true,
                                                phoneNumber: null,
                                                viewType: isClientMobile ? "component" : "modal",
                                                canChooseAnotherTwoFactorMethod: false,
                                                hasError: isCodeSent === false,
                                                isUnderAction: formUnderAction,
                                                onClickFailureButton: function() {
                                                    router.push("/");
                                                },
                                                onCallAction: handleSignUp,
                                                onClickIsInvalidClientInfo: function(clientAction, sendCodeType) {
                                                    handleCleanInputData(clientAction, sendCodeType, emailRef, phoneNumberRef, setValue, setFocus);
                                                }
                                            }),
                                            showTwoFactorButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorButton, {
                                                title: "Continuar",
                                                isDisabled: !!isDisabled,
                                                handleOnClick: handleContinueRegister
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SignUpFormButton */.EH, {
                                        form: "sign-up-form",
                                        "data-cy": "button-create-account",
                                        text: "Criar conta",
                                        textUnderAction: "Criando conta...",
                                        underAction: formUnderAction,
                                        buttonType: "submit",
                                        onClickAction: function() {
                                            setFormSubmitted(true);
                                            handleSubmit(handleSignUpWithoutTwoFA);
                                        },
                                        isDisabled: !!isDisabled,
                                        fontWeight: ui.theme.typography.fontWeight[400],
                                        color: "".concat(ui.theme.colors.secondary[380]),
                                        hoveredColor: "".concat(ui.theme.colors.secondary[350])
                                    })
                                })
                            })
                        ]
                    }))
                })
            })
        ]
    });
};
/* harmony default export */ var Body = (FormBody);

// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
;// CONCATENATED MODULE: ../../packages/components/Register/Form/Footer/useFormFooter.tsx


var useFormFooter = function() {
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var isValidationActive = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            isValidationActive: state.isValidationActive
        };
    })).isValidationActive;
    var hideFooter = isValidationActive && isClientMobile;
    return {
        isClientMobile: isClientMobile,
        hideFooter: hideFooter
    };
};


;// CONCATENATED MODULE: ../../packages/components/Register/Form/Footer/index.tsx





var FormFooter = /*#__PURE__*/ (0,react.memo)(function() {
    var ref = useFormFooter(), isClientMobile = ref.isClientMobile, hideFooter = ref.hideFooter;
    if (hideFooter) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.FlexContainer, {
        display: "inline-flex",
        alignItems: "center",
        gap: ui.theme.space.x1,
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, {
                margin: "".concat(ui.theme.space.x0),
                fontSize: ui.theme.typography.fontSize.sm.x5,
                color: ui.theme.colors.neutral[550],
                fontWeight: ui.theme.typography.fontWeight[400],
                children: "J\xe1 tem uma conta?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, {
                margin: "".concat(ui.theme.space.x0),
                fontSize: ui.theme.typography.fontSize.sm.x5,
                fontWeight: ui.theme.typography.fontWeight[500],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                    href: isClientMobile ? "/login" : "/",
                    target: "_self",
                    fontSize: ui.theme.typography.fontSize.sm.x5,
                    color: ui.theme.colors.neutral[550],
                    "data-cy": "link-sign-in",
                    textDecoration: "underline !important",
                    children: "Entrar"
                })
            })
        ]
    });
});
FormFooter.displayName = "FormFooter";
/* harmony default export */ var Footer = (FormFooter);

;// CONCATENATED MODULE: ../../packages/components/Register/Form/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  box-shadow: 0px 2px 4px 0px ",
        ";\n  border-radius: ",
        ';\n  font-size: 1.25rem;\n\n  input:not([type="checkbox"]):not([type="radio"]) {\n    font-size: 1.25rem;\n    padding: 1.2rem 0.9rem;\n  }\n\n  @media ',
        " {\n    width: 55.5rem;\n  }\n\n  @media ",
        " {\n    box-shadow: none;\n    border-radius: none;\n    background-color: transparent;\n    width: 100%;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var FormContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__FormContainer",
    componentId: "sc-ed6a5d2a-0"
})(styles_templateObject());
var FormBox = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__FormBox",
    componentId: "sc-ed6a5d2a-1"
})(styles_templateObject1(), ui.theme.colors.neutral.white, ui.theme.colors.neutral["999-opacity-10"], ui.theme.space.x4, ui.theme.device.desktopFirst.tabletXL, ui.theme.device.desktopFirst.tabletM);

;// CONCATENATED MODULE: ../../packages/components/Register/Form/index.tsx







var Form_Form = function() {
    var ref = (0,application/* useAppContext */.bp4)(), isClientTabletM = ref.isClientTabletM, isClientMobile = ref.isClientMobile;
    var basePadding = "".concat(ui.theme.space.x6);
    var tabletMPadding = "".concat(ui.theme.space.x4, " ").concat(ui.theme.space["x13.5"]);
    var paddingMobile = function() {
        return isClientMobile && basePadding;
    };
    var paddingTabletM = function() {
        return isClientTabletM ? tabletMPadding : basePadding;
    };
    var padding = paddingMobile() || paddingTabletM();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContainer, {
        "data-cy": "form-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBox, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.SpaceWrapper, {
                padding: padding,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                        profileApi: implementations/* profileApi */.c_
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                ]
            })
        })
    });
};
/* harmony default export */ var Register_Form = (Form_Form);

;// CONCATENATED MODULE: ../../packages/components/Register/styles.ts

function Register_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  min-height: 100vh;\n  overflow-x: hidden;\n"
    ]);
    Register_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Register_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n\n  @media ",
        " {\n    padding: ",
        " ",
        ";\n  }\n"
    ]);
    Register_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var RegisterContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__RegisterContainer",
    componentId: "sc-176b1fb0-0"
})(Register_styles_templateObject(), ui.theme.colors.neutral["white-050"]);
var RegisterSpaceWrapper = (0,styled_components_browser_esm/* default */.ZP)(ui.SpaceWrapper).withConfig({
    displayName: "styles__RegisterSpaceWrapper",
    componentId: "sc-176b1fb0-1"
})(Register_styles_templateObject1(), ui.theme.space.x4, ui.theme.space.x6, ui.theme.device.desktopFirst.laptopL, ui.theme.space.x0, ui.theme.space.x0);

;// CONCATENATED MODULE: ../../packages/components/Register/index.tsx







var Register = function() {
    var allConfigs = (0,state_manager/* useEnvs */.HS)().allConfigs;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var isValidationActive = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            isValidationActive: state.isValidationActive
        };
    })).isValidationActive;
    var getHeaderSteps = function(isOnValidation) {
        if (!isOnValidation) {
            return [
                {
                    name: "Cadastro",
                    statusColor: ui.theme.colors.secondary[250]
                },
                {
                    name: "Verifica\xe7\xe3o",
                    statusColor: ui.theme.colors.neutral[150]
                }, 
            ];
        }
        return [
            {
                name: "Cadastro",
                statusColor: ui.theme.colors.secondary[37]
            },
            {
                name: "Verifica\xe7\xe3o",
                statusColor: ui.theme.colors.secondary[250]
            }, 
        ];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegisterContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                hasStepper: (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isTwoFactorAuthenticationAvailable) === "true" && isClientMobile,
                marginBottom: isClientMobile ? ui.theme.space.x0 : ui.theme.space.x6,
                icon: isValidationActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ShieldUserProtection, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SingleUserIcon, {}),
                steps: getHeaderSteps(isValidationActive),
                stepTitle: isValidationActive ? "Verifica\xe7\xe3o em duas etapas" : "Informa\xe7\xf5es de cadastro"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterSpaceWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Register_Form, {})
            })
        ]
    });
};



/***/ }),

/***/ 4181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ RegisterPhoneNumber; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../packages/typing/index.tsx + 7 modules
var typing = __webpack_require__(96915);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
;// CONCATENATED MODULE: ../../packages/components/RegisterPhoneNumber/RegisterNewPhoneNumber/data.tsx











var useRegisterPhoneNumberData = function() {
    var ref;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var ref1 = (0,state_manager/* useRegisterPhoneNumber */.KH)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            changeCurrentStep: state.changeCurrentStep,
            setPhoneNumber: state.setPhoneNumber,
            isRegisterPhoneNumberModalOpen: state.isRegisterPhoneNumberModalOpen,
            phoneNumber: state.phoneNumber
        };
    })), changeCurrentStep = ref1.changeCurrentStep, setPhoneNumber = ref1.setPhoneNumber, phoneNumber = ref1.phoneNumber, isRegisterPhoneNumberModalOpen = ref1.isRegisterPhoneNumberModalOpen;
    var ref2 = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setIsValidationActive: state.setIsValidationActive,
            setChannelSelected: state.setChannelSelected,
            setFaType: state.setFaType,
            setIsBlockedToSendCode: state.setIsBlockedToSendCode
        };
    })), setIsValidationActive = ref2.setIsValidationActive, setChannelSelected = ref2.setChannelSelected, setFaType = ref2.setFaType, setIsBlockedToSendCode = ref2.setIsBlockedToSendCode;
    var router = (0,next_router.useRouter)();
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var onPrimaryButtonClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            implementations/* notificationApi.sendTokenForSMS */.E8.sendTokenForSMS(typing/* FATypeValues.AccountUpdatePhone2FA */.ZI.AccountUpdatePhone2FA, phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/\D/g, ""))
                        ];
                    case 1:
                        response = _state.sent();
                        if ((response === null || response === void 0 ? void 0 : (ref = response.validationResult) === null || ref === void 0 ? void 0 : ref.isValid) || (response === null || response === void 0 ? void 0 : (ref1 = response.validationResult) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.errors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.errorCode) === "666") {
                            setIsBlockedToSendCode(false);
                            changeCurrentStep("validation");
                            setIsValidationActive(true);
                            setChannelSelected(1);
                            setFaType(typing/* FATypeValues.AccountUpdatePhone2FA */.ZI.AccountUpdatePhone2FA);
                            return [
                                2
                            ];
                        }
                        if ((response === null || response === void 0 ? void 0 : (ref4 = response.validationResult) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.errors) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.errorCode) === "222") {
                            setIsBlockedToSendCode(true);
                            setIsValidationActive(true);
                            changeCurrentStep("validation");
                            return [
                                2
                            ];
                        }
                        addToast({
                            title: "Telefone inv\xe1lido",
                            description: response === null || response === void 0 ? void 0 : (ref7 = response.validationResult) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.errors) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.errorMessage,
                            isNewToast: true,
                            type: "error",
                            newToastTheme: "dark"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function onPrimaryButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var focusOnInput = (0,react.useCallback)(function() {
        var input = document.querySelector("#register-phone");
        if (input) {
            input.focus();
            input.setSelectionRange(0, 0);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (isRegisterPhoneNumberModalOpen) {
            focusOnInput();
        }
    }, [
        focusOnInput,
        isRegisterPhoneNumberModalOpen
    ]);
    var register = (0,index_esm/* useForm */.cI)().register;
    var isCheckout = router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.includes("pagamento");
    var handleInputChange = function(e) {
        var input = e.target.value.replace(/\D/g, "");
        setPhoneNumber(input);
    };
    var getRegisterPhoneNumberData = function() {
        var ref;
        return {
            hasInput: true,
            id: "register-phone",
            margin: "".concat(ui.theme.space.x4, " 0"),
            type: "tel",
            name: "register-phone",
            onChange: handleInputChange,
            value: phoneNumber,
            primaryButtonIsDisabled: ((ref = String(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/\D/g, ""))) === null || ref === void 0 ? void 0 : ref.length) < 11,
            onPrimaryButtonClick: onPrimaryButtonClick,
            register: register,
            mask: "(99) 99999-9999",
            width: "489px !important",
            borderRadius: "4px",
            title: isCheckout ? "Para finalizar a compra, \xe9 preciso cadastrar e validar seu telefone" : "Sua conta ainda n\xe3o possui um telefone cadastrado",
            description: isCheckout ? "Digite seu telefone" : "Cadastre e valide seu telefone para ter uma conta mais segura.",
            primaryButtonLabel: !isClientMobile ? "Continuar" : undefined,
            image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.TelephoneAuthenticationIcon, {}),
            onSecondaryButtonClick: function() {
                return changeCurrentStep("validation");
            }
        };
    };
    return {
        getRegisterPhoneNumberData: getRegisterPhoneNumberData,
        onPrimaryButtonClick: onPrimaryButtonClick
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../packages/components/ResponsiveModal/components/index.ts + 5 modules
var components = __webpack_require__(76861);
;// CONCATENATED MODULE: ../../packages/components/RegisterPhoneNumber/RegisterNewPhoneNumber/ui.tsx




var RegisterNewPhoneNumberUI = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ResponsiveModalContent */.N, (0,_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../packages/components/RegisterPhoneNumber/RegisterNewPhoneNumber/index.tsx




var RegisterNewPhoneNumber = function() {
    var getRegisterPhoneNumberData = useRegisterPhoneNumberData().getRegisterPhoneNumberData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterNewPhoneNumberUI, (0,_object_spread/* default */.Z)({}, getRegisterPhoneNumberData()));
};


;// CONCATENATED MODULE: ../../packages/components/RegisterPhoneNumber/PhoneValidationComponent/data.tsx










var usePhoneValidationComponentData = function() {
    var ref;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var loggedClient = (0,application/* useUser */.aFb)().loggedClient;
    var ref2 = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            isRequesting: state.isRequesting,
            setIsTokenCodeValid: state.setIsTokenCodeValid,
            setIsValidatingCode: state.setIsValidatingCode,
            setValidateCode: state.setValidateCode,
            setIsValidationActive: state.setIsValidationActive,
            channelSelected: state.channelSelected,
            faType: state.faType,
            isBlockedToSendCode: state.isBlockedToSendCode,
            tokenCode: state.tokenCode
        };
    })), isRequesting = ref2.isRequesting, setIsTokenCodeValid = ref2.setIsTokenCodeValid, setIsValidatingCode = ref2.setIsValidatingCode, setIsValidationActive = ref2.setIsValidationActive, setValidateCode = ref2.setValidateCode, channelSelected = ref2.channelSelected, faType = ref2.faType, isBlockedToSendCode = ref2.isBlockedToSendCode, tokenCode = ref2.tokenCode;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,state_manager/* useRegisterPhoneNumber */.KH)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setIsRegisterPhoneNumberModalOpen: state.setIsRegisterPhoneNumberModalOpen,
            changeCurrentStep: state.changeCurrentStep,
            phoneNumber: state.phoneNumber,
            setOpenCheckoutModal: state.setOpenCheckoutModal
        };
    })), setIsRegisterPhoneNumberModalOpen = ref3.setIsRegisterPhoneNumberModalOpen, changeCurrentStep = ref3.changeCurrentStep, phoneNumber = ref3.phoneNumber, setOpenCheckoutModal = ref3.setOpenCheckoutModal;
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var clearTime = (0,react.useCallback)(function() {
        localStorage.removeItem("timeSent_".concat(faType, "_").concat(channelSelected));
        localStorage.removeItem("countdownTime_".concat(faType, "_").concat(channelSelected));
        localStorage.removeItem("countdownTimeTimestamp_".concat(faType, "_").concat(channelSelected));
    }, [
        faType,
        channelSelected
    ]);
    var handleEditPhone = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var userFAType, token, email, userPhoneNumber, cpf, channel, newEmail, newPhoneNumber, ref, handleEditPhoneCall;
            return (0,tslib_es6.__generator)(this, function(_state) {
                userFAType = param.faType, token = param.token, email = param.email, userPhoneNumber = param.phoneNumber, cpf = param.cpf, channel = param.channel, newEmail = param.newEmail, newPhoneNumber = param.newPhoneNumber;
                setIsValidatingCode(true);
                handleEditPhoneCall = function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(location, hasLocation) {
                        var data, editResponse, ref, ref1;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        implementations/* profileApi.editData */.c_.editData({
                                            faType: userFAType,
                                            token: token,
                                            email: email,
                                            phoneNumber: userPhoneNumber,
                                            cpf: cpf,
                                            channel: channel,
                                            newEmail: newEmail !== null && newEmail !== void 0 ? newEmail : "",
                                            newPhoneNumber: newPhoneNumber !== null && newPhoneNumber !== void 0 ? newPhoneNumber : "",
                                            location: hasLocation ? location : ""
                                        }, accessToken)
                                    ];
                                case 1:
                                    data = _state.sent().data;
                                    editResponse = data;
                                    if (editResponse === null || editResponse === void 0 ? void 0 : editResponse.id) {
                                        ;
                                        clearTime();
                                        addToast({
                                            isNewToast: true,
                                            newToastTheme: "light",
                                            type: "success",
                                            title: "Telefone validado com sucesso",
                                            description: "Parab\xe9ns! Seu telefone foi cadastrado.",
                                            timerInMilliseconds: 3000
                                        });
                                        setIsTokenCodeValid(true);
                                        setIsRegisterPhoneNumberModalOpen(false);
                                        setIsValidationActive(false);
                                        changeCurrentStep("modalCall");
                                        if (router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.includes("pagamento")) {
                                            setOpenCheckoutModal(true);
                                        }
                                        return [
                                            2
                                        ];
                                    }
                                    addToast({
                                        isNewToast: true,
                                        newToastTheme: "light",
                                        type: "error",
                                        title: "Erro ao cadastrar seu telefone",
                                        description: (data === null || data === void 0 ? void 0 : data.detail) !== "" && (data === null || data === void 0 ? void 0 : data.detail) ? data === null || data === void 0 ? void 0 : data.detail : (ref1 = data === null || data === void 0 ? void 0 : data.title) !== null && ref1 !== void 0 ? ref1 : "Ocorreu um erro ao validar o c\xf3digo de verifica\xe7\xe3o.",
                                        timerInMilliseconds: 3000
                                    });
                                    setIsTokenCodeValid(false);
                                    setValidateCode(true);
                                    setIsValidatingCode(false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function handleEditPhoneCall(location, hasLocation) {
                        return _ref.apply(this, arguments);
                    };
                }();
                navigator === null || navigator === void 0 ? void 0 : (ref = navigator.geolocation) === null || ref === void 0 ? void 0 : ref.getCurrentPosition(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(position) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            handleEditPhoneCall("Latitude: ".concat(position.coords.latitude, ", Longitude: ").concat(position.coords.longitude), true);
                            return [
                                2
                            ];
                        });
                    });
                    return function(position) {
                        return _ref.apply(this, arguments);
                    };
                }(), /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        handleEditPhoneCall("", false);
                        return [
                            2
                        ];
                    });
                }));
                return [
                    2
                ];
            });
        });
        return function handleEditPhone(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var getPhoneValidationComponentData = function() {
        var contentMap = new Map();
        contentMap.set("shouldMask", false);
        contentMap.set("clientAction", "registerPhoneNumber");
        contentMap.set("email", String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email));
        contentMap.set("isUnderAction", isRequesting);
        contentMap.set("onCallAction", function() {
            return handleEditPhone({
                channel: 1,
                faType: typing/* FATypeValues.AccountUpdatePhone2FA */.ZI.AccountUpdatePhone2FA,
                cpf: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf),
                email: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email),
                phoneNumber: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber),
                token: String(tokenCode),
                newPhoneNumber: phoneNumber,
                newEmail: ""
            });
        });
        contentMap.set("phoneNumber", (0,application/* formatPhoneNumber */.unW)(phoneNumber));
        contentMap.set("sendCodeType", "sms");
        contentMap.set("hasHeader", false);
        contentMap.set("viewType", "component");
        contentMap.set("hasDescriptionOnMobile", true);
        contentMap.set("preventDefault", true);
        contentMap.set("canChooseAnotherTwoFactorMethod", false);
        contentMap.set("isMobile", isClientMobile);
        contentMap.set("successTitle", "Verifique seu novo n\xfamero de telefone");
        contentMap.set("options", null);
        contentMap.set("onClickFailureButton", function() {
            setIsRegisterPhoneNumberModalOpen(false);
            setIsValidationActive(false);
        });
        contentMap.set("titleFailure", "Erro na valida\xe7\xe3o do telefone");
        contentMap.set("errorButtonText", "Fechar");
        contentMap.set("handleSelectAnotherTwoFactorType", undefined);
        contentMap.set("failureIllustration", /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.TelephoneErrorIcon, {}));
        contentMap.set("hasError", isBlockedToSendCode);
        return contentMap;
    };
    return {
        getPhoneValidationComponentData: getPhoneValidationComponentData,
        isLoading: isLoading,
        setIsLoading: setIsLoading
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/RegisterPhoneNumber/PhoneValidationComponent/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TwoFactorContentContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__TwoFactorContentContainer",
    componentId: "sc-2ea8cef9-0"
})(_templateObject(), ui.theme.space.x4);

// EXTERNAL MODULE: ../../packages/components/2fa/index.ts + 18 modules
var _2fa = __webpack_require__(83650);
// EXTERNAL MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/components/index.tsx + 9 modules
var ResponsiveModalContent_components = __webpack_require__(70255);
;// CONCATENATED MODULE: ../../packages/components/RegisterPhoneNumber/PhoneValidationComponent/ui.tsx







var PhoneValidationComponentUI = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TwoFactorContentContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModalContent_components/* ResponsiveModalImage */.NC, {
                margin: "".concat(ui.theme.space.x4, " 0"),
                image: (props === null || props === void 0 ? void 0 : props.hasError) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.TelephoneErrorIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.TelephoneAuthenticationIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_2fa.TwoFactorContent, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/components/RegisterPhoneNumber/PhoneValidationComponent/index.tsx




var PhoneValidationComponent = function() {
    var getPhoneValidationComponentData = usePhoneValidationComponentData().getPhoneValidationComponentData;
    var phoneValidationComponentData = Object.fromEntries(getPhoneValidationComponentData());
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneValidationComponentUI, (0,_object_spread/* default */.Z)({}, phoneValidationComponentData));
};


;// CONCATENATED MODULE: ../../packages/components/RegisterPhoneNumber/RegisterPhoneNumberModal/data.tsx






var useRegisterPhoneNumberModal = function() {
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var ref = (0,state_manager/* useRegisterPhoneNumber */.KH)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            isRegisterPhoneNumberModalOpen: state.isRegisterPhoneNumberModalOpen,
            setIsRegisterPhoneNumberModalOpen: state.setIsRegisterPhoneNumberModalOpen,
            steps: state.steps,
            currentStep: state.currentStep,
            phoneNumber: state.phoneNumber
        };
    })), isRegisterPhoneNumberModalOpen = ref.isRegisterPhoneNumberModalOpen, setIsRegisterPhoneNumberModalOpen = ref.setIsRegisterPhoneNumberModalOpen, steps = ref.steps, currentStep = ref.currentStep, phoneNumber = ref.phoneNumber;
    var handleCloseModal = function() {
        setIsRegisterPhoneNumberModalOpen(false);
    };
    var onPrimaryButtonClick = useRegisterPhoneNumberData().onPrimaryButtonClick;
    var getRegisterPhoneNumberModal = function() {
        var ref;
        return {
            isMobile: isClientMobile,
            currentStep: currentStep,
            isOpen: isRegisterPhoneNumberModalOpen,
            onClose: handleCloseModal,
            goNext: onPrimaryButtonClick,
            steps: steps,
            isNextButtonDisabled: ((ref = String(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/\D/g, ""))) === null || ref === void 0 ? void 0 : ref.length) < 11,
            width: "489px",
            statusHeight: "5px",
            title: currentStep === "modalCall" ? "Cadastrar telefone" : "Validar n\xfamero de telefone",
            headerFlexDirection: "column-reverse",
            hasBorderBottom: true,
            children: currentStep === "modalCall" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterNewPhoneNumber, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneValidationComponent, {})
        };
    };
    return {
        getRegisterPhoneNumberModal: getRegisterPhoneNumberModal
    };
};


// EXTERNAL MODULE: ../../packages/components/BottomSheet/index.tsx
var BottomSheet = __webpack_require__(33082);
// EXTERNAL MODULE: ../../packages/components/StepperModal/index.tsx + 1 modules
var StepperModal = __webpack_require__(96187);
// EXTERNAL MODULE: ../../packages/components/StatusProgress/index.tsx + 1 modules
var StatusProgress = __webpack_require__(70020);
;// CONCATENATED MODULE: ../../packages/components/RegisterPhoneNumber/RegisterPhoneNumberModal/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StepperContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__StepperContainer",
    componentId: "sc-d0057926-0"
})(styles_templateObject(), ui.theme.space.x4);

;// CONCATENATED MODULE: ../../packages/components/RegisterPhoneNumber/RegisterPhoneNumberModal/ui.tsx








var RegisterPhoneNumberModalUI = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    if (props.isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomSheet/* BottomSheet */.R, {
            omitHeader: false,
            title: props.title,
            onCloseBottomSheet: props.onClose,
            stateBottomSheet: props.isOpen,
            justifyContent: "space-between",
            onClickFooterButton: props.goNext,
            containerHeight: "540px",
            heightContent: "max-content",
            display: "flex",
            buttonFontSize: ui.theme.typography.fontSize.sm.x5,
            buttonFontWeight: ui.theme.typography.fontWeight[500],
            textButton: "Salvar",
            onActionTextButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {}),
            headerAction: props.onClose,
            hasActionInHeader: true,
            size: "small",
            noFooter: props.currentStep !== "modalCall",
            buttonBorderRadius: ui.theme.space.x1,
            isButtonDisabled: props.isNextButtonDisabled,
            onDismiss: props.onClose,
            padding: "".concat(ui.theme.space.x4, " ").concat(ui.theme.space.x0),
            paddingContent: "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x4),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusProgress/* StatusProgress */.M, {
                        height: props.statusHeight,
                        statusStep: props.steps,
                        hasIcon: false
                    })
                }),
                props.children
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperModal/* StepperModal */.a, (0,_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../packages/components/RegisterPhoneNumber/RegisterPhoneNumberModal/index.tsx




var RegisterPhoneNumberModal = function() {
    var getRegisterPhoneNumberModal = useRegisterPhoneNumberModal().getRegisterPhoneNumberModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterPhoneNumberModalUI, (0,_object_spread/* default */.Z)({}, getRegisterPhoneNumberModal()));
};


;// CONCATENATED MODULE: ../../packages/components/RegisterPhoneNumber/index.tsx


var RegisterPhoneNumber = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterPhoneNumberModal, {});
};



/***/ }),

/***/ 56043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ RequestFeedbackModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/RequestFeedbackModal/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  inset: 0;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: ",
        ";\n  border-radius: ",
        ";\n  min-height: 480px;\n  max-width: 694px;\n  width: 100%;\n  gap: ",
        ";\n  background-color: ",
        ";\n  box-shadow: 0px 2px 8px 0px ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var RequestFeedbackOverlay = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__RequestFeedbackOverlay",
    componentId: "sc-1284270a-0"
})(_templateObject(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "flex" : "none";
}, ui.theme.colors.neutral["999-opacity-50"]);
var RequestFeedbackModalContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__RequestFeedbackModalContainer",
    componentId: "sc-1284270a-1"
})(_templateObject1(), ui.theme.space.x4, ui.theme.space.x2, ui.theme.space.x6, ui.theme.colors.neutral.white, ui.theme.colors.neutral["900-opacity-32"]);
var RequestFeedbackModalHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__RequestFeedbackModalHeader",
    componentId: "sc-1284270a-2"
})(_templateObject2());
var CloseRequestModalFeedback = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CloseRequestModalFeedback",
    componentId: "sc-1284270a-3"
})(_templateObject3());
var RequestSentIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RequestSentIcon",
    componentId: "sc-1284270a-4"
})(_templateObject4(), ui.theme.space.x10);
var RequestContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RequestContent",
    componentId: "sc-1284270a-5"
})(_templateObject5(), ui.theme.space.x4);
var RequestSentTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__RequestSentTitle",
    componentId: "sc-1284270a-6"
})(_templateObject6(), ui.theme.colors.neutral[550], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.md.x1, ui.theme.typography.fontWeight.bold);
var RequestSentDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__RequestSentDescription",
    componentId: "sc-1284270a-7"
})(_templateObject7(), ui.theme.colors.neutral[585], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x7, ui.theme.typography.fontWeight[400]);
var GoToInitialPageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__GoToInitialPageContainer",
    componentId: "sc-1284270a-8"
})(_templateObject8(), ui.theme.space.x4);
var GoToInitialPageText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__GoToInitialPageText",
    componentId: "sc-1284270a-9"
})(_templateObject9(), ui.theme.colors.secondary[380], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[400]);

;// CONCATENATED MODULE: ../../packages/components/RequestFeedbackModal/index.tsx






var RequestFeedbackModal = function(param) {
    var isOpen = param.isOpen, onCloseModal = param.onCloseModal, title = param.title, description = param.description, icon = param.icon, onNavigateToInitialPage = param.onNavigateToInitialPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestFeedbackOverlay, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("request-feedback-modal-overlay")), {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RequestFeedbackModalContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("request-feedback-modal-container")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestFeedbackModalHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("request-feedback-modal-header")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseRequestModalFeedback, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("close-request-modal-feedback")), {
                        onClick: onCloseModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {
                            color: ui.theme.colors.neutral[999]
                        })
                    }))
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestSentIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("request-feedback-modal-icon")), {
                    children: icon
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RequestContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("request-feedback-modal-content")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestSentTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("request-feedback-modal-title")), {
                            children: title
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestSentDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("request-feedback-modal-description")), {
                            children: description
                        }))
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GoToInitialPageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("request-feedback-modal-go-to-initial-page")), {
                    onClick: onNavigateToInitialPage,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.House, {
                            width: 24,
                            height: 24,
                            color: "".concat(ui.theme.colors.secondary[380])
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GoToInitialPageText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("request-feedback-modal-go-to-initial-page-text")), {
                            children: "Ir para p\xe1gina inicial"
                        }))
                    ]
                }))
            ]
        }))
    }));
};



/***/ }),

/***/ 70255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oM": function() { return /* reexport */ ResponsiveModalButtons; },
  "NC": function() { return /* reexport */ ResponsiveModalImage; },
  "Ok": function() { return /* reexport */ ResponsiveModalInformation; },
  "RJ": function() { return /* reexport */ ResponsiveModalInput_ResponsiveModalInput; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/components/ResponsiveModalImage/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: ",
        ";\n\n  @media ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ResponsiveModalContentImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ResponsiveModalContentImage",
    componentId: "sc-bec2d19-0"
})(_templateObject(), function(param) {
    var margin = param.margin;
    return margin !== null && margin !== void 0 ? margin : "0 0 ".concat(ui.theme.space.x6);
}, ui.theme.device.desktopFirst.mobileXL, function(param) {
    var margin = param.margin;
    return margin !== null && margin !== void 0 ? margin : "".concat(ui.theme.space.x4, " 0 0");
});

;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/components/ResponsiveModalImage/index.tsx





var ResponsiveModalImage = function(param) {
    var image = param.image, margin = param.margin;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModalContentImage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        margin: margin
    }, (0,application/* buildTestIds */.Fek)("responsive-modal-content-image")), {
        children: image
    }));
};


;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/components/ResponsiveModalButtons/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  height: 45px;\n  transition: background-color 0.3s ease-in-out;\n  font-size: ",
        ";\n\n  :hover {\n    background-color: ",
        ";\n  }\n\n  :disabled {\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: ",
        ";\n  height: 45px;\n  color: ",
        ";\n  font-size: ",
        ";\n\n  :hover {\n    background-color: ",
        ";\n  }\n\n  :disabled {\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ResponsiveModalContentButtons = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ResponsiveModalContentButtons",
    componentId: "sc-c0ea3868-0"
})(styles_templateObject(), ui.theme.space.x4);
var ResponsiveModalPrimaryButton = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__ResponsiveModalPrimaryButton",
    componentId: "sc-c0ea3868-1"
})(_templateObject1(), ui.theme.colors.secondary[380], ui.theme.space.x1, ui.theme.colors.neutral.white, ui.theme.typography.fontSize.sm.x5, ui.theme.colors.secondary[350]);
var ResponsiveModalSecondaryButton = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__ResponsiveModalSecondaryButton",
    componentId: "sc-c0ea3868-2"
})(_templateObject2(), ui.theme.colors.neutral.white, ui.theme.colors.neutral[550], ui.theme.typography.fontSize.sm.x3, ui.theme.colors.neutral.white);

;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/components/ResponsiveModalButtons/index.tsx





var ResponsiveModalButtons = function(param) {
    var onPrimaryButtonClick = param.onPrimaryButtonClick, onSecondaryButtonClick = param.onSecondaryButtonClick, primaryButtonLabel = param.primaryButtonLabel, primaryButtonIsDisabled = param.primaryButtonIsDisabled, secondaryButtonLabel = param.secondaryButtonLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveModalContentButtons, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("responsive-modal-content-buttons")), {
        children: [
            onPrimaryButtonClick && primaryButtonLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModalPrimaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("responsive-modal-primary-button")), {
                onClick: function(e) {
                    e.preventDefault();
                    onPrimaryButtonClick();
                },
                disabled: primaryButtonIsDisabled,
                children: primaryButtonLabel
            })) : null,
            onSecondaryButtonClick && secondaryButtonLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModalSecondaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("responsive-modal-secondary-button")), {
                onClick: onSecondaryButtonClick,
                children: secondaryButtonLabel
            })) : null
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/components/ResponsiveModalInformation/styles.ts

function ResponsiveModalInformation_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n"
    ]);
    ResponsiveModalInformation_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ResponsiveModalContentInformation = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ResponsiveModalContentInformation",
    componentId: "sc-16e4aeb9-0"
})(ResponsiveModalInformation_styles_templateObject(), ui.theme.space.x2);
var ResponsiveModalContentTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__ResponsiveModalContentTitle",
    componentId: "sc-16e4aeb9-1"
})(styles_templateObject1(), ui.theme.typography.fontSize.sm.x7, ui.theme.colors.neutral[550], ui.theme.typography.fontWeight[700], ui.theme.typography.fontFamily.chivo, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x5);
var ResponsiveModalContentDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__ResponsiveModalContentDescription",
    componentId: "sc-16e4aeb9-2"
})(styles_templateObject2(), ui.theme.typography.fontSize.sm.x5, ui.theme.colors.neutral[110], ui.theme.typography.fontWeight[400], ui.theme.typography.fontFamily.chivo);

;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/components/ResponsiveModalInformation/index.tsx





var ResponsiveModalInformation = function(param) {
    var description = param.description, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveModalContentInformation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("responsive-modal-content-information")), {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModalContentTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("responsive-modal-content-title")), {
                children: title
            })),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModalContentDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("responsive-modal-content-description")), {
                children: description
            }))
        ]
    }));
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../packages/components/Form/Input/index.tsx + 1 modules
var Input = __webpack_require__(59556);
;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/components/ResponsiveModalInput/styles.tsx

function ResponsiveModalInput_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ResponsiveModalInput_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ResponsiveModalInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    displayName: "styles__ResponsiveModalInput",
    componentId: "sc-c9987ff-0"
})(ResponsiveModalInput_styles_templateObject());

;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/components/ResponsiveModalInput/ui.tsx



var ResponsiveModalInputUI = function(param) {
    var disabled = param.disabled, hasError = param.hasError, mask = param.mask, id = param.id, name = param.name, registerInput = param.register, padding = param.padding, placeholder = param.placeholder, onChange = param.onChange, type = param.type, borderRadius = param.borderRadius;
    var register = (0,index_esm/* useForm */.cI)().register;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModalInput, {
        disabled: disabled,
        hasError: hasError,
        id: id,
        name: name,
        height: "40px",
        width: "100%",
        borderRadius: borderRadius,
        margin: "16px 0px",
        padding: padding,
        placeholder: placeholder,
        register: registerInput || register,
        type: type,
        onChange: onChange,
        mask: mask
    });
};


;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/components/ResponsiveModalInput/index.tsx




var ResponsiveModalInput_ResponsiveModalInput = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModalInputUI, (0,_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/components/index.tsx






/***/ }),

/***/ 76861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ ResponsiveComponent; },
  "N": function() { return /* reexport */ ResponsiveModalContent; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ResponsiveModalContentContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ResponsiveModalContentContainer",
    componentId: "sc-dd14dcbe-0"
})(_templateObject());

// EXTERNAL MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/components/index.tsx + 9 modules
var components = __webpack_require__(70255);
;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/ui.tsx







var ResponsiveModalContentUI = function(_param) {
    var description = _param.description, image = _param.image, onPrimaryButtonClick = _param.onPrimaryButtonClick, onSecondaryButtonClick = _param.onSecondaryButtonClick, primaryButtonLabel = _param.primaryButtonLabel, secondaryButtonLabel = _param.secondaryButtonLabel, title = _param.title, primaryButtonIsDisabled = _param.primaryButtonIsDisabled, hasInput = _param.hasInput, margin = _param.margin, props = (0,_object_without_properties/* default */.Z)(_param, [
        "description",
        "image",
        "onPrimaryButtonClick",
        "onSecondaryButtonClick",
        "primaryButtonLabel",
        "secondaryButtonLabel",
        "title",
        "primaryButtonIsDisabled",
        "hasInput",
        "margin"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveModalContentContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("responsive-modal-content-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ResponsiveModalImage */.NC, {
                margin: margin,
                image: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ResponsiveModalInformation */.Ok, {
                description: description,
                title: title
            }),
            hasInput ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ResponsiveModalInput */.RJ, (0,_object_spread/* default */.Z)({}, props, (0,application/* buildTestIds */.Fek)("responsive-modal-input"))) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ResponsiveModalButtons */.oM, {
                onPrimaryButtonClick: onPrimaryButtonClick,
                onSecondaryButtonClick: onSecondaryButtonClick,
                primaryButtonLabel: primaryButtonLabel,
                secondaryButtonLabel: secondaryButtonLabel,
                primaryButtonIsDisabled: primaryButtonIsDisabled
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveModalContent/index.tsx




var ResponsiveModalContent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModalContentUI, (0,_object_spread/* default */.Z)({}, props));
};


// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/BottomSheet/index.tsx
var BottomSheet = __webpack_require__(33082);
// EXTERNAL MODULE: ../../packages/components/ModalGeneral/index.tsx + 1 modules
var ModalGeneral = __webpack_require__(89459);
;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveComponent/ui.tsx







var ResponsiveComponentUI = function(_param) {
    var closeModal = _param.closeModal, modalTitle = _param.modalTitle, isModalOpen = _param.isModalOpen, isBottomSheet = _param.isBottomSheet, _hasHeader = _param.hasHeader, hasHeader = _hasHeader === void 0 ? false : _hasHeader, _hideheaderline = _param.hideheaderline, hideheaderline = _hideheaderline === void 0 ? false : _hideheaderline, headerPadding = _param.headerPadding, type = _param.contentType, props = (0,_object_without_properties/* default */.Z)(_param, [
        "closeModal",
        "modalTitle",
        "isModalOpen",
        "isBottomSheet",
        "hasHeader",
        "hideheaderline",
        "headerPadding",
        "contentType"
    ]);
    if (isBottomSheet) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet/* BottomSheet */.R, {
            hideheaderline: hideheaderline,
            omitHeader: !hasHeader,
            headerpadding: headerPadding,
            title: modalTitle,
            onCloseBottomSheet: closeModal,
            stateBottomSheet: isModalOpen,
            noFooter: true,
            justifyContent: "space-between",
            display: "flex",
            onDismiss: closeModal,
            hasCloseButton: true,
            padding: "".concat(ui.theme.space.x4, " ").concat(ui.theme.space.x0),
            paddingContent: "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x4),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModalContent, (0,_object_spread/* default */.Z)({}, props))
        });
    }
    if (type === "component") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModalContent, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGeneral.ModalGeneral, {
        hasHeader: hasHeader,
        contentGap: ui.theme.space.x0,
        isOpen: isModalOpen,
        title: modalTitle,
        onCloseModal: closeModal,
        closeButtonSize: 24,
        fontWeight: ui.theme.typography.fontWeight[400],
        bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModalContent, (0,_object_spread/* default */.Z)({}, props)),
        ariaLabelForModal: modalTitle
    });
};


;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/ResponsiveComponent/index.tsx




var ResponsiveComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveComponentUI, (0,_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../packages/components/ResponsiveModal/components/index.ts




/***/ }),

/***/ 58393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ ResponsiveModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58013);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76861);




var ResponsiveModal = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .ResponsiveComponent */ .Y, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
};



/***/ }),

/***/ 6499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ SendCodeAgain; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/utils/validations/secondsCounter/index.ts
var secondsCounter = __webpack_require__(73105);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/SendCodeAgain/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SendCodeAgainContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__SendCodeAgainContainer",
    componentId: "sc-7044151b-0"
})(_templateObject(), function(param) {
    var fontSize = param.fontSize;
    return fontSize || "".concat(ui.theme.typography.fontSize.sm.x3);
}, function(param) {
    var color = param.color;
    return color || "".concat(ui.theme.colors.primary[150]);
});

;// CONCATENATED MODULE: ../../packages/components/SendCodeAgain/index.tsx








var SendCodeAgain = function(param) {
    var typeSMS = param.typeSMS, color = param.color, fontSize = param.fontSize, onSendCodeAgain = param.onSendCodeAgain;
    var ref;
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var initializeValidationCounter = (0,application/* useNotification */.lmA)().initializeValidationCounter;
    var handleSendCodeAgain = (0,react.useCallback)(function() {
        var onSendSMS = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(type) {
                var ref, ref1, ref2, response, remainingTime;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                implementations/* notificationApi.sendTwoFactorSMS */.E8.sendTwoFactorSMS(type, accessToken)
                            ];
                        case 1:
                            response = _state.sent();
                            if ((response === null || response === void 0 ? void 0 : (ref = response.validationResult) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.errorCode) === "666") {
                                remainingTime = (0,secondsCounter/* getMinutesAndSeconds */.G)(response === null || response === void 0 ? void 0 : response.retryTokenDate);
                                initializeValidationCounter(remainingTime);
                                return [
                                    2
                                ];
                            }
                            initializeValidationCounter();
                            return [
                                2
                            ];
                    }
                });
            });
            return function onSendSMS(type) {
                return _ref.apply(this, arguments);
            };
        }();
        if (onSendCodeAgain) {
            onSendCodeAgain(true);
        }
        onSendSMS(typeSMS);
        addToast({
            title: "C\xf3digo reenviado!",
            type: "success"
        });
    }, [
        onSendCodeAgain,
        typeSMS,
        addToast,
        accessToken
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SendCodeAgainContainer, {
        color: color,
        fontSize: fontSize,
        onClick: handleSendCodeAgain,
        children: "Reenviar c\xf3digo"
    });
};



/***/ }),

/***/ 44860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Skeleton": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var infra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11338);



var Skeleton = function(skeletonProps) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(infra__WEBPACK_IMPORTED_MODULE_1__/* .ReactLoadingSkeleton */ .L9, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, skeletonProps));
};


/***/ }),

/***/ 75926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ SliderWithBlackThemeValidation; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/infra/index.ts + 47 modules
var infra = __webpack_require__(11338);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/Slider/DefaultNextButton/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 10px !important;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          path {\n            stroke: ",
        " !important;\n          }\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            path {\n              stroke: ",
        " !important;\n            }\n          "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: ",
        ";\n\n      svg {\n        ",
        "\n      }\n\n      &:hover {\n        background: ",
        ";\n        transition: 0.8s;\n\n        svg {\n          ",
        "\n        }\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        " !important;\n  width: ",
        " !important;\n  border-radius: 30px;\n\n  top: ",
        " !important;\n\n  padding: 0px 0px 0px 4px !important;\n  margin-right: 22px !important;\n\n  background: ",
        " !important;\n  box-shadow: ",
        ";\n\n  &:hover {\n    background: ",
        " !important;\n    transition: 0.8s !important;\n  }\n\n  &:hover path {\n    stroke: ",
        ";\n  }\n\n  svg {\n    ",
        "\n    margin-top: ",
        " !important;\n    margin-left: ",
        " !important;\n  }\n\n  @media (max-width: 1270px) {\n    margin-right: 25px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var ButtonArrowNext = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ButtonArrowNext",
    componentId: "sc-10fa3925-0"
})(_templateObject4(), function(param) {
    var arrowButtonsSize = param.arrowButtonsSize;
    return arrowButtonsSize === "small" ? "32px" : "60px";
}, function(param) {
    var arrowButtonsSize = param.arrowButtonsSize;
    return arrowButtonsSize === "small" ? "32px" : "60px";
}, function(param) {
    var isCentralized = param.isCentralized;
    return isCentralized ? "50%" : "calc(50% - 25px)";
}, function(param) {
    var customTheme = param.customTheme;
    var ref, ref1;
    return customTheme ? ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["50"] : ui.theme.colors.neutral.white;
}, "".concat(ui.theme.space.x0, " ").concat(ui.theme.space["x0.5"], " ").concat(ui.theme.space["x0.5"], "\n    ").concat(ui.theme.colors.neutral["999-opacity-25"]), ui.theme.colors.primary[200], ui.theme.colors.neutral.white, function(param) {
    var arrowButtonsSize = param.arrowButtonsSize;
    return arrowButtonsSize === "small" && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
}, function(param) {
    var arrowButtonsSize = param.arrowButtonsSize;
    return arrowButtonsSize === "small" ? "3px" : "17px";
}, function(param) {
    var arrowButtonsSize = param.arrowButtonsSize;
    return arrowButtonsSize === "small" ? "7px" : "18px";
}, function(param) {
    var customTheme = param.customTheme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["50"], customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref2 = ui.theme.colors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.blackFriday) === null || ref3 === void 0 ? void 0 : ref3["20"]), ui.theme === null || ui.theme === void 0 ? void 0 : (ref4 = ui.theme.colors) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.primary) === null || ref5 === void 0 ? void 0 : ref5["150"], customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref6 = ui.theme.colors) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.blackFriday) === null || ref7 === void 0 ? void 0 : ref7.white));
});

;// CONCATENATED MODULE: ../../packages/components/Slider/DefaultPrevButton/style.ts

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 10px !important;\n      "
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            path {\n              stroke: ",
        " !important;\n            }\n          "
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              path {\n                stroke: ",
        " !important;\n              }\n            "
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background: ",
        ";\n\n        svg {\n          ",
        "\n        }\n\n        &:hover {\n          background: ",
        ";\n          transition: 0.8s;\n\n          svg {\n            ",
        "\n          }\n        }\n      "
    ]);
    style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n    "
    ]);
    style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        " !important;\n  width: ",
        " !important;\n\n  top: ",
        " !important;\n  position: absolute !important;\n\n  border-radius: 30px;\n  padding: 0px 0px 0px 4px !important;\n  background: ",
        " !important;\n  margin-left: 12px !important;\n  z-index: 1;\n\n  @media (max-width: 1270px) {\n    margin-left: 25px;\n  }\n\n  &:hover {\n    background: ",
        " !important;\n    transition: 0.8s !important;\n  }\n\n  &:hover path {\n    stroke: ",
        ";\n  }\n\n  svg {\n    ",
        "\n    margin-top: ",
        " !important;\n    margin-left: ",
        " !important;\n  }\n\n  box-shadow: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var ButtonArrowPrev = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ButtonArrowPrev",
    componentId: "sc-2adbd07a-0"
})(_templateObject5(), function(param) {
    var arrowButtonsSize = param.arrowButtonsSize;
    return arrowButtonsSize === "small" ? "32px" : "60px";
}, function(param) {
    var arrowButtonsSize = param.arrowButtonsSize;
    return arrowButtonsSize === "small" ? "32px" : "60px";
}, function(param) {
    var isCentralized = param.isCentralized;
    return isCentralized ? "50%" : "calc(50% - 25px)";
}, function(param) {
    var customTheme = param.customTheme;
    var ref, ref1;
    return customTheme ? ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["50"] : ui.theme.colors.neutral.white;
}, function(param) {
    var buttonArrowTheme = param.buttonArrowTheme;
    var ref;
    return (buttonArrowTheme === null || buttonArrowTheme === void 0 ? void 0 : (ref = buttonArrowTheme.backgroundColor) === null || ref === void 0 ? void 0 : ref.hover) || ui.theme.colors.primary[200];
}, function(param) {
    var buttonArrowTheme = param.buttonArrowTheme;
    var ref;
    return (buttonArrowTheme === null || buttonArrowTheme === void 0 ? void 0 : (ref = buttonArrowTheme.arrowColor) === null || ref === void 0 ? void 0 : ref.hover) || ui.theme.colors.neutral.white;
}, function(param) {
    var arrowButtonsSize = param.arrowButtonsSize;
    return arrowButtonsSize === "small" && (0,styled_components_browser_esm/* css */.iv)(style_templateObject());
}, function(param) {
    var arrowButtonsSize = param.arrowButtonsSize;
    return arrowButtonsSize === "small" ? "4px" : "17px";
}, function(param) {
    var arrowButtonsSize = param.arrowButtonsSize;
    return arrowButtonsSize === "small" ? "5px" : "18px";
}, "".concat(ui.theme.space.x0, " ").concat(ui.theme.space["x0.5"], " ").concat(ui.theme.space["x0.5"], "\n    ").concat(ui.theme.colors.neutral["999-opacity-25"]), function(param) {
    var customTheme = param.customTheme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return (0,styled_components_browser_esm/* css */.iv)(style_templateObject4(), customTheme && (0,styled_components_browser_esm/* css */.iv)(style_templateObject3(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["50"], customTheme && (0,styled_components_browser_esm/* css */.iv)(style_templateObject1(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref2 = ui.theme.colors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.blackFriday) === null || ref3 === void 0 ? void 0 : ref3["20"]), ui.theme === null || ui.theme === void 0 ? void 0 : (ref4 = ui.theme.colors) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.primary) === null || ref5 === void 0 ? void 0 : ref5["150"], customTheme && (0,styled_components_browser_esm/* css */.iv)(style_templateObject2(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref6 = ui.theme.colors) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.blackFriday) === null || ref7 === void 0 ? void 0 : ref7.white)));
});

;// CONCATENATED MODULE: ../../packages/components/Slider/style.ts

function Slider_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 3px !important;\n  width: ",
        ";\n  height: 5px;\n  background-color: ",
        ";\n  box-shadow: none;\n  transition: background-color 0.2s ease-in-out;\n"
    ]);
    Slider_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ControlDot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ControlDot",
    componentId: "sc-5f9dc7da-0"
})(Slider_style_templateObject(), function(param) {
    var isSelected = param.isSelected;
    return isSelected ? "30px" : ui.theme.space.x5;
}, function(param) {
    var isSelected = param.isSelected;
    return isSelected ? ui.theme.colors.primary[200] : "rgba(189, 189, 189, 0.5)";
}); // .carousel .control-dots .selected {
 //   width: 30px;
 //   background: ${theme.colors.primary["200"]};
 // }

// EXTERNAL MODULE: ../../packages/components/hocs/index.ts + 5 modules
var hocs = __webpack_require__(42621);
;// CONCATENATED MODULE: ../../packages/components/Slider/index.tsx











var Slider = /*#__PURE__*/ (0,react.memo)(function(param) {
    var children = param.children, PrevButton = param.PrevButton, NextButton = param.NextButton, swipe = param.swipe, verticalSwiping = param.verticalSwiping, touchMove = param.touchMove, arrowsIsActive = param.arrowsIsActive, arrowNextIsInCenter = param.arrowNextIsInCenter, arrowPrevIsInCenter = param.arrowPrevIsInCenter, vertical = param.vertical, slidesToScroll = param.slidesToScroll, slidesToShow = param.slidesToShow, speed = param.speed, autoplay = param.autoplay, _autoplaySpeed = param.autoplaySpeed, autoplaySpeed = _autoplaySpeed === void 0 ? 3500 : _autoplaySpeed, infinite = param.infinite, _dots = param.dots, dots = _dots === void 0 ? false : _dots, responsive = param.responsive, swipeToSlide = param.swipeToSlide, customTheme = param.customTheme, isBlackTheme = param.isBlackTheme, arrowButtonsSize = param.arrowButtonsSize;
    var ref = (0,react.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var isBlackThemeValue = !!customTheme || isBlackTheme;
    var controlDot = (0,react.useCallback)(function(index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlDot, {
            isSelected: index === currentIndex
        });
    }, [
        currentIndex
    ]);
    var DefaultNextButton = (0,react.useMemo)(function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ButtonArrowNext, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-arrow-next")), {
            isCentralized: !!arrowNextIsInCenter,
            customTheme: isBlackThemeValue,
            arrowButtonsSize: arrowButtonsSize,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowCarouselRight, {
                alt: "bot\xe3o de pr\xf3ximo do carrosel",
                themeColors: customTheme === null || customTheme === void 0 ? void 0 : customTheme.arrowColor
            })
        }));
    }, [
        arrowButtonsSize,
        arrowNextIsInCenter,
        customTheme === null || customTheme === void 0 ? void 0 : customTheme.arrowColor,
        isBlackThemeValue, 
    ]);
    var DefaultPrevButton = (0,react.useMemo)(function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ButtonArrowPrev, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-arrow-prev")), {
            isCentralized: !!arrowPrevIsInCenter,
            buttonArrowTheme: customTheme,
            customTheme: isBlackThemeValue,
            arrowButtonsSize: arrowButtonsSize,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowCarouselLeft, {
                alt: "bot\xe3o de voltar do carrosel",
                themeColors: customTheme === null || customTheme === void 0 ? void 0 : customTheme.arrowColor
            })
        }));
    }, [
        arrowButtonsSize,
        arrowPrevIsInCenter,
        customTheme,
        isBlackThemeValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(infra/* ReactSlick */.OA, {
        speed: speed,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        vertical: vertical,
        arrows: arrowsIsActive,
        touchMove: touchMove,
        verticalSwiping: verticalSwiping,
        swipe: swipe,
        prevArrow: PrevButton || DefaultPrevButton,
        nextArrow: NextButton || DefaultNextButton,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        infinite: infinite,
        dots: dots,
        responsive: responsive,
        swipeToSlide: swipeToSlide,
        beforeChange: function(_, nextIndex) {
            var normalizedIndex = nextIndex / slidesToShow;
            setCurrentIndex(normalizedIndex);
        },
        customPaging: function(index) {
            return controlDot(index);
        },
        children: children
    });
});
Slider.displayName = "Slider";
var SliderWithBlackThemeValidation = (0,hocs/* withBlackThemeValidation */.z7)(Slider);



/***/ }),

/***/ 70020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ StatusProgress; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/StatusProgress/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  max-width: 764px;\n  display: grid;\n  margin-top: ",
        ";\n\n  @media (max-width: 924px) {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-around;\n\n  & > div:last-child {\n    width: 53px;\n\n    @media (max-width: 924px) {\n    }\n  }\n\n  @media (max-width: 924px) {\n    justify-self: auto;\n    gap: initial;\n    padding-left: 18%;\n    justify-content: space-between;\n  }\n\n  @media ",
        " {\n    padding-left: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 11px;\n  max-width: calc(100% - 14px);\n  width: 100%;\n  height: 6px;\n  border-radius: ",
        ";\n\n  background: ",
        ";\n  transition: background-color 1s ease;\n\n  @media (max-width: 320px) {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border: 1.5px solid\n    ",
        ";\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ",
        ";\n  background: ",
        ";\n  z-index: 1;\n\n  & > svg {\n    width: 20px;\n    height: 20px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  font-family: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  width: 100%;\n  border-radius: 4px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          display: flex;\n          padding: ",
        ";\n          width: 100%;\n          align-items: center;\n          gap: ",
        ";\n          background-color: ",
        ";\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 41px;\n  height: 36px;\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var StatusStepperContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__StatusStepperContainer",
    componentId: "sc-2f2c82a4-0"
})(_templateObject(), ui.theme.space.x4, ui.theme.space.x0);
var StepperContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__StepperContainer",
    componentId: "sc-2f2c82a4-1"
})(_templateObject1(), ui.theme.device.desktopFirst.mobileXL);
var StepperBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StepperBar",
    componentId: "sc-2f2c82a4-2"
})(_templateObject2(), ui.theme.space.x1, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : ui.theme.colors.neutral[155];
});
var StatusContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StatusContainer",
    componentId: "sc-2f2c82a4-3"
})(_templateObject3(), ui.theme.space.x2, function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "100%";
});
var StatusIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StatusIcon",
    componentId: "sc-2f2c82a4-4"
})(_templateObject4(), ui.theme.space.x7, ui.theme.space.x7, function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : "".concat(ui.theme.colors.neutral[350]);
}, ui.theme.space.x1, ui.theme.colors.neutral.white);
var StatusText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__StatusText",
    componentId: "sc-2f2c82a4-5"
})(_templateObject5(), function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : "".concat(ui.theme.colors.neutral[350]);
}, ui.theme.typography.fontWeight[400], ui.theme.typography.fontSize.sm.x3, ui.theme.typography.fontFamily.chivo);
var Stepper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Stepper",
    componentId: "sc-2f2c82a4-6"
})(_templateObject6(), function(param) {
    var height = param.height;
    return height !== null && height !== void 0 ? height : "4px";
}, function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui.theme.colors.neutral[555];
});
var StatusProgressContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StatusProgressContainer",
    componentId: "sc-2f2c82a4-7"
})(_templateObject7(), ui.theme.space.x2);
var StepperWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__StepperWrapper",
    componentId: "sc-2f2c82a4-8"
})(_templateObject10(), function(param) {
    var hasHeader = param.hasHeader;
    return hasHeader ? (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), ui.theme.space.x4, ui.theme.space.x3, ui.theme.colors.neutral.white) : (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
});
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__IconWrapper",
    componentId: "sc-2f2c82a4-9"
})(_templateObject11(), ui.theme.space.x3, ui.theme.colors.secondary[28]);
var StatusProgressWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StatusProgressWrapper",
    componentId: "sc-2f2c82a4-10"
})(_templateObject12(), ui.theme.space.x2);
var StepTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__StepTitle",
    componentId: "sc-2f2c82a4-11"
})(_templateObject13(), ui.theme.typography.fontSize.sm.x5, ui.theme.colors.neutral[550], ui.theme.typography.fontWeight[500], ui.theme.typography.fontFamily.chivo);

;// CONCATENATED MODULE: ../../packages/components/StatusProgress/index.tsx





var StatusProgress = function(param) {
    var barColor = param.barColor, statusStep = param.statusStep, _hasIcon = param.hasIcon, hasIcon = _hasIcon === void 0 ? true : _hasIcon, icon = param.icon, stepTitle = param.stepTitle, height = param.height, width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("stepper-wrapper")), {
        hasHeader: !!(icon && stepTitle),
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("icon-wrapper")), {
                children: icon
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StatusProgressWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("status-progress-wrapper")), {
                children: [
                    stepTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StepTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("step-title")), {
                        children: stepTitle
                    })) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusProgressContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("status-progress-container")), {
                        children: hasIcon ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StatusStepperContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("status-stepper-container")), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("stepper-container")), {
                                    children: statusStep.map(function(step) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StatusContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            width: width
                                        }, (0,application/* buildTestIds */.Fek)("status-".concat(step.name, "-container"))), {
                                            children: [
                                                (step === null || step === void 0 ? void 0 : step.icon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    color: step.statusColor
                                                }, (0,application/* buildTestIds */.Fek)("status-".concat(step.name, "-icon"))), {
                                                    children: step.icon
                                                })) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    color: step === null || step === void 0 ? void 0 : step.statusTextColor
                                                }, (0,application/* buildTestIds */.Fek)("status-".concat(step.name, "-text"))), {
                                                    children: step === null || step === void 0 ? void 0 : step.statusText
                                                }))
                                            ]
                                        }), step.name);
                                    })
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperBar, (0,_object_spread/* default */.Z)({
                                    backgroundColor: barColor
                                }, (0,application/* buildTestIds */.Fek)("stepper-bar")))
                            ]
                        })) : statusStep === null || statusStep === void 0 ? void 0 : statusStep.map(function(step) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Stepper, {
                                height: height,
                                color: step === null || step === void 0 ? void 0 : step.statusColor
                            }, step === null || step === void 0 ? void 0 : step.name);
                        })
                    }))
                ]
            }))
        ]
    }));
};



/***/ }),

/***/ 96187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ StepperModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/StepperModal/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: ",
        ";\n  border-radius: ",
        ";\n  min-height: ",
        ";\n  width: ",
        ";\n  background-color: ",
        ";\n  box-shadow: 0px 2px 8px 0px ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  inset: 0;\n  display: ",
        ";\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  gap: 16px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-bottom: ",
        ";\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: auto;\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  background-color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  border-radius: ",
        ";\n  transition: background-color 0.2s ease-in-out;\n  white-space: nowrap;\n  width: auto;\n\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: ",
        " ",
        ";\n  gap: ",
        ";\n  align-items: center;\n  cursor: pointer;\n\n  svg {\n    stroke-width: 2;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}


var StepperModalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StepperModalContainer",
    componentId: "sc-1c2b3d73-0"
})(_templateObject(), function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "".concat(ui.theme.space.x6);
}, ui.theme.space.x2, function(param) {
    var minHeight = param.minHeight;
    return minHeight !== null && minHeight !== void 0 ? minHeight : "480px";
}, function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "694px";
}, ui.theme.colors.neutral.white, ui.theme.colors.neutral["900-opacity-32"]);
var StepperModalOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StepperModalOverlay",
    componentId: "sc-1c2b3d73-1"
})(_templateObject1(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "flex" : "none";
}, function(param) {
    var overlayBackgroundColor = param.overlayBackgroundColor;
    return overlayBackgroundColor !== null && overlayBackgroundColor !== void 0 ? overlayBackgroundColor : "".concat(ui.theme.colors.neutral["999-opacity-50"]);
});
var StepperModalHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__StepperModalHeader",
    componentId: "sc-1c2b3d73-2"
})(_templateObject2(), function(param) {
    var headerFlexDirection = param.headerFlexDirection;
    return headerFlexDirection !== null && headerFlexDirection !== void 0 ? headerFlexDirection : "column";
});
var StepperModalTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StepperModalTitleContainer",
    componentId: "sc-1c2b3d73-3"
})(_templateObject4(), function(param) {
    var hasBorderBottom = param.hasBorderBottom;
    return hasBorderBottom && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), ui.theme.space.x2, ui.theme.colors.neutral[150]);
});
var ModalTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__ModalTitle",
    componentId: "sc-1c2b3d73-4"
})(_templateObject5(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight.bold, function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "".concat(ui.theme.typography.fontSize.md.x1);
}, function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : "".concat(ui.theme.colors.neutral[900]);
});
var CloseModalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CloseModalContainer",
    componentId: "sc-1c2b3d73-5"
})(_templateObject6());
var StepperContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StepperContainer",
    componentId: "sc-1c2b3d73-6"
})(_templateObject7());
var StatusProgressBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StatusProgressBar",
    componentId: "sc-1c2b3d73-7"
})(_templateObject8());
var StepperModalDescriptionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StepperModalDescriptionContainer",
    componentId: "sc-1c2b3d73-8"
})(_templateObject9());
var ModalDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ModalDescription",
    componentId: "sc-1c2b3d73-9"
})(_templateObject10(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[400], ui.theme.typography.fontSize.sm.x7, ui.theme.colors.neutral[585]);
var StepperModalFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    displayName: "styles__StepperModalFooter",
    componentId: "sc-1c2b3d73-10"
})(_templateObject11(), function(param) {
    var hasNextButton = param.hasNextButton, hasBackButton = param.hasBackButton;
    if (hasNextButton && hasBackButton) {
        return "justify-content: space-between;";
    }
    return "justify-content: ".concat(hasNextButton ? "end" : "start", ";");
});
var StepperNextButton = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__StepperNextButton",
    componentId: "sc-1c2b3d73-11"
})(_templateObject12(), ui.theme.space.x2, ui.theme.space.x6, ui.theme.colors.secondary[380], ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[400], ui.theme.typography.fontFamily.chivo, ui.theme.space.x1, ui.theme.colors.secondary[250]);
var StepperBackButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StepperBackButton",
    componentId: "sc-1c2b3d73-12"
})(_templateObject13(), ui.theme.space.x2, ui.theme.space.x6, ui.theme.space.x1);
var StepperBackButtonText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__StepperBackButtonText",
    componentId: "sc-1c2b3d73-13"
})(_templateObject14(), ui.theme.colors.secondary[380], ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight.bold, ui.theme.typography.fontFamily.chivo);
var StepperModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StepperModalContent",
    componentId: "sc-1c2b3d73-14"
})(_templateObject15());

// EXTERNAL MODULE: ../../packages/components/StatusProgress/index.tsx + 1 modules
var StatusProgress = __webpack_require__(70020);
;// CONCATENATED MODULE: ../../packages/components/StepperModal/index.tsx








var StepperModal = function(param) {
    var isOpen = param.isOpen, title = param.title, onClose = param.onClose, steps = param.steps, children = param.children, description = param.description, hasBackButton = param.hasBackButton, hasButtons = param.hasButtons, hasNextButton = param.hasNextButton, goBack = param.goBack, isNextButtonDisabled = param.isNextButtonDisabled, goNext = param.goNext, nextButtonText = param.nextButtonText, width = param.width, headerFlexDirection = param.headerFlexDirection, hasBorderBottom = param.hasBorderBottom, overlayBackgroundColor = param.overlayBackgroundColor, padding = param.padding, minHeight = param.minHeight, statusHeight = param.statusHeight, titleColor = param.titleColor, titleFontSize = param.titleFontSize;
    var stepperModalRef = (0,react.useRef)(null);
    (0,application/* useClickOutside */.O8h)({
        ref: stepperModalRef,
        callback: function() {
            if (isOpen) onClose();
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperModalOverlay, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        overlayBackgroundColor: overlayBackgroundColor
    }, (0,application/* buildTestIds */.Fek)("stepper-modal-overlay")), {
        isVisible: isOpen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperModalContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            width: width,
            ref: stepperModalRef,
            padding: padding,
            minHeight: minHeight
        }, (0,application/* buildTestIds */.Fek)("stepper-modal-container")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperModalHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    headerFlexDirection: headerFlexDirection
                }, (0,application/* buildTestIds */.Fek)("stepper-modal-header")), {
                    children: [
                        (steps === null || steps === void 0 ? void 0 : steps.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusProgress/* StatusProgress */.M, {
                            height: statusHeight,
                            statusStep: steps,
                            hasIcon: false
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperModalTitleContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("stepper-modal-title-container")), {
                            hasBorderBottom: hasBorderBottom,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-title")), {
                                    color: titleColor,
                                    fontSize: titleFontSize,
                                    children: title
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseModalContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("close-modal-container")), {
                                    onClick: onClose,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {
                                        width: 24,
                                        height: 24
                                    })
                                }))
                            ]
                        })),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperModalDescriptionContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("stepper-modal-description-container")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-description")), {
                                children: description
                            }))
                        }))
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperModalContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("stepper-modal-content")), {
                    children: children
                })),
                hasButtons ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperModalFooter, {
                    hasBackButton: hasBackButton,
                    hasNextButton: hasNextButton,
                    children: [
                        hasBackButton && goBack ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperBackButton, {
                            onClick: function() {
                                return goBack();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowLeft, {
                                    width: 16,
                                    height: 16,
                                    color: ui.theme.colors.secondary[380]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperBackButtonText, {
                                    children: "Voltar"
                                })
                            ]
                        }) : null,
                        hasNextButton && goNext ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperNextButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("stepper-next-cancel")), {
                            isDisabled: isNextButtonDisabled,
                            onClick: function() {
                                return goNext();
                            },
                            children: nextButtonText !== null && nextButtonText !== void 0 ? nextButtonText : "Pr\xf3ximo"
                        })) : null
                    ]
                }) : null
            ]
        }))
    }));
};



/***/ }),

/***/ 85922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomStyledLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(430);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32346);







var CustomStyledLink = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var onClick = _param.onClick, target = _param.target, mouseOver = _param.mouseOver, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "onClick",
        "target",
        "mouseOver",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_style__WEBPACK_IMPORTED_MODULE_3__/* .StyledLink */ .F, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        onClick: onClick,
        ref: ref,
        target: target || "_blank",
        mouseOver: mouseOver
    }, (0,application__WEBPACK_IMPORTED_MODULE_2__/* .buildTestIds */ .Fek)("styled-link"), props), {
        children: children
    }));
});
CustomStyledLink.displayName = "StyledLink";



/***/ }),

/***/ 32346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ StyledLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 0 !important;\n  width: ",
        ";\n  text-decoration: ",
        ";\n  color: ",
        ";\n  background-color: ",
        ";\n  font-size: ",
        ";\n  ",
        "\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "style__StyledLink",
    componentId: "sc-5539f3f4-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width || "initial";
}, function(param) {
    var textDecoration = param.textDecoration;
    return textDecoration || "none";
}, function(param) {
    var color = param.color;
    return color || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[520];
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || "transparent";
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize || ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x5;
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight && "font-weight: ".concat(fontWeight, ";");
}, function(param) {
    var mouseOver = param.mouseOver;
    return mouseOver && "&:hover {\n    color: ".concat((mouseOver === null || mouseOver === void 0 ? void 0 : mouseOver.color) || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[999], " !important;\n\n  }");
});


/***/ }),

/***/ 63665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Swiper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var infra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11338);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(430);






var Swiper = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var slidesPerView = param.slidesPerView, pagination = param.pagination, scrollbar = param.scrollbar, freeMode = param.freeMode, spaceBetween = param.spaceBetween, sticky = param.sticky, slidesPerGroup = param.slidesPerGroup, breakpoints = param.breakpoints, subComponents = param.subComponents, navigation = param.navigation, slidesOffsetAfter = param.slidesOffsetAfter, slidesOffsetBefore = param.slidesOffsetBefore, width = param.width, effect = param.effect, position = param.position, getBreakpoints = param.getBreakpoints, configs = param.configs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(infra__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlider */ .tI, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_3__/* .buildTestIds */ .Fek)("swiper-slider-component")), {
        slidesPerView: slidesPerView,
        pagination: pagination,
        scrollbar: scrollbar,
        freeMode: freeMode,
        spaceBetween: spaceBetween,
        sticky: sticky,
        slidesPerGroup: slidesPerGroup,
        breakpoints: breakpoints,
        subComponents: subComponents,
        navigation: navigation,
        slidesOffsetAfter: slidesOffsetAfter,
        slidesOffsetBefore: slidesOffsetBefore,
        width: width,
        effect: effect,
        position: position,
        getBreakpoints: getBreakpoints,
        configs: configs
    }));
});
Swiper.displayName = "Slider";



/***/ }),

/***/ 93082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useUniqueClientFeedbackData; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(430);
/* harmony import */ var application_state_manager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74224);
/* harmony import */ var implementations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32202);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26365);







var useUniqueClientFeedbackData = function() {
    var showSecondaryButton = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(true), showModal = ref[0], setShowModal = ref[1];
    var ref1 = (0,application_state_manager__WEBPACK_IMPORTED_MODULE_2__/* .useUniqueClient */ .NG)((0,application_state_manager__WEBPACK_IMPORTED_MODULE_2__/* .useShallow */ .NL)(function(state) {
        return {
            changeUniqueClientStep: state.changeUniqueClientStep,
            currentStep: state.currentStep,
            setIsUniqueClientModalOpen: state.setIsUniqueClientModalOpen
        };
    })), changeUniqueClientStep = ref1.changeUniqueClientStep, currentStep = ref1.currentStep, setIsUniqueClientModalOpen = ref1.setIsUniqueClientModalOpen;
    var channelSelected = (0,application_state_manager__WEBPACK_IMPORTED_MODULE_2__/* .useTwoFactor */ .kD)((0,application_state_manager__WEBPACK_IMPORTED_MODULE_2__/* .useShallow */ .NL)(function(state) {
        return {
            channelSelected: state.channelSelected
        };
    })).channelSelected;
    var isClientMobile = (0,application__WEBPACK_IMPORTED_MODULE_1__/* .useAppContext */ .bp4)().isClientMobile;
    var isSuccess = currentStep === "feedbackSuccess";
    var isFailed = currentStep === "feedbackError";
    var getFeedbackImage = function() {
        if (isSuccess) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui__WEBPACK_IMPORTED_MODULE_6__.SuccessSyncIcon, {});
        }
        if (isFailed && channelSelected === 1) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui__WEBPACK_IMPORTED_MODULE_6__.TelephoneErrorIcon, {});
        }
        if (isFailed && channelSelected === 2) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui__WEBPACK_IMPORTED_MODULE_6__.EmailFailureIcon, {});
        }
        return null;
    };
    var getModalTitle = function() {
        if (isSuccess) {
            return "Agora voc\xea pode acessar todas as suas compras!";
        }
        if (isFailed) {
            return "Erro ao realizar verifica\xe7\xe3o";
        }
        return undefined;
    };
    var getDescription = function() {
        if (isSuccess) {
            return "Suas compras em nossas lojas f\xedsicas e online j\xe1 podem ser acessadas pelo nosso site e aplicativo.";
        }
        if (isFailed) {
            return "Parece que voc\xea atingiu o limite de envios de c\xf3digo por dia. Para sua seguran\xe7a, pausamos temporariamente as tentativas de envio do c\xf3digo de verifica\xe7\xe3o. Por favor, aguarde 24 horas antes de tentar novamente ou entre em contato com o SAC.";
        }
        return undefined;
    };
    var getPrimaryButtonLabel = function() {
        var ref;
        if (isSuccess && (router === null || router === void 0 ? void 0 : router.pathname) === "/") {
            return "Ir para a p\xe1gina inicial";
        }
        if (isSuccess && (router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.includes("conta/meus-pedidos"))) {
            return "Continuar";
        }
        if (isFailed) {
            return "Entrar em contato com o SAC";
        }
        return undefined;
    };
    var getSecondaryButtonLabel = function() {
        if (isSuccess) {
            return "Ir para meus pedidos";
        }
        if (isFailed) {
            return "Ir para p\xe1gina inicial";
        }
        return undefined;
    };
    var onClickOnPrimaryButton = function() {
        implementations__WEBPACK_IMPORTED_MODULE_3__/* .cookie.deleteCookie */ .pR.deleteCookie({
            name: "@FC:Ecom:HadValidationVisualization"
        });
        setIsUniqueClientModalOpen(false);
        setShowModal(false);
        if (isSuccess) {
            var ref;
            if ((router === null || router === void 0 ? void 0 : router.pathname) === "/" || (router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.includes("/conta/meus-pedidos"))) {
                changeUniqueClientStep("modalCall");
                return;
            }
            router === null || router === void 0 ? void 0 : router.push("/");
            return;
        }
        router === null || router === void 0 ? void 0 : router.push("https://ferreiracosta.movidesk.com/kb/");
    };
    var onClickOnSecondaryButton = function() {
        implementations__WEBPACK_IMPORTED_MODULE_3__/* .cookie.deleteCookie */ .pR.deleteCookie({
            name: "@FC:Ecom:HadValidationVisualization"
        });
        setIsUniqueClientModalOpen(false);
        setShowModal(false);
        if (isSuccess) {
            router.push("/conta/meus-pedidos");
            return;
        }
        if ((router === null || router === void 0 ? void 0 : router.pathname) === "/") {
            changeUniqueClientStep("modalCall");
            return;
        }
        router === null || router === void 0 ? void 0 : router.push("/");
    };
    var getUniqueClientFeedback = function() {
        var feedbackProps = {
            actions: {
                closeModal: function() {
                    setShowModal(false);
                    changeUniqueClientStep("modalCall");
                    setIsUniqueClientModalOpen(false);
                },
                isModalOpen: showModal && (isSuccess || isFailed),
                modalTitle: isSuccess ? "J\xe1 comprou em uma das nossas lojas?" : "",
                hasHeader: !isFailed,
                hideheaderline: isFailed,
                headerPadding: isFailed ? "0px" : undefined
            },
            content: {
                title: getModalTitle(),
                description: getDescription(),
                primaryButtonLabel: getPrimaryButtonLabel(),
                image: getFeedbackImage(),
                onPrimaryButtonClick: onClickOnPrimaryButton,
                contentType: isClientMobile ? "component" : "modal",
                onSecondaryButtonClick: onClickOnSecondaryButton
            }
        };
        if (showSecondaryButton) {
            feedbackProps.content.secondaryButtonLabel = getSecondaryButtonLabel();
        }
        return feedbackProps;
    };
    return {
        getUniqueClientFeedback: getUniqueClientFeedback
    };
};



/***/ }),

/***/ 58466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ UniqueClientFeedbackUI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _ResponsiveModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58393);




var UniqueClientFeedbackUI = function(_param) {
    var actions = _param.actions, content = _param.content, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "actions",
        "content"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ResponsiveModal__WEBPACK_IMPORTED_MODULE_1__/* .ResponsiveModal */ .c, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, actions, content, props));
};



/***/ }),

/***/ 82177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZF": function() { return /* reexport */ UniqueClientComponent; },
  "vF": function() { return /* reexport */ UniqueClientValidation; }
});

// UNUSED EXPORTS: UniqueClientContent, UniqueClientModal

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
// EXTERNAL MODULE: ../../packages/typing/index.tsx + 7 modules
var typing = __webpack_require__(96915);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/components/UniqueClient/components/utils/data.tsx
var data = __webpack_require__(85486);
;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientContent/data.tsx








var useUniqueClientData = function() {
    var loggedClient = (0,application/* useUser */.aFb)().loggedClient;
    var router = (0,next_router.useRouter)();
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var ref = (0,state_manager/* useUniqueClient */.NG)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setIsUniqueClientModalOpen: state.setIsUniqueClientModalOpen,
            changeUniqueClientStep: state.changeUniqueClientStep
        };
    })), setIsUniqueClientModalOpen = ref.setIsUniqueClientModalOpen, changeUniqueClientStep = ref.changeUniqueClientStep;
    var setIsValidationActive = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setIsValidationActive: state.setIsValidationActive
        };
    })).setIsValidationActive;
    var ref1 = (0,data/* useUniqueClientUtils */.s)(), sendTwoFactorToken = ref1.sendTwoFactorToken, needsToValidateEmail = ref1.needsToValidateEmail, needsToValidatePhoneNumber = ref1.needsToValidatePhoneNumber;
    var closeModal = function() {
        setIsUniqueClientModalOpen(false);
    };
    var handleValidationFlow = function() {
        implementations/* cookie.setCookie */.pR.setCookie({
            name: "@FC:Ecom:HadValidationVisualization",
            value: "true"
        });
        if (isClientMobile) {
            router.push("conta/seguranca/verificacao-identidade");
            return;
        }
        if (needsToValidatePhoneNumber && needsToValidateEmail) {
            changeUniqueClientStep("chooseAnotherMethod");
            setIsValidationActive(true);
            return;
        }
        var ref, ref1, ref2;
        sendTwoFactorToken({
            channel: needsToValidatePhoneNumber ? 1 : 2,
            faType: needsToValidatePhoneNumber ? typing/* FATypeValues.AccountValidatePhone2FA */.ZI.AccountValidatePhone2FA : typing/* FATypeValues.AccountValidateEMail2FA */.ZI.AccountValidateEMail2FA,
            cpf: (ref = loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf) !== null && ref !== void 0 ? ref : "",
            email: (ref1 = loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email) !== null && ref1 !== void 0 ? ref1 : "",
            phoneNumber: (ref2 = loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber) !== null && ref2 !== void 0 ? ref2 : ""
        });
    };
    var getUniqueClientContent = function() {
        var contentMap = new Map();
        contentMap.set("image", /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ShoppingFlowIcon, {}));
        contentMap.set("title", "Todas as compras num s\xf3 lugar!");
        contentMap.set("description", "Agora voc\xea pode visualizar suas compras f\xedsicas e online aqui no site. Mais comodidade para voc\xea!");
        contentMap.set("primaryButtonLabel", "Sincronizar compras");
        contentMap.set("secondaryButtonLabel", "Deixar para depois");
        contentMap.set("onPrimaryButtonClick", handleValidationFlow);
        contentMap.set("onSecondaryButtonClick", closeModal);
        return contentMap;
    };
    return {
        getUniqueClientContent: getUniqueClientContent
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientContent/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: ",
        ";\n\n  @media ",
        " {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  height: 45px;\n  transition: background-color 0.3s ease-in-out;\n  font-size: ",
        ";\n\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: ",
        ";\n  height: 45px;\n  color: ",
        ";\n  font-size: ",
        ";\n\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var UniqueClientContentContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__UniqueClientContentContainer",
    componentId: "sc-3a1932d7-0"
})(_templateObject());
var UniqueClientContentImage = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__UniqueClientContentImage",
    componentId: "sc-3a1932d7-1"
})(_templateObject1(), ui.theme.space.x6, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x4);
var UniqueClientContentInformation = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__UniqueClientContentInformation",
    componentId: "sc-3a1932d7-2"
})(_templateObject2(), ui.theme.space.x2);
var UniqueClientContentTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__UniqueClientContentTitle",
    componentId: "sc-3a1932d7-3"
})(_templateObject3(), ui.theme.typography.fontSize.sm.x7, ui.theme.colors.neutral[550], ui.theme.typography.fontWeight[700], ui.theme.typography.fontFamily.chivo, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x5);
var UniqueClientContentDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__UniqueClientContentDescription",
    componentId: "sc-3a1932d7-4"
})(_templateObject4(), ui.theme.typography.fontSize.sm.x3, ui.theme.colors.neutral[110], ui.theme.typography.fontWeight[400], ui.theme.typography.fontFamily.chivo);
var UniqueClientContentButtons = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__UniqueClientContentButtons",
    componentId: "sc-3a1932d7-5"
})(_templateObject5(), ui.theme.space.x4);
var UniqueClientPrimaryButton = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__UniqueClientPrimaryButton",
    componentId: "sc-3a1932d7-6"
})(_templateObject6(), ui.theme.colors.secondary[380], ui.theme.space.x1, ui.theme.colors.neutral.white, ui.theme.typography.fontSize.sm.x5, ui.theme.colors.secondary[350]);
var UniqueClientSecondaryButton = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__UniqueClientSecondaryButton",
    componentId: "sc-3a1932d7-7"
})(_templateObject7(), ui.theme.colors.neutral.white, ui.theme.colors.neutral[550], ui.theme.typography.fontSize.sm.x3, ui.theme.colors.neutral.white);

;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientContent/ui.tsx





var UniqueClientContentUI = function(param) {
    var description = param.description, image = param.image, onPrimaryButtonClick = param.onPrimaryButtonClick, onSecondaryButtonClick = param.onSecondaryButtonClick, primaryButtonLabel = param.primaryButtonLabel, secondaryButtonLabel = param.secondaryButtonLabel, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UniqueClientContentContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("unique-client-content-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientContentImage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("unique-client-content-image")), {
                children: image
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UniqueClientContentInformation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("unique-client-content-information")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientContentTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("unique-client-content-title")), {
                        children: title
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientContentDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("unique-client-content-description")), {
                        children: description
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UniqueClientContentButtons, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("unique-client-content-buttons")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientPrimaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("unique-client-primary-button")), {
                        onClick: onPrimaryButtonClick,
                        children: primaryButtonLabel
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientSecondaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("unique-client-secondary-button")), {
                        onClick: onSecondaryButtonClick,
                        children: secondaryButtonLabel
                    }))
                ]
            }))
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientContent/index.tsx




var UniqueClientContent = function() {
    var getUniqueClientContent = useUniqueClientData().getUniqueClientContent;
    var uniqueClientContent = Object.fromEntries(getUniqueClientContent());
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientContentUI, (0,_object_spread/* default */.Z)({}, uniqueClientContent));
};


;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientModal/data.tsx


var useUniqueClientModalData = function() {
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var ref = (0,state_manager/* useUniqueClient */.NG)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setIsUniqueClientModalOpen: state.setIsUniqueClientModalOpen,
            isUniqueClientModalOpen: state.isUniqueClientModalOpen
        };
    })), setIsUniqueClientModalOpen = ref.setIsUniqueClientModalOpen, isUniqueClientModalOpen = ref.isUniqueClientModalOpen;
    var getUniqueClientModalContent = function() {
        var contentMap = new Map();
        contentMap.set("closeModal", function() {
            setIsUniqueClientModalOpen(false);
        });
        contentMap.set("modalTitle", "J\xe1 comprou em uma das nossas lojas?");
        contentMap.set("isModalOpen", isUniqueClientModalOpen);
        contentMap.set("isMobile", isClientMobile);
        return contentMap;
    };
    return {
        getUniqueClientModalContent: getUniqueClientModalContent
    };
};


// EXTERNAL MODULE: ../../packages/components/BottomSheet/index.tsx
var BottomSheet = __webpack_require__(33082);
// EXTERNAL MODULE: ../../packages/components/ModalGeneral/index.tsx + 1 modules
var ModalGeneral = __webpack_require__(89459);
;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientModal/ui.tsx





var UniqueClientModalUI = function(param) {
    var closeModal = param.closeModal, modalTitle = param.modalTitle, isModalOpen = param.isModalOpen, isMobile = param.isMobile;
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet/* BottomSheet */.R, {
            omitHeader: false,
            title: modalTitle,
            onCloseBottomSheet: closeModal,
            stateBottomSheet: isModalOpen,
            noFooter: true,
            hasActionInHeader: true,
            headerAction: closeModal,
            textButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {
                width: 24,
                height: 24,
                color: ui.theme.colors.neutral[350]
            }),
            justifyContent: "space-between",
            display: "flex",
            onDismiss: closeModal,
            padding: "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x0, " ").concat(ui.theme.space.x2),
            paddingContent: "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x4),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientContent, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGeneral.ModalGeneral, {
        contentGap: ui.theme.space.x0,
        isOpen: isModalOpen,
        onCloseModal: closeModal,
        title: modalTitle,
        closeButtonSize: 24,
        fontWeight: ui.theme.typography.fontWeight[400],
        bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientContent, {}),
        ariaLabelForModal: modalTitle
    });
};


;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientModal/index.tsx




var UniqueClientModal = function() {
    var getUniqueClientModalContent = useUniqueClientModalData().getUniqueClientModalContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientModalUI, (0,_object_spread/* default */.Z)({}, Object.fromEntries(getUniqueClientModalContent())));
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/components/2fa/Content/useTwoFactorContent/index.tsx
var useTwoFactorContent = __webpack_require__(53886);
;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientValidation/data.tsx












var useUniqueClientValidationData = function(clientInfo) {
    var ref, ref1;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var loggedClient = (0,application/* useUser */.aFb)().loggedClient;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(true), isFirstRender = ref3[0], setIsFirstRender = ref3[1];
    var ref4 = (0,data/* useUniqueClientUtils */.s)(), sendTwoFactorToken = ref4.sendTwoFactorToken, needsToValidateEmail = ref4.needsToValidateEmail, needsToValidatePhoneNumber = ref4.needsToValidatePhoneNumber;
    var shouldShowComponent = !isClientMobile || isClientMobile && (router === null || router === void 0 ? void 0 : (ref1 = router.pathname) === null || ref1 === void 0 ? void 0 : ref1.includes("verificacao-identidade"));
    var ref5 = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            isRequesting: state.isRequesting,
            setIsTokenCodeValid: state.setIsTokenCodeValid,
            setIsValidatingCode: state.setIsValidatingCode,
            setValidateCode: state.setValidateCode,
            setIsValidationActive: state.setIsValidationActive,
            channelSelected: state.channelSelected,
            faType: state.faType,
            tokenCode: state.tokenCode,
            setInitTimer: state.setInitTimer,
            setChannelSelected: state.setChannelSelected
        };
    })), isRequesting = ref5.isRequesting, setIsTokenCodeValid = ref5.setIsTokenCodeValid, setIsValidatingCode = ref5.setIsValidatingCode, setIsValidationActive = ref5.setIsValidationActive, setValidateCode = ref5.setValidateCode, channelSelected = ref5.channelSelected, faType = ref5.faType, tokenCode = ref5.tokenCode, setInitTimer = ref5.setInitTimer, setChannelSelected = ref5.setChannelSelected;
    var ref6 = (0,state_manager/* useUniqueClient */.NG)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            changeUniqueClientStep: state.changeUniqueClientStep,
            currentStep: state.currentStep,
            setUniqueClientInfo: state.setUniqueClientInfo,
            uniqueClientInfo: state.uniqueClientInfo
        };
    })), changeUniqueClientStep = ref6.changeUniqueClientStep, currentStep = ref6.currentStep, setUniqueClientInfo = ref6.setUniqueClientInfo, uniqueClientInfo = ref6.uniqueClientInfo;
    (0,react.useEffect)(function() {
        if ((!loggedClient || !clientInfo) && isClientMobile) {
            setIsLoading(true);
            return;
        }
        setIsLoading(false);
    }, [
        clientInfo,
        loggedClient,
        isClientMobile
    ]);
    // eslint-disable-next-line sonarjs/cognitive-complexity
    (0,react.useEffect)(function() {
        if (isClientMobile && (clientInfo || uniqueClientInfo)) {
            setIsValidationActive(true);
            if (needsToValidateEmail && needsToValidatePhoneNumber && isFirstRender) {
                changeUniqueClientStep("chooseAnotherMethod");
                setIsLoading(false);
                return;
            }
            if (loggedClient && isFirstRender) {
                setIsLoading(true);
                setIsFirstRender(false);
                var ref, ref1, ref2;
                sendTwoFactorToken({
                    channel: needsToValidatePhoneNumber ? 1 : 2,
                    faType: needsToValidatePhoneNumber ? typing/* FATypeValues.AccountValidatePhone2FA */.ZI.AccountValidatePhone2FA : typing/* FATypeValues.AccountValidateEMail2FA */.ZI.AccountValidateEMail2FA,
                    cpf: (ref = loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf) !== null && ref !== void 0 ? ref : "",
                    email: (ref1 = loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email) !== null && ref1 !== void 0 ? ref1 : "",
                    phoneNumber: (ref2 = loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber) !== null && ref2 !== void 0 ? ref2 : ""
                });
                setIsLoading(false);
                changeUniqueClientStep("verifyIdentity");
            }
        }
    }, [
        isClientMobile,
        setUniqueClientInfo,
        uniqueClientInfo,
        clientInfo,
        setIsValidationActive,
        changeUniqueClientStep,
        needsToValidateEmail,
        sendTwoFactorToken,
        needsToValidatePhoneNumber,
        loggedClient,
        isFirstRender,
        setIsFirstRender, 
    ]);
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var clearTime = (0,react.useCallback)(function() {
        localStorage.removeItem("timeSent_".concat(faType, "_").concat(channelSelected));
        localStorage.removeItem("countdownTime_".concat(faType, "_").concat(channelSelected));
        localStorage.removeItem("countdownTimeTimestamp_".concat(faType, "_").concat(channelSelected));
    }, [
        faType,
        channelSelected
    ]);
    var checkErrorAttempt = (0,react.useCallback)(function(statusCode, messages) {
        if (statusCode === null || statusCode === void 0 ? void 0 : statusCode.includes("222")) {
            setIsValidationActive(false);
            changeUniqueClientStep("feedbackError");
            clearTime();
            return;
        }
        setIsTokenCodeValid(false);
        setValidateCode(true);
        addToast({
            isNewToast: true,
            newToastTheme: "dark",
            type: "error",
            description: "".concat(messages === null || messages === void 0 ? void 0 : messages[0]),
            title: "Ocorreu um erro ao validar o c\xf3digo",
            timerInMilliseconds: 3000
        });
    }, [
        setIsValidationActive,
        setIsTokenCodeValid,
        addToast,
        setValidateCode,
        changeUniqueClientStep,
        clearTime, 
    ]);
    var handleSuccessValidation = (0,react.useCallback)(function() {
        setIsTokenCodeValid(true);
        setIsValidatingCode(true);
        changeUniqueClientStep("feedbackSuccess");
    }, [
        changeUniqueClientStep,
        setIsTokenCodeValid,
        setIsValidatingCode
    ]);
    var handleCodeValidation = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var channel, userFAType, cpf, email, phoneNumber, token, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        channel = param.channel, userFAType = param.faType, cpf = param.cpf, email = param.email, phoneNumber = param.phoneNumber, token = param.token;
                        return [
                            4,
                            implementations/* notificationApi.validateTwoFactorCode */.E8.validateTwoFactorCode({
                                channel: channel,
                                faType: Number(userFAType),
                                cpf: cpf,
                                email: email,
                                phoneNumber: phoneNumber,
                                token: token,
                                jwt: accessToken
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (!(response === null || response === void 0 ? void 0 : response.isValid)) {
                            checkErrorAttempt(response === null || response === void 0 ? void 0 : response.statusCodeInternal, response === null || response === void 0 ? void 0 : response.messages);
                            return [
                                2
                            ];
                        }
                        clearTime();
                        handleSuccessValidation();
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        accessToken,
        clearTime,
        checkErrorAttempt,
        handleSuccessValidation
    ]);
    var canChooseAnotherMethod = needsToValidateEmail && needsToValidatePhoneNumber;
    var handleSelectAnotherTwoFactorType = function() {
        changeUniqueClientStep("chooseAnotherMethod");
    };
    var chooseMethods = function(phoneNumber, email) {
        var methods = [];
        if (phoneNumber) {
            methods.push({
                title: "SMS",
                description: (0,useTwoFactorContent/* maskPhoneNumber */.Y)(String(phoneNumber)),
                handleOptionAction: function() {
                    setInitTimer(true);
                    setChannelSelected(1);
                    if (isRequesting) {
                        changeUniqueClientStep("verifyIdentity");
                        return;
                    }
                    sendTwoFactorToken({
                        channel: 1,
                        cpf: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf),
                        email: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email),
                        faType: typing/* FATypeValues.AccountValidatePhone2FA */.ZI.AccountValidatePhone2FA,
                        phoneNumber: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber)
                    });
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.MessagesIcon, {}),
                isValid: true
            });
        }
        if (email) {
            methods.push({
                title: "E-mail",
                description: (0,useTwoFactorContent/* maskEmail */.o)(String(email)),
                handleOptionAction: function() {
                    setInitTimer(true);
                    setChannelSelected(2);
                    if (isRequesting) {
                        changeUniqueClientStep("verifyIdentity");
                        return;
                    }
                    sendTwoFactorToken({
                        channel: 2,
                        cpf: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf),
                        email: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email),
                        faType: typing/* FATypeValues.AccountValidateEMail2FA */.ZI.AccountValidateEMail2FA,
                        phoneNumber: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber)
                    });
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.EmailIcon, {}),
                isValid: true
            });
        }
        return methods;
    };
    var getUniqueClientValidationData = function() {
        var contentMap = new Map();
        contentMap.set("clientAction", "loginValidation");
        contentMap.set("email", String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email));
        contentMap.set("hasError", false);
        contentMap.set("isUnderAction", isRequesting);
        contentMap.set("onCallAction", function() {
            return handleCodeValidation({
                channel: channelSelected,
                faType: Number(faType),
                cpf: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf),
                email: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email),
                phoneNumber: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber),
                token: String(tokenCode)
            });
        });
        contentMap.set("phoneNumber", String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber));
        contentMap.set("sendCodeType", channelSelected === 1 ? "sms" : "email");
        contentMap.set("viewType", isClientMobile ? "component" : "modal");
        contentMap.set("handleSelectAnotherTwoFactorType", handleSelectAnotherTwoFactorType);
        contentMap.set("isVerifyIdentity", currentStep === "chooseAnotherMethod");
        contentMap.set("options", chooseMethods(String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber), String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email)));
        contentMap.set("verifyIdentityDescription", "Para continuar, escolha um modo para autenticar a sua identidade.");
        contentMap.set("optionsBackgroundColor", "".concat(ui.theme.colors.neutral.white));
        contentMap.set("hasDescriptionOnMobile", true);
        contentMap.set("verifyIdentityTitle", "Escolha como verificar sua identidade");
        contentMap.set("preventDefault", true);
        contentMap.set("canChooseAnotherTwoFactorMethod", canChooseAnotherMethod);
        contentMap.set("isMobile", isClientMobile);
        return contentMap;
    };
    return {
        getUniqueClientValidationData: getUniqueClientValidationData,
        isLoading: isLoading,
        shouldShowComponent: shouldShowComponent,
        sendTwoFactorToken: sendTwoFactorToken,
        handleCodeValidation: handleCodeValidation,
        handleSelectAnotherTwoFactorType: handleSelectAnotherTwoFactorType,
        setIsLoading: setIsLoading,
        currentStep: currentStep
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../packages/components/2fa/index.ts + 18 modules
var _2fa = __webpack_require__(83650);
;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientValidation/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 2rem;\n\n  @media ",
        " {\n    padding: ",
        " ",
        ";\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  width: 100%;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var UniqueClientValidationContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__UniqueClientValidationContainer",
    componentId: "sc-ad5a2cc5-0"
})(styles_templateObject(), ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x0, ui.theme.space.x4);
var SkeletonWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SkeletonWrapper",
    componentId: "sc-ad5a2cc5-1"
})(styles_templateObject1());

// EXTERNAL MODULE: ../../packages/components/Skeleton/index.tsx
var Skeleton = __webpack_require__(44860);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../packages/components/UniqueClient/components/UniqueClientFeedback/data.tsx
var UniqueClientFeedback_data = __webpack_require__(93082);
// EXTERNAL MODULE: ../../packages/components/UniqueClient/components/UniqueClientFeedback/ui.tsx
var UniqueClientFeedback_ui = __webpack_require__(58466);
;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientFeedback/index.tsx





var UniqueClientFeedback = function() {
    var register = (0,index_esm/* useForm */.cI)().register;
    var getUniqueClientFeedback = (0,UniqueClientFeedback_data/* useUniqueClientFeedbackData */.E)().getUniqueClientFeedback;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientFeedback_ui/* UniqueClientFeedbackUI */.v, (0,_object_spread/* default */.Z)({
        register: register
    }, getUniqueClientFeedback()));
};


;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientValidation/ui.tsx









var UniqueClientValidationUI = function(_param) {
    var isMobile = _param.isMobile, isLoading = _param.isLoading, shouldShowComponent = _param.shouldShowComponent, currentStep = _param.currentStep, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isMobile",
        "isLoading",
        "shouldShowComponent",
        "currentStep"
    ]);
    var ref;
    if (!shouldShowComponent) return null;
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
            count: 1,
            height: 100,
            width: "100vw"
        })
    });
    if (((ref = [
        "feedbackSuccess",
        "feedbackError"
    ]) === null || ref === void 0 ? void 0 : ref.includes(currentStep)) && !isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientValidationContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("unique-client-validation-container")), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientFeedback, {})
        }));
    }
    if (isMobile) {
        var ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientValidationContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("unique-client-validation-container")), {
            children: !((ref1 = [
                "feedbackSuccess",
                "feedbackError"
            ]) === null || ref1 === void 0 ? void 0 : ref1.includes(currentStep)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(_2fa.TwoFactorContent, (0,_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientFeedback, {})
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_2fa.TwoFactorContent, (0,_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientValidation/index.tsx





var UniqueClientValidation = function(param) {
    var clientInfo = param.clientInfo;
    var ref = useUniqueClientValidationData(clientInfo), getUniqueClientValidationData = ref.getUniqueClientValidationData, isLoading = ref.isLoading, shouldShowComponent = ref.shouldShowComponent, currentStep = ref.currentStep;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientValidationUI, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Object.fromEntries(getUniqueClientValidationData())), {
        isLoading: isLoading,
        shouldShowComponent: shouldShowComponent,
        currentStep: currentStep
    }));
};


;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientComponent/data.tsx

var useUniqueClientComponentData = function() {
    var currentStep = (0,state_manager/* useUniqueClient */.NG)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            currentStep: state.currentStep
        };
    })).currentStep;
    return {
        currentStep: currentStep
    };
};


;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientComponent/ui.tsx



var UniqueClientComponentUI = function(param) {
    var currentStep = param.currentStep, isMobile = param.isMobile;
    if ([
        "verifyIdentity",
        "chooseAnotherMethod",
        "feedbackError",
        "feedbackSuccess", 
    ].includes(currentStep) && !isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientValidation, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientModal, {});
};


;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/UniqueClientComponent/index.tsx



var UniqueClientComponent = function() {
    var currentStep = useUniqueClientComponentData().currentStep;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClientComponentUI, {
        currentStep: currentStep
    });
};


;// CONCATENATED MODULE: ../../packages/components/UniqueClient/components/index.ts






/***/ }),

/***/ 85486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useUniqueClientUtils; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50853);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(430);
/* harmony import */ var application_state_manager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74224);
/* harmony import */ var implementations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32202);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);






var useUniqueClientUtils = function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,application_state_manager__WEBPACK_IMPORTED_MODULE_1__/* .useUniqueClient */ .NG)((0,application_state_manager__WEBPACK_IMPORTED_MODULE_1__/* .useShallow */ .NL)(function(state) {
        return {
            changeUniqueClientStep: state.changeUniqueClientStep,
            uniqueClientInfo: state.uniqueClientInfo
        };
    })), changeUniqueClientStep = ref5.changeUniqueClientStep, uniqueClientInfo = ref5.uniqueClientInfo;
    var needsToValidateEmail = (uniqueClientInfo === null || uniqueClientInfo === void 0 ? void 0 : (ref = uniqueClientInfo.emailValidation) === null || ref === void 0 ? void 0 : ref.isSameInPhysicalStoreAndEcommerce) && !(uniqueClientInfo === null || uniqueClientInfo === void 0 ? void 0 : (ref1 = uniqueClientInfo.emailValidation) === null || ref1 === void 0 ? void 0 : ref1.isEmailVerified);
    var needsToValidatePhoneNumber = (uniqueClientInfo === null || uniqueClientInfo === void 0 ? void 0 : (ref2 = uniqueClientInfo.phoneNumberValidation) === null || ref2 === void 0 ? void 0 : ref2.isSameInPhysicalStoreAndEcommerce) && !(uniqueClientInfo === null || uniqueClientInfo === void 0 ? void 0 : (ref3 = uniqueClientInfo.phoneNumberValidation) === null || ref3 === void 0 ? void 0 : ref3.isPhoneNumberVerified);
    var ref6 = (0,application_state_manager__WEBPACK_IMPORTED_MODULE_1__/* .useTwoFactor */ .kD)((0,application_state_manager__WEBPACK_IMPORTED_MODULE_1__/* .useShallow */ .NL)(function(state) {
        return {
            setIsValidationActive: state.setIsValidationActive,
            setChannelSelected: state.setChannelSelected,
            setFaType: state.setFaType,
            setIsRequesting: state.setIsRequesting,
            setIsBlockedToSendCode: state.setIsBlockedToSendCode,
            setIsTokenCodeValid: state.setIsTokenCodeValid
        };
    })), setIsValidationActive = ref6.setIsValidationActive, setChannelSelected = ref6.setChannelSelected, setFaType = ref6.setFaType, setIsRequesting = ref6.setIsRequesting, setIsBlockedToSendCode = ref6.setIsBlockedToSendCode, setIsTokenCodeValid = ref6.setIsTokenCodeValid;
    var getTokens = (0,application__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .aCi)().getTokens;
    var accessToken = (ref4 = getTokens()) === null || ref4 === void 0 ? void 0 : ref4.token;
    var loggedClient = (0,application__WEBPACK_IMPORTED_MODULE_0__/* .useUser */ .aFb)().loggedClient;
    var addToast = (0,application__WEBPACK_IMPORTED_MODULE_0__/* .useToast */ .pmc)().addToast;
    var checkError = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(errorCode, errorMessage, isValid) {
        var ref;
        if (errorCode === "222" || ((ref = [
            "Tente novamente em 24 horas.",
            "Opera\xe7\xe3o bloqueada devido ao n\xfamero de tentativas excessivas na solicita\xe7\xe3o do c\xf3digo.", 
        ]) === null || ref === void 0 ? void 0 : ref.includes(String(errorMessage)))) {
            setIsBlockedToSendCode(true);
            setIsValidationActive(true);
            setIsTokenCodeValid(false);
            changeUniqueClientStep("verifyIdentity");
            return;
        }
        if (errorMessage === "Cliente n\xe3o encontrado") {
            addToast({
                isNewToast: true,
                newToastTheme: "dark",
                type: "error",
                title: "Erro ao enviar o c\xf3digo",
                description: "".concat(errorMessage),
                timerInMilliseconds: 3000
            });
            setIsBlockedToSendCode(false);
            setIsValidationActive(true);
            return;
        }
        if (!errorMessage && !isValid) {
            addToast({
                isNewToast: true,
                newToastTheme: "dark",
                type: "error",
                title: "Erro ao enviar o c\xf3digo",
                description: "Ocorreu um erro ao enviar o c\xf3digo de verifica\xe7\xe3o.",
                timerInMilliseconds: 3000
            });
        }
    }, [
        addToast,
        changeUniqueClientStep,
        setIsBlockedToSendCode,
        setIsTokenCodeValid,
        setIsValidationActive, 
    ]);
    var sendTwoFactorToken = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
            var channel, faType, cpf, email, phoneNumber, ref, ref1, ref2, ref3, ref4, ref5, ref6, storagedTime, actualTime, diffTime, ref7, ref8, ref9, data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        channel = param.channel, faType = param.faType, cpf = param.cpf, email = param.email, phoneNumber = param.phoneNumber;
                        setFaType(Number(faType));
                        setChannelSelected(channel);
                        setIsRequesting(true);
                        storagedTime = localStorage.getItem("timeSent_".concat(faType, "_").concat(channel));
                        actualTime = Date.now();
                        diffTime = Math.floor(Number(storagedTime) - Number(actualTime) / 1000);
                        if (diffTime && diffTime > 0 && storagedTime) {
                            setIsValidationActive(true);
                            setIsRequesting(false);
                            changeUniqueClientStep("verifyIdentity");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            implementations__WEBPACK_IMPORTED_MODULE_2__/* .notificationApi.sendTwoFactorCode */ .E8.sendTwoFactorCode({
                                channel: channel,
                                faType: faType,
                                cpf: (ref7 = String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf)) !== null && ref7 !== void 0 ? ref7 : cpf,
                                email: (ref8 = String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email)) !== null && ref8 !== void 0 ? ref8 : email,
                                phoneNumber: (ref9 = String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber)) !== null && ref9 !== void 0 ? ref9 : phoneNumber,
                                token: accessToken
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        checkError(data === null || data === void 0 ? void 0 : (ref = data.validationResult) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.errorCode, data === null || data === void 0 ? void 0 : (ref3 = data.validationResult) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.errors) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.errorMessage, data === null || data === void 0 ? void 0 : (ref6 = data.validationResult) === null || ref6 === void 0 ? void 0 : ref6.isValid);
                        setIsRequesting(false);
                        setIsValidationActive(true);
                        setIsBlockedToSendCode(false);
                        changeUniqueClientStep("verifyIdentity");
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setFaType,
        setChannelSelected,
        setIsRequesting,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber,
        accessToken,
        setIsValidationActive,
        setIsBlockedToSendCode,
        changeUniqueClientStep,
        checkError, 
    ]);
    return {
        sendTwoFactorToken: sendTwoFactorToken,
        needsToValidateEmail: needsToValidateEmail,
        needsToValidatePhoneNumber: needsToValidatePhoneNumber
    };
};



/***/ }),

/***/ 18272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ CustomBanner; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/components/Image/index.tsx
var Image = __webpack_require__(25926);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomBanner/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: 0 auto;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding: ",
        ";\n    cursor: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 1600px;\n      width: 100%;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        max-width: 1280px;\n        width: 100%;\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 94vw;\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n    ",
        "}\n\n  @media ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: auto 0;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-width: ",
        ";\n  width: 100%;\n\n  ",
        "\n\n  @media ",
        " {\n    max-width: 100%;\n  }\n\n  & > span {\n    position: unset !important;\n    height: 100% !important;\n    width: 100% !important;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          border-radius: ",
        " !important;\n          min-height: 340px !important;\n          max-height: 340px !important;\n          width: 100%;\n\n          object-fit: cover;\n          object-position: center;\n\n          @media ",
        " {\n            min-height: 220px !important;\n            max-height: 220px !important;\n          }\n\n          @media ",
        " {\n            min-height: 100%;\n            height: fit-content;\n            width: fit-content;\n            object-fit: contain;\n            object-position: 50% 50%;\n          }\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          height: auto !important;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative !important;\n  width: 100% !important;\n  border-radius: ",
        " !important;\n\n  ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var CustomCommonBannerContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__CustomCommonBannerContainer",
    componentId: "sc-8cd2b1ac-0"
})(_templateObject5(), function(param) {
    var isBannerComponent = param.isBannerComponent;
    return isBannerComponent && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
}, function(param) {
    var isToRedirect = param.isToRedirect;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), ui.theme.space.x0, isToRedirect ? "pointer" : "default");
}, function(param) {
    var format = param.format;
    return format === "extended" && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
}, function(param) {
    var format = param.format;
    return format === "default" && (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
}, ui.theme.device.desktopFirst.tablet, function(param) {
    var format = param.format;
    return format === "default" && (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
});
var CustomBannerImageWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__CustomBannerImageWrapper",
    componentId: "sc-8cd2b1ac-1"
})(_templateObject7(), function(param) {
    var format = param.format;
    return format === "extended" ? "1600px" : "1280px";
}, function(param) {
    var format = param.format;
    return format === "extended" && (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
}, ui.theme.device.desktopFirst.mobileXL);
var CustomBannerImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* Image */.E).withConfig({
    displayName: "style__CustomBannerImage",
    componentId: "sc-8cd2b1ac-2"
})(_templateObject10(), function(param) {
    var format = param.format;
    return format === "extended" ? ui.theme.space.x0 : ui.theme.space.x2;
}, function(param) {
    var isinsidecarousel = param.isinsidecarousel, isinsidecarouselingridformat = param.isinsidecarouselingridformat;
    return isinsidecarousel === "true" && isinsidecarouselingridformat === "false" ? (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), ui.theme.space.x0, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL) : (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
});

// EXTERNAL MODULE: ../../packages/components/backoffice/utils/index.tsx + 1 modules
var utils = __webpack_require__(60764);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomBanner/data.tsx

var customBannerData = function(properties) {
    var ref, ref1, ref2, ref3, ref4;
    var title = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var desktopImage = (ref1 = properties.find(function(param) {
        var key = param.key;
        return key === "desktopImage";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var mobileImage = (ref2 = properties.find(function(param) {
        var key = param.key;
        return key === "mobileImage";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var desktopFormat = (ref3 = properties.find(function(param) {
        var key = param.key;
        return key === "desktopFormat";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var mobileFormat = (ref4 = properties.find(function(param) {
        var key = param.key;
        return key === "mobileFormat";
    })) === null || ref4 === void 0 ? void 0 : ref4.value;
    return {
        title: title,
        desktopImage: desktopImage,
        mobileImage: mobileImage,
        desktopFormat: desktopFormat,
        mobileFormat: mobileFormat
    };
};
var handleComponentWarnings = function(config, currentPathName, position) {
    var ref;
    if (!(config === null || config === void 0 ? void 0 : (ref = config.branches) === null || ref === void 0 ? void 0 : ref.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('Um componente de Banner, localizado em "'.concat(currentPathName, '" na posi\xe7\xe3o ').concat(position, ", n\xe3o possui nenhuma configura\xe7\xe3o de branches."), "warning");
    }
};
var getBannerTypeValidation = function(isinsidecarousel, isinsidecarouselingridformat) {
    return isinsidecarousel ? "carousel" : isinsidecarouselingridformat ? "grid" : "banner";
};
var getImageFormat = function(isinsidecarouselingridformat, isinsidecarousel, isClientMobile, mobileFormat, desktopFormat) {
    return isinsidecarouselingridformat ? "default" : (isinsidecarousel ? "extended" : isClientMobile ? mobileFormat : desktopFormat) || "extended";
};


// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomBanner/index.tsx












var CustomBanner = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, config = param.config, position = param.position, _isClientMobile = param.isClientMobile, isClientMobile = _isClientMobile === void 0 ? false : _isClientMobile, _isinsidecarousel = param.isinsidecarousel, isinsidecarousel = _isinsidecarousel === void 0 ? false : _isinsidecarousel, _isinsidecarouselingridformat = param.isinsidecarouselingridformat, isinsidecarouselingridformat = _isinsidecarouselingridformat === void 0 ? false : _isinsidecarouselingridformat, _isBannerComponent = param.isBannerComponent, isBannerComponent = _isBannerComponent === void 0 ? true : _isBannerComponent, _preloadComponent = param.preloadComponent, preloadComponent = _preloadComponent === void 0 ? false : _preloadComponent;
    var ref = customBannerData(properties), title = ref.title, desktopImage = ref.desktopImage, mobileImage = ref.mobileImage, desktopFormat = ref.desktopFormat, mobileFormat = ref.mobileFormat;
    var linkConfig = (0,utils/* useGetBranchLinkConfig */._e)(config === null || config === void 0 ? void 0 : config.branches, "subComponentBanner");
    var currentPathName = (0,application/* useCurrentPathName */.Y0L)();
    handleComponentWarnings(config, currentPathName, position || -1);
    var format = getImageFormat(!!isinsidecarouselingridformat, !!isinsidecarousel, !!isClientMobile, mobileFormat, desktopFormat);
    var router = (0,next_router.useRouter)();
    var bannerTypeValidation = getBannerTypeValidation(!!isinsidecarousel, !!isinsidecarouselingridformat);
    var gtagPromotionId = "".concat(title, "_").concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url, "_").concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.id);
    var gtagSelectPromotion = function() {
        implementations/* gtag.selectPromotion */.SX.selectPromotion({
            locationId: router.asPath,
            promotionId: gtagPromotionId,
            promotionName: title,
            creativeName: bannerTypeValidation,
            creativeSlot: bannerTypeValidation
        });
    };
    var url = (0,utils/* useBackofficeComponentUrl */.Sb)(config === null || config === void 0 ? void 0 : config.branches, linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url);
    // const image = isClientMobile ? mobileImage || "" : desktopImage || "";
    var hasImage = mobileImage || desktopImage;
    var image = isClientMobile ? mobileImage || "" : desktopImage || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCommonBannerContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-banner-container")), {
        isToRedirect: !!linkConfig,
        as: format === "extended" ? "section" : ui.Container,
        format: format,
        onClick: function() {
            gtagSelectPromotion();
        },
        isBannerComponent: isBannerComponent,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBannerImageWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-banner-image-wrapper")), {
            as: (linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url) ? Link/* Link */.r : "section",
            href: url,
            target: linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.target,
            format: format,
            children: hasImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBannerImage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-banner-image")), {
                src: image,
                alt: title,
                layout: "fill",
                objectFit: isClientMobile ? "contain" : "cover",
                objectPosition: "center",
                isinsidecarousel: String(isinsidecarousel),
                isinsidecarouselingridformat: String(isinsidecarouselingridformat),
                format: format,
                loading: "eager",
                priority: preloadComponent
            }))
        }))
    }));
});
CustomBanner.displayName = "CustomBanner";



/***/ }),

/***/ 18356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ CustomCardCTA; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCardCTA/data.ts
var customCardCTAData = function(properties) {
    var ref;
    var layout = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "layout";
    })) === null || ref === void 0 ? void 0 : ref.value;
    return {
        layout: layout
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/Image/index.tsx
var Image = __webpack_require__(25926);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCardCTA/SubComponents/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        ", ",
        " {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n\n  @media ",
        " {\n    padding: ",
        ";\n    display: flex;\n    flex-direction: column;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: ",
        " ",
        " ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          text-align: center;\n          height: 215px;\n          display: flex;\n          align-items: center;\n\n          @media ",
        " {\n            text-align: start;\n            display: block;\n            height: 100%;\n          }\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-color: ",
        ";\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-color: ",
        ";\n        "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 166px;\n  height: 42px;\n\n  ",
        "\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  margin-right: ",
        ";\n  word-break: break-all;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > path {\n    width: 18px;\n    height: 18px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        color: ",
        " !important;\n        background-color: ",
        ";\n      "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  box-shadow: 0 2px 4px ",
        ";\n  border-radius: ",
        ";\n  background-color: ",
        ";\n\n  @media ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}



var CardCTASubComponentImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CardCTASubComponentImage",
    componentId: "sc-3a0bd171-0"
})(_templateObject());
var HeaderTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__HeaderTitle",
    componentId: "sc-3a0bd171-1"
})(_templateObject1(), ui.theme.typography.fontSize.sm.x7);
var HeaderSubTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__HeaderSubTitle",
    componentId: "sc-3a0bd171-2"
})(_templateObject2(), ui.theme.space.x2, ui.theme.typography.fontSize.md.x3, ui.theme.typography.fontWeight[400], ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.sm.x9);
var ComponentHeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ComponentHeaderContainer",
    componentId: "sc-3a0bd171-3"
})(_templateObject4(), ui.theme.space.x4, ui.theme.device.desktopFirst.tablet, ui.theme.space.x0, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), HeaderSubTitle, HeaderTitle, "".concat(ui.theme.colors.neutral.white, " !important"));
});
var CardCTASubComponentContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CardCTASubComponentContent",
    componentId: "sc-3a0bd171-4"
})(_templateObject6(), ui.theme.space.x2, ui.theme.space.x4, ui.theme.space.x6, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), "".concat(ui.theme.colors.blackFriday[125], " !important"));
});
var CardCTASubComponentDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CardCTASubComponentDescription",
    componentId: "sc-3a0bd171-5"
})(_templateObject8(), function(param) {
    var textAlignCenter = param.textAlignCenter;
    return textAlignCenter ? (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), ui.theme.device.desktopFirst.tablet) : "";
});
var CardCTAImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* Image */.E).withConfig({
    displayName: "styles__CardCTAImage",
    componentId: "sc-3a0bd171-6"
})(_templateObject9());
var CustomCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CustomCta",
    componentId: "sc-3a0bd171-7"
})(_templateObject12(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), "".concat(ui.theme.colors.secondary[385], " !important")) : (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), function(param) {
        var backgroundColor = param.backgroundColor;
        return backgroundColor;
    });
}, ui.theme.space.x4, ui.theme.space.x1);
var CtaText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__CtaText",
    componentId: "sc-3a0bd171-8"
})(_templateObject13(), ui.theme.typography.fontSize.sm.x7, ui.theme.colors.neutral.white, ui.theme.space.x1);
var CardCTASubComponentText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CardCTASubComponentText",
    componentId: "sc-3a0bd171-9"
})(_templateObject14());
var ArrowRightIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowRight).withConfig({
    displayName: "styles__ArrowRightIcon",
    componentId: "sc-3a0bd171-10"
})(_templateObject15());
var CardCTAText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CardCTAText",
    componentId: "sc-3a0bd171-11"
})(_templateObject16());
var CustomCardCTASubComponentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CustomCardCTASubComponentContainer",
    componentId: "sc-3a0bd171-12"
})(_templateObject19(), ui.theme.colors.neutral["999-opacity-10"], ui.theme.space.x2, ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.tablet, ui.theme.space["x0.5"], function(param) {
    var isBlackTheme = param.isBlackTheme;
    var ref, ref1;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject17(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["125"]);
}, CardCTAText, function(param) {
    var isBlackTheme = param.isBlackTheme;
    var ref, ref1;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject18(), ui.theme.colors.blackFriday.white, ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["125"]);
});

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCardCTA/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        " {\n            flex-direction: row-reverse;\n\n            @media ",
        " {\n              flex-direction: column;\n            }\n          }\n\n          ",
        " {\n            height: 350px;\n\n            @media ",
        " {\n              height: 379px;\n            }\n\n            @media ",
        " {\n              height: 183px;\n            }\n            ",
        " {\n              border-radius: 0 ",
        " ",
        " 0;\n\n              @media ",
        " {\n                border-radius: ",
        " ",
        " 0 0;\n              }\n            }\n          }\n\n          ",
        " {\n            @media ",
        " {\n              padding: ",
        " !important;\n            }\n          }\n\n          ",
        " {\n            font-size: ",
        ";\n\n            @media ",
        " {\n              font-size: ",
        ";\n            }\n            @media ",
        " {\n              font-size: 1.8rem;\n            }\n          }\n\n          ",
        " {\n            border-radius: 0 ",
        " ",
        " 0;\n\n            @media ",
        " {\n              border-radius: ",
        " ",
        " 0 0;\n            }\n          }\n\n          ",
        " {\n            margin-top: 15px;\n            @media ",
        " {\n              margin-top: ",
        ";\n            }\n          }\n\n          ",
        " {\n            font-size: ",
        ";\n\n            @media ",
        " {\n              font-size: ",
        ";\n            }\n          }\n\n          ",
        " {\n            padding: ",
        ";\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            height: 350px;\n            border-radius: ",
        ";\n\n            @media ",
        " {\n              padding: ",
        " ",
        " ",
        "\n                ",
        ";\n              height: 100%;\n            }\n\n            @media ",
        " {\n              padding: ",
        " ",
        " ",
        ";\n            }\n          }\n        "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          @media ",
        " {\n            gap: ",
        ";\n            justify-content: center;\n          }\n\n          @media ",
        " {\n            flex-direction: column;\n            gap: ",
        ";\n            margin-bottom: 3.175rem;\n          }\n\n          ",
        " {\n            max-width: 628px;\n\n            @media ",
        " {\n              max-width: 328px;\n            }\n\n            @media ",
        " {\n              max-width: 448px;\n            }\n          }\n\n          ",
        " {\n            height: 350px;\n            @media ",
        " {\n              height: 183px;\n            }\n            ",
        " {\n              border-radius: ",
        " ",
        " 0 0;\n            }\n          }\n\n          ",
        " {\n            display: none;\n          }\n\n          ",
        " {\n            padding: ",
        " ",
        " ",
        ";\n            margin-top: ",
        ";\n            border-radius: ",
        ";\n\n            @media ",
        " {\n              padding: ",
        " ",
        " ",
        ";\n              margin-top: ",
        ";\n            }\n          }\n          ",
        " {\n            height: 100%;\n            text-align: start;\n            font-size: ",
        ";\n          }\n        "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                ",
        " {\n                  background-color: ",
        ";\n                }\n              "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              background-color: ",
        ";\n              color: ",
        ";\n              ",
        "\n            "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          .slick-track {\n            display: flex;\n            gap: ",
        ";\n          }\n\n          @media ",
        " {\n            margin-bottom: 3.175rem;\n          }\n\n          ",
        " {\n            height: 234px;\n\n            @media ",
        " {\n              height: 379px;\n            }\n\n            @media ",
        " {\n              height: 183px;\n            }\n            ",
        " {\n              border-radius: ",
        " ",
        " 0 0;\n            }\n          }\n\n          ",
        " {\n            height: 234px;\n\n            @media ",
        " {\n              height: 379px;\n            }\n            @media ",
        " {\n              height: 183px;\n            }\n          }\n\n          ",
        " {\n            max-width: 415px;\n            ",
        "\n\n            @media ",
        " {\n              max-width: 737px;\n            }\n\n            @media ",
        " {\n              max-width: 448px;\n            }\n          }\n\n          ",
        " {\n            display: none;\n          }\n\n          @media ",
        " {\n            display: block;\n          }\n\n          ",
        " {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            margin-top: ",
        ";\n            border-radius: ",
        ";\n            @media ",
        " {\n              margin-top: 0;\n              padding: ",
        " ",
        " ",
        "\n                ",
        ";\n            }\n\n            @media ",
        " {\n              padding: ",
        " ",
        "",
        ";\n              margin-top: ",
        ";\n            }\n          }\n\n          ",
        " {\n            @media ",
        " {\n              margin-top: ",
        ";\n            }\n            @media ",
        " {\n              margin-top: ",
        ";\n            }\n          }\n\n          ",
        " {\n            text-align: start;\n\n            font-size: ",
        ";\n\n            @media ",
        " {\n              font-size: ",
        ";\n            }\n\n            @media ",
        " {\n              font-size: ",
        ";\n            }\n          }\n        "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  justify-content: center;\n  max-width: 1280px;\n  margin: 0 auto;\n  width: 100%;\n\n  @media ",
        " {\n    padding: ",
        " ",
        ";\n    gap: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n      \n      ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1280px;\n  width: 100%;\n\n  @media ",
        " {\n    margin-bottom: ",
        ";\n    padding: ",
        " ",
        ";\n  }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var CustomCardCTAContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CustomCardCTAContainer",
    componentId: "sc-4ce068f1-0"
})(styles_templateObject5(), ui.theme.space["x4.5"], ui.theme.device.desktopFirst.tablet, ui.theme.space.x2, ui.theme.space.x4, ui.theme.space.x0, function(param) {
    var isOneCard = param.isOneCard;
    return isOneCard ? (0,styled_components_browser_esm/* css */.iv)(styles_templateObject(), CustomCardCTASubComponentContainer, ui.theme.device.desktopFirst.tablet, CardCTASubComponentImage, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL, CardCTAImage, ui.theme.space.x3, ui.theme.space.x3, ui.theme.device.desktopFirst.tablet, ui.theme.space.x2, ui.theme.space.x2, ComponentHeaderContainer, ui.theme.device.desktopFirst.tablet, ui.theme.space.x0, HeaderTitle, ui.theme.typography.fontSize.lg.x4, ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.md.x3, ui.theme.device.desktopFirst.mobileXL, CardCTAImage, ui.theme.space.x3, ui.theme.space.x3, ui.theme.device.desktopFirst.tablet, ui.theme.space.x2, ui.theme.space.x2, CustomCta, ui.theme.device.desktopFirst.tablet, ui.theme.space.x8, CardCTASubComponentDescription, ui.theme.typography.fontSize.sm.x7, ui.theme.device.desktopFirst.mobileM, ui.theme.typography.fontSize.sm.x5, CardCTASubComponentContent, ui.theme.space.x10, ui.theme.space.x2, ui.theme.device.desktopFirst.tablet, ui.theme.space.x8, ui.theme.space.x8, ui.theme.space.x8, ui.theme.space.x6, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x6, ui.theme.space.x8, ui.theme.space.x8) : "";
}, function(param) {
    var isTwoCards = param.isTwoCards;
    return isTwoCards ? (0,styled_components_browser_esm/* css */.iv)(styles_templateObject1(), ui.theme.device.desktopFirst.tablet, ui.theme.space.x2, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x0, CustomCardCTASubComponentContainer, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL, CardCTASubComponentImage, ui.theme.device.desktopFirst.tablet, CardCTAImage, ui.theme.space.x2, ui.theme.space.x2, HeaderSubTitle, CardCTASubComponentContent, ui.theme.space.x4, ui.theme.space.x6, ui.theme.space.x6, ui.theme.space.x2, ui.theme.space.x2, ui.theme.device.desktopFirst.tablet, ui.theme.space.x2, ui.theme.space.x4, ui.theme.space.x6, ui.theme.space.x4, CardCTASubComponentDescription, ui.theme.typography.fontSize.sm.x5) : "";
}, function(param) {
    var isThreeCards = param.isThreeCards, customTheme = param.customTheme;
    var ref, ref1, ref2, ref3, ref4, ref5;
    return isThreeCards ? (0,styled_components_browser_esm/* css */.iv)(styles_templateObject4(), ui.theme.space.x2, ui.theme.device.desktopFirst.tablet, CardCTASubComponentImage, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL, CardCTAImage, ui.theme.space.x2, ui.theme.space.x2, CardCTAImage, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL, CustomCardCTASubComponentContainer, customTheme && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject3(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["175"], ui.theme === null || ui.theme === void 0 ? void 0 : (ref2 = ui.theme.colors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.blackFriday) === null || ref3 === void 0 ? void 0 : ref3.white, customTheme && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject2(), CustomCta, ui.theme === null || ui.theme === void 0 ? void 0 : (ref4 = ui.theme.colors) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.secondary) === null || ref5 === void 0 ? void 0 : ref5["385"])), ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL, HeaderSubTitle, ui.theme.device.desktopFirst.tablet, CardCTASubComponentContent, ui.theme.space.x4, ui.theme.space.x2, ui.theme.device.desktopFirst.tablet, ui.theme.space.x8, ui.theme.space.x8, ui.theme.space.x8, ui.theme.space.x6, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x2, ui.theme.space.x4, ui.theme.space.x2, ui.theme.space.x4, CustomCta, ui.theme.device.desktopFirst.tablet, ui.theme.space.x8, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x4, CardCTASubComponentDescription, ui.theme.typography.fontSize.sm.x5, ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.sm.x7, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x5) : "";
});
var CustomCardCTAContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CustomCardCTAContent",
    componentId: "sc-4ce068f1-1"
})(styles_templateObject6(), ui.theme.device.desktopFirst.tablet, ui.theme.space.x4, ui.theme.space.x0, ui.theme.space.x2);

// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCardCTA/SubComponents/data.ts
var customCardCTASubComponentData = function(properties) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var showTitle = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "showTitle";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var showSubTitle = (ref1 = properties.find(function(param) {
        var key = param.key;
        return key === "showSubTitle";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var subTitle = (ref2 = properties.find(function(param) {
        var key = param.key;
        return key === "subTitle";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var title = (ref3 = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var text = (ref4 = properties.find(function(param) {
        var key = param.key;
        return key === "text";
    })) === null || ref4 === void 0 ? void 0 : ref4.value;
    var showCta = (ref5 = properties.find(function(param) {
        var key = param.key;
        return key === "showCta";
    })) === null || ref5 === void 0 ? void 0 : ref5.value;
    var ctaText = (ref6 = properties.find(function(param) {
        var key = param.key;
        return key === "ctaText";
    })) === null || ref6 === void 0 ? void 0 : ref6.value;
    var color = (ref7 = properties.find(function(param) {
        var key = param.key;
        return key === "color";
    })) === null || ref7 === void 0 ? void 0 : ref7.value;
    var image = (ref8 = properties.find(function(param) {
        var key = param.key;
        return key === "image";
    })) === null || ref8 === void 0 ? void 0 : ref8.value;
    return {
        showCta: showCta,
        showTitle: showTitle,
        title: title,
        text: text,
        ctaText: ctaText,
        color: color,
        image: image,
        showSubTitle: showSubTitle,
        subTitle: subTitle
    };
};


// EXTERNAL MODULE: ../../packages/components/backoffice/utils/index.tsx + 1 modules
var utils = __webpack_require__(60764);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCardCTA/SubComponents/SubComponentHeader/index.tsx





var SubComponentHeader = function(param) {
    var showTitle = param.showTitle, showSubTitle = param.showSubTitle, title = param.title, subTitle = param.subTitle, isBlackTheme = param.isBlackTheme;
    var hasOnlySubTitle = (!showTitle || showTitle === "false") && showSubTitle && showSubTitle === "true";
    var hasOnlyTitle = (!showSubTitle || showSubTitle === "false") && showTitle && showTitle === "true";
    var hasTitleAndSubtitle = showSubTitle && showSubTitle === "true" && showTitle && showTitle === "true";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentHeaderContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isBlackTheme: isBlackTheme
    }, (0,application/* buildTestIds */.Fek)("card-cta-header-container")), {
        children: hasOnlySubTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSubTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("card-cta-subtitle")), {
            children: subTitle
        })) : hasOnlyTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("card-cta-title")), {
            children: title
        })) : hasTitleAndSubtitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("card-cta-title")), {
                    children: title
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSubTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("card-cta-subtitle")), {
                    children: subTitle
                }))
            ]
        }) : null
    }));
};
/* harmony default export */ var SubComponents_SubComponentHeader = (SubComponentHeader);

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCardCTA/SubComponents/index.tsx












var CustomCardCTASubComponent = function(param) {
    var config = param.config, properties = param.properties, isClientTablet = param.isClientTablet, positionComponent = param.positionComponent, isBlackTheme = param.isBlackTheme;
    var ref;
    var linkConfig = (0,utils/* useGetBranchLinkConfig */._e)(config === null || config === void 0 ? void 0 : config.branches, "subComponentCardCTA");
    var currentPathName = (0,application/* useCurrentPathName */.Y0L)();
    if (!(config === null || config === void 0 ? void 0 : (ref = config.branches) === null || ref === void 0 ? void 0 : ref.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Um subComponente de Card CTA, localizado em ".concat(currentPathName, " na posi\xe7\xe3o ").concat(positionComponent, ", n\xe3o possui nenhuma configura\xe7\xe3o de branches."), "warning");
    }
    var ref1 = customCardCTASubComponentData(properties), image = ref1.image, showCta = ref1.showCta, showTitle = ref1.showTitle, ctaText = ref1.ctaText, title = ref1.title, color = ref1.color, showSubTitle = ref1.showSubTitle, text = ref1.text, subTitle = ref1.subTitle;
    var withoutTitleAndSubTitle = (!showTitle || showTitle === "false") && (!showSubTitle || showSubTitle === "false");
    var hasCta = showCta && showCta === "true";
    var renderCardCTAText = (0,react.useCallback)(function() {
        return text && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCTAText, (0,_object_spread/* default */.Z)({
            dangerouslySetInnerHTML: {
                __html: text
            }
        }, (0,application/* buildTestIds */.Fek)("card-cta-description-text")));
    }, [
        text
    ]);
    var url = (0,utils/* useBackofficeComponentUrl */.Sb)(config === null || config === void 0 ? void 0 : config.branches, linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomCardCTASubComponentContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isBlackTheme: isBlackTheme
    }, (0,application/* buildTestIds */.Fek)("custom-card-cta-subcomponent-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCTASubComponentImage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("card-cta-subcomponent-image")), {
                children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCTAImage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("card-cta-image")), {
                    layout: "fill",
                    src: image,
                    alt: "Imagem do Produto",
                    loading: "lazy"
                }))
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardCTASubComponentContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                isBlackTheme: isBlackTheme
            }, (0,application/* buildTestIds */.Fek)("card-cta-subcomponent-content")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCTASubComponentText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-card-cta-text-wrapper")), {
                        children: isClientTablet ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardCTASubComponentDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("card-cta-description-container")), {
                            textAlignCenter: false,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubComponents_SubComponentHeader, {
                                    showTitle: showTitle,
                                    showSubTitle: showSubTitle,
                                    title: title !== null && title !== void 0 ? title : "",
                                    subTitle: subTitle !== null && subTitle !== void 0 ? subTitle : "",
                                    isBlackTheme: isBlackTheme
                                }),
                                renderCardCTAText()
                            ]
                        })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardCTASubComponentDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            textAlignCenter: withoutTitleAndSubTitle
                        }, (0,application/* buildTestIds */.Fek)("card-cta-description-container")), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubComponents_SubComponentHeader, {
                                    showTitle: showTitle,
                                    showSubTitle: showSubTitle,
                                    title: title !== null && title !== void 0 ? title : "",
                                    subTitle: subTitle !== null && subTitle !== void 0 ? subTitle : "",
                                    isBlackTheme: isBlackTheme
                                }),
                                renderCardCTAText()
                            ]
                        }))
                    })),
                    hasCta && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomCta, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        isBlackTheme: isBlackTheme,
                        as: (linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url) ? Link/* Link */.r : "div",
                        backgroundColor: color,
                        href: url,
                        target: linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.target
                    }, (0,application/* buildTestIds */.Fek)("cta-of-card-cta-component")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("cta-text-of-card-cta-component")), {
                                children: ctaText
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon, {
                                color: ui.theme.colors.neutral[55]
                            })
                        ]
                    }))
                ]
            }))
        ]
    }));
};
/* harmony default export */ var SubComponents = (CustomCardCTASubComponent);

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCardCTA/CardCTASlider/styles.ts

function CardCTASlider_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CardCTASlider_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CustomCardCTAWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CustomCardCTAWrapper",
    componentId: "sc-11ae27c7-0"
})(CardCTASlider_styles_templateObject());

// EXTERNAL MODULE: ../../packages/components/Slider/index.tsx + 3 modules
var Slider = __webpack_require__(75926);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCardCTA/CardCTASlider/index.tsx









var CardCTASlider = /*#__PURE__*/ (0,react.memo)(function(param) {
    var subComponents = param.subComponents, positionComponent = param.positionComponent;
    var ref = (0,application/* useAppContext */.bp4)(), isClientMobile = ref.isClientMobile, isClientTablet = ref.isClientTablet;
    var ref1 = (0,react.useState)(isClientTablet || isClientMobile ? 1 : 3), slidesToShow = ref1[0], setSlidesToShow = ref1[1];
    var ref2 = (0,react.useState)(isClientTablet || isClientMobile ? 1 : 3), slidesToScroll = ref2[0], setSlidesToScroll = ref2[1];
    (0,react.useEffect)(function() {
        setSlidesToShow(isClientTablet || isClientMobile ? 1 : 3);
        setSlidesToScroll(isClientTablet || isClientMobile ? 1 : 3);
    }, [
        isClientTablet,
        isClientMobile
    ]);
    var settings = {
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        touchMove: true,
        swipe: true,
        dots: true,
        autoplay: true,
        infinite: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
        children: subComponents === null || subComponents === void 0 ? void 0 : subComponents.map(function(subComponent) {
            return /*#__PURE__*/ (0,react.createElement)(CustomCardCTAWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-card-cta-slider-wrapper")), {
                key: "".concat(subComponent)
            }), /*#__PURE__*/ (0,jsx_runtime.jsx)(SubComponents, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, subComponent), {
                positionComponent: positionComponent
            })));
        })
    }));
});
CardCTASlider.displayName = "CardCTASlider";
/* harmony default export */ var CustomCardCTA_CardCTASlider = (CardCTASlider);

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCardCTA/index.tsx










var CustomCardCTA = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, subComponents = param.subComponents, isClientTablet = param.isClientTablet, position = param.position, isBlackTheme = param.isBlackTheme;
    var layout = customCardCTAData(properties).layout;
    var arraySubComponents = (0,_to_consumable_array/* default */.Z)(subComponents);
    arraySubComponents = subComponents.slice(0, layout === "1 card" ? 1 : layout === "2 cards" ? 2 : 3);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCardCTAContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isOneCard: layout === "1 card",
        isTwoCards: layout === "2 cards",
        isThreeCards: layout === "3 cards"
    }, (0,application/* buildTestIds */.Fek)("custom-card-cta-container")), {
        customTheme: isBlackTheme,
        children: isClientTablet && layout === "3 cards" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCardCTA_CardCTASlider, {
            positionComponent: position,
            subComponents: subComponents
        }) : arraySubComponents === null || arraySubComponents === void 0 ? void 0 : arraySubComponents.map(function(subComponent, index) {
            var componentKey = "".concat(subComponent.type, "#").concat(index);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCardCTAContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-card-cta-content")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubComponents, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, subComponent), {
                    isBlackTheme: isBlackTheme,
                    positionComponent: position
                }))
            }), componentKey);
        })
    }));
});
CustomCardCTA.displayName = "customCardCTA";



/***/ }),

/***/ 46963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ CustomCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCarousel/data.tsx


var getBlackFridayCustomCarouselTheme = function(isBlackFriday) {
    return isBlackFriday ? {
        key: "blackFridayTheme",
        value: JSON.stringify(ui.blackFridayCarouselTheme)
    } : undefined;
};
var customCarouselData = function(properties, isBlackFriday) {
    var ref, ref1;
    var format = (ref = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "format";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var slide = (ref1 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "automaticSlide";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var blackFridayTheme = getBlackFridayCustomCarouselTheme(isBlackFriday);
    var carouselBlackFridayTheme = (0,application/* getComponentTheme */.sul)(blackFridayTheme);
    return {
        format: format,
        slide: slide,
        carouselBlackFridayTheme: carouselBlackFridayTheme
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomBanner/index.tsx + 2 modules
var CustomBanner = __webpack_require__(18272);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomProduct/index.tsx + 3 modules
var CustomProduct = __webpack_require__(78400);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCarousel/SubComponent/data.tsx
var customCarouselSubComponentData = function(properties) {
    var ref;
    var bannerType = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "bannerType";
    })) === null || ref === void 0 ? void 0 : ref.value;
    return {
        bannerType: bannerType
    };
};


;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCarousel/SubComponent/index.tsx









var CarouselSubComponent = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var properties = _param.properties, _isinsidecarouselingridformat = _param.isinsidecarouselingridformat, isinsidecarouselingridformat = _isinsidecarouselingridformat === void 0 ? false : _isinsidecarouselingridformat, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "properties",
        "isinsidecarouselingridformat"
    ]);
    var bannerType = customCarouselSubComponentData(properties).bannerType;
    if (!bannerType) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('Um item de um carrosel n\xe3o tem um tipo definido. Desse modo, o tipo "banner" ser\xe1 assumido', "warning");
        bannerType = "banner";
    }
    var componentProps = (0,_object_spread/* default */.Z)({
        properties: properties
    }, restProps);
    if (bannerType === "banner") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBanner/* CustomBanner */.b, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, componentProps), {
            isBannerComponent: false,
            isinsidecarousel: true,
            isinsidecarouselingridformat: isinsidecarouselingridformat
        }));
    }
    if (bannerType === "dynamicBanner") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProduct/* CustomProduct */.l, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, componentProps), {
            isinsidecarousel: true
        }));
    }
    return null;
});
CarouselSubComponent.displayName = "CarouselSubComponent";


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCarousel/Extended/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .slick-disabled {\n        background: ",
        ";\n        opacity: 1;\n        visibility: visible;\n\n        &:hover {\n          background: ",
        ";\n        }\n        cursor: default;\n\n        path {\n          stroke: ",
        ";\n        }\n\n        &:hover path {\n          stroke: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1600px;\n  margin: 0 auto;\n  width: 100%;\n\n  @media ",
        " {\n    margin: 0;\n    max-width: none;\n  }\n\n  .slick-prev,\n  .slick-next {\n    margin-top: 2rem;\n  }\n\n  .slick-prev {\n    margin-left: 3.5rem !important;\n  }\n\n  .slick-next {\n    margin-right: 3.5rem !important;\n  }\n\n  ",
        "\n\n  .slick-dots {\n    @media ",
        " {\n      bottom: -16px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CustomExtendedCarousel = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CustomExtendedCarousel",
    componentId: "sc-3f1fa060-0"
})(_templateObject1(), ui.theme.device.desktopFirst.laptopXL, function(param) {
    var customTheme = param.customTheme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), customTheme === null || customTheme === void 0 ? void 0 : (ref = customTheme.sliderButton) === null || ref === void 0 ? void 0 : (ref1 = ref.backgroundColor) === null || ref1 === void 0 ? void 0 : ref1.disabled, customTheme === null || customTheme === void 0 ? void 0 : (ref2 = customTheme.sliderButton) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.backgroundColor) === null || ref3 === void 0 ? void 0 : ref3.disabled, customTheme === null || customTheme === void 0 ? void 0 : (ref4 = customTheme.sliderButton) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.arrowColor) === null || ref5 === void 0 ? void 0 : ref5.disabled, customTheme === null || customTheme === void 0 ? void 0 : (ref6 = customTheme.sliderButton) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.arrowColor) === null || ref7 === void 0 ? void 0 : ref7.disabled);
}, ui.theme.device.desktopFirst.mobileXL);

// EXTERNAL MODULE: ../../packages/components/Slider/index.tsx + 3 modules
var Slider = __webpack_require__(75926);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCarousel/Extended/index.tsx









var ExtendedCarousel = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var subComponents = _param.subComponents, isClientLaptop = _param.isClientLaptop, automaticSlide = _param.automaticSlide, carouselTheme = _param.carouselTheme, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "subComponents",
        "isClientLaptop",
        "automaticSlide",
        "carouselTheme"
    ]);
    var ref = (0,react.useState)(false), autoPlay = ref[0], setAutoPlay = ref[1];
    (0,react.useEffect)(function() {
        if (automaticSlide === "true") {
            setAutoPlay(true);
        } else {
            setAutoPlay(false);
        }
    }, [
        automaticSlide
    ]);
    var settings = {
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchMove: true,
        swipe: true,
        dots: true,
        autoplay: autoPlay,
        infinite: true,
        arrowsIsActive: !isClientLaptop
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomExtendedCarousel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-extended-carousel")), {
        customTheme: carouselTheme,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            customTheme: carouselTheme === null || carouselTheme === void 0 ? void 0 : carouselTheme.sliderButton
        }, settings), {
            children: subComponents === null || subComponents === void 0 ? void 0 : subComponents.map(function(subComponent, index) {
                var subComponentKey = "".concat(subComponent === null || subComponent === void 0 ? void 0 : subComponent.type, "#").concat(index);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselSubComponent, (0,_object_spread/* default */.Z)({
                    position: index + 1
                }, subComponent, restProps), subComponentKey);
            })
        }))
    }));
});
ExtendedCarousel.displayName = "ExtendedCarousel";


;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCarousel/Grid/style.ts

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .slick-disabled {\n        background: ",
        ";\n        opacity: 1;\n        visibility: visible;\n\n        &:hover {\n          background: ",
        ";\n        }\n        cursor: default;\n\n        path {\n          stroke: ",
        ";\n        }\n\n        &:hover path {\n          stroke: ",
        ";\n        }\n      }\n    "
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1300px;\n  margin: auto;\n  width: 100%;\n\n  .slick-list {\n    max-width: 1300px;\n    width: 100%;\n  }\n\n  .slick-track {\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n  }\n\n  ",
        "\n\n  @media ",
        " {\n    .slick-track {\n      display: block;\n    }\n  }\n"
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CustomGridCarousel = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__CustomGridCarousel",
    componentId: "sc-55593f52-0"
})(style_templateObject1(), function(param) {
    var customTheme = param.customTheme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return customTheme && (0,styled_components_browser_esm/* css */.iv)(style_templateObject(), customTheme === null || customTheme === void 0 ? void 0 : (ref = customTheme.sliderButton) === null || ref === void 0 ? void 0 : (ref1 = ref.backgroundColor) === null || ref1 === void 0 ? void 0 : ref1.disabled, customTheme === null || customTheme === void 0 ? void 0 : (ref2 = customTheme.sliderButton) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.backgroundColor) === null || ref3 === void 0 ? void 0 : ref3.disabled, customTheme === null || customTheme === void 0 ? void 0 : (ref4 = customTheme.sliderButton) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.arrowColor) === null || ref5 === void 0 ? void 0 : ref5.disabled, customTheme === null || customTheme === void 0 ? void 0 : (ref6 = customTheme.sliderButton) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.arrowColor) === null || ref7 === void 0 ? void 0 : ref7.disabled);
}, ui.theme.device.desktopFirst.tablet);

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCarousel/Grid/index.tsx








var GridCarousel = /*#__PURE__*/ (0,react.memo)(function(param) {
    var subComponents = param.subComponents, isClientMobile = param.isClientMobile, isClientTablet = param.isClientTablet, automaticSlide = param.automaticSlide, carouselTheme = param.carouselTheme, preloadComponent = param.preloadComponent;
    var slidesQuantity = isClientTablet ? 1 : 3;
    var ref = (0,react.useState)(slidesQuantity), slidesToShow = ref[0], setSlidesToShow = ref[1];
    var ref1 = (0,react.useState)(slidesQuantity), slidesToScroll = ref1[0], setSlidesToScroll = ref1[1];
    var ref2 = (0,react.useState)(false), autoPlay = ref2[0], setAutoPlay = ref2[1];
    (0,react.useEffect)(function() {
        if (automaticSlide === "true") {
            setAutoPlay(true);
        } else {
            setAutoPlay(false);
        }
    }, [
        automaticSlide
    ]);
    (0,react.useEffect)(function() {
        setSlidesToShow(slidesQuantity);
        setSlidesToScroll(slidesQuantity);
    }, [
        isClientTablet,
        slidesQuantity
    ]);
    var settings = {
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        arrowsIsActive: !isClientMobile && !isClientTablet && (subComponents === null || subComponents === void 0 ? void 0 : subComponents.length) > 3,
        arrowNextIsInCenter: true,
        arrowPrevIsInCenter: true,
        touchMove: true,
        swipe: true,
        dots: true,
        autoplay: autoPlay,
        infinite: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomGridCarousel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-carousel")), {
        customTheme: carouselTheme,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            customTheme: carouselTheme === null || carouselTheme === void 0 ? void 0 : carouselTheme.sliderButton
        }, settings), {
            children: subComponents === null || subComponents === void 0 ? void 0 : subComponents.map(function(subComponent, index) {
                var subComponentKey = "".concat(subComponent === null || subComponent === void 0 ? void 0 : subComponent.type, "#").concat(index);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselSubComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, subComponent), {
                    isinsidecarouselingridformat: true,
                    isClientMobile: isClientMobile,
                    isClientTablet: isClientTablet,
                    position: index + 1,
                    preloadComponent: preloadComponent
                }), subComponentKey);
            })
        }))
    }));
});
GridCarousel.displayName = "GridCarousel";


;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCarousel/index.tsx









var CustomCarousel = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, position = param.position, subComponents = param.subComponents, isClientMobile = param.isClientMobile, isClientTablet = param.isClientTablet, isClientLaptop = param.isClientLaptop, isBlackTheme = param.isBlackTheme, preloadComponent = param.preloadComponent;
    var ref = customCarouselData(properties, !!isBlackTheme), format = ref.format, slide = ref.slide, carouselBlackFridayTheme = ref.carouselBlackFridayTheme;
    if (!format) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Um componente de Carrossel, localizado na posi\xe7\xe3o ".concat(position, ", n\xe3o est\xe1 retornando o formato do componente."), "warning");
    }
    if (!(subComponents === null || subComponents === void 0 ? void 0 : subComponents.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Um componente de carrossel n\xe3o possui subcomponentes, ou seja, n\xe3o existem items a serem mostrados", "warning");
        return null;
    }
    var details = {
        isClientMobile: isClientMobile,
        isClientTablet: isClientTablet,
        isClientLaptop: isClientLaptop,
        isBlackTheme: isBlackTheme
    };
    if (format === "extended") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtendedCarousel, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-extended-carousel")), {
            automaticSlide: slide,
            subComponents: subComponents,
            carouselTheme: carouselBlackFridayTheme,
            preloadComponent: preloadComponent
        }), details));
    }
    if (format === "grid") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridCarousel, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-carousel")), {
            automaticSlide: slide,
            carouselTheme: carouselBlackFridayTheme,
            subComponents: subComponents,
            preloadComponent: preloadComponent
        }), details));
    }
    return null;
});
CustomCarousel.displayName = "CustomCarousel";



/***/ }),

/***/ 62915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ CustomCountdown; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCountdown/data.tsx

var customCountdownData = function(properties) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var title = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var showTitle = (ref1 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "showTitle";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var subTitle = (ref2 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "subTitle";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var showSubTitle = (ref3 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "showSubTitle";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var date = (ref4 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "date";
    })) === null || ref4 === void 0 ? void 0 : ref4.value;
    var titleColor = (ref5 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "titleColor";
    })) === null || ref5 === void 0 ? void 0 : ref5.value;
    var subTitleColor = (ref6 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "subTitleColor";
    })) === null || ref6 === void 0 ? void 0 : ref6.value;
    var separatorColor = (ref7 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "separatorColor";
    })) === null || ref7 === void 0 ? void 0 : ref7.value;
    var showSeparator = (ref8 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "showSeparator";
    })) === null || ref8 === void 0 ? void 0 : ref8.value;
    var showUnits = (ref9 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "showUnits";
    })) === null || ref9 === void 0 ? void 0 : ref9.value;
    var format = (ref10 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "format";
    })) === null || ref10 === void 0 ? void 0 : ref10.value;
    var desktopImage = (ref11 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "desktopImage";
    })) === null || ref11 === void 0 ? void 0 : ref11.value;
    var mobileImage = (ref12 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "mobileImage";
    })) === null || ref12 === void 0 ? void 0 : ref12.value;
    var backgroundType = (ref13 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "background";
    })) === null || ref13 === void 0 ? void 0 : ref13.value;
    var backgroundColor = (ref14 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "backgroundColor";
    })) === null || ref14 === void 0 ? void 0 : ref14.value;
    var dateColor = (ref15 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "dateColor";
    })) === null || ref15 === void 0 ? void 0 : ref15.value;
    return {
        title: title,
        showTitle: showTitle,
        subTitle: subTitle,
        date: date,
        titleColor: titleColor,
        subTitleColor: subTitleColor,
        showSubTitle: showSubTitle,
        showUnits: showUnits,
        showSeparator: showSeparator,
        separatorColor: separatorColor,
        format: format,
        desktopImage: desktopImage,
        mobileImage: mobileImage,
        backgroundColor: backgroundColor,
        backgroundType: backgroundType,
        dateColor: dateColor
    };
};
var handleComponentWarning = function(branches, currentPathName, position) {
    if (!(branches === null || branches === void 0 ? void 0 : branches.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Um componente de Countdown, localizado em ".concat(currentPathName, " na posi\xe7\xe3o ").concat(position, ", n\xe3o possui nenhuma configura\xe7\xe3o de branches."), "warning");
    }
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCountdown/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      flex-direction: row;\n      justify-content: space-between;\n      padding: 0.7rem 0.67rem 0.7rem 0.67rem;\n\n      @media ",
        " {\n        gap: ",
        ";\n        padding: 0.5rem 1.87rem 0.5rem 0.67rem;\n      }\n\n      @media ",
        " {\n        min-height: 50px;\n        padding-bottom: ",
        ";\n        gap: ",
        ";\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        padding: ",
        " ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      @media ",
        " {\n        padding: ",
        " ",
        ";\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 1280px;\n  width: 100%;\n  background-color: ",
        ";\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(",
        ");\n  border-radius: 10px;\n  padding: 1.3rem 0;\n  object-fit: cover;\n  object-position: center;\n  align-items: center;\n  justify-content: center;\n\n  @media ",
        " {\n    padding: ",
        " ",
        ";\n  }\n\n  @media ",
        " {\n    min-height: 120px;\n    border-radius: ",
        ";\n    padding: ",
        " ",
        ";\n    gap: ",
        ";\n  }\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 6.16rem;\n\n      @media ",
        " {\n        width: 5rem;\n      }\n\n      @media ",
        " {\n        max-width: 4rem;\n        min-width: 3rem;\n      }\n\n      @media ",
        " {\n        max-width: initial;\n        min-width: initial;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 1.33rem;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  @media ",
        " {\n    font-size: 1.035rem;\n    max-width: 74px;\n    min-width: 50px;\n  }\n\n  @media ",
        " {\n    font-size: 0.9rem;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          font-size: 40px;\n          line-height: 1.8vw;\n          margin-top: 1rem;\n\n          @media ",
        " {\n            font-size: ",
        ";\n            line-height: ",
        ";\n            margin-top: 0;\n          }\n          @media ",
        " {\n            font-size: ",
        ";\n            line-height: ",
        ";\n          }\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          font-size: ",
        ";\n          line-height: ",
        ";\n\n          @media ",
        " {\n            font-size: ",
        ";\n            line-height: ",
        ";\n          }\n\n          @media ",
        " {\n            font-size: ",
        ";\n            line-height: ",
        ";\n          }\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ';\n  align-items: flex-start;\n  font-family: "Inter";\n\n  ',
        "\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: flex;\n      justify-content: center;\n      width: 100%;\n\n      @media ",
        " {\n        justify-content: center;\n      }\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          font-size: 3vw;\n          @media ",
        " {\n            font-size: 25px;\n          }\n        "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          font-size: ",
        ";\n          @media ",
        " {\n            font-size: ",
        ";\n          }\n\n          @media ",
        " {\n            font-size: ",
        ";\n          }\n        "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        " !important;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  max-width: 625px;\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  @media ",
        " {\n    max-width: 322px;\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  @media ",
        " {\n    padding-top: ",
        ";\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 600px;\n  width: 100%;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: 40%;\n          align-items: flex-start;\n          padding: ",
        ";\n          @media",
        " {\n            display: none;\n          }\n\n          @media ",
        " {\n            padding-bottom: ",
        ";\n          }\n\n          @media ",
        " {\n            align-items: center;\n            padding-bottom: ",
        ";\n          }\n\n          ",
        " {\n            font-size: ",
        ";\n            letter-spacing: ",
        ";\n            margin: auto;\n            display: flex;\n\n            @media ",
        " {\n              font-size: ",
        ";\n              letter-spacing: 0;\n            }\n\n            /* pedro.souza procurar melhor solu\xe7\xe3o depois, referente ao media 917px */\n            @media (max-width: 917px) {\n              font-size: ",
        ";\n            }\n\n            @media ",
        " {\n              letter-spacing: ",
        ";\n            }\n          }\n\n          ",
        " {\n            font-size: ",
        ";\n            padding-top: 0;\n            margin-left: 7.3rem;\n\n            /* pedro.souza procurar melhor solu\xe7\xe3o depois, referente ao media 917px */\n            @media (max-width: 917px) {\n              font-size: ",
        ";\n            }\n\n            /* pedro.souza procurar melhor solu\xe7\xe3o depois, referente ao media 1075px */\n            @media (max-width: 1075px) {\n              margin-left: 0;\n              margin: 0 auto;\n            }\n\n            @media ",
        " {\n              font-size: ",
        ";\n            }\n          }\n        "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: ",
        " ",
        " ",
        ";\n  align-items: center;\n  max-width: 625px;\n\n  @media ",
        " {\n    padding-bottom: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            color: ",
        ";\n          "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            color: ",
        ";\n          "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    gap: 0.5rem;\n                  "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          gap: 1.3rem;\n\n          @media ",
        " {\n            gap: 0.5rem;\n          }\n\n          @media ",
        " {\n            margin: 0 auto;\n            gap: 1rem;\n          }\n\n          @media ",
        " {\n            gap: 1rem;\n\n            ",
        "\n          }\n\n          @media (max-width: 333px) {\n            gap: 0.3rem;\n          }\n        "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin: 0 auto;\n  gap: 1.3rem;\n  z-index: 10;\n  align-items: flex-start;\n\n  /* pedro.souza procurar melhor solu\xe7\xe3o depois, referente ao media 683px */\n  @media (max-width: 683px) {\n    gap: 0.5rem;\n  }\n\n  ",
        " {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.1rem;\n    color: ",
        ";\n\n    ",
        "\n  }\n\n  @media ",
        " {\n    gap: 0.5rem;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}


var CustomCountdownWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CustomCountdownWrapper",
    componentId: "sc-7b222195-0"
})(_templateObject2(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
}, function(param) {
    var backgroundImage = param.backgroundImage;
    return backgroundImage;
}, ui.theme.device.desktopFirst.tablet, ui.theme.space.x3, ui.theme.space.x0, ui.theme.device.desktopFirst.mobileXL, ui.theme.space["x2.5"], ui.theme.space.x2, ui.theme.space.x0, ui.theme.space.x0, function(param) {
    var isSmall = param.isSmall;
    return isSmall && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), ui.theme.device.desktopFirst.tablet, ui.theme.space.x6, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x0, ui.theme.space.x0, ui.theme.space.x2, ui.theme.space.x0);
}, function(param) {
    var isComplete = param.isComplete;
    return isComplete && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), ui.theme.device.desktopFirst.mobileXL, ui.theme.space["x4.5"], ui.theme.space.x0);
});
var TimeItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TimeItem",
    componentId: "sc-7b222195-1"
})(_templateObject3());
var TimeText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TimeText",
    componentId: "sc-7b222195-2"
})(_templateObject5(), ui.theme.typography.fontFamily.chivo, ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.sm.x5, ui.theme.device.desktopFirst.mobileXL, ui.theme.device.desktopFirst.mobileS, function(param) {
    var isSmall = param.isSmall;
    return isSmall && (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), ui.theme.device.desktopFirst.tabletXM, ui.theme.device.desktopFirst.tabletM, ui.theme.device.desktopFirst.mobileXL);
});
var Separator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Separator",
    componentId: "sc-7b222195-3"
})(_templateObject10(), function(param) {
    var hasSeparator = param.hasSeparator;
    return hasSeparator === "true" ? "flex" : "none";
}, function(param) {
    var hasImage = param.hasImage, backgroundType = param.backgroundType, hasBackground = param.hasBackground;
    return !hasImage && backgroundType === "image" || !hasBackground && backgroundType === "solidColor" ? (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), ui.theme.colors.neutral[999]) : (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), ui.theme.colors.neutral.white);
}, function(param) {
    var isSmall = param.isSmall;
    return isSmall ? (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.lg.x2, ui.theme.typography.fontSize.lg.x2, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.lg.x2, ui.theme.typography.fontSize.md.x5) : (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), ui.theme.typography.fontSize.lg.x7, ui.theme.typography.fontSize.lg.x7, ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.lg.x6, ui.theme.typography.fontSize.lg.x6, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.md.x5, ui.theme.typography.fontSize.md.x5);
});
var TimerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TimerContainer",
    componentId: "sc-7b222195-4"
})(_templateObject12(), function(param) {
    var isSmall = param.isSmall;
    return isSmall && (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), ui.theme.device.desktopFirst.mobileXL);
});
var Time = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Time",
    componentId: "sc-7b222195-5"
})(_templateObject17(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight.bold, function(param) {
    var dateColor = param.dateColor;
    return dateColor;
}, function(param) {
    var hasImage = param.hasImage, backgroundType = param.backgroundType, hasBackground = param.hasBackground;
    return !hasImage && backgroundType === "image" || !hasBackground && backgroundType === "solidColor" ? (0,styled_components_browser_esm/* css */.iv)(_templateObject13(), ui.theme.colors.neutral[999]) : (0,styled_components_browser_esm/* css */.iv)(_templateObject14(), ui.theme.colors.neutral.white);
}, function(param) {
    var isSmall = param.isSmall;
    return isSmall ? (0,styled_components_browser_esm/* css */.iv)(_templateObject15(), ui.theme.device.desktopFirst.tablet) : (0,styled_components_browser_esm/* css */.iv)(_templateObject16(), ui.theme.typography.fontSize.lg.x7, ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.lg.x6, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.md.x5);
});
var CustomCountdownContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CustomCountdownContainer",
    componentId: "sc-7b222195-6"
})(_templateObject18(), ui.theme.space.x0, ui.theme.space.x4);
var CustomCountdownTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__CustomCountdownTitle",
    componentId: "sc-7b222195-7"
})(_templateObject19(), ui.theme.typography.fontSize.lg.x3, ui.theme.typography.fontWeight.normal, function(param) {
    var color = param.color;
    return color;
}, ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.md.x3, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.md.x1);
var CustomCountdownSubTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__CustomCountdownSubTitle",
    componentId: "sc-7b222195-8"
})(_templateObject20(), ui.theme.typography.fontSize.md.x1, ui.theme.typography.fontWeight[400], function(param) {
    var color = param.color;
    return color;
}, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x3, ui.theme.typography.fontSize.sm.x2);
var TitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TitleContainer",
    componentId: "sc-7b222195-9"
})(_templateObject21());
var CustomCountdownHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__CustomCountdownHeader",
    componentId: "sc-7b222195-10"
})(_templateObject23(), ui.theme.space.x0, ui.theme.space.x0, ui.theme.space.x6, ui.theme.device.desktopFirst.tablet, ui.theme.space.x3, function(param) {
    var isSmall = param.isSmall;
    return isSmall ? (0,styled_components_browser_esm/* css */.iv)(_templateObject22(), ui.theme.space.x0, ui.theme.device.desktopFirst.tabletSM, ui.theme.device.desktopFirst.tablet, ui.theme.space.x0, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x3, CustomCountdownTitle, ui.theme.typography.fontSize.md.x1, ui.theme.space["x0.5"], ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.sm.x6, ui.theme.typography.fontSize.sm.x5, ui.theme.device.desktopFirst.mobileXL, ui.theme.space["x0.5"], CustomCountdownSubTitle, ui.theme.typography.fontSize.md.x1, ui.theme.typography.fontSize.sm.x5, ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.sm.x6) : null;
});
var TimerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TimerContent",
    componentId: "sc-7b222195-11"
})(_templateObject28(), TimeItem, function(param) {
    var color = param.color;
    return color;
}, function(param) {
    var hasImage = param.hasImage, backgroundType = param.backgroundType, hasBackground = param.hasBackground;
    return !hasImage && backgroundType === "image" || !hasBackground && backgroundType === "solidColor" ? (0,styled_components_browser_esm/* css */.iv)(_templateObject24(), ui.theme.colors.neutral[999]) : (0,styled_components_browser_esm/* css */.iv)(_templateObject25(), ui.theme.colors.neutral.white);
}, ui.theme.device.desktopFirst.mobileXL, function(param) {
    var isSmall = param.isSmall;
    return isSmall ? (0,styled_components_browser_esm/* css */.iv)(_templateObject27(), ui.theme.device.desktopFirst.tabletS, ui.theme.device.desktopFirst.tabletSM, ui.theme.device.desktopFirst.mobileXL, function(param) {
        var showDays = param.showDays;
        return !showDays ? null : (0,styled_components_browser_esm/* css */.iv)(_templateObject26());
    }) : null;
});

// EXTERNAL MODULE: ../../packages/components/backoffice/utils/index.tsx + 1 modules
var utils = __webpack_require__(60764);
// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCountdown/Countdown/loading.ts
var leadingZero = function(value) {
    var countNumber = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var stringValue = String(value);
    if (value < 10) {
        var ref;
        return (ref = "0".concat(stringValue)) === null || ref === void 0 ? void 0 : ref.slice(-2);
    }
    if (stringValue.length <= countNumber) {
        var ref1;
        return (ref1 = "0".repeat(countNumber) + stringValue) === null || ref1 === void 0 ? void 0 : ref1.slice(-countNumber);
    }
    return stringValue;
};

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCountdown/Countdown/index.tsx







var Countdown = function(param) {
    var hasImage = param.hasImage, separatorColor = param.separatorColor, showSeparator = param.showSeparator, formatSmall = param.formatSmall, date = param.date, dateColor = param.dateColor, showUnits = param.showUnits, hasBackground = param.hasBackground, backgroundType = param.backgroundType;
    var ref = (0,react.useState)({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    }), timeLeft = ref[0], setTimeLeft = ref[1];
    var days = timeLeft.days, hours = timeLeft.hours, minutes = timeLeft.minutes, seconds = timeLeft.seconds;
    setTimeout(function() {
        if (date) {
            setTimeLeft((0,application/* formatCountdownTimer */.p0S)(date));
        }
    });
    var showDays = days >= 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimerContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hasImage: hasImage,
        color: separatorColor,
        hasBackground: hasBackground,
        backgroundType: backgroundType,
        hasSeparator: showSeparator,
        isSmall: formatSmall,
        showDays: showDays
    }, (0,application/* buildTestIds */.Fek)("countdown-timer-content")), {
        children: [
            showDays && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimeItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-time-item-days")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                isSmall: formatSmall,
                                hasImage: hasImage,
                                dateColor: dateColor
                            }, (0,application/* buildTestIds */.Fek)("countdown-time-days")), {
                                children: leadingZero(days, 2)
                            })),
                            showUnits && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                isSmall: formatSmall
                            }, (0,application/* buildTestIds */.Fek)("countdown-time-text-days")), {
                                children: "dias"
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        isSmall: formatSmall,
                        hasBackground: hasBackground,
                        backgroundType: backgroundType,
                        hasImage: hasImage,
                        color: separatorColor,
                        hasSeparator: showSeparator
                    }, (0,application/* buildTestIds */.Fek)("countdown-separator-days")), {
                        children: ":"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimeItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-time-item-hours")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        isSmall: formatSmall,
                        hasImage: hasImage,
                        dateColor: dateColor
                    }, (0,application/* buildTestIds */.Fek)("countdown-time-hours")), {
                        children: leadingZero(hours)
                    })),
                    showUnits && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        isSmall: formatSmall
                    }, (0,application/* buildTestIds */.Fek)("countdown-time-text-hours")), {
                        children: "horas"
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-separator-hours")), {
                isSmall: formatSmall,
                hasImage: hasImage,
                color: separatorColor,
                hasSeparator: showSeparator,
                children: ":"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimeItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-time-item-minutes")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        dateColor: dateColor,
                        isSmall: formatSmall,
                        hasImage: hasImage
                    }, (0,application/* buildTestIds */.Fek)("countdown-time-minutes")), {
                        children: leadingZero(minutes)
                    })),
                    showUnits && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        isSmall: formatSmall
                    }, (0,application/* buildTestIds */.Fek)("countdown-time-text-minutes")), {
                        children: "minutos"
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-separator-minutes")), {
                isSmall: formatSmall,
                hasSeparator: showSeparator,
                hasBackground: hasBackground,
                hasImage: hasImage,
                color: separatorColor,
                children: ":"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimeItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-time-item-seconds")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        dateColor: dateColor,
                        isSmall: formatSmall,
                        hasImage: hasImage
                    }, (0,application/* buildTestIds */.Fek)("countdown-time-seconds")), {
                        children: leadingZero(seconds)
                    })),
                    showUnits && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        isSmall: formatSmall
                    }, (0,application/* buildTestIds */.Fek)("countdown-time-text-seconds")), {
                        children: "segundos"
                    }))
                ]
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCountdown/Header/index.tsx





var RenderCountdownHeader = function(param) {
    var showTitle = param.showTitle, showSubTitle = param.showSubTitle, format = param.format, title = param.title, subTitle = param.subTitle, subTitleColor = param.subTitleColor, titleColor = param.titleColor;
    var formatSmall = format === "small";
    var incompleteHeader = showTitle === "false" && showSubTitle === "false";
    var showSubTitleFalse = showSubTitle === "false";
    var showTitleFalse = showTitle === "false";
    if (incompleteHeader || formatSmall) return null;
    if (showSubTitleFalse) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCountdownHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-header-container-only-title")), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCountdownTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-header-only-title")), {
                color: titleColor,
                children: title
            }))
        }));
    }
    if (showTitleFalse) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCountdownHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-header-container-only-subTitle")), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCountdownSubTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-header-only-subtitle")), {
                color: subTitleColor,
                children: subTitle
            }))
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomCountdownHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-header-container-complete")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCountdownTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                isSmall: formatSmall
            }, (0,application/* buildTestIds */.Fek)("countdown-header-title")), {
                color: titleColor,
                children: title
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCountdownSubTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-header-subtitle")), {
                color: subTitleColor,
                children: subTitle
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomCountdown/index.tsx











var CustomCountdown = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, isClientMobile = param.isClientMobile, config = param.config, position = param.position;
    var ref = customCountdownData(properties), showTitle = ref.showTitle, title = ref.title, titleColor = ref.titleColor, showSubTitle = ref.showSubTitle, subTitle = ref.subTitle, subTitleColor = ref.subTitleColor, desktopImage = ref.desktopImage, mobileImage = ref.mobileImage, format = ref.format, showSeparator = ref.showSeparator, showUnits = ref.showUnits, separatorColor = ref.separatorColor, date = ref.date, backgroundColor = ref.backgroundColor, backgroundType = ref.backgroundType, dateColor = ref.dateColor;
    var linkConfig = (0,utils/* useGetBranchLinkConfig */._e)(config === null || config === void 0 ? void 0 : config.branches, "countdown");
    var isClientLaptop = (0,application/* useAppContext */.bp4)().isClientLaptop;
    handleComponentWarning(config === null || config === void 0 ? void 0 : config.branches, (0,application/* useCurrentPathName */.Y0L)(), position);
    var hasImage = !isClientMobile && desktopImage || isClientMobile && mobileImage;
    var hasBackground = backgroundType === "solidColor";
    var formatSmall = format && format === "small";
    var showSubTitleTrue = showSubTitle && showSubTitle === "true";
    var showTitleTrue = showTitle && showTitle === "true";
    var headerComplete = showSubTitleTrue && showTitleTrue;
    if (date && (0,application/* formatCountdownTimer */.p0S)(date).days === 0 && (0,application/* formatCountdownTimer */.p0S)(date).minutes === 0 && (0,application/* formatCountdownTimer */.p0S)(date).hours === 0 && (0,application/* formatCountdownTimer */.p0S)(date).seconds === 0) {
        return null;
    }
    var backgroundImage = isClientMobile ? mobileImage : desktopImage;
    var conditionForBackgroundImage = backgroundType === "image" ? backgroundImage : null;
    var backgroundColorCondition = hasBackground ? backgroundColor : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCountdownContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-main-container")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomCountdownWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            backgroundColor: backgroundColorCondition,
            backgroundImage: conditionForBackgroundImage,
            isSmall: formatSmall,
            as: (linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url) ? Link/* Link */.r : CustomCountdownWrapper,
            href: "/".concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url),
            target: linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.target,
            isComplete: headerComplete
        }, (0,application/* buildTestIds */.Fek)("countdown-wrapper")), {
            isClientLaptop: isClientLaptop,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderCountdownHeader, {
                    format: format,
                    showTitle: showTitle,
                    showSubTitle: showSubTitle,
                    title: title,
                    subTitle: subTitle,
                    subTitleColor: subTitleColor,
                    titleColor: titleColor
                }),
                showTitleTrue && formatSmall && !isClientMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCountdownHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    isSmall: formatSmall
                }, (0,application/* buildTestIds */.Fek)("countdown-header-title-container-format-small")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCountdownTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        color: titleColor
                    }, (0,application/* buildTestIds */.Fek)("countdown-header-title-small")), {
                        children: title
                    }))
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimerContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    isSmall: formatSmall
                }, (0,application/* buildTestIds */.Fek)("countdown-timer-container")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown, {
                        hasImage: hasImage,
                        dateColor: dateColor,
                        date: date,
                        backgroundType: backgroundType,
                        hasBackground: hasBackground,
                        formatSmall: formatSmall,
                        separatorColor: separatorColor,
                        showSeparator: showSeparator,
                        showUnits: showUnits
                    })
                })),
                showSubTitleTrue && formatSmall && !isClientMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCountdownHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-header-subtitle-container-format-small")), {
                    isSmall: formatSmall,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCountdownSubTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("countdown-header-subtitle-small")), {
                        color: subTitleColor,
                        children: subTitle
                    }))
                }))
            ]
        }))
    }));
});
CustomCountdown.displayName = "customCountdown";



/***/ }),

/***/ 27579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ CustomDynamicBanner; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/Slider/index.tsx + 3 modules
var Slider = __webpack_require__(75926);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomProduct/index.tsx + 3 modules
var CustomProduct = __webpack_require__(78400);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomDynamicBanner/data.tsx
var customDynamicBannerData = function(properties) {
    var ref, ref1, ref2, ref3, ref4;
    var title = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var textAlign = (ref1 = properties.find(function(param) {
        var key = param.key;
        return key === "textAlign";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var showTitle = (ref2 = properties.find(function(param) {
        var key = param.key;
        return key === "showTitle";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var subTitle = (ref3 = properties.find(function(param) {
        var key = param.key;
        return key === "subTitle";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var showSubTitle = (ref4 = properties.find(function(param) {
        var key = param.key;
        return key === "showSubTitle";
    })) === null || ref4 === void 0 ? void 0 : ref4.value;
    return {
        title: title,
        textAlign: textAlign,
        showTitle: showTitle,
        subTitle: subTitle,
        showSubTitle: showSubTitle
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomDynamicBanner/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media ",
        " {\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-slide {\n    width: auto;\n  }\n\n  .slick-prev,\n  .slick-next {\n    margin-top: 2rem;\n  }\n\n  .slick-prev {\n    margin-left: calc(50% - (613px)) !important;\n    @media ",
        " {\n      margin-left: 3.5rem;\n    }\n\n    @media (max-width: 1300px) {\n      margin-left: 3% !important;\n    }\n  }\n\n  .slick-next {\n    margin-right: calc(50% - (613px)) !important;\n    @media ",
        " {\n      margin-right: 3.5rem;\n    }\n\n    @media (max-width: 1300px) {\n      margin-right: 3% !important;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  ",
        ";\n  margin: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1280px;\n  margin: 0 auto;\n  width: 100%;\n  padding: ",
        ";\n\n  @media ",
        " {\n    padding: 0 12px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var CustomDynamicBannerContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "style__CustomDynamicBannerContainer",
    componentId: "sc-1bd888f3-0"
})(_templateObject(), ui.theme.space.x7, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x3);
var CustomDynamicBannerSlider = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__CustomDynamicBannerSlider",
    componentId: "sc-1bd888f3-1"
})(_templateObject1(), ui.theme.device.desktopFirst.laptopXL, ui.theme.device.desktopFirst.laptopXL);
var CustomDynamicBannerTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "style__CustomDynamicBannerTitle",
    componentId: "sc-1bd888f3-2"
})(_templateObject3(), function(param) {
    var alignSelf = param.alignSelf;
    return alignSelf;
}, ui.theme.colors.neutral[520], ui.theme.typography.fontSize.md.x3, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight && "font-weight: ".concat(fontWeight);
}, function(param) {
    var alignSelf = param.alignSelf;
    return "".concat(ui.theme.space.x0, " ").concat(alignSelf === "center" ? ui.theme.space.x0 : ui.theme.space.x4);
}, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x9, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), ui.theme.colors.blackFriday.white);
});
var CustomDynamicBannerSubTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "style__CustomDynamicBannerSubTitle",
    componentId: "sc-1bd888f3-3"
})(_templateObject5(), function(param) {
    var alignSelf = param.alignSelf;
    return alignSelf;
}, ui.theme.colors.neutral[520], ui.theme.typography.fontSize.sm.x9, ui.theme.typography.fontWeight[400], function(param) {
    var alignSelf = param.alignSelf;
    return "".concat(ui.theme.space.x0, " ").concat(alignSelf === "center" ? ui.theme.space.x0 : ui.theme.space.x4);
}, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x7, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), ui.theme.colors.blackFriday.white);
});
var CustomDynamicBannerHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__CustomDynamicBannerHeader",
    componentId: "sc-1bd888f3-4"
})(_templateObject6(), "0 ".concat(ui.theme.space.x3), ui.theme.device.desktopFirst.tablet);

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomDynamicBanner/index.tsx











var getTextAlignment = function(textAlign) {
    switch(textAlign){
        case "left":
            return "flex-start";
        case "center":
            return "center";
        case "right":
            return "flex-end";
        default:
            return "center";
    }
};
var CustomDynamicBanner = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, subComponents = param.subComponents, isClientMobile = param.isClientMobile, isClientTablet = param.isClientTablet, isClientLaptop = param.isClientLaptop, isBlackTheme = param.isBlackTheme;
    var ref = customDynamicBannerData(properties), title = ref.title, textAlign = ref.textAlign, showTitle = ref.showTitle, showSubTitle = ref.showSubTitle, subTitle = ref.subTitle;
    var titleTextAlign = getTextAlignment(textAlign);
    if (!(subComponents === null || subComponents === void 0 ? void 0 : subComponents.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Um componente de banner din\xe2mico n\xe3o possui subcomponentes, ou seja, n\xe3o existem produtos a serem mostrados", "warning");
        return null;
    }
    var details = {
        isClientMobile: isClientMobile,
        isClientTablet: isClientTablet
    };
    var settings = {
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchMove: true,
        swipe: true,
        dots: true,
        autoplay: true,
        infinite: true,
        arrowsIsActive: !isClientLaptop
    };
    var conditionForTitle = showTitle && showTitle === "true" && title;
    var conditionForSubTitle = showSubTitle && showSubTitle === "true" && subTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomDynamicBannerContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-dynamic-banner-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomDynamicBannerHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-dynamic-banner-header")), {
                children: [
                    conditionForTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomDynamicBannerTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-dynamic-banner-title")), {
                        alignSelf: titleTextAlign,
                        isBlackTheme: isBlackTheme,
                        color: ui.theme.colors.neutral[520],
                        fontWeight: ui.theme.typography.fontWeight[400],
                        children: title
                    })),
                    conditionForSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomDynamicBannerSubTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-dynamic-banner-subtitle")), {
                        isBlackTheme: isBlackTheme,
                        alignSelf: titleTextAlign,
                        children: subTitle
                    }))
                ]
            })),
            (subComponents === null || subComponents === void 0 ? void 0 : subComponents.length) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProduct/* CustomProduct */.l, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, subComponents[0], details), {
                priority: true
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomDynamicBannerSlider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-dynamic-banner-slider")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                    children: subComponents === null || subComponents === void 0 ? void 0 : subComponents.map(function(product, index) {
                        var subComponentKey = "".concat(product === null || product === void 0 ? void 0 : product.displayName, "#").concat(product === null || product === void 0 ? void 0 : product.type, "#").concat(index);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProduct/* CustomProduct */.l, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product, details), {
                            priority: true
                        }), subComponentKey);
                    })
                }))
            }))
        ]
    }));
});
CustomDynamicBanner.displayName = "CustomDynamicBanner";



/***/ }),

/***/ 47044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ CustomFAQ; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomFAQ/data.tsx


var customfAQBlackTheme = function(isBlackTheme) {
    return isBlackTheme ? {
        key: "blackFridayTheme",
        value: JSON.stringify({
            backgroundColor: "".concat(ui.theme.colors.blackFriday[125]),
            secondaryBackgroundColor: "".concat(ui.theme.colors.blackFriday[110]),
            defaultColor: "".concat(ui.theme.colors.blackFriday.white),
            textColor: "".concat(ui.theme.colors.blackFriday.white),
            borderColor: "".concat(ui.theme.colors.blackFriday[75])
        })
    } : undefined;
};
var customFAQData = function(properties, isBlackTheme) {
    var ref, ref1, ref2, ref3, ref4;
    var title = (ref = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var textAlign = (ref1 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "textAlign";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var showTitle = (ref2 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "showTitle";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var subTitle = (ref3 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "subTitle";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var showSubTitle = (ref4 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "showSubTitle";
    })) === null || ref4 === void 0 ? void 0 : ref4.value;
    var blackFridayTheme = customfAQBlackTheme(!!isBlackTheme);
    if (blackFridayTheme) {
        properties === null || properties === void 0 ? void 0 : properties.push(blackFridayTheme);
    }
    var faqBlackFridayTheme = (0,application/* getComponentTheme */.sul)(blackFridayTheme);
    return {
        title: title,
        textAlign: textAlign,
        showTitle: showTitle,
        subTitle: subTitle,
        showSubTitle: showSubTitle,
        blackFridayTheme: blackFridayTheme,
        faqBlackFridayTheme: faqBlackFridayTheme
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomFAQ/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: transparent;\n      border: none;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1280px;\n  margin: 0 auto;\n  width: 100%;\n\n  @media ",
        " {\n    width: 94vw;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var CustomFAQContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CustomFAQContainer",
    componentId: "sc-d27fdff7-0"
})(_templateObject1(), ui.theme.device.desktopFirst.laptop, function(param) {
    var faqBlackTheme = param.faqBlackTheme;
    return faqBlackTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var CustomFAQHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CustomFAQHeader",
    componentId: "sc-d27fdff7-1"
})(_templateObject2());
var CustomFAQTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__CustomFAQTitle",
    componentId: "sc-d27fdff7-2"
})(_templateObject3(), function(param) {
    var alignSelf = param.alignSelf;
    return alignSelf;
}, function(param) {
    var faqBlackTheme = param.faqBlackTheme;
    return faqBlackTheme ? ui.theme.colors.blackFriday.white : "".concat(ui.theme.colors.neutral[520]);
}, ui.theme.typography.fontSize.md.x3, ui.theme.typography.fontWeight[400], function(param) {
    var alignSelf = param.alignSelf;
    return "".concat(ui.theme.space.x0, " ").concat(alignSelf === "center" ? ui.theme.space.x0 : ui.theme.space.x4);
}, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x9);
var CustomFAQSubTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__CustomFAQSubTitle",
    componentId: "sc-d27fdff7-3"
})(_templateObject4(), function(param) {
    var alignSelf = param.alignSelf;
    return alignSelf;
}, function(param) {
    var faqBlackTheme = param.faqBlackTheme;
    return faqBlackTheme ? ui.theme.colors.blackFriday.white : "".concat(ui.theme.colors.neutral[520]);
}, ui.theme.typography.fontSize.sm.x9, ui.theme.typography.fontWeight[400], function(param) {
    var alignSelf = param.alignSelf;
    return "".concat(ui.theme.space.x0, " ").concat(alignSelf === "center" ? ui.theme.space.x0 : ui.theme.space.x4);
}, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x7);

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomFAQ/SubComponents/data.tsx
var customFAQSubComponentData = function(properties) {
    var ref, ref1, ref2;
    var question = (ref = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "question";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var text = (ref1 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "text";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var title = (ref2 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "question";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    return {
        question: question,
        text: text,
        title: title
    };
};


;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomFAQ/SubComponents/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 1.3rem 0;\n  border: ",
        ";\n  border-radius: 4px;\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  border: none;\n  background-color: ",
        ";\n  width: 100%;\n  height: 64px;\n  cursor: pointer;\n  border-radius: ",
        ";\n  padding: ",
        " ",
        " ",
        ";\n  transition: all 0.2ms ease-in-out;\n  -webkit-tap-highlight-color: transparent;\n\n  @media ",
        " {\n    padding: ",
        " ",
        " ",
        ";\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 0 2rem;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-align: start;\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1.5rem 0;\n  border-top: 1px solid ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -4px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var CustomFAQSubComponentContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CustomFAQSubComponentContainer",
    componentId: "sc-dc44b63c-0"
})(styles_templateObject1(), function(param) {
    var faqBlackTheme = param.faqBlackTheme;
    return faqBlackTheme ? "1px solid ".concat(ui.theme.colors.blackFriday[75]) : "1px solid ".concat(ui.theme.colors.neutral[100]);
}, function(param) {
    var faqBlackTheme = param.faqBlackTheme;
    return faqBlackTheme && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject(), ui.theme.colors.blackFriday[125]);
});
var AccordionButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__AccordionButton",
    componentId: "sc-dc44b63c-1"
})(styles_templateObject2(), function(param) {
    var faqBlackTheme = param.faqBlackTheme;
    return faqBlackTheme ? ui.theme.colors.blackFriday[125] : "".concat(ui.theme.colors.neutral.white);
}, ui.theme.space.x1, ui.theme.space["x5.5"], ui.theme.space.x6, ui.theme.space.x0, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x4, ui.theme.space.x4, ui.theme.space.x0);
var AccordionContent = (0,styled_components_browser_esm/* default */.ZP)(ui.Accordion).withConfig({
    displayName: "styles__AccordionContent",
    componentId: "sc-dc44b63c-2"
})(styles_templateObject3(), function(param) {
    var faqBlackTheme = param.faqBlackTheme;
    return faqBlackTheme ? ui.theme.colors.blackFriday[125] : "".concat(ui.theme.colors.neutral.white);
});
var Question = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Question",
    componentId: "sc-dc44b63c-3"
})(_templateObject5(), ui.theme.typography.fontSize.sm.x9, ui.theme.typography.fontWeight[500], ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.sm.x7, function(param) {
    var faqBlackTheme = param.faqBlackTheme;
    return faqBlackTheme && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject4(), ui.theme.colors.blackFriday.white);
});
var AccordionContentText = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__AccordionContentText",
    componentId: "sc-dc44b63c-4"
})(_templateObject6(), ui.theme.colors.neutral[100], function(param) {
    var faqBlackTheme = param.faqBlackTheme;
    return faqBlackTheme ? "".concat(ui.theme.colors.neutral[150]) : "".concat(ui.theme.colors.neutral[550]);
}, ui.theme.typography.fontWeight[400], ui.theme.typography.fontSize.sm.x7, ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.sm.x5);
var ArrowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ArrowContainer",
    componentId: "sc-dc44b63c-5"
})(_templateObject7());

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomFAQ/SubComponents/index.tsx








var CustomFAQSubComponent = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, faqTheme = param.faqTheme;
    var ref = (0,react.useState)(false), openAccordion = ref[0], setOpenAccordion = ref[1];
    var ref1 = customFAQSubComponentData(properties), question = ref1.question, text = ref1.text;
    var arrowColor = faqTheme ? ui.theme.colors.blackFriday.white : "".concat(ui.theme.colors.primary[150]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomFAQSubComponentContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-faq-subcomponent-container")), {
        faqBlackTheme: faqTheme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("accordion-button")), {
                faqBlackTheme: faqTheme,
                onClick: function() {
                    return setOpenAccordion(!openAccordion);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Question, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("faq-question")), {
                            faqBlackTheme: faqTheme,
                            children: question
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowContainer, {
                            children: openAccordion ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowUp, {
                                color: arrowColor
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowDown, {
                                color: arrowColor
                            })
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("accordion-content")), {
                faqBlackTheme: faqTheme,
                maxHeight: ui.theme.space.x160,
                show: openAccordion,
                children: !text ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionContentText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("accordion-content-text")), {
                    faqBlackTheme: faqTheme,
                    dangerouslySetInnerHTML: {
                        __html: text
                    }
                }))
            }))
        ]
    }));
});
CustomFAQSubComponent.displayName = "CustomFAQSubComponent";


;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomFAQ/index.tsx








var getTextAlignment = function(textAlign) {
    if (!textAlign) {
        return "center";
    }
    return textAlign === "left" ? "flex-start" : textAlign === "center" ? "center" : textAlign === "right" ? "flex-end" : "center";
};
var CustomFAQ = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, subComponents = param.subComponents, isBlackTheme = param.isBlackTheme;
    var ref = customFAQData(properties, !!isBlackTheme), title = ref.title, textAlign = ref.textAlign, showTitle = ref.showTitle, showSubTitle = ref.showSubTitle, subTitle = ref.subTitle, faqBlackFridayTheme = ref.faqBlackFridayTheme;
    var titleTextAlign = getTextAlignment(textAlign);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomFAQContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-faq-container")), {
        faqBlackTheme: faqBlackFridayTheme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomFAQHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-faq-header")), {
                children: [
                    showTitle && showTitle === "true" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFAQTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-faq-title")), {
                        faqBlackTheme: faqBlackFridayTheme,
                        alignSelf: titleTextAlign,
                        children: title
                    })) : null,
                    showSubTitle && showSubTitle === "true" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFAQSubTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-faq-subtitle")), {
                        faqBlackTheme: faqBlackFridayTheme,
                        alignSelf: titleTextAlign,
                        children: subTitle
                    })) : null
                ]
            })),
            subComponents === null || subComponents === void 0 ? void 0 : subComponents.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFAQSubComponent, (0,_object_spread/* default */.Z)({
                    faqTheme: faqBlackFridayTheme
                }, item), "".concat(item.type, "-").concat(index + 1));
            })
        ]
    }));
});
CustomFAQ.displayName = "CustomFAQ";



/***/ }),

/***/ 16997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ CustomGridPlaylists; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomGridPlaylists/GridPlaylistsCard/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-basis: 153px;\n  flex-grow: 1;\n  flex-direction: column;\n  height: 120px;\n  width: 153px;\n  max-width: 153px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 30px;\n  font-size: ",
        ";\n  color: ",
        ";\n  padding: 0px 12px;\n  text-align: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var GridPlaylistsCardStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__GridPlaylistsCardStyled",
    componentId: "sc-d753ab98-0"
})(_templateObject(), ui.theme.colors.neutral.white, ui.theme.colors.neutral[100]);
var GridPlaylistsImage = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    displayName: "styles__GridPlaylistsImage",
    componentId: "sc-d753ab98-1"
})(_templateObject1());
var GridPlaylistsCardContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__GridPlaylistsCardContent",
    componentId: "sc-d753ab98-2"
})(_templateObject2());
var GridPlaylistsDescriptionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__GridPlaylistsDescriptionContainer",
    componentId: "sc-d753ab98-3"
})(_templateObject3());
var GridPlaylistsDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__GridPlaylistsDescription",
    componentId: "sc-d753ab98-4"
})(_templateObject4(), ui.theme.typography.fontSize.sm.x3, ui.theme.colors.neutral[520], ui.theme.typography.fontWeight[400]);

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomGridPlaylists/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          display: grid;\n          grid-auto-flow: column;\n          justify-content: start;\n          grid-template-rows: repeat(2, auto);\n\n          @media ",
        " {\n            grid-template-rows: repeat(4, auto);\n          }\n\n          @media ",
        " {\n            grid-template-rows: repeat(6, auto);\n          }\n        "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  height: auto;\n  flex-basis: 33%;\n  justify-content: center;\n  gap: ",
        ";\n\n  ",
        "\n\n  @media ",
        " {\n    ",
        " {\n      width: 103px;\n    }\n    ",
        " {\n      padding: 0 19px 8px;\n    }\n    ",
        " {\n      padding: 0 8px;\n    }\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: ",
        ";\n  max-width: 1285px;\n  margin: 0 auto;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 1285px;\n  margin: 0 auto;\n  width: 100%;\n  padding: ",
        " ",
        " ",
        ";\n\n  @media (max-width: 1414px) {\n    padding: ",
        " ",
        " ",
        ";\n  }\n\n  @media ",
        " {\n    padding: ",
        " ",
        " ",
        ";\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  @media ",
        " {\n    margin: ",
        ";\n  }\n\n  @media ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        ",
        "\n      }\n\n      ",
        " {\n        ",
        "\n      }\n\n      .slick-disabled {\n        background: ",
        ";\n        opacity: 1;\n        visibility: visible;\n\n        &:hover {\n          background: ",
        ";\n        }\n        cursor: default;\n\n        path {\n          stroke: ",
        ";\n        }\n\n        &:hover path {\n          stroke: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  padding: 0 6.6rem;\n\n  .slick-track {\n    height: 248px;\n    display: grid;\n    grid-auto-flow: column;\n    grid-template-columns: repeat (8, auto);\n    grid-template-rows: repeat(2, auto);\n    width: 100%;\n\n    @media ",
        " {\n      height: 504px;\n      width: 680px;\n      grid-template-rows: repeat(4, auto);\n    }\n\n    @media ",
        " {\n      width: 360px;\n      height: 760px;\n      grid-template-rows: repeat(6, auto);\n    }\n  }\n\n  .slick-track:before {\n    display: none;\n  }\n\n  .slick-slide {\n    display: flex;\n    margin: ",
        " ",
        " ",
        ";\n    max-width: 100%;\n\n    @media ",
        " {\n      gap: 8px;\n      margin: 0;\n    }\n\n    ",
        " {\n      flex-grow: 1;\n    }\n  }\n\n  .slick-slide > div {\n    display: flex;\n    max-width: 100%;\n  }\n\n  .slick-list {\n    display: flex;\n    flex-wrap: wrap;\n    height: 248px;\n\n    @media ",
        " {\n      height: 504px;\n    }\n\n    @media ",
        " {\n      height: 760px;\n    }\n  }\n\n  @media (max-width: 479px) {\n    ",
        " {\n      margin: 0px;\n    }\n\n    ",
        " {\n      margin: 0px;\n    }\n  }\n\n  @media ",
        " {\n    padding: 1.3rem 2.2rem;\n  }\n\n  @media (max-width: 1414px) {\n    padding: 0 1rem;\n  }\n\n  @media ",
        " {\n    padding: 1.3rem 1.3rem 1.3rem 2.3rem;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
var ref, ref1, ref2, ref3;



var CustomGridPlaylistsContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CustomGridPlaylistsContent",
    componentId: "sc-d115e0dc-0"
})(styles_templateObject1(), ui.theme.space.x2, function(param) {
    var isSliderActive = param.isSliderActive;
    return isSliderActive ? (0,styled_components_browser_esm/* css */.iv)(styles_templateObject(), ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL) : null;
}, ui.theme.device.desktopFirst.mobileXL, GridPlaylistsCardStyled, GridPlaylistsImage, GridPlaylistsDescription);
var WrapperRow = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__WrapperRow",
    componentId: "sc-d115e0dc-1"
})(styles_templateObject2(), ui.theme.space.x1);
var CustomGridPlaylistsHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CustomGridPlaylistsHeader",
    componentId: "sc-d115e0dc-2"
})(styles_templateObject3(), ui.theme.space.x0, ui.theme.space.x3, ui.theme.space.x7, ui.theme.space.x0, ui.theme.space.x0, ui.theme.space.x7, ui.theme.device.desktopFirst.mobileL, ui.theme.space.x0, ui.theme.space.x0, ui.theme.space.x7);
var CustomGridPlaylistsTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__CustomGridPlaylistsTitle",
    componentId: "sc-d115e0dc-3"
})(styles_templateObject4(), function(param) {
    var alignSelf = param.alignSelf;
    return alignSelf;
}, ui.theme.colors.neutral[520], ui.theme.typography.fontSize.md.x3, ui.theme.typography.fontWeight[400], function(param) {
    var alignSelf = param.alignSelf;
    return "".concat(ui.theme.space.x0, " ").concat(alignSelf === "center" ? ui.theme.space.x0 : ui.theme.space.x4);
}, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x9, ui.theme.device.desktopFirst.mobileS, function(param) {
    var alignSelf = param.alignSelf;
    return "".concat(ui.theme.space.x0, " ").concat(alignSelf === "center" ? ui.theme.space.x0 : ui.theme.space.x5);
}, ui.theme.device.desktopFirst.mobileM, ui.theme.space.x0);
var CustomGridPlaylistsSubTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__CustomGridPlaylistsSubTitle",
    componentId: "sc-d115e0dc-4"
})(_templateObject5(), function(param) {
    var alignSelf = param.alignSelf;
    return alignSelf;
}, ui.theme.colors.neutral[520], ui.theme.typography.fontSize.sm.x9, ui.theme.typography.fontWeight[400], function(param) {
    var alignSelf = param.alignSelf;
    return "".concat(ui.theme.space.x0, " ").concat(alignSelf === "center" ? ui.theme.space.x0 : ui.theme.space.x4);
}, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x7);
var CustomGridPlaylistsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CustomGridPlaylistsContainer",
    componentId: "sc-d115e0dc-5"
})(_templateObject9(), function(param) {
    var customTheme = param.customTheme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    return customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), CustomGridPlaylistsTitle, customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1.white), CustomGridPlaylistsSubTitle, customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref2 = ui.theme.colors) === null || ref2 === void 0 ? void 0 : ref2.blackFriday["15"]), ui.theme === null || ui.theme === void 0 ? void 0 : (ref3 = ui.theme.colors) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.blackFriday) === null || ref4 === void 0 ? void 0 : ref4["110"], ui.theme === null || ui.theme === void 0 ? void 0 : (ref5 = ui.theme.colors) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.blackFriday) === null || ref6 === void 0 ? void 0 : ref6["110"], ui.theme === null || ui.theme === void 0 ? void 0 : (ref7 = ui.theme.colors) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.blackFriday) === null || ref8 === void 0 ? void 0 : ref8["40"], ui.theme === null || ui.theme === void 0 ? void 0 : (ref9 = ui.theme.colors) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.blackFriday) === null || ref10 === void 0 ? void 0 : ref10["40"]);
}, ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.device) === null || ref === void 0 ? void 0 : (ref1 = ref.desktopFirst) === null || ref1 === void 0 ? void 0 : ref1.tablet, (ref2 = ui.theme.device) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.desktopFirst) === null || ref3 === void 0 ? void 0 : ref3.mobileXL, ui.theme.space.x0, ui.theme.space.x2, ui.theme.space.x2, ui.theme.device.desktopFirst.tablet, GridPlaylistsCardStyled, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL, CustomGridPlaylistsTitle, CustomGridPlaylistsSubTitle, ui.theme.device.desktopFirst.mobileXL, ui.theme.device.desktopFirst.mobileM);

// EXTERNAL MODULE: ../../packages/components/Image/index.tsx
var Image = __webpack_require__(25926);
// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomGridPlaylists/GridPlaylistsCard/data.tsx
var customGridPlaylistsCardData = function(properties) {
    var ref, ref1;
    var title = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var image = (ref1 = properties.find(function(param) {
        var key = param.key;
        return key === "image";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    return {
        title: title,
        image: image
    };
};


// EXTERNAL MODULE: ../../packages/components/backoffice/utils/index.tsx + 1 modules
var utils = __webpack_require__(60764);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomGridPlaylists/GridPlaylistsCard/index.tsx










var CustomGridPlaylistsCard = function(param) {
    var config = param.config, properties = param.properties, positionComponent = param.positionComponent, index = param.index;
    var ref;
    var linkConfig = (0,utils/* useGetBranchLinkConfig */._e)(config === null || config === void 0 ? void 0 : config.branches, "subComponentGridPlaylists");
    var ref1 = customGridPlaylistsCardData(properties), image = ref1.image, title = ref1.title;
    var currentPathName = (0,application/* useCurrentPathName */.Y0L)();
    if (!(config === null || config === void 0 ? void 0 : (ref = config.branches) === null || ref === void 0 ? void 0 : ref.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('Um subComponente de Playlists em Grade, localizado em "'.concat(currentPathName, '" na posi\xe7\xe3o ').concat(positionComponent, ", n\xe3o possui nenhuma configura\xe7\xe3o de branches."), "warning");
    }
    if (!image) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("O subcomponente ".concat(index, " de Playlists em Grade na posi\xe7\xe3o ").concat(positionComponent, ' localizado em "').concat(currentPathName, '", n\xe3o possui imagem.'), "error");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridPlaylistsCardStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-card")), {
        as: (linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url) ? Link/* Link */.r : "div",
        href: "/".concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url),
        target: linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.target,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridPlaylistsCardContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-card-content")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GridPlaylistsImage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-card-image")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        src: image,
                        alt: "Imagem do Card",
                        width: 65,
                        height: 65
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GridPlaylistsDescriptionContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-card-description-container")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridPlaylistsDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-card-description")), {
                        children: title
                    }))
                }))
            ]
        }))
    }));
};
/* harmony default export */ var GridPlaylistsCard = (CustomGridPlaylistsCard);

// EXTERNAL MODULE: ../../packages/components/Slider/index.tsx + 3 modules
var Slider = __webpack_require__(75926);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomGridPlaylists/GridPlaylistsSlider/index.tsx









var GridPlaylistsSlider = /*#__PURE__*/ (0,react.memo)(function(param) {
    var subComponents = param.subComponents, positionComponent = param.positionComponent, isBlackFriday = param.isBlackFriday;
    var ref = (0,application/* useAppContext */.bp4)(), isClientMobile = ref.isClientMobile, isClientTablet = ref.isClientTablet, isClientLaptop = ref.isClientLaptop;
    var ref1 = (0,react.useState)(6), slidesToShow = ref1[0], setSlidesToShow = ref1[1];
    var ref2 = (0,react.useState)(1), slidesToScroll = ref2[0], setSlidesToScroll = ref2[1];
    (0,react.useEffect)(function() {
        setSlidesToShow(isClientMobile ? 3 : isClientTablet ? 4 : isClientLaptop ? 5 : 9);
        setSlidesToScroll(isClientMobile ? 18 : isClientTablet ? 16 : isClientLaptop ? 3 : 8);
    }, [
        isClientLaptop,
        isClientMobile,
        isClientTablet
    ]);
    var settings = {
        speed: 800,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        arrowsIsActive: !isClientMobile && !isClientTablet,
        touchMove: true,
        swipe: true,
        dots: isClientMobile || isClientTablet,
        isBlackTheme: isBlackFriday
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
        children: subComponents === null || subComponents === void 0 ? void 0 : subComponents.map(function(subComponent, index) {
            var componentKey = "".concat(subComponent.type, "#").concat(index);
            return /*#__PURE__*/ (0,react.createElement)(CustomGridPlaylistsContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-content")), {
                key: componentKey,
                isSliderActive: true
            }), /*#__PURE__*/ (0,jsx_runtime.jsx)(GridPlaylistsCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-card"), subComponent), {
                positionComponent: positionComponent,
                index: index + 1
            })));
        })
    }));
});
GridPlaylistsSlider.displayName = "GridPlaylistsSlider";
/* harmony default export */ var CustomGridPlaylists_GridPlaylistsSlider = (GridPlaylistsSlider);

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomGridPlaylists/data.tsx
var customGridPlaylistsData = function(properties) {
    var ref, ref1, ref2, ref3, ref4;
    var title = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var textAlign = (ref1 = properties.find(function(param) {
        var key = param.key;
        return key === "textAlign";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var showTitle = (ref2 = properties.find(function(param) {
        var key = param.key;
        return key === "showTitle";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var subTitle = (ref3 = properties.find(function(param) {
        var key = param.key;
        return key === "subTitle";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var showSubTitle = (ref4 = properties.find(function(param) {
        var key = param.key;
        return key === "showSubTitle";
    })) === null || ref4 === void 0 ? void 0 : ref4.value;
    return {
        title: title,
        showTitle: showTitle,
        subTitle: subTitle,
        showSubTitle: showSubTitle,
        textAlign: textAlign
    };
};


;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomGridPlaylists/index.tsx











var getTextAlignment = function(textAlign) {
    if (!textAlign) {
        return "center";
    }
    return textAlign === "left" ? "flex-start" : textAlign === "center" ? "center" : textAlign === "right" ? "flex-end" : "center";
};
var CustomGridPlaylists = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, subComponents = param.subComponents, isClientMobile = param.isClientMobile, isClientTablet = param.isClientTablet, position = param.position, isBlackTheme = param.isBlackTheme;
    var ref = customGridPlaylistsData(properties), title = ref.title, textAlign = ref.textAlign, showTitle = ref.showTitle, showSubTitle = ref.showSubTitle, subTitle = ref.subTitle;
    var titleTextAlign = getTextAlignment(textAlign);
    if (!(subComponents === null || subComponents === void 0 ? void 0 : subComponents.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Um componente de Playlists em Grade n\xe3o possui subcomponentes, ou seja, n\xe3o existem produtos a serem mostrados", "warning");
        return null;
    }
    var evenSubComponents = subComponents === null || subComponents === void 0 ? void 0 : subComponents.filter(function(_, index) {
        return (index + 1) % 2 === 0;
    });
    var oddSubComponents = subComponents === null || subComponents === void 0 ? void 0 : subComponents.filter(function(_, index) {
        return (index + 1) % 2 !== 0;
    });
    var conditionForTitle = showTitle && showTitle === "true";
    var conditionForSubTitle = showSubTitle && showSubTitle === "true";
    var cardsWithoutSliderOnTabletAndMobile = (subComponents === null || subComponents === void 0 ? void 0 : subComponents.length) < 19 && isClientMobile || (subComponents === null || subComponents === void 0 ? void 0 : subComponents.length) < 17 && isClientTablet;
    var cardsWithoutSliderOnDesktop = !isClientTablet && (subComponents === null || subComponents === void 0 ? void 0 : subComponents.length) < 17;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomGridPlaylistsContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-container")), {
        customTheme: isBlackTheme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomGridPlaylistsHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-header")), {
                children: [
                    conditionForTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomGridPlaylistsTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-title")), {
                        alignSelf: titleTextAlign,
                        children: title
                    })),
                    conditionForSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomGridPlaylistsSubTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-subtitle")), {
                        alignSelf: titleTextAlign,
                        children: subTitle
                    }))
                ]
            })),
            cardsWithoutSliderOnTabletAndMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomGridPlaylistsContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-content")), {
                children: subComponents === null || subComponents === void 0 ? void 0 : subComponents.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridPlaylistsCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        positionComponent: position,
                        index: index + 1
                    }), "".concat(item.displayName, "-").concat(item.type));
                })
            })) : cardsWithoutSliderOnDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperRow, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-wrapper-row")), {
                children: [
                    oddSubComponents === null || oddSubComponents === void 0 ? void 0 : oddSubComponents.map(function(subComponent, index) {
                        var componentKey = "".concat(subComponent.type, "#odd#").concat(index);
                        return /*#__PURE__*/ (0,react.createElement)(GridPlaylistsCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-card")), {
                            key: componentKey
                        }), subComponent), {
                            positionComponent: position,
                            index: index + 1
                        }));
                    }),
                    evenSubComponents === null || evenSubComponents === void 0 ? void 0 : evenSubComponents.map(function(subComponent, index) {
                        var componentKey = "".concat(subComponent.type, "#even#").concat(index);
                        return /*#__PURE__*/ (0,react.createElement)(GridPlaylistsCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-card")), {
                            key: componentKey
                        }), subComponent), {
                            positionComponent: position,
                            index: index + 1
                        }));
                    })
                ]
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomGridPlaylists_GridPlaylistsSlider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-grid-playlists-slider")), {
                positionComponent: position,
                isBlackFriday: isBlackTheme,
                subComponents: subComponents
            }))
        ]
    }));
});
CustomGridPlaylists.displayName = "CustomGridPlaylists";



/***/ }),

/***/ 40818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ CustomHeader; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomHeader/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: ",
        ";\n  gap: ",
        " ",
        ";\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-image: url(",
        ") !important;\n      background-position: center;\n      background-repeat: no-repeat;\n      background-size: cover;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: -webkit-fill-available;\n  padding: 0.25rem 1rem;\n  background-color: ",
        ";\n  text-align: center;\n  min-height: 3rem;\n  max-height: fit-content !important;\n  cursor: ",
        ";\n\n  ",
        "\n\n  ",
        " {\n    font-size: 1.25rem;\n    font-weight: normal;\n    color: ",
        ";\n  }\n\n  ",
        " {\n    font-size: 1.25rem;\n    color: ",
        ";\n  }\n\n  ",
        " {\n    font-size: 1.25rem;\n    color: ",
        ";\n  }\n\n  ",
        " {\n    text-decoration: none;\n    margin-left: 0.5rem;\n    font-size: 1rem;\n    color: ",
        ";\n  }\n\n  @media ",
        " {\n    ",
        " {\n      font-size: 1.083rem;\n      color: ",
        ";\n    }\n\n    ",
        " {\n      font-size: 1.083rem;\n      color: ",
        ";\n    }\n\n    ",
        " {\n      font-size: 1.083rem;\n      color: ",
        ";\n    }\n\n    ",
        " {\n      width: 8rem;\n    }\n  }\n\n  @media ",
        " {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0 0.5rem;\n    min-height: 5rem !important;\n    max-height: fit-content !important;\n\n    ",
        " {\n      font-size: 1rem;\n    }\n\n    ",
        " {\n      font-size: 1rem;\n    }\n\n    ",
        " {\n      font-size: 1rem;\n    }\n\n    ",
        " {\n      margin-top: 0.125rem;\n      font-size: 1rem;\n    }\n  }\n\n  @media ",
        " {\n    padding: 0.75rem 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var TextsContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "style__TextsContainer",
    componentId: "sc-45bad67f-0"
})(_templateObject(), function(param) {
    var isClientMobile = param.isClientMobile;
    return isClientMobile ? "column" : "row";
}, ui.theme.space.x0, ui.theme.space.x2);
var BannerTitle = styled_components_browser_esm/* default.i.withConfig */.ZP.i.withConfig({
    displayName: "style__BannerTitle",
    componentId: "sc-45bad67f-1"
})(_templateObject1());
var BannerMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__BannerMessage",
    componentId: "sc-45bad67f-2"
})(_templateObject2());
var BannerCtaText = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    displayName: "style__BannerCtaText",
    componentId: "sc-45bad67f-3"
})(_templateObject3());
var BannerLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "style__BannerLink",
    componentId: "sc-45bad67f-4"
})(_templateObject4());
var Banner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Banner",
    componentId: "sc-45bad67f-5"
})(_templateObject6(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || ui.theme.colors.primary[200];
}, function(param) {
    var isToRedirect = param.isToRedirect;
    return isToRedirect ? "pointer" : "default";
}, function(param) {
    var backgroundImage = param.backgroundImage;
    return backgroundImage && (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), backgroundImage);
}, BannerMessage, ui.theme.colors.neutral.white, BannerTitle, ui.theme.colors.neutral.white, BannerCtaText, ui.theme.colors.neutral.white, BannerLink, ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.tablet, BannerMessage, ui.theme.colors.neutral.white, BannerTitle, ui.theme.colors.neutral.white, BannerCtaText, ui.theme.colors.neutral.white, BannerLink, ui.theme.device.desktopFirst.mobileXL, BannerMessage, BannerTitle, BannerCtaText, BannerLink, ui.theme.device.desktopFirst.mobileM);

// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomHeader/data.tsx


var customHeaderData = function(properties) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var contentType = (ref = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "contentType";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var linkText = (ref1 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "linkText";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var linkHref = (ref2 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "linkHref";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var desktopImage = (ref3 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "desktopImage";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var mobileImage = (ref4 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "mobileImage";
    })) === null || ref4 === void 0 ? void 0 : ref4.value;
    var title = (ref5 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref5 === void 0 ? void 0 : ref5.value;
    var message = (ref6 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "message";
    })) === null || ref6 === void 0 ? void 0 : ref6.value;
    var ctaText = (ref7 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "ctaText";
    })) === null || ref7 === void 0 ? void 0 : ref7.value;
    var backgroundColor = (ref8 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "backgroundColor";
    })) === null || ref8 === void 0 ? void 0 : ref8.value;
    var showTopbar = (ref9 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "showTopbar";
    })) === null || ref9 === void 0 ? void 0 : ref9.value;
    var blackFridayTheme = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "blackFridayTheme";
    });
    var headerBlackFridayTheme = (0,application/* getComponentTheme */.sul)(blackFridayTheme);
    return {
        contentType: contentType,
        linkText: linkText,
        linkHref: linkHref,
        desktopImage: desktopImage,
        mobileImage: mobileImage,
        title: title,
        message: message,
        ctaText: ctaText,
        backgroundColor: backgroundColor,
        showTopbar: showTopbar,
        headerBlackFridayTheme: headerBlackFridayTheme
    };
};
var handleComponentWarnings = function(branches, currentPathName, contentType, desktopImage, mobileImage, message, showTopbar) {
    if (!(branches === null || branches === void 0 ? void 0 : branches.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('O componente de Header Personalizado, localizado em "'.concat(currentPathName, '" na posi\xe7\xe3o 0, n\xe3o possui nenhuma configura\xe7\xe3o de branches.'), "warning");
    }
    if (!showTopbar || showTopbar === "false") {
        return;
    }
    if (contentType === "image") {
        if (!desktopImage || !mobileImage) {
            implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('O componente de Header Personalizado, localizado em "'.concat(currentPathName, '" na posi\xe7\xe3o 0, n\xe3o possui imagem.'), "warning");
        }
    } else if (!message) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('O componente de Header Personalizado, localizado em "'.concat(currentPathName, '" na posi\xe7\xe3o 0, n\xe3o possui texto.'), "warning");
    }
};


// EXTERNAL MODULE: ../../packages/components/backoffice/utils/branch-config.tsx
var branch_config = __webpack_require__(72182);
// EXTERNAL MODULE: ../../packages/components/PreloadImage/index.tsx
var PreloadImage = __webpack_require__(18494);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomHeader/index.tsx











var CustomHeader = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, isClientTablet = param.isClientTablet, config = param.config, isClientMobile = param.isClientMobile, preloadComponent = param.preloadComponent;
    var ref = customHeaderData(properties), showTopbar = ref.showTopbar, backgroundColor = ref.backgroundColor, contentType = ref.contentType, title = ref.title, message = ref.message, ctaText = ref.ctaText, desktopImage = ref.desktopImage, mobileImage = ref.mobileImage;
    var linkConfig = (0,branch_config/* useGetBranchLinkConfig */._e)(config === null || config === void 0 ? void 0 : config.branches, "subComponentHeader");
    handleComponentWarnings(config === null || config === void 0 ? void 0 : config.branches, (0,application/* useCurrentPathName */.Y0L)(), contentType, desktopImage, mobileImage, message, showTopbar);
    var isSidebarMenuOpened = (0,application/* useAppContext */.bp4)().isSidebarMenuOpened;
    var router = (0,next_router.useRouter)();
    var customHeaderRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)("1.667rem"), headerOverlayHeight = ref1[0], setHeaderOverlayHeight = ref1[1];
    // Esse eslint está desabilitado para que, toda vez que o componente for recriado, o overlay possa obter a largura exata do StyledFooter, mesmo que a tela seja redimensionada.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react.useEffect)(function() {
        var ref;
        if (customHeaderRef === null || customHeaderRef === void 0 ? void 0 : (ref = customHeaderRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) {
            setHeaderOverlayHeight("".concat(customHeaderRef.current.clientHeight, "px"));
        }
    });
    if (showTopbar === "false") {
        return null;
    }
    if (contentType === "image" && (mobileImage || desktopImage)) {
        var image = isClientTablet ? mobileImage : desktopImage;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                preloadComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PreloadImage/* PreloadImage */.b, (0,_object_spread/* default */.Z)({
                    imgSrc: image
                }, (0,application/* buildTestIds */.Fek)("preload-banner-image-custom-header"))) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.OverlayDynamic, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-overlay-dynamic")), {
                    isVisible: !isClientMobile && isSidebarMenuOpened,
                    height: headerOverlayHeight,
                    top: "0px"
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-header-banner")), {
                    ref: customHeaderRef,
                    backgroundColor: "transparent",
                    backgroundImage: image,
                    onClick: function() {
                        (0,branch_config/* handleOnClickRedirect */.Vs)(linkConfig, router);
                    },
                    isToRedirect: !!linkConfig
                }))
            ]
        });
    }
    // Se o tipo não for imagem, hoje, o único outro tipo possível é text. Logo, segue a lógica de texto abaixo
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.OverlayDynamic, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-overlay-dynamic")), {
                isVisible: !isClientMobile && isSidebarMenuOpened,
                height: headerOverlayHeight,
                top: "0px"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-header-banner")), {
                ref: customHeaderRef,
                backgroundColor: backgroundColor,
                onClick: function() {
                    (0,branch_config/* handleOnClickRedirect */.Vs)(linkConfig, router);
                },
                isToRedirect: !!linkConfig,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextsContainer, {
                    isClientMobile: isClientMobile,
                    isClientTablet: isClientTablet,
                    children: [
                        title && !isClientTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerTitle, {
                            children: title
                        }),
                        message && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerMessage, {
                            children: message
                        }),
                        ctaText && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerCtaText, {
                            children: ctaText
                        })
                    ]
                })
            }))
        ]
    });
});
CustomHeader.displayName = "CustomHeader";



/***/ }),

/***/ 89236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ CustomHighlightCategories; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomHighlightCategories/HighlightCategory/index.tsx




var HighlightCategory = function(param) {
    var id = param.id, name = param.name, descriptionUrl = param.descriptionUrl;
    var currentPathName = (0,application/* useCurrentPathName */.Y0L)();
    // const formattedDescriptionUrl = descriptionUrl
    //   ? descriptionUrl?.startsWith("Destaque/")
    //     ? descriptionUrl
    //     : `Destaque/${descriptionUrl}`
    //   : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
        href: "/".concat(descriptionUrl || ""),
        target: "_self",
        color: descriptionUrl && (currentPathName === null || currentPathName === void 0 ? void 0 : currentPathName.includes(descriptionUrl)) ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[520],
        backgroundColor: descriptionUrl && (currentPathName === null || currentPathName === void 0 ? void 0 : currentPathName.includes(descriptionUrl)) ? ui.theme.colors.secondary[200] : undefined,
        children: name
    }, "".concat(id, "#").concat(descriptionUrl, "#").concat(name));
};


// EXTERNAL MODULE: ../../packages/components/backoffice/CustomHighlightCategories/style.ts
var style = __webpack_require__(85865);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomHighlightCategories/index.tsx






// const propsAreEqual = (
//   { subComponents: prevSubComponents }: CustomHighlightCategoriesProps,
//   { subComponents: nextSubComponents }: CustomHighlightCategoriesProps
// ) => {
//   return !prevSubComponents?.find(
//     (subComponent, index) =>
//       subComponent?.name !== nextSubComponents?.[`${index}`]?.name ||
//       subComponent?.descriptionUrl !==
//         nextSubComponents?.[`${index}`]?.descriptionUrl
//   );
// };
var CustomHighlightCategories = function(param) {
    var subComponents = param.subComponents;
    if (!(subComponents === null || subComponents === void 0 ? void 0 : subComponents.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* HighlightCategories */.N, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("highlight-categories-container")), {
        children: subComponents.map(function(component) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightCategory, (0,_object_spread/* default */.Z)({}, component), "".concat(component === null || component === void 0 ? void 0 : component.id, "#").concat(component === null || component === void 0 ? void 0 : component.name));
        })
    }));
};
CustomHighlightCategories.displayName = "CustomHighlightCategories";



/***/ }),

/***/ 85865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ HighlightCategories; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 1.5rem;\n  display: flex;\n\n  @media (max-width: 980px) {\n    display: flex;\n    flex-flow: row nowrap;\n    width: 100%;\n    white-space: nowrap;\n    overflow-x: hidden;\n    overflow-y: hidden;\n  }\n\n  @media ",
        " {\n    margin-left: 1rem;\n    display: flex;\n    flex-flow: row nowrap;\n    width: 100%;\n    white-space: nowrap;\n    overflow-x: hidden;\n    overflow-y: hidden;\n  }\n\n  @media ",
        " {\n    margin-left: 1.5rem;\n  }\n\n  a {\n    text-decoration: none;\n    font-size: 1.17rem;\n    font-weight: 400;\n    padding: 0.4rem 0.65rem;\n    border-radius: 4px;\n    cursor: pointer;\n\n    transition: all 0.2s ease-in;\n\n    &:hover {\n      background: ",
        ";\n    }\n\n    @media (max-width: 980px) {\n      padding: 0.25rem 0.38rem !important;\n    }\n\n    @media ",
        " {\n      padding: 0.4rem 0.65rem;\n    }\n\n    @media ",
        " {\n      font-size: 1.17rem !important;\n    }\n\n    @media ",
        " {\n      padding: 0.25rem 0.38rem;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var HighlightCategories = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "style__HighlightCategories",
    componentId: "sc-a315ab0c-0"
})(_templateObject(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.laptopL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[100], ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.laptop, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.mobileFirst.laptopL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet);


/***/ }),

/***/ 91320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ CustomImagesGrid; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomImagesGrid/data.tsx
var customImagesGridData = function(properties) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var title = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var showTitle = (ref1 = properties.find(function(param) {
        var key = param.key;
        return key === "showTitle";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var textAlign = (ref2 = properties.find(function(param) {
        var key = param.key;
        return key === "textAlign";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var subTitle = (ref3 = properties.find(function(param) {
        var key = param.key;
        return key === "subTitle";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var showSubTitle = (ref4 = properties.find(function(param) {
        var key = param.key;
        return key === "showSubTitle";
    })) === null || ref4 === void 0 ? void 0 : ref4.value;
    var orientation = (ref5 = properties.find(function(param) {
        var key = param.key;
        return key === "orientation";
    })) === null || ref5 === void 0 ? void 0 : ref5.value;
    var format = (ref6 = properties.find(function(param) {
        var key = param.key;
        return key === "format";
    })) === null || ref6 === void 0 ? void 0 : ref6.value;
    return {
        title: title,
        showTitle: showTitle,
        textAlign: textAlign,
        subTitle: subTitle,
        showSubTitle: showSubTitle,
        orientation: orientation,
        format: format
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/Image/index.tsx
var Image = __webpack_require__(25926);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomImagesGrid/SubComponents/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  & > span {\n    position: unset !important;\n    height: 100% !important;\n    width: 100% !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100% !important;\n  position: relative !important;\n  height: auto !important;\n  border-radius: ",
        " ",
        " ",
        "\n    ",
        " !important;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__Container",
    componentId: "sc-274ca601-0"
})(_templateObject());
var ImageContainer = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    displayName: "styles__ImageContainer",
    componentId: "sc-274ca601-1"
})(_templateObject1());
var BannerImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* Image */.E).withConfig({
    displayName: "styles__BannerImage",
    componentId: "sc-274ca601-2"
})(_templateObject2(), ui.theme.space.x2, ui.theme.space.x3, ui.theme.space.x3, ui.theme.space.x2);

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomImagesGrid/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  grid-template-areas: "a b";\n'
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  grid-template-areas:\n    "a"\n    "b";\n'
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  grid-template-areas: "a b c";\n'
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  grid-template-areas:\n    "a"\n    "b"\n    "c";\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  grid-template-areas:\n    "a a"\n    "b c";\n'
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  grid-template-areas:\n    "a b"\n    "c c";\n'
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  grid-template-areas:\n    "a b"\n    "c d";\n'
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  grid-template-areas:\n    "a a a b b b"\n    "c c d d e e";\n'
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  grid-template-areas:\n    "a a b b c c"\n    "d d d e e e";\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  grid-template-areas:\n    "a b c"\n    "d e f";\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n  text-align: ",
        ";\n\n  @media ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  @media ",
        " {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: ",
        ";\n\n  ",
        ";\n\n  & > ",
        ":nth-child(1) {\n    grid-area: a;\n    display: ",
        ";\n  }\n  & > ",
        ":nth-child(2) {\n    grid-area: b;\n    display: ",
        ";\n  }\n  & > ",
        ":nth-child(3) {\n    grid-area: c;\n    display: ",
        ";\n  }\n  & > ",
        ":nth-child(4) {\n    grid-area: d;\n    display: ",
        ";\n  }\n  & > ",
        ":nth-child(5) {\n    grid-area: e;\n    display: ",
        ";\n  }\n  & > ",
        ":nth-child(6) {\n    grid-area: f;\n    display: ",
        ";\n  }\n\n  @media ",
        " {\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        ", ",
        " {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  max-width: 1280px;\n  margin: ",
        " auto;\n  width: 100%;\n\n  @media ",
        " {\n    width: 94vw;\n    padding: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}



var styles_double = (0,styled_components_browser_esm/* css */.iv)(styles_templateObject());
var doubleVertical = (0,styled_components_browser_esm/* css */.iv)(styles_templateObject1());
var triple = (0,styled_components_browser_esm/* css */.iv)(styles_templateObject2());
var tripleVertical = (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
var tripleDown = (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
var tripleUp = (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
var quadruple = (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
var quintupleDown = (0,styled_components_browser_esm/* css */.iv)(_templateObject7());
var quintupleUp = (0,styled_components_browser_esm/* css */.iv)(_templateObject8());
var sextuple = (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
var gridArea = function(gridType, orientation) {
    if (orientation && orientation === "vertical") {
        return gridType === "triple" ? tripleVertical : doubleVertical;
    }
    switch(gridType){
        case "triple":
            return triple;
        case "tripleDown":
            return tripleDown;
        case "tripleUp":
            return tripleUp;
        case "quadruple":
            return quadruple;
        case "quintupleDown":
            return quintupleDown;
        case "quintupleUp":
            return quintupleUp;
        case "sextuple":
            return sextuple;
        default:
            return styles_double;
    }
};
var CustomImagesGridHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CustomImagesGridHeader",
    componentId: "sc-12c256b2-0"
})(_templateObject10(), ui.theme.space.x1, ui.theme.space.x7, function(param) {
    var textAlign = param.textAlign;
    return textAlign || "left";
}, ui.theme.device.desktopFirst.tablet, ui.theme.space.x4, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x4);
var CustomImagesGridTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__CustomImagesGridTitle",
    componentId: "sc-12c256b2-1"
})(_templateObject11(), function(param) {
    var textAlign = param.textAlign;
    return textAlign;
}, ui.theme.typography.fontSize.lg.x1, ui.theme.colors.neutral[520], ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.md.x2);
var CustomImagesGridSubtitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__CustomImagesGridSubtitle",
    componentId: "sc-12c256b2-2"
})(_templateObject12(), function(param) {
    var textAlign = param.textAlign;
    return textAlign;
}, ui.theme.typography.fontSize.sm.x9, ui.theme.colors.neutral[330], ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x7);
var CustomImagesGridGrid = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CustomImagesGridGrid",
    componentId: "sc-12c256b2-3"
})(_templateObject13(), ui.theme.space["x4.5"], function(param) {
    var gridType = param.gridType, orientation = param.orientation;
    return gridArea(gridType, orientation);
}, Container, function(param) {
    var gridType = param.gridType;
    return gridType ? "block" : "none";
}, Container, function(param) {
    var gridType = param.gridType;
    return gridType ? "block" : "none";
}, Container, function(param) {
    var gridType = param.gridType;
    return gridType && gridType !== "double" && gridType !== undefined ? "block" : "none";
}, Container, function(param) {
    var gridType = param.gridType;
    return gridType && gridType !== "double" && gridType !== "triple" && gridType !== "tripleDown" && gridType !== "tripleUp" ? "block" : "none";
}, Container, function(param) {
    var gridType = param.gridType;
    return gridType && gridType === "quintupleUp" || gridType === "quintupleDown" || gridType === "sextuple" ? "block" : "none";
}, Container, function(param) {
    var gridType = param.gridType;
    return gridType && gridType === "sextuple" ? "block" : "none";
}, ui.theme.device.desktopFirst.tablet, ui.theme.space.x2);
var CustomImagesGridContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CustomImagesGridContainer",
    componentId: "sc-12c256b2-4"
})(_templateObject15(), ui.theme.typography.fontWeight[400], ui.theme.typography.fontFamily.chivo, ui.theme.space.x0, ui.theme.device.desktopFirst.tablet, ui.theme.space.x0, function(param) {
    var customTheme = param.customTheme;
    return customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject14(), CustomImagesGridTitle, CustomImagesGridSubtitle, ui.theme.colors.neutral.white);
});

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomImagesGrid/SubComponents/data.tsx
var customImagesGridSubComponentData = function(properties) {
    var ref, ref1, ref2;
    var title = (ref = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var desktopImage = (ref1 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "desktopImage";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var mobileImage = (ref2 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "mobileImage";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    return {
        title: title,
        desktopImage: desktopImage,
        mobileImage: mobileImage
    };
};


// EXTERNAL MODULE: ../../packages/components/backoffice/utils/index.tsx + 1 modules
var utils = __webpack_require__(60764);
// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomImagesGrid/SubComponents/index.tsx










var ImagesGrid = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, config = param.config, isClientMobile = param.isClientMobile, positionComponent = param.positionComponent;
    var ref;
    var ref1 = customImagesGridSubComponentData(properties), desktopImage = ref1.desktopImage, mobileImage = ref1.mobileImage, title = ref1.title;
    var linkConfig = (0,utils/* useGetBranchLinkConfig */._e)(config === null || config === void 0 ? void 0 : config.branches, "subComponentImagesGrid");
    var currentPathName = (0,application/* useCurrentPathName */.Y0L)();
    if (!(config === null || config === void 0 ? void 0 : (ref = config.branches) === null || ref === void 0 ? void 0 : ref.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('Um subComponente de Imagens em Grade, localizado em "'.concat(currentPathName, '" na posi\xe7\xe3o ').concat(positionComponent, ", n\xe3o possui nenhuma configura\xe7\xe3o de branches."), "warning");
    }
    var image = isClientMobile ? mobileImage !== null && mobileImage !== void 0 ? mobileImage : "" : desktopImage !== null && desktopImage !== void 0 ? desktopImage : "";
    var url = (0,utils/* useBackofficeComponentUrl */.Sb)(config === null || config === void 0 ? void 0 : config.branches, linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: (linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url) ? Link/* Link */.r : "section",
        href: url,
        target: "".concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.target)
    }, (0,application/* buildTestIds */.Fek)("custom-imagesgrid-subComponent")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("image-container")), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImage, (0,_object_spread/* default */.Z)({
                src: image || "",
                alt: title !== null && title !== void 0 ? title : "Imagem de banner",
                layout: "fill",
                objectFit: "cover",
                objectPosition: "center"
            }, (0,application/* buildTestIds */.Fek)("banner-image")))
        }))
    }));
});
ImagesGrid.displayName = "CustomImagesGrid";


;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomImagesGrid/index.tsx









var CustomImagesGrid = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, subComponents = param.subComponents, isClientTablet = param.isClientTablet, isClientMobile = param.isClientMobile, isClientLaptop = param.isClientLaptop, position = param.position, isBlackTheme = param.isBlackTheme;
    var ref = customImagesGridData(properties), title = ref.title, showTitle = ref.showTitle, textAlign = ref.textAlign, subTitle = ref.subTitle, showSubTitle = ref.showSubTitle, orientation = ref.orientation, format = ref.format;
    if (!(subComponents === null || subComponents === void 0 ? void 0 : subComponents.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Um componente de grade de imagens n\xe3o possui subcomponentes, ou seja, n\xe3o existem produtos a serem mostrados", "warning");
        return null;
    }
    if (!format) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Um componente de grade de imagens n\xe3o possui formato especificado. Desse modo, ir\xe1 assumir o formato double.", "warning");
        return null;
    }
    if (!orientation) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Um componente de grade de imagens n\xe3o possui orienta\xe7\xe3o especificada. Desse modo, ir\xe1 assumir a orienta\xe7\xe3o horizontal.", "warning");
        return null;
    }
    var details = {
        isClientMobile: isClientMobile,
        isClientTablet: isClientTablet,
        isClientLaptop: isClientLaptop
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomImagesGridContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        customTheme: isBlackTheme
    }, (0,application/* buildTestIds */.Fek)("custom-imagesgrid-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomImagesGridHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                textAlign: textAlign
            }, (0,application/* buildTestIds */.Fek)("custom-imagesgrid-header")), {
                children: [
                    showTitle && showTitle === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImagesGridTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        textAlign: textAlign
                    }, (0,application/* buildTestIds */.Fek)("custom-imagesgrid-title")), {
                        children: title
                    })),
                    showSubTitle && showSubTitle === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImagesGridSubtitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        textAlign: textAlign
                    }, (0,application/* buildTestIds */.Fek)("custom-imagesgrid-subtitle")), {
                        children: subTitle
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImagesGridGrid, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                gridType: format,
                orientation: orientation
            }, (0,application/* buildTestIds */.Fek)("custom-imagesgrid-grid")), {
                children: subComponents === null || subComponents === void 0 ? void 0 : subComponents.map(function(subComponent) {
                    var ref, ref1;
                    var subComponentKey = (ref1 = subComponent === null || subComponent === void 0 ? void 0 : (ref = subComponent.properties) === null || ref === void 0 ? void 0 : ref.find(function(property) {
                        return (property === null || property === void 0 ? void 0 : property.key) === "desktopImage" || (property === null || property === void 0 ? void 0 : property.key) === "mobileImage";
                    })) === null || ref1 === void 0 ? void 0 : ref1.value;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagesGrid, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, subComponent, details), {
                        positionComponent: position
                    }), (0,application/* buildTestIds */.Fek)("custom-imagesgrid-subComponent-".concat(subComponentKey))), subComponentKey);
                })
            }))
        ]
    }));
});
CustomImagesGrid.displayName = "CustomImagesGrid";



/***/ }),

/***/ 78400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ CustomProduct; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/Image/index.tsx
var Image = __webpack_require__(25926);
// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
// EXTERNAL MODULE: ../../packages/components/backoffice/utils/index.tsx + 1 modules
var utils = __webpack_require__(60764);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomProduct/data.tsx

var customProductData = function(properties) {
    var ref;
    var title = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    return {
        title: title
    };
};
var getUtilDimensions = function(isClientMobile, isClientTablet) {
    var percentageDiscountDimension = isClientMobile ? "20px" : isClientTablet ? "26px" : "28px";
    var saleTagIconDimension = isClientMobile ? 18 : isClientTablet ? 24 : 28;
    return {
        percentageDiscountDimension: percentageDiscountDimension,
        saleTagIconDimension: saleTagIconDimension
    };
};
var getCustomProductStyles = function(isClientTablet) {
    var discountTagTextFontSize = !isClientTablet ? ui.theme.typography.fontSize.sm.x5 : ui.theme.typography.fontSize.sm.x3;
    var priceValueGap = !isClientTablet ? ui.theme.space.x2 : ui.theme.space.x1;
    return {
        discountTagTextFontSize: discountTagTextFontSize,
        priceValueGap: priceValueGap
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomProduct/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  padding: ",
        ";\n  width: 100%;\n  max-height: fit-content;\n  background-color: ",
        ";\n  margin: auto;\n\n  @media ",
        " {\n    gap: ",
        ";\n    padding: ",
        ";\n  }\n\n  @media ",
        " {\n    gap: ",
        ";\n    padding: ",
        ";\n    max-height: 220px;\n    min-height: 220px;\n  }\n\n  @media ",
        " {\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: center;\n\n  min-width: 335px;\n  max-width: 335px;\n  min-height: 335px;\n  max-height: 335px;\n\n  @media ",
        " {\n    min-width: 250px;\n    max-width: 250px;\n  }\n\n  @media ",
        " {\n    max-height: 220px;\n    min-height: 220px;\n  }\n\n  @media ",
        " {\n    max-height: 200px;\n    min-height: 200px;\n  }\n\n  @media ",
        " {\n    min-width: 150px;\n    max-width: 150px;\n  }\n\n  @media ",
        " {\n    min-width: 120px;\n    max-width: 120px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  width: 356px;\n  gap: ",
        ";\n  margin: 8px 0;\n\n  @media ",
        " {\n    width: 195px;\n  }\n\n  @media ",
        " {\n    gap: ",
        ";\n    width: 180px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  white-space: pre-wrap;\n  overflow: hidden;\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  min-height: 2rem;\n\n  @media ",
        " {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 8px;\n\n  @media ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: max-content;\n  justify-content: center;\n  padding: 8px;\n  border-radius: 8px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  max-width: fit-content;\n\n  @media ",
        " {\n    background: ",
        ";\n    border-radius: 4px;\n    height: 20px;\n    border: none;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: 0.92rem;\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  @media ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 0.5rem;\n  display: flex;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  width: max-content;\n  border: 1px solid\n    ",
        ";\n  background: ",
        ";\n\n  @media ",
        " {\n    background: ",
        ";\n    border-radius: 4px;\n    height: 20px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  user-select: none;\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: ",
        ";\n  transition: background-color 0.2s;\n  margin-top: ",
        ";\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var CustomProductInnerContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "style__CustomProductInnerContainer",
    componentId: "sc-412aa3b3-0"
})(_templateObject(), ui.theme.space.x20, "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x39, " ").concat(ui.theme.space.x0, "\n    ").concat(ui.theme.space.x63), ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.tablet, ui.theme.space.x14, "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x8, " ").concat(ui.theme.space.x0, "\n    ").concat(ui.theme.space.x17), ui.theme.device.desktopFirst.tabletS, ui.theme.space.x12, "17px ".concat(ui.theme.space.x3, " 17px ").concat(ui.theme.space.x3), ui.theme.device.desktopFirst.mobileL, ui.theme.space["x5.5"]);
var ProductImageContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "style__ProductImageContainer",
    componentId: "sc-412aa3b3-1"
})(_templateObject1(), ui.theme.device.desktopFirst.laptop, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.tabletS, ui.theme.device.desktopFirst.mobileXL, ui.theme.device.desktopFirst.mobileL);
var ProductDetailsContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "style__ProductDetailsContainer",
    componentId: "sc-412aa3b3-2"
})(_templateObject2(), ui.theme.space.x2, ui.theme.device.desktopFirst.tabletM, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x1);
var ProductTitle = (0,styled_components_browser_esm/* default */.ZP)(ui.Title).withConfig({
    displayName: "style__ProductTitle",
    componentId: "sc-412aa3b3-3"
})(_templateObject3(), ui.theme.typography.fontSize.md.x1, ui.theme.typography.fontWeight[600], ui.theme.colors.neutral[715], ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.sm.x5);
var BoxTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__BoxTags",
    componentId: "sc-412aa3b3-4"
})(_templateObject4(), ui.theme.device.desktopFirst.tabletM);
var TagProductWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__TagProductWrapper",
    componentId: "sc-412aa3b3-5"
})(_templateObject5(), ui.theme.device.desktopFirst.tabletM);
var TagProductPriceOnlySiteContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__TagProductPriceOnlySiteContainer",
    componentId: "sc-412aa3b3-6"
})(_templateObject6(), ui.theme.colors.secondary[250], ui.theme.colors.secondary[250], ui.theme.device.desktopFirst.mobileXL, ui.theme.colors.secondary[28]);
var TagProductPriceOnlySiteText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__TagProductPriceOnlySiteText",
    componentId: "sc-412aa3b3-7"
})(_templateObject7(), ui.theme.colors.neutral.white, ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[500], ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.sm.x3, ui.theme.device.desktopFirst.mobileXL, ui.theme.colors.secondary[380]);
var TagIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__TagIcon",
    componentId: "sc-412aa3b3-8"
})(_templateObject8());
var TagCampaignBoxProduct = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__TagCampaignBoxProduct",
    componentId: "sc-412aa3b3-9"
})(_templateObject9(), function(param) {
    var borderColor = param.borderColor;
    return borderColor || ui.theme.colors.neutral[750];
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || ui.theme.colors.neutral[490];
}, ui.theme.device.desktopFirst.mobileXL, ui.theme.colors.neutral[999]);
var TagTextCampaignBoxProduct = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__TagTextCampaignBoxProduct",
    componentId: "sc-412aa3b3-10"
})(_templateObject10(), function(param) {
    var color = param.color;
    return color || ui.theme.colors.neutral.white;
}, ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[500], ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.sm.x3);
var ProductBuyButton = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "style__ProductBuyButton",
    componentId: "sc-412aa3b3-11"
})(_templateObject11(), ui.theme.space.x2, ui.theme.space.x2, ui.theme.device.desktopFirst.tablet);
var CustomCartIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.CartIcon).attrs({
    color: ui.theme.colors.neutral.white,
    width: "30px",
    height: "30px"
}).withConfig({
    displayName: "style__CustomCartIcon",
    componentId: "sc-412aa3b3-12"
})(_templateObject12());

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomProduct/utils.ts

var hasProductCardAllInfosToShow = function(productCard) {
    var ref, ref1;
    return productCard && (productCard === null || productCard === void 0 ? void 0 : (ref = productCard.prices) === null || ref === void 0 ? void 0 : ref.length) && (productCard === null || productCard === void 0 ? void 0 : (ref1 = productCard.mediaLinks) === null || ref1 === void 0 ? void 0 : ref1.length);
};
var getProductUtils = function(product) {
    var ref;
    if (!product) {
        return null;
    }
    var description = product.description, mediaLinks = product.mediaLinks;
    var discountPercentage = (0,application/* getDiscountPercentage */.$Q4)(product);
    var priceList = (0,application/* getPriceList */.D7)(product, true);
    var salePrice = (0,application/* getSalePrice */.FlL)(product);
    var spotPrice = (0,application/* getSpotPrice */.$XT)(product);
    var installmentsText = (0,application/* getInstallmentsText */.aY_)(product, 2);
    var finalPrice = {
        value: spotPrice || (discountPercentage ? salePrice : priceList),
        text: spotPrice ? "\xe0 vista no pix ou no cart\xe3o" : null
    };
    var imageUrl = (ref = mediaLinks === null || mediaLinks === void 0 ? void 0 : mediaLinks.find(function(item) {
        return (item === null || item === void 0 ? void 0 : item.isDefault) && item.linkType === "BANNER";
    })) === null || ref === void 0 ? void 0 : ref.imageUrl;
    return {
        description: description,
        discountPercentage: discountPercentage,
        priceList: priceList,
        installmentsText: installmentsText,
        finalPrice: finalPrice,
        imageUrl: imageUrl,
        salePrice: salePrice
    };
};


;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomProduct/index.tsx













var CustomProduct = function(param) {
    var config = param.config, isClientMobile = param.isClientMobile, isClientTablet = param.isClientTablet, isinsidecarousel = param.isinsidecarousel, position = param.position, productCards = param.productCards, _priority = param.priority, priority = _priority === void 0 ? false : _priority;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var linkConfig = (0,utils/* useGetBranchLinkConfig */._e)(config === null || config === void 0 ? void 0 : config.branches, "subComponentProduct");
    var router = (0,next_router.useRouter)();
    var isClientTabletM = (0,application/* useAppContext */.bp4)().isClientTabletM;
    var currentPathName = (0,application/* useCurrentPathName */.Y0L)();
    var productCard = productCards === null || productCards === void 0 ? void 0 : productCards[0];
    if (!(config === null || config === void 0 ? void 0 : (ref = config.branches) === null || ref === void 0 ? void 0 : ref.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('Um subComponente do tipo CustomProduct, cujo id \xe9 "'.concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.id, '", localizado em "').concat(currentPathName, '", na posi\xe7\xe3o ').concat(position, ", n\xe3o possui nenhuma configura\xe7\xe3o de branches."), {
            level: "warning",
            tags: {
                fcx_labs_error_source: "workspace"
            }
        });
    }
    if (!hasProductCardAllInfosToShow(productCard)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('Um subComponente do tipo CustomProduct, cujo id \xe9 "'.concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.id, '", localizado em "').concat(currentPathName, '", na posi\xe7\xe3o ').concat(position, ", n\xe3o possui as informa\xe7\xf5es necess\xe1rias sobre o produto (productCards) e n\xe3o ser\xe1 exibido por completo para o usu\xe1rio."), {
            level: "error",
            tags: {
                fcx_labs_error_source: "workspace"
            }
        });
    }
    var productUtils = getProductUtils(productCard);
    if (!productUtils) {
        return null;
    }
    var description = productUtils.description, discountPercentage = productUtils.discountPercentage, priceList = productUtils.priceList, installmentsText = productUtils.installmentsText, finalPrice = productUtils.finalPrice, imageUrl = productUtils.imageUrl, salePrice = productUtils.salePrice;
    var ref6 = getCustomProductStyles(!!isClientTablet), discountTagTextFontSize = ref6.discountTagTextFontSize, priceValueGap = ref6.priceValueGap;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomProductInnerContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: Link/* Link */.r,
        href: "/".concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url),
        target: linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.target
    }, (0,application/* buildTestIds */.Fek)("custom-product-inner-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-image-container")), {
                isinsidecarousel: isinsidecarousel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, (0,_object_spread/* default */.Z)({
                    src: String(imageUrl),
                    alt: "Imagem do produto",
                    width: "100%",
                    height: "100%",
                    layout: "responsive",
                    priority: priority
                }, (0,application/* buildTestIds */.Fek)("product-image")))
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetailsContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-details-container")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagProductWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("tag-product-wrapper")), {
                        children: [
                            (productCard === null || productCard === void 0 ? void 0 : productCard.isBlackFriday) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxTags, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-tags-black-friday")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagCampaignBoxProduct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    backgroundColor: ui.theme.colors.blackFriday[125],
                                    borderColor: ui.theme.colors.blackFriday[125]
                                }, (0,application/* buildTestIds */.Fek)("tag-campaign-box-product")), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagTextCampaignBoxProduct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("tag-text-campaign-box-product")), {
                                        children: isClientMobile ? "Black Friday" : "Oferta Black Friday"
                                    }))
                                }))
                            })),
                            (productCard === null || productCard === void 0 ? void 0 : (ref1 = productCard.tagProduct) === null || ref1 === void 0 ? void 0 : ref1.title) && !isClientTabletM ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxTags, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-tags-price-only-site")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagProductPriceOnlySiteContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("tag-product-price-only-site-container")), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagProductPriceOnlySiteText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("tag-product-only-site-text")), {
                                        children: "".concat(productCard === null || productCard === void 0 ? void 0 : (ref2 = productCard.tagProduct) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.title) === null || ref3 === void 0 ? void 0 : ref3.toLocaleLowerCase())
                                    }))
                                }))
                            })) : null
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-description")), {
                        children: description
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.PriceMainContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("price-main-container")), {
                        childrenQuantity: discountPercentage ? 2 : 1,
                        children: [
                            discountPercentage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.DiscountContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("discount-container")), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.OldPrice, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("old-price")), {
                                        marginRight: "0px",
                                        fontSizeDiscount: discountTagTextFontSize,
                                        children: priceList
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.DiscountPercentageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("discount-percentage-container")), {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.DiscountTagDot, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.DiscountTagText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("discount-tag-text")), {
                                                fontSizeDiscount: discountTagTextFontSize,
                                                children: [
                                                    discountPercentage,
                                                    "% OFF"
                                                ]
                                            }))
                                        ]
                                    }))
                                ]
                            })) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.PriceValue, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                isFlexDirectionColumn: isClientMobile,
                                display: "flex",
                                gap: priceValueGap,
                                fontSize: "40px",
                                fontSizeLaptop: "36px",
                                margin: "0px",
                                fontSizeTablet: "32px",
                                fontSizeMobileLarge: "24px",
                                fontSizeMobile: "21px"
                            }, (0,application/* buildTestIds */.Fek)("price-value")), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.PriceValueText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("price-value-text")), {
                                        children: (finalPrice === null || finalPrice === void 0 ? void 0 : finalPrice.value) || salePrice
                                    })),
                                    (finalPrice === null || finalPrice === void 0 ? void 0 : finalPrice.text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpotPriceText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("spot-price-text")), {
                                        children: "".concat(finalPrice.text)
                                    })) : null
                                ]
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.PriceInstallments, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("price-installments")), {
                        color: ui.theme.colors.blackFriday[210],
                        children: installmentsText
                    })),
                    isClientTabletM && (productCard === null || productCard === void 0 ? void 0 : (ref4 = productCard.tagProduct) === null || ref4 === void 0 ? void 0 : ref4.title) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxTags, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-tags-price-only-site-mobile")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagProductPriceOnlySiteContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("tag-product-only-site-container-mobile")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagProductPriceOnlySiteText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-price-only-site-text-mobile")), {
                                children: (productCard === null || productCard === void 0 ? void 0 : (ref5 = productCard.tagProduct) === null || ref5 === void 0 ? void 0 : ref5.title) || ""
                            }))
                        }))
                    })) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductBuyButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        onClick: function() {
                            return (linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.target) === "_blank" ? window.open("/".concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url), "_blank") : router === null || router === void 0 ? void 0 : router.push("/".concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url));
                        },
                        rounded: true,
                        backgroundColor: ui.theme.colors.secondary[310],
                        mouseOverColor: ui.theme.colors.secondary[500],
                        color: ui.theme.colors.neutral.white,
                        width: "181px",
                        height: "50px"
                    }, (0,application/* buildTestIds */.Fek)("product-buy-button")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCartIcon, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-buy-button-text")), {
                                fontSize: ui.theme.typography.fontSize.sm.x7,
                                fontWeight: ui.theme.typography.fontWeight[500],
                                children: "Comprar"
                            }))
                        ]
                    }))
                ]
            }))
        ]
    }));
};



/***/ }),

/***/ 24683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ CustomProductList; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/ProductCard/index.tsx
var ProductCard = __webpack_require__(95770);
// EXTERNAL MODULE: ../../packages/components/Skeleton/index.tsx
var Skeleton = __webpack_require__(44860);
// EXTERNAL MODULE: ../../packages/components/backoffice/utils/index.tsx + 1 modules
var utils = __webpack_require__(60764);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/components/ProductCard/styles.ts
var styles = __webpack_require__(3483);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomProductList/components/Slider/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  ",
        " {\n    height: ",
        ";\n    min-height: ",
        ";\n    max-height: ",
        ";\n  }\n\n  @media ",
        " {\n    .slick-list {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SliderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SliderContainer",
    componentId: "sc-30050b9c-0"
})(_templateObject());
var ProductCardStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ProductCardStyle",
    componentId: "sc-30050b9c-1"
})(_templateObject1(), styles/* ProductCardContainer */.hd, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, ui.theme.device.desktopFirst.mobileXL, ui.theme.colors.primary[705]);

// EXTERNAL MODULE: ../../packages/components/RecommendationCarouselProductCard/index.tsx + 10 modules
var RecommendationCarouselProductCard = __webpack_require__(49234);
// EXTERNAL MODULE: ../../packages/components/Slider/index.tsx + 3 modules
var Slider = __webpack_require__(75926);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomProductList/components/Slider/index.tsx










var CustomProductListSlider = /*#__PURE__*/ (0,react.memo)(function(param) {
    var productCards = param.productCards, isVertical = param.isVertical, customTheme = param.customTheme, slidesToShow = param.slidesToShow, arrowsIsActive = param.arrowsIsActive, isBlackFriday = param.isBlackFriday, height = param.height, crm = param.crm, isCrmProductList = param.isCrmProductList, isCrmProductListMinimalist = param.isCrmProductListMinimalist;
    var isClientLaptop = (0,application/* useAppContext */.bp4)().isClientLaptop;
    var slidesToScroll = (0,react.useMemo)(function() {
        if (isClientLaptop) return 4;
        return 5;
    }, [
        isClientLaptop
    ]);
    var sliderProps = {
        speed: 700,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        arrowsIsActive: arrowsIsActive,
        touchMove: true,
        swipe: false,
        vertical: isVertical,
        verticalSwiping: isVertical
    };
    var getProductCartType = (0,react.useCallback)(function(product) {
        return isCrmProductList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationCarouselProductCard/* default */.Z, {
            className: crm ? "ins-product-box ins-element-link ins-add-to-cart-wrapper ins-sr-api" : "",
            "data-event-collection": crm ? "true" : "false",
            "data-ins-product-id": crm ? "".concat(product === null || product === void 0 ? void 0 : product.id) : "",
            isVertical: isVertical,
            item: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                index: productCards.indexOf(product) + 1
            }),
            isPlaylist: true,
            isMinimalist: isCrmProductListMinimalist
        }, "".concat(product.id)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
            className: crm ? "ins-product-box ins-element-link ins-add-to-cart-wrapper ins-sr-api" : "",
            "data-event-collection": crm ? "true" : "false",
            "data-ins-product-id": crm ? "".concat(product === null || product === void 0 ? void 0 : product.id) : "",
            isVertical: isVertical,
            item: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                index: productCards.indexOf(product) + 1
            }),
            shouldShowInGridOnMobile: false,
            isPlaylist: true
        }, "".concat(product.id));
    }, [
        crm,
        isCrmProductList,
        isCrmProductListMinimalist,
        isVertical,
        productCards, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderContainer, {
        className: crm ? "ins-web-smart-recommender-body" : "",
        "data-recommended-items": crm ? crm === null || crm === void 0 ? void 0 : crm.recommendedProductsId : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-product-list-slider")), {
            customTheme: customTheme,
            isBlackTheme: isBlackFriday
        }), sliderProps), {
            children: productCards === null || productCards === void 0 ? void 0 : productCards.map(function(product) {
                return /*#__PURE__*/ (0,react.createElement)(ProductCardStyle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: crm ? "ins-web-smart-recommender-box-item" : ""
                }, (0,application/* buildTestIds */.Fek)("product-card-style")), {
                    key: "box-".concat(product.id),
                    isVertical: isVertical,
                    height: height
                }), getProductCartType(product));
            })
        }))
    });
});
CustomProductListSlider.displayName = "CustomProductListSlider";


// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomProductList/data.tsx



var getBlackFridayProductListTheme = function(isBlackTheme) {
    return isBlackTheme ? {
        key: "blackFridayTheme",
        value: JSON.stringify(ui.blackFridayProductListTheme)
    } : undefined;
};
var getPlaylistId = function(branches) {
    var ref;
    var currentBranchId = implementations/* cookie.getCookie */.pR.getCookie({
        name: "@FC:Ecom:Dropdown:BranchLocation"
    }) || "2";
    return (ref = branches === null || branches === void 0 ? void 0 : branches.find(function(param) {
        var id = param.id;
        return id === currentBranchId;
    })) === null || ref === void 0 ? void 0 : ref.linkId;
};
var customProductListData = function(properties, isBlackTheme) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var title = (ref = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var showTitle = (ref1 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "showTitle";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var showCta = (ref2 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "showCta";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var ctaText = (ref3 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "ctaText";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var ref8;
    var quantity = (ref8 = (ref4 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "quantity";
    })) === null || ref4 === void 0 ? void 0 : ref4.value) !== null && ref8 !== void 0 ? ref8 : "10";
    var orientation = (ref5 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "orientation";
    })) === null || ref5 === void 0 ? void 0 : ref5.value;
    var showArrows = (ref6 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "showArrows";
    })) === null || ref6 === void 0 ? void 0 : ref6.value;
    var visibleItemsQuantity = (ref7 = properties === null || properties === void 0 ? void 0 : properties.find(function(param) {
        var key = param.key;
        return key === "visibleItemsQuantity";
    })) === null || ref7 === void 0 ? void 0 : ref7.value;
    var blackFridayTheme = getBlackFridayProductListTheme(isBlackTheme);
    var productListBlackFridayTheme = (0,application/* getComponentTheme */.sul)(blackFridayTheme);
    return {
        title: title,
        showTitle: showTitle,
        showCta: showCta,
        ctaText: ctaText,
        quantity: quantity,
        orientation: orientation,
        showArrows: showArrows,
        visibleItemsQuantity: visibleItemsQuantity,
        productListBlackFridayTheme: productListBlackFridayTheme
    };
};
var handleComponentWarnings = function(branches, currentPathName, position, productCards) {
    if (!(branches === null || branches === void 0 ? void 0 : branches.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Um item de Lista de Produtos, localizado em ".concat(currentPathName, " na posi\xe7\xe3o ").concat(position, ", n\xe3o possui nenhuma configura\xe7\xe3o de branches."), "warning");
    }
    var playlistId = getPlaylistId(branches);
    var branchId = (0,application/* getClientBranchId */.R0G)(implementations/* cookie */.pR);
    if (!(productCards === null || productCards === void 0 ? void 0 : productCards.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Uma Lista de Produtos, cuja playlist \xe9 ".concat(playlistId, " e cuja filial \xe9 ").concat(branchId, ", n\xe3o tem produtos."), "warning");
    }
};
var calculateSlidesToShow = function(isVertical, isCrmProductListVertical, isClientDesktop, isClientMobile, arrowsIsActive) {
    if (isCrmProductListVertical) {
        return 10;
    }
    if (arrowsIsActive && isClientDesktop) {
        return 5;
    }
    if (!arrowsIsActive && isClientDesktop) {
        return 6;
    }
    if (isClientMobile && isVertical) {
        return 3.3;
    }
    return 5;
};
var setIsVertical = function(isClientMobile, isCrmProductListVertical, orientation) {
    return !!(isClientMobile && orientation && orientation === "vertical" || isCrmProductListVertical);
};
var slidesToShowValueIncrement = function(value) {
    return value + 4;
};
var setShouldRenderButtonViewMore = function(isVertical, productsCards, slidesToShow, isCrmProductListVertical) {
    return isVertical && !isCrmProductListVertical && (productsCards === null || productsCards === void 0 ? void 0 : productsCards.length) > slidesToShow && (productsCards === null || productsCards === void 0 ? void 0 : productsCards.length) !== 3;
};


// EXTERNAL MODULE: ../../packages/components/backoffice/CustomProductList/styles.ts
var CustomProductList_styles = __webpack_require__(36348);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomProductList/index.tsx

















var propsAreEqual = function(param, param1) {
    var oldIsClientMobile = param.isClientMobile, oldIsClientTablet = param.isClientTablet, oldIsClientDesktop = param.isClientDesktop, oldProductCards = param.productCards, // crm: oldCrm,
    oldIsLoading = param.isLoading, oldProperties = param.properties, isClientMobile = param1.isClientMobile, isClientTablet = param1.isClientTablet, isClientDesktop = param1.isClientDesktop, productCards = param1.productCards, // crm,
    isLoading = param1.isLoading, properties = param1.properties;
    return oldIsClientMobile === isClientMobile && oldIsClientTablet === isClientTablet && oldIsClientDesktop === isClientDesktop && (oldProductCards === null || oldProductCards === void 0 ? void 0 : oldProductCards.length) === (productCards === null || productCards === void 0 ? void 0 : productCards.length) && // oldCrm?.campaignId === crm?.campaignId &&
    oldIsLoading === isLoading && oldProperties === properties;
};
var CustomProductList = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, productCards = param.productCards, config = param.config, position = param.position, isBlackTheme = param.isBlackTheme, crm = param.crm, isLoading = param.isLoading, isCrmComponent = param.isCrmComponent, isCrmProductList = param.isCrmProductList, isCrmProductListVertical = param.isCrmProductListVertical, isCrmProductListMinimalist = param.isCrmProductListMinimalist, _preloadComponent = param.preloadComponent, preloadComponent = _preloadComponent === void 0 ? false : _preloadComponent;
    var _Math;
    var ref = customProductListData(properties, !!isBlackTheme), showTitle = ref.showTitle, title = ref.title, showCta = ref.showCta, showArrows = ref.showArrows, ctaText = ref.ctaText, quantity = ref.quantity, orientation = ref.orientation, productListBlackFridayTheme = ref.productListBlackFridayTheme;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,application/* useAppContext */.bp4)(), isClientDesktop = ref1.isClientDesktop, isClientMobile = ref1.isClientMobile, isClientTablet = ref1.isClientTablet, isClientTabletL = ref1.isClientTabletL;
    var ref2 = (0,react.useState)(false), arrowsIsActive = ref2[0], setArrowsIsActive = ref2[1];
    var ref3 = (0,react.useState)(false), increaseCardSize = ref3[0], setIncreaseCardSize = ref3[1];
    var isVertical = setIsVertical(isClientMobile, isCrmProductListVertical, orientation);
    var ref4 = (0,react.useState)(calculateSlidesToShow(isVertical, isCrmProductListVertical, isClientDesktop, isClientMobile, arrowsIsActive)), slidesToShow = ref4[0], setSlidesToShow = ref4[1];
    var userCrmId = (0,state_manager/* useCrm */.K3)(function(state) {
        return state.userCrmId;
    });
    var productCardVertical = Boolean(isVertical && (isCrmProductListVertical || isClientMobile) && (router === null || router === void 0 ? void 0 : router.route) !== "/pesquisa/[term]");
    var heightsFromProducts = productCards === null || productCards === void 0 ? void 0 : productCards.map(function(product) {
        var ref, ref1, ref2, ref3, ref4;
        var minHeight = 292;
        var heightBlackFriday = (product === null || product === void 0 ? void 0 : product.isBlackFriday) ? 24 : 0;
        var heightCoupon = (product === null || product === void 0 ? void 0 : (ref = product.coupons) === null || ref === void 0 ? void 0 : ref.length) ? 18 : 0;
        var heightSpotPrice = (0,application/* getSpotPrice */.$XT)(product) ? 13 : 0;
        var heightInstallments = (product === null || product === void 0 ? void 0 : (ref1 = product.prices) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.maxNumberInstallments) > 1 ? 17 : 0;
        var heightTagProduct = (product === null || product === void 0 ? void 0 : (ref3 = product.tag) === null || ref3 === void 0 ? void 0 : ref3.title) || (product === null || product === void 0 ? void 0 : (ref4 = product.tagProduct) === null || ref4 === void 0 ? void 0 : ref4.title) ? 24 : 0;
        return heightBlackFriday + heightCoupon + heightSpotPrice + heightInstallments + heightTagProduct + minHeight;
    });
    var maxHeightForProductCards = heightsFromProducts ? (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(heightsFromProducts)) : 292;
    var productListTheme = productListBlackFridayTheme === null || productListBlackFridayTheme === void 0 ? void 0 : productListBlackFridayTheme.horizontal;
    var linkConfig = (0,utils/* useGetBranchLinkConfig */._e)(config === null || config === void 0 ? void 0 : config.branches);
    handleComponentWarnings(config === null || config === void 0 ? void 0 : config.branches, (0,application/* useCurrentPathName */.Y0L)(), position, productCards);
    var handleViewMoreClick = function() {
        setSlidesToShow(function(previousSlidesToShow) {
            return (productCards === null || productCards === void 0 ? void 0 : productCards.length) > previousSlidesToShow ? slidesToShowValueIncrement(previousSlidesToShow) : previousSlidesToShow;
        });
    };
    (0,react.useEffect)(function() {
        if (Number(quantity) === 6 && (productCards === null || productCards === void 0 ? void 0 : productCards.length) === 6 && showArrows === "true" || Number(quantity) > 6 || (productCards === null || productCards === void 0 ? void 0 : productCards.length) > 6) setArrowsIsActive(true);
        if (isVertical && productCardVertical) {
            setArrowsIsActive(false);
            setIncreaseCardSize(false);
        }
        if (Number(quantity) === 6 || (productCards === null || productCards === void 0 ? void 0 : productCards.length) === 6 && showArrows === "true") setIncreaseCardSize(true);
        if (Number(quantity) > 6 || (productCards === null || productCards === void 0 ? void 0 : productCards.length) > 6) setIncreaseCardSize(true);
    }, [
        isClientDesktop,
        isVertical,
        orientation,
        position,
        productCardVertical,
        productCards,
        quantity,
        showArrows, 
    ]);
    (0,react.useEffect)(function() {
        setSlidesToShow(calculateSlidesToShow(isVertical, isCrmProductListVertical, isClientDesktop, isClientMobile, arrowsIsActive));
    }, [
        isClientDesktop,
        isClientMobile,
        isVertical,
        arrowsIsActive,
        isCrmProductListVertical, 
    ]);
    var shouldCentralizeCards = (0,react.useCallback)(function() {
        return Number(quantity) <= 3;
    }, [
        quantity
    ]);
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProductList_styles/* SkeletonContainer */.Fh, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
                type: "card",
                count: isClientTablet ? 3 : 5,
                width: 210,
                height: 360
            })
        });
    }
    if (Boolean((crm === null || crm === void 0 ? void 0 : crm.needCrmUserId) && Boolean(!userCrmId)) || Boolean(!(productCards === null || productCards === void 0 ? void 0 : productCards.length) && !isLoading)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomProductList_styles/* CustomProductListContainer */.We, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: crm ? "ins-preview-wrapper-".concat(crm.campaignVariationId) : ""
    }, (0,application/* buildTestIds */.Fek)("custom-product-list-container")), {
        increaseCardSize: increaseCardSize,
        customTheme: productListBlackFridayTheme,
        isVertical: isVertical,
        isBlackFriday: isBlackTheme,
        isCrmProductListVertical: isCrmProductListVertical,
        children: [
            showTitle === "true" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomProductList_styles/* ProductListHeader */.zY, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                increaseCardSize: increaseCardSize
            }, (0,application/* buildTestIds */.Fek)("product-list-header")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProductList_styles/* ProductListTitle */.IR, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-list-header-title")), {
                        color: productListTheme === null || productListTheme === void 0 ? void 0 : productListTheme.titleColor,
                        href: "/".concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url),
                        target: linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.target,
                        isCrmComponent: isCrmComponent,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProductList_styles/* CustomStoriesTitle */.Su, {
                            children: title
                        })
                    })),
                    showCta && showCta === "true" && !isCrmComponent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomProductList_styles/* CtaButton */.dI, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-list-header-cta-button")), {
                        color: productListTheme === null || productListTheme === void 0 ? void 0 : productListTheme.ctaButton.textColor.default,
                        mouseOver: {
                            color: (productListTheme === null || productListTheme === void 0 ? void 0 : productListTheme.ctaButton.textColor.hover) || ui.theme.colors.primary[200]
                        },
                        href: "/".concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url),
                        target: linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.target,
                        "aria-label": "Visualizar todos ao clicar aqui",
                        children: [
                            isClientTablet ? null : ctaText,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.RightArrowProduct, {
                                alt: "Seta para direita",
                                color: productListTheme === null || productListTheme === void 0 ? void 0 : productListTheme.ctaButton.textColor.default
                            })
                        ]
                    }))
                ]
            })),
            (isVertical || !isClientTablet) && (!isCrmProductListVertical || !isClientTabletL) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProductListSlider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-product-list-slider")), {
                crm: crm,
                customTheme: productListTheme === null || productListTheme === void 0 ? void 0 : productListTheme.sliderButton,
                arrowsIsActive: arrowsIsActive,
                isBlackFriday: isBlackTheme,
                slidesToShow: slidesToShow,
                productCards: productCards,
                isVertical: isVertical,
                height: productCardVertical ? 198 : maxHeightForProductCards,
                isCrmProductList: isCrmProductList,
                isCrmProductListMinimalist: isCrmProductListMinimalist
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProductList_styles/* ProductCardContainer */.hd, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: crm ? "ins-web-smart-recommender-body" : "",
                "data-recommended-items": crm === null || crm === void 0 ? void 0 : crm.recommendedProductsId,
                centralizeCards: shouldCentralizeCards()
            }, (0,application/* buildTestIds */.Fek)("product-card-container")), {
                children: isCrmProductList ? productCards === null || productCards === void 0 ? void 0 : productCards.map(function(product) {
                    return /*#__PURE__*/ (0,react.createElement)(RecommendationCarouselProductCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-card")), {
                        key: "".concat(product.id),
                        item: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                            index: productCards.indexOf(product)
                        }),
                        isPlaylist: false,
                        preloadComponent: preloadComponent,
                        isMinimalist: isCrmProductListMinimalist
                    }));
                }) : productCards === null || productCards === void 0 ? void 0 : productCards.map(function(product) {
                    return /*#__PURE__*/ (0,react.createElement)(ProductCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-card")), {
                        key: "".concat(product.id),
                        item: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                            index: productCards.indexOf(product)
                        }),
                        shouldShowInGridOnMobile: false,
                        isPlaylist: true,
                        preloadComponent: preloadComponent
                    }));
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProductList_styles/* ContainerView */.o6, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("container-view")), {
                children: setShouldRenderButtonViewMore(isVertical, productCards, slidesToShow, isCrmProductListVertical) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomProductList_styles/* ButtonViewMore */.AS, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-view-more")), {
                    onClick: handleViewMoreClick,
                    children: [
                        showCta && showCta === "true" && ctaText,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowFilledDown, {
                            alt: "Seta para baixo"
                        })
                    ]
                }))
            }))
        ]
    }));
}, propsAreEqual);
CustomProductList.displayName = "CustomProductList";



/***/ }),

/***/ 36348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AS": function() { return /* binding */ ButtonViewMore; },
/* harmony export */   "BL": function() { return /* binding */ ButtonArrowPrev; },
/* harmony export */   "Fh": function() { return /* binding */ SkeletonContainer; },
/* harmony export */   "IR": function() { return /* binding */ ProductListTitle; },
/* harmony export */   "Lo": function() { return /* binding */ ContainerProduct; },
/* harmony export */   "Su": function() { return /* binding */ CustomStoriesTitle; },
/* harmony export */   "We": function() { return /* binding */ CustomProductListContainer; },
/* harmony export */   "d8": function() { return /* binding */ ProductCardDiv; },
/* harmony export */   "dI": function() { return /* binding */ CtaButton; },
/* harmony export */   "hd": function() { return /* binding */ ProductCardContainer; },
/* harmony export */   "j6": function() { return /* binding */ ContainerCarousel; },
/* harmony export */   "lk": function() { return /* binding */ ButtonArrowNext; },
/* harmony export */   "o6": function() { return /* binding */ ContainerView; },
/* harmony export */   "zY": function() { return /* binding */ ProductListHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17335);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      pointer-events: none;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  background: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n\n    @media ",
        "\n      overflow-y: visible;\n    }\n      \n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 25rem;\n  width: 90px;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          padding: ",
        ";\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          padding: ",
        " ",
        " ",
        "\n            ",
        ";\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-bottom: ",
        ";\n\n  ",
        "\n\n  @media ",
        " {\n    padding: ",
        ";\n  }\n\n  @media ",
        " {\n    padding: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        ";\n  border: none;\n  cursor: pointer;\n  color: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n\n  &:path {\n    stroke: ",
        ";\n  }\n\n  &:hover path {\n    stroke: ",
        ";\n  }\n\n  &:hover {\n    transition: color 0.5s ease-in-out;\n  }\n\n  svg {\n    margin-top: 5px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  height: 60px;\n  width: 60px;\n\n  border-radius: 35px;\n  padding: 0px 0px 0px ",
        ";\n  background: ",
        ";\n  z-index: 5;\n  margin-left: -5px;\n\n  &:hover {\n    background: ",
        ";\n    transition: 0.8s;\n  }\n\n  &:hover path {\n    stroke: ",
        ";\n  }\n\n  svg {\n    margin-top: 15px;\n    margin-left: 15px;\n  }\n\n  box-shadow: 0px 2px 2px ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 60px;\n  width: 60px;\n  border-radius: 35px;\n\n  padding: 0px 0px 0px ",
        ";\n  margin-right: 5px;\n\n  background: ",
        ";\n  z-index: 5;\n\n  box-shadow: 0px 2px 2px ",
        ";\n\n  &:hover path {\n    stroke: ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n    transition: 0.8s;\n  }\n\n  svg {\n    margin-top: 15px;\n    margin-left: 21px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  height: 37px;\n  width: 100vw;\n  border-radius: ",
        ";\n  color: ",
        ";\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1rem;\n  gap: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 400px;\n  width: 1px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        justify-content: center;\n      "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      @media ",
        " {\n        overflow-y: visible;\n        margin-left: 0;\n      }\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  padding: ",
        " ",
        ";\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding-bottom: ",
        ";\n  height: 100%;\n\n  &::-webkit-scrollbar {\n    width: 2px;\n    height: 3px;\n    border-radius: ",
        ";\n  }\n\n  &::-webkit-scrollbar-thumb {\n    height: 2px;\n    width: 1px;\n    border-radius: ",
        ";\n    background: ",
        ";\n  }\n\n  @media ",
        " {\n    gap: ",
        ";\n    ",
        "\n\n    & > a {\n      min-width: 190px;\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          @media ",
        " {\n            padding: 0;\n\n            ",
        " {\n              padding: ",
        " ",
        " 0 ",
        ";\n              margin-bottom: 0;\n            }\n\n            ",
        " {\n              padding: 0;\n              font-size: ",
        ";\n              font-weight: ",
        ";\n              color: ",
        ";\n            }\n\n            .slick-slide > div {\n              padding: 0;\n            }\n          }\n        "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          @media (min-width: 1190px) {\n            padding: 0 1.34rem 0 22px;\n          }\n        "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          max-width: 1280px;\n          margin-left: auto;\n          margin-right: auto;\n          width: 100%;\n        "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          .slick-track {\n            padding-bottom: 0.5rem;\n            display: flex;\n            flex-direction: row;\n            transition: all 0.5ms ease-in-out;\n\n            @media ",
        " {\n              margin-left: 10px;\n            }\n          }\n        "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          .slick-track {\n            max-height: 100vh;\n            padding: ",
        ";\n          }\n        "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      .slick-slide {\n        width: 226px !important;\n        margin: 0px 9px;\n      }\n\n      .slick-slide:first-child {\n        margin: 0px 9px 0px 0px;\n      }\n\n      @media ",
        " {\n        .slick-slide {\n          width: 190px !important;\n          margin: 0px 5px;\n        }\n\n        .slick-slide:first-child {\n          margin: 0px 5px 0px 12px;\n        }\n      }\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            width: 226px;\n            height: 100%;\n          "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            width: 192px;\n            @media (max-width: 1024px) {\n              width: 205px;\n            }\n          "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n\n          width: 100%;\n\n          @media ",
        "\n            padding: 0 8px;\n          }     \n          "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            max-width: 100%;\n            height: 100%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            padding: 0 10px;\n          "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              width: 100%;\n            "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              width: 191px;\n            "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              width: 205px;\n            "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          overflow-x: scroll;\n          overflow-y: hidden;\n        "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      .slick-track {\n        width: fit-content !important;\n        overflow: hidden;\n      }\n    "
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      .slick-slide:first-child {\n        margin-left: 0px !important;\n      }\n\n      @media ",
        " {\n        .slick-track {\n          overflow: visible;\n        }\n      }\n    "
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      .slick-slide {\n        width: 191px !important;\n        margin: 0px 5px;\n\n        @media ",
        " {\n          width: 203px !important;\n        }\n\n        @media ",
        " {\n          margin: 0px 7px;\n        }\n\n        @media ",
        " {\n          .slick-slide:first-child {\n            margin-left: 0px;\n          }\n\n          .slick-slide:last-child {\n            margin-right: 0px;\n          }\n\n          .slick-slide {\n            margin: 0px 9px;\n          }\n        }\n      }\n\n      .slick-slide:first-child {\n        margin: 0px 5px 0px 12px;\n      }\n\n      .slick-slide:last-child {\n        margin: 0px 12px 0px 5px;\n      }\n    "
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        background: ",
        ";\n        color: ",
        ";\n      "
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      .slick-slider {\n        @media ",
        " {\n          padding: 0px 15px;\n        }\n\n        & > .slick-next,\n        .slick-prev {\n          display: flex !important;\n          justify-content: center;\n          align-items: center;\n          padding: 0px !important;\n\n          & > svg {\n            margin: 0px !important;\n          }\n        }\n\n        & > .slick-next {\n          margin-right: 15px !important;\n        }\n\n        & > .slick-prev {\n          margin-left: 9px !important;\n        }\n\n        @media ",
        " {\n          padding: 0px;\n        }\n      }\n    "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      .slick-slide {\n        margin: 4px 0px;\n      }\n    "
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        .slick-track {\n          width: 161.7% !important;\n        }\n\n        .slick-slide:last-child {\n          margin-right: 28px;\n        }\n      "
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n    \n\n  .slick-slide > div {\n    ",
        "\n  }\n\n  @media (max-width: 1014px) and (min-width: 769px) {\n    ",
        " {\n      overflow-x: auto;\n    }\n  }\n\n  @media (min-width: 769px) and (max-width: 1260px) {\n    .slick-slide > div {\n      ",
        ";\n    }\n\n    .slick-list {\n      ",
        "\n    }\n  }\n\n  .slick-list {\n    padding: 0.6rem 0;\n    width: 100%;\n  }\n\n  ",
        "\n\n  ",
        "\n\n  .slick-track {\n    @media ",
        " {\n      padding-top: ",
        ";\n    }\n  }\n\n  .slick-prev:before {\n    display: none;\n  }\n\n  .slick-next:before {\n    display: none;\n  }\n\n  .slick-disabled {\n    background: ",
        " !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n\n    &:hover {\n      background: ",
        ";\n    }\n    cursor: default !important;\n\n    path {\n      stroke: ",
        ";\n    }\n\n    &:hover path {\n      stroke: ",
        ";\n    }\n  }\n\n  ",
        "\n\n  ",
        " {\n    ",
        "\n  }\n\n  .slick-track {\n    padding-top: 0.5rem;\n  }\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: 1025px) and (max-width: 1260px) {\n    .slick-slide > div {\n      width: 100%;\n    }\n\n    .slick-slider {\n      padding: 0px;\n    }\n\n    .slick-slide:first-child {\n      margin-left: 12px;\n    }\n\n    .slick-slide:last-child {\n      margin-right: 12px;\n    }\n\n    ",
        "\n  }\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: ",
        ";\n  justify-content: center;\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}



var ProductListTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r).withConfig({
    displayName: "styles__ProductListTitle",
    componentId: "sc-caad8445-0"
})(_templateObject1(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.md.x3, function(param) {
    var color = param.color;
    return color || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[520];
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x9, function(param) {
    var isCrmComponent = param.isCrmComponent;
    return isCrmComponent && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject());
});
var CustomStoriesTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    displayName: "styles__CustomStoriesTitle",
    componentId: "sc-caad8445-1"
})(_templateObject2(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.md.x3);
var ContainerCarousel = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ContainerCarousel",
    componentId: "sc-caad8445-2"
})(_templateObject3(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[50]);
var ContainerProduct = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__ContainerProduct",
    componentId: "sc-caad8445-3"
})(_templateObject5(), function(param) {
    var isCrmProductListVertical = param.isCrmProductListVertical;
    return isCrmProductListVertical && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.mobileFirst.tabletL);
});
var ProductListHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    displayName: "styles__ProductListHeader",
    componentId: "sc-caad8445-4"
})(_templateObject8(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x5, function(param) {
    var increaseCardSize = param.increaseCardSize;
    return increaseCardSize ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6(), "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, " ").concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6, " ").concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, " ").concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3, "\n            ")) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x5, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4);
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet, "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, " ").concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space["x2.5"], " ").concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, "\n      ").concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0);
var CtaButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r).withConfig({
    displayName: "styles__CtaButton",
    componentId: "sc-caad8445-5"
})(_templateObject9(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3, function(param) {
    var color = param.color;
    return color || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[520];
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x7, function(param) {
    var color = param.color;
    return color || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[520];
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200]);
var ButtonArrowPrev = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ButtonArrowPrev",
    componentId: "sc-caad8445-6"
})(_templateObject10(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral["999-opacity-60"]);
var ButtonArrowNext = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ButtonArrowNext",
    componentId: "sc-caad8445-7"
})(_templateObject11(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral["999-opacity-60"], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200]);
var ButtonViewMore = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "styles__ButtonViewMore",
    componentId: "sc-caad8445-8"
})(_templateObject12(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200], ui__WEBPACK_IMPORTED_MODULE_1__.theme.space["x0.5"], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1);
var ProductCardDiv = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ProductCardDiv",
    componentId: "sc-caad8445-9"
})(_templateObject13());
var ContainerView = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ContainerView",
    componentId: "sc-caad8445-10"
})(_templateObject14(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space["x2.5"]);
var ProductCardContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ProductCardContainer",
    componentId: "sc-caad8445-11"
})(_templateObject17(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space["x2.5"], ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[150], ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, function(param) {
    var centralizeCards = param.centralizeCards;
    return centralizeCards && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject15());
}, function(param) {
    var isCrmProductListVertical = param.isCrmProductListVertical;
    return isCrmProductListVertical && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject16(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.mobileFirst.tabletL);
});
var CustomProductListContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__CustomProductListContainer",
    componentId: "sc-caad8445-12"
})(_templateObject40(), function(param) {
    var isCrmProductListVertical = param.isCrmProductListVertical;
    return isCrmProductListVertical ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject18(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.mobileFirst.tabletL, ProductListHeader, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ProductListTitle, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x7, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[600], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[550]) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject19());
}, function(param) {
    var isVertical = param.isVertical;
    return isVertical === false ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject20()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject21());
}, function(param) {
    var isVertical = param.isVertical;
    return isVertical === false ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject22(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject23(), "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, " 0"));
}, function(param) {
    var isVertical = param.isVertical;
    return !isVertical && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject24(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.laptop);
}, function(param) {
    var isVertical = param.isVertical, increaseCardSize = param.increaseCardSize, isCrmProductListVertical = param.isCrmProductListVertical;
    return !isVertical && increaseCardSize ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject25()) : !increaseCardSize && !isVertical ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject26()) : isCrmProductListVertical ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject27(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.mobileFirst.tabletL) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject28());
}, ProductCardContainer, function(param) {
    var isCrmProductListVertical = param.isCrmProductListVertical, increaseCardSize = param.increaseCardSize;
    return isCrmProductListVertical ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject29()) : increaseCardSize ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject30()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject31());
}, function(param) {
    var increaseCardSize = param.increaseCardSize;
    return !increaseCardSize && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject32());
}, function(param) {
    var isVertical = param.isVertical;
    return !isVertical && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject33());
}, function(param) {
    var isCrmProductListVertical = param.isCrmProductListVertical;
    return isCrmProductListVertical && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject34(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.mobileFirst.tabletL);
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3, function(param) {
    var customTheme = param.customTheme;
    var ref;
    return ((ref = customTheme === null || customTheme === void 0 ? void 0 : customTheme.horizontal.sliderButton.backgroundColor) === null || ref === void 0 ? void 0 : ref.disabled) || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[50];
}, function(param) {
    var customTheme = param.customTheme;
    var ref;
    return ((ref = customTheme === null || customTheme === void 0 ? void 0 : customTheme.horizontal.sliderButton.backgroundColor) === null || ref === void 0 ? void 0 : ref.disabled) || ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[50];
}, function(param) {
    var isBlackFriday = param.isBlackFriday;
    var ref, ref1;
    return isBlackFriday ? "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme === null || ui__WEBPACK_IMPORTED_MODULE_1__.theme === void 0 ? void 0 : (ref = ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["40"], " !important") : "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[99], " !important");
}, function(param) {
    var isBlackFriday = param.isBlackFriday;
    var ref, ref1;
    return isBlackFriday ? "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme === null || ui__WEBPACK_IMPORTED_MODULE_1__.theme === void 0 ? void 0 : (ref = ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["40"], " !important") : "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[99], " !important");
}, function(param) {
    var increaseCardSize = param.increaseCardSize, isVertical = param.isVertical;
    return !increaseCardSize && !isVertical && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject35(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.laptop, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.desktop, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.desktop);
}, ButtonViewMore, function(param) {
    var customTheme = param.customTheme;
    return (customTheme === null || customTheme === void 0 ? void 0 : customTheme.vertical.seeMoreButton) && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject36(), customTheme.vertical.seeMoreButton.backgroundColor.default, customTheme.vertical.seeMoreButton.textColor.default);
}, function(param) {
    var isVertical = param.isVertical, increaseCardSize = param.increaseCardSize;
    return !isVertical && increaseCardSize && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject37(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.desktop, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.laptop);
}, function(param) {
    var isVertical = param.isVertical;
    return isVertical && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject38());
}, function(props) {
    return props.increaseCardSize && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject39());
});
var SkeletonContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__SkeletonContainer",
    componentId: "sc-caad8445-13"
})(_templateObject41(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4);


/***/ }),

/***/ 28286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ CustomStories; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomStories/data.ts
var customStoriesData = function(properties) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var title = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var showTitle = (ref1 = properties.find(function(param) {
        var key = param.key;
        return key === "showTitle";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var textAlign = (ref2 = properties.find(function(param) {
        var key = param.key;
        return key === "textAlign";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var subTitle = (ref3 = properties.find(function(param) {
        var key = param.key;
        return key === "subTitle";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var showSubTitle = (ref4 = properties.find(function(param) {
        var key = param.key;
        return key === "showSubTitle";
    })) === null || ref4 === void 0 ? void 0 : ref4.value;
    var format = (ref5 = properties.find(function(param) {
        var key = param.key;
        return key === "format";
    })) === null || ref5 === void 0 ? void 0 : ref5.value;
    var size = (ref6 = properties.find(function(param) {
        var key = param.key;
        return key === "size";
    })) === null || ref6 === void 0 ? void 0 : ref6.value;
    var hasShadow = (ref7 = properties.find(function(param) {
        var key = param.key;
        return key === "hasShadow";
    })) === null || ref7 === void 0 ? void 0 : ref7.value;
    return {
        title: title,
        showTitle: showTitle,
        textAlign: textAlign,
        subTitle: subTitle,
        showSubTitle: showSubTitle,
        format: format,
        size: size,
        hasShadow: hasShadow
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../packages/infra/components/lib/SwiperJS/styles.ts
var styles = __webpack_require__(7090);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/Image/index.tsx
var Image = __webpack_require__(25926);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomStories/SubComponents/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin: 2px 0 10px 0;\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n\n  ",
        ";\n\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  gap: 8px;\n\n  box-shadow: ",
        ";\n\n  @media ",
        " {\n    width: ",
        "px;\n  }\n\n  @media ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: inherit;\n\n  height: ",
        "px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: ",
        ";\n\n  box-shadow: ",
        ";\n\n  border-radius: ",
        ";\n\n  @media ",
        " {\n    width: inherit;\n    height: ",
        "px;\n  }\n\n  @media ",
        " {\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n\n  width: ",
        ";\n\n  height: ",
        ";\n\n  background-color: ",
        ";\n\n  border-radius: ",
        ";\n\n  border-color: ",
        ";\n\n  @media ",
        " {\n    width: ",
        ";\n\n    height: ",
        ";\n  }\n\n  @media ",
        " {\n    width: ",
        ";\n\n    height: ",
        ";\n  }\n\n  box-shadow: ",
        " !important;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  padding: ",
        " !important;\n  border-radius: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            width: ",
        ";\n            height: ",
        ";\n          "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: ",
        ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  padding: 3px ",
        ";\n\n  background: ",
        ";\n\n  border: ",
        "\n    solid ",
        ";\n  border-radius: ",
        ";\n\n  @media ",
        " {\n    ",
        "\n\n    border-size: 1.5px solid ",
        ";\n    margin-bottom: -2px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n\n  @media ",
        " {\n    font-size: ",
        "px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  background-color: ",
        ";\n\n  line-height: 1;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n  word-break: break-word;\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-c1f401af-0"
})(_templateObject1(), function(param) {
    var format = param.format;
    switch(format){
        case "circle":
            return 152;
        case "squircle":
            return 142;
        case "square":
            return 158;
        case "rectangle":
            return 180;
        default:
            return 152;
    }
}, function(param) {
    var format = param.format;
    return format && format === "square" || format === "rectangle" ? (0,styled_components_browser_esm/* css */.iv)(_templateObject()) : null;
}, function(param) {
    var hasShadow = param.hasShadow, format = param.format;
    return hasShadow && hasShadow === "true" && (format === "rectangle" || format === "square") ? "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x1, " ").concat(ui.theme.space.x2, " rgba(0, 0, 0, 0.1)") : "none";
}, ui.theme.device.desktopFirst.tablet, function(param) {
    var format = param.format;
    switch(format){
        case "circle":
            return 112;
        case "squircle":
            return 110;
        case "square":
            return 130;
        case "rectangle":
            return 180;
        default:
            return 112;
    }
}, ui.theme.device.desktopFirst.mobileXL, function(param) {
    var size = param.size, format = param.format;
    if (size === "small") {
        switch(format){
            case "circle":
                return "70px";
            case "squircle":
                return "70px";
            default:
                return "100%";
        }
    }
    switch(format){
        case "circle":
            return "112px";
        case "squircle":
            return "110px";
        case "square":
            return "130px";
        case "rectangle":
            return "126px";
        default:
            return "112px";
    }
});
var ImageSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ImageSection",
    componentId: "sc-c1f401af-1"
})(_templateObject2(), function(param) {
    var format = param.format;
    switch(format){
        case "circle":
            return 152;
        case "squircle":
            return 142;
        case "square":
            return 158;
        case "rectangle":
            return 120;
        default:
            return 152;
    }
}, function(param) {
    var color = param.color, format = param.format;
    var ref;
    return format && format === "square" || format && format === "rectangle" ? "white" : color === "green" ? "linear-gradient(45deg, ".concat(ui.theme.colors.secondary[430], ", ").concat(ui.theme.colors.secondary[390], ", ").concat(ui.theme.colors.secondary[40], ")") : color === "red" ? "".concat(ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : ref.primary["150"]) : "none";
}, function(param) {
    var hasShadow = param.hasShadow, format = param.format, color = param.color;
    return hasShadow === "true" && color !== "" && format !== "square" && format !== "rectangle" ? "0 2px 4px rgba(0, 0, 0, 0.1)" : "none";
}, function(param) {
    var format = param.format;
    return format && format === "circle" ? "50%" : format === "squircle" ? "30%" : 0;
}, ui.theme.device.desktopFirst.tablet, function(param) {
    var format = param.format;
    switch(format){
        case "circle":
            return 112;
        case "squircle":
            return 110;
        case "square":
            return 130;
        case "rectangle":
            return 120;
        default:
            return 112;
    }
}, ui.theme.device.desktopFirst.mobileXL, function(param) {
    var size = param.size, format = param.format;
    if (size === "small") {
        switch(format){
            case "circle":
                return "70px";
            case "squircle":
                return "70px";
            default:
                return "100%";
        }
    }
    switch(format){
        case "circle":
            return "112px";
        case "squircle":
            return "110px";
        case "square":
            return "130px";
        case "rectangle":
            return "90px";
        default:
            return "112px";
    }
});
var StoriesImageContainer = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    displayName: "styles__StoriesImageContainer",
    componentId: "sc-c1f401af-2"
})(_templateObject3(), function(param) {
    var format = param.format;
    switch(format){
        case "circle":
            return "146px";
        case "squircle":
            return "138px";
        case "square":
            return "100%";
        case "rectangle":
            return "100%";
        default:
            return "146px";
    }
}, function(param) {
    var format = param.format;
    switch(format){
        case "circle":
            return "146px";
        case "squircle":
            return "138px";
        case "square":
            return "100%";
        case "rectangle":
            return "100%";
        default:
            return "146px";
    }
}, function(param) {
    var themeBlackFriday = param.themeBlackFriday;
    return themeBlackFriday ? "transparent" : ui.theme.colors.neutral["white-075"];
}, function(param) {
    var format = param.format;
    return format === "circle" ? "50%" : format === "squircle" ? "30%" : 0;
}, function(param) {
    var color = param.color, format = param.format;
    return format && format === "square" || format === "rectangle" ? "white" : color === "green" ? "linear-gradient(45deg, ".concat(ui.theme.colors.secondary[430], ", ").concat(ui.theme.colors.secondary[390], ", ").concat(ui.theme.colors.secondary[40], ")") : color === "red" ? "linear-gradient(330deg, ".concat(ui.theme.colors.primary[150], ", ").concat(ui.theme.colors.yellow[40], ", ").concat(ui.theme.colors.yellow[1000], ")") : "none";
}, ui.theme.device.desktopFirst.tablet, function(param) {
    var format = param.format;
    switch(format){
        case "circle":
            return "108px";
        case "squircle":
            return "106px";
        case "square":
            return "100%";
        case "rectangle":
            return "100%";
        default:
            return "108px";
    }
}, function(param) {
    var format = param.format;
    switch(format){
        case "circle":
            return "108px";
        case "squircle":
            return "106px";
        case "square":
            return "100%";
        case "rectangle":
            return "100%";
        default:
            return "108px";
    }
}, ui.theme.device.desktopFirst.mobileXL, function(param) {
    var size = param.size, format = param.format;
    if (size === "small") {
        switch(format){
            case "circle":
                return "64px";
            case "squircle":
                return "64px";
            default:
                return "100%";
        }
    }
    switch(format){
        case "circle":
            return "108px";
        case "squircle":
            return "106px";
        default:
            return "100%";
    }
}, function(param) {
    var size = param.size, format = param.format;
    if (size === "small") {
        switch(format){
            case "circle":
                return "64px";
            case "squircle":
                return "64px";
            default:
                return "100%";
        }
    }
    switch(format){
        case "circle":
            return "108px";
        case "squircle":
            return "106px";
        default:
            return "100%";
    }
}, function(param) {
    var hasShadow = param.hasShadow, color = param.color, format = param.format;
    return hasShadow && hasShadow === "true" && !color && format && format !== "square" ? "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x1, " ").concat(ui.theme.space.x2, " ").concat(ui.theme.colors.neutral["999-opacity-10"]) : "none";
});
var StoriesImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* Image */.E).withConfig({
    displayName: "styles__StoriesImage",
    componentId: "sc-c1f401af-3"
})(_templateObject4(), function(param) {
    var color = param.color, format = param.format;
    return color !== "" && format !== "rectangle" && format !== "square" ? "3px" : null;
}, function(param) {
    var format = param.format;
    return format && format === "circle" ? "50%" : format === "squircle" ? "30%" : 0;
});
var Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Badge",
    componentId: "sc-c1f401af-4"
})(_templateObject6(), ui.theme.space.x0, ui.theme.space.x2, function(param) {
    var color = param.color;
    return color && color === "green" ? "linear-gradient(45deg, ".concat(ui.theme.colors.secondary[430], ", ").concat(ui.theme.colors.secondary[390], ", ").concat(ui.theme.colors.secondary[40], ")") : color === "red" ? "".concat(ui.theme.colors.primary[150]) : "none";
}, function(param) {
    var size = param.size;
    return size && size === "small" ? "".concat(ui.theme.space["x0.5"]) : "3px";
}, ui.theme.colors.neutral.white, ui.theme.space.x5, ui.theme.device.desktopFirst.mobileXL, function(param) {
    var size = param.size;
    return size && size === "small" ? (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), ui.theme.space.x10, ui.theme.space.x5) : null;
}, ui.theme.colors.neutral.white);
var BadgeText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BadgeText",
    componentId: "sc-c1f401af-5"
})(_templateObject7(), ui.theme.typography.fontSize.md.x1, ui.theme.typography.fontWeight[600], ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.mobileXL, function(param) {
    var size = param.size;
    return size && size === "small" ? "8" : "20";
});
var TitleSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__TitleSection",
    componentId: "sc-c1f401af-6"
})(_templateObject8(), function(param) {
    var hasBackground = param.hasBackground;
    return hasBackground ? "".concat(ui.theme.colors.neutral.white) : "transparent";
});
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__Title",
    componentId: "sc-c1f401af-7"
})(_templateObject9(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[550];
}, ui.theme.device.desktopFirst.mobileXL, function(param) {
    var size = param.size;
    return size && size === "small" ? "10px" : "".concat(ui.theme.typography.fontSize.sm.x5);
});

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomStories/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  max-width: 1320px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  font-size: 30px;\n  font-weight: ",
        ";\n  color: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media ",
        " {\n    font-size: 22px;\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            .swiper-button-next,\n            .swiper-button-prev {\n              top: 80%;\n              transform: translateY(-50%);\n            }\n\n            .swiper-initialized {\n              max-width: 1280px;\n            }\n          "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          border-color: ",
        ";\n        "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n        "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n        "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            color: ",
        " !important;\n          "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        ",
        "\n      }\n      ",
        " {\n        ",
        "\n      }\n      ",
        " {\n        ",
        "\n      }\n      ",
        " {\n        * {\n          ",
        "\n        }\n      }\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n\n  max-width: 1440px;\n  margin: 0 auto;\n  width: 100%;\n\n  div.slick-slide {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  @media ",
        " {\n    padding: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var StoriesContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StoriesContent",
    componentId: "sc-ba6e2b60-0"
})(styles_templateObject());
var ComponentHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ComponentHeader",
    componentId: "sc-ba6e2b60-1"
})(styles_templateObject1(), function(param) {
    var textAlign = param.textAlign;
    return textAlign !== null && textAlign !== void 0 ? textAlign : "left";
});
var StoriesTitle = (0,styled_components_browser_esm/* default */.ZP)(ui.Title).withConfig({
    displayName: "styles__StoriesTitle",
    componentId: "sc-ba6e2b60-2"
})(styles_templateObject2(), function(param) {
    var showTitle = param.showTitle;
    return showTitle === "true" ? "block" : "none";
});
var CustomStoriesTitle = (0,styled_components_browser_esm/* default */.ZP)(ui.H2).withConfig({
    displayName: "styles__CustomStoriesTitle",
    componentId: "sc-ba6e2b60-3"
})(styles_templateObject3(), function(param) {
    var showTitle = param.showTitle;
    return showTitle === "true" ? "block" : "none";
}, ui.theme.typography.fontWeight.normal, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[520];
}, ui.theme.space.x1, ui.theme.device.desktopFirst.mobileXL);
var StoriesSubtitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__StoriesSubtitle",
    componentId: "sc-ba6e2b60-4"
})(styles_templateObject4(), function(param) {
    var showSubTitle = param.showSubTitle;
    return showSubTitle === "true" ? "block" : "none";
}, ui.theme.typography.fontSize.md.x3, ui.theme.typography.fontWeight.normal, ui.theme.colors.neutral[330], ui.theme.space.x7, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x7, function(param) {
    var size = param.size;
    return size === "small" ? "".concat(ui.theme.space.x3) : "".concat(ui.theme.space.x7);
});
var ComponentBody = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ComponentBody",
    componentId: "sc-ba6e2b60-5"
})(styles_templateObject6(), styles/* SwiperContainer */.mn, function(param) {
    var format = param.format;
    return format && format === "rectangle" ? (0,styled_components_browser_esm/* css */.iv)(styles_templateObject5()) : null;
});
var CustomStoriesContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CustomStoriesContainer",
    componentId: "sc-ba6e2b60-6"
})(_templateObject12(), function(param) {
    var format = param.format;
    return "".concat(ui.theme.space.x1, "\n    ").concat(format && format === "rectangle" ? ui.theme.space.x4 : ui.theme.space.x20);
}, ui.theme.device.desktopFirst.laptop, function(param) {
    var format = param.format;
    return "".concat(ui.theme.space.x1, "\n        ").concat(format && format === "rectangle" ? ui.theme.space.x2 : ui.theme.space.x8);
}, function(param) {
    var customTheme = param.customTheme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), Badge, customTheme && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject7(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["185"]), CustomStoriesTitle, customTheme && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject8(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref2 = ui.theme.colors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.blackFriday) === null || ref3 === void 0 ? void 0 : ref3["15"]), StoriesSubtitle, customTheme && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject9(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref4 = ui.theme.colors) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.blackFriday) === null || ref5 === void 0 ? void 0 : ref5["35"]), TitleSection, customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref6 = ui.theme.colors) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.blackFriday) === null || ref7 === void 0 ? void 0 : ref7["15"]));
});

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomStories/SubComponents/data.ts
var customStoriesSubComponentData = function(properties) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var title = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var showTitle = (ref1 = properties.find(function(param) {
        var key = param.key;
        return key === "showTitle";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var image = (ref2 = properties.find(function(param) {
        var key = param.key;
        return key === "image";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var hasBorder = (ref3 = properties.find(function(param) {
        var key = param.key;
        return key === "hasBorder";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var color = (ref4 = properties.find(function(param) {
        var key = param.key;
        return key === "color";
    })) === null || ref4 === void 0 ? void 0 : ref4.value;
    var hasBadge = (ref5 = properties.find(function(param) {
        var key = param.key;
        return key === "hasBadge";
    })) === null || ref5 === void 0 ? void 0 : ref5.value;
    var badgeText = (ref6 = properties.find(function(param) {
        var key = param.key;
        return key === "badgeText";
    })) === null || ref6 === void 0 ? void 0 : ref6.value;
    return {
        title: title,
        showTitle: showTitle,
        image: image,
        hasBorder: hasBorder,
        color: color,
        hasBadge: hasBadge,
        badgeText: badgeText
    };
};


// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
// EXTERNAL MODULE: ../../packages/components/backoffice/utils/index.tsx + 1 modules
var utils = __webpack_require__(60764);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomStories/SubComponents/index.tsx










var CustomStoriesSubComponent = /*#__PURE__*/ (0,react.memo)(function(param) {
    var config = param.config, properties = param.properties, index = param.index, positionComponent = param.positionComponent, format = param.format, size = param.size, hasShadow = param.hasShadow, _preloadComponent = param.preloadComponent, preloadComponent = _preloadComponent === void 0 ? false : _preloadComponent;
    var ref;
    var ref1 = customStoriesSubComponentData(properties), title = ref1.title, showTitle = ref1.showTitle, hasBorder = ref1.hasBorder, image = ref1.image, color = ref1.color, hasBadge = ref1.hasBadge, badgeText = ref1.badgeText;
    var appContext = (0,application/* useAppContext */.bp4)();
    var linkConfig = (0,utils/* useGetBranchLinkConfig */._e)(config === null || config === void 0 ? void 0 : config.branches, "subComponentStories");
    var currentPathName = (0,application/* useCurrentPathName */.Y0L)();
    if (!(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('Um subComponente de Stories, localizado em "'.concat(currentPathName, '", na posi\xe7\xe3o ').concat(positionComponent, ", n\xe3o possui nenhuma url (undefined)."), "warning");
    }
    if (!(config === null || config === void 0 ? void 0 : (ref = config.branches) === null || ref === void 0 ? void 0 : ref.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('Um subComponente de Stories, localizado em "'.concat(currentPathName, '", na posi\xe7\xe3o ').concat(positionComponent, ", n\xe3o possui nenhuma configura\xe7\xe3o de branches."), "warning");
    }
    if (!image) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("O subcomponente ".concat(index, " de Stories, na posi\xe7\xe3o ").concat(positionComponent, ', localizado em "').concat(currentPathName, '", n\xe3o possui imagem.'), "error");
        return null;
    }
    var hasBorderColorOnStories = hasBorder === "true" ? color : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-sub-component-container")), {
        size: size,
        format: format,
        hasShadow: hasShadow,
        as: (linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url) ? Link/* Link */.r : Container,
        href: "/".concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url),
        target: linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.target,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-sub-component-image-section")), {
                size: size,
                format: format,
                color: hasBorderColorOnStories,
                hasShadow: hasShadow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoriesImageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-sub-component-image-container")), {
                        size: size,
                        format: format,
                        color: hasBorderColorOnStories,
                        hasShadow: hasShadow,
                        themeBlackFriday: appContext === null || appContext === void 0 ? void 0 : appContext.isBlackTheme,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoriesImage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-sub-component-image")), {
                            color: hasBorderColorOnStories,
                            layout: "fill",
                            src: image,
                            alt: title || "Imagem do Stories",
                            format: format,
                            priority: preloadComponent
                        }))
                    })),
                    hasBadge === "true" && format !== "square" && format !== "rectangle" && hasBorder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-sub-component-badge")), {
                        color: color,
                        size: size,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-sub-component-badge-text")), {
                            size: size,
                            children: badgeText
                        }))
                    })) : null
                ]
            })),
            showTitle === "true" && format !== "rectangle" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-sub-component-title-section")), {
                hasBackground: format === "square",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-sub-component-title-section")), {
                    isBlackTheme: appContext === null || appContext === void 0 ? void 0 : appContext.isBlackTheme,
                    size: size,
                    children: title
                }))
            })) : null
        ]
    }));
});
CustomStoriesSubComponent.displayName = "CustomStories";


// EXTERNAL MODULE: ../../packages/components/Swiper/index.tsx
var Swiper = __webpack_require__(63665);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomStories/index.tsx










var CustomStories = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, subComponents = param.subComponents, position = param.position, isBlackTheme = param.isBlackTheme, _preloadComponent = param.preloadComponent, preloadComponent = _preloadComponent === void 0 ? false : _preloadComponent;
    var ref = customStoriesData(properties), title = ref.title, showTitle = ref.showTitle, textAlign = ref.textAlign, subTitle = ref.subTitle, showSubTitle = ref.showSubTitle, format = ref.format, size = ref.size, hasShadow = ref.hasShadow;
    var ref1 = (0,application/* useAppContext */.bp4)(), isClientDesktop = ref1.isClientDesktop, isClientLaptopM = ref1.isClientLaptopM, isClientLaptop = ref1.isClientLaptop, isClientTabletXL = ref1.isClientTabletXL, isClientTablet = ref1.isClientTablet, isClientTabletM = ref1.isClientTabletM, isClientTabletSmall = ref1.isClientTabletSmall, isClientMobile = ref1.isClientMobile, isClientMobileL = ref1.isClientMobileL;
    var storiesListVisibleOnMobile = subComponents === null || subComponents === void 0 ? void 0 : subComponents.filter(function(subComponent) {
        var ref, ref1, ref2;
        return subComponent === null || subComponent === void 0 ? void 0 : (ref = subComponent.config) === null || ref === void 0 ? void 0 : (ref1 = ref.branches) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.visibleOnMobile;
    });
    var storiesListVisibleOnDesktop = subComponents === null || subComponents === void 0 ? void 0 : subComponents.filter(function(subComponent) {
        var ref, ref1, ref2;
        return subComponent === null || subComponent === void 0 ? void 0 : (ref = subComponent.config) === null || ref === void 0 ? void 0 : (ref1 = ref.branches) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.visibleOnDesktop;
    });
    var finalStoriesList = isClientMobile ? storiesListVisibleOnMobile : storiesListVisibleOnDesktop;
    var storiesLength = (finalStoriesList === null || finalStoriesList === void 0 ? void 0 : finalStoriesList.length) || 0;
    var swiperConfigs = {
        effect: "slide",
        freeMode: true,
        sticky: "true",
        breakpoints: {
            1280: {
                speed: 500,
                freeMode: false,
                slidesPerGroup: 6,
                showNavigation: storiesLength > 6,
                slidesPerView: storiesLength < 6 ? storiesLength : 6
            },
            1024: {
                speed: 500,
                freeMode: false,
                slidesPerGroup: 5,
                showNavigation: storiesLength > 5,
                slidesPerView: storiesLength < 5 ? storiesLength : 5
            },
            850: {
                speed: 500,
                freeMode: false,
                slidesPerGroup: 4,
                showNavigation: storiesLength > 4,
                slidesPerView: storiesLength < 4 ? storiesLength : 4
            },
            768: {
                speed: 500,
                freeMode: false,
                slidesPerGroup: 3,
                showNavigation: storiesLength > 3,
                slidesPerView: storiesLength < 3 ? storiesLength : 3
            },
            600: {
                slidesPerView: storiesLength < 4 ? storiesLength : format === "rectangle" || format === "square" ? 2.7 : 4.5
            },
            576: {
                slidesPerView: storiesLength < 4 ? storiesLength : format === "square" || format === "rectangle" ? 2.7 : 4.5
            },
            480: {
                slidesPerView: storiesLength < 3 ? storiesLength : format === "rectangle" || format === "square" ? 2.3 : 3.4
            },
            425: {
                slidesPerView: storiesLength < 3 ? storiesLength : size === "small" ? 4.8 : 2.7
            },
            360: {
                slidesPerView: storiesLength < 3 ? storiesLength : size === "small" ? 4.4 : format === "square" || format === "rectangle" ? 2.2 : 2.4
            },
            320: {
                slidesPerView: storiesLength < 3 ? storiesLength : size === "small" ? 3.8 : format === "square" || format === "rectangle" ? 1.8 : 2.4
            }
        }
    };
    var details = {
        isClientMobile: isClientMobile,
        isClientTablet: isClientTablet,
        isClientLaptop: isClientLaptop
    };
    var getBreakpointValue = function() {
        if (isClientMobileL) return 320;
        if (isClientMobile) return 425;
        if (isClientTabletSmall) return 480;
        if (isClientTabletM) return 576;
        if (isClientTablet) return 600;
        if (isClientTabletXL) return 768;
        if (isClientLaptop) return 850;
        if (isClientLaptopM) return 1024;
        if (isClientDesktop) return 1280;
        return 0;
    };
    var subComponentsStories = finalStoriesList === null || finalStoriesList === void 0 ? void 0 : finalStoriesList.map(function(subComponent, index) {
        var currentIndex = index;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomStoriesSubComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, subComponent, details), {
            format: format,
            size: size,
            hasShadow: hasShadow,
            positionComponent: position,
            index: index + 1,
            preloadComponent: preloadComponent
        }), "".concat(position, "#story#").concat(currentIndex));
    });
    if (!(subComponents === null || subComponents === void 0 ? void 0 : subComponents.length)) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("O componente de Stories, localizado na posi\xe7\xe3o ".concat(position, ", n\xe3o apresenta nenhum SubComponente, ou seja, n\xe3o est\xe1 retornando nenhum slide."), "error");
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomStoriesContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-container")), {
        customTheme: isBlackTheme,
        format: format,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoriesContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-content")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComponentHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-header")), {
                    textAlign: textAlign,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomStoriesTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-title")), {
                            isBlackTheme: isBlackTheme,
                            showTitle: showTitle,
                            children: title
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StoriesSubtitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-subtitle")), {
                            showSubTitle: showSubTitle,
                            size: size,
                            children: subTitle
                        }))
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentBody, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-body")), {
                    format: format,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-stories-swiper")), {
                        configs: swiperConfigs,
                        subComponents: subComponentsStories,
                        position: position,
                        getBreakpoints: getBreakpointValue
                    }))
                }))
            ]
        }))
    }));
});
CustomStories.displayName = "CustomStories";



/***/ }),

/***/ 24644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ CustomTextBlock; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomTextBlock/data.ts
var customTextBlockData = function(properties) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var title = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var showTitle = (ref1 = properties.find(function(param) {
        var key = param.key;
        return key === "showTitle";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var ctaText = (ref2 = properties.find(function(param) {
        var key = param.key;
        return key === "ctaText";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var subTitle = (ref3 = properties.find(function(param) {
        var key = param.key;
        return key === "subTitle";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var showSubTitle = (ref4 = properties.find(function(param) {
        var key = param.key;
        return key === "showSubTitle";
    })) === null || ref4 === void 0 ? void 0 : ref4.value;
    var plainText = (ref5 = properties.find(function(param) {
        var key = param.key;
        return key === "plainText";
    })) === null || ref5 === void 0 ? void 0 : ref5.value;
    var hideText = (ref6 = properties.find(function(param) {
        var key = param.key;
        return key === "hideText";
    })) === null || ref6 === void 0 ? void 0 : ref6.value;
    var text = (ref7 = properties.find(function(param) {
        var key = param.key;
        return key === "text";
    })) === null || ref7 === void 0 ? void 0 : ref7.value;
    return {
        title: title,
        showTitle: showTitle,
        ctaText: ctaText,
        subTitle: subTitle,
        showSubTitle: showSubTitle,
        text: text,
        plainText: plainText,
        hideText: hideText
    };
};
var removeHtmlTags = function(html) {
    return html.replace(/<[^>]*>/g, "");
};
var calculateTextLimit = function(htmlText, limit) {
    if (!htmlText) return limit;
    var plainText = removeHtmlTags(htmlText);
    if (plainText.length > limit) {
        var lastSpaceIndex = plainText.lastIndexOf(" ", limit);
        return lastSpaceIndex !== -1 ? lastSpaceIndex : limit;
    }
    return plainText.length;
};
var truncateHtml = function(htmlText, limit) {
    var plainTextLimit = calculateTextLimit(htmlText, limit);
    var plainTextCount = 0;
    var htmlTextCount = 0;
    var isInsideTag = false;
    var truncatedChars = [];
    while(plainTextCount < plainTextLimit && htmlTextCount < htmlText.length){
        var currentChar = htmlText[htmlTextCount];
        if (currentChar === "<") {
            isInsideTag = true;
        } else if (currentChar === ">") {
            isInsideTag = false;
        } else if (!isInsideTag) {
            plainTextCount++;
        }
        truncatedChars.push(currentChar);
        htmlTextCount++;
    }
    var truncatedHtml = truncatedChars.join("");
    var openTags = [];
    var tagRegex = /<([a-zA-Z]+)(?:"[^"]*"|'[^']*'|[^'">])*>|<\/([a-zA-Z]+)>/g;
    var tagMatch;
    while((tagMatch = tagRegex.exec(truncatedHtml)) !== null){
        if (tagMatch[1]) {
            openTags.push(tagMatch[1]);
        } else if (tagMatch[2]) {
            var matchPosition = openTags.lastIndexOf(tagMatch[2]);
            if (matchPosition !== -1) {
                openTags.splice(matchPosition, 1);
            }
        }
    }
    openTags.reverse().forEach(function(tag) {
        truncatedChars.push("</".concat(tag, ">"));
    });
    return truncatedHtml;
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomTextBlock/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 30px;\n  color: ",
        ";\n\n  @media (max-width: 712px) {\n    font-size: 22px;\n  }\n\n  @media (max-width: 360px) {\n    font-size: 22px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n\n  @media (max-width: 712px) {\n    font-size: ",
        ";\n  }\n\n  @media (max-width: 360px) {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  > * {\n    word-break: keep-all;\n  }\n\n  a {\n    font-weight: ",
        ";\n    text-decoration: underline;\n  }\n\n  ol {\n    margin-left: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > svg {\n    ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  cursor: pointer;\n  margin: ",
        " auto ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              path {\n                fill: ",
        ";\n              }\n            "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          svg {\n            ",
        "\n          }\n        "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        ", ",
        ", ",
        " {\n        ",
        "\n      }\n      ",
        " {\n        ",
        "\n      }\n      ",
        " {\n        ",
        "\n      }\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  margin: ",
        " auto;\n  padding: ",
        " ",
        ";\n\n  @media (max-width: 712px) {\n    padding: ",
        ";\n  }\n\n  @media (max-width: 360px) {\n    padding: ",
        ";\n  }\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
var ref, ref1;


var ArrowDownIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowDownSolid).withConfig({
    displayName: "styles__ArrowDownIcon",
    componentId: "sc-4a28258f-0"
})(_templateObject());
var CustomTextBlockHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CustomTextBlockHeader",
    componentId: "sc-4a28258f-1"
})(_templateObject1(), ui.theme.space.x1, ui.theme.space.x4);
var CustomTextBlockTitle = (0,styled_components_browser_esm/* default */.ZP)(ui.Title).withConfig({
    displayName: "styles__CustomTextBlockTitle",
    componentId: "sc-4a28258f-2"
})(_templateObject2(), ui.theme.colors.neutral[520]);
var CustomTextBlockSubTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__CustomTextBlockSubTitle",
    componentId: "sc-4a28258f-3"
})(_templateObject3(), ui.theme.typography.fontSize.md.x3, ui.theme.colors.neutral[330], ui.theme.typography.fontSize.sm.x7, ui.theme.typography.fontSize.sm.x7);
var CustomTextBlockContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CustomTextBlockContent",
    componentId: "sc-4a28258f-4"
})(_templateObject4(), ui.theme.colors.neutral[520], ui.theme.typography.fontWeight.bold, ui.theme.space.x4);
var CustomTextBlockCollapsibleField = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CustomTextBlockCollapsibleField",
    componentId: "sc-4a28258f-5"
})(_templateObject5(), function(param) {
    var hidingText = param.hidingText;
    return hidingText ? "" : "transform: rotate(180deg)";
});
var CustomTextBlockCtaContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CustomTextBlockCtaContainer",
    componentId: "sc-4a28258f-6"
})(_templateObject6(), ui.theme.space.x2, ui.theme.space.x4, ui.theme.space.x0);
var CustomTextBlockCtaText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__CustomTextBlockCtaText",
    componentId: "sc-4a28258f-7"
})(_templateObject7(), ui.theme.colors.primary[200], ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight.bold);
var CustomTextBlockContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CustomTextBlockContainer",
    componentId: "sc-4a28258f-8"
})(_templateObject13(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.device) === null || ref === void 0 ? void 0 : (ref1 = ref.size) === null || ref1 === void 0 ? void 0 : ref1.laptopL, ui.theme.space.x0, ui.theme.space.x4, ui.theme.space.x20, ui.theme.space.x4, ui.theme.space.x4, function(param) {
    var customTheme = param.customTheme;
    var ref, ref1, ref2, ref3, ref4, ref5;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), CustomTextBlockTitle, CustomTextBlockSubTitle, CustomTextBlockCtaText, customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1.white), CustomTextBlockContent, customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref2 = ui.theme.colors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.blackFriday) === null || ref3 === void 0 ? void 0 : ref3["20"]), CustomTextBlockCollapsibleField, customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), customTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref4 = ui.theme.colors) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.blackFriday) === null || ref5 === void 0 ? void 0 : ref5.white)));
});

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomTextBlock/index.tsx







var CustomTextBlock = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, isBlackTheme = param.isBlackTheme;
    var ref = customTextBlockData(properties), title = ref.title, showTitle = ref.showTitle, ctaText = ref.ctaText, subTitle = ref.subTitle, showSubTitle = ref.showSubTitle, text = ref.text, plainText = ref.plainText, hideText = ref.hideText;
    var showTitleBoolean = showTitle === "true";
    var showSubTitleBoolean = showSubTitle === "true";
    var shouldHideText = hideText === "true";
    var textLength = plainText && (plainText === null || plainText === void 0 ? void 0 : plainText.length) > 180;
    var ref1 = (0,react.useState)(shouldHideText), hidingText = ref1[0], setHidingText = ref1[1];
    var hasToShowCollapse = shouldHideText && textLength;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var handleChangeHidingTextValue = (0,react.useCallback)(function() {
        setHidingText(function(state) {
            return !state;
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomTextBlockContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        customTheme: isBlackTheme
    }, (0,application/* buildTestIds */.Fek)("custom-textblock-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomTextBlockHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-textblock-header")), {
                children: [
                    showTitleBoolean && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextBlockTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-textblock-title")), {
                        children: title
                    })),
                    showSubTitleBoolean && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextBlockSubTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-textblock-subtitle")), {
                        children: subTitle
                    }))
                ]
            })),
            hidingText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextBlockContent, (0,_object_spread/* default */.Z)({
                dangerouslySetInnerHTML: {
                    __html: text ? truncateHtml(text, calculateTextLimit(removeHtmlTags(text), isClientMobile ? 180 : 430)) : ""
                }
            }, (0,application/* buildTestIds */.Fek)("custom-textblock-content"))) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextBlockContent, (0,_object_spread/* default */.Z)({
                dangerouslySetInnerHTML: {
                    __html: text !== null && text !== void 0 ? text : ""
                }
            }, (0,application/* buildTestIds */.Fek)("custom-textblock-content"))),
            hasToShowCollapse && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomTextBlockCtaContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onClick: function() {
                    return handleChangeHidingTextValue();
                }
            }, (0,application/* buildTestIds */.Fek)("custom-textblock-ctaContainer")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextBlockCtaText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-textblock-ctaText")), {
                        children: hidingText ? ctaText : "Ocultar"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextBlockCollapsibleField, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        hidingText: hidingText
                    }, (0,application/* buildTestIds */.Fek)("custom-textblock-collapsibleField")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownIcon, {})
                    }))
                ]
            }))
        ]
    }));
});
CustomTextBlock.displayName = "CustomTextBlock";



/***/ }),

/***/ 51646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ useMappedBackofficeComponent; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomBanner/index.tsx + 2 modules
var CustomBanner = __webpack_require__(18272);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomCarousel/index.tsx + 7 modules
var CustomCarousel = __webpack_require__(46963);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomDynamicBanner/index.tsx + 2 modules
var CustomDynamicBanner = __webpack_require__(27579);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomFilterProducts/data.tsx


var customFilterProductsBlackTheme = function(isBlackTheme) {
    return isBlackTheme ? {
        key: "blackFridayTheme",
        value: JSON.stringify({
            backgroundColor: "".concat(ui.theme.colors.blackFriday[125]),
            secondaryBackgroundColor: "".concat(ui.theme.colors.blackFriday[110]),
            defaultColor: "".concat(ui.theme.colors.blackFriday.white),
            textColor: "".concat(ui.theme.colors.blackFriday.white),
            borderColor: "".concat(ui.theme.colors.blackFriday[75])
        })
    } : undefined;
};
var customFilterProductsData = function(properties, isBlackTheme) {
    var ref, ref1;
    var title = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var configMenuHeaderTitle = (ref1 = properties.find(function(param) {
        var key = param.key;
        return key === "configMenuHeaderTitle";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var blackFridayTheme = customFilterProductsBlackTheme(!!isBlackTheme);
    if (blackFridayTheme) {
        properties === null || properties === void 0 ? void 0 : properties.push(blackFridayTheme);
    }
    var filterProductsBlackFridayTheme = (0,application/* getComponentTheme */.sul)(blackFridayTheme);
    return {
        title: title,
        configMenuHeaderTitle: configMenuHeaderTitle,
        filterProductsBlackFridayTheme: filterProductsBlackFridayTheme
    };
};


// EXTERNAL MODULE: ../../packages/components/patterns/FilterProducts/index.tsx + 6 modules
var FilterProducts = __webpack_require__(93884);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomFilterProducts/index.tsx






var CustomFilterProducts = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, filterProducts = param.filterProducts, source = param.source, isBlackTheme = param.isBlackTheme, _preloadComponent = param.preloadComponent, preloadComponent = _preloadComponent === void 0 ? false : _preloadComponent;
    var ref = customFilterProductsData(properties, !!isBlackTheme), configMenuHeaderTitle = ref.configMenuHeaderTitle, title = ref.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterProducts/* FilterProducts */.P, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterProducts), {
        title: title !== null && title !== void 0 ? title : configMenuHeaderTitle,
        source: source,
        isBlackTheme: isBlackTheme,
        preloadComponent: preloadComponent
    }));
});
CustomFilterProducts.displayName = "CustomFilterProducts";


// EXTERNAL MODULE: ../../packages/components/backoffice/CustomHeader/index.tsx + 2 modules
var CustomHeader = __webpack_require__(40818);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomHighlightCategories/index.tsx + 1 modules
var CustomHighlightCategories = __webpack_require__(89236);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomImagesGrid/index.tsx + 5 modules
var CustomImagesGrid = __webpack_require__(91320);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomProductList/index.tsx + 3 modules
var CustomProductList = __webpack_require__(24683);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomGridPlaylists/index.tsx + 6 modules
var CustomGridPlaylists = __webpack_require__(16997);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomTextBlock/index.tsx + 2 modules
var CustomTextBlock = __webpack_require__(24644);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomMarquee/data.ts
var customMarqueeData = function(properties) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var title = (ref = properties.find(function(param) {
        var key = param.key;
        return key === "title";
    })) === null || ref === void 0 ? void 0 : ref.value;
    var showTitle = (ref1 = properties.find(function(param) {
        var key = param.key;
        return key === "showTitle";
    })) === null || ref1 === void 0 ? void 0 : ref1.value;
    var desktopImage = (ref2 = properties.find(function(param) {
        var key = param.key;
        return key === "desktopImage";
    })) === null || ref2 === void 0 ? void 0 : ref2.value;
    var mobileImage = (ref3 = properties.find(function(param) {
        var key = param.key;
        return key === "mobileImage";
    })) === null || ref3 === void 0 ? void 0 : ref3.value;
    var backgroundColor = (ref4 = properties.find(function(param) {
        var key = param.key;
        return key === "backgroundColor";
    })) === null || ref4 === void 0 ? void 0 : ref4.value;
    var text = (ref5 = properties.find(function(param) {
        var key = param.key;
        return key === "text";
    })) === null || ref5 === void 0 ? void 0 : ref5.value;
    return {
        title: title,
        showTitle: showTitle,
        desktopImage: desktopImage,
        mobileImage: mobileImage,
        backgroundColor: backgroundColor,
        text: text
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
// EXTERNAL MODULE: ../../packages/components/Image/index.tsx
var Image = __webpack_require__(25926);
;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomMarquee/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  height: 31.5rem;\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  @media ",
        " {\n    height: 20rem;\n  }\n\n  @media ",
        " {\n    height: 20.5rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n\n  ",
        " {\n    font-weight: bold;\n    text-decoration: underline;\n  }\n\n  ",
        " {\n    margin-left: ",
        ";\n  }\n\n  @media ",
        " {\n    padding: 0 ",
        ";\n  }\n\n  @media ",
        " {\n    padding: ",
        " ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1280px;\n  width: 100%;\n  margin: ",
        " auto;\n  word-break: break-word;\n  color: ",
        ";\n  align-self: center;\n  line-height: 1.5;\n\n  @media ",
        " {\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-image: linear-gradient(to right, ",
        ", ",
        "),\n            url(",
        ");\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-image: url(",
        ");\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 61rem;\n  display: ",
        ";\n  font-size: 4rem;\n  color: ",
        ";\n  line-height: normal;\n  margin-bottom: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n    margin-bottom: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  @media ",
        " {\n    font-size: ",
        ";\n    margin-bottom: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  @media ",
        " {\n    margin-bottom: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  @media ",
        " {\n    font-size: ",
        ";\n    margin-bottom: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  @media ",
        " {\n    font-size: ",
        ";\n    margin-bottom: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 349px;\n  height: 1px;\n  margin-bottom: ",
        ";\n  padding: ",
        ";\n  border-color: ",
        ";\n\n  @media ",
        " {\n    width: 349px;\n  }\n\n  @media ",
        " {\n    width: 262px;\n    margin-bottom: ",
        ";\n  }\n\n  @media ",
        " {\n    width: 222px;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 61rem;\n  word-break: break-word;\n  font-size: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}




var CustomMarqueeContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CustomMarqueeContainer",
    componentId: "sc-57bb7aab-0"
})(_templateObject(), ui.theme.typography.fontWeight[400], ui.theme.typography.fontFamily.chivo, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileM);
var MarqueeAncor = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "styles__MarqueeAncor",
    componentId: "sc-57bb7aab-1"
})(_templateObject1());
var MarqueeOrdenadedList = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    displayName: "styles__MarqueeOrdenadedList",
    componentId: "sc-57bb7aab-2"
})(_templateObject2());
var MainContentWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__MainContentWrapper",
    componentId: "sc-57bb7aab-3"
})(_templateObject3(), MarqueeAncor, MarqueeOrdenadedList, ui.theme.space.x4, ui.theme.device.desktopFirst.laptopM, ui.theme.space.x4, ui.theme.device.desktopFirst.tablet, ui.theme.space.x0, ui.theme.space.x6);
var MainContent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__MainContent",
    componentId: "sc-57bb7aab-4"
})(_templateObject4(), ui.theme.space.x0, ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.laptopM);
var ImageSection = (0,styled_components_browser_esm/* default */.ZP)(Image/* Image */.E).withConfig({
    displayName: "styles__ImageSection",
    componentId: "sc-57bb7aab-5"
})(_templateObject7(), function(param) {
    var opacity = param.opacity, src = param.src;
    return opacity ? (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), opacity, opacity, src) : (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), src);
});
var MarqueeTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    displayName: "styles__MarqueeTitle",
    componentId: "sc-57bb7aab-6"
})(_templateObject8(), function(param) {
    var showTitle = param.showTitle;
    return showTitle === "false" ? "none" : "";
}, ui.theme.colors.neutral.white, ui.theme.space.x4, ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.lg.x2, ui.theme.space.x1, ui.theme.space.x1, ui.theme.device.desktopFirst.tabletS, ui.theme.typography.fontSize.md.x4, ui.theme.space["x2.5"], ui.theme.space["x2.5"], ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x1, ui.theme.space.x0, ui.theme.device.desktopFirst.mobileL, ui.theme.typography.fontSize.md.x3, ui.theme.space.x1, ui.theme.space.x0, ui.theme.device.desktopFirst.mobileS, ui.theme.typography.fontSize.sm.x9, ui.theme.space.x1, ui.theme.space.x0);
var HorizontalLine = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    displayName: "styles__HorizontalLine",
    componentId: "sc-57bb7aab-7"
})(_templateObject9(), ui.theme.space.x4, ui.theme.space.x0, ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x1, ui.theme.device.desktopFirst.mobileS, ui.theme.space.x1);
var MarqueeTextSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__MarqueeTextSection",
    componentId: "sc-57bb7aab-8"
})(_templateObject10(), ui.theme.typography.fontSize.sm.x7, ui.theme.device.desktopFirst.tablet, ui.theme.typography.fontSize.sm.x5, ui.theme.device.desktopFirst.tabletS, ui.theme.typography.fontSize.sm.x3);

;// CONCATENATED MODULE: ../../packages/components/backoffice/CustomMarquee/index.tsx








var CustomMarquee = /*#__PURE__*/ (0,react.memo)(function(param) {
    var properties = param.properties, isClientMobile = param.isClientMobile, position = param.position, preloadComponent = param.preloadComponent;
    var ref = customMarqueeData(properties), title = ref.title, showTitle = ref.showTitle, desktopImage = ref.desktopImage, mobileImage = ref.mobileImage, backgroundColor = ref.backgroundColor, text = ref.text;
    var currentPathName = (0,application/* useCurrentPathName */.Y0L)();
    if (!desktopImage) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('O componente de Letreiro, localizado em "'.concat(currentPathName, '", na posi\xe7\xe3o ').concat(position, ", n\xe3o possui imagem na vers\xe3o desktop."), "warning");
    }
    if (!mobileImage) {
        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage('O componente de Letreiro, localizado em "'.concat(currentPathName, '", na posi\xe7\xe3o ').concat(position, ", n\xe3o possui imagem na vers\xe3o mobile."), "warning");
    }
    var image = isClientMobile ? mobileImage !== null && mobileImage !== void 0 ? mobileImage : "" : desktopImage !== null && desktopImage !== void 0 ? desktopImage : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomMarqueeContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-marquee-container")), {
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSection, (0,_object_spread/* default */.Z)({
                alt: title,
                src: image,
                opacity: backgroundColor,
                layout: "fill",
                objectFit: "cover",
                priority: preloadComponent
            }, (0,application/* buildTestIds */.Fek)("custom-marquee-image"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContentWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("main-content-wrapper")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("main-content")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MarqueeTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            showTitle: showTitle
                        }, (0,application/* buildTestIds */.Fek)("marquee-title")), {
                            children: title
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalLine, (0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("horizontal-line"))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MarqueeTextSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("marquee-text-section")), {
                            dangerouslySetInnerHTML: {
                                __html: text !== null && text !== void 0 ? text : ""
                            }
                        }))
                    ]
                }))
            }))
        ]
    }));
});
CustomMarquee.displayName = "CustomMarquee";


// EXTERNAL MODULE: ../../packages/components/backoffice/CustomCardCTA/index.tsx + 8 modules
var CustomCardCTA = __webpack_require__(18356);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomFAQ/index.tsx + 5 modules
var CustomFAQ = __webpack_require__(47044);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomStories/index.tsx + 5 modules
var CustomStories = __webpack_require__(28286);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomCountdown/index.tsx + 5 modules
var CustomCountdown = __webpack_require__(62915);
;// CONCATENATED MODULE: ../../packages/components/backoffice/hooks/useMappedBackofficeComponent.tsx



















var useMappedBackofficeComponent = function(component, details, highlightCategories) {
    var constructMapComponentTypeAndElement = (0,react.useCallback)(function() {
        if (!component) {
            return new Map();
        }
        var componentProps = (0,_object_spread/* default */.Z)({}, details, component);
        var mapComponentTypeAndElement = new Map();
        mapComponentTypeAndElement.set("banner", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBanner/* CustomBanner */.b, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, componentProps), {
            isinsidecarousel: false
        })));
        mapComponentTypeAndElement.set("carousel", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCarousel/* CustomCarousel */.O, (0,_object_spread/* default */.Z)({}, componentProps)));
        mapComponentTypeAndElement.set("dynamicBanner", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomDynamicBanner/* CustomDynamicBanner */.k, (0,_object_spread/* default */.Z)({}, componentProps)));
        mapComponentTypeAndElement.set("filterProducts", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFilterProducts, (0,_object_spread/* default */.Z)({}, componentProps)));
        mapComponentTypeAndElement.set("imagesGrid", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImagesGrid/* CustomImagesGrid */.L, (0,_object_spread/* default */.Z)({}, componentProps)));
        mapComponentTypeAndElement.set("gridPlaylists", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomGridPlaylists/* CustomGridPlaylists */.C, (0,_object_spread/* default */.Z)({}, componentProps)));
        mapComponentTypeAndElement.set("header", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHeader/* CustomHeader */.Y, (0,_object_spread/* default */.Z)({}, componentProps)));
        var customHighlightCategoriesDetails = {
            subComponents: highlightCategories
        };
        mapComponentTypeAndElement.set("highlightCategories", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHighlightCategories/* CustomHighlightCategories */.w, (0,_object_spread/* default */.Z)({}, customHighlightCategoriesDetails)));
        mapComponentTypeAndElement.set("productList", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProductList/* CustomProductList */.S, (0,_object_spread/* default */.Z)({}, componentProps)));
        mapComponentTypeAndElement.set("stories", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomStories/* CustomStories */.B, (0,_object_spread/* default */.Z)({}, componentProps)));
        mapComponentTypeAndElement.set("textBlock", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextBlock/* CustomTextBlock */.w, (0,_object_spread/* default */.Z)({}, componentProps)));
        mapComponentTypeAndElement.set("marquee", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomMarquee, (0,_object_spread/* default */.Z)({}, componentProps)));
        mapComponentTypeAndElement.set("cardCTA", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCardCTA/* CustomCardCTA */.Q, (0,_object_spread/* default */.Z)({}, componentProps)));
        mapComponentTypeAndElement.set("countdown", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCountdown/* CustomCountdown */.O, (0,_object_spread/* default */.Z)({}, componentProps)));
        mapComponentTypeAndElement.set("faq", /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFAQ/* CustomFAQ */.Q, (0,_object_spread/* default */.Z)({}, componentProps)));
        return mapComponentTypeAndElement;
    }, [
        component,
        details,
        highlightCategories
    ]);
    return constructMapComponentTypeAndElement().get(component === null || component === void 0 ? void 0 : component.type) || null;
};


;// CONCATENATED MODULE: ../../packages/components/backoffice/hooks/index.tsx



/***/ }),

/***/ 72182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sb": function() { return /* binding */ useBackofficeComponentUrl; },
/* harmony export */   "Vs": function() { return /* binding */ handleOnClickRedirect; },
/* harmony export */   "_e": function() { return /* binding */ useGetBranchLinkConfig; }
/* harmony export */ });
/* harmony import */ var implementations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32202);

// const getProductLink = (
//   productId: string,
//   branchID = 2
// ): LinkConfig<Product> => {
//   const { data, isLoading } = catalogApi.getProduct(
//     Number(productId),
//     branchID,
//     !!productId && !Number.isNaN(productId)
//   );
//   return {
//     url: `produto/${data?.id}/${formatStringUrl(data?.description || "")}`,
//     id: data?.id || null,
//     target: "_self",
//     data,
//     isLoading,
//   };
// };
var handleOnClickRedirect = function(linkConfig, router) {
    if (linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url) {
        var url = linkConfig.url, target = linkConfig.target;
        if (target === "_blank") {
            window.open(url, "_ blank");
            return;
        }
        router.push("/".concat(url));
    }
};
var getLinkConfig = function(typeLink, id) {
    var url = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    if (!typeLink) {
        return null;
    }
    if (typeLink === "external") {
        return {
            url: url || id,
            id: id,
            target: "_blank"
        };
    }
    if (typeLink === "landingPage") {
        return {
            // No caso da landingPage, o backend irá retornar a url em linkId
            url: url || id,
            id: id,
            target: "_self"
        };
    }
    if (typeLink === "none") {
        return null;
    }
    if (typeLink === "playlist") {
        return {
            url: url,
            id: id,
            target: "_self"
        };
    }
    if (typeLink === "product") {
        // Tratamento momentâneo enquanto a api retorna a url de produto com "Product/" no início
        var formattedUrl = (url === null || url === void 0 ? void 0 : url.replace("Product", "produto")) || id ? "produto/".concat(id) : null;
        return {
            url: formattedUrl,
            id: id,
            target: "_self"
        };
    }
    return null;
};
var useGetBranchLinkConfig = function() {
    var branches = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], componentType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "customizado";
    if (!(branches === null || branches === void 0 ? void 0 : branches.length)) {
        return null;
    }
    var currentBranchId = implementations__WEBPACK_IMPORTED_MODULE_0__/* .cookie.getCookie */ .pR.getCookie({
        name: "@FC:Ecom:Dropdown:BranchLocation"
    }) || "2";
    var currentBranch = branches === null || branches === void 0 ? void 0 : branches.find(function(param) {
        var id = param.id;
        return id === currentBranchId;
    });
    if (!(currentBranch === null || currentBranch === void 0 ? void 0 : currentBranch.typeLink) && !(currentBranch === null || currentBranch === void 0 ? void 0 : currentBranch.linkId) && !(currentBranch === null || currentBranch === void 0 ? void 0 : currentBranch.linkUrl)) {
        implementations__WEBPACK_IMPORTED_MODULE_0__/* .appMonitoringClient.captureMessage */ .pE.captureMessage("Um componente ".concat(componentType, " n\xe3o tem o tipo de link, o id do link e ."));
        return null;
    }
    var typeLink = currentBranch.typeLink, id = currentBranch.linkId, url = currentBranch.linkUrl;
    if (typeLink === "playlist" && !url && !id) {
        implementations__WEBPACK_IMPORTED_MODULE_0__/* .appMonitoringClient.captureMessage */ .pE.captureMessage("Um componente ".concat(componentType, " cujo link \xe9 do tipo Playlist n\xe3o possui uma URL configurada."));
    }
    if (typeLink === "landingPage" && !url && !id) {
        implementations__WEBPACK_IMPORTED_MODULE_0__/* .appMonitoringClient.captureMessage */ .pE.captureMessage("Um componente ".concat(componentType, " cujo link \xe9 do tipo Landing Page n\xe3o possui um id configurado."));
    }
    return getLinkConfig(typeLink, id, url);
};
var useBackofficeComponentUrl = function(configBranches, url) {
    var ref;
    var typeLinkExternal = configBranches === null || configBranches === void 0 ? void 0 : configBranches.find(function(param) {
        var typeLink = param.typeLink;
        return typeLink === "external";
    });
    var linkConfig = useGetBranchLinkConfig(configBranches, "subComponentImagesGrid");
    var formattedUrl = (linkConfig === null || linkConfig === void 0 ? void 0 : (ref = linkConfig.url) === null || ref === void 0 ? void 0 : ref.includes("https://")) ? linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url : "https://".concat(linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.url);
    if (typeLinkExternal) {
        return formattedUrl;
    }
    if (url) {
        return "/".concat(url);
    }
    return "";
};



/***/ }),

/***/ 60764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sb": function() { return /* reexport */ branch_config/* useBackofficeComponentUrl */.Sb; },
  "_e": function() { return /* reexport */ branch_config/* useGetBranchLinkConfig */._e; }
});

// UNUSED EXPORTS: CustomBannerContainer, handleOnClickRedirect

// EXTERNAL MODULE: ../../packages/components/backoffice/utils/branch-config.tsx
var branch_config = __webpack_require__(72182);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/backoffice/utils/custom-banner.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: center;\n  width: ",
        ";\n  min-height: ",
        ";\n  max-height: ",
        ";\n  margin-bottom: 14px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CustomBannerContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "custom-banner__CustomBannerContainer",
    componentId: "sc-fbc92b36-0"
})(_templateObject(), function(param) {
    var isDynamicBanner = param.isDynamicBanner;
    return isDynamicBanner ? "98.5vw" : "100%";
}, function(param) {
    var minHeight = param.minHeight;
    return minHeight || "max-content";
}, function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight || "max-content";
});

;// CONCATENATED MODULE: ../../packages/components/backoffice/utils/index.tsx




/***/ }),

/***/ 42621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z7": function() { return /* reexport */ withBlackThemeValidation; },
  "Lo": function() { return /* reexport */ withRedirectAfterLogout; },
  "XJ": function() { return /* reexport */ withUserPhoneNumberValidation; }
});

// UNUSED EXPORTS: withProductsRecommendations

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
;// CONCATENATED MODULE: ../../packages/components/hocs/withBlackThemeValidation/index.tsx




var isHomePageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return currentPathNameInLowerCase === "/" && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.home) === "black";
};
var isCategoryPageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return (currentPathNameInLowerCase === null || currentPathNameInLowerCase === void 0 ? void 0 : currentPathNameInLowerCase.includes("/categoria/")) && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.category) === "black";
};
var isHighlightPageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return (currentPathNameInLowerCase === null || currentPathNameInLowerCase === void 0 ? void 0 : currentPathNameInLowerCase.includes("/destaque/")) && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.highlight) === "black";
};
var isSearchPageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return (currentPathNameInLowerCase === null || currentPathNameInLowerCase === void 0 ? void 0 : currentPathNameInLowerCase.includes("/pesquisa")) && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.searchResult) === "black";
};
var isLoginPageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return (currentPathNameInLowerCase === null || currentPathNameInLowerCase === void 0 ? void 0 : currentPathNameInLowerCase.includes("/login")) && pageThemeMap.login === "black";
};
var isProductPageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return (currentPathNameInLowerCase === null || currentPathNameInLowerCase === void 0 ? void 0 : currentPathNameInLowerCase.includes("/produto")) && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.product) === "black";
};
var isCartPageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return currentPathNameInLowerCase === "/checkout/meu-carrinho" && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.cart) === "black";
};
var isMyAddressPageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return currentPathNameInLowerCase === "/conta/meus-enderecos" && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.myAddresses) === "black";
};
var isMyOrdersByPhonePageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return currentPathNameInLowerCase === "/conta/pedidos-eletronicos" && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.myOrdersByPhone) === "black";
};
var isMyOrdersPageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return currentPathNameInLowerCase === "/conta/meus-pedidos" && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.myOrders) === "black";
};
var isDetailedOrderPageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return (currentPathNameInLowerCase === null || currentPathNameInLowerCase === void 0 ? void 0 : currentPathNameInLowerCase.includes("/detalhamento-do-pedido")) && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.detailedOrder) === "black";
};
var isMyCreditCardsPageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return currentPathNameInLowerCase === "/conta/meus-cartoes" && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.myCreditCards) === "black";
};
var isMyListPageWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return currentPathNameInLowerCase === "/conta/minhas-listas" && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.myWeddingLists) === "black";
};
var isChangePasswordWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return currentPathNameInLowerCase === "/conta/seguranca/alterar-senha" && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.changePassword) === "black";
};
var isMyDataWithBlackTheme = function(currentPathNameInLowerCase, pageThemeMap) {
    return currentPathNameInLowerCase === "/conta/meus-dados" && (pageThemeMap === null || pageThemeMap === void 0 ? void 0 : pageThemeMap.myData) === "black";
};
var withBlackThemeValidation = function(WrappedComponent) {
    var ComponentWithLogic = function(props) {
        var currentPathName = (0,application/* useCurrentPathName */.Y0L)();
        var pageThemeMap = (0,application/* useAppContext */.bp4)().pageThemeMap;
        var currentPathNameInLowerCase = currentPathName === null || currentPathName === void 0 ? void 0 : currentPathName.toLowerCase();
        var isBlackTheme = isHomePageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isCategoryPageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isHighlightPageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isSearchPageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isLoginPageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isProductPageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isCartPageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isMyAddressPageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isMyOrdersPageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isMyCreditCardsPageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isMyOrdersByPhonePageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isMyListPageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isDetailedOrderPageWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isChangePasswordWithBlackTheme(currentPathNameInLowerCase, pageThemeMap) || isMyDataWithBlackTheme(currentPathNameInLowerCase, pageThemeMap);
        var allProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            isBlackTheme: isBlackTheme
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,src_object_spread/* default */.Z)({}, allProps));
    };
    ComponentWithLogic.displayName = "CustomComponentWithBlackThemeValidation";
    return ComponentWithLogic;
};


// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../packages/components/Skeleton/index.tsx
var components_Skeleton = __webpack_require__(44860);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/components/hocs/withProductsRecommendation/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var styles_SkeletonContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SkeletonContainer",
    componentId: "sc-3fc1a298-0"
})(_templateObject(), ui.theme.space.x4);

;// CONCATENATED MODULE: ../../packages/components/hocs/withProductsRecommendation/index.tsx







var withProductsRecommendations = function(WrappedComponent) {
    var ComponentWithLogic = function(props) {
        var ref = useProductsRecommendation(crm, props, cookie, catalogApi, appMonitoringClient), isCrmComponent = ref.isCrmComponent, isLoading = ref.isLoading, productCards = ref.productCards, componentCrmProps = ref.componentCrmProps;
        if (isCrmComponent && isLoading) {
            return /*#__PURE__*/ _jsxs(SkeletonContainer, {
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        count: 1,
                        width: 380,
                        height: 250
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        count: 1,
                        width: 380,
                        height: 250
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        count: 1,
                        width: 380,
                        height: 250
                    })
                ]
            });
        }
        if (!(productCards === null || productCards === void 0 ? void 0 : productCards.length)) {
            return /*#__PURE__*/ _jsx(WrappedComponent, _object_spread({}, props));
        }
        // if (isCrmComponent && !productCards?.length) {
        //   return null as unknown as ReactElement;
        // }
        // if (!isCrmComponent) {
        //   return <WrappedComponent {...props} />;
        // }
        var allProps = _object_spread_props(_object_spread({}, props), {
            productCards: productCards,
            crm: componentCrmProps
        });
        return /*#__PURE__*/ _jsx(WrappedComponent, _object_spread({}, allProps));
    };
    ComponentWithLogic.displayName = "CustomComponentWithProductsRecommendation";
    return ComponentWithLogic;
};


// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ../../packages/components/hocs/withRedirectAfterLogout/index.tsx




var withRedirectAfterLogout = function(WrappedComponent) {
    var ComponentWithLogic = function(props) {
        var isAuthenticated = (0,application/* useAuth */.aCi)().isAuthenticated;
        var router = (0,next_router.useRouter)();
        if (isAuthenticated !== undefined && isAuthenticated === false) {
            router.push("/");
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,src_object_spread/* default */.Z)({}, props));
    };
    ComponentWithLogic.displayName = "CustomComponent";
    return ComponentWithLogic;
};


;// CONCATENATED MODULE: ../../packages/components/hocs/withUserPhoneNumberValidation/index.tsx





var withUserPhoneNumberValidation = function(WrappedComponent) {
    var ComponentWithLogic = function(props) {
        var ref;
        var getTokens = (0,application/* useAuth */.aCi)().getTokens;
        var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
        var ref1 = implementations/* profileApi.getClient */.c_.getClient(accessToken, !!accessToken), loggedClient = ref1.data, isLoadingUserPhoneNumber = ref1.isLoading, error = ref1.error;
        if (error) {
            implementations/* appMonitoringClient.captureException */.pE.captureException(error);
        }
        var userHasValidPhoneNumberRegistered = !(0,application/* validatePhoneNumber */.Y08)(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber);
        var allProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            isLoadingUserPhoneNumber: isLoadingUserPhoneNumber,
            userHasValidPhoneNumberRegistered: userHasValidPhoneNumberRegistered
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,src_object_spread/* default */.Z)({}, allProps));
    };
    ComponentWithLogic.displayName = "CustomComponentWithUserPhoneNumberValidation";
    return ComponentWithLogic;
};


;// CONCATENATED MODULE: ../../packages/components/hocs/index.ts






/***/ }),

/***/ 88033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q2": function() { return /* reexport */ AccountBaseModal_AccountBaseModal; },
  "oC": function() { return /* reexport */ AddToHead/* AddToHead */.o; },
  "Xt": function() { return /* reexport */ AuthLoading; },
  "Jm": function() { return /* reexport */ ButtonSearchZipCode; },
  "GX": function() { return /* reexport */ ButtonSubmit/* ButtonSubmit */.G; },
  "XZ": function() { return /* reexport */ Form/* Checkbox */.XZ; },
  "Hr": function() { return /* reexport */ Collapsed; },
  "YP": function() { return /* reexport */ ConfirmPayment; },
  "$M": function() { return /* reexport */ ConfirmPaymentModal; },
  "Qk": function() { return /* reexport */ CountQuantityProduct; },
  "h0": function() { return /* reexport */ DropdownEllipsis; },
  "mf": function() { return /* reexport */ ErrorPage; },
  "yx": function() { return /* reexport */ Form/* FieldInfo */.yx; },
  "PF": function() { return /* reexport */ FilterProducts/* FilterProducts */.P; },
  "o5": function() { return /* reexport */ FinalizeOrderModal; },
  "$_": function() { return /* reexport */ FooterWithBlackThemeValidation; },
  "l0": function() { return /* reexport */ Form/* Form */.l0; },
  "eE": function() { return /* reexport */ FormNewAddress; },
  "Fb": function() { return /* reexport */ Head/* Head */.F; },
  "h4": function() { return /* reexport */ HeaderWithBlackThemeValidation; },
  "EL": function() { return /* reexport */ Divider_styles/* HorizontalDivider */.EL; },
  "Ee": function() { return /* reexport */ components_Image/* Image */.E; },
  "eY": function() { return /* reexport */ ImagesProduct; },
  "II": function() { return /* reexport */ Form/* Input */.II; },
  "qK": function() { return /* reexport */ InputCodeValidation/* InputBoxValidation */.q; },
  "Vr": function() { return /* reexport */ InputSearch; },
  "__": function() { return /* reexport */ Form/* Label */.__; },
  "Ar": function() { return /* reexport */ Layout; },
  "rU": function() { return /* reexport */ Link/* Link */.r; },
  "x6": function() { return /* reexport */ LinkRedirectHome/* LinkRedirectHome */.x; },
  "or": function() { return /* reexport */ Main; },
  "kS": function() { return /* reexport */ ModalAlertConfirm; },
  "Sh": function() { return /* reexport */ ModalConfirmEmail; },
  "CQ": function() { return /* reexport */ ModalGeneral.ModalGeneral; },
  "f": function() { return /* reexport */ ModalNewAddress; },
  "Xx": function() { return /* reexport */ Form/* MonetaryInput */.Xx; },
  "gW": function() { return /* reexport */ NewFormAddress; },
  "kK": function() { return /* reexport */ NoOrders.NoOrders; },
  "qX": function() { return /* reexport */ Notice; },
  "j7": function() { return /* reexport */ PageTemplateComponents; },
  "Ds": function() { return /* reexport */ Paginator/* Paginator */.D; },
  "Tj": function() { return /* reexport */ PasswordValidation/* PasswordValidation */.T; },
  "Oj": function() { return /* reexport */ components_PopUpAlertConfirm.PopUpAlertConfirm; },
  "zR": function() { return /* reexport */ PopupAlertAddProductToWeddingList; },
  "KX": function() { return /* reexport */ RecommendationCarousel; },
  "aX": function() { return /* reexport */ Register/* Register */.a; },
  "Xf": function() { return /* reexport */ Script; },
  "Od": function() { return /* reexport */ Skeleton.Skeleton; },
  "iR": function() { return /* reexport */ Slider/* Slider */.i; },
  "aK": function() { return /* reexport */ StepperModal/* StepperModal */.a; },
  "Kx": function() { return /* reexport */ Form/* TextArea */.Kx; },
  "JA": function() { return /* reexport */ ValidationButton; },
  "Ng": function() { return /* reexport */ WhatsAppOption; },
  "Lo": function() { return /* reexport */ hocs/* withRedirectAfterLogout */.Lo; },
  "XJ": function() { return /* reexport */ hocs/* withUserPhoneNumberValidation */.XJ; }
});

// UNUSED EXPORTS: AwsWafRecaptcha, Badge, BoxContentEmail, Breadcrumb, Carousel, ChangePassword, ChangePhoneNumber, CodeExpiration, CountdownCircleTimer, CustomBanner, CustomBannerContainer, CustomCardCTA, CustomCarousel, CustomCountdown, CustomDynamicBanner, CustomFAQ, CustomGridPlaylists, CustomHeader, CustomHighlightCategories, CustomImagesGrid, CustomProductList, CustomSelect, CustomStories, CustomStyledLink, CustomTextBlock, Divider, FCTextArea, GiftsListFilterSidebar, GoogleRecaptcha, InputNumber, LogoImage, MaskedInput, Modal, ModalConfirmEmailError, ModalConfirmedEmail, ModalPasswordChange, ModalPasswordChanged, NewCustomInput, NoticeConfirmationEmail, PreloadImage, RecommendationCarouselProductCardComponent, RecommendedProductList, RegisterPhoneNumber, RemoveSelection, RequestFeedbackModal, ResponsiveModal, SWRConfigContainer, SendCodeAgain, Snackbar, SupportContact, Swiper, TextWithCountdown, UniqueClient, UtilInfo, VerticalDivider, ZoomImages, handleOnClickRedirect, useBackofficeComponentUrl, useGetBranchLinkConfig, withBlackThemeValidation, withProductsRecommendations

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/components/ButtonSubmit/index.tsx
var ButtonSubmit = __webpack_require__(42942);
// EXTERNAL MODULE: ../../packages/components/Modal/index.tsx
var Modal = __webpack_require__(51345);
;// CONCATENATED MODULE: ../../packages/components/AccountBaseModal/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  padding: 1rem 1rem 1rem 2.5rem;\n  font-size: ",
        ";\n  font-weight: bold;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 6rem;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      -webkit-box-shadow: 0px -38px 26px -15px rgba(0, 0, 0);\n      -moz-box-shadow: 0px -38px 26px -15px rgba(0, 0, 0);\n      box-shadow: 0px -38px 26px -15px rgba(0, 0, 0);\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-flow: row nowrap;\n  gap: ",
        ";\n  align-items: center;\n  z-index: 1;\n  flex: 1;\n  max-height: 70px;\n  min-height: 70px;\n  padding: ",
        ";\n  padding: 1rem;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 16px;\n  transition: background-color 0.2s ease-in;\n  align-self: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  flex-flow: row nowrap;\n  align-items: stretch;\n  justify-content: ",
        ";\n  box-shadow: 0 1px 3px ",
        ";\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  max-height: 70px;\n  min-height: 70px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        width: 100%;\n        height: fit-content;\n      }\n\n      ",
        " {\n        padding: 0;\n        color: ",
        ";\n        font-size: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var BaseModalHeaderTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    displayName: "style__BaseModalHeaderTitle",
    componentId: "sc-3abcc542-0"
})(_templateObject(), function(param) {
    var titleFontSize = param.titleFontSize;
    return titleFontSize || "2rem";
});
var BaseModalHeaderClose = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__BaseModalHeaderClose",
    componentId: "sc-3abcc542-1"
})(_templateObject1());
var style_Close = (0,styled_components_browser_esm/* default */.ZP)(ui.CloseIcon).attrs(function(param) {
    var color = param.color;
    return {
        width: "3.5rem",
        height: "3.5rem",
        strokeWidth: "0.75",
        color: color
    };
}).withConfig({
    displayName: "style__Close",
    componentId: "sc-3abcc542-2"
})(_templateObject2());
var BaseModalBody = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__BaseModalBody",
    componentId: "sc-3abcc542-3"
})(_templateObject3(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : ui.theme.colors.neutral[80];
}, function(param) {
    var padding = param.padding;
    return padding || "2.5rem 2rem";
});
var BaseModalFooter = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__BaseModalFooter",
    componentId: "sc-3abcc542-4"
})(_templateObject5(), function(param) {
    var gap = param.gap;
    return gap;
}, function(param) {
    var padding = param.padding;
    return padding || "initial";
}, function(param) {
    var hasFooterShadow = param.hasFooterShadow;
    return hasFooterShadow && (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
});
var BaseModalFooterButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonSubmit/* ButtonSubmit */.G).attrs({
    alignSelf: "center",
    fontSize: ui.theme.typography.fontSize.sm.x5,
    height: "4rem"
}).withConfig({
    displayName: "style__BaseModalFooterButton",
    componentId: "sc-3abcc542-5"
})(_templateObject6());
var BaseModalHeader = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__BaseModalHeader",
    componentId: "sc-3abcc542-6"
})(_templateObject7(), function(param) {
    var displayHeader = param.displayHeader;
    return displayHeader || "flex";
}, function(param) {
    var justifyContent = param.justifyContent;
    return justifyContent !== null && justifyContent !== void 0 ? justifyContent : "space-between";
}, ui.theme.colors.neutral["999-opacity-10"]);
var BaseModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* Modal */.u).withConfig({
    displayName: "style__BaseModal",
    componentId: "sc-3abcc542-7"
})(_templateObject9(), function(param) {
    var isNewModal = param.isNewModal;
    return isNewModal && (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), BaseModalHeader, BaseModalHeaderTitle, ui.theme.colors.neutral[695], ui.theme.typography.fontSize.sm.x7);
});


;// CONCATENATED MODULE: ../../packages/components/AccountBaseModal/index.tsx







var AccountBaseModal_AccountBaseModal = function(_param) {
    var children = _param.children, width = _param.width, height = _param.height, _footerGap = _param.footerGap, footerGap = _footerGap === void 0 ? "2rem" : _footerGap, title = _param.title, _titleFontSize = _param.titleFontSize, titleFontSize = _titleFontSize === void 0 ? "2rem" : _titleFontSize, buttonText = _param.buttonText, buttonTextUnderAction = _param.buttonTextUnderAction, buttonUnderAction = _param.buttonUnderAction, buttonWidth = _param.buttonWidth, onCloseModal = _param.onCloseModal, onClickOnButton = _param.onClickOnButton, onClickAlternativeButton = _param.onClickAlternativeButton, _buttonHoverColor = _param.buttonHoverColor, buttonHoverColor = _buttonHoverColor === void 0 ? ui.theme.colors.secondary[500] : _buttonHoverColor, hasFooterShadow = _param.hasFooterShadow, // modalButtonPadding,
    buttonFormId = _param.buttonFormId, _isFormInvalid = _param.isFormInvalid, isFormInvalid = _isFormInvalid === void 0 ? false : _isFormInvalid, _buttonType = _param.buttonType, buttonType = _buttonType === void 0 ? "button" : _buttonType, _modalButtonColor = _param.modalButtonColor, modalButtonColor = _modalButtonColor === void 0 ? ui.theme.colors.secondary[265] : _modalButtonColor, _visible = _param.visible, visible = _visible === void 0 ? "visible" : _visible, _hasFooter = _param.hasFooter, hasFooter = _hasFooter === void 0 ? true : _hasFooter, _hasBaseFooter = _param.hasBaseFooter, hasBaseFooter = _hasBaseFooter === void 0 ? true : _hasBaseFooter, _alternativeButtonText = _param.alternativeButtonText, alternativeButtonText = _alternativeButtonText === void 0 ? "Cancelar" : _alternativeButtonText, backgroundColor = _param.backgroundColor, boxShadow = _param.boxShadow, padding = _param.padding, displayHeader = _param.displayHeader, overlay = _param.overlay, borderRadius = _param.borderRadius, isNewModal = _param.isNewModal, closeButtonColor = _param.closeButtonColor, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "width",
        "height",
        "footerGap",
        "title",
        "titleFontSize",
        "buttonText",
        "buttonTextUnderAction",
        "buttonUnderAction",
        "buttonWidth",
        "onCloseModal",
        "onClickOnButton",
        "onClickAlternativeButton",
        "buttonHoverColor",
        "hasFooterShadow",
        "buttonFormId",
        "isFormInvalid",
        "buttonType",
        "modalButtonColor",
        "visible",
        "hasFooter",
        "hasBaseFooter",
        "alternativeButtonText",
        "backgroundColor",
        "boxShadow",
        "padding",
        "displayHeader",
        "overlay",
        "borderRadius",
        "isNewModal",
        "closeButtonColor"
    ]);
    var ref = (0,application/* useAppContext */.bp4)(), isClientMobile = ref.isClientMobile, isClientTablet = ref.isClientTablet;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseModal, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        styles: {
            content: {
                borderRadius: borderRadius !== null && borderRadius !== void 0 ? borderRadius : ui.theme.space.x1,
                boxShadow: boxShadow !== null && boxShadow !== void 0 ? boxShadow : "none",
                padding: "0px",
                width: width || (isClientMobile ? "95vw" : ui.theme.space.x160 && isClientTablet ? "60vw" : "65vw"),
                minHeight: height !== null && height !== void 0 ? height : "fit-content",
                visibility: visible
            },
            overlay: {
                backgroundColor: overlay !== null && overlay !== void 0 ? overlay : ui.theme.colors.neutral["999-opacity-50"],
                visibility: visible
            }
        },
        onCloseModal: onCloseModal,
        isNewModal: isNewModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseModalHeader, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                displayHeader: displayHeader
            }, (0,application/* buildTestIds */.Fek)("base-modal-header")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseModalHeaderTitle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("base-modal-header-title")), {
                        titleFontSize: titleFontSize,
                        children: title
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseModalHeaderClose, {
                        "data-testid": "base-modal-closer",
                        onClick: onCloseModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Close, {
                            color: closeButtonColor
                        })
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseModalBody, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("base-modal-body")), {
                backgroundColor: backgroundColor,
                padding: padding,
                "data-testid": "base-modal-body",
                children: children
            })),
            hasBaseFooter && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseModalFooter, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("base-modal-footer")), {
                gap: footerGap,
                hasFooterShadow: hasFooterShadow,
                children: [
                    alternativeButtonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseModalFooterButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        text: alternativeButtonText
                    }, (0,application/* buildTestIds */.Fek)("base-modal-alternative-footer-button")), {
                        textUnderAction: alternativeButtonText,
                        underAction: buttonUnderAction,
                        color: ui.theme.colors.neutral.white,
                        contentColor: ui.theme.colors.primary[200],
                        hoveredColor: ui.theme.colors.pink[50],
                        minWidth: buttonWidth,
                        onClickAction: onClickAlternativeButton !== null && onClickAlternativeButton !== void 0 ? onClickAlternativeButton : onCloseModal,
                        border: "1px solid ".concat(ui.theme.colors.primary[200]),
                        alternativeButton: true
                    })),
                    hasFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseModalFooterButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("base-modal-button")), {
                        text: buttonText,
                        textUnderAction: buttonTextUnderAction || "",
                        underAction: buttonUnderAction,
                        isDisabled: isFormInvalid,
                        color: modalButtonColor,
                        hoveredColor: buttonHoverColor,
                        minWidth: buttonWidth,
                        onClickAction: onClickOnButton,
                        form: buttonFormId,
                        buttonType: buttonType !== null && buttonType !== void 0 ? buttonType : "button"
                    }))
                ]
            }))
        ]
    }));
};


// EXTERNAL MODULE: ../../packages/components/AddToHead/index.tsx
var AddToHead = __webpack_require__(59797);
// EXTERNAL MODULE: ../../packages/components/Loading/index.tsx + 1 modules
var Loading = __webpack_require__(38879);
;// CONCATENATED MODULE: ../../packages/components/AuthLoading/style.ts

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2rem;\n  width: 100%;\n  height: 100vh;\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-family: ",
        ", sans-serif;\n"
    ]);
    style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var AuthLoadingContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__AuthLoadingContainer",
    componentId: "sc-d61ffbb4-0"
})(style_templateObject());
var WrapperLoadingAuth = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__WrapperLoadingAuth",
    componentId: "sc-d61ffbb4-1"
})(style_templateObject1());
var LoadingAuthCustom = (0,styled_components_browser_esm/* default */.ZP)(Loading/* Loading */.g).attrs({
    color: ui.theme.colors.tertiary[300],
    size: "extraLarge"
}).withConfig({
    displayName: "style__LoadingAuthCustom",
    componentId: "sc-d61ffbb4-2"
})(style_templateObject2());
var AuthLoadingText = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "style__AuthLoadingText",
    componentId: "sc-d61ffbb4-3"
})(style_templateObject3(), ui.theme.typography.fontWeight[400], ui.theme.typography.fontFamily.chivo);

;// CONCATENATED MODULE: ../../packages/components/AuthLoading/index.tsx


var AuthLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthLoadingContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperLoadingAuth, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingAuthCustom, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthLoadingText, {
                children: "Um momento..."
            })
        ]
    });
};


// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/components/AwsWafRecaptcha/index.tsx





var AwsWafRecaptcha = function(envsApi) {
    var ref = useRecaptcha(), handleCheckIfTheCustomerIsNotARobotSignUp = ref.handleCheckIfTheCustomerIsNotARobotSignUp, handleCheckIfTheCustomerIsNotARobotSignIn = ref.handleCheckIfTheCustomerIsNotARobotSignIn;
    var onSuccess = useCallback(function() {
        var _ref = _async_to_generator(function(wafToken) {
            var ref, ref1, wafProtectedUrl;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            envsApi === null || envsApi === void 0 ? void 0 : envsApi.getEnv("AWS_WAF_JS_API_URL")
                        ];
                    case 1:
                        ref1 = _state.sent() || {
                            data: ""
                        }, wafProtectedUrl = ref1.data;
                        window === null || window === void 0 ? void 0 : (ref = window.AwsWafIntegration) === null || ref === void 0 ? void 0 : ref.fetch(wafProtectedUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                        if (wafToken) {
                            handleCheckIfTheCustomerIsNotARobotSignUp(false);
                            handleCheckIfTheCustomerIsNotARobotSignIn(false);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(wafToken) {
            return _ref.apply(this, arguments);
        };
    }(), [
        envsApi,
        handleCheckIfTheCustomerIsNotARobotSignIn,
        handleCheckIfTheCustomerIsNotARobotSignUp, 
    ]);
    var onError = useCallback(function(error) {
        if (error) {
            handleCheckIfTheCustomerIsNotARobotSignUp(true);
            handleCheckIfTheCustomerIsNotARobotSignIn(true);
        }
    }, [
        handleCheckIfTheCustomerIsNotARobotSignIn,
        handleCheckIfTheCustomerIsNotARobotSignUp, 
    ]);
    var renderAwsWafCaptcha = useCallback(function() {
        var _ref = _async_to_generator(function(usedEnvsApi) {
            var ref, container, ref1, apiKey;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        container = document.querySelector("#aws-captcha-container");
                        return [
                            4,
                            usedEnvsApi === null || usedEnvsApi === void 0 ? void 0 : usedEnvsApi.getEnv("AWS_WAF_CAPTCHA")
                        ];
                    case 1:
                        ref1 = _state.sent() || {
                            data: ""
                        }, apiKey = ref1.data;
                        window === null || window === void 0 ? void 0 : (ref = window.AwsWafCaptcha) === null || ref === void 0 ? void 0 : ref.renderCaptcha(container, {
                            apiKey: apiKey,
                            onSuccess: onSuccess,
                            onError: onError,
                            dynamicWidth: true,
                            skipTitle: true
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(usedEnvsApi) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onError,
        onSuccess
    ]);
    useEffect(function() {
        renderAwsWafCaptcha(envsApi);
    }, [
        envsApi,
        renderAwsWafCaptcha
    ]);
    return /*#__PURE__*/ _jsx("div", {
        id: "aws-captcha-container"
    });
};


// EXTERNAL MODULE: ../../packages/components/backoffice/CustomBanner/index.tsx + 2 modules
var CustomBanner = __webpack_require__(18272);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomCarousel/index.tsx + 7 modules
var CustomCarousel = __webpack_require__(46963);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomDynamicBanner/index.tsx + 2 modules
var CustomDynamicBanner = __webpack_require__(27579);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomGridPlaylists/index.tsx + 6 modules
var CustomGridPlaylists = __webpack_require__(16997);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomHeader/index.tsx + 2 modules
var CustomHeader = __webpack_require__(40818);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomHighlightCategories/index.tsx + 1 modules
var CustomHighlightCategories = __webpack_require__(89236);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomImagesGrid/index.tsx + 5 modules
var CustomImagesGrid = __webpack_require__(91320);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomProductList/index.tsx + 3 modules
var CustomProductList = __webpack_require__(24683);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomStories/index.tsx + 5 modules
var CustomStories = __webpack_require__(28286);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomTextBlock/index.tsx + 2 modules
var CustomTextBlock = __webpack_require__(24644);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomCardCTA/index.tsx + 8 modules
var CustomCardCTA = __webpack_require__(18356);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomFAQ/index.tsx + 5 modules
var CustomFAQ = __webpack_require__(47044);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomCountdown/index.tsx + 5 modules
var CustomCountdown = __webpack_require__(62915);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(77149);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../packages/components/backoffice/hooks/index.tsx + 6 modules
var hooks = __webpack_require__(51646);
;// CONCATENATED MODULE: ../../packages/components/backoffice/PageTemplateComponents/CustomComponent/index.tsx





var CustomComponent = function(component, details) {
    var ref = (0,application/* useProductsRecommendation */.zN7)(implementations/* crm */.XE, component, implementations/* cookie */.pR, implementations/* catalogApi */.dZ, implementations/* appMonitoringClient */.pE), isCrmComponent = ref.isCrmComponent, isLoading = ref.isLoading, productCards = ref.productCards, componentCrmProps = ref.componentCrmProps;
    return (0,hooks/* useMappedBackofficeComponent */.J)((0,src_object_spread/* default */.Z)({}, component, isCrmComponent && {
        productCards: productCards
    }, isCrmComponent && {
        crm: componentCrmProps || undefined
    }), (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, details, isCrmComponent && {
        isLoading: isLoading
    }), {
        isCrmComponent: isCrmComponent
    }));
};
CustomComponent.displayName = "CustomComponent";


;// CONCATENATED MODULE: ../../packages/components/backoffice/PageTemplateComponents/index.tsx






var PageTemplateComponents = function(param, details) {
    var _param = (0,_to_array/* default */.Z)(param), components = _param.slice(0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: components.filter(function(param) {
            var type = param.type;
            return type !== "header";
        }).map(function(component, index) {
            var componentKey = "".concat((component === null || component === void 0 ? void 0 : component.displayName) || "Componente", "#").concat(component === null || component === void 0 ? void 0 : component.type, "#").concat(index);
            if ((details === null || details === void 0 ? void 0 : details.isClientMobile) && (0,application/* isVisibleOnMobile */.tIi)(component) !== undefined && (0,application/* isVisibleOnMobile */.tIi)(component) === false) {
                return null;
            }
            if (!(details === null || details === void 0 ? void 0 : details.isClientMobile) && (0,application/* isVisibleOnDesktop */.y8l)(component) !== undefined && (0,application/* isVisibleOnDesktop */.y8l)(component) === false) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomComponent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, details, component), {
                position: index + 1
            }), componentKey);
        })
    });
};


// EXTERNAL MODULE: ../../packages/components/backoffice/utils/index.tsx + 1 modules
var utils = __webpack_require__(60764);
;// CONCATENATED MODULE: ../../packages/components/backoffice/index.tsx
















;// CONCATENATED MODULE: ../../packages/components/Badge/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: ",
        ";\n  gap: ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  border: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  padding: ",
        ";\n  cursor: pointer;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var styles_BadgeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BadgeContainer",
    componentId: "sc-c172a0d3-0"
})(styles_templateObject(), ui.theme.typography.fontFamily.chivo, function(param) {
    var gap = param.gap;
    return gap || ui.theme.space.x1;
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius || ui.theme.space.x2;
}, function(param) {
    var border = param.border;
    return border;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width || "6.25rem";
}, function(param) {
    var height = param.height;
    return height || "2rem";
}, function(param) {
    var padding = param.padding;
    return padding;
});
var styles_BadgeText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__BadgeText",
    componentId: "sc-c172a0d3-1"
})(styles_templateObject1(), function(param) {
    var fontSize = param.fontSize;
    return fontSize || ui.theme.typography.fontSize.sm.x3;
}, function(param) {
    var color = param.color;
    return color;
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight;
});

;// CONCATENATED MODULE: ../../packages/components/Badge/index.tsx


var Badge = function(param) {
    var icon = param.icon, text = param.text, color = param.color, backgroundColor = param.backgroundColor, border = param.border, borderRadius = param.borderRadius, fontSize = param.fontSize, fontWeight = param.fontWeight, height = param.height, margin = param.margin, padding = param.padding, width = param.width, gap = param.gap, _ariaLabel = param.ariaLabel, ariaLabel = _ariaLabel === void 0 ? "Badge" : _ariaLabel, _ariaLabelledby = param.ariaLabelledby, ariaLabelledby = _ariaLabelledby === void 0 ? "Badge" : _ariaLabelledby, onClick = param.onClick;
    return /*#__PURE__*/ _jsxs(BadgeContainer, {
        padding: padding,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        margin: margin,
        width: width,
        height: height,
        border: border,
        borderRadius: borderRadius,
        backgroundColor: backgroundColor,
        gap: gap,
        onClick: onClick,
        children: [
            icon,
            /*#__PURE__*/ _jsx(BadgeText, {
                "aria-label": text,
                fontSize: fontSize,
                fontWeight: fontWeight,
                color: color,
                children: text
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/components/BoxContentEmail/styles.ts

function BoxContentEmail_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 4rem;\n  border-radius: 4px;\n  background: ",
        ";\n"
    ]);
    BoxContentEmail_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BoxContentEmail_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 1.35rem;\n"
    ]);
    BoxContentEmail_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 4rem;\n  height: 4rem;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1rem;\n  font-weight: ",
        ";\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var BoxContentEmailContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BoxContentEmailContainer",
    componentId: "sc-98f418ac-0"
})(BoxContentEmail_styles_templateObject(), ui.theme.colors.neutral["white-075"]);
var BoxContentEmailContainerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxContentEmailContainerContent",
    componentId: "sc-98f418ac-1"
})(BoxContentEmail_styles_templateObject1());
var EmailMessageBoxContentEmailIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__EmailMessageBoxContentEmailIconWrapper",
    componentId: "sc-98f418ac-2"
})(styles_templateObject2());
var EmailMessageBoxContentEmailIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.EmailLetterMessage).attrs({
    width: 48,
    height: 48
}).withConfig({
    displayName: "styles__EmailMessageBoxContentEmailIcon",
    componentId: "sc-98f418ac-3"
})(styles_templateObject3());
var TitleBoxContentEmail = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TitleBoxContentEmail",
    componentId: "sc-98f418ac-4"
})(styles_templateObject4(), ui.theme.colors.neutral[550], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[400]);

;// CONCATENATED MODULE: ../../packages/components/BoxContentEmail/index.tsx





var BoxContentEmail = function(param) {
    var email = param.email;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxContentEmailContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-content-email-container")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxContentEmailContainerContent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-content-email-content")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailMessageBoxContentEmailIconWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("email-message-box-content-email-icon-wrapper")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailMessageBoxContentEmailIcon, {})
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBoxContentEmail, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-box-content-email")), {
                    children: (0,application/* formatEmailToShowOnlyFourCharactersAndDomain */.XCW)(email)
                }))
            ]
        }))
    }));
};


// EXTERNAL MODULE: ../../packages/components/Breadcrumb/index.tsx
var Breadcrumb = __webpack_require__(90350);
// EXTERNAL MODULE: ../../packages/application/hooks/validateClientBranchChange/pageReload.ts
var pageReload = __webpack_require__(33757);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/components/Skeleton/index.tsx
var Skeleton = __webpack_require__(44860);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../packages/components/Form/index.tsx + 12 modules
var Form = __webpack_require__(29043);
;// CONCATENATED MODULE: ../../packages/components/ButtonSearchZipCode/InputZipCode/styles.ts

function InputZipCode_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none !important;\n  max-height: 4rem !important;\n  max-width: 11rem !important;\n  padding: 16px 8px !important;\n  font-size: 1.2rem !important;\n  line-height: 4rem !important;\n  color: ",
        " !important;\n  margin: 0 !important;\n\n  @media ",
        " {\n    max-width: 8rem !important;\n    font-size: 1.2rem !important;\n  }\n\n  & > input {\n    margin: 0;\n    border: none;\n  }\n"
    ]);
    InputZipCode_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



// artur.castro remover os !important
var InputCep = (0,styled_components_browser_esm/* default */.ZP)(Form/* Input */.II).withConfig({
    displayName: "styles__InputCep",
    componentId: "sc-3f492e82-0"
})(InputZipCode_styles_templateObject(), ui.theme.colors.neutral[900], ui.theme.device.desktopFirst.mobileL);

;// CONCATENATED MODULE: ../../packages/components/ButtonSearchZipCode/InputZipCode/index.tsx




var InputCepComponent = function(param) {
    var id = param.id, name = param.name, className = param.className, inputMode = param.inputMode, maxLength = param.maxLength, minLength = param.minLength, value = param.value, onChange = param.onChange, onFocus = param.onFocus, onBlur = param.onBlur, placeholder = param.placeholder, mask = param.mask, onMouseOver = param.onMouseOver, onMouseOut = param.onMouseOut, disableField = param.disableField;
    var register = (0,index_esm/* useForm */.cI)().register;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCep, {
        id: id,
        name: name,
        className: className,
        inputMode: inputMode,
        maxLength: maxLength,
        minLength: minLength,
        value: value,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        placeholder: placeholder,
        mask: mask,
        register: register,
        hasError: false,
        disabled: disableField
    });
};

;// CONCATENATED MODULE: ../../packages/components/ButtonSearchZipCode/styles.ts

function ButtonSearchZipCode_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  max-height: 4rem;\n  max-width: 16vh;\n  padding-left: 0.4rem;\n  font-size: 1.2rem;\n  color: ",
        ";\n\n  @media ",
        " {\n    max-width: 8rem;\n    font-size: 1.2rem;\n  }\n"
    ]);
    ButtonSearchZipCode_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ButtonSearchZipCode_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: center;\n  width: 6rem;\n  height: 3rem;\n  cursor: pointer;\n\n  border: ",
        ";\n  background-color: ",
        ";\n  pointer-events: ",
        ";\n"
    ]);
    ButtonSearchZipCode_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ButtonSearchZipCode_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  flex: 0.52;\n  border: thin solid ",
        ";\n  border-radius: 8px;\n  background-color: ",
        ";\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n  max-height: 4rem;\n  padding: 0.6rem;\n\n  @media ",
        " {\n    max-width: 20rem;\n  }\n\n  @media ",
        " {\n    flex: inherit;\n    min-width: 240px;\n  }\n"
    ]);
    ButtonSearchZipCode_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ButtonSearchZipCode_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    ButtonSearchZipCode_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var styles_InputCep = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "styles__InputCep",
    componentId: "sc-d2a51120-0"
})(ButtonSearchZipCode_styles_templateObject(), ui.theme.colors.neutral[900], ui.theme.device.desktopFirst.mobileXL);
var ButtonSearch = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonSearch",
    componentId: "sc-d2a51120-1"
})(ButtonSearchZipCode_styles_templateObject1(), function(param) {
    var isLoading = param.isLoading;
    return isLoading ? "1px solid ".concat(ui.theme.colors.secondary[265]) : "none";
}, function(param) {
    var isLoading = param.isLoading;
    return isLoading ? ui.theme.colors.neutral.white : ui.theme.colors.secondary[265];
}, function(param) {
    var isLoading = param.isLoading;
    return isLoading ? "none" : "";
});
var BoxActionZipCode = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxActionZipCode",
    componentId: "sc-d2a51120-2"
})(ButtonSearchZipCode_styles_templateObject2(), ui.theme.colors.neutral[95], ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL);
var ZipCodeForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "styles__ZipCodeForm",
    componentId: "sc-d2a51120-3"
})(ButtonSearchZipCode_styles_templateObject3());

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ModalBranchLocation/schema/index.tsx
var invalidZipCodeList = [
    "00000-000",
    "11111-111",
    "22222-222",
    "33333-333",
    "44444-444",
    "55555-555",
    "66666-666",
    "77777-777",
    "88888-888",
    "99999-999",
    "12345-678", 
];
var validateZipCode = function(zipCode) {
    var invalidZipCodeMessage = "CEP inv\xe1lido";
    var isZipCodeInvalid = invalidZipCodeList.find(function(invalidZipCode) {
        return zipCode === invalidZipCode;
    });
    if ((zipCode === null || zipCode === void 0 ? void 0 : zipCode.length) < 9 || isZipCodeInvalid) return invalidZipCodeMessage;
    return "";
};

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ModalBranchLocation/hooks/index.tsx


var useGetAddressByCity = function(typedCity, isTypingCity, selectedCity, shippingApi) {
    var ref, ref1;
    var formattedTypedCity = (ref = typedCity === null || typedCity === void 0 ? void 0 : typedCity.split("-")) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.trim();
    var debouncedTypedCity = (0,application/* useDebounce */.NrF)(formattedTypedCity, 500);
    var typedCityHasMoreThanTwoCharacters = (debouncedTypedCity === null || debouncedTypedCity === void 0 ? void 0 : debouncedTypedCity.length) >= 3;
    var ref2 = shippingApi.getAddressByCity(debouncedTypedCity, 5, typedCityHasMoreThanTwoCharacters && isTypingCity), addressByCityList = ref2.data, isLoading = ref2.isLoading;
    var cityNotFound = Boolean(!isLoading && typedCityHasMoreThanTwoCharacters && !(addressByCityList === null || addressByCityList === void 0 ? void 0 : addressByCityList.length));
    var conditionSuccessToCity = Boolean(typedCityHasMoreThanTwoCharacters && selectedCity && !isTypingCity);
    var conditionErrorToCity = Boolean(typedCityHasMoreThanTwoCharacters && cityNotFound && !selectedCity);
    return {
        addressByCityList: addressByCityList,
        conditionErrorToCity: conditionErrorToCity,
        conditionSuccessToCity: conditionSuccessToCity
    };
};
var useGetAddressByZipCode = function(typedZipCode, shippingApi) {
    var isZipCodeLengthValid = (typedZipCode === null || typedZipCode === void 0 ? void 0 : typedZipCode.length) === 9;
    var isInvalidZipCode = validateZipCode(typedZipCode);
    var ref = shippingApi.getAddressByZipCode(typedZipCode, isZipCodeLengthValid), addressByZipCode = ref.data, isLoading = ref.isLoading;
    var hasZipCodeError = !!(isZipCodeLengthValid && (isInvalidZipCode || !isLoading && !addressByZipCode));
    return {
        addressByZipCode: addressByZipCode,
        isZipCodeLengthValid: isZipCodeLengthValid,
        isInvalidZipCode: isInvalidZipCode,
        hasZipCodeError: hasZipCodeError
    };
};


;// CONCATENATED MODULE: ../../packages/components/ButtonSearchZipCode/index.tsx














var keyZipCodeStr = "@FC:Ecom:Dropdown:Cep";
var ButtonSearchZipCode = function(param) {
    var returnInfoClickButton = param.returnInfoClickButton, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _returnWithHyphen = param.returnWithHyphen, returnWithHyphen = _returnWithHyphen === void 0 ? false : _returnWithHyphen, setIsNumericKeyboardActive = param.setIsNumericKeyboardActive;
    var ref, ref1, ref2, ref3;
    var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
        return state.allConfigs;
    });
    var router = (0,next_router.useRouter)();
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var ref4 = (0,application/* useBranchLocation */.vKz)(), isChangingClientLocation = ref4.isChangingClientLocation, regionClientLocation = ref4.regionClientLocation, clientLocation = ref4.clientLocation;
    var addressByCityList = useGetAddressByCity(regionClientLocation !== null && regionClientLocation !== void 0 ? regionClientLocation : "", true, regionClientLocation !== null && regionClientLocation !== void 0 ? regionClientLocation : "", implementations/* shippingApi */.JK).addressByCityList;
    var ref5 = implementations/* profileApi.getAllAddresses */.c_.getAllAddresses(accessToken, !!accessToken && (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isAutoLoadShippingInfo) === "true"), addresses = ref5.data, isLoadingAddress = ref5.isLoading;
    var productPage = router === null || router === void 0 ? void 0 : (ref1 = router.pathname) === null || ref1 === void 0 ? void 0 : ref1.includes("/produto/");
    var defaultAddress = (ref2 = addresses === null || addresses === void 0 ? void 0 : addresses.find(function(address) {
        return (address === null || address === void 0 ? void 0 : address.isDefault) === true;
    })) === null || ref2 === void 0 ? void 0 : ref2.zipCode;
    var routerId = router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.region_id;
    var clientZipCode = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(keyZipCodeStr);
    var ref6 = (0,react.useState)(true), isFirstRender = ref6[0], setIsFirstRender = ref6[1];
    var ref7 = (0,react.useState)(clientZipCode || ""), selectedZipCode = ref7[0], setSelectedZipCode = ref7[1];
    var ref8 = (0,react.useState)(null), selectedZipCodeSearched = ref8[0], setSelectedZipCodeSearched = ref8[1];
    var ref9 = (0,react.useState)(false), isMouseOverInput = ref9[0], setIsMouseOverInput = ref9[1];
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    (0,react.useEffect)(function() {
        if (isChangingClientLocation) {
            returnInfoClickButton("");
            setSelectedZipCode("");
            setSelectedZipCodeSearched("");
        }
    }, [
        isChangingClientLocation,
        returnInfoClickButton
    ]);
    (0,react.useEffect)(function() {
        if (isFirstRender) {
            if ((0,pageReload/* isPageReloadByZipCodeSearch */.q)()) {
                returnInfoClickButton(selectedZipCode);
                (0,pageReload/* setIsPageReloadByZipCodeSearch */.B)(false);
            }
            if (routerId) {
                setSelectedZipCode("");
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(keyZipCodeStr, "");
            }
            setIsFirstRender(false);
        }
    }, [
        isFirstRender,
        returnInfoClickButton,
        selectedZipCode,
        routerId
    ]);
    var onClickButtonToSearch = (0,react.useCallback)(function(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        var formattedSelectedZipCode = selectedZipCode === null || selectedZipCode === void 0 ? void 0 : selectedZipCode.replace("-", "");
        if ((formattedSelectedZipCode === null || formattedSelectedZipCode === void 0 ? void 0 : formattedSelectedZipCode.length) === 8 && (!clientZipCode || clientZipCode && clientZipCode !== formattedSelectedZipCode)) {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(keyZipCodeStr, formattedSelectedZipCode);
            setSelectedZipCode(formattedSelectedZipCode);
        }
        if ((formattedSelectedZipCode === null || formattedSelectedZipCode === void 0 ? void 0 : formattedSelectedZipCode.length) === 8 && selectedZipCodeSearched !== formattedSelectedZipCode) {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(keyZipCodeStr, formattedSelectedZipCode);
            setSelectedZipCodeSearched(formattedSelectedZipCode);
        }
        if (returnWithHyphen) {
            return returnInfoClickButton(selectedZipCode);
        }
        return returnInfoClickButton(selectedZipCode.replace("-", ""));
    }, [
        clientZipCode,
        returnInfoClickButton,
        returnWithHyphen,
        selectedZipCode,
        selectedZipCodeSearched, 
    ]);
    (0,react.useEffect)(function() {
        if (accessToken && !clientZipCode && defaultAddress && productPage && (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isAutoLoadShippingInfo) === "true" && !routerId) {
            setSelectedZipCode(defaultAddress);
            setSelectedZipCodeSearched(defaultAddress);
            returnInfoClickButton(defaultAddress.replace("-", ""));
            return;
        }
        if (clientZipCode && !isLoadingAddress && productPage && (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isAutoLoadShippingInfo) === "true") {
            setSelectedZipCode(clientZipCode);
            returnInfoClickButton(clientZipCode.replace("-", ""));
            (0,pageReload/* setIsPageReloadByZipCodeSearch */.B)(false);
        }
    }, [
        accessToken,
        allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isAutoLoadShippingInfo,
        clientZipCode,
        defaultAddress,
        isLoadingAddress,
        productPage,
        returnInfoClickButton,
        routerId, 
    ]);
    var isKnowLocation = regionClientLocation !== "Demais regi\xf5es";
    // eslint-disable-next-line sonarjs/cognitive-complexity
    (0,react.useEffect)(function() {
        if (routerId) {
            setSelectedZipCode("");
            return;
        }
        if (accessToken && !isLoadingAddress) {
            var ref;
            if (defaultAddress && !clientZipCode) {
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(keyZipCodeStr, defaultAddress);
                return;
            }
            if (clientZipCode) {
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(keyZipCodeStr, clientZipCode);
                return;
            }
            if (isKnowLocation && addressByCityList && (addressByCityList === null || addressByCityList === void 0 ? void 0 : (ref = addressByCityList[0]) === null || ref === void 0 ? void 0 : ref.cep)) {
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(keyZipCodeStr, addressByCityList[0].cep);
                return;
            }
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(keyZipCodeStr, "");
            return;
        }
        if (!accessToken && !routerId) {
            var ref1;
            if (clientZipCode) {
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(keyZipCodeStr, clientZipCode);
                return;
            }
            if (isKnowLocation && (addressByCityList === null || addressByCityList === void 0 ? void 0 : (ref1 = addressByCityList[0]) === null || ref1 === void 0 ? void 0 : ref1.cep)) {
                var ref2;
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(keyZipCodeStr, addressByCityList === null || addressByCityList === void 0 ? void 0 : (ref2 = addressByCityList[0]) === null || ref2 === void 0 ? void 0 : ref2.cep);
                return;
            }
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(keyZipCodeStr, "");
        }
    }, [
        accessToken,
        clientLocation,
        addresses,
        regionClientLocation,
        isLoadingAddress,
        addressByCityList,
        clientZipCode,
        isKnowLocation,
        defaultAddress,
        routerId, 
    ]);
    if (isLoadingAddress) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
            count: 1,
            width: 210,
            height: 48
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxActionZipCode, {
        children: isClientMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ZipCodeForm, {
            onSubmit: onClickButtonToSearch,
            "aria-disabled": isLoading,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCepComponent, {
                    id: "mobile-zipcode-input",
                    name: "mobile-zipcode-input",
                    className: "cep-input",
                    inputMode: "numeric",
                    placeholder: isMouseOverInput ? "_____-___" : "00000-000",
                    mask: "99999-999",
                    maxLength: 9,
                    value: selectedZipCode,
                    onChange: function(e) {
                        var ref;
                        return setSelectedZipCode(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                    },
                    onFocus: function() {
                        return setIsNumericKeyboardActive && setIsNumericKeyboardActive(true);
                    },
                    onBlur: function() {
                        return setIsNumericKeyboardActive && setIsNumericKeyboardActive(false);
                    },
                    onMouseOver: function() {
                        return setIsMouseOverInput(true);
                    },
                    onMouseOut: function() {
                        return setIsMouseOverInput(false);
                    },
                    disableField: isLoading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSearch, {
                    isLoading: isLoading,
                    title: "Consultar op\xe7\xf5es de frete",
                    type: "submit",
                    disabled: isLoading,
                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {
                        color: ui.theme.colors.secondary[400]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Search, {
                        color: ui.theme.colors.neutral.white,
                        height: 28
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ZipCodeForm, {
            onSubmit: onClickButtonToSearch,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCepComponent, {
                    id: "desktop-zipcode-input",
                    name: "desktop-zipcode-input",
                    className: "cep-input",
                    inputMode: "numeric",
                    placeholder: isMouseOverInput ? "_____-___" : "00000-000",
                    mask: "99999-999",
                    maxLength: 9,
                    minLength: 9,
                    value: selectedZipCode,
                    onChange: function(e) {
                        var ref;
                        return setSelectedZipCode(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                    },
                    onMouseOver: function() {
                        return setIsMouseOverInput(true);
                    },
                    onMouseOut: function() {
                        return setIsMouseOverInput(false);
                    },
                    disableField: isLoading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSearch, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("zip-code-search-button")), {
                    isLoading: isLoading,
                    title: "Consultar op\xe7\xf5es de frete",
                    type: "submit",
                    disabled: isLoading,
                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("zip-code-search-button-loading")), {
                        color: ui.theme.colors.secondary[400],
                        type: "dotted"
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Search, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("zip-code-search-button-icon")), {
                        color: ui.theme.colors.neutral.white,
                        height: 28
                    }))
                }))
            ]
        })
    });
};


// EXTERNAL MODULE: ../../packages/components/ChangePassword/index.tsx + 1 modules
var ChangePassword = __webpack_require__(80712);
// EXTERNAL MODULE: ../../packages/application/utils/validations/index.ts + 8 modules
var validations = __webpack_require__(12747);
;// CONCATENATED MODULE: ../../packages/components/ChangePhoneNumber/style.ts

function ChangePhoneNumber_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ChangePhoneNumber_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChangePhoneNumber_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ChangePhoneNumber_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var style_ChangePhoneNumberLabel = (0,styled_components_browser_esm/* default */.ZP)(Form/* Label */.__).withConfig({
    displayName: "style__ChangePhoneNumberLabel",
    componentId: "sc-38755f64-0"
})(ChangePhoneNumber_style_templateObject());
var style_ChangePhoneNumberInput = (0,styled_components_browser_esm/* default */.ZP)(Form/* Input */.II).withConfig({
    displayName: "style__ChangePhoneNumberInput",
    componentId: "sc-38755f64-1"
})(ChangePhoneNumber_style_templateObject1());


;// CONCATENATED MODULE: ../../packages/components/ChangePhoneNumber/index.tsx












var ChangePhoneNumber = function(param) {
    var isModalOpen = param.isModalOpen, setIsModalOpen = param.setIsModalOpen, finishRegisterNewPhoneNumber = param.finishRegisterNewPhoneNumber, _modalHeaderTitle = param.modalHeaderTitle, modalHeaderTitle = _modalHeaderTitle === void 0 ? "Alterar n\xfamero" : _modalHeaderTitle, modalInputLabelText = param.modalInputLabelText;
    var ref;
    var ref1 = useForm(), register = ref1.register, handleSubmit = ref1.handleSubmit, setValue = ref1.setValue, watch = ref1.watch;
    var isClientTablet = useAppContext().isClientTablet;
    var getTokens = useAuth().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var addToast = useToast().addToast;
    var ref2 = useState(""), newPhoneNumberValue = ref2[0], setNewPhoneNumberValue = ref2[1];
    var ref3 = useState(false), changingPhoneNumber = ref3[0], setChangingPhoneNumber = ref3[1];
    var newPhoneNumberErrorMessage = validatePhoneNumber(newPhoneNumberValue);
    watch("newPhoneNumber");
    var isFormInvalid = !!newPhoneNumberErrorMessage;
    var onSaveNewPhoneNumber = function() {
        var _ref = _async_to_generator(function() {
            var changePhoneBody, ref, data, changePhoneError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!accessToken) return [
                            3,
                            2
                        ];
                        if (newPhoneNumberErrorMessage) {
                            addToast({
                                title: newPhoneNumberErrorMessage,
                                type: "error"
                            });
                            return [
                                2
                            ];
                        }
                        setChangingPhoneNumber(true);
                        changePhoneBody = {
                            newPhoneNumber: newPhoneNumberValue
                        };
                        return [
                            4,
                            profileApi.changePhone(accessToken, changePhoneBody)
                        ];
                    case 1:
                        ref = _state.sent(), data = ref.data, changePhoneError = ref.error;
                        setChangingPhoneNumber(false);
                        if (changePhoneError) {
                            addToast({
                                title: changePhoneError,
                                type: "error"
                            });
                            return [
                                2
                            ];
                        }
                        if (!data) {
                            addToast({
                                title: "Ocorreu um erro inesperado, tente novamente",
                                type: "error"
                            });
                            return [
                                2
                            ];
                        }
                        finishRegisterNewPhoneNumber();
                        addToast({
                            title: "N\xfamero salvo com sucesso!",
                            type: "success"
                        });
                        setIsModalOpen(false);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSaveNewPhoneNumber() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(AccountBaseModal, {
        isOpen: isModalOpen,
        contentLabel: "Edi\xe7\xe3o de n\xfamero do telefone",
        onCloseModal: function() {
            setIsModalOpen(false);
        },
        width: isClientTablet ? "90%" : "fit-content",
        height: "22rem",
        title: modalHeaderTitle,
        titleFontSize: "16px",
        buttonText: "Salvar",
        buttonTextUnderAction: "Salvando...",
        buttonUnderAction: changingPhoneNumber,
        buttonWidth: "10rem",
        onClickOnButton: handleSubmit(onSaveNewPhoneNumber),
        isFormInvalid: isFormInvalid,
        children: [
            modalInputLabelText && /*#__PURE__*/ _jsx(ChangePhoneNumberLabel, _object_spread_props(_object_spread({
                htmlFor: "new-phone-number",
                text: modalInputLabelText
            }, buildTestIds("my-data-label-new-phone-number")), {
                hasSuccessfully: !newPhoneNumberErrorMessage && !!(newPhoneNumberValue === null || newPhoneNumberValue === void 0 ? void 0 : newPhoneNumberValue.length)
            })),
            /*#__PURE__*/ _jsx(ChangePhoneNumberInput, _object_spread({
                id: "new-phone-number",
                name: "new-phone-number",
                type: "tel",
                mask: "(99) 99999-9999",
                placeholder: "Digite seu telefone",
                value: newPhoneNumberValue,
                register: register,
                hasError: newPhoneNumberErrorMessage && !!(newPhoneNumberValue === null || newPhoneNumberValue === void 0 ? void 0 : newPhoneNumberValue.length),
                hasSuccessfully: !newPhoneNumberErrorMessage && !!(newPhoneNumberValue === null || newPhoneNumberValue === void 0 ? void 0 : newPhoneNumberValue.length),
                textError: newPhoneNumberErrorMessage,
                width: "100%",
                onChange: function(param) {
                    var target = param.target;
                    var ref;
                    var typedPhoneNumber = target === null || target === void 0 ? void 0 : (ref = target.value) === null || ref === void 0 ? void 0 : ref.replace(/\D/g, "");
                    setValue("newPhoneNumber", typedPhoneNumber);
                    setNewPhoneNumberValue(typedPhoneNumber);
                },
                disabled: changingPhoneNumber
            }, buildTestIds("my-data-input-new-phone-number")))
        ]
    });
};


// EXTERNAL MODULE: ../../packages/components/CodeExpiration/index.tsx
var CodeExpiration = __webpack_require__(88484);
;// CONCATENATED MODULE: ../../packages/components/Collapsed/styles.ts

function Collapsed_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 50px;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 0.2rem;\n  background: none;\n\n  @media ",
        " {\n    padding: ",
        " ",
        " ",
        "\n      ",
        ";\n    background: ",
        ";\n    border: thin solid\n      ",
        ";\n    display: flex;\n    align-items: center;\n    box-shadow: 0px 3px 6px ",
        ";\n  }\n"
    ]);
    Collapsed_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Collapsed_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 0.2rem;\n  border: thin solid\n    ",
        ";\n"
    ]);
    Collapsed_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Collapsed_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Collapsed_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Collapsed_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Collapsed_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Collapsed_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Collapsed_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .open {\n    display: block;\n  }\n  .closed {\n    display: none;\n  }\n\n  .openIcon {\n    transform: rotate(90deg);\n  }\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Header",
    componentId: "sc-fa0c7b39-0"
})(Collapsed_styles_templateObject(), ui.theme.device.desktopFirst.tablet, ui.theme.space.x0, ui.theme.space.x1, ui.theme.space.x0, ui.theme.space["x3.5"], function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[175]) : "".concat(ui.theme.colors.neutral.white);
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[100]) : "".concat(ui.theme.colors.blackFriday[30]);
}, ui.theme.colors.neutral["999-opacity-10"]);
var BoxContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxContent",
    componentId: "sc-fa0c7b39-1"
})(Collapsed_styles_templateObject1(), ui.theme.colors.neutral.white, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui.theme.colors.blackFriday[100]) : "".concat(ui.theme.colors.blackFriday[30]);
});
var ArrowContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ArrowContainer",
    componentId: "sc-fa0c7b39-2"
})(Collapsed_styles_templateObject2());
var CollapseArrowUp = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowUp).withConfig({
    displayName: "styles__CollapseArrowUp",
    componentId: "sc-fa0c7b39-3"
})(Collapsed_styles_templateObject3());
var CollapseArrowDown = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowDown).withConfig({
    displayName: "styles__CollapseArrowDown",
    componentId: "sc-fa0c7b39-4"
})(Collapsed_styles_templateObject4());
var CollapsedContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CollapsedContainer",
    componentId: "sc-fa0c7b39-5"
})(styles_templateObject5());

;// CONCATENATED MODULE: ../../packages/components/Collapsed/index.tsx







var Collapsed = function(param) {
    var id = param.id, children = param.children, titleComponent = param.titleComponent, _handleOpen = param.handleOpen, handleOpen = _handleOpen === void 0 ? true : _handleOpen, isBlackTheme = param.isBlackTheme;
    var isClientTablet = (0,application/* useAppContext */.bp4)().isClientTablet;
    var ref = (0,react.useState)(true), isOpen = ref[0], setOpen = ref[1];
    var arrowColor = isBlackTheme ? ui.theme.colors.blackFriday.white : isClientTablet && !isBlackTheme ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[999];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollapsedContainer, {
        isClientMobile: true,
        id: id,
        isBlackTheme: isBlackTheme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                isBlackTheme: isBlackTheme,
                onClick: function() {
                    if (handleOpen) setOpen(function(state) {
                        return !state;
                    });
                }
            }, (0,application/* buildTestIds */.Fek)("collapsed-header")), {
                children: [
                    titleComponent,
                    handleOpen && isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseArrowUp, {
                        color: arrowColor
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseArrowDown, {
                        color: arrowColor
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxContent, {
                isBlackTheme: isBlackTheme,
                className: isOpen ? "open" : "closed",
                children: children
            })
        ]
    });
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
;// CONCATENATED MODULE: ../../packages/components/ConfirmPaymentModal/style.ts

function ConfirmPaymentModal_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ConfirmPaymentModal_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConfirmPaymentModal_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: stretch;\n  justify-content: ",
        ";\n  box-shadow: 0 1px 3px rgb(0 0 0 / 10%);\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  padding: ",
        ";\n  max-height: 70px;\n  min-height: 70px;\n  width: 100%;\n"
    ]);
    ConfirmPaymentModal_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConfirmPaymentModal_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: flex-start;\n  flex: 1;\n  display: flex;\n  position: relative;\n  align-items: center;\n  font-size: ",
        ";\n  font-weight: bold;\n  padding: ",
        ";\n  color: ",
        ";\n"
    ]);
    ConfirmPaymentModal_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConfirmPaymentModal_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    ConfirmPaymentModal_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  padding-bottom: 0;\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n"
    ]);
    style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      -webkit-box-shadow: 0px -38px 26px -15px rgba(0, 0, 0);\n      -moz-box-shadow: 0px -38px 26px -15px rgba(0, 0, 0);\n      box-shadow: 0px -38px 26px -15px rgba(0, 0, 0);\n    "
    ]);
    style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  z-index: 1;\n  flex: 1;\n  gap: ",
        ";\n  min-height: 70px;\n  padding: ",
        ";\n  ",
        "\n"
    ]);
    style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 16px;\n  transition: background-color 0.2s ease-in;\n  align-self: center;\n"
    ]);
    style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function style_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1rem;\n  font-weight: bold;\n  color: ",
        ";\n  font-family: ",
        ", sans-serif;\n  text-decoration: underline;\n  text-decoration-color: ",
        ";\n  cursor: pointer;\n"
    ]);
    style_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.5rem;\n  width: 100%;\n  max-width: 50rem;\n  align-items: flex-start;\n  justify-content: center;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  min-width: 17rem;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  text-align: start;\n  font-weight: 500;\n  color: ",
        ";\n  font-size: ",
        ";\n  gap: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border-radius: 4px;\n  gap: ",
        ";\n  color: ",
        ";\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: start;\n  width: 100%;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: 400;\n  @media ",
        " {\n    margin-left: 0;\n  }\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}




var style_BaseModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* Modal */.u).withConfig({
    displayName: "style__BaseModal",
    componentId: "sc-2dfef101-0"
})(ConfirmPaymentModal_style_templateObject());
var style_BaseModalHeader = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__BaseModalHeader",
    componentId: "sc-2dfef101-1"
})(ConfirmPaymentModal_style_templateObject1(), function(param) {
    var justifyContent = param.justifyContent;
    return justifyContent || "space-between";
}, ui.theme.space.x4);
var style_BaseModalHeaderTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    displayName: "style__BaseModalHeaderTitle",
    componentId: "sc-2dfef101-2"
})(ConfirmPaymentModal_style_templateObject2(), ui.theme.typography.fontSize.md.x1, "".concat(ui.theme.space.x4, " ").concat(ui.theme.space.x0), ui.theme.colors.neutral[550]);
var style_BaseModalHeaderClose = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__BaseModalHeaderClose",
    componentId: "sc-2dfef101-3"
})(ConfirmPaymentModal_style_templateObject3());
var CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.CloseIcon).attrs({
    width: "32px",
    height: "32px",
    strokeWidth: "0.75",
    color: ui.theme.colors.neutral[550]
}).withConfig({
    displayName: "style__CloseIcon",
    componentId: "sc-2dfef101-4"
})(style_templateObject4());
var style_BaseModalBody = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__BaseModalBody",
    componentId: "sc-2dfef101-5"
})(style_templateObject5(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || ui.theme.colors.neutral[80];
}, ui.theme.space.x4);
var style_BaseModalFooter = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__BaseModalFooter",
    componentId: "sc-2dfef101-6"
})(style_templateObject7(), function(param) {
    var gap = param.gap;
    return gap || ui.theme.space.x2;
}, function(param) {
    var padding = param.padding;
    return padding || "initial";
}, function(param) {
    var hasFooterShadow = param.hasFooterShadow;
    return hasFooterShadow && (0,styled_components_browser_esm/* css */.iv)(style_templateObject6());
});
var style_BaseModalFooterButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonSubmit/* ButtonSubmit */.G).attrs({
    alignSelf: "center",
    fontSize: ui.theme.typography.fontSize.sm.x5
}).withConfig({
    displayName: "style__BaseModalFooterButton",
    componentId: "sc-2dfef101-7"
})(style_templateObject8());
var BaseModalFooterText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__BaseModalFooterText",
    componentId: "sc-2dfef101-8"
})(style_templateObject9(), ui.theme.colors.neutral[999], ui.theme.typography.fontFamily.chivo, ui.theme.colors.neutral[999]);

var ConfirmPaymentBody = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__ConfirmPaymentBody",
    componentId: "sc-2dfef101-9"
})(_templateObject10(), ui.theme.space.x2);
var ConfirmPaymentHeader = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__ConfirmPaymentHeader",
    componentId: "sc-2dfef101-10"
})(_templateObject11(), ui.theme.colors.neutral[550], ui.theme.typography.fontSize.sm.x7, ui.theme.space.x2, ui.theme.device.desktopFirst.mobileS, ui.theme.typography.fontSize.sm.x5);
var ConfirmPaymentFieldSet = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__ConfirmPaymentFieldSet",
    componentId: "sc-2dfef101-11"
})(_templateObject12(), ui.theme.space.x2, ui.theme.colors.neutral[520]);
var ConfirmPaymentFieldSetLegend = styled_components_browser_esm/* default.legend.withConfig */.ZP.legend.withConfig({
    displayName: "style__ConfirmPaymentFieldSetLegend",
    componentId: "sc-2dfef101-12"
})(_templateObject13(), ui.theme.colors.neutral[520], ui.theme.typography.fontSize.sm.x5, ui.theme.device.desktopFirst.mobileM, ui.theme.device.desktopFirst.mobileS, ui.theme.typography.fontSize.sm.x5);

;// CONCATENATED MODULE: ../../packages/components/WhatsAppOption/styles.ts

function WhatsAppOption_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: ",
        ";\n      background-color: ",
        ";\n    "
    ]);
    WhatsAppOption_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WhatsAppOption_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  ",
        "\n"
    ]);
    WhatsAppOption_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WhatsAppOption_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    WhatsAppOption_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WhatsAppOption_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  transition: background-color 0.2s ease-in;\n  align-self: flex-start;\n"
    ]);
    WhatsAppOption_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WhatsAppOption_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n\n  @media ",
        " {\n    gap: ",
        ";\n  }\n"
    ]);
    WhatsAppOption_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function WhatsAppOption_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-self: end;\n"
    ]);
    WhatsAppOption_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var WhatsAppOptionContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).attrs({
    alignItems: "center",
    justifyContent: "space-between",
    gap: ui.theme.space.x2
}).withConfig({
    displayName: "styles__WhatsAppOptionContainer",
    componentId: "sc-9363f9b8-0"
})(WhatsAppOption_styles_templateObject1(), ui.theme.space.x4, ui.theme.space.x0, function(param) {
    var hasBackground = param.hasBackground;
    return !hasBackground && (0,styled_components_browser_esm/* css */.iv)(WhatsAppOption_styles_templateObject(), ui.theme.space.x4, ui.theme.colors.neutral["white-075"]);
});
var WhatsAppImage = (0,styled_components_browser_esm/* default */.ZP)(ui.WhatsappIcon).withConfig({
    displayName: "styles__WhatsAppImage",
    componentId: "sc-9363f9b8-1"
})(WhatsAppOption_styles_templateObject2());
var SaveDataButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonSubmit/* ButtonSubmit */.G).attrs({
    fontSize: ui.theme.typography.fontSize.sm.x5,
    height: "4rem",
    type: "button"
}).withConfig({
    displayName: "styles__SaveDataButton",
    componentId: "sc-9363f9b8-2"
})(WhatsAppOption_styles_templateObject3(), ui.theme.space.x0, ui.theme.space.x4);
var WhatsAppForm = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WhatsAppForm",
    componentId: "sc-9363f9b8-3"
})(WhatsAppOption_styles_templateObject4(), ui.theme.space.x2, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x2);
var CheckBoxContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CheckBoxContainer",
    componentId: "sc-9363f9b8-4"
})(WhatsAppOption_styles_templateObject5());


// EXTERNAL MODULE: ../../packages/components/Form/Checkbox/index.tsx + 1 modules
var Checkbox = __webpack_require__(47852);
;// CONCATENATED MODULE: ../../packages/components/WhatsAppOption/test-utils.ts

// MyData
var myDataAccountLayoutTestIds = (0,application/* buildTestIds */.Fek)("my-data-account-layout");
var myDataContainerTestIds = (0,application/* buildTestIds */.Fek)("my-data-container");
var myDataContainerTitleTestIds = (0,application/* buildTestIds */.Fek)("my-data-container-title");
var myDataFormTestIds = (0,application/* buildTestIds */.Fek)("my-data-form");
var myDataFormWrapperTestIds = (0,application/* buildTestIds */.Fek)("my-data-form-wrapper");
var myDataBodyTestIds = (0,application/* buildTestIds */.Fek)("my-data-body");
var myDataFooterTestIds = (0,application/* buildTestIds */.Fek)("my-data-footer");
// Body
var myDataBodyContainerTestIds = (0,application/* buildTestIds */.Fek)("my-data-body-container");
var myDataFieldContainerNameTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-container-name");
var myDataFieldLabelNameTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-label-name");
var myDataFieldInputNameTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-input-name");
var myDataFieldContainerCpfTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-container-cpf");
var myDataFieldLabelCpfTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-label-cpf");
var myDataFieldInputCpfTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-input-cpf");
var myDataFieldContainerEmailTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-container-email");
var myDataFieldLabelEmailTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-label-email");
var myDataFieldInputEmailTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-input-email");
var myDataFieldContainerPhoneNumberTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-container-phone-number");
var myDataFieldLabelPhoneNumberTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-label-phone-number");
var myDataFieldInputPhoneNumberTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-input-phone-number");
var myDataFieldContainerPasswordTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-container-password");
var myDataFieldLabelPasswordTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-label-password");
var myDataFieldInputPasswordTestIds = (0,application/* buildTestIds */.Fek)("my-data-field-input-password");
// Footer
var myDataFooterContainerTestIds = (0,application/* buildTestIds */.Fek)("my-data-footer-container");
var myDataWhatsAppOptionContainerTestIds = (0,application/* buildTestIds */.Fek)("my-data-whatsapp-option-container");
var myDataWhatsAppOptionCheckboxTestIds = (0,application/* buildTestIds */.Fek)("my-data-whatsapp-option-checkbox");
var myDataWhatsAppOptionTextTestIds = (0,application/* buildTestIds */.Fek)("my-data-whatsapp-option-text");
var myDataWhatsAppOptionImageTestIds = (0,application/* buildTestIds */.Fek)("my-data-whatsapp-option-image");
var myDataSaveDataButtonTestIds = (0,application/* buildTestIds */.Fek)("my-data-save-data-button");


;// CONCATENATED MODULE: ../../packages/components/WhatsAppOption/index.tsx













var WhatsAppOption = function(param) {
    var isSavingWhatsAppOption = param.isSavingWhatsAppOption, shallUseToast = param.shallUseToast, finishSaveWhatsAppOption = param.finishSaveWhatsAppOption, _hasBackground = param.hasBackground, hasBackground = _hasBackground === void 0 ? false : _hasBackground;
    var ref;
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var register = (0,index_esm/* useForm */.cI)().register;
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var acceptedWhatsapp = (0,application/* useUser */.aFb)().acceptedWhatsapp;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var defaultErrorMessage = "Ocorreu um erro inesperado, tente novamente";
    var ref1 = (0,react.useState)(acceptedWhatsapp), isOptionChecked = ref1[0], setIsOptionChecked = ref1[1];
    // gabriel.lenon diminuir complexidade
    // eslint-disable-next-line sonarjs/cognitive-complexity
    var onSaveWhatsAppOption = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, data, onSetUserNotificationsError;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(accessToken && isSavingWhatsAppOption)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        implementations/* notificationApi.setUserNotificationsSettingsWhatsApp */.E8.setUserNotificationsSettingsWhatsApp({
                            token_type: "Bearer",
                            access_token: accessToken
                        }, {
                            notificationChannelId: 5,
                            notificationTypeId: 1,
                            receiveNotification: isOptionChecked
                        })
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, onSetUserNotificationsError = ref.error;
                    if (onSetUserNotificationsError) {
                        if (shallUseToast) {
                            addToast({
                                title: "".concat(onSetUserNotificationsError !== null && onSetUserNotificationsError !== void 0 ? onSetUserNotificationsError : defaultErrorMessage),
                                type: "error"
                            });
                        }
                        if (finishSaveWhatsAppOption) finishSaveWhatsAppOption("".concat(onSetUserNotificationsError !== null && onSetUserNotificationsError !== void 0 ? onSetUserNotificationsError : defaultErrorMessage));
                        return [
                            2
                        ];
                    }
                    if (!data) {
                        if (shallUseToast) {
                            addToast({
                                title: defaultErrorMessage,
                                type: "error"
                            });
                        }
                        if (finishSaveWhatsAppOption) finishSaveWhatsAppOption("Ocorreu um erro inesperado, tente novamente");
                        return [
                            2
                        ];
                    }
                    if (shallUseToast) {
                        addToast({
                            title: "Op\xe7\xe3o alterada com sucesso!",
                            type: "success"
                        });
                    }
                    if (finishSaveWhatsAppOption) finishSaveWhatsAppOption();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        accessToken,
        addToast,
        finishSaveWhatsAppOption,
        isOptionChecked,
        isSavingWhatsAppOption,
        shallUseToast, 
    ]);
    (0,react.useEffect)(function() {
        onSaveWhatsAppOption();
    }, [
        accessToken,
        addToast,
        isOptionChecked,
        isSavingWhatsAppOption,
        finishSaveWhatsAppOption,
        shallUseToast,
        onSaveWhatsAppOption, 
    ]);
    var fontSize = isClientMobile ? ui.theme.typography.fontSize.sm.x3 : ui.theme.typography.fontSize.sm.x5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsAppOptionContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        hasBackground: hasBackground
    }, (0,application/* buildTestIds */.Fek)("whatsapp-option-container"), myDataWhatsAppOptionContainerTestIds), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatsAppForm, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("whatsapp-form")), {
            id: "whatsAppForm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("checkbox-Container")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("receive-notification")), {
                        id: "receive-notification",
                        height: ui.theme.space.x4,
                        width: ui.theme.space.x4,
                        borderRadius: ui.theme.space.x1,
                        borderColor: ui.theme.colors.neutral[580],
                        name: "receiveNotification",
                        color: ui.theme.colors.secondary[250],
                        required: false,
                        hasError: false,
                        heightChecked: "8px",
                        widthChecked: "4px",
                        left: "1px",
                        sizeChecked: "1em",
                        register: register,
                        checked: isOptionChecked,
                        disabled: isSavingWhatsAppOption,
                        isCheckedEvent: function(isChecked) {
                            if (isChecked !== null && isChecked !== undefined) {
                                setIsOptionChecked(isChecked);
                            }
                        }
                    }), myDataWhatsAppOptionCheckboxTestIds))
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsAppImage, (0,src_object_spread/* default */.Z)({}, myDataWhatsAppOptionImageTestIds)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("whatsapp-option-text")), {
                    "aria-label": "Desejo acompanhar meu pedido por WhatsApp",
                    fontSize: fontSize,
                    color: ui.theme.colors.neutral[550]
                }), myDataWhatsAppOptionTextTestIds), {
                    textAlign: "flex-start",
                    margin: "0px",
                    children: "Desejo acompanhar meu pedido por WhatsApp"
                }))
            ]
        }))
    }));
};


;// CONCATENATED MODULE: ../../packages/components/ConfirmPaymentModal/index.tsx








var ConfirmPaymentModal = function(_param) {
    var width = _param.width, height = _param.height, _footerGap = _param.footerGap, footerGap = _footerGap === void 0 ? "1rem" : _footerGap, title = _param.title, buttonText = _param.buttonText, alternativeButtonText = _param.alternativeButtonText, buttonTextUnderAction = _param.buttonTextUnderAction, buttonUnderAction = _param.buttonUnderAction, form = _param.form, buttonSize = _param.buttonSize, border = _param.border, onCloseModal = _param.onCloseModal, onClickOnButton = _param.onClickOnButton, onClickAlternativeButton = _param.onClickAlternativeButton, _buttonHoverColor = _param.buttonHoverColor, buttonHoverColor = _buttonHoverColor === void 0 ? ui.theme.colors.secondary[500] : _buttonHoverColor, hasFooterShadow = _param.hasFooterShadow, modalButtonPadding = _param.modalButtonPadding, textDecoration = _param.textDecoration, _isFormInvalid = _param.isFormInvalid, isFormInvalid = _isFormInvalid === void 0 ? false : _isFormInvalid, _modalButtonColor = _param.modalButtonColor, modalButtonColor = _modalButtonColor === void 0 ? ui.theme.colors.secondary[265] : _modalButtonColor, footerText = _param.footerText, modalText = _param.modalText, isOpen = _param.isOpen, isDoingPayment = _param.isDoingPayment, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "width",
        "height",
        "footerGap",
        "title",
        "buttonText",
        "alternativeButtonText",
        "buttonTextUnderAction",
        "buttonUnderAction",
        "form",
        "buttonSize",
        "border",
        "onCloseModal",
        "onClickOnButton",
        "onClickAlternativeButton",
        "buttonHoverColor",
        "hasFooterShadow",
        "modalButtonPadding",
        "textDecoration",
        "isFormInvalid",
        "modalButtonColor",
        "footerText",
        "modalText",
        "isOpen",
        "isDoingPayment"
    ]);
    var acceptedWhatsapp = (0,application/* useUser */.aFb)().acceptedWhatsapp;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_BaseModal, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-modal"), props), {
        styles: {
            content: {
                gap: "16px",
                padding: "0px",
                maxWidth: width,
                minHeight: height !== null && height !== void 0 ? height : "fit-content"
            }
        },
        onCloseModal: onCloseModal,
        contentLabel: title,
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_BaseModalHeader, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-modal-header")), {
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style_BaseModalHeaderTitle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-modal-header-title")), {
                        children: title
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style_BaseModalHeaderClose, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-modal-header-close")), {
                        onClick: onCloseModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {})
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(style_BaseModalBody, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-modal-body")), {
                backgroundColor: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmPaymentBody, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-body")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmPaymentHeader, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-header")), {
                            children: modalText
                        })),
                        !acceptedWhatsapp && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmPaymentFieldSet, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-field-set")), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmPaymentFieldSetLegend, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-field-set-legend")), {
                                    children: "Para acompanhar seu pedido em tempo real via Whatsapp selecione a op\xe7\xe3o abaixo:"
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsAppOption, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("whats-app-option")), {
                                    isSavingWhatsAppOption: !!isDoingPayment,
                                    shallUseToast: false
                                }))
                            ]
                        }))
                    ]
                }))
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_BaseModalFooter, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-modal-footer")), {
                gap: footerGap,
                hasFooterShadow: hasFooterShadow,
                padding: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style_BaseModalFooterButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-modal-footer-button")), {
                        buttonType: "button",
                        text: buttonText,
                        textUnderAction: buttonTextUnderAction,
                        underAction: buttonUnderAction,
                        color: modalButtonColor,
                        hoveredColor: buttonHoverColor,
                        minWidth: typeof buttonSize === "string" ? buttonSize : buttonSize === null || buttonSize === void 0 ? void 0 : buttonSize.minWidth,
                        maxWidth: typeof buttonSize === "string" ? buttonSize : buttonSize === null || buttonSize === void 0 ? void 0 : buttonSize.maxWidth,
                        onClickAction: onClickOnButton,
                        form: form,
                        border: border,
                        height: ui.theme.space.x12,
                        fontWeight: 400
                    })),
                    onClickAlternativeButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(style_BaseModalFooterButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-modal-footer-alternative-button")), {
                        text: alternativeButtonText,
                        isDisabled: isFormInvalid,
                        textUnderAction: "",
                        color: "white",
                        contentColor: "black",
                        hoveredColor: "white",
                        minWidth: typeof buttonSize === "string" ? buttonSize : buttonSize === null || buttonSize === void 0 ? void 0 : buttonSize.minWidth,
                        maxWidth: typeof buttonSize === "string" ? buttonSize : buttonSize === null || buttonSize === void 0 ? void 0 : buttonSize.maxWidth,
                        onClickAction: onCloseModal,
                        padding: modalButtonPadding,
                        buttonType: "button",
                        fontWeight: 700,
                        textDecoration: textDecoration
                    })),
                    !!footerText && /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseModalFooterText, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-modal-footer-text")), {
                        onClick: onCloseModal,
                        children: footerText
                    }))
                ]
            }))
        ]
    }));
};


// EXTERNAL MODULE: ../../packages/components/ConfirmPayment/styles.ts
var styles = __webpack_require__(93240);
// EXTERNAL MODULE: ../../packages/components/RegisterPhoneNumber/index.tsx + 11 modules
var RegisterPhoneNumber = __webpack_require__(4181);
;// CONCATENATED MODULE: ../../packages/components/ConfirmPayment/index.tsx












var ConfirmPayment = function(param) {
    var doPayment = param.doPayment, isDoingPayment = param.isDoingPayment, _isButtonDisabled = param.isButtonDisabled, isButtonDisabled = _isButtonDisabled === void 0 ? false : _isButtonDisabled, modalText = param.modalText, formSubmitButtonId = param.formSubmitButtonId, _isClosedModal = param.isClosedModal, isClosedModal = _isClosedModal === void 0 ? true : _isClosedModal, callbackBeforeOpenModal = param.callbackBeforeOpenModal;
    var ref;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var ref1 = (0,react.useState)(false), isModalOpen = ref1[0], setIsModalOpen = ref1[1];
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var loggedClient = (0,application/* useUser */.aFb)().loggedClient;
    var ref2 = (0,application/* useRegisterPhoneNumber */.KHp)((0,application/* useShallow */.NL6)(function(state) {
        return {
            setIsRegisterPhoneNumberModalOpen: state.setIsRegisterPhoneNumberModalOpen,
            changeCurrentStep: state.changeCurrentStep,
            openCheckoutModal: state.openCheckoutModal,
            setOpenCheckoutModal: state.setOpenCheckoutModal,
            isRegisterPhoneNumberModalOpen: state.isRegisterPhoneNumberModalOpen
        };
    })), setIsRegisterPhoneNumberModalOpen = ref2.setIsRegisterPhoneNumberModalOpen, changeCurrentStep = ref2.changeCurrentStep, openCheckoutModal = ref2.openCheckoutModal, setOpenCheckoutModal = ref2.setOpenCheckoutModal, isRegisterPhoneNumberModalOpen = ref2.isRegisterPhoneNumberModalOpen;
    var handleCloseModal = (0,react.useCallback)(function() {
        setIsModalOpen(false);
        setOpenCheckoutModal(false);
    }, [
        setOpenCheckoutModal
    ]);
    (0,react.useEffect)(function() {
        if (!isClosedModal && !isDoingPayment) {
            handleCloseModal();
        }
    }, [
        isDoingPayment,
        isClosedModal,
        handleCloseModal
    ]);
    var verifyIfUserNeedsToRegisterPhone = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, confirmationTypesResponse;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            implementations/* identityApi.receiveConfirmationTypes */.IJ.receiveConfirmationTypes({
                                cpf: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf),
                                email: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email),
                                jwt: accessToken
                            })
                        ];
                    case 1:
                        confirmationTypesResponse = _state.sent();
                        if (((confirmationTypesResponse === null || confirmationTypesResponse === void 0 ? void 0 : (ref = confirmationTypesResponse.data) === null || ref === void 0 ? void 0 : ref.phoneNumber) === "" || !(confirmationTypesResponse === null || confirmationTypesResponse === void 0 ? void 0 : (ref1 = confirmationTypesResponse.data) === null || ref1 === void 0 ? void 0 : ref1.phoneNumber)) && (!(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber) || (loggedClient === null || loggedClient === void 0 ? void 0 : (ref2 = loggedClient.phoneNumber) === null || ref2 === void 0 ? void 0 : ref2.length) < 10) || !!(0,application/* validatePhoneNumber */.Y08)(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber)) {
                            changeCurrentStep("modalCall");
                            setIsRegisterPhoneNumberModalOpen(true);
                            return [
                                2
                            ];
                        }
                        setIsModalOpen(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function verifyIfUserNeedsToRegisterPhone() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isDoingPayment && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BlockScreen */.Ne, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ButtonContainer */.qO, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-button")), {
                isClientMobile: isClientMobile,
                onClick: function(e) {
                    if (callbackBeforeOpenModal) {
                        callbackBeforeOpenModal();
                    }
                    e.preventDefault();
                    verifyIfUserNeedsToRegisterPhone();
                },
                disabled: isButtonDisabled,
                isButtonDisabled: isButtonDisabled,
                type: "button",
                form: formSubmitButtonId,
                children: "Finalizar pedido"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmPaymentModal, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-payment-modal")), {
                form: "whatsAppForm",
                isOpen: isModalOpen || openCheckoutModal,
                onCloseModal: handleCloseModal,
                width: "630px",
                height: "15rem",
                title: "Finalizar pedido",
                buttonText: "Finalizar pedido",
                buttonUnderAction: isDoingPayment,
                buttonTextUnderAction: "Finalizando pedido...",
                buttonSize: {
                    maxWidth: "596px",
                    minWidth: "264px"
                },
                modalButtonColor: ui.theme.colors.secondary[250],
                onClickOnButton: function() {
                    doPayment();
                },
                buttonHoverColor: ui.theme.colors.secondary[700],
                footerGap: "5.5rem",
                modalButtonPadding: "2rem",
                modalText: modalText,
                isDoingPayment: isDoingPayment
            })),
            isRegisterPhoneNumberModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterPhoneNumber/* RegisterPhoneNumber */.n, {})
        ]
    });
};


// EXTERNAL MODULE: ../../packages/components/CountdownCircleTimer/index.tsx
var CountdownCircleTimer = __webpack_require__(49911);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ../../packages/components/Form/InputNumber/style.ts

function InputNumber_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ';\n  border-radius: 4px;\n  padding: 1px;\n  /* overflow: hidden; */\n  display: flex;\n  input[type="number"]::-webkit-outer-spin-button,\n  input[type="number"]::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  input[type="number"] {\n    -moz-appearance: textfield;\n    -webkit-box-shadow: none;\n    max-width: 4rem;\n    font-size: 1rem;\n    color: ',
        ";\n    font-weight: ",
        ";\n    font-family: ",
        ';\n    background: none;\n    border: none;\n    text-align: center;\n    line-height: 35px;\n  }\n  input[type="number"]:focus-visible {\n    outline: -webkit-focus-ring-color auto 1px;\n  }\n  button {\n    background: none;\n    border: none;\n    width: 2rem;\n    height: 3rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n  }\n  button span {\n    font-size: 3rem;\n    color: ',
        ";\n  }\n  button:first-child > span {\n    transform: rotate(90deg);\n  }\n  button:last-child > span {\n    transform: rotate(-90deg);\n  }\n  button:active,\n  button:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    InputNumber_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__StyledInput",
    componentId: "sc-141ce54e-0"
})(InputNumber_style_templateObject(), ui.theme.colors.neutral[80], ui.theme.colors.neutral[520], ui.theme.typography.fontWeight.bold, ui.theme.typography.fontFamily.chivo, ui.theme.colors.neutral[999], ui.theme.colors.neutral[200]);

;// CONCATENATED MODULE: ../../packages/components/Form/InputNumber/index.tsx







var InputNumber = function(param) {
    var productListId = param.productListId, _min = param.min, min = _min === void 0 ? 1 : _min, _max = param.max, max = _max === void 0 ? 99999 : _max, setCountState = param.setCountState, _valueCount = param.valueCount, valueCount = _valueCount === void 0 ? 1 : _valueCount, callbackMaxQuantity = param.callbackMaxQuantity, _debounceTime = param.debounceTime, debounceTime = _debounceTime === void 0 ? 500 : _debounceTime, isInputClicked = param.isInputClicked, productQuantity = param.productQuantity;
    var ref = (0,react.useState)(valueCount !== null && valueCount !== void 0 ? valueCount : min), count = ref[0], setCount = ref[1];
    var ref1 = (0,react.useState)(false), isClicked = ref1[0], setIsClicked = ref1[1];
    var increase = function() {
        var quantity = productQuantity || count;
        setIsClicked(true);
        if (quantity === max && callbackMaxQuantity) {
            callbackMaxQuantity();
        }
        setCount(function(state) {
            if (quantity > max) {
                if (callbackMaxQuantity) {
                    callbackMaxQuantity();
                }
                return max || 1;
            }
            if (quantity < max) {
                if (!Number.isInteger(state)) {
                    return +(state + min).toFixed(2);
                }
                return state + min;
            }
            return state;
        });
    };
    var decrease = function() {
        setIsClicked(true);
        setCount(function(state) {
            if (state > min) {
                if (!Number.isInteger(state)) {
                    return +(state - min).toFixed(2);
                }
                return state - min;
            }
            return state;
        });
    };
    var validateCountInput = (0,react.useCallback)(function() {
        setCount(function(state) {
            var quantity = productQuantity || state;
            if (!state) {
                return min;
            }
            if (quantity > max && state !== min) {
                if (callbackMaxQuantity) {
                    callbackMaxQuantity();
                }
                return max || 1;
            }
            if (state < min) {
                return min;
            }
            if (!Number.isInteger(state / min)) {
                return +(Math.round(state / min) * min).toFixed(2);
            }
            return state;
        });
    }, [
        productQuantity,
        max,
        min,
        callbackMaxQuantity
    ]);
    var handlerInput = function(e) {
        var newValue = parseInt(e.target.value, 10);
        setCount(newValue);
    };
    (0,react.useEffect)(function() {
        if (isClicked && isInputClicked) {
            isInputClicked();
        }
    }, [
        isInputClicked,
        isClicked
    ]);
    (0,react.useEffect)(function() {
        validateCountInput();
    }, [
        max,
        validateCountInput
    ]);
    var debouncedCount = (0,application/* useDebounce */.NrF)(count, debounceTime);
    (0,react.useEffect)(function() {
        setCountState(debouncedCount);
    }, [
        debouncedCount,
        setCountState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("styled-input-container")), {
        children: [
            !productListId && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "button",
                onClick: decrease
            }, (0,application/* buildTestIds */.Fek)("decrease-counter-button")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowDown, {})
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("value-input-number")), {
                id: "value-input-number",
                "aria-label": "Contador",
                onBlur: validateCountInput,
                type: "number",
                inputMode: "numeric",
                onChange: handlerInput,
                value: Number.isNaN(count) ? "" : count
            })),
            !productListId && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "button",
                onClick: increase
            }, (0,application/* buildTestIds */.Fek)("add-counter-button")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowUp, {})
            }))
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/CountQuantityProduct/data.ts
var getAvailableStock = function(maximumStockPerBranch, totalStockFC) {
    return maximumStockPerBranch !== null && maximumStockPerBranch !== void 0 ? maximumStockPerBranch : totalStockFC;
};
var getMaxProductPossible = function(factPackaged) {
    return factPackaged === 0 ? 150 : 1000;
};
var getMaxQuantityProduct = function(availableStock, productsQuantity, packingQuantity, factPackaged) {
    return availableStock < productsQuantity * (packingQuantity !== null && packingQuantity !== void 0 ? packingQuantity : 1) ? Math.floor(availableStock / (packingQuantity !== null && packingQuantity !== void 0 ? packingQuantity : 1)) : getMaxProductPossible(factPackaged);
};
var getAlertMessage = function(maxQuantity, packageDescription) {
    return "Ops! Este produto possui o limite de ".concat(maxQuantity, " ").concat(packageDescription, " por pessoa.");
};
var getIsMaxQuantity = function(productsQuantity, maxQuantityProduct, packingQuantity) {
    return productsQuantity * (packingQuantity !== null && packingQuantity !== void 0 ? packingQuantity : 1) >= maxQuantityProduct;
};
var getMaxQuantityLimitReason = function(availableStock, productsQuantity, packingQuantity, factPackaged) {
    if (availableStock <= productsQuantity * (packingQuantity !== null && packingQuantity !== void 0 ? packingQuantity : 1)) {
        return "stock";
    }
    if ((factPackaged === 0 && productsQuantity >= 150 || factPackaged !== 0 && productsQuantity >= 1000) && availableStock > productsQuantity * (packingQuantity !== null && packingQuantity !== void 0 ? packingQuantity : 1)) {
        return "cpf";
    }
    return null;
};

// EXTERNAL MODULE: ../../packages/ui/themes/index.ts + 15 modules
var themes = __webpack_require__(27814);
;// CONCATENATED MODULE: ../../packages/components/CountQuantityProduct/styles.ts

function CountQuantityProduct_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-self: flex-start;\n"
    ]);
    CountQuantityProduct_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CountQuantityProduct_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-bottom: 5px;\n  text-align: left;\n  font-size: 1.2rem;\n  font-weight: 500;\n"
    ]);
    CountQuantityProduct_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CountQuantityProduct_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    CountQuantityProduct_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CountQuantityProduct_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 0.8rem;\n  font-weight: 500;\n  gap: 1.2rem;\n  align-items: center;\n"
    ]);
    CountQuantityProduct_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CountQuantityProduct_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1rem;\n  font-weight: bold;\n  color: ",
        ";\n  text-transform: ",
        ";\n"
    ]);
    CountQuantityProduct_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var BoxQuantity = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxQuantity",
    componentId: "sc-d3c2d974-0"
})(CountQuantityProduct_styles_templateObject());
var TitleBoxQuantity = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TitleBoxQuantity",
    componentId: "sc-d3c2d974-1"
})(CountQuantityProduct_styles_templateObject1(), themes/* theme.colors.neutral.450 */.rS.colors.neutral[450]);
var BoxDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxDescription",
    componentId: "sc-d3c2d974-2"
})(CountQuantityProduct_styles_templateObject2());
var SelectQuantity = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SelectQuantity",
    componentId: "sc-d3c2d974-3"
})(CountQuantityProduct_styles_templateObject3());
var TextUni = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TextUni",
    componentId: "sc-d3c2d974-4"
})(CountQuantityProduct_styles_templateObject4(), themes/* theme.colors.neutral.520 */.rS.colors.neutral[520], function(capitalize) {
    return capitalize ? "capitalize" : "lowercase";
});

;// CONCATENATED MODULE: ../../packages/components/CountQuantityProduct/index.tsx









var PopUpAlertConfirm = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 15261)).then(function(module) {
        return module.PopUpAlertConfirm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15261)
            ];
        }
    }
});
var CountQuantityProduct_Skeleton = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 44860)).then(function(module) {
        return module.Skeleton;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44860)
            ];
        }
    }
});
var validateValue = function(value, max, min) {
    if (!value) {
        return min;
    }
    if (value > max) {
        return max;
    }
    if (value < min) {
        return min;
    }
    if (!Number.isInteger(value / min)) {
        return +(Math.round(value / min) * min).toFixed(2);
    }
    return value;
};
var messageLimitByCpf = "unidade(s) por cliente.";
var CountQuantityProduct = function(param) {
    var setProductQuantity = param.setProductQuantity, _descriptionPackagingUnitSingular = param.descriptionPackagingUnitSingular, descriptionPackagingUnitSingular = _descriptionPackagingUnitSingular === void 0 ? "" : _descriptionPackagingUnitSingular, _descriptionPackagingUnitPlural = param.descriptionPackagingUnitPlural, descriptionPackagingUnitPlural = _descriptionPackagingUnitPlural === void 0 ? "" : _descriptionPackagingUnitPlural, factPackaged = param.factPackaged, measuredUnity = param.measuredUnity, packingUnity = param.packingUnity, packingQuantity = param.packingQuantity, productListId = param.productListId, _resumeDescription = param.resumeDescription, resumeDescription = _resumeDescription === void 0 ? false : _resumeDescription, quantityItemSelected = param.quantityItemSelected, minValue = param.minValue, _totalStockFC = param.totalStockFC, totalStockFC = _totalStockFC === void 0 ? 1 : _totalStockFC, _maximumStockPerBranch = param.maximumStockPerBranch, maximumStockPerBranch = _maximumStockPerBranch === void 0 ? 1 : _maximumStockPerBranch, limitQuantityItem = param.limitQuantityItem, loadingGiftProducts = param.loadingGiftProducts, _debounceTime = param.debounceTime, debounceTime = _debounceTime === void 0 ? 500 : _debounceTime;
    var formattedQuantityItemSelected = quantityItemSelected !== null && quantityItemSelected !== void 0 ? quantityItemSelected : 1;
    var ref = (0,application/* useCartContext */.iQs)(), messageError = ref.messageError, setLimitItemsPerCpf = ref.setLimitItemsPerCpf;
    var ref1 = (0,react.useState)(formattedQuantityItemSelected), quantityProductSelected = ref1[0], setQuantityProductSelected = ref1[1];
    var ref2 = (0,react.useState)(false), isPopUpAlertConfirmOpen = ref2[0], setIsPopUpAlertConfirmOpen = ref2[1];
    var ref3 = (0,react.useState)(quantityProductSelected), initialValue = ref3[0], setInitialValue = ref3[1];
    var QUANTITY_CURRENT_FORMAT = factPackaged ? (quantityProductSelected / factPackaged).toFixed(0) : quantityProductSelected;
    var DESCRIPTION_PACKAGED = packingUnity === "m\xb2" || packingUnity === "M2" ? QUANTITY_CURRENT_FORMAT === "1" ? "embalagem" : "embalagens" : quantityProductSelected > 1 ? descriptionPackagingUnitPlural : descriptionPackagingUnitSingular;
    var QUANTITY_CURRENT_PACKAGE = factPackaged ? "".concat(factPackaged, " ").concat(measuredUnity) : "".concat(packingQuantity, " ").concat(measuredUnity);
    var COUNT_TOTAL_ITEMS = factPackaged ? "".concat(quantityProductSelected, " ").concat(measuredUnity) : packingQuantity ? "".concat(packingQuantity * quantityProductSelected, " ").concat(measuredUnity) : 0;
    var maxQuantityLimitReason = (0,react.useCallback)(function(availableStock, productsQuantity, productPackingQuantity, productFactPackaged) {
        return getMaxQuantityLimitReason(availableStock, productsQuantity, productPackingQuantity, productFactPackaged);
    }, []);
    var handleActionCloseButton = (0,react.useCallback)(function() {
        setIsPopUpAlertConfirmOpen(false);
    }, []);
    (0,react.useLayoutEffect)(function() {
        var normalizedQuantityProductSelected = quantityProductSelected / (factPackaged || 1);
        var maxQuantityProduct = getMaxQuantityProduct(getAvailableStock(maximumStockPerBranch, totalStockFC), Number(QUANTITY_CURRENT_FORMAT), packingQuantity, factPackaged);
        if (!Number.isNaN(quantityProductSelected) && Number(normalizedQuantityProductSelected) <= maxQuantityProduct) {
            var newProductQuantity = validateValue(Number(normalizedQuantityProductSelected), limitQuantityItem !== null && limitQuantityItem !== void 0 ? limitQuantityItem : maxQuantityProduct, minValue !== null && minValue !== void 0 ? minValue : 1);
            if (quantityProductSelected !== initialValue) {
                setProductQuantity(newProductQuantity);
            }
        }
        if (maxQuantityProduct) {
            setLimitItemsPerCpf(maxQuantityProduct);
        }
    }, [
        quantityProductSelected,
        factPackaged,
        limitQuantityItem,
        minValue,
        initialValue,
        setProductQuantity,
        setLimitItemsPerCpf,
        maximumStockPerBranch,
        totalStockFC,
        QUANTITY_CURRENT_FORMAT,
        packingQuantity, 
    ]);
    var resumeDescriptionText = function(value) {
        var descriptionSingular = descriptionPackagingUnitSingular || packingUnity === "m\xb2" && "Metro Quadrado";
        var descriptionPlural = descriptionPackagingUnitPlural || packingUnity === "m\xb2" && "Metros Quadrados";
        return value ? descriptionPlural : descriptionSingular;
    };
    var maxQuantityLimitReasonMemoized = (0,react.useMemo)(function() {
        return maxQuantityLimitReason(getAvailableStock(maximumStockPerBranch, totalStockFC), Number(QUANTITY_CURRENT_FORMAT), packingQuantity, factPackaged);
    }, [
        maxQuantityLimitReason,
        maximumStockPerBranch,
        totalStockFC,
        QUANTITY_CURRENT_FORMAT,
        packingQuantity,
        factPackaged, 
    ]);
    var maxQuantityProduct = (0,react.useMemo)(function() {
        return getMaxQuantityProduct(getAvailableStock(maximumStockPerBranch, totalStockFC), Number(QUANTITY_CURRENT_FORMAT), packingQuantity, factPackaged);
    }, [
        QUANTITY_CURRENT_FORMAT,
        factPackaged,
        maximumStockPerBranch,
        packingQuantity,
        totalStockFC, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxQuantity, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("count-quantity-product-box-quantity")), {
                children: [
                    !resumeDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBoxQuantity, {
                        children: "Quantidade"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectQuantity, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("count-quantity-product-select-quantity")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNumber, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                setCountState: function(newValue) {
                                    return setQuantityProductSelected(newValue);
                                },
                                isInputClicked: function() {
                                    setInitialValue(quantityProductSelected);
                                }
                            }, (0,application/* buildTestIds */.Fek)("count-quantity-product-input-number")), {
                                productListId: productListId,
                                min: (minValue !== null && minValue !== void 0 ? minValue : factPackaged && factPackaged > 1) ? factPackaged : 1,
                                max: limitQuantityItem !== null && limitQuantityItem !== void 0 ? limitQuantityItem : maxQuantityProduct,
                                callbackMaxQuantity: function() {
                                    setIsPopUpAlertConfirmOpen(true);
                                },
                                productQuantity: Number(QUANTITY_CURRENT_FORMAT),
                                valueCount: quantityProductSelected,
                                debounceTime: debounceTime
                            })),
                            resumeDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextUni, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("count-quantity-product-text-quantity-uni")), {
                                capitalize: resumeDescription,
                                children: resumeDescriptionText(quantityProductSelected > 1)
                            })) : !factPackaged && packingQuantity === 1 && !Number.isNaN(quantityProductSelected) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextUni, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("count-quantity-product-text-quantity-uni")), {
                                children: [
                                    quantityProductSelected,
                                    " ",
                                    quantityProductSelected > 1 ? descriptionPackagingUnitPlural : descriptionPackagingUnitSingular
                                ]
                            })) : !Number.isNaN(quantityProductSelected) && QUANTITY_CURRENT_FORMAT && DESCRIPTION_PACKAGED && QUANTITY_CURRENT_PACKAGE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxDescription, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("count-quantity-product-box-description")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextUni, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("count-quantity-product-text-uni")), {
                                            children: "".concat(QUANTITY_CURRENT_FORMAT, " ").concat(DESCRIPTION_PACKAGED, " de ").concat(QUANTITY_CURRENT_PACKAGE)
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextUni, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("count-quantity-product-text-uni")), {
                                            children: "( total de ".concat(COUNT_TOTAL_ITEMS, " )")
                                        }))
                                    ]
                                })
                            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CountQuantityProduct_Skeleton, {
                                count: 1,
                                width: 100,
                                height: 20
                            })
                        ]
                    }))
                ]
            })),
            (limitQuantityItem || maxQuantityProduct) && !(messageError === null || messageError === void 0 ? void 0 : messageError.includes(messageLimitByCpf)) && isPopUpAlertConfirmOpen && maxQuantityLimitReasonMemoized === "cpf" && (!productListId || productListId && !loadingGiftProducts) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpAlertConfirm, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("count-quantity-product-pop-up-alert-confirm")), {
                textHeader: "Limite excedido",
                descriptionBody: getAlertMessage(getMaxQuantityProduct(getAvailableStock(maximumStockPerBranch, totalStockFC), Number(QUANTITY_CURRENT_FORMAT), packingQuantity, factPackaged), DESCRIPTION_PACKAGED === null || DESCRIPTION_PACKAGED === void 0 ? void 0 : DESCRIPTION_PACKAGED.toLowerCase()),
                isOpen: true,
                actionCloseButton: handleActionCloseButton
            })) : null,
            isPopUpAlertConfirmOpen && maxQuantityLimitReasonMemoized === "stock" && !(messageError === null || messageError === void 0 ? void 0 : messageError.includes(messageLimitByCpf)) && (!productListId || productListId && !loadingGiftProducts) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpAlertConfirm, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("count-quantity-product-pop-up-alert-confirm")), {
                textHeader: "Limite atingido",
                descriptionBody: "N\xe3o \xe9 poss\xedvel adicionar mais unidades desse produto devido ao estoque dispon\xedvel.",
                isOpen: true,
                actionCloseButton: handleActionCloseButton
            })) : null
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/components/DropdownEllipsis/style.ts

function DropdownEllipsis_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    DropdownEllipsis_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DropdownEllipsis_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 6px;\n  height: 6px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 100%;\n  margin: 0 0.17rem;\n  justify-content: center;\n  background-color: ",
        ";\n  transition: 500ms;\n"
    ]);
    DropdownEllipsis_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DropdownEllipsis_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  margin-right: 1rem;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  -webkit-tap-highlight-color: transparent;\n\n  :hover {\n    ",
        " {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    DropdownEllipsis_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DropdownEllipsis_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  visibility: ",
        ";\n  opacity: ",
        ";\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  margin-top: ",
        ";\n  margin-left: ",
        ";\n  width: ",
        ";\n  background-color: ",
        ";\n  align-items: flex-start;\n  justify-content: right;\n  position: absolute;\n  box-shadow: -1px 2px 6px rgb(0 0 0 / 16%);\n  transition: all 0.2s ease-in-out;\n  -webkit-tap-highlight-color: transparent;\n  z-index: 99;\n"
    ]);
    DropdownEllipsis_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DropdownEllipsis_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 1rem;\n  font-size: ",
        ";\n  color: ",
        ";\n  width: -webkit-fill-available;\n"
    ]);
    DropdownEllipsis_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var DropdownEllipsisStyled = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__DropdownEllipsisStyled",
    componentId: "sc-225f877b-0"
})(DropdownEllipsis_style_templateObject());
var Dots = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__Dots",
    componentId: "sc-225f877b-1"
})(DropdownEllipsis_style_templateObject1(), ui.theme.colors.neutral[320]);
var DropdownEllipsisWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__DropdownEllipsisWrapper",
    componentId: "sc-225f877b-2"
})(DropdownEllipsis_style_templateObject2(), Dots, ui.theme.colors.neutral[520]);
var DropdownEllipsisContent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "style__DropdownEllipsisContent",
    componentId: "sc-225f877b-3"
})(DropdownEllipsis_style_templateObject3(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "visible" : "hidden";
}, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "1.0" : "0";
}, function(param) {
    var marginTop = param.marginTop;
    return marginTop !== null && marginTop !== void 0 ? marginTop : "initial";
}, function(param) {
    var marginLeft = param.marginLeft;
    return marginLeft !== null && marginLeft !== void 0 ? marginLeft : "initial";
}, function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "initial";
}, ui.theme.colors.neutral.white);
var DropdownEllipsisContentOption = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__DropdownEllipsisContentOption",
    componentId: "sc-225f877b-4"
})(DropdownEllipsis_style_templateObject4(), function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, ui.theme.colors.primary[200]);

;// CONCATENATED MODULE: ../../packages/components/DropdownEllipsis/index.tsx






var DropdownEllipsis = function(param) {
    var _content = param.//   showEllipsis,
    //   isContentOpened,
    content, _props = _content.props, _marginTop = _props.marginTop, marginTop = _marginTop === void 0 ? "initial" : _marginTop, _marginLeft = _props.marginLeft, marginLeft = _marginLeft === void 0 ? "initial" : _marginLeft, _width = _props.width, width = _width === void 0 ? "initial" : _width, options = _content.options;
    var ref = (0,react.useState)(false), isContentOpened = ref[0], setIsContentOpened = ref[1];
    var dropdownEllipsisWrapperRef = (0,react.useRef)(null);
    (0,application/* useClickOutside */.O8h)({
        ref: dropdownEllipsisWrapperRef,
        callback: function() {
            if (isContentOpened) {
                setIsContentOpened(false);
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownEllipsisStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("dropdown-ellipsis-styled")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownEllipsisWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("dropdown-ellipsis-wrapper")), {
                ref: dropdownEllipsisWrapperRef,
                onClick: function() {
                    setIsContentOpened(!isContentOpened);
                },
                "data-testid": "dropdown-ellipsis-wrapper",
                "data-cy": "dropdown-ellipsis-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots, {
                        "data-testid": "dropdown-ellipsis-wrapper-dot-one",
                        "data-cy": "dropdown-ellipsis-wrapper-dot-one"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots, {
                        "data-testid": "dropdown-ellipsis-wrapper-dot-two",
                        "data-cy": "dropdown-ellipsis-wrapper-dot-two"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots, {
                        "data-testid": "dropdown-ellipsis-wrapper-dot-three",
                        "data-cy": "dropdown-ellipsis-wrapper-dot-three"
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownEllipsisContent, {
                isVisible: isContentOpened,
                marginTop: marginTop,
                marginLeft: marginLeft,
                width: width,
                "data-testid": "dropdown-ellipsis-content",
                children: options === null || options === void 0 ? void 0 : options.map(function(param) {
                    var title = param.title, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "inherit" : _fontSize, onClickAction = param.onClickAction;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownEllipsisContentOption, {
                        onClick: function(event) {
                            event.stopPropagation();
                            event.preventDefault();
                            onClickAction();
                        },
                        fontSize: fontSize,
                        "data-testid": "dropdown-ellipsis-content-option-".concat(title),
                        "data-cy": "dropdown-ellipsis-content-option-".concat(title),
                        children: title
                    }, title);
                })
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/ErrorPage/styles.ts

function ErrorPage_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 90vh;\n  background-color: ",
        ";\n"
    ]);
    ErrorPage_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ErrorPage_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  text-align: center;\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    ErrorPage_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ErrorPageContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ErrorPageContainer",
    componentId: "sc-fe44295f-0"
})(ErrorPage_styles_templateObject(), ui.theme.colors.neutral[25]);
var ErrorText = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__ErrorText",
    componentId: "sc-fe44295f-1"
})(ErrorPage_styles_templateObject1(), ui.theme.typography.fontSize.md.x3, ui.theme.colors.neutral[520], ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x9);

;// CONCATENATED MODULE: ../../packages/components/ErrorPage/index.tsx


var ErrorPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPageContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
            children: "Ops, ocorreu um erro inesperado. Por favor, tente novamente em instantes."
        })
    });
};


;// CONCATENATED MODULE: ../../packages/components/FinalizeOrderModal/index.tsx







var FinalizeOrderModal = function(param) {
    var isOpen = param.isOpen, onCloseModal = param.onCloseModal, buttonUnderAction = param.buttonUnderAction, onClickOnButton = param.onClickOnButton, onClickAlternativeButton = param.onClickAlternativeButton, titleHeader = param.titleHeader, subtitleHeader = param.subtitleHeader, buttonText = param.buttonText, buttonTextUnderAction = param.buttonTextUnderAction, _footerText = param.footerText, footerText = _footerText === void 0 ? "" : _footerText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            buttonUnderAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BlockScreen */.Ne, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmPaymentModal, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("finalize-order-modal")), {
                form: "whatsAppForm",
                isOpen: isOpen,
                onCloseModal: onCloseModal,
                width: "",
                height: "20rem",
                title: titleHeader,
                buttonText: buttonText,
                buttonUnderAction: buttonUnderAction,
                buttonTextUnderAction: buttonTextUnderAction,
                buttonSize: "100px",
                modalButtonColor: ui.theme.colors.secondary[300],
                onClickOnButton: onClickOnButton,
                onClickAlternativeButton: onClickAlternativeButton,
                buttonHoverColor: ui.theme.colors.secondary[700],
                footerGap: "5.5rem",
                modalButtonPadding: "2rem",
                alternativeButtonText: "",
                footerText: footerText,
                modalText: subtitleHeader
            }))
        ]
    });
};


// EXTERNAL MODULE: ../../packages/ui/Icons/index.tsx + 326 modules
var Icons = __webpack_require__(39927);
// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
;// CONCATENATED MODULE: ../../packages/components/FormNewAddress/styles.ts

function FormNewAddress_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 1rem;\n"
    ]);
    FormNewAddress_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FormNewAddress_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-right: ",
        ";\n  gap: 0.5rem;\n  flex-direction: ",
        ";\n  @media ",
        " {\n    width: 100%;\n    grid-template-rows: 1fr;\n    place-items: center;\n  }\n"
    ]);
    FormNewAddress_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FormNewAddress_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 15px;\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  font-family: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    FormNewAddress_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FormNewAddress_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 4rem;\n"
    ]);
    FormNewAddress_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FormNewAddress_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.3rem;\n  font-weight: 500;\n  background-color: ",
        ";\n  border: none;\n  padding: 1rem 2.5rem;\n  color: ",
        ";\n  border-radius: 8px;\n  cursor: ",
        ";\n  opacity: ",
        ";\n\n  ",
        "\n"
    ]);
    FormNewAddress_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FormNewAddress_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  @media ",
        " {\n    height: ",
        ";\n    grid-template-rows: 1fr;\n  }\n\n  @media (max-width: 1440px) {\n    grid-template-rows: 1fr;\n  }\n"
    ]);
    FormNewAddress_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.5rem;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2rem;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  max-width: 600px;\n  justify-content: ",
        ";\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 2rem;\n\n  @media ",
        " {\n    flex-direction: ",
        ";\n    gap: 1.5rem;\n  }\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n  padding-top: 1rem;\n\n  @media ",
        " {\n    justify-content: flex-start;\n    margin-top: 0;\n    margin-bottom: 2.5rem;\n  }\n\n  @media ",
        " {\n    justify-content: flex-start;\n    margin-top: 0;\n    margin-bottom: 2.5rem;\n  }\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 5px;\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0.5;\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 1.5rem -1rem;\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  margin-bottom: 1rem;\n  flex-direction: ",
        ";\n\n  @media ",
        " {\n    flex-direction: ",
        ";\n    gap: 0.8rem;\n  }\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1;\n  position: absolute;\n  right: 20%;\n  margin-top: -1rem;\n  @media ",
        " {\n    width: 4rem;\n    left: 7rem;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-family: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        " !important;\n  opacity: ",
        ";\n  background-color: ",
        ";\n  max-width: ",
        ";\n\n  @media ",
        " {\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    border: ",
        ";\n    ",
        ";\n  }\n\n  &:checked {\n    background-color: ",
        " !important;\n    border-color: ",
        " !important;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.2rem;\n  border: thin solid ",
        ";\n  color: thin solid ",
        ";\n  border-radius: 8px;\n  padding: 1.2rem 0.9rem;\n  width: 200px;\n  height: 4.4rem;\n  margin-top: 0.5rem;\n\n  border-color: ",
        ";\n  border-color: ",
        ";\n  opacity: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 16px;\n  transition: background-color 0.2s ease-in;\n  align-self: center;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 4rem;\n  padding: 2.75rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding-top: 0.5rem;\n\n  @media ",
        " {\n    padding-top: 0;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: fit-content;\n  margin-bottom: 3rem;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}






var sizeInput = {
    large: "24.125rem",
    medium: "15.8125rem",
    small: "11.325rem"
};
var IconLoading = (0,styled_components_browser_esm/* default */.ZP)(Loading/* Loading */.g).withConfig({
    displayName: "styles__IconLoading",
    componentId: "sc-31c2285-0"
})(FormNewAddress_styles_templateObject());
var ExtraInfoCEP = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ExtraInfoCEP",
    componentId: "sc-31c2285-1"
})(FormNewAddress_styles_templateObject1(), function(param) {
    var isdisplayedonbottomsheet = param.isdisplayedonbottomsheet;
    return isdisplayedonbottomsheet ? "0" : "5rem";
}, function(param) {
    var isdisplayedonbottomsheet = param.isdisplayedonbottomsheet;
    return isdisplayedonbottomsheet ? "row-reverse" : "row";
}, ui.theme.device.desktopFirst.mobileXL);
var DescriptionText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DescriptionText",
    componentId: "sc-31c2285-2"
})(FormNewAddress_styles_templateObject2(), ui.theme.colors.secondary[250], ui.theme.typography.fontFamily.barlow, ui.theme.device.desktopFirst.laptopL, ui.theme.typography.fontSize.sm.x3, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x3);
var BoxButtonDefault = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BoxButtonDefault",
    componentId: "sc-31c2285-3"
})(FormNewAddress_styles_templateObject3());
var ButtonDefaultForm = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonDefaultForm",
    componentId: "sc-31c2285-4"
})(FormNewAddress_styles_templateObject4(), function(param) {
    var purchaseScreen = param.purchaseScreen;
    return purchaseScreen ? ui.theme.colors.secondary[360] : ui.theme.colors.secondary[300];
}, ui.theme.colors.neutral.white, function(param) {
    var disabled = param.disabled;
    return disabled ? "default" : "pointer";
}, function(param) {
    var disabled = param.disabled;
    return disabled ? 0.5 : 1;
}, function(param) {
    var disabled = param.disabled, purchaseScreen = param.purchaseScreen;
    return !disabled && "\n      &:hover {\n        background-color: ".concat(purchaseScreen ? ui.theme.colors.secondary[420] : ui.theme.colors.secondary[500], ";\n      }\n    ");
});
var FormNewAddressContainer = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "styles__FormNewAddressContainer",
    componentId: "sc-31c2285-5"
})(FormNewAddress_styles_templateObject5(), ui.theme.device.desktopFirst.tablet, function(param) {
    var isCheckoutPage = param.isCheckoutPage;
    return isCheckoutPage ? "auto" : "39rem";
});
var SpaceMobileTop = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SpaceMobileTop",
    componentId: "sc-31c2285-6"
})(styles_templateObject6());
var SpaceMobileBottom = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SpaceMobileBottom",
    componentId: "sc-31c2285-7"
})(styles_templateObject7());
var FormNewAddressContent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__FormNewAddressContent",
    componentId: "sc-31c2285-8"
})(styles_templateObject8(), function(param) {
    var isCheckoutPage = param.isCheckoutPage;
    return isCheckoutPage ? "initial" : "center";
});
var WrapperContentHouse = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperContentHouse",
    componentId: "sc-31c2285-9"
})(styles_templateObject9(), ui.theme.device.desktopFirst.mobileXL, function(param) {
    var isdisplayedonbottomsheet = param.isdisplayedonbottomsheet;
    return isdisplayedonbottomsheet ? "row" : "column";
});
var AlignWrapperInput = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__AlignWrapperInput",
    componentId: "sc-31c2285-10"
})(styles_templateObject10(), ui.theme.device.desktopFirst.mobileS, ui.theme.device.desktopFirst.tablet);
var WrapperInput = (0,styled_components_browser_esm/* default */.ZP)(ui.Row).withConfig({
    displayName: "styles__WrapperInput",
    componentId: "sc-31c2285-11"
})(styles_templateObject11());
var WrapperSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperSelect",
    componentId: "sc-31c2285-12"
})(styles_templateObject12());
var WrapperRow = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__WrapperRow",
    componentId: "sc-31c2285-13"
})(styles_templateObject13(), function(param) {
    var isFlex = param.isFlex;
    return isFlex ? "20px" : "2.5rem";
}, function(param) {
    var isFlex = param.isFlex;
    return isFlex ? "column-reverse" : "row";
}, ui.theme.device.desktopFirst.tablet, function(param) {
    var isdisplayedonbottomsheet = param.isdisplayedonbottomsheet;
    return isdisplayedonbottomsheet ? "row" : "column";
});
var CheckDoneSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CheckDoneSection",
    componentId: "sc-31c2285-14"
})(_templateObject14(), ui.theme.device.desktopFirst.mobileL);
var CustomLabelNewAddress = (0,styled_components_browser_esm/* default */.ZP)(Form/* Label */.__).withConfig({
    displayName: "styles__CustomLabelNewAddress",
    componentId: "sc-31c2285-15"
})(_templateObject15(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x5);
var CustomInputNewAddress = (0,styled_components_browser_esm/* default */.ZP)(Form/* Input */.II).withConfig({
    displayName: "styles__CustomInputNewAddress",
    componentId: "sc-31c2285-16"
})(_templateObject16(), function(param) {
    var size = param.size;
    return sizeInput[size !== null && size !== void 0 ? size : "medium"];
}, function(param) {
    var disabled = param.disabled;
    return disabled ? 0.5 : 1;
}, function(param) {
    var disabled = param.disabled;
    return disabled ? ui.theme.colors.neutral[100] : ui.theme.colors.neutral.white;
}, function(param) {
    var isdisplayedonbottomsheet = param.isdisplayedonbottomsheet;
    return isdisplayedonbottomsheet ? "184px" : "none";
}, ui.theme.device.desktopFirst.mobileS, function(param) {
    var isdisplayedonbottomsheet = param.isdisplayedonbottomsheet;
    return isdisplayedonbottomsheet ? "184px" : "100%";
});
var CustomCheckboxNewAddress = (0,styled_components_browser_esm/* default */.ZP)(Form/* Checkbox */.XZ).withConfig({
    displayName: "styles__CustomCheckboxNewAddress",
    componentId: "sc-31c2285-17"
})(_templateObject17(), "".concat(ui.theme.space.xpx, " solid "), function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui.theme.colors.secondary[300];
}, ui.theme.colors.secondary[300], ui.theme.colors.secondary[300]);
var StateSelect = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    displayName: "styles__StateSelect",
    componentId: "sc-31c2285-18"
})(_templateObject18(), ui.theme.colors.neutral[200], ui.theme.colors.neutral[450], function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[300] : "";
}, function(param) {
    var hasSuccessfully = param.hasSuccessfully;
    return hasSuccessfully ? ui.theme.colors.secondary[300] : "";
}, function(param) {
    var disabled = param.disabled;
    return disabled ? 0.3 : 1;
}, function(param) {
    var disabled = param.disabled;
    return disabled ? ui.theme.colors.neutral[100] : ui.theme.colors.neutral.white;
});
var ButtonRegisterAction = (0,styled_components_browser_esm/* default */.ZP)(ButtonSubmit/* ButtonSubmit */.G).attrs({
    width: "53rem",
    alignSelf: "center",
    fontSize: ui.theme.typography.fontSize.sm.x5,
    height: "4rem"
}).withConfig({
    displayName: "styles__ButtonRegisterAction",
    componentId: "sc-31c2285-19"
})(_templateObject19());
var BoxButton = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BoxButton",
    componentId: "sc-31c2285-20"
})(_templateObject20(), ui.theme.colors.neutral.white);
var OptionStates = styled_components_browser_esm/* default.option.withConfig */.ZP.option.withConfig({
    displayName: "styles__OptionStates",
    componentId: "sc-31c2285-21"
})(_templateObject21());
var LinkCustom = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "styles__LinkCustom",
    componentId: "sc-31c2285-22"
})(_templateObject22(), ui.theme.device.desktopFirst.tablet);
var ContainerRequiredWarning = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ContainerRequiredWarning",
    componentId: "sc-31c2285-23"
})(_templateObject23());

;// CONCATENATED MODULE: ../../packages/components/RequiredWarning/styles.ts

function RequiredWarning_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: ",
        ";\n"
    ]);
    RequiredWarning_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RequiredWarning_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    RequiredWarning_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var RequiredWarningContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__RequiredWarningContainer",
    componentId: "sc-64dd6cf3-0"
})(RequiredWarning_styles_templateObject(), ui.theme.space.x3);
var RequiredWarningText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__RequiredWarningText",
    componentId: "sc-64dd6cf3-1"
})(RequiredWarning_styles_templateObject1(), function(param) {
    var highlight = param.highlight;
    return highlight ? ui.theme.colors.primary[225] : ui.theme.colors.neutral[550];
}, ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[600], function(param) {
    var marginLeft = param.marginLeft;
    return marginLeft !== null && marginLeft !== void 0 ? marginLeft : "0";
});

;// CONCATENATED MODULE: ../../packages/components/RequiredWarning/index.tsx



var RequiredWarning = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RequiredWarningContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.InfoOutlineIcon, {
                color: ui.theme.colors.neutral[550]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RequiredWarningText, {
                marginLeft: ui.theme.space.x2,
                children: [
                    " ",
                    "Os itens marcados com",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredWarningText, {
                        highlight: true,
                        children: " * "
                    }),
                    "s\xe3o obrigat\xf3rios."
                ]
            })
        ]
    });
};
/* harmony default export */ var components_RequiredWarning = (RequiredWarning);

;// CONCATENATED MODULE: ../../packages/components/FormNewAddress/index.tsx














var FormNewAddress = function(param) {
    var setCreatingNewAddress = param.setCreatingNewAddress, newAddressData = param.newAddress, _optionButton = param.optionButton, optionButton = _optionButton === void 0 ? "buttonForm" : _optionButton, returnCreatedStatus = param.returnCreatedStatus, returnEditStatus = param.returnEditStatus, purchaseScreen = param.purchaseScreen, _hasDefaultButton = param.hasDefaultButton, hasDefaultButton = _hasDefaultButton === void 0 ? true : _hasDefaultButton, isdisplayedonbottomsheet = param.isdisplayedonbottomsheet, onCreateNewAddress = param.onCreateNewAddress, onActionAfterCreateNewAddress = param.onActionAfterCreateNewAddress, _hasSpaceBottom = param.hasSpaceBottom, hasSpaceBottom = _hasSpaceBottom === void 0 ? false : _hasSpaceBottom, _hasSpaceTop = param.hasSpaceTop, hasSpaceTop = _hasSpaceTop === void 0 ? false : _hasSpaceTop, _isCheckoutPage = param.isCheckoutPage, isCheckoutPage = _isCheckoutPage === void 0 ? false : _isCheckoutPage, _isFlexColumn = param.isFlexColumn, isFlexColumn = _isFlexColumn === void 0 ? false : _isFlexColumn, addresses = param.addresses;
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var TOKEN_SESSION = getTokens();
    var ref = (0,application/* useAppContext */.bp4)(), isClientMobile = ref.isClientMobile, isClientTablet = ref.isClientTablet;
    var ref1 = (0,react.useState)(), isDisabledInfoSearchCEP = ref1[0], setIsDisabledInfoSearchCEP = ref1[1];
    var ref2 = (0,react.useState)(), newAddress = ref2[0], setNewAddress = ref2[1];
    var ref3 = (0,react.useState)(false), requiredInputStatus = ref3[0], setRequiredInputStatus = ref3[1];
    var ref4 = (0,index_esm/* useForm */.cI)(), register = ref4.register, setValue = ref4.setValue, watch = ref4.watch, handleSubmit = ref4.handleSubmit, errors = ref4.formState.errors;
    var ref5;
    var houseNumberWatcher = (ref5 = watch("number")) !== null && ref5 !== void 0 ? ref5 : "";
    var noNumberCheckboxWatcher = watch("noNumber");
    var ref6;
    var recipientWatcher = (ref6 = watch("recipient")) !== null && ref6 !== void 0 ? ref6 : "";
    var ref7;
    var addressComplementWatcher = (ref7 = watch("addressComplement")) !== null && ref7 !== void 0 ? ref7 : "";
    var ref8;
    var referencePointWatcher = (ref8 = watch("referencePoint")) !== null && ref8 !== void 0 ? ref8 : "";
    var ref9;
    var zipCodeWatcher = (ref9 = watch("zipCode")) !== null && ref9 !== void 0 ? ref9 : "";
    var streetWatcher = watch("street");
    var districtWatcher = watch("district");
    var cityWatcher = watch("city");
    var stateWatcher = watch("state");
    var ref10 = (0,react.useState)(false), isLoadingButton = ref10[0], handleLoadingButton = ref10[1];
    var ref11 = (0,react.useState)(false), searchCEP = ref11[0], handleSearchCEP = ref11[1];
    var ref12 = (0,react.useState)(""), errorCepMessage = ref12[0], setErrorCepMessage = ref12[1];
    var isCEPValid = String(zipCodeWatcher).length === 9;
    var ref13 = implementations/* shippingApi.getAddressByZipCode */.JK.getAddressByZipCode(String(zipCodeWatcher) || "", isCEPValid && searchCEP), addressByCep = ref13.data, isLoading = ref13.isLoading, error = ref13.error;
    var hasNewAddressStreet = !!(newAddress === null || newAddress === void 0 ? void 0 : newAddress.street);
    var shouldDisabledAllInputs = errorCepMessage === "O CEP digitado \xe9 inv\xe1lido.";
    var validateCheckDone = function(type) {
        switch(type){
            case "zipCode":
                return !!isCEPValid && hasNewAddressStreet;
            case "city":
                return !!(newAddress === null || newAddress === void 0 ? void 0 : newAddress.city);
            case "state":
                return !!(newAddress === null || newAddress === void 0 ? void 0 : newAddress.state);
            case "street":
                return !!(newAddress === null || newAddress === void 0 ? void 0 : newAddress.street);
            case "number":
                return !!(newAddress === null || newAddress === void 0 ? void 0 : newAddress.number);
            case "district":
                return !!(newAddress === null || newAddress === void 0 ? void 0 : newAddress.district);
            default:
                return false;
        }
    };
    var onAutoCompleteAddressByCep = (0,react.useCallback)(function() {
        handleSearchCEP(false);
        if (isCEPValid && addressByCep) {
            var street = addressByCep.street, city = addressByCep.city, uf = addressByCep.uf, district = addressByCep.district;
            var formattedStreet = street === null || street === void 0 ? void 0 : street.trim();
            var formattedCity = city === null || city === void 0 ? void 0 : city.trim();
            var formattedState = uf === null || uf === void 0 ? void 0 : uf.trim();
            var formattedDistrict = district === null || district === void 0 ? void 0 : district.trim();
            setValue("city", formattedCity);
            setValue("state", formattedState);
            setValue("street", formattedStreet);
            setValue("district", formattedDistrict);
            setNewAddress({
                zipCode: String(zipCodeWatcher) || "",
                street: formattedStreet,
                city: formattedCity,
                district: formattedDistrict,
                state: formattedState,
                recipient: "",
                addressComplement: "",
                referencePoint: "",
                number: Number(houseNumberWatcher === null || houseNumberWatcher === void 0 ? void 0 : houseNumberWatcher.toString().slice(0, 6)) || 0
            });
            setIsDisabledInfoSearchCEP({
                zipCode: String(zipCodeWatcher),
                street: formattedStreet,
                city: formattedCity,
                district: formattedDistrict,
                state: formattedState,
                recipient: "",
                addressComplement: "",
                referencePoint: "",
                number: Number(houseNumberWatcher === null || houseNumberWatcher === void 0 ? void 0 : houseNumberWatcher.toString().slice(0, 6)) || 0
            });
            return;
        }
        if (!isCEPValid && !newAddressData) {
            setValue("city", "");
            setValue("state", "");
            setValue("street", "");
            setValue("district", "");
            setNewAddress({
                zipCode: String(zipCodeWatcher) || "",
                street: "",
                city: "",
                district: "",
                state: "",
                recipient: "",
                addressComplement: "",
                referencePoint: "",
                number: 0
            });
        }
    }, [
        isCEPValid,
        addressByCep,
        newAddressData,
        setValue,
        zipCodeWatcher,
        houseNumberWatcher, 
    ]);
    var handleCreateNewAddress = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, street, zipCode, city, district, recipient, state, addressComplement, number, referencePoint, ref1, ref2, responseCreated, createdAddress;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    handleLoadingButton(true);
                    if (!newAddress) {
                        return [
                            2
                        ];
                    }
                    street = newAddress.street, zipCode = newAddress.zipCode, city = newAddress.city, district = newAddress.district, recipient = newAddress.recipient, state = newAddress.state, addressComplement = newAddress.addressComplement, number = newAddress.number, referencePoint = newAddress.referencePoint;
                    return [
                        4,
                        implementations/* profileApi.createClientAddress */.c_.createClientAddress({
                            street: street !== null && street !== void 0 ? street : streetWatcher,
                            number: Number((ref1 = number === null || number === void 0 ? void 0 : number.toString().slice(0, 6)) !== null && ref1 !== void 0 ? ref1 : 0),
                            addressComplement: addressComplement,
                            referencePoint: referencePoint,
                            district: district !== null && district !== void 0 ? district : districtWatcher,
                            state: state !== null && state !== void 0 ? state : "",
                            zipCode: (ref2 = String(zipCode)) !== null && ref2 !== void 0 ? ref2 : "",
                            city: city !== null && city !== void 0 ? city : "",
                            recipient: recipient !== null && recipient !== void 0 ? recipient : "",
                            isDefault: false
                        }, (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token)
                    ];
                case 1:
                    responseCreated = _state.sent();
                    if (responseCreated) {
                        createdAddress = responseCreated;
                        handleLoadingButton(false);
                        if (onActionAfterCreateNewAddress) {
                            onActionAfterCreateNewAddress(createdAddress === null || createdAddress === void 0 ? void 0 : createdAddress.id);
                        }
                        if (onCreateNewAddress) {
                            onCreateNewAddress(createdAddress);
                        }
                        if (returnCreatedStatus) {
                            returnCreatedStatus();
                        }
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        newAddress,
        streetWatcher,
        districtWatcher,
        getTokens,
        onActionAfterCreateNewAddress,
        onCreateNewAddress,
        returnCreatedStatus, 
    ]);
    var handleEditNewAddress = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var street, zipCode, city, district, recipient, state, addressComplement, number, referencePoint, BODY, responseEdit;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!newAddress) {
                        return [
                            2
                        ];
                    }
                    street = newAddress.street, zipCode = newAddress.zipCode, city = newAddress.city, district = newAddress.district, recipient = newAddress.recipient, state = newAddress.state, addressComplement = newAddress.addressComplement, number = newAddress.number, referencePoint = newAddress.referencePoint;
                    BODY = [
                        {
                            op: "replace",
                            path: "/ZipCode",
                            value: zipCode
                        },
                        {
                            op: "replace",
                            path: "/Street",
                            value: street
                        },
                        {
                            op: "replace",
                            path: "/Number",
                            value: Number(number === null || number === void 0 ? void 0 : number.toString().slice(0, 6))
                        },
                        {
                            op: "replace",
                            path: "/AddressComplement",
                            value: addressComplement !== null && addressComplement !== void 0 ? addressComplement : ""
                        },
                        {
                            op: "replace",
                            path: "/ReferencePoint",
                            value: referencePoint !== null && referencePoint !== void 0 ? referencePoint : ""
                        },
                        {
                            op: "replace",
                            path: "/District",
                            value: district
                        },
                        {
                            op: "replace",
                            path: "/State",
                            value: state
                        },
                        {
                            op: "replace",
                            path: "/City",
                            value: city
                        },
                        {
                            op: "replace",
                            path: "/Recipient",
                            value: recipient !== null && recipient !== void 0 ? recipient : ""
                        }
                    ];
                    return [
                        4,
                        implementations/* profileApi.editClientAddresses */.c_.editClientAddresses((TOKEN_SESSION === null || TOKEN_SESSION === void 0 ? void 0 : TOKEN_SESSION.token) || "", String(newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.id) || "", BODY)
                    ];
                case 1:
                    responseEdit = _state.sent();
                    if (returnEditStatus && responseEdit) {
                        returnEditStatus();
                    }
                    handleLoadingButton(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        TOKEN_SESSION === null || TOKEN_SESSION === void 0 ? void 0 : TOKEN_SESSION.token,
        newAddress,
        newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.id,
        returnEditStatus
    ]);
    var handleCheckBox = houseNumberWatcher || noNumberCheckboxWatcher;
    var verifyFieldsForm = zipCodeWatcher && (newAddress === null || newAddress === void 0 ? void 0 : newAddress.street) && (newAddress === null || newAddress === void 0 ? void 0 : newAddress.city) && (newAddress === null || newAddress === void 0 ? void 0 : newAddress.district) && (newAddress === null || newAddress === void 0 ? void 0 : newAddress.state) && recipientWatcher && handleCheckBox;
    var controlAction = (0,react.useCallback)(function() {
        if (setCreatingNewAddress) setCreatingNewAddress(true, false);
        if (!verifyFieldsForm) {
            addToast({
                type: "error",
                title: "Preencha os campos obrigat\xf3rios antes de enviar."
            });
            setErrorCepMessage("O Campo CEP deve ser preenchido");
            setRequiredInputStatus(true);
            if (setCreatingNewAddress) setCreatingNewAddress(false, true);
            return;
        }
        setRequiredInputStatus(true);
        handleLoadingButton(true);
        if (newAddressData) {
            handleEditNewAddress();
            if (setCreatingNewAddress) setCreatingNewAddress(false, false);
            return;
        }
        handleCreateNewAddress();
        if (setCreatingNewAddress) setCreatingNewAddress(false, false);
    }, [
        setCreatingNewAddress,
        newAddressData,
        handleCreateNewAddress,
        addToast,
        handleEditNewAddress,
        verifyFieldsForm, 
    ]);
    (0,react.useEffect)(function() {
        if (addressByCep) {
            onAutoCompleteAddressByCep();
        }
    }, [
        addressByCep,
        onAutoCompleteAddressByCep
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = String(zipCodeWatcher)) === null || ref === void 0 ? void 0 : ref.length) === 0 && hasNewAddressStreet || addressByCep === null) {
            setNewAddress(function(address) {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, address), {
                    street: "",
                    city: "",
                    district: "",
                    state: ""
                });
            });
            setIsDisabledInfoSearchCEP({
                street: "",
                city: "",
                district: "",
                state: ""
            });
        }
    }, [
        addressByCep,
        hasNewAddressStreet,
        zipCodeWatcher
    ]);
    (0,react.useEffect)(function() {
        if (newAddressData) {
            setNewAddress((0,src_object_spread/* default */.Z)({
                id: undefined,
                noNumber: Number(newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.number) === 0,
                number: Number(newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.number),
                zipCode: String(newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.zipCode) || String(undefined)
            }, newAddressData));
            setValue("zipCode", newAddressData.zipCode);
            setValue("number", Number(newAddressData.number) === 0 ? 0 : newAddressData.number);
            setValue("noNumber", newAddressData.number === 0);
            setValue("addressComplement", newAddressData.addressComplement);
            setValue("referencePoint", newAddressData.referencePoint);
            setValue("recipient", newAddressData.recipient);
            setIsDisabledInfoSearchCEP({
                zipCode: String(newAddressData.zipCode),
                street: newAddressData.street,
                city: newAddressData.city,
                district: newAddressData.district,
                state: newAddressData.state,
                recipient: "",
                addressComplement: "",
                referencePoint: "",
                number: Number(newAddressData.number) || 0
            });
        }
    }, [
        newAddressData,
        setValue
    ]);
    (0,react.useEffect)(function() {
        setNewAddress(function(currentNewAddress) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, currentNewAddress), {
                number: houseNumberWatcher,
                recipient: recipientWatcher,
                addressComplement: addressComplementWatcher,
                referencePoint: referencePointWatcher
            });
        });
    }, [
        houseNumberWatcher,
        recipientWatcher,
        addressComplementWatcher,
        referencePointWatcher, 
    ]);
    (0,react.useEffect)(function() {
        var validCepAndNotLoading = isCEPValid && !isLoading;
        if (error && validCepAndNotLoading) {
            setErrorCepMessage("Desculpe, ocorreu um erro ao buscar o CEP. Por favor, tente novamente mais tarde.");
            return;
        }
        var notExistentZipCode = !isLoading && zipCodeWatcher && !streetWatcher && !districtWatcher && !cityWatcher && stateWatcher !== "(Selecione)";
        if (notExistentZipCode || addressByCep === null) {
            setErrorCepMessage("O CEP digitado \xe9 inv\xe1lido.");
            return;
        }
        setErrorCepMessage("");
    // Remove a mensagem abaixo, conforme alinhado com Volpato em 19/06/2023
    // if (!hasNewAddressStreet && validCepAndNotLoading) {
    //   setErrorCepMessage("Ainda não realizamos entrega no seu endereço");
    // }
    }, [
        addressByCep,
        cityWatcher,
        districtWatcher,
        error,
        hasNewAddressStreet,
        isCEPValid,
        isLoading,
        stateWatcher,
        streetWatcher,
        zipCodeWatcher, 
    ]);
    var hasAddress = addresses && addresses.length > 0;
    // wellington.braga revisar essa lógica, pois está gerando bug ao cadastrar um novo cartão com um novo endereço
    // useEffect(() => {
    //   if (setCreatingNewAddress) setCreatingNewAddress(true, false);
    //   return () => {
    //     if (setCreatingNewAddress) setCreatingNewAddress(false, false);
    //   };
    // }, [setCreatingNewAddress]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormNewAddressContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-new-address")), {
        id: "form-new-address",
        onSubmit: handleSubmit(handleCreateNewAddress),
        isCheckoutPage: isCheckoutPage,
        children: [
            (isClientMobile || isClientTablet) && hasSpaceTop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SpaceMobileTop, (0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("space-mobile-top"))) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperRow, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-row-1")), {
                isdisplayedonbottomsheet: isdisplayedonbottomsheet,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-input-1")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLabelNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-label-zipCode")), {
                                htmlFor: "zipCode",
                                text: "CEP",
                                isRequired: !hasAddress,
                                hasSuccessfully: validateCheckDone("zipCode")
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-zipCode")), {
                                id: "zipCode",
                                name: "zipCode",
                                required: "Campo obrigat\xf3rio",
                                size: isClientMobile ? "large" : "medium",
                                register: register,
                                value: zipCodeWatcher,
                                onChange: function(param) {
                                    var target = param.target;
                                    var ref;
                                    setValue("zipCode", target.value);
                                    if ((target === null || target === void 0 ? void 0 : (ref = target.value) === null || ref === void 0 ? void 0 : ref.length) === 9) {
                                        handleSearchCEP(true);
                                    }
                                },
                                placeholder: "_ _ _ _ _-_ _ _",
                                type: "tel",
                                minLength: 9,
                                max: 9,
                                maxLength: 9,
                                mask: "99999-999",
                                maskChar: "",
                                hasError: !hasNewAddressStreet && !!errorCepMessage,
                                hasSuccessfully: isCEPValid && hasNewAddressStreet,
                                textError: errorCepMessage,
                                isdisplayedonbottomsheet: isdisplayedonbottomsheet,
                                autoComplete: "off"
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtraInfoCEP, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("extra-info-cep")), {
                        isdisplayedonbottomsheet: isdisplayedonbottomsheet,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkCustom, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("verify-my-zipCode")), {
                            href: "https://buscacepinter.correios.com.br/app/endereco/index.php",
                            target: "_black",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionText, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("description-text")), {
                                    isdisplayedonbottomsheet: isdisplayedonbottomsheet,
                                    children: "N\xe3o sei meu CEP"
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Question */.HNF, {
                                    color: ui.theme.colors.secondary[250],
                                    height: 24
                                })
                            ]
                        }))
                    }))
                ]
            })),
            (!purchaseScreen || isCEPValid) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperRow, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        isFlex: isFlexColumn
                    }, (0,application/* buildTestIds */.Fek)("wrapper-row-3")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-input-3")), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLabelNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-label-city")), {
                                        htmlFor: "city",
                                        text: "Cidade",
                                        isRequired: true,
                                        hasSuccessfully: validateCheckDone("city")
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-city")), {
                                        id: "city",
                                        name: "city",
                                        type: "text",
                                        value: newAddress === null || newAddress === void 0 ? void 0 : newAddress.city,
                                        required: "Campo obrigat\xf3rio",
                                        size: "large",
                                        placeholder: "Ex. Recife",
                                        onChange: function(param) {
                                            var target = param.target;
                                            setValue("city", target === null || target === void 0 ? void 0 : target.value);
                                            setNewAddress(function(address) {
                                                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, address), {
                                                    city: target === null || target === void 0 ? void 0 : target.value
                                                });
                                            });
                                        },
                                        disabled: !!(isDisabledInfoSearchCEP === null || isDisabledInfoSearchCEP === void 0 ? void 0 : isDisabledInfoSearchCEP.city) || shouldDisabledAllInputs,
                                        register: register,
                                        hasError: !(newAddress === null || newAddress === void 0 ? void 0 : newAddress.city) && (requiredInputStatus || !!(errors === null || errors === void 0 ? void 0 : errors.city)),
                                        hasSuccessfully: !!(newAddress === null || newAddress === void 0 ? void 0 : newAddress.city) && !(isDisabledInfoSearchCEP === null || isDisabledInfoSearchCEP === void 0 ? void 0 : isDisabledInfoSearchCEP.city)
                                    }))
                                ]
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-input-4")), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLabelNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-label-state")), {
                                        htmlFor: "estado",
                                        text: "Estado",
                                        isRequired: true,
                                        hasSuccessfully: validateCheckDone("state")
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StateSelect, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-state-select")), {
                                        id: "state"
                                    }), register("state")), {
                                        disabled: !!(isDisabledInfoSearchCEP === null || isDisabledInfoSearchCEP === void 0 ? void 0 : isDisabledInfoSearchCEP.state) || shouldDisabledAllInputs,
                                        value: newAddress === null || newAddress === void 0 ? void 0 : newAddress.state,
                                        hasError: !(newAddress === null || newAddress === void 0 ? void 0 : newAddress.state) && requiredInputStatus,
                                        hasSuccessfully: Boolean(newAddress === null || newAddress === void 0 ? void 0 : newAddress.state) && !(isDisabledInfoSearchCEP === null || isDisabledInfoSearchCEP === void 0 ? void 0 : isDisabledInfoSearchCEP.state),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionStates, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-states")), {
                                                value: "selecione",
                                                children: "(Selecione)"
                                            })),
                                            application/* brazilianStates.map */.xVL.map(function(param) {
                                                var state = param.state;
                                                return /*#__PURE__*/ (0,react.createElement)(OptionStates, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-states")), {
                                                    key: state,
                                                    value: "".concat(state)
                                                }), state);
                                            })
                                        ]
                                    }))
                                ]
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperRow, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        isFlex: isFlexColumn
                    }, (0,application/* buildTestIds */.Fek)("wrapper-row-2")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLabelNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-label-district")), {
                                        htmlFor: "district",
                                        text: "Bairro",
                                        isRequired: true,
                                        hasSuccessfully: validateCheckDone("district")
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-district")), {
                                        id: "district",
                                        name: "district",
                                        type: "text",
                                        size: "large",
                                        value: newAddress === null || newAddress === void 0 ? void 0 : newAddress.district,
                                        required: "Campo obrigat\xf3rio",
                                        register: register,
                                        disabled: !!(isDisabledInfoSearchCEP === null || isDisabledInfoSearchCEP === void 0 ? void 0 : isDisabledInfoSearchCEP.district) || shouldDisabledAllInputs,
                                        hasError: !(newAddress === null || newAddress === void 0 ? void 0 : newAddress.district) && (requiredInputStatus || !!(errors === null || errors === void 0 ? void 0 : errors.district)),
                                        hasSuccessfully: !!(newAddress === null || newAddress === void 0 ? void 0 : newAddress.district) && !(isDisabledInfoSearchCEP === null || isDisabledInfoSearchCEP === void 0 ? void 0 : isDisabledInfoSearchCEP.district),
                                        placeholder: "Ex. Santo Antonio",
                                        onChange: function(param) {
                                            var target = param.target;
                                            setValue("district", target === null || target === void 0 ? void 0 : target.value);
                                            setNewAddress(function(address) {
                                                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, address), {
                                                    district: target === null || target === void 0 ? void 0 : target.value
                                                });
                                            });
                                        }
                                    }))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-input-2")), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLabelNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-label-street")), {
                                        htmlFor: "street",
                                        text: "Endere\xe7o",
                                        isRequired: true,
                                        hasSuccessfully: validateCheckDone("street")
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-street")), {
                                        id: "street",
                                        name: "street",
                                        type: "text",
                                        value: newAddress === null || newAddress === void 0 ? void 0 : newAddress.street,
                                        placeholder: "Rua ou avenida",
                                        size: "large",
                                        required: "Campo obrigat\xf3rio",
                                        register: register,
                                        disabled: !!(isDisabledInfoSearchCEP === null || isDisabledInfoSearchCEP === void 0 ? void 0 : isDisabledInfoSearchCEP.street) || shouldDisabledAllInputs,
                                        hasError: !(newAddress === null || newAddress === void 0 ? void 0 : newAddress.street) && (requiredInputStatus || !!(errors === null || errors === void 0 ? void 0 : errors.street)),
                                        hasSuccessfully: Boolean(newAddress === null || newAddress === void 0 ? void 0 : newAddress.street) && !(isDisabledInfoSearchCEP === null || isDisabledInfoSearchCEP === void 0 ? void 0 : isDisabledInfoSearchCEP.street),
                                        onChange: function(param) {
                                            var target = param.target;
                                            setNewAddress(function(address) {
                                                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, address), {
                                                    street: target === null || target === void 0 ? void 0 : target.value
                                                });
                                            });
                                            setValue("street", target === null || target === void 0 ? void 0 : target.value);
                                        }
                                    }))
                                ]
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperRow, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-row-4")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContentHouse, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-content-house")), {
                            isdisplayedonbottomsheet: isdisplayedonbottomsheet,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-input-5")), {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLabelNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-label-house-number")), {
                                            htmlFor: "number",
                                            text: "N\xfamero",
                                            isRequired: true,
                                            hasSuccessfully: validateCheckDone("number")
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-house-number")), {
                                            id: "number",
                                            name: "number",
                                            size: "small",
                                            type: "tel",
                                            placeholder: "Ex. 1",
                                            value: houseNumberWatcher,
                                            maxLength: 6,
                                            register: register,
                                            onChange: function(param) {
                                                var target = param.target;
                                                var value = target === null || target === void 0 ? void 0 : target.value;
                                                if (/^\d*$/.test(value)) {
                                                    setValue("number", value);
                                                }
                                            },
                                            disabled: !!noNumberCheckboxWatcher || shouldDisabledAllInputs,
                                            hasSuccessfully: Boolean(houseNumberWatcher || noNumberCheckboxWatcher),
                                            hasError: !(newAddress === null || newAddress === void 0 ? void 0 : newAddress.number) && !noNumberCheckboxWatcher && (requiredInputStatus || !!(errors === null || errors === void 0 ? void 0 : errors.number)),
                                            required: noNumberCheckboxWatcher ? undefined : "Campo obrigat\xf3rio"
                                        }))
                                    ]
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-input-6")), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlignWrapperInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("align-wrapper-input")), {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCheckboxNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("checkbox-no-number")), {
                                                id: "noNumber",
                                                color: ui.theme.colors.secondary[300],
                                                name: "noNumber",
                                                register: register,
                                                isCheckedEvent: function() {
                                                    setValue("noNumber", !noNumberCheckboxWatcher);
                                                    setValue("number", "");
                                                },
                                                checked: noNumberCheckboxWatcher
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLabelNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("checkbox-text-no-number")), {
                                                htmlFor: "noNumber",
                                                text: "Sem n\xfamero"
                                            }))
                                        ]
                                    }))
                                }))
                            ]
                        }))
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperRow, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        isFlex: isFlexColumn
                    }, (0,application/* buildTestIds */.Fek)("wrapper-row-6")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-input-8")), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLabelNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-label-addressComplement")), {
                                        htmlFor: "addressComplement",
                                        text: "Complemento"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-addressComplement")), {
                                        id: "addressComplement",
                                        name: "addressComplement",
                                        size: "large",
                                        type: "text",
                                        hasError: false,
                                        placeholder: "Apartamento, bloco, edif\xedcio, andar, etc",
                                        value: addressComplementWatcher,
                                        register: register,
                                        onChange: function(param) {
                                            var target = param.target;
                                            return setValue("addressComplement", target.value);
                                        },
                                        hasSuccessfully: Boolean(addressComplementWatcher)
                                    }))
                                ]
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-input-7")), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLabelNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-label-referencePoint")), {
                                        htmlFor: "referencePoint",
                                        text: "Ponto de refer\xeancia"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-referencePoint")), {
                                        id: "referencePoint",
                                        name: "referencePoint",
                                        size: "large",
                                        type: "text",
                                        hasError: false,
                                        value: referencePointWatcher,
                                        register: register,
                                        onChange: function(param) {
                                            var target = param.target;
                                            return setValue("referencePoint", target.value);
                                        },
                                        hasSuccessfully: Boolean(referencePointWatcher)
                                    }))
                                ]
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperRow, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-row-5")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-input-6")), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLabelNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-label-recipient")), {
                                    htmlFor: "recipient",
                                    isRequired: true,
                                    text: "Nome do destinat\xe1rio"
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-input-recipient")), {
                                    id: "recipient",
                                    name: "recipient",
                                    size: "large",
                                    type: "text",
                                    value: recipientWatcher,
                                    required: "Campo obrigat\xf3rio",
                                    register: register,
                                    onChange: function(param) {
                                        var target = param.target;
                                        return setValue("recipient", target.value);
                                    },
                                    hasError: !(newAddress === null || newAddress === void 0 ? void 0 : newAddress.recipient) && (requiredInputStatus || !!(errors === null || errors === void 0 ? void 0 : errors.recipient)),
                                    hasSuccessfully: Boolean(recipientWatcher)
                                }))
                            ]
                        }))
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerRequiredWarning, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RequiredWarning, {})
                    }),
                    optionButton === "buttonModal" && hasSpaceBottom ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SpaceMobileBottom, (0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("space-mobile-bottom"))) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormNewAddressContent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-new-address-content")), {
                        isCheckoutPage: isCheckoutPage,
                        children: (!purchaseScreen || isCEPValid) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: optionButton === "buttonModal" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-button")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonRegisterAction, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-register-action")), {
                                    text: newAddressData ? "Salvar Altera\xe7\xf5es" : "Adicionando novo endere\xe7o",
                                    textUnderAction: newAddressData ? "Salvar Altera\xe7\xf5es" : "Adicionando novo endere\xe7o",
                                    buttonType: "button",
                                    color: ui.theme.colors.secondary[265],
                                    hoveredColor: ui.theme.colors.secondary[600],
                                    onClickAction: controlAction,
                                    underAction: isLoadingButton
                                }))
                            })) : hasDefaultButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxButtonDefault, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-button-default")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDefaultForm, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-save-address")), {
                                    disabled: isLoadingButton || !verifyFieldsForm,
                                    onClick: controlAction,
                                    purchaseScreen: purchaseScreen !== null && purchaseScreen !== void 0 ? purchaseScreen : false,
                                    children: isLoadingButton ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLoading, {}),
                                            "Salvando endere\xe7o"
                                        ]
                                    }) : "Salvar Endere\xe7o"
                                }))
                            }))
                        }, "fragment-buttons")
                    }))
                ]
            })
        ]
    }));
};


// EXTERNAL MODULE: ../../packages/components/FCTextArea/index.tsx + 1 modules
var FCTextArea = __webpack_require__(54874);
// EXTERNAL MODULE: ../../packages/components/FacetsFilterList/index.tsx + 2 modules
var components_FacetsFilterList = __webpack_require__(92041);
;// CONCATENATED MODULE: ../../packages/components/GiftsListFilterSidebar/styles.ts

function GiftsListFilterSidebar_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: ",
        ";\n  align-items: center;\n  justify-content: center;\n  gap: 10px 0;\n\n  @media ",
        " {\n    position: absolute;\n    width: 100%;\n    height: 350%;\n    left: 0;\n    padding: 15px;\n    margin-top: -20px;\n    z-index: 5;\n    background-color: ",
        ";\n    align-items: start;\n    justify-content: start;\n    transform: ",
        ";\n    transition: 0.2s ease-in-out;\n  }\n\n  @media ",
        " {\n    position: absolute;\n    width: 100%;\n    height: 350%;\n    left: 0;\n    padding: 15px;\n    margin-top: -20px;\n    z-index: 5;\n    background-color: ",
        ";\n    align-items: start;\n    justify-content: start;\n    transform: ",
        ";\n    transition: 0.2s ease-in-out;\n  }\n"
    ]);
    GiftsListFilterSidebar_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GiftsListFilterSidebar_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  border-radius: 50%;\n  background-color: ",
        ";\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n  font-size: 1.4rem;\n  font-weight: 300;\n  margin-bottom: 1rem;\n"
    ]);
    GiftsListFilterSidebar_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var styles_SidebarGiftFilter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SidebarGiftFilter",
    componentId: "sc-9e273fc3-0"
})(GiftsListFilterSidebar_styles_templateObject(), function(param) {
    var width = param.width;
    return width || "100%";
}, ui.theme.device.desktopFirst.tablet, ui.theme.colors.neutral[50], function(param) {
    var openMobile = param.openMobile;
    return openMobile ? "translateX(0)" : "translateX(-100%)";
}, ui.theme.device.desktopFirst.mobileL, ui.theme.colors.neutral[50], function(param) {
    var openMobile = param.openMobile;
    return openMobile ? "translateX(0)" : "translateX(-100%)";
});
var styles_BackButton = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__BackButton",
    componentId: "sc-9e273fc3-1"
})(GiftsListFilterSidebar_styles_templateObject1(), ui.theme.colors.neutral.white);

;// CONCATENATED MODULE: ../../packages/components/GiftsListFilterSidebar/index.tsx








var GiftsListFilterSidebar = function(param) {
    var facets = param.facets, openMobile = param.openMobile, isLoading = param.isLoading, onApplyFilters = param.onApplyFilters, handlerClick = param.handlerClick, handlerOpenFilterMobile = param.handlerOpenFilterMobile;
    var ref = useState([]), filters = ref[0], setFilters = ref[1];
    var ref1 = useState(openMobile), openMobileFilter = ref1[0], setOpenMobileFilter = ref1[1];
    var ref2 = useState([]), categoryFilterParams = ref2[0], setCategoryFilterParams = ref2[1];
    var ref3 = useState([]), brandFilterParams = ref3[0], setBrandFilterParams = ref3[1];
    var ref4 = useState([]), modelFilterParams = ref4[0], setModelFilterParams = ref4[1];
    var ref5 = useState(""), brandFilterTitle = ref5[0], setBrandFilterTitle = ref5[1];
    var ref6 = useState([]), brandFilterOptions = ref6[0], setBrandFilterOptions = ref6[1];
    var ref7 = useState(""), lastClickedFilter = ref7[0], setLastClickedFilter = ref7[1];
    useEffect(function() {
        if (facets && facets.aggregations && facets.aggregations.topk) {
            var mappedFilters = Object.entries(facets.aggregations.topk).map(function(filter) {
                return _define_property({}, filter[0], filter[1]);
            }, [
                facets
            ]);
            setFilters(mappedFilters);
        }
    }, [
        facets
    ]);
    var ref8 = useState(""), categoryFilterTitle = ref8[0], setCategoryFilterTitle = ref8[1];
    var ref9 = useState([]), categoryFilterOptions = ref9[0], setCategoryFilterOptions = ref9[1];
    var ref10 = useState(""), modelFilterTitle = ref10[0], setModelFilterTitle = ref10[1];
    var ref11 = useState([]), modelFilterOptions = ref11[0], setModelFilterOptions = ref11[1];
    var ref12 = useState([]), activeFilters = ref12[0], setActiveFilters = ref12[1];
    // useEffect(() => {
    //   selectedFilters(activeFilters);
    // }, [activeFilters, selectedFilters]);
    useEffect(function() {
        var auxSelectedCategoryFilters = activeFilters.map(function(activeFilter) {
            return activeFilter.title === "Categoria" ? activeFilter.option : "";
        });
        var auxSelectedBrandFilters = activeFilters.map(function(activeFilter) {
            return activeFilter.title === "Marcas" ? activeFilter.option : "";
        });
        var auxSelectedModelFilters = activeFilters.map(function(activeFilter) {
            return activeFilter.title === "Modelos" ? activeFilter.option : "";
        });
        setCategoryFilterParams(auxSelectedCategoryFilters.filter(function(element) {
            return element !== "";
        }));
        setBrandFilterParams(auxSelectedBrandFilters.filter(function(element) {
            return element !== "";
        }));
        setModelFilterParams(auxSelectedModelFilters.filter(function(element) {
            return element !== "";
        }));
        onApplyFilters(auxSelectedCategoryFilters.filter(function(element) {
            return element !== "";
        }), auxSelectedBrandFilters.filter(function(element) {
            return element !== "";
        }), auxSelectedModelFilters.filter(function(element) {
            return element !== "";
        }));
    // italo.albuquerque resolve problema de re-renders infinitos aqui e, posteriormente, remover o eslint-disable abaixo
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeFilters
    ]);
    var getBrandFacet = useCallback(function() {
        if (filters[1]) {
            Object.entries(filters[1]).map(function(param) {
                var _param = _sliced_to_array(param, 2), title = _param[0], options = _param[1];
                setBrandFilterTitle(title);
                Object.entries(options).map(function(param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    if (key === "buckets" && lastClickedFilter !== "Marcas") {
                        setBrandFilterOptions(value);
                    }
                    return null;
                });
                return null;
            });
        }
    }, [
        filters,
        lastClickedFilter
    ]);
    var getCategoryFacet = useCallback(function() {
        if (filters[2]) {
            Object.entries(filters[2]).map(function(param) {
                var _param = _sliced_to_array(param, 2), title = _param[0], options = _param[1];
                setCategoryFilterTitle(title);
                Object.entries(options).map(function(param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    if (key === "buckets" && lastClickedFilter !== "Categoria") {
                        setCategoryFilterOptions(value);
                    }
                    return null;
                });
                return null;
            });
        }
    }, [
        filters,
        lastClickedFilter
    ]);
    var getModelFacet = useCallback(function() {
        if (filters[4]) {
            Object.entries(filters[4]).map(function(param) {
                var _param = _sliced_to_array(param, 2), title = _param[0], options = _param[1];
                setModelFilterTitle(title);
                Object.entries(options).map(function(param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    if (key === "buckets" && lastClickedFilter !== "Modelos") {
                        setModelFilterOptions(value);
                    }
                    return null;
                });
                return null;
            });
        }
    }, [
        filters,
        lastClickedFilter
    ]);
    // const handleOnApplyFilters = useCallback(() => {
    //   const selectedCategories = categoryFilterParams;
    //   const selectedBrands = brandFilterParams;
    //   const selectedModels = modelFilterParams;
    //   onApplyFilters(selectedCategories, selectedBrands, selectedModels);
    //   selectedFilters(activeFilters);
    // }, [
    //   brandFilterParams,
    //   categoryFilterParams,
    //   modelFilterParams,
    //   onApplyFilters,
    //   activeFilters,
    //   selectedFilters,
    // ]);
    useEffect(function() {
        getCategoryFacet();
        getBrandFacet();
        getModelFacet();
    }, [
        getCategoryFacet,
        getBrandFacet,
        getModelFacet
    ]);
    useEffect(function() {
        setOpenMobileFilter(openMobile);
    }, [
        openMobile
    ]);
    useEffect(function() {
        handlerOpenFilterMobile(openMobileFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        openMobileFilter
    ]);
    // useEffect(() => {
    //   if (filters) {
    //     handleOnApplyFilters();
    //   }
    // }, [filters]);
    return /*#__PURE__*/ _jsxs(SidebarGiftFilter, {
        openMobile: openMobileFilter,
        onClick: function() {
            handlerClick();
        },
        children: [
            openMobile && /*#__PURE__*/ _jsx(BackButton, {
                width: "28px",
                height: "28px",
                onClick: function() {
                    return setOpenMobileFilter(!openMobileFilter);
                },
                children: /*#__PURE__*/ _jsx(ArrowLeft, {
                    color: "".concat(theme.colors.neutral[520])
                })
            }),
            /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(FacetsFilterList, {
                        isLoadingFacets: isLoading,
                        hasFacets: !!facets,
                        filterTitle: categoryFilterTitle,
                        filterOptions: categoryFilterOptions,
                        activeOptions: categoryFilterParams,
                        handleTitleFilter: function(clickedOptionTitle) {
                            if (clickedOptionTitle) {
                                setLastClickedFilter(clickedOptionTitle);
                            }
                        },
                        handleOptionFilter: function(clickedOption) {
                            var auxClickedOption = _to_consumable_array(categoryFilterParams).concat([
                                clickedOption
                            ]);
                            var auxActiveFilters = _to_consumable_array(activeFilters).concat([
                                {
                                    title: "Categoria",
                                    option: clickedOption
                                }, 
                            ]);
                            // console.log(auxActiveFilters);
                            if (!categoryFilterParams.length) {
                                setCategoryFilterParams(auxClickedOption);
                            }
                            var newAuxClickedOption = categoryFilterParams.find(function(activeItem) {
                                return activeItem === clickedOption;
                            });
                            setCategoryFilterParams(auxClickedOption.filter(function(option) {
                                return option !== newAuxClickedOption;
                            }));
                            if (!activeFilters.length) {
                                setActiveFilters(auxActiveFilters);
                            }
                            var newAuxActiveFilters = activeFilters.find(function(activeItem) {
                                return activeItem.option === clickedOption;
                            });
                            setActiveFilters(auxActiveFilters.filter(function(selectedFilter) {
                                return selectedFilter.option !== (newAuxActiveFilters === null || newAuxActiveFilters === void 0 ? void 0 : newAuxActiveFilters.option);
                            }));
                        }
                    }),
                    /*#__PURE__*/ _jsx(FacetsFilterList, {
                        isLoadingFacets: isLoading,
                        hasFacets: !!facets,
                        filterTitle: brandFilterTitle,
                        filterOptions: brandFilterOptions,
                        activeOptions: brandFilterParams,
                        handleTitleFilter: function(clickedTitle) {
                            if (clickedTitle) {
                                setLastClickedFilter(clickedTitle);
                            }
                        },
                        handleOptionFilter: function(clickedOption) {
                            var auxClickedOption = _to_consumable_array(brandFilterParams).concat([
                                clickedOption
                            ]);
                            var auxActiveFilters = _to_consumable_array(activeFilters).concat([
                                {
                                    title: "Marcas",
                                    option: clickedOption
                                }, 
                            ]);
                            if (!brandFilterParams.length) {
                                setBrandFilterParams(auxClickedOption);
                            }
                            var newAuxClickedOption = brandFilterParams.find(function(activeItem) {
                                return activeItem === clickedOption;
                            });
                            setBrandFilterParams(auxClickedOption.filter(function(option) {
                                return option !== newAuxClickedOption;
                            }));
                            if (!activeFilters.length) {
                                setActiveFilters(auxActiveFilters);
                            }
                            var newAuxActiveFilters = activeFilters.find(function(activeItem) {
                                return activeItem.option === clickedOption;
                            });
                            setActiveFilters(auxActiveFilters.filter(function(selectedFilter) {
                                return selectedFilter.option !== (newAuxActiveFilters === null || newAuxActiveFilters === void 0 ? void 0 : newAuxActiveFilters.option);
                            }));
                        }
                    }),
                    /*#__PURE__*/ _jsx(FacetsFilterList, {
                        isLoadingFacets: isLoading,
                        hasFacets: !!facets,
                        filterTitle: modelFilterTitle,
                        filterOptions: modelFilterOptions,
                        activeOptions: modelFilterParams,
                        handleTitleFilter: function(clickedOptionTitle) {
                            if (clickedOptionTitle) {
                                setLastClickedFilter(clickedOptionTitle);
                            }
                        },
                        handleOptionFilter: function(clickedOption) {
                            var auxClickedOption = _to_consumable_array(modelFilterParams).concat([
                                clickedOption
                            ]);
                            var auxActiveFilters = _to_consumable_array(activeFilters).concat([
                                {
                                    title: "Modelos",
                                    option: clickedOption
                                }, 
                            ]);
                            if (!modelFilterParams.length) {
                                setModelFilterParams(auxClickedOption);
                            }
                            var newAuxClickedOption = modelFilterParams.find(function(activeItem) {
                                return activeItem === clickedOption;
                            });
                            setModelFilterParams(auxClickedOption.filter(function(option) {
                                return option !== newAuxClickedOption;
                            }));
                            if (!activeFilters.length) {
                                setActiveFilters(auxActiveFilters);
                            }
                            var newAuxActiveFilters = activeFilters.find(function(activeItem) {
                                return activeItem.option === clickedOption;
                            });
                            setActiveFilters(auxActiveFilters.filter(function(selectedFilter) {
                                return selectedFilter.option !== (newAuxActiveFilters === null || newAuxActiveFilters === void 0 ? void 0 : newAuxActiveFilters.option);
                            }));
                        }
                    })
                ]
            })
        ]
    });
};


// EXTERNAL MODULE: ../../packages/infra/index.ts + 47 modules
var infra = __webpack_require__(11338);
;// CONCATENATED MODULE: ../../packages/components/GoogleRecaptcha/index.tsx




var GoogleRecaptcha = function(_param) {
    var rest = _extends({}, _param);
    return /*#__PURE__*/ _jsx(Recaptcha, _object_spread({}, rest));
};


// EXTERNAL MODULE: ../../packages/components/hocs/index.ts + 5 modules
var hocs = __webpack_require__(42621);
// EXTERNAL MODULE: ../../packages/components/Image/index.tsx
var components_Image = __webpack_require__(25926);
;// CONCATENATED MODULE: ../../packages/components/ZoomImages/index.tsx



var ZoomImages = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(infra/* MagicZoom */.EX, (0,src_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../packages/components/ImagesProduct/styles.ts

function ImagesProduct_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 60rem;\n\n  @media ",
        " {\n    order: 2;\n    height: fit-content;\n    /* overflow: auto; */\n  }\n"
    ]);
    ImagesProduct_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ImagesProduct_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      aspect-ratio: 1;\n    "
    ]);
    ImagesProduct_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ImagesProduct_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-top: 1rem;\n  justify-content: center;\n  padding-bottom: 1rem;\n  height: fit-content;\n  width: 100%;\n  cursor: zoom-in;\n  overflow: hidden;\n\n  ",
        "\n\n  @media ",
        " {\n    height: fit-content;\n    padding-top: 0rem;\n  }\n\n  @media ",
        " {\n    height: auto;\n  }\n"
    ]);
    ImagesProduct_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ImagesProduct_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  @media ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    ImagesProduct_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ImagesProduct_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    ImagesProduct_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ImagesProduct_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ImagesProduct_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var SectionImages = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SectionImages",
    componentId: "sc-899b7c33-0"
})(ImagesProduct_styles_templateObject(), themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet);
var MainImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MainImage",
    componentId: "sc-899b7c33-1"
})(ImagesProduct_styles_templateObject2(), function(param) {
    var isVideo = param.isVideo;
    return isVideo && (0,styled_components_browser_esm/* css */.iv)(ImagesProduct_styles_templateObject1());
}, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL);
var ImageProductContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__ImageProductContainer",
    componentId: "sc-899b7c33-2"
})(ImagesProduct_styles_templateObject3(), themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet);
var ContainerImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ContainerImage",
    componentId: "sc-899b7c33-3"
})(ImagesProduct_styles_templateObject4());
var ImageProductDefault = (0,styled_components_browser_esm/* default */.ZP)(ui.DefaultProductImage).attrs(function(param) {
    var isClientMobile = param.isClientMobile;
    return {
        width: isClientMobile ? "200" : "280",
        height: isClientMobile ? "200" : "280"
    };
}).withConfig({
    displayName: "styles__ImageProductDefault",
    componentId: "sc-899b7c33-4"
})(ImagesProduct_styles_templateObject5());

;// CONCATENATED MODULE: ../../packages/components/patterns/MediaPlayer/index.tsx






var MediaPlayer = function(_param) {
    var _playing = _param.playing, playing = _playing === void 0 ? true : _playing, _width = _param.width, width = _width === void 0 ? "100%" : _width, _height = _param.height, height = _height === void 0 ? "100%" : _height, _className = _param.className, className = _className === void 0 ? "react-media-player" : _className, mediaPlayProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "playing",
        "width",
        "height",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(infra/* ReactVideoPlayer */.Q9, (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("video-media-player")), {
        width: width,
        height: height,
        playing: playing,
        className: className
    }), mediaPlayProps));
};


;// CONCATENATED MODULE: ../../packages/components/ImagesProduct/ThumbnailSelect/styles.ts

function ThumbnailSelect_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .active {\n    border-color: ",
        " !important;\n  }\n  .disabled:hover {\n    border-color: rgba(255, 0, 0, 0.2) !important;\n    filter: brightness(0.8);\n    transition: border 100ms !important;\n    transition: filter 100ms !important;\n  }\n"
    ]);
    ThumbnailSelect_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ThumbnailSelect_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 4rem;\n  width: 4rem;\n  border: 2px solid ",
        ";\n  overflow: hidden;\n  cursor: pointer;\n  transition: border 500ms;\n\n  .active {\n    border-color: ",
        ";\n  }\n  .disabled:hover {\n    border-color: ",
        ";\n  }\n"
    ]);
    ThumbnailSelect_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-4385b82d-0"
})(ThumbnailSelect_styles_templateObject(), themes/* theme.colors.primary.200 */.rS.colors.primary[200]);
var BoxMiniatureImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxMiniatureImage",
    componentId: "sc-4385b82d-1"
})(ThumbnailSelect_styles_templateObject1(), themes/* theme.colors.neutral.95 */.rS.colors.neutral[95], themes/* theme.colors.primary.200 */.rS.colors.primary[200], themes/* theme.colors.primary.200 */.rS.colors.primary[200]);

;// CONCATENATED MODULE: ../../packages/components/ImagesProduct/ThumbnailSelect/index.tsx






var ThumbnailSelect = function(param) {
    var actionReturnInfo = param.actionReturnInfo, defaultImage = param.defaultImage, imageUrl = param.imageUrl, linkType = param.linkType, sequenceNumber = param.sequenceNumber, active = param.active;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Container, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("thumbnail-container")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxMiniatureImage, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("thumbnail-box-miniature")), {
            "data-thumb-number": "thumb-list-item-box-miniature",
            className: active ? "active" : "disabled",
            onClick: function() {
                return actionReturnInfo(sequenceNumber);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* Image */.E, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("thumbnail-image")), {
                src: defaultImage || imageUrl,
                alt: linkType,
                width: "100px",
                height: "100px",
                layout: "responsive"
            }))
        }))
    }));
};
/* harmony default export */ var ImagesProduct_ThumbnailSelect = (ThumbnailSelect);

;// CONCATENATED MODULE: ../../packages/components/ImagesProduct/ThumbList/styles.ts

function ThumbList_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: -1%;\n  left: 14%;\n  right: inherit;\n  margin: auto;\n  z-index: 1;\n  margin-top: -20px;\n  background: none !important;\n\n  &:hover {\n    opacity: 0.5;\n  }\n\n  &:before {\n    display: none;\n  }\n"
    ]);
    ThumbList_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ThumbList_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: inherit;\n  bottom: -7%;\n  left: 11.5%;\n  right: inherit;\n  /* padding: 2rem; */\n  margin: auto;\n  background: none !important;\n\n  z-index: 1;\n\n  &:hover {\n    opacity: 0.5;\n  }\n\n  &:before {\n    display: none;\n  }\n"
    ]);
    ThumbList_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ThumbList_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  padding-top: 4rem;\n  max-width: 6rem;\n  min-width: 6rem;\n  @media ",
        " {\n    display: none;\n  }\n\n  .slick-list {\n    width: 50px;\n  }\n"
    ]);
    ThumbList_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ThumbList_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n    max-width: 100%;\n    order: 2;\n    padding: 1rem;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    margin: auto;\n    order: 2;\n  }\n"
    ]);
    ThumbList_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ThumbList_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    ThumbList_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var ButtonArrowPrev = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ButtonArrowPrev",
    componentId: "sc-e0b6b629-0"
})(ThumbList_styles_templateObject());
var ButtonArrowNext = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ButtonArrowNext",
    componentId: "sc-e0b6b629-1"
})(ThumbList_styles_templateObject1());
var CarouselLib = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CarouselLib",
    componentId: "sc-e0b6b629-2"
})(ThumbList_styles_templateObject2(), themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet);
var ContainerList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ContainerList",
    componentId: "sc-e0b6b629-3"
})(ThumbList_styles_templateObject3(), themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet);
var ThumbList_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-e0b6b629-4"
})(ThumbList_styles_templateObject4());

// EXTERNAL MODULE: ../../packages/components/Slider/index.tsx + 3 modules
var Slider = __webpack_require__(75926);
;// CONCATENATED MODULE: ../../packages/components/ImagesProduct/ThumbList/index.tsx







var CarouselThumb = function(param) {
    var children = param.children;
    var isClientTablet = (0,application/* useAppContext */.bp4)().isClientTablet;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbList_styles_Container, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("carousel-thumb-container")), {
        children: isClientTablet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerList, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("carousel-thumb-container-list")), {
            children: children
        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselLib, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("carousel-lib-wrapper")), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, {
                speed: 500,
                slidesToShow: 8,
                slidesToScroll: 2,
                vertical: true,
                arrowsIsActive: true,
                touchMove: true,
                verticalSwiping: true,
                swipe: false,
                PrevButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonArrowPrev, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("carousel-thumb-button-arrow-prev")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowUp, {
                        alt: "seta para cima",
                        width: 35,
                        height: 35,
                        color: ui.theme.colors.primary[200]
                    })
                })),
                NextButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonArrowNext, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("carousel-thumb-button-arrow-next")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowDown, {
                        alt: "seta para baixo",
                        width: 35,
                        height: 35,
                        color: ui.theme.colors.primary[200]
                    })
                })),
                children: children
            })
        }))
    }));
};


;// CONCATENATED MODULE: ../../packages/components/ImagesProduct/ListThumb/index.tsx






var ListThumb = function(param) {
    var thumbs = param.thumbs, sequenceImageNumberCurrentActive = param.sequenceImageNumberCurrentActive, setSequenceImageNumberCurrentActive = param.setSequenceImageNumberCurrentActive;
    if (!(thumbs === null || thumbs === void 0 ? void 0 : thumbs.length) || !sequenceImageNumberCurrentActive) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselThumb, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("thumb-list")), {
        children: thumbs === null || thumbs === void 0 ? void 0 : thumbs.map(function(thumbItem) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagesProduct_ThumbnailSelect, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, thumbItem), {
                actionReturnInfo: setSequenceImageNumberCurrentActive,
                active: sequenceImageNumberCurrentActive === thumbItem.sequenceNumber
            }), thumbItem.sequenceNumber);
        })
    }));
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ../../packages/components/ImagesProduct/data.tsx




var useMedia = function(setSequenceImageNumberCurrentActive) {
    var ref = (0,react.useState)({
        medias: [],
        thumb: [],
        zoomItems: [],
        images: []
    }), listImages = ref[0], setListImages = ref[1];
    var processMedia = (0,react.useCallback)(function(list) {
        if (!Array.isArray(list) || !list.length) return [];
        var count = 0;
        var newMediaList = (0,src_to_consumable_array/* default */.Z)(list);
        newMediaList.forEach(function(item, pos) {
            for(var i = 0; i < newMediaList.length; i += 1){
                var ref;
                if (((ref = newMediaList["".concat(i)]) === null || ref === void 0 ? void 0 : ref.sequenceNumber) === (item === null || item === void 0 ? void 0 : item.sequenceNumber)) {
                    count += 1;
                }
            }
            if (count > 1) {
                newMediaList.splice(pos, 1);
            }
            count = 0;
        });
        return newMediaList;
    }, []);
    var handleZoomItems = function(mediaList, lastItem, type) {
        var zoomItemIndex = mediaList.findIndex(function(elem) {
            return elem.sequenceNumber === lastItem.sequenceNumber;
        });
        if (zoomItemIndex === -1) {
            return (0,src_to_consumable_array/* default */.Z)(mediaList).concat([
                {
                    sequenceNumber: lastItem.sequenceNumber,
                    smallImage: type === "IMAGEM" ? lastItem.imageUrl : "",
                    tinyImage: type === "THUMB" ? lastItem.imageUrl : "",
                    idThumb: ""
                }, 
            ]);
        }
        return mediaList.map(function(elem) {
            if (elem.sequenceNumber === lastItem.sequenceNumber) {
                var _smallImage, _smallImage1;
                return {
                    sequenceNumber: lastItem.sequenceNumber,
                    smallImage: type === "IMAGEM" ? lastItem.imageUrl : (_smallImage = elem.smallImage) !== null && _smallImage !== void 0 ? _smallImage : "",
                    tinyImage: type === "THUMB" ? lastItem.imageUrl : (_smallImage1 = elem.smallImage) !== null && _smallImage1 !== void 0 ? _smallImage1 : "",
                    idThumb: ""
                };
            }
            return elem;
        });
    };
    var sortImages = (0,react.useCallback)(function(mediaData) {
        var ref;
        var reducerImages = mediaData === null || mediaData === void 0 ? void 0 : mediaData.reduce(function(previousValue, currentValue) {
            if (currentValue.linkType === "THUMB") {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, previousValue), {
                    thumb: (0,src_to_consumable_array/* default */.Z)(previousValue.thumb).concat([
                        currentValue
                    ]),
                    zoomItems: handleZoomItems(previousValue.zoomItems, currentValue, currentValue.linkType)
                });
            }
            if (currentValue.linkType === "IMAGEM") {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, previousValue), {
                    images: (0,src_to_consumable_array/* default */.Z)(previousValue.images).concat([
                        currentValue
                    ]),
                    zoomItems: handleZoomItems(previousValue.zoomItems, currentValue, currentValue.linkType)
                });
            }
            if ((currentValue === null || currentValue === void 0 ? void 0 : currentValue.linkType) === "VIDEO") {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, previousValue), {
                    thumb: (0,src_to_consumable_array/* default */.Z)(previousValue.thumb).concat([
                        currentValue
                    ]),
                    medias: (0,src_to_consumable_array/* default */.Z)(previousValue.medias).concat([
                        currentValue
                    ]),
                    zoomItems: handleZoomItems(previousValue.zoomItems, currentValue, currentValue.linkType)
                });
            }
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, previousValue), {
                medias: (0,src_to_consumable_array/* default */.Z)(previousValue.medias).concat([
                    currentValue
                ]),
                zoomItems: handleZoomItems(previousValue.zoomItems, currentValue, currentValue.linkType)
            });
        }, {
            medias: [],
            thumb: [],
            zoomItems: [],
            images: []
        });
        reducerImages === null || reducerImages === void 0 ? void 0 : (ref = reducerImages.thumb) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
            if (a.sequenceNumber < b.sequenceNumber) {
                return -1;
            }
            if (a.sequenceNumber > b.sequenceNumber) {
                return 1;
            }
            return 0;
        });
        var newProcessMediaThumbList = processMedia(reducerImages === null || reducerImages === void 0 ? void 0 : reducerImages.thumb);
        var newProcessMediaImageList = processMedia(reducerImages === null || reducerImages === void 0 ? void 0 : reducerImages.medias);
        var newProcessMediaImagesList = processMedia(reducerImages === null || reducerImages === void 0 ? void 0 : reducerImages.images);
        if (newProcessMediaThumbList.length && setSequenceImageNumberCurrentActive) {
            var ref1;
            setSequenceImageNumberCurrentActive((ref1 = newProcessMediaThumbList[0]) === null || ref1 === void 0 ? void 0 : ref1.sequenceNumber);
        }
        setListImages({
            thumb: newProcessMediaThumbList || [],
            medias: newProcessMediaImageList || [],
            zoomItems: reducerImages.zoomItems || [],
            images: newProcessMediaImagesList
        });
    }, [
        processMedia,
        setSequenceImageNumberCurrentActive
    ]);
    return {
        processMedia: processMedia,
        sortImages: sortImages,
        listImages: listImages,
        handleZoomItems: handleZoomItems
    };
};


;// CONCATENATED MODULE: ../../packages/components/ImagesProduct/index.tsx










var ImagesProduct = function(param) {
    var mediaLinks = param.mediaLinks;
    var ref;
    var ref1 = (0,react.useState)(0), sequenceImageNumberCurrentActive = ref1[0], setSequenceImageNumberCurrentActive = ref1[1];
    var ref2 = (0,react.useState)(), mediaCurrentSelect = ref2[0], setMediaCurrentSelect = ref2[1];
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var ref3 = useMedia(setSequenceImageNumberCurrentActive), listImages = ref3.listImages, sortImages = ref3.sortImages;
    (0,react.useEffect)(function() {
        var ref;
        if (listImages === null || listImages === void 0 ? void 0 : (ref = listImages.medias) === null || ref === void 0 ? void 0 : ref.length) {
            setMediaCurrentSelect(listImages === null || listImages === void 0 ? void 0 : listImages.medias[0]);
        }
    }, [
        listImages
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var hasImage = listImages === null || listImages === void 0 ? void 0 : (ref = listImages.images) === null || ref === void 0 ? void 0 : ref.some(function(media) {
            if (media.sequenceNumber === sequenceImageNumberCurrentActive) {
                setMediaCurrentSelect(media);
                return true;
            }
            return false;
        });
        if (!hasImage) {
            var ref1;
            listImages === null || listImages === void 0 ? void 0 : (ref1 = listImages.medias) === null || ref1 === void 0 ? void 0 : ref1.some(function(media) {
                if (media.sequenceNumber === sequenceImageNumberCurrentActive) {
                    setMediaCurrentSelect(media);
                    return true;
                }
                return false;
            });
        }
    }, [
        listImages === null || listImages === void 0 ? void 0 : listImages.images,
        listImages === null || listImages === void 0 ? void 0 : listImages.medias,
        sequenceImageNumberCurrentActive, 
    ]);
    (0,react.useEffect)(function() {
        sortImages(mediaLinks);
    }, [
        mediaLinks,
        sortImages
    ]);
    var NUMBER_INDEX_SELECTED = listImages === null || listImages === void 0 ? void 0 : (ref = listImages.zoomItems) === null || ref === void 0 ? void 0 : ref.findIndex(function(item) {
        return item.sequenceNumber === (mediaCurrentSelect === null || mediaCurrentSelect === void 0 ? void 0 : mediaCurrentSelect.sequenceNumber);
    });
    var imageUrl = mediaCurrentSelect === null || mediaCurrentSelect === void 0 ? void 0 : mediaCurrentSelect.imageUrl;
    var videoUrl = mediaCurrentSelect === null || mediaCurrentSelect === void 0 ? void 0 : mediaCurrentSelect.videoUrl;
    var isVideo = (mediaCurrentSelect === null || mediaCurrentSelect === void 0 ? void 0 : mediaCurrentSelect.linkType) === "VIDEO" && videoUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageProductContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("media-product-container")), {
        children: [
            (listImages === null || listImages === void 0 ? void 0 : listImages.thumb.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionImages, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("section-medias")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListThumb, {
                    thumbs: listImages === null || listImages === void 0 ? void 0 : listImages.thumb,
                    sequenceImageNumberCurrentActive: sequenceImageNumberCurrentActive,
                    setSequenceImageNumberCurrentActive: setSequenceImageNumberCurrentActive
                })
            })) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainImage, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                isVideo: !!isVideo
            }, (0,application/* buildTestIds */.Fek)("main-media-container")), {
                children: (mediaCurrentSelect === null || mediaCurrentSelect === void 0 ? void 0 : mediaCurrentSelect.linkType) === "IMAGEM" && imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomImages, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("zoom-medias")), {
                    largeImage: imageUrl,
                    moreImages: listImages === null || listImages === void 0 ? void 0 : listImages.zoomItems,
                    indexImageCurrent: NUMBER_INDEX_SELECTED
                })) : isVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaPlayer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("video-media-player")), {
                    controls: true,
                    loop: true,
                    volume: 0.5,
                    url: videoUrl
                })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerImage, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("container-default-image")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageProductDefault, {
                        alt: "imagem padr\xe3o de produto",
                        isClientMobile: isClientMobile
                    })
                }))
            }))
        ]
    }));
};


// EXTERNAL MODULE: ../../packages/components/InputCodeValidation/index.tsx + 3 modules
var InputCodeValidation = __webpack_require__(4247);
;// CONCATENATED MODULE: ../../packages/components/InputSearch/styles.ts

function InputSearch_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding: ",
        ";\n  align-items: center;\n  gap: ",
        ";\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  flex: 1;\n\n  &:focus-within {\n    box-shadow: 0px 2px 8px 0px ",
        ";\n    border: 1px solid ",
        ';\n  }\n\n  input[type="search"]::-ms-clear {\n    display: none;\n    width: 0;\n    height: 0;\n  }\n\n  input[type="search"]::-ms-reveal {\n    display: none;\n    width: 0;\n    height: 0;\n  }\n\n  input[type="search"]::-webkit-search-decoration,\n  input[type="search"]::-webkit-search-cancel-button,\n  input[type="search"]::-webkit-search-results-button,\n  input[type="search"]::-webkit-search-results-decoration {\n    display: none;\n  }\n'
    ]);
    InputSearch_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InputSearch_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  width: 100%;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  &::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    InputSearch_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function InputSearch_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    InputSearch_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var InputContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__InputContainer",
    componentId: "sc-710029f3-0"
})(InputSearch_styles_templateObject(), ui.theme.space.x4, ui.theme.space.x4, ui.theme.space.x1, ui.theme.colors.neutral[88], ui.theme.colors.neutral.white, ui.theme.colors.secondary[760], ui.theme.colors.neutral[550]);
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "styles__Input",
    componentId: "sc-710029f3-1"
})(InputSearch_styles_templateObject1(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[400], ui.theme.colors.neutral[550], ui.theme.colors.neutral[330]);
var SearchIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.Search).attrs({
    width: 16,
    height: 16,
    color: ui.theme.colors.neutral[350]
}).withConfig({
    displayName: "styles__SearchIcon",
    componentId: "sc-710029f3-2"
})(InputSearch_styles_templateObject2());

;// CONCATENATED MODULE: ../../packages/components/InputSearch/index.tsx






var InputSearch = function(_param) {
    var placeholder = _param.placeholder, register = _param.register, setValue = _param.setValue, name = _param.name, required = _param.required, minLength = _param.minLength, maxLength = _param.maxLength, onBlur = _param.onBlur, onFocus = _param.onFocus, onKeyDown = _param.onKeyDown, onChange = _param.onChange, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "placeholder",
        "register",
        "setValue",
        "name",
        "required",
        "minLength",
        "maxLength",
        "onBlur",
        "onFocus",
        "onKeyDown",
        "onChange"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
        "data-testid": "input-container",
        "data-cy": "input-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                onFocus: onFocus,
                type: "search",
                placeholder: placeholder
            }, setValue, register(name, {
                required: required,
                minLength: minLength,
                maxLength: maxLength
            })), {
                onBlur: onBlur,
                onKeyDown: onKeyDown,
                onChange: onChange
            }), (0,application/* buildTestIds */.Fek)("input-search-".concat(name)), props))
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/components/LogoImage/index.tsx



var LogoImage = function(param) {
    var _src = param.src, src = _src === void 0 ? "https://d2urakutajlof6.cloudfront.net/logo/logo_fc.svg" : _src, _alt = param.alt, alt = _alt === void 0 ? "Ferreira Costa" : _alt, _width = param.width, width = _width === void 0 ? "180px" : _width, _height = param.height, height = _height === void 0 ? "77px" : _height, _layout = param.layout, layout = _layout === void 0 ? "fixed" : _layout;
    return /*#__PURE__*/ _jsx(Desk, {
        justifyContent: "center",
        children: /*#__PURE__*/ _jsx(Image, {
            src: src,
            alt: alt,
            width: width,
            height: height,
            layout: layout
        })
    });
};


;// CONCATENATED MODULE: ../../packages/components/MaskedInput/index.tsx

var MaskedInput = function(ariaLabel) {
    return /*#__PURE__*/ _jsx("input", {
        "aria-label": ariaLabel
    });
};


// EXTERNAL MODULE: ../../packages/components/Modal/ModalAlert/styles.ts
var ModalAlert_styles = __webpack_require__(40752);
;// CONCATENATED MODULE: ../../packages/components/Modal/ModalAlert/index.tsx






var ModalAlertConfirm = function(param) {
    var isOpen = param.isOpen, typeInfo = param.typeInfo, backgroundColor = param.backgroundColor, textHeader = param.textHeader, descriptionBody = param.descriptionBody, actionCloseButton = param.actionCloseButton, footerProps = param.footerProps;
    if (!isOpen) {
        return null;
    }
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalAlert_styles/* ContentModalAlert */.O$, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-alert-confirm")), {
        typeInfo: typeInfo,
        backgroundColor: backgroundColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAlert_styles/* ButtonClose */.fb, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-alert-confirm-button-close")), {
                onClick: actionCloseButton,
                typeInfo: typeInfo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {
                    height: 25,
                    width: 25
                })
            })),
            textHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAlert_styles/* HeaderModal */.ge, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-alert-confirm-header")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAlert_styles/* TitleModal */.SB, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-alert-confirm-header-title")), {
                    lowerContent: Boolean(descriptionBody),
                    children: textHeader
                }))
            })),
            descriptionBody && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAlert_styles/* BodyModal */.aQ, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-alert-confirm-body")), {
                children: descriptionBody
            })),
            (footerProps === null || footerProps === void 0 ? void 0 : footerProps.isActive) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAlert_styles/* FooterModal */.no, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-alert-confirm-footer")), {
                children: (footerProps === null || footerProps === void 0 ? void 0 : footerProps.children) ? footerProps.children : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        (footerProps === null || footerProps === void 0 ? void 0 : footerProps.buttonLine) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAlert_styles/* ButtonLine */.mH, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-alert-confirm-footer-button-line")), {
                            onClick: footerProps === null || footerProps === void 0 ? void 0 : footerProps.actionButtonLine,
                            children: (ref = footerProps === null || footerProps === void 0 ? void 0 : footerProps.textButtonLine) !== null && ref !== void 0 ? ref : "Cancelar"
                        })),
                        (footerProps === null || footerProps === void 0 ? void 0 : footerProps.buttonSolid) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAlert_styles/* ButtonSolid */.oe, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-alert-confirm-footer-button-solid")), {
                            onClick: footerProps === null || footerProps === void 0 ? void 0 : footerProps.actionButtonSolid,
                            children: (ref1 = footerProps === null || footerProps === void 0 ? void 0 : footerProps.textButtonSolid) !== null && ref1 !== void 0 ? ref1 : "Confirmar"
                        }))
                    ]
                })
            })) : null
        ]
    }));
};


// EXTERNAL MODULE: ../../packages/components/ModalConfirmedEmail/index.tsx + 1 modules
var ModalConfirmedEmail = __webpack_require__(27294);
// EXTERNAL MODULE: ../../packages/components/ModalGeneral/index.tsx + 1 modules
var ModalGeneral = __webpack_require__(89459);
;// CONCATENATED MODULE: ../../packages/components/TextWithCountdown/styles.ts

function TextWithCountdown_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    TextWithCountdown_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TextWithCountdown_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 1rem;\n  font-weight: ",
        ";\n  line-height: 140%;\n  letter-spacing: -0.02rem;\n"
    ]);
    TextWithCountdown_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TextWithCountdown_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  text-decoration: underline;\n  cursor: pointer;\n"
    ]);
    TextWithCountdown_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var TextWithCountdownContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__TextWithCountdownContainer",
    componentId: "sc-1e2a00b5-0"
})(TextWithCountdown_styles_templateObject());
var SubTitleTextWithCountdown = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__SubTitleTextWithCountdown",
    componentId: "sc-1e2a00b5-1"
})(TextWithCountdown_styles_templateObject1(), ui.theme.colors.neutral[525], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[400]);
var TitleStyledTextWithCountdown = (0,styled_components_browser_esm/* default */.ZP)(SubTitleTextWithCountdown).withConfig({
    displayName: "styles__TitleStyledTextWithCountdown",
    componentId: "sc-1e2a00b5-2"
})(TextWithCountdown_styles_templateObject2(), ui.theme.typography.fontWeight[700]);

;// CONCATENATED MODULE: ../../packages/components/TextWithCountdown/index.tsx






var TextWithCountdown = function(param) {
    var textLink = param.textLink, textCountdownEnded = param.textCountdownEnded, textWaitingForEndOfCountdown = param.textWaitingForEndOfCountdown, onClickTheLink = param.onClickTheLink, onFinishedTime = param.onFinishedTime, isModalOpen = param.isModalOpen;
    var ref = (0,application/* useCountdown */.au2)(), timeInSeconds = ref.timeInSeconds, timeFormatted = ref.timeFormatted, hasFinishedCountdown = ref.hasFinishedCountdown, changeHasFinishedCountdown = ref.changeHasFinishedCountdown, changeTimeInSeconds = ref.changeTimeInSeconds;
    var handleClickOnTextLink = (0,react.useCallback)(function() {
        onClickTheLink();
        changeTimeInSeconds(60);
        changeHasFinishedCountdown(false);
    }, [
        changeHasFinishedCountdown,
        changeTimeInSeconds,
        onClickTheLink
    ]);
    (0,react.useEffect)(function() {
        if (timeInSeconds === 0) {
            onFinishedTime();
            if (!isModalOpen) {
                changeTimeInSeconds(60);
                changeHasFinishedCountdown(false);
            }
        }
    }, [
        changeHasFinishedCountdown,
        changeTimeInSeconds,
        isModalOpen,
        onFinishedTime,
        timeInSeconds, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWithCountdownContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("text-with-countdown-container")), {
        children: hasFinishedCountdown ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubTitleTextWithCountdown, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("subtitle-finished-countdown")), {
            children: [
                textCountdownEnded,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleStyledTextWithCountdown, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-styled-finished-text-with-countdown")), {
                    onClick: handleClickOnTextLink,
                    children: textLink
                }))
            ]
        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitleTextWithCountdown, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("subtitle-unfinished-text-with-countdown")), {
            children: "".concat(textWaitingForEndOfCountdown, " ").concat(timeFormatted)
        }))
    }));
};


;// CONCATENATED MODULE: ../../packages/components/NoticeConfirmationEmail/styles.ts

function NoticeConfirmationEmail_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 0.65rem;\n"
    ]);
    NoticeConfirmationEmail_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NoticeConfirmationEmail_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 2rem;\n  height: 2rem;\n"
    ]);
    NoticeConfirmationEmail_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NoticeConfirmationEmail_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    NoticeConfirmationEmail_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NoticeConfirmationEmail_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    NoticeConfirmationEmail_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var textNoticeConfirmationEmailColors = {
    success: ui.theme.colors.secondary[380]
};
var NoticeConfirmationEmailContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__NoticeConfirmationEmailContainer",
    componentId: "sc-300f9d68-0"
})(NoticeConfirmationEmail_styles_templateObject());
var CheckmarkCircleNoticeConfirmationEmailWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CheckmarkCircleNoticeConfirmationEmailWrapper",
    componentId: "sc-300f9d68-1"
})(NoticeConfirmationEmail_styles_templateObject1());
var CheckmarkCircleNoticeConfirmationEmail = (0,styled_components_browser_esm/* default */.ZP)(ui.CheckmarkCircle).withConfig({
    displayName: "styles__CheckmarkCircleNoticeConfirmationEmail",
    componentId: "sc-300f9d68-2"
})(NoticeConfirmationEmail_styles_templateObject2());
var TextNoticeConfirmationEmail = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TextNoticeConfirmationEmail",
    componentId: "sc-300f9d68-3"
})(NoticeConfirmationEmail_styles_templateObject3(), function(param) {
    var type = param.type;
    return textNoticeConfirmationEmailColors[type];
}, ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight[400]);

;// CONCATENATED MODULE: ../../packages/components/NoticeConfirmationEmail/index.tsx





var NoticeConfirmationEmail = function(param) {
    var message = param.message, _type = param.type, type = _type === void 0 ? "success" : _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoticeConfirmationEmailContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("notice-confirmation-email-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkCircleNoticeConfirmationEmailWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("checkmark-circle-notice-confirmation-email-wrapper")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkCircleNoticeConfirmationEmail, {})
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextNoticeConfirmationEmail, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("text-notice-confirmation-email")), {
                type: type,
                children: message
            }))
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/ModalConfirmEmail/index.tsx








var ModalConfirmEmail = function(param) {
    var isOpen = param.isOpen, email = param.email, ariaHideApp = param.ariaHideApp, onCloseModal = param.onCloseModal;
    var ref = (0,react.useState)(false), isEmailResent = ref[0], setEmailResent = ref[1];
    var sendOrResendEmailConfirmation = (0,application/* useModalGroup */.IzY)().sendOrResendEmailConfirmation;
    var handleFinishedTime = (0,react.useCallback)(function() {
        setEmailResent(false);
    }, []);
    var handleResendEmail = (0,react.useCallback)(function() {
        var responseIfSendEmail = sendOrResendEmailConfirmation(email);
        if (responseIfSendEmail !== null) setEmailResent(true);
    }, [
        sendOrResendEmailConfirmation,
        email
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGeneral.ModalGeneral, {
        ariaHideApp: ariaHideApp,
        isOpen: isOpen,
        onCloseModal: onCloseModal,
        ariaLabelForModal: "Confirme seu e-mail",
        title: "Confirme seu e-mail",
        bodyDescription: "Para garantir a sua seguran\xe7a, \xe9 necess\xe1rio confirmar seu e-mail atrav\xe9s do link enviado para o endere\xe7o abaixo. Por favor, lembre de checar sua caixa de spam.",
        illustration: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.IllustrationSendEmail, {}),
        bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxContentEmail, {
                    email: email
                }),
                isEmailResent && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoticeConfirmationEmail, {
                    message: "O link de confirma\xe7\xe3o foi reenviado com sucesso. Verifique seu e-mail ou caixa de spam"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWithCountdown, {
                    textLink: "Enviar novamente",
                    textCountdownEnded: "N\xe3o recebeu o e-mail? ",
                    onClickTheLink: handleResendEmail,
                    onFinishedTime: handleFinishedTime,
                    isModalOpen: isOpen,
                    textWaitingForEndOfCountdown: "N\xe3o recebeu o e-mail? Enviar novamente em"
                })
            ]
        })
    });
};


// EXTERNAL MODULE: ../../packages/components/ModalConfirmEmailError/index.tsx + 1 modules
var ModalConfirmEmailError = __webpack_require__(51637);
;// CONCATENATED MODULE: ../../packages/components/ModalNewAddress/styles.ts

function ModalNewAddress_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: ",
        ";\n"
    ]);
    ModalNewAddress_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalNewAddress_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  height: 100%;\n  position: relative;\n  color: ",
        ";\n  background-color: transparent;\n  flex: 1;\n  align-items: center;\n  z-index: 100;\n"
    ]);
    ModalNewAddress_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalNewAddress_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n\n  @media ",
        " {\n    margin-top: auto;\n    position: relative;\n    align-items: flex-start;\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    margin-bottom: 0.5rem;\n  }\n\n  @media ",
        " {\n    height: calc(70vh - 100px);\n\n    margin-top: auto;\n    position: relative;\n    align-items: flex-start;\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    margin-bottom: 0.5rem;\n  }\n\n  @media ",
        " {\n    height: 25.9rem;\n  }\n"
    ]);
    ModalNewAddress_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var FormAddNewAddressWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__FormAddNewAddressWrapper",
    componentId: "sc-5ac61c7e-0"
})(ModalNewAddress_styles_templateObject(), ui.theme.colors.neutral.white[80]);
var NewAddressModal = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__NewAddressModal",
    componentId: "sc-5ac61c7e-1"
})(ModalNewAddress_styles_templateObject1(), ui.theme.colors.neutral[520]);
var SectionModal = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SectionModal",
    componentId: "sc-5ac61c7e-2"
})(ModalNewAddress_styles_templateObject2(), ui.theme.device.desktopFirst.mobileS, ui.theme.device.desktopFirst.mobileL, ui.theme.device.desktopFirst.mobileXL);

// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/styles.ts

function NewFormAddress_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 1rem;\n"
    ]);
    NewFormAddress_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-right: ",
        ";\n  gap: 0.5rem;\n  flex-direction: ",
        ";\n  @media ",
        " {\n    width: 100%;\n    grid-template-rows: 1fr;\n    place-items: center;\n  }\n"
    ]);
    NewFormAddress_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 15px;\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  font-family: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    NewFormAddress_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 1.5rem;\n  margin-bottom: 0.5rem;\n"
    ]);
    NewFormAddress_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  @media ",
        " {\n    height: 80vh;\n    grid-template-rows: 1fr;\n  }\n\n  @media ",
        " {\n    height: 100%;\n  }\n"
    ]);
    NewFormAddress_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.5rem;\n"
    ]);
    NewFormAddress_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2rem;\n"
    ]);
    NewFormAddress_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1rem;\n"
    ]);
    NewFormAddress_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 4rem;\n  align-items: flex-end;\n\n  @media ",
        " {\n    gap: ",
        ";\n  }\n\n  @media ",
        " {\n    align-items: center;\n  }\n"
    ]);
    NewFormAddress_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n"
    ]);
    NewFormAddress_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: fit-content;\n\n  @media (max-width: 736px) {\n    width: 100%;\n  }\n"
    ]);
    NewFormAddress_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: flex-start;\n"
    ]);
    NewFormAddress_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 240px;\n  height: fit-content;\n"
    ]);
    NewFormAddress_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function NewFormAddress_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: ",
        ";\n  width: 100%;\n  height: fit-content;\n"
    ]);
    NewFormAddress_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  column-gap: ",
        ";\n  row-gap: ",
        ";\n  max-width: 800px;\n  max-height: 1200px;\n  height: 100%;\n  margin-bottom: ",
        ";\n\n  @media ",
        " {\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: repeat(5, 100px);\n    height: fit-content;\n    row-gap: ",
        ";\n  }\n\n  @media ",
        " {\n    grid-template-columns: 1fr;\n    grid-template-rows: repeat(9, 80px);\n    height: fit-content;\n    row-gap: ",
        ";\n  }\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1;\n  position: absolute;\n  right: 20%;\n  margin-top: -1rem;\n  @media ",
        " {\n    width: 4rem;\n    left: 7rem;\n  }\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-family: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: ",
        ";\n\n  background-color: ",
        ";\n"
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:checked {\n    background-color: ",
        " !important;\n    border-color: ",
        " !important;\n  }\n"
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.2rem;\n  background: ",
        ";\n  border: thin solid ",
        ";\n  color: thin solid ",
        ";\n  border-radius: ",
        ";\n  padding: 0 0.8rem;\n  margin: ",
        ";\n  height: 50px;\n\n  border-color: ",
        ";\n  border-color: ",
        ";\n\n  opacity: ",
        ";\n  background-color: ",
        ";\n\n  width: 100%;\n"
    ]);
    styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 16px;\n  transition: background-color 0.2s ease-in;\n  align-self: center;\n"
    ]);
    styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding-top: 0.5rem;\n\n  @media ",
        " {\n    padding-top: 0;\n  }\n"
    ]);
    styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: ",
        ";\n  width: 100%;\n\n  @media ",
        " {\n    justify-content: flex-start;\n    gap: ",
        ";\n  }\n"
    ]);
    styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 2rem;\n  cursor: pointer;\n\n  @media ",
        " {\n    margin-left: -",
        ";\n    display: flex;\n    align-items: center;\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 4rem;\n  padding: 2.75rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}






var styles_IconLoading = (0,styled_components_browser_esm/* default */.ZP)(Loading/* Loading */.g).withConfig({
    displayName: "styles__IconLoading",
    componentId: "sc-d5ff411d-0"
})(NewFormAddress_styles_templateObject());
var styles_ExtraInfoCEP = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ExtraInfoCEP",
    componentId: "sc-d5ff411d-1"
})(NewFormAddress_styles_templateObject1(), function(param) {
    var isdisplayedonbottomsheet = param.isdisplayedonbottomsheet;
    return isdisplayedonbottomsheet ? "0" : "5rem";
}, function(param) {
    var isdisplayedonbottomsheet = param.isdisplayedonbottomsheet;
    return isdisplayedonbottomsheet ? "row-reverse" : "row";
}, ui.theme.device.desktopFirst.mobileXL);
var styles_DescriptionText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DescriptionText",
    componentId: "sc-d5ff411d-2"
})(NewFormAddress_styles_templateObject2(), ui.theme.colors.neutral[400], ui.theme.typography.fontFamily.barlow, ui.theme.device.desktopFirst.laptopL, ui.theme.typography.fontSize.sm.x3, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x3);
var styles_BoxButtonDefault = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BoxButtonDefault",
    componentId: "sc-d5ff411d-3"
})(NewFormAddress_styles_templateObject3());
var styles_FormNewAddressContainer = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "styles__FormNewAddressContainer",
    componentId: "sc-d5ff411d-4"
})(NewFormAddress_styles_templateObject4(), ui.theme.device.desktopFirst.tablet, ui.theme.device.mobileFirst.mobileM);
var styles_SpaceMobileTop = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SpaceMobileTop",
    componentId: "sc-d5ff411d-5"
})(NewFormAddress_styles_templateObject5());
var styles_SpaceMobileBottom = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SpaceMobileBottom",
    componentId: "sc-d5ff411d-6"
})(NewFormAddress_styles_templateObject6());
var styles_FormNewAddressContent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__FormNewAddressContent",
    componentId: "sc-d5ff411d-7"
})(NewFormAddress_styles_templateObject7());
var styles_WrapperContentHouse = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperContentHouse",
    componentId: "sc-d5ff411d-8"
})(NewFormAddress_styles_templateObject8(), ui.theme.device.desktopFirst.tabletXL, ui.theme.space["x4.5"], ui.theme.device.desktopFirst.mobileXL);
var styles_AlignWrapperInput = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__AlignWrapperInput",
    componentId: "sc-d5ff411d-9"
})(NewFormAddress_styles_templateObject9());
var styles_WrapperInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperInput",
    componentId: "sc-d5ff411d-10"
})(NewFormAddress_styles_templateObject10());
var WrapperCheckBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperCheckBox",
    componentId: "sc-d5ff411d-11"
})(NewFormAddress_styles_templateObject11());
var styles_WrapperSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperSelect",
    componentId: "sc-d5ff411d-12"
})(NewFormAddress_styles_templateObject12());
var styles_WrapperRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperRow",
    componentId: "sc-d5ff411d-13"
})(NewFormAddress_styles_templateObject13(), ui.theme.space.x6);
var FormContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__FormContainer",
    componentId: "sc-d5ff411d-14"
})(styles_templateObject14(), ui.theme.space.x6, ui.theme.space.x6, ui.theme.space.x6, ui.theme.device.desktopFirst.tablet, ui.theme.space["x3.5"], ui.theme.device.desktopFirst.mobileM, ui.theme.space.x2);
var styles_CheckDoneSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CheckDoneSection",
    componentId: "sc-d5ff411d-15"
})(styles_templateObject15(), ui.theme.device.desktopFirst.mobileL);
var styles_CustomLabelNewAddress = (0,styled_components_browser_esm/* default */.ZP)(Form/* Label */.__).withConfig({
    displayName: "styles__CustomLabelNewAddress",
    componentId: "sc-d5ff411d-16"
})(styles_templateObject16(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x3);
var styles_CustomInputNewAddress = (0,styled_components_browser_esm/* default */.ZP)(Form/* NewCustomInput */.xg).withConfig({
    displayName: "styles__CustomInputNewAddress",
    componentId: "sc-d5ff411d-17"
})(styles_templateObject17(), function(param) {
    var disabled = param.disabled;
    return disabled ? 0.5 : 1;
}, function(param) {
    var disabled = param.disabled;
    return disabled ? ui.theme.colors.neutral[100] : ui.theme.colors.neutral.white;
});
var styles_CustomCheckboxNewAddress = (0,styled_components_browser_esm/* default */.ZP)(Form/* Checkbox */.XZ).withConfig({
    displayName: "styles__CustomCheckboxNewAddress",
    componentId: "sc-d5ff411d-18"
})(styles_templateObject18(), ui.theme.colors.secondary[300], ui.theme.colors.secondary[300]);
var styles_StateSelect = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    displayName: "styles__StateSelect",
    componentId: "sc-d5ff411d-19"
})(styles_templateObject19(), ui.theme.colors.neutral.white, ui.theme.colors.neutral[200], ui.theme.colors.neutral[450], ui.theme.space.x2, "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0), function(param) {
    var hasSuccessfully = param.hasSuccessfully;
    return hasSuccessfully ? ui.theme.colors.secondary[300] : "";
}, function(param) {
    var hasError = param.hasError, hasSuccessfully = param.hasSuccessfully;
    return hasError && !hasSuccessfully ? ui.theme.colors.primary[300] : "";
}, function(param) {
    var disabled = param.disabled;
    return disabled ? 0.8 : 1;
}, function(param) {
    var disabled = param.disabled;
    return disabled ? ui.theme.colors.neutral[100] : ui.theme.colors.neutral.white;
});
var styles_ButtonRegisterAction = (0,styled_components_browser_esm/* default */.ZP)(ButtonSubmit/* ButtonSubmit */.G).attrs({
    fontSize: ui.theme.typography.fontSize.sm.x7,
    height: "3.75rem",
    fontWeight: 400,
    borderRadius: "8px"
}).withConfig({
    displayName: "styles__ButtonRegisterAction",
    componentId: "sc-d5ff411d-20"
})(styles_templateObject20());
var styles_OptionStates = styled_components_browser_esm/* default.option.withConfig */.ZP.option.withConfig({
    displayName: "styles__OptionStates",
    componentId: "sc-d5ff411d-21"
})(styles_templateObject21());
var styles_LinkCustom = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "styles__LinkCustom",
    componentId: "sc-d5ff411d-22"
})(styles_templateObject22(), ui.theme.device.desktopFirst.tablet);
var AddressHeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__AddressHeaderContainer",
    componentId: "sc-d5ff411d-23"
})(styles_templateObject23(), ui.theme.space["x4.5"], ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x2);
var CloseButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CloseButton",
    componentId: "sc-d5ff411d-24"
})(_templateObject24(), ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x2);
var AddressHeaderTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__AddressHeaderTitle",
    componentId: "sc-d5ff411d-25"
})(_templateObject25(), ui.theme.typography.fontSize.md.x1, ui.theme.colors.neutral[525], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight.bold);
var styles_BoxButton = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BoxButton",
    componentId: "sc-d5ff411d-26"
})(_templateObject26(), ui.theme.colors.neutral.white);
var FormMyAddressWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__FormMyAddressWrapper",
    componentId: "sc-d5ff411d-27"
})(_templateObject27(), ui.theme.space["x4.5"], ui.theme.space["x4.5"]);

;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/Form/city/index.tsx



var CityComponent = function(param) {
    var control = param.control, requiredFieldText = param.requiredFieldText, hasError = param.hasError, disabled = param.disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_WrapperInput, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CustomInputNewAddress, {
            id: "city",
            name: "city",
            type: "text",
            required: requiredFieldText,
            placeholder: "Ex. Recife",
            margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
            width: "100%",
            disabled: disabled,
            control: control,
            hasError: hasError,
            label: "Cidade"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/Form/complement/index.tsx



var ComplementComponent = function(param) {
    var control = param.control, hasError = param.hasError;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_WrapperInput, {
        fully: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CustomInputNewAddress, {
            id: "addressComplement",
            name: "addressComplement",
            type: "text",
            hasError: hasError,
            control: control,
            margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
            width: "100%",
            placeholder: "Apartamento, bloco, edif\xedcio, andar, etc",
            label: "Complemento",
            showOptionalText: true
        })
    });
};

;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/Form/district/index.tsx



var DistrictComponent = function(param) {
    var control = param.control, disabled = param.disabled, hasError = param.hasError, requiredFieldText = param.requiredFieldText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_WrapperInput, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CustomInputNewAddress, {
            id: "district",
            name: "district",
            type: "text",
            required: requiredFieldText,
            control: control,
            disabled: disabled,
            hasError: hasError,
            placeholder: "Ex. Santo Antonio",
            margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
            width: "100%",
            label: "Bairro"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/Form/noNumber/index.tsx



var NoNumberComponent = function(param) {
    var isCheckedEvent = param.isCheckedEvent, register = param.register;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperCheckBox, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_AlignWrapperInput, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CustomCheckboxNewAddress, {
                    id: "noNumber",
                    color: ui.theme.colors.secondary[300],
                    name: "noNumber",
                    register: register,
                    isCheckedEvent: function(isChecked) {
                        if (isCheckedEvent) isCheckedEvent(isChecked);
                    },
                    heightChecked: "8px",
                    widthChecked: "4px",
                    left: "1px",
                    sizeChecked: "1em",
                    height: ui.theme.space.x4,
                    width: ui.theme.space.x4,
                    borderRadius: ui.theme.space.x1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CustomLabelNewAddress, {
                    htmlFor: "noNumber",
                    text: "Sem n\xfamero"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/Form/number/index.tsx







var NumberComponent = function(param) {
    var control = param.control, disabled = param.disabled, hasError = param.hasError, requiredFieldText = param.requiredFieldText, setValue = param.setValue;
    var ref = (0,react.useState)(""), number = ref[0], selectNumber = ref[1];
    var isNoNumberOptionChecked = (0,index_esm/* useWatch */.qo)({
        control: control,
        name: "noNumber"
    });
    (0,react.useEffect)(function() {
        if (isNoNumberOptionChecked) {
            selectNumber("");
            setValue("number", "");
        }
    }, [
        isNoNumberOptionChecked,
        setValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_WrapperInput, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CustomInputNewAddress, (0,src_object_spread/* default */.Z)({
            id: "number",
            name: "number",
            type: "tel",
            inputMode: "numeric",
            placeholder: "Ex. 1",
            control: control,
            disabled: disabled || Boolean(isNoNumberOptionChecked),
            hasSuccessfully: !!number && !hasError || Boolean(isNoNumberOptionChecked),
            hasError: hasError,
            onChange: function(e) {
                var ref;
                var formattedValue = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value.replace(/\D/g, "");
                selectNumber(formattedValue);
                setValue("number", formattedValue);
            },
            value: number,
            required: isNoNumberOptionChecked ? undefined : requiredFieldText,
            width: "100%",
            margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
            maxLength: 6,
            label: "N\xfamero"
        }, (0,application/* buildTestIds */.Fek)("form-input-number")))
    });
};

;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/Form/recipient/index.tsx




var RecipientComponent = function(param) {
    var control = param.control, hasError = param.hasError, requiredFieldText = param.requiredFieldText;
    var loggedClient = (0,application/* useUser */.aFb)().loggedClient;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_WrapperInput, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CustomInputNewAddress, {
            id: "recipient",
            name: "recipient",
            type: "text",
            placeholder: "Ex. ".concat(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.name),
            required: requiredFieldText,
            control: control,
            hasError: !!hasError,
            margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
            width: "100%",
            label: "Nome do destinat\xe1rio"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/Form/reference/index.tsx



var ReferenceComponent = function(param) {
    var control = param.control, hasError = param.hasError;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_WrapperInput, {
        fully: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CustomInputNewAddress, {
            id: "referencePoint",
            name: "referencePoint",
            type: "text",
            hasError: hasError,
            control: control,
            margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
            width: "100%",
            label: "Refer\xeancia",
            placeholder: "Ex. Pr\xf3ximo a Ferreira Costa",
            showOptionalText: true
        })
    });
};

;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/Form/state/index.tsx



var StateComponent = function(param) {
    var control = param.control, disabled = param.disabled, hasError = param.hasError, stateList = param.stateList;
    var stateListFormatted = stateList.map(function(state, index) {
        return {
            value: state,
            label: state,
            index: index + 1
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_WrapperSelect, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* CustomSelect */.AP, {
            id: "state",
            name: "state",
            label: "Estado",
            control: control,
            disabled: disabled,
            placeholder: "Selecione o estado",
            hasError: hasError,
            width: "100%",
            optionsList: stateListFormatted,
            required: true
        })
    });
};

;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/Form/street/index.tsx



var StreetComponent = function(param) {
    var control = param.control, disabled = param.disabled, hasError = param.hasError, requiredFieldText = param.requiredFieldText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_WrapperInput, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CustomInputNewAddress, {
            label: "Rua ou avenida",
            id: "street",
            name: "street",
            type: "text",
            placeholder: "Rua ou avenida",
            required: requiredFieldText,
            control: control,
            margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
            disabled: disabled,
            hasError: hasError,
            width: "100%"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/Form/zipcode/index.tsx



var ZipCodeComponent = function(param) {
    var control = param.control, requiredFieldText = param.requiredFieldText, hasError = param.hasError, hasSuccessfully = param.hasSuccessfully, textError = param.textError, onChange = param.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_WrapperInput, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CustomInputNewAddress, {
            id: "zipCode",
            name: "zipCode",
            required: requiredFieldText,
            control: control,
            placeholder: "_ _ _ _ _-_ _ _",
            type: "tel",
            minLength: 9,
            max: 9,
            onChange: function(e) {
                onChange(e);
            },
            maxLength: 9,
            width: "100%",
            mask: "99999-999",
            margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
            maskChar: "",
            hasError: hasError,
            hasSuccessfully: hasSuccessfully,
            textError: textError,
            label: "CEP"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/Form/index.tsx











;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/Header/index.tsx



var AddressHeader = function(param) {
    var isClientMobile = param.isClientMobile, newAddressData = param.newAddressData, onCloseModal = param.onCloseModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressHeaderContainer, {
        children: [
            isClientMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                onClick: onCloseModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowLeft, {})
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressHeaderTitle, {
                children: newAddressData ? "Alterar endere\xe7o" : "Adicionar novo endere\xe7o"
            }),
            !isClientMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                onClick: onCloseModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {})
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/components/index.tsx



;// CONCATENATED MODULE: ../../packages/components/NewFormAddress/index.tsx













var NewFormAddress = function(param) {
    var newAddressData = param.newAddress, returnCreatedStatus = param.returnCreatedStatus, returnEditStatus = param.returnEditStatus, onCreateNewAddress = param.onCreateNewAddress, onActionAfterCreateNewAddress = param.onActionAfterCreateNewAddress, onActionAfterEditAddress = param.onActionAfterEditAddress, onCloseModal = param.onCloseModal;
    var ref, ref1;
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var TOKEN_SESSION = getTokens();
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var ref2 = (0,react.useState)(), disabledInputs = ref2[0], setDisabledInputs = ref2[1];
    var ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var ref14 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            addressComplement: (ref3 = newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.addressComplement) !== null && ref3 !== void 0 ? ref3 : "",
            city: (ref4 = newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.city) !== null && ref4 !== void 0 ? ref4 : "",
            district: (ref5 = newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.district) !== null && ref5 !== void 0 ? ref5 : "",
            noNumber: (newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.number) === 0,
            number: (newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.number) !== 0 ? newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.number : undefined,
            recipient: (ref6 = newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.recipient) !== null && ref6 !== void 0 ? ref6 : "",
            referencePoint: (ref7 = newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.referencePoint) !== null && ref7 !== void 0 ? ref7 : "",
            state: (ref8 = newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.state) !== null && ref8 !== void 0 ? ref8 : "",
            street: (ref9 = newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.street) !== null && ref9 !== void 0 ? ref9 : "",
            zipCode: (ref10 = newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.zipCode) !== null && ref10 !== void 0 ? ref10 : "",
            clientId: (ref11 = newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.clientId) !== null && ref11 !== void 0 ? ref11 : 0,
            id: (ref12 = newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.id) !== null && ref12 !== void 0 ? ref12 : 0,
            isDefault: (ref13 = newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.isDefault) !== null && ref13 !== void 0 ? ref13 : false
        },
        shouldFocusError: true,
        mode: "onChange",
        reValidateMode: "onChange",
        resetOptions: {
            keepDefaultValues: false,
            keepValues: false,
            keepErrors: false
        },
        resolver: (0,zod/* zodResolver */.F)(application/* FormAddressSchema */.UGY)
    }), register = ref14.register, setValue = ref14.setValue, handleSubmit = ref14.handleSubmit, control = ref14.control, watch = ref14.watch, setError = ref14.setError, clearErrors = ref14.clearErrors, reset = ref14.reset, errors = ref14.formState.errors;
    var buttonText = newAddressData ? "Salvar Altera\xe7\xf5es" : "Adicionar novo endere\xe7o";
    var buttonUnderActionText = newAddressData ? "Salvando Altera\xe7\xf5es" : "Adicionando novo endere\xe7o";
    var requiredField = "Campo obrigat\xf3rio";
    var ref15 = (0,react.useState)(false), shouldFetchAddressByZipCode = ref15[0], setShouldFetchAddressByZipCode = ref15[1];
    var ref16 = (0,react.useState)(false), isLoadingButton = ref16[0], handleLoadingButton = ref16[1];
    var ref17 = (0,react.useState)(false), shouldDisabledAllInputs = ref17[0], setShouldDisabledAllInputs = ref17[1];
    var newStreetWatcher = watch("street");
    var zipCodeWatcher = watch("zipCode");
    var searchCEP = (0,react.useMemo)(function() {
        return String(zipCodeWatcher);
    }, [
        zipCodeWatcher
    ]);
    var isCEPValid = (0,react.useMemo)(function() {
        return String(searchCEP).length === 9;
    }, [
        searchCEP
    ]);
    var hasNewAddressStreet = !!newStreetWatcher;
    var ref18 = implementations/* shippingApi.getAddressByZipCode */.JK.getAddressByZipCode(searchCEP !== null && searchCEP !== void 0 ? searchCEP : "", shouldFetchAddressByZipCode), addressByCep = ref18.data, addressByCepIsLoading = ref18.isLoading, addressByCepError = ref18.error;
    var onAutoCompleteAddressByCep = (0,react.useCallback)(function() {
        if (isCEPValid && addressByCep && addressByCep !== null) {
            var street = addressByCep.street, city = addressByCep.city, uf = addressByCep.uf, district = addressByCep.district;
            setValue("city", city === null || city === void 0 ? void 0 : city.trim());
            setValue("state", uf === null || uf === void 0 ? void 0 : uf.trim());
            setValue("street", street === null || street === void 0 ? void 0 : street.trim());
            setValue("district", district === null || district === void 0 ? void 0 : district.trim());
            setDisabledInputs({
                street: Boolean(street),
                city: Boolean(city),
                district: Boolean(district),
                state: Boolean(uf),
                addressComplement: false,
                clientId: false,
                id: false,
                isDefault: false,
                noNumber: false,
                number: false,
                recipient: false,
                referencePoint: false,
                zipCode: false
            });
        }
    }, [
        addressByCep,
        isCEPValid,
        setValue
    ]);
    var handleCreateNewAddress = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(addressData) {
            var ref, street, zipCode, city, district, recipient, state, addressComplement, number, noNumber, referencePoint, responseCreated;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        handleLoadingButton(true);
                        street = addressData.street, zipCode = addressData.zipCode, city = addressData.city, district = addressData.district, recipient = addressData.recipient, state = addressData.state, addressComplement = addressData.addressComplement, number = addressData.number, noNumber = addressData.noNumber, referencePoint = addressData.referencePoint;
                        return [
                            4,
                            implementations/* profileApi.createClientAddress */.c_.createClientAddress({
                                street: (0,application/* removeSpecialCharacters */.A2V)(street),
                                number: noNumber ? 0 : Number(number),
                                addressComplement: (0,application/* removeSpecialCharacters */.A2V)(addressComplement),
                                referencePoint: (0,application/* removeSpecialCharacters */.A2V)(referencePoint),
                                district: (0,application/* removeSpecialCharacters */.A2V)(district),
                                state: (0,application/* removeSpecialCharacters */.A2V)(state),
                                zipCode: String(zipCode),
                                city: (0,application/* removeSpecialCharacters */.A2V)(city),
                                recipient: (0,application/* removeSpecialCharacters */.A2V)(recipient),
                                isDefault: false
                            }, (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token)
                        ];
                    case 1:
                        responseCreated = _state.sent();
                        if (responseCreated) {
                            handleLoadingButton(false);
                            if (onActionAfterCreateNewAddress) onActionAfterCreateNewAddress();
                            if (onCreateNewAddress) onCreateNewAddress(responseCreated);
                            if (returnCreatedStatus) {
                                returnCreatedStatus();
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(addressData) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getTokens,
        onCreateNewAddress,
        onActionAfterCreateNewAddress,
        returnCreatedStatus, 
    ]);
    var handleEditNewAddress = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(data) {
            var street, zipCode, city, district, recipient, state, addressComplement, number, referencePoint, noNumber, BODY, responseEdit;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!data) {
                            return [
                                2
                            ];
                        }
                        street = data.street, zipCode = data.zipCode, city = data.city, district = data.district, recipient = data.recipient, state = data.state, addressComplement = data.addressComplement, number = data.number, referencePoint = data.referencePoint, noNumber = data.noNumber;
                        BODY = [
                            {
                                op: "replace",
                                path: "/ZipCode",
                                value: zipCode
                            },
                            {
                                op: "replace",
                                path: "/Street",
                                value: (0,application/* removeSpecialCharacters */.A2V)(street)
                            },
                            {
                                op: "replace",
                                path: "/Number",
                                value: Number(noNumber ? 0 : number !== null && number !== void 0 ? number : 0)
                            },
                            {
                                op: "replace",
                                path: "/AddressComplement",
                                value: (0,application/* removeSpecialCharacters */.A2V)(addressComplement) || ""
                            },
                            {
                                op: "replace",
                                path: "/ReferencePoint",
                                value: (0,application/* removeSpecialCharacters */.A2V)(referencePoint) || ""
                            },
                            {
                                op: "replace",
                                path: "/District",
                                value: (0,application/* removeSpecialCharacters */.A2V)(district)
                            },
                            {
                                op: "replace",
                                path: "/State",
                                value: (0,application/* removeSpecialCharacters */.A2V)(state)
                            },
                            {
                                op: "replace",
                                path: "/City",
                                value: (0,application/* removeSpecialCharacters */.A2V)(city)
                            },
                            {
                                op: "replace",
                                path: "/Recipient",
                                value: (0,application/* removeSpecialCharacters */.A2V)(recipient)
                            }
                        ];
                        return [
                            4,
                            implementations/* profileApi.editClientAddresses */.c_.editClientAddresses((TOKEN_SESSION === null || TOKEN_SESSION === void 0 ? void 0 : TOKEN_SESSION.token) || "", String(newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.id) || "", BODY)
                        ];
                    case 1:
                        responseEdit = _state.sent();
                        if (returnEditStatus && responseEdit) {
                            returnEditStatus();
                        }
                        if (onActionAfterEditAddress) onActionAfterEditAddress();
                        handleLoadingButton(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        TOKEN_SESSION === null || TOKEN_SESSION === void 0 ? void 0 : TOKEN_SESSION.token,
        newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.id,
        returnEditStatus,
        onActionAfterEditAddress, 
    ]);
    var controlAction = (0,react.useCallback)(function(data) {
        var handleCheckBox = data.number || data.noNumber;
        if (!data.zipCode || !(data === null || data === void 0 ? void 0 : data.street) || !(data === null || data === void 0 ? void 0 : data.city) || !(data === null || data === void 0 ? void 0 : data.district) || !(data === null || data === void 0 ? void 0 : data.state) || !data.recipient || !handleCheckBox) {
            addToast({
                type: "error",
                title: "Preencha os campos obrigat\xf3rios antes de enviar."
            });
            setError("root", {
                type: "manual",
                message: "Preencha os campos obrigat\xf3rios antes de enviar."
            });
            return;
        }
        handleLoadingButton(true);
        if (newAddressData) {
            handleEditNewAddress(data);
            return;
        }
        handleCreateNewAddress(data);
    }, [
        newAddressData,
        handleCreateNewAddress,
        addToast,
        setError,
        handleEditNewAddress, 
    ]);
    (0,react.useEffect)(function() {
        if ((zipCodeWatcher === null || zipCodeWatcher === void 0 ? void 0 : zipCodeWatcher.toString().length) === 0) {
            reset({
                addressComplement: "",
                city: "",
                district: "",
                noNumber: false,
                number: undefined,
                recipient: "",
                referencePoint: "",
                state: "",
                street: "",
                zipCode: ""
            });
            setDisabledInputs({
                street: false,
                city: false,
                district: false,
                state: false,
                addressComplement: false,
                clientId: false,
                id: false,
                isDefault: false,
                noNumber: false,
                number: false,
                recipient: false,
                referencePoint: false,
                zipCode: false
            });
        }
    }, [
        reset,
        zipCodeWatcher
    ]);
    (0,react.useEffect)(function() {
        if (addressByCep) {
            setShouldFetchAddressByZipCode(false);
            clearErrors();
            onAutoCompleteAddressByCep();
        }
    }, [
        addressByCep,
        clearErrors,
        onAutoCompleteAddressByCep
    ]);
    (0,react.useEffect)(function() {
        var validCepAndNotLoading = isCEPValid && !addressByCepIsLoading;
        if (addressByCepError && validCepAndNotLoading) {
            setShouldDisabledAllInputs(true);
            addToast({
                type: "error",
                title: "Erro ao buscar o CEP",
                description: "Desculpe, ocorreu um erro ao buscar o CEP. Por favor, tente novamente mais tarde.",
                isNewToast: true,
                newToastTheme: "light"
            });
            return;
        }
        if (!addressByCepIsLoading && addressByCep === null) {
            setShouldDisabledAllInputs(true);
            addToast({
                type: "error",
                title: "CEP inv\xe1lido",
                description: "O CEP digitado \xe9 inv\xe1lido.",
                isNewToast: true,
                newToastTheme: "light"
            });
            return;
        }
        setShouldDisabledAllInputs(false);
    }, [
        addToast,
        addressByCep,
        addressByCepError,
        addressByCepIsLoading,
        hasNewAddressStreet,
        isCEPValid,
        zipCodeWatcher, 
    ]);
    (0,react.useEffect)(function() {
        if (newAddressData) {
            setDisabledInputs({
                street: true,
                city: true,
                district: true,
                state: true,
                addressComplement: false,
                clientId: false,
                id: false,
                isDefault: false,
                noNumber: false,
                number: false,
                recipient: false,
                referencePoint: false,
                zipCode: false
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var ref19;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_FormNewAddressContainer, {
        id: "form-new-address",
        onSubmit: handleSubmit(handleCreateNewAddress),
        "data-testid": "form-new-address",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressHeader, {
                isClientMobile: isClientMobile,
                newAddressData: newAddressData,
                onCloseModal: onCloseModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeComponent, {
                        hasError: !hasNewAddressStreet && Boolean(!!errors.zipCode || !!errors.root) || addressByCep === null,
                        hasSuccessfully: isCEPValid && hasNewAddressStreet && addressByCep !== null,
                        textError: (ref19 = (ref = errors.zipCode) === null || ref === void 0 ? void 0 : ref.message) !== null && ref19 !== void 0 ? ref19 : (ref1 = errors.root) === null || ref1 === void 0 ? void 0 : ref1.message,
                        requiredFieldText: requiredField,
                        control: control,
                        onChange: function(e) {
                            if (e.target.value.length === 9) {
                                setValue("zipCode", e.target.value);
                                setShouldFetchAddressByZipCode(true);
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StateComponent, {
                        control: control,
                        disabled: !!(disabledInputs === null || disabledInputs === void 0 ? void 0 : disabledInputs.state) || shouldDisabledAllInputs,
                        hasError: !!errors.state || !!errors.root,
                        stateList: application/* brazilianStates.map */.xVL.map(function(param) {
                            var state = param.state;
                            return state;
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CityComponent, {
                        requiredFieldText: requiredField,
                        disabled: !!(disabledInputs === null || disabledInputs === void 0 ? void 0 : disabledInputs.city) || shouldDisabledAllInputs,
                        control: control,
                        hasError: !!(errors === null || errors === void 0 ? void 0 : errors.city) || !!(errors === null || errors === void 0 ? void 0 : errors.root)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StreetComponent, {
                        requiredFieldText: requiredField,
                        control: control,
                        disabled: !!(disabledInputs === null || disabledInputs === void 0 ? void 0 : disabledInputs.street) || shouldDisabledAllInputs,
                        hasError: !!(errors === null || errors === void 0 ? void 0 : errors.street) || !!(errors === null || errors === void 0 ? void 0 : errors.root)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberComponent, {
                        control: control,
                        disabled: shouldDisabledAllInputs,
                        hasError: !!(errors === null || errors === void 0 ? void 0 : errors.number) || !!(errors === null || errors === void 0 ? void 0 : errors.root),
                        requiredFieldText: requiredField,
                        setValue: setValue
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoNumberComponent, {
                        register: register,
                        isCheckedEvent: function(isChecked) {
                            setValue("noNumber", isChecked);
                            setValue("number", undefined);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DistrictComponent, {
                        requiredFieldText: requiredField,
                        control: control,
                        disabled: !!(disabledInputs === null || disabledInputs === void 0 ? void 0 : disabledInputs.district) || shouldDisabledAllInputs,
                        hasError: !!errors.district || !!(errors === null || errors === void 0 ? void 0 : errors.root)
                    }),
                    !newAddressData && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecipientComponent, {
                        requiredFieldText: requiredField,
                        control: control,
                        hasError: !!errors.recipient || !!(errors === null || errors === void 0 ? void 0 : errors.root)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComplementComponent, {
                        hasError: !!errors.addressComplement,
                        control: control
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReferenceComponent, {
                        hasError: !!errors.referencePoint,
                        control: control
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_FormNewAddressContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ButtonRegisterAction, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-register-action")), {
                    text: buttonText,
                    textUnderAction: buttonUnderActionText,
                    buttonType: "button",
                    minWidth: isClientMobile ? "100%" : "33.835rem",
                    color: ui.theme.colors.secondary[380],
                    hoveredColor: ui.theme.colors.secondary[350],
                    onClickAction: handleSubmit(controlAction),
                    underAction: isLoadingButton
                }))
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/components/ModalNewAddress/index.tsx












var ModalNewAddress = function(_param) {
    var isOpen = _param.isOpen, handleStatusCloseModal = _param.handleStatusCloseModal, isMyAddress = _param.isMyAddress, formProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "isOpen",
        "handleStatusCloseModal",
        "isMyAddress"
    ]);
    var ref;
    var ref1 = (0,application/* useAppContext */.bp4)(), isClientTabletXL = ref1.isClientTabletXL, isClientMobile = ref1.isClientMobile, isClientTabletM = ref1.isClientTabletM;
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var router = (0,next_router.useRouter)();
    var isMyAddressPage = router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.includes("meus-enderecos");
    var shouldNotRenderNewFormAddress = (0,react.useMemo)(function() {
        return Boolean(isClientMobile && isMyAddress && isMyAddressPage);
    }, [
        isClientMobile,
        isMyAddress,
        isMyAddressPage
    ]);
    var modalWidth = (0,react.useMemo)(function() {
        if (isClientTabletM) {
            return "95vw";
        }
        if (isClientTabletXL) {
            return "75vw";
        }
        return "fit-content";
    }, [
        isClientTabletM,
        isClientTabletXL
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountBaseModal_AccountBaseModal, {
        backgroundColor: ui.theme.colors.neutral.white,
        buttonWidth: "20.8125rem",
        displayHeader: "none",
        overlay: ui.theme.colors.neutral["999-opacity-60"],
        boxShadow: "7px 7px 7px ".concat(ui.theme.colors.neutral["999-opacity-60"]),
        isOpen: shouldNotRenderNewFormAddress ? false : isOpen,
        borderRadius: isClientTabletXL ? ui.theme.space.x7 : ui.theme.space.x4,
        contentLabel: "Adicione novo endere\xe7o",
        onCloseModal: function(event) {
            handleStatusCloseModal(false);
            event === null || event === void 0 ? void 0 : event.stopPropagation();
        },
        height: "4rem",
        width: modalWidth,
        title: "Adicionar novo endere\xe7o",
        buttonText: "Adicionar novo endere\xe7o",
        AlternativeButtonText: "Voltar",
        buttonTextUnderAction: "Cadastrando endere\xe7o...",
        buttonFormId: "form-new-address",
        buttonType: "button",
        padding: isClientTabletXL ? "2rem" : "1.35rem 2rem",
        hasFooterShadow: true,
        hasFooter: false,
        hasBaseFooter: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAddNewAddressWrapper, {
            children: isMyAddress ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewFormAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formProps), {
                onCloseModal: function() {
                    handleStatusCloseModal(false);
                },
                onActionAfterCreateNewAddress: function() {
                    handleStatusCloseModal(false);
                    addToast({
                        isNewToast: true,
                        newToastTheme: "light",
                        type: "success",
                        title: "Endere\xe7o adicionado.",
                        description: "Seu endere\xe7o foi registrado com sucesso.",
                        timerInMilliseconds: 3000
                    });
                },
                onActionAfterEditAddress: function() {
                    handleStatusCloseModal(false);
                    addToast({
                        isNewToast: true,
                        newToastTheme: "light",
                        type: "success",
                        title: "Endere\xe7o alterado.",
                        description: "Parab\xe9ns, voc\xea concluiu sua altera\xe7\xe3o com sucesso.",
                        timerInMilliseconds: 3000
                    });
                }
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FormNewAddress, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formProps), {
                hasSpaceBottom: true,
                hasSpaceTop: true,
                onActionAfterCreateNewAddress: function() {
                    handleStatusCloseModal(false);
                    addToast({
                        type: "success",
                        title: "Seu endere\xe7o foi registrado com sucesso!",
                        timerInMilliseconds: 3000
                    });
                }
            }))
        })
    });
};


// EXTERNAL MODULE: ../../packages/components/ModalPasswordChange/index.tsx + 1 modules
var ModalPasswordChange = __webpack_require__(68546);
// EXTERNAL MODULE: ../../packages/components/ModalPasswordChanged/index.tsx + 1 modules
var ModalPasswordChanged = __webpack_require__(91285);
// EXTERNAL MODULE: ../../packages/components/NoOrders/index.tsx + 1 modules
var NoOrders = __webpack_require__(38677);
;// CONCATENATED MODULE: ../../packages/components/Notice/styles.ts

function Notice_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-left-width: ",
        ";\n  border-left-color: ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n\n  @media ",
        " {\n    padding: ",
        " ",
        ";\n  }\n"
    ]);
    Notice_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Notice_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    Notice_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Notice_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    Notice_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Notice_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    Notice_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Notice_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    Notice_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Notice_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Notice_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Notice_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Notice_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Notice_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  background-color: transparent;\n"
    ]);
    Notice_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var RevalidationMessageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RevalidationMessageContainer",
    componentId: "sc-5f884098-0"
})(Notice_styles_templateObject(), ui.theme.colors.yellow[650], ui.theme.space.x2, ui.theme.colors.yellow[650], ui.theme.colors.neutral.white, ui.theme.space.x2, "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x6, " ").concat(ui.theme.space.x2, "\n    ").concat(ui.theme.space.x2), ui.theme.device.mobileFirst.mobileL, ui.theme.space.x2, ui.theme.space.x4);
var styles_CloseButton = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__CloseButton",
    componentId: "sc-5f884098-1"
})(Notice_styles_templateObject1(), ui.theme.space.x6);
var MessageContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__MessageContainer",
    componentId: "sc-5f884098-2"
})(Notice_styles_templateObject2());
var IconAndTextContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__IconAndTextContainer",
    componentId: "sc-5f884098-3"
})(Notice_styles_templateObject3(), ui.theme.space.x2);
var WarningIconContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__WarningIconContainer",
    componentId: "sc-5f884098-4"
})(Notice_styles_templateObject4(), ui.theme.space.x6, ui.theme.space.x6);
var Warning = (0,styled_components_browser_esm/* default */.ZP)(ui.WarningRevalidationIcon).attrs({
    width: ui.theme.space.x6,
    height: ui.theme.space.x6
}).withConfig({
    displayName: "styles__Warning",
    componentId: "sc-5f884098-5"
})(Notice_styles_templateObject5());
var styles_CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.CloseIcon).attrs({
    width: ui.theme.space.x6,
    height: ui.theme.space.x6
}).withConfig({
    displayName: "styles__CloseIcon",
    componentId: "sc-5f884098-6"
})(Notice_styles_templateObject6());
var RevalidationMessage = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__RevalidationMessage",
    componentId: "sc-5f884098-7"
})(Notice_styles_templateObject7(), ui.theme.colors.neutral[550], function(param) {
    var fontSize = param.fontSize;
    return fontSize || ui.theme.typography.fontSize.sm.x7;
}, ui.theme.typography.fontWeight[400]);

;// CONCATENATED MODULE: ../../packages/components/Notice/index.tsx





var Notice = function(param) {
    var text = param.text, handleShowRevalidationMessage = param.handleShowRevalidationMessage, fontSize = param.fontSize, _hasCloseButton = param.hasCloseButton, hasCloseButton = _hasCloseButton === void 0 ? true : _hasCloseButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RevalidationMessageContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("revalidation-message-container")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("revalidation-message")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconAndTextContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("revalidation-message-icon-and-text")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIconContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("revalidation-message-warning-icon")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning, {
                                alt: "aten\xe7\xe3o"
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RevalidationMessage, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            fontSize: fontSize
                        }, (0,application/* buildTestIds */.Fek)("revalidation-message-text")), {
                            children: text
                        }))
                    ]
                })),
                hasCloseButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CloseButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("revalidation-message-close-button")), {
                    onClick: function() {
                        if (handleShowRevalidationMessage) handleShowRevalidationMessage(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CloseIcon, {})
                }))
            ]
        }))
    }));
};

// EXTERNAL MODULE: ../../packages/components/Paginator/index.tsx + 1 modules
var Paginator = __webpack_require__(49926);
// EXTERNAL MODULE: ../../packages/components/PasswordValidation/index.tsx + 1 modules
var PasswordValidation = __webpack_require__(4043);
// EXTERNAL MODULE: ../../packages/infra/components/index.ts + 234 modules
var components = __webpack_require__(62911);
;// CONCATENATED MODULE: ../../packages/components/patterns/Carousel/ArrowNextButton/style.ts

function ArrowNextButton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      pointer-events: none;\n      opacity: 0.5;\n    "
    ]);
    ArrowNextButton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArrowNextButton_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  top: calc(50% - 25px);\n  bottom: 0px;\n  right: 64px;\n  border-radius: 50%;\n  border: none;\n  outline: none;\n  height: 60px;\n  width: 60px;\n  background-color: ",
        " !important;\n  opacity: 1 !important;\n  box-shadow: 0 2px 2px 0 ",
        ";\n  z-index: 5;\n  -webkit-tap-highlight-color: transparent !important;\n\n  &:hover {\n    background-color: ",
        ' !important;\n    :before {\n      content: "";\n      width: 13px;\n      height: 13px;\n      border: 3px solid ',
        ";\n      border-radius: 2px;\n      display: block;\n      position: absolute;\n      top: 21px;\n      right: 25px;\n      border-top: 0;\n      border-right: 0;\n      transform: rotate(-135deg);\n      transition: all 0.3s ease-in-out;\n    }\n  }\n\n  transition: background-color 0.2s;\n\n  ",
        ";\n\n  @media ",
        ' {\n    right: 16px;\n  }\n\n  :before {\n    content: "";\n    width: 13px;\n    height: 13px;\n    border: 3px solid ',
        ";\n    border-radius: 2px;\n    display: block;\n    position: absolute;\n    top: 21px;\n    right: 25px;\n    border-top: 0;\n    border-right: 0;\n    transform: rotate(-135deg);\n    transition: all 0.3s ease-in-out;\n  }\n"
    ]);
    ArrowNextButton_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var style_ArrowNext = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__ArrowNext",
    componentId: "sc-6f93d73c-0"
})(ArrowNextButton_style_templateObject1(), ui.theme.colors.neutral.white, ui.theme.colors.neutral["999-opacity-10"], ui.theme.colors.primary[200], ui.theme.colors.neutral.white, function(param) {
    var hasNext = param.hasNext;
    return !hasNext && (0,styled_components_browser_esm/* css */.iv)(ArrowNextButton_style_templateObject());
}, ui.theme.device.desktopFirst.laptopL, ui.theme.colors.neutral[450]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Carousel/ArrowNextButton/index.tsx


var ArrowNextButton_ArrowNextButton = function(param) {
    var hasNext = param.hasNext, clickHandler = param.clickHandler, showArrows = param.showArrows;
    if (!showArrows) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ArrowNext, {
        "aria-label": "Passar",
        hasNext: hasNext,
        onClick: function(event) {
            clickHandler();
            event === null || event === void 0 ? void 0 : event.stopPropagation();
            event === null || event === void 0 ? void 0 : event.preventDefault();
        }
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Carousel/ArrowPrevButton/style.ts

function ArrowPrevButton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      pointer-events: none;\n      opacity: 0.5;\n    "
    ]);
    ArrowPrevButton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArrowPrevButton_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  top: calc(50% - 25px);\n  bottom: 0px;\n  left: 64px;\n  border-radius: 50%;\n  border: none;\n  outline: none;\n  height: 60px;\n  width: 60px;\n  background-color: ",
        " !important;\n  opacity: 1 !important;\n  box-shadow: 0 2px 2px 0 ",
        ";\n  z-index: 5;\n  -webkit-tap-highlight-color: transparent !important;\n\n  &:hover {\n    background-color: ",
        ' !important;\n    :before {\n      content: "";\n      width: 13px;\n      height: 13px;\n      border: 3px solid ',
        ";\n      border-radius: 2px;\n      display: block;\n      position: absolute;\n      top: 21px;\n      left: 25px;\n      border-top: 0;\n      border-right: 0;\n      transform: rotate(45deg);\n      transition: all 0.3s ease-in-out;\n    }\n  }\n\n  transition: background-color 0.2s;\n\n  ",
        ";\n\n  @media ",
        ' {\n    left: 16px;\n  }\n\n  :before {\n    content: "";\n    width: 13px;\n    height: 13px;\n    border: 3px solid ',
        ";\n    border-radius: 2px;\n    display: block;\n    position: absolute;\n    top: 21px;\n    left: 25px;\n    border-top: 0;\n    border-right: 0;\n    transform: rotate(45deg);\n    transition: all 0.3s ease-in-out;\n  }\n"
    ]);
    ArrowPrevButton_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var style_ArrowPrev = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__ArrowPrev",
    componentId: "sc-e8bcf25b-0"
})(ArrowPrevButton_style_templateObject1(), ui.theme.colors.neutral.white, ui.theme.colors.neutral["999-opacity-10"], ui.theme.colors.primary[200], ui.theme.colors.neutral.white, function(param) {
    var hasPrev = param.hasPrev;
    return !hasPrev && (0,styled_components_browser_esm/* css */.iv)(ArrowPrevButton_style_templateObject());
}, ui.theme.device.desktopFirst.laptopL, ui.theme.colors.neutral[450]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Carousel/ArrowPrevButton/index.tsx


var ArrowPrevButton_ArrowPrevButton = function(param) {
    var hasPrev = param.hasPrev, clickHandler = param.clickHandler, showArrows = param.showArrows;
    if (!showArrows) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ArrowPrev, {
        "aria-label": "Voltar",
        hasPrev: hasPrev,
        onClick: function(event) {
            clickHandler();
            event === null || event === void 0 ? void 0 : event.stopPropagation();
            event === null || event === void 0 ? void 0 : event.preventDefault();
        }
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Carousel/index.tsx







var Carousel = function(_param) {
    var children = _param.children, showArrows = _param.showArrows, props = _object_without_properties(_param, [
        "children",
        "showArrows"
    ]);
    return /*#__PURE__*/ _jsx(ReactResponsiveCarousel, _object_spread_props(_object_spread({}, props), {
        showArrows: showArrows,
        transitionTime: 400,
        interval: 3500,
        renderArrowPrev: function(clickHandler, hasPrev) {
            return /*#__PURE__*/ _jsx(ArrowPrevButton, {
                hasPrev: hasPrev,
                clickHandler: clickHandler,
                showArrows: !!showArrows
            });
        },
        renderArrowNext: function(clickHandler, hasNext) {
            return /*#__PURE__*/ _jsx(ArrowNextButton, {
                hasNext: hasNext,
                clickHandler: clickHandler,
                showArrows: !!showArrows
            });
        },
        children: children
    }));
};


// EXTERNAL MODULE: ../../packages/components/patterns/Divider/styles.ts
var Divider_styles = __webpack_require__(64492);
;// CONCATENATED MODULE: ../../packages/components/patterns/Divider/index.tsx



// EXTERNAL MODULE: ../../packages/components/patterns/FilterProducts/index.tsx + 6 modules
var FilterProducts = __webpack_require__(93884);
// EXTERNAL MODULE: ../../packages/application/context/state.tsx + 1 modules
var state = __webpack_require__(14366);
;// CONCATENATED MODULE: ../../packages/components/CategoryBlock/style.ts

function CategoryBlock_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    CategoryBlock_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryBlock_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin: ",
        ";\n  ",
        "\n  ",
        "\n  text-align: ",
        ";\n"
    ]);
    CategoryBlock_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategoryBlock_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin: ",
        ";\n  ",
        "\n  ",
        "\n  text-align: ",
        ";\n"
    ]);
    CategoryBlock_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Wrapper",
    componentId: "sc-b73e1bf2-0"
})(CategoryBlock_style_templateObject(), function(param) {
    var width = param.width;
    return width || ui.theme.space["x1/1"];
}, function(param) {
    var height = param.height;
    return height || ui.theme.space["x1/1"];
});
var CategoryBlockTitle = (0,styled_components_browser_esm/* default */.ZP)(ui.H2).withConfig({
    displayName: "style__CategoryBlockTitle",
    componentId: "sc-b73e1bf2-1"
})(CategoryBlock_style_templateObject1(), function(param) {
    var fontSize = param.fontSize;
    return fontSize || ui.theme.typography.fontSize.sm.x5;
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight || ui.theme.typography.fontWeight.normal;
}, function(param) {
    var margin = param.margin;
    return margin || "".concat(ui.theme.space["x2.5"], " ").concat(ui.theme.space.x0, " ").concat(ui.theme.space.x2);
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var fontFamily = param.fontFamily;
    return fontFamily && "font-family: ".concat(fontFamily, ";");
}, function(param) {
    var textAlign = param.textAlign;
    return textAlign || "start";
});
var CategoryBlockSubTitle = (0,styled_components_browser_esm/* default */.ZP)(ui.H3).withConfig({
    displayName: "style__CategoryBlockSubTitle",
    componentId: "sc-b73e1bf2-2"
})(CategoryBlock_style_templateObject2(), function(param) {
    var fontSize = param.fontSize;
    return fontSize || ui.theme.typography.fontSize.sm.x5;
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight || ui.theme.typography.fontWeight.normal;
}, function(param) {
    var margin = param.margin;
    return margin || "".concat(ui.theme.space["x2.5"], " ").concat(ui.theme.space.x0, " ").concat(ui.theme.space.x2);
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var fontFamily = param.fontFamily;
    return fontFamily && "font-family: ".concat(fontFamily, ";");
}, function(param) {
    var textAlign = param.textAlign;
    return textAlign || "start";
});

;// CONCATENATED MODULE: ../../packages/components/CategoryBlock/index.tsx





var CategoryBlock = function(param) {
    var _category = param.category, title = _category.title, data = _category.categories, level = param.level, isLoading = param.isLoading, isBlackTheme = param.isBlackTheme;
    var backgroundColor = isBlackTheme ? ui.theme.colors.blackFriday[175] : ui.theme.colors.neutral["white-050"];
    var jsxElement = null;
    switch(level){
        case 1:
            {
                jsxElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Title, {
                    fontSize: ui.theme.typography.fontSize.sm.x5,
                    children: title
                }, title);
                break;
            }
        case 2:
        case 3:
            {
                jsxElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                    width: "18%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Aggregator, {
                        background: backgroundColor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryBlockTitle, {
                                fontSize: ui.theme.typography.fontSize.sm.x5,
                                fontWeight: ui.theme.typography.fontWeight[600],
                                color: isBlackTheme ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[520],
                                margin: "0px 0px 20px",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Aggregator, {
                                background: backgroundColor,
                                children: (data === null || data === void 0 ? void 0 : data.length) ? data.map(function(param) {
                                    var id = param.id, innerCategoryTitle = param.title, descriptionUrl = param.descriptionUrl;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, {
                                        fontSize: ui.theme.typography.fontSize.sm.x3,
                                        fontWeight: ui.theme.typography.fontWeight[500],
                                        margin: "10px 0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            href: "/".concat(descriptionUrl),
                                            target: "_self",
                                            fontSize: ui.theme.typography.fontSize.sm.x3,
                                            color: isBlackTheme ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[999],
                                            mouseOver: {
                                                color: ui.theme.colors.primary[200]
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryBlockSubTitle, {
                                                children: innerCategoryTitle
                                            })
                                        })
                                    }, id);
                                }) : isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
                                    count: 10
                                }) : null
                            })
                        ]
                    }, title)
                });
                break;
            }
        default:
            {
                break;
            }
    }
    return jsxElement;
};
/* harmony default export */ var components_CategoryBlock = (CategoryBlock);

;// CONCATENATED MODULE: ../../packages/components/patterns/SupportContact/styles.ts

function SupportContact_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    SupportContact_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SupportContact_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    SupportContact_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SupportContact_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    SupportContact_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SupportContact_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    SupportContact_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SupportContactTitle = (0,styled_components_browser_esm/* default */.ZP)(ui.H2).withConfig({
    displayName: "styles__SupportContactTitle",
    componentId: "sc-895d5975-0"
})(SupportContact_styles_templateObject1(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(SupportContact_styles_templateObject(), ui.theme.colors.neutral.white);
});
var SupportContactText = (0,styled_components_browser_esm/* default */.ZP)(ui.Text).withConfig({
    displayName: "styles__SupportContactText",
    componentId: "sc-895d5975-1"
})(SupportContact_styles_templateObject3(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(SupportContact_styles_templateObject2(), ui.theme.colors.neutral.white);
});

;// CONCATENATED MODULE: ../../packages/components/patterns/SupportContact/utils.ts
var getAriaLabel = function(iconTitle) {
    var socialMediaLabels = {
        instagram: "Link do Instagram",
        facebook: "Link do Facebook",
        twitter: "Link do Twitter",
        linkedin: "Link do LinkedIn",
        pinterest: "Link do Pinterest",
        spotify: "Link do Spotify",
        youtube: "Link do YouTube"
    };
    return socialMediaLabels[iconTitle] || "Link das redes sociais";
};

;// CONCATENATED MODULE: ../../packages/components/patterns/SupportContact/index.tsx













var SupportContact = function(param) {
    var isBlackTheme = param.isBlackTheme;
    var ref = (0,react.useState)({
        data: null,
        isLoading: true,
        error: false
    }), options = ref[0], setOptions = ref[1];
    (0,react.useEffect)(function() {
        var getOptions = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                implementations/* supportContactApi.getOptions */.Mq.getOptions()
                            ];
                        case 1:
                            response = _state.sent();
                            setOptions(response);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getOptions() {
                return _ref.apply(this, arguments);
            };
        }();
        getOptions();
    }, []);
    var data = options.data, isLoading = options.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Aggregator, {
        id: "support-contact-container",
        "data-testid": "support-contact-container",
        display: "flex",
        flexDirection: "row",
        alignItems: "start",
        justifyContent: "start",
        border: isBlackTheme ? "1px solid ".concat(ui.theme.colors.neutral[750]) : "1px solid ".concat(ui.theme.colors.neutral[100]),
        borderRadius: isBlackTheme ? ui.theme.space.x4 : ui.theme.space.x1,
        padding: ui.theme.space.x6,
        tablet: {
            padding: "0",
            alignItems: "start"
        },
        mobile: {
            display: "flex",
            flexDirection: "column",
            alignItems: "start"
        },
        children: data ? data.map(function(param, index) {
            var mainIcon = param.mainIcon, title = param.title, description = param.description, link = param.link, secondaryIcons = param.secondaryIcons;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ui.Desk, {
                alignItems: "start",
                hasRightBorder: index !== data.length - 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.DeskInfo, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.IconWrapper, {
                            color: isBlackTheme ? ui.theme.colors.secondary[230] : ui.theme.colors.secondary[300],
                            width: "60px",
                            height: "60px",
                            children: (0,ui.mappedIcons)(mainIcon === null || mainIcon === void 0 ? void 0 : mainIcon.title, {
                                color: ui.theme.colors.neutral.white
                            }, {
                                secondColor: ui.theme.colors.neutral.white
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.DeskInfo, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportContactTitle, {
                                isBlackTheme: !!isBlackTheme,
                                children: title
                            }),
                            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportContactText, {
                                isBlackTheme: !!isBlackTheme,
                                children: description
                            }),
                            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                fontWeight: "".concat(ui.theme.typography.fontWeight[400]),
                                color: isBlackTheme ? ui.theme.colors.secondary[230] : ui.theme.colors.primary[200],
                                href: link === null || link === void 0 ? void 0 : link.href
                            }, (0,application/* buildTestIds */.Fek)("support-contact-link-".concat(title))), {
                                children: link === null || link === void 0 ? void 0 : link.title
                            })),
                            (secondaryIcons === null || secondaryIcons === void 0 ? void 0 : secondaryIcons.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Aggregator, {
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "start",
                                margin: "".concat(ui.theme.space.x3, " 0 0"),
                                gap: "8px",
                                children: secondaryIcons === null || secondaryIcons === void 0 ? void 0 : secondaryIcons.map(function(param) {
                                    var iconTitle = param.title, iconLink = param.link;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.IconWrapper, {
                                        marginRight: "0px",
                                        width: ui.theme.space.x7,
                                        height: ui.theme.space.x7,
                                        color: "transparent",
                                        borderRadius: ui.theme.space.x1,
                                        clickable: true,
                                        isBlackTheme: !!isBlackTheme,
                                        mouseOverColor: ui.theme.colors.primary[200],
                                        lineHeight: "5px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            href: iconLink || "",
                                            "aria-label": getAriaLabel(iconTitle),
                                            children: (0,ui.mappedIcons)(iconTitle, {
                                                color: ui.theme.colors.neutral[280]
                                            }, {
                                                secondColor: ui.theme.colors.neutral[280]
                                            })
                                        })
                                    }, iconLink);
                                })
                            })
                        ]
                    })
                ]
            }, title);
        }) : isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
            type: "card",
            count: 3,
            width: ui.theme.space.x96,
            height: ui.theme.space.x24
        }) : null
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/SupportContact/mobile/index.tsx
/* eslint-disable react/no-array-index-key */ 











var SupportContactMobile = function(param) {
    var isBlackTheme = param.isBlackTheme;
    var ref = (0,react.useState)({
        data: null,
        isLoading: true,
        error: false
    }), options = ref[0], setOptions = ref[1];
    (0,react.useEffect)(function() {
        var getOptions = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                implementations/* supportContactApi.getOptions */.Mq.getOptions()
                            ];
                        case 1:
                            response = _state.sent();
                            setOptions(response);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getOptions() {
                return _ref.apply(this, arguments);
            };
        }();
        getOptions();
    }, []);
    var data = options.data, isLoading = options.isLoading;
    if (!data) {
        return null;
    }
    var settings = {
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchMove: true,
        swipe: true,
        dots: true,
        autoplay: true,
        infinite: true
    };
    return isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
        count: 3
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, settings), {
        children: data === null || data === void 0 ? void 0 : data.map(function(param) {
            var mainIcon = param.mainIcon, title = param.title, description = param.description, link = param.link, secondaryIcons = param.secondaryIcons;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Aggregator, {
                justifyContent: "center",
                display: "flex",
                alignItems: "start",
                padding: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x8, " ").concat(ui.theme.space.x8),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.DeskInfo, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.IconWrapper, {
                            color: isBlackTheme ? ui.theme.colors.secondary[230] : ui.theme.colors.secondary[300],
                            width: "75px",
                            height: "75px",
                            children: (0,ui.mappedIcons)(mainIcon === null || mainIcon === void 0 ? void 0 : mainIcon.title, {
                                color: ui.theme.colors.neutral.white
                            }, {
                                secondColor: ui.theme.colors.neutral.white
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.DeskInfo, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportContactTitle, {
                                isBlackTheme: !!isBlackTheme,
                                children: title
                            }),
                            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportContactText, {
                                isBlackTheme: !!isBlackTheme,
                                children: description
                            }),
                            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                color: isBlackTheme ? ui.theme.colors.secondary[230] : ui.theme.colors.primary[200],
                                href: link === null || link === void 0 ? void 0 : link.href,
                                children: link === null || link === void 0 ? void 0 : link.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Aggregator, {
                                display: "flex",
                                flexDirection: "row",
                                margin: "".concat(ui.theme.space.x4, " 0 0"),
                                gap: "8px",
                                children: secondaryIcons === null || secondaryIcons === void 0 ? void 0 : secondaryIcons.map(function(param) {
                                    var iconTitle = param.title, iconLink = param.link;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.IconWrapper, {
                                        width: ui.theme.space.x6,
                                        height: ui.theme.space.x6,
                                        color: "transparent",
                                        borderRadius: ui.theme.space.x1,
                                        clickable: true,
                                        marginRight: "0px",
                                        isBlackTheme: !!isBlackTheme,
                                        mouseOverColor: ui.theme.colors.primary[200],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            href: iconLink || "",
                                            "aria-label": iconTitle,
                                            children: (0,ui.mappedIcons)(iconTitle, {
                                                color: ui.theme.colors.neutral[280]
                                            }, {
                                                secondColor: ui.theme.colors.neutral[280]
                                            })
                                        })
                                    }, iconLink);
                                })
                            })
                        ]
                    })
                ]
            }, title);
        })
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/UtilInfo/Option/styles.ts

function Option_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    Option_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Option_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Option_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var UtilInfoOptionContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.Aggregator).withConfig({
    displayName: "styles__UtilInfoOptionContainer",
    componentId: "sc-10dd90d0-0"
})(Option_styles_templateObject(), ui.theme.colors.neutral.white);
var ImageInfoOptionContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.Aggregator).withConfig({
    displayName: "styles__ImageInfoOptionContainer",
    componentId: "sc-10dd90d0-1"
})(Option_styles_templateObject1());

;// CONCATENATED MODULE: ../../packages/components/patterns/UtilInfo/Option/index.tsx









var UtilInfoOption = function(param) {
    var optionTitle = param.title, optionLink = param.link, optionImages = param.images, isBlackTheme = param.isBlackTheme;
    var isClientMobile = (0,state/* useAppContext */.b)().isClientMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UtilInfoOptionContainer, {
        "data-testid": "util-info-option-".concat(optionTitle),
        "data-cy": "util-info-option-".concat(optionTitle),
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: ui.theme.space["x3.5"],
        margin: "".concat(ui.theme.space.x4, " ").concat(ui.theme.space.x0, " ").concat(ui.theme.space.x0),
        mobile: {
            margin: "".concat(ui.theme.space.x4, " ").concat(ui.theme.space.x0)
        },
        tablet: {
            margin: "".concat(ui.theme.space.x4, " ").concat(ui.theme.space.x0)
        },
        laptop: {
            margin: "".concat(ui.theme.space.x4, " ").concat(ui.theme.space.x0)
        },
        children: [
            optionLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-link-".concat(optionTitle))), {
                href: optionLink === null || optionLink === void 0 ? void 0 : optionLink.href,
                fontSize: isClientMobile ? ui.theme.typography.fontSize.sm.x5 : ui.theme.typography.fontSize.sm.x3,
                color: isBlackTheme ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[999],
                mouseOver: {
                    color: ui.theme.colors.primary[200]
                },
                children: optionLink === null || optionLink === void 0 ? void 0 : optionLink.title
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, {
                fontSize: ui.theme.typography.fontSize.sm.x3,
                color: isBlackTheme ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[520],
                margin: ui.theme.space.x0,
                "data-cy": "footer-payment-option-title-".concat(optionTitle),
                children: optionTitle
            }),
            (optionImages === null || optionImages === void 0 ? void 0 : optionImages.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageInfoOptionContainer, {
                display: "flex",
                gap: ui.theme.space.x1,
                mobile: {
                    margin: "".concat(ui.theme.space.x1, " ").concat(ui.theme.space.x0)
                },
                children: optionImages === null || optionImages === void 0 ? void 0 : optionImages.map(function(param) {
                    var src = param.src, alt = param.alt, width = param.width, height = param.height, _layout = param.layout, layout = _layout === void 0 ? "fixed" : _layout;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* Image */.E, {
                        src: src,
                        alt: alt,
                        width: width,
                        height: height,
                        layout: layout
                    }, src);
                })
            })
        ]
    }, optionTitle);
};
/* harmony default export */ var Option = (UtilInfoOption);

;// CONCATENATED MODULE: ../../packages/components/patterns/UtilInfo/LinkOptions/style.ts

function LinkOptions_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin: 0;\n  ",
        "\n  ",
        "\n\n    @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    LinkOptions_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var LinkOptionsTitle = (0,styled_components_browser_esm/* default */.ZP)(ui.H2).withConfig({
    displayName: "style__LinkOptionsTitle",
    componentId: "sc-104f8638-0"
})(LinkOptions_style_templateObject(), function(param) {
    var fontSize = param.fontSize;
    return fontSize || ui.theme.typography.fontSize.sm.x9;
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight && "font-weight: ".concat(fontWeight, ";");
}, ui.theme.device.desktopFirst.tablet, function(param) {
    var fontSize = param.fontSize;
    return fontSize || ui.theme.typography.fontSize.sm.x7;
});

;// CONCATENATED MODULE: ../../packages/components/patterns/UtilInfo/LinkOptions/index.tsx











var iconsColor = function(icon, isBlackFridayTheme) {
    return isBlackFridayTheme ? ui.theme.colors.neutral.white : (icon === null || icon === void 0 ? void 0 : icon.color) || undefined;
};
var UtilInfoLinkOptions = function(param) {
    var isBlackTheme = param.isBlackTheme;
    var getBranchLocationClient = (0,application/* useBranchLocation */.vKz)().getBranchLocationClient;
    var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
        return state.allConfigs;
    });
    var ref = (0,react.useState)({
        data: null,
        isLoading: true,
        error: false
    }), linkOptions = ref[0], setLinkOptions = ref[1];
    (0,react.useEffect)(function() {
        var getLinkOptions = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var isBranchJPA, response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            isBranchJPA = getBranchLocationClient() === "6";
                            return [
                                4,
                                implementations/* utilInfoApi.getLinkOptions */.w.getLinkOptions(isBranchJPA, (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isBlackFridayOffersAvailable) === "true")
                            ];
                        case 1:
                            response = _state.sent();
                            setLinkOptions(response);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getLinkOptions() {
                return _ref.apply(this, arguments);
            };
        }();
        getLinkOptions();
    }, [
        allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isBlackFridayOffersAvailable,
        getBranchLocationClient
    ]);
    return (linkOptions === null || linkOptions === void 0 ? void 0 : linkOptions.data) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: linkOptions.data.map(function(param) {
            var title = param.title, icon = param.icon, options = param.options;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui.Column, {
                md: "4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Desk, {
                    hasRightBorder: false,
                    alignItems: "start",
                    gap: ui.theme.space.x4,
                    padding: "0 10px",
                    children: [
                        icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.DeskInfo, {
                            children: (0,ui.mappedIcons)(icon === null || icon === void 0 ? void 0 : icon.title, {
                                width: (icon === null || icon === void 0 ? void 0 : icon.width) ? Number(icon.width) : undefined,
                                height: (icon === null || icon === void 0 ? void 0 : icon.height) ? Number(icon.height) : undefined,
                                color: iconsColor(icon, isBlackTheme)
                            }, {
                                secondColor: iconsColor(icon, isBlackTheme)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.DeskInfo, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOptionsTitle, {
                                    color: isBlackTheme ? ui.theme.colors.neutral.white : "initial",
                                    fontSize: ui.theme.typography.fontSize.sm.x5,
                                    children: title
                                }),
                                (options === null || options === void 0 ? void 0 : options.length) && (options === null || options === void 0 ? void 0 : options.map(function(option) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Option, (0,src_object_spread/* default */.Z)({
                                        isBlackTheme: !!isBlackTheme
                                    }, option), option === null || option === void 0 ? void 0 : option.title);
                                }))
                            ]
                        })
                    ]
                })
            }, title);
        })
    }) : (linkOptions === null || linkOptions === void 0 ? void 0 : linkOptions.isLoading) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
        count: 5,
        height: ui.theme.space.x4
    }) : null;
};
/* harmony default export */ var LinkOptions = (UtilInfoLinkOptions);

;// CONCATENATED MODULE: ../../packages/components/patterns/UtilInfo/LinkOptions/mobile/List/index.tsx






var List_iconsColor = function(icon, isBlackFridayTheme) {
    return isBlackFridayTheme ? ui.theme.colors.neutral.white : (icon === null || icon === void 0 ? void 0 : icon.color) || undefined;
};
var UtilInfoLinkOptionMobileList = function(param) {
    var title = param.title, icon = param.icon, options = param.options, isBlackTheme = param.isBlackTheme;
    var ref = (0,react.useState)(false), titleClicked = ref[0], setTitleClicked = ref[1];
    var toggleTitleClicked = function() {
        setTitleClicked(function(state) {
            return !state;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Row, {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "data-cy": "footer-options-title-clicked-".concat(icon === null || icon === void 0 ? void 0 : icon.title),
                    onClick: toggleTitleClicked,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                            xs: "11",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.FlexContainer, {
                                gap: ui.theme.space.x4,
                                alignItems: "center",
                                children: [
                                    icon && (0,ui.mappedIcons)(icon === null || icon === void 0 ? void 0 : icon.title, {
                                        width: (icon === null || icon === void 0 ? void 0 : icon.width) ? Number(icon.width) : undefined,
                                        height: (icon === null || icon === void 0 ? void 0 : icon.height) ? Number(icon.height) : undefined,
                                        color: List_iconsColor(icon, isBlackTheme)
                                    }, {
                                        secondColor: List_iconsColor(icon, isBlackTheme)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportContactTitle, {
                                        isBlackTheme: isBlackTheme,
                                        fontSize: ui.theme.typography.fontSize.sm.x5,
                                        fontWeight: ui.theme.typography.fontWeight[400],
                                        children: title
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                            xs: "1",
                            children: titleClicked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowUp, {
                                color: isBlackTheme ? ui.theme.colors.neutral.white : "initial"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowDown, {
                                color: isBlackTheme ? ui.theme.colors.neutral.white : "initial"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Accordion, {
                show: titleClicked,
                maxHeight: ui.theme.space.x160,
                "data-cy": "footer-wrapper-".concat(icon === null || icon === void 0 ? void 0 : icon.title),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, {
                    "data-cy": "footer-option-title-".concat(icon === null || icon === void 0 ? void 0 : icon.title),
                    margin: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x11),
                    children: (options === null || options === void 0 ? void 0 : options.length) && options.map(function(option) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, (0,src_object_spread/* default */.Z)({
                            isBlackTheme: isBlackTheme
                        }, option), option.title);
                    })
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/UtilInfo/LinkOptions/mobile/index.tsx











var UtilInfoLinkOptionsMobile = function(param) {
    var isBlackTheme = param.isBlackTheme;
    var ref;
    var getBranchLocationClient = (0,application/* useBranchLocation */.vKz)().getBranchLocationClient;
    var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
        return state.allConfigs;
    });
    var ref1 = (0,react.useState)({
        data: null,
        isLoading: true,
        error: false
    }), linkOptions = ref1[0], setLinkOptions = ref1[1];
    (0,react.useEffect)(function() {
        var getLinkOptions = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var isBranchJPA, response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            isBranchJPA = getBranchLocationClient() === "6";
                            return [
                                4,
                                implementations/* utilInfoApi.getLinkOptions */.w.getLinkOptions(isBranchJPA, (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isBlackFridayOffersAvailable) === "true")
                            ];
                        case 1:
                            response = _state.sent();
                            setLinkOptions(response);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getLinkOptions() {
                return _ref.apply(this, arguments);
            };
        }();
        getLinkOptions();
    }, [
        getBranchLocationClient,
        allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isBlackFridayOffersAvailable
    ]);
    return (linkOptions === null || linkOptions === void 0 ? void 0 : linkOptions.isLoading) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
        count: 5,
        height: ui.theme.space.x4
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, {
        children: linkOptions === null || linkOptions === void 0 ? void 0 : (ref = linkOptions.data) === null || ref === void 0 ? void 0 : ref.map(function(linkOption) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui.Column, {
                xs: "12",
                "data-cy": "util-info-link-options-mobile",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    borderColor: isBlackTheme ? ui.theme.colors.blackFriday[210] : ui.theme.colors.neutral[100],
                    padding: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x4)
                }, (linkOption === null || linkOption === void 0 ? void 0 : linkOption.style) && linkOption.style), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilInfoLinkOptionMobileList, (0,src_object_spread/* default */.Z)({
                        isBlackTheme: isBlackTheme
                    }, linkOption))
                }))
            }, linkOption === null || linkOption === void 0 ? void 0 : linkOption.title);
        })
    });
};
/* harmony default export */ var mobile = (UtilInfoLinkOptionsMobile);

;// CONCATENATED MODULE: ../../packages/components/patterns/UtilInfo/PaymentOptions/styles.ts

function PaymentOptions_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PaymentOptions_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PaymentOptions_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: ",
        ";\n\n  @media ",
        " {\n    flex-wrap: wrap;\n    gap: ",
        ";\n  }\n"
    ]);
    PaymentOptions_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PaymentOptions_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    PaymentOptions_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PaymentOptions_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PaymentOptions_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var FooterIconAndTitleContent = (0,styled_components_browser_esm/* default */.ZP)(ui.Column).withConfig({
    displayName: "styles__FooterIconAndTitleContent",
    componentId: "sc-520d83aa-0"
})(PaymentOptions_styles_templateObject());
var WrapperUtilInfoOption = (0,styled_components_browser_esm/* default */.ZP)(ui.Column).withConfig({
    displayName: "styles__WrapperUtilInfoOption",
    componentId: "sc-520d83aa-1"
})(PaymentOptions_styles_templateObject1(), ui.theme.space.x8, ui.theme.device.desktopFirst.mobileM, ui.theme.space.x0);
var PaymentOptionsTitle = (0,styled_components_browser_esm/* default */.ZP)(ui.H2).withConfig({
    displayName: "styles__PaymentOptionsTitle",
    componentId: "sc-520d83aa-2"
})(PaymentOptions_styles_templateObject2(), function(param) {
    var fontSize = param.fontSize;
    return fontSize || ui.theme.typography.fontSize.sm.x9;
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight && "font-weight: ".concat(fontWeight, ";");
}, ui.theme.device.desktopFirst.tablet, function(param) {
    var fontSize = param.fontSize;
    return fontSize || ui.theme.typography.fontSize.sm.x7;
});
var PaymentOptionsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PaymentOptionsWrapper",
    componentId: "sc-520d83aa-3"
})(PaymentOptions_styles_templateObject3());

;// CONCATENATED MODULE: ../../packages/components/patterns/UtilInfo/PaymentOptions/index.tsx











var UtilInfoPaymentOptions = function(param) {
    var isBlackTheme = param.isBlackTheme;
    var ref;
    var isClientLaptop = (0,state/* useAppContext */.b)().isClientLaptop;
    var ref1 = (0,react.useState)({
        data: null,
        isLoading: true,
        error: false
    }), paymentOptions = ref1[0], setPaymentOptions = ref1[1];
    var marginSpaceWrapper = function() {
        return isClientLaptop ? "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x2) : "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0);
    };
    var paddingSpaceWrapper = function() {
        return isClientLaptop ? "".concat(ui.theme.space.x6, " ").concat(ui.theme.space.x0, " ").concat(ui.theme.space.x0) : "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x2);
    };
    (0,react.useEffect)(function() {
        var getPaymentOptions = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                implementations/* utilInfoApi.getPaymentOptions */.w.getPaymentOptions()
                            ];
                        case 1:
                            response = _state.sent();
                            setPaymentOptions(response);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getPaymentOptions() {
                return _ref.apply(this, arguments);
            };
        }();
        getPaymentOptions();
    }, []);
    var paymentOptionsColor = function(title) {
        return isBlackTheme ? ui.theme.colors.neutral.white : title === "Formas de pagamento" ? ui.theme.colors.neutral[520] : ui.theme.colors.neutral[999];
    };
    return (paymentOptions === null || paymentOptions === void 0 ? void 0 : paymentOptions.isLoading) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
        count: 4,
        height: ui.theme.space.x4
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOptionsWrapper, {
        children: paymentOptions === null || paymentOptions === void 0 ? void 0 : (ref = paymentOptions.data) === null || ref === void 0 ? void 0 : ref.map(function(param) {
            var title = param.title, icon = param.icon, options = param.options;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, {
                margin: marginSpaceWrapper(),
                padding: paddingSpaceWrapper(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Container, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Row, {
                        alignItems: "start",
                        gap: ui.theme.space.x4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterIconAndTitleContent, {
                                children: [
                                    icon && (0,ui.mappedIcons)(icon === null || icon === void 0 ? void 0 : icon.title, (0,src_object_spread/* default */.Z)({}, icon), (0,src_object_spread/* default */.Z)({}, icon)),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOptionsTitle, {
                                        color: paymentOptionsColor(title),
                                        fontSize: ui.theme.typography.fontSize.sm.x5,
                                        children: title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperUtilInfoOption, {
                                display: "flex",
                                flexDirection: isClientLaptop ? "row" : "column",
                                isPayment: true,
                                children: (options === null || options === void 0 ? void 0 : options.length) && options.map(function(option) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Option, (0,src_object_spread/* default */.Z)({
                                        isBlackTheme: !!isBlackTheme
                                    }, option), option === null || option === void 0 ? void 0 : option.title);
                                })
                            })
                        ]
                    })
                })
            }, title);
        })
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/UtilInfo/style.ts

function UtilInfo_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    max-width: 100%;\n    padding: 0;\n  }\n\n  @media ",
        " {\n    max-width: 100%;\n    padding: 0;\n  }\n"
    ]);
    UtilInfo_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UtilInfo_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    UtilInfo_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UtilInfo_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"
    ]);
    UtilInfo_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var UtilInfoContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.Container).withConfig({
    displayName: "style__UtilInfoContainer",
    componentId: "sc-fa1e4cea-0"
})(UtilInfo_style_templateObject(), ui.theme.device.desktopFirst.mobileM, ui.theme.device.desktopFirst.mobileS);
var UtilInfoPaymentOptionsWrapper = (0,styled_components_browser_esm/* default */.ZP)(ui.Column).attrs({
    lg: "6",
    xs: "12"
}).withConfig({
    displayName: "style__UtilInfoPaymentOptionsWrapper",
    componentId: "sc-fa1e4cea-1"
})(UtilInfo_style_templateObject1());
var UtilInfoContent = (0,styled_components_browser_esm/* default */.ZP)(ui.Column).attrs({
    lg: "6"
}).withConfig({
    displayName: "style__UtilInfoContent",
    componentId: "sc-fa1e4cea-2"
})(UtilInfo_style_templateObject2(), ui.theme.device.desktopFirst.mobileS);

;// CONCATENATED MODULE: ../../packages/components/patterns/UtilInfo/index.tsx









var UtilInfo = function(param) {
    var isBlackTheme = param.isBlackTheme;
    var isClientLaptop = (0,application/* useAppContext */.bp4)().isClientLaptop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Aggregator, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        background: isBlackTheme ? ui.theme.colors.blackFriday[175] : "trasnparent",
        id: "util-info-container"
    }, (0,application/* buildTestIds */.Fek)("util-info-container")), {
        padding: isClientLaptop ? "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x0) : "".concat(ui.theme.space.x10, " ").concat(ui.theme.space.x6),
        mobile: {
            margin: "".concat(ui.theme.space.x0),
            padding: ui.theme.space.x0
        },
        tablet: {
            margin: "".concat(ui.theme.space.x0),
            padding: ui.theme.space.x0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Row, {
                display: "flex",
                flexDirection: isClientLaptop ? "column-reverse" : "row",
                justifyContent: "start",
                alignItems: "start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilInfoContent, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, {
                            margin: isClientLaptop ? "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x4) : ui.theme.space.x0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilInfoContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Row, {
                                    display: "flex",
                                    alignItems: "center",
                                    children: [
                                        !isClientLaptop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                                            lg: "6",
                                            justifyContent: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.LogoFCBlack, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilInfoPaymentOptionsWrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilInfoPaymentOptions, {
                                                isBlackTheme: !!isBlackTheme,
                                                "data-cy": "util-info-payment-options"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Column, {
                        lg: "6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Container, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Row, {
                                children: isClientLaptop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile, {
                                    isBlackTheme: !!isBlackTheme
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOptions, {
                                    isBlackTheme: !!isBlackTheme
                                })
                            })
                        })
                    })
                ]
            })
        })
    }));
};


// EXTERNAL MODULE: ../../packages/components/StyledLink/style.ts
var style = __webpack_require__(32346);
;// CONCATENATED MODULE: ../../packages/components/patterns/Footer/style.ts

function Footer_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-dots {\n    position: absolute;\n    bottom: 0;\n    margin: 10px 0;\n    padding: 0;\n    text-align: center;\n    width: 100%;\n    z-index: 1;\n    gap: 10px;\n  }\n\n  .slick-slide {\n    display: flex;\n    justify-content: center;\n    ",
        " {\n      display: inline-flex !important;\n    }\n\n    ",
        " {\n      position: absolute;\n    }\n  }\n"
    ]);
    Footer_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Footer_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-top: ",
        " solid ",
        ";\n      border-bottom: ",
        " solid ",
        ";\n      background-color: ",
        " !important;\n      color: ",
        " !important;\n\n      @media ",
        " {\n        background-color: ",
        " !important;\n      }\n    "
    ]);
    Footer_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Footer_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  ",
        "\n"
    ]);
    Footer_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Footer_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-top: ",
        " solid ",
        ";\n      border-left: ",
        " solid ",
        ";\n      border-right: ",
        " solid ",
        ";\n      background-color: ",
        " !important;\n    "
    ]);
    Footer_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Footer_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ",
        ";\n  height: ",
        ';\n  border-radius: 4px 4px 0 0;\n  cursor: pointer;\n  font-family: "Chivo", Arial, Helvetica, sans-serif;\n  ',
        ";\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    Footer_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Footer_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      * {\n        background-color: ",
        " !important;\n        color: ",
        " !important;\n      }\n    "
    ]);
    Footer_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Footer_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  text-align: center;\n  color: ",
        " !important;\n\n  @media ",
        " {\n    padding: ",
        " ",
        " ",
        ";\n  }\n\n  @media ",
        " {\n    margin: ",
        ";\n    padding: ",
        " ",
        ";\n    text-align: start;\n  }\n\n  ",
        "\n"
    ]);
    Footer_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var StyledFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    displayName: "style__StyledFooter",
    componentId: "sc-564cf23b-0"
})(Footer_style_templateObject(), ui.Aggregator, style/* StyledLink */.F);
var style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Wrapper",
    componentId: "sc-564cf23b-1"
})(Footer_style_templateObject2(), "\n    border-top: ".concat(ui.theme.space.xpx, " solid ").concat(ui.theme.colors.neutral[250], ";\n    border-bottom: ").concat(ui.theme.space.xpx, " solid ").concat(ui.theme.colors.neutral[250], ";\n    background-color: ").concat(ui.theme.colors.neutral.white, "\n  "), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(Footer_style_templateObject1(), ui.theme.space.xpx, ui.theme.colors.neutral[750], ui.theme.space.xpx, ui.theme.colors.neutral[750], ui.theme.colors.blackFriday[200], ui.theme.colors.blackFriday.white, ui.theme.device.desktopFirst.tablet, ui.theme.colors.blackFriday[175]);
});
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__Button",
    componentId: "sc-564cf23b-2"
})(Footer_style_templateObject4(), ui.theme.space.x60, ui.theme.space.x10, "\n    background-color: ".concat(ui.theme.colors.neutral["white-050"], ";\n    border-top: ").concat(ui.theme.space.xpx, " solid ").concat(ui.theme.colors.neutral[250], ";\n    border-left: ").concat(ui.theme.space.xpx, " solid ").concat(ui.theme.colors.neutral[250], ";\n    border-right: ").concat(ui.theme.space.xpx, " solid ").concat(ui.theme.colors.neutral[250], ";\n    border-bottom: none;\n  "), ui.theme.colors.neutral.white, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(Footer_style_templateObject3(), ui.theme.space.xpx, ui.theme.colors.neutral[750], ui.theme.space.xpx, ui.theme.colors.neutral[750], ui.theme.space.xpx, ui.theme.colors.neutral[750], ui.theme.colors.blackFriday[175]);
});
var FooterDescriptionContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.Aggregator).withConfig({
    displayName: "style__FooterDescriptionContainer",
    componentId: "sc-564cf23b-3"
})(Footer_style_templateObject6(), ui.theme.space.x0, ui.theme.space.x0, ui.theme.colors.neutral[520], ui.theme.device.desktopFirst.laptopL, ui.theme.space.x0, ui.theme.space.x2, ui.theme.space.x2, ui.theme.device.desktopFirst.tablet, ui.theme.space.x0, ui.theme.space.x0, ui.theme.space.x1, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(Footer_style_templateObject5(), ui.theme.colors.blackFriday[175], ui.theme.colors.blackFriday[175], ui.theme.colors.blackFriday.white);
});

;// CONCATENATED MODULE: ../../packages/components/patterns/Footer/index.tsx
/* eslint-disable react/no-array-index-key */ 














var currentYear = new Date().getFullYear();
var Footer = function(param) {
    var isBlackTheme = param.isBlackTheme;
    var ref;
    var ref1 = (0,state/* useAppContext */.b)(), categories = ref1.categories, isClientTablet = ref1.isClientTablet, isClientMobile = ref1.isClientMobile, isSidebarMenuOpened = ref1.isSidebarMenuOpened;
    var styledFooterRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)("100%"), styledFooterOverlayHeight = ref2[0], setStyledFooterOverlayHeight = ref2[1];
    var ref3 = (0,react.useState)(false), otherPagesButtonClicked = ref3[0], setOtherPagesButtonClicked = ref3[1];
    // Esse eslint está desabilitado para que, toda vez que o componente for recriado, o overlay possa obter a largura exata do StyledFooter, mesmo que a tela seja redimensionada.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react.useEffect)(function() {
        var ref;
        if (styledFooterRef === null || styledFooterRef === void 0 ? void 0 : (ref = styledFooterRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) {
            setStyledFooterOverlayHeight("".concat(styledFooterRef.current.clientHeight, "px"));
        }
    });
    var toggleOtherPagesContainer = function() {
        setOtherPagesButtonClicked(function(state) {
            return !state;
        });
    };
    var branchId = (0,application/* getClientBranchId */.R0G)(implementations/* cookie */.pR);
    var blackThemeColor = isBlackTheme ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[999];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.OverlayDynamic, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("footer-overlay-dynamic")), {
                isVisible: !isClientMobile && isSidebarMenuOpened,
                height: styledFooterOverlayHeight
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooter, {
                id: "footer",
                "data-testid": "footer",
                "data-cy": "footer-container",
                ref: styledFooterRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Wrapper, {
                        isBlackTheme: !!isBlackTheme,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Container, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, {
                                    "data-testid": "space-wrapper",
                                    margin: isClientTablet ? "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0) : "".concat(ui.theme.space.x10, " ").concat(ui.theme.space.x4),
                                    children: isClientTablet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportContactMobile, {
                                        isBlackTheme: !!isBlackTheme,
                                        "data-testid": "support-contact-mobile-container"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportContact, {
                                        isBlackTheme: !!isBlackTheme
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Aggregator, {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "end",
                                    padding: "0",
                                    laptop: {
                                        display: "none"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                                        isBlackTheme: !!isBlackTheme,
                                        id: "other-pages-button",
                                        "data-testid": "other-pages-button",
                                        onClick: toggleOtherPagesContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, {
                                                "data-testid": "other-pages-text",
                                                fontSize: ui.theme.typography.fontSize.sm.x5,
                                                color: blackThemeColor,
                                                margin: isClientTablet ? "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0) : "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x1),
                                                children: "Outras p\xe1ginas"
                                            }),
                                            otherPagesButtonClicked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowUp, {
                                                color: blackThemeColor
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowDown, {
                                                color: blackThemeColor
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Accordion, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("other-pages-accordion")), {
                        show: otherPagesButtonClicked,
                        maxHeight: ui.theme.space.x160,
                        backgroundColor: isBlackTheme ? ui.theme.colors.blackFriday[175] : ui.theme.colors.neutral["white-050"],
                        laptop: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Container, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, {
                                padding: isClientTablet ? "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0) : "".concat(ui.theme.space.x10, " ").concat(ui.theme.space.x10),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Aggregator, {
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    flexWrap: "wrap",
                                    maxHeight: "550px",
                                    gap: "".concat(ui.theme.space.x3, " 40px"),
                                    alignItems: "center",
                                    color: ui.theme.colors.neutral[999],
                                    children: (categories === null || categories === void 0 ? void 0 : categories.isLoading) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
                                        count: 10
                                    }) : categories === null || categories === void 0 ? void 0 : (ref = categories.data) === null || ref === void 0 ? void 0 : ref.map(function(category) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_CategoryBlock, {
                                            isBlackTheme: isBlackTheme,
                                            category: category,
                                            level: 2,
                                            isLoading: categories === null || categories === void 0 ? void 0 : categories.isLoading
                                        }, "".concat(category.id, "#").concat(category.descriptionUrl));
                                    })
                                })
                            })
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilInfo, {
                        isBlackTheme: isBlackTheme
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterDescriptionContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        id: "fc-texts-container"
                    }, (0,application/* buildTestIds */.Fek)("fc-texts-container")), {
                        isBlackTheme: isBlackTheme,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.SpaceWrapper, {
                            margin: isClientTablet ? "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x2) : "".concat(ui.theme.space.x1, " ").concat(ui.theme.space.x2, " ").concat(ui.theme.space.x0),
                            padding: isClientTablet ? "".concat(ui.theme.space.x4, " ").concat(ui.theme.space.x0) : "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x2),
                            borderColor: isBlackTheme ? ui.theme.colors.blackFriday[100] : ui.theme.colors.neutral[250],
                            borderTop: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, {
                                    "data-testid": "warning-text",
                                    textAlign: "center",
                                    fontSize: isClientMobile ? ui.theme.typography.fontSize.sm.x2 : "13.5px",
                                    margin: isClientTablet ? "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x0) : "".concat(ui.theme.space.x3, " ").concat(ui.theme.space.x0),
                                    children: "Pre\xe7os, promo\xe7\xf5es, condi\xe7\xf5es de pagamento e frete s\xe3o v\xe1lidos para compras realizadas exclusivamente pelo site. Caso haja diverg\xeancia de pre\xe7o de um produto, ser\xe1 v\xe1lido o pre\xe7o que for exibido no carrinho de compras do site no momento do pagamento. As vendas est\xe3o sujeitas a an\xe1lise e disponibilidade do estoque. Imagens de produtos meramente ilustrativas."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, {
                                    padding: "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x0, " ").concat(ui.theme.space.x1),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Text, {
                                        "data-testid": "info-text",
                                        fontSize: isClientMobile ? ui.theme.typography.fontSize.sm.x2 : "13.5px",
                                        textAlign: "center",
                                        children: [
                                            "Copyright \xa9 1884-",
                                            currentYear,
                                            " \xb7 Ferreira Costa & Cia LTDA CNPJ 10.230.480/0019-60 \xb7 ",
                                            (0,application/* getBranchAddress */.MvN)(branchId)
                                        ]
                                    })
                                })
                            ]
                        })
                    }))
                ]
            })
        ]
    });
};
Footer.displayName = "Footer";
var FooterWithBlackThemeValidation = (0,hocs/* withBlackThemeValidation */.z7)(Footer);


// EXTERNAL MODULE: ../../packages/components/patterns/Head/index.tsx + 1 modules
var Head = __webpack_require__(53343);
// EXTERNAL MODULE: ../../packages/components/patterns/LinkRedirectHome/index.tsx
var LinkRedirectHome = __webpack_require__(98277);
// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
// EXTERNAL MODULE: ../../packages/components/2fa/index.ts + 18 modules
var _2fa = __webpack_require__(83650);
// EXTERNAL MODULE: ../../packages/components/BottomSheet/index.tsx
var BottomSheet = __webpack_require__(33082);
// EXTERNAL MODULE: ../../packages/typing/index.tsx + 7 modules
var typing = __webpack_require__(96915);
// EXTERNAL MODULE: ../../packages/components/2fa/Content/useTwoFactorContent/index.tsx
var useTwoFactorContent = __webpack_require__(53886);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/data.tsx










var feedbackErrorTitle = "Erro ao enviar o c\xf3digo";
var defaultErrorMessage = "Ocorreu um erro ao enviar o c\xf3digo de verifica\xe7\xe3o.";
var methods = function(changeCurrentStep, sendTokenByChannel, userIdentification) {
    return [
        {
            title: "SMS",
            description: (0,useTwoFactorContent/* maskPhoneNumber */.Y)(userIdentification === null || userIdentification === void 0 ? void 0 : userIdentification.phoneNumber),
            handleOptionAction: function() {
                sendTokenByChannel(typing/* FATypeValues.AccountValidatePhone2FA */.ZI.AccountValidatePhone2FA, typing/* FAChannelsValues.SMS */.jC.SMS);
                changeCurrentStep("secondStep");
            },
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.MessagesIcon, {}),
            isValid: true
        },
        {
            title: "E-mail",
            description: (0,useTwoFactorContent/* maskEmail */.o)(userIdentification === null || userIdentification === void 0 ? void 0 : userIdentification.email),
            handleOptionAction: function() {
                sendTokenByChannel(typing/* FATypeValues.AccountValidateEMail2FA */.ZI.AccountValidateEMail2FA, typing/* FAChannelsValues.Email */.jC.Email);
                changeCurrentStep("secondStep");
            },
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.EmailIcon, {}),
            isValid: true
        }, 
    ];
};
var useLoginAuthenticationModal = function(param) {
    var accessToken = param.accessToken, notificationApi = param.notificationApi, loggedClient = param.loggedClient;
    var ref = (0,react.useState)(false), isUnderAction = ref[0], setIsUnderAction = ref[1];
    var ref1 = (0,react.useState)(false), hasError = ref1[0], setHasError = ref1[1];
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var ref2 = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            tokenCode: state.tokenCode,
            setChannelSelected: state.setChannelSelected,
            channelSelected: state.channelSelected,
            setIsValidationActive: state.setIsValidationActive,
            setIsBlockedToSendCode: state.setIsBlockedToSendCode,
            setIsTokenCodeValid: state.setIsTokenCodeValid,
            setValidateCode: state.setValidateCode,
            setFaType: state.setFaType,
            clearTimer: state.clearTimer,
            getTimer: state.getTimer,
            availableMethods: state.availableMethods
        };
    })), tokenCode = ref2.tokenCode, setChannelSelected = ref2.setChannelSelected, channelSelected = ref2.channelSelected, setIsValidationActive = ref2.setIsValidationActive, setIsBlockedToSendCode = ref2.setIsBlockedToSendCode, setIsTokenCodeValid = ref2.setIsTokenCodeValid, setValidateCode = ref2.setValidateCode, setFaType = ref2.setFaType, clearTimer = ref2.clearTimer, getTimer = ref2.getTimer, availableMethods = ref2.availableMethods;
    var ref3 = (0,state_manager/* useLoginAuthentication */.VQ)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setIsLoginAuthenticationModalOpen: state.setIsLoginAuthenticationModalOpen,
            currentStep: state.currentStep,
            changeLoginStep: state.changeLoginStep
        };
    })), setIsLoginAuthenticationModalOpen = ref3.setIsLoginAuthenticationModalOpen, currentStep = ref3.currentStep, changeLoginStep = ref3.changeLoginStep;
    var handleCloseLoginAuthenticationModal = function() {
        setIsValidationActive(false);
        setIsLoginAuthenticationModalOpen(false);
    };
    var canChooseAnotherMethod = (0,react.useMemo)(function() {
        return (availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.emailConfirmed) && (availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumberConfirmed) || !(availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.emailConfirmed) && !(availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumberConfirmed);
    }, [
        availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.emailConfirmed,
        availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumberConfirmed, 
    ]);
    var handleValidateAccountInfo = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1, faType, body, ref2, isValid, errors, ref3, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        3,
                        4
                    ]);
                    setIsUnderAction(true);
                    faType = channelSelected === 2 ? typing/* FATypeValues.AccountValidateEMail2FA */.ZI.AccountValidateEMail2FA : channelSelected === 1 ? typing/* FATypeValues.AccountValidatePhone2FA */.ZI.AccountValidatePhone2FA : null;
                    body = {
                        email: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email,
                        cpf: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf,
                        phoneNumber: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber,
                        channel: Number(channelSelected),
                        token: tokenCode,
                        faType: faType,
                        jwt: accessToken
                    };
                    return [
                        4,
                        notificationApi.validateTwoFactorCode(body)
                    ];
                case 1:
                    ref2 = _state.sent(), isValid = ref2.isValid, errors = ref2.errors;
                    if (!isValid && (errors === null || errors === void 0 ? void 0 : (ref = errors.statusCode) === null || ref === void 0 ? void 0 : ref.includes("222"))) {
                        setIsBlockedToSendCode(true);
                        setIsValidationActive(true);
                        setHasError(true);
                        return [
                            2
                        ];
                    }
                    if (!isValid && !(errors === null || errors === void 0 ? void 0 : (ref1 = errors.statusCode) === null || ref1 === void 0 ? void 0 : ref1.includes("222"))) {
                        ;
                        setIsTokenCodeValid(false);
                        setValidateCode(true);
                        addToast({
                            isNewToast: true,
                            newToastTheme: "dark",
                            type: "error",
                            title: "Erro ao validar o c\xf3digo",
                            description: "".concat(errors === null || errors === void 0 ? void 0 : (ref3 = errors.messages) === null || ref3 === void 0 ? void 0 : ref3[0]) || "Ocorreu um erro ao validar o c\xf3digo",
                            timerInMilliseconds: 3000
                        });
                        return [
                            2
                        ];
                    }
                    clearTimer(Number(faType), channelSelected);
                    addToast({
                        title: "C\xf3digo validado com sucesso!",
                        description: "Parab\xe9ns, sua conta agora est\xe1 mais protegida!",
                        isNewToast: true,
                        newToastTheme: "light",
                        type: "success",
                        timerInMilliseconds: 3000
                    });
                    setIsValidationActive(false);
                    setIsLoginAuthenticationModalOpen(false);
                    return [
                        3,
                        4
                    ];
                case 2:
                    error = _state.sent();
                    implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Ocorreu um erro no processo de valida\xe7\xe3o do c\xf3digo fun\xe7\xe3o handleValidateAccountInfo em LoginAuthenticationModal.\nErro: ".concat(error), {
                        level: "error"
                    });
                    setHasError(true);
                    setIsTokenCodeValid(false);
                    addToast({
                        isNewToast: true,
                        newToastTheme: "dark",
                        type: "error",
                        title: "Erro ao validar o c\xf3digo",
                        description: "Ocorreu um erro ao validar o c\xf3digo",
                        timerInMilliseconds: 3000
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    setIsUnderAction(false);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        accessToken,
        addToast,
        channelSelected,
        clearTimer,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber,
        notificationApi,
        setIsBlockedToSendCode,
        setIsLoginAuthenticationModalOpen,
        setIsTokenCodeValid,
        setIsValidationActive,
        setValidateCode,
        tokenCode, 
    ]);
    var sendTokenByChannel = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(faType, channel) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, isTimerRunning, requestBody, data, ref11, ref12, ref13, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setIsUnderAction(true);
                        setChannelSelected(channel);
                        setFaType(faType);
                        isTimerRunning = getTimer(faType, channel).isTimerRunning;
                        if (isTimerRunning) {
                            setIsValidationActive(true);
                            if (currentStep === "verifyIdentity") {
                                changeLoginStep("secondStep");
                            }
                            return [
                                2
                            ];
                        }
                        if (canChooseAnotherMethod) {
                            changeLoginStep("verifyIdentity");
                        }
                        requestBody = {
                            email: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email,
                            cpf: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf,
                            faType: Number(faType),
                            channel: Number(channel),
                            phoneNumber: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber,
                            token: accessToken
                        };
                        return [
                            4,
                            notificationApi.sendTwoFactorCode(requestBody)
                        ];
                    case 1:
                        data = _state.sent().data;
                        if ((data === null || data === void 0 ? void 0 : (ref = data.validationResult) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.errorCode) === "222" || ((ref3 = [
                            "Tente novamente em 24 horas.",
                            "Opera\xe7\xe3o bloqueada devido ao n\xfamero de tentativas excessivas na solicita\xe7\xe3o do c\xf3digo.", 
                        ]) === null || ref3 === void 0 ? void 0 : ref3.includes(String(data === null || data === void 0 ? void 0 : (ref4 = data.validationResult) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.errors) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.errorMessage)))) {
                            addToast({
                                isNewToast: true,
                                newToastTheme: "dark",
                                type: "error",
                                title: feedbackErrorTitle,
                                description: defaultErrorMessage,
                                timerInMilliseconds: 3000
                            });
                            setIsLoginAuthenticationModalOpen(false);
                            return [
                                2
                            ];
                        }
                        if ((data === null || data === void 0 ? void 0 : (ref7 = data.validationResult) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.errors) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.errorMessage) === "Cliente n\xe3o encontrado") {
                            ;
                            addToast({
                                isNewToast: true,
                                newToastTheme: "dark",
                                type: "error",
                                title: feedbackErrorTitle,
                                description: "".concat(data === null || data === void 0 ? void 0 : (ref11 = data.validationResult) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.errors) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.errorMessage),
                                timerInMilliseconds: 3000
                            });
                            return [
                                2
                            ];
                        }
                        if (data === null || data === void 0 ? void 0 : (ref10 = data.validationResult) === null || ref10 === void 0 ? void 0 : ref10.isValid) {
                            addToast({
                                title: "C\xf3digo enviado!",
                                isNewToast: true,
                                newToastTheme: "light",
                                type: "success",
                                timerInMilliseconds: 3000
                            });
                            changeLoginStep("secondStep");
                            return [
                                2
                            ];
                        }
                        addToast({
                            isNewToast: true,
                            newToastTheme: "dark",
                            type: "error",
                            title: feedbackErrorTitle,
                            description: defaultErrorMessage,
                            timerInMilliseconds: 3000
                        });
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Ocorreu um erro ao enviar o c\xf3digo de verifica\xe7\xe3o pela fun\xe7\xe3o sendTokenByChannel em LoginAuthenticationModal.\nErro: ".concat(error), {
                            level: "error"
                        });
                        addToast({
                            isNewToast: true,
                            newToastTheme: "dark",
                            type: "error",
                            title: feedbackErrorTitle,
                            description: defaultErrorMessage,
                            timerInMilliseconds: 3000
                        });
                        setHasError(true);
                        setIsLoginAuthenticationModalOpen(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsUnderAction(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function sendTokenByChannel(faType, channel) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        handleCloseLoginAuthenticationModal: handleCloseLoginAuthenticationModal,
        handleValidateAccountInfo: handleValidateAccountInfo,
        sendTokenByChannel: sendTokenByChannel,
        isUnderAction: isUnderAction,
        setIsUnderAction: setIsUnderAction,
        hasError: hasError
    };
};


// EXTERNAL MODULE: ../../packages/components/UniqueClient/components/index.ts + 15 modules
var UniqueClient_components = __webpack_require__(82177);
;// CONCATENATED MODULE: ../../packages/components/UniqueClient/index.tsx


var UniqueClient = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClient_components/* UniqueClientComponent */.ZF, {});
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/PhoneValidation/data.tsx

var usePhoneValidationData = function() {
    var validationStep = (0,state_manager/* useLoginAuthentication */.VQ)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            validationStep: state.validationStep
        };
    })).validationStep;
    return {
        validationStep: validationStep
    };
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/PhoneValidation/components/PhoneValidationContent/data.tsx









var usePhoneValidationContentData = function() {
    var ref;
    var ref1 = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setIsValidationActive: state.setIsValidationActive,
            setChannelSelected: state.setChannelSelected,
            setFaType: state.setFaType,
            setIsRequesting: state.setIsRequesting,
            setIsBlockedToSendCode: state.setIsBlockedToSendCode,
            setIsTokenCodeValid: state.setIsTokenCodeValid,
            isBlockedToSendCode: state.isBlockedToSendCode
        };
    })), setIsValidationActive = ref1.setIsValidationActive, setChannelSelected = ref1.setChannelSelected, setFaType = ref1.setFaType, setIsRequesting = ref1.setIsRequesting, setIsBlockedToSendCode = ref1.setIsBlockedToSendCode, isBlockedToSendCode = ref1.isBlockedToSendCode, setIsTokenCodeValid = ref1.setIsTokenCodeValid;
    var ref2 = (0,state_manager/* useLoginAuthentication */.VQ)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setIsPhoneValidationModalOpen: state.setIsPhoneValidationModalOpen,
            isPhoneValidationModalOpen: state.isPhoneValidationModalOpen,
            changeValidationStep: state.changeValidationStep
        };
    })), setIsPhoneValidationModalOpen = ref2.setIsPhoneValidationModalOpen, isPhoneValidationModalOpen = ref2.isPhoneValidationModalOpen, changeValidationStep = ref2.changeValidationStep;
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var loggedClient = (0,application/* useUser */.aFb)().loggedClient;
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var checkError = (0,react.useCallback)(function(errorCode, errorMessage, isValid) {
        var ref;
        if (errorCode === "222" || ((ref = [
            "Tente novamente em 24 horas.",
            "Opera\xe7\xe3o bloqueada devido ao n\xfamero de tentativas excessivas na solicita\xe7\xe3o do c\xf3digo.", 
        ]) === null || ref === void 0 ? void 0 : ref.includes(String(errorMessage)))) {
            setIsBlockedToSendCode(true);
            setIsValidationActive(true);
            changeValidationStep("validation");
            setIsTokenCodeValid(false);
            return;
        }
        if (errorMessage === "Cliente n\xe3o encontrado") {
            addToast({
                isNewToast: true,
                newToastTheme: "dark",
                type: "error",
                title: "Erro ao enviar o c\xf3digo",
                description: "".concat(errorMessage),
                timerInMilliseconds: 3000
            });
            setIsBlockedToSendCode(false);
            setIsValidationActive(true);
            return;
        }
        if (!errorMessage && !isValid) {
            addToast({
                isNewToast: true,
                newToastTheme: "dark",
                type: "error",
                title: "Erro ao enviar o c\xf3digo",
                description: "Ocorreu um erro ao enviar o c\xf3digo de verifica\xe7\xe3o.",
                timerInMilliseconds: 3000
            });
        }
    }, [
        addToast,
        setIsBlockedToSendCode,
        setIsTokenCodeValid,
        setIsValidationActive,
        changeValidationStep, 
    ]);
    var sendTwoFactorToken = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
            var channel, faType, cpf, email, phoneNumber, ref, storagedTime, actualTime, diffTime, ref1, ref2, ref3, data, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        channel = param.channel, faType = param.faType, cpf = param.cpf, email = param.email, phoneNumber = param.phoneNumber;
                        setFaType(Number(faType));
                        setChannelSelected(channel);
                        setIsRequesting(true);
                        storagedTime = localStorage.getItem("timeSent_".concat(faType, "_").concat(channel));
                        actualTime = Date.now();
                        diffTime = Math.floor(Number(storagedTime) - Number(actualTime) / 1000);
                        if (diffTime && diffTime > 0 && storagedTime && !isBlockedToSendCode) {
                            setIsValidationActive(true);
                            changeValidationStep("validation");
                            setIsRequesting(false);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            implementations/* notificationApi.sendTwoFactorCode */.E8.sendTwoFactorCode({
                                channel: channel,
                                faType: faType,
                                cpf: (ref1 = String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf)) !== null && ref1 !== void 0 ? ref1 : cpf,
                                email: (ref2 = String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email)) !== null && ref2 !== void 0 ? ref2 : email,
                                phoneNumber: (ref3 = String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber)) !== null && ref3 !== void 0 ? ref3 : phoneNumber,
                                token: accessToken
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (!(data === null || data === void 0 ? void 0 : (ref = data.validationResult) === null || ref === void 0 ? void 0 : ref.isValid)) {
                            ;
                            checkError(data === null || data === void 0 ? void 0 : (ref4 = data.validationResult) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.errors) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.errorCode, data === null || data === void 0 ? void 0 : (ref7 = data.validationResult) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.errors) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.errorMessage, data === null || data === void 0 ? void 0 : (ref10 = data.validationResult) === null || ref10 === void 0 ? void 0 : ref10.isValid);
                            return [
                                2
                            ];
                        }
                        setIsRequesting(false);
                        setIsValidationActive(true);
                        setIsBlockedToSendCode(false);
                        changeValidationStep("validation");
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setFaType,
        setChannelSelected,
        setIsRequesting,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber,
        accessToken,
        checkError,
        setIsValidationActive,
        setIsBlockedToSendCode,
        changeValidationStep,
        isBlockedToSendCode, 
    ]);
    var onClickOnPrimaryButton = function() {
        setFaType(typing/* FATypeValues.AccountValidatePhone2FA */.ZI.AccountValidatePhone2FA);
        setChannelSelected(1);
        var ref, ref1, ref2;
        sendTwoFactorToken({
            channel: 1,
            faType: typing/* FATypeValues.AccountValidatePhone2FA */.ZI.AccountValidatePhone2FA,
            cpf: (ref = loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf) !== null && ref !== void 0 ? ref : "",
            email: (ref1 = loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email) !== null && ref1 !== void 0 ? ref1 : "",
            phoneNumber: (ref2 = loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber) !== null && ref2 !== void 0 ? ref2 : ""
        });
    };
    var onClickOnSecondaryButton = function() {
        setIsPhoneValidationModalOpen(false);
    };
    var getPhoneValidationContent = function() {
        return {
            actions: {
                closeModal: function() {
                    setIsPhoneValidationModalOpen(false);
                },
                isModalOpen: isPhoneValidationModalOpen,
                modalTitle: "Validar n\xfamero de telefone",
                hasHeader: true
            },
            content: {
                title: "Voc\xea ainda n\xe3o validou seu n\xfamero de telefone",
                description: "Confirme o seu telefone para deixar sua conta ainda mais segura.",
                primaryButtonLabel: "Continuar",
                secondaryButtonLabel: "Deixar para depois",
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.TelephoneAuthenticationIcon, {}),
                onPrimaryButtonClick: onClickOnPrimaryButton,
                onSecondaryButtonClick: onClickOnSecondaryButton,
                margin: "0px 0px 16px"
            }
        };
    };
    return {
        getPhoneValidationContent: getPhoneValidationContent
    };
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var src_extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../packages/components/ResponsiveModal/index.tsx
var ResponsiveModal = __webpack_require__(58393);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/PhoneValidation/components/PhoneValidationContent/ui.tsx




var PhoneValidationContentUI = function(_param) {
    var props = (0,src_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveModal/* ResponsiveModal */.c, (0,src_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/PhoneValidation/components/PhoneValidationContent/index.tsx






var PhoneValidationContent = function() {
    var register = (0,index_esm/* useForm */.cI)().register;
    var getPhoneValidationContent = usePhoneValidationContentData().getPhoneValidationContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneValidationContentUI, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        register: register
    }, getPhoneValidationContent().content, getPhoneValidationContent().actions), {
        hasInput: false
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/PhoneValidation/components/PhoneValidationComponent/data.tsx








var usePhoneValidationComponentData = function(clientInfo) {
    var ref;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var loggedClient = (0,application/* useUser */.aFb)().loggedClient;
    var ref2 = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            isRequesting: state.isRequesting,
            setIsTokenCodeValid: state.setIsTokenCodeValid,
            setIsValidatingCode: state.setIsValidatingCode,
            setValidateCode: state.setValidateCode,
            setIsValidationActive: state.setIsValidationActive,
            channelSelected: state.channelSelected,
            faType: state.faType,
            setIsBlockedToSendCode: state.setIsBlockedToSendCode,
            tokenCode: state.tokenCode
        };
    })), isRequesting = ref2.isRequesting, setIsTokenCodeValid = ref2.setIsTokenCodeValid, setIsValidatingCode = ref2.setIsValidatingCode, setIsValidationActive = ref2.setIsValidationActive, setValidateCode = ref2.setValidateCode, channelSelected = ref2.channelSelected, faType = ref2.faType, tokenCode = ref2.tokenCode, setIsBlockedToSendCode = ref2.setIsBlockedToSendCode;
    var ref3 = (0,state_manager/* useLoginAuthentication */.VQ)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setIsPhoneValidationModalOpen: state.setIsPhoneValidationModalOpen,
            changeValidationStep: state.changeValidationStep
        };
    })), setIsPhoneValidationModalOpen = ref3.setIsPhoneValidationModalOpen, changeValidationStep = ref3.changeValidationStep;
    (0,react.useEffect)(function() {
        if ((!loggedClient || !clientInfo) && isClientMobile) {
            setIsLoading(true);
        }
    }, [
        clientInfo,
        loggedClient,
        isClientMobile
    ]);
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var clearTime = (0,react.useCallback)(function() {
        localStorage.removeItem("timeSent_".concat(faType, "_").concat(channelSelected));
        localStorage.removeItem("countdownTime_".concat(faType, "_").concat(channelSelected));
        localStorage.removeItem("countdownTimeTimestamp_".concat(faType, "_").concat(channelSelected));
    }, [
        faType,
        channelSelected
    ]);
    var checkErrorAttempt = (0,react.useCallback)(function(statusCode, messages) {
        if (statusCode === null || statusCode === void 0 ? void 0 : statusCode.includes("222")) {
            setIsValidationActive(true);
            setIsBlockedToSendCode(true);
            addToast({
                isNewToast: true,
                newToastTheme: "dark",
                type: "error",
                description: "".concat(messages === null || messages === void 0 ? void 0 : messages[0]),
                title: "Ocorreu um erro ao validar o c\xf3digo",
                timerInMilliseconds: 3000
            });
            return;
        }
        setIsTokenCodeValid(false);
        setValidateCode(true);
        addToast({
            isNewToast: true,
            newToastTheme: "dark",
            type: "error",
            description: "".concat(messages === null || messages === void 0 ? void 0 : messages[0]),
            title: "Ocorreu um erro ao validar o c\xf3digo",
            timerInMilliseconds: 3000
        });
    }, [
        setIsValidationActive,
        setIsTokenCodeValid,
        addToast,
        setValidateCode,
        setIsBlockedToSendCode, 
    ]);
    var handleSuccessValidation = (0,react.useCallback)(function() {
        setIsTokenCodeValid(true);
        setIsValidatingCode(true);
        setIsValidationActive(false);
        changeValidationStep("modalCall");
        setIsPhoneValidationModalOpen(false);
        addToast({
            isNewToast: true,
            newToastTheme: "dark",
            type: "success",
            description: "Parab\xe9ns! Seu telefone foi validado.",
            title: "Telefone validado com sucesso",
            timerInMilliseconds: 3000
        });
    }, [
        setIsTokenCodeValid,
        setIsValidatingCode,
        setIsValidationActive,
        changeValidationStep,
        setIsPhoneValidationModalOpen,
        addToast, 
    ]);
    var handleCodeValidation = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
            var channel, userFAType, cpf, email, phoneNumber, token, ref, isValid, errors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        channel = param.channel, userFAType = param.faType, cpf = param.cpf, email = param.email, phoneNumber = param.phoneNumber, token = param.token;
                        return [
                            4,
                            implementations/* notificationApi.validateTwoFactorCode */.E8.validateTwoFactorCode({
                                channel: channel,
                                faType: userFAType,
                                cpf: cpf,
                                email: email,
                                phoneNumber: phoneNumber,
                                token: token,
                                jwt: accessToken
                            })
                        ];
                    case 1:
                        ref = _state.sent(), isValid = ref.isValid, errors = ref.errors;
                        if (!isValid) {
                            checkErrorAttempt(errors === null || errors === void 0 ? void 0 : errors.statusCode, errors === null || errors === void 0 ? void 0 : errors.messages);
                            return [
                                2
                            ];
                        }
                        clearTime();
                        handleSuccessValidation();
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        accessToken,
        clearTime,
        checkErrorAttempt,
        handleSuccessValidation
    ]);
    var getPhoneValidationComponentData = function() {
        var contentMap = new Map();
        contentMap.set("clientAction", "loginValidation");
        contentMap.set("email", String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email));
        contentMap.set("hasError", false);
        contentMap.set("isUnderAction", isRequesting);
        contentMap.set("onCallAction", function() {
            return handleCodeValidation({
                channel: channelSelected,
                faType: Number(faType),
                cpf: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf),
                email: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email),
                phoneNumber: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber),
                token: String(tokenCode)
            });
        });
        contentMap.set("phoneNumber", String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber));
        contentMap.set("sendCodeType", "sms");
        contentMap.set("viewType", "modal");
        contentMap.set("hasDescriptionOnMobile", true);
        contentMap.set("verifyIdentityTitle", "Escolha como verificar sua identidade");
        contentMap.set("preventDefault", true);
        contentMap.set("canChooseAnotherTwoFactorMethod", false);
        contentMap.set("isMobile", isClientMobile);
        contentMap.set("options", null);
        contentMap.set("handleSelectAnotherTwoFactorType", undefined);
        contentMap.set("failureIllustration", /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.TelephoneErrorIcon, {}));
        return contentMap;
    };
    return {
        getPhoneValidationComponentData: getPhoneValidationComponentData,
        isLoading: isLoading,
        setIsLoading: setIsLoading
    };
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/PhoneValidation/components/PhoneValidationComponent/styles.ts

function PhoneValidationComponent_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PhoneValidationComponent_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var TwoFactorContentContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__TwoFactorContentContainer",
    componentId: "sc-46394dd0-0"
})(PhoneValidationComponent_styles_templateObject());

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/PhoneValidation/components/PhoneValidationComponent/ui.tsx





var PhoneValidationComponentUI = function(_param) {
    var props = (0,src_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorContentContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_2fa.TwoFactorContent, (0,src_object_spread/* default */.Z)({}, props))
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/PhoneValidation/components/PhoneValidationComponent/index.tsx




var PhoneValidationComponent = function() {
    var getPhoneValidationComponentData = usePhoneValidationComponentData().getPhoneValidationComponentData;
    var phoneValidationComponentData = Object.fromEntries(getPhoneValidationComponentData());
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneValidationComponentUI, (0,src_object_spread/* default */.Z)({}, phoneValidationComponentData));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/PhoneValidation/components/index.tsx



;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/PhoneValidation/ui.tsx


var PhoneValidationUI = function(param) {
    var currentStep = param.currentStep;
    if (currentStep === "validation") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneValidationComponent, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneValidationContent, {});
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/PhoneValidation/index.tsx



var PhoneValidation = function() {
    var validationStep = usePhoneValidationData().validationStep;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneValidationUI, {
        currentStep: validationStep
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/ModalBody/styles.ts

function ModalBody_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1.33rem;\n"
    ]);
    ModalBody_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBody_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 2.67rem;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    ModalBody_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBody_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 1.16667rem;\n"
    ]);
    ModalBody_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalBody_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    ModalBody_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalBody_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1.37rem;\n"
    ]);
    ModalBody_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalBody_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* @media ",
        " {\n    min-width: 324px;\n  } */\n"
    ]);
    ModalBody_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ModalBody_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  color: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    ModalBody_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var ModalContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ModalContainer",
    componentId: "sc-ea6cb49c-0"
})(ModalBody_styles_templateObject());
var ModalDescription = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ModalDescription",
    componentId: "sc-ea6cb49c-1"
})(ModalBody_styles_templateObject1(), ui.theme.space.x2);
var ModalDescriptionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ModalDescriptionTitle",
    componentId: "sc-ea6cb49c-2"
})(ModalBody_styles_templateObject2(), ui.theme.colors.neutral[550]);
var ModalDescriptionSubtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ModalDescriptionSubtitle",
    componentId: "sc-ea6cb49c-3"
})(ModalBody_styles_templateObject3(), ui.theme.colors.neutral[730], ui.theme.typography.fontSize.sm.x3, ui.theme.typography.fontWeight[400]);
var ModalBottom = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ModalBottom",
    componentId: "sc-ea6cb49c-4"
})(ModalBody_styles_templateObject4());
var ModalButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonSubmit/* ButtonSubmit */.G).attrs({
    minWidth: "100%",
    fontSize: ui.theme.typography.fontSize.sm.x7,
    height: "3.75rem",
    fontWeight: ui.theme.typography.fontWeight[400],
    fontFamily: ui.theme.typography.fontFamily.chivo
}).withConfig({
    displayName: "styles__ModalButton",
    componentId: "sc-ea6cb49c-5"
})(ModalBody_styles_templateObject5(), ui.theme.device.desktopFirst.tabletM);
var DoItLaterButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DoItLaterButton",
    componentId: "sc-ea6cb49c-6"
})(ModalBody_styles_templateObject6(), ui.theme.colors.neutral[550], ui.theme.typography.fontSize.sm.x3);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/components/ModalBody/index.tsx












var ModalBody_defaultErrorMessage = "Ocorreu um erro ao enviar o c\xf3digo de verifica\xe7\xe3o.";
var ModalBody_feedbackErrorTitle = "Erro ao enviar o c\xf3digo";
var ModalBody = function(param) {
    var loggedClient = param.loggedClient, token = param.token;
    var ref = (0,state_manager/* useLoginAuthentication */.VQ)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setIsLoginAuthenticationModalOpen: state.setIsLoginAuthenticationModalOpen,
            changeLoginStep: state.changeLoginStep
        };
    })), setIsLoginAuthenticationModalOpen = ref.setIsLoginAuthenticationModalOpen, changeLoginStep = ref.changeLoginStep;
    var ref1 = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            channelSelected: state.channelSelected,
            setChannelSelected: state.setChannelSelected,
            setIsBlockedToSendCode: state.setIsBlockedToSendCode,
            setIsValidationActive: state.setIsValidationActive,
            setInitTimer: state.setInitTimer,
            setClientAction: state.setClientAction,
            setFaType: state.setFaType,
            currentStep: state.currentStep,
            getTimer: state.getTimer
        };
    })), setChannelSelected = ref1.setChannelSelected, setIsBlockedToSendCode = ref1.setIsBlockedToSendCode, setIsValidationActive = ref1.setIsValidationActive, setInitTimer = ref1.setInitTimer, currentStep = ref1.currentStep, setFaType = ref1.setFaType, setClientAction = ref1.setClientAction, getTimer = ref1.getTimer;
    var handleCloseLoginAuthenticationModal = function() {
        setIsValidationActive(false);
        setIsLoginAuthenticationModalOpen(false);
    };
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var ref2 = (0,state_manager/* useConfirmationTypes */.wA)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            availableMethods: state.availableMethods,
            canChooseAnotherMethod: state.canChooseAnotherMethod
        };
    })), availableMethods = ref2.availableMethods, canChooseAnotherMethod = ref2.canChooseAnotherMethod;
    var requestBody = (0,react.useMemo)(function() {
        return {
            email: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email,
            cpf: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf,
            faType: typing/* FATypeValues.AccountValidatePhone2FA */.ZI.AccountValidatePhone2FA,
            channel: (availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumberConfirmed) ? 1 : (availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.emailConfirmed) ? 2 : 1,
            phoneNumber: loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber,
            token: token
        };
    }, [
        availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.emailConfirmed,
        availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumberConfirmed,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.cpf,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber,
        token, 
    ]);
    var sendTokenByChannel = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(body) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, isTimerRunning, data, ref14, ref15, ref16, ref17, ref18, ref19, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        setFaType(typing/* FATypeValues.AccountValidatePhone2FA */.ZI.AccountValidatePhone2FA);
                        setChannelSelected(body.channel);
                        isTimerRunning = getTimer(13, body.channel).isTimerRunning;
                        if (isTimerRunning) {
                            setIsValidationActive(true);
                            if (currentStep === "verifyIdentity") {
                                changeLoginStep("secondStep");
                            }
                            return [
                                2
                            ];
                        }
                        if (canChooseAnotherMethod) {
                            changeLoginStep("verifyIdentity");
                            return [
                                2
                            ];
                        }
                        setClientAction("loginValidation");
                        return [
                            4,
                            implementations/* notificationApi.sendTwoFactorCode */.E8.sendTwoFactorCode(body)
                        ];
                    case 1:
                        data = _state.sent().data;
                        if ((data === null || data === void 0 ? void 0 : (ref = data.validationResult) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.errorCode) === "222" || ((ref3 = [
                            "Tente novamente em 24 horas.",
                            "Opera\xe7\xe3o bloqueada devido ao n\xfamero de tentativas excessivas na solicita\xe7\xe3o do c\xf3digo.", 
                        ]) === null || ref3 === void 0 ? void 0 : ref3.includes(String(data === null || data === void 0 ? void 0 : (ref4 = data.validationResult) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.errors) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.errorMessage)))) {
                            ;
                            setIsBlockedToSendCode(true);
                            setIsValidationActive(true);
                            addToast({
                                isNewToast: true,
                                newToastTheme: "dark",
                                type: "error",
                                title: ModalBody_feedbackErrorTitle,
                                description: (data === null || data === void 0 ? void 0 : (ref14 = data.validationResult) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.errors) === null || ref15 === void 0 ? void 0 : (ref16 = ref15[0]) === null || ref16 === void 0 ? void 0 : ref16.errorMessage) || ModalBody_defaultErrorMessage,
                                timerInMilliseconds: 3000
                            });
                            return [
                                2
                            ];
                        }
                        if ((data === null || data === void 0 ? void 0 : (ref7 = data.validationResult) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.errors) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.errorMessage) === "Cliente n\xe3o encontrado") {
                            ;
                            addToast({
                                isNewToast: true,
                                newToastTheme: "dark",
                                type: "error",
                                title: ModalBody_feedbackErrorTitle,
                                description: "".concat((data === null || data === void 0 ? void 0 : (ref17 = data.validationResult) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.errors) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : ref19.errorMessage) === "Cliente n\xe3o encontrado"),
                                timerInMilliseconds: 3000
                            });
                            setIsBlockedToSendCode(false);
                            return [
                                2
                            ];
                        }
                        if (data === null || data === void 0 ? void 0 : (ref10 = data.validationResult) === null || ref10 === void 0 ? void 0 : ref10.isValid) {
                            addToast({
                                title: "C\xf3digo enviado!",
                                isNewToast: true,
                                newToastTheme: "light",
                                type: "success",
                                timerInMilliseconds: 3000
                            });
                            setInitTimer(true);
                            changeLoginStep("secondStep");
                            setIsValidationActive(true);
                            setIsBlockedToSendCode(false);
                            return [
                                2
                            ];
                        }
                        addToast({
                            isNewToast: true,
                            newToastTheme: "dark",
                            type: "error",
                            title: ModalBody_feedbackErrorTitle,
                            description: (data === null || data === void 0 ? void 0 : (ref11 = data.validationResult) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.errors) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.errorMessage) || ModalBody_defaultErrorMessage,
                            timerInMilliseconds: 3000
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        implementations/* appMonitoringClient.captureMessage */.pE.captureMessage("Ocorreu um erro ao enviar o c\xf3digo de verifica\xe7\xe3o pela fun\xe7\xe3o sendTokenByChannel em LoginAuthenticationModal/ModalBody.\nErro: ".concat(error), {
                            level: "error"
                        });
                        setIsBlockedToSendCode(true);
                        setIsValidationActive(true);
                        addToast({
                            isNewToast: true,
                            newToastTheme: "dark",
                            type: "error",
                            title: ModalBody_feedbackErrorTitle,
                            description: ModalBody_defaultErrorMessage,
                            timerInMilliseconds: 3000
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(body) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addToast,
        canChooseAnotherMethod,
        changeLoginStep,
        currentStep,
        getTimer,
        setChannelSelected,
        setClientAction,
        setFaType,
        setInitTimer,
        setIsBlockedToSendCode,
        setIsValidationActive, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalDescription, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDescriptionTitle, {
                        children: "Vamos proteger a sua conta?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDescriptionSubtitle, {
                        children: "Torne a sua navega\xe7\xe3o ainda mais segura com a verifica\xe7\xe3o em duas etapas. \xc9 bem r\xe1pido e pr\xe1tico, vamos come\xe7ar?"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBottom, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("login-modal-button")), {
                        text: "Confirmar",
                        buttonType: "button",
                        onClickAction: function() {
                            sendTokenByChannel(requestBody);
                        },
                        fontWeight: ui.theme.typography.fontWeight[400],
                        color: "".concat(ui.theme.colors.secondary[380]),
                        hoveredColor: "".concat(ui.theme.colors.secondary[350])
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoItLaterButton, {
                        onClick: handleCloseLoginAuthenticationModal,
                        children: "Deixar pra depois"
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/LoginAuthenticationModal/index.tsx














var LoginAuthenticationModal = function() {
    var ref;
    var ref1 = (0,state_manager/* useLoginAuthentication */.VQ)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            isLoginAuthenticationModalOpen: state.isLoginAuthenticationModalOpen,
            currentStep: state.currentStep,
            changeLoginStep: state.changeLoginStep,
            isPhoneValidationModalOpen: state.isPhoneValidationModalOpen
        };
    })), isLoginAuthenticationModalOpen = ref1.isLoginAuthenticationModalOpen, currentStep = ref1.currentStep, changeLoginStep = ref1.changeLoginStep, isPhoneValidationModalOpen = ref1.isPhoneValidationModalOpen;
    var isRegisterPhoneNumberModalOpen = (0,state_manager/* useRegisterPhoneNumber */.KH)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            isRegisterPhoneNumberModalOpen: state.isRegisterPhoneNumberModalOpen
        };
    })).isRegisterPhoneNumberModalOpen;
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var ref2 = implementations/* profileApi.getClient */.c_.getClient(accessToken, !!accessToken), loggedClient = ref2.data;
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var router = (0,next_router.useRouter)();
    var isUniqueClientModalOpen = (0,state_manager/* useUniqueClient */.NG)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            isUniqueClientModalOpen: state.isUniqueClientModalOpen
        };
    })).isUniqueClientModalOpen;
    var ref3 = useLoginAuthenticationModal({
        accessToken: accessToken,
        loggedClient: loggedClient,
        notificationApi: implementations/* notificationApi */.E8
    }), handleCloseLoginAuthenticationModal = ref3.handleCloseLoginAuthenticationModal, handleValidateAccountInfo = ref3.handleValidateAccountInfo, sendTokenByChannel = ref3.sendTokenByChannel, isUnderAction = ref3.isUnderAction, hasError = ref3.hasError;
    var channelSelected = (0,state_manager/* useTwoFactor */.kD)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            channelSelected: state.channelSelected
        };
    })).channelSelected;
    // eslint-disable-next-line sonarjs/cognitive-complexity
    var renderAuthenticationContent = function() {
        switch(currentStep){
            case "firstStep":
                return isClientMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet/* BottomSheet */.R, {
                    alignItems: "center",
                    display: "flex",
                    title: "Verifica\xe7\xe3o em duas etapas",
                    textButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {}),
                    justifyContent: "space-between",
                    hasActionInHeader: true,
                    paddingContent: "16px 16px 0px",
                    containerHeight: "420px",
                    headerAction: handleCloseLoginAuthenticationModal,
                    noFooter: true,
                    formId: "form-new-address",
                    stateBottomSheet: isLoginAuthenticationModalOpen,
                    onDismiss: handleCloseLoginAuthenticationModal,
                    onCloseBottomSheet: handleCloseLoginAuthenticationModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.AuthenticationIcon, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody, {
                                loggedClient: loggedClient,
                                token: accessToken
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGeneral.ModalGeneral, {
                    ariaHideApp: false,
                    isOpen: isLoginAuthenticationModalOpen,
                    onCloseModal: handleCloseLoginAuthenticationModal,
                    ariaLabelForModal: "Verifica\xe7\xe3o em duas etapas",
                    title: "Verifica\xe7\xe3o em duas etapas",
                    bodyDescription: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.AuthenticationIcon, {}),
                    maxWidth: "489px",
                    bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody, {
                        loggedClient: loggedClient,
                        token: accessToken
                    }),
                    contentGap: "0"
                });
            case "secondStep":
                return isClientMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet/* BottomSheet */.R, {
                    alignItems: "center",
                    display: "flex",
                    title: "Verifica\xe7\xe3o em duas etapas",
                    noFooter: true,
                    textButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {}),
                    justifyContent: "space-between",
                    hasActionInHeader: true,
                    paddingContent: "16px 16px 0px",
                    containerHeight: "420px",
                    headerAction: handleCloseLoginAuthenticationModal,
                    formId: "form-new-address",
                    stateBottomSheet: isLoginAuthenticationModalOpen,
                    onDismiss: handleCloseLoginAuthenticationModal,
                    onCloseBottomSheet: handleCloseLoginAuthenticationModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_2fa.TwoFactorContent, {
                        options: methods(changeLoginStep, sendTokenByChannel, loggedClient),
                        onClickIsInvalidClientInfo: function() {
                            return [];
                        },
                        handleSelectAnotherTwoFactorType: function() {
                            return changeLoginStep("verifyIdentity");
                        },
                        preventDefault: true,
                        noTitle: true,
                        sendCodeType: channelSelected === 1 ? "sms" : "email",
                        clientAction: "loginValidation",
                        email: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email),
                        phoneNumber: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber),
                        viewType: isClientMobile ? "component" : "modal",
                        canChooseAnotherTwoFactorMethod: true,
                        hasError: hasError,
                        isUnderAction: isUnderAction,
                        onClickFailureButton: function() {
                            router.push("/");
                        },
                        onCallAction: handleValidateAccountInfo
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(_2fa.TwoFactorContent, {
                    options: methods(changeLoginStep, sendTokenByChannel, loggedClient),
                    handleSelectAnotherTwoFactorType: function() {
                        return changeLoginStep("verifyIdentity");
                    },
                    onClickIsInvalidClientInfo: function() {
                        return [];
                    },
                    sendCodeType: channelSelected === 1 ? "sms" : "email",
                    clientAction: "loginValidation",
                    preventDefault: true,
                    email: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email),
                    phoneNumber: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber),
                    viewType: isClientMobile ? "component" : "modal",
                    canChooseAnotherTwoFactorMethod: true,
                    hasError: hasError,
                    isUnderAction: isUnderAction,
                    onClickFailureButton: function() {
                        router.push("/");
                    },
                    onCallAction: handleValidateAccountInfo
                });
            case "verifyIdentity":
                return isClientMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet/* BottomSheet */.R, {
                    alignItems: "center",
                    display: "flex",
                    title: "Verifica\xe7\xe3o em duas etapas",
                    noFooter: true,
                    formId: "form-new-address",
                    textButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {}),
                    justifyContent: "space-between",
                    hasActionInHeader: true,
                    paddingContent: "16px 16px 0px",
                    containerHeight: "420px",
                    headerAction: handleCloseLoginAuthenticationModal,
                    stateBottomSheet: isLoginAuthenticationModalOpen,
                    onDismiss: handleCloseLoginAuthenticationModal,
                    onCloseBottomSheet: handleCloseLoginAuthenticationModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_2fa.TwoFactorContent, {
                        options: methods(changeLoginStep, sendTokenByChannel, loggedClient),
                        noTitle: true,
                        onClickIsInvalidClientInfo: function() {
                            return [];
                        },
                        sendCodeType: "sms",
                        preventDefault: true,
                        clientAction: "loginValidation",
                        email: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email),
                        phoneNumber: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber),
                        viewType: isClientMobile ? "component" : "modal",
                        canChooseAnotherTwoFactorMethod: true,
                        isVerifyIdentity: true,
                        verifyIdentityTitle: "Verifica\xe7\xe3o de identidade",
                        hasError: hasError,
                        isUnderAction: isUnderAction,
                        onClickFailureButton: function() {
                            router.push("/");
                        },
                        onCallAction: handleValidateAccountInfo
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(_2fa.TwoFactorContent, {
                    options: methods(changeLoginStep, sendTokenByChannel, loggedClient),
                    onClickIsInvalidClientInfo: function() {
                        return [];
                    },
                    sendCodeType: "sms",
                    clientAction: "loginValidation",
                    email: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email),
                    phoneNumber: String(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.phoneNumber),
                    viewType: isClientMobile ? "component" : "modal",
                    canChooseAnotherTwoFactorMethod: true,
                    isVerifyIdentity: true,
                    preventDefault: true,
                    verifyIdentityTitle: "Verifica\xe7\xe3o de identidade",
                    hasError: hasError,
                    isUnderAction: isUnderAction,
                    onClickFailureButton: function() {
                        router.push("/");
                    },
                    onCallAction: handleValidateAccountInfo
                });
            default:
                return null;
        }
    };
    if (isUniqueClientModalOpen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UniqueClient, {});
    }
    if (isRegisterPhoneNumberModalOpen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterPhoneNumber/* RegisterPhoneNumber */.n, {});
    }
    if (isPhoneValidationModalOpen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneValidation, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: renderAuthenticationContent()
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/CartButton/ModalItems/ItemProductCartModal/styles.ts

function ItemProductCartModal_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    ItemProductCartModal_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ItemProductCartModal_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 !important;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    ItemProductCartModal_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ItemProductCartModal_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      pointer-events: none;\n    "
    ]);
    ItemProductCartModal_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ItemProductCartModal_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  margin: 0 !important;\n  padding: 1.4rem;\n  display: flex;\n  border-bottom: thin solid ",
        ";\n\n  ",
        "\n"
    ]);
    ItemProductCartModal_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ItemProductCartModal_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 5.8rem;\n  max-height: 5.8rem;\n  min-width: 5.8rem;\n  min-height: 5.8rem;\n"
    ]);
    ItemProductCartModal_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ItemProductCartModal_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: 200;\n  margin-bottom: 1rem;\n"
    ]);
    ItemProductCartModal_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ItemProductCartModal_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    ItemProductCartModal_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ItemProductCartModal_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: 600;\n  text-align: end;\n  color: ",
        ";\n"
    ]);
    ItemProductCartModal_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ItemProductCartModal_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ItemProductCartModal_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ItemProductCartModal_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  font-size: ",
        ";\n  font-weight: 200;\n"
    ]);
    ItemProductCartModal_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ItemProductCartModal_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  border: none;\n  background: none;\n  justify-content: flex-end;\n"
    ]);
    ItemProductCartModal_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ItemProductCartModal_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1.5rem;\n  height: 1.5rem;\n  padding-top: 0.1rem;\n\n  margin-right: 0.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    ItemProductCartModal_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var SectionDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SectionDescription",
    componentId: "sc-c5774a7c-0"
})(ItemProductCartModal_styles_templateObject());
var ExtraInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ExtraInfo",
    componentId: "sc-c5774a7c-1"
})(ItemProductCartModal_styles_templateObject1());
var ContainerCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ContainerCard",
    componentId: "sc-c5774a7c-2"
})(ItemProductCartModal_styles_templateObject3(), ui.theme.colors.neutral.white, ui.theme.colors.neutral[95], function(param) {
    var isDeleting = param.isDeleting;
    return isDeleting && (0,styled_components_browser_esm/* css */.iv)(ItemProductCartModal_styles_templateObject2());
});
var BoxImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxImage",
    componentId: "sc-c5774a7c-3"
})(ItemProductCartModal_styles_templateObject4());
var DescriptionProduct = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__DescriptionProduct",
    componentId: "sc-c5774a7c-4"
})(ItemProductCartModal_styles_templateObject5(), ui.theme.typography.fontSize.sm.x3);
var DescriptionValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DescriptionValue",
    componentId: "sc-c5774a7c-5"
})(ItemProductCartModal_styles_templateObject6(), ui.theme.typography.fontSize.sm.x3, ui.theme.colors.neutral[520]);
var TextPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TextPrice",
    componentId: "sc-c5774a7c-6"
})(ItemProductCartModal_styles_templateObject7(), ui.theme.typography.fontSize.sm.x3, ui.theme.colors.primary[200]);
var PriceValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__PriceValue",
    componentId: "sc-c5774a7c-7"
})(ItemProductCartModal_styles_templateObject8());
var ProductInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ProductInfo",
    componentId: "sc-c5774a7c-8"
})(ItemProductCartModal_styles_templateObject9(), ui.theme.typography.fontSize.sm.x3);
var ButtonIcon = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonIcon",
    componentId: "sc-c5774a7c-9"
})(ItemProductCartModal_styles_templateObject10());
// export const  = styled.section`
//   background-color: ${theme.colors.neutral.white};
//   border-radius: 4px;
//   padding: 1.5rem;
//   display: flex;
//   gap: 1rem;
//   @media ${theme.device.desktopFirst.tablet} {
//     flex-direction: column;
//   }
// `;
var IconBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__IconBox",
    componentId: "sc-c5774a7c-10"
})(ItemProductCartModal_styles_templateObject11());

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/CartButton/ModalItems/ItemProductCartModal/index.tsx










var packageDescriptionUnitySingular = "Caixa";
var packageDescriptionUnityPlural = "Caixas";
var ItemProductCartModal = function(param) {
    var productId = param.productId, _quantity = param.quantity, quantity = _quantity === void 0 ? 1 : _quantity, // packagePrice,
    productIdCart = param.productIdCart, deleteAction = param.deleteAction, giftProduct = param.giftProduct, productInCart = param.productInCart, clientId = param.clientId;
    var ref = (0,react.useState)(new Set()), deletingItems = ref[0], setDeletingItems = ref[1];
    var thumbImage = productInCart === null || productInCart === void 0 ? void 0 : productInCart.imageUrl;
    // const PACKAGE_CURRENT = data?.prices?.find(
    //   (item) => item?.packingLevel === packagePrice
    // );
    var factPackaged = productInCart === null || productInCart === void 0 ? void 0 : productInCart.factPackaged;
    var measuredUnity = productInCart === null || productInCart === void 0 ? void 0 : productInCart.measuredUnity;
    var FINAL_QUANTITY = factPackaged > 0 ? quantity * factPackaged : quantity;
    var priceProduct = (0,application/* filterValueProductPricePackage */.IJK)({
        priceList: (productInCart === null || productInCart === void 0 ? void 0 : productInCart.priceList) || 0,
        salePrice: (productInCart === null || productInCart === void 0 ? void 0 : productInCart.salePrice) || 0,
        spotPrice: (productInCart === null || productInCart === void 0 ? void 0 : productInCart.spotPrice) || 0
    }) || 0;
    var removeFromCartAnalyticEvent = (0,react.useCallback)(function() {
        if (!(productInCart === null || productInCart === void 0 ? void 0 : productInCart.id)) {
            return;
        }
        implementations/* gtag */.SX === null || implementations/* gtag */.SX === void 0 ? void 0 : implementations/* gtag.removeFromCart */.SX.removeFromCart({
            itemId: productInCart === null || productInCart === void 0 ? void 0 : productInCart.productId,
            quantity: quantity,
            itemName: productInCart === null || productInCart === void 0 ? void 0 : productInCart.description,
            itemBrand: productInCart === null || productInCart === void 0 ? void 0 : productInCart.brand,
            itemCategory: productInCart === null || productInCart === void 0 ? void 0 : productInCart.categoryName,
            itemVariant: productInCart === null || productInCart === void 0 ? void 0 : productInCart.packingLevel,
            price: productInCart === null || productInCart === void 0 ? void 0 : productInCart.salePrice
        }, productInCart === null || productInCart === void 0 ? void 0 : productInCart.salePrice, clientId);
    }, [
        clientId,
        productInCart,
        quantity
    ]);
    var removeItemFromCart = (0,react.useCallback)(function() {
        setDeletingItems(function(prev) {
            return new Set(prev).add(productIdCart);
        });
        removeFromCartAnalyticEvent();
        deleteAction(productIdCart);
    }, [
        deleteAction,
        productIdCart,
        removeFromCartAnalyticEvent
    ]);
    // Adicionei esse useEffect para remover o item do Set quando o produto for deletado afim de controlar o estado de isDeletingItem para quando existe mais de um item com o mesmo productId no carrinho, como por ex: Prego (caixa) e Prego (Saco)
    (0,react.useEffect)(function() {
        if (!productInCart) {
            setDeletingItems(function(prev) {
                var newSet = new Set(prev);
                newSet.delete(productIdCart);
                return newSet;
            });
        }
    }, [
        productInCart,
        productIdCart
    ]);
    var isDeletingItem = deletingItems.has(productIdCart);
    var isPackage = !!(productInCart === null || productInCart === void 0 ? void 0 : productInCart.package);
    var getPackagingDescriptionUnity = (0,react.useCallback)(function() {
        if (quantity > 1) {
            return isPackage ? packageDescriptionUnityPlural : productInCart === null || productInCart === void 0 ? void 0 : productInCart.descriptionPackagingUnitPlural;
        }
        return isPackage ? packageDescriptionUnitySingular : productInCart === null || productInCart === void 0 ? void 0 : productInCart.descriptionPackagingUnitSingular;
    }, [
        isPackage,
        productInCart,
        quantity
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-".concat(productId, "}"))), {
        isDeleting: isDeletingItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-link-".concat(productId, "}"))), {
                href: "/produto/".concat(productId, "/").concat((0,application/* formatStringUrl */.Ess)((productInCart === null || productInCart === void 0 ? void 0 : productInCart.description) || (giftProduct === null || giftProduct === void 0 ? void 0 : giftProduct.productName) || "")),
                target: "_self",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxImage, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-image-".concat(productId, "}"))), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* Image */.E, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-image-".concat(productId))), {
                        src: (giftProduct === null || giftProduct === void 0 ? void 0 : giftProduct.imageUrl) || thumbImage || "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb/default/default_thumb.svg",
                        width: "100%",
                        height: "100%",
                        alt: "Imagem do produto",
                        layout: "responsive"
                    }))
                }))
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionDescription, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-section-description-".concat(productId))), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductInfo, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-product-info-".concat(productId))), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-link-description-".concat(productId))), {
                                href: "/produto/".concat(productId, "/").concat((0,application/* formatStringUrl */.Ess)((productInCart === null || productInCart === void 0 ? void 0 : productInCart.description) || (giftProduct === null || giftProduct === void 0 ? void 0 : giftProduct.productName) || "")),
                                target: "_self",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionProduct, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-description-".concat(productId))), {
                                    children: (productInCart === null || productInCart === void 0 ? void 0 : productInCart.description) || (giftProduct === null || giftProduct === void 0 ? void 0 : giftProduct.productName)
                                }))
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIcon, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-button-icon-".concat(productId))), {
                                onClick: function() {
                                    return removeItemFromCart();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Bin, {
                                    height: 20,
                                    width: 20,
                                    color: ui.theme.colors.neutral[400]
                                })
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExtraInfo, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-extra-info-".concat(productId))), {
                        children: [
                            giftProduct ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(DescriptionValue, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-description-value-".concat(productId))), {
                                children: [
                                    quantity,
                                    " Unidade",
                                    quantity > 1 && "s"
                                ]
                            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionValue, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-description-value-".concat(productId))), {
                                children: factPackaged > 0 ? "".concat(quantity, " ").concat(quantity > 1 ? "embalagens de ".concat(factPackaged).concat(measuredUnity) : "embalagem de ".concat(factPackaged).concat(measuredUnity)) : "".concat(quantity, " ").concat(getPackagingDescriptionUnity())
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceValue, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-price-value-".concat(productId))), {
                                children: giftProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextPrice, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-text-price-".concat(productId))), {
                                    children: (0,application/* formatCurrency */.xGv)((giftProduct === null || giftProduct === void 0 ? void 0 : giftProduct.price) || 0)
                                })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextPrice, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-text-price-".concat(productId))), {
                                            children: "".concat((0,application/* formatCurrency */.xGv)(priceProduct * (FINAL_QUANTITY || 1)), " ").concat((productInCart === null || productInCart === void 0 ? void 0 : productInCart.spotPrice) ? "\xe0 vista" : "")
                                        })),
                                        (productInCart === null || productInCart === void 0 ? void 0 : productInCart.salePrice) === priceProduct ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(TextPrice, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-second-text-price-".concat(productId))), {
                                            children: " ou ".concat((0,application/* formatCurrency */.xGv)(((productInCart === null || productInCart === void 0 ? void 0 : productInCart.salePrice) || 0) * (FINAL_QUANTITY || 1)))
                                        }))
                                    ]
                                })
                            }))
                        ]
                    }))
                ]
            }))
        ]
    }));
};
/* harmony default export */ var ModalItems_ItemProductCartModal = (ItemProductCartModal);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/CartButton/ModalItems/styles.ts

function ModalItems_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    opacity: 0;\n    visibility: hidden;\n    top: 4rem;\n  }\n\n  100% {\n    opacity: 1;\n    visibility: visible;\n    top: 6rem;\n  }\n"
    ]);
    ModalItems_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          animation: ",
        " 0.2s ease-in-out;\n        "
    ]);
    ModalItems_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 1rem;\n  top: 6rem;\n  border-radius: 4px;\n  z-index: 1;\n  visibility: ",
        ";\n  opacity: ",
        ";\n  flex-direction: column;\n  width: 40rem;\n  box-shadow: 0 6px 36px 0 rgb(0 0 0 / 20%);\n  z-index: 7;\n  transition: visibility 0.2s ease-in-out, opacity 0.2s ease-in-out;\n  background-color: ",
        ";\n  ",
        "\n"
    ]);
    ModalItems_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  font-size: 1.25rem;\n  font-weight: 400;\n  cursor: pointer;\n"
    ]);
    ModalItems_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1.5rem;\n  height: 1.5rem;\n  transform: rotate(45deg);\n  position: absolute;\n  top: -0.4rem;\n  right: 1rem;\n"
    ]);
    ModalItems_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  /* justify-content: ",
        "; */\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 4px 4px 0 0;\n\n  padding: 1rem 1.2rem;\n  background: ",
        ";\n\n  ",
        " {\n    background: ",
        ";\n  }\n"
    ]);
    ModalItems_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  font-size: 1.5rem;\n  color: ",
        ";\n  text-align: left;\n  font-weight: 400;\n"
    ]);
    ModalItems_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  color: ",
        ";\n  text-align: left;\n"
    ]);
    ModalItems_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem;\n  background-color: ",
        ";\n"
    ]);
    ModalItems_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.2rem;\n  color: ",
        ";\n"
    ]);
    ModalItems_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 30rem;\n  overflow: auto;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    ModalItems_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  font-size: 1rem;\n  color: ",
        ";\n"
    ]);
    ModalItems_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.25rem;\n  color: ",
        ";\n  font-weight: 400;\n"
    ]);
    ModalItems_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: flex-end !important;\n  align-items: flex-end !important;\n"
    ]);
    ModalItems_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: baseline !important;\n"
    ]);
    ModalItems_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border: none;\n  border-radius: 4px;\n  padding: 1rem 1.2rem;\n  cursor: pointer;\n  color: ",
        ";\n  font-size: 1.5rem;\n  height: 48px;\n  width: 100% !important;\n  min-width: 100%;\n  background-color: ",
        " !important;\n  transition: background-color 0.2s ease-in-out;\n\n  &:hover {\n    background-color: ",
        " !important;\n  }\n"
    ]);
    ModalItems_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 0 0 4px 4px;\n\n  background-color: ",
        " !important;\n  padding: 1rem;\n"
    ]);
    ModalItems_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    ModalItems_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function ModalItems_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ModalItems_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}



var showModalCartAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(ModalItems_styles_templateObject());
var ModalCart = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "styles__ModalCart",
    componentId: "sc-5be4064b-0"
})(ModalItems_styles_templateObject2(), function(param) {
    var visible = param.visible;
    return visible ? "visible" : "hidden";
}, function(param) {
    var visible = param.visible;
    return visible ? "1" : "0";
}, ui.theme.colors.neutral.white, function(param) {
    var visible = param.visible;
    return visible ? (0,styled_components_browser_esm/* css */.iv)(ModalItems_styles_templateObject1(), showModalCartAnimation) : null;
});
var ButtonCart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ButtonCart",
    componentId: "sc-5be4064b-1"
})(ModalItems_styles_templateObject3(), ui.theme.colors.neutral.white);
var ArrowItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ArrowItem",
    componentId: "sc-5be4064b-2"
})(ModalItems_styles_templateObject4());
var HeaderModalCart = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__HeaderModalCart",
    componentId: "sc-5be4064b-3"
})(ModalItems_styles_templateObject5(), function(param) {
    var alignAtTheEnd = param.alignAtTheEnd;
    return alignAtTheEnd ? "flex-end" : "flex-start";
}, ui.theme.colors.primary[200], ArrowItem, ui.theme.colors.primary[200]);
var DescriptionEmptyCartProduct = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__DescriptionEmptyCartProduct",
    componentId: "sc-5be4064b-4"
})(ModalItems_styles_templateObject6(), ui.theme.colors.neutral.white);
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Description",
    componentId: "sc-5be4064b-5"
})(ModalItems_styles_templateObject7(), ui.theme.colors.neutral.white);
var BoxEmpty = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxEmpty",
    componentId: "sc-5be4064b-6"
})(ModalItems_styles_templateObject8(), ui.theme.colors.neutral.white);
var DescriptionEmptyCart = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DescriptionEmptyCart",
    componentId: "sc-5be4064b-7"
})(ModalItems_styles_templateObject9(), ui.theme.colors.neutral[400]);
var ContentModalCart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ContentModalCart",
    componentId: "sc-5be4064b-8"
})(ModalItems_styles_templateObject10(), ui.theme.colors.neutral[300]);
var DescriptionTitleSub = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DescriptionTitleSub",
    componentId: "sc-5be4064b-9"
})(ModalItems_styles_templateObject11(), ui.theme.colors.neutral[900]);
var DescriptionPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DescriptionPrice",
    componentId: "sc-5be4064b-10"
})(ModalItems_styles_templateObject12(), ui.theme.colors.neutral[450]);
var BoxExtraInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxExtraInfo",
    componentId: "sc-5be4064b-11"
})(ModalItems_styles_templateObject13());
var ColumnInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ColumnInfo",
    componentId: "sc-5be4064b-12"
})(ModalItems_styles_templateObject14());
var styles_Button = (0,styled_components_browser_esm/* default */.ZP)(ButtonSubmit/* ButtonSubmit */.G).withConfig({
    displayName: "styles__Button",
    componentId: "sc-5be4064b-13"
})(ModalItems_styles_templateObject15(), ui.theme.colors.neutral.white, ui.theme.colors.secondary[300], ui.theme.colors.secondary[315]);
var FooterModalCart = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    displayName: "styles__FooterModalCart",
    componentId: "sc-5be4064b-14"
})(ModalItems_styles_templateObject16(), ui.theme.colors.neutral[50]);
var ModalItems_styles_CloseButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CloseButton",
    componentId: "sc-5be4064b-15"
})(ModalItems_styles_templateObject17());
var ModalItems_styles_CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.CloseIcon).attrs(function() {
    return {
        color: ui.theme.colors.neutral.white,
        width: 20,
        height: 20
    };
}).withConfig({
    displayName: "styles__CloseIcon",
    componentId: "sc-5be4064b-16"
})(ModalItems_styles_templateObject18());

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/CartButton/ModalItems/index.tsx












var ModalItems = function(param) {
    var isOpen = param.isOpen, deleteAction = param.deleteAction, navigate = param.navigate, closeModal = param.closeModal, userHasValidPhoneNumberRegistered = param.userHasValidPhoneNumberRegistered, isLoadingUserPhoneNumber = param.isLoadingUserPhoneNumber;
    var router = (0,next_router.useRouter)();
    var userData = (0,application/* useAuth */.aCi)().userData;
    var ref = (0,application/* useCartContext */.iQs)(), cartItems = ref.cartItems, clientId = ref.clientId, totalSalePrice = ref.totalSalePrice;
    var timeInSeconds = (0,application/* useCountdown */.au2)().timeInSeconds;
    var ref1 = (0,application/* useModalGroup */.IzY)(), handleOpenModalToConfirmEmail = ref1.handleOpenModalToConfirmEmail, sendOrResendEmailConfirmation = ref1.sendOrResendEmailConfirmation;
    var ref2 = (0,react.useState)(false), modalItemsUnderAction = ref2[0], setModalItemsUnderAction = ref2[1];
    var cartItem = cartItems;
    var productsInCart = cartItem === null || cartItem === void 0 ? void 0 : cartItem.filter(function(item) {
        return !(item === null || item === void 0 ? void 0 : item.listId);
    });
    var GIFTS_ITEMS = cartItem === null || cartItem === void 0 ? void 0 : cartItem.filter(function(item) {
        return item.listId;
    });
    var giftProductsParams = GIFTS_ITEMS === null || GIFTS_ITEMS === void 0 ? void 0 : GIFTS_ITEMS.reduce(function(result, item) {
        var existingItem = result.find(function(listItem) {
            return listItem.listId === item.listId;
        });
        if (existingItem) {
            existingItem.productKeys.push({
                packaging: item.package,
                branchId: item.branchId,
                productId: item.productId,
                sellerId: item.sellerId
            });
        } else {
            result.push({
                listId: item.listId,
                productKeys: [
                    {
                        packaging: item.package,
                        branchId: item.branchId,
                        productId: item.productId,
                        sellerId: item.sellerId
                    }, 
                ]
            });
        }
        return result;
    }, []);
    var accessToken = implementations/* cookie.getCookie */.pR.getCookie({
        name: "@FC:Ecom:Token:Access"
    });
    var ref3 = implementations/* weddingGiftListApi.getGiftProduct */._6.getGiftProduct(giftProductsParams, accessToken, !!(giftProductsParams === null || giftProductsParams === void 0 ? void 0 : giftProductsParams.length)), giftProducts = ref3.data;
    var giftItensWithProducts = GIFTS_ITEMS === null || GIFTS_ITEMS === void 0 ? void 0 : GIFTS_ITEMS.map(function(giftItem) {
        var giftProduct = giftProducts === null || giftProducts === void 0 ? void 0 : giftProducts.find(function(item) {
            return item.productId === giftItem.productId;
        });
        return giftProduct ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, giftItem), {
            giftProduct: giftProduct
        }) : giftItem;
    });
    var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
        return state.allConfigs;
    });
    var handleFinishOrder = (0,react.useCallback)(function(userAccessToken, thereIsPhoneNumberRegistered, nextRouter) {
        setModalItemsUnderAction(true);
        if (!userAccessToken) {
            nextRouter.push({
                pathname: "/login",
                query: {
                    redirectTo: "/checkout/pagamento"
                }
            });
            setModalItemsUnderAction(false);
            return;
        }
        if ((allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isEmailConfirmationAvailable) === "true" && !(userData === null || userData === void 0 ? void 0 : userData.email_verified)) {
            handleOpenModalToConfirmEmail(String((nextRouter === null || nextRouter === void 0 ? void 0 : nextRouter.route) || "/checkout/meu-carrinho"));
            sendOrResendEmailConfirmation(userData === null || userData === void 0 ? void 0 : userData.email, timeInSeconds === 0 || timeInSeconds === 60);
            setModalItemsUnderAction(false);
            return;
        }
        nextRouter.push("/checkout/pagamento");
        setModalItemsUnderAction(false);
    }, [
        allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isEmailConfirmationAvailable,
        handleOpenModalToConfirmEmail,
        sendOrResendEmailConfirmation,
        timeInSeconds,
        userData === null || userData === void 0 ? void 0 : userData.email,
        userData === null || userData === void 0 ? void 0 : userData.email_verified, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalCart, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-cart-container")), {
        visible: isOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderModalCart, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-modal-cart")), {
                alignAtTheEnd: Boolean(cartItems === null || cartItems === void 0 ? void 0 : cartItems.length),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalItems_styles_CloseButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("close-button")), {
                        onClick: function() {
                            return closeModal();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalItems_styles_CloseIcon, {})
                    })),
                    (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonCart, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-cart-modal-cart")), {
                        onClick: navigate,
                        children: [
                            "ver carrinho",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowRight, {
                                alt: "Seta para a direita",
                                height: 20,
                                width: 20,
                                color: ui.theme.colors.neutral.white
                            })
                        ]
                    })) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowItem, {})
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentModalCart, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("content-modal-cart")), {
                children: (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        (productsInCart === null || productsInCart === void 0 ? void 0 : productsInCart.length) ? productsInCart === null || productsInCart === void 0 ? void 0 : productsInCart.map(function(item, index) {
                            /*#__PURE__*/ return (0,react.createElement)(ModalItems_ItemProductCartModal, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-".concat(index))), {
                                deleteAction: deleteAction,
                                key: "".concat(item.cartId, "#").concat(item === null || item === void 0 ? void 0 : item.productId),
                                productId: item.productId,
                                productIdCart: item.id,
                                quantity: item.quantity,
                                // packagePrice={item.package}
                                productInCart: item,
                                clientId: clientId
                            }));
                        }) : null,
                        giftItensWithProducts.length ? giftItensWithProducts === null || giftItensWithProducts === void 0 ? void 0 : giftItensWithProducts.map(function(item, index) {
                            /*#__PURE__*/ return (0,react.createElement)(ModalItems_ItemProductCartModal, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("item-product-cart-modal-".concat(index))), {
                                deleteAction: deleteAction,
                                key: "".concat(item.cartId, "#").concat(item === null || item === void 0 ? void 0 : item.productId),
                                productId: item.productId,
                                productIdCart: item.id,
                                quantity: item === null || item === void 0 ? void 0 : item.quantity,
                                // packagePrice={item?.giftProduct?.price}
                                giftProduct: item.giftProduct,
                                clientId: clientId
                            }));
                        }) : null
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxEmpty, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-empty")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CartIcon, {
                            color: ui.theme.colors.neutral[600]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionEmptyCart, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("description-empty-cart")), {
                            children: "Seu carrinho est\xe1 vazio"
                        }))
                    ]
                }))
            })),
            (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterModalCart, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("footer-modal-cart")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnInfo, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("column-info")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionTitleSub, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("description-title-sub")), {
                                children: "SUBTOTAL"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionPrice, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("description-price")), {
                                children: (0,application/* formatCurrency */.xGv)(totalSalePrice || 0)
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxExtraInfo, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-extra-info")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Button, (0,src_object_spread/* default */.Z)({
                            text: "Fechar pedido",
                            textUnderAction: "Fechando pedido...",
                            isDisabled: isLoadingUserPhoneNumber,
                            underAction: modalItemsUnderAction,
                            onClickAction: function() {
                                return handleFinishOrder(accessToken, !!userHasValidPhoneNumberRegistered, router);
                            }
                        }, (0,application/* buildTestIds */.Fek)("button-close-order")))
                    }))
                ]
            })) : null
        ]
    }));
};
ModalItems.displayName = "CartButtonModalItems";
var CartButtonModalItemsWithUserPhoneNumberValidation = (0,hocs/* withUserPhoneNumberValidation */.XJ)(ModalItems);
/* harmony default export */ var CartButton_ModalItems = (CartButtonModalItemsWithUserPhoneNumberValidation);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/CartButton/styles.ts

function CartButton_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-width: 5rem;\n  @media ",
        " {\n    max-width: 4.2rem;\n  }\n"
    ]);
    CartButton_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartButton_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  background: ",
        ";\n  cursor: pointer;\n\n  transition: all 0.2s ease-in;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    CartButton_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CartButton_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      pointer-events: ",
        ";\n    "
    ]);
    CartButton_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CartButton_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n  width: 5rem;\n  height: 4.17rem;\n  border: 0;\n  border-radius: 4px;\n\n  ",
        "\n\n  @media ",
        " {\n    height: 3rem;\n    width: 3.75rem;\n    padding: 13px;\n  }\n\n  //larissa.ferreira n\xe3o utilizar inline-css\n  svg {\n    width: 28px;\n    height: 28px;\n  }\n"
    ]);
    CartButton_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CartButton_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CartButton_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CartButton_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  max-width: 2rem;\n  max-height: 2rem;\n  padding: 0.7rem 0.9rem;\n  /* height: 2.5rem; */\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  position: absolute;\n  right: -0.5rem;\n  bottom: -0.8rem;\n\n  background: ",
        ";\n  border-radius: 50%;\n  font-size: 1rem;\n  font-weight: 200;\n  color: ",
        ";\n  user-select: none;\n\n  @media ",
        " {\n    max-width: 1.9rem;\n    max-height: 1.9rem;\n    font-size: 0.9rem;\n  }\n"
    ]);
    CartButton_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var ContainerButton = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ContainerButton",
    componentId: "sc-7ecb1b7c-0"
})(CartButton_styles_templateObject(), ui.theme.device.desktopFirst.mobileL);
var BaseHyperLink = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__BaseHyperLink",
    componentId: "sc-7ecb1b7c-1"
})(CartButton_styles_templateObject1(), ui.theme.colors.primary[200], ui.theme.colors.primary[400]);
var CartHyperLink = (0,styled_components_browser_esm/* default */.ZP)(BaseHyperLink).withConfig({
    displayName: "styles__CartHyperLink",
    componentId: "sc-7ecb1b7c-2"
})(CartButton_styles_templateObject3(), function(param) {
    var isLoading = param.isLoading;
    return isLoading && (0,styled_components_browser_esm/* css */.iv)(CartButton_styles_templateObject2(), isLoading ? "none" : "initial");
}, ui.theme.device.desktopFirst.mobileL);
var CartIconUi = (0,styled_components_browser_esm/* default */.ZP)(ui.CartIcon).attrs({
    color: ui.theme.colors.neutral.white
}).withConfig({
    displayName: "styles__CartIconUi",
    componentId: "sc-7ecb1b7c-3"
})(CartButton_styles_templateObject4());
var CountItens = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__CountItens",
    componentId: "sc-7ecb1b7c-4"
})(CartButton_styles_templateObject5(), ui.theme.colors.secondary[265], ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.mobileL);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/CartButton/index.tsx








var CartButton = function() {
    var isClientMobile = (0,application/* useAppContext */.bp4)().isClientMobile;
    var modalToConfirmEmail = (0,application/* useModalGroup */.IzY)().modalToConfirmEmail;
    var ref = (0,application/* useCartContext */.iQs)(), cartItems = ref.cartItems, removeItemCart = ref.removeItemCart, cartId = ref.id, isGetCartLoading = ref.isGetCartLoading;
    var ref1 = (0,react.useState)(false), isOpenStatus = ref1[0], setStatusModal = ref1[1];
    var ModalCartRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var COUNT_ITEMS = (0,react.useMemo)(function() {
        return (cartItems === null || cartItems === void 0 ? void 0 : cartItems.reduce(function(previousSum, currentItem) {
            return currentItem.quantity + previousSum;
        }, 0)) || 0;
    }, [
        cartItems
    ]);
    var handleModal = function() {
        if (isClientMobile) {
            router.push("/checkout/meu-carrinho");
            return;
        }
        setStatusModal(function(state) {
            return !state;
        });
    };
    var handleRemoveItem = (0,react.useCallback)(function(idProductCart) {
        removeItemCart({
            idProductCart: idProductCart,
            cartId: cartId
        });
    }, [
        cartId,
        removeItemCart
    ]);
    var navigateCart = (0,react.useCallback)(function() {
        router.push("/checkout/meu-carrinho");
        setStatusModal(function(state) {
            return !state;
        });
    }, [
        router
    ]);
    // useEffect(() => {
    //   if (isOpenStatus) {
    //     fetchCart();
    //   }
    // }, [fetchCart, isOpenStatus]);
    (0,application/* useClickOutside */.O8h)({
        ref: ModalCartRef,
        callback: function() {
            if (isOpenStatus && !modalToConfirmEmail) {
                setStatusModal(false);
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-details-info-button-success")), {
        ref: ModalCartRef,
        className: "cart-btn",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartHyperLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("cart-hyper-link")), {
                onClick: handleModal,
                className: "cart-btn",
                isLoading: isGetCartLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIconUi, {
                    alt: "Carrinho"
                })
            })),
            COUNT_ITEMS ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CountItens, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("counter-itens")), {
                onClick: handleModal,
                children: COUNT_ITEMS > 99 ? "99+" : COUNT_ITEMS
            })) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton_ModalItems, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-item-header")), {
                navigate: navigateCart,
                isOpen: isOpenStatus,
                deleteAction: handleRemoveItem,
                closeModal: function() {
                    return setStatusModal(false);
                }
            }))
        ]
    }));
};


// EXTERNAL MODULE: ../../packages/application/context/Identity/AuthContext.tsx
var AuthContext = __webpack_require__(24452);
// EXTERNAL MODULE: ../../packages/components/backoffice/CustomHighlightCategories/style.ts
var CustomHighlightCategories_style = __webpack_require__(85865);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ListCategories/Inner/styles.ts

function Inner_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row wrap;\n  align-content: space-between;\n  height: fit-content;\n\n  @media (max-width: 1240px) {\n    gap: 10px 80px;\n    align-content: flex-start;\n    flex-wrap: wrap !important;\n    overflow: auto !important;\n    margin-left: 0 !important;\n  }\n"
    ]);
    Inner_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Inner_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 33.333%;\n  display: flex;\n  flex-direction: column;\n  white-space: initial;\n  margin: 0 0 2rem 0 !important;\n\n  // &:nth-of-type(3n + 1) {\n  //   order: 1;\n  // }\n  // &:nth-of-type(3n + 2) {\n  //   order: 2;\n  // }\n  // &:nth-of-type(3n) {\n  //   order: 3;\n  // }\n\n  @media (max-width: 1240px) {\n    /* max-width: 40%; */\n    width: 100%;\n    margin: 0 0 1rem 0 !important;\n\n    a {\n      white-space: pre-wrap;\n    }\n  }\n"
    ]);
    Inner_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Inner_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Inner_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Inner_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  cursor: pointer;\n  font-weight: bold;\n  background: transparent !important;\n  padding: 0 !important;\n  margin-bottom: 1rem;\n\n  &:hover {\n    color: none;\n    background: transparent !important;\n  }\n"
    ]);
    Inner_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Inner_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Inner_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Inner_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  height: auto !important;\n\n  @media (max-width: 1240px) {\n    flex-direction: column !important;\n    flex-flow: wrap !important;\n    margin: 0 !important;\n  }\n"
    ]);
    Inner_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Inner_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  color: ",
        ";\n  background: transparent !important;\n  transition: all 0.2s ease-in;\n  padding: 0.4rem 0.65rem 0.4rem 0;\n  line-height: 27px;\n  padding: 0 !important;\n\n  &:hover {\n    color: ",
        " !important;\n    background: transparent !important;\n  }\n\n  @media (max-width: 1240px) {\n    background-color: ",
        " !important;\n    border-radius: 100px !important;\n    padding: 0px 10px !important;\n    margin: 0 10px 10px 0;\n    font-weight: 400;\n\n    &:hover {\n      color: ",
        ";\n      background-color: ",
        " !important;\n    }\n  }\n"
    ]);
    Inner_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var ListCategoriesInnerWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ListCategoriesInnerWrapper",
    componentId: "sc-34f6c890-0"
})(Inner_styles_templateObject());
var ListCategoryInnerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ListCategoryInnerContainer",
    componentId: "sc-34f6c890-1"
})(Inner_styles_templateObject1());
var SubCategory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SubCategory",
    componentId: "sc-34f6c890-2"
})(Inner_styles_templateObject2());
var SubCategoryTitleLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "styles__SubCategoryTitleLink",
    componentId: "sc-34f6c890-3"
})(Inner_styles_templateObject3());
var SubCategoryTitle = (0,styled_components_browser_esm/* default */.ZP)(ui.Title).attrs({
    fontSize: ui.theme.typography.fontSize.sm.x7
}).withConfig({
    displayName: "styles__SubCategoryTitle",
    componentId: "sc-34f6c890-4"
})(Inner_styles_templateObject4());
var InnerItemsWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__InnerItemsWrapper",
    componentId: "sc-34f6c890-5"
})(Inner_styles_templateObject5());
var InnerItemTitleLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "styles__InnerItemTitleLink",
    componentId: "sc-34f6c890-6"
})(Inner_styles_templateObject6(), ui.theme.colors.neutral[520], ui.theme.colors.primary[100], ui.theme.colors.neutral[30], ui.theme.colors.neutral[520], ui.theme.colors.neutral[30]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ListCategories/styles.ts

function ListCategories_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 1.17rem;\n  height: 3.5rem;\n  color: ",
        ";\n  transition: color 0.2s ease-out;\n  width: 90%;\n  white-space: normal;\n"
    ]);
    ListCategories_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n"
    ]);
    ListCategories_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > path {\n    stroke-width: 1px;\n  }\n"
    ]);
    ListCategories_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 0.75rem 0.75rem 1.2rem;\n  width: 100%;\n  height: 3.417rem;\n  transition: all 0.2s ease-in;\n  cursor: pointer;\n  background-color: ",
        ";\n\n  &:hover {\n    background: ",
        ";\n\n    a {\n      color: ",
        " !important;\n    }\n\n    & > svg > path {\n      fill: ",
        ";\n    }\n  }\n\n  &:last-child {\n    border-bottom: 0;\n  }\n"
    ]);
    ListCategories_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer !important;\n\n  &:hover {\n    ",
        " {\n      color: ",
        ";\n    }\n\n    ",
        " {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    ListCategories_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        " !important;\n  align-items: start;\n"
    ]);
    ListCategories_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: start;\n  padding: 1.685rem 0 0.65rem;\n  transition: all 0.2s ease-in;\n  gap: ",
        ";\n\n  @media ",
        " {\n    padding: 1.667rem 0 1rem;\n\n    aside section {\n      justify-content: space-evenly !important;\n    }\n\n    aside section a strong {\n      display: none;\n    }\n  }\n\n  ",
        " {\n    display: flex;\n    gap: 3px;\n    align-items: start;\n  }\n\n  aside {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  aside section {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: ",
        ";\n\n    @media ",
        " {\n      margin: 0;\n    }\n  }\n\n  aside section a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    margin-right: 1rem;\n\n    transition: all 0.2s ease-in-out;\n\n    @media ",
        " {\n      margin-right: 0;\n    }\n  }\n\n  aside section a strong {\n    font-weight: bold;\n    font-size: 1.25rem;\n    color: ",
        ";\n    line-height: 1;\n  }\n"
    ]);
    ListCategories_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &::-webkit-tap-highlight-color {\n    color: none;\n    background: none;\n  }\n"
    ]);
    ListCategories_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  overflow-x: hidden;\n  /* overflow: hidden; */\n  top: -1px;\n  left: 20.3rem;\n  display: none;\n  width: 84.5rem;\n  /* height: calc(100% + 1.5px); */\n  min-height: 328px;\n  max-height: 533px;\n  height: fit-content;\n  margin: 0 !important;\n  padding: 1rem 2.167rem;\n  z-index: 99;\n  border: thin solid ",
        ";\n  border-radius: 0 0 4px 0;\n  background-color: ",
        ";\n\n  // @media (max-width: 1240px) {\n  //   width: calc(100vw - 20.5rem);\n  // }\n\n  @media ",
        " {\n    width: calc(100vw - 20.5rem);\n  }\n"
    ]);
    ListCategories_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column !important;\n  width: 100%;\n  margin-bottom: 1rem;\n"
    ]);
    ListCategories_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  grid-template-columns: 20.3rem 1fr;\n  align-items: center;\n  grid-template-columns: none;\n  /* height: 100%; */\n  padding-bottom: 1rem;\n  overflow: hidden;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  @media ",
        " {\n    max-height: 485px;\n  }\n"
    ]);
    ListCategories_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 2rem;\n  font-weight: bold;\n  padding-bottom: 0.5rem;\n  color: ",
        ";\n\n  @media ",
        " {\n    font-size: 1.65rem;\n  }\n"
    ]);
    ListCategories_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  width: 0;\n  height: 0;\n  opacity: 0;\n  display: none;\n  z-index: 99;\n  margin-top: 6rem;\n  transition: all 0.2s ease-in-out;\n  background-color: transparent;\n\n  @media ",
        " {\n    width: 20.4rem;\n    height: 2rem;\n    left: -15px;\n  }\n\n  @media ",
        " {\n    margin-top: 5rem;\n  }\n"
    ]);
    ListCategories_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 2;\n  list-style-type: none;\n  border-radius: 0 0 0 4px;\n  border: thin solid ",
        ";\n  position: relative;\n  min-height: 328px;\n  max-height: 533px;\n  height: 100%;\n  background-color: transparent;\n\n  @media ",
        ' {\n    min-width: 20.35rem;\n  }\n\n  &:before {\n    content: "";\n    width: 0;\n    height: 0;\n    border-left: 9.5px solid transparent;\n    border-right: 9.5px solid transparent;\n    border-bottom: 11px solid ',
        ';\n    position: absolute;\n    z-index: -1;\n    left: calc(100% - 19rem);\n    top: -11.2px;\n  }\n\n  &:after {\n    content: "";\n    width: 0;\n    height: 0;\n    border-left: 9.5px solid transparent;\n    border-right: 9.5px solid transparent;\n    border-bottom: 11px solid transparent;\n    position: absolute;\n    z-index: -2;\n    left: calc(100% - 19rem);\n    top: -11.2px;\n  }\n\n  ',
        " {\n    display: grid;\n    grid-template-columns: 20.3rem 1fr;\n    height: fit-content;\n    cursor: default !important;\n    border-bottom: 1px solid ",
        ";\n\n    &:last-of-type {\n      border-bottom: none;\n      border-radius: 8px;\n    }\n\n    &:hover {\n      ",
        " {\n        display: block;\n        overflow: hidden;\n      }\n    }\n  }\n"
    ]);
    ListCategories_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  cursor: default !important;\n"
    ]);
    ListCategories_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ListCategories_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 12.5rem;\n  display: flex;\n  flex: none;\n  align-items: center;\n  justify-content: left;\n  cursor: pointer;\n  position: relative;\n  height: 100%;\n\n  /* transition: all 0.2s ease-in; */\n\n  strong {\n    font-size: 1.33rem;\n    color: ",
        ";\n    margin-left: 0.5rem;\n  }\n\n  ",
        "\n\n  @media ",
        " {\n    width: 10.5rem;\n  }\n\n  @media ",
        " {\n    width: 10rem;\n\n    strong {\n      font-size: 1.33rem !important;\n    }\n  }\n"
    ]);
    ListCategories_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px !important;\n"
    ]);
    ListCategories_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"
    ]);
    ListCategories_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  white-space: nowrap;\n\n  section a {\n    text-decoration: none;\n    font-size: 1.167rem;\n    font-weight: 400;\n    padding: 0.4rem 0.65rem;\n    border-radius: 4px;\n    cursor: pointer;\n    letter-spacing: -0.03rem;\n\n    transition: all 0.2s ease-in;\n\n    &:hover {\n      background: ",
        ";\n    }\n  }\n\n  @media (max-width: 980px) {\n    section {\n      display: flex;\n      flex-flow: row nowrap;\n      width: 100%;\n      white-space: nowrap;\n      overflow-x: hidden;\n      overflow-y: hidden;\n\n      a {\n        padding: 0.25rem 0.38rem;\n      }\n    }\n  }\n\n  @media ",
        " {\n    section {\n      display: flex;\n      flex-flow: row nowrap;\n      width: 100%;\n      white-space: nowrap;\n      overflow-x: hidden;\n      overflow-y: hidden;\n    }\n\n    section a {\n      /* font-size: 0.75rem !important; */\n      padding: 0.4rem 0.65rem;\n    }\n  }\n\n  @media ",
        " {\n    section a {\n      font-size: 1.17rem !important;\n    }\n  }\n\n  @media ",
        " {\n    padding: 0 0rem 0.5rem 0rem !important;\n\n    section {\n      margin-left: 1.5rem;\n\n      a {\n        padding: 0.25rem 0.38rem;\n      }\n    }\n  }\n"
    ]);
    ListCategories_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1;\n  color: ",
        " !important;\n  transition: color 0.2s ease-in;\n"
    ]);
    ListCategories_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1;\n  color: ",
        " !important;\n  transition: color 0.2s ease-in;\n"
    ]);
    ListCategories_styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    ListCategories_styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function ListCategories_styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: ",
        ";\n  @media ",
        " {\n    padding-right: ",
        ";\n  }\n"
    ]);
    ListCategories_styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: ",
        ";\n"
    ]);
    styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        color: ",
        " !important;\n      }\n\n      ",
        " {\n        color: ",
        " !important;\n      }\n\n      ",
        " {\n        background-color: ",
        ";\n        border: 1px solid ",
        " !important;\n        border-radius: 2px;\n\n        ::before {\n          border-bottom: 11px solid ",
        " !important;\n        }\n\n        ",
        " {\n          border-bottom: ",
        " solid transparent !important;\n\n          &:hover {\n            ",
        " {\n              background-color: ",
        " !important;\n            }\n          }\n        }\n\n        ",
        " {\n          color: ",
        " !important;\n        }\n\n        ",
        " {\n          background: ",
        " !important;\n          border: thin solid transparent !important;\n\n          ",
        " {\n            background-color: ",
        ";\n          }\n\n          ",
        " {\n            will-change: border;\n            will-change: font-weight;\n            border: ",
        " solid transparent !important;\n\n            &:hover {\n              font-weight: bold !important;\n            }\n\n            @media (max-width: 1240px) {\n              background-color: transparent !important;\n\n              &:hover {\n                border: ",
        " solid\n                  ",
        " !important;\n                font-weight: initial !important;\n              }\n            }\n          }\n\n          * {\n            color: ",
        " !important;\n          }\n        }\n      }\n    "
    ]);
    styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function styles_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 1480px;\n\n  ",
        "\n"
    ]);
    styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function styles_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n"
    ]);
    styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
var ref, ref1;





var CategoryListedInDropdown = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "styles__CategoryListedInDropdown",
    componentId: "sc-74b3e3a4-0"
})(ListCategories_styles_templateObject(), ui.theme.colors.neutral[520]);
var ListCategoriesTitle = (0,styled_components_browser_esm/* default */.ZP)(ui.H1).withConfig({
    displayName: "styles__ListCategoriesTitle",
    componentId: "sc-74b3e3a4-1"
})(ListCategories_styles_templateObject1());
var ArrowRightIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowRight).attrs({
    height: "28px",
    width: "28px",
    color: ui.theme.colors.neutral[300]
}).withConfig({
    displayName: "styles__ArrowRightIcon",
    componentId: "sc-74b3e3a4-2"
})(ListCategories_styles_templateObject2());
var WrapperList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperList",
    componentId: "sc-74b3e3a4-3"
})(ListCategories_styles_templateObject3(), ui.theme.colors.neutral.white, ui.theme.colors.primary[100], ui.theme.colors.neutral.white, ui.theme.colors.neutral.white);
var DropdownContainerListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "styles__DropdownContainerListItem",
    componentId: "sc-74b3e3a4-4"
})(ListCategories_styles_templateObject4(), CategoryListedInDropdown, ui.theme.colors.neutral.white, WrapperList, ui.theme.colors.primary[100]);
var ContentHeaderWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ContentHeaderWrapper",
    componentId: "sc-74b3e3a4-5"
})(ListCategories_styles_templateObject5(), ui.theme.space.x2);
var ContentHeaderDesktop = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ContentHeaderDesktop",
    componentId: "sc-74b3e3a4-6"
})(ListCategories_styles_templateObject6(), ui.theme.space.x4, ui.theme.device.desktopFirst.laptop, ContentHeaderWrapper, ui.theme.space.x4, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.tablet, ui.theme.colors.neutral[999]);
var LinkWrapperUser = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "styles__LinkWrapperUser",
    componentId: "sc-74b3e3a4-7"
})(ListCategories_styles_templateObject7());
var SubMenuContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "styles__SubMenuContainer",
    componentId: "sc-74b3e3a4-8"
})(ListCategories_styles_templateObject8(), ui.theme.colors.neutral[315], ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.laptop);
var SubMenuContentHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__SubMenuContentHeader",
    componentId: "sc-74b3e3a4-9"
})(ListCategories_styles_templateObject9());
var SubMenuContent = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "styles__SubMenuContent",
    componentId: "sc-74b3e3a4-10"
})(ListCategories_styles_templateObject10(), ui.theme.device.desktopFirst.laptopL);
var CategoryTitle = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "styles__CategoryTitle",
    componentId: "sc-74b3e3a4-11"
})(ListCategories_styles_templateObject11(), ui.theme.colors.neutral[520], ui.theme.device.mobileFirst.tabletS);
var DropdownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DropdownContainer",
    componentId: "sc-74b3e3a4-12"
})(ListCategories_styles_templateObject12(), ui.theme.device.mobileFirst.tabletS, ui.theme.device.desktopFirst.tabletS);
var DropdownContainerList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "styles__DropdownContainerList",
    componentId: "sc-74b3e3a4-13"
})(ListCategories_styles_templateObject13(), ui.theme.colors.neutral[200], ui.theme.device.desktopFirst.tabletS, ui.theme.colors.neutral.white, DropdownContainerListItem, ui.theme.colors.neutral[200], SubMenuContainer);
var DropdownWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DropdownWrapper",
    componentId: "sc-74b3e3a4-14"
})(ListCategories_styles_templateObject14());
var CategoryNameContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__CategoryNameContainer",
    componentId: "sc-74b3e3a4-15"
})(ListCategories_styles_templateObject15());
// export const CategoryNameContainer = styled(
//   FlexContainer
// )<CategoryButtonDropdownProps>`
//   ${({ isDropdownOpen }) =>
//     isDropdownOpen &&
//     `
//     ~ ${DropdownContainer} {
//       opacity: 1 !important;
//       visibility: visible !important;
//     }
//   `}
// `;
var CategoryButtonDropDown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CategoryButtonDropDown",
    componentId: "sc-74b3e3a4-16"
})(ListCategories_styles_templateObject16(), ui.theme.colors.primary[200], function(param) {
    var isDropdownOpen = param.isDropdownOpen;
    return isDropdownOpen && "\n      ".concat(DropdownContainer, " {\n        opacity: 1 !important;\n        display: block !important;\n      }\n   ");
}, ui.theme.device.desktopFirst.laptop, ui.theme.device.desktopFirst.tablet);
var CategoryTitleSection = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    displayName: "styles__CategoryTitleSection",
    componentId: "sc-74b3e3a4-17"
})(ListCategories_styles_templateObject17());
var WelcomeText = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    displayName: "styles__WelcomeText",
    componentId: "sc-74b3e3a4-18"
})(ListCategories_styles_templateObject18());
var ContentHeaderCategoriesDesktop = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ContentHeaderCategoriesDesktop",
    componentId: "sc-74b3e3a4-19"
})(ListCategories_styles_templateObject19(), ui.theme.colors.neutral[100], ui.theme.device.desktopFirst.laptop, ui.theme.device.mobileFirst.laptopL, ui.theme.device.desktopFirst.tablet);
var EnterOrCreateAccountText = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    displayName: "styles__EnterOrCreateAccountText",
    componentId: "sc-74b3e3a4-20"
})(ListCategories_styles_templateObject20(), function(param) {
    var mouseOver = param.mouseOver;
    return mouseOver ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[999];
});
var WeddingGiftListText = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    displayName: "styles__WeddingGiftListText",
    componentId: "sc-74b3e3a4-21"
})(ListCategories_styles_templateObject21(), function(param) {
    var mouseOver = param.mouseOver;
    return mouseOver ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[999];
});
var DropdownContainerOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DropdownContainerOverlay",
    componentId: "sc-74b3e3a4-22"
})(ListCategories_styles_templateObject22());
var FcLogoBlackWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FcLogoBlackWrapper",
    componentId: "sc-74b3e3a4-23"
})(ListCategories_styles_templateObject23(), ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.space) === null || ref === void 0 ? void 0 : ref["x2.5"], ui.theme.device.desktopFirst.tablet, ui.theme === null || ui.theme === void 0 ? void 0 : (ref1 = ui.theme.space) === null || ref1 === void 0 ? void 0 : ref1.x0);
var ListCategoriesAside = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    displayName: "styles__ListCategoriesAside",
    componentId: "sc-74b3e3a4-24"
})(styles_templateObject24(), ui.theme.space.x6);
var ListCategoriesContainerHeader = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ListCategoriesContainerHeader",
    componentId: "sc-74b3e3a4-25"
})(styles_templateObject26(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject25(), WeddingGiftListText, ui.theme.colors.neutral[555], EnterOrCreateAccountText, ui.theme.colors.neutral[555], DropdownContainerList, ui.theme.colors.blackFriday[150], ui.theme.colors.blackFriday[100], ui.theme.colors.blackFriday[150], DropdownContainerListItem, ui.theme.space.xpx, WrapperList, ui.theme.colors.blackFriday[100], CategoryListedInDropdown, ui.theme.colors.blackFriday.white, SubMenuContainer, ui.theme.colors.blackFriday[100], Divider_styles/* Divider */.iz, ui.theme.colors.blackFriday[50], InnerItemTitleLink, ui.theme.space.xpx, ui.theme.space.xpx, ui.theme.colors.blackFriday.white, ui.theme.colors.blackFriday.white);
});
var HeaderUserActionsSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__HeaderUserActionsSection",
    componentId: "sc-74b3e3a4-26"
})(styles_templateObject27());

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/NavBarDesktop/styles.ts

function NavBarDesktop_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  width: 100%;\n  margin-top: ",
        ";\n\n  @media (max-width: 820px) {\n    padding: 0 !important;\n    flex-direction: column;\n  }\n\n  @media ",
        " {\n    padding: 0 0.75rem;\n  }\n"
    ]);
    NavBarDesktop_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavBarDesktop_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  gap: ",
        ";\n"
    ]);
    NavBarDesktop_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NavBarDesktop_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  text-align: left;\n  font-size: 1.167rem;\n\n  color: ",
        ";\n  cursor: pointer;\n\n  &:last-child {\n    span {\n      display: none;\n    }\n  }\n\n  @media (max-width: 820px) {\n    font-size: 1rem !important;\n    gap: 1rem;\n  }\n"
    ]);
    NavBarDesktop_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NavBarDesktop_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 1rem;\n\n  color: ",
        ";\n"
    ]);
    NavBarDesktop_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NavBarDesktop_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  position: relative;\n  cursor: pointer;\n  align-items: center;\n\n  &:after {\n    content: "";\n    width: 0;\n    height: 0;\n    border-right: 4px solid transparent;\n    border-top: 7px solid;\n    border-top-color: inherit;\n    border-left: 4px solid transparent;\n    position: relative;\n    left: 8px;\n    align-self: center;\n    top: 1px;\n    color: ',
        ";\n  }\n"
    ]);
    NavBarDesktop_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NavBarDesktop_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  font-size: 0.825rem;\n  position: relative;\n  height: 2.7rem;\n"
    ]);
    NavBarDesktop_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NavBarDesktop_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 4px;\n  color: ",
        ";\n"
    ]);
    NavBarDesktop_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NavBarDesktop_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.125rem;\n  margin-right: 4px;\n\n  @media ",
        " {\n    font-size: 1rem;\n  }\n"
    ]);
    NavBarDesktop_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var NavBarDesktopContainer = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "styles__NavBarDesktopContainer",
    componentId: "sc-83982c26-0"
})(NavBarDesktop_styles_templateObject(), function(param) {
    var isPageWeddingList = param.isPageWeddingList;
    return isPageWeddingList ? 0 : "0";
}, ui.theme.device.desktopFirst.laptop);
var ContentCompanyProducts = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ContentCompanyProducts",
    componentId: "sc-83982c26-1"
})(NavBarDesktop_styles_templateObject1(), function(param) {
    var isPageWeddingList = param.isPageWeddingList;
    return isPageWeddingList ? "1rem" : "2rem";
});
var CompanyProductLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "styles__CompanyProductLink",
    componentId: "sc-83982c26-2"
})(NavBarDesktop_styles_templateObject2(), function(param) {
    var isPageWeddingList = param.isPageWeddingList;
    return isPageWeddingList ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[999];
});
var DividerCompanyProducts = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DividerCompanyProducts",
    componentId: "sc-83982c26-3"
})(NavBarDesktop_styles_templateObject3(), function(param) {
    var isPageWeddingList = param.isPageWeddingList;
    return isPageWeddingList ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[999];
});
var ContentLocation = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__ContentLocation",
    componentId: "sc-83982c26-4"
})(NavBarDesktop_styles_templateObject4(), function(param) {
    var arrowDownColor = param.arrowDownColor;
    return arrowDownColor || "initial";
});
var RegionText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__RegionText",
    componentId: "sc-83982c26-5"
})(NavBarDesktop_styles_templateObject5(), function(param) {
    var isPageWeddingList = param.isPageWeddingList;
    return isPageWeddingList ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[900];
});
var RegionClientLocation = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    displayName: "styles__RegionClientLocation",
    componentId: "sc-83982c26-6"
})(NavBarDesktop_styles_templateObject6(), function(param) {
    var isPageWeddingList = param.isPageWeddingList;
    return isPageWeddingList ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[999];
});
var LocationIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.MapPin).withConfig({
    displayName: "styles__LocationIcon",
    componentId: "sc-83982c26-7"
})(NavBarDesktop_styles_templateObject7(), ui.theme.device.desktopFirst.tablet);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/mobile/NavBarMobile/styles.ts

function NavBarMobile_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 3rem;\n"
    ]);
    NavBarMobile_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavBarMobile_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 4px;\n  color: ",
        ";\n"
    ]);
    NavBarMobile_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NavBarMobile_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    NavBarMobile_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NavBarMobile_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: center;\n"
    ]);
    NavBarMobile_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NavBarMobile_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 1.125rem;\n  margin-right: 4px;\n"
    ]);
    NavBarMobile_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var NavBarMobileContainer = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "styles__NavBarMobileContainer",
    componentId: "sc-1498b917-0"
})(NavBarMobile_styles_templateObject());
var styles_RegionText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__RegionText",
    componentId: "sc-1498b917-1"
})(NavBarMobile_styles_templateObject1(), function(param) {
    var isPageWeddingList = param.isPageWeddingList;
    return isPageWeddingList ? ui.theme.colors.neutral.white : "";
});
var RegionTextStrong = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    displayName: "styles__RegionTextStrong",
    componentId: "sc-1498b917-2"
})(NavBarMobile_styles_templateObject2());
var styles_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__Wrapper",
    componentId: "sc-1498b917-3"
})(NavBarMobile_styles_templateObject3());
var styles_LocationIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.MapPin).withConfig({
    displayName: "styles__LocationIcon",
    componentId: "sc-1498b917-4"
})(NavBarMobile_styles_templateObject4(), ui.theme.colors.primary[200]);

// EXTERNAL MODULE: ../../packages/components/patterns/Header/components/mobile/SidebarMenuMobile/styles.ts
var SidebarMenuMobile_styles = __webpack_require__(32191);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/styles.ts

function Header_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100%;\n  box-shadow: 0 2px 2px 0 ",
        ";\n  background-color: ",
        ";\n\n  @media ",
        " {\n    min-height: 19vh;\n  }\n"
    ]);
    Header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  z-index: 99;\n  section {\n    width: 100%;\n    height: 100%;\n  }\n\n  main {\n    background-color: transparent;\n  }\n"
    ]);
    Header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    transform: scale(0.95);\n    margin-left: 0.25rem;\n  }\n"
    ]);
    Header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 12.5rem;\n  height: 4.667rem;\n  cursor: pointer;\n  margin-right: 0.75rem;\n\n  transition: all 0.2s ease-in;\n\n  &:hover {\n    opacity: 0.75;\n  }\n\n  @media ",
        " {\n    width: 10rem;\n    height: 4rem;\n  }\n\n  @media ",
        " {\n    width: 8rem;\n    height: 3rem;\n    margin-right: 0;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n"
    ]);
    Header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Header_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Header_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Header_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Header_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 0rem;\n  padding: 1rem 0.5rem;\n"
    ]);
    Header_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Header_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  box-shadow: ",
        ";\n  z-index: 99;\n  /* position: relative; */\n"
    ]);
    Header_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Header_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    Header_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Header_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    Header_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Header_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        " svg path {\n          stroke: ",
        " !important;\n        }\n\n        ",
        " svg path {\n          stroke: ",
        " !important;\n          fill: ",
        " !important;\n        }\n\n        ",
        ", ",
        " {\n          background-color: ",
        ";\n          color: ",
        " !important;\n        }\n\n        ",
        " {\n          background-color: ",
        ";\n        }\n\n        ",
        " {\n          color: ",
        ";\n        }\n\n        ",
        " ",
        " * {\n          &:hover {\n            color: ",
        ";\n          }\n        }\n\n        ",
        " ",
        " svg path,\n        ",
        " ",
        " svg circle {\n          &:hover {\n            stroke: ",
        " !important;\n          }\n        }\n\n        ",
        " * {\n          color: ",
        " !important;\n        }\n\n        ",
        ":after {\n          color: ",
        " !important;\n        }\n\n        ",
        " svg path {\n          stroke: ",
        " !important;\n          fill: ",
        " !important;\n        }\n\n        ",
        " * {\n          color: ",
        " !important;\n        }\n\n        ",
        " svg path {\n          stroke: ",
        " !important;\n          fill: ",
        " !important;\n        }\n\n        ",
        " {\n          color: ",
        " !important;\n        }\n\n        ",
        " * {\n          color: ",
        " !important;\n        }\n\n        ",
        " a:hover {\n          background-color: ",
        ";\n        }\n      "
    ]);
    Header_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function Header_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        will-change: color, background-color;\n      }\n\n      ",
        "\n    "
    ]);
    Header_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function Header_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Header_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}








var HeaderContainerMainContent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__HeaderContainerMainContent",
    componentId: "sc-1ce372db-0"
})(Header_styles_templateObject(), ui.theme.colors.neutral["999-opacity-10"], ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.mobileL);
var HeaderContainer = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__HeaderContainer",
    componentId: "sc-1ce372db-1"
})(Header_styles_templateObject1());
var HamburgerIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HamburgerIconWrapper",
    componentId: "sc-1ce372db-2"
})(Header_styles_templateObject2(), ui.theme.device.desktopFirst.mobileL);
var LogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LogoWrapper",
    componentId: "sc-1ce372db-3"
})(Header_styles_templateObject3(), ui.theme.device.desktopFirst.laptop, ui.theme.device.desktopFirst.mobileXL);
var MobileLogoFC = (0,styled_components_browser_esm/* default */.ZP)(components_Image/* Image */.E).withConfig({
    displayName: "styles__MobileLogoFC",
    componentId: "sc-1ce372db-4"
})(Header_styles_templateObject4());
var DesktopLogoFC = (0,styled_components_browser_esm/* default */.ZP)(components_Image/* Image */.E).withConfig({
    displayName: "styles__DesktopLogoFC",
    componentId: "sc-1ce372db-5"
})(Header_styles_templateObject5());
var ContentHeaderMobile = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ContentHeaderMobile",
    componentId: "sc-1ce372db-6"
})(Header_styles_templateObject6());
var FlexContainerNavCenterHeaderCustom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FlexContainerNavCenterHeaderCustom",
    componentId: "sc-1ce372db-7"
})(Header_styles_templateObject7(), function(param) {
    var isPageWeddingList = param.isPageWeddingList;
    return isPageWeddingList ? ui.theme.colors.primary[200] : ui.theme.colors.neutral.white;
}, function(param) {
    var isPageWeddingList = param.isPageWeddingList, isBlackFriday = param.isBlackFriday;
    var ref, ref1, ref2, ref3;
    return !isBlackFriday || isPageWeddingList ? "0 1px 1px 0 ".concat(ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.neutral) === null || ref1 === void 0 ? void 0 : ref1["999-opacity-10"]) : "0 1px 1px 0 ".concat(ui.theme === null || ui.theme === void 0 ? void 0 : (ref2 = ui.theme.colors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.blackFriday) === null || ref3 === void 0 ? void 0 : ref3.white);
});
var FlexContainerCenterHeaderCustom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FlexContainerCenterHeaderCustom",
    componentId: "sc-1ce372db-8"
})(Header_styles_templateObject8());
var ClientLocationContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ClientLocationContainer",
    componentId: "sc-1ce372db-9"
})(Header_styles_templateObject9(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || ui.theme.colors.neutral.white;
}, function(param) {
    var color = param.color;
    return color || ui.theme.colors.primary[200];
});
var HeaderOuterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HeaderOuterContainer",
    componentId: "sc-1ce372db-10"
})(Header_styles_templateObject12(), function(param) {
    var isPageWeddingList = param.isPageWeddingList, isBlackTheme = param.isBlackTheme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var themeConditional = isBlackTheme && !isPageWeddingList;
    var grayThemeBlackFriday = ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["20"];
    var blackThemeBlackFriday = ui.theme === null || ui.theme === void 0 ? void 0 : (ref2 = ui.theme.colors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.blackFriday) === null || ref3 === void 0 ? void 0 : ref3["175"];
    var whiteThemeBlackFriday = ui.theme === null || ui.theme === void 0 ? void 0 : (ref4 = ui.theme.colors) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.blackFriday) === null || ref5 === void 0 ? void 0 : ref5.white;
    return (0,styled_components_browser_esm/* css */.iv)(Header_styles_templateObject11(), SidebarMenuMobile_styles/* SidebarMenuMobileContainer */.Ai, themeConditional && (0,styled_components_browser_esm/* css */.iv)(Header_styles_templateObject10(), HamburgerIconWrapper, grayThemeBlackFriday, styles_Wrapper, grayThemeBlackFriday, grayThemeBlackFriday, HeaderContainer, FlexContainerNavCenterHeaderCustom, blackThemeBlackFriday, grayThemeBlackFriday, HeaderContainerMainContent, blackThemeBlackFriday, CompanyProductLink, whiteThemeBlackFriday, ListCategoriesAside, ui.FlexContainer, whiteThemeBlackFriday, ListCategoriesAside, ui.FlexContainer, ListCategoriesAside, ui.FlexContainer, whiteThemeBlackFriday, ContentLocation, grayThemeBlackFriday, ContentLocation, whiteThemeBlackFriday, ContentLocation, whiteThemeBlackFriday, whiteThemeBlackFriday, CategoryNameContainer, grayThemeBlackFriday, CategoryNameContainer, whiteThemeBlackFriday, whiteThemeBlackFriday, WelcomeText, grayThemeBlackFriday, CustomHighlightCategories_style/* HighlightCategories */.N, grayThemeBlackFriday, CustomHighlightCategories_style/* HighlightCategories */.N, ui.theme === null || ui.theme === void 0 ? void 0 : (ref6 = ui.theme.colors) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.blackFriday) === null || ref7 === void 0 ? void 0 : ref7["100"]));
});

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ModalAuthentication/styles.ts

function ModalAuthentication_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -23px;\n  left: calc(43%);\n  display: block;\n  width: 0;\n  height: 0;\n  z-index: 1;\n  filter: drop-shadow(5px -6px 3px ",
        ");\n  border-left: 2rem solid transparent;\n  border-right: 2rem solid transparent;\n  border-bottom: 2rem solid ",
        ";\n\n  @media ",
        " {\n    left: calc(53%);\n  }\n\n  @media ",
        " {\n    left: calc(56%);\n  }\n\n  @media ",
        " {\n    left: calc(70%);\n  }\n\n  @media ",
        " {\n    left: calc(75%);\n  }\n"
    ]);
    ModalAuthentication_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalAuthentication_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  visibility: ",
        ";\n  opacity: ",
        ";\n  z-index: 99;\n  position: absolute;\n  top: calc(100% + 2.5rem);\n  right: calc(100% - 16.575rem);\n  background: ",
        ";\n  border-radius: 16px;\n  box-shadow: 6px 4px 15px 0px ",
        ";\n  padding: ",
        ";\n  width: 30rem;\n  cursor: auto;\n  height: auto;\n  transition: all 0.2s ease-in-out;\n  cursor: initial;\n\n  @media ",
        " {\n    right: calc(100% - 13.675rem);\n  }\n\n  @media ",
        " {\n    right: calc(100% - 12.675rem);\n  }\n\n  @media ",
        " {\n    right: calc(100% - 8.65rem);\n  }\n\n  @media ",
        " {\n    right: calc(100% - 7rem);\n  }\n"
    ]);
    ModalAuthentication_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PointerUp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PointerUp",
    componentId: "sc-11fb05f3-0"
})(ModalAuthentication_styles_templateObject(), ui.theme.colors.neutral["999-opacity-65"], ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.laptop, ui.theme.device.desktopFirst.tabletXL, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.tabletS);
var ModalAuthenticationContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ModalAuthenticationContainer",
    componentId: "sc-11fb05f3-1"
})(ModalAuthentication_styles_templateObject1(), function(param) {
    var isOpenedLogin = param.isOpenedLogin;
    return isOpenedLogin ? "visible" : "hidden";
}, function(param) {
    var isOpenedLogin = param.isOpenedLogin;
    return isOpenedLogin ? 1 : 0;
}, ui.theme.colors.neutral.white, ui.theme.colors.neutral["999-opacity-60"], ui.theme.space.x6, ui.theme.device.desktopFirst.laptop, ui.theme.device.desktopFirst.tabletXL, ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.tabletS);

// EXTERNAL MODULE: ../../packages/components/patterns/Header/components/AuthContent/index.tsx + 1 modules
var AuthContent = __webpack_require__(133);
// EXTERNAL MODULE: ../../packages/components/patterns/Header/components/data/index.tsx + 24 modules
var data = __webpack_require__(74774);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ModalAuthentication/index.tsx









var ModalAuthentication = function(param) {
    var _useAuthentication = param.useAuthentication, useAuthentication = _useAuthentication === void 0 ? state_manager/* useAuthentication */.JL : _useAuthentication;
    var ref = useAuthentication((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setIsAuthenticationDropdownActive: state.setIsAuthenticationDropdownActive,
            isAuthenticationDropdownActive: state.isAuthenticationDropdownActive,
            currentStep: state.currentStep
        };
    })), setIsAuthenticationDropdownActive = ref.setIsAuthenticationDropdownActive, isAuthenticationDropdownActive = ref.isAuthenticationDropdownActive, currentStep = ref.currentStep;
    var ModalAuthenticationContainerRef = (0,react.useRef)(null);
    (0,application/* useClickOutside */.O8h)({
        ref: ModalAuthenticationContainerRef,
        callback: function() {
            if (isAuthenticationDropdownActive) {
                setIsAuthenticationDropdownActive(false);
            }
        }
    });
    var renderAuthContent = (0,react.useCallback)(function(step) {
        return (0,data/* getAuthContent */.VY)("modal", step);
    }, []);
    if (!isAuthenticationDropdownActive) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalAuthenticationContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-authentication-container")), {
            isOpenedLogin: isAuthenticationDropdownActive,
            ref: ModalAuthenticationContainerRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PointerUp, (0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-authentication-container-pointer-up"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthContent/* AuthContent */.p, {
                    loginMode: "modal",
                    children: renderAuthContent(currentStep)
                })
            ]
        }))
    }, "modal-auth");
};


// EXTERNAL MODULE: ../../packages/application/utils/index.tsx + 44 modules
var application_utils = __webpack_require__(83428);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/components/subcomponents/SuggestedProductCard/styles.ts

function SuggestedProductCard_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  width: 100%;\n  background: ",
        ";\n  margin-bottom: 0.15rem;\n  box-shadow: 0 2px 2px 0 ",
        ";\n  border-radius: 2px;\n  cursor: pointer;\n  color: ",
        ";\n"
    ]);
    SuggestedProductCard_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SuggestedProductCard_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.2rem;\n  border-right: 2px solid ",
        ";\n"
    ]);
    SuggestedProductCard_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SuggestedProductCard_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 0 !important;\n"
    ]);
    SuggestedProductCard_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SuggestedProductCard_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-flex: 1;\n  display: inline-flex;\n  box-orient: vertical;\n  box-direction: normal;\n  flex-flow: column nowrap;\n  box-pack: justify;\n  justify-content: space-between;\n  padding: 0.5rem 0.75rem;\n"
    ]);
    SuggestedProductCard_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SuggestedProductCard_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: normal;\n"
    ]);
    SuggestedProductCard_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SuggestedProductCard_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    SuggestedProductCard_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var SuggestedCardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SuggestedCardContainer",
    componentId: "sc-3497759e-0"
})(SuggestedProductCard_styles_templateObject(), ui.theme.colors.neutral.white, ui.theme.colors.neutral["999-opacity-025"], ui.theme.colors.neutral[520]);
var SuggestedCardImageBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SuggestedCardImageBox",
    componentId: "sc-3497759e-1"
})(SuggestedProductCard_styles_templateObject1(), ui.theme.colors.neutral[50]);
var SuggestedCardImage = (0,styled_components_browser_esm/* default */.ZP)(components_Image/* Image */.E).withConfig({
    displayName: "styles__SuggestedCardImage",
    componentId: "sc-3497759e-2"
})(SuggestedProductCard_styles_templateObject2());
var SuggestedCardInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SuggestedCardInfo",
    componentId: "sc-3497759e-3"
})(SuggestedProductCard_styles_templateObject3());
var SuggestedCardDescription = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    displayName: "styles__SuggestedCardDescription",
    componentId: "sc-3497759e-4"
})(SuggestedProductCard_styles_templateObject4());
var SuggestedCardPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SuggestedCardPrice",
    componentId: "sc-3497759e-5"
})(SuggestedProductCard_styles_templateObject5(), ui.theme.colors.primary[200]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/components/subcomponents/SuggestedProductCard/index.tsx








var SuggestedProductCard = function(param) {
    var suggestedProduct = param.suggestedProduct, afterClick = param.afterClick;
    var ref;
    var router = (0,next_router.useRouter)();
    var isProductScreen = router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.includes("produto");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuggestedCardContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        onClick: function() {
            afterClick(suggestedProduct.description.replace(/[\\/\\-]+/g, " "));
        },
        as: isProductScreen ? "a" : Link/* Link */.r,
        href: "/produto/".concat(suggestedProduct.id, "/").concat((0,application_utils/* formatStringUrl */.Es)(suggestedProduct.description)),
        target: "_self"
    }, (0,application_utils/* buildTestIds */.Fe)("suggested-card-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedCardImageBox, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application_utils/* buildTestIds */.Fe)("suggested-card-image-box")), {
                children: (suggestedProduct === null || suggestedProduct === void 0 ? void 0 : suggestedProduct.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedCardImage, {
                    width: "72px",
                    height: "72px",
                    layout: "fixed",
                    src: suggestedProduct.imageUrl,
                    alt: suggestedProduct === null || suggestedProduct === void 0 ? void 0 : suggestedProduct.description
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuggestedCardInfo, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application_utils/* buildTestIds */.Fe)("suggested-card-info")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedCardDescription, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application_utils/* buildTestIds */.Fe)("suggested-card-description")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Text, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application_utils/* buildTestIds */.Fe)("suggested-card-description-text")), {
                            fontSize: "1.1rem",
                            children: [
                                suggestedProduct === null || suggestedProduct === void 0 ? void 0 : suggestedProduct.description,
                                " - ",
                                suggestedProduct.id
                            ]
                        }))
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedCardPrice, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application_utils/* buildTestIds */.Fe)("suggested-card-price")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application_utils/* buildTestIds */.Fe)("suggested-card-price-text")), {
                            fontSize: "1.1rem",
                            fontWeight: "bold",
                            margin: "15px 0 0",
                            children: (0,application_utils/* formatCurrency */.xG)(Number(suggestedProduct.price))
                        }))
                    }))
                ]
            }))
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/components/subcomponents/TermSuggestionOption/styles.ts

function TermSuggestionOption_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    TermSuggestionOption_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TermSuggestionOption_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  align-items: center;\n  padding: 0.75rem 0.5rem;\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    TermSuggestionOption_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TermSuggestionOption_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 1.25rem;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  width: 100%;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    TermSuggestionOption_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TermSuggestionOption_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    cursor: pointer;\n    width: ",
        ";\n    height: ",
        ";\n    fill: ",
        ";\n    transition: all 0.2s ease;\n  }\n\n  & > svg > g > path {\n    cursor: pointer;\n    stroke: ",
        ";\n    stroke-width: 2;\n    transition: all 0.2s ease;\n  }\n"
    ]);
    TermSuggestionOption_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var ItemLinkContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ItemLinkContainer",
    componentId: "sc-4f5265cd-0"
})(TermSuggestionOption_styles_templateObject());
var WrapperSuggestions = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__WrapperSuggestions",
    componentId: "sc-4f5265cd-1"
})(TermSuggestionOption_styles_templateObject1(), ItemLinkContainer);
var ItemContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ItemContent",
    componentId: "sc-4f5265cd-2"
})(TermSuggestionOption_styles_templateObject2(), ui.theme.colors.neutral[520], ui.theme.colors.neutral[900]);
var ActionButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ActionButtonContainer",
    componentId: "sc-4f5265cd-3"
})(TermSuggestionOption_styles_templateObject3(), ui.theme.space.x6, ui.theme.space.x6, ui.theme.colors.neutral[350], ui.theme.colors.neutral[350]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/components/subcomponents/TermSuggestionOption/index.tsx





var TermSuggestionOption = function(param) {
    var term = param.term, onClick = param.onClick, actionButton = param.actionButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperSuggestions, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemLinkContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemContent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    onClick: onClick
                }, (0,application/* buildTestIds */.Fek)("item-suggestion-result")), {
                    children: term
                })),
                actionButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButtonContainer, {
                    onClick: function(event) {
                        event.stopPropagation();
                        actionButton.onClick(term);
                    },
                    children: actionButton.icon
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/components/subcomponents/index.tsx



;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/components/Results/OmniSearchResult/index.tsx



var OmniSearchResult = function(param) {
    var result = param.result, onClick = param.onClick;
    var router = (0,next_router.useRouter)();
    var getPath = function(omniSearch) {
        var ref, ref1;
        var needAdjust = ((ref = omniSearch.url.split("/")) === null || ref === void 0 ? void 0 : ref.length) === 1;
        return "".concat(((ref1 = omniSearch.url) === null || ref1 === void 0 ? void 0 : ref1.startsWith("/")) || (omniSearch === null || omniSearch === void 0 ? void 0 : omniSearch.externUrl) ? "" : "/").concat(needAdjust ? "pesquisa/" : "").concat(omniSearch.url);
    };
    if (!result || result.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: result.map(function(omniSearch) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermSuggestionOption, {
                term: omniSearch.term,
                onClick: function() {
                    router.push(getPath(omniSearch));
                    onClick(omniSearch.term);
                }
            }, omniSearch.term);
        })
    });
};

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/components/Results/SearchHistoricResult/index.tsx


var SearchHistoricResult = function(param) {
    var result = param.result, showHistoricSearch = param.showHistoricSearch, onClick = param.onClick, actionButton = param.actionButton;
    if (showHistoricSearch) {
        return(// eslint-disable-next-line react/jsx-no-useless-fragment
        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: result === null || result === void 0 ? void 0 : result.map(function(searchedTerm) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermSuggestionOption, {
                    term: searchedTerm,
                    actionButton: actionButton,
                    onClick: function() {
                        onClick("/pesquisa/".concat(searchedTerm));
                    }
                }, searchedTerm);
            })
        }));
    }
    return null;
};

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/styles.ts

function SearchInput_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  background: ",
        ";\n  cursor: pointer;\n\n  transition: all 0.2s ease-in;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    SearchInput_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchInput_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  width: 100%;\n  flex-direction: ",
        ";\n  align-items: flex-start;\n  justify-content: center;\n  padding: 0 0 0 0.5rem;\n  transition: all 0.2s ease-in;\n\n  @media ",
        " {\n    padding: 0 1rem;\n  }\n\n  /* @media ",
        " {\n    max-width: 100%;\n  } */\n"
    ]);
    SearchInput_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchInput_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: -2px;\n  width: 100%;\n  margin-top: -2px;\n  padding: 1rem 1rem 0;\n  overflow-y: auto;\n  will-change: transform;\n  max-height: 40rem;\n  z-index: ",
        ";\n  opacity: ",
        ";\n  border-radius: 0px 0px 8px 8px;\n  visibility: ",
        ";\n  background-color: ",
        ";\n  box-shadow: 0 12px 18px ",
        ";\n  margin-bottom: -100vh;\n  transition: all 0.2s ease;\n\n  &:focus ~ ",
        " {\n    z-index: 5;\n    opacity: 1;\n    visibility: visible;\n    box-shadow: 0 4px 8px 0 ",
        ",\n      0 6px 20px 0 ",
        ";\n  }\n"
    ]);
    SearchInput_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchInput_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      pointer-events: none;\n      opacity: 0.8;\n    "
    ]);
    SearchInput_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchInput_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 6.5rem;\n  height: 4.17rem;\n  z-index: ",
        ";\n  border-radius: ",
        ";\n  margin-top: 0;\n  order: 2;\n  transition: all 0.2s ease;\n\n  ",
        "\n\n  &:focus {\n    border: 1px solid ",
        ";\n  }\n\n  &::placeholder {\n    outline: none;\n    color: ",
        ";\n  }\n\n  @media ",
        " {\n    height: 3.85rem;\n  }\n\n  @media ",
        " {\n    order: 1;\n    border-radius: 4px 0 0 4px;\n  }\n\n  @media ",
        " {\n    width: 4rem;\n    height: 3rem;\n  }\n\n  @media ",
        " {\n    height: 3rem;\n  }\n\n  @media ",
        " {\n    height: 3rem;\n  }\n"
    ]);
    SearchInput_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SearchInput_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    SearchInput_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SearchInput_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  padding: 0.75rem 0rem;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    SearchInput_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SearchInput_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0rem 0.25rem;\n  width: 100%;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    SearchInput_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var styles_BaseHyperLink = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__BaseHyperLink",
    componentId: "sc-533efcd1-0"
})(SearchInput_styles_templateObject(), ui.theme.colors.primary[200], ui.theme.colors.primary[400]);
var ContainerSearchProduct = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "styles__ContainerSearchProduct",
    componentId: "sc-533efcd1-1"
})(SearchInput_styles_templateObject1(), function(param) {
    var isDesktop = param.isDesktop;
    return isDesktop ? "row-reverse" : "row";
}, ui.theme.device.desktopFirst.mobileL, ui.theme.device.mobileFirst.laptop);
var SearchContainerSuggestion = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SearchContainerSuggestion",
    componentId: "sc-533efcd1-2"
})(SearchInput_styles_templateObject2(), function(param) {
    var hasFocusOnInputSearch = param.hasFocusOnInputSearch;
    return hasFocusOnInputSearch ? "99" : "-1";
}, function(param) {
    var showItems = param.showItems, hasFocusOnInputSearch = param.hasFocusOnInputSearch;
    return showItems && hasFocusOnInputSearch ? 1 : 0;
}, function(param) {
    var showItems = param.showItems, hasFocusOnInputSearch = param.hasFocusOnInputSearch;
    return showItems && hasFocusOnInputSearch ? "visible" : "hidden";
}, ui.theme.colors.neutral[80], ui.theme.colors.neutral["999-opacity-20"], ui.OverlayContainer, ui.theme.colors.neutral["999-opacity-20"], ui.theme.colors.neutral["999-opacity-19"]);
var SearchProductHyperLink = (0,styled_components_browser_esm/* default */.ZP)(styles_BaseHyperLink).withConfig({
    displayName: "styles__SearchProductHyperLink",
    componentId: "sc-533efcd1-3"
})(SearchInput_styles_templateObject4(), function(param) {
    var hasFocusOnInputSearch = param.hasFocusOnInputSearch;
    return hasFocusOnInputSearch ? 20 : 0;
}, function(param) {
    var isDesktop = param.isDesktop;
    return isDesktop ? "0px 4px 4px 0" : "4px 0 0 4px";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(SearchInput_styles_templateObject3());
}, ui.theme.colors.primary[100], ui.theme.colors.neutral[300], ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.tabletS, ui.theme.device.desktopFirst.mobileL, ui.theme.device.desktopFirst.mobileM, ui.theme.device.desktopFirst.mobileS);
var SearchProductIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.Search).attrs({
    color: ui.theme.colors.neutral.white
}).withConfig({
    displayName: "styles__SearchProductIcon",
    componentId: "sc-533efcd1-4"
})(SearchInput_styles_templateObject5());
var ListSuggestedProducts = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__ListSuggestedProducts",
    componentId: "sc-533efcd1-5"
})(SearchInput_styles_templateObject6(), ItemLinkContainer);
var ItemSuggestedProducts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ItemSuggestedProducts",
    componentId: "sc-533efcd1-6"
})(SearchInput_styles_templateObject7(), ItemLinkContainer);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/components/Results/SuggestedProductsResult/index.tsx



var SuggestedProductsResult = function(param) {
    var suggestion = param.suggestion, isClientTablet = param.isClientTablet, suggestionsProducts = param.suggestionsProducts, onClick = param.onClick;
    var ref;
    var ref1;
    if (suggestion && ((ref1 = suggestion === null || suggestion === void 0 ? void 0 : (ref = suggestion.suggestions) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 1) > 0 && !isClientTablet) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSuggestedProducts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSuggestedProducts, {
                children: suggestionsProducts === null || suggestionsProducts === void 0 ? void 0 : suggestionsProducts.slice(0, 4).map(function(suggestedProduct) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedProductCard, {
                        suggestedProduct: suggestedProduct,
                        afterClick: onClick
                    }, suggestedProduct.id);
                })
            })
        });
    }
    return null;
};

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/components/Results/TermSuggestionResult/index.tsx




var TermSuggestionResult = function(param) {
    var result = param.result, searchProduct = param.searchProduct, onClick = param.onClick;
    var ref;
    if (result && (result === null || result === void 0 ? void 0 : (ref = result.suggestions) === null || ref === void 0 ? void 0 : ref.length) > 0) {
        return(// eslint-disable-next-line react/jsx-no-useless-fragment
        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: result === null || result === void 0 ? void 0 : result.suggestions.map(function(suggestion) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermSuggestionOption, {
                    term: suggestion,
                    onClick: function() {
                        onClick("/pesquisa/".concat(suggestion.replace(/\//g, " ")));
                    }
                }, suggestion);
            })
        }));
    }
    if (searchProduct) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermSuggestionOption, (0,src_object_spread/* default */.Z)({
            term: searchProduct,
            onClick: function() {
                onClick("/pesquisa/".concat(searchProduct.replace(/\//g, " ")));
            }
        }, (0,application/* buildTestIds */.Fek)("item-suggestion-not-found")), searchProduct);
    }
    return null;
};

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/components/Results/index.tsx





;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/components/index.tsx



;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/data.tsx



var DEFAULT_USER_SEARCH_HISTORY = "@FC:Ecom:User:Search:History";
var useSearchHistory = function(param) {
    var _limit = param.limit, limit = _limit === void 0 ? 10 : _limit;
    var searchTermHistory = (0,react.useMemo)(function() {
        return new Set();
    }, []);
    var loggedClient = (0,application/* useUser */.aFb)().loggedClient;
    var LOGGED_USER_SEARCH_HISTORY = (0,react.useMemo)(function() {
        return "".concat(DEFAULT_USER_SEARCH_HISTORY, ":").concat(loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email);
    }, [
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email
    ]);
    var searchTermHistoryPointer = (0,react.useMemo)(function() {
        return (loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email) ? LOGGED_USER_SEARCH_HISTORY : DEFAULT_USER_SEARCH_HISTORY;
    }, [
        LOGGED_USER_SEARCH_HISTORY,
        loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email
    ]);
    var removeSearchTerm = (0,react.useCallback)(function(searchTerm) {
        var formattedSearchTerm = searchTerm.trimStart().trimEnd();
        if (!(searchTermHistory === null || searchTermHistory === void 0 ? void 0 : searchTermHistory.has(formattedSearchTerm)) || !formattedSearchTerm) {
            return;
        }
        searchTermHistory.delete(formattedSearchTerm);
        localStorage.setItem(searchTermHistoryPointer, JSON.stringify((0,src_to_consumable_array/* default */.Z)(Array.from(searchTermHistory))));
    }, [
        searchTermHistory,
        searchTermHistoryPointer
    ]);
    var resetSearchHistory = (0,react.useCallback)(function() {
        var complete = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        searchTermHistory.clear();
        if (complete) localStorage.setItem(DEFAULT_USER_SEARCH_HISTORY, JSON.stringify([]));
    }, [
        searchTermHistory
    ]);
    var saveSearchTerm = (0,react.useCallback)(function(searchTerm) {
        var formattedSearchTerm = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.trimStart().trimEnd();
        if (!formattedSearchTerm) {
            return;
        }
        if (searchTermHistory === null || searchTermHistory === void 0 ? void 0 : searchTermHistory.has(formattedSearchTerm)) {
            removeSearchTerm(formattedSearchTerm);
            saveSearchTerm(formattedSearchTerm);
            return;
        }
        if ((searchTermHistory === null || searchTermHistory === void 0 ? void 0 : searchTermHistory.size) > limit - 1) {
            var _value;
            searchTermHistory.delete((_value = searchTermHistory === null || searchTermHistory === void 0 ? void 0 : searchTermHistory.values().next().value) !== null && _value !== void 0 ? _value : "");
        }
        searchTermHistory.add(formattedSearchTerm);
        localStorage.setItem(searchTermHistoryPointer, JSON.stringify((0,src_to_consumable_array/* default */.Z)(Array.from(searchTermHistory))));
    }, [
        limit,
        removeSearchTerm,
        searchTermHistory,
        searchTermHistoryPointer
    ]);
    var mergeSearchHistory = (0,react.useCallback)(function() {
        var ref;
        var loggedUserSearchHistory = JSON.parse((ref = localStorage.getItem(LOGGED_USER_SEARCH_HISTORY)) !== null && ref !== void 0 ? ref : "[]");
        var ref1;
        var defaultUserSearchHistory = JSON.parse((ref1 = localStorage.getItem(DEFAULT_USER_SEARCH_HISTORY)) !== null && ref1 !== void 0 ? ref1 : "[]");
        if (defaultUserSearchHistory.length > 0) {
            localStorage.setItem(LOGGED_USER_SEARCH_HISTORY, JSON.stringify((0,src_to_consumable_array/* default */.Z)(loggedUserSearchHistory).concat((0,src_to_consumable_array/* default */.Z)(defaultUserSearchHistory))));
        }
    }, [
        LOGGED_USER_SEARCH_HISTORY
    ]);
    (0,react.useEffect)(function() {
        if (loggedClient === null || loggedClient === void 0 ? void 0 : loggedClient.email) {
            mergeSearchHistory();
            resetSearchHistory(true);
        }
        resetSearchHistory();
    }, [
        LOGGED_USER_SEARCH_HISTORY,
        loggedClient,
        mergeSearchHistory,
        resetSearchHistory, 
    ]);
    (0,react.useEffect)(function() {
        var storedSearchTermHistory = localStorage.getItem(searchTermHistoryPointer);
        if (storedSearchTermHistory) {
            var terms = JSON.parse(storedSearchTermHistory);
            terms.forEach(function(term) {
                searchTermHistory.add(term);
            });
        } else {
            localStorage.setItem(searchTermHistoryPointer, JSON.stringify((0,src_to_consumable_array/* default */.Z)(Array.from(searchTermHistory))));
        }
    }, [
        searchTermHistory,
        searchTermHistoryPointer
    ]);
    var termsList = (0,src_to_consumable_array/* default */.Z)(Array.from(searchTermHistory)).reverse().slice(0, limit);
    return {
        termsList: termsList,
        saveSearchTerm: saveSearchTerm,
        removeSearchTerm: removeSearchTerm,
        resetSearchHistory: resetSearchHistory
    };
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/SearchInput/index.tsx















var SearchInput = function(param) {
    var isDesktop = param.isDesktop;
    var router = (0,next_router.useRouter)();
    var ref = useSearchHistory({}), saveSearchTerm = ref.saveSearchTerm, termsList = ref.termsList, removeSearchTerm = ref.removeSearchTerm;
    var ref1 = (0,state/* useAppContext */.b)(), isSidebarMenuOpened = ref1.isSidebarMenuOpened, setIsSidebarMenuOpened = ref1.setIsSidebarMenuOpened;
    var ref2 = (0,index_esm/* useForm */.cI)(), handleSubmit = ref2.handleSubmit, reset = ref2.reset, register = ref2.register, watch = ref2.watch, setFocus = ref2.setFocus, setValue = ref2.setValue;
    (0,react.useEffect)(function() {
        var ref;
        if (!(router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes("/pesquisa"))) {
            reset();
        }
    }, [
        reset,
        router === null || router === void 0 ? void 0 : router.pathname
    ]);
    var goToSearchResult = (0,react.useCallback)(function(url) {
        var term = url === null || url === void 0 ? void 0 : url.split("/")[2];
        implementations/* gtag.search */.SX.search(term);
        router.push(url);
        saveSearchTerm(term);
        setValue("searchProduct", term);
    }, [
        router,
        saveSearchTerm,
        setValue
    ]);
    var focusOnInputSearch = (0,state/* useAppContext */.b)().focusOnInputSearch;
    var handleSearchProduct = function(param) {
        var searchProduct = param.searchProduct;
        var ref;
        if (!searchProduct) {
            return;
        }
        var formattedSearchProduct = searchProduct.replace(/\//g, " ");
        (ref = document.getElementById("searchProduct")) === null || ref === void 0 ? void 0 : ref.blur();
        goToSearchResult("/pesquisa/".concat(formattedSearchProduct));
    };
    var searchProduct = watch("searchProduct");
    var debouncedSearchProduct = (0,application/* useDebounce */.NrF)(searchProduct, 500);
    var ref3 = (0,react.useState)(false), hasFocusOnInputSearch = ref3[0], setHasFocusOnInputSearch = ref3[1];
    var isClientTablet = (0,state/* useAppContext */.b)().isClientTablet;
    (0,react.useEffect)(function() {
        if (focusOnInputSearch) {
            setFocus("searchProduct");
        }
    }, [
        setFocus,
        focusOnInputSearch
    ]);
    var branchId = Number((0,application/* getClientBranchId */.R0G)(implementations/* cookie */.pR));
    var data = implementations/* catalogApi.getSuggestions */.dZ.getSuggestions(debouncedSearchProduct, branchId).data;
    var showHistoricSearch = (0,react.useMemo)(function() {
        return Boolean(!(searchProduct === null || searchProduct === void 0 ? void 0 : searchProduct.length) && (termsList === null || termsList === void 0 ? void 0 : termsList.length));
    }, [
        searchProduct === null || searchProduct === void 0 ? void 0 : searchProduct.length,
        termsList === null || termsList === void 0 ? void 0 : termsList.length
    ]);
    var handleTypeInSearchProduct = (0,react.useCallback)(function() {
        if (isSidebarMenuOpened) {
            setTimeout(function() {
                setIsSidebarMenuOpened(false);
            }, 150);
        }
    }, [
        isSidebarMenuOpened,
        setIsSidebarMenuOpened
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerSearchProduct, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        onSubmit: handleSubmit(handleSearchProduct),
        isDesktop: isDesktop
    }, (0,application/* buildTestIds */.Fek)("container-search-product")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.HeaderSearchbarFlexContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.InputSearchFlexContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("container-input-search")), {
                    onFocus: function() {
                        return setHasFocusOnInputSearch(true);
                    },
                    onBlur: function() {
                        return setHasFocusOnInputSearch(false);
                    },
                    onClick: handleTypeInSearchProduct,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchProductHyperLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            isDesktop: isDesktop
                        }, (0,application/* buildTestIds */.Fek)("search-product-hyperlink")), {
                            hasFocusOnInputSearch: hasFocusOnInputSearch,
                            isDisabled: Boolean((debouncedSearchProduct === null || debouncedSearchProduct === void 0 ? void 0 : debouncedSearchProduct.length) === 0),
                            onClick: handleSubmit(handleSearchProduct),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchProductIcon, {})
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.InputSearch, (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            id: "searchProduct",
                            fontSize: "1.25rem",
                            fontWeight: "400",
                            autoComplete: "off",
                            list: "search-products",
                            type: "text",
                            maxLength: 200,
                            hasFocusOnInputSearch: hasFocusOnInputSearch,
                            placeholder: "O que voc\xea est\xe1 procurando?"
                        }, (0,application/* buildTestIds */.Fek)("input-search-product")), {
                            hideBorder: hasFocusOnInputSearch
                        }), register("searchProduct"))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.OverlayContainer, (0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("overlay-container")))
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchContainerSuggestion, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    id: "search-products"
                }, (0,application/* buildTestIds */.Fek)("search-container-suggestion")), {
                    showItems: !!searchProduct || showHistoricSearch,
                    hasFocusOnInputSearch: hasFocusOnInputSearch,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchHistoricResult, {
                            actionButton: {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Close, {}),
                                onClick: removeSearchTerm
                            },
                            onClick: goToSearchResult,
                            showHistoricSearch: showHistoricSearch,
                            result: termsList
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniSearchResult, {
                            result: data === null || data === void 0 ? void 0 : data.omniSearch,
                            onClick: saveSearchTerm
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TermSuggestionResult, {
                            result: data === null || data === void 0 ? void 0 : data.suggestion,
                            searchProduct: searchProduct,
                            onClick: goToSearchResult
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedProductsResult, {
                            onClick: saveSearchTerm,
                            isClientTablet: isClientTablet,
                            suggestion: data === null || data === void 0 ? void 0 : data.suggestion,
                            suggestionsProducts: data === null || data === void 0 ? void 0 : data.products
                        })
                    ]
                }))
            ]
        })
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ListCategories/Inner/index.tsx






var ListCategoriesInner = function(param) {
    var _category = param.category, data = _category.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListCategoriesInnerWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("list-categories-inner-wrapper")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListCategoryInnerContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("list-category-inner-container-1")), {
                children: data === null || data === void 0 ? void 0 : data.map(function(subCategory) {
                    var ref;
                    return subCategory.colunm === 1 && /*#__PURE__*/ (0,react.createElement)(SubCategory, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sub-category-".concat(subCategory.title))), {
                        key: "".concat(subCategory.id, "#").concat(subCategory.title),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryTitleLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sub-category-title-link-".concat(subCategory.title))), {
                                href: "/".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.descriptionUrl),
                                target: "_self",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryTitle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sub-category-title-".concat(subCategory.title))), {
                                    children: subCategory.title
                                }))
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerItemsWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("inner-items-wrapper-".concat(subCategory.title))), {
                                children: subCategory === null || subCategory === void 0 ? void 0 : (ref = subCategory.categories) === null || ref === void 0 ? void 0 : ref.map(function(innerSubCategory) {
                                    /*#__PURE__*/ return (0,react.createElement)(InnerItemTitleLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("inner-item-title-link-".concat(innerSubCategory.title))), {
                                        key: "".concat(innerSubCategory.id, "#").concat(innerSubCategory.title, "#").concat(innerSubCategory.descriptionUrl, "}"),
                                        href: "/".concat(innerSubCategory === null || innerSubCategory === void 0 ? void 0 : innerSubCategory.descriptionUrl),
                                        target: "_self"
                                    }), innerSubCategory.title);
                                })
                            }))
                        ]
                    }));
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListCategoryInnerContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("list-category-inner-container-2")), {
                children: data === null || data === void 0 ? void 0 : data.map(function(subCategory) {
                    var ref;
                    return subCategory.colunm === 2 && /*#__PURE__*/ (0,react.createElement)(SubCategory, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sub-category")), {
                        key: "".concat(subCategory.id, "#").concat(subCategory.title),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryTitleLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sub-category-title-link")), {
                                href: "/".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.descriptionUrl),
                                target: "_self",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryTitle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sub-category-title")), {
                                    children: subCategory.title
                                }))
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerItemsWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("inner-items-wrapper")), {
                                children: subCategory === null || subCategory === void 0 ? void 0 : (ref = subCategory.categories) === null || ref === void 0 ? void 0 : ref.map(function(innerSubCategory) {
                                    /*#__PURE__*/ return (0,react.createElement)(InnerItemTitleLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("inner-item-title-link")), {
                                        key: "".concat(innerSubCategory.id, "#").concat(innerSubCategory.title, "#").concat(innerSubCategory.descriptionUrl, "}"),
                                        href: "/".concat(innerSubCategory === null || innerSubCategory === void 0 ? void 0 : innerSubCategory.descriptionUrl),
                                        target: "_self"
                                    }), innerSubCategory.title);
                                })
                            }))
                        ]
                    }));
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListCategoryInnerContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("list-category-inner-container-3")), {
                children: data === null || data === void 0 ? void 0 : data.map(function(subCategory) {
                    var ref;
                    return subCategory.colunm === 3 && /*#__PURE__*/ (0,react.createElement)(SubCategory, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sub-category")), {
                        key: "".concat(subCategory.id, "#").concat(subCategory.title),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryTitleLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sub-category-title-link")), {
                                href: "/".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.descriptionUrl),
                                target: "_self",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryTitle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sub-category-title")), {
                                    children: subCategory.title
                                }))
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerItemsWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("inner-items-wrapper")), {
                                children: subCategory === null || subCategory === void 0 ? void 0 : (ref = subCategory.categories) === null || ref === void 0 ? void 0 : ref.map(function(innerSubCategory) {
                                    /*#__PURE__*/ return (0,react.createElement)(InnerItemTitleLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("inner-item-title-link")), {
                                        key: "".concat(innerSubCategory.id, "#").concat(innerSubCategory.title, "#").concat(innerSubCategory.descriptionUrl, "}"),
                                        href: "/".concat(innerSubCategory === null || innerSubCategory === void 0 ? void 0 : innerSubCategory.descriptionUrl),
                                        target: "_self"
                                    }), innerSubCategory.title);
                                })
                            }))
                        ]
                    }));
                })
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ListCategories/components/DropdownUserAuthenticated/styles.ts

function DropdownUserAuthenticated_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  background: ",
        " !important;\n  width: 21.5rem;\n  height: auto;\n  margin-top: 34rem;\n  margin-right: 12rem;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  box-shadow: 6px 4px 15px 0px ",
        ";\n  border-radius: 8px;\n\n  visibility: ",
        ";\n  opacity: ",
        ";\n  transition: all 0.4s;\n\n  z-index: 99;\n\n  @media ",
        " {\n    margin-right: 9.5rem;\n  }\n"
    ]);
    DropdownUserAuthenticated_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -12px;\n  left: calc(63%);\n  display: block;\n  width: 0;\n  height: 0;\n  z-index: 1;\n  border-left: 2rem solid transparent;\n  border-right: 2rem solid transparent;\n  border-bottom: 1.2rem solid ",
        ";\n"
    ]);
    DropdownUserAuthenticated_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DropdownUserAuthenticated_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DropdownUserAuthenticated_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DropdownUserAuthenticated_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DropdownUserAuthenticated_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DropdownUserAuthenticated_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DropdownUserAuthenticated_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DropdownUserAuthenticated_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DropdownUserAuthenticated_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DropdownUserAuthenticated_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: start !important;\n  margin-right: 0 !important;\n  gap: ",
        ";\n  padding: ",
        ";\n  color: ",
        ";\n  transition: all 0.2s ease;\n  font-size: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    DropdownUserAuthenticated_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DropdownUserAuthenticated_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function DropdownUserAuthenticated_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 10px;\n  border-radius: 8px 8px 0px 0px;\n  background-color: ",
        ";\n"
    ]);
    DropdownUserAuthenticated_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var DropdownUserAuthenticatedContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "styles__DropdownUserAuthenticatedContainer",
    componentId: "sc-94bec86d-0"
})(DropdownUserAuthenticated_styles_templateObject(), ui.theme.colors.neutral.white, ui.theme.colors.neutral["999-opacity-60"], function(param) {
    var isOpenedDropdownUser = param.isOpenedDropdownUser;
    return isOpenedDropdownUser ? "visible" : "hidden";
}, function(param) {
    var isOpenedDropdownUser = param.isOpenedDropdownUser;
    return isOpenedDropdownUser ? 1 : 0;
}, ui.theme.device.desktopFirst.laptop);
var DropdownUserAuthenticatedHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__DropdownUserAuthenticatedHeader",
    componentId: "sc-94bec86d-1"
})(DropdownUserAuthenticated_styles_templateObject1(), ui.theme.colors.primary[350]);
var DropdownUserAuthenticated_styles_CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.CloseIcon).attrs(function(param) {
    var color = param.color;
    return {
        color: color !== null && color !== void 0 ? color : ui.theme.colors.neutral[760],
        height: "20px",
        width: "20px"
    };
}).withConfig({
    displayName: "styles__CloseIcon",
    componentId: "sc-94bec86d-2"
})(DropdownUserAuthenticated_styles_templateObject2());
var CartIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ShoppingCartIcon).attrs(function(param) {
    var color = param.color;
    return {
        color: color !== null && color !== void 0 ? color : ui.theme.colors.neutral[760]
    };
}).withConfig({
    displayName: "styles__CartIcon",
    componentId: "sc-94bec86d-3"
})(DropdownUserAuthenticated_styles_templateObject3());
var UserIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ClientIcon).attrs(function(param) {
    var color = param.color;
    return {
        color: color !== null && color !== void 0 ? color : ui.theme.colors.neutral[760]
    };
}).withConfig({
    displayName: "styles__UserIcon",
    componentId: "sc-94bec86d-4"
})(DropdownUserAuthenticated_styles_templateObject4());
var DollarIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.DollarIcon).attrs(function(param) {
    var color = param.color;
    return {
        color: color !== null && color !== void 0 ? color : ui.theme.colors.neutral[760]
    };
}).withConfig({
    displayName: "styles__DollarIcon",
    componentId: "sc-94bec86d-5"
})(DropdownUserAuthenticated_styles_templateObject5());
var styles_SecurityIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.SecurityLockIcon).attrs(function(param) {
    var color = param.color;
    return {
        color: color !== null && color !== void 0 ? color : ui.theme.colors.neutral[760],
        height: "20px",
        width: "20px"
    };
}).withConfig({
    displayName: "styles__SecurityIcon",
    componentId: "sc-94bec86d-6"
})(DropdownUserAuthenticated_styles_templateObject6());
var GiftIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.NewGiftIcon).attrs(function(param) {
    var color = param.color;
    return {
        color: color !== null && color !== void 0 ? color : ui.theme.colors.neutral[760]
    };
}).withConfig({
    displayName: "styles__GiftIcon",
    componentId: "sc-94bec86d-7"
})(DropdownUserAuthenticated_styles_templateObject7());
var styles_HouseIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.HouseIcon).attrs(function(param) {
    var color = param.color;
    return {
        color: color !== null && color !== void 0 ? color : ui.theme.colors.neutral[760]
    };
}).withConfig({
    displayName: "styles__HouseIcon",
    componentId: "sc-94bec86d-8"
})(DropdownUserAuthenticated_styles_templateObject8());
var BagIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ShoppingBagIcon).attrs(function(param) {
    var color = param.color;
    return {
        color: color !== null && color !== void 0 ? color : ui.theme.colors.neutral[760]
    };
}).withConfig({
    displayName: "styles__BagIcon",
    componentId: "sc-94bec86d-9"
})(DropdownUserAuthenticated_styles_templateObject9());
var styles_ProfileIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ProfileIcon).attrs(function(param) {
    var color = param.color;
    return {
        color: color !== null && color !== void 0 ? color : ui.theme.colors.neutral[760],
        height: "18px",
        width: "18px"
    };
}).withConfig({
    displayName: "styles__ProfileIcon",
    componentId: "sc-94bec86d-10"
})(DropdownUserAuthenticated_styles_templateObject10());
var DropdownUserAuthenticatedWrapperLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "styles__DropdownUserAuthenticatedWrapperLink",
    componentId: "sc-94bec86d-11"
})(DropdownUserAuthenticated_styles_templateObject11(), function(param) {
    var gap = param.gap;
    return gap ? "".concat(gap) : "1rem";
}, function(param) {
    var padding = param.padding;
    return padding ? "".concat(padding) : "0.75rem";
}, ui.theme.colors.neutral[550], ui.theme.typography.fontSize.sm.x5, ui.theme.colors.neutral[999]);
var WrapperIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__WrapperIcon",
    componentId: "sc-94bec86d-12"
})(DropdownUserAuthenticated_styles_templateObject12());
var DropdownTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DropdownTop",
    componentId: "sc-94bec86d-13"
})(DropdownUserAuthenticated_styles_templateObject13(), ui.theme.colors.primary[350]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ListCategories/components/Category/style.ts

function Category_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  height: 3rem;\n  align-items: center;\n"
    ]);
    Category_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Category_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-self: flex-end;\n  border-radius: ",
        ";\n  padding: ",
        " ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  letter-spacing: -0.36px;\n  background-color: ",
        ";\n  margin-right: 1rem;\n"
    ]);
    Category_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CategoryContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "style__CategoryContainer",
    componentId: "sc-ec2d88e9-0"
})(Category_style_templateObject());
var TagNew = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__TagNew",
    componentId: "sc-ec2d88e9-1"
})(Category_style_templateObject1(), ui.theme.space.x3, ui.theme.space.x1, ui.theme.space.x2, ui.theme.colors.neutral.white, ui.theme.typography.fontWeight[500], ui.theme.typography.fontSize.sm.x3, ui.theme.colors.secondary[380]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ListCategories/components/Category/index.tsx











var Category = function(param) {
    var action = param.action, handleCloseDropdownUserAuthenticated = param.handleCloseDropdownUserAuthenticated, _isCloseIcon = param.isCloseIcon, isCloseIcon = _isCloseIcon === void 0 ? false : _isCloseIcon;
    var changeCurrentStep = (0,state_manager/* useAuthentication */.JL)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            changeCurrentStep: state.changeCurrentStep
        };
    })).changeCurrentStep;
    var signOutAccount = (0,application/* useAuth */.aCi)().signOutAccount;
    // const router = useRouter();
    var iconColor = "".concat(ui.theme.colors.neutral[760]);
    var handleCloseAction = (0,react.useCallback)(function() {
        signOutAccount(implementations/* cookie */.pR);
        changeCurrentStep("login");
    }, [
        signOutAccount,
        changeCurrentStep
    ]);
    if (action && !isCloseIcon) {
        var id = action.id, title = action.title, path = action.path, icon = action.icon;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-user-authenticated")), {
            children: /*#__PURE__*/ (0,react.createElement)(DropdownUserAuthenticatedWrapperLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-user-authenticated-link")), {
                key: id,
                target: "_self",
                href: path,
                onClick: function() {
                    return handleCloseDropdownUserAuthenticated();
                },
                padding: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x3, " ").concat(ui.theme.space.x2, " ").concat(ui.theme.space.x4),
                children: [
                    icon(iconColor) || /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownUserAuthenticated_styles_CloseIcon, {
                        color: iconColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-user-authenticated-text")), {
                        color: ui.theme.colors.neutral[550],
                        fontSize: ui.theme.typography.fontSize.sm.x5,
                        margin: "0px !important",
                        children: title
                    }))
                ]
            }))
        }), id);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-user-authenticated")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownUserAuthenticatedWrapperLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-user-authenticated-link")), {
            padding: "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x4),
            target: "_self",
            href: "/",
            onClick: handleCloseAction,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownUserAuthenticated_styles_CloseIcon, {
                    color: iconColor
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("option-user-authenticated-text")), {
                    color: ui.theme.colors.neutral[550],
                    fontSize: ui.theme.typography.fontSize.sm.x5,
                    margin: "0px !important",
                    children: "Sair"
                }))
            ]
        }))
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ListCategories/components/DropdownUserAuthenticated/data/index.tsx



var userAuthenticatedActions = function(allConfigs) {
    return [
        {
            id: 8,
            title: "Minha conta",
            path: "/conta/",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[450];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ProfileIcon, {
                    color: color
                });
            }
        },
        {
            id: 1,
            title: "Meus pedidos",
            path: "/conta/meus-pedidos",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[760];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIcon, {
                    color: color
                });
            }
        },
        {
            id: 2,
            title: "Pedidos telefone/WhatsApp",
            path: "/conta/pedidos-eletronicos",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[760];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BagIcon, {
                    color: color
                });
            }
        },
        {
            id: 3,
            title: "Meus dados",
            path: "/conta/meus-dados",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[760];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon, {
                    color: color
                });
            }
        },
        {
            id: 4,
            title: "Seguran\xe7a",
            path: (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isSecurityPageAvailable) === "true" ? "/conta/seguranca" : "/conta/seguranca/alterar-senha",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[760];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_SecurityIcon, {
                    color: color
                });
            }
        },
        {
            id: 5,
            title: "Meus cart\xf5es",
            path: "/conta/meus-cartoes",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[760];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DollarIcon, {
                    color: color
                });
            }
        },
        {
            id: 6,
            title: "Meus endere\xe7os",
            path: "/conta/meus-enderecos",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[760];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_HouseIcon, {
                    color: color
                });
            }
        },
        {
            id: 7,
            title: "Minhas listas",
            path: "/conta/minhas-listas",
            icon: function() {
                var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ui.theme.colors.neutral[760];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftIcon, {
                    color: color
                });
            }
        }, 
    ];
};

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ListCategories/components/DropdownUserAuthenticated/index.tsx







var DropdownUserAuthenticated = function(param) {
    var handleCloseDropdownUserAuthenticated = param.handleCloseDropdownUserAuthenticated, isOpenedDropdownUser = param.isOpenedDropdownUser;
    var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
        return state.allConfigs;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownUserAuthenticatedContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("dropdown-user-authenticated")), {
        isOpenedDropdownUser: isOpenedDropdownUser,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownUserAuthenticatedHeader, (0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("dropdown-user-authenticated-header"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownTop, (0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("dropdown-user-authenticated-top"))),
            userAuthenticatedActions(allConfigs).map(function(action) {
                return Category({
                    action: action,
                    handleCloseDropdownUserAuthenticated: handleCloseDropdownUserAuthenticated,
                    isCloseIcon: false
                });
            }),
            Category({
                action: null,
                handleCloseDropdownUserAuthenticated: handleCloseDropdownUserAuthenticated,
                isCloseIcon: true
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ListCategories/index.tsx
























var ListCategories = function(param) {
    var refHeaderContainer = param.refHeaderContainer, isPageWeddingList = param.isPageWeddingList, isBlackTheme = param.isBlackTheme;
    var ref, ref1, ref2;
    var ref3 = (0,AuthContext/* useAuth */.aC)(), isAuthenticated = ref3.isAuthenticated, userData = ref3.userData;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,application/* useAppContext */.bp4)(), categories = ref4.categories, isSidebarMenuOpened = ref4.isSidebarMenuOpened, isOpenedDropdownUser = ref4.isOpenedDropdownUser, setIsSidebarMenuOpened = ref4.setIsSidebarMenuOpened, setIsOpenedDropdownUser = ref4.setIsOpenedDropdownUser, closeCategoriesDropDown = ref4.closeCategoriesDropDown;
    var DropdownContainerListRef = (0,react.useRef)(null);
    var ModalAuthRef = (0,react.useRef)(null);
    var CategoryButtonDropDownRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(false), isDropdownHoveredAction = ref5[0], setIsDropdownHoveredAction = ref5[1];
    var ref6 = (0,react.useState)(false), isDropdownClickedAction = ref6[0], setIsDropdownClickedAction = ref6[1];
    var ref7 = (0,react.useState)(false), loginContainerOnHover = ref7[0], setLoginContainerOnHover = ref7[1];
    var ref8 = (0,react.useState)(false), weddingGiftListContainerOnHover = ref8[0], setWeddingGiftListContainerOnHover = ref8[1];
    var setIsAuthenticationDropdownActive = (0,state_manager/* useAuthentication */.JL)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setIsAuthenticationDropdownActive: state.setIsAuthenticationDropdownActive
        };
    })).setIsAuthenticationDropdownActive;
    (0,application/* useClickOutside */.O8h)({
        ref: ModalAuthRef,
        callback: function() {
            if (isOpenedDropdownUser) {
                setIsOpenedDropdownUser(false);
            }
        }
    });
    (0,application/* useClickOutside */.O8h)({
        ref: CategoryButtonDropDownRef,
        callback: function() {
            if (isDropdownClickedAction) {
                setIsDropdownClickedAction(false);
            }
        }
    });
    refHeaderContainer === null || refHeaderContainer === void 0 ? void 0 : (ref = refHeaderContainer.current) === null || ref === void 0 ? void 0 : ref.addEventListener("mouseleave", function() {
        return setIsDropdownHoveredAction(false);
    });
    var debouncedIsDropdownHovered = (0,application/* useDebounce */.NrF)(isDropdownHoveredAction, 300);
    var debouncedIsDropdownClicked = (0,application/* useDebounce */.NrF)(isDropdownClickedAction, 300);
    (0,react.useEffect)(function() {
        setIsSidebarMenuOpened(Boolean(debouncedIsDropdownHovered) || Boolean(debouncedIsDropdownClicked));
    }, [
        debouncedIsDropdownHovered,
        debouncedIsDropdownClicked,
        setIsSidebarMenuOpened, 
    ]);
    var handleProfileDropdown = function(event1) {
        event1 === null || event1 === void 0 ? void 0 : event1.preventDefault();
        event1 === null || event1 === void 0 ? void 0 : event1.stopPropagation();
    };
    var handleOpenDropdownUserAuthenticated = function() {
        // eslint-disable-next-line no-restricted-globals
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setIsOpenedDropdownUser(function(state) {
            return !state;
        });
    };
    var handleClickDropDownClose = function() {
        setIsDropdownHoveredAction(false);
        setIsDropdownClickedAction(false);
    };
    (0,react.useEffect)(function() {
        if (!closeCategoriesDropDown) {
            handleClickDropDownClose();
        }
    }, [
        closeCategoriesDropDown
    ]);
    var ref9 = (0,application/* useHeaderContext */.Jv3)(), highlightCategories = ref9.highlightCategories, isLoadingHighlightCategories = ref9.isLoadingHighlightCategories;
    var highlightCategoriesComponent = (0,hooks/* useMappedBackofficeComponent */.J)({
        type: "highlightCategories",
        subComponents: null,
        displayName: "Menu de Destaques",
        config: null,
        properties: []
    }, {
        isLoading: isLoadingHighlightCategories
    }, highlightCategories);
    var openLoginModal = function(event1) {
        event1 === null || event1 === void 0 ? void 0 : event1.preventDefault();
        event1 === null || event1 === void 0 ? void 0 : event1.stopPropagation();
        setIsAuthenticationDropdownActive(true);
    };
    var isHomePage = (router === null || router === void 0 ? void 0 : router.pathname) === "/";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListCategoriesContainerHeader, {
        isBlackTheme: !!isBlackTheme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentHeaderDesktop, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("content-header-desktop")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentHeaderWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkRedirectHome/* LinkRedirectHome */.x, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("link-redirect-home")), {
                                children: [
                                    isHomePage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListCategoriesTitle, {
                                        children: "Ferreira Costa – Home Center com os Melhores Pre\xe7os do Brasil"
                                    }),
                                    !isBlackTheme || isPageWeddingList ? (router === null || router === void 0 ? void 0 : router.asPath) === "/" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        id: "logo-wapper"
                                    }, (0,application/* buildTestIds */.Fek)("logo-wrapper")), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopLogoFC, {
                                            layout: "fill",
                                            src: "https://d2urakutajlof6.cloudfront.net/logo/logo_fc.svg",
                                            alt: "Logo escrito Ferreira Costa, em branco com bordas vermelhas",
                                            "data-testid": "desktop-logo-fc",
                                            "data-cy": "desktop-logo-fc",
                                            priority: true
                                        })
                                    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                                        id: "logo-wapper",
                                        "data-testid": "logo-wrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopLogoFC, {
                                            layout: "fill",
                                            src: "https://d2urakutajlof6.cloudfront.net/logo/logo_fc.svg",
                                            alt: "Logo escrito Ferreira Costa, em branco com bordas vermelhas",
                                            "data-testid": "desktop-logo-fc",
                                            "data-cy": "desktop-logo-fc",
                                            priority: true
                                        })
                                    }) : (router === null || router === void 0 ? void 0 : router.asPath) === "/" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListCategoriesTitle, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FcLogoBlackWrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.FCLogoBlackFriday, {
                                                alt: "Logo escrito Ferreira Costa Black Friday, em branco com bordas vermelhas e contorno branco",
                                                "data-cy": "desktop-logo-fc-bf",
                                                "data-testid": "desktop-logo-fc-bf"
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FcLogoBlackWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.FCLogoBlackFriday, {
                                            alt: "Logo escrito Ferreira Costa Black Friday, em branco com bordas vermelhas e contorno branco",
                                            "data-cy": "desktop-logo-fc-bf",
                                            "data-testid": "desktop-logo-fc-bf"
                                        })
                                    })
                                ]
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                                isDesktop: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListCategoriesAside, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("list-categories-aside")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderUserActionsSection, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wedding-gift-list-link")), {
                                        href: "/lista-de-casamento",
                                        target: "_self",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.FlexContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wedding-gift-list-container")), {
                                            alignItems: "center",
                                            gap: "8px",
                                            onMouseEnter: function(event1) {
                                                event1 === null || event1 === void 0 ? void 0 : event1.preventDefault();
                                                event1 === null || event1 === void 0 ? void 0 : event1.stopPropagation();
                                                setWeddingGiftListContainerOnHover(true);
                                            },
                                            onMouseLeave: function(event1) {
                                                event1 === null || event1 === void 0 ? void 0 : event1.preventDefault();
                                                event1 === null || event1 === void 0 ? void 0 : event1.stopPropagation();
                                                setWeddingGiftListContainerOnHover(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Alliances, {
                                                    color: isBlackTheme ? ui.theme.colors.blackFriday[20] : weddingGiftListContainerOnHover ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[999]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WeddingGiftListText, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wedding-gift-list-text")), {
                                                    mouseOver: weddingGiftListContainerOnHover,
                                                    children: [
                                                        "Lista de ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        " casamento"
                                                    ]
                                                }))
                                            ]
                                        }))
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapperUser, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        href: "/",
                                        "aria-label": "\xc1rea de login do usu\xe1rio"
                                    }, (0,application/* buildTestIds */.Fek)("link-wrapper-user-desk")), {
                                        onClick: function(event1) {
                                            return isAuthenticated ? handleProfileDropdown : openLoginModal(event1);
                                        },
                                        children: isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.BoxButtonAuth, {
                                            ref: ModalAuthRef,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.UserWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-user-authenticated")), {
                                                    onClick: function() {
                                                        return handleOpenDropdownUserAuthenticated();
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ImageCircle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("image-circle")), {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.UserInitials, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("user-initial")), {
                                                                children: (userData === null || userData === void 0 ? void 0 : userData.name) ? (0,application/* getUserInitials */.ZhG)(userData === null || userData === void 0 ? void 0 : userData.name) : null
                                                            }))
                                                        })),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(WelcomeText, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("greeting-message")), {
                                                            children: [
                                                                "Ol\xe1, ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " ",
                                                                (userData === null || userData === void 0 ? void 0 : userData.name) ? userData === null || userData === void 0 ? void 0 : (ref1 = userData.name) === null || ref1 === void 0 ? void 0 : ref1.split(" ")[0] : null
                                                            ]
                                                        }))
                                                    ]
                                                })),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownUserAuthenticated, {
                                                    handleCloseDropdownUserAuthenticated: handleOpenDropdownUserAuthenticated,
                                                    isOpenedDropdownUser: isOpenedDropdownUser
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.FlexContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                            position: "relative",
                                            alignItems: "center",
                                            gap: ui.theme.space.x2,
                                            whiteSpace: "nowrap",
                                            onMouseEnter: function(event1) {
                                                event1 === null || event1 === void 0 ? void 0 : event1.preventDefault();
                                                event1 === null || event1 === void 0 ? void 0 : event1.stopPropagation();
                                                setLoginContainerOnHover(true);
                                            },
                                            onMouseLeave: function(event1) {
                                                event1 === null || event1 === void 0 ? void 0 : event1.preventDefault();
                                                event1 === null || event1 === void 0 ? void 0 : event1.stopPropagation();
                                                setLoginContainerOnHover(false);
                                            }
                                        }, (0,application/* buildTestIds */.Fek)("user-unaunthenticated-container")), {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.UserIcon, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("user-icon-component")), {
                                                    alt: "\xcdcone de usu\xe1rio",
                                                    "aria-label": "\xc1rea de login do usu\xe1rio",
                                                    color: isBlackTheme ? ui.theme.colors.blackFriday[20] : loginContainerOnHover ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[999]
                                                })),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EnterOrCreateAccountText, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("instruction-message")), {
                                                    mouseOver: loginContainerOnHover,
                                                    children: [
                                                        "Entrar ou criar ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "conta"
                                                    ]
                                                })),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAuthentication, (0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-authentication")))
                                            ]
                                        }))
                                    }))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton, {})
                        ]
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentHeaderCategoriesDesktop, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("content-header-categories-desktop")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryButtonDropDown, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("category-button-dropdown")), {
                        onMouseUp: function() {
                            return setIsDropdownClickedAction(function(state) {
                                return !state;
                            });
                        },
                        onMouseEnter: function() {
                            return setIsDropdownHoveredAction(true);
                        },
                        isDropdownOpen: isSidebarMenuOpened,
                        ref: CategoryButtonDropDownRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("category-dropdown-container")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownContainerList, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("dropdown-container-categories-list-header")), {
                                        ref: DropdownContainerListRef,
                                        children: (categories === null || categories === void 0 ? void 0 : (ref2 = categories.data) === null || ref2 === void 0 ? void 0 : ref2.length) ? categories.data.map(function(category) {
                                            /*#__PURE__*/ return (0,react.createElement)(DropdownContainerListItem, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("category-item-".concat((0,application/* formatTestId */.c$e)(category.title)))), {
                                                key: "".concat(category.id),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperList, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryListedInDropdown, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("category-item-listed-in-dropdown")), {
                                                                "aria-label": "Item da lista de categorias",
                                                                href: "/".concat(category === null || category === void 0 ? void 0 : category.descriptionUrl),
                                                                target: "_self",
                                                                children: category.title
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon, {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubMenuContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubMenuContent, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubMenuContentHeader, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTitle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("category-title-submenu")), {
                                                                            href: "/".concat(category === null || category === void 0 ? void 0 : category.descriptionUrl),
                                                                            target: "_self",
                                                                            children: category.title
                                                                        })),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_styles/* Divider */.iz, {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListCategoriesInner, {
                                                                    category: category,
                                                                    level: 2
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }));
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
                                            count: 10,
                                            width: "17.25rem"
                                        })
                                    }))
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryNameContainer, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.HamburgerIcon, {
                                        color: ui.theme.colors.primary[200]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTitleSection, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("category-title-section")), {
                                        children: "Categorias"
                                    }))
                                ]
                            })
                        ]
                    })),
                    isLoadingHighlightCategories ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("skeleton-list-categories")), {
                        type: "chip",
                        count: 5,
                        hasMargin: false
                    })) : highlightCategoriesComponent
                ]
            })),
            (router === null || router === void 0 ? void 0 : router.pathname) === "/" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAuthenticationModal, {}) : null
        ]
    });
};
ListCategories.displayName = "ListCategories";
var ListCategoriesWithBlackThemeValidation = (0,hocs/* withBlackThemeValidation */.z7)(ListCategories);


// EXTERNAL MODULE: ../../packages/application/context/BranchLocationContext.tsx
var BranchLocationContext = __webpack_require__(64462);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/DropdownBranchLocation/styles.ts

function DropdownBranchLocation_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DropdownBranchLocation_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DropdownBranchLocation_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 7;\n  max-width: 335px;\n  width: 100%;\n  height: 8.875rem !important;\n  position: absolute;\n  margin-top: 2.5rem;\n  display: ",
        ";\n  opacity: ",
        ";\n  flex-direction: column;\n  justify-content: space-between;\n  background: ",
        ";\n  border-radius: 8px;\n  padding: 1rem;\n  box-shadow: 0 0.25rem 1rem 0 ",
        ";\n\n  @media ",
        " {\n    margin-top: 7rem;\n    max-width: 380px;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    &::after {\n      content: none !important;\n    }\n\n    span {\n      margin-bottom: 0rem !important;\n    }\n  }\n\n  @media ",
        " {\n    max-width: 330px !important;\n  }\n\n  @media ",
        ' {\n    max-width: 296px !important;\n  }\n\n  &::after {\n    content: "";\n    position: absolute;\n    top: 0px;\n    left: 24px;\n    width: 10px;\n    height: 10px;\n    border-radius: 2px;\n    transform: rotate(-45deg);\n    transform-origin: left top;\n    background: ',
        ";\n  }\n"
    ]);
    DropdownBranchLocation_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DropdownBranchLocation_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.125rem;\n"
    ]);
    DropdownBranchLocation_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DropdownBranchLocation_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.125rem;\n  color: ",
        ";\n"
    ]);
    DropdownBranchLocation_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DropdownBranchLocation_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 0.5rem;\n"
    ]);
    DropdownBranchLocation_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DropdownBranchLocation_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  width: 100%;\n  height: 2.5rem;\n  border-radius: 8px;\n  padding: 0.875rem 1rem;\n  margin: 0.75rem 0;\n  cursor: pointer;\n  border: 0;\n  transition: all 0.2s ease;\n  font-weight: bold;\n"
    ]);
    DropdownBranchLocation_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DropdownBranchLocation_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  color: ",
        ";\n\n  &:hover {\n    background: rgb(218, 8, 18, 0.05);\n  }\n\n  &:focus {\n    border: thin solid ",
        ";\n  }\n"
    ]);
    DropdownBranchLocation_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function DropdownBranchLocation_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  &:focus {\n    border: thin solid ",
        ";\n  }\n"
    ]);
    DropdownBranchLocation_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var Parent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__Parent",
    componentId: "sc-2452f76e-0"
})(DropdownBranchLocation_styles_templateObject());
var DropdownBranchLocationContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__DropdownBranchLocationContainer",
    componentId: "sc-2452f76e-1"
})(DropdownBranchLocation_styles_templateObject1(), function(param) {
    var isHadOpen = param.isHadOpen;
    return isHadOpen ? "flex" : "none";
}, function(param) {
    var isHadOpen = param.isHadOpen;
    return isHadOpen ? 1 : 0;
}, ui.theme.colors.neutral.white, ui.theme.colors.neutral[400], ui.theme.device.desktopFirst.mobileXL, ui.theme.device.desktopFirst.mobileM, ui.theme.device.desktopFirst.mobileS, ui.theme.colors.neutral.white);
var DropdownBranchLocationContent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DropdownBranchLocationContent",
    componentId: "sc-2452f76e-2"
})(DropdownBranchLocation_styles_templateObject2());
var TitleRegionClient = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    displayName: "styles__TitleRegionClient",
    componentId: "sc-2452f76e-3"
})(DropdownBranchLocation_styles_templateObject3(), ui.theme.colors.primary[200]);
var WrapperButtons = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    displayName: "styles__WrapperButtons",
    componentId: "sc-2452f76e-4"
})(DropdownBranchLocation_styles_templateObject4());
var BaseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__BaseButton",
    componentId: "sc-2452f76e-5"
})(DropdownBranchLocation_styles_templateObject5());
var ContinueButton = (0,styled_components_browser_esm/* default */.ZP)(BaseButton).withConfig({
    displayName: "styles__ContinueButton",
    componentId: "sc-2452f76e-6"
})(DropdownBranchLocation_styles_templateObject6(), ui.theme.colors.primary[200], ui.theme.colors.primary[200]);
var ChangeLocationButton = (0,styled_components_browser_esm/* default */.ZP)(BaseButton).withConfig({
    displayName: "styles__ChangeLocationButton",
    componentId: "sc-2452f76e-7"
})(DropdownBranchLocation_styles_templateObject7(), ui.theme.colors.primary[200], ui.theme.colors.neutral.white, ui.theme.colors.primary[400], ui.theme.colors.primary[200]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/DropdownBranchLocation/index.tsx








var cookieModalBranchLocationStr = "@FC:Ecom:Modal:BranchLocation";
var DropdownBranchLocation = function() {
    var ref = (0,BranchLocationContext/* useBranchLocation */.vK)(), regionClientLocation = ref.regionClientLocation, onOpenModalBranchLocation = ref.onOpenModalBranchLocation, statementDropdownBranchLocation = ref.statementDropdownBranchLocation, setDefaultBranchLocation = ref.setDefaultBranchLocation;
    var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
        return state.allConfigs;
    });
    // Mudança temporária, a pedido de Volpato, Peixoto e Armando em 17/06/2023
    // const [isContinueWithCurrentLocation, setIsContinueWithCurrentLocation] =
    //   useState(true);
    var ref1 = (0,react.useState)(false), isContinueWithCurrentLocation = ref1[0], setIsContinueWithCurrentLocation = ref1[1];
    var handleContinueLocation = function() {
        setIsContinueWithCurrentLocation(false);
        setDefaultBranchLocation();
    };
    var handleChangeLocation = function() {
        onOpenModalBranchLocation();
        setIsContinueWithCurrentLocation(false);
        setDefaultBranchLocation();
    };
    var hadVisualizationModalBranchLocationInFirstRender = implementations/* cookie.getCookie */.pR.getCookie({
        name: cookieModalBranchLocationStr
    });
    if (statementDropdownBranchLocation && !hadVisualizationModalBranchLocationInFirstRender && (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isModalBranchLocationAutoOpenOnClientFirstAccess) === "true") {
        onOpenModalBranchLocation();
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Parent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("dropdown-branch-location")), {
        children: statementDropdownBranchLocation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownBranchLocationContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("dropdown-branch-location-container")), {
            isHadOpen: isContinueWithCurrentLocation,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownBranchLocationContent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("dropdown-branch-location-content")), {
                    children: [
                        "Para acessar produtos e ofertas da sua regi\xe3o, identificamos que voc\xea est\xe1 em",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleRegionClient, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-dropdown-branch-location-title")), {
                            children: [
                                regionClientLocation !== null && regionClientLocation !== void 0 ? regionClientLocation : "Demais Regi\xf5es",
                                "."
                            ]
                        }))
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperButtons, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-dropdown-branch-location-wrapper-buttons")), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeLocationButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            type: "button",
                            onClick: function() {
                                return handleChangeLocation();
                            }
                        }, (0,application/* buildTestIds */.Fek)("header-change-location-button")), {
                            children: "Alterar"
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContinueButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            type: "button",
                            onClick: function() {
                                return handleContinueLocation();
                            }
                        }, (0,application/* buildTestIds */.Fek)("header-continue-button")), {
                            children: "Continuar"
                        }))
                    ]
                }))
            ]
        }))
    }));
};


// EXTERNAL MODULE: ../../packages/components/patterns/Header/components/ModalBranchLocation/components/StateInput/styles.ts
var StateInput_styles = __webpack_require__(20128);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ModalBranchLocation/components/StateInput/index.tsx






var StateInput = function(param) {
    var conditionError = param.conditionError, conditionSuccess = param.conditionSuccess, messageError = param.messageError;
    var ref = (0,application/* useAppContext */.bp4)(), isFirefox = ref.isFirefox, isSafari = ref.isSafari;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: conditionError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StateInput_styles/* WrapperAlertError */.WE, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-error-icon")), {
                    positionShouldBeRelative: isFirefox || isSafari,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StateInput_styles/* AlertError */.ne, {})
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StateInput_styles/* TextError */.uF, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("text-error")), {
                    children: messageError
                }))
            ]
        }) : conditionSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StateInput_styles/* WrapperCheckSuccess */.b8, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-success-icon")), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StateInput_styles/* CheckSuccess */.G8, {})
        })) : null
    }, messageError);
};


// EXTERNAL MODULE: ../../packages/components/Form/Label/index.tsx + 1 modules
var Label = __webpack_require__(3355);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ModalBranchLocation/styles.ts

function ModalBranchLocation_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n      display: none;\n      opacity: 0;\n  }\n\n  1% {\n      display: flex;\n      opacity: 0;\n  }\n\n  100% {\n      display: flex;\n      opacity: 1;\n  }\n"
    ]);
    ModalBranchLocation_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"
    ]);
    ModalBranchLocation_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        " 0.4s ease\n        "
    ]);
    ModalBranchLocation_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        " 0.4s ease\n        "
    ]);
    ModalBranchLocation_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  opacity: ",
        ";\n  display: ",
        ";\n  justify-content: center;\n  z-index: 9999;\n  background: rgba(39, 44, 54, 0.3);\n\n  animation: ",
        ";\n"
    ]);
    ModalBranchLocation_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  width: 100%;\n  height: 100%;\n  max-height: 504px;\n  max-width: 500px;\n  border-radius: 5px;\n  box-shadow: 0 0 60px ",
        ";\n  position: relative;\n  transform: translateY(7vh);\n  padding: ",
        " ",
        ";\n\n  @media ",
        " {\n    max-height: 476px;\n    max-width: 324px;\n  }\n"
    ]);
    ModalBranchLocation_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    ModalBranchLocation_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 2rem;\n  font-family: ",
        ", sans-serif;\n  font-weight: 700;\n  text-align: center;\n  padding-bottom: 1rem;\n  width: 100%;\n\n  @media ",
        " {\n    font-size: 1.35rem;\n  }\n"
    ]);
    ModalBranchLocation_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2rem;\n\n  width: 100% !important;\n  height: auto !important;\n\n  @media ",
        " {\n    padding: 0.75rem 2rem 0;\n  }\n"
    ]);
    ModalBranchLocation_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  text-align: center;\n  font-weight: 400;\n  font-size: 1.5rem;\n  font-family: ",
        ", sans-serif;\n  line-height: 1.75rem;\n  color: ",
        ";\n\n  @media ",
        " {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n"
    ]);
    ModalBranchLocation_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1.5rem 2rem;\n\n  @media ",
        " {\n    padding: 2rem 2rem 0;\n  }\n"
    ]);
    ModalBranchLocation_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ", sans-serif;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    ModalBranchLocation_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: 0.65rem 0 0.5rem !important;\n    "
    ]);
    ModalBranchLocation_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-color: ",
        " !important;\n    "
    ]);
    ModalBranchLocation_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 3rem;\n  padding: 0.75rem;\n  border: 1px solid\n    ",
        ";\n  border-radius: 4px;\n  background: ",
        ";\n  color: ",
        ";\n  transition: all 0.2s ease;\n  font-family: ",
        ", sans-serif;\n  font-weight: 500;\n  font-size: ",
        ";\n  margin: ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  &:hover {\n    border: 1px solid\n      ",
        ";\n  }\n\n  &:focus {\n    border: 1px solid\n      ",
        ";\n  }\n\n  &::placeholder {\n    color: ",
        ";\n    font-size: 1.125rem;\n    font-family: ",
        ", sans-serif;\n    font-weight: 400;\n  }\n"
    ]);
    ModalBranchLocation_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1.25rem;\n"
    ]);
    ModalBranchLocation_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 4rem) !important;\n  height: auto !important;\n  max-height: 8.45rem;\n  background: ",
        ";\n  position: absolute;\n  overflow: auto;\n  border-radius: 0 0 4px 4px;\n  border: 1px solid ",
        ";\n  margin-top: -0.975rem;\n  display: ",
        ";\n  opacity: ",
        ";\n  visibility: ",
        ";\n  flex-direction: column;\n  z-index: 8;\n"
    ]);
    ModalBranchLocation_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ", sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n"
    ]);
    ModalBranchLocation_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  padding: 0.75rem;\n\n  border-bottom: 1px solid ",
        ";\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: ",
        ";\n\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n"
    ]);
    ModalBranchLocation_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  height: 2.25rem;\n  width: 100%;\n  padding: 0 1rem;\n"
    ]);
    ModalBranchLocation_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 2.25rem;\n  width: 2.5rem;\n  cursor: pointer;\n"
    ]);
    ModalBranchLocation_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: inherit;\n  height: inherit;\n\n  background: none;\n  outline: none;\n  border: none;\n  cursor: pointer;\n"
    ]);
    ModalBranchLocation_styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ModalBranchLocation_styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ModalBranchLocation_styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n  height: 1.75rem;\n  margin-bottom: 0.75rem;\n\n  @media ",
        " {\n    margin-bottom: 2rem;\n  }\n"
    ]);
    ModalBranchLocation_styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.925rem;\n  color: ",
        ";\n  gap: 0.25rem;\n  font-family: ",
        ", sans-serif;\n"
    ]);
    ModalBranchLocation_styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ModalBranchLocation_styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function ModalBranchLocation_styles_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  width: 100%;\n  height: 3rem;\n  border-radius: 8px;\n  padding: 0.65rem 0;\n  cursor: pointer;\n  border: 0;\n  transition: all 0.2s ease;\n  font-weight: 700;\n"
    ]);
    ModalBranchLocation_styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  margin-top: 2rem;\n  color: ",
        ";\n  text-decoration: underline;\n  gap: 0.25rem;\n  font-size: 1.35rem;\n\n  &:hover {\n    background: rgb(190, 15, 44, 0.03);\n  }\n\n  &:focus {\n    border: thin solid ",
        ";\n  }\n\n  @media ",
        " {\n    margin-top: 1rem;\n    font-size: 1rem;\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: ",
        ";\n  height: 3rem;\n  transition: all 0.2s ease;\n  display: flex;\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n\n  &:not(:disabled):hover {\n    background: ",
        ";\n  }\n\n  &:focus {\n    border: thin solid ",
        ";\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}




// interface ModalBranchLocationContainerProps {
//   isHadShowButtonConfirm: boolean;
// }
// type ConfirmButtonProps = ModalBranchLocationContainerProps;
var animationOpenModal = (0,styled_components_browser_esm/* keyframes */.F4)(ModalBranchLocation_styles_templateObject());
var animationCloseModal = (0,styled_components_browser_esm/* keyframes */.F4)(ModalBranchLocation_styles_templateObject1());
var ModalBranchLocationOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ModalBranchLocationOverlay",
    componentId: "sc-64cdd140-0"
})(ModalBranchLocation_styles_templateObject4(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? 1 : 0;
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "flex" : "none";
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? (0,styled_components_browser_esm/* css */.iv)(ModalBranchLocation_styles_templateObject2(), animationOpenModal) : (0,styled_components_browser_esm/* css */.iv)(ModalBranchLocation_styles_templateObject3(), animationCloseModal);
});
var ModalBranchLocationContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ModalBranchLocationContainer",
    componentId: "sc-64cdd140-1"
})(ModalBranchLocation_styles_templateObject5(), ui.theme.colors.neutral.white, ui.theme.colors.neutral["999-opacity-05"], ui.theme.space.x3, ui.theme.space.x0, ui.theme.device.desktopFirst.tablet);
var HeaderModal = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__HeaderModal",
    componentId: "sc-64cdd140-2"
})(ModalBranchLocation_styles_templateObject6(), ui.theme.colors.neutral[150]);
var TitleModal = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TitleModal",
    componentId: "sc-64cdd140-3"
})(ModalBranchLocation_styles_templateObject7(), ui.theme.colors.neutral[550], ui.theme.typography.fontFamily.roboto, ui.theme.device.desktopFirst.tablet);
var MainContent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__MainContent",
    componentId: "sc-64cdd140-4"
})(ModalBranchLocation_styles_templateObject8(), ui.theme.device.desktopFirst.tablet);
var InfoText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__InfoText",
    componentId: "sc-64cdd140-5"
})(ModalBranchLocation_styles_templateObject9(), ui.theme.typography.fontFamily.roboto, ui.theme.colors.neutral[550], ui.theme.device.desktopFirst.tablet);
var styles_FormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FormContainer",
    componentId: "sc-64cdd140-6"
})(ModalBranchLocation_styles_templateObject10(), ui.theme.device.desktopFirst.tablet);
var LabelCustom = (0,styled_components_browser_esm/* default */.ZP)(Label/* default */.Z).withConfig({
    displayName: "styles__LabelCustom",
    componentId: "sc-64cdd140-7"
})(ModalBranchLocation_styles_templateObject11(), ui.theme.typography.fontFamily.roboto, function(param) {
    var highlightText = param.highlightText;
    return highlightText ? "bold" : 500;
}, function(param) {
    var highlightText = param.highlightText;
    return highlightText ? "1.25rem" : "1.05rem";
}, ui.theme.colors.neutral[550]);
var CustomInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "styles__CustomInput",
    componentId: "sc-64cdd140-8"
})(ModalBranchLocation_styles_templateObject14(), function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[200];
}, ui.theme.colors.neutral.white, ui.theme.colors.neutral[999], ui.theme.typography.fontFamily.roboto, function(param) {
    var highlightText = param.highlightText;
    return highlightText ? "1.35rem" : "1.125rem";
}, function(param) {
    var hasLargeMarginBottom = param.hasLargeMarginBottom;
    return hasLargeMarginBottom ? "0.65rem 0 0.75rem" : "0.65rem 0 0.5rem";
}, function(param) {
    var hasLargeMarginBottom = param.hasLargeMarginBottom, hasError = param.hasError;
    return hasError && hasLargeMarginBottom && (0,styled_components_browser_esm/* css */.iv)(ModalBranchLocation_styles_templateObject12());
}, function(param) {
    var hasSuccessfully = param.hasSuccessfully;
    return hasSuccessfully && (0,styled_components_browser_esm/* css */.iv)(ModalBranchLocation_styles_templateObject13(), ui.theme.colors.secondary[380]);
}, function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[200] : ui.theme.colors.neutral[200];
}, function(param) {
    var hasError = param.hasError;
    return hasError ? ui.theme.colors.primary[200] : ui.theme.colors.secondary[380];
}, ui.theme.colors.neutral[200], ui.theme.typography.fontFamily.roboto);
var styles_InputContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__InputContainer",
    componentId: "sc-64cdd140-9"
})(ModalBranchLocation_styles_templateObject15());
var styles_DropdownContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__DropdownContainer",
    componentId: "sc-64cdd140-10"
})(ModalBranchLocation_styles_templateObject16(), ui.theme.colors.neutral["white-050"], ui.theme.colors.neutral[99], function(param) {
    var isShowDropdown = param.isShowDropdown;
    return isShowDropdown ? "flex" : "none";
}, function(param) {
    var isShowDropdown = param.isShowDropdown;
    return isShowDropdown ? "1" : "0";
}, function(param) {
    var isShowDropdown = param.isShowDropdown;
    return isShowDropdown ? "visible" : "hidden";
});
var CityTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__CityTitle",
    componentId: "sc-64cdd140-11"
})(ModalBranchLocation_styles_templateObject17(), ui.theme.colors.neutral[350], ui.theme.typography.fontFamily.roboto);
var DropdownContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DropdownContent",
    componentId: "sc-64cdd140-12"
})(ModalBranchLocation_styles_templateObject18(), ui.theme.colors.neutral[99], ui.theme.colors.secondary[28], CityTitle, ui.theme.colors.neutral[999]);
var ContentCloseIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ContentCloseIcon",
    componentId: "sc-64cdd140-13"
})(ModalBranchLocation_styles_templateObject19());
var WrapperCloseIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperCloseIcon",
    componentId: "sc-64cdd140-14"
})(ModalBranchLocation_styles_templateObject20());
var ButtonCloseIcon = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonCloseIcon",
    componentId: "sc-64cdd140-15"
})(ModalBranchLocation_styles_templateObject21());
var styles_Close = (0,styled_components_browser_esm/* default */.ZP)(ui.CloseIcon).attrs({
    width: "2.125rem",
    height: "1.75rem"
}).withConfig({
    displayName: "styles__Close",
    componentId: "sc-64cdd140-16"
})(ModalBranchLocation_styles_templateObject22());
var ActualLocationIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.Map).attrs({
    width: "1.5rem",
    height: "1.5rem",
    color: ui.theme.colors.primary[350]
}).withConfig({
    displayName: "styles__ActualLocationIcon",
    componentId: "sc-64cdd140-17"
})(ModalBranchLocation_styles_templateObject23());
var InfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__InfoContainer",
    componentId: "sc-64cdd140-18"
})(ModalBranchLocation_styles_templateObject24(), ui.theme.device.desktopFirst.tablet);
var CustomLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    displayName: "styles__CustomLink",
    componentId: "sc-64cdd140-19"
})(ModalBranchLocation_styles_templateObject25(), ui.theme.colors.neutral[550], ui.theme.typography.fontFamily.roboto);
var InterrogationIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.Interrogation).attrs({
    width: "1rem",
    height: "1rem"
}).withConfig({
    displayName: "styles__InterrogationIcon",
    componentId: "sc-64cdd140-20"
})(ModalBranchLocation_styles_templateObject26());
var styles_BaseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__BaseButton",
    componentId: "sc-64cdd140-21"
})(ModalBranchLocation_styles_templateObject27());
var ClientLocationButton = (0,styled_components_browser_esm/* default */.ZP)(styles_BaseButton).withConfig({
    displayName: "styles__ClientLocationButton",
    componentId: "sc-64cdd140-22"
})(_templateObject28(), ui.theme.colors.primary[350], ui.theme.colors.primary[350], ui.theme.device.desktopFirst.tablet);
var ConfirmButton = (0,styled_components_browser_esm/* default */.ZP)(styles_BaseButton).withConfig({
    displayName: "styles__ConfirmButton",
    componentId: "sc-64cdd140-23"
})(_templateObject29(), ui.theme.colors.secondary[250], ui.theme.colors.neutral.white, ui.theme.colors.secondary[350], ui.theme.colors.secondary[350]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/ModalBranchLocation/index.tsx














var ModalBranchLocation = function() {
    var ref = (0,react.useState)({}), addressBySelectedCity = ref[0], setAddressBySelectedCity = ref[1];
    var ref1 = (0,react.useState)(""), userZipCode = ref1[0], setUserZipCode = ref1[1];
    var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
        return state.allConfigs;
    });
    var router = (0,next_router.useRouter)();
    var ref2 = (0,BranchLocationContext/* useBranchLocation */.vK)(), isOpen = ref2.isOpen, onCloseModalBranchLocation = ref2.onCloseModalBranchLocation, // handleClientLocationByHimCurrentLocation,
    handleLocationBySubmit = ref2.handleLocationBySubmit;
    var ref3 = (0,index_esm/* useForm */.cI)(), register = ref3.register, handleSubmit = ref3.handleSubmit, reset = ref3.reset, resetField = ref3.resetField, watch = ref3.watch, setValue = ref3.setValue;
    var cityWatching = watch("city");
    var ref4 = (0,react.useState)(watch("zipCode")), zipCodeWatching = ref4[0], setZipCodeWatching = ref4[1];
    var ref5 = (0,react.useState)(2), locationBranchId = ref5[0], setLocationBranchId = ref5[1];
    var ref6 = (0,react.useState)(false), isTypingCity = ref6[0], setIsTypingCity = ref6[1];
    var branchLocationContainerModal = (0,react.useRef)(null);
    var ref7 = useGetAddressByCity(cityWatching, isTypingCity, addressBySelectedCity === null || addressBySelectedCity === void 0 ? void 0 : addressBySelectedCity.city, implementations/* shippingApi */.JK), addressByCityList = ref7.addressByCityList, conditionErrorToCity = ref7.conditionErrorToCity, conditionSuccessToCity = ref7.conditionSuccessToCity;
    var ref8 = useGetAddressByZipCode(zipCodeWatching, implementations/* shippingApi */.JK), addressByZipCode = ref8.addressByZipCode, isZipCodeLengthValid = ref8.isZipCodeLengthValid, isInvalidZipCode = ref8.isInvalidZipCode, hasZipCodeError = ref8.hasZipCodeError;
    var onAutoCompleteCityByZipCode = (0,react.useCallback)(function() {
        if (isZipCodeLengthValid && (addressByZipCode === null || addressByZipCode === void 0 ? void 0 : addressByZipCode.city)) {
            setValue("city", "".concat(addressByZipCode === null || addressByZipCode === void 0 ? void 0 : addressByZipCode.city, " - ").concat(addressByZipCode === null || addressByZipCode === void 0 ? void 0 : addressByZipCode.uf));
            setAddressBySelectedCity({
                city: addressByZipCode === null || addressByZipCode === void 0 ? void 0 : addressByZipCode.city,
                uf: addressByZipCode === null || addressByZipCode === void 0 ? void 0 : addressByZipCode.uf,
                cep: zipCodeWatching,
                branchId: addressByZipCode === null || addressByZipCode === void 0 ? void 0 : addressByZipCode.branchId
            });
            setLocationBranchId((addressByZipCode === null || addressByZipCode === void 0 ? void 0 : addressByZipCode.branchId) || 2);
            setUserZipCode(zipCodeWatching);
        }
    }, [
        addressByZipCode,
        zipCodeWatching,
        isZipCodeLengthValid,
        setValue
    ]);
    var handleClientLocationBySelectedCityAndState = function(param) {
        var cityAndState = param.city, zipCode = param.zipCode;
        var getZipCode = (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isAutoLoadShippingInfo) === "true" ? userZipCode : zipCode;
        handleLocationBySubmit(getZipCode, cityAndState, locationBranchId, router);
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(application/* cookiePostalCodeStr */.emg, getZipCode);
        setAddressBySelectedCity({});
        reset();
    };
    var handleOnTypeZipCode = (0,react.useCallback)(function(event) {
        var mask = event.target.value;
        mask = mask.replace(/\D/g, "").replace(/(\d{5})(\d)/, "$1-$2").replace(/(-\d{3})\d+?$/, "$1");
        setZipCodeWatching(mask);
        // eslint-disable-next-line no-param-reassign
        event.target.value = mask;
        setIsTypingCity(false);
    }, []);
    var handleSetIsTypingCity = (0,react.useCallback)(function() {
        setIsTypingCity(true);
    }, []);
    var onSelectCity = function(address) {
        setValue("city", "".concat(address.city, " - ").concat(address.uf));
        setIsTypingCity(false);
        resetField("zipCode");
        setUserZipCode(address.cep);
        setAddressBySelectedCity(address);
        setLocationBranchId((address === null || address === void 0 ? void 0 : address.branchId) || 2);
    };
    (0,react.useEffect)(function() {
        onAutoCompleteCityByZipCode();
    }, [
        onAutoCompleteCityByZipCode
    ]);
    var isHadShowButtonConfirm = zipCodeWatching ? !isInvalidZipCode && !!addressBySelectedCity.city : !!addressBySelectedCity.city;
    var conditionToShowButtonConfirm = isHadShowButtonConfirm && cityWatching === "".concat(addressBySelectedCity.city, " - ").concat(addressBySelectedCity.uf);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBranchLocationOverlay, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        isOpen: isOpen
    }, (0,application/* buildTestIds */.Fek)("modal-branch-location-overlay")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBranchLocationContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-branch-location-container")), {
            ref: branchLocationContainerModal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCloseIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperCloseIcon, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-close-icon-modal-branch-location")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCloseIcon, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-close-modal-branch-location")), {
                            onClick: function() {
                                onCloseModalBranchLocation(implementations/* cookie */.pR);
                                reset();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Close, {
                                alt: "\xcdcone de fechar"
                            })
                        }))
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderModal, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-modal")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleModal, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-modal-branch-location")), {
                        children: "Por favor, informe sua localiza\xe7\xe3o"
                    }))
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("main-content-header")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("info-text-modal-branch-location")), {
                        children: "Digite seu CEP ou cidade para ter acesso aos melhores fretes e prazos para sua regi\xe3o."
                    }))
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l0, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_FormContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-container-modal-branch-location")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelCustom, (0,src_object_spread/* default */.Z)({
                                htmlFor: "zip-code",
                                text: "Digite seu CEP",
                                highlightText: true
                            }, (0,application/* buildTestIds */.Fek)("label-zip-code-modal-branch-location"))),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput, (0,src_object_spread/* default */.Z)({
                                id: "zip-code",
                                onKeyUp: handleOnTypeZipCode,
                                placeholder: "_ _ _ _ _-_ _ _",
                                type: "tel",
                                max: 9,
                                autoComplete: "off",
                                highlightText: true,
                                maxLength: 9,
                                hasError: hasZipCodeError,
                                hasSuccessfully: isZipCodeLengthValid && !hasZipCodeError
                            }, register("zipCode"), (0,application/* buildTestIds */.Fek)("input-zip-code-modal-branch-location"))),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StateInput, (0,src_object_spread/* default */.Z)({
                                conditionError: hasZipCodeError,
                                conditionSuccess: isZipCodeLengthValid && !isInvalidZipCode,
                                messageError: "CEP Inv\xe1lido"
                            }, (0,application/* buildTestIds */.Fek)("state-input-cep-error"))),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-link-modal-branch-location")), {
                                    target: "_blank",
                                    href: "https://www2.correios.com.br/sistemas/buscacep/buscaCep.cfm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InterrogationIcon, {
                                            alt: "\xcdcone de interroga\xe7\xe3o"
                                        }),
                                        "N\xe3o sei meu CEP"
                                    ]
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelCustom, (0,src_object_spread/* default */.Z)({
                                htmlFor: "city",
                                text: "ou, se preferir, insira o nome da sua cidade"
                            }, (0,application/* buildTestIds */.Fek)("label-city-modal-branch-location"))),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_InputContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput, (0,src_object_spread/* default */.Z)({
                                        id: "city",
                                        placeholder: "Nome da cidade",
                                        type: "text",
                                        hasError: conditionErrorToCity,
                                        hasSuccessfully: conditionSuccessToCity,
                                        hasLargeMarginBottom: true,
                                        autoComplete: "off",
                                        onKeyUp: handleSetIsTypingCity
                                    }, register("city"), (0,application/* buildTestIds */.Fek)("input-city-modal-branch-location"))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_DropdownContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        isShowDropdown: !!(addressByCityList === null || addressByCityList === void 0 ? void 0 : addressByCityList.length)
                                    }, (0,application/* buildTestIds */.Fek)("dropdown-container-modal-branch-location")), {
                                        children: (addressByCityList === null || addressByCityList === void 0 ? void 0 : addressByCityList.length) ? addressByCityList === null || addressByCityList === void 0 ? void 0 : addressByCityList.map(function(address) {
                                            return /*#__PURE__*/ (0,react.createElement)(DropdownContent, (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("dropdown-content-modal-branch-location")), {
                                                onClick: function() {
                                                    onSelectCity(address);
                                                },
                                                key: address.cep
                                            }), (0,application/* buildTestIds */.Fek)("dropdown-content-modal-branch-location")), /*#__PURE__*/ (0,jsx_runtime.jsxs)(CityTitle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("city-title-modal-branch-location")), {
                                                children: [
                                                    address.city,
                                                    " - ",
                                                    address.uf
                                                ]
                                            })));
                                        }) : null
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StateInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("state-input-city-error")), {
                                        conditionError: conditionErrorToCity,
                                        conditionSuccess: conditionSuccessToCity,
                                        messageError: "Cidade n\xe3o encontrada"
                                    }))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("button-submit-modal-branch-location")), {
                                onClick: handleSubmit(handleClientLocationBySelectedCityAndState),
                                type: conditionToShowButtonConfirm ? "submit" : "button"
                            }), (0,application/* buildTestIds */.Fek)("button-submit-modal-branch-location")), {
                                disabled: !conditionToShowButtonConfirm,
                                children: "Confirmar"
                            }))
                        ]
                    }))
                })
            ]
        }))
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/NavBarDesktop/index.tsx









var companyProducts = [
    {
        title: "Lista de Casamento",
        path: "/lista-de-casamento/"
    },
    {
        title: "Nossas Lojas",
        path: "https://ferreiracosta.movidesk.com/kb/article/156436/nossas-lojas?ticketId=&q="
    },
    {
        title: "Para Empresas",
        path: "http://empresas.ferreiracosta.com/"
    },
    {
        title: "Clube do Profissional",
        path: "https://clubedoprofissional.ferreiracosta.com/"
    }, 
];
var NavBarDesktop = function(param) {
    var companyProductsColor = param.companyProductsColor, isBlackFriday = param.isBlackFriday;
    var isPageWeddingList = (0,application/* useAppContext */.bp4)().isPageWeddingList;
    var ref = (0,application/* useBranchLocation */.vKz)(), regionClientLocation = ref.regionClientLocation, onOpenModalBranchLocation = ref.onOpenModalBranchLocation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBranchLocation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownBranchLocation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBarDesktopContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-navbar-location-desktop-header")), {
                isPageWeddingList: isPageWeddingList,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentLocation, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("content-location-desktop-header")), {
                        onClick: function() {
                            return onOpenModalBranchLocation();
                        },
                        arrowDownColor: isPageWeddingList || isBlackFriday ? ui.theme.colors.neutral.white : ui.theme.colors.neutral[999],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationIcon, {
                                width: 16,
                                height: 16,
                                alt: "\xedcone de localiza\xe7\xe3o",
                                color: isPageWeddingList ? ui.theme.colors.neutral.white : ui.theme.colors.primary[200]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionText, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-navbar-location-desktop")), {
                                isPageWeddingList: isPageWeddingList,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Text, {
                                    fontSize: "15px",
                                    margin: "0px 0px 0px 5px",
                                    children: [
                                        regionClientLocation === "Demais Regi\xf5es" ? "" : "Voc\xea est\xe1 em ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionClientLocation, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("nav-bar-region-client-desktop")), {
                                            isPageWeddingList: isPageWeddingList,
                                            children: regionClientLocation !== null && regionClientLocation !== void 0 ? regionClientLocation : "Demais Regi\xf5es"
                                        }))
                                    ]
                                })
                            }))
                        ]
                    })),
                    (companyProducts === null || companyProducts === void 0 ? void 0 : companyProducts.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.FlexContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("flex-container-company-products-header")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCompanyProducts, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            isPageWeddingList: isPageWeddingList
                        }, (0,application/* buildTestIds */.Fek)("content-company-products-header")), {
                            children: companyProducts.map(function(product) {
                                return /*#__PURE__*/ (0,react.createElement)(CompanyProductLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("company-product-link-".concat((0,application/* formatTestId */.c$e)(product.title)))), {
                                    isPageWeddingList: isPageWeddingList,
                                    key: product.title,
                                    href: product.path,
                                    color: companyProductsColor !== null && companyProductsColor !== void 0 ? companyProductsColor : ui.theme.colors.neutral[900],
                                    margin: ui.theme.space.x4,
                                    children: [
                                        product.title,
                                        isPageWeddingList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerCompanyProducts, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("divider-company-product")), {
                                            isPageWeddingList: isPageWeddingList,
                                            children: "|"
                                        })) : null
                                    ]
                                }));
                            })
                        }))
                    })) : null
                ]
            }))
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/mobile/NavBarMobile/index.tsx









var NavBarMobile = function() {
    var isPageWeddingList = (0,application/* useAppContext */.bp4)().isPageWeddingList;
    var ref = (0,BranchLocationContext/* useBranchLocation */.vK)(), regionClientLocation = ref.regionClientLocation, onOpenModalBranchLocation = ref.onOpenModalBranchLocation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBranchLocation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownBranchLocation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarMobileContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("nav-bar-mobile-container")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-navbar-location-mobile-header")), {
                    onClick: onOpenModalBranchLocation,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_LocationIcon, {
                            width: 16,
                            height: 16,
                            alt: "\xedcone de localiza\xe7\xe3o",
                            color: isPageWeddingList ? ui.theme.colors.neutral.white : ui.theme.colors.primary[200]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_RegionText, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("nav-bar-region-client-container-mobile")), {
                            isPageWeddingList: isPageWeddingList,
                            children: regionClientLocation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    regionClientLocation === "Demais Regi\xf5es" ? "" : "Voc\xea est\xe1 em ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionTextStrong, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("nav-bar-region-client-mobile")), {
                                        children: regionClientLocation !== null && regionClientLocation !== void 0 ? regionClientLocation : "Demais Regi\xf5es"
                                    }))
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: "Demais Regi\xf5es"
                            })
                        }))
                    ]
                }))
            }))
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/UserAuthenticationBox/styles.ts

function UserAuthenticationBox_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  @media ",
        " {\n    line-height: 16px;\n  }\n"
    ]);
    UserAuthenticationBox_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    UserAuthenticationBox_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 36px;\n\n  @media ",
        " {\n    height: 24px;\n  }\n"
    ]);
    UserAuthenticationBox_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n"
    ]);
    UserAuthenticationBox_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  margin-right: 1rem;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n\n  @media ",
        " {\n    margin-right: 0;\n  }\n\n  &::-webkit-tap-highlight-color {\n    color: none;\n    background: none;\n  }\n\n  @media ",
        " {\n    cursor: auto;\n  }\n"
    ]);
    UserAuthenticationBox_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n\n  @media ",
        " {\n    gap: ",
        ";\n  }\n"
    ]);
    UserAuthenticationBox_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 230px;\n  width: 100%;\n\n  @media ",
        " {\n    display: none;\n  }\n\n  @media ",
        " {\n    display: flex;\n    max-width: 230px;\n  }\n"
    ]);
    UserAuthenticationBox_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media ",
        " {\n    display: none;\n  }\n\n  @media ",
        " {\n    display: flex;\n    gap: ",
        ";\n  }\n"
    ]);
    UserAuthenticationBox_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  @media ",
        " {\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    UserAuthenticationBox_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    UserAuthenticationBox_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n\n  @media ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    UserAuthenticationBox_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 232px;\n\n  &:hover {\n    background-color: ",
        ";\n    border-radius: ",
        ";\n    transition: all 0.2s ease-in;\n\n    ",
        ", ",
        ", svg > path, circle {\n      color: ",
        ";\n      stroke: ",
        ";\n    }\n  }\n\n  @media ",
        " {\n    width: 100%;\n  }\n\n  @media ",
        " {\n    width: 100%;\n\n    &:hover {\n      background-color: transparent;\n      border-radius: 0;\n\n      ",
        ", svg > path, circle {\n        color: ",
        ";\n        stroke: ",
        ";\n      }\n\n      ",
        ", ",
        " {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    UserAuthenticationBox_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n"
    ]);
    UserAuthenticationBox_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    UserAuthenticationBox_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  padding: 0;\n  text-decoration: none;\n  align-self: center;\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    UserAuthenticationBox_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function UserAuthenticationBox_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n  background-color: ",
        ";\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    UserAuthenticationBox_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}


var UserEmail = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__UserEmail",
    componentId: "sc-f8f2f45d-0"
})(UserAuthenticationBox_styles_templateObject(), ui.theme.colors.neutral.white, ui.theme.typography.fontSize.sm.x3, ui.theme.typography.fontWeight[400], ui.theme.device.desktopFirst.mobileXL);
var UserName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__UserName",
    componentId: "sc-f8f2f45d-1"
})(UserAuthenticationBox_styles_templateObject1(), ui.theme.typography.fontSize.sm.x5, ui.theme.colors.neutral.white, ui.theme.typography.fontWeight[700]);
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__IconWrapper",
    componentId: "sc-f8f2f45d-2"
})(UserAuthenticationBox_styles_templateObject2(), ui.theme.device.desktopFirst.mobileXL);
var styles_HeaderUserActionsSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__HeaderUserActionsSection",
    componentId: "sc-f8f2f45d-3"
})(UserAuthenticationBox_styles_templateObject3());
var styles_LinkWrapperUser = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LinkWrapperUser",
    componentId: "sc-f8f2f45d-4"
})(UserAuthenticationBox_styles_templateObject4(), ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileXL);
var WelcomeWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__WelcomeWrapper",
    componentId: "sc-f8f2f45d-5"
})(UserAuthenticationBox_styles_templateObject5(), ui.theme.space["x1.5"], ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x3);
var UserInformation = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__UserInformation",
    componentId: "sc-f8f2f45d-6"
})(UserAuthenticationBox_styles_templateObject6(), ui.theme.device.desktopFirst.tabletML, ui.theme.device.desktopFirst.mobileXL);
var WelcomeMessageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WelcomeMessageContainer",
    componentId: "sc-f8f2f45d-7"
})(UserAuthenticationBox_styles_templateObject7(), ui.theme.space["x0.5"], ui.theme.device.desktopFirst.tabletML, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x0);
var WelcomeMessageTitle = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    displayName: "styles__WelcomeMessageTitle",
    componentId: "sc-f8f2f45d-8"
})(UserAuthenticationBox_styles_templateObject8(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[700], ui.theme.colors.neutral[999], ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontWeight[500], ui.theme.colors.neutral.white);
var WelcomeMessageLinkContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WelcomeMessageLinkContainer",
    componentId: "sc-f8f2f45d-9"
})(UserAuthenticationBox_styles_templateObject9(), ui.theme.space.x1);
var WelcomeMessageLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WelcomeMessageLink",
    componentId: "sc-f8f2f45d-10"
})(UserAuthenticationBox_styles_templateObject10(), ui.theme.typography.fontSize.sm.x3, ui.theme.colors.neutral[585], ui.theme.device.desktopFirst.mobileXL, ui.theme.colors.neutral.white);
var WelcomeContainer = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__WelcomeContainer",
    componentId: "sc-f8f2f45d-11"
})(UserAuthenticationBox_styles_templateObject11(), ui.theme.colors.neutral[174], ui.theme.space.x2, WelcomeMessageTitle, WelcomeMessageLink, ui.theme.colors.neutral[930], ui.theme.colors.neutral[930], ui.theme.device.desktopFirst.tabletML, ui.theme.device.desktopFirst.mobileXL, WelcomeMessageTitle, ui.theme.colors.neutral[680], ui.theme.colors.neutral[999], WelcomeMessageLink, UserEmail, ui.theme.colors.neutral[585]);
var FullEmail = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__FullEmail",
    componentId: "sc-f8f2f45d-12"
})(UserAuthenticationBox_styles_templateObject12(), ui.theme.typography.fontSize.sm.x3, ui.theme.colors.neutral[130]);
var ShowMoreText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ShowMoreText",
    componentId: "sc-f8f2f45d-13"
})(UserAuthenticationBox_styles_templateObject13(), ui.theme.typography.fontSize.sm.x1, ui.theme.colors.neutral[345]);
var UserInitials = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__UserInitials",
    componentId: "sc-f8f2f45d-14"
})(UserAuthenticationBox_styles_templateObject14(), ui.theme.typography.fontSize.sm.x3, ui.theme.colors.neutral.white);
var ImageCircle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ImageCircle",
    componentId: "sc-f8f2f45d-15"
})(UserAuthenticationBox_styles_templateObject15(), ui.theme.colors.secondary[200]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/UserAuthenticationBox/data.tsx



var useUserAuthenticationBox = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,application/* useAppContext */.bp4)(), isOpenedDropdownUser = ref.isOpenedDropdownUser, setIsOpenedDropdownUser = ref.setIsOpenedDropdownUser, isClientMobile = ref.isClientMobile;
    var ref1 = (0,application/* useAuth */.aCi)(), isAuthenticated = ref1.isAuthenticated, userData = ref1.userData;
    var setIsAuthenticationDropdownActive = (0,application/* useAuthentication */.JLf)((0,application/* useShallow */.NL6)(function(state) {
        return {
            setIsAuthenticationDropdownActive: state.setIsAuthenticationDropdownActive
        };
    })).setIsAuthenticationDropdownActive;
    var ModalAuthRef = (0,react.useRef)(null);
    var handleOpenDropdownUserAuthenticated = function() {
        if (isClientMobile) {
            return;
        }
        // eslint-disable-next-line no-restricted-globals
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setIsOpenedDropdownUser(function(state) {
            return !state;
        });
    };
    var openLoginModal = function(event1, path) {
        if (isClientMobile) {
            router.push(path || "/login");
            return;
        }
        event1 === null || event1 === void 0 ? void 0 : event1.preventDefault();
        event1 === null || event1 === void 0 ? void 0 : event1.stopPropagation();
        setIsAuthenticationDropdownActive(true);
    };
    var handleUserMenu = function(event1) {
        if (isClientMobile) {
            return;
        }
        openLoginModal(event1);
    };
    return {
        handleOpenDropdownUserAuthenticated: handleOpenDropdownUserAuthenticated,
        openLoginModal: openLoginModal,
        handleUserMenu: handleUserMenu,
        ModalAuthRef: ModalAuthRef,
        userData: userData,
        isClientMobile: isClientMobile,
        isOpenedDropdownUser: isOpenedDropdownUser,
        isAuthenticated: isAuthenticated
    };
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/UserAuthenticationBox/index.tsx









var UserAuthenticationBox = function() {
    var ref = useUserAuthenticationBox(), handleUserMenu = ref.handleUserMenu, isAuthenticated = ref.isAuthenticated, ModalAuthRef = ref.ModalAuthRef, handleOpenDropdownUserAuthenticated = ref.handleOpenDropdownUserAuthenticated, openLoginModal = ref.openLoginModal, isOpenedDropdownUser = ref.isOpenedDropdownUser, userData = ref.userData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_HeaderUserActionsSection, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_LinkWrapperUser, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            "aria-label": "\xc1rea de login do usu\xe1rio"
        }, (0,application/* buildTestIds */.Fek)("link-wrapper-user-desk")), {
            onClick: function(event) {
                return handleUserMenu(event);
            },
            children: isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.BoxButtonAuth, {
                ref: ModalAuthRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.UserWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-user-authenticated")), {
                        onClick: handleOpenDropdownUserAuthenticated,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("icon-wrapper")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCircle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("image-circle")), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInitials, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("user-initial")), {
                                        children: (userData === null || userData === void 0 ? void 0 : userData.name) ? (0,application/* getUserInitials */.ZhG)(userData === null || userData === void 0 ? void 0 : userData.name) : null
                                    }))
                                }))
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInformation, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("user-information")), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserName, {
                                        children: userData === null || userData === void 0 ? void 0 : userData.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserEmail, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("user-email")), {
                                        children: userData === null || userData === void 0 ? void 0 : userData.email
                                    }))
                                ]
                            }))
                        ]
                    })),
                    isOpenedDropdownUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownUserAuthenticated, {
                        handleCloseDropdownUserAuthenticated: handleOpenDropdownUserAuthenticated,
                        isOpenedDropdownUser: isOpenedDropdownUser
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(WelcomeContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                position: "relative",
                alignItems: "center",
                gap: ui.theme.space.x2,
                whiteSpace: "nowrap"
            }, (0,application/* buildTestIds */.Fek)("user-unaunthenticated-container")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(WelcomeWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("welcome-wrapper")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("icon-wrapper")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.UserIcon, {
                                    width: 24,
                                    height: 24,
                                    color: ui.theme.colors.neutral.white
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WelcomeMessageContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("instruction-message")), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WelcomeMessageTitle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("welcome-message-title")), {
                                        children: "Bem vindo!"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(WelcomeMessageLinkContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("welcome-message-link-container")), {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WelcomeMessageLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                                onClick: function(e) {
                                                    return openLoginModal(e, "/login");
                                                }
                                            }, (0,application/* buildTestIds */.Fek)("welcome-message-link-login")), {
                                                children: "Entre"
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WelcomeMessageLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("welcome-message-link-register")), {
                                                onClick: function(e) {
                                                    return openLoginModal(e, "/cadastro");
                                                },
                                                children: "ou cadastre-se"
                                            }))
                                        ]
                                    }))
                                ]
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAuthentication, (0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-authentication")))
                ]
            }))
        }))
    });
};

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/mobile/SidebarMenuMobile/data/index.tsx







var data_userAuthenticatedActions = function(allConfigs) {
    return [
        {
            id: 8,
            title: "Minha Conta",
            path: "/conta/",
            isLogout: false,
            hasBorderBottom: true,
            icon: /*#__PURE__*/ _jsx(ProfileIcon, {})
        },
        {
            id: 1,
            title: "Meus Cart\xf5es",
            path: "/conta/meus-cartoes",
            isLogout: false,
            hasBorderBottom: true,
            icon: /*#__PURE__*/ _jsx(CardIcon, {})
        },
        {
            id: 2,
            title: "Meus Endere\xe7os",
            path: "/conta/meus-enderecos",
            isLogout: false,
            hasBorderBottom: true,
            icon: /*#__PURE__*/ _jsx(HouseIcon, {})
        },
        {
            id: 3,
            title: "Seguran\xe7a",
            path: (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isSecurityPageAvailable) === "true" ? "/conta/seguranca" : "/conta/seguranca/alterar-senha",
            isLogout: false,
            hasBorderBottom: true,
            icon: /*#__PURE__*/ _jsx(SecurityIcon, {})
        },
        {
            id: 4,
            title: "Minhas Listas",
            path: "/conta/minhas-listas",
            isLogout: false,
            hasBorderBottom: true,
            icon: /*#__PURE__*/ _jsx(GiftBoxIcon, {})
        },
        {
            id: 5,
            title: "Lista de Casamento",
            path: "/lista-de-casamento",
            isLogout: false,
            hasBorderBottom: true,
            icon: /*#__PURE__*/ _jsx(AlliancesIcon, {})
        },
        {
            id: 6,
            title: "Fazer Logout",
            path: "/#",
            isLogout: true,
            hasBorderBottom: false,
            icon: /*#__PURE__*/ _jsx(Close, {})
        }, 
    ];
};
// Quando implementar a http request para buscar highlight categories separadamente, substituir essa lógica
var handleHighlightCategories = function(highlightCategories) {
    if (!(highlightCategories === null || highlightCategories === void 0 ? void 0 : highlightCategories.length)) {
        return [];
    }
    var formattedHighlightCategories = highlightCategories === null || highlightCategories === void 0 ? void 0 : highlightCategories.map(function(category) {
        var name = category.name, descriptionUrl = category.descriptionUrl;
        return {
            name: name,
            descriptionUrl: descriptionUrl
        };
    });
    // console.log("formattedHighlightCategories: ", formattedHighlightCategories);
    return (0,src_to_consumable_array/* default */.Z)(formattedHighlightCategories).concat([
        {
            name: "Ver todas categorias",
            descriptionUrl: "",
            excludeDivider: true,
            color: ui.theme.colors.primary[200]
        }, 
    ]);
};
// Essa lista abaixo precisará ser substituída pelos stories, os quais virão da Home personalizada pelo Backoffice.
var listCategories = [
    {
        name: "Eletro e eletr\xf4nicos",
        image: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb_dev/10588_thumb"
    },
    {
        name: "Utilidades dom\xe9sticas",
        image: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb_dev/10587_thumb"
    },
    {
        name: "M\xf3veis e acess\xf3rios",
        image: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb_dev/10585_thumb"
    },
    {
        name: "Decora\xe7\xe3o",
        image: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb_dev/10583_thumb"
    },
    {
        name: "Pisos e revestimentos",
        image: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb_dev/10586_thumb"
    },
    {
        name: "Ar e ventila\xe7\xe3o",
        image: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb_dev/10584_thumb"
    }, 
];
var data_companyProducts = [
    {
        title: "Clube do Profissional",
        path: "https://clubedoprofissional.ferreiracosta.com/"
    },
    {
        title: "Nossas Lojas",
        path: "https://ferreiracosta.movidesk.com/kb/article/156436/nossas-lojas?ticketId=&q="
    },
    {
        title: "Para Empresas",
        path: "http://empresas.ferreiracosta.com/"
    },
    {
        title: "Televendas",
        path: "https://ferreiracosta.movidesk.com/kb/article/156443/qual-o-horario-de-funcionamento-e-contatos-do-vendas-corporativa?ticketId=&q="
    },
    {
        title: "Pol\xedtica de Entrega",
        path: "https://ferreiracosta.movidesk.com/kb/article/156345/politica-de-entrega-da-ferreira-costa?ticketId=&q="
    }, 
];
var categoriesIcon = [
    {
        title: "Eletro e eletr\xf4nicos",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.EletronicosIcon, {})
    },
    {
        title: "Utilidades dom\xe9sticas",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.UtilidadesDomesticasIcon, {})
    },
    {
        title: "M\xf3veis e decora\xe7\xe3o",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.MoveisEDecoracaoIcon, {})
    },
    {
        title: "Cama, mesa e banho",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CamaMesaEBanhoIcon, {})
    },
    {
        title: "Automotivo",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.AutomotivoIcon, {})
    },
    {
        title: "Materiais el\xe9tricos",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.MateriaisEletricosIcon, {})
    },
    {
        title: "Materiais hidr\xe1ulicos e bombas",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.MateriaisHidraulicosIcon, {})
    },
    {
        title: "Pisos e revestimentos",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.PisosERevestimentosIcon, {})
    },
    {
        title: "Lou\xe7as, metais e acess\xf3rios",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.LoucasMetaisEAcessoriosIcon, {})
    },
    {
        title: "Portas, janelas e fechaduras",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.PortasJanelasEFechadurasIcon, {})
    },
    {
        title: "Tintas e qu\xedmicos",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.TintasEQuimicosIcon, {})
    },
    {
        title: "Ferramentas e EPI",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.FerramentasEEPIIcon, {})
    }, 
];
var Categories = function() {
    var ref;
    var categories = (0,application/* useAppContext */.bp4)().categories;
    return categories === null || categories === void 0 ? void 0 : (ref = categories.data) === null || ref === void 0 ? void 0 : ref.map(function(category) {
        var categoryIcon = categoriesIcon.find(function(icon) {
            return icon.title === category.title;
        });
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, category), {
            image: categoryIcon === null || categoryIcon === void 0 ? void 0 : categoryIcon.image
        });
    });
};
var HightLightCategoriesIcon = [
    {
        name: "Ilumina\xe7\xe3o",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.IluminacaoIcon, {})
    },
    {
        name: "Constru\xe7\xe3o",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ConstrucaoIcon, {})
    }, 
];
var HighLightCategories = function() {
    var highlightCategories = (0,application/* useHeaderContext */.Jv3)().highlightCategories;
    var highlightCategoriesAndSeeAllCategoriesOption = handleHighlightCategories(highlightCategories || undefined);
    if (!(highlightCategoriesAndSeeAllCategoriesOption === null || highlightCategoriesAndSeeAllCategoriesOption === void 0 ? void 0 : highlightCategoriesAndSeeAllCategoriesOption.length)) {
        return null;
    }
    return highlightCategoriesAndSeeAllCategoriesOption.map(function(category) {
        var categoryIcon = HightLightCategoriesIcon.find(function(icon) {
            return icon.name === category.name;
        });
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, category), {
            image: categoryIcon === null || categoryIcon === void 0 ? void 0 : categoryIcon.image
        });
    });
};

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/mobile/SidebarMenuMobile/components/OffersList/index.tsx









var formatTestId = function(testId) {
    return testId.replace(/\s/g, "-").toLowerCase();
};
var OffersList = /*#__PURE__*/ (0,react.memo)(function(param) {
    var isAuthenticated = param.isAuthenticated, onCloseSidebarMenu = param.onCloseSidebarMenu, setCategoriesLevel = param.setCategoriesLevel;
    var highlightCategories = (0,application/* useHeaderContext */.Jv3)().highlightCategories;
    var highlightCategoriesAndSeeAllCategoriesOption = handleHighlightCategories(highlightCategories || undefined);
    if (!(highlightCategoriesAndSeeAllCategoriesOption === null || highlightCategoriesAndSeeAllCategoriesOption === void 0 ? void 0 : highlightCategoriesAndSeeAllCategoriesOption.length)) {
        return null;
    }
    var onlyHighlight = highlightCategoriesAndSeeAllCategoriesOption.filter(function(category) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return ((ref1 = category === null || category === void 0 ? void 0 : (ref = category.descriptionUrl) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes("destaque")) && !((ref3 = category === null || category === void 0 ? void 0 : (ref2 = category.descriptionUrl) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === null || ref3 === void 0 ? void 0 : ref3.includes("construcao")) && !((ref5 = category === null || category === void 0 ? void 0 : (ref4 = category.descriptionUrl) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) === null || ref5 === void 0 ? void 0 : ref5.includes("iluminacao-categoria"));
    });
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* TitleWrapper */.$t, {
                isAuthenticated: isAuthenticated,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Title, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-offers-sidebar-menu-mobile")), {
                    color: ui.theme.colors.neutral[999],
                    fontSize: ui.theme.typography.fontSize.sm.x5,
                    fontWeight: ui.theme.typography.fontWeight[500],
                    children: "Destaques"
                }))
            }),
            onlyHighlight === null || onlyHighlight === void 0 ? void 0 : onlyHighlight.map(function(category) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* Link */.r, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    href: "/".concat(category.descriptionUrl),
                    target: "_self"
                }, (0,application/* buildTestIds */.Fek)("highlight-categories-link-".concat(formatTestId(category.name)))), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarMenuMobile_styles/* ListContentSidebarMenuWrapper */.Tk, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("list-content-wrapper-".concat(formatTestId(category.name)))), {
                        isBorderActive: !(category === null || category === void 0 ? void 0 : category.excludeDivider),
                        onClick: (category === null || category === void 0 ? void 0 : category.excludeDivider) ? undefined : onCloseSidebarMenu,
                        children: [
                            !(category === null || category === void 0 ? void 0 : category.excludeDivider) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* CategorySidebarMenu */.n7, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                isOffersList: true
                            }, (0,application/* buildTestIds */.Fek)("".concat(formatTestId(category.name), "-sidebar-menu-mobile"))), {
                                id: "SidebarContainerOverlayId",
                                onClick: onCloseSidebarMenu,
                                children: category.name
                            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* CategorySidebarMenu */.n7, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("".concat(formatTestId(category.name), "-sidebar-menu-mobile"))), {
                                isOffersList: true,
                                onClick: function(e) {
                                    e === null || e === void 0 ? void 0 : e.preventDefault();
                                    setCategoriesLevel("FirstLevel");
                                },
                                menuColor: (ref = category === null || category === void 0 ? void 0 : category.excludeDivider) !== null && ref !== void 0 ? ref : undefined,
                                children: category.name
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* CategoryExploreIcon */.pd, (0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("category-explore-icon")))
                        ]
                    }))
                }), category.name);
            })
        ]
    });
});
OffersList.displayName = "OffersList";


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/mobile/SidebarMenuMobile/components/ServicesList/index.tsx









var ServicesList = /*#__PURE__*/ (0,react.memo)(function(param) {
    var onCloseSidebarMenu = param.onCloseSidebarMenu, setCategoriesLevel = param.setCategoriesLevel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* TitleWrapper */.$t, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Title, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-store-and-services")), {
                    color: ui.theme.colors.neutral[999],
                    fontSize: ui.theme.typography.fontSize.sm.x5,
                    fontWeight: ui.theme.typography.fontWeight[500],
                    children: "Servi\xe7os"
                }))
            }),
            data_companyProducts === null || data_companyProducts === void 0 ? void 0 : data_companyProducts.map(function(products) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    href: products.path,
                    target: "_selft",
                    width: "100%"
                }, (0,application/* buildTestIds */.Fek)("highlight-categories-link-".concat(products.title))), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarMenuMobile_styles/* ListContentSidebarMenuWrapper */.Tk, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("list-content-wrapper-".concat(products.title))), {
                        isBorderActive: false,
                        isEnterpriseProduct: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* CategorySidebarMenu */.n7, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("".concat(products.title, "-sidebar-menu-mobile"))), {
                                isOffersList: true,
                                onClick: function() {
                                    setCategoriesLevel("FirstLevel");
                                    onCloseSidebarMenu();
                                },
                                children: products.title
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* CategoryExploreIcon */.pd, (0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("category-explore-icon")))
                        ]
                    }))
                }), products.title);
            })
        ]
    });
});
ServicesList.displayName = "ServicesList";


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/mobile/SidebarMenuMobile/components/FirstLevelCategories/index.tsx














var iconColor = "".concat(ui.theme.colors.neutral[999]);
var FirstLevelCategories = function(param) {
    var onCloseSidebarMenu = param.onCloseSidebarMenu, setCategoriesLevel = param.setCategoriesLevel;
    var ref, ref1;
    var ref2 = (0,application/* useAuth */.aCi)(), isAuthenticated = ref2.isAuthenticated, signOutAccount = ref2.signOutAccount;
    var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
        return state.allConfigs;
    });
    var router = (0,next_router.useRouter)();
    var ref3 = (0,application/* useCategories */.L_s)((0,application/* useShallow */.NL6)(function(state) {
        return {
            setSelectedCategory: state.setSelectedCategory,
            setCategoryTitle: state.setCategoryTitle,
            setCategoryUrl: state.setCategoryUrl
        };
    })), setSelectedCategory = ref3.setSelectedCategory, setCategoryTitle = ref3.setCategoryTitle, setCategoryUrl = ref3.setCategoryUrl;
    var categories = Categories();
    var highLightCategories = (ref = HighLightCategories()) === null || ref === void 0 ? void 0 : ref.filter(function(category) {
        var ref, ref1, ref2, ref3;
        return ((ref1 = category === null || category === void 0 ? void 0 : (ref = category.descriptionUrl) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes("construcao")) || ((ref3 = category === null || category === void 0 ? void 0 : (ref2 = category.descriptionUrl) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === null || ref3 === void 0 ? void 0 : ref3.includes("iluminacao-categoria"));
    });
    var handleCategoryClick = function(title, url, category) {
        if (category) {
            setSelectedCategory(category);
            setCategoriesLevel("SecondLevel");
            setCategoryTitle(title);
            setCategoryUrl(url);
        }
    };
    var handleCategoriesNavigation = (0,react.useCallback)(function(category) {
        router.push("/".concat(category === null || category === void 0 ? void 0 : category.descriptionUrl));
        onCloseSidebarMenu();
    }, [
        onCloseSidebarMenu,
        router
    ]);
    var handleSignOut = (0,react.useCallback)(function() {
        signOutAccount(implementations/* cookie */.pR);
        onCloseSidebarMenu();
    }, [
        onCloseSidebarMenu,
        signOutAccount
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarMenuMobile_styles/* ListCategoriesSidebarMenu */.Uw, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("list-categories-sidebar-menu")), {
        children: [
            (ref1 = (0,application/* userAuthenticatedActions */.GuQ)(allConfigs)) === null || ref1 === void 0 ? void 0 : ref1.map(function(action) {
                /*#__PURE__*/ return (0,react.createElement)(SidebarMenuMobile_styles/* AuthenticatedOptionDefault */.DA, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("action-item-link-".concat(action.title))), {
                    key: action === null || action === void 0 ? void 0 : action.id,
                    as: SidebarMenuMobile_styles/* AuthenticatedOptionWithLink */.x5,
                    href: action.path,
                    target: "_self",
                    onClick: function() {
                        return onCloseSidebarMenu();
                    }
                }), /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* LinkWrapper */.gM, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("action-link-wrapper-".concat(action.title))), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarMenuMobile_styles/* UserAuthenticatedActionsSidebarMenu */.rP, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("action-item-wrapper-".concat(action.title))), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* WrapperIcon */.aS, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("action-item-wrapper-icon-".concat(action.title))), {
                                children: action.icon(iconColor)
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* TitleAction */.VK, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("action-item-title-".concat(action.title))), {
                                children: action.title
                            }))
                        ]
                    }))
                })));
            }),
            isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* AuthenticatedOptionDefault */.DA, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("action-item-link-Sair")), {
                as: SidebarMenuMobile_styles/* AuthenticatedOptionDefault */.DA,
                href: "/",
                target: "_self",
                onClick: handleSignOut,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* LinkWrapper */.gM, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("action-link-wrapper-Sair")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarMenuMobile_styles/* UserAuthenticatedActionsSidebarMenu */.rP, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("action-item-wrapper-Sair")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* WrapperIcon */.aS, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("action-item-wrapper-icon-Sair")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {
                                    width: 20,
                                    height: 20,
                                    color: ui.theme.colors.neutral[999]
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* TitleAction */.VK, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("action-item-title-Sair")), {
                                children: "Sair"
                            }))
                        ]
                    }))
                }))
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* TitleWrapper */.$t, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-wrapper")), {
                isAuthenticated: isAuthenticated,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Title, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-categories-sidebar-menu-mobile")), {
                    color: ui.theme.colors.neutral[999],
                    fontSize: ui.theme.typography.fontSize.sm.x5,
                    fontWeight: ui.theme.typography.fontWeight[500],
                    children: "Categorias"
                }))
            })),
            categories === null || categories === void 0 ? void 0 : categories.map(function(category) {
                /*#__PURE__*/ return (0,react.createElement)(react.Fragment, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("categories-fragment-".concat(category === null || category === void 0 ? void 0 : category.title))), {
                    key: category === null || category === void 0 ? void 0 : category.id
                }), /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarMenuMobile_styles/* CategoriesList */.wg, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("categories-list-".concat(category === null || category === void 0 ? void 0 : category.title))), {
                    onClick: function() {
                        return handleCategoryClick(category === null || category === void 0 ? void 0 : category.title, category === null || category === void 0 ? void 0 : category.descriptionUrl, category === null || category === void 0 ? void 0 : category.categories);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarMenuMobile_styles/* CategorySidebarMenu */.n7, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("category-title-".concat(category === null || category === void 0 ? void 0 : category.title))), {
                            children: [
                                category === null || category === void 0 ? void 0 : category.image,
                                category === null || category === void 0 ? void 0 : category.title
                            ]
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* CategoryExploreIcon */.pd, {})
                    ]
                })));
            }),
            highLightCategories === null || highLightCategories === void 0 ? void 0 : highLightCategories.map(function(category) {
                /*#__PURE__*/ return (0,react.createElement)(react.Fragment, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("categories-fragment-".concat(category === null || category === void 0 ? void 0 : category.name))), {
                    key: category === null || category === void 0 ? void 0 : category.name
                }), /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* CategoriesList */.wg, {
                    onClick: function() {
                        return handleCategoriesNavigation(category);
                    },
                    children: /*#__PURE__*/ (0,react.createElement)(Link/* Link */.r, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("categories-link-".concat(category === null || category === void 0 ? void 0 : category.name))), {
                        key: category === null || category === void 0 ? void 0 : category.name,
                        href: "/".concat(category === null || category === void 0 ? void 0 : category.descriptionUrl),
                        target: "_self",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarMenuMobile_styles/* CategorySidebarMenu */.n7, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("category-name-".concat(category === null || category === void 0 ? void 0 : category.name))), {
                                children: [
                                    category === null || category === void 0 ? void 0 : category.image,
                                    category === null || category === void 0 ? void 0 : category.name
                                ]
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* CategoryExploreIcon */.pd, {})
                        ]
                    }))
                }));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersList, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("offer-list")), {
                isAuthenticated: !!isAuthenticated,
                onCloseSidebarMenu: onCloseSidebarMenu,
                setCategoriesLevel: setCategoriesLevel
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesList, {
                onCloseSidebarMenu: onCloseSidebarMenu,
                setCategoriesLevel: setCategoriesLevel
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/mobile/SidebarMenuMobile/components/SubCategories/styles.ts

function SubCategories_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    SubCategories_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SubCategories_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  padding: ",
        " ",
        ";\n  border-bottom: 1px solid ",
        ";\n  cursor: pointer;\n"
    ]);
    SubCategories_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SubCategories_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    SubCategories_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SubCategories_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  cursor: pointer;\n"
    ]);
    SubCategories_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SubCategories_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    SubCategories_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SubCategories_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  cursor: pointer;\n\n  ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    SubCategories_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var SubCategoriesContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SubCategoriesContainer",
    componentId: "sc-8cbcfe3f-0"
})(SubCategories_styles_templateObject(), ui.theme.colors.neutral.white);
var SubCategoriesHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__SubCategoriesHeader",
    componentId: "sc-8cbcfe3f-1"
})(SubCategories_styles_templateObject1(), ui.theme.space.x2, ui.theme.space.x2, ui.theme.space.x4, ui.theme.colors.neutral[150]);
var SubCategoriesTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__SubCategoriesTitle",
    componentId: "sc-8cbcfe3f-2"
})(SubCategories_styles_templateObject2(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[500], ui.theme.colors.neutral[999]);
var styles_CategoryContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CategoryContainer",
    componentId: "sc-8cbcfe3f-3"
})(SubCategories_styles_templateObject3(), ui.theme.colors.neutral[150], ui.theme.space.x2, ui.theme.space.x4);
var styles_CategoryTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__CategoryTitle",
    componentId: "sc-8cbcfe3f-4"
})(SubCategories_styles_templateObject4(), ui.theme.colors.neutral[345], ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[400]);
var SeeAll = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SeeAll",
    componentId: "sc-8cbcfe3f-5"
})(SubCategories_styles_templateObject5(), ui.theme.colors.neutral[150], ui.theme.space.x2, ui.theme.space.x4, styles_CategoryTitle, ui.theme.colors.primary[150]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/mobile/SidebarMenuMobile/components/SubCategories/index.tsx









var SubCategories = function(param) {
    var onCloseSidebarMenu = param.onCloseSidebarMenu, level = param.level, setCategoriesLevel = param.setCategoriesLevel;
    var router = (0,next_router.useRouter)();
    var ref = (0,application/* useCategories */.L_s)((0,application/* useShallow */.NL6)(function(state) {
        return {
            selectedCategory: state.selectedCategory,
            categoryTitle: state.categoryTitle,
            categoryUrl: state.categoryUrl,
            setThirdLevelCategory: state.setThirdLevelCategory,
            setThirdLevelTitle: state.setThirdLevelTitle,
            setThirdLevelUrl: state.setThirdLevelUrl,
            thirdLevelCategory: state.thirdLevelCategory,
            thirdLevelTitle: state.thirdLevelTitle,
            thirdLevelUrl: state.thirdLevelUrl
        };
    })), selectedCategory = ref.selectedCategory, categoryTitle = ref.categoryTitle, categoryUrl = ref.categoryUrl, setThirdLevelCategory = ref.setThirdLevelCategory, setThirdLevelTitle = ref.setThirdLevelTitle, setThirdLevelUrl = ref.setThirdLevelUrl, thirdLevelCategory = ref.thirdLevelCategory, thirdLevelTitle = ref.thirdLevelTitle, thirdLevelUrl = ref.thirdLevelUrl;
    var currentTitle = level === "SecondLevel" ? categoryTitle : thirdLevelTitle;
    var currentUrl = level === "SecondLevel" ? categoryUrl : thirdLevelUrl;
    var currentCategory = level === "SecondLevel" ? selectedCategory : thirdLevelCategory;
    var handleCategoryClick = (0,react.useCallback)(function(title, url, category) {
        if ((category === null || category === void 0 ? void 0 : category.length) && level === "SecondLevel") {
            setThirdLevelCategory(category);
            setThirdLevelTitle(title);
            setThirdLevelUrl(url);
            setCategoriesLevel("ThirdLevel");
            return;
        }
        router.push("/".concat(url));
        onCloseSidebarMenu();
    }, [
        level,
        router,
        onCloseSidebarMenu,
        setThirdLevelCategory,
        setThirdLevelTitle,
        setThirdLevelUrl,
        setCategoriesLevel, 
    ]);
    var handleChangeLevel = (0,react.useCallback)(function() {
        if (level === "ThirdLevel") {
            setCategoriesLevel("SecondLevel");
            return;
        }
        setCategoriesLevel("FirstLevel");
    }, [
        level,
        setCategoriesLevel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubCategoriesContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sub-categories-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubCategoriesHeader, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sub-categories-header")), {
                onClick: handleChangeLevel,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowLeftCategoriesIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoriesTitle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sub-categories-title")), {
                        children: currentTitle === null || currentTitle === void 0 ? void 0 : currentTitle.toUpperCase()
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SeeAll, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("see-everything-on-category-".concat(currentTitle, "-container"))), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CategoryTitle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        onClick: function() {
                            router.push("/".concat(currentUrl));
                            onCloseSidebarMenu();
                        }
                    }, (0,application/* buildTestIds */.Fek)("see-everything-on-category-".concat(currentTitle))), {
                        children: [
                            "Tudo em ",
                            currentTitle
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowRight, {
                        width: 20,
                        height: 20,
                        color: ui.theme.colors.primary[150]
                    })
                ]
            })),
            currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.map(function(category) {
                /*#__PURE__*/ return (0,react.createElement)(styles_CategoryContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("category-container-".concat(category === null || category === void 0 ? void 0 : category.title))), {
                    onClick: function() {
                        return handleCategoryClick(category === null || category === void 0 ? void 0 : category.title, category === null || category === void 0 ? void 0 : category.descriptionUrl, category === null || category === void 0 ? void 0 : category.categories);
                    },
                    key: category === null || category === void 0 ? void 0 : category.id,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CategoryTitle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("category-title-".concat(category === null || category === void 0 ? void 0 : category.title))), {
                            children: category === null || category === void 0 ? void 0 : category.title
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowRight, {
                            width: 20,
                            height: 20,
                            color: ui.theme.colors.neutral[680]
                        })
                    ]
                }));
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/mobile/SidebarMenuMobile/CategoriesSection/index.tsx



var CategoriesSection = function(param) {
    var level = param.level, onCloseSidebarMenu = param.onCloseSidebarMenu, setCategoriesLevel = param.setCategoriesLevel;
    if (level === "FirstLevel") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstLevelCategories, {
            onCloseSidebarMenu: onCloseSidebarMenu,
            setCategoriesLevel: setCategoriesLevel
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategories, {
        level: level,
        setCategoriesLevel: setCategoriesLevel,
        onCloseSidebarMenu: onCloseSidebarMenu
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/mobile/SidebarMenuMobile/index.tsx








var SidebarMenuMobile = function(param) {
    var sidebarMenuRef = param.sidebarMenuRef, isOpenSidebarMenu = param.isOpenSidebarMenu, onCloseSidebarMenu = param.onCloseSidebarMenu;
    var ref = (0,react.useState)("FirstLevel"), categoriesLevel = ref[0], setCategoriesLevel = ref[1];
    var handleCloseSideBarMenu = function() {
        document.body.style.overflow = "visible";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarMenuMobile_styles/* SidebarMenuMobileContainer */.Ai, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                ref: sidebarMenuRef,
                isActiveOverlay: isOpenSidebarMenu
            }, (0,application/* buildTestIds */.Fek)("sidebar-mobile-container")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarMenuMobile_styles/* SidebarMenuHeader */.XZ, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("styled-sidebar-menu-mobile")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAuthenticationBox, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* CloseSidebarBox */.ZE, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                id: "CloseSidebarBoxId",
                                onClick: function() {
                                    onCloseSidebarMenu();
                                    handleCloseSideBarMenu();
                                }
                            }, (0,application/* buildTestIds */.Fek)("close-sidebar-mobile")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* CloseSidebarMenuIcon */.S7, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("close-sidebar-menu-icon")), {
                                    onClick: function() {
                                        onCloseSidebarMenu();
                                        handleCloseSideBarMenu();
                                    }
                                }))
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesSection, {
                        level: categoriesLevel,
                        onCloseSidebarMenu: onCloseSidebarMenu,
                        setCategoriesLevel: setCategoriesLevel
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile_styles/* SidebarContainerOverlay */.k8, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sidebar-mobile-overlay")), {
                id: "SidebarContainerOverlayId",
                onClick: onCloseSidebarMenu,
                isActiveOverlay: !isOpenSidebarMenu
            }))
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/index.tsx





















// eslint-disable-next-line sonarjs/cognitive-complexity
var Header_Header = function(param) {
    var isBlackTheme = param.isBlackTheme;
    var ref, ref1;
    // const [location] = useState<BranchProps>(2);
    var isUniqueClientModalOpen = (0,application/* useUniqueClient */.NGB)((0,application/* useShallow */.NL6)(function(state) {
        return {
            isUniqueClientModalOpen: state.isUniqueClientModalOpen
        };
    })).isUniqueClientModalOpen;
    var ref2 = (0,react.useState)(false), isOpenSidebarMenu = ref2[0], setIsOpenSidebarMenu = ref2[1];
    var sidebarMenuRef = (0,react.useRef)(null);
    var ref3 = (0,state/* useAppContext */.b)(), isClientMobile = ref3.isClientMobile, isClientTablet = ref3.isClientTablet, isPageWeddingList = ref3.isPageWeddingList;
    var handleOpenSidebarMenu = function() {
        setIsOpenSidebarMenu(true);
        document.body.style.overflow = "hidden";
    };
    var handleCloseOutsideSideBarMenu = function(event) {
        var categoryItemsList = (event === null || event === void 0 ? void 0 : event.path) || [];
        var closeSidebarBoxItem = categoryItemsList.find(function(param) {
            var id = param.id;
            return id === "CloseSidebarBoxId";
        });
        var id = (event === null || event === void 0 ? void 0 : event.target).id;
        if (id === "SidebarContainerOverlayId" || closeSidebarBoxItem) {
            setIsOpenSidebarMenu(false);
            document.body.style.overflow = "visible";
        }
    };
    (0,react.useEffect)(function() {
        document.body.addEventListener("click", // eslint-disable-next-line no-undef
        handleCloseOutsideSideBarMenu, true);
    }, [
        isOpenSidebarMenu,
        sidebarMenuRef
    ]);
    var router = (0,next_router.useRouter)();
    var ref4 = (0,application/* useHeaderContext */.Jv3)(), customHeader = ref4.customHeader, isLoadingCustomHeader = ref4.isLoadingCustomHeader;
    var customHeaderComponent = (0,hooks/* useMappedBackofficeComponent */.J)(customHeader, {
        isPageWeddingList: isPageWeddingList,
        isClientMobile: isClientMobile,
        isClientTablet: isClientTablet,
        isLoading: isLoadingCustomHeader
    });
    var refHeaderContainer = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (isUniqueClientModalOpen) {
            setIsOpenSidebarMenu(false);
        }
    }, [
        isUniqueClientModalOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderOuterContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-outer-container")), {
        isPageWeddingList: isPageWeddingList,
        isBlackTheme: isBlackTheme,
        children: [
            isClientMobile && isOpenSidebarMenu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarMenuMobile, {
                sidebarMenuRef: sidebarMenuRef,
                isOpenSidebarMenu: isOpenSidebarMenu,
                onCloseSidebarMenu: function() {
                    setIsOpenSidebarMenu(false);
                    document.body.style.overflow = "visible";
                }
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                ref: refHeaderContainer
            }, (0,application/* buildTestIds */.Fek)("header-container")), {
                children: [
                    isLoadingCustomHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
                        count: 1,
                        hasMargin: false
                    }) : customHeaderComponent,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainerMainContent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("main-content-container-header")), {
                        children: [
                            isClientMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexContainerNavCenterHeaderCustom, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("select-location-container-header")), {
                                isPageWeddingList: isPageWeddingList,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Container, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarMobile, (0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("nav-bar-mobile-header")))
                                })
                            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexContainerNavCenterHeaderCustom, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("select-location-container-header")), {
                                isPageWeddingList: isPageWeddingList,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Container, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarDesktop, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("nav-bar-desktop-header")), {
                                        companyProductsColor: isPageWeddingList ? ui.theme.colors.neutral.white : isBlackTheme && (ui.theme === null || ui.theme === void 0 ? void 0 : (ref = ui.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["25"]) || undefined
                                    }))
                                })
                            })),
                            isClientMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Container, {
                                hasNoMobilePadding: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentHeaderMobile, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HamburgerIconWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("wrapper-hamburger-icon-mobile")), {
                                                onClick: function() {
                                                    return handleOpenSidebarMenu();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.HamburgerIcon, {
                                                    color: ui.theme.colors.primary[200]
                                                })
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRedirectHome/* LinkRedirectHome */.x, {
                                                hrefQueryParams: "IsOpen=False",
                                                children: isBlackTheme ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.FCLogoBlackFriday, {
                                                    alt: "Logo escrito Ferreira Costa, em branco com bordas vermelhas, black friday",
                                                    width: "96",
                                                    height: "36"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("logo-wrapper")), {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLogoFC, {
                                                        src: "https://d2urakutajlof6.cloudfront.net/logo/logo_fc.svg",
                                                        alt: "Logo escrito Ferreira Costa, em branco com bordas vermelhas",
                                                        layout: "fill",
                                                        priority: true
                                                    })
                                                }))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton, {})
                                        ]
                                    }),
                                    (router === null || router === void 0 ? void 0 : router.pathname) === "/" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAuthenticationModal, {}) : null
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Container, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("list-categories-container")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexContainerCenterHeaderCustom, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListCategoriesWithBlackThemeValidation, (0,src_object_spread/* default */.Z)({
                                        isPageWeddingList: isPageWeddingList,
                                        refHeaderContainer: refHeaderContainer
                                    }, (0,application/* buildTestIds */.Fek)("list-categories-desktop")))
                                })
                            })),
                            isClientMobile && !isPageWeddingList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {}) : null,
                            isClientMobile && isPageWeddingList ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_styles/* Divider */.iz, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("bottom-divider-header")), {
                                isWithShadow: true
                            }))
                        ]
                    }))
                ]
            }))
        ]
    }));
};
Header_Header.displayName = "Header";
var HeaderWithBlackThemeValidation = (0,hocs/* withBlackThemeValidation */.z7)(Header_Header);


// EXTERNAL MODULE: ../../packages/components/Header/index.tsx + 1 modules
var components_Header = __webpack_require__(43119);
;// CONCATENATED MODULE: ../../packages/components/patterns/Main/style.ts

function Main_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    Main_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var MainContainer = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    displayName: "style__MainContainer",
    componentId: "sc-5aff76c4-0"
})(Main_style_templateObject(), ui.theme.colors.neutral[25]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Main/index.tsx







var Main = function(param) {
    var children = param.children;
    var ref = (0,application/* useAppContext */.bp4)(), isSidebarMenuOpened = ref.isSidebarMenuOpened, isClientMobile = ref.isClientMobile;
    var mainContainerRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)("100%"), mainContainerOverlayHeight = ref1[0], setMainContainerOverlayHeight = ref1[1];
    // Esse eslint está desabilitado para que, toda vez que o componente for recriado, o overlay possa obter a largura exata do MainContainer, mesmo que a tela seja redimensionada.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react.useEffect)(function() {
        var ref;
        if (mainContainerRef === null || mainContainerRef === void 0 ? void 0 : (ref = mainContainerRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) {
            setMainContainerOverlayHeight("".concat(mainContainerRef.current.clientHeight, "px"));
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.OverlayDynamic, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("main-overlay-dynamic")), {
                isVisible: !isClientMobile && isSidebarMenuOpened,
                height: mainContainerOverlayHeight
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContainer, {
                ref: mainContainerRef,
                children: children
            })
        ]
    });
};
// transformar o main em styled components. Aplicar overlay no main, no footer(componente) e no banner.


;// CONCATENATED MODULE: ../../packages/components/patterns/Layout/HeaderCart/styles.ts

function HeaderCart_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    HeaderCart_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeaderCart_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1;\n  padding: ",
        ";\n"
    ]);
    HeaderCart_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeaderCart_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    HeaderCart_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HeaderCart_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.2rem;\n  color: ",
        ";\n  font-weight: 600;\n"
    ]);
    HeaderCart_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HeaderCart_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-top: 1px solid ",
        ";\n  border-bottom: ",
        " solid ",
        ";\n  padding: ",
        ";\n"
    ]);
    HeaderCart_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HeaderCart_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.3rem;\n  font-weight: 500;\n"
    ]);
    HeaderCart_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var ContainerHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__ContainerHeader",
    componentId: "sc-2242b0c-0"
})(HeaderCart_styles_templateObject(), function(param) {
    var customTheme = param.customTheme;
    return customTheme && "#252728";
}, function(param) {
    var customTheme = param.customTheme;
    return customTheme && "#FFF";
});
var styles_BoxDescription = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BoxDescription",
    componentId: "sc-2242b0c-1"
})(HeaderCart_styles_templateObject1(), ui.theme.space.x4);
var BoxInfoSecurity = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxInfoSecurity",
    componentId: "sc-2242b0c-2"
})(HeaderCart_styles_templateObject2(), ui.theme.space.x2);
var TextSecurity = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    displayName: "styles__TextSecurity",
    componentId: "sc-2242b0c-3"
})(HeaderCart_styles_templateObject3(), function(param) {
    var customTheme = param.customTheme;
    return customTheme && ui.theme.colors.neutral[400];
});
var BoxDescriptionTitlePage = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BoxDescriptionTitlePage",
    componentId: "sc-2242b0c-4"
})(HeaderCart_styles_templateObject4(), ui.theme.colors.neutral[300], ui.theme.space.x1, ui.theme.colors.primary[200], ui.theme.space.x4);
var TextCartTitle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    displayName: "styles__TextCartTitle",
    componentId: "sc-2242b0c-5"
})(HeaderCart_styles_templateObject5());

;// CONCATENATED MODULE: ../../packages/components/patterns/Layout/HeaderCart/index.tsx






var HeaderCart = function() {
    var isBlackTheme = (0,application/* useAppContext */.bp4)().isBlackTheme;
    var WIDTH_SCREEN = window.innerWidth;
    var WIDTH_DEFAULT_MOBILE = Number(ui.theme.device.size.mobileXL.replace("px", ""));
    if (WIDTH_SCREEN > WIDTH_DEFAULT_MOBILE) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerHeader, {
        customTheme: isBlackTheme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_BoxDescription, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRedirectHome/* LinkRedirectHome */.x, {
                        hrefQueryParams: "IsOpen=False",
                        children: isBlackTheme ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CartLogoFCBlack, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLogoFC, {
                                src: "https://d2urakutajlof6.cloudfront.net/logo/logo_fc.svg",
                                alt: "Logo escrito Ferreira Costa, em branco com bordas vermelhas",
                                layout: "fill",
                                priority: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxInfoSecurity, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Lock, {
                                height: 24,
                                width: 22,
                                color: ui.theme.colors.neutral[500]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSecurity, {
                                children: "P\xe1gina Segura"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxDescriptionTitlePage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxInfoSecurity, {
                    children: [
                        isBlackTheme ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.BlackFridayBag, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Bag, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextCartTitle, {
                            children: "Carrinho"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Layout_HeaderCart = (HeaderCart);

;// CONCATENATED MODULE: ../../packages/components/patterns/Layout/index.tsx








var headProps = {
    keywords: [
        "Ferreira Costa",
        "Home Center",
        "Constru\xe7\xe3o",
        "Casa",
        "Ofertas",
        "Decora\xe7\xe3o", 
    ]
};
var Layout = function(param) {
    var children = param.children, _footerIsOpen = param.footerIsOpen, footerIsOpen = _footerIsOpen === void 0 ? true : _footerIsOpen, headerComponent = param.headerComponent, _hasHeader = param.hasHeader, hasHeader = _hasHeader === void 0 ? true : _hasHeader, _defaultHeader = param.defaultHeader, defaultHeader = _defaultHeader === void 0 ? true : _defaultHeader, _title = param.title, title = _title === void 0 ? "Ferreira Costa" : _title, _subTitle = param.subTitle, subTitle = _subTitle === void 0 ? "Encontre as melhores ofertas de eletrodom\xe9sticos, m\xf3veis, pisos, utilidades dom\xe9sticas e muito mais para sua casa! Aproveite!" : _subTitle, _shouldIndexPage = param.shouldIndexPage, shouldIndexPage = _shouldIndexPage === void 0 ? true : _shouldIndexPage;
    var renderHeader = function() {
        if (!hasHeader) {
            return null;
        }
        if (headerComponent) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_HeaderCart, {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWithBlackThemeValidation, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            defaultHeader ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, (0,src_object_spread/* default */.Z)({
                        title: title !== null && title !== void 0 ? title : headProps.title,
                        subtitle: subTitle !== null && subTitle !== void 0 ? subTitle : headProps.subtitle,
                        shouldIndexPage: shouldIndexPage
                    }, headProps)),
                    renderHeader()
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header/* Header */.h, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                children: children
            }),
            footerIsOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWithBlackThemeValidation, {}) : null
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/index.tsx












;// CONCATENATED MODULE: ../../packages/components/PopupAlertAddProductToWeddingList/styles.ts

function PopupAlertAddProductToWeddingList_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 7rem;\n  min-width: 12rem;\n  max-width: 25rem;\n  background-color: ",
        ";\n\n  position: fixed;\n  top: ",
        ";\n  right: 2rem;\n  padding: ",
        ";\n\n  display: ",
        ";\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n\n  z-index: 14;\n  transition: top 1500ms;\n  border-top: 3px solid ",
        ";\n  box-shadow: 1px 1px 3px 0 ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    PopupAlertAddProductToWeddingList_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PopupAlertAddProductToWeddingList_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0.7;\n"
    ]);
    PopupAlertAddProductToWeddingList_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PopupAlertAddProductToWeddingList_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 5rem;\n  max-width: 5rem;\n  flex: 0.3;\n"
    ]);
    PopupAlertAddProductToWeddingList_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PopupAlertAddProductToWeddingList_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1rem;\n  color: ",
        ";\n  margin-bottom: ",
        ";\n  font-weight: 600;\n"
    ]);
    PopupAlertAddProductToWeddingList_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PopupAlertAddProductToWeddingList_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.9rem;\n"
    ]);
    PopupAlertAddProductToWeddingList_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PopupAlertAddProductToWeddingList_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PopupAlertAddProductToWeddingList_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var ModalAlertAddProductToWeddingList = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ModalAlertAddProductToWeddingList",
    componentId: "sc-f17cc5df-0"
})(PopupAlertAddProductToWeddingList_styles_templateObject(), ui.theme.colors.neutral.white, function(param) {
    var isVisibled = param.isVisibled;
    return isVisibled ? "2rem" : "-30rem";
}, ui.theme.space.x4, function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "none" : "flex";
}, function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui.theme.colors.secondary[300];
}, function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui.theme.colors.neutral[400];
}, ui.theme.space.x1);
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Content",
    componentId: "sc-f17cc5df-1"
})(PopupAlertAddProductToWeddingList_styles_templateObject1());
var styles_BoxImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoxImage",
    componentId: "sc-f17cc5df-2"
})(PopupAlertAddProductToWeddingList_styles_templateObject2());
var TitleDescription = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    displayName: "styles__TitleDescription",
    componentId: "sc-f17cc5df-3"
})(PopupAlertAddProductToWeddingList_styles_templateObject3(), function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : ui.theme.colors.secondary[300];
}, ui.theme.space["x1.5"]);
var styles_DescriptionProduct = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__DescriptionProduct",
    componentId: "sc-f17cc5df-4"
})(PopupAlertAddProductToWeddingList_styles_templateObject4());
var DefaultProductImageModal = (0,styled_components_browser_esm/* default */.ZP)(ui.DefaultProductImage).attrs({
    width: 60,
    height: 60
}).withConfig({
    displayName: "styles__DefaultProductImageModal",
    componentId: "sc-f17cc5df-5"
})(PopupAlertAddProductToWeddingList_styles_templateObject5());

;// CONCATENATED MODULE: ../../packages/components/PopupAlertAddProductToWeddingList/index.tsx







var PopupAlertAddProductToWeddingList = function(param) {
    var _imageUrlProduct = param.imageUrlProduct, imageUrlProduct = _imageUrlProduct === void 0 ? "" : _imageUrlProduct, _textDescriptionProduct = param.textDescriptionProduct, textDescriptionProduct = _textDescriptionProduct === void 0 ? "" : _textDescriptionProduct, _titleAlert = param.titleAlert, titleAlert = _titleAlert === void 0 ? "" : _titleAlert, color = param.color, isOpen = param.isOpen, _openModalTime = param.openModalTime, openModalTime = _openModalTime === void 0 ? 6000 : _openModalTime, handlerStatusPopup = param.handlerStatusPopup;
    var ref = (0,react.useState)(false), popupIsOpen = ref[0], popupOpeningHandler = ref[1];
    (0,react.useEffect)(function() {
        if (popupIsOpen) {
            setTimeout(function() {
                popupOpeningHandler(false);
            }, openModalTime);
        } else if (handlerStatusPopup) {
            handlerStatusPopup(false);
        }
    }, [
        handlerStatusPopup,
        openModalTime,
        popupIsOpen
    ]);
    (0,react.useEffect)(function() {
        if (isOpen) {
            popupOpeningHandler(true);
        }
    }, [
        isOpen
    ]);
    if (!isOpen) {
        return null;
    }
    var imageUrl = imageUrlProduct;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalAlertAddProductToWeddingList, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("modal-alert-add-product-to-wedding-list")), {
        color: color,
        isVisibled: popupIsOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_BoxImage, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("box-image")), {
                children: imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(infra/* Image */.Ee, {
                    src: imageUrl,
                    layout: "responsive",
                    width: "100%",
                    height: "100%",
                    alt: "Imagem do produto"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultProductImageModal, {})
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("text-content")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleDescription, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-description")), {
                        color: color,
                        children: titleAlert
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_DescriptionProduct, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("description-product")), {
                        children: textDescriptionProduct
                    }))
                ]
            }))
        ]
    }));
};

// EXTERNAL MODULE: ../../packages/components/PopUpAlertConfirm/index.tsx + 1 modules
var components_PopUpAlertConfirm = __webpack_require__(15261);
// EXTERNAL MODULE: ../../packages/components/PreloadImage/index.tsx
var PreloadImage = __webpack_require__(18494);
;// CONCATENATED MODULE: ../../packages/components/RecommendationCarousel/styles.ts

function RecommendationCarousel_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n  justify-content: center;\n"
    ]);
    RecommendationCarousel_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SkeletonContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__SkeletonContainer",
    componentId: "sc-3fc1a298-0"
})(RecommendationCarousel_styles_templateObject(), ui.theme.space.x4);

// EXTERNAL MODULE: ../../packages/components/RecommendationCarousel/data.ts
var RecommendationCarousel_data = __webpack_require__(37952);
;// CONCATENATED MODULE: ../../packages/components/RecommendationCarousel/index.tsx










var RecommendationCarousel = function(param) {
    var crmUrl = param.crmUrl, crmLinkId = param.crmLinkId;
    var branchId = (0,application/* getClientBranchId */.R0G)(implementations/* cookie */.pR);
    var ref = (0,application/* useAppContext */.bp4)(), isClientTablet = ref.isClientTablet, isClientMobile = ref.isClientMobile;
    var ref1 = (0,application/* useProductsRecommendation */.zN7)(implementations/* crm */.XE, (0,RecommendationCarousel_data/* productsRecommendationDetails */.L)(branchId, crmUrl, crmLinkId), implementations/* cookie */.pR, implementations/* catalogApi */.dZ, implementations/* appMonitoringClient */.pE), productCards = ref1.productCards, componentCrmProps = ref1.componentCrmProps, isLoading = ref1.isLoading;
    var skeletonQuantity = (0,react.useCallback)(function() {
        if (isClientMobile) {
            return 1;
        }
        if (isClientTablet) {
            return 3;
        }
        return 5;
    }, [
        isClientMobile,
        isClientTablet
    ]);
    var CustomProductList = (0,hooks/* useMappedBackofficeComponent */.J)((0,RecommendationCarousel_data/* productsRecommendationDetails */.L)(branchId, crmUrl, crmLinkId, componentCrmProps, productCards), {
        isCrmComponent: true
    });
    if (!(productCards === null || productCards === void 0 ? void 0 : productCards.length) && !isLoading) {
        return null;
    }
    return isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("skeleton-container")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, {
            type: "card",
            count: skeletonQuantity(),
            width: 190,
            height: 360
        })
    })) : CustomProductList;
};


// EXTERNAL MODULE: ../../packages/components/RecommendationCarouselProductCard/index.tsx + 10 modules
var RecommendationCarouselProductCard = __webpack_require__(49234);
;// CONCATENATED MODULE: ../../packages/components/RecommendedProductList/data.tsx


var calculateSlidesToShow = function(isClientDesktop, isClientMobile, arrowsIsActive) {
    if (arrowsIsActive && isClientDesktop) {
        return 5;
    }
    if (!arrowsIsActive && isClientDesktop) {
        return 6;
    }
    if (isClientMobile) {
        return 3.3;
    }
    return 5;
};
var handleComponentWarnings = function(branches, currentPathName, position, productCards) {
    if (!(branches === null || branches === void 0 ? void 0 : branches.length)) {
        appMonitoringClient.captureMessage("Um item de Lista de Produtos, localizado em ".concat(currentPathName, " na posi\xe7\xe3o ").concat(position, ", n\xe3o possui nenhuma configura\xe7\xe3o de branches."), "warning");
    }
    var branchId = getClientBranchId(cookie);
    if (!(productCards === null || productCards === void 0 ? void 0 : productCards.length)) {
        appMonitoringClient.captureMessage("Uma Lista de Produtos, cuja filial \xe9 ".concat(branchId, ", n\xe3o tem produtos."), "warning");
    }
};
var showArrows = function(quantity) {
    return !!(Number(quantity) >= 6);
};


// EXTERNAL MODULE: ../../packages/components/backoffice/CustomProductList/styles.ts
var CustomProductList_styles = __webpack_require__(36348);
// EXTERNAL MODULE: ../../packages/components/ProductCard/index.tsx
var ProductCard = __webpack_require__(95770);
;// CONCATENATED MODULE: ../../packages/components/RecommendedProductList/styles.ts

function RecommendedProductList_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    RecommendedProductList_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RecommendedProductList_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    RecommendedProductList_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RecommendedProductList_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    RecommendedProductList_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RecommendedProductList_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-bottom: ",
        ";\n  padding: ",
        " ",
        " ",
        "\n    ",
        ";\n\n  @media ",
        " {\n    padding: ",
        ";\n  }\n\n  @media ",
        " {\n    padding: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    RecommendedProductList_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RecommendedProductList_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    RecommendedProductList_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RecommendedProductList_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    RecommendedProductList_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RecommendedProductList_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    RecommendedProductList_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function RecommendedProductList_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    RecommendedProductList_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function RecommendedProductList_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    RecommendedProductList_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function RecommendedProductList_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: ",
        " ",
        ";\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding-bottom: ",
        ";\n  height: 100%;\n\n  @media ",
        " {\n    gap: ",
        ";\n\n    & > a {\n      min-width: 190px;\n    }\n  }\n"
    ]);
    RecommendedProductList_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function RecommendedProductList_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: ",
        ";\n  min-height: ",
        ";\n  max-height: ",
        ";\n"
    ]);
    RecommendedProductList_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function RecommendedProductList_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    RecommendedProductList_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function RecommendedProductList_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: 1190px) {\n    padding: 0 1.34rem;\n  }\n\n  max-width: 1280px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n\n  @media (min-width: 1190px) {\n    padding: 0 1.34rem;\n  }\n\n  .slick-track {\n    padding-bottom: 0.5rem;\n    display: flex;\n    flex-direction: row;\n    transition: all 0.5ms ease-in-out;\n\n    @media ",
        " {\n      margin-left: 10px;\n    }\n  }\n\n  .slick-slide:first-child {\n    margin: 0px 9px 0px 0px;\n  }\n\n  @media ",
        " {\n    .slick-slide {\n      width: 190px !important;\n      margin: 0px 5px;\n    }\n\n    .slick-slide:first-child {\n      margin: 0px 5px 0px 12px;\n    }\n  }\n\n  .slick-slide > div {\n    width: 226px;\n    height: 100%;\n\n    @media (max-width: 1024px) {\n      width: 205px;\n    }\n  }\n\n  @media (max-width: 1014px) and (min-width: 769px) {\n    ",
        " {\n      overflow-x: auto;\n    }\n  }\n\n  @media (min-width: 769px) and (max-width: 1260px) {\n    .slick-slide > div {\n      width: 205px;\n    }\n  }\n\n  .slick-list {\n    padding: 0.6rem 0;\n    width: 100%;\n  }\n\n  .slick-track {\n    width: fit-content !important;\n    overflow: hidden;\n\n    @media ",
        " {\n      padding-top: ",
        ";\n    }\n  }\n\n  .slick-prev:before {\n    display: none;\n  }\n\n  .slick-next:before {\n    display: none;\n  }\n\n  .slick-disabled {\n    background: ",
        ";\n    opacity: 1;\n    visibility: visible;\n\n    &:hover {\n      background: ",
        ";\n    }\n    cursor: default;\n\n    path {\n      stroke: ",
        ";\n    }\n\n    &:hover path {\n      stroke: ",
        ";\n    }\n  }\n\n  .slick-slide {\n    width: 226px !important;\n    margin: 0px 9px;\n\n    @media ",
        " {\n      width: 203px !important;\n    }\n\n    @media ",
        " {\n      .slick-slide:first-child {\n        margin-left: 0px;\n      }\n\n      .slick-slide:last-child {\n        margin-right: 0px;\n      }\n\n      .slick-slide {\n        margin: 0px 9px;\n      }\n    }\n  }\n\n  .slick-slide:last-child {\n    margin: 0px 12px 0px 5px;\n  }\n\n  .slick-track {\n    padding-top: 0.5rem;\n  }\n\n  .slick-slider {\n    @media ",
        " {\n      padding: 0px 15px;\n    }\n\n    @media ",
        " {\n      padding: 0px;\n    }\n  }\n\n  @media (min-width: 1025px) and (max-width: 1260px) {\n    .slick-slide > div {\n      width: 100%;\n    }\n\n    .slick-slider {\n      padding: 0px;\n    }\n\n    .slick-slide:first-child {\n      margin-left: 12px;\n    }\n\n    .slick-slide:last-child {\n      margin-right: 12px;\n    }\n\n    .slick-track {\n      width: 161.7% !important;\n    }\n\n    .slick-slide:last-child {\n      margin-right: 28px;\n    }\n  }\n"
    ]);
    RecommendedProductList_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var RecommendedProductListTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RecommendedProductListTitle",
    componentId: "sc-780c0c4-0"
})(RecommendedProductList_styles_templateObject(), ui.theme.typography.fontWeight[400], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.md.x3, function(param) {
    var color = param.color;
    return color || ui.theme.colors.neutral[520];
}, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x9);
var RecommendedContainerCarousel = (0,styled_components_browser_esm/* default */.ZP)(CustomProductList_styles/* ContainerCarousel */.j6).withConfig({
    displayName: "styles__RecommendedContainerCarousel",
    componentId: "sc-780c0c4-1"
})(RecommendedProductList_styles_templateObject1());
var RecommendedContainerProduct = (0,styled_components_browser_esm/* default */.ZP)(CustomProductList_styles/* ContainerProduct */.Lo).withConfig({
    displayName: "styles__RecommendedContainerProduct",
    componentId: "sc-780c0c4-2"
})(RecommendedProductList_styles_templateObject2());
var RecommendedProductListHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__RecommendedProductListHeader",
    componentId: "sc-780c0c4-3"
})(RecommendedProductList_styles_templateObject3(), ui.theme.space.x5, ui.theme.space.x0, ui.theme.space.x5, ui.theme.space.x0, ui.theme.space.x4, ui.theme.device.desktopFirst.tablet, "".concat(ui.theme.space.x0, " ").concat(ui.theme.space["x2.5"], " ").concat(ui.theme.space.x0, "\n    ").concat(ui.theme.space.x3), ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x3, ui.theme.space.x0);
var RecommendedButtonArrowPrev = (0,styled_components_browser_esm/* default */.ZP)(CustomProductList_styles/* ButtonArrowPrev */.BL).withConfig({
    displayName: "styles__RecommendedButtonArrowPrev",
    componentId: "sc-780c0c4-4"
})(RecommendedProductList_styles_templateObject4());
var RecommendedButtonArrowNext = (0,styled_components_browser_esm/* default */.ZP)(CustomProductList_styles/* ButtonArrowNext */.lk).withConfig({
    displayName: "styles__RecommendedButtonArrowNext",
    componentId: "sc-780c0c4-5"
})(RecommendedProductList_styles_templateObject5());
var RecommendedButtonViewMore = (0,styled_components_browser_esm/* default */.ZP)(CustomProductList_styles/* ButtonViewMore */.AS).withConfig({
    displayName: "styles__RecommendedButtonViewMore",
    componentId: "sc-780c0c4-6"
})(RecommendedProductList_styles_templateObject6());
var RecommendedProductCardDiv = (0,styled_components_browser_esm/* default */.ZP)(CustomProductList_styles/* ProductCardDiv */.d8).withConfig({
    displayName: "styles__RecommendedProductCardDiv",
    componentId: "sc-780c0c4-7"
})(RecommendedProductList_styles_templateObject7());
var RecommendedContainerView = (0,styled_components_browser_esm/* default */.ZP)(CustomProductList_styles/* ContainerView */.o6).withConfig({
    displayName: "styles__RecommendedContainerView",
    componentId: "sc-780c0c4-8"
})(RecommendedProductList_styles_templateObject8());
var RecommendedProductCardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RecommendedProductCardContainer",
    componentId: "sc-780c0c4-9"
})(RecommendedProductList_styles_templateObject9(), ui.theme.space.x0, ui.theme.space["x2.5"], ui.theme.space.x3, ui.theme.device.desktopFirst.tablet, ui.theme.space.x2);
var RecommendedProductBoxCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RecommendedProductBoxCard",
    componentId: "sc-780c0c4-10"
})(RecommendedProductList_styles_templateObject10(), function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var RecommendedProductCard = (0,styled_components_browser_esm/* default */.ZP)(ProductCard/* default */.Z).withConfig({
    displayName: "styles__RecommendedProductCard",
    componentId: "sc-780c0c4-11"
})(RecommendedProductList_styles_templateObject11());
var RecommendedProductListContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__RecommendedProductListContainer",
    componentId: "sc-780c0c4-12"
})(RecommendedProductList_styles_templateObject12(), ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.laptop, RecommendedProductCardContainer, ui.theme.device.desktopFirst.tablet, ui.theme.space.x3, ui.theme.colors.neutral[50], ui.theme.colors.neutral[50], ui.theme.colors.neutral[99], ui.theme.colors.neutral[99], ui.theme.device.desktopFirst.laptop, ui.theme.device.desktopFirst.desktop, ui.theme.device.desktopFirst.desktop, ui.theme.device.desktopFirst.laptop);

// EXTERNAL MODULE: ../../packages/components/ProductCard/styles.ts
var ProductCard_styles = __webpack_require__(3483);
;// CONCATENATED MODULE: ../../packages/components/RecommendedProductList/components/Slider/styles.ts

function Slider_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  ",
        " {\n    height: ",
        ";\n    min-height: ",
        ";\n    max-height: ",
        ";\n  }\n\n  @media ",
        " {\n    .slick-list {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    Slider_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ProductCardStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ProductCardStyled",
    componentId: "sc-cb140614-0"
})(Slider_styles_templateObject(), ProductCard_styles/* ProductCardContainer */.hd, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, ui.theme.device.desktopFirst.mobileXL, ui.theme.colors.primary[705]);

;// CONCATENATED MODULE: ../../packages/components/RecommendedProductList/components/Slider/index.tsx









var RecommendedProductListSlider = function(param) {
    var slidesToShow = param.slidesToShow, arrowsIsActive = param.arrowsIsActive, productCards = param.productCards, isBlackFriday = param.isBlackFriday, height = param.height;
    var isClientLaptop = (0,application/* useAppContext */.bp4)().isClientLaptop;
    var slidesToScroll = (0,react.useMemo)(function() {
        if (isClientLaptop) return 4;
        return 5;
    }, [
        isClientLaptop
    ]);
    var sliderProps = {
        speed: 700,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        arrowsIsActive: arrowsIsActive,
        touchMove: true,
        swipe: false
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommended-product-list-slider"), sliderProps), {
        isBlackTheme: isBlackFriday,
        children: productCards === null || productCards === void 0 ? void 0 : productCards.map(function(product) {
            /*#__PURE__*/ return (0,react.createElement)(ProductCardStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-card-style")), {
                className: "ins-web-smart-recommender-box-item",
                key: "".concat(product.id),
                height: height
            }), /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedProductCard, {
                className: "ins-product-box ins-element-link ins-add-to-cart-wrapper ins-sr-api",
                "data-ins-product-id": "".concat(product === null || product === void 0 ? void 0 : product.id),
                "data-event-collection": "true",
                item: product,
                shouldShowInGridOnMobile: false,
                isPlaylist: true
            }));
        })
    }));
};


;// CONCATENATED MODULE: ../../packages/components/RecommendedProductList/ui.tsx








var RecommendedProductListUI = /*#__PURE__*/ (0,react.memo)(function(param) {
    var productCards = param.productCards, isBlackTheme = param.isBlackTheme, campaignVariationId = param.campaignVariationId, isClientTablet = param.isClientTablet, recommendedProductsId = param.recommendedProductsId, maxHeightForProductCards = param.maxHeightForProductCards, arrowIsActive = param.arrowIsActive, slidesToShow = param.slidesToShow;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecommendedProductListContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommended-product-list-container")), {
        className: "ins-preview-wrapper-".concat(campaignVariationId),
        isBlackTheme: isBlackTheme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedProductListHeader, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommended-product-list-header")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedProductListTitle, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommended-product-list-header-title")), {
                    children: "Recomendamos para voc\xea"
                }))
            })),
            isClientTablet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedProductCardContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommended-product-card-container")), {
                className: "ins-web-smart-recommender-body",
                "data-recommended-items": recommendedProductsId,
                children: productCards === null || productCards === void 0 ? void 0 : productCards.map(function(product) {
                    /*#__PURE__*/ return (0,react.createElement)(RecommendedProductBoxCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommended-product-card")), {
                        className: "ins-web-smart-recommender-box-item",
                        key: "box-".concat(product.id),
                        height: maxHeightForProductCards
                    }), /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedProductCard, {
                        className: "ins-product-box ins-element-link ins-add-to-cart-wrapper ins-sr-api",
                        "data-event-collection": "true",
                        "data-ins-product-id": "".concat(product === null || product === void 0 ? void 0 : product.id),
                        item: product,
                        shouldShowInGridOnMobile: false,
                        isPlaylist: true
                    }, "".concat(product.id)));
                })
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedProductListSlider, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recommended-product-list-slider")), {
                arrowsIsActive: arrowIsActive,
                isBlackFriday: isBlackTheme,
                slidesToShow: slidesToShow,
                productCards: productCards,
                height: maxHeightForProductCards
            }))
        ]
    }));
});
RecommendedProductListUI.displayName = "RecommendedProductListUI";


;// CONCATENATED MODULE: ../../packages/components/RecommendedProductList/index.tsx






var propsAreEqual = function(param, param1) {
    var oldIsClientMobile = param.isClientMobile, oldIsClientTablet = param.isClientTablet, oldIsClientDesktop = param.isClientDesktop, isClientMobile = param1.isClientMobile, isClientTablet = param1.isClientTablet, isClientDesktop = param1.isClientDesktop;
    return oldIsClientMobile === isClientMobile && oldIsClientTablet === isClientTablet && oldIsClientDesktop === isClientDesktop;
};
var RecommendedProductList = /*#__PURE__*/ (0,react.memo)(function(param) {
    var campaignVariationId = param.campaignVariationId, recommendedProductsId = param.recommendedProductsId, productCards = param.productCards, isBlackTheme = param.isBlackTheme;
    var _Math;
    var ref = (0,application/* useAppContext */.bp4)(), isClientDesktop = ref.isClientDesktop, isClientMobile = ref.isClientMobile, isClientTablet = ref.isClientTablet;
    var ref1 = (0,react.useState)(false), arrowsIsActive = ref1[0], setArrowsIsActive = ref1[1];
    var ref2 = (0,react.useState)(calculateSlidesToShow(isClientDesktop, isClientMobile, arrowsIsActive)), slidesToShow = ref2[0], setSlidesToShow = ref2[1];
    var quantity = 10;
    (0,react.useEffect)(function() {
        setArrowsIsActive(showArrows(quantity));
    }, [
        isClientDesktop,
        quantity
    ]);
    (0,react.useEffect)(function() {
        setSlidesToShow(calculateSlidesToShow(isClientDesktop, isClientMobile, arrowsIsActive));
    }, [
        isClientDesktop,
        isClientMobile,
        arrowsIsActive
    ]);
    if (!(productCards === null || productCards === void 0 ? void 0 : productCards.length)) {
        return null;
    }
    var heightsFromProducts = productCards === null || productCards === void 0 ? void 0 : productCards.map(function(product) {
        var ref, ref1, ref2, ref3, ref4;
        var minHeight = 292;
        var heightBlackFriday = (product === null || product === void 0 ? void 0 : product.isBlackFriday) ? 24 : 0;
        var heightCoupon = (product === null || product === void 0 ? void 0 : (ref = product.coupons) === null || ref === void 0 ? void 0 : ref.length) ? 18 : 0;
        var heightSpotPrice = (0,application/* getSpotPrice */.$XT)(product) ? 13 : 0;
        var heightInstallments = (product === null || product === void 0 ? void 0 : (ref1 = product.prices) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.maxNumberInstallments) > 1 ? 17 : 0;
        var heightTagProduct = (product === null || product === void 0 ? void 0 : (ref3 = product.tag) === null || ref3 === void 0 ? void 0 : ref3.title) || (product === null || product === void 0 ? void 0 : (ref4 = product.tagProduct) === null || ref4 === void 0 ? void 0 : ref4.title) ? 24 : 0;
        return heightBlackFriday + heightCoupon + heightSpotPrice + heightInstallments + heightTagProduct + minHeight;
    });
    var maxHeightForProductCards = heightsFromProducts ? (_Math = Math).max.apply(_Math, (0,src_to_consumable_array/* default */.Z)(heightsFromProducts)) : 292;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedProductListUI, {
        campaignVariationId: campaignVariationId,
        arrowIsActive: arrowsIsActive,
        maxHeightForProductCards: maxHeightForProductCards,
        productCards: productCards,
        recommendedProductsId: recommendedProductsId,
        slidesToShow: slidesToShow,
        isClientTablet: isClientTablet,
        isBlackTheme: isBlackTheme
    });
}, propsAreEqual);
RecommendedProductList.displayName = "RecommendedProductList";


// EXTERNAL MODULE: ../../packages/components/Register/index.tsx + 13 modules
var Register = __webpack_require__(22948);
;// CONCATENATED MODULE: ../../packages/components/RemoveSelection/styles.ts

function RemoveSelection_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.19);\n  position: fixed;\n  background-color: white;\n  bottom: 0;\n  z-index: 100;\n  width: 100%;\n  justify-content: flex-start;\n  align-items: center;\n  border-top: 2px solid red;\n  margin-left: 1rem;\n  padding: 2rem;\n  transition: all 0.2s ease;\n  opacity: ",
        ";\n  transform: ",
        ";\n"
    ]);
    RemoveSelection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RemoveSelection_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 0.5rem;\n  width: fit-content;\n"
    ]);
    RemoveSelection_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RemoveSelection_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  min-width: 13rem;\n  justify-content: center;\n"
    ]);
    RemoveSelection_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RemoveSelection_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-size: 16px;\n  width: fit-content;\n  cursor: pointer;\n"
    ]);
    RemoveSelection_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RemoveSelection_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: thin solid ",
        ";\n  color: ",
        ";\n  font-size: 20px;\n  font-weight: ",
        ";\n  border-radius: 4px;\n  justify-content: flex-start;\n  align-items: center;\n  width: fit-content;\n  transition: 300ms ease;\n  padding: 1rem 2rem;\n  cursor: pointer;\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    RemoveSelection_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RemoveSelection_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 20px;\n  font-weight: ",
        ";\n  border-radius: 4px;\n  justify-content: flex-start;\n  align-items: center;\n  width: fit-content;\n  transition: 300ms ease;\n  padding: 1rem 2rem;\n  cursor: pointer;\n"
    ]);
    RemoveSelection_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RemoveSelection_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 2rem;\n"
    ]);
    RemoveSelection_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var styles_RemoveSelectionWrapper = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__RemoveSelectionWrapper",
    componentId: "sc-913fd375-0"
})(RemoveSelection_styles_templateObject(), function(param) {
    var isVisible = param.isVisible;
    return !isVisible ? "0" : "1";
}, function(param) {
    var isVisible = param.isVisible;
    return !isVisible ? "translateY(100%)" : "translateY(0)";
});
var styles_RemoveSelectionFirst = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__RemoveSelectionFirst",
    componentId: "sc-913fd375-1"
})(RemoveSelection_styles_templateObject1());
var styles_SelectedQuantityBox = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__SelectedQuantityBox",
    componentId: "sc-913fd375-2"
})(RemoveSelection_styles_templateObject2());
var styles_CancelSecectionButton = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__CancelSecectionButton",
    componentId: "sc-913fd375-3"
})(RemoveSelection_styles_templateObject3(), ui.theme.colors.primary[200], ui.theme.typography.fontWeight[700]);
var styles_RemoveSelectionSecond = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__RemoveSelectionSecond",
    componentId: "sc-913fd375-4"
})(RemoveSelection_styles_templateObject4(), ui.theme.colors.primary[200], ui.theme.colors.primary[200], ui.theme.typography.fontWeight[700], ui.theme.colors.pink[50]);
var styles_ActionButton = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__ActionButton",
    componentId: "sc-913fd375-5"
})(RemoveSelection_styles_templateObject5(), ui.theme.colors.secondary[200], ui.theme.colors.neutral.white, ui.theme.typography.fontWeight[700]);
var RemoveSelection_styles_Container = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__Container",
    componentId: "sc-913fd375-6"
})(RemoveSelection_styles_templateObject6());

;// CONCATENATED MODULE: ../../packages/components/RemoveSelection/index.tsx



var RemoveSelection = function(param) {
    var selectedQuantity = param.selectedQuantity, onCancelSelection = param.onCancelSelection, onRemoveSelection = param.onRemoveSelection, onActionSelection = param.onActionSelection, actionButtonText = param.actionButtonText, visible = param.visible, selectedProducts = param.selectedProducts, environments = param.environments;
    var ref = useState(true), showButton = ref[0], setShowButton = ref[1];
    useEffect(function() {
        var hasVoucher = [];
        var environmentGiftCard = environments === null || environments === void 0 ? void 0 : environments.filter(function(environment) {
            return environment.id === -2;
        });
        if ((environmentGiftCard === null || environmentGiftCard === void 0 ? void 0 : environmentGiftCard.length) > 0) {
            hasVoucher = selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.filter(function(product) {
                return environmentGiftCard === null || environmentGiftCard === void 0 ? void 0 : environmentGiftCard[0].products.find(function(giftCard) {
                    return giftCard.productId === product.productId;
                });
            });
        }
        setShowButton((hasVoucher === null || hasVoucher === void 0 ? void 0 : hasVoucher.length) === 0);
    }, [
        selectedProducts,
        environments,
        setShowButton,
        showButton
    ]);
    return /*#__PURE__*/ _jsx(RemoveSelectionWrapper, {
        isVisible: visible,
        children: /*#__PURE__*/ _jsxs(Container, {
            children: [
                /*#__PURE__*/ _jsxs(RemoveSelectionFirst, {
                    children: [
                        /*#__PURE__*/ _jsx(SelectedQuantityBox, {
                            children: selectedQuantity <= 1 ? "".concat(selectedQuantity, " item selecionado") : "".concat(selectedQuantity, " itens selecionados")
                        }),
                        /*#__PURE__*/ _jsx(CancelSecectionButton, {
                            onClick: onCancelSelection,
                            children: "cancelar sele\xe7\xe3o"
                        })
                    ]
                }),
                actionButtonText && showButton && /*#__PURE__*/ _jsx(ActionButton, {
                    onClick: onActionSelection,
                    children: actionButtonText
                }),
                /*#__PURE__*/ _jsx(RemoveSelectionSecond, {
                    onClick: onRemoveSelection,
                    children: "Remover"
                })
            ]
        })
    });
};


// EXTERNAL MODULE: ../../packages/components/RequestFeedbackModal/index.tsx + 1 modules
var RequestFeedbackModal = __webpack_require__(56043);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ../../packages/components/Script/index.tsx



var Script = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), (0,src_object_spread/* default */.Z)({}, props));
};


// EXTERNAL MODULE: ../../packages/components/SendCodeAgain/index.tsx + 1 modules
var SendCodeAgain = __webpack_require__(6499);
;// CONCATENATED MODULE: ../../packages/components/Snackbar/style.ts

function Snackbar_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .snackbar {\n    background-color: ",
        ";\n    position: fixed;\n    left: 49%;\n    width: 400px;\n    margin-left: -200px;\n    opacity: 0;\n    visibility: hidden;\n    color: ",
        ";\n    padding: 16px;\n    border-radius: 4px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: all 200ms ease-in-out;\n    transform: translateY(-40vh);\n    font-size: 18px;\n    text-align: center;\n  }\n\n  .snackbar .close {\n    font-size: 18px;\n    cursor: pointer;\n    transition-delay: 2s;\n    transition: 200ms ease-in;\n    padding: 0;\n    border: 0;\n    background-color: transparent;\n    color: ",
        ";\n  }\n\n  .snackbar.visible {\n    opacity: 1;\n    visibility: visible;\n    transition-delay: 1s;\n    transform: translateY(-20vh);\n  }\n\n  .snackbar.success {\n    background-color: rgb(0, 158, 0);\n  }\n\n  .snackbar.info {\n    background-color: rgb(86, 83, 255);\n  }\n\n  .snackbar.warning {\n    background-color: rgb(255, 181, 44);\n  }\n\n  .snackbar.error {\n    background-color: ",
        ";\n  }\n  @media ",
        " {\n    .snackbar {\n      width: 100%;\n      margin-left: 0;\n      left: 0;\n      border-radius: 4px 4px 0 0;\n    }\n\n    .snackbar.visible {\n      top: 30px;\n    }\n  }\n"
    ]);
    Snackbar_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var style_StyledSnackbar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__StyledSnackbar",
    componentId: "sc-e43c57a1-0"
})(Snackbar_style_templateObject(), ui.theme.colors.neutral[485], ui.theme.colors.neutral.white, ui.theme.colors.neutral.white, ui.theme.colors.neutral[200], ui.theme.device.desktopFirst.mobileXL);

;// CONCATENATED MODULE: ../../packages/components/Snackbar/index.tsx


var Snackbar = function(param) {
    var type = param.type, open = param.open, children = param.children;
    return /*#__PURE__*/ _jsx(StyledSnackbar, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "snackbar ".concat(open && "visible", " ").concat(type),
            children: /*#__PURE__*/ _jsx("span", {
                children: children
            })
        })
    });
};


// EXTERNAL MODULE: ../../packages/components/StepperModal/index.tsx + 1 modules
var StepperModal = __webpack_require__(96187);
// EXTERNAL MODULE: ../../packages/components/StyledLink/index.tsx
var StyledLink = __webpack_require__(85922);
// EXTERNAL MODULE: ../../packages/components/Swiper/index.tsx
var Swiper = __webpack_require__(63665);
;// CONCATENATED MODULE: ../../packages/components/SWRConfigContainer/index.tsx



var SWRConfigContainer = function(props) {
    return /*#__PURE__*/ _jsx(CustomSWRConfig, _object_spread({}, props));
};


;// CONCATENATED MODULE: ../../packages/components/Tooltip/style.ts

function Tooltip_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: inline-block;\n\n  span {\n    visibility: hidden;\n    min-width: ",
        ";\n    background-color: white;\n    color: black;\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px 0;\n    position: absolute;\n    z-index: 1;\n    bottom: 125%;\n    left: 50%;\n    margin-left: -60px;\n    opacity: 0;\n    transition: opacity 0.3s;\n    font-size: ",
        ";\n\n    @media ",
        " {\n      min-width: ",
        ";\n      font-size: ",
        ";\n      font-weight: ",
        ';\n      margin-left: -120px;\n    }\n\n    &::after {\n      content: "";\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      margin-left: -170px;\n      border-width: 5px;\n      border-style: solid;\n      border-color: ',
        " transparent transparent\n        transparent;\n\n      @media ",
        " {\n        left: 38.5vh;\n      }\n    }\n  }\n\n  &:hover span {\n    visibility: visible;\n    opacity: 1;\n  }\n"
    ]);
    Tooltip_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var style_TooltipContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__TooltipContainer",
    componentId: "sc-3be06a6b-0"
})(Tooltip_style_templateObject(), ui.theme.space.x112, ui.theme.typography.fontSize.sm.x9, ui.theme.device.desktopFirst.mobileL, ui.theme.space.x64, ui.theme.typography.fontSize.sm.x3, ui.theme.typography.fontWeight.bold, ui.theme.colors.neutral["white-050"], ui.theme.device.desktopFirst.mobileL);

;// CONCATENATED MODULE: ../../packages/components/Tooltip/index.tsx





var Tooltip = function(param) {
    var icon = param.icon, content = param.content, children = param.children;
    return /*#__PURE__*/ _jsxs(TooltipContainer, _object_spread_props(_object_spread({}, buildTestIds("tooltip-container")), {
        children: [
            children,
            icon !== null && icon !== void 0 ? icon : null,
            content && /*#__PURE__*/ _jsx("span", _object_spread_props(_object_spread({}, buildTestIds("tooltip-content")), {
                children: content
            }))
        ]
    }));
};
/* harmony default export */ var components_Tooltip = ((/* unused pure expression or super */ null && (Tooltip)));

// EXTERNAL MODULE: ../../packages/application/utils/validations/secondsCounter/index.ts
var secondsCounter = __webpack_require__(73105);
// EXTERNAL MODULE: ../../packages/components/CodeExpiration/styles.ts
var CodeExpiration_styles = __webpack_require__(61882);
;// CONCATENATED MODULE: ../../packages/components/ModalValidationSMS/styles.ts

function ModalValidationSMS_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  width: 100%;\n  height: 100%;\n\n  position: fixed;\n  top: 0;\n  left: 0;\n\n  z-index: 2;\n  background-color: ",
        ";\n\n  justify-content: center;\n  align-items: center;\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    ModalValidationSMS_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalValidationSMS_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 20%;\n  width: 550px;\n  background-color: ",
        ";\n  border-radius: 2px;\n  padding: 1.3rem 0 3rem;\n\n  @media ",
        " {\n    width: 400px;\n  }\n"
    ]);
    ModalValidationSMS_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalValidationSMS_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    ModalValidationSMS_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalValidationSMS_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    ModalValidationSMS_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalValidationSMS_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 2rem;\n  text-align: center;\n  color: ",
        ";\n  font-weight: ",
        ";\n  padding-left: 4.5rem;\n  font-family: ",
        ";\n\n  @media ",
        " {\n    padding-left: 0;\n  }\n"
    ]);
    ModalValidationSMS_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalValidationSMS_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 2rem;\n  flex-direction: column;\n  gap: 2rem;\n  padding: 0 4.5rem;\n\n  @media ",
        " {\n    padding: 0 1.5rem;\n  }\n"
    ]);
    ModalValidationSMS_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ModalValidationSMS_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 40px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  justify-content: center;\n  font-size: ",
        ";\n  border-radius: 8px;\n  font-family: ",
        ";\n  margin-bottom: 2rem;\n  font-weight: ",
        ";\n"
    ]);
    ModalValidationSMS_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ModalValidationSMS_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    ModalValidationSMS_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ModalValidationSMS_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  right: 0;\n\n  z-index: 999999;\n  position: fixed;\n\n  background-color: ",
        ";\n"
    ]);
    ModalValidationSMS_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var ModalValidationSMSContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ModalValidationSMSContainer",
    componentId: "sc-9527b0ad-0"
})(ModalValidationSMS_styles_templateObject(), function(param) {
    var stateModal = param.stateModal;
    return stateModal ? "flex" : "none";
}, ui.theme.colors.neutral["999-opacity-50"], CodeExpiration_styles/* Countdown */.I);
var ModalValidationSMSWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ModalValidationSMSWrapper",
    componentId: "sc-9527b0ad-1"
})(ModalValidationSMS_styles_templateObject1(), ui.theme.colors.neutral.white, ui.theme.device.desktopFirst.mobileXL);
var ModalValidationSMSHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ModalValidationSMSHeader",
    componentId: "sc-9527b0ad-2"
})(ModalValidationSMS_styles_templateObject2());
var ModalValidationText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ModalValidationText",
    componentId: "sc-9527b0ad-3"
})(ModalValidationSMS_styles_templateObject3(), ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontFamily.barlow);
var ModalValidationTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ModalValidationTitle",
    componentId: "sc-9527b0ad-4"
})(ModalValidationSMS_styles_templateObject4(), ui.theme.colors.neutral[570], ui.theme.typography.fontWeight[500], ui.theme.typography.fontFamily.barlow, ui.theme.device.desktopFirst.mobileXL);
var ModalValidationContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ModalValidationContent",
    componentId: "sc-9527b0ad-5"
})(ModalValidationSMS_styles_templateObject5(), ui.theme.device.desktopFirst.mobileXL);
var ModalValidationButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ModalValidationButton",
    componentId: "sc-9527b0ad-6"
})(ModalValidationSMS_styles_templateObject6(), ui.theme.colors.secondary[380], ui.theme.colors.secondary[380], ui.theme.colors.neutral.white, ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontFamily.barlow, ui.theme.typography.fontWeight[500]);
var ButtonCLoseModal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ButtonCLoseModal",
    componentId: "sc-9527b0ad-7"
})(ModalValidationSMS_styles_templateObject7());
var ContainerModal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ContainerModal",
    componentId: "sc-9527b0ad-8"
})(ModalValidationSMS_styles_templateObject8(), function(param) {
    var stateModal = param.stateModal;
    return stateModal ? "flex" : "none";
}, ui.theme.colors.neutral[820]);

;// CONCATENATED MODULE: ../../packages/components/ModalValidationSMS/index.tsx



var ModalValidationSMS = function(param) {
    var actionCloseModal = param.actionCloseModal, title = param.title, description = param.description, children = param.children, stateModal = param.stateModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalValidationSMSContainer, {
        stateModal: stateModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalValidationSMSWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalValidationSMSHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalValidationTitle, {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCLoseModal, {
                            onClick: actionCloseModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {
                                width: 50,
                                height: 38,
                                strokeWidth: "0.6",
                                color: "".concat(ui.theme.colors.primary[200])
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalValidationContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalValidationText, {
                            children: description
                        }),
                        children
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_ModalValidationSMS = (ModalValidationSMS);

;// CONCATENATED MODULE: ../../packages/components/Validation2FA/ValidationButton/styles.ts

function ValidationButton_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 40px;\n  width: ",
        ";\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  justify-content: center;\n  font-size: ",
        ";\n  border-radius: ",
        ";\n  font-family: ",
        ";\n  cursor: pointer;\n  font-weight: ",
        ";\n  transition: background-color 0.2s ease-in-out;\n\n  &:not(:disabled):hover {\n    background: ",
        ";\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: auto;\n  }\n"
    ]);
    ValidationButton_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SendCode = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__SendCode",
    componentId: "sc-4446ef32-0"
})(ValidationButton_styles_templateObject(), function(param) {
    var width = param.width;
    return width || "100%";
}, ui.theme.colors.secondary[380], function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || "".concat(ui.theme.colors.secondary[360]);
}, function(param) {
    var color = param.color;
    return color || "".concat(ui.theme.colors.neutral.white);
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize || "".concat(ui.theme.typography.fontSize.sm.x5);
}, ui.theme.space.x2, ui.theme.typography.fontFamily.barlow, ui.theme.typography.fontWeight[400], ui.theme.colors.secondary[420]);

;// CONCATENATED MODULE: ../../packages/components/Validation2FA/ValidationButton/index.tsx









var ValidationButton = function(param) {
    var actionButtonValidation = param.actionButtonValidation, typeSMS = param.typeSMS, backgroundColor = param.backgroundColor, color = param.color, fontSize = param.fontSize, width = param.width;
    var ref;
    var ref1 = (0,application/* useNotification */.lmA)(), changeIsUserBlockedFromReceiveMessages = ref1.changeIsUserBlockedFromReceiveMessages, initializeValidationCounter = ref1.initializeValidationCounter;
    var getTokens = (0,application/* useAuth */.aCi)().getTokens;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var data = implementations/* profileApi.getClient */.c_.getClient(accessToken, !!accessToken).data;
    var ref2 = (0,react.useState)(false), isModalOpen = ref2[0], setIsModalOpen = ref2[1];
    var ref3 = (0,react.useState)(false), isUserBlocked = ref3[0], setIsUserBlocked = ref3[1];
    var ref4 = (0,react.useState)(false), isButtonDisabled = ref4[0], setIsButtonDisabledButton = ref4[1];
    var onSendSMS = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(type) {
            var ref, ref1, ref2, ref3, ref4, ref5, response, remainingTime;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsButtonDisabledButton(true);
                        return [
                            4,
                            implementations/* notificationApi.sendTwoFactorSMS */.E8.sendTwoFactorSMS(type, accessToken)
                        ];
                    case 1:
                        response = _state.sent();
                        if ((response === null || response === void 0 ? void 0 : (ref = response.validationResult) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.errorCode) === "222") {
                            setIsModalOpen(true);
                            setIsUserBlocked(true);
                            setIsButtonDisabledButton(false);
                            return [
                                2
                            ];
                        }
                        if ((response === null || response === void 0 ? void 0 : (ref3 = response.validationResult) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.errors) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.errorCode) === "666") {
                            remainingTime = (0,secondsCounter/* getMinutesAndSeconds */.G)(response === null || response === void 0 ? void 0 : response.retryTokenDate);
                            initializeValidationCounter(remainingTime);
                            actionButtonValidation();
                            return [
                                2
                            ];
                        }
                        initializeValidationCounter();
                        actionButtonValidation();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSendSMS(type) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        changeIsUserBlockedFromReceiveMessages(isUserBlocked);
    }, [
        isUserBlocked,
        changeIsUserBlockedFromReceiveMessages
    ]);
    if (!(data === null || data === void 0 ? void 0 : data.phoneNumber)) {
        return null;
    }
    var numberValidation = "(".concat(data === null || data === void 0 ? void 0 : data.phoneNumber.substring(0, 2), ") *****-").concat(data === null || data === void 0 ? void 0 : data.phoneNumber.substring(7, 11));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalValidationSMS, {
                stateModal: isModalOpen,
                actionCloseModal: function() {
                    return setIsModalOpen(false);
                },
                title: "Infelizmente, voc\xea est\xe1 bloqueado :(",
                description: "Seus cr\xe9ditos foram bloqueados temporariamente devido a tentativas excessivas de valida\xe7\xe3o do c\xf3digo de seguran\xe7a. Entre em contato com o suporte para regularizar a situa\xe7\xe3o."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SendCode, {
                color: color,
                backgroundColor: backgroundColor,
                fontSize: fontSize,
                width: width,
                disabled: isButtonDisabled,
                type: "button",
                onClick: function() {
                    onSendSMS(typeSMS);
                },
                children: [
                    "Enviar c\xf3digo SMS para ",
                    numberValidation
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/components/index.tsx















































































/***/ }),

/***/ 64492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EL": function() { return /* binding */ HorizontalDivider; },
/* harmony export */   "iz": function() { return /* binding */ Divider; }
/* harmony export */ });
/* unused harmony export VerticalDivider */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: 1;\n  position: initial;\n  background-color: ",
        ";\n  height: ",
        ";\n  width: ",
        ";\n  margin-top: ",
        ";\n  margin-left: ",
        ";\n  box-shadow: ",
        ";\n\n  @media ",
        " {\n    margin-top: ",
        ";\n  }\n\n  @media ",
        " {\n    margin-top: ",
        ";\n  }\n\n  @media ",
        " {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: 1;\n  position: initial;\n  background-color: ",
        ";\n  height: 100%;\n  width: 1px;\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: 1;\n  position: initial;\n  background-color: ",
        ";\n  height: 1px;\n  width: 100%;\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var shadow = "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)";
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Divider",
    componentId: "sc-41c93be1-0"
})(_templateObject(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[100], function(param) {
    var isClientTablet = param.isClientTablet;
    return isClientTablet && "1px";
}, function(param) {
    var isClientTablet = param.isClientTablet;
    return !isClientTablet ? "1px" : "100%";
}, function(param) {
    var isWithoutMargin = param.isWithoutMargin;
    return isWithoutMargin ? 0 : "0.8rem";
}, function(param) {
    var marginLeft = param.marginLeft;
    return marginLeft !== null && marginLeft !== void 0 ? marginLeft : "initial";
}, function(param) {
    var isWithShadow = param.isWithShadow;
    return isWithShadow ? shadow : 0;
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileL, function(param) {
    var isWithoutMargin = param.isWithoutMargin;
    return isWithoutMargin ? 0 : "0.35rem";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileM, function(param) {
    var isWithoutMargin = param.isWithoutMargin;
    return isWithoutMargin ? 0 : "0.35rem";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileS, function(param) {
    var isWithoutMargin = param.isWithoutMargin;
    return isWithoutMargin ? 0 : "0.35rem";
});
var VerticalDivider = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__VerticalDivider",
    componentId: "sc-41c93be1-1"
})(_templateObject1(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[100], function(param) {
    var isWithShadow = param.isWithShadow;
    return isWithShadow ? shadow : 0;
});
var HorizontalDivider = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__HorizontalDivider",
    componentId: "sc-41c93be1-2"
})(_templateObject2(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[100], function(param) {
    var isWithShadow = param.isWithShadow;
    return isWithShadow ? shadow : 0;
});


/***/ }),

/***/ 93884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ FilterProducts; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/Breadcrumb/index.tsx
var Breadcrumb = __webpack_require__(90350);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/BreadcrumbFilter/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  width: 100%;\n  background-color: ",
        ";\n  padding: 0.5rem;\n  overflow-x: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 0.5rem 2.5rem 0.5rem 0.5rem;\n  margin-right: 0.5rem;\n  white-space: nowrap;\n  position: relative;\n  cursor: pointer;\n  border-radius: 4px;\n\n  &:last-of-type {\n    margin-right: 0rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1rem;\n  color: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n  white-space: nowrap;\n  display: block;\n  margin-bottom: 5px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.167rem;\n  font-weight: 400;\n  color: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n  white-space: nowrap;\n  display: block;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: calc(50% - 10px);\n  right: 5px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        padding: 0;\n        background-color: transparent;\n      }\n\n      ",
        " {\n        background-color: ",
        ";\n      }\n\n      ",
        " {\n        color: ",
        ";\n      }\n\n      ",
        " {\n        color: ",
        ";\n      }\n\n      ",
        " {\n        path {\n          stroke: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  position: relative;\n  left: 0;\n  margin-bottom: 3rem;\n\n  @media ",
        " {\n    width: 100%;\n    position: relative;\n    left: 0px;\n  }\n\n  @media ",
        " {\n    width: 100%;\n    position: relative;\n    left: 0px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var BreadcrumbsFilterList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BreadcrumbsFilterList",
    componentId: "sc-abacff0b-0"
})(_templateObject(), ui.theme.colors.neutral["white-050"]);
var BreadcrumbFilterItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__BreadcrumbFilterItem",
    componentId: "sc-abacff0b-1"
})(_templateObject1(), ui.theme.colors.neutral.white);
var FilterTitle = styled_components_browser_esm/* default.small.withConfig */.ZP.small.withConfig({
    displayName: "styles__FilterTitle",
    componentId: "sc-abacff0b-2"
})(_templateObject2(), ui.theme.colors.neutral[450]);
var FilterText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__FilterText",
    componentId: "sc-abacff0b-3"
})(_templateObject3(), ui.theme.colors.neutral[520]);
var CloseFilter = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__CloseFilter",
    componentId: "sc-abacff0b-4"
})(_templateObject4());
var BreadcrumbsFilterStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BreadcrumbsFilterStyled",
    componentId: "sc-abacff0b-5"
})(_templateObject6(), ui.theme.device.desktopFirst.tablet, ui.theme.device.desktopFirst.mobileL, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), BreadcrumbsFilterList, BreadcrumbFilterItem, ui.theme.colors.neutral[110], FilterTitle, ui.theme.colors.neutral[150], FilterText, ui.theme.colors.neutral.white, CloseFilter, ui.theme.colors.neutral[150]);
});

;// CONCATENATED MODULE: ../../packages/components/BreadcrumbFilter/index.tsx




var BreadcrumbFilter = function(param) {
    var selectedFilters = param.selectedFilters, isBlackTheme = param.isBlackTheme, handlerClick = param.handlerClick, selectedBreadcrumbFilters = param.selectedBreadcrumbFilters;
    var ref = (0,react.useState)([]), activeFilters = ref[0], setActiveFilters = ref[1];
    (0,react.useEffect)(function() {
        setActiveFilters(selectedFilters);
    }, [
        selectedFilters
    ]);
    (0,react.useEffect)(function() {
        selectedBreadcrumbFilters(activeFilters);
    }, [
        activeFilters,
        selectedBreadcrumbFilters
    ]);
    var removeFilter = function(filter) {
        setActiveFilters(activeFilters.filter(function(element) {
            return element.option !== filter.option;
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbsFilterStyled, {
        isBlackTheme: isBlackTheme,
        children: activeFilters.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbsFilterList, {
            children: activeFilters.map(function(filter) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BreadcrumbFilterItem, {
                    onClick: function() {
                        removeFilter(filter);
                        handlerClick();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTitle, {
                            children: filter.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterText, {
                            children: decodeURIComponent(filter.option)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseFilter, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {
                                width: "15px",
                                height: "15px"
                            })
                        })
                    ]
                }, filter.option);
            })
        })
    });
};
/* harmony default export */ var components_BreadcrumbFilter = (BreadcrumbFilter);

// EXTERNAL MODULE: ../../packages/components/Form/index.tsx + 12 modules
var Form = __webpack_require__(29043);
// EXTERNAL MODULE: ../../packages/components/Paginator/index.tsx + 1 modules
var Paginator = __webpack_require__(49926);
// EXTERNAL MODULE: ../../packages/components/Playlist/index.tsx + 1 modules
var Playlist = __webpack_require__(57073);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../packages/components/FacetsFilterList/index.tsx + 2 modules
var FacetsFilterList = __webpack_require__(92041);
;// CONCATENATED MODULE: ../../packages/components/ProductFilterSidebar/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      @media ",
        " {\n        background: ",
        ";\n      }\n\n      @media ",
        " {\n        background: ",
        ";\n      }\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: ",
        ";\n  align-items: center;\n  justify-content: center;\n  gap: 10px 0;\n\n  @media ",
        " {\n    position: absolute;\n    width: 100%;\n    height: fit-content;\n    left: 0;\n    padding: 15px;\n    margin-top: -20px;\n    z-index: 5;\n    background: ",
        ";\n    align-items: start;\n    justify-content: start;\n    transform: ",
        ";\n    transition: 0.2s ease-in-out;\n  }\n\n  @media ",
        " {\n    position: absolute;\n    width: 100%;\n    height: fit-content;\n    left: 0;\n    padding: 15px;\n    margin-top: 0px;\n    z-index: 5;\n    background: ",
        ";\n    align-items: start;\n    justify-content: start;\n    transform: ",
        ";\n    transition: 0.2s ease-in-out;\n  }\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  border-radius: 50%;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var SidebarFilter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SidebarFilter",
    componentId: "sc-22ed77c4-0"
})(styles_templateObject1(), function(param) {
    var width = param.width;
    return width || "100%";
}, ui.theme.device.desktopFirst.tabletXL, ui.theme.colors.neutral[50], function(param) {
    var openMobile = param.openMobile;
    return openMobile ? "translateX(0)" : "translateX(-100%)";
}, ui.theme.device.desktopFirst.tablet, ui.theme.colors.neutral[50], function(param) {
    var openMobile = param.openMobile;
    return openMobile ? "translateX(0)" : "translateX(-100%)";
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject(), ui.theme.device.desktopFirst.tabletXL, ui.theme.colors.neutral[670], ui.theme.device.desktopFirst.tablet, ui.theme.colors.neutral[670]);
});
var BackButton = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__BackButton",
    componentId: "sc-22ed77c4-1"
})(styles_templateObject2());

;// CONCATENATED MODULE: ../../packages/components/ProductFilterSidebar/index.tsx












var ProductFilterSidebar = function(param) {
    var facets = param.facets, openMobile = param.openMobile, isLoading = param.isLoading, onApplyFilters = param.onApplyFilters, selectedBreadcrumbFilters = param.selectedBreadcrumbFilters, handlerClick = param.handlerClick, selectedFilters = param.selectedFilters, isBlackTheme = param.isBlackTheme;
    var events = (0,next_router.useRouter)().events;
    var ref = (0,react.useState)([]), filters = ref[0], setFilters = ref[1];
    var ref1 = (0,react.useState)(openMobile), openMobileFilter = ref1[0], setOpenMobileFilter = ref1[1];
    var ref2 = (0,react.useState)([]), categoryFilterParams = ref2[0], setCategoryFilterParams = ref2[1];
    var ref3 = (0,react.useState)([]), brandFilterParams = ref3[0], setBrandFilterParams = ref3[1];
    var ref4 = (0,react.useState)([]), modelFilterParams = ref4[0], setModelFilterParams = ref4[1];
    var ref5 = (0,react.useState)([]), setAttrAggFilterParams = ref5[1];
    var ref6 = (0,react.useState)([]), attrAggFilterOptionsParams = ref6[0], setAttrAggFilterOptionsParams = ref6[1];
    var ref7 = (0,react.useState)(""), brandFilterTitle = ref7[0], setBrandFilterTitle = ref7[1];
    var ref8 = (0,react.useState)([]), brandFilterOptions = ref8[0], setBrandFilterOptions = ref8[1];
    var ref9 = (0,react.useState)(""), lastClickedFilter = ref9[0], setLastClickedFilter = ref9[1];
    (0,react.useEffect)(function() {
        if (facets) {
            var mappedFilters = Object.entries(facets).map(function(filter) {
                return (0,_define_property/* default */.Z)({}, filter[0], filter[1]);
            }, [
                facets
            ]);
            setFilters(mappedFilters);
        }
    }, [
        facets
    ]);
    var ref10 = (0,react.useState)(""), categoryFilterTitle = ref10[0], setCategoryFilterTitle = ref10[1];
    var ref11 = (0,react.useState)([]), categoryFilterOptions = ref11[0], setCategoryFilterOptions = ref11[1];
    var ref12 = (0,react.useState)(""), modelFilterTitle = ref12[0], setModelFilterTitle = ref12[1];
    var ref13 = (0,react.useState)([]), modelFilterOptions = ref13[0], setModelFilterOptions = ref13[1];
    var ref14 = (0,react.useState)([]), attrAggFilterOptions = ref14[0], setAttrAggFilterOptions = ref14[1];
    var ref15 = (0,react.useState)(selectedBreadcrumbFilters), activeFilters = ref15[0], setActiveFilters = ref15[1];
    (0,react.useEffect)(function() {
        setActiveFilters(selectedBreadcrumbFilters);
    }, [
        selectedBreadcrumbFilters,
        selectedFilters
    ]);
    (0,react.useEffect)(function() {
        events.on("routeChangeStart", function() {
            setActiveFilters([]);
            selectedFilters([]);
        });
    }, [
        events,
        selectedFilters
    ]);
    (0,react.useEffect)(function() {
        var auxSelectedCategoryFilters = selectedBreadcrumbFilters.map(function(activeFilter) {
            return activeFilter.title === "Categoria" ? activeFilter.option : "";
        });
        var auxSelectedBrandFilters = selectedBreadcrumbFilters.map(function(activeFilter) {
            return activeFilter.title === "Marcas" ? activeFilter.option : "";
        });
        var auxSelectedModelFilters = selectedBreadcrumbFilters.map(function(activeFilter) {
            return activeFilter.title === "Modelos" ? activeFilter.option : "";
        });
        var auxSelectedAttrAggFilters = selectedBreadcrumbFilters.map(function(activeFilter) {
            return activeFilter.title !== "Categoria" && activeFilter.title !== "Marcas" && activeFilter.title !== "Modelos" ? "".concat(activeFilter.title, "-").concat(activeFilter.option) : "";
        });
        var auxSelectedAttrAggFiltersOptions = selectedBreadcrumbFilters.map(function(activeFilter) {
            return activeFilter.title !== "Categoria" && activeFilter.title !== "Marcas" && activeFilter.title !== "Modelos" ? activeFilter.option : "";
        });
        setCategoryFilterParams(auxSelectedCategoryFilters.filter(function(element) {
            return element !== "";
        }));
        setBrandFilterParams(auxSelectedBrandFilters.filter(function(element) {
            return element !== "";
        }));
        setModelFilterParams(auxSelectedModelFilters.filter(function(element) {
            return element !== "";
        }));
        setAttrAggFilterParams(auxSelectedAttrAggFilters.filter(function(element) {
            return element !== "";
        }));
        setAttrAggFilterOptionsParams(auxSelectedAttrAggFiltersOptions.filter(function(element) {
            return element !== "";
        }));
        onApplyFilters(auxSelectedCategoryFilters.filter(function(element) {
            return element !== "";
        }), auxSelectedBrandFilters.filter(function(element) {
            return element !== "";
        }), auxSelectedModelFilters.filter(function(element) {
            return element !== "";
        }), auxSelectedAttrAggFilters.filter(function(element) {
            return element !== "";
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedBreadcrumbFilters
    ]);
    var getBrandFacet = (0,react.useCallback)(function() {
        var brandFiltersList = filters.find(function(filter) {
            return filter.brand;
        });
        if (brandFiltersList) {
            Object.entries(brandFiltersList).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), title = _param[0], options = _param[1];
                setBrandFilterTitle(title);
                if (options) {
                    Object.entries(options).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                        if (key === "buckets" && lastClickedFilter !== "Marcas" || !activeFilters.length) {
                            setBrandFilterOptions(value);
                        }
                        return null;
                    });
                }
                return null;
            });
        }
    }, [
        activeFilters,
        filters,
        lastClickedFilter
    ]);
    var getCategoryFacet = (0,react.useCallback)(function() {
        var categoryFiltersList = filters.find(function(filter) {
            return filter.category;
        });
        if (categoryFiltersList) {
            Object.entries(categoryFiltersList).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), title = _param[0], options = _param[1];
                setCategoryFilterTitle(title);
                if (options) {
                    Object.entries(options).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                        if (key === "buckets" && lastClickedFilter !== "Categoria" || !activeFilters.length) {
                            setCategoryFilterOptions(value);
                        }
                        return null;
                    });
                }
                return null;
            });
        }
    }, [
        activeFilters,
        filters,
        lastClickedFilter
    ]);
    var getModelFacet = (0,react.useCallback)(function() {
        var modelFiltersList = filters.find(function(filter) {
            return filter.model;
        });
        if (modelFiltersList) {
            Object.entries(modelFiltersList).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), title = _param[0], options = _param[1];
                setModelFilterTitle(title);
                if (options) {
                    Object.entries(options).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                        if (key === "buckets" && lastClickedFilter !== "Modelos" || !activeFilters.length) {
                            setModelFilterOptions(value);
                        }
                        return null;
                    });
                }
                return null;
            });
        }
    }, [
        activeFilters,
        filters,
        lastClickedFilter
    ]);
    // italo.albuquerque revisar complexidade
    // eslint-disable-next-line sonarjs/cognitive-complexity
    var getAttrAggFacet = (0,react.useCallback)(function() {
        var attrAgg = {};
        var attrAggFiltersList = filters.find(function(filter) {
            return filter.attrAgg;
        });
        if (attrAggFiltersList) {
            Object.entries(attrAggFiltersList).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), options = _param[1];
                if (options) {
                    Object.entries(options).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                        if (key === "key") {
                            attrAgg = value;
                        }
                        return null;
                    });
                }
                return null;
            });
            if (attrAgg) {
                Object.entries(attrAgg).map(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                    if (key === "buckets" && lastClickedFilter !== value.key || !activeFilters.length) {
                        setAttrAggFilterOptions(value);
                    }
                    return null;
                });
            }
        }
    }, [
        activeFilters,
        filters,
        lastClickedFilter
    ]);
    // const getBrandFacet = useCallback(() => {
    //   if (filters[1]) {
    //     Object.entries(filters[1]).map(([title, options]) => {
    //       setBrandFilterTitle(title);
    //       Object.entries(options).map(([key, value]) => {
    //         if (
    //           (key === "buckets" && lastClickedFilter !== "Marcas") ||
    //           !activeFilters.length
    //         ) {
    //           setBrandFilterOptions(value as Buckets[]);
    //         }
    //         return null;
    //       });
    //       return null;
    //     });
    //   }
    // }, [activeFilters, filters, lastClickedFilter]);
    // const getCategoryFacet = useCallback(() => {
    //   if (filters[2]) {
    //     Object.entries(filters[2]).map(([title, options]) => {
    //       setCategoryFilterTitle(title);
    //       Object.entries(options).map(([key, value]) => {
    //         if (
    //           (key === "buckets" && lastClickedFilter !== "Categoria") ||
    //           !activeFilters.length
    //         ) {
    //           setCategoryFilterOptions(value as Buckets[]);
    //         }
    //         return null;
    //       });
    //       return null;
    //     });
    //   }
    // }, [activeFilters, filters, lastClickedFilter]);
    // const getModelFacet = useCallback(() => {
    //   if (filters[3]) {
    //     Object.entries(filters[3]).map(([title, options]) => {
    //       setModelFilterTitle(title);
    //       Object.entries(options).map(([key, value]) => {
    //         if (
    //           (key === "buckets" && lastClickedFilter !== "Modelos") ||
    //           !activeFilters.length
    //         ) {
    //           setModelFilterOptions(value as Buckets[]);
    //         }
    //         return null;
    //       });
    //       return null;
    //     });
    //   }
    // }, [activeFilters, filters, lastClickedFilter]);
    // // italo.albuquerque revisar complexidade
    // // eslint-disable-next-line sonarjs/cognitive-complexity
    // const getAttrAggFacet = useCallback(() => {
    //   let attrAgg: object = {};
    //   if (filters[0]) {
    //     Object.entries(filters[0]).map(([, options]) => {
    //       Object.entries(options).map(([key, value]) => {
    //         if (key === "key") {
    //           attrAgg = value as Buckets[];
    //         }
    //         return null;
    //       });
    //       return null;
    //     });
    //     if (attrAgg !== null) {
    //       Object.entries(attrAgg).map(([key, value]) => {
    //         if (
    //           (key === "buckets" && lastClickedFilter !== value.key) ||
    //           !activeFilters.length
    //         ) {
    //           // console.log(value.buckets);
    //           setAttrAggFilterOptions(value as Buckets[]);
    //         }
    //         return null;
    //       });
    //     }
    //   }
    // }, [activeFilters, filters, lastClickedFilter]);
    (0,react.useEffect)(function() {
        getCategoryFacet();
        getBrandFacet();
        getModelFacet();
        getAttrAggFacet();
    }, [
        getCategoryFacet,
        getBrandFacet,
        getModelFacet,
        getAttrAggFacet
    ]);
    (0,react.useEffect)(function() {
        setOpenMobileFilter(openMobile);
    }, [
        openMobile
    ]);
    // useEffect(() => {
    //   handleOnApplyFilters();
    // }, [handleOnApplyFilters]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarFilter, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sidebar-filter")), {
        openMobile: openMobileFilter,
        onClick: function() {
            handlerClick();
        },
        isBlackTheme: isBlackTheme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FacetsFilterList/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("first-facets-filter-list")), {
                isLoadingFacets: isLoading,
                hasFacets: !!facets,
                isBlackTheme: isBlackTheme,
                filterTitle: categoryFilterTitle,
                filterOptions: categoryFilterOptions,
                activeOptions: categoryFilterParams,
                handleTitleFilter: function(clickedOptionTitle) {
                    if (clickedOptionTitle) {
                        setLastClickedFilter(clickedOptionTitle);
                    }
                },
                handleOptionFilter: function(clickedOption) {
                    // const auxClickedOption = [...categoryFilterParams, clickedOption];
                    // if (!categoryFilterParams.length) {
                    //   setCategoryFilterParams(auxClickedOption);
                    // }
                    // const newAuxClickedOption = categoryFilterParams.find(
                    //   (activeItem) => activeItem === clickedOption
                    // );
                    // setCategoryFilterParams(
                    //   auxClickedOption.filter(
                    //     (option) => option !== newAuxClickedOption
                    //   )
                    // );
                    var auxActiveFilters = (0,_to_consumable_array/* default */.Z)(activeFilters).concat([
                        {
                            title: "Categoria",
                            option: clickedOption
                        }, 
                    ]);
                    if (!(activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length)) {
                        setActiveFilters(auxActiveFilters);
                        selectedFilters(auxActiveFilters);
                    }
                    var newAuxActiveFilters = activeFilters.find(function(activeItem) {
                        return activeItem.option === clickedOption;
                    });
                    var tempActiveFilters = auxActiveFilters.filter(function(selectedFilter) {
                        return selectedFilter.option !== (newAuxActiveFilters === null || newAuxActiveFilters === void 0 ? void 0 : newAuxActiveFilters.option);
                    });
                    setActiveFilters(tempActiveFilters);
                    selectedFilters(tempActiveFilters);
                },
                hasPreSelectFilter: true
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FacetsFilterList/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("second-facets-filter-list")), {
                isLoadingFacets: isLoading,
                hasFacets: !!facets,
                isBlackTheme: isBlackTheme,
                filterTitle: brandFilterTitle,
                filterOptions: brandFilterOptions,
                activeOptions: brandFilterParams,
                handleTitleFilter: function(clickedTitle) {
                    if (clickedTitle) {
                        setLastClickedFilter(clickedTitle);
                    }
                },
                handleOptionFilter: function(clickedOption) {
                    // const auxClickedOption = [...brandFilterParams, clickedOption];
                    // if (!brandFilterParams.length) {
                    //   setBrandFilterParams(auxClickedOption);
                    // }
                    // const newAuxClickedOption = brandFilterParams.find(
                    //   (activeItem) => activeItem === clickedOption
                    // );
                    // setBrandFilterParams(
                    //   auxClickedOption.filter(
                    //     (option) => option !== newAuxClickedOption
                    //   )
                    // );
                    var auxActiveFilters = (0,_to_consumable_array/* default */.Z)(activeFilters).concat([
                        {
                            title: "Marcas",
                            option: clickedOption
                        }, 
                    ]);
                    if (!(activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length)) {
                        setActiveFilters(auxActiveFilters);
                        selectedFilters(auxActiveFilters);
                    }
                    var newAuxActiveFilters = activeFilters.find(function(activeItem) {
                        return activeItem.option === clickedOption;
                    });
                    var tempActiveFilters = auxActiveFilters.filter(function(selectedFilter) {
                        return selectedFilter.option !== (newAuxActiveFilters === null || newAuxActiveFilters === void 0 ? void 0 : newAuxActiveFilters.option);
                    });
                    setActiveFilters(tempActiveFilters);
                    selectedFilters(tempActiveFilters);
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FacetsFilterList/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("thrid-facets-filter-list")), {
                isLoadingFacets: isLoading,
                hasFacets: !!facets,
                isBlackTheme: isBlackTheme,
                filterTitle: modelFilterTitle,
                filterOptions: modelFilterOptions,
                activeOptions: modelFilterParams,
                handleTitleFilter: function(clickedOptionTitle) {
                    if (clickedOptionTitle) {
                        setLastClickedFilter(clickedOptionTitle);
                    }
                },
                handleOptionFilter: function(clickedOption) {
                    // const auxClickedOption = [...modelFilterParams, clickedOption];
                    // if (!modelFilterParams.length) {
                    //   setModelFilterParams(auxClickedOption);
                    // }
                    // const newAuxClickedOption = modelFilterParams.find(
                    //   (activeItem) => activeItem === clickedOption
                    // );
                    // setModelFilterParams(
                    //   auxClickedOption.filter(
                    //     (option) => option !== newAuxClickedOption
                    //   )
                    // );
                    var auxActiveFilters = (0,_to_consumable_array/* default */.Z)(activeFilters).concat([
                        {
                            title: "Modelos",
                            option: clickedOption
                        }, 
                    ]);
                    if (!(activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length)) {
                        setActiveFilters(auxActiveFilters);
                        selectedFilters(auxActiveFilters);
                    }
                    var newAuxActiveFilters = activeFilters.find(function(activeItem) {
                        return activeItem.option === clickedOption;
                    });
                    var tempActiveFilters = auxActiveFilters.filter(function(selectedFilter) {
                        return selectedFilter.option !== (newAuxActiveFilters === null || newAuxActiveFilters === void 0 ? void 0 : newAuxActiveFilters.option);
                    });
                    setActiveFilters(tempActiveFilters);
                    selectedFilters(tempActiveFilters);
                }
            })),
            (categoryFilterParams === null || categoryFilterParams === void 0 ? void 0 : categoryFilterParams.length) ? attrAggFilterOptions.map(// italo.alboquerque diminuir a complexidade
            // eslint-disable-next-line sonarjs/cognitive-complexity
            function(param) {
                var key = param.key, value = param.value;
                return value && Object.entries(value).map(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), buckets = _param[0], val = _param[1];
                    return buckets === "buckets" ? /*#__PURE__*/ (0,react.createElement)(FacetsFilterList/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("facets-filter-".concat(buckets))), {
                        isLoadingFacets: isLoading,
                        hasFacets: !!facets,
                        isBlackTheme: isBlackTheme,
                        key: buckets,
                        filterTitle: key,
                        filterOptions: val,
                        activeOptions: attrAggFilterOptionsParams,
                        handleTitleFilter: function(clickedOptionTitle) {
                            if (clickedOptionTitle) {
                                setLastClickedFilter(clickedOptionTitle);
                            }
                        },
                        handleOptionFilter: function(clickedOption) {
                            // const auxClickedOption = [
                            //   ...attrAggFilterParams,
                            //   `${key}-${clickedOption}`,
                            // ];
                            // if (!attrAggFilterParams.length) {
                            //   setAttrAggFilterParams(auxClickedOption);
                            // }
                            // const newAuxClickedOption = attrAggFilterParams.find(
                            //   (activeItem) => activeItem === clickedOption
                            // );
                            // setAttrAggFilterParams(
                            //   auxClickedOption.filter(
                            //     (option) => option !== newAuxClickedOption
                            //   )
                            // );
                            var auxActiveFilters = (0,_to_consumable_array/* default */.Z)(activeFilters).concat([
                                {
                                    title: key,
                                    option: clickedOption
                                }, 
                            ]);
                            if (!(activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length)) {
                                setActiveFilters(auxActiveFilters);
                                selectedFilters(auxActiveFilters);
                            }
                            var newAuxActiveFilters = activeFilters.find(function(activeItem) {
                                return activeItem.option === clickedOption;
                            });
                            var tempActiveFilters = auxActiveFilters.filter(function(selectedFilter) {
                                return selectedFilter.option !== (newAuxActiveFilters === null || newAuxActiveFilters === void 0 ? void 0 : newAuxActiveFilters.option);
                            });
                            setActiveFilters(tempActiveFilters);
                            selectedFilters(tempActiveFilters);
                        }
                    })) : null;
                });
            }) : null
        ]
    }));
};
/* harmony default export */ var components_ProductFilterSidebar = (ProductFilterSidebar);

// EXTERNAL MODULE: ../../packages/components/Skeleton/index.tsx
var Skeleton = __webpack_require__(44860);
;// CONCATENATED MODULE: ../../packages/components/patterns/FilterProducts/data/utils.ts

var mapPageSourceToUrlType = function(source) {
    return ({
        category: "Category",
        highlight: "Highlight"
    })["".concat(source)];
};
var identifier = "filterProducts";
var cookiesKey = "currentPage_".concat(identifier);
var tabletSkeletonCardsGrid = "1fr 1fr 1fr";
var options = [
    {
        value: " ",
        label: "Mais relevante"
    },
    {
        value: "1",
        label: "Maiores pre\xe7os"
    },
    {
        value: "0",
        label: "Menores pre\xe7os"
    }, 
];
var pageUrlList = (/* unused pure expression or super */ null && ([
    "/Destaque/liquida",
    "/Destaque/construcao",
    "/Categoria/moveis-acessorios",
    "/Categoria/ar-ventilacao",
    "/Categoria/eletrodomesticos-acessorios",
    "/Categoria/ferramentas-e-epi",
    "/Categoria/automotivo",
    "/Categoria/utilidades-domesticas",
    "/Categoria/eletroportateis",
    "/Destaque/iluminacao-categoria",
    "/Destaque/outlet-rec", 
]));
var getItemListName = function(title, term, pathname) {
    if (pathname === "/pesquisa/[term]") {
        return "".concat(term);
    }
    return "".concat(title);
};
var getItemListId = function(term, idInfo, pathname) {
    if (pathname === "/pesquisa/[term]") {
        return "search_".concat(term);
    }
    if (pathname === "/Destaque/[url]" || pathname === "/Categoria/[url]") {
        return "expanded_playlist_".concat(idInfo);
    }
    return "preview_playlist_".concat(idInfo);
};
var setCookiesItem = function(value) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : cookiesKey;
    implementations/* cookie.setCookie */.pR.setCookie({
        name: name,
        value: value
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/FilterProducts/data/index.tsx





var useLogicFilterProducts = function(hasClickedFilter, currentPage) {
    var ref = (0,react.useState)(), params = ref[0], setParams = ref[1];
    var ref1 = (0,react.useState)(), searchedData = ref1[0], setSearchedData = ref1[1];
    var ref2 = (0,react.useState)([]), currentSelectedFilter = ref2[0], setCurrentSelectedFilter = ref2[1];
    var productListId = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = searchedData === null || searchedData === void 0 ? void 0 : (ref = searchedData.products) === null || ref === void 0 ? void 0 : ref.find(function(product) {
            return product;
        })) === null || ref1 === void 0 ? void 0 : ref1.categoryId;
    }, [
        searchedData === null || searchedData === void 0 ? void 0 : searchedData.products
    ]);
    var itemListIdInfo = (0,react.useMemo)(function() {
        var ref, ref1;
        return String((ref1 = searchedData === null || searchedData === void 0 ? void 0 : (ref = searchedData.products) === null || ref === void 0 ? void 0 : ref.find(function(product) {
            return product;
        })) === null || ref1 === void 0 ? void 0 : ref1.categoryId);
    }, [
        searchedData === null || searchedData === void 0 ? void 0 : searchedData.products
    ]);
    var hasUpdatedFilterOnParams = (0,react.useCallback)(function(updatedParams, oldParams) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        if ((updatedParams === null || updatedParams === void 0 ? void 0 : (ref = updatedParams.selectedFilterCategories) === null || ref === void 0 ? void 0 : ref.find(function(filterCategory, index) {
            var ref;
            return filterCategory !== (oldParams === null || oldParams === void 0 ? void 0 : (ref = oldParams.selectedFilterCategories) === null || ref === void 0 ? void 0 : ref["".concat(index)]);
        })) || (oldParams === null || oldParams === void 0 ? void 0 : (ref1 = oldParams.selectedFilterCategories) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            return true;
        }
        if ((updatedParams === null || updatedParams === void 0 ? void 0 : (ref2 = updatedParams.selectedFilterBrands) === null || ref2 === void 0 ? void 0 : ref2.find(function(filterCategory, index) {
            var ref;
            return filterCategory !== (oldParams === null || oldParams === void 0 ? void 0 : (ref = oldParams.selectedFilterBrands) === null || ref === void 0 ? void 0 : ref["".concat(index)]);
        })) || (oldParams === null || oldParams === void 0 ? void 0 : (ref3 = oldParams.selectedFilterBrands) === null || ref3 === void 0 ? void 0 : ref3.length)) {
            return true;
        }
        if ((updatedParams === null || updatedParams === void 0 ? void 0 : (ref4 = updatedParams.selectedFilterModels) === null || ref4 === void 0 ? void 0 : ref4.find(function(filterCategory, index) {
            var ref;
            return filterCategory !== (oldParams === null || oldParams === void 0 ? void 0 : (ref = oldParams.selectedFilterModels) === null || ref === void 0 ? void 0 : ref["".concat(index)]);
        })) || (oldParams === null || oldParams === void 0 ? void 0 : (ref5 = oldParams.selectedFilterModels) === null || ref5 === void 0 ? void 0 : ref5.length)) {
            return true;
        }
        if ((updatedParams === null || updatedParams === void 0 ? void 0 : (ref6 = updatedParams.selectedFilterAttrAgg) === null || ref6 === void 0 ? void 0 : ref6.find(function(filterCategory, index) {
            var ref;
            return filterCategory !== (oldParams === null || oldParams === void 0 ? void 0 : (ref = oldParams.selectedFilterAttrAgg) === null || ref === void 0 ? void 0 : ref["".concat(index)]);
        })) || (oldParams === null || oldParams === void 0 ? void 0 : (ref7 = oldParams.selectedFilterAttrAgg) === null || ref7 === void 0 ? void 0 : ref7.length)) {
            return true;
        }
        if ((updatedParams === null || updatedParams === void 0 ? void 0 : updatedParams.pageIndex) !== (oldParams === null || oldParams === void 0 ? void 0 : oldParams.pageIndex)) {
            return true;
        }
        return (updatedParams === null || updatedParams === void 0 ? void 0 : updatedParams.sortByOption) !== (oldParams === null || oldParams === void 0 ? void 0 : oldParams.sortByOption);
    }, []);
    var filterChangeHandler = (0,react.useCallback)(function(selectedFilterCategories, selectedFilterBrands, selectedFilterModels, selectedFilterAttrAgg) {
        var updatedParams = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
            selectedFilterCategories: selectedFilterCategories,
            selectedFilterBrands: selectedFilterBrands,
            selectedFilterModels: selectedFilterModels,
            selectedFilterAttrAgg: selectedFilterAttrAgg,
            pageIndex: "1"
        });
        if (hasUpdatedFilterOnParams(updatedParams, params) && hasClickedFilter) {
            setParams(updatedParams);
            setCookiesItem("1");
        }
    }, [
        hasClickedFilter,
        hasUpdatedFilterOnParams,
        params
    ]);
    var pageChangeHandler = (0,react.useCallback)(function(newCurrentPage) {
        if (Number(currentPage) !== Number(newCurrentPage)) {
            var updatedParams = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                pageIndex: newCurrentPage.toString()
            });
            setParams(updatedParams);
            setCookiesItem(newCurrentPage.toString(), cookiesKey);
        }
    }, [
        currentPage,
        params
    ]);
    var resetFilters = (0,react.useCallback)(function() {
        setSearchedData(null);
        setCurrentSelectedFilter([]);
    }, []);
    return {
        filterChangeHandler: filterChangeHandler,
        params: params,
        setParams: setParams,
        pageChangeHandler: pageChangeHandler,
        setSearchedData: setSearchedData,
        searchedData: searchedData,
        productListId: productListId,
        currentSelectedFilter: currentSelectedFilter,
        resetFilters: resetFilters,
        setCurrentSelectedFilter: setCurrentSelectedFilter,
        itemListIdInfo: itemListIdInfo
    };
};
var useFilterProductsUtilities = function() {
    var isClientMobile = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var spaceWrapperResponsivePadding = isClientMobile ? "0" : "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x4);
    var searchResultContentResponsivePadding = isClientMobile ? "0" : "".concat(ui.theme.space.x5, " ").concat(ui.theme.space.x0);
    var filterProductsContainerRef = (0,react.useRef)(null);
    var scrollIntoSelfContainer = function() {
        if (filterProductsContainerRef === null || filterProductsContainerRef === void 0 ? void 0 : filterProductsContainerRef.current) {
            filterProductsContainerRef.current.scrollIntoView();
        }
    };
    var searchResultContent = !isClientMobile ? "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x4) : "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x2);
    return {
        spaceWrapperResponsivePadding: spaceWrapperResponsivePadding,
        searchResultContentResponsivePadding: searchResultContentResponsivePadding,
        filterProductsContainerRef: filterProductsContainerRef,
        scrollIntoSelfContainer: scrollIntoSelfContainer,
        searchResultContent: searchResultContent
    };
};


// EXTERNAL MODULE: ../../packages/components/patterns/FilterProducts/styles.ts
var styles = __webpack_require__(62726);
;// CONCATENATED MODULE: ../../packages/components/patterns/FilterProducts/index.tsx





















var FilterProducts = function(param) {
    var data = param.data, totalRows = param.totalRows, term = param.term, title = param.title, playlistId = param.playlistId, isBlackTheme = param.isBlackTheme, _source = param.source, source = _source === void 0 ? "search" : _source, _preloadComponent = param.preloadComponent, preloadComponent = _preloadComponent === void 0 ? false : _preloadComponent;
    var ref, ref1, ref2, ref3, ref4;
    var branchId = (0,application/* getClientBranchId */.R0G)(implementations/* cookie */.pR);
    var ref5 = (0,react.useState)(true), isLoading = ref5[0], setIsLoading = ref5[1];
    var currentPage = implementations/* cookie.getCookie */.pR.getCookie({
        name: cookiesKey
    }) || "1";
    var ref6 = (0,react.useState)(false), openMobileFilter = ref6[0], setOpenMobileFilter = ref6[1];
    var ref7 = (0,react.useState)(false), hasClickedFilter = ref7[0], setHasClickedFilter = ref7[1];
    var ref8 = (0,react.useState)(""), sortByOption = ref8[0], setSortByOption = ref8[1];
    var ref9 = (0,react.useState)(""), currentProductTerm = ref9[0], setCurrentProductTerm = ref9[1];
    var ref10 = (0,react.useState)(true), sendEvent = ref10[0], setSendEvent = ref10[1];
    var ref11 = (0,react.useState)(totalRows), countRows = ref11[0], setCountRows = ref11[1];
    var ref12 = (0,react.useState)([]), currentSelectedBreadcrumbFilter = ref12[0], setCurrentSelectedBreadcrumbFilter = ref12[1];
    var router = (0,next_router.useRouter)();
    var filterProductsTerm = term || String(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.term);
    var ref13 = (0,application/* useAppContext */.bp4)(), isClientTabletXL = ref13.isClientTabletXL, isClientTablet = ref13.isClientTablet, isClientMobile = ref13.isClientMobile, setCloseCategoriesDropDown = ref13.setCloseCategoriesDropDown;
    var ref14 = useLogicFilterProducts(hasClickedFilter, currentPage), productListId = ref14.productListId, params = ref14.params, searchedData = ref14.searchedData, currentSelectedFilter = ref14.currentSelectedFilter, filterChangeHandler = ref14.filterChangeHandler, pageChangeHandler = ref14.pageChangeHandler, resetFilters = ref14.resetFilters, itemListIdInfo = ref14.itemListIdInfo, setParams = ref14.setParams, setSearchedData = ref14.setSearchedData, setCurrentSelectedFilter = ref14.setCurrentSelectedFilter;
    var ref15 = useFilterProductsUtilities(isClientMobile), filterProductsContainerRef = ref15.filterProductsContainerRef, scrollIntoSelfContainer = ref15.scrollIntoSelfContainer, searchResultContent = ref15.searchResultContent, searchResultContentResponsivePadding = ref15.searchResultContentResponsivePadding, spaceWrapperResponsivePadding = ref15.spaceWrapperResponsivePadding;
    var storedCurrentPage = implementations/* cookie.getCookie */.pR.getCookie({
        name: "currentPage_filterProducts"
    });
    var newUpdatedParams = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
        pageIndex: String(storedCurrentPage)
    });
    var ref16 = implementations/* catalogApi.getProductsSearchByTermsFilter */.dZ.getProductsSearchByTermsFilter(branchId, filterProductsTerm, (newUpdatedParams === null || newUpdatedParams === void 0 ? void 0 : (ref1 = newUpdatedParams.selectedFilterCategories) === null || ref1 === void 0 ? void 0 : ref1.length) ? newUpdatedParams.selectedFilterCategories.join(";") : "", (newUpdatedParams === null || newUpdatedParams === void 0 ? void 0 : (ref2 = newUpdatedParams.selectedFilterBrands) === null || ref2 === void 0 ? void 0 : ref2.length) ? newUpdatedParams.selectedFilterBrands.join(";") : "", (newUpdatedParams === null || newUpdatedParams === void 0 ? void 0 : (ref3 = newUpdatedParams.selectedFilterModels) === null || ref3 === void 0 ? void 0 : ref3.length) ? newUpdatedParams.selectedFilterModels.join(";") : "", (newUpdatedParams === null || newUpdatedParams === void 0 ? void 0 : (ref4 = newUpdatedParams.selectedFilterAttrAgg) === null || ref4 === void 0 ? void 0 : ref4.length) ? newUpdatedParams.selectedFilterAttrAgg.join(";") : "", storedCurrentPage, newUpdatedParams === null || newUpdatedParams === void 0 ? void 0 : newUpdatedParams.sortByOption, isClientMobile ? "46" : "45", !!(newUpdatedParams && source === "search" && branchId), Number(newUpdatedParams === null || newUpdatedParams === void 0 ? void 0 : newUpdatedParams.pageIndex) > 1 ? undefined : data), searchedDataByTerm = ref16.data, searchedDataIsLoading = ref16.isLoading;
    // eslint-disable-next-line sonarjs/cognitive-complexity
    var searchByTerm = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var storedTerm, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, sortData, totalResult, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    storedTerm = implementations/* cookie.getCookie */.pR.getCookie({
                        name: "filterProductsTerm"
                    });
                    implementations/* catalogApi.getProductsSearchByTerms */.dZ.getProductsSearchByTerms(String(branchId), filterProductsTerm, storedCurrentPage, isClientMobile ? "46" : "45");
                    setCookiesItem(filterProductsTerm, "filterProductsTerm");
                    if (filterProductsTerm !== storedTerm) {
                        setCookiesItem("1");
                    }
                    if (!(branchId && source !== "search")) return [
                        3,
                        5
                    ];
                    setIsLoading(true);
                    if (!playlistId) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        implementations/* catalogApi.getPlaylistProducts */.dZ.getPlaylistProducts({
                            playlistId: playlistId,
                            branchId: branchId,
                            currentPage: storedCurrentPage,
                            sortBy: sortByOption || "",
                            category: (params === null || params === void 0 ? void 0 : (ref = params.selectedFilterCategories) === null || ref === void 0 ? void 0 : ref.length) ? params.selectedFilterCategories.join(";") : "",
                            brand: (params === null || params === void 0 ? void 0 : (ref1 = params.selectedFilterBrands) === null || ref1 === void 0 ? void 0 : ref1.length) ? params.selectedFilterBrands.join(";") : "",
                            model: (params === null || params === void 0 ? void 0 : (ref2 = params.selectedFilterModels) === null || ref2 === void 0 ? void 0 : ref2.length) ? params.selectedFilterModels.join(";") : "",
                            attrAgg: (params === null || params === void 0 ? void 0 : (ref3 = params.selectedFilterAttrAgg) === null || ref3 === void 0 ? void 0 : ref3.length) ? params.selectedFilterAttrAgg.join(";") : "",
                            pageSize: isClientMobile ? "46" : "45"
                        })
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        implementations/* catalogApi.getPlaylistProductsByTypeAndUrlFilter */.dZ.getPlaylistProductsByTypeAndUrlFilter(mapPageSourceToUrlType(source), filterProductsTerm, branchId, (params === null || params === void 0 ? void 0 : (ref4 = params.selectedFilterCategories) === null || ref4 === void 0 ? void 0 : ref4.length) ? params.selectedFilterCategories.join(";") : "", (params === null || params === void 0 ? void 0 : (ref5 = params.selectedFilterBrands) === null || ref5 === void 0 ? void 0 : ref5.length) ? params.selectedFilterBrands.join(";") : "", (params === null || params === void 0 ? void 0 : (ref6 = params.selectedFilterModels) === null || ref6 === void 0 ? void 0 : ref6.length) ? params.selectedFilterModels.join(";") : "", (params === null || params === void 0 ? void 0 : (ref7 = params.selectedFilterAttrAgg) === null || ref7 === void 0 ? void 0 : ref7.length) ? params.selectedFilterAttrAgg.join(";") : "", currentPage, sortByOption, isClientMobile ? "46" : "45")
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    ref8 = _tmp, sortData = ref8.data, totalResult = ref8.totalRows;
                    setSearchedData(sortData);
                    setCountRows(totalResult ? Number(totalResult) : 0);
                    setIsLoading(false);
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [
        filterProductsTerm,
        params,
        currentPage,
        sortByOption,
        branchId
    ]);
    var customLabels = [
        {
            label: title || filterProductsTerm,
            redirectTo: "/".concat(source === "category" ? "Categoria" : "pesquisa", "/").concat(filterProductsTerm)
        }, 
    ];
    var itemListName = getItemListName(title || "", filterProductsTerm, router.pathname);
    var itemListId = getItemListId(filterProductsTerm || "", itemListIdInfo, router.pathname);
    var ref17 = (0,react.useState)(false), existH1 = ref17[0], setExistH1 = ref17[1];
    // const { asPath } = useRouter();
    (0,react.useEffect)(function() {
        if (searchedDataByTerm && source === "search") {
            var ref;
            setCurrentProductTerm(filterProductsTerm);
            setSearchedData(searchedDataByTerm);
            setCountRows(Number(((ref = searchedDataByTerm.headers) === null || ref === void 0 ? void 0 : ref.totalResults) || totalRows));
        } else {
            setSearchedData({});
        }
        setIsLoading(searchedDataIsLoading);
    }, [
        filterProductsTerm,
        searchedDataByTerm,
        searchedDataIsLoading,
        setSearchedData,
        source,
        totalRows, 
    ]);
    (0,react.useEffect)(function() {
        if (currentPage) {
            setSendEvent(true);
        }
    }, [
        currentPage
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((searchedData === null || searchedData === void 0 ? void 0 : (ref = searchedData.products) === null || ref === void 0 ? void 0 : ref.length) && sendEvent) {
            implementations/* gtag */.SX === null || implementations/* gtag */.SX === void 0 ? void 0 : implementations/* gtag.viewItemList */.SX.viewItemList(itemListName, itemListId, (0,_to_consumable_array/* default */.Z)(((searchedData === null || searchedData === void 0 ? void 0 : searchedData.products) || []).map(function(product, index) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                    index: (0,application/* getProductPosition */.E8Y)(index + 1, isClientMobile ? 46 : 45, Number(currentPage))
                });
            })));
            setSendEvent(false);
        }
    }, [
        itemListId,
        itemListName,
        searchedData === null || searchedData === void 0 ? void 0 : searchedData.products,
        isClientMobile,
        currentPage,
        sendEvent, 
    ]);
    (0,react.useEffect)(function() {
        router.events.on("routeChangeStart", function() {
            var ref, ref1;
            if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.term) === null || ref1 === void 0 ? void 0 : ref1.includes(String(currentProductTerm))) {
                return;
            }
            setIsLoading(true);
            resetFilters();
        });
    }, [
        currentProductTerm,
        resetFilters,
        router
    ]);
    (0,react.useEffect)(function() {
        searchByTerm();
    }, [
        searchByTerm
    ]);
    (0,react.useEffect)(function() {
        setCloseCategoriesDropDown(isLoading);
    }, [
        isLoading,
        setCloseCategoriesDropDown
    ]);
    (0,react.useEffect)(function() {
        var returnsQuantityOfH1 = document.querySelectorAll("h1").length;
        if (returnsQuantityOfH1) {
            setExistH1(false);
        } else {
            setExistH1(true);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* FilterProductsSearchContainer */.R$, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("filter-products-search-container")), {
        isBlackTheme: isBlackTheme,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* FilterProductsContainer */.ij, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("filter-products-container")), {
            ref: filterProductsContainerRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Row, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, {
                        padding: "".concat(ui.theme.space.x5, " ").concat(ui.theme.space.x4, " ").concat(ui.theme.space.x2),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BreadcrumbBox */.Nn, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("breadcrumb-box")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* Breadcrumb */.a, {
                                customLabels: customLabels
                            })
                        }))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Row, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* SearchResultHeader */.Zn, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("search-result-header")), {
                        isBlackTheme: isBlackTheme,
                        padding: "".concat(ui.theme.space.x5, " ").concat(ui.theme.space.x0),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Column, {
                                sm: "8",
                                md: "9",
                                padding: "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x4),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SearchResultTitle */.Rz, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        as: !existH1 ? "h2" : "h1"
                                    }, (0,application/* buildTestIds */.Fek)("search-result-title")), {
                                        children: source === "category" || source === "highlight" ? title !== null && title !== void 0 ? title : filterProductsTerm : 'Pesquisa por: "'.concat(title !== null && title !== void 0 ? title : filterProductsTerm, '"')
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SearchResultCounter */.wD, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("search-result-counter")), {
                                        children: "".concat(countRows !== null && countRows !== void 0 ? countRows : "Buscando os melhores produtos", " ").concat(countRows === undefined ? "" : countRows === 1 ? "Produto" : "Produtos")
                                    }))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.Column, {
                                xs: "12",
                                sm: "4",
                                md: "3",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: isClientMobile ? "space-between" : "end",
                                alignItems: "end",
                                padding: isClientMobile ? "".concat(ui.theme.space.x1, " ").concat(ui.theme.space.x2) : "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x4),
                                children: [
                                    isClientTabletXL && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* FilterButton */.Lb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("filter-button")), {
                                        width: "auto",
                                        height: "42px",
                                        onClick: function() {
                                            return setOpenMobileFilter(function(prev) {
                                                return !prev;
                                            });
                                        },
                                        children: [
                                            !openMobileFilter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* FilterIcon */.k1, (0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("filter-icon"))) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {
                                                width: "20px",
                                                height: "20px",
                                                color: ui.theme.colors.neutral.white
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("filter-button-text")), {
                                                fontSize: isClientMobile ? "1.2rem" : "1.3rem",
                                                margin: "0 0 0 8px",
                                                children: "Filtros"
                                            }))
                                        ]
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* SelectSortBy */.av, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("select-sort-by")), {
                                        isMobile: isClientMobile,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Label */.__, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("select-sort-by-label")), {
                                                fontSize: "14px",
                                                color: ui.theme.colors.neutral[550],
                                                text: "Ordenar por"
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* CustomSelect */.AP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-select-sort-by-select")), {
                                                autoFocus: false,
                                                blurInputOnSelect: false,
                                                isSearchable: false,
                                                instanceId: 1,
                                                options: options,
                                                defaultValue: options[0],
                                                classNamePrefix: "react-select",
                                                onChange: function(choice) {
                                                    var selectedOption = choice;
                                                    if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) {
                                                        setSortByOption(selectedOption.value);
                                                        var updatedParams = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                                            pageIndex: String(storedCurrentPage) || "1",
                                                            sortByOption: selectedOption.value
                                                        });
                                                        setParams(updatedParams);
                                                        setCookiesItem("1");
                                                    }
                                                }
                                            }))
                                        ]
                                    }))
                                ]
                            })
                        ]
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Row, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* SearchResultContent */.ZL, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("search-result-content")), {
                        padding: searchResultContentResponsivePadding,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.SpaceWrapper, {
                                padding: searchResultContent,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProductFilterSidebar, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("product-filter-sidebar")), {
                                    facets: searchedData === null || searchedData === void 0 ? void 0 : searchedData.facets,
                                    openMobile: openMobileFilter,
                                    isLoading: isLoading,
                                    onApplyFilters: function(activeCategoryFilters, activeBrandFilters, activeModelFilters, activeAttrAggFilters) {
                                        filterChangeHandler(activeCategoryFilters, activeBrandFilters, activeModelFilters, activeAttrAggFilters);
                                    },
                                    handlerClick: function() {
                                        scrollIntoSelfContainer();
                                        setHasClickedFilter(true);
                                    },
                                    selectedFilters: function(selectedFilter) {
                                        setCurrentSelectedFilter(selectedFilter);
                                    },
                                    selectedBreadcrumbFilters: currentSelectedBreadcrumbFilter,
                                    isBlackTheme: isBlackTheme
                                }))
                            }),
                            !openMobileFilter && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.SpaceWrapper, {
                                padding: spaceWrapperResponsivePadding,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BreadcrumbFilter, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("breadcrumb-filter")), {
                                        selectedBreadcrumbFilters: function(selectedFilters) {
                                            setCurrentSelectedBreadcrumbFilter(selectedFilters);
                                        },
                                        handlerClick: function() {
                                            setCookiesItem("1");
                                            scrollIntoSelfContainer();
                                        },
                                        selectedFilters: currentSelectedFilter,
                                        isBlackTheme: isBlackTheme
                                    })),
                                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Skeleton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("skeleton")), {
                                        type: "productListGridCard",
                                        count: 15,
                                        width: "100%",
                                        height: isClientMobile ? "325px" : "350px",
                                        style: isClientMobile ? {
                                            display: "grid",
                                            gridTemplateColumns: "1fr 1fr",
                                            width: "100%",
                                            marginLeft: "0px"
                                        } : isClientTablet ? {
                                            display: "grid",
                                            gridTemplateColumns: tabletSkeletonCardsGrid,
                                            marginLeft: "0px"
                                        } : {
                                            display: "grid",
                                            gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                                            width: "100%",
                                            marginLeft: "0px"
                                        },
                                        gap: "7px"
                                    })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Playlist/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("playlist-component")), {
                                                playlistId: Number(productListId),
                                                playlistName: String(title),
                                                searchTerm: currentProductTerm,
                                                productCards: (0,_to_consumable_array/* default */.Z)(((searchedData === null || searchedData === void 0 ? void 0 : searchedData.products) || []).map(function(product, index) {
                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                        index: (0,application/* getProductPosition */.E8Y)(index, isClientMobile ? 46 : 45, Number(storedCurrentPage))
                                                    });
                                                })),
                                                preloadComponent: preloadComponent
                                            })),
                                            (searchedData === null || searchedData === void 0 ? void 0 : searchedData.products) && countRows > 14 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Paginator/* Paginator */.D, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("paginator")), {
                                                identifier: identifier,
                                                visiblePages: 5,
                                                pageSize: isClientMobile ? 46 : 45,
                                                totalRows: countRows,
                                                justifyContent: "center",
                                                loading: isLoading,
                                                page: Number(currentPage),
                                                pageChangeHandler: pageChangeHandler,
                                                pageClickHandler: function() {
                                                    return scrollIntoSelfContainer();
                                                },
                                                isBlackTheme: isBlackTheme
                                            })) : null
                                        ]
                                    })
                                ]
                            })
                        ]
                    }))
                })
            ]
        }))
    }));
};



/***/ }),

/***/ 62726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ CustomSelect; },
/* harmony export */   "Lb": function() { return /* binding */ FilterButton; },
/* harmony export */   "Nn": function() { return /* binding */ BreadcrumbBox; },
/* harmony export */   "R$": function() { return /* binding */ FilterProductsSearchContainer; },
/* harmony export */   "Rz": function() { return /* binding */ SearchResultTitle; },
/* harmony export */   "ZL": function() { return /* binding */ SearchResultContent; },
/* harmony export */   "Zn": function() { return /* binding */ SearchResultHeader; },
/* harmony export */   "av": function() { return /* binding */ SelectSortBy; },
/* harmony export */   "ij": function() { return /* binding */ FilterProductsContainer; },
/* harmony export */   "k1": function() { return /* binding */ FilterIcon; },
/* harmony export */   "wD": function() { return /* binding */ SearchResultCounter; }
/* harmony export */ });
/* unused harmony exports BoxSelect, SkeletonContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63356);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86748);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  scroll-behavior: smooth;\n  width: -webkit-fill-available;\n  padding: 0 !important;\n\n  max-width: 1402px;\n\n  @media ",
        " {\n    padding: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  padding: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  @media ",
        " {\n    flex-direction: column;\n  }\n\n  @media ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  font-size: 2rem;\n  font-weight: bold;\n  letter-spacing: -1px;\n  margin-bottom: 1.3rem;\n  color: ",
        ";\n\n  @media ",
        " {\n    width: 80%;\n  }\n\n  @media ",
        " {\n    width: 80%;\n  }\n\n  @media ",
        " {\n    width: 100%;\n    font-size: 1.5rem;\n  }\n  /* \n  @media ",
        " {\n    width: 100%;\n    font-size: 1.5rem;\n  }\n\n  @media ",
        " {\n    width: 100%;\n    font-size: 1.5rem;\n  } */\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  > * {\n    box-shadow: none !important;\n    border-radius: ",
        ";\n    cursor: ",
        ";\n  }\n\n  .react-select__menu {\n    margin-top: 0;\n    background-color: transparent;\n    z-index: 10;\n  }\n\n  .react-select__option {\n    color: ",
        ";\n    cursor: pointer;\n    background-color: ",
        ";\n\n    :first-child {\n      border-radius: ",
        " ",
        " 0 0;\n    }\n    :last-child {\n      border-radius: 0 0 ",
        " ",
        ";\n    }\n  }\n\n  .react-select__option:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  .react-select__option--is-selected {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  .react-select__option--is-selected:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  font-weight: bold;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: 20% 80%;\n  padding: ",
        ";\n\n  @media ",
        " {\n    grid-template-columns: 22% 78%;\n  }\n\n  @media ",
        " {\n    grid-template-columns: 100%;\n  }\n\n  @media ",
        " {\n    grid-template-columns: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: start;\n  position: relative;\n  z-index: 6;\n\n  label {\n    margin: 0.5rem 0 1.33rem 0rem;\n  }\n\n  .react-select {\n    &__control {\n      width: 15rem;\n      border-radius: 4px;\n      height: 3.5rem;\n      position: relative;\n      border: thin solid ",
        ";\n      background-color: transparent;\n      appearance: none;\n      font-size: ",
        ";\n      color: ",
        ";\n      outline: none;\n      cursor: pointer;\n\n      &:hover {\n        border-color: ",
        ";\n      }\n    }\n\n    &__single-value {\n      color: ",
        ";\n      text-overflow: initial;\n      overflow: visible;\n    }\n\n    &__indicator-separator {\n      opacity: 0;\n    }\n\n    &__indicator {\n      color: ",
        ";\n      background: transparent;\n    }\n\n    &__option {\n      font-size: 1.3rem;\n    }\n  }\n\n  @media ",
        " {\n    .react-select {\n      &__control {\n        width: calc(16.65rem - 3rem);\n      }\n    }\n  }\n\n  @media ",
        " {\n    .react-select {\n      &__control {\n        width: calc(14.15rem - 0.5rem);\n      }\n    }\n  }\n\n  @media ",
        " {\n    .react-select {\n      &__control {\n        width: calc(13.35rem - 3rem);\n      }\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 10px;\n  border-radius: 4px;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        " {\n        a > svg > path {\n          fill: ",
        ";\n        }\n        ol > li > a {\n          color: ",
        ";\n        }\n      }\n\n      ",
        " {\n        border-bottom-color: ",
        ";\n      }\n\n      ",
        " {\n        color: ",
        ";\n      }\n\n      ",
        " {\n        color: ",
        ";\n      }\n\n      ",
        " {\n        .react-select__option {\n          color: ",
        ";\n          background-color: ",
        ";\n          border-top: 1px solid ",
        ";\n          border-left: 1px solid ",
        ";\n          border-right: 1px solid ",
        ";\n\n          &:last-of-type {\n            border-bottom: 1px solid ",
        ";\n          }\n        }\n\n        .react-select__option:hover {\n          color: ",
        ";\n          background-color: ",
        ";\n        }\n\n        .react-select__option--is-selected {\n          background-color: ",
        ";\n          color: ",
        ";\n          border-color: ",
        ";\n\n          &:last-of-type {\n            border-color: ",
        ";\n          }\n        }\n\n        .react-select__option--is-selected:hover {\n          background-color: ",
        ";\n          color: ",
        ";\n          border-color: ",
        ";\n        }\n      }\n\n      ",
        " {\n        label {\n          color: ",
        ";\n        }\n        .react-select {\n          &__control {\n            color: ",
        ";\n            border-color: ",
        ";\n\n            &:hover {\n              border-color: ",
        ";\n            }\n          }\n\n          &__single-value {\n            color: ",
        ";\n            text-overflow: initial;\n            overflow: visible;\n          }\n\n          &__indicator {\n            color: ",
        ";\n          }\n        }\n      }\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  width: 100%;\n  margin-left: 0;\n  gap: 7px;\n\n  @media ",
        " {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}

// italo.albuquerquer o Select do react-select precisa ser implementado em infra e chamado em components/Select. Desse modo, todo lugar do projeto usará o Select de components, e não de react-select.


var FilterProductsContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.Container).withConfig({
    displayName: "styles__FilterProductsContainer",
    componentId: "sc-a7ecb76b-0"
})(_templateObject(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL);
var handleFilterIcon = function(mobileFilterIconWidth, deskTopFilterIconWidth) {
    return ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileS ? mobileFilterIconWidth : deskTopFilterIconWidth;
};
var SearchResultHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__SearchResultHeader",
    componentId: "sc-a7ecb76b-1"
})(_templateObject1(), function(param) {
    var padding = param.padding;
    return padding || "0 0";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[278], ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tabletS, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL);
var SearchResultTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    displayName: "styles__SearchResultTitle",
    componentId: "sc-a7ecb76b-2"
})(_templateObject2(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[520], ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tabletXL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileM, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileS);
var CustomSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(react_select__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP).withConfig({
    displayName: "styles__CustomSelect",
    componentId: "sc-a7ecb76b-3"
})(_templateObject3(), function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius || "0";
}, function(param) {
    var cursor = param.cursor;
    return cursor || "auto";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.pink[50], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[100], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[250], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[250], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white);
var SearchResultCounter = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__SearchResultCounter",
    componentId: "sc-a7ecb76b-4"
})(_templateObject4(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[520]);
var SearchResultContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__SearchResultContent",
    componentId: "sc-a7ecb76b-5"
})(_templateObject5(), function(param) {
    var padding = param.padding;
    return padding || "0 0";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.laptop, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tabletXL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet);
var BreadcrumbBox = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__BreadcrumbBox",
    componentId: "sc-a7ecb76b-6"
})(_templateObject6());
var BoxSelect = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__BoxSelect",
    componentId: "sc-a7ecb76b-7"
})(_templateObject7());
var SelectSortBy = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__SelectSortBy",
    componentId: "sc-a7ecb76b-8"
})(_templateObject8(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200], function(isMobile) {
    return isMobile ? "1.2rem" : "1.3rem";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[300], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200], ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tabletXL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileS);
var FilterIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.Filter).attrs({
    width: handleFilterIcon(14, 20),
    height: handleFilterIcon(14, 20),
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white
}).withConfig({
    displayName: "styles__FilterIcon",
    componentId: "sc-a7ecb76b-9"
})(_templateObject9());
var FilterButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.Button).withConfig({
    displayName: "styles__FilterButton",
    componentId: "sc-a7ecb76b-10"
})(_templateObject10(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200]);
var FilterProductsSearchContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__FilterProductsSearchContainer",
    componentId: "sc-a7ecb76b-11"
})(_templateObject12(), function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject11(), BreadcrumbBox, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[560], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[560], SearchResultHeader, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.blackFriday[100], SearchResultTitle, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, SearchResultCounter, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, CustomSelect, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.blackFriday[200], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[110], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[250], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[250], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[250], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[250], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[250], SelectSortBy, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[100], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white);
});
var SkeletonContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__SkeletonContainer",
    componentId: "sc-a7ecb76b-12"
})(_templateObject13(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.laptop, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL);


/***/ }),

/***/ 53343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ Head; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/infra/components/index.ts + 234 modules
var components = __webpack_require__(62911);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/components/patterns/Head/Waf/index.tsx


var WafScript = /*#__PURE__*/ (0,react.memo)(function(wafInfos) {
    if (!wafInfos) {
        return null;
    }
    var isWafAvailable = wafInfos.isWafAvailable, awsWafChallengeUrl = wafInfos.awsWafChallengeUrl, awsWafJsApiUrl = wafInfos.awsWafJsApiUrl;
    if (isWafAvailable !== "true" || !awsWafChallengeUrl || !awsWafJsApiUrl) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                src: awsWafChallengeUrl,
                defer: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                src: awsWafJsApiUrl,
                defer: true
            })
        ]
    });
});
WafScript.displayName = "WafScript";


;// CONCATENATED MODULE: ../../packages/components/patterns/Head/index.tsx










var Head = function(param) {
    var _title = param.title, title = _title === void 0 ? "Ferreira Costa" : _title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? "Tudo para Casa, Constru\xe7\xe3o e Decora\xe7\xe3o" : _subtitle, _description = param.description, description = _description === void 0 ? "Encontre as melhores ofertas de eletrodom\xe9sticos, m\xf3veis, pisos, utilidades dom\xe9sticas e muito mais para sua casa! Aproveite!" : _description, _keywords = param.keywords, keywords = _keywords === void 0 ? [
        "Ferreira Costa, Home Center, Constru\xe7\xe3o, Casa, Ofertas, Decora\xe7\xe3o", 
    ] : _keywords, _image = param.image, image = _image === void 0 ? "https://fcx-s3-fercos-backoffice.ferreiracosta.com/favicon/apple-touch-icon.png" : _image, _shouldIndexPage = param.shouldIndexPage, shouldIndexPage = _shouldIndexPage === void 0 ? true : _shouldIndexPage, pageUrl = param.pageUrl, category = param.category, highlight = param.highlight, product = param.product;
    var ref, ref1, ref2, ref3;
    var ref4, ref5, ref6;
    var pageTitle = "".concat((ref6 = (ref5 = (ref4 = product === null || product === void 0 ? void 0 : product.productName) !== null && ref4 !== void 0 ? ref4 : category === null || category === void 0 ? void 0 : category.title) !== null && ref5 !== void 0 ? ref5 : highlight === null || highlight === void 0 ? void 0 : highlight.title) !== null && ref6 !== void 0 ? ref6 : title, " | ").concat(subtitle);
    var router = (0,next_router.useRouter)();
    var ref7 = (0,react.useState)({
        isWafAvailable: "false",
        awsWafChallengeUrl: "",
        awsWafJsApiUrl: ""
    }), wafInfos = ref7[0], setWafInfos = ref7[1];
    var ref8 = (0,react.useState)(null), pageImage = ref8[0], setPageImage = ref8[1];
    var ref9 = (0,react.useState)(pageUrl || null), formattedPageUrl = ref9[0], setFormattedPageUrl = ref9[1];
    var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
        return state.allConfigs;
    });
    (0,react.useEffect)(function() {
        var handleIsWafAvailable = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(passedWafInfos) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setWafInfos(passedWafInfos);
                    return [
                        2
                    ];
                });
            });
            return function handleIsWafAvailable(passedWafInfos) {
                return _ref.apply(this, arguments);
            };
        }();
        if (allConfigs) {
            var isWafAvailable = allConfigs.isWafAvailable, awsWafChallengeUrl = allConfigs.awsWafChallengeUrl, awsWafJsApiUrl = allConfigs.awsWafJsApiUrl, siteUrl = allConfigs.siteUrl;
            handleIsWafAvailable({
                isWafAvailable: isWafAvailable,
                awsWafChallengeUrl: awsWafChallengeUrl,
                awsWafJsApiUrl: awsWafJsApiUrl
            });
            setPageImage(image ? image.startsWith("/") ? "".concat(siteUrl).concat(image) : image : null);
            if (!formattedPageUrl) {
                setFormattedPageUrl(siteUrl);
            }
        }
    }, [
        allConfigs,
        formattedPageUrl,
        image
    ]);
    var siteName = (ref = formattedPageUrl === null || formattedPageUrl === void 0 ? void 0 : formattedPageUrl.match(/https?:\/\/([^/]+)/)) === null || ref === void 0 ? void 0 : ref.at(1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Head */.Fb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("head-component")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: pageTitle
            }),
            keywords && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: keywords.slice().join(", ")
            }),
            !shouldIndexPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex,nofollow"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/favicon/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "100x100",
                href: "https://fercos-s3-ecommerce.s3.us-east-1.amazonaws.com/favicon/apple-touch-icon-precomposed.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "120x120",
                href: "https://fercos-s3-ecommerce.s3.us-east-1.amazonaws.com/favicon/apple-touch-icon-120x120-precomposed.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: "/favicon.ico",
                type: "image/png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/favicon/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0, minimum-scale=0.5, maximum-scale=1.0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "x-ua-compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "MobileOptimized",
                content: "320"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "HandheldFriendly",
                content: "True"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "theme-color",
                content: "#DA0812"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#DA0812"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "Content-Language",
                content: "pt-br"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "referrer",
                content: "no-referrer-when-downgrade"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:locale",
                content: "pt_BR"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "application-name",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: (product === null || product === void 0 ? void 0 : product.productTitle) || (category === null || category === void 0 ? void 0 : category.title) || (highlight === null || highlight === void 0 ? void 0 : highlight.title) || title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: (product === null || product === void 0 ? void 0 : product.description) || (category === null || category === void 0 ? void 0 : category.description) || (highlight === null || highlight === void 0 ? void 0 : highlight.description) || description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: (product === null || product === void 0 ? void 0 : product.image) || image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WafScript, (0,_object_spread/* default */.Z)({}, wafInfos)),
            product || category || highlight ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: (product === null || product === void 0 ? void 0 : product.url) || (category === null || category === void 0 ? void 0 : category.url) || (highlight === null || highlight === void 0 ? void 0 : highlight.url)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msvalidate.01",
                        content: "E7DCE11C2F6EF34169891FD104F4B11B"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "fb:app_id",
                        content: "271309290176012"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: (product === null || product === void 0 ? void 0 : product.id) ? "product" : "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: (product === null || product === void 0 ? void 0 : product.productTitle) || (category === null || category === void 0 ? void 0 : category.title) || (highlight === null || highlight === void 0 ? void 0 : highlight.title)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: (product === null || product === void 0 ? void 0 : product.url) || (category === null || category === void 0 ? void 0 : category.url) || (highlight === null || highlight === void 0 ? void 0 : highlight.url)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: (product === null || product === void 0 ? void 0 : product.image) || image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: (product === null || product === void 0 ? void 0 : product.image) || image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: (product === null || product === void 0 ? void 0 : product.productName) || "Thumbnail"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:width",
                        content: "420"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:height",
                        content: "420"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: (product === null || product === void 0 ? void 0 : product.description) || (category === null || category === void 0 ? void 0 : category.description) || (highlight === null || highlight === void 0 ? void 0 : highlight.description)
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msvalidate.01",
                        content: "E7DCE11C2F6EF34169891FD104F4B11B"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "fb:app_id",
                        content: "271309290176012"
                    }),
                    router && !(router === null || router === void 0 ? void 0 : (ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.includes("/prod")) && !(router === null || router === void 0 ? void 0 : (ref2 = router.asPath) === null || ref2 === void 0 ? void 0 : ref2.includes("/Destaque")) && !(router === null || router === void 0 ? void 0 : (ref3 = router.asPath) === null || ref3 === void 0 ? void 0 : ref3.includes("/Categ")) && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: String(formattedPageUrl)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: pageTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: pageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: siteName || pageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "image",
                        content: pageImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: pageImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: pageImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: "Thumbnail"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:type",
                        content: "image/png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:width",
                        content: "1200"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:height",
                        content: "630"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge"
            })
        ]
    }));
};



/***/ }),

/***/ 94340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F2": function() { return /* binding */ AccessAction; },
/* harmony export */   "FM": function() { return /* binding */ CompleteOrderText; },
/* harmony export */   "JP": function() { return /* binding */ EyeCloseIcon; },
/* harmony export */   "Oy": function() { return /* binding */ CartContent; },
/* harmony export */   "RR": function() { return /* binding */ LoginText; },
/* harmony export */   "Us": function() { return /* binding */ LoginDivider; },
/* harmony export */   "Wb": function() { return /* binding */ WrapperDivider; },
/* harmony export */   "Xk": function() { return /* binding */ AppleOAuthIcon; },
/* harmony export */   "Yb": function() { return /* binding */ FormContainer; },
/* harmony export */   "Ze": function() { return /* binding */ ContainerIconEye; },
/* harmony export */   "d4": function() { return /* binding */ LinkCustom; },
/* harmony export */   "dd": function() { return /* binding */ ButtonAuthenticationOAuth; },
/* harmony export */   "eC": function() { return /* binding */ WrapperOAuthButtons; },
/* harmony export */   "hs": function() { return /* binding */ EyeOpenIcon; },
/* harmony export */   "iJ": function() { return /* binding */ GoogleOAuthIcon; },
/* harmony export */   "lF": function() { return /* binding */ AuthenticationWrapper; },
/* harmony export */   "nf": function() { return /* binding */ AuthContentContainer; },
/* harmony export */   "oF": function() { return /* binding */ WrapperRow; },
/* harmony export */   "on": function() { return /* binding */ PasswordContainer; },
/* harmony export */   "s5": function() { return /* binding */ InputAuth; },
/* harmony export */   "sg": function() { return /* binding */ TitleForgotPassword; },
/* harmony export */   "u6": function() { return /* binding */ LinkText; },
/* harmony export */   "z4": function() { return /* binding */ LabelCustom; },
/* harmony export */   "zp": function() { return /* binding */ OptionText; }
/* harmony export */ });
/* unused harmony exports FormWrapper, WrapperNewUser, TitleNewUser, WrapperRecaptcha, PasswordInfo, PrivacyPolicy, PrivacyPolicyLink */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);
/* harmony import */ var _Form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29043);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  width: ",
        ";\n  margin: 0 auto !important;\n  display: flex;\n  flex-direction: column;\n\n  @media ",
        " {\n    padding: 16px;\n    margin-top: 2rem;\n    width: 100%;\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding: ",
        " ",
        ";\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        " ",
        ";\n  font-size: ",
        ";\n  color: ",
        " !important;\n  font-family: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  margin: 0 !important;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 100px;\n  border: 0.5px solid ",
        ";\n  gap: 0.75rem;\n  cursor: pointer;\n\n  background: ",
        ";\n\n  transition: 0.2s ease-in-out;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: initial;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  gap: ",
        ";\n  color: ",
        ";\n  margin-bottom: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  color: ",
        " !important;\n  font-weight: ",
        ";\n  letter-spacing: -0.24px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-right-width: 0;\n      border-radius: ",
        " ",
        " ",
        "\n        ",
        ";\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 45px;\n  font-family: ",
        ";\n  padding-left: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px 0px 0px 4px;\n  background: transparent;\n  border-radius: ",
        ";\n  color: ",
        " !important;\n  border-right-width: ",
        ";\n\n  &::placeholder {\n    color: ",
        " !important;\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  &::-ms-reveal,\n  &::-ms-clear {\n    display: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-weight: ",
        ";\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  text-decoration: underline;\n  color: ",
        " !important;\n\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 1.8rem 0 0.9rem 0;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 !important;\n  justify-content: flex-start !important;\n  cursor: pointer;\n  color: ",
        " !important;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 45px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 3.35rem;\n  border-left: none;\n  cursor: pointer;\n  border: 1px solid ",
        ";\n  border-radius: 0px 4px 4px 0px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 0.83rem;\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  color: ",
        ";\n  letter-spacing: -0.2px;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 2px;\n  justify-content: center;\n  margin: 2rem 0;\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  letter-spacing: -0.4px;\n  text-align: center;\n\n  @media ",
        " {\n    flex-wrap: wrap;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  letter-spacing: -0.4px;\n  text-decoration: underline;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  color: ",
        " !important;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin: ",
        " ",
        " ",
        ";\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 1px;\n  background-color: ",
        " !important;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}



var AuthContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__AuthContentContainer",
    componentId: "sc-6e6ee377-0"
})(_templateObject(), function(param) {
    var isPageLogin = param.isPageLogin;
    return isPageLogin ? "3rem 0 2rem" : "0";
}, function(param) {
    var isPageLogin = param.isPageLogin;
    return isPageLogin ? "360px" : "auto";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL);
var WrapperDivider = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].aside.withConfig */ .ZP.aside.withConfig({
    displayName: "styles__WrapperDivider",
    componentId: "sc-6e6ee377-1"
})(_templateObject1(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0);
var OptionText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "styles__OptionText",
    componentId: "sc-6e6ee377-2"
})(_templateObject2(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x5, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[350], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400]);
var AuthenticationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__AuthenticationWrapper",
    componentId: "sc-6e6ee377-3"
})(_templateObject3());
var WrapperOAuthButtons = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__WrapperOAuthButtons",
    componentId: "sc-6e6ee377-4"
})(_templateObject4(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4);
var ButtonAuthenticationOAuth = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "styles__ButtonAuthenticationOAuth",
    componentId: "sc-6e6ee377-5"
})(_templateObject5(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[330], function(param) {
    var typeAuthentication = param.typeAuthentication;
    return typeAuthentication !== "Google" ? ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[999] : ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white;
}, function(param) {
    var typeAuthentication = param.typeAuthentication;
    return typeAuthentication === "Google" && ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral["999-opacity-15"];
});
var AppleOAuthIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.Apple).attrs(function(param) {
    var isHovered = param.isHovered;
    return {
        color: isHovered ? ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[580] : ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white,
        height: 20,
        width: 20
    };
}).withConfig({
    displayName: "styles__AppleOAuthIcon",
    componentId: "sc-6e6ee377-6"
})(_templateObject6());
var GoogleOAuthIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.GoogleColored).attrs({
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white,
    height: 22,
    width: 22
}).withConfig({
    displayName: "styles__GoogleOAuthIcon",
    componentId: "sc-6e6ee377-7"
})(_templateObject7());
var FormContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    displayName: "styles__FormContainer",
    componentId: "sc-6e6ee377-8"
})(_templateObject8(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x3, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[400], ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6);
var WrapperRow = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__WrapperRow",
    componentId: "sc-6e6ee377-9"
})(_templateObject9(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2);
var PasswordContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__PasswordContainer",
    componentId: "sc-6e6ee377-10"
})(_templateObject10());
var FormWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    displayName: "styles__FormWrapper",
    componentId: "sc-6e6ee377-11"
})(_templateObject11());
var LabelCustom = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Form__WEBPACK_IMPORTED_MODULE_2__/* .Label */ .__).withConfig({
    displayName: "styles__LabelCustom",
    componentId: "sc-6e6ee377-12"
})(_templateObject12(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x7, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[750], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400]);
var InputAuth = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    displayName: "styles__InputAuth",
    componentId: "sc-6e6ee377-13"
})(_templateObject14(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[580], ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[999], function(param) {
    var hasIcon = param.hasIcon;
    return hasIcon && "0";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[350], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x5, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400], function(param) {
    var hasIcon = param.hasIcon;
    return hasIcon && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject13(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1);
});
var TitleForgotPassword = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__TitleForgotPassword",
    componentId: "sc-6e6ee377-14"
})(_templateObject16(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x5, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[550], function(param) {
    var isMyCartPage = param.isMyCartPage;
    return isMyCartPage && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject15(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight.bold);
});
var WrapperNewUser = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].aside.withConfig */ .ZP.aside.withConfig({
    displayName: "styles__WrapperNewUser",
    componentId: "sc-6e6ee377-15"
})(_templateObject17());
var TitleNewUser = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__TitleNewUser",
    componentId: "sc-6e6ee377-16"
})(_templateObject18(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x6, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[520], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo);
var LinkCustom = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__LinkCustom",
    componentId: "sc-6e6ee377-17"
})(_templateObject19(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[100]);
var ContainerIconEye = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__ContainerIconEye",
    componentId: "sc-6e6ee377-18"
})(_templateObject20(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[580]);
var EyeOpenIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.EyeOpen).attrs({
    width: 24,
    height: 24,
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[200]
}).withConfig({
    displayName: "styles__EyeOpenIcon",
    componentId: "sc-6e6ee377-19"
})(_templateObject21());
var EyeCloseIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.EyeClose).attrs({
    width: 24,
    height: 24,
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[200]
}).withConfig({
    displayName: "styles__EyeCloseIcon",
    componentId: "sc-6e6ee377-20"
})(_templateObject22());
var WrapperRecaptcha = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__WrapperRecaptcha",
    componentId: "sc-6e6ee377-21"
})(_templateObject23());
var PasswordInfo = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__PasswordInfo",
    componentId: "sc-6e6ee377-22"
})(_templateObject24(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[550]);
var AccessAction = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__AccessAction",
    componentId: "sc-6e6ee377-23"
})(_templateObject25(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6);
var PrivacyPolicy = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__PrivacyPolicy",
    componentId: "sc-6e6ee377-24"
})(_templateObject26(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x3, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[550], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400], ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet);
var PrivacyPolicyLink = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__PrivacyPolicyLink",
    componentId: "sc-6e6ee377-25"
})(_templateObject27());
var LinkText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__LinkText",
    componentId: "sc-6e6ee377-26"
})(_templateObject28(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x5, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[550]);
var CartContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CartContent",
    componentId: "sc-6e6ee377-27"
})(_templateObject29(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space["x0.5"], ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4);
var CompleteOrderText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__CompleteOrderText",
    componentId: "sc-6e6ee377-28"
})(_templateObject30(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x3, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[525], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400]);
var LoginText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__LoginText",
    componentId: "sc-6e6ee377-29"
})(_templateObject31(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.md.x1, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[525], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight.bold);
var LoginDivider = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__LoginDivider",
    componentId: "sc-6e6ee377-30"
})(_templateObject32(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[580]);


/***/ }),

/***/ 133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ AuthContent; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../packages/components/Header/index.tsx + 1 modules
var Header = __webpack_require__(43119);
// EXTERNAL MODULE: ../../packages/components/patterns/Head/index.tsx + 1 modules
var Head = __webpack_require__(53343);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px !important;\n  height: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var AuthContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__AuthContainer",
    componentId: "sc-9e658c7c-0"
})(_templateObject(), function(param) {
    var isPageLogin = param.isPageLogin;
    return isPageLogin ? "100vh" : "auto";
});

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/index.tsx







var AuthContent = function(param) {
    var loginMode = param.loginMode, children = param.children;
    var isLoginPage = loginMode === "page";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isPageLogin: isLoginPage
    }, (0,application/* buildTestIds */.Fek)("auth-content-container")), {
        children: [
            isLoginPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: "Entrar | Ferreira Costa"
            }),
            isLoginPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {}),
            children
        ]
    }));
};



/***/ }),

/***/ 20128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G8": function() { return /* binding */ CheckSuccess; },
/* harmony export */   "WE": function() { return /* binding */ WrapperAlertError; },
/* harmony export */   "b8": function() { return /* binding */ WrapperCheckSuccess; },
/* harmony export */   "ne": function() { return /* binding */ AlertError; },
/* harmony export */   "uF": function() { return /* binding */ TextError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 1.125rem;\n  font-family: ",
        ";\n  font-weight: 400;\n  color: ",
        ";\n  width: 100%;\n\n  @media ",
        " {\n    font-size: 1rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: ",
        ";\n  margin: 1.5rem 0 0 -2rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  margin: 1.5rem 0 0 -2rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var TextError = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__TextError",
    componentId: "sc-3e77b371-0"
})(_templateObject(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.roboto, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[380], ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet);
var WrapperAlertError = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__WrapperAlertError",
    componentId: "sc-3e77b371-1"
})(_templateObject1(), function(param) {
    var positionShouldBeRelative = param.positionShouldBeRelative;
    return positionShouldBeRelative ? "relative" : "absolute";
});
var WrapperCheckSuccess = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__WrapperCheckSuccess",
    componentId: "sc-3e77b371-2"
})(_templateObject2());
var AlertError = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.AlertWithStroke).attrs({
    width: "1.125rem",
    height: "1.125rem",
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200]
}).withConfig({
    displayName: "styles__AlertError",
    componentId: "sc-3e77b371-3"
})(_templateObject3());
var CheckSuccess = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.CheckDone).attrs({
    width: "1.125rem",
    height: "1.125rem",
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.secondary[380]
}).withConfig({
    displayName: "styles__CheckSuccess",
    componentId: "sc-3e77b371-4"
})(_templateObject4());


/***/ }),

/***/ 74774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VY": function() { return /* binding */ getAuthContent; }
});

// UNUSED EXPORTS: companyProducts, handleHighlightCategories, listCategories, userAuthenticatedActions

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
// EXTERNAL MODULE: ../../packages/components/patterns/Header/components/mobile/SidebarMenuMobile/styles.ts
var styles = __webpack_require__(32191);
// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../packages/components/ButtonSubmit/index.tsx
var ButtonSubmit = __webpack_require__(42942);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ForgotPassword/NewForgotPassword/schema/index.tsx


var recoverPasswordFormValidateSchema = lib/* object */.Ry({
    recipientEmailForgotPassword: lib/* string */.Z_().min(11, {
        message: "O valor de caracteres deve ser no m\xednimo 11"
    }).email({
        message: "E-mail n\xe3o \xe9 v\xe1lido"
    })
});
var validateCpfSchema = lib/* object */.Ry({
    recipientCPFForgotPassword: lib/* string */.Z_().superRefine(function(value, context) {
        var response = (0,application/* validateCpf */.cyc)(value);
        var received = response;
        if (response) context.addIssue({
            code: "invalid_type",
            expected: "string",
            received: received,
            message: "".concat(response)
        });
    })
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/react-select.esm.js + 47 modules
var react_select_esm = __webpack_require__(86748);
// EXTERNAL MODULE: ../../packages/components/Form/index.tsx + 12 modules
var Form = __webpack_require__(29043);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ForgotPassword/NewForgotPassword/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 2rem;\n  border-radius: ",
        ";\n  max-width: 360px;\n  margin: 0 auto;\n\n  @media ",
        " {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 126px;\n  height: 3.35rem;\n  display: flex;\n  align-items: center;\n  padding: 0 1rem;\n  border-radius: 4px;\n  justify-content: center;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 0;\n  height: 3.35rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        " !important;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n\n  &::placeholder {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  margin: 0 !important;\n\n  @media ",
        " {\n    padding: ",
        " ",
        " ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n\n  @media ",
        " {\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  gap: ",
        ";\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  white-space: break-spaces;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 3.35rem;\n  font-family: ",
        ";\n  padding-left: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  background: transparent;\n  color: ",
        ";\n\n  &::placeholder {\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  &::-ms-reveal,\n  &::-ms-clear {\n    display: none;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  > * {\n    box-shadow: none !important;\n    border-radius: ",
        ";\n    cursor: pointer;\n  }\n\n  .react-select__control {\n    height: 40px;\n    border-color: ",
        ";\n    cursor: pointer;\n  }\n\n  .react-select__menu {\n    margin-top: 0;\n  }\n\n  .react-select__option {\n    border-radius: 4px;\n    color: ",
        " !important;\n    cursor: pointer;\n    background-color: ",
        ";\n  }\n\n  .react-select__control:hover {\n    border-color: ",
        ";\n  }\n\n  .react-select__option:hover {\n    background-color: ",
        ";\n    color: ",
        " !important;\n    border-color: ",
        ";\n  }\n\n  .react-select__single-value {\n    color: ",
        " !important;\n  }\n\n  .react-select__option--is-selected {\n    background-color: ",
        ";\n    color: ",
        " !important;\n  }\n\n  .react-select__option--is-selected:hover {\n    background-color: ",
        ";\n    color: ",
        " !important;\n  }\n\n  .react-select__indicator-separator {\n    display: none;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  box-shadow: 0px 2px 2px ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}




var ForgotPasswordWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ForgotPasswordWrapper",
    componentId: "sc-d3f87077-0"
})(_templateObject(), ui.theme.space.x4, ui.theme.device.desktopFirst.mobileXL);
var SelectIdentificationType = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    displayName: "styles__SelectIdentificationType",
    componentId: "sc-d3f87077-1"
})(_templateObject1(), ui.theme.colors.neutral[580]);
var TypeOption = styled_components_browser_esm/* default.option.withConfig */.ZP.option.withConfig({
    displayName: "styles__TypeOption",
    componentId: "sc-d3f87077-2"
})(_templateObject2());
var SelectWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SelectWrapper",
    componentId: "sc-d3f87077-3"
})(_templateObject3(), ui.theme.space.x1);
var LabelSelect = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "styles__LabelSelect",
    componentId: "sc-d3f87077-4"
})(_templateObject4(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[400], ui.theme.colors.neutral[750]);
var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Form/* Input */.II).withConfig({
    displayName: "styles__StyledInput",
    componentId: "sc-d3f87077-5"
})(_templateObject5(), ui.theme.colors.neutral[550], ui.theme.colors.neutral[350]);
var ForgotPasswordContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ForgotPasswordContainer",
    componentId: "sc-d3f87077-6"
})(_templateObject6(), ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x0, ui.theme.space.x6, ui.theme.space.x6);
var ContentInformation = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__ContentInformation",
    componentId: "sc-d3f87077-7"
})(_templateObject7(), ui.theme.space["x2.5"], ui.theme.device.desktopFirst.mobileXL);
var ArrowLeftIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowLeftIcon).attrs({
    height: "15px",
    width: "15px",
    color: ui.theme.colors.neutral[600]
}).withConfig({
    displayName: "styles__ArrowLeftIcon",
    componentId: "sc-d3f87077-8"
})(_templateObject8());
var FormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FormContainer",
    componentId: "sc-d3f87077-9"
})(_templateObject9());
var FormForgotPassword = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "styles__FormForgotPassword",
    componentId: "sc-d3f87077-10"
})(_templateObject10());
var ForgotPasswordContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ForgotPasswordContent",
    componentId: "sc-d3f87077-11"
})(_templateObject11(), ui.theme.space.x4, FormForgotPassword);
var RecoverAccessText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__RecoverAccessText",
    componentId: "sc-d3f87077-12"
})(_templateObject12(), ui.theme.colors.neutral[550], ui.theme.typography.fontSize.sm.x9, ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight.bold, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x7, ui.theme.colors.neutral[750]);
var RecoverInfoText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__RecoverInfoText",
    componentId: "sc-d3f87077-13"
})(_templateObject13(), ui.theme.colors.neutral[110], ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[400]);
var InputForgotPassword = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "styles__InputForgotPassword",
    componentId: "sc-d3f87077-14"
})(_templateObject14(), ui.theme.typography.fontFamily.chivo, ui.theme.space.x3, ui.theme.colors.neutral[580], ui.theme.space.x1, ui.theme.colors.neutral[999], ui.theme.colors.neutral[350], ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[400]);
var CustomSelect = (0,styled_components_browser_esm/* default */.ZP)(react_select_esm/* default */.ZP).withConfig({
    displayName: "styles__CustomSelect",
    componentId: "sc-d3f87077-15"
})(_templateObject15(), ui.theme.space.x1, ui.theme.colors.neutral[200], ui.theme.colors.primary[200], ui.theme.colors.neutral.white, ui.theme.colors.neutral[200], ui.theme.colors.pink[50], ui.theme.colors.primary[100], ui.theme.colors.neutral[200], ui.theme.colors.neutral[550], ui.theme.colors.primary[250], ui.theme.colors.neutral.white, ui.theme.colors.primary[250], ui.theme.colors.neutral.white);
var WrapperIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperIcon",
    componentId: "sc-d3f87077-16"
})(_templateObject16(), ui.theme.colors.neutral["999-opacity-12"]);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../packages/implementations/index.ts
var implementations = __webpack_require__(32202);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ForgotPassword/NewForgotPassword/data.tsx





var useNewForgotPassword = function() {
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var ref = (0,application/* useAuthentication */.JLf)((0,application/* useShallow */.NL6)(function(state) {
        return {
            changeCurrentStep: state.changeCurrentStep,
            userIdentification: state.userIdentification,
            identificationType: state.identificationType,
            currentStep: state.currentStep
        };
    })), changeCurrentStep = ref.changeCurrentStep, userIdentification = ref.userIdentification, identificationType = ref.identificationType, currentStep = ref.currentStep;
    var ref1 = (0,application/* useTwoFactor */.kD7)((0,application/* useShallow */.NL6)(function(state) {
        return {
            setIsValidationActive: state.setIsValidationActive,
            channelSelected: state.channelSelected,
            setAvailableMethods: state.setAvailableMethods,
            setIsBlockedToSendCode: state.setIsBlockedToSendCode,
            setFaType: state.setFaType,
            getTimer: state.getTimer,
            setClientAction: state.setClientAction,
            setChannelSelected: state.setChannelSelected,
            setCanChooseAnotherTwoFactorMethod: state.setCanChooseAnotherTwoFactorMethod,
            clearTimer: state.clearTimer
        };
    })), setIsValidationActive = ref1.setIsValidationActive, channelSelected = ref1.channelSelected, setAvailableMethods = ref1.setAvailableMethods, setIsBlockedToSendCode = ref1.setIsBlockedToSendCode, setFaType = ref1.setFaType, getTimer = ref1.getTimer, setClientAction = ref1.setClientAction, setChannelSelected = ref1.setChannelSelected, setCanChooseAnotherTwoFactorMethod = ref1.setCanChooseAnotherTwoFactorMethod, clearTimer = ref1.clearTimer;
    // eslint-disable-next-line sonarjs/cognitive-complexity
    var onVerifyIdentity = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, passedUserIdentification, isTheSameIdentification, isTimerRunning, ref15, availableMethods, availableMethodsError, ref16, redirectToChooseAnotherMethod, currentChannel, response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    setFaType(9);
                    setClientAction("forgotPassword");
                    setIsBlockedToSendCode(false);
                    passedUserIdentification = implementations/* securedSessionStorage.getItem */.KT.getItem("userIdentification");
                    isTheSameIdentification = passedUserIdentification === userIdentification;
                    isTimerRunning = getTimer(9, channelSelected).isTimerRunning;
                    if (isTimerRunning && isTheSameIdentification && ((ref = [
                        "forgotPassword",
                        "verifyIdentity"
                    ]) === null || ref === void 0 ? void 0 : ref.includes(currentStep))) {
                        changeCurrentStep("verifyCode");
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        implementations/* identityApi.receiveConfirmationTypesPublic */.IJ.receiveConfirmationTypesPublic({
                            email: identificationType === "email" ? userIdentification : "",
                            cpf: identificationType === "cpf" ? userIdentification : ""
                        })
                    ];
                case 1:
                    ref15 = _state.sent(), availableMethods = ref15.data, availableMethodsError = ref15.error;
                    if (!availableMethods && availableMethodsError || !availableMethods && !availableMethodsError) {
                        ;
                        throw new Error((ref16 = availableMethodsError.errors) === null || ref16 === void 0 ? void 0 : ref16.Messages[0]);
                    }
                    redirectToChooseAnotherMethod = Boolean((availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.emailConfirmed) && (availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumberConfirmed)) || Boolean(!(availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.emailConfirmed) && !(availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumberConfirmed));
                    setAvailableMethods(availableMethods);
                    if (redirectToChooseAnotherMethod) {
                        setIsValidationActive(true);
                        setCanChooseAnotherTwoFactorMethod(true);
                        changeCurrentStep("verifyIdentity");
                        return [
                            2
                        ];
                    }
                    currentChannel = (availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.emailConfirmed) ? 2 : (availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumberConfirmed) ? 1 : 2;
                    setChannelSelected(currentChannel);
                    return [
                        4,
                        implementations/* notificationApi.sendTwoFactorCodePublic */.E8.sendTwoFactorCodePublic({
                            faType: 9,
                            email: identificationType === "email" ? userIdentification : "",
                            cpf: identificationType === "cpf" ? userIdentification : "",
                            channel: currentChannel,
                            phoneNumber: "",
                            token: "",
                            canSendToken: Boolean(availableMethods)
                        })
                    ];
                case 2:
                    response = _state.sent();
                    if (response === null || response === void 0 ? void 0 : (ref1 = response.validationResult) === null || ref1 === void 0 ? void 0 : ref1.isValid) {
                        setIsBlockedToSendCode(false);
                        setIsValidationActive(true);
                        implementations/* securedSessionStorage.setItem */.KT.setItem("userIdentification", userIdentification);
                        changeCurrentStep("verifyCode");
                        return [
                            2
                        ];
                    }
                    if ((response === null || response === void 0 ? void 0 : (ref2 = response.validationResult) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.errors) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.errorMessage) === "Cliente n\xe3o encontrado") {
                        changeCurrentStep("emailFeedback");
                        return [
                            2
                        ];
                    }
                    if ((response === null || response === void 0 ? void 0 : (ref5 = response.validationResult) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.errors) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.errorCode) === "222" || ((ref8 = [
                        "Tente novamente em 24 horas.",
                        "Opera\xe7\xe3o bloqueada devido ao n\xfamero de tentativas excessivas na solicita\xe7\xe3o do c\xf3digo.", 
                    ]) === null || ref8 === void 0 ? void 0 : ref8.includes(String(response === null || response === void 0 ? void 0 : (ref9 = response.validationResult) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.errors) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.errorMessage)))) {
                        clearTimer(9, currentChannel);
                        setIsValidationActive(true);
                        setIsBlockedToSendCode(true);
                        changeCurrentStep("verifyCode");
                        return [
                            2
                        ];
                    }
                    if ((response === null || response === void 0 ? void 0 : (ref12 = response.validationResult) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.errors) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[0]) === null || ref14 === void 0 ? void 0 : ref14.errorCode) === "666") {
                        setIsValidationActive(true);
                        changeCurrentStep("verifyCode");
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    setIsValidationActive(false);
                    addToast({
                        type: "error",
                        title: "N\xe3o foi poss\xedvel processar a solicita\xe7\xe3o.",
                        description: "Verifique as informa\xe7\xf5es inseridas e tente novamente.",
                        isNewToast: true,
                        newToastTheme: "dark",
                        timerInMilliseconds: 7000
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        setFaType,
        setClientAction,
        getTimer,
        channelSelected,
        currentStep,
        identificationType,
        userIdentification,
        setCanChooseAnotherTwoFactorMethod,
        setChannelSelected,
        setAvailableMethods,
        changeCurrentStep,
        setIsBlockedToSendCode,
        setIsValidationActive,
        addToast,
        clearTimer, 
    ]);
    return {
        onVerifyIdentity: onVerifyIdentity
    };
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ForgotPassword/NewForgotPassword/index.tsx














var NewForgotPasswordLogin = function(param) {
    var _useAuthentication = param.useAuthentication, useAuthentication = _useAuthentication === void 0 ? state_manager/* useAuthentication */.JL : _useAuthentication, _useRouter = param.useRouter, useRouter = _useRouter === void 0 ? next_router.useRouter : _useRouter;
    var ref;
    var router = useRouter();
    var ref1 = useAuthentication((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            changeCurrentStep: state.changeCurrentStep,
            setUserIdentification: state.setUserIdentification,
            setIdentificationType: state.setIdentificationType,
            identificationType: state.identificationType
        };
    })), changeCurrentStep = ref1.changeCurrentStep, setUserIdentification = ref1.setUserIdentification, setIdentificationType = ref1.setIdentificationType, identificationType = ref1.identificationType;
    var ref2 = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(identificationType === "email" ? recoverPasswordFormValidateSchema : validateCpfSchema)
    }), register = ref2.register, handleSubmit = ref2.handleSubmit, watch = ref2.watch, setValue = ref2.setValue, _formState = ref2.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, isValidating = _formState.isValidating, isLoading = _formState.isLoading;
    var onVerifyIdentity = useNewForgotPassword().onVerifyIdentity;
    var options = [
        {
            value: "email",
            label: "E-mail"
        },
        {
            value: "cpf",
            label: "CPF"
        }, 
    ];
    var email = watch("recipientEmailForgotPassword");
    var cpf = watch("recipientCPFForgotPassword");
    var isSubmitDisabled = !(email || cpf);
    var emailErrorMessage = errors === null || errors === void 0 ? void 0 : (ref = errors.recipientEmailForgotPassword) === null || ref === void 0 ? void 0 : ref.message;
    var checkEmailErrorMessage = !isSubmitDisabled && emailErrorMessage && email;
    (0,react.useEffect)(function() {
        if (identificationType === "email") {
            setUserIdentification(email);
            return;
        }
        setUserIdentification(cpf);
    }, [
        identificationType,
        email,
        cpf,
        setUserIdentification
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPasswordContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("forgot-password-container")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPasswordWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("forgot-password-wrapper")), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ForgotPasswordContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("forgot-password-content")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentInformation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("content-information")), {
                        children: [
                            (router === null || router === void 0 ? void 0 : router.pathname) !== "/login" && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                onClick: function() {
                                    return changeCurrentStep("login");
                                }
                            }, (0,application/* buildTestIds */.Fek)("forgot-password-back-button")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon, {})
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecoverAccessText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recover-access-text")), {
                                children: "Esqueceu sua senha?"
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecoverInfoText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recover-info-text")), {
                        children: "Vamos enviar um c\xf3digo de recupera\xe7\xe3o para o e-mail ou CPF inserido abaixo."
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("forgot-password-form-container")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("forgot-password-select-wrapper")), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelSelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("label-recipient-forgot-password")), {
                                        children: "Modo de identifica\xe7\xe3o"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect, {
                                        autoFocus: false,
                                        blurInputOnSelect: false,
                                        isSearchable: false,
                                        instanceId: 1,
                                        options: options,
                                        defaultValue: options === null || options === void 0 ? void 0 : options.find(function(option) {
                                            return (option === null || option === void 0 ? void 0 : option.value) === identificationType;
                                        }),
                                        classNamePrefix: "react-select",
                                        onChange: function(choice) {
                                            var selectedOption = choice;
                                            if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) {
                                                setIdentificationType(selectedOption.value);
                                            }
                                        }
                                    })
                                ]
                            })),
                            identificationType === "email" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelSelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("email-label")), {
                                        children: "Digite seu E-mail"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("input-recipient-email-forgot-password")), {
                                        id: "recipientEmailForgotPassword",
                                        name: "recipientEmailForgotPassword",
                                        register: register,
                                        type: "text",
                                        inputMode: "email",
                                        placeholder: "Digite seu e-mail",
                                        hasError: checkEmailErrorMessage,
                                        onChange: function(param) {
                                            var target = param.target;
                                            return setValue("recipientEmailForgotPassword", target.value);
                                        },
                                        height: "40px",
                                        textError: emailErrorMessage,
                                        width: "100%",
                                        padding: "".concat(ui.theme.space.x3),
                                        paddingErrorMessage: "".concat(ui.theme.space.x0),
                                        margin: "0px",
                                        fontSize: "".concat(ui.theme.typography.fontSize.sm.x5),
                                        borderRadius: "".concat(ui.theme.space.x1)
                                    }))
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelSelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("cpf-label")), {
                                        children: "Digite seu CPF"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("input-recipient-cpf-forgot-password")), {
                                        id: "recipientCPFForgotPassword",
                                        name: "recipientCPFForgotPassword",
                                        register: register,
                                        type: "tel",
                                        mask: "999.999.999-99",
                                        onChange: function(param) {
                                            var target = param.target;
                                            return setValue("recipientCPFForgotPassword", target.value.replace(/[^0-9]/g, ""));
                                        },
                                        placeholder: "Digite seu CPF",
                                        hasError: !!(0,application/* validateCpf */.cyc)(cpf) && (cpf === null || cpf === void 0 ? void 0 : cpf.length) === 11,
                                        height: "40px",
                                        textError: "CPF inv\xe1lido",
                                        width: "100%",
                                        padding: "".concat(ui.theme.space.x3),
                                        paddingErrorMessage: "".concat(ui.theme.space["x0.5"], " ").concat(ui.theme.space.x0, " ").concat(ui.theme.space.x0),
                                        margin: "0px",
                                        fontSize: "".concat(ui.theme.typography.fontSize.sm.x5),
                                        borderRadius: "".concat(ui.theme.space.x1)
                                    }))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSubmit/* ButtonSubmit */.G, (0,_object_spread/* default */.Z)({
                                text: "Continuar",
                                onClickAction: handleSubmit(onVerifyIdentity),
                                isDisabled: isSubmitDisabled,
                                minWidth: "100%",
                                height: "37px",
                                fontWeight: 500,
                                borderRadius: "8px",
                                margin: "24px 0px 0px",
                                underAction: isSubmitting || isValidating || isLoading,
                                color: "".concat(ui.theme.colors.secondary[380]),
                                hoveredColor: "".concat(ui.theme.colors.secondary[350])
                            }, (0,application/* buildTestIds */.Fek)("button-submit-forgot-password")))
                        ]
                    }))
                ]
            }))
        }))
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ForgotPassword/OldForgotPassword/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 2rem;\n  border-radius: ",
        ";\n  max-width: 360px;\n  margin: 0 auto;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start !important;\n  width: 100%;\n  padding: ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 126px;\n  height: 3.35rem;\n  display: flex;\n  align-items: center;\n  padding: 0 1rem;\n  border-radius: 4px;\n  justify-content: center;\n  border: 1px solid ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 0;\n  height: 3.35rem;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  letter-spacing: -0.24px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        " !important;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n\n  &::placeholder {\n    color: ",
        " !important;\n  }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  margin: 0 !important;\n\n  @media ",
        " {\n    padding-top: ",
        ";\n  }\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  box-shadow: 0px 2px 2px ",
        ";\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: ",
        ";\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  gap: 2rem;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 3.35rem;\n  font-family: ",
        ";\n  padding-left: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  background: transparent;\n  color: ",
        ";\n\n  &::placeholder {\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  &::-ms-reveal,\n  &::-ms-clear {\n    display: none;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 2px;\n  justify-content: center;\n  font-size: ",
        ";\n  color: ",
        " !important;\n  font-weight: ",
        ";\n  text-align: center;\n\n  @media ",
        " {\n    flex-wrap: wrap;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  color: ",
        " !important;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        " !important;\n  margin-top: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: start;\n  font-size: ",
        ";\n  color: ",
        " !important;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 126px;\n  height: 3.35rem;\n\n  > * {\n    box-shadow: none !important;\n    border-radius: ",
        ";\n    cursor: pointer;\n  }\n\n  .react-select__control {\n    border-color: ",
        ";\n    cursor: pointer;\n  }\n\n  .react-select__menu {\n    margin-top: 0;\n  }\n\n  .react-select__option {\n    border-radius: 4px;\n    color: ",
        " !important;\n    cursor: pointer;\n    background-color: ",
        ";\n  }\n\n  .react-select__control:hover {\n    border-color: ",
        ";\n  }\n\n  .react-select__option:hover {\n    background-color: ",
        ";\n    color: ",
        " !important;\n    border-color: ",
        ";\n  }\n\n  .react-select__single-value {\n    color: ",
        " !important;\n  }\n\n  .react-select__option--is-selected {\n    background-color: ",
        ";\n    color: ",
        " !important;\n  }\n\n  .react-select__option--is-selected:hover {\n    background-color: ",
        ";\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}




var styles_ForgotPasswordWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ForgotPasswordWrapper",
    componentId: "sc-a8ed192f-0"
})(styles_templateObject(), ui.theme.space.x4);
var ForgotPasswordHeaderWrapper = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    displayName: "styles__ForgotPasswordHeaderWrapper",
    componentId: "sc-a8ed192f-1"
})(styles_templateObject1(), function(param) {
    var withoutPadding = param.withoutPadding;
    return withoutPadding ? "0 !important" : "0 0.75rem !important";
});
var styles_SelectIdentificationType = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    displayName: "styles__SelectIdentificationType",
    componentId: "sc-a8ed192f-2"
})(styles_templateObject2(), ui.theme.colors.neutral[580]);
var styles_TypeOption = styled_components_browser_esm/* default.option.withConfig */.ZP.option.withConfig({
    displayName: "styles__TypeOption",
    componentId: "sc-a8ed192f-3"
})(styles_templateObject3());
var styles_SelectWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SelectWrapper",
    componentId: "sc-a8ed192f-4"
})(styles_templateObject4(), ui.theme.space.x1);
var styles_LabelSelect = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "styles__LabelSelect",
    componentId: "sc-a8ed192f-5"
})(styles_templateObject5(), ui.theme.typography.fontFamily.roboto, ui.theme.typography.fontSize.sm.x7, ui.theme.typography.fontWeight[400], ui.theme.colors.neutral[750]);
var styles_StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Form/* Input */.II).withConfig({
    displayName: "styles__StyledInput",
    componentId: "sc-a8ed192f-6"
})(styles_templateObject6(), ui.theme.colors.neutral[550], ui.theme.colors.neutral[350]);
var styles_ForgotPasswordContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ForgotPasswordContainer",
    componentId: "sc-a8ed192f-7"
})(styles_templateObject7(), ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x4);
var styles_WrapperIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperIcon",
    componentId: "sc-a8ed192f-8"
})(styles_templateObject8(), ui.theme.colors.neutral["999-opacity-12"]);
var styles_ContentInformation = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__ContentInformation",
    componentId: "sc-a8ed192f-9"
})(styles_templateObject9(), ui.theme.space["x2.5"]);
var RecoverPasswordInformation = (0,styled_components_browser_esm/* default */.ZP)(styles_ContentInformation).withConfig({
    displayName: "styles__RecoverPasswordInformation",
    componentId: "sc-a8ed192f-10"
})(styles_templateObject10(), ui.theme.space.x4);
var styles_ArrowLeftIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowLeftIcon).attrs({
    height: "15px",
    width: "15px",
    color: ui.theme.colors.neutral[600]
}).withConfig({
    displayName: "styles__ArrowLeftIcon",
    componentId: "sc-a8ed192f-11"
})(styles_templateObject11());
var styles_FormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FormContainer",
    componentId: "sc-a8ed192f-12"
})(styles_templateObject12());
var styles_FormForgotPassword = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "styles__FormForgotPassword",
    componentId: "sc-a8ed192f-13"
})(styles_templateObject13());
var styles_ForgotPasswordContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ForgotPasswordContent",
    componentId: "sc-a8ed192f-14"
})(styles_templateObject14(), styles_FormForgotPassword);
var styles_RecoverAccessText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__RecoverAccessText",
    componentId: "sc-a8ed192f-15"
})(styles_templateObject15(), ui.theme.colors.neutral[550], ui.theme.typography.fontSize.sm.x9, ui.theme.typography.fontFamily.roboto, ui.theme.typography.fontWeight.bold);
var styles_RecoverInfoText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__RecoverInfoText",
    componentId: "sc-a8ed192f-16"
})(styles_templateObject16(), ui.theme.colors.neutral[550], ui.theme.typography.fontFamily.roboto, ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[400]);
var styles_InputForgotPassword = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "styles__InputForgotPassword",
    componentId: "sc-a8ed192f-17"
})(_templateObject17(), ui.theme.typography.fontFamily.chivo, ui.theme.space.x3, ui.theme.colors.neutral[580], ui.theme.space.x1, ui.theme.colors.neutral[999], ui.theme.colors.neutral[350], ui.theme.typography.fontSize.sm.x5, ui.theme.typography.fontWeight[400]);
var CreateAccount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CreateAccount",
    componentId: "sc-a8ed192f-18"
})(_templateObject18(), ui.theme.typography.fontSize.sm.x3, ui.theme.colors.neutral[550], ui.theme.typography.fontWeight[400], ui.theme.device.desktopFirst.mobileXL);
var CreateAccountLink = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__CreateAccountLink",
    componentId: "sc-a8ed192f-19"
})(_templateObject19(), ui.theme.colors.neutral[550]);
var TitleInformation = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TitleInformation",
    componentId: "sc-a8ed192f-20"
})(_templateObject20(), ui.theme.typography.fontSize.sm.x9, ui.theme.typography.fontWeight.bold, ui.theme.colors.neutral[550], ui.theme.space.x1);
var ContentInformationText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__ContentInformationText",
    componentId: "sc-a8ed192f-21"
})(_templateObject21(), ui.theme.typography.fontSize.sm.x5, ui.theme.colors.neutral[550]);
var styles_CustomSelect = (0,styled_components_browser_esm/* default */.ZP)(react_select_esm/* default */.ZP).withConfig({
    displayName: "styles__CustomSelect",
    componentId: "sc-a8ed192f-22"
})(_templateObject22(), ui.theme.space.x1, ui.theme.colors.neutral[200], ui.theme.colors.primary[200], ui.theme.colors.neutral.white, ui.theme.colors.neutral[200], ui.theme.colors.pink[50], ui.theme.colors.primary[100], ui.theme.colors.neutral[200], ui.theme.colors.neutral[550], ui.theme.colors.primary[250], ui.theme.colors.neutral.white, ui.theme.colors.primary[250], ui.theme.colors.neutral.white);
var AlmostThereContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__AlmostThereContainer",
    componentId: "sc-a8ed192f-23"
})(_templateObject23(), ui.theme.space.x4);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ForgotPassword/OldForgotPassword/schema/index.tsx


var schema_recoverPasswordFormValidateSchema = lib/* object */.Ry({
    recipientEmailForgotPassword: lib/* string */.Z_().min(11, {
        message: "O valor de caracteres deve ser no m\xednimo 11"
    }).email({
        message: "E-mail n\xe3o \xe9 v\xe1lido"
    })
});
var schema_validateCpfSchema = lib/* object */.Ry({
    recipientCPFForgotPassword: lib/* string */.Z_().superRefine(function(value, context) {
        var response = (0,application/* validateCpf */.cyc)(value);
        var received = response;
        if (response) context.addIssue({
            code: "invalid_type",
            expected: "string",
            received: received,
            message: "".concat(response)
        });
    })
});

// EXTERNAL MODULE: ../../packages/components/Link/index.tsx
var Link = __webpack_require__(17335);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ForgotPassword/OldForgotPassword/index.tsx
















var OldForgotPasswordLogin = function() {
    var ref;
    var ref1 = (0,react.useState)("email"), identificationType = ref1[0], setIdentificationType = ref1[1];
    var ref2 = (0,react.useState)(false), isSubmittingEmail = ref2[0], setIsSubmittingEmail = ref2[1];
    var ref3 = (0,react.useState)(false), isEmailSent = ref3[0], setIsEmailSent = ref3[1];
    var changeCurrentStep = (0,state_manager/* useAuthentication */.JL)((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            changeCurrentStep: state.changeCurrentStep
        };
    })).changeCurrentStep;
    var options = [
        {
            value: "email",
            label: "E-mail"
        },
        {
            value: "cpf",
            label: "CPF"
        }, 
    ];
    var ref4 = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(identificationType === "email" ? schema_recoverPasswordFormValidateSchema : schema_validateCpfSchema)
    }), register = ref4.register, handleSubmit = ref4.handleSubmit, watch = ref4.watch, setValue = ref4.setValue, errors = ref4.formState.errors;
    var email = watch("recipientEmailForgotPassword");
    var cpf = watch("recipientCPFForgotPassword");
    var isSubmitDisabled = !(email || cpf);
    var onRequestRecoverPassword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(identificationType === "email")) return [
                            3,
                            2
                        ];
                        setIsSubmittingEmail(true);
                        return [
                            4,
                            implementations/* identityApi.recoverPassword */.IJ.recoverPassword(email).then(function() {
                                setIsEmailSent(true);
                            }).catch(function() {
                                setIsEmailSent(false);
                            }).finally(function() {
                                setIsSubmittingEmail(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        setIsSubmittingEmail(true);
                        return [
                            4,
                            implementations/* identityApi.recoverPassword */.IJ.recoverPassword(cpf).then(function() {
                                setIsEmailSent(true);
                            }).catch(function() {
                                setIsEmailSent(false);
                            }).finally(function() {
                                setIsSubmittingEmail(false);
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onRequestRecoverPassword() {
            return _ref.apply(this, arguments);
        };
    }();
    var emailErrorMessage = errors === null || errors === void 0 ? void 0 : (ref = errors.recipientEmailForgotPassword) === null || ref === void 0 ? void 0 : ref.message;
    var checkEmailErrorMessage = !isSubmitDisabled && emailErrorMessage && email;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ForgotPasswordContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("forgot-password-container")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ForgotPasswordWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("forgot-password-wrapper")), {
            children: !isEmailSent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_ForgotPasswordContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("forgot-password-content")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_ContentInformation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("content-information")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_RecoverAccessText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recover-access-text")), {
                                children: "Recupere o acesso \xe0 sua conta"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_RecoverInfoText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recover-info-text")), {
                                children: "Digite o seu e-mail ou CPF para continuar."
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_FormContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("forgot-password-form-container")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_SelectWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("forgot-password-select-wrapper")), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_LabelSelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("label-recipient-forgot-password")), {
                                        children: "Modo de identifica\xe7\xe3o"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CustomSelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("forgot-password-select")), {
                                        autoFocus: false,
                                        blurInputOnSelect: false,
                                        isSearchable: false,
                                        instanceId: 1,
                                        options: options,
                                        defaultValue: options[0],
                                        classNamePrefix: "react-select",
                                        onChange: function(choice) {
                                            var selectedOption = choice;
                                            if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) {
                                                setIdentificationType(selectedOption.value);
                                            }
                                        }
                                    }))
                                ]
                            })),
                            identificationType === "email" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("input-recipient-email-forgot-password")), {
                                id: "recipientEmailForgotPassword",
                                name: "recipientEmailForgotPassword",
                                register: register,
                                type: "text",
                                inputMode: "email",
                                placeholder: "Digite seu e-mail",
                                hasError: checkEmailErrorMessage,
                                onChange: function(param) {
                                    var target = param.target;
                                    return setValue("recipientEmailForgotPassword", target.value);
                                },
                                height: "45px",
                                textError: emailErrorMessage,
                                width: "100%",
                                padding: "".concat(ui.theme.space.x3),
                                paddingErrorMessage: "".concat(ui.theme.space.x0),
                                margin: "0px",
                                fontSize: "".concat(ui.theme.typography.fontSize.sm.x5),
                                borderRadius: "".concat(ui.theme.space.x1)
                            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("input-recipient-cpf-forgot-password")), {
                                id: "recipientCPFForgotPassword",
                                name: "recipientCPFForgotPassword",
                                register: register,
                                type: "tel",
                                mask: "999.999.999-99",
                                onChange: function(param) {
                                    var target = param.target;
                                    return setValue("recipientCPFForgotPassword", target.value.replace(/[^0-9]/g, ""));
                                },
                                placeholder: "Digite seu CPF",
                                hasError: !!(0,application/* validateCpf */.cyc)(cpf) && (cpf === null || cpf === void 0 ? void 0 : cpf.length) === 11,
                                height: "45px",
                                textError: "CPF inv\xe1lido",
                                width: "100%",
                                padding: "".concat(ui.theme.space.x3),
                                paddingErrorMessage: "".concat(ui.theme.space["x0.5"], " ").concat(ui.theme.space.x0, " ").concat(ui.theme.space.x0),
                                margin: "0px",
                                fontSize: "".concat(ui.theme.typography.fontSize.sm.x5),
                                borderRadius: "".concat(ui.theme.space.x1)
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSubmit/* ButtonSubmit */.G, (0,_object_spread/* default */.Z)({
                                text: "Enviar",
                                textUnderAction: "Enviando...",
                                onClickAction: handleSubmit(onRequestRecoverPassword),
                                underAction: isSubmittingEmail,
                                isDisabled: isSubmitDisabled || isSubmittingEmail,
                                minWidth: "100%",
                                height: "37px",
                                fontWeight: 500,
                                borderRadius: "8px",
                                color: "".concat(ui.theme.colors.secondary[380]),
                                hoveredColor: "".concat(ui.theme.colors.secondary[350])
                            }, (0,application/* buildTestIds */.Fek)("button-submit-forgot-password"))),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CreateAccount, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("create-account-container")), {
                                children: [
                                    "Ainda n\xe3o tem uma conta?",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateAccountLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("create-account-link")), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            fontSize: "1rem",
                                            href: "/cadastro",
                                            target: "_self",
                                            children: "Crie uma conta"
                                        })
                                    }))
                                ]
                            }))
                        ]
                    }))
                ]
            })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlmostThereContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("forgot-password-content")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_WrapperIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        onClick: function() {
                            return changeCurrentStep("login");
                        }
                    }, (0,application/* buildTestIds */.Fek)("forgot-password-back-button")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ArrowLeftIcon, {})
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecoverPasswordInformation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("content-information-recover-password")), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleInformation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-information-recover-password")), {
                                children: "Quase l\xe1!"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentInformationText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("content-information-text")), {
                                children: "Se os dados estiverem corretos, n\xf3s enviaremos um e-mail com as instru\xe7\xf5es para voc\xea acessar sua conta."
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentInformationText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("content-information-text")), {
                                children: "Lembra de conferir o lixo eletr\xf4nico :)"
                            }))
                        ]
                    }))
                ]
            }))
        }))
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ForgotPassword/index.tsx





var ForgotPasswordLogin = function(param) {
    var _useAuthentication = param.useAuthentication, useAuthentication = _useAuthentication === void 0 ? state_manager/* useAuthentication */.JL : _useAuthentication, _useRouter = param.useRouter, useRouter = _useRouter === void 0 ? next_router.useRouter : _useRouter;
    var allConfigs = (0,state_manager/* useEnvs */.HS)().allConfigs;
    return (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isNewForgotPasswordFlowAvailable) === "true" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewForgotPasswordLogin, {
        useAuthentication: useAuthentication,
        useRouter: useRouter
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OldForgotPasswordLogin, {});
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/schema/index.tsx

var authPropsFormValidateSchema = lib/* object */.Ry({
    login: lib/* string */.Z_().min(11, {
        message: "\xc9 requerido no m\xednimo 11 caracteres"
    }),
    password: lib/* string */.Z_().min(6, {
        message: "\xc9 requerido no m\xednimo 6 caracteres"
    })
});

// EXTERNAL MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/styles.ts
var Login_styles = __webpack_require__(94340);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/Login/index.tsx















var Login = function(param) {
    var isMyCartPage = param.isMyCartPage, loginMode = param.loginMode;
    var ref;
    var ref1 = (0,react.useState)(false), isUserAuthenticating = ref1[0], setIsUserAuthenticating = ref1[1];
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var ref2 = (0,react.useState)("password"), typeInputPassword = ref2[0], setTypeInputPassword = ref2[1];
    var ref3 = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(authPropsFormValidateSchema)
    }), register = ref3.register, handleSubmit = ref3.handleSubmit, resetForm = ref3.reset, watch = ref3.watch;
    var ref4 = (0,application/* useAuth */.aCi)(), getTokens = ref4.getTokens, onAuthenticateUser = ref4.onAuthenticateUser, onAuthenticateUserOAuth = ref4.onAuthenticateUserOAuth, isAuthenticated = ref4.isAuthenticated;
    var ref5 = (0,application/* useAuthentication */.JLf)((0,application/* useShallow */.NL6)(function(state) {
        return {
            changeCurrentStep: state.changeCurrentStep,
            setUserIdentification: state.setUserIdentification,
            setIdentificationType: state.setIdentificationType,
            setChangePasswordDueToPurchase: state.setChangePasswordDueToPurchase
        };
    })), changeCurrentStep = ref5.changeCurrentStep, setUserIdentification = ref5.setUserIdentification, setIdentificationType = ref5.setIdentificationType, setChangePasswordDueToPurchase = ref5.setChangePasswordDueToPurchase;
    var ref6 = (0,application/* useAppContext */.bp4)(), setIsOpenedDropdownUser = ref6.setIsOpenedDropdownUser, isClientTablet = ref6.isClientTablet;
    var accessToken = (ref = getTokens()) === null || ref === void 0 ? void 0 : ref.token;
    var ref7 = (0,react.useState)(false), isHovered = ref7[0], setIsHovered = ref7[1];
    var authContentContainerRef = (0,react.useRef)(null);
    var formRef = (0,react.useRef)(null);
    var error = implementations/* profileApi.getClient */.c_.getClient(accessToken, !!accessToken).error;
    if (error) {
        implementations/* appMonitoringClient.captureException */.pE.captureException(error);
    }
    var textLogin = watch("login");
    var textPassword = watch("password");
    var isFormInvalid = !!((textLogin === null || textLogin === void 0 ? void 0 : textLogin.length) < 11 || (textPassword === null || textPassword === void 0 ? void 0 : textPassword.length) < 6);
    var router = (0,next_router.useRouter)();
    var isLoginPage = loginMode === "page";
    var paymentRoute = "/checkout/pagamento";
    var cartRoute = "/checkout/meu-carrinho";
    var resetLoginForm = (0,react.useCallback)(function() {
        resetForm();
    }, [
        resetForm
    ]);
    var handleFinishOrder = (0,react.useCallback)(function() {
        // if (!userData?.email_verified) {
        //   handleOpenModalToConfirmEmail(String(router?.route || cartRoute));
        //   sendOrResendEmailConfirmation(userData?.email);
        //   return;
        // }
        router.push(paymentRoute);
    }, [
        // handleOpenModalToConfirmEmail,
        router, 
    ]);
    var handleAuthenticateUser = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var login, password, formattedLogin, verifyClient, token, _tmp, _;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        login = param.login, password = param.password;
                        formattedLogin = RegExp(application/* validEmailRegex */.C2y).exec(login) ? login : RegExp(application/* validCpfRegex */.nlr).exec(login) ? login === null || login === void 0 ? void 0 : login.replace(/[.-]/g, "") : login === null || login === void 0 ? void 0 : login.replace(/\D/g, "");
                        return [
                            4,
                            implementations/* profileApi.passwordChangeDuePurchaseTime */.c_.passwordChangeDuePurchaseTime(formattedLogin)
                        ];
                    case 1:
                        verifyClient = _state.sent();
                        setIsUserAuthenticating(true);
                        if (verifyClient === null || verifyClient === void 0 ? void 0 : verifyClient.clientNeedUpdatePassword) {
                            setUserIdentification(login);
                            setIdentificationType("email");
                            changeCurrentStep("changePasswordDuePurchaseTime");
                            setChangePasswordDueToPurchase(true);
                            return [
                                2
                            ];
                        }
                        _tmp = {
                            login: formattedLogin,
                            password: password
                        };
                        _ = JSON.stringify;
                        return [
                            4,
                            (0,application/* getGeolocation */.Yt8)()
                        ];
                    case 2:
                        return [
                            4,
                            onAuthenticateUser.apply(void 0, [
                                (_tmp.location = _.apply(JSON, [
                                    _state.sent()
                                ]), _tmp)
                            ])
                        ];
                    case 3:
                        token = _state.sent();
                        setChangePasswordDueToPurchase(false);
                        if (!isAuthenticated && !token) {
                            addToast({
                                title: "Credenciais  Inv\xe1lidas",
                                type: "error"
                            });
                            setIsUserAuthenticating(false);
                            return [
                                2
                            ];
                        }
                        if (isMyCartPage) {
                            handleFinishOrder();
                            return [
                                2
                            ];
                        }
                        setIsUserAuthenticating(false);
                        resetLoginForm();
                        setIsOpenedDropdownUser(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onAuthenticateUser,
        setChangePasswordDueToPurchase,
        isAuthenticated,
        isMyCartPage,
        resetLoginForm,
        setIsOpenedDropdownUser,
        setUserIdentification,
        setIdentificationType,
        changeCurrentStep,
        addToast,
        handleFinishOrder, 
    ]);
    var handleManagementInputPasswordType = (0,react.useCallback)(function(type) {
        setTypeInputPassword(type);
    }, []);
    var handleAuthenticateUserOAuth = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(type) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onAuthenticateUserOAuth(type)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(type) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onAuthenticateUserOAuth
    ]);
    var handleMouseEnter = (0,react.useCallback)(function() {
        setIsHovered(true);
    }, []);
    var handleMouseLeave = (0,react.useCallback)(function() {
        setIsHovered(false);
    }, []);
    var handleForgotPasswordComponent = (0,react.useCallback)(function() {
        changeCurrentStep("forgotPassword");
        setChangePasswordDueToPurchase(false);
    }, [
        changeCurrentStep,
        setChangePasswordDueToPurchase
    ]);
    var handleNavigation = (0,react.useCallback)(function(currentRouter) {
        if ((currentRouter === null || currentRouter === void 0 ? void 0 : currentRouter.pathname) === cartRoute && isMyCartPage) {
            currentRouter.push({
                pathname: "/cadastro",
                query: {
                    redirectTo: paymentRoute
                }
            });
            return;
        }
        currentRouter.push("/cadastro");
    }, [
        isMyCartPage
    ]);
    (0,react.useEffect)(function() {
        if (formRef === null || formRef === void 0 ? void 0 : formRef.current) {
            formRef.current.focus();
        }
    }, []);
    var handleOnPressEnter = (0,react.useCallback)(function(event) {
        if ((event === null || event === void 0 ? void 0 : event.key) === "Enter") {
            event.preventDefault();
            handleSubmit(handleAuthenticateUser)();
        }
    }, [
        handleSubmit,
        handleAuthenticateUser
    ]);
    var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
        return state.allConfigs;
    });
    var isAppleOAuthEnabled = (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isAppleAuthButtonAvailable) === "true";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Login_styles/* AuthContentContainer */.nf, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: authContentContainerRef,
        isPageLogin: isLoginPage
    }, (0,application/* buildTestIds */.Fek)(isLoginPage ? "page-auth-container" : "modal-auth-container")), {
        children: [
            isMyCartPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Login_styles/* CartContent */.Oy, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("cart-content-auth-container")), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* CompleteOrderText */.FM, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("complete-order-text-auth-container")), {
                        children: "Para concluir o pedido"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* LoginText */.RR, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("login-text-auth-container")), {
                        children: "Entre na sua conta"
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* AuthenticationWrapper */.lF, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Login_styles/* WrapperOAuthButtons */.eC, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* ButtonAuthenticationOAuth */.dd, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            type: "button",
                            typeAuthentication: "Google",
                            onClick: function() {
                                return handleAuthenticateUserOAuth("google");
                            }
                        }, (0,application/* buildTestIds */.Fek)("button-auth-google")), {
                            isUserAuthenticating: isUserAuthenticating,
                            // disabled={
                            //   checkIfTheCustomerIsNotARobotSignIn || isUserAuthenticating
                            // }
                            disabled: isUserAuthenticating,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* GoogleOAuthIcon */.iJ, {})
                        })),
                        isAppleOAuthEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* ButtonAuthenticationOAuth */.dd, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            type: "button",
                            onMouseEnter: handleMouseEnter,
                            onMouseLeave: handleMouseLeave,
                            typeAuthentication: "Apple",
                            onClick: function() {
                                return handleAuthenticateUserOAuth("apple");
                            }
                        }, (0,application/* buildTestIds */.Fek)("button-auth-apple")), {
                            isUserAuthenticating: isUserAuthenticating,
                            // disabled={
                            //   checkIfTheCustomerIsNotARobotSignIn || isUserAuthenticating
                            // }
                            disabled: isUserAuthenticating,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* AppleOAuthIcon */.Xk, {
                                isHovered: isHovered
                            })
                        }))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Login_styles/* WrapperDivider */.Wb, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* LoginDivider */.Us, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* OptionText */.zp, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("other-auth-options-text")), {
                        children: "OU"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* LoginDivider */.Us, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Login_styles/* FormContainer */.Yb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("form-container")), {
                ref: formRef,
                onKeyDown: handleOnPressEnter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Login_styles/* WrapperRow */.oF, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* LabelCustom */.z4, {
                                htmlFor: "login",
                                text: "E-mail ou CPF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* InputAuth */.s5, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                id: "login",
                                type: "text"
                            }, (0,application/* buildTestIds */.Fek)("input-email-login")), {
                                role: "presentation",
                                autoComplete: "off",
                                inputMode: "email",
                                /**
             * carlos.lins no mobile inicia com o teclado de número impossibilitando
             * entrar com email caso o usuário desejar por enquanto vamos comentar e
             * deixar o text por enquanto
             */ // type={textLogin.includes("@") ? "email" : "tel"}
                                placeholder: "Digite seu e-mail ou CPF",
                                minLength: 11
                            }), register("login")), {
                                // onChange={(e) => setTextLogin(e.target.value)}
                                disabled: isUserAuthenticating
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Login_styles/* WrapperRow */.oF, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* LabelCustom */.z4, {
                                htmlFor: "password",
                                text: "Senha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Login_styles/* PasswordContainer */.on, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* InputAuth */.s5, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        id: "password",
                                        height: "40px",
                                        type: typeInputPassword !== null && typeInputPassword !== void 0 ? typeInputPassword : "password"
                                    }, (0,application/* buildTestIds */.Fek)("input-password-login")), {
                                        role: "presentation",
                                        autoComplete: "off",
                                        placeholder: "Digite sua senha",
                                        hasIcon: true,
                                        minLength: 6
                                    }), register("password")), {
                                        // onChange={(e) => setTextPassword(e.target.value)}
                                        disabled: isUserAuthenticating
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* ContainerIconEye */.Ze, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("container-icon-eye")), {
                                        onClick: function() {
                                            return handleManagementInputPasswordType(typeInputPassword === "password" ? "text" : "password");
                                        },
                                        children: typeInputPassword === "text" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* EyeOpenIcon */.hs, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* EyeCloseIcon */.JP, {})
                                    }))
                                ]
                            })
                        ]
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Login_styles/* AccessAction */.F2, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSubmit/* ButtonSubmit */.G, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        text: "Entrar",
                        textUnderAction: "Entrando...",
                        underAction: isUserAuthenticating
                    }, (0,application/* buildTestIds */.Fek)("button-submit-login")), {
                        buttonType: "submit",
                        onClickAction: handleSubmit(handleAuthenticateUser),
                        isDisabled: isFormInvalid,
                        // isDisabled={checkIfTheCustomerIsNotARobotSignIn || isFormInvalid}
                        fontSize: "".concat(ui.theme.typography.fontSize.sm.x5),
                        minWidth: "100%",
                        height: isClientTablet ? "37px" : "45px",
                        fontWeight: 500,
                        borderRadius: "4px",
                        color: "".concat(ui.theme.colors.secondary[380]),
                        hoveredColor: "".concat(ui.theme.colors.secondary[350])
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui.FlexContainer, {
                        flexDirection: "row",
                        alignSelf: "stretch",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* LinkCustom */.d4, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                onClick: function() {
                                    return handleNavigation(router);
                                }
                            }, (0,application/* buildTestIds */.Fek)("sign-up-link")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* LinkText */.u6, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("sign-up-link-text")), {
                                    children: "Criar conta"
                                }))
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_styles/* TitleForgotPassword */.sg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                isMyCartPage: isMyCartPage,
                                onClick: handleForgotPasswordComponent,
                                onKeyDown: handleForgotPasswordComponent,
                                role: "presentation"
                            }, (0,application/* buildTestIds */.Fek)("forgot-password-text")), {
                                children: "Esqueci minha senha"
                            }))
                        ]
                    })
                ]
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/components/ChangePasswordFeedback/styles.ts

function ChangePasswordFeedback_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        " !important;\n"
    ]);
    ChangePasswordFeedback_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChangePasswordFeedback_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: start;\n  font-size: ",
        ";\n  color: ",
        " !important;\n"
    ]);
    ChangePasswordFeedback_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ChangePasswordFeedback_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  max-width: 360px;\n  margin: 0 auto;\n\n  @media ",
        " {\n    max-width: 100%;\n    padding: ",
        " ",
        ";\n  }\n"
    ]);
    ChangePasswordFeedback_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ChangePasswordFeedback_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  box-shadow: 0px 2px 2px ",
        ";\n"
    ]);
    ChangePasswordFeedback_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ChangePasswordFeedback_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    ChangePasswordFeedback_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ChangePasswordFeedback_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: ",
        ";\n"
    ]);
    ChangePasswordFeedback_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ChangePasswordFeedback_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ChangePasswordFeedback_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ChangePasswordFeedback_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 45px;\n  padding: ",
        " ",
        ";\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  font-size: ",
        ";\n  color: ",
        " !important;\n  transition: background-color 0.5s ease-in-out;\n\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    ChangePasswordFeedback_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ChangePasswordFeedback_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    ChangePasswordFeedback_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ChangePasswordFeedback_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  box-shadow: 0px 2px 2px ",
        ";\n"
    ]);
    ChangePasswordFeedback_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var styles_TitleInformation = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TitleInformation",
    componentId: "sc-efab7a56-0"
})(ChangePasswordFeedback_styles_templateObject(), ui.theme.typography.fontSize.sm.x9, ui.theme.typography.fontWeight.bold, ui.theme.colors.neutral[550]);
var styles_ContentInformationText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__ContentInformationText",
    componentId: "sc-efab7a56-1"
})(ChangePasswordFeedback_styles_templateObject1(), ui.theme.typography.fontSize.sm.x5, ui.theme.colors.neutral[550]);
var ChangePasswordFeedbackContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ChangePasswordFeedbackContainer",
    componentId: "sc-efab7a56-2"
})(ChangePasswordFeedback_styles_templateObject2(), ui.theme.space.x4, ui.theme.device.desktopFirst.mobileXL, ui.theme.space.x0, ui.theme.space.x6);
var ChangePasswordFeedback_styles_WrapperIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperIcon",
    componentId: "sc-efab7a56-3"
})(ChangePasswordFeedback_styles_templateObject3(), ui.theme.colors.neutral["999-opacity-25"]);
var ChangePasswordFeedback_styles_ContentInformation = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__ContentInformation",
    componentId: "sc-efab7a56-4"
})(ChangePasswordFeedback_styles_templateObject4(), ui.theme.space["x2.5"]);
var ChangePasswordFeedbackInformation = (0,styled_components_browser_esm/* default */.ZP)(ChangePasswordFeedback_styles_ContentInformation).withConfig({
    displayName: "styles__ChangePasswordFeedbackInformation",
    componentId: "sc-efab7a56-5"
})(ChangePasswordFeedback_styles_templateObject5(), ui.theme.space.x6);
var ChangePasswordFeedback_styles_ArrowLeftIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowLeft).attrs({
    height: "15px",
    width: "15px",
    color: ui.theme.colors.neutral[600]
}).withConfig({
    displayName: "styles__ArrowLeftIcon",
    componentId: "sc-efab7a56-6"
})(ChangePasswordFeedback_styles_templateObject6());
var GoToLoginButton = (0,styled_components_browser_esm/* default */.ZP)(ui.Button).withConfig({
    displayName: "styles__GoToLoginButton",
    componentId: "sc-efab7a56-7"
})(ChangePasswordFeedback_styles_templateObject7(), ui.theme.space.x2, ui.theme.space.x4, ui.theme.space.x2, ui.theme.colors.secondary[380], ui.theme.typography.fontSize.sm.x7, ui.theme.colors.neutral.white, ui.theme.colors.secondary[390]);
var TitleInformationContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TitleInformationContainer",
    componentId: "sc-efab7a56-8"
})(ChangePasswordFeedback_styles_templateObject8());
var ReturnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ReturnWrapper",
    componentId: "sc-efab7a56-9"
})(ChangePasswordFeedback_styles_templateObject9(), ui.theme.colors.neutral["999-opacity-25"]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/components/ChangePasswordFeedback/index.tsx







var ChangePasswordFeedback = function(param) {
    var title = param.title, description = param.description, buttonText = param.buttonText, onCloseFeedback = param.onCloseFeedback, onCallAction = param.onCallAction, hasReturn = param.hasReturn, _useRouter = param.useRouter, useRouter = _useRouter === void 0 ? next_router.useRouter : _useRouter;
    var router = useRouter();
    var changeCurrentStep = (0,application/* useAuthentication */.JLf)(function(state) {
        return state.changeCurrentStep;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePasswordFeedbackContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("change-password-feedback-container")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChangePasswordFeedbackInformation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("change-password-feedback-information")), {
            children: [
                hasReturn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnWrapper, {
                    onClick: function() {
                        return changeCurrentStep("login");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowLeftIcon, {
                        color: "".concat(ui.theme.colors.neutral[330])
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleInformationContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-information-container")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_TitleInformation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-information")), {
                        children: title
                    }))
                })),
                (router === null || router === void 0 ? void 0 : router.pathname) !== "/login" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePasswordFeedback_styles_WrapperIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    onClick: onCloseFeedback
                }, (0,application/* buildTestIds */.Fek)("close-button")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.CloseIcon, {
                        height: 24,
                        width: 24,
                        color: "".concat(ui.theme.colors.neutral[330])
                    })
                })) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ContentInformationText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("content-information-text")), {
                    children: description
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GoToLoginButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("go-to-login-button")), {
                    onClick: onCallAction,
                    children: buttonText
                }))
            ]
        }))
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/PasswordFeedback/data.tsx
var getFeedbackContent = function(isTokenCodeValid) {
    if (isTokenCodeValid) {
        return {
            title: "Sua senha foi alterada!",
            description: "Sua senha foi alterada com sucesso."
        };
    }
    return {
        title: "Erro na altera\xe7\xe3o de senha",
        description: "Houve um erro na tentativa de altera\xe7\xe3o da sua senha."
    };
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/PasswordFeedback/index.tsx




var PasswordFeedback = function(param) {
    var _useAuthentication = param.useAuthentication, useAuthentication = _useAuthentication === void 0 ? state_manager/* useAuthentication */.JL : _useAuthentication, _useTwoFactor = param.useTwoFactor, useTwoFactor = _useTwoFactor === void 0 ? state_manager/* useTwoFactor */.kD : _useTwoFactor;
    var ref = useAuthentication((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            closeAuthenticationModal: state.closeAuthenticationModal,
            changeCurrentStep: state.changeCurrentStep
        };
    })), closeAuthenticationModal = ref.closeAuthenticationModal, changeCurrentStep = ref.changeCurrentStep;
    var isTokenCodeValid = useTwoFactor((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            isTokenCodeValid: state.isTokenCodeValid
        };
    })).isTokenCodeValid;
    var feedbackContent = getFeedbackContent(isTokenCodeValid);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePasswordFeedback, {
        onCloseFeedback: closeAuthenticationModal,
        onCallAction: function() {
            return changeCurrentStep("login");
        },
        title: feedbackContent.title,
        buttonText: "Ir para login",
        description: feedbackContent.description
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/EmailFeedback/data.tsx



var useEmailFeedbackData = function() {
    var router = (0,next_router.useRouter)();
    var closeAuthenticationModal = (0,application/* useAuthentication */.JLf)((0,application/* useShallow */.NL6)(function(state) {
        return {
            closeAuthenticationModal: state.closeAuthenticationModal
        };
    })).closeAuthenticationModal;
    var isPhoneNumberInvalid = (0,application/* useTwoFactor */.kD7)((0,application/* useShallow */.NL6)(function(state) {
        return {
            isPhoneNumberInvalid: state.isPhoneNumberInvalid
        };
    })).isPhoneNumberInvalid;
    var ref = (0,application/* getPhoneNumberInvalidInformation */.pgP)(), buttonAction = ref.buttonAction, buttonText = ref.buttonText, description = ref.description, title = ref.title;
    var returnTitle = (0,react.useCallback)(function() {
        if (isPhoneNumberInvalid) {
            return title;
        }
        return "E-mail n\xe3o encontrado";
    }, [
        isPhoneNumberInvalid,
        title
    ]);
    var returnDescription = (0,react.useCallback)(function() {
        if (isPhoneNumberInvalid) {
            return description;
        }
        return "N\xe3o foi poss\xedvel encontrar o e-mail digitado em nosso sistema. Por favor, verifique se o endere\xe7o de e-mail est\xe1 correto ou tente usar um endere\xe7o diferente.";
    }, [
        description,
        isPhoneNumberInvalid
    ]);
    var returnButtonText = (0,react.useCallback)(function() {
        if (isPhoneNumberInvalid) {
            return buttonText;
        }
        return "Criar cadastro";
    }, [
        buttonText,
        isPhoneNumberInvalid
    ]);
    var returnButtonAction = (0,react.useCallback)(function() {
        if (isPhoneNumberInvalid) {
            return buttonAction;
        }
        return "/cadastro";
    }, [
        buttonAction,
        isPhoneNumberInvalid
    ]);
    var handleRedirect = (0,react.useCallback)(function() {
        router.push(returnButtonAction());
    }, [
        returnButtonAction,
        router
    ]);
    return {
        closeAuthenticationModal: closeAuthenticationModal,
        handleRedirect: handleRedirect,
        returnButtonText: returnButtonText,
        returnDescription: returnDescription,
        returnTitle: returnTitle
    };
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/EmailFeedback/index.tsx



var EmailFeedback = function() {
    var ref = useEmailFeedbackData(), closeAuthenticationModal = ref.closeAuthenticationModal, handleRedirect = ref.handleRedirect, returnButtonText = ref.returnButtonText, returnDescription = ref.returnDescription, returnTitle = ref.returnTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePasswordFeedback, {
        onCloseFeedback: closeAuthenticationModal,
        onCallAction: handleRedirect,
        title: returnTitle(),
        buttonText: returnButtonText(),
        description: returnDescription()
    });
};


// EXTERNAL MODULE: ../../packages/typing/index.tsx + 7 modules
var typing = __webpack_require__(96915);
// EXTERNAL MODULE: ../../packages/components/2fa/index.ts + 18 modules
var _2fa = __webpack_require__(83650);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ChooseAnotherMethod/data.tsx


var methods = function(setChannelSelected, changeCurrentStep, availableMethods, isValid, onVerifyIdentity) {
    return [
        {
            title: "SMS",
            description: String(availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.sms),
            handleOptionAction: function() {
                setChannelSelected(1);
                onVerifyIdentity === null || onVerifyIdentity === void 0 ? void 0 : onVerifyIdentity(1);
            },
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.MessagesIcon, {}),
            isValid: isValid === null || isValid === void 0 ? void 0 : isValid.sms
        },
        {
            title: "E-mail",
            description: String(availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.email),
            handleOptionAction: function() {
                setChannelSelected(2);
                onVerifyIdentity === null || onVerifyIdentity === void 0 ? void 0 : onVerifyIdentity(2);
            },
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.EmailIcon, {}),
            isValid: isValid === null || isValid === void 0 ? void 0 : isValid.email
        }, 
    ];
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/VerifyCode/styles.ts

function VerifyCode_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  max-width: 380px;\n  width: 100%;\n\n  @media ",
        " {\n    max-width: 100%;\n    padding: 0 24px 24px;\n  }\n"
    ]);
    VerifyCode_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VerifyCode_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  margin-bottom: 24px;\n\n  @media ",
        " {\n    align-items: flex-start;\n    margin-bottom: 8px;\n  }\n"
    ]);
    VerifyCode_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VerifyCode_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    VerifyCode_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function VerifyCode_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  box-shadow: 0px 2px 2px ",
        ";\n"
    ]);
    VerifyCode_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function VerifyCode_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    VerifyCode_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var TwoFactorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TwoFactorContainer",
    componentId: "sc-cb61dd2c-0"
})(VerifyCode_styles_templateObject(), ui.theme.device.desktopFirst.mobileXL);
var VerifyCode_styles_ContentInformation = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__ContentInformation",
    componentId: "sc-cb61dd2c-1"
})(VerifyCode_styles_templateObject1(), ui.theme.space["x2.5"], ui.theme.device.desktopFirst.mobileXL);
var VerifyCode_styles_ArrowLeftIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowLeft).attrs({
    height: "24px",
    width: "24px",
    color: ui.theme.colors.neutral[600]
}).withConfig({
    displayName: "styles__ArrowLeftIcon",
    componentId: "sc-cb61dd2c-2"
})(VerifyCode_styles_templateObject2());
var VerifyCode_styles_WrapperIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperIcon",
    componentId: "sc-cb61dd2c-3"
})(VerifyCode_styles_templateObject3(), ui.theme.colors.neutral["999-opacity-12"]);
var VerifyCodeText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__VerifyCodeText",
    componentId: "sc-cb61dd2c-4"
})(VerifyCode_styles_templateObject4(), ui.theme.colors.neutral[550], ui.theme.typography.fontSize.sm.x9, ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight.bold, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x7, ui.theme.colors.neutral[750]);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/VerifyCode/index.tsx














var VerifyCode = function(param) {
    var _useAuthentication = param.useAuthentication, useAuthentication = _useAuthentication === void 0 ? state_manager/* useAuthentication */.JL : _useAuthentication, _useTwoFactor = param.useTwoFactor, useTwoFactor = _useTwoFactor === void 0 ? state_manager/* useTwoFactor */.kD : _useTwoFactor, _useRouter = param.useRouter, useRouter = _useRouter === void 0 ? next_router.useRouter : _useRouter;
    var ref = (0,react.useState)(false), isValidatingCode = ref[0], setIsValidatingCode = ref[1];
    var router = useRouter();
    var ref1 = useAuthentication((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            changeCurrentStep: state.changeCurrentStep,
            userIdentification: state.userIdentification,
            identificationType: state.identificationType
        };
    })), changeCurrentStep = ref1.changeCurrentStep, userIdentification = ref1.userIdentification, identificationType = ref1.identificationType;
    var ref2 = useTwoFactor((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            channelSelected: state.channelSelected,
            availableMethods: state.availableMethods,
            isBlockedToSendCode: state.isBlockedToSendCode,
            tokenCode: state.tokenCode,
            setIsTokenCodeValid: state.setIsTokenCodeValid,
            setValidateCode: state.setValidateCode,
            isValidationActive: state.isValidationActive,
            clearTimer: state.clearTimer,
            setChannelSelected: state.setChannelSelected
        };
    })), channelSelected = ref2.channelSelected, availableMethods = ref2.availableMethods, isBlockedToSendCode = ref2.isBlockedToSendCode, tokenCode = ref2.tokenCode, setIsTokenCodeValid = ref2.setIsTokenCodeValid, setValidateCode = ref2.setValidateCode, clearTimer = ref2.clearTimer, setChannelSelected = ref2.setChannelSelected;
    var addToast = (0,application/* useToast */.pmc)().addToast;
    var handleCodeValidation = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(token, identifier) {
            var ref, handleValidation;
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    ;
                    setIsValidatingCode(true);
                    setChannelSelected(channelSelected);
                    handleValidation = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(location, hasLocation) {
                            var ref, ref1, ref2, isValid, errors, ref3;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            implementations/* notificationApi.validateTwoFactorCodePublic */.E8.validateTwoFactorCodePublic({
                                                email: identificationType === "email" ? identifier : "",
                                                cpf: identificationType === "cpf" ? identifier : "",
                                                channel: channelSelected,
                                                faType: typing/* FATypeValues.RecoverAccount2FA */.ZI.RecoverAccount2FA,
                                                token: token,
                                                phoneNumber: "",
                                                location: hasLocation ? location : "",
                                                needsToLog: true
                                            })
                                        ];
                                    case 1:
                                        ref2 = _state.sent(), isValid = ref2.isValid, errors = ref2.errors;
                                        if (!isValid && (errors === null || errors === void 0 ? void 0 : (ref = errors.ErrorCodes) === null || ref === void 0 ? void 0 : ref.includes("222"))) {
                                            setIsTokenCodeValid(false);
                                            setValidateCode(true);
                                            clearTimer(typing/* FATypeValues.RecoverAccount2FA */.ZI.RecoverAccount2FA, channelSelected, true);
                                            return [
                                                2
                                            ];
                                        }
                                        if (!isValid && !(errors === null || errors === void 0 ? void 0 : (ref1 = errors.ErrorCodes) === null || ref1 === void 0 ? void 0 : ref1.includes("222"))) {
                                            ;
                                            setIsTokenCodeValid(false);
                                            setValidateCode(true);
                                            addToast({
                                                type: "error",
                                                isNewToast: true,
                                                newToastTheme: "light",
                                                title: "Erro ao validar c\xf3digo",
                                                description: errors === null || errors === void 0 ? void 0 : (ref3 = errors.Messages) === null || ref3 === void 0 ? void 0 : ref3[0]
                                            });
                                            return [
                                                2
                                            ];
                                        }
                                        clearTimer(typing/* FATypeValues.RecoverAccount2FA */.ZI.RecoverAccount2FA, channelSelected);
                                        setIsTokenCodeValid(true);
                                        changeCurrentStep("changePassword");
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function handleValidation(location, hasLocation) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    navigator === null || navigator === void 0 ? void 0 : (ref = navigator.geolocation) === null || ref === void 0 ? void 0 : ref.getCurrentPosition(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(position) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                handleValidation("Latitude: ".concat(position.coords.latitude, ", Longitude: ").concat(position.coords.longitude), true);
                                return [
                                    2
                                ];
                            });
                        });
                        return function(position) {
                            return _ref.apply(this, arguments);
                        };
                    }(), /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            handleValidation("");
                            return [
                                2
                            ];
                        });
                    }));
                } finally{
                    setIsValidatingCode(false);
                }
                return [
                    2
                ];
            });
        });
        return function(token, identifier) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setChannelSelected,
        identificationType,
        channelSelected,
        clearTimer,
        setIsTokenCodeValid,
        changeCurrentStep,
        setValidateCode,
        addToast, 
    ]);
    var handleSelectAnotherTwoFactorType = function() {
        changeCurrentStep("verifyIdentity");
    };
    var getTitle = function() {
        if (isBlockedToSendCode) {
            return "Voc\xea est\xe1 bloqueado";
        }
        if ((router === null || router === void 0 ? void 0 : router.pathname) === "/login") {
            return "Verifica\xe7\xe3o de identidade";
        }
        return "Digite o c\xf3digo";
    };
    var shouldShowChooseAnotherTwoFactorMethod = (availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.emailConfirmed) && (availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumberConfirmed) || !(availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.emailConfirmed) && !(availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumberConfirmed);
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TwoFactorContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VerifyCode_styles_ContentInformation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("content-information")), {
                children: [
                    (router === null || router === void 0 ? void 0 : router.pathname) !== "/login" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyCode_styles_WrapperIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        onClick: function() {
                            return changeCurrentStep("login");
                        }
                    }, (0,application/* buildTestIds */.Fek)("back-button")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyCode_styles_ArrowLeftIcon, {})
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyCodeText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("verify-code-text")), {
                        children: getTitle()
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_2fa.TwoFactorContent, {
                options: methods(setChannelSelected, changeCurrentStep, {}, {
                    email: availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.emailConfirmed,
                    sms: availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumberConfirmed
                }),
                canChooseAnotherTwoFactorMethod: shouldShowChooseAnotherTwoFactorMethod,
                hasHeader: false,
                clientAction: "forgotPassword",
                email: (ref3 = availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.email) !== null && ref3 !== void 0 ? ref3 : userIdentification,
                hasError: isBlockedToSendCode,
                successTitle: "",
                buttonHeight: "45px",
                shouldMask: false,
                preventDefault: true,
                buttonBorderRadius: "8px",
                isUnderAction: isValidatingCode,
                onCallAction: function() {
                    handleCodeValidation(tokenCode, userIdentification);
                },
                phoneNumber: String(availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumber),
                viewType: "component",
                sendCodeType: channelSelected === 1 ? "sms" : "email",
                handleSelectAnotherTwoFactorType: handleSelectAnotherTwoFactorType,
                onClickIsInvalidClientInfo: function() {
                    return changeCurrentStep("login");
                },
                verifyIdentityTitle: "Verifica\xe7\xe3o de identidade",
                verifyIdentityDescription: "Para garantir a sua seguran\xe7a, escolha um modo para autenticar a sua identidade."
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ChooseAnotherMethod/styles.ts

function ChooseAnotherMethod_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  max-width: 360px;\n  width: 100%;\n\n  @media ",
        " {\n    max-width: 100%;\n    padding: 0 24px 24px;\n  }\n"
    ]);
    ChooseAnotherMethod_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChooseAnotherMethod_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  margin-bottom: ",
        ";\n\n  @media ",
        " {\n    align-items: flex-start;\n  }\n"
    ]);
    ChooseAnotherMethod_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ChooseAnotherMethod_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ChooseAnotherMethod_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ChooseAnotherMethod_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  box-shadow: 0px 2px 2px ",
        ";\n"
    ]);
    ChooseAnotherMethod_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ChooseAnotherMethod_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    ChooseAnotherMethod_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ChooseAnotherMethod_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: pre-wrap;\n  color: ",
        " !important;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    ChooseAnotherMethod_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var styles_TwoFactorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TwoFactorContainer",
    componentId: "sc-569a1b1d-0"
})(ChooseAnotherMethod_styles_templateObject(), ui.theme.device.desktopFirst.mobileXL);
var ChooseAnotherMethod_styles_ContentInformation = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__ContentInformation",
    componentId: "sc-569a1b1d-1"
})(ChooseAnotherMethod_styles_templateObject1(), ui.theme.space["x2.5"], function(param) {
    var marginBottom = param.marginBottom;
    return marginBottom;
}, ui.theme.device.desktopFirst.mobileXL);
var ChooseAnotherMethod_styles_ArrowLeftIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowLeft).attrs({
    height: "24px",
    width: "24px",
    color: ui.theme.colors.neutral[330]
}).withConfig({
    displayName: "styles__ArrowLeftIcon",
    componentId: "sc-569a1b1d-2"
})(ChooseAnotherMethod_styles_templateObject2());
var ChooseAnotherMethod_styles_WrapperIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperIcon",
    componentId: "sc-569a1b1d-3"
})(ChooseAnotherMethod_styles_templateObject3(), ui.theme.colors.neutral["999-opacity-12"]);
var IdentityVerificationText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__IdentityVerificationText",
    componentId: "sc-569a1b1d-4"
})(ChooseAnotherMethod_styles_templateObject4(), ui.theme.colors.neutral[550], ui.theme.typography.fontSize.sm.x9, ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight.bold, ui.theme.device.desktopFirst.mobileXL, ui.theme.typography.fontSize.sm.x7, ui.theme.colors.neutral[750]);
var ChooseAnotherMethodDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ChooseAnotherMethodDescription",
    componentId: "sc-569a1b1d-5"
})(ChooseAnotherMethod_styles_templateObject5(), ui.theme.colors.neutral[110], ui.theme.typography.fontSize.sm.x5, ui.theme.space.x4);

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ChooseAnotherMethod/index.tsx














var ChooseAnotherMethod = function(param) {
    var _useAuthentication = param.useAuthentication, useAuthentication = _useAuthentication === void 0 ? state_manager/* useAuthentication */.JL : _useAuthentication, _useTwoFactor = param.useTwoFactor, useTwoFactor = _useTwoFactor === void 0 ? state_manager/* useTwoFactor */.kD : _useTwoFactor;
    var ref = useAuthentication((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            changeCurrentStep: state.changeCurrentStep,
            userIdentification: state.userIdentification,
            identificationType: state.identificationType,
            currentStep: state.currentStep,
            isChangePasswordDueToPurchase: state.isChangePasswordDueToPurchase
        };
    })), changeCurrentStep = ref.changeCurrentStep, userIdentification = ref.userIdentification, identificationType = ref.identificationType, currentStep = ref.currentStep, isChangePasswordDueToPurchase = ref.isChangePasswordDueToPurchase;
    var ref1 = useTwoFactor((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            setChannelSelected: state.setChannelSelected,
            availableMethods: state.availableMethods,
            channelSelected: state.channelSelected,
            setIsBlockedToSendCode: state.setIsBlockedToSendCode,
            setIsValidationActive: state.setIsValidationActive,
            setAvailableMethods: state.setAvailableMethods,
            setFaType: state.setFaType,
            getTimer: state.getTimer,
            setClientAction: state.setClientAction,
            setIsPhoneNumberInvalid: state.setIsPhoneNumberInvalid
        };
    })), setChannelSelected = ref1.setChannelSelected, availableMethods = ref1.availableMethods, setIsBlockedToSendCode = ref1.setIsBlockedToSendCode, setIsValidationActive = ref1.setIsValidationActive, setAvailableMethods = ref1.setAvailableMethods, setFaType = ref1.setFaType, getTimer = ref1.getTimer, setClientAction = ref1.setClientAction, setIsPhoneNumberInvalid = ref1.setIsPhoneNumberInvalid;
    var onVerifyIdentity = (0,react.useCallback)(function() {
        var _ref = // eslint-disable-next-line sonarjs/cognitive-complexity
        (0,_async_to_generator/* default */.Z)(function(channel) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, isTimerRunning, response, ref18, newAvailableMethods;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setFaType(9);
                        setClientAction("forgotPassword");
                        isTimerRunning = getTimer(9, channel).isTimerRunning;
                        if (isTimerRunning) {
                            setIsValidationActive(true);
                            if (currentStep === "verifyIdentity") {
                                changeCurrentStep("verifyCode");
                            }
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            implementations/* notificationApi.sendTwoFactorCodePublic */.E8.sendTwoFactorCodePublic({
                                faType: 9,
                                email: identificationType === "email" ? userIdentification : "",
                                cpf: identificationType === "cpf" ? userIdentification : "",
                                channel: channel !== null && channel !== void 0 ? channel : 2,
                                phoneNumber: "",
                                token: ""
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (!(response === null || response === void 0 ? void 0 : (ref = response.validationResult) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : ref1.some(function(error) {
                            var ref;
                            return (error === null || error === void 0 ? void 0 : (ref = error.propertyName) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "phonenumber";
                        }))) {
                            setIsPhoneNumberInvalid(false);
                        }
                        if (!(response === null || response === void 0 ? void 0 : (ref2 = response.validationResult) === null || ref2 === void 0 ? void 0 : ref2.isValid)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            implementations/* identityApi.receiveConfirmationTypesPublic */.IJ.receiveConfirmationTypesPublic({
                                email: identificationType === "email" ? userIdentification : "",
                                cpf: identificationType === "cpf" ? userIdentification : ""
                            })
                        ];
                    case 2:
                        ref18 = _state.sent(), newAvailableMethods = ref18.data;
                        setIsBlockedToSendCode(false);
                        setAvailableMethods(newAvailableMethods);
                        setIsValidationActive(true);
                        changeCurrentStep("verifyCode");
                        return [
                            2
                        ];
                    case 3:
                        if ((response === null || response === void 0 ? void 0 : (ref3 = response.validationResult) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.errors) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.errorMessage) === "Cliente n\xe3o encontrado") {
                            changeCurrentStep("emailFeedback");
                            return [
                                2
                            ];
                        }
                        if ((response === null || response === void 0 ? void 0 : (ref6 = response.validationResult) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.errors) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.errorCode) === "222" || ((ref9 = [
                            "Tente novamente em 24 horas.",
                            "Opera\xe7\xe3o bloqueada devido ao n\xfamero de tentativas excessivas na solicita\xe7\xe3o do c\xf3digo.", 
                        ]) === null || ref9 === void 0 ? void 0 : ref9.includes(String(response === null || response === void 0 ? void 0 : (ref10 = response.validationResult) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.errors) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.errorMessage)))) {
                            setIsBlockedToSendCode(true);
                            setIsValidationActive(true);
                            changeCurrentStep("verifyCode");
                            return [
                                2
                            ];
                        }
                        if ((response === null || response === void 0 ? void 0 : (ref13 = response.validationResult) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.errors) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : ref15.errorCode) === "666") {
                            changeCurrentStep("verifyCode");
                            return [
                                2
                            ];
                        }
                        if (response === null || response === void 0 ? void 0 : (ref16 = response.validationResult) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.errors) === null || ref17 === void 0 ? void 0 : ref17.some(function(error) {
                            var ref;
                            return (error === null || error === void 0 ? void 0 : (ref = error.propertyName) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "phonenumber";
                        })) {
                            changeCurrentStep("phoneNumberFeedback");
                            setIsPhoneNumberInvalid(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(channel) {
            return _ref.apply(this, arguments);
        };
    }(), [
        changeCurrentStep,
        currentStep,
        getTimer,
        identificationType,
        setAvailableMethods,
        setClientAction,
        setFaType,
        setIsBlockedToSendCode,
        setIsValidationActive,
        userIdentification,
        setIsPhoneNumberInvalid, 
    ]);
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_TwoFactorContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("two-factor-container")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChooseAnotherMethod_styles_ContentInformation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                marginBottom: isChangePasswordDueToPurchase ? "".concat(ui.theme.space.x4) : "".concat(ui.theme.space.x6)
            }, (0,application/* buildTestIds */.Fek)("content-information")), {
                children: [
                    (router === null || router === void 0 ? void 0 : router.pathname) !== "/login" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseAnotherMethod_styles_WrapperIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        onClick: function() {
                            return changeCurrentStep(isChangePasswordDueToPurchase ? "changePasswordDuePurchaseTime" : "login");
                        }
                    }, (0,application/* buildTestIds */.Fek)("back-button")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseAnotherMethod_styles_ArrowLeftIcon, {
                            color: ui.theme.colors.neutral[330]
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IdentityVerificationText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("identity-verification-text")), {
                        children: "Verifica\xe7\xe3o de identidade"
                    }))
                ]
            })),
            isChangePasswordDueToPurchase ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseAnotherMethodDescription, {
                children: "Para garantir a sua seguran\xe7a, escolha um modo para autenticar a sua identidade."
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_2fa.TwoFactorContent, {
                options: methods(setChannelSelected, changeCurrentStep, {
                    email: availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.email,
                    sms: availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumber
                }, {
                    email: availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.emailConfirmed,
                    sms: availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumberConfirmed
                }, onVerifyIdentity),
                canChooseAnotherTwoFactorMethod: false,
                onClickFailureButton: function() {
                    return changeCurrentStep("login");
                },
                clientAction: "forgotPassword",
                email: String(availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.email),
                hasError: null,
                phoneNumber: String(availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumber),
                shouldMask: false,
                viewType: "component",
                isUnderAction: false,
                onCallAction: function() {
                    return changeCurrentStep("verifyCode");
                },
                sendCodeType: "email",
                onClickIsInvalidClientInfo: function() {
                    return changeCurrentStep("forgotPassword");
                },
                isVerifyIdentity: true,
                verifyIdentityDescription: "Para garantir a sua seguran\xe7a, escolha um modo para autenticar a sua identidade."
            })
        ]
    }));
};


// EXTERNAL MODULE: ../../packages/components/ChangePassword/index.tsx + 1 modules
var ChangePassword = __webpack_require__(80712);
;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ChooseNewPassword/styles.ts

function ChooseNewPassword_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  gap: ",
        ";\n  justify-content: center;\n  height: 32px;\n  align-items: center;\n  margin-bottom: 24px;\n\n  @media ",
        " {\n    justify-content: start;\n  }\n"
    ]);
    ChooseNewPassword_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChooseNewPassword_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ChooseNewPassword_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ChooseNewPassword_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  box-shadow: 0px 2px 2px ",
        ";\n"
    ]);
    ChooseNewPassword_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ChooseNewPassword_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    ChooseNewPassword_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ChooseNewPassword_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n"
    ]);
    ChooseNewPassword_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ChooseNewPassword_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 0 16px;\n      align-items: start;\n    "
    ]);
    ChooseNewPassword_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ChooseNewPassword_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  ",
        "\n"
    ]);
    ChooseNewPassword_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var ChooseNewPassword_styles_ContentInformation = (0,styled_components_browser_esm/* default */.ZP)(ui.FlexContainer).withConfig({
    displayName: "styles__ContentInformation",
    componentId: "sc-35247e-0"
})(ChooseNewPassword_styles_templateObject(), ui.theme.space["x2.5"], ui.theme.device.desktopFirst.mobileXL);
var ChooseNewPassword_styles_ArrowLeftIcon = (0,styled_components_browser_esm/* default */.ZP)(ui.ArrowLeft).attrs({
    height: "24px",
    width: "24px",
    color: ui.theme.colors.neutral[600]
}).withConfig({
    displayName: "styles__ArrowLeftIcon",
    componentId: "sc-35247e-1"
})(ChooseNewPassword_styles_templateObject1());
var ChooseNewPassword_styles_WrapperIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__WrapperIcon",
    componentId: "sc-35247e-2"
})(ChooseNewPassword_styles_templateObject2(), ui.theme.colors.neutral["999-opacity-12"]);
var ChooseNewPassword_styles_RecoverAccessText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__RecoverAccessText",
    componentId: "sc-35247e-3"
})(ChooseNewPassword_styles_templateObject3(), ui.theme.colors.neutral[550], ui.theme.typography.fontSize.sm.x9, ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontWeight.bold);
var ChangeNewPasswordContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ChangeNewPasswordContent",
    componentId: "sc-35247e-4"
})(ChooseNewPassword_styles_templateObject4(), ui.theme.space.x112);
var ChangeNewPasswordContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ChangeNewPasswordContainer",
    componentId: "sc-35247e-5"
})(ChooseNewPassword_styles_templateObject6(), function(param) {
    var isLogin = param.isLogin;
    return isLogin && (0,styled_components_browser_esm/* css */.iv)(ChooseNewPassword_styles_templateObject5());
});

;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ChooseNewPassword/index.tsx












var ChooseNewPassword = function(param) {
    var _useAuthentication = param.useAuthentication, useAuthentication = _useAuthentication === void 0 ? state_manager/* useAuthentication */.JL : _useAuthentication, _useRouter = param.useRouter, useRouter = _useRouter === void 0 ? next_router.useRouter : _useRouter, _useTwoFactor = param.useTwoFactor, useTwoFactor = _useTwoFactor === void 0 ? state_manager/* useTwoFactor */.kD : _useTwoFactor, _useToast = param.useToast, useToast = _useToast === void 0 ? application/* useToast */.pmc : _useToast;
    var router = useRouter();
    var addToast = useToast().addToast;
    var ref = useAuthentication((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            changeCurrentStep: state.changeCurrentStep,
            userIdentification: state.userIdentification,
            identificationType: state.identificationType,
            setIsAuthenticationModalActive: state.setIsAuthenticationModalActive
        };
    })), changeCurrentStep = ref.changeCurrentStep, userIdentification = ref.userIdentification, identificationType = ref.identificationType, setIsAuthenticationModalActive = ref.setIsAuthenticationModalActive;
    var setIsOpenedDropdownUser = (0,application/* useAppContext */.bp4)().setIsOpenedDropdownUser;
    var ref1 = (0,application/* useAuth */.aCi)(), onAuthenticateUser = ref1.onAuthenticateUser, isAuthenticated = ref1.isAuthenticated;
    var ref2 = (0,react.useState)(false), isUnderAction = ref2[0], setIsUnderAction = ref2[1];
    var ref3 = useTwoFactor((0,state_manager/* useShallow */.NL)(function(state) {
        return {
            availableMethods: state.availableMethods,
            channelSelected: state.channelSelected,
            tokenCode: state.tokenCode,
            setIsTokenCodeValid: state.setIsTokenCodeValid,
            clearTimer: state.clearTimer
        };
    })), availableMethods = ref3.availableMethods, channelSelected = ref3.channelSelected, tokenCode = ref3.tokenCode, setIsTokenCodeValid = ref3.setIsTokenCodeValid, clearTimer = ref3.clearTimer;
    // eslint-disable-next-line sonarjs/cognitive-complexity
    var changePassword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newPassword) {
            var handleRecoverAccount, ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                handleRecoverAccount = function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(location, hasLocation) {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, response, token, _tmp, _;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setIsUnderAction(true);
                                    return [
                                        4,
                                        implementations/* identityApi.recoverAccount */.IJ.recoverAccount({
                                            email: identificationType === "email" ? userIdentification : "",
                                            phoneNumber: channelSelected === 1 ? String(availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.phoneNumber) : "",
                                            newPassword: newPassword,
                                            token: tokenCode,
                                            channel: Number(channelSelected),
                                            cpf: identificationType === "cpf" ? userIdentification : "",
                                            faType: 9,
                                            location: hasLocation ? location : ""
                                        })
                                    ];
                                case 1:
                                    ref6 = _state.sent(), response = ref6.data;
                                    if ((response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.errorMessages) === null || ref2 === void 0 ? void 0 : ref2[0]) === "The new password cannot be the same as the old password.") {
                                        setIsUnderAction(false);
                                        addToast({
                                            description: "A nova senha n\xe3o pode ser igual a senha antiga",
                                            type: "error",
                                            title: "Erro",
                                            isNewToast: true,
                                            newToastTheme: "dark"
                                        });
                                        return [
                                            2
                                        ];
                                    }
                                    if ((response === null || response === void 0 ? void 0 : (ref3 = response.data) === null || ref3 === void 0 ? void 0 : ref3.status) === 400 || (response === null || response === void 0 ? void 0 : (ref4 = response.data) === null || ref4 === void 0 ? void 0 : ref4.status) === 500 || (response === null || response === void 0 ? void 0 : response.error) || (response === null || response === void 0 ? void 0 : response.status) === 400 || (response === null || response === void 0 ? void 0 : response.status) === 500) {
                                        setIsUnderAction(false);
                                        setIsTokenCodeValid(false);
                                        changeCurrentStep("passwordFeedback");
                                        return [
                                            2
                                        ];
                                    }
                                    clearTimer(9, channelSelected);
                                    setIsTokenCodeValid(true);
                                    setIsUnderAction(false);
                                    _tmp = {
                                        login: userIdentification,
                                        password: newPassword
                                    };
                                    _ = JSON.stringify;
                                    return [
                                        4,
                                        (0,application/* getGeolocation */.Yt8)()
                                    ];
                                case 2:
                                    return [
                                        4,
                                        onAuthenticateUser.apply(void 0, [
                                            (_tmp.location = _.apply(JSON, [
                                                _state.sent()
                                            ]), _tmp)
                                        ])
                                    ];
                                case 3:
                                    token = _state.sent();
                                    if (!isAuthenticated && !token) {
                                        addToast({
                                            title: "Credenciais  Inv\xe1lidas",
                                            type: "error"
                                        });
                                        return [
                                            2
                                        ];
                                    }
                                    setIsOpenedDropdownUser(false);
                                    addToast({
                                        title: "Senha alterada com sucesso",
                                        description: "Sua senha foi alterada",
                                        type: "success",
                                        isNewToast: true,
                                        newToastTheme: "dark"
                                    });
                                    if (router === null || router === void 0 ? void 0 : (ref5 = router.pathname) === null || ref5 === void 0 ? void 0 : ref5.includes("meu-carrinho")) {
                                        router.push("/checkout/pagamento");
                                        setIsAuthenticationModalActive(false);
                                        changeCurrentStep("login");
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function handleRecoverAccount(location, hasLocation) {
                        return _ref.apply(this, arguments);
                    };
                }();
                try {
                    ;
                    setIsUnderAction(true);
                    navigator === null || navigator === void 0 ? void 0 : (ref = navigator.geolocation) === null || ref === void 0 ? void 0 : ref.getCurrentPosition(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(position) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                handleRecoverAccount("Latitude: ".concat(position.coords.latitude, ", Longitude: ").concat(position.coords.longitude), true);
                                return [
                                    2
                                ];
                            });
                        });
                        return function(position) {
                            return _ref.apply(this, arguments);
                        };
                    }(), /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            handleRecoverAccount("", false);
                            return [
                                2
                            ];
                        });
                    }));
                } finally{
                    setIsUnderAction(false);
                }
                return [
                    2
                ];
            });
        });
        return function changePassword(newPassword) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeNewPasswordContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("change-new-password-container")), {
        isLogin: (router === null || router === void 0 ? void 0 : router.pathname) === "/login",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChangeNewPasswordContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChooseNewPassword_styles_ContentInformation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("content-information")), {
                    children: [
                        (router === null || router === void 0 ? void 0 : router.pathname) !== "/login" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseNewPassword_styles_WrapperIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            onClick: function() {
                                return changeCurrentStep("forgotPassword");
                            }
                        }, (0,application/* buildTestIds */.Fek)("forgot-password-back-button")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseNewPassword_styles_ArrowLeftIcon, {})
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseNewPassword_styles_RecoverAccessText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("recover-access-text")), {
                            children: "Escolha sua nova senha"
                        }))
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePassword/* ChangePassword */.G, {
                    onChangePassword: function(newPassword) {
                        return changePassword(newPassword);
                    },
                    isUnderAction: isUnderAction
                })
            ]
        })
    }));
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/AuthContent/ChangePasswordDuePurchaseTime/index.tsx





var ChangePasswordDuePurchaseTime = function() {
    var ref;
    var closeAuthenticationModal = (0,application/* useAuthentication */.JLf)((0,application/* useShallow */.NL6)(function(state) {
        return {
            closeAuthenticationModal: state.closeAuthenticationModal
        };
    })).closeAuthenticationModal;
    var router = (0,next_router.useRouter)();
    var onVerifyIdentity = useNewForgotPassword().onVerifyIdentity;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePasswordFeedback, {
        hasReturn: !(router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.includes("login")),
        onCloseFeedback: closeAuthenticationModal,
        onCallAction: onVerifyIdentity,
        title: "Redefinir senha",
        buttonText: "Alterar senha",
        description: "Novas medidas de seguran\xe7a foram implementadas para aumentar sua prote\xe7\xe3o. Por favor, redefina sua senha."
    });
};


;// CONCATENATED MODULE: ../../packages/components/patterns/Header/components/data/index.tsx












var userAuthenticatedActions = [
    {
        id: 1,
        title: "Meus Cart\xf5es",
        path: "/conta/meus-cartoes",
        isLogout: false,
        hasBorderBottom: true,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* CardIcon */._K, {})
    },
    {
        id: 2,
        title: "Meus Endere\xe7os",
        path: "/conta/meus-enderecos",
        isLogout: false,
        hasBorderBottom: true,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* HouseIcon */.K2, {})
    },
    {
        id: 3,
        title: "Minhas Listas",
        path: "/conta/minhas-listas",
        isLogout: false,
        hasBorderBottom: true,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* GiftBoxIcon */.PA, {})
    },
    {
        id: 4,
        title: "Lista de Casamento",
        path: "/lista-de-casamento",
        isLogout: false,
        hasBorderBottom: true,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* AlliancesIcon */.VH, {})
    },
    {
        id: 5,
        title: "Fazer Logout",
        path: "/#",
        isLogout: true,
        hasBorderBottom: false,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Close */.x8, {})
    }, 
];
// Quando implementar a http request para buscar highlight categories separadamente, substituir essa lógica
var handleHighlightCategories = function(highlightCategories) {
    if (!(highlightCategories === null || highlightCategories === void 0 ? void 0 : highlightCategories.length)) {
        return [];
    }
    var formattedHighlightCategories = highlightCategories === null || highlightCategories === void 0 ? void 0 : highlightCategories.map(function(category) {
        var name = category.name, descriptionUrl = category.descriptionUrl;
        return {
            name: name,
            descriptionUrl: descriptionUrl
        };
    });
    // console.log("formattedHighlightCategories: ", formattedHighlightCategories);
    return _to_consumable_array(formattedHighlightCategories).concat([
        {
            name: "Ver todas categorias",
            descriptionUrl: "",
            excludeDivider: true,
            color: theme.colors.primary["200"]
        }, 
    ]);
};
// Essa lista abaixo precisará ser substituída pelos stories, os quais virão da Home personalizada pelo Backoffice.
var listCategories = [
    {
        name: "Eletro e eletr\xf4nicos",
        image: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb_dev/10588_thumb"
    },
    {
        name: "Utilidades dom\xe9sticas",
        image: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb_dev/10587_thumb"
    },
    {
        name: "M\xf3veis e acess\xf3rios",
        image: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb_dev/10585_thumb"
    },
    {
        name: "Decora\xe7\xe3o",
        image: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb_dev/10583_thumb"
    },
    {
        name: "Pisos e revestimentos",
        image: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb_dev/10586_thumb"
    },
    {
        name: "Ar e ventila\xe7\xe3o",
        image: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/thumb_dev/10584_thumb"
    }, 
];
var companyProducts = [
    {
        title: "Lista de Casamento",
        path: "/lista-de-casamento",
        desktop: true
    },
    {
        title: "Clube do Profissional",
        path: "https://clubedoprofissional.ferreiracosta.com/",
        desktop: true
    },
    {
        title: "Nossas Lojas",
        path: "https://ferreiracosta.movidesk.com/kb/article/156436/nossas-lojas?ticketId=&q=",
        desktop: true
    },
    {
        title: "Para Empresas",
        path: "http://empresas.ferreiracosta.com/",
        desktop: true
    },
    {
        title: "Televendas",
        path: "https://ferreiracosta.movidesk.com/kb/article/156443/qual-o-horario-de-funcionamento-e-contatos-do-vendas-corporativa?ticketId=&q=",
        desktop: false
    },
    {
        title: "Pol\xedtica de Entrega",
        path: "https://ferreiracosta.movidesk.com/kb/article/156345/politica-de-entrega-da-ferreira-costa?ticketId=&q=",
        desktop: false
    }, 
];
var getAuthContent = function(loginMode, currentStep, isMyCartPage) {
    switch(currentStep){
        case "login":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
                loginMode: loginMode,
                isMyCartPage: isMyCartPage
            });
        case "forgotPassword":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPasswordLogin, {});
        case "verifyCode":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyCode, {});
        case "emailFeedback":
        case "phoneNumberFeedback":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailFeedback, {});
        case "verifyIdentity":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseAnotherMethod, {});
        case "changePassword":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseNewPassword, {});
        case "passwordFeedback":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordFeedback, {});
        case "changePasswordDuePurchaseTime":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePasswordDuePurchaseTime, {});
        default:
            return null;
    }
};



/***/ }),

/***/ 32191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ TitleWrapper; },
/* harmony export */   "Ai": function() { return /* binding */ SidebarMenuMobileContainer; },
/* harmony export */   "DA": function() { return /* binding */ AuthenticatedOptionDefault; },
/* harmony export */   "K2": function() { return /* binding */ HouseIcon; },
/* harmony export */   "PA": function() { return /* binding */ GiftBoxIcon; },
/* harmony export */   "S7": function() { return /* binding */ CloseSidebarMenuIcon; },
/* harmony export */   "Tk": function() { return /* binding */ ListContentSidebarMenuWrapper; },
/* harmony export */   "Uw": function() { return /* binding */ ListCategoriesSidebarMenu; },
/* harmony export */   "VH": function() { return /* binding */ AlliancesIcon; },
/* harmony export */   "VK": function() { return /* binding */ TitleAction; },
/* harmony export */   "XZ": function() { return /* binding */ SidebarMenuHeader; },
/* harmony export */   "ZE": function() { return /* binding */ CloseSidebarBox; },
/* harmony export */   "_K": function() { return /* binding */ CardIcon; },
/* harmony export */   "aS": function() { return /* binding */ WrapperIcon; },
/* harmony export */   "gM": function() { return /* binding */ LinkWrapper; },
/* harmony export */   "k8": function() { return /* binding */ SidebarContainerOverlay; },
/* harmony export */   "n7": function() { return /* binding */ CategorySidebarMenu; },
/* harmony export */   "pd": function() { return /* binding */ CategoryExploreIcon; },
/* harmony export */   "rP": function() { return /* binding */ UserAuthenticatedActionsSidebarMenu; },
/* harmony export */   "wg": function() { return /* binding */ CategoriesList; },
/* harmony export */   "x5": function() { return /* binding */ AuthenticatedOptionWithLink; },
/* harmony export */   "x8": function() { return /* binding */ Close; }
/* harmony export */ });
/* unused harmony exports UserSidebarMenuIcon, AllCategoriesButton, ArrowLeftIcon, TitleSidebarMenuHyperlink, SidebarMenuHeaderContent, SubtitleSidebarMenuHyperlink, EnterpriseProductSidebarMenu, UserAuthenticatedWrapper, WeddingGiftListTitle, UsernameTitle, UserAuthenticatedImageCircle, SecurityIcon, ProfileIcon, CategoriesDiv */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17335);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: ",
        ";\n  opacity: ",
        ";\n  display: flex;\n  visibility: ",
        ";\n  background: ",
        ";\n  transition: all 0.2s ease;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 320px;\n  width: 100%;\n  height: 100vh;\n  z-index: 99;\n  position: fixed;\n  top: 0;\n  left: ",
        ";\n  transition: left 0.4s;\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding: ",
        " ",
        ";\n  position: relative;\n  background-color: ",
        ";\n\n  @media ",
        " {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from{\n    left: -1px;\n    opacity:0;\n  \n  }\n\n  to{\n    left: 352px;\n    opacity:1;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  color: ",
        ";\n  background-color: ",
        ";\n  border: 0;\n  width: 100%;\n  height: 3.125rem;\n  font-size: 13px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  gap: 0.872rem;\n  padding: 0 1.25rem;\n  animation: ",
        " 0.3s ease;\n  position: sticky;\n  top: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: center;\n  text-decoration: none;\n  text-align: left;\n\n  color: ",
        ';\n  font-family: "Chivo", Arial, Helvetica, sans-serif;\n'
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: bold;\n  font-size: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  width: 100%;\n  height: 2.25rem;\n\n  margin-top: 0.875rem;\n  padding-left: 0.25rem;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  width: 10rem;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  margin-top: ",
        ";\n  max-height: calc(100vh - 100px);\n  overflow-x: hidden;\n  overflow-y: auto; /* Certifique-se de que isso est\xe1 configurado corretamente */\n  flex-grow: 1;\n\n  ::-webkit-scrollbar {\n    width: 6px;\n    border-radius: ",
        ";\n    right: 0; /* Remover posi\xe7\xe3o absoluta */\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: ",
        ";\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: ",
        ";\n  border-bottom: 1px thin ",
        ";\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: ",
        " ",
        ";\n  background: ",
        ";\n  border-bottom: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: ",
        " ",
        ";\n  background: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  cursor: pointer;\n\n  & a {\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: center;\n  text-decoration: none;\n  text-align: left;\n  color: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-weight: ",
        ";\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  width: 100%;\n  padding-left: 0;\n  font-weight: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  font-size: ",
        ";\n\n  &:first-child {\n    display: flex !important;\n    flex-direction: row !important;\n    flex: 1 !important;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  background: ",
        ";\n  padding-left: 1rem;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 1rem;\n  width: 100%;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: none;\n  align-self: center;\n  font-size: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  border: 0;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}



var SidebarContainerOverlay = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__SidebarContainerOverlay",
    componentId: "sc-db6d1664-0"
})(_templateObject(), function(param) {
    var isActiveOverlay = param.isActiveOverlay;
    return isActiveOverlay ? "-1" : "98";
}, function(param) {
    var isActiveOverlay = param.isActiveOverlay;
    return isActiveOverlay ? "0" : "1";
}, function(param) {
    var isActiveOverlay = param.isActiveOverlay;
    return isActiveOverlay ? "hidden" : "visible";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral["999-opacity-50"]);
var SidebarMenuMobileContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__SidebarMenuMobileContainer",
    componentId: "sc-db6d1664-1"
})(_templateObject1(), function(param) {
    var isActiveOverlay = param.isActiveOverlay;
    return isActiveOverlay ? "0" : "-100%";
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[255]);
var SidebarMenuHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    displayName: "styles__SidebarMenuHeader",
    componentId: "sc-db6d1664-2"
})(_templateObject2(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[350], ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.mobileXL);
var TitleWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__TitleWrapper",
    componentId: "sc-db6d1664-3"
})(_templateObject3(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[150], ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4);
var UserSidebarMenuIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.UserIcon).attrs({
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white,
    width: ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6,
    height: ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6
}).withConfig({
    displayName: "styles__UserSidebarMenuIcon",
    componentId: "sc-db6d1664-4"
})(_templateObject4());
var CloseSidebarMenuIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.CloseIcon).attrs({
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white,
    width: ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6,
    height: ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6
}).withConfig({
    displayName: "styles__CloseSidebarMenuIcon",
    componentId: "sc-db6d1664-5"
})(_templateObject5());
var CloseSidebarBox = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CloseSidebarBox",
    componentId: "sc-db6d1664-6"
})(_templateObject6());
var AllCategoriesButtonAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .keyframes */ .F4)(_templateObject7());
var AllCategoriesButton = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "styles__AllCategoriesButton",
    componentId: "sc-db6d1664-7"
})(_templateObject8(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[300], AllCategoriesButtonAnimation);
var ArrowLeftIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.ArrowLeft).attrs({
    width: "2.1rem",
    height: "2.1rem",
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white
}).withConfig({
    displayName: "styles__ArrowLeftIcon",
    componentId: "sc-db6d1664-8"
})(_templateObject9());
var BaseHyperlinkSidebarMenu = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r).withConfig({
    displayName: "styles__BaseHyperlinkSidebarMenu",
    componentId: "sc-db6d1664-9"
})(_templateObject10(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white);
var TitleSidebarMenuHyperlink = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(BaseHyperlinkSidebarMenu).withConfig({
    displayName: "styles__TitleSidebarMenuHyperlink",
    componentId: "sc-db6d1664-10"
})(_templateObject11(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4);
var SidebarMenuHeaderContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__SidebarMenuHeaderContent",
    componentId: "sc-db6d1664-11"
})(_templateObject12());
var SubtitleSidebarMenuHyperlink = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(BaseHyperlinkSidebarMenu).withConfig({
    displayName: "styles__SubtitleSidebarMenuHyperlink",
    componentId: "sc-db6d1664-12"
})(_templateObject13(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3);
var ListCategoriesSidebarMenu = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__ListCategoriesSidebarMenu",
    componentId: "sc-db6d1664-13"
})(_templateObject14(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[255], ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x1, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[150], ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4);
var LinkWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__LinkWrapper",
    componentId: "sc-db6d1664-14"
})(_templateObject15(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[150], ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x3);
var ListContentSidebarMenuWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ListContentSidebarMenuWrapper",
    componentId: "sc-db6d1664-15"
})(_templateObject16(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, function(param) {
    var isBorderActive = param.isBorderActive;
    return isBorderActive ? "1px solid ".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[150]) : "none";
});
var CategoriesList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CategoriesList",
    componentId: "sc-db6d1664-16"
})(_templateObject17(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[150]);
var BaseSidebarMenu = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__BaseSidebarMenu",
    componentId: "sc-db6d1664-17"
})(_templateObject18(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontFamily.chivo);
var CategorySidebarMenu = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(BaseSidebarMenu).withConfig({
    displayName: "styles__CategorySidebarMenu",
    componentId: "sc-db6d1664-18"
})(_templateObject20(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x2, function(param) {
    var menuColor = param.menuColor;
    return menuColor ? "bold" : "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400]);
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[345], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x5, function(param) {
    var isOffersList = param.isOffersList;
    return isOffersList && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject19(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[500]);
});
var UserAuthenticatedActionsSidebarMenu = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(CategorySidebarMenu).withConfig({
    displayName: "styles__UserAuthenticatedActionsSidebarMenu",
    componentId: "sc-db6d1664-19"
})(_templateObject21());
var WrapperIcon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__WrapperIcon",
    componentId: "sc-db6d1664-20"
})(_templateObject22());
var TitleAction = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__TitleAction",
    componentId: "sc-db6d1664-21"
})(_templateObject23(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[345], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontWeight[400], ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography.fontSize.sm.x5);
var EnterpriseProductSidebarMenu = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(CategorySidebarMenu).withConfig({
    displayName: "styles__EnterpriseProductSidebarMenu",
    componentId: "sc-db6d1664-22"
})(_templateObject24(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[500], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral["white-050"]);
var CategoryExploreIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.ArrowRight).attrs({
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[999],
    width: ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4,
    height: ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4
}).withConfig({
    displayName: "styles__CategoryExploreIcon",
    componentId: "sc-db6d1664-23"
})(_templateObject25());
var UserAuthenticatedWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "styles__UserAuthenticatedWrapper",
    componentId: "sc-db6d1664-24"
})(_templateObject26());
var WeddingGiftListTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__WeddingGiftListTitle",
    componentId: "sc-db6d1664-25"
})(_templateObject27());
var UsernameTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].strong.withConfig */ .ZP.strong.withConfig({
    displayName: "styles__UsernameTitle",
    componentId: "sc-db6d1664-26"
})(_templateObject28(), function(param) {
    var isTitleOnImage = param.isTitleOnImage;
    var ref, ref1, ref2, ref3, ref4, ref5;
    return isTitleOnImage ? "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme === null || ui__WEBPACK_IMPORTED_MODULE_1__.theme === void 0 ? void 0 : (ref = ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography) === null || ref === void 0 ? void 0 : (ref1 = ref.fontSize) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sm) === null || ref2 === void 0 ? void 0 : ref2.x3) : "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme === null || ui__WEBPACK_IMPORTED_MODULE_1__.theme === void 0 ? void 0 : (ref3 = ui__WEBPACK_IMPORTED_MODULE_1__.theme.typography) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fontSize) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sm) === null || ref5 === void 0 ? void 0 : ref5.x6);
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white);
var UserAuthenticatedImageCircle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__UserAuthenticatedImageCircle",
    componentId: "sc-db6d1664-27"
})(_templateObject29(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.secondary[350]);
var CardIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.Card).attrs({
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200],
    height: "18px",
    width: "18px"
}).withConfig({
    displayName: "styles__CardIcon",
    componentId: "sc-db6d1664-28"
})(_templateObject30());
var HouseIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.House).attrs({
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200],
    height: "16px",
    width: "16px"
}).withConfig({
    displayName: "styles__HouseIcon",
    componentId: "sc-db6d1664-29"
})(_templateObject31());
var SecurityIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.SecurityLockIcon).attrs({
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200],
    height: "16px",
    width: "16px"
}).withConfig({
    displayName: "styles__SecurityIcon",
    componentId: "sc-db6d1664-30"
})(_templateObject32());
var GiftBoxIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.Gift).attrs({
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200],
    height: "16px",
    width: "16px"
}).withConfig({
    displayName: "styles__GiftBoxIcon",
    componentId: "sc-db6d1664-31"
})(_templateObject33());
var Close = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.CloseIcon).attrs({
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200],
    height: "16px",
    width: "16px"
}).withConfig({
    displayName: "styles__Close",
    componentId: "sc-db6d1664-32"
})(_templateObject34());
var AlliancesIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.Alliances).attrs({
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200],
    height: "16px",
    width: "16px"
}).withConfig({
    displayName: "styles__AlliancesIcon",
    componentId: "sc-db6d1664-33"
})(_templateObject35());
var ProfileIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ui__WEBPACK_IMPORTED_MODULE_1__.ProfileIcon).attrs({
    color: ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200],
    height: "16px",
    width: "16px"
}).withConfig({
    displayName: "styles__ProfileIcon",
    componentId: "sc-db6d1664-34"
})(_templateObject36());
var CategoriesDiv = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__CategoriesDiv",
    componentId: "sc-db6d1664-35"
})(_templateObject37());
var AuthenticatedOptionDefault = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__AuthenticatedOptionDefault",
    componentId: "sc-db6d1664-36"
})(_templateObject38());
var AuthenticatedOptionWithLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r).withConfig({
    displayName: "styles__AuthenticatedOptionWithLink",
    componentId: "sc-db6d1664-37"
})(_templateObject39());


/***/ }),

/***/ 98277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ LinkRedirectHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(430);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17335);



var LinkRedirectHome = function(param) {
    var children = param.children, _hrefQueryParams = param.hrefQueryParams, hrefQueryParams = _hrefQueryParams === void 0 ? "" : _hrefQueryParams;
    var currentPathName = (0,application__WEBPACK_IMPORTED_MODULE_1__/* .useCurrentPathName */ .Y0L)();
    var queryParams = hrefQueryParams ? "?".concat(hrefQueryParams) : "";
    var allConfigs = (0,application__WEBPACK_IMPORTED_MODULE_1__/* .useEnvs */ .HSW)(function(state) {
        return state.allConfigs;
    });
    var nodeEnv = (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.nodeEnv) || "";
    return nodeEnv !== "development" && (currentPathName === null || currentPathName === void 0 ? void 0 : currentPathName.includes("lista-de-casamento")) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        target: "_self",
        href: "/".concat(queryParams),
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
        id: "redirect-home",
        target: "_self",
        href: "/".concat(queryParams),
        children: children
    });
};



/***/ }),

/***/ 32202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ shoppingApi; },
/* harmony export */   "E8": function() { return /* binding */ notificationApi; },
/* harmony export */   "HI": function() { return /* binding */ encrypt; },
/* harmony export */   "I$": function() { return /* binding */ allowMeFingerprint; },
/* harmony export */   "IJ": function() { return /* binding */ identityApi; },
/* harmony export */   "JK": function() { return /* binding */ shippingApi; },
/* harmony export */   "KT": function() { return /* binding */ securedSessionStorage; },
/* harmony export */   "Mq": function() { return /* binding */ supportContactApi; },
/* harmony export */   "SX": function() { return /* binding */ gtag; },
/* harmony export */   "TB": function() { return /* binding */ eventEmitter; },
/* harmony export */   "Uq": function() { return /* binding */ webSocketClient; },
/* harmony export */   "X3": function() { return /* binding */ backofficeApi; },
/* harmony export */   "XE": function() { return /* binding */ crm; },
/* harmony export */   "Yw": function() { return /* binding */ paymentApi; },
/* harmony export */   "_6": function() { return /* binding */ weddingGiftListApi; },
/* harmony export */   "_X": function() { return /* binding */ jwtDecoder; },
/* harmony export */   "c_": function() { return /* binding */ profileApi; },
/* harmony export */   "dZ": function() { return /* binding */ catalogApi; },
/* harmony export */   "dv": function() { return /* binding */ purchaseApi; },
/* harmony export */   "hI": function() { return /* binding */ clearSaleFingerprint; },
/* harmony export */   "iO": function() { return /* binding */ creditCardUtils; },
/* harmony export */   "jY": function() { return /* binding */ clientIp; },
/* harmony export */   "m1": function() { return /* binding */ stateManager; },
/* harmony export */   "pE": function() { return /* binding */ appMonitoringClient; },
/* harmony export */   "pR": function() { return /* binding */ cookie; },
/* harmony export */   "qn": function() { return /* binding */ envsApi; },
/* harmony export */   "sO": function() { return /* binding */ heatmapClient; },
/* harmony export */   "w": function() { return /* binding */ utilInfoApi; },
/* harmony export */   "wi": function() { return /* binding */ browserBroadcast; }
/* harmony export */ });
/* unused harmony exports cookieParser, genesys, idGenerator */
/* harmony import */ var application_services_apis__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11780);
/* harmony import */ var infra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11338);


var httpClient = infra__WEBPACK_IMPORTED_MODULE_1__/* .SWRHttpClient */ .iE;
var appMonitoringClient = infra__WEBPACK_IMPORTED_MODULE_1__/* .SentryClient */ .I;
var creditCardUtils = infra__WEBPACK_IMPORTED_MODULE_1__/* .CreditCardTypeLib */ .Ld;
var heatmapClient = infra__WEBPACK_IMPORTED_MODULE_1__/* .clarityRaw */ .UQ;
var cookie = infra__WEBPACK_IMPORTED_MODULE_1__/* .CookiesNext */ .H1;
var cookieParser = infra__WEBPACK_IMPORTED_MODULE_1__/* .Cookie */ .Vj;
var genesys = infra__WEBPACK_IMPORTED_MODULE_1__/* .GenesysChatBot */ .M$;
var gtag = infra__WEBPACK_IMPORTED_MODULE_1__/* .gtagRaw */ .EA;
var crm = infra__WEBPACK_IMPORTED_MODULE_1__/* .InsiderObject */ .xp;
var allowMeFingerprint = infra__WEBPACK_IMPORTED_MODULE_1__/* .AllowMeFingerprint */ .Qp;
var clearSaleFingerprint = infra__WEBPACK_IMPORTED_MODULE_1__/* .ClearSaleFingerprint */ .HT;
var idGenerator = infra__WEBPACK_IMPORTED_MODULE_1__/* .UUIDLib */ .GX;
var envsApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .EnvsApi */ .vX(cookie);
var jwtDecoder = new infra__WEBPACK_IMPORTED_MODULE_1__/* .JwtDecode */ .ZQ();
var webSocketClient = new infra__WEBPACK_IMPORTED_MODULE_1__/* .WebSocketRaw */ .U_(envsApi);
var eventEmitter = new infra__WEBPACK_IMPORTED_MODULE_1__/* .DocumentEventListener */ .YJ();
var backofficeApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .BackofficeApi */ .iQ(httpClient, envsApi);
var catalogApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .CatalogApi */ .jx(httpClient, appMonitoringClient, envsApi);
var shippingApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .ShippingApi */ .J_(httpClient, envsApi);
var shoppingApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .ShoppingApi */ .R$(httpClient, appMonitoringClient, envsApi);
var notificationApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .NotificationApi */ .mj(httpClient, appMonitoringClient, envsApi);
var identityApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .IdentityApi */ .xm(httpClient, appMonitoringClient, gtag, envsApi);
var profileApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .ProfileApi */ .R5(httpClient, appMonitoringClient, gtag, envsApi);
var supportContactApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .SupportContactApi */ .tc(infra__WEBPACK_IMPORTED_MODULE_1__/* .MockedClient */ .SA);
var utilInfoApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .UtilInfoApi */ .Ny(infra__WEBPACK_IMPORTED_MODULE_1__/* .MockedClient */ .SA, envsApi);
var weddingGiftListApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .WeddingGiftListApi */ .AT(httpClient, appMonitoringClient, envsApi);
var purchaseApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .PurchaseApi */ .K$(httpClient, appMonitoringClient, gtag, envsApi);
var paymentApi = new application_services_apis__WEBPACK_IMPORTED_MODULE_0__/* .PaymentApi */ .gY(httpClient, appMonitoringClient, envsApi);
var clientIp = new infra__WEBPACK_IMPORTED_MODULE_1__/* .RequestIp */ .h7(cookie);
var stateManager = {
    createStore: infra__WEBPACK_IMPORTED_MODULE_1__/* .ZustandImpl.createStore */ .g3.createStore,
    produceNewState: infra__WEBPACK_IMPORTED_MODULE_1__/* .ImmerImpl.produceNewState */ .TD.produceNewState
};
var browserBroadcast = new infra__WEBPACK_IMPORTED_MODULE_1__/* .BroadcastChannelRaw */ .iw();
var encrypt = new infra__WEBPACK_IMPORTED_MODULE_1__/* .Encryption */ .dW();
var securedSessionStorage = new infra__WEBPACK_IMPORTED_MODULE_1__/* .SecuredSessionStorage */ .C$(encrypt);



/***/ }),

/***/ 62911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cr": function() { return /* reexport */ EventScroll; },
  "Fb": function() { return /* reexport */ Head; },
  "Ee": function() { return /* reexport */ Image_Image; },
  "EX": function() { return /* reexport */ MagicZoom/* MagicZoom */.E; },
  "jp": function() { return /* reexport */ NextjsBreadcrumbs; },
  "IM": function() { return /* reexport */ ReactCountdownCircleTimer; },
  "jL": function() { return /* reexport */ ReactDatePicker; },
  "L9": function() { return /* reexport */ ReactLoadingSkeleton; },
  "Fv": function() { return /* reexport */ ReactModal; },
  "OA": function() { return /* reexport */ ReactSlick; },
  "sN": function() { return /* reexport */ ReactSpringBottomSheet; },
  "Q9": function() { return /* reexport */ ReactVideoPlayer; },
  "Aw": function() { return /* reexport */ ScrollToLink; },
  "tI": function() { return /* reexport */ SwiperSlider; }
});

// UNUSED EXPORTS: CustomSWRConfig, Html2Canvas, ImageMagnify, MultiEmailInput, ReactEasyCrop, ReactResponsiveCarousel

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/html2canvas/dist/html2canvas.js
var dist_html2canvas = __webpack_require__(31763);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/index.tsx + 24 modules
var ui = __webpack_require__(26365);
;// CONCATENATED MODULE: ../../packages/infra/components/lib/Html2Canvas/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var style_DownloadLink = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__DownloadLink",
    componentId: "sc-8b90511f-0"
})(_templateObject(), function(param) {
    var colorLink = param.colorLink;
    return colorLink || ui.theme.colors.neutral[999];
});

;// CONCATENATED MODULE: ../../packages/infra/components/lib/Html2Canvas/index.tsx






var Html2Canvas = function(param) {
    var className = param.className, fileName = param.fileName, colorLink = param.colorLink, iconLink = param.iconLink, textLink = param.textLink;
    var downloadToImage = function() {
        var element = document.querySelector(".".concat(className));
        var button = element === null || element === void 0 ? void 0 : element.querySelector(".downloadLink");
        if (element && button) {
            button.style.display = "none";
            html2canvas(element, {
                allowTaint: false,
                useCORS: true
            }).then(function(canvas) {
                var link = document.createElement("a");
                link.download = fileName;
                link.href = canvas.toDataURL("image/png");
                link.click();
            });
        }
    };
    return /*#__PURE__*/ _jsxs(DownloadLink, _object_spread_props(_object_spread({}, buildTestIds("download-link-".concat(className))), {
        type: "button",
        colorLink: colorLink,
        onClick: downloadToImage,
        className: "downloadLink",
        children: [
            iconLink,
            " ",
            textLink
        ]
    }));
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ../../node_modules/nextjs-breadcrumbs/dist/index.modern.js




var getPathFromUrl = function getPathFromUrl(url) {
  return url.split(/[?#]/)[0];
};

var convertBreadcrumb = function convertBreadcrumb(title, toUpperCase, replaceCharacterList, transformLabel) {
  var transformedTitle = getPathFromUrl(title);

  if (transformLabel) {
    return transformLabel(transformedTitle);
  }

  if (replaceCharacterList) {
    for (var i = 0; i < replaceCharacterList.length; i++) {
      transformedTitle = transformedTitle.replaceAll(replaceCharacterList[i].from, replaceCharacterList[i].to);
    }
  }

  return toUpperCase ? decodeURI(transformedTitle).toUpperCase() : decodeURI(transformedTitle);
};

var defaultProps = {
  useDefaultStyle: false,
  rootLabel: 'Home',
  omitRootLabel: false,
  labelsToUppercase: false,
  replaceCharacterList: [{
    from: '-',
    to: ' '
  }],
  transformLabel: undefined,
  omitIndexList: undefined,
  containerStyle: null,
  containerClassName: '',
  listStyle: null,
  listClassName: '',
  inactiveItemStyle: null,
  inactiveItemClassName: '',
  activeItemStyle: null,
  activeItemClassName: ''
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var useDefaultStyle = _ref.useDefaultStyle,
      rootLabel = _ref.rootLabel,
      omitRootLabel = _ref.omitRootLabel,
      labelsToUppercase = _ref.labelsToUppercase,
      replaceCharacterList = _ref.replaceCharacterList,
      transformLabel = _ref.transformLabel,
      omitIndexList = _ref.omitIndexList,
      containerStyle = _ref.containerStyle,
      containerClassName = _ref.containerClassName,
      listStyle = _ref.listStyle,
      listClassName = _ref.listClassName,
      inactiveItemStyle = _ref.inactiveItemStyle,
      inactiveItemClassName = _ref.inactiveItemClassName,
      activeItemStyle = _ref.activeItemStyle,
      activeItemClassName = _ref.activeItemClassName;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(null),
      breadcrumbs = _useState[0],
      setBreadcrumbs = _useState[1];

  (0,react.useEffect)(function () {
    if (router) {
      var linkPath = router.asPath.split('/');
      linkPath.shift();
      var pathArray = linkPath.map(function (path, i) {
        return {
          breadcrumb: path,
          href: '/' + linkPath.slice(0, i + 1).join('/')
        };
      });
      setBreadcrumbs(pathArray);
    }
  }, [router]);

  if (!breadcrumbs) {
    return null;
  }

  return react.createElement("nav", {
    style: containerStyle,
    className: containerClassName,
    "aria-label": "breadcrumbs"
  }, react.createElement("ol", {
    style: listStyle,
    className: useDefaultStyle ? '_2jvtI' : listClassName
  }, !omitRootLabel && react.createElement("li", {
    style: inactiveItemStyle,
    className: inactiveItemClassName
  }, react.createElement((link_default()), {
    href: "/"
  }, react.createElement("a", null, convertBreadcrumb(rootLabel || 'Home', labelsToUppercase, replaceCharacterList, transformLabel)))), breadcrumbs.length >= 1 && breadcrumbs.map(function (breadcrumb, i) {
    if (!breadcrumb || breadcrumb.breadcrumb.length === 0 || omitIndexList && omitIndexList.find(function (value) {
      return value === i;
    })) {
      return;
    }

    return react.createElement("li", {
      key: breadcrumb.href,
      className: i === breadcrumbs.length - 1 ? activeItemClassName : inactiveItemClassName,
      style: i === breadcrumbs.length - 1 ? activeItemStyle : inactiveItemStyle
    }, react.createElement((link_default()), {
      href: breadcrumb.href
    }, react.createElement("a", null, convertBreadcrumb(breadcrumb.breadcrumb, labelsToUppercase, replaceCharacterList, transformLabel))));
  })));
};

Breadcrumbs.defaultProps = defaultProps;

/* harmony default export */ var index_modern = (Breadcrumbs);
//# sourceMappingURL=index.modern.js.map

;// CONCATENATED MODULE: ../../packages/infra/components/lib/NextjsBreadcrumbs/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  &:after {\n    content: " ";\n    display: block;\n    width: 5px;\n    height: 5px;\n    border-top: 1px solid ',
        ";\n    border-left: 1px solid ",
        ";\n    transform: rotate(135deg);\n    top: 5px;\n    left: 90%;\n    z-index: 2;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n\n  ol {\n    display: flex;\n    align-items: center;\n    list-style: none;\n\n    li {\n      /* &:last-child a {\n        pointer-events: none;\n        cursor: default;\n      } */\n\n      :last-child a::after {\n        border: 0;\n      }\n    }\n\n    li a {\n      position: relative;\n      margin-right: 15px;\n      padding-right: 15px;\n      text-decoration: none;\n      color: ",
        ';\n    }\n\n    li a::after {\n      content: " ";\n      display: block;\n      margin: 30px auto;\n      width: 5px;\n      height: 5px;\n      border-top: 1px solid ',
        ";\n      border-left: 1px solid ",
        ";\n      transform: rotate(135deg);\n      position: absolute;\n      top: 5px;\n      margin-top: 0;\n      left: 90%;\n      z-index: 2;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var LinkStyled = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
    displayName: "styles__LinkStyled",
    componentId: "sc-88acd2d-0"
})(styles_templateObject());
var InnerLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__InnerLink",
    componentId: "sc-88acd2d-1"
})(_templateObject1());
var ArrowStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ArrowStyled",
    componentId: "sc-88acd2d-2"
})(_templateObject2(), ui.theme.colors.neutral[315], ui.theme.colors.neutral[315]);
var CustomBreadcrumbNavigation = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "styles__CustomBreadcrumbNavigation",
    componentId: "sc-88acd2d-3"
})(_templateObject3());
var CustomBreadcrumbList = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    displayName: "styles__CustomBreadcrumbList",
    componentId: "sc-88acd2d-4"
})(_templateObject4());
var CustomBreadcrumbItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "styles__CustomBreadcrumbItem",
    componentId: "sc-88acd2d-5"
})(_templateObject5());
var BreadcrumbsStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BreadcrumbsStyled",
    componentId: "sc-88acd2d-6"
})(_templateObject6(), ui.theme.space["x2.5"], ui.theme.colors.neutral[450], ui.theme.colors.neutral[315], ui.theme.colors.neutral[315]);

;// CONCATENATED MODULE: ../../packages/infra/components/lib/NextjsBreadcrumbs/index.tsx








var NextjsBreadcrumbs = function(param) {
    var _omitRootLabel = param.omitRootLabel, omitRootLabel = _omitRootLabel === void 0 ? false : _omitRootLabel, _useDefaultStyle = param.useDefaultStyle, useDefaultStyle = _useDefaultStyle === void 0 ? false : _useDefaultStyle, _rootLabel = param.rootLabel, rootLabel = _rootLabel === void 0 ? "Home" : _rootLabel, _replaceCharacterList = param.replaceCharacterList, replaceCharacterList = _replaceCharacterList === void 0 ? [
        {
            from: "sofas",
            to: "Sof\xe1s"
        }
    ] : _replaceCharacterList, customLabels = param.customLabels;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BreadcrumbsStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("breadcrumbs-styled-component")), {
        children: [
            omitRootLabel ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("breadcrumbs-home-link")), {
                        href: "/",
                        target: "_self",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("breadcrumbs-home-inner-link")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.Home, {
                                width: 16,
                                height: 16,
                                color: ui.theme.colors.neutral[450]
                            })
                        }))
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowStyled, (0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("arrow-styled-icon")))
                ]
            }),
            (customLabels === null || customLabels === void 0 ? void 0 : customLabels.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadcrumbNavigation, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-breadcrumb-navigation")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadcrumbList, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-breadcrumb-list")), {
                    children: customLabels === null || customLabels === void 0 ? void 0 : customLabels.map(function(customLabel, index) {
                        /*#__PURE__*/ return (0,react.createElement)(CustomBreadcrumbItem, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-breadcrumb-item-".concat(index))), {
                            key: customLabel.label
                        }), /*#__PURE__*/ (0,react.createElement)(LinkStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("custom-breadcrumb-link-styled-".concat(index))), {
                            key: customLabel.label,
                            href: customLabel === null || customLabel === void 0 ? void 0 : customLabel.redirectTo,
                            target: "_self"
                        }), (0,application/* capitalizeAll */.R0u)(customLabel === null || customLabel === void 0 ? void 0 : customLabel.label)));
                    })
                }))
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("breadcrumbs-component")), {
                omitRootLabel: true,
                useDefaultStyle: useDefaultStyle,
                rootLabel: rootLabel,
                replaceCharacterList: replaceCharacterList,
                omitIndexList: [
                    0
                ]
            }))
        ]
    }));
};


// EXTERNAL MODULE: ../../node_modules/react-spring-bottom-sheet/dist/style.css
var style = __webpack_require__(16789);
// EXTERNAL MODULE: ../../node_modules/warning/warning.js
var warning = __webpack_require__(45982);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ../../node_modules/@reach/utils/dist/reach-utils.esm.js




/* eslint-disable no-restricted-globals, eqeqeq  */

/**
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * TODO: We are calling useLayoutEffect in a couple of places that will likely
 * cause some issues for SSR users, whether the warning shows or not. Audit and
 * fix these.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */
var useIsomorphicLayoutEffect = /*#__PURE__*/canUseDOM() ? react.useLayoutEffect : react.useEffect;
var checkedPkgs = {};
/**
 * Copy of Facebook's warning package.
 *
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical paths.
 * Removing the logging code for production environments will keep the same
 * logic and follow the same code paths.
 *
 * @see https://github.com/BerkeleyTrue/warning/blob/master/warning.js
 */

var reach_utils_esm_warning = (warning_default());
/**
 * When in dev mode, checks that styles for a given @reach package are loaded.
 *
 * @param packageName Name of the package to check.
 * @example checkStyles("dialog") will check for styles for @reach/dialog
 */

var checkStyles = noop;

if (false) { var _ref, env; }
/**
 * Ponyfill for the global object in some environments.
 *
 * @link https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */

var ponyfillGlobal = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self :
/*#__PURE__*/
// eslint-disable-next-line no-new-func
Function("return this")();
/**
 * Passes or assigns an arbitrary value to a ref function or object.
 *
 * @param ref
 * @param value
 */

function assignRef(ref, value) {
  if (ref == null) return;

  if (reach_utils_esm_isFunction(ref)) {
    ref(value);
  } else {
    try {
      ref.current = value;
    } catch (error) {
      throw new Error("Cannot assign value \"" + value + "\" to ref \"" + ref + "\"");
    }
  }
}
/**
 * Checks true|"true" vs false|"false"
 *
 * @param value
 */

function boolOrBoolString(value) {
  return value === "true" ? true : isBoolean(value) ? value : false;
}
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
/**
 * Type-safe clone element
 *
 * @param element
 * @param props
 * @param children
 */

function cloneValidElement(element, props) {
  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  return /*#__PURE__*/isValidElement(element) ? cloneElement.apply(React, [element, props].concat(children)) : element;
}
function createNamedContext(name, defaultValue) {
  var Ctx = /*#__PURE__*/createContext(defaultValue);
  Ctx.displayName = name;
  return Ctx;
}
/**
 * This is a hack for sure. The thing is, getting a component to intelligently
 * infer props based on a component or JSX string passed into an `as` prop is
 * kind of a huge pain. Getting it to work and satisfy the constraints of
 * `forwardRef` seems dang near impossible. To avoid needing to do this awkward
 * type song-and-dance every time we want to forward a ref into a component
 * that accepts an `as` prop, we abstract all of that mess to this function for
 * the time time being.
 */

function forwardRefWithAs(render) {
  return /*#__PURE__*/forwardRef(render);
}
function memoWithAs(Component, propsAreEqual) {
  return /*#__PURE__*/memo(Component, propsAreEqual);
}
/**
 * Get the size of the working document minus the scrollbar offset.
 *
 * @param element
 */

function getDocumentDimensions(element) {
  var _ownerDocument$docume, _ownerDocument$docume2;

  var ownerDocument = getOwnerDocument(element);
  var ownerWindow = ownerDocument.defaultView || window;

  if (!ownerDocument) {
    return {
      width: 0,
      height: 0
    };
  }

  return {
    width: (_ownerDocument$docume = ownerDocument.documentElement.clientWidth) != null ? _ownerDocument$docume : ownerWindow.innerWidth,
    height: (_ownerDocument$docume2 = ownerDocument.documentElement.clientHeight) != null ? _ownerDocument$docume2 : ownerWindow.innerHeight
  };
}
/**
 * Get the scoll position of the global window object relative to a given node.
 *
 * @param element
 */

function getScrollPosition(element) {
  var ownerDocument = getOwnerDocument(element);
  var ownerWindow = ownerDocument.defaultView || window;

  if (!ownerDocument) {
    return {
      scrollX: 0,
      scrollY: 0
    };
  }

  return {
    scrollX: ownerWindow.scrollX,
    scrollY: ownerWindow.scrollY
  };
}
/**
 * Get a computed style value by property.
 *
 * @param element
 * @param styleProp
 */

function getElementComputedStyle(element, styleProp) {
  var ownerDocument = getOwnerDocument(element);
  var ownerWindow = (ownerDocument == null ? void 0 : ownerDocument.defaultView) || window;

  if (ownerWindow) {
    return ownerWindow.getComputedStyle(element, null).getPropertyValue(styleProp);
  }

  return null;
}
/**
 * Get an element's owner document. Useful when components are used in iframes
 * or other environments like dev tools.
 *
 * @param element
 */

function getOwnerDocument(element) {
  return canUseDOM() ? element ? element.ownerDocument : document : null;
}
/**
 * TODO: Remove in 1.0
 */

function getOwnerWindow(element) {
  var ownerDocument = getOwnerDocument(element);
  return ownerDocument ? ownerDocument.defaultView || window : null;
}
/**
 * Get the scrollbar offset distance.
 *
 * TODO: Remove in 1.0 (we used this in public examples)
 */

function getScrollbarOffset() {
  try {
    if (window.innerWidth > document.documentElement.clientWidth) {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  } catch (err) {}

  return 0;
}
/**
 * Checks whether or not a value is a boolean.
 *
 * @param value
 */

function isBoolean(value) {
  return typeof value === "boolean";
}
/**
 * Checks whether or not a value is a function.
 *
 * @param value
 */

function reach_utils_esm_isFunction(value) {
  return !!(value && {}.toString.call(value) == "[object Function]");
}
/**
 * Checks whether or not a value is a number.
 *
 * @param value
 */

function isNumber(value) {
  return typeof value === "number" && !isNaN(value);
}
/**
 * Detects right clicks
 *
 * @param nativeEvent
 */

function isRightClick(nativeEvent) {
  return "which" in nativeEvent ? nativeEvent.which === 3 : "button" in nativeEvent ? nativeEvent.button === 2 : false;
}
/**
 * Checks whether or not a value is a string.
 *
 * @param value
 */

function reach_utils_esm_isString(value) {
  return typeof value === "string";
}
/**
 * Joins strings to format IDs for compound components.
 *
 * @param args
 */

function makeId() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args.filter(function (val) {
    return val != null;
  }).join("--");
}
/**
 * No-op function.
 */

function noop() {}
/**
 * Convert our state strings for HTML data attributes.
 * No need for a fancy kebab-caser here, we know what our state strings are!
 *
 * @param state
 */

function stateToAttributeString(state) {
  return String(state).replace(/([\s_]+)/g, "-").toLowerCase();
}
/**
 * Check if a component is controlled or uncontrolled and return the correct
 * state value and setter accordingly. If the component state is controlled by
 * the app, the setter is a noop.
 *
 * @param controlledValue
 * @param defaultValue
 */

function useControlledState(controlledValue, defaultValue) {
  var controlledRef = useRef(controlledValue != null);

  var _React$useState = useState(defaultValue),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var set = useCallback(function (n) {
    if (!controlledRef.current) {
      setValue(n);
    }
  }, []);
  return [controlledRef.current ? controlledValue : valueState, set];
}
/**
 * Logs a warning in dev mode when a component switches from controlled to
 * uncontrolled, or vice versa
 *
 * A single prop should typically be used to determine whether or not a
 * component is controlled or not.
 *
 * @param controlledValue
 * @param controlledPropName
 * @param componentName
 */

var useControlledSwitchWarning = (/* unused pure expression or super */ null && (noop));

if (false) {}
var useCheckStyles = (/* unused pure expression or super */ null && (noop));

if (false) {}
/**
 * React hook for creating a value exactly once.
 * @see https://github.com/Andarist/use-constant
 */

function useConstant(fn) {
  var ref = useRef();

  if (!ref.current) {
    ref.current = {
      v: fn()
    };
  }

  return ref.current.v;
}
/**
 * @param callback
 */

function useEventCallback(callback) {
  var ref = useRef(callback);
  useIsomorphicLayoutEffect(function () {
    ref.current = callback;
  });
  return useCallback(function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return ref.current.apply(ref, [event].concat(args));
  }, []);
}
function useLazyRef(fn) {
  var ref = useRef({
    __internalSet: true
  });

  if (ref.current && ref.current.__internalSet === true) {
    ref.current = fn();
  }

  return ref;
}
/**
 * TODO: Remove in 1.0
 * @alias useStableCallback
 * @param callback
 */

var useCallbackProp = useStableCallback;
/**
 * Adds a DOM event listener
 *
 * @param eventName
 * @param listener
 * @param element
 */

function useEventListener(eventName, listener, element) {
  if (element === void 0) {
    element = window;
  }

  var savedHandler = useRef(listener);
  useEffect(function () {
    savedHandler.current = listener;
  }, [listener]);
  useEffect(function () {
    var isSupported = element && element.addEventListener;

    if (!isSupported) {
      if (false) {}

      return;
    }

    function eventListener(event) {
      savedHandler.current(event);
    }

    element.addEventListener(eventName, eventListener);
    return function () {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
}
/**
 * Detect when focus changes in our document.
 *
 * @param handleChange
 * @param when
 * @param ownerDocument
 */

function useFocusChange(handleChange, when, ownerDocument) {
  if (handleChange === void 0) {
    handleChange = console.log;
  }

  if (when === void 0) {
    when = "focus";
  }

  if (ownerDocument === void 0) {
    ownerDocument = document;
  }

  var lastActiveElement = useRef(ownerDocument.activeElement);
  useEffect(function () {
    lastActiveElement.current = ownerDocument.activeElement;

    function onChange(event) {
      if (lastActiveElement.current !== ownerDocument.activeElement) {
        handleChange(ownerDocument.activeElement, lastActiveElement.current, event);
        lastActiveElement.current = ownerDocument.activeElement;
      }
    }

    ownerDocument.addEventListener(when, onChange, true);
    return function () {
      ownerDocument.removeEventListener(when, onChange);
    };
  }, [when, handleChange, ownerDocument]);
}
/**
 * Forces a re-render, similar to `forceUpdate` in class components.
 */

function useForceUpdate() {
  var _React$useState2 = (0,react.useState)(Object.create(null)),
      dispatch = _React$useState2[1];

  return (0,react.useCallback)(function () {
    dispatch(Object.create(null));
  }, []);
}
/**
 * Passes or assigns a value to multiple refs (typically a DOM node). Useful for
 * dealing with components that need an explicit ref for DOM calculations but
 * also forwards refs assigned by an app.
 *
 * @param refs Refs to fork
 */

function useForkedRef() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }

  return useMemo(function () {
    if (refs.every(function (ref) {
      return ref == null;
    })) {
      return null;
    }

    return function (node) {
      refs.forEach(function (ref) {
        assignRef(ref, node);
      });
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [].concat(refs));
}
/**
 * Returns the previous value of a reference after a component update.
 *
 * @param value
 */

function usePrevious(value) {
  var ref = useRef(null);
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}
/**
 * Converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop and exposed as a stable function to avoid executing effects when
 * passed as a dependency.
 */

function useStableCallback(callback) {
  var callbackRef = (0,react.useRef)(callback);
  (0,react.useEffect)(function () {
    callbackRef.current = callback;
  }); // eslint-disable-next-line react-hooks/exhaustive-deps

  return (0,react.useCallback)(function () {
    callbackRef.current && callbackRef.current.apply(callbackRef, arguments);
  }, []);
}
/**
 * Call an effect after a component update, skipping the initial mount.
 *
 * @param effect Effect to call
 * @param deps Effect dependency list
 */

function useUpdateEffect(effect, deps) {
  var mounted = useRef(false);
  useEffect(function () {
    if (mounted.current) {
      effect();
    } else {
      mounted.current = true;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, deps);
}
/**
 * Just a lil state logger
 *
 * @param state
 * @param DEBUG
 */

var useStateLogger = (/* unused pure expression or super */ null && (noop));

if (false) {}
/**
 * Wraps a lib-defined event handler and a user-defined event handler, returning
 * a single handler that allows a user to prevent lib-defined handlers from
 * firing.
 *
 * @param theirHandler User-supplied event handler
 * @param ourHandler Library-supplied event handler
 */

function wrapEvent(theirHandler, ourHandler) {
  return function (event) {
    theirHandler && theirHandler(event);

    if (!event.defaultPrevented) {
      return ourHandler(event);
    }
  };
} // Export types



// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/@reach/portal/dist/reach-portal.esm.js




/**
 * Welcome to @reach/portal!
 *
 * Creates and appends a DOM node to the end of `document.body` and renders a
 * React tree into it. Useful for rendering a natural React element hierarchy
 * with a different DOM hierarchy to prevent parent styles from clipping or
 * hiding content (for popovers, dropdowns, and modals).
 *
 * @see Docs   https://reach.tech/portal
 * @see Source https://github.com/reach/reach-ui/tree/main/packages/portal
 * @see React  https://reactjs.org/docs/portals.html
 */
/**
 * Portal
 *
 * @see Docs https://reach.tech/portal#portal
 */

var Portal = function Portal(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "reach-portal" : _ref$type;
  var mountNode = (0,react.useRef)(null);
  var portalNode = (0,react.useRef)(null);
  var forceUpdate = useForceUpdate();
  useIsomorphicLayoutEffect(function () {
    // This ref may be null when a hot-loader replaces components on the page
    if (!mountNode.current) return; // It's possible that the content of the portal has, itself, been portaled.
    // In that case, it's important to append to the correct document element.

    var ownerDocument = mountNode.current.ownerDocument;
    portalNode.current = ownerDocument == null ? void 0 : ownerDocument.createElement(type);
    ownerDocument.body.appendChild(portalNode.current);
    forceUpdate();
    return function () {
      if (portalNode.current && portalNode.current.ownerDocument) {
        portalNode.current.ownerDocument.body.removeChild(portalNode.current);
      }
    };
  }, [type, forceUpdate]);
  return portalNode.current ? /*#__PURE__*/(0,react_dom.createPortal)(children, portalNode.current) : /*#__PURE__*/(0,react.createElement)("span", {
    ref: mountNode
  });
};
/**
 * @see Docs https://reach.tech/portal#portal-props
 */


if (false) {} ////////////////////////////////////////////////////////////////////////////////

/* harmony default export */ var reach_portal_esm = (Portal);


;// CONCATENATED MODULE: ../../node_modules/xstate/es/_virtual/_tslib.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _tslib_assign = function() {
    _tslib_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return _tslib_assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function _tslib_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}



;// CONCATENATED MODULE: ../../node_modules/xstate/es/constants.js
var STATE_DELIMITER = '.';
var EMPTY_ACTIVITY_MAP = {};
var DEFAULT_GUARD_TYPE = 'xstate.guard';
var TARGETLESS_KEY = '';



;// CONCATENATED MODULE: ../../node_modules/xstate/es/types.js
var ActionTypes;

(function (ActionTypes) {
  ActionTypes["Start"] = "xstate.start";
  ActionTypes["Stop"] = "xstate.stop";
  ActionTypes["Raise"] = "xstate.raise";
  ActionTypes["Send"] = "xstate.send";
  ActionTypes["Cancel"] = "xstate.cancel";
  ActionTypes["NullEvent"] = "";
  ActionTypes["Assign"] = "xstate.assign";
  ActionTypes["After"] = "xstate.after";
  ActionTypes["DoneState"] = "done.state";
  ActionTypes["DoneInvoke"] = "done.invoke";
  ActionTypes["Log"] = "xstate.log";
  ActionTypes["Init"] = "xstate.init";
  ActionTypes["Invoke"] = "xstate.invoke";
  ActionTypes["ErrorExecution"] = "error.execution";
  ActionTypes["ErrorCommunication"] = "error.communication";
  ActionTypes["ErrorPlatform"] = "error.platform";
  ActionTypes["ErrorCustom"] = "xstate.error";
  ActionTypes["Update"] = "xstate.update";
  ActionTypes["Pure"] = "xstate.pure";
  ActionTypes["Choose"] = "xstate.choose";
})(ActionTypes || (ActionTypes = {}));

var types_SpecialTargets;

(function (SpecialTargets) {
  SpecialTargets["Parent"] = "#_parent";
  SpecialTargets["Internal"] = "#_internal";
})(types_SpecialTargets || (types_SpecialTargets = {}));



;// CONCATENATED MODULE: ../../node_modules/xstate/es/actionTypes.js


var start = ActionTypes.Start;
var stop = ActionTypes.Stop;
var raise = ActionTypes.Raise;
var send = ActionTypes.Send;
var cancel = ActionTypes.Cancel;
var nullEvent = ActionTypes.NullEvent;
var actionTypes_assign = ActionTypes.Assign;
var after = ActionTypes.After;
var doneState = ActionTypes.DoneState;
var log = ActionTypes.Log;
var init = ActionTypes.Init;
var invoke = ActionTypes.Invoke;
var errorExecution = ActionTypes.ErrorExecution;
var errorPlatform = ActionTypes.ErrorPlatform;
var actionTypes_error = ActionTypes.ErrorCustom;
var update = ActionTypes.Update;
var choose = ActionTypes.Choose;
var pure = ActionTypes.Pure;



;// CONCATENATED MODULE: ../../node_modules/xstate/es/environment.js
var environment_IS_PRODUCTION = "production" === 'production';



;// CONCATENATED MODULE: ../../node_modules/xstate/es/utils.js






var _a;
function keys(value) {
  return Object.keys(value);
}
function matchesState(parentStateId, childStateId, delimiter) {
  if (delimiter === void 0) {
    delimiter = STATE_DELIMITER;
  }

  var parentStateValue = toStateValue(parentStateId, delimiter);
  var childStateValue = toStateValue(childStateId, delimiter);

  if (utils_isString(childStateValue)) {
    if (utils_isString(parentStateValue)) {
      return childStateValue === parentStateValue;
    } // Parent more specific than child


    return false;
  }

  if (utils_isString(parentStateValue)) {
    return parentStateValue in childStateValue;
  }

  return Object.keys(parentStateValue).every(function (key) {
    if (!(key in childStateValue)) {
      return false;
    }

    return matchesState(parentStateValue[key], childStateValue[key]);
  });
}
function getEventType(event) {
  try {
    return utils_isString(event) || typeof event === 'number' ? "".concat(event) : event.type;
  } catch (e) {
    throw new Error('Events must be strings or objects with a string event.type property.');
  }
}
function getActionType(action) {
  try {
    return utils_isString(action) || typeof action === 'number' ? "".concat(action) : utils_isFunction(action) ? action.name : action.type;
  } catch (e) {
    throw new Error('Actions must be strings or objects with a string action.type property.');
  }
}
function toStatePath(stateId, delimiter) {
  try {
    if (isArray(stateId)) {
      return stateId;
    }

    return stateId.toString().split(delimiter);
  } catch (e) {
    throw new Error("'".concat(stateId, "' is not a valid state path."));
  }
}
function isStateLike(state) {
  return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
}
function toStateValue(stateValue, delimiter) {
  if (isStateLike(stateValue)) {
    return stateValue.value;
  }

  if (isArray(stateValue)) {
    return pathToStateValue(stateValue);
  }

  if (typeof stateValue !== 'string') {
    return stateValue;
  }

  var statePath = toStatePath(stateValue, delimiter);
  return pathToStateValue(statePath);
}
function pathToStateValue(statePath) {
  if (statePath.length === 1) {
    return statePath[0];
  }

  var value = {};
  var marker = value;

  for (var i = 0; i < statePath.length - 1; i++) {
    if (i === statePath.length - 2) {
      marker[statePath[i]] = statePath[i + 1];
    } else {
      marker[statePath[i]] = {};
      marker = marker[statePath[i]];
    }
  }

  return value;
}
function mapValues(collection, iteratee) {
  var result = {};
  var collectionKeys = Object.keys(collection);

  for (var i = 0; i < collectionKeys.length; i++) {
    var key = collectionKeys[i];
    result[key] = iteratee(collection[key], key, collection, i);
  }

  return result;
}
function mapFilterValues(collection, iteratee, predicate) {
  var e_1, _a;

  var result = {};

  try {
    for (var _b = _tslib_values(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var item = collection[key];

      if (!predicate(item)) {
        continue;
      }

      result[key] = iteratee(item, key, collection);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */

var path = function (props) {
  return function (object) {
    var e_2, _a;

    var result = object;

    try {
      for (var props_1 = _tslib_values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
        var prop = props_1_1.value;
        result = result[prop];
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return result;
  };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */

function nestedPath(props, accessorProp) {
  return function (object) {
    var e_3, _a;

    var result = object;

    try {
      for (var props_2 = _tslib_values(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()) {
        var prop = props_2_1.value;
        result = result[accessorProp][prop];
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    return result;
  };
}
function toStatePaths(stateValue) {
  if (!stateValue) {
    return [[]];
  }

  if (utils_isString(stateValue)) {
    return [[stateValue]];
  }

  var result = flatten(Object.keys(stateValue).map(function (key) {
    var subStateValue = stateValue[key];

    if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) {
      return [[key]];
    }

    return toStatePaths(stateValue[key]).map(function (subPath) {
      return [key].concat(subPath);
    });
  }));
  return result;
}
function pathsToStateValue(paths) {
  var e_4, _a;

  var result = {};

  if (paths && paths.length === 1 && paths[0].length === 1) {
    return paths[0][0];
  }

  try {
    for (var paths_1 = __values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
      var currentPath = paths_1_1.value;
      var marker = result; // tslint:disable-next-line:prefer-for-of

      for (var i = 0; i < currentPath.length; i++) {
        var subPath = currentPath[i];

        if (i === currentPath.length - 2) {
          marker[subPath] = currentPath[i + 1];
          break;
        }

        marker[subPath] = marker[subPath] || {};
        marker = marker[subPath];
      }
    }
  } catch (e_4_1) {
    e_4 = {
      error: e_4_1
    };
  } finally {
    try {
      if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
    } finally {
      if (e_4) throw e_4.error;
    }
  }

  return result;
}
function flatten(array) {
  var _a;

  return (_a = []).concat.apply(_a, __spreadArray([], __read(array), false));
}
function toArrayStrict(value) {
  if (isArray(value)) {
    return value;
  }

  return [value];
}
function toArray(value) {
  if (value === undefined) {
    return [];
  }

  return toArrayStrict(value);
}
function mapContext(mapper, context, _event) {
  var e_5, _a;

  if (utils_isFunction(mapper)) {
    return mapper(context, _event.data);
  }

  var result = {};

  try {
    for (var _b = _tslib_values(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var subMapper = mapper[key];

      if (utils_isFunction(subMapper)) {
        result[key] = subMapper(context, _event.data);
      } else {
        result[key] = subMapper;
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_5) throw e_5.error;
    }
  }

  return result;
}
function isBuiltInEvent(eventType) {
  return /^(done|error)\./.test(eventType);
}
function isPromiseLike(value) {
  if (value instanceof Promise) {
    return true;
  } // Check if shape matches the Promise/A+ specification for a "thenable".


  if (value !== null && (utils_isFunction(value) || typeof value === 'object') && utils_isFunction(value.then)) {
    return true;
  }

  return false;
}
function isBehavior(value) {
  return value !== null && typeof value === 'object' && 'transition' in value && typeof value.transition === 'function';
}
function partition(items, predicate) {
  var e_6, _a;

  var _b = __read([[], []], 2),
      truthy = _b[0],
      falsy = _b[1];

  try {
    for (var items_1 = _tslib_values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
      var item = items_1_1.value;

      if (predicate(item)) {
        truthy.push(item);
      } else {
        falsy.push(item);
      }
    }
  } catch (e_6_1) {
    e_6 = {
      error: e_6_1
    };
  } finally {
    try {
      if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
    } finally {
      if (e_6) throw e_6.error;
    }
  }

  return [truthy, falsy];
}
function updateHistoryStates(hist, stateValue) {
  return mapValues(hist.states, function (subHist, key) {
    if (!subHist) {
      return undefined;
    }

    var subStateValue = (utils_isString(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);

    if (!subStateValue) {
      return undefined;
    }

    return {
      current: subStateValue,
      states: updateHistoryStates(subHist, subStateValue)
    };
  });
}
function updateHistoryValue(hist, stateValue) {
  return {
    current: stateValue,
    states: updateHistoryStates(hist, stateValue)
  };
}
function updateContext(context, _event, assignActions, state) {
  if (!environment_IS_PRODUCTION) {
    utils_warn(!!context, 'Attempting to update undefined context');
  }

  var updatedContext = context ? assignActions.reduce(function (acc, assignAction) {
    var e_7, _a;

    var assignment = assignAction.assignment;
    var meta = {
      state: state,
      action: assignAction,
      _event: _event
    };
    var partialUpdate = {};

    if (utils_isFunction(assignment)) {
      partialUpdate = assignment(acc, _event.data, meta);
    } else {
      try {
        for (var _b = _tslib_values(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          var propAssignment = assignment[key];
          partialUpdate[key] = utils_isFunction(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_7) throw e_7.error;
        }
      }
    }

    return Object.assign({}, acc, partialUpdate);
  }, context) : context;
  return updatedContext;
} // tslint:disable-next-line:no-empty

var utils_warn = function () {};

if (!environment_IS_PRODUCTION) {
  utils_warn = function (condition, message) {
    var error = condition instanceof Error ? condition : undefined;

    if (!error && condition) {
      return;
    }

    if (console !== undefined) {
      var args = ["Warning: ".concat(message)];

      if (error) {
        args.push(error);
      } // tslint:disable-next-line:no-console


      console.warn.apply(console, args);
    }
  };
}
function isArray(value) {
  return Array.isArray(value);
} // tslint:disable-next-line:ban-types

function utils_isFunction(value) {
  return typeof value === 'function';
}
function utils_isString(value) {
  return typeof value === 'string';
}
function toGuard(condition, guardMap) {
  if (!condition) {
    return undefined;
  }

  if (utils_isString(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition,
      predicate: guardMap ? guardMap[condition] : undefined
    };
  }

  if (utils_isFunction(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition.name,
      predicate: condition
    };
  }

  return condition;
}
function isObservable(value) {
  try {
    return 'subscribe' in value && utils_isFunction(value.subscribe);
  } catch (e) {
    return false;
  }
}
var symbolObservable = /*#__PURE__*/function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages

var interopSymbols = (_a = {}, _a[symbolObservable] = function () {
  return this;
}, _a[Symbol.observable] = function () {
  return this;
}, _a);
function utils_isMachine(value) {
  return !!value && '__xstatenode' in value;
}
function isActor(value) {
  return !!value && typeof value.send === 'function';
}
var utils_uniqueId = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var currentId = 0;
  return function () {
    currentId++;
    return currentId.toString(16);
  };
}()));
function toEventObject(event, payload // id?: TEvent['type']
) {
  if (utils_isString(event) || typeof event === 'number') {
    return _tslib_assign({
      type: event
    }, payload);
  }

  return event;
}
function toSCXMLEvent(event, scxmlEvent) {
  if (!utils_isString(event) && '$$type' in event && event.$$type === 'scxml') {
    return event;
  }

  var eventObject = toEventObject(event);
  return _tslib_assign({
    name: eventObject.type,
    data: eventObject,
    $$type: 'scxml',
    type: 'external'
  }, scxmlEvent);
}
function toTransitionConfigArray(event, configLike) {
  var transitions = toArrayStrict(configLike).map(function (transitionLike) {
    if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || utils_isMachine(transitionLike)) {
      return {
        target: transitionLike,
        event: event
      };
    }

    return _tslib_assign(_tslib_assign({}, transitionLike), {
      event: event
    });
  });
  return transitions;
}
function normalizeTarget(target) {
  if (target === undefined || target === TARGETLESS_KEY) {
    return undefined;
  }

  return toArray(target);
}
function reportUnhandledExceptionOnInvocation(originalError, currentError, id) {
  if (!environment_IS_PRODUCTION) {
    var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : '';

    if (originalError === currentError) {
      // tslint:disable-next-line:no-console
      console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
    } else {
      var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ''; // tslint:disable-next-line:no-console

      console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
    }
  }
}
function evaluateGuard(machine, guard, context, _event, state) {
  var guards = machine.options.guards;
  var guardMeta = {
    state: state,
    cond: guard,
    _event: _event
  }; // TODO: do not hardcode!

  if (guard.type === DEFAULT_GUARD_TYPE) {
    return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
  }

  var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];

  if (!condFn) {
    throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
  }

  return condFn(context, _event.data, guardMeta);
}
function toInvokeSource(src) {
  if (typeof src === 'string') {
    return {
      type: src
    };
  }

  return src;
}
function toObserver(nextHandler, errorHandler, completionHandler) {
  var noop = function () {};

  var isObserver = typeof nextHandler === 'object';
  var self = isObserver ? nextHandler : null;
  return {
    next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
    error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
    complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
  };
}
function createInvokeId(stateNodeId, index) {
  return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function isRaisableAction(action) {
  return (action.type === raise || action.type === send && action.to === types_SpecialTargets.Internal) && typeof action.delay !== 'number';
}



;// CONCATENATED MODULE: ../../node_modules/xstate/es/stateUtils.js



var isLeafNode = function (stateNode) {
  return stateNode.type === 'atomic' || stateNode.type === 'final';
};
function getAllChildren(stateNode) {
  return Object.keys(stateNode.states).map(function (key) {
    return stateNode.states[key];
  });
}
function getChildren(stateNode) {
  return getAllChildren(stateNode).filter(function (sn) {
    return sn.type !== 'history';
  });
}
function getAllStateNodes(stateNode) {
  var stateNodes = [stateNode];

  if (isLeafNode(stateNode)) {
    return stateNodes;
  }

  return stateNodes.concat(flatten(getChildren(stateNode).map(getAllStateNodes)));
}
function getConfiguration(prevStateNodes, stateNodes) {
  var e_1, _a, e_2, _b, e_3, _c, e_4, _d;

  var prevConfiguration = new Set(prevStateNodes);
  var prevAdjList = getAdjList(prevConfiguration);
  var configuration = new Set(stateNodes);

  try {
    // add all ancestors
    for (var configuration_1 = _tslib_values(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()) {
      var s = configuration_1_1.value;
      var m = s.parent;

      while (m && !configuration.has(m)) {
        configuration.add(m);
        m = m.parent;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  var adjList = getAdjList(configuration);

  try {
    // add descendants
    for (var configuration_2 = _tslib_values(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()) {
      var s = configuration_2_1.value; // if previously active, add existing child nodes

      if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) {
        if (prevAdjList.get(s)) {
          prevAdjList.get(s).forEach(function (sn) {
            return configuration.add(sn);
          });
        } else {
          s.initialStateNodes.forEach(function (sn) {
            return configuration.add(sn);
          });
        }
      } else {
        if (s.type === 'parallel') {
          try {
            for (var _e = (e_3 = void 0, _tslib_values(getChildren(s))), _f = _e.next(); !_f.done; _f = _e.next()) {
              var child = _f.value;

              if (!configuration.has(child)) {
                configuration.add(child);

                if (prevAdjList.get(child)) {
                  prevAdjList.get(child).forEach(function (sn) {
                    return configuration.add(sn);
                  });
                } else {
                  child.initialStateNodes.forEach(function (sn) {
                    return configuration.add(sn);
                  });
                }
              }
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
            } finally {
              if (e_3) throw e_3.error;
            }
          }
        }
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
    } finally {
      if (e_2) throw e_2.error;
    }
  }

  try {
    // add all ancestors
    for (var configuration_3 = _tslib_values(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()) {
      var s = configuration_3_1.value;
      var m = s.parent;

      while (m && !configuration.has(m)) {
        configuration.add(m);
        m = m.parent;
      }
    }
  } catch (e_4_1) {
    e_4 = {
      error: e_4_1
    };
  } finally {
    try {
      if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
    } finally {
      if (e_4) throw e_4.error;
    }
  }

  return configuration;
}

function getValueFromAdj(baseNode, adjList) {
  var childStateNodes = adjList.get(baseNode);

  if (!childStateNodes) {
    return {}; // todo: fix?
  }

  if (baseNode.type === 'compound') {
    var childStateNode = childStateNodes[0];

    if (childStateNode) {
      if (isLeafNode(childStateNode)) {
        return childStateNode.key;
      }
    } else {
      return {};
    }
  }

  var stateValue = {};
  childStateNodes.forEach(function (csn) {
    stateValue[csn.key] = getValueFromAdj(csn, adjList);
  });
  return stateValue;
}

function getAdjList(configuration) {
  var e_5, _a;

  var adjList = new Map();

  try {
    for (var configuration_4 = _tslib_values(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()) {
      var s = configuration_4_1.value;

      if (!adjList.has(s)) {
        adjList.set(s, []);
      }

      if (s.parent) {
        if (!adjList.has(s.parent)) {
          adjList.set(s.parent, []);
        }

        adjList.get(s.parent).push(s);
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
    } finally {
      if (e_5) throw e_5.error;
    }
  }

  return adjList;
}
function getValue(rootNode, configuration) {
  var config = getConfiguration([rootNode], configuration);
  return getValueFromAdj(rootNode, getAdjList(config));
}
function has(iterable, item) {
  if (Array.isArray(iterable)) {
    return iterable.some(function (member) {
      return member === item;
    });
  }

  if (iterable instanceof Set) {
    return iterable.has(item);
  }

  return false; // TODO: fix
}
function nextEvents(configuration) {
  return __spreadArray([], __read(new Set(flatten(__spreadArray([], __read(configuration.map(function (sn) {
    return sn.ownEvents;
  })), false)))), false);
}
function isInFinalState(configuration, stateNode) {
  if (stateNode.type === 'compound') {
    return getChildren(stateNode).some(function (s) {
      return s.type === 'final' && has(configuration, s);
    });
  }

  if (stateNode.type === 'parallel') {
    return getChildren(stateNode).every(function (sn) {
      return isInFinalState(configuration, sn);
    });
  }

  return false;
}
function getMeta(configuration) {
  if (configuration === void 0) {
    configuration = [];
  }

  return configuration.reduce(function (acc, stateNode) {
    if (stateNode.meta !== undefined) {
      acc[stateNode.id] = stateNode.meta;
    }

    return acc;
  }, {});
}
function getTagsFromConfiguration(configuration) {
  return new Set(flatten(configuration.map(function (sn) {
    return sn.tags;
  })));
}



;// CONCATENATED MODULE: ../../node_modules/xstate/es/actions.js








var initEvent = /*#__PURE__*/toSCXMLEvent({
  type: init
});
function getActionFunction(actionType, actionFunctionMap) {
  return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function toActionObject(action, actionFunctionMap) {
  var actionObject;

  if (utils_isString(action) || typeof action === 'number') {
    var exec = getActionFunction(action, actionFunctionMap);

    if (utils_isFunction(exec)) {
      actionObject = {
        type: action,
        exec: exec
      };
    } else if (exec) {
      actionObject = exec;
    } else {
      actionObject = {
        type: action,
        exec: undefined
      };
    }
  } else if (utils_isFunction(action)) {
    actionObject = {
      // Convert action to string if unnamed
      type: action.name || action.toString(),
      exec: action
    };
  } else {
    var exec = getActionFunction(action.type, actionFunctionMap);

    if (utils_isFunction(exec)) {
      actionObject = _tslib_assign(_tslib_assign({}, action), {
        exec: exec
      });
    } else if (exec) {
      var actionType = exec.type || action.type;
      actionObject = _tslib_assign(_tslib_assign(_tslib_assign({}, exec), action), {
        type: actionType
      });
    } else {
      actionObject = action;
    }
  }

  return actionObject;
}
var toActionObjects = function (action, actionFunctionMap) {
  if (!action) {
    return [];
  }

  var actions = isArray(action) ? action : [action];
  return actions.map(function (subAction) {
    return toActionObject(subAction, actionFunctionMap);
  });
};
function toActivityDefinition(action) {
  var actionObject = toActionObject(action);
  return _tslib_assign(_tslib_assign({
    id: utils_isString(action) ? action : actionObject.id
  }, actionObject), {
    type: actionObject.type
  });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */

function actions_raise(event, options) {
  return {
    type: raise,
    event: typeof event === 'function' ? event : toEventObject(event),
    delay: options ? options.delay : undefined,
    id: options === null || options === void 0 ? void 0 : options.id
  };
}
function resolveRaise(action, ctx, _event, delaysMap) {
  var meta = {
    _event: _event
  };
  var resolvedEvent = toSCXMLEvent(utils_isFunction(action.event) ? action.event(ctx, _event.data, meta) : action.event);
  var resolvedDelay;

  if (utils_isString(action.delay)) {
    var configDelay = delaysMap && delaysMap[action.delay];
    resolvedDelay = utils_isFunction(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
  } else {
    resolvedDelay = utils_isFunction(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
  }

  return _tslib_assign(_tslib_assign({}, action), {
    type: raise,
    _event: resolvedEvent,
    delay: resolvedDelay
  });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */

function actions_send(event, options) {
  return {
    to: options ? options.to : undefined,
    type: send,
    event: utils_isFunction(event) ? event : toEventObject(event),
    delay: options ? options.delay : undefined,
    // TODO: don't auto-generate IDs here like that
    // there is too big chance of the ID collision
    id: options && options.id !== undefined ? options.id : utils_isFunction(event) ? event.name : getEventType(event)
  };
}
function resolveSend(action, ctx, _event, delaysMap) {
  var meta = {
    _event: _event
  }; // TODO: helper function for resolving Expr

  var resolvedEvent = toSCXMLEvent(utils_isFunction(action.event) ? action.event(ctx, _event.data, meta) : action.event);
  var resolvedDelay;

  if (utils_isString(action.delay)) {
    var configDelay = delaysMap && delaysMap[action.delay];
    resolvedDelay = utils_isFunction(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
  } else {
    resolvedDelay = utils_isFunction(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
  }

  var resolvedTarget = utils_isFunction(action.to) ? action.to(ctx, _event.data, meta) : action.to;
  return _tslib_assign(_tslib_assign({}, action), {
    to: resolvedTarget,
    _event: resolvedEvent,
    event: resolvedEvent.data,
    delay: resolvedDelay
  });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */

function sendParent(event, options) {
  return actions_send(event, _tslib_assign(_tslib_assign({}, options), {
    to: types_SpecialTargets.Parent
  }));
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event to send
 * @param options Send action options
 * @returns An XState send action object
 */

function sendTo(actor, event, options) {
  return actions_send(event, _tslib_assign(_tslib_assign({}, options), {
    to: actor
  }));
}
/**
 * Sends an update event to this machine's parent.
 */

function sendUpdate() {
  return sendParent(update);
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */

function respond(event, options) {
  return actions_send(event, __assign(__assign({}, options), {
    to: function (_, __, _a) {
      var _event = _a._event;
      return _event.origin; // TODO: handle when _event.origin is undefined
    }
  }));
}

var defaultLogExpr = function (context, event) {
  return {
    context: context,
    event: event
  };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */


function actions_log(expr, label) {
  if (expr === void 0) {
    expr = defaultLogExpr;
  }

  return {
    type: log,
    label: label,
    expr: expr
  };
}
var resolveLog = function (action, ctx, _event) {
  return _tslib_assign(_tslib_assign({}, action), {
    value: utils_isString(action.expr) ? action.expr : action.expr(ctx, _event.data, {
      _event: _event
    })
  });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */

var actions_cancel = function (sendId) {
  return {
    type: cancel,
    sendId: sendId
  };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */

function actions_start(activity) {
  var activityDef = toActivityDefinition(activity);
  return {
    type: ActionTypes.Start,
    activity: activityDef,
    exec: undefined
  };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */

function actions_stop(actorRef) {
  var activity = utils_isFunction(actorRef) ? actorRef : toActivityDefinition(actorRef);
  return {
    type: ActionTypes.Stop,
    activity: activity,
    exec: undefined
  };
}
function resolveStop(action, context, _event) {
  var actorRefOrString = utils_isFunction(action.activity) ? action.activity(context, _event.data) : action.activity;
  var resolvedActorRef = typeof actorRefOrString === 'string' ? {
    id: actorRefOrString
  } : actorRefOrString;
  var actionObject = {
    type: ActionTypes.Stop,
    activity: resolvedActorRef
  };
  return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */

var actions_assign = function (assignment) {
  return {
    type: actionTypes_assign,
    assignment: assignment
  };
};
function isActionObject(action) {
  return typeof action === 'object' && 'type' in action;
}
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */

function actions_after(delayRef, id) {
  var idSuffix = id ? "#".concat(id) : '';
  return "".concat(ActionTypes.After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */

function done(id, data) {
  var type = "".concat(ActionTypes.DoneState, ".").concat(id);
  var eventObject = {
    type: type,
    data: data
  };

  eventObject.toString = function () {
    return type;
  };

  return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */

function actions_doneInvoke(id, data) {
  var type = "".concat(ActionTypes.DoneInvoke, ".").concat(id);
  var eventObject = {
    type: type,
    data: data
  };

  eventObject.toString = function () {
    return type;
  };

  return eventObject;
}
function actions_error(id, data) {
  var type = "".concat(ActionTypes.ErrorPlatform, ".").concat(id);
  var eventObject = {
    type: type,
    data: data
  };

  eventObject.toString = function () {
    return type;
  };

  return eventObject;
}
function actions_pure(getActions) {
  return {
    type: ActionTypes.Pure,
    get: getActions
  };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */

function forwardTo(target, options) {
  if (!environment_IS_PRODUCTION && (!target || typeof target === 'function')) {
    var originalTarget_1 = target;

    target = function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      var resolvedTarget = typeof originalTarget_1 === 'function' ? originalTarget_1.apply(void 0, __spreadArray([], __read(args), false)) : originalTarget_1;

      if (!resolvedTarget) {
        throw new Error("Attempted to forward event to undefined actor. This risks an infinite loop in the sender.");
      }

      return resolvedTarget;
    };
  }

  return actions_send(function (_, event) {
    return event;
  }, _tslib_assign(_tslib_assign({}, options), {
    to: target
  }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */

function escalate(errorData, options) {
  return sendParent(function (context, event, meta) {
    return {
      type: error$1,
      data: isFunction(errorData) ? errorData(context, event, meta) : errorData
    };
  }, __assign(__assign({}, options), {
    to: SpecialTargets.Parent
  }));
}
function actions_choose(conds) {
  return {
    type: ActionTypes.Choose,
    conds: conds
  };
}

var pluckAssigns = function (actionBlocks) {
  var e_1, _a;

  var assignActions = [];

  try {
    for (var actionBlocks_1 = _tslib_values(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()) {
      var block = actionBlocks_1_1.value;
      var i = 0;

      while (i < block.actions.length) {
        if (block.actions[i].type === actionTypes_assign) {
          assignActions.push(block.actions[i]);
          block.actions.splice(i, 1);
          continue;
        }

        i++;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return assignActions;
};

function resolveActions(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
  if (preserveActionOrder === void 0) {
    preserveActionOrder = false;
  }

  var assignActions = preserveActionOrder ? [] : pluckAssigns(actionBlocks);
  var updatedContext = assignActions.length ? updateContext(currentContext, _event, assignActions, currentState) : currentContext;
  var preservedContexts = preserveActionOrder ? [currentContext] : undefined;
  var deferredToBlockEnd = [];

  function handleAction(blockType, actionObject) {
    var _a;

    switch (actionObject.type) {
      case raise:
        {
          var raisedAction = resolveRaise(actionObject, updatedContext, _event, machine.options.delays);

          if (predictableExec && typeof raisedAction.delay === 'number') {
            predictableExec(raisedAction, updatedContext, _event);
          }

          return raisedAction;
        }

      case send:
        var sendAction = resolveSend(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init

        if (!environment_IS_PRODUCTION) {
          var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here

          utils_warn(!utils_isString(configuredDelay) || typeof sendAction.delay === 'number', // tslint:disable-next-line:max-line-length
          "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
        }

        if (predictableExec && sendAction.to !== types_SpecialTargets.Internal) {
          if (blockType === 'entry') {
            deferredToBlockEnd.push(sendAction);
          } else {
            predictableExec(sendAction, updatedContext, _event);
          }
        }

        return sendAction;

      case log:
        {
          var resolved = resolveLog(actionObject, updatedContext, _event);
          predictableExec === null || predictableExec === void 0 ? void 0 : predictableExec(resolved, updatedContext, _event);
          return resolved;
        }

      case choose:
        {
          var chooseAction = actionObject;
          var matchedActions = (_a = chooseAction.conds.find(function (condition) {
            var guard = toGuard(condition.cond, machine.options.guards);
            return !guard || evaluateGuard(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
          })) === null || _a === void 0 ? void 0 : _a.actions;

          if (!matchedActions) {
            return [];
          }

          var _b = __read(resolveActions(machine, currentState, updatedContext, _event, [{
            type: blockType,
            actions: toActionObjects(toArray(matchedActions), machine.options.actions)
          }], predictableExec, preserveActionOrder), 2),
              resolvedActionsFromChoose = _b[0],
              resolvedContextFromChoose = _b[1];

          updatedContext = resolvedContextFromChoose;
          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
          return resolvedActionsFromChoose;
        }

      case pure:
        {
          var matchedActions = actionObject.get(updatedContext, _event.data);

          if (!matchedActions) {
            return [];
          }

          var _c = __read(resolveActions(machine, currentState, updatedContext, _event, [{
            type: blockType,
            actions: toActionObjects(toArray(matchedActions), machine.options.actions)
          }], predictableExec, preserveActionOrder), 2),
              resolvedActionsFromPure = _c[0],
              resolvedContext = _c[1];

          updatedContext = resolvedContext;
          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
          return resolvedActionsFromPure;
        }

      case stop:
        {
          var resolved = resolveStop(actionObject, updatedContext, _event);
          predictableExec === null || predictableExec === void 0 ? void 0 : predictableExec(resolved, currentContext, _event);
          return resolved;
        }

      case actionTypes_assign:
        {
          updatedContext = updateContext(updatedContext, _event, [actionObject], !predictableExec ? currentState : undefined);
          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
          break;
        }

      default:
        var resolvedActionObject = toActionObject(actionObject, machine.options.actions);
        var exec_1 = resolvedActionObject.exec;

        if (predictableExec) {
          predictableExec(resolvedActionObject, updatedContext, _event);
        } else if (exec_1 && preservedContexts) {
          var contextIndex_1 = preservedContexts.length - 1;

          var wrapped = _tslib_assign(_tslib_assign({}, resolvedActionObject), {
            exec: function (_ctx) {
              var args = [];

              for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
              }

              exec_1.apply(void 0, __spreadArray([preservedContexts[contextIndex_1]], __read(args), false));
            }
          });

          resolvedActionObject = wrapped;
        }

        return resolvedActionObject;
    }
  }

  function processBlock(block) {
    var e_2, _a;

    var resolvedActions = [];

    try {
      for (var _b = _tslib_values(block.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
        var action = _c.value;
        var resolved = handleAction(block.type, action);

        if (resolved) {
          resolvedActions = resolvedActions.concat(resolved);
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    deferredToBlockEnd.forEach(function (action) {
      predictableExec(action, updatedContext, _event);
    });
    deferredToBlockEnd.length = 0;
    return resolvedActions;
  }

  var resolvedActions = flatten(actionBlocks.map(processBlock));
  return [resolvedActions, updatedContext];
}



;// CONCATENATED MODULE: ../../node_modules/xstate/es/State.js







function stateValuesEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a === undefined || b === undefined) {
    return false;
  }

  if (utils_isString(a) || utils_isString(b)) {
    return a === b;
  }

  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  return aKeys.length === bKeys.length && aKeys.every(function (key) {
    return stateValuesEqual(a[key], b[key]);
  });
}
function isStateConfig(state) {
  if (typeof state !== 'object' || state === null) {
    return false;
  }

  return 'value' in state && '_event' in state;
}
/**
 * @deprecated Use `isStateConfig(object)` or `state instanceof State` instead.
 */

var isState = (/* unused pure expression or super */ null && (isStateConfig));
function bindActionToState(action, state) {
  var exec = action.exec;

  var boundAction = _tslib_assign(_tslib_assign({}, action), {
    exec: exec !== undefined ? function () {
      return exec(state.context, state.event, {
        action: action,
        state: state,
        _event: state._event
      });
    } : undefined
  });

  return boundAction;
}

var State =
/*#__PURE__*/

/** @class */
function () {
  /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */
  function State(config) {
    var _this = this;

    var _a;

    this.actions = [];
    this.activities = EMPTY_ACTIVITY_MAP;
    this.meta = {};
    this.events = [];
    this.value = config.value;
    this.context = config.context;
    this._event = config._event;
    this._sessionid = config._sessionid;
    this.event = this._event.data;
    this.historyValue = config.historyValue;
    this.history = config.history;
    this.actions = config.actions || [];
    this.activities = config.activities || EMPTY_ACTIVITY_MAP;
    this.meta = getMeta(config.configuration);
    this.events = config.events || [];
    this.matches = this.matches.bind(this);
    this.toStrings = this.toStrings.bind(this);
    this.configuration = config.configuration;
    this.transitions = config.transitions;
    this.children = config.children;
    this.done = !!config.done;
    this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
    this.machine = config.machine;
    Object.defineProperty(this, 'nextEvents', {
      get: function () {
        return nextEvents(_this.configuration);
      }
    });
  }
  /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */


  State.from = function (stateValue, context) {
    if (stateValue instanceof State) {
      if (stateValue.context !== context) {
        return new State({
          value: stateValue.value,
          context: context,
          _event: stateValue._event,
          _sessionid: null,
          historyValue: stateValue.historyValue,
          history: stateValue.history,
          actions: [],
          activities: stateValue.activities,
          meta: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        });
      }

      return stateValue;
    }

    var _event = initEvent;
    return new State({
      value: stateValue,
      context: context,
      _event: _event,
      _sessionid: null,
      historyValue: undefined,
      history: undefined,
      actions: [],
      activities: undefined,
      meta: undefined,
      events: [],
      configuration: [],
      transitions: [],
      children: {}
    });
  };
  /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */


  State.create = function (config) {
    return new State(config);
  };
  /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */


  State.inert = function (stateValue, context) {
    if (stateValue instanceof State) {
      if (!stateValue.actions.length) {
        return stateValue;
      }

      var _event = initEvent;
      return new State({
        value: stateValue.value,
        context: context,
        _event: _event,
        _sessionid: null,
        historyValue: stateValue.historyValue,
        history: stateValue.history,
        activities: stateValue.activities,
        configuration: stateValue.configuration,
        transitions: [],
        children: {}
      });
    }

    return State.from(stateValue, context);
  };
  /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */


  State.prototype.toStrings = function (stateValue, delimiter) {
    var _this = this;

    if (stateValue === void 0) {
      stateValue = this.value;
    }

    if (delimiter === void 0) {
      delimiter = '.';
    }

    if (utils_isString(stateValue)) {
      return [stateValue];
    }

    var valueKeys = Object.keys(stateValue);
    return valueKeys.concat.apply(valueKeys, __spreadArray([], __read(valueKeys.map(function (key) {
      return _this.toStrings(stateValue[key], delimiter).map(function (s) {
        return key + delimiter + s;
      });
    })), false));
  };

  State.prototype.toJSON = function () {
    var _a = this;
        _a.configuration;
        _a.transitions;
        var tags = _a.tags;
        _a.machine;
        var jsonValues = __rest(_a, ["configuration", "transitions", "tags", "machine"]);

    return _tslib_assign(_tslib_assign({}, jsonValues), {
      tags: Array.from(tags)
    });
  };

  State.prototype.matches = function (parentStateValue) {
    return matchesState(parentStateValue, this.value);
  };
  /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */


  State.prototype.hasTag = function (tag) {
    return this.tags.has(tag);
  };
  /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */


  State.prototype.can = function (event) {
    var _a;

    if (environment_IS_PRODUCTION) {
      utils_warn(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
    }

    var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
    return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
    transitionData.transitions.some(function (t) {
      return t.target !== undefined || t.actions.length;
    });
  };

  return State;
}();



// EXTERNAL MODULE: ../../node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.js
var use_isomorphic_layout_effect_browser_esm = __webpack_require__(84337);
;// CONCATENATED MODULE: ../../node_modules/xstate/es/scheduler.js


var defaultOptions = {
  deferEvents: false
};

var Scheduler =
/*#__PURE__*/

/** @class */
function () {
  function Scheduler(options) {
    this.processingEvent = false;
    this.queue = [];
    this.initialized = false;
    this.options = _tslib_assign(_tslib_assign({}, defaultOptions), options);
  }

  Scheduler.prototype.initialize = function (callback) {
    this.initialized = true;

    if (callback) {
      if (!this.options.deferEvents) {
        this.schedule(callback);
        return;
      }

      this.process(callback);
    }

    this.flushEvents();
  };

  Scheduler.prototype.schedule = function (task) {
    if (!this.initialized || this.processingEvent) {
      this.queue.push(task);
      return;
    }

    if (this.queue.length !== 0) {
      throw new Error('Event queue should be empty when it is not processing events');
    }

    this.process(task);
    this.flushEvents();
  };

  Scheduler.prototype.clear = function () {
    this.queue = [];
  };

  Scheduler.prototype.flushEvents = function () {
    var nextCallback = this.queue.shift();

    while (nextCallback) {
      this.process(nextCallback);
      nextCallback = this.queue.shift();
    }
  };

  Scheduler.prototype.process = function (callback) {
    this.processingEvent = true;

    try {
      callback();
    } catch (e) {
      // there is no use to keep the future events
      // as the situation is not anymore the same
      this.clear();
      throw e;
    } finally {
      this.processingEvent = false;
    }
  };

  return Scheduler;
}();



;// CONCATENATED MODULE: ../../node_modules/xstate/es/serviceScope.js
/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */
var serviceStack = [];
var provide = function (service, fn) {
  serviceStack.push(service);
  var result = fn(service);
  serviceStack.pop();
  return result;
};
var serviceScope_consume = function (fn) {
  return fn(serviceStack[serviceStack.length - 1]);
};



;// CONCATENATED MODULE: ../../node_modules/xstate/es/Actor.js




function createNullActor(id) {
  var _a;

  return _a = {
    id: id,
    send: function () {
      return void 0;
    },
    subscribe: function () {
      return {
        unsubscribe: function () {
          return void 0;
        }
      };
    },
    getSnapshot: function () {
      return undefined;
    },
    toJSON: function () {
      return {
        id: id
      };
    }
  }, _a[symbolObservable] = function () {
    return this;
  }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */

function createInvocableActor(invokeDefinition, machine, context, _event) {
  var _a;

  var invokeSrc = toInvokeSource(invokeDefinition.src);
  var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
  var resolvedData = invokeDefinition.data ? mapContext(invokeDefinition.data, context, _event) : undefined;
  var tempActor = serviceCreator ? Actor_createDeferredActor(serviceCreator, invokeDefinition.id, resolvedData) : createNullActor(invokeDefinition.id); // @ts-ignore

  tempActor.meta = invokeDefinition;
  return tempActor;
}
function Actor_createDeferredActor(entity, id, data) {
  var tempActor = createNullActor(id); // @ts-ignore

  tempActor.deferred = true;

  if (utils_isMachine(entity)) {
    // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
    var initialState_1 = tempActor.state = provide(undefined, function () {
      return (data ? entity.withContext(data) : entity).initialState;
    });

    tempActor.getSnapshot = function () {
      return initialState_1;
    };
  }

  return tempActor;
}
function Actor_isActor(item) {
  try {
    return typeof item.send === 'function';
  } catch (e) {
    return false;
  }
}
function isSpawnedActor(item) {
  return Actor_isActor(item) && 'id' in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now

function toActorRef(actorRefLike) {
  var _a;

  return _tslib_assign((_a = {
    subscribe: function () {
      return {
        unsubscribe: function () {
          return void 0;
        }
      };
    },
    id: 'anonymous',
    getSnapshot: function () {
      return undefined;
    }
  }, _a[symbolObservable] = function () {
    return this;
  }, _a), actorRefLike);
}



;// CONCATENATED MODULE: ../../node_modules/xstate/es/registry.js
var children = /*#__PURE__*/new Map();
var sessionIdIndex = 0;
var registry = {
  bookId: function () {
    return "x:".concat(sessionIdIndex++);
  },
  register: function (id, actor) {
    children.set(id, actor);
    return id;
  },
  get: function (id) {
    return children.get(id);
  },
  free: function (id) {
    children.delete(id);
  }
};



;// CONCATENATED MODULE: ../../node_modules/xstate/es/devTools.js


function getGlobal() {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }

  if (typeof self !== 'undefined') {
    return self;
  }

  if (typeof window !== 'undefined') {
    return window;
  }

  if (typeof __webpack_require__.g !== 'undefined') {
    return __webpack_require__.g;
  }

  if (!environment_IS_PRODUCTION) {
    console.warn('XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues');
  }
}

function getDevTools() {
  var global = getGlobal();

  if (global && '__xstate__' in global) {
    return global.__xstate__;
  }

  return undefined;
}

function registerService(service) {
  if (!getGlobal()) {
    return;
  }

  var devTools = getDevTools();

  if (devTools) {
    devTools.register(service);
  }
}



;// CONCATENATED MODULE: ../../node_modules/xstate/es/behaviors.js




/**
 * Returns an actor behavior from a reducer and its initial state.
 *
 * @param transition The pure reducer that returns the next state given the current state and event.
 * @param initialState The initial state of the reducer.
 * @returns An actor behavior
 */

function fromReducer(transition, initialState) {
  return {
    transition: transition,
    initialState: initialState
  };
}
function fromPromise(promiseFn) {
  var initialState = {
    error: undefined,
    data: undefined,
    status: 'pending'
  };
  return {
    transition: function (state, event, _a) {
      var parent = _a.parent,
          id = _a.id,
          observers = _a.observers;

      switch (event.type) {
        case 'fulfill':
          parent === null || parent === void 0 ? void 0 : parent.send(doneInvoke(id, event.data));
          return {
            error: undefined,
            data: event.data,
            status: 'fulfilled'
          };

        case 'reject':
          parent === null || parent === void 0 ? void 0 : parent.send(error(id, event.error));
          observers.forEach(function (observer) {
            observer.error(event.error);
          });
          return {
            error: event.error,
            data: undefined,
            status: 'rejected'
          };

        default:
          return state;
      }
    },
    initialState: initialState,
    start: function (_a) {
      var self = _a.self;
      promiseFn().then(function (data) {
        self.send({
          type: 'fulfill',
          data: data
        });
      }, function (reason) {
        self.send({
          type: 'reject',
          error: reason
        });
      });
      return initialState;
    }
  };
}
function spawnBehavior(behavior, options) {
  if (options === void 0) {
    options = {};
  }

  var state = behavior.initialState;
  var observers = new Set();
  var mailbox = [];
  var flushing = false;

  var flush = function () {
    if (flushing) {
      return;
    }

    flushing = true;

    while (mailbox.length > 0) {
      var event_1 = mailbox.shift();
      state = behavior.transition(state, event_1, actorCtx);
      observers.forEach(function (observer) {
        return observer.next(state);
      });
    }

    flushing = false;
  };

  var actor = toActorRef({
    id: options.id,
    send: function (event) {
      mailbox.push(event);
      flush();
    },
    getSnapshot: function () {
      return state;
    },
    subscribe: function (next, handleError, complete) {
      var observer = toObserver(next, handleError, complete);
      observers.add(observer);
      observer.next(state);
      return {
        unsubscribe: function () {
          observers.delete(observer);
        }
      };
    }
  });
  var actorCtx = {
    parent: options.parent,
    self: actor,
    id: options.id || 'anonymous',
    observers: observers
  };
  state = behavior.start ? behavior.start(actorCtx) : state;
  return actor;
}



;// CONCATENATED MODULE: ../../node_modules/xstate/es/interpreter.js














var DEFAULT_SPAWN_OPTIONS = {
  sync: false,
  autoForward: false
};
var InterpreterStatus;

(function (InterpreterStatus) {
  InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
  InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
  InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})(InterpreterStatus || (InterpreterStatus = {}));

var Interpreter =
/*#__PURE__*/

/** @class */
function () {
  /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */
  function Interpreter(machine, options) {
    if (options === void 0) {
      options = Interpreter.defaultOptions;
    }

    var _this = this;

    this.machine = machine;
    this.delayedEventsMap = {};
    this.listeners = new Set();
    this.contextListeners = new Set();
    this.stopListeners = new Set();
    this.doneListeners = new Set();
    this.eventListeners = new Set();
    this.sendListeners = new Set();
    /**
     * Whether the service is started.
     */

    this.initialized = false;
    this.status = InterpreterStatus.NotStarted;
    this.children = new Map();
    this.forwardTo = new Set();
    this._outgoingQueue = [];
    /**
     * Alias for Interpreter.prototype.start
     */

    this.init = this.start;
    /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */

    this.send = function (event, payload) {
      if (isArray(event)) {
        _this.batch(event);

        return _this.state;
      }

      var _event = toSCXMLEvent(toEventObject(event, payload));

      if (_this.status === InterpreterStatus.Stopped) {
        // do nothing
        if (!environment_IS_PRODUCTION) {
          utils_warn(false, "Event \"".concat(_event.name, "\" was sent to stopped service \"").concat(_this.machine.id, "\". This service has already reached its final state, and will not transition.\nEvent: ").concat(JSON.stringify(_event.data)));
        }

        return _this.state;
      }

      if (_this.status !== InterpreterStatus.Running && !_this.options.deferEvents) {
        throw new Error("Event \"".concat(_event.name, "\" was sent to uninitialized service \"").concat(_this.machine.id // tslint:disable-next-line:max-line-length
        , "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ").concat(JSON.stringify(_event.data)));
      }

      _this.scheduler.schedule(function () {
        // Forward copy of event to child actors
        _this.forward(_event);

        var nextState = _this._nextState(_event);

        _this.update(nextState, _event);
      });

      return _this._state; // TODO: deprecate (should return void)
      // tslint:disable-next-line:semicolon
    };

    this.sendTo = function (event, to, immediate) {
      var isParent = _this.parent && (to === types_SpecialTargets.Parent || _this.parent.id === to);
      var target = isParent ? _this.parent : utils_isString(to) ? to === types_SpecialTargets.Internal ? _this : _this.children.get(to) || registry.get(to) : isActor(to) ? to : undefined;

      if (!target) {
        if (!isParent) {
          throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
        } // tslint:disable-next-line:no-console


        if (!environment_IS_PRODUCTION) {
          utils_warn(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event.type));
        }

        return;
      }

      if ('machine' in target) {
        // perhaps those events should be rejected in the parent
        // but atm it doesn't have easy access to all of the information that is required to do it reliably
        if (_this.status !== InterpreterStatus.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
        _this.state.done) {
          // Send SCXML events to machines
          var scxmlEvent = _tslib_assign(_tslib_assign({}, event), {
            name: event.name === actionTypes_error ? "".concat(actions_error(_this.id)) : event.name,
            origin: _this.sessionId
          });

          if (!immediate && _this.machine.config.predictableActionArguments) {
            _this._outgoingQueue.push([target, scxmlEvent]);
          } else {
            target.send(scxmlEvent);
          }
        }
      } else {
        // Send normal events to other targets
        if (!immediate && _this.machine.config.predictableActionArguments) {
          _this._outgoingQueue.push([target, event.data]);
        } else {
          target.send(event.data);
        }
      }
    };

    this._exec = function (action, context, _event, actionFunctionMap) {
      if (actionFunctionMap === void 0) {
        actionFunctionMap = _this.machine.options.actions;
      }

      var actionOrExec = action.exec || getActionFunction(action.type, actionFunctionMap);
      var exec = utils_isFunction(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;

      if (exec) {
        try {
          return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
            action: action,
            state: _this.state,
            _event: _event
          } : {
            action: action,
            _event: _event
          });
        } catch (err) {
          if (_this.parent) {
            _this.parent.send({
              type: 'xstate.error',
              data: err
            });
          }

          throw err;
        }
      }

      switch (action.type) {
        case raise:
          {
            // if raise action reached the interpreter then it's a delayed one
            var sendAction_1 = action;

            _this.defer(sendAction_1);

            break;
          }

        case send:
          var sendAction = action;

          if (typeof sendAction.delay === 'number') {
            _this.defer(sendAction);

            return;
          } else {
            if (sendAction.to) {
              _this.sendTo(sendAction._event, sendAction.to, _event === initEvent);
            } else {
              _this.send(sendAction._event);
            }
          }

          break;

        case cancel:
          _this.cancel(action.sendId);

          break;

        case start:
          {
            if (_this.status !== InterpreterStatus.Running) {
              return;
            }

            var activity = action.activity; // If the activity will be stopped right after it's started
            // (such as in transient states)
            // don't bother starting the activity.

            if ( // in v4 with `predictableActionArguments` invokes are called eagerly when the `this.state` still points to the previous state
            !_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) {
              break;
            } // Invoked services


            if (activity.type === ActionTypes.Invoke) {
              var invokeSource = toInvokeSource(activity.src);
              var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
              var id = activity.id,
                  data = activity.data;

              if (!environment_IS_PRODUCTION) {
                utils_warn(!('forward' in activity), // tslint:disable-next-line:max-line-length
                "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
              }

              var autoForward = 'autoForward' in activity ? activity.autoForward : !!activity.forward;

              if (!serviceCreator) {
                // tslint:disable-next-line:no-console
                if (!environment_IS_PRODUCTION) {
                  utils_warn(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                }

                return;
              }

              var resolvedData = data ? mapContext(data, context, _event) : undefined;

              if (typeof serviceCreator === 'string') {
                // TODO: warn
                return;
              }

              var source = utils_isFunction(serviceCreator) ? serviceCreator(context, _event.data, {
                data: resolvedData,
                src: invokeSource,
                meta: activity.meta
              }) : serviceCreator;

              if (!source) {
                // TODO: warn?
                return;
              }

              var options = void 0;

              if (utils_isMachine(source)) {
                source = resolvedData ? source.withContext(resolvedData) : source;
                options = {
                  autoForward: autoForward
                };
              }

              _this.spawn(source, id, options);
            } else {
              _this.spawnActivity(activity);
            }

            break;
          }

        case stop:
          {
            _this.stopChild(action.activity.id);

            break;
          }

        case log:
          var _a = action,
              label = _a.label,
              value = _a.value;

          if (label) {
            _this.logger(label, value);
          } else {
            _this.logger(value);
          }

          break;

        default:
          if (!environment_IS_PRODUCTION) {
            utils_warn(false, "No implementation found for action type '".concat(action.type, "'"));
          }

          break;
      }
    };

    var resolvedOptions = _tslib_assign(_tslib_assign({}, Interpreter.defaultOptions), options);

    var clock = resolvedOptions.clock,
        logger = resolvedOptions.logger,
        parent = resolvedOptions.parent,
        id = resolvedOptions.id;
    var resolvedId = id !== undefined ? id : machine.id;
    this.id = resolvedId;
    this.logger = logger;
    this.clock = clock;
    this.parent = parent;
    this.options = resolvedOptions;
    this.scheduler = new Scheduler({
      deferEvents: this.options.deferEvents
    });
    this.sessionId = registry.bookId();
  }

  Object.defineProperty(Interpreter.prototype, "initialState", {
    get: function () {
      var _this = this;

      if (this._initialState) {
        return this._initialState;
      }

      return provide(this, function () {
        _this._initialState = _this.machine.initialState;
        return _this._initialState;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Interpreter.prototype, "state", {
    /**
     * @deprecated Use `.getSnapshot()` instead.
     */
    get: function () {
      if (!environment_IS_PRODUCTION) {
        utils_warn(this.status !== InterpreterStatus.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
      }

      return this._state;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */

  Interpreter.prototype.execute = function (state, actionsConfig) {
    var e_1, _a;

    try {
      for (var _b = _tslib_values(state.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
        var action = _c.value;
        this.exec(action, state, actionsConfig);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };

  Interpreter.prototype.update = function (state, _event) {
    var e_2, _a, e_3, _b, e_4, _c, e_5, _d;

    var _this = this; // Attach session ID to state


    state._sessionid = this.sessionId; // Update state

    this._state = state; // Execute actions

    if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
    // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
    _event === initEvent) && this.options.execute) {
      this.execute(this.state);
    } else {
      var item = void 0;

      while (item = this._outgoingQueue.shift()) {
        item[0].send(item[1]);
      }
    } // Update children


    this.children.forEach(function (child) {
      _this.state.children[child.id] = child;
    }); // Dev tools

    if (this.devTools) {
      this.devTools.send(_event.data, state);
    } // Execute listeners


    if (state.event) {
      try {
        for (var _e = _tslib_values(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()) {
          var listener = _f.value;
          listener(state.event);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }

    try {
      for (var _g = _tslib_values(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()) {
        var listener = _h.value;
        listener(state, state.event);
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    try {
      for (var _j = _tslib_values(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()) {
        var contextListener = _k.value;
        contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    if (this.state.done) {
      // get final child state node
      var finalChildStateNode = state.configuration.find(function (sn) {
        return sn.type === 'final' && sn.parent === _this.machine;
      });
      var doneData = finalChildStateNode && finalChildStateNode.doneData ? mapContext(finalChildStateNode.doneData, state.context, _event) : undefined;
      this._doneEvent = actions_doneInvoke(this.id, doneData);

      try {
        for (var _l = _tslib_values(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()) {
          var listener = _m.value;
          listener(this._doneEvent);
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
        } finally {
          if (e_5) throw e_5.error;
        }
      }

      this._stop();

      this._stopChildren();

      registry.free(this.sessionId);
    }
  };
  /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */


  Interpreter.prototype.onTransition = function (listener) {
    this.listeners.add(listener); // Send current state to listener

    if (this.status === InterpreterStatus.Running) {
      listener(this.state, this.state.event);
    }

    return this;
  };

  Interpreter.prototype.subscribe = function (nextListenerOrObserver, _, // TODO: error listener
  completeListener) {
    var _this = this;

    var observer = toObserver(nextListenerOrObserver, _, completeListener);
    this.listeners.add(observer.next); // Send current state to listener

    if (this.status !== InterpreterStatus.NotStarted) {
      observer.next(this.state);
    }

    var completeOnce = function () {
      _this.doneListeners.delete(completeOnce);

      _this.stopListeners.delete(completeOnce);

      observer.complete();
    };

    if (this.status === InterpreterStatus.Stopped) {
      observer.complete();
    } else {
      this.onDone(completeOnce);
      this.onStop(completeOnce);
    }

    return {
      unsubscribe: function () {
        _this.listeners.delete(observer.next);

        _this.doneListeners.delete(completeOnce);

        _this.stopListeners.delete(completeOnce);
      }
    };
  };
  /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */


  Interpreter.prototype.onEvent = function (listener) {
    this.eventListeners.add(listener);
    return this;
  };
  /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */


  Interpreter.prototype.onSend = function (listener) {
    this.sendListeners.add(listener);
    return this;
  };
  /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */


  Interpreter.prototype.onChange = function (listener) {
    this.contextListeners.add(listener);
    return this;
  };
  /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */


  Interpreter.prototype.onStop = function (listener) {
    this.stopListeners.add(listener);
    return this;
  };
  /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */


  Interpreter.prototype.onDone = function (listener) {
    if (this.status === InterpreterStatus.Stopped && this._doneEvent) {
      listener(this._doneEvent);
    } else {
      this.doneListeners.add(listener);
    }

    return this;
  };
  /**
   * Removes a listener.
   * @param listener The listener to remove
   */


  Interpreter.prototype.off = function (listener) {
    this.listeners.delete(listener);
    this.eventListeners.delete(listener);
    this.sendListeners.delete(listener);
    this.stopListeners.delete(listener);
    this.doneListeners.delete(listener);
    this.contextListeners.delete(listener);
    return this;
  };
  /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */


  Interpreter.prototype.start = function (initialState) {
    var _this = this;

    if (this.status === InterpreterStatus.Running) {
      // Do not restart the service if it is already started
      return this;
    } // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
    // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
    // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
    // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)


    this.machine._init();

    registry.register(this.sessionId, this);
    this.initialized = true;
    this.status = InterpreterStatus.Running;
    var resolvedState = initialState === undefined ? this.initialState : provide(this, function () {
      return isStateConfig(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState(State.from(initialState, _this.machine.context));
    });

    if (this.options.devTools) {
      this.attachDev();
    }

    this.scheduler.initialize(function () {
      _this.update(resolvedState, initEvent);
    });
    return this;
  };

  Interpreter.prototype._stopChildren = function () {
    // TODO: think about converting those to actions
    this.children.forEach(function (child) {
      if (utils_isFunction(child.stop)) {
        child.stop();
      }
    });
    this.children.clear();
  };

  Interpreter.prototype._stop = function () {
    var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;

    try {
      for (var _f = _tslib_values(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()) {
        var listener = _g.value;
        this.listeners.delete(listener);
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
      } finally {
        if (e_6) throw e_6.error;
      }
    }

    try {
      for (var _h = _tslib_values(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()) {
        var listener = _j.value; // call listener, then remove

        listener();
        this.stopListeners.delete(listener);
      }
    } catch (e_7_1) {
      e_7 = {
        error: e_7_1
      };
    } finally {
      try {
        if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
      } finally {
        if (e_7) throw e_7.error;
      }
    }

    try {
      for (var _k = _tslib_values(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()) {
        var listener = _l.value;
        this.contextListeners.delete(listener);
      }
    } catch (e_8_1) {
      e_8 = {
        error: e_8_1
      };
    } finally {
      try {
        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
      } finally {
        if (e_8) throw e_8.error;
      }
    }

    try {
      for (var _m = _tslib_values(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()) {
        var listener = _o.value;
        this.doneListeners.delete(listener);
      }
    } catch (e_9_1) {
      e_9 = {
        error: e_9_1
      };
    } finally {
      try {
        if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
      } finally {
        if (e_9) throw e_9.error;
      }
    }

    if (!this.initialized) {
      // Interpreter already stopped; do nothing
      return this;
    }

    this.initialized = false;
    this.status = InterpreterStatus.Stopped;
    this._initialState = undefined;

    try {
      // we are going to stop within the current sync frame
      // so we can safely just cancel this here as nothing async should be fired anyway
      for (var _p = _tslib_values(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()) {
        var key = _q.value;
        this.clock.clearTimeout(this.delayedEventsMap[key]);
      }
    } catch (e_10_1) {
      e_10 = {
        error: e_10_1
      };
    } finally {
      try {
        if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
      } finally {
        if (e_10) throw e_10.error;
      }
    } // clear everything that might be enqueued


    this.scheduler.clear();
    this.scheduler = new Scheduler({
      deferEvents: this.options.deferEvents
    });
  };
  /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */


  Interpreter.prototype.stop = function () {
    // TODO: add warning for stopping non-root interpreters
    var _this = this; // grab the current scheduler as it will be replaced in _stop


    var scheduler = this.scheduler;

    this._stop(); // let what is currently processed to be finished


    scheduler.schedule(function () {
      var _a;

      if ((_a = _this._state) === null || _a === void 0 ? void 0 : _a.done) {
        return;
      } // it feels weird to handle this here but we need to handle this even slightly "out of band"


      var _event = toSCXMLEvent({
        type: 'xstate.stop'
      });

      var nextState = provide(_this, function () {
        var exitActions = flatten(__spreadArray([], __read(_this.state.configuration), false).sort(function (a, b) {
          return b.order - a.order;
        }).map(function (stateNode) {
          return toActionObjects(stateNode.onExit, _this.machine.options.actions);
        }));

        var _a = __read(resolveActions(_this.machine, _this.state, _this.state.context, _event, [{
          type: 'exit',
          actions: exitActions
        }], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2),
            resolvedActions = _a[0],
            updatedContext = _a[1];

        var newState = new State({
          value: _this.state.value,
          context: updatedContext,
          _event: _event,
          _sessionid: _this.sessionId,
          historyValue: undefined,
          history: _this.state,
          actions: resolvedActions.filter(function (action) {
            return !isRaisableAction(action);
          }),
          activities: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {},
          done: _this.state.done,
          tags: _this.state.tags,
          machine: _this.machine
        });
        newState.changed = true;
        return newState;
      });

      _this.update(nextState, _event);

      _this._stopChildren();

      registry.free(_this.sessionId);
    });
    return this;
  };

  Interpreter.prototype.batch = function (events) {
    var _this = this;

    if (this.status === InterpreterStatus.NotStarted && this.options.deferEvents) {
      // tslint:disable-next-line:no-console
      if (!environment_IS_PRODUCTION) {
        utils_warn(false, "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\" and are deferred. Make sure .start() is called for this service.\nEvent: ").concat(JSON.stringify(event)));
      }
    } else if (this.status !== InterpreterStatus.Running) {
      throw new Error( // tslint:disable-next-line:max-line-length
      "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options."));
    }

    if (!events.length) {
      return;
    }

    var exec = !!this.machine.config.predictableActionArguments && this._exec;
    this.scheduler.schedule(function () {
      var e_11, _a;

      var nextState = _this.state;
      var batchChanged = false;
      var batchedActions = [];

      var _loop_1 = function (event_1) {
        var _event = toSCXMLEvent(event_1);

        _this.forward(_event);

        nextState = provide(_this, function () {
          return _this.machine.transition(nextState, _event, undefined, exec || undefined);
        });
        batchedActions.push.apply(batchedActions, __spreadArray([], __read(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function (a) {
          return bindActionToState(a, nextState);
        })), false));
        batchChanged = batchChanged || !!nextState.changed;
      };

      try {
        for (var events_1 = _tslib_values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
          var event_1 = events_1_1.value;

          _loop_1(event_1);
        }
      } catch (e_11_1) {
        e_11 = {
          error: e_11_1
        };
      } finally {
        try {
          if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
        } finally {
          if (e_11) throw e_11.error;
        }
      }

      nextState.changed = batchChanged;
      nextState.actions = batchedActions;

      _this.update(nextState, toSCXMLEvent(events[events.length - 1]));
    });
  };
  /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */


  Interpreter.prototype.sender = function (event) {
    return this.send.bind(this, event);
  };

  Interpreter.prototype._nextState = function (event, exec) {
    var _this = this;

    if (exec === void 0) {
      exec = !!this.machine.config.predictableActionArguments && this._exec;
    }

    var _event = toSCXMLEvent(event);

    if (_event.name.indexOf(errorPlatform) === 0 && !this.state.nextEvents.some(function (nextEvent) {
      return nextEvent.indexOf(errorPlatform) === 0;
    })) {
      throw _event.data.data;
    }

    var nextState = provide(this, function () {
      return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
    });
    return nextState;
  };
  /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */


  Interpreter.prototype.nextState = function (event) {
    return this._nextState(event, false);
  };

  Interpreter.prototype.forward = function (event) {
    var e_12, _a;

    try {
      for (var _b = _tslib_values(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()) {
        var id = _c.value;
        var child = this.children.get(id);

        if (!child) {
          throw new Error("Unable to forward event '".concat(event, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
        }

        child.send(event);
      }
    } catch (e_12_1) {
      e_12 = {
        error: e_12_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_12) throw e_12.error;
      }
    }
  };

  Interpreter.prototype.defer = function (sendAction) {
    var _this = this;

    var timerId = this.clock.setTimeout(function () {
      if ('to' in sendAction && sendAction.to) {
        _this.sendTo(sendAction._event, sendAction.to, true);
      } else {
        _this.send(sendAction._event);
      }
    }, sendAction.delay);

    if (sendAction.id) {
      this.delayedEventsMap[sendAction.id] = timerId;
    }
  };

  Interpreter.prototype.cancel = function (sendId) {
    this.clock.clearTimeout(this.delayedEventsMap[sendId]);
    delete this.delayedEventsMap[sendId];
  };

  Interpreter.prototype.exec = function (action, state, actionFunctionMap) {
    if (actionFunctionMap === void 0) {
      actionFunctionMap = this.machine.options.actions;
    }

    this._exec(action, state.context, state._event, actionFunctionMap);
  };

  Interpreter.prototype.removeChild = function (childId) {
    var _a;

    this.children.delete(childId);
    this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
    // such as when a child is added then removed while initializing the state

    (_a = this.state) === null || _a === void 0 ? true : delete _a.children[childId];
  };

  Interpreter.prototype.stopChild = function (childId) {
    var child = this.children.get(childId);

    if (!child) {
      return;
    }

    this.removeChild(childId);

    if (utils_isFunction(child.stop)) {
      child.stop();
    }
  };

  Interpreter.prototype.spawn = function (entity, name, options) {
    if (this.status !== InterpreterStatus.Running) {
      return Actor_createDeferredActor(entity, name);
    }

    if (isPromiseLike(entity)) {
      return this.spawnPromise(Promise.resolve(entity), name);
    } else if (utils_isFunction(entity)) {
      return this.spawnCallback(entity, name);
    } else if (isSpawnedActor(entity)) {
      return this.spawnActor(entity, name);
    } else if (isObservable(entity)) {
      return this.spawnObservable(entity, name);
    } else if (utils_isMachine(entity)) {
      return this.spawnMachine(entity, _tslib_assign(_tslib_assign({}, options), {
        id: name
      }));
    } else if (isBehavior(entity)) {
      return this.spawnBehavior(entity, name);
    } else {
      throw new Error("Unable to spawn entity \"".concat(name, "\" of type \"").concat(typeof entity, "\"."));
    }
  };

  Interpreter.prototype.spawnMachine = function (machine, options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    var childService = new Interpreter(machine, _tslib_assign(_tslib_assign({}, this.options), {
      parent: this,
      id: options.id || machine.id
    }));

    var resolvedOptions = _tslib_assign(_tslib_assign({}, DEFAULT_SPAWN_OPTIONS), options);

    if (resolvedOptions.sync) {
      childService.onTransition(function (state) {
        _this.send(update, {
          state: state,
          id: childService.id
        });
      });
    }

    var actor = childService;
    this.children.set(childService.id, actor);

    if (resolvedOptions.autoForward) {
      this.forwardTo.add(childService.id);
    }

    childService.onDone(function (doneEvent) {
      _this.removeChild(childService.id);

      _this.send(toSCXMLEvent(doneEvent, {
        origin: childService.id
      }));
    }).start();
    return actor;
  };

  Interpreter.prototype.spawnBehavior = function (behavior, id) {
    var actorRef = spawnBehavior(behavior, {
      id: id,
      parent: this
    });
    this.children.set(id, actorRef);
    return actorRef;
  };

  Interpreter.prototype.spawnPromise = function (promise, id) {
    var _a;

    var _this = this;

    var canceled = false;
    var resolvedData;
    promise.then(function (response) {
      if (!canceled) {
        resolvedData = response;

        _this.removeChild(id);

        _this.send(toSCXMLEvent(actions_doneInvoke(id, response), {
          origin: id
        }));
      }
    }, function (errorData) {
      if (!canceled) {
        _this.removeChild(id);

        var errorEvent = actions_error(id, errorData);

        try {
          // Send "error.platform.id" to this (parent).
          _this.send(toSCXMLEvent(errorEvent, {
            origin: id
          }));
        } catch (error) {
          reportUnhandledExceptionOnInvocation(errorData, error, id);

          if (_this.devTools) {
            _this.devTools.send(errorEvent, _this.state);
          }

          if (_this.machine.strict) {
            // it would be better to always stop the state machine if unhandled
            // exception/promise rejection happens but because we don't want to
            // break existing code so enforce it on strict mode only especially so
            // because documentation says that onError is optional
            _this.stop();
          }
        }
      }
    });
    var actor = (_a = {
      id: id,
      send: function () {
        return void 0;
      },
      subscribe: function (next, handleError, complete) {
        var observer = toObserver(next, handleError, complete);
        var unsubscribed = false;
        promise.then(function (response) {
          if (unsubscribed) {
            return;
          }

          observer.next(response);

          if (unsubscribed) {
            return;
          }

          observer.complete();
        }, function (err) {
          if (unsubscribed) {
            return;
          }

          observer.error(err);
        });
        return {
          unsubscribe: function () {
            return unsubscribed = true;
          }
        };
      },
      stop: function () {
        canceled = true;
      },
      toJSON: function () {
        return {
          id: id
        };
      },
      getSnapshot: function () {
        return resolvedData;
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a);
    this.children.set(id, actor);
    return actor;
  };

  Interpreter.prototype.spawnCallback = function (callback, id) {
    var _a;

    var _this = this;

    var canceled = false;
    var receivers = new Set();
    var listeners = new Set();
    var emitted;

    var receive = function (e) {
      emitted = e;
      listeners.forEach(function (listener) {
        return listener(e);
      });

      if (canceled) {
        return;
      }

      _this.send(toSCXMLEvent(e, {
        origin: id
      }));
    };

    var callbackStop;

    try {
      callbackStop = callback(receive, function (newListener) {
        receivers.add(newListener);
      });
    } catch (err) {
      this.send(actions_error(id, err));
    }

    if (isPromiseLike(callbackStop)) {
      // it turned out to be an async function, can't reliably check this before calling `callback`
      // because transpiled async functions are not recognizable
      return this.spawnPromise(callbackStop, id);
    }

    var actor = (_a = {
      id: id,
      send: function (event) {
        return receivers.forEach(function (receiver) {
          return receiver(event);
        });
      },
      subscribe: function (next) {
        var observer = toObserver(next);
        listeners.add(observer.next);
        return {
          unsubscribe: function () {
            listeners.delete(observer.next);
          }
        };
      },
      stop: function () {
        canceled = true;

        if (utils_isFunction(callbackStop)) {
          callbackStop();
        }
      },
      toJSON: function () {
        return {
          id: id
        };
      },
      getSnapshot: function () {
        return emitted;
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a);
    this.children.set(id, actor);
    return actor;
  };

  Interpreter.prototype.spawnObservable = function (source, id) {
    var _a;

    var _this = this;

    var emitted;
    var subscription = source.subscribe(function (value) {
      emitted = value;

      _this.send(toSCXMLEvent(value, {
        origin: id
      }));
    }, function (err) {
      _this.removeChild(id);

      _this.send(toSCXMLEvent(actions_error(id, err), {
        origin: id
      }));
    }, function () {
      _this.removeChild(id);

      _this.send(toSCXMLEvent(actions_doneInvoke(id), {
        origin: id
      }));
    });
    var actor = (_a = {
      id: id,
      send: function () {
        return void 0;
      },
      subscribe: function (next, handleError, complete) {
        return source.subscribe(next, handleError, complete);
      },
      stop: function () {
        return subscription.unsubscribe();
      },
      getSnapshot: function () {
        return emitted;
      },
      toJSON: function () {
        return {
          id: id
        };
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a);
    this.children.set(id, actor);
    return actor;
  };

  Interpreter.prototype.spawnActor = function (actor, name) {
    this.children.set(name, actor);
    return actor;
  };

  Interpreter.prototype.spawnActivity = function (activity) {
    var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;

    if (!implementation) {
      if (!environment_IS_PRODUCTION) {
        utils_warn(false, "No implementation found for activity '".concat(activity.type, "'"));
      } // tslint:disable-next-line:no-console


      return;
    } // Start implementation


    var dispose = implementation(this.state.context, activity);
    this.spawnEffect(activity.id, dispose);
  };

  Interpreter.prototype.spawnEffect = function (id, dispose) {
    var _a;

    this.children.set(id, (_a = {
      id: id,
      send: function () {
        return void 0;
      },
      subscribe: function () {
        return {
          unsubscribe: function () {
            return void 0;
          }
        };
      },
      stop: dispose || undefined,
      getSnapshot: function () {
        return undefined;
      },
      toJSON: function () {
        return {
          id: id
        };
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a));
  };

  Interpreter.prototype.attachDev = function () {
    var global = getGlobal();

    if (this.options.devTools && global) {
      if (global.__REDUX_DEVTOOLS_EXTENSION__) {
        var devToolsOptions = typeof this.options.devTools === 'object' ? this.options.devTools : undefined;
        this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect(_tslib_assign(_tslib_assign({
          name: this.id,
          autoPause: true,
          stateSanitizer: function (state) {
            return {
              value: state.value,
              context: state.context,
              actions: state.actions
            };
          }
        }, devToolsOptions), {
          features: _tslib_assign({
            jump: false,
            skip: false
          }, devToolsOptions ? devToolsOptions.features : undefined)
        }), this.machine);
        this.devTools.init(this.state);
      } // add XState-specific dev tooling hook


      registerService(this);
    }
  };

  Interpreter.prototype.toJSON = function () {
    return {
      id: this.id
    };
  };

  Interpreter.prototype[symbolObservable] = function () {
    return this;
  };

  Interpreter.prototype.getSnapshot = function () {
    if (this.status === InterpreterStatus.NotStarted) {
      return this.initialState;
    }

    return this._state;
  };
  /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */


  Interpreter.defaultOptions = {
    execute: true,
    deferEvents: true,
    clock: {
      setTimeout: function (fn, ms) {
        return setTimeout(fn, ms);
      },
      clearTimeout: function (id) {
        return clearTimeout(id);
      }
    },
    logger: /*#__PURE__*/console.log.bind(console),
    devTools: false
  };
  Interpreter.interpret = interpret;
  return Interpreter;
}();

var resolveSpawnOptions = function (nameOrOptions) {
  if (isString(nameOrOptions)) {
    return __assign(__assign({}, DEFAULT_SPAWN_OPTIONS), {
      name: nameOrOptions
    });
  }

  return __assign(__assign(__assign({}, DEFAULT_SPAWN_OPTIONS), {
    name: uniqueId()
  }), nameOrOptions);
};

function spawn(entity, nameOrOptions) {
  var resolvedOptions = resolveSpawnOptions(nameOrOptions);
  return consume(function (service) {
    if (!IS_PRODUCTION) {
      var isLazyEntity = isMachine(entity) || isFunction(entity);
      warn(!!service || isLazyEntity, "Attempted to spawn an Actor (ID: \"".concat(isMachine(entity) ? entity.id : 'undefined', "\") outside of a service. This will have no effect."));
    }

    if (service) {
      return service.spawn(entity, resolvedOptions.name, resolvedOptions);
    } else {
      return createDeferredActor(entity, resolvedOptions.name);
    }
  });
}
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */

function interpret(machine, options) {
  var interpreter = new Interpreter(machine, options);
  return interpreter;
}



;// CONCATENATED MODULE: ../../node_modules/@xstate/react/es/useConstant.js

function useConstant_useConstant(fn) {
    var ref = react.useRef();
    if (!ref.current) {
        ref.current = { v: fn() };
    }
    return ref.current.v;
}

;// CONCATENATED MODULE: ../../node_modules/@xstate/react/es/types.js
var types_ReactEffectType;
(function (ReactEffectType) {
    ReactEffectType[ReactEffectType["Effect"] = 1] = "Effect";
    ReactEffectType[ReactEffectType["LayoutEffect"] = 2] = "LayoutEffect";
})(types_ReactEffectType || (types_ReactEffectType = {}));

;// CONCATENATED MODULE: ../../node_modules/@xstate/react/es/utils.js
var utils_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var utils_values = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function utils_partition(items, predicate) {
    var e_1, _a;
    var _b = utils_read([[], []], 2), truthy = _b[0], falsy = _b[1];
    try {
        for (var items_1 = utils_values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
            var item = items_1_1.value;
            if (predicate(item)) {
                truthy.push(item);
            }
            else {
                falsy.push(item);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return [truthy, falsy];
}

;// CONCATENATED MODULE: ../../node_modules/@xstate/react/es/useReactEffectActions.js
var useReactEffectActions_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var useReactEffectActions_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};




function executeEffect(action, state) {
    var exec = action.exec;
    var originalExec = exec(state.context, state._event.data, {
        action: action,
        state: state,
        _event: state._event
    });
    originalExec();
}
function useReactEffectActions(service) {
    var effectActionsRef = (0,react.useRef)([]);
    var layoutEffectActionsRef = (0,react.useRef)([]);
    (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
        var sub = service.subscribe(function (currentState) {
            var _a, _b;
            if (currentState.actions.length) {
                var reactEffectActions = currentState.actions.filter(function (action) {
                    return (typeof action.exec === 'function' &&
                        '__effect' in action.exec);
                });
                var _c = useReactEffectActions_read(utils_partition(reactEffectActions, function (action) {
                    return action.exec.__effect === types_ReactEffectType.Effect;
                }), 2), effectActions = _c[0], layoutEffectActions = _c[1];
                (_a = effectActionsRef.current).push.apply(_a, useReactEffectActions_spreadArray([], useReactEffectActions_read(effectActions.map(function (effectAction) { return [effectAction, currentState]; })), false));
                (_b = layoutEffectActionsRef.current).push.apply(_b, useReactEffectActions_spreadArray([], useReactEffectActions_read(layoutEffectActions.map(function (layoutEffectAction) { return [layoutEffectAction, currentState]; })), false));
            }
        });
        return function () {
            sub.unsubscribe();
        };
    }, []);
    // this is somewhat weird - this should always be flushed within useLayoutEffect
    // but we don't want to receive warnings about useLayoutEffect being used on the server
    // so we have to use `useIsomorphicLayoutEffect` to silence those warnings
    (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
        while (layoutEffectActionsRef.current.length) {
            var _a = useReactEffectActions_read(layoutEffectActionsRef.current.shift(), 2), layoutEffectAction = _a[0], effectState = _a[1];
            executeEffect(layoutEffectAction, effectState);
        }
    }); // https://github.com/davidkpiano/xstate/pull/1202#discussion_r429677773
    (0,react.useEffect)(function () {
        while (effectActionsRef.current.length) {
            var _a = useReactEffectActions_read(effectActionsRef.current.shift(), 2), effectAction = _a[0], effectState = _a[1];
            executeEffect(effectAction, effectState);
        }
    });
}

;// CONCATENATED MODULE: ../../node_modules/@xstate/react/es/useInterpret.js
var useInterpret_assign = (undefined && undefined.__assign) || function () {
    useInterpret_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return useInterpret_assign.apply(this, arguments);
};
var useInterpret_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var useInterpret_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





// copied from core/src/utils.ts
// it avoids a breaking change between this package and XState which is its peer dep
function useInterpret_toObserver(nextHandler, errorHandler, completionHandler) {
    if (typeof nextHandler === 'object') {
        return nextHandler;
    }
    var noop = function () { return void 0; };
    return {
        next: nextHandler,
        error: errorHandler || noop,
        complete: completionHandler || noop
    };
}
function useInterpret(getMachine, options, observerOrListener) {
    if (options === void 0) { options = {}; }
    var machine = useConstant_useConstant(function () {
        return typeof getMachine === 'function' ? getMachine() : getMachine;
    });
    if (false) { var _a, initialMachine; }
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = useInterpret_rest(options, ["context", "guards", "actions", "activities", "services", "delays", "state"]);
    var service = useConstant_useConstant(function () {
        var machineConfig = {
            context: context,
            guards: guards,
            actions: actions,
            activities: activities,
            services: services,
            delays: delays
        };
        var machineWithConfig = machine.withConfig(machineConfig, function () { return (useInterpret_assign(useInterpret_assign({}, machine.context), context)); });
        return interpret(machineWithConfig, useInterpret_assign({ deferEvents: true }, interpreterOptions));
    });
    (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
        var sub;
        if (observerOrListener) {
            sub = service.subscribe(useInterpret_toObserver(observerOrListener));
        }
        return function () {
            sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        };
    }, [observerOrListener]);
    (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
        service.start(rehydratedState ? State.create(rehydratedState) : undefined);
        return function () {
            service.stop();
        };
    }, []);
    // Make sure options are kept updated when they change.
    // This mutation assignment is safe because the service instance is only used
    // in one place -- this hook's caller.
    (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
        Object.assign(service.machine.options.actions, actions);
        Object.assign(service.machine.options.guards, guards);
        Object.assign(service.machine.options.activities, activities);
        Object.assign(service.machine.options.services, services);
        Object.assign(service.machine.options.delays, delays);
    }, [actions, guards, activities, services, delays]);
    useReactEffectActions(service);
    return service;
}

;// CONCATENATED MODULE: ../../node_modules/@xstate/react/es/useMachine.js
var useMachine_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var useMachine_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};




function createReactActionFunction(exec, tag) {
    var effectExec = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // don't execute; just return
        return function () {
            return exec.apply(void 0, useMachine_spreadArray([], useMachine_read(args), false));
        };
    };
    Object.defineProperties(effectExec, {
        name: { value: "effect:".concat(exec.name) },
        __effect: { value: tag }
    });
    return effectExec;
}
function asEffect(exec) {
    return createReactActionFunction(exec, ReactEffectType.Effect);
}
function asLayoutEffect(exec) {
    return createReactActionFunction(exec, ReactEffectType.LayoutEffect);
}
function useMachine(getMachine, options) {
    if (options === void 0) { options = {}; }
    var listener = (0,react.useCallback)(function (nextState) {
        // Only change the current state if:
        // - the incoming state is the "live" initial state (since it might have new actors)
        // - OR the incoming state actually changed.
        //
        // The "live" initial state will have .changed === undefined.
        var initialStateChanged = nextState.changed === undefined &&
            Object.keys(nextState.children).length;
        if (nextState.changed || initialStateChanged) {
            setState(nextState);
        }
    }, []);
    var service = useInterpret(getMachine, options, listener);
    var _a = useMachine_read((0,react.useState)(function () {
        var initialState = service.machine.initialState;
        return (options.state
            ? State.create(options.state)
            : initialState);
    }), 2), state = _a[0], setState = _a[1];
    return [state, service.send, service];
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
;// CONCATENATED MODULE: ../../node_modules/react-spring/web.js




const is = {
  arr: Array.isArray,
  obj: a => Object.prototype.toString.call(a) === '[object Object]',
  fun: a => typeof a === 'function',
  str: a => typeof a === 'string',
  num: a => typeof a === 'number',
  und: a => a === void 0,
  nul: a => a === null,
  set: a => a instanceof Set,
  map: a => a instanceof Map,

  equ(a, b) {
    if (typeof a !== typeof b) return false;
    if (is.str(a) || is.num(a)) return a === b;
    if (is.obj(a) && is.obj(b) && Object.keys(a).length + Object.keys(b).length === 0) return true;
    let i;

    for (i in a) if (!(i in b)) return false;

    for (i in b) if (a[i] !== b[i]) return false;

    return is.und(i) ? a === b : true;
  }

};
function merge(target, lowercase) {
  if (lowercase === void 0) {
    lowercase = true;
  }

  return object => (is.arr(object) ? object : Object.keys(object)).reduce((acc, element) => {
    const key = lowercase ? element[0].toLowerCase() + element.substring(1) : element;
    acc[key] = target(key);
    return acc;
  }, target);
}
function web_useForceUpdate() {
  const _useState = (0,react.useState)(false),
        f = _useState[1];

  const forceUpdate = (0,react.useCallback)(() => f(v => !v), []);
  return forceUpdate;
}
function withDefault(value, defaultValue) {
  return is.und(value) || is.nul(value) ? defaultValue : value;
}
function web_toArray(a) {
  return !is.und(a) ? is.arr(a) ? a : [a] : [];
}
function callProp(obj) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return is.fun(obj) ? obj(...args) : obj;
}

function getForwardProps(props) {
  const to = props.to,
        from = props.from,
        config = props.config,
        onStart = props.onStart,
        onRest = props.onRest,
        onFrame = props.onFrame,
        children = props.children,
        reset = props.reset,
        reverse = props.reverse,
        force = props.force,
        immediate = props.immediate,
        delay = props.delay,
        attach = props.attach,
        destroyed = props.destroyed,
        interpolateTo = props.interpolateTo,
        ref = props.ref,
        lazy = props.lazy,
        forward = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ["to", "from", "config", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "delay", "attach", "destroyed", "interpolateTo", "ref", "lazy"]);

  return forward;
}

function interpolateTo(props) {
  const forward = getForwardProps(props);
  if (is.und(forward)) return (0,esm_extends/* default */.Z)({
    to: forward
  }, props);
  const rest = Object.keys(props).reduce((a, k) => !is.und(forward[k]) ? a : (0,esm_extends/* default */.Z)({}, a, {
    [k]: props[k]
  }), {});
  return (0,esm_extends/* default */.Z)({
    to: forward
  }, rest);
}
function handleRef(ref, forward) {
  if (forward) {
    // If it's a function, assume it's a ref callback
    if (is.fun(forward)) forward(ref);else if (is.obj(forward)) {
      forward.current = ref;
    }
  }

  return ref;
}

class Animated {
  constructor() {
    this.payload = void 0;
    this.children = [];
  }

  getAnimatedValue() {
    return this.getValue();
  }

  getPayload() {
    return this.payload || this;
  }

  attach() {}

  detach() {}

  getChildren() {
    return this.children;
  }

  addChild(child) {
    if (this.children.length === 0) this.attach();
    this.children.push(child);
  }

  removeChild(child) {
    const index = this.children.indexOf(child);
    this.children.splice(index, 1);
    if (this.children.length === 0) this.detach();
  }

}
class AnimatedArray extends Animated {
  constructor() {
    super(...arguments);
    this.payload = [];

    this.attach = () => this.payload.forEach(p => p instanceof Animated && p.addChild(this));

    this.detach = () => this.payload.forEach(p => p instanceof Animated && p.removeChild(this));
  }

}
class AnimatedObject extends Animated {
  constructor() {
    super(...arguments);
    this.payload = {};

    this.attach = () => Object.values(this.payload).forEach(s => s instanceof Animated && s.addChild(this));

    this.detach = () => Object.values(this.payload).forEach(s => s instanceof Animated && s.removeChild(this));
  }

  getValue(animated) {
    if (animated === void 0) {
      animated = false;
    }

    const payload = {};

    for (const key in this.payload) {
      const value = this.payload[key];
      if (animated && !(value instanceof Animated)) continue;
      payload[key] = value instanceof Animated ? value[animated ? 'getAnimatedValue' : 'getValue']() : value;
    }

    return payload;
  }

  getAnimatedValue() {
    return this.getValue(true);
  }

}

let applyAnimatedValues;
function injectApplyAnimatedValues(fn, transform) {
  applyAnimatedValues = {
    fn,
    transform
  };
}
let colorNames;
function injectColorNames(names) {
  colorNames = names;
}
let requestFrame = cb => typeof window !== 'undefined' ? window.requestAnimationFrame(cb) : -1;
let cancelFrame = id => {
  typeof window !== 'undefined' && window.cancelAnimationFrame(id);
};
function injectFrame(raf, caf) {
  requestFrame = raf;
  cancelFrame = caf;
}
let interpolation;
function injectStringInterpolator(fn) {
  interpolation = fn;
}
let web_now = () => Date.now();
function injectNow(nowFn) {
  web_now = nowFn;
}
let defaultElement;
function injectDefaultElement(el) {
  defaultElement = el;
}
let animatedApi = node => node.current;
function injectAnimatedApi(fn) {
  animatedApi = fn;
}
let createAnimatedStyle;
function injectCreateAnimatedStyle(factory) {
  createAnimatedStyle = factory;
}
let manualFrameloop;
function injectManualFrameloop(callback) {
  manualFrameloop = callback;
}

var Globals = /*#__PURE__*/Object.freeze({
  get applyAnimatedValues () { return applyAnimatedValues; },
  injectApplyAnimatedValues: injectApplyAnimatedValues,
  get colorNames () { return colorNames; },
  injectColorNames: injectColorNames,
  get requestFrame () { return requestFrame; },
  get cancelFrame () { return cancelFrame; },
  injectFrame: injectFrame,
  get interpolation () { return interpolation; },
  injectStringInterpolator: injectStringInterpolator,
  get now () { return web_now; },
  injectNow: injectNow,
  get defaultElement () { return defaultElement; },
  injectDefaultElement: injectDefaultElement,
  get animatedApi () { return animatedApi; },
  injectAnimatedApi: injectAnimatedApi,
  get createAnimatedStyle () { return createAnimatedStyle; },
  injectCreateAnimatedStyle: injectCreateAnimatedStyle,
  get manualFrameloop () { return manualFrameloop; },
  injectManualFrameloop: injectManualFrameloop
});

/**
 * Wraps the `style` property with `AnimatedStyle`.
 */

class AnimatedProps extends AnimatedObject {
  constructor(props, callback) {
    super();
    this.update = void 0;
    this.payload = !props.style ? props : (0,esm_extends/* default */.Z)({}, props, {
      style: createAnimatedStyle(props.style)
    });
    this.update = callback;
    this.attach();
  }

}

const isFunctionComponent = val => is.fun(val) && !(val.prototype instanceof react.Component);

const createAnimatedComponent = Component => {
  const AnimatedComponent = (0,react.forwardRef)((props, ref) => {
    const forceUpdate = web_useForceUpdate();
    const mounted = (0,react.useRef)(true);
    const propsAnimated = (0,react.useRef)(null);
    const node = (0,react.useRef)(null);
    const attachProps = (0,react.useCallback)(props => {
      const oldPropsAnimated = propsAnimated.current;

      const callback = () => {
        let didUpdate = false;

        if (node.current) {
          didUpdate = applyAnimatedValues.fn(node.current, propsAnimated.current.getAnimatedValue());
        }

        if (!node.current || didUpdate === false) {
          // If no referenced node has been found, or the update target didn't have a
          // native-responder, then forceUpdate the animation ...
          forceUpdate();
        }
      };

      propsAnimated.current = new AnimatedProps(props, callback);
      oldPropsAnimated && oldPropsAnimated.detach();
    }, []);
    (0,react.useEffect)(() => () => {
      mounted.current = false;
      propsAnimated.current && propsAnimated.current.detach();
    }, []);
    (0,react.useImperativeHandle)(ref, () => animatedApi(node, mounted, forceUpdate));
    attachProps(props);

    const _getValue = propsAnimated.current.getValue(),
          scrollTop = _getValue.scrollTop,
          scrollLeft = _getValue.scrollLeft,
          animatedProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_getValue, ["scrollTop", "scrollLeft"]); // Functions cannot have refs, see:
    // See: https://github.com/react-spring/react-spring/issues/569


    const refFn = isFunctionComponent(Component) ? undefined : childRef => node.current = handleRef(childRef, ref);
    return react.createElement(Component, (0,esm_extends/* default */.Z)({}, animatedProps, {
      ref: refFn
    }));
  });
  return AnimatedComponent;
};

let active = false;
const controllers = new Set();

const web_update = () => {
  if (!active) return false;
  let time = web_now();

  for (let controller of controllers) {
    let isActive = false;

    for (let configIdx = 0; configIdx < controller.configs.length; configIdx++) {
      let config = controller.configs[configIdx];
      let endOfAnimation, lastTime;

      for (let valIdx = 0; valIdx < config.animatedValues.length; valIdx++) {
        let animation = config.animatedValues[valIdx]; // If an animation is done, skip, until all of them conclude

        if (animation.done) continue;
        let from = config.fromValues[valIdx];
        let to = config.toValues[valIdx];
        let position = animation.lastPosition;
        let isAnimated = to instanceof Animated;
        let velocity = Array.isArray(config.initialVelocity) ? config.initialVelocity[valIdx] : config.initialVelocity;
        if (isAnimated) to = to.getValue(); // Conclude animation if it's either immediate, or from-values match end-state

        if (config.immediate) {
          animation.setValue(to);
          animation.done = true;
          continue;
        } // Break animation when string values are involved


        if (typeof from === 'string' || typeof to === 'string') {
          animation.setValue(to);
          animation.done = true;
          continue;
        }

        if (config.duration !== void 0) {
          /** Duration easing */
          position = from + config.easing((time - animation.startTime) / config.duration) * (to - from);
          endOfAnimation = time >= animation.startTime + config.duration;
        } else if (config.decay) {
          /** Decay easing */
          position = from + velocity / (1 - 0.998) * (1 - Math.exp(-(1 - 0.998) * (time - animation.startTime)));
          endOfAnimation = Math.abs(animation.lastPosition - position) < 0.1;
          if (endOfAnimation) to = position;
        } else {
          /** Spring easing */
          lastTime = animation.lastTime !== void 0 ? animation.lastTime : time;
          velocity = animation.lastVelocity !== void 0 ? animation.lastVelocity : config.initialVelocity; // If we lost a lot of frames just jump to the end.

          if (time > lastTime + 64) lastTime = time; // http://gafferongames.com/game-physics/fix-your-timestep/

          let numSteps = Math.floor(time - lastTime);

          for (let i = 0; i < numSteps; ++i) {
            let force = -config.tension * (position - to);
            let damping = -config.friction * velocity;
            let acceleration = (force + damping) / config.mass;
            velocity = velocity + acceleration * 1 / 1000;
            position = position + velocity * 1 / 1000;
          } // Conditions for stopping the spring animation


          let isOvershooting = config.clamp && config.tension !== 0 ? from < to ? position > to : position < to : false;
          let isVelocity = Math.abs(velocity) <= config.precision;
          let isDisplacement = config.tension !== 0 ? Math.abs(to - position) <= config.precision : true;
          endOfAnimation = isOvershooting || isVelocity && isDisplacement;
          animation.lastVelocity = velocity;
          animation.lastTime = time;
        } // Trails aren't done until their parents conclude


        if (isAnimated && !config.toValues[valIdx].done) endOfAnimation = false;

        if (endOfAnimation) {
          // Ensure that we end up with a round value
          if (animation.value !== to) position = to;
          animation.done = true;
        } else isActive = true;

        animation.setValue(position);
        animation.lastPosition = position;
      } // Keep track of updated values only when necessary


      if (controller.props.onFrame) controller.values[config.name] = config.interpolation.getValue();
    } // Update callbacks in the end of the frame


    if (controller.props.onFrame) controller.props.onFrame(controller.values); // Either call onEnd or next frame

    if (!isActive) {
      controllers.delete(controller);
      controller.stop(true);
    }
  } // Loop over as long as there are controllers ...


  if (controllers.size) {
    if (manualFrameloop) manualFrameloop();else requestFrame(web_update);
  } else {
    active = false;
  }

  return active;
};

const web_start = controller => {
  if (!controllers.has(controller)) controllers.add(controller);

  if (!active) {
    active = true;
    if (manualFrameloop) requestFrame(manualFrameloop);else requestFrame(web_update);
  }
};

const web_stop = controller => {
  if (controllers.has(controller)) controllers.delete(controller);
};

function createInterpolator(range, output, extrapolate) {
  if (typeof range === 'function') {
    return range;
  }

  if (Array.isArray(range)) {
    return createInterpolator({
      range,
      output: output,
      extrapolate
    });
  }

  if (interpolation && typeof range.output[0] === 'string') {
    return interpolation(range);
  }

  const config = range;
  const outputRange = config.output;
  const inputRange = config.range || [0, 1];
  const extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
  const extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';

  const easing = config.easing || (t => t);

  return input => {
    const range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
  };
}

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input; // Extrapolate

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
  }

  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax; // Input Range

  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin); // Easing

  result = easing(result); // Output Range

  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}

function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) if (inputRange[i] >= input) break;

  return i - 1;
}

class AnimatedInterpolation extends AnimatedArray {
  constructor(parents, range, output, extrapolate) {
    super();
    this.calc = void 0;
    this.payload = parents instanceof AnimatedArray && !(parents instanceof AnimatedInterpolation) ? parents.getPayload() : Array.isArray(parents) ? parents : [parents];
    this.calc = createInterpolator(range, output, extrapolate);
  }

  getValue() {
    return this.calc(...this.payload.map(value => value.getValue()));
  }

  updateConfig(range, output, extrapolate) {
    this.calc = createInterpolator(range, output, extrapolate);
  }

  interpolate(range, output, extrapolate) {
    return new AnimatedInterpolation(this, range, output, extrapolate);
  }

}

const interpolate$1 = (parents, range, output) => parents && new AnimatedInterpolation(parents, range, output);

const config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};

/** API
 *  useChain(references, timeSteps, timeFrame)
 */

function useChain(refs, timeSteps, timeFrame) {
  if (timeFrame === void 0) {
    timeFrame = 1000;
  }

  const previous = useRef();
  useEffect(() => {
    if (is.equ(refs, previous.current)) refs.forEach((_ref) => {
      let current = _ref.current;
      return current && current.start();
    });else if (timeSteps) {
      refs.forEach((_ref2, index) => {
        let current = _ref2.current;

        if (current) {
          const ctrls = current.controllers;

          if (ctrls.length) {
            const t = timeFrame * timeSteps[index];
            ctrls.forEach(ctrl => {
              ctrl.queue = ctrl.queue.map(e => _extends({}, e, {
                delay: e.delay + t
              }));
              ctrl.start();
            });
          }
        }
      });
    } else refs.reduce((q, _ref3, rI) => {
      let current = _ref3.current;
      return q = q.then(() => current.start());
    }, Promise.resolve());
    previous.current = refs;
  });
}

/**
 * Animated works by building a directed acyclic graph of dependencies
 * transparently when you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an AnimatedValue is updated, we recursively go down through this
 * graph in order to find leaf nodes: the views that we flag as needing
 * an update.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new value that it needs. The reason why we need
 * this two-phases process is to deal with composite props such as
 * transform which can receive values from multiple parents.
 */
function addAnimatedStyles(node, styles) {
  if ('update' in node) {
    styles.add(node);
  } else {
    node.getChildren().forEach(child => addAnimatedStyles(child, styles));
  }
}

class AnimatedValue extends Animated {
  constructor(_value) {
    var _this;

    super();
    _this = this;
    this.animatedStyles = new Set();
    this.value = void 0;
    this.startPosition = void 0;
    this.lastPosition = void 0;
    this.lastVelocity = void 0;
    this.startTime = void 0;
    this.lastTime = void 0;
    this.done = false;

    this.setValue = function (value, flush) {
      if (flush === void 0) {
        flush = true;
      }

      _this.value = value;
      if (flush) _this.flush();
    };

    this.value = _value;
    this.startPosition = _value;
    this.lastPosition = _value;
  }

  flush() {
    if (this.animatedStyles.size === 0) {
      addAnimatedStyles(this, this.animatedStyles);
    }

    this.animatedStyles.forEach(animatedStyle => animatedStyle.update());
  }

  clearStyles() {
    this.animatedStyles.clear();
  }

  getValue() {
    return this.value;
  }

  interpolate(range, output, extrapolate) {
    return new AnimatedInterpolation(this, range, output, extrapolate);
  }

}

class AnimatedValueArray extends AnimatedArray {
  constructor(values) {
    super();
    this.payload = values.map(n => new AnimatedValue(n));
  }

  setValue(value, flush) {
    if (flush === void 0) {
      flush = true;
    }

    if (Array.isArray(value)) {
      if (value.length === this.payload.length) {
        value.forEach((v, i) => this.payload[i].setValue(v, flush));
      }
    } else {
      this.payload.forEach(p => p.setValue(value, flush));
    }
  }

  getValue() {
    return this.payload.map(v => v.getValue());
  }

  interpolate(range, output) {
    return new AnimatedInterpolation(this, range, output);
  }

}

let G = 0;

class Controller {
  constructor() {
    this.id = void 0;
    this.idle = true;
    this.hasChanged = false;
    this.guid = 0;
    this.local = 0;
    this.props = {};
    this.merged = {};
    this.animations = {};
    this.interpolations = {};
    this.values = {};
    this.configs = [];
    this.listeners = [];
    this.queue = [];
    this.localQueue = void 0;

    this.getValues = () => this.interpolations;

    this.id = G++;
  }
  /** update(props)
   *  This function filters input props and creates an array of tasks which are executed in .start()
   *  Each task is allowed to carry a delay, which means it can execute asnychroneously */


  update(args) {
    //this._id = n + this.id
    if (!args) return this; // Extract delay and the to-prop from props

    const _ref = interpolateTo(args),
          _ref$delay = _ref.delay,
          delay = _ref$delay === void 0 ? 0 : _ref$delay,
          to = _ref.to,
          props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["delay", "to"]);

    if (is.arr(to) || is.fun(to)) {
      // If config is either a function or an array queue it up as is
      this.queue.push((0,esm_extends/* default */.Z)({}, props, {
        delay,
        to
      }));
    } else if (to) {
      // Otherwise go through each key since it could be delayed individually
      let ops = {};
      Object.entries(to).forEach((_ref2) => {
        let k = _ref2[0],
            v = _ref2[1];

        // Fetch delay and create an entry, consisting of the to-props, the delay, and basic props
        const entry = (0,esm_extends/* default */.Z)({
          to: {
            [k]: v
          },
          delay: callProp(delay, k)
        }, props);

        const previous = ops[entry.delay] && ops[entry.delay].to;
        ops[entry.delay] = (0,esm_extends/* default */.Z)({}, ops[entry.delay], entry, {
          to: (0,esm_extends/* default */.Z)({}, previous, entry.to)
        });
      });
      this.queue = Object.values(ops);
    } // Sort queue, so that async calls go last


    this.queue = this.queue.sort((a, b) => a.delay - b.delay); // Diff the reduced props immediately (they'll contain the from-prop and some config)

    this.diff(props);
    return this;
  }
  /** start(onEnd)
   *  This function either executes a queue, if present, or starts the frameloop, which animates */


  start(onEnd) {
    // If a queue is present we must excecute it
    if (this.queue.length) {
      this.idle = false; // Updates can interrupt trailing queues, in that case we just merge values

      if (this.localQueue) {
        this.localQueue.forEach((_ref3) => {
          let _ref3$from = _ref3.from,
              from = _ref3$from === void 0 ? {} : _ref3$from,
              _ref3$to = _ref3.to,
              to = _ref3$to === void 0 ? {} : _ref3$to;
          if (is.obj(from)) this.merged = (0,esm_extends/* default */.Z)({}, from, this.merged);
          if (is.obj(to)) this.merged = (0,esm_extends/* default */.Z)({}, this.merged, to);
        });
      } // The guid helps us tracking frames, a new queue over an old one means an override
      // We discard async calls in that caseÍ


      const local = this.local = ++this.guid;
      const queue = this.localQueue = this.queue;
      this.queue = []; // Go through each entry and execute it

      queue.forEach((_ref4, index) => {
        let delay = _ref4.delay,
            props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref4, ["delay"]);

        const cb = finished => {
          if (index === queue.length - 1 && local === this.guid && finished) {
            this.idle = true;
            if (this.props.onRest) this.props.onRest(this.merged);
          }

          if (onEnd) onEnd();
        }; // Entries can be delayed, ansyc or immediate


        let async = is.arr(props.to) || is.fun(props.to);

        if (delay) {
          setTimeout(() => {
            if (local === this.guid) {
              if (async) this.runAsync(props, cb);else this.diff(props).start(cb);
            }
          }, delay);
        } else if (async) this.runAsync(props, cb);else this.diff(props).start(cb);
      });
    } // Otherwise we kick of the frameloop
    else {
        if (is.fun(onEnd)) this.listeners.push(onEnd);
        if (this.props.onStart) this.props.onStart();
        web_start(this);
      }

    return this;
  }

  stop(finished) {
    this.listeners.forEach(onEnd => onEnd(finished));
    this.listeners = [];
    return this;
  }
  /** Pause sets onEnd listeners free, but also removes the controller from the frameloop */


  pause(finished) {
    this.stop(true);
    if (finished) web_stop(this);
    return this;
  }

  runAsync(_ref5, onEnd) {
    var _this = this;

    let delay = _ref5.delay,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref5, ["delay"]);

    const local = this.local; // If "to" is either a function or an array it will be processed async, therefor "to" should be empty right now
    // If the view relies on certain values "from" has to be present

    let queue = Promise.resolve(undefined);

    if (is.arr(props.to)) {
      for (let i = 0; i < props.to.length; i++) {
        const index = i;

        const fresh = (0,esm_extends/* default */.Z)({}, props, interpolateTo(props.to[index]));

        if (is.arr(fresh.config)) fresh.config = fresh.config[index];
        queue = queue.then(() => {
          //this.stop()
          if (local === this.guid) return new Promise(r => this.diff(fresh).start(r));
        });
      }
    } else if (is.fun(props.to)) {
      let index = 0;
      let last;
      queue = queue.then(() => props.to( // next(props)
      p => {
        const fresh = (0,esm_extends/* default */.Z)({}, props, interpolateTo(p));

        if (is.arr(fresh.config)) fresh.config = fresh.config[index];
        index++; //this.stop()

        if (local === this.guid) return last = new Promise(r => this.diff(fresh).start(r));
        return;
      }, // cancel()
      function (finished) {
        if (finished === void 0) {
          finished = true;
        }

        return _this.stop(finished);
      }).then(() => last));
    }

    queue.then(onEnd);
  }

  diff(props) {
    this.props = (0,esm_extends/* default */.Z)({}, this.props, props);
    let _this$props = this.props,
        _this$props$from = _this$props.from,
        from = _this$props$from === void 0 ? {} : _this$props$from,
        _this$props$to = _this$props.to,
        to = _this$props$to === void 0 ? {} : _this$props$to,
        _this$props$config = _this$props.config,
        config = _this$props$config === void 0 ? {} : _this$props$config,
        reverse = _this$props.reverse,
        attach = _this$props.attach,
        reset = _this$props.reset,
        immediate = _this$props.immediate; // Reverse values when requested

    if (reverse) {
      var _ref6 = [to, from];
      from = _ref6[0];
      to = _ref6[1];
    } // This will collect all props that were ever set, reset merged props when necessary


    this.merged = (0,esm_extends/* default */.Z)({}, from, this.merged, to);
    this.hasChanged = false; // Attachment handling, trailed springs can "attach" themselves to a previous spring

    let target = attach && attach(this); // Reduces input { name: value } pairs into animated values

    this.animations = Object.entries(this.merged).reduce((acc, _ref7) => {
      let name = _ref7[0],
          value = _ref7[1];
      // Issue cached entries, except on reset
      let entry = acc[name] || {}; // Figure out what the value is supposed to be

      const isNumber = is.num(value);
      const isString = is.str(value) && !value.startsWith('#') && !/\d/.test(value) && !colorNames[value];
      const isArray = is.arr(value);
      const isInterpolation = !isNumber && !isArray && !isString;
      let fromValue = !is.und(from[name]) ? from[name] : value;
      let toValue = isNumber || isArray ? value : isString ? value : 1;
      let toConfig = callProp(config, name);
      if (target) toValue = target.animations[name].parent;
      let parent = entry.parent,
          interpolation$$1 = entry.interpolation,
          toValues = web_toArray(target ? toValue.getPayload() : toValue),
          animatedValues;
      let newValue = value;
      if (isInterpolation) newValue = interpolation({
        range: [0, 1],
        output: [value, value]
      })(1);
      let currentValue = interpolation$$1 && interpolation$$1.getValue(); // Change detection flags

      const isFirst = is.und(parent);
      const isActive = !isFirst && entry.animatedValues.some(v => !v.done);
      const currentValueDiffersFromGoal = !is.equ(newValue, currentValue);
      const hasNewGoal = !is.equ(newValue, entry.previous);
      const hasNewConfig = !is.equ(toConfig, entry.config); // Change animation props when props indicate a new goal (new value differs from previous one)
      // and current values differ from it. Config changes trigger a new update as well (though probably shouldn't?)

      if (reset || hasNewGoal && currentValueDiffersFromGoal || hasNewConfig) {
        // Convert regular values into animated values, ALWAYS re-use if possible
        if (isNumber || isString) parent = interpolation$$1 = entry.parent || new AnimatedValue(fromValue);else if (isArray) parent = interpolation$$1 = entry.parent || new AnimatedValueArray(fromValue);else if (isInterpolation) {
          let prev = entry.interpolation && entry.interpolation.calc(entry.parent.value);
          prev = prev !== void 0 && !reset ? prev : fromValue;

          if (entry.parent) {
            parent = entry.parent;
            parent.setValue(0, false);
          } else parent = new AnimatedValue(0);

          const range = {
            output: [prev, value]
          };

          if (entry.interpolation) {
            interpolation$$1 = entry.interpolation;
            entry.interpolation.updateConfig(range);
          } else interpolation$$1 = parent.interpolate(range);
        }
        toValues = web_toArray(target ? toValue.getPayload() : toValue);
        animatedValues = web_toArray(parent.getPayload());
        if (reset && !isInterpolation) parent.setValue(fromValue, false);
        this.hasChanged = true; // Reset animated values

        animatedValues.forEach(value => {
          value.startPosition = value.value;
          value.lastPosition = value.value;
          value.lastVelocity = isActive ? value.lastVelocity : undefined;
          value.lastTime = isActive ? value.lastTime : undefined;
          value.startTime = web_now();
          value.done = false;
          value.animatedStyles.clear();
        }); // Set immediate values

        if (callProp(immediate, name)) {
          parent.setValue(isInterpolation ? toValue : value, false);
        }

        return (0,esm_extends/* default */.Z)({}, acc, {
          [name]: (0,esm_extends/* default */.Z)({}, entry, {
            name,
            parent,
            interpolation: interpolation$$1,
            animatedValues,
            toValues,
            previous: newValue,
            config: toConfig,
            fromValues: web_toArray(parent.getValue()),
            immediate: callProp(immediate, name),
            initialVelocity: withDefault(toConfig.velocity, 0),
            clamp: withDefault(toConfig.clamp, false),
            precision: withDefault(toConfig.precision, 0.01),
            tension: withDefault(toConfig.tension, 170),
            friction: withDefault(toConfig.friction, 26),
            mass: withDefault(toConfig.mass, 1),
            duration: toConfig.duration,
            easing: withDefault(toConfig.easing, t => t),
            decay: toConfig.decay
          })
        });
      } else {
        if (!currentValueDiffersFromGoal) {
          // So ... the current target value (newValue) appears to be different from the previous value,
          // which normally constitutes an update, but the actual value (currentValue) matches the target!
          // In order to resolve this without causing an animation update we silently flag the animation as done,
          // which it technically is. Interpolations also needs a config update with their target set to 1.
          if (isInterpolation) {
            parent.setValue(1, false);
            interpolation$$1.updateConfig({
              output: [newValue, newValue]
            });
          }

          parent.done = true;
          this.hasChanged = true;
          return (0,esm_extends/* default */.Z)({}, acc, {
            [name]: (0,esm_extends/* default */.Z)({}, acc[name], {
              previous: newValue
            })
          });
        }

        return acc;
      }
    }, this.animations);

    if (this.hasChanged) {
      // Make animations available to frameloop
      this.configs = Object.values(this.animations);
      this.values = {};
      this.interpolations = {};

      for (let key in this.animations) {
        this.interpolations[key] = this.animations[key].interpolation;
        this.values[key] = this.animations[key].interpolation.getValue();
      }
    }

    return this;
  }

  destroy() {
    this.stop();
    this.props = {};
    this.merged = {};
    this.animations = {};
    this.interpolations = {};
    this.values = {};
    this.configs = [];
    this.local = 0;
  }

}

/** API
 * const props = useSprings(number, [{ ... }, { ... }, ...])
 * const [props, set] = useSprings(number, (i, controller) => ({ ... }))
 */

const useSprings = (length, props) => {
  const mounted = (0,react.useRef)(false);
  const ctrl = (0,react.useRef)();
  const isFn = is.fun(props); // The controller maintains the animation values, starts and stops animations

  const _useMemo = (0,react.useMemo)(() => {
    // Remove old controllers
    if (ctrl.current) {
      ctrl.current.map(c => c.destroy());
      ctrl.current = undefined;
    }

    let ref;
    return [new Array(length).fill().map((_, i) => {
      const ctrl = new Controller();
      const newProps = isFn ? callProp(props, i, ctrl) : props[i];
      if (i === 0) ref = newProps.ref;
      ctrl.update(newProps);
      if (!ref) ctrl.start();
      return ctrl;
    }), ref];
  }, [length]),
        controllers = _useMemo[0],
        ref = _useMemo[1];

  ctrl.current = controllers; // The hooks reference api gets defined here ...

  const api = (0,react.useImperativeHandle)(ref, () => ({
    start: () => Promise.all(ctrl.current.map(c => new Promise(r => c.start(r)))),
    stop: finished => ctrl.current.forEach(c => c.stop(finished)),

    get controllers() {
      return ctrl.current;
    }

  })); // This function updates the controllers

  const updateCtrl = (0,react.useMemo)(() => updateProps => ctrl.current.map((c, i) => {
    c.update(isFn ? callProp(updateProps, i, c) : updateProps[i]);
    if (!ref) c.start();
  }), [length]); // Update controller if props aren't functional

  (0,react.useEffect)(() => {
    if (mounted.current) {
      if (!isFn) updateCtrl(props);
    } else if (!ref) ctrl.current.forEach(c => c.start());
  }); // Update mounted flag and destroy controller on unmount

  (0,react.useEffect)(() => (mounted.current = true, () => ctrl.current.forEach(c => c.destroy())), []); // Return animated props, or, anim-props + the update-setter above

  const propValues = ctrl.current.map(c => c.getValues());
  return isFn ? [propValues, updateCtrl, finished => ctrl.current.forEach(c => c.pause(finished))] : propValues;
};

/** API
 * const props = useSpring({ ... })
 * const [props, set] = useSpring(() => ({ ... }))
 */

const useSpring = props => {
  const isFn = is.fun(props);

  const _useSprings = useSprings(1, isFn ? props : [props]),
        result = _useSprings[0],
        set = _useSprings[1],
        pause = _useSprings[2];

  return isFn ? [result[0], set, pause] : result;
};

/** API
 * const trails = useTrail(number, { ... })
 * const [trails, set] = useTrail(number, () => ({ ... }))
 */

const useTrail = (length, props) => {
  const mounted = useRef(false);
  const isFn = is.fun(props);
  const updateProps = callProp(props);
  const instances = useRef();

  const _useSprings = useSprings(length, (i, ctrl) => {
    if (i === 0) instances.current = [];
    instances.current.push(ctrl);
    return _extends({}, updateProps, {
      config: callProp(updateProps.config, i),
      attach: i > 0 && (() => instances.current[i - 1])
    });
  }),
        result = _useSprings[0],
        set = _useSprings[1],
        pause = _useSprings[2]; // Set up function to update controller


  const updateCtrl = useMemo(() => props => set((i, ctrl) => {
    const last = props.reverse ? i === 0 : length - 1 === i;
    const attachIdx = props.reverse ? i + 1 : i - 1;
    const attachController = instances.current[attachIdx];
    return _extends({}, props, {
      config: callProp(props.config || updateProps.config, i),
      attach: attachController && (() => attachController)
    });
  }), [length, updateProps.reverse]); // Update controller if props aren't functional

  useEffect(() => void (mounted.current && !isFn && updateCtrl(props))); // Update mounted flag and destroy controller on unmount

  useEffect(() => void (mounted.current = true), []);
  return isFn ? [result, updateCtrl, pause] : result;
};

/** API
 * const transitions = useTransition(items, itemKeys, { ... })
 * const [transitions, update] = useTransition(items, itemKeys, () => ({ ... }))
 */

let guid = 0;
const ENTER = 'enter';
const LEAVE = 'leave';
const UPDATE = 'update';

const mapKeys = (items, keys) => (typeof keys === 'function' ? items.map(keys) : web_toArray(keys)).map(String);

const get = props => {
  let items = props.items,
      _props$keys = props.keys,
      keys = _props$keys === void 0 ? item => item : _props$keys,
      rest = _objectWithoutPropertiesLoose(props, ["items", "keys"]);

  items = web_toArray(items !== void 0 ? items : null);
  return _extends({
    items,
    keys: mapKeys(items, keys)
  }, rest);
};

function useTransition(input, keyTransform, config) {
  const props = _extends({
    items: input,
    keys: keyTransform || (i => i)
  }, config);

  const _get = get(props),
        _get$lazy = _get.lazy,
        lazy = _get$lazy === void 0 ? false : _get$lazy,
        _get$unique = _get.unique,
        _get$reset = _get.reset,
        reset = _get$reset === void 0 ? false : _get$reset,
        enter = _get.enter,
        leave = _get.leave,
        update = _get.update,
        onDestroyed = _get.onDestroyed,
        keys = _get.keys,
        items = _get.items,
        onFrame = _get.onFrame,
        _onRest = _get.onRest,
        onStart = _get.onStart,
        ref = _get.ref,
        extra = _objectWithoutPropertiesLoose(_get, ["lazy", "unique", "reset", "enter", "leave", "update", "onDestroyed", "keys", "items", "onFrame", "onRest", "onStart", "ref"]);

  const forceUpdate = web_useForceUpdate();
  const mounted = useRef(false);
  const state = useRef({
    mounted: false,
    first: true,
    deleted: [],
    current: {},
    transitions: [],
    prevProps: {},
    paused: !!props.ref,
    instances: !mounted.current && new Map(),
    forceUpdate
  });
  useImperativeHandle(props.ref, () => ({
    start: () => Promise.all(Array.from(state.current.instances).map((_ref) => {
      let c = _ref[1];
      return new Promise(r => c.start(r));
    })),
    stop: finished => Array.from(state.current.instances).forEach((_ref2) => {
      let c = _ref2[1];
      return c.stop(finished);
    }),

    get controllers() {
      return Array.from(state.current.instances).map((_ref3) => {
        let c = _ref3[1];
        return c;
      });
    }

  })); // Update state

  state.current = diffItems(state.current, props);

  if (state.current.changed) {
    // Update state
    state.current.transitions.forEach(transition => {
      const slot = transition.slot,
            from = transition.from,
            to = transition.to,
            config = transition.config,
            trail = transition.trail,
            key = transition.key,
            item = transition.item;
      if (!state.current.instances.has(key)) state.current.instances.set(key, new Controller()); // update the map object

      const ctrl = state.current.instances.get(key);

      const newProps = _extends({}, extra, {
        to,
        from,
        config,
        ref,
        onRest: values => {
          if (state.current.mounted) {
            if (transition.destroyed) {
              // If no ref is given delete destroyed items immediately
              if (!ref && !lazy) cleanUp(state, key);
              if (onDestroyed) onDestroyed(item);
            } // A transition comes to rest once all its springs conclude


            const curInstances = Array.from(state.current.instances);
            const active = curInstances.some((_ref4) => {
              let c = _ref4[1];
              return !c.idle;
            });
            if (!active && (ref || lazy) && state.current.deleted.length > 0) cleanUp(state);
            if (_onRest) _onRest(item, slot, values);
          }
        },
        onStart: onStart && (() => onStart(item, slot)),
        onFrame: onFrame && (values => onFrame(item, slot, values)),
        delay: trail,
        reset: reset && slot === ENTER // Update controller

      });

      ctrl.update(newProps);
      if (!state.current.paused) ctrl.start();
    });
  }

  useEffect(() => {
    state.current.mounted = mounted.current = true;
    return () => {
      state.current.mounted = mounted.current = false;
      Array.from(state.current.instances).map((_ref5) => {
        let c = _ref5[1];
        return c.destroy();
      });
      state.current.instances.clear();
    };
  }, []);
  return state.current.transitions.map((_ref6) => {
    let item = _ref6.item,
        slot = _ref6.slot,
        key = _ref6.key;
    return {
      item,
      key,
      state: slot,
      props: state.current.instances.get(key).getValues()
    };
  });
}

function cleanUp(state, filterKey) {
  const deleted = state.current.deleted;

  for (let _ref7 of deleted) {
    let key = _ref7.key;

    const filter = t => t.key !== key;

    if (is.und(filterKey) || filterKey === key) {
      state.current.instances.delete(key);
      state.current.transitions = state.current.transitions.filter(filter);
      state.current.deleted = state.current.deleted.filter(filter);
    }
  }

  state.current.forceUpdate();
}

function diffItems(_ref8, props) {
  let first = _ref8.first,
      prevProps = _ref8.prevProps,
      state = _objectWithoutPropertiesLoose(_ref8, ["first", "prevProps"]);

  let _get2 = get(props),
      items = _get2.items,
      keys = _get2.keys,
      initial = _get2.initial,
      from = _get2.from,
      enter = _get2.enter,
      leave = _get2.leave,
      update = _get2.update,
      _get2$trail = _get2.trail,
      trail = _get2$trail === void 0 ? 0 : _get2$trail,
      unique = _get2.unique,
      config = _get2.config,
      _get2$order = _get2.order,
      order = _get2$order === void 0 ? [ENTER, LEAVE, UPDATE] : _get2$order;

  let _get3 = get(prevProps),
      _keys = _get3.keys,
      _items = _get3.items;

  let current = _extends({}, state.current);

  let deleted = [...state.deleted]; // Compare next keys with current keys

  let currentKeys = Object.keys(current);
  let currentSet = new Set(currentKeys);
  let nextSet = new Set(keys);
  let added = keys.filter(item => !currentSet.has(item));
  let removed = state.transitions.filter(item => !item.destroyed && !nextSet.has(item.originalKey)).map(i => i.originalKey);
  let updated = keys.filter(item => currentSet.has(item));
  let delay = -trail;

  while (order.length) {
    const changeType = order.shift();

    switch (changeType) {
      case ENTER:
        {
          added.forEach((key, index) => {
            // In unique mode, remove fading out transitions if their key comes in again
            if (unique && deleted.find(d => d.originalKey === key)) deleted = deleted.filter(t => t.originalKey !== key);
            const keyIndex = keys.indexOf(key);
            const item = items[keyIndex];
            const slot = first && initial !== void 0 ? 'initial' : ENTER;
            current[key] = {
              slot,
              originalKey: key,
              key: unique ? String(key) : guid++,
              item,
              trail: delay = delay + trail,
              config: callProp(config, item, slot),
              from: callProp(first ? initial !== void 0 ? initial || {} : from : from, item),
              to: callProp(enter, item)
            };
          });
          break;
        }

      case LEAVE:
        {
          removed.forEach(key => {
            const keyIndex = _keys.indexOf(key);

            const item = _items[keyIndex];
            const slot = LEAVE;
            deleted.unshift(_extends({}, current[key], {
              slot,
              destroyed: true,
              left: _keys[Math.max(0, keyIndex - 1)],
              right: _keys[Math.min(_keys.length, keyIndex + 1)],
              trail: delay = delay + trail,
              config: callProp(config, item, slot),
              to: callProp(leave, item)
            }));
            delete current[key];
          });
          break;
        }

      case UPDATE:
        {
          updated.forEach(key => {
            const keyIndex = keys.indexOf(key);
            const item = items[keyIndex];
            const slot = UPDATE;
            current[key] = _extends({}, current[key], {
              item,
              slot,
              trail: delay = delay + trail,
              config: callProp(config, item, slot),
              to: callProp(update, item)
            });
          });
          break;
        }
    }
  }

  let out = keys.map(key => current[key]); // This tries to restore order for deleted items by finding their last known siblings
  // only using the left sibling to keep order placement consistent for all deleted items

  deleted.forEach((_ref9) => {
    let left = _ref9.left,
        right = _ref9.right,
        item = _objectWithoutPropertiesLoose(_ref9, ["left", "right"]);

    let pos; // Was it the element on the left, if yes, move there ...

    if ((pos = out.findIndex(t => t.originalKey === left)) !== -1) pos += 1; // And if nothing else helps, move it to the start ¯\_(ツ)_/¯

    pos = Math.max(0, pos);
    out = [...out.slice(0, pos), item, ...out.slice(pos)];
  });
  return _extends({}, state, {
    changed: added.length || removed.length || updated.length,
    first: first && added.length === 0,
    transitions: out,
    current,
    deleted,
    prevProps: props
  });
}

class AnimatedStyle extends AnimatedObject {
  constructor(style) {
    if (style === void 0) {
      style = {};
    }

    super();

    if (style.transform && !(style.transform instanceof Animated)) {
      style = applyAnimatedValues.transform(style);
    }

    this.payload = style;
  }

}

// http://www.w3.org/TR/css3-color/#svg-color
const colors = {
  transparent: 0x00000000,
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff
};

// const INTEGER = '[-+]?\\d+';
const NUMBER = '[-+]?\\d*\\.?\\d+';
const PERCENTAGE = NUMBER + '%';

function call() {
  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
}

const rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
const rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
const hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
const hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
const hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex6 = /^#([0-9a-fA-F]{6})$/;
const hex8 = /^#([0-9a-fA-F]{8})$/;

/*
https://github.com/react-community/normalize-css-color

BSD 3-Clause License

Copyright (c) 2016, React Community
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

* Neither the name of the copyright holder nor the names of its
  contributors may be used to endorse or promote products derived from
  this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
function normalizeColor(color) {
  let match;

  if (typeof color === 'number') {
    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
  } // Ordered based on occurrences on Facebook codebase


  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;
  if (colors.hasOwnProperty(color)) return colors[color];

  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    0x000000ff) >>> // a
    0;
  }

  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
  }

  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    'ff', // a
    16) >>> 0;
  } // https://drafts.csswg.org/css-color-4/#hex-notation


  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;

  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
  }

  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | 0x000000ff) >>> // a
    0;
  }

  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | parse1(match[4])) >>> // a
    0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}

function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0) return 0;
  if (int > 255) return 255;
  return int;
}

function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}

function parse1(str) {
  const num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  const int = parseFloat(str);
  if (int < 0) return 0;
  if (int > 100) return 1;
  return int / 100;
}

function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  let r = (int32Color & 0xff000000) >>> 24;
  let g = (int32Color & 0x00ff0000) >>> 16;
  let b = (int32Color & 0x0000ff00) >>> 8;
  let a = (int32Color & 0x000000ff) / 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
} // Problem: https://github.com/animatedjs/animated/pull/102
// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662


const stringShapeRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g; // Covers rgb, rgba, hsl, hsla
// Taken from https://gist.github.com/olmokramer/82ccce673f86db7cda5e

const colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi; // Covers color names (transparent, blue, etc.)

const colorNamesRegex = new RegExp(`(${Object.keys(colors).join('|')})`, 'g');
/**
 * Supports string shapes by extracting numbers so new values can be computed,
 * and recombines those values into new strings of the same shape.  Supports
 * things like:
 *
 *   rgba(123, 42, 99, 0.36)           // colors
 *   -45deg                            // values with units
 *   0 2px 2px 0px rgba(0, 0, 0, 0.12) // box shadows
 */

const createStringInterpolator = config => {
  // Replace colors with rgba
  const outputRange = config.output.map(rangeValue => rangeValue.replace(colorRegex, colorToRgba)).map(rangeValue => rangeValue.replace(colorNamesRegex, colorToRgba));
  const outputRanges = outputRange[0].match(stringShapeRegex).map(() => []);
  outputRange.forEach(value => {
    value.match(stringShapeRegex).forEach((number, i) => outputRanges[i].push(+number));
  });
  const interpolations = outputRange[0].match(stringShapeRegex).map((_value, i) => createInterpolator((0,esm_extends/* default */.Z)({}, config, {
    output: outputRanges[i]
  })));
  return input => {
    let i = 0;
    return outputRange[0] // 'rgba(0, 100, 200, 0)'
    // ->
    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
    .replace(stringShapeRegex, () => interpolations[i++](input)) // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
    // round the opacity (4th column).
    .replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`);
  };
};

let isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

const prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);

const prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes.forEach(prefix => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);

function dangerousStyleValue(name, value, isCustomProperty) {
  if (value == null || typeof value === 'boolean' || value === '') return '';
  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers

  return ('' + value).trim();
}

const attributeCache = {};
injectCreateAnimatedStyle(style => new AnimatedStyle(style));
injectDefaultElement('div');
injectStringInterpolator(createStringInterpolator);
injectColorNames(colors);
injectApplyAnimatedValues((instance, props) => {
  if (instance.nodeType && instance.setAttribute !== undefined) {
    const style = props.style,
          children = props.children,
          scrollTop = props.scrollTop,
          scrollLeft = props.scrollLeft,
          attributes = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ["style", "children", "scrollTop", "scrollLeft"]);

    const filter = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter';
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft; // Set textContent, if children is an animatable value

    if (children !== void 0) instance.textContent = children; // Set styles ...

    for (let styleName in style) {
      if (!style.hasOwnProperty(styleName)) continue;
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = dangerousStyleValue(styleName, style[styleName], isCustomProperty);
      if (styleName === 'float') styleName = 'cssFloat';
      if (isCustomProperty) instance.style.setProperty(styleName, styleValue);else instance.style[styleName] = styleValue;
    } // Set attributes ...


    for (let name in attributes) {
      // Attributes are written in dash case
      const dashCase = filter ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, n => '-' + n.toLowerCase()));
      if (typeof instance.getAttribute(dashCase) !== 'undefined') instance.setAttribute(dashCase, attributes[name]);
    }

    return;
  } else return false;
}, style => style);

const domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
// Extend animated with all the available THREE elements
const apply = merge(createAnimatedComponent, false);
const extendedAnimated = apply(domElements);



;// CONCATENATED MODULE: ../../node_modules/react-use-gesture/dist/react-use-gesture.esm.js


// vector add
function addV(v1, v2) {
  return v1.map(function (v, i) {
    return v + v2[i];
  });
} // vector substract

function subV(v1, v2) {
  return v1.map(function (v, i) {
    return v - v2[i];
  });
}
/**
 * Calculates distance
 * @param movement the difference between current and initial vectors
 * @returns distance
 */

function calculateDistance(movement) {
  return Math.hypot.apply(Math, movement);
}
function calculateAllGeometry(movement, delta) {
  if (delta === void 0) {
    delta = movement;
  }

  var dl = calculateDistance(delta);
  var alpha = dl === 0 ? 0 : 1 / dl;
  var direction = delta.map(function (v) {
    return alpha * v;
  });
  var distance = calculateDistance(movement);
  return {
    distance: distance,
    direction: direction
  };
}
/**
 * Calculates all kinematics
 * @template T the expected vector type
 * @param movement the difference between current and initial vectors
 * @param delta the difference between current and previous vectors
 * @param delta_t the time difference between current and previous timestamps
 * @returns all kinematics
 */

function calculateAllKinematics(movement, delta, dt) {
  var dl = calculateDistance(delta);
  var alpha = dl === 0 ? 0 : 1 / dl;
  var beta = dt === 0 ? 0 : 1 / dt;
  var velocity = beta * dl;
  var velocities = delta.map(function (v) {
    return beta * v;
  });
  var direction = delta.map(function (v) {
    return alpha * v;
  });
  var distance = calculateDistance(movement);
  return {
    velocities: velocities,
    velocity: velocity,
    distance: distance,
    direction: direction
  };
}
/**
 * Because IE doesn't support `Math.sign` function, so we use the polyfill version of the function.
 * This polyfill function is suggested by Mozilla:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign#Polyfill
 * @param x target number
 */

function sign(x) {
  if (Math.sign) return Math.sign(x);
  return Number(x > 0) - Number(x < 0) || +x;
}

function minMax(value, min, max) {
  return Math.max(min, Math.min(value, max));
} // Based on @aholachek ;)
// https://twitter.com/chpwn/status/285540192096497664
// iOS constant = 0.55
// https://medium.com/@nathangitter/building-fluid-interfaces-ios-swift-9732bb934bf5


function rubberband2(distance, constant) {
  // default constant from the article is 0.7
  return Math.pow(distance, constant * 5);
}

function rubberband(distance, dimension, constant) {
  if (dimension === 0 || Math.abs(dimension) === Infinity) return rubberband2(distance, constant);
  return distance * dimension * constant / (dimension + constant * distance);
}

function rubberbandIfOutOfBounds(position, min, max, constant) {
  if (constant === void 0) {
    constant = 0.15;
  }

  if (constant === 0) return minMax(position, min, max);
  if (position < min) return -rubberband(min - position, max - min, constant) + min;
  if (position > max) return +rubberband(position - max, max - min, constant) + max;
  return position;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function react_use_gesture_esm_extends() {
  react_use_gesture_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return react_use_gesture_esm_extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function react_use_gesture_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function react_use_gesture_esm_noop() {}
/**
 * TODO Beware that only optimized cases are covered in tests =)
 * TODO Need to cover general case as well
 *
 * @param fns
 */

function chainFns() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  if (fns.length === 0) return react_use_gesture_esm_noop;
  if (fns.length === 1) return fns[0];
  return function () {
    var result;

    for (var _iterator = _createForOfIteratorHelperLoose(fns), _step; !(_step = _iterator()).done;) {
      var fn = _step.value;
      result = fn.apply(this, arguments) || result;
    }

    return result;
  };
}
/**
 * Expects a simple value or 2D vector (an array with 2 elements) and
 * always returns 2D vector. If simple value is passed, returns a
 * vector with this value as both coordinates.
 *
 * @param value
 */

function ensureVector(value, fallback) {
  if (value === undefined) {
    if (fallback === undefined) {
      throw new Error('Must define fallback value if undefined is expected');
    }

    value = fallback;
  }

  if (Array.isArray(value)) return value;
  return [value, value];
}
/**
 * Helper for defining a default value
 *
 * @param value
 * @param fallback
 */

function assignDefault(value, fallback) {
  return Object.assign({}, fallback, value || {});
}
/**
 * Resolves getters (functions) by calling them
 * If simple value is given it just passes through
 *
 * @param v
 */

function valueFn(v) {
  if (typeof v === 'function') {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    // @ts-ignore
    return v.apply(void 0, args);
  } else {
    return v;
  }
}

function resolveWith(config, resolvers) {
  if (config === void 0) {
    config = {};
  }

  var result = {};

  for (var _i = 0, _Object$entries = Object.entries(resolvers); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
        key = _Object$entries$_i[0],
        resolver = _Object$entries$_i[1];

    switch (typeof resolver) {
      case 'function':
        result[key] = resolver.call(result, config[key], key, config);
        break;

      case 'object':
        result[key] = resolveWith(config[key], resolver);
        break;

      case 'boolean':
        if (resolver) result[key] = config[key];
        break;
    }
  }

  return result;
}

var DEFAULT_DRAG_DELAY = 180;
var DEFAULT_RUBBERBAND = 0.15;
var DEFAULT_SWIPE_VELOCITY = 0.5;
var DEFAULT_SWIPE_DISTANCE = 60;
var InternalGestureOptionsNormalizers = {
  threshold: function threshold(value) {
    if (value === void 0) {
      value = 0;
    }

    return ensureVector(value);
  },
  rubberband: function rubberband(value) {
    if (value === void 0) {
      value = 0;
    }

    switch (value) {
      case true:
        return ensureVector(DEFAULT_RUBBERBAND);

      case false:
        return ensureVector(0);

      default:
        return ensureVector(value);
    }
  },
  enabled: function enabled(value) {
    if (value === void 0) {
      value = true;
    }

    return value;
  },
  triggerAllEvents: function triggerAllEvents(value) {
    if (value === void 0) {
      value = false;
    }

    return value;
  },
  initial: function initial(value) {
    if (value === void 0) {
      value = 0;
    }

    if (typeof value === 'function') return value;
    return ensureVector(value);
  }
};

var InternalCoordinatesOptionsNormalizers = /*#__PURE__*/react_use_gesture_esm_extends({}, InternalGestureOptionsNormalizers, {
  axis: true,
  lockDirection: function lockDirection(value) {
    if (value === void 0) {
      value = false;
    }

    return value;
  },
  bounds: function bounds(value) {
    if (value === void 0) {
      value = {};
    }

    if (typeof value === 'function') return function (state) {
      return InternalCoordinatesOptionsNormalizers.bounds(value(state));
    };
    var _value2 = value,
        _value2$left = _value2.left,
        left = _value2$left === void 0 ? -Infinity : _value2$left,
        _value2$right = _value2.right,
        right = _value2$right === void 0 ? Infinity : _value2$right,
        _value2$top = _value2.top,
        top = _value2$top === void 0 ? -Infinity : _value2$top,
        _value2$bottom = _value2.bottom,
        bottom = _value2$bottom === void 0 ? Infinity : _value2$bottom;
    return [[left, right], [top, bottom]];
  }
});

var isBrowser = typeof window !== 'undefined' && window.document && window.document.createElement;
var InternalGenericOptionsNormalizers = {
  enabled: function enabled(value) {
    if (value === void 0) {
      value = true;
    }

    return value;
  },
  domTarget: true,
  window: /*#__PURE__*/function (_window) {
    function window(_x) {
      return _window.apply(this, arguments);
    }

    window.toString = function () {
      return _window.toString();
    };

    return window;
  }(function (value) {
    if (value === void 0) {
      value = isBrowser ? window : undefined;
    }

    return value;
  }),
  eventOptions: function eventOptions(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$passive = _ref.passive,
        passive = _ref$passive === void 0 ? true : _ref$passive,
        _ref$capture = _ref.capture,
        capture = _ref$capture === void 0 ? false : _ref$capture;

    return {
      passive: passive,
      capture: capture
    };
  }
};

var InternalDistanceAngleOptionsNormalizers = /*#__PURE__*/react_use_gesture_esm_extends({}, InternalGestureOptionsNormalizers, {
  bounds: function bounds(_value, _key, _ref2) {
    var _ref2$distanceBounds = _ref2.distanceBounds,
        distanceBounds = _ref2$distanceBounds === void 0 ? {} : _ref2$distanceBounds,
        _ref2$angleBounds = _ref2.angleBounds,
        angleBounds = _ref2$angleBounds === void 0 ? {} : _ref2$angleBounds;

    var _distanceBounds = function _distanceBounds(state) {
      var D = assignDefault(valueFn(distanceBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [D.min, D.max];
    };

    var _angleBounds = function _angleBounds(state) {
      var A = assignDefault(valueFn(angleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [A.min, A.max];
    };

    if (typeof distanceBounds !== 'function' && typeof angleBounds !== 'function') return [_distanceBounds(), _angleBounds()];
    return function (state) {
      return [_distanceBounds(state), _angleBounds(state)];
    };
  }
});

var InternalDragOptionsNormalizers = /*#__PURE__*/react_use_gesture_esm_extends({}, InternalCoordinatesOptionsNormalizers, {
  threshold: function threshold(v, _k, _ref3) {
    var _ref3$filterTaps = _ref3.filterTaps,
        filterTaps = _ref3$filterTaps === void 0 ? false : _ref3$filterTaps,
        _ref3$lockDirection = _ref3.lockDirection,
        lockDirection = _ref3$lockDirection === void 0 ? false : _ref3$lockDirection,
        _ref3$axis = _ref3.axis,
        axis = _ref3$axis === void 0 ? undefined : _ref3$axis;
    var A = ensureVector(v, filterTaps ? 3 : lockDirection ? 1 : axis ? 1 : 0);
    this.filterTaps = filterTaps || A[0] + A[1] > 0;
    return A;
  },
  swipeVelocity: function swipeVelocity(v) {
    if (v === void 0) {
      v = DEFAULT_SWIPE_VELOCITY;
    }

    return ensureVector(v);
  },
  swipeDistance: function swipeDistance(v) {
    if (v === void 0) {
      v = DEFAULT_SWIPE_DISTANCE;
    }

    return ensureVector(v);
  },
  delay: function delay(value) {
    if (value === void 0) {
      value = 0;
    }

    switch (value) {
      case true:
        return DEFAULT_DRAG_DELAY;

      case false:
        return 0;

      default:
        return value;
    }
  }
});

function getInternalGenericOptions(config) {
  if (config === void 0) {
    config = {};
  }

  // TODO warn when passive is set to true and domTarget is undefined
  return resolveWith(config, InternalGenericOptionsNormalizers);
}
function getInternalCoordinatesOptions(config) {
  if (config === void 0) {
    config = {};
  }

  return resolveWith(config, InternalCoordinatesOptionsNormalizers);
}
function getInternalDistanceAngleOptions(config) {
  if (config === void 0) {
    config = {};
  }

  return resolveWith(config, InternalDistanceAngleOptionsNormalizers);
}
function getInternalDragOptions(config) {
  if (config === void 0) {
    config = {};
  }

  return resolveWith(config, InternalDragOptionsNormalizers);
}

function _buildMoveConfig(_ref) {
  var domTarget = _ref.domTarget,
      eventOptions = _ref.eventOptions,
      window = _ref.window,
      enabled = _ref.enabled,
      rest = react_use_gesture_esm_objectWithoutPropertiesLoose(_ref, ["domTarget", "eventOptions", "window", "enabled"]);

  var opts = getInternalGenericOptions({
    domTarget: domTarget,
    eventOptions: eventOptions,
    window: window,
    enabled: enabled
  });
  opts.move = getInternalCoordinatesOptions(rest);
  return opts;
}
function _buildHoverConfig(_ref2) {
  var domTarget = _ref2.domTarget,
      eventOptions = _ref2.eventOptions,
      window = _ref2.window,
      enabled = _ref2.enabled,
      rest = react_use_gesture_esm_objectWithoutPropertiesLoose(_ref2, ["domTarget", "eventOptions", "window", "enabled"]);

  var opts = getInternalGenericOptions({
    domTarget: domTarget,
    eventOptions: eventOptions,
    window: window,
    enabled: enabled
  });
  opts.hover = react_use_gesture_esm_extends({
    enabled: true
  }, rest);
  return opts;
}
function _buildDragConfig(_ref3) {
  var domTarget = _ref3.domTarget,
      eventOptions = _ref3.eventOptions,
      window = _ref3.window,
      enabled = _ref3.enabled,
      rest = react_use_gesture_esm_objectWithoutPropertiesLoose(_ref3, ["domTarget", "eventOptions", "window", "enabled"]);

  var opts = getInternalGenericOptions({
    domTarget: domTarget,
    eventOptions: eventOptions,
    window: window,
    enabled: enabled
  });
  opts.drag = getInternalDragOptions(rest);
  return opts;
}
function _buildPinchConfig(_ref4) {
  var domTarget = _ref4.domTarget,
      eventOptions = _ref4.eventOptions,
      window = _ref4.window,
      enabled = _ref4.enabled,
      rest = react_use_gesture_esm_objectWithoutPropertiesLoose(_ref4, ["domTarget", "eventOptions", "window", "enabled"]);

  var opts = getInternalGenericOptions({
    domTarget: domTarget,
    eventOptions: eventOptions,
    window: window,
    enabled: enabled
  });
  opts.pinch = getInternalDistanceAngleOptions(rest);
  return opts;
}
function _buildScrollConfig(_ref5) {
  var domTarget = _ref5.domTarget,
      eventOptions = _ref5.eventOptions,
      window = _ref5.window,
      enabled = _ref5.enabled,
      rest = react_use_gesture_esm_objectWithoutPropertiesLoose(_ref5, ["domTarget", "eventOptions", "window", "enabled"]);

  var opts = getInternalGenericOptions({
    domTarget: domTarget,
    eventOptions: eventOptions,
    window: window,
    enabled: enabled
  });
  opts.scroll = getInternalCoordinatesOptions(rest);
  return opts;
}
function _buildWheelConfig(_ref6) {
  var domTarget = _ref6.domTarget,
      eventOptions = _ref6.eventOptions,
      window = _ref6.window,
      enabled = _ref6.enabled,
      rest = react_use_gesture_esm_objectWithoutPropertiesLoose(_ref6, ["domTarget", "eventOptions", "window", "enabled"]);

  var opts = getInternalGenericOptions({
    domTarget: domTarget,
    eventOptions: eventOptions,
    window: window,
    enabled: enabled
  });
  opts.wheel = getInternalCoordinatesOptions(rest);
  return opts;
}
function buildComplexConfig(config, actions) {
  if (config === void 0) {
    config = {};
  }

  if (actions === void 0) {
    actions = new Set();
  }

  var _config = config,
      drag = _config.drag,
      wheel = _config.wheel,
      move = _config.move,
      scroll = _config.scroll,
      pinch = _config.pinch,
      hover = _config.hover,
      eventOptions = _config.eventOptions,
      window = _config.window,
      domTarget = _config.domTarget,
      enabled = _config.enabled;
  var mergedConfig = getInternalGenericOptions({
    eventOptions: eventOptions,
    window: window,
    domTarget: domTarget,
    enabled: enabled
  });
  if (actions.has('onDrag')) mergedConfig.drag = getInternalDragOptions(drag);
  if (actions.has('onWheel')) mergedConfig.wheel = getInternalCoordinatesOptions(wheel);
  if (actions.has('onScroll')) mergedConfig.scroll = getInternalCoordinatesOptions(scroll);
  if (actions.has('onMove')) mergedConfig.move = getInternalCoordinatesOptions(move);
  if (actions.has('onPinch')) mergedConfig.pinch = getInternalDistanceAngleOptions(pinch);
  if (actions.has('onHover')) mergedConfig.hover = react_use_gesture_esm_extends({
    enabled: true
  }, hover);
  return mergedConfig;
}

function getInitial(mixed) {
  return react_use_gesture_esm_extends({
    _active: false,
    _blocked: false,
    _intentional: [false, false],
    _movement: [0, 0],
    _initial: [0, 0],
    _bounds: [[-Infinity, Infinity], [-Infinity, Infinity]],
    _lastEventType: undefined,
    event: undefined,
    // currentTarget: undefined,
    // pointerId: undefined,
    intentional: false,
    values: [0, 0],
    velocities: [0, 0],
    delta: [0, 0],
    movement: [0, 0],
    offset: [0, 0],
    lastOffset: [0, 0],
    direction: [0, 0],
    initial: [0, 0],
    previous: [0, 0],
    first: false,
    last: false,
    active: false,
    timeStamp: 0,
    startTime: 0,
    elapsedTime: 0,
    cancel: react_use_gesture_esm_noop,
    canceled: false,
    memo: undefined,
    args: undefined
  }, mixed);
}

function getInitialState() {
  var shared = {
    hovering: false,
    scrolling: false,
    wheeling: false,
    dragging: false,
    moving: false,
    pinching: false,
    touches: 0,
    buttons: 0,
    down: false,
    shiftKey: false,
    altKey: false,
    metaKey: false,
    ctrlKey: false
  };
  var drag = getInitial({
    axis: undefined,
    xy: [0, 0],
    vxvy: [0, 0],
    velocity: 0,
    distance: 0,
    _isTap: true,
    _delayedEvent: false,
    _pointerId: undefined,
    tap: false,
    swipe: [0, 0]
  });
  var pinch = getInitial({
    da: [0, 0],
    vdva: [0, 0],
    // @ts-ignore origin can never be passed as undefined in userland
    origin: undefined,
    turns: 0
  });
  var wheel = getInitial({
    axis: undefined,
    xy: [0, 0],
    vxvy: [0, 0],
    velocity: 0,
    distance: 0
  });
  var move = getInitial({
    axis: undefined,
    xy: [0, 0],
    vxvy: [0, 0],
    velocity: 0,
    distance: 0
  });
  var scroll = getInitial({
    axis: undefined,
    xy: [0, 0],
    vxvy: [0, 0],
    velocity: 0,
    distance: 0
  });
  return {
    shared: shared,
    drag: drag,
    pinch: pinch,
    wheel: wheel,
    move: move,
    scroll: scroll
  };
}

var RecognizersMap = /*#__PURE__*/new Map();
/**
 * @private
 * Recognizer abstract class.
 */

var Recognizer = /*#__PURE__*/function () {
  /**
   * Creates an instance of a gesture recognizer.
   * @param stateKey drag, move, pinch, etc.
   * @param controller the controller attached to the gesture
   * @param [args] the args that should be passed to the gesture handler
   */
  function Recognizer(controller, args) {
    var _this = this;

    if (args === void 0) {
      args = [];
    }

    this.controller = controller;
    this.args = args;
    this.debounced = true; // Convenience method to set a timeout for a given gesture

    this.setTimeout = function (callback, ms) {
      var _window;

      if (ms === void 0) {
        ms = 140;
      }

      clearTimeout(_this.controller.timeouts[_this.stateKey]);

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      _this.controller.timeouts[_this.stateKey] = (_window = window).setTimeout.apply(_window, [callback, ms].concat(args));
    }; // Convenience method to clear a timeout for a given gesture


    this.clearTimeout = function () {
      clearTimeout(_this.controller.timeouts[_this.stateKey]);
    };
    /**
     * Fires the gesture handler
     */


    this.fireGestureHandler = function (forceFlag) {
      if (forceFlag === void 0) {
        forceFlag = false;
      }

      /**
       * If the gesture has been blocked (this can happen when the gesture has started in an unwanted direction),
       * clean everything and don't do anything.
       */
      if (_this.state._blocked) {
        // we need debounced gestures to end by themselves
        if (!_this.debounced) {
          _this.state._active = false;

          _this.clean();
        }

        return null;
      } // If the gesture has no intentional dimension, don't fire the handler.


      if (!forceFlag && !_this.state.intentional && !_this.config.triggerAllEvents) return null;

      if (_this.state.intentional) {
        var prev_active = _this.state.active;
        var next_active = _this.state._active;
        _this.state.active = next_active;
        _this.state.first = next_active && !prev_active;
        _this.state.last = prev_active && !next_active;
        _this.controller.state.shared[_this.ingKey] = next_active; // Sets dragging, pinching, etc. to the gesture active state
      }

      var state = react_use_gesture_esm_extends({}, _this.controller.state.shared, _this.state, _this.mapStateValues(_this.state)); // @ts-ignore


      var newMemo = _this.handler(state); // Sets memo to the returned value of the handler (unless it's not undefined)


      _this.state.memo = newMemo !== void 0 ? newMemo : _this.state.memo; // Cleans the gesture when the gesture is no longer active.

      if (!_this.state._active) _this.clean();
      return state;
    };
  } // Returns the gesture config


  var _proto = Recognizer.prototype;

  // Convenience method to update the shared state
  _proto.updateSharedState = function updateSharedState(sharedState) {
    Object.assign(this.controller.state.shared, sharedState);
  } // Convenience method to update the gesture state
  ;

  _proto.updateGestureState = function updateGestureState(gestureState) {
    Object.assign(this.state, gestureState);
  }
  /**
   * Returns state properties depending on the movement and state.
   *
   * Should be overriden for custom behavior, doesn't do anything in the implementation
   * below.
   */
  ;

  _proto.checkIntentionality = function checkIntentionality(_intentional, _movement) {
    return {
      _intentional: _intentional,
      _blocked: false
    };
  }
  /**
   * Returns basic movement properties for the gesture based on the next values and current state.
   */
  ;

  _proto.getMovement = function getMovement(values) {
    var _this$config = this.config,
        initial = _this$config.initial,
        bounds = _this$config.bounds,
        rubberband = _this$config.rubberband,
        T = _this$config.threshold;
    var _this$state = this.state,
        _bounds = _this$state._bounds,
        _initial = _this$state._initial,
        _active = _this$state._active,
        wasIntentional = _this$state._intentional,
        lastOffset = _this$state.lastOffset,
        prevMovement = _this$state.movement;
    var M = this.getInternalMovement(values, this.state);
    var i0 = wasIntentional[0] === false ? getIntentionalDisplacement(M[0], T[0]) : wasIntentional[0];
    var i1 = wasIntentional[1] === false ? getIntentionalDisplacement(M[1], T[1]) : wasIntentional[1]; // Get gesture specific state properties based on intentionality and movement.

    var intentionalityCheck = this.checkIntentionality([i0, i1], M);

    if (intentionalityCheck._blocked) {
      return react_use_gesture_esm_extends({}, intentionalityCheck, {
        _movement: M,
        delta: [0, 0]
      });
    }

    var _intentional = intentionalityCheck._intentional;
    var _movement = M;

    var __cachedBounds;

    var __cachedInitial;

    if (_intentional[0] !== false && wasIntentional[0] === false) {
      __cachedInitial = valueFn(initial, this.state);
      __cachedBounds = valueFn(bounds, this.state);
      _initial[0] = __cachedInitial[0];
      _bounds[0] = __cachedBounds[0];
    }

    if (_intentional[1] !== false && wasIntentional[1] === false) {
      var _cachedInitial, _cachedBounds;

      __cachedInitial = (_cachedInitial = __cachedInitial) != null ? _cachedInitial : valueFn(initial, this.state);
      __cachedBounds = (_cachedBounds = __cachedBounds) != null ? _cachedBounds : valueFn(bounds, this.state);
      _initial[1] = __cachedInitial[1];
      _bounds[1] = __cachedBounds[1];
    }
    /**
     * The movement sent to the handler has 0 in its dimensions when intentionality is false.
     * It is calculated from the actual movement minus the threshold.
     */


    var movement = [_intentional[0] !== false ? M[0] - _intentional[0] : _initial[0], _intentional[1] !== false ? M[1] - _intentional[1] : _initial[1]];
    var offset = addV(movement, lastOffset);
    /**
     * Rubberband should be 0 when the gesture is no longer active, so that movement
     * and offset can return within their bounds.
     */

    var _rubberband = _active ? rubberband : [0, 0];

    movement = computeRubberband(_bounds, addV(movement, _initial), _rubberband);
    return react_use_gesture_esm_extends({}, intentionalityCheck, {
      intentional: _intentional[0] !== false || _intentional[1] !== false,
      _initial: _initial,
      _movement: _movement,
      movement: movement,
      values: values,
      offset: computeRubberband(_bounds, offset, _rubberband),
      delta: subV(movement, prevMovement)
    });
  } // Cleans the gesture. Can be overriden by gestures.
  ;

  _proto.clean = function clean() {
    this.clearTimeout();
  };

  _createClass(Recognizer, [{
    key: "config",
    get: function get() {
      return this.controller.config[this.stateKey];
    } // Is the gesture enabled

  }, {
    key: "enabled",
    get: function get() {
      return this.controller.config.enabled && this.config.enabled;
    } // Returns the controller state for a given gesture

  }, {
    key: "state",
    get: function get() {
      return this.controller.state[this.stateKey];
    } // Returns the gesture handler

  }, {
    key: "handler",
    get: function get() {
      return this.controller.handlers[this.stateKey];
    }
  }]);

  return Recognizer;
}(); //--------------------------------------------

function getIntentionalDisplacement(movement, threshold) {
  if (Math.abs(movement) >= threshold) {
    return sign(movement) * threshold;
  } else {
    return false;
  }
}

function computeRubberband(bounds, _ref, _ref2) {
  var Vx = _ref[0],
      Vy = _ref[1];
  var Rx = _ref2[0],
      Ry = _ref2[1];
  var _bounds$ = bounds[0],
      X1 = _bounds$[0],
      X2 = _bounds$[1],
      _bounds$2 = bounds[1],
      Y1 = _bounds$2[0],
      Y2 = _bounds$2[1];
  return [rubberbandIfOutOfBounds(Vx, X1, X2, Rx), rubberbandIfOutOfBounds(Vy, Y1, Y2, Ry)];
}
/**
 * Returns a generic, common payload for all gestures from an event.
 */


function getGenericPayload(_ref3, event, isStartEvent) {
  var state = _ref3.state,
      args = _ref3.args;
  var timeStamp = event.timeStamp,
      _lastEventType = event.type;
  var previous = state.values;
  var elapsedTime = isStartEvent ? 0 : timeStamp - state.startTime;
  return {
    _lastEventType: _lastEventType,
    event: event,
    timeStamp: timeStamp,
    elapsedTime: elapsedTime,
    args: args,
    previous: previous
  };
}
/**
 * Returns the reinitialized start state for the gesture.
 * Should be common to all gestures.
 */

function getStartGestureState(recognizer, values, event) {
  var offset = recognizer.state.offset;
  var startTime = event.timeStamp;
  return react_use_gesture_esm_extends({}, getInitialState()[recognizer.stateKey], {
    _active: true,
    values: values,
    initial: values,
    offset: offset,
    lastOffset: offset,
    startTime: startTime
  });
}

function partial(func, state) {
  return function (event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    // @ts-ignore
    return func.call.apply(func, [this, react_use_gesture_esm_extends({}, state, {
      event: event
    })].concat(args));
  };
}
/**
 * The controller will keep track of the state for all gestures and also keep
 * track of timeouts, and window listeners.
 */


var react_use_gesture_esm_Controller = function Controller(classes) {
  var _this = this;

  this.classes = classes;

  this.bind = function () {
    var bindings = {};

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    for (var _iterator = _createForOfIteratorHelperLoose(_this.classes), _step; !(_step = _iterator()).done;) {
      var RecognizerClass = _step.value;
      new RecognizerClass(_this, args).addBindings(bindings);
    } // we also add event bindings for native handlers


    for (var _i = 0, _Object$entries = Object.entries(_this.nativeRefs); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _Object$entries[_i],
          event = _Object$entries$_i[0],
          handler = _Object$entries$_i[1];
      addBindings(bindings, event, partial(handler, react_use_gesture_esm_extends({}, _this.state.shared, {
        args: args
      })));
    }

    if (_this.config.domTarget) {
      // If config.domTarget is set we add event listeners to it and return the clean function.
      return updateDomListeners(_this, bindings);
    } else {
      // If not, we return an object that contains gesture handlers mapped to react handler event keys.
      return getPropsListener(_this, bindings);
    }
  };

  this.effect = function () {
    if (_this.config.domTarget) _this.bind();
    return _this.clean;
  };
  /**
   * Function ran on component unmount: cleans timeouts and removes dom listeners set by the bind function.
   */


  this.clean = function () {
    var domTarget = getDomTargetFromConfig(_this.config);
    var eventOptions = _this.config.eventOptions;
    if (domTarget) removeListeners(domTarget, takeAll(_this.domListeners), eventOptions);
    Object.values(_this.timeouts).forEach(clearTimeout);
    clearAllWindowListeners(_this);
  };

  this.state = getInitialState();
  this.timeouts = {};
  this.domListeners = [];
  this.windowListeners = {};
};
function clearAllWindowListeners(controller) {
  var _controller$config = controller.config,
      el = _controller$config.window,
      eventOptions = _controller$config.eventOptions,
      windowListeners = controller.windowListeners;
  if (!el) return;

  for (var stateKey in windowListeners) {
    var handlers = windowListeners[stateKey];
    removeListeners(el, handlers, eventOptions);
  }

  controller.windowListeners = {};
}
function clearWindowListeners(_ref, stateKey) {
  var config = _ref.config,
      windowListeners = _ref.windowListeners;
  if (!config.window) return;
  removeListeners(config.window, windowListeners[stateKey], config.eventOptions);
  delete windowListeners[stateKey];
}
function updateWindowListeners(_ref2, stateKey, listeners) {
  var config = _ref2.config,
      windowListeners = _ref2.windowListeners;

  if (listeners === void 0) {
    listeners = [];
  }

  if (!config.window) return;
  removeListeners(config.window, windowListeners[stateKey], config.eventOptions);
  addListeners(config.window, windowListeners[stateKey] = listeners, config.eventOptions);
}

function updateDomListeners(_ref3, bindings) {
  var config = _ref3.config,
      domListeners = _ref3.domListeners;
  var domTarget = getDomTargetFromConfig(config);
  if (!domTarget) throw new Error('domTarget must be defined');
  var eventOptions = config.eventOptions;
  removeListeners(domTarget, takeAll(domListeners), eventOptions);

  for (var _i2 = 0, _Object$entries2 = Object.entries(bindings); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _Object$entries2[_i2],
        key = _Object$entries2$_i[0],
        fns = _Object$entries2$_i[1];
    var name = key.slice(2).toLowerCase();
    domListeners.push([name, chainFns.apply(void 0, fns)]);
  }

  addListeners(domTarget, domListeners, eventOptions);
}

function getPropsListener(_ref4, bindings) {
  var config = _ref4.config;
  var props = {};
  var captureString = config.eventOptions.capture ? 'Capture' : '';

  for (var _i3 = 0, _Object$entries3 = Object.entries(bindings); _i3 < _Object$entries3.length; _i3++) {
    var _Object$entries3$_i = _Object$entries3[_i3],
        event = _Object$entries3$_i[0],
        fns = _Object$entries3$_i[1];
    var fnsArray = Array.isArray(fns) ? fns : [fns];
    var key = event + captureString;
    props[key] = chainFns.apply(void 0, fnsArray);
  }

  return props;
}

function takeAll(array) {
  if (array === void 0) {
    array = [];
  }

  return array.splice(0, array.length);
}

function getDomTargetFromConfig(_ref5) {
  var domTarget = _ref5.domTarget;
  return domTarget && 'current' in domTarget ? domTarget.current : domTarget;
}
/**
 * bindings is an object which keys match ReactEventHandlerKeys.
 * Since a recognizer might want to bind a handler function to an event key already used by a previously
 * added recognizer, we need to make sure that each event key is an array of all the functions mapped for
 * that key.
 */


function addBindings(bindings, name, fn) {
  if (!bindings[name]) bindings[name] = [];
  bindings[name].push(fn);
}

function addListeners(el, listeners, options) {
  if (listeners === void 0) {
    listeners = [];
  }

  if (options === void 0) {
    options = {};
  }

  for (var _iterator2 = _createForOfIteratorHelperLoose(listeners), _step2; !(_step2 = _iterator2()).done;) {
    var _step2$value = _step2.value,
        eventName = _step2$value[0],
        eventHandler = _step2$value[1];
    el.addEventListener(eventName, eventHandler, options);
  }
}

function removeListeners(el, listeners, options) {
  if (listeners === void 0) {
    listeners = [];
  }

  if (options === void 0) {
    options = {};
  }

  for (var _iterator3 = _createForOfIteratorHelperLoose(listeners), _step3; !(_step3 = _iterator3()).done;) {
    var _step3$value = _step3.value,
        eventName = _step3$value[0],
        eventHandler = _step3$value[1];
    el.removeEventListener(eventName, eventHandler, options);
  }
}

/* eslint-disable react-hooks/exhaustive-deps */
/**
 * Utility hook called by all gesture hooks and that will be responsible for the internals.
 *
 * @param handlers
 * @param classes
 * @param config
 * @param nativeHandlers - native handlers such as onClick, onMouseDown, etc.
 */

function useRecognizers(handlers, config, nativeHandlers) {
  if (nativeHandlers === void 0) {
    nativeHandlers = {};
  }

  var classes = resolveClasses(handlers);
  var controller = react.useMemo(function () {
    return new react_use_gesture_esm_Controller(classes);
  }, []);
  controller.config = config;
  controller.handlers = handlers;
  controller.nativeRefs = nativeHandlers;
  react.useEffect(controller.effect, []); // @ts-ignore

  if (controller.config.domTarget) return deprecationNoticeForDomTarget; // @ts-ignore

  return controller.bind;
}

function deprecationNoticeForDomTarget() {
  if (false) {}
}

function resolveClasses(internalHandlers) {
  var classes = new Set();
  if (internalHandlers.drag) classes.add(RecognizersMap.get('drag'));
  if (internalHandlers.wheel) classes.add(RecognizersMap.get('wheel'));
  if (internalHandlers.scroll) classes.add(RecognizersMap.get('scroll'));
  if (internalHandlers.move) classes.add(RecognizersMap.get('move'));
  if (internalHandlers.pinch) classes.add(RecognizersMap.get('pinch'));
  if (internalHandlers.hover) classes.add(RecognizersMap.get('hover'));
  return classes;
}

/**
 * @private
 * Abstract class for coordinates-based gesture recongizers
 */

var CoordinatesRecognizer = /*#__PURE__*/function (_Recognizer) {
  _inheritsLoose(CoordinatesRecognizer, _Recognizer);

  function CoordinatesRecognizer() {
    return _Recognizer.apply(this, arguments) || this;
  }

  var _proto = CoordinatesRecognizer.prototype;

  /**
   * Returns the real movement (without taking intentionality into acount)
   */
  _proto.getInternalMovement = function getInternalMovement(values, state) {
    return subV(values, state.initial);
  }
  /**
   * In coordinates-based gesture, this function will detect the first intentional axis,
   * lock the gesture axis if lockDirection is specified in the config, block the gesture
   * if the first intentional axis doesn't match the specified axis in config.
   */
  ;

  _proto.checkIntentionality = function checkIntentionality(_intentional, _movement) {
    if (_intentional[0] === false && _intentional[1] === false) {
      return {
        _intentional: _intentional,
        axis: this.state.axis
      };
    }

    var _movement$map = _movement.map(Math.abs),
        absX = _movement$map[0],
        absY = _movement$map[1];

    var axis = this.state.axis || (absX > absY ? 'x' : absX < absY ? 'y' : undefined);
    if (!this.config.axis && !this.config.lockDirection) return {
      _intentional: _intentional,
      _blocked: false,
      axis: axis
    };
    if (!axis) return {
      _intentional: [false, false],
      _blocked: false,
      axis: axis
    };
    if (!!this.config.axis && axis !== this.config.axis) return {
      _intentional: _intentional,
      _blocked: true,
      axis: axis
    };
    _intentional[axis === 'x' ? 1 : 0] = false;
    return {
      _intentional: _intentional,
      _blocked: false,
      axis: axis
    };
  };

  _proto.getKinematics = function getKinematics(values, event) {
    var state = this.getMovement(values);

    if (!state._blocked) {
      var dt = event.timeStamp - this.state.timeStamp;
      Object.assign(state, calculateAllKinematics(state.movement, state.delta, dt));
    }

    return state;
  };

  _proto.mapStateValues = function mapStateValues(state) {
    return {
      xy: state.values,
      vxvy: state.velocities
    };
  };

  return CoordinatesRecognizer;
}(Recognizer);

var WEBKIT_DISTANCE_SCALE_FACTOR = 260;
/**
 * Whether the browser supports GestureEvent (ie Safari)
 * @returns true if the browser supports gesture event
 */

function supportsGestureEvents() {
  try {
    // TODO [TS] possibly find GestureEvent definitions?
    // @ts-ignore: no type definitions for webkit GestureEvents
    return 'constructor' in GestureEvent;
  } catch (e) {
    return false;
  }
}
function supportsTouchEvents() {
  return typeof window !== 'undefined' && window.ontouchstart === null;
}

function getTouchEvents(event) {
  if ('touches' in event) {
    var targetTouches = event.targetTouches,
        changedTouches = event.changedTouches;
    return targetTouches.length > 0 ? targetTouches : changedTouches;
  }

  return null;
}

function getGenericEventData(event) {
  var buttons = 'buttons' in event ? event.buttons : 0;
  var touchEvents = getTouchEvents(event);
  var touches = touchEvents && touchEvents.length || 0;
  var down = touches > 0 || buttons > 0;
  var shiftKey = event.shiftKey,
      altKey = event.altKey,
      metaKey = event.metaKey,
      ctrlKey = event.ctrlKey; // TODO check if this might create some overrides?

  return {
    touches: touches,
    down: down,
    buttons: buttons,
    shiftKey: shiftKey,
    altKey: altKey,
    metaKey: metaKey,
    ctrlKey: ctrlKey
  };
}
/**
 * Gets pointer event values.
 * @param event
 * @returns pointer event values
 */

function getPointerEventValues(event) {
  var touchEvents = getTouchEvents(event);

  var _ref = touchEvents ? touchEvents[0] : event,
      clientX = _ref.clientX,
      clientY = _ref.clientY;

  return [clientX, clientY];
}
/**
 * Gets scroll event values
 * @param event
 * @returns scroll event values
 */

function getScrollEventValues(event) {
  // If the currentTarget is the window then we return the scrollX/Y position.
  // If not (ie the currentTarget is a DOM element), then we return scrollLeft/Top
  var _event$currentTarget = event.currentTarget,
      scrollX = _event$currentTarget.scrollX,
      scrollY = _event$currentTarget.scrollY,
      scrollLeft = _event$currentTarget.scrollLeft,
      scrollTop = _event$currentTarget.scrollTop;
  return [scrollX || scrollLeft || 0, scrollY || scrollTop || 0];
}
/**
 * Gets wheel event values.
 * @param event
 * @returns wheel event values
 */

function getWheelEventValues(event) {
  var deltaX = event.deltaX,
      deltaY = event.deltaY; //TODO implement polyfill ?
  // https://developer.mozilla.org/en-US/docs/Web/Events/wheel#Polyfill

  return [deltaX, deltaY];
}
/**
 * Gets webkit gesture event values.
 * @param event
 * @returns webkit gesture event values
 */

function getWebkitGestureEventValues(event) {
  return [event.scale * WEBKIT_DISTANCE_SCALE_FACTOR, event.rotation];
}
/**
 * Gets two touches event data
 * @param event
 * @returns two touches event data
 */

function getTwoTouchesEventData(event) {
  var _e$rotation;

  var targetTouches = event.targetTouches;
  var A = targetTouches[0],
      B = targetTouches[1];
  var dx = B.clientX - A.clientX;
  var dy = B.clientY - A.clientY;
  var cx = (B.clientX + A.clientX) / 2;
  var cy = (B.clientY + A.clientY) / 2;
  var e = 'nativeEvent' in event ? event.nativeEvent : event;
  var distance = Math.hypot(dx, dy);
  var angle = (_e$rotation = e.rotation) != null ? _e$rotation : -(Math.atan2(dx, dy) * 180) / Math.PI;
  var values = [distance, angle];
  var origin = [cx, cy];
  return {
    values: values,
    origin: origin
  };
}

var TAP_DISTANCE_THRESHOLD = 3;
var SWIPE_MAX_ELAPSED_TIME = 220;
var DragRecognizer = /*#__PURE__*/function (_CoordinatesRecognize) {
  _inheritsLoose(DragRecognizer, _CoordinatesRecognize);

  function DragRecognizer() {
    var _this;

    _this = _CoordinatesRecognize.apply(this, arguments) || this;
    _this.ingKey = 'dragging';
    _this.stateKey = 'drag';
    /**
     * TODO add back when setPointerCapture is widely wupported
     * https://caniuse.com/#search=setPointerCapture
     * private setPointers = (event: UseGestureEvent<PointerEvent>) => {
     *   const { currentTarget, pointerId } = event
     *   if (currentTarget) currentTarget.setPointerCapture(pointerId)
     *   this.updateGestureState({ currentTarget, pointerId })
     * }
            * private removePointers = () => {
     *   const { currentTarget, pointerId } = this.state
     *   if (currentTarget && pointerId) currentTarget.releasePointerCapture(pointerId)
     * }
     */

    _this.onDragStart = function (event) {
      if (!_this.enabled || _this.state._active) return;
      /**
       * TODO add back when setPointerCapture is widely supported
       * this.setPointers(event as PointerEvent)
       */

      updateWindowListeners(_this.controller, _this.stateKey, [['pointermove', _this.onDragChange], ['pointerup', _this.onDragEnd], ['pointercancel', _this.onDragEnd]]); // We set the state pointerId to the event.pointerId so we can make sure
      // that we lock the drag to the event initiating the gesture

      _this.updateGestureState({
        _pointerId: event.pointerId
      });

      if (_this.config.delay > 0) {
        _this.state._delayedEvent = true; // If it's a React SyntheticEvent we need to persist it so that we can use it async

        if ('persist' in event && typeof event.persist === 'function') event.persist();

        _this.setTimeout(_this.startDrag.bind(_assertThisInitialized(_this)), _this.config.delay, event);
      } else {
        _this.startDrag(event);
      }
    };

    _this.onDragChange = function (event) {
      // If the gesture was canceled don't respond to the event.
      if (_this.state.canceled) return; // If the event pointerId doesn't match the initiating pointerId
      // don't respond to the event.

      if (event.pointerId !== _this.state._pointerId) return; // If the gesture isn't active then respond to the event only if
      // it's been delayed via the `delay` option, in which case start
      // the gesture immediately.

      if (!_this.state._active) {
        if (_this.state._delayedEvent) {
          _this.clearTimeout();

          _this.startDrag(event);
        }

        return;
      }

      var genericEventData = getGenericEventData(event); // If the event doesn't have any button / touches left we should cancel
      // the gesture. This may happen if the drag release happens outside the browser
      // window.

      if (!genericEventData.down) {
        _this.onDragEnd(event);

        return;
      }

      _this.updateSharedState(genericEventData);

      var values = getPointerEventValues(event);

      var kinematics = _this.getKinematics(values, event);

      var genericPayload = getGenericPayload(_assertThisInitialized(_this), event); // This verifies if the drag can be assimilated to a tap by checking
      // if the real distance of the drag (ie not accounting for the threshold) is
      // greater than the TAP_DISTANCE_THRESHOLD.

      var _isTap = _this.state._isTap;
      var realDistance = calculateDistance(kinematics._movement);
      if (_isTap && realDistance >= TAP_DISTANCE_THRESHOLD) _isTap = false;

      _this.updateGestureState(react_use_gesture_esm_extends({}, genericPayload, kinematics, {
        _isTap: _isTap
      }));

      _this.fireGestureHandler();
    };

    _this.onDragEnd = function (event) {
      // If the event pointerId doesn't match the initiating pointerId
      // don't respond to the event.
      if (event.pointerId !== _this.state._pointerId) return;
      _this.state._active = false;

      _this.updateSharedState({
        down: false,
        buttons: 0,
        touches: 0
      });

      var tap = _this.state._isTap;
      var _this$state$velocitie = _this.state.velocities,
          vx = _this$state$velocitie[0],
          vy = _this$state$velocitie[1];
      var _this$state$movement = _this.state.movement,
          mx = _this$state$movement[0],
          my = _this$state$movement[1];
      var _this$state$_intentio = _this.state._intentional,
          ix = _this$state$_intentio[0],
          iy = _this$state$_intentio[1];
      var _this$config$swipeVel = _this.config.swipeVelocity,
          svx = _this$config$swipeVel[0],
          svy = _this$config$swipeVel[1];
      var _this$config$swipeDis = _this.config.swipeDistance,
          sx = _this$config$swipeDis[0],
          sy = _this$config$swipeDis[1];

      var endState = react_use_gesture_esm_extends({}, getGenericPayload(_assertThisInitialized(_this), event), _this.getMovement(_this.state.values));

      var swipe = [0, 0];

      if (endState.elapsedTime < SWIPE_MAX_ELAPSED_TIME) {
        if (ix !== false && Math.abs(vx) > svx && Math.abs(mx) > sx) swipe[0] = sign(vx);
        if (iy !== false && Math.abs(vy) > svy && Math.abs(my) > sy) swipe[1] = sign(vy);
      }

      _this.updateGestureState(react_use_gesture_esm_extends({}, endState, {
        tap: tap,
        swipe: swipe
      }));

      _this.fireGestureHandler(tap === true);
    };

    _this.clean = function () {
      _CoordinatesRecognize.prototype.clean.call(_assertThisInitialized(_this));

      _this.state._delayedEvent = false; // can't remember if this is useful?

      clearWindowListeners(_this.controller, _this.stateKey); // TODO add back when setPointerCapture is widely wupported
      // this.removePointers()
    };

    _this.onCancel = function () {
      if (_this.state.canceled) return;

      _this.updateGestureState({
        canceled: true
      });

      _this.state._active = false;

      _this.updateSharedState({
        down: false,
        buttons: 0,
        touches: 0
      });

      requestAnimationFrame(function () {
        return _this.fireGestureHandler();
      });
    };

    _this.onClick = function (event) {
      if (!_this.state._isTap) event.stopPropagation();
    };

    return _this;
  }

  var _proto = DragRecognizer.prototype;

  _proto.startDrag = function startDrag(event) {
    var values = getPointerEventValues(event);
    this.updateSharedState(getGenericEventData(event));
    this.updateGestureState(react_use_gesture_esm_extends({}, getStartGestureState(this, values, event), getGenericPayload(this, event, true), {
      _pointerId: event.pointerId,
      cancel: this.onCancel
    }));
    this.updateGestureState(this.getMovement(values));
    this.fireGestureHandler();
  };

  _proto.addBindings = function addBindings$1(bindings) {
    addBindings(bindings, 'onPointerDown', this.onDragStart);

    if (this.config.filterTaps) {
      var handler = this.controller.config.eventOptions.capture ? 'onClick' : 'onClickCapture';

      addBindings(bindings, handler, this.onClick);
    } // TODO add back when setPointerCapture is widely wupported
    // addBindings(bindings, 'onPointerMove', this.onDragChange)
    // addBindings(bindings, 'onPointerUp', this.onDragEnd)
    // addBindings(bindings, 'onPointerCancel', this.onDragEnd)

  };

  return DragRecognizer;
}(CoordinatesRecognizer);

/**
 * Inlined from https://github.com/alexreardon/memoize-one
 */
function memoizeOne(resultFn, isEqual) {
  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  function memoized() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }

  return memoized;
}

/**
 * Taken from https://github.com/FormidableLabs/react-fast-compare
 *
 * Dropped comments and ArrayBuffer handling
 */
function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;

    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    var it;

    if (typeof Map === 'function' && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      it = a.entries();

      while (!(i = it.next()).done) {
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      }

      return true;
    }

    if (typeof Set === 'function' && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    }

    if (typeof Element !== 'undefined' && a instanceof Element) return false;

    for (i = length; i-- !== 0;) {
      if (keys[i] === '_owner' && a.$$typeof) continue;
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }

    return true;
  } // true if both NaN, false otherwise — NaN !== NaN → true
  // eslint-disable-next-line no-self-compare


  return a !== a && b !== b;
}

function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }

    throw error;
  }
}

/**
 * Drag hook.
 *
 * @param handler - the function fired every time the drag gesture updates
 * @param [config={}] - the config object including generic options and drag options
 */

function useDrag(handler, config) {
  if (config === void 0) {
    config = {};
  }

  RecognizersMap.set('drag', DragRecognizer);
  var buildDragConfig = (0,react.useRef)();

  if (!buildDragConfig.current) {
    buildDragConfig.current = memoizeOne(_buildDragConfig, isEqual);
  }

  return useRecognizers({
    drag: handler
  }, buildDragConfig.current(config));
}

/**
 * @private
 * Abstract class for distance/angle-based gesture recongizers
 */

var DistanceAngleRecognizer = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Recognizer) {
  _inheritsLoose(DistanceAngleRecognizer, _Recognizer);

  function DistanceAngleRecognizer() {
    return _Recognizer.apply(this, arguments) || this;
  }

  var _proto = DistanceAngleRecognizer.prototype;

  _proto.getInternalMovement = function getInternalMovement(values, state) {
    var prev_a = state.values[1]; // not be defined if ctrl+wheel is used for zoom only

    var d = values[0],
        _values$ = values[1],
        a = _values$ === void 0 ? prev_a : _values$;
    var delta_a = a - prev_a;
    var next_turns = state.turns;
    if (Math.abs(delta_a) > 270) next_turns += sign(delta_a);
    return subV([d, a - 360 * next_turns], state.initial);
  };

  _proto.getKinematics = function getKinematics(values, event) {
    var state = this.getMovement(values);
    var turns = (values[1] - state.movement[1] - this.state.initial[1]) / 360;
    var dt = event.timeStamp - this.state.timeStamp;
    var kinematics = calculateAllKinematics(state.movement, state.delta, dt);
    return react_use_gesture_esm_extends({
      turns: turns
    }, state, kinematics);
  };

  _proto.mapStateValues = function mapStateValues(state) {
    return {
      da: state.values,
      vdva: state.velocities
    };
  };

  return DistanceAngleRecognizer;
}(Recognizer)));

var PinchRecognizer = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_DistanceAngleRecogni) {
  _inheritsLoose(PinchRecognizer, _DistanceAngleRecogni);

  function PinchRecognizer() {
    var _this;

    _this = _DistanceAngleRecogni.apply(this, arguments) || this;
    _this.ingKey = 'pinching';
    _this.stateKey = 'pinch';

    _this.pinchShouldStart = function (event) {
      var _getGenericEventData = getGenericEventData(event),
          touches = _getGenericEventData.touches;

      return _this.enabled && touches === 2;
    };

    _this.onPinchStart = function (event) {
      if (!_this.pinchShouldStart(event)) return;

      var _getTwoTouchesEventDa = getTwoTouchesEventData(event),
          values = _getTwoTouchesEventDa.values,
          origin = _getTwoTouchesEventDa.origin;

      _this.updateSharedState(getGenericEventData(event));

      _this.updateGestureState(react_use_gesture_esm_extends({}, getStartGestureState(_assertThisInitialized(_this), values, event), getGenericPayload(_assertThisInitialized(_this), event, true), {
        cancel: _this.onCancel,
        origin: origin
      }));

      _this.updateGestureState(_this.getMovement(values));

      _this.fireGestureHandler();
    };

    _this.onPinchChange = function (event) {
      var _this$state = _this.state,
          canceled = _this$state.canceled,
          _active = _this$state._active;
      if (canceled || !_active) return;
      var genericEventData = getGenericEventData(event);

      _this.updateSharedState(genericEventData);

      var _getTwoTouchesEventDa2 = getTwoTouchesEventData(event),
          values = _getTwoTouchesEventDa2.values,
          origin = _getTwoTouchesEventDa2.origin; // @ts-ignore


      var kinematics = _this.getKinematics(values, event);

      _this.updateGestureState(react_use_gesture_esm_extends({}, getGenericPayload(_assertThisInitialized(_this), event), kinematics, {
        origin: origin
      }));

      _this.fireGestureHandler();
    };

    _this.onPinchEnd = function (event) {
      if (!_this.state.active) return;
      _this.state._active = false;

      _this.updateSharedState({
        down: false,
        touches: 0
      });

      _this.updateGestureState(react_use_gesture_esm_extends({}, getGenericPayload(_assertThisInitialized(_this), event), _this.getMovement(_this.state.values)));

      _this.fireGestureHandler();
    };

    _this.onCancel = function () {
      if (_this.state.canceled) return;
      _this.state._active = false;

      _this.updateGestureState({
        canceled: true
      });

      _this.updateSharedState({
        down: false,
        touches: 0
      });

      requestAnimationFrame(function () {
        return _this.fireGestureHandler();
      });
    };
    /**
     * PINCH WITH WEBKIT GESTURES
     */


    _this.onGestureStart = function (event) {
      if (!_this.enabled) return;
      event.preventDefault(); // useless

      var values = getWebkitGestureEventValues(event);

      _this.updateSharedState(getGenericEventData(event));

      _this.updateGestureState(react_use_gesture_esm_extends({}, getStartGestureState(_assertThisInitialized(_this), values, event), getGenericPayload(_assertThisInitialized(_this), event, true), {
        origin: [event.clientX, event.clientY],
        cancel: _this.onCancel
      }));

      _this.updateGestureState(_this.getMovement(values));

      _this.fireGestureHandler();
    };

    _this.onGestureChange = function (event) {
      var _this$state2 = _this.state,
          canceled = _this$state2.canceled,
          _active = _this$state2._active;
      if (canceled || !_active) return;
      event.preventDefault();
      var genericEventData = getGenericEventData(event);

      _this.updateSharedState(genericEventData);

      var values = getWebkitGestureEventValues(event);

      var kinematics = _this.getKinematics(values, event);

      _this.updateGestureState(react_use_gesture_esm_extends({}, getGenericPayload(_assertThisInitialized(_this), event), kinematics, {
        origin: [event.clientX, event.clientY]
      }));

      _this.fireGestureHandler();
    };

    _this.onGestureEnd = function (event) {
      event.preventDefault();
      if (!_this.state.active) return;
      _this.state._active = false;

      _this.updateSharedState({
        down: false,
        touches: 0
      });

      _this.updateGestureState(react_use_gesture_esm_extends({}, getGenericPayload(_assertThisInitialized(_this), event), _this.getMovement(_this.state.values), {
        origin: [event.clientX, event.clientY]
      }));

      _this.fireGestureHandler();
    };
    /**
     * PINCH WITH WHEEL
     */


    _this.wheelShouldRun = function (event) {
      return _this.enabled && event.ctrlKey;
    };

    _this.getWheelValuesFromEvent = function (event) {
      var _getWheelEventValues = getWheelEventValues(event),
          delta_d = _getWheelEventValues[1];

      var _this$state$values = _this.state.values,
          prev_d = _this$state$values[0],
          prev_a = _this$state$values[1];
      var d = prev_d - delta_d;
      var a = prev_a !== void 0 ? prev_a : 0;
      return {
        values: [d, a],
        origin: [event.clientX, event.clientY],
        delta: [0, delta_d]
      };
    };

    _this.onWheel = function (event) {
      if (!_this.wheelShouldRun(event)) return;

      _this.setTimeout(_this.onWheelEnd);

      if (!_this.state._active) _this.onWheelStart(event);else _this.onWheelChange(event);
    };

    _this.onWheelStart = function (event) {
      var _this$getWheelValuesF = _this.getWheelValuesFromEvent(event),
          values = _this$getWheelValuesF.values,
          delta = _this$getWheelValuesF.delta,
          origin = _this$getWheelValuesF.origin;

      if (event.cancelable) event.preventDefault();else if (false) {}

      _this.updateSharedState(getGenericEventData(event));

      _this.updateGestureState(react_use_gesture_esm_extends({}, getStartGestureState(_assertThisInitialized(_this), values, event), getGenericPayload(_assertThisInitialized(_this), event, true), {
        initial: _this.state.values,
        offset: values,
        delta: delta,
        origin: origin
      }));

      _this.updateGestureState(_this.getMovement(values));

      _this.fireGestureHandler();
    };

    _this.onWheelChange = function (event) {
      _this.updateSharedState(getGenericEventData(event));

      var _this$getWheelValuesF2 = _this.getWheelValuesFromEvent(event),
          values = _this$getWheelValuesF2.values,
          origin = _this$getWheelValuesF2.origin,
          delta = _this$getWheelValuesF2.delta;

      _this.updateGestureState(react_use_gesture_esm_extends({}, getGenericPayload(_assertThisInitialized(_this), event), _this.getKinematics(values, event), {
        origin: origin,
        delta: delta
      }));

      _this.fireGestureHandler();
    };

    _this.onWheelEnd = function () {
      _this.state._active = false;

      _this.updateGestureState(_this.getMovement(_this.state.values));

      _this.fireGestureHandler();
    };

    return _this;
  }

  var _proto = PinchRecognizer.prototype;

  _proto.addBindings = function addBindings$1(bindings) {
    // Only try to use gesture events when they are supported and domTarget is set
    // as React doesn't support gesture handlers.
    if (this.controller.config.domTarget && !supportsTouchEvents() && supportsGestureEvents()) {
      addBindings(bindings, 'onGestureStart', this.onGestureStart);

      addBindings(bindings, 'onGestureChange', this.onGestureChange);

      addBindings(bindings, 'onGestureEnd', this.onGestureEnd);
    } else {
      addBindings(bindings, 'onTouchStart', this.onPinchStart);

      addBindings(bindings, 'onTouchMove', this.onPinchChange);

      addBindings(bindings, 'onTouchEnd', this.onPinchEnd);

      addBindings(bindings, 'onTouchCancel', this.onPinchEnd);

      addBindings(bindings, 'onWheel', this.onWheel);
    }
  };

  return PinchRecognizer;
}(DistanceAngleRecognizer)));

/**
 * Pinch hook.
 *
 * @param handler - the function fired every time the pinch gesture updates
 * @param [config={}] - the config object including generic options and pinch options
 */

function usePinch(handler, config) {
  if (config === void 0) {
    config = {};
  }

  RecognizersMap.set('pinch', PinchRecognizer);
  var buildPinchConfig = useRef();

  if (!buildPinchConfig.current) {
    buildPinchConfig.current = memoizeOne(_buildPinchConfig, isEqual);
  }

  return useRecognizers({
    pinch: handler
  }, buildPinchConfig.current(config));
}

var WheelRecognizer = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_CoordinatesRecognize) {
  _inheritsLoose(WheelRecognizer, _CoordinatesRecognize);

  function WheelRecognizer() {
    var _this;

    _this = _CoordinatesRecognize.apply(this, arguments) || this;
    _this.ingKey = 'wheeling';
    _this.stateKey = 'wheel';
    _this.debounced = true;

    _this.handleEvent = function (event) {
      if (event.ctrlKey && 'pinch' in _this.controller.handlers) return;
      if (!_this.enabled) return;

      _this.setTimeout(_this.onEnd);

      _this.updateSharedState(getGenericEventData(event));

      var values = addV(getWheelEventValues(event), _this.state.values);

      if (!_this.state._active) {
        _this.updateGestureState(react_use_gesture_esm_extends({}, getStartGestureState(_assertThisInitialized(_this), values, event), getGenericPayload(_assertThisInitialized(_this), event, true), {
          initial: _this.state.values
        }));

        var movement = _this.getMovement(values);

        var geometry = calculateAllGeometry(movement.delta);

        _this.updateGestureState(movement);

        _this.updateGestureState(geometry);
      } else {
        _this.updateGestureState(react_use_gesture_esm_extends({}, getGenericPayload(_assertThisInitialized(_this), event), _this.getKinematics(values, event)));
      }

      _this.fireGestureHandler();
    };

    _this.onEnd = function () {
      var movement = _this.getMovement(_this.state.values);

      _this.updateGestureState(movement);

      _this.updateGestureState({
        _active: false,
        velocities: [0, 0],
        velocity: 0
      });

      _this.fireGestureHandler();
    };

    return _this;
  }

  var _proto = WheelRecognizer.prototype;

  _proto.addBindings = function addBindings$1(bindings) {
    addBindings(bindings, 'onWheel', this.handleEvent);
  };

  return WheelRecognizer;
}(CoordinatesRecognizer)));

/**
 * Wheel hook.
 *
 * @param handler - the function fired every time the wheel gesture updates
 * @param the config object including generic options and wheel options
 */

function useWheel(handler, config) {
  if (config === void 0) {
    config = {};
  }

  RecognizersMap.set('wheel', WheelRecognizer);
  var buildWheelConfig = useRef();

  if (!buildWheelConfig.current) {
    buildWheelConfig.current = memoizeOne(_buildWheelConfig, isEqual);
  }

  return useRecognizers({
    wheel: handler
  }, buildWheelConfig.current(config));
}

var MoveRecognizer = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_CoordinatesRecognize) {
  _inheritsLoose(MoveRecognizer, _CoordinatesRecognize);

  function MoveRecognizer() {
    var _this;

    _this = _CoordinatesRecognize.apply(this, arguments) || this;
    _this.ingKey = 'moving';
    _this.stateKey = 'move';
    _this.debounced = true;

    _this.onMove = function (event) {
      if (!_this.enabled) return;

      _this.setTimeout(_this.onMoveEnd);

      if (!_this.state._active) _this.onMoveStart(event);else _this.onMoveChange(event);
    };

    _this.onMoveStart = function (event) {
      _this.updateSharedState(getGenericEventData(event));

      var values = getPointerEventValues(event);

      _this.updateGestureState(react_use_gesture_esm_extends({}, getStartGestureState(_assertThisInitialized(_this), values, event), getGenericPayload(_assertThisInitialized(_this), event, true)));

      _this.updateGestureState(_this.getMovement(values));

      _this.fireGestureHandler();
    };

    _this.onMoveChange = function (event) {
      _this.updateSharedState(getGenericEventData(event));

      var values = getPointerEventValues(event);

      _this.updateGestureState(react_use_gesture_esm_extends({}, getGenericPayload(_assertThisInitialized(_this), event), _this.getKinematics(values, event)));

      _this.fireGestureHandler();
    };

    _this.onMoveEnd = function () {
      var values = _this.state.values;

      _this.updateGestureState(_this.getMovement(values));

      _this.updateGestureState({
        velocities: [0, 0],
        velocity: 0,
        _active: false
      });

      _this.fireGestureHandler();
    };

    _this.onPointerEnter = function (event) {
      _this.controller.state.shared.hovering = true;
      if (!_this.controller.config.enabled) return;

      if (_this.controller.config.hover.enabled) {
        var values = getPointerEventValues(event);

        var state = react_use_gesture_esm_extends({}, _this.controller.state.shared, _this.state, getGenericPayload(_assertThisInitialized(_this), event, true), {
          values: values,
          active: true,
          hovering: true
        });

        _this.controller.handlers.hover(react_use_gesture_esm_extends({}, state, _this.mapStateValues(state)));
      }

      if ('move' in _this.controller.handlers) _this.onMoveStart(event);
    };

    _this.onPointerLeave = function (event) {
      _this.controller.state.shared.hovering = false;
      if ('move' in _this.controller.handlers) _this.onMoveEnd();
      if (!_this.controller.config.hover.enabled) return;
      var values = getPointerEventValues(event);

      var state = react_use_gesture_esm_extends({}, _this.controller.state.shared, _this.state, getGenericPayload(_assertThisInitialized(_this), event), {
        values: values,
        active: false
      });

      _this.controller.handlers.hover(react_use_gesture_esm_extends({}, state, _this.mapStateValues(state)));
    };

    return _this;
  }

  var _proto = MoveRecognizer.prototype;

  _proto.addBindings = function addBindings$1(bindings) {
    if ('move' in this.controller.handlers) {
      addBindings(bindings, 'onPointerMove', this.onMove);
    }

    if ('hover' in this.controller.handlers) {
      addBindings(bindings, 'onPointerEnter', this.onPointerEnter);

      addBindings(bindings, 'onPointerLeave', this.onPointerLeave);
    }
  };

  return MoveRecognizer;
}(CoordinatesRecognizer)));

/**
 * Move hook.
 *
 * @param handler - the function fired every time the move gesture updates
 * @param [config={}] - the config object including generic options and move options
 */

function useMove(handler, config) {
  if (config === void 0) {
    config = {};
  }

  RecognizersMap.set('move', MoveRecognizer);
  var buildMoveConfig = useRef();

  if (!buildMoveConfig.current) {
    buildMoveConfig.current = memoizeOne(_buildMoveConfig, isEqual);
  }

  return useRecognizers({
    move: handler
  }, buildMoveConfig.current(config));
}

/**
 * Hover hook.
 *
 * @param handler - the function fired every time the hover gesture updates
 * @param [config={}] - the config object including generic options and hover options
 */

function useHover(handler, config) {
  if (config === void 0) {
    config = {};
  }

  RecognizersMap.set('hover', MoveRecognizer);
  var buildHoverConfig = useRef();

  if (!buildHoverConfig.current) {
    buildHoverConfig.current = memoizeOne(_buildHoverConfig, isEqual);
  }

  return useRecognizers({
    hover: handler
  }, buildHoverConfig.current(config));
}

var ScrollRecognizer = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_CoordinatesRecognize) {
  _inheritsLoose(ScrollRecognizer, _CoordinatesRecognize);

  function ScrollRecognizer() {
    var _this;

    _this = _CoordinatesRecognize.apply(this, arguments) || this;
    _this.ingKey = 'scrolling';
    _this.stateKey = 'scroll';
    _this.debounced = true;

    _this.handleEvent = function (event) {
      if (!_this.enabled) return;

      _this.clearTimeout();

      _this.setTimeout(_this.onEnd);

      var values = getScrollEventValues(event);

      _this.updateSharedState(getGenericEventData(event));

      if (!_this.state._active) {
        _this.updateGestureState(react_use_gesture_esm_extends({}, getStartGestureState(_assertThisInitialized(_this), values, event), getGenericPayload(_assertThisInitialized(_this), event, true), {
          initial: _this.state.values
        }));

        var movementDetection = _this.getMovement(values);

        var geometry = calculateAllGeometry(movementDetection.delta);

        _this.updateGestureState(movementDetection);

        _this.updateGestureState(geometry);
      } else {
        _this.updateGestureState(react_use_gesture_esm_extends({}, getGenericPayload(_assertThisInitialized(_this), event), _this.getKinematics(values, event)));
      }

      _this.fireGestureHandler();
    };

    _this.onEnd = function () {
      _this.state._active = false;

      _this.updateGestureState(react_use_gesture_esm_extends({}, _this.getMovement(_this.state.values), {
        velocities: [0, 0],
        velocity: 0
      }));

      _this.fireGestureHandler();
    };

    return _this;
  }

  var _proto = ScrollRecognizer.prototype;

  _proto.addBindings = function addBindings$1(bindings) {
    addBindings(bindings, 'onScroll', this.handleEvent);
  };

  return ScrollRecognizer;
}(CoordinatesRecognizer)));

/**
 * Scroll hook.
 *
 * @param handler - the function fired every time the scroll gesture updates
 * @param [config={}] - the config object including generic options and scroll options
 */

function useScroll(handler, config) {
  if (config === void 0) {
    config = {};
  }

  RecognizersMap.set('scroll', ScrollRecognizer);
  var buildScrollConfig = useRef();

  if (!buildScrollConfig.current) {
    buildScrollConfig.current = memoizeOne(_buildScrollConfig, isEqual);
  }

  return useRecognizers({
    scroll: handler
  }, buildScrollConfig.current(config));
}

var RE_NOT_NATIVE = /^on(Drag|Wheel|Scroll|Move|Pinch|Hover)/;

function sortHandlers(handlers) {
  var _native = {};
  var handle = {};
  var actions = new Set();

  for (var key in handlers) {
    if (RE_NOT_NATIVE.test(key)) {
      actions.add(RegExp.lastMatch);
      handle[key] = handlers[key];
    } else {
      _native[key] = handlers[key];
    }
  }

  return [handle, _native, actions];
}
/**
 * @public
 *
 * The most complete gesture hook, allowing support for multiple gestures.
 *
 * @param {Handlers} handlers - an object with on[Gesture] keys containg gesture handlers
 * @param {UseGestureConfig} [config={}] - the full config object
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */


function useGesture(_handlers, config) {
  if (config === void 0) {
    config = {};
  }

  var _sortHandlers = sortHandlers(_handlers),
      handlers = _sortHandlers[0],
      nativeHandlers = _sortHandlers[1],
      actions = _sortHandlers[2];

  RecognizersMap.set('drag', DragRecognizer);
  RecognizersMap.set('hover', MoveRecognizer);
  RecognizersMap.set('move', MoveRecognizer);
  RecognizersMap.set('pinch', PinchRecognizer);
  RecognizersMap.set('scroll', ScrollRecognizer);
  RecognizersMap.set('wheel', WheelRecognizer);
  var mergedConfig = buildComplexConfig(config, actions);
  var internalHandlers = {};
  if (actions.has('onDrag')) internalHandlers.drag = includeStartEndHandlers(handlers, 'onDrag');
  if (actions.has('onWheel')) internalHandlers.wheel = includeStartEndHandlers(handlers, 'onWheel');
  if (actions.has('onScroll')) internalHandlers.scroll = includeStartEndHandlers(handlers, 'onScroll');
  if (actions.has('onMove')) internalHandlers.move = includeStartEndHandlers(handlers, 'onMove');
  if (actions.has('onPinch')) internalHandlers.pinch = includeStartEndHandlers(handlers, 'onPinch');
  if (actions.has('onHover')) internalHandlers.hover = handlers.onHover;
  return useRecognizers(internalHandlers, mergedConfig, nativeHandlers);
}

function includeStartEndHandlers(handlers, handlerKey) {
  var startKey = handlerKey + 'Start';
  var endKey = handlerKey + 'End';

  var fn = function fn(state) {
    var memo = undefined;
    if (state.first && startKey in handlers) handlers[startKey](state);
    if (handlerKey in handlers) memo = handlers[handlerKey](state);
    if (state.last && endKey in handlers) handlers[endKey](state);
    return memo;
  };

  return fn;
}


//# sourceMappingURL=react-use-gesture.esm.js.map

;// CONCATENATED MODULE: ../../node_modules/tabbable/dist/index.esm.js
/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]:not(slot)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  return element.getRootNode();
} : function (element) {
  return element.ownerDocument;
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */

var getCandidates = function getCandidates(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }

  candidates = candidates.filter(filter);
  return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidatesScope
 * @property {Element} scope contains inner candidates
 * @property {Element[]} candidates
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidatesScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidatesScope>}
 */


var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);

  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();

    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);

      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scope: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);

      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      } // iterate over shadow content if possible


      var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
      var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);

      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);

        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scope: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }

  return candidates;
};

var getTabindex = function getTabindex(node, isScope) {
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    //
    // isScope is positive for custom element with shadow root or slot that by default
    // have tabIndex -1, but need to be sorted by document order in order for their
    // content to be inserted in the correct position
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute('tabindex'), 10))) {
      return 0;
    }
  }

  return node.tabIndex;
};

var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};

var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};

var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};

var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};

var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};

var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }

  var radioScope = node.form || getRootNode(node);

  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };

  var radioSet;

  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }

  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};

var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};

var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
      width = _node$getBoundingClie.width,
      height = _node$getBoundingClie.height;

  return width === 0 && height === 0;
};

var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
      getShadowRoot = _ref.getShadowRoot;

  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }

  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  } // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.


  var nodeRootHost = getRootNode(node).host;
  var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);

  if (!displayCheck || displayCheck === 'full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;

      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);

        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }

      node = originalNode;
    } // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled
    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.


    if (nodeIsAttached) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    } // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.

  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  } // visible, as far as we can tell, or per current `displayCheck` mode


  return false;
}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset


var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement; // check if `node` is contained in a disabled <fieldset>

    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i); // when the first <legend> (in document order) is found

          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        } // the disabled <fieldset> containing `node` has no <legend>


        return true;
      }

      parentNode = parentNode.parentElement;
    }
  } // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state


  return false;
};

var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }

  return true;
};

var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }

  return true;
};

var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);

  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  } // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.


  return false;
};
/**
 * @param {Array.<Element|CandidatesScope>} candidates
 * @returns Element[]
 */


var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scope;
    var element = isScope ? item.scope : item;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;

    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};

var tabbable = function tabbable(el, options) {
  options = options || {};
  var candidates;

  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }

  return sortByOrder(candidates);
};

var focusable = function focusable(el, options) {
  options = options || {};
  var candidates;

  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }

  return candidates;
};

var isTabbable = function isTabbable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, candidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorTabbable(options, node);
};

var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

var isFocusable = function isFocusable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorFocusable(options, node);
};


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ../../node_modules/focus-trap/dist/focus-trap.esm.js
/*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var activeFocusTraps = function () {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];

        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();

var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};

var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};

var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};

var delay = function delay(fn) {
  return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs


var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });
  return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */


var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return typeof value === 'function' ? value.apply(void 0, params) : value;
};

var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};

var createFocusTrap = function createFocusTrap(elements, userOptions) {
  // SSR: a live trap shouldn't be created in this type of environment so this
  //  should be safe code to execute if the `document` option isn't specified
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;

  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);

  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */

  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };
  /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */


  var findContainerIndex = function findContainerIndex(element) {
    // NOTE: search `containerGroups` because it's possible a group contains no tabbable
    //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
    //  and we still need to find the element in there
    return state.containerGroups.findIndex(function (_ref) {
      var container = _ref.container,
          tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      tabbableNodes.find(function (node) {
        return node === element;
      });
    });
  };
  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */


  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];

    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      optionValue = optionValue.apply(void 0, params);
    }

    if (optionValue === true) {
      optionValue = undefined; // use default value
    }

    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      } // else, empty string (invalid), null (invalid), 0 (invalid)


      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }

    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails

      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }

    return node;
  };

  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus'); // false explicitly indicates we want no initialFocus at all

    if (node === false) {
      return false;
    }

    if (node === undefined) {
      // option not specified: use fallback options
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)

        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }

    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }

    return node;
  };

  var updateTabbableNodes = function updateTabbableNodes() {
    state.containerGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions); // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
      //  are a superset of tabbable nodes

      var focusableNodes = focusable(container, config.tabbableOptions);
      return {
        container: container,
        tabbableNodes: tabbableNodes,
        focusableNodes: focusableNodes,
        firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
        lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,

        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          // NOTE: If tabindex is positive (in order to manipulate the tab order separate
          //  from the DOM order), this __will not work__ because the list of focusableNodes,
          //  while it contains tabbable nodes, does not sort its nodes in any order other
          //  than DOM order, because it can't: Where would you place focusable (but not
          //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
          // Support for positive tabindex is already broken and hard to manage (possibly
          //  not supportable, TBD), so this isn't going to make things worse than they
          //  already are, and at least makes things better for the majority of cases where
          //  tabindex is either 0/unset or negative.
          // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
          var nodeIdx = focusableNodes.findIndex(function (n) {
            return n === node;
          });

          if (nodeIdx < 0) {
            return undefined;
          }

          if (forward) {
            return focusableNodes.slice(nodeIdx + 1).find(function (n) {
              return isTabbable(n, config.tabbableOptions);
            });
          }

          return focusableNodes.slice(0, nodeIdx).reverse().find(function (n) {
            return isTabbable(n, config.tabbableOptions);
          });
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function (group) {
      return group.tabbableNodes.length > 0;
    }); // throw if no groups have tabbable nodes and we don't have a fallback focus node either

    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };

  var tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }

    if (node === doc.activeElement) {
      return;
    }

    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;

    if (isSelectableInput(node)) {
      node.select();
    }
  };

  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  }; // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.


  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);

    if (findContainerIndex(target) >= 0) {
      // allow the click since it ocurred inside the trap
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
      });
      return;
    } // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)


    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    } // otherwise, prevent the click


    e.preventDefault();
  }; // In case focus escapes the trap for some strange reason, pull it back in.


  var checkFocusIn = function checkFocusIn(e) {
    var target = getActualTarget(e);
    var targetContained = findContainerIndex(target) >= 0; // In Firefox when you Tab out of an iframe the Document is briefly focused.

    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  }; // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.


  var checkTab = function checkTab(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;

    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's focusable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findContainerIndex(target);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;

      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back in to...
        if (e.shiftKey) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        // REVERSE
        // is the target the first tabbable node in a group?
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });

        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          // an exception case where the target is either the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }

        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        // FORWARD
        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });

        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          // an exception case where the target is the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }

        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }

    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    } // else, let the browser take care of [shift+]tab and move the focus

  };

  var checkKey = function checkKey(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }

    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };

  var checkClick = function checkClick(e) {
    var target = getActualTarget(e);

    if (findContainerIndex(target) >= 0) {
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }

    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }; //
  // EVENT LISTENERS
  //


  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    } // There can be only one listening focus trap at a time


    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.

    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };

  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  }; //
  // TRAP DEFINITION
  //


  trap = {
    get active() {
      return state.active;
    },

    get paused() {
      return state.paused;
    },

    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }

      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }

      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;

      if (onActivate) {
        onActivate();
      }

      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }

        addListeners();

        if (onPostActivate) {
          onPostActivate();
        }
      };

      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }

      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }

      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);

      clearTimeout(state.delayInitialFocusTimer); // noop if undefined

      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(options, 'onDeactivate');
      var onPostDeactivate = getOption(options, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
      var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');

      if (onDeactivate) {
        onDeactivate();
      }

      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }

          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };

      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }

      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }

      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }

      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });

      if (state.active) {
        updateTabbableNodes();
      }

      return this;
    }
  }; // initialize container elements

  trap.updateContainerElements(elements);
  return trap;
};


//# sourceMappingURL=focus-trap.esm.js.map

;// CONCATENATED MODULE: ../../node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Older browsers don't support event options, feature detect it.

// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

var hasPassiveEvents = false;
if (typeof window !== 'undefined') {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return undefined;
    }
  };
  window.addEventListener('testPassive', null, passiveTestOptions);
  window.removeEventListener('testPassive', null, passiveTestOptions);
}

var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);


var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPaddingRight = void 0;

// returns true if `el` should be allowed to receive touchmove events.
var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }

    return false;
  });
};

var preventDefault = function preventDefault(rawEvent) {
  var e = rawEvent || window.event;

  // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.
  if (allowTouchMove(e.target)) {
    return true;
  }

  // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
  if (e.touches.length > 1) return true;

  if (e.preventDefault) e.preventDefault();

  return false;
};

var setOverflowHidden = function setOverflowHidden(options) {
  // If previousBodyPaddingRight is already set, don't set it again.
  if (previousBodyPaddingRight === undefined) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

    if (_reserveScrollBarGap && scrollBarGap > 0) {
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollBarGap + 'px';
    }
  }

  // If previousBodyOverflowSetting is already set, don't set it again.
  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
};

var restoreOverflowSetting = function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight;

    // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
    // can be set again.
    previousBodyPaddingRight = undefined;
  }

  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting;

    // Restore previousBodyOverflowSetting to undefined
    // so setOverflowHidden knows it can be set again.
    previousBodyOverflowSetting = undefined;
  }
};

// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};

var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;

  if (allowTouchMove(event.target)) {
    return false;
  }

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the bottom of its scroll.
    return preventDefault(event);
  }

  event.stopPropagation();
  return true;
};

var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  // targetElement must be provided
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
    return;
  }

  // disableBodyScroll must not have been called on this targetElement before
  if (locks.some(function (lock) {
    return lock.targetElement === targetElement;
  })) {
    return;
  }

  var lock = {
    targetElement: targetElement,
    options: options || {}
  };

  locks = [].concat(_toConsumableArray(locks), [lock]);

  if (isIosDevice) {
    targetElement.ontouchstart = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        handleScroll(event, targetElement);
      }
    };

    if (!documentListenerAdded) {
      document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = true;
    }
  } else {
    setOverflowHidden(options);
  }
};

var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
  if (isIosDevice) {
    // Clear all locks ontouchstart/ontouchmove handlers, and the references.
    locks.forEach(function (lock) {
      lock.targetElement.ontouchstart = null;
      lock.targetElement.ontouchmove = null;
    });

    if (documentListenerAdded) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }

    // Reset initial clientY.
    initialClientY = -1;
  } else {
    restoreOverflowSetting();
  }

  locks = [];
};

var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
    return;
  }

  locks = locks.filter(function (lock) {
    return lock.targetElement !== targetElement;
  });

  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;

    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }
  } else if (!locks.length) {
    restoreOverflowSetting();
  }
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js
var resizeObservers = [];


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/algorithms/hasActiveObservations.js

var hasActiveObservations = function () {
    return resizeObservers.some(function (ro) { return ro.activeTargets.length > 0; });
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/algorithms/hasSkippedObservations.js

var hasSkippedObservations = function () {
    return resizeObservers.some(function (ro) { return ro.skippedTargets.length > 0; });
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/algorithms/deliverResizeLoopError.js
var msg = 'ResizeObserver loop completed with undelivered notifications.';
var deliverResizeLoopError = function () {
    var event;
    if (typeof ErrorEvent === 'function') {
        event = new ErrorEvent('error', {
            message: msg
        });
    }
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = msg;
    }
    window.dispatchEvent(event);
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/ResizeObserverBoxOptions.js
var ResizeObserverBoxOptions;
(function (ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/utils/freeze.js
var freeze = function (obj) { return Object.freeze(obj); };

;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/ResizeObserverSize.js

var ResizeObserverSize = (function () {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        freeze(this);
    }
    return ResizeObserverSize;
}());


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/DOMRectReadOnly.js

var DOMRectReadOnly = (function () {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return freeze(this);
    }
    DOMRectReadOnly.prototype.toJSON = function () {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return { x: x, y: y, top: top, right: right, bottom: bottom, left: left, width: width, height: height };
    };
    DOMRectReadOnly.fromRect = function (rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}());


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/utils/element.js
var isSVG = function (target) { return target instanceof SVGElement && 'getBBox' in target; };
var element_isHidden = function (target) {
    if (isSVG(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isElement = function (obj) {
    var _a;
    if (obj instanceof Element) {
        return true;
    }
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var isReplacedElement = function (target) {
    switch (target.tagName) {
        case 'INPUT':
            if (target.type !== 'image') {
                break;
            }
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/utils/global.js
var global = typeof window !== 'undefined' ? window : {};

;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/algorithms/calculateBoxSize.js






var cache = new WeakMap();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = (/msie|trident/i).test(global.navigator && global.navigator.userAgent);
var parseDimension = function (pixel) { return parseFloat(pixel || '0'); };
var size = function (inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) { inlineSize = 0; }
    if (blockSize === void 0) { blockSize = 0; }
    if (switchSizes === void 0) { switchSizes = false; }
    return new ResizeObserverSize((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var zeroBoxes = freeze({
    devicePixelContentBoxSize: size(),
    borderBoxSize: size(),
    contentBoxSize: size(),
    contentRect: new DOMRectReadOnly(0, 0, 0, 0)
});
var calculateBoxSizes = function (target, forceRecalculation) {
    if (forceRecalculation === void 0) { forceRecalculation = false; }
    if (cache.has(target) && !forceRecalculation) {
        return cache.get(target);
    }
    if (element_isHidden(target)) {
        cache.set(target, zeroBoxes);
        return zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = isSVG(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !IE && cs.boxSizing === 'border-box';
    var switchSizes = verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = freeze({
        devicePixelContentBoxSize: size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: size(contentWidth, contentHeight, switchSizes),
        contentRect: new DOMRectReadOnly(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    cache.set(target, boxes);
    return boxes;
};
var calculateBoxSize = function (target, observedBox, forceRecalculation) {
    var _a = calculateBoxSizes(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch (observedBox) {
        case ResizeObserverBoxOptions.DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case ResizeObserverBoxOptions.BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/ResizeObserverEntry.js


var ResizeObserverEntry = (function () {
    function ResizeObserverEntry(target) {
        var boxes = calculateBoxSizes(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = freeze([boxes.borderBoxSize]);
        this.contentBoxSize = freeze([boxes.contentBoxSize]);
        this.devicePixelContentBoxSize = freeze([boxes.devicePixelContentBoxSize]);
    }
    return ResizeObserverEntry;
}());


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/algorithms/calculateDepthForNode.js

var calculateDepthForNode = function (node) {
    if (element_isHidden(node)) {
        return Infinity;
    }
    var depth = 0;
    var parent = node.parentNode;
    while (parent) {
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/algorithms/broadcastActiveObservations.js




var broadcastActiveObservations = function () {
    var shallowestDepth = Infinity;
    var callbacks = [];
    resizeObservers.forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) {
            return;
        }
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new ResizeObserverEntry(ot.target);
            var targetDepth = calculateDepthForNode(ot.target);
            entries.push(entry);
            ot.lastReportedSize = calculateBoxSize(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) {
                shallowestDepth = targetDepth;
            }
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for (var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++) {
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/algorithms/gatherActiveObservationsAtDepth.js


var gatherActiveObservationsAtDepth = function (depth) {
    resizeObservers.forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if (calculateDepthForNode(ot.target) > depth) {
                    ro.activeTargets.push(ot);
                }
                else {
                    ro.skippedTargets.push(ot);
                }
            }
        });
    });
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/utils/process.js





var process = function () {
    var depth = 0;
    gatherActiveObservationsAtDepth(depth);
    while (hasActiveObservations()) {
        depth = broadcastActiveObservations();
        gatherActiveObservationsAtDepth(depth);
    }
    if (hasSkippedObservations()) {
        deliverResizeLoopError();
    }
    return depth > 0;
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/utils/queueMicroTask.js
var trigger;
var callbacks = [];
var notify = function () { return callbacks.splice(0).forEach(function (cb) { return cb(); }); };
var queueMicroTask = function (callback) {
    if (!trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = { characterData: true };
        new MutationObserver(function () { return notify(); }).observe(el_1, config);
        trigger = function () { el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++); };
    }
    callbacks.push(callback);
    trigger();
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/utils/queueResizeObserver.js

var queueResizeObserver = function (cb) {
    queueMicroTask(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/utils/scheduler.js



var watching = 0;
var isWatching = function () { return !!watching; };
var CATCH_PERIOD = 250;
var observerConfig = { attributes: true, characterData: true, childList: true, subtree: true };
var events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var time = function (timeout) {
    if (timeout === void 0) { timeout = 0; }
    return Date.now() + timeout;
};
var scheduled = false;
var scheduler_Scheduler = (function () {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function () { return _this.schedule(); };
    }
    Scheduler.prototype.run = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = CATCH_PERIOD; }
        if (scheduled) {
            return;
        }
        scheduled = true;
        var until = time(timeout);
        queueResizeObserver(function () {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = process();
            }
            finally {
                scheduled = false;
                timeout = until - time();
                if (!isWatching()) {
                    return;
                }
                if (elementsHaveResized) {
                    _this.run(1000);
                }
                else if (timeout > 0) {
                    _this.run(timeout);
                }
                else {
                    _this.start();
                }
            }
        });
    };
    Scheduler.prototype.schedule = function () {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function () {
        var _this = this;
        var cb = function () { return _this.observer && _this.observer.observe(document.body, observerConfig); };
        document.body ? cb() : global.addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function () {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            events.forEach(function (name) { return global.addEventListener(name, _this.listener, true); });
        }
    };
    Scheduler.prototype.stop = function () {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            events.forEach(function (name) { return global.removeEventListener(name, _this.listener, true); });
            this.stopped = true;
        }
    };
    return Scheduler;
}());
var scheduler = new scheduler_Scheduler();
var updateCount = function (n) {
    !watching && n > 0 && scheduler.start();
    watching += n;
    !watching && scheduler.stop();
};


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/ResizeObservation.js



var skipNotifyOnElement = function (target) {
    return !isSVG(target)
        && !isReplacedElement(target)
        && getComputedStyle(target).display === 'inline';
};
var ResizeObservation = (function () {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || ResizeObserverBoxOptions.CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function () {
        var size = calculateBoxSize(this.target, this.observedBox, true);
        if (skipNotifyOnElement(this.target)) {
            this.lastReportedSize = size;
        }
        if (this.lastReportedSize.inlineSize !== size.inlineSize
            || this.lastReportedSize.blockSize !== size.blockSize) {
            return true;
        }
        return false;
    };
    return ResizeObservation;
}());


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/ResizeObserverDetail.js
var ResizeObserverDetail = (function () {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}());


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/ResizeObserverController.js




var observerMap = new WeakMap();
var getObservationIndex = function (observationTargets, target) {
    for (var i = 0; i < observationTargets.length; i += 1) {
        if (observationTargets[i].target === target) {
            return i;
        }
    }
    return -1;
};
var ResizeObserverController = (function () {
    function ResizeObserverController() {
    }
    ResizeObserverController.connect = function (resizeObserver, callback) {
        var detail = new ResizeObserverDetail(resizeObserver, callback);
        observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function (resizeObserver, target, options) {
        var detail = observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if (getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && resizeObservers.push(detail);
            detail.observationTargets.push(new ResizeObservation(target, options && options.box));
            updateCount(1);
            scheduler.schedule();
        }
    };
    ResizeObserverController.unobserve = function (resizeObserver, target) {
        var detail = observerMap.get(resizeObserver);
        var index = getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && resizeObservers.splice(resizeObservers.indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            updateCount(-1);
        }
    };
    ResizeObserverController.disconnect = function (resizeObserver) {
        var _this = this;
        var detail = observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function (ot) { return _this.unobserve(resizeObserver, ot.target); });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}());


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/ResizeObserver.js


var ResizeObserver_ResizeObserver = (function () {
    function ResizeObserver(callback) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (typeof callback !== 'function') {
            throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        }
        ResizeObserverController.connect(this, callback);
    }
    ResizeObserver.prototype.observe = function (target, options) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (!isElement(target)) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        ResizeObserverController.observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function (target) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (!isElement(target)) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        ResizeObserverController.unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function () {
        ResizeObserverController.disconnect(this);
    };
    ResizeObserver.toString = function () {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}());


;// CONCATENATED MODULE: ../../node_modules/@juggle/resize-observer/lib/exports/resize-observer.js




;// CONCATENATED MODULE: ../../node_modules/xstate/es/invokeUtils.js






function invokeUtils_toInvokeSource(src) {
  if (typeof src === 'string') {
    var simpleSrc = {
      type: src
    };

    simpleSrc.toString = function () {
      return src;
    }; // v4 compat - TODO: remove in v5


    return simpleSrc;
  }

  return src;
}
function toInvokeDefinition(invokeConfig) {
  return _tslib_assign(_tslib_assign({
    type: invoke
  }, invokeConfig), {
    toJSON: function () {
      invokeConfig.onDone;
          invokeConfig.onError;
          var invokeDef = __rest(invokeConfig, ["onDone", "onError"]);

      return _tslib_assign(_tslib_assign({}, invokeDef), {
        type: invoke,
        src: invokeUtils_toInvokeSource(invokeConfig.src)
      });
    }
  });
}



;// CONCATENATED MODULE: ../../node_modules/xstate/es/StateNode.js











var NULL_EVENT = '';
var STATE_IDENTIFIER = '#';
var WILDCARD = '*';
var EMPTY_OBJECT = {};

var isStateId = function (str) {
  return str[0] === STATE_IDENTIFIER;
};

var createDefaultOptions = function () {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
};

var validateArrayifiedTransitions = function (stateNode, event, transitions) {
  var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function (transition) {
    return !('cond' in transition) && !('in' in transition) && (utils_isString(transition.target) || utils_isMachine(transition.target));
  });
  var eventText = event === NULL_EVENT ? 'the transient event' : "event '".concat(event, "'");
  utils_warn(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};

var StateNode_StateNode =
/*#__PURE__*/

/** @class */
function () {
  function StateNode(
  /**
   * The raw config used to create the machine.
   */
  config, options,
  /**
   * The initial extended state
   */
  _context, // TODO: this is unsafe, but we're removing it in v5 anyway
  _stateInfo) {
    if (_context === void 0) {
      _context = 'context' in config ? config.context : undefined;
    }

    var _this = this;

    var _a;

    this.config = config;
    this._context = _context;
    /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */

    this.order = -1;
    this.__xstatenode = true;
    this.__cache = {
      events: undefined,
      relativeValue: new Map(),
      initialStateValue: undefined,
      initialState: undefined,
      on: undefined,
      transitions: undefined,
      candidates: {},
      delayedTransitions: undefined
    };
    this.idMap = {};
    this.tags = [];
    this.options = Object.assign(createDefaultOptions(), options);
    this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
    this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || '(machine)';
    this.machine = this.parent ? this.parent.machine : this;
    this.path = this.parent ? this.parent.path.concat(this.key) : [];
    this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : STATE_DELIMITER);
    this.id = this.config.id || __spreadArray([this.machine.key], __read(this.path), false).join(this.delimiter);
    this.version = this.parent ? this.parent.version : this.config.version;
    this.type = this.config.type || (this.config.parallel ? 'parallel' : this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
    this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
    this.description = this.config.description;

    if (!environment_IS_PRODUCTION) {
      utils_warn(!('parallel' in this.config), "The \"parallel\" property is deprecated and will be removed in version 4.1. ".concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
    }

    this.initial = this.config.initial;
    this.states = this.config.states ? mapValues(this.config.states, function (stateConfig, key) {
      var _a;

      var stateNode = new StateNode(stateConfig, {}, undefined, {
        parent: _this,
        key: key
      });
      Object.assign(_this.idMap, _tslib_assign((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
      return stateNode;
    }) : EMPTY_OBJECT; // Document order

    var order = 0;

    function dfs(stateNode) {
      var e_1, _a;

      stateNode.order = order++;

      try {
        for (var _b = _tslib_values(getAllChildren(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          dfs(child);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }

    dfs(this); // History config

    this.history = this.config.history === true ? 'shallow' : this.config.history || false;
    this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function (_a) {
      var event = _a.event;
      return event === NULL_EVENT;
    }) : NULL_EVENT in this.config.on);
    this.strict = !!this.config.strict; // TODO: deprecate (entry)

    this.onEntry = toArray(this.config.entry || this.config.onEntry).map(function (action) {
      return toActionObject(action);
    }); // TODO: deprecate (exit)

    this.onExit = toArray(this.config.exit || this.config.onExit).map(function (action) {
      return toActionObject(action);
    });
    this.meta = this.config.meta;
    this.doneData = this.type === 'final' ? this.config.data : undefined;
    this.invoke = toArray(this.config.invoke).map(function (invokeConfig, i) {
      var _a, _b;

      if (utils_isMachine(invokeConfig)) {
        var invokeId = createInvokeId(_this.id, i);
        _this.machine.options.services = _tslib_assign((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
        return toInvokeDefinition({
          src: invokeId,
          id: invokeId
        });
      } else if (utils_isString(invokeConfig.src)) {
        var invokeId = invokeConfig.id || createInvokeId(_this.id, i);
        return toInvokeDefinition(_tslib_assign(_tslib_assign({}, invokeConfig), {
          id: invokeId,
          src: invokeConfig.src
        }));
      } else if (utils_isMachine(invokeConfig.src) || utils_isFunction(invokeConfig.src)) {
        var invokeId = invokeConfig.id || createInvokeId(_this.id, i);
        _this.machine.options.services = _tslib_assign((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
        return toInvokeDefinition(_tslib_assign(_tslib_assign({
          id: invokeId
        }, invokeConfig), {
          src: invokeId
        }));
      } else {
        var invokeSource = invokeConfig.src;
        return toInvokeDefinition(_tslib_assign(_tslib_assign({
          id: createInvokeId(_this.id, i)
        }, invokeConfig), {
          src: invokeSource
        }));
      }
    });
    this.activities = toArray(this.config.activities).concat(this.invoke).map(function (activity) {
      return toActivityDefinition(activity);
    });
    this.transition = this.transition.bind(this);
    this.tags = toArray(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
  }

  StateNode.prototype._init = function () {
    if (this.__cache.transitions) {
      return;
    }

    getAllStateNodes(this).forEach(function (stateNode) {
      return stateNode.on;
    });
  };
  /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */


  StateNode.prototype.withConfig = function (options, context) {
    var _a = this.options,
        actions = _a.actions,
        activities = _a.activities,
        guards = _a.guards,
        services = _a.services,
        delays = _a.delays;
    return new StateNode(this.config, {
      actions: _tslib_assign(_tslib_assign({}, actions), options.actions),
      activities: _tslib_assign(_tslib_assign({}, activities), options.activities),
      guards: _tslib_assign(_tslib_assign({}, guards), options.guards),
      services: _tslib_assign(_tslib_assign({}, services), options.services),
      delays: _tslib_assign(_tslib_assign({}, delays), options.delays)
    }, context !== null && context !== void 0 ? context : this.context);
  };
  /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */


  StateNode.prototype.withContext = function (context) {
    return new StateNode(this.config, this.options, context);
  };

  Object.defineProperty(StateNode.prototype, "context", {
    get: function () {
      return utils_isFunction(this._context) ? this._context() : this._context;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "definition", {
    /**
     * The well-structured state node definition.
     */
    get: function () {
      return {
        id: this.id,
        key: this.key,
        version: this.version,
        context: this.context,
        type: this.type,
        initial: this.initial,
        history: this.history,
        states: mapValues(this.states, function (state) {
          return state.definition;
        }),
        on: this.on,
        transitions: this.transitions,
        entry: this.onEntry,
        exit: this.onExit,
        activities: this.activities || [],
        meta: this.meta,
        order: this.order || -1,
        data: this.doneData,
        invoke: this.invoke,
        description: this.description,
        tags: this.tags
      };
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.toJSON = function () {
    return this.definition;
  };

  Object.defineProperty(StateNode.prototype, "on", {
    /**
     * The mapping of events to transitions.
     */
    get: function () {
      if (this.__cache.on) {
        return this.__cache.on;
      }

      var transitions = this.transitions;
      return this.__cache.on = transitions.reduce(function (map, transition) {
        map[transition.eventType] = map[transition.eventType] || [];
        map[transition.eventType].push(transition);
        return map;
      }, {});
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "after", {
    get: function () {
      return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "transitions", {
    /**
     * All the transitions that can be taken from this state node.
     */
    get: function () {
      return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.getCandidates = function (eventName) {
    if (this.__cache.candidates[eventName]) {
      return this.__cache.candidates[eventName];
    }

    var transient = eventName === NULL_EVENT;
    var candidates = this.transitions.filter(function (transition) {
      var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions

      return transient ? sameEventType : sameEventType || transition.eventType === WILDCARD;
    });
    this.__cache.candidates[eventName] = candidates;
    return candidates;
  };
  /**
   * All delayed transitions from the config.
   */


  StateNode.prototype.getDelayedTransitions = function () {
    var _this = this;

    var afterConfig = this.config.after;

    if (!afterConfig) {
      return [];
    }

    var mutateEntryExit = function (delay, i) {
      var delayRef = utils_isFunction(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
      var eventType = actions_after(delayRef, _this.id);

      _this.onEntry.push(actions_send(eventType, {
        delay: delay
      }));

      _this.onExit.push(actions_cancel(eventType));

      return eventType;
    };

    var delayedTransitions = isArray(afterConfig) ? afterConfig.map(function (transition, i) {
      var eventType = mutateEntryExit(transition.delay, i);
      return _tslib_assign(_tslib_assign({}, transition), {
        event: eventType
      });
    }) : flatten(Object.keys(afterConfig).map(function (delay, i) {
      var configTransition = afterConfig[delay];
      var resolvedTransition = utils_isString(configTransition) ? {
        target: configTransition
      } : configTransition;
      var resolvedDelay = !isNaN(+delay) ? +delay : delay;
      var eventType = mutateEntryExit(resolvedDelay, i);
      return toArray(resolvedTransition).map(function (transition) {
        return _tslib_assign(_tslib_assign({}, transition), {
          event: eventType,
          delay: resolvedDelay
        });
      });
    }));
    return delayedTransitions.map(function (delayedTransition) {
      var delay = delayedTransition.delay;
      return _tslib_assign(_tslib_assign({}, _this.formatTransition(delayedTransition)), {
        delay: delay
      });
    });
  };
  /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */


  StateNode.prototype.getStateNodes = function (state) {
    var _a;

    var _this = this;

    if (!state) {
      return [];
    }

    var stateValue = state instanceof State ? state.value : toStateValue(state, this.delimiter);

    if (utils_isString(stateValue)) {
      var initialStateValue = this.getStateNode(stateValue).initial;
      return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [this, this.states[stateValue]];
    }

    var subStateKeys = Object.keys(stateValue);
    var subStateNodes = [this];
    subStateNodes.push.apply(subStateNodes, __spreadArray([], __read(flatten(subStateKeys.map(function (subStateKey) {
      return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
    }))), false));
    return subStateNodes;
  };
  /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */


  StateNode.prototype.handles = function (event) {
    var eventType = getEventType(event);
    return this.events.includes(eventType);
  };
  /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */


  StateNode.prototype.resolveState = function (state) {
    var stateFromConfig = state instanceof State ? state : State.create(state);
    var configuration = Array.from(getConfiguration([], this.getStateNodes(stateFromConfig.value)));
    return new State(_tslib_assign(_tslib_assign({}, stateFromConfig), {
      value: this.resolve(stateFromConfig.value),
      configuration: configuration,
      done: isInFinalState(configuration, this),
      tags: getTagsFromConfiguration(configuration),
      machine: this.machine
    }));
  };

  StateNode.prototype.transitionLeafNode = function (stateValue, state, _event) {
    var stateNode = this.getStateNode(stateValue);
    var next = stateNode.next(state, _event);

    if (!next || !next.transitions.length) {
      return this.next(state, _event);
    }

    return next;
  };

  StateNode.prototype.transitionCompoundNode = function (stateValue, state, _event) {
    var subStateKeys = Object.keys(stateValue);
    var stateNode = this.getStateNode(subStateKeys[0]);

    var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);

    if (!next || !next.transitions.length) {
      return this.next(state, _event);
    }

    return next;
  };

  StateNode.prototype.transitionParallelNode = function (stateValue, state, _event) {
    var e_2, _a;

    var transitionMap = {};

    try {
      for (var _b = _tslib_values(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var subStateKey = _c.value;
        var subStateValue = stateValue[subStateKey];

        if (!subStateValue) {
          continue;
        }

        var subStateNode = this.getStateNode(subStateKey);

        var next = subStateNode._transition(subStateValue, state, _event);

        if (next) {
          transitionMap[subStateKey] = next;
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    var stateTransitions = Object.keys(transitionMap).map(function (key) {
      return transitionMap[key];
    });
    var enabledTransitions = flatten(stateTransitions.map(function (st) {
      return st.transitions;
    }));
    var willTransition = stateTransitions.some(function (st) {
      return st.transitions.length > 0;
    });

    if (!willTransition) {
      return this.next(state, _event);
    }

    var configuration = flatten(Object.keys(transitionMap).map(function (key) {
      return transitionMap[key].configuration;
    }));
    return {
      transitions: enabledTransitions,
      exitSet: flatten(stateTransitions.map(function (t) {
        return t.exitSet;
      })),
      configuration: configuration,
      source: state,
      actions: flatten(Object.keys(transitionMap).map(function (key) {
        return transitionMap[key].actions;
      }))
    };
  };

  StateNode.prototype._transition = function (stateValue, state, _event) {
    // leaf node
    if (utils_isString(stateValue)) {
      return this.transitionLeafNode(stateValue, state, _event);
    } // hierarchical node


    if (Object.keys(stateValue).length === 1) {
      return this.transitionCompoundNode(stateValue, state, _event);
    } // orthogonal node


    return this.transitionParallelNode(stateValue, state, _event);
  };

  StateNode.prototype.getTransitionData = function (state, event) {
    return this._transition(state.value, state, toSCXMLEvent(event));
  };

  StateNode.prototype.next = function (state, _event) {
    var e_3, _a;

    var _this = this;

    var eventName = _event.name;
    var actions = [];
    var nextStateNodes = [];
    var selectedTransition;

    try {
      for (var _b = _tslib_values(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var candidate = _c.value;
        var cond = candidate.cond,
            stateIn = candidate.in;
        var resolvedContext = state.context;
        var isInState = stateIn ? utils_isString(stateIn) && isStateId(stateIn) ? // Check if in state by ID
        state.matches(toStateValue(this.getStateNodeById(stateIn).path, this.delimiter)) : // Check if in state by relative grandparent
        matchesState(toStateValue(stateIn, this.delimiter), path(this.path.slice(0, -2))(state.value)) : true;
        var guardPassed = false;

        try {
          guardPassed = !cond || evaluateGuard(this.machine, cond, resolvedContext, _event, state);
        } catch (err) {
          throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
        }

        if (guardPassed && isInState) {
          if (candidate.target !== undefined) {
            nextStateNodes = candidate.target;
          }

          actions.push.apply(actions, __spreadArray([], __read(candidate.actions), false));
          selectedTransition = candidate;
          break;
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    if (!selectedTransition) {
      return undefined;
    }

    if (!nextStateNodes.length) {
      return {
        transitions: [selectedTransition],
        exitSet: [],
        configuration: state.value ? [this] : [],
        source: state,
        actions: actions
      };
    }

    var allNextStateNodes = flatten(nextStateNodes.map(function (stateNode) {
      return _this.getRelativeStateNodes(stateNode, state.historyValue);
    }));
    var isInternal = !!selectedTransition.internal;
    return {
      transitions: [selectedTransition],
      exitSet: isInternal ? [] : flatten(nextStateNodes.map(function (targetNode) {
        return _this.getPotentiallyReenteringNodes(targetNode);
      })),
      configuration: allNextStateNodes,
      source: state,
      actions: actions
    };
  }; // even though the name of this function mentions reentry nodes
  // we are pushing its result into `exitSet`
  // that's because what we exit might be reentered (it's an invariant of reentrancy)


  StateNode.prototype.getPotentiallyReenteringNodes = function (targetNode) {
    if (this.order < targetNode.order) {
      return [this];
    }

    var nodes = [];
    var marker = this;
    var possibleAncestor = targetNode;

    while (marker && marker !== possibleAncestor) {
      nodes.push(marker);
      marker = marker.parent;
    }

    if (marker !== possibleAncestor) {
      // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
      // it's in a different part of the tree so no states will be reentered for such an external transition
      return [];
    }

    nodes.push(possibleAncestor);
    return nodes;
  };

  StateNode.prototype.getActions = function (resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
    var e_4, _a, e_5, _b;

    var _this = this;

    var prevConfig = prevState ? getConfiguration([], this.getStateNodes(prevState.value)) : [];
    var entrySet = new Set();

    try {
      for (var _c = _tslib_values(Array.from(resolvedConfig).sort(function (a, b) {
        return a.order - b.order;
      })), _d = _c.next(); !_d.done; _d = _c.next()) {
        var sn = _d.value;

        if (!has(prevConfig, sn) || has(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) {
          entrySet.add(sn);
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    try {
      for (var prevConfig_1 = _tslib_values(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()) {
        var sn = prevConfig_1_1.value;

        if (!has(resolvedConfig, sn) || has(transition.exitSet, sn.parent)) {
          transition.exitSet.push(sn);
        }
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
      } finally {
        if (e_5) throw e_5.error;
      }
    }

    transition.exitSet.sort(function (a, b) {
      return b.order - a.order;
    });
    var entryStates = Array.from(entrySet).sort(function (a, b) {
      return a.order - b.order;
    });
    var exitStates = new Set(transition.exitSet);
    var doneEvents = flatten(entryStates.map(function (sn) {
      var events = [];

      if (sn.type !== 'final') {
        return events;
      }

      var parent = sn.parent;

      if (!parent.parent) {
        return events;
      }

      events.push(done(sn.id, sn.doneData), // TODO: deprecate - final states should not emit done events for their own state.
      done(parent.id, sn.doneData ? mapContext(sn.doneData, currentContext, _event) : undefined));
      var grandparent = parent.parent;

      if (grandparent.type === 'parallel') {
        if (getChildren(grandparent).every(function (parentNode) {
          return isInFinalState(transition.configuration, parentNode);
        })) {
          events.push(done(grandparent.id));
        }
      }

      return events;
    }));
    var entryActions = entryStates.map(function (stateNode) {
      var entryActions = stateNode.onEntry;
      var invokeActions = stateNode.activities.map(function (activity) {
        return actions_start(activity);
      });
      return {
        type: 'entry',
        actions: toActionObjects(predictableExec ? __spreadArray(__spreadArray([], __read(entryActions), false), __read(invokeActions), false) : __spreadArray(__spreadArray([], __read(invokeActions), false), __read(entryActions), false), _this.machine.options.actions)
      };
    }).concat({
      type: 'state_done',
      actions: doneEvents.map(function (event) {
        return actions_raise(event);
      })
    });
    var exitActions = Array.from(exitStates).map(function (stateNode) {
      return {
        type: 'exit',
        actions: toActionObjects(__spreadArray(__spreadArray([], __read(stateNode.onExit), false), __read(stateNode.activities.map(function (activity) {
          return actions_stop(activity);
        })), false), _this.machine.options.actions)
      };
    });
    var actions = exitActions.concat({
      type: 'transition',
      actions: toActionObjects(transition.actions, this.machine.options.actions)
    }).concat(entryActions);

    if (isDone) {
      var stopActions = toActionObjects(flatten(__spreadArray([], __read(resolvedConfig), false).sort(function (a, b) {
        return b.order - a.order;
      }).map(function (stateNode) {
        return stateNode.onExit;
      })), this.machine.options.actions).filter(function (action) {
        return !isRaisableAction(action);
      });
      return actions.concat({
        type: 'stop',
        actions: stopActions
      });
    }

    return actions;
  };
  /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */


  StateNode.prototype.transition = function (state, event, context, exec) {
    if (state === void 0) {
      state = this.initialState;
    }

    var _event = toSCXMLEvent(event);

    var currentState;

    if (state instanceof State) {
      currentState = context === undefined ? state : this.resolveState(State.from(state, context));
    } else {
      var resolvedStateValue = utils_isString(state) ? this.resolve(pathToStateValue(this.getResolvedPath(state))) : this.resolve(state);
      var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
      currentState = this.resolveState(State.from(resolvedStateValue, resolvedContext));
    }

    if (!environment_IS_PRODUCTION && _event.name === WILDCARD) {
      throw new Error("An event cannot have the wildcard type ('".concat(WILDCARD, "')"));
    }

    if (this.strict) {
      if (!this.events.includes(_event.name) && !isBuiltInEvent(_event.name)) {
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
      }
    }

    var stateTransition = this._transition(currentState.value, currentState, _event) || {
      transitions: [],
      configuration: [],
      exitSet: [],
      source: currentState,
      actions: []
    };
    var prevConfig = getConfiguration([], this.getStateNodes(currentState.value));
    var resolvedConfig = stateTransition.configuration.length ? getConfiguration(prevConfig, stateTransition.configuration) : prevConfig;
    stateTransition.configuration = __spreadArray([], __read(resolvedConfig), false);
    return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
  };

  StateNode.prototype.resolveRaisedTransition = function (state, _event, originalEvent, predictableExec) {
    var _a;

    var currentActions = state.actions;
    state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
    // TODO: this should be the raised event! Delete in V5 (breaking)

    state._event = originalEvent;
    state.event = originalEvent.data;

    (_a = state.actions).unshift.apply(_a, __spreadArray([], __read(currentActions), false));

    return state;
  };

  StateNode.prototype.resolveTransition = function (stateTransition, currentState, context, predictableExec, _event) {
    var e_6, _a, e_7, _b;

    var _this = this;

    if (_event === void 0) {
      _event = initEvent;
    }

    var configuration = stateTransition.configuration; // Transition will "apply" if:
    // - this is the initial state (there is no current state)
    // - OR there are transitions

    var willTransition = !currentState || stateTransition.transitions.length > 0;
    var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
    var isDone = isInFinalState(resolvedConfiguration, this);
    var resolvedStateValue = willTransition ? getValue(this.machine, configuration) : undefined;
    var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
    var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
    var activities = currentState ? _tslib_assign({}, currentState.activities) : {};

    try {
      for (var actionBlocks_1 = _tslib_values(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()) {
        var block = actionBlocks_1_1.value;

        try {
          for (var _c = (e_7 = void 0, _tslib_values(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var action = _d.value;

            if (action.type === start) {
              activities[action.activity.id || action.activity.type] = action;
            } else if (action.type === stop) {
              activities[action.activity.id || action.activity.type] = false;
            }
          }
        } catch (e_7_1) {
          e_7 = {
            error: e_7_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
          } finally {
            if (e_7) throw e_7.error;
          }
        }
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
      } finally {
        if (e_6) throw e_6.error;
      }
    }

    var _e = __read(resolveActions(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2),
        resolvedActions = _e[0],
        updatedContext = _e[1];

    var _f = __read(partition(resolvedActions, isRaisableAction), 2),
        raisedEvents = _f[0],
        nonRaisedActions = _f[1];

    var invokeActions = resolvedActions.filter(function (action) {
      var _a;

      return action.type === start && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === invoke;
    });
    var children = invokeActions.reduce(function (acc, action) {
      acc[action.activity.id] = createInvocableActor(action.activity, _this.machine, updatedContext, _event);
      return acc;
    }, currentState ? _tslib_assign({}, currentState.children) : {});
    var nextState = new State({
      value: resolvedStateValue || currentState.value,
      context: updatedContext,
      _event: _event,
      // Persist _sessionid between states
      _sessionid: currentState ? currentState._sessionid : null,
      historyValue: resolvedStateValue ? historyValue ? updateHistoryValue(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
      history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
      actions: resolvedStateValue ? nonRaisedActions : [],
      activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
      events: [],
      configuration: resolvedConfiguration,
      transitions: stateTransition.transitions,
      children: children,
      done: isDone,
      tags: getTagsFromConfiguration(resolvedConfiguration),
      machine: this
    });
    var didUpdateContext = context !== updatedContext;
    nextState.changed = _event.name === update || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks

    var history = nextState.history;

    if (history) {
      delete history.history;
    } // There are transient transitions if the machine is not in a final state
    // and if some of the state nodes have transient ("always") transitions.


    var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function (stateNode) {
      return stateNode._transient;
    })); // If there are no enabled transitions, check if there are transient transitions.
    // If there are transient transitions, continue checking for more transitions
    // because an transient transition should be triggered even if there are no
    // enabled transitions.
    //
    // If we're already working on an transient transition then stop to prevent an infinite loop.
    //
    // Otherwise, if there are no enabled nor transient transitions, we are done.

    if (!willTransition && (!hasAlwaysTransitions || _event.name === NULL_EVENT)) {
      return nextState;
    }

    var maybeNextState = nextState;

    if (!isDone) {
      if (hasAlwaysTransitions) {
        maybeNextState = this.resolveRaisedTransition(maybeNextState, {
          type: nullEvent
        }, _event, predictableExec);
      }

      while (raisedEvents.length) {
        var raisedEvent = raisedEvents.shift();
        maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
      }
    } // Detect if state changed


    var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !stateValuesEqual(maybeNextState.value, history.value) : undefined);
    maybeNextState.changed = changed; // Preserve original history after raised events

    maybeNextState.history = history;
    return maybeNextState;
  };
  /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */


  StateNode.prototype.getStateNode = function (stateKey) {
    if (isStateId(stateKey)) {
      return this.machine.getStateNodeById(stateKey);
    }

    if (!this.states) {
      throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
    }

    var result = this.states[stateKey];

    if (!result) {
      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
    }

    return result;
  };
  /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */


  StateNode.prototype.getStateNodeById = function (stateId) {
    var resolvedStateId = isStateId(stateId) ? stateId.slice(STATE_IDENTIFIER.length) : stateId;

    if (resolvedStateId === this.id) {
      return this;
    }

    var stateNode = this.machine.idMap[resolvedStateId];

    if (!stateNode) {
      throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
    }

    return stateNode;
  };
  /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */


  StateNode.prototype.getStateNodeByPath = function (statePath) {
    if (typeof statePath === 'string' && isStateId(statePath)) {
      try {
        return this.getStateNodeById(statePath.slice(1));
      } catch (e) {// try individual paths
        // throw e;
      }
    }

    var arrayStatePath = toStatePath(statePath, this.delimiter).slice();
    var currentStateNode = this;

    while (arrayStatePath.length) {
      var key = arrayStatePath.shift();

      if (!key.length) {
        break;
      }

      currentStateNode = currentStateNode.getStateNode(key);
    }

    return currentStateNode;
  };
  /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */


  StateNode.prototype.resolve = function (stateValue) {
    var _a;

    var _this = this;

    if (!stateValue) {
      return this.initialStateValue || EMPTY_OBJECT; // TODO: type-specific properties
    }

    switch (this.type) {
      case 'parallel':
        return mapValues(this.initialStateValue, function (subStateValue, subStateKey) {
          return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : EMPTY_OBJECT;
        });

      case 'compound':
        if (utils_isString(stateValue)) {
          var subStateNode = this.getStateNode(stateValue);

          if (subStateNode.type === 'parallel' || subStateNode.type === 'compound') {
            return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
          }

          return stateValue;
        }

        if (!Object.keys(stateValue).length) {
          return this.initialStateValue || {};
        }

        return mapValues(stateValue, function (subStateValue, subStateKey) {
          return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : EMPTY_OBJECT;
        });

      default:
        return stateValue || EMPTY_OBJECT;
    }
  };

  StateNode.prototype.getResolvedPath = function (stateIdentifier) {
    if (isStateId(stateIdentifier)) {
      var stateNode = this.machine.idMap[stateIdentifier.slice(STATE_IDENTIFIER.length)];

      if (!stateNode) {
        throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
      }

      return stateNode.path;
    }

    return toStatePath(stateIdentifier, this.delimiter);
  };

  Object.defineProperty(StateNode.prototype, "initialStateValue", {
    get: function () {
      var _a;

      if (this.__cache.initialStateValue) {
        return this.__cache.initialStateValue;
      }

      var initialStateValue;

      if (this.type === 'parallel') {
        initialStateValue = mapFilterValues(this.states, function (state) {
          return state.initialStateValue || EMPTY_OBJECT;
        }, function (stateNode) {
          return !(stateNode.type === 'history');
        });
      } else if (this.initial !== undefined) {
        if (!this.states[this.initial]) {
          throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
        }

        initialStateValue = isLeafNode(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
      } else {
        // The finite state value of a machine without child states is just an empty object
        initialStateValue = {};
      }

      this.__cache.initialStateValue = initialStateValue;
      return this.__cache.initialStateValue;
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.getInitialState = function (stateValue, context) {
    this._init(); // TODO: this should be in the constructor (see note in constructor)


    var configuration = this.getStateNodes(stateValue);
    return this.resolveTransition({
      configuration: configuration,
      exitSet: [],
      transitions: [],
      source: undefined,
      actions: []
    }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
  };

  Object.defineProperty(StateNode.prototype, "initialState", {
    /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */
    get: function () {
      var initialStateValue = this.initialStateValue;

      if (!initialStateValue) {
        throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
      }

      return this.getInitialState(initialStateValue);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "target", {
    /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */
    get: function () {
      var target;

      if (this.type === 'history') {
        var historyConfig = this.config;

        if (utils_isString(historyConfig.target)) {
          target = isStateId(historyConfig.target) ? pathToStateValue(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
        } else {
          target = historyConfig.target;
        }
      }

      return target;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */

  StateNode.prototype.getRelativeStateNodes = function (relativeStateId, historyValue, resolve) {
    if (resolve === void 0) {
      resolve = true;
    }

    return resolve ? relativeStateId.type === 'history' ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [relativeStateId];
  };

  Object.defineProperty(StateNode.prototype, "initialStateNodes", {
    get: function () {
      var _this = this;

      if (isLeafNode(this)) {
        return [this];
      } // Case when state node is compound but no initial state is defined


      if (this.type === 'compound' && !this.initial) {
        if (!environment_IS_PRODUCTION) {
          utils_warn(false, "Compound state node '".concat(this.id, "' has no initial state."));
        }

        return [this];
      }

      var initialStateNodePaths = toStatePaths(this.initialStateValue);
      return flatten(initialStateNodePaths.map(function (initialPath) {
        return _this.getFromRelativePath(initialPath);
      }));
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */

  StateNode.prototype.getFromRelativePath = function (relativePath) {
    if (!relativePath.length) {
      return [this];
    }

    var _a = __read(relativePath),
        stateKey = _a[0],
        childStatePath = _a.slice(1);

    if (!this.states) {
      throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
    }

    var childStateNode = this.getStateNode(stateKey);

    if (childStateNode.type === 'history') {
      return childStateNode.resolveHistory();
    }

    if (!this.states[stateKey]) {
      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
    }

    return this.states[stateKey].getFromRelativePath(childStatePath);
  };

  StateNode.prototype.historyValue = function (relativeStateValue) {
    if (!Object.keys(this.states).length) {
      return undefined;
    }

    return {
      current: relativeStateValue || this.initialStateValue,
      states: mapFilterValues(this.states, function (stateNode, key) {
        if (!relativeStateValue) {
          return stateNode.historyValue();
        }

        var subStateValue = utils_isString(relativeStateValue) ? undefined : relativeStateValue[key];
        return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
      }, function (stateNode) {
        return !stateNode.history;
      })
    };
  };
  /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */


  StateNode.prototype.resolveHistory = function (historyValue) {
    var _this = this;

    if (this.type !== 'history') {
      return [this];
    }

    var parent = this.parent;

    if (!historyValue) {
      var historyTarget = this.target;
      return historyTarget ? flatten(toStatePaths(historyTarget).map(function (relativeChildPath) {
        return parent.getFromRelativePath(relativeChildPath);
      })) : parent.initialStateNodes;
    }

    var subHistoryValue = nestedPath(parent.path, 'states')(historyValue).current;

    if (utils_isString(subHistoryValue)) {
      return [parent.getStateNode(subHistoryValue)];
    }

    return flatten(toStatePaths(subHistoryValue).map(function (subStatePath) {
      return _this.history === 'deep' ? parent.getFromRelativePath(subStatePath) : [parent.states[subStatePath[0]]];
    }));
  };

  Object.defineProperty(StateNode.prototype, "stateIds", {
    /**
     * All the state node IDs of this state node and its descendant state nodes.
     */
    get: function () {
      var _this = this;

      var childStateIds = flatten(Object.keys(this.states).map(function (stateKey) {
        return _this.states[stateKey].stateIds;
      }));
      return [this.id].concat(childStateIds);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "events", {
    /**
     * All the event types accepted by this state node and its descendants.
     */
    get: function () {
      var e_8, _a, e_9, _b;

      if (this.__cache.events) {
        return this.__cache.events;
      }

      var states = this.states;
      var events = new Set(this.ownEvents);

      if (states) {
        try {
          for (var _c = _tslib_values(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var stateId = _d.value;
            var state = states[stateId];

            if (state.states) {
              try {
                for (var _e = (e_9 = void 0, _tslib_values(state.events)), _f = _e.next(); !_f.done; _f = _e.next()) {
                  var event_1 = _f.value;
                  events.add("".concat(event_1));
                }
              } catch (e_9_1) {
                e_9 = {
                  error: e_9_1
                };
              } finally {
                try {
                  if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally {
                  if (e_9) throw e_9.error;
                }
              }
            }
          }
        } catch (e_8_1) {
          e_8 = {
            error: e_8_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
          } finally {
            if (e_8) throw e_8.error;
          }
        }
      }

      return this.__cache.events = Array.from(events);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "ownEvents", {
    /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */
    get: function () {
      var events = new Set(this.transitions.filter(function (transition) {
        return !(!transition.target && !transition.actions.length && transition.internal);
      }).map(function (transition) {
        return transition.eventType;
      }));
      return Array.from(events);
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.resolveTarget = function (_target) {
    var _this = this;

    if (_target === undefined) {
      // an undefined target signals that the state node should not transition from that state when receiving that event
      return undefined;
    }

    return _target.map(function (target) {
      if (!utils_isString(target)) {
        return target;
      }

      var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
      // do not include machine key on target

      if (isInternalTarget && !_this.parent) {
        return _this.getStateNodeByPath(target.slice(1));
      }

      var resolvedTarget = isInternalTarget ? _this.key + target : target;

      if (_this.parent) {
        try {
          var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);

          return targetStateNode;
        } catch (err) {
          throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
        }
      } else {
        return _this.getStateNodeByPath(resolvedTarget);
      }
    });
  };

  StateNode.prototype.formatTransition = function (transitionConfig) {
    var _this = this;

    var normalizedTarget = normalizeTarget(transitionConfig.target);
    var internal = 'internal' in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function (_target) {
      return utils_isString(_target) && _target[0] === _this.delimiter;
    }) : true;
    var guards = this.machine.options.guards;
    var target = this.resolveTarget(normalizedTarget);

    var transition = _tslib_assign(_tslib_assign({}, transitionConfig), {
      actions: toActionObjects(toArray(transitionConfig.actions)),
      cond: toGuard(transitionConfig.cond, guards),
      target: target,
      source: this,
      internal: internal,
      eventType: transitionConfig.event,
      toJSON: function () {
        return _tslib_assign(_tslib_assign({}, transition), {
          target: transition.target ? transition.target.map(function (t) {
            return "#".concat(t.id);
          }) : undefined,
          source: "#".concat(_this.id)
        });
      }
    });

    return transition;
  };

  StateNode.prototype.formatTransitions = function () {
    var e_10, _a;

    var _this = this;

    var onConfig;

    if (!this.config.on) {
      onConfig = [];
    } else if (Array.isArray(this.config.on)) {
      onConfig = this.config.on;
    } else {
      var _b = this.config.on,
          _c = WILDCARD,
          _d = _b[_c],
          wildcardConfigs = _d === void 0 ? [] : _d,
          strictTransitionConfigs_1 = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);

      onConfig = flatten(Object.keys(strictTransitionConfigs_1).map(function (key) {
        if (!environment_IS_PRODUCTION && key === NULL_EVENT) {
          utils_warn(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + "Please check the `on` configuration for \"#".concat(_this.id, "\"."));
        }

        var transitionConfigArray = toTransitionConfigArray(key, strictTransitionConfigs_1[key]);

        if (!environment_IS_PRODUCTION) {
          validateArrayifiedTransitions(_this, key, transitionConfigArray);
        }

        return transitionConfigArray;
      }).concat(toTransitionConfigArray(WILDCARD, wildcardConfigs)));
    }

    var eventlessConfig = this.config.always ? toTransitionConfigArray('', this.config.always) : [];
    var doneConfig = this.config.onDone ? toTransitionConfigArray(String(done(this.id)), this.config.onDone) : [];

    if (!environment_IS_PRODUCTION) {
      utils_warn(!(this.config.onDone && !this.parent), "Root nodes cannot have an \".onDone\" transition. Please check the config of \"".concat(this.id, "\"."));
    }

    var invokeConfig = flatten(this.invoke.map(function (invokeDef) {
      var settleTransitions = [];

      if (invokeDef.onDone) {
        settleTransitions.push.apply(settleTransitions, __spreadArray([], __read(toTransitionConfigArray(String(actions_doneInvoke(invokeDef.id)), invokeDef.onDone)), false));
      }

      if (invokeDef.onError) {
        settleTransitions.push.apply(settleTransitions, __spreadArray([], __read(toTransitionConfigArray(String(actions_error(invokeDef.id)), invokeDef.onError)), false));
      }

      return settleTransitions;
    }));
    var delayedTransitions = this.after;
    var formattedTransitions = flatten(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(doneConfig), false), __read(invokeConfig), false), __read(onConfig), false), __read(eventlessConfig), false).map(function (transitionConfig) {
      return toArray(transitionConfig).map(function (transition) {
        return _this.formatTransition(transition);
      });
    }));

    try {
      for (var delayedTransitions_1 = _tslib_values(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()) {
        var delayedTransition = delayedTransitions_1_1.value;
        formattedTransitions.push(delayedTransition);
      }
    } catch (e_10_1) {
      e_10 = {
        error: e_10_1
      };
    } finally {
      try {
        if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
      } finally {
        if (e_10) throw e_10.error;
      }
    }

    return formattedTransitions;
  };

  return StateNode;
}();



;// CONCATENATED MODULE: ../../node_modules/xstate/es/Machine.js



var warned = false;
function Machine(config, options, initialContext) {
  if (initialContext === void 0) {
    initialContext = config.context;
  }

  return new StateNode_StateNode(config, options, initialContext);
}
function createMachine(config, options) {
  if (!IS_PRODUCTION && !('predictableActionArguments' in config) && !warned) {
    warned = true;
    console.warn('It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html');
  }

  return new StateNode(config, options);
}



;// CONCATENATED MODULE: ../../node_modules/xstate/es/index.js















var es_assign = actions_assign,
    es_cancel = actions_cancel,
    es_send = actions_send,
    es_sendTo = sendTo,
    es_sendParent = sendParent,
    es_sendUpdate = sendUpdate,
    es_forwardTo = forwardTo,
    es_doneInvoke = actions_doneInvoke,
    es_raise = actions_raise,
    es_log = actions_log,
    es_pure = actions_pure,
    es_choose = actions_choose,
    es_stop = actions_stop;



;// CONCATENATED MODULE: ../../node_modules/react-spring-bottom-sheet/dist/index.es.js
function x(){return x=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var r=arguments[n];for(var t in r)Object.prototype.hasOwnProperty.call(r,t)&&(e[t]=r[t])}return e},x.apply(this,arguments)}function C(e,n){if(null==e)return{};var r,t,o={},i=Object.keys(e);for(t=0;t<i.length;t++)n.indexOf(r=i[t])>=0||(o[r]=e[r]);return o}var O="undefined"!=typeof window?react.useLayoutEffect:react.useEffect;function N(e,n,r){return n=(n=+n)==n?n:0,r=(r=+r)==r?r:0,(e=+e)==e&&(e=(e=e<=r?e:r)>=n?e:n),e}function w(e){var n=Math.round(e);if(Number.isNaN(e))throw new TypeError("Found a NaN! Check your snapPoints / defaultSnap / snapTo ");return n}var H={box:"border-box"};function D(e,n){var r=n.label,o=n.enabled,i=n.resizeSourceRef,u=(0,react.useState)(0),s=u[0],l=u[1];(0,react.useDebugValue)(r+": "+s);var d=(0,react.useCallback)(function(e){l(e[0].borderBoxSize[0].blockSize),i.current="element"},[i]);return O(function(){if(e.current&&o){var n=new ResizeObserver_ResizeObserver(d);return n.observe(e.current,H),function(){n.disconnect()}}},[e,d,o]),o?s:0}function k(e){return void 0===e&&(e=1e3),new Promise(function(n){return setTimeout(n,e)})}var z={DRAG:{target:"#overlay.dragging",actions:"onOpenEnd"}},j={RESIZE:{target:"#overlay.resizing",actions:"onOpenEnd"}},A=Machine({id:"overlay",initial:"closed",context:{initialState:"CLOSED"},states:{closed:{on:{OPEN:"opening",CLOSE:void 0}},opening:{initial:"start",states:{start:{invoke:{src:"onOpenStart",onDone:"transition"}},transition:{always:[{target:"immediately",cond:"initiallyOpen"},{target:"smoothly",cond:"initiallyClosed"}]},immediately:{initial:"open",states:{open:{invoke:{src:"openImmediately",onDone:"activating"}},activating:{invoke:{src:"activate",onDone:"#overlay.opening.end"},on:x({},z,j)}}},smoothly:{initial:"visuallyHidden",states:{visuallyHidden:{invoke:{src:"renderVisuallyHidden",onDone:"activating"}},activating:{invoke:{src:"activate",onDone:"open"}},open:{invoke:{src:"openSmoothly",onDone:"#overlay.opening.end"},on:x({},z,j)}}},end:{invoke:{src:"onOpenEnd",onDone:"done"},on:{CLOSE:"#overlay.closing",DRAG:"#overlay.dragging"}},done:{type:"final"}},on:x({},{CLOSE:{target:"#overlay.closing",actions:"onOpenCancel"}}),onDone:"open"},open:{on:{DRAG:"#overlay.dragging",SNAP:"snapping",RESIZE:"resizing"}},dragging:{on:{SNAP:"snapping"}},snapping:{initial:"start",states:{start:{invoke:{src:"onSnapStart",onDone:"snappingSmoothly"},entry:[es_assign({y:function(e,n){return n.payload.y},velocity:function(e,n){return n.payload.velocity},snapSource:function(e,n){var r=n.payload.source;return void 0===r?"custom":r}})]},snappingSmoothly:{invoke:{src:"snapSmoothly",onDone:"end"}},end:{invoke:{src:"onSnapEnd",onDone:"done"},on:{RESIZE:"#overlay.resizing",SNAP:"#overlay.snapping",CLOSE:"#overlay.closing",DRAG:"#overlay.dragging"}},done:{type:"final"}},on:{SNAP:{target:"snapping",actions:"onSnapEnd"},RESIZE:{target:"#overlay.resizing",actions:"onSnapCancel"},DRAG:{target:"#overlay.dragging",actions:"onSnapCancel"},CLOSE:{target:"#overlay.closing",actions:"onSnapCancel"}},onDone:"open"},resizing:{initial:"start",states:{start:{invoke:{src:"onResizeStart",onDone:"resizingSmoothly"}},resizingSmoothly:{invoke:{src:"resizeSmoothly",onDone:"end"}},end:{invoke:{src:"onResizeEnd",onDone:"done"},on:{SNAP:"#overlay.snapping",CLOSE:"#overlay.closing",DRAG:"#overlay.dragging"}},done:{type:"final"}},on:{RESIZE:{target:"resizing",actions:"onResizeEnd"},SNAP:{target:"snapping",actions:"onResizeCancel"},DRAG:{target:"#overlay.dragging",actions:"onResizeCancel"},CLOSE:{target:"#overlay.closing",actions:"onResizeCancel"}},onDone:"open"},closing:{initial:"start",states:{start:{invoke:{src:"onCloseStart",onDone:"deactivating"},on:{OPEN:{target:"#overlay.open",actions:"onCloseCancel"}}},deactivating:{invoke:{src:"deactivate",onDone:"closingSmoothly"}},closingSmoothly:{invoke:{src:"closeSmoothly",onDone:"end"}},end:{invoke:{src:"onCloseEnd",onDone:"done"},on:{OPEN:{target:"#overlay.opening",actions:"onCloseCancel"}}},done:{type:"final"}},on:{CLOSE:void 0,OPEN:{target:"#overlay.opening",actions:"onCloseCancel"}},onDone:"closed"}},on:{CLOSE:"closing"}},{actions:{onOpenCancel:function(e,n){},onSnapCancel:function(e,n){},onResizeCancel:function(e,n){},onCloseCancel:function(e,n){},onOpenEnd:function(e,n){},onSnapEnd:function(e,n){},onRezizeEnd:function(e,n){}},services:{onSnapStart:function(){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},onOpenStart:function(){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},onCloseStart:function(){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},onResizeStart:function(){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},onSnapEnd:function(){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},onOpenEnd:function(){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},onCloseEnd:function(){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},onResizeEnd:function(){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},renderVisuallyHidden:function(e,n){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},activate:function(e,n){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},deactivate:function(e,n){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},openSmoothly:function(e,n){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},openImmediately:function(e,n){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},snapSmoothly:function(e,n){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},resizeSmoothly:function(e,n){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}},closeSmoothly:function(e,n){try{return Promise.resolve(k()).then(function(){})}catch(e){return Promise.reject(e)}}},guards:{initiallyClosed:function(e){return"CLOSED"===e.initialState},initiallyOpen:function(e){return"OPEN"===e.initialState}}}),L=["children","sibling","className","footer","header","open","initialState","lastSnapRef","initialFocusRef","onDismiss","maxHeight","defaultSnap","snapPoints","blocking","scrollLocking","style","onSpringStart","onSpringCancel","onSpringEnd","reserveScrollBarGap","expandOnContentDrag"],T=["velocity"],M=["onRest","config"],I=config["default"],F=I.tension,index_es_G=I.friction,Z=react.forwardRef(function(e,i){var l=e.children,p=e.sibling,P=e.className,b=e.footer,R=e.header,H=e.open,k=e.initialState,z=e.lastSnapRef,j=e.initialFocusRef,I=e.onDismiss,Z=e.maxHeight,K=e.defaultSnap,J=void 0===K?q:K,Q=e.snapPoints,U=void 0===Q?V:Q,W=e.blocking,X=void 0===W||W,Y=e.scrollLocking,$=void 0===Y||Y,_=e.style,ee=e.onSpringStart,ne=e.onSpringCancel,re=e.onSpringEnd,te=e.reserveScrollBarGap,oe=void 0===te?X:te,ie=e.expandOnContentDrag,ae=void 0!==ie&&ie,ce=C(e,L),ue=function(){var e=(0,react.useState)(!1),n=e[0],r=e[1],t=(0,react.useState)({}),i=t[0],u=t[1],s=(0,react.useCallback)(function(e){return u(function(n){var r;return x({},n,((r={})[e]=!1,r))}),function(){u(function(n){var r;return x({},n,((r={})[e]=!0,r))})}},[]);return (0,react.useEffect)(function(){var e=Object.values(i);0!==e.length&&e.every(Boolean)&&r(!0)},[i]),{ready:n,registerReady:s}}(),se=ue.ready,le=ue.registerReady,de=(0,react.useRef)(!1),fe=(0,react.useRef)(ee),ve=(0,react.useRef)(ne),me=(0,react.useRef)(re);(0,react.useEffect)(function(){fe.current=ee,ve.current=ne,me.current=re},[ne,ee,re]);var pe,ye,he=useSpring(function(){return{y:0,ready:0,maxHeight:0,minSnap:0,maxSnap:0}}),ge=he[0],Se=he[1],Ee=(0,react.useRef)(null),Pe=(0,react.useRef)(null),be=(0,react.useRef)(null),Re=(0,react.useRef)(null),xe=(0,react.useRef)(null),Ce=(0,react.useRef)(null),Oe=(0,react.useRef)(0),Ne=(0,react.useRef)(),we=(0,react.useRef)(!1),He=(pe=(0,react.useMemo)(function(){return"undefined"!=typeof window?window.matchMedia("(prefers-reduced-motion: reduce)"):null},[]),ye=(0,react.useRef)(null==pe?void 0:pe.matches),(0,react.useDebugValue)(ye.current?"reduce":"no-preference"),(0,react.useEffect)(function(){var e=function(e){ye.current=e.matches};return null==pe||pe.addListener(e),function(){return null==pe?void 0:pe.removeListener(e)}},[pe]),ye),De=function(e){var n=e.targetRef,i=e.enabled,a=e.reserveScrollBarGap,c=(0,react.useRef)({activate:function(){throw new TypeError("Tried to activate scroll lock too early")},deactivate:function(){}});return (0,react.useDebugValue)(i?"Enabled":"Disabled"),(0,react.useEffect)(function(){if(!i)return c.current.deactivate(),void(c.current={activate:function(){},deactivate:function(){}});var e=n.current,r=!1;c.current={activate:function(){r||(r=!0,disableBodyScroll(e,{allowTouchMove:function(e){return e.closest("[data-body-scroll-lock-ignore]")},reserveScrollBarGap:a}))},deactivate:function(){r&&(r=!1,enableBodyScroll(e))}}},[i,n,a]),c}({targetRef:Pe,enabled:se&&$,reserveScrollBarGap:oe}),ke=function(e){var n=e.targetRef,i=e.enabled,a=(0,react.useRef)({activate:function(){throw new TypeError("Tried to activate aria hider too early")},deactivate:function(){}});return (0,react.useDebugValue)(i?"Enabled":"Disabled"),(0,react.useEffect)(function(){if(!i)return a.current.deactivate(),void(a.current={activate:function(){},deactivate:function(){}});var e=n.current,r=!1,t=[],o=[];a.current={activate:function(){if(!r){r=!0;var n=e.parentNode;document.querySelectorAll("body > *").forEach(function(e){if(e!==n){var r=e.getAttribute("aria-hidden");null!==r&&"false"!==r||(t.push(r),o.push(e),e.setAttribute("aria-hidden","true"))}})}},deactivate:function(){r&&(r=!1,o.forEach(function(e,n){var r=t[n];null===r?e.removeAttribute("aria-hidden"):e.setAttribute("aria-hidden",r)}),t=[],o=[])}}},[n,i]),a}({targetRef:Ee,enabled:se&&X}),ze=function(e){var n=e.targetRef,i=e.fallbackRef,a=e.initialFocusRef,c=e.enabled,u=(0,react.useRef)({activate:function(){throw new TypeError("Tried to activate focus trap too early")},deactivate:function(){}});return (0,react.useDebugValue)(c?"Enabled":"Disabled"),(0,react.useEffect)(function(){if(!c)return u.current.deactivate(),void(u.current={activate:function(){},deactivate:function(){}});var e=i.current,r=createFocusTrap(n.current,{onActivate:void 0,initialFocus:a?function(){return(null==a?void 0:a.current)||e}:void 0,fallbackFocus:e,escapeDeactivates:!1,clickOutsideDeactivates:!1}),t=!1;u.current={activate:function(){try{return t?Promise.resolve():(t=!0,Promise.resolve(r.activate()).then(function(){return Promise.resolve(new Promise(function(e){return setTimeout(function(){return e(void 0)},0)})).then(function(){})}))}catch(e){return Promise.reject(e)}},deactivate:function(){t&&(t=!1,r.deactivate())}}},[c,i,a,n]),u}({targetRef:Ee,fallbackRef:Ce,initialFocusRef:j||void 0,enabled:se&&X&&!1!==j}),je=function(e){var n=e.getSnapPoints,i=e.heightRef,c=e.lastSnapRef,s=e.ready,l=function(e){var n=e.contentRef,i=e.controlledMaxHeight,c=e.footerEnabled,s=e.footerRef,l=e.headerEnabled,d=e.headerRef,f=e.registerReady,v=e.resizeSourceRef,m=(0,react.useMemo)(function(){return f("contentHeight")},[f]),p=function(e,n,i){var c=(0,react.useMemo)(function(){return n("maxHeight")},[n]),s=(0,react.useState)(function(){return w(e)||"undefined"!=typeof window?window.innerHeight:0}),l=s[0],d=s[1],f=l>0,v=(0,react.useRef)(0);return (0,react.useDebugValue)(e?"controlled":"auto"),(0,react.useEffect)(function(){f&&c()},[f,c]),O(function(){if(e)return d(w(e)),void(i.current="maxheightprop");var n=function(){v.current||(v.current=requestAnimationFrame(function(){d(window.innerHeight),i.current="window",v.current=0}))};return window.addEventListener("resize",n),d(window.innerHeight),i.current="window",c(),function(){window.removeEventListener("resize",n),cancelAnimationFrame(v.current)}},[e,c,i]),l}(i,f,v),y=D(d,{label:"headerHeight",enabled:l,resizeSourceRef:v}),h=D(n,{label:"contentHeight",enabled:!0,resizeSourceRef:v}),g=D(s,{label:"footerHeight",enabled:c,resizeSourceRef:v}),S=Math.min(p-y-g,h)+y+g;(0,react.useDebugValue)("minHeight: "+S);var E=h>0;return (0,react.useEffect)(function(){E&&m()},[E,m]),{maxHeight:p,minHeight:S,headerHeight:y,footerHeight:g}}({contentRef:e.contentRef,controlledMaxHeight:e.controlledMaxHeight,footerEnabled:e.footerEnabled,footerRef:e.footerRef,headerEnabled:e.headerEnabled,headerRef:e.headerRef,registerReady:e.registerReady,resizeSourceRef:e.resizeSourceRef}),d=l.maxHeight,f=l.minHeight,v=l.headerHeight,m=l.footerHeight,p=function(e,n){var r=[].concat(e).map(w).reduce(function(e,r){return e.add(N(r,0,n)),e},new Set),t=Array.from(r),o=Math.min.apply(Math,t);if(Number.isNaN(o))throw new TypeError("minSnap is NaN");var i=Math.max.apply(Math,t);if(Number.isNaN(i))throw new TypeError("maxSnap is NaN");return{snapPoints:t,minSnap:o,maxSnap:i}}(s?n({height:i.current,footerHeight:m,headerHeight:v,minHeight:f,maxHeight:d}):[0],d),y=p.snapPoints,h=p.minSnap,g=p.maxSnap;return (0,react.useDebugValue)("minSnap: "+h+", maxSnap:"+g),{minSnap:h,maxSnap:g,findSnap:function(e){var n=w("function"==typeof e?e({footerHeight:m,headerHeight:v,height:i.current,minHeight:f,maxHeight:d,snapPoints:y,lastSnap:c.current}):e);return y.reduce(function(e,r){return Math.abs(r-n)<Math.abs(e-n)?r:e},h)},maxHeight:d}}({contentRef:be,controlledMaxHeight:Z,footerEnabled:!!b,footerRef:xe,getSnapPoints:U,headerEnabled:!1!==R,headerRef:Re,heightRef:Oe,lastSnapRef:z,ready:se,registerReady:le,resizeSourceRef:Ne}),Ae=je.minSnap,Le=je.maxSnap,Te=je.maxHeight,Me=je.findSnap,Ie=(0,react.useRef)(Te),Fe=(0,react.useRef)(Ae),Ge=(0,react.useRef)(Le),Ze=(0,react.useRef)(Me),Be=(0,react.useRef)(0);O(function(){Ie.current=Te,Ge.current=Le,Fe.current=Ae,Ze.current=Me,Be.current=Me(J)},[Me,J,Te,Le,Ae]);var qe=(0,react.useCallback)(function(e){var n=e.onRest,r=e.config,t=(r=void 0===r?{}:r).velocity,o=void 0===t?1:t,i=C(r,T),a=C(e,M);return new Promise(function(e){return Se(x({},a,{config:x({velocity:o},i,{mass:1,tension:F,friction:Math.max(index_es_G,index_es_G+(index_es_G-index_es_G*o))}),onRest:function(){var r=[].slice.call(arguments);e.apply(void 0,r),null==n||n.apply(void 0,r)}}))})},[Se]),Ve=useMachine(A,{devTools:!1,actions:{onOpenCancel:(0,react.useCallback)(function(){return null==ve.current?void 0:ve.current({type:"OPEN"})},[]),onSnapCancel:(0,react.useCallback)(function(e){return null==ve.current?void 0:ve.current({type:"SNAP",source:e.snapSource})},[]),onCloseCancel:(0,react.useCallback)(function(){return null==ve.current?void 0:ve.current({type:"CLOSE"})},[]),onResizeCancel:(0,react.useCallback)(function(){return null==ve.current?void 0:ve.current({type:"RESIZE",source:Ne.current})},[]),onOpenEnd:(0,react.useCallback)(function(){return null==me.current?void 0:me.current({type:"OPEN"})},[]),onSnapEnd:(0,react.useCallback)(function(e,n){return null==me.current?void 0:me.current({type:"SNAP",source:e.snapSource})},[]),onResizeEnd:(0,react.useCallback)(function(){return null==me.current?void 0:me.current({type:"RESIZE",source:Ne.current})},[])},context:{initialState:k},services:{onSnapStart:(0,react.useCallback)(function(e,n){try{return Promise.resolve(null==fe.current?void 0:fe.current({type:"SNAP",source:n.payload.source||"custom"}))}catch(e){return Promise.reject(e)}},[]),onOpenStart:(0,react.useCallback)(function(){try{return Promise.resolve(null==fe.current?void 0:fe.current({type:"OPEN"}))}catch(e){return Promise.reject(e)}},[]),onCloseStart:(0,react.useCallback)(function(){try{return Promise.resolve(null==fe.current?void 0:fe.current({type:"CLOSE"}))}catch(e){return Promise.reject(e)}},[]),onResizeStart:(0,react.useCallback)(function(){try{return Promise.resolve(null==fe.current?void 0:fe.current({type:"RESIZE",source:Ne.current}))}catch(e){return Promise.reject(e)}},[]),onSnapEnd:(0,react.useCallback)(function(e,n){try{return Promise.resolve(null==me.current?void 0:me.current({type:"SNAP",source:e.snapSource}))}catch(e){return Promise.reject(e)}},[]),onOpenEnd:(0,react.useCallback)(function(){try{return Promise.resolve(null==me.current?void 0:me.current({type:"OPEN"}))}catch(e){return Promise.reject(e)}},[]),onCloseEnd:(0,react.useCallback)(function(){try{return Promise.resolve(null==me.current?void 0:me.current({type:"CLOSE"}))}catch(e){return Promise.reject(e)}},[]),onResizeEnd:(0,react.useCallback)(function(){try{return Promise.resolve(null==me.current?void 0:me.current({type:"RESIZE",source:Ne.current}))}catch(e){return Promise.reject(e)}},[]),renderVisuallyHidden:(0,react.useCallback)(function(e,n){try{return Promise.resolve(qe({y:Be.current,ready:0,maxHeight:Ie.current,maxSnap:Ge.current,minSnap:Be.current,immediate:!0})).then(function(){})}catch(e){return Promise.reject(e)}},[qe]),activate:(0,react.useCallback)(function(e,n){try{return de.current=!0,Promise.resolve(Promise.all([De.current.activate(),ze.current.activate(),ke.current.activate()])).then(function(){})}catch(e){return Promise.reject(e)}},[ke,ze,De]),deactivate:(0,react.useCallback)(function(){try{return De.current.deactivate(),ze.current.deactivate(),ke.current.deactivate(),de.current=!1,Promise.resolve()}catch(e){return Promise.reject(e)}},[ke,ze,De]),openImmediately:(0,react.useCallback)(function(){try{return Oe.current=Be.current,Promise.resolve(qe({y:Be.current,ready:1,maxHeight:Ie.current,maxSnap:Ge.current,minSnap:Be.current,immediate:!0})).then(function(){})}catch(e){return Promise.reject(e)}},[qe]),openSmoothly:(0,react.useCallback)(function(){try{return Promise.resolve(qe({y:0,ready:1,maxHeight:Ie.current,maxSnap:Ge.current,minSnap:Be.current,immediate:!0})).then(function(){return Oe.current=Be.current,Promise.resolve(qe({y:Be.current,ready:1,maxHeight:Ie.current,maxSnap:Ge.current,minSnap:Be.current,immediate:He.current})).then(function(){})})}catch(e){return Promise.reject(e)}},[qe,He]),snapSmoothly:(0,react.useCallback)(function(e,n){try{var r=Ze.current(e.y);return Oe.current=r,z.current=r,Promise.resolve(qe({y:r,ready:1,maxHeight:Ie.current,maxSnap:Ge.current,minSnap:Fe.current,immediate:He.current,config:{velocity:e.velocity}})).then(function(){})}catch(e){return Promise.reject(e)}},[qe,z,He]),resizeSmoothly:(0,react.useCallback)(function(){try{var e=Ze.current(Oe.current);return Oe.current=e,z.current=e,Promise.resolve(qe({y:e,ready:1,maxHeight:Ie.current,maxSnap:Ge.current,minSnap:Fe.current,immediate:"element"!==Ne.current||He.current})).then(function(){})}catch(e){return Promise.reject(e)}},[qe,z,He]),closeSmoothly:(0,react.useCallback)(function(e,n){try{return qe({minSnap:Oe.current,immediate:!0}),Oe.current=0,Promise.resolve(qe({y:0,maxHeight:Ie.current,maxSnap:Ge.current,immediate:He.current})).then(function(){return Promise.resolve(qe({ready:0,immediate:!0})).then(function(){})})}catch(e){return Promise.reject(e)}},[qe,He])}}),Ke=Ve[0],Je=Ve[1];(0,react.useEffect)(function(){se&&Je(H?"OPEN":"CLOSE")},[H,Je,se]),O(function(){(Te||Le||Ae)&&Je("RESIZE")},[Te,Le,Ae,Je]),(0,react.useEffect)(function(){return function(){De.current.deactivate(),ze.current.deactivate(),ke.current.deactivate()}},[ke,ze,De]),(0,react.useImperativeHandle)(i,function(){return{snapTo:function(e,n){var r=void 0===n?{}:n,t=r.velocity,o=void 0===t?1:t,i=r.source,a=void 0===i?"custom":i;Je("SNAP",{payload:{y:Ze.current(e),velocity:o,source:a}})},get height(){return Oe.current}}},[Je]),(0,react.useEffect)(function(){var e=Pe.current,n=function(e){we.current&&e.preventDefault()},r=function(n){e.scrollTop<0&&(requestAnimationFrame(function(){e.style.overflow="hidden",e.scrollTop=0,e.style.removeProperty("overflow")}),n.preventDefault())};return ae&&(e.addEventListener("scroll",n),e.addEventListener("touchmove",n),e.addEventListener("touchstart",r)),function(){e.removeEventListener("scroll",n),e.removeEventListener("touchmove",n),e.removeEventListener("touchstart",r)}},[ae,Pe]);var Qe=useDrag(function(e){var n=e.args,r=(n=void 0===n?[]:n)[0],t=(r=void 0===r?{}:r).closeOnTap,o=void 0!==t&&t,i=r.isContentDragging,a=void 0!==i&&i,c=e.cancel,u=e.direction[1],s=e.down,l=e.first,d=e.last,f=e.memo,v=void 0===f?ge.y.getValue():f,m=e.tap,p=e.velocity,y=-1*e.movement[1];if(!de.current)return c(),v;if(I&&o&&m)return c(),setTimeout(function(){return I()},0),v;if(m)return v;var g=v+y,S=y*p,E=Math.max(Fe.current,Math.min(Ge.current,g+2*S));if(!s&&I&&u>0&&g+S<Fe.current/2)return c(),I(),v;var P=s?I||Fe.current!==Ge.current?rubberbandIfOutOfBounds(g,I?0:Fe.current,Ge.current,.55):g<Fe.current?rubberbandIfOutOfBounds(g,Fe.current,2*Ge.current,.55):rubberbandIfOutOfBounds(g,Fe.current/2,Ge.current,.55):E;return ae&&a?(P>=Ge.current&&(P=Ge.current),v===Ge.current&&Pe.current.scrollTop>0&&(P=Ge.current),we.current=P<Ge.current):we.current=!1,l&&Je("DRAG"),d?(Je("SNAP",{payload:{y:P,velocity:p>.05?p:1,source:"dragging"}}),v):(Se({y:P,ready:1,maxHeight:Ie.current,maxSnap:Ge.current,minSnap:Fe.current,immediate:!0,config:{velocity:p}}),v)},{filterTaps:!0});if(Number.isNaN(Ge.current))throw new TypeError("maxSnapRef is NaN!!");if(Number.isNaN(Fe.current))throw new TypeError("minSnapRef is NaN!!");var Ue=function(e){var n,r=e.spring,t=interpolate$1([r.y,r.maxHeight],function(e,n){return Math.round(N(n-e,0,16))+"px"}),o=interpolate$1([r.y,r.minSnap,r.maxSnap],function(e,n,r){return N(e,n,r)+"px"}),i=interpolate$1([r.y,r.minSnap,r.maxSnap],function(e,n,r){return e<n?n-e+"px":e>r?r-e+"px":"0px"}),a=interpolate$1([r.y,r.maxSnap],function(e,n){return e>=n?Math.ceil(e-n):0}),c=interpolate$1([r.y,r.minSnap],function(e,n){if(!n)return 0;var r=Math.max(n/2-45,0);return N((e-r)*(1/(Math.min(n/2+45,n)-r)+0),0,1)}),u=interpolate$1([r.y,r.minSnap],function(e,n){return n?N(e/n,0,1):0});return(n={})["--rsbs-content-opacity"]=c,n["--rsbs-backdrop-opacity"]=u,n["--rsbs-antigap-scale-y"]=a,n["--rsbs-overlay-translate-y"]=i,n["--rsbs-overlay-rounded"]=t,n["--rsbs-overlay-h"]=o,n}({spring:ge});/*#__PURE__*/return react.createElement(extendedAnimated.div,x({},ce,{"data-rsbs-root":!0,"data-rsbs-state":B.find(Ke.matches),"data-rsbs-is-blocking":X,"data-rsbs-is-dismissable":!!I,"data-rsbs-has-header":!!R,"data-rsbs-has-footer":!!b,className:P,ref:Ee,style:x({},Ue,_,{opacity:ge.ready})}),p,X&&/*#__PURE__*/react.createElement("div",x({key:"backdrop","data-rsbs-backdrop":!0},Qe({closeOnTap:!0}))),/*#__PURE__*/react.createElement("div",{key:"overlay","aria-modal":"true",role:"dialog","data-rsbs-overlay":!0,tabIndex:-1,ref:Ce,onKeyDown:function(e){"Escape"===e.key&&(e.stopPropagation(),I&&I())}},!1!==R&&/*#__PURE__*/react.createElement("div",x({key:"header","data-rsbs-header":!0,ref:Re},Qe()),R),/*#__PURE__*/react.createElement("div",x({key:"scroll","data-rsbs-scroll":!0,ref:Pe},ae?Qe({isContentDragging:!0}):{}),/*#__PURE__*/react.createElement("div",{"data-rsbs-content":!0,ref:be},l)),b&&/*#__PURE__*/react.createElement("div",x({key:"footer",ref:xe,"data-rsbs-footer":!0},Qe()),b)))}),B=["closed","opening","open","closing","dragging","snapping","resizing"];function q(e){var n=e.lastSnap;return null!=n?n:Math.min.apply(Math,e.snapPoints)}function V(e){return e.minHeight}var K=["onSpringStart","onSpringEnd","skipInitialTransition"],J=(0,react.forwardRef)(function(t,o){var i=t.onSpringStart,u=t.onSpringEnd,s=t.skipInitialTransition,l=C(t,K),d=(0,react.useState)(!1),f=d[0],v=d[1],m=(0,react.useRef)(),p=(0,react.useRef)(null),y=(0,react.useRef)(s&&l.open?"OPEN":"CLOSED");O(function(){if(l.open)return cancelAnimationFrame(m.current),v(!0),function(){y.current="CLOSED"}},[l.open]);var h=(0,react.useCallback)(function(e){return Promise.resolve(null==i?void 0:i(e)).then(function(){"OPEN"===e.type&&cancelAnimationFrame(m.current)})},[i]),g=(0,react.useCallback)(function(e){return Promise.resolve(null==u?void 0:u(e)).then(function(){"CLOSE"===e.type&&(m.current=requestAnimationFrame(function(){return v(!1)}))})},[u]);return f?/*#__PURE__*/react.createElement(reach_portal_esm,{"data-rsbs-portal":!0},/*#__PURE__*/react.createElement(Z,x({},l,{lastSnapRef:p,ref:o,initialState:y.current,onSpringStart:h,onSpringEnd:g}))):null});
//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactSpringBottomSheet/styles.ts

function ReactSpringBottomSheet_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  [data-rsbs-header] {\n    padding: ",
        ';\n    &::before {\n      content: "";\n      ',
        "\n\n      display: ",
        "\n    }\n  }\n\n  [data-rsbs-overlay] {\n    height: ",
        ";\n  }\n\n  [data-rsbs-overlay],\n  [data-rsbs-backdrop],\n  [data-rsbs-root]:after {\n    z-index: 6;\n  }\n"
    ]);
    ReactSpringBottomSheet_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: ",
        ";\n    "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: ",
        ";\n      max-height: ",
        ";\n    "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: ",
        ";\n    "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n\n  height: ",
        ";\n  display: ",
        ";\n  flex-direction: ",
        ";\n  align-items: ",
        ";\n  width: 100vw;\n  ",
        ";\n  overflow-y: ",
        ";\n\n  margin-bottom: ",
        ";\n\n  /* @media (max-height: 820px) {\n    margin-bottom: ",
        ";\n  }\n\n  @media (max-height: 738px) {\n    margin-bottom: 18rem;\n  }\n\n  @media (max-height: 677px) {\n    margin-bottom: 24rem;\n  }\n\n  @media (max-height: 518px) {\n    margin-bottom: ",
        ";\n  } */\n\n  @media ",
        " {\n    padding: ",
        ";\n  }\n\n  ",
        ";\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: ",
        ";\n  padding: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  background: ",
        ";\n  position: fixed;\n  top: 8px;\n  right: 8px;\n  z-index: 4;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  width: 100%;\n  height: 3rem;\n  border-radius: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  padding: 0.65rem 0;\n  cursor: pointer;\n  border: 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: ",
        ";\n  height: ",
        ";\n  display: flex;\n  transition: all 0.3s ease-in-out;\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n\n  &:not(:disabled):hover {\n    background: ",
        ";\n  }\n\n  &:focus {\n    border: thin solid ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: ",
        ";\n  height: ",
        ";\n  width: ",
        ";\n  border: 1px solid\n    ",
        ";\n  border-radius: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  display: flex;\n  transition: all 0.3s ease-in-out;\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    border: thin solid ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  width: 100%;\n  height: 6rem;\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  position: fixed;\n  bottom: 0px;\n  transition: all 0.4s ease-in-out;\n  background: ",
        ";\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  -webkit-box-shadow: 0px 0px 12px 1px ",
        ";\n  box-shadow: 0px 0px 12px 1px ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var BottomSheetContainer = (0,styled_components_browser_esm/* default */.ZP)(J).withConfig({
    displayName: "styles__BottomSheetContainer",
    componentId: "sc-10da199c-0"
})(ReactSpringBottomSheet_styles_templateObject(), function(param) {
    var headerpadding = param.headerpadding;
    return headerpadding || "20px 16px 8px";
}, function(param) {
    var omitHeader = param.omitHeader;
    return omitHeader && "margin-top: 4px;";
}, function(param) {
    var hideheaderline = param.hideheaderline;
    return hideheaderline === "true" ? "none" : "block";
}, function(param) {
    var containerHeight = param.containerHeight;
    return containerHeight;
});
var BottomSheetContent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__BottomSheetContent",
    componentId: "sc-10da199c-1"
})(styles_templateObject4(), function(param) {
    var noFooter = param.noFooter;
    return noFooter ? "".concat(ui.theme.space.x0, " ").concat(ui.theme.space.x4, " calc( 100% + 50px)") : "".concat(ui.theme.space.x2, " ").concat(ui.theme.space.x8, " calc( 100% + 50px)");
}, function(param) {
    var noFooter = param.noFooter;
    return !noFooter && "auto";
}, function(param) {
    var display = param.display;
    return display || "block";
}, function(param) {
    var display = param.display;
    return display && "column";
}, function(param) {
    var alignItems = param.alignItems;
    return alignItems;
}, function(param) {
    var noFooter = param.noFooter, omitHeader = param.omitHeader;
    return noFooter && !omitHeader && "max-height: 50vh;";
}, function(param) {
    var noFooter = param.noFooter, hasOverflow = param.hasOverflow;
    return noFooter || hasOverflow ? "auto" : "visible";
}, function(param) {
    var noFooter = param.noFooter, isSafari = param.isSafari;
    return noFooter ? "".concat(ui.theme.space.x0) : isSafari ? "10rem" : "20%";
}, function(param) {
    var noFooter = param.noFooter;
    return noFooter ? "".concat(ui.theme.space.x0) : "".concat(ui.theme.space.x60);
}, function(param) {
    var noFooter = param.noFooter;
    return noFooter ? "".concat(ui.theme.space.x0) : "".concat(ui.theme.space.x60);
}, ui.theme.device.desktopFirst.mobileS, function(param) {
    var noFooter = param.noFooter;
    return noFooter && "".concat(ui.theme.space.x0);
}, function(param) {
    var padding = param.padding;
    return padding && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject1(), padding);
}, function(param) {
    var height = param.height, maxHeight = param.maxHeight;
    return height && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject2(), height || "100%", maxHeight || height);
}, function(param) {
    var marginBottom = param.marginBottom;
    return marginBottom && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject3(), marginBottom);
});
var HeaderBottomSheet = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "styles__HeaderBottomSheet",
    componentId: "sc-10da199c-2"
})(styles_templateObject5(), function(param) {
    var justifyContent = param.justifyContent;
    return justifyContent || "center";
}, function(param) {
    var padding = param.padding;
    return padding || "1.25rem";
});
var TitleBottomSheet = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__TitleBottomSheet",
    componentId: "sc-10da199c-3"
})(styles_templateObject6(), function(param) {
    var titleFontSize = param.titleFontSize;
    return titleFontSize || "1.35rem";
}, function(param) {
    var titleColor = param.titleColor;
    return titleColor || ui.theme.colors.neutral[550];
}, function(param) {
    var titleFontWeight = param.titleFontWeight;
    return titleFontWeight || ui.theme.typography.fontWeight[600];
}, function(param) {
    var titleFontFamily = param.titleFontFamily;
    return titleFontFamily || ui.theme.typography.fontFamily.barlow;
});
var TopBackdropBottomSheet = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TopBackdropBottomSheet",
    componentId: "sc-10da199c-4"
})(_templateObject7(), ui.theme.colors.neutral[825]);
var Close = (0,styled_components_browser_esm/* default */.ZP)(ui.CloseIcon).attrs({
    color: ui.theme.colors.neutral[315],
    width: 24,
    height: 24
}).withConfig({
    displayName: "styles__Close",
    componentId: "sc-10da199c-5"
})(_templateObject8());
var BaseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__BaseButton",
    componentId: "sc-10da199c-6"
})(_templateObject9(), function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius || "8px";
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight || 700;
});
var ConfirmButton = (0,styled_components_browser_esm/* default */.ZP)(BaseButton).withConfig({
    displayName: "styles__ConfirmButton",
    componentId: "sc-10da199c-7"
})(_templateObject10(), ui.theme.colors.secondary[250], ui.theme.colors.neutral.white, function(param) {
    var height = param.height;
    return height || "3rem";
}, ui.theme.colors.secondary[350], ui.theme.colors.secondary[350]);
var SecondaryButton = (0,styled_components_browser_esm/* default */.ZP)(BaseButton).withConfig({
    displayName: "styles__SecondaryButton",
    componentId: "sc-10da199c-8"
})(_templateObject11(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || ui.theme.colors.neutral.white;
}, function(param) {
    var fontColor = param.fontColor;
    return fontColor || ui.theme.colors.secondary[250];
}, function(param) {
    var height = param.height;
    return height || "3rem";
}, function(param) {
    var width = param.width;
    return width || "100%";
}, function(param) {
    var borderColor = param.borderColor;
    return borderColor || ui.theme.colors.secondary[250];
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius || "8px";
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize || "1rem";
}, function(param) {
    var fontWeight = param.fontWeight;
    return "".concat(fontWeight || 500, " !important");
}, ui.theme.colors.secondary[350]);
var FooterBottomSheet = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    displayName: "styles__FooterBottomSheet",
    componentId: "sc-10da199c-9"
})(_templateObject12(), function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "1rem ".concat(ui.theme.space.x4);
}, ui.theme.colors.neutral.white, ui.theme.colors.neutral["999-opacity-15"], ui.theme.colors.neutral["999-opacity-15"]);
var HeaderActionText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__HeaderActionText",
    componentId: "sc-10da199c-10"
})(_templateObject13(), function(param) {
    var headerActionColor = param.headerActionColor;
    return headerActionColor || ui.theme.colors.primary[350];
}, function(param) {
    var headerActionFontFamily = param.headerActionFontFamily;
    return headerActionFontFamily || ui.theme.typography.fontFamily.chivo;
}, function(param) {
    var headerActionFontSize = param.headerActionFontSize;
    return headerActionFontSize || "".concat(ui.theme.typography.fontSize.sm.x5);
}, function(param) {
    var headerActionFontWeight = param.headerActionFontWeight;
    return headerActionFontWeight || ui.theme.typography.fontWeight[400];
});

;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactSpringBottomSheet/index.tsx







var ReactSpringBottomSheet = function(param) {
    var title = param.title, textButton = param.textButton, onActionTextButton = param.onActionTextButton, formId = param.formId, typeButtonFooter = param.typeButtonFooter, stateBottomSheet = param.stateBottomSheet, children = param.children, onDismiss = param.onDismiss, onCloseBottomSheet = param.onCloseBottomSheet, onClickFooterButton = param.onClickFooterButton, hasSuccessfully = param.hasSuccessfully, _size = param.size, size = _size === void 0 ? "large" : _size, _autoFocus = param.autoFocus, autoFocus = _autoFocus === void 0 ? false : _autoFocus, noFooter = param.noFooter, omitHeader = param.omitHeader, hasActionInHeader = param.hasActionInHeader, titleFontSize = param.titleFontSize, titleColor = param.titleColor, titleFontFamily = param.titleFontFamily, titleFontWeight = param.titleFontWeight, justifyContent = param.justifyContent, boxShadow = param.boxShadow, padding = param.padding, hasCloseButton = param.hasCloseButton, headerAction = param.headerAction, headerActionColor = param.headerActionColor, headerActionFontSize = param.headerActionFontSize, containerHeight = param.containerHeight, headerActionFontFamily = param.headerActionFontFamily, headerActionFontWeight = param.headerActionFontWeight, paddingContent = param.paddingContent, heightContent = param.heightContent, display = param.display, alignItems = param.alignItems, buttonBorderRadius = param.buttonBorderRadius, isButtonDisabled = param.isButtonDisabled, buttonFontSize = param.buttonFontSize, buttonFontWeight = param.buttonFontWeight, marginBottomContent = param.marginBottomContent, _hideheaderline = param.hideheaderline, hideheaderline = _hideheaderline === void 0 ? false : _hideheaderline, headerpadding = param.headerpadding, bottomHeight = param.bottomHeight, hasOverflow = param.hasOverflow, isSafari = param.isSafari, buttonHeight = param.buttonHeight, secondaryButton = param.secondaryButton, maxHeightContent = param.maxHeightContent, footerPadding = param.footerPadding;
    var ref = (0,react.useState)(false), buttonOnAction = ref[0], setButtonOnAction = ref[1];
    var bottomSheet = (0,react.useRef)();
    var calculateHeight = {
        large: 1.125,
        medium: 1.5,
        small: 1.5
    };
    var handleClickFooterButton = function() {
        setButtonOnAction(true);
        if (onClickFooterButton) onClickFooterButton();
        if (hasSuccessfully) {
            onCloseBottomSheet();
        }
    };
    (0,react.useEffect)(function() {
        if (hasSuccessfully && buttonOnAction) {
            setButtonOnAction(false);
        }
        return function() {
            setButtonOnAction(false);
        };
    }, [
        hasSuccessfully,
        buttonOnAction
    ]);
    var noFooterMaxHeight = noFooter ? 465 : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheetContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        isSafari: isSafari,
        maxHeight: bottomHeight !== null && bottomHeight !== void 0 ? bottomHeight : noFooterMaxHeight
    }, (0,application/* buildTestIds */.Fek)("bottom-sheet-container")), {
        ref: bottomSheet,
        open: stateBottomSheet,
        onDismiss: onDismiss,
        containerHeight: containerHeight,
        sibling: stateBottomSheet && hasCloseButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBackdropBottomSheet, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("top-backdrop-bottom-sheet")), {
            onClick: onCloseBottomSheet,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {})
        })),
        defaultSnap: function(param) {
            var maxHeight = param.maxHeight;
            return maxHeight;
        },
        snapPoints: function(param) {
            var maxHeight = param.maxHeight;
            return [
                maxHeight / calculateHeight[size], 
            ];
        },
        hideheaderline: hideheaderline.toString(),
        headerpadding: headerpadding,
        header: omitHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderBottomSheet, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            padding: padding,
            boxShadow: boxShadow,
            justifyContent: justifyContent
        }, (0,application/* buildTestIds */.Fek)("header-bottom-sheet")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBottomSheet, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("title-bottom-sheet")), {
                    titleColor: titleColor,
                    titleFontFamily: titleFontFamily,
                    titleFontWeight: titleFontWeight,
                    titleFontSize: titleFontSize,
                    children: title
                })),
                hasActionInHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderActionText, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("header-action-text")), {
                    onClick: headerAction,
                    headerActionColor: headerActionColor,
                    headerActionFontFamily: headerActionFontFamily,
                    headerActionFontSize: headerActionFontSize,
                    headerActionFontWeight: headerActionFontWeight,
                    children: onActionTextButton !== null && onActionTextButton !== void 0 ? onActionTextButton : textButton
                })) : null
            ]
        })),
        expandOnContentDrag: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheetContent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    isSafari: isSafari,
                    display: display,
                    alignItems: alignItems,
                    height: heightContent,
                    marginBottom: marginBottomContent,
                    padding: paddingContent,
                    noFooter: noFooter,
                    omitHeader: omitHeader,
                    hasOverflow: hasOverflow,
                    maxHeight: maxHeightContent
                }, (0,application/* buildTestIds */.Fek)("bottom-sheet-content")), {
                    children: children
                })),
                noFooter ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterBottomSheet, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    padding: footerPadding || paddingContent
                }, (0,application/* buildTestIds */.Fek)("footer-bottom-sheet")), {
                    children: [
                        secondaryButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-button")), {
                            type: "button",
                            onClick: secondaryButton.onClick,
                            fontSize: buttonFontSize,
                            fontWeight: secondaryButton.fontWeight || buttonFontWeight,
                            borderRadius: secondaryButton.borderRadius,
                            disabled: secondaryButton.isDisabled,
                            height: buttonHeight,
                            children: secondaryButton.text
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("confirm-button")), {
                            type: typeButtonFooter !== null && typeButtonFooter !== void 0 ? typeButtonFooter : "submit",
                            form: formId,
                            onClick: handleClickFooterButton,
                            autoFocus: autoFocus,
                            fontSize: buttonFontSize,
                            fontWeight: buttonFontWeight,
                            borderRadius: buttonBorderRadius,
                            disabled: isButtonDisabled,
                            height: buttonHeight,
                            children: buttonOnAction && onActionTextButton ? onActionTextButton : textButton
                        }))
                    ]
                }))
            ]
        })
    }));
};


// EXTERNAL MODULE: ../../node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(14080);
// EXTERNAL MODULE: ../../node_modules/react-loading-skeleton/dist/skeleton.css
var skeleton = __webpack_require__(7925);
// EXTERNAL MODULE: ../../packages/infra/components/lib/ReactLoadingSkeleton/style.ts
var ReactLoadingSkeleton_style = __webpack_require__(9542);
;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactLoadingSkeleton/index.tsx
/* eslint-disable react/no-array-index-key */ 







var Box = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactLoadingSkeleton_style/* BoxContainer */.K3, {
        children: children
    });
};
var ReactLoadingSkeleton = function(param) {
    var count = param.count, _type = param.type, type = _type === void 0 ? "basic" : _type, _width = param.width, width = _width === void 0 ? "100%" : _width, _height = param.height, height = _height === void 0 ? 30 : _height, gap = param.gap, _inline = param.inline, inline = _inline === void 0 ? false : _inline, style = param.style, justifyContent = param.justifyContent, _hasMargin = param.hasMargin, hasMargin = _hasMargin === void 0 ? true : _hasMargin;
    var templates = {
        basic: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
            wrapper: Box,
            count: count,
            width: width,
            height: height,
            inline: inline
        }),
        button: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
            wrapper: Box,
            count: count,
            width: width || "150px",
            height: height || "4rem",
            inline: inline,
            borderRadius: "4px"
        }),
        card: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactLoadingSkeleton_style/* SkeletonFlexContainer */.kt, {
            gap: gap,
            children: Array(count).fill(1).map(function(_, index) {
                var fakeIndex = index;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactLoadingSkeleton_style/* SkeletonCardWrapper */.sD, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        width: width,
                        height: height
                    })
                }, fakeIndex);
            })
        }),
        productListGridCard: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactLoadingSkeleton_style/* SkeletonFlexContainer */.kt, {
            style: (0,src_object_spread/* default */.Z)({}, style),
            gap: gap,
            children: Array(count).fill(1).map(function(_, index) {
                var fakeIndex = index;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    width: width,
                    height: height,
                    borderRadius: "8px"
                }, fakeIndex);
            })
        }),
        "card-user": /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactLoadingSkeleton_style/* SkeletonFlexContainer */.kt, {
            justifyContent: justifyContent,
            children: Array(count).fill(1).map(function(_, index) {
                var fakeIndex = index;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReactLoadingSkeleton_style/* SkeletonCardWrapper */.sD, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactLoadingSkeleton_style/* SkeletonCircle */.s7, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            width: width,
                            height: height
                        })
                    ]
                }, fakeIndex);
            })
        }),
        chip: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactLoadingSkeleton_style/* SkeletonFlexContainer */.kt, {
            children: Array(count).fill(1).map(function(_, index) {
                var fakeIndex = index;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactLoadingSkeleton_style/* SkeletonChip */.rA, {}, fakeIndex);
            })
        }),
        user: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactLoadingSkeleton_style/* ItemWrapper */.f$, {
            children: Array(count).fill(1).map(function(_, index) {
                var fakeIndex = index;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactLoadingSkeleton_style/* SkeletonContainer */.Fh, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReactLoadingSkeleton_style/* SkeletonFlexContainer */.kt, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                style: {
                                    marginRight: "10px"
                                },
                                width: "50px",
                                height: "50px",
                                borderRadius: "400px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReactLoadingSkeleton_style/* SkeletonFlexContainer */.kt, {
                                flexDirection: "column",
                                gap: ui.theme.space.x1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        width: "300px",
                                        height: "16px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        width: "125px",
                                        height: "16px"
                                    })
                                ]
                            })
                        ]
                    })
                }, fakeIndex);
            })
        }),
        standardLibrary: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
            width: width,
            height: height
        }),
        sidebarFilters: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactLoadingSkeleton_style/* SkeletonFlexContainer */.kt, {
            gap: gap,
            marginBottom: "25px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReactLoadingSkeleton_style/* SkeletonCardWrapper */.sD, {
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        width: "120px",
                        height: "22px",
                        style: {
                            marginBottom: "20px"
                        }
                    }),
                    Array(count).fill(1).map(function(_, index) {
                        var fakeIndex = index;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReactLoadingSkeleton_style/* SkeletonFlexContainer */.kt, {
                            gap: "20px",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: "18px",
                                    style: (0,src_object_spread/* default */.Z)({}, style)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    width: "30px",
                                    height: "18px",
                                    style: {
                                        borderRadius: "10px"
                                    }
                                })
                            ]
                        }, fakeIndex);
                    })
                ]
            })
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactLoadingSkeleton_style/* SkeletonWrapper */.nR, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        hasMargin: hasMargin
    }, (0,application/* buildTestIds */.Fek)("skeleton-container")), {
        children: templates["".concat(type)]
    }));
};
/* harmony default export */ var lib_ReactLoadingSkeleton = ((/* unused pure expression or super */ null && (ReactLoadingSkeleton)));

// EXTERNAL MODULE: ../../node_modules/react-modal/lib/index.js
var lib = __webpack_require__(37149);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactModal/index.tsx





var defaultStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "4px"
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        zIndex: 999
    }
};
// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
if (true) {
    try {
        lib_default().setAppElement("#__next");
    } catch (e) {
        lib_default().setAppElement("body");
    }
}
var ReactModal = function(param) {
    var children = param.children, styles = param.styles, isOpen = param.isOpen, contentLabel = param.contentLabel, _preventScroll = param.preventScroll, preventScroll = _preventScroll === void 0 ? false : _preventScroll, _testId = param.testId, testId = _testId === void 0 ? undefined : _testId, onCloseModal = param.onCloseModal, ariaHideApp = param.ariaHideApp, _shouldCloseOnOverlayClick = param.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _shouldCloseOnOverlayClick === void 0 ? true : _shouldCloseOnOverlayClick, onAfterClose = param.onAfterClose, onAfterOpen = param.onAfterOpen;
    document.body.style.overflow = isOpen ? "hidden" : "unset";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)(testId !== null && testId !== void 0 ? testId : "modal")), {
        isOpen: isOpen,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        onRequestClose: onCloseModal,
        ariaHideApp: ariaHideApp,
        style: styles ? (0,src_object_spread/* default */.Z)({}, {
            content: (0,src_object_spread/* default */.Z)({}, defaultStyles.content, styles.content)
        }, {
            overlay: (0,src_object_spread/* default */.Z)({}, defaultStyles.overlay, styles.overlay)
        }) : (0,src_object_spread/* default */.Z)({}, defaultStyles),
        contentLabel: contentLabel,
        preventScroll: preventScroll,
        testId: testId,
        closeTimeoutMS: 300,
        onAfterClose: onAfterClose,
        onAfterOpen: onAfterOpen,
        children: children
    }));
};


// EXTERNAL MODULE: ../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(83619);
// EXTERNAL MODULE: ../../node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(11445);
;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactResponsiveCarousel/index.tsx






var ReactResponsiveCarousel = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Carousel, _object_spread_props(_object_spread({}, props), {
        showStatus: false,
        showThumbs: false,
        preventMovementUntilSwipeScrollTolerance: true,
        swipeScrollTolerance: 15,
        children: children
    }));
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(23467);
// EXTERNAL MODULE: ../../node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(81192);
// EXTERNAL MODULE: ../../node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(63201);
;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactSlick/index.tsx









var ReactSlick = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var children = _param.children, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("react-slick-slider"), restProps), {
        children: children
    }));
});
ReactSlick.displayName = "ReactSlick";


;// CONCATENATED MODULE: ../../node_modules/ssr-window/ssr-window.esm.js
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */
/* eslint-disable no-param-reassign */
function ssr_window_esm_isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target = {}, src = {}) {
    Object.keys(src).forEach((key) => {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (ssr_window_esm_isObject(src[key]) &&
            ssr_window_esm_isObject(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

const ssrDocument = {
    body: {},
    addEventListener() { },
    removeEventListener() { },
    activeElement: {
        blur() { },
        nodeName: '',
    },
    querySelector() {
        return null;
    },
    querySelectorAll() {
        return [];
    },
    getElementById() {
        return null;
    },
    createEvent() {
        return {
            initEvent() { },
        };
    },
    createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() { },
            getElementsByTagName() {
                return [];
            },
        };
    },
    createElementNS() {
        return {};
    },
    importNode() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function ssr_window_esm_getDocument() {
    const doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}

const ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState() { },
        pushState() { },
        go() { },
        back() { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener() { },
    removeEventListener() { },
    getComputedStyle() {
        return {
            getPropertyValue() {
                return '';
            },
        };
    },
    Image() { },
    Date() { },
    screen: {},
    setTimeout() { },
    clearTimeout() { },
    matchMedia() {
        return {};
    },
    requestAnimationFrame(callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame(id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function ssr_window_esm_getWindow() {
    const win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}



;// CONCATENATED MODULE: ../../node_modules/dom7/dom7.esm.js
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */


/* eslint-disable no-proto */
function makeReactive(obj) {
  const proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get() {
      return proto;
    },

    set(value) {
      proto.__proto__ = value;
    }

  });
}

class Dom7 extends Array {
  constructor(items) {
    if (typeof items === 'number') {
      super(items);
    } else {
      super(...(items || []));
      makeReactive(this);
    }
  }

}

function arrayFlat(arr = []) {
  const res = [];
  arr.forEach(el => {
    if (Array.isArray(el)) {
      res.push(...arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  const uniqueArray = [];

  for (let i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, (match, group) => group.toUpperCase());
}

// eslint-disable-next-line

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  const a = [];
  const res = context.querySelectorAll(selector);

  for (let i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function dom7_esm_$(selector, context) {
  const window = ssr_window_esm_getWindow();
  const document = ssr_window_esm_getDocument();
  let arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    const html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      let toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      const tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (let i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

dom7_esm_$.fn = Dom7.prototype;

// eslint-disable-next-line

function addClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.add(...classNames);
  });
  return this;
}

function removeClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.remove(...classNames);
  });
  return this;
}

function toggleClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    classNames.forEach(className => {
      el.classList.toggle(className);
    });
  });
}

function hasClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  return arrayFilter(this, el => {
    return classNames.filter(className => el.classList.contains(className)).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (let i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (const attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (let i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        for (const propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }

    return this;
  }

  return this;
}

function data(key, value) {
  let el;

  if (typeof value === 'undefined') {
    el = this[0];
    if (!el) return undefined; // Get value

    if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
      return el.dom7ElementDataStorage[key];
    }

    const dataKey = el.getAttribute(`data-${key}`);

    if (dataKey) {
      return dataKey;
    }

    return undefined;
  } // Set value


  for (let i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }

  return this;
}

function removeData(key) {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}

function dataset() {
  const el = this[0];
  if (!el) return undefined;
  const dataset = {}; // eslint-disable-line

  if (el.dataset) {
    for (const dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (let i = 0; i < el.attributes.length; i += 1) {
      const attr = el.attributes[i];

      if (attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
      }
    }
  }

  for (const key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }

  return dataset;
}

function val(value) {
  if (typeof value === 'undefined') {
    // get value
    const el = this[0];
    if (!el) return undefined;

    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
      const values = [];

      for (let i = 0; i < el.selectedOptions.length; i += 1) {
        values.push(el.selectedOptions[i].value);
      }

      return values;
    }

    return el.value;
  } // set value


  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
      for (let j = 0; j < el.options.length; j += 1) {
        el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
      }
    } else {
      el.value = value;
    }
  }

  return this;
}

function value(value) {
  return this.val(value);
}

function transform(transform) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition(duration) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
  }

  return this;
}

function on(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    const target = e.target;
    if (!target) return;
    const eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if (dom7_esm_$(target).is(targetSelector)) listener.apply(target, eventData);else {
      const parents = dom7_esm_$(target).parents(); // eslint-disable-line

      for (let k = 0; k < parents.length; k += 1) {
        if (dom7_esm_$(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    const eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  const events = eventType.split(' ');
  let j;

  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
        el.dom7LiveListeners[event].push({
          listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  const events = eventType.split(' ');

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let handlers;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (let k = handlers.length - 1; k >= 0; k -= 1) {
          const handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function once(...args) {
  const dom = this;
  let [eventName, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventName, listener, capture] = args;
    targetSelector = undefined;
  }

  function onceHandler(...eventArgs) {
    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);

    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }

  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}

function dom7_esm_trigger(...args) {
  const window = ssr_window_esm_getWindow();
  const events = args[0].split(' ');
  const eventData = args[1];

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];

      if (window.CustomEvent) {
        const evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionStart(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionstart', fireCallBack);
  }

  if (callback) {
    dom.on('transitionstart', fireCallBack);
  }

  return this;
}

function transitionEnd(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function animationEnd(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('animationend', fireCallBack);
  }

  if (callback) {
    dom.on('animationend', fireCallBack);
  }

  return this;
}

function width() {
  const window = getWindow();

  if (this[0] === window) {
    return window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}

function dom7_esm_outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function height() {
  const window = getWindow();

  if (this[0] === window) {
    return window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}

function dom7_esm_outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    const window = ssr_window_esm_getWindow();
    const document = ssr_window_esm_getDocument();
    const el = this[0];
    const box = el.getBoundingClientRect();
    const body = document.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window ? window.scrollY : el.scrollTop;
    const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function hide() {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }

  return this;
}

function show() {
  const window = getWindow();

  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.style.display === 'none') {
      el.style.display = '';
    }

    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }

  return this;
}

function styles() {
  const window = ssr_window_esm_getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  const window = ssr_window_esm_getWindow();
  let i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (const prop in props) {
          this[i].style[prop] = props[prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach((el, index) => {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  const result = arrayFilter(this, callback);
  return dom7_esm_$(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function dom7_esm_text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function dom7_esm_is(selector) {
  const window = ssr_window_esm_getWindow();
  const document = ssr_window_esm_getDocument();
  const el = this[0];
  let compareWith;
  let i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = dom7_esm_$(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  let child = this[0];
  let i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  const length = this.length;

  if (index > length - 1) {
    return dom7_esm_$([]);
  }

  if (index < 0) {
    const returnIndex = length + index;
    if (returnIndex < 0) return dom7_esm_$([]);
    return dom7_esm_$([this[returnIndex]]);
  }

  return dom7_esm_$([this[index]]);
}

function append(...els) {
  let newChild;
  const document = ssr_window_esm_getDocument();

  for (let k = 0; k < els.length; k += 1) {
    newChild = els[k];

    for (let i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (let j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function appendTo(parent) {
  dom7_esm_$(parent).append(this);
  return this;
}

function prepend(newChild) {
  const document = ssr_window_esm_getDocument();
  let i;
  let j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function prependTo(parent) {
  dom7_esm_$(parent).prepend(this);
  return this;
}

function insertBefore(selector) {
  const before = dom7_esm_$(selector);

  for (let i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (let j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}

function insertAfter(selector) {
  const after = dom7_esm_$(selector);

  for (let i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (let j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && dom7_esm_$(this[0].nextElementSibling).is(selector)) {
        return dom7_esm_$([this[0].nextElementSibling]);
      }

      return dom7_esm_$([]);
    }

    if (this[0].nextElementSibling) return dom7_esm_$([this[0].nextElementSibling]);
    return dom7_esm_$([]);
  }

  return dom7_esm_$([]);
}

function nextAll(selector) {
  const nextEls = [];
  let el = this[0];
  if (!el) return dom7_esm_$([]);

  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if (dom7_esm_$(next).is(selector)) nextEls.push(next);
    } else nextEls.push(next);

    el = next;
  }

  return dom7_esm_$(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    const el = this[0];

    if (selector) {
      if (el.previousElementSibling && dom7_esm_$(el.previousElementSibling).is(selector)) {
        return dom7_esm_$([el.previousElementSibling]);
      }

      return dom7_esm_$([]);
    }

    if (el.previousElementSibling) return dom7_esm_$([el.previousElementSibling]);
    return dom7_esm_$([]);
  }

  return dom7_esm_$([]);
}

function prevAll(selector) {
  const prevEls = [];
  let el = this[0];
  if (!el) return dom7_esm_$([]);

  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if (dom7_esm_$(prev).is(selector)) prevEls.push(prev);
    } else prevEls.push(prev);

    el = prev;
  }

  return dom7_esm_$(prevEls);
}

function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}

function dom7_esm_parent(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if (dom7_esm_$(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return dom7_esm_$(parents);
}

function parents(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    let parent = this[i].parentNode; // eslint-disable-line

    while (parent) {
      if (selector) {
        if (dom7_esm_$(parent).is(selector)) parents.push(parent);
      } else {
        parents.push(parent);
      }

      parent = parent.parentNode;
    }
  }

  return dom7_esm_$(parents);
}

function closest(selector) {
  let closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return dom7_esm_$([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  const foundElements = [];

  for (let i = 0; i < this.length; i += 1) {
    const found = this[i].querySelectorAll(selector);

    for (let j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return dom7_esm_$(foundElements);
}

function dom7_esm_children(selector) {
  const children = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    const childNodes = this[i].children;

    for (let j = 0; j < childNodes.length; j += 1) {
      if (!selector || dom7_esm_$(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return dom7_esm_$(children);
}

function remove() {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

function detach() {
  return this.remove();
}

function add(...els) {
  const dom = this;
  let i;
  let j;

  for (i = 0; i < els.length; i += 1) {
    const toAdd = dom7_esm_$(els[i]);

    for (j = 0; j < toAdd.length; j += 1) {
      dom.push(toAdd[j]);
    }
  }

  return dom;
}

function empty() {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.nodeType === 1) {
      for (let j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }

      el.textContent = '';
    }
  }

  return this;
}

// eslint-disable-next-line

function scrollTo(...args) {
  const window = getWindow();
  let [left, top, duration, easing, callback] = args;

  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    [left, top, duration, callback, easing] = args;
  }

  if (typeof easing === 'undefined') easing = 'swing';
  return this.each(function animate() {
    const el = this;
    let currentTop;
    let currentLeft;
    let maxTop;
    let maxLeft;
    let newTop;
    let newLeft;
    let scrollTop; // eslint-disable-line

    let scrollLeft; // eslint-disable-line

    let animateTop = top > 0 || top === 0;
    let animateLeft = left > 0 || left === 0;

    if (typeof easing === 'undefined') {
      easing = 'swing';
    }

    if (animateTop) {
      currentTop = el.scrollTop;

      if (!duration) {
        el.scrollTop = top;
      }
    }

    if (animateLeft) {
      currentLeft = el.scrollLeft;

      if (!duration) {
        el.scrollLeft = left;
      }
    }

    if (!duration) return;

    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }

    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }

    let startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;

    function render(time = new Date().getTime()) {
      if (startTime === null) {
        startTime = time;
      }

      const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
      let done;
      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);

      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }

      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      window.requestAnimationFrame(render);
    }

    window.requestAnimationFrame(render);
  });
} // scrollTop(top, duration, easing, callback) {


function scrollTop(...args) {
  let [top, duration, easing, callback] = args;

  if (args.length === 3 && typeof easing === 'function') {
    [top, duration, callback, easing] = args;
  }

  const dom = this;

  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }

  return dom.scrollTo(undefined, top, duration, easing, callback);
}

function scrollLeft(...args) {
  let [left, duration, easing, callback] = args;

  if (args.length === 3 && typeof easing === 'function') {
    [left, duration, callback, easing] = args;
  }

  const dom = this;

  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }

  return dom.scrollTo(left, undefined, duration, easing, callback);
}

// eslint-disable-next-line

function animate(initialProps, initialParams) {
  const window = getWindow();
  const els = this;
  const a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing' // or 'linear'

      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */

    }, initialParams),
    elements: els,
    animating: false,
    que: [],

    easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - Math.cos(progress * Math.PI) / 2;
      }

      if (typeof easing === 'function') {
        return easing(progress);
      }

      return progress;
    },

    stop() {
      if (a.frameId) {
        window.cancelAnimationFrame(a.frameId);
      }

      a.animating = false;
      a.elements.each(el => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },

    done(complete) {
      a.animating = false;
      a.elements.each(el => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);

      if (a.que.length > 0) {
        const que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },

    animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }

      const elements = []; // Define & Cache Initials & Units

      a.elements.each((el, index) => {
        let initialFullValue;
        let initialValue;
        let unit;
        let finalValue;
        let finalFullValue;
        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
        elements[index] = {
          container: el
        };
        Object.keys(props).forEach(prop => {
          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue,
            initialValue,
            unit,
            finalValue,
            finalFullValue,
            currentValue: initialValue
          };
        });
      });
      let startTime = null;
      let time;
      let elementsDone = 0;
      let propsDone = 0;
      let done;
      let began = false;
      a.animating = true;

      function render() {
        time = new Date().getTime();
        let progress;
        let easeProgress; // let el;

        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }

        if (startTime === null) {
          startTime = time;
        }

        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
        }

        elements.forEach(element => {
          const el = element;
          if (done || el.done) return;
          Object.keys(props).forEach(prop => {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            const {
              initialValue,
              finalValue,
              unit
            } = el[prop];
            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
            const currentValue = el[prop].currentValue;

            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;

              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }

              if (elementsDone === elements.length) {
                done = true;
              }
            }

            if (done) {
              a.done(params.complete);
              return;
            }

            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return; // Then call

        a.frameId = window.requestAnimationFrame(render);
      }

      a.frameId = window.requestAnimationFrame(render);
      return a;
    }

  };

  if (a.elements.length === 0) {
    return els;
  }

  let animateInstance;

  for (let i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }

  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function dom7_esm_stop() {
  const els = this;

  for (let i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

const noTrigger = 'resize scroll'.split(' ');

function shortcut(name) {
  function eventHandler(...args) {
    if (typeof args[0] === 'undefined') {
      for (let i = 0; i < this.length; i += 1) {
        if (noTrigger.indexOf(name) < 0) {
          if (name in this[i]) this[i][name]();else {
            dom7_esm_$(this[i]).trigger(name);
          }
        }
      }

      return this;
    }

    return this.on(name, ...args);
  }

  return eventHandler;
}

const click = shortcut('click');
const dom7_esm_blur = shortcut('blur');
const dom7_esm_focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const dom7_esm_submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const dom7_esm_scroll = shortcut('scroll');

/* harmony default export */ var dom7_esm = ((/* unused pure expression or super */ null && (dom7_esm_$)));


;// CONCATENATED MODULE: ../../node_modules/swiper/shared/dom.js

const Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition,
  on: on,
  off: off,
  trigger: dom7_esm_trigger,
  transitionEnd: transitionEnd,
  outerWidth: dom7_esm_outerWidth,
  outerHeight: dom7_esm_outerHeight,
  styles: styles,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: dom7_esm_text,
  is: dom7_esm_is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: dom7_esm_parent,
  parents: parents,
  closest: closest,
  find: find,
  children: dom7_esm_children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(methodName => {
  Object.defineProperty(dom7_esm_$.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});
/* harmony default export */ var dom = (dom7_esm_$);
;// CONCATENATED MODULE: ../../node_modules/swiper/shared/utils.js


function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function utils_nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}

function utils_now() {
  return Date.now();
}

function utils_getComputedStyle(el) {
  const window = ssr_window_esm_getWindow();
  let style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function utils_getTranslate(el, axis = 'x') {
  const window = ssr_window_esm_getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = utils_getComputedStyle(el, null);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function utils_isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function utils_extend(...args) {
  const to = Object(args[0]);
  const noExtend = ['__proto__', 'constructor', 'prototype'];

  for (let i = 1; i < args.length; i += 1) {
    const nextSource = args[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);

      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              utils_extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              utils_extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function utils_setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}

function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  const window = ssr_window_esm_getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? 'next' : 'prev';

  const isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };

  const animate = () => {
    time = new Date().getTime();

    if (startTime === null) {
      startTime = time;
    }

    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);

    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }

    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });

    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }

    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };

  animate();
}


;// CONCATENATED MODULE: ../../node_modules/swiper/shared/get-support.js

let support;

function calcSupport() {
  const window = ssr_window_esm_getWindow();
  const document = ssr_window_esm_getDocument();
  return {
    smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    passiveListener: function checkPassiveListener() {
      let supportsPassive = false;

      try {
        const opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get() {
            supportsPassive = true;
          }

        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}


;// CONCATENATED MODULE: ../../node_modules/swiper/shared/get-device.js


let deviceCached;

function calcDevice({
  userAgent
} = {}) {
  const support = getSupport();
  const window = ssr_window_esm_getWindow();
  const platform = window.navigator.platform;
  const ua = userAgent || window.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === 'Win32';
  let macos = platform === 'MacIntel'; // iPadOs 13 fix

  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }

  return deviceCached;
}


;// CONCATENATED MODULE: ../../node_modules/swiper/shared/get-browser.js

let browser;

function calcBrowser() {
  const window = ssr_window_esm_getWindow();

  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}


;// CONCATENATED MODULE: ../../node_modules/swiper/core/modules/resize/resize.js

function Resize({
  swiper,
  on,
  emit
}) {
  const window = ssr_window_esm_getWindow();
  let observer = null;
  let animationFrame = null;

  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };

  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      animationFrame = window.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });

        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };

  const removeObserver = () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }

    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };

  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };

  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }

    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/modules/observer/observer.js

function Observer({
  swiper,
  extendParams,
  on,
  emit
}) {
  const observers = [];
  const window = ssr_window_esm_getWindow();

  const attach = (target, options = {}) => {
    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    const observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }

      const observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };

  const init = () => {
    if (!swiper.params.observer) return;

    if (swiper.params.observeParents) {
      const containerParents = swiper.$el.parents();

      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    } // Observe container


    attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  };

  const destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };

  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/events-emitter.js
/* eslint-disable no-underscore-dangle */
/* harmony default export */ var events_emitter = ({
  on(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },

  once(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;

    function onceHandler(...args) {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },

  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },

  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    const index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },

  off(events, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },

  emit(...args) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }

});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/update/updateSize.js
function updateSize() {
  const swiper = this;
  let width;
  let height;
  const $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/update/updateSlides.js

function updateSlides() {
  const swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  const params = swiper.params;
  const {
    $wrapperEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  let offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  }); // reset cssMode offsets

  if (params.centeredSlides && params.cssMode) {
    utils_setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', '');
    utils_setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', '');
  }

  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;

  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  } // Calc slides


  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;

  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide = slides.eq(i);

    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel('width')] = ``;
      }

      const slideStyles = getComputedStyle(slide[0]);
      const currentTransform = slide[0].style.transform;
      const currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        const width = getDirectionPropertyValue(slideStyles, 'width');
        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        const boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide[0];
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (params.setWrapperSize) {
    $wrapperEl.css({
      [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    const newSlidesGrid = [];

    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);

      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css({
      [key]: `${spaceBetween}px`
    });
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(snap => {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;

    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });

  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    utils_setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
    utils_setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }

  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);

    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.$el.removeClass(backFaceHiddenClass);
    }
  }
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/update/updateAutoHeight.js

function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  const getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides.filter(el => parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || dom([])).each(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/update/updateSlidesOffset.js
function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;

  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/update/updateSlidesProgress.js

function updateSlidesProgress(translate = this && this.translate || 0) {
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    let slideOffset = slide.swiperSlideOffset;

    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }

    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
      slides.eq(i).addClass(params.slideVisibleClass);
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }

  swiper.visibleSlides = dom(swiper.visibleSlides);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/update/updateProgress.js
function updateProgress(translate) {
  const swiper = this;

  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  Object.assign(swiper, {
    progress,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/update/updateSlidesClasses.js
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    $wrapperEl,
    activeIndex,
    realIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
  let activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/update/updateActiveIndex.js
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    slidesGrid,
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/update/updateClickedSlide.js

function updateClickedSlide(e) {
  const swiper = this;
  const params = swiper.params;
  const slide = dom(e).closest(`.${params.slideClass}`)[0];
  let slideFound = false;
  let slideIndex;

  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(dom(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/update/index.js









/* harmony default export */ var core_update = ({
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/translate/getTranslate.js

function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate,
    $wrapperEl
  } = swiper;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  let currentTranslate = utils_getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/translate/setTranslate.js
function setTranslate(translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    $wrapperEl,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/translate/minTranslate.js
function minTranslate() {
  return -this.snapGrid[0];
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/translate/maxTranslate.js
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/translate/translateTo.js

function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    const isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/translate/index.js





/* harmony default export */ var translate = ({
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/transition/setTransition.js
function setTransition(duration, byController) {
  const swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/transition/transitionEmit.js
function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit(`transition${step}`);

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }

    swiper.emit(`slideChangeTransition${step}`);

    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/transition/transitionStart.js

function transitionStart_transitionStart(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/transition/transitionEnd.js

function transitionEnd_transitionEnd(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/transition/index.js



/* harmony default export */ var core_transition = ({
  setTransition: setTransition,
  transitionStart: transitionStart_transitionStart,
  transitionEnd: transitionEnd_transitionEnd
});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/slide/slideTo.js

function slideTo(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate = -snapGrid[snapIndex]; // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  } // Update progress


  swiper.updateProgress(translate);
  let direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate : -translate;

    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }

      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;

      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._swiperImmediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }

    return true;
  }

  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);

  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;

    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }

    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
  }

  return true;
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/slide/slideToLoop.js
function slideToLoop(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/slide/slideNext.js
/* eslint no-unused-vars: "off" */
function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    animating,
    enabled,
    params
  } = swiper;
  if (!enabled) return swiper;
  let perGroup = params.slidesPerGroup;

  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }

  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/slide/slidePrev.js
/* eslint no-unused-vars: "off" */
function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    params,
    animating,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  const translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });

    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }

  let prevIndex = 0;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;

    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }

  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/slide/slideReset.js
/* eslint no-unused-vars: "off" */
function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/slide/slideToClosest.js
/* eslint no-unused-vars: "off" */
function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper = this;
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/slide/slideToClickedSlide.js


function slideToClickedSlide() {
  const swiper = this;
  const {
    params,
    $wrapperEl
  } = swiper;
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(dom(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
        utils_nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
      utils_nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/slide/index.js







/* harmony default export */ var slide = ({
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/loop/loopCreate.js


function loopCreate() {
  const swiper = this;
  const document = ssr_window_esm_getDocument();
  const {
    params,
    $wrapperEl
  } = swiper; // Remove duplicated slides

  const $selector = $wrapperEl.children().length > 0 ? dom($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
  let slides = $selector.children(`.${params.slideClass}`);

  if (params.loopFillGroupWithBlank) {
    const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankNode = dom(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
        $selector.append(blankNode);
      }

      slides = $selector.children(`.${params.slideClass}`);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) {
    swiper.loopedSlides = slides.length;
  }

  const prependSlides = [];
  const appendSlides = [];
  slides.each((el, index) => {
    const slide = dom(el);
    slide.attr('data-swiper-slide-index', index);
  });

  for (let i = 0; i < swiper.loopedSlides; i += 1) {
    const index = i - Math.floor(i / slides.length) * slides.length;
    appendSlides.push(slides.eq(index)[0]);
    prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
  }

  for (let i = 0; i < appendSlides.length; i += 1) {
    $selector.append(dom(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
    $selector.prepend(dom(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/loop/loopFix.js
function loopFix() {
  const swiper = this;
  swiper.emit('beforeLoopFix');
  const {
    activeIndex,
    slides,
    loopedSlides,
    allowSlidePrev,
    allowSlideNext,
    snapGrid,
    rtlTranslate: rtl
  } = swiper;
  let newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  const snapTranslate = -snapGrid[activeIndex];
  const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/loop/loopDestroy.js
function loopDestroy() {
  const swiper = this;
  const {
    $wrapperEl,
    params,
    slides
  } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
  slides.removeAttr('data-swiper-slide-index');
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/loop/index.js



/* harmony default export */ var loop = ({
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/grab-cursor/setGrabCursor.js
function setGrabCursor(moving) {
  const swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/grab-cursor/unsetGrabCursor.js
function unsetGrabCursor() {
  const swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/grab-cursor/index.js


/* harmony default export */ var grab_cursor = ({
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/events/onTouchStart.js


 // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd

function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === ssr_window_esm_getDocument() || el === ssr_window_esm_getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);

    if (!found && !el.getRootNode) {
      return null;
    }

    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  const swiper = this;
  const document = ssr_window_esm_getDocument();
  const window = ssr_window_esm_getWindow();
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }

  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let $targetEl = dom(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line

  const eventPath = event.composedPath ? event.composedPath() : event.path;

  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    $targetEl = dom(eventPath[0]);
  }

  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = utils_now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    let preventDefault = true;

    if ($targetEl.is(data.focusableElements)) {
      preventDefault = false;

      if ($targetEl[0].nodeName === 'SELECT') {
        data.isTouched = false;
      }
    }

    if (document.activeElement && dom(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }

  swiper.emit('touchStart', e);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/events/onTouchMove.js



function onTouchMove(event) {
  const document = ssr_window_esm_getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    if (!dom(e.target).is(data.focusableElements)) {
      swiper.allowClick = false;
    }

    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = utils_now();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && dom(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop && !params.cssMode) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  let diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/events/onTouchEnd.js

function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  const touchEndTime = utils_now();
  const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = utils_now();
  utils_nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  } // Find current slide


  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];

  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  let rewindFirstIndex = null;
  let rewindLastIndex = null;

  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  } // Find current slide size


  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/events/onResize.js
function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/events/onClick.js
function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/events/onScroll.js
function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/events/index.js







let dummyEventAttached = false;

function dummyEventListener() {}

const events_events = (swiper, method) => {
  const document = ssr_window_esm_getDocument();
  const {
    params,
    touchEvents,
    el,
    wrapperEl,
    device,
    support
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  const swiperMethod = method; // Touch Events

  if (!support.touch) {
    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
    document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
    document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
  } else {
    const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
    el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
      passive: false,
      capture
    } : capture);
    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);

    if (touchEvents.cancel) {
      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }
};

function attachEvents() {
  const swiper = this;
  const document = ssr_window_esm_getDocument();
  const {
    params,
    support
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  if (support.touch && !dummyEventAttached) {
    document.addEventListener('touchstart', dummyEventListener);
    dummyEventAttached = true;
  }

  events_events(swiper, 'on');
}

function detachEvents() {
  const swiper = this;
  events_events(swiper, 'off');
}

/* harmony default export */ var core_events = ({
  attachEvents,
  detachEvents
});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/breakpoints/setBreakpoint.js


const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};

function setBreakpoint() {
  const swiper = this;
  const {
    activeIndex,
    initialized,
    loopedSlides = 0,
    params,
    $el
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(`${params.containerModifierClass}grid`);

    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      $el.addClass(`${params.containerModifierClass}grid-column`);
    }

    swiper.emitContainerClasses();
  } // Toggle navigation, pagination, scrollbar


  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;

    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }

    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  utils_extend(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/breakpoints/getBreakpoint.js

function getBreakpoint(breakpoints, base = 'window', containerEl) {
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  let breakpoint = false;
  const window = ssr_window_esm_getWindow();
  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }

    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));

  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];

    if (base === 'window') {
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/breakpoints/index.js


/* harmony default export */ var breakpoints = ({
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/classes/addClasses.js
function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    $el,
    device,
    support
  } = swiper; // prettier-ignore

  const suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': !support.touch
  }, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  $el.addClass([...classNames].join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/classes/removeClasses.js
function removeClasses() {
  const swiper = this;
  const {
    $el,
    classNames
  } = swiper;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/classes/index.js


/* harmony default export */ var classes = ({
  addClasses: addClasses,
  removeClasses: removeClasses
});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/images/loadImage.js


function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  const window = ssr_window_esm_getWindow();
  let image;

  function onReady() {
    if (callback) callback();
  }

  const isPicture = dom(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/images/preloadImages.js
function preloadImages() {
  const swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
    const imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/images/index.js


/* harmony default export */ var core_images = ({
  loadImage: loadImage,
  preloadImages: preloadImages
});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/check-overflow/index.js
function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;

  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }

  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }

  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}

/* harmony default export */ var check_overflow = ({
  checkOverflow
});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/defaults.js
/* harmony default export */ var defaults = ({
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: true,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
});
;// CONCATENATED MODULE: ../../node_modules/swiper/core/moduleExtendParams.js

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];

    if (typeof moduleParams !== 'object' || moduleParams === null) {
      utils_extend(allModulesParams, obj);
      return;
    }

    if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }

    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      utils_extend(allModulesParams, obj);
      return;
    }

    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }

    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }

    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    utils_extend(allModulesParams, obj);
  };
}
;// CONCATENATED MODULE: ../../node_modules/swiper/core/core.js
/* eslint no-param-reassign: "off" */






















const prototypes = {
  eventsEmitter: events_emitter,
  update: core_update,
  translate: translate,
  transition: core_transition,
  slide: slide,
  loop: loop,
  grabCursor: grab_cursor,
  events: core_events,
  breakpoints: breakpoints,
  checkOverflow: check_overflow,
  classes: classes,
  images: core_images
};
const extendedDefaults = {};

class Swiper {
  constructor(...args) {
    let el;
    let params;

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }

    if (!params) params = {};
    params = utils_extend({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && dom(params.el).length > 1) {
      const swipers = [];
      dom(params.el).each(containerEl => {
        const newParams = utils_extend({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      }); // eslint-disable-next-line no-constructor-return

      return swipers;
    } // Swiper Instance


    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];

    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }

    const allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    }); // Extend defaults with modules params

    const swiperParams = utils_extend({}, defaults, allModulesParams); // Extend defaults with passed params

    swiper.params = utils_extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = utils_extend({}, swiper.params);
    swiper.passedParams = utils_extend({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = dom; // Extend Swiper

    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: dom(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },

      isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        const desktop = ['pointerdown', 'pointermove', 'pointerup'];
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: utils_now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance
    // eslint-disable-next-line no-constructor-return


    return swiper;
  }

  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  }

  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  }

  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }

  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return '';
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }

  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.each(slideEl => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }

  slidesPerViewDynamic(view = 'current', exact = false) {
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;

    if (params.centeredSlides) {
      let slideSize = slides[activeIndex].swiperSlideSize;
      let breakLoop;

      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      }
    }

    return spv;
  }

  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    let translated;

    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  }

  changeDirection(newDirection, needUpdate = true) {
    const swiper = this;
    const currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }

  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
    swiper.rtl = direction === 'rtl';
    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;

    if (swiper.rtl) {
      swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'rtl';
    } else {
      swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'ltr';
    }

    swiper.update();
  }

  mount(el) {
    const swiper = this;
    if (swiper.mounted) return true; // Find el

    const $el = dom(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
    };

    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = dom(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = options => $el.children(options);

        return res;
      }

      if (!$el.children) {
        return dom($el).children(getWrapperSelector());
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    let $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      const document = ssr_window_esm_getDocument();
      const wrapper = document.createElement('div');
      $wrapperEl = dom(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children(`.${swiper.params.slideClass}`).each(slideEl => {
        $wrapperEl.append(slideEl);
      });
    }

    Object.assign(swiper, {
      $el,
      el,
      $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  }

  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }

  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper = this;
    const {
      params,
      $el,
      $wrapperEl,
      slides
    } = swiper;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  }

  static extendDefaults(newDefaults) {
    utils_extend(extendedDefaults, newDefaults);
  }

  static get extendedDefaults() {
    return extendedDefaults;
  }

  static get defaults() {
    return defaults;
  }

  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;

    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }

  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper.installModule(m));
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  }

}

Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);
/* harmony default export */ var core = (Swiper);
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/virtual/virtual.js


function Virtual({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let cssModeTimeout;
  swiper.virtual = {
    cache: {},
    from: undefined,
    to: undefined,
    slides: [],
    offset: 0,
    slidesGrid: []
  };

  function renderSlide(slide, index) {
    const params = swiper.params.virtual;

    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }

    const $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  }

  function update(force) {
    const {
      slidesPerView,
      slidesPerGroup,
      centeredSlides
    } = swiper.params;
    const {
      addSlidesBefore,
      addSlidesAfter
    } = swiper.params.virtual;
    const {
      from: previousFrom,
      to: previousTo,
      slides,
      slidesGrid: previousSlidesGrid,
      offset: previousOffset
    } = swiper.virtual;

    if (!swiper.params.cssMode) {
      swiper.updateActiveIndex();
    }

    const activeIndex = swiper.activeIndex || 0;
    let offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    let slidesAfter;
    let slidesBefore;

    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = slidesPerGroup + addSlidesBefore;
    }

    const from = Math.max((activeIndex || 0) - slidesBefore, 0);
    const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    Object.assign(swiper.virtual, {
      from,
      to,
      offset,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }

      emit('virtualUpdate');
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, `${offset}px`);
      }

      swiper.updateProgress();
      emit('virtualUpdate');
      return;
    }

    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset,
        from,
        to,
        slides: function getSlides() {
          const slidesToRender = [];

          for (let i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }

          return slidesToRender;
        }()
      });

      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      } else {
        emit('virtualUpdate');
      }

      return;
    }

    const prependIndexes = [];
    const appendIndexes = [];

    if (force) {
      swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
    } else {
      for (let i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
      }
    }

    for (let i = 0; i < slides.length; i += 1) {
      if (i >= from && i <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(i);
        } else {
          if (i > previousTo) appendIndexes.push(i);
          if (i < previousFrom) prependIndexes.push(i);
        }
      }
    }

    appendIndexes.forEach(index => {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort((a, b) => b - a).forEach(index => {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
    onRendered();
  }

  function appendSlide(slides) {
    if (typeof slides === 'object' && 'length' in slides) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }

    update(true);
  }

  function prependSlide(slides) {
    const activeIndex = swiper.activeIndex;
    let newActiveIndex = activeIndex + 1;
    let numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }

      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }

    if (swiper.params.virtual.cache) {
      const cache = swiper.virtual.cache;
      const newCache = {};
      Object.keys(cache).forEach(cachedIndex => {
        const $cachedEl = cache[cachedIndex];
        const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');

        if (cachedElIndex) {
          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
        }

        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
      });
      swiper.virtual.cache = newCache;
    }

    update(true);
    swiper.slideTo(newActiveIndex, 0);
  }

  function removeSlide(slidesIndexes) {
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    let activeIndex = swiper.activeIndex;

    if (Array.isArray(slidesIndexes)) {
      for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);

        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }

        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);

      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }

      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }

    update(true);
    swiper.slideTo(activeIndex, 0);
  }

  function removeAllSlides() {
    swiper.virtual.slides = [];

    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }

    update(true);
    swiper.slideTo(0, 0);
  }

  on('beforeInit', () => {
    if (!swiper.params.virtual.enabled) return;
    swiper.virtual.slides = swiper.params.virtual.slides;
    swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;

    if (!swiper.params.initialSlide) {
      update();
    }
  });
  on('setTranslate', () => {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode && !swiper._immediateVirtual) {
      clearTimeout(cssModeTimeout);
      cssModeTimeout = setTimeout(() => {
        update();
      }, 100);
    } else {
      update();
    }
  });
  on('init update resize', () => {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode) {
      setCSSProperty(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    }
  });
  Object.assign(swiper.virtual, {
    appendSlide,
    prependSlide,
    removeSlide,
    removeAllSlides,
    update
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/keyboard/keyboard.js
/* eslint-disable consistent-return */


function Keyboard({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document = getDocument();
  const window = getWindow();
  swiper.keyboard = {
    enabled: false
  };
  extendParams({
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  });

  function handle(event) {
    if (!swiper.enabled) return;
    const {
      rtlTranslate: rtl
    } = swiper;
    let e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    const kc = e.keyCode || e.charCode;
    const pageUpDown = swiper.params.keyboard.pageUpDown;
    const isPageUp = pageUpDown && kc === 33;
    const isPageDown = pageUpDown && kc === 34;
    const isArrowLeft = kc === 37;
    const isArrowRight = kc === 39;
    const isArrowUp = kc === 38;
    const isArrowDown = kc === 40; // Directions locks

    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }

    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }

    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }

    if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }

    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      let inView = false; // Check that swiper should be inside of visible area of window

      if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) {
        return undefined;
      }

      const $el = swiper.$el;
      const swiperWidth = $el[0].clientWidth;
      const swiperHeight = $el[0].clientHeight;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];

      for (let i = 0; i < swiperCoord.length; i += 1) {
        const point = swiperCoord[i];

        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

          inView = true;
        }
      }

      if (!inView) return undefined;
    }

    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }

    emit('keyPress', kc);
    return undefined;
  }

  function enable() {
    if (swiper.keyboard.enabled) return;
    $(document).on('keydown', handle);
    swiper.keyboard.enabled = true;
  }

  function disable() {
    if (!swiper.keyboard.enabled) return;
    $(document).off('keydown', handle);
    swiper.keyboard.enabled = false;
  }

  on('init', () => {
    if (swiper.params.keyboard.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    if (swiper.keyboard.enabled) {
      disable();
    }
  });
  Object.assign(swiper.keyboard, {
    enable,
    disable
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/mousewheel/mousewheel.js
/* eslint-disable consistent-return */



function Mousewheel({
  swiper,
  extendParams,
  on,
  emit
}) {
  const window = getWindow();
  extendParams({
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null
    }
  });
  swiper.mousewheel = {
    enabled: false
  };
  let timeout;
  let lastScrollTime = now();
  let lastEventBeforeSnap;
  const recentWheelEvents = [];

  function normalize(e) {
    // Reasonable defaults
    const PIXEL_STEP = 10;
    const LINE_HEIGHT = 40;
    const PAGE_HEIGHT = 800;
    let sX = 0;
    let sY = 0; // spinX, spinY

    let pX = 0;
    let pY = 0; // pixelX, pixelY
    // Legacy

    if ('detail' in e) {
      sY = e.detail;
    }

    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }

    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }

    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    } // side scrolling on FF with DOMMouseScroll


    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }

    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    } // Fall-back if spin cannot be determined


    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }

    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }

  function handleMouseEnter() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = true;
  }

  function handleMouseLeave() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = false;
  }

  function animateSlider(newEvent) {
    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
      // Prevent if delta of wheel scroll delta is below configured threshold
      return false;
    }

    if (swiper.params.mousewheel.thresholdTime && now() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
      // Prevent if time between scrolls is below configured threshold
      return false;
    } // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).


    if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
      // Return false as a default
      return true;
    } // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.


    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      emit('scroll', newEvent.raw);
    } // If you got here is because an animation has been triggered so store the current time


    lastScrollTime = new window.Date().getTime(); // Return false as a default

    return false;
  }

  function releaseScroll(newEvent) {
    const params = swiper.params.mousewheel;

    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }

    return false;
  }

  function handle(event) {
    let e = event;
    let disableParentSwiper = true;
    if (!swiper.enabled) return;
    const params = swiper.params.mousewheel;

    if (swiper.params.cssMode) {
      e.preventDefault();
    }

    let target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarget);
    }

    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    let delta = 0;
    const rtlFactor = swiper.rtlTranslate ? -1 : 1;
    const data = normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) return true;
    if (params.invert) delta = -delta; // Get the scroll positions

    let positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
    //     the disableParentSwiper will be true.
    // When loop is false:
    //     if the scroll positions is not on edge,
    //     then the disableParentSwiper will be true.
    //     if the scroll on edge positions,
    //     then the disableParentSwiper will be false.

    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();

    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
      // Register the new event in a variable which stores the relevant data
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      }; // Keep the most recent events

      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.

      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          animateSlider(newEvent);
        }
      } else {
        animateSlider(newEvent);
      } // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.


      if (releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:
      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;

      if (!ignoreWheelEvents) {
        lastEventBeforeSnap = undefined;

        if (swiper.params.loop) {
          swiper.loopFix();
        }

        let position = swiper.getTranslate() + delta * params.sensitivity;
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeMode.sticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(timeout);
          timeout = undefined;

          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift(); // only store the last N events
          }

          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          const firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(newEvent);

          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
            lastEventBeforeSnap = newEvent;
            recentWheelEvents.splice(0);
            timeout = nextTick(() => {
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            timeout = nextTick(() => {
              const snapToThreshold = 0.5;
              lastEventBeforeSnap = newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        } // Emit event


        if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay

        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions

        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
      }
    }

    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  }

  function events(method) {
    let target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarget);
    }

    target[method]('mouseenter', handleMouseEnter);
    target[method]('mouseleave', handleMouseLeave);
    target[method]('wheel', handle);
  }

  function enable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener('wheel', handle);
      return true;
    }

    if (swiper.mousewheel.enabled) return false;
    events('on');
    swiper.mousewheel.enabled = true;
    return true;
  }

  function disable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, handle);
      return true;
    }

    if (!swiper.mousewheel.enabled) return false;
    events('off');
    swiper.mousewheel.enabled = false;
    return true;
  }

  on('init', () => {
    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
      disable();
    }

    if (swiper.params.mousewheel.enabled) enable();
  });
  on('destroy', () => {
    if (swiper.params.cssMode) {
      enable();
    }

    if (swiper.mousewheel.enabled) disable();
  });
  Object.assign(swiper.mousewheel, {
    enable,
    disable
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/shared/create-element-if-not-defined.js

function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  const document = ssr_window_esm_getDocument();

  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        let element = swiper.$el.children(`.${checkProps[key]}`)[0];

        if (!element) {
          element = document.createElement('div');
          element.className = checkProps[key];
          swiper.$el.append(element);
        }

        params[key] = element;
        originalParams[key] = element;
      }
    });
  }

  return params;
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/navigation/navigation.js


function Navigation({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
      navigationDisabledClass: 'swiper-navigation-disabled'
    }
  });
  swiper.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  };

  function getEl(el) {
    let $el;

    if (el) {
      $el = dom(el);

      if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) {
        $el = swiper.$el.find(el);
      }
    }

    return $el;
  }

  function toggleEl($el, disabled) {
    const params = swiper.params.navigation;

    if ($el && $el.length > 0) {
      $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
      if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;

      if (swiper.params.watchOverflow && swiper.enabled) {
        $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  }

  function update() {
    // Update Navigation Buttons
    if (swiper.params.loop) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
  }

  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
    emit('navigationPrev');
  }

  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
    emit('navigationNext');
  }

  function init() {
    const params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    const $nextEl = getEl(params.nextEl);
    const $prevEl = getEl(params.prevEl);

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', onPrevClick);
    }

    Object.assign(swiper.navigation, {
      $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  }

  function destroy() {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }

  on('init', () => {
    if (swiper.params.navigation.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      update();
    }
  });
  on('toEdge fromEdge lock unlock', () => {
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl) {
      $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }

    if ($prevEl) {
      $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }
  });
  on('click', (_s, e) => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    const targetEl = e.target;

    if (swiper.params.navigation.hideOnClick && !dom(targetEl).is($prevEl) && !dom(targetEl).is($nextEl)) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden;

      if ($nextEl) {
        isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
      } else if ($prevEl) {
        isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
      }

      if (isHidden === true) {
        emit('navigationShow');
      } else {
        emit('navigationHide');
      }

      if ($nextEl) {
        $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
      }

      if ($prevEl) {
        $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
      }
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
    init();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
    destroy();
  };

  Object.assign(swiper.navigation, {
    enable,
    disable,
    update,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/shared/classes-to-selector.js
function classesToSelector(classes = '') {
  return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/pagination/pagination.js



function Pagination({
  swiper,
  extendParams,
  on,
  emit
}) {
  const pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;

  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
  }

  function setSideBullets($bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
  }

  function update() {
    // Render || Update Pagination bullets/items
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el; // Current/Total

    let current;
    const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;

      if (params.dynamicBullets) {
        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);

          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }

        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`).join(' '));

      if ($el.length > 1) {
        bullets.each(bullet => {
          const $bullet = dom(bullet);
          const bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(`${params.bulletActiveClass}-main`);
            }

            if (bulletIndex === firstIndex) {
              setSideBullets($bullet, 'prev');
            }

            if (bulletIndex === lastIndex) {
              setSideBullets($bullet, 'next');
            }
          }
        });
      } else {
        const $bullet = bullets.eq(current);
        const bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          const $firstDisplayedBullet = bullets.eq(firstIndex);
          const $lastDisplayedBullet = bullets.eq(lastIndex);

          for (let i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length) {
              for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
            } else {
              setSideBullets($firstDisplayedBullet, 'prev');
              setSideBullets($lastDisplayedBullet, 'next');
            }
          } else {
            setSideBullets($firstDisplayedBullet, 'prev');
            setSideBullets($lastDisplayedBullet, 'next');
          }
        }
      }

      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
      }
    }

    if (params.type === 'fraction') {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      let progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      const scale = (current + 1) / total;
      let scaleX = 1;
      let scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      emit('paginationRender', $el[0]);
    } else {
      emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  }

  function render() {
    // Render Container
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el;
    let paginationHTML = '';

    if (params.type === 'bullets') {
      let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      emit('paginationRender', swiper.pagination.$el[0]);
    }
  }

  function init() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let $el = dom(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper

      if ($el.length > 1) {
        $el = $el.filter(el => {
          if (dom(el).parents('.swiper')[0] !== swiper.el) return false;
          return true;
        });
      }
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);
    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
      dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        let index = dom(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Object.assign(swiper.pagination, {
      $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classesToSelector(params.bulletClass));
    }
  }

  on('init', () => {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', () => {
    if (swiper.params.loop) {
      update();
    } else if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    if (!swiper.params.loop) {
      update();
    }
  });
  on('slidesLengthChange', () => {
    if (swiper.params.loop) {
      render();
      update();
    }
  });
  on('snapGridLengthChange', () => {
    if (!swiper.params.loop) {
      render();
      update();
    }
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.pagination;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    const targetEl = e.target;
    const {
      $el
    } = swiper.pagination;

    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !dom(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);

      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }

      $el.toggleClass(swiper.params.pagination.hiddenClass);
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    }

    init();
    render();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/scrollbar/scrollbar.js




function Scrollbar({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document = ssr_window_esm_getDocument();
  let isTouched = false;
  let timeout = null;
  let dragTimeout = null;
  let dragStartPos;
  let dragSize;
  let trackSize;
  let divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
      scrollbarDisabledClass: 'swiper-scrollbar-disabled',
      horizontalClass: `swiper-scrollbar-horizontal`,
      verticalClass: `swiper-scrollbar-vertical`
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null,
    $el: null,
    $dragEl: null
  };

  function setTranslate() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar,
      rtlTranslate: rtl,
      progress
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    const params = swiper.params.scrollbar;
    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;

    if (rtl) {
      newPos = -newPos;

      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }

    if (swiper.isHorizontal()) {
      $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
      $dragEl[0].style.width = `${newSize}px`;
    } else {
      $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
      $dragEl[0].style.height = `${newSize}px`;
    }

    if (params.hide) {
      clearTimeout(timeout);
      $el[0].style.opacity = 1;
      timeout = setTimeout(() => {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  }

  function setTransition(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  }

  function updateSize() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));

    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = `${dragSize}px`;
    } else {
      $dragEl[0].style.height = `${dragSize}px`;
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }

    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function getPointerPosition(e) {
    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
    }

    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
  }

  function setDragPosition(e) {
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      $el
    } = scrollbar;
    let positionRatio;
    positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);

    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  function onDragStart(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    setDragPosition(e);
    clearTimeout(dragTimeout);
    $el.transition(0);

    if (params.hide) {
      $el.css('opacity', 1);
    }

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }

    emit('scrollbarDragStart', e);
  }

  function onDragMove(e) {
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    if (!isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    emit('scrollbarDragMove', e);
  }

  function onDragEnd(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el
    } = scrollbar;
    if (!isTouched) return;
    isTouched = false;

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }

    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = utils_nextTick(() => {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }

    emit('scrollbarDragEnd', e);

    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }

  function events(method) {
    const {
      scrollbar,
      touchEventsTouch,
      touchEventsDesktop,
      params,
      support
    } = swiper;
    const $el = scrollbar.$el;
    if (!$el) return;
    const target = $el[0];
    const activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    const passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;
    const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';

    if (!support.touch) {
      target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
      document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
      document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
    } else {
      target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
      target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
      target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
    }
  }

  function enableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('on');
  }

  function disableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('off');
  }

  function init() {
    const {
      scrollbar,
      $el: $swiperEl
    } = swiper;
    swiper.params.scrollbar = createElementIfNotDefined(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: 'swiper-scrollbar'
    });
    const params = swiper.params.scrollbar;
    if (!params.el) return;
    let $el = dom(params.el);

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);

    if ($dragEl.length === 0) {
      $dragEl = dom(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
      $el.append($dragEl);
    }

    Object.assign(scrollbar, {
      $el,
      el: $el[0],
      $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      enableDraggable();
    }

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.scrollbar;
    const $el = swiper.scrollbar.$el;

    if ($el) {
      $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    }

    disableDraggable();
  }

  on('init', () => {
    if (swiper.params.scrollbar.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      updateSize();
      setTranslate();
    }
  });
  on('update resize observerUpdate lock unlock', () => {
    updateSize();
  });
  on('setTranslate', () => {
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    setTransition(duration);
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.scrollbar;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  });
  on('destroy', () => {
    destroy();
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);

    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }

    init();
    updateSize();
    setTranslate();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);

    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.scrollbar, {
    enable,
    disable,
    updateSize,
    setTranslate,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/parallax/parallax.js

function Parallax({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    parallax: {
      enabled: false
    }
  });

  const setTransform = (el, progress) => {
    const {
      rtl
    } = swiper;
    const $el = $(el);
    const rtlFactor = rtl ? -1 : 1;
    const p = $el.attr('data-swiper-parallax') || '0';
    let x = $el.attr('data-swiper-parallax-x');
    let y = $el.attr('data-swiper-parallax-y');
    const scale = $el.attr('data-swiper-parallax-scale');
    const opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if (x.indexOf('%') >= 0) {
      x = `${parseInt(x, 10) * progress * rtlFactor}%`;
    } else {
      x = `${x * progress * rtlFactor}px`;
    }

    if (y.indexOf('%') >= 0) {
      y = `${parseInt(y, 10) * progress}%`;
    } else {
      y = `${y * progress}px`;
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      $el[0].style.opacity = currentOpacity;
    }

    if (typeof scale === 'undefined' || scale === null) {
      $el.transform(`translate3d(${x}, ${y}, 0px)`);
    } else {
      const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
    }
  };

  const setTranslate = () => {
    const {
      $el,
      slides,
      progress,
      snapGrid
    } = swiper;
    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
      setTransform(el, progress);
    });
    slides.each((slideEl, slideIndex) => {
      let slideProgress = slideEl.progress;

      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }

      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
        setTransform(el, slideProgress);
      });
    });
  };

  const setTransition = (duration = swiper.params.speed) => {
    const {
      $el
    } = swiper;
    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(parallaxEl => {
      const $parallaxEl = $(parallaxEl);
      let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      $parallaxEl.transition(parallaxDuration);
    });
  };

  on('beforeInit', () => {
    if (!swiper.params.parallax.enabled) return;
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
  });
  on('init', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTranslate', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTransition', (_swiper, duration) => {
    if (!swiper.params.parallax.enabled) return;
    setTransition(duration);
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/zoom/zoom.js



function Zoom({
  swiper,
  extendParams,
  on,
  emit
}) {
  const window = getWindow();
  extendParams({
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  });
  swiper.zoom = {
    enabled: false
  };
  let currentScale = 1;
  let isScaling = false;
  let gesturesEnabled;
  let fakeGestureTouched;
  let fakeGestureMoved;
  const gesture = {
    $slideEl: undefined,
    slideWidth: undefined,
    slideHeight: undefined,
    $imageEl: undefined,
    $imageWrapEl: undefined,
    maxRatio: 3
  };
  const image = {
    isTouched: undefined,
    isMoved: undefined,
    currentX: undefined,
    currentY: undefined,
    minX: undefined,
    minY: undefined,
    maxX: undefined,
    maxY: undefined,
    width: undefined,
    height: undefined,
    startX: undefined,
    startY: undefined,
    touchesStart: {},
    touchesCurrent: {}
  };
  const velocity = {
    x: undefined,
    y: undefined,
    prevPositionX: undefined,
    prevPositionY: undefined,
    prevTime: undefined
  };
  let scale = 1;
  Object.defineProperty(swiper.zoom, 'scale', {
    get() {
      return scale;
    },

    set(value) {
      if (scale !== value) {
        const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
        const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
        emit('zoomChange', value, imageEl, slideEl);
      }

      scale = value;
    }

  });

  function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    const x1 = e.targetTouches[0].pageX;
    const y1 = e.targetTouches[0].pageY;
    const x2 = e.targetTouches[1].pageX;
    const y2 = e.targetTouches[1].pageY;
    const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    return distance;
  } // Events


  function onGestureStart(e) {
    const support = swiper.support;
    const params = swiper.params.zoom;
    fakeGestureTouched = false;
    fakeGestureMoved = false;

    if (!support.gestures) {
      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
        return;
      }

      fakeGestureTouched = true;
      gesture.scaleStart = getDistanceBetweenTouches(e);
    }

    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`);
      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }

    if (gesture.$imageEl) {
      gesture.$imageEl.transition(0);
    }

    isScaling = true;
  }

  function onGestureChange(e) {
    const support = swiper.support;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;

    if (!support.gestures) {
      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
        return;
      }

      fakeGestureMoved = true;
      gesture.scaleMove = getDistanceBetweenTouches(e);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
      if (e.type === 'gesturechange') onGestureStart(e);
      return;
    }

    if (support.gestures) {
      zoom.scale = e.scale * currentScale;
    } else {
      zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
    }

    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
    }

    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
    }

    gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  }

  function onGestureEnd(e) {
    const device = swiper.device;
    const support = swiper.support;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;

    if (!support.gestures) {
      if (!fakeGestureTouched || !fakeGestureMoved) {
        return;
      }

      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) {
        return;
      }

      fakeGestureTouched = false;
      fakeGestureMoved = false;
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    currentScale = zoom.scale;
    isScaling = false;
    if (zoom.scale === 1) gesture.$slideEl = undefined;
  }

  function onTouchStart(e) {
    const device = swiper.device;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (image.isTouched) return;
    if (device.android && e.cancelable) e.preventDefault();
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  }

  function onTouchMove(e) {
    const zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) return;

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);
    } // Define if we need image drag


    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        return;
      }

      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        return;
      }
    }

    if (e.cancelable) {
      e.preventDefault();
    }

    e.stopPropagation();
    image.isMoved = true;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
    }

    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
    }

    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
    }

    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
    } // Velocity


    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();
    gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  }

  function onTouchEnd() {
    const zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }

    image.isTouched = false;
    image.isMoved = false;
    let momentumDurationX = 300;
    let momentumDurationY = 300;
    const momentumDistanceX = velocity.x * momentumDurationX;
    const newPositionX = image.currentX + momentumDistanceX;
    const momentumDistanceY = velocity.y * momentumDurationY;
    const newPositionY = image.currentY + momentumDistanceY; // Fix duration

    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX;
    image.currentY = newPositionY; // Define if we need image drag

    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
    gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  }

  function onTransitionEnd() {
    const zoom = swiper.zoom;

    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      if (gesture.$imageEl) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      }

      if (gesture.$imageWrapEl) {
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
      }

      zoom.scale = 1;
      currentScale = 1;
      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;
    }
  }

  function zoomIn(e) {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;

    if (!gesture.$slideEl) {
      if (e && e.target) {
        gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`);
      }

      if (!gesture.$slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
        } else {
          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        }
      }

      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;

    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.touchAction = 'none';
    }

    gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
    let touchX;
    let touchY;
    let offsetX;
    let offsetY;
    let diffX;
    let diffY;
    let translateX;
    let translateY;
    let imageWidth;
    let imageHeight;
    let scaledWidth;
    let scaledHeight;
    let translateMinX;
    let translateMinY;
    let translateMaxX;
    let translateMaxY;
    let slideWidth;
    let slideHeight;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left + window.scrollX;
      offsetY = gesture.$slideEl.offset().top + window.scrollY;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;
      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;
      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;
      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }

      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }

      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }

    gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
    gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  }

  function zoomOut() {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;

    if (!gesture.$slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
      } else {
        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      }

      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;

    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = '';
      swiper.wrapperEl.style.touchAction = '';
    }

    zoom.scale = 1;
    currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
    gesture.$slideEl = undefined;
  } // Toggle Zoom


  function zoomToggle(e) {
    const zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoomOut();
    } else {
      // Zoom In
      zoomIn(e);
    }
  }

  function getListeners() {
    const support = swiper.support;
    const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    const activeListenerWithCapture = support.passiveListener ? {
      passive: false,
      capture: true
    } : true;
    return {
      passiveListener,
      activeListenerWithCapture
    };
  }

  function getSlideSelector() {
    return `.${swiper.params.slideClass}`;
  }

  function toggleGestures(method) {
    const {
      passiveListener
    } = getListeners();
    const slideSelector = getSlideSelector();
    swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
    swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
    swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
  }

  function enableGestures() {
    if (gesturesEnabled) return;
    gesturesEnabled = true;
    toggleGestures('on');
  }

  function disableGestures() {
    if (!gesturesEnabled) return;
    gesturesEnabled = false;
    toggleGestures('off');
  } // Attach/Detach Events


  function enable() {
    const zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;
    const support = swiper.support;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    const slideSelector = getSlideSelector(); // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
  }

  function disable() {
    const zoom = swiper.zoom;
    if (!zoom.enabled) return;
    const support = swiper.support;
    zoom.enabled = false;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    const slideSelector = getSlideSelector(); // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
  }

  on('init', () => {
    if (swiper.params.zoom.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    disable();
  });
  on('touchStart', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchStart(e);
  });
  on('touchEnd', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchEnd(e);
  });
  on('doubleTap', (_s, e) => {
    if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
      zoomToggle(e);
    }
  });
  on('transitionEnd', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
      onTransitionEnd();
    }
  });
  on('slideChange', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
      onTransitionEnd();
    }
  });
  Object.assign(swiper.zoom, {
    enable,
    disable,
    in: zoomIn,
    out: zoomOut,
    toggle: zoomToggle
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/lazy/lazy.js


function Lazy({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    lazy: {
      checkInView: false,
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,
      scrollingElement: '',
      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader'
    }
  });
  swiper.lazy = {};
  let scrollHandlerAttached = false;
  let initialImageLoaded = false;

  function loadInSlide(index, loadInDuplicate = true) {
    const params = swiper.params.lazy;
    if (typeof index === 'undefined') return;
    if (swiper.slides.length === 0) return;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
    const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);

    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images.push($slideEl[0]);
    }

    if ($images.length === 0) return;
    $images.each(imageEl => {
      const $imageEl = $(imageEl);
      $imageEl.addClass(params.loadingClass);
      const background = $imageEl.attr('data-background');
      const src = $imageEl.attr('data-src');
      const srcset = $imageEl.attr('data-srcset');
      const sizes = $imageEl.attr('data-sizes');
      const $pictureEl = $imageEl.parent('picture');
      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, () => {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;

        if (background) {
          $imageEl.css('background-image', `url("${background}")`);
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }

          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }

          if ($pictureEl.length) {
            $pictureEl.children('source').each(sourceEl => {
              const $source = $(sourceEl);

              if ($source.attr('data-srcset')) {
                $source.attr('srcset', $source.attr('data-srcset'));
                $source.removeAttr('data-srcset');
              }
            });
          }

          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find(`.${params.preloaderClass}`).remove();

        if (swiper.params.loop && loadInDuplicate) {
          const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');

          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
            loadInSlide(originalSlide.index(), false);
          } else {
            const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
            loadInSlide(duplicatedSlide.index(), false);
          }
        }

        emit('lazyImageReady', $slideEl[0], $imageEl[0]);

        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      });
      emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  }

  function load() {
    const {
      $wrapperEl,
      params: swiperParams,
      slides,
      activeIndex
    } = swiper;
    const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    const params = swiperParams.lazy;
    let slidesPerView = swiperParams.slidesPerView;

    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) {
          return true;
        }
      } else if (slides[index]) return true;

      return false;
    }

    function slideIndex(slideEl) {
      if (isVirtual) {
        return $(slideEl).attr('data-swiper-slide-index');
      }

      return $(slideEl).index();
    }

    if (!initialImageLoaded) initialImageLoaded = true;

    if (swiper.params.watchSlidesProgress) {
      $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each(slideEl => {
        const index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
        loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (let i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) loadInSlide(i);
      }
    } else {
      loadInSlide(activeIndex);
    }

    if (params.loadPrevNext) {
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        const amount = params.loadPrevNextAmount;
        const spv = Math.ceil(slidesPerView);
        const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

        for (let i = activeIndex + spv; i < maxIndex; i += 1) {
          if (slideExist(i)) loadInSlide(i);
        } // Prev Slides


        for (let i = minIndex; i < activeIndex; i += 1) {
          if (slideExist(i)) loadInSlide(i);
        }
      } else {
        const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
        if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
        const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
        if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
      }
    }
  }

  function checkInViewOnLoad() {
    const window = getWindow();
    if (!swiper || swiper.destroyed) return;
    const $scrollElement = swiper.params.lazy.scrollingElement ? $(swiper.params.lazy.scrollingElement) : $(window);
    const isWindow = $scrollElement[0] === window;
    const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
    const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
    const swiperOffset = swiper.$el.offset();
    const {
      rtlTranslate: rtl
    } = swiper;
    let inView = false;
    if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
    const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];

    for (let i = 0; i < swiperCoord.length; i += 1) {
      const point = swiperCoord[i];

      if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
        if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

        inView = true;
      }
    }

    const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;

    if (inView) {
      load();
      $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
    } else if (!scrollHandlerAttached) {
      scrollHandlerAttached = true;
      $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
    }
  }

  on('beforeInit', () => {
    if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
      swiper.params.preloadImages = false;
    }
  });
  on('init', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('scroll', () => {
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) {
      load();
    }
  });
  on('scrollbarDragMove resize _freeModeNoMomentumRelease', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('transitionStart', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
        if (swiper.params.lazy.checkInView) {
          checkInViewOnLoad();
        } else {
          load();
        }
      }
    }
  });
  on('transitionEnd', () => {
    if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('slideChange', () => {
    const {
      lazy,
      cssMode,
      watchSlidesProgress,
      touchReleaseOnEdges,
      resistanceRatio
    } = swiper.params;

    if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) {
      load();
    }
  });
  on('destroy', () => {
    if (!swiper.$el) return;
    swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
  });
  Object.assign(swiper.lazy, {
    load,
    loadInSlide
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/controller/controller.js
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

function controller_Controller({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'

    }
  });
  swiper.controller = {
    control: undefined
  };

  function LinearSpline(x, y) {
    const binarySearch = function search() {
      let maxIndex;
      let minIndex;
      let guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;

        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;

          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }

        return maxIndex;
      };
    }();

    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.

    let i1;
    let i3;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };

    return this;
  } // xxx: for now i will just save one spline function to to


  function getInterpolateFunction(c) {
    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  }

  function setTranslate(_t, byController) {
    const controlled = swiper.controller.control;
    let multiplier;
    let controlledTranslate;
    const Swiper = swiper.constructor;

    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

      if (swiper.params.controller.by === 'slide') {
        getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out

        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }

      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }

    if (Array.isArray(controlled)) {
      for (let i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  }

  function setTransition(duration, byController) {
    const Swiper = swiper.constructor;
    const controlled = swiper.controller.control;
    let i;

    function setControlledTransition(c) {
      c.setTransition(duration, swiper);

      if (duration !== 0) {
        c.transitionStart();

        if (c.params.autoHeight) {
          nextTick(() => {
            c.updateAutoHeight();
          });
        }

        c.$wrapperEl.transitionEnd(() => {
          if (!controlled) return;

          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }

          c.transitionEnd();
        });
      }
    }

    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }

  function removeSpline() {
    if (!swiper.controller.control) return;

    if (swiper.controller.spline) {
      swiper.controller.spline = undefined;
      delete swiper.controller.spline;
    }
  }

  on('beforeInit', () => {
    swiper.controller.control = swiper.params.controller.control;
  });
  on('update', () => {
    removeSpline();
  });
  on('resize', () => {
    removeSpline();
  });
  on('observerUpdate', () => {
    removeSpline();
  });
  on('setTranslate', (_s, translate, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTranslate(translate, byController);
  });
  on('setTransition', (_s, duration, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTransition(duration, byController);
  });
  Object.assign(swiper.controller, {
    setTranslate,
    setTransition
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/a11y/a11y.js


function A11y({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group',
      id: null
    }
  });
  swiper.a11y = {
    clicked: false
  };
  let liveRegion = null;

  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  }

  function getRandomNumber(size = 16) {
    const randomChar = () => Math.round(16 * Math.random()).toString(16);

    return 'x'.repeat(size).replace(/x/g, randomChar);
  }

  function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
  }

  function makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
  }

  function addElRole($el, role) {
    $el.attr('role', role);
  }

  function addElRoleDescription($el, description) {
    $el.attr('aria-roledescription', description);
  }

  function addElControls($el, controls) {
    $el.attr('aria-controls', controls);
  }

  function addElLabel($el, label) {
    $el.attr('aria-label', label);
  }

  function addElId($el, id) {
    $el.attr('id', id);
  }

  function addElLive($el, live) {
    $el.attr('aria-live', live);
  }

  function disableEl($el) {
    $el.attr('aria-disabled', true);
  }

  function enableEl($el) {
    $el.attr('aria-disabled', false);
  }

  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const $targetEl = dom(e.target);

    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }

      if (swiper.isEnd) {
        notify(params.lastSlideMessage);
      } else {
        notify(params.nextSlideMessage);
      }
    }

    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }

      if (swiper.isBeginning) {
        notify(params.firstSlideMessage);
      } else {
        notify(params.prevSlideMessage);
      }
    }

    if (swiper.pagination && $targetEl.is(classesToSelector(swiper.params.pagination.bulletClass))) {
      $targetEl[0].click();
    }
  }

  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        disableEl($prevEl);
        makeElNotFocusable($prevEl);
      } else {
        enableEl($prevEl);
        makeElFocusable($prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        disableEl($nextEl);
        makeElNotFocusable($nextEl);
      } else {
        enableEl($nextEl);
        makeElFocusable($nextEl);
      }
    }
  }

  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }

  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }

  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.each(bulletEl => {
      const $bulletEl = dom(bulletEl);

      if (swiper.params.pagination.clickable) {
        makeElFocusable($bulletEl);

        if (!swiper.params.pagination.renderBullet) {
          addElRole($bulletEl, 'button');
          addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
        }
      }

      if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) {
        $bulletEl.attr('aria-current', 'true');
      } else {
        $bulletEl.removeAttr('aria-current');
      }
    });
  }

  const initNavEl = ($el, wrapperId, message) => {
    makeElFocusable($el);

    if ($el[0].tagName !== 'BUTTON') {
      addElRole($el, 'button');
      $el.on('keydown', onEnterOrSpaceKey);
    }

    addElLabel($el, message);
    addElControls($el, wrapperId);
  };

  const handlePointerDown = () => {
    swiper.a11y.clicked = true;
  };

  const handlePointerUp = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };

  const handleFocus = e => {
    if (swiper.a11y.clicked) return;
    const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;

    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }

    swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
  };

  const initSlides = () => {
    const params = swiper.params.a11y;

    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription(dom(swiper.slides), params.itemRoleDescriptionMessage);
    }

    if (params.slideRole) {
      addElRole(dom(swiper.slides), params.slideRole);
    }

    const slidesLength = swiper.params.loop ? swiper.slides.filter(el => !el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;

    if (params.slideLabelMessage) {
      swiper.slides.each((slideEl, index) => {
        const $slideEl = dom(slideEl);
        const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel($slideEl, ariaLabelMessage);
      });
    }
  };

  const init = () => {
    const params = swiper.params.a11y;
    swiper.$el.append(liveRegion); // Container

    const $containerEl = swiper.$el;

    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
    }

    if (params.containerMessage) {
      addElLabel($containerEl, params.containerMessage);
    } // Wrapper


    const $wrapperEl = swiper.$wrapperEl;
    const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
    const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    addElId($wrapperEl, wrapperId);
    addElLive($wrapperEl, live); // Slide

    initSlides(); // Navigation

    let $nextEl;
    let $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl && $nextEl.length) {
      initNavEl($nextEl, wrapperId, params.nextSlideMessage);
    }

    if ($prevEl && $prevEl.length) {
      initNavEl($prevEl, wrapperId, params.prevSlideMessage);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.on('keydown', classesToSelector(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    } // Tab focus


    swiper.$el.on('focus', handleFocus, true);
    swiper.$el.on('pointerdown', handlePointerDown, true);
    swiper.$el.on('pointerup', handlePointerUp, true);
  };

  function destroy() {
    if (liveRegion && liveRegion.length > 0) liveRegion.remove();
    let $nextEl;
    let $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      $nextEl.off('keydown', onEnterOrSpaceKey);
    }

    if ($prevEl) {
      $prevEl.off('keydown', onEnterOrSpaceKey);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.off('keydown', classesToSelector(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    } // Tab focus


    swiper.$el.off('focus', handleFocus, true);
    swiper.$el.off('pointerdown', handlePointerDown, true);
    swiper.$el.off('pointerup', handlePointerUp, true);
  }

  on('beforeInit', () => {
    liveRegion = dom(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
  });
  on('afterInit', () => {
    if (!swiper.params.a11y.enabled) return;
    init();
  });
  on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on('fromEdge toEdge afterInit lock unlock', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('paginationUpdate', () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on('destroy', () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/history/history.js

function History({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    history: {
      enabled: false,
      root: '',
      replaceState: false,
      key: 'slides',
      keepQuery: false
    }
  });
  let initialized = false;
  let paths = {};

  const slugify = text => {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  };

  const getPathValues = urlOverride => {
    const window = getWindow();
    let location;

    if (urlOverride) {
      location = new URL(urlOverride);
    } else {
      location = window.location;
    }

    const pathArray = location.pathname.slice(1).split('/').filter(part => part !== '');
    const total = pathArray.length;
    const key = pathArray[total - 2];
    const value = pathArray[total - 1];
    return {
      key,
      value
    };
  };

  const setHistory = (key, index) => {
    const window = getWindow();
    if (!initialized || !swiper.params.history.enabled) return;
    let location;

    if (swiper.params.url) {
      location = new URL(swiper.params.url);
    } else {
      location = window.location;
    }

    const slide = swiper.slides.eq(index);
    let value = slugify(slide.attr('data-history'));

    if (swiper.params.history.root.length > 0) {
      let root = swiper.params.history.root;
      if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
      value = `${root}/${key}/${value}`;
    } else if (!location.pathname.includes(key)) {
      value = `${key}/${value}`;
    }

    if (swiper.params.history.keepQuery) {
      value += location.search;
    }

    const currentState = window.history.state;

    if (currentState && currentState.value === value) {
      return;
    }

    if (swiper.params.history.replaceState) {
      window.history.replaceState({
        value
      }, null, value);
    } else {
      window.history.pushState({
        value
      }, null, value);
    }
  };

  const scrollToSlide = (speed, value, runCallbacks) => {
    if (value) {
      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHistory = slugify(slide.attr('data-history'));

        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  };

  const setHistoryPopState = () => {
    paths = getPathValues(swiper.params.url);
    scrollToSlide(swiper.params.speed, paths.value, false);
  };

  const init = () => {
    const window = getWindow();
    if (!swiper.params.history) return;

    if (!window.history || !window.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }

    initialized = true;
    paths = getPathValues(swiper.params.url);
    if (!paths.key && !paths.value) return;
    scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);

    if (!swiper.params.history.replaceState) {
      window.addEventListener('popstate', setHistoryPopState);
    }
  };

  const destroy = () => {
    const window = getWindow();

    if (!swiper.params.history.replaceState) {
      window.removeEventListener('popstate', setHistoryPopState);
    }
  };

  on('init', () => {
    if (swiper.params.history.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.history.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/hash-navigation/hash-navigation.js


function HashNavigation({
  swiper,
  extendParams,
  emit,
  on
}) {
  let initialized = false;
  const document = getDocument();
  const window = getWindow();
  extendParams({
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false
    }
  });

  const onHashChange = () => {
    emit('hashChange');
    const newHash = document.location.hash.replace('#', '');
    const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');

    if (newHash !== activeSlideHash) {
      const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
      if (typeof newIndex === 'undefined') return;
      swiper.slideTo(newIndex);
    }
  };

  const setHash = () => {
    if (!initialized || !swiper.params.hashNavigation.enabled) return;

    if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
      window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
      emit('hashSet');
    } else {
      const slide = swiper.slides.eq(swiper.activeIndex);
      const hash = slide.attr('data-hash') || slide.attr('data-history');
      document.location.hash = hash || '';
      emit('hashSet');
    }
  };

  const init = () => {
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    initialized = true;
    const hash = document.location.hash.replace('#', '');

    if (hash) {
      const speed = 0;

      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHash = slide.attr('data-hash') || slide.attr('data-history');

        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }

    if (swiper.params.hashNavigation.watchState) {
      $(window).on('hashchange', onHashChange);
    }
  };

  const destroy = () => {
    if (swiper.params.hashNavigation.watchState) {
      $(window).off('hashchange', onHashChange);
    }
  };

  on('init', () => {
    if (swiper.params.hashNavigation.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.hashNavigation.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHash();
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHash();
    }
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/autoplay/autoplay.js
/* eslint no-underscore-dangle: "off" */

/* eslint no-use-before-define: "off" */


function Autoplay({
  swiper,
  extendParams,
  on,
  emit
}) {
  let timeout;
  swiper.autoplay = {
    running: false,
    paused: false
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });

  function run() {
    if (!swiper.size) {
      swiper.autoplay.running = false;
      swiper.autoplay.paused = false;
      return;
    }

    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    let delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(timeout);
    timeout = nextTick(() => {
      let autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          emit('autoplay');
        } else {
          stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        emit('autoplay');
      } else {
        stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) run();else if (autoplayResult === false) {
        run();
      }
    }, delay);
  }

  function start() {
    if (typeof timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    emit('autoplayStart');
    run();
    return true;
  }

  function stop() {
    if (!swiper.autoplay.running) return false;
    if (typeof timeout === 'undefined') return false;

    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
    }

    swiper.autoplay.running = false;
    emit('autoplayStop');
    return true;
  }

  function pause(speed) {
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (timeout) clearTimeout(timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(event => {
        swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
      });
    }
  }

  function onVisibilityChange() {
    const document = getDocument();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      run();
      swiper.autoplay.paused = false;
    }
  }

  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      stop();
    } else {
      run();
    }
  }

  function onMouseEnter() {
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
    } else {
      emit('autoplayPause');
      pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
  }

  function onMouseLeave() {
    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    emit('autoplayResume');
    run();
  }

  function attachMouseEvents() {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', onMouseEnter);
      swiper.$el.on('mouseleave', onMouseLeave);
    }
  }

  function detachMouseEvents() {
    swiper.$el.off('mouseenter', onMouseEnter);
    swiper.$el.off('mouseleave', onMouseLeave);
  }

  on('init', () => {
    if (swiper.params.autoplay.enabled) {
      start();
      const document = getDocument();
      document.addEventListener('visibilitychange', onVisibilityChange);
      attachMouseEvents();
    }
  });
  on('beforeTransitionStart', (_s, speed, internal) => {
    if (swiper.autoplay.running) {
      if (internal || !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.pause(speed);
      } else {
        stop();
      }
    }
  });
  on('sliderFirstMove', () => {
    if (swiper.autoplay.running) {
      if (swiper.params.autoplay.disableOnInteraction) {
        stop();
      } else {
        pause();
      }
    }
  });
  on('touchEnd', () => {
    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
      run();
    }
  });
  on('destroy', () => {
    detachMouseEvents();

    if (swiper.autoplay.running) {
      stop();
    }

    const document = getDocument();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  });
  Object.assign(swiper.autoplay, {
    pause,
    run,
    start,
    stop
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/thumbs/thumbs.js


function Thumb({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-thumbs'
    }
  });
  let initialized = false;
  let swiperCreated = false;
  swiper.thumbs = {
    swiper: null
  };

  function onThumbClick() {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const clickedIndex = thumbsSwiper.clickedIndex;
    const clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    let slideToIndex;

    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }

    if (swiper.params.loop) {
      let currentIndex = swiper.activeIndex;

      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }

      const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
    }

    swiper.slideTo(slideToIndex);
  }

  function init() {
    const {
      thumbs: thumbsParams
    } = swiper.params;
    if (initialized) return false;
    initialized = true;
    const SwiperClass = swiper.constructor;

    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if (isObject(thumbsParams.swiper)) {
      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }

    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', onThumbClick);
    return true;
  }

  function update(initial) {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs

    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }

    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.removeClass(thumbActiveClass);

    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
      }
    } else {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
      }
    }

    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      let currentThumbsIndex = thumbsSwiper.activeIndex;
      let newThumbsIndex;
      let direction;

      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix(); // eslint-disable-next-line

          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        } // Find actual thumbs index to slide to


        const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
        const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();

        if (typeof prevThumbsIndex === 'undefined') {
          newThumbsIndex = nextThumbsIndex;
        } else if (typeof nextThumbsIndex === 'undefined') {
          newThumbsIndex = prevThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = nextThumbsIndex;
        } else {
          newThumbsIndex = prevThumbsIndex;
        }

        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }

      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }

      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) {// newThumbsIndex = newThumbsIndex - slidesPerView + 1;
        }

        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    }
  }

  on('beforeInit', () => {
    const {
      thumbs
    } = swiper.params;
    if (!thumbs || !thumbs.swiper) return;
    init();
    update(true);
  });
  on('slideChange update resize observerUpdate', () => {
    update();
  });
  on('setTransition', (_s, duration) => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    thumbsSwiper.setTransition(duration);
  });
  on('beforeDestroy', () => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;

    if (swiperCreated) {
      thumbsSwiper.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init,
    update
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/free-mode/free-mode.js

function freeMode({
  swiper,
  extendParams,
  emit,
  once
}) {
  extendParams({
    freeMode: {
      enabled: false,
      momentum: true,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: false,
      minimumVelocity: 0.02
    }
  });

  function onTouchStart() {
    const translate = swiper.getTranslate();
    swiper.setTranslate(translate);
    swiper.setTransition(0);
    swiper.touchEventsData.velocities.length = 0;
    swiper.freeMode.onTouchEnd({
      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
    });
  }

  function onTouchMove() {
    const {
      touchEventsData: data,
      touches
    } = swiper; // Velocity

    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: utils_now()
    });
  }

  function onTouchEnd({
    currentPos
  }) {
    const {
      params,
      $wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper; // Time diff

    const touchEndTime = utils_now();
    const timeDiff = touchEndTime - data.touchStartTime;

    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop();
        const velocityEvent = data.velocities.pop();
        const distance = lastMoveEvent.position - velocityEvent.position;
        const time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || utils_now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeMode.momentumVelocityRatio;
      data.velocities.length = 0;
      let momentumDuration = 1000 * params.freeMode.momentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;
      let newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      let doBounce = false;
      let afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      let needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeMode.sticky) {
        let nextSlide;

        for (let j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        once('transitionEnd', () => {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeMode.sticky) {
          // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeMode.momentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(() => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(() => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(() => {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }

  Object.assign(swiper, {
    freeMode: {
      onTouchStart,
      onTouchMove,
      onTouchEnd
    }
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/effect-cube/effect-cube.js


function EffectCube({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });

  const createSlideShadows = ($slideEl, progress, isHorizontal) => {
    let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
    let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

    if (shadowBefore.length === 0) {
      shadowBefore = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
      $slideEl.append(shadowBefore);
    }

    if (shadowAfter.length === 0) {
      shadowAfter = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
      $slideEl.append(shadowAfter);
    }

    if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
    if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
  };

  const recreateShadows = () => {
    // create new ones
    const isHorizontal = swiper.isHorizontal();
    swiper.slides.each(slideEl => {
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      createSlideShadows($(slideEl), progress, isHorizontal);
    });
  };

  const setTranslate = () => {
    const {
      $el,
      $wrapperEl,
      slides,
      width: swiperWidth,
      height: swiperHeight,
      rtlTranslate: rtl,
      size: swiperSize,
      browser
    } = swiper;
    const params = swiper.params.cubeEffect;
    const isHorizontal = swiper.isHorizontal();
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let wrapperRotate = 0;
    let $cubeShadowEl;

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }

        $cubeShadowEl.css({
          height: `${swiperWidth}px`
        });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      let slideIndex = i;

      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }

      let slideAngle = slideIndex * 90;
      let round = Math.floor(slideAngle / 360);

      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }

      const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      let tx = 0;
      let ty = 0;
      let tz = 0;

      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }

      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;

      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }

      $slideEl.transform(transform);

      if (params.slideShadows) {
        createSlideShadows($slideEl, progress, isHorizontal);
      }
    }

    $wrapperEl.css({
      '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
      'transform-origin': `50% 50% -${swiperSize / 2}px`
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
      } else {
        const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        const scale1 = params.shadowScale;
        const scale2 = params.shadowScale / multiplier;
        const offset = params.shadowOffset;
        $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
      }
    }

    const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
    $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
    $wrapperEl[0].style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
  };

  const setTransition = duration => {
    const {
      $el,
      slides
    } = swiper;
    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  };

  effectInit({
    effect: 'cube',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.cubeEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: false,
      virtualTranslate: true
    })
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/shared/create-shadow.js

function create_shadow_createShadow(params, $slideEl, side) {
  const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
  const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
  let $shadowEl = $shadowContainer.children(`.${shadowClass}`);

  if (!$shadowEl.length) {
    $shadowEl = $(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
    $shadowContainer.append($shadowEl);
  }

  return $shadowEl;
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/effect-flip/effect-flip.js





function EffectFlip({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    flipEffect: {
      slideShadows: true,
      limitRotation: true,
      transformEl: null
    }
  });

  const createSlideShadows = ($slideEl, progress, params) => {
    let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
    let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

    if (shadowBefore.length === 0) {
      shadowBefore = createShadow(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
    }

    if (shadowAfter.length === 0) {
      shadowAfter = createShadow(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
    }

    if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
    if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
  };

  const recreateShadows = () => {
    // Set shadows
    const params = swiper.params.flipEffect;
    swiper.slides.each(slideEl => {
      const $slideEl = $(slideEl);
      let progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }

      createSlideShadows($slideEl, progress, params);
    });
  };

  const setTranslate = () => {
    const {
      slides,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.flipEffect;

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      let progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }

      const offset = $slideEl[0].swiperSlideOffset;
      const rotate = -180 * progress;
      let rotateY = rotate;
      let rotateX = 0;
      let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (params.slideShadows) {
        createSlideShadows($slideEl, progress, params);
      }

      const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform);
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.flipEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl
    });
  };

  effectInit({
    effect: 'flip',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.flipEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/effect-coverflow/effect-coverflow.js



function EffectCoverflow({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true,
      transformEl: null
    }
  });

  const setTranslate = () => {
    const {
      width: swiperWidth,
      height: swiperHeight,
      slides,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.coverflowEffect;
    const isHorizontal = swiper.isHorizontal();
    const transform = swiper.translate;
    const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    const rotate = isHorizontal ? params.rotate : -params.rotate;
    const translate = params.depth; // Each slide offset from center

    for (let i = 0, length = slides.length; i < length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideSize = slidesSizesGrid[i];
      const slideOffset = $slideEl[0].swiperSlideOffset;
      const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
      const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
      let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

      let translateZ = -translate * Math.abs(offsetMultiplier);
      let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders

      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = parseFloat(params.stretch) / 100 * slideSize;
      }

      let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
      let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
      let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values

      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;
      const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;

      if (params.slideShadows) {
        // Set shadows
        let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = createShadow(params, $slideEl, isHorizontal ? 'left' : 'top');
        }

        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = createShadow(params, $slideEl, isHorizontal ? 'right' : 'bottom');
        }

        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.coverflowEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  };

  effectInit({
    effect: 'coverflow',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true
    })
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/effect-creative/effect-creative.js




function EffectCreative({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    creativeEffect: {
      transformEl: null,
      limitProgress: 1,
      shadowPerProgress: false,
      progressMultiplier: 1,
      perspective: true,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });

  const getTranslateValue = value => {
    if (typeof value === 'string') return value;
    return `${value}px`;
  };

  const setTranslate = () => {
    const {
      slides,
      $wrapperEl,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.creativeEffect;
    const {
      progressMultiplier: multiplier
    } = params;
    const isCenteredSlides = swiper.params.centeredSlides;

    if (isCenteredSlides) {
      const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
      $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
    }

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideProgress = $slideEl[0].progress;
      const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
      let originalProgress = progress;

      if (!isCenteredSlides) {
        originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
      }

      const offset = $slideEl[0].swiperSlideOffset;
      const t = [swiper.params.cssMode ? -offset - swiper.translate : -offset, 0, 0];
      const r = [0, 0, 0];
      let custom = false;

      if (!swiper.isHorizontal()) {
        t[1] = t[0];
        t[0] = 0;
      }

      let data = {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        scale: 1,
        opacity: 1
      };

      if (progress < 0) {
        data = params.next;
        custom = true;
      } else if (progress > 0) {
        data = params.prev;
        custom = true;
      } // set translate


      t.forEach((value, index) => {
        t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
      }); // set rotates

      r.forEach((value, index) => {
        r[index] = data.rotate[index] * Math.abs(progress * multiplier);
      });
      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const translateString = t.join(', ');
      const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
      const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
      const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
      const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows

      if (custom && data.shadow || !custom) {
        let $shadowEl = $slideEl.children('.swiper-slide-shadow');

        if ($shadowEl.length === 0 && data.shadow) {
          $shadowEl = createShadow(params, $slideEl);
        }

        if ($shadowEl.length) {
          const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
          $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
        }
      }

      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform).css({
        opacity: opacityString
      });

      if (data.origin) {
        $targetEl.css('transform-origin', data.origin);
      }
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.creativeEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl,
      allSlides: true
    });
  };

  effectInit({
    effect: 'creative',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => swiper.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/modules/effect-cards/effect-cards.js




function EffectCards({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    cardsEffect: {
      slideShadows: true,
      transformEl: null,
      rotate: true,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  });

  const setTranslate = () => {
    const {
      slides,
      activeIndex
    } = swiper;
    const params = swiper.params.cardsEffect;
    const {
      startTranslate,
      isTouched
    } = swiper.touchEventsData;
    const currentTranslate = swiper.translate;

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideProgress = $slideEl[0].progress;
      const progress = Math.min(Math.max(slideProgress, -4), 4);
      let offset = $slideEl[0].swiperSlideOffset;

      if (swiper.params.centeredSlides && !swiper.params.cssMode) {
        swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
      }

      if (swiper.params.centeredSlides && swiper.params.cssMode) {
        offset -= slides[0].swiperSlideOffset;
      }

      let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let tY = 0;
      const tZ = -100 * Math.abs(progress);
      let scale = 1;
      let rotate = -params.perSlideRotate * progress;
      let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
      const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
      const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
      const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;

      if (isSwipeToNext || isSwipeToPrev) {
        const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
        rotate += -28 * progress * subProgress;
        scale += -0.5 * subProgress;
        tXAdd += 96 * subProgress;
        tY = `${-25 * subProgress * Math.abs(progress)}%`;
      }

      if (progress < 0) {
        // next
        tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
      } else if (progress > 0) {
        // prev
        tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
      } else {
        tX = `${tX}px`;
      }

      if (!swiper.isHorizontal()) {
        const prevY = tY;
        tY = tX;
        tX = prevY;
      }

      const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
      const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;

      if (params.slideShadows) {
        // Set shadows
        let $shadowEl = $slideEl.find('.swiper-slide-shadow');

        if ($shadowEl.length === 0) {
          $shadowEl = createShadow(params, $slideEl);
        }

        if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform);
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.cardsEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl
    });
  };

  effectInit({
    effect: 'cards',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ../../node_modules/swiper/swiper.esm.js
/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */


























;// CONCATENATED MODULE: ../../node_modules/swiper/components-shared/utils.js
function components_shared_utils_isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function components_shared_utils_extend(target, src) {
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (components_shared_utils_isObject(src[key]) && components_shared_utils_isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else components_shared_utils_extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params = {}) {
  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params = {}) {
  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params = {}) {
  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames = '') {
  const classes = classNames.split(' ').map(c => c.trim()).filter(c => !!c);
  const unique = [];
  classes.forEach(c => {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}


;// CONCATENATED MODULE: ../../node_modules/swiper/components-shared/params-list.js
/* underscore in name -> watch for changes */
const paramsList = ['modules', 'init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', 'maxBackfaceHiddenSlides', '_grid', '_slidesPerGroup', '_slidesPerGroupSkip', '_slidesPerGroupAuto', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopedSlidesLimit', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_rewind', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', '_autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'creativeEffect', 'cardsEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

;// CONCATENATED MODULE: ../../node_modules/swiper/components-shared/get-params.js




function getParams(obj = {}, splitEvents = true) {
  const params = {
    on: {}
  };
  const events = {};
  const passedParams = {};
  components_shared_utils_extend(params, core.defaults);
  components_shared_utils_extend(params, core.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map(key => key.replace(/_/, ''));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach(key => {
    if (typeof obj[key] === 'undefined') return;

    if (allowedParams.indexOf(key) >= 0) {
      if (components_shared_utils_isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        components_shared_utils_extend(params[key], obj[key]);
        components_shared_utils_extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      if (splitEvents) {
        events[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(key => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events
  };
}


;// CONCATENATED MODULE: ../../node_modules/swiper/components-shared/mount-swiper.js


function mountSwiper({
  el,
  nextEl,
  prevEl,
  paginationEl,
  scrollbarEl,
  swiper
}, swiperParams) {
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}


;// CONCATENATED MODULE: ../../node_modules/swiper/shared/calc-looped-slides.js

const calcLoopedSlides = (slides, swiperParams) => {
  let slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    const breakpoint = core.prototype.getBreakpoint(swiperParams.breakpoints);
    const breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  let loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length && swiperParams.loopedSlidesLimit) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
};
;// CONCATENATED MODULE: ../../node_modules/swiper/react/loop.js



function renderLoop(swiper, slides, swiperParams) {
  const modifiedSlides = slides.map((child, index) => {
    return /*#__PURE__*/react.cloneElement(child, {
      swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/react.cloneElement(child, {
      key: `${child.key}-duplicate-${index}-${position}`,
      className: `${child.props.className || ''} ${swiperParams.slideDuplicateClass}`
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    const blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankSlide = /*#__PURE__*/react.createElement("div", {
          className: `${swiperParams.slideClass} ${swiperParams.slideBlankClass}`
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  const loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  const prependSlides = [];
  const appendSlides = [];

  for (let i = 0; i < loopedSlides; i += 1) {
    const index = i - Math.floor(i / modifiedSlides.length) * modifiedSlides.length;
    appendSlides.push(duplicateSlide(modifiedSlides[index], i, 'append'));
    prependSlides.unshift(duplicateSlide(modifiedSlides[modifiedSlides.length - index - 1], i, 'prepend'));
  }

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [...prependSlides, ...modifiedSlides, ...appendSlides];
}


;// CONCATENATED MODULE: ../../node_modules/swiper/components-shared/get-changed-params.js



function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;

  const addKey = key => {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
  }

  const watchParams = paramsList.filter(key => key[0] === '_').map(key => key.replace(/_/, ''));
  watchParams.forEach(key => {
    if (key in swiperParams && key in oldParams) {
      if (components_shared_utils_isObject(swiperParams[key]) && components_shared_utils_isObject(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(newKey => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(oldKey => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}


;// CONCATENATED MODULE: ../../node_modules/swiper/react/get-children.js


function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}

function processChildren(c) {
  const slides = [];
  react.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(slide => slides.push(slide));
    }
  });
  return slides;
}

function get_children_getChildren(c) {
  const slides = [];
  const slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  react.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(slide => slides.push(slide));
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides,
    slots
  };
}


;// CONCATENATED MODULE: ../../node_modules/swiper/components-shared/update-swiper.js


function updateSwiper({
  swiper,
  slides,
  passedParams,
  changedParams,
  nextEl,
  prevEl,
  scrollbarEl,
  paginationEl
}) {
  const updateParams = changedParams.filter(key => key !== 'children' && key !== 'direction');
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  const destroyModule = mod => {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(key => {
    if (components_shared_utils_isObject(currentParams[key]) && components_shared_utils_isObject(passedParams[key])) {
      components_shared_utils_extend(currentParams[key], passedParams[key]);
    } else {
      const newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}


;// CONCATENATED MODULE: ../../node_modules/swiper/react/virtual.js


function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? 'right' : 'left']: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  return slides.filter((child, index) => index >= virtualData.from && index <= virtualData.to).map(child => {
    return /*#__PURE__*/react.cloneElement(child, {
      swiper,
      style
    });
  });
}


;// CONCATENATED MODULE: ../../node_modules/swiper/components-shared/update-on-virtual-data.js
const updateOnVirtualData = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};
;// CONCATENATED MODULE: ../../node_modules/swiper/react/use-isomorphic-layout-effect.js


function use_isomorphic_layout_effect_useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return (0,react.useEffect)(callback, deps);
  return (0,react.useLayoutEffect)(callback, deps);
}


;// CONCATENATED MODULE: ../../node_modules/swiper/react/context.js

const SwiperSlideContext = /*#__PURE__*/(0,react.createContext)(null);
const useSwiperSlide = () => {
  return useContext(SwiperSlideContext);
};
const SwiperContext = /*#__PURE__*/(0,react.createContext)(null);
const useSwiper = () => {
  return useContext(SwiperContext);
};
;// CONCATENATED MODULE: ../../node_modules/swiper/react/swiper.js
function swiper_extends() { swiper_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return swiper_extends.apply(this, arguments); }














const swiper_Swiper = /*#__PURE__*/(0,react.forwardRef)(function (_temp, externalElRef) {
  let {
    className,
    tag: Tag = 'div',
    wrapperTag: WrapperTag = 'div',
    children,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = (0,react.useState)('swiper');
  const [virtualData, setVirtualData] = (0,react.useState)(null);
  const [breakpointChanged, setBreakpointChanged] = (0,react.useState)(false);
  const initializedRef = (0,react.useRef)(false);
  const swiperElRef = (0,react.useRef)(null);
  const swiperRef = (0,react.useRef)(null);
  const oldPassedParamsRef = (0,react.useRef)(null);
  const oldSlides = (0,react.useRef)(null);
  const nextElRef = (0,react.useRef)(null);
  const prevElRef = (0,react.useRef)(null);
  const paginationElRef = (0,react.useRef)(null);
  const scrollbarElRef = (0,react.useRef)(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events
  } = getParams(rest);
  const {
    slides,
    slots
  } = get_children_getChildren(children);

  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }

  });

  const initSwiper = () => {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = new core(swiperParams);

    swiperRef.current.loopCreate = () => {};

    swiperRef.current.loopDestroy = () => {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      components_shared_utils_extend(swiperRef.current.params.virtual, extendWith);
      components_shared_utils_extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };

  if (!swiperElRef.current) {
    initSwiper();
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  const attachEvents = () => {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  const detachEvents = () => {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  (0,react.useEffect)(() => {
    return () => {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  (0,react.useEffect)(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  use_isomorphic_layout_effect_useIsomorphicLayoutEffect(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;

    if (swiperRef.current.destroyed) {
      initSwiper();
    }

    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  use_isomorphic_layout_effect_useIsomorphicLayoutEffect(() => {
    attachEvents();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, c => c.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return () => {
      detachEvents();
    };
  }); // update on virtual update

  use_isomorphic_layout_effect_useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(child => {
        return /*#__PURE__*/react.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/react.createElement(Tag, swiper_extends({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ''}`)
  }, restProps), /*#__PURE__*/react.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots['container-start'], /*#__PURE__*/react.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), needsNavigation(swiperParams) && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/react.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots['container-end']));
});
swiper_Swiper.displayName = 'Swiper';

;// CONCATENATED MODULE: ../../node_modules/swiper/react/swiper-slide.js
function swiper_slide_extends() { swiper_slide_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return swiper_slide_extends.apply(this, arguments); }





const SwiperSlide = /*#__PURE__*/(0,react.forwardRef)(function (_temp, externalRef) {
  let {
    tag: Tag = 'div',
    children,
    className = '',
    swiper,
    zoom,
    virtualIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = (0,react.useRef)(null);
  const [slideClasses, setSlideClasses] = (0,react.useState)('swiper-slide');

  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  use_isomorphic_layout_effect_useIsomorphicLayoutEffect(() => {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return () => {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  use_isomorphic_layout_effect_useIsomorphicLayoutEffect(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
    isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
    isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
    isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
    isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
  };

  const renderChildren = () => {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/react.createElement(Tag, swiper_slide_extends({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ''}`),
    "data-swiper-slide-index": virtualIndex
  }, rest), /*#__PURE__*/react.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, zoom ? /*#__PURE__*/react.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren()));
});
SwiperSlide.displayName = 'SwiperSlide';

;// CONCATENATED MODULE: ../../node_modules/swiper/react/swiper-react.js
/**
 * Swiper React 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */





// EXTERNAL MODULE: ../../node_modules/swiper/swiper-bundle.css
var swiper_bundle = __webpack_require__(26047);
// EXTERNAL MODULE: ../../node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(84988);
// EXTERNAL MODULE: ../../packages/infra/components/lib/SwiperJS/styles.ts
var SwiperJS_styles = __webpack_require__(7090);
;// CONCATENATED MODULE: ../../packages/infra/components/lib/SwiperJS/index.tsx










var SwiperSlider = function(param) {
    var subComponents = param.subComponents, position = param.position, getBreakpoints = param.getBreakpoints, configs = param.configs;
    var ref, ref1;
    var isBlackFridayTheme = (0,application/* useBlackFriday */.R4_)((0,application/* useShallow */.NL6)(function(state) {
        return {
            isBlackFridayTheme: state.isBlackFridayTheme
        };
    })).isBlackFridayTheme;
    var nextButtonId = "nextButton-".concat(position);
    var prevButtonId = "prevButton-".concat(position);
    var breakPoint = getBreakpoints();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwiperJS_styles/* SwiperContainer */.mn, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_Swiper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                modules: [
                    freeMode,
                    Scrollbar,
                    A11y,
                    Pagination,
                    Navigation
                ],
                navigation: {
                    nextEl: "#".concat(nextButtonId),
                    prevEl: "#".concat(prevButtonId)
                }
            }, configs), {
                children: subComponents === null || subComponents === void 0 ? void 0 : subComponents.map(function(subComponent, index) {
                    return(// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperSlide, {
                        children: subComponent
                    }, "".concat(index)));
                })
            })),
            (configs === null || configs === void 0 ? void 0 : (ref = configs.breakpoints) === null || ref === void 0 ? void 0 : (ref1 = ref["".concat(breakPoint)]) === null || ref1 === void 0 ? void 0 : ref1.showNavigation) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwiperJS_styles/* NavButtonsContainer */.VK, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperJS_styles/* NavButtonPrev */.r, {
                        isBlackTheme: isBlackFridayTheme,
                        id: prevButtonId,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowCarouselLeft, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperJS_styles/* NavButtonNext */.KS, {
                        isBlackTheme: isBlackFridayTheme,
                        id: nextButtonId,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui.ArrowCarouselRight, {})
                    })
                ]
            })
        ]
    });
};


// EXTERNAL MODULE: ../../node_modules/swr/dist/index.mjs
var swr_dist = __webpack_require__(49857);
;// CONCATENATED MODULE: ../../packages/infra/components/lib/SWRConfig/index.tsx


var CustomSWRConfig = function(param) {
    var children = param.children, fallback = param.fallback;
    return /*#__PURE__*/ _jsx(SWRConfig, {
        value: {
            fallback: fallback
        },
        children: children
    });
};


// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
;// CONCATENATED MODULE: ../../packages/infra/components/lib/ScrollToLink/index.tsx





var ScrollToLink = function(param) {
    var to = param.to, spy = param.spy, offset = param.offset, activeClass = param.activeClass, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("scroll-to-link-item")), {
        activeClass: activeClass,
        offset: offset,
        spy: spy,
        to: to,
        children: children
    }));
};
var EventScroll = modules/* animateScroll */.NY;

// EXTERNAL MODULE: ../../packages/infra/components/lib/MagicZoom/index.tsx
var MagicZoom = __webpack_require__(89959);
// EXTERNAL MODULE: ../../node_modules/react-multi-email/dist/es6/index.js
var es6 = __webpack_require__(35293);
// EXTERNAL MODULE: ../../node_modules/react-multi-email/dist/style.css
var dist_style = __webpack_require__(95818);
;// CONCATENATED MODULE: ../../packages/infra/components/lib/MultiEmailInput/index.tsx









var MultiEmailInput = function(_param) {
    var id = _param.id, emails = _param.emails, placeholder = _param.placeholder, handlerChange = _param.handlerChange, props = _object_without_properties(_param, [
        "id",
        "emails",
        "placeholder",
        "handlerChange"
    ]);
    var ref = useState(false), setFocused = ref[1];
    var removeEmailButton = function(email, index, removeEmail) {
        return /*#__PURE__*/ _createElement("div", _object_spread_props(_object_spread({}, buildTestIds("form-input-multi-email-tag-".concat(id))), {
            "data-tag": true,
            key: index,
            children: [
                /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, buildTestIds("form-input-multi-email-tag-item-".concat(id))), {
                    "data-tag-item": true,
                    children: email
                })),
                /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({}, buildTestIds("form-input-multi-email-tag-handle-".concat(id))), {
                    type: "button",
                    "data-tag-handle": true,
                    onClick: function() {
                        return removeEmail(index);
                    },
                    onKeyDown: function() {
                        return removeEmail(index);
                    },
                    children: "\xd7"
                }))
            ]
        }));
    };
    return /*#__PURE__*/ _jsx(ReactMultiEmail, _object_spread_props(_object_spread({
        id: id
    }, props), {
        placeholder: placeholder,
        emails: emails,
        autoFocus: false,
        onChange: handlerChange,
        onFocus: function() {
            return setFocused(true);
        },
        onBlur: function() {
            return setFocused(false);
        },
        getLabel: function(emailIndex, index, removeEmail) {
            return removeEmailButton(emailIndex, index, removeEmail);
        }
    }));
};


;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactEasyCrop/styles.ts

function ReactEasyCrop_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  margin: 0;\n\n  .reactEasyCrop_Container {\n    height: 250px;\n    position: relative;\n  }\n"
    ]);
    ReactEasyCrop_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ReactEasyCrop_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-top: 24px;\n  padding: 0 24px;\n"
    ]);
    ReactEasyCrop_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ReactEasyCrop_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  appearance: none;\n  width: 100%;\n  margin: 0;\n  height: ",
        ";\n  cursor: pointer;\n\n  /* Webkit */\n  &::-webkit-slider-runnable-track {\n    overflow: hidden;\n    width: 100%;\n    height: ",
        ";\n    background: linear-gradient(to bottom, ",
        ", ",
        ")\n      100% 50% / 100% ",
        " no-repeat transparent;\n  }\n  &::-webkit-slider-thumb {\n    position: relative;\n    appearance: none;\n    height: ",
        "px;\n    width: ",
        "px;\n    background: ",
        ";\n    border-radius: 100%;\n    border: 1px solid ",
        ";\n    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.09);\n    top: 50%;\n    transform: translateY(-50%);\n    box-shadow: ",
        ";\n    transition: background-color 150ms;\n  }\n\n  /* Firefox */\n  &::-moz-range-track,\n  &::-moz-range-progress {\n    width: 100%;\n    height: ",
        ";\n    background: ",
        ";\n  }\n  &::-moz-range-progress {\n    background: ",
        ";\n  }\n\n  &::-moz-range-thumb {\n    appearance: none;\n    height: ",
        ";\n    width: ",
        ";\n    background: ",
        ";\n    border-radius: 100%;\n    border: 1px solid ",
        ";\n    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.09);\n    transition: background-color 150ms;\n  }\n"
    ]);
    ReactEasyCrop_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var makeLongShadow = function(color, size) {
    var shadowLength = 700;
    return Array.from({
        length: shadowLength
    }, function(_, i) {
        return "".concat(i + 18, "px 0 0 ").concat(size, " ").concat(color);
    }).join(", ");
};
var styles_height = "36px";
var trackHeight = "8px";
var thumbHeight = 30;
var barColor = ui.theme.colors.neutral[99];
var progressColor = ui.theme.colors.secondary[265];
var upperBackground = "linear-gradient(to bottom, ".concat(barColor, ", ").concat(barColor, ") 100% 50% / 100% ").concat(trackHeight, " no-repeat transparent");
var lowerBackground = "linear-gradient(to bottom, ".concat(progressColor, ", ").concat(progressColor, ") 100% 50% / 100% ").concat(trackHeight, " no-repeat transparent");
var styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-982bf092-0"
})(ReactEasyCrop_styles_templateObject());
var styles_RangeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RangeContainer",
    componentId: "sc-982bf092-1"
})(ReactEasyCrop_styles_templateObject1());
var styles_RangeInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "styles__RangeInput",
    componentId: "sc-982bf092-2"
})(ReactEasyCrop_styles_templateObject2(), styles_height, styles_height, progressColor, progressColor, trackHeight, thumbHeight, thumbHeight, ui.theme.colors.neutral.white, ui.theme.colors.neutral[99], makeLongShadow(barColor, "-10px"), styles_height, upperBackground, lowerBackground, thumbHeight, thumbHeight, ui.theme.colors.neutral.white, ui.theme.colors.neutral[99]);

;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactEasyCrop/index.tsx






var ReactEasyCrop = function(param) {
    var imageInfo = param.imageInfo, croppedImage = param.croppedImage;
    var ref = useState({
        x: 0,
        y: 0
    }), crop = ref[0], setCrop = ref[1];
    var ref1 = useState(1), zoom = ref1[0], setZoom = ref1[1];
    var onCropComplete = useCallback(function() {
        var _ref = _async_to_generator(function(_, croppedAreaPixels) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            new Promise(function() {
                                var image = new Image();
                                image.src = (imageInfo === null || imageInfo === void 0 ? void 0 : imageInfo.imageSrc) || "";
                                image.onload = function() {
                                    var canvas = document.createElement("canvas");
                                    var ctx = canvas.getContext("2d");
                                    canvas.width = croppedAreaPixels.width;
                                    canvas.height = croppedAreaPixels.height;
                                    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(image, croppedAreaPixels.x, croppedAreaPixels.y, croppedAreaPixels.width, croppedAreaPixels.height, 0, 0, croppedAreaPixels.width, croppedAreaPixels.height);
                                    canvas.toBlob(function(blob) {
                                        if (blob) {
                                            var file = new File([
                                                blob
                                            ], (imageInfo === null || imageInfo === void 0 ? void 0 : imageInfo.name) || "", {
                                                type: imageInfo === null || imageInfo === void 0 ? void 0 : imageInfo.type
                                            });
                                            croppedImage(file);
                                        }
                                    }, imageInfo === null || imageInfo === void 0 ? void 0 : imageInfo.type, 0.7);
                                };
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(_, croppedAreaPixels) {
            return _ref.apply(this, arguments);
        };
    }(), [
        imageInfo,
        croppedImage
    ]);
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(Cropper, {
                image: imageInfo === null || imageInfo === void 0 ? void 0 : imageInfo.imageSrc,
                crop: crop,
                zoom: zoom,
                showGrid: false,
                cropShape: (imageInfo === null || imageInfo === void 0 ? void 0 : imageInfo.formatPhoto) === "Profile" ? "round" : "rect",
                onCropChange: setCrop,
                onZoomChange: setZoom,
                onCropComplete: onCropComplete,
                cropSize: imageInfo.formatPhoto === "Profile" ? {
                    width: 215,
                    height: 215
                } : {
                    width: 300,
                    height: 100
                }
            }),
            /*#__PURE__*/ _jsx(RangeContainer, {
                children: /*#__PURE__*/ _jsx(RangeInput, {
                    type: "range",
                    value: zoom,
                    min: 1,
                    max: 3,
                    step: 0.1,
                    onChange: function(e) {
                        return setZoom(Number(e.target.value));
                    }
                })
            })
        ]
    });
};


// EXTERNAL MODULE: ../../node_modules/detect-it/lib/index.js
var detect_it_lib = __webpack_require__(35878);
// EXTERNAL MODULE: ../../node_modules/next/dist/build/polyfills/object-assign.js
var object_assign = __webpack_require__(4079);
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);
// EXTERNAL MODULE: ../../node_modules/react-image-magnify/node_modules/prop-types/index.js
var prop_types = __webpack_require__(23406);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var node_modules_prop_types = __webpack_require__(13980);
var node_modules_prop_types_default = /*#__PURE__*/__webpack_require__.n(node_modules_prop_types);
// EXTERNAL MODULE: ../../node_modules/object.omit/index.js
var object_omit = __webpack_require__(13000);
var object_omit_default = /*#__PURE__*/__webpack_require__.n(object_omit);
;// CONCATENATED MODULE: ../../node_modules/react-cursor-position/dist/es/lib/ElementRelativeCursorPosition.js
var ElementRelativeCursorPosition_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ElementRelativeCursorPosition = function () {
    function ElementRelativeCursorPosition(el) {
        _classCallCheck(this, ElementRelativeCursorPosition);

        this.el = el;
    }

    ElementRelativeCursorPosition_createClass(ElementRelativeCursorPosition, [{
        key: "getDocumentRelativeElementOffset",
        value: function getDocumentRelativeElementOffset(el) {
            var rootEl = this.getRootOfEl(el);

            var _rootEl$getBoundingCl = rootEl.getBoundingClientRect(),
                docLeft = _rootEl$getBoundingCl.left,
                docTop = _rootEl$getBoundingCl.top;

            var _el$getBoundingClient = el.getBoundingClientRect(),
                elLeft = _el$getBoundingClient.left,
                elTop = _el$getBoundingClient.top;

            return {
                x: Math.abs(docLeft) + elLeft,
                y: Math.abs(docTop) + elTop
            };
        }
    }, {
        key: "getRootOfEl",
        value: function getRootOfEl(el) {
            if (el.parentElement) {
                return this.getRootOfEl(el.parentElement);
            }
            return el;
        }
    }, {
        key: "getComputedElementRelativeCursorPosition",
        value: function getComputedElementRelativeCursorPosition(event, documentRelativeElementOffset) {
            this.lastEvent = event;
            var position = this.getDocumentRelativeCursorPosition(event);
            var cursorX = position.x,
                cursorY = position.y;
            var offsetX = documentRelativeElementOffset.x,
                offsetY = documentRelativeElementOffset.y;


            return {
                x: Math.round(cursorX - offsetX),
                y: Math.round(cursorY - offsetY)
            };
        }
    }, {
        key: "getDocumentRelativeCursorPosition",
        value: function getDocumentRelativeCursorPosition(event) {
            return {
                x: event.pageX,
                y: event.pageY
            };
        }
    }, {
        key: "getCursorPosition",
        value: function getCursorPosition(event) {
            return this.getComputedElementRelativeCursorPosition(event, this.documentRelativeElementOffset);
        }
    }, {
        key: "documentRelativeElementOffset",
        get: function get() {
            if (!this.elementOffset) {
                this.elementOffset = this.getDocumentRelativeElementOffset(this.el);
            }

            return this.elementOffset;
        }
    }]);

    return ElementRelativeCursorPosition;
}();

/* harmony default export */ var lib_ElementRelativeCursorPosition = (ElementRelativeCursorPosition);
;// CONCATENATED MODULE: ../../node_modules/react-cursor-position/dist/es/utils/addEventListener.js
function addEventListener(node, eventName, handler, options) {
    node.addEventListener(eventName, handler, options);
    return {
        removeEventListener: function removeEventListener() {
            node.removeEventListener(eventName, handler, options);
        }
    };
}
;// CONCATENATED MODULE: ../../node_modules/react-cursor-position/dist/es/constants.js
var PRESS_EVENT_TIMER_NAME = 'pressEvent';
var MOUSE_EMULATION_GUARD_TIMER_NAME = 'mouseEmulation';
var SET_ACTIVATION_TIMER_NAME = 'setHovering';
var UNSET_ACTIVATION_TIMER_NAME = 'unsetHovering';
;// CONCATENATED MODULE: ../../node_modules/react-cursor-position/dist/es/utils/noop.js
/* harmony default export */ var utils_noop = (function () {});
;// CONCATENATED MODULE: ../../node_modules/react-cursor-position/dist/es/ReactCursorPosition.js
var ReactCursorPosition_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ReactCursorPosition_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
        ReactCursorPosition_classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            detectedEnvironment: {
                isMouseDetected: false,
                isTouchDetected: false
            },
            elementDimensions: {
                width: 0,
                height: 0
            },
            isActive: false,
            isPositionOutside: true,
            position: {
                x: 0,
                y: 0
            }
        };

        _this.shouldGuardAgainstMouseEmulationByDevices = false;
        _this.eventListeners = [];
        _this.timers = [];
        _this.elementOffset = {
            x: 0,
            y: 0
        };

        _this.onTouchStart = _this.onTouchStart.bind(_this);
        _this.onTouchMove = _this.onTouchMove.bind(_this);
        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
        _this.onTouchCancel = _this.onTouchCancel.bind(_this);
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        return _this;
    }

    ReactCursorPosition_createClass(_class, [{
        key: 'onTouchStart',
        value: function onTouchStart(e) {
            this.init();
            this.onTouchDetected();
            this.setShouldGuardAgainstMouseEmulationByDevices();

            var position = this.core.getCursorPosition(this.getTouchEvent(e));
            this.setPositionState(position);

            if (this.props.isActivatedOnTouch) {
                e.preventDefault();
                this.activate();
                return;
            }

            this.initPressEventCriteria(position);
            this.setPressEventTimer();
        }
    }, {
        key: 'onTouchMove',
        value: function onTouchMove(e) {
            if (!this.isCoreReady) {
                return;
            }

            var position = this.core.getCursorPosition(this.getTouchEvent(e));

            if (!this.state.isActive) {
                this.setPressEventCriteria(position);
                return;
            }

            this.setPositionState(position);
            e.preventDefault();

            if (this.props.shouldStopTouchMovePropagation) {
                e.stopPropagation();
            }
        }
    }, {
        key: 'onTouchEnd',
        value: function onTouchEnd() {
            this.deactivate();
            this.unsetShouldGuardAgainstMouseEmulationByDevices();
        }
    }, {
        key: 'onTouchCancel',
        value: function onTouchCancel() {
            this.deactivate();
            this.unsetShouldGuardAgainstMouseEmulationByDevices();
        }
    }, {
        key: 'onMouseEnter',
        value: function onMouseEnter(e) {
            if (this.shouldGuardAgainstMouseEmulationByDevices) {
                return;
            }

            this.init();
            this.onMouseDetected();
            this.setPositionState(this.core.getCursorPosition(e));
            this.clearActivationTimers();
            this.schedulActivation(this.props.hoverDelayInMs);
        }
    }, {
        key: 'onMouseMove',
        value: function onMouseMove(e) {
            if (!this.isCoreReady) {
                return;
            }

            this.setPositionState(this.core.getCursorPosition(e));
        }
    }, {
        key: 'onMouseLeave',
        value: function onMouseLeave() {
            this.clearActivationTimers();
            this.scheduleDeactivation(this.props.hoverOffDelayInMs);
            this.setState({ isPositionOutside: true });
        }
    }, {
        key: 'onTouchDetected',
        value: function onTouchDetected() {
            var environment = {
                isTouchDetected: true,
                isMouseDetected: false
            };

            this.setState({ detectedEnvironment: environment });
            this.props.onDetectedEnvironmentChanged(environment);
        }
    }, {
        key: 'onMouseDetected',
        value: function onMouseDetected() {
            var environment = {
                isTouchDetected: false,
                isMouseDetected: true
            };

            this.setState({ detectedEnvironment: environment });
            this.props.onDetectedEnvironmentChanged(environment);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.isEnabled) {
                this.enable();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var willBeEnabled = _ref.isEnabled;
            var isEnabled = this.props.isEnabled;

            var isEnabledWillChange = isEnabled !== willBeEnabled;

            if (!isEnabledWillChange) {
                return;
            }

            if (willBeEnabled) {
                this.enable();
            } else {
                this.disable();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimers();
            this.disable();
        }
    }, {
        key: 'enable',
        value: function enable() {
            this.addEventListeners();
        }
    }, {
        key: 'disable',
        value: function disable() {
            this.removeEventListeners();
        }
    }, {
        key: 'init',
        value: function init() {
            this.core = new lib_ElementRelativeCursorPosition(this.el);

            this.setElementDimensionsState(this.getElementDimensions(this.el));
        }
    }, {
        key: 'reset',
        value: function reset() {
            var _core = this.core;
            _core = _core === undefined ? {} : _core;
            var lastMouseEvent = _core.lastEvent;


            this.init();

            if (!lastMouseEvent) {
                return;
            }

            this.setPositionState(this.core.getCursorPosition(lastMouseEvent));
        }
    }, {
        key: 'activate',
        value: function activate() {
            this.setState({ isActive: true });
            this.props.onActivationChanged({ isActive: true });
        }
    }, {
        key: 'deactivate',
        value: function deactivate() {
            var _this2 = this;

            this.clearTimer(PRESS_EVENT_TIMER_NAME);

            this.setState({ isActive: false }, function () {
                var _state = _this2.state,
                    isPositionOutside = _state.isPositionOutside,
                    position = _state.position;


                _this2.props.onPositionChanged({
                    isPositionOutside: isPositionOutside,
                    position: position
                });

                _this2.props.onActivationChanged({ isActive: false });
            });
        }
    }, {
        key: 'setPositionState',
        value: function setPositionState(position) {
            var isPositionOutside = this.getIsPositionOutside(position);

            this.setState({
                isPositionOutside: isPositionOutside,
                position: position
            }, this.onPositionChanged);
        }
    }, {
        key: 'setElementDimensionsState',
        value: function setElementDimensionsState(dimensions) {
            this.setState({
                elementDimensions: dimensions
            });
        }
    }, {
        key: 'schedulActivation',
        value: function schedulActivation(schedule) {
            var _this3 = this;

            var scheduleId = setTimeout(function () {
                _this3.activate();
            }, schedule);

            this.timers.push({
                id: scheduleId,
                name: SET_ACTIVATION_TIMER_NAME
            });
        }
    }, {
        key: 'scheduleDeactivation',
        value: function scheduleDeactivation(schedule) {
            var _this4 = this;

            var scheduleId = setTimeout(function () {
                _this4.deactivate();
            }, schedule);

            this.timers.push({
                id: scheduleId,
                name: UNSET_ACTIVATION_TIMER_NAME
            });
        }
    }, {
        key: 'clearActivationTimers',
        value: function clearActivationTimers() {
            this.clearTimer(SET_ACTIVATION_TIMER_NAME);
            this.clearTimer(UNSET_ACTIVATION_TIMER_NAME);
        }
    }, {
        key: 'setPressEventTimer',
        value: function setPressEventTimer() {
            var _this5 = this;

            var _props = this.props,
                pressDuration = _props.pressDuration,
                pressMoveThreshold = _props.pressMoveThreshold;


            this.timers.push({
                name: PRESS_EVENT_TIMER_NAME,
                id: setTimeout(function () {
                    if (Math.abs(_this5.currentElTop - _this5.initialElTop) < pressMoveThreshold) {
                        _this5.activate();
                    }
                }, pressDuration)
            });
        }
    }, {
        key: 'setPressEventCriteria',
        value: function setPressEventCriteria(position) {
            this.currentElTop = position.y;
        }
    }, {
        key: 'initPressEventCriteria',
        value: function initPressEventCriteria(position) {
            var top = position.y;
            this.initialElTop = top;
            this.currentElTop = top;
        }
    }, {
        key: 'setShouldGuardAgainstMouseEmulationByDevices',
        value: function setShouldGuardAgainstMouseEmulationByDevices() {
            this.shouldGuardAgainstMouseEmulationByDevices = true;
        }
    }, {
        key: 'unsetShouldGuardAgainstMouseEmulationByDevices',
        value: function unsetShouldGuardAgainstMouseEmulationByDevices() {
            var _this6 = this;

            this.timers.push({
                name: MOUSE_EMULATION_GUARD_TIMER_NAME,
                id: setTimeout(function () {
                    _this6.shouldGuardAgainstMouseEmulationByDevices = false;
                }, 0)
            });
        }
    }, {
        key: 'clearTimers',
        value: function clearTimers() {
            var timers = this.timers;
            while (timers.length) {
                var timer = timers.pop();
                clearTimeout(timer.id);
            }
        }
    }, {
        key: 'clearTimer',
        value: function clearTimer(timerName) {
            this.timers.forEach(function (timer) {
                if (timer.name === timerName) {
                    clearTimeout(timer.id);
                }
            });
        }
    }, {
        key: 'getElementDimensions',
        value: function getElementDimensions(el) {
            var _el$getBoundingClient = el.getBoundingClientRect(),
                width = _el$getBoundingClient.width,
                height = _el$getBoundingClient.height;

            return {
                width: width,
                height: height
            };
        }
    }, {
        key: 'getIsPositionOutside',
        value: function getIsPositionOutside(position) {
            var x = position.x,
                y = position.y;
            var _state$elementDimensi = this.state.elementDimensions,
                width = _state$elementDimensi.width,
                height = _state$elementDimensi.height;


            var isPositionOutside = x < 0 || y < 0 || x > width || y > height;

            return isPositionOutside;
        }
    }, {
        key: 'getTouchEvent',
        value: function getTouchEvent(e) {
            return e.touches[0];
        }
    }, {
        key: 'getIsReactComponent',
        value: function getIsReactComponent(reactElement) {
            return typeof reactElement.type === 'function';
        }
    }, {
        key: 'shouldDecorateChild',
        value: function shouldDecorateChild(child) {
            return !!child && this.getIsReactComponent(child) && this.props.shouldDecorateChildren;
        }
    }, {
        key: 'decorateChild',
        value: function decorateChild(child, props) {
            return (0,react.cloneElement)(child, props);
        }
    }, {
        key: 'decorateChildren',
        value: function decorateChildren(children, props) {
            var _this7 = this;

            return react.Children.map(children, function (child) {
                return _this7.shouldDecorateChild(child) ? _this7.decorateChild(child, props) : child;
            });
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.eventListeners.push(addEventListener(this.el, 'touchstart', this.onTouchStart, { passive: false }), addEventListener(this.el, 'touchmove', this.onTouchMove, { passive: false }), addEventListener(this.el, 'touchend', this.onTouchEnd), addEventListener(this.el, 'touchcancel', this.onTouchCancel), addEventListener(this.el, 'mouseenter', this.onMouseEnter), addEventListener(this.el, 'mousemove', this.onMouseMove), addEventListener(this.el, 'mouseleave', this.onMouseLeave));
        }
    }, {
        key: 'removeEventListeners',
        value: function removeEventListeners() {
            while (this.eventListeners.length) {
                this.eventListeners.pop().removeEventListener();
            }
        }
    }, {
        key: 'getPassThroughProps',
        value: function getPassThroughProps() {
            var ownPropNames = Object.keys(this.constructor.propTypes);
            return object_omit_default()(this.props, ownPropNames);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this8 = this;

            var _props2 = this.props,
                children = _props2.children,
                className = _props2.className,
                mapChildProps = _props2.mapChildProps,
                style = _props2.style;

            var props = object_assign_default()({}, mapChildProps(this.state), this.getPassThroughProps());

            return react.createElement(
                'div',
                {
                    className: className,
                    ref: function ref(el) {
                        return _this8.el = el;
                    },
                    style: object_assign_default()({}, style, {
                        WebkitUserSelect: 'none'
                    })
                },
                this.decorateChildren(children, props)
            );
        }
    }, {
        key: 'isCoreReady',
        get: function get() {
            return !!this.core;
        }
    }]);

    return _class;
}(react.Component);

_class.displayName = 'ReactCursorPosition';
_class.propTypes = {
    children: (node_modules_prop_types_default()).any,
    className: (node_modules_prop_types_default()).string,
    hoverDelayInMs: (node_modules_prop_types_default()).number,
    hoverOffDelayInMs: (node_modules_prop_types_default()).number,
    isActivatedOnTouch: (node_modules_prop_types_default()).bool,
    isEnabled: (node_modules_prop_types_default()).bool,
    mapChildProps: (node_modules_prop_types_default()).func,
    onActivationChanged: (node_modules_prop_types_default()).func,
    onPositionChanged: (node_modules_prop_types_default()).func,
    onDetectedEnvironmentChanged: (node_modules_prop_types_default()).func,
    pressDuration: (node_modules_prop_types_default()).number,
    pressMoveThreshold: (node_modules_prop_types_default()).number,
    shouldDecorateChildren: (node_modules_prop_types_default()).bool,
    shouldStopTouchMovePropagation: (node_modules_prop_types_default()).bool,
    style: (node_modules_prop_types_default()).object
};
_class.defaultProps = {
    isActivatedOnTouch: false,
    isEnabled: true,
    hoverDelayInMs: 0,
    hoverOffDelayInMs: 0,
    mapChildProps: function mapChildProps(props) {
        return props;
    },
    onActivationChanged: utils_noop,
    onPositionChanged: utils_noop,
    onDetectedEnvironmentChanged: utils_noop,
    pressDuration: 500,
    pressMoveThreshold: 5,
    shouldDecorateChildren: true,
    shouldStopTouchMovePropagation: false
};

var _initialiseProps = function _initialiseProps() {
    var _this9 = this;

    this.onPositionChanged = function () {
        var onPositionChanged = _this9.props.onPositionChanged;

        onPositionChanged(_this9.state);
    };
};

/* harmony default export */ var ReactCursorPosition = (_class);
// EXTERNAL MODULE: ../../node_modules/clamp/index.js
var clamp = __webpack_require__(45936);
var clamp_default = /*#__PURE__*/__webpack_require__.n(clamp);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lib/imageRatio.js

function getSmallToLargeImageRatio(smallImage, largeImage) {
    return getSmallToLargeElementRatio(smallImage, largeImage);
}

function getLargeToSmallImageRatio(smallImage, largeImage) {
    return {
        x: smallImage.width / largeImage.width,
        y: smallImage.height / largeImage.height
    };
}

function getContainerToImageRatio(container, image) {
    return getSmallToLargeElementRatio(container, {
        width: image.width - container.width,
        height: image.height - container.height
    });
}

function getSmallToLargeElementRatio(smallElement, largeElement) {
    return {
        x: largeElement.width / smallElement.width,
        y: largeElement.height / smallElement.height
    };
}
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lib/imageCoordinates.js



function getMinCoordinates(container, largeImage) {
    return {
        x: (largeImage.width - container.width) * -1,
        y: (largeImage.height - container.height) * -1
    };
}

function getMaxCoordinates() {
    return {
        x: 0,
        y: 0
    };
}

function getLensModeEnlargedImageCoordinates(_ref) {
    var containerDimensions = _ref.containerDimensions,
        lensCursorOffset = _ref.cursorOffset,
        largeImage = _ref.largeImage,
        position = _ref.position,
        smallImage = _ref.smallImage;

    var adjustedPosition = getCursorPositionAdjustedForLens(position, lensCursorOffset);
    var ratio = getSmallToLargeImageRatio(smallImage, largeImage);
    var coordinates = {
        x: Math.round(adjustedPosition.x * ratio.x) * -1,
        y: Math.round(adjustedPosition.y * ratio.y) * -1
    };
    var minCoordinates = getMinCoordinates(containerDimensions, largeImage);
    var maxCoordinates = getMaxCoordinates();

    return clampImageCoordinates(coordinates, minCoordinates, maxCoordinates);
}

function getInPlaceEnlargedImageCoordinates(_ref2) {
    var containerDimensions = _ref2.containerDimensions,
        largeImage = _ref2.largeImage,
        position = _ref2.position;

    var minCoordinates = getMinCoordinates(containerDimensions, largeImage);
    var maxCoordinates = getMaxCoordinates();
    var ratio = getContainerToImageRatio(containerDimensions, largeImage);
    var coordinates = {
        x: Math.round(position.x * ratio.x) * -1,
        y: Math.round(position.y * ratio.y) * -1
    };

    return clampImageCoordinates(coordinates, minCoordinates, maxCoordinates);
}

function clampImageCoordinates(imageCoordinates, minCoordinates, maxCoordinates) {
    return {
        x: clamp_default()(imageCoordinates.x, minCoordinates.x, maxCoordinates.x),
        y: clamp_default()(imageCoordinates.y, minCoordinates.y, maxCoordinates.y)
    };
}

function getCursorPositionAdjustedForLens(position, lensCursorOffset) {
    return {
        x: position.x - lensCursorOffset.x,
        y: position.y - lensCursorOffset.y
    };
}
// EXTERNAL MODULE: ../../node_modules/react-required-if/index.js
var react_required_if = __webpack_require__(33606);
var react_required_if_default = /*#__PURE__*/__webpack_require__.n(react_required_if);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/prop-types/Image.js




var BaseImageShape = {
    alt: (prop_types_default()).string,
    src: (prop_types_default()).string.isRequired,
    srcSet: (prop_types_default()).string,
    sizes: (prop_types_default()).string,
    onLoad: (prop_types_default()).func,
    onError: (prop_types_default()).func
};

var LargeImageShape = prop_types_default().shape(object_assign_default()({}, BaseImageShape, {
    width: (prop_types_default()).number.isRequired,
    height: (prop_types_default()).number.isRequired
}));

var SmallImageShape = prop_types_default().shape(object_assign_default()({}, BaseImageShape, {
    isFluidWidth: (prop_types_default()).bool,
    width: react_required_if_default()((prop_types_default()).number, function (props) {
        return !props.isFluidWidth;
    }),
    height: react_required_if_default()((prop_types_default()).number, function (props) {
        return !props.isFluidWidth;
    })
}));
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/constants/index.js
var INPUT_TYPE = {
    mouse: 'mouse',
    touch: 'touch'
};

var ENLARGED_IMAGE_POSITION = {
    over: 'over',
    beside: 'beside'
};
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/prop-types/EnlargedImage.js



var EnlargedImagePosition = prop_types_default().oneOf([ENLARGED_IMAGE_POSITION.beside, ENLARGED_IMAGE_POSITION.over]);

var EnlargedImageContainerDimensions = prop_types_default().shape({
    width: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
    height: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string])
});

var ContainerDimensions = prop_types_default().shape({
    width: (prop_types_default()).number,
    height: (prop_types_default()).number
});
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/utils/index.js
function es_utils_noop() {}
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/prop-types/Point.js


/* harmony default export */ var Point = (prop_types_default().shape({
    x: (prop_types_default()).number.isRequired,
    y: (prop_types_default()).number.isRequired
}));
// EXTERNAL MODULE: ../../node_modules/react-image-magnify/node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(31496);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lib/styles.js



function getContainerStyle(smallImage, userSpecifiedStyle) {
    var isSmallImageFluidWidth = smallImage.isFluidWidth,
        width = smallImage.width,
        height = smallImage.height;


    var fluidWidthContainerStyle = {
        width: 'auto',
        height: 'auto',
        fontSize: '0px',
        position: 'relative'
    };

    var fixedWidthContainerStyle = {
        width: width + 'px',
        height: height + 'px',
        position: 'relative'
    };

    var priorityContainerStyle = isSmallImageFluidWidth ? fluidWidthContainerStyle : fixedWidthContainerStyle;

    var compositContainerStyle = object_assign_default()({ cursor: 'crosshair' }, userSpecifiedStyle, priorityContainerStyle);

    return compositContainerStyle;
}

function getSmallImageStyle(smallImage, style) {
    var isSmallImageFluidWidth = smallImage.isFluidWidth,
        width = smallImage.width,
        height = smallImage.height;


    var fluidWidthSmallImageStyle = {
        width: '100%',
        height: 'auto',
        display: 'block',
        pointerEvents: 'none'
    };

    var fixedWidthSmallImageStyle = {
        width: width + 'px',
        height: height + 'px',
        pointerEvents: 'none'
    };

    var prioritySmallImageStyle = isSmallImageFluidWidth ? fluidWidthSmallImageStyle : fixedWidthSmallImageStyle;

    var compositSmallImageStyle = object_assign_default()({}, style, prioritySmallImageStyle);

    return compositSmallImageStyle;
}

function getPrimaryEnlargedImageContainerStyle(isInPlaceMode, isPortalRendered) {
    var baseContainerStyle = {
        overflow: 'hidden'
    };

    if (isPortalRendered) {
        return baseContainerStyle;
    }

    var sharedPositionStyle = {
        position: 'absolute',
        top: '0px'
    };

    if (isInPlaceMode) {
        return object_assign_default()(baseContainerStyle, sharedPositionStyle, { left: '0px' });
    }

    return object_assign_default()(baseContainerStyle, sharedPositionStyle, {
        left: '100%',
        marginLeft: '10px',
        border: '1px solid #d6d6d6'
    });
}

function getPriorityEnlargedImageContainerStyle(params) {
    var containerDimensions = params.containerDimensions,
        fadeDurationInMs = params.fadeDurationInMs,
        isTransitionActive = params.isTransitionActive;


    return {
        width: containerDimensions.width,
        height: containerDimensions.height,
        opacity: isTransitionActive ? 1 : 0,
        transition: 'opacity ' + fadeDurationInMs + 'ms ease-in',
        pointerEvents: 'none'
    };
}

var enlargedImageContainerStyleCache = {};

function getEnlargedImageContainerStyle(params) {
    var cache = enlargedImageContainerStyleCache;
    var _cache$params = cache.params,
        memoizedParams = _cache$params === undefined ? {} : _cache$params,
        memoizedStyle = cache.compositStyle;


    if (fast_deep_equal_default()(memoizedParams, params)) {
        return memoizedStyle;
    }

    var containerDimensions = params.containerDimensions,
        userSpecifiedStyle = params.containerStyle,
        fadeDurationInMs = params.fadeDurationInMs,
        isTransitionActive = params.isTransitionActive,
        isInPlaceMode = params.isInPlaceMode,
        isPortalRendered = params.isPortalRendered;


    var primaryStyle = getPrimaryEnlargedImageContainerStyle(isInPlaceMode, isPortalRendered);
    var priorityStyle = getPriorityEnlargedImageContainerStyle({
        containerDimensions: containerDimensions,
        fadeDurationInMs: fadeDurationInMs,
        isTransitionActive: isTransitionActive
    });

    cache.compositStyle = object_assign_default()({}, primaryStyle, userSpecifiedStyle, priorityStyle);
    cache.params = params;

    return cache.compositStyle;
}

function getEnlargedImageStyle(params) {
    var imageCoordinates = params.imageCoordinates,
        userSpecifiedStyle = params.imageStyle,
        largeImage = params.largeImage;


    var translate = 'translate(' + imageCoordinates.x + 'px, ' + imageCoordinates.y + 'px)';

    var priorityStyle = {
        width: largeImage.width,
        height: largeImage.height,
        transform: translate,
        WebkitTransform: translate,
        msTransform: translate,
        pointerEvents: 'none'
    };

    var compositeImageStyle = object_assign_default()({}, userSpecifiedStyle, priorityStyle);

    return compositeImageStyle;
}
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/EnlargedImage.js
var EnlargedImage_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function EnlargedImage_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EnlargedImage_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EnlargedImage_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var EnlargedImage_class = function (_React$Component) {
    EnlargedImage_inherits(_class, _React$Component);

    function _class(props) {
        EnlargedImage_classCallCheck(this, _class);

        var _this = EnlargedImage_possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

        _this.state = {
            isTransitionEntering: false,
            isTransitionActive: false,
            isTransitionLeaving: false,
            isTransitionDone: false
        };

        _this.timers = [];
        return _this;
    }

    EnlargedImage_createClass(_class, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.scheduleCssTransition(nextProps);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.timers.forEach(function (timerId) {
                clearTimeout(timerId);
            });
        }
    }, {
        key: 'scheduleCssTransition',
        value: function scheduleCssTransition(nextProps) {
            var _this2 = this;

            var _props = this.props,
                fadeDurationInMs = _props.fadeDurationInMs,
                isActive = _props.isActive,
                isPositionOutside = _props.isPositionOutside;

            var willIsActiveChange = isActive !== nextProps.isActive;
            var willIsPositionOutsideChange = isPositionOutside !== nextProps.isPositionOutside;

            if (!willIsActiveChange && !willIsPositionOutsideChange) {
                return;
            }

            if (nextProps.isActive && !nextProps.isPositionOutside) {
                this.setState({
                    isTrainsitionDone: false,
                    isTransitionEntering: true
                });

                this.timers.push(setTimeout(function () {
                    _this2.setState({
                        isTransitionEntering: false,
                        isTransitionActive: true
                    });
                }, 0));
            } else {
                this.setState({
                    isTransitionLeaving: true,
                    isTransitionActive: false
                });

                this.timers.push(setTimeout(function () {
                    _this2.setState({
                        isTransitionDone: true,
                        isTransitionLeaving: false
                    });
                }, fadeDurationInMs));
            }
        }
    }, {
        key: 'getImageCoordinates',
        value: function getImageCoordinates() {
            var _props2 = this.props,
                cursorOffset = _props2.cursorOffset,
                largeImage = _props2.largeImage,
                containerDimensions = _props2.containerDimensions,
                position = _props2.position,
                smallImage = _props2.smallImage,
                isInPlaceMode = _props2.isInPlaceMode;


            if (isInPlaceMode) {
                return getInPlaceEnlargedImageCoordinates({
                    containerDimensions: containerDimensions,
                    largeImage: largeImage,
                    position: position
                });
            }

            return getLensModeEnlargedImageCoordinates({
                containerDimensions: containerDimensions,
                cursorOffset: cursorOffset,
                largeImage: largeImage,
                position: position,
                smallImage: smallImage
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                containerClassName = _props3.containerClassName,
                imageClassName = _props3.imageClassName,
                isLazyLoaded = _props3.isLazyLoaded,
                largeImage = _props3.largeImage,
                _props3$largeImage = _props3.largeImage,
                _props3$largeImage$al = _props3$largeImage.alt,
                alt = _props3$largeImage$al === undefined ? '' : _props3$largeImage$al,
                _props3$largeImage$on = _props3$largeImage.onLoad,
                onLoad = _props3$largeImage$on === undefined ? es_utils_noop : _props3$largeImage$on,
                _props3$largeImage$on2 = _props3$largeImage.onError,
                onError = _props3$largeImage$on2 === undefined ? es_utils_noop : _props3$largeImage$on2;


            var component = react.createElement(
                'div',
                {
                    className: containerClassName,
                    style: this.containerStyle
                },
                react.createElement('img', {
                    alt: alt,
                    className: imageClassName,
                    src: largeImage.src,
                    srcSet: largeImage.srcSet,
                    sizes: largeImage.sizes,
                    style: this.imageStyle,
                    onLoad: onLoad,
                    onError: onError
                })
            );

            if (isLazyLoaded) {
                return this.isVisible ? component : null;
            }

            return component;
        }
    }, {
        key: 'isVisible',
        get: function get() {
            var _state = this.state,
                isTransitionEntering = _state.isTransitionEntering,
                isTransitionActive = _state.isTransitionActive,
                isTransitionLeaving = _state.isTransitionLeaving;


            return isTransitionEntering || isTransitionActive || isTransitionLeaving;
        }
    }, {
        key: 'containerStyle',
        get: function get() {
            var _props4 = this.props,
                containerStyle = _props4.containerStyle,
                containerDimensions = _props4.containerDimensions,
                fadeDurationInMs = _props4.fadeDurationInMs,
                isPortalRendered = _props4.isPortalRendered,
                isInPlaceMode = _props4.isInPlaceMode;
            var isTransitionActive = this.state.isTransitionActive;


            return getEnlargedImageContainerStyle({
                containerDimensions: containerDimensions,
                containerStyle: containerStyle,
                fadeDurationInMs: fadeDurationInMs,
                isTransitionActive: isTransitionActive,
                isInPlaceMode: isInPlaceMode,
                isPortalRendered: isPortalRendered
            });
        }
    }, {
        key: 'imageStyle',
        get: function get() {
            var _props5 = this.props,
                imageStyle = _props5.imageStyle,
                largeImage = _props5.largeImage;


            return getEnlargedImageStyle({
                imageCoordinates: this.getImageCoordinates(),
                imageStyle: imageStyle,
                largeImage: largeImage
            });
        }
    }]);

    return _class;
}(react.Component);

EnlargedImage_class.displayName = 'EnlargedImage';
EnlargedImage_class.defaultProps = {
    fadeDurationInMs: 0,
    isLazyLoaded: true
};
EnlargedImage_class.propTypes = {
    containerClassName: (prop_types_default()).string,
    containerStyle: (prop_types_default()).object,
    cursorOffset: Point,
    position: Point,
    fadeDurationInMs: (prop_types_default()).number,
    imageClassName: (prop_types_default()).string,
    imageStyle: (prop_types_default()).object,
    isActive: (prop_types_default()).bool,
    isLazyLoaded: (prop_types_default()).bool,
    largeImage: LargeImageShape,
    containerDimensions: ContainerDimensions,
    isPortalRendered: (prop_types_default()).bool,
    isInPlaceMode: (prop_types_default()).bool
};
/* harmony default export */ var EnlargedImage = (EnlargedImage_class);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/RenderEnlargedImage.js
var RenderEnlargedImage_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function RenderEnlargedImage_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RenderEnlargedImage_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function RenderEnlargedImage_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var RenderEnlargedImage = function (_Component) {
    RenderEnlargedImage_inherits(RenderEnlargedImage, _Component);

    function RenderEnlargedImage() {
        var _ref;

        var _temp, _this, _ret;

        RenderEnlargedImage_classCallCheck(this, RenderEnlargedImage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = RenderEnlargedImage_possibleConstructorReturn(this, (_ref = RenderEnlargedImage.__proto__ || Object.getPrototypeOf(RenderEnlargedImage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isMounted: false }, _temp), RenderEnlargedImage_possibleConstructorReturn(_this, _ret);
    }

    RenderEnlargedImage_createClass(RenderEnlargedImage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ isMounted: true });

            if (this.isPortalRendered) {
                var portalId = this.props.portalId;

                this.portalElement = document.getElementById(portalId);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.isMounted) {
                return null;
            }

            var props = this.compositProps;

            if (this.isPortalRendered) {
                return react_dom.createPortal(react.createElement(EnlargedImage, props), this.portalElement);
            }

            return react.createElement(EnlargedImage, props);
        }
    }, {
        key: 'isPortalIdImplemented',
        get: function get() {
            return !!this.props.portalId;
        }
    }, {
        key: 'isPortalRendered',
        get: function get() {
            var _props = this.props,
                isPortalEnabledForTouch = _props.isPortalEnabledForTouch,
                isTouchDetected = _props.isTouchDetected;


            if (!this.isPortalIdImplemented) {
                return false;
            }

            if (!isTouchDetected) {
                return true;
            }

            if (isPortalEnabledForTouch) {
                return true;
            }

            return false;
        }
    }, {
        key: 'isMounted',
        get: function get() {
            return this.state.isMounted;
        }
    }, {
        key: 'compositProps',
        get: function get() {
            return object_assign_default()({}, this.props, { isPortalRendered: this.isPortalRendered });
        }
    }]);

    return RenderEnlargedImage;
}(react.Component);

RenderEnlargedImage.propTypes = {
    isPortalEnabledForTouch: (prop_types_default()).bool.isRequired,
    isTouchDetected: (prop_types_default()).bool.isRequired,
    portalId: (prop_types_default()).string
};
/* harmony default export */ var es_RenderEnlargedImage = (RenderEnlargedImage);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lens/negative-space/Lens.js




var Lens = function Lens(props) {
    var fadeDurationInMs = props.fadeDurationInMs,
        isActive = props.isActive,
        isPositionOutside = props.isPositionOutside,
        parentSpecifiedStyle = props.style;


    var defaultStyle = {
        width: 'auto',
        height: 'auto',
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto',
        display: 'block'
    };

    var computedStyle = {
        position: 'absolute',
        opacity: isActive && !isPositionOutside ? 1 : 0,
        transition: 'opacity ' + fadeDurationInMs + 'ms ease-in'
    };

    var compositStyle = object_assign_default()({}, defaultStyle, parentSpecifiedStyle, computedStyle);

    return react.createElement('div', { style: compositStyle });
};

Lens.propTypes = {
    style: (prop_types_default()).object,
    fadeDurationInMs: (prop_types_default()).number,
    isActive: (prop_types_default()).bool,
    translateX: (prop_types_default()).number,
    translateY: (prop_types_default()).number,
    userStyle: (prop_types_default()).object
};

Lens.defaultProps = {
    isActive: false,
    fadeDurationInMs: 0,
    translateX: 0,
    translateY: 0
};

/* harmony default export */ var negative_space_Lens = (Lens);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/prop-types/Lens.js




/* harmony default export */ var prop_types_Lens = ({
    cursorOffset: Point,
    fadeDurationInMs: (prop_types_default()).number,
    isActive: (prop_types_default()).bool,
    isPositionOutside: (prop_types_default()).bool,
    position: Point,
    smallImage: SmallImageShape,
    style: (prop_types_default()).object
});
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lens/negative-space/LensTop.js






var LensTop = function LensTop(_ref) {
    var cursorOffset = _ref.cursorOffset,
        position = _ref.position,
        fadeDurationInMs = _ref.fadeDurationInMs,
        isActive = _ref.isActive,
        isPositionOutside = _ref.isPositionOutside,
        smallImage = _ref.smallImage,
        parentSpecifiedStyle = _ref.style;

    var clearLensHeight = cursorOffset.y * 2;
    var maxHeight = smallImage.height - clearLensHeight;
    var height = clamp_default()(position.y - cursorOffset.y, 0, maxHeight);
    var computedStyle = {
        height: height + 'px',
        width: '100%',
        top: '0px'
    };

    return react.createElement(negative_space_Lens, {
        fadeDurationInMs: fadeDurationInMs,
        isActive: isActive,
        isPositionOutside: isPositionOutside,
        style: object_assign_default()({}, parentSpecifiedStyle, computedStyle)
    });
};

LensTop.propTypes = prop_types_Lens;

/* harmony default export */ var negative_space_LensTop = (LensTop);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lens/negative-space/LensLeft.js






var LensLeft = function LensLeft(_ref) {
    var cursorOffset = _ref.cursorOffset,
        position = _ref.position,
        fadeDurationInMs = _ref.fadeDurationInMs,
        isActive = _ref.isActive,
        isPositionOutside = _ref.isPositionOutside,
        smallImage = _ref.smallImage,
        parentSpecifiedStyle = _ref.style;

    var clearLensHeight = cursorOffset.y * 2;
    var clearLensWidth = cursorOffset.x * 2;
    var maxHeight = smallImage.height - clearLensHeight;
    var maxWidth = smallImage.width - clearLensWidth;
    var height = clearLensHeight;
    var width = clamp_default()(position.x - cursorOffset.x, 0, maxWidth);
    var top = clamp_default()(position.y - cursorOffset.y, 0, maxHeight);
    var computedStyle = {
        height: height + 'px',
        width: width + 'px',
        top: top + 'px',
        left: '0px'
    };

    return react.createElement(negative_space_Lens, {
        fadeDurationInMs: fadeDurationInMs,
        isActive: isActive,
        isPositionOutside: isPositionOutside,
        style: object_assign_default()({}, parentSpecifiedStyle, computedStyle)
    });
};

LensLeft.propTypes = prop_types_Lens;

/* harmony default export */ var negative_space_LensLeft = (LensLeft);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lens/negative-space/LensRight.js






var LensRight = function LensRight(_ref) {
    var cursorOffset = _ref.cursorOffset,
        position = _ref.position,
        fadeDurationInMs = _ref.fadeDurationInMs,
        isActive = _ref.isActive,
        isPositionOutside = _ref.isPositionOutside,
        smallImage = _ref.smallImage,
        parentSpecifiedStyle = _ref.style;

    var clearLensHeight = cursorOffset.y * 2;
    var clearLensWidth = cursorOffset.x * 2;
    var maxHeight = smallImage.height - clearLensHeight;
    var maxWidth = smallImage.width - clearLensWidth;
    var height = clearLensHeight;
    var width = clamp_default()(smallImage.width - position.x - cursorOffset.x, 0, maxWidth);
    var top = clamp_default()(position.y - cursorOffset.y, 0, maxHeight);
    var computedStyle = {
        height: height + 'px',
        width: width + 'px',
        top: top + 'px',
        right: '0px'
    };

    return react.createElement(negative_space_Lens, {
        fadeDurationInMs: fadeDurationInMs,
        isActive: isActive,
        isPositionOutside: isPositionOutside,
        style: object_assign_default()({}, parentSpecifiedStyle, computedStyle)
    });
};

LensRight.propTypes = prop_types_Lens;

/* harmony default export */ var negative_space_LensRight = (LensRight);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lens/negative-space/LensBottom.js






var LensBottom = function LensBottom(_ref) {
    var cursorOffset = _ref.cursorOffset,
        position = _ref.position,
        fadeDurationInMs = _ref.fadeDurationInMs,
        isActive = _ref.isActive,
        isPositionOutside = _ref.isPositionOutside,
        smallImage = _ref.smallImage,
        parentSpecifiedStyle = _ref.style;


    var clearLensHeight = cursorOffset.y * 2;
    var computedHeight = smallImage.height - position.y - cursorOffset.y;
    var maxHeight = smallImage.height - clearLensHeight;
    var height = clamp_default()(computedHeight, 0, maxHeight);
    var clearLensBottom = position.y + cursorOffset.y;
    var top = Math.max(clearLensBottom, clearLensHeight);
    var computedStyle = {
        height: height + 'px',
        width: '100%',
        top: top + 'px'
    };

    return react.createElement(negative_space_Lens, {
        fadeDurationInMs: fadeDurationInMs,
        isActive: isActive,
        isPositionOutside: isPositionOutside,
        style: object_assign_default()({}, parentSpecifiedStyle, computedStyle)
    });
};

LensBottom.propTypes = prop_types_Lens;

/* harmony default export */ var negative_space_LensBottom = (LensBottom);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lens/negative-space/index.js










function NegativeSpaceLens(inputProps) {
    var userSpecifiedStyle = inputProps.style;


    var compositLensStyle = object_assign_default()({ backgroundColor: 'rgba(0,0,0,.4)' }, userSpecifiedStyle);

    var props = object_assign_default()({}, inputProps, { style: compositLensStyle });

    return react.createElement(
        'div',
        null,
        react.createElement(negative_space_LensTop, props),
        react.createElement(negative_space_LensLeft, props),
        react.createElement(negative_space_LensRight, props),
        react.createElement(negative_space_LensBottom, props)
    );
}

NegativeSpaceLens.propTypes = prop_types_Lens;
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lens/positive-space/assets/textured-lens-data-uri.js
/* harmony default export */ var textured_lens_data_uri = ('data:image/gif;base64,R0lGODlhZABkAPABAHOf4fj48yH5BAEAAAEALAAAAABkAGQAAAL+jI+py+0PowOB2oqvznz7Dn5iSI7SiabqWrbj68bwTLL2jUv0Lvf8X8sJhzmg0Yc8mojM5kmZjEKPzqp1MZVqs7Cr98rdisOXr7lJHquz57YwDV8j3XRb/C7v1vcovD8PwicY8VcISDGY2GDIKKf4mNAoKQZZeXg5aQk5yRml+dgZ2vOpKGraQpp4uhqYKsgKi+H6iln7N8sXG4u7p2s7ykvnyxos/DuMWtyGfKq8fAwd5nzGHN067VUtiv2lbV3GDfY9DhQu7p1pXoU+rr5ODk/j7sSePk9Ub33PlN+4jx8v4JJ/RQQa3EDwzcGFiBLi6AfN4UOGCyXegGjIoh0fisQ0rsD4y+NHjgZFqgB5y2Qfks1UPmEZ0OVLlIcKAAA7');
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lens/positive-space/index.js
var positive_space_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function positive_space_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function positive_space_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function positive_space_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PositiveSpaceLens = function (_Component) {
    positive_space_inherits(PositiveSpaceLens, _Component);

    function PositiveSpaceLens() {
        positive_space_classCallCheck(this, PositiveSpaceLens);

        return positive_space_possibleConstructorReturn(this, (PositiveSpaceLens.__proto__ || Object.getPrototypeOf(PositiveSpaceLens)).apply(this, arguments));
    }

    positive_space_createClass(PositiveSpaceLens, [{
        key: 'render',
        value: function render() {
            return react.createElement('div', { style: this.compositStyle });
        }
    }, {
        key: 'dimensions',
        get: function get() {
            var _props$cursorOffset = this.props.cursorOffset,
                cursorOffsetX = _props$cursorOffset.x,
                cursorOffsetY = _props$cursorOffset.y;


            return {
                width: cursorOffsetX * 2,
                height: cursorOffsetY * 2
            };
        }
    }, {
        key: 'positionOffset',
        get: function get() {
            var _props = this.props,
                _props$cursorOffset2 = _props.cursorOffset,
                cursorOffsetX = _props$cursorOffset2.x,
                cursorOffsetY = _props$cursorOffset2.y,
                _props$position = _props.position,
                positionX = _props$position.x,
                positionY = _props$position.y,
                _props$smallImage = _props.smallImage,
                imageHeight = _props$smallImage.height,
                imageWidth = _props$smallImage.width;
            var _dimensions = this.dimensions,
                width = _dimensions.width,
                height = _dimensions.height;


            var top = positionY - cursorOffsetY;
            var left = positionX - cursorOffsetX;
            var maxTop = imageHeight - height;
            var maxLeft = imageWidth - width;
            var minOffset = 0;

            return {
                top: clamp_default()(top, minOffset, maxTop),
                left: clamp_default()(left, minOffset, maxLeft)
            };
        }
    }, {
        key: 'defaultStyle',
        get: function get() {
            var fadeDurationInMs = this.props.fadeDurationInMs;


            return {
                transition: 'opacity ' + fadeDurationInMs + 'ms ease-in',
                backgroundImage: 'url(' + textured_lens_data_uri + ')'
            };
        }
    }, {
        key: 'userSpecifiedStyle',
        get: function get() {
            var style = this.props.style;


            return style;
        }
    }, {
        key: 'isVisible',
        get: function get() {
            var _props2 = this.props,
                isActive = _props2.isActive,
                isPositionOutside = _props2.isPositionOutside;


            return isActive && !isPositionOutside;
        }
    }, {
        key: 'priorityStyle',
        get: function get() {
            var _dimensions2 = this.dimensions,
                width = _dimensions2.width,
                height = _dimensions2.height;
            var _positionOffset = this.positionOffset,
                top = _positionOffset.top,
                left = _positionOffset.left;


            return {
                position: 'absolute',
                top: top + 'px',
                left: left + 'px',
                width: width + 'px',
                height: height + 'px',
                opacity: this.isVisible ? 1 : 0
            };
        }
    }, {
        key: 'compositStyle',
        get: function get() {
            return object_assign_default()(this.defaultStyle, this.userSpecifiedStyle, this.priorityStyle);
        }
    }]);

    return PositiveSpaceLens;
}(react.Component);

PositiveSpaceLens.propTypes = prop_types_Lens;
PositiveSpaceLens.defaultProps = {
    style: {}
};
/* harmony default export */ var positive_space = (PositiveSpaceLens);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/hint/DisplayUntilActive.js
var DisplayUntilActive_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function DisplayUntilActive_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DisplayUntilActive_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function DisplayUntilActive_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DisplayUntilActive = function (_React$Component) {
    DisplayUntilActive_inherits(DisplayUntilActive, _React$Component);

    function DisplayUntilActive(props) {
        DisplayUntilActive_classCallCheck(this, DisplayUntilActive);

        var _this = DisplayUntilActive_possibleConstructorReturn(this, (DisplayUntilActive.__proto__ || Object.getPrototypeOf(DisplayUntilActive)).call(this, props));

        _this.hasShown = false;
        return _this;
    }

    DisplayUntilActive_createClass(DisplayUntilActive, [{
        key: 'setHasShown',
        value: function setHasShown() {
            this.hasShown = true;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                isActive = _props.isActive,
                shouldHideAfterFirstActivation = _props.shouldHideAfterFirstActivation,
                hasShown = this.hasShown;

            var shouldShow = !isActive && (!hasShown || !shouldHideAfterFirstActivation);

            if (isActive && !hasShown) {
                this.setHasShown();
            }

            return shouldShow ? children : null;
        }
    }]);

    return DisplayUntilActive;
}(react.Component);

DisplayUntilActive.propTypes = {
    children: (prop_types_default()).element,
    isActive: (prop_types_default()).bool,
    shouldHideAfterFirstActivation: (prop_types_default()).bool
};
DisplayUntilActive.defaultProps = {
    shouldHideAfterFirstActivation: true
};
/* harmony default export */ var hint_DisplayUntilActive = (DisplayUntilActive);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/hint/DefaultHint.js



function DefaultHint(_ref) {
    var isTouchDetected = _ref.isTouchDetected,
        hintTextMouse = _ref.hintTextMouse,
        hintTextTouch = _ref.hintTextTouch;

    return react.createElement(
        'div',
        { style: {
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                position: 'absolute',
                bottom: '25px'
            } },
        react.createElement(
            'div',
            { style: {
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 10px',
                    backgroundColor: '#333',
                    borderRadius: '10px',
                    opacity: '0.90'
                } },
            react.createElement('img', {
                style: {
                    width: '25px',
                    height: '25px'
                },
                src: 'data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ5MC4yIDQ5MC4yIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0OTAuMiA0OTAuMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+CjxnPgoJPGc+CgkJPHBhdGggZD0iTTQxOC41LDQxOC41Yzk1LjYtOTUuNiw5NS42LTI1MS4yLDAtMzQ2LjhzLTI1MS4yLTk1LjYtMzQ2LjgsMHMtOTUuNiwyNTEuMiwwLDM0Ni44UzMyMi45LDUxNC4xLDQxOC41LDQxOC41eiBNODksODkgICAgYzg2LjEtODYuMSwyMjYuMS04Ni4xLDMxMi4yLDBzODYuMSwyMjYuMSwwLDMxMi4ycy0yMjYuMSw4Ni4xLTMxMi4yLDBTMywxNzUuMSw4OSw4OXoiIGZpbGw9IiNGRkZGRkYiLz4KCQk8cGF0aCBkPSJNMjQ1LjEsMzM2LjljMy40LDAsNi40LTEuNCw4LjctMy42YzIuMi0yLjIsMy42LTUuMywzLjYtOC43di02Ny4zaDY3LjNjMy40LDAsNi40LTEuNCw4LjctMy42YzIuMi0yLjIsMy42LTUuMywzLjYtOC43ICAgIGMwLTYuOC01LjUtMTIuMy0xMi4yLTEyLjJoLTY3LjN2LTY3LjNjMC02LjgtNS41LTEyLjMtMTIuMi0xMi4yYy02LjgsMC0xMi4zLDUuNS0xMi4yLDEyLjJ2NjcuM2gtNjcuM2MtNi44LDAtMTIuMyw1LjUtMTIuMiwxMi4yICAgIGMwLDYuOCw1LjUsMTIuMywxMi4yLDEyLjJoNjcuM3Y2Ny4zQzIzMi44LDMzMS40LDIzOC4zLDMzNi45LDI0NS4xLDMzNi45eiIgZmlsbD0iI0ZGRkZGRiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=',
                alt: ''
            }),
            react.createElement(
                'span',
                { style: {
                        padding: '2px 0 0 5px',
                        fontFamily: 'Arial, sans-serif',
                        fontSize: '14px',
                        color: 'white'
                    } },
                isTouchDetected ? hintTextTouch : hintTextMouse
            )
        )
    );
}

DefaultHint.displayName = 'DefaultHint';

DefaultHint.propTypes = {
    isTouchDetected: (prop_types_default()).bool,
    hintTextMouse: (prop_types_default()).string,
    hintTextTouch: (prop_types_default()).string
};

/* harmony default export */ var hint_DefaultHint = (DefaultHint);
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lib/lens.js


function getLensCursorOffset(smallImage, largeImage, enlargedImageContainerDimensions) {
    var ratio = getLargeToSmallImageRatio(smallImage, largeImage);
    return {
        x: getLensCursorOffsetDimension(enlargedImageContainerDimensions.width, ratio.x),
        y: getLensCursorOffsetDimension(enlargedImageContainerDimensions.height, ratio.y)
    };
}

function getLensCursorOffsetDimension(enlargedImageContainerDimension, ratio) {
    return Math.round(enlargedImageContainerDimension * ratio / 2);
}
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/lib/dimensions.js
function isPercentageFormat(val) {
    return typeof val === 'string' && /^\d+%$/.test(val);
}

function convertPercentageToDecimal(percentage) {
    return parseInt(percentage) / 100;
}

function getEnlargedImageContainerDimension(_ref) {
    var containerDimension = _ref.containerDimension,
        smallImageDimension = _ref.smallImageDimension,
        isInPlaceMode = _ref.isInPlaceMode;

    if (isInPlaceMode) {
        return smallImageDimension;
    }

    if (isPercentageFormat(containerDimension)) {
        return smallImageDimension * convertPercentageToDecimal(containerDimension);
    }

    return containerDimension;
}
;// CONCATENATED MODULE: ../../node_modules/react-image-magnify/dist/es/ReactImageMagnify.js
var ReactImageMagnify_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ReactImageMagnify_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ReactImageMagnify_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ReactImageMagnify_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var ReactImageMagnify_ReactImageMagnify = function (_React$Component) {
    ReactImageMagnify_inherits(ReactImageMagnify, _React$Component);

    function ReactImageMagnify(props) {
        ReactImageMagnify_classCallCheck(this, ReactImageMagnify);

        var _this = ReactImageMagnify_possibleConstructorReturn(this, (ReactImageMagnify.__proto__ || Object.getPrototypeOf(ReactImageMagnify)).call(this, props));

        var primaryInput = detect_it_lib/* default.primaryInput */.Z.primaryInput;
        var MOUSE = INPUT_TYPE.mouse,
            TOUCH = INPUT_TYPE.touch;


        _this.state = {
            smallImageWidth: 0,
            smallImageHeight: 0,
            detectedInputType: {
                isMouseDeteced: primaryInput === MOUSE,
                isTouchDetected: primaryInput === TOUCH
            }
        };

        _this.onSmallImageLoad = _this.onSmallImageLoad.bind(_this);
        _this.setSmallImageDimensionState = _this.setSmallImageDimensionState.bind(_this);
        _this.onDetectedInputTypeChanged = _this.onDetectedInputTypeChanged.bind(_this);
        return _this;
    }

    ReactImageMagnify_createClass(ReactImageMagnify, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var isFluidWidth = this.props.smallImage.isFluidWidth;


            if (!isFluidWidth) {
                return;
            }

            this.setSmallImageDimensionState();
            window.addEventListener('resize', this.setSmallImageDimensionState);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.setSmallImageDimensionState);
        }
    }, {
        key: 'onSmallImageLoad',
        value: function onSmallImageLoad(e) {
            var _props$smallImage = this.props.smallImage,
                _props$smallImage$onL = _props$smallImage.onLoad,
                onLoad = _props$smallImage$onL === undefined ? es_utils_noop : _props$smallImage$onL,
                isFluidWidth = _props$smallImage.isFluidWidth;


            onLoad(e);

            if (!isFluidWidth) {
                return;
            }

            this.setSmallImageDimensionState();
        }
    }, {
        key: 'onDetectedInputTypeChanged',
        value: function onDetectedInputTypeChanged(detectedInputType) {
            this.setState({
                detectedInputType: detectedInputType
            });
        }
    }, {
        key: 'setSmallImageDimensionState',
        value: function setSmallImageDimensionState() {
            var _smallImageEl = this.smallImageEl,
                smallImageWidth = _smallImageEl.offsetWidth,
                smallImageHeight = _smallImageEl.offsetHeight;


            this.setState({
                smallImageWidth: smallImageWidth,
                smallImageHeight: smallImageHeight
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                style = _props.style,
                hoverDelayInMs = _props.hoverDelayInMs,
                hoverOffDelayInMs = _props.hoverOffDelayInMs,
                isActivatedOnTouch = _props.isActivatedOnTouch,
                pressDuration = _props.pressDuration,
                pressMoveThreshold = _props.pressMoveThreshold,
                _props$smallImage$onE = _props.smallImage.onError,
                onError = _props$smallImage$onE === undefined ? es_utils_noop : _props$smallImage$onE,
                imageClassName = _props.imageClassName,
                imageStyle = _props.imageStyle,
                lensStyle = _props.lensStyle,
                largeImage = _props.largeImage,
                enlargedImageContainerClassName = _props.enlargedImageContainerClassName,
                enlargedImageContainerStyle = _props.enlargedImageContainerStyle,
                enlargedImageClassName = _props.enlargedImageClassName,
                enlargedImageStyle = _props.enlargedImageStyle,
                enlargedImagePortalId = _props.enlargedImagePortalId,
                isEnlargedImagePortalEnabledForTouch = _props.isEnlargedImagePortalEnabledForTouch,
                fadeDurationInMs = _props.fadeDurationInMs,
                HintComponent = _props.hintComponent,
                isHintEnabled = _props.isHintEnabled,
                hintTextMouse = _props.hintTextMouse,
                hintTextTouch = _props.hintTextTouch,
                shouldHideHintAfterFirstActivation = _props.shouldHideHintAfterFirstActivation;


            var smallImage = this.smallImage;

            var isTouchDetected = this.state.detectedInputType.isTouchDetected;


            var cursorOffset = getLensCursorOffset(smallImage, largeImage, this.enlargedImageContainerDimensions);

            var Lens = this.lensComponent;

            return react.createElement(
                ReactCursorPosition,
                {
                    className: className,
                    hoverDelayInMs: hoverDelayInMs,
                    hoverOffDelayInMs: hoverOffDelayInMs,
                    isActivatedOnTouch: isActivatedOnTouch,
                    onDetectedInputTypeChanged: this.onDetectedInputTypeChanged,
                    pressDuration: pressDuration,
                    pressMoveThreshold: pressMoveThreshold,
                    shouldStopTouchMovePropagation: true,
                    style: getContainerStyle(smallImage, style)
                },
                react.createElement('img', {
                    src: smallImage.src,
                    srcSet: smallImage.srcSet,
                    sizes: smallImage.sizes,
                    alt: smallImage.alt,
                    className: imageClassName,
                    style: getSmallImageStyle(smallImage, imageStyle),
                    ref: function ref(el) {
                        return _this2.smallImageEl = el;
                    },
                    onLoad: this.onSmallImageLoad,
                    onError: onError
                }),
                isHintEnabled && react.createElement(
                    hint_DisplayUntilActive,
                    {
                        shouldHideAfterFirstActivation: shouldHideHintAfterFirstActivation
                    },
                    react.createElement(HintComponent, {
                        isTouchDetected: isTouchDetected,
                        hintTextMouse: hintTextMouse,
                        hintTextTouch: hintTextTouch
                    })
                ),
                this.shouldShowLens && react.createElement(Lens, {
                    cursorOffset: cursorOffset,
                    fadeDurationInMs: fadeDurationInMs,
                    smallImage: smallImage,
                    style: lensStyle
                }),
                react.createElement(es_RenderEnlargedImage, {
                    containerClassName: enlargedImageContainerClassName,
                    containerDimensions: this.enlargedImageContainerDimensions,
                    containerStyle: enlargedImageContainerStyle,
                    cursorOffset: cursorOffset,
                    fadeDurationInMs: fadeDurationInMs,
                    imageClassName: enlargedImageClassName,
                    imageStyle: enlargedImageStyle,
                    largeImage: largeImage,
                    smallImage: smallImage,
                    portalId: enlargedImagePortalId,
                    isPortalEnabledForTouch: isEnlargedImagePortalEnabledForTouch,
                    isTouchDetected: this.isTouchDetected,
                    isInPlaceMode: this.isInPlaceMode
                })
            );
        }
    }, {
        key: 'smallImage',
        get: function get() {
            var _props2 = this.props,
                smallImage = _props2.smallImage,
                isFluidWidth = _props2.smallImage.isFluidWidth;


            if (!isFluidWidth) {
                return smallImage;
            }

            var _state = this.state,
                fluidWidth = _state.smallImageWidth,
                fluidHeight = _state.smallImageHeight;


            return object_assign_default()({}, smallImage, {
                width: fluidWidth,
                height: fluidHeight
            });
        }
    }, {
        key: 'enlargedImagePlacement',
        get: function get() {
            var userDefinedEnlargedImagePosition = this.props.enlargedImagePosition;
            var isTouchDetected = this.state.detectedInputType.isTouchDetected;


            var computedEnlargedImagePosition = isTouchDetected ? ENLARGED_IMAGE_POSITION.over : ENLARGED_IMAGE_POSITION.beside;

            return userDefinedEnlargedImagePosition || computedEnlargedImagePosition;
        }
    }, {
        key: 'isInPlaceMode',
        get: function get() {
            var OVER = ENLARGED_IMAGE_POSITION.over;

            return this.enlargedImagePlacement === OVER;
        }
    }, {
        key: 'enlargedImageContainerDimensions',
        get: function get() {
            var _props$enlargedImageC = this.props.enlargedImageContainerDimensions,
                containerWidth = _props$enlargedImageC.width,
                containerHeight = _props$enlargedImageC.height;
            var _smallImage = this.smallImage,
                smallImageWidth = _smallImage.width,
                smallImageHeight = _smallImage.height;

            var isInPlaceMode = this.isInPlaceMode;

            return {
                width: getEnlargedImageContainerDimension({
                    containerDimension: containerWidth,
                    smallImageDimension: smallImageWidth,
                    isInPlaceMode: isInPlaceMode
                }),
                height: getEnlargedImageContainerDimension({
                    containerDimension: containerHeight,
                    smallImageDimension: smallImageHeight,
                    isInPlaceMode: isInPlaceMode
                })
            };
        }
    }, {
        key: 'isTouchDetected',
        get: function get() {
            var isTouchDetected = this.state.detectedInputType.isTouchDetected;


            return isTouchDetected;
        }
    }, {
        key: 'shouldShowLens',
        get: function get() {
            return !this.isInPlaceMode && !this.isTouchDetected;
        }
    }, {
        key: 'lensComponent',
        get: function get() {
            var _props3 = this.props,
                shouldUsePositiveSpaceLens = _props3.shouldUsePositiveSpaceLens,
                lensComponent = _props3.lensComponent;


            if (lensComponent) {
                return lensComponent;
            }

            if (shouldUsePositiveSpaceLens) {
                return positive_space;
            }

            return NegativeSpaceLens;
        }
    }]);

    return ReactImageMagnify;
}(react.Component);

ReactImageMagnify_ReactImageMagnify.propTypes = {
    className: (prop_types_default()).string,
    style: (prop_types_default()).object,
    hoverDelayInMs: (prop_types_default()).number,
    hoverOffDelayInMs: (prop_types_default()).number,
    fadeDurationInMs: (prop_types_default()).number,
    pressDuration: (prop_types_default()).number,
    pressMoveThreshold: (prop_types_default()).number,
    isActivatedOnTouch: (prop_types_default()).bool,
    imageClassName: (prop_types_default()).string,
    imageStyle: (prop_types_default()).object,
    lensStyle: (prop_types_default()).object,
    lensComponent: (prop_types_default()).func,
    shouldUsePositiveSpaceLens: (prop_types_default()).bool,
    smallImage: SmallImageShape,
    largeImage: LargeImageShape,
    enlargedImageContainerClassName: (prop_types_default()).string,
    enlargedImageContainerStyle: (prop_types_default()).object,
    enlargedImageClassName: (prop_types_default()).string,
    enlargedImageStyle: (prop_types_default()).object,
    enlargedImageContainerDimensions: EnlargedImageContainerDimensions,
    enlargedImagePosition: EnlargedImagePosition,
    enlargedImagePortalId: (prop_types_default()).string,
    isEnlargedImagePortalEnabledForTouch: (prop_types_default()).bool,
    hintComponent: (prop_types_default()).func,
    hintTextMouse: (prop_types_default()).string,
    hintTextTouch: (prop_types_default()).string,
    isHintEnabled: (prop_types_default()).bool,
    shouldHideHintAfterFirstActivation: (prop_types_default()).bool
};
ReactImageMagnify_ReactImageMagnify.defaultProps = {
    enlargedImageContainerDimensions: {
        width: '100%',
        height: '100%'
    },
    isEnlargedImagePortalEnabledForTouch: false,
    fadeDurationInMs: 300,
    hintComponent: hint_DefaultHint,
    shouldHideHintAfterFirstActivation: true,
    isHintEnabled: false,
    hintTextMouse: 'Hover to Zoom',
    hintTextTouch: 'Long-Touch to Zoom',
    hoverDelayInMs: 250,
    hoverOffDelayInMs: 150,
    shouldUsePositiveSpaceLens: false
};


/* harmony default export */ var es_ReactImageMagnify = ((/* unused pure expression or super */ null && (ReactImageMagnify_ReactImageMagnify)));
;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactImageMagnify/index.tsx


var ImageMagnify = function(param) {
    var smallImage = param.smallImage, largeImage = param.largeImage, enlargedImagePosition = param.enlargedImagePosition, style = param.style;
    return /*#__PURE__*/ _jsx(ReactImageMagnify, {
        smallImage: smallImage,
        largeImage: largeImage,
        enlargedImagePosition: enlargedImagePosition,
        style: style
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var src_extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../node_modules/react-player/lazy/index.js
var lazy = __webpack_require__(84372);
var lazy_default = /*#__PURE__*/__webpack_require__.n(lazy);
;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactPlayer/index.tsx
// eslint-disable-next-line import/no-extraneous-dependencies




var ReactVideoPlayer = function(_param) {
    var playerProps = (0,src_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lazy_default()), (0,src_object_spread/* default */.Z)({
        width: "100%",
        height: "100%"
    }, playerProps));
};


;// CONCATENATED MODULE: ../../node_modules/react-countdown-circle-timer/lib/index.module.js
var index_module_G=typeof window=="undefined"?react.useEffect:react.useLayoutEffect,index_module_I=({isPlaying:o,duration:e,startAt:n=0,updateInterval:t=0,onComplete:s,onUpdate:r})=>{let[i,c]=(0,react.useState)(n),m=(0,react.useRef)(0),p=(0,react.useRef)(n),f=(0,react.useRef)(n*-1e3),u=(0,react.useRef)(null),a=(0,react.useRef)(null),h=(0,react.useRef)(null),w=g=>{let l=g/1e3;if(a.current===null){a.current=l,u.current=requestAnimationFrame(w);return}let d=l-a.current,C=m.current+d;a.current=l,m.current=C;let k=p.current+(t===0?C:(C/t|0)*t),R=p.current+C,v=typeof e=="number"&&R>=e;c(v?e:k),v||(u.current=requestAnimationFrame(w))},$=()=>{u.current&&cancelAnimationFrame(u.current),h.current&&clearTimeout(h.current),a.current=null},y=(0,react.useCallback)(g=>{$(),m.current=0;let l=typeof g=="number"?g:n;p.current=l,c(l),o&&(u.current=requestAnimationFrame(w))},[o,n]);return index_module_G(()=>{if(r==null||r(i),e&&i>=e){f.current+=e*1e3;let{shouldRepeat:g=!1,delay:l=0,newStartAt:d}=(s==null?void 0:s(f.current/1e3))||{};g&&(h.current=setTimeout(()=>y(d),l*1e3))}},[i,e]),index_module_G(()=>(o&&(u.current=requestAnimationFrame(w)),$),[o,e,t]),{elapsedTime:i,reset:y}};var index_module_A=(o,e,n)=>{let t=o/2,s=e/2,r=t-s,i=2*r,c=n==="clockwise"?"1,0":"0,1",m=2*Math.PI*r;return{path:`m ${t},${s} a ${r},${r} 0 ${c} 0,${i} a ${r},${r} 0 ${c} 0,-${i}`,pathLength:m}},index_module_T=(o,e)=>o===0||o===e?0:typeof e=="number"?o-e:0,index_module_B=o=>({position:"relative",width:o,height:o}),P={display:"flex",justifyContent:"center",alignItems:"center",position:"absolute",left:0,top:0,width:"100%",height:"100%"};var index_module_F=(o,e,n,t,s)=>{if(t===0)return e;let r=(s?t-o:o)/t;return e+n*r},W=o=>{var e,n;return(n=(e=o.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,(t,s,r,i)=>`#${s}${s}${r}${r}${i}${i}`).substring(1).match(/.{2}/g))==null?void 0:e.map(t=>parseInt(t,16)))!=null?n:[]},index_module_j=(o,e)=>{var u;let{colors:n,colorsTime:t,isSmoothColorTransition:s=!0}=o;if(typeof n=="string")return n;let r=(u=t==null?void 0:t.findIndex((a,h)=>a>=e&&e>=t[h+1]))!=null?u:-1;if(!t||r===-1)return n[0];if(!s)return n[r];let i=t[r]-e,c=t[r]-t[r+1],m=W(n[r]),p=W(n[r+1]),f=!!o.isGrowing;return`rgb(${m.map((a,h)=>index_module_F(i,a,p[h]-a,c,f)|0).join(",")})`},S=o=>{let{duration:e,initialRemainingTime:n,updateInterval:t,size:s=180,strokeWidth:r=12,trailStrokeWidth:i,isPlaying:c=!1,isGrowing:m=!1,rotation:p="clockwise",onComplete:f,onUpdate:u}=o,a=(0,react.useRef)(),h=Math.max(r,i!=null?i:0),{path:w,pathLength:$}=index_module_A(s,h,p),{elapsedTime:y}=index_module_I({isPlaying:c,duration:e,startAt:index_module_T(e,n),updateInterval:t,onUpdate:typeof u=="function"?l=>{let d=Math.ceil(e-l);d!==a.current&&(a.current=d,u(d))}:void 0,onComplete:typeof f=="function"?l=>{var R;let{shouldRepeat:d,delay:C,newInitialRemainingTime:k}=(R=f(l))!=null?R:{};if(d)return{shouldRepeat:d,delay:C,newStartAt:index_module_T(e,k)}}:void 0}),g=e-y;return{elapsedTime:y,path:w,pathLength:$,remainingTime:Math.ceil(g),rotation:p,size:s,stroke:index_module_j(o,g),strokeDashoffset:index_module_F(y,0,$,e,m),strokeWidth:r}};var index_module_D=o=>{let{children:e,strokeLinecap:n,trailColor:t,trailStrokeWidth:s}=o,{path:r,pathLength:i,stroke:c,strokeDashoffset:m,remainingTime:p,elapsedTime:f,size:u,strokeWidth:a}=S(o);return react.createElement("div",{style:index_module_B(u)},react.createElement("svg",{viewBox:`0 0 ${u} ${u}`,width:u,height:u,xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{d:r,fill:"none",stroke:t!=null?t:"#d9d9d9",strokeWidth:s!=null?s:a}),react.createElement("path",{d:r,fill:"none",stroke:c,strokeLinecap:n!=null?n:"round",strokeWidth:a,strokeDasharray:i,strokeDashoffset:m})),typeof e=="function"&&react.createElement("div",{style:P},e({remainingTime:p,elapsedTime:f,color:c})))};index_module_D.displayName="CountdownCircleTimer";

;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactCountdownCircleTimer/index.tsx




var ReactCountdownCircleTimer = function(props) {
    var children = props.children, colors = props.colors, duration = props.duration;
    var color = Array.isArray(colors) ? colors[0] : colors;
    var timeProps = {
        remainingTime: duration,
        elapsedTime: 0,
        color: color
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module_D, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: children ? function() {
            return children(timeProps);
        } : undefined
    }));
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(37726);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ../../node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(79192);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/pt-BR/_lib/formatDistance.mjs
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos",
  },

  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos",
  },

  halfAMinute: "meio minuto",

  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos",
  },

  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos",
  },

  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas",
  },

  xHours: {
    one: "1 hora",
    other: "{{count}} horas",
  },

  xDays: {
    one: "1 dia",
    other: "{{count}} dias",
  },

  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas",
  },

  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas",
  },

  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses",
  },

  xMonths: {
    one: "1 mês",
    other: "{{count}} meses",
  },

  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos",
  },

  xYears: {
    one: "1 ano",
    other: "{{count}} anos",
  },

  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos",
  },

  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos",
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "em " + result;
    } else {
      return "há " + result;
    }
  }

  return result;
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/_lib/buildFormatLongFn.mjs
function buildFormatLongFn(args) {
  return (options = {}) => {
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/pt-BR/_lib/formatLong.mjs


const dateFormats = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy",
};

const timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/pt-BR/_lib/formatRelative.mjs
const formatRelativeLocale = {
  lastWeek: (date) => {
    const weekday = date.getDay();
    const last = weekday === 0 || weekday === 6 ? "último" : "última";
    return "'" + last + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P",
};

const formatRelative = (token, date, _baseDate, _options) => {
  const format = formatRelativeLocale[token];

  if (typeof format === "function") {
    return format(date);
  }

  return format;
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/_lib/buildLocalizeFn.mjs
/* eslint-disable no-unused-vars */

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";

    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;

      valuesArray =
        args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/pt-BR/_lib/localize.mjs


const eraValues = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"],
};

const monthValues = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez",
  ],

  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ],
};

const dayValues = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: [
    "domingo",
    "segunda",
    "terça",
    "quarta",
    "quinta",
    "sexta",
    "sábado",
  ],

  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite",
  },
};

const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite",
  },
};

const ordinalNumber = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);

  if (options?.unit === "week") {
    return number + "ª";
  }
  return number + "º";
};

const localize = {
  ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchFn.mjs
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;

    const matchPattern =
      (width && args.matchPatterns[width]) ||
      args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];

    const parsePatterns =
      (width && args.parsePatterns[width]) ||
      args.parsePatterns[args.defaultParseWidth];

    const key = Array.isArray(parsePatterns)
      ? buildMatchFn_findIndex(parsePatterns, (pattern) => pattern.test(matchedString))
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        findKey(parsePatterns, (pattern) => pattern.test(matchedString));

    let value;

    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        options.valueCallback(value)
      : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

function findKey(object, predicate) {
  for (const key in object) {
    if (
      Object.prototype.hasOwnProperty.call(object, key) &&
      predicate(object[key])
    ) {
      return key;
    }
  }
  return undefined;
}

function buildMatchFn_findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchPatternFn.mjs
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];

    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback
      ? args.valueCallback(parseResult[0])
      : parseResult[0];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/pt-BR/_lib/match.mjs



const matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i,
};
const parseEraPatterns = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^fev/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dez/i,
  ],
};

const matchDayPatterns = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i,
};
const parseDayPatterns = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/pt-BR.mjs






/**
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe](https://github.com/duailibe)
 * @author Yago Carballo [@yagocarballo](https://github.com/YagoCarballo)
 */
const ptBR = {
  code: "pt-BR",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
};

// Fallback for modularized imports:
/* harmony default export */ var pt_BR = ((/* unused pure expression or super */ null && (ptBR)));

// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/react-input-mask/index.js
var react_input_mask = __webpack_require__(98738);
var react_input_mask_default = /*#__PURE__*/__webpack_require__.n(react_input_mask);
;// CONCATENATED MODULE: ../../packages/infra/utils/date/isInvalidYear.ts
var isInvalidYear = function(date) {
    var year = date.split("/")[2];
    var currentYear = new Date().getFullYear();
    return Number(year) < 1900 || Number(year) > currentYear;
};

;// CONCATENATED MODULE: ../../packages/infra/utils/date/isFutureDate.ts

var isFutureDate = function(date) {
    var ref = (0,_sliced_to_array/* default */.Z)(date.split("/").map(Number), 3), day = ref[0], month = ref[1], year = ref[2];
    var inputDate = new Date(year, month - 1, day);
    var now = new Date();
    return inputDate > now;
};

;// CONCATENATED MODULE: ../../packages/infra/utils/date/isValidDayForMonth.ts
var isValidDayForMonth = function(day, month, year) {
    var monthsWith31Days = [
        1,
        3,
        5,
        7,
        8,
        10,
        12
    ];
    var monthsWith30Days = [
        4,
        6,
        9,
        11
    ];
    if (monthsWith31Days.includes(month) && day <= 31) {
        return true;
    }
    if (monthsWith30Days.includes(month) && day <= 30) {
        return true;
    }
    if (month === 2) {
        var isLeapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        if (isLeapYear && day <= 29) return true;
        if (!isLeapYear && day <= 28) return true;
    }
    return false;
};

;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactDatePicker/styles.ts

function ReactDatePicker_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n\n  .react-datepicker__current-month {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  .react-datepicker__day-names {\n    margin-top: ",
        ";\n  }\n\n  .react-datepicker__day-name {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: ",
        ";\n    height: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n    font-size: ",
        ";\n  }\n\n  .react-datepicker__day {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    margin: 3px;\n    width: ",
        ";\n    height: ",
        ";\n    line-height: ",
        ";\n    font-size: ",
        ";\n    transition: background-color 0.2s ease, transform 0.2s ease;\n  }\n\n  .react-datepicker__day--today {\n    background-color: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--today) {\n    background-color: transparent;\n  }\n\n  .react-datepicker__day:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n    transform: scale(1.1);\n  }\n\n  .react-datepicker__header {\n    text-align: center;\n    display: block;\n    background-color: ",
        ";\n    padding: ",
        " ",
        ";\n    border-bottom: 1px solid ",
        ";\n    font-size: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  .react-datepicker__day--selected {\n    background-color: ",
        ";\n    color: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  .react-datepicker__month-select,\n  .react-datepicker__year-select {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    color: ",
        ";\n    background-color: ",
        ";\n    border: none;\n    border-radius: 4px;\n    padding: ",
        ";\n    width: 100%;\n    max-width: 120px;\n    cursor: pointer;\n    margin-top: ",
        ";\n  }\n\n  .react-datepicker__month-select option,\n  .react-datepicker__year-select option {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n\n  .react-datepicker__month-select:hover,\n  .react-datepicker__year-select:hover {\n    border-color: ",
        ";\n  }\n"
    ]);
    ReactDatePicker_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledDatePickerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StyledDatePickerWrapper",
    componentId: "sc-169f06fe-0"
})(ReactDatePicker_styles_templateObject(), ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x7, ui.theme.typography.fontWeight[700], ui.theme.space.x2, ui.theme.space.x6, ui.theme.space.x6, ui.theme.space.x6, ui.theme.typography.fontWeight[400], ui.theme.colors.neutral[500], ui.theme.typography.fontSize.sm.x4, ui.theme.space.x6, ui.theme.space.x6, ui.theme.space.x6, ui.theme.typography.fontSize.sm.x4, ui.theme.colors.secondary[33], ui.theme.typography.fontWeight[500], ui.theme.colors.secondary[300], ui.theme.colors.neutral.white, ui.theme.colors.neutral["white-050"], ui.theme.space["x2.5"], ui.theme.space.x0, ui.theme.colors.neutral[300], ui.theme.typography.fontSize.sm.x4, ui.theme.space["x2.5"], ui.theme.colors.secondary[300], ui.theme.colors.secondary[33], ui.theme.typography.fontWeight.bold, ui.theme.typography.fontFamily.chivo, ui.theme.typography.fontSize.sm.x4, ui.theme.colors.neutral[700], ui.theme.colors.neutral["white-050"], ui.theme.space.x1, ui.theme.space.x2, ui.theme.typography.fontSize.sm.x4, ui.theme.colors.neutral[600], ui.theme.colors.primary[300]);

;// CONCATENATED MODULE: ../../packages/infra/components/lib/ReactDatePicker/index.tsx
/* eslint-disable import/no-extraneous-dependencies */ 












(0,react_datepicker_min.registerLocale)("pt-BR", ptBR);
var ReactDatePicker = function(_param) {
    var onChange = _param.onChange, id = _param.id, required = _param.required, onBlur = _param.onBlur, placeholder = _param.placeholder, _open = _param.open, open = _open === void 0 ? false : _open, setIsOpen = _param.setIsOpen, onInputClick = _param.onInputClick, onClickOutside = _param.onClickOutside, onInputChangesMonitoringErrors = _param.onInputChangesMonitoringErrors, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "onChange",
        "id",
        "required",
        "onBlur",
        "placeholder",
        "open",
        "setIsOpen",
        "onInputClick",
        "onClickOutside",
        "onInputChangesMonitoringErrors"
    ]);
    var today = (0,react.useMemo)(function() {
        return new Date();
    }, []);
    var ref = (0,react.useState)(""), inputedDate = ref[0], setInputedDate = ref[1];
    var field = (0,index_esm/* useController */.bc)({
        name: id || "date-picker",
        control: props.control,
        rules: {
            onBlur: onBlur,
            onChange: onChange,
            value: inputedDate,
            required: required,
            maxLength: 10,
            pattern: {
                value: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
                message: "Data inv\xe1lida"
            }
        }
    }).field;
    var isValidDate = function(date) {
        var pattern = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
        var invalidDate = !pattern.test(date) || date === "00/00/0000" || isInvalidYear(date) || isFutureDate(date);
        if (invalidDate) {
            return false;
        }
        var ref = (0,_sliced_to_array/* default */.Z)(date.split("/").map(Number), 3), day = ref[0], month = ref[1], year = ref[2];
        return isValidDayForMonth(day, month, year);
    };
    var handleInputChange = function(e) {
        var inputValue = e.target.value;
        if (onInputChangesMonitoringErrors) {
            onInputChangesMonitoringErrors(inputValue);
        }
        if (!isValidDate(inputValue)) {
            setInputedDate("");
            field.onChange("");
            return;
        }
        field.onChange(inputValue);
        setInputedDate(inputValue);
    };
    var handleDateSelect = function(date) {
        if (date) {
            var formattedDate = date.toISOString().slice(0, 10).split("-").reverse().join("/");
            setInputedDate(formattedDate);
            field.onChange(date);
        }
    };
    var handleClickOutside = function() {
        if (setIsOpen) setIsOpen(!open);
        if (onClickOutside) onClickOutside();
    };
    var handleInputClick = function() {
        if (setIsOpen) setIsOpen(true);
        if (onInputClick) onInputClick();
    };
    var handleRawChange = function(e) {
        var rawValue = e ? e.target.value : "";
        field.value = rawValue;
        setInputedDate(rawValue);
        if (!rawValue || rawValue.length !== 10) return;
        if (!isValidDate(rawValue)) {
            setInputedDate("");
            field.onChange("");
            return;
        }
        var isoDate = new Date("".concat(rawValue.slice(0, 10).split("/").reverse().join("-"), "T00:00:00"));
        setInputedDate(rawValue.slice(0, 10));
        field.onChange(isoDate);
    };
    var selectedDate = isValidDate(inputedDate) ? new Date("".concat(inputedDate.split("/").reverse().join("-"), "T00:00:00")) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDatePickerWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, field, props), {
            autoComplete: "off",
            startDate: today,
            selected: selectedDate,
            dateFormat: "dd/MM/yyyy",
            placeholderText: placeholder || "dd/mm/aaaa",
            locale: ptBR,
            open: open,
            onClickOutside: handleClickOutside,
            onInputClick: handleInputClick,
            onSelect: handleDateSelect,
            maxDate: today,
            closeOnScroll: true,
            formatWeekDay: function(date) {
                return date.substring(0, 3);
            },
            minDate: new Date("1900-01-01"),
            dropdownMode: "select",
            showYearDropdown: true,
            showMonthDropdown: true,
            useShortMonthInDropdown: true,
            onChangeRaw: handleRawChange,
            onKeyDown: function(e) {
                return e.preventDefault();
            },
            customInput: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_input_mask_default()), {
                mask: "99/99/9999",
                value: field.value,
                onChange: function(e) {
                    handleInputChange(e);
                    field.onChange(e.target.value);
                },
                maskChar: null
            })
        }))
    });
};


;// CONCATENATED MODULE: ../../packages/infra/components/lib/index.ts


















// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../packages/infra/components/next/Image/index.tsx




var Image_Image = function(_param) {
    var alt = _param.alt, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "alt"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,src_object_spread/* default */.Z)({
        alt: alt
    }, props));
};


// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../packages/infra/components/next/Head/index.tsx





var Head = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,application/* buildTestIds */.Fek)("head-component-category")), {
        children: children
    }));
};


;// CONCATENATED MODULE: ../../packages/infra/components/next/index.ts



;// CONCATENATED MODULE: ../../packages/infra/components/index.ts




/***/ }),

/***/ 89959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ MagicZoomComponents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(430);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41870);
/* harmony import */ var _stylesMagicZoomPerson_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26895);
/* harmony import */ var _stylesMagicZoomPerson_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_stylesMagicZoomPerson_css__WEBPACK_IMPORTED_MODULE_7__);




// eslint-disable-next-line import/no-extraneous-dependencies
// import { appMonitoringClient } from "implementations";







var MagicZoomComponents = function(param) {
    var largeImage = param.largeImage, descriptionImage = param.descriptionImage, _zoomPosition = param.zoomPosition, zoomPosition = _zoomPosition === void 0 ? "inner" : _zoomPosition, _zoomMode = param.zoomMode, zoomMode = _zoomMode === void 0 ? "zoom" : _zoomMode, _activeZoom = param.activeZoom, activeZoom = _activeZoom === void 0 ? "hover" : _activeZoom, _expandStyle = param.expandStyle, expandStyle = _expandStyle === void 0 ? "window" : _expandStyle, _zoomModeExpanded = param.zoomModeExpanded, zoomModeExpanded = _zoomModeExpanded === void 0 ? "zoom" : _zoomModeExpanded, _zoomTriggerInExpandedMode = param.zoomTriggerInExpandedMode, zoomTriggerInExpandedMode = _zoomTriggerInExpandedMode === void 0 ? "zoom" : _zoomTriggerInExpandedMode, _closeOnClickOutside = param.closeOnClickOutside, closeOnClickOutside = _closeOnClickOutside === void 0 ? true : _closeOnClickOutside, _expandCaption = param.expandCaption, expandCaption = _expandCaption === void 0 ? false : _expandCaption, _titlePreviousButtonExpanded = param.titlePreviousButtonExpanded, titlePreviousButtonExpanded = _titlePreviousButtonExpanded === void 0 ? "Previous" : _titlePreviousButtonExpanded, _titleNextButtonExpanded = param.titleNextButtonExpanded, titleNextButtonExpanded = _titleNextButtonExpanded === void 0 ? "Next" : _titleNextButtonExpanded, _titleCloseButtonExpanded = param.titleCloseButtonExpanded, titleCloseButtonExpanded = _titleCloseButtonExpanded === void 0 ? "Close" : _titleCloseButtonExpanded, _hint = param.hint, hint = _hint === void 0 ? "once" : _hint, _textExpandHint = param.textExpandHint, textExpandHint = _textExpandHint === void 0 ? "" : _textExpandHint, _textHoverZoomHint = param.textHoverZoomHint, textHoverZoomHint = _textHoverZoomHint === void 0 ? "" : _textHoverZoomHint, _textClickZoomHint = param.textClickZoomHint, textClickZoomHint = _textClickZoomHint === void 0 ? "" : _textClickZoomHint, _mobileCofig = param.mobileCofig, mobileCofig = _mobileCofig === void 0 ? {
        zoomMode: "zoom",
        textExpandHint: "",
        textTouchZoomHint: "",
        textClickZoomHint: ""
    } : _mobileCofig, _moreImages = param.moreImages, moreImages = _moreImages === void 0 ? [] : _moreImages, indexImageCurrent = param.indexImageCurrent;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var idProduct = router.query.idProduct;
    var refMagicZoom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), magicZoomRef = ref[0], setMagicZoomRef = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), productId = ref[0], setProductId = ref[1];
    var configZoom = [
        "zoomPosition: ".concat(zoomPosition),
        "zoomMode: ".concat(zoomMode),
        "zoomOn: ".concat(activeZoom),
        "expand: ".concat(expandStyle),
        "expandZoomMode:".concat(zoomModeExpanded),
        "expandZoomOn: ".concat(zoomTriggerInExpandedMode),
        "closeOnClickOutside: ".concat(closeOnClickOutside),
        "expandCaption: ".concat(expandCaption),
        "textBtnPrev: ".concat(titlePreviousButtonExpanded),
        "textBtnClose: ".concat(titleCloseButtonExpanded),
        "textBtnNext: ".concat(titleNextButtonExpanded),
        "textHoverZoomHint: ".concat(textHoverZoomHint),
        "textExpandHint: ".concat(textExpandHint),
        "textClickZoomHint: ".concat(textClickZoomHint),
        "hint: ".concat(hint), 
    ];
    var configMobileZoom = [
        "zoomMode: ".concat(mobileCofig.zoomMode),
        "textExpandHint: ".concat(mobileCofig.textExpandHint),
        "textTouchZoomHint: ".concat(mobileCofig.textTouchZoomHint),
        "textClickZoomHint: ".concat(mobileCofig.textClickZoomHint), 
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (productId !== idProduct) {
            magicZoomRef === null || magicZoomRef === void 0 ? void 0 : magicZoomRef.stop();
            setProductId(idProduct);
        }
    }, [
        idProduct,
        magicZoomRef,
        productId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!productId) {
            setProductId(idProduct);
        }
        if (largeImage) {
            try {
                // eslint-disable-next-line no-eval
                var magicZoomLib = eval("MagicZoom");
                setMagicZoomRef(magicZoomLib);
                if (refMagicZoom && magicZoomLib) {
                    magicZoomRef === null || magicZoomRef === void 0 ? void 0 : magicZoomRef.start(refMagicZoom === null || refMagicZoom === void 0 ? void 0 : refMagicZoom.current);
                }
            } catch (e) {
            // appMonitoringClient.captureMessage(
            //   `Erro na inicialização do Magic Zoom Plus: ${error}`,
            //   {
            //     level: "error",
            //     tags: {
            //       component: "MagicZoom",
            //       function: "useEffect",
            //       type: "error",
            //     },
            //   }
            // );
            }
        }
    }, [
        largeImage,
        idProduct,
        productId,
        magicZoomRef,
        indexImageCurrent
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (productId === idProduct) {
            magicZoomRef === null || magicZoomRef === void 0 ? void 0 : magicZoomRef.switchTo(refMagicZoom === null || refMagicZoom === void 0 ? void 0 : refMagicZoom.current, indexImageCurrent);
        }
    }, [
        idProduct,
        magicZoomRef,
        indexImageCurrent,
        productId
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_5__/* .buildTestIds */ .Fek)("head-magic-zoom")), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_5__/* .buildTestIds */ .Fek)("link-magic-zoom")), {
                    rel: "stylesheet",
                    href: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/scripts/magiczoomplus-commercial/magiczoomplus/magiczoomplus.css"
                }))
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_5__/* .buildTestIds */ .Fek)("script-magic-zoom")), {
                id: "MagicZoomScript",
                src: "https://fcx-s3-fercos-backoffice.ferreiracosta.com/scripts/magiczoomplus-commercial/magiczoomplus/magiczoomplus.js",
                strategy: "lazyOnload"
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "MagicZoomOptions",
                dangerouslySetInnerHTML: {
                    __html: '\n            var mzOptions = {};\n            mzOptions = {\n                onUpdate: function(abc, def) {\n                  const selectedThumbSequenceNumber = arguments[2]?.getAttribute("data-sequence-number");\n\n                  let currentSequenceNumber = 1;\n                  let boxMiniatureElements = Array.from(document.querySelectorAll(\'[data-thumb-number="thumb-list-item-box-miniature-\' + currentSequenceNumber + \'"]\'));\n\n                  while (boxMiniatureElements?.length) {\n                    if (currentSequenceNumber === Number(selectedThumbSequenceNumber)) {\n                      for (const element of boxMiniatureElements) {\n                        element.classList.remove("disabled");\n                        element.classList.add("active");\n                      }\n                    } else {\n                      for (const element of boxMiniatureElements) {\n                        element.classList.remove("active");\n                      }\n                    }\n\n                    currentSequenceNumber += 1;\n\n                    boxMiniatureElements = Array.from(document.querySelectorAll(\'[data-thumb-number="thumb-list-item-box-miniature-\' + currentSequenceNumber + \'"]\'));\n                  }\n                },\n            };\n          '
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .ContainerZoomImage */ .jc, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_5__/* .buildTestIds */ .Fek)("container-zoom-image")), {
                ref: refMagicZoom,
                id: "zoom-products",
                href: largeImage,
                className: "MagicZoom",
                "data-options": configZoom.join(";"),
                "data-mobile-options": configMobileZoom.join(";"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .MagicZoomImage */ .F9, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_5__/* .buildTestIds */ .Fek)("magic-zoom-image")), {
                    src: largeImage,
                    alt: descriptionImage
                }))
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .ViewMoreImagesZoom */ .yV, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_5__/* .buildTestIds */ .Fek)("view-more-images-zoom")), {
                children: moreImages ? moreImages.map(function(item) {
                    /*#__PURE__*/ return (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .ContainerImage */ .os, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_5__/* .buildTestIds */ .Fek)("container-image")), {
                        key: item === null || item === void 0 ? void 0 : item.sequenceNumber,
                        href: item.smallImage,
                        "data-zoom-id": "zoom-products",
                        "data-image": item.smallImage,
                        "data-sequence-number": item === null || item === void 0 ? void 0 : item.sequenceNumber
                    }), /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_6__/* .ImageThumb */ .BB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,application__WEBPACK_IMPORTED_MODULE_5__/* .buildTestIds */ .Fek)("image-thumb")), {
                        src: item.tinyImage
                    })));
                }) : null
            }))
        ]
    });
};



/***/ }),

/***/ 41870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": function() { return /* binding */ ImageThumb; },
/* harmony export */   "F9": function() { return /* binding */ MagicZoomImage; },
/* harmony export */   "jc": function() { return /* binding */ ContainerZoomImage; },
/* harmony export */   "os": function() { return /* binding */ ContainerImage; },
/* harmony export */   "yV": function() { return /* binding */ ViewMoreImagesZoom; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(430);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26365);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 4rem;\n  width: 4rem;\n  border: 2px solid ",
        ";\n  overflow: hidden;\n  cursor: pointer;\n  transition: border 500ms;\n\n  .active {\n    border-color: ",
        ";\n  }\n  .disabled:hover {\n    border-color: ",
        ";\n  }\n  :hover {\n    border-color: rgba(255, 0, 0, 0.2) !important;\n    filter: brightness(0.8);\n    transition: border 100ms !important;\n    transition: filter 100ms !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: max-content;\n  overflow: hidden;\n\n  @media ",
        " {\n    height: 676px;\n    width: 676px;\n  }\n\n  @media ",
        " {\n    height: auto;\n  }\n\n  img {\n    width: inherit;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var ContainerImage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "styles__ContainerImage",
    componentId: "sc-74690c87-0"
})(_templateObject(), ui__WEBPACK_IMPORTED_MODULE_2__.theme.colors.neutral[95], ui__WEBPACK_IMPORTED_MODULE_2__.theme.colors.primary[200], ui__WEBPACK_IMPORTED_MODULE_2__.theme.colors.primary[200]);
var ImageThumb = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].img.attrs */ .ZP.img.attrs(function(props) {
    return {
        src: (0,application__WEBPACK_IMPORTED_MODULE_1__/* .replaceImageBaseUrl */ .sMx)(props.src)
    };
}).withConfig({
    displayName: "styles__ImageThumb",
    componentId: "sc-74690c87-1"
})(_templateObject1());
var ViewMoreImagesZoom = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ViewMoreImagesZoom",
    componentId: "sc-74690c87-2"
})(_templateObject2());
var ContainerZoomImage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "styles__ContainerZoomImage",
    componentId: "sc-74690c87-3"
})(_templateObject3(), ui__WEBPACK_IMPORTED_MODULE_2__.theme.device.desktopFirst.tablet, ui__WEBPACK_IMPORTED_MODULE_2__.theme.device.desktopFirst.mobileL);
var MagicZoomImage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    displayName: "styles__MagicZoomImage",
    componentId: "sc-74690c87-4"
})(_templateObject4());


/***/ }),

/***/ 9542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fh": function() { return /* binding */ SkeletonContainer; },
/* harmony export */   "K3": function() { return /* binding */ BoxContainer; },
/* harmony export */   "f$": function() { return /* binding */ ItemWrapper; },
/* harmony export */   "kt": function() { return /* binding */ SkeletonFlexContainer; },
/* harmony export */   "nR": function() { return /* binding */ SkeletonWrapper; },
/* harmony export */   "rA": function() { return /* binding */ SkeletonChip; },
/* harmony export */   "s7": function() { return /* binding */ SkeletonCircle; },
/* harmony export */   "sD": function() { return /* binding */ SkeletonCardWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: ",
        ";\n  flex-direction: ",
        ";\n  flex-wrap: wrap;\n  gap: ",
        ";\n  justify-content: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  left: 36%;\n  border-radius: 100%;\n  width: 90px;\n  height: 90px;\n  background-color: ",
        ";\n\n  top: -35px;\n  z-index: 2;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  width: 120px;\n  height: 27px;\n  font-size: 1.17rem;\n  font-weight: 400;\n  padding: 0.4rem 0.65rem;\n  border-radius: 4px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 0.8rem;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  width: ",
        ";\n  border-bottom: 1px solid\n    ",
        ";\n  padding: ",
        " 0;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var SkeletonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "style__SkeletonWrapper",
    componentId: "sc-52db1cb3-0"
})(_templateObject(), function(param) {
    var hasMargin = param.hasMargin;
    return hasMargin ? "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4, " ").concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0) : "0";
});
var SkeletonFlexContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "style__SkeletonFlexContainer",
    componentId: "sc-52db1cb3-1"
})(_templateObject1(), function(param) {
    var alignItems = param.alignItems;
    return alignItems !== null && alignItems !== void 0 ? alignItems : "flex-start";
}, function(param) {
    var flexDirection = param.flexDirection;
    return flexDirection !== null && flexDirection !== void 0 ? flexDirection : "row";
}, function(param) {
    var gap = param.gap;
    return gap !== null && gap !== void 0 ? gap : "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x12, " ").concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x6);
}, function(param) {
    var justifyContent = param.justifyContent;
    return justifyContent !== null && justifyContent !== void 0 ? justifyContent : "flex-start";
}, function(param) {
    var marginBottom = param.marginBottom;
    return marginBottom !== null && marginBottom !== void 0 ? marginBottom : "0";
});
var SkeletonCardWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__SkeletonCardWrapper",
    componentId: "sc-52db1cb3-2"
})(_templateObject2(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "auto";
});
var SkeletonCircle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__SkeletonCircle",
    componentId: "sc-52db1cb3-3"
})(_templateObject3(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[125]);
var SkeletonChip = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__SkeletonChip",
    componentId: "sc-52db1cb3-4"
})(_templateObject4(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[100]);
var BoxContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__BoxContainer",
    componentId: "sc-52db1cb3-5"
})(_templateObject5());
var ItemWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "style__ItemWrapper",
    componentId: "sc-52db1cb3-6"
})(_templateObject6());
var SkeletonContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__SkeletonContainer",
    componentId: "sc-52db1cb3-7"
})(_templateObject7(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "auto";
}, function(param) {
    var borderColor = param.borderColor;
    return borderColor !== null && borderColor !== void 0 ? borderColor : "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[555]);
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x4);


/***/ }),

/***/ 7090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KS": function() { return /* binding */ NavButtonNext; },
/* harmony export */   "VK": function() { return /* binding */ NavButtonsContainer; },
/* harmony export */   "mn": function() { return /* binding */ SwiperContainer; },
/* harmony export */   "r": function() { return /* binding */ NavButtonPrev; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63356);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26365);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  .swiper-initialized {\n    height: auto;\n    .swiper-wrapper {\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n      .swiper-slide {\n        display: flex;\n        justify-content: center;\n        align-items: flex-start;\n        height: 100%;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  position: absolute;\n  top: 25%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n  z-index: 2;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border: none;\n  border-radius: 35px;\n  background: ",
        ";\n\n  box-shadow: ",
        " ",
        " ",
        "\n    ",
        ";\n  transition: 0.8s;\n  cursor: pointer;\n\n  path {\n    stroke: ",
        ";\n  }\n\n  &:hover {\n    background: ",
        " !important;\n  }\n\n  &:hover path {\n    stroke: ",
        " !important;\n  }\n\n  &:disabled {\n    background: ",
        ";\n    path {\n      stroke: ",
        ";\n    }\n\n    &:hover {\n      path {\n        transition: 0.8s;\n      }\n    }\n    opacity: 1;\n    visibility: visible;\n    cursor: default;\n  }\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SwiperContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__SwiperContainer",
    componentId: "sc-fa4c55d4-0"
})(_templateObject());
var NavButtonsContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__NavButtonsContainer",
    componentId: "sc-fa4c55d4-1"
})(_templateObject1());
var NavButtonPrev = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "styles__NavButtonPrev",
    componentId: "sc-fa4c55d4-2"
})(_templateObject2(), ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x15, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x15, function(param) {
    var isBlackTheme = param.isBlackTheme;
    var ref, ref1;
    return isBlackTheme ? "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme === null || ui__WEBPACK_IMPORTED_MODULE_1__.theme === void 0 ? void 0 : (ref = ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["50"], " !important") : "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, " !important");
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space.x0, ui__WEBPACK_IMPORTED_MODULE_1__.theme.space["x0.5"], ui__WEBPACK_IMPORTED_MODULE_1__.theme.space["x0.5"], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral["999-opacity-60"], function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme ? "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, " !important") : "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[450], " !important");
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.primary[200], ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral.white, function(param) {
    var isBlackTheme = param.isBlackTheme;
    var ref, ref1;
    return isBlackTheme ? "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme === null || ui__WEBPACK_IMPORTED_MODULE_1__.theme === void 0 ? void 0 : (ref = ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["110"], " !important") : "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[80], " !important");
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    var ref, ref1;
    return isBlackTheme ? "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme === null || ui__WEBPACK_IMPORTED_MODULE_1__.theme === void 0 ? void 0 : (ref = ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.blackFriday) === null || ref1 === void 0 ? void 0 : ref1["40"], " !important") : "".concat(ui__WEBPACK_IMPORTED_MODULE_1__.theme.colors.neutral[99], " !important");
}, ui__WEBPACK_IMPORTED_MODULE_1__.theme.device.desktopFirst.tablet);
var NavButtonNext = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(NavButtonPrev).withConfig({
    displayName: "styles__NavButtonNext",
    componentId: "sc-fa4c55d4-3"
})(_templateObject3());


/***/ }),

/***/ 11338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Qp": function() { return /* reexport */ AllowMeFingerprint; },
  "iw": function() { return /* reexport */ BroadcastChannelRaw; },
  "HT": function() { return /* reexport */ ClearSaleFingerprint; },
  "Vj": function() { return /* reexport */ Cookie; },
  "H1": function() { return /* reexport */ CookiesNext; },
  "Ld": function() { return /* reexport */ CreditCardTypeLib; },
  "YJ": function() { return /* reexport */ DocumentEventListener; },
  "dW": function() { return /* reexport */ Encryption; },
  "cr": function() { return /* reexport */ components/* EventScroll */.cr; },
  "M$": function() { return /* reexport */ GenesysChatBot; },
  "Ee": function() { return /* reexport */ components/* Image */.Ee; },
  "TD": function() { return /* reexport */ ImmerImpl; },
  "xp": function() { return /* reexport */ InsiderObject; },
  "ZQ": function() { return /* reexport */ JwtDecode; },
  "EX": function() { return /* reexport */ components/* MagicZoom */.EX; },
  "SA": function() { return /* reexport */ MockedClient; },
  "jp": function() { return /* reexport */ components/* NextjsBreadcrumbs */.jp; },
  "IM": function() { return /* reexport */ components/* ReactCountdownCircleTimer */.IM; },
  "jL": function() { return /* reexport */ components/* ReactDatePicker */.jL; },
  "L9": function() { return /* reexport */ components/* ReactLoadingSkeleton */.L9; },
  "Fv": function() { return /* reexport */ components/* ReactModal */.Fv; },
  "OA": function() { return /* reexport */ components/* ReactSlick */.OA; },
  "sN": function() { return /* reexport */ components/* ReactSpringBottomSheet */.sN; },
  "Q9": function() { return /* reexport */ components/* ReactVideoPlayer */.Q9; },
  "h7": function() { return /* reexport */ RequestIp; },
  "iE": function() { return /* reexport */ SWRHttpClient; },
  "Aw": function() { return /* reexport */ components/* ScrollToLink */.Aw; },
  "C$": function() { return /* reexport */ SecuredSessionStorage; },
  "I": function() { return /* reexport */ SentryClient; },
  "tI": function() { return /* reexport */ components/* SwiperSlider */.tI; },
  "GX": function() { return /* reexport */ UUIDLib; },
  "U_": function() { return /* reexport */ WebSocketRaw; },
  "g3": function() { return /* reexport */ ZustandImpl; },
  "UQ": function() { return /* reexport */ clarityRaw; },
  "EA": function() { return /* reexport */ gtagRaw; }
});

// UNUSED EXPORTS: CustomSWRConfig, FetchHttpClient, Head, Html2Canvas, ImageMagnify, JsCookie, MockedCookie, MockedIdentityApi, MockedPaymentApi, MultiEmailInput, ReactEasyCrop, ReactResponsiveCarousel, Recaptcha, isFutureDate, isInvalidYear, isValidDayForMonth, useFetcher

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
;// CONCATENATED MODULE: ../../packages/infra/broadcastChannel/index.ts



var BroadcastChannelRaw = /*#__PURE__*/ function() {
    "use strict";
    function BroadcastChannelRaw() {
        (0,_class_call_check/* default */.Z)(this, BroadcastChannelRaw);
        this.broadcastChannel = null;
        this.isChannelOpen = false;
        this.isCreatingBroadcastInstance = false;
    }
    var _proto = BroadcastChannelRaw.prototype;
    _proto.createChannel = function createChannel(channelName) {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(function() {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!((ref = _this.broadcastChannel) === null || ref === void 0 ? void 0 : ref.name) && !_this.isChannelOpen && !_this.isCreatingBroadcastInstance) {
                    _this.isCreatingBroadcastInstance = true;
                    try {
                        _this.broadcastChannel = new BroadcastChannel(channelName);
                        _this.isCreatingBroadcastInstance = false;
                        _this.isChannelOpen = true;
                    } catch (e) {
                        _this.isCreatingBroadcastInstance = false;
                    }
                }
                return [
                    2
                ];
            });
        })();
    };
    _proto.closeChannel = function closeChannel() {
        if (this.broadcastChannel) {
            this.broadcastChannel.close();
            this.broadcastChannel = null;
            this.isChannelOpen = false;
        }
    };
    _proto.getChannelName = function getChannelName() {
        var ref;
        return ((ref = this.broadcastChannel) === null || ref === void 0 ? void 0 : ref.name) || "";
    };
    _proto.postMessage = function postMessage(message) {
        var messageString = typeof message === "string" ? message : JSON.stringify(message);
        if (this.broadcastChannel) {
            this.broadcastChannel.postMessage(messageString);
        }
    };
    _proto.onMessage = function onMessage(callback) {
        if (this.broadcastChannel) {
            this.broadcastChannel.onmessage = function(event) {
                callback(event.data);
            };
        }
    };
    _proto.getIsChannelOpen = function getIsChannelOpen() {
        return this.isChannelOpen;
    };
    return BroadcastChannelRaw;
}();


// EXTERNAL MODULE: ../../packages/infra/components/index.ts + 234 modules
var components = __webpack_require__(62911);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/crypto-browserify/index.js
var crypto_browserify = __webpack_require__(71941);
var crypto_browserify_default = /*#__PURE__*/__webpack_require__.n(crypto_browserify);
;// CONCATENATED MODULE: ../../packages/infra/encryption/index.ts
/* provided dependency */ var Buffer = __webpack_require__(48834)["Buffer"];


var Encryption = /*#__PURE__*/ function() {
    "use strict";
    function Encryption() {
        (0,_class_call_check/* default */.Z)(this, Encryption);
    }
    var _proto = Encryption.prototype;
    _proto.initialize = function initialize(keyValue, ivValue) {
        this.key = Buffer.from(keyValue, "hex");
        this.iv = Buffer.from(ivValue, "hex");
    };
    _proto.encrypt = function encrypt(data) {
        try {
            var cipher = crypto_browserify_default().createCipheriv("aes-256-cbc", this.key, this.iv);
            var encrypted = cipher.update(data, "utf-8", "hex");
            encrypted += cipher.final("hex");
            return encrypted;
        } catch (e) {
            return "";
        }
    };
    _proto.decrypt = function decrypt(data) {
        try {
            var decipher = crypto_browserify_default().createDecipheriv("aes-256-cbc", this.key, this.iv);
            var decrypted = decipher.update(data, "hex", "utf-8");
            decrypted += decipher.final("utf-8");
            return decrypted;
        } catch (e) {
            return "";
        }
    };
    return Encryption;
}();


;// CONCATENATED MODULE: ../../packages/infra/event-emitter/document-event-listener/index.ts
/* eslint-disable class-methods-use-this */ 
var DocumentEventListener = /*#__PURE__*/ function() {
    "use strict";
    function DocumentEventListener() {
        (0,_class_call_check/* default */.Z)(this, DocumentEventListener);
    }
    var _proto = DocumentEventListener.prototype;
    _proto.emit = function emit(event, data) {
        var customEvent = new CustomEvent(event, {
            detail: data
        });
        document.dispatchEvent(customEvent);
    };
    _proto.subscribe = function subscribe(event, callback) {
        document.addEventListener(event, callback);
    };
    _proto.unsubscribe = function unsubscribe(event, callback) {
        document.removeEventListener(event, callback);
    };
    return DocumentEventListener;
}();


;// CONCATENATED MODULE: ../../packages/infra/event-emitter/index.ts


// EXTERNAL MODULE: ../../packages/infra/node_modules/cookie/index.js
var cookie = __webpack_require__(4468);
;// CONCATENATED MODULE: ../../packages/infra/http/Cookie.ts

var Cookie = {
    parse: function parse(value) {
        return (0,cookie/* parse */.Q)(value);
    },
    serialize: function serialize(name, value) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined;
        return (0,cookie/* serialize */.q)(name, value, options);
    }
};

// EXTERNAL MODULE: ../../node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(35196);
;// CONCATENATED MODULE: ../../packages/infra/http/CookiesNext.ts

var CookiesNext = {
    setCookie: function setCookie(param) {
        var name = param.name, value = param.value, options = param.options;
        var formattedOptions = options;
        (0,lib.setCookie)(String(name), String(value), formattedOptions);
    },
    getCookie: function getCookie(param) {
        var name = param.name, options = param.options;
        var formattedOptions = options;
        return (0,lib.getCookie)(String(name), formattedOptions);
    },
    deleteCookie: function deleteCookie(param) {
        var name = param.name, options = param.options;
        var formattedOptions = options;
        (0,lib.deleteCookie)(String(name), formattedOptions);
    }
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../packages/application/utils/http/index.tsx + 6 modules
var http = __webpack_require__(60143);
;// CONCATENATED MODULE: ../../packages/infra/http/FetchHttpClient.ts




var errorToCallApi = "Erro na chamada da API";
var FetchHttpClient = {
    useGet: function(url) {
        return fetch(url, {
            headers: (0,src_object_spread/* default */.Z)({}, http/* defaultHeaders */.B)
        }).then(function(response) {
            return {
                data: response.json(),
                error: null
            };
        }).catch(function(err) {
            // console.log(err);
            return {
                data: null,
                error: err || {
                    message: errorToCallApi
                }
            };
        });
    },
    usePost: function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(url, body) {
            var formattedBody;
            return (0,tslib_es6.__generator)(this, function(_state) {
                formattedBody = body;
                return [
                    2,
                    fetch(url, {
                        body: formattedBody,
                        method: "POST",
                        headers: (0,src_object_spread/* default */.Z)({}, http/* defaultHeaders */.B)
                    }).then(function(response) {
                        return {
                            data: response.json(),
                            error: null
                        };
                    }).catch(function(err) {
                        // console.log(err);
                        return {
                            data: null,
                            error: err || {
                                message: errorToCallApi
                            }
                        };
                    })
                ];
            });
        });
        return function(url, body) {
            return _ref.apply(this, arguments);
        };
    }(),
    usePut: function usePut(url, headers, body) {
        var formattedBody = body;
        return fetch(url, {
            headers: (0,src_object_spread/* default */.Z)({}, headers, http/* defaultHeaders */.B),
            body: formattedBody,
            method: "PUT"
        }).then(function(response) {
            return response;
        }).catch(function(err) {
            // console.log(err);
            return err;
        });
    },
    usePatch: function usePatch(url, headers, body) {
        var formattedBody = body;
        return fetch(url, {
            headers: (0,src_object_spread/* default */.Z)({}, headers, http/* defaultHeaders */.B),
            body: formattedBody,
            method: "PATCH"
        }).then(function(response) {
            return {
                data: response.json(),
                error: null
            };
        }).catch(function(err) {
            // console.log(err);
            return {
                data: null,
                error: err || {
                    message: errorToCallApi
                }
            };
        });
    },
    useDelete: function useDelete(url, headers, body) {
        var formattedBody = body;
        return fetch(url, {
            headers: (0,src_object_spread/* default */.Z)({}, headers, http/* defaultHeaders */.B),
            body: formattedBody,
            method: "DELETE"
        }).then(function(response) {
            return {
                data: response.json(),
                error: null
            };
        }).catch(function(err) {
            // console.log(err);
            return {
                data: null,
                error: err || {
                    message: errorToCallApi
                }
            };
        });
    }
};

;// CONCATENATED MODULE: ../../node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */



;// CONCATENATED MODULE: ../../packages/infra/http/JsCookie.ts

var JsCookie = {
    setCookie: function setCookie(param) {
        var name = param.name, value = param.value;
        api.set(String(name), String(value));
    },
    getCookie: function getCookie(param) {
        var name = param.name;
        return api.get(String(name));
    },
    deleteCookie: function deleteCookie(param) {
        var name = param.name;
        api.remove(String(name));
    }
};

// EXTERNAL MODULE: ../../packages/application/services/mocks/index.ts + 5 modules
var mocks = __webpack_require__(49294);
;// CONCATENATED MODULE: ../../packages/infra/http/MockedClient.ts
// import { setupWorker } from "msw";
// import { setupServer } from "msw/node";
// import { CoupleDetailDto, SupportContactDto, UtilInfoDto } from "typing/dto";




// const runMockServiceWorker = () => {
//     if (typeof window === "undefined") {
//         const server = setupServer(
//             ...supportContactHandlers,
//             ...utilInfoHandlers,
//             ...weddingGiftListHandlers
//         );
//         server.listen({
//             onUnhandledRequest: "bypass",
//         });
//     } else {
//         const worker = setupWorker(
//             ...supportContactHandlers,
//             ...utilInfoHandlers,
//             ...weddingGiftListHandlers
//         );
//         worker.start({
//             onUnhandledRequest: "bypass",
//         });
//     }
// };
// export default runMockServiceWorker;
var notImplementedErrorStr = "Function not implemented.";
var MockedClient = {
    useGet: function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(endpoint) {
            var allResponses, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        allResponses = (0,src_object_spread/* default */.Z)({}, mocks/* supportContactHandlers */.oA, mocks/* utilInfoHandlers */.H8);
                        return [
                            4,
                            allResponses["".concat(endpoint)]()
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response) {
                            return [
                                2,
                                {
                                    data: null,
                                    error: {
                                        message: "Endpoint does not exist"
                                    },
                                    isLoading: false
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                data: response,
                                error: null,
                                isLoading: false
                            }
                        ];
                }
            });
        });
        return function(endpoint) {
            return _ref.apply(this, arguments);
        };
    }(),
    usePost: function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(endpoint) {
            var allResponses, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        allResponses = (0,src_object_spread/* default */.Z)({}, mocks/* supportContactHandlers */.oA, mocks/* utilInfoHandlers */.H8);
                        return [
                            4,
                            allResponses["".concat(endpoint)]()
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response) {
                            return [
                                2,
                                {
                                    data: null,
                                    error: {
                                        message: "Endpoint does not exist"
                                    },
                                    isLoading: false
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                data: response,
                                error: null,
                                isLoading: false
                            }
                        ];
                }
            });
        });
        return function(endpoint) {
            return _ref.apply(this, arguments);
        };
    }(),
    usePatch: function usePatch() {
        throw new Error(notImplementedErrorStr);
    },
    useDelete: function useDelete() {
        throw new Error(notImplementedErrorStr);
    },
    usePut: function usePut() {
        throw new Error(notImplementedErrorStr);
    }
};


;// CONCATENATED MODULE: ../../packages/infra/http/MockedCookie.ts
var keyAndValueMap = new Map();
var MockedCookie = {
    setCookie: function setCookie(param) {
        var name = param.name, value = param.value;
        keyAndValueMap.set(String(name), String(value));
    },
    getCookie: function getCookie(param) {
        var name = param.name;
        return keyAndValueMap.get(String(name));
    },
    deleteCookie: function deleteCookie(param) {
        var name = param.name;
        keyAndValueMap.delete(String(name));
    }
};

;// CONCATENATED MODULE: ../../packages/infra/http/MockedIdentityApi.ts
var MockedIdentityApi = {
    baseUrl: "mocked_identity_base_url",
    clientId: "mocked_client_id",
    // deepcode ignore HardcodedNonCryptoSecret: <apenas um mock de secret com um valor qualquer>
    clientSecret: "mocked_client_secret",
    scopeEcommerce: "ecommerce offline_access IdentityServerApi",
    appMonitoringClient: {},
    initialize: function initialize(httpClient, appMonitoringClient) {
        this.appMonitoringClient = appMonitoringClient;
    }
};

;// CONCATENATED MODULE: ../../packages/infra/http/MockedPaymentApi.ts
var MockedPaymentApi = {
    baseUrl: "",
    SALE_CHANNEL: 4,
    getCards: function getCards(jwt, condition) {
        var isLoading = jwt && condition;
        var error = null;
        var data = [
            {
                id: 3147,
                ownerName: "artur polo norte",
                lastFourNumbers: "4242",
                banner: "Visa",
                cardExpiringDate: "12/2032",
                token: "0vgqzkuUCQU=",
                clientId: 4505,
                updatedon: "2023-03-14T09:34:47.910366",
                bin: "424242",
                cpfHolder: "42471108024",
                tokenBraspag: null,
                tokenMundipagg: " ",
                cardType: "C"
            }, 
        ];
        return {
            data: data,
            error: error,
            isLoading: isLoading
        };
    }
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../packages/application/index.tsx + 11 modules
var application = __webpack_require__(430);
// EXTERNAL MODULE: ../../node_modules/next/error.js
var error = __webpack_require__(70689);
// EXTERNAL MODULE: ../../node_modules/swr/dist/index.mjs
var dist = __webpack_require__(49857);
;// CONCATENATED MODULE: ../../node_modules/jwt-decode/build/jwt-decode.esm.js
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* harmony default export */ var jwt_decode_esm = (o);
//# sourceMappingURL=jwt-decode.esm.js.map

;// CONCATENATED MODULE: ../../packages/infra/jwt-decode/index.tsx


var JwtDecode = /*#__PURE__*/ function() {
    "use strict";
    function JwtDecode() {
        (0,_class_call_check/* default */.Z)(this, JwtDecode);
    }
    var _proto = JwtDecode.prototype;
    // eslint-disable-next-line class-methods-use-this
    _proto.decode = function decode(token) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        var formattedOptions = options;
        return jwt_decode_esm(token, formattedOptions);
    };
    return JwtDecode;
}();


// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(92642);
;// CONCATENATED MODULE: ../../packages/infra/monitoring/SentryClient.ts

var SentryClient = {
    captureException: function(error) {
        var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        return (0,esm_exports/* captureException */.Tb)(error, context);
    },
    captureMessage: function(message) {
        var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        return (0,esm_exports/* captureMessage */.uT)(message, context);
    },
    configureScope: function(user, token) {
        return (0,esm_exports/* configureScope */.e)(function(sentryScope) {
            if (user) {
                sentryScope.setUser(user);
                sentryScope.setExtra("fcx_labs_user_access_token", token);
            } else {
                (0,esm_exports/* setUser */.av)(null);
                sentryScope.setExtra("fcx_labs_user_access_token", undefined);
            }
        });
    },
    addBreadcrumb: function(breadcrumb) {
        return (0,esm_exports/* addBreadcrumb */.n_)(breadcrumb);
    }
};

;// CONCATENATED MODULE: ../../packages/infra/monitoring/index.ts


;// CONCATENATED MODULE: ../../packages/infra/http/SWRHttpClient.ts










// deepcode ignore HardcodedNonCryptoSecret: não é uma secret, apenas o valor da key que terá o secret como value
// const accessTokenCookieKey = "@FC:Ecom:Token:Access";
var isPrimitive = function(variable) {
    return !!(variable && (typeof variable === "boolean" || typeof variable === "string" || typeof variable === "number"));
};
var getResponseHeaders = function(headers) {
    return {
        currentPage: headers.get("x-pagination-currentpage"),
        pageSize: headers.get("x-pagination-pagesize"),
        totalPages: headers.get("x-pagination-totalpages"),
        totalResults: headers.get("x-pagination-totalresults")
    };
};
var formattedResponse = function(response) {
    var isResponseOk = response === null || response === void 0 ? void 0 : response.ok;
    var responseStatus = response === null || response === void 0 ? void 0 : response.status;
    var responseUrl = response === null || response === void 0 ? void 0 : response.url;
    return response.json().then(function(resolvedResponse) {
        if (Array.isArray(resolvedResponse)) {
            return resolvedResponse.map(function(resolvedResponseItemList) {
                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, resolvedResponseItemList), {
                    headers: getResponseHeaders(response.headers),
                    status: responseStatus
                });
            });
        }
        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, resolvedResponse, isPrimitive(resolvedResponse) && {
            response: resolvedResponse
        }), {
            headers: getResponseHeaders(response.headers),
            status: responseStatus
        });
    }).catch(function() {
        if (!isResponseOk) {
            throw new error["default"]({
                statusCode: responseStatus,
                title: "Erro retornado na request feita em ".concat(responseUrl)
            });
        }
        return null;
    });
};
// const accessTokenIsRefreshed: Middleware =
//   (useSWRNext: SWRHook) => (key, fetcher, config) => {
//     const accessToken = CookiesNext.getCookie({ name: accessTokenCookieKey });
//     // const [isHandlingRefreshAccessToken, setIsHandlingRefreshAccessToken] =
//     //   useState(true);
//     // const [newAccessToken, setNewAccessToken] = useState<string | undefined>(
//     //   undefined
//     // );
//     // useEffect(() => {
//     //   const callHandleRefreshUserAccessToken = async () => {
//     //     const { refreshingAccessToken, refreshedAccessToken } =
//     //       await handleRefreshUserAccessToken(
//     //         CookiesNext,
//     //         SentryClient,
//     //         accessToken
//     //       );
//     //     if (
//     //       refreshingAccessToken !== undefined &&
//     //       refreshingAccessToken === false
//     //     ) {
//     //       setIsHandlingRefreshAccessToken(false);
//     //       if (refreshedAccessToken) {
//     //         setNewAccessToken(refreshedAccessToken);
//     //       }
//     //     }
//     //   };
//     //   callHandleRefreshUserAccessToken();
//     // }, [accessToken]);
//     let customFetcher = fetcher;
//     if (fetcher) {
//       customFetcher = (...args: unknown[]) => {
//         return handleRefreshUserAccessToken(
//           CookiesNext,
//           SentryClient,
//           accessToken
//         ).then(() => {
//           return fetcher(...args);
//         });
//       };
//     }
//     return useSWRNext(key, customFetcher, config);
//   };
var jwtDecoder = new JwtDecode();
function useFetcher(input, init) {
    return _useFetcher.apply(this, arguments);
}
function _useFetcher() {
    _useFetcher = (0,src_async_to_generator/* default */.Z)(function(input, init) {
        var condition, ref, accessToken, ref1, refreshedAccessToken, cancelRequest, response, _tmp;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    condition = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true;
                    accessToken = (ref = init === null || init === void 0 ? void 0 : init.headers) === null || ref === void 0 ? void 0 : ref.Authorization;
                    return [
                        4,
                        (0,application/* handleRefreshUserAccessToken */.Wu_)(CookiesNext, SentryClient, jwtDecoder, accessToken)
                    ];
                case 1:
                    ref1 = _state.sent(), refreshedAccessToken = ref1.refreshedAccessToken, cancelRequest = ref1.cancelRequest;
                    if (cancelRequest) {
                        return [
                            2,
                            new Promise(function(resolve) {
                                resolve({
                                    data: null,
                                    error: null
                                });
                            })
                        ];
                    }
                    if (!condition) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        fetch(input, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, init), {
                            headers: (0,src_object_spread/* default */.Z)({}, init === null || init === void 0 ? void 0 : init.headers, application/* defaultHeaders */.Bas, refreshedAccessToken && {
                                Authorization: "Bearer ".concat(refreshedAccessToken)
                            })
                        }))
                    ];
                case 2:
                    _tmp = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    _tmp = null;
                    _state.label = 4;
                case 4:
                    response = _tmp;
                    // return response && typeof response === "object"
                    //   ? { ...(await response.json()), headers: response.headers }
                    //   : null;
                    return [
                        2,
                        response ? formattedResponse(response) : null
                    ];
            }
        });
    });
    return _useFetcher.apply(this, arguments);
}
var applicationJsonStr = "application/json";
var SWRHttpClient = {
    useGet: function(url) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined, condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, fallbackData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined;
        // const accessToken = (params?.headers as IHttpParams)
        //   ?.Authorization as string;
        var parameters = {
            revalidateOnFocus: false,
            revalidateOnMount: true,
            revalidateOnReconnect: false,
            refreshWhenOffline: false,
            refreshWhenHidden: false,
            refreshInterval: 0,
            fallbackData: fallbackData,
            // use: accessToken ? [accessTokenIsRefreshed] : undefined,
            onErrorRetry: function(error, key, _, revalidate, param) {
                var retryCount = param.retryCount;
                var ref;
                (0,application/* handleOnErrorRetry */.A42)({
                    url: key,
                    retryCount: retryCount,
                    status: error === null || error === void 0 ? void 0 : (ref = error.props) === null || ref === void 0 ? void 0 : ref.statusCode,
                    doRequestAgain: revalidate
                });
            }
        };
        var useCustomGetFetcher = params ? function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(input) {
                var customParams, customHeaders, accessToken, ref, refreshedAccessToken, cancelRequest, formattedCustomParams, response;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            customParams = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : params;
                            customHeaders = customParams === null || customParams === void 0 ? void 0 : customParams.headers;
                            accessToken = customHeaders === null || customHeaders === void 0 ? void 0 : customHeaders.Authorization;
                            return [
                                4,
                                (0,application/* handleRefreshUserAccessToken */.Wu_)(CookiesNext, SentryClient, jwtDecoder, accessToken)
                            ];
                        case 1:
                            ref = _state.sent(), refreshedAccessToken = ref.refreshedAccessToken, cancelRequest = ref.cancelRequest;
                            if (cancelRequest) {
                                return [
                                    2,
                                    new Promise(function(resolve) {
                                        resolve({
                                            data: null,
                                            error: null
                                        });
                                    })
                                ];
                            }
                            formattedCustomParams = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, customParams), {
                                headers: (0,src_object_spread/* default */.Z)({}, customHeaders, application/* defaultHeaders */.Bas, refreshedAccessToken && {
                                    Authorization: "Bearer ".concat(refreshedAccessToken)
                                })
                            });
                            return [
                                4,
                                fetch(input, formattedCustomParams)
                            ];
                        case 2:
                            response = _state.sent();
                            return [
                                2,
                                response ? formattedResponse(response) : null
                            ];
                    }
                });
            });
            return function(input) {
                return _ref.apply(this, arguments);
            };
        }() : null;
        var ref = (0,dist/* default */.ZP)(condition ? url : null, useCustomGetFetcher || useFetcher, parameters), data = ref.data, error = ref.error, trigger = ref.mutate, isLoading = ref.isValidating;
        return {
            data: data,
            error: error,
            trigger: trigger,
            isLoading: isLoading
        };
    },
    usePost: function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(url, body, params) {
            var condition;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                condition = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : true;
                return [
                    2,
                    useFetcher(url, (0,src_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        body: JSON.stringify(body),
                        method: "POST"
                    }, params), {
                        headers: (0,src_object_spread/* default */.Z)({
                            "Content-Type": applicationJsonStr
                        }, params === null || params === void 0 ? void 0 : params.headers, application/* defaultHeaders */.Bas)
                    }), (params === null || params === void 0 ? void 0 : params.signal) && {
                        signal: AbortSignal.timeout(Number(params.signal))
                    }), condition).then(function(res) {
                        return res;
                    }).catch(function(error) {
                        return error;
                    })
                ];
            });
        });
        return function(url, body, params) {
            return _ref.apply(this, arguments);
        };
    }(),
    usePut: function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(url, header, body) {
            var bodyType;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                bodyType = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : "json";
                return [
                    2,
                    useFetcher(url, {
                        body: bodyType === "json" ? JSON.stringify(body) : body,
                        method: "PUT",
                        headers: (0,src_object_spread/* default */.Z)({}, bodyType === "json" && {
                            "Content-Type": applicationJsonStr
                        }, header, application/* defaultHeaders */.Bas)
                    }).then(function(res) {
                        return res;
                    }).catch(function(error) {
                        return error;
                    })
                ];
            });
        });
        return function(url, header, body) {
            return _ref.apply(this, arguments);
        };
    }(),
    usePatch: function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(url, header, body) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    useFetcher(url, {
                        body: JSON.stringify(body),
                        method: "PATCH",
                        headers: (0,src_object_spread/* default */.Z)({
                            "Content-Type": applicationJsonStr
                        }, header, application/* defaultHeaders */.Bas)
                    }).then(function(res) {
                        return res;
                    }).catch(function(error) {
                        return error;
                    })
                ];
            });
        });
        return function(url, header, body) {
            return _ref.apply(this, arguments);
        };
    }(),
    useDelete: function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(url, header, body) {
            var condition;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                condition = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : true;
                return [
                    2,
                    useFetcher(url, {
                        body: JSON.stringify(body),
                        method: "DELETE",
                        headers: (0,src_object_spread/* default */.Z)({
                            "Content-Type": applicationJsonStr
                        }, header, application/* defaultHeaders */.Bas)
                    }, condition).then(function(res) {
                        return res;
                    }).catch(function(error) {
                        // console.log(error);
                        return error;
                    })
                ];
            });
        });
        return function(url, header, body) {
            return _ref.apply(this, arguments);
        };
    }()
};


;// CONCATENATED MODULE: ../../packages/infra/http/index.ts










// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/infra/node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ../../packages/infra/node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ../../packages/infra/node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ../../packages/infra/node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
;// CONCATENATED MODULE: ../../packages/infra/integrations/clear-sale/index.tsx





var clearSaleSessionIdStr = "clear-sale-session-id";
var clientSessionIdStr = "@FC:Ecom:Client:sessionId";
var ClearSaleFingerprint = {
    collect: function collect() {
        var hostEnv = "production" || 0;
        if (![
            "production",
            "qas"
        ].includes(hostEnv)) {
            return null;
        }
        var alreadyExistentSessionId = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(clientSessionIdStr);
        if (alreadyExistentSessionId) {
            return alreadyExistentSessionId;
        }
        var generatedId = esm_browser_v4();
        sessionStorage.setItem(clientSessionIdStr, String(generatedId));
        return generatedId;
    },
    Script: function() {
        var ref = (0,react.useState)(""), hostEnv = ref[0], setHostEnv = ref[1];
        var ref1 = (0,react.useState)(""), appKey = ref1[0], setAppKey = ref1[1];
        var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
            return state.allConfigs;
        });
        (0,react.useEffect)(function() {
            if ((allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.clearSaleAppKey) && (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.hostEnv)) {
                setAppKey((0,application/* obfuscate */.H6d)(allConfigs.clearSaleAppKey));
                setHostEnv(allConfigs.hostEnv);
            }
        }, [
            allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.clearSaleAppKey,
            allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.hostEnv
        ]);
        if (![
            "production",
            "qas"
        ].includes(hostEnv) || !appKey) {
            return null;
        }
        var sessionId = ClearSaleFingerprint.collect();
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    id: clearSaleSessionIdStr,
                    value: sessionId
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "clear-sale-fingerprint-script",
                    strategy: "afterInteractive",
                    children: '!function(e,s,c,n,t,a,o){e.CsdpObject=t,e[t]=e[t]||function(){(e[t].q=e[t].q||[]).push(arguments)},e[t].l=1*Date.now(),a=s.createElement(c),o=s.getElementsByTagName(c)[0],a.async=1,a.src=n,o.parentNode.insertBefore(a,o)}(window,document,"script","//device.clearsale.com.br/p/fp.js","csdp"),csdp("app","'.concat(appKey, '"),csdp("inputsessionid","').concat(clearSaleSessionIdStr, '");')
                })
            ]
        });
    },
    remove: function() {
        sessionStorage.removeItem("@FC:Ecom:Client:sessionId");
    }
};


;// CONCATENATED MODULE: ../../packages/infra/integrations/insider/index.tsx
/* eslint-disable camelcase */ 

var InsiderObject = {
    pageObject: function(type) {
        window.insider_object = window.insider_object || {};
        window.insider_object.page = {
            type: type
        };
    },
    userObject: function(params) {
        window.insider_object = window.insider_object || {};
        window.insider_object.user = params;
    },
    productObject: function(param) {
        var product_id = param.product_id, name = param.name, taxonomy = param.taxonomy, url = param.url, image_url = param.image_url, price = param.price, currency = param.currency, color = param.color, voucherName = param.voucherName, size = param.size, salePrice = param.salePrice, spotPrice = param.spotPrice, voucherDiscountPercentage = param.voucherDiscountPercentage, voucherDiscountValue = param.voucherDiscountValue, product_tag = param.product_tag, branch_id = param.branch_id, model = param.model, brand = param.brand;
        window.insider_object = window.insider_object || {};
        window.insider_object.product = {
            product_id: product_id,
            name: name,
            taxonomy: taxonomy,
            url: url,
            image_url: image_url,
            price: price,
            currency: currency,
            color: color,
            size: size,
            salePrice: salePrice,
            custom: {
                spotPrice: spotPrice,
                voucherName: voucherName,
                voucherDiscountPercentage: voucherDiscountPercentage,
                voucherDiscountValue: voucherDiscountValue,
                product_tag: product_tag,
                branch_id: branch_id,
                model: model,
                brand: brand
            }
        };
    },
    transactionObject: function(param) {
        var order_id = param.order_id, currency = param.currency, total = param.total, shipping_cost = param.shipping_cost, delivery = param.delivery, line_items = param.line_items, payment_type = param.payment_type;
        window.insider_object = window.insider_object || {};
        window.insider_object.transaction = {
            order_id: order_id,
            currency: currency,
            total: total,
            shipping_cost: shipping_cost,
            delivery: delivery,
            line_items: line_items,
            payment_type: payment_type
        };
    },
    getRecommendedProducts: function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(crmEndpoint, userId, branchId, shuffle, appMonitoringClient) {
            var ref, insiderBaseUrl, insiderUrl, userData, response, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        insiderBaseUrl = "https://recommendationv2.api.useinsider.com/v2";
                        insiderUrl = "".concat(insiderBaseUrl).concat(crmEndpoint, "?partnerName=ferreiracosta&locale=pt_BR:").concat(branchId || 2, "&currency=BRL&platform=web&details=false&shuffle=").concat(!!shuffle, "&userId=").concat(userId);
                        userData = window === null || window === void 0 ? void 0 : (ref = window.insider_object) === null || ref === void 0 ? void 0 : ref.user;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch(insiderUrl, {
                                cache: "no-cache"
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        data = _state.sent();
                        if (data.success) {
                            return [
                                2,
                                data
                            ];
                        }
                        appMonitoringClient === null || appMonitoringClient === void 0 ? void 0 : appMonitoringClient.captureMessage("Erro ao solicitar os produtos no endpoint ".concat(crmEndpoint, " da insider. Messagem de erro: ").concat(data === null || data === void 0 ? void 0 : data.message), {
                            level: "error",
                            user: {
                                email: userData === null || userData === void 0 ? void 0 : userData.email
                            }
                        });
                        return [
                            2,
                            null
                        ];
                    case 4:
                        error = _state.sent();
                        appMonitoringClient === null || appMonitoringClient === void 0 ? void 0 : appMonitoringClient.captureException(error, {
                            level: "error",
                            user: {
                                email: userData === null || userData === void 0 ? void 0 : userData.email
                            }
                        });
                        return [
                            2,
                            null
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(crmEndpoint, userId, branchId, shuffle, appMonitoringClient) {
            return _ref.apply(this, arguments);
        };
    }(),
    clearProductObject: function clearProductObject() {
        var ref;
        window === null || window === void 0 ? void 0 : (ref = window.insider_object) === null || ref === void 0 ? void 0 : delete ref.product;
    },
    clearUserObject: function clearUserObject() {
        var ref;
        window === null || window === void 0 ? void 0 : (ref = window.insider_object) === null || ref === void 0 ? void 0 : delete ref.user;
    },
    clearTransactionObject: function clearTransactionObject() {
        var ref;
        window === null || window === void 0 ? void 0 : (ref = window.insider_object) === null || ref === void 0 ? void 0 : delete ref.transaction;
    },
    reinitializeTag: function reinitializeTag() {
        var // setTimeout(() => {
        ref, ref1;
        window === null || window === void 0 ? void 0 : (ref = window.Insider) === null || ref === void 0 ? void 0 : (ref1 = ref.eventManager) === null || ref1 === void 0 ? void 0 : ref1.dispatch("init-manager:re-initialize");
    // }, 500);
    },
    changePageTypeToOther: function changePageTypeToOther() {
        setTimeout(function() {
            window.insider_object.page = {
                type: "Other"
            };
        }, 2000);
    },
    getUserData: function getUserData() {
        var ref;
        return window === null || window === void 0 ? void 0 : (ref = window.insider_object) === null || ref === void 0 ? void 0 : ref.user;
    },
    sendEvent: function sendEvent(event, keys) {
        var ref;
        window === null || window === void 0 ? void 0 : (ref = window.Insider) === null || ref === void 0 ? void 0 : ref.track(event, keys);
    },
    insiderId: "10008597"
};


;// CONCATENATED MODULE: ../../packages/infra/integrations/gtag/index.ts




var handleIsGtagDefined = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(retryTimes) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (!(window === null || window === void 0 ? void 0 : window.gtag)) {
                if (retryTimes >= 5) {
                    return [
                        2,
                        Promise.resolve({
                            action: "abort"
                        })
                    ];
                }
                return [
                    2,
                    new Promise(function(resolve) {
                        setTimeout(function() {
                            resolve({
                                action: "retry"
                            });
                        }, 1000);
                    })
                ];
            }
            return [
                2,
                {
                    action: "continue"
                }
            ];
        });
    });
    return function handleIsGtagDefined(retryTimes) {
        return _ref.apply(this, arguments);
    };
}();
// https://developers.google.com/analytics/devguides/collection/gtagjs/events
var gtag_event = function(eventProps) {
    var retryTimes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    handleIsGtagDefined(retryTimes)// eslint-disable-next-line sonarjs/cognitive-complexity
    .then(function(param) {
        var isGtagDefinedAction = param.action;
        if (isGtagDefinedAction === "abort") {
            return;
        }
        if (isGtagDefinedAction === "retry") {
            gtag_event(eventProps, retryTimes + 1);
            return;
        }
        var action = eventProps.action, category = eventProps.category, label = eventProps.label, value = eventProps.value, items = eventProps.items, method = eventProps.method, searchTerm = eventProps.searchTerm, sendTo = eventProps.sendTo, currency = eventProps.currency, transactionId = eventProps.transactionId, itemListId = eventProps.itemListId, itemListName = eventProps.itemListName, shippingTier = eventProps.shippingTier, shipping = eventProps.shipping, paymentType = eventProps.paymentType, quantity = eventProps.quantity, zipCode = eventProps.zipCode, clientId = eventProps.clientId, discount = eventProps.discount, productId = eventProps.productId, productName = eventProps.productName, fcShippingOptions = eventProps.fcShippingOptions;
        window.gtag("event", action, (0,src_object_spread/* default */.Z)({}, value && {
            value: value
        }, category && {
            event_category: category
        }, label && {
            event_label: label
        }, items && {
            items: items
        }, method && {
            method: method
        }, searchTerm && {
            search_term: searchTerm
        }, sendTo && {
            send_to: sendTo
        }, currency && {
            currency: currency
        }, transactionId && {
            transaction_id: transactionId
        }, itemListId && {
            item_list_id: itemListId
        }, itemListName && {
            item_list_name: itemListName
        }, shippingTier && {
            shipping_tier: shippingTier
        }, shipping && {
            shipping: shipping
        }, paymentType && {
            payment_type: paymentType
        }, quantity && {
            quantity: quantity
        }, zipCode && {
            zipCode: zipCode
        }, clientId && {
            client: clientId
        }, discount && {
            discount: discount
        }, productId && {
            product_id: productId
        }, productName && {
            productName: productName
        }, fcShippingOptions && {
            fc_shipping_options: fcShippingOptions
        }));
    }).catch(function() {
        return undefined;
    });
};
// const addToCartGoogleAdsLabel =
//   process.env.NEXT_PUBLIC_HOST_ENV !== "production"
//     ? "/nT5ACKfflZ0YEIKt7cEo"
//     : "/0094CPmOx6gYEIOF-OYC";
// const beginCheckoutGoogleAdsLabel =
//   process.env.NEXT_PUBLIC_HOST_ENV !== "production"
//     ? "/nJF9CKrflZ0YEIKt7cEo"
//     : "/YFA2CN2Z0qgYEIOF-OYC";
var gtagRaw = {
    GA_TRACKING_ID:  false ? 0 : "G-9T953BGJS4",
    GTM_ID:  false ? 0 : "GTM-54XRRFM",
    GA_TRACKING_ID_DEV: "G-SQ70CTCNQ2",
    AW_ID:  false ? 0 : "AW-752747139",
    AW_PURCHASE_LABEL:  false ? 0 : "/1br_CMbOwKgYEIOF-OYC",
    pageview: function pageview(url) {
        window === null || window === void 0 ? void 0 : window.gtag("config", gtagRaw.GA_TRACKING_ID, {
            page_path: url
        });
    },
    addToCart: function(value, item) {
        var currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "BRL";
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
        // Precisamos entender melhor como enviar a tag de google ads sem que ela seja de conversão
        // Evento do AW
        // event({
        //   action: "conversion",
        //   value: args.price,
        //   currency,
        //   sendTo: `${gtagRaw.AW_ID}${addToCartGoogleAdsLabel}`,
        // });
        // Evento do GA
        gtag_event({
            currency: currency,
            action: "add_to_cart",
            category: "ecommerce",
            label: "Adicionar ao carrinho",
            value: value,
            items: [
                {
                    item_id: item === null || item === void 0 ? void 0 : item.id,
                    quantity: item === null || item === void 0 ? void 0 : item.quantity,
                    item_name: item === null || item === void 0 ? void 0 : item.description,
                    item_brand: item === null || item === void 0 ? void 0 : item.brand,
                    item_category: item === null || item === void 0 ? void 0 : (ref = item.breadCrumbs) === null || ref === void 0 ? void 0 : (ref1 = ref.category) === null || ref1 === void 0 ? void 0 : ref1.name,
                    item_category2: item === null || item === void 0 ? void 0 : (ref2 = item.breadCrumbs) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fatherCategory) === null || ref3 === void 0 ? void 0 : ref3.name,
                    item_category3: item === null || item === void 0 ? void 0 : (ref4 = item.breadCrumbs) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.grandFatherCategory) === null || ref5 === void 0 ? void 0 : ref5.name,
                    price: (item === null || item === void 0 ? void 0 : (ref6 = item.prices) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.spotPrice) || (item === null || item === void 0 ? void 0 : (ref8 = item.prices) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.salePrice),
                    item_variant: ((ref11 = (ref10 = item === null || item === void 0 ? void 0 : item.productFamilies[0]) === null || ref10 === void 0 ? void 0 : ref10.families[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.color) === null || ref12 === void 0 ? void 0 : ref12.name) || "no_variant",
                    coupon: ((ref13 = item === null || item === void 0 ? void 0 : item.coupons[0]) === null || ref13 === void 0 ? void 0 : ref13.couponName) || "not_applied",
                    discount: item === null || item === void 0 ? void 0 : (ref14 = item.prices) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : ref15.discountPercentage
                }, 
            ],
            sendTo: gtagRaw.GA_TRACKING_ID
        });
    // henrique.melo precisamos ver se faz sentido unificar os dois eventos acima em um só, utilizando as mesmas propriedades
    },
    beginCheckout: function beginCheckout(value, items, clientId) {
        var currency = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "BRL";
        // Precisamos entender melhor como enviar a tag de google ads sem que ela seja de conversão
        // Evento do AW
        // event({
        //   action: "conversion",
        //   value,
        //   currency,
        //   sendTo: `${gtagRaw.AW_ID}${beginCheckoutGoogleAdsLabel}`,
        // });
        // Evento do GA
        gtag_event({
            currency: currency,
            action: "begin_checkout",
            category: "ecommerce",
            label: "Iniciar fechamento de pedido",
            value: value,
            clientId: clientId,
            items: items === null || items === void 0 ? void 0 : items.map(function(item) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
                return {
                    item_id: item === null || item === void 0 ? void 0 : item.id,
                    item_name: item === null || item === void 0 ? void 0 : item.description,
                    item_brand: item === null || item === void 0 ? void 0 : item.brand,
                    item_category: item === null || item === void 0 ? void 0 : (ref = item.breadCrumbs) === null || ref === void 0 ? void 0 : (ref1 = ref.category) === null || ref1 === void 0 ? void 0 : ref1.name,
                    item_category2: item === null || item === void 0 ? void 0 : (ref2 = item.breadCrumbs) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fatherCategory) === null || ref3 === void 0 ? void 0 : ref3.name,
                    item_category3: item === null || item === void 0 ? void 0 : (ref4 = item.breadCrumbs) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.grandFatherCategory) === null || ref5 === void 0 ? void 0 : ref5.name,
                    price: (item === null || item === void 0 ? void 0 : (ref6 = item.prices) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.spotPrice) || (item === null || item === void 0 ? void 0 : (ref8 = item.prices) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.salePrice),
                    discount: (item === null || item === void 0 ? void 0 : (ref10 = item.prices) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.discountPercentage) || "string",
                    coupon: (item === null || item === void 0 ? void 0 : (ref12 = item.coupons) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.couponName) || "not_applied"
                };
            }),
            sendTo: gtagRaw.GA_TRACKING_ID
        });
    // henrique.melo precisamos ver se faz sentido unificar os dois eventos acima em um só, utilizando as mesmas propriedades
    },
    viewCart: function viewCart(value, items, clientId) {
        var currency = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "BRL";
        var customViewCartEvent = {
            currency: currency,
            action: "view_cart",
            category: "ecommerce",
            label: "Visualizar carrinho",
            value: value,
            clientId: clientId,
            items: items === null || items === void 0 ? void 0 : items.map(function(item) {
                return {
                    item_id: item === null || item === void 0 ? void 0 : item.productId,
                    item_variant: item === null || item === void 0 ? void 0 : item.package,
                    quantity: item === null || item === void 0 ? void 0 : item.quantity
                };
            }),
            sendTo: gtagRaw.GA_TRACKING_ID
        };
        gtag_event(customViewCartEvent);
    },
    login: function login(method, clientId) {
        gtag_event({
            action: "login",
            category: "ecommerce",
            label: "Realizar login",
            method: method,
            clientId: clientId,
            sendTo: gtagRaw.GA_TRACKING_ID
        });
    },
    viewItem: function viewItem(value, item) {
        var currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "BRL";
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
        var discountValue = (0,application/* calculateDiscountPercentage */.vs9)(item === null || item === void 0 ? void 0 : (ref = item.prices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.discountPercentage);
        var customViewItemEvent = {
            currency: currency,
            action: "view_item",
            category: "ecommerce",
            label: "Acessar tela do produto",
            value: value,
            items: [
                {
                    item_id: item === null || item === void 0 ? void 0 : item.id,
                    quantity: item === null || item === void 0 ? void 0 : item.quantity,
                    item_name: item === null || item === void 0 ? void 0 : item.description,
                    item_brand: item === null || item === void 0 ? void 0 : item.brand,
                    item_category: item === null || item === void 0 ? void 0 : (ref2 = item.breadCrumbs) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.category) === null || ref3 === void 0 ? void 0 : ref3.name,
                    item_category2: item === null || item === void 0 ? void 0 : (ref4 = item.breadCrumbs) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fatherCategory) === null || ref5 === void 0 ? void 0 : ref5.name,
                    item_category3: item === null || item === void 0 ? void 0 : (ref6 = item.breadCrumbs) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.grandFatherCategory) === null || ref7 === void 0 ? void 0 : ref7.name,
                    price: (item === null || item === void 0 ? void 0 : (ref8 = item.prices) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.spotPrice) || (item === null || item === void 0 ? void 0 : (ref10 = item.prices) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.salePrice),
                    coupon: ((ref12 = item === null || item === void 0 ? void 0 : item.coupons[0]) === null || ref12 === void 0 ? void 0 : ref12.couponName) || "not_applied",
                    item_variant: ((ref14 = (ref13 = item === null || item === void 0 ? void 0 : item.productFamilies[0]) === null || ref13 === void 0 ? void 0 : ref13.families[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.color) === null || ref15 === void 0 ? void 0 : ref15.name) || "no_variant",
                    index: 0
                }, 
            ],
            discount: discountValue,
            sendTo: gtagRaw.GA_TRACKING_ID
        };
        gtag_event(customViewItemEvent);
    },
    viewItemList: function viewItemList(itemListName, itemListId, items) {
        gtag_event({
            action: "view_item_list",
            category: "ecommerce",
            label: "Acessar lista de produtos",
            itemListName: itemListName,
            itemListId: itemListId,
            items: items === null || items === void 0 ? void 0 : items.map(function(item) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
                return {
                    item_id: item === null || item === void 0 ? void 0 : item.id,
                    item_name: item === null || item === void 0 ? void 0 : item.description,
                    item_brand: item === null || item === void 0 ? void 0 : item.brand,
                    item_category: item === null || item === void 0 ? void 0 : (ref = item.breadCrumbs) === null || ref === void 0 ? void 0 : (ref1 = ref.category) === null || ref1 === void 0 ? void 0 : ref1.name,
                    item_category2: item === null || item === void 0 ? void 0 : (ref2 = item.breadCrumbs) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fatherCategory) === null || ref3 === void 0 ? void 0 : ref3.name,
                    item_category3: item === null || item === void 0 ? void 0 : (ref4 = item.breadCrumbs) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.grandFatherCategory) === null || ref5 === void 0 ? void 0 : ref5.name,
                    price: (item === null || item === void 0 ? void 0 : (ref6 = item.prices) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.spotPrice) || (item === null || item === void 0 ? void 0 : (ref8 = item.prices) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.salePrice),
                    discount: (item === null || item === void 0 ? void 0 : (ref10 = item.prices) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.discountPercentage) || "string",
                    coupon: (item === null || item === void 0 ? void 0 : (ref12 = item.coupons) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.couponName) || "not_applied",
                    index: item === null || item === void 0 ? void 0 : item.index
                };
            }),
            sendTo: gtagRaw.GA_TRACKING_ID
        });
    },
    signUp: function signUp(method) {
        gtag_event({
            action: "sign_up",
            category: "ecommerce",
            label: "Realizar cadastro da conta",
            method: method
        });
    },
    removeFromCart: function removeFromCart(args, value, clientId) {
        var customRemoveFromCartEvent = {
            action: "remove_from_cart",
            category: "ecommerce",
            label: "Remover do carrinho",
            clientId: clientId,
            value: value,
            items: [
                {
                    item_id: args.itemId,
                    quantity: args.quantity,
                    item_name: args.itemName,
                    item_brand: args.itemBrand,
                    item_category: args.itemCategory,
                    item_variant: args.itemVariant,
                    price: args.price
                }, 
            ],
            sendTo: [
                gtagRaw.GA_TRACKING_ID
            ]
        };
        gtag_event(customRemoveFromCartEvent);
    },
    search: function search(searchTerm) {
        gtag_event({
            action: "search",
            category: "ecommerce",
            label: "Realizar busca",
            searchTerm: searchTerm
        });
    },
    viewProductShipping: function viewProductShipping(productId, productName, zipCode, fcShippingOptions) {
        gtag_event({
            action: "view_product_shipping",
            label: "Consultar Frete",
            productId: productId,
            productName: productName,
            zipCode: zipCode,
            fcShippingOptions: fcShippingOptions
        });
    },
    selectItem: function(value, args, discount) {
        var currency = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "BRL";
        var customSelectItemEvent = {
            action: "select_item",
            category: "ecommerce",
            label: "Selecionar produto",
            currency: currency,
            value: value,
            items: [
                {
                    item_id: args.itemId,
                    item_name: args.itemName,
                    price: args.price,
                    item_list_id: args.itemListId,
                    item_list_name: args.itemListName,
                    index: args.index
                }, 
            ],
            discount: discount,
            sendTo: gtagRaw.GA_TRACKING_ID
        };
        gtag_event(customSelectItemEvent);
    },
    purchase: function purchase(value, shipping, transactionId, items, quantity, clientId) {
        var currency = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "BRL";
        // Evento do AW
        gtag_event({
            action: "conversion",
            value: value,
            currency: currency,
            transactionId: transactionId,
            sendTo: "".concat(gtagRaw.AW_ID).concat(gtagRaw.AW_PURCHASE_LABEL)
        });
        // Evento do GA
        var customPurchaseEvent = {
            currency: currency,
            action: "purchase",
            category: "ecommerce",
            label: "Fechar pedido",
            value: value,
            shipping: shipping,
            clientId: clientId,
            items: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
                return {
                    item_id: item === null || item === void 0 ? void 0 : item.id,
                    item_name: item === null || item === void 0 ? void 0 : item.description,
                    item_brand: item === null || item === void 0 ? void 0 : item.brand,
                    item_category: item === null || item === void 0 ? void 0 : (ref = item.breadCrumbs) === null || ref === void 0 ? void 0 : (ref1 = ref.category) === null || ref1 === void 0 ? void 0 : ref1.name,
                    item_category2: item === null || item === void 0 ? void 0 : (ref2 = item.breadCrumbs) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fatherCategory) === null || ref3 === void 0 ? void 0 : ref3.name,
                    item_category3: item === null || item === void 0 ? void 0 : (ref4 = item.breadCrumbs) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.grandFatherCategory) === null || ref5 === void 0 ? void 0 : ref5.name,
                    item_variant: item === null || item === void 0 ? void 0 : item.itemVariant,
                    price: (item === null || item === void 0 ? void 0 : (ref6 = item.prices) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.spotPrice) || (item === null || item === void 0 ? void 0 : (ref8 = item.prices) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.salePrice),
                    discount: (0,application/* calculateDiscountPercentage */.vs9)(item === null || item === void 0 ? void 0 : (ref10 = item.prices) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.discountPercentage) || "no_discount",
                    coupon: (item === null || item === void 0 ? void 0 : (ref12 = item.coupons) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.couponName) || "not_applied",
                    index: index,
                    quantity: item === null || item === void 0 ? void 0 : item.quantity
                };
            }),
            transactionId: transactionId,
            quantity: quantity
        };
        gtag_event(customPurchaseEvent);
    },
    addShippingInfo: function addShippingInfo(items, shippingTier, value, zipCode, clientId) {
        // Evento do GA
        var customEvent = {
            action: "add_shipping_info",
            category: "ecommerce",
            label: "Adicionar informa\xe7\xe3o de entrega",
            items: items === null || items === void 0 ? void 0 : items.map(function(param) {
                var id = param.id;
                return {
                    item_id: id
                };
            }),
            shippingTier: shippingTier,
            value: value,
            zipCode: zipCode,
            clientId: clientId
        };
        gtag_event(customEvent);
    },
    selectPromotion: function(args) {
        // Evento do GA
        gtag_event({
            action: "select_promotion",
            category: "ecommerce",
            label: "Selecionar banner, carrousel ou grid de imagens",
            items: [
                {
                    location_id: args.locationId,
                    promotion_id: args.promotionId,
                    promotion_name: args.promotionName,
                    creative_name: args.creativeName,
                    creative_slot: args.creativeSlot
                }, 
            ]
        });
    },
    addPaymentInfo: function(items, paymentType, value, clientId) {
        // Evento do GA
        gtag_event({
            action: "purchase",
            category: "ecommerce",
            label: "Adicionar informa\xe7\xe3o de pagamento",
            items: items === null || items === void 0 ? void 0 : items.map(function(param) {
                var id = param.id;
                return {
                    item_id: id
                };
            }),
            paymentType: paymentType,
            value: value,
            clientId: clientId
        });
    }
};


// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ../../node_modules/react-google-recaptcha/lib/esm/recaptcha.js
var _excluded = ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl", "isolated"];
function recaptcha_extends() { recaptcha_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return recaptcha_extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


var recaptcha_ReCAPTCHA = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);
  function ReCAPTCHA() {
    var _this;
    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = ReCAPTCHA.prototype;
  _proto.getCaptchaFunction = function getCaptchaFunction(fnName) {
    if (this.props.grecaptcha) {
      if (this.props.grecaptcha.enterprise) {
        return this.props.grecaptcha.enterprise[fnName];
      }
      return this.props.grecaptcha[fnName];
    }
    return null;
  };
  _proto.getValue = function getValue() {
    var getResponse = this.getCaptchaFunction("getResponse");
    if (getResponse && this._widgetId !== undefined) {
      return getResponse(this._widgetId);
    }
    return null;
  };
  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }
    return null;
  };
  _proto.execute = function execute() {
    var execute = this.getCaptchaFunction("execute");
    if (execute && this._widgetId !== undefined) {
      return execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };
  _proto.executeAsync = function executeAsync() {
    var _this2 = this;
    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;
      _this2.execute();
    });
  };
  _proto.reset = function reset() {
    var resetter = this.getCaptchaFunction("reset");
    if (resetter && this._widgetId !== undefined) {
      resetter(this._widgetId);
    }
  };
  _proto.forceReset = function forceReset() {
    var resetter = this.getCaptchaFunction("reset");
    if (resetter) {
      resetter();
    }
  };
  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };
  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }
    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };
  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }
    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };
  _proto.explicitRender = function explicitRender() {
    var render = this.getCaptchaFunction("render");
    if (render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge,
        isolated: this.props.isolated
      });
      this.captcha.appendChild(wrapper);
    }
    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };
  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };
  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
      sitekey = _this$props.sitekey,
      onChange = _this$props.onChange,
      theme = _this$props.theme,
      type = _this$props.type,
      tabindex = _this$props.tabindex,
      onExpired = _this$props.onExpired,
      onErrored = _this$props.onErrored,
      size = _this$props.size,
      stoken = _this$props.stoken,
      grecaptcha = _this$props.grecaptcha,
      badge = _this$props.badge,
      hl = _this$props.hl,
      isolated = _this$props.isolated,
      childProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    /* eslint-enable no-unused-vars */
    return /*#__PURE__*/react.createElement("div", recaptcha_extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };
  return ReCAPTCHA;
}(react.Component);

recaptcha_ReCAPTCHA.displayName = "ReCAPTCHA";
recaptcha_ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"]),
  isolated: (prop_types_default()).bool
};
recaptcha_ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";
function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}
function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  if (dynamicOptions.enterprise) {
    return "https://" + hostname + "/recaptcha/enterprise.js?onload=" + callbackName + "&render=explicit";
  }
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}
/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName,
  attributes: getOptions().nonce ? {
    nonce: getOptions().nonce
  } : {}
})(recaptcha_ReCAPTCHA));
;// CONCATENATED MODULE: ../../node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = ((/* unused pure expression or super */ null && (RecaptchaWrapper)));

;// CONCATENATED MODULE: ../../packages/infra/integrations/recaptcha/index.tsx








var Recaptcha = function(_param) {
    var rest = _extends({}, _param);
    var ref = useRecaptcha(), handleCheckIfTheCustomerIsNotARobotSignUp = ref.handleCheckIfTheCustomerIsNotARobotSignUp, handleCheckIfTheCustomerIsNotARobotSignIn = ref.handleCheckIfTheCustomerIsNotARobotSignIn;
    var ref1 = useState(null), siteKey = ref1[0], setSiteKey = ref1[1];
    var allConfigs = useEnvs(function(state) {
        return state.allConfigs;
    });
    useEffect(function() {
        var handleSetGoogleRecaptchaKey = function() {
            var _ref = _async_to_generator(function(googleRecaptchaKey) {
                return _ts_generator(this, function(_state) {
                    setSiteKey(googleRecaptchaKey);
                    return [
                        2
                    ];
                });
            });
            return function handleSetGoogleRecaptchaKey(googleRecaptchaKey) {
                return _ref.apply(this, arguments);
            };
        }();
        if (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.googleRecaptchaKey) {
            handleSetGoogleRecaptchaKey(allConfigs.googleRecaptchaKey);
        }
    }, [
        allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.googleRecaptchaKey
    ]);
    if (!siteKey) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ReCAPTCHA, _object_spread({
        sitekey: siteKey,
        onChange: function(token) {
            if (!token) {
                handleCheckIfTheCustomerIsNotARobotSignUp(true);
                handleCheckIfTheCustomerIsNotARobotSignIn(true);
            }
            if (token) {
                handleCheckIfTheCustomerIsNotARobotSignUp(false);
                handleCheckIfTheCustomerIsNotARobotSignIn(false);
            }
        }
    }, rest));
};


;// CONCATENATED MODULE: ../../packages/infra/integrations/allow-me/index.tsx







var AllowMeFingerprint = {
    collect: function collect(action) {
        return (0,src_async_to_generator/* default */.Z)(function() {
            var fingerprint, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(typeof Alwm !== "undefined")) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            Alwm.collect(action)
                        ];
                    case 2:
                        fingerprint = _state.sent();
                        return [
                            2,
                            fingerprint
                        ];
                    case 3:
                        e = _state.sent();
                        return [
                            2,
                            null
                        ];
                    case 4:
                        return [
                            2,
                            null
                        ];
                }
            });
        })();
    },
    Script: function Script1() {
        var ref = (0,react.useState)(""), apiKey = ref[0], setApiKey = ref[1];
        var ref1 = (0,react.useState)(""), url = ref1[0], setUrl = ref1[1];
        var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
            return state.allConfigs;
        });
        (0,react.useEffect)(function() {
            var setAllowMeConfigs = function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(allowMeApiKey, allowMeUrl) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        setApiKey((0,application/* obfuscate */.H6d)(allowMeApiKey));
                        setUrl(allowMeUrl);
                        return [
                            2
                        ];
                    });
                });
                return function setAllowMeConfigs(allowMeApiKey, allowMeUrl) {
                    return _ref.apply(this, arguments);
                };
            }();
            if ((allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isAllowMeAvailable) === "true" && (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.allowMeApiKey) && (allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.allowMeUrl)) {
                setAllowMeConfigs(allConfigs.allowMeApiKey, allConfigs.allowMeUrl);
            }
        }, [
            allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.allowMeApiKey,
            allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.allowMeUrl,
            allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isAllowMeAvailable, 
        ]);
        if ((allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.isAllowMeAvailable) !== "true" || !apiKey || !url) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "allow-me-fingerprint-script-init",
                    strategy: "afterInteractive",
                    children: " window.alwmAsyncInit=()=>{Alwm.init({apiKey:'".concat(apiKey, "',});}; ")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), (0,src_object_spread/* default */.Z)({
                    async: true,
                    defer: true,
                    src: url,
                    type: "text/javascript",
                    id: "allow-me-fingerprint-script",
                    strategy: "afterInteractive"
                }, (0,application/* buildTestIds */.Fek)("allow-me-fingerprint-script")))
            ]
        });
    }
};


// EXTERNAL MODULE: ../../packages/application/state-manager/index.ts + 20 modules
var state_manager = __webpack_require__(74224);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ../../packages/infra/integrations/genesys/index.tsx





var GenesysChatBot = {
    Script: function(param) {
        var jwtDecoder = param.jwtDecoder, purchaseApi = param.purchaseApi;
        var router = (0,next_router.useRouter)();
        var ref = (0,state_manager/* useChatbot */.dp)((0,state_manager/* useShallow */.NL)(function(state) {
            return {
                showChatbot: state.showChatbot,
                showSaleChatbot: state.showSaleChatbot
            };
        })), showChatbot = ref.showChatbot, showSaleChatbot = ref.showSaleChatbot;
        var token = (0,lib.getCookie)("@FC:Ecom:Token:Access");
        var data = purchaseApi.getChatEligibleForClient(token, !!token).data;
        var ref1 = (0,react.useState)(false), isClientMobileL = ref1[0], setIsClientMobileL = ref1[1];
        (0,react.useEffect)(function() {
            var mediaQuery = window.matchMedia("(max-width: 425px)");
            setIsClientMobileL(mediaQuery.matches);
            var handleResize = function() {
                setIsClientMobileL(mediaQuery.matches);
            };
            mediaQuery.addListener(handleResize);
            return function() {
                return mediaQuery.removeListener(handleResize);
            };
        }, []);
        (0,react.useEffect)(function() {
            var genesysButton = document.getElementById("genesys-messenger");
            var isChatbotAvailable = (data === null || data === void 0 ? void 0 : data.championClient) && (data === null || data === void 0 ? void 0 : data.clientHasOpenedPurchases);
            var showSaleChat = showSaleChatbot && !isChatbotAvailable && Boolean(token);
            if ((router.pathname.includes("/produto") || router.pathname.includes("/checkout")) && isClientMobileL && !showSaleChat) {
                genesysButton === null || genesysButton === void 0 ? void 0 : genesysButton.style.setProperty("display", "none");
                var script = document.getElementById("genesys");
                script === null || script === void 0 ? void 0 : script.remove();
                return;
            }
            var showChampionClientChat = isChatbotAvailable && showChatbot;
            if (showChampionClientChat || showSaleChat) {
                var genesysScript = document.getElementById("genesys");
                if (genesysScript) return;
                var genesysUrl = (0,application/* obfuscate */.H6d)("https://apps.sae1.pure.cloud/genesys-bootstrap/genesys.min.js");
                var genesysChampionClientId = (0,application/* obfuscate */.H6d)("3fab9f2e-ed7a-4a54-bafd-e346eed40380");
                var genesysSaleId = (0,application/* obfuscate */.H6d)("e38de0e3-d979-4adb-8d1c-d92e165e24a0");
                var deploymentId = showChampionClientChat ? genesysChampionClientId : genesysSaleId;
                var userData = jwtDecoder === null || jwtDecoder === void 0 ? void 0 : jwtDecoder.decode(token);
                var script1 = document.createElement("script");
                script1.type = "text/javascript";
                script1.id = "genesys";
                script1.setAttribute("data-testid", "genesys-script");
                script1.setAttribute("data-cy", "genesys-script");
                script1.innerHTML = "(function (g, e, n, es, ys) {\n          g['_genesysJs'] = e;\n          g[e] = g[e] || function () {\n              (g[e].q = g[e].q || []).push(arguments)\n            };\n            g[e].t = 1 * new Date();\n            g[e].c = es;\n            ys = document.createElement('script'); ys.async = 1; ys.src = n; ys.charset = 'utf-8'; document.head.appendChild(ys);\n          })(window, 'Genesys', '".concat(genesysUrl, "', {\n            environment: 'prod-sae1',\n            deploymentId: '").concat(deploymentId, '\'\n          });\n          \n          Genesys("command", "Database.set", {\n            messaging: {\n              customAttributes: {\n                "cgc_cpf": \'').concat(userData === null || userData === void 0 ? void 0 : userData.cpf, "',\n                \"email\":  '").concat(userData === null || userData === void 0 ? void 0 : userData.email, "',\n              }\n            }\n          });");
                document.head.appendChild(script1);
                genesysButton === null || genesysButton === void 0 ? void 0 : genesysButton.style.setProperty("display", "block");
                return;
            }
            genesysButton === null || genesysButton === void 0 ? void 0 : genesysButton.style.setProperty("display", "none");
            var script2 = document.getElementById("genesys");
            script2 === null || script2 === void 0 ? void 0 : script2.remove();
        }, [
            showChatbot,
            token,
            jwtDecoder,
            data === null || data === void 0 ? void 0 : data.championClient,
            data === null || data === void 0 ? void 0 : data.clientHasOpenedPurchases,
            router.pathname,
            showSaleChatbot,
            isClientMobileL,
            data, 
        ]);
        return null;
    }
};


;// CONCATENATED MODULE: ../../packages/infra/integrations/clarity/index.tsx



var isClarityDefined = function() {
    return !!(window === null || window === void 0 ? void 0 : window.clarity);
};
var clarityRaw = {
    Id: function Id() {
        var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
            return state.allConfigs;
        });
        var ref;
        return (ref = allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.clarityId) !== null && ref !== void 0 ? ref : "";
    },
    cookieConsent: function cookieConsent() {
        if (isClarityDefined()) {
            window === null || window === void 0 ? void 0 : window.clarity("consent");
        }
    },
    customIdentifiers: function customIdentifiers(customId, customSessionId, customPageId, friendlyName) {
        if (isClarityDefined()) {
            window === null || window === void 0 ? void 0 : window.clarity("identify", customId, customSessionId, customPageId, friendlyName);
        }
    },
    customTags: function customTags(key, value) {
        if (isClarityDefined()) {
            window === null || window === void 0 ? void 0 : window.clarity("set", key, value);
        }
    },
    upgradeSession: function upgradeSession(upgradeReason) {
        if (isClarityDefined()) {
            window === null || window === void 0 ? void 0 : window.clarity("upgrade", upgradeReason);
        }
    },
    resetCustomIdentifiers: function resetCustomIdentifiers() {
        if (isClarityDefined()) {
            window === null || window === void 0 ? void 0 : window.clarity("identify", "", "");
        }
    },
    Script: function Script1() {
        var allConfigs = (0,application/* useEnvs */.HSW)(function(state) {
            return state.allConfigs;
        });
        if (![
            "production",
            "qas"
        ].includes(String(allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.hostEnv))) {
            return null;
        }
        var clarityId = (0,application/* obfuscate */.H6d)(allConfigs === null || allConfigs === void 0 ? void 0 : allConfigs.clarityId);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
            id: "clarity-script",
            strategy: "afterInteractive",
            children: '(function(c,l,a,r,i,t,y){ c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)}; t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i; y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y); })(window, document, "clarity", "script", "'.concat(clarityId, '");')
        });
    }
};


;// CONCATENATED MODULE: ../../packages/infra/integrations/index.ts








// EXTERNAL MODULE: ../../node_modules/request-ip/lib/index.js
var request_ip_lib = __webpack_require__(41527);
var request_ip_lib_default = /*#__PURE__*/__webpack_require__.n(request_ip_lib);
;// CONCATENATED MODULE: ../../packages/infra/misc/request-ip.ts


var RequestIp = function RequestIp(cookie) {
    "use strict";
    var _this = this;
    (0,_class_call_check/* default */.Z)(this, RequestIp);
    this.cookie = cookie;
    this.getClientIp = function() {
        return _this.cookie.getCookie({
            name: "@FC:Ecom:Client:Ip"
        });
    };
    this.storageClientIp = function(req, res) {
        var ip = request_ip_lib_default().getClientIp(req);
        if (ip) {
            _this.cookie.setCookie({
                name: "@FC:Ecom:Client:Ip",
                value: ip,
                options: {
                    req: req,
                    res: res
                }
            });
        }
    };
    this.cookie = cookie;
};


;// CONCATENATED MODULE: ../../packages/infra/misc/uuid.ts

var UUIDLib = {
    generateUUID: function() {
        return esm_browser_v4();
    }
};


;// CONCATENATED MODULE: ../../packages/infra/misc/index.ts



// EXTERNAL MODULE: ../../node_modules/credit-card-type/dist/index.js
var credit_card_type_dist = __webpack_require__(2291);
var dist_default = /*#__PURE__*/__webpack_require__.n(credit_card_type_dist);
;// CONCATENATED MODULE: ../../packages/infra/payment/creditCard/index.tsx

var getMappedCreditCardBrand = function(creditCardTypeCardBrandId) {
    switch(creditCardTypeCardBrandId){
        case "american-express":
            return "Amex";
        case "hipercard":
            return "Hipercard";
        case "diners-club":
            return "Diners";
        case "discover":
            return null;
        case "elo":
            return "Elo";
        case "hiper":
            return "Hiper";
        case "mastercard":
            return "Mastercard";
        case "jcb":
            return "Jcb";
        case "visa":
            return "Visa";
        default:
            return null;
    }
};
var CreditCardTypeLib = {
    getBrand: function(creditCardNumber) {
        var ref;
        var formattedCreditCardNumber = creditCardNumber.trim().replace(/\s/g, "");
        // console.log("formattedCreditCardNumber: ", formattedCreditCardNumber);
        var creditCardInfo = dist_default()(formattedCreditCardNumber);
        return getMappedCreditCardBrand((ref = creditCardInfo[0]) === null || ref === void 0 ? void 0 : ref.type);
    }
};


;// CONCATENATED MODULE: ../../packages/infra/payment/index.tsx


;// CONCATENATED MODULE: ../../node_modules/immer/dist/immer.mjs
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");

// src/utils/errors.ts
var errors =  false ? 0 : [];
function die(error, ...args) {
  if (false) {}
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}

// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  if (!value)
    return false;
  return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!value.constructor?.[DRAFTABLE] || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
  if (!value || typeof value !== "object")
    return false;
  const proto = getPrototypeOf(value);
  if (proto === null) {
    return true;
  }
  const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  if (Ctor === Object)
    return true;
  return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
  if (!isDraft(value))
    die(15, value);
  return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
  if (getArchtype(obj) === 0 /* Object */) {
    Object.entries(obj).forEach(([key, value]) => {
      iter(key, value, obj);
    });
  } else {
    obj.forEach((entry, index) => iter(index, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */ : isMap(thing) ? 2 /* Map */ : isSet(thing) ? 3 /* Set */ : 0 /* Object */;
}
function has(thing, prop) {
  return getArchtype(thing) === 2 /* Map */ ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
  return getArchtype(thing) === 2 /* Map */ ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
  const t = getArchtype(thing);
  if (t === 2 /* Map */)
    thing.set(propOrOldValue, value);
  else if (t === 3 /* Set */) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
}
function is(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function isMap(target) {
  return target instanceof Map;
}
function isSet(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap(base)) {
    return new Map(base);
  }
  if (isSet(base)) {
    return new Set(base);
  }
  if (Array.isArray(base))
    return Array.prototype.slice.call(base);
  if (!strict && isPlainObject(base)) {
    if (!getPrototypeOf(base)) {
      const obj = /* @__PURE__ */ Object.create(null);
      return Object.assign(obj, base);
    }
    return { ...base };
  }
  const descriptors = Object.getOwnPropertyDescriptors(base);
  delete descriptors[DRAFT_STATE];
  let keys = Reflect.ownKeys(descriptors);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const desc = descriptors[key];
    if (desc.writable === false) {
      desc.writable = true;
      desc.configurable = true;
    }
    if (desc.get || desc.set)
      descriptors[key] = {
        configurable: true,
        writable: true,
        // could live with !!desc.set as well here...
        enumerable: desc.enumerable,
        value: base[key]
      };
  }
  return Object.create(getPrototypeOf(base), descriptors);
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
  }
  Object.freeze(obj);
  if (deep)
    each(obj, (_key, value) => freeze(value, true), true);
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(obj) {
  return Object.isFrozen(obj);
}

// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}
function loadPlugin(pluginKey, implementation) {
  if (!plugins[pluginKey])
    plugins[pluginKey] = implementation;
}

// src/core/scope.ts
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 /* Object */ || state.type_ === 1 /* Array */)
    state.revoke_();
  else
    state.revoked_ = true;
}

// src/core/finalize.ts
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== void 0 && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
      if (!scope.parent_)
        maybeFreeze(scope, result);
    }
    if (scope.patches_) {
      getPlugin("Patches").generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result,
        scope.patches_,
        scope.inversePatches_
      );
    }
  } else {
    result = finalize(scope, baseDraft, []);
  }
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    each(
      value,
      (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path),
      true
      // See #590, don't recurse into non-enumerable of non drafted objects
    );
    return value;
  }
  if (state.scope_ !== rootScope)
    return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result = state.copy_;
    let resultEach = result;
    let isSet2 = false;
    if (state.type_ === 3 /* Set */) {
      resultEach = new Set(result);
      result.clear();
      isSet2 = true;
    }
    each(
      resultEach,
      (key, childValue) => finalizeProperty(rootScope, state, result, key, childValue, path, isSet2)
    );
    maybeFreeze(rootScope, result, false);
    if (path && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(
        state,
        path,
        rootScope.patches_,
        rootScope.inversePatches_
      );
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (false)
    {}
  if (isDraft(childValue)) {
    const path = rootPath && parentState && parentState.type_ !== 3 /* Set */ && // Set objects are atomic since they have no keys.
    !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
    const res = finalize(rootScope, childValue, path);
    set(targetObject, prop, res);
    if (isDraft(res)) {
      rootScope.canAutoFreeze_ = false;
    } else
      return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !isFrozen(childValue)) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    finalize(rootScope, childValue);
    if (!parentState || !parentState.scope_.parent_)
      maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}

// src/core/proxy.ts
function createProxyProxy(base, parent) {
  const isArray = Array.isArray(base);
  const state = {
    type_: isArray ? 1 /* Array */ : 0 /* Object */,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is(value, current2) && (value !== void 0 || has(state.base_, prop)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 /* Array */ || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key, fn) => {
  arrayTraps[key] = function() {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  if (false)
    {}
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  if (false)
    {}
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? `value` in desc ? desc.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}

// src/core/immerClass.ts
var Immer2 = class {
  constructor(config) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function")
        die(6);
      if (patchListener !== void 0 && typeof patchListener !== "function")
        die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || typeof base !== "object") {
        result = recipe(base);
        if (result === void 0)
          result = base;
        if (result === NOTHING)
          result = void 0;
        if (this.autoFreeze_)
          freeze(result, true);
        if (patchListener) {
          const p = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
          patchListener(p, ip);
        }
        return result;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p, ip) => {
        patches = p;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (typeof config?.autoFreeze === "boolean")
      this.setAutoFreeze(config.autoFreeze);
    if (typeof config?.useStrictShallowCopy === "boolean")
      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (isDraft(base))
      base = current(base);
    const scope = enterScope(this);
    const proxy = createProxy(base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  applyPatches(base, patches) {
    let i;
    for (i = patches.length - 1; i >= 0; i--) {
      const patch = patches[i];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i > -1) {
      patches = patches.slice(i + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(value, parent) {
  const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent ? parent.scope_ : getCurrentScope();
  scope.drafts_.push(draft);
  return draft;
}

// src/core/current.ts
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
  } else {
    copy = shallowCopy(value, true);
  }
  each(copy, (key, childValue) => {
    set(copy, key, currentImpl(childValue));
  });
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}

// src/plugins/patches.ts
function enablePatches() {
  const errorOffset = 16;
  if (false) {}
  const REPLACE = "replace";
  const ADD = "add";
  const REMOVE = "remove";
  function generatePatches_(state, basePath, patches, inversePatches) {
    switch (state.type_) {
      case 0 /* Object */:
      case 2 /* Map */:
        return generatePatchesFromAssigned(
          state,
          basePath,
          patches,
          inversePatches
        );
      case 1 /* Array */:
        return generateArrayPatches(state, basePath, patches, inversePatches);
      case 3 /* Set */:
        return generateSetPatches(
          state,
          basePath,
          patches,
          inversePatches
        );
    }
  }
  function generateArrayPatches(state, basePath, patches, inversePatches) {
    let { base_, assigned_ } = state;
    let copy_ = state.copy_;
    if (copy_.length < base_.length) {
      ;
      [base_, copy_] = [copy_, base_];
      [patches, inversePatches] = [inversePatches, patches];
    }
    for (let i = 0; i < base_.length; i++) {
      if (assigned_[i] && copy_[i] !== base_[i]) {
        const path = basePath.concat([i]);
        patches.push({
          op: REPLACE,
          path,
          // Need to maybe clone it, as it can in fact be the original value
          // due to the base/copy inversion at the start of this function
          value: clonePatchValueIfNeeded(copy_[i])
        });
        inversePatches.push({
          op: REPLACE,
          path,
          value: clonePatchValueIfNeeded(base_[i])
        });
      }
    }
    for (let i = base_.length; i < copy_.length; i++) {
      const path = basePath.concat([i]);
      patches.push({
        op: ADD,
        path,
        // Need to maybe clone it, as it can in fact be the original value
        // due to the base/copy inversion at the start of this function
        value: clonePatchValueIfNeeded(copy_[i])
      });
    }
    for (let i = copy_.length - 1; base_.length <= i; --i) {
      const path = basePath.concat([i]);
      inversePatches.push({
        op: REMOVE,
        path
      });
    }
  }
  function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
    const { base_, copy_ } = state;
    each(state.assigned_, (key, assignedValue) => {
      const origValue = get(base_, key);
      const value = get(copy_, key);
      const op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
      if (origValue === value && op === REPLACE)
        return;
      const path = basePath.concat(key);
      patches.push(op === REMOVE ? { op, path } : { op, path, value });
      inversePatches.push(
        op === ADD ? { op: REMOVE, path } : op === REMOVE ? { op: ADD, path, value: clonePatchValueIfNeeded(origValue) } : { op: REPLACE, path, value: clonePatchValueIfNeeded(origValue) }
      );
    });
  }
  function generateSetPatches(state, basePath, patches, inversePatches) {
    let { base_, copy_ } = state;
    let i = 0;
    base_.forEach((value) => {
      if (!copy_.has(value)) {
        const path = basePath.concat([i]);
        patches.push({
          op: REMOVE,
          path,
          value
        });
        inversePatches.unshift({
          op: ADD,
          path,
          value
        });
      }
      i++;
    });
    i = 0;
    copy_.forEach((value) => {
      if (!base_.has(value)) {
        const path = basePath.concat([i]);
        patches.push({
          op: ADD,
          path,
          value
        });
        inversePatches.unshift({
          op: REMOVE,
          path,
          value
        });
      }
      i++;
    });
  }
  function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
    patches.push({
      op: REPLACE,
      path: [],
      value: replacement === NOTHING ? void 0 : replacement
    });
    inversePatches.push({
      op: REPLACE,
      path: [],
      value: baseValue
    });
  }
  function applyPatches_(draft, patches) {
    patches.forEach((patch) => {
      const { path, op } = patch;
      let base = draft;
      for (let i = 0; i < path.length - 1; i++) {
        const parentType = getArchtype(base);
        let p = path[i];
        if (typeof p !== "string" && typeof p !== "number") {
          p = "" + p;
        }
        if ((parentType === 0 /* Object */ || parentType === 1 /* Array */) && (p === "__proto__" || p === "constructor"))
          die(errorOffset + 3);
        if (typeof base === "function" && p === "prototype")
          die(errorOffset + 3);
        base = get(base, p);
        if (typeof base !== "object")
          die(errorOffset + 2, path.join("/"));
      }
      const type = getArchtype(base);
      const value = deepClonePatchValue(patch.value);
      const key = path[path.length - 1];
      switch (op) {
        case REPLACE:
          switch (type) {
            case 2 /* Map */:
              return base.set(key, value);
            case 3 /* Set */:
              die(errorOffset);
            default:
              return base[key] = value;
          }
        case ADD:
          switch (type) {
            case 1 /* Array */:
              return key === "-" ? base.push(value) : base.splice(key, 0, value);
            case 2 /* Map */:
              return base.set(key, value);
            case 3 /* Set */:
              return base.add(value);
            default:
              return base[key] = value;
          }
        case REMOVE:
          switch (type) {
            case 1 /* Array */:
              return base.splice(key, 1);
            case 2 /* Map */:
              return base.delete(key);
            case 3 /* Set */:
              return base.delete(patch.value);
            default:
              return delete base[key];
          }
        default:
          die(errorOffset + 1, op);
      }
    });
    return draft;
  }
  function deepClonePatchValue(obj) {
    if (!isDraftable(obj))
      return obj;
    if (Array.isArray(obj))
      return obj.map(deepClonePatchValue);
    if (isMap(obj))
      return new Map(
        Array.from(obj.entries()).map(([k, v]) => [k, deepClonePatchValue(v)])
      );
    if (isSet(obj))
      return new Set(Array.from(obj).map(deepClonePatchValue));
    const cloned = Object.create(getPrototypeOf(obj));
    for (const key in obj)
      cloned[key] = deepClonePatchValue(obj[key]);
    if (has(obj, DRAFTABLE))
      cloned[DRAFTABLE] = obj[DRAFTABLE];
    return cloned;
  }
  function clonePatchValueIfNeeded(obj) {
    if (isDraft(obj)) {
      return deepClonePatchValue(obj);
    } else
      return obj;
  }
  loadPlugin("Patches", {
    applyPatches_,
    generatePatches_,
    generateReplacementPatches_
  });
}

// src/plugins/mapset.ts
function enableMapSet() {
  class DraftMap extends Map {
    constructor(target, parent) {
      super();
      this[DRAFT_STATE] = {
        type_: 2 /* Map */,
        parent_: parent,
        scope_: parent ? parent.scope_ : getCurrentScope(),
        modified_: false,
        finalized_: false,
        copy_: void 0,
        assigned_: void 0,
        base_: target,
        draft_: this,
        isManual_: false,
        revoked_: false
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(key) {
      return latest(this[DRAFT_STATE]).has(key);
    }
    set(key, value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!latest(state).has(key) || latest(state).get(key) !== value) {
        prepareMapCopy(state);
        markChanged(state);
        state.assigned_.set(key, true);
        state.copy_.set(key, value);
        state.assigned_.set(key, true);
      }
      return this;
    }
    delete(key) {
      if (!this.has(key)) {
        return false;
      }
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareMapCopy(state);
      markChanged(state);
      if (state.base_.has(key)) {
        state.assigned_.set(key, false);
      } else {
        state.assigned_.delete(key);
      }
      state.copy_.delete(key);
      return true;
    }
    clear() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (latest(state).size) {
        prepareMapCopy(state);
        markChanged(state);
        state.assigned_ = /* @__PURE__ */ new Map();
        each(state.base_, (key) => {
          state.assigned_.set(key, false);
        });
        state.copy_.clear();
      }
    }
    forEach(cb, thisArg) {
      const state = this[DRAFT_STATE];
      latest(state).forEach((_value, key, _map) => {
        cb.call(thisArg, this.get(key), key, this);
      });
    }
    get(key) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      const value = latest(state).get(key);
      if (state.finalized_ || !isDraftable(value)) {
        return value;
      }
      if (value !== state.base_.get(key)) {
        return value;
      }
      const draft = createProxy(value, state);
      prepareMapCopy(state);
      state.copy_.set(key, draft);
      return draft;
    }
    keys() {
      return latest(this[DRAFT_STATE]).keys();
    }
    values() {
      const iterator = this.keys();
      return {
        [Symbol.iterator]: () => this.values(),
        next: () => {
          const r = iterator.next();
          if (r.done)
            return r;
          const value = this.get(r.value);
          return {
            done: false,
            value
          };
        }
      };
    }
    entries() {
      const iterator = this.keys();
      return {
        [Symbol.iterator]: () => this.entries(),
        next: () => {
          const r = iterator.next();
          if (r.done)
            return r;
          const value = this.get(r.value);
          return {
            done: false,
            value: [r.value, value]
          };
        }
      };
    }
    [(DRAFT_STATE, Symbol.iterator)]() {
      return this.entries();
    }
  }
  function proxyMap_(target, parent) {
    return new DraftMap(target, parent);
  }
  function prepareMapCopy(state) {
    if (!state.copy_) {
      state.assigned_ = /* @__PURE__ */ new Map();
      state.copy_ = new Map(state.base_);
    }
  }
  class DraftSet extends Set {
    constructor(target, parent) {
      super();
      this[DRAFT_STATE] = {
        type_: 3 /* Set */,
        parent_: parent,
        scope_: parent ? parent.scope_ : getCurrentScope(),
        modified_: false,
        finalized_: false,
        copy_: void 0,
        base_: target,
        draft_: this,
        drafts_: /* @__PURE__ */ new Map(),
        revoked_: false,
        isManual_: false
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!state.copy_) {
        return state.base_.has(value);
      }
      if (state.copy_.has(value))
        return true;
      if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value)))
        return true;
      return false;
    }
    add(value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!this.has(value)) {
        prepareSetCopy(state);
        markChanged(state);
        state.copy_.add(value);
      }
      return this;
    }
    delete(value) {
      if (!this.has(value)) {
        return false;
      }
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      markChanged(state);
      return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : (
        /* istanbul ignore next */
        false
      ));
    }
    clear() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (latest(state).size) {
        prepareSetCopy(state);
        markChanged(state);
        state.copy_.clear();
      }
    }
    values() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      return state.copy_.values();
    }
    entries() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      return state.copy_.entries();
    }
    keys() {
      return this.values();
    }
    [(DRAFT_STATE, Symbol.iterator)]() {
      return this.values();
    }
    forEach(cb, thisArg) {
      const iterator = this.values();
      let result = iterator.next();
      while (!result.done) {
        cb.call(thisArg, result.value, result.value, this);
        result = iterator.next();
      }
    }
  }
  function proxySet_(target, parent) {
    return new DraftSet(target, parent);
  }
  function prepareSetCopy(state) {
    if (!state.copy_) {
      state.copy_ = /* @__PURE__ */ new Set();
      state.base_.forEach((value) => {
        if (isDraftable(value)) {
          const draft = createProxy(value, state);
          state.drafts_.set(value, draft);
          state.copy_.add(draft);
        } else {
          state.copy_.add(value);
        }
      });
    }
  }
  function assertUnrevoked(state) {
    if (state.revoked_)
      die(3, JSON.stringify(latest(state)));
  }
  loadPlugin("MapSet", { proxyMap_, proxySet_ });
}

// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(
  immer
);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
  return value;
}
function castImmutable(value) {
  return value;
}

//# sourceMappingURL=immer.mjs.map
;// CONCATENATED MODULE: ../../packages/infra/state-manager/immer/index.ts

var ImmerImpl = {
    produceNewState: produce
};


// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var zustand_esm = __webpack_require__(40624);
;// CONCATENATED MODULE: ../../packages/infra/state-manager/zustand/index.ts

var ZustandImpl = {
    createStore: zustand_esm/* create */.Ue
};


;// CONCATENATED MODULE: ../../packages/infra/state-manager/index.ts



;// CONCATENATED MODULE: ../../packages/infra/websocket/index.ts




// declare const WebSocket: {
//   prototype: WebSocket;
//   new (
//     uri: string,
//     protocols?: string | string[] | null,
//     options?: {
//       headers: { [headerName: string]: string };
//       [optionName: string]: any;
//     } | null
//   ): WebSocket;
//   readonly CLOSED: number;
//   readonly CLOSING: number;
//   readonly CONNECTING: number;
//   readonly OPEN: number;
// };
var WebSocketRaw = /*#__PURE__*/ function() {
    "use strict";
    function WebSocketRaw(envsApi) {
        (0,_class_call_check/* default */.Z)(this, WebSocketRaw);
        this.envsApi = envsApi;
        this.socket = null;
        this.isCreatingSocketInstance = false;
        this.userEmail = null;
        this.envsApi = envsApi;
    }
    var _proto = WebSocketRaw.prototype;
    _proto.getUserEmail = function getUserEmail() {
        return this.userEmail;
    };
    _proto.createSocketInstance = function createSocketInstance(userEmail, accessToken) {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(function() {
            var ref, allConfigs, websocketUrl, url, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!((ref = _this.socket) === null || ref === void 0 ? void 0 : ref.OPEN) && !_this.isCreatingSocketInstance)) return [
                            3,
                            4
                        ];
                        _this.isCreatingSocketInstance = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _this.envsApi.getAwaitAllConfigs()
                        ];
                    case 2:
                        allConfigs = _state.sent();
                        websocketUrl = (allConfigs || {
                            websocketUrl: ""
                        }).websocketUrl;
                        url = new URL("".concat(websocketUrl, "?email=").concat(userEmail, "&connectionSource=site&Authorizer=").concat(accessToken));
                        _this.socket = new WebSocket(url);
                        _this.userEmail = userEmail;
                        _this.isCreatingSocketInstance = false;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        _this.isCreatingSocketInstance = false;
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.destroySocketInstance = function destroySocketInstance() {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
    };
    _proto.emitEvent = function emitEvent(eventAction, metadata) {
        if (this.socket) {
            var eventData = (0,src_object_spread/* default */.Z)({
                action: "sendMessage",
                email: this.userEmail,
                event: eventAction
            }, metadata && {
                metadata: metadata
            });
            this.socket.send(JSON.stringify(eventData));
        }
    };
    _proto.onReceiveMessage = function onReceiveMessage(eventAction, callback) {
        if (this.socket) {
            this.socket.addEventListener(eventAction, callback);
        }
    };
    return WebSocketRaw;
}();


;// CONCATENATED MODULE: ../../packages/infra/webStorage/sessionStorage/index.ts
/* eslint-disable class-methods-use-this */ 
var SecuredSessionStorage = /*#__PURE__*/ function() {
    "use strict";
    function SecuredSessionStorage(encryptAgent) {
        (0,_class_call_check/* default */.Z)(this, SecuredSessionStorage);
        this.encryptAgent = encryptAgent;
    }
    var _proto = SecuredSessionStorage.prototype;
    _proto.getItem = function getItem(key) {
        var encryptedKey = this.encryptAgent.encrypt(key);
        if (!encryptedKey) return null;
        var encryptedValue = sessionStorage.getItem(encryptedKey);
        if (!encryptedValue) return null;
        return this.encryptAgent.decrypt(encryptedValue);
    };
    _proto.setItem = function setItem(key, value) {
        var encryptedKey = this.encryptAgent.encrypt(key);
        var encryptedValue = this.encryptAgent.encrypt(value);
        return sessionStorage.setItem(encryptedKey, encryptedValue);
    };
    _proto.removeItem = function removeItem(key) {
        var encryptedKey = this.encryptAgent.encrypt(key);
        return sessionStorage.removeItem(encryptedKey);
    };
    return SecuredSessionStorage;
}();


;// CONCATENATED MODULE: ../../packages/infra/webStorage/index.ts


;// CONCATENATED MODULE: ../../packages/infra/index.ts
















/***/ }),

/***/ 96915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jC": function() { return /* reexport */ FAChannelsValues; },
  "ZI": function() { return /* reexport */ FATypeValues; },
  "$1": function() { return /* reexport */ StatusGiftList; }
});

// UNUSED EXPORTS: FilterSessions, SaleChannel

;// CONCATENATED MODULE: ../../packages/typing/dto/CoupleDetail.ts
var StatusGiftList;
(function(StatusGiftList) {
    StatusGiftList[StatusGiftList["Open"] = 1] = "Open";
    StatusGiftList[StatusGiftList["ExclusionPending"] = 2] = "ExclusionPending";
    StatusGiftList[StatusGiftList["ClosingPending"] = 3] = "ClosingPending";
    StatusGiftList[StatusGiftList["PendingFilling"] = 4] = "PendingFilling";
    StatusGiftList[StatusGiftList["Closed"] = 5] = "Closed";
    StatusGiftList[StatusGiftList["Deleted"] = 6] = "Deleted";
    StatusGiftList[StatusGiftList["Blocked"] = 7] = "Blocked";
    StatusGiftList[StatusGiftList["Pending"] = 99] = "Pending";
})(StatusGiftList || (StatusGiftList = {}));

;// CONCATENATED MODULE: ../../packages/typing/dto/OrderFilter.ts
var FilterSessions;
(function(FilterSessions) {
    FilterSessions[FilterSessions["Status"] = 0] = "Status";
    FilterSessions[FilterSessions["Date"] = 1] = "Date";
    FilterSessions[FilterSessions["SaleChannel"] = 2] = "SaleChannel";
    FilterSessions[FilterSessions["OrderType"] = 3] = "OrderType";
})(FilterSessions || (FilterSessions = {}));

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/typing/dto/LibMagicZoom.ts


;// CONCATENATED MODULE: ../../packages/typing/dto/Orders.ts
// Importações
var SaleChannel;
(function(SaleChannel) {
    SaleChannel[SaleChannel["STORE"] = 1] = "STORE";
    SaleChannel[SaleChannel["DIGITAL"] = 2] = "DIGITAL";
    SaleChannel[SaleChannel["APP"] = 4] = "APP";
})(SaleChannel || (SaleChannel = {}));

;// CONCATENATED MODULE: ../../packages/typing/dto/index.ts


















































;// CONCATENATED MODULE: ../../packages/typing/types/enum.ts
// eslint-disable-next-line no-shadow
var FATypeValues;
(function(FATypeValues) {
    FATypeValues[FATypeValues["GiftCard2FA"] = 1] = "GiftCard2FA";
    FATypeValues[FATypeValues["Address2FA"] = 2] = "Address2FA";
    FATypeValues[FATypeValues["PickUp2FA"] = 3] = "PickUp2FA";
    FATypeValues[FATypeValues["GiftCardForStore2FA"] = 4] = "GiftCardForStore2FA";
    FATypeValues[FATypeValues["AccountCreate2FA"] = 5] = "AccountCreate2FA";
    FATypeValues[FATypeValues["AccountUpdatePhone2FA"] = 6] = "AccountUpdatePhone2FA";
    FATypeValues[FATypeValues["AccountUpdateAddress2FA"] = 7] = "AccountUpdateAddress2FA";
    FATypeValues[FATypeValues["AccountUpdateEmail2FA"] = 8] = "AccountUpdateEmail2FA";
    FATypeValues[FATypeValues["RecoverAccount2FA"] = 9] = "RecoverAccount2FA";
    FATypeValues[FATypeValues["AccountUpdatePassword2FA"] = 10] = "AccountUpdatePassword2FA";
    FATypeValues[FATypeValues["AccountValidateEMail2FA"] = 12] = "AccountValidateEMail2FA";
    FATypeValues[FATypeValues["AccountValidatePhone2FA"] = 13] = "AccountValidatePhone2FA";
    FATypeValues[FATypeValues["ReportSecurityProblem2FA"] = 14] = "ReportSecurityProblem2FA";
    FATypeValues[FATypeValues["UpdatePickupResponsible2FA"] = 15] = "UpdatePickupResponsible2FA";
})(FATypeValues || (FATypeValues = {}));
var // eslint-disable-next-line no-shadow
FAChannelsValues;
(function(FAChannelsValues) {
    FAChannelsValues[FAChannelsValues["SMS"] = 1] = "SMS";
    FAChannelsValues[FAChannelsValues["Email"] = 2] = "Email";
    FAChannelsValues[FAChannelsValues["AppAuthenticator"] = 3] = "AppAuthenticator";
})(FAChannelsValues || (FAChannelsValues = {}));


;// CONCATENATED MODULE: ../../packages/typing/types/index.ts









































































;// CONCATENATED MODULE: ../../packages/typing/index.tsx




/***/ }),

/***/ 39927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wc$": function() { return /* reexport */ AccountDeletionIcon; },
  "GST": function() { return /* reexport */ AddCard; },
  "Boy": function() { return /* reexport */ AddNewEnvironment; },
  "YSu": function() { return /* reexport */ AddressListIcon; },
  "bZj": function() { return /* reexport */ Alert; },
  "kb0": function() { return /* reexport */ AlertWithDetail; },
  "Wg4": function() { return /* reexport */ AlertWithStroke; },
  "Xvm": function() { return /* reexport */ Alliances; },
  "iqj": function() { return /* reexport */ Amex; },
  "PK3": function() { return /* reexport */ AppAuthenticationIcon; },
  "KGf": function() { return /* reexport */ AppFcIcon; },
  "ACs": function() { return /* reexport */ Apple; },
  "HiE": function() { return /* reexport */ ArrowCarouselLeft; },
  "aYg": function() { return /* reexport */ ArrowCarouselRight; },
  "K5e": function() { return /* reexport */ ArrowDown; },
  "oHn": function() { return /* reexport */ ArrowDownCircle; },
  "obG": function() { return /* reexport */ ArrowDownSolid; },
  "SDF": function() { return /* reexport */ ArrowFilledDown; },
  "XdH": function() { return /* reexport */ ArrowLeft; },
  "dFl": function() { return /* reexport */ ArrowLeftCategoriesIcon; },
  "Y4O": function() { return /* reexport */ ArrowLeftIcon; },
  "qGl": function() { return /* reexport */ ArrowLength; },
  "olP": function() { return /* reexport */ ArrowRight; },
  "a2Z": function() { return /* reexport */ ArrowUp; },
  "kpN": function() { return /* reexport */ ArrowUpCircle; },
  "Wc5": function() { return /* reexport */ ArrowWidth; },
  "v44": function() { return /* reexport */ AtEmailIcon; },
  "GmG": function() { return /* reexport */ AuthenticationIcon; },
  "niG": function() { return /* reexport */ AutomotivoIcon; },
  "Nh5": function() { return /* reexport */ Bag; },
  "LnD": function() { return /* reexport */ BagIcon; },
  "iZZ": function() { return /* reexport */ Banknote; },
  "vwY": function() { return /* reexport */ BanknoteInput; },
  "S2I": function() { return /* reexport */ Barcode; },
  "Dlc": function() { return /* reexport */ Bin; },
  "_1e": function() { return /* reexport */ BlackFridayBag; },
  "hj4": function() { return /* reexport */ BoxGift; },
  "Jmn": function() { return /* reexport */ BreadcrumbArrowIcon; },
  "IfH": function() { return /* reexport */ BrowserDefault; },
  "Ncw": function() { return /* reexport */ CPF; },
  "D2G": function() { return /* reexport */ CalendarChecklistIcon; },
  "Que": function() { return /* reexport */ CalendarIcon; },
  "lHO": function() { return /* reexport */ CalendarOutlineIcon; },
  "o8m": function() { return /* reexport */ CallIcon; },
  "QL2": function() { return /* reexport */ CamaMesaEBanhoIcon; },
  "V1s": function() { return /* reexport */ Camera; },
  "B_A": function() { return /* reexport */ CancellationIcon; },
  "Zbd": function() { return /* reexport */ Card; },
  "Hue": function() { return /* reexport */ CardHeart; },
  "_Kv": function() { return /* reexport */ CardIcon; },
  "APc": function() { return /* reexport */ Cart; },
  "w7_": function() { return /* reexport */ CartIcon; },
  "Bbg": function() { return /* reexport */ CartLogoFCBlack; },
  "pMC": function() { return /* reexport */ CartOutlineIcon; },
  "FWC": function() { return /* reexport */ CenteredUserIcon; },
  "AML": function() { return /* reexport */ ChangeAddressIcon; },
  "IaT": function() { return /* reexport */ ChangePasswordIcon; },
  "JrY": function() { return /* reexport */ Check; },
  "GcA": function() { return /* reexport */ CheckDone; },
  "nQG": function() { return /* reexport */ CheckIcon; },
  "DQr": function() { return /* reexport */ CheckPayment; },
  "jg9": function() { return /* reexport */ CheckValidateIcon; },
  "Zgy": function() { return /* reexport */ CheckmarkCircle; },
  "eLj": function() { return /* reexport */ ChromeIcon; },
  "owK": function() { return /* reexport */ CircleCheckIcon; },
  "Mgn": function() { return /* reexport */ CircleErrorIcon; },
  "ODY": function() { return /* reexport */ CircularTelephoneIcon; },
  "NSo": function() { return /* reexport */ ClientIcon; },
  "SUY": function() { return /* reexport */ Clock; },
  "T39": function() { return /* reexport */ ClockIcon; },
  "x8P": function() { return /* reexport */ Close; },
  "Two": function() { return /* reexport */ CloseIcon; },
  "MA4": function() { return /* reexport */ Coinpig; },
  "vZk": function() { return /* reexport */ ConstrucaoIcon; },
  "CKM": function() { return /* reexport */ Copy; },
  "TIy": function() { return /* reexport */ CopyIcon; },
  "Xtd": function() { return /* reexport */ CouponTag; },
  "U9w": function() { return /* reexport */ CouponTicket; },
  "aBT": function() { return /* reexport */ CreditCard; },
  "eZD": function() { return /* reexport */ DefaultCard; },
  "T54": function() { return /* reexport */ DefaultProductImage; },
  "uoG": function() { return /* reexport */ DeliveredPackageTrackingStatusIcon; },
  "VPl": function() { return /* reexport */ DeliveringTrackingStatusIcon; },
  "Reo": function() { return /* reexport */ DeliveryTruckPinIcon; },
  "Iq3": function() { return /* reexport */ DeviceAccountIcon; },
  "x5s": function() { return /* reexport */ DeviceCheck; },
  "saf": function() { return /* reexport */ DeviceCheckError; },
  "NQD": function() { return /* reexport */ DeviceComputerIcon; },
  "qHj": function() { return /* reexport */ DevicePasswordChange; },
  "LAI": function() { return /* reexport */ DevicePasswordChanged; },
  "X91": function() { return /* reexport */ DeviceSmartphoneIcon; },
  "Uoy": function() { return /* reexport */ DevicesIcon; },
  "Xiq": function() { return /* reexport */ Diners; },
  "RN8": function() { return /* reexport */ DisconnectIcon; },
  "RFQ": function() { return /* reexport */ DollarCircle; },
  "teY": function() { return /* reexport */ DollarIcon; },
  "kfl": function() { return /* reexport */ DoubleArrowDown; },
  "$m7": function() { return /* reexport */ DoubleCard; },
  "W0f": function() { return /* reexport */ DoubtsIcon; },
  "eQy": function() { return /* reexport */ DownPayment; },
  "I8b": function() { return /* reexport */ Edit; },
  "mOM": function() { return /* reexport */ EditPencilIcon; },
  "lts": function() { return /* reexport */ EditRight; },
  "DEN": function() { return /* reexport */ EletronicosIcon; },
  "oPg": function() { return /* reexport */ Elo; },
  "GEH": function() { return /* reexport */ EmailAuthenticationIcon; },
  "XlC": function() { return /* reexport */ EmailFailureIcon; },
  "LQS": function() { return /* reexport */ EmailIcon; },
  "jN3": function() { return /* reexport */ EmailLetterMessage; },
  "AIT": function() { return /* reexport */ EmailValidationErrorIcon; },
  "MN3": function() { return /* reexport */ EmailValidationIcon; },
  "K4G": function() { return /* reexport */ EmployeeIcon; },
  "KM_": function() { return /* reexport */ EraseIcon; },
  "Pz_": function() { return /* reexport */ ErrorIcon; },
  "u5P": function() { return /* reexport */ ExclusionAccountFailedIcon; },
  "rI4": function() { return /* reexport */ ExclusionAccountSucceedIcon; },
  "Wif": function() { return /* reexport */ EyeClose; },
  "YyG": function() { return /* reexport */ EyeOpen; },
  "rEg": function() { return /* reexport */ FCCredit; },
  "l2y": function() { return /* reexport */ FCLogoBlackFriday; },
  "EPk": function() { return /* reexport */ FaceAuthenticationIcon; },
  "s1S": function() { return /* reexport */ Facebook; },
  "GKd": function() { return /* reexport */ FacebookIconFooter; },
  "dgZ": function() { return /* reexport */ FailureIcon; },
  "slo": function() { return /* reexport */ FailurePaperAirplaneIcon; },
  "q4I": function() { return /* reexport */ FerramentasEEPIIcon; },
  "$BE": function() { return /* reexport */ File; },
  "wn$": function() { return /* reexport */ Filter; },
  "wG3": function() { return /* reexport */ FurnitureGiftIcon; },
  "NC6": function() { return /* reexport */ FurnitureGiftSmallIcon; },
  "r5N": function() { return /* reexport */ GeometricBoxIcon; },
  "ncs": function() { return /* reexport */ Gift; },
  "s6A": function() { return /* reexport */ GiftCardWeddingListHome; },
  "OgN": function() { return /* reexport */ GiftIcon; },
  "D5x": function() { return /* reexport */ GiftIconActivityHistory; },
  "LzI": function() { return /* reexport */ GiftIconNew; },
  "qPd": function() { return /* reexport */ GiftOutlineIcon; },
  "ieO": function() { return /* reexport */ Google; },
  "fCp": function() { return /* reexport */ GoogleColored; },
  "cvE": function() { return /* reexport */ GreenAddIcon; },
  "Uq7": function() { return /* reexport */ HamburgerIcon; },
  "dZ4": function() { return /* reexport */ HandPackageDeliveryIcon; },
  "fJl": function() { return /* reexport */ HeadPhone; },
  "Xdw": function() { return /* reexport */ Heart; },
  "h_8": function() { return /* reexport */ HeartIcon; },
  "WWB": function() { return /* reexport */ Help; },
  "E4Q": function() { return /* reexport */ Hiper; },
  "RAr": function() { return /* reexport */ Hipercard; },
  "SK8": function() { return /* reexport */ Home; },
  "tvw": function() { return /* reexport */ HomeIcon; },
  "vEO": function() { return /* reexport */ HomeImprovementsIcon; },
  "uDo": function() { return /* reexport */ HomeImprovementsSmallIcon; },
  "TXp": function() { return /* reexport */ House; },
  "K2o": function() { return /* reexport */ HouseIcon; },
  "Dc$": function() { return /* reexport */ IconLeftBottom; },
  "t2y": function() { return /* reexport */ IconLeftBottomMobile; },
  "rI_": function() { return /* reexport */ IconRightTop; },
  "rqA": function() { return /* reexport */ IconRightTopMobile; },
  "kot": function() { return /* reexport */ IconStore; },
  "fW_": function() { return /* reexport */ IllustrationSendEmail; },
  "OIN": function() { return /* reexport */ IluminacaoIcon; },
  "HW3": function() { return /* reexport */ ImageCardVirtualMyCards; },
  "l_": function() { return /* reexport */ ImagePhoneWhereToUse; },
  "FM": function() { return /* reexport */ IndifferentFaceIcon; },
  "hQ6": function() { return /* reexport */ InfoOutlineIcon; },
  "mre": function() { return /* reexport */ Instagram; },
  "ozo": function() { return /* reexport */ InstagramIconFooter; },
  "iPI": function() { return /* reexport */ Interrogation; },
  "$Iz": function() { return /* reexport */ InvoicedTrackingStatusIcon; },
  "xnI": function() { return /* reexport */ Jcb; },
  "yhk": function() { return /* reexport */ LinkedIn; },
  "hhm": function() { return /* reexport */ LinkedinIconFooter; },
  "DE2": function() { return /* reexport */ ListIcon; },
  "HEZ": function() { return /* reexport */ Lock; },
  "mBM": function() { return /* reexport */ LockIcon; },
  "V6C": function() { return /* reexport */ LogoFCBlack; },
  "dSO": function() { return /* reexport */ LogoFerreiraCosta; },
  "CsV": function() { return /* reexport */ LoucasMetaisEAcessoriosIcon; },
  "D5R": function() { return /* reexport */ Map; },
  "$td": function() { return /* reexport */ MapPin; },
  "ffk": function() { return /* reexport */ Mastercard; },
  "oH9": function() { return /* reexport */ MateriaisEletricosIcon; },
  "YPk": function() { return /* reexport */ MateriaisHidraulicosIcon; },
  "wW5": function() { return /* reexport */ MessagesIcon; },
  "hiG": function() { return /* reexport */ MoveisEDecoracaoIcon; },
  "Yf9": function() { return /* reexport */ MozilaFirefoxIcon; },
  "$h5": function() { return /* reexport */ MyAccountIcon; },
  "WD5": function() { return /* reexport */ MyCardsIcon; },
  "RrJ": function() { return /* reexport */ MyDataIcon; },
  "WVy": function() { return /* reexport */ MyListFingerOnPhone; },
  "Zj$": function() { return /* reexport */ MyListFingerPoiting; },
  "b$w": function() { return /* reexport */ MyListThumbsUp; },
  "i4T": function() { return /* reexport */ MyListsIcon; },
  "NJL": function() { return /* reexport */ MyOrdersIcon; },
  "aSj": function() { return /* reexport */ MySecurityIcon; },
  "pB$": function() { return /* reexport */ NewEyeCloseIcon; },
  "TPX": function() { return /* reexport */ NewEyeOpenIcon; },
  "Bl$": function() { return /* reexport */ NewGiftIcon; },
  "I3k": function() { return /* reexport */ NewShareIcon; },
  "$6R": function() { return /* reexport */ NoAddress; },
  "dIr": function() { return /* reexport */ NoOrder; },
  "lM8": function() { return /* reexport */ NoOrderIcon; },
  "wy_": function() { return /* reexport */ NoPackages; },
  "_Jb": function() { return /* reexport */ OfflineIcon; },
  "GOp": function() { return /* reexport */ OpsIcon; },
  "btc": function() { return /* reexport */ OrderApproved; },
  "byi": function() { return /* reexport */ OrderCancelled; },
  "agT": function() { return /* reexport */ OrderCancelledIcon; },
  "DTl": function() { return /* reexport */ OrderCancelling; },
  "orY": function() { return /* reexport */ OrderDelivered; },
  "apP": function() { return /* reexport */ OrderDelivering; },
  "Uyx": function() { return /* reexport */ OrderWaitingPayment; },
  "SHC": function() { return /* reexport */ OrderWithdrawAvailable; },
  "PAp": function() { return /* reexport */ OthersPayments; },
  "oCG": function() { return /* reexport */ OutForDeliveryTrackingStatusIcon; },
  "GLc": function() { return /* reexport */ Package; },
  "jtq": function() { return /* reexport */ PackageIcon; },
  "N8c": function() { return /* reexport */ PackageOutlined; },
  "MAY": function() { return /* reexport */ PackageThumbsUpIcon; },
  "TuS": function() { return /* reexport */ PasteIcon; },
  "TlF": function() { return /* reexport */ PaymentCancelledIcon; },
  "Tfr": function() { return /* reexport */ PaymentDoneIcon; },
  "A6c": function() { return /* reexport */ PaymentMethods; },
  "zaA": function() { return /* reexport */ Pencil; },
  "eCG": function() { return /* reexport */ PercentageDiscount; },
  "LPZ": function() { return /* reexport */ Phone; },
  "QoR": function() { return /* reexport */ PhoneAuthenticationIcon; },
  "Csw": function() { return /* reexport */ PhoneCallIcon; },
  "dUP": function() { return /* reexport */ PhoneNumberValidationError; },
  "XqY": function() { return /* reexport */ PickupStore; },
  "zun": function() { return /* reexport */ PigIcon; },
  "rUJ": function() { return /* reexport */ PinLocation; },
  "ij4": function() { return /* reexport */ PinLocationOutline; },
  "cHF": function() { return /* reexport */ PinterestIcon; },
  "rdS": function() { return /* reexport */ PisosERevestimentosIcon; },
  "WEt": function() { return /* reexport */ PixIcon; },
  "A34": function() { return /* reexport */ PixIconWithBG; },
  "yB6": function() { return /* reexport */ PlusInCircleIcon; },
  "gkv": function() { return /* reexport */ PortasJanelasEFechadurasIcon; },
  "wSx": function() { return /* reexport */ PreparingTrackingStatusIcon; },
  "rJM": function() { return /* reexport */ PrintedInvoiceIcon; },
  "m26": function() { return /* reexport */ ProfileIcon; },
  "UHX": function() { return /* reexport */ QrCode; },
  "HNF": function() { return /* reexport */ Question; },
  "vl4": function() { return /* reexport */ ReadyForPickupTrackingStatusIcon; },
  "MGt": function() { return /* reexport */ ReportSecurityProblemIcon; },
  "D94": function() { return /* reexport */ RequestErrorIcon; },
  "O7B": function() { return /* reexport */ ResumeOrder; },
  "KMc": function() { return /* reexport */ RightArrowProduct; },
  "Vk2": function() { return /* reexport */ RotateIcon; },
  "wSs": function() { return /* reexport */ SafariIcon; },
  "Gg0": function() { return /* reexport */ SaleTagIcon; },
  "zuy": function() { return /* reexport */ SatisfiedFaceIcon; },
  "olm": function() { return /* reexport */ Search; },
  "tWk": function() { return /* reexport */ SearchBagIcon; },
  "FTV": function() { return /* reexport */ SearchBoxIcon; },
  "W1M": function() { return /* reexport */ SearchIcon; },
  "J8y": function() { return /* reexport */ SecurityIcon; },
  "cjT": function() { return /* reexport */ SecurityLockIcon; },
  "Zrf": function() { return /* reexport */ Settings; },
  "ewm": function() { return /* reexport */ SettingsIcon; },
  "mBz": function() { return /* reexport */ Share; },
  "Op7": function() { return /* reexport */ ShieldUserProtection; },
  "EOn": function() { return /* reexport */ ShopIcon; },
  "b_c": function() { return /* reexport */ ShoppingBagIcon; },
  "Q1y": function() { return /* reexport */ ShoppingCartIcon; },
  "cqj": function() { return /* reexport */ ShoppingFlowIcon; },
  "CFw": function() { return /* reexport */ SingleUserIcon; },
  "rpN": function() { return /* reexport */ Smartphone; },
  "usK": function() { return /* reexport */ SocialMedia; },
  "yFx": function() { return /* reexport */ Spotify; },
  "RlD": function() { return /* reexport */ SpotifyIconFooter; },
  "Uxw": function() { return /* reexport */ Star; },
  "r7p": function() { return /* reexport */ StarIcon; },
  "Jj5": function() { return /* reexport */ StatusIcon; },
  "yh4": function() { return /* reexport */ Store; },
  "tmp": function() { return /* reexport */ SuccessIcon; },
  "h29": function() { return /* reexport */ SuccessSyncIcon; },
  "sUU": function() { return /* reexport */ TelephoneAuthenticationIcon; },
  "ow7": function() { return /* reexport */ TelephoneErrorIcon; },
  "nMY": function() { return /* reexport */ ThreeDotsHorizontal; },
  "TzQ": function() { return /* reexport */ TintasEQuimicosIcon; },
  "LAV": function() { return /* reexport */ TrackingStatusDeliveryManArrivedStore; },
  "SYV": function() { return /* reexport */ TrackingStatusDeliveryManAtPlace; },
  "iA1": function() { return /* reexport */ TrackingStatusDeliveryManOnTheWay; },
  "oI5": function() { return /* reexport */ TrackingStatusOrderBeignSeparated; },
  "utO": function() { return /* reexport */ TrackingStatusOrderCanceled; },
  "TgP": function() { return /* reexport */ TrackingStatusOrderInvoiced; },
  "Yql": function() { return /* reexport */ TrackingStatusOrderNewDeliveryMan; },
  "vhD": function() { return /* reexport */ TrackingStatusOrderOnTheCarrier; },
  "W72": function() { return /* reexport */ TrackingStatusOrderOutForDelivery; },
  "ufH": function() { return /* reexport */ TrackingStatusOrderReceived; },
  "Nvd": function() { return /* reexport */ TrackingStatusPickingAvailable; },
  "sXz": function() { return /* reexport */ TrackingStatusRescheduledOrder; },
  "_DY": function() { return /* reexport */ Truck; },
  "Rt9": function() { return /* reexport */ TruckFC; },
  "WOT": function() { return /* reexport */ TwoCardsIcon; },
  "mYL": function() { return /* reexport */ TwoStepVerificationIcon; },
  "Jcv": function() { return /* reexport */ UnavailableIcon; },
  "_ju": function() { return /* reexport */ UniqueClientImage; },
  "T_Y": function() { return /* reexport */ UniqueClientMediumSMobileInfo; },
  "ZPv": function() { return /* reexport */ UniqueClientMobileImage; },
  "xMg": function() { return /* reexport */ UniqueClientSecondaryMobileImage; },
  "t95": function() { return /* reexport */ UniqueClientXSMobileImage; },
  "zeW": function() { return /* reexport */ UniqueClientXSMobileInfo; },
  "PN2": function() { return /* reexport */ UnsatisfiedFaceIcon; },
  "Oww": function() { return /* reexport */ UserCardIcon; },
  "tBG": function() { return /* reexport */ UserIcon; },
  "KgO": function() { return /* reexport */ UtilidadesDomesticasIcon; },
  "XGw": function() { return /* reexport */ ValidIcon; },
  "CvM": function() { return /* reexport */ VerySatisfiedFaceIcon; },
  "Z2X": function() { return /* reexport */ VeryUnsatisfiedFaceIcon; },
  "aB9": function() { return /* reexport */ Visa; },
  "w5x": function() { return /* reexport */ Wallet; },
  "aNP": function() { return /* reexport */ WarningIcon; },
  "FB0": function() { return /* reexport */ WarningRevalidationIcon; },
  "AHd": function() { return /* reexport */ WarningValidateIcon; },
  "pZu": function() { return /* reexport */ WeddingRingIcon; },
  "Wge": function() { return /* reexport */ WeddingRingsDefaultIcon; },
  "lxD": function() { return /* reexport */ WeddingRingsIcon; },
  "Kvs": function() { return /* reexport */ WeighIcon; },
  "w26": function() { return /* reexport */ WhatsApp; },
  "udp": function() { return /* reexport */ WhatsappIcon; },
  "LKl": function() { return /* reexport */ YoutubeIcon; },
  "aZq": function() { return /* binding */ mappedIcons; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ui/themes/index.ts + 15 modules
var themes = __webpack_require__(27814);
;// CONCATENATED MODULE: ../../packages/ui/Icons/AccountDeletionIcon.tsx


var AccountDeletionIcon = function(param) {
    var width = param.width, height = param.height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, alt = param.alt, strokeWidth = param.strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 20 21",
        fill: "none",
        "aria-label": alt,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.3915 3.01931C11.5279 4.15574 11.5279 5.99824 10.3915 7.13467C9.25508 8.27109 7.41257 8.27109 6.27615 7.13467C5.13972 5.99824 5.13972 4.15574 6.27615 3.01931C7.41257 1.88289 9.25508 1.88289 10.3915 3.01931",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9695 11.164C10.887 10.7315 9.61699 10.4932 8.33366 10.4932C4.96033 10.4932 1.66699 12.1323 1.66699 14.6532V15.4865C1.66699 15.9465 2.04033 16.3198 2.50033 16.3198H10.3445",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1667 18.8333C11.8658 18.8333 10 16.9683 10 14.6667C10 12.4133 11.9167 10.4975 14.17 10.5C16.47 10.5017 18.3333 12.3667 18.3333 14.6667C18.3333 16.9675 16.4683 18.8333 14.1667 18.8333",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.3422 13.4922L12.9922 15.8422",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.3422 15.8422L12.9922 13.4922",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AddCard.tsx


var AddCard = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.tertiary.110 */.rS.colors.tertiary[110] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.tertiary.210 */.rS.colors.tertiary[210] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.neutral.40 */.rS.colors.neutral[40] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.secondary.255 */.rS.colors.secondary[255] : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _fifthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "24",
                height: "24",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "4",
                y: "7",
                width: "15",
                height: "10",
                rx: "1.5",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "4",
                y: "9",
                width: "15",
                height: "2.5",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "3",
                height: "0.5",
                rx: "0.25",
                transform: "matrix(1 0 0 -1 6 14)",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "5",
                height: "0.5",
                rx: "0.25",
                transform: "matrix(1 0 0 -1 6 15)",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "18.5",
                cy: "14.5",
                r: "3.5",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "18",
                y: "12",
                width: "1",
                height: "5",
                rx: "0.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "16",
                y: "15",
                width: "1",
                height: "5",
                rx: "0.5",
                transform: "rotate(-90 16 15)",
                fill: fifthColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AddNewEnvironment.tsx


var AddNewEnvironment = function(param) {
    var _width = param.width, width = _width === void 0 ? 30 : _width, _height = param.height, height = _height === void 0 ? 30 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.265 */.rS.colors.secondary[265] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.2363 7C19.6036 7 19.9013 7.29773 19.9013 7.665V9.57133H21.814C22.1848 9.57133 22.4853 9.8719 22.4853 10.2427V10.2427C22.4853 10.6134 22.1848 10.914 21.814 10.914H19.9013V12.8077C19.9013 13.1749 19.6036 13.4727 19.2363 13.4727V13.4727C18.8691 13.4727 18.5713 13.1749 18.5713 12.8077V10.914H16.6713C16.3006 10.914 16 10.6134 16 10.2427V10.2427C16 9.8719 16.3006 9.57133 16.6713 9.57133H18.5713V7.665C18.5713 7.29773 18.8691 7 19.2363 7V7Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 12H13.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 17H22.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 7H13.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Alert.tsx


var Alert = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.alert */.rS.colors.primary.alert : _color, _alt = param.alt, alt = _alt === void 0 ? "Aviso" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 12.5V7.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.999 16C11.861 16 11.749 16.112 11.75 16.25C11.75 16.388 11.862 16.5 12 16.5C12.138 16.5 12.25 16.388 12.25 16.25C12.25 16.112 12.138 16 11.999 16",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AlertWithStroke.tsx


var AlertWithStroke = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 3V11",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 14H8.019",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Alliances.tsx


var Alliances = function(param) {
    var _width = param.width, width = _width === void 0 ? 40 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.25" : _strokeWidth, _alt = param.alt, alt = _alt === void 0 ? "Alian\xe7as" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8.16665",
                cy: "15.0106",
                r: "5.41665",
                stroke: color,
                strokeWidth: strokeWidth
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "15.8333",
                cy: "15.0106",
                r: "5.41665",
                stroke: color,
                strokeWidth: strokeWidth
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 7.17733L11.5638 7.78741L11.5637 7.78739L11.5636 7.78731L11.5632 7.78703L11.5618 7.78597L11.556 7.78188L11.5344 7.76638L11.4564 7.71048C11.3914 7.66382 11.3032 7.6004 11.2107 7.53352C11.0356 7.40698 10.8163 7.24749 10.7315 7.17965C10.6431 7.10896 10.1158 6.63397 9.87182 6.37606C9.72508 6.22094 9.55479 5.98833 9.42244 5.73296C9.30068 5.49801 9.14672 5.12276 9.18706 4.71937C9.2462 4.1279 9.60617 3.78716 9.71518 3.68398C9.72395 3.67567 9.7311 3.6689 9.73634 3.66367C10.0848 3.31517 10.4623 3.26732 10.624 3.26143C10.6408 3.25972 10.6651 3.25738 10.6939 3.2553C10.7607 3.25051 10.8537 3.24696 10.9621 3.25384C11.1701 3.26704 11.4859 3.32189 11.7825 3.53127C11.8569 3.58379 11.9328 3.64677 12.0073 3.71489C12.0835 3.64642 12.1602 3.58344 12.2342 3.53127C12.5231 3.32728 12.8245 3.2683 13.0347 3.25405C13.1418 3.24679 13.2331 3.25053 13.2988 3.25561C13.3234 3.25752 13.3446 3.25964 13.3601 3.2613C13.5097 3.26615 13.9243 3.30769 14.2803 3.66367L13.75 4.194L14.2803 3.66367C14.2851 3.66847 14.2907 3.67391 14.2969 3.68002C14.4115 3.79265 14.7539 4.12895 14.8129 4.71937C14.8533 5.12275 14.6993 5.49801 14.5776 5.73296C14.4452 5.98833 14.2749 6.22094 14.1282 6.37606C13.8842 6.63397 13.3569 7.10896 13.2685 7.17964C13.1837 7.24749 12.9644 7.40698 12.7893 7.53352C12.6968 7.6004 12.6086 7.66382 12.5436 7.71048L12.4656 7.76638L12.444 7.78188L12.4382 7.78597L12.4368 7.78703L12.4364 7.78731L12.4363 7.78739L12.4362 7.78741L12 7.17733ZM12 7.17733L11.5638 7.78742L12 8.09932L12.4362 7.78742L12 7.17733Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Amex.tsx


var Amex = function(param) {
    var _width = param.width, width = _width === void 0 ? 65 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _alt = param.alt, alt = _alt === void 0 ? "Amex" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.tertiary.800 */.rS.colors.tertiary[800] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 53 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.26662 0H49C50.8033 0 52.2667 1.09069 52.2667 2.43585V25.5654C52.2667 26.9093 50.8033 28 49 28H3.26662C1.46178 28.0001 0 26.9093 0 25.5655V2.43585C0 1.09069 1.4634 0 3.26662 0Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.14104 8.43201L4.1145 19.5556H10.132L10.878 17.782H12.5831L13.3291 19.5556H19.9527V18.2019L20.5429 19.5556H23.9691L24.5593 18.1733V19.5556H38.3344L40.0094 17.8281L41.5778 19.5556L48.653 19.5699L43.6106 14.0248L48.653 8.43201H41.6876L40.0571 10.1276L38.538 8.43201H23.5525L22.2656 11.3031L20.9486 8.43201H14.9437V9.73958L14.2757 8.43201C14.2757 8.43201 9.14104 8.43201 9.14104 8.43201ZM10.3054 10.0116H13.2386L16.5727 17.5545V10.0116H19.7859L22.3611 15.4198L24.7344 10.0116H27.9316V17.9935H25.9862L25.9703 11.7389L23.1341 17.9935H21.3939L18.5418 11.7389V17.9935H14.5397L13.781 16.204H9.68186L8.92471 17.9919H6.78042L10.3054 10.0116ZM29.7114 10.0116H37.6218L40.0412 12.625L42.5386 10.0116H44.958L41.2819 14.0233L44.958 17.9887H42.4288L40.0094 15.345L37.4993 17.9887H29.7114V10.0116ZM11.7323 11.3621L10.3818 14.5498H13.0812L11.7323 11.3621ZM31.6648 11.6642V13.1213H35.9803V14.7454H31.6648V16.3361H36.5052L38.7544 13.9931L36.6007 11.6628H31.6648V11.6642Z",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Apple.tsx


var Apple = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        version: "1.1",
        id: "Capa_1",
        xmlns: "https://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 22.773 22.773",
        xmlSpace: "preserve",
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.769,0c0.053,0,0.106,0,0.162,0c0.13,1.606-0.483,2.806-1.228,3.675c-0.731,0.863-1.732,1.7-3.351,1.573 c-0.108-1.583,0.506-2.694,1.25-3.561C13.292,0.879,14.557,0.16,15.769,0z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.67,16.716c0,0.016,0,0.03,0,0.045c-0.455,1.378-1.104,2.559-1.896,3.655c-0.723,0.995-1.609,2.334-3.191,2.334 c-1.367,0-2.275-0.879-3.676-0.903c-1.482-0.024-2.297,0.735-3.652,0.926c-0.155,0-0.31,0-0.462,0 c-0.995-0.144-1.798-0.932-2.383-1.642c-1.725-2.098-3.058-4.808-3.306-8.276c0-0.34,0-0.679,0-1.019 c0.105-2.482,1.311-4.5,2.914-5.478c0.846-0.52,2.009-0.963,3.304-0.765c0.555,0.086,1.122,0.276,1.619,0.464 c0.471,0.181,1.06,0.502,1.618,0.485c0.378-0.011,0.754-0.208,1.135-0.347c1.116-0.403,2.21-0.865,3.652-0.648 c1.733,0.262,2.963,1.032,3.723,2.22c-1.466,0.933-2.625,2.339-2.427,4.74C17.818,14.688,19.086,15.964,20.67,16.716z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowCarouselLeft.tsx


var ArrowCarouselLeft = function(param) {
    var _width = param.width, width = _width === void 0 ? 12 : _width, _height = param.height, height = _height === void 0 ? 26 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.450 */.rS.colors.neutral[450] : _color, themeColors = param.themeColors, _alt = param.alt, alt = _alt === void 0 ? "bot\xe3o de voltar do carrosel" : _alt;
    var customColor = (themeColors === null || themeColors === void 0 ? void 0 : themeColors.default) || color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 15 26",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.854 24.25L1.61029 12.9662L12.8603 1.75",
            stroke: customColor,
            strokeWidth: "2.64706",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowCarouselRight.tsx


var ArrowCarouselRight = function(param) {
    var _width = param.width, width = _width === void 0 ? 12 : _width, _height = param.height, height = _height === void 0 ? 26 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.450 */.rS.colors.neutral[450] : _color, themeColors = param.themeColors, _alt = param.alt, alt = _alt === void 0 ? "bot\xe3o de pr\xf3ximo do carrosel" : _alt;
    var customColor = (themeColors === null || themeColors === void 0 ? void 0 : themeColors.default) || color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 15 26",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2.1459 1.75L13.3896 13.0338L2.13965 24.25",
            stroke: customColor,
            strokeWidth: "2.64706",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowDown.tsx


var ArrowDown = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Seta para baixo" : _alt, _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 15.9393L19.4697 10.4697C19.7626 10.1768 20.2374 10.1768 20.5303 10.4697C20.8232 10.7626 20.8232 11.2374 20.5303 11.5303L14.5303 17.5303C14.2374 17.8232 13.7626 17.8232 13.4697 17.5303L7.46967 11.5303C7.17678 11.2374 7.17678 10.7626 7.46967 10.4697C7.76256 10.1768 8.23744 10.1768 8.53033 10.4697L14 15.9393Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_2440",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "10",
                width: "14",
                height: "8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14 15.9393L19.4697 10.4697C19.7626 10.1768 20.2374 10.1768 20.5303 10.4697C20.8232 10.7626 20.8232 11.2374 20.5303 11.5303L14.5303 17.5303C14.2374 17.8232 13.7626 17.8232 13.4697 17.5303L7.46967 11.5303C7.17678 11.2374 7.17678 10.7626 7.46967 10.4697C7.76256 10.1768 8.23744 10.1768 8.53033 10.4697L14 15.9393Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_0_2440)"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowDownSolid.tsx


var ArrowDownSolid = function(param) {
    var _width = param.width, width = _width === void 0 ? 8 : _width, _height = param.height, height = _height === void 0 ? 7 : _height, _alt = param.alt, alt = _alt === void 0 ? "Seta direcionada para baixo" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.200 */.rS.colors.primary[200] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 8 7",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.00001 6.83317L0 0.166504H8L4.00001 6.83317Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowFilledDown.tsx


var ArrowFilledDown = function(param) {
    var _width = param.width, width = _width === void 0 ? 7 : _width, _height = param.height, height = _height === void 0 ? 6 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _alt = param.alt, alt = _alt === void 0 ? "Seta para baixo" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.99757 5.13281L0.997559 0.132812H6.99756L3.99757 5.13281Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowLeft.tsx


var ArrowLeft = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Voltar" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.0607 14L17.5303 19.4697C17.8232 19.7626 17.8232 20.2374 17.5303 20.5303C17.2374 20.8232 16.7626 20.8232 16.4697 20.5303L10.4697 14.5303C10.1768 14.2374 10.1768 13.7626 10.4697 13.4697L16.4697 7.46967C16.7626 7.17678 17.2374 7.17678 17.5303 7.46967C17.8232 7.76256 17.8232 8.23744 17.5303 8.53033L12.0607 14Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_3595",
                maskUnits: "userSpaceOnUse",
                x: "10",
                y: "7",
                width: "8",
                height: "14",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.0607 14L17.5303 19.4697C17.8232 19.7626 17.8232 20.2374 17.5303 20.5303C17.2374 20.8232 16.7626 20.8232 16.4697 20.5303L10.4697 14.5303C10.1768 14.2374 10.1768 13.7626 10.4697 13.4697L16.4697 7.46967C16.7626 7.17678 17.2374 7.17678 17.5303 7.46967C17.8232 7.76256 17.8232 8.23744 17.5303 8.53033L12.0607 14Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_0_3595)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: width,
                    height: height,
                    fill: "none"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowLeftIcon.tsx

var ArrowLeftIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? "18px" : _height, _width = param.width, width = _width === void 0 ? "18px" : _width, _alt = param.alt, alt = _alt === void 0 ? "Seta para esquerda" : _alt, _color = param.color, color = _color === void 0 ? "currentColor" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: color,
        viewBox: "0 0 256 256",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowLength.tsx


var ArrowLength = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.2426 6.58578V3.75735H9.41422",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.643 10.357L12.2427 3.75731",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75732 9.41418V12.2426H6.58575",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.357 5.64293L3.75738 12.2426",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowRight.tsx


var ArrowRight = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Seta para direita" : _alt, _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? "".concat(themes/* theme.colors.neutral.white */.rS.colors.neutral.white) : _secondColor, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "0.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.9393 14L10.4697 19.4697C10.1768 19.7626 10.1768 20.2374 10.4697 20.5303C10.7626 20.8232 11.2374 20.8232 11.5303 20.5303L17.5303 14.5303C17.8232 14.2374 17.8232 13.7626 17.5303 13.4697L11.5303 7.46967C11.2374 7.17678 10.7626 7.17678 10.4697 7.46967C10.1768 7.76256 10.1768 8.23744 10.4697 8.53033L15.9393 14Z",
                fill: color,
                strokeWidth: strokeWidth
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_3607",
                maskUnits: "userSpaceOnUse",
                x: "10",
                y: "7",
                width: "8",
                height: "14",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15.9393 14L10.4697 19.4697C10.1768 19.7626 10.1768 20.2374 10.4697 20.5303C10.7626 20.8232 11.2374 20.8232 11.5303 20.5303L17.5303 14.5303C17.8232 14.2374 17.8232 13.7626 17.5303 13.4697L11.5303 7.46967C11.2374 7.17678 10.7626 7.17678 10.4697 7.46967C10.1768 7.76256 10.1768 8.23744 10.4697 8.53033L15.9393 14Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_0_3607)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: width,
                    height: height,
                    transform: "matrix(-1 0 0 1 28 0)",
                    fill: "none"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowUp.tsx


var ArrowUp = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Seta para cima" : _alt, _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 12.0607L8.53033 17.5303C8.23744 17.8232 7.76256 17.8232 7.46967 17.5303C7.17678 17.2374 7.17678 16.7626 7.46967 16.4697L13.4697 10.4697C13.7626 10.1768 14.2374 10.1768 14.5303 10.4697L20.5303 16.4697C20.8232 16.7626 20.8232 17.2374 20.5303 17.5303C20.2374 17.8232 19.7626 17.8232 19.4697 17.5303L14 12.0607Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_2440",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "10",
                width: "14",
                height: "8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14 12.0607L8.53033 17.5303C8.23744 17.8232 7.76256 17.8232 7.46967 17.5303C7.17678 17.2374 7.17678 16.7626 7.46967 16.4697L13.4697 10.4697C13.7626 10.1768 14.2374 10.1768 14.5303 10.4697L20.5303 16.4697C20.8232 16.7626 20.8232 17.2374 20.5303 17.5303C20.2374 17.8232 19.7626 17.8232 19.4697 17.5303L14 12.0607Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_0_2440)"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowWidth.tsx


var ArrowWidth = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.0687 9.862L14 7.93133L12.0687 6",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.66669 7.93331H14",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.93133 6L2 7.93067L3.93133 9.862",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.3333 7.92867H2",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            " "
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AtEmailICon.tsx


var AtEmailIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 21 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.655 */.rS.colors.neutral[655] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.1685 18.0028H10.0001C5.85621 18.0028 2.49695 14.6436 2.49695 10.4997C2.49695 6.35585 5.85621 2.99658 10.0001 2.99658C14.1439 2.99658 17.5032 6.35585 17.5032 10.4997V11.7502C17.5032 12.9013 16.5701 13.8344 15.419 13.8344C14.2679 13.8344 13.3348 12.9013 13.3348 11.7502V10.4997C13.3348 8.65799 11.8418 7.16498 10.0001 7.16498V7.16498C8.15836 7.16498 6.66535 8.65799 6.66535 10.4997C6.66535 12.3414 8.15836 13.8344 10.0001 13.8344C11.8418 13.8344 13.3348 12.3414 13.3348 10.4997",
            stroke: color,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthenticationIcon.tsx

var AuthenticationIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de Autentica\xe7\xe3o" : _alt, _width = param.width, width = _width === void 0 ? 132 : _width, _height = param.height, height = _height === void 0 ? 131 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 132 131",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "66",
                cy: "65.5",
                r: "65.5",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M98.2721 82.9386L102.836 75.0249",
                stroke: "#A0A2A4",
                strokeWidth: "2.35285",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M95.4815 81.3294L98.2717 82.9387",
                stroke: "#A0A2A4",
                strokeWidth: "2.35285",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M97.3311 78.1222L100.121 79.7315",
                stroke: "#A0A2A4",
                strokeWidth: "2.35285",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M105.691 75.3994C103.684 75.9381 101.62 74.7478 101.081 72.7409C100.543 70.734 101.733 68.6703 103.74 68.1316C105.747 67.5928 107.811 68.7831 108.349 70.79C108.888 72.797 107.698 74.8606 105.691 75.3994",
                stroke: "#A0A2A4",
                strokeWidth: "2.35285",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M124.283 84.9563L120.829 80.6493",
                stroke: "#C3C4C5",
                strokeWidth: "1.42191",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M122.764 86.1741L124.282 84.9562",
                stroke: "#C3C4C5",
                strokeWidth: "1.42191",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121.364 84.4287L122.883 83.2109",
                stroke: "#C3C4C5",
                strokeWidth: "1.42191",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121.666 79.1238C121.529 80.3721 120.405 81.2728 119.157 81.1356C117.909 80.9985 117.008 79.8753 117.145 78.627C117.283 77.3787 118.406 76.478 119.654 76.6152C120.902 76.7523 121.803 77.8755 121.666 79.1238",
                stroke: "#C3C4C5",
                strokeWidth: "1.42191",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.8865 43.1952L88.763 36.4157",
                stroke: "#C3C4C5",
                strokeWidth: "2.35285",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M92.496 45.3543L94.8864 43.1952",
                stroke: "#C3C4C5",
                strokeWidth: "2.35285",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M90.0146 42.6067L92.4049 40.4477",
                stroke: "#C3C4C5",
                strokeWidth: "2.35285",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M89.9992 33.8145C89.8937 35.8899 88.1258 37.4867 86.0505 37.3812C83.9752 37.2757 82.3783 35.5078 82.4839 33.4325C82.5894 31.3571 84.3573 29.7603 86.4326 29.8658C88.5079 29.9713 90.1047 31.7392 89.9992 33.8145",
                stroke: "#C3C4C5",
                strokeWidth: "2.35285",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.8969 79.4699L31.6768 72.9162",
                stroke: "#A0A2A4",
                strokeWidth: "1.94851",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.5857 78.1372L27.8964 79.4699",
                stroke: "#A0A2A4",
                strokeWidth: "1.94851",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.1179 75.4812L29.4286 76.8139",
                stroke: "#A0A2A4",
                strokeWidth: "1.94851",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0411 73.2265C32.3791 73.6727 30.67 72.687 30.2239 71.0249C29.7777 69.3629 30.7634 67.6538 32.4255 67.2077C34.0875 66.7616 35.7966 67.7473 36.2427 69.4093C36.6889 71.0714 35.7032 72.7804 34.0411 73.2265",
                stroke: "#A0A2A4",
                strokeWidth: "1.94851",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M109.627 38.6971L111.927 34.7102",
                stroke: "#C3C4C5",
                strokeWidth: "1.18536",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M108.222 37.8863L109.628 38.6971",
                stroke: "#C3C4C5",
                strokeWidth: "1.18536",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M109.154 36.2706L110.559 37.0814",
                stroke: "#C3C4C5",
                strokeWidth: "1.18536",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M113.365 34.8988C112.354 35.1702 111.314 34.5705 111.043 33.5594C110.772 32.5484 111.371 31.5087 112.382 31.2373C113.393 30.9659 114.433 31.5655 114.705 32.5766C114.976 33.5877 114.376 34.6274 113.365 34.8988",
                stroke: "#C3C4C5",
                strokeWidth: "1.18536",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M77.6372 20.418L79.9367 16.4311",
                stroke: "#C3C4C5",
                strokeWidth: "1.18536",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M76.2317 19.6073L77.6374 20.418",
                stroke: "#C3C4C5",
                strokeWidth: "1.18536",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M77.1633 17.9916L78.5691 18.8023",
                stroke: "#C3C4C5",
                strokeWidth: "1.18536",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M81.375 16.6197C80.3639 16.8911 79.3242 16.2915 79.0528 15.2804C78.7814 14.2693 79.3811 13.2296 80.3922 12.9582C81.4033 12.6868 82.4429 13.2865 82.7143 14.2975C82.9857 15.3086 82.3861 16.3483 81.375 16.6197",
                stroke: "#C3C4C5",
                strokeWidth: "1.18536",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.943 28.049L42.7299 19.7492",
                stroke: "#A0A2A4",
                strokeWidth: "2.46765",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.0167 26.3613L37.943 28.0491",
                stroke: "#A0A2A4",
                strokeWidth: "2.46765",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.9561 22.9975L39.8825 24.6854",
                stroke: "#A0A2A4",
                strokeWidth: "2.46765",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.724 20.1423C43.6191 20.7073 41.4548 19.459 40.8898 17.3541C40.3247 15.2492 41.5731 13.0849 43.6779 12.5199C45.7828 11.9549 47.9472 13.2032 48.5122 15.308C49.0772 17.4129 47.8289 19.5773 45.724 20.1423",
                stroke: "#A0A2A4",
                strokeWidth: "2.46765",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.0235 48.9445L21.2929 50.7995C20.5492 51.0045 19.7807 50.5682 19.5758 49.8244L18.2773 45.113C18.0723 44.3692 18.5086 43.6008 19.2524 43.3958L25.983 41.5408C26.7268 41.3358 27.4952 41.7722 27.7001 42.5159L28.9987 47.2274C29.2036 47.9711 28.7673 48.7395 28.0235 48.9445Z",
                stroke: "#C3C4C5",
                strokeWidth: "1.77471",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.9255 43.2105L19.369 41.1913V41.1913C18.9592 39.7045 19.8324 38.1668 21.3192 37.757V37.757C22.806 37.3472 24.3437 38.2205 24.7535 39.7073V39.7073L25.31 41.7265",
                stroke: "#C3C4C5",
                strokeWidth: "1.77471",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M105.745 104.145L100.12 100.01C99.4985 99.5528 99.3651 98.6792 99.8221 98.0577L102.717 94.1201C103.174 93.4986 104.047 93.3652 104.669 93.8222L110.294 97.9576C110.916 98.4145 111.049 99.2881 110.592 99.9097L107.697 103.847C107.24 104.469 106.367 104.602 105.745 104.145Z",
                stroke: "#C3C4C5",
                strokeWidth: "1.77471",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M105.231 94.2356L106.472 92.5481V92.5481C107.385 91.3055 109.133 91.0387 110.376 91.9522V91.9522C111.619 92.8658 111.885 94.6138 110.972 95.8564V95.8564L109.731 97.5439",
                stroke: "#C3C4C5",
                strokeWidth: "1.77471",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M119.42 59.6071L112.689 61.4621C111.946 61.6671 111.177 61.2308 110.972 60.487L109.674 55.7756C109.469 55.0318 109.905 54.2634 110.649 54.0584L117.379 52.2034C118.123 51.9984 118.892 52.4348 119.097 53.1785L120.395 57.89C120.6 58.6337 120.164 59.4021 119.42 59.6071Z",
                stroke: "#A0A2A4",
                strokeWidth: "1.77471",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M111.322 53.8731L110.765 51.8539V51.8539C110.356 50.3671 111.229 48.8294 112.716 48.4196V48.4196C114.202 48.0098 115.74 48.8831 116.15 50.3699V50.3699L116.706 52.3891",
                stroke: "#A0A2A4",
                strokeWidth: "1.77471",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M102.965 60.0862L98.6369 63.3051C98.1586 63.6608 97.4832 63.5616 97.1275 63.0833L94.8742 60.0536C94.5186 59.5754 94.6178 58.8999 95.0961 58.5442L99.4242 55.3253C99.9025 54.9696 100.578 55.0689 100.934 55.5471L103.187 58.5768C103.543 59.0551 103.443 59.7305 102.965 60.0862Z",
                stroke: "#C3C4C5",
                strokeWidth: "1.37112",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M95.5296 58.2226L94.5639 56.9241V56.9241C93.8529 55.968 94.0515 54.6164 95.0076 53.9053V53.9053C95.9637 53.1943 97.3154 53.3929 98.0264 54.349V54.349L98.9921 55.6474",
                stroke: "#C3C4C5",
                strokeWidth: "1.37112",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5313 69.6073L7.08099 68.2086C6.58922 68.054 6.3161 67.5305 6.47066 67.0387L7.44975 63.9235C7.60431 63.4318 8.1278 63.1586 8.61956 63.3132L13.0699 64.7119C13.5617 64.8664 13.8348 65.3899 13.6802 65.8817L12.7011 68.9969C12.5466 69.4887 12.0231 69.7618 11.5313 69.6073Z",
                stroke: "#A0A2A4",
                strokeWidth: "1.18582",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.06485 63.4531L9.48446 62.118V62.118C9.79344 61.1349 10.841 60.5884 11.8241 60.8974V60.8974C12.8072 61.2063 13.3537 62.2539 13.0447 63.237V63.237L12.6251 64.5721",
                stroke: "#A0A2A4",
                strokeWidth: "1.18582",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39.7132 58.3377L36.3521 59.7831C35.9807 59.9429 35.5505 59.7714 35.3907 59.4L34.3789 57.0472C34.2192 56.6758 34.3907 56.2456 34.7621 56.0859L38.1232 54.6405C38.4946 54.4807 38.9248 54.6522 39.0845 55.0236L40.0963 57.3764C40.256 57.7478 40.0846 58.178 39.7132 58.3377Z",
                stroke: "#C3C4C5",
                strokeWidth: "0.930047",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.0987 55.9414L34.6651 54.9331V54.9331C34.3458 54.1906 34.6889 53.3297 35.4314 53.0104V53.0104C36.1738 52.6911 37.0347 53.0342 37.354 53.7767V53.7767L37.7876 54.785",
                stroke: "#C3C4C5",
                strokeWidth: "0.930047",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.4264 25.1239L89.8013 22.5515C89.1797 22.2673 88.9065 21.5336 89.1907 20.912L90.9914 16.9744C91.2756 16.3528 92.0093 16.0796 92.6309 16.3638L98.2561 18.9362C98.8776 19.2205 99.1509 19.9542 98.8666 20.5757L97.066 24.5134C96.7817 25.1349 96.048 25.4082 95.4264 25.1239Z",
                stroke: "#A0A2A4",
                strokeWidth: "1.57233",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M93.1935 16.6212L93.9652 14.9337V14.9337C94.5334 13.6911 96.0016 13.1443 97.2442 13.7125V13.7125C98.4868 14.2808 99.0336 15.749 98.4653 16.9916V16.9916L97.6936 18.6791",
                stroke: "#A0A2A4",
                strokeWidth: "1.57233",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M29.5489 102.259L22.8183 104.114C22.0746 104.319 21.3061 103.882 21.1012 103.139L19.8026 98.4272C19.5977 97.6834 20.034 96.915 20.7778 96.7101L27.5084 94.855C28.2521 94.6501 29.0206 95.0864 29.2255 95.8302L30.5241 100.542C30.729 101.285 30.2927 102.054 29.5489 102.259Z",
                stroke: "#A0A2A4",
                strokeWidth: "1.77471",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.4509 96.5247L20.8944 94.5055V94.5055C20.4846 93.0187 21.3578 91.481 22.8446 91.0712V91.0712C24.3314 90.6615 25.8691 91.5347 26.2789 93.0215V93.0215L26.8354 95.0407",
                stroke: "#A0A2A4",
                strokeWidth: "1.77471",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "65.2382",
                cy: "114.397",
                rx: "25.1337",
                ry: "1.67558",
                fill: "#C3C4C5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.9072 24.1183V20.3102V20.3102C59.9072 17.5061 62.1807 15.2327 64.9847 15.2327V15.2327C67.7888 15.2327 70.0623 17.5061 70.0623 20.3102V20.3102V24.1183",
                stroke: "#53565A",
                strokeWidth: "3.22674",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "43.8834",
                y: "28.1507",
                width: "42.7104",
                height: "77.7453",
                rx: "5.12389",
                fill: "#53565A",
                stroke: "#53565A",
                strokeWidth: "1.46397"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "45.3176",
                y: "31.1081",
                width: "36.7959",
                height: "70.3075",
                rx: "4.49933",
                stroke: "#53565A",
                strokeWidth: "1.28552"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58.3838 30.4653H69.4397C68.7621 31.8205 67.377 32.6765 65.8619 32.6765H61.9615C60.4464 32.6765 59.0614 31.8205 58.3838 30.4653Z",
                fill: "#53565A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "45.3176",
                y: "29.5847",
                width: "39.8424",
                height: "74.8773",
                rx: "4.49933",
                fill: "#F6F7F7",
                stroke: "#53565A",
                strokeWidth: "1.28552"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58.3848 29.3762H70.7016C69.9547 31.1304 68.2324 32.2691 66.3258 32.2691H62.7606C60.854 32.2691 59.1317 31.1304 58.3848 29.3762Z",
                fill: "#53565A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M67.568 55.0489L79.2346 75.4666C80.5903 77.8399 78.8766 80.7935 76.1439 80.7935H52.8107C50.0765 80.7935 48.3628 77.8399 49.72 75.4666L61.3866 55.0489C62.753 52.6559 66.2016 52.6559 67.568 55.0489Z",
                fill: "#D9A900"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64.4774 68.7294V63.0325",
                stroke: "#F6F7F7",
                strokeWidth: "3.87209",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64.4759 73.3066C64.2657 73.3066 64.0951 73.4772 64.0966 73.6874C64.0966 73.8976 64.2672 74.0682 64.4775 74.0682C64.6877 74.0682 64.8583 73.8976 64.8583 73.6874C64.8583 73.4772 64.6877 73.3066 64.4759 73.3066",
                stroke: "#F6F7F7",
                strokeWidth: "3.87209",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Bag.tsx


var Bag = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Sacola de compras" : _alt, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 22 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.99993 5V6H3.79002C2.77092 6 1.91479 6.76627 1.80225 7.77914L0.493459 19.5583C0.477162 19.705 0.468994 19.8524 0.468994 20C0.468994 22.2091 2.25986 24 4.46899 24H17.5309C17.6785 24 17.8259 23.9918 17.9726 23.9755C20.1682 23.7316 21.7504 21.7539 21.5064 19.5583L20.1976 7.77914C20.0851 6.76627 19.2289 6 18.2098 6H15.9999V5C15.9999 2.23858 13.7614 0 10.9999 0C8.23851 0 5.99993 2.23858 5.99993 5ZM15.9999 9.12692V7.5H18.2098C18.4646 7.5 18.6787 7.69157 18.7068 7.94478L20.0156 19.7239C20.1681 21.0962 19.1792 22.3322 17.807 22.4847C17.7153 22.4949 17.6231 22.5 17.5309 22.5H4.46899C3.08828 22.5 1.96899 21.3807 1.96899 20C1.96899 19.9078 1.9741 19.8156 1.98428 19.7239L3.29308 7.94478C3.32121 7.69157 3.53524 7.5 3.79002 7.5H5.99993V9.12692C5.99993 9.54114 6.33572 9.87692 6.74993 9.87692C7.16415 9.87692 7.49993 9.54114 7.49993 9.12692V7.5H14.4999V9.12692C14.4999 9.54114 14.8357 9.87692 15.2499 9.87692C15.6641 9.87692 15.9999 9.54114 15.9999 9.12692ZM14.4999 6V5C14.4999 3.067 12.9329 1.5 10.9999 1.5C9.06694 1.5 7.49993 3.067 7.49993 5V6H14.4999ZM14.0314 13.4143L9.5556 16.995L8.03026 15.4697C7.73737 15.1768 7.2625 15.1768 6.9696 15.4697C6.67671 15.7626 6.67671 16.2374 6.9696 16.5303L8.9696 18.5303C9.23983 18.8006 9.67004 18.8244 9.96846 18.5857L14.9685 14.5857C15.2919 14.3269 15.3443 13.8549 15.0856 13.5315C14.8268 13.208 14.3549 13.1556 14.0314 13.4143Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/BagIcon.tsx


var BagIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.155 */.rS.colors.primary[155] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de bolsa" : _alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18 21H6C4.895 21 4 20.105 4 19V9C4 7.895 4.895 7 6 7H18C19.105 7 20 7.895 20 9V19C20 20.105 19.105 21 18 21Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 6C9 4.343 10.343 3 12 3C13.657 3 15 4.343 15 6",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 7V6",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 7V6",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Bin.tsx


var Bin = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": "Lixeira",
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Icons / Bin",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Cores/Preto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Mask",
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M7.01496 7H9.5V4.5C9.5 3.94772 9.90294 3.5 10.4 3.5H17.6C18.0971 3.5 18.5 3.94772 18.5 4.5V7H20.9851H23.3023C23.6876 7 24 7.33579 24 7.75C24 8.16421 23.6876 8.5 23.3023 8.5H21.9499L20.1896 24.1104C20.1325 24.6169 19.698 25 19.1809 25H8.81917C8.30205 25 7.86762 24.6169 7.81051 24.1104L6.05023 8.5H4.69767C4.31236 8.5 4 8.16421 4 7.75C4 7.33579 4.31236 7 4.69767 7H7.01496ZM20.4182 8.5H7.5819L9.27335 23.5H18.7267L20.4182 8.5ZM17.15 7H10.85V5H17.15V7Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "mask0_0_2837",
                        maskUnits: "userSpaceOnUse",
                        x: "4",
                        y: "3",
                        width: "20",
                        height: "22",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Mask_2",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M7.01496 7H9.5V4.5C9.5 3.94772 9.90294 3.5 10.4 3.5H17.6C18.0971 3.5 18.5 3.94772 18.5 4.5V7H20.9851H23.3023C23.6876 7 24 7.33579 24 7.75C24 8.16421 23.6876 8.5 23.3023 8.5H21.9499L20.1896 24.1104C20.1325 24.6169 19.698 25 19.1809 25H8.81917C8.30205 25 7.86762 24.6169 7.81051 24.1104L6.05023 8.5H4.69767C4.31236 8.5 4 8.16421 4 7.75C4 7.33579 4.31236 7 4.69767 7H7.01496ZM20.4182 8.5H7.5819L9.27335 23.5H18.7267L20.4182 8.5ZM17.15 7H10.85V5H17.15V7Z",
                            fill: secondColor
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/BlackFridayBag.tsx

var BlackFridayBag = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.5029 21.845H6.4979C5.9672 21.8452 5.4582 21.6344 5.08294 21.2591C4.70768 20.8839 4.49707 20.3749 4.49707 19.8442V9.3398C4.49737 8.51115 5.16905 7.83948 5.9977 7.83917H19.0031C19.8318 7.83948 20.5034 8.51115 20.5037 9.3398V19.8442C20.5037 20.3749 20.2931 20.8839 19.9179 21.2591C19.5426 21.6344 19.0336 21.8452 18.5029 21.845Z",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.0559 14.0655L12.1101 16.0113L10.9434 14.8433",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.49805 7.83913V7.58903V7.58903C8.49805 5.51712 10.1777 3.83751 12.2496 3.83746H12.7498C14.8217 3.83751 16.5014 5.51712 16.5014 7.58903V7.58903V7.83913",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/BoxGift.tsx


var BoxGift = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-1-inside-1_620_10128",
                fill: color,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "3.33333",
                    y: "10.7333",
                    width: "17.3333",
                    height: "10.8333",
                    rx: "1"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.33333",
                y: "10.7333",
                width: "17.3333",
                height: "10.8333",
                rx: "1",
                stroke: color,
                strokeWidth: "3",
                mask: "url(#path-1-inside-1_620_10128)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.46666 6.91666C5.42666 6.91666 6.03333 3.96667 7.21667 3.28333C9.29609 2.05403 12.0233 5.3163 12 7.2C11.9178 5.4069 14.6627 2.16472 16.8 3.28334C17.9833 3.96667 18.59 6.91667 15.55 6.91667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.05 20.5833V7.3",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-4-inside-2_620_10128",
                fill: color,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "2",
                    y: "6.16667",
                    width: "20",
                    height: "6.06667",
                    rx: "1"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2",
                y: "6.16667",
                width: "20",
                height: "6.06667",
                rx: "1",
                stroke: secondColor,
                strokeWidth: "3",
                mask: "url(#path-4-inside-2_620_10128)"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/BreadcrumbArrowIcon.tsx


var BreadcrumbArrowIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Seta para direita" : _alt, _width = param.width, width = _width === void 0 ? 17 : _width, _height = param.height, height = _height === void 0 ? 16 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.16669 10.6666L9.83335 7.99996L7.16669 5.33329",
            stroke: color,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CalendarChecklistIcon.tsx


var CalendarChecklistIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.155 */.rS.colors.primary[155] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de calend\xe1rio com checklist" : _alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 13.0007H17.0019",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2.99609",
                y: "2.99658",
                width: "18.0075",
                height: "18.0075",
                rx: "3",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0036 7.99826H2.99609",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.99826 1.99609V3.99693",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0022 1.99609V3.99693",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.99805 12.7265L7.91743 13.5549L9.7682 11.8882",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 17.0022H17.0019",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.99805 16.728L7.91743 17.5563L9.7692 15.8896",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CalendarIcon.tsx


var CalendarIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 21 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.8333 3.83325H4.16667C3.24619 3.83325 2.5 4.57944 2.5 5.49992V17.1666C2.5 18.0871 3.24619 18.8333 4.16667 18.8333H15.8333C16.7538 18.8333 17.5 18.0871 17.5 17.1666V5.49992C17.5 4.57944 16.7538 3.83325 15.8333 3.83325Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.333 2.16675V5.50008",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.66699 2.16675V5.50008",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 8.83325H17.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CalendarOutlineIcon.tsx


var CalendarOutlineIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _alt = param.alt, alt = _alt === void 0 ? "Calend\xe1rio" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-labelledby": alt,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5 2V6",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5 2V6",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.5 9H21.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.5 4H5.5C4.395 4 3.5 4.895 3.5 6V19C3.5 20.105 4.395 21 5.5 21H19.5C20.605 21 21.5 20.105 21.5 19V6C21.5 4.895 20.605 4 19.5 4Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.51316 12.729C7.37516 12.729 7.26316 12.841 7.26416 12.979C7.26416 13.117 7.37616 13.229 7.51416 13.229C7.65216 13.229 7.76416 13.117 7.76416 12.979C7.76416 12.841 7.65216 12.729 7.51316 12.729",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5132 12.729C12.3752 12.729 12.2632 12.841 12.2642 12.979C12.2642 13.117 12.3762 13.229 12.5142 13.229C12.6522 13.229 12.7642 13.117 12.7642 12.979C12.7642 12.841 12.6522 12.729 12.5132 12.729",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5132 12.729C17.3752 12.729 17.2632 12.841 17.2642 12.979C17.2642 13.117 17.3762 13.229 17.5142 13.229C17.6522 13.229 17.7642 13.117 17.7642 12.979C17.7642 12.841 17.6522 12.729 17.5132 12.729",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.51316 16.729C7.37516 16.729 7.26316 16.841 7.26416 16.979C7.26416 17.117 7.37616 17.229 7.51416 17.229C7.65216 17.229 7.76416 17.117 7.76416 16.979C7.76416 16.841 7.65216 16.729 7.51316 16.729",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5132 16.729C12.3752 16.729 12.2632 16.841 12.2642 16.979C12.2642 17.117 12.3762 17.229 12.5142 17.229C12.6522 17.229 12.7642 17.117 12.7642 16.979C12.7642 16.841 12.6522 16.729 12.5132 16.729",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Camera.tsx


var Camera = function(param) {
    var _width = param.width, width = _width === void 0 ? "61" : _width, _height = param.height, height = _height === void 0 ? "61" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 61 61",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M37.0722 11.6554L39.9222 14.5054C40.3989 14.9821 41.0454 15.2498 41.7195 15.2498H48.2917C51.0991 15.2498 53.375 17.5257 53.375 20.3332V43.2082C53.375 46.0156 51.0991 48.2915 48.2917 48.2915H12.7083C9.90089 48.2915 7.625 46.0156 7.625 43.2082V20.3332C7.625 17.5257 9.90089 15.2498 12.7083 15.2498H19.2806C19.9546 15.2498 20.6011 14.9821 21.0778 14.5054L23.9278 11.6554C24.8811 10.7021 26.1741 10.1665 27.5223 10.1665H33.4777C34.8259 10.1665 36.1189 10.7021 37.0722 11.6554Z",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "11.5",
                y: "10.5",
                width: "9",
                height: "5",
                rx: "1.5",
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "12.5",
                y: "17.5",
                width: "6",
                height: "2",
                rx: "1",
                fill: color,
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "43.5",
                y: "17.5",
                width: "6",
                height: "2",
                rx: "1",
                fill: color,
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "30.4999",
                cy: "30.5002",
                r: "10.1667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.6875 30.5C26.6875 28.3944 28.3944 26.6875 30.5 26.6875",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CancellationIcon.tsx


var CancellationIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 50 : _width, _height = param.height, height = _height === void 0 ? 50 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.520 */.rS.colors.neutral[520] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.66699 6.66675L13.3337 13.3334",
                stroke: color,
                strokeWidth: "0.75",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3337 6.66675L6.66699 13.3334",
                stroke: color,
                strokeWidth: "0.75",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Card.tsx


var Card = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Cart\xe3o" : _alt, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "4.0332",
                y: "6.09996",
                width: "15.8667",
                height: "11.9667",
                rx: "1",
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "6.6333",
                y: "8.69995",
                width: "3.23333",
                height: "2.96667",
                rx: "1",
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.6167 14.75H8.40003M9.63337 14.75H11.4167M12.75 14.75H14.5334M15.8667 14.75H17.65",
                stroke: color,
                strokeLinecap: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CardHeart.tsx


var CardHeart = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.5",
                y: "5.5",
                width: "17",
                height: "12",
                rx: "1",
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.8303 9.51726L12 9.68957L12.1754 9.50416C12.4731 9.18656 12.8877 9.00445 13.3229 9.00008C13.7582 8.99571 14.1764 9.16946 14.4804 9.48102L14.5161 9.51723C15.1613 10.1803 15.1613 11.2366 14.5161 11.8997L12.7618 13.6809C12.5608 13.8851 12.2864 14 12 14C11.7135 14 11.4391 13.8851 11.2382 13.6809L9.48395 11.8997C8.83868 11.2366 8.83868 10.1803 9.48395 9.51726C9.79338 9.20291 10.216 9.0259 10.6571 9.0259C11.0982 9.0259 11.5208 9.20291 11.8303 9.51726Z",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 6L7.5 9.5",
                stroke: color,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 6L16.5 9.5",
                stroke: color,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 13L20 17",
                stroke: color,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 13L4 17",
                stroke: color,
                strokeLinecap: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CardIcon.tsx


var CardIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 15.57 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.tertiary.55 */.rS.colors.tertiary[55] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.tertiary.950 */.rS.colors.tertiary[950] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.tertiary.205 */.rS.colors.tertiary[205] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.yellow.55 */.rS.colors.yellow[55] : _fourthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 37 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 1.64384C0 0.73597 0.73597 0 1.64384 0H35.3562C36.264 0 37 0.73597 37 1.64384V22.3562C37 23.264 36.264 24 35.3562 24H1.64384C0.735973 24 0 23.264 0 22.3562V1.64384Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M35.3562 1.15068H1.64384C1.37148 1.15068 1.15068 1.37148 1.15068 1.64384V22.3562C1.15068 22.6285 1.37148 22.8493 1.64384 22.8493H35.3562C35.6285 22.8493 35.8493 22.6285 35.8493 22.3562V1.64384C35.8493 1.37148 35.6285 1.15068 35.3562 1.15068ZM1.64384 0C0.73597 0 0 0.73597 0 1.64384V22.3562C0 23.264 0.735973 24 1.64384 24H35.3562C36.264 24 37 23.264 37 22.3562V1.64384C37 0.73597 36.264 0 35.3562 0H1.64384Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 5H37V11H0V5Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M35.8493 6.15068H1.15068V9.84932H35.8493V6.15068ZM0 5V11H37V5H0Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 15C4 14.4477 4.44772 14 5 14H12C12.5523 14 13 14.4477 13 15V19C13 19.5523 12.5523 20 12 20H5C4.44772 20 4 19.5523 4 19V15Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.15068 15.1507V18.8493H11.8493V15.1507H5.15068ZM5 14C4.44772 14 4 14.4477 4 15V19C4 19.5523 4.44772 20 5 20H12C12.5523 20 13 19.5523 13 19V15C13 14.4477 12.5523 14 12 14H5Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.4995 16C19.4995 15.7239 19.7234 15.5 19.9995 15.5H30.9995C31.2757 15.5 31.4995 15.7239 31.4995 16C31.4995 16.2761 31.2757 16.5 30.9995 16.5H19.9995C19.7234 16.5 19.4995 16.2761 19.4995 16Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.4995 18.0005C19.4995 17.7243 19.7234 17.5005 19.9995 17.5005H24.9995C25.2757 17.5005 25.4995 17.7243 25.4995 18.0005C25.4995 18.2766 25.2757 18.5005 24.9995 18.5005H19.9995C19.7234 18.5005 19.4995 18.2766 19.4995 18.0005Z",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Cart.tsx


var Cart = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.1279 7.63562H20.2109C20.3721 7.63562 20.4912 7.7859 20.4543 7.94281L18.8003 14.9818C18.7738 15.0948 18.673 15.1746 18.557 15.1746H8.4998C8.38017 15.1746 8.27731 15.0899 8.25442 14.9725L6.88252 7.93345C6.85243 7.77909 6.97064 7.63562 7.1279 7.63562Z",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 3L5.33909 3.38137C5.75366 3.44897 6.08181 3.76844 6.16047 4.18105L6.83623 7.72531",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "9.38818",
                cy: "19.514",
                r: "1.73614",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16.7643",
                cy: "19.514",
                r: "1.73614",
                stroke: color,
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CartIcon.tsx


var CartIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _alt = param.alt, alt = _alt === void 0 ? "Carrinho" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        xmlns: "https://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.12329 2.26021C2.71472 2.19211 2.3283 2.46813 2.2602 2.8767C2.1921 3.28528 2.46812 3.6717 2.8767 3.7398L5.2061 4.12803C5.30728 4.1449 5.38789 4.22186 5.40943 4.32215L6.14636 7.74701L7.51827 15.1159C7.60981 15.5856 8.02127 15.9246 8.4998 15.9246H18.5569C19.0211 15.9246 19.4243 15.6052 19.5304 15.1534L21.1844 8.11437C21.3319 7.48673 20.8556 6.88562 20.2109 6.88562H7.49403L6.876 4.00725C6.72526 3.30521 6.16097 2.76649 5.4527 2.64844L3.12329 2.26021ZM9.11278 14.4246L7.81611 8.38562H19.5798L18.1608 14.4246H9.11278Z",
                fill: color
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "9.38818",
                cy: "19.514",
                r: "1.73614",
                stroke: color,
                strokeWidth: "1.5"
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16.7643",
                cy: "19.514",
                r: "1.73614",
                stroke: color,
                strokeWidth: "1.5"
            }),
            " "
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CartLogoFCBlack.tsx

var CartLogoFCBlack = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "82",
        height: "32",
        viewBox: "0 0 82 32",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.7196 4.73025C30.3221 4.73025 30.8577 4.86351 31.2585 5.19658C31.993 4.86357 32.7949 4.70397 33.6016 4.73025H35.7439V5.6629C36.7932 4.90447 38.0624 4.50692 39.3591 4.53045C41.1666 4.53045 42.6386 5.26312 43.5766 6.46284V5.39638C43.3038 4.95651 43.1643 4.44764 43.175 3.93086C43.1754 2.26572 44.5146 1 46.3222 1C48.1298 1 49.4687 2.199 49.4687 3.93104C49.4568 4.20192 49.4118 4.47036 49.3348 4.73043H50.6068C51.1667 4.72294 51.7115 4.91156 52.1458 5.2633C52.8749 4.90784 53.677 4.72544 54.4889 4.73043H58.9072C62.5224 4.73043 64.5307 6.59556 64.5307 10.0595V11.6582H65.5349V14.9214H69.2175V17.2534H74.3723C77.9874 17.2534 79.9958 19.1858 79.9958 22.5825V24.3143H81V29.2438H77.3849C76.8655 29.2544 76.3541 29.1156 75.912 28.8442C75.3094 29.1772 74.5731 29.2438 73.6358 29.2438H68.548C66.7404 29.2438 65.4015 28.6442 64.5313 27.5784C64.0626 28.3111 63.2592 28.7774 62.3221 29.1098C62.2856 29.1052 62.2486 29.1088 62.2137 29.1203C62.1789 29.1318 62.147 29.1509 62.1206 29.1763C62.0537 29.1763 61.919 29.2428 61.8527 29.2428H61.6512C60.4733 29.4628 59.2609 29.4173 58.1031 29.1096C57.759 29.0288 57.4229 28.9173 57.0989 28.7765C57.032 28.7765 57.032 28.7765 56.965 28.71C56.8981 28.71 56.8981 28.6434 56.8311 28.6434C56.8222 28.6436 56.8135 28.642 56.8053 28.6387C56.7971 28.6355 56.7896 28.6306 56.7834 28.6243C56.7771 28.6181 56.7722 28.6107 56.7689 28.6026C56.7656 28.5944 56.764 28.5857 56.7642 28.5769C56.2689 28.3871 55.7972 28.1413 55.3584 27.8442C54.2238 28.8144 52.7705 29.3359 51.2748 29.3098C49.6615 29.341 48.0998 28.7434 46.9233 27.6444V28.9103L46.2539 29.3099C44.6471 30.3757 43.1074 30.8413 41.2998 30.8413C36.6805 30.8413 33.4003 27.6439 33.4003 23.1142C33.4003 20.2499 34.6723 17.9187 36.6798 16.5862H16.5983C13.3849 16.5862 10.9748 14.5878 10.5063 11.6568H8.02929V16.5868H2.27204V6.59556H1V1.3996H13.0502V5.4631C14.0311 4.84632 15.1694 4.52263 16.3297 4.53045C18.0033 4.53045 19.4091 5.13004 20.3464 6.26231V4.73098H22.8235C23.426 4.73098 23.9616 4.86424 24.3624 5.19731C25.0969 4.8643 25.8988 4.7047 26.7055 4.73098L29.7196 4.73025Z",
                fill: "#E71C35",
                stroke: "white",
                strokeWidth: "1.33177"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46.2557 5.39639C47.2599 5.39639 47.9293 4.7968 47.9293 3.86506C47.9293 2.99913 47.2599 2.39954 46.2557 2.39954C45.2515 2.39954 44.582 2.9984 44.582 3.86433C44.6489 4.86352 45.3184 5.39639 46.2557 5.39639Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.2303 7.1284C24.0964 6.52882 23.5609 6.19575 22.9583 6.19575H21.9541V15.1885H24.6988V10.2592C24.6988 8.86045 25.6361 8.26086 26.908 8.26086H27.5105V6.12921H26.8411C25.6367 6.12921 24.6988 6.52882 24.2303 7.1284Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M52.2799 10.2592C52.2799 8.86045 53.2172 8.26086 54.489 8.26086H55.0916V6.12921H54.4221C53.2172 6.12921 52.3469 6.52882 51.8112 7.1284C51.6773 6.52882 51.1417 6.19575 50.5392 6.19575H49.5352V15.1885H52.2799V10.2592Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3975 5.92944C13.7197 5.92944 11.9121 7.86184 11.9121 10.6589C11.9121 13.3234 13.7865 15.3218 16.6652 15.3218C18.0041 15.3218 19.1422 15.0553 19.9447 14.4559V12.3242C19.0083 12.8569 18.0711 13.0574 16.9321 13.0574C15.6601 13.0574 14.7898 12.3913 14.5221 11.2588H20.2803V10.1927C20.2803 7.66131 18.8075 5.92944 16.3975 5.92944ZM14.5899 9.39317C14.8578 8.52724 15.4602 7.99437 16.3975 7.99437C17.2009 7.99437 17.7364 8.52724 17.8703 9.39317H14.5899Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.992 7.1284C30.8581 6.52882 30.3226 6.19575 29.72 6.19575H28.7158V15.1885H31.4605V10.2592C31.4605 8.86045 32.3978 8.26086 33.6697 8.26086H34.2723V6.12921H33.6028C32.3984 6.12921 31.5276 6.52882 30.992 7.1284Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46.5892 6.19574H44.9824V15.1885H47.7271V7.39474C47.7942 6.66207 47.3255 6.19574 46.5892 6.19574Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.47266 5.19658H3.20898C3.61059 5.19658 3.74451 5.32984 3.74451 5.72944V15.3885H6.62332V10.4591H10.774V8.12762H6.62332V5.19658H11.6433V2.79858H2.47266V5.19658Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M63.0586 12.5905V9.92601C63.0586 7.39476 61.7865 6.0625 58.9079 6.0625H56.2303V8.19415H58.5725C59.7774 8.19415 60.38 8.59375 60.4469 9.65967H59.6435C56.8997 9.65967 55.293 10.4589 55.293 12.5905C55.293 14.2559 56.4311 15.3216 58.2386 15.3216C59.3768 15.3216 60.0462 14.8553 60.6486 14.1891C60.9165 14.7887 61.3849 15.1218 61.9875 15.1218H64.1298V13.1234H63.5943C63.5223 13.13 63.4497 13.1207 63.3818 13.0963C63.3138 13.0718 63.252 13.0328 63.2009 12.9819C63.1498 12.9311 63.1105 12.8696 63.0859 12.802C63.0613 12.7344 63.052 12.6622 63.0586 12.5905ZM58.7071 13.3234C58.5884 13.3281 58.4698 13.3093 58.3584 13.2683C58.2469 13.2273 58.1447 13.1647 58.0576 13.0843C57.9705 13.0038 57.9002 12.907 57.8508 12.7994C57.8015 12.6919 57.7739 12.5756 57.7698 12.4574C57.7698 11.6581 58.3053 11.3917 59.5774 11.3917H60.3808C60.3808 12.524 59.7113 13.3234 58.7071 13.3234Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.5602 15.3217C40.8991 15.3217 42.0372 15.0552 42.9075 14.4558V12.3242C41.9702 12.857 40.9655 13.0568 39.8281 13.0568C38.556 13.0568 37.6858 12.3907 37.485 11.2582H43.1754C43.2609 10.8867 43.3058 10.507 43.3093 10.1258C43.3091 7.59453 41.8361 5.86267 39.3594 5.86267C36.6816 5.86267 34.874 7.79506 34.874 10.5921C34.874 13.3234 36.6816 15.3217 39.5602 15.3217ZM39.2924 7.99432C40.0957 7.99432 40.6981 8.52719 40.7652 9.39312H37.5518C37.8197 8.52719 38.355 7.99432 39.2924 7.99432Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.8197 23.3153C37.8197 20.9173 39.4265 19.5851 41.5023 19.5851C42.908 19.5851 44.0462 19.9847 45.2511 20.7841V18.2526C44.0138 17.4603 42.5713 17.0437 41.0999 17.0536C37.351 17.0536 34.874 19.6516 34.874 23.3819C34.874 27.1121 37.485 29.6436 41.3007 29.6436C42.7832 29.6633 44.2346 29.2206 45.4514 28.3778V25.7799C44.1125 26.6458 42.8404 27.0456 41.5015 27.0456C39.4263 26.979 37.8197 25.6468 37.8197 23.3153Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M67.7444 16.3875H64.9326V24.4476C64.9326 26.8456 66.4716 27.7782 68.5478 27.7782H69.8867V25.5801H68.8825C68.1462 25.5801 67.6775 25.1805 67.6775 24.2478V20.8506H70.3557V18.719H67.6773L67.7442 16.3875H67.7444Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M79.1259 25.7798C78.7243 25.7798 78.5903 25.5793 78.5903 25.247V22.6492C78.5903 20.0512 77.3183 18.7189 74.4397 18.7189H71.6279V20.8506H74.1711C75.3761 20.8506 75.9787 21.2502 76.0455 22.3161H75.1753C72.4306 22.3161 70.8916 23.1153 70.8916 25.247C70.8916 26.9123 71.9627 27.978 73.7702 27.978C74.9083 27.978 75.6447 27.4451 76.2473 26.8456C76.3247 27.1197 76.4919 27.3603 76.7223 27.5293C76.9527 27.6982 77.2332 27.7858 77.5193 27.7782H79.6616V25.7798H79.1259ZM74.2389 25.9131C73.6363 25.9131 73.2347 25.58 73.2347 25.1137C73.2347 24.3143 73.7702 23.9812 75.1091 23.9812H75.9116C75.9116 25.1137 75.2431 25.9131 74.2389 25.9131Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.2762 18.5857C48.5313 18.5857 46.4561 20.5841 46.4561 23.3151C46.4561 25.9797 48.5313 27.978 51.2762 27.978C54.0211 27.978 56.0292 25.9131 56.0292 23.2486C56.0292 20.5841 54.0209 18.5857 51.2762 18.5857ZM51.2762 25.7137C50.0712 25.7137 49.2678 24.781 49.2678 23.3157C49.2678 21.7844 50.0712 20.9177 51.2762 20.9177C52.4812 20.9177 53.2182 21.7836 53.2182 23.3157C53.2175 24.7807 52.4812 25.7137 51.2762 25.7137Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56.9663 21.3835C56.9663 22.6492 57.6357 23.3159 59.2425 23.9814C60.5146 24.5143 60.983 24.7808 60.983 25.1804C60.983 25.6468 60.7152 25.7133 60.1128 25.7133C58.9969 25.7406 57.892 25.4887 56.8994 24.9806V27.1123C57.6357 27.5786 59.0417 27.9117 60.3804 27.9117C62.3888 27.9117 63.7946 26.7792 63.7946 25.1139C63.7946 23.4486 62.5229 22.849 61.2509 22.3167C60.1128 21.7838 59.6441 21.7171 59.6441 21.3175C59.6441 20.9179 59.912 20.7846 60.6483 20.7846H63.7948V18.6524H60.4475C58.3723 18.6524 56.9663 19.6516 56.9663 21.3835Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CartOutlineIcon.tsx


var CartOutlineIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _alt = param.alt, alt = _alt === void 0 ? "Carrinho" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.43935 9.72227L4.41602 4.8916H12.8333C13.2673 4.8916 13.5853 5.29893 13.48 5.72027L12.5813 9.31494C12.4447 9.86094 11.9807 10.2623 11.4207 10.3183L6.87668 10.7729C6.19935 10.8403 5.58002 10.3876 5.43935 9.72227Z",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.41616 4.8916L3.98283 2.8916H2.8335",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9062 13.0698C11.7716 13.0698 11.6622 13.1791 11.6636 13.3138C11.6636 13.4485 11.7729 13.5578 11.9076 13.5578C12.0422 13.5578 12.1516 13.4485 12.1516 13.3138C12.1509 13.1791 12.0416 13.0698 11.9062 13.0698",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.29816 13.0695C6.16349 13.0695 6.05416 13.1788 6.05549 13.3135C6.05416 13.4488 6.16416 13.5581 6.29883 13.5581C6.43349 13.5581 6.54283 13.4488 6.54283 13.3141C6.54283 13.1788 6.43349 13.0695 6.29816 13.0695",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ChangeAddressIcon.tsx


var ChangeAddressIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _alt = param.alt, alt = _alt === void 0 ? "mudar endere\xe7o" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5 6H12C16.142 6 19.5 9.358 19.5 13.5C19.5 17.642 16.142 21 12 21C7.858 21 4.5 17.642 4.5 13.5C4.5 12.26 4.801 11.09 5.334 10.06",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 3L8.5 6L11.5 9",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ChangePasswordIcon.tsx


var ChangePasswordIcon = function(param) {
    var width = param.width, height = param.height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, alt = param.alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": alt,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.84344 11.7299C7.95083 11.8371 7.98302 11.9985 7.92498 12.1388C7.86694 12.279 7.73011 12.3705 7.57833 12.3705C7.42655 12.3705 7.28973 12.279 7.23169 12.1388C7.17365 11.9985 7.20583 11.8371 7.31322 11.7299C7.45969 11.5836 7.69697 11.5836 7.84344 11.7299",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.2595 11.7299C12.3669 11.8371 12.399 11.9985 12.341 12.1388C12.283 12.279 12.1461 12.3705 11.9943 12.3705C11.8426 12.3705 11.7057 12.279 11.6477 12.1388C11.5897 11.9985 11.6218 11.8371 11.7292 11.7299C11.8757 11.5836 12.113 11.5836 12.2595 11.7299",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.9963 19.9989V3.99219",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.9964 16.9973H4.99302C3.88799 16.9973 2.99219 16.1015 2.99219 14.9965V8.994C2.99219 7.88897 3.88799 6.99316 4.99302 6.99316H12.9964",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.9961 16.9973H18.9973C20.1024 16.9973 20.9982 16.1015 20.9982 14.9965V8.994C20.9982 7.88897 20.1024 6.99316 18.9973 6.99316H15.9961",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.4961 19.9983H18.4982",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.4961 3.99142H18.4982",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Check.tsx


var Check = function(param) {
    var _width = param.width, width = _width === void 0 ? "44" : _width, _height = param.height, height = _height === void 0 ? "44" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.265 */.rS.colors.secondary[265] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M32 13L18 32L12 25.5",
            stroke: color,
            strokeWidth: "4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CheckDone.tsx


var CheckDone = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "concluido" : _alt, _width = param.width, width = _width === void 0 ? 18 : _width, _height = param.height, height = _height === void 0 ? 18 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.265 */.rS.colors.secondary[265] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M20 6.5L9 17.5L4 12.5",
            stroke: color,
            strokeWidth: "3.0",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CheckIcon.tsx


var CheckIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 18 : _width, _height = param.height, height = _height === void 0 ? 18 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Validado" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75Z",
                fill: color,
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.4375 10.6875L6.75 9",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.25 7.875L8.4375 10.6875",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CheckValidateIcon.tsx


var CheckValidateIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.350 */.rS.colors.secondary[350] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9 3.95454L4.875 8.04545L3 6.18595",
            stroke: color,
            strokeWidth: "2",
            strokeLinecap: "square",
            strokeLinejoin: "miter"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CheckmarkCircle.tsx


var CheckmarkCircle = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "C\xedrculo de marca de Sele\xe7\xe3o" : _alt, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.secondary.28 */.rS.colors.secondary[28] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "9.00375",
                fill: secondColor,
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.44252 12.3392L10.6104 14.5071L10.5964 14.4931L15.4875 9.60205",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/ui/Icons/CircleCheckIcon.tsx


var CircleCheckIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 25 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.28 */.rS.colors.secondary[28] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12.5",
                cy: "12",
                r: "9.00375",
                fill: color,
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.9425 12.3392L11.1104 14.5071L11.0964 14.4931L15.9874 9.60205",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CircleErrorIcon.tsx


var CircleErrorIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 25 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.60 */.rS.colors.primary[60] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.primary.155 */.rS.colors.primary[155] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.5 21C7.529 21 3.5 16.971 3.5 12C3.5 7.029 7.529 3 12.5 3C17.471 3 21.5 7.029 21.5 12C21.5 16.971 17.471 21 12.5 21Z",
                fill: color,
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.33 9.17004L9.67004 14.83",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.33 14.83L9.67004 9.17004",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CircularTelephoneIcon.tsx


var CircularTelephoneIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 25 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de alian\xe7as de casamento" : _alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.65126 14.8469C11.8343 17.0309 14.6003 18.4229 16.2453 16.7849L16.6443 16.3859C17.1763 15.8549 17.1023 14.9749 16.4843 14.5459C16.0953 14.2749 15.6773 13.9839 15.2153 13.6589C14.7373 13.3229 14.0823 13.3759 13.6673 13.7869L13.2163 14.2349C12.6573 13.8809 12.1043 13.4259 11.5903 12.9129L11.5883 12.9109C11.0753 12.3979 10.6203 11.8439 10.2663 11.2849L10.7143 10.8339C11.1263 10.4199 11.1773 9.76392 10.8423 9.28592C10.5163 8.82392 10.2253 8.40592 9.95526 8.01692C9.52626 7.39992 8.64626 7.32592 8.11526 7.85692L7.71626 8.25592C6.07926 9.90092 7.47026 12.6649 9.65326 14.8499",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ClientIcon.tsx


var ClientIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.760 */.rS.colors.neutral[760] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de cliente" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.6668 16.6667V16.0417C16.6668 14.0857 15.0812 12.5 13.1252 12.5H6.87516C4.91915 12.5 3.3335 14.0857 3.3335 16.0417V16.6667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "10.0003",
                cy: "5.83333",
                rx: "3.33333",
                ry: "3.33333",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Clock.tsx


var Clock = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Icons / Clock",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "history",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "Cores/Preto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Mask",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2ZM14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5ZM18.4673 19.6083C18.7913 19.3502 18.8447 18.8784 18.5866 18.5544L14.8589 13.8745C14.7884 13.786 14.75 13.6762 14.75 13.563V6.02118C14.75 5.60697 14.4142 5.27118 14 5.27118C13.5858 5.27118 13.25 5.60697 13.25 6.02118V14.0874C13.25 14.2006 13.2884 14.3104 13.3589 14.3989L17.4134 19.4889C17.6714 19.8129 18.1433 19.8664 18.4673 19.6083Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                            id: "mask0_0_3132",
                            maskUnits: "userSpaceOnUse",
                            x: "2",
                            y: "2",
                            width: "24",
                            height: "24",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                id: "Mask_2",
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2ZM14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5ZM18.4673 19.6083C18.7913 19.3502 18.8447 18.8784 18.5866 18.5544L14.8589 13.8745C14.7884 13.786 14.75 13.6762 14.75 13.563V6.02118C14.75 5.60697 14.4142 5.27118 14 5.27118C13.5858 5.27118 13.25 5.60697 13.25 6.02118V14.0874C13.25 14.2006 13.2884 14.3104 13.3589 14.3989L17.4134 19.4889C17.6714 19.8129 18.1433 19.8664 18.4673 19.6083Z",
                                fill: secondColor
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            mask: "url(#mask0_0_3132)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "Cores/Preto_2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    id: "Rectangle",
                                    width: "28",
                                    height: "28",
                                    fill: color
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ClockIcon.tsx


var ClockIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2ZM14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5ZM18.4673 19.6083C18.7913 19.3502 18.8447 18.8784 18.5866 18.5544L14.8589 13.8745C14.7884 13.786 14.75 13.6762 14.75 13.563V6.02118C14.75 5.60697 14.4142 5.27118 14 5.27118C13.5858 5.27118 13.25 5.60697 13.25 6.02118V14.0874C13.25 14.2006 13.2884 14.3104 13.3589 14.3989L17.4134 19.4889C17.6714 19.8129 18.1433 19.8664 18.4673 19.6083Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_1346_1908",
                maskUnits: "userSpaceOnUse",
                x: "2",
                y: "2",
                width: "24",
                height: "24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2ZM14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5ZM18.4673 19.6083C18.7913 19.3502 18.8447 18.8784 18.5866 18.5544L14.8589 13.8745C14.7884 13.786 14.75 13.6762 14.75 13.563V6.02118C14.75 5.60697 14.4142 5.27118 14 5.27118C13.5858 5.27118 13.25 5.60697 13.25 6.02118V14.0874C13.25 14.2006 13.2884 14.3104 13.3589 14.3989L17.4134 19.4889C17.6714 19.8129 18.1433 19.8664 18.4673 19.6083Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_1346_1908)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: width,
                    height: height,
                    fill: color
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Close.tsx


var Close = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Fechar" : _alt, _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, click = param.click;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        onClick: click,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1181_37)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.66667 6.66669L17.3333 17.3334",
                        stroke: color,
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.3333 6.66669L6.66667 17.3334",
                        stroke: color,
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1181_37",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: width,
                        height: height,
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CloseIcon.tsx


var CloseIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.695 */.rS.colors.neutral[695] : _color, _width = param.width, width = _width === void 0 ? "24" : _width, _height = param.height, height = _height === void 0 ? "24" : _height, _alt = param.alt, alt = _alt === void 0 ? "Fechar" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 6.5L18 18.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 6.5L6 18.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Coinpig.tsx


var Coinpig = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Cofrinho" : _alt, _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.9749 4.02513C15.3417 5.39197 15.3417 7.60804 13.9749 8.97488C12.6081 10.3417 10.392 10.3417 9.02515 8.97488C7.65831 7.60804 7.65831 5.39197 9.02515 4.02513C10.392 2.65829 12.6081 2.65829 13.9749 4.02513",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0325 11.9675C17.0505 11.9854 17.0505 12.0146 17.0325 12.0325C17.0145 12.0505 16.9854 12.0505 16.9674 12.0325C16.9495 12.0146 16.9495 11.9854 16.9674 11.9675C16.9854 11.9495 17.0145 11.9495 17.0325 11.9675",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.98 6.859C15.306 6.775 15.619 6.652 15.902 6.47C16.363 6.173 16.91 6 17.5 6H18.5V8.554C19.218 9.202 19.788 10.01 20.126 10.935H21C21.552 10.935 22 11.383 22 11.935V15C22 15.552 21.552 16 21 16H19.689C19.164 16.908 18.406 17.664 17.5 18.191V20C17.5 20.552 17.052 21 16.5 21H14.5C13.948 21 13.5 20.552 13.5 20V19H10V19.868C10 20.42 9.552 20.868 9 20.868H7C6.448 20.868 6 20.42 6 19.868V17.463C4.775 16.365 4 14.775 4 13C4 10.352 5.718 8.109 8.098 7.313",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.288 10C1.819 10.273 1.5 10.776 1.5 11.358C1.5 12.229 2.206 12.935 3.077 12.935H4",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5 10H14.5",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Copy.tsx


var Copy = function(param) {
    var _width = param.width, width = _width === void 0 ? 17 : _width, _height = param.height, height = _height === void 0 ? 17 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.350 */.rS.colors.primary[350] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de copiar" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 17 17",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "4.99219",
                y: "4.91504",
                width: "9.82354",
                height: "9.33722",
                rx: "1",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.99227 11.5848H3.58891C2.81385 11.5848 2.18555 10.9876 2.18555 10.2509V3.58145C2.18555 2.84476 2.81385 2.24756 3.58891 2.24756H10.6057C11.3808 2.24756 12.0091 2.84476 12.0091 3.58145V4.91534",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/ui/Icons/CopyIcon.tsx


var CopyIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de copiar" : _alt, _width = param.width, width = _width === void 0 ? 25 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.5007 19.4031V10.8625C15.5007 10.4377 15.332 10.0303 15.0315 9.73006L12.7685 7.46712C12.4683 7.16665 12.0609 6.99792 11.6361 6.99792H6.09676C5.21274 6.99792 4.49609 7.71457 4.49609 8.59859V19.4031C4.49609 20.2871 5.21274 21.0038 6.09676 21.0038H13.9C14.784 21.0038 15.5007 20.2871 15.5007 19.4031V19.4031Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5005 17.002H18.902C19.786 17.002 20.5026 16.2854 20.5026 15.4014V4.99705C20.5026 3.89202 19.6068 2.99622 18.5018 2.99622H11.0987C10.2147 2.99622 9.49805 3.71286 9.49805 4.59688V6.99788",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.4997 10.9996H12.2984C11.8564 10.9996 11.498 10.6413 11.498 10.1993V6.99792",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CouponTag.tsx

var CouponTag = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Tag de cupom \xedcone" : _alt, _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 36 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 28 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.016 5.08005L21.3723 5.08005C22.0425 5.08005 22.5865 5.70546 22.5865 6.47605L22.5865 31.604C22.5865 32.3746 22.0425 33 21.3723 33L18.016 33C17.8399 33 17.6796 32.8855 17.6007 32.7055C16.9353 31.174 15.5753 30.208 14.0865 30.208C12.5978 30.208 11.2378 31.1754 10.5724 32.7055C10.4935 32.8855 10.3332 33 10.1571 33L6.80083 33C6.13055 33 5.58655 32.3746 5.58655 31.604L5.58655 6.47605C5.58655 5.70546 6.13055 5.08005 6.80083 5.08005L10.1571 5.08005C10.3332 5.08005 10.0782 4.89997 10.1571 5.08005C10.1292 5.01863 12.6197 5.08005 14.0865 5.08005C15.574 5.08005 16.0018 5.07866 18.016 5.08005C18.0949 4.89997 17.8399 5.08005 18.016 5.08005Z",
                fill: "#BE0F2C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.4745 12.1722L6.59814 12.1722",
                stroke: "white",
                strokeDasharray: "2 2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.25311 19.3462L9.25457 18.8683C9.25561 18.5248 9.34122 18.2124 9.51138 17.9311C9.68154 17.6497 9.92913 17.4242 10.2542 17.2545C10.5792 17.0849 10.9698 17 11.426 17C11.8963 17 12.291 17.0849 12.6103 17.2545C12.9343 17.4242 13.1805 17.6497 13.349 17.9311C13.5174 18.2124 13.6011 18.5248 13.6001 18.8683L13.5986 19.3462C13.5976 19.6813 13.512 19.9896 13.3419 20.271C13.1764 20.5524 12.9312 20.7779 12.6061 20.9475C12.2858 21.1172 11.8929 21.202 11.4273 21.202C10.9664 21.202 10.5716 21.1172 10.2429 20.9475C9.91892 20.7779 9.6727 20.5524 9.50425 20.271C9.3358 19.9896 9.25209 19.6813 9.25311 19.3462ZM10.4327 18.8683L10.4312 19.3462C10.4307 19.5117 10.4655 19.6689 10.5356 19.8179C10.6104 19.9669 10.7229 20.0869 10.8731 20.1779C11.0233 20.2689 11.2089 20.3144 11.43 20.3144C11.6557 20.3144 11.8393 20.2689 11.9806 20.1779C12.1267 20.0869 12.2352 19.9669 12.3062 19.8179C12.3772 19.6689 12.413 19.5117 12.4135 19.3462L12.4149 18.8683C12.4155 18.6986 12.3783 18.5393 12.3035 18.3903C12.2335 18.2372 12.1257 18.1152 11.9801 18.0242C11.8346 17.9331 11.649 17.8876 11.4233 17.8876C11.2069 17.8876 11.0234 17.9331 10.8726 18.0242C10.7265 18.1152 10.6156 18.2372 10.5399 18.3903C10.4689 18.5393 10.4332 18.6986 10.4327 18.8683ZM14.1898 24.4357L14.1913 23.9516C14.1923 23.6123 14.2779 23.3019 14.4481 23.0206C14.6229 22.7392 14.8729 22.5137 15.1979 22.344C15.5229 22.1744 15.9135 22.0896 16.3697 22.0896C16.84 22.0896 17.2348 22.1744 17.5541 22.344C17.8781 22.5137 18.1219 22.7392 18.2857 23.0206C18.4541 23.3019 18.5378 23.6123 18.5368 23.9516L18.5353 24.4357C18.5343 24.775 18.4487 25.0853 18.2785 25.3667C18.1131 25.6481 17.8702 25.8736 17.5499 26.0432C17.2296 26.2129 16.839 26.2977 16.3781 26.2977C15.9125 26.2977 15.5153 26.2129 15.1866 26.0432C14.8627 25.8736 14.6141 25.6481 14.4409 25.3667C14.2725 25.0853 14.1888 24.775 14.1898 24.4357ZM15.3764 23.9516L15.375 24.4357C15.3745 24.6012 15.4116 24.7584 15.4864 24.9074C15.5659 25.0564 15.6807 25.1784 15.8309 25.2736C15.9812 25.3646 16.1621 25.4102 16.3737 25.4102C16.6136 25.4102 16.8065 25.3646 16.9526 25.2736C17.0987 25.1784 17.2025 25.0584 17.2641 24.9136C17.3304 24.7647 17.3638 24.6054 17.3643 24.4357L17.3658 23.9516C17.3663 23.7819 17.3292 23.6226 17.2544 23.4737C17.1843 23.3247 17.0741 23.2047 16.9239 23.1137C16.7784 23.0226 16.5928 22.9771 16.367 22.9771C16.146 22.9771 15.9624 23.0226 15.8164 23.1137C15.6703 23.2047 15.5594 23.3247 15.4837 23.4737C15.4127 23.6226 15.3769 23.7819 15.3764 23.9516ZM16.8042 18.4214L11.767 25.4846L10.9006 25.044L15.9378 17.9807L16.8042 18.4214Z",
                fill: "white"
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/ui/Icons/CouponTicket.tsx


var CouponTicket = function(param) {
    var _width = param.width, width = _width === void 0 ? 223 : _width, _height = param.height, height = _height === void 0 ? 37 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.350 */.rS.colors.primary[350] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de ticket de cupom" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 223 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-1-inside-1_370_71302",
                fill: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.0682 0.75058H221C222.105 0.75058 223 1.64601 223 2.75058V34.2502C223 35.3548 222.105 36.2502 221 36.2502H15.6116L13.0373 33.8626L12.2692 33.2775C12.1374 33.1771 11.9238 33.1771 11.792 33.2775L10.5253 34.2425L8.41786 36.2502H2C0.895426 36.2502 0 35.3548 0 34.2502V2.75058C0 1.64601 0.895431 0.75058 2 0.75058H6.80806C6.80793 0.750387 6.80779 0.750193 6.80766 0.75H7.85117L7.85193 0.75058H8.94248L12.1333 3.70987C12.1485 3.70161 12.1631 3.69227 12.1768 3.68184L12.5312 3.41181L15.3246 0.75058H16.0244L16.0251 0.75H17.0686C17.0685 0.750193 17.0684 0.750387 17.0682 0.75058Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0682 0.75058H221C222.105 0.75058 223 1.64601 223 2.75058V34.2502C223 35.3548 222.105 36.2502 221 36.2502H15.6116L13.0373 33.8626L12.2692 33.2775C12.1374 33.1771 11.9238 33.1771 11.792 33.2775L10.5253 34.2425L8.41786 36.2502H2C0.895426 36.2502 0 35.3548 0 34.2502V2.75058C0 1.64601 0.895431 0.75058 2 0.75058H6.80806C6.80793 0.750387 6.80779 0.750193 6.80766 0.75H7.85117L7.85193 0.75058H8.94248L12.1333 3.70987C12.1485 3.70161 12.1631 3.69227 12.1768 3.68184L12.5312 3.41181L15.3246 0.75058H16.0244L16.0251 0.75H17.0686C17.0685 0.750193 17.0684 0.750387 17.0682 0.75058Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0682 0.75058L14.6114 -0.971077L11.3026 3.75058H17.0682V0.75058ZM15.6116 36.2502L13.5716 38.4499L14.4346 39.2502H15.6116V36.2502ZM13.0373 33.8626L15.0773 31.663L14.9708 31.5643L14.8553 31.4763L13.0373 33.8626ZM12.2692 33.2775L14.0873 30.8911L14.0873 30.8911L12.2692 33.2775ZM11.792 33.2775L9.97394 30.8911L9.97393 30.8911L11.792 33.2775ZM10.5253 34.2425L8.70724 31.8562L8.5757 31.9564L8.45596 32.0704L10.5253 34.2425ZM8.41786 36.2502V39.2502H9.61814L10.4872 38.4223L8.41786 36.2502ZM6.80806 0.75058V3.75058H12.5504L9.27057 -0.962917L6.80806 0.75058ZM6.80766 0.75V-2.25H1.06639L4.3449 2.46313L6.80766 0.75ZM7.85117 0.75L9.6693 -1.6363L8.86381 -2.25H7.85117V0.75ZM7.85193 0.75058L6.0338 3.13687L6.83929 3.75058H7.85193V0.75058ZM8.94248 0.75058L10.9825 -1.44903L10.1195 -2.24942H8.94248V0.75058ZM12.1333 3.70987L10.0932 5.90948L11.6697 7.37157L13.5608 6.34847L12.1333 3.70987ZM12.1768 3.68184L10.3587 1.29547L10.3587 1.29547L12.1768 3.68184ZM12.5312 3.41181L14.3493 5.79817L14.4808 5.69796L14.6005 5.58389L12.5312 3.41181ZM15.3246 0.75058V-2.24942H14.1243L13.2553 -1.4215L15.3246 0.75058ZM16.0244 0.75058V3.75058H17.037L17.8425 3.13687L16.0244 0.75058ZM16.0251 0.75V-2.25H15.0125L14.207 -1.6363L16.0251 0.75ZM17.0686 0.75L19.5371 2.45491L22.7867 -2.25H17.0686V0.75ZM221 -2.24942H17.0682V3.75058H221V-2.24942ZM226 2.75058C226 -0.0108446 223.761 -2.24942 221 -2.24942V3.75058C220.448 3.75058 220 3.30287 220 2.75058H226ZM226 34.2502V2.75058H220V34.2502H226ZM221 39.2502C223.761 39.2502 226 37.0117 226 34.2502H220C220 33.698 220.448 33.2502 221 33.2502V39.2502ZM15.6116 39.2502H221V33.2502H15.6116V39.2502ZM10.9972 36.0622L13.5716 38.4499L17.6517 34.0506L15.0773 31.663L10.9972 36.0622ZM14.8553 31.4763L14.0873 30.8911L10.4512 35.6639L11.2192 36.249L14.8553 31.4763ZM14.0873 30.8911C12.8815 29.9726 11.1797 29.9726 9.97394 30.8911L13.61 35.6639C13.0698 36.0754 12.4876 36.2022 12.0306 36.2022C11.5736 36.2022 10.9914 36.0754 10.4512 35.6639L14.0873 30.8911ZM9.97393 30.8911L8.70724 31.8562L12.3433 36.6289L13.61 35.6639L9.97393 30.8911ZM10.4872 38.4223L12.5946 36.4146L8.45596 32.0704L6.34854 34.0782L10.4872 38.4223ZM2 39.2502H8.41786V33.2502H2V39.2502ZM-3 34.2502C-3 37.0117 -0.761437 39.2502 2 39.2502V33.2502C2.55229 33.2502 3 33.698 3 34.2502H-3ZM-3 2.75058V34.2502H3V2.75058H-3ZM2 -2.24942C-0.761427 -2.24942 -3 -0.010839 -3 2.75058H3C3 3.30286 2.55229 3.75058 2 3.75058V-2.24942ZM6.80806 -2.24942H2V3.75058H6.80806V-2.24942ZM9.27057 -0.962917C9.27052 -0.962987 9.27047 -0.963057 9.27042 -0.963127L4.3449 2.46313C4.34512 2.46344 4.34534 2.46376 4.34556 2.46408L9.27057 -0.962917ZM6.80766 3.75H7.85117V-2.25H6.80766V3.75ZM6.03304 3.1363L6.0338 3.13687L9.67006 -1.63572L9.6693 -1.6363L6.03304 3.1363ZM8.94248 -2.24942H7.85193V3.75058H8.94248V-2.24942ZM14.1733 1.51027L10.9825 -1.44903L6.90245 2.95019L10.0932 5.90948L14.1733 1.51027ZM13.5608 6.34847C13.7062 6.26981 13.852 6.17697 13.9948 6.0682L10.3587 1.29547C10.4741 1.20756 10.5909 1.13341 10.7057 1.07127L13.5608 6.34847ZM13.9948 6.0682L14.3493 5.79817L10.7132 1.02544L10.3587 1.29547L13.9948 6.0682ZM13.2553 -1.4215L10.4619 1.23973L14.6005 5.58389L17.3939 2.92266L13.2553 -1.4215ZM16.0244 -2.24942H15.3246V3.75058H16.0244V-2.24942ZM17.8425 3.13687L17.8433 3.1363L14.207 -1.6363L14.2062 -1.63572L17.8425 3.13687ZM16.0251 3.75H17.0686V-2.25H16.0251V3.75ZM14.6002 -0.954911C14.5999 -0.954549 14.6013 -0.956543 14.603 -0.958921C14.6048 -0.961519 14.6077 -0.965795 14.6114 -0.971077L19.525 2.47224C19.5289 2.46676 19.532 2.46229 19.5339 2.4595C19.5349 2.45808 19.5357 2.45692 19.5362 2.45618C19.5367 2.45549 19.5371 2.45491 19.5371 2.45491L14.6002 -0.954911Z",
                fill: color,
                mask: "url(#path-1-inside-1_370_71302)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 5.4585V34.1479",
                stroke: "white",
                strokeDasharray: "2 2"
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/ui/Icons/CreditCard.tsx


var CreditCard = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0021 18.0025V12C17.0022 11.4693 16.7915 10.9603 16.4162 10.585C16.0409 10.2098 15.5319 9.999 15.0012 9.99915H4.99708C4.46638 9.999 3.95738 10.2098 3.58212 10.585C3.20686 10.9603 2.9961 11.4693 2.99625 12V18.0025C2.9961 18.5332 3.20686 19.0422 3.58212 19.4174C3.95738 19.7927 4.46638 20.0035 4.99708 20.0033H15.0012C16.1063 20.0033 17.0021 19.1075 17.0021 18.0025Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.99625 14.0799H17.0021",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.19757 9.99913L7.40807 5.47724C7.54542 4.96477 7.88105 4.52801 8.34089 4.26337C8.80074 3.99872 9.34699 3.92794 9.8591 4.06665L19.5231 6.65773C20.0356 6.79508 20.4724 7.13071 20.737 7.59055C21.0016 8.05039 21.0724 8.59665 20.9337 9.10875L19.3831 14.9012C19.1071 15.9436 18.0521 16.5776 17.0021 16.3318",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var CreditCard_CartIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? theme.colors.neutral["999"] : _color;
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "https://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.12329 2.26021C2.71472 2.19211 2.3283 2.46813 2.2602 2.8767C2.1921 3.28528 2.46812 3.6717 2.8767 3.7398L5.2061 4.12803C5.30728 4.1449 5.38789 4.22186 5.40943 4.32215L6.14636 7.74701L7.51827 15.1159C7.60981 15.5856 8.02127 15.9246 8.4998 15.9246H18.5569C19.0211 15.9246 19.4243 15.6052 19.5304 15.1534L21.1844 8.11437C21.3319 7.48673 20.8556 6.88562 20.2109 6.88562H7.49403L6.876 4.00725C6.72526 3.30521 6.16097 2.76649 5.4527 2.64844L3.12329 2.26021ZM9.11278 14.4246L7.81611 8.38562H19.5798L18.1608 14.4246H9.11278Z",
                fill: color
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9.38818",
                cy: "19.514",
                r: "1.73614",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16.7643",
                cy: "19.514",
                r: "1.73614",
                stroke: color,
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DefaultCard.tsx


var DefaultCard = function(param) {
    var _width = param.width, width = _width === void 0 ? 65 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _alt = param.alt, alt = _alt === void 0 ? "Default Card" : _alt, _color = param.color, color = _color === void 0 ? "".concat(themes/* theme.colors.neutral.25 */.rS.colors.neutral[25]) : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.primary.200 */.rS.colors.primary[200] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 65 40",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.75",
                y: "0.75",
                width: "63.5",
                height: "38.5",
                rx: "3.25",
                fill: color,
                stroke: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "8",
                width: "63",
                height: "7",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "5",
                y: "25",
                width: "21",
                height: "7",
                rx: "2",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "35",
                y: "25",
                width: "22",
                height: "2",
                rx: "1",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "35",
                y: "29",
                width: "18",
                height: "2",
                rx: "1",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DefaultProduct.tsx


var DefaultProductImage = function(param) {
    var _width = param.width, width = _width === void 0 ? 160 : _width, _height = param.height, height = _height === void 0 ? 160 : _height, _alt = param.alt, alt = _alt === void 0 ? "Imagem padr\xe3o de produto" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.88 */.rS.colors.neutral[88] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 160 160",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "20",
                y: "20",
                width: "120",
                height: "120",
                rx: "12",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M93.8933 43.9172L93.9172 43.8933C99.1285 38.6952 107.566 38.7033 112.767 43.9112C117.969 49.1192 117.966 57.5568 112.761 62.7614C107.557 67.9661 99.1192 67.9688 93.9112 62.7674C88.7033 57.5661 88.6952 49.1285 93.8933 43.9172Z",
                fill: secondColor,
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.2001 126.8V108.065V93.698C23.2001 87.6367 36.1461 75.5545 42.1333 72.1469C45.2887 70.351 51.6 68.5551 57.9112 70.351C62.5032 71.6577 73.334 78.2307 78.4222 81.1265C84.7333 84.7184 90.5911 89.2906 97.3555 91.902C104.591 94.6954 119.444 93.698 125.755 86.5143C132.067 79.3306 136.666 55.7046 136.666 55.7046L136.571 126.813C136.563 132.331 132.088 136.8 126.571 136.8H33.2001C27.6772 136.8 23.2001 132.323 23.2001 126.8Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M136.8 48.8L136.666 55.7046M136.666 55.7046L136.571 126.813C136.563 132.331 132.088 136.8 126.571 136.8H33.2001C27.6772 136.8 23.2001 132.323 23.2001 126.8V108.065C23.2001 105.671 23.2 102.678 23.2001 93.698C23.2001 87.6367 36.1461 75.5545 42.1333 72.1469C45.2888 70.351 51.6 68.5551 57.9112 70.351C62.5032 71.6577 73.334 78.2307 78.4222 81.1265C84.7333 84.7184 90.5911 89.2906 97.3555 91.902C104.591 94.6954 119.444 93.698 125.755 86.5143C132.067 79.3306 136.666 55.7046 136.666 55.7046Z",
                stroke: color,
                strokeWidth: "4"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DeliveredPackageTrackingStatusIcon.tsx


var DeliveredPackageTrackingStatusIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Pacote Entregue" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.9979 23.5032H9.33051C8.87008 23.5032 8.49683 23.1299 8.49683 22.6695V17.6674C8.49683 17.207 8.87008 16.8337 9.33051 16.8337H10.9979C11.4583 16.8337 11.8315 17.207 11.8315 17.6674V22.6695C11.8315 23.1299 11.4583 23.5032 10.9979 23.5032Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.2506 9.33057V13.1655",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.6694 17.6674V14.366C22.6671 13.7027 22.1289 13.166 21.4656 13.1655H13.0354C12.372 13.166 11.8338 13.7027 11.8315 14.366V18.5845",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.8315 17.6674V12.6411C11.8317 12.3159 11.8975 11.9941 12.025 11.6949L12.6844 10.1526C12.8975 9.65386 13.3876 9.33039 13.9299 9.33057H20.5702C21.1142 9.32883 21.6066 9.65248 21.8207 10.1526L22.4801 11.6966C22.6064 11.996 22.6707 12.3179 22.6694 12.6428V18.0717",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.8336 20.1683H18.7786C19.1394 20.1683 19.4904 20.0513 19.779 19.8348L21.7932 18.3242C22.296 17.9473 22.9995 17.9974 23.4439 18.4418V18.4418C23.6808 18.6785 23.8139 18.9997 23.8139 19.3346C23.8139 19.6696 23.6808 19.9908 23.4439 20.2275L21.7157 21.9557C21.2501 22.4213 20.6572 22.7386 20.0116 22.8678L17.5689 23.3563C17.0847 23.4531 16.5849 23.4412 16.1058 23.3213L13.8966 22.7694C13.6325 22.7028 13.3611 22.6692 13.0887 22.6693H11.8315",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.8336 20.1685H18.0716C18.7692 20.1685 19.3347 19.603 19.3347 18.9054V18.6553C19.3347 18.076 18.9405 17.5711 18.3784 17.4307L16.4676 16.953C16.1572 16.8746 15.8383 16.8346 15.5181 16.8337V16.8337C14.7451 16.8335 13.9893 17.0624 13.3463 17.4915L11.8315 18.5011",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DeliveringTrackingStatusIcon.tsx


var DeliveringTrackingStatusIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Saiu para entrega" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.0715 17.7261H17.627C17.1668 17.7261 16.7937 17.353 16.7937 16.8928V14.3333",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "21.4167",
                cy: "22.25",
                rx: "1.25",
                ry: "1.25",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.3333 14.3333H17.1805C18.3608 14.3333 19.4723 14.889 20.1805 15.8333L21.0813 17.0344C21.2366 17.2414 21.4379 17.4094 21.6693 17.5251L23.4119 18.3964C23.9766 18.6787 24.3333 19.2558 24.3333 19.8871V21.2083C24.3333 21.7835 23.8669 22.2499 23.2916 22.2499H22.6666",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1667 22.2499H17.6667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.3318 23.5001H12.2484C12.0274 23.5001 11.8155 23.4122 11.6594 23.2559C11.5032 23.0995 11.4157 22.8875 11.416 22.6665V20.5831C11.416 20.3621 11.5039 20.1502 11.6602 19.9941C11.8166 19.8379 12.0287 19.7504 12.2496 19.7507H14.333C14.554 19.7507 14.7659 19.8386 14.922 19.995C15.0782 20.1513 15.1657 20.3634 15.1654 20.5843V22.6678C15.1654 22.8887 15.0775 23.1006 14.9212 23.2568C14.7648 23.4129 14.5528 23.5004 14.3318 23.5001Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.5825 23.5001H8.50036C8.27919 23.5004 8.067 23.4126 7.91062 23.2562C7.75423 23.0999 7.66649 22.8877 7.66675 22.6665V20.5831C7.66675 20.3621 7.75461 20.1502 7.91098 19.9941C8.06735 19.8379 8.27938 19.7504 8.50036 19.7507H10.5838C10.8047 19.7507 11.0166 19.8386 11.1728 19.995C11.3289 20.1513 11.4165 20.3634 11.4161 20.5843V22.6678C11.4161 22.8887 11.3283 23.1006 11.1719 23.2568C11.0155 23.4129 10.8035 23.5004 10.5825 23.5001V23.5001Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.457 19.7506H10.3736C10.1525 19.7507 9.94048 19.6629 9.78414 19.5065C9.6278 19.3502 9.53999 19.1381 9.54004 18.917V16.8336C9.53998 16.6125 9.62779 16.4004 9.78414 16.2441C9.94048 16.0878 10.1525 15.9999 10.3736 16H12.457C12.6782 15.9999 12.8902 16.0878 13.0466 16.2441C13.2029 16.4004 13.2907 16.6125 13.2907 16.8336V18.917C13.2909 19.1382 13.2032 19.3504 13.0468 19.5068C12.8904 19.6632 12.6782 19.7509 12.457 19.7506V19.7506Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.5 14.3334V12.6993C23.5 11.9427 23.0898 11.2456 22.4285 10.8781L17.2146 7.98139C16.4595 7.56187 15.5413 7.56187 14.7863 7.98139L9.57154 10.8786C8.91018 11.246 8.5 11.9432 8.5 12.6997V13.5001",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DeliveryTruckPinIcon.tsx


var DeliveryTruckPinIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.350 */.rS.colors.neutral[350] : _color, _alt = param.alt, alt = _alt === void 0 ? "Caminh\xe3o de entrega com pino de localiza\xe7\xe3o" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.3333 11.6632H15.4167C15.1865 11.6632 15 11.4766 15 11.2465V8.32983H17.6667",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.464 15.3661C15.8215 15.7236 15.9284 16.2612 15.735 16.7283C15.5415 17.1954 15.0858 17.5 14.5802 17.5C14.0746 17.5 13.6188 17.1955 13.4253 16.7284C13.2318 16.2614 13.3387 15.7237 13.6962 15.3662L13.6963 15.3661C14.1844 14.878 14.9758 14.878 15.4639 15.3661V15.3661",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.29696 15.3662C6.65448 15.7237 6.76145 16.2613 6.568 16.7284C6.37454 17.1955 5.91876 17.5001 5.41319 17.5001C4.90761 17.5002 4.4518 17.1956 4.2583 16.7285C4.0648 16.2615 4.17171 15.7238 4.52919 15.3663V15.3663L4.52944 15.366C5.01749 14.878 5.80876 14.878 6.2968 15.366L6.29694 15.3662V15.3662",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.401 15.8334H6.5918",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.7587 15.8333H17.5C17.9602 15.8333 18.3333 15.4602 18.3333 14.9999V10.3176C18.3333 10.1057 18.2929 9.89576 18.2142 9.699L17.0852 6.87743C16.8321 6.24472 16.2193 5.82984 15.5378 5.82983H12.5",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.23498 15.8333H2.50033C2.04009 15.8333 1.66699 15.4602 1.66699 15V10",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.66699 12.4967H11.667C12.1272 12.4967 12.5003 12.1236 12.5003 11.6633V4.99666C12.5003 4.53643 12.1272 4.16333 11.667 4.16333H10.0003",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.66699 4.58325C1.66699 5.94869 3.15699 7.40727 4.00699 8.12855C4.34268 8.40149 4.82381 8.40149 5.15949 8.12855C6.01033 7.40727 7.50033 5.94869 7.50033 4.58325",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.58449 4.36675C4.70405 4.36721 4.80063 4.46442 4.80033 4.58397C4.80002 4.70353 4.70294 4.80024 4.58338 4.80009C4.46383 4.79993 4.36699 4.70297 4.36699 4.58342C4.36669 4.52572 4.38953 4.4703 4.43041 4.42958C4.47129 4.38885 4.52679 4.36622 4.58449 4.36675",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.66699 4.58342V4.58342C1.66699 2.97258 2.97283 1.66675 4.58366 1.66675V1.66675C6.19449 1.66675 7.50033 2.97258 7.50033 4.58342V4.58342",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/ui/Icons/DeviceAccountIcon.tsx


var DeviceAccountIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "221" : _width, _height = param.height, height = _height === void 0 ? "171" : _height, alt = param.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 221 171",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": alt,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "70",
                cy: "100.539",
                r: "69.5",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M37.2652 86.4754C35.5007 86.4754 34.0693 87.8113 34.0693 89.459C34.0693 91.1066 35.5007 92.4417 37.2652 92.4417H46.0547C47.82 92.4417 49.2514 91.1058 49.2514 89.459C49.2514 87.8121 47.82 86.4762 46.0556 86.4762C46.0556 84.2106 44.0878 82.374 41.6604 82.374C39.2329 82.374 37.2652 84.2098 37.2652 86.4754Z",
                    stroke: "#A0A2A4",
                    strokeWidth: "0.830869",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.9741 104.019C11.2096 104.019 9.77832 105.355 9.77832 107.003C9.77832 108.651 11.2096 109.986 12.9741 109.986H21.7637C23.529 109.986 24.9604 108.65 24.9604 107.003C24.9604 105.356 23.529 104.02 21.7645 104.02C21.7645 101.755 19.7968 99.918 17.3693 99.918C14.9419 99.918 12.9741 101.754 12.9741 104.019Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M93.9448 148.553C92.1804 148.553 90.749 149.888 90.749 151.536C90.749 153.184 92.1804 154.519 93.9448 154.519H102.734C104.5 154.519 105.931 153.183 105.931 151.536C105.931 149.889 104.5 148.553 102.735 148.553C102.735 146.288 100.767 144.451 98.34 144.451C95.9126 144.451 93.9448 146.287 93.9448 148.553Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.830869",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M26.4683 124.262C24.7038 124.262 23.2725 125.597 23.2725 127.245C23.2725 128.893 24.7038 130.228 26.4683 130.228H35.2578C37.0232 130.228 38.4545 128.892 38.4545 127.245C38.4545 125.598 37.0232 124.262 35.2587 124.262C35.2587 121.997 33.2909 120.16 30.8635 120.16C28.436 120.16 26.4683 121.996 26.4683 124.262Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.830869",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M120.935 117.514C119.171 117.514 117.739 118.85 117.739 120.498C117.739 122.146 119.171 123.481 120.935 123.481H129.725C131.49 123.481 132.921 122.145 132.921 120.498C132.921 118.851 131.49 117.515 129.725 117.515C129.725 115.25 127.758 113.413 125.33 113.413C122.903 113.413 120.935 115.249 120.935 117.514Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.830869",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M87.1968 45.9901C85.4323 45.9901 84.001 47.326 84.001 48.9736C84.001 50.6213 85.4323 51.9564 87.1968 51.9564H95.9864C97.7517 51.9564 99.183 50.6205 99.183 48.9736C99.183 47.3268 97.7517 45.9909 95.9872 45.9909C95.9872 43.7252 94.0194 41.8887 91.592 41.8887C89.1646 41.8887 87.1968 43.7245 87.1968 45.9901Z",
                    stroke: "#8F9194",
                    strokeWidth: "0.830869",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M115.539 70.2811C113.774 70.2811 112.343 71.617 112.343 73.2646C112.343 74.9123 113.774 76.2474 115.539 76.2474H124.328C126.093 76.2474 127.525 74.9115 127.525 73.2646C127.525 71.6178 126.093 70.2819 124.329 70.2819C124.329 68.0163 122.361 66.1797 119.934 66.1797C117.506 66.1797 115.539 68.0155 115.539 70.2811Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M101.863 104.374C100.569 104.374 99.5195 105.328 99.5195 106.505C99.5195 107.682 100.569 108.636 101.863 108.636H108.309C109.603 108.636 110.653 107.681 110.653 106.505C110.653 105.329 109.603 104.374 108.309 104.374C108.309 102.756 106.866 101.444 105.086 101.444C103.306 101.444 101.863 102.756 101.863 104.374Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M50.5819 42.2968C49.2879 42.2968 48.2383 43.251 48.2383 44.4279C48.2383 45.6048 49.2879 46.5584 50.5819 46.5584H57.0276C58.3221 46.5584 59.3718 45.6042 59.3718 44.4279C59.3718 43.2515 58.3221 42.2973 57.0282 42.2973C57.0282 40.679 55.5852 39.3672 53.805 39.3672C52.0249 39.3672 50.5819 40.6785 50.5819 42.2968Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M41.1366 150.258C39.8426 150.258 38.793 151.212 38.793 152.389C38.793 153.566 39.8426 154.519 41.1366 154.519H47.5822C48.8768 154.519 49.9265 153.565 49.9265 152.389C49.9265 151.212 48.8768 150.258 47.5829 150.258C47.5829 148.64 46.1398 147.328 44.3597 147.328C42.5796 147.328 41.1366 148.639 41.1366 150.258Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M27.6405 63.8886C26.3465 63.8886 25.2969 64.8428 25.2969 66.0197C25.2969 67.1966 26.3465 68.1502 27.6405 68.1502H34.0862C35.3807 68.1502 36.4304 67.196 36.4304 66.0197C36.4304 64.8433 35.3807 63.8891 34.0868 63.8891C34.0868 62.2708 32.6437 60.959 30.8636 60.959C29.0835 60.959 27.6405 62.2703 27.6405 63.8886Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "70.0115",
                cy: "142.125",
                rx: "17.4393",
                ry: "1.16711",
                fill: "black",
                fillOpacity: "0.4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M57.1434 54.6973H81.8267C88.4389 54.6973 93.7944 60.0735 93.7944 66.7112V120.774C93.7944 127.412 88.4389 132.788 81.8267 132.788H57.1434C50.5313 132.788 45.1758 127.412 45.1758 120.774V66.7112C45.1758 60.0735 50.5313 54.6973 57.1434 54.6973Z",
                fill: "#F6F7F7",
                stroke: "#53565A",
                strokeWidth: "4.76405",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M64.2344 119.273H74.7061H64.2344Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64.2344 119.273H74.7061",
                stroke: "#53565A",
                strokeWidth: "4.76405",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "69.4866",
                cy: "79.1014",
                rx: "8.4554",
                ry: "8.4881",
                fill: "#F8FCF6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "72.5162",
                cy: "90.1795",
                rx: "6.07282",
                ry: "2.02427",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M75.6549 72.9115C79.0601 76.3299 79.0601 81.8722 75.6549 85.2905C72.2496 88.7089 66.7287 88.7089 63.3235 85.2905C59.9182 81.8721 59.9182 76.3298 63.3235 72.9115C66.7287 69.4931 72.2496 69.4931 75.6549 72.9115",
                stroke: "#252728",
                strokeWidth: "1.79982",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M71.4162 75.5259C72.4805 76.5944 72.4805 78.3267 71.4162 79.3951C70.3518 80.4635 68.6262 80.4635 67.5619 79.3951C66.4976 78.3267 66.4976 76.5944 67.5619 75.5259C68.6262 74.4575 70.3518 74.4575 71.4162 75.5259Z",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M71.4162 75.5259C72.4805 76.5944 72.4805 78.3267 71.4162 79.3951C70.3518 80.4635 68.6262 80.4635 67.5619 79.3951C66.4976 78.3267 66.4976 76.5944 67.5619 75.5259C68.6262 74.4575 70.3518 74.4575 71.4162 75.5259",
                stroke: "#252728",
                strokeWidth: "1.79982",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M75.0174 85.8682C73.6271 84.3986 71.6662 83.4775 69.4882 83.4775C67.3102 83.4775 65.3493 84.3986 63.959 85.8692",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M75.0174 85.8682C73.6271 84.3986 71.6662 83.4775 69.4882 83.4775C67.3102 83.4775 65.3493 84.3986 63.959 85.8692",
                stroke: "#252728",
                strokeWidth: "1.79982",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.17",
                d: "M218.289 62.5086L80.7683 104.032L59.6304 96.3869L144.064 29.5103L218.289 62.5086Z",
                fill: "url(#paint0_linear_2364_388677)",
                stroke: "#68A439",
                strokeWidth: "1.34951"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "140.143",
                y: "25.9893",
                width: "80.3263",
                height: "36.0744",
                rx: "5.23584",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M163.673 43.5147C163.673 43.079 163.323 42.7273 162.889 42.7305C162.455 42.7305 162.104 43.0823 162.104 43.5179C162.104 43.9536 162.455 44.3054 162.889 44.3054C163.319 44.3054 163.673 43.9536 163.673 43.5147Z",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M163.673 43.5147C163.673 43.079 163.323 42.7273 162.889 42.7305C162.455 42.7305 162.104 43.0823 162.104 43.5179C162.104 43.9536 162.455 44.3054 162.889 44.3054C163.319 44.3054 163.673 43.9536 163.673 43.5147",
                stroke: "#FEF4F5",
                strokeWidth: "6.46981",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M176.534 43.5147C176.534 43.079 176.184 42.7273 175.75 42.7305C175.316 42.7305 174.966 43.0823 174.966 43.5179C174.966 43.9536 175.316 44.3054 175.75 44.3054C176.181 44.3054 176.534 43.9536 176.534 43.5147Z",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M176.534 43.5147C176.534 43.079 176.184 42.7273 175.75 42.7305C175.316 42.7305 174.966 43.0823 174.966 43.5179C174.966 43.9536 175.316 44.3054 175.75 44.3054C176.181 44.3054 176.534 43.9536 176.534 43.5147",
                stroke: "#FEF4F5",
                strokeWidth: "6.46981",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M189.392 43.5147C189.392 43.079 189.041 42.7273 188.607 42.7305C188.173 42.7305 187.823 43.0823 187.823 43.5179C187.823 43.9536 188.173 44.3054 188.607 44.3054C189.038 44.3054 189.392 43.9536 189.392 43.5147Z",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M189.392 43.5147C189.392 43.079 189.041 42.7273 188.607 42.7305C188.173 42.7305 187.823 43.0823 187.823 43.5179C187.823 43.9536 188.173 44.3054 188.607 44.3054C189.038 44.3054 189.392 43.9536 189.392 43.5147",
                stroke: "#FEF4F5",
                strokeWidth: "6.46981",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M202.249 43.5147C202.249 43.079 201.899 42.7273 201.465 42.7305C201.031 42.7305 200.68 43.0823 200.68 43.5179C200.68 43.9536 201.031 44.3054 201.465 44.3054C201.899 44.3054 202.249 43.9536 202.249 43.5147Z",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M202.249 43.5147C202.249 43.079 201.899 42.7273 201.465 42.7305C201.031 42.7305 200.68 43.0823 200.68 43.5179C200.68 43.9536 201.031 44.3054 201.465 44.3054C201.899 44.3054 202.249 43.9536 202.249 43.5147",
                stroke: "#FEF4F5",
                strokeWidth: "6.46981",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "57.8594",
                y: "95.0146",
                width: "23.6254",
                height: "10.6101",
                rx: "1.53995",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M64.7777 100.17C64.7777 100.042 64.6746 99.9383 64.547 99.9393C64.4193 99.9393 64.3163 100.043 64.3163 100.171C64.3163 100.299 64.4193 100.402 64.547 100.402C64.6737 100.402 64.7777 100.299 64.7777 100.17Z",
                fill: "#5C5E62"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64.7777 100.17C64.7777 100.042 64.6746 99.9383 64.547 99.9393C64.4193 99.9393 64.3163 100.043 64.3163 100.171C64.3163 100.299 64.4193 100.402 64.547 100.402C64.6737 100.402 64.7777 100.299 64.7777 100.17",
                stroke: "#36383B",
                strokeWidth: "1.90289",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M68.5629 100.17C68.5629 100.042 68.4598 99.9383 68.3321 99.9393C68.2045 99.9393 68.1014 100.043 68.1014 100.171C68.1014 100.299 68.2045 100.402 68.3321 100.402C68.4588 100.402 68.5629 100.299 68.5629 100.17Z",
                fill: "#5C5E62"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M68.5629 100.17C68.5629 100.042 68.4598 99.9383 68.3321 99.9393C68.2045 99.9393 68.1014 100.043 68.1014 100.171C68.1014 100.299 68.2045 100.402 68.3321 100.402C68.4588 100.402 68.5629 100.299 68.5629 100.17",
                stroke: "#36383B",
                strokeWidth: "1.90289",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M72.3461 100.17C72.3461 100.042 72.243 99.9383 72.1153 99.9393C71.9877 99.9393 71.8846 100.043 71.8846 100.171C71.8846 100.299 71.9877 100.402 72.1153 100.402C72.242 100.402 72.3461 100.299 72.3461 100.17Z",
                fill: "#5C5E62"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M72.3461 100.17C72.3461 100.042 72.243 99.9383 72.1153 99.9393C71.9877 99.9393 71.8846 100.043 71.8846 100.171C71.8846 100.299 71.9877 100.402 72.1153 100.402C72.242 100.402 72.3461 100.299 72.3461 100.17",
                stroke: "#36383B",
                strokeWidth: "1.90289",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M76.1293 100.17C76.1293 100.042 76.0262 99.9383 75.8985 99.9393C75.7709 99.9393 75.6678 100.043 75.6678 100.171C75.6678 100.299 75.7709 100.402 75.8985 100.402C76.0262 100.402 76.1293 100.299 76.1293 100.17Z",
                fill: "#5C5E62"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M76.1293 100.17C76.1293 100.042 76.0262 99.9383 75.8985 99.9393C75.7709 99.9393 75.6678 100.043 75.6678 100.171C75.6678 100.299 75.7709 100.402 75.8985 100.402C76.0262 100.402 76.1293 100.299 76.1293 100.17",
                stroke: "#36383B",
                strokeWidth: "1.90289",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_2364_388677",
                    x1: "65.1115",
                    y1: "114.522",
                    x2: "172.504",
                    y2: "12.086",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#74B740"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#74B740",
                            stopOpacity: "0"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DeviceCheck.tsx

var DeviceCheck = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "E-mail confirmado \xedcone" : _alt, _width = param.width, width = _width === void 0 ? 101 : _width, _height = param.height, height = _height === void 0 ? 100 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 101 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "50.5",
                cy: "50",
                r: "50",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M75.1351 63.3117L78.6193 57.2707",
                stroke: "#B2B3B5",
                strokeWidth: "1.09164",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M73.0051 62.0832L75.135 63.3117",
                stroke: "#B2B3B5",
                strokeWidth: "1.09164",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M74.4167 59.635L76.5466 60.8635",
                stroke: "#B2B3B5",
                strokeWidth: "1.09164",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.7987 57.5566C79.2667 57.9679 77.6913 57.0593 77.2801 55.5273C76.8689 53.9952 77.7774 52.4199 79.3095 52.0087C80.8415 51.5974 82.4168 52.506 82.828 54.038C83.2393 55.5701 82.3307 57.1454 80.7987 57.5566",
                stroke: "#B2B3B5",
                strokeWidth: "1.09164",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.9912 64.8522L92.3544 61.5644",
                stroke: "#C3C4C5",
                strokeWidth: "0.659714",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M93.8323 65.7819L94.9915 64.8522",
                stroke: "#C3C4C5",
                strokeWidth: "0.659714",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M92.7634 64.4494L93.9226 63.5198",
                stroke: "#C3C4C5",
                strokeWidth: "0.659714",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M92.9938 60.4C92.8891 61.3529 92.0318 62.0404 91.0789 61.9357C90.126 61.831 89.4384 60.9736 89.5431 60.0208C89.6478 59.0679 90.5052 58.3803 91.4581 58.485C92.411 58.5897 93.0986 59.4471 92.9938 60.4",
                stroke: "#C3C4C5",
                strokeWidth: "0.659714",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M72.5514 32.9733L67.877 27.7981",
                stroke: "#C3C4C5",
                strokeWidth: "1.09164",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M70.727 34.6215L72.5517 32.9734",
                stroke: "#C3C4C5",
                strokeWidth: "1.09164",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M68.8325 32.5241L70.6572 30.876",
                stroke: "#C3C4C5",
                strokeWidth: "1.09164",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M68.8204 25.8126C68.7399 27.3968 67.3903 28.6157 65.8061 28.5352C64.2219 28.4546 63.003 27.1051 63.0835 25.5209C63.164 23.9367 64.5136 22.7177 66.0978 22.7983C67.682 22.8788 68.901 24.2284 68.8204 25.8126",
                stroke: "#C3C4C5",
                strokeWidth: "1.09164",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.4129 60.6641L24.2983 55.6612",
                stroke: "#B2B3B5",
                strokeWidth: "0.904039",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.649 59.6467L21.4129 60.6641",
                stroke: "#B2B3B5",
                strokeWidth: "0.904039",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.8184 57.6193L22.5823 58.6366",
                stroke: "#B2B3B5",
                strokeWidth: "0.904039",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.1037 55.898C24.8349 56.2386 23.5303 55.4862 23.1898 54.2174C22.8492 52.9487 23.6016 51.6441 24.8704 51.3035C26.1391 50.9629 27.4437 51.7154 27.7843 52.9841C28.1248 54.2529 27.3724 55.5575 26.1037 55.898",
                stroke: "#B2B3B5",
                strokeWidth: "0.904039",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M83.8039 29.5397L85.5592 26.4963",
                stroke: "#C3C4C5",
                strokeWidth: "0.549963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.7306 28.9208L83.8037 29.5397",
                stroke: "#C3C4C5",
                strokeWidth: "0.549963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M83.442 27.6874L84.5151 28.3063",
                stroke: "#C3C4C5",
                strokeWidth: "0.549963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M86.657 26.6403C85.8852 26.8475 85.0916 26.3898 84.8844 25.6179C84.6772 24.8461 85.135 24.0525 85.9068 23.8453C86.6786 23.6381 87.4723 24.0958 87.6794 24.8677C87.8866 25.6395 87.4289 26.4331 86.657 26.6403",
                stroke: "#C3C4C5",
                strokeWidth: "0.549963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.3849 15.5862L61.1403 12.5427",
                stroke: "#C3C4C5",
                strokeWidth: "0.549963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58.3121 14.9673L59.3852 15.5862",
                stroke: "#C3C4C5",
                strokeWidth: "0.549963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.0231 13.7339L60.0961 14.3528",
                stroke: "#C3C4C5",
                strokeWidth: "0.549963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.2381 12.6868C61.4663 12.894 60.6726 12.4363 60.4655 11.6644C60.2583 10.8926 60.716 10.099 61.4878 9.89179C62.2597 9.68461 63.0533 10.1423 63.2605 10.9142C63.4677 11.686 63.0099 12.4796 62.2381 12.6868",
                stroke: "#C3C4C5",
                strokeWidth: "0.549963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.081 21.4115L32.7352 15.0757",
                stroke: "#B2B3B5",
                strokeWidth: "1.1449",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.8471 20.1231L29.081 21.4115",
                stroke: "#B2B3B5",
                strokeWidth: "1.1449",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.3281 17.5554L30.562 18.8438",
                stroke: "#B2B3B5",
                strokeWidth: "1.1449",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.021 15.3757C33.4143 15.807 31.7621 14.8541 31.3308 13.2473C30.8995 11.6405 31.8524 9.98834 33.4592 9.55704C35.0659 9.12573 36.7181 10.0786 37.1494 11.6854C37.5807 13.2922 36.6278 14.9444 35.021 15.3757",
                stroke: "#B2B3B5",
                strokeWidth: "1.1449",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.5102 37.3623L16.3723 38.7783C15.8046 38.9348 15.218 38.6017 15.0615 38.034L14.0703 34.4374C13.9138 33.8697 14.247 33.2831 14.8147 33.1266L19.9526 31.7106C20.5203 31.5541 21.1069 31.8872 21.2634 32.455L22.2546 36.0515C22.4111 36.6192 22.078 37.2058 21.5102 37.3623Z",
                stroke: "#C3C4C5",
                strokeWidth: "0.823401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.3286 32.985L14.9038 31.4436V31.4436C14.591 30.3087 15.2576 29.1349 16.3926 28.8221V28.8221C17.5275 28.5093 18.7013 29.1759 19.0141 30.3108V30.3108L19.4389 31.8522",
                stroke: "#C3C4C5",
                strokeWidth: "0.823401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M80.8394 79.5001L76.5455 76.3433C76.071 75.9945 75.9693 75.3277 76.3181 74.8532L78.5278 71.8474C78.8766 71.373 79.5435 71.2712 80.018 71.62L84.3119 74.7768C84.7864 75.1256 84.8882 75.7924 84.5393 76.2669L82.3296 79.2727C81.9808 79.7472 81.3139 79.8489 80.8394 79.5001Z",
                stroke: "#C3C4C5",
                strokeWidth: "0.823401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.4475 71.9357L81.3945 70.6475V70.6475C82.0918 69.699 83.4263 69.4953 84.3748 70.1926V70.1926C85.3233 70.89 85.527 72.2244 84.8297 73.1729V73.1729L83.8826 74.4611",
                stroke: "#C3C4C5",
                strokeWidth: "0.823401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M91.2778 45.5018L86.1399 46.9179C85.5722 47.0743 84.9856 46.7412 84.8291 46.1735L83.8379 42.577C83.6814 42.0092 84.0145 41.4226 84.5823 41.2662L89.7202 39.8501C90.2879 39.6937 90.8745 40.0268 91.0309 40.5945L92.0222 44.191C92.1787 44.7588 91.8455 45.3453 91.2778 45.5018Z",
                stroke: "#B2B3B5",
                strokeWidth: "0.823401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M85.0962 41.1245L84.6714 39.5832V39.5832C84.3586 38.4482 85.0252 37.2744 86.1601 36.9616V36.9616C87.2951 36.6488 88.4689 37.3154 88.7817 38.4503V38.4503L89.2065 39.9917",
                stroke: "#B2B3B5",
                strokeWidth: "0.823401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M78.7189 45.8676L75.4149 48.3247C75.0499 48.5963 74.5342 48.5205 74.2627 48.1554L72.5427 45.8427C72.2712 45.4776 72.347 44.962 72.7121 44.6904L76.016 42.2333C76.381 41.9618 76.8967 42.0375 77.1682 42.4026L78.8882 44.7154C79.1597 45.0804 79.0839 45.5961 78.7189 45.8676Z",
                stroke: "#C3C4C5",
                strokeWidth: "0.636149",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M73.0423 44.4447L72.3051 43.4535V43.4535C71.7623 42.7237 71.914 41.6919 72.6438 41.1491V41.1491C73.3737 40.6063 74.4055 40.7579 74.9483 41.4878V41.4878L75.6854 42.479",
                stroke: "#C3C4C5",
                strokeWidth: "0.636149",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.9212 53.1353L5.524 52.0676C5.14861 51.9496 4.94012 51.55 5.0581 51.1746L5.8055 48.7966C5.92348 48.4212 6.32309 48.2127 6.69848 48.3307L10.0957 49.3984C10.4711 49.5164 10.6796 49.916 10.5616 50.2914L9.81418 52.6694C9.6962 53.0448 9.29659 53.2533 8.9212 53.1353Z",
                stroke: "#B2B3B5",
                strokeWidth: "0.55018",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.03825 48.4374L7.35856 47.4183V47.4183C7.59442 46.6678 8.39408 46.2506 9.14452 46.4865V46.4865C9.89497 46.7223 10.3122 47.522 10.0763 48.2724V48.2724L9.75601 49.2916",
                stroke: "#B2B3B5",
                strokeWidth: "0.55018",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M30.4347 44.5324L27.869 45.6358C27.5855 45.7577 27.2571 45.6268 27.1351 45.3433L26.3628 43.5473C26.2408 43.2638 26.3717 42.9354 26.6552 42.8134L29.221 41.71C29.5045 41.5881 29.8329 41.719 29.9548 42.0025L30.7272 43.7985C30.8491 44.082 30.7182 44.4104 30.4347 44.5324Z",
                stroke: "#C3C4C5",
                strokeWidth: "0.431508",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.9115 42.7031L26.5805 41.9334V41.9334C26.3368 41.3666 26.5987 40.7095 27.1655 40.4657V40.4657C27.7322 40.222 28.3894 40.4839 28.6331 41.0507V41.0507L28.9641 41.8204",
                stroke: "#C3C4C5",
                strokeWidth: "0.431508",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M72.964 19.1785L68.67 17.2148C68.1955 16.9979 67.9869 16.4378 68.2039 15.9633L69.5785 12.9575C69.7954 12.483 70.3555 12.2744 70.83 12.4914L75.124 14.4551C75.5985 14.6721 75.8071 15.2321 75.5901 15.7066L74.2155 18.7124C73.9986 19.1869 73.4385 19.3955 72.964 19.1785Z",
                stroke: "#B2B3B5",
                strokeWidth: "0.729504",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M71.2592 12.6878L71.8483 11.3996V11.3996C72.2821 10.451 73.4028 10.0336 74.3514 10.4674V10.4674C75.2999 10.9012 75.7173 12.0219 75.2835 12.9705V12.9705L74.6945 14.2587",
                stroke: "#B2B3B5",
                strokeWidth: "0.729504",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.6738 78.0598L17.5359 79.4758C16.9682 79.6323 16.3816 79.2992 16.2251 78.7315L15.2339 75.1349C15.0774 74.5672 15.4105 73.9806 15.9783 73.8242L21.1162 72.4081C21.6839 72.2516 22.2705 72.5847 22.4269 73.1525L23.4182 76.749C23.5746 77.3167 23.2415 77.9033 22.6738 78.0598Z",
                stroke: "#B2B3B5",
                strokeWidth: "0.823401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.4922 73.6825L16.0674 72.1412V72.1412C15.7546 71.0062 16.4212 69.8324 17.5561 69.5196V69.5196C18.6911 69.2068 19.8649 69.8734 20.1777 71.0083V71.0083L20.6025 72.5497",
                stroke: "#B2B3B5",
                strokeWidth: "0.823401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "49.9185",
                cy: "87.3256",
                rx: "19.186",
                ry: "1.27907",
                fill: "#C3C4C5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.8486 20.9619V18.0549C45.8486 15.9144 47.5841 14.179 49.7246 14.179C51.8651 14.179 53.6006 15.9144 53.6006 18.0549V20.9619",
                stroke: "#53565A",
                strokeWidth: "1.49709",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "33.3977",
                y: "21.2699",
                width: "33.0417",
                height: "59.7859",
                rx: "2.3773",
                fill: "#53565A",
                stroke: "#53565A",
                strokeWidth: "0.679229"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "34.5189",
                y: "23.5541",
                width: "28.4733",
                height: "54.0547",
                rx: "2.08753",
                stroke: "#7AC143",
                strokeWidth: "0.596436"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44.686 23.2559H53.1256C52.6084 24.2903 51.5511 24.9438 50.3945 24.9438H47.4171C46.2606 24.9438 45.2033 24.2903 44.686 23.2559Z",
                fill: "#7AC143"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "34.5189",
                y: "22.3913",
                width: "30.7989",
                height: "57.5431",
                rx: "2.08753",
                fill: "#F6F7F7",
                stroke: "#53565A",
                strokeWidth: "0.596436"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M48.0264 23.7636C47.4654 23.7636 46.932 23.5939 46.4858 23.2939H52.2885C51.8423 23.5939 51.3088 23.7636 50.7479 23.7636H48.0264Z",
                fill: "#53565A",
                stroke: "#53565A",
                strokeWidth: "1.73856"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "49.3372",
                cy: "51.1629",
                rx: "10.4651",
                ry: "10.4651",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M49.3372 61.6279V61.6279C43.557 61.6279 38.8721 56.943 38.8721 51.1628V51.1628C38.8721 45.3826 43.557 40.6977 49.3372 40.6977V40.6977C55.1174 40.6977 59.8023 45.3826 59.8023 51.1628V51.1628C59.8023 56.943 55.1174 61.6279 49.3372 61.6279Z",
                stroke: "#F6F7F7",
                strokeWidth: "1.79651",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.9884 48.8372L48.1744 54.6512L44.686 51.1628",
                stroke: "#F6F7F7",
                strokeWidth: "1.79651",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/ui/Icons/DeviceCheckError.tsx

var DeviceCheckError = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Erro na confirma\xe7\xe3o de e-mail \xedcone" : _alt, _width = param.width, width = _width === void 0 ? 101 : _width, _height = param.height, height = _height === void 0 ? 100 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 101 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "50.5",
                cy: "50",
                r: "50",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M75.1351 63.3116L78.6193 57.2706",
                stroke: "#B2B3B5",
                strokeWidth: "0.869069",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M73.0051 62.0832L75.135 63.3116",
                stroke: "#B2B3B5",
                strokeWidth: "0.869069",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M74.4172 59.6351L76.5471 60.8635",
                stroke: "#B2B3B5",
                strokeWidth: "0.869069",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.7987 57.5566C79.2667 57.9679 77.6913 57.0593 77.2801 55.5273C76.8689 53.9952 77.7774 52.4199 79.3095 52.0087C80.8415 51.5974 82.4168 52.506 82.828 54.038C83.2393 55.5701 82.3307 57.1454 80.7987 57.5566",
                stroke: "#B2B3B5",
                strokeWidth: "0.869069",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.9912 64.8521L92.3544 61.5644",
                stroke: "#C3C4C5",
                strokeWidth: "0.525209",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M93.832 65.7818L94.9912 64.8521",
                stroke: "#C3C4C5",
                strokeWidth: "0.525209",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M92.7634 64.4494L93.9226 63.5197",
                stroke: "#C3C4C5",
                strokeWidth: "0.525209",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M92.9938 60.3999C92.8891 61.3528 92.0318 62.0404 91.0789 61.9357C90.126 61.8309 89.4384 60.9736 89.5431 60.0207C89.6478 59.0678 90.5052 58.3802 91.4581 58.4849C92.411 58.5896 93.0986 59.447 92.9938 60.3999",
                stroke: "#C3C4C5",
                strokeWidth: "0.525209",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M72.5514 32.9733L67.877 27.7981",
                stroke: "#C3C4C5",
                strokeWidth: "0.869069",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M70.7268 34.6215L72.5515 32.9733",
                stroke: "#C3C4C5",
                strokeWidth: "0.869069",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M68.8325 32.5241L70.6572 30.876",
                stroke: "#C3C4C5",
                strokeWidth: "0.869069",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M68.8204 25.8126C68.7399 27.3968 67.3903 28.6157 65.8061 28.5352C64.2219 28.4546 63.003 27.1051 63.0835 25.5209C63.164 23.9367 64.5136 22.7177 66.0978 22.7983C67.682 22.8788 68.901 24.2284 68.8204 25.8126",
                stroke: "#C3C4C5",
                strokeWidth: "0.869069",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.4131 60.6641L24.2986 55.6612",
                stroke: "#B2B3B5",
                strokeWidth: "0.71972",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.6492 59.6467L21.4132 60.6641",
                stroke: "#B2B3B5",
                strokeWidth: "0.71972",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.8184 57.6193L22.5823 58.6366",
                stroke: "#B2B3B5",
                strokeWidth: "0.71972",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.1034 55.8981C24.8347 56.2387 23.5301 55.4862 23.1895 54.2175C22.8489 52.9487 23.6014 51.6441 24.8701 51.3036C26.1389 50.963 27.4435 51.7154 27.784 52.9842C28.1246 54.2529 27.3722 55.5575 26.1034 55.8981",
                stroke: "#B2B3B5",
                strokeWidth: "0.71972",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M83.8036 29.5397L85.559 26.4963",
                stroke: "#C3C4C5",
                strokeWidth: "0.437834",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.7306 28.9208L83.8037 29.5397",
                stroke: "#C3C4C5",
                strokeWidth: "0.437834",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M83.4418 27.6874L84.5148 28.3063",
                stroke: "#C3C4C5",
                strokeWidth: "0.437834",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M86.657 26.6403C85.8852 26.8475 85.0916 26.3898 84.8844 25.6179C84.6772 24.8461 85.135 24.0525 85.9068 23.8453C86.6786 23.6381 87.4723 24.0958 87.6794 24.8677C87.8866 25.6395 87.4289 26.4331 86.657 26.6403",
                stroke: "#C3C4C5",
                strokeWidth: "0.437834",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.3849 15.5862L61.1403 12.5428",
                stroke: "#C3C4C5",
                strokeWidth: "0.437834",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58.3119 14.9673L59.385 15.5862",
                stroke: "#C3C4C5",
                strokeWidth: "0.437834",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.0231 13.7339L60.0961 14.3528",
                stroke: "#C3C4C5",
                strokeWidth: "0.437834",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.2383 12.6868C61.4665 12.894 60.6729 12.4363 60.4657 11.6644C60.2585 10.8926 60.7163 10.099 61.4881 9.89179C62.2599 9.68461 63.0536 10.1423 63.2607 10.9142C63.4679 11.686 63.0102 12.4796 62.2383 12.6868",
                stroke: "#C3C4C5",
                strokeWidth: "0.437834",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.0813 21.4115L32.7354 15.0757",
                stroke: "#B2B3B5",
                strokeWidth: "0.911474",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.8474 20.1231L29.0812 21.4115",
                stroke: "#B2B3B5",
                strokeWidth: "0.911474",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.3283 17.5554L30.5622 18.8438",
                stroke: "#B2B3B5",
                strokeWidth: "0.911474",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.0213 15.3757C33.4145 15.807 31.7623 14.8541 31.331 13.2473C30.8997 11.6405 31.8526 9.98834 33.4594 9.55704C35.0662 9.12574 36.7184 10.0786 37.1497 11.6854C37.581 13.2922 36.6281 14.9444 35.0213 15.3757",
                stroke: "#B2B3B5",
                strokeWidth: "0.911474",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.5105 37.3622L16.3726 38.7783C15.8048 38.9347 15.2183 38.6016 15.0618 38.0339L14.0706 34.4374C13.9141 33.8696 14.2472 33.2831 14.8149 33.1266L19.9528 31.7105C20.5206 31.5541 21.1071 31.8872 21.2636 32.4549L22.2548 36.0514C22.4113 36.6192 22.0782 37.2057 21.5105 37.3622Z",
                stroke: "#C3C4C5",
                strokeWidth: "0.655523",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.3289 32.985L14.9041 31.4436V31.4436C14.5913 30.3086 15.2578 29.1348 16.3928 28.822V28.822C17.5278 28.5092 18.7016 29.1758 19.0144 30.3107V30.3107L19.4392 31.8521",
                stroke: "#C3C4C5",
                strokeWidth: "0.655523",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M80.8399 79.5001L76.546 76.3433C76.0715 75.9945 75.9697 75.3277 76.3186 74.8532L78.5283 71.8474C78.8771 71.373 79.544 71.2712 80.0185 71.62L84.3124 74.7768C84.7869 75.1256 84.8886 75.7924 84.5398 76.2669L82.3301 79.2727C81.9813 79.7472 81.3144 79.8489 80.8399 79.5001Z",
                stroke: "#C3C4C5",
                strokeWidth: "0.655523",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.4477 71.9357L81.3948 70.6475V70.6475C82.0921 69.699 83.4265 69.4953 84.375 70.1926V70.1926C85.3236 70.89 85.5272 72.2244 84.8299 73.1729V73.1729L83.8829 74.4611",
                stroke: "#C3C4C5",
                strokeWidth: "0.655523",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M91.2778 45.5017L86.1399 46.9178C85.5722 47.0743 84.9856 46.7412 84.8291 46.1734L83.8379 42.5769C83.6814 42.0092 84.0145 41.4226 84.5823 41.2661L89.7202 39.8501C90.2879 39.6936 90.8745 40.0267 91.0309 40.5944L92.0222 44.191C92.1786 44.7587 91.8455 45.3453 91.2778 45.5017Z",
                stroke: "#B2B3B5",
                strokeWidth: "0.655523",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M85.0962 41.1245L84.6714 39.5831V39.5831C84.3586 38.4482 85.0252 37.2743 86.1601 36.9615V36.9615C87.2951 36.6487 88.4689 37.3153 88.7817 38.4503V38.4503L89.2065 39.9916",
                stroke: "#B2B3B5",
                strokeWidth: "0.655523",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M78.7186 45.8676L75.4147 48.3247C75.0496 48.5963 74.534 48.5205 74.2625 48.1554L72.5425 45.8427C72.2709 45.4776 72.3467 44.962 72.7118 44.6904L76.0157 42.2333C76.3808 41.9618 76.8964 42.0375 77.1679 42.4026L78.888 44.7154C79.1595 45.0804 79.0837 45.5961 78.7186 45.8676Z",
                stroke: "#C3C4C5",
                strokeWidth: "0.506449",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M73.0423 44.4448L72.3051 43.4536V43.4536C71.7623 42.7237 71.914 41.6919 72.6438 41.1491V41.1491C73.3737 40.6064 74.4055 40.758 74.9483 41.4878V41.4878L75.6854 42.479",
                stroke: "#C3C4C5",
                strokeWidth: "0.506449",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.92095 53.1352L5.52376 52.0675C5.14837 51.9495 4.93988 51.5499 5.05786 51.1745L5.80526 48.7965C5.92324 48.4211 6.32285 48.2126 6.69824 48.3306L10.0954 49.3983C10.4708 49.5163 10.6793 49.9159 10.5613 50.2913L9.81394 52.6693C9.69595 53.0447 9.29634 53.2532 8.92095 53.1352Z",
                stroke: "#B2B3B5",
                strokeWidth: "0.438007",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.038 48.4374L7.35832 47.4182V47.4182C7.59417 46.6678 8.39384 46.2506 9.14428 46.4864V46.4864C9.89472 46.7223 10.3119 47.5219 10.0761 48.2724V48.2724L9.75576 49.2915",
                stroke: "#B2B3B5",
                strokeWidth: "0.438007",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M30.4349 44.5325L27.8692 45.6359C27.5857 45.7578 27.2573 45.6269 27.1354 45.3434L26.363 43.5474C26.2411 43.2639 26.372 42.9355 26.6555 42.8136L29.2212 41.7102C29.5047 41.5882 29.8331 41.7191 29.955 42.0026L30.7274 43.7987C30.8493 44.0822 30.7185 44.4106 30.4349 44.5325Z",
                stroke: "#C3C4C5",
                strokeWidth: "0.343531",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.912 42.7032L26.581 41.9335V41.9335C26.3373 41.3667 26.5992 40.7096 27.1659 40.4659V40.4659C27.7327 40.2221 28.3899 40.484 28.6336 41.0508V41.0508L28.9646 41.8205",
                stroke: "#C3C4C5",
                strokeWidth: "0.343531",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M72.964 19.1785L68.67 17.2148C68.1955 16.9979 67.9869 16.4378 68.2039 15.9633L69.5785 12.9575C69.7954 12.483 70.3555 12.2744 70.83 12.4914L75.124 14.4551C75.5985 14.6721 75.8071 15.2321 75.5901 15.7066L74.2155 18.7124C73.9986 19.1869 73.4385 19.3955 72.964 19.1785Z",
                stroke: "#B2B3B5",
                strokeWidth: "0.58077",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M71.2595 12.6878L71.8486 11.3996V11.3996C72.2823 10.4511 73.4031 10.0337 74.3516 10.4675V10.4675C75.3002 10.9012 75.7176 12.022 75.2838 12.9705V12.9705L74.6947 14.2587",
                stroke: "#B2B3B5",
                strokeWidth: "0.58077",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.6731 78.0599L17.5352 79.4759C16.9674 79.6324 16.3809 79.2993 16.2244 78.7315L15.2332 75.135C15.0767 74.5673 15.4098 73.9807 15.9775 73.8242L21.1154 72.4082C21.6832 72.2517 22.2697 72.5848 22.4262 73.1525L23.4174 76.7491C23.5739 77.3168 23.2408 77.9034 22.6731 78.0599Z",
                stroke: "#B2B3B5",
                strokeWidth: "0.655523",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.4915 73.6826L16.0667 72.1412V72.1412C15.7539 71.0063 16.4204 69.8324 17.5554 69.5196V69.5196C18.6904 69.2068 19.8642 69.8734 20.177 71.0084V71.0084L20.6018 72.5497",
                stroke: "#B2B3B5",
                strokeWidth: "0.655523",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "49.9187",
                cy: "87.3256",
                rx: "19.186",
                ry: "1.27907",
                fill: "#C3C4C5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.8486 20.9619V18.0549C45.8486 15.9144 47.5841 14.179 49.7246 14.179C51.8651 14.179 53.6006 15.9144 53.6006 18.0549V20.9619",
                stroke: "#53565A",
                strokeWidth: "1.19186",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "33.3285",
                y: "21.2007",
                width: "33.1802",
                height: "59.9244",
                rx: "1.89261",
                fill: "#53565A",
                stroke: "#53565A",
                strokeWidth: "0.540746"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "34.4581",
                y: "23.4933",
                width: "28.5949",
                height: "54.1763",
                rx: "1.66191",
                stroke: "#7AC143",
                strokeWidth: "0.474833"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44.686 23.2559H53.1256C52.6084 24.2903 51.5511 24.9438 50.3945 24.9438H47.4172C46.2606 24.9438 45.2033 24.2903 44.686 23.2559Z",
                fill: "#7AC143"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "34.4581",
                y: "22.3305",
                width: "30.9205",
                height: "57.6647",
                rx: "1.66191",
                fill: "#F6F7F7",
                stroke: "#53565A",
                strokeWidth: "0.474833"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M48.0264 23.9409C47.25 23.9409 46.5231 23.6353 45.9856 23.1167H52.7887C52.2512 23.6353 51.5243 23.9409 50.7479 23.9409H48.0264Z",
                fill: "#53565A",
                stroke: "#53565A",
                strokeWidth: "1.3841"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M49.8169 61C44.0376 61 39.3535 56.3159 39.3535 50.5366C39.3535 44.7573 44.0376 40.0732 49.8169 40.0732C55.5962 40.0732 60.2803 44.7573 60.2803 50.5366C60.2803 56.3159 55.5962 61 49.8169 61Z",
                fill: "#BE0F2C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.1072 47.2465L46.5269 53.8268",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.1072 53.8268L46.5269 47.2465",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/ui/Icons/DevicePasswordChange.tsx

var DevicePasswordChange = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Alterar nova senha \xedcone" : _alt, _width = param.width, width = _width === void 0 ? 203 : _width, _height = param.height, height = _height === void 0 ? 155 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 203 155",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "64.1421",
                cy: "91",
                r: "64",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M33.3667 78.4854C31.7567 78.4854 30.4507 79.7043 30.4507 81.2077C30.4507 82.7111 31.7567 83.9293 33.3667 83.9293H41.3867C42.9975 83.9293 44.3035 82.7104 44.3035 81.2077C44.3035 79.705 42.9975 78.4861 41.3875 78.4861C41.3875 76.4188 39.592 74.743 37.3771 74.743C35.1622 74.743 33.3667 76.4181 33.3667 78.4854Z",
                    stroke: "#A0A2A4",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.3667 94.4854C9.7567 94.4854 8.45068 95.7043 8.45068 97.2077C8.45068 98.7111 9.7567 99.9293 11.3667 99.9293H19.3867C20.9975 99.9293 22.3035 98.7104 22.3035 97.2077C22.3035 95.705 20.9975 94.4861 19.3875 94.4861C19.3875 92.4188 17.592 90.743 15.3771 90.743C13.1622 90.743 11.3667 92.4181 11.3667 94.4854Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M85.3667 135.485C83.7567 135.485 82.4507 136.704 82.4507 138.208C82.4507 139.711 83.7567 140.929 85.3667 140.929H93.3867C94.9975 140.929 96.3035 139.71 96.3035 138.208C96.3035 136.705 94.9975 135.486 93.3875 135.486C93.3875 133.419 91.592 131.743 89.3771 131.743C87.1622 131.743 85.3667 133.418 85.3667 135.485Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.3667 112.485C22.7567 112.485 21.4507 113.704 21.4507 115.208C21.4507 116.711 22.7567 117.929 24.3667 117.929H32.3867C33.9975 117.929 35.3035 116.71 35.3035 115.208C35.3035 113.705 33.9975 112.486 32.3875 112.486C32.3875 110.419 30.592 108.743 28.3771 108.743C26.1622 108.743 24.3667 110.418 24.3667 112.485Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M110.367 106.485C108.757 106.485 107.451 107.704 107.451 109.208C107.451 110.711 108.757 111.929 110.367 111.929H118.387C119.997 111.929 121.303 110.71 121.303 109.208C121.303 107.705 119.997 106.486 118.387 106.486C118.387 104.419 116.592 102.743 114.377 102.743C112.162 102.743 110.367 104.418 110.367 106.485Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M79.3667 41.4854C77.7567 41.4854 76.4507 42.7043 76.4507 44.2077C76.4507 45.7111 77.7567 46.9293 79.3667 46.9293H87.3867C88.9975 46.9293 90.3035 45.7104 90.3035 44.2077C90.3035 42.705 88.9975 41.4861 87.3875 41.4861C87.3875 39.4188 85.592 37.743 83.3771 37.743C81.1622 37.743 79.3667 39.4181 79.3667 41.4854Z",
                    stroke: "#8F9194",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M105.367 63.4854C103.757 63.4854 102.451 64.7043 102.451 66.2077C102.451 67.7111 103.757 68.9293 105.367 68.9293H113.387C114.997 68.9293 116.303 67.7104 116.303 66.2077C116.303 64.705 114.997 63.4861 113.387 63.4861C113.387 61.4188 111.592 59.743 109.377 59.743C107.162 59.743 105.367 61.4181 105.367 63.4854Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M92.9734 94.4892C91.7927 94.4892 90.835 95.3831 90.835 96.4856C90.835 97.5881 91.7927 98.4815 92.9734 98.4815H98.8547C100.036 98.4815 100.994 97.5876 100.994 96.4856C100.994 95.3837 100.036 94.4898 98.8553 94.4898C98.8553 92.9738 97.5386 91.7449 95.9143 91.7449C94.2901 91.7449 92.9734 92.9733 92.9734 94.4892Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M45.9734 37.4892C44.7927 37.4892 43.835 38.3831 43.835 39.4856C43.835 40.5881 44.7927 41.4815 45.9734 41.4815H51.8547C53.0359 41.4815 53.9937 40.5876 53.9937 39.4856C53.9937 38.3837 53.0359 37.4898 51.8553 37.4898C51.8553 35.9738 50.5386 34.7449 48.9143 34.7449C47.2901 34.7449 45.9734 35.9733 45.9734 37.4892Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M36.9734 136.489C35.7927 136.489 34.835 137.383 34.835 138.486C34.835 139.588 35.7927 140.481 36.9734 140.481H42.8547C44.0359 140.481 44.9937 139.588 44.9937 138.486C44.9937 137.384 44.0359 136.49 42.8553 136.49C42.8553 134.974 41.5386 133.745 39.9143 133.745C38.2901 133.745 36.9734 134.973 36.9734 136.489Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.9734 57.4892C23.7927 57.4892 22.835 58.3831 22.835 59.4856C22.835 60.5881 23.7927 61.4815 24.9734 61.4815H30.8547C32.0359 61.4815 32.9937 60.5876 32.9937 59.4856C32.9937 58.3837 32.0359 57.4898 30.8553 57.4898C30.8553 55.9738 29.5386 54.7449 27.9143 54.7449C26.2901 54.7449 24.9734 55.9733 24.9734 57.4892Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "63.9358",
                cy: "128.926",
                rx: "16.0042",
                ry: "1.06694",
                fill: "black",
                fillOpacity: "0.4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M52.1249 49.0025H74.777C80.845 49.0025 85.7598 53.9173 85.7598 59.9853V109.408C85.7598 115.476 80.845 120.391 74.777 120.391H52.1249C46.0569 120.391 41.1421 115.476 41.1421 109.408V59.9853C41.1421 53.9173 46.0569 49.0025 52.1249 49.0025Z",
                fill: "#F6F7F7",
                stroke: "#53565A",
                strokeWidth: "3.53019",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M58.6323 108.035H68.2423H58.6323Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58.6323 108.035H68.2423",
                stroke: "#53565A",
                strokeWidth: "3.53019",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "63.4505",
                cy: "71.3114",
                r: "7.75959",
                fill: "#F8FCF6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "63.6416",
                cy: "77.4999",
                rx: "4.5",
                ry: "1.5",
                fill: "#F2BD00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.1096 65.653C72.2346 68.778 72.2346 73.8447 69.1096 76.9697C65.9846 80.0947 60.918 80.0947 57.793 76.9697C54.668 73.8446 54.668 68.778 57.793 65.653C60.918 62.528 65.9846 62.528 69.1096 65.653",
                stroke: "#252728",
                strokeWidth: "1.33368",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M65.2203 68.0429C66.197 69.0196 66.197 70.6032 65.2203 71.5799C64.2436 72.5567 62.66 72.5567 61.6832 71.5799C60.7065 70.6032 60.7065 69.0196 61.6832 68.0429C62.66 67.0661 64.2436 67.0661 65.2203 68.0429Z",
                fill: "#F2BD00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M65.2203 68.0429C66.197 69.0196 66.197 70.6032 65.2203 71.5799C64.2436 72.5567 62.66 72.5567 61.6832 71.5799C60.7065 70.6032 60.7065 69.0196 61.6832 68.0429C62.66 67.0661 64.2436 67.0661 65.2203 68.0429",
                stroke: "#252728",
                strokeWidth: "1.33368",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M68.5254 77.4978C67.2495 76.1544 65.4499 75.3124 63.4512 75.3124C61.4524 75.3124 59.6528 76.1544 58.377 77.4987",
                fill: "#F2BD00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M68.5254 77.4978C67.2495 76.1544 65.4499 75.3124 63.4512 75.3124C61.4524 75.3124 59.6528 76.1544 58.377 77.4987",
                stroke: "#252728",
                strokeWidth: "1.33368",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.17",
                d: "M200.349 56.1655L73.8035 94.2279L54.1647 87.1523L131.872 25.8401L200.349 56.1655Z",
                fill: "url(#paint0_linear_123_168517)",
                stroke: "#F2BD00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "128.295",
                y: "22.7583",
                width: "73.7162",
                height: "32.9783",
                rx: "3.8798",
                fill: "#F2BD00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M149.889 38.7797C149.889 38.3815 149.568 38.0599 149.169 38.0628C148.771 38.0628 148.45 38.3844 148.45 38.7827C148.45 39.181 148.771 39.5026 149.169 39.5026C149.565 39.5026 149.889 39.181 149.889 38.7797Z",
                fill: "#F2BD00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M149.889 38.7797C149.889 38.3815 149.568 38.0599 149.169 38.0628C148.771 38.0628 148.45 38.3844 148.45 38.7827C148.45 39.181 148.771 39.5026 149.169 39.5026C149.565 39.5026 149.889 39.181 149.889 38.7797",
                stroke: "#FEF4F5",
                strokeWidth: "4.79418",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M161.691 38.7797C161.691 38.3815 161.369 38.0599 160.971 38.0628C160.572 38.0628 160.251 38.3844 160.251 38.7827C160.251 39.181 160.572 39.5026 160.971 39.5026C161.366 39.5026 161.691 39.181 161.691 38.7797Z",
                fill: "#F2BD00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M161.691 38.7797C161.691 38.3815 161.369 38.0599 160.971 38.0628C160.572 38.0628 160.251 38.3844 160.251 38.7827C160.251 39.181 160.572 39.5026 160.971 39.5026C161.366 39.5026 161.691 39.181 161.691 38.7797",
                stroke: "#FEF4F5",
                strokeWidth: "4.79418",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M173.491 38.7797C173.491 38.3815 173.17 38.0599 172.772 38.0628C172.373 38.0628 172.052 38.3844 172.052 38.7827C172.052 39.181 172.373 39.5026 172.772 39.5026C173.167 39.5026 173.491 39.181 173.491 38.7797Z",
                fill: "#F2BD00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M173.491 38.7797C173.491 38.3815 173.17 38.0599 172.772 38.0628C172.373 38.0628 172.052 38.3844 172.052 38.7827C172.052 39.181 172.373 39.5026 172.772 39.5026C173.167 39.5026 173.491 39.181 173.491 38.7797",
                stroke: "#FEF4F5",
                strokeWidth: "4.79418",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M185.293 38.7797C185.293 38.3815 184.971 38.0599 184.573 38.0628C184.175 38.0628 183.853 38.3844 183.853 38.7827C183.853 39.181 184.175 39.5026 184.573 39.5026C184.971 39.5026 185.293 39.181 185.293 38.7797Z",
                fill: "#F2BD00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M185.293 38.7797C185.293 38.3815 184.971 38.0599 184.573 38.0628C184.175 38.0628 183.853 38.3844 183.853 38.7827C183.853 39.181 184.175 39.5026 184.573 39.5026C184.971 39.5026 185.293 39.181 185.293 38.7797",
                stroke: "#FEF4F5",
                strokeWidth: "4.79418",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "52.7817",
                y: "85.8606",
                width: "21.6812",
                height: "9.69949",
                rx: "1.14112",
                fill: "#F2BD00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M59.1329 90.5728C59.1329 90.4557 59.0383 90.3611 58.9212 90.362C58.804 90.362 58.7094 90.4566 58.7094 90.5737C58.7094 90.6908 58.804 90.7854 58.9212 90.7854C59.0374 90.7854 59.1329 90.6908 59.1329 90.5728Z",
                fill: "#5C5E62"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.1329 90.5728C59.1329 90.4557 59.0383 90.3611 58.9212 90.362C58.804 90.362 58.7094 90.4566 58.7094 90.5737C58.7094 90.6908 58.804 90.7854 58.9212 90.7854C59.0374 90.7854 59.1329 90.6908 59.1329 90.5728",
                stroke: "#36383B",
                strokeWidth: "1.41005",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M62.6036 90.5728C62.6036 90.4557 62.509 90.3611 62.3919 90.362C62.2747 90.362 62.1801 90.4566 62.1801 90.5737C62.1801 90.6908 62.2747 90.7854 62.3919 90.7854C62.5081 90.7854 62.6036 90.6908 62.6036 90.5728Z",
                fill: "#5C5E62"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.6036 90.5728C62.6036 90.4557 62.509 90.3611 62.3919 90.362C62.2747 90.362 62.1801 90.4566 62.1801 90.5737C62.1801 90.6908 62.2747 90.7854 62.3919 90.7854C62.5081 90.7854 62.6036 90.6908 62.6036 90.5728",
                stroke: "#36383B",
                strokeWidth: "1.41005",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M66.0748 90.5728C66.0748 90.4557 65.9802 90.3611 65.8631 90.362C65.7459 90.362 65.6513 90.4566 65.6513 90.5737C65.6513 90.6908 65.7459 90.7854 65.8631 90.7854C65.9793 90.7854 66.0748 90.6908 66.0748 90.5728Z",
                fill: "#5C5E62"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M66.0748 90.5728C66.0748 90.4557 65.9802 90.3611 65.8631 90.362C65.7459 90.362 65.6513 90.4566 65.6513 90.5737C65.6513 90.6908 65.7459 90.7854 65.8631 90.7854C65.9793 90.7854 66.0748 90.6908 66.0748 90.5728",
                stroke: "#36383B",
                strokeWidth: "1.41005",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M69.5455 90.5728C69.5455 90.4557 69.4509 90.3611 69.3338 90.362C69.2166 90.362 69.122 90.4566 69.122 90.5737C69.122 90.6908 69.2166 90.7854 69.3338 90.7854C69.4509 90.7854 69.5455 90.6908 69.5455 90.5728Z",
                fill: "#5C5E62"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.5455 90.5728C69.5455 90.4557 69.4509 90.3611 69.3338 90.362C69.2166 90.362 69.122 90.4566 69.122 90.5737C69.122 90.6908 69.2166 90.7854 69.3338 90.7854C69.4509 90.7854 69.5455 90.6908 69.5455 90.5728",
                stroke: "#36383B",
                strokeWidth: "1.41005",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_123_168517",
                    x1: "59.436",
                    y1: "103.693",
                    x2: "157.629",
                    y2: "9.6697",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#74B740"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#74B740",
                            stopOpacity: "0"
                        })
                    ]
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/ui/Icons/DevicePasswordChanged.tsx

var DevicePasswordChanged = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Senha alterada com sucesso \xedcone" : _alt, _width = param.width, width = _width === void 0 ? 203 : _width, _height = param.height, height = _height === void 0 ? 155 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 203 155",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "64.6416",
                cy: "91",
                r: "64",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M33.8662 78.4854C32.2562 78.4854 30.9502 79.7043 30.9502 81.2077C30.9502 82.7111 32.2562 83.9293 33.8662 83.9293H41.8862C43.497 83.9293 44.803 82.7104 44.803 81.2077C44.803 79.705 43.497 78.4861 41.887 78.4861C41.887 76.4188 40.0915 74.743 37.8766 74.743C35.6617 74.743 33.8662 76.4181 33.8662 78.4854Z",
                    stroke: "#A0A2A4",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.8662 94.4854C10.2562 94.4854 8.9502 95.7043 8.9502 97.2077C8.9502 98.7111 10.2562 99.9293 11.8662 99.9293H19.8862C21.497 99.9293 22.803 98.7104 22.803 97.2077C22.803 95.705 21.497 94.4861 19.887 94.4861C19.887 92.4188 18.0915 90.743 15.8766 90.743C13.6617 90.743 11.8662 92.4181 11.8662 94.4854Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M85.8662 135.485C84.2562 135.485 82.9502 136.704 82.9502 138.208C82.9502 139.711 84.2562 140.929 85.8662 140.929H93.8862C95.497 140.929 96.803 139.71 96.803 138.208C96.803 136.705 95.497 135.486 93.887 135.486C93.887 133.419 92.0915 131.743 89.8766 131.743C87.6617 131.743 85.8662 133.418 85.8662 135.485Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.8662 112.485C23.2562 112.485 21.9502 113.704 21.9502 115.208C21.9502 116.711 23.2562 117.929 24.8662 117.929H32.8862C34.497 117.929 35.803 116.71 35.803 115.208C35.803 113.705 34.497 112.486 32.887 112.486C32.887 110.419 31.0915 108.743 28.8766 108.743C26.6617 108.743 24.8662 110.418 24.8662 112.485Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M110.866 106.485C109.256 106.485 107.95 107.704 107.95 109.208C107.95 110.711 109.256 111.929 110.866 111.929H118.886C120.497 111.929 121.803 110.71 121.803 109.208C121.803 107.705 120.497 106.486 118.887 106.486C118.887 104.419 117.092 102.743 114.877 102.743C112.662 102.743 110.866 104.418 110.866 106.485Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M79.8662 41.4854C78.2562 41.4854 76.9502 42.7043 76.9502 44.2077C76.9502 45.7111 78.2562 46.9293 79.8662 46.9293H87.8862C89.497 46.9293 90.803 45.7104 90.803 44.2077C90.803 42.705 89.497 41.4861 87.887 41.4861C87.887 39.4188 86.0915 37.743 83.8766 37.743C81.6617 37.743 79.8662 39.4181 79.8662 41.4854Z",
                    stroke: "#8F9194",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M105.866 63.4854C104.256 63.4854 102.95 64.7043 102.95 66.2077C102.95 67.7111 104.256 68.9293 105.866 68.9293H113.886C115.497 68.9293 116.803 67.7104 116.803 66.2077C116.803 64.705 115.497 63.4861 113.887 63.4861C113.887 61.4188 112.092 59.743 109.877 59.743C107.662 59.743 105.866 61.4181 105.866 63.4854Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M93.4734 94.4892C92.2927 94.4892 91.335 95.3831 91.335 96.4856C91.335 97.5881 92.2927 98.4815 93.4734 98.4815H99.3547C100.536 98.4815 101.494 97.5876 101.494 96.4856C101.494 95.3837 100.536 94.4898 99.3553 94.4898C99.3553 92.9738 98.0386 91.7449 96.4143 91.7449C94.7901 91.7449 93.4734 92.9733 93.4734 94.4892Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M46.4734 37.4892C45.2927 37.4892 44.335 38.3831 44.335 39.4856C44.335 40.5881 45.2927 41.4815 46.4734 41.4815H52.3547C53.5359 41.4815 54.4937 40.5876 54.4937 39.4856C54.4937 38.3837 53.5359 37.4898 52.3553 37.4898C52.3553 35.9738 51.0386 34.7449 49.4143 34.7449C47.7901 34.7449 46.4734 35.9733 46.4734 37.4892Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M37.4734 136.489C36.2927 136.489 35.335 137.383 35.335 138.486C35.335 139.588 36.2927 140.481 37.4734 140.481H43.3547C44.5359 140.481 45.4937 139.588 45.4937 138.486C45.4937 137.384 44.5359 136.49 43.3553 136.49C43.3553 134.974 42.0386 133.745 40.4143 133.745C38.7901 133.745 37.4734 134.973 37.4734 136.489Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.4734 57.4892C24.2927 57.4892 23.335 58.3831 23.335 59.4856C23.335 60.5881 24.2927 61.4815 25.4734 61.4815H31.3547C32.5359 61.4815 33.4937 60.5876 33.4937 59.4856C33.4937 58.3837 32.5359 57.4898 31.3553 57.4898C31.3553 55.9738 30.0386 54.7449 28.4143 54.7449C26.7901 54.7449 25.4734 55.9733 25.4734 57.4892Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "64.4358",
                cy: "128.926",
                rx: "16.0042",
                ry: "1.06694",
                fill: "black",
                fillOpacity: "0.4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M52.6244 49.0025H75.2765C81.3445 49.0025 86.2593 53.9173 86.2593 59.9853V109.408C86.2593 115.476 81.3445 120.391 75.2765 120.391H52.6244C46.5564 120.391 41.6416 115.476 41.6416 109.408V59.9853C41.6416 53.9173 46.5564 49.0025 52.6244 49.0025Z",
                fill: "#F6F7F7",
                stroke: "#53565A",
                strokeWidth: "3.53019",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M59.1318 108.035H68.7418H59.1318Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.1318 108.035H68.7418",
                stroke: "#53565A",
                strokeWidth: "3.53019",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "63.951",
                cy: "71.3114",
                r: "7.75959",
                fill: "#F8FCF6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "64.1416",
                cy: "77.5",
                rx: "4.5",
                ry: "1.5",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.6096 65.653C72.7346 68.778 72.7346 73.8447 69.6096 76.9697C66.4846 80.0947 61.418 80.0947 58.293 76.9697C55.168 73.8446 55.168 68.778 58.293 65.653C61.418 62.528 66.4846 62.528 69.6096 65.653",
                stroke: "#252728",
                strokeWidth: "1.33368",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M65.7198 68.0429C66.6966 69.0196 66.6966 70.6032 65.7198 71.5799C64.7431 72.5567 63.1595 72.5567 62.1827 71.5799C61.206 70.6032 61.206 69.0196 62.1827 68.0429C63.1595 67.0661 64.7431 67.0661 65.7198 68.0429Z",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M65.7198 68.0429C66.6966 69.0196 66.6966 70.6032 65.7198 71.5799C64.7431 72.5567 63.1595 72.5567 62.1827 71.5799C61.206 70.6032 61.206 69.0196 62.1827 68.0429C63.1595 67.0661 64.7431 67.0661 65.7198 68.0429",
                stroke: "#252728",
                strokeWidth: "1.33368",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M69.0254 77.4978C67.7495 76.1544 65.9499 75.3124 63.9512 75.3124C61.9524 75.3124 60.1528 76.1544 58.877 77.4987",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.0254 77.4978C67.7495 76.1544 65.9499 75.3124 63.9512 75.3124C61.9524 75.3124 60.1528 76.1544 58.877 77.4987",
                stroke: "#252728",
                strokeWidth: "1.33368",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.17",
                d: "M200.849 56.1655L74.303 94.2279L54.6642 87.1523L132.372 25.8401L200.849 56.1655Z",
                fill: "url(#paint0_linear_123_168665)",
                stroke: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "128.795",
                y: "22.7583",
                width: "73.7162",
                height: "32.9783",
                rx: "3.8798",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M150.389 38.7797C150.389 38.3815 150.068 38.0599 149.669 38.0628C149.271 38.0628 148.95 38.3844 148.95 38.7827C148.95 39.181 149.271 39.5026 149.669 39.5026C150.065 39.5026 150.389 39.181 150.389 38.7797Z",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M150.389 38.7797C150.389 38.3815 150.068 38.0599 149.669 38.0628C149.271 38.0628 148.95 38.3844 148.95 38.7827C148.95 39.181 149.271 39.5026 149.669 39.5026C150.065 39.5026 150.389 39.181 150.389 38.7797",
                stroke: "#FEF4F5",
                strokeWidth: "4.79418",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M162.19 38.7797C162.19 38.3815 161.869 38.0599 161.47 38.0628C161.072 38.0628 160.75 38.3844 160.75 38.7827C160.75 39.181 161.072 39.5026 161.47 39.5026C161.866 39.5026 162.19 39.181 162.19 38.7797Z",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M162.19 38.7797C162.19 38.3815 161.869 38.0599 161.47 38.0628C161.072 38.0628 160.75 38.3844 160.75 38.7827C160.75 39.181 161.072 39.5026 161.47 39.5026C161.866 39.5026 162.19 39.181 162.19 38.7797",
                stroke: "#FEF4F5",
                strokeWidth: "4.79418",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M173.991 38.7797C173.991 38.3815 173.669 38.0599 173.271 38.0628C172.873 38.0628 172.551 38.3844 172.551 38.7827C172.551 39.181 172.873 39.5026 173.271 39.5026C173.666 39.5026 173.991 39.181 173.991 38.7797Z",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M173.991 38.7797C173.991 38.3815 173.669 38.0599 173.271 38.0628C172.873 38.0628 172.551 38.3844 172.551 38.7827C172.551 39.181 172.873 39.5026 173.271 39.5026C173.666 39.5026 173.991 39.181 173.991 38.7797",
                stroke: "#FEF4F5",
                strokeWidth: "4.79418",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M185.792 38.7797C185.792 38.3815 185.47 38.0599 185.072 38.0628C184.674 38.0628 184.352 38.3844 184.352 38.7827C184.352 39.181 184.674 39.5026 185.072 39.5026C185.47 39.5026 185.792 39.181 185.792 38.7797Z",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M185.792 38.7797C185.792 38.3815 185.47 38.0599 185.072 38.0628C184.674 38.0628 184.352 38.3844 184.352 38.7827C184.352 39.181 184.674 39.5026 185.072 39.5026C185.47 39.5026 185.792 39.181 185.792 38.7797",
                stroke: "#FEF4F5",
                strokeWidth: "4.79418",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "53.2812",
                y: "85.8606",
                width: "21.6812",
                height: "9.69949",
                rx: "1.14112",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M59.6319 90.5728C59.6319 90.4556 59.5373 90.361 59.4202 90.3619C59.303 90.3619 59.2085 90.4565 59.2085 90.5736C59.2085 90.6908 59.303 90.7854 59.4202 90.7854C59.5365 90.7854 59.6319 90.6908 59.6319 90.5728Z",
                fill: "#5C5E62"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.6319 90.5728C59.6319 90.4556 59.5373 90.361 59.4202 90.3619C59.303 90.3619 59.2085 90.4565 59.2085 90.5736C59.2085 90.6908 59.303 90.7854 59.4202 90.7854C59.5365 90.7854 59.6319 90.6908 59.6319 90.5728",
                stroke: "#36383B",
                strokeWidth: "1.41005",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M63.1036 90.5728C63.1036 90.4556 63.009 90.361 62.8919 90.3619C62.7747 90.3619 62.6801 90.4565 62.6801 90.5736C62.6801 90.6908 62.7747 90.7854 62.8919 90.7854C63.0081 90.7854 63.1036 90.6908 63.1036 90.5728Z",
                fill: "#5C5E62"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M63.1036 90.5728C63.1036 90.4556 63.009 90.361 62.8919 90.3619C62.7747 90.3619 62.6801 90.4565 62.6801 90.5736C62.6801 90.6908 62.7747 90.7854 62.8919 90.7854C63.0081 90.7854 63.1036 90.6908 63.1036 90.5728",
                stroke: "#36383B",
                strokeWidth: "1.41005",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M66.5743 90.5728C66.5743 90.4556 66.4797 90.361 66.3626 90.3619C66.2454 90.3619 66.1508 90.4565 66.1508 90.5736C66.1508 90.6908 66.2454 90.7854 66.3626 90.7854C66.4788 90.7854 66.5743 90.6908 66.5743 90.5728Z",
                fill: "#5C5E62"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M66.5743 90.5728C66.5743 90.4556 66.4797 90.361 66.3626 90.3619C66.2454 90.3619 66.1508 90.4565 66.1508 90.5736C66.1508 90.6908 66.2454 90.7854 66.3626 90.7854C66.4788 90.7854 66.5743 90.6908 66.5743 90.5728",
                stroke: "#36383B",
                strokeWidth: "1.41005",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M70.045 90.5728C70.045 90.4556 69.9504 90.361 69.8333 90.3619C69.7161 90.3619 69.6216 90.4565 69.6216 90.5736C69.6216 90.6908 69.7161 90.7854 69.8333 90.7854C69.9504 90.7854 70.045 90.6908 70.045 90.5728Z",
                fill: "#5C5E62"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M70.045 90.5728C70.045 90.4556 69.9504 90.361 69.8333 90.3619C69.7161 90.3619 69.6216 90.4565 69.6216 90.5736C69.6216 90.6908 69.7161 90.7854 69.8333 90.7854C69.9504 90.7854 70.045 90.6908 70.045 90.5728",
                stroke: "#36383B",
                strokeWidth: "1.41005",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_123_168665",
                    x1: "59.9355",
                    y1: "103.693",
                    x2: "158.128",
                    y2: "9.6697",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#74B740"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#74B740",
                            stopOpacity: "0"
                        })
                    ]
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/ui/Icons/DevicesIcon.tsx


var DevicesIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.8704 18.995H2.99536C2.44336 18.995 1.99536 18.547 1.99536 17.995V16.995C1.99536 16.443 2.44336 15.995 2.99536 15.995H13.8704",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.9954 4.995C19.9954 3.89 19.1004 2.995 17.9954 2.995H4.99536C3.89036 2.995 2.99536 3.89 2.99536 4.995V15.995",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.8704 7.995H19.9954C21.1004 7.995 21.9954 8.89 21.9954 9.995V18.995C21.9954 20.1 21.1004 20.995 19.9954 20.995H15.8704C14.7654 20.995 13.8704 20.1 13.8704 18.995V9.995C13.8704 8.89 14.7654 7.995 15.8704 7.995Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.9954 7.995V4.995",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0554 18.745H18.8054",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Diners.tsx


var Diners = function(param) {
    var _width = param.width, width = _width === void 0 ? 65 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _alt = param.alt, alt = _alt === void 0 ? "Diners" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.tertiary.750 */.rS.colors.tertiary[750] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 44 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.24 0H41.44C42.6772 0 43.68 1.0029 43.68 2.24V25.76C43.68 26.9972 42.6772 28 41.44 28H2.24C1.0029 28 0 26.9972 0 25.76V2.24C0 1.0029 1.0029 0 2.24 0Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.5961 14.0812C33.5961 8.51396 28.9492 4.66592 23.8577 4.6676H19.4761C14.324 4.66576 10.0833 8.51508 10.0833 14.0812C10.0833 19.1733 14.324 23.357 19.4761 23.3324H23.8577C28.9489 23.3568 33.5961 19.1719 33.5961 14.0812Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.5037 5.45605C14.7958 5.45757 10.9811 9.2813 10.98 14.0005C10.9811 18.719 14.796 22.5422 19.5037 22.5439C24.2128 22.5424 28.0286 18.7189 28.0292 14.0005C28.0286 9.2813 24.2128 5.45773 19.5037 5.45605Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.116 13.9776C14.1204 11.6714 15.5577 9.70492 17.5846 8.92355V19.0304C15.5577 18.2493 14.1204 16.2839 14.116 13.9776ZM21.452 19.0329V8.92322C23.4796 9.70274 24.9192 11.6704 24.9228 13.9776C24.9192 16.2855 23.4796 18.2516 21.452 19.0327V19.0329Z",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DisconnectIcon.tsx


var DisconnectIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de desconectar dispositivo" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.110 */.rS.colors.neutral[110] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 21",
        "aria-label": alt,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.16667 16.3317V6.75249C9.16667 6.17749 8.87083 5.64332 8.38333 5.33915L5.05 3.25582C3.94 2.56248 2.5 3.35998 2.5 4.66915V14.2475C2.5 14.8225 2.79583 15.3567 3.28333 15.6608L6.61667 17.7442C7.72667 18.4383 9.16667 17.64 9.16667 16.3317Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 9.66667H12.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1667 8L12.5 9.66667L14.1667 11.3333",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.1665 16.3333H12.4998C13.4207 16.3333 14.1665 15.5875 14.1665 14.6667V13.8333",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1665 5.5V4.66667C14.1665 3.74583 13.4207 3 12.4998 3H4.1665",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DollarCircle.tsx


var DollarCircle = function(param) {
    var _width = param.width, width = _width === void 0 ? 18 : _width, _height = param.height, height = _height === void 0 ? 18 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 6V7.5",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.364 5.63604C21.8787 9.15076 21.8787 14.8492 18.364 18.3639C14.8493 21.8787 9.1508 21.8787 5.6361 18.3639C2.12138 14.8492 2.12138 9.15074 5.6361 5.63604C9.15082 2.12132 14.8493 2.12132 18.364 5.63604",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 18V16.5",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 14.255V14.255C9 15.498 10.007 16.505 11.25 16.505H12.893C14.056 16.505 15 15.562 15 14.398V14.398C15 13.432 14.343 12.59 13.406 12.355L10.594 11.65C9.657 11.415 9 10.573 9 9.607V9.607C9 8.443 9.943 7.5 11.107 7.5H12.75C13.993 7.5 15 8.507 15 9.75V9.75",
                stroke: color,
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DollarIcon.tsx


var DollarIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.760 */.rS.colors.neutral[760] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de dolar" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5 6.8185V6.1815",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5 13.182V13.818",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "8.25",
                stroke: "#A0A2A4",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.26499 12.2838C8.5237 12.7079 8.9657 13 9.50092 13H10.0005H10.5965C11.3726 13 12 12.3717 12 11.5969C12 10.9529 11.5611 10.3927 10.9369 10.2346L9.06206 9.76335C8.43886 9.60733 8 9.04712 8 8.40314C8 7.62723 8.62844 7 9.40351 7H10.0005H10.5001C11.0333 7 11.4753 7.29215 11.7329 7.71518",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DoubleArrowDown.tsx


var DoubleArrowDown = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, click = param.click;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        onClick: click,
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 11.2L12 19.2L20 11.2",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 4L12 12L20 4",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DoubleCard.tsx


//
var DoubleCard = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.primary.80 */.rS.colors.primary[80] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.neutral.40 */.rS.colors.neutral[40] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.tertiary.110 */.rS.colors.tertiary[110] : _fourthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "24",
                height: "24",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "20.2812",
                y: "3",
                width: "15",
                height: "10",
                rx: "1.5",
                transform: "rotate(83.8457 20.2812 3)",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "3",
                height: "0.5",
                rx: "0.25",
                transform: "matrix(0.107206 0.994237 0.994237 -0.107206 13.536 5.73891)",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "5",
                height: "0.5",
                rx: "0.25",
                transform: "matrix(0.107206 0.994237 0.994237 -0.107206 12.5417 5.84612)",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "9.07108",
                y: "4.16116",
                width: "15",
                height: "10",
                rx: "1.5",
                transform: "rotate(45 9.07108 4.16116)",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "7.65686",
                y: "5.57538",
                width: "15",
                height: "2.5",
                transform: "rotate(45 7.65686 5.57538)",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "3",
                height: "0.5",
                rx: "0.25",
                transform: "matrix(0.707107 0.707107 0.707107 -0.707107 5.53554 10.5251)",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "5",
                height: "0.5",
                rx: "0.25",
                transform: "matrix(0.707107 0.707107 0.707107 -0.707107 4.82843 11.2322)",
                fill: thirdColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DoubtsIcon.tsx


var DoubtsIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19 17H18C17.448 17 17 16.552 17 16V11C17 10.448 17.448 10 18 10H19C20.105 10 21 10.895 21 12V15C21 16.105 20.105 17 19 17Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6 17H5C3.895 17 3 16.105 3 15V12C3 10.895 3.895 10 5 10H6C6.552 10 7 10.448 7 11V16C7 16.552 6.552 17 6 17Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.5 10V9.5C18.5 5.91 15.59 3 12 3V3C8.41 3 5.5 5.91 5.5 9.5V10",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.625 21.25H11.375C10.685 21.25 10.125 20.69 10.125 20V20C10.125 19.31 10.685 18.75 11.375 18.75H12.625C13.315 18.75 13.875 19.31 13.875 20V20C13.875 20.69 13.315 21.25 12.625 21.25Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.875 20H16C17.105 20 18 19.105 18 18V17",
                stroke: "black",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            " "
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Edit.tsx


var Edit = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-1-inside-1_1823_175",
                fill: color,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.7116 18.3196L3.43134 19.9211C3.35132 20.3615 3.65155 20.6418 4.07202 20.5618L5.67358 20.2815M16.2836 6.94881C16.4839 6.74856 16.8041 6.74856 17.0043 6.94881C17.2046 7.14905 17.2046 7.46927 17.0043 7.66949L7.39754 17.2009C7.39754 17.2009 7.27553 17.0789 7.07531 16.8787C6.87506 16.6784 6.67685 16.4802 6.67685 16.4802L16.2836 6.94881ZM8.17596 19.4608L8.33613 18.8001L3.83184 20.1815C3.79176 20.2016 3.75183 20.2016 3.73172 20.2016C3.73172 20.2016 3.75169 20.2016 3.7718 20.2216C3.79176 20.2415 3.79176 20.2616 3.79176 20.2616C3.79176 20.2417 3.79176 20.2016 3.81173 20.1615L5.19323 15.6572L4.5326 15.8174L8.17596 19.4608ZM4.4324 15.4169L3.05104 19.9212C2.83083 20.6419 3.35127 21.1824 4.07198 20.9421L8.57627 19.5608L8.73644 18.9001L5.09297 15.2567L4.4324 15.4169ZM18.4858 9.15094V8.5904L8.35613 18.72H8.91667L5.2732 15.0766V15.6371L15.4028 5.50747H14.8423L18.4858 9.15094ZM15.1225 4.66667L4.43232 15.3568L8.63633 19.5608L19.3265 8.87067L15.1225 4.66667ZM19.0462 8.5904L15.4028 4.94693V5.50747L17.0043 3.90591C17.1645 3.74574 17.4047 3.74574 17.5649 3.90591L20.0672 6.40829C20.2274 6.56846 20.2274 6.82876 20.0672 6.96882L18.4657 8.57038H19.0463L19.0462 8.5904ZM20.6478 7.54938C21.1082 7.08897 21.1082 6.30823 20.6478 5.84768L18.1454 3.3453C17.685 2.8849 16.9043 2.8849 16.4437 3.3453L14.5619 5.22713L18.7659 9.43113L20.6478 7.54938Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.7116 18.3196L3.43134 19.9211C3.35132 20.3615 3.65155 20.6418 4.07202 20.5618L5.67358 20.2815M16.2836 6.94881C16.4839 6.74856 16.8041 6.74856 17.0043 6.94881C17.2046 7.14905 17.2046 7.46927 17.0043 7.66949L7.39754 17.2009C7.39754 17.2009 7.27553 17.0789 7.07531 16.8787C6.87506 16.6784 6.67685 16.4802 6.67685 16.4802L16.2836 6.94881ZM8.17596 19.4608L8.33613 18.8001L3.83184 20.1815C3.79176 20.2016 3.75183 20.2016 3.73172 20.2016C3.73172 20.2016 3.75169 20.2016 3.7718 20.2216C3.79176 20.2415 3.79176 20.2616 3.79176 20.2616C3.79176 20.2417 3.79176 20.2016 3.81173 20.1615L5.19323 15.6572L4.5326 15.8174L8.17596 19.4608ZM4.4324 15.4169L3.05104 19.9212C2.83083 20.6419 3.35127 21.1824 4.07198 20.9421L8.57627 19.5608L8.73644 18.9001L5.09297 15.2567L4.4324 15.4169ZM18.4858 9.15094V8.5904L8.35613 18.72H8.91667L5.2732 15.0766V15.6371L15.4028 5.50747H14.8423L18.4858 9.15094ZM15.1225 4.66667L4.43232 15.3568L8.63633 19.5608L19.3265 8.87067L15.1225 4.66667ZM19.0462 8.5904L15.4028 4.94693V5.50747L17.0043 3.90591C17.1645 3.74574 17.4047 3.74574 17.5649 3.90591L20.0672 6.40829C20.2274 6.56846 20.2274 6.82876 20.0672 6.96882L18.4657 8.57038H19.0463L19.0462 8.5904ZM20.6478 7.54938C21.1082 7.08897 21.1082 6.30823 20.6478 5.84768L18.1454 3.3453C17.685 2.8849 16.9043 2.8849 16.4437 3.3453L14.5619 5.22713L18.7659 9.43113L20.6478 7.54938Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.43134 19.9211L4.16927 20.0552L4.17011 20.0504L3.43134 19.9211ZM4.07202 20.5618L3.94272 19.8229L3.93182 19.825L4.07202 20.5618ZM16.2836 6.94881L16.8119 7.48122L16.814 7.47914L16.2836 6.94881ZM17.0043 6.94881L16.474 7.47911L16.474 7.47914L17.0043 6.94881ZM17.0043 7.66949L17.5326 8.20191L17.5346 8.19985L17.0043 7.66949ZM7.39754 17.2009L6.86726 17.7313L7.3955 18.2595L7.92578 17.7333L7.39754 17.2009ZM7.07531 16.8787L7.60567 16.3484L7.60564 16.3484L7.07531 16.8787ZM6.67685 16.4802L6.14862 15.9478L5.6141 16.4781L6.14652 17.0106L6.67685 16.4802ZM8.17596 19.4608L7.64563 19.9911L8.59012 20.9356L8.90484 19.6375L8.17596 19.4608ZM8.33613 18.8001L9.06501 18.9768L9.37532 17.697L8.11623 18.0831L8.33613 18.8001ZM3.83184 20.1815L3.61194 19.4644L3.55176 19.4829L3.4955 19.5111L3.83184 20.1815ZM3.73172 20.2016V19.4516L3.73169 20.9516L3.73172 20.2016ZM3.7718 20.2216L4.30213 19.6912L4.30027 19.6894L3.7718 20.2216ZM3.79176 20.2616H3.04176L4.54176 20.2616L3.79176 20.2616ZM3.81173 20.1615L4.48302 20.496L4.51062 20.4406L4.52877 20.3814L3.81173 20.1615ZM5.19323 15.6572L5.91026 15.8771L6.29644 14.618L5.01651 14.9283L5.19323 15.6572ZM4.5326 15.8174L4.35588 15.0885L3.05778 15.4032L4.00227 16.3477L4.5326 15.8174ZM4.4324 15.4169L4.25561 14.688L3.84057 14.7887L3.71536 15.197L4.4324 15.4169ZM3.05104 19.9212L2.33401 19.7013L2.33378 19.702L3.05104 19.9212ZM4.07198 20.9421L3.85208 20.2251L3.84338 20.2278L3.83475 20.2306L4.07198 20.9421ZM8.57627 19.5608L8.79617 20.2778L9.20451 20.1526L9.30515 19.7375L8.57627 19.5608ZM8.73644 18.9001L9.46532 19.0769L9.56455 18.6676L9.26677 18.3698L8.73644 18.9001ZM5.09297 15.2567L5.6233 14.7263L5.32549 14.4285L4.91618 14.5278L5.09297 15.2567ZM18.4858 9.15094L17.9554 9.68127L19.2358 10.9616V9.15094H18.4858ZM18.4858 8.5904H19.2358V6.77974L17.9554 8.06007L18.4858 8.5904ZM8.35613 18.72L7.8258 18.1897L6.54547 19.47H8.35613V18.72ZM8.91667 18.72V19.47H10.7273L9.447 18.1897L8.91667 18.72ZM5.2732 15.0766L5.80353 14.5462L4.5232 13.2659V15.0766H5.2732ZM5.2732 15.6371H4.5232V17.4478L5.80353 16.1674L5.2732 15.6371ZM15.4028 5.50747L15.9332 6.0378L17.2135 4.75747H15.4028V5.50747ZM14.8423 5.50747V4.75747H13.0316L14.312 6.0378L14.8423 5.50747ZM15.1225 4.66667L15.6528 4.13634L15.1225 3.60601L14.5922 4.13634L15.1225 4.66667ZM4.43232 15.3568L3.90199 14.8265L3.37166 15.3568L3.90199 15.8872L4.43232 15.3568ZM8.63633 19.5608L8.106 20.0912L8.63633 20.6215L9.16666 20.0912L8.63633 19.5608ZM19.3265 8.87067L19.8568 9.401L20.3872 8.87067L19.8568 8.34034L19.3265 8.87067ZM19.0462 8.5904L18.5159 9.12073L19.7898 10.3946L19.7962 8.5931L19.0462 8.5904ZM15.4028 4.94693L15.9331 4.4166L14.6528 3.13627V4.94693H15.4028ZM15.4028 5.50747H14.6528V7.31813L15.9331 6.0378L15.4028 5.50747ZM17.0043 3.90591L17.5347 4.43624L17.5347 4.43624L17.0043 3.90591ZM17.5649 3.90591L18.0952 3.37558L18.0952 3.37555L17.5649 3.90591ZM20.0672 6.40829L20.5976 5.87796L20.5976 5.87796L20.0672 6.40829ZM20.0672 6.96882L19.5735 6.40424L19.5547 6.42075L19.5369 6.43849L20.0672 6.96882ZM18.4657 8.57038L17.9354 8.04005L16.655 9.32038H18.4657V8.57038ZM19.0463 8.57038L19.7963 8.57308L19.799 7.82038H19.0463V8.57038ZM20.6478 7.54938L21.1781 8.07973L21.1781 8.07971L20.6478 7.54938ZM20.6478 5.84768L21.1782 5.31744L21.1781 5.31735L20.6478 5.84768ZM18.1454 3.3453L17.6151 3.87563L17.6151 3.87563L18.1454 3.3453ZM16.4437 3.3453L15.9135 2.81489L15.9134 2.81497L16.4437 3.3453ZM14.5619 5.22713L14.0316 4.6968L13.5012 5.22713L14.0316 5.75746L14.5619 5.22713ZM18.7659 9.43113L18.2356 9.96146L18.7659 10.4918L19.2962 9.96148L18.7659 9.43113ZM2.97282 18.1903L2.69256 19.7918L4.17011 20.0504L4.45037 18.4488L2.97282 18.1903ZM2.69341 19.787C2.61832 20.2004 2.70929 20.6495 3.03938 20.9726C3.36635 21.2926 3.81164 21.3748 4.21221 21.2986L3.93182 19.825C3.91193 19.8288 3.99687 19.8108 4.08861 19.9006C4.13023 19.9414 4.15299 19.987 4.16266 20.0229C4.17188 20.057 4.16644 20.0707 4.16926 20.0552L2.69341 19.787ZM4.2013 21.3006L5.80286 21.0203L5.5443 19.5428L3.94274 19.823L4.2013 21.3006ZM16.814 7.47914C16.7213 7.57177 16.5667 7.57181 16.474 7.47911L17.5347 6.4185C17.0415 5.92531 16.2464 5.92535 15.7533 6.41848L16.814 7.47914ZM16.474 7.47914C16.3814 7.38651 16.3813 7.23182 16.474 7.13913L17.5346 8.19985C18.0278 7.70671 18.0278 6.9116 17.5347 6.41848L16.474 7.47914ZM16.4761 7.13708L6.8693 16.6685L7.92578 17.7333L17.5326 8.20191L16.4761 7.13708ZM7.39754 17.2009C7.92782 16.6705 7.92782 16.6705 7.92782 16.6705C7.92782 16.6705 7.92782 16.6705 7.92782 16.6705C7.92781 16.6705 7.92781 16.6705 7.9278 16.6705C7.92779 16.6705 7.92776 16.6705 7.92773 16.6705C7.92768 16.6704 7.92759 16.6703 7.92747 16.6702C7.92723 16.67 7.92688 16.6696 7.92641 16.6691C7.92547 16.6682 7.92406 16.6668 7.9222 16.6649C7.91847 16.6612 7.91293 16.6557 7.90565 16.6484C7.89109 16.6338 7.86958 16.6123 7.84183 16.5846C7.78631 16.529 7.70576 16.4485 7.60567 16.3484L6.54495 17.409C6.64508 17.5091 6.72565 17.5897 6.78119 17.6452C6.80896 17.673 6.83048 17.6945 6.84505 17.7091C6.85233 17.7164 6.85788 17.7219 6.86161 17.7257C6.86348 17.7275 6.86489 17.7289 6.86583 17.7299C6.8663 17.7303 6.86666 17.7307 6.8669 17.7309C6.86702 17.7311 6.86711 17.7311 6.86717 17.7312C6.8672 17.7312 6.86722 17.7313 6.86723 17.7313C6.86724 17.7313 6.86725 17.7313 6.86725 17.7313C6.86725 17.7313 6.86725 17.7313 6.86725 17.7313C6.86726 17.7313 6.86726 17.7313 7.39754 17.2009ZM7.60564 16.3484C7.50551 16.2482 7.4059 16.1486 7.33132 16.074C7.29403 16.0367 7.26299 16.0057 7.24128 15.984C7.23043 15.9731 7.2219 15.9646 7.21609 15.9588C7.21318 15.9559 7.21096 15.9537 7.20946 15.9522C7.20871 15.9514 7.20814 15.9509 7.20776 15.9505C7.20757 15.9503 7.20742 15.9501 7.20733 15.95C7.20728 15.95 7.20724 15.95 7.20722 15.9499C7.20721 15.9499 7.2072 15.9499 7.20719 15.9499C7.20719 15.9499 7.20719 15.9499 7.20718 15.9499C7.20718 15.9499 7.20718 15.9499 6.67685 16.4802C6.14652 17.0106 6.14652 17.0106 6.14653 17.0106C6.14653 17.0106 6.14653 17.0106 6.14653 17.0106C6.14654 17.0106 6.14655 17.0106 6.14656 17.0106C6.14658 17.0106 6.14662 17.0107 6.14667 17.0107C6.14676 17.0108 6.14691 17.011 6.1471 17.0111C6.14748 17.0115 6.14805 17.0121 6.1488 17.0128C6.1503 17.0143 6.15253 17.0166 6.15543 17.0195C6.16124 17.0253 6.16977 17.0338 6.18062 17.0447C6.20233 17.0664 6.23337 17.0974 6.27066 17.1347C6.34524 17.2093 6.44485 17.3089 6.54498 17.409L7.60564 16.3484ZM7.20509 17.0127L16.8119 7.48122L15.7554 6.41639L6.14862 15.9478L7.20509 17.0127ZM8.90484 19.6375L9.06501 18.9768L7.60725 18.6234L7.44708 19.284L8.90484 19.6375ZM8.11623 18.0831L3.61194 19.4644L4.05174 20.8985L8.55603 19.5172L8.11623 18.0831ZM3.4955 19.5111C3.62662 19.4453 3.74486 19.4516 3.73172 19.4516V20.9516C3.75879 20.9516 3.95691 20.9578 4.16818 20.8518L3.4955 19.5111ZM3.73172 20.2016C3.73169 20.9516 3.73133 20.9516 3.73096 20.9516C3.73084 20.9516 3.73047 20.9516 3.73023 20.9516C3.72974 20.9516 3.72925 20.9516 3.72876 20.9516C3.72777 20.9516 3.72679 20.9516 3.7258 20.9516C3.72383 20.9515 3.72184 20.9515 3.71985 20.9515C3.71586 20.9514 3.71182 20.9513 3.70775 20.9512C3.69959 20.9509 3.69125 20.9505 3.68273 20.95C3.6657 20.9488 3.64781 20.947 3.62917 20.9444C3.59202 20.9391 3.55093 20.9302 3.50753 20.9158C3.41816 20.886 3.32453 20.8344 3.24332 20.7537L4.30027 19.6894C4.19895 19.5888 4.08529 19.5271 3.9809 19.4924C3.93 19.4755 3.88266 19.4653 3.84114 19.4594C3.82031 19.4564 3.8007 19.4545 3.7825 19.4533C3.77339 19.4527 3.7646 19.4523 3.75615 19.452C3.75192 19.4518 3.74777 19.4517 3.7437 19.4517C3.74167 19.4516 3.73966 19.4516 3.73766 19.4516C3.73667 19.4516 3.73567 19.4516 3.73469 19.4516C3.73419 19.4516 3.7337 19.4516 3.73321 19.4516C3.73297 19.4516 3.7326 19.4516 3.73248 19.4516C3.73211 19.4516 3.73174 19.4516 3.73172 20.2016ZM3.24147 20.7519C3.15921 20.6696 3.10715 20.5748 3.07743 20.4853C3.06299 20.4417 3.05416 20.4006 3.0489 20.3636C3.04626 20.345 3.04449 20.3272 3.04336 20.3103C3.0428 20.3018 3.0424 20.2935 3.04214 20.2854C3.04201 20.2814 3.04192 20.2774 3.04186 20.2734C3.04183 20.2714 3.0418 20.2694 3.04179 20.2675C3.04178 20.2665 3.04177 20.2655 3.04177 20.2645C3.04177 20.2641 3.04177 20.2636 3.04177 20.2631C3.04176 20.2628 3.04176 20.2625 3.04176 20.2624C3.04176 20.262 3.04176 20.2616 3.79176 20.2616C4.54176 20.2616 4.54176 20.2613 4.54176 20.2609C4.54176 20.2608 4.54176 20.2604 4.54176 20.2602C4.54176 20.2597 4.54176 20.2592 4.54176 20.2587C4.54175 20.2577 4.54175 20.2567 4.54174 20.2558C4.54173 20.2538 4.5417 20.2518 4.54167 20.2498C4.54161 20.2457 4.54151 20.2416 4.54137 20.2374C4.54111 20.229 4.54069 20.2202 4.54009 20.2112C4.53889 20.1931 4.53695 20.1735 4.534 20.1527C4.52812 20.1113 4.51804 20.0639 4.50111 20.0129C4.46639 19.9083 4.40435 19.7934 4.30213 19.6912L3.24147 20.7519ZM4.54176 20.2616C4.54176 20.2482 4.54802 20.3655 4.48302 20.496L3.14044 19.827C3.03551 20.0376 3.04176 20.2351 3.04176 20.2616H4.54176ZM4.52877 20.3814L5.91026 15.8771L4.47619 15.4373L3.0947 19.9416L4.52877 20.3814ZM5.01651 14.9283L4.35588 15.0885L4.70932 16.5463L5.36994 16.3861L5.01651 14.9283ZM4.00227 16.3477L7.64563 19.9911L8.70629 18.9304L5.06293 15.2871L4.00227 16.3477ZM3.71536 15.197L2.33401 19.7013L3.76808 20.1411L5.14943 15.6368L3.71536 15.197ZM2.33378 19.702C2.15995 20.2709 2.25139 20.8899 2.67491 21.3189C3.10464 21.7542 3.73033 21.8466 4.30921 21.6536L3.83475 20.2306C3.76042 20.2554 3.72353 20.2497 3.71876 20.2488C3.71557 20.2482 3.7283 20.2508 3.74242 20.2651C3.75598 20.2789 3.7548 20.287 3.75229 20.2742C3.74957 20.2603 3.74499 20.2167 3.76831 20.1404L2.33378 19.702ZM4.29188 21.6592L8.79617 20.2778L8.35637 18.8437L3.85208 20.2251L4.29188 21.6592ZM9.30515 19.7375L9.46532 19.0769L8.00756 18.7234L7.84739 19.3841L9.30515 19.7375ZM9.26677 18.3698L5.6233 14.7263L4.56264 15.787L8.20611 19.4305L9.26677 18.3698ZM4.91618 14.5278L4.25561 14.688L4.60918 16.1458L5.26976 15.9855L4.91618 14.5278ZM19.2358 9.15094V8.5904H17.7358V9.15094H19.2358ZM17.9554 8.06007L7.8258 18.1897L8.88646 19.2504L19.0161 9.12073L17.9554 8.06007ZM8.35613 19.47H8.91667V17.97H8.35613V19.47ZM9.447 18.1897L5.80353 14.5462L4.74287 15.6069L8.38633 19.2504L9.447 18.1897ZM4.5232 15.0766V15.6371H6.0232V15.0766H4.5232ZM5.80353 16.1674L15.9332 6.0378L14.8725 4.97714L4.74287 15.1068L5.80353 16.1674ZM15.4028 4.75747H14.8423V6.25747H15.4028V4.75747ZM14.312 6.0378L17.9554 9.68127L19.0161 8.62061L15.3726 4.97714L14.312 6.0378ZM14.5922 4.13634L3.90199 14.8265L4.96265 15.8872L15.6528 5.197L14.5922 4.13634ZM3.90199 15.8872L8.106 20.0912L9.16666 19.0305L4.96265 14.8265L3.90199 15.8872ZM9.16666 20.0912L19.8568 9.401L18.7962 8.34034L8.106 19.0305L9.16666 20.0912ZM19.8568 8.34034L15.6528 4.13634L14.5922 5.197L18.7962 9.401L19.8568 8.34034ZM19.5766 8.06007L15.9331 4.4166L14.8724 5.47726L18.5159 9.12073L19.5766 8.06007ZM14.6528 4.94693V5.50747H16.1528V4.94693H14.6528ZM15.9331 6.0378L17.5347 4.43624L16.474 3.37558L14.8724 4.97714L15.9331 6.0378ZM17.5347 4.43624C17.4786 4.49227 17.3897 4.53578 17.2846 4.53578C17.1794 4.53578 17.0906 4.49228 17.0346 4.43627L18.0952 3.37555C17.6421 2.92254 16.9271 2.9225 16.474 3.37558L17.5347 4.43624ZM17.0345 4.43624L19.5369 6.93862L20.5976 5.87796L18.0952 3.37558L17.0345 4.43624ZM19.5369 6.93862C19.4254 6.8271 19.3708 6.58154 19.5735 6.40424L20.5609 7.53341C21.084 7.07598 21.0294 6.30982 20.5976 5.87796L19.5369 6.93862ZM19.5369 6.43849L17.9354 8.04005L18.996 9.10071L20.5976 7.49915L19.5369 6.43849ZM18.4657 9.32038H19.0463V7.82038H18.4657V9.32038ZM18.2963 8.56769L18.2962 8.58771L19.7962 8.5931L19.7963 8.57308L18.2963 8.56769ZM21.1781 8.07971C21.9315 7.32637 21.9313 6.07081 21.1782 5.31744L20.1174 6.37793C20.285 6.54565 20.2849 6.85158 20.1175 7.01905L21.1781 8.07971ZM21.1781 5.31735L18.6757 2.81497L17.6151 3.87563L20.1175 6.37801L21.1781 5.31735ZM18.6757 2.81497C17.9224 2.06163 16.6668 2.06175 15.9135 2.81489L16.974 3.87571C17.1417 3.70805 17.4476 3.70817 17.6151 3.87563L18.6757 2.81497ZM15.9134 2.81497L14.0316 4.6968L15.0922 5.75746L16.9741 3.87563L15.9134 2.81497ZM14.0316 5.75746L18.2356 9.96146L19.2962 8.9008L15.0922 4.6968L14.0316 5.75746ZM19.2962 9.96148L21.1781 8.07973L20.1175 7.01903L18.2356 8.90078L19.2962 9.96148Z",
                fill: secondColor,
                mask: "url(#path-1-inside-1_1823_175)"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/EditPencilIcon.tsx


var EditPencilIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.760 */.rS.colors.neutral[760] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de l\xe1pis num box de edi\xe7\xe3o" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 13.067V18.972C21 20.092 20.099 21 18.987 21H5.013C3.901 21 3 20.092 3 18.972V6.028C3 4.908 3.901 4 5.013 4H12",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.82812 17.1718L11.5591 16.2388C11.7351 16.1948 11.8951 16.1037 12.0241 15.9757L20.4141 7.58575C21.1951 6.80475 21.1951 5.53875 20.4141 4.75775L20.2421 4.58575C19.4611 3.80475 18.1951 3.80475 17.4141 4.58575L9.02412 12.9757C8.89612 13.1037 8.80513 13.2648 8.76113 13.4408L7.82813 17.1718",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.8301 6.16992L18.8301 9.16992",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5468 16.2409C11.5608 16.1349 11.5788 16.0299 11.5788 15.9199C11.5788 14.5389 10.4598 13.4199 9.07881 13.4199C8.96881 13.4199 8.86381 13.4389 8.75781 13.4519",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/EditRight.tsx


var EditRight = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _alt = param.alt, alt = _alt === void 0 ? "editar" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-1-inside-1_1823_175",
                fill: color,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M20.2815 18.3196L20.5618 19.9211C20.6418 20.3615 20.3416 20.6418 19.9211 20.5618L18.3195 20.2815M7.70946 6.94881C7.50921 6.74856 7.189 6.74856 6.98877 6.94881C6.78853 7.14905 6.78853 7.46927 6.98877 7.66949L16.5956 17.2009C16.5956 17.2009 16.7176 17.0789 16.9178 16.8787C17.118 16.6784 17.3163 16.4802 17.3163 16.4802L7.70946 6.94881ZM15.8171 19.4608L15.657 18.8001L20.1613 20.1815C20.2013 20.2016 20.2413 20.2016 20.2614 20.2016C20.2614 20.2016 20.2414 20.2016 20.2213 20.2216C20.2013 20.2415 20.2013 20.2616 20.2013 20.2616C20.2013 20.2417 20.2013 20.2016 20.1814 20.1615L18.7999 15.6572L19.4605 15.8174L15.8171 19.4608ZM19.5607 15.4169L20.9421 19.9212C21.1623 20.6419 20.6418 21.1824 19.9211 20.9421L15.4168 19.5608L15.2567 18.9001L18.9001 15.2567L19.5607 15.4169ZM5.50733 9.15094V8.5904L15.637 18.72H15.0764L18.7199 15.0766V15.6371L8.59027 5.50747H9.1508L5.50733 9.15094ZM8.8706 4.66667L19.5608 15.3568L15.3568 19.5608L4.6666 8.87067L8.8706 4.66667ZM4.94687 8.5904L8.59033 4.94693V5.50747L6.98877 3.90591C6.8286 3.74574 6.58843 3.74574 6.42824 3.90591L3.92586 6.40829C3.76569 6.56846 3.76569 6.82876 3.92586 6.96882L5.52742 8.57038H4.94679L4.94687 8.5904ZM3.34531 7.54938C2.8849 7.08897 2.8849 6.30823 3.34531 5.84768L5.84769 3.3453C6.30809 2.8849 7.08883 2.8849 7.54938 3.3453L9.43121 5.22713L5.22721 9.43113L3.34531 7.54938Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.2815 18.3196L20.5618 19.9211C20.6418 20.3615 20.3416 20.6418 19.9211 20.5618L18.3195 20.2815M7.70946 6.94881C7.50921 6.74856 7.189 6.74856 6.98877 6.94881C6.78853 7.14905 6.78853 7.46927 6.98877 7.66949L16.5956 17.2009C16.5956 17.2009 16.7176 17.0789 16.9178 16.8787C17.118 16.6784 17.3163 16.4802 17.3163 16.4802L7.70946 6.94881ZM15.8171 19.4608L15.657 18.8001L20.1613 20.1815C20.2013 20.2016 20.2413 20.2016 20.2614 20.2016C20.2614 20.2016 20.2414 20.2016 20.2213 20.2216C20.2013 20.2415 20.2013 20.2616 20.2013 20.2616C20.2013 20.2417 20.2013 20.2016 20.1814 20.1615L18.7999 15.6572L19.4605 15.8174L15.8171 19.4608ZM19.5607 15.4169L20.9421 19.9212C21.1623 20.6419 20.6418 21.1824 19.9211 20.9421L15.4168 19.5608L15.2567 18.9001L18.9001 15.2567L19.5607 15.4169ZM5.50733 9.15094V8.5904L15.637 18.72H15.0764L18.7199 15.0766V15.6371L8.59027 5.50747H9.1508L5.50733 9.15094ZM8.8706 4.66667L19.5608 15.3568L15.3568 19.5608L4.6666 8.87067L8.8706 4.66667ZM4.94687 8.5904L8.59033 4.94693V5.50747L6.98877 3.90591C6.8286 3.74574 6.58843 3.74574 6.42824 3.90591L3.92586 6.40829C3.76569 6.56846 3.76569 6.82876 3.92586 6.96882L5.52742 8.57038H4.94679L4.94687 8.5904ZM3.34531 7.54938C2.8849 7.08897 2.8849 6.30823 3.34531 5.84768L5.84769 3.3453C6.30809 2.8849 7.08883 2.8849 7.54938 3.3453L9.43121 5.22713L5.22721 9.43113L3.34531 7.54938Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.5618 19.9211L19.8238 20.0552L19.823 20.0504L20.5618 19.9211ZM19.9211 20.5618L20.0504 19.8229L20.0613 19.825L19.9211 20.5618ZM7.70946 6.94881L7.18122 7.48122L7.17913 7.47914L7.70946 6.94881ZM6.98877 6.94881L7.51913 7.47911L7.5191 7.47914L6.98877 6.94881ZM6.98877 7.66949L6.46053 8.20191L6.45847 8.19985L6.98877 7.66949ZM16.5956 17.2009L17.1258 17.7313L16.5976 18.2595L16.0673 17.7333L16.5956 17.2009ZM16.9178 16.8787L16.3874 16.3484L16.3875 16.3484L16.9178 16.8787ZM17.3163 16.4802L17.8445 15.9478L18.379 16.4781L17.8466 17.0106L17.3163 16.4802ZM15.8171 19.4608L16.3475 19.9911L15.403 20.9356L15.0883 19.6375L15.8171 19.4608ZM15.657 18.8001L14.9281 18.9768L14.6178 17.697L15.8769 18.0831L15.657 18.8001ZM20.1613 20.1815L20.3812 19.4644L20.4413 19.4829L20.4976 19.5111L20.1613 20.1815ZM20.2614 20.2016V19.4516L20.2614 20.9516L20.2614 20.2016ZM20.2213 20.2216L19.691 19.6912L19.6928 19.6894L20.2213 20.2216ZM20.2013 20.2616H20.9513L19.4513 20.2616L20.2013 20.2616ZM20.1814 20.1615L19.5101 20.496L19.4825 20.4406L19.4643 20.3814L20.1814 20.1615ZM18.7999 15.6572L18.0828 15.8771L17.6967 14.618L18.9766 14.9283L18.7999 15.6572ZM19.4605 15.8174L19.6372 15.0885L20.9353 15.4032L19.9908 16.3477L19.4605 15.8174ZM19.5607 15.4169L19.7375 14.688L20.1525 14.7887L20.2777 15.197L19.5607 15.4169ZM20.9421 19.9212L21.6591 19.7013L21.6593 19.702L20.9421 19.9212ZM19.9211 20.9421L20.141 20.2251L20.1497 20.2278L20.1584 20.2306L19.9211 20.9421ZM15.4168 19.5608L15.1969 20.2778L14.7886 20.1526L14.688 19.7375L15.4168 19.5608ZM15.2567 18.9001L14.5278 19.0769L14.4286 18.6676L14.7263 18.3698L15.2567 18.9001ZM18.9001 15.2567L18.3698 14.7263L18.6676 14.4285L19.0769 14.5278L18.9001 15.2567ZM5.50733 9.15094L6.03766 9.68127L4.75733 10.9616V9.15094H5.50733ZM5.50733 8.5904H4.75733V6.77974L6.03766 8.06007L5.50733 8.5904ZM15.637 18.72L16.1673 18.1897L17.4476 19.47H15.637V18.72ZM15.0764 18.72V19.47H13.2658L14.5461 18.1897L15.0764 18.72ZM18.7199 15.0766L18.1896 14.5462L19.4699 13.2659V15.0766H18.7199ZM18.7199 15.6371H19.4699V17.4478L18.1896 16.1674L18.7199 15.6371ZM8.59027 5.50747L8.05993 6.0378L6.7796 4.75747H8.59027V5.50747ZM9.1508 5.50747V4.75747H10.9615L9.68113 6.0378L9.1508 5.50747ZM8.8706 4.66667L8.34027 4.13634L8.8706 3.60601L9.40093 4.13634L8.8706 4.66667ZM19.5608 15.3568L20.0911 14.8265L20.6214 15.3568L20.0911 15.8872L19.5608 15.3568ZM15.3568 19.5608L15.8871 20.0912L15.3568 20.6215L14.8264 20.0912L15.3568 19.5608ZM4.6666 8.87067L4.13627 9.401L3.60594 8.87067L4.13627 8.34034L4.6666 8.87067ZM4.94687 8.5904L5.4772 9.12073L4.20335 10.3946L4.19687 8.5931L4.94687 8.5904ZM8.59033 4.94693L8.06001 4.4166L9.34033 3.13627V4.94693H8.59033ZM8.59033 5.50747H9.34033V7.31813L8.06001 6.0378L8.59033 5.50747ZM6.98877 3.90591L6.45844 4.43624V4.43624L6.98877 3.90591ZM6.42824 3.90591L5.89791 3.37558L5.89794 3.37555L6.42824 3.90591ZM3.92586 6.40829L3.39553 5.87796L3.92586 6.40829ZM3.92586 6.96882L4.41956 6.40424L4.43845 6.42075L4.45619 6.43849L3.92586 6.96882ZM5.52742 8.57038L6.05775 8.04005L7.33808 9.32038H5.52742V8.57038ZM4.94679 8.57038L4.1968 8.57308L4.19409 7.82038H4.94679V8.57038ZM3.34531 7.54938L2.815 8.07973L2.81498 8.07971L3.34531 7.54938ZM3.34531 5.84768L2.81489 5.31744L2.81498 5.31735L3.34531 5.84768ZM5.84769 3.3453L6.37802 3.87563V3.87563L5.84769 3.3453ZM7.54938 3.3453L8.07963 2.81489L8.07971 2.81497L7.54938 3.3453ZM9.43121 5.22713L9.96154 4.6968L10.4919 5.22713L9.96154 5.75746L9.43121 5.22713ZM5.22721 9.43113L5.75754 9.96146L5.22723 10.4918L4.6969 9.96148L5.22721 9.43113ZM21.0203 18.1903L21.3005 19.7918L19.823 20.0504L19.5427 18.4488L21.0203 18.1903ZM21.2997 19.787C21.3748 20.2004 21.2838 20.6495 20.9537 20.9726C20.6268 21.2926 20.1815 21.3748 19.7809 21.2986L20.0613 19.825C20.0812 19.8288 19.9962 19.8108 19.9045 19.9006C19.8629 19.9414 19.8401 19.987 19.8304 20.0229C19.8212 20.057 19.8267 20.0707 19.8238 20.0552L21.2997 19.787ZM19.7918 21.3006L18.1902 21.0203L18.4488 19.5428L20.0504 19.823L19.7918 21.3006ZM7.17913 7.47914C7.27176 7.57177 7.42644 7.57181 7.51913 7.47911L6.45842 6.4185C6.95156 5.92531 7.74667 5.92535 8.23979 6.41848L7.17913 7.47914ZM7.5191 7.47914C7.61173 7.38651 7.61178 7.23182 7.51908 7.13913L6.45847 8.19985C5.96528 7.70671 5.96532 6.9116 6.45844 6.41848L7.5191 7.47914ZM7.51701 7.13708L17.1238 16.6685L16.0673 17.7333L6.46054 8.20191L7.51701 7.13708ZM16.5956 17.2009C16.0653 16.6705 16.0653 16.6705 16.0653 16.6705C16.0653 16.6705 16.0653 16.6705 16.0653 16.6705C16.0653 16.6705 16.0653 16.6705 16.0653 16.6705C16.0653 16.6705 16.0653 16.6705 16.0654 16.6705C16.0654 16.6704 16.0655 16.6703 16.0656 16.6702C16.0659 16.67 16.0662 16.6696 16.0667 16.6691C16.0676 16.6682 16.069 16.6668 16.0709 16.6649C16.0746 16.6612 16.0802 16.6557 16.0875 16.6484C16.102 16.6338 16.1235 16.6123 16.1513 16.5846C16.2068 16.529 16.2873 16.4485 16.3874 16.3484L17.4482 17.409C17.348 17.5091 17.2675 17.5897 17.2119 17.6452C17.1841 17.673 17.1626 17.6945 17.1481 17.7091C17.1408 17.7164 17.1352 17.7219 17.1315 17.7257C17.1296 17.7275 17.1282 17.7289 17.1273 17.7299C17.1268 17.7303 17.1264 17.7307 17.1262 17.7309C17.1261 17.7311 17.126 17.7311 17.1259 17.7312C17.1259 17.7312 17.1259 17.7313 17.1259 17.7313C17.1259 17.7313 17.1259 17.7313 17.1259 17.7313C17.1259 17.7313 17.1258 17.7313 17.1258 17.7313C17.1258 17.7313 17.1258 17.7313 16.5956 17.2009ZM16.3875 16.3484C16.4876 16.2482 16.5872 16.1486 16.6618 16.074C16.6991 16.0367 16.7301 16.0057 16.7518 15.984C16.7627 15.9731 16.7712 15.9646 16.777 15.9588C16.7799 15.9559 16.7821 15.9537 16.7836 15.9522C16.7844 15.9514 16.785 15.9509 16.7853 15.9505C16.7855 15.9503 16.7857 15.9501 16.7858 15.95C16.7858 15.95 16.7859 15.95 16.7859 15.9499C16.7859 15.9499 16.7859 15.9499 16.7859 15.9499C16.7859 15.9499 16.7859 15.9499 16.7859 15.9499C16.7859 15.9499 16.7859 15.9499 17.3163 16.4802C17.8466 17.0106 17.8466 17.0106 17.8466 17.0106C17.8466 17.0106 17.8466 17.0106 17.8466 17.0106C17.8466 17.0106 17.8466 17.0106 17.8465 17.0106C17.8465 17.0106 17.8465 17.0107 17.8464 17.0107C17.8463 17.0108 17.8462 17.011 17.846 17.0111C17.8456 17.0115 17.8451 17.0121 17.8443 17.0128C17.8428 17.0143 17.8406 17.0166 17.8377 17.0195C17.8319 17.0253 17.8233 17.0338 17.8125 17.0447C17.7908 17.0664 17.7597 17.0974 17.7224 17.1347C17.6479 17.2093 17.5482 17.3089 17.4481 17.409L16.3875 16.3484ZM16.788 17.0127L7.18122 7.48122L8.2377 6.41639L17.8445 15.9478L16.788 17.0127ZM15.0883 19.6375L14.9281 18.9768L16.3859 18.6234L16.546 19.284L15.0883 19.6375ZM15.8769 18.0831L20.3812 19.4644L19.9414 20.8985L15.4371 19.5172L15.8769 18.0831ZM20.4976 19.5111C20.3665 19.4453 20.2482 19.4516 20.2614 19.4516V20.9516C20.2343 20.9516 20.0362 20.9578 19.8249 20.8518L20.4976 19.5111ZM20.2614 20.2016C20.2614 20.9516 20.2618 20.9516 20.2621 20.9516C20.2623 20.9516 20.2626 20.9516 20.2629 20.9516C20.2634 20.9516 20.2639 20.9516 20.2643 20.9516C20.2653 20.9516 20.2663 20.9516 20.2673 20.9516C20.2693 20.9515 20.2713 20.9515 20.2733 20.9515C20.2772 20.9514 20.2813 20.9513 20.2854 20.9512C20.2935 20.9509 20.3019 20.9505 20.3104 20.95C20.3274 20.9488 20.3453 20.947 20.3639 20.9444C20.4011 20.9391 20.4422 20.9302 20.4856 20.9158C20.5749 20.886 20.6686 20.8344 20.7498 20.7537L19.6928 19.6894C19.7942 19.5888 19.9078 19.5271 20.0122 19.4924C20.0631 19.4755 20.1104 19.4653 20.152 19.4594C20.1728 19.4564 20.1924 19.4545 20.2106 19.4533C20.2197 19.4527 20.2285 19.4523 20.237 19.452C20.2412 19.4518 20.2453 19.4517 20.2494 19.4517C20.2514 19.4516 20.2534 19.4516 20.2554 19.4516C20.2564 19.4516 20.2574 19.4516 20.2584 19.4516C20.2589 19.4516 20.2594 19.4516 20.2599 19.4516C20.2601 19.4516 20.2605 19.4516 20.2606 19.4516C20.261 19.4516 20.2614 19.4516 20.2614 20.2016ZM20.7516 20.7519C20.8339 20.6696 20.886 20.5748 20.9157 20.4853C20.9301 20.4417 20.9389 20.4006 20.9442 20.3636C20.9468 20.345 20.9486 20.3272 20.9497 20.3103C20.9503 20.3018 20.9507 20.2935 20.951 20.2854C20.9511 20.2814 20.9512 20.2774 20.9512 20.2734C20.9513 20.2714 20.9513 20.2694 20.9513 20.2675C20.9513 20.2665 20.9513 20.2655 20.9513 20.2645C20.9513 20.2641 20.9513 20.2636 20.9513 20.2631C20.9513 20.2628 20.9513 20.2625 20.9513 20.2624C20.9513 20.262 20.9513 20.2616 20.2013 20.2616C19.4513 20.2616 19.4513 20.2613 19.4513 20.2609C19.4513 20.2608 19.4513 20.2604 19.4513 20.2602C19.4513 20.2597 19.4513 20.2592 19.4513 20.2587C19.4513 20.2577 19.4514 20.2567 19.4514 20.2558C19.4514 20.2538 19.4514 20.2518 19.4514 20.2498C19.4515 20.2457 19.4516 20.2416 19.4517 20.2374C19.452 20.229 19.4524 20.2202 19.453 20.2112C19.4542 20.1931 19.4562 20.1735 19.4591 20.1527C19.465 20.1113 19.4751 20.0639 19.492 20.0129C19.5267 19.9083 19.5888 19.7934 19.691 19.6912L20.7516 20.7519ZM19.4513 20.2616C19.4513 20.2482 19.4451 20.3655 19.5101 20.496L20.8527 19.827C20.9576 20.0376 20.9513 20.2351 20.9513 20.2616H19.4513ZM19.4643 20.3814L18.0828 15.8771L19.5169 15.4373L20.8984 19.9416L19.4643 20.3814ZM18.9766 14.9283L19.6372 15.0885L19.2838 16.5463L18.6232 16.3861L18.9766 14.9283ZM19.9908 16.3477L16.3475 19.9911L15.2868 18.9304L18.9302 15.2871L19.9908 16.3477ZM20.2777 15.197L21.6591 19.7013L20.225 20.1411L18.8437 15.6368L20.2777 15.197ZM21.6593 19.702C21.8332 20.2709 21.7417 20.8899 21.3182 21.3189C20.8885 21.7542 20.2628 21.8466 19.6839 21.6536L20.1584 20.2306C20.2327 20.2554 20.2696 20.2497 20.2743 20.2488C20.2775 20.2482 20.2648 20.2508 20.2507 20.2651C20.2371 20.2789 20.2383 20.287 20.2408 20.2742C20.2435 20.2603 20.2481 20.2167 20.2248 20.1404L21.6593 19.702ZM19.7012 21.6592L15.1969 20.2778L15.6367 18.8437L20.141 20.2251L19.7012 21.6592ZM14.688 19.7375L14.5278 19.0769L15.9855 18.7234L16.1457 19.3841L14.688 19.7375ZM14.7263 18.3698L18.3698 14.7263L19.4305 15.787L15.787 19.4305L14.7263 18.3698ZM19.0769 14.5278L19.7375 14.688L19.3839 16.1458L18.7233 15.9855L19.0769 14.5278ZM4.75733 9.15094V8.5904H6.25733V9.15094H4.75733ZM6.03766 8.06007L16.1673 18.1897L15.1066 19.2504L4.977 9.12073L6.03766 8.06007ZM15.637 19.47H15.0764V17.97H15.637V19.47ZM14.5461 18.1897L18.1896 14.5462L19.2502 15.6069L15.6068 19.2504L14.5461 18.1897ZM19.4699 15.0766V15.6371H17.9699V15.0766H19.4699ZM18.1896 16.1674L8.05993 6.0378L9.12059 4.97714L19.2502 15.1068L18.1896 16.1674ZM8.59027 4.75747H9.1508V6.25747H8.59027V4.75747ZM9.68113 6.0378L6.03766 9.68127L4.977 8.62061L8.62047 4.97714L9.68113 6.0378ZM9.40093 4.13634L20.0911 14.8265L19.0304 15.8872L8.34027 5.197L9.40093 4.13634ZM20.0911 15.8872L15.8871 20.0912L14.8264 19.0305L19.0304 14.8265L20.0911 15.8872ZM14.8264 20.0912L4.13627 9.401L5.19693 8.34034L15.8871 19.0305L14.8264 20.0912ZM4.13627 8.34034L8.34027 4.13634L9.40093 5.197L5.19693 9.401L4.13627 8.34034ZM4.41654 8.06007L8.06001 4.4166L9.12067 5.47726L5.4772 9.12073L4.41654 8.06007ZM9.34033 4.94693V5.50747H7.84033V4.94693H9.34033ZM8.06001 6.0378L6.45844 4.43624L7.5191 3.37558L9.12067 4.97714L8.06001 6.0378ZM6.45844 4.43624C6.51448 4.49227 6.60337 4.53578 6.70852 4.53578C6.81365 4.53578 6.90253 4.49228 6.95854 4.43627L5.89794 3.37555C6.351 2.92254 7.06602 2.9225 7.5191 3.37558L6.45844 4.43624ZM6.95857 4.43624L4.45619 6.93862L3.39553 5.87796L5.89791 3.37558L6.95857 4.43624ZM4.45619 6.93862C4.56771 6.8271 4.62232 6.58154 4.41956 6.40424L3.43216 7.53341C2.90906 7.07598 2.96367 6.30982 3.39553 5.87796L4.45619 6.93862ZM4.45619 6.43849L6.05775 8.04005L4.99709 9.10071L3.39553 7.49915L4.45619 6.43849ZM5.52742 9.32038H4.94679V7.82038H5.52742V9.32038ZM5.69679 8.56769L5.69686 8.58771L4.19687 8.5931L4.1968 8.57308L5.69679 8.56769ZM2.81498 8.07971C2.06164 7.32636 2.06175 6.07081 2.81489 5.31744L3.87572 6.37793C3.70806 6.54565 3.70817 6.85158 3.87564 7.01905L2.81498 8.07971ZM2.81498 5.31735L5.31736 2.81497L6.37802 3.87563L3.87564 6.37801L2.81498 5.31735ZM5.31736 2.81497C6.0707 2.06163 7.32625 2.06175 8.07963 2.81489L7.01913 3.87571C6.85142 3.70805 6.54548 3.70817 6.37802 3.87563L5.31736 2.81497ZM8.07971 2.81497L9.96154 4.6968L8.90088 5.75746L7.01905 3.87563L8.07971 2.81497ZM9.96154 5.75746L5.75754 9.96146L4.69688 8.9008L8.90088 4.6968L9.96154 5.75746ZM4.6969 9.96148L2.815 8.07973L3.87562 7.01903L5.75752 8.90078L4.6969 9.96148Z",
                fill: color,
                mask: "url(#path-1-inside-1_1823_175)"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Elo.tsx


var Elo = function(param) {
    var _width = param.width, width = _width === void 0 ? 65 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _alt = param.alt, alt = _alt === void 0 ? "Elo" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.yellow.500 */.rS.colors.yellow[500] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.tertiary.900 */.rS.colors.tertiary[900] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.primary.850 */.rS.colors.primary[850] : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _fifthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 45 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.86889 0H42.0039C43.2947 0 44.3403 1.06411 44.3403 2.3779V25.6221C44.3403 26.9359 43.2947 28 42.0039 28H2.86889C1.57803 28 0.532471 26.9359 0.532471 25.6221V2.3779C0.532471 1.06411 1.57803 0 2.86889 0Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.90796 10.1686C10.2891 10.0396 10.6984 9.97236 11.1244 9.97236C12.9854 9.97236 14.5382 11.2953 14.8913 13.0498L17.526 12.5117C16.9206 9.52952 14.2859 7.28162 11.1244 7.28162C10.4013 7.28162 9.70616 7.39939 9.05591 7.61795L9.90796 10.1686Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.79675 18.7115L8.57934 16.6935C7.78334 15.9872 7.28444 14.9614 7.28444 13.8122C7.28444 12.6687 7.78334 11.6373 8.57934 10.9366L6.79675 8.92419C5.4458 10.1237 4.59375 11.8671 4.59375 13.8179C4.59375 15.763 5.4458 17.5119 6.79675 18.7115Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.8913 14.5858C14.5326 16.3404 12.9854 17.6577 11.1244 17.6577C10.6983 17.6577 10.2891 17.5904 9.90234 17.4615L9.05029 20.012C9.70054 20.2306 10.4012 20.3484 11.1244 20.3484C14.2859 20.3484 16.9206 18.1061 17.526 15.124L14.8913 14.5858Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.3042 16.3908C25.867 16.8169 25.2784 17.0747 24.6281 17.0635C24.1797 17.0579 23.7649 16.9233 23.4173 16.6991L22.5428 18.0894C23.1426 18.4649 23.8433 18.6891 24.6057 18.7003C25.7099 18.7171 26.719 18.2799 27.4533 17.568L26.3042 16.3908ZM24.7234 10.7235C22.526 10.6899 20.7098 12.4501 20.6762 14.6475C20.665 15.4715 20.9004 16.2451 21.3208 16.8841L28.5408 13.7954C28.1372 12.0633 26.5901 10.7571 24.7234 10.7235ZM22.3298 14.9613C22.3186 14.8716 22.313 14.7763 22.313 14.681C22.3354 13.3861 23.4005 12.3491 24.6954 12.3716C25.4017 12.3827 26.0295 12.7023 26.4499 13.2068L22.3298 14.9613ZM30.8111 8.92969V16.6262L32.1453 17.1811L31.5118 18.7003L30.1889 18.1509C29.8918 18.022 29.69 17.8258 29.5386 17.6016C29.3928 17.3773 29.2807 17.0634 29.2807 16.6486V8.92969H30.8111ZM35.6264 12.4892C35.8618 12.4108 36.1085 12.3715 36.3719 12.3715C37.5099 12.3715 38.4517 13.1787 38.6702 14.2494L40.279 13.9187C39.9091 12.0969 38.3002 10.7291 36.3719 10.7291C35.9291 10.7291 35.503 10.802 35.1107 10.9309L35.6264 12.4892ZM33.726 17.6969L34.8135 16.4692C34.3258 16.0376 34.0231 15.4098 34.0231 14.7091C34.0231 14.0084 34.3314 13.3806 34.8135 12.9545L33.726 11.7269C32.902 12.4557 32.3807 13.5263 32.3807 14.7147C32.3807 15.9031 32.902 16.9681 33.726 17.6969ZM38.6702 15.1855C38.4517 16.2562 37.5042 17.0634 36.3719 17.0634C36.1141 17.0634 35.8618 17.0185 35.6264 16.9401L35.105 18.4985C35.503 18.6329 35.9291 18.7059 36.3719 18.7059C38.3002 18.7059 39.9091 17.3381 40.279 15.5163L38.6702 15.1855Z",
                fill: fifthColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/EmailFailureIcon.tsx

var EmailFailureIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 121 : _width, _height = param.height, height = _height === void 0 ? 120 : _height, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de e-mail para falha" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 121 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "60.5",
                cy: "59.875",
                r: "59.875",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M90.0003 75.8159L94.1726 68.5819",
                stroke: "#B2B3B5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M87.449 74.3448L89.9996 75.8159",
                stroke: "#B2B3B5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M89.1404 71.413L91.691 72.884",
                stroke: "#B2B3B5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.7818 68.9239C94.9472 69.4164 93.0607 68.3283 92.5683 66.4937C92.0758 64.6592 93.1639 62.7727 94.9984 62.2802C96.833 61.7878 98.7195 62.8758 99.2119 64.7104C99.7044 66.545 98.6164 68.4314 96.7818 68.9239",
                stroke: "#B2B3B5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M113.78 77.6606L110.623 73.7234",
                stroke: "#C3C4C5",
                strokeWidth: "1.04397",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M112.391 78.7739L113.779 77.6606",
                stroke: "#C3C4C5",
                strokeWidth: "1.04397",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M111.112 77.1782L112.5 76.0649",
                stroke: "#C3C4C5",
                strokeWidth: "1.04397",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M111.388 72.3289C111.262 73.47 110.236 74.2934 109.094 74.168C107.953 74.0426 107.13 73.0159 107.255 71.8748C107.381 70.7337 108.407 69.9104 109.549 70.0357C110.69 70.1611 111.513 71.1878 111.388 72.3289",
                stroke: "#C3C4C5",
                strokeWidth: "1.04397",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M86.9067 39.4858L81.3091 33.2885",
                stroke: "#C3C4C5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.7215 41.4595L86.9066 39.4858",
                stroke: "#C3C4C5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.452 38.948L84.6371 36.9743",
                stroke: "#C3C4C5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.438 30.9106C82.3416 32.8077 80.7255 34.2674 78.8284 34.171C76.9313 34.0745 75.4716 32.4584 75.568 30.5613C75.6645 28.6642 77.2806 27.2045 79.1777 27.301C81.0748 27.3974 82.5345 29.0135 82.438 30.9106",
                stroke: "#C3C4C5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.6689 72.6455L29.1242 66.6545",
                stroke: "#B2B3B5",
                strokeWidth: "1.4306",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.5564 71.427L25.6687 72.6453",
                stroke: "#B2B3B5",
                strokeWidth: "1.4306",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.9568 68.9988L27.0691 70.2171",
                stroke: "#B2B3B5",
                strokeWidth: "1.4306",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.2855 66.9379C29.7662 67.3457 28.2039 66.4446 27.7961 64.9253C27.3882 63.406 28.2893 61.8437 29.8086 61.4359C31.3279 61.0281 32.8902 61.9291 33.298 63.4484C33.7058 64.9678 32.8048 66.53 31.2855 66.9379",
                stroke: "#B2B3B5",
                strokeWidth: "1.4306",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M100.381 35.3737L102.483 31.7292",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M99.0968 34.6327L100.382 35.3738",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M99.9503 33.1554L101.235 33.8965",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M103.799 31.9018C102.875 32.1499 101.925 31.6018 101.677 30.6775C101.428 29.7533 101.977 28.8029 102.901 28.5548C103.825 28.3067 104.776 28.8548 105.024 29.7791C105.272 30.7034 104.724 31.6537 103.799 31.9018",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M71.1372 18.6643L73.2392 15.0197",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.8527 17.9232L71.1377 18.6644",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M70.7062 16.4459L71.9912 17.1871",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M74.5552 15.1924C73.6309 15.4405 72.6805 14.8923 72.4324 13.9681C72.1843 13.0438 72.7324 12.0934 73.6567 11.8453C74.581 11.5972 75.5314 12.1454 75.7795 13.0696C76.0276 13.9939 75.4794 14.9443 74.5552 15.1924",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.8491 25.6403L39.225 18.0532",
                stroke: "#B2B3B5",
                strokeWidth: "1.81175",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.1755 24.0976L34.8506 25.6405",
                stroke: "#B2B3B5",
                strokeWidth: "1.81175",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.949 21.0226L36.624 22.5655",
                stroke: "#B2B3B5",
                strokeWidth: "1.81175",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.9633 18.4124C40.0392 18.9289 38.0607 17.7878 37.5442 15.8637C37.0277 13.9396 38.1688 11.9611 40.0929 11.4446C42.017 10.9281 43.9955 12.0692 44.512 13.9933C45.0285 15.9174 43.8874 17.8959 41.9633 18.4124",
                stroke: "#B2B3B5",
                strokeWidth: "1.81175",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.7855 44.7413L19.6329 46.437C18.9531 46.6244 18.2506 46.2255 18.0633 45.5457L16.8763 41.2388C16.6889 40.559 17.0878 39.8565 17.7676 39.6692L23.9203 37.9734C24.6001 37.7861 25.3026 38.185 25.4899 38.8648L26.6769 43.1717C26.8643 43.8515 26.4654 44.554 25.7855 44.7413Z",
                stroke: "#C3C4C5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.3823 39.4997L17.8736 37.6539V37.6539C17.499 36.2948 18.2972 34.8892 19.6564 34.5146V34.5146C21.0155 34.14 22.4211 34.9382 22.7957 36.2974V36.2974L23.3044 38.1431",
                stroke: "#C3C4C5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M96.8324 95.2013L91.6904 91.421C91.1223 91.0033 91.0004 90.2048 91.4181 89.6366L94.0643 86.0372C94.482 85.469 95.2805 85.3471 95.8487 85.7648L100.991 89.5451C101.559 89.9628 101.681 90.7613 101.263 91.3295L98.6169 94.9289C98.1992 95.4971 97.4006 95.619 96.8324 95.2013Z",
                stroke: "#C3C4C5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.3636 86.1428L97.4977 84.6003V84.6003C98.3327 83.4644 99.9307 83.2205 101.067 84.0556V84.0556C102.202 84.8906 102.446 86.4886 101.611 87.6244V87.6244L100.477 89.167",
                stroke: "#C3C4C5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M109.33 54.4884L103.178 56.1841C102.498 56.3715 101.796 55.9726 101.608 55.2927L100.421 50.9859C100.234 50.306 100.633 49.6036 101.313 49.4162L107.465 47.7205C108.145 47.5331 108.847 47.932 109.035 48.6119L110.222 52.9187C110.409 53.5986 110.01 54.301 109.33 54.4884Z",
                stroke: "#B2B3B5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M101.927 49.2465L101.419 47.4007V47.4007C101.044 46.0416 101.842 44.636 103.201 44.2614V44.2614C104.56 43.8868 105.966 44.6851 106.341 46.0442V46.0442L106.849 47.89",
                stroke: "#B2B3B5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M94.293 54.9266L90.3366 57.869C89.8994 58.1942 89.282 58.1034 88.9568 57.6663L86.8971 54.8968C86.5719 54.4596 86.6627 53.8421 87.0999 53.517L91.0563 50.5745C91.4935 50.2494 92.1109 50.3401 92.4361 50.7773L94.4958 53.5468C94.821 53.984 94.7302 54.6014 94.293 54.9266Z",
                stroke: "#C3C4C5",
                strokeWidth: "1.00668",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M87.4972 53.2226L86.6145 52.0357V52.0357C85.9645 51.1617 86.1461 49.9261 87.0201 49.2761V49.2761C87.894 48.6261 89.1296 48.8077 89.7796 49.6817V49.6817L90.6624 50.8687",
                stroke: "#C3C4C5",
                strokeWidth: "1.00668",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.7097 63.6294L6.64156 62.3508C6.19203 62.2095 5.94236 61.731 6.08365 61.2814L6.97866 58.4337C7.11994 57.9842 7.59847 57.7346 8.048 57.8758L12.1162 59.1544C12.5657 59.2957 12.8153 59.7742 12.6741 60.2238L11.7791 63.0715C11.6378 63.521 11.1592 63.7707 10.7097 63.6294Z",
                stroke: "#B2B3B5",
                strokeWidth: "0.870636",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.4546 58.0037L8.83818 56.7833V56.7833C9.12061 55.8846 10.0782 55.385 10.9769 55.6674V55.6674C11.8755 55.9499 12.3751 56.9075 12.0927 57.8061V57.8061L11.7091 59.0266",
                stroke: "#B2B3B5",
                strokeWidth: "0.870636",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M36.4705 53.3276L33.398 54.6489C33.0585 54.7949 32.6653 54.6382 32.5193 54.2987L31.5943 52.1479C31.4483 51.8084 31.6051 51.4152 31.9446 51.2692L35.017 49.9479C35.3565 49.8019 35.7498 49.9586 35.8958 50.2981L36.8207 52.4488C36.9667 52.7883 36.81 53.1816 36.4705 53.3276Z",
                stroke: "#C3C4C5",
                strokeWidth: "0.682843",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.255 51.1371L31.8586 50.2153V50.2153C31.5667 49.5366 31.8804 48.7497 32.5591 48.4578V48.4578C33.2378 48.1659 34.0247 48.4796 34.3166 49.1583V49.1583L34.713 50.08",
                stroke: "#C3C4C5",
                strokeWidth: "0.682843",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M87.4023 22.9663L82.2602 20.6149C81.692 20.355 81.4422 19.6844 81.702 19.1162L83.3481 15.5167C83.6079 14.9485 84.2786 14.6987 84.8468 14.9586L89.9889 17.31C90.5571 17.5699 90.8068 18.2406 90.547 18.8088L88.901 22.4082C88.6411 22.9764 87.9705 23.2262 87.4023 22.9663Z",
                stroke: "#B2B3B5",
                strokeWidth: "1.15441",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M85.3618 15.1937L86.0672 13.6511V13.6511C86.5867 12.5152 87.9288 12.0154 89.0646 12.5348V12.5348C90.2005 13.0543 90.7003 14.3964 90.1809 15.5323V15.5323L89.4755 17.0749",
                stroke: "#B2B3B5",
                strokeWidth: "1.15441",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.1762 93.4767L21.0235 95.1724C20.3437 95.3598 19.6413 94.9609 19.4539 94.281L18.2669 89.9742C18.0795 89.2943 18.4784 88.5919 19.1583 88.4045L25.3109 86.7088C25.9908 86.5214 26.6932 86.9203 26.8806 87.6002L28.0676 91.907C28.2549 92.5869 27.856 93.2893 27.1762 93.4767Z",
                stroke: "#B2B3B5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.7729 88.2348L19.2642 86.389V86.389C18.8896 85.0299 19.6879 83.6243 21.047 83.2497V83.2497C22.4061 82.8751 23.8117 83.6733 24.1863 85.0325V85.0325L24.695 86.8782",
                stroke: "#B2B3B5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "59.8034",
                cy: "104.572",
                rx: "22.9753",
                ry: "1.53169",
                fill: "#C3C4C5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M57.4447 86.9102H77.9122C83.7328 86.9102 88.4514 82.1916 88.4514 76.3709V52.2185C88.4514 48.5847 86.5794 45.2072 83.4979 43.2813L65.9326 32.3029C62.515 30.1669 58.1786 30.1669 54.761 32.3029L37.1956 43.2813C34.1141 45.2072 32.2422 48.5847 32.2422 52.2185L32.2422 65.068",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M57.4447 86.9102H77.9122C83.7328 86.9102 88.4514 82.1916 88.4514 76.3709V52.2185C88.4514 48.5847 86.5794 45.2072 83.4979 43.2813L65.9326 32.3029C62.515 30.1669 58.1786 30.1669 54.761 32.3029L37.1956 43.2813C34.1141 45.2072 32.2422 48.5847 32.2422 52.2185L32.2422 65.068",
                stroke: "#47494D",
                strokeWidth: "3.32639",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.3245 31.6198C65.9052 30.9745 86.5873 46.7834 86.2738 48.0739C85.9604 49.3644 62.1449 59.0433 60.2647 59.0433C58.3844 59.0433 51.0254 55.6873 45.8499 53.5586C40.8651 51.5084 33.1588 49.6871 33.9421 48.0739C34.7254 46.4608 40.5228 42.2666 47.1035 38.395C51.9681 35.1296 56.4267 31.904 59.3245 31.6198Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M85.4466 48.2324L64.5131 58.1956C62.4811 59.3257 60.0955 59.3257 58.0635 58.1956L35.5508 48.2324",
                stroke: "#47494D",
                strokeWidth: "3.32639",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "46.7538",
                cy: "73.622",
                r: "15.5203",
                fill: "#BE0F2C",
                stroke: "white",
                strokeWidth: "3.32639"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40.543 67.3594L53.2941 80.1105",
                stroke: "#F6F7F7",
                strokeWidth: "2.8429",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.2941 67.3594L40.543 80.1105",
                stroke: "#F6F7F7",
                strokeWidth: "2.8429",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/EmailIcon.tsx


var EmailIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.00049 9.06797V9.06797C4.00049 9.86797 4.40049 10.5346 5.06715 11.068L13.0672 16.5346C14.9338 17.7346 17.2005 17.7346 19.0672 16.5346L27.0672 11.2013C27.6005 10.5346 28.0005 9.86797 28.0005 9.06797V9.06797C28.0005 7.73464 26.9338 6.66797 25.6005 6.66797H6.40049C5.06715 6.66797 4.00049 7.73464 4.00049 9.06797Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.00049 9.33496V22.6683C4.00049 24.135 5.20049 25.335 6.66716 25.335H25.3338C26.8005 25.335 28.0005 24.135 28.0005 22.6683V9.33496",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.78467 24.5511L12.91 16.4258",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.147 16.4814L27.2163 24.5508",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/EmailLetterMessage.tsx


var EmailLetterMessage = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Email usu\xe1rio logado" : _alt, _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.33 */.rS.colors.secondary[33] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.25171 34.3317C3.89361 26.6843 5.27022 16.2098 12.4224 10.2066C19.5745 4.2033 30.129 4.66319 36.7319 11.2658C43.3348 17.8684 43.7951 28.4229 37.7921 35.5753C31.7892 42.7277 21.3148 44.1047 13.6671 38.7469L7.99023 40.0084L9.25171 34.3317Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.2468 20.4985V27.5014C15.2468 29.4352 16.8145 31.0029 18.7483 31.0029H29.2527C31.1865 31.0029 32.7541 29.4352 32.7541 27.5014V20.4985C32.7541 18.5647 31.1865 16.9971 29.2527 16.9971H18.7483C17.8196 16.9971 16.929 17.366 16.2724 18.0226C15.6157 18.6793 15.2468 19.5699 15.2468 20.4985Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.0194 21.9991L22.9959 23.7246C23.6301 24.0918 24.4122 24.0918 25.0464 23.7246L28.0227 21.9991",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/ui/Icons/EmailValidationIcon.tsx

var EmailValidationIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 118 : _width, _height = param.height, height = _height === void 0 ? 117 : _height, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de email com um check" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 118 117",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "58.999",
                cy: "58.752",
                r: "58.124",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M87.6369 74.2265L91.6872 67.204",
                stroke: "#B2B3B5",
                strokeWidth: "1.71887",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M85.1606 72.7978L87.6366 74.2259",
                stroke: "#B2B3B5",
                strokeWidth: "1.71887",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M86.8012 69.9521L89.2772 71.3802",
                stroke: "#B2B3B5",
                strokeWidth: "1.71887",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.2173 67.5357C92.4364 68.0138 90.6051 66.9576 90.127 65.1766C89.649 63.3957 90.7052 61.5644 92.4861 61.0864C94.2671 60.6083 96.0983 61.6645 96.5764 63.4455C97.0545 65.2264 95.9983 67.0577 94.2173 67.5357",
                stroke: "#B2B3B5",
                strokeWidth: "1.71887",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.727 76.0173L107.662 72.1953",
                stroke: "#C3C4C5",
                strokeWidth: "1.03877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M109.378 77.0986L110.726 76.0178",
                stroke: "#C3C4C5",
                strokeWidth: "1.03877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M108.138 75.5497L109.485 74.469",
                stroke: "#C3C4C5",
                strokeWidth: "1.03877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M108.405 70.8421C108.283 71.9498 107.287 72.7491 106.179 72.6274C105.071 72.5056 104.272 71.509 104.394 70.4012C104.515 69.2935 105.512 68.4942 106.62 68.6159C107.727 68.7377 108.527 69.7343 108.405 70.8421",
                stroke: "#C3C4C5",
                strokeWidth: "1.03877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.6272 38.9583L79.1933 32.9423",
                stroke: "#C3C4C5",
                strokeWidth: "1.71887",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.5076 40.874L84.6288 38.9581",
                stroke: "#C3C4C5",
                strokeWidth: "1.71887",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.3064 38.4365L82.4276 36.5206",
                stroke: "#C3C4C5",
                strokeWidth: "1.71887",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.292 30.6343C80.1984 32.4759 78.6296 33.8929 76.788 33.7993C74.9464 33.7057 73.5293 32.1368 73.623 30.2952C73.7166 28.4536 75.2854 27.0366 77.127 27.1302C78.9687 27.2239 80.3857 28.7927 80.292 30.6343",
                stroke: "#C3C4C5",
                strokeWidth: "1.71887",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.1832 71.1487L28.5374 65.333",
                stroke: "#B2B3B5",
                strokeWidth: "1.42348",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.135 69.9655L25.1855 71.1481",
                stroke: "#B2B3B5",
                strokeWidth: "1.42348",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.4944 67.609L26.5449 68.7917",
                stroke: "#B2B3B5",
                strokeWidth: "1.42348",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.6374 65.6081C29.1625 66.004 27.646 65.1293 27.25 63.6544C26.8541 62.1795 27.7288 60.663 29.2037 60.2671C30.6786 59.8712 32.1952 60.7459 32.5911 62.2208C32.987 63.6956 32.1123 65.2122 30.6374 65.6081",
                stroke: "#B2B3B5",
                strokeWidth: "1.42348",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M97.7197 34.9678L99.7602 31.4298",
                stroke: "#C3C4C5",
                strokeWidth: "0.865963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.4715 34.2479L97.7189 34.9673",
                stroke: "#C3C4C5",
                strokeWidth: "0.865963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M97.2976 32.8143L98.5451 33.5337",
                stroke: "#C3C4C5",
                strokeWidth: "0.865963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M101.035 31.5968C100.138 31.8376 99.2152 31.3055 98.9744 30.4083C98.7335 29.511 99.2657 28.5884 100.163 28.3476C101.06 28.1068 101.983 28.6389 102.224 29.5361C102.464 30.4333 101.932 31.3559 101.035 31.5968",
                stroke: "#C3C4C5",
                strokeWidth: "0.865963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.3232 18.7471L71.3637 15.2091",
                stroke: "#C3C4C5",
                strokeWidth: "0.865963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M68.075 18.0272L69.3224 18.7466",
                stroke: "#C3C4C5",
                strokeWidth: "0.865963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M68.9012 16.5936L70.1486 17.313",
                stroke: "#C3C4C5",
                strokeWidth: "0.865963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M72.6386 15.3761C71.7413 15.6169 70.8187 15.0848 70.5779 14.1876C70.3371 13.2903 70.8692 12.3677 71.7664 12.1269C72.6636 11.8861 73.5862 12.4182 73.8271 13.3154C74.0679 14.2126 73.5358 15.1352 72.6386 15.3761",
                stroke: "#C3C4C5",
                strokeWidth: "0.865963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.1455 30.209L64.186 26.671",
                stroke: "#C3C4C5",
                strokeWidth: "0.865963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M60.8973 29.4891L62.1447 30.2085",
                stroke: "#C3C4C5",
                strokeWidth: "0.865963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M61.7234 28.0555L62.9708 28.7749",
                stroke: "#C3C4C5",
                strokeWidth: "0.865963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M65.4608 26.838C64.5636 27.0788 63.641 26.5467 63.4002 25.6495C63.1593 24.7522 63.6914 23.8297 64.5887 23.5888C65.4859 23.348 66.4085 23.8801 66.6493 24.7773C66.8902 25.6745 66.3581 26.5971 65.4608 26.838",
                stroke: "#C3C4C5",
                strokeWidth: "0.865963",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0997 25.5191L38.3476 18.1539",
                stroke: "#B2B3B5",
                strokeWidth: "1.80274",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.5044 24.0209L34.1012 25.5186",
                stroke: "#B2B3B5",
                strokeWidth: "1.80274",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.227 21.0355L35.8239 22.5333",
                stroke: "#B2B3B5",
                strokeWidth: "1.80274",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.0077 18.5018C39.1399 19.0032 37.2193 17.8955 36.7179 16.0276C36.2165 14.1598 37.3242 12.2392 39.1921 11.7378C41.0599 11.2364 42.9806 12.3441 43.4819 14.212C43.9833 16.0798 42.8756 18.0004 41.0077 18.5018",
                stroke: "#B2B3B5",
                strokeWidth: "1.80274",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.3022 44.0604L19.3295 45.7066C18.6695 45.8885 17.9876 45.5012 17.8057 44.8412L16.6534 40.6604C16.4715 40.0004 16.8588 39.3185 17.5188 39.1366L23.4915 37.4905C24.1514 37.3086 24.8333 37.6958 25.0152 38.3558L26.1675 42.5367C26.3494 43.1967 25.9622 43.8785 25.3022 44.0604Z",
                stroke: "#C3C4C5",
                strokeWidth: "1.29651",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.1171 38.9719L17.6233 37.1801V37.1801C17.2597 35.8607 18.0346 34.4962 19.3539 34.1326V34.1326C20.6733 33.7689 22.0378 34.5438 22.4015 35.8632V35.8632L22.8953 37.655",
                stroke: "#C3C4C5",
                strokeWidth: "1.29651",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M94.2658 93.0458L89.2742 89.3761C88.7226 88.9706 88.6043 88.1954 89.0098 87.6438L91.5786 84.1497C91.9841 83.5981 92.7592 83.4798 93.3108 83.8853L98.3024 87.555C98.854 87.9605 98.9723 88.7357 98.5668 89.2873L95.998 92.7814C95.5925 93.333 94.8173 93.4513 94.2658 93.0458Z",
                stroke: "#C3C4C5",
                strokeWidth: "1.29651",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M93.814 84.2519L94.9149 82.7545V82.7545C95.7256 81.6518 97.2768 81.4151 98.3795 82.2257V82.2257C99.4821 83.0363 99.7189 84.5876 98.9082 85.6902V85.6902L97.8073 87.1877",
                stroke: "#C3C4C5",
                strokeWidth: "1.29651",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M106.408 53.5224L100.435 55.1685C99.775 55.3504 99.0931 54.9631 98.9112 54.3032L97.7589 50.1223C97.577 49.4623 97.9642 48.7804 98.6242 48.5985L104.597 46.9524C105.257 46.7705 105.939 47.1577 106.121 47.8177L107.273 51.9986C107.455 52.6586 107.068 53.3405 106.408 53.5224Z",
                stroke: "#B2B3B5",
                strokeWidth: "1.29651",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M99.2226 48.4338L98.7288 46.642V46.642C98.3651 45.3226 99.14 43.9581 100.459 43.5945V43.5945C101.779 43.2309 103.143 44.0057 103.507 45.3251V45.3251L104.001 47.1169",
                stroke: "#B2B3B5",
                strokeWidth: "1.29651",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M91.8017 53.9485L87.961 56.8049C87.5366 57.1205 86.9372 57.0324 86.6216 56.608L84.6221 53.9195C84.3064 53.4951 84.3945 52.8957 84.8189 52.5801L88.6597 49.7237C89.0841 49.408 89.6835 49.4961 89.9991 49.9205L91.9986 52.609C92.3142 53.0334 92.2261 53.6328 91.8017 53.9485Z",
                stroke: "#C3C4C5",
                strokeWidth: "1.00167",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M85.2026 52.294L84.3457 51.1418V51.1418C83.7147 50.2933 83.891 49.0939 84.7394 48.4629V48.4629C85.5878 47.8319 86.7873 48.0082 87.4183 48.8566V48.8566L88.2752 50.0088",
                stroke: "#C3C4C5",
                strokeWidth: "1.00167",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.6628 62.396L6.71358 61.1548C6.2772 61.0177 6.03484 60.5531 6.17199 60.1168L7.04082 57.3523C7.17798 56.916 7.64251 56.6736 8.0789 56.8107L12.0281 58.0519C12.4645 58.1891 12.7068 58.6536 12.5697 59.09L11.7008 61.8544C11.5637 62.2908 11.0991 62.5332 10.6628 62.396Z",
                stroke: "#B2B3B5",
                strokeWidth: "0.866305",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.47296 56.9353L8.84532 55.7506V55.7506C9.1195 54.8782 10.0491 54.3932 10.9215 54.6674V54.6674C11.7938 54.9416 12.2788 55.8712 12.0047 56.7435V56.7435L11.6323 57.9283",
                stroke: "#B2B3B5",
                strokeWidth: "0.866305",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M35.6756 52.396L32.693 53.6786C32.3634 53.8204 31.9817 53.6682 31.84 53.3387L30.9421 51.2508C30.8003 50.9212 30.9525 50.5395 31.2821 50.3978L34.2647 49.1151C34.5943 48.9734 34.976 49.1255 35.1177 49.4551L36.0156 51.5429C36.1574 51.8725 36.0052 52.2542 35.6756 52.396Z",
                stroke: "#C3C4C5",
                strokeWidth: "0.679446",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.5795 50.2695L31.1947 49.3747V49.3747C30.9114 48.7158 31.2158 47.9519 31.8747 47.6686V47.6686C32.5335 47.3852 33.2975 47.6897 33.5808 48.3486V48.3486L33.9656 49.2433",
                stroke: "#C3C4C5",
                strokeWidth: "0.679446",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M85.1178 22.9225L80.126 20.6398C79.5745 20.3876 79.332 19.7365 79.5842 19.1849L81.1821 15.6907C81.4344 15.1391 82.0854 14.8967 82.637 15.1489L87.6287 17.4316C88.1803 17.6839 88.4228 18.3349 88.1705 18.8865L86.5726 22.3807C86.3204 22.9323 85.6693 23.1748 85.1178 22.9225Z",
                stroke: "#B2B3B5",
                strokeWidth: "1.14867",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M83.1345 15.377L83.8193 13.8795V13.8795C84.3236 12.7768 85.6264 12.2916 86.7291 12.7959V12.7959C87.8318 13.3001 88.317 14.603 87.8127 15.7057V15.7057L87.1279 17.2032",
                stroke: "#B2B3B5",
                strokeWidth: "1.14867",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M50.1105 34.1532L44.6221 34.2323C44.0157 34.241 43.5174 33.7569 43.5087 33.1504L43.4533 29.3086C43.4446 28.7021 43.9287 28.2039 44.5352 28.1951L50.0235 28.116C50.63 28.1073 51.1282 28.5914 51.137 29.1979L51.1923 33.0397C51.2011 33.6462 50.7169 34.1445 50.1105 34.1532Z",
                stroke: "#B2B3B5",
                strokeWidth: "1.14867",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.0846 28.1875L45.0609 26.541V26.541C45.0435 25.3287 46.0123 24.3315 47.2246 24.3141V24.3141C48.437 24.2966 49.4341 25.2654 49.4516 26.4778V26.4778L49.4753 28.1243",
                stroke: "#B2B3B5",
                strokeWidth: "1.14867",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M59.8293 14.8935L55.4313 13.3301C54.9453 13.1573 54.6916 12.6238 54.8644 12.1378L55.9588 9.05928C56.1316 8.5733 56.6651 8.31961 57.1511 8.49237L61.549 10.0558C62.035 10.2285 62.2887 10.7621 62.1159 11.2481L61.0215 14.3266C60.8488 14.8126 60.3152 15.0663 59.8293 14.8935Z",
                stroke: "#B2B3B5",
                strokeWidth: "1.14867",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M57.5912 8.64887L58.0602 7.32949V7.32949C58.4055 6.35798 59.4732 5.85032 60.4447 6.19568V6.19568C61.4162 6.54104 61.9239 7.60872 61.5785 8.58022V8.58022L61.1095 9.89961",
                stroke: "#B2B3B5",
                strokeWidth: "1.14867",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.6499 91.371L20.6772 93.0171C20.0172 93.199 19.3353 92.8118 19.1534 92.1518L18.0011 87.9709C17.8192 87.3109 18.2064 86.629 18.8664 86.4471L24.8391 84.801C25.4991 84.6191 26.181 85.0064 26.3629 85.6663L27.5152 89.8472C27.6971 90.5072 27.3098 91.1891 26.6499 91.371Z",
                stroke: "#B2B3B5",
                strokeWidth: "1.29651",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.4648 86.2825L18.9709 84.4906V84.4906C18.6073 83.1713 19.3822 81.8067 20.7016 81.4431V81.4431C22.0209 81.0795 23.3855 81.8544 23.7491 83.1737V83.1737L24.2429 84.9656",
                stroke: "#B2B3B5",
                strokeWidth: "1.29651",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "58.3229",
                cy: "102.142",
                rx: "22.3034",
                ry: "1.48689",
                fill: "#C3C4C5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M56.028 91.5215H75.8969C81.5473 91.5215 86.1279 86.9409 86.1279 81.2905V57.8444C86.1279 54.3168 84.3107 51.0381 81.3193 49.1685L64.2677 38.5112C60.95 36.4377 56.7404 36.4377 53.4228 38.5112L36.3711 49.1685C33.3797 51.0381 31.5625 54.3168 31.5625 57.8444L31.5625 70.3181",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56.028 91.5215H75.8969C81.5473 91.5215 86.1279 86.9409 86.1279 81.2905V57.8444C86.1279 54.3168 84.3107 51.0381 81.3193 49.1685L64.2676 38.5112C60.95 36.4377 56.7404 36.4377 53.4228 38.5112L36.3711 49.1685C33.3797 51.0381 31.5625 54.3168 31.5625 57.8444L31.5625 70.3181",
                stroke: "#47494D",
                strokeWidth: "3.30984",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58.9382 38.0582C65.4861 37.4161 86.0653 53.1463 85.7534 54.4304C85.4415 55.7145 61.7446 65.3453 59.8737 65.3452C58.0027 65.3452 50.6804 62.0059 45.5306 59.8878C40.5707 57.8478 32.9026 56.0356 33.682 54.4304C34.4614 52.8253 40.23 48.652 46.7779 44.7997C51.6184 41.5506 56.0548 38.3409 58.9382 38.0582Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.0194 53.9092L63.3593 63.581C61.3539 64.6781 58.9994 64.6781 56.994 63.581L34.7754 53.9092",
                stroke: "#47494D",
                strokeWidth: "3.30984",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "44.1685",
                cy: "80.1031",
                rx: "15.5689",
                ry: "15.5689",
                fill: "#7AC143"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M44.1646 95.6721V95.6721C35.5654 95.6721 28.5957 88.7024 28.5957 80.1031V80.1031C28.5957 71.5039 35.5654 64.5342 44.1646 64.5342V64.5342C52.7639 64.5342 59.7336 71.5039 59.7336 80.1031V80.1031C59.7336 88.7024 52.7639 95.6721 44.1646 95.6721Z",
                stroke: "#F6F7F7",
                strokeWidth: "3.30984",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.0852 76.6436L42.4357 85.293L37.2461 80.1033",
                stroke: "#F6F7F7",
                strokeWidth: "3.30984",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/EmployeeIcon.tsx


var EmployeeIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 25 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de um colaborador" : _alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 25",
        fill: "none",
        "aria-label": alt,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 21.5V21.0285C3 19.5985 4.00938 18.3672 5.41165 18.0868L8.25765 17.5176C8.49288 17.4705 8.73716 17.5188 8.93676 17.6519V17.6519C10.7917 18.8886 13.2083 18.8886 15.0633 17.6519V17.6519C15.2629 17.5188 15.5072 17.4705 15.7424 17.5176L18.5884 18.0868C19.9906 18.3672 21 19.5985 21 21.0285V21.5",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 21.4993V17.5684",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 21.4993V17.5684",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.83496 9.5H16.1653C16.7176 9.5 17.1653 9.05228 17.1653 8.5V7.66515C17.1653 6.29527 16.6211 4.98149 15.6524 4.01283C14.6838 3.04418 13.37 2.5 12.0001 2.5V2.5C10.6302 2.5 9.31646 3.04418 8.3478 4.01283C7.37915 4.98149 6.83496 6.29527 6.83496 7.66515V8.5C6.83496 9.05228 7.28268 9.5 7.83496 9.5Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.5 9.5H17.5",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 9.5V11.4995C16 13.7086 14.2091 15.4995 12 15.4995V15.4995C9.79086 15.4995 8 13.7086 8 11.4995V9.5",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1009 14.9043L14.8249 17.8008",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.90108 14.9043L9.17704 17.8007",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.5 2.7207V4.09989C13.5 4.92832 12.8284 5.59989 12 5.59989V5.59989C11.1716 5.59989 10.5 4.92832 10.5 4.09989V2.7207",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 21.5H17",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/EraseIcon.tsx


var EraseIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de borracha" : _alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.018 13.3176H5.956C6.30933 13.3176 6.64867 13.1769 6.89867 12.9269L12.7147 7.11091C13.2353 6.59024 13.2353 5.74624 12.7147 5.22558L10.5153 3.02624C9.99467 2.50558 9.15067 2.50558 8.63 3.02624L2.34533 9.31091C1.82467 9.83158 1.82467 10.6756 2.34533 11.1962L4.076 12.9269C4.32533 13.1769 4.664 13.3176 5.018 13.3176V13.3176Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.39331 6.25977L9.47998 10.3464",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 13.3197L5.95337 13.3197",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ErrorIcon.tsx


var ErrorIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.350 */.rS.colors.primary[350] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.680 */.rS.colors.neutral[680] : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de erro" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        "aria-label": alt,
        "aria-labelledby": alt,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "8",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 7L17 18",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 7L8 18",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/EyeClose.tsx


var EyeClose = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _alt = param.alt, alt = _alt === void 0 ? "Olho fechado" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 28 28",
        fill: color,
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.043 12.7576C14.2445 12.7412 14.4974 12.7172 14.6293 12.5937C15.2733 11.99 15.9022 11.3704 16.553 10.729C16.7689 10.5163 16.9872 10.3012 17.2093 10.0835C14.9679 8.5002 11.9395 8.82927 10.0601 10.78C8.24297 12.6664 7.9927 15.7043 9.53241 17.6828C9.74051 17.4757 9.9489 17.2694 10.1571 17.0634C10.7864 16.4407 11.4136 15.8199 12.0244 15.1835C12.1506 15.0522 12.176 14.7973 12.1927 14.595C12.2813 13.5087 12.9452 12.8491 14.043 12.7576ZM23.661 3.62183C24.1082 3.17786 24.5555 2.73381 25.002 2.28882L26.4874 3.88973C19.2845 11.0528 11.9736 18.3233 4.66445 25.5923L3.17641 24.0668C4.31344 22.9603 5.50214 21.8037 6.75118 20.5887C6.66145 20.5229 6.58493 20.4678 6.51733 20.4191C6.39269 20.3293 6.2984 20.2613 6.20763 20.1889C5.78707 19.8545 5.36593 19.5207 4.94478 19.187C3.61304 18.1316 2.28123 17.0762 0.967588 15.999C0.707098 15.7856 0.499519 15.5084 0.291947 15.2312C0.196352 15.1035 0.100759 14.9759 0 14.8545V14.4218C0.351763 14.0661 0.696128 13.7018 1.04049 13.3376C1.80132 12.5327 2.56215 11.7279 3.40272 11.0164C5.9539 8.85727 8.81365 7.2477 12.1869 6.71224C14.4691 6.35026 16.6643 6.67962 18.7652 7.59641C19.2755 7.81896 19.5665 7.73467 19.9421 7.35076C21.1689 6.0959 22.4146 4.85917 23.661 3.62183ZM22.296 10.8611C22.5737 10.5847 22.854 10.3058 23.1373 10.0231C24.9353 11.2744 26.5715 12.6554 28 14.2774V14.9987C24.9558 18.3711 21.474 21.092 16.9646 22.255C14.9959 22.7631 13.0209 22.781 10.8646 22.1892C11.053 22.0072 11.2352 21.8302 11.4131 21.6574C11.9521 21.1338 12.4514 20.6487 12.964 20.1784C13.0619 20.0889 13.279 20.0959 13.4369 20.1083C17.0535 20.3932 19.8154 17.6425 19.5567 14.0251C19.542 13.8207 19.6283 13.5479 19.7686 13.4036C20.5932 12.5554 21.4321 11.7207 22.296 10.8611Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_2977",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "2",
                width: width,
                height: height,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.043 12.7576C14.2445 12.7412 14.4974 12.7172 14.6293 12.5937C15.2733 11.99 15.9022 11.3704 16.553 10.729C16.7689 10.5163 16.9872 10.3012 17.2093 10.0835C14.9679 8.5002 11.9395 8.82927 10.0601 10.78C8.24297 12.6664 7.9927 15.7043 9.53241 17.6828C9.74051 17.4757 9.9489 17.2694 10.1571 17.0634C10.7864 16.4407 11.4136 15.8199 12.0244 15.1835C12.1506 15.0522 12.176 14.7973 12.1927 14.595C12.2813 13.5087 12.9452 12.8491 14.043 12.7576ZM23.661 3.62183C24.1082 3.17786 24.5555 2.73381 25.002 2.28882L26.4874 3.88973C19.2845 11.0528 11.9736 18.3233 4.66445 25.5923L3.17641 24.0668C4.31344 22.9603 5.50214 21.8037 6.75118 20.5887C6.66145 20.5229 6.58493 20.4678 6.51733 20.4191C6.39269 20.3293 6.2984 20.2613 6.20763 20.1889C5.78707 19.8545 5.36593 19.5207 4.94478 19.187C3.61304 18.1316 2.28123 17.0762 0.967588 15.999C0.707098 15.7856 0.499519 15.5084 0.291947 15.2312C0.196352 15.1035 0.100759 14.9759 0 14.8545V14.4218C0.351763 14.0661 0.696128 13.7018 1.04049 13.3376C1.80132 12.5327 2.56215 11.7279 3.40272 11.0164C5.9539 8.85727 8.81365 7.2477 12.1869 6.71224C14.4691 6.35026 16.6643 6.67962 18.7652 7.59641C19.2755 7.81896 19.5665 7.73467 19.9421 7.35076C21.1689 6.0959 22.4146 4.85917 23.661 3.62183ZM22.296 10.8611C22.5737 10.5847 22.854 10.3058 23.1373 10.0231C24.9353 11.2744 26.5715 12.6554 28 14.2774V14.9987C24.9558 18.3711 21.474 21.092 16.9646 22.255C14.9959 22.7631 13.0209 22.781 10.8646 22.1892C11.053 22.0072 11.2352 21.8302 11.4131 21.6574C11.9521 21.1338 12.4514 20.6487 12.964 20.1784C13.0619 20.0889 13.279 20.0959 13.4369 20.1083C17.0535 20.3932 19.8154 17.6425 19.5567 14.0251C19.542 13.8207 19.6283 13.5479 19.7686 13.4036C20.5932 12.5554 21.4321 11.7207 22.296 10.8611Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_0_2977)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    fill: color
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/EyeOpen.tsx


var EyeOpen = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: color,
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.65892 14.1554C7.5766 17.6666 10.3044 20.4759 13.8688 20.5512C17.3931 20.6257 20.1892 17.9091 20.2617 14.3408C20.3331 10.8139 17.6264 8.02426 14.0538 7.94222C10.5438 7.86186 7.74236 10.5837 7.65892 14.1554ZM20.3947 7.14588C20.4666 7.18107 24.0527 8.93592 27.5204 13.309C27.9626 13.8665 28.1073 14.4343 27.6302 15.0304C24.8627 18.4887 21.6239 21.3139 17.2822 22.619C14.2339 23.5351 11.2807 23.1703 8.44208 21.8131C5.20724 20.267 2.59876 17.9455 0.380603 15.1573C-0.0682375 14.5931 -0.156998 14.0213 0.314523 13.4333C5.10532 7.46006 10.7526 5.85398 10.7526 5.85398C11.8276 5.55242 12.7096 5.31134 13.9455 5.28278C16.4666 5.22454 18.2872 6.10066 20.3936 7.14534C20.3936 7.14534 20.394 7.14552 20.3947 7.14588ZM10.784 14.2426C10.7868 12.4948 12.2196 11.0668 13.9676 11.0693C15.7123 11.0718 17.1448 12.5091 17.142 14.2543C17.1392 15.9976 15.6988 17.4334 13.9556 17.4304C12.212 17.4276 10.7815 15.9895 10.784 14.2426Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_2792",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "5",
                width: width,
                height: height,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.65892 14.1554C7.5766 17.6666 10.3044 20.4759 13.8688 20.5512C17.3931 20.6257 20.1892 17.9091 20.2617 14.3408C20.3331 10.8139 17.6264 8.02426 14.0538 7.94222C10.5438 7.86186 7.74236 10.5837 7.65892 14.1554ZM20.3947 7.14588C20.4666 7.18107 24.0527 8.93592 27.5204 13.309C27.9626 13.8665 28.1073 14.4343 27.6302 15.0304C24.8627 18.4887 21.6239 21.3139 17.2822 22.619C14.2339 23.5351 11.2807 23.1703 8.44208 21.8131C5.20724 20.267 2.59876 17.9455 0.380603 15.1573C-0.0682375 14.5931 -0.156998 14.0213 0.314523 13.4333C5.10532 7.46006 10.7526 5.85398 10.7526 5.85398C11.8276 5.55242 12.7096 5.31134 13.9455 5.28278C16.4666 5.22454 18.2872 6.10066 20.3936 7.14534C20.3936 7.14534 20.394 7.14552 20.3947 7.14588ZM10.784 14.2426C10.7868 12.4948 12.2196 11.0668 13.9676 11.0693C15.7123 11.0718 17.1448 12.5091 17.142 14.2543C17.1392 15.9976 15.6988 17.4334 13.9556 17.4304C12.212 17.4276 10.7815 15.9895 10.784 14.2426Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_0_2792)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    fill: color
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/FCLogoBlackFriday.tsx

var FCLogoBlackFriday = function(param) {
    var _width = param.width, width = _width === void 0 ? "12.5rem" : _width, _height = param.height, height = _height === void 0 ? 58 : _height, _color = param.color, color = _color === void 0 ? "white" : _color, _alt = param.alt, alt = _alt === void 0 ? "Logo escrito Ferreira Costa, em branco com bordas vermelhas, black friday" : _alt, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? "#E71C35" : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 152 58",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M54.6272 8.00017C55.7523 8.00017 56.7523 8.25025 57.5008 8.87528C58.8723 8.25036 60.3697 7.95086 61.876 8.00017H65.8763V9.75038C67.8356 8.32711 70.2054 7.58106 72.6267 7.62522C76.0019 7.62522 78.7504 9.00015 80.502 11.2515V9.25023C79.9926 8.42476 79.7322 7.46983 79.7521 6.50004C79.7528 3.37524 82.2536 1 85.6288 1C89.004 1 91.5041 3.25003 91.5041 6.50038C91.4819 7.00871 91.3979 7.51246 91.254 8.00051H93.6293C94.6748 7.98645 95.692 8.34041 96.503 9.00049C97.8644 8.33343 99.3621 7.99115 100.878 8.00051H109.128C115.879 8.00051 119.629 11.5006 119.629 18.001V21.0012H121.504V27.1249H128.38V31.5011H138.006C144.756 31.5011 148.506 35.1275 148.506 41.5016V44.7516H150.382V54.0021H143.631C142.661 54.022 141.706 53.7616 140.881 53.2522C139.756 53.8773 138.381 54.0021 136.631 54.0021H127.13C123.755 54.0021 121.255 52.8769 119.63 50.877C118.755 52.2519 117.255 53.127 115.505 53.7507C115.437 53.742 115.368 53.7488 115.303 53.7704C115.237 53.792 115.178 53.8279 115.129 53.8755C115.004 53.8755 114.752 54.0004 114.628 54.0004H114.252C112.053 54.4132 109.789 54.3278 107.627 53.7503C106.984 53.5987 106.357 53.3895 105.752 53.1253C105.627 53.1253 105.627 53.1253 105.502 53.0004C105.377 53.0004 105.377 52.8756 105.252 52.8756C105.235 52.8759 105.219 52.8729 105.203 52.8667C105.188 52.8606 105.174 52.8514 105.163 52.8397C105.151 52.8281 105.142 52.8142 105.136 52.7989C105.129 52.7836 105.126 52.7672 105.127 52.7507C104.202 52.3945 103.321 51.9332 102.502 51.3758C100.383 53.1964 97.6695 54.1751 94.8766 54.126C91.8641 54.1847 88.948 53.0631 86.7512 51.0008V53.3764L85.5012 54.1263C82.5009 56.1263 79.6259 57 76.2506 57C67.6251 57 61.5001 50.9998 61.5001 42.4995C61.5001 37.1243 63.8753 32.7495 67.6238 30.249H30.1262C24.126 30.249 19.6256 26.4989 18.7508 20.9985H14.1256V30.2501H3.37524V11.5006H1V1.7499H23.501V9.37544C25.3327 8.218 27.458 7.61054 29.6247 7.62522C32.7498 7.62522 35.3748 8.75041 37.125 10.8752V8.00154H41.7503C42.8755 8.00154 43.8755 8.25162 44.624 8.87665C45.9955 8.25172 47.4928 7.95223 48.9992 8.00154L54.6272 8.00017Z",
                fill: secondColor,
                stroke: color,
                strokeWidth: "1.33177"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M85.5036 9.25016C87.3786 9.25016 88.6287 8.12497 88.6287 6.37647C88.6287 4.75147 87.3786 3.62628 85.5036 3.62628C83.6285 3.62628 82.3784 4.7501 82.3784 6.3751C82.5033 8.25019 83.7533 9.25016 85.5036 9.25016Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44.3769 12.5005C44.1268 11.3753 43.1269 10.7503 42.0017 10.7503H40.1266V27.626H45.2517V18.3758C45.2517 15.7509 47.0019 14.6257 49.3768 14.6257H50.502V10.6254H49.2519C47.0029 10.6254 45.2517 11.3753 44.3769 12.5005Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.754 18.3758C96.754 15.7509 98.5042 14.6257 100.879 14.6257H102.004V10.6254H100.754C98.5042 10.6254 96.8792 11.3753 95.8789 12.5005C95.6288 11.3753 94.6288 10.7503 93.5036 10.7503H91.6289V27.626H96.754V18.3758Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.7513 10.2505C24.7511 10.2505 21.3759 13.8769 21.3759 19.1258C21.3759 24.126 24.8759 27.8762 30.2511 27.8762C32.7512 27.8762 34.8764 27.376 36.3748 26.2512V22.2509C34.6263 23.2506 32.8764 23.6269 30.7496 23.6269C28.3743 23.6269 26.7493 22.3768 26.2495 20.2517H37.0015V18.251C37.0015 13.5006 34.2514 10.2505 29.7513 10.2505ZM26.3761 16.7506C26.8762 15.1256 28.0011 14.1256 29.7513 14.1256C31.2514 14.1256 32.2514 15.1256 32.5015 16.7506H26.3761Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M57.0024 12.5005C56.7523 11.3753 55.7523 10.7503 54.6272 10.7503H52.7521V27.626H57.8772V18.3758C57.8772 15.7509 59.6274 14.6257 62.0023 14.6257H63.1275V10.6254H61.8774C59.6284 10.6254 58.0024 11.3753 57.0024 12.5005Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M86.1288 10.7504H83.1285V27.6262H88.2536V13.0005C88.3788 11.6255 87.5037 10.7504 86.1288 10.7504Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75037 8.87531H5.12529C5.87519 8.87531 6.12527 9.12538 6.12527 9.87528V28.0014H11.5008V18.7509H19.2512V14.3757H11.5008V8.87531H20.8745V4.37524H3.75037V8.87531Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M116.88 22.7507V17.7505C116.88 13.0004 114.505 10.5002 109.129 10.5002H104.129V14.5005H108.503C110.753 14.5005 111.878 15.2504 112.003 17.2507H110.503C105.38 17.2507 102.379 18.7505 102.379 22.7507C102.379 25.8759 104.504 27.8758 107.88 27.8758C110.005 27.8758 111.255 27.0007 112.38 25.7506C112.88 26.8758 113.755 27.5009 114.88 27.5009H118.88V23.7507H117.88C117.746 23.7631 117.61 23.7457 117.483 23.6998C117.356 23.6539 117.241 23.5807 117.145 23.4852C117.05 23.3898 116.977 23.2745 116.931 23.1476C116.885 23.0206 116.867 22.8851 116.88 22.7507ZM108.754 24.126C108.533 24.1348 108.311 24.0996 108.103 24.0226C107.895 23.9456 107.704 23.8283 107.542 23.6773C107.379 23.5262 107.248 23.3446 107.156 23.1427C107.063 22.9409 107.012 22.7228 107.004 22.501C107.004 21.0008 108.004 20.501 110.379 20.501H111.88C111.88 22.6258 110.629 24.126 108.754 24.126Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M73.0029 27.8762C75.5031 27.8762 77.6282 27.3761 79.2532 26.2512V22.251C77.503 23.2509 75.6269 23.6259 73.5031 23.6259C71.1279 23.6259 69.5029 22.3758 69.1279 20.2507H79.7534C79.9132 19.5534 79.997 18.8408 80.0035 18.1255C80.0031 13.3754 77.2526 10.1254 72.628 10.1254C67.6278 10.1254 64.2526 13.7517 64.2526 19.0006C64.2526 24.1261 67.6278 27.8762 73.0029 27.8762ZM72.5028 14.1256C74.0029 14.1256 75.1278 15.1256 75.253 16.7506H69.2528C69.7529 15.1256 70.7526 14.1256 72.5028 14.1256Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.7529 42.8769C69.7529 38.3768 72.7532 35.8767 76.6293 35.8767C79.2542 35.8767 81.3794 36.6266 83.6294 38.1268V33.3763C81.319 31.8894 78.6255 31.1076 75.878 31.1262C68.8778 31.1262 64.2526 36.0016 64.2526 43.0018C64.2526 50.0019 69.1279 54.7524 76.253 54.7524C79.0211 54.7894 81.7313 53.9588 84.0034 52.3772V47.5018C81.5033 49.1268 79.128 49.8771 76.6279 49.8771C72.7529 49.7522 69.7529 47.2521 69.7529 42.8769Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M125.631 29.8761H120.38V45.0016C120.38 49.5017 123.254 51.2519 127.131 51.2519H129.631V47.1268H127.756C126.381 47.1268 125.506 46.3769 125.506 44.6267V38.2515H130.507V34.2513H125.505L125.63 29.8761H125.631Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M146.881 47.5018C146.131 47.5018 145.881 47.1255 145.881 46.5018V41.6268C145.881 36.7515 143.506 34.2513 138.131 34.2513H132.881V38.2516H137.629C139.879 38.2516 141.005 39.0015 141.129 41.0018H139.504C134.379 41.0018 131.506 42.5016 131.506 46.5018C131.506 49.6269 133.506 51.6269 136.881 51.6269C139.006 51.6269 140.381 50.6269 141.506 49.5017C141.651 50.0162 141.963 50.4677 142.393 50.7847C142.823 51.1018 143.347 51.2662 143.881 51.252H147.882V47.5018H146.881ZM137.756 47.7519C136.631 47.7519 135.881 47.1268 135.881 46.2517C135.881 44.7516 136.881 44.1266 139.381 44.1266H140.879C140.879 46.2517 139.631 47.7519 137.756 47.7519Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.879 34.0013C89.7536 34.0013 85.8785 37.7514 85.8785 42.8765C85.8785 47.8768 89.7536 51.6269 94.879 51.6269C100.004 51.6269 103.754 47.7519 103.754 42.7517C103.754 37.7514 100.004 34.0013 94.879 34.0013ZM94.879 47.3776C92.629 47.3776 91.1288 45.6274 91.1288 42.8776C91.1288 40.0039 92.629 38.3775 94.879 38.3775C97.129 38.3775 98.5053 40.0025 98.5053 42.8776C98.504 45.6267 97.129 47.3776 94.879 47.3776Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M105.505 39.2516C105.505 41.6268 106.755 42.8779 109.755 44.1269C112.13 45.1269 113.005 45.627 113.005 46.3769C113.005 47.252 112.505 47.3769 111.38 47.3769C109.296 47.4281 107.233 46.9553 105.38 46.002V50.0022C106.755 50.8773 109.38 51.5024 111.88 51.5024C115.63 51.5024 118.255 49.3772 118.255 46.2521C118.255 43.1269 115.88 42.0017 113.505 41.0028C111.38 40.0028 110.505 39.8776 110.505 39.1277C110.505 38.3778 111.005 38.1277 112.38 38.1277H118.255V34.1265H112.005C108.13 34.1265 105.505 36.0015 105.505 39.2516Z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Facebook.tsx


var Facebook = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.280 */.rS.colors.neutral[280] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14 0H4C1.791 0 0 1.791 0 4V14C0 16.209 1.791 18 4 18H9.621V11.039H7.278V8.314H9.621V6.309C9.621 3.985 11.042 2.718 13.116 2.718C13.815 2.716 14.513 2.752 15.208 2.823V5.253H13.78C12.65 5.253 12.43 5.787 12.43 6.575V8.31H15.13L14.779 11.035H12.414V18H14C16.209 18 18 16.209 18 14V4C18 1.791 16.209 0 14 0Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/FacebookIconFooter.tsx


var FacebookIconFooter = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xcdcone do  Facebook" : _alt, _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.280 */.rS.colors.neutral[280] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M17 3H7C4.791 3 3 4.791 3 7V17C3 19.209 4.791 21 7 21H12.621V14.039H10.278V11.314H12.621V9.309C12.621 6.985 14.042 5.718 16.116 5.718C16.815 5.716 17.513 5.752 18.208 5.823V8.253H16.78C15.65 8.253 15.43 8.787 15.43 9.575V11.31H18.13L17.779 14.035H15.414V21H17C19.209 21 21 19.209 21 17V7C21 4.791 19.209 3 17 3Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/FailureIcon.tsx


var FailureIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de Alerta" : _alt, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 25 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.150 */.rS.colors.primary[150] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Group",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Group_2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path",
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.029 4.63919L21.688 18.0432C22.578 19.6012 21.453 21.5402 19.659 21.5402H4.34101C2.54601 21.5402 1.42101 19.6012 2.31201 18.0432L9.97101 4.63919C10.868 3.06819 13.132 3.06819 14.029 4.63919Z",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_2",
                        d: "M12 13.6199V9.87988",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_3",
                        d: "M11.999 16.625C11.861 16.625 11.749 16.737 11.75 16.875C11.75 17.013 11.862 17.125 12 17.125C12.138 17.125 12.25 17.013 12.25 16.875C12.25 16.737 12.138 16.625 11.999 16.625",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/FailurePaperAirplaneIcon.tsx

var FailurePaperAirplaneIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Avi\xe3o de papel indicativo de falha no envio" : _alt, _width = param.width, width = _width === void 0 ? 114 : _width, _height = param.height, height = _height === void 0 ? 120 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 114 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "64.089",
                cy: "44.7497",
                r: "33.3371",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.17",
                d: "M68.9593 30.3633L81.1205 40.798L43.3056 113.388L8.5862 71.4977L68.9593 30.3633Z",
                fill: "url(#paint0_linear_2964_180087)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.17",
                d: "M70.2229 31.8124L80.1924 39.4362L42.418 100.434L22.6763 70.6404L70.2229 31.8124Z",
                fill: "url(#paint1_linear_2964_180087)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M81.0006 54.6136C80.0335 54.6136 79.249 55.3458 79.249 56.2488C79.249 57.1519 80.0335 57.8836 81.0006 57.8836H85.8179C86.7855 57.8836 87.57 57.1514 87.57 56.2488C87.57 55.3462 86.7855 54.614 85.8184 54.614C85.8184 53.3723 84.7399 52.3657 83.4095 52.3657C82.0791 52.3657 81.0006 53.3719 81.0006 54.6136Z",
                    stroke: "#A0A2A4",
                    strokeWidth: "0.369819",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M72.1256 62.0101C71.1585 62.0101 70.374 62.7423 70.374 63.6453C70.374 64.5483 71.1585 65.2801 72.1256 65.2801H76.9429C77.9105 65.2801 78.695 64.5479 78.695 63.6453C78.695 62.7427 77.9105 62.0105 76.9434 62.0105C76.9434 60.7688 75.8649 59.7622 74.5345 59.7622C73.2041 59.7622 72.1256 60.7684 72.1256 62.0101Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M61.7701 71.6253C60.803 71.6253 60.0186 72.3575 60.0186 73.2605C60.0186 74.1636 60.803 74.8953 61.7701 74.8953H66.5875C67.555 74.8953 68.3395 74.1632 68.3395 73.2605C68.3395 72.3579 67.555 71.6258 66.5879 71.6258C66.5879 70.384 65.5094 69.3774 64.179 69.3774C62.8486 69.3774 61.7701 70.3836 61.7701 71.6253Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.369819",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M37.2213 52.201C36.2542 52.201 35.4697 52.9332 35.4697 53.8362C35.4697 54.7393 36.2542 55.471 37.2213 55.471H42.0386C43.0062 55.471 43.7907 54.7388 43.7907 53.8362C43.7907 52.9336 43.0062 52.2014 42.0391 52.2014C42.0391 50.9597 40.9606 49.9531 39.6302 49.9531C38.2998 49.9531 37.2213 50.9593 37.2213 52.201Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.369819",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M66.9478 27.2469C65.9808 27.2469 65.1963 27.9791 65.1963 28.8821C65.1963 29.7852 65.9808 30.5169 66.9478 30.5169H71.7652C72.7327 30.5169 73.5172 29.7847 73.5172 28.8821C73.5172 27.9795 72.7327 27.2473 71.7657 27.2473C71.7657 26.0056 70.6872 24.999 69.3568 24.999C68.0263 24.999 66.9478 26.0052 66.9478 27.2469Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.369819",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M43.8775 29.2723C42.9105 29.2723 42.126 30.0045 42.126 30.9075C42.126 31.8106 42.9105 32.5423 43.8775 32.5423H48.6949C49.6624 32.5423 50.4469 31.8101 50.4469 30.9075C50.4469 30.0049 49.6624 29.2727 48.6954 29.2727C48.6954 28.031 47.6169 27.0244 46.2864 27.0244C44.956 27.0244 43.8775 28.0306 43.8775 29.2723Z",
                    stroke: "#8F9194",
                    strokeWidth: "0.369819",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M51.4166 48.6966C50.4495 48.6966 49.665 49.4288 49.665 50.3318C49.665 51.2349 50.4495 51.9666 51.4166 51.9666H56.234C57.2015 51.9666 57.986 51.2344 57.986 50.3318C57.986 49.4292 57.2015 48.697 56.2344 48.697C56.2344 47.4553 55.1559 46.4487 53.8255 46.4487C52.4951 46.4487 51.4166 47.4549 51.4166 48.6966Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M87.5618 40.8408C86.8526 40.8408 86.2773 41.3778 86.2773 42.04C86.2773 42.7022 86.8526 43.2388 87.5618 43.2388H91.0945C91.8041 43.2388 92.3794 42.7019 92.3794 42.04C92.3794 41.3781 91.8041 40.8411 91.0949 40.8411C91.0949 39.9305 90.304 39.1924 89.3284 39.1924C88.3527 39.1924 87.5618 39.9302 87.5618 40.8408Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M54.136 21.416C53.4268 21.416 52.8516 21.953 52.8516 22.6152C52.8516 23.2774 53.4268 23.814 54.136 23.814H57.6688C58.3783 23.814 58.9536 23.2771 58.9536 22.6152C58.9536 21.9533 58.3783 21.4163 57.6691 21.4163C57.6691 20.5057 56.8782 19.7676 55.9026 19.7676C54.9269 19.7676 54.136 20.5054 54.136 21.416Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M49.3686 56.4628L35.6853 70.5633",
                stroke: "#040405",
                strokeWidth: "0.814966",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58.1514 63.9951L45.9126 78.4398",
                stroke: "#040405",
                strokeWidth: "0.814966",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50.0322 64.0561L36.667 79.0215",
                stroke: "#040405",
                strokeWidth: "0.814966",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M57.0531 54.3178L57.1362 38.3002L87.8605 22.4101L86.0504 30.1826L57.0531 54.3178Z",
                fill: "url(#paint2_linear_2964_180087)",
                stroke: "#040405",
                strokeWidth: "1.53792"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M89.7103 18.3486C90.6075 18.024 91.1758 19.2999 90.3346 19.7498L57.0936 37.5274C56.9897 37.583 56.8743 37.6139 56.7565 37.6178L39.2579 38.1979C38.3826 38.2269 38.1473 37.0042 38.9708 36.7062L89.7103 18.3486Z",
                fill: "#AA0E27",
                stroke: "#040405",
                strokeWidth: "1.53792"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M90.6864 20.2966C91.016 19.5538 90.1183 18.8741 89.4928 19.3927L62.8962 41.4433C62.6374 41.6578 62.548 42.0155 62.6753 42.3266L70.7415 62.0331C70.9981 62.66 71.8812 62.6729 72.156 62.0537L90.6864 20.2966Z",
                fill: "#F6F7F7",
                stroke: "#040405",
                strokeWidth: "1.53792"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M57.4941 55.0433L62.519 42.1871C62.5253 42.171 62.5311 42.1632 62.5338 42.1599C62.5367 42.1565 62.5394 42.1542 62.5426 42.1522C62.5499 42.1476 62.5651 42.1418 62.5866 42.1424C62.6081 42.143 62.6229 42.1497 62.6299 42.1546C62.633 42.1568 62.6356 42.1593 62.6383 42.1629C62.6408 42.1662 62.6462 42.1744 62.6516 42.1909L62.6608 42.2189L62.6721 42.2462L65.5828 49.2608L66.4326 51.8548L57.4941 55.0433Z",
                fill: "#AA0E27",
                stroke: "#040405",
                strokeWidth: "1.53792"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "82.3154",
                cy: "72",
                r: "11.25",
                fill: "#AA0E27",
                stroke: "white",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.3161 72.501L82.3161 67.4863",
                stroke: "#F6F7F7",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.3148 76.0624C82.2041 76.0624 82.1148 76.1517 82.1161 76.2624C82.1161 76.373 82.2054 76.4624 82.3161 76.4624C82.4268 76.4624 82.5161 76.373 82.5161 76.2624C82.5161 76.153 82.4268 76.0624 82.3148 76.0624",
                stroke: "#F6F7F7",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_2964_180087",
                        x1: "73.9948",
                        y1: "30.9133",
                        x2: "31.6407",
                        y2: "100.731",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.419792",
                                stopColor: "#AA0E27"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#AA0E27",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_2964_180087",
                        x1: "73.9946",
                        y1: "30.9137",
                        x2: "31.6404",
                        y2: "100.731",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.51875",
                                stopColor: "#AA0E27"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#AA0E27",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_2964_180087",
                        x1: "68.8443",
                        y1: "29.1715",
                        x2: "76.4187",
                        y2: "47.7555",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E5E6E6"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8F9194"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/ui/Icons/File.tsx


var File = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Arquivo" : _alt, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6.82499 3C5.70854 3 4.79999 3.90855 4.79999 5.025V18.975C4.79999 20.0914 5.70854 21 6.82499 21H17.175C18.2914 21 19.2 20.0914 19.2 18.975V10.2H14.025C12.9085 10.2 12 9.29145 12 8.175V3H6.82499ZM13.35 3.39551V8.175C13.35 8.54715 13.6528 8.85 14.025 8.85H18.8045L13.35 3.39551Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Filter.tsx


var Filter = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 22 22",
        fill: color,
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.75 18V12.2184L21.6327 1.40266C21.9505 0.903363 21.5918 0.25 21 0.25H0.999996C0.408178 0.25 0.0495176 0.903363 0.36725 1.40266L7.25 12.2184V21C7.25 21.5575 7.83673 21.9202 8.33541 21.6708L14.3354 18.6708C14.5895 18.5438 14.75 18.2841 14.75 18ZM8.41171 11.25H13.5883L19.6337 1.75H2.36625L8.41171 11.25ZM13.25 12.75H8.75V19.7865L13.25 17.5365V12.75Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_2702",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: width,
                height: height,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.75 18V12.2184L21.6327 1.40266C21.9505 0.903363 21.5918 0.25 21 0.25H0.999996C0.408178 0.25 0.0495176 0.903363 0.36725 1.40266L7.25 12.2184V21C7.25 21.5575 7.83673 21.9202 8.33541 21.6708L14.3354 18.6708C14.5895 18.5438 14.75 18.2841 14.75 18ZM8.41171 11.25H13.5883L19.6337 1.75H2.36625L8.41171 11.25ZM13.25 12.75H8.75V19.7865L13.25 17.5365V12.75Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_0_2702)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "-3",
                    y: "-3",
                    width: width,
                    height: height,
                    fill: color
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/FurnitureGiftIcon.tsx


var FurnitureGiftIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 324 : _width, _height = param.height, height = _height === void 0 ? 319 : _height, _color = param.color, color = _color === void 0 ? "".concat(themes/* theme.colors.neutral.150 */.rS.colors.neutral[150]) : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? "".concat(themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"]) : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? "".concat(themes/* theme.colors.primary.900 */.rS.colors.primary[900]) : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? "".concat(themes/* theme.colors.primary.180 */.rS.colors.primary[180]) : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? "".concat(themes/* theme.colors.secondary.410 */.rS.colors.secondary[410]) : _fifthColor, _sixthColor = param.sixthColor, sixthColor = _sixthColor === void 0 ? "".concat(themes/* theme.colors.yellow.1100 */.rS.colors.yellow[1100]) : _sixthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 324 319",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M106 2H0V108H106V2Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.5399 72.7001C43.7162 72.7001 44.6711 73.655 44.6711 74.8313L44.6711 86.5114L48.2693 89.3622L53.8325 89.3622L57.4307 86.5114L57.4307 74.8313C57.4307 73.655 58.3856 72.7001 59.5619 72.7001C60.7382 72.7001 61.6931 73.655 61.6931 74.8313L61.6931 87.5493C61.6931 88.1998 61.3887 88.8225 60.8905 89.2239L55.9084 93.1818C55.5348 93.4863 55.0642 93.6523 54.5799 93.6523L47.522 93.6523C47.0376 93.6523 46.5671 93.4863 46.1934 93.1818L41.2114 89.2239C40.6993 88.8225 40.4087 88.1998 40.4087 87.5493L40.4087 74.8313C40.4087 73.655 41.3636 72.7001 42.5399 72.7001Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.5398 80.2923L59.5618 80.2923C60.7381 80.2923 61.693 81.2472 61.693 82.4235C61.693 83.5998 60.7381 84.5547 59.5618 84.5547L42.5398 84.5547C41.3635 84.5547 40.4086 83.5998 40.4086 82.4235C40.4086 81.2472 41.3635 80.2923 42.5398 80.2923Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.0508 12.5974C67.5054 12.5974 80.8877 25.6199 80.8877 41.6179C80.8877 47.5133 79.0748 53.1734 75.6704 58.0171C72.6258 62.321 68.4879 65.7254 63.6443 67.9258L63.6443 72.3128C63.6443 74.8869 61.5131 76.9766 58.8975 76.9766L43.204 76.9766C40.5885 76.9766 38.4572 74.8869 38.4572 72.3128L38.4572 67.9258C33.6136 65.7393 29.4757 62.3349 26.4311 58.0171C23.0129 53.1873 21.2 47.5133 21.2 41.6179C21.2 25.6199 34.5823 12.5974 51.0369 12.5974M58.8836 72.7003C59.1327 72.7003 59.3542 72.5204 59.3542 72.3128L59.3542 66.5004C59.3542 65.6286 59.8939 64.8397 60.7104 64.5076C70.37 60.688 76.6114 51.6927 76.6114 41.604C76.6114 27.9587 65.1389 16.8598 51.0508 16.8598C36.9626 16.8598 25.4901 27.9587 25.4901 41.604C25.4901 51.6927 31.7315 60.6742 41.3911 64.5076C42.2076 64.8259 42.7335 65.6147 42.7335 66.5004L42.7335 72.3128C42.7335 72.5204 42.9549 72.7003 43.204 72.7003L58.8975 72.7003L58.8836 72.7003Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214.07 110L107.93 110L107.93 216.14H214.07V110Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214.07 173.037H155.192C153.597 173.037 152.307 171.747 152.307 170.151V143.876H147.567V196.641H152.307V190.847C152.307 189.252 153.597 187.962 155.192 187.962H214.07V193.733H158.076V199.526C158.076 201.122 156.787 202.412 155.192 202.412H144.683C143.088 202.412 141.798 201.122 141.798 199.526V140.991C141.798 139.395 143.088 138.105 144.683 138.105H155.192C156.787 138.105 158.076 139.395 158.076 140.991V167.266H214.07V173.037Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214.07 158.249H162.137C159.897 158.249 158.076 160.071 158.076 162.312C158.076 163.907 156.787 165.197 155.192 165.197C153.597 165.197 152.307 163.907 152.307 162.312C152.307 156.892 156.719 152.479 162.137 152.479H214.07V158.249Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214.07 129.519H162.137C159.897 129.519 158.076 131.341 158.076 133.581V140.993C158.076 142.588 156.787 143.878 155.192 143.878C153.597 143.878 152.307 142.588 152.307 140.993V133.581C152.307 128.161 156.719 123.748 162.137 123.748L214.07 123.748V129.519Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M106 214.141H0V320.141H106V214.141Z",
                fill: fifthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44.8376 299.369H22.8889C21.3528 299.369 20.1073 298.124 20.1073 296.588V258.807C20.1073 257.631 21.0622 256.676 22.2385 256.676H44.201C45.3774 256.676 46.3323 257.631 46.3323 258.807V295.688C46.7336 296.075 46.9827 296.615 46.9827 297.224C46.9827 298.4 46.0278 299.369 44.8515 299.369M24.3836 295.093H42.0698V260.952H24.3836V295.093Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.639 299.369H58.6903C57.514 299.369 56.5591 298.414 56.5591 297.224C56.5591 296.629 56.8082 296.089 57.2095 295.688V258.807C57.2095 257.631 58.1644 256.676 59.3407 256.676H81.2894C82.4657 256.676 83.4206 257.631 83.4206 258.807V296.588C83.4206 298.124 82.1751 299.369 80.639 299.369ZM61.4719 295.093H79.1582V260.952H61.4719V295.093Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.8462 260.955H59.3271C58.1507 260.955 57.1958 260 57.1958 258.824V245.22C56.7945 244.833 56.5454 244.293 56.5454 243.684C56.5454 242.508 57.5003 241.553 58.6766 241.553H84.8462C86.3823 241.553 87.6279 242.798 87.6279 244.334V258.173C87.6279 259.71 86.3823 260.955 84.8462 260.955ZM61.4721 256.679H83.3654V245.815H61.4721V256.679Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44.2008 260.955H18.6817C17.1455 260.955 15.9 259.71 15.9 258.173V244.334C15.9 242.798 17.1455 241.553 18.6817 241.553H44.8513C46.0276 241.553 46.9825 242.508 46.9825 243.684C46.9825 244.279 46.7334 244.833 46.332 245.22V258.824C46.332 260 45.3771 260.955 44.2008 260.955ZM20.1763 256.679H42.0696V245.815H20.1763V256.679Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M52.4624 245.814H35.8003C30.749 245.814 25.7808 241.233 25.767 236.569C25.767 234.798 26.2375 231.629 29.3651 230.452C32.4097 229.304 37.1011 230.563 43.3287 234.203C48.2139 237.054 52.504 240.486 54.0678 242.271C54.6213 242.907 54.7459 243.793 54.3999 244.568C54.0539 245.329 53.2928 245.827 52.4486 245.827M31.8285 234.327C31.4271 234.327 31.1088 234.383 30.8597 234.466C30.6383 234.549 30.0294 234.784 30.0294 236.583C30.0294 238.908 33.1017 241.551 35.7864 241.551H46.6777C45.1139 240.389 43.218 239.116 41.1698 237.912C36.6168 235.254 33.5307 234.327 31.8285 234.327Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M67.7136 245.812H51.0514C50.2211 245.812 49.46 245.327 49.1001 244.552C48.7542 243.791 48.8787 242.892 49.4323 242.255C50.9822 240.47 55.2862 237.038 60.1714 234.201C66.3989 230.575 71.0903 229.302 74.1349 230.451C77.2625 231.627 77.7331 234.782 77.7331 236.567C77.7331 241.231 72.7649 245.812 67.6998 245.812M56.8085 241.536H67.6998C70.3845 241.536 73.4568 238.892 73.4568 236.567C73.4568 234.768 72.8617 234.547 72.6265 234.464C71.3256 233.979 67.935 234.63 62.3164 237.91C60.2544 239.114 58.3723 240.387 56.8085 241.549V241.536Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58.6211 299.374H44.9066C43.3428 299.374 42.0558 298.101 42.0558 296.523V244.392C42.0558 242.814 43.329 241.541 44.9066 241.541H58.6211C60.1849 241.541 61.4719 242.814 61.4719 244.392V296.523C61.4719 298.087 60.1987 299.374 58.6211 299.374ZM46.3321 295.098H57.1957V245.817H46.3321V295.098Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M324 212.141H214V322.141H324V212.141Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M304.262 263.451H233.738V307.179H304.262V263.451ZM233.094 259.967H304.906C305.678 259.967 306.393 260.284 306.908 260.8C307.423 261.316 307.739 262.031 307.739 262.805V307.812C307.739 308.586 307.423 309.302 306.908 309.818C306.393 310.334 305.69 310.662 304.906 310.662H233.094C232.322 310.662 231.607 310.346 231.092 309.83C230.577 309.314 230.261 308.598 230.261 307.824V262.817C230.261 262.043 230.577 261.327 231.092 260.811C231.607 260.295 232.31 259.967 233.094 259.967Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M306.783 264.75H233.13V268.576H306.783V264.75Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M304.262 227.14H233.738V246.905H304.262V227.14ZM233.094 223.631H304.906C305.678 223.631 306.393 223.95 306.908 224.47C307.423 225.001 307.739 225.71 307.739 226.49V247.543C307.739 248.322 307.423 249.043 306.908 249.563C306.393 250.083 305.69 250.402 304.906 250.402H233.094C232.322 250.402 231.607 250.083 231.092 249.563C230.577 249.031 230.261 248.322 230.261 247.543V226.49C230.261 225.71 230.577 224.99 231.092 224.47C231.607 223.95 232.31 223.619 233.094 223.619V223.631Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M258.957 224.576H255.13V248.489H258.957V224.576Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M283.826 224.576H280V248.489H283.826V224.576Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M250.348 234.777C250.348 233.9 250.993 233.184 251.783 233.184C252.572 233.184 253.217 233.9 253.217 234.777V238.286C253.217 239.163 252.572 239.879 251.783 239.879C250.993 239.879 250.348 239.163 250.348 238.286V234.777Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M275.217 234.777C275.217 233.9 275.863 233.184 276.652 233.184C277.442 233.184 278.087 233.9 278.087 234.777V238.286C278.087 239.163 277.442 239.879 276.652 239.879C275.863 239.879 275.217 239.163 275.217 238.286V234.777Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M300.087 234.777C300.087 233.9 300.732 233.184 301.522 233.184C302.311 233.184 302.956 233.9 302.956 234.777V238.286C302.956 239.163 302.311 239.879 301.522 239.879C300.732 239.879 300.087 239.163 300.087 238.286V234.777Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M258.957 286.43C258.957 285.553 259.817 284.836 260.87 284.836C261.922 284.836 262.783 285.553 262.783 286.43V289.938C262.783 290.815 261.922 291.532 260.87 291.532C259.817 291.532 258.957 290.815 258.957 289.938V286.43Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M276.174 286.43C276.174 285.553 276.819 284.836 277.609 284.836C278.398 284.836 279.043 285.553 279.043 286.43V289.938C279.043 290.815 278.398 291.532 277.609 291.532C276.819 291.532 276.174 290.815 276.174 289.938V286.43Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M271.391 266.662H267.565V308.749H271.391V266.662Z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/FurnitureGiftSmallIcon.tsx


var FurnitureGiftSmallIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 197 : _width, _height = param.height, height = _height === void 0 ? 210 : _height, _color = param.color, color = _color === void 0 ? "".concat(themes/* theme.colors.neutral.150 */.rS.colors.neutral[150]) : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? "".concat(themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"]) : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? "".concat(themes/* theme.colors.primary.900 */.rS.colors.primary[900]) : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? "".concat(themes/* theme.colors.primary.180 */.rS.colors.primary[180]) : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? "".concat(themes/* theme.colors.secondary.410 */.rS.colors.secondary[410]) : _fifthColor, _sixthColor = param.sixthColor, sixthColor = _sixthColor === void 0 ? "".concat(themes/* theme.colors.yellow.1100 */.rS.colors.yellow[1100]) : _sixthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 197 210",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M66 2H-1V69H66V2Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.8881 46.6882C26.6316 46.6882 27.2352 47.2918 27.2352 48.0353L27.2352 55.418L29.5095 57.22L33.0259 57.22L35.3002 55.418L35.3002 48.0353C35.3002 47.2918 35.9038 46.6882 36.6473 46.6882C37.3908 46.6882 37.9944 47.2918 37.9944 48.0353L37.9944 56.0741C37.9944 56.4852 37.8019 56.8788 37.487 57.1325L34.338 59.6342C34.1018 59.8267 33.8044 59.9316 33.4983 59.9316L29.0371 59.9316C28.731 59.9316 28.4336 59.8267 28.1974 59.6342L25.0484 57.1325C24.7247 56.8788 24.541 56.4852 24.541 56.0741L24.541 48.0353C24.541 47.2918 25.1446 46.6882 25.8881 46.6882Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.8881 51.4855L36.6473 51.4855C37.3908 51.4855 37.9944 52.0891 37.9944 52.8326C37.9944 53.5761 37.3908 54.1797 36.6473 54.1797L25.8881 54.1797C25.1446 54.1797 24.541 53.5761 24.541 52.8326C24.541 52.0891 25.1446 51.4855 25.8881 51.4855Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.2675 8.69815C41.6681 8.69815 50.1267 16.9294 50.1267 27.0413C50.1267 30.7676 48.9808 34.3453 46.829 37.4068C44.9046 40.1272 42.2891 42.2791 39.2276 43.6699L39.2276 46.4428C39.2276 48.0698 37.8805 49.3906 36.2272 49.3906L26.3078 49.3906C24.6546 49.3906 23.3075 48.0698 23.3075 46.4428L23.3075 43.6699C20.2459 42.2878 17.6305 40.136 15.7061 37.4068C13.5455 34.354 12.3996 30.7676 12.3996 27.0413C12.3996 16.9294 20.8582 8.69815 31.2588 8.69815M36.2185 46.6877C36.3759 46.6877 36.5159 46.574 36.5159 46.4428L36.5159 42.7689C36.5159 42.2178 36.857 41.7192 37.3731 41.5093C43.4788 39.095 47.4238 33.4093 47.4238 27.0325C47.4238 18.4077 40.1723 11.3923 31.2675 11.3923C22.3628 11.3923 15.1112 18.4077 15.1112 27.0325C15.1112 33.4093 19.0563 39.0863 25.1619 41.5093C25.678 41.7105 26.0104 42.2091 26.0104 42.7689L26.0104 46.4428C26.0104 46.574 26.1503 46.6877 26.3078 46.6877L36.2272 46.6877L36.2185 46.6877Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M130.5 71H63.5V138H130.5V71Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M75.2357 118.385H92.0357V122.178H75.2357V118.385ZM89.0428 123.436H77.5571V126.843H89.0428V123.436ZM95.6142 96.44H98.2714V112.827H95.6142V96.44ZM118.757 90.6108H101.957V86.8176H118.757V90.6108ZM104.95 85.5603H116.436V82.1528H104.95V85.5603ZM115.679 91.8681H104.936C104.386 94.7184 103.257 97.3401 100.186 98.0259C100.214 101.805 100.236 105.591 100.264 109.37C109.864 107.791 114.886 101.276 115.679 91.8681ZM93.7642 110.984V104.648L93.7285 99.6261C84.1285 101.205 79.1071 107.72 78.3142 117.128H89.0571C89.6071 114.285 90.7214 111.685 93.7642 110.977V110.984ZM75.0357 117.135H76.8428C77.6714 106.905 83.2785 99.7547 93.7642 98.1402V95.3899C93.7642 94.9399 94.1357 94.5684 94.5857 94.5684H99.0571C99.5071 94.5684 99.8785 94.9399 99.8785 95.3899V96.59C102.186 96.0471 103.007 94.0112 103.443 91.8681H101.764C101.179 91.8681 100.707 91.3895 100.707 90.8109V86.6247C100.707 86.0389 101.186 85.5674 101.764 85.5674H103.821V81.717C103.821 81.3384 104.129 81.0312 104.507 81.0312H116.879C117.257 81.0312 117.564 81.3384 117.564 81.717V85.5674H118.957C119.543 85.5674 120.014 86.0461 120.014 86.6247V90.8109C120.014 91.3966 119.536 91.8681 118.957 91.8681H117.15C116.314 102.212 110.593 109.399 99.8857 110.913V113.892C99.8857 114.342 99.5142 114.713 99.0642 114.713H94.5928C94.1428 114.713 93.7714 114.342 93.7714 113.892V112.506C91.7285 113.163 90.9642 115.099 90.5499 117.135H92.2285C92.8142 117.135 93.2857 117.614 93.2857 118.192V122.379C93.2857 122.964 92.8071 123.436 92.2285 123.436H90.1714V127.286C90.1714 127.665 89.8642 127.972 89.4857 127.972H77.1142C76.7357 127.972 76.4285 127.665 76.4285 127.286V123.436H75.0357C74.4499 123.436 73.9785 122.957 73.9785 122.379V118.192C73.9785 117.607 74.4571 117.135 75.0357 117.135Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M79.6715 83.3514C72.7643 93.0953 75.3572 97.8244 79.7572 97.8244C84.1572 97.8244 86.6215 92.9024 79.6715 83.3514ZM80.6857 82.6156C82.6286 85.2873 84.7 88.7591 85.1643 92.088C85.4714 94.2883 85.05 96.61 83.1786 98.0172C82.1857 98.7602 80.9786 99.0817 79.75 99.0817C78.5214 99.0817 77.2 98.7459 76.1714 97.953C71.4143 94.274 76.1429 86.1588 78.6429 82.6299L79.6572 81.2012L80.6857 82.6156Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M79.9782 95.0066C80.8496 94.6923 81.3282 94.1351 81.5711 93.2492C81.8425 92.2706 83.2139 92.6492 82.9425 93.6279C82.5711 94.9637 81.7639 95.871 80.4568 96.3424C79.4996 96.6925 79.0139 95.3495 79.9711 95.0066",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M66 142H-1V209H66V142Z",
                fill: fifthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.3404 195.87H13.4672C12.4962 195.87 11.709 195.083 11.709 194.112V170.232C11.709 169.488 12.3125 168.885 13.0561 168.885H26.938C27.6816 168.885 28.2851 169.488 28.2851 170.232V193.543C28.5388 193.788 28.6963 194.129 28.6963 194.514C28.6963 195.258 28.0927 195.87 27.3492 195.87M14.4119 193.167H25.591V171.588H14.4119V193.167Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M49.9703 195.87H36.0971C35.3536 195.87 34.75 195.267 34.75 194.514C34.75 194.138 34.9074 193.797 35.1611 193.543V170.232C35.1611 169.488 35.7647 168.885 36.5082 168.885H50.3814C51.125 168.885 51.7285 169.488 51.7285 170.232V194.112C51.7285 195.083 50.9413 195.87 49.9703 195.87ZM37.8553 193.167H49.0343V171.588H37.8553V193.167Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M52.6292 171.588H36.4992C35.7557 171.588 35.1521 170.984 35.1521 170.241V161.642C34.8984 161.397 34.741 161.056 34.741 160.671C34.741 159.928 35.3445 159.324 36.0881 159.324H52.6292C53.6002 159.324 54.3874 160.111 54.3874 161.082V169.83C54.3874 170.801 53.6002 171.588 52.6292 171.588ZM37.855 168.885H51.6932V162.018H37.855V168.885Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.9383 171.588H10.8083C9.83731 171.588 9.05005 170.801 9.05005 169.83V161.082C9.05005 160.111 9.83731 159.324 10.8083 159.324H27.3494C28.0929 159.324 28.6965 159.928 28.6965 160.671C28.6965 161.047 28.5391 161.397 28.2854 161.642V170.241C28.2854 170.984 27.6818 171.588 26.9383 171.588ZM11.753 168.885H25.5912V162.018H11.753V168.885Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.1607 162.018H21.6289C18.4361 162.018 15.2959 159.123 15.2871 156.175C15.2871 155.055 15.5845 153.052 17.5614 152.309C19.4858 151.583 22.4512 152.379 26.3874 154.679C29.4752 156.481 32.1869 158.651 33.1754 159.779C33.5252 160.181 33.604 160.741 33.3853 161.231C33.1666 161.712 32.6855 162.027 32.1519 162.027M19.1184 154.758C18.8648 154.758 18.6636 154.793 18.5061 154.846C18.3662 154.898 17.9813 155.047 17.9813 156.184C17.9813 157.653 19.9232 159.324 21.6202 159.324H28.5043C27.5158 158.589 26.3175 157.785 25.0229 157.024C22.145 155.344 20.1943 154.758 19.1184 154.758Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.8001 162.017H31.2684C30.7435 162.017 30.2625 161.711 30.035 161.221C29.8163 160.74 29.8951 160.172 30.245 159.769C31.2247 158.641 33.9451 156.471 37.0329 154.678C40.9692 152.386 43.9345 151.582 45.8589 152.308C47.8358 153.051 48.1332 155.046 48.1332 156.174C48.1332 159.122 44.9929 162.017 41.7914 162.017M34.9073 159.314H41.7914C43.4884 159.314 45.4303 157.644 45.4303 156.174C45.4303 155.037 45.0541 154.897 44.9054 154.844C44.0832 154.538 41.9401 154.949 38.3887 157.022C37.0853 157.783 35.8957 158.588 34.9073 159.323V159.314Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.053 195.873H27.3845C26.396 195.873 25.5825 195.069 25.5825 194.071V161.12C25.5825 160.123 26.3873 159.318 27.3845 159.318H36.053C37.0415 159.318 37.855 160.123 37.855 161.12V194.071C37.855 195.06 37.0502 195.873 36.053 195.873ZM28.2854 193.17H35.1521V162.021H28.2854V193.17Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M197 140H126V211H197V140Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M184.26 173.118H138.74V201.342H184.26V173.118ZM138.325 170.869H184.675C185.174 170.869 185.635 171.074 185.968 171.407C186.3 171.74 186.504 172.202 186.504 172.701V201.751C186.504 202.251 186.3 202.713 185.968 203.046C185.635 203.379 185.182 203.591 184.675 203.591H138.325C137.826 203.591 137.365 203.386 137.032 203.053C136.7 202.72 136.496 202.258 136.496 201.759V172.709C136.496 172.209 136.7 171.747 137.032 171.414C137.365 171.081 137.818 170.869 138.325 170.869Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M185.887 173.957H138.348V176.427H185.887V173.957Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M184.26 149.681H138.74V162.438H184.26V149.681ZM138.325 147.416H184.675C185.174 147.416 185.635 147.622 185.968 147.957C186.3 148.3 186.504 148.758 186.504 149.261V162.85C186.504 163.353 186.3 163.818 185.968 164.154C185.635 164.489 185.182 164.695 184.675 164.695H138.325C137.826 164.695 137.365 164.489 137.032 164.154C136.7 163.811 136.496 163.353 136.496 162.85V149.261C136.496 148.758 136.7 148.293 137.032 147.957C137.365 147.622 137.818 147.408 138.325 147.408V147.416Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M155.017 148.027H152.548V163.462H155.017V148.027Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M171.07 148.027H168.6V163.462H171.07V148.027Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M149.461 154.611C149.461 154.045 149.877 153.582 150.387 153.582C150.896 153.582 151.313 154.045 151.313 154.611V156.875C151.313 157.441 150.896 157.904 150.387 157.904C149.877 157.904 149.461 157.441 149.461 156.875V154.611Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M165.513 154.611C165.513 154.045 165.929 153.582 166.439 153.582C166.949 153.582 167.365 154.045 167.365 154.611V156.875C167.365 157.441 166.949 157.904 166.439 157.904C165.929 157.904 165.513 157.441 165.513 156.875V154.611Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M181.565 154.611C181.565 154.045 181.982 153.582 182.491 153.582C183.001 153.582 183.417 154.045 183.417 154.611V156.875C183.417 157.441 183.001 157.904 182.491 157.904C181.982 157.904 181.565 157.441 181.565 156.875V154.611Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M155.017 187.951C155.017 187.384 155.573 186.922 156.252 186.922C156.932 186.922 157.487 187.384 157.487 187.951V190.215C157.487 190.781 156.932 191.244 156.252 191.244C155.573 191.244 155.017 190.781 155.017 190.215V187.951Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M166.13 187.951C166.13 187.384 166.547 186.922 167.056 186.922C167.566 186.922 167.983 187.384 167.983 187.951V190.215C167.983 190.781 167.566 191.244 167.056 191.244C166.547 191.244 166.13 190.781 166.13 190.215V187.951Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M163.044 175.191H160.574V202.357H163.044V175.191Z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/GeometricBoxIcon.tsx


var GeometricBoxIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "".concat(themes/* theme.colors.neutral.white */.rS.colors.neutral.white),
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4 8L12 3L20 8V16L12 21L4 16V8L12 12.375V21V12.375L20 8",
            stroke: color,
            strokeWidth: strokeWidth,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Gift.tsx


var Gift = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _alt = param.alt, alt = _alt === void 0 ? "Presente" : _alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 8H4C3.448 8 3 8.448 3 9V11C3 11.552 3.448 12 4 12H20C20.552 12 21 11.552 21 11V9C21 8.448 20.552 8 20 8Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 21V8",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.696 6.612C14.618 7.734 12.921 8 12.099 8",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.099 8C12.099 8 11.605 4.884 12.82 3.62",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.696 6.61199C16.49 5.78599 16.49 4.44599 15.696 3.61999C14.902 2.79399 13.615 2.79399 12.821 3.61999",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.30399 6.612C9.38199 7.734 11.079 8 11.901 8",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.901 8C11.901 8 12.395 4.884 11.18 3.62",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.304 6.61199C7.51 5.78599 7.51 4.44599 8.304 3.61999C9.098 2.79399 10.385 2.79399 11.179 3.61999",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 12V20C19 20.552 18.552 21 18 21H6C5.448 21 5 20.552 5 20V12",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/GiftCardWeddingListHome.tsx


var GiftCardWeddingListHome = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 27 20",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.9038 18H5.98077C3.79135 18 2 16.8 2 15.3333V4.66667C2 3.2 3.79135 2 5.98077 2H21.9038C24.0933 2 25.8846 3.2 25.8846 4.66667V15.3333C25.8846 16.8 24.0933 18 21.9038 18Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.27013 9.38171C9.27013 7.42171 10.6833 5.83337 12.4262 5.83337C13.1765 5.83337 13.7848 6.41921 13.7848 7.14171C13.7848 8.72004 11.7624 10 9.2684 10C6.77436 10 4.75195 8.72087 4.75195 7.14171C4.75195 6.41921 5.36032 5.83337 6.11147 5.83337C7.85436 5.83337 9.26753 7.42171 9.26753 9.38171",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.80762 13.2117C7.71839 13.2117 9.26742 11.47 9.26742 9.32166L9.27089 9.33332C9.27089 11.4817 10.8199 13.2233 12.7307 13.2233",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.26961 2.5V17.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.8846 10H2",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/GiftIcon.tsx


var GiftIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 26 : _width, _height = param.height, height = _height === void 0 ? 26 : _height, _alt = param.alt, alt = _alt === void 0 ? "Presente" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.200 */.rS.colors.primary[200] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-1-inside-1_1648_51",
                fill: secondColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.33334 11.7333C3.33334 11.1811 3.78105 10.7333 4.33334 10.7333H19.6667C20.219 10.7333 20.6667 11.1811 20.6667 11.7333V19.5667C20.6667 20.6712 19.7712 21.5667 18.6667 21.5667H5.33334C4.22877 21.5667 3.33334 20.6712 3.33334 19.5667V11.7333Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.33334 11.7333C3.33334 11.1811 3.78105 10.7333 4.33334 10.7333H19.6667C20.219 10.7333 20.6667 11.1811 20.6667 11.7333V19.5667C20.6667 20.6712 19.7712 21.5667 18.6667 21.5667H5.33334C4.22877 21.5667 3.33334 20.6712 3.33334 19.5667V11.7333Z",
                stroke: color,
                strokeWidth: "3",
                mask: "url(#path-1-inside-1_1648_51)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.46666 6.91666C5.42666 6.91666 6.03333 3.96666 7.21667 3.28333C9.29609 2.05403 12.0233 5.31629 12 7.2C11.9178 5.4069 14.6627 2.16472 16.8 3.28334C17.9833 3.96667 18.59 6.91667 15.55 6.91667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.05 20.5833V7.3",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2.75",
                y: "6.91666",
                width: "18.5",
                height: "4.56667",
                rx: "1.25",
                stroke: color,
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/GiftIconActivityHistory.tsx


var GiftIconActivityHistory = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-1-inside-1_1553_145",
                fill: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "3.33334",
                    y: "10.7333",
                    width: "17.3333",
                    height: "10.8333",
                    rx: "1"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.33334",
                y: "10.7333",
                width: "17.3333",
                height: "10.8333",
                rx: "1",
                stroke: color,
                strokeWidth: "3",
                mask: "url(#path-1-inside-1_1553_145)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.46666 6.91666C5.42666 6.91666 6.03333 3.96666 7.21667 3.28333C9.29609 2.05403 12.0233 5.31629 12 7.2C11.9178 5.4069 14.6627 2.16472 16.8 3.28334C17.9833 3.96667 18.59 6.91667 15.55 6.91667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.05 20.5833V7.3",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-4-inside-2_1553_145",
                fill: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "2",
                    y: "6.16666",
                    width: "20",
                    height: "6.06667",
                    rx: "1"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2",
                y: "6.16666",
                width: "20",
                height: "6.06667",
                rx: "1",
                stroke: color,
                strokeWidth: "3",
                mask: "url(#path-4-inside-2_1553_145)"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/GiftIconNew.tsx


var GiftIconNew = function(param) {
    var _width = param.width, width = _width === void 0 ? "24" : _width, _height = param.height, height = _height === void 0 ? "24" : _height, _alt = param.alt, alt = _alt === void 0 ? "Presente" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.350 */.rS.colors.primary[350] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-label": alt,
        "aria-labelledby": alt,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 8H4C3.448 8 3 8.448 3 9V11C3 11.552 3.448 12 4 12H20C20.552 12 21 11.552 21 11V9C21 8.448 20.552 8 20 8Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 21V8",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.6961 6.61194C14.6181 7.73394 12.9211 7.99994 12.0991 7.99994",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.0988 8C12.0988 8 11.6048 4.884 12.8198 3.62",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.6958 6.61199C16.4898 5.78599 16.4898 4.44599 15.6958 3.61999C14.9018 2.79399 13.6148 2.79399 12.8208 3.61999",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.3042 6.61194C9.3822 7.73394 11.0792 7.99994 11.9012 7.99994",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9012 8C11.9012 8 12.3952 4.884 11.1802 3.62",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.304 6.61199C7.51 5.78599 7.51 4.44599 8.304 3.61999C9.098 2.79399 10.385 2.79399 11.179 3.61999",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 12V20C19 20.552 18.552 21 18 21H6C5.448 21 5 20.552 5 20V12",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/GiftOutlineIcon.tsx


var GiftOutlineIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _alt = param.alt, alt = _alt === void 0 ? "Presente" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.200 */.rS.colors.primary[200] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 8H4C3.448 8 3 8.448 3 9V11C3 11.552 3.448 12 4 12H20C20.552 12 21 11.552 21 11V9C21 8.448 20.552 8 20 8Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 21V8",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.6961 6.61194C14.6181 7.73394 12.9211 7.99994 12.0991 7.99994",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.0988 8C12.0988 8 11.6048 4.884 12.8198 3.62",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.6958 6.61199C16.4898 5.78599 16.4898 4.44599 15.6958 3.61999C14.9018 2.79399 13.6148 2.79399 12.8208 3.61999",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.3042 6.61194C9.3822 7.73394 11.0792 7.99994 11.9012 7.99994",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9012 8C11.9012 8 12.3952 4.884 11.1802 3.62",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.304 6.61199C7.51 5.78599 7.51 4.44599 8.304 3.61999C9.098 2.79399 10.385 2.79399 11.179 3.61999",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 12V20C19 20.552 18.552 21 18 21H6C5.448 21 5 20.552 5 20V12",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Google.tsx


var Google = function(param) {
    var _width = param.width, width = _width === void 0 ? 20.5 : _width, _height = param.height, height = _height === void 0 ? 20.5 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: color,
        height: height,
        width: width,
        version: "1.1",
        id: "Capa_1",
        xmlns: "https://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 210 210",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0,105C0,47.103,47.103,0,105,0c23.383,0,45.515,7.523,64.004,21.756l-24.4,31.696C133.172,44.652,119.477,40,105,40 c-35.841,0-65,29.159-65,65s29.159,65,65,65c28.867,0,53.398-18.913,61.852-45H105V85h105v20c0,57.897-47.103,105-105,105 S0,162.897,0,105z"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/GoogleColored.tsx


var GoogleColored = function(param) {
    var _width = param.width, width = _width === void 0 ? 22 : _width, _height = param.height, height = _height === void 0 ? 22 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.primary.190 */.rS.colors.primary[190] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.yellow.70 */.rS.colors.yellow[70] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.tertiary.260 */.rS.colors.tertiary[260] : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? themes/* theme.colors.secondary.440 */.rS.colors.secondary[440] : _fifthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.79575 1.12206C5.25108 1.99275 3.08278 3.89704 1.87504 6.30689C1.45374 7.13826 1.1504 8.02018 0.965032 8.93581C0.504408 11.2052 0.824598 13.6263 1.86943 15.6935C2.54913 17.0417 3.52655 18.2438 4.7062 19.1819C5.82405 20.0694 7.12166 20.7323 8.50353 21.0974C10.2449 21.5636 12.0986 21.5524 13.8513 21.1536C15.4354 20.7885 16.9352 20.0301 18.1317 18.9291C19.3956 17.7663 20.3 16.2384 20.7775 14.5925C21.2999 12.8006 21.3673 10.885 21.0415 9.04254C17.7666 9.04254 14.486 9.04254 11.2111 9.04254C11.2111 10.4019 11.2111 11.7613 11.2111 13.1207C13.1098 13.1207 15.0084 13.1207 16.9071 13.1207C16.688 14.424 15.9128 15.6149 14.8175 16.3507C14.1265 16.817 13.3345 17.1147 12.5143 17.2607C11.6942 17.4012 10.8404 17.418 10.0202 17.2551C9.18324 17.0866 8.39119 16.7383 7.69463 16.2496C6.5824 15.4688 5.73417 14.3285 5.30164 13.0421C4.85787 11.7333 4.85225 10.2784 5.30164 8.97513C5.61621 8.05389 6.13301 7.20566 6.81833 6.50911C7.66093 5.64404 8.75632 5.02613 9.94158 4.77334C10.9527 4.55989 12.02 4.59921 13.0087 4.89693C13.8513 5.14971 14.6265 5.61595 15.2612 6.22263C15.9016 5.58225 16.542 4.94187 17.1824 4.30149C17.5194 3.95883 17.8733 3.6274 18.1991 3.27351C17.2273 2.37473 16.0814 1.65009 14.8343 1.18947C12.5874 0.358097 10.0595 0.341245 7.79575 1.12206Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.7957 1.12173C10.0539 0.340919 12.5873 0.357771 14.8343 1.18352C16.0813 1.64415 17.2216 2.36317 18.1991 3.26757C17.8733 3.62146 17.5194 3.95288 17.1823 4.29554C16.5419 4.93592 15.9016 5.5763 15.2612 6.21668C14.6264 5.61001 13.8512 5.14938 13.0086 4.89099C12.02 4.59327 10.9527 4.54833 9.94153 4.7674C8.76189 5.02018 7.6665 5.63809 6.81828 6.50317C6.13296 7.19411 5.61616 8.04795 5.30159 8.96919C4.16127 8.08165 3.02094 7.19972 1.875 6.31218C3.08273 3.89671 5.25104 1.99242 7.7957 1.12173Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.970594 8.92995C1.15597 8.01994 1.45931 7.1324 1.88061 6.30103C3.02093 7.18857 4.16126 8.0705 5.3072 8.95804C4.85781 10.2669 4.85781 11.7218 5.3072 13.025C4.16688 13.9126 3.02655 14.8001 1.88623 15.682C0.83016 13.6205 0.50997 11.1994 0.970594 8.92995Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.2107 9.03662C14.4856 9.03662 17.7662 9.03662 21.0411 9.03662C21.3669 10.8735 21.2939 12.789 20.7771 14.5866C20.2996 16.2325 19.3952 17.7604 18.1313 18.9232C17.0247 18.0637 15.918 17.2043 14.8114 16.3448C15.9068 15.6089 16.682 14.4181 16.9011 13.1148C15.0024 13.1148 13.1037 13.1148 11.2051 13.1148C11.2107 11.7554 11.2107 10.396 11.2107 9.03662Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.875 15.6875C3.01533 14.8056 4.15565 13.9181 5.29598 13.0305C5.73413 14.3169 6.57674 15.4572 7.68897 16.238C8.38553 16.7267 9.18319 17.075 10.0146 17.2435C10.8347 17.4121 11.6829 17.3896 12.5087 17.2492C13.3288 17.1031 14.1209 16.8054 14.8118 16.3391C15.9184 17.1986 17.025 18.0581 18.1317 18.9175C16.9352 20.0241 15.4353 20.7769 13.8512 21.142C12.0986 21.5408 10.2449 21.5521 8.50349 21.0858C7.12162 20.7207 5.82401 20.0635 4.70615 19.1703C3.53212 18.2378 2.5547 17.0357 1.875 15.6875Z",
                fill: fifthColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/GreenAddIcon.tsx


var GreenAddIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Adicionar" : _alt, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.250 */.rS.colors.secondary[250] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 7V17",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 12H7",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/HamburgerIcon.tsx


var HamburgerIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "2.05" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.99625 5.9975H21.0038",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 12H3.00001",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.00001 18.5H21",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "square",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/HandPackageDeliveryIcon.tsx


var HandPackageDeliveryIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.350 */.rS.colors.neutral[350] : _color, _alt = param.alt, alt = _alt === void 0 ? "Entrega de pacote com m\xe3o" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.99811 17.5032H3.33075C2.87032 17.5032 2.49707 17.1299 2.49707 16.6695V11.6674C2.49707 11.207 2.87032 10.8337 3.33075 10.8337H4.99811C5.45854 10.8337 5.83179 11.207 5.83179 11.6674V16.6695C5.83179 17.1299 5.45854 17.5032 4.99811 17.5032Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.2508 3.33057V7.1655",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.6699 11.6674V8.36603C16.6676 7.70266 16.1294 7.16598 15.466 7.16553H7.03587C6.3725 7.16598 5.83433 7.70266 5.83203 8.36603V12.5845",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.83203 11.6674V6.64113C5.83221 6.31592 5.89799 5.99409 6.02545 5.6949L6.68489 4.15259C6.89795 3.65386 7.38807 3.33039 7.93041 3.33057H14.5707C15.1147 3.32883 15.6071 3.65248 15.8212 4.15259L16.4806 5.69657C16.6069 5.99599 16.6712 6.31785 16.6699 6.64279V12.0717",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.8341 14.1683H12.7791C13.1399 14.1683 13.4909 14.0513 13.7795 13.8348L15.7937 12.3242C16.2965 11.9473 17 11.9974 17.4444 12.4418V12.4418C17.6813 12.6785 17.8144 12.9997 17.8144 13.3346C17.8144 13.6696 17.6813 13.9908 17.4444 14.2275L15.7161 15.9557C15.2506 16.4213 14.6577 16.7386 14.0121 16.8678L11.5694 17.3563C11.0851 17.4531 10.5854 17.4412 10.1063 17.3213L7.89706 16.7694C7.63294 16.7028 7.3616 16.6692 7.08922 16.6693H5.83203",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.8341 14.1685H12.0721C12.7697 14.1685 13.3352 13.603 13.3352 12.9054V12.6553C13.3352 12.076 12.9409 11.5711 12.3789 11.4307L10.4681 10.953C10.1577 10.8746 9.83877 10.8346 9.51857 10.8337V10.8337C8.74555 10.8335 7.9898 11.0624 7.34683 11.4915L5.83203 12.5011",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/HeadPhone.tsx


var HeadPhone = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "https://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Icons / Contact",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Cores/Preto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Mask",
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M13 26.25H15C15.9663 26.25 16.8099 25.6358 17.1224 24.7488C19.873 24.6956 22.245 22.8516 23.0017 20.25C24.7958 20.2491 26.25 18.7944 26.25 17V15C26.25 13.2892 24.9281 11.8871 23.25 11.7595V10C23.25 5.44365 19.5563 1.75 15 1.75H13C8.44365 1.75 4.75 5.44365 4.75 10V11.7595C3.07189 11.8871 1.75 13.2892 1.75 15V17C1.75 18.7949 3.20507 20.25 5 20.25H7C7.69036 20.25 8.25 19.6904 8.25 19V13C8.25 12.3096 7.69036 11.75 7 11.75H6.25V10C6.25 6.27208 9.27208 3.25 13 3.25H15C18.7279 3.25 21.75 6.27208 21.75 10V11.75H21C20.3096 11.75 19.75 12.3096 19.75 13V19C19.75 19.6904 20.3096 20.25 21 20.25H21.4174C20.7246 22 19.0436 23.1998 17.1214 23.2485C16.8082 22.3629 15.9653 21.75 15 21.75H13C11.7574 21.75 10.75 22.7574 10.75 24C10.75 25.2426 11.7574 26.25 13 26.25ZM24.75 17C24.75 17.9665 23.9665 18.75 23 18.75H21.25V13.25H22H23C23.9665 13.25 24.75 14.0335 24.75 15V17ZM5 13.25C4.0335 13.25 3.25 14.0335 3.25 15V17C3.25 17.9665 4.0335 18.75 5 18.75H6.75V13.25H5ZM12.25 24C12.25 23.5858 12.5858 23.25 13 23.25H15C15.4142 23.25 15.75 23.5858 15.75 24C15.75 24.4142 15.4142 24.75 15 24.75H13C12.5858 24.75 12.25 24.4142 12.25 24Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "mask0_0_3326",
                        maskUnits: "userSpaceOnUse",
                        x: "1",
                        y: "1",
                        width: "26",
                        height: "26",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Mask_2",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M13 26.25H15C15.9663 26.25 16.8099 25.6358 17.1224 24.7488C19.873 24.6956 22.245 22.8516 23.0017 20.25C24.7958 20.2491 26.25 18.7944 26.25 17V15C26.25 13.2892 24.9281 11.8871 23.25 11.7595V10C23.25 5.44365 19.5563 1.75 15 1.75H13C8.44365 1.75 4.75 5.44365 4.75 10V11.7595C3.07189 11.8871 1.75 13.2892 1.75 15V17C1.75 18.7949 3.20507 20.25 5 20.25H7C7.69036 20.25 8.25 19.6904 8.25 19V13C8.25 12.3096 7.69036 11.75 7 11.75H6.25V10C6.25 6.27208 9.27208 3.25 13 3.25H15C18.7279 3.25 21.75 6.27208 21.75 10V11.75H21C20.3096 11.75 19.75 12.3096 19.75 13V19C19.75 19.6904 20.3096 20.25 21 20.25H21.4174C20.7246 22 19.0436 23.1998 17.1214 23.2485C16.8082 22.3629 15.9653 21.75 15 21.75H13C11.7574 21.75 10.75 22.7574 10.75 24C10.75 25.2426 11.7574 26.25 13 26.25ZM24.75 17C24.75 17.9665 23.9665 18.75 23 18.75H21.25V13.25H22H23C23.9665 13.25 24.75 14.0335 24.75 15V17ZM5 13.25C4.0335 13.25 3.25 14.0335 3.25 15V17C3.25 17.9665 4.0335 18.75 5 18.75H6.75V13.25H5ZM12.25 24C12.25 23.5858 12.5858 23.25 13 23.25H15C15.4142 23.25 15.75 23.5858 15.75 24C15.75 24.4142 15.4142 24.75 15 24.75H13C12.5858 24.75 12.25 24.4142 12.25 24Z",
                            fill: secondColor
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        mask: "url(#mask0_0_3326)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            id: "Cores/Preto_2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                id: "Rectangle",
                                width: width,
                                height: height,
                                fill: color
                            })
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Heart.tsx


var Heart = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.400 */.rS.colors.secondary[400] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.5247 1.3017C12.7802 1.8775 12.272 2.40814 12 2.89362C11.7281 2.40814 11.22 1.8775 10.4755 1.3017C9.3587 0.437988 8.08997 0 6.70459 0C4.85101 0 3.1463 0.742126 1.90393 2.0896C0.676208 3.42133 0 5.24066 0 7.21271C0 9.24243 0.756409 11.1004 2.38037 13.06C3.83313 14.8129 5.92108 16.5923 8.33899 18.6528L8.3432 18.6564C8.83468 19.0752 9.86085 19.8377 11.4217 20.9439C11.7681 21.1895 12.2318 21.1894 12.5782 20.9439L12.5782 20.9439C14.1415 19.8358 15.1693 19.0719 15.6617 18.6524L15.6621 18.6521C18.0795 16.5919 20.1671 14.8128 21.6198 13.0598C23.2438 11.1004 24 9.24243 24 7.21271C24 5.24066 23.324 3.42133 22.0963 2.0896C20.8539 0.742126 19.149 0 17.2956 0C15.9102 0 14.6415 0.437988 13.5247 1.3017ZM20.4649 12.1026C19.3195 13.4848 18.0768 14.6234 14.6888 17.5108C13.4507 18.5656 12.7863 19.1355 12.0001 19.8225C11.2181 19.1392 10.568 18.5815 9.31609 17.5147L9.32326 17.5209C5.92452 14.6244 4.6807 13.4849 3.53528 12.1028C2.12233 10.3978 1.5 8.86915 1.5 7.21271C1.5 5.60902 2.04064 4.15431 3.00678 3.10632C3.96428 2.06782 5.26875 1.5 6.70459 1.5C7.75606 1.5 8.70242 1.82669 9.55779 2.48823C10.0054 2.83449 10.4168 3.26406 10.7845 3.7726L11.1896 4.33275C11.2519 4.41894 11.3276 4.49463 11.4138 4.55697C11.8612 4.88069 12.4864 4.78037 12.8101 4.33291L13.2153 3.77283C13.5836 3.26381 13.9948 2.83434 14.4423 2.48829C15.2978 1.82669 16.2441 1.5 17.2956 1.5C18.7313 1.5 20.036 2.06788 20.9935 3.10638C21.9595 4.15421 22.5 5.60888 22.5 7.21271C22.5 8.8693 21.8777 10.398 20.4649 12.1026Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/HeartIcon.tsx


var HeartIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? "none" : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.580 */.rS.colors.neutral[580] : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de cora\xe7\xe3o" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: color,
        "aria-label": alt,
        "aria-labelledby": alt,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.5091 5.9742L12 6.49112L11.4908 5.97412C10.5625 5.03106 9.29461 4.5 7.97132 4.5C6.64804 4.5 5.38012 5.03106 4.45182 5.97412V5.97412C2.51606 7.96337 2.51606 11.1322 4.45182 13.1215L9.84447 18.5971C10.413 19.1747 11.1896 19.5 12 19.5C12.8105 19.5 13.587 19.1747 14.1556 18.5971L19.5482 13.1216C21.4839 11.1323 21.4839 7.96347 19.5482 5.97421V5.97421C18.6199 5.03112 17.3519 4.50003 16.0286 4.50003C14.7053 4.50003 13.4374 5.03111 12.5091 5.9742Z",
            stroke: secondColor,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Help.tsx


var Help = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.tertiary.105 */.rS.colors.tertiary[105] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "9",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.5968 7.88475C13.1692 7.62825 12.654 7.5 12.051 7.5H11.97C11.358 7.5 10.827 7.635 10.377 7.905C9.927 8.175 9.585 8.517 9.351 8.931C9.117 9.345 9 9.768 9 10.2C9 10.4833 9.22967 10.713 9.51298 10.713L9.86327 10.713C9.8718 10.713 9.88033 10.7128 9.88885 10.7123C10.1502 10.6982 10.3506 10.4749 10.3365 10.2135C10.3365 9.7635 10.4827 9.399 10.7753 9.12C11.0678 8.841 11.4615 8.7015 11.9565 8.7015C12.4065 8.7015 12.7845 8.841 13.0905 9.12C13.3965 9.399 13.5495 9.75 13.5495 10.173C13.5495 10.47 13.464 10.7355 13.293 10.9695C13.122 11.2035 12.861 11.4915 12.51 11.8335C12.159 12.1665 11.8935 12.4567 11.7135 12.7043C11.5335 12.9518 11.4435 13.2285 11.4435 13.5345V13.7235C11.4435 14.0963 11.7457 14.3985 12.1185 14.3985H12.132C12.4973 14.3985 12.7935 14.1023 12.7935 13.737C12.7935 13.53 12.8587 13.341 12.9892 13.17C13.1198 12.999 13.3245 12.7875 13.6035 12.5355C14.0085 12.1845 14.3235 11.8448 14.5485 11.5163C14.7735 11.1877 14.886 10.767 14.886 10.254C14.886 9.777 14.778 9.327 14.562 8.904C14.346 8.481 14.0243 8.14125 13.5968 7.88475ZM12.8204 16.194V16.0995C12.8204 15.7118 12.5061 15.3975 12.1184 15.3975C11.7307 15.3975 11.4164 15.7118 11.4164 16.0995V16.194C11.4164 16.5817 11.7307 16.896 12.1184 16.896C12.5061 16.896 12.8204 16.5817 12.8204 16.194Z",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Hiper.tsx


var Hiper = function(param) {
    var _width = param.width, width = _width === void 0 ? 65 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _alt = param.alt, alt = _alt === void 0 ? "Hiper" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.yellow.300 */.rS.colors.yellow[300] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.yellow.400 */.rS.colors.yellow[400] : _thirdColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 28 21",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.04243 3.41551L18.4603 0.100072C20.5643 -0.383859 22.683 0.934831 23.1686 3.03045L26.4972 17.3912C26.7543 18.5001 26.5045 19.6129 25.9006 20.487H3.97049L1.10039 8.10491C0.61475 6.00951 1.93869 3.89923 4.04243 3.41551Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.69835 15.4472H7.51018V12.8676H5.08645V15.4472H3.8985V9.49053H5.08645V11.8164H7.51018V9.49053H8.69835V15.4472Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.053 9.71574C11.053 9.81376 11.0344 9.90562 10.9945 9.9913C10.9561 10.077 10.904 10.152 10.8378 10.2163C10.7717 10.2807 10.6933 10.3311 10.6026 10.3679C10.5136 10.4061 10.4182 10.4244 10.32 10.4244C10.223 10.4244 10.1323 10.4061 10.0463 10.3679C9.96175 10.3311 9.8864 10.2807 9.82193 10.2163C9.75725 10.152 9.70666 10.077 9.66823 9.9913C9.6313 9.90562 9.61273 9.81376 9.61273 9.71574C9.61273 9.61624 9.6313 9.52438 9.66823 9.43721C9.70666 9.35131 9.75725 9.27477 9.82193 9.21055C9.8864 9.14634 9.96175 9.09574 10.0463 9.05895C10.1323 9.02068 10.223 9.0024 10.32 9.0024C10.4182 9.0024 10.5136 9.02068 10.6026 9.05895C10.6933 9.09574 10.7717 9.14634 10.8378 9.21055C10.904 9.27477 10.9561 9.35131 10.9945 9.43721C11.0344 9.52438 11.053 9.61624 11.053 9.71574Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.0258 16.8907V15.514L11.966 15.5146C11.6569 15.5146 11.3696 15.464 11.1021 15.3615C11.037 15.3369 10.974 15.3092 10.9132 15.2786C10.2034 14.9148 9.84608 14.1706 9.76965 13.1235V11.1397H10.9132C10.9132 11.6955 10.9465 12.6431 10.9132 13.3835C10.9132 13.5536 10.9655 13.7864 11.0253 13.9455C11.0853 14.103 11.1651 14.2331 11.2635 14.3344C11.3634 14.4368 11.4804 14.5119 11.6155 14.5608C11.7398 14.6074 11.8757 14.6316 12.0258 14.6352V11.1397H12.7283C12.8005 11.1397 12.8624 11.1561 12.9111 11.1886C12.9606 11.2218 12.9911 11.2732 13.008 11.3417L13.1032 11.7321C13.1924 11.6325 13.2878 11.5407 13.386 11.458C13.4859 11.374 13.5922 11.3021 13.7088 11.2422C13.8241 11.1828 13.9485 11.1359 14.0824 11.1029C14.2158 11.0702 14.3605 11.0538 14.5157 11.0538C14.7539 11.0538 14.9704 11.105 15.1689 11.2069C15.3668 11.3085 15.5389 11.4554 15.6821 11.6479C16.0871 12.1913 16.137 12.4966 16.137 13.1862C16.137 13.5183 16.0926 13.826 16.0019 14.1107C15.9127 14.3939 15.7852 14.6403 15.6191 14.8487C15.4548 15.0568 15.255 15.2191 15.0229 15.3371C14.7907 15.4549 14.5296 15.5146 14.242 15.5146C13.9993 15.5146 13.7933 15.4778 13.6243 15.4043C13.4567 15.3307 13.3045 15.2314 13.1694 15.1057V16.8907H12.0258ZM14.1253 11.8099C13.9116 11.8099 13.7319 11.8528 13.5843 11.937C13.4368 12.0227 13.2983 12.1467 13.1694 12.3074V14.2806C13.2846 14.4183 13.4076 14.5149 13.5412 14.5699C13.6749 14.6252 13.8179 14.6526 13.9716 14.6526C14.1191 14.6526 14.2529 14.6235 14.3744 14.5655C14.4956 14.5072 14.6002 14.4183 14.6878 14.2991C14.7738 14.1796 14.8415 14.0282 14.8876 13.8445C14.9337 13.6591 14.9582 13.4403 14.9582 13.1862C14.9582 12.9351 14.9384 12.7222 14.9 12.5477C14.8598 12.3733 14.8045 12.2309 14.7324 12.1222C14.6602 12.0119 14.574 11.9338 14.4711 11.8834C14.3697 11.8343 14.2544 11.8099 14.1253 11.8099Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.8482 11.0676C19.131 11.0676 19.391 11.1131 19.6274 11.2039C19.8641 11.2949 20.0682 11.428 20.2392 11.5989C20.4106 11.7705 20.5444 11.8379 20.6403 12.0884C20.7363 12.3397 20.7848 12.6259 20.7848 12.9489C20.7848 13.036 20.7801 13.1064 20.7709 13.1615C20.7617 13.2168 20.7479 13.2612 20.7278 13.2948C20.7094 13.3269 20.6817 13.3499 20.648 13.3637C20.6125 13.3775 20.5696 13.3835 20.5188 13.3835H17.8447C17.863 13.5995 17.9015 13.7862 17.9614 13.9454C18.0212 14.103 18.1013 14.2331 18.1997 14.3343C18.2996 14.4368 18.4163 14.5119 18.5515 14.5608C18.6868 14.6114 18.8358 14.6358 19.0019 14.6358C19.1663 14.6358 19.3093 14.6158 19.4308 14.5746C19.5537 14.5348 19.6596 14.4904 19.7518 14.4444C19.8425 14.3985 19.9241 14.3556 19.9962 14.3143C20.0686 14.2746 20.1393 14.2546 20.2084 14.2546C20.293 14.2546 20.3606 14.2882 20.4159 14.3571L20.7449 14.7781C20.6202 14.922 20.4851 15.0415 20.3344 15.1348C20.1837 15.2297 20.0285 15.3047 19.8688 15.3598C19.7074 15.4151 19.5445 15.4548 19.3799 15.4793C19.2139 15.5022 19.0557 15.5146 18.902 15.5146C16.8542 15.5146 16.2686 13.1685 17.279 11.7152C17.4337 11.4926 17.688 11.3582 17.9521 11.2421C18.2163 11.1258 18.5148 11.0676 18.8482 11.0676ZM18.8712 11.7333C18.5792 11.7333 18.3519 11.8175 18.1858 11.9874C18.0212 12.1558 17.9153 12.3945 17.866 12.7024H19.758C19.758 12.5738 19.7411 12.4513 19.7057 12.335C19.672 12.2187 19.6182 12.1145 19.5445 12.0256C19.4707 11.9355 19.3785 11.8649 19.2679 11.8113C19.1556 11.7594 19.0235 11.7333 18.8712 11.7333Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.5596 15.4472V11.1397H22.2311C22.3479 11.1397 22.4292 11.1616 22.4754 11.2024C22.5225 11.2437 22.5558 11.3174 22.5693 11.4212L22.6276 11.8743C22.7629 11.6202 22.9202 11.4199 23.0993 11.2743C23.2793 11.128 23.4883 11.0538 23.725 11.0538C23.9201 11.0538 24.0815 11.0999 24.2077 11.1933L24.1214 11.9002C24.1152 11.9532 24.0975 11.9915 24.0676 12.0136C24.0382 12.0353 23.997 12.0472 23.9462 12.0472C23.9018 12.0472 23.8371 12.041 23.7528 12.0272C23.6682 12.0136 23.5914 12.0074 23.519 12.0074C23.4129 12.0074 23.3192 12.0227 23.2379 12.0518C23.1548 12.0825 23.081 12.1269 23.0165 12.1849C22.9518 12.2432 22.8935 12.3136 22.8427 12.3978C22.7921 12.4805 22.7458 12.5768 22.7029 12.684V15.4472H21.5596Z",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Hipercard.tsx


var Hipercard = function(param) {
    var _width = param.width, width = _width === void 0 ? 64 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _alt = param.alt, alt = _alt === void 0 ? "Hipercard" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.800 */.rS.colors.primary[800] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 47 21",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1212 1H9.54501C7.52305 1.09624 5.87023 1.9161 5.393 3.60676C5.14415 4.48848 5.00721 5.45684 4.81262 6.37084C3.82339 11.0183 2.94624 15.7937 2 20.3484H37.6269C40.3812 20.3484 42.2723 19.7625 42.7834 17.5619C43.0208 16.5396 43.2483 15.3816 43.4754 14.2585C44.3609 9.8793 45.2472 5.50038 46.1541 1H14.1212Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.5026 12.5598C32.0085 13.0467 30.6216 13.185 30.7635 12.0211C30.8813 11.0543 31.9268 10.8489 33.06 10.9885C32.9757 11.5173 32.8791 12.1888 32.5026 12.5598ZM30.9418 8.78879C30.8946 9.05549 30.8222 9.29683 30.7635 9.55193C31.3292 9.40917 33.091 8.9713 33.2608 9.73147C33.3171 9.98405 33.2199 10.2524 33.1492 10.4498C31.5561 10.2979 30.2576 10.5643 29.9161 11.7068C29.6874 12.472 29.9418 13.225 30.429 13.4353C31.3674 13.8399 32.5088 13.3763 32.904 12.7394C32.8629 12.9599 32.8241 13.1826 32.8371 13.4577H33.662C33.6708 12.6623 33.7858 12.0185 33.9073 11.3027C34.0109 10.6932 34.2058 10.0899 34.1748 9.55193C34.104 8.31998 32.0766 8.75576 30.9418 8.78879ZM39.214 12.9413C38.5686 12.9553 38.2477 12.5532 38.2329 11.8864C38.2072 10.7187 38.716 9.42137 39.7492 9.30502C40.2302 9.25089 40.5785 9.3635 40.9309 9.48465C40.6074 10.7963 40.7242 12.9088 39.214 12.9413ZM41.3546 6.7686C41.2724 7.49391 41.1625 8.19143 41.0202 8.85608C38.6683 8.10671 37.226 9.84861 37.2519 11.9986C37.257 12.4144 37.328 12.8267 37.5864 13.1209C38.0316 13.6278 39.3063 13.749 39.9499 13.323C40.0745 13.2406 40.2018 13.0905 40.2844 12.9863C40.3464 12.9079 40.4449 12.7027 40.4626 12.7617C40.4289 12.9896 40.3783 13.2006 40.3736 13.4577H41.2431C41.4107 11.0375 41.9289 8.97034 42.3134 6.7686H41.3546ZM16.8054 12.5823C16.2924 13.1292 15.0313 13.1208 14.9325 12.2006C14.8893 11.8002 15.0376 11.3804 15.1108 10.9661C15.1849 10.5468 15.2382 10.1445 15.3114 9.77636C15.8167 9.15528 17.3014 9.08033 17.452 10.1131C17.5827 11.0098 17.2302 12.1293 16.8054 12.5823ZM17.5635 8.78879C16.752 8.48192 15.763 8.84823 15.3343 9.19668C15.3357 9.21202 15.324 9.21412 15.3114 9.21525C15.3188 9.20906 15.3266 9.20287 15.3343 9.19668C15.3342 9.19538 15.3341 9.19424 15.3337 9.19285C15.341 9.04294 15.3934 8.93861 15.4007 8.78879H14.5757C14.2319 11.0914 13.8242 13.3295 13.3939 15.5451H14.3527C14.4914 14.6822 14.5831 13.7719 14.7764 12.9638C14.9953 13.8138 16.425 13.6513 17.0283 13.323C18.2732 12.6454 19.2333 9.42024 17.5635 8.78879ZM22.1121 10.4049H19.8601C19.9314 9.88374 20.3972 9.31086 21.131 9.28262C21.8217 9.25604 22.3162 9.5379 22.1121 10.4049ZM21.1979 8.69902C20.5051 8.75271 19.9195 8.95343 19.5034 9.39479C18.9929 9.9362 18.5795 11.1331 18.7006 12.2231C18.8734 13.7781 20.7967 13.7224 22.3351 13.3454C22.3613 13.0725 22.4269 12.8392 22.4689 12.5823C21.8351 12.821 20.7348 13.1542 20.0831 12.7394C19.591 12.4262 19.5881 11.633 19.7486 10.9436C20.7825 10.9105 21.8571 10.9169 22.8925 10.9436C22.9582 10.455 23.1462 9.92235 22.9817 9.43976C22.7647 8.80265 21.9882 8.63775 21.1979 8.69902ZM12.7696 8.78879C12.7436 8.79254 12.7454 8.82427 12.7473 8.85608C12.536 10.4466 12.2501 11.9621 11.9446 13.4577H12.9034C13.1337 11.8564 13.3976 10.289 13.7284 8.78879H12.7696ZM37.7871 8.81119C36.9397 8.38474 36.2342 9.10038 35.9587 9.52945C36.0372 9.30929 36.0417 9.01453 36.1148 8.78879H35.2674C35.039 10.3919 34.7636 11.9478 34.4424 13.4577H35.4235C35.4298 12.8389 35.5505 12.3811 35.6465 11.7742C35.8516 10.4784 36.1525 9.05732 37.6533 9.48465C37.7031 9.26545 37.7238 9.01688 37.7871 8.81119ZM27.0175 12.3577C26.9291 12.1279 26.9062 11.7484 26.9283 11.4599C26.9779 10.8113 27.2126 10.0216 27.5749 9.66419C28.0749 9.1708 29.062 9.25246 29.8492 9.52945C29.8736 9.26231 29.9269 9.02411 29.9607 8.76639C28.6695 8.55408 27.4442 8.68612 26.7945 9.37239C26.1586 10.0442 25.7417 11.5882 26.0364 12.5598C26.3814 13.6966 27.928 13.7584 29.1804 13.323C29.2357 13.0945 29.2651 12.8397 29.3142 12.6047C28.6299 12.9626 27.3216 13.1486 27.0175 12.3577ZM26.4824 8.78879C25.6322 8.44313 24.9639 9.02725 24.6541 9.57442C24.7243 9.33099 24.7533 9.0459 24.8101 8.78879H23.9628C23.7557 10.406 23.4503 11.9242 23.1601 13.4577H24.1189C24.2533 12.5474 24.3113 11.3205 24.6094 10.4498C24.8477 9.75405 25.4712 9.1613 26.3709 9.48465C26.3835 9.22797 26.4565 9.03205 26.4824 8.78879ZM11.0304 6.90326C10.8935 7.79791 10.7392 8.67514 10.5845 9.55193C9.59119 9.56248 8.57703 9.60135 7.61898 9.52945C7.79992 8.67174 7.9297 7.76235 8.10943 6.90326H7.03926C6.65607 9.09149 6.3076 11.3145 5.87982 13.4577H6.97233C7.14376 12.3582 7.30401 11.2476 7.52971 10.2029C8.46128 10.1798 9.57777 10.1395 10.473 10.2254C10.2884 11.3115 10.0654 12.3589 9.89326 13.4577H10.9859C11.3368 11.2372 11.7068 9.03571 12.1453 6.90326H11.0304ZM13.7507 7.89091C13.9418 7.75843 14.188 7.15461 13.9068 6.90326C13.8177 6.82368 13.6686 6.80059 13.4608 6.83597C13.268 6.86874 13.1571 6.93463 13.0818 7.03791C12.9606 7.20403 12.8496 7.70483 13.0371 7.89091C13.2198 8.07211 13.629 7.97519 13.7507 7.89091Z",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Home.tsx


var Home = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _alt = param.alt, alt = _alt === void 0 ? "Inicio" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 18 16",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.50613 0.435567L5.00001 3.50342V2C5.00001 1.44772 4.5523 1 4.00001 1C3.44773 1 3.00001 1.44772 3.00001 2V5C3.00001 5.0792 3.00922 5.15625 3.02662 5.23014L0.506132 7.43557C0.194404 7.70833 0.162816 8.18215 0.435578 8.49388C0.708339 8.80561 1.18216 8.83719 1.49389 8.56443L9.00074 1.99594L16.5305 8.56515C16.8426 8.83746 17.3164 8.80518 17.5887 8.49306C17.861 8.18093 17.8287 7.70716 17.5166 7.43485L9.49307 0.434849C9.21025 0.188111 8.78859 0.188418 8.50613 0.435567ZM11 11V16H14C14.5523 16 15 15.5523 15 15V9.46837C15 9.17159 14.8682 8.89015 14.6402 8.70015L9.64019 4.53349C9.26935 4.22445 8.73067 4.22445 8.35983 4.53349L3.35983 8.70015C3.13183 8.89015 3.00001 9.17159 3.00001 9.46837V15C3.00001 15.5523 3.44773 16 4.00001 16H7.00001V11H11Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/HomeIcon.tsx


var HomeIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? "18px" : _height, _width = param.width, width = _width === void 0 ? "18px" : _width, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.200 */.rS.colors.primary[200] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de casa" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: color,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 256 256",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M218.83,103.77l-80-75.48a1.14,1.14,0,0,1-.11-.11,16,16,0,0,0-21.53,0l-.11.11L37.17,103.77A16,16,0,0,0,32,115.55V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V160h32v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V115.55A16,16,0,0,0,218.83,103.77ZM208,208H160V160a16,16,0,0,0-16-16H112a16,16,0,0,0-16,16v48H48V115.55l.11-.1L128,40l79.9,75.43.11.1Z"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/HomeImprovementsIcon.tsx


var HomeImprovementsIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 322 : _height, _width = param.width, width = _width === void 0 ? 211 : _width, _color = param.color, color = _color === void 0 ? "".concat(themes/* theme.colors.neutral.150 */.rS.colors.neutral[150]) : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? "".concat(themes/* theme.colors.secondary.410 */.rS.colors.secondary[410]) : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? "".concat(themes/* theme.colors.yellow.1100 */.rS.colors.yellow[1100]) : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? "".concat(themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"]) : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? "".concat(themes/* theme.colors.primary.900 */.rS.colors.primary[900]) : _fifthColor, _sixthColor = param.sixthColor, sixthColor = _sixthColor === void 0 ? "".concat(themes/* theme.colors.primary.180 */.rS.colors.primary[180]) : _sixthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 211 322",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M108 108H2V214H108V108Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.8111 142.428C34.2714 142.428 33.7178 142.221 33.3027 141.805C28.9434 137.446 28.9434 130.333 33.3027 125.974C37.6758 121.614 44.7752 121.614 49.1345 125.974L58.4759 135.315C59.3062 136.145 59.3062 137.501 58.4759 138.332C57.6455 139.162 56.2893 139.162 55.459 138.332L46.1176 128.99C43.419 126.292 39.032 126.292 36.3334 128.99C33.6348 131.689 33.6348 136.076 36.3334 138.775C37.1638 139.605 37.1638 140.961 36.3334 141.792C35.9182 142.207 35.3647 142.414 34.825 142.414",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.0235 192.902C52.47 192.902 51.9302 192.694 51.5151 192.279L20.0451 160.809C19.2148 159.979 19.2148 158.622 20.0451 157.792L56.8708 120.967C57.7011 120.136 59.0573 120.136 59.8877 120.967L91.3576 152.436C92.1879 153.267 92.1879 154.623 91.3576 155.453L54.532 192.279C54.1168 192.694 53.5632 192.902 53.0235 192.902ZM24.5705 159.287L53.0235 187.74L86.8322 153.931L58.3792 125.478L24.5705 159.287V159.287Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56.9536 142.43C53.826 142.43 51.2935 139.883 51.2935 136.77C51.2935 133.656 53.8398 131.109 56.9536 131.109C60.0674 131.109 62.6138 133.656 62.6138 136.77C62.6138 139.883 60.0674 142.43 56.9536 142.43ZM56.9536 135.372C56.1925 135.372 55.5559 135.995 55.5559 136.77C55.5559 137.545 56.1786 138.167 56.9536 138.167C57.7286 138.167 58.3514 137.545 58.3514 136.77C58.3514 135.995 57.7286 135.372 56.9536 135.372Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M88.8251 191.325C85.6006 191.325 83.843 189.706 82.9297 188.35C80.7016 185.015 80.7293 179.147 83.0265 170.415C84.6319 164.325 86.7492 159.15 86.8461 158.928C87.1782 158.125 87.9532 157.6 88.8251 157.6C89.6969 157.6 90.4719 158.125 90.8041 158.928C90.8871 159.15 93.0183 164.325 94.6236 170.415C96.9209 179.147 96.9486 185.015 94.7205 188.35C93.8071 189.706 92.0496 191.325 88.8251 191.325M88.8251 165.986C88.2715 167.647 87.6764 169.557 87.1506 171.563C86.2787 174.898 84.4658 182.967 86.4863 185.983C86.8184 186.482 87.3858 187.063 88.8251 187.063C90.2643 187.063 90.8317 186.495 91.1639 185.983C91.842 184.973 93.129 181.555 90.4996 171.563C89.9737 169.57 89.3786 167.647 88.8251 165.986Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.6486 145.279C37.095 145.279 36.5553 145.072 36.1401 144.656L33.2893 141.819C32.4589 140.989 32.4589 139.633 33.2893 138.802C34.1196 137.972 35.4758 137.972 36.3062 138.802L39.157 141.653C39.9873 142.484 39.9873 143.84 39.157 144.67C38.7418 145.085 38.1883 145.293 37.6486 145.293",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M54.1858 194.075C53.6323 194.075 53.0925 193.868 52.6774 193.453L18.5227 159.298C17.6923 158.468 17.6923 157.111 18.5227 156.281C19.353 155.451 20.7092 155.451 21.5396 156.281L55.6943 190.436C56.5246 191.266 56.5246 192.622 55.6943 193.453C55.2791 193.868 54.7255 194.075 54.1858 194.075",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M90.7903 157.017C90.2368 157.017 89.697 156.809 89.2819 156.394L55.1272 122.239C54.2968 121.409 54.2968 120.053 55.1272 119.222C55.9575 118.392 57.3137 118.392 58.1441 119.222L92.2988 153.377C93.1291 154.207 93.1291 155.564 92.2988 156.394C91.8836 156.809 91.33 157.017 90.7903 157.017",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M67.9419 176.611C66.4888 176.611 65.1326 176.044 64.1085 175.034L63.209 174.134C61.1055 172.03 61.1055 168.598 63.209 166.481L74.3356 155.354C75.1659 154.524 76.5221 154.524 77.3525 155.354C78.1828 156.185 78.1828 157.541 77.3525 158.371L66.2259 169.498C65.7831 169.941 65.7831 170.674 66.2259 171.103L67.1254 172.003C67.4161 172.293 67.7482 172.335 67.9281 172.335C68.108 172.335 68.454 172.293 68.7308 172.003L88.3268 152.421C89.1572 151.59 90.5134 151.59 91.3576 152.421C92.1879 153.251 92.1879 154.607 91.3576 155.438L71.7615 175.034C70.7374 176.058 69.3812 176.611 67.9281 176.611",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M75.8576 158.996C75.304 158.996 74.7643 158.788 74.3491 158.373C73.5188 157.543 73.5188 156.187 74.3491 155.356C74.6397 155.066 74.6813 154.734 74.6813 154.554C74.6813 154.374 74.6397 154.042 74.3491 153.751L73.4496 152.851C73.159 152.561 72.8268 152.519 72.6469 152.519C72.467 152.519 72.121 152.561 71.8443 152.851C71.0139 153.682 69.6577 153.682 68.8273 152.851C67.997 152.021 67.997 150.665 68.8273 149.834C70.9309 147.731 74.3768 147.731 76.4803 149.834L77.3799 150.734C78.404 151.758 78.9575 153.114 78.9575 154.567C78.9575 156.021 78.3901 157.377 77.3799 158.401C76.9647 158.816 76.4111 159.024 75.8714 159.024",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M61.9356 160.503C60.5517 160.503 59.1678 159.977 58.1022 158.925L57.2026 158.026C55.0991 155.922 55.0991 152.476 57.2026 150.373L71.6091 135.967C72.4394 135.136 73.7956 135.136 74.626 135.967C75.4563 136.797 75.4563 138.153 74.626 138.983L60.2196 153.39C59.7767 153.833 59.7767 154.566 60.2196 154.995L61.1191 155.895C61.5481 156.338 62.2954 156.338 62.7244 155.895L68.7998 149.819C69.6301 148.989 70.9863 148.989 71.8167 149.819C72.647 150.65 72.647 152.006 71.8167 152.836L65.7413 158.912C64.6896 159.963 63.3057 160.489 61.9079 160.489",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214 2H108V108H214V2Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M151.924 48.9402H120.731C119.555 48.9402 118.6 47.9853 118.6 46.809V30.6312C118.6 29.4549 119.555 28.5 120.731 28.5H151.924C153.101 28.5 154.056 29.4549 154.056 30.6312V46.809C154.056 47.9853 153.101 48.9402 151.924 48.9402ZM122.863 44.664H149.779V32.7624H122.863V44.664Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M151.924 81.2937H120.731C119.555 81.2937 118.6 80.3389 118.6 79.1625V62.9847C118.6 61.8084 119.555 60.8535 120.731 60.8535H151.924C153.101 60.8535 154.056 61.8084 154.056 62.9847V79.1625C154.056 80.3389 153.101 81.2937 151.924 81.2937ZM122.863 77.0175H149.779V65.1021H122.863V77.0175Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M183.049 81.2937H151.855C150.679 81.2937 149.71 80.3389 149.71 79.1625V62.9847C149.71 61.8084 150.665 60.8535 151.855 60.8535H183.049C184.225 60.8535 185.18 61.8084 185.18 62.9847V79.1625C185.18 80.3389 184.225 81.2937 183.049 81.2937ZM153.987 77.0175H180.904V65.1021H153.987V77.0175Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M167.48 65.1182H136.286C135.11 65.1182 134.155 64.1633 134.155 62.9869V46.8091C134.155 45.6328 135.11 44.6641 136.286 44.6641H167.48C168.656 44.6641 169.625 45.619 169.625 46.8091V62.9869C169.625 64.1633 168.67 65.1182 167.48 65.1182ZM138.418 60.8419H165.335V48.9403H138.418V60.8419Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M198.603 65.1182H167.41C166.234 65.1182 165.279 64.1633 165.279 62.9869V46.8091C165.279 45.6328 166.234 44.6641 167.41 44.6641H198.603C199.78 44.6641 200.735 45.619 200.735 46.8091V62.9869C200.735 64.1633 199.78 65.1182 198.603 65.1182ZM169.541 60.8419H196.458V48.9403H169.541V60.8419Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214 108H108V214H214V108Z",
                fill: fifthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M161.4 173.374C160.847 173.374 160.307 173.167 159.892 172.752C155.491 168.351 152.737 162.525 152.128 156.339C151.588 150.831 152.765 145.254 155.449 140.465L146.025 131.041C143.188 128.204 143.188 123.582 146.025 120.731C147.409 119.347 149.236 118.6 151.187 118.6C153.138 118.6 154.965 119.361 156.349 120.731L165.773 130.155C170.562 127.47 176.139 126.294 181.647 126.834C187.833 127.443 193.659 130.197 198.06 134.598C198.89 135.428 198.89 136.784 198.06 137.614L162.936 172.738C162.521 173.153 161.968 173.361 161.428 173.361M151.201 122.862C150.398 122.862 149.637 123.18 149.07 123.748C147.893 124.924 147.893 126.834 149.07 128.01L159.67 138.611C160.39 139.33 160.501 140.438 159.947 141.296C157.152 145.586 155.892 150.775 156.39 155.91C156.833 160.393 158.618 164.67 161.483 168.129L193.437 136.175C189.978 133.31 185.701 131.525 181.218 131.082C176.083 130.57 170.894 131.844 166.604 134.639C165.759 135.193 164.638 135.082 163.919 134.362L153.318 123.762C152.751 123.194 151.99 122.876 151.187 122.876L151.201 122.862Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M178.962 165.665C175.89 165.665 172.817 164.502 170.478 162.163C169.648 161.333 169.648 159.977 170.478 159.147C171.309 158.316 172.665 158.316 173.509 159.147C176.512 162.15 181.411 162.15 184.428 159.147C187.431 156.13 187.431 151.231 184.428 148.228C183.598 147.397 183.598 146.041 184.428 145.211C185.259 144.38 186.615 144.38 187.445 145.211C192.123 149.888 192.123 157.5 187.445 162.177C185.106 164.516 182.034 165.679 178.962 165.679",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M150.218 207.155C149.443 207.155 148.696 206.726 148.309 205.993L129.432 168.904C129.059 168.17 129.142 167.285 129.64 166.634L152.972 135.995C153.692 135.054 155.034 134.874 155.962 135.593C156.903 136.313 157.083 137.655 156.363 138.596L133.833 168.17L152.1 204.069C152.64 205.121 152.211 206.408 151.159 206.947C150.855 207.113 150.523 207.183 150.191 207.183",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M216 212H106V322H216V212Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M145.965 307.392C145.906 307.392 145.836 307.392 145.777 307.392C144.323 307.287 143.221 306.02 143.327 304.566L147.653 243.867C147.758 242.413 149.024 241.322 150.478 241.416C151.932 241.521 153.022 242.788 152.928 244.242L148.602 304.941C148.509 306.337 147.348 307.392 145.976 307.392",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M176.034 307.392C174.663 307.392 173.502 306.325 173.408 304.941L169.082 244.242C168.977 242.788 170.079 241.521 171.533 241.416C172.986 241.322 174.252 242.413 174.358 243.867L178.684 304.566C178.789 306.02 177.687 307.287 176.234 307.392C176.175 307.392 176.105 307.392 176.046 307.392",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M177.219 245.448H144.793C143.339 245.448 142.155 244.264 142.155 242.81V235.867C142.155 234.413 143.339 233.229 144.793 233.229H177.219C178.673 233.229 179.857 234.413 179.857 235.867V242.81C179.857 244.264 178.673 245.448 177.219 245.448ZM147.43 240.171H174.582V238.506H147.43V240.171Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M173.081 284.004H148.907C147.454 284.004 146.27 282.819 146.27 281.365C146.27 279.911 147.454 278.727 148.907 278.727H173.081C174.534 278.727 175.719 279.911 175.719 281.365C175.719 282.819 174.534 284.004 173.081 284.004Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M173.937 292.662H148.063C146.61 292.662 145.426 291.478 145.426 290.023C145.426 288.569 146.61 287.385 148.063 287.385H173.937C175.39 287.385 176.574 288.569 176.574 290.023C176.574 291.478 175.39 292.662 173.937 292.662Z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/HomeImprovementsSmallIcon.tsx


var HomeImprovementsSmallIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 136 : _width, _height = param.height, height = _height === void 0 ? 207 : _height, _color = param.color, color = _color === void 0 ? "".concat(themes/* theme.colors.neutral.150 */.rS.colors.neutral[150]) : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? "".concat(themes/* theme.colors.yellow.1100 */.rS.colors.yellow[1100]) : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? "".concat(themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"]) : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? "".concat(themes/* theme.colors.primary.900 */.rS.colors.primary[900]) : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? "".concat(themes/* theme.colors.primary.180 */.rS.colors.primary[180]) : _fifthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 136 207",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69 70H2V137H69V70Z",
                fill: "".concat(themes/* theme.colors.secondary.250 */.rS.colors.secondary[250])
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.7392 91.765C22.3981 91.765 22.0482 91.6337 21.7858 91.3713C19.0304 88.6159 19.0304 84.1198 21.7858 81.3644C24.5499 78.609 29.0373 78.609 31.7927 81.3644L37.6971 87.2688C38.222 87.7937 38.222 88.6509 37.6971 89.1757C37.1723 89.7006 36.3151 89.7006 35.7902 89.1757L29.8858 83.2713C28.1801 81.5656 25.4072 81.5656 23.7014 83.2713C21.9957 84.977 21.9957 87.7499 23.7014 89.4557C24.2263 89.9805 24.2263 90.8377 23.7014 91.3626C23.439 91.625 23.0891 91.7562 22.748 91.7562",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.2502 123.661C33.9003 123.661 33.5591 123.53 33.2967 123.267L13.4053 103.376C12.8805 102.851 12.8805 101.994 13.4053 101.469L36.6819 78.1925C37.2068 77.6676 38.064 77.6676 38.5888 78.1925L58.4802 98.0838C59.0051 98.6087 59.0051 99.4659 58.4802 99.9907L35.2036 123.267C34.9412 123.53 34.5913 123.661 34.2502 123.661ZM16.2657 102.414L34.2502 120.398L55.6199 99.0285L37.6354 81.0441L16.2657 102.414Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.7354 91.7656C34.7585 91.7656 33.1577 90.1561 33.1577 88.188C33.1577 86.2199 34.7672 84.6104 36.7354 84.6104C38.7035 84.6104 40.313 86.2199 40.313 88.188C40.313 90.1561 38.7035 91.7656 36.7354 91.7656ZM36.7354 87.3045C36.2543 87.3045 35.8519 87.6981 35.8519 88.188C35.8519 88.6778 36.2455 89.0715 36.7354 89.0715C37.2252 89.0715 37.6188 88.6778 37.6188 88.188C37.6188 87.6981 37.2252 87.3045 36.7354 87.3045Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56.8794 122.665C54.8413 122.665 53.7304 121.641 53.1531 120.784C51.7447 118.676 51.7622 114.967 53.2143 109.448C54.229 105.599 55.5673 102.327 55.6286 102.187C55.8385 101.68 56.3283 101.348 56.8794 101.348C57.4305 101.348 57.9203 101.68 58.1303 102.187C58.1828 102.327 59.5299 105.599 60.5445 109.448C61.9966 114.967 62.0141 118.676 60.6058 120.784C60.0284 121.641 58.9175 122.665 56.8794 122.665ZM56.8794 106.649C56.5295 107.698 56.1534 108.905 55.821 110.174C55.2699 112.282 54.124 117.381 55.4011 119.288C55.6111 119.603 55.9697 119.971 56.8794 119.971C57.7891 119.971 58.1478 119.612 58.3577 119.288C58.7863 118.65 59.5998 116.489 57.9378 110.174C57.6054 108.914 57.2293 107.698 56.8794 106.649Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.5326 93.5665C24.1827 93.5665 23.8415 93.4353 23.5791 93.1728L21.7772 91.3796C21.2523 90.8548 21.2523 89.9976 21.7772 89.4727C22.302 88.9479 23.1592 88.9479 23.6841 89.4727L25.486 91.2747C26.0109 91.7995 26.0109 92.6568 25.486 93.1816C25.2236 93.444 24.8737 93.5752 24.5326 93.5752",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.9855 124.407C34.6356 124.407 34.2945 124.275 34.032 124.013L12.4437 102.425C11.9188 101.9 11.9188 101.042 12.4437 100.518C12.9685 99.9928 13.8258 99.9928 14.3506 100.518L35.9389 122.106C36.4638 122.631 36.4638 123.488 35.9389 124.013C35.6765 124.275 35.3266 124.407 34.9855 124.407Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58.1222 100.983C57.7723 100.983 57.4312 100.852 57.1688 100.589L35.5804 79.0007C35.0556 78.4759 35.0556 77.6187 35.5804 77.0938C36.1052 76.569 36.9625 76.569 37.4873 77.0938L59.0757 98.6822C59.6005 99.207 59.6005 100.064 59.0757 100.589C58.8132 100.852 58.4634 100.983 58.1222 100.983Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M43.6804 113.368C42.762 113.368 41.9047 113.009 41.2574 112.37L40.6888 111.802C39.3593 110.472 39.3593 108.303 40.6888 106.964L47.7217 99.9316C48.2465 99.4068 49.1038 99.4068 49.6286 99.9316C50.1534 100.456 50.1534 101.314 49.6286 101.839L42.5958 108.871C42.3158 109.151 42.3158 109.615 42.5958 109.886L43.1643 110.455C43.348 110.638 43.558 110.665 43.6717 110.665C43.7854 110.665 44.0041 110.638 44.179 110.455L56.5652 98.0772C57.09 97.5524 57.9473 97.5524 58.4809 98.0772C59.0057 98.6021 59.0057 99.4593 58.4809 99.9841L46.0947 112.37C45.4474 113.018 44.5901 113.368 43.6717 113.368",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M48.6837 102.233C48.3338 102.233 47.9927 102.102 47.7302 101.84C47.2054 101.315 47.2054 100.458 47.7302 99.9327C47.9139 99.749 47.9402 99.5391 47.9402 99.4253C47.9402 99.3116 47.9139 99.1017 47.7302 98.918L47.1617 98.3494C46.978 98.1657 46.768 98.1395 46.6543 98.1395C46.5406 98.1395 46.3219 98.1657 46.147 98.3494C45.6221 98.8743 44.7649 98.8743 44.2401 98.3494C43.7152 97.8246 43.7152 96.9673 44.2401 96.4425C45.5697 95.1129 47.7477 95.1129 49.0773 96.4425L49.6459 97.0111C50.2932 97.6584 50.6431 98.5156 50.6431 99.4341C50.6431 100.353 50.2845 101.21 49.6459 101.857C49.3835 102.12 49.0336 102.251 48.6924 102.251",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.8838 103.189C39.0091 103.189 38.1343 102.856 37.4608 102.192L36.8922 101.623C35.5626 100.293 35.5626 98.1153 36.8922 96.7857L45.9982 87.6798C46.523 87.1549 47.3802 87.1549 47.9051 87.6798C48.4299 88.2046 48.4299 89.0618 47.9051 89.5867L38.7991 98.6926C38.5192 98.9725 38.5192 99.4361 38.7991 99.7073L39.3677 100.276C39.6389 100.556 40.1112 100.556 40.3824 100.276L44.2225 96.4358C44.7473 95.911 45.6045 95.911 46.1294 96.4358C46.6542 96.9606 46.6542 97.8179 46.1294 98.3427L42.2893 102.183C41.6245 102.848 40.7498 103.18 39.8663 103.18",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M137 2H70V69H137V2Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M97.7635 31.6698H78.047C77.3035 31.6698 76.7 31.0662 76.7 30.3227V20.0971C76.7 19.3536 77.3035 18.75 78.047 18.75H97.7635C98.507 18.75 99.1106 19.3536 99.1106 20.0971V30.3227C99.1106 31.0662 98.507 31.6698 97.7635 31.6698ZM79.3941 28.9668H96.4076V21.4442H79.3941V28.9668Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M97.7635 52.1229H78.047C77.3035 52.1229 76.7 51.5193 76.7 50.7758V40.5502C76.7 39.8067 77.3035 39.2031 78.047 39.2031H97.7635C98.507 39.2031 99.1106 39.8067 99.1106 40.5502V50.7758C99.1106 51.5193 98.507 52.1229 97.7635 52.1229ZM79.3941 49.42H96.4076V41.8885H79.3941V49.42Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M117.436 52.1229H97.7198C96.9763 52.1229 96.364 51.5193 96.364 50.7758V40.5502C96.364 39.8067 96.9676 39.2031 97.7198 39.2031H117.436C118.18 39.2031 118.783 39.8067 118.783 40.5502V50.7758C118.783 51.5193 118.18 52.1229 117.436 52.1229ZM99.0669 49.42H116.08V41.8885H99.0669V49.42Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M107.595 41.8983H87.8788C87.1353 41.8983 86.5317 41.2947 86.5317 40.5512V30.3256C86.5317 29.582 87.1353 28.9697 87.8788 28.9697H107.595C108.339 28.9697 108.951 29.5733 108.951 30.3256V40.5512C108.951 41.2947 108.348 41.8983 107.595 41.8983ZM89.2259 39.1953H106.239V31.6726H89.2259V39.1953Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M127.268 41.8983H107.552C106.808 41.8983 106.205 41.2947 106.205 40.5512V30.3256C106.205 29.582 106.808 28.9697 107.552 28.9697H127.268C128.012 28.9697 128.615 29.5733 128.615 30.3256V40.5512C128.615 41.2947 128.012 41.8983 127.268 41.8983ZM108.899 39.1953H125.912V31.6726H108.899V39.1953Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M137 69H70V136H137V69Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M103.753 110.322C103.403 110.322 103.062 110.191 102.8 109.928C100.018 107.147 98.2775 103.464 97.8926 99.5541C97.5515 96.0727 98.295 92.5475 99.992 89.5209L94.0351 83.564C92.2419 81.7708 92.2419 78.8492 94.0351 77.0473C94.9098 76.1726 96.0645 75.7002 97.2978 75.7002C98.5312 75.7002 99.6858 76.1813 100.561 77.0473L106.517 83.0042C109.544 81.3072 113.069 80.5637 116.551 80.9048C120.461 81.2897 124.143 83.0304 126.925 85.8121C127.45 86.3369 127.45 87.1942 126.925 87.719L104.724 109.92C104.462 110.182 104.112 110.313 103.771 110.313M97.3066 78.3944C96.7992 78.3944 96.3181 78.5956 95.9595 78.9542C95.216 79.6977 95.216 80.9048 95.9595 81.6484L102.66 88.3488C103.115 88.8037 103.185 89.5034 102.835 90.0458C101.068 92.7574 100.272 96.0377 100.587 99.2829C100.867 102.117 101.995 104.82 103.806 107.007L124.003 86.8093C121.817 84.9986 119.114 83.8702 116.279 83.5903C113.034 83.2666 109.754 84.0714 107.042 85.8383C106.509 86.1882 105.8 86.1182 105.345 85.6634L98.6449 78.9629C98.2863 78.6043 97.8052 78.4031 97.2978 78.4031L97.3066 78.3944Z",
                fill: fifthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M114.853 105.451C112.911 105.451 110.969 104.716 109.491 103.238C108.966 102.713 108.966 101.856 109.491 101.331C110.016 100.806 110.873 100.806 111.407 101.331C113.305 103.229 116.401 103.229 118.308 101.331C120.206 99.4242 120.206 96.3276 118.308 94.4294C117.783 93.9046 117.783 93.0474 118.308 92.5225C118.833 91.9977 119.69 91.9977 120.215 92.5225C123.172 95.4791 123.172 100.29 120.215 103.247C118.737 104.725 116.795 105.46 114.853 105.46",
                fill: fifthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.6851 131.673C96.1953 131.673 95.7229 131.402 95.478 130.938L83.5467 107.496C83.3105 107.032 83.363 106.472 83.6779 106.061L98.4258 86.6946C98.8807 86.0998 99.7292 85.986 100.315 86.4409C100.91 86.8958 101.024 87.7442 100.569 88.3391L86.3283 107.032L97.8748 129.723C98.2159 130.387 97.9447 131.201 97.28 131.542C97.0875 131.647 96.8776 131.691 96.6676 131.691",
                fill: fifthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M139 134H68V205H139V134Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M93.7952 195.571C93.7574 195.571 93.712 195.571 93.6741 195.571C92.7358 195.503 92.0245 194.685 92.0926 193.747L94.8848 154.568C94.9529 153.629 95.7701 152.925 96.7084 152.986C97.6467 153.054 98.3505 153.872 98.2899 154.81L95.4977 193.989C95.4372 194.89 94.6881 195.571 93.8028 195.571",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M113.204 195.571C112.319 195.571 111.57 194.882 111.509 193.989L108.717 154.81C108.649 153.872 109.36 153.054 110.298 152.986C111.237 152.925 112.054 153.629 112.122 154.568L114.914 193.747C114.982 194.685 114.271 195.503 113.333 195.571C113.295 195.571 113.249 195.571 113.212 195.571",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M113.969 155.588H93.0387C92.1004 155.588 91.3362 154.824 91.3362 153.885V149.404C91.3362 148.466 92.1004 147.701 93.0387 147.701H113.969C114.907 147.701 115.671 148.466 115.671 149.404V153.885C115.671 154.824 114.907 155.588 113.969 155.588ZM94.7413 152.182H112.266V151.107H94.7413V152.182Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M111.298 180.475H95.6947C94.7564 180.475 93.9922 179.71 93.9922 178.771C93.9922 177.833 94.7564 177.068 95.6947 177.068H111.298C112.236 177.068 113 177.833 113 178.771C113 179.71 112.236 180.475 111.298 180.475Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M111.85 186.064H95.1503C94.212 186.064 93.4478 185.3 93.4478 184.361C93.4478 183.423 94.212 182.658 95.1503 182.658H111.85C112.789 182.658 113.553 183.423 113.553 184.361C113.553 185.3 112.789 186.064 111.85 186.064Z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/House.tsx


var House = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _alt = param.alt, alt = _alt === void 0 ? "Home" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.2188 12C24.0188 12 23.8189 11.9244 23.6664 11.7731L23 11.1126V21.2304C23 22.4818 21.9969 23.5 20.7639 23.5H15.7H9.3H4.23611C3.00314 23.5 2 22.4819 2 21.2304V11.1127L1.33368 11.7732C1.0286 12.0756 0.533924 12.0756 0.228845 11.7732C-0.0762818 11.4708 -0.0762818 10.9805 0.228845 10.6781L9.94507 1.04729C11.3539 -0.349098 13.6462 -0.349098 15.0549 1.04729L24.7712 10.678C25.0763 10.9804 25.0763 11.4707 24.7712 11.7731C24.6187 11.9244 24.4187 12 24.2188 12ZM14.9 21.9212H10.1V15.9038C10.1 15.4267 10.5037 15.0385 11 15.0385H14C14.4963 15.0385 14.9 15.4267 14.9 15.9038V21.9212ZM16.5 21.9212V15.9038C16.5 14.5784 15.3785 13.5 14 13.5H11C9.6215 13.5 8.5 14.5784 8.5 15.9038V21.9212H4.23611C3.86083 21.9212 3.55556 21.6113 3.55556 21.2304V9.57085L11.0499 2.14245C11.8495 1.34988 13.1505 1.34988 13.9501 2.14245L21.4444 9.57077V21.2304C21.4444 21.6113 21.1392 21.9212 20.7639 21.9212H16.5Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/HouseIcon.tsx


var HouseIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.760 */.rS.colors.neutral[760] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de casa" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.49707 9.74491L9.11237 4.07453C9.62325 3.63661 10.3771 3.63661 10.888 4.07453L17.5033 9.74491",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.6697 17.5026V3.74692C16.6697 3.5167 16.4831 3.33008 16.2528 3.33008H13.7518C13.5216 3.33008 13.335 3.5167 13.335 3.74692V5.91949",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.9541 17.5029V12.9177C7.9541 12.4572 8.32735 12.084 8.78778 12.084H11.213C11.6735 12.084 12.0467 12.4572 12.0467 12.9177V17.5029",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.5687 8.82617V17.5017",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5033 17.5028H2.49707",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/IconLeftBottom.tsx


var IconLeftBottom = function(param) {
    var _width = param.width, width = _width === void 0 ? "324" : _width, _height = param.height, height = _height === void 0 ? "326" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.150 */.rS.colors.neutral[150] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.primary.710 */.rS.colors.primary[710] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.primary.705 */.rS.colors.primary[705] : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? themes/* theme.colors.secondary.355 */.rS.colors.secondary[355] : _fifthColor, _sixthColor = param.sixthColor, sixthColor = _sixthColor === void 0 ? themes/* theme.colors.secondary.45 */.rS.colors.secondary[45] : _sixthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 324 326",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M106 2H0V108H106V2Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.5402 72.7001C43.7165 72.7001 44.6714 73.655 44.6714 74.8313L44.6714 86.5114L48.2695 89.3622L53.8328 89.3622L57.4309 86.5114L57.4309 74.8313C57.4309 73.655 58.3858 72.7001 59.5622 72.7001C60.7385 72.7001 61.6934 73.655 61.6934 74.8313L61.6934 87.5493C61.6934 88.1998 61.3889 88.8225 60.8907 89.2239L55.9087 93.1818C55.535 93.4863 55.0645 93.6523 54.5801 93.6523L47.5222 93.6523C47.0378 93.6523 46.5673 93.4863 46.1937 93.1818L41.2116 89.2239C40.6996 88.8225 40.4089 88.1998 40.4089 87.5493L40.4089 74.8313C40.4089 73.655 41.3638 72.7001 42.5402 72.7001Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.5394 80.2864L59.5614 80.2864C60.7377 80.2864 61.6926 81.2413 61.6926 82.4176C61.6926 83.5939 60.7377 84.5488 59.5614 84.5488L42.5394 84.5488C41.3631 84.5488 40.4082 83.5939 40.4082 82.4176C40.4082 81.2413 41.3631 80.2864 42.5394 80.2864Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.0508 12.6023C67.5054 12.6023 80.8877 25.6248 80.8877 41.6227C80.8877 47.5182 79.0748 53.1783 75.6704 58.022C72.6258 62.3259 68.4879 65.7303 63.6443 67.9307L63.6443 72.3177C63.6443 74.8918 61.5131 76.9814 58.8975 76.9814L43.204 76.9814C40.5885 76.9814 38.4572 74.8918 38.4572 72.3177L38.4572 67.9307C33.6136 65.7442 29.4757 62.3398 26.4311 58.022C23.0129 53.1922 21.2 47.5182 21.2 41.6227C21.2 25.6248 34.5823 12.6023 51.0369 12.6023M58.8836 72.7052C59.1327 72.7052 59.3542 72.5253 59.3542 72.3177L59.3542 66.5053C59.3542 65.6334 59.8939 64.8446 60.7104 64.5125C70.37 60.6929 76.6114 51.6975 76.6114 41.6089C76.6114 27.9636 65.1389 16.8647 51.0508 16.8647C36.9626 16.8647 25.4901 27.9636 25.4901 41.6089C25.4901 51.6975 31.7315 60.6791 41.3911 64.5125C42.2076 64.8308 42.7335 65.6196 42.7335 66.5053L42.7335 72.3177C42.7335 72.5253 42.9549 72.7052 43.204 72.7052L58.8975 72.7052L58.8836 72.7052Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214 112H108V218H214V112Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M126.567 186.966H153.146V192.968H126.567V186.966V186.966ZM148.411 194.957H130.24V200.348H148.411V194.957ZM158.808 152.247H163.012V178.174H158.808V152.247ZM195.422 143.025H168.843V137.024H195.422V143.025ZM173.578 135.035H191.749V129.644H173.578V135.035V135.035ZM190.551 145.014H173.555C172.685 149.523 170.899 153.671 166.04 154.756C166.085 160.735 166.119 166.725 166.164 172.704C181.353 170.206 189.297 159.899 190.551 145.014V145.014ZM155.881 175.258V165.233L155.824 157.288C140.636 159.786 132.692 170.093 131.438 184.977H148.434C149.304 180.479 151.067 176.365 155.881 175.246V175.258ZM126.251 184.989H129.11C130.421 168.804 139.292 157.491 155.881 154.937V150.586C155.881 149.874 156.469 149.286 157.18 149.286H164.255C164.967 149.286 165.554 149.874 165.554 150.586V152.485C169.204 151.626 170.504 148.405 171.193 145.014H168.538C167.611 145.014 166.865 144.257 166.865 143.341V136.718C166.865 135.792 167.622 135.046 168.538 135.046H171.792V128.954C171.792 128.355 172.278 127.869 172.877 127.869H192.45C193.049 127.869 193.535 128.355 193.535 128.954V135.046H195.738C196.665 135.046 197.411 135.803 197.411 136.718V143.341C197.411 144.268 196.654 145.014 195.738 145.014H192.879C191.557 161.379 182.505 172.749 165.566 175.145V179.858C165.566 180.57 164.978 181.157 164.266 181.157H157.192C156.48 181.157 155.892 180.57 155.892 179.858V177.665C152.66 178.705 151.451 181.768 150.796 184.989H153.451C154.378 184.989 155.124 185.746 155.124 186.661V193.284C155.124 194.211 154.367 194.957 153.451 194.957H150.197V201.049C150.197 201.648 149.711 202.134 149.112 202.134H129.539C128.94 202.134 128.454 201.648 128.454 201.049V194.957H126.251C125.324 194.957 124.578 194.2 124.578 193.284V186.661C124.578 185.735 125.335 184.989 126.251 184.989V184.989Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M133.585 131.54C122.657 146.955 126.759 154.437 133.72 154.437C140.682 154.437 144.58 146.65 133.585 131.54M135.189 130.375C138.263 134.602 141.54 140.095 142.275 145.362C142.761 148.843 142.094 152.516 139.133 154.742C137.563 155.918 135.653 156.426 133.709 156.426C131.765 156.426 129.675 155.895 128.047 154.641C120.521 148.82 128.002 135.981 131.957 130.398L133.562 128.138L135.189 130.375V130.375Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M134.07 149.974C135.449 149.476 136.206 148.595 136.59 147.193C137.02 145.645 139.189 146.244 138.76 147.792C138.172 149.906 136.895 151.341 134.827 152.087C133.313 152.641 132.545 150.516 134.059 149.974",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M106 218H0V324H106V218Z",
                fill: fifthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M61.4331 265.688H47.1424V273.181H61.4331V265.688ZM70.7871 297.895V265.688H64.2461V297.895H70.7871ZM73.6 275.859V297.895H85.1682V275.859H73.6ZM73.6 265.677V273.169H88.0941V265.677H73.6ZM80.0054 262.987H79.3502C80.7736 262.411 81.6096 261.36 81.892 260.479C81.9937 260.14 82.0276 259.823 81.9711 259.563C81.9259 259.371 81.8356 259.19 81.6661 259.066C81.2481 258.738 80.4573 258.58 79.192 258.727C75.769 259.134 72.8883 261.371 71.205 262.987H80.0167H80.0054ZM51.6612 262.987C51.2771 262.445 50.9721 261.857 50.7913 261.27C50.5541 260.513 50.4976 259.733 50.6444 259.01C50.8139 258.218 51.2206 257.507 51.8984 256.953C52.8474 256.196 54.3047 255.8 56.3495 256.049C62.3595 256.772 66.8557 261.982 67.6013 262.897C68.3469 261.982 72.8431 256.772 78.8531 256.049C80.9092 255.8 82.3665 256.196 83.3042 256.953C83.9933 257.495 84.4 258.207 84.5581 259.01C84.705 259.733 84.6485 260.513 84.4113 261.27C84.2305 261.857 83.9368 262.434 83.5414 262.987H89.2012C89.6305 262.987 90.0146 263.157 90.2857 263.439C90.5681 263.722 90.7376 264.106 90.7376 264.524V274.311C90.7376 274.729 90.5681 275.113 90.2857 275.395C90.0033 275.678 89.6192 275.847 89.2012 275.847H87.823V298.55C87.823 299.104 87.597 299.601 87.2355 299.963C86.874 300.336 86.3657 300.562 85.8234 300.562H49.3679C48.8143 300.562 48.306 300.336 47.9445 299.974C47.583 299.613 47.357 299.104 47.357 298.55V275.847H45.9788C45.5495 275.847 45.1654 275.678 44.8943 275.395C44.6118 275.113 44.4424 274.729 44.4424 274.311V264.524C44.4424 264.106 44.6118 263.722 44.8943 263.439C45.1767 263.157 45.5608 262.987 45.9788 262.987H51.6386H51.6612ZM64.0427 262.987C62.3595 261.371 59.4787 259.134 56.0557 258.727C54.7905 258.58 53.9997 258.727 53.5817 259.066C53.4122 259.202 53.3218 259.371 53.2767 259.563C53.2202 259.823 53.2541 260.14 53.3557 260.479C53.6269 261.36 54.8018 262.501 55.8072 262.987H64.054H64.0427ZM50.0683 297.884H61.4444V275.847H50.0683V297.884Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.1149 261.338C18.6856 260.931 18.2902 260.501 17.9174 260.049V289.759C17.9174 292.381 18.9906 294.776 20.7191 296.505C22.4475 298.234 24.8425 299.308 27.4634 299.308C30.0843 299.308 32.4793 298.234 34.2077 296.505C35.9362 294.776 37.0094 292.381 37.0094 289.759V260.049C36.6479 260.513 36.2412 260.942 35.8119 261.338C33.6203 263.394 30.6718 264.66 27.4521 264.66C24.2324 264.66 21.2839 263.394 19.0923 261.338M16.5618 251.777H17.8383L17.9174 253.032C18.0756 255.529 19.2053 257.767 20.9224 259.383C22.6283 260.987 24.9216 261.971 27.4408 261.971C29.96 261.971 32.2533 260.987 33.9592 259.383C35.6876 257.767 36.806 255.518 36.9642 253.032L37.0433 251.777H39.6642V289.759C39.6642 293.126 38.2859 296.189 36.0717 298.404C33.8575 300.619 30.796 301.997 27.4295 301.997C24.063 301.997 21.0015 300.619 18.7873 298.404C16.5731 296.189 15.1948 293.126 15.1948 289.759V251.777H16.5392H16.5618Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.2188 245.473C32.4904 243.744 30.1067 242.67 27.4632 242.67C24.8197 242.67 22.436 243.744 20.7076 245.473C18.9791 247.202 17.9059 249.586 17.9059 252.231C17.9059 254.875 18.9791 257.26 20.7076 258.989C22.436 260.718 24.8197 261.791 27.4632 261.791C30.1067 261.791 32.4904 260.718 34.2188 258.989C35.9473 257.26 37.0205 254.875 37.0205 252.231C37.0205 249.586 35.9473 247.202 34.2188 245.473ZM27.4632 239.992C30.841 239.992 33.9025 241.36 36.1167 243.574C38.3309 245.789 39.6979 248.852 39.6979 252.231C39.6979 255.61 38.3309 258.672 36.1167 260.887C33.9025 263.102 30.841 264.469 27.4632 264.469C24.0854 264.469 21.0239 263.102 18.8097 260.887C16.5955 258.672 15.2285 255.61 15.2285 252.231C15.2285 248.852 16.5955 245.789 18.8097 243.574C21.0239 241.36 24.0854 239.992 27.4632 239.992Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.9599 249.744C29.3272 249.111 28.4461 248.716 27.4745 248.716C26.503 248.716 25.6218 249.111 24.9892 249.744C24.3566 250.377 23.9612 251.258 23.9612 252.229C23.9612 253.201 24.3566 254.082 24.9892 254.715C25.6218 255.347 26.503 255.743 27.4745 255.743C28.4461 255.743 29.3272 255.347 29.9599 254.715C30.5925 254.082 30.9879 253.201 30.9879 252.229C30.9879 251.258 30.5925 250.377 29.9599 249.744ZM27.4745 246.027C29.1804 246.027 30.7394 246.716 31.8578 247.846C32.9762 248.965 33.6766 250.512 33.6766 252.229C33.6766 253.947 32.9875 255.494 31.8578 256.613C30.7394 257.731 29.1917 258.431 27.4745 258.431C25.7574 258.431 24.2097 257.742 23.0913 256.613C21.9729 255.494 21.2725 253.947 21.2725 252.229C21.2725 250.512 21.9616 248.965 23.0913 247.846C24.2097 246.728 25.7574 246.027 27.4745 246.027Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.3652 250.887H73.4537C74.2332 250.887 74.9336 251.203 75.442 251.712C75.9504 252.22 76.2667 252.932 76.2667 253.701V254.22C75.3177 254.492 74.4253 254.842 73.578 255.249V253.701C73.578 253.701 73.5667 253.633 73.5328 253.61C73.5102 253.588 73.4763 253.565 73.4424 253.565H39.6982V293.84H45.0191V296.53H37.0095V250.887H38.3539H38.3652Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M61.4331 265.688H47.1424V273.181H61.4331V265.688ZM70.7871 297.895V265.688H64.2461V297.895H70.7871ZM73.6 275.859V297.895H85.1682V275.859H73.6ZM73.6 265.677V273.169H88.0941V265.677H73.6ZM80.0054 262.987H79.3502C80.7736 262.411 81.6096 261.36 81.892 260.479C81.9937 260.14 82.0276 259.823 81.9711 259.563C81.9259 259.371 81.8356 259.19 81.6661 259.066C81.2481 258.738 80.4573 258.58 79.192 258.727C75.769 259.134 72.8883 261.371 71.205 262.987H80.0167H80.0054ZM51.6612 262.987C51.2771 262.445 50.9721 261.857 50.7913 261.27C50.5541 260.513 50.4976 259.733 50.6444 259.01C50.8139 258.218 51.2206 257.507 51.8984 256.953C52.8474 256.196 54.3047 255.8 56.3495 256.049C62.3595 256.772 66.8557 261.982 67.6013 262.897C68.3469 261.982 72.8431 256.772 78.8531 256.049C80.9092 255.8 82.3665 256.196 83.3042 256.953C83.9933 257.495 84.4 258.207 84.5581 259.01C84.705 259.733 84.6485 260.513 84.4113 261.27C84.2305 261.857 83.9368 262.434 83.5414 262.987H89.2012C89.6305 262.987 90.0146 263.157 90.2857 263.439C90.5681 263.722 90.7376 264.106 90.7376 264.524V274.311C90.7376 274.729 90.5681 275.113 90.2857 275.395C90.0033 275.678 89.6192 275.847 89.2012 275.847H87.823V298.55C87.823 299.104 87.597 299.601 87.2355 299.963C86.874 300.336 86.3657 300.562 85.8234 300.562H49.3679C48.8143 300.562 48.306 300.336 47.9445 299.974C47.583 299.613 47.357 299.104 47.357 298.55V275.847H45.9788C45.5495 275.847 45.1654 275.678 44.8943 275.395C44.6118 275.113 44.4424 274.729 44.4424 274.311V264.524C44.4424 264.106 44.6118 263.722 44.8943 263.439C45.1767 263.157 45.5608 262.987 45.9788 262.987H51.6386H51.6612ZM64.0427 262.987C62.3595 261.371 59.4787 259.134 56.0557 258.727C54.7905 258.58 53.9997 258.727 53.5817 259.066C53.4122 259.202 53.3218 259.371 53.2767 259.563C53.2202 259.823 53.2541 260.14 53.3557 260.479C53.6269 261.36 54.8018 262.501 55.8072 262.987H64.054H64.0427ZM50.0683 297.884H61.4444V275.847H50.0683V297.884Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M61.4331 265.688H47.1424V273.181H61.4331V265.688ZM70.7871 297.895V265.688H64.2461V297.895H70.7871ZM73.6 275.859V297.895H85.1682V275.859H73.6ZM73.6 265.677V273.169H88.0941V265.677H73.6ZM80.0054 262.987H79.3502C80.7736 262.411 81.6096 261.36 81.892 260.479C81.9937 260.14 82.0276 259.823 81.9711 259.563C81.9259 259.371 81.8356 259.19 81.6661 259.066C81.2481 258.738 80.4573 258.58 79.192 258.727C75.769 259.134 72.8883 261.371 71.205 262.987H80.0167H80.0054ZM51.6612 262.987C51.2771 262.445 50.9721 261.857 50.7913 261.27C50.5541 260.513 50.4976 259.733 50.6444 259.01C50.8139 258.218 51.2206 257.507 51.8984 256.953C52.8474 256.196 54.3047 255.8 56.3495 256.049C62.3595 256.772 66.8557 261.982 67.6013 262.897C68.3469 261.982 72.8431 256.772 78.8531 256.049C80.9092 255.8 82.3665 256.196 83.3042 256.953C83.9933 257.495 84.4 258.207 84.5581 259.01C84.705 259.733 84.6485 260.513 84.4113 261.27C84.2305 261.857 83.9368 262.434 83.5414 262.987H89.2012C89.6305 262.987 90.0146 263.157 90.2857 263.439C90.5681 263.722 90.7376 264.106 90.7376 264.524V274.311C90.7376 274.729 90.5681 275.113 90.2857 275.395C90.0033 275.678 89.6192 275.847 89.2012 275.847H87.823V298.55C87.823 299.104 87.597 299.601 87.2355 299.963C86.874 300.336 86.3657 300.562 85.8234 300.562H49.3679C48.8143 300.562 48.306 300.336 47.9445 299.974C47.583 299.613 47.357 299.104 47.357 298.55V275.847H45.9788C45.5495 275.847 45.1654 275.678 44.8943 275.395C44.6118 275.113 44.4424 274.729 44.4424 274.311V264.524C44.4424 264.106 44.6118 263.722 44.8943 263.439C45.1767 263.157 45.5608 262.987 45.9788 262.987H51.6386H51.6612ZM64.0427 262.987C62.3595 261.371 59.4787 259.134 56.0557 258.727C54.7905 258.58 53.9997 258.727 53.5817 259.066C53.4122 259.202 53.3218 259.371 53.2767 259.563C53.2202 259.823 53.2541 260.14 53.3557 260.479C53.6269 261.36 54.8018 262.501 55.8072 262.987H64.054H64.0427ZM50.0683 297.884H61.4444V275.847H50.0683V297.884Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M322 218H216V324H322V218Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M286.889 277.028H255.02C254.06 277.028 253.28 276.246 253.28 275.282C253.28 274.318 254.06 273.536 255.02 273.536H286.889C287.996 273.536 289.035 273.105 289.815 272.323L296.028 266.087C296.808 265.305 297.237 264.261 297.237 263.15V252.787C297.237 252.073 296.661 251.495 295.949 251.495L247.18 251.325C246.22 251.325 245.44 250.531 245.452 249.579C245.452 248.615 246.231 247.833 247.203 247.844L295.961 248.014C298.581 248.014 300.717 250.157 300.717 252.799V263.162C300.717 265.203 299.926 267.13 298.491 268.57L292.278 274.806C290.843 276.246 288.922 277.04 286.889 277.04",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M291.091 301.844C287.872 301.844 285.251 299.293 285.251 296.153C285.251 293.012 287.872 290.461 291.091 290.461C294.311 290.461 296.943 293.012 296.943 296.153C296.943 299.293 294.322 301.844 291.091 301.844ZM291.091 293.953C289.781 293.953 288.719 294.939 288.719 296.153C288.719 297.366 289.781 298.352 291.091 298.352C292.402 298.352 293.464 297.366 293.464 296.153C293.464 294.939 292.402 293.953 291.091 293.953Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M253.845 301.844C250.625 301.844 248.004 299.293 248.004 296.153C248.004 293.012 250.625 290.461 253.845 290.461C257.065 290.461 259.697 293.012 259.697 296.153C259.697 299.293 257.076 301.844 253.845 301.844ZM253.845 293.953C252.535 293.953 251.473 294.939 251.473 296.153C251.473 297.366 252.535 298.352 253.845 298.352C255.155 298.352 256.217 297.366 256.217 296.153C256.217 294.939 255.155 293.953 253.845 293.953Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M293.95 289.796H252.953C252.445 289.796 251.959 289.569 251.631 289.183C251.304 288.798 251.157 288.276 251.236 287.778L253.292 275.011C253.45 274.058 254.343 273.412 255.28 273.571C256.229 273.73 256.873 274.625 256.715 275.578L254.986 286.326H293.939C294.899 286.326 295.678 287.109 295.678 288.072C295.678 289.036 294.899 289.818 293.939 289.818",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M255.009 277.024C254.263 277.024 253.574 276.537 253.348 275.789L243.565 243.634H238.64C237.679 243.634 236.9 242.851 236.9 241.888C236.9 240.924 237.679 240.142 238.64 240.142H244.853C245.621 240.142 246.288 240.64 246.514 241.377L256.67 274.768C256.952 275.687 256.432 276.662 255.517 276.945C255.348 277.002 255.178 277.024 255.009 277.024Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M280.235 260.742C279.241 262.341 277.49 263.044 276.338 262.318C275.174 261.592 275.05 259.699 276.044 258.1C277.038 256.501 278.789 255.787 279.941 256.524C281.105 257.25 281.229 259.143 280.235 260.731",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M274.891 257.649C274.519 259.497 273.14 260.778 271.796 260.506C270.452 260.234 269.672 258.522 270.034 256.674C270.406 254.826 271.785 253.545 273.129 253.817C274.473 254.089 275.253 255.801 274.891 257.66",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M268.452 259.712C268.508 261.129 267.729 262.32 266.701 262.365C265.673 262.41 264.792 261.299 264.735 259.882C264.667 258.465 265.458 257.274 266.486 257.229C267.514 257.184 268.395 258.295 268.463 259.712",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M279.422 263.986C278.349 264.904 278.021 266.299 278.687 267.081C279.354 267.863 280.766 267.75 281.851 266.831C282.924 265.913 283.251 264.518 282.585 263.736C281.918 262.954 280.506 263.067 279.422 263.986Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M266 265.359C263.944 267.604 268.768 267.955 270.994 268.84C273.038 269.656 276.879 272.808 277.004 269.758C277.139 266.323 276.574 263.647 273.547 262.422C270.508 261.209 268.508 262.615 266.012 265.348",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/IconLeftBottomMobile.tsx


var IconLeftBottomMobile = function(param) {
    var _width = param.width, width = _width === void 0 ? "201" : _width, _height = param.height, height = _height === void 0 ? "201" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.150 */.rS.colors.neutral[150] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.primary.710 */.rS.colors.primary[710] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.primary.705 */.rS.colors.primary[705] : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? themes/* theme.colors.secondary.355 */.rS.colors.secondary[355] : _fifthColor, _sixthColor = param.sixthColor, sixthColor = _sixthColor === void 0 ? themes/* theme.colors.secondary.45 */.rS.colors.secondary[45] : _sixthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 201 201",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M66 2H-1V69H66V2Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.8881 46.6897C26.6316 46.6897 27.2352 47.2932 27.2352 48.0368L27.2352 55.4195L29.5095 57.2214L33.0259 57.2214L35.3002 55.4195L35.3002 48.0368C35.3002 47.2932 35.9038 46.6897 36.6473 46.6897C37.3908 46.6897 37.9944 47.2932 37.9944 48.0368L37.9944 56.0755C37.9944 56.4867 37.8019 56.8803 37.487 57.134L34.338 59.6357C34.1018 59.8281 33.8044 59.9331 33.4983 59.9331L29.0371 59.9331C28.731 59.9331 28.4336 59.8281 28.1974 59.6357L25.0484 57.134C24.7247 56.8803 24.541 56.4867 24.541 56.0755L24.541 48.0368C24.541 47.2932 25.1446 46.6897 25.8881 46.6897Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.8881 51.4828L36.6473 51.4828C37.3908 51.4828 37.9944 52.0864 37.9944 52.8299C37.9944 53.5734 37.3908 54.177 36.6473 54.177L25.8881 54.177C25.1446 54.177 24.541 53.5734 24.541 52.8299C24.541 52.0864 25.1446 51.4828 25.8881 51.4828Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.2675 8.69986C41.6681 8.69986 50.1267 16.9311 50.1267 27.043C50.1267 30.7693 48.9808 34.347 46.829 37.4085C44.9046 40.1289 42.2891 42.2808 39.2276 43.6716L39.2276 46.4445C39.2276 48.0715 37.8805 49.3923 36.2272 49.3923L26.3078 49.3923C24.6546 49.3923 23.3075 48.0715 23.3075 46.4445L23.3075 43.6716C20.2459 42.2895 17.6305 40.1377 15.7061 37.4085C13.5455 34.3557 12.3996 30.7693 12.3996 27.043C12.3996 16.9311 20.8582 8.69986 31.2588 8.69986M36.2185 46.6894C36.3759 46.6894 36.5159 46.5757 36.5159 46.4445L36.5159 42.7706C36.5159 42.2195 36.857 41.7209 37.3731 41.511C43.4788 39.0968 47.4238 33.411 47.4238 27.0342C47.4238 18.4094 40.1723 11.394 31.2675 11.394C22.3628 11.394 15.1112 18.4094 15.1112 27.0342C15.1112 33.411 19.0563 39.088 25.1619 41.511C25.678 41.7122 26.0104 42.2108 26.0104 42.7706L26.0104 46.4445C26.0104 46.5757 26.1503 46.6894 26.3078 46.6894L36.2272 46.6894L36.2185 46.6894Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M132 69H65V136H132V69Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M76.7357 116.384H93.5357V120.177H76.7357V116.384ZM90.5428 121.434H79.0571V124.842H90.5428V121.434ZM97.1142 94.4383H99.7714V110.826H97.1142V94.4383ZM120.257 88.6091H103.457V84.8159H120.257V88.6091ZM106.45 83.5586H117.936V80.1511H106.45V83.5586ZM117.179 89.8664H106.436C105.886 92.7167 104.757 95.3384 101.686 96.0242C101.714 99.8032 101.736 103.589 101.764 107.368C111.364 105.79 116.386 99.2746 117.179 89.8664ZM95.2642 108.983V102.646L95.2285 97.6244C85.6285 99.2031 80.6071 105.718 79.8142 115.126H90.5571C91.1071 112.283 92.2214 109.683 95.2642 108.976V108.983ZM76.5357 115.133H78.3428C79.1714 104.904 84.7785 97.753 95.2642 96.1385V93.3882C95.2642 92.9382 95.6357 92.5667 96.0857 92.5667H100.557C101.007 92.5667 101.379 92.9382 101.379 93.3882V94.5883C103.686 94.0454 104.507 92.0095 104.943 89.8664H103.264C102.679 89.8664 102.207 89.3878 102.207 88.8092V84.623C102.207 84.0372 102.686 83.5657 103.264 83.5657H105.321V79.7153C105.321 79.3367 105.629 79.0295 106.007 79.0295H118.379C118.757 79.0295 119.064 79.3367 119.064 79.7153V83.5657H120.457C121.043 83.5657 121.514 84.0444 121.514 84.623V88.8092C121.514 89.3949 121.036 89.8664 120.457 89.8664H118.65C117.814 100.21 112.093 107.397 101.386 108.911V111.89C101.386 112.34 101.014 112.712 100.564 112.712H96.0928C95.6428 112.712 95.2714 112.34 95.2714 111.89V110.504C93.2285 111.162 92.4642 113.097 92.0499 115.133H93.7285C94.3142 115.133 94.7857 115.612 94.7857 116.191V120.377C94.7857 120.963 94.3071 121.434 93.7285 121.434H91.6714V125.284C91.6714 125.663 91.3642 125.97 90.9857 125.97H78.6142C78.2357 125.97 77.9285 125.663 77.9285 125.284V121.434H76.5357C75.9499 121.434 75.4785 120.955 75.4785 120.377V116.191C75.4785 115.605 75.9571 115.133 76.5357 115.133Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M81.1715 81.3516C74.2643 91.0955 76.8572 95.8246 81.2572 95.8246C85.6572 95.8246 88.1215 90.9027 81.1715 81.3516ZM82.1857 80.6159C84.1286 83.2876 86.2 86.7594 86.6643 90.0883C86.9714 92.2885 86.55 94.6102 84.6786 96.0175C83.6857 96.7604 82.4786 97.0819 81.25 97.0819C80.0214 97.0819 78.7 96.7461 77.6714 95.9532C72.9143 92.2742 77.6429 84.1591 80.1429 80.6301L81.1572 79.2014L82.1857 80.6159Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M81.4782 93.0024C82.3496 92.6881 82.8282 92.1309 83.0711 91.2451C83.3425 90.2664 84.7139 90.645 84.4425 91.6237C84.0711 92.9596 83.2639 93.8668 81.9568 94.3383C80.9996 94.6883 80.5139 93.3453 81.4711 93.0024",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M66 136H-1V203H66V136Z",
                fill: fifthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.83 166.143H28.7972V170.878H37.83V166.143ZM43.7424 186.5V166.143H39.608V186.5H43.7424ZM45.5204 172.571V186.5H52.8323V172.571H45.5204ZM45.5204 166.136V170.871H54.6818V166.136H45.5204ZM49.5691 164.436H49.155C50.0547 164.071 50.5831 163.407 50.7616 162.85C50.8258 162.636 50.8473 162.436 50.8116 162.271C50.783 162.15 50.7259 162.036 50.6188 161.957C50.3546 161.75 49.8547 161.65 49.055 161.743C46.8914 162 45.0705 163.414 44.0066 164.436H49.5762H49.5691ZM31.6534 164.436C31.4106 164.093 31.2178 163.721 31.1036 163.35C30.9536 162.871 30.9179 162.378 31.0108 161.921C31.1179 161.421 31.3749 160.971 31.8034 160.621C32.4032 160.143 33.3243 159.893 34.6167 160.05C38.4155 160.507 41.2575 163.8 41.7288 164.378C42.2 163.8 45.042 160.507 48.8408 160.05C50.1404 159.893 51.0615 160.143 51.6542 160.621C52.0897 160.964 52.3468 161.414 52.4468 161.921C52.5396 162.378 52.5039 162.871 52.3539 163.35C52.2397 163.721 52.054 164.086 51.8041 164.436H55.3815C55.6529 164.436 55.8957 164.543 56.067 164.721C56.2455 164.9 56.3527 165.143 56.3527 165.407V171.593C56.3527 171.857 56.2455 172.1 56.067 172.278C55.8885 172.457 55.6457 172.564 55.3815 172.564H54.5104V186.914C54.5104 187.264 54.3676 187.578 54.1391 187.807C53.9106 188.043 53.5892 188.186 53.2465 188.186H30.2039C29.854 188.186 29.5327 188.043 29.3042 187.814C29.0757 187.586 28.9328 187.264 28.9328 186.914V172.564H28.0617C27.7904 172.564 27.5476 172.457 27.3762 172.278C27.1977 172.1 27.0906 171.857 27.0906 171.593V165.407C27.0906 165.143 27.1977 164.9 27.3762 164.721C27.5547 164.543 27.7975 164.436 28.0617 164.436H31.6391H31.6534ZM39.4795 164.436C38.4155 163.414 36.5947 162 34.4311 161.743C33.6313 161.65 33.1315 161.743 32.8673 161.957C32.7602 162.043 32.7031 162.15 32.6745 162.271C32.6388 162.436 32.6602 162.636 32.7245 162.85C32.8959 163.407 33.6385 164.128 34.274 164.436H39.4866H39.4795ZM30.6466 186.493H37.8371V172.564H30.6466V186.493Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.082 163.392C10.8107 163.135 10.5608 162.864 10.3251 162.578V181.357C10.3251 183.014 11.0035 184.528 12.096 185.621C13.1885 186.714 14.7023 187.392 16.3589 187.392C18.0155 187.392 19.5293 186.714 20.6218 185.621C21.7143 184.528 22.3927 183.014 22.3927 181.357V162.578C22.1642 162.871 21.9071 163.142 21.6358 163.392C20.2505 164.692 18.3868 165.492 16.3518 165.492C14.3167 165.492 12.453 164.692 11.0677 163.392M9.46826 157.35H10.2751L10.3251 158.142C10.4251 159.721 11.1392 161.135 12.2245 162.157C13.3027 163.171 14.7523 163.792 16.3446 163.792C17.937 163.792 19.3865 163.171 20.4647 162.157C21.5573 161.135 22.2642 159.714 22.3641 158.142L22.4141 157.35H24.0707V181.357C24.0707 183.485 23.1996 185.421 21.8 186.821C20.4005 188.221 18.4654 189.092 16.3375 189.092C14.2096 189.092 12.2745 188.221 10.875 186.821C9.4754 185.421 8.60425 183.485 8.60425 181.357V157.35H9.45398H9.46826Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.6288 153.364C19.5363 152.271 18.0296 151.593 16.3587 151.593C14.6878 151.593 13.1812 152.271 12.0887 153.364C10.9962 154.457 10.3178 155.964 10.3178 157.635C10.3178 159.307 10.9962 160.814 12.0887 161.907C13.1812 163 14.6878 163.678 16.3587 163.678C18.0296 163.678 19.5363 163 20.6288 161.907C21.7213 160.814 22.3997 159.307 22.3997 157.635C22.3997 155.964 21.7213 154.457 20.6288 153.364ZM16.3587 149.9C18.4938 149.9 20.4289 150.764 21.8284 152.164C23.228 153.564 24.092 155.5 24.092 157.635C24.092 159.771 23.228 161.707 21.8284 163.107C20.4289 164.507 18.4938 165.371 16.3587 165.371C14.2237 165.371 12.2886 164.507 10.8891 163.107C9.4895 161.707 8.62549 159.771 8.62549 157.635C8.62549 155.5 9.4895 153.564 10.8891 152.164C12.2886 150.764 14.2237 149.9 16.3587 149.9Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.9369 156.064C17.537 155.664 16.9801 155.414 16.366 155.414C15.7519 155.414 15.1949 155.664 14.7951 156.064C14.3952 156.463 14.1453 157.02 14.1453 157.635C14.1453 158.249 14.3952 158.806 14.7951 159.205C15.1949 159.605 15.7519 159.855 16.366 159.855C16.9801 159.855 17.537 159.605 17.9369 159.205C18.3368 158.806 18.5867 158.249 18.5867 157.635C18.5867 157.02 18.3368 156.463 17.9369 156.064ZM16.366 153.714C17.4442 153.714 18.4296 154.15 19.1365 154.864C19.8434 155.571 20.2862 156.549 20.2862 157.635C20.2862 158.72 19.8506 159.698 19.1365 160.405C18.4296 161.112 17.4513 161.555 16.366 161.555C15.2806 161.555 14.3024 161.119 13.5954 160.405C12.8885 159.698 12.4458 158.72 12.4458 157.635C12.4458 156.549 12.8814 155.571 13.5954 154.864C14.3024 154.157 15.2806 153.714 16.366 153.714Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.2497 156.785H45.4283C45.921 156.785 46.3637 156.985 46.6851 157.307C47.0064 157.628 47.2063 158.078 47.2063 158.564V158.893C46.6065 159.064 46.0424 159.285 45.5069 159.543V158.564C45.5069 158.564 45.4997 158.521 45.4783 158.507C45.464 158.493 45.4426 158.478 45.4212 158.478H24.0923V183.935H27.4555V185.635H22.3928V156.785H23.2425H23.2497Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.83 166.143H28.7972V170.878H37.83V166.143ZM43.7424 186.5V166.143H39.608V186.5H43.7424ZM45.5204 172.571V186.5H52.8323V172.571H45.5204ZM45.5204 166.136V170.871H54.6818V166.136H45.5204ZM49.5691 164.436H49.155C50.0547 164.071 50.5831 163.407 50.7616 162.85C50.8258 162.636 50.8473 162.436 50.8116 162.271C50.783 162.15 50.7259 162.036 50.6188 161.957C50.3546 161.75 49.8547 161.65 49.055 161.743C46.8914 162 45.0705 163.414 44.0066 164.436H49.5762H49.5691ZM31.6534 164.436C31.4106 164.093 31.2178 163.721 31.1036 163.35C30.9536 162.871 30.9179 162.378 31.0108 161.921C31.1179 161.421 31.3749 160.971 31.8034 160.621C32.4032 160.143 33.3243 159.893 34.6167 160.05C38.4155 160.507 41.2575 163.8 41.7288 164.378C42.2 163.8 45.042 160.507 48.8408 160.05C50.1404 159.893 51.0615 160.143 51.6542 160.621C52.0897 160.964 52.3468 161.414 52.4468 161.921C52.5396 162.378 52.5039 162.871 52.3539 163.35C52.2397 163.721 52.054 164.086 51.8041 164.436H55.3815C55.6529 164.436 55.8957 164.543 56.067 164.721C56.2455 164.9 56.3527 165.143 56.3527 165.407V171.593C56.3527 171.857 56.2455 172.1 56.067 172.278C55.8885 172.457 55.6457 172.564 55.3815 172.564H54.5104V186.914C54.5104 187.264 54.3676 187.578 54.1391 187.807C53.9106 188.043 53.5892 188.186 53.2465 188.186H30.2039C29.854 188.186 29.5327 188.043 29.3042 187.814C29.0757 187.586 28.9328 187.264 28.9328 186.914V172.564H28.0617C27.7904 172.564 27.5476 172.457 27.3762 172.278C27.1977 172.1 27.0906 171.857 27.0906 171.593V165.407C27.0906 165.143 27.1977 164.9 27.3762 164.721C27.5547 164.543 27.7975 164.436 28.0617 164.436H31.6391H31.6534ZM39.4795 164.436C38.4155 163.414 36.5947 162 34.4311 161.743C33.6313 161.65 33.1315 161.743 32.8673 161.957C32.7602 162.043 32.7031 162.15 32.6745 162.271C32.6388 162.436 32.6602 162.636 32.7245 162.85C32.8959 163.407 33.6385 164.128 34.274 164.436H39.4866H39.4795ZM30.6466 186.493H37.8371V172.564H30.6466V186.493Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.83 166.143H28.7972V170.878H37.83V166.143ZM43.7424 186.5V166.143H39.608V186.5H43.7424ZM45.5204 172.571V186.5H52.8323V172.571H45.5204ZM45.5204 166.136V170.871H54.6818V166.136H45.5204ZM49.5691 164.436H49.155C50.0547 164.071 50.5831 163.407 50.7616 162.85C50.8258 162.636 50.8473 162.436 50.8116 162.271C50.783 162.15 50.7259 162.036 50.6188 161.957C50.3546 161.75 49.8547 161.65 49.055 161.743C46.8914 162 45.0705 163.414 44.0066 164.436H49.5762H49.5691ZM31.6534 164.436C31.4106 164.093 31.2178 163.721 31.1036 163.35C30.9536 162.871 30.9179 162.378 31.0108 161.921C31.1179 161.421 31.3749 160.971 31.8034 160.621C32.4032 160.143 33.3243 159.893 34.6167 160.05C38.4155 160.507 41.2575 163.8 41.7288 164.378C42.2 163.8 45.042 160.507 48.8408 160.05C50.1404 159.893 51.0615 160.143 51.6542 160.621C52.0897 160.964 52.3468 161.414 52.4468 161.921C52.5396 162.378 52.5039 162.871 52.3539 163.35C52.2397 163.721 52.054 164.086 51.8041 164.436H55.3815C55.6529 164.436 55.8957 164.543 56.067 164.721C56.2455 164.9 56.3527 165.143 56.3527 165.407V171.593C56.3527 171.857 56.2455 172.1 56.067 172.278C55.8885 172.457 55.6457 172.564 55.3815 172.564H54.5104V186.914C54.5104 187.264 54.3676 187.578 54.1391 187.807C53.9106 188.043 53.5892 188.186 53.2465 188.186H30.2039C29.854 188.186 29.5327 188.043 29.3042 187.814C29.0757 187.586 28.9328 187.264 28.9328 186.914V172.564H28.0617C27.7904 172.564 27.5476 172.457 27.3762 172.278C27.1977 172.1 27.0906 171.857 27.0906 171.593V165.407C27.0906 165.143 27.1977 164.9 27.3762 164.721C27.5547 164.543 27.7975 164.436 28.0617 164.436H31.6391H31.6534ZM39.4795 164.436C38.4155 163.414 36.5947 162 34.4311 161.743C33.6313 161.65 33.1315 161.743 32.8673 161.957C32.7602 162.043 32.7031 162.15 32.6745 162.271C32.6388 162.436 32.6602 162.636 32.7245 162.85C32.8959 163.407 33.6385 164.128 34.274 164.436H39.4866H39.4795ZM30.6466 186.493H37.8371V172.564H30.6466V186.493Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M199 136H132V203H199V136Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M176.807 173.309H156.664C156.057 173.309 155.564 172.815 155.564 172.206C155.564 171.596 156.057 171.102 156.664 171.102H176.807C177.507 171.102 178.164 170.83 178.657 170.335L182.584 166.394C183.077 165.899 183.348 165.24 183.348 164.537V157.987C183.348 157.536 182.984 157.17 182.534 157.17L151.708 157.063C151.101 157.063 150.608 156.561 150.616 155.959C150.616 155.35 151.108 154.855 151.722 154.863L182.541 154.97C184.198 154.97 185.547 156.325 185.547 157.994V164.545C185.547 165.835 185.047 167.053 184.141 167.963L180.213 171.905C179.306 172.815 178.092 173.316 176.807 173.316",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M179.463 188.997C177.428 188.997 175.772 187.384 175.772 185.399C175.772 183.414 177.428 181.802 179.463 181.802C181.498 181.802 183.162 183.414 183.162 185.399C183.162 187.384 181.506 188.997 179.463 188.997ZM179.463 184.009C178.635 184.009 177.964 184.632 177.964 185.399C177.964 186.166 178.635 186.789 179.463 186.789C180.292 186.789 180.963 186.166 180.963 185.399C180.963 184.632 180.292 184.009 179.463 184.009Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M155.921 188.997C153.886 188.997 152.229 187.384 152.229 185.399C152.229 183.414 153.886 181.802 155.921 181.802C157.956 181.802 159.62 183.414 159.62 185.399C159.62 187.384 157.963 188.997 155.921 188.997ZM155.921 184.009C155.093 184.009 154.421 184.632 154.421 185.399C154.421 186.166 155.093 186.789 155.921 186.789C156.749 186.789 157.42 186.166 157.42 185.399C157.42 184.632 156.749 184.009 155.921 184.009Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M181.27 181.378H155.357C155.036 181.378 154.729 181.235 154.522 180.991C154.314 180.748 154.222 180.418 154.272 180.103L155.571 172.033C155.671 171.431 156.235 171.023 156.828 171.123C157.428 171.223 157.835 171.79 157.735 172.392L156.642 179.185H181.263C181.87 179.185 182.363 179.68 182.363 180.289C182.363 180.898 181.87 181.393 181.263 181.393",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M156.657 173.309C156.185 173.309 155.75 173.001 155.607 172.528L149.423 152.204H146.31C145.703 152.204 145.21 151.709 145.21 151.1C145.21 150.491 145.703 149.996 146.31 149.996H150.237C150.723 149.996 151.144 150.312 151.287 150.777L157.706 171.883C157.885 172.463 157.556 173.08 156.978 173.259C156.871 173.295 156.764 173.309 156.657 173.309Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M172.601 163.018C171.973 164.028 170.866 164.472 170.138 164.014C169.402 163.555 169.324 162.358 169.952 161.348C170.581 160.337 171.687 159.886 172.416 160.352C173.151 160.81 173.23 162.007 172.601 163.011",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M169.224 161.062C168.989 162.23 168.117 163.04 167.268 162.868C166.418 162.696 165.925 161.614 166.154 160.446C166.389 159.278 167.261 158.468 168.11 158.64C168.96 158.812 169.453 159.894 169.224 161.069",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M165.154 162.366C165.189 163.262 164.697 164.014 164.047 164.043C163.397 164.071 162.84 163.369 162.804 162.473C162.761 161.577 163.261 160.825 163.911 160.796C164.561 160.768 165.118 161.47 165.161 162.366",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M172.087 165.068C171.409 165.648 171.202 166.53 171.623 167.024C172.044 167.519 172.937 167.447 173.623 166.867C174.301 166.286 174.508 165.405 174.087 164.91C173.665 164.416 172.773 164.487 172.087 165.068Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M163.605 165.935C162.305 167.354 165.354 167.576 166.761 168.135C168.053 168.651 170.481 170.643 170.559 168.715C170.645 166.544 170.288 164.853 168.374 164.079C166.454 163.312 165.19 164.2 163.612 165.928",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/IconRightTop.tsx


var IconRightTop = function(param) {
    var _width = param.width, width = _width === void 0 ? "211" : _width, _height = param.height, height = _height === void 0 ? "322" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.355 */.rS.colors.secondary[355] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.secondary.45 */.rS.colors.secondary[45] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.neutral.150 */.rS.colors.neutral[150] : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? themes/* theme.colors.primary.710 */.rS.colors.primary[710] : _fifthColor, _sixthColor = param.sixthColor, sixthColor = _sixthColor === void 0 ? themes/* theme.colors.primary.705 */.rS.colors.primary[705] : _sixthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 211 322",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M108 108H2V214H108V108Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.8111 142.428C34.2714 142.428 33.7178 142.221 33.3027 141.805C28.9434 137.446 28.9434 130.333 33.3027 125.974C37.6758 121.614 44.7752 121.614 49.1345 125.974L58.4759 135.315C59.3062 136.145 59.3062 137.501 58.4759 138.332C57.6455 139.162 56.2893 139.162 55.459 138.332L46.1176 128.99C43.419 126.292 39.032 126.292 36.3334 128.99C33.6348 131.689 33.6348 136.076 36.3334 138.775C37.1638 139.605 37.1638 140.961 36.3334 141.792C35.9182 142.207 35.3647 142.414 34.825 142.414",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.023 192.902C52.4695 192.902 51.9297 192.694 51.5146 192.279L20.0446 160.809C19.2143 159.979 19.2143 158.622 20.0446 157.792L56.8703 120.967C57.7006 120.136 59.0568 120.136 59.8872 120.967L91.3571 152.436C92.1875 153.267 92.1875 154.623 91.3571 155.453L54.5315 192.279C54.1163 192.694 53.5627 192.902 53.023 192.902ZM24.57 159.287L53.023 187.74L86.8318 153.931L58.3787 125.478L24.57 159.287Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56.9541 142.43C53.8265 142.43 51.2939 139.883 51.2939 136.77C51.2939 133.656 53.8403 131.109 56.9541 131.109C60.0679 131.109 62.6143 133.656 62.6143 136.77C62.6143 139.883 60.0679 142.43 56.9541 142.43ZM56.9541 135.372C56.193 135.372 55.5564 135.995 55.5564 136.77C55.5564 137.545 56.1791 138.167 56.9541 138.167C57.7291 138.167 58.3518 137.545 58.3518 136.77C58.3518 135.995 57.7291 135.372 56.9541 135.372Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M88.8246 191.325C85.6001 191.325 83.8425 189.706 82.9292 188.35C80.7011 185.015 80.7288 179.147 83.026 170.415C84.6314 164.325 86.7487 159.15 86.8456 158.928C87.1778 158.125 87.9527 157.6 88.8246 157.6C89.6965 157.6 90.4714 158.125 90.8036 158.928C90.8866 159.15 93.0178 164.325 94.6231 170.415C96.9204 179.147 96.9481 185.015 94.72 188.35C93.8066 189.706 92.0491 191.325 88.8246 191.325ZM88.8246 165.986C88.271 167.647 87.6759 169.557 87.1501 171.563C86.2782 174.898 84.4653 182.967 86.4858 185.983C86.8179 186.482 87.3853 187.063 88.8246 187.063C90.2639 187.063 90.8312 186.495 91.1634 185.983C91.8415 184.973 93.1285 181.555 90.4991 171.563C89.9732 169.57 89.3782 167.647 88.8246 165.986Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.6486 145.279C37.095 145.279 36.5553 145.072 36.1401 144.656L33.2893 141.819C32.4589 140.989 32.4589 139.633 33.2893 138.802C34.1196 137.972 35.4758 137.972 36.3062 138.802L39.157 141.653C39.9873 142.484 39.9873 143.84 39.157 144.67C38.7418 145.085 38.1883 145.293 37.6486 145.293",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M54.1858 194.075C53.6323 194.075 53.0925 193.868 52.6774 193.453L18.5227 159.298C17.6923 158.468 17.6923 157.111 18.5227 156.281C19.353 155.451 20.7092 155.451 21.5396 156.281L55.6943 190.436C56.5246 191.266 56.5246 192.622 55.6943 193.453C55.2791 193.868 54.7255 194.075 54.1858 194.075Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M90.7903 157.017C90.2368 157.017 89.697 156.809 89.2819 156.394L55.1272 122.239C54.2968 121.409 54.2968 120.053 55.1272 119.222C55.9575 118.392 57.3137 118.392 58.1441 119.222L92.2988 153.377C93.1291 154.207 93.1291 155.564 92.2988 156.394C91.8836 156.809 91.33 157.017 90.7903 157.017Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M67.9419 176.611C66.4888 176.611 65.1326 176.044 64.1085 175.034L63.209 174.134C61.1055 172.03 61.1055 168.598 63.209 166.481L74.3356 155.354C75.1659 154.524 76.5221 154.524 77.3525 155.354C78.1828 156.185 78.1828 157.541 77.3525 158.371L66.2259 169.498C65.7831 169.941 65.7831 170.674 66.2259 171.103L67.1254 172.003C67.4161 172.293 67.7482 172.335 67.9281 172.335C68.108 172.335 68.454 172.293 68.7308 172.003L88.3268 152.421C89.1572 151.59 90.5134 151.59 91.3576 152.421C92.1879 153.251 92.1879 154.607 91.3576 155.438L71.7615 175.034C70.7374 176.058 69.3812 176.611 67.9281 176.611",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M75.8576 158.996C75.304 158.996 74.7643 158.788 74.3491 158.373C73.5188 157.543 73.5188 156.187 74.3491 155.356C74.6397 155.066 74.6813 154.734 74.6813 154.554C74.6813 154.374 74.6397 154.042 74.3491 153.751L73.4496 152.851C73.159 152.561 72.8268 152.519 72.6469 152.519C72.467 152.519 72.121 152.561 71.8443 152.851C71.0139 153.682 69.6577 153.682 68.8273 152.851C67.997 152.021 67.997 150.665 68.8273 149.834C70.9309 147.731 74.3768 147.731 76.4803 149.834L77.3799 150.734C78.4039 151.758 78.9575 153.114 78.9575 154.567C78.9575 156.021 78.3901 157.377 77.3799 158.401C76.9647 158.816 76.4111 159.024 75.8714 159.024",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M61.9356 160.503C60.5517 160.503 59.1678 159.977 58.1022 158.925L57.2026 158.026C55.0991 155.922 55.0991 152.476 57.2026 150.373L71.6091 135.967C72.4394 135.136 73.7956 135.136 74.626 135.967C75.4563 136.797 75.4563 138.153 74.626 138.983L60.2196 153.39C59.7767 153.833 59.7767 154.566 60.2196 154.995L61.1191 155.895C61.5481 156.338 62.2954 156.338 62.7244 155.895L68.7998 149.819C69.6301 148.989 70.9863 148.989 71.8167 149.819C72.647 150.65 72.647 152.006 71.8167 152.836L65.7413 158.912C64.6896 159.963 63.3057 160.489 61.9079 160.489",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214 2H108V108H214V2Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M151.924 48.9402H120.731C119.555 48.9402 118.6 47.9853 118.6 46.809V30.6312C118.6 29.4549 119.555 28.5 120.731 28.5H151.924C153.101 28.5 154.056 29.4549 154.056 30.6312V46.809C154.056 47.9853 153.101 48.9402 151.924 48.9402ZM122.863 44.664H149.779V32.7624H122.863V44.664Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M151.924 81.2937H120.731C119.555 81.2937 118.6 80.3389 118.6 79.1625V62.9847C118.6 61.8084 119.555 60.8535 120.731 60.8535H151.924C153.101 60.8535 154.056 61.8084 154.056 62.9847V79.1625C154.056 80.3389 153.101 81.2937 151.924 81.2937ZM122.863 77.0175H149.779V65.1021H122.863V77.0175Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M183.049 81.2937H151.855C150.679 81.2937 149.71 80.3389 149.71 79.1625V62.9847C149.71 61.8084 150.665 60.8535 151.855 60.8535H183.049C184.225 60.8535 185.18 61.8084 185.18 62.9847V79.1625C185.18 80.3389 184.225 81.2937 183.049 81.2937ZM153.987 77.0175H180.904V65.1021H153.987V77.0175Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M167.479 65.1182H136.286C135.109 65.1182 134.154 64.1633 134.154 62.9869V46.8091C134.154 45.6328 135.109 44.6641 136.286 44.6641H167.479C168.655 44.6641 169.624 45.619 169.624 46.8091V62.9869C169.624 64.1633 168.669 65.1182 167.479 65.1182ZM138.417 60.8419H165.334V48.9403H138.417V60.8419Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M198.604 65.1182H167.41C166.234 65.1182 165.279 64.1633 165.279 62.9869V46.8091C165.279 45.6328 166.234 44.6641 167.41 44.6641H198.604C199.78 44.6641 200.735 45.619 200.735 46.8091V62.9869C200.735 64.1633 199.78 65.1182 198.604 65.1182ZM169.542 60.8419H196.459V48.9403H169.542V60.8419Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214 108H108V214H214V108Z",
                fill: fifthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M161.401 173.374C160.847 173.374 160.308 173.167 159.892 172.752C155.492 168.351 152.738 162.525 152.129 156.339C151.589 150.831 152.765 145.254 155.45 140.465L146.026 131.041C143.189 128.204 143.189 123.582 146.026 120.731C147.41 119.347 149.236 118.6 151.188 118.6C153.139 118.6 154.966 119.361 156.35 120.731L165.774 130.155C170.562 127.47 176.139 126.294 181.647 126.834C187.833 127.443 193.66 130.197 198.06 134.598C198.891 135.428 198.891 136.784 198.06 137.614L162.937 172.738C162.522 173.153 161.968 173.361 161.429 173.361M151.201 122.862C150.399 122.862 149.638 123.18 149.07 123.748C147.894 124.924 147.894 126.834 149.07 128.01L159.671 138.611C160.391 139.33 160.501 140.438 159.948 141.296C157.152 145.586 155.893 150.775 156.391 155.91C156.834 160.393 158.619 164.67 161.484 168.129L193.438 136.175C189.978 133.31 185.702 131.525 181.218 131.082C176.084 130.57 170.894 131.844 166.604 134.639C165.76 135.193 164.639 135.082 163.92 134.362L153.319 123.762C152.751 123.194 151.99 122.876 151.188 122.876L151.201 122.862Z",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M178.962 165.665C175.89 165.665 172.818 164.502 170.479 162.163C169.648 161.333 169.648 159.977 170.479 159.147C171.309 158.316 172.665 158.316 173.509 159.147C176.513 162.15 181.412 162.15 184.428 159.147C187.432 156.13 187.432 151.231 184.428 148.228C183.598 147.397 183.598 146.041 184.428 145.211C185.259 144.38 186.615 144.38 187.445 145.211C192.123 149.888 192.123 157.5 187.445 162.177C185.107 164.516 182.034 165.679 178.962 165.679",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M150.219 207.155C149.444 207.155 148.696 206.726 148.309 205.993L129.432 168.904C129.059 168.17 129.142 167.285 129.64 166.634L152.973 135.995C153.692 135.054 155.035 134.874 155.962 135.593C156.903 136.313 157.083 137.655 156.363 138.596L133.833 168.17L152.101 204.069C152.64 205.121 152.211 206.408 151.16 206.947C150.855 207.113 150.523 207.183 150.191 207.183",
                fill: sixthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214 214H108V320H214V214Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M181.498 271.133C181.046 271.133 180.605 270.964 180.266 270.625C175.126 265.485 168.28 262.649 161.005 262.649C153.73 262.649 146.884 265.485 141.744 270.625C141.066 271.303 139.959 271.303 139.281 270.625C138.603 269.947 138.603 268.84 139.281 268.162C145.087 262.355 152.803 259.158 161.005 259.158C169.207 259.158 176.934 262.355 182.74 268.162C183.418 268.84 183.418 269.947 182.74 270.625C182.402 270.964 181.95 271.133 181.509 271.133",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M150.567 278.843C150.115 278.843 149.675 278.673 149.336 278.334C148.658 277.656 148.658 276.549 149.336 275.871C155.775 269.432 166.248 269.432 172.687 275.871C173.365 276.549 173.365 277.656 172.687 278.334C172.009 279.012 170.902 279.012 170.224 278.334C165.152 273.262 156.894 273.262 151.81 278.334C151.471 278.673 151.019 278.843 150.579 278.843",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M191.789 262.07C191.338 262.07 190.897 261.9 190.558 261.561C182.661 253.665 172.166 249.327 161.016 249.327C149.866 249.327 139.36 253.676 131.463 261.561C130.785 262.239 129.678 262.239 129.001 261.561C128.323 260.884 128.323 259.776 129.001 259.099C137.552 250.547 148.917 245.836 161.016 245.836C173.115 245.836 184.48 250.547 193.032 259.099C193.71 259.776 193.71 260.884 193.032 261.561C192.693 261.9 192.241 262.07 191.801 262.07",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M164.079 285.093C164.079 286.788 162.701 288.166 161.006 288.166C159.312 288.166 157.934 286.788 157.934 285.093C157.934 283.399 159.312 282.021 161.006 282.021C162.701 282.021 164.079 283.399 164.079 285.093Z",
                fill: fourthColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/IconRightTopMobile.tsx


var IconRightTopMobile = function(param) {
    var _width = param.width, width = _width === void 0 ? "139" : _width, _height = param.height, height = _height === void 0 ? "207" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.250 */.rS.colors.secondary[250] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.secondary.45 */.rS.colors.secondary[45] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.neutral.150 */.rS.colors.neutral[150] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.primary.705 */.rS.colors.primary[705] : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? themes/* theme.colors.primary.710 */.rS.colors.primary[710] : _fifthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 139 207",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69 70H2V137H69V70Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.7392 91.763C22.3981 91.763 22.0482 91.6318 21.7858 91.3694C19.0304 88.614 19.0304 84.1179 21.7858 81.3624C24.5499 78.607 29.0373 78.607 31.7927 81.3624L37.6971 87.2669C38.222 87.7917 38.222 88.649 37.6971 89.1738C37.1723 89.6986 36.3151 89.6986 35.7902 89.1738L29.8858 83.2694C28.1801 81.5636 25.4072 81.5636 23.7014 83.2694C21.9957 84.9751 21.9957 87.748 23.7014 89.4537C24.2263 89.9785 24.2263 90.8358 23.7014 91.3606C23.439 91.623 23.0891 91.7542 22.748 91.7542",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.2502 123.665C33.9003 123.665 33.5591 123.534 33.2967 123.271L13.4053 103.38C12.8805 102.855 12.8805 101.998 13.4053 101.473L36.6819 78.1964C37.2068 77.6715 38.064 77.6715 38.5888 78.1964L58.4802 98.0877C59.0051 98.6126 59.0051 99.4698 58.4802 99.9947L35.2036 123.271C34.9412 123.534 34.5913 123.665 34.2502 123.665ZM16.2657 102.418L34.2502 120.402L55.6199 99.0324L37.6354 81.048L16.2657 102.418Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.7354 91.7627C34.7585 91.7627 33.1577 90.1532 33.1577 88.1851C33.1577 86.2169 34.7672 84.6074 36.7354 84.6074C38.7035 84.6074 40.313 86.2169 40.313 88.1851C40.313 90.1532 38.7035 91.7627 36.7354 91.7627ZM36.7354 87.3016C36.2543 87.3016 35.8519 87.6952 35.8519 88.1851C35.8519 88.6749 36.2455 89.0685 36.7354 89.0685C37.2252 89.0685 37.6188 88.6749 37.6188 88.1851C37.6188 87.6952 37.2252 87.3016 36.7354 87.3016Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56.8794 122.668C54.8413 122.668 53.7304 121.644 53.1531 120.787C51.7447 118.679 51.7622 114.97 53.2143 109.451C54.229 105.602 55.5673 102.33 55.6286 102.19C55.8385 101.683 56.3283 101.351 56.8794 101.351C57.4305 101.351 57.9203 101.683 58.1303 102.19C58.1828 102.33 59.5299 105.602 60.5445 109.451C61.9966 114.97 62.0141 118.679 60.6058 120.787C60.0284 121.644 58.9175 122.668 56.8794 122.668ZM56.8794 106.651C56.5295 107.701 56.1534 108.908 55.821 110.177C55.2699 112.285 54.124 117.384 55.4011 119.291C55.6111 119.606 55.9697 119.974 56.8794 119.974C57.7891 119.974 58.1478 119.615 58.3577 119.291C58.7863 118.653 59.5998 116.492 57.9378 110.177C57.6054 108.917 57.2293 107.701 56.8794 106.651Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.5326 93.565C24.1827 93.565 23.8415 93.4338 23.5791 93.1714L21.7772 91.3782C21.2523 90.8533 21.2523 89.9961 21.7772 89.4713C22.302 88.9464 23.1592 88.9464 23.6841 89.4713L25.486 91.2732C26.0109 91.7981 26.0109 92.6553 25.486 93.1801C25.2236 93.4425 24.8737 93.5738 24.5326 93.5738",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.9855 124.408C34.6356 124.408 34.2945 124.277 34.032 124.014L12.4437 102.426C11.9188 101.901 11.9188 101.044 12.4437 100.519C12.9685 99.9943 13.8258 99.9943 14.3506 100.519L35.9389 122.107C36.4638 122.632 36.4638 123.49 35.9389 124.014C35.6765 124.277 35.3266 124.408 34.9855 124.408Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58.1222 100.983C57.7723 100.983 57.4312 100.852 57.1688 100.589L35.5804 79.0007C35.0556 78.4759 35.0556 77.6187 35.5804 77.0938C36.1052 76.569 36.9625 76.569 37.4873 77.0938L59.0757 98.6822C59.6005 99.207 59.6005 100.064 59.0757 100.589C58.8132 100.852 58.4634 100.983 58.1222 100.983Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M43.6804 113.369C42.762 113.369 41.9047 113.01 41.2574 112.372L40.6888 111.803C39.3593 110.474 39.3593 108.304 40.6888 106.966L47.7217 99.9331C48.2465 99.4083 49.1038 99.4083 49.6286 99.9331C50.1534 100.458 50.1534 101.315 49.6286 101.84L42.5958 108.873C42.3158 109.153 42.3158 109.616 42.5958 109.888L43.1643 110.456C43.348 110.64 43.558 110.666 43.6717 110.666C43.7854 110.666 44.0041 110.64 44.179 110.456L56.5652 98.0787C57.09 97.5538 57.9473 97.5538 58.4809 98.0787C59.0057 98.6035 59.0057 99.4608 58.4809 99.9856L46.0947 112.372C45.4474 113.019 44.5901 113.369 43.6717 113.369",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M48.6837 102.234C48.3338 102.234 47.9927 102.103 47.7302 101.84C47.2054 101.315 47.2054 100.458 47.7302 99.9332C47.9139 99.7495 47.9402 99.5395 47.9402 99.4258C47.9402 99.3121 47.9139 99.1022 47.7302 98.9185L47.1617 98.3499C46.978 98.1662 46.768 98.14 46.6543 98.14C46.5406 98.14 46.3219 98.1662 46.147 98.3499C45.6221 98.8747 44.7649 98.8747 44.2401 98.3499C43.7152 97.8251 43.7152 96.9678 44.2401 96.443C45.5697 95.1134 47.7477 95.1134 49.0773 96.443L49.6459 97.0116C50.2932 97.6589 50.6431 98.5161 50.6431 99.4346C50.6431 100.353 50.2845 101.21 49.6459 101.858C49.3835 102.12 49.0336 102.251 48.6924 102.251",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.8838 103.187C39.0091 103.187 38.1343 102.855 37.4608 102.19L36.8922 101.622C35.5626 100.292 35.5626 98.1138 36.8922 96.7842L45.9982 87.6783C46.523 87.1535 47.3802 87.1535 47.9051 87.6783C48.4299 88.2031 48.4299 89.0604 47.9051 89.5852L38.7991 98.6912C38.5192 98.9711 38.5192 99.4347 38.7991 99.7058L39.3677 100.274C39.6389 100.554 40.1112 100.554 40.3824 100.274L44.2225 96.4343C44.7473 95.9095 45.6045 95.9095 46.1294 96.4343C46.6542 96.9592 46.6542 97.8164 46.1294 98.3413L42.2893 102.181C41.6245 102.846 40.7498 103.179 39.8663 103.179",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M137 2H70V69H137V2Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M97.7635 31.6698H78.047C77.3035 31.6698 76.7 31.0662 76.7 30.3227V20.0971C76.7 19.3536 77.3035 18.75 78.047 18.75H97.7635C98.507 18.75 99.1106 19.3536 99.1106 20.0971V30.3227C99.1106 31.0662 98.507 31.6698 97.7635 31.6698ZM79.3941 28.9668H96.4076V21.4442H79.3941V28.9668Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M97.7635 52.1214H78.047C77.3035 52.1214 76.7 51.5179 76.7 50.7743V40.5487C76.7 39.8052 77.3035 39.2017 78.047 39.2017H97.7635C98.507 39.2017 99.1106 39.8052 99.1106 40.5487V50.7743C99.1106 51.5179 98.507 52.1214 97.7635 52.1214ZM79.3941 49.4185H96.4076V41.8871H79.3941V49.4185Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M117.436 52.1214H97.7198C96.9763 52.1214 96.364 51.5179 96.364 50.7743V40.5487C96.364 39.8052 96.9676 39.2017 97.7198 39.2017H117.436C118.18 39.2017 118.783 39.8052 118.783 40.5487V50.7743C118.783 51.5179 118.18 52.1214 117.436 52.1214ZM99.0669 49.4185H116.08V41.8871H99.0669V49.4185Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M107.595 41.8953H87.8788C87.1353 41.8953 86.5317 41.2918 86.5317 40.5482V30.3226C86.5317 29.5791 87.1353 28.9668 87.8788 28.9668H107.595C108.339 28.9668 108.951 29.5704 108.951 30.3226V40.5482C108.951 41.2918 108.348 41.8953 107.595 41.8953ZM89.2259 39.1924H106.239V31.6697H89.2259V39.1924Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M127.268 41.8953H107.552C106.808 41.8953 106.205 41.2918 106.205 40.5482V30.3226C106.205 29.5791 106.808 28.9668 107.552 28.9668H127.268C128.012 28.9668 128.615 29.5704 128.615 30.3226V40.5482C128.615 41.2918 128.012 41.8953 127.268 41.8953ZM108.899 39.1924H125.912V31.6697H108.899V39.1924Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M137 69H70V136H137V69Z",
                fill: fifthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M103.753 110.322C103.403 110.322 103.062 110.191 102.8 109.928C100.018 107.147 98.2775 103.464 97.8926 99.5541C97.5515 96.0727 98.295 92.5475 99.992 89.5209L94.0351 83.564C92.2419 81.7708 92.2419 78.8492 94.0351 77.0473C94.9098 76.1726 96.0645 75.7002 97.2978 75.7002C98.5312 75.7002 99.6858 76.1813 100.561 77.0473L106.517 83.0042C109.544 81.3072 113.069 80.5637 116.551 80.9048C120.461 81.2897 124.143 83.0304 126.925 85.8121C127.45 86.3369 127.45 87.1942 126.925 87.719L104.724 109.92C104.462 110.182 104.112 110.313 103.771 110.313M97.3066 78.3944C96.7992 78.3944 96.3181 78.5956 95.9595 78.9542C95.216 79.6977 95.216 80.9048 95.9595 81.6484L102.66 88.3488C103.115 88.8037 103.185 89.5034 102.835 90.0458C101.068 92.7574 100.272 96.0377 100.587 99.2829C100.867 102.117 101.995 104.82 103.806 107.007L124.003 86.8093C121.817 84.9986 119.114 83.8702 116.279 83.5903C113.034 83.2666 109.754 84.0714 107.042 85.8383C106.509 86.1882 105.8 86.1182 105.345 85.6634L98.6449 78.9629C98.2863 78.6043 97.8052 78.4031 97.2978 78.4031L97.3066 78.3944Z",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M114.853 105.45C112.911 105.45 110.969 104.715 109.491 103.237C108.966 102.712 108.966 101.855 109.491 101.33C110.016 100.805 110.873 100.805 111.407 101.33C113.305 103.228 116.401 103.228 118.308 101.33C120.206 99.4232 120.206 96.3266 118.308 94.4285C117.783 93.9036 117.783 93.0464 118.308 92.5216C118.833 91.9967 119.69 91.9967 120.215 92.5216C123.172 95.4781 123.172 100.289 120.215 103.246C118.737 104.724 116.795 105.459 114.853 105.459",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.6851 131.673C96.1953 131.673 95.7229 131.402 95.478 130.938L83.5467 107.496C83.3105 107.032 83.363 106.472 83.6779 106.061L98.4258 86.6946C98.8807 86.0998 99.7292 85.986 100.315 86.4409C100.91 86.8958 101.024 87.7442 100.569 88.3391L86.3283 107.032L97.8748 129.723C98.2159 130.387 97.9447 131.201 97.28 131.542C97.0875 131.647 96.8776 131.691 96.6676 131.691",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M137 136H70V203H137V136Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M116.456 172.112C116.171 172.112 115.892 172.005 115.678 171.791C112.429 168.542 108.102 166.749 103.503 166.749C98.9048 166.749 94.5776 168.542 91.3287 171.791C90.9002 172.219 90.2004 172.219 89.772 171.791C89.3436 171.362 89.3436 170.662 89.772 170.234C93.4423 166.564 98.3193 164.543 103.503 164.543C108.687 164.543 113.572 166.564 117.242 170.234C117.67 170.662 117.67 171.362 117.242 171.791C117.028 172.005 116.742 172.112 116.463 172.112",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.906 176.984C96.6204 176.984 96.3419 176.877 96.1277 176.662C95.6993 176.234 95.6993 175.534 96.1277 175.106C100.198 171.036 106.817 171.036 110.887 175.106C111.316 175.534 111.316 176.234 110.887 176.662C110.459 177.091 109.759 177.091 109.331 176.662C106.125 173.456 100.905 173.456 97.6915 176.662C97.4773 176.877 97.1917 176.984 96.9132 176.984",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M122.961 166.382C122.676 166.382 122.397 166.275 122.183 166.061C117.192 161.07 110.558 158.328 103.51 158.328C96.4626 158.328 89.8219 161.077 84.8306 166.061C84.4022 166.489 83.7024 166.489 83.274 166.061C82.8455 165.632 82.8455 164.933 83.274 164.504C88.6794 159.099 95.8628 156.121 103.51 156.121C111.158 156.121 118.341 159.099 123.747 164.504C124.175 164.933 124.175 165.632 123.747 166.061C123.533 166.275 123.247 166.382 122.968 166.382",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M105.446 180.935C105.446 182.006 104.575 182.878 103.504 182.878C102.433 182.878 101.562 182.006 101.562 180.935C101.562 179.864 102.433 178.993 103.504 178.993C104.575 178.993 105.446 179.864 105.446 180.935Z",
                fill: thirdColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/IconStore.tsx


var IconStore = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Loja" : _alt, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.200 */.rS.colors.primary[200] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        xmlns: "https://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 489.4 489.4",
        width: width,
        height: height,
        xmlSpace: "preserve",
        fill: color,
        enableBackground: "new 0 0 489.4 489.4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M347.7 263.75h-66.5c-18.2 0-33 14.8-33 33v51c0 18.2 14.8 33 33 33h66.5c18.2 0 33-14.8 33-33v-51c0-18.2-14.8-33-33-33zm9 84c0 5-4.1 9-9 9h-66.5c-5 0-9-4.1-9-9v-51c0-5 4.1-9 9-9h66.5c5 0 9 4.1 9 9v51z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M489.4 171.05c0-2.1-.5-4.1-1.6-5.9l-72.8-128c-2.1-3.7-6.1-6.1-10.4-6.1H84.7c-4.3 0-8.3 2.3-10.4 6.1l-72.7 128c-1 1.8-1.6 3.8-1.6 5.9 0 28.7 17.3 53.3 42 64.2v211.1c0 6.6 5.4 12 12 12h381.3c6.6 0 12-5.4 12-12v-209.6c0-.5 0-.9-.1-1.3 24.8-10.9 42.2-35.6 42.2-64.4zM91.7 55.15h305.9l56.9 100.1H34.9l56.8-100.1zm256.6 124c-3.8 21.6-22.7 38-45.4 38s-41.6-16.4-45.4-38h90.8zm-116.3 0c-3.8 21.6-22.7 38-45.4 38s-41.6-16.4-45.5-38H232zm-207.2 0h90.9c-3.8 21.6-22.8 38-45.5 38-22.7.1-41.6-16.4-45.4-38zm176.8 255.2h-69v-129.5c0-9.4 7.6-17.1 17.1-17.1h34.9c9.4 0 17.1 7.6 17.1 17.1v129.5h-.1zm221.7 0H225.6v-129.5c0-22.6-18.4-41.1-41.1-41.1h-34.9c-22.6 0-41.1 18.4-41.1 41.1v129.6H66v-193.3c1.4.1 2.8.1 4.2.1 24.2 0 45.6-12.3 58.2-31 12.6 18.7 34 31 58.2 31s45.5-12.3 58.2-31c12.6 18.7 34 31 58.1 31 24.2 0 45.5-12.3 58.1-31 12.6 18.7 34 31 58.2 31 1.4 0 2.7-.1 4.1-.1v193.2zm-4.1-217.1c-22.7 0-41.6-16.4-45.4-38h90.9c-3.9 21.5-22.8 38-45.5 38z"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/IllustrationSendEmail.tsx

var IllustrationSendEmail = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Autenticac\xe3o por Email" : _alt, _width = param.width, width = _width === void 0 ? 138 : _width, _height = param.height, height = _height === void 0 ? 144 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 138 144",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "77.5105",
                cy: "53.9547",
                r: "40.0181",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.17",
                d: "M83.356 36.6851L97.9544 49.211L52.5611 136.349L10.8836 86.0632L83.356 36.6851Z",
                fill: "url(#paint0_linear_42_91407)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.17",
                d: "M84.8733 38.4243L96.8407 47.576L51.4961 120.798L27.798 85.0337L84.8733 38.4243Z",
                fill: "url(#paint1_linear_42_91407)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M97.8112 65.7951C96.6503 65.7951 95.7086 66.674 95.7086 67.758C95.7086 68.8421 96.6503 69.7205 97.8112 69.7205H103.594C104.755 69.7205 105.697 68.8415 105.697 67.758C105.697 66.6746 104.755 65.7956 103.595 65.7956C103.595 64.3051 102.3 63.0967 100.703 63.0967C99.1058 63.0967 97.8112 64.3045 97.8112 65.7951Z",
                    stroke: "#A0A2A4",
                    strokeWidth: "0.443934",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M87.1569 74.6739C85.996 74.6739 85.0543 75.5528 85.0543 76.6368C85.0543 77.7208 85.996 78.5992 87.1569 78.5992H92.9397C94.1011 78.5992 95.0428 77.7203 95.0428 76.6368C95.0428 75.5533 94.1011 74.6744 92.9403 74.6744C92.9403 73.1838 91.6456 71.9755 90.0486 71.9755C88.4515 71.9755 87.1569 73.1833 87.1569 74.6739Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M74.7271 86.216C73.5662 86.216 72.6245 87.0949 72.6245 88.1789C72.6245 89.2629 73.5662 90.1413 74.7271 90.1413H80.5099C81.6713 90.1413 82.613 89.2624 82.613 88.1789C82.613 87.0954 81.6713 86.2165 80.5104 86.2165C80.5104 84.7259 79.2158 83.5176 77.6188 83.5176C76.0217 83.5176 74.7271 84.7254 74.7271 86.216Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.443934",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M45.2577 62.8987C44.0968 62.8987 43.1552 63.7776 43.1552 64.8616C43.1552 65.9456 44.0968 66.824 45.2577 66.824H51.0405C52.202 66.824 53.1437 65.9451 53.1437 64.8616C53.1437 63.7781 52.202 62.8992 51.0411 62.8992C51.0411 61.4086 49.7465 60.2003 48.1494 60.2003C46.5524 60.2003 45.2577 61.4081 45.2577 62.8987Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.443934",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M80.9418 32.944C79.7809 32.944 78.8392 33.823 78.8392 34.907C78.8392 35.991 79.7809 36.8694 80.9418 36.8694H86.7246C87.8861 36.8694 88.8277 35.9905 88.8277 34.907C88.8277 33.8235 87.8861 32.9446 86.7252 32.9446C86.7252 31.454 85.4305 30.2457 83.8335 30.2457C82.2364 30.2457 80.9418 31.4535 80.9418 32.944Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.443934",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M53.2487 35.3748C52.0878 35.3748 51.1461 36.2537 51.1461 37.3378C51.1461 38.4218 52.0878 39.3002 53.2487 39.3002H59.0315C60.1929 39.3002 61.1346 38.4213 61.1346 37.3378C61.1346 36.2543 60.1929 35.3753 59.0321 35.3753C59.0321 33.8848 57.7374 32.6765 56.1404 32.6765C54.5433 32.6765 53.2487 33.8842 53.2487 35.3748Z",
                    stroke: "#8F9194",
                    strokeWidth: "0.443934",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M62.2969 58.6921C61.136 58.6921 60.1943 59.571 60.1943 60.655C60.1943 61.739 61.136 62.6174 62.2969 62.6174H68.0797C69.2412 62.6174 70.1828 61.7385 70.1828 60.655C70.1828 59.5715 69.2412 58.6926 68.0803 58.6926C68.0803 57.202 66.7856 55.9937 65.1886 55.9937C63.5915 55.9937 62.2969 57.2015 62.2969 58.6921Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M105.686 49.262C104.834 49.262 104.144 49.9065 104.144 50.7014C104.144 51.4964 104.834 52.1405 105.686 52.1405H109.926C110.778 52.1405 111.469 51.496 111.469 50.7014C111.469 49.9069 110.778 49.2623 109.927 49.2623C109.927 48.1692 108.977 47.2831 107.806 47.2831C106.635 47.2831 105.686 48.1689 105.686 49.262Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M65.5622 25.9448C64.7108 25.9448 64.0203 26.5894 64.0203 27.3843C64.0203 28.1792 64.7108 28.8234 65.5622 28.8234H69.8029C70.6546 28.8234 71.3452 28.1789 71.3452 27.3843C71.3452 26.5897 70.6546 25.9452 69.8033 25.9452C69.8033 24.8521 68.8539 23.966 67.6827 23.966C66.5115 23.966 65.5622 24.8517 65.5622 25.9448Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.8392 68.015L43.4137 84.9412",
                stroke: "#040405",
                strokeWidth: "0.978292",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M70.3823 77.0572L55.6908 94.3967",
                stroke: "#040405",
                strokeWidth: "0.978292",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M60.6363 77.1303L44.5926 95.095",
                stroke: "#040405",
                strokeWidth: "0.978292",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.064 65.4399L69.1638 46.2124L106.046 27.1378L103.873 36.4679L69.064 65.4399Z",
                fill: "url(#paint2_linear_42_91407)",
                stroke: "#040405",
                strokeWidth: "1.84614"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M108.267 22.2624C109.344 21.8727 110.026 23.4043 109.016 23.9444L69.1135 45.2847C68.9887 45.3515 68.8502 45.3886 68.7088 45.3933L47.7033 46.0896C46.6526 46.1244 46.3702 44.6567 47.3587 44.299L108.267 22.2624Z",
                fill: "#68A439",
                stroke: "#040405",
                strokeWidth: "1.84614"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M109.438 24.6007C109.834 23.7091 108.756 22.8931 108.005 23.5157L76.0784 49.9854C75.7678 50.2429 75.6604 50.6723 75.8133 51.0457L85.496 74.7016C85.804 75.4541 86.8641 75.4696 87.194 74.7263L109.438 24.6007Z",
                fill: "#F6F7F7",
                stroke: "#040405",
                strokeWidth: "1.84614"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.5943 66.3113L75.6262 50.8787C75.6337 50.8593 75.6407 50.8499 75.644 50.846C75.6474 50.8419 75.6507 50.8391 75.6546 50.8367C75.6633 50.8313 75.6815 50.8242 75.7073 50.8249C75.7331 50.8257 75.7509 50.8337 75.7593 50.8396C75.763 50.8422 75.7662 50.8452 75.7694 50.8495C75.7724 50.8536 75.7789 50.8634 75.7853 50.8831L75.7964 50.9168L75.81 50.9496L79.304 59.3699L80.3241 62.4838L69.5943 66.3113Z",
                fill: "#68A439",
                stroke: "#040405",
                strokeWidth: "1.84614"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_42_91407",
                        x1: "89.4007",
                        y1: "37.3454",
                        x2: "38.5584",
                        y2: "121.155",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.419792",
                                stopColor: "#68A439"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#68A439",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_42_91407",
                        x1: "89.4009",
                        y1: "37.3455",
                        x2: "38.5586",
                        y2: "121.155",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.51875",
                                stopColor: "#68A439"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#68A439",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_42_91407",
                        x1: "83.2183",
                        y1: "35.2541",
                        x2: "92.3107",
                        y2: "57.5625",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E5E6E6"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8F9194"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/ui/Icons/ImageCardVirtualMyCards.tsx


var ImageCardVirtualMyCards = function(param) {
    var _width = param.width, width = _width === void 0 ? 860 : _width, _height = param.height, height = _height === void 0 ? 542 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.primary.350 */.rS.colors.primary[350] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.primary.200 */.rS.colors.primary[200] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.primary.85 */.rS.colors.primary[85] : _fourthColor, codeMyCard = param.codeMyCard;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 860 542",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "860",
                height: "542",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "790",
                height: "482",
                transform: "translate(29 36)",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M140.288 50.6254C142.623 50.6254 144.698 51.1478 146.252 52.4537C149.098 51.1481 152.205 50.5223 155.331 50.6254H163.633V54.2821C167.699 51.3084 172.617 49.7497 177.641 49.842C184.646 49.842 190.349 52.7146 193.984 57.4184V53.2371C192.927 51.5124 192.387 49.5173 192.428 47.4911C192.43 40.9626 197.619 36 204.624 36C211.628 36 216.816 40.701 216.816 47.4919C216.77 48.5539 216.596 49.6064 216.297 50.6261H221.226C223.396 50.5967 225.507 51.3362 227.19 52.7153C230.015 51.3216 233.123 50.6065 236.269 50.6261H253.39C267.399 50.6261 275.182 57.9388 275.182 71.5198V77.7883H279.073V90.5824H293.343V99.7256H313.318C327.326 99.7256 335.109 107.302 335.109 120.619V127.41H339V146.737H324.991C322.979 146.778 320.997 146.234 319.284 145.17C316.949 146.476 314.096 146.737 310.464 146.737H290.749C283.744 146.737 278.556 144.386 275.184 140.207C273.368 143.08 270.255 144.908 266.623 146.211C266.482 146.193 266.338 146.207 266.203 146.252C266.068 146.298 265.945 146.373 265.842 146.472C265.583 146.472 265.061 146.733 264.804 146.733H264.023C259.459 147.595 254.761 147.417 250.275 146.211C248.941 145.894 247.639 145.457 246.383 144.905C246.124 144.905 246.124 144.905 245.864 144.644C245.605 144.644 245.605 144.383 245.345 144.383C245.311 144.384 245.277 144.377 245.245 144.364C245.214 144.352 245.185 144.332 245.161 144.308C245.136 144.284 245.117 144.255 245.105 144.223C245.092 144.191 245.086 144.156 245.086 144.122C243.167 143.378 241.339 142.414 239.639 141.249C235.242 145.053 229.611 147.098 223.815 146.995C217.563 147.118 211.512 144.775 206.953 140.466V145.429L204.359 146.996C198.133 151.175 192.166 153 185.162 153C167.262 153 154.551 140.464 154.551 122.704C154.551 111.474 159.48 102.334 167.259 97.1096H89.4434C76.9916 97.1096 67.6523 89.2744 65.837 77.7825H56.2385V97.1117H33.9292V57.9388H29V37.5667H75.6946V53.4987C79.4957 51.0805 83.9063 49.8113 88.4026 49.842C94.888 49.842 100.335 52.1928 103.967 56.6322V50.6282H113.566C115.901 50.6282 117.976 51.1507 119.529 52.4566C122.376 51.1509 125.483 50.5252 128.609 50.6282L140.288 50.6254Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M204.364 53.2372C208.255 53.2372 210.849 50.8864 210.849 47.2332C210.849 43.8381 208.255 41.4873 204.364 41.4873C200.473 41.4873 197.878 43.8353 197.878 47.2304C198.138 51.148 200.732 53.2372 204.364 53.2372Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.017 60.0279C118.498 57.6771 116.423 56.3712 114.088 56.3712H110.197V91.6295H120.832V72.3032C120.832 66.8188 124.464 64.468 129.393 64.468H131.728V56.1104H129.134C124.466 56.1104 120.832 57.6771 119.017 60.0279Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M227.711 72.3032C227.711 66.8188 231.343 64.468 236.272 64.468H238.607V56.1104H236.012C231.343 56.1104 227.971 57.6771 225.895 60.0279C225.376 57.6771 223.301 56.3712 220.966 56.3712H217.075V91.6295H227.711V72.3032Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M88.6653 55.3271C78.2887 55.3271 71.2844 62.9036 71.2844 73.8701C71.2844 84.317 78.5478 92.1521 89.7025 92.1521C94.8908 92.1521 99.301 91.1072 102.411 88.757V80.3994C98.782 82.4879 95.1506 83.2741 90.7369 83.2741C85.8077 83.2741 82.4355 80.6624 81.3983 76.2224H103.711V72.0425C103.711 62.1173 98.0039 55.3271 88.6653 55.3271ZM81.6609 68.9075C82.6989 65.5124 85.0332 63.4232 88.6653 63.4232C91.7784 63.4232 93.8535 65.5124 94.3725 68.9075H81.6609Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M145.217 60.0279C144.698 57.6771 142.623 56.3712 140.288 56.3712H136.397V91.6295H147.033V72.3032C147.033 66.8188 150.665 64.468 155.593 64.468H157.928V56.1104H155.334C150.667 56.1104 147.293 57.6771 145.217 60.0279Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M205.661 56.3713H199.435V91.6296H210.07V61.0723C210.33 58.1997 208.514 56.3713 205.661 56.3713Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.7073 52.4537H37.5605C39.1167 52.4537 39.6357 52.9762 39.6357 54.5429V92.4136H50.7911V73.0866H66.8749V63.9455H50.7911V52.4537H70.2436V43.0518H34.7073V52.4537Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M269.476 81.4436V70.9967C269.476 61.0723 264.547 55.8489 253.393 55.8489H243.017V64.2065H252.093C256.762 64.2065 259.097 65.7733 259.356 69.9525H256.243C245.611 69.9525 239.385 73.086 239.385 81.4436C239.385 87.9729 243.795 92.1514 250.799 92.1514C255.209 92.1514 257.803 90.323 260.138 87.7113C261.176 90.0622 262.991 91.368 265.326 91.368H273.627V83.5328H271.552C271.273 83.5587 270.992 83.5224 270.729 83.4265C270.465 83.3307 270.226 83.1776 270.028 82.9782C269.83 82.7788 269.678 82.538 269.582 82.2728C269.487 82.0076 269.451 81.7245 269.476 81.4436V81.4436ZM252.614 84.3169C252.154 84.3353 251.695 84.2619 251.263 84.101C250.831 83.9401 250.435 83.6949 250.098 83.3794C249.76 83.0639 249.488 82.6844 249.296 82.2627C249.105 81.8409 248.998 81.3852 248.982 80.9218C248.982 77.7876 251.058 76.7434 255.987 76.7434H259.1C259.1 81.1827 256.506 84.3169 252.614 84.3169Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M178.422 92.152C183.611 92.152 188.021 91.107 191.393 88.7569V80.3993C187.761 82.4885 183.868 83.2719 179.46 83.2719C174.531 83.2719 171.159 80.6602 170.381 76.2201H192.431C192.763 74.7633 192.937 73.2746 192.95 71.78C192.949 61.8556 187.241 55.0654 177.644 55.0654C167.268 55.0654 160.263 62.6419 160.263 73.6084C160.263 84.3169 167.268 92.152 178.422 92.152ZM177.384 63.4231C180.497 63.4231 182.832 65.5123 183.092 68.9074H170.64C171.678 65.5123 173.752 63.4231 177.384 63.4231Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M171.678 123.493C171.678 114.091 177.904 108.867 185.948 108.867C191.395 108.867 195.805 110.434 200.475 113.568V103.643C195.68 100.537 190.09 98.9033 184.389 98.9423C169.862 98.9423 160.263 109.128 160.263 123.754C160.263 138.379 170.381 148.304 185.167 148.304C190.911 148.381 196.536 146.646 201.251 143.342V133.156C196.062 136.551 191.133 138.118 185.945 138.118C177.903 137.857 171.678 132.634 171.678 123.493Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M287.636 96.3306H276.741V127.932C276.741 137.334 282.704 140.991 290.749 140.991H295.938V132.372H292.046C289.193 132.372 287.377 130.805 287.377 127.149V113.829H297.755V105.472H287.376L287.635 96.3306H287.636Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M331.736 133.155C330.18 133.155 329.661 132.369 329.661 131.066V120.881C329.661 110.695 324.731 105.471 313.577 105.471H302.681V113.829H312.536C317.205 113.829 319.54 115.396 319.799 119.575H316.427C305.792 119.575 299.828 122.709 299.828 131.066C299.828 137.595 303.978 141.774 310.983 141.774C315.393 141.774 318.246 139.685 320.581 137.334C320.881 138.409 321.529 139.352 322.422 140.014C323.315 140.677 324.402 141.02 325.51 140.991H333.812V133.155H331.736ZM312.799 133.678C310.464 133.678 308.907 132.372 308.907 130.544C308.907 127.409 310.983 126.104 316.171 126.104H319.281C319.281 130.544 316.69 133.678 312.799 133.678V133.678Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M223.82 104.949C213.183 104.949 205.142 112.784 205.142 123.492C205.142 133.939 213.183 141.774 223.82 141.774C234.456 141.774 242.238 133.678 242.238 123.231C242.238 112.784 234.456 104.949 223.82 104.949ZM223.82 132.896C219.15 132.896 216.037 129.239 216.037 123.494C216.037 117.49 219.15 114.092 223.82 114.092C228.489 114.092 231.345 117.487 231.345 123.494C231.342 129.238 228.489 132.896 223.82 132.896Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M245.87 115.918C245.87 120.881 248.464 123.495 254.69 126.104C259.619 128.194 261.435 129.239 261.435 130.805C261.435 132.634 260.397 132.895 258.063 132.895C253.739 133.002 249.457 132.014 245.611 130.022V138.38C248.464 140.208 253.912 141.514 259.1 141.514C266.882 141.514 272.33 137.074 272.33 130.545C272.33 124.015 267.402 121.664 262.473 119.577C258.063 117.488 256.247 117.226 256.247 115.66C256.247 114.093 257.284 113.57 260.138 113.57H272.33V105.211H259.36C251.318 105.211 245.87 109.128 245.87 115.918Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                fontSize: "50",
                fontFamily: "'Chivo',Arial,Helvetica,sans-serif",
                x: "25",
                y: "475",
                fill: thirdColor,
                children: codeMyCard
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "698.294",
                cy: "461.878",
                r: "50.5968",
                stroke: fourthColor,
                strokeWidth: "11"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "758.706",
                cy: "461.878",
                r: "50.5968",
                stroke: fourthColor,
                strokeWidth: "11"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M727.035 358.464L728.5 359.951L730.013 358.351C732.583 355.61 736.16 354.038 739.917 354.001C743.674 353.963 747.282 355.462 749.906 358.151L750.214 358.464C755.783 364.186 755.783 373.303 750.214 379.025L735.074 394.398C733.34 396.16 730.971 397.152 728.5 397.152C726.028 397.152 723.659 396.16 721.925 394.398L706.786 379.025C701.217 373.303 701.217 364.187 706.786 358.464C709.456 355.751 713.104 354.224 716.91 354.224C720.717 354.224 724.365 355.751 727.035 358.464Z",
                stroke: fourthColor,
                strokeWidth: "11",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ImagePhoneWhereToUse.tsx

var ImagePhoneWhereToUse = function(param) {
    var _width = param.width, width = _width === void 0 ? "456" : _width, _height = param.height, height = _height === void 0 ? "900" : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 456 900",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "456",
                height: "900",
                fill: "url(#pattern0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_335_1371",
                            transform: "matrix(0.00219298 0 0 0.00111111 -0.657895 -0.131111)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_335_1371",
                        width: "1500",
                        height: "1125",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/IndifferentFaceIcon.tsx


var IndifferentFaceIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de Avalia\xe7\xe3o - Indiferente" : _alt, _width = param.width, width = _width === void 0 ? 40 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.yellow.45 */.rS.colors.yellow[45] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.yellow.80 */.rS.colors.yellow[80] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 40 40",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "20",
                cy: "20",
                r: "19",
                fill: color,
                stroke: secondColor,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "13",
                y: "27.5",
                width: "13",
                height: "1",
                rx: "0.5",
                fill: color,
                stroke: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.49988 15.8642L11.6668 14.0358C12.6234 13.4835 13.8466 13.8112 14.3989 14.7678L16.2273 17.9347",
                stroke: secondColor,
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.5363 17.934L24.3647 14.7671C24.917 13.8105 26.1401 13.4828 27.0967 14.035L30.2637 15.8635",
                stroke: secondColor,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/InfoOutlineIcon.tsx


var InfoOutlineIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _alt = param.alt, alt = _alt === void 0 ? "Informativo" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 3V3C14.1425 3 17.5 6.3575 17.5 10.5V10.5C17.5 14.6425 14.1425 18 10 18V18C5.8575 18 2.5 14.6425 2.5 10.5V10.5C2.5 6.3575 5.8575 3 10 3Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.0002 10.9167V6.75",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.99933 13.8333C9.88433 13.8333 9.791 13.9267 9.79183 14.0417C9.79183 14.1567 9.88517 14.25 10.0002 14.25C10.1152 14.25 10.2085 14.1567 10.2085 14.0417C10.2085 13.9267 10.1152 13.8333 9.99933 13.8333",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Instagram.tsx


var Instagram = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.280 */.rS.colors.neutral[280] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.44737 0C2.44374 0 0 2.44374 0 5.44737V12.5526C0 15.5563 2.44374 18 5.44737 18H12.5526C15.5563 18 18 15.5563 18 12.5526V5.44737C18 2.44374 15.5563 0 12.5526 0H5.44737ZM13.7368 3.31579C14.2603 3.31579 14.6842 3.73974 14.6842 4.26316C14.6842 4.78611 14.2603 5.21053 13.7368 5.21053C13.2134 5.21053 12.7895 4.78611 12.7895 4.26316C12.7895 3.73974 13.2134 3.31579 13.7368 3.31579ZM9 4.26316C11.6119 4.26316 13.7368 6.38811 13.7368 9C13.7368 11.6119 11.6119 13.7368 9 13.7368C6.38811 13.7368 4.26316 11.6119 4.26316 9C4.26316 6.38811 6.38811 4.26316 9 4.26316ZM9 5.68421C8.56456 5.68421 8.13339 5.76998 7.7311 5.93661C7.32881 6.10324 6.96328 6.34748 6.65538 6.65538C6.34748 6.96328 6.10324 7.32881 5.93661 7.7311C5.76998 8.13339 5.68421 8.56456 5.68421 9C5.68421 9.43544 5.76998 9.86661 5.93661 10.2689C6.10324 10.6712 6.34748 11.0367 6.65538 11.3446C6.96328 11.6525 7.32881 11.8968 7.7311 12.0634C8.13339 12.23 8.56456 12.3158 9 12.3158C9.43544 12.3158 9.86661 12.23 10.2689 12.0634C10.6712 11.8968 11.0367 11.6525 11.3446 11.3446C11.6525 11.0367 11.8968 10.6712 12.0634 10.2689C12.23 9.86661 12.3158 9.43544 12.3158 9C12.3158 8.56456 12.23 8.13339 12.0634 7.7311C11.8968 7.32881 11.6525 6.96328 11.3446 6.65538C11.0367 6.34748 10.6712 6.10324 10.2689 5.93661C9.86661 5.76998 9.43544 5.68421 9 5.68421Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/InstagramIconFooter.tsx


var InstagramIconFooter = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xcdcone do instagram" : _alt, _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.280 */.rS.colors.neutral[280] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.44737 3C5.44374 3 3 5.44374 3 8.44737V15.5526C3 18.5563 5.44374 21 8.44737 21H15.5526C18.5563 21 21 18.5563 21 15.5526V8.44737C21 5.44374 18.5563 3 15.5526 3H8.44737ZM16.7368 6.31579C17.2603 6.31579 17.6842 6.73974 17.6842 7.26316C17.6842 7.78611 17.2603 8.21053 16.7368 8.21053C16.2134 8.21053 15.7895 7.78611 15.7895 7.26316C15.7895 6.73974 16.2134 6.31579 16.7368 6.31579ZM12 7.26316C14.6119 7.26316 16.7368 9.38811 16.7368 12C16.7368 14.6119 14.6119 16.7368 12 16.7368C9.38811 16.7368 7.26316 14.6119 7.26316 12C7.26316 9.38811 9.38811 7.26316 12 7.26316ZM12 8.68421C11.5646 8.68421 11.1334 8.76998 10.7311 8.93661C10.3288 9.10324 9.96328 9.34748 9.65538 9.65538C9.34748 9.96328 9.10324 10.3288 8.93661 10.7311C8.76998 11.1334 8.68421 11.5646 8.68421 12C8.68421 12.4354 8.76998 12.8666 8.93661 13.2689C9.10324 13.6712 9.34748 14.0367 9.65538 14.3446C9.96328 14.6525 10.3288 14.8968 10.7311 15.0634C11.1334 15.23 11.5646 15.3158 12 15.3158C12.4354 15.3158 12.8666 15.23 13.2689 15.0634C13.6712 14.8968 14.0367 14.6525 14.3446 14.3446C14.6525 14.0367 14.8968 13.6712 15.0634 13.2689C15.23 12.8666 15.3158 12.4354 15.3158 12C15.3158 11.5646 15.23 11.1334 15.0634 10.7311C14.8968 10.3288 14.6525 9.96328 14.3446 9.65538C14.0367 9.34748 13.6712 9.10324 13.2689 8.93661C12.8666 8.76998 12.4354 8.68421 12 8.68421Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Interrogation.tsx


var Interrogation = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.tertiary.115 */.rS.colors.tertiary[115] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1125_1157)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM6.12904 4.01215C5.89628 3.97223 5.6569 4.01597 5.4533 4.13563C5.2497 4.25529 5.09502 4.44314 5.01665 4.66592C4.92501 4.92641 4.63956 5.0633 4.37906 4.97166C4.11857 4.88003 3.98168 4.59457 4.07332 4.33407C4.23005 3.88852 4.53942 3.51281 4.94662 3.27349C5.35382 3.03418 5.83258 2.9467 6.2981 3.02655C6.76362 3.1064 7.18586 3.34842 7.49003 3.70976C7.79415 4.07102 7.96062 4.52823 7.95998 5.00045C7.95976 5.76563 7.39245 6.27094 6.98733 6.54102C6.76952 6.68623 6.55526 6.793 6.39743 6.86315C6.3178 6.89854 6.25075 6.9254 6.20243 6.9438C6.17823 6.95302 6.15862 6.96016 6.14433 6.96524L6.12697 6.97132L6.12144 6.97321L6.11949 6.97387L6.11872 6.97413C6.11872 6.97413 6.1181 6.97434 5.95998 6.49999L6.1181 6.97434C5.85612 7.06166 5.57297 6.92008 5.48564 6.65811C5.39838 6.39631 5.53971 6.11335 5.80135 6.02583L5.80932 6.02303C5.81701 6.02029 5.82962 6.01572 5.84644 6.00931C5.88015 5.99647 5.93029 5.97645 5.99129 5.94934C6.11471 5.89449 6.27545 5.81376 6.43263 5.70897C6.77743 5.4791 6.95998 5.23456 6.95998 4.99999L6.95998 4.99925C6.96034 4.76309 6.8771 4.53443 6.72501 4.35376C6.57292 4.17309 6.3618 4.05208 6.12904 4.01215ZM5.49998 8.49999C5.49998 8.22385 5.72384 7.99999 5.99998 7.99999H6.00498C6.28113 7.99999 6.50498 8.22385 6.50498 8.49999C6.50498 8.77614 6.28113 8.99999 6.00498 8.99999H5.99998C5.72384 8.99999 5.49998 8.77614 5.49998 8.49999Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1125_1157",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: width,
                        height: height,
                        fill: secondColor
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/InvoicedTrackingStatusIcon.tsx


var InvoicedTrackingStatusIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Faturado" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.8315 17.4704H10.1642C9.24333 17.4704 8.49683 16.7238 8.49683 15.803V10.8009C8.49683 9.88005 9.24333 9.13354 10.1642 9.13354H21.8357C22.7566 9.13354 23.5031 9.88005 23.5031 10.8009V15.803C23.5031 16.7238 22.7566 17.4704 21.8357 17.4704H20.1684",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.1683 13.302H11.8315V22.0783C11.8314 22.404 11.9607 22.7164 12.191 22.9467C12.4213 23.177 12.6742 23.5003 12.9999 23.5002L13.9999 22.5002L14.9999 23.5002L16.4999 22.5002L17.4999 23.5002L18.4999 22.5002C18.8256 22.5003 19.5786 23.177 19.8089 22.9467C20.0392 22.7164 20.1685 22.404 20.1683 22.0783V13.302Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 19.5H16",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.7495 17.4168H17.2506",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 15.5H18",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Jcb.tsx


var Jcb = function(param) {
    var _width = param.width, width = _width === void 0 ? 65 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _alt = param.alt, alt = _alt === void 0 ? "Jcb" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.secondary.650 */.rS.colors.secondary[650] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.tertiary.850 */.rS.colors.tertiary[850] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.primary.750 */.rS.colors.primary[750] : _fourthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 36 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.5184 22.3556C35.5184 25.4667 33.0434 28 30.0039 28H0V5.64444C0 2.53333 2.475 0 5.51447 0H35.5184V22.3556Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7485 16.6223H28.0281C28.0933 16.6223 28.2452 16.6001 28.3104 16.6001C28.7446 16.5112 29.1137 16.1112 29.1137 15.5557C29.1137 15.0223 28.7446 14.6223 28.3104 14.5112C28.2452 14.489 28.115 14.489 28.0281 14.489H25.7485V16.6223Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.7677 1.88879C25.5967 1.88879 23.8164 3.68879 23.8164 5.93324V10.1332H29.396C29.5263 10.1332 29.6782 10.1332 29.7868 10.1555C31.046 10.2221 31.9795 10.8888 31.9795 12.0443C31.9795 12.9555 31.3499 13.7332 30.1776 13.8888V13.9332C31.4585 14.0221 32.4355 14.7555 32.4355 15.8888C32.4355 17.111 31.3499 17.911 29.917 17.911H23.7947V26.1332H29.5914C31.7624 26.1332 33.5427 24.3332 33.5427 22.0888V1.88879H27.7677Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.8314 12.311C28.8314 11.7777 28.4624 11.4221 28.0281 11.3555C27.9847 11.3555 27.8762 11.3333 27.811 11.3333H25.7485V13.2888H27.811C27.8762 13.2888 28.0064 13.2888 28.0281 13.2666C28.4624 13.1999 28.8314 12.8444 28.8314 12.311Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.92688 1.88879C3.75583 1.88879 1.97557 3.68879 1.97557 5.93324V15.911C3.0828 16.4666 4.23346 16.8221 5.38412 16.8221C6.75188 16.8221 7.49004 15.9777 7.49004 14.8221V10.111H10.8769V14.7999C10.8769 16.6221 9.76965 18.111 6.01373 18.111C3.73412 18.111 1.95386 17.5999 1.95386 17.5999V26.111H7.75057C9.92162 26.111 11.7019 24.311 11.7019 22.0666V1.88879H5.92688Z",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.8473 1.88879C14.6763 1.88879 12.896 3.68879 12.896 5.93324V11.2221C13.8947 10.3555 15.6315 9.79991 18.4322 9.93324C19.9302 9.99991 21.5368 10.4221 21.5368 10.4221V12.1332C20.7335 11.711 19.7782 11.3332 18.5407 11.2443C16.4131 11.0888 15.1322 12.1555 15.1322 14.0221C15.1322 15.911 16.4131 16.9777 18.5407 16.7999C19.7782 16.711 20.7335 16.311 21.5368 15.911V17.6221C21.5368 17.6221 19.9519 18.0444 18.4322 18.111C15.6315 18.2444 13.8947 17.6888 12.896 16.8221V26.1555H18.6927C20.8638 26.1555 22.644 24.3555 22.644 22.111V1.88879H16.8473Z",
                fill: fourthColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/LinkedIn.tsx


var LinkedIn = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.280 */.rS.colors.neutral[280] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.3636 0H1.63636C0.732273 0 0 0.732273 0 1.63636V16.3636C0 17.2677 0.732273 18 1.63636 18H16.3636C17.2677 18 18 17.2677 18 16.3636V1.63636C18 0.732273 17.2677 0 16.3636 0ZM5.68964 14.7273H3.276V6.96109H5.68964V14.7273ZM4.45827 5.85082C3.68018 5.85082 3.051 5.22 3.051 4.44355C3.051 3.66709 3.681 3.03709 4.45827 3.03709C5.23391 3.03709 5.86473 3.66791 5.86473 4.44355C5.86473 5.22 5.23391 5.85082 4.45827 5.85082ZM14.7305 14.7273H12.3185V10.9505C12.3185 10.0497 12.3022 8.89118 11.0643 8.89118C9.80836 8.89118 9.61527 9.87218 9.61527 10.8851V14.7273H7.20327V6.96109H9.51873V8.02227H9.55145C9.87382 7.41191 10.6609 6.768 11.835 6.768C14.2789 6.768 14.7305 8.37655 14.7305 10.4678V14.7273Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/LinkedinIconFooter.tsx


var LinkedinIconFooter = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone do Linkedin" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.280 */.rS.colors.neutral[280] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M19.3636 3H4.63636C3.73227 3 3 3.73227 3 4.63636V19.3636C3 20.2677 3.73227 21 4.63636 21H19.3636C20.2677 21 21 20.2677 21 19.3636V4.63636C21 3.73227 20.2677 3 19.3636 3ZM8.68964 17.7273H6.276V9.96109H8.68964V17.7273ZM7.45827 8.85082C6.68018 8.85082 6.051 8.22 6.051 7.44355C6.051 6.66709 6.681 6.03709 7.45827 6.03709C8.23391 6.03709 8.86473 6.66791 8.86473 7.44355C8.86473 8.22 8.23391 8.85082 7.45827 8.85082ZM17.7305 17.7273H15.3185V13.9505C15.3185 13.0497 15.3022 11.8912 14.0643 11.8912C12.8084 11.8912 12.6153 12.8722 12.6153 13.8851V17.7273H10.2033V9.96109H12.5187V11.0223H12.5515C12.8738 10.4119 13.6609 9.768 14.835 9.768C17.2789 9.768 17.7305 11.3765 17.7305 13.4678V17.7273Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Lock.tsx


var Lock = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 30 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 28 30",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.244.75c4.673 0 8.483 3.52 8.483 7.862v2.507c1.762.486 3.011 2.12 3.011 3.998v9.986c0 2.286-1.829 4.147-4.08 4.147H6.83c-2.252 0-4.081-1.86-4.081-4.146v-9.986c0-1.879 1.25-3.513 3.011-3.999V8.612c0-4.341 3.81-7.862 8.483-7.862ZM6.831 12.695c-1.254 0-2.286.997-2.37 2.256l-.005.166v9.986c0 1.281.98 2.332 2.212 2.417l.163.006h14.827c1.253 0 2.285-.998 2.369-2.257l.005-.166v-9.986c0-1.336-1.067-2.422-2.374-2.422H6.83Zm9.873 4.86c0-1.376-1.102-2.496-2.46-2.496-1.358 0-2.46 1.12-2.46 2.496v3.066c0 1.376 1.102 2.497 2.46 2.497 1.358 0 2.46-1.12 2.46-2.497v-3.066Zm-2.46-.772c-.38 0-.697.29-.747.667l-.007.105v3.066c0 .427.34.772.754.772.38 0 .697-.29.747-.667l.007-.105v-3.066a.764.764 0 0 0-.754-.772Zm0-14.309c-3.66 0-6.644 2.64-6.772 5.919l-.004.22v2.56H21.02v-2.56c0-3.38-3.035-6.139-6.777-6.139Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "a",
                maskUnits: "userSpaceOnUse",
                x: 2,
                y: 0,
                width: width,
                height: height,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.244.75c4.673 0 8.483 3.52 8.483 7.862v2.507c1.762.486 3.011 2.12 3.011 3.998v9.986c0 2.286-1.829 4.147-4.08 4.147H6.83c-2.252 0-4.081-1.86-4.081-4.146v-9.986c0-1.879 1.25-3.513 3.011-3.999V8.612c0-4.341 3.81-7.862 8.483-7.862ZM6.831 12.695c-1.254 0-2.286.997-2.37 2.256l-.005.166v9.986c0 1.281.98 2.332 2.212 2.417l.163.006h14.827c1.253 0 2.285-.998 2.369-2.257l.005-.166v-9.986c0-1.336-1.067-2.422-2.374-2.422H6.83Zm9.873 4.86c0-1.376-1.102-2.496-2.46-2.496-1.358 0-2.46 1.12-2.46 2.496v3.066c0 1.376 1.102 2.497 2.46 2.497 1.358 0 2.46-1.12 2.46-2.497v-3.066Zm-2.46-.772c-.38 0-.697.29-.747.667l-.007.105v3.066c0 .427.34.772.754.772.38 0 .697-.29.747-.667l.007-.105v-3.066a.764.764 0 0 0-.754-.772Zm0-14.309c-3.66 0-6.644 2.64-6.772 5.919l-.004.22v2.56H21.02v-2.56c0-3.38-3.035-6.139-6.777-6.139Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0 1h28v28H0z"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/LockIcon.tsx


var LockIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Cadeado" : _alt, _width = param.width, width = _width === void 0 ? 33 : _width, _height = param.height, height = _height === void 0 ? 43.3 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, strokeWidth = param.strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 79 79",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.3333 32.9167V23.0417V23.0417C26.3333 15.7704 32.2286 9.875 39.4999 9.875V9.875C46.7712 9.875 52.6666 15.7704 52.6666 23.0417V23.0417V32.9167",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M55.9583 69.1248H23.0416C19.4043 69.1248 16.4583 66.1788 16.4583 62.5415V39.4998C16.4583 35.8625 19.4043 32.9165 23.0416 32.9165H55.9583C59.5955 32.9165 62.5416 35.8625 62.5416 39.4998V62.5415C62.5416 66.1788 59.5955 69.1248 55.9583 69.1248Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40.5 51C40.5 53.46 40.278 55.6719 39.9261 57.2555C39.7493 58.0513 39.5454 58.6613 39.3359 59.0602C39.2308 59.2601 39.1369 59.3826 39.0644 59.4493C39.0328 59.4784 39.0115 59.4915 39 59.4972C38.9885 59.4915 38.9672 59.4784 38.9356 59.4493C38.8631 59.3826 38.7692 59.2601 38.6641 59.0602C38.4546 58.6613 38.2507 58.0513 38.0739 57.2555C37.722 55.6719 37.5 53.46 37.5 51C37.5 48.54 37.722 46.3281 38.0739 44.7445C38.2507 43.9487 38.4546 43.3387 38.6641 42.9398C38.7692 42.7399 38.8631 42.6174 38.9356 42.5507C38.9672 42.5216 38.9885 42.5085 39 42.5028C39.0115 42.5085 39.0328 42.5216 39.0644 42.5507C39.1369 42.6174 39.2308 42.7399 39.3359 42.9398C39.5454 43.3387 39.7493 43.9487 39.9261 44.7445C40.278 46.3281 40.5 48.54 40.5 51ZM38.9896 59.5012C38.9896 59.5011 38.9905 59.5008 38.9922 59.5005C38.9905 59.5011 38.9896 59.5013 38.9896 59.5012ZM39.0078 59.5005C39.0095 59.5008 39.0104 59.5011 39.0104 59.5012C39.0104 59.5013 39.0095 59.5011 39.0078 59.5005ZM39.0104 42.4988C39.0104 42.4989 39.0095 42.4992 39.0078 42.4995C39.0095 42.4989 39.0104 42.4987 39.0104 42.4988ZM38.9922 42.4995C38.9905 42.4992 38.9896 42.4989 38.9896 42.4988C38.9896 42.4987 38.9905 42.4989 38.9922 42.4995Z",
                stroke: color,
                strokeWidth: strokeWidth
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/LogoFCBlack.tsx


var LogoFCBlack = function(param) {
    var _width = param.width, width = _width === void 0 ? 182 : _width, _height = param.height, height = _height === void 0 ? 70 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.primary.150 */.rS.colors.primary[150] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 182 70",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M65.619 9.95207C66.9748 9.95207 68.1798 10.2534 69.0817 11.0065C70.7343 10.2535 72.5386 9.89265 74.3537 9.95207H79.1738V12.061C81.5348 10.346 84.3903 9.44706 87.3079 9.50027C91.3749 9.50027 94.6868 11.157 96.7973 13.8699V11.4583C96.1835 10.4637 95.8698 9.31303 95.8937 8.14446C95.8946 4.37918 98.908 1.51709 102.975 1.51709C107.042 1.51709 110.055 4.2283 110.055 8.14487C110.028 8.7574 109.927 9.36439 109.753 9.95248H112.615C113.875 9.93554 115.101 10.3621 116.078 11.1574C117.719 10.3536 119.523 9.9412 121.35 9.95248H131.291C139.425 9.95248 143.944 14.17 143.944 22.0027V25.6179H146.204V32.9968H154.489V38.27H166.088C174.222 38.27 178.741 42.6396 178.741 50.3202V54.2363H181V65.383H172.866C171.697 65.4069 170.547 65.0932 169.552 64.4794C168.196 65.2325 166.539 65.383 164.431 65.383H152.983C148.916 65.383 145.903 64.0271 143.945 61.6173C142.891 63.274 141.083 64.3285 138.975 65.08C138.893 65.0696 138.809 65.0777 138.731 65.1037C138.652 65.1298 138.581 65.1731 138.521 65.2304C138.371 65.2304 138.068 65.3809 137.919 65.3809H137.465C134.815 65.8783 132.087 65.7753 129.482 65.0796C128.708 64.8968 127.952 64.6448 127.223 64.3264C127.072 64.3264 127.072 64.3264 126.921 64.176C126.771 64.176 126.771 64.0255 126.62 64.0255C126.6 64.0259 126.58 64.0223 126.562 64.0148C126.543 64.0074 126.527 63.9964 126.513 63.9823C126.499 63.9683 126.488 63.9515 126.48 63.9331C126.473 63.9146 126.469 63.8949 126.469 63.875C125.355 63.4458 124.294 62.8899 123.306 62.2183C120.754 64.412 117.484 65.5914 114.118 65.5322C110.488 65.6029 106.975 64.2515 104.327 61.7665V64.629L102.821 65.5326C99.206 67.9425 95.7416 68.9953 91.6746 68.9953C81.2811 68.9953 73.9006 61.7653 73.9006 51.5227C73.9006 45.0458 76.7627 39.7742 81.2795 36.7612H36.0962C28.8661 36.7612 23.4433 32.2424 22.3892 25.6146H16.8159V36.7625H3.86209V14.17H1V2.42069H28.113V11.6092C30.3201 10.2145 32.8811 9.48259 35.4918 9.50027C39.2575 9.50027 42.4205 10.8561 44.5295 13.4164V9.95372H50.1028C51.4586 9.95372 52.6635 10.2551 53.5655 11.0082C55.2181 10.2552 57.0224 9.8943 58.8375 9.95372L65.619 9.95207Z",
                fill: secondColor,
                stroke: color,
                strokeWidth: "1.33177"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M102.824 11.4587C105.083 11.4587 106.59 10.1029 106.59 7.99602C106.59 6.03794 105.083 4.68213 102.824 4.68213C100.565 4.68213 99.0583 6.03629 99.0583 7.99437C99.2088 10.2538 100.715 11.4587 102.824 11.4587Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.2677 15.3746C52.9664 14.0188 51.7615 13.2657 50.4057 13.2657H48.1462V33.6004H54.3218V22.4542C54.3218 19.2912 56.4308 17.9354 59.2924 17.9354H60.6482V13.1152H59.142C56.432 13.1152 54.3218 14.0188 53.2677 15.3746Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M116.381 22.4542C116.381 19.2912 118.49 17.9354 121.351 17.9354H122.707V13.1152H121.201C118.49 13.1152 116.532 14.0188 115.326 15.3746C115.025 14.0188 113.82 13.2657 112.464 13.2657H110.205V33.6004H116.381V22.4542Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.6444 12.6636C29.6193 12.6636 25.5522 17.0332 25.5522 23.358C25.5522 29.3831 29.7697 33.9019 36.2466 33.9019C39.2592 33.9019 41.8199 33.2992 43.6255 31.9438V27.1237C41.5186 28.3282 39.4101 28.7816 36.8473 28.7816C33.9852 28.7816 32.0271 27.2754 31.4248 24.7146H44.3807V22.3039C44.3807 16.5797 41.0668 12.6636 35.6444 12.6636ZM31.5774 20.4959C32.18 18.5378 33.5354 17.3329 35.6444 17.3329C37.452 17.3329 38.6569 18.5378 38.9583 20.4959H31.5774Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M68.4811 15.3746C68.1798 14.0188 66.9748 13.2657 65.619 13.2657H63.3596V33.6004H69.5352V22.4542C69.5352 19.2912 71.6441 17.9354 74.5058 17.9354H75.8616V13.1152H74.3554C71.6454 13.1152 69.6861 14.0188 68.4811 15.3746Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M103.577 13.2656H99.9622V33.6004H106.138V15.9768C106.289 14.3201 105.234 13.2656 103.577 13.2656Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.31372 11.0064H5.97046C6.87406 11.0064 7.1754 11.3078 7.1754 12.2114V34.0528H13.6527V22.9062H22.9917V17.6342H13.6527V11.0064H24.9477V5.58398H4.31372V11.0064Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M140.631 27.7258V21.7007C140.631 15.9769 137.769 12.9644 131.292 12.9644H125.268V17.7845H130.538C133.249 17.7845 134.605 18.6881 134.755 21.0984H132.947C126.774 21.0984 123.159 22.9056 123.159 27.7258C123.159 31.4915 125.719 33.9013 129.786 33.9013C132.347 33.9013 133.853 32.8469 135.209 31.3406C135.812 32.6964 136.866 33.4495 138.221 33.4495H143.042V28.9307H141.837C141.675 28.9456 141.511 28.9247 141.358 28.8694C141.205 28.8141 141.067 28.7258 140.952 28.6108C140.836 28.4958 140.748 28.3569 140.693 28.204C140.637 28.051 140.616 27.8878 140.631 27.7258ZM130.841 29.3829C130.573 29.3935 130.307 29.3512 130.056 29.2584C129.805 29.1656 129.575 29.0242 129.379 28.8422C129.183 28.6603 129.025 28.4414 128.914 28.1982C128.803 27.9549 128.741 27.6921 128.732 27.4249C128.732 25.6172 129.937 25.015 132.799 25.015H134.606C134.606 27.5753 133.1 29.3829 130.841 29.3829Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M87.7615 33.9019C90.774 33.9019 93.3348 33.2992 95.2928 31.9438V27.1237C93.1839 28.3286 90.9232 28.7804 88.3641 28.7804C85.502 28.7804 83.544 27.2741 83.0922 24.7134H95.8955C96.0881 23.8732 96.1891 23.0146 96.1969 22.1526C96.1964 16.4288 92.8821 12.5127 87.3097 12.5127C81.2846 12.5127 77.2175 16.8823 77.2175 23.2071C77.2175 29.3831 81.2846 33.9019 87.7615 33.9019ZM87.1588 17.3329C88.9664 17.3329 90.3218 18.5378 90.4727 20.4959H83.2426C83.8453 18.5378 85.0498 17.3329 87.1588 17.3329Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M83.8453 51.9769C83.8453 46.5545 87.4605 43.542 92.1311 43.542C95.2941 43.542 97.8548 44.4456 100.566 46.2532V40.529C97.782 38.7374 94.5365 37.7953 91.2258 37.8178C82.7908 37.8178 77.2175 43.6924 77.2175 52.1274C77.2175 60.5624 83.0922 66.2866 91.6776 66.2866C95.0131 66.3311 98.2788 65.3303 101.017 63.4245V57.5498C98.0041 59.5079 95.142 60.4119 92.1294 60.4119C87.4601 60.2615 83.8453 57.2489 83.8453 51.9769Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M151.176 36.312H144.849V54.5378C144.849 59.9602 148.312 62.0692 152.983 62.0692H155.996V57.0985H153.737C152.08 57.0985 151.025 56.1949 151.025 54.086V46.4041H157.051V41.584H151.025L151.175 36.312H151.176Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M176.782 57.5504C175.878 57.5504 175.577 57.0969 175.577 56.3454V50.4712C175.577 44.5965 172.715 41.584 166.238 41.584H159.912V46.4042H165.634C168.345 46.4042 169.701 47.3078 169.851 49.718H167.893C161.718 49.718 158.255 51.5252 158.255 56.3454C158.255 60.1111 160.665 62.521 164.732 62.521C167.293 62.521 168.949 61.316 170.305 59.9602C170.479 60.5802 170.856 61.1242 171.374 61.5062C171.892 61.8882 172.523 62.0863 173.167 62.0692H177.987V57.5504H176.782ZM165.786 57.8517C164.43 57.8517 163.527 57.0985 163.527 56.0441C163.527 54.2365 164.732 53.4833 167.744 53.4833H169.55C169.55 56.0441 168.046 57.8517 165.786 57.8517Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M114.121 41.2822C107.945 41.2822 103.276 45.8011 103.276 51.9766C103.276 58.0017 107.945 62.5206 114.121 62.5206C120.297 62.5206 124.816 57.8513 124.816 51.8262C124.816 45.8011 120.297 41.2822 114.121 41.2822ZM114.121 57.4003C111.41 57.4003 109.602 55.2913 109.602 51.9779C109.602 48.5152 111.41 46.5554 114.121 46.5554C116.832 46.5554 118.491 48.5135 118.491 51.9779C118.489 55.2905 116.832 57.4003 114.121 57.4003Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M126.924 47.6087C126.924 50.4708 128.431 51.9783 132.046 53.4833C134.908 54.6883 135.962 55.2909 135.962 56.1945C135.962 57.249 135.359 57.3995 134.004 57.3995C131.493 57.4612 129.007 56.8915 126.774 55.7427V60.5629C128.431 61.6174 131.594 62.3705 134.606 62.3705C139.125 62.3705 142.288 59.8098 142.288 56.0441C142.288 52.2784 139.427 50.9226 136.565 49.7189C134.004 48.5139 132.949 48.363 132.949 47.4594C132.949 46.5558 133.552 46.2545 135.209 46.2545H142.288V41.4331H134.757C130.088 41.4331 126.924 43.6925 126.924 47.6087Z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/LogoFerreiraCosta.tsx


var LogoFerreiraCosta = function(param) {
    var _width = param.width, width = _width === void 0 ? "272" : _width, _height = param.height, height = _height === void 0 ? "102" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.150 */.rS.colors.primary[150] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 272 102",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M97.6465 12.7503C99.6953 12.7503 101.516 13.2058 102.879 14.3443C105.376 13.206 108.103 12.6605 110.846 12.7503H118.129V15.9382C121.697 13.3458 126.012 11.9869 130.421 12.0674C136.567 12.0674 141.571 14.5717 144.76 18.6725V15.0272C143.833 13.5237 143.359 11.7843 143.395 10.0179C143.396 4.32633 147.95 0 154.096 0C160.241 0 164.794 4.09827 164.794 10.0185C164.753 10.9444 164.6 11.862 164.338 12.7509H168.663C170.567 12.7253 172.419 13.37 173.896 14.5723C176.375 13.3573 179.102 12.7339 181.862 12.7509H196.885C209.176 12.7509 216.004 19.1261 216.004 30.966V36.4308H219.419V47.5847H231.939V55.5556H249.466C261.757 55.5556 268.586 62.1607 268.586 73.7707V79.6904H272V96.5396H259.709C257.943 96.5758 256.204 96.1016 254.701 95.1737C252.652 96.3121 250.149 96.5396 246.962 96.5396H229.663C223.517 96.5396 218.965 94.4901 216.006 90.8474C214.413 93.3517 211.681 94.9456 208.495 96.0816C208.371 96.0659 208.245 96.0781 208.127 96.1175C208.008 96.1569 207.9 96.2223 207.81 96.309C207.583 96.309 207.125 96.5365 206.899 96.5365H206.214C202.209 97.2884 198.087 97.1327 194.151 96.081C192.981 95.8047 191.838 95.4237 190.736 94.9425C190.509 94.9425 190.509 94.9425 190.281 94.7151C190.054 94.7151 190.054 94.4876 189.826 94.4876C189.796 94.4882 189.766 94.4828 189.738 94.4715C189.71 94.4603 189.685 94.4436 189.663 94.4223C189.642 94.4011 189.626 94.3758 189.614 94.3479C189.603 94.3201 189.598 94.2902 189.598 94.2602C187.914 93.6114 186.311 92.7711 184.819 91.7559C180.961 95.0719 176.02 96.8546 170.934 96.7652C165.449 96.8721 160.139 94.8292 156.139 91.0729V95.3999L153.863 96.7658C148.4 100.409 143.165 102 137.019 102C121.314 102 110.161 91.0711 110.161 75.5884C110.161 65.7979 114.486 57.8294 121.311 53.275H53.0342C42.1088 53.275 33.9143 46.4444 32.3215 36.4258H23.8996V53.2769H4.32494V19.1261H0V1.36588H40.9707V15.2553C44.3059 13.1471 48.1758 12.0406 52.121 12.0674C57.8114 12.0674 62.591 14.1168 65.7779 17.987V12.7528H74.1998C76.2486 12.7528 78.0694 13.2083 79.4323 14.3467C81.9296 13.2085 84.656 12.663 87.3988 12.7528L97.6465 12.7503Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M153.868 15.0277C157.282 15.0277 159.558 12.9782 159.558 9.79345C159.558 6.83363 157.282 4.78418 153.868 4.78418C150.453 4.78418 148.177 6.83113 148.177 9.79096C148.405 13.2063 150.681 15.0277 153.868 15.0277Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M78.9826 20.9476C78.5272 18.8981 76.7064 17.7597 74.6576 17.7597H71.2434V48.4976H80.5754V31.649C80.5754 26.8678 83.7622 24.8184 88.0866 24.8184H90.1353V17.5322H87.8592C83.7641 17.5322 80.5754 18.8981 78.9826 20.9476Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M174.353 31.649C174.353 26.8678 177.54 24.8184 181.864 24.8184H183.913V17.5322H181.637C177.54 17.5322 174.581 18.8981 172.76 20.9476C172.304 18.8981 170.483 17.7597 168.435 17.7597H165.021V48.4976H174.353V31.649Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M52.3514 16.8496C43.2468 16.8496 37.1011 23.4547 37.1011 33.0152C37.1011 42.1228 43.4742 48.9534 53.2615 48.9534C57.8138 48.9534 61.6834 48.0424 64.4118 45.9936V38.7075C61.228 40.5282 58.0418 41.2137 54.1691 41.2137C49.8442 41.2137 46.8853 38.9368 45.9752 35.0659H65.553V31.4219C65.553 22.7693 60.5453 16.8496 52.3514 16.8496ZM46.2057 28.6889C47.1164 25.7291 49.1645 23.9077 52.3514 23.9077C55.0829 23.9077 56.9037 25.7291 57.3591 28.6889H46.2057Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M101.971 20.9476C101.516 18.8981 99.6952 17.7597 97.6464 17.7597H94.2322V48.4976H103.564V31.649C103.564 26.8678 106.751 24.8184 111.075 24.8184H113.124V17.5322H110.848C106.753 17.5322 103.792 18.8981 101.971 20.9476Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M155.005 17.7598H149.542V48.4977H158.874V21.858C159.102 19.3537 157.509 17.7598 155.005 17.7598Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00757 14.344H7.51109C8.87653 14.344 9.33188 14.7995 9.33188 16.1654V49.1809H19.1198V32.3316H33.2321V24.3625H19.1198V14.344H36.1878V6.14746H5.00757V14.344Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M210.999 39.6171V30.5095C210.999 21.8575 206.674 17.3037 196.886 17.3037H187.782V24.5899H195.746C199.843 24.5899 201.891 25.9558 202.119 29.5991H199.387C190.058 29.5991 184.595 32.3309 184.595 39.6171C184.595 45.3093 188.465 48.9521 194.611 48.9521C198.48 48.9521 200.757 47.3581 202.805 45.0812C203.715 47.1307 205.308 48.2691 207.357 48.2691H214.641V41.4385H212.82C212.575 41.461 212.328 41.4293 212.097 41.3458C211.866 41.2622 211.656 41.1288 211.482 40.9549C211.309 40.7811 211.175 40.5711 211.091 40.3399C211.008 40.1087 210.976 39.8619 210.999 39.6171ZM196.204 42.122C195.8 42.138 195.397 42.0741 195.018 41.9338C194.639 41.7935 194.291 41.5797 193.995 41.3047C193.699 41.0297 193.46 40.6988 193.292 40.3311C193.124 39.9634 193.031 39.5662 193.017 39.1622C193.017 36.4298 194.838 35.5194 199.162 35.5194H201.894C201.894 39.3896 199.618 42.122 196.204 42.122Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M131.106 48.953C135.658 48.953 139.528 48.042 142.487 45.9932V38.707C139.3 40.5284 135.884 41.2113 132.017 41.2113C127.692 41.2113 124.733 38.9345 124.05 35.0636H143.397C143.688 33.7936 143.841 32.4957 143.853 31.1928C143.852 22.5407 138.844 16.6211 130.423 16.6211C121.319 16.6211 115.173 23.2262 115.173 32.7867C115.173 42.1223 121.319 48.953 131.106 48.953ZM130.195 23.9073C132.927 23.9073 134.975 25.7286 135.203 28.6885H124.277C125.188 25.7286 127.008 23.9073 130.195 23.9073Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M125.188 76.2756C125.188 68.0791 130.651 63.5253 137.709 63.5253C142.489 63.5253 146.358 64.8912 150.455 67.6236V58.9709C146.248 56.2627 141.344 54.8386 136.341 54.8727C123.595 54.8727 115.173 63.7528 115.173 76.5031C115.173 89.2534 124.05 97.9061 137.024 97.9061C142.064 97.9734 146.999 96.4605 151.136 93.5797V84.6996C146.584 87.6595 142.259 89.026 137.706 89.026C130.651 88.7985 125.188 84.2447 125.188 76.2756Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M226.932 52.5957H217.372V80.1458C217.372 88.3423 222.605 91.5302 229.664 91.5302H234.216V84.0166H230.802C228.298 84.0166 226.705 82.6507 226.705 79.4628V67.851H235.811V60.5648H226.704L226.932 52.5957H226.932Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M265.626 84.6992C264.261 84.6992 263.806 84.0138 263.806 82.8778V73.9983C263.806 65.1182 259.481 60.5645 249.693 60.5645H240.133V67.8506H248.78C252.877 67.8506 254.926 69.2165 255.153 72.8599H252.194C242.862 72.8599 237.63 75.5917 237.63 82.8778C237.63 88.57 241.271 92.2128 247.417 92.2128C251.287 92.2128 253.79 90.3914 255.839 88.342C256.102 89.279 256.671 90.1014 257.454 90.6789C258.238 91.2563 259.191 91.5558 260.164 91.5299H267.448V84.6992H265.626ZM249.011 85.1547C246.962 85.1547 245.596 84.0163 245.596 82.4223C245.596 79.6899 247.417 78.5515 251.97 78.5515H254.698C254.698 82.4223 252.425 85.1547 249.011 85.1547Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M170.939 60.1094C161.606 60.1094 154.55 66.94 154.55 76.275C154.55 85.3826 161.606 92.2132 170.939 92.2132C180.271 92.2132 187.099 85.1551 187.099 76.0476C187.099 66.94 180.271 60.1094 170.939 60.1094ZM170.939 84.4734C166.842 84.4734 164.11 81.2855 164.11 76.2769C164.11 71.0427 166.842 68.0803 170.939 68.0803C175.036 68.0803 177.542 71.0402 177.542 76.2769C177.539 81.2843 175.036 84.4734 170.939 84.4734Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M190.286 69.6729C190.286 73.9992 192.562 76.278 198.025 78.553C202.35 80.3744 203.943 81.2854 203.943 82.6512C203.943 84.2452 203.032 84.4726 200.984 84.4726C197.19 84.5659 193.433 83.7048 190.059 81.9683V89.2545C192.562 90.8484 197.342 91.9869 201.894 91.9869C208.723 91.9869 213.502 88.116 213.502 82.4238C213.502 76.7316 209.179 74.6821 204.854 72.8626C200.984 71.0412 199.391 70.8132 199.391 69.4473C199.391 68.0814 200.301 67.6259 202.805 67.6259H213.503V60.3379H202.122C195.066 60.3379 190.286 63.7532 190.286 69.6729Z",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Map.tsx


var Map = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 10.8333V10.8333C8.61917 10.8333 7.5 9.71408 7.5 8.33325V8.33325C7.5 6.95242 8.61917 5.83325 10 5.83325V5.83325C11.3808 5.83325 12.5 6.95242 12.5 8.33325V8.33325C12.5 9.71408 11.3808 10.8333 10 10.8333Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 17.5C10 17.5 4.16666 12.7083 4.16666 8.33333C4.16666 5.11167 6.77833 2.5 10 2.5C13.2217 2.5 15.8333 5.11167 15.8333 8.33333C15.8333 12.7083 10 17.5 10 17.5Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/MapPin.tsx


var MapPin = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 10 14",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 5.21277C0 7.10831 1.5607 9.95575 4.67102 13.8396C4.84234 14.0535 5.15766 14.0535 5.32898 13.8396C8.4393 9.95575 10 7.10831 10 5.21277C10 2.33384 7.76142 0 5 0C2.23858 0 0 2.33384 0 5.21277ZM3 5C3 6.10457 3.89543 7 5 7C6.10457 7 7 6.10457 7 5C7 3.89543 6.10457 3 5 3C3.89543 3 3 3.89543 3 5Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_1124_465",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: width,
                height: height,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 5.21277C0 7.10831 1.5607 9.95575 4.67102 13.8396C4.84234 14.0535 5.15766 14.0535 5.32898 13.8396C8.4393 9.95575 10 7.10831 10 5.21277C10 2.33384 7.76142 0 5 0C2.23858 0 0 2.33384 0 5.21277ZM3 5C3 6.10457 3.89543 7 5 7C6.10457 7 7 6.10457 7 5C7 3.89543 6.10457 3 5 3C3.89543 3 3 3.89543 3 5Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_1124_465)"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Mastercard.tsx


var Mastercard = function(param) {
    var _width = param.width, width = _width === void 0 ? 65 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _alt = param.alt, alt = _alt === void 0 ? "Mastercard" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.orange.400 */.rS.colors.orange[400] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.primary.700 */.rS.colors.primary[700] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.yellow.150 */.rS.colors.yellow[150] : _thirdColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 43 26",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1940_4380)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M27.1521 3.24288H16.8179V21.7584H27.1521V3.24288Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.4747 12.4999C17.4731 10.7167 17.8784 8.95655 18.6599 7.35262C19.4414 5.74869 20.5787 4.34306 21.9856 3.24214C20.2433 1.87673 18.1509 1.02761 15.9474 0.791818C13.744 0.556025 11.5185 0.943071 9.52528 1.90873C7.53205 2.87439 5.85153 4.37971 4.6758 6.2526C3.50007 8.1255 2.87659 10.2904 2.87659 12.4999C2.87659 14.7094 3.50007 16.8743 4.6758 18.7472C5.85153 20.6201 7.53205 22.1254 9.52528 23.0911C11.5185 24.0567 13.744 24.4438 15.9474 24.208C18.1509 23.9722 20.2433 23.1231 21.9856 21.7577C20.5787 20.6567 19.4414 19.2511 18.6599 17.6472C17.8784 16.0433 17.4731 14.2831 17.4747 12.4999Z",
                        fill: secondColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M41.0935 12.4999C41.0936 14.7093 40.4702 16.8742 39.2945 18.7471C38.1188 20.62 36.4384 22.1253 34.4452 23.091C32.452 24.0567 30.2265 24.4437 28.0231 24.208C25.8197 23.9722 23.7273 23.123 21.985 21.7576C23.3907 20.6556 24.5271 19.2497 25.3085 17.6461C26.0899 16.0424 26.4959 14.2828 26.4959 12.4999C26.4959 10.717 26.0899 8.95733 25.3085 7.35366C24.5271 5.74999 23.3907 4.34413 21.985 3.24209C23.7273 1.87669 25.8197 1.02756 28.0231 0.791771C30.2265 0.555981 32.452 0.943044 34.4452 1.90872C36.4384 2.87439 38.1188 4.3797 39.2945 6.2526C40.4702 8.12549 41.0936 10.2904 41.0935 12.4999Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M39.9667 19.7962V19.4172H40.12V19.3399H39.7296V19.4172H39.883V19.7962H39.9667ZM40.7247 19.7962V19.3392H40.6051L40.4674 19.6536L40.3297 19.3392H40.21V19.7962H40.2945V19.4515L40.4236 19.7487H40.5112L40.6403 19.4507V19.7962H40.7247Z",
                        fill: thirdColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1940_4380",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "43",
                        height: "26",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/MessagesIcon.tsx


var MessagesIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 33 : _height, _width = param.width, width = _width === void 0 ? 32 : _width, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de mensagem" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.4658 22.3623C27.4392 20.629 28.0005 18.6316 28.0005 16.501C28.0005 9.87298 22.6285 4.50098 16.0005 4.50098C9.37249 4.50098 4.00049 9.87298 4.00049 16.501C4.00049 23.129 9.37249 28.501 16.0005 28.501C18.1312 28.501 20.1285 27.9396 21.8618 26.9663L28.0005 28.501L26.4658 22.3623Z",
                stroke: color,
                strokeWidth: "1.5882",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.7646 16.9316C15.8953 16.801 16.106 16.801 16.2366 16.9316C16.3673 17.0623 16.3673 17.273 16.2366 17.4036C16.106 17.5343 15.8953 17.5343 15.7646 17.4036C15.6353 17.273 15.6353 17.0623 15.7646 16.9316",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.4311 16.9316C10.5618 16.801 10.7725 16.801 10.9031 16.9316C11.0338 17.0623 11.0338 17.273 10.9031 17.4036C10.7725 17.5343 10.5618 17.5343 10.4311 17.4036C10.3018 17.273 10.3018 17.0623 10.4311 16.9316",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0976 16.9316C21.2283 16.801 21.439 16.801 21.5696 16.9316C21.7003 17.0623 21.7003 17.273 21.5696 17.4036C21.439 17.5343 21.2283 17.5343 21.0976 17.4036C20.9683 17.273 20.9683 17.0623 21.0976 16.9316",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/MyListFingerOnPhone.tsx


var MyListFingerOnPhone = function(param) {
    var _width = param.width, width = _width === void 0 ? 110 : _width, _height = param.height, height = _height === void 0 ? 126 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.270 */.rS.colors.secondary[270] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.secondary.270 */.rS.colors.secondary[270] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _thirdColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M191.818 70.9396H411.868",
                stroke: color,
                strokeWidth: "13.6465"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M324.5 364.34H408.457",
                stroke: color,
                strokeWidth: "13.6465",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-3-inside-1_1808_327",
                fill: thirdColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M350.44 270.373C346.34 266.273 341.146 263.898 335.818 263.269C339.577 254.236 337.776 243.401 330.438 236.063C325.921 231.546 320.073 229.144 314.144 228.803C316.547 220.394 314.433 210.969 307.801 204.337C304.277 200.813 299.969 198.593 295.425 197.6L331.684 161.342C341.397 151.629 341.397 135.805 331.684 126.092C321.97 116.379 306.147 116.379 296.434 126.092L235.826 186.7L235.98 187.072C235.231 187.665 234.508 188.308 233.816 189L179.404 243.412C166.402 256.414 159.246 273.7 159.246 292.081C159.246 294.71 159.392 297.318 159.681 299.893L91.5065 368.068C89.3071 370.267 89.3071 373.833 91.5065 376.033C93.7059 378.232 97.2718 378.232 99.4712 376.033L145.113 330.391L171.828 303.676C168.053 285.383 173.25 265.593 187.419 251.425L187.272 251.26L216.255 222.276C216.65 222.039 217.022 221.751 217.36 221.412L304.587 134.186C309.861 128.911 318.425 128.911 323.699 134.186C328.974 139.46 328.974 148.024 323.699 153.298L257.547 219.45C255.327 221.671 255.301 225.299 257.547 227.544C259.767 229.765 263.395 229.79 265.641 227.544L280.732 212.453C285.981 207.204 294.545 207.204 299.819 212.479C305.094 217.753 305.094 226.317 299.819 231.591L280.603 250.808C278.383 253.028 278.357 256.656 280.603 258.902C282.848 261.148 286.451 261.148 288.697 258.902L303.371 244.228C308.645 238.953 317.209 238.953 322.484 244.228C327.758 249.502 327.758 258.066 322.484 263.34L303.553 282.271C301.333 284.491 301.307 288.119 303.553 290.365C305.799 292.611 309.401 292.611 311.647 290.365L323.423 278.588C328.698 273.314 337.262 273.314 342.536 278.588C347.811 283.863 347.811 292.427 342.536 297.701L288.124 352.113L287.96 351.965C273.983 365.942 254.537 371.189 236.454 367.706L226.961 377.199C226.961 377.199 226.961 377.199 226.961 377.199L163.799 440.361C161.6 442.56 161.6 446.126 163.799 448.325C165.998 450.524 169.564 450.524 171.763 448.325L240.181 379.907C242.579 380.156 245.004 380.283 247.448 380.283C265.829 380.283 283.115 373.127 296.117 360.124L322.478 333.764L322.333 333.62L350.385 305.568C360.098 295.855 360.098 280.032 350.385 270.319L350.44 270.373Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M350.44 270.373C346.34 266.273 341.146 263.898 335.818 263.269C339.577 254.236 337.776 243.401 330.438 236.063C325.921 231.546 320.073 229.144 314.144 228.803C316.547 220.394 314.433 210.969 307.801 204.337C304.277 200.813 299.969 198.593 295.425 197.6L331.684 161.342C341.397 151.629 341.397 135.805 331.684 126.092C321.97 116.379 306.147 116.379 296.434 126.092L235.826 186.7L235.98 187.072C235.231 187.665 234.508 188.308 233.816 189L179.404 243.412C166.402 256.414 159.246 273.7 159.246 292.081C159.246 294.71 159.392 297.318 159.681 299.893L91.5065 368.068C89.3071 370.267 89.3071 373.833 91.5065 376.033C93.7059 378.232 97.2718 378.232 99.4712 376.033L145.113 330.391L171.828 303.676C168.053 285.383 173.25 265.593 187.419 251.425L187.272 251.26L216.255 222.276C216.65 222.039 217.022 221.751 217.36 221.412L304.587 134.186C309.861 128.911 318.425 128.911 323.699 134.186C328.974 139.46 328.974 148.024 323.699 153.298L257.547 219.45C255.327 221.671 255.301 225.299 257.547 227.544C259.767 229.765 263.395 229.79 265.641 227.544L280.732 212.453C285.981 207.204 294.545 207.204 299.819 212.479C305.094 217.753 305.094 226.317 299.819 231.591L280.603 250.808C278.383 253.028 278.357 256.656 280.603 258.902C282.848 261.148 286.451 261.148 288.697 258.902L303.371 244.228C308.645 238.953 317.209 238.953 322.484 244.228C327.758 249.502 327.758 258.066 322.484 263.34L303.553 282.271C301.333 284.491 301.307 288.119 303.553 290.365C305.799 292.611 309.401 292.611 311.647 290.365L323.423 278.588C328.698 273.314 337.262 273.314 342.536 278.588C347.811 283.863 347.811 292.427 342.536 297.701L288.124 352.113L287.96 351.965C273.983 365.942 254.537 371.189 236.454 367.706L226.961 377.199C226.961 377.199 226.961 377.199 226.961 377.199L163.799 440.361C161.6 442.56 161.6 446.126 163.799 448.325C165.998 450.524 169.564 450.524 171.763 448.325L240.181 379.907C242.579 380.156 245.004 380.283 247.448 380.283C265.829 380.283 283.115 373.127 296.117 360.124L322.478 333.764L322.333 333.62L350.385 305.568C360.098 295.855 360.098 280.032 350.385 270.319L350.44 270.373Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M335.818 263.269L325.419 258.942C324.062 262.203 324.313 265.911 326.097 268.959C327.881 272.007 330.991 274.042 334.499 274.455L335.818 263.269ZM350.44 270.373L342.55 278.412C346.975 282.754 354.078 282.704 358.441 278.3C362.805 273.895 362.788 266.792 358.404 262.408L350.44 270.373ZM314.144 228.803L303.314 225.709C302.375 228.998 302.981 232.536 304.961 235.325C306.942 238.114 310.083 239.852 313.498 240.048L314.144 228.803ZM295.425 197.6L287.461 189.636C284.549 192.548 283.458 196.817 284.617 200.769C285.775 204.721 288.999 207.726 293.022 208.604L295.425 197.6ZM235.826 186.7L227.861 178.736C224.636 181.961 223.674 186.814 225.426 191.026L235.826 186.7ZM235.98 187.072L242.971 195.903C246.924 192.774 248.316 187.401 246.38 182.746L235.98 187.072ZM159.246 292.081L170.509 292.081L170.509 292.081L159.246 292.081ZM159.681 299.893L167.646 307.858C170.068 305.435 171.257 302.041 170.874 298.637L159.681 299.893ZM99.4712 376.033L107.436 383.997L107.436 383.997L99.4712 376.033ZM145.113 330.391L137.148 322.426L137.148 322.426L145.113 330.391ZM171.828 303.676L179.792 311.64C182.472 308.96 183.625 305.112 182.859 301.4L171.828 303.676ZM187.419 251.425L195.384 259.389C199.614 255.158 199.799 248.358 195.804 243.904L187.419 251.425ZM187.272 251.26L179.307 243.296C175.076 247.526 174.892 254.326 178.886 258.78L187.272 251.26ZM216.255 222.276L210.454 212.622C209.667 213.095 208.94 213.662 208.291 214.312L216.255 222.276ZM217.36 221.412L225.324 229.377L217.36 221.412ZM304.587 134.186L296.622 126.221L304.587 134.186ZM288.124 352.113L280.605 360.499C285.059 364.493 291.858 364.308 296.089 360.078L288.124 352.113ZM287.96 351.965L295.479 343.58C291.025 339.586 284.226 339.771 279.995 344.001L287.96 351.965ZM236.454 367.706L238.584 356.645C234.914 355.939 231.132 357.098 228.489 359.741L236.454 367.706ZM226.961 377.199L218.996 369.234C214.598 373.633 214.598 380.764 218.996 385.163L226.961 377.199ZM226.961 377.199L234.925 385.163C239.324 380.764 239.324 373.633 234.925 369.234L226.961 377.199ZM240.181 379.907L241.349 368.704C237.973 368.352 234.617 369.542 232.217 371.942L240.181 379.907ZM247.448 380.283L247.448 369.02H247.448L247.448 380.283ZM322.478 333.764L330.442 341.728C334.841 337.33 334.841 330.198 330.442 325.8L322.478 333.764ZM322.333 333.62L314.369 325.655C309.97 330.054 309.97 337.185 314.369 341.584L322.333 333.62ZM350.385 270.319L358.274 262.28C353.849 257.937 346.746 257.987 342.383 262.392C338.019 266.796 338.036 273.899 342.42 278.283L350.385 270.319ZM334.499 274.455C337.396 274.797 340.224 276.086 342.475 278.337L358.404 262.408C352.455 256.46 344.895 252.999 337.138 252.084L334.499 274.455ZM322.474 244.027C326.472 248.026 327.488 253.97 325.419 258.942L346.217 267.597C351.667 254.501 349.08 238.776 338.402 228.099L322.474 244.027ZM313.498 240.048C316.829 240.239 320.022 241.576 322.474 244.027L338.402 228.099C331.82 221.516 323.317 218.048 314.791 217.558L313.498 240.048ZM299.837 212.302C303.466 215.931 304.637 221.081 303.314 225.709L324.975 231.897C328.457 219.707 325.399 206.007 315.765 196.373L299.837 212.302ZM293.022 208.604C295.575 209.162 297.919 210.384 299.837 212.302L315.765 196.373C310.635 191.242 304.363 188.024 297.829 186.596L293.022 208.604ZM323.719 153.378L287.461 189.636L303.39 205.565L339.648 169.307L323.719 153.378ZM323.719 134.057C329.033 139.371 329.033 148.063 323.719 153.378L339.648 169.307C353.76 155.195 353.76 132.24 339.648 118.128L323.719 134.057ZM304.398 134.057C309.712 128.742 318.405 128.742 323.719 134.057L339.648 118.128C325.536 104.016 302.581 104.016 288.469 118.128L304.398 134.057ZM243.79 194.665L304.398 134.057L288.469 118.128L227.861 178.736L243.79 194.665ZM246.38 182.746L246.225 182.375L225.426 191.026L225.581 191.398L246.38 182.746ZM241.781 196.964C242.164 196.581 242.562 196.227 242.971 195.903L228.989 178.241C227.9 179.103 226.852 180.035 225.852 181.035L241.781 196.964ZM187.369 251.376L241.781 196.964L225.852 181.035L171.44 235.447L187.369 251.376ZM170.509 292.081C170.509 276.686 176.479 262.265 187.369 251.376L171.44 235.447C156.324 250.563 147.982 270.714 147.982 292.081L170.509 292.081ZM170.874 298.637C170.632 296.48 170.509 294.292 170.509 292.081L147.982 292.081C147.982 295.129 148.152 298.156 148.488 301.15L170.874 298.637ZM99.4709 376.032L167.646 307.858L151.717 291.929L83.5421 360.103L99.4709 376.032ZM99.4709 368.068C101.67 370.267 101.67 373.833 99.4709 376.032L83.5421 360.103C76.9441 366.701 76.9441 377.399 83.5421 383.997L99.4709 368.068ZM91.5068 368.068C93.706 365.869 97.2717 365.869 99.4709 368.068L83.5421 383.997C90.1401 390.595 100.838 390.595 107.436 383.997L91.5068 368.068ZM137.148 322.426L91.5068 368.068L107.436 383.997L153.077 338.355L137.148 322.426ZM153.077 338.355L179.792 311.64L163.863 295.711L137.148 322.426L153.077 338.355ZM182.859 301.4C179.815 286.65 184.015 270.758 195.384 259.389L179.455 243.46C162.486 260.429 156.291 284.116 160.797 305.952L182.859 301.4ZM195.804 243.904L195.657 243.74L178.886 258.78L179.034 258.945L195.804 243.904ZM195.236 259.224L224.219 230.241L208.291 214.312L179.307 243.296L195.236 259.224ZM222.056 231.931C223.234 231.223 224.333 230.368 225.324 229.377L209.395 213.448C209.71 213.133 210.066 212.855 210.454 212.622L222.056 231.931ZM225.324 229.377L312.551 142.15L296.622 126.221L209.395 213.448L225.324 229.377ZM312.551 142.15C313.427 141.274 314.859 141.274 315.735 142.15L331.664 126.221C321.991 116.548 306.295 116.548 296.622 126.221L312.551 142.15ZM315.735 142.15C316.611 143.026 316.611 144.458 315.735 145.334L331.664 161.263C341.337 151.59 341.337 135.894 331.664 126.221L315.735 142.15ZM315.735 145.334L249.583 211.486L265.512 227.415L331.664 161.263L315.735 145.334ZM249.583 211.486C242.997 218.072 242.906 228.832 249.583 235.509L265.512 219.58C267.697 221.766 267.657 225.269 265.512 227.415L249.583 211.486ZM249.583 235.509C256.169 242.095 266.929 242.186 273.605 235.509L257.677 219.58C259.862 217.394 263.366 217.434 265.512 219.58L249.583 235.509ZM273.605 235.509L288.697 220.417L272.768 204.489L257.677 219.58L273.605 235.509ZM288.697 220.417C289.533 219.581 290.965 219.553 291.855 220.443L307.784 204.514C298.125 194.855 282.43 194.827 272.768 204.489L288.697 220.417ZM291.855 220.443C292.731 221.319 292.731 222.751 291.855 223.627L307.784 239.556C317.457 229.883 317.457 214.187 307.784 204.514L291.855 220.443ZM291.855 223.627L272.638 242.844L288.567 258.773L307.784 239.556L291.855 223.627ZM272.638 242.844C266.052 249.43 265.961 260.19 272.638 266.866L288.567 250.938C290.753 253.123 290.713 256.627 288.567 258.773L272.638 242.844ZM272.638 266.866C279.283 273.511 290.017 273.511 296.661 266.866L280.732 250.938C282.885 248.785 286.414 248.785 288.567 250.938L272.638 266.866ZM296.661 266.866L311.335 252.192L295.407 236.263L280.732 250.938L296.661 266.866ZM311.335 252.192C312.211 251.316 313.644 251.316 314.519 252.192L330.448 236.263C320.775 226.59 305.079 226.59 295.407 236.263L311.335 252.192ZM314.519 252.192C315.395 253.068 315.395 254.5 314.519 255.376L330.448 271.305C340.121 261.632 340.121 245.936 330.448 236.263L314.519 252.192ZM314.519 255.376L295.588 274.307L311.517 290.236L330.448 271.305L314.519 255.376ZM295.588 274.307C289.002 280.893 288.912 291.653 295.588 298.33L311.517 282.401C313.703 284.586 313.663 288.09 311.517 290.236L295.588 274.307ZM295.588 298.33C302.233 304.974 312.967 304.974 319.611 298.33L303.682 282.401C305.835 280.248 309.364 280.248 311.517 282.401L295.588 298.33ZM319.611 298.33L331.388 286.553L315.459 270.624L303.682 282.401L319.611 298.33ZM331.388 286.553C332.264 285.677 333.696 285.677 334.572 286.553L350.501 270.624C340.827 260.951 325.132 260.951 315.459 270.624L331.388 286.553ZM334.572 286.553C335.448 287.429 335.448 288.861 334.572 289.737L350.501 305.666C360.174 295.992 360.174 280.297 350.501 270.624L334.572 286.553ZM334.572 289.737L280.16 344.149L296.089 360.078L350.501 305.666L334.572 289.737ZM295.644 343.728L295.479 343.58L280.44 360.351L280.605 360.499L295.644 343.728ZM279.995 344.001C268.78 355.216 253.165 359.454 238.584 356.645L234.324 378.766C255.909 382.923 279.186 376.668 295.924 359.93L279.995 344.001ZM228.489 359.741L218.996 369.234L234.925 385.163L244.418 375.67L228.489 359.741ZM234.925 369.234C234.704 369.013 234.476 368.804 234.244 368.607C234.013 368.411 233.779 368.228 233.544 368.059C233.309 367.89 233.076 367.736 232.845 367.595C232.615 367.453 232.388 367.326 232.168 367.211C231.728 366.982 231.312 366.802 230.936 366.66C230.748 366.589 230.569 366.527 230.401 366.473C230.232 366.419 230.073 366.373 229.925 366.332C229.776 366.292 229.637 366.257 229.509 366.227C229.381 366.198 229.262 366.172 229.154 366.151C229.046 366.129 228.947 366.111 228.859 366.096C228.77 366.081 228.69 366.069 228.62 366.058C228.55 366.048 228.489 366.039 228.437 366.032C228.385 366.026 228.341 366.02 228.307 366.016C228.274 366.012 228.247 366.009 228.23 366.007C228.222 366.006 228.215 366.005 228.211 366.005C228.209 366.005 228.207 366.004 228.206 366.004C228.206 366.004 228.205 366.004 228.205 366.004C228.205 366.004 228.205 366.004 228.205 366.004C228.205 366.004 228.205 366.004 228.205 366.004C228.204 366.004 228.207 366.004 228.211 366.005C228.215 366.005 228.222 366.006 228.23 366.007C228.247 366.009 228.274 366.012 228.307 366.016C228.341 366.02 228.385 366.026 228.437 366.032C228.489 366.039 228.55 366.048 228.62 366.058C228.69 366.068 228.77 366.081 228.859 366.096C228.947 366.111 229.046 366.129 229.154 366.151C229.262 366.172 229.381 366.198 229.509 366.227C229.637 366.257 229.776 366.292 229.924 366.332C230.073 366.373 230.232 366.419 230.401 366.473C230.569 366.527 230.748 366.589 230.936 366.66C231.312 366.802 231.728 366.982 232.168 367.211C232.388 367.326 232.615 367.453 232.845 367.594C233.076 367.736 233.309 367.89 233.544 368.059C233.778 368.228 234.013 368.411 234.244 368.607C234.476 368.804 234.704 369.013 234.925 369.234L218.996 385.163C219.218 385.385 219.445 385.594 219.677 385.79C219.909 385.987 220.143 386.169 220.378 386.338C220.612 386.507 220.846 386.661 221.077 386.803C221.307 386.944 221.533 387.071 221.754 387.186C222.194 387.416 222.61 387.595 222.985 387.737C223.173 387.808 223.352 387.87 223.521 387.924C223.69 387.978 223.849 388.025 223.997 388.065C224.146 388.106 224.285 388.14 224.413 388.17C224.541 388.2 224.659 388.225 224.767 388.246C224.875 388.268 224.975 388.286 225.063 388.301C225.152 388.316 225.232 388.329 225.302 388.339C225.371 388.349 225.433 388.358 225.485 388.365C225.536 388.372 225.58 388.377 225.614 388.381C225.648 388.385 225.675 388.388 225.691 388.39C225.7 388.391 225.707 388.392 225.711 388.392C225.713 388.393 225.714 388.393 225.715 388.393C225.716 388.393 225.716 388.393 225.717 388.393C225.717 388.393 225.717 388.393 225.717 388.393C225.717 388.393 225.717 388.393 225.717 388.393C225.718 388.393 225.714 388.393 225.711 388.392C225.707 388.392 225.7 388.391 225.691 388.39C225.675 388.388 225.648 388.385 225.614 388.381C225.58 388.377 225.536 388.372 225.485 388.365C225.433 388.358 225.371 388.349 225.302 388.339C225.232 388.329 225.152 388.316 225.063 388.301C224.975 388.286 224.875 388.268 224.767 388.246C224.659 388.225 224.541 388.2 224.413 388.17C224.285 388.14 224.146 388.106 223.997 388.065C223.849 388.025 223.69 387.978 223.521 387.924C223.353 387.87 223.173 387.808 222.985 387.737C222.61 387.595 222.194 387.416 221.754 387.186C221.533 387.071 221.307 386.944 221.077 386.803C220.846 386.661 220.613 386.507 220.378 386.338C220.143 386.169 219.909 385.987 219.677 385.79C219.446 385.594 219.218 385.385 218.997 385.163L234.925 369.234ZM171.763 448.325L234.925 385.163L218.997 369.234L155.834 432.396L171.763 448.325ZM171.763 440.36C173.963 442.56 173.963 446.126 171.763 448.325L155.834 432.396C149.237 438.994 149.237 449.691 155.834 456.289L171.763 440.36ZM163.799 440.36C165.998 438.161 169.564 438.161 171.763 440.36L155.834 456.289C162.432 462.887 173.129 462.887 179.727 456.289L163.799 440.36ZM232.217 371.942L163.799 440.36L179.727 456.289L248.146 387.871L232.217 371.942ZM247.448 369.02C245.393 369.02 243.358 368.913 241.349 368.704L239.013 391.109C241.8 391.4 244.615 391.546 247.448 391.546V369.02ZM288.153 352.16C277.263 363.05 262.842 369.02 247.448 369.02L247.448 391.546C268.815 391.546 288.966 383.204 304.081 368.089L288.153 352.16ZM314.513 325.8L288.153 352.16L304.081 368.089L330.442 341.728L314.513 325.8ZM314.369 341.584L314.513 341.728L330.442 325.8L330.298 325.655L314.369 341.584ZM342.42 297.604L314.369 325.655L330.298 341.584L358.349 313.533L342.42 297.604ZM342.42 278.283C347.735 283.597 347.735 292.29 342.42 297.604L358.349 313.533C372.461 299.421 372.461 276.466 358.349 262.354L342.42 278.283ZM358.329 262.334L358.274 262.28L342.495 278.358L342.55 278.412L358.329 262.334Z",
                fill: secondColor,
                mask: "url(#path-3-inside-1_1808_327)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M225.934 43.6465H376.046C391.12 43.6465 403.339 55.866 403.339 70.9395V377.986C403.339 393.06 391.12 405.279 376.046 405.279H245.967C243.825 405.279 241.963 406.06 240.664 407.762V407.762C237.223 412.271 240.325 418.926 245.996 418.926H376.046C398.656 418.926 416.986 400.596 416.986 377.986V70.9395C416.986 48.3293 398.656 30 376.046 30H225.934C203.324 30 184.995 48.3292 184.995 70.9395V196.338C184.995 202.074 191.643 205.25 196.105 201.646V201.646C197.709 200.35 198.641 198.399 198.641 196.338V70.9395C198.641 55.866 210.861 43.6465 225.934 43.6465Z",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/MyListFingerPoiting.tsx


var MyListFingerPoiting = function(param) {
    var _width = param.width, width = _width === void 0 ? 130 : _width, _height = param.height, height = _height === void 0 ? 150 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.270 */.rS.colors.secondary[270] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.secondary.395 */.rS.colors.secondary[395] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M358.077 273.82C351.385 273.82 345.207 276.121 340.347 279.956C336.042 269.515 325.729 262.143 313.752 262.143C306.379 262.143 299.646 264.955 294.529 269.516C289.627 260.692 280.209 254.726 269.385 254.726C263.632 254.726 258.305 256.429 253.786 259.328V200.145C253.786 184.29 240.872 171.376 225.018 171.376C209.164 171.376 196.249 184.29 196.249 200.145V325.132L170.635 296.153C166.075 290.995 159.811 287.671 152.991 286.735C146.171 285.798 139.269 287.374 133.472 291.167C121.242 299.179 116.978 315.033 123.584 328.075L175.41 430.528C181.546 442.675 190.923 452.86 202.517 459.976C214.107 467.093 227.405 470.845 241 470.845H307.316C328.539 470.845 348.487 462.578 363.488 447.577C378.489 432.576 386.756 412.628 386.756 391.404V302.59C386.756 286.735 373.842 273.821 357.988 273.821L358.077 273.82ZM373.675 391.403C373.675 427.927 343.971 457.632 307.446 457.632H241.131C229.965 457.632 219.054 454.564 209.55 448.68C200.046 442.841 192.331 434.488 187.305 424.514L135.479 322.061C131.899 315.03 134.2 306.463 140.806 302.158C147.198 297.981 155.807 299.132 160.837 304.843L197.959 346.864C199.79 348.909 202.688 349.635 205.245 348.654C207.802 347.673 209.508 345.244 209.508 342.473V200.096C209.508 191.487 216.497 184.497 225.107 184.497C233.716 184.497 240.705 191.487 240.705 200.096V308.074C240.705 311.697 243.645 314.679 247.311 314.679C250.935 314.679 253.917 311.739 253.917 308.074V283.441C253.917 274.873 260.906 267.884 269.515 267.884C278.124 267.884 285.114 274.873 285.114 283.483V314.849C285.114 318.473 288.054 321.455 291.719 321.455C295.385 321.455 298.325 318.515 298.325 314.849V290.897C298.325 282.288 305.314 275.298 313.923 275.298C322.533 275.298 329.522 282.287 329.522 290.897V321.797C329.522 325.421 332.462 328.403 336.128 328.403C339.793 328.403 342.733 325.462 342.733 321.797V302.574C342.733 293.965 349.723 286.976 358.332 286.976C366.941 286.976 373.93 293.965 373.93 302.574V391.389L373.675 391.403Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "68.8807",
                y: "67.523",
                width: "89.4495",
                height: "110.092",
                rx: "6.88073",
                stroke: secondColor,
                strokeWidth: "13.7615"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "209.936",
                y: "36.8807",
                width: "89.4495",
                height: "110.092",
                rx: "6.88073",
                fill: color,
                strokeWidth: "13.7615"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "340.67",
                y: "67.523",
                width: "89.4495",
                height: "110.092",
                rx: "6.88073",
                stroke: secondColor,
                strokeWidth: "13.7615"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/MyListThumbsUp.tsx


var MyListThumbsUp = function(param) {
    var _width = param.width, width = _width === void 0 ? 130 : _width, _height = param.height, height = _height === void 0 ? 130 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.270 */.rS.colors.secondary[270] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M367.359 377.325C365.024 374.99 361.271 374.922 358.765 377.071C340.361 392.846 318.226 404.851 293.249 411.544C204.003 435.457 112.269 382.495 88.3559 293.249C64.4426 204.003 117.405 112.269 206.651 88.3559C295.897 64.4426 387.63 117.405 411.544 206.651C425.618 259.176 413.064 312.562 382.156 352.477C380.207 354.995 380.364 358.583 382.615 360.834V360.834C385.173 363.392 389.38 363.214 391.601 360.36C424.977 317.474 438.568 260.007 423.419 203.469C397.748 107.665 299.273 50.8102 203.469 76.4809C107.665 102.152 50.8102 200.626 76.4809 296.431C102.152 392.235 200.626 449.09 296.431 423.419C323.402 416.192 347.287 403.195 367.112 386.111C369.758 383.831 369.829 379.795 367.359 377.325V377.325Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-2-inside-1_1808_252",
                fill: secondColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M112.311 365.192C86.2253 333.979 70.5261 293.787 70.5261 249.927C70.5261 204.809 87.1396 163.57 114.583 131.996L220.521 131.996C229.72 131.996 237.178 139.454 237.178 148.653V348.536C237.178 357.735 229.72 365.192 220.521 365.192H112.311Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M112.311 365.192L102.877 373.076L106.563 377.486H112.311V365.192ZM114.583 131.996V119.702H108.98L105.304 123.931L114.583 131.996ZM121.744 357.309C97.4379 328.225 82.8201 290.799 82.8201 249.927H58.2322C58.2322 296.774 75.0126 339.734 102.877 373.076L121.744 357.309ZM82.8201 249.927C82.8201 207.884 98.2886 169.484 123.862 140.061L105.304 123.931C75.9905 157.657 58.2322 201.734 58.2322 249.927H82.8201ZM114.583 144.29L220.521 144.29V119.702L114.583 119.702V144.29ZM220.521 144.29C222.93 144.29 224.884 146.243 224.884 148.653H249.472C249.472 132.664 236.51 119.702 220.521 119.702V144.29ZM224.884 148.653V348.536H249.472V148.653H224.884ZM224.884 348.536C224.884 350.945 222.93 352.898 220.521 352.898V377.486C236.51 377.486 249.472 364.525 249.472 348.536H224.884ZM220.521 352.898H112.311V377.486H220.521V352.898Z",
                fill: color,
                mask: "url(#path-2-inside-1_1808_252)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M180.261 140.192V176.619",
                fill: color,
                strokeWidth: "12.294",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M180.261 218.282L180.261 356.93",
                fill: color,
                strokeWidth: "12.294",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M324.853 32.7634C318.692 33.1784 312.177 36.1072 307.536 41.7941C302.895 47.4811 300.137 55.5136 299.461 66.1235C297.056 103.906 283.553 127.071 268.757 141.982C254.324 156.524 238.615 162.979 230.085 166.1C226.048 167.63 224.884 169.508 224.884 173.962V310.908C224.884 322.502 234.531 331.943 246.133 331.943H405.602C420.898 331.943 433.65 319.563 433.65 304.319C433.65 298.03 431.426 292.282 427.807 287.638C437.267 283.203 443.957 273.669 443.957 262.67C443.957 256.137 441.562 250.194 437.689 245.458C446.526 240.814 452.67 231.577 452.67 221.021C452.67 214.741 450.441 208.984 446.827 204.34C456.242 199.889 462.87 190.339 462.87 179.372C462.87 164.129 450.119 151.856 434.822 151.856H352.486C358.092 140.228 361.541 125.76 362.793 110.314C364.472 89.5986 361.987 67.2017 353.231 48.3764C348.851 38.9523 338.618 32.8095 327.201 32.7573C326.44 32.7549 325.634 32.7051 324.863 32.7573L324.853 32.7634Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M324.853 32.7634C318.692 33.1784 312.177 36.1072 307.536 41.7941C302.895 47.4811 300.137 55.5136 299.461 66.1235C297.056 103.906 283.553 127.071 268.757 141.982C254.324 156.524 238.615 162.979 230.085 166.1C226.048 167.63 224.884 169.508 224.884 173.962V310.908C224.884 322.502 234.531 331.943 246.133 331.943H405.602C420.898 331.943 433.65 319.563 433.65 304.319C433.65 298.03 431.426 292.282 427.807 287.638C437.267 283.203 443.957 273.669 443.957 262.67C443.957 256.137 441.562 250.194 437.689 245.458C446.526 240.814 452.67 231.577 452.67 221.021C452.67 214.742 450.441 208.984 446.827 204.34C456.242 199.889 462.87 190.339 462.87 179.373C462.87 164.129 450.118 151.856 434.822 151.856H352.486C358.092 140.228 361.541 125.76 362.793 110.314C364.472 89.5986 361.987 67.2017 353.231 48.3764C348.851 38.9523 338.618 32.8095 327.201 32.7573C326.44 32.7549 325.634 32.7051 324.863 32.7573L324.853 32.7634ZM325.808 46.3614C331.761 45.9606 339.57 51.2705 340.894 54.116C348.3 70.0405 350.705 90.3435 349.182 109.149C347.681 127.685 342.181 144.717 335.37 154.089C330.99 158.47 331.052 165.459 341 165.459H434.811C442.848 165.459 449.261 171.694 449.261 179.377C449.261 187.014 442.834 193.403 434.811 193.403H388.595C385.03 193.403 381.779 196.638 381.779 200.202C381.779 203.766 385.028 207.008 388.595 207.001H424.611C432.586 207.001 439.061 213.389 439.061 221.026C439.061 228.724 432.648 235.052 424.611 235.052H388.595C385.03 235.052 381.779 238.287 381.779 241.851C381.779 245.415 385.028 248.657 388.595 248.65H415.901C423.924 248.65 430.35 254.991 430.35 262.675C430.35 270.311 423.924 276.701 415.901 276.701H388.595C385.03 276.701 381.779 279.935 381.779 283.5C381.779 287.064 385.028 290.306 388.595 290.299H405.594C413.631 290.299 420.044 296.64 420.044 304.324C420.044 312.008 413.631 318.35 405.594 318.35H246.124C241.81 318.35 238.473 314.916 238.473 310.913V177.47C248.296 173.585 263.934 166.144 278.422 151.547C295.335 134.508 310.466 107.681 313.058 66.9764C313.613 58.2893 315.752 53.2193 318.052 50.4017C320.353 47.5844 322.831 46.5646 325.807 46.3654L325.808 46.3614Z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/NewEyeCloseIcon.tsx


var NewEyeCloseIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de olho fechado" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1475_522305)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.41317 9.41334C9.23007 9.60984 9.00927 9.76744 8.76394 9.87675C8.51861 9.98607 8.25377 10.0448 7.98523 10.0496C7.71669 10.0543 7.44995 10.0049 7.20091 9.90433C6.95188 9.80374 6.72565 9.65403 6.53573 9.46411C6.34582 9.27419 6.1961 9.04797 6.09551 8.79893C5.99492 8.5499 5.94552 8.28315 5.95026 8.01461C5.955 7.74607 6.01378 7.48124 6.12309 7.2359C6.2324 6.99057 6.39001 6.76977 6.5865 6.58667M11.9598 11.96C10.8202 12.8287 9.43258 13.3099 7.99984 13.3333C3.33317 13.3333 0.666504 8.00001 0.666504 8.00001C1.49576 6.4546 2.64593 5.10441 4.03984 4.04001L11.9598 11.96ZM6.59984 2.82667C7.05872 2.71926 7.52855 2.66557 7.99984 2.66667C12.6665 2.66667 15.3332 8.00001 15.3332 8.00001C14.9285 8.75708 14.4459 9.46983 13.8932 10.1267L6.59984 2.82667Z",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0.666504 0.666656L15.3332 15.3333",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1475_522305",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: secondColor
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/NewEyeOpenIcon.tsx


var NewEyeOpenIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de olho aberto" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.07865 8.31137C1.97399 8.11737 1.97399 7.88204 2.07865 7.68804C3.33999 5.35537 5.66999 3.33337 7.99999 3.33337C10.33 3.33337 12.66 5.35537 13.9213 7.68871C14.026 7.88271 14.026 8.11804 13.9213 8.31204C12.66 10.6447 10.33 12.6667 7.99999 12.6667C5.66999 12.6667 3.33999 10.6447 2.07865 8.31137Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.41421 6.58579C10.1953 7.36683 10.1953 8.63316 9.41421 9.41421C8.63316 10.1953 7.36683 10.1953 6.58578 9.41421C5.80474 8.63316 5.80474 7.36683 6.58578 6.58579C7.36683 5.80474 8.63316 5.80474 9.41421 6.58579",
                stroke: color,
                strokeWidth: "1.4286",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/NewGiftIcon.tsx


var NewGiftIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.760 */.rS.colors.neutral[760] : _color, _alt = param.alt, alt = _alt === void 0 ? "caixa de presente" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.6667 9.16732H16.25C16.9404 9.16732 17.5 8.60767 17.5 7.91732V7.08398C17.5 6.39363 16.9404 5.83398 16.25 5.83398H3.75C3.05964 5.83398 2.5 6.39363 2.5 7.08398V7.91732C2.5 8.60767 3.05964 9.16732 3.75 9.16732H8.33333",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.6668 9.16602V15.8327C16.6668 16.7532 15.9206 17.4993 15.0002 17.4993H5.00016C4.07969 17.4993 3.3335 16.7532 3.3335 15.8327V9.16602",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.33317 2.5V2.5C9.25365 2.5 9.99984 3.24619 9.99984 4.16667V5.83333H8.33317C7.4127 5.83333 6.6665 5.08714 6.6665 4.16667V4.16667C6.6665 3.24619 7.4127 2.5 8.33317 2.5Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.6667 2.5V2.5C12.5871 2.5 13.3333 3.24619 13.3333 4.16667V4.16667C13.3333 5.08714 12.5871 5.83333 11.6667 5.83333H10V4.16667C10 3.24619 10.7462 2.5 11.6667 2.5Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "8.3335",
                y: "5.83398",
                width: "3.33333",
                height: "11.6667",
                rx: "1",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/NewShareIcon.tsx


var NewShareIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 25 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de compartilhamento" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Group",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Group_2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path",
                        d: "M13.5307 8.02002L9.4707 11.06",
                        stroke: color,
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_2",
                        d: "M16.4044 5.14216C17.1979 5.9357 17.1979 7.2223 16.4044 8.01584C15.6108 8.80938 14.3242 8.80938 13.5307 8.01584C12.7372 7.22229 12.7372 5.9357 13.5307 5.14216C14.3243 4.34861 15.6108 4.34861 16.4044 5.14216",
                        stroke: color,
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_3",
                        d: "M13.5307 16.9799L9.4707 13.9399",
                        stroke: color,
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_4",
                        d: "M16.4044 16.9842C17.1979 17.7777 17.1979 19.0643 16.4044 19.8579C15.6108 20.6514 14.3242 20.6514 13.5307 19.8579C12.7372 19.0643 12.7372 17.7777 13.5307 16.9842C14.3243 16.1907 15.6108 16.1907 16.4044 16.9842",
                        stroke: color,
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_5",
                        d: "M9.46542 11.0645C10.2582 11.8573 10.2582 13.1426 9.46542 13.9354C8.67266 14.7282 7.38733 14.7282 6.59457 13.9354C5.80181 13.1426 5.80181 11.8573 6.59457 11.0645C7.38734 10.2718 8.67266 10.2718 9.46542 11.0645",
                        stroke: color,
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/NoAddress.tsx

var NoAddress = function(param) {
    var _width = param.width, width = _width === void 0 ? 220 : _width, _height = param.height, height = _height === void 0 ? 162 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "https://www.w3.org/2000/svg",
        xmlnsXlink: "https://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 220.061 161.762",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        children: ".a{fill:#ededed;}.b{fill:#f7f7f7;}.c{fill:#dbdbdb;}.d{fill:url(#a);}.e{fill:url(#b);}.f{fill:rgba(246,214,219,0.32);stroke:#eba6b1;}.g{fill:#ba0f2b;}.h,.i,.j{fill:#222235;font-family:Barlow-SemiBold, Barlow;font-weight:600;letter-spacing:0.01em;}.h{font-size:18px;}.i{font-size:12px;opacity:0.657;}.j{font-size:14px;opacity:0.81;}.k{stroke:none;}.l{fill:none;}"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 0.559,
                        y1: 0.611,
                        x2: 0.86,
                        y2: 0.533,
                        gradientUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0,
                                stopColor: "#fff",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#fff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "b",
                        cx: 0.488,
                        cy: 0.5,
                        r: 0.47,
                        gradientTransform: "matrix(0.953, -0.304, 0.29, 0.91, -0.123, 0.185)",
                        gradientUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0,
                                stopColor: "#fff",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.724,
                                stopColor: "#fff",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#fff"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                transform: "translate(-332.939 -193.954)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "translate(22 77.906)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M.649,0H15.022V14.373L0,20.14Z",
                                transform: "translate(353.519 245.193) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M.577.207,16.078,0l-.455,20.4L-1.064,27.914Z",
                                transform: "translate(335.466 238.526) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M0,.027,9.841,0,2.433,6.366.758,2Z",
                                transform: "translate(321.075 233.125) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "c",
                                d: "M17.546,0,15.195,19.4,1.675,17.822,0,13.458Z",
                                transform: "translate(325.889 209.227) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "c",
                                d: "M-1.828-22.482l18,43.447L2.765,27.451-10.579-19.123Z",
                                transform: "translate(425.889 170.227) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "c",
                                d: "M5.306,13.721l2.122,5.529L-2.924,23.225-6.4,14.171Z",
                                transform: "translate(407.889 250.227) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "c",
                                d: "M5.306,13.721l2.122,5.529-15.123,7.9L-4.538,6.446Z",
                                transform: "translate(464.889 222.227) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "c",
                                d: "M12.59-23.976l9.6,48.4L1.675,17.822-.632,3.646Z",
                                transform: "translate(385.953 166.227) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "c",
                                d: "M-9.2-15.723,19.485,17.144,7.646,28.159l-11.7-17.47Z",
                                transform: "translate(464.953 161.227) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M19.393-.77l21.894,6.8L-.071,32.389.993,4.185Z",
                                transform: "translate(360.62 180.227) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M46.71,3.424l-18.951,17.6-30.2,16.168L-7.893,21.2,57.831-19.5Z",
                                transform: "translate(336.62 148.227) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M-2.549-9.175l12.61,47.63-7.6,4.632L-9.629-6.457Z",
                                transform: "translate(416.62 158.227) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M-2.549-9.175,3.038,14.348l-16.9.113L-19.284,3.039Z",
                                transform: "translate(455.62 153.227) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M-2.549-9.175,3.038,14.348-2.508,43.973-19.284,3.039Z",
                                transform: "translate(457.62 205.227) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M23.6-24.111,21.942,6.679,3.05,20.174-7.8-8.083Z",
                                transform: "translate(325.448 197.696) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M0,7.226,8.521,0,6.77,24.862.758,9.2Z",
                                transform: "translate(323.655 236.736) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M.252,9.505,14.551,0l-.512,19.332L0,19Z",
                                transform: "translate(362.943 223.801) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M.366,1.454,12.252-5.99l7.593,28.354L.18,22.312Z",
                                transform: "translate(380.415 226.801) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M-11.549-16.395,2.262-23.443,19.845,22.364,6.37,40Z",
                                transform: "translate(423.415 221.801) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M-1.973,13.048-6.109-31.706,19.5-5.25,6.091,37.654Z",
                                transform: "translate(476.415 222.801) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M0,5.889,8.836,0,8.38,5.7l-4.49.216Z",
                                transform: "translate(345.688 231.24) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M1.665,9.282,16.49,0,15.478,20.509,0,31Z",
                                transform: "translate(348.972 204.858) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M16.057,24.228l4-5.551L21.835,28.9l-14.421,3.4Z",
                                transform: "translate(366.972 147.858) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M12.4,21.924,79.765-7.846,70.718.774,7.017,40.593Z",
                                transform: "translate(329.972 120.858) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M-3.49,15.128l7.8-4.406L21.664,65.808l-12.072.459Z",
                                transform: "translate(411.972 190.858) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M-9.866,26.353l12.008-11.4L5.231,56.994-3.1,51.943Z",
                                transform: "translate(481.972 174.858) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M-29.906,28.752l32.048-13.8,27.3,73.907L-.7,60.637Z",
                                transform: "translate(503.972 125.858) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M20.352,76.434-5.006,89.609l-13.956,5.357L-2.856,73.718,15.76,64.47Z",
                                transform: "translate(472.972 181.858) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M-15.584,9.544l15.729.2L11.708,26.439-4.109,35.678Z",
                                transform: "translate(455.972 162.858) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M.743,5.293l20.075-.367,4.416,11.5L.959,18.677Z",
                                transform: "translate(372.972 246.858) rotate(21)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M0,0,24.608-16.95,28.119.3.338,18.721Z",
                                transform: "translate(367.857 211.205) rotate(21)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        className: "d",
                        width: 195,
                        height: 131,
                        transform: "translate(358 219)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        className: "e",
                        width: 211,
                        height: 136,
                        transform: "translate(340 214)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        className: "f",
                        transform: "translate(401 265)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                className: "k",
                                cx: 29,
                                cy: 15.5,
                                rx: 29,
                                ry: 15.5
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                className: "l",
                                cx: 29,
                                cy: 15.5,
                                rx: 28.5,
                                ry: 15
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "g",
                        d: "M50.5-174.069c-.96,0-2.659-3.569-3.929-6.91C45.057-184.958,44-188.9,44-190.557a6.372,6.372,0,0,1,1.9-4.556A6.487,6.487,0,0,1,50.5-197a6.486,6.486,0,0,1,4.6,1.887,6.373,6.373,0,0,1,1.9,4.556c0,1.66-1.057,5.6-2.57,9.578C53.159-177.638,51.46-174.069,50.5-174.069Zm0-19.57a3.1,3.1,0,0,0-3.109,3.081,3.1,3.1,0,0,0,3.109,3.081,3.1,3.1,0,0,0,3.109-3.081A3.1,3.1,0,0,0,50.5-193.639Z",
                        transform: "translate(380 451)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        className: "h",
                        transform: "translate(466 307)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "?"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        className: "i",
                        transform: "translate(450 248)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "?"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        className: "j",
                        transform: "translate(381 275)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "?"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/NoOrder.tsx


var NoOrder = function(param) {
    var _width = param.width, width = _width === void 0 ? 100 : _width, _height = param.height, height = _height === void 0 ? 100 : _height, _alt = param.alt, alt = _alt === void 0 ? "No Order" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.450 */.rS.colors.neutral[450] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "44",
                height: "44",
                rx: "22"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28 31.5H16C15.4695 31.5001 14.9607 31.2895 14.5856 30.9144C14.2105 30.5393 13.9999 30.0305 14 29.5L15 19C15.0003 18.1717 15.6717 17.5003 16.5 17.5H27.5C28.3283 17.5003 28.9997 18.1717 29 19L30 29.5C30.0001 30.0305 29.7895 30.5393 29.4144 30.9144C29.0393 31.2895 28.5305 31.5001 28 31.5Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 19.5V17C18 14.929 19.5 12.5 21.75 12.5H22.25C24.5 12.5 26 14.929 26 17V19.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 25.5L21 27.5L25 23",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/NoOrderIcon.tsx


var NoOrderIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 175 : _width, _height = param.height, height = _height === void 0 ? 175 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.neutral.150 */.rS.colors.neutral[150] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.neutral.88 */.rS.colors.neutral[88] : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _fifthColor, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de pacote com um X" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 175 175",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1021_54010)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "20.9774",
                        y: "2.55566",
                        width: "151.449",
                        height: "161.539",
                        rx: "75.7245",
                        fill: secondColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M61.4625 71.8378L86.0074 71.5791V142.348L79.5544 143.005V92.3918L70.4233 91.2822C70.8153 88.7901 70.3955 86.2301 69.2339 84.0278C67.2947 80.4261 61.4625 79.7651 61.4625 79.7651V71.8378Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M31.4216 108.962H47.7512L49.5647 142.21H31.4216V108.962Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M123.768 112.128H140.097L141.911 145.376H123.768V112.128Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M58.124 108.962H73.529V142.21H55.9088L58.124 108.962Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M150.47 112.128H165.875V145.376H148.255L150.47 112.128Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M28.7446 95.3594H76.0355V105.422H28.7446V95.3594Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M123.154 93.7354L169.862 101.626L168.387 111.564L121.678 103.674L123.154 93.7354Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M62.4783 22.4375H86.9487L85.8673 66.2606H61.4625L62.4783 22.4375Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M45.9273 41.1653L51.5155 43.0893L52.2564 47.9923L48.8642 60.4644L38.2419 56.6773L41.8114 44.6656L45.9273 41.1653Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M93.3922 22.4375H114.02V66.3318H92.1294L93.3922 22.4375Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M92.1294 71.5781H114.02V141.864H92.1294V71.5781Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M121.037 32.9873H142.927C142.927 32.9873 136.251 38.2623 136.251 49.5634C136.251 60.8645 143.357 66.1774 145.026 79.6099C146.695 93.0424 145.026 93.7318 145.026 93.7318H121.037C121.037 93.7318 119.034 93.034 121.037 79.6099C123.039 66.1857 129.063 60.9013 129.063 49.5598C129.09 46.3094 128.373 43.101 126.974 40.213C125.576 37.3251 123.538 34.8447 121.037 32.9873Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M57.1461 87.3425C59.7251 84.5917 64.6751 83.6637 66.5198 87.3425C68.3644 91.0213 63.9508 95.3623 63.9508 95.3623H53.6337C53.6337 95.3623 54.5671 90.0933 57.1461 87.3425Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M49.0895 87.3425C46.5105 84.5917 41.5605 83.6637 39.7158 87.3425C37.8712 91.0213 42.2859 95.3623 42.2859 95.3623H52.6019C52.6019 95.3623 51.6685 90.0933 49.0895 87.3425Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M47.5551 47.273C48.4768 47.273 49.224 46.4761 49.224 45.493C49.224 44.5099 48.4768 43.7129 47.5551 43.7129C46.6334 43.7129 45.8862 44.5099 45.8862 45.493C45.8862 46.4761 46.6334 47.273 47.5551 47.273Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M62.7977 22.541C58.9197 23.5545 55.4073 25.7635 52.6986 28.8923C48.7789 33.8326 48.1336 41.6863 48.1336 41.6863C48.1336 41.6863 47.3648 32.691 51.2856 27.7507C55.2064 22.8104 62.7977 22.541 62.7977 22.541Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M147.34 72.9661L142.41 76.3672L142.884 81.3078L149.187 92.4184L158.528 85.828L152.165 75.211L147.34 72.9661Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M147.253 79.3146C148.143 79.06 148.671 78.0839 148.433 77.1343C148.194 76.1847 147.279 75.6213 146.389 75.8759C145.498 76.1305 144.97 77.1067 145.209 78.0563C145.448 79.0058 146.363 79.5692 147.253 79.3146Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M126.528 59.6338C130.52 59.5418 134.449 60.7055 137.825 62.9796C142.812 66.6688 145.339 74.0795 145.339 74.0795C145.339 74.0795 143.897 65.1765 138.91 61.4873C133.923 57.7981 126.528 59.6338 126.528 59.6338Z",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M128.923 65.9344V112.562C128.923 117.283 125.33 121.109 120.898 121.109H64.7227C60.2906 121.109 56.6976 117.283 56.6976 112.562V65.9344C56.6961 64.7754 56.9159 63.6282 57.3437 62.5626L62.6402 49.3617C63.9066 46.2201 66.8091 44.1845 70.0193 44.1865H115.602C118.815 44.1865 121.718 46.2279 122.981 49.3746L128.277 62.5626C128.705 63.6284 128.924 64.7755 128.923 65.9344Z",
                        fill: color,
                        stroke: fifthColor,
                        strokeWidth: "3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M56.6976 65.5547H128.883",
                        stroke: fifthColor,
                        strokeWidth: "3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M100.123 44.9404L104.136 62.535V73.8834C104.036 75.4701 102.495 76.6885 100.685 76.6106H83.5115C81.7018 76.6885 80.1601 75.4701 80.0608 73.8834V62.535L84.0733 44.9404",
                        stroke: fifthColor,
                        strokeWidth: "3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M68.7317 108.289H76.7568",
                        stroke: fifthColor,
                        strokeWidth: "3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M140.482 115.91C140.482 125.218 133.397 132.763 124.658 132.763C115.919 132.763 108.835 125.218 108.835 115.91C108.835 106.603 115.919 99.0576 124.658 99.0576C128.857 99.0507 132.885 100.824 135.854 103.986C138.823 107.148 140.488 111.439 140.482 115.91Z",
                        fill: "#F9C6CD",
                        stroke: fifthColor,
                        strokeWidth: "3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M113.474 126.407L135.845 105.758",
                        stroke: fifthColor,
                        strokeWidth: "3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M55.4105 27.0146L65.2869 25.4199L57.9472 38.4427L67.5153 36.8978",
                stroke: color,
                strokeWidth: "15",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M55.4105 27.0146L65.2869 25.4199L57.9472 38.4427L67.5153 36.8978",
                stroke: fifthColor,
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.826 50.5039L49.0293 47.189L45.9379 58.4519L52.7959 55.2959L45.9379 58.4519",
                stroke: color,
                strokeWidth: "16",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.826 50.5039L49.0293 47.189L45.9379 58.4519L52.7959 55.2959L45.9379 58.4519",
                stroke: fifthColor,
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.8093 20.2021L38.9139 16.4959L31.5942 34.3485L43.423 30.7267",
                stroke: color,
                strokeWidth: "16",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.9128 20.0176L39.0877 16.5832L31.4191 34.2677L43.3166 30.9115",
                stroke: fifthColor,
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1021_54010",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "20.9774",
                        y: "2.55566",
                        width: "151.449",
                        height: "161.539",
                        rx: "75.7245",
                        fill: color
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/NoPackages.tsx

var NoPackages = function(param) {
    var _width = param.width, width = _width === void 0 ? 213 : _width, _height = param.height, height = _height === void 0 ? 137 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "https://www.w3.org/2000/svg",
        xmlnsXlink: "https://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 213 137",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        children: ".a{fill:#f7f7f7;}.b{fill:#eaeaea;}.c{fill:#f8f8f8;}.d{fill:#f2f2f2;}.e{fill:#fafafa;}.f{fill:url(#a);}.g{fill:url(#b);}.h{fill:url(#c);}.i{fill:#ba0f2b;}.j{fill:#222235;}.k{fill:#fff;}.l{fill:rgba(0,0,0,0.08);}.m{opacity:0.854;}.n{fill:none;stroke:rgba(189,39,47,0.6);stroke-linecap:round;}.o,.p{stroke:none;}.p{fill:#222235;}"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 0.559,
                        y1: 0.611,
                        x2: 0.86,
                        y2: 0.533,
                        gradientUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0,
                                stopColor: "#fff",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#fff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "b",
                        cx: 0.488,
                        cy: 0.5,
                        r: 0.47,
                        gradientTransform: "matrix(0.953, -0.304, 0.29, 0.91, -0.123, 0.185)",
                        gradientUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0,
                                stopColor: "#fff",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.724,
                                stopColor: "#fff",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#fff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "c",
                        x1: 0.116,
                        y1: 0.79,
                        x2: 0.18,
                        y2: -0.167,
                        gradientUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0,
                                stopColor: "#bd272f",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#bd272f",
                                stopOpacity: 0.302
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                transform: "translate(-336 -235)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "a",
                        d: "M0,0,9-7.366H21V46H0Z",
                        transform: "translate(336 309)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "a",
                        d: "M0-33.893H24.506L17.734,46H0Z",
                        transform: "translate(383 309)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "b",
                        d: "M-.256-25.4H12.609L14.656,1.27l.919,44.2H-5.809Z",
                        transform: "translate(411 309)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "b",
                        d: "M-12.213,19.1l-19.662-1.145V6.822H7.182v3.872H3.826L2.787,45.469H-9.247Z",
                        transform: "translate(483.213 242.747)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "c",
                        d: "M-.505-6.738H27.341L30,82.143H13.012V44.267H-7.626L-2.5.471-12.981-6.738Z",
                        transform: "translate(441 271)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "d",
                        d: "M-5.809,10.2H15.575V45.469H-5.809Z",
                        transform: "translate(435.384 309)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "d",
                        d: "M-6.8,14.216H14.587l2.646,22.762L18.4,75.012H-5.809Z",
                        transform: "translate(480.384 278)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "e",
                        d: "M-5.809,10.2h26.4V45.469H.4L-.747,60.9h-6.72Z",
                        transform: "translate(356.384 238.134)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "d",
                        d: "M0,0H18l1.428,68H-1Z",
                        transform: "translate(361 287)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "d",
                        d: "M-.193,50.652H24.743V77.744H19.722L18.89,68H-1Z",
                        transform: "translate(394 204)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "translate(-4 16)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                className: "f",
                                width: 195,
                                height: 131,
                                transform: "translate(358 219)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                className: "g",
                                width: 211,
                                height: 136,
                                transform: "translate(340 220)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "h",
                        d: "M3.354-9.774H17.373L36.907,65.515l-54.568-4.356Z",
                        transform: "translate(413 286)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "translate(409.83 320.554) rotate(-13)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "i",
                                d: "M13,11H2A2,2,0,0,1,0,9V0H15V9A2,2,0,0,1,13,11ZM5.616,2.2a1,1,0,0,0-1,1v.2a1,1,0,0,0,1,1H9.385a1,1,0,0,0,1-1V3.2a1,1,0,0,0-1-1Z",
                                transform: "translate(2.12 16.1)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "i",
                                d: "M2,0H15a2,2,0,0,1,2,2V4a0,0,0,0,1,0,0H0A0,0,0,0,1,0,4V2A2,2,0,0,1,2,0Z",
                                transform: "translate(1.12 11.1)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "translate(4.955 5.98)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                className: "j",
                                cx: 20.5,
                                cy: 6.5,
                                rx: 20.5,
                                ry: 6.5,
                                transform: "translate(398.045 259.02)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                className: "k",
                                transform: "translate(408.968 252)",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        className: "o",
                                        d: "M 9.577101707458496 12.54406452178955 C 4.847671508789062 12.54406452178955 1.000001668930054 11.21309471130371 1.000001668930054 9.577104568481445 C 1.000001668930054 4.84767484664917 4.847671508789062 1.000004649162292 9.577101707458496 1.000004649162292 C 14.30653190612793 1.000004649162292 18.15420150756836 4.84767484664917 18.15420150756836 9.577104568481445 C 18.15420150756836 11.21309471130371 14.30653190612793 12.54406452178955 9.577101707458496 12.54406452178955 Z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        className: "p",
                                        d: "M 9.577101707458496 2.000004768371582 C 5.39907169342041 2.000004768371582 2.000001907348633 5.399074554443359 2.000001907348633 9.577104568481445 C 2.000001907348633 9.70484447479248 2.399072647094727 10.20244407653809 3.683871269226074 10.67549514770508 C 5.183061599731445 11.22748470306396 7.331061363220215 11.54406452178955 9.577101707458496 11.54406452178955 C 11.82314109802246 11.54406452178955 13.97114181518555 11.22748470306396 15.4703311920166 10.67549514770508 C 16.75513076782227 10.20244407653809 17.15420150756836 9.70484447479248 17.15420150756836 9.577104568481445 C 17.15420150756836 5.399074554443359 13.75513172149658 2.000004768371582 9.577101707458496 2.000004768371582 M 9.577101707458496 4.76837158203125e-06 C 14.86639213562012 4.76837158203125e-06 19.15420150756836 4.287815093994141 19.15420150756836 9.577104568481445 C 19.15420150756836 12.22174453735352 14.36565208435059 13.54406452178955 9.577101707458496 13.54406452178955 C 4.788551330566406 13.54406452178955 1.9073486328125e-06 12.22174453735352 1.9073486328125e-06 9.577104568481445 C 1.9073486328125e-06 4.287815093994141 4.287811279296875 4.76837158203125e-06 9.577101707458496 4.76837158203125e-06 Z"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                        className: "l",
                        cx: 13.5,
                        cy: 3.5,
                        rx: 13.5,
                        ry: 3.5,
                        transform: "translate(411 355)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        className: "m",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                className: "n",
                                y2: 4,
                                transform: "translate(430.5 345.5)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                className: "n",
                                y2: 5.793,
                                transform: "translate(427.5 346.707)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                className: "n",
                                y2: 4,
                                transform: "translate(419.5 347.5)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                className: "n",
                                y2: 3,
                                transform: "translate(415.5 343.707)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/OfflineIcon.tsx


var OfflineIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "184" : _width, _height = param.height, height = _height === void 0 ? "161" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.150 */.rS.colors.neutral[150] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.yellow.110 */.rS.colors.yellow[110] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.neutral.240 */.rS.colors.neutral[240] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? themes/* theme.colors.neutral.560 */.rS.colors.neutral[560] : _fifthColor, _sixthColor = param.sixthColor, sixthColor = _sixthColor === void 0 ? themes/* theme.colors.neutral.245 */.rS.colors.neutral[245] : _sixthColor, _seventhColor = param.seventhColor, seventhColor = _seventhColor === void 0 ? themes/* theme.colors.primary.150 */.rS.colors.primary[150] : _seventhColor, _octaveColor = param.octaveColor, octaveColor = _octaveColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _octaveColor, _ninthColor = param.ninthColor, ninthColor = _ninthColor === void 0 ? themes/* theme.colors.primary.355 */.rS.colors.primary[355] : _ninthColor, _tenthColor = param.tenthColor, tenthColor = _tenthColor === void 0 ? themes/* theme.colors.primary.155 */.rS.colors.primary[155] : _tenthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 184 161",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_324_1292)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M80.3036 10.6768C85.2939 1.94152 97.8891 1.94154 102.879 10.6768L177.764 141.758C182.715 150.424 176.457 161.206 166.476 161.206H16.7071C6.72604 161.206 0.468214 150.424 5.41925 141.758L80.3036 10.6768Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M118.344 53.5231L127.04 41.7136L125.479 50.2524L130.855 51.2358L121.294 64.1947L123.72 54.5065L118.344 53.5231Z",
                        fill: secondColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M56.042 55.729L56.9411 41.0903L60.2614 49.1107L65.3113 47.0201L64.3101 63.0929L61.0919 53.6384L56.042 55.729Z",
                        fill: secondColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        filter: "url(#filter0_d_324_1292)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "70.9788",
                            y: "40.6553",
                            width: "43.0681",
                            height: "50.2616",
                            rx: "7",
                            fill: octaveColor
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "72.0042",
                        y: "42.21",
                        width: "41.0172",
                        height: "47.1526",
                        rx: "7",
                        fill: "url(#paint0_linear_324_1292)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        clipPath: "url(#clip1_324_1292)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                cx: "92.7691",
                                cy: "65.7858",
                                rx: "12.5615",
                                ry: "12.6949",
                                fill: thirdColor
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                cx: "92.7691",
                                cy: "67.858",
                                rx: "12.5615",
                                ry: "12.6949",
                                fill: color
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "80.7075",
                        y: "53.5908",
                        width: "24.1231",
                        height: "24.3899",
                        rx: "12.0615",
                        stroke: "url(#paint1_linear_324_1292)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "87.8984",
                        y: "60.8633",
                        width: "2.05086",
                        height: "5.18161",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "95.5891",
                        y: "60.8633",
                        width: "2.05085",
                        height: "5.18161",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M95.5891 72.7808C95.5891 71.9563 95.265 71.1655 94.6881 70.5825C94.1112 69.9994 93.3287 69.6719 92.5128 69.6719C91.6969 69.6719 90.9145 69.9994 90.3375 70.5825C89.7606 71.1655 89.4365 71.9563 89.4365 72.7808L92.5128 72.7808H95.5891Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        opacity: "0.45",
                        d: "M92.7775 111.384C92.7775 111.384 93.0339 123.561 88.6758 134.701C84.3178 145.841 79.4469 150.79 70.7308 153.873C64.826 155.962 49.4445 153.355 53.5463 147.914C57.648 142.473 76.3621 148.432 85.591 149.21C94.0508 149.987 95.0762 150.764 106.612 150.764C114.816 150.764 123.532 149.728 132.504 155.168C141.477 160.609 146.348 157.241 149.424 155.168C152.5 153.096 155.064 152.578 158.909 152.578C162.755 152.578 173.009 153.873 173.009 153.873",
                        fill: fifthColor,
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M92.7775 111.384C92.7775 111.384 93.0339 123.561 88.6758 134.701C84.3177 145.841 79.4469 150.79 70.7308 153.873C67.9108 154.87 54.3238 155.946 51.5039 148.432C48.684 140.919 57.6565 135.737 69.9617 139.364C74.3197 140.439 78.9342 143.467 87.394 147.137C94.572 150.251 103.032 152.578 113.543 149.21C128.411 143.51 134.82 127.965 134.82 127.965C134.82 127.965 140.452 113.716 147.886 117.084C155.32 120.452 153.782 131.333 153.782 136.515C153.782 141.696 154.038 148.691 159.422 151.282C164.806 153.873 173.009 153.873 173.009 153.873",
                        stroke: "black",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "87.394",
                        y: "86.7715",
                        width: "2.5636",
                        height: "11.3995",
                        rx: "1.2818",
                        fill: secondColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "95.5974",
                        y: "86.7715",
                        width: "2.56358",
                        height: "11.3995",
                        rx: "1.28179",
                        fill: secondColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M87.9067 107.326C87.9067 106.849 88.2934 106.462 88.7703 106.462H96.272C96.749 106.462 97.1356 106.849 97.1356 107.326C97.1356 109.71 95.2024 111.644 92.8176 111.644H92.2247C89.84 111.644 87.9067 109.71 87.9067 107.326Z",
                        fill: "url(#paint2_linear_324_1292)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M83.2837 96.0254C83.2837 94.9208 84.1791 94.0254 85.2837 94.0254H100.254C101.359 94.0254 102.254 94.9208 102.254 96.0254V97.4942C102.254 102.733 98.0075 106.979 92.7689 106.979C87.5304 106.979 83.2837 102.733 83.2837 97.4942V96.0254Z",
                        fill: "url(#paint3_linear_324_1292)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_d_324_1292",
                        x: "42.9788",
                        y: "12.6553",
                        width: "99.0681",
                        height: "106.262",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feMorphology", {
                                radius: "2",
                                operator: "dilate",
                                in: "SourceAlpha",
                                result: "effect1_dropShadow_324_1292"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "13"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_324_1292"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_324_1292",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_324_1292",
                        x1: "72.0042",
                        y1: "62.7352",
                        x2: "113.021",
                        y2: "62.7352",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.528337",
                                stopColor: sixthColor
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: octaveColor
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_324_1292",
                        x1: "92.5127",
                        y1: "68.8947",
                        x2: "92.7745",
                        y2: "78.4806",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "white",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: octaveColor
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_324_1292",
                        x1: "92.5127",
                        y1: "110.866",
                        x2: "94.0799",
                        y2: "106.472",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: seventhColor
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: ninthColor
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_324_1292",
                        x1: "96.291",
                        y1: "91.6937",
                        x2: "91.8204",
                        y2: "107.427",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: seventhColor
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: tenthColor
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_324_1292",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "183",
                            height: "161",
                            fill: octaveColor,
                            transform: "translate(0.5)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip1_324_1292",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "80.2075",
                            y: "53.0908",
                            width: "25.1231",
                            height: "25.3899",
                            rx: "12.5615",
                            fill: octaveColor
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/OpsIcon.tsx


var OpsIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "163" : _width, _height = param.height, height = _height === void 0 ? "71" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.150 */.rS.colors.primary[150] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 163 71",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M49.3 32.48C49.3 37.4933 48.2067 41.84 46.02 45.52C43.8333 49.2 40.8733 52 37.14 53.92C33.46 55.84 29.3533 56.8 24.82 56.8C20.2867 56.8 16.1533 55.84 12.42 53.92C8.74 52 5.80667 49.2 3.62 45.52C1.43333 41.84 0.34 37.4933 0.34 32.48V24.64C0.34 19.6267 1.43333 15.28 3.62 11.6C5.80667 7.92 8.74 5.12 12.42 3.2C16.1533 1.28 20.2867 0.319997 24.82 0.319997C29.3533 0.319997 33.46 1.28 37.14 3.2C40.8733 5.12 43.8333 7.92 46.02 11.6C48.2067 15.28 49.3 19.6267 49.3 24.64V32.48ZM36.34 22.88C36.34 18.8267 35.2733 15.7067 33.14 13.52C31.0067 11.28 28.2333 10.16 24.82 10.16C21.4067 10.16 18.6333 11.28 16.5 13.52C14.3667 15.7067 13.3 18.8267 13.3 22.88V34.24C13.3 38.2933 14.3667 41.44 16.5 43.68C18.6333 45.8667 21.4067 46.96 24.82 46.96C28.2333 46.96 31.0067 45.8667 33.14 43.68C35.2733 41.44 36.34 38.2933 36.34 34.24V22.88ZM68.8206 20.24C71.8073 16.2933 75.6473 14.32 80.3406 14.32C83.5406 14.32 86.4206 15.0933 88.9806 16.64C91.5406 18.1867 93.5673 20.5333 95.0606 23.68C96.554 26.8267 97.3006 30.72 97.3006 35.36V36.24C97.3006 40.6667 96.6073 44.4267 95.2206 47.52C93.834 50.6133 91.9406 52.9333 89.5406 54.48C87.194 56.0267 84.5273 56.8 81.5406 56.8C78.9806 56.8 76.714 56.2667 74.7406 55.2C72.8206 54.1333 71.274 52.8267 70.1006 51.28V70.48H58.4206V15.12H67.6206L68.8206 20.24ZM85.4606 32C85.4606 28.8533 84.7406 26.4533 83.3006 24.8C81.8606 23.1467 80.0206 22.32 77.7806 22.32C75.5406 22.32 73.7006 23.1467 72.2606 24.8C70.8206 26.4533 70.1006 28.8533 70.1006 32V38.64C70.1006 41.7333 70.8206 44.1333 72.2606 45.84C73.7006 47.4933 75.5406 48.32 77.7806 48.32C80.0206 48.32 81.8606 47.4933 83.3006 45.84C84.7406 44.1333 85.4606 41.7333 85.4606 38.64V32ZM113.359 43.52C113.359 45.3867 114.185 46.7467 115.839 47.6C117.492 48.4 119.545 48.8 121.999 48.8C124.132 48.8 126.025 48.48 127.679 47.84C129.385 47.2 130.239 46.1867 130.239 44.8C130.239 43.3067 129.465 42.24 127.919 41.6C126.372 40.96 123.972 40.4 120.719 39.92C117.305 39.3333 114.505 38.6933 112.319 38C110.132 37.3067 108.239 36.1067 106.639 34.4C105.092 32.6933 104.319 30.32 104.319 27.28C104.319 24.5067 105.119 22.16 106.719 20.24C108.372 18.2667 110.532 16.8 113.199 15.84C115.919 14.8267 118.879 14.32 122.079 14.32H123.679C126.505 14.32 129.172 14.8 131.679 15.76C134.239 16.6667 136.292 17.9733 137.839 19.68C139.385 21.3333 140.159 23.2267 140.159 25.36C140.159 25.7867 140.132 26.1867 140.079 26.56C140.025 26.88 139.999 27.0667 139.999 27.12H129.759C129.759 23.92 127.305 22.32 122.399 22.32C120.159 22.32 118.345 22.64 116.959 23.28C115.625 23.92 114.959 24.8 114.959 25.92C114.959 27.2533 115.679 28.1867 117.119 28.72C118.612 29.2533 120.932 29.76 124.079 30.24C127.652 30.8267 130.532 31.4667 132.719 32.16C134.959 32.8 136.905 34 138.559 35.76C140.212 37.4667 141.039 39.8933 141.039 43.04C141.039 47.8933 139.332 51.4133 135.919 53.6C132.505 55.7333 128.159 56.8 122.879 56.8H120.239C116.932 56.8 113.972 56.2933 111.359 55.28C108.745 54.2667 106.692 52.8267 105.199 50.96C103.759 49.0933 103.039 46.96 103.039 44.56L103.119 42.96H113.359V43.52ZM148.324 1.12H162.484L159.204 39.84H151.444L148.324 1.12ZM149.604 44.24H161.284V56H149.604V44.24Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/OrderApproved.tsx


var OrderApproved = function(param) {
    var _width = param.width, width = _width === void 0 ? 44 : _width, _height = param.height, height = _height === void 0 ? 44 : _height, _alt = param.alt, alt = _alt === void 0 ? "pedido aprovado" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.275 */.rS.colors.secondary[275] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: width,
                height: height,
                rx: "22",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28 31.5H16C15.4695 31.5001 14.9607 31.2895 14.5856 30.9144C14.2105 30.5393 13.9999 30.0305 14 29.5L15 19C15.0003 18.1717 15.6717 17.5003 16.5 17.5H27.5C28.3283 17.5003 28.9997 18.1717 29 19L30 29.5C30.0001 30.0305 29.7895 30.5393 29.4144 30.9144C29.0393 31.2895 28.5305 31.5001 28 31.5Z",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 19.5V17C18 14.929 19.5 12.5 21.75 12.5H22.25C24.5 12.5 26 14.929 26 17V19.5",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 25.5L21 27.5L25 23",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/OrderCancelled.tsx


var OrderCancelled = function(param) {
    var _width = param.width, width = _width === void 0 ? 44 : _width, _height = param.height, height = _height === void 0 ? 44 : _height, _alt = param.alt, alt = _alt === void 0 ? "pedido cancelado" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.520 */.rS.colors.neutral[520] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        "aria-labelledby": alt,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: width,
                height: height,
                rx: "22",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 12L12 32",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 12L32 32",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/OrderCancelledIcon.tsx


var OrderCancelledIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 190 : _width, _height = param.height, height = _height === void 0 ? 190 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.275 */.rS.colors.neutral[275] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 300 300",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M92.0039 44H58.0039V78H92.0039V44ZM50.0039 86V36H100.004H200.004H250.004V86V169.165C264.493 173.985 292.504 187.707 292.504 205.5C292.504 226.332 263.786 234.735 250.004 234.278V236H235.375C209.041 244.944 99.4194 260.088 76.5039 262.5C38.5039 266.5 8.50406 251 8.00406 221.5C7.61728 198.68 34.9377 180.878 50.0039 174.151V86ZM242.004 78V44H208.004V78H242.004ZM200.004 44V86H242.004V228H100.004V186H58.0039V86H100.004V44H200.004ZM92.0039 194V228H58.0039V194H92.0039ZM216.004 52H234.004V70H216.004V52ZM84.0039 52H66.0039V70H84.0039V52ZM66.0039 202H84.0039V220H66.0039V202ZM135.832 105.172C137.394 106.734 137.394 109.266 135.832 110.828L122.161 124.5L135.832 138.172C137.394 139.734 137.394 142.266 135.832 143.828C134.27 145.391 131.738 145.391 130.175 143.828L116.504 130.157L102.832 143.828C101.27 145.391 98.7378 145.391 97.1753 143.828C95.6132 142.266 95.6132 139.734 97.1753 138.172L110.847 124.5L97.1753 110.828C95.6132 109.266 95.6132 106.734 97.1753 105.172C98.7378 103.609 101.27 103.609 102.832 105.172L116.504 118.843L130.175 105.172C131.738 103.609 134.27 103.609 135.832 105.172ZM170.332 105.172C168.77 103.609 166.238 103.609 164.675 105.172C163.113 106.734 163.113 109.266 164.675 110.828L178.347 124.5L164.675 138.172C163.113 139.734 163.113 142.266 164.675 143.828C166.238 145.391 168.77 145.391 170.332 143.828L184.004 130.157L197.675 143.828C199.238 145.391 201.77 145.391 203.332 143.828C204.894 142.266 204.894 139.734 203.332 138.172L189.661 124.5L203.332 110.828C204.894 109.266 204.894 106.734 203.332 105.172C201.77 103.609 199.238 103.609 197.675 105.172L184.004 118.843L170.332 105.172ZM170.004 184C170.004 172.954 161.05 164 150.004 164C138.958 164 130.004 172.954 130.004 184H170.004Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/OrderCancelling.tsx


var OrderCancelling = function(param) {
    var _width = param.width, width = _width === void 0 ? 44 : _width, _height = param.height, height = _height === void 0 ? 44 : _height, _alt = param.alt, alt = _alt === void 0 ? "pedido cancelado" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.200 */.rS.colors.primary[200] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 ".concat(width, " ").concat(width),
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: width,
                height: height,
                rx: "22",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 12L12 32",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 12L32 32",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/OrderDelivered.tsx


var OrderDelivered = function(param) {
    var _width = param.width, width = _width === void 0 ? 44 : _width, _height = param.height, height = _height === void 0 ? 44 : _height, _alt = param.alt, alt = _alt === void 0 ? "pedido entregue" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.275 */.rS.colors.secondary[275] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: width,
                height: height,
                rx: "22",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 13L18 32L12 25.5",
                stroke: secondColor,
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/OrderDelivering.tsx


var OrderDelivering = function(param) {
    var _width = param.width, width = _width === void 0 ? 44 : _width, _height = param.height, height = _height === void 0 ? 44 : _height, _alt = param.alt, alt = _alt === void 0 ? "pedido em transporte" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.275 */.rS.colors.secondary[275] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 ".concat(width, " ").concat(width),
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "44",
                height: "44",
                rx: "22",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5575 29.0446H25.7932",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "27.4189",
                cy: "29.0446",
                r: "1.62568",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "14.9318",
                cy: "29.0446",
                r: "1.62568",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.25 28.5V24.0168L25.2514 23.4749V16.5811C25.2514 15.384 24.2809 14.4135 23.0838 14.4135H13.3297C12.1326 14.4135 11.1622 15.384 11.1622 16.5811V27.9608C11.1622 28.5594 11.6474 29.0446 12.2459 29.0446H13.3062",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.2514 16.5811H28.7699C29.9105 16.5811 30.929 17.2954 31.3174 18.3678L32.7083 22.2077C32.794 22.4444 32.8378 22.6942 32.8378 22.9459V27.4189C32.8378 28.3168 32.11 29.0446 31.2122 29.0446H29.0446",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.2917 22H29.5833H29.0417H28.0538H25.2514",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.4167 18.6474H14.7163C14.8798 18.6474 14.9343 18.7019 14.9343 18.8654V22.8159H16.1058V20.7998H17.795V19.8462H16.1058V18.6474H18.1488V17.6667H14.4167V18.6474Z",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.8106 22.7773C18.8106 21.7965 19.4644 21.2517 20.3092 21.2517C20.8813 21.2517 21.3445 21.4151 21.8348 21.742V20.7067C21.3313 20.3826 20.7443 20.2122 20.1455 20.2163C18.6198 20.2163 17.6118 21.2789 17.6118 22.8045C17.6118 24.3302 18.6743 25.3655 20.2272 25.3655C20.8305 25.3736 21.4212 25.1925 21.9163 24.8478V23.7853C21.3715 24.1394 20.8538 24.3029 20.3089 24.3029C19.4644 24.2757 18.8106 23.7308 18.8106 22.7773Z",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/OrderWaitingPayment.tsx


var OrderWaitingPayment = function(param) {
    var _width = param.width, width = _width === void 0 ? 44 : _width, _height = param.height, height = _height === void 0 ? 44 : _height, _alt = param.alt, alt = _alt === void 0 ? "pedido aguardando pagamento" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.yellow.50 */.rS.colors.yellow[50] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: width,
                height: height,
                rx: "22",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.5556 18.6667H13.1111C12.4978 18.6667 12 18.1689 12 17.5556V13.1111C12 12.4978 12.4978 12 13.1111 12H17.5556C18.1689 12 18.6667 12.4978 18.6667 13.1111V17.5556C18.6667 18.1689 18.1689 18.6667 17.5556 18.6667Z",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.5556 32H13.1111C12.4978 32 12 31.5022 12 30.8889V26.4444C12 25.8311 12.4978 25.3333 13.1111 25.3333H17.5556C18.1689 25.3333 18.6667 25.8311 18.6667 26.4444V30.8889C18.6667 31.5022 18.1689 32 17.5556 32Z",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M30.8889 18.6667H26.4444C25.8311 18.6667 25.3333 18.1689 25.3333 17.5556V13.1111C25.3333 12.4978 25.8311 12 26.4444 12H30.8889C31.5022 12 32 12.4978 32 13.1111V17.5556C32 18.1689 31.5022 18.6667 30.8889 18.6667Z",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 14.2222V12",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.4444 22H23.1111C22.4978 22 22 21.5022 22 20.8889V18.6667",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.1111 22H12",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.3333 28.6667H23.1111C22.4978 28.6667 22 29.1644 22 29.7778V32",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 25.3333H28.6667",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 25.3333V30.8889C32 31.5022 31.5022 32 30.8889 32H25.3333",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.3333 15.3222C15.33 15.3222 15.3278 15.3244 15.3278 15.3278C15.3278 15.3311 15.33 15.3333 15.3333 15.3333C15.3367 15.3333 15.3389 15.3311 15.3389 15.3278C15.3389 15.3244 15.3367 15.3222 15.3333 15.3222",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.6611 15.3278C28.6578 15.3278 28.6555 15.33 28.6555 15.3333C28.6555 15.3367 28.6578 15.3389 28.6611 15.3389C28.6644 15.3389 28.6666 15.3367 28.6666 15.3333C28.6666 15.33 28.6644 15.3278 28.6611 15.3278",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.7722 21.9944C29.7689 21.9944 29.7667 21.9967 29.7667 22C29.7667 22.0033 29.7689 22.0056 29.7722 22.0056C29.7756 22.0056 29.7778 22.0033 29.7778 22C29.7778 21.9967 29.7756 21.9944 29.7722 21.9944",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.6611 28.6611C28.6578 28.6611 28.6555 28.6633 28.6555 28.6667C28.6555 28.67 28.6578 28.6722 28.6611 28.6722C28.6644 28.6722 28.6666 28.67 28.6666 28.6667C28.6666 28.6633 28.6644 28.6611 28.6611 28.6611",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.3389 28.6611C15.3355 28.6611 15.3333 28.6633 15.3333 28.6667C15.3333 28.67 15.3355 28.6722 15.3389 28.6722C15.3422 28.6722 15.3444 28.67 15.3444 28.6667C15.3444 28.6633 15.3422 28.6611 15.3389 28.6611",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.4444 22H18.6666",
                stroke: secondColor,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/OrderWithdrawAvailable.tsx


var OrderWithdrawAvailable = function(param) {
    var _width = param.width, width = _width === void 0 ? 44 : _width, _height = param.height, height = _height === void 0 ? 44 : _height, _alt = param.alt, alt = _alt === void 0 ? "pedido pronto para retirada" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.yellow.50 */.rS.colors.yellow[50] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: width,
                height: height,
                rx: "22",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.4498 18.0833L13.8759 12H30.0449L33.5378 18.0833H10.4498Z",
                stroke: secondColor,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.2503 18.1457C9.5211 21.5415 15.5002 23.1456 16.1044 18.3123C15.8127 21.8332 21.4794 22.8123 21.9586 18.479C22.0184 21.9396 27.4201 22.563 27.8961 18.6248C28.6669 23.0623 34.4772 21.4145 33.7502 18.229",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.2083 21.5208V31.9791C12.2083 32.2552 12.4322 32.4791 12.7083 32.4791H31.2599C31.536 32.4791 31.7599 32.2552 31.7599 31.9791V21.5208",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.4374 32.75V25.5C20.4374 24.9477 19.9897 24.5 19.4374 24.5H16.6041C16.0518 24.5 15.6041 24.9477 15.6041 25.5V32.75",
                stroke: secondColor,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 24.75H28C28.1381 24.75 28.25 24.8619 28.25 25V29C28.25 29.1381 28.1381 29.25 28 29.25H24C23.8619 29.25 23.75 29.1381 23.75 29V25C23.75 24.8619 23.8619 24.75 24 24.75Z",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/OutForDeliveryTrackingStatusIcon.tsx


var OutForDeliveryTrackingStatusIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Saiu Para Entrega" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.0715 17.7261H17.627C17.1668 17.7261 16.7937 17.353 16.7937 16.8928V14.3333",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "21.4167",
                cy: "22.25",
                rx: "1.25",
                ry: "1.25",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.3333 14.3333H17.1805C18.3608 14.3333 19.4723 14.889 20.1805 15.8333L21.0813 17.0344C21.2366 17.2414 21.4379 17.4094 21.6693 17.5251L23.4119 18.3964C23.9766 18.6787 24.3333 19.2558 24.3333 19.8871V21.2083C24.3333 21.7835 23.8669 22.2499 23.2916 22.2499H22.6666",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1667 22.2499H17.6667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.3318 23.5001H12.2484C12.0274 23.5001 11.8155 23.4122 11.6594 23.2559C11.5032 23.0995 11.4157 22.8875 11.416 22.6665V20.5831C11.416 20.3621 11.5039 20.1502 11.6602 19.9941C11.8166 19.8379 12.0287 19.7504 12.2496 19.7507H14.333C14.554 19.7507 14.7659 19.8386 14.922 19.995C15.0782 20.1513 15.1657 20.3634 15.1654 20.5843V22.6678C15.1654 22.8887 15.0775 23.1006 14.9212 23.2568C14.7648 23.4129 14.5528 23.5004 14.3318 23.5001Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.5825 23.5001H8.50036C8.27919 23.5004 8.067 23.4126 7.91062 23.2562C7.75423 23.0999 7.66649 22.8877 7.66675 22.6665V20.5831C7.66675 20.3621 7.75461 20.1502 7.91098 19.9941C8.06735 19.8379 8.27938 19.7504 8.50036 19.7507H10.5838C10.8047 19.7507 11.0166 19.8386 11.1728 19.995C11.3289 20.1513 11.4165 20.3634 11.4161 20.5843V22.6678C11.4161 22.8887 11.3283 23.1006 11.1719 23.2568C11.0155 23.4129 10.8035 23.5004 10.5825 23.5001V23.5001Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.457 19.7506H10.3736C10.1525 19.7507 9.94048 19.6629 9.78414 19.5065C9.6278 19.3502 9.53999 19.1381 9.54004 18.917V16.8336C9.53998 16.6125 9.62779 16.4004 9.78414 16.2441C9.94048 16.0878 10.1525 15.9999 10.3736 16H12.457C12.6782 15.9999 12.8902 16.0878 13.0466 16.2441C13.2029 16.4004 13.2907 16.6125 13.2907 16.8336V18.917C13.2909 19.1382 13.2032 19.3504 13.0468 19.5068C12.8904 19.6632 12.6782 19.7509 12.457 19.7506V19.7506Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.5 14.3334V12.6993C23.5 11.9427 23.0898 11.2456 22.4285 10.8781L17.2146 7.98139C16.4595 7.56187 15.5413 7.56187 14.7863 7.98139L9.57154 10.8786C8.91018 11.246 8.5 11.9432 8.5 12.6997V13.5001",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Package.tsx


var Package = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Pacote" : _alt, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.21063 4V8.39467H20.7893V4H3.21063ZM3.94308 9.12712V20.48H20.0569V9.12712H3.94308ZM10.2533 11.2258H13.7466C14.2531 11.2258 14.6622 11.6349 14.6622 12.1413C14.6622 12.6478 14.2531 13.0569 13.7466 13.0569H10.2533C9.74689 13.0569 9.33775 12.6478 9.33775 12.1413C9.33775 11.6349 9.74689 11.2258 10.2533 11.2258Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PackageIcon.tsx


var PackageIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.750 */.rS.colors.neutral[750] : _color, _width = param.width, width = _width === void 0 ? 18 : _width, _height = param.height, height = _height === void 0 ? 18 : _height, _alt = param.alt, alt = _alt === void 0 ? "Pacote" : _alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.7527 6.06443V14.2511C15.7527 15.0799 15.0808 15.7517 14.2521 15.7517H3.7477C2.91893 15.7517 2.24707 15.0799 2.24707 14.2511V6.06443C2.24679 5.86095 2.28789 5.65954 2.36787 5.47244L3.35829 3.15472C3.5951 2.60313 4.13783 2.24573 4.73811 2.24609H13.2617C13.8625 2.24609 14.4054 2.6045 14.6415 3.15697L15.6319 5.47244C15.7118 5.65958 15.7529 5.86097 15.7527 6.06443Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.24707 5.9982H15.7452",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5006 2.24609L11.2509 5.99766V8.41741C11.2323 8.75571 10.944 9.01551 10.6056 8.99891H7.39429C7.05589 9.01551 6.7676 8.75571 6.74902 8.41741V5.99766L7.49934 2.24609",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.49805 13.5021H5.99867",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PackageThumbsUpIcon.tsx


var PackageThumbsUpIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.350 */.rS.colors.neutral[350] : _color, _width = param.width, width = _width === void 0 ? 21 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _alt = param.alt, alt = _alt === void 0 ? "Pacote com sinal de positivo" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.99707 9.99995V6.78194C2.99707 6.52854 3.04879 6.2778 3.1488 6.04497L4.1784 3.63563C4.47367 2.94507 5.15224 2.49707 5.90328 2.49683H15.0979C15.8489 2.49729 16.5274 2.94522 16.8228 3.63563L17.8524 6.04497C17.9519 6.27795 18.0033 6.52863 18.0033 6.78194V15.6273C18.0033 16.6633 17.1635 17.5031 16.1275 17.5031H13.0012",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.08105 13.9057L6.62003 11.3872C6.88323 10.9591 7.39833 10.7574 7.88224 10.8929C8.36615 11.0283 8.7016 11.4682 8.70423 11.9707V13.3005H9.96309C10.3414 13.3006 10.6945 13.4903 10.9035 13.8057C11.0895 14.0853 11.1434 14.4324 11.051 14.7552L10.4408 16.8911C10.3375 17.2512 10.0084 17.4994 9.63378 17.4997H6.65004C6.40651 17.5 6.17056 17.4151 5.9831 17.2596L5.08105 16.5093",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.66443 17.5032H3.41391C3.1837 17.5032 2.99707 17.3166 2.99707 17.0864V13.3348C2.99707 13.1046 3.1837 12.918 3.41391 12.918H4.66443C4.89465 12.918 5.08127 13.1046 5.08127 13.3348V17.0864C5.08127 17.3166 4.89465 17.5032 4.66443 17.5032Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.4998 6.66523V2.49683",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.835 14.1683H14.6686",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.99707 10V8.33264C2.99707 7.41179 3.74357 6.66528 4.66443 6.66528H16.336C17.2568 6.66528 18.0033 7.41179 18.0033 8.33264V14.1684",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PasteIcon.tsx


var PasteIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de colar" : _alt, _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 17 : _height, _color = param.color, color = _color === void 0 ? "".concat(themes/* theme.colors.neutral.110 */.rS.colors.neutral[110], " !important") : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Group",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Group_2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path",
                        d: "M4.66667 10.752H3.33333C2.59667 10.752 2 10.1553 2 9.41862V4.08529C2 3.34862 2.59667 2.75195 3.33333 2.75195H8.66667C9.40333 2.75195 10 3.34862 10 4.08529V5.41862",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_2",
                        d: "M8.66669 13.4186H6.00002C5.26335 13.4186 4.66669 12.8219 4.66669 12.0852V6.75191C4.66669 6.01525 5.26335 5.41858 6.00002 5.41858H11.3334C12.07 5.41858 12.6667 6.01525 12.6667 6.75191V9.41858",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_3",
                        d: "M12.6666 12.0853V14.752",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_4",
                        d: "M11.3333 13.4187H14",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PaymentCancelledIcon.tsx


var PaymentCancelledIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.155 */.rS.colors.primary[155] : _color, _width = param.width, width = _width === void 0 ? 21 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _alt = param.alt, alt = _alt === void 0 ? "Pagamento cancelado" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 21 20",
        "aria-label": alt,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.5 14.1667H7.16667",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.1667 16.6666H4.66667C3.74583 16.6666 3 15.9208 3 14.9999V7.14075C3 6.91575 3.04583 6.69242 3.13417 6.48575L4.04917 4.34492C4.31167 3.73159 4.91417 3.33325 5.58167 3.33325H13.7517C14.4192 3.33325 15.0217 3.73159 15.2842 4.34492L16.1992 6.48575C16.2875 6.69325 16.3333 6.91575 16.3333 7.14075V10.8333",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.66667 3.33325V7.03325",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.325 7.03337H3",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0234 11.8096C18.3251 13.1113 18.3251 15.2219 17.0234 16.5236C15.7216 17.8254 13.6111 17.8254 12.3093 16.5236C11.0076 15.2219 11.0076 13.1113 12.3093 11.8096C13.6111 10.5078 15.7216 10.5078 17.0234 11.8096Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.8 11.9317L12.4316 16.3",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PaymentDoneIcon.tsx


var PaymentDoneIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 21 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.yellow.1020 */.rS.colors.yellow[1020] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _alt = param.alt, alt = _alt === void 0 ? "Pagamento efetuado" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.49658 6.66538H17.5028",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.91574 10.0001H5.83154",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1682 10.8337C16.0099 10.8337 17.5029 12.3267 17.5029 14.1685C17.5029 16.0102 16.0099 17.5032 14.1682 17.5032C12.3265 17.5032 10.8335 16.0102 10.8335 14.1685C10.8335 12.3267 12.3265 10.8337 14.1682 10.8337",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.4655 13.5208L13.8448 15.1414L12.8711 14.1685",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.33235 15.0021H4.99762C3.61634 15.0021 2.49658 13.8823 2.49658 12.5011V5.83161C2.49658 4.45032 3.61634 3.33057 4.99762 3.33057H15.0018C16.3831 3.33057 17.5028 4.45032 17.5028 5.83161V9.16633",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PaymentMethods.tsx

var PaymentMethods = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": "M\xe9todos de pagamento",
        "aria-labelledby": "M\xe9todos de pagamento",
        xmlns: "https://www.w3.org/2000/svg",
        width: 185.605,
        height: 17.523,
        viewBox: "0 0 185.605 17.523",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    children: ".a,.j{fill:#fff;}.b{fill:#006fcf;}.c{fill:#fbc707;}.d{fill:#38a7e4;}.e{fill:#ef3120;}.f{fill:#231f20;}.g{fill:#b3131b;}.h{fill:#e85400;}.h,.i,.j{fill-rule:evenodd;}.i{fill:#ffe000;}.k{fill:#f79f1a;}.l{fill:#ea001b;}.m{fill:#ff5f01;}.n{fill:#3c58bf;}.o{fill:#293688;}.p{fill:#ffbc00;}.q{fill:#f7981d;}.r{fill:#ed7c00;}.s{fill:#051244;}"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                transform: "translate(-518.971 8.853)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "translate(420.133 -106.358)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M115.133,115.021H98.838V98.726h16.295Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M115.133,107.769V98.95H98.838v16.295h16.295v-4.754c-.036,0,0-2.722,0-2.722",
                                transform: "translate(0 -0.216)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M113.137,257.325h1.234v-2.867h-1.343v.4l-.254-.4h-1.161v.508l-.218-.508h-2.141c-.073,0-.145.036-.218.036s-.109.036-.181.073-.109.036-.181.073v-.181H102.54l-.181.472-.181-.472h-1.452v.508l-.218-.508H99.346l-.508,1.234v1.633h.835l.145-.4h.29l.145.4h6.387v-.363l.254.363h1.778v-.218c.036.036.109.036.145.073s.109.036.145.073a.46.46,0,0,0,.218.036h1.306l.145-.4h.29l.145.4h1.778v-.363Zm2,3.629v-2.686h-9.98l-.254.363-.254-.363h-2.9v2.867h2.9l.254-.363.254.363h1.815v-.617H106.9a1.758,1.758,0,0,0,.653-.109v.762h1.306v-.363l.254.363h5.407A3.09,3.09,0,0,0,115.133,260.954Z",
                                transform: "translate(0 -150.68)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "b",
                                d: "M114.516,274.337h-.98v.4h.944a.6.6,0,0,0,.653-.617.508.508,0,0,0-.581-.544h-.436a.181.181,0,0,1,0-.363h.835l.181-.4h-.98a.594.594,0,0,0-.653.581.508.508,0,0,0,.581.544h.436a.171.171,0,0,1,.181.181C114.734,274.264,114.661,274.337,114.516,274.337Zm-1.778,0h-.98v.4h.944a.6.6,0,0,0,.653-.617.508.508,0,0,0-.581-.544h-.436a.181.181,0,0,1,0-.363h.835l.181-.4h-.98a.594.594,0,0,0-.653.581.508.508,0,0,0,.581.544h.436a.171.171,0,0,1,.181.181A.169.169,0,0,1,112.738,274.337Zm-1.27-1.161v-.4h-1.524V274.7h1.524v-.4h-1.089v-.4h1.052v-.4h-1.052v-.363h1.089Zm-2.468,0c.181,0,.254.109.254.218s-.073.218-.254.218h-.544v-.472Zm-.544.835h.218l.581.69h.544l-.653-.726a.582.582,0,0,0,.508-.581.6.6,0,0,0-.653-.617h-1.016V274.7h.436Zm-1.161-.581a.229.229,0,0,1-.254.254h-.581v-.508H107A.259.259,0,0,1,107.294,273.429Zm-1.27-.653V274.7h.436v-.653h.581a.639.639,0,0,0,.69-.653.629.629,0,0,0-.653-.653Zm-.653,1.923h.544l-.762-.98.762-.944h-.544l-.472.617-.472-.617h-.544l.762.944-.762.944h.544l.472-.617Zm-1.633-1.524v-.4h-1.524V274.7h1.524v-.4h-1.089v-.4H103.7v-.4h-1.052v-.363h1.089Zm8.819-3.411.762,1.161h.544V269h-.436v1.27l-.109-.181-.69-1.089h-.581v1.923h.436v-1.306Zm-1.887-.036.145-.4.145.4.181.435h-.653Zm.762,1.2h.472L111.069,269h-.581l-.835,1.923h.472l.181-.4h.944Zm-2.032,0,.181-.4h-.109a.487.487,0,0,1-.508-.544v-.036a.487.487,0,0,1,.508-.544h.472V269h-.508a.867.867,0,0,0-.907.944v.036A.841.841,0,0,0,109.4,270.925Zm-1.633,0h.435v-1.887h-.435Zm-.944-1.524c.181,0,.254.109.254.218s-.073.218-.254.218h-.544v-.472Zm-.544.835h.218l.581.69h.544l-.653-.726a.582.582,0,0,0,.508-.581.6.6,0,0,0-.653-.617h-1.016v1.923h.435Zm-.8-.835V269h-1.524v1.923h1.524v-.4h-1.089v-.4h1.052v-.4h-1.052v-.363h1.089Zm-3.3,1.524h.4l.544-1.561v1.561h.435V269h-.726l-.435,1.306L101.959,269h-.726v1.923h.435v-1.561Zm-2.359-1.2.145-.4.145.4.181.435h-.653Zm.762,1.2h.472L100.217,269h-.544l-.835,1.923h.472l.181-.4h.944Z",
                                transform: "translate(0 -164.752)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "translate(113.478 476.008)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(435.492 -480.027)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "c",
                                    d: "M-4.028-13.635a2.663,2.663,0,0,1,.847-.137A2.671,2.671,0,0,1-.564-11.635l1.831-.374A4.54,4.54,0,0,0-3.181-15.64a4.526,4.526,0,0,0-1.439.233Z",
                                    transform: "translate(4.62 15.64)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(432.392 -478.888)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "d",
                                    d: "M-10.416-46.228l1.238-1.4a2.665,2.665,0,0,1-.9-2,2.663,2.663,0,0,1,.9-2l-1.238-1.4a4.528,4.528,0,0,0-1.531,3.4,4.529,4.529,0,0,0,1.532,3.4",
                                    transform: "translate(11.948 53.027)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(435.491 -474.953)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "e",
                                    d: "M-27.583,0A2.67,2.67,0,0,1-30.2,2.134,2.65,2.65,0,0,1-31.047,2l-.593,1.772A4.53,4.53,0,0,0-30.2,4,4.539,4.539,0,0,0-25.752.375Z",
                                    transform: "translate(31.64)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(442.558 -477.643)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "f",
                                    d: "M-27.742-24.89v0l-.052-.036a1.466,1.466,0,0,1-.679.568,1.319,1.319,0,0,1-1.456-.146l-.034.052h0l-.638.954a2.736,2.736,0,0,0,.507.278,2.641,2.641,0,0,0,2.135-.03,2.626,2.626,0,0,0,1.192-.992Zm-1.99-2.353a1.379,1.379,0,0,0-.836,1.464l2.512-1.082a1.333,1.333,0,0,0-1.677-.382M-31.4-24.338a3.217,3.217,0,0,1-.191-.367,2.694,2.694,0,0,1-.059-2.038A2.69,2.69,0,0,1-30.2-28.323a2.788,2.788,0,0,1,2.56.186A2.737,2.737,0,0,1-26.5-26.758c.035.082.065.169.1.243Z",
                                    transform: "translate(31.822 28.55)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(448.545 -478.82)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "f",
                                    d: "M-8.012,0V5.3l.824.334-.468,1.093-.91-.378a1.035,1.035,0,0,1-.449-.377,1.189,1.189,0,0,1-.176-.657V0Z",
                                    transform: "translate(9.191)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(450.592 -476.943)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "f",
                                    d: "M-8.609-14.1a1.5,1.5,0,0,1,.515-1.132l-.846-.943a2.763,2.763,0,0,0-.935,2.073,2.76,2.76,0,0,0,.933,2.076l.844-.944A1.5,1.5,0,0,1-8.609-14.1",
                                    transform: "translate(9.875 16.179)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(452.481 -474.562)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "f",
                                    d: "M-5.986-8.149a1.514,1.514,0,0,1-.476-.078l-.4,1.2a2.771,2.771,0,0,0,.879.143A2.773,2.773,0,0,0-3.271-9.095l-1.242-.253a1.5,1.5,0,0,1-1.474,1.2",
                                    transform: "translate(6.867 9.348)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(452.486 -477.638)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "f",
                                    d: "M-5.973,0a2.77,2.77,0,0,0-.879.141l.4,1.2a1.522,1.522,0,0,1,.477-.077A1.5,1.5,0,0,1-4.5,2.471l1.242-.252A2.771,2.771,0,0,0-5.973,0",
                                    transform: "translate(6.852 0)"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "translate(468.762 1690.276)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(111.527 -1696.114)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "g",
                                    d: "M-100.78-53.478c1.471,0,2.755-.452,3.051-1.907s2.217-10.81,2.217-10.81h-23.971c-1.472,0-2.761.524-3.051,1.906s-2.211,10.809-2.211,10.809Z",
                                    transform: "translate(124.745 66.195)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(111.397 -1696.221)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "a",
                                    d: "M-101.328-54.37v-.212c1.458-.006,2.664-.437,2.946-1.823.275-1.354,1.96-9.559,2.192-10.683h-23.841c-1.455,0-2.672.509-2.948,1.822-.145.69-.7,3.392-1.215,5.922-.446,2.184-.864,4.237-.971,4.759l23.836,0v.212l-24.1,0,.026-.127s1.92-9.427,2.211-10.809c.305-1.45,1.666-2,3.155-1.991h24.1l-.026.128s-.48,2.338-1,4.86-1.072,5.223-1.219,5.95c-.307,1.514-1.654,1.992-3.126,1.992h-.029",
                                    transform: "translate(125.423 67.299)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(114.097 -1692.243)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "a",
                                    d: "M-.055-17.871l.2-1.016.2-1.073.173-1.08.162-1.015L.7-22.121h.718a.471.471,0,0,1-.014.065c-.026.123-.077.395-.149.814-.039.227-.091.485-.149.777l-.013.091h.058l.937.012L3-20.374h.072l.012-.091c.039-.252.078-.518.129-.8.1-.569.111-.608.143-.853h.73a.4.4,0,0,1-.019.065c-.013.065-.077.4-.187,1.015l-.2,1.08L3.5-18.887c-.1.608-.155.945-.167,1.016a.232.232,0,0,1-.008.064H2.59l.014-.064c.018-.078.051-.265.1-.563.019-.111.059-.3.11-.583l.1-.569c.032-.174.052-.278.058-.3s.007-.031.013-.064H2.907c-.122-.006-.563-.006-.983-.006s-.7,0-.829.006H1.012c-.013.124-.019.149-.058.369-.032.168-.064.362-.1.569-.051.305-.085.5-.1.583-.051.311-.084.5-.1.563a.285.285,0,0,1-.006.063H-.068Z",
                                    transform: "translate(0.068 22.121)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(118.119 -1692.3)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "a",
                                    d: "M-.08-18.123l.136-.693L.2-19.594l.124-.754c.062-.384.1-.624.111-.723a.274.274,0,0,1,.006-.062h.636a.278.278,0,0,1-.017.062c-.025.1-.068.339-.143.723l-.142.754-.129.778c-.057.364-.094.6-.107.693a.323.323,0,0,1,0,.061H-.1Zm.65-3.809c0-.315.154-.5.426-.5.185,0,.278.087.278.266,0,.309-.161.5-.427.5-.154,0-.247-.063-.273-.179a.541.541,0,0,1,0-.087",
                                    transform: "translate(0.099 22.432)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(119.078 -1691.069)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "a",
                                    d: "M-.08-18.686c.03-.135.1-.519.222-1.161l.2-1.107.179-1.063c.087-.519.137-.847.155-.983a.287.287,0,0,1,.006-.062h.551L1.224-23l-.03.172-.012.069a1.414,1.414,0,0,1,1.007-.37.961.961,0,0,1,1.063,1.081,3.011,3.011,0,0,1-.285,1.218,1.484,1.484,0,0,1-1.421.921A.677.677,0,0,1,.8-20.341l-.012.073-.142.915c-.05.309-.088.532-.1.662a.626.626,0,0,1-.005.074H-.1l.019-.069m1.235-3.623-.2,1.15a1.472,1.472,0,0,0-.024.236.533.533,0,0,0,.605.6.829.829,0,0,0,.643-.273A2.283,2.283,0,0,0,2.6-21.973c0-.5-.222-.749-.7-.749a.947.947,0,0,0-.724.322Z",
                                    transform: "translate(0.099 23.129)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(122.594 -1691.069)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "a",
                                    d: "M-5.226-13.488c-.833,0-1.243-.357-1.243-1.1a3.058,3.058,0,0,1,.285-1.248A1.527,1.527,0,0,1-4.656-16.7c.711,0,1.064.271,1.064.809a3.547,3.547,0,0,1-.1.673l-.068-.006c-.111-.006-.458-.006-1.039-.006-.494,0-.8,0-.914.006l-.063.006a2.16,2.16,0,0,0-.06.545c0,.5.283.761.815.761a2.561,2.561,0,0,0,1.052-.229l-.093.494a4.541,4.541,0,0,1-1.163.154m-.4-2.083c.068.007.3.007.681.007h.1c.278,0,.47,0,.581-.007h.056l.012-.08a1.256,1.256,0,0,0,.019-.2c0-.3-.2-.451-.6-.451a.844.844,0,0,0-.915.735Z",
                                    transform: "translate(6.468 16.696)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(125.55 -1691.069)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "a",
                                    d: "M-.05-12.949l.137-.693.148-.778.124-.754c.062-.384.1-.624.111-.723,0-.013.006-.031.006-.062h.556L1.02-15.9l-.073.389-.02.086a2.019,2.019,0,0,1,.222-.3.855.855,0,0,1,.644-.3.763.763,0,0,1,.346.08l-.08.445a1.16,1.16,0,0,0-.365-.061c-.37,0-.7.334-.829.846-.048.192-.093.415-.135.675a11.392,11.392,0,0,0-.162,1.155H-.062Z",
                                    transform: "translate(0.062 16.028)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(127.409 -1691.069)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "a",
                                    d: "M-10.791-2.314a2.42,2.42,0,0,0-.792-.143.954.954,0,0,0-.686.223A2.146,2.146,0,0,0-12.72-.855c0,.526.229.78.7.78a2.177,2.177,0,0,0,.883-.21l-.087.469a3.1,3.1,0,0,1-.988.161,1.033,1.033,0,0,1-.953-.389,1.174,1.174,0,0,1-.191-.729,2.828,2.828,0,0,1,.3-1.262,1.514,1.514,0,0,1,.365-.476,1.621,1.621,0,0,1,1.181-.352c.2,0,.407.013.742.043l.062.006Z",
                                    transform: "translate(13.357 2.864)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(129.981 -1691.069)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "a",
                                    d: "M-3.871-13.488c-.625,0-.921-.26-.921-.8,0-.8.568-1.267,1.551-1.267.154,0,.458.011.661.024l.013-.068a1.317,1.317,0,0,0,.043-.316c0-.247-.2-.372-.625-.372a3.73,3.73,0,0,0-1.032.162l.124-.508A.2.2,0,0,0-4-16.628a4.583,4.583,0,0,0,.47-.037c.185-.018.371-.03.543-.03.736,0,1.064.192,1.064.618a2.926,2.926,0,0,1-.068.506l-.1.563a8.77,8.77,0,0,0-.172,1.354.711.711,0,0,0,.005.1h-.556v-.049c0-.088.025-.279.05-.458a1.2,1.2,0,0,1-1.106.575m1.162-1.693a3.514,3.514,0,0,0-.408-.018,1.171,1.171,0,0,0-.772.185.8.8,0,0,0-.3.636c0,.31.185.476.524.476a.874.874,0,0,0,.793-.487,3.149,3.149,0,0,0,.221-.786Z",
                                    transform: "translate(4.792 16.696)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(133.035 -1691.069)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "a",
                                    d: "M-.053-12.949l.135-.693.15-.778.124-.754c.061-.384.1-.624.11-.723,0-.013.007-.031.007-.062h.557l-.014.062-.074.389-.018.086a2.041,2.041,0,0,1,.223-.3.852.852,0,0,1,.643-.3.77.77,0,0,1,.346.08l-.08.445a1.158,1.158,0,0,0-.366-.061c-.369,0-.7.334-.827.846-.05.192-.093.415-.136.675-.124.772-.136.834-.162,1.155h-.63Z",
                                    transform: "translate(0.066 16.028)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(134.893 -1692.325)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "a",
                                    d: "M-4.471-18.771a.924.924,0,0,1-1.063-1.056,2.781,2.781,0,0,1,.3-1.25,1.566,1.566,0,0,1,1.489-.9,2.382,2.382,0,0,1,.538.055c.05.018.082.025.174.055l.012-.074c.025-.124.056-.32.1-.593.049-.3.081-.513.1-.65l.007-.049h.63l-.012.044c-.05.248-.123.619-.216,1.125-.168.9-.229,1.243-.322,1.805a9.692,9.692,0,0,0-.161,1.378v.044H-3.47a2.074,2.074,0,0,1,.025-.259c.019-.1.025-.135.037-.241a1.052,1.052,0,0,1-1.064.568m.76-2.806a.963.963,0,0,0-.655.216A2.055,2.055,0,0,0-4.885-19.9c0,.488.2.71.63.71a.845.845,0,0,0,.76-.47,2.511,2.511,0,0,0,.155-.493c.074-.378.174-.915.229-1.243l.006-.067a1.683,1.683,0,0,0-.606-.117",
                                    transform: "translate(5.534 23.234)"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "translate(320.257 -211.128)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "h",
                                d: "M302.332,205l11.125-2.645a3.044,3.044,0,0,1,3.655,2.251l2.645,11.125a3.027,3.027,0,0,1-.428,2.379h-17l-2.248-9.455A3.044,3.044,0,0,1,302.332,205Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M328.03,290.606v4.754h1.079v-1.989h1.77v1.989h1.072v-4.754h-1.072v1.827h-1.77v-1.827Z",
                                transform: "translate(-25.721 -81.055)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M452.205,307.649a2.547,2.547,0,0,0,.035-.423,1.53,1.53,0,0,0-1.538-1.721,1.727,1.727,0,0,0-1.742,1.841A1.655,1.655,0,0,0,450.8,309.1a3.4,3.4,0,0,0,1.248-.212l-.141-.726a3.038,3.038,0,0,1-.952.141c-.5,0-.938-.212-.973-.656Zm-2.229-.734a.7.7,0,0,1,.663-.7.622.622,0,0,1,.607.7Z",
                                transform: "translate(-136.692 -94.726)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "a",
                                d: "M492.633,309.031h1.072v-1.749a1.268,1.268,0,0,1,.021-.24.689.689,0,0,1,.734-.543,1.541,1.541,0,0,1,.289.028v-1.008a1.105,1.105,0,0,0-.226-.014,1.013,1.013,0,0,0-.931.712h-.028l-.035-.635h-.924c.014.3.028.628.028,1.135v2.313Z",
                                transform: "translate(-176.741 -94.726)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "i",
                                d: "M382.736,288.283a.551.551,0,1,1-.551.551.551.551,0,0,1,.551-.551Z",
                                transform: "translate(-75.416 -78.923)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "j",
                                d: "M385,308.25h.538a.7.7,0,0,0,.785-.707c0-.361-.026-1.177-.694-1.177-.767,0-.643,1.013-.639,1.543,0,.113.007.227.01.34Zm-2.815-2.65h1.1v1.943a.641.641,0,0,0,.642.707c0-.875,0-1.776-.03-2.65h.921q.03.253.055.507a1.37,1.37,0,0,1,2.267.056c.477.759.639,2.931-1.6,2.931h-.522c.005.441.006.883.006,1.324h-1.1c0-.424,0-.868.006-1.324a1.559,1.559,0,0,1-1.74-1.549V305.6Z",
                                transform: "translate(-75.416 -94.748)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "translate(650.701 -4.429)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "k",
                                d: "M294.425,52.494a5.936,5.936,0,1,1-5.941-5.949,5.942,5.942,0,0,1,5.941,5.949Z",
                                transform: "translate(-275.223 -46.545)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "l",
                                d: "M78.956,52.494a5.936,5.936,0,1,1-5.936-5.949,5.942,5.942,0,0,1,5.936,5.949Z",
                                transform: "translate(-67.083 -46.545)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "m",
                                d: "M284.7,83.733a5.961,5.961,0,0,0,0,9.368,5.961,5.961,0,0,0,0-9.368Z",
                                transform: "translate(-275.106 -82.468)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(18.731 8.893)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                    transform: "translate(0 0)",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        className: "k",
                                        d: "M1.383,15.654v-.21H1.331l-.063.147L1.2,15.439H1.147v.21h.037v-.158l.058.137h.042l.063-.137v.163Zm-.352,0v-.179H1.1v-.037H.926v.037H1v.179Z",
                                        transform: "translate(-0.926 -15.439)"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "translate(680.508 -0.934)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "n",
                                d: "M184.8,187.277l1.222-6.877h1.91l-1.184,6.877Z",
                                transform: "translate(-175.975 -180.171)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "o",
                                d: "M184.8,187.277l1.566-6.877h1.566l-1.184,6.877Z",
                                transform: "translate(-175.975 -180.171)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "n",
                                d: "M253.845,175.906a4.846,4.846,0,0,0-1.757-.306c-1.91,0-3.285.955-3.285,2.33,0,1.031.955,1.566,1.719,1.91s.993.573.993.879c0,.458-.611.688-1.146.688a4.152,4.152,0,0,1-1.834-.382l-.267-.115L248,182.477a6.194,6.194,0,0,0,2.178.382c2.025,0,3.362-.955,3.362-2.407,0-.8-.5-1.413-1.643-1.91-.688-.344-1.108-.535-1.108-.879,0-.306.344-.611,1.108-.611a3.5,3.5,0,0,1,1.452.267l.191.076.306-1.49Z",
                                transform: "translate(-236.157 -175.6)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "o",
                                d: "M253.845,175.906a4.846,4.846,0,0,0-1.757-.306c-1.91,0-2.942.955-2.942,2.33a2,2,0,0,0,1.375,1.91c.764.344.993.573.993.879,0,.458-.611.688-1.146.688a4.152,4.152,0,0,1-1.834-.382l-.267-.115L248,182.477a6.194,6.194,0,0,0,2.178.382c2.025,0,3.362-.955,3.362-2.407,0-.8-.5-1.413-1.643-1.91-.688-.344-1.108-.535-1.108-.879,0-.306.344-.611,1.108-.611a3.5,3.5,0,0,1,1.452.267l.191.076.306-1.49Z",
                                transform: "translate(-236.157 -175.6)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "n",
                                d: "M362.259,180.4c-.458,0-.8.038-.993.5l-2.865,6.38h2.063l.382-1.146h2.445l.229,1.146h1.834l-1.6-6.877Zm-.879,4.584c.115-.344.764-2.025.764-2.025s.153-.42.267-.688l.115.649s.382,1.719.458,2.1h-1.6Z",
                                transform: "translate(-341.285 -180.171)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "o",
                                d: "M362.717,180.4c-.458,0-.8.038-.993.5l-3.324,6.38h2.063l.382-1.146h2.445l.229,1.146h1.834l-1.6-6.877Zm-1.337,4.584c.153-.382.764-2.025.764-2.025s.153-.42.267-.688l.115.649s.382,1.719.458,2.1h-1.6Z",
                                transform: "translate(-341.285 -180.171)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "n",
                                d: "M54.065,185.975l-.191-.993a5.538,5.538,0,0,0-2.674-3.018l1.719,6.112h2.063l3.094-6.877H56.014Z",
                                transform: "translate(-48.755 -180.933)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "o",
                                d: "M54.065,185.975l-.191-.993a5.538,5.538,0,0,0-2.674-3.018l1.719,6.112h2.063l3.094-6.877H56.4Z",
                                transform: "translate(-48.755 -180.933)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "p",
                                d: "M0,180.4l.344.076a6.443,6.443,0,0,1,4.775,3.744l-.688-3.247c-.115-.458-.458-.573-.879-.573Z",
                                transform: "translate(0 -180.171)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "q",
                                d: "M0,180.4H0c2.445.573,4.47,2.063,5.119,3.782L4.47,181.47a.933.933,0,0,0-.917-.726Z",
                                transform: "translate(0 -180.171)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: "r",
                                d: "M0,180.4H0c2.445.573,4.47,2.063,5.119,3.782l-.458-1.49a1.347,1.347,0,0,0-.8-1.108Z",
                                transform: "translate(0 -180.171)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                transform: "translate(2.483 0.993)",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        className: "s",
                                        d: "M56.737,200.22l-1.3-1.3-.611,1.452-.153-.955A5.538,5.538,0,0,0,52,196.4l1.719,6.112h2.063Z",
                                        transform: "translate(-52 -196.4)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        className: "s",
                                        d: "M186.748,290.881l-1.643-1.681-.306,1.681Z",
                                        transform: "translate(-178.458 -284.768)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        className: "s",
                                        d: "M251.324,274.8h0c.153.153.229.267.191.42,0,.458-.611.688-1.146.688a4.152,4.152,0,0,1-1.834-.382l-.267-.115L248,276.978a6.2,6.2,0,0,0,2.178.382,3.782,3.782,0,0,0,2.789-.955Z",
                                        transform: "translate(-238.64 -271.056)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        className: "s",
                                        d: "M364,224.6h1.8l.382-1.146h2.445l.229,1.146h1.834l-.649-2.789-2.292-2.216.115.611s.382,1.719.458,2.1h-1.6c.153-.382.764-2.025.764-2.025s.153-.42.267-.688",
                                        transform: "translate(-349.101 -218.492)"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Pencil.tsx


var Pencil = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: color,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.582 20.054l14.886-14.886 6.369 6.369-14.886 14.886-6.369-6.369zM21.153 8.758l-0.698-0.697-11.981 11.98 0.698 0.698 11.981-11.981zM22.549 10.154l-0.698-0.698-11.981 11.982 0.697 0.697 11.982-11.981zM23.945 11.55l-0.698-0.698-11.981 11.981 0.698 0.698 11.981-11.981zM23.319 2.356c0.781-0.783 2.045-0.788 2.82-0.013l3.512 3.512c0.775 0.775 0.77 2.038-0.012 2.82l-2.17 2.17-6.32-6.32 2.17-2.169zM5.092 20.883l6.030 6.030-5.284 1.877-2.623-2.623 1.877-5.284zM4.837 29.117l-3.066 1.117 1.117-3.066 1.949 1.949z"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PercentageDiscount.tsx


var PercentageDiscount = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.265 */.rS.colors.secondary[265] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "percentageDiscount",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                    id: "Oval",
                    cx: "6.28433",
                    cy: "7.10494",
                    rx: "0.615385",
                    ry: "0.761194",
                    fill: color
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                    id: "Oval_2",
                    cx: "10.715",
                    cy: "9.89596",
                    rx: "0.615385",
                    ry: "0.761194",
                    fill: color
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Shape",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.0468 9.08696L16.2944 9.43878C16.6725 9.97871 16.5119 10.7381 15.9531 11.0586L15.5884 11.2711C15.1903 11.501 14.9761 11.9712 15.0598 12.438L15.1367 12.8665C15.2538 13.5213 14.7921 14.1344 14.153 14.1727L13.7348 14.1971C13.2797 14.2215 12.8916 14.549 12.7711 15.0088L12.6607 15.4303C12.4901 16.0712 11.8209 16.4161 11.2286 16.1618L10.8405 15.9946C10.4189 15.8134 9.93375 15.9319 9.63261 16.2907L9.35824 16.6181C8.93999 17.1232 8.19384 17.1267 7.76556 16.632L7.48784 16.3081C7.18336 15.9528 6.69485 15.8413 6.2766 16.0294L5.89182 16.2001C5.30292 16.4648 4.62704 16.1339 4.4497 15.493L4.33259 15.0749C4.20545 14.6186 3.81062 14.2981 3.35557 14.2772L2.93732 14.2598C2.29824 14.232 1.82646 13.6258 1.93353 12.971L2.0038 12.5425C2.08076 12.0722 1.85992 11.6055 1.4584 11.3825L1.09035 11.177C0.524879 10.86 0.354234 10.1041 0.722291 9.5607L0.963201 9.20539C1.22753 8.81525 1.22084 8.29622 0.953163 7.91304L0.705561 7.56122C0.327467 7.02477 0.488073 6.26539 1.04685 5.94143L1.41156 5.72894C1.80973 5.49904 2.02387 5.02878 1.94022 4.562L1.86327 4.13354C1.74616 3.47865 2.2079 2.86557 2.84698 2.82726L3.26523 2.80287C3.72028 2.77849 4.10841 2.45105 4.22887 1.99124L4.33929 1.56974C4.50993 0.928794 5.17912 0.583936 5.77136 0.838226L6.15949 1.00543C6.58109 1.18657 7.06625 1.06813 7.36739 0.709339L7.64176 0.381898C8.06335 -0.123197 8.8095 -0.126681 9.23444 0.367964L9.51216 0.691922C9.81664 1.04723 10.3052 1.1587 10.7234 0.970595L11.1082 0.799908C11.6971 0.535168 12.373 0.866093 12.5503 1.50704L12.6674 1.92505C12.7946 2.38138 13.1894 2.70185 13.6444 2.72275L14.0627 2.74017C14.7018 2.76804 15.1735 3.37415 15.0665 4.02904L14.9962 4.4575C14.9192 4.92776 15.1401 5.39453 15.5416 5.61747L15.9097 5.82299C16.4751 6.13999 16.6458 6.89589 16.2777 7.4393L16.0368 7.79461C15.7725 8.18475 15.7792 8.70378 16.0468 9.08696ZM6.32688 5.3418C5.41678 5.3418 4.68066 6.10815 4.68066 7.05564C4.68066 7.99964 5.41678 8.76948 6.32688 8.76948C7.23699 8.76948 7.9731 8.00313 7.9731 7.05564C7.9731 6.10815 7.23699 5.3418 6.32688 5.3418ZM6.6443 11.4769C6.50377 11.6545 6.24948 11.6789 6.07883 11.5326C5.90819 11.3863 5.88477 11.1215 6.0253 10.9439L10.3449 5.52718C10.4855 5.34953 10.7398 5.32514 10.9104 5.47145C11.0811 5.61775 11.1045 5.88249 10.9639 6.06014L6.6443 11.4769ZM9.02051 9.9404C9.02051 10.8879 9.75662 11.6542 10.6667 11.6542C11.5768 11.6542 12.3129 10.8879 12.3129 9.9404C12.3129 8.99291 11.5768 8.22656 10.6667 8.22656C9.75662 8.22656 9.02051 8.99291 9.02051 9.9404Z",
                    fill: color
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Phone.tsx


var Phone = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.856 13.144C9.686 11.974 8.804 10.664 8.218 9.33499C8.094 9.05399 8.167 8.72499 8.384 8.50799L9.203 7.68999C9.874 7.01899 9.874 6.06999 9.288 5.48399L8.114 4.30999C7.333 3.52899 6.067 3.52899 5.286 4.30999L4.634 4.96199C3.893 5.70299 3.584 6.77199 3.784 7.83199C4.278 10.445 5.796 13.306 8.245 15.755C10.694 18.204 13.555 19.722 16.168 20.216C17.228 20.416 18.297 20.107 19.038 19.366L19.689 18.715C20.47 17.934 20.47 16.668 19.689 15.887L18.516 14.714C17.93 14.128 16.98 14.128 16.395 14.714L15.492 15.618C15.275 15.835 14.946 15.908 14.665 15.784C13.336 15.197 12.026 14.314 10.856 13.144Z",
            stroke: color,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PhoneCallIcon.tsx


var PhoneCallIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 21 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.8041 14.342L14.8266 13.3645C14.3383 12.8761 13.5466 12.8761 13.0591 13.3645L12.2908 14.1328C12.1191 14.3045 11.8591 14.362 11.6375 14.2645C10.5241 13.777 9.42415 13.0378 8.44331 12.057C7.46665 11.0803 6.72998 9.9853 6.24165 8.87613C6.13998 8.64697 6.19915 8.3778 6.37665 8.2003L7.06498 7.51197C7.62415 6.9528 7.62415 6.16197 7.13581 5.67363L6.15831 4.69613C5.50748 4.0453 4.45248 4.0453 3.80165 4.69613L3.25831 5.23863C2.64081 5.85613 2.38331 6.74697 2.54998 7.6303C2.96165 9.8078 4.22665 12.192 6.26748 14.2328C8.30831 16.2736 10.6925 17.5386 12.87 17.9503C13.7533 18.117 14.6441 17.8595 15.2616 17.242L15.8041 16.6995C16.455 16.0486 16.455 14.9936 15.8041 14.342V14.342Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.8333 6.32599C11.6924 6.31433 12.5558 6.63266 13.2116 7.28849",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5683 4.93188C14.2608 3.62438 12.5466 2.97021 10.8333 2.97021",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1742 9.66691C14.1858 8.80774 13.8675 7.94441 13.2117 7.28857",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5684 4.93164C16.8759 6.23914 17.53 7.95331 17.53 9.66664",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PickUpStore.tsx


var PickupStore = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _alt = param.alt, alt = _alt === void 0 ? "Retirada em loja" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-labelledby": alt,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 20H12",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.99995 20L4.00005 9.98749",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.7236 6.47765C22.0187 7.03345 22.0774 7.68474 21.8863 8.28433C21.5559 9.32453 20.5797 10.0228 19.4885 9.99943C18.3973 9.9761 17.4519 9.23678 17.1662 8.18341C17.1481 8.12223 17.0919 8.08025 17.0281 8.08025C16.9643 8.08025 16.9081 8.12223 16.89 8.18341C16.5982 9.25555 15.6246 9.99951 14.5135 9.99939C13.4024 9.99927 12.4289 9.2551 12.1374 8.1829C12.1193 8.12169 12.0631 8.07968 11.9993 8.07968C11.9355 8.07968 11.8793 8.12169 11.8612 8.1829C11.5695 9.2551 10.596 9.99918 9.48483 9.99914C8.37366 9.9991 7.40016 9.25495 7.10858 8.18273C7.09045 8.12156 7.03425 8.0796 6.97045 8.0796C6.90665 8.0796 6.85045 8.12156 6.83232 8.18273C6.54658 9.23599 5.60124 9.97521 4.51016 9.99858C3.41908 10.0219 2.44296 9.32387 2.1124 8.28381C1.92126 7.68412 1.97992 7.0327 2.27512 6.47681L3.98184 3.09822C4.32207 2.4247 5.01242 2 5.767 2H18.2313C18.9859 2 19.6762 2.4247 20.0165 3.09822L21.7236 6.47765Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 16.5C15 18.1385 16.788 19.8888 17.808 20.7544C18.2108 21.0819 18.7882 21.0819 19.191 20.7544C20.212 19.8888 22 18.1385 22 16.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.5002 16.45C18.5278 16.4501 18.5501 16.4725 18.55 16.5001C18.5499 16.5277 18.5275 16.55 18.4999 16.55C18.4723 16.55 18.45 16.5276 18.45 16.5C18.4499 16.4867 18.4552 16.4739 18.4646 16.4645C18.4741 16.4551 18.4869 16.4499 18.5002 16.45",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 16.5V16.5C15 14.567 16.567 13 18.5 13V13C20.433 13 22 14.567 22 16.5V16.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 13H8V16H10",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PigIcon.tsx


var PigIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.6333 6.71667C15.6333 8.68997 14.0124 10.3 12 10.3C9.98761 10.3 8.36667 8.68997 8.36667 6.71667C8.36667 4.74337 9.98761 3.13334 12 3.13334C14.0124 3.13334 15.6333 4.74337 15.6333 6.71667Z",
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.03327 8.55377C6.63317 9.54729 5 11.5078 5 13.7638C5 15.8595 6.40922 17.7002 8.53333 18.7476L8.46667 20.8H10.8V19.4833C11.3568 19.5838 12.0204 19.6667 12.6167 19.6667C13.2129 19.6667 13.7932 19.6136 14.35 19.5131V20.8H16.7V18.7476C17.9895 18.1117 19.0156 17.1835 19.6228 16.0833H21.4V12.5833H20.063C19.8646 11.8685 19.3978 11.1152 18.8986 10.5111L20.9319 8.47581C20.25 7.8 18.15 6.4 15.7 8.71667C15.4681 8.62616 15.1279 8.38758 14.8833 8.31667",
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.83333 13.75C4.49457 13.7733 2.89327 13.4143 2.68333 11.9833",
                stroke: color,
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "16.3917",
                y: "12.2917",
                width: "0.583333",
                height: "0.583333",
                stroke: color,
                strokeWidth: "0.583333"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.2833 7.63333C11.426 7.70841 11.7344 7.78012 12.0333 7.77529M12.6167 5.54999C12.4025 5.45597 12.2063 5.4127 12.0333 5.41145M12.0333 4.93333V5.41145M12.0333 5.41145C11.6543 5.40873 11.3863 5.6077 11.2833 5.91667C11.2333 6.3 11.5333 6.49445 12.0833 6.61667C12.8333 6.78333 12.7667 7.28333 12.7667 7.28333C12.7484 7.64965 12.3979 7.76939 12.0333 7.77529M12.0333 7.77529V8.3",
                stroke: color,
                strokeWidth: "0.8",
                strokeLinecap: "square"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PinLocation.tsx


var PinLocation = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "localiza\xe7\xe3o" : _alt, _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-labelledby": alt,
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.4553 12.8674C11.8272 12.8674 12.9394 11.7552 12.9394 10.3833C12.9394 9.01143 11.8272 7.89929 10.4553 7.89929C9.08345 7.89929 7.97131 9.01143 7.97131 10.3833C7.97131 11.7552 9.08345 12.8674 10.4553 12.8674Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.8915 10.9235C18.1106 7.49614 15.9599 4.3625 12.683 3.33451C9.40605 2.30653 5.85084 3.65023 4.07302 6.58868C2.29519 9.52713 2.75483 13.2999 5.18616 15.7255L10.4554 21.0037",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.01541 10.9264C2.79494 7.50122 4.95851 4.36963 8.25512 3.34232C11.5517 2.315 15.1283 3.65783 16.9168 6.59436C18.7053 9.53088 17.9459 13.0759 15.5 15.5L10.4961 21",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PinLocationOutline.tsx


var PinLocationOutline = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "localiza\xe7\xe3o" : _alt, _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-labelledby": alt,
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 13V13C10.343 13 9 11.657 9 10V10C9 8.343 10.343 7 12 7V7C13.657 7 15 8.343 15 10V10C15 11.657 13.657 13 12 13Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 21C12 21 5 15.25 5 10C5 6.134 8.134 3 12 3C15.866 3 19 6.134 19 10C19 15.25 12 21 12 21Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PinterestIcon.tsx


var PinterestIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 25 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone do Pinterest" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.560 */.rS.colors.neutral[560] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1527_13318)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.4999 0.507815C9.78009 0.50609 7.14514 1.45483 5.05068 3.19C2.95622 4.92516 1.53393 7.33767 1.02972 10.0104C0.525522 12.6831 0.971108 15.4479 2.28944 17.8269C3.60777 20.2059 5.71596 22.0494 8.2495 23.0388C8.14743 22.1158 8.05411 20.697 8.28887 19.6894C8.50175 18.7781 9.65659 13.8905 9.65659 13.8905C9.65659 13.8905 9.3081 13.192 9.3081 12.1597C9.3081 10.5368 10.2486 9.32655 11.4195 9.32655C12.4139 9.32655 12.8951 10.0731 12.8951 10.9699C12.8951 11.9701 12.2579 13.4662 11.9283 14.8528C11.6542 16.0135 12.5116 16.9613 13.6562 16.9613C15.7297 16.9613 17.3234 14.7741 17.3234 11.6187C17.3234 8.82642 15.3156 6.87399 12.4504 6.87399C9.13166 6.87399 7.18361 9.36301 7.18361 11.9351C7.18361 12.9383 7.57001 14.013 8.05119 14.5977C8.09263 14.6418 8.12193 14.6958 8.13625 14.7546C8.15056 14.8134 8.14939 14.8749 8.13285 14.933C8.0439 15.3005 7.84706 16.0937 7.80915 16.2556C7.75811 16.4685 7.64 16.5137 7.41837 16.4116C5.96024 15.7336 5.05037 13.6032 5.05037 11.8914C5.05037 8.21255 7.72457 4.83407 12.758 4.83407C16.8043 4.83407 19.9495 7.71678 19.9495 11.5706C19.9495 15.5907 17.4138 18.8262 13.8968 18.8262C12.7143 18.8262 11.6032 18.2124 11.2226 17.4862L10.4965 20.2596C10.2325 21.273 9.52098 22.543 9.04564 23.3173C10.6495 23.8132 12.3416 23.957 14.0062 23.739C15.6708 23.521 17.2687 22.9463 18.6908 22.0541C20.1129 21.1619 21.3257 19.9732 22.2463 18.5693C23.1668 17.1654 23.7735 15.5793 24.0249 13.9195C24.2763 12.2596 24.1664 10.565 23.7028 8.95146C23.2392 7.33793 22.4328 5.84348 21.3386 4.5702C20.2444 3.29693 18.8883 2.27483 17.3629 1.57372C15.8375 0.872623 14.1787 0.509041 12.4999 0.507815Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1527_13318",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "23.33",
                        height: "23.33",
                        fill: color,
                        transform: "translate(0.834961 0.507812)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PixIcon.tsx


var PixIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.450 */.rS.colors.secondary[450] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.57383 5.62665C6.03687 5.62542 6.49556 5.71597 6.92338 5.89308C7.35121 6.07019 7.73969 6.33034 8.06637 6.65849L11.6789 10.2718C11.8045 10.397 11.9746 10.4673 12.1519 10.4673C12.3292 10.4673 12.4993 10.397 12.6249 10.2718L16.2245 6.67218C16.5509 6.34361 16.9393 6.08314 17.3672 5.90588C17.7951 5.72863 18.2539 5.63811 18.7171 5.63958H19.1505L14.5791 1.06816C14.2405 0.729517 13.8386 0.460887 13.3963 0.27761C12.9539 0.0943327 12.4798 0 12.001 0C11.5222 0 11.048 0.0943327 10.6057 0.27761C10.1633 0.460887 9.7614 0.729517 9.42289 1.06816L4.8682 5.62665H5.57383ZM18.7171 18.3585C18.2542 18.3602 17.7957 18.2701 17.3678 18.0935C16.94 17.917 16.5514 17.6573 16.2245 17.3297L12.6241 13.727C12.4968 13.6052 12.3273 13.5373 12.1511 13.5373C11.9749 13.5373 11.8055 13.6052 11.6782 13.727L8.06561 17.3396C7.73891 17.6677 7.35042 17.9278 6.9226 18.1049C6.49478 18.282 6.0361 18.3726 5.57307 18.3714H4.8682L9.4305 22.9337C10.1147 23.6165 11.0419 24 12.0086 24C12.9752 24 13.9024 23.6165 14.5867 22.9337L19.1581 18.3615L18.7171 18.3585ZM20.1694 6.65924L22.9318 9.42172V9.42096C23.2705 9.75947 23.5391 10.1614 23.7224 10.6037C23.9057 11.0461 24 11.5202 24 11.999C24 12.4779 23.9057 12.952 23.7224 13.3943C23.5391 13.8367 23.2705 14.2386 22.9318 14.5771L20.1694 17.3396C20.1071 17.3139 20.0405 17.3005 19.9732 17.3H18.717C18.0634 17.2984 17.4368 17.0388 16.9735 16.5777L13.3738 12.9788C12.7214 12.3264 11.5831 12.3264 10.93 12.9788L7.31738 16.5914C6.85416 17.0527 6.22758 17.3126 5.57382 17.3145H4.02568C3.96208 17.3155 3.8992 17.3281 3.84015 17.3518L1.06627 14.5779C0.38347 13.8936 0 12.9664 0 11.9998C0 11.0331 0.38347 10.106 1.06627 9.42172L3.84623 6.64708C3.90541 6.67029 3.96821 6.68291 4.03176 6.68434H5.57382C6.22759 6.68617 6.85421 6.94605 7.31738 7.40746L10.9307 11.0185C11.2549 11.3421 11.6942 11.5239 12.1523 11.5239C12.6103 11.5239 13.0496 11.3421 13.3738 11.0185L16.9735 7.42115C17.4368 6.96002 18.0634 6.70042 18.717 6.69878H19.9732C20.0405 6.69813 20.1071 6.68471 20.1694 6.65924Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PlusInCircleIcon.tsx


var PlusInCircleIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 45 : _width, _height = param.height, height = _height === void 0 ? 45 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.265 */.rS.colors.secondary[265] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 8V16",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 12H8",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PreparingTrackingStatusIcon.tsx


var PreparingTrackingStatusIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Preparando" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.6667 22.6667H10.2708C9.2925 22.6667 8.5 21.8742 8.5 20.8958V12.5458C8.5 12.3067 8.54833 12.0692 8.6425 11.85L9.615 9.575C9.89333 8.92333 10.5342 8.5 11.2433 8.5H19.9242C20.6333 8.5 21.2733 8.92333 21.5525 9.575L22.525 11.85C22.6183 12.07 22.6667 12.3067 22.6667 12.5458V16",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5834 8.5V12.2",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.6309 12.2001H8.53589",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 19.3334H12.6667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1667 23.5001C17.8658 23.5001 16 21.6342 16 19.3334C16 17.0326 17.8658 15.1667 20.1667 15.1667C22.4683 15.1667 24.3333 17.0326 24.3333 19.3334C24.3333 21.6342 22.4683 23.5001 20.1667 23.5001",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.7866 18.5234L19.7608 20.5493L18.5449 19.3334",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PrintedInvoiceIcon.tsx


var PrintedInvoiceIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.350 */.rS.colors.neutral[350] : _color, _alt = param.alt, alt = _alt === void 0 ? "Nota fiscal impressa" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.83179 11.4704H4.16443C3.24357 11.4704 2.49707 10.7238 2.49707 9.80299V4.80091C2.49707 3.88005 3.24357 3.13354 4.16443 3.13354H15.836C16.7568 3.13354 17.5033 3.88005 17.5033 4.80091V9.80299C17.5033 10.7238 16.7568 11.4704 15.836 11.4704H14.1686",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.1688 7.302H5.83203V16.0783C5.83189 16.404 5.96121 16.7164 6.19152 16.9467C6.42182 17.177 6.67472 17.5003 7.00043 17.5002L8.00043 16.5002L9.00043 17.5002L10.5004 16.5002L11.5004 17.5002L12.5004 16.5002C12.8261 16.5003 13.579 17.177 13.8094 16.9467C14.0397 16.7164 14.169 16.404 14.1688 16.0783V7.302Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 13.5H10",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.75 11.4168H11.251",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 9.5H12",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ProfileIcon.tsx


var ProfileIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 14H4C2.89533 14 2 13.1047 2 12V4C2 2.89533 2.89533 2 4 2H12C13.1047 2 14 2.89533 14 4V12C14 13.1047 13.1047 14 12 14Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.33333 5.33325V13.9999",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 5.33325H9.33333C10.07 5.33325 10.6667 5.92992 10.6667 6.66659V13.9999",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/QrCode.tsx


var QrCode = function(param) {
    var _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, alt = param.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.5556 11.6667H6.11111C5.49778 11.6667 5 11.1689 5 10.5556V6.11111C5 5.49778 5.49778 5 6.11111 5H10.5556C11.1689 5 11.6667 5.49778 11.6667 6.11111V10.5556C11.6667 11.1689 11.1689 11.6667 10.5556 11.6667Z",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.5556 25H6.11111C5.49778 25 5 24.5022 5 23.8889V19.4444C5 18.8311 5.49778 18.3333 6.11111 18.3333H10.5556C11.1689 18.3333 11.6667 18.8311 11.6667 19.4444V23.8889C11.6667 24.5022 11.1689 25 10.5556 25Z",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.8889 11.6667H19.4445C18.8311 11.6667 18.3333 11.1689 18.3333 10.5556V6.11111C18.3333 5.49778 18.8311 5 19.4445 5H23.8889C24.5022 5 25 5.49778 25 6.11111V10.5556C25 11.1689 24.5022 11.6667 23.8889 11.6667Z",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 7.22222V5",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.4444 15H16.1111C15.4978 15 15 14.5022 15 13.8889V11.6667",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.11111 15H5",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.3333 21.6667H16.1111C15.4978 21.6667 15 22.1644 15 22.7778V25",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 18.3333H21.6667",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 18.3333V23.8889C25 24.5022 24.5022 25 23.8889 25H18.3333",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.33331 8.32222C8.32998 8.32222 8.32776 8.32444 8.32776 8.32777C8.32776 8.33111 8.32998 8.33333 8.33331 8.33333C8.33664 8.33333 8.33887 8.33111 8.33887 8.32777C8.33887 8.32444 8.33664 8.32222 8.33331 8.32222",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.6611 8.32777C21.6577 8.32777 21.6555 8.33 21.6555 8.33333C21.6555 8.33666 21.6577 8.33888 21.6611 8.33888C21.6644 8.33888 21.6666 8.33666 21.6666 8.33333C21.6666 8.33 21.6644 8.32777 21.6611 8.32777",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.7722 14.9944C22.7689 14.9944 22.7667 14.9967 22.7667 15C22.7667 15.0033 22.7689 15.0056 22.7722 15.0056C22.7756 15.0056 22.7778 15.0033 22.7778 15C22.7778 14.9967 22.7756 14.9944 22.7722 14.9944",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.6611 21.6611C21.6577 21.6611 21.6555 21.6633 21.6555 21.6667C21.6555 21.67 21.6577 21.6722 21.6611 21.6722C21.6644 21.6722 21.6666 21.67 21.6666 21.6667C21.6666 21.6633 21.6644 21.6611 21.6611 21.6611",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.33889 21.6611C8.33556 21.6611 8.33333 21.6633 8.33333 21.6667C8.33333 21.67 8.33556 21.6722 8.33889 21.6722C8.34222 21.6722 8.34444 21.67 8.34444 21.6667C8.34444 21.6633 8.34222 21.6611 8.33889 21.6611",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.44444 15H11.6667",
                stroke: color,
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Question.tsx


var Question = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_579_10148)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "9.25",
                        stroke: color,
                        strokeWidth: strokeWidth
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.99336 8.73919C10.3437 8.11641 10.9293 7.75757 11.6154 7.71912C12.4032 7.67497 13.1464 7.93504 13.5218 8.50507C14.0944 9.37464 13.6054 10.3445 12.97 10.8462C12.97 10.8462 12.2161 11.514 12.1004 11.6823C11.7325 12.2174 11.6823 12.4516 11.699 13.0536",
                        stroke: color,
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "11.6655",
                        cy: "15.7123",
                        r: "0.75",
                        fill: color,
                        stroke: color,
                        strokeWidth: "0.506689"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_579_10148",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: color
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ReadyForPickupTrackingStatusIcon.tsx


var ReadyForPickupTrackingStatusIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Retirada Dispon\xedvel" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.49683 16V12.7819C8.49683 12.5285 8.54855 12.2778 8.64856 12.045L9.67815 9.63563C9.97343 8.94507 10.652 8.49707 11.403 8.49683H20.5977C21.3487 8.49729 22.0271 8.94522 22.3226 9.63563L23.3522 12.045C23.4516 12.278 23.5031 12.5286 23.5031 12.7819V21.6273C23.5031 22.6633 22.6633 23.5031 21.6273 23.5031H18.501",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5811 19.9057L12.12 17.3872C12.3832 16.9591 12.8983 16.7574 13.3822 16.8929C13.8661 17.0283 14.2016 17.4682 14.2042 17.9707V19.3005H15.4631C15.8414 19.3006 16.1945 19.4903 16.4035 19.8057C16.5895 20.0853 16.6434 20.4324 16.551 20.7552L15.9408 22.8911C15.8375 23.2512 15.5084 23.4994 15.1338 23.4997H12.15C11.9065 23.5 11.6706 23.4151 11.4831 23.2596L10.5811 22.5093",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.1642 23.5032H8.91367C8.68345 23.5032 8.49683 23.3166 8.49683 23.0864V19.3348C8.49683 19.1046 8.68345 18.918 8.91367 18.918H10.1642C10.3944 18.918 10.581 19.1046 10.581 19.3348V23.0864C10.581 23.3166 10.3944 23.5032 10.1642 23.5032Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.0001 12.6652V8.49683",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.3347 20.1683H20.1684",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.49683 16V14.3326C8.49683 13.4118 9.24333 12.6653 10.1642 12.6653H21.8357C22.7566 12.6653 23.5031 13.4118 23.5031 14.3326V20.1684",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ReportSecurityProblemIcon.tsx


var ReportSecurityProblemIcon = function(param) {
    var width = param.width, height = param.height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, alt = param.alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": alt,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "7.5",
                y: "10.083",
                width: "5",
                height: "3.33333",
                rx: "1.25",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.4577 10.083V9.04134C11.4577 8.23593 10.8048 7.58301 9.99935 7.58301V7.58301C9.19393 7.58301 8.54102 8.23593 8.54102 9.04134V10.083",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.6673 11.3504C16.6673 14.496 12.7966 16.8327 10.9508 17.7709C10.3552 18.0754 9.64978 18.076 9.05369 17.7726C7.20908 16.8353 3.33398 14.4928 3.33398 11.3504V6.80749C3.34011 6.38178 3.66251 6.02737 4.08573 5.98109C5.854 5.84672 7.54928 5.21977 8.97948 4.17129C9.58554 3.72025 10.4157 3.72025 11.0218 4.17129C12.452 5.21977 14.1473 5.84672 15.9155 5.98109C16.3388 6.02736 16.6612 6.38177 16.6673 6.80749V11.3504Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/RequestErrorIcon.tsx


var RequestErrorIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 114 : _width, _height = param.height, height = _height === void 0 ? 120 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.760 */.rS.colors.neutral[760] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.neutral.240 */.rS.colors.neutral[240] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.neutral.350 */.rS.colors.neutral[350] : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? themes/* theme.colors.neutral.940 */.rS.colors.neutral[940] : _fifthColor, _sixthColor = param.sixthColor, sixthColor = _sixthColor === void 0 ? themes/* theme.colors.primary.155 */.rS.colors.primary[155] : _sixthColor, _seventhColor = param.seventhColor, seventhColor = _seventhColor === void 0 ? themes/* theme.colors.neutral.150 */.rS.colors.neutral[150] : _seventhColor, _alt = param.alt, alt = _alt === void 0 ? "Erro no envio da mensagem" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 114 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "64.09",
                cy: "44.966",
                r: "33.3371",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.17",
                d: "M68.9584 30.5796L81.1195 41.0143L43.3046 113.604L8.58522 71.714L68.9584 30.5796Z",
                fill: "url(#paint0_linear_4814_275)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.17",
                d: "M70.2219 32.0287L80.1914 39.6525L42.4171 100.65L22.6754 70.8567L70.2219 32.0287Z",
                fill: "url(#paint1_linear_4814_275)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M81.0006 54.8299C80.0335 54.8299 79.249 55.5621 79.249 56.4651C79.249 57.3682 80.0335 58.0999 81.0006 58.0999H85.8179C86.7855 58.0999 87.57 57.3677 87.57 56.4651C87.57 55.5625 86.7855 54.8303 85.8184 54.8303C85.8184 53.5886 84.7399 52.582 83.4095 52.582C82.0791 52.582 81.0006 53.5882 81.0006 54.8299Z",
                    stroke: secondColor,
                    strokeWidth: "0.369819",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M72.1256 62.2264C71.1585 62.2264 70.374 62.9586 70.374 63.8616C70.374 64.7647 71.1585 65.4964 72.1256 65.4964H76.9429C77.9105 65.4964 78.695 64.7642 78.695 63.8616C78.695 62.959 77.9105 62.2268 76.9434 62.2268C76.9434 60.9851 75.8649 59.9785 74.5345 59.9785C73.2041 59.9785 72.1256 60.9847 72.1256 62.2264Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M61.7701 71.8416C60.803 71.8416 60.0186 72.5738 60.0186 73.4769C60.0186 74.3799 60.803 75.1116 61.7701 75.1116H66.5875C67.555 75.1116 68.3395 74.3795 68.3395 73.4769C68.3395 72.5742 67.555 71.8421 66.5879 71.8421C66.5879 70.6003 65.5094 69.5938 64.179 69.5938C62.8486 69.5938 61.7701 70.5999 61.7701 71.8416Z",
                    stroke: thirdColor,
                    strokeWidth: "0.369819",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M37.2213 52.4178C36.2542 52.4178 35.4697 53.15 35.4697 54.053C35.4697 54.9561 36.2542 55.6878 37.2213 55.6878H42.0386C43.0062 55.6878 43.7907 54.9556 43.7907 54.053C43.7907 53.1504 43.0062 52.4182 42.0391 52.4182C42.0391 51.1765 40.9606 50.1699 39.6302 50.1699C38.2998 50.1699 37.2213 51.1761 37.2213 52.4178Z",
                    stroke: thirdColor,
                    strokeWidth: "0.369819",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M66.9478 27.4627C65.9808 27.4627 65.1963 28.1949 65.1963 29.0979C65.1963 30.001 65.9808 30.7327 66.9478 30.7327H71.7652C72.7327 30.7327 73.5172 30.0006 73.5172 29.0979C73.5172 28.1953 72.7327 27.4632 71.7657 27.4632C71.7657 26.2214 70.6872 25.2148 69.3568 25.2148C68.0263 25.2148 66.9478 26.221 66.9478 27.4627Z",
                    stroke: thirdColor,
                    strokeWidth: "0.369819",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M43.8775 29.4881C42.9105 29.4881 42.126 30.2203 42.126 31.1233C42.126 32.0264 42.9105 32.7581 43.8775 32.7581H48.6949C49.6624 32.7581 50.4469 32.0259 50.4469 31.1233C50.4469 30.2207 49.6624 29.4886 48.6954 29.4886C48.6954 28.2468 47.6169 27.2402 46.2864 27.2402C44.956 27.2402 43.8775 28.2464 43.8775 29.4881Z",
                    stroke: fourthColor,
                    strokeWidth: "0.369819",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M51.4166 48.9119C50.4495 48.9119 49.665 49.6441 49.665 50.5472C49.665 51.4502 50.4495 52.182 51.4166 52.182H56.234C57.2015 52.182 57.986 51.4498 57.986 50.5472C57.986 49.6446 57.2015 48.9124 56.2344 48.9124C56.2344 47.6706 55.1559 46.6641 53.8255 46.6641C52.4951 46.6641 51.4166 47.6702 51.4166 48.9119Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M87.5628 41.0567C86.8536 41.0567 86.2783 41.5936 86.2783 42.2558C86.2783 42.918 86.8536 43.4547 87.5628 43.4547H91.0955C91.8051 43.4547 92.3803 42.9177 92.3803 42.2558C92.3803 41.5939 91.8051 41.057 91.0959 41.057C91.0959 40.1464 90.305 39.4082 89.3293 39.4082C88.3537 39.4082 87.5628 40.1461 87.5628 41.0567Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M54.137 21.6328C53.4278 21.6328 52.8525 22.1698 52.8525 22.832C52.8525 23.4942 53.4278 24.0308 54.137 24.0308H57.6697C58.3793 24.0308 58.9546 23.4939 58.9546 22.832C58.9546 22.1701 58.3793 21.6331 57.6701 21.6331C57.6701 20.7225 56.8792 19.9844 55.9035 19.9844C54.9279 19.9844 54.137 20.7222 54.137 21.6328Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M49.3676 56.6787L35.6843 70.7791",
                stroke: fifthColor,
                strokeWidth: "0.814966",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58.1514 64.2129L45.9126 78.6576",
                stroke: fifthColor,
                strokeWidth: "0.814966",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50.0332 64.2734L36.668 79.2388",
                stroke: fifthColor,
                strokeWidth: "0.814966",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M57.0531 54.5341L57.1362 38.5165L87.8605 22.6264L86.0504 30.3989L57.0531 54.5341Z",
                fill: "url(#paint2_linear_4814_275)",
                stroke: fifthColor,
                strokeWidth: "1.53792"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M89.7103 18.5649C90.6075 18.2403 91.1758 19.5162 90.3346 19.9661L57.0936 37.7437C56.9897 37.7993 56.8743 37.8302 56.7565 37.8341L39.2579 38.4142C38.3826 38.4432 38.1473 37.2205 38.9708 36.9225L89.7103 18.5649Z",
                fill: sixthColor,
                stroke: fifthColor,
                strokeWidth: "1.53792"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M90.6864 20.5114C91.016 19.7687 90.1183 19.0889 89.4928 19.6075L62.8962 41.6582C62.6374 41.8727 62.548 42.2304 62.6753 42.5414L70.7415 62.2479C70.9981 62.8749 71.8812 62.8877 72.156 62.2686L90.6864 20.5114Z",
                fill: color,
                stroke: fifthColor,
                strokeWidth: "1.53792"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M57.4951 55.2601L62.52 42.4039C62.5263 42.3878 62.5321 42.38 62.5348 42.3767C62.5376 42.3733 62.5404 42.371 62.5436 42.369C62.5509 42.3644 62.566 42.3586 62.5876 42.3592C62.6091 42.3598 62.6239 42.3665 62.6309 42.3714C62.634 42.3736 62.6366 42.3761 62.6392 42.3796C62.6418 42.383 62.6471 42.3912 62.6525 42.4077L62.6617 42.4357L62.6731 42.463L65.5838 49.4776L66.4336 52.0716L57.4951 55.2601Z",
                fill: sixthColor,
                stroke: fifthColor,
                strokeWidth: "1.53792"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "82.3154",
                cy: "72.2168",
                r: "11.25",
                fill: sixthColor,
                stroke: "white",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.3171 72.7178L82.3171 67.7031",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.3157 76.2792C82.2051 76.2792 82.1157 76.3685 82.1171 76.4792C82.1171 76.5898 82.2064 76.6792 82.3171 76.6792C82.4277 76.6792 82.5171 76.5898 82.5171 76.4792C82.5171 76.3698 82.4277 76.2792 82.3157 76.2792",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_4814_275",
                        x1: "73.9938",
                        y1: "31.1296",
                        x2: "31.6397",
                        y2: "100.947",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.419792",
                                stopColor: sixthColor
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: sixthColor,
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_4814_275",
                        x1: "73.9936",
                        y1: "31.13",
                        x2: "31.6395",
                        y2: "100.948",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.51875",
                                stopColor: sixthColor
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: sixthColor,
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_4814_275",
                        x1: "68.8443",
                        y1: "29.3878",
                        x2: "76.4187",
                        y2: "47.9718",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: seventhColor
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: fourthColor
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ResumeOrder.tsx


var ResumeOrder = function(param) {
    var _width = param.width, width = _width === void 0 ? 18 : _width, _height = param.height, height = _height === void 0 ? 18 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.855 */.rS.colors.primary[855] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "24",
                height: "24",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V9H14.5C13.9477 9 13.5 8.55228 13.5 8V3H6C5.44772 3 5 3.44772 5 4V20Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5 3V7C14.5 7.55228 14.9477 8 15.5 8H19L14.5 3Z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/RightArrowProduct.tsx


var RightArrowProduct = function(param) {
    var _width = param.width, width = _width === void 0 ? 12 : _width, _height = param.height, height = _height === void 0 ? 15 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.520 */.rS.colors.neutral[520] : _color, _alt = param.alt, alt = _alt === void 0 ? "Seta para direita" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.6665 10.3506L6.99984 5.85939L1.6665 1.36816",
            stroke: color,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/RotateIcon.tsx


var RotateIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.230 */.rS.colors.secondary[230] : _color, _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de setas de rota\xe7\xe3o" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.99756 6.66671L4.5673 4.09697C5.48424 3.17999 6.72795 2.6649 8.02474 2.66504V2.66504C10.0238 2.66518 11.8214 3.88227 12.564 5.73832L12.6687 5.99976",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.66534 6.6668H1.99756V3.99902",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.0025 9.33398L11.4328 11.9037C10.5158 12.8207 9.27214 13.3358 7.97535 13.3357V13.3357C5.97629 13.3355 4.17866 12.1184 3.43613 10.2624L3.33142 10.0009",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.3347 9.33398H14.0025V12.0018",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SaleTagIcon.tsx


var SaleTagIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.8814 24.5817C10.0555 25.4155 8.7147 25.4155 7.88874 24.5817L1.07736 17.7116C0.251395 16.8778 0.251395 15.5243 1.07736 14.6905L11.3284 4.34822C11.8998 3.76571 12.6805 3.44591 13.4951 3.45733L19.6333 3.54299C20.8892 3.56012 21.9019 4.58236 21.9188 5.85017V5.8673C22.2017 5.97009 22.4902 6.0786 22.7787 6.19853C24.3458 6.85527 25.7262 7.74045 26.6766 8.69987L26.7275 8.75127C28.2606 10.3275 28.0909 11.5267 27.8533 12.0978C27.6157 12.6746 26.8916 13.6397 24.7079 13.6512C23.8253 13.6569 22.824 13.5027 21.7944 13.2114C21.6473 13.5883 21.421 13.9424 21.1268 14.2394L10.8814 24.5817ZM18.2642 7.15795C17.5797 6.46694 16.4709 6.46694 15.7863 7.15795C15.1018 7.84896 15.1018 8.96828 15.7807 9.65358C16.4652 10.3446 17.574 10.3446 18.2586 9.65358C18.2699 9.6393 18.2826 9.62503 18.2953 9.61075C18.3081 9.59647 18.3208 9.58219 18.3321 9.56792C19.0279 10.0876 19.8879 10.5673 20.8043 10.9556C23.9385 12.2749 26.0034 11.8637 26.1957 11.4011C26.258 11.2526 26.1788 10.7672 25.4433 10.0077L25.4094 9.97339C24.6343 9.191 23.4293 8.42575 22.0885 7.86038C22.0631 7.84896 22.039 7.83896 22.015 7.82897C21.991 7.81897 21.9669 7.80898 21.9415 7.79756L21.9188 10.1614C21.6386 10.1321 21.1268 9.90958 20.8043 9.74679C20.0189 9.35029 19.459 8.99042 18.7858 8.51071C18.865 7.97961 18.6715 7.56913 18.2642 7.15795Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_11_427895",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "3",
                width: "29",
                height: "23",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.8814 24.5817C10.0555 25.4155 8.7147 25.4155 7.88874 24.5817L1.07736 17.7116C0.251395 16.8778 0.251395 15.5243 1.07736 14.6905L11.3284 4.34822C11.8998 3.76571 12.6805 3.44591 13.4951 3.45733L19.6333 3.54299C20.8892 3.56012 21.9019 4.58236 21.9188 5.85017V5.8673C22.2017 5.97009 22.4902 6.0786 22.7787 6.19853C24.3458 6.85527 25.7262 7.74045 26.6766 8.69987L26.7275 8.75127C28.2606 10.3275 28.0909 11.5267 27.8533 12.0978C27.6157 12.6746 26.8916 13.6397 24.7079 13.6512C23.8253 13.6569 22.824 13.5027 21.7944 13.2114C21.6473 13.5883 21.421 13.9424 21.1268 14.2394L10.8814 24.5817ZM18.2642 7.15795C17.5797 6.46694 16.4709 6.46694 15.7863 7.15795C15.1018 7.84896 15.1018 8.96828 15.7807 9.65358C16.4652 10.3446 17.574 10.3446 18.2586 9.65358C18.2699 9.6393 18.2826 9.62503 18.2953 9.61075C18.3081 9.59647 18.3208 9.58219 18.3321 9.56792C19.0279 10.0876 19.8879 10.5673 20.8043 10.9556C23.9385 12.2749 26.0034 11.8637 26.1957 11.4011C26.258 11.2526 26.1788 10.7672 25.4433 10.0077L25.4094 9.97339C24.6343 9.191 23.4293 8.42575 22.0885 7.86038C22.0631 7.84896 22.039 7.83896 22.015 7.82897C21.991 7.81897 21.9669 7.80898 21.9415 7.79756L21.9188 10.1614C21.6386 10.1321 21.1268 9.90958 20.8043 9.74679C20.0189 9.35029 19.459 8.99042 18.7858 8.51071C18.865 7.97961 18.6715 7.56913 18.2642 7.15795Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_11_427895)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: width,
                    height: height,
                    fill: color
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SatisfiedFaceIcon.tsx


var SatisfiedFaceIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de Avalia\xe7\xe3o - Satisfeito" : _alt, _width = param.width, width = _width === void 0 ? 40 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.37 */.rS.colors.secondary[37] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.secondary.357 */.rS.colors.secondary[357] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 40 40",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "20",
                cy: "20",
                r: "19",
                fill: color,
                stroke: secondColor,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.6833 28.7226C13.6833 28.7226 16.3713 31.1772 20.3958 30.9459C23.4141 30.7724 26.4272 27.8039 26.4272 27.8039",
                stroke: secondColor,
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.11804 15.8969L12.285 14.0685C13.2416 13.5162 14.4647 13.8439 15.017 14.8005L16.8455 17.9675",
                stroke: secondColor,
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.1544 17.9667L24.9828 14.7998C25.5351 13.8432 26.7583 13.5155 27.7149 14.0678L30.8818 15.8962",
                stroke: secondColor,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Search.tsx


var Search = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de pesquisa" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "10.8024",
                cy: "10.7981",
                r: "6.05241",
                stroke: color,
                strokeWidth: strokeWidth
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.9662 14.8671L15.4359 14.3368L14.3752 15.3974L14.9055 15.9278L15.9662 14.8671ZM19.508 20.5302C19.8009 20.8231 20.2758 20.8231 20.5687 20.5302C20.8615 20.2373 20.8615 19.7624 20.5687 19.4695L19.508 20.5302ZM14.9055 15.9278L19.508 20.5302L20.5687 19.4695L15.9662 14.8671L14.9055 15.9278Z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SearchBagIcon.tsx


var SearchBagIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 24 : _height, _width = param.width, width = _width === void 0 ? 24 : _width, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.155 */.rS.colors.primary[155] : _color, _alt = param.alt, alt = _alt === void 0 ? "Sacola de compras com uma lupa" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16.0017",
                cy: "5.99727",
                r: "4.00167",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.004 10.9996L18.8311 8.82666",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.002 21.0035H18.0028C19.6603 21.0035 21.004 19.6598 21.004 18.0022V15.001",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.99609 9.99908V6.99783C2.99609 5.34029 4.3398 3.99658 5.99734 3.99658H7.99818",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.99707 15.668C5.99707 16.773 6.89287 17.6688 7.9979 17.6688C9.10293 17.6688 9.99874 16.773 9.99874 15.668",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2.99609",
                y: "13",
                width: "10.0042",
                height: "8.00333",
                rx: "1",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SearchBoxIcon.tsx


var SearchBoxIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 175 : _width, _height = param.height, height = _height === void 0 ? 175 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.neutral.150 */.rS.colors.neutral[150] : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? themes/* theme.colors.neutral.88 */.rS.colors.neutral[88] : _fifthColor, _sixthColor = param.sixthColor, sixthColor = _sixthColor === void 0 ? themes/* theme.colors.primary.350 */.rS.colors.primary[350] : _sixthColor, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de uma lupa e uma caixa" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 175 175",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_983_36665)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: width,
                        height: height,
                        rx: "87.5",
                        fill: thirdColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M46.7791 75.0557L75.1409 74.7754V151.441L67.6844 152.154V97.3224L57.1334 96.1204C57.5862 93.4206 57.1013 90.6472 55.759 88.2614C53.5182 84.3596 46.7791 83.6435 46.7791 83.6435V75.0557Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.0676 115.273H30.9365L33.0321 151.292H12.0676V115.273Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M118.773 118.703H137.642L139.738 154.722H118.773V118.703Z",
                        fill: fifthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M42.9222 115.273H60.7227V151.292H40.3625L42.9222 115.273Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M149.628 118.703H167.429V154.722H147.068L149.628 118.703Z",
                        fill: fifthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.97437 100.536H63.6192V111.437H8.97437V100.536Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M118.066 98.7773L172.038 107.326L170.333 118.092L116.361 109.544L118.066 98.7773Z",
                        fill: fifthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M47.9528 21.5381H76.2285L74.9789 69.0131H46.7791L47.9528 21.5381Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M28.8303 41.8262L35.2875 43.9105L36.1437 49.2221L32.2239 62.7335L19.9499 58.6309L24.0744 45.6182L28.8303 41.8262Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M83.676 21.5381H107.511V69.0902H82.2168L83.676 21.5381Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M82.2168 74.7734H107.511V150.916H82.2168V74.7734Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M115.618 32.9668H140.913C140.913 32.9668 133.199 38.6813 133.199 50.9242C133.199 63.1671 141.41 68.9227 143.339 83.4746C145.267 98.0264 143.339 98.7733 143.339 98.7733H115.618C115.618 98.7733 113.304 98.0174 115.618 83.4746C117.932 68.9317 124.893 63.2069 124.893 50.9203C124.924 47.3991 124.096 43.9233 122.48 40.7947C120.863 37.666 118.508 34.979 115.618 32.9668Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M41.7923 91.8521C44.7724 88.872 50.492 87.8667 52.6236 91.8521C54.7551 95.8374 49.6551 100.54 49.6551 100.54H37.7336C37.7336 100.54 38.8123 94.8321 41.7923 91.8521Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M32.4821 91.8521C29.5021 88.872 23.7824 87.8667 21.6508 91.8521C19.5193 95.8374 24.6206 100.54 24.6206 100.54H36.5408C36.5408 100.54 35.4621 94.8321 32.4821 91.8521Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M30.7092 48.4437C31.7742 48.4437 32.6376 47.5804 32.6376 46.5153C32.6376 45.4503 31.7742 44.5869 30.7092 44.5869C29.6441 44.5869 28.7808 45.4503 28.7808 46.5153C28.7808 47.5804 29.6441 48.4437 30.7092 48.4437Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M48.3217 21.6504C43.8407 22.7483 39.7821 25.1414 36.6522 28.531C32.123 33.883 31.3774 42.3911 31.3774 42.3911C31.3774 42.3911 30.489 32.6462 35.0195 27.2942C39.55 21.9422 48.3217 21.6504 48.3217 21.6504Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M146.011 76.2773L140.314 79.9618L140.861 85.3141L148.145 97.3505L158.939 90.2109L151.587 78.7092L146.011 76.2773Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M145.911 83.1546C146.939 82.8788 147.55 81.8212 147.274 80.7925C146.998 79.7638 145.941 79.1535 144.912 79.4293C143.883 79.7051 143.273 80.7626 143.549 81.7913C143.825 82.82 144.882 83.4304 145.911 83.1546Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M121.963 61.834C126.576 61.7344 131.116 62.995 135.017 65.4586C140.78 69.4552 143.699 77.4835 143.699 77.4835C143.699 77.4835 142.033 67.8386 136.27 63.842C130.507 59.8454 121.963 61.834 121.963 61.834Z",
                        fill: fourthColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M126.878 70.3894V118.125C126.878 122.957 122.96 126.875 118.128 126.875H56.8779C52.0455 126.875 48.1279 122.957 48.1279 118.125V70.3894C48.1263 69.2029 48.3659 68.0285 48.8323 66.9375L54.6073 53.4231C55.9881 50.2068 59.1528 48.1229 62.6529 48.125H112.353C115.856 48.125 119.022 50.2148 120.399 53.4363L126.174 66.9375C126.639 68.0287 126.879 69.203 126.878 70.3894Z",
                        fill: color,
                        stroke: secondColor,
                        strokeWidth: "3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M48.1279 70H126.834",
                        stroke: secondColor,
                        strokeWidth: "3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M95.477 48.8965L99.8519 66.9089V78.5269C99.7436 80.1512 98.0626 81.3986 96.0895 81.3189H77.3647C75.3916 81.3986 73.7106 80.1512 73.6023 78.5269V66.9089L77.9772 48.8965",
                        stroke: secondColor,
                        strokeWidth: "3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M61.2495 113.75H69.9995",
                        stroke: secondColor,
                        strokeWidth: "3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M129.453 108.68C129.453 120.907 119.526 130.823 107.275 130.823C95.0246 130.823 85.0972 120.907 85.0972 108.68C85.0972 96.453 95.0246 86.5371 107.275 86.5371C119.526 86.5371 129.453 96.453 129.453 108.68Z",
                        fill: "#FEF4F5",
                        stroke: secondColor,
                        strokeWidth: "3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M124.466 123.606L123.405 122.546L121.282 124.666L122.343 125.726L124.466 123.606ZM138.364 141.723C138.95 142.308 139.9 142.308 140.486 141.723C141.073 141.137 141.073 140.188 140.486 139.603L138.364 141.723ZM122.343 125.726L138.364 141.723L140.486 139.603L124.466 123.606L122.343 125.726Z",
                        fill: secondColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M106.19 112.091V110.674C106.19 110.136 106.32 109.681 106.578 109.306C106.836 108.932 107.238 108.467 107.785 107.914C108.331 107.376 108.741 106.896 109.014 106.473C109.303 106.049 109.447 105.545 109.447 104.958C109.447 104.307 109.273 103.786 108.923 103.395C108.589 102.988 108.081 102.784 107.398 102.784C106.593 102.784 106.031 103.029 105.712 103.517C105.409 104.006 105.257 104.559 105.257 105.178L105.28 105.96H102.068C102.023 105.52 102 105.219 102 105.056C102 104.209 102.22 103.395 102.66 102.614C103.116 101.832 103.754 101.205 104.573 100.733C105.393 100.244 106.327 100 107.375 100H107.876C108.939 100 109.857 100.228 110.631 100.684C111.406 101.14 111.99 101.75 112.385 102.516C112.795 103.281 113 104.112 113 105.007C113 105.756 112.879 106.408 112.636 106.961C112.408 107.515 112.135 107.971 111.816 108.329C111.497 108.671 111.087 109.054 110.586 109.477C110.13 109.884 109.796 110.21 109.584 110.454C109.386 110.698 109.288 110.983 109.288 111.309V112.091H106.19ZM106.054 113.409H109.402V117H106.054V113.409Z",
                        fill: sixthColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_983_36665",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: width,
                        height: height,
                        rx: "87.5",
                        fill: color
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SearchIcon.tsx

var SearchIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? "18px" : _height, _width = param.width, width = _width === void 0 ? "18px" : _width, _color = param.color, color = _color === void 0 ? "currentColor" : _color, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de pesquisa" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        fill: color,
        viewBox: "0 0 256 256",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SecurityLockIcon.tsx


var SecurityLockIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 22 : _width, _height = param.height, height = _height === void 0 ? 22 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.760 */.rS.colors.neutral[760] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de cadeado" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "5.16406",
                y: "9.33203",
                width: "11.6715",
                height: "9.17049",
                rx: "3",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.9998 16.0033V14.3359",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.5007 16.0025V14.3351C13.5009 13.3235 12.8915 12.4115 11.9569 12.0244C11.0224 11.6373 9.9466 11.8514 9.23145 12.5669",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.49887 15.168V16.0016",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.66504 9.33381V6.83277V6.83277C7.66504 4.99105 9.15804 3.49805 10.9998 3.49805V3.49805C12.8415 3.49805 14.3345 4.99105 14.3345 6.83277V6.83277V9.33381",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Settings.tsx


var Settings = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, alt = param.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Icons / Settings",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Cores/Preto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Mask",
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M25.4818 11.6471C25.2876 11.3929 25.0147 11.2302 24.6984 11.1818L22.525 10.8494C22.444 10.6338 22.3529 10.4169 22.2516 10.1987C22.3863 10.0219 22.5484 9.81357 22.7379 9.57396C23.0888 9.13036 23.3382 8.80517 23.4903 8.59234C23.6534 8.36814 23.7445 8.10551 23.7445 7.8268C23.7445 7.52261 23.6554 7.24211 23.458 7.01711C23.1236 6.53572 22.3101 5.69755 21.0396 4.52554C20.7692 4.29824 20.4825 4.18362 20.1733 4.18362C19.8615 4.18362 19.5734 4.28382 19.3464 4.48727L17.7077 5.72218C17.5373 5.64644 17.3615 5.57456 17.1803 5.50652L16.8471 3.31685C16.8278 3.04022 16.6717 2.74845 16.4128 2.53886C16.1775 2.34832 15.8938 2.25 15.5898 2.25H12.4102C11.7896 2.25 11.3172 2.61732 11.1669 3.21928C11.0495 3.67046 10.9252 4.43065 10.7906 5.51156C10.6137 5.57895 10.4389 5.65197 10.2664 5.73059L8.65876 4.48409C8.40839 4.2915 8.12781 4.18362 7.82685 4.18362C7.32131 4.18362 6.8182 4.56429 5.94675 5.42368C5.22767 6.13297 4.73406 6.6717 4.45481 7.05785C4.28064 7.30898 4.18372 7.55701 4.18372 7.8268C4.18372 8.131 4.29982 8.40987 4.50095 8.65096C4.99079 9.24334 5.40204 9.76505 5.73402 10.2151C5.64344 10.4066 5.56172 10.5986 5.4889 10.7911L3.27523 11.1242C2.94635 11.1839 2.6926 11.3577 2.50833 11.6109C2.34161 11.8393 2.25 12.1025 2.25 12.3815V15.5613C2.25 15.8505 2.34247 16.1221 2.51815 16.3525C2.71235 16.6071 2.98567 16.7702 3.30245 16.8184L5.46718 17.1379C5.54776 17.3602 5.64053 17.5828 5.74542 17.8056C5.61151 17.9813 5.45048 18.188 5.2623 18.4259C4.90628 18.8762 4.65962 19.1977 4.50948 19.4081C4.3465 19.6327 4.25536 19.8947 4.25536 20.1733C4.25536 20.4486 4.33454 20.7087 4.49095 20.9323C4.9094 21.5122 5.72535 22.343 6.96575 23.4651C7.18049 23.6811 7.48837 23.8164 7.82695 23.8164C8.15015 23.8164 8.44904 23.7091 8.68664 23.4954L10.2939 22.2783C10.464 22.3538 10.6394 22.4256 10.8202 22.4935L11.1534 24.6833C11.173 24.9598 11.3287 25.2509 11.5866 25.4605C11.8221 25.6518 12.1064 25.75 12.4105 25.75H15.5902C16.211 25.75 16.6831 25.3831 16.8338 24.7812C16.9511 24.3295 17.0752 23.5696 17.2099 22.4886C17.3861 22.4215 17.5601 22.3488 17.732 22.2705L19.3392 23.5284C19.6419 23.7268 19.9015 23.8164 20.1737 23.8164C20.6789 23.8164 21.1817 23.4367 22.0466 22.5834C22.7609 21.8794 23.2566 21.3386 23.544 20.9441C23.7039 20.7722 23.8167 20.4843 23.8167 20.1733C23.8167 19.8635 23.702 19.5764 23.498 19.3332C22.9849 18.7055 22.5728 18.1822 22.2641 17.7663C22.3438 17.593 22.4221 17.4078 22.4991 17.2105L24.7115 16.8759C25.0381 16.8211 25.3044 16.6479 25.4928 16.3883C25.659 16.1592 25.75 15.8967 25.75 15.6183V12.4388C25.7506 12.1505 25.6581 11.8781 25.4818 11.6471ZM21.2479 11.7459L21.3875 12.1928L24.25 12.6307L24.25 15.4287L21.8374 15.7935L21.3917 15.8609L21.2421 16.2861C21.073 16.7666 20.9019 17.1658 20.7311 17.4819L20.511 17.8892L20.7765 18.2685C21.1063 18.7397 21.5945 19.3714 22.2471 20.1728C21.9672 20.521 21.5572 20.9597 20.9934 21.5153C20.671 21.8333 20.4097 22.0673 20.2157 22.2138L20.1987 22.2265C20.1802 22.2402 20.1638 22.2522 20.1504 22.2624L18.287 20.8L17.906 20.5018L17.4772 20.726C17.0954 20.9257 16.7008 21.0905 16.2931 21.2208L15.8329 21.3678L15.7765 21.8476C15.6441 22.9729 15.5231 23.7797 15.4187 24.25H12.603L12.2354 21.8224L12.1659 21.3658L11.727 21.2223C11.2956 21.0813 10.9023 20.9195 10.5465 20.7374L10.1269 20.5226L7.85452 22.2471C6.8373 21.3197 6.15485 20.6298 5.80219 20.1807C5.94284 19.99 6.15354 19.7172 6.43881 19.3564C6.79053 18.9118 7.05373 18.5682 7.23271 18.3193L7.50689 17.938L7.28368 17.5249C7.05097 17.0942 6.87607 16.6719 6.75783 16.2578L6.62493 15.7925L3.75 15.3683V12.5693L6.16262 12.2066L6.63082 12.1361L6.76856 11.6831C6.88705 11.2935 7.05343 10.9009 7.2684 10.5055L7.49041 10.0971L7.22347 9.71655C6.85093 9.18548 6.36367 8.55439 5.75903 7.81892C5.99231 7.52266 6.41096 7.07272 7.00005 6.49165C7.32487 6.17133 7.58818 5.93551 7.78349 5.78772C7.79636 5.77798 7.80848 5.76903 7.81958 5.76083L7.81959 5.76082L7.83892 5.74648L9.71619 7.20208L10.0966 7.49703L10.5232 7.27405C10.9049 7.07455 11.2995 6.90974 11.7075 6.77929L12.1676 6.63222L12.224 6.15249C12.3563 5.02732 12.4774 4.22033 12.582 3.75H15.3976L15.7652 6.17779L15.8347 6.63446L16.2738 6.77788C16.7052 6.91879 17.0984 7.08048 17.4537 7.26248L17.8718 7.47669L20.159 5.75313C21.1665 6.68811 21.8565 7.39286 22.1932 7.82557C22.0506 8.01856 21.8402 8.29106 21.5614 8.64344C21.2103 9.0875 20.9468 9.43156 20.7677 9.68065L20.4983 10.0552L20.7111 10.4645C20.9397 10.9042 21.1184 11.3313 21.2479 11.7459ZM16.0623 16.0622C16.6379 15.4868 16.917 14.8133 16.917 14.0001C16.917 13.1869 16.638 12.5135 16.0624 11.9378C15.4871 11.3624 14.8136 11.0834 14.0003 11.0834C13.1872 11.0834 12.5137 11.3625 11.9381 11.9378C11.3625 12.5134 11.0836 13.1867 11.0836 14.0001C11.0836 14.8132 11.3627 15.4867 11.9381 16.0621C12.5137 16.6378 13.1871 16.9168 14.0003 16.9168C14.8136 16.9168 15.487 16.6377 16.0623 16.0622ZM10.8774 17.1228C11.7343 17.9797 12.7892 18.4168 14.0003 18.4168C15.2116 18.4168 16.2665 17.9796 17.1231 17.1227C17.9799 16.2663 18.417 15.2112 18.417 14.0001C18.417 12.789 17.9799 11.7342 17.1232 10.8773C16.2666 10.0205 15.2115 9.58338 14.0003 9.58338C12.7894 9.58338 11.7344 10.0205 10.8775 10.8771C10.0206 11.7341 9.58358 12.7889 9.58358 14.0001C9.58358 15.2111 10.0208 16.2662 10.8774 17.1228Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "mask0_0_2536",
                        maskUnits: "userSpaceOnUse",
                        x: "2",
                        y: "2",
                        width: "24",
                        height: "24",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Mask_2",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M25.4818 11.6471C25.2876 11.3929 25.0147 11.2302 24.6984 11.1818L22.525 10.8494C22.444 10.6338 22.3529 10.4169 22.2516 10.1987C22.3863 10.0219 22.5484 9.81357 22.7379 9.57396C23.0888 9.13036 23.3382 8.80517 23.4903 8.59234C23.6534 8.36814 23.7445 8.10551 23.7445 7.8268C23.7445 7.52261 23.6554 7.24211 23.458 7.01711C23.1236 6.53572 22.3101 5.69755 21.0396 4.52554C20.7692 4.29824 20.4825 4.18362 20.1733 4.18362C19.8615 4.18362 19.5734 4.28382 19.3464 4.48727L17.7077 5.72218C17.5373 5.64644 17.3615 5.57456 17.1803 5.50652L16.8471 3.31685C16.8278 3.04022 16.6717 2.74845 16.4128 2.53886C16.1775 2.34832 15.8938 2.25 15.5898 2.25H12.4102C11.7896 2.25 11.3172 2.61732 11.1669 3.21928C11.0495 3.67046 10.9252 4.43065 10.7906 5.51156C10.6137 5.57895 10.4389 5.65197 10.2664 5.73059L8.65876 4.48409C8.40839 4.2915 8.12781 4.18362 7.82685 4.18362C7.32131 4.18362 6.8182 4.56429 5.94675 5.42368C5.22767 6.13297 4.73406 6.6717 4.45481 7.05785C4.28064 7.30898 4.18372 7.55701 4.18372 7.8268C4.18372 8.131 4.29982 8.40987 4.50095 8.65096C4.99079 9.24334 5.40204 9.76505 5.73402 10.2151C5.64344 10.4066 5.56172 10.5986 5.4889 10.7911L3.27523 11.1242C2.94635 11.1839 2.6926 11.3577 2.50833 11.6109C2.34161 11.8393 2.25 12.1025 2.25 12.3815V15.5613C2.25 15.8505 2.34247 16.1221 2.51815 16.3525C2.71235 16.6071 2.98567 16.7702 3.30245 16.8184L5.46718 17.1379C5.54776 17.3602 5.64053 17.5828 5.74542 17.8056C5.61151 17.9813 5.45048 18.188 5.2623 18.4259C4.90628 18.8762 4.65962 19.1977 4.50948 19.4081C4.3465 19.6327 4.25536 19.8947 4.25536 20.1733C4.25536 20.4486 4.33454 20.7087 4.49095 20.9323C4.9094 21.5122 5.72535 22.343 6.96575 23.4651C7.18049 23.6811 7.48837 23.8164 7.82695 23.8164C8.15015 23.8164 8.44904 23.7091 8.68664 23.4954L10.2939 22.2783C10.464 22.3538 10.6394 22.4256 10.8202 22.4935L11.1534 24.6833C11.173 24.9598 11.3287 25.2509 11.5866 25.4605C11.8221 25.6518 12.1064 25.75 12.4105 25.75H15.5902C16.211 25.75 16.6831 25.3831 16.8338 24.7812C16.9511 24.3295 17.0752 23.5696 17.2099 22.4886C17.3861 22.4215 17.5601 22.3488 17.732 22.2705L19.3392 23.5284C19.6419 23.7268 19.9015 23.8164 20.1737 23.8164C20.6789 23.8164 21.1817 23.4367 22.0466 22.5834C22.7609 21.8794 23.2566 21.3386 23.544 20.9441C23.7039 20.7722 23.8167 20.4843 23.8167 20.1733C23.8167 19.8635 23.702 19.5764 23.498 19.3332C22.9849 18.7055 22.5728 18.1822 22.2641 17.7663C22.3438 17.593 22.4221 17.4078 22.4991 17.2105L24.7115 16.8759C25.0381 16.8211 25.3044 16.6479 25.4928 16.3883C25.659 16.1592 25.75 15.8967 25.75 15.6183V12.4388C25.7506 12.1505 25.6581 11.8781 25.4818 11.6471ZM21.2479 11.7459L21.3875 12.1928L24.25 12.6307L24.25 15.4287L21.8374 15.7935L21.3917 15.8609L21.2421 16.2861C21.073 16.7666 20.9019 17.1658 20.7311 17.4819L20.511 17.8892L20.7765 18.2685C21.1063 18.7397 21.5945 19.3714 22.2471 20.1728C21.9672 20.521 21.5572 20.9597 20.9934 21.5153C20.671 21.8333 20.4097 22.0673 20.2157 22.2138L20.1987 22.2265C20.1802 22.2402 20.1638 22.2522 20.1504 22.2624L18.287 20.8L17.906 20.5018L17.4772 20.726C17.0954 20.9257 16.7008 21.0905 16.2931 21.2208L15.8329 21.3678L15.7765 21.8476C15.6441 22.9729 15.5231 23.7797 15.4187 24.25H12.603L12.2354 21.8224L12.1659 21.3658L11.727 21.2223C11.2956 21.0813 10.9023 20.9195 10.5465 20.7374L10.1269 20.5226L7.85452 22.2471C6.8373 21.3197 6.15485 20.6298 5.80219 20.1807C5.94284 19.99 6.15354 19.7172 6.43881 19.3564C6.79053 18.9118 7.05373 18.5682 7.23271 18.3193L7.50689 17.938L7.28368 17.5249C7.05097 17.0942 6.87607 16.6719 6.75783 16.2578L6.62493 15.7925L3.75 15.3683V12.5693L6.16262 12.2066L6.63082 12.1361L6.76856 11.6831C6.88705 11.2935 7.05343 10.9009 7.2684 10.5055L7.49041 10.0971L7.22347 9.71655C6.85093 9.18548 6.36367 8.55439 5.75903 7.81892C5.99231 7.52266 6.41096 7.07272 7.00005 6.49165C7.32487 6.17133 7.58818 5.93551 7.78349 5.78772C7.79636 5.77798 7.80848 5.76903 7.81958 5.76083L7.81959 5.76082L7.83892 5.74648L9.71619 7.20208L10.0966 7.49703L10.5232 7.27405C10.9049 7.07455 11.2995 6.90974 11.7075 6.77929L12.1676 6.63222L12.224 6.15249C12.3563 5.02732 12.4774 4.22033 12.582 3.75H15.3976L15.7652 6.17779L15.8347 6.63446L16.2738 6.77788C16.7052 6.91879 17.0984 7.08048 17.4537 7.26248L17.8718 7.47669L20.159 5.75313C21.1665 6.68811 21.8565 7.39286 22.1932 7.82557C22.0506 8.01856 21.8402 8.29106 21.5614 8.64344C21.2103 9.0875 20.9468 9.43156 20.7677 9.68065L20.4983 10.0552L20.7111 10.4645C20.9397 10.9042 21.1184 11.3313 21.2479 11.7459ZM16.0623 16.0622C16.6379 15.4868 16.917 14.8133 16.917 14.0001C16.917 13.1869 16.638 12.5135 16.0624 11.9378C15.4871 11.3624 14.8136 11.0834 14.0003 11.0834C13.1872 11.0834 12.5137 11.3625 11.9381 11.9378C11.3625 12.5134 11.0836 13.1867 11.0836 14.0001C11.0836 14.8132 11.3627 15.4867 11.9381 16.0621C12.5137 16.6378 13.1871 16.9168 14.0003 16.9168C14.8136 16.9168 15.487 16.6377 16.0623 16.0622ZM10.8774 17.1228C11.7343 17.9797 12.7892 18.4168 14.0003 18.4168C15.2116 18.4168 16.2665 17.9796 17.1231 17.1227C17.9799 16.2663 18.417 15.2112 18.417 14.0001C18.417 12.789 17.9799 11.7342 17.1232 10.8773C16.2666 10.0205 15.2115 9.58338 14.0003 9.58338C12.7894 9.58338 11.7344 10.0205 10.8775 10.8771C10.0206 11.7341 9.58358 12.7889 9.58358 14.0001C9.58358 15.2111 10.0208 16.2662 10.8774 17.1228Z",
                            fill: secondColor
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        mask: "url(#mask0_0_2536)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            id: "Cores/Preto_2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                id: "Rectangle",
                                width: "28",
                                height: "28",
                                fill: color
                            })
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SettingsIcon.tsx


var SettingsIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 17 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.41421 3.75229C6.19526 4.53334 6.19526 5.79967 5.41421 6.58072C4.63316 7.36176 3.36683 7.36176 2.58579 6.58072C1.80474 5.79967 1.80474 4.53334 2.58579 3.75229C3.36683 2.97124 4.63316 2.97124 5.41421 3.75229",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3333 5.16634H6",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.4142 10.4188C14.1953 11.1998 14.1953 12.4662 13.4142 13.2472C12.6332 14.0283 11.3668 14.0283 10.5858 13.2472C9.80474 12.4662 9.80474 11.1998 10.5858 10.4188C11.3668 9.63775 12.6332 9.63775 13.4142 10.4188",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.66699 11.8333H10.0003",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Share.tsx


var Share = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "https://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: color,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "Icons / Share",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Mask",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.4772 4.26136C17.4772 4.72199 17.5507 5.16577 17.6866 5.58161L8.47053 10.8358C7.68866 9.94104 6.53966 9.375 5.26138 9.375C2.91242 9.375 1 11.2864 1 13.6364C1 15.9864 2.91242 17.8977 5.26138 17.8977C6.53985 17.8977 7.689 17.3315 8.47088 16.4366L17.6868 21.6906C17.5508 22.1066 17.4772 22.5505 17.4772 23.0114C17.4772 25.3614 19.3899 27.2727 21.7386 27.2727C24.0876 27.2727 26 25.3614 26 23.0114C26 20.6614 24.0876 18.75 21.7386 18.75C20.4608 18.75 19.3121 19.3157 18.5302 20.21L9.31375 14.9556C9.44939 14.5401 9.52275 14.0966 9.52275 13.6364C9.52275 13.1759 9.44932 12.7322 9.31356 12.3165L18.5299 7.06235C19.3118 7.95686 20.4606 8.52273 21.7386 8.52273C24.0876 8.52273 26 6.61136 26 4.26136C26 1.91137 24.0876 0 21.7386 0C19.3899 0 17.4772 1.91137 17.4772 4.26136ZM19.1818 4.26136C19.1818 2.85104 20.3295 1.70455 21.7386 1.70455C23.1477 1.70455 24.2955 2.85104 24.2955 4.26136C24.2955 5.67169 23.1477 6.81818 21.7386 6.81818C20.3295 6.81818 19.1818 5.67169 19.1818 4.26136ZM19.1818 23.0114C19.1818 21.601 20.3295 20.4545 21.7386 20.4545C23.1477 20.4545 24.2955 21.601 24.2955 23.0114C24.2955 24.4217 23.1477 25.5682 21.7386 25.5682C20.3295 25.5682 19.1818 24.4217 19.1818 23.0114ZM5.26138 11.0795C3.85229 11.0795 2.70455 12.226 2.70455 13.6364C2.70455 15.0467 3.85229 16.1932 5.26138 16.1932C6.67046 16.1932 7.8182 15.0467 7.8182 13.6364C7.8182 12.226 6.67046 11.0795 5.26138 11.0795Z",
                    strokeWidth: strokeWidth
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                    id: "mask0_0_3206",
                    maskUnits: "userSpaceOnUse",
                    x: "1",
                    y: "0",
                    width: Number(width) - 3,
                    height: height,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Mask_2",
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M17.4772 4.26136C17.4772 4.72199 17.5507 5.16577 17.6866 5.58161L8.47053 10.8358C7.68866 9.94104 6.53966 9.375 5.26138 9.375C2.91242 9.375 1 11.2864 1 13.6364C1 15.9864 2.91242 17.8977 5.26138 17.8977C6.53985 17.8977 7.689 17.3315 8.47088 16.4366L17.6868 21.6906C17.5508 22.1066 17.4772 22.5505 17.4772 23.0114C17.4772 25.3614 19.3899 27.2727 21.7386 27.2727C24.0876 27.2727 26 25.3614 26 23.0114C26 20.6614 24.0876 18.75 21.7386 18.75C20.4608 18.75 19.3121 19.3157 18.5302 20.21L9.31375 14.9556C9.44939 14.5401 9.52275 14.0966 9.52275 13.6364C9.52275 13.1759 9.44932 12.7322 9.31356 12.3165L18.5299 7.06235C19.3118 7.95686 20.4606 8.52273 21.7386 8.52273C24.0876 8.52273 26 6.61136 26 4.26136C26 1.91137 24.0876 0 21.7386 0C19.3899 0 17.4772 1.91137 17.4772 4.26136ZM19.1818 4.26136C19.1818 2.85104 20.3295 1.70455 21.7386 1.70455C23.1477 1.70455 24.2955 2.85104 24.2955 4.26136C24.2955 5.67169 23.1477 6.81818 21.7386 6.81818C20.3295 6.81818 19.1818 5.67169 19.1818 4.26136ZM19.1818 23.0114C19.1818 21.601 20.3295 20.4545 21.7386 20.4545C23.1477 20.4545 24.2955 21.601 24.2955 23.0114C24.2955 24.4217 23.1477 25.5682 21.7386 25.5682C20.3295 25.5682 19.1818 24.4217 19.1818 23.0114ZM5.26138 11.0795C3.85229 11.0795 2.70455 12.226 2.70455 13.6364C2.70455 15.0467 3.85229 16.1932 5.26138 16.1932C6.67046 16.1932 7.8182 15.0467 7.8182 13.6364C7.8182 12.226 6.67046 11.0795 5.26138 11.0795Z"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    mask: "url(#mask0_0_3206)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        id: "Cores/Preto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            id: "Rectangle",
                            width: width,
                            height: height,
                            fill: "transparent"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ShieldUserProtection.tsx


var ShieldUserProtection = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de usu\xe1rio com escudo" : _alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "10.5",
                r: "2.5",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 12.5209C20 16.2956 15.3552 19.0997 13.1401 20.2255C12.4254 20.5909 11.579 20.5916 10.8636 20.2274C8.65012 19.1027 4 16.2918 4 12.5209V7.06937C4.00735 6.55852 4.39423 6.13323 4.9021 6.07769C7.02402 5.91645 9.05835 5.16411 10.7746 3.90593C11.5019 3.36469 12.4981 3.36469 13.2254 3.90593C14.9416 5.16411 16.9759 5.91645 19.0979 6.07769C19.6057 6.13321 19.9926 6.55851 20 7.06937V12.5209Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.9007 17.8015L16.4409 16.882C16.0175 16.035 15.1518 15.5 14.2049 15.5H9.79502C8.84808 15.5 7.98241 16.035 7.55894 16.882L7.10156 17.7968",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ShopIcon.tsx


var ShopIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.66919 3.75195H18.5623L21.4309 8.74808H2.85544L5.66919 3.75195Z",
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.85677 8.70435C2.28022 11.3894 7.00793 12.6578 7.48564 8.83613C7.25502 11.62 11.7356 12.3943 12.1145 8.96791C12.1619 11.7042 16.4329 12.1972 16.8093 9.08322C17.4188 12.5919 22.013 11.289 21.4382 8.77024",
                stroke: color,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.40503 11.373V19.5378C4.40503 19.8139 4.62889 20.0378 4.90503 20.0378H19.3645C19.6406 20.0378 19.8645 19.8139 19.8645 19.5378V11.373",
                stroke: color,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.9118 20.252V14.1357C10.9118 13.5835 10.4641 13.1357 9.91179 13.1357H8.09009C7.5378 13.1357 7.09009 13.5835 7.09009 14.1357V20.252",
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.2627 13.1414H16.6328C16.909 13.1414 17.1329 13.3652 17.1329 13.6414V16.3855C17.1329 16.6617 16.909 16.8855 16.6329 16.8855H13.2627C12.9866 16.8855 12.7627 16.6617 12.7627 16.3855V13.6414C12.7627 13.3652 12.9866 13.1414 13.2627 13.1414Z",
                stroke: color,
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ShoppingBagIcon.tsx


var ShoppingBagIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 20 : _height, _width = param.width, width = _width === void 0 ? 20 : _width, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.760 */.rS.colors.neutral[760] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de sacola" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0021 17.5016H4.99793C4.55568 17.5017 4.13151 17.3261 3.81879 17.0134C3.50607 16.7007 3.33057 16.2765 3.33057 15.8342V7.0806C3.33082 6.39006 3.89055 5.83033 4.58109 5.83008H15.4189C16.1095 5.83033 16.6692 6.39006 16.6695 7.0806V15.8342C16.6695 16.2765 16.4939 16.7007 16.1812 17.0134C15.8685 17.3261 15.4443 17.5017 15.0021 17.5016Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.2964 11.0195L9.67492 12.641L8.70264 11.6677",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.66553 5.83082V5.6224V5.6224C6.66553 3.8958 8.06524 2.49614 9.79183 2.49609H10.2087C11.9353 2.49614 13.335 3.8958 13.335 5.6224V5.6224V5.83082",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ShoppingCartIcon.tsx


var ShoppingCartIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.760 */.rS.colors.neutral[760] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de carrinho de compras" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.17419 11.8723L4.89502 5.83398H15.4167C15.9592 5.83398 16.3567 6.34315 16.225 6.86982L15.1017 11.3632C14.9309 12.0457 14.3509 12.5473 13.6509 12.6173L7.97085 13.1857C7.12419 13.2698 6.35002 12.704 6.17419 11.8723Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.89484 5.83398L4.35317 3.33398H2.9165",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.2573 16.057C14.089 16.057 13.9523 16.1936 13.954 16.362C13.954 16.5303 14.0906 16.667 14.259 16.667C14.4273 16.667 14.564 16.5303 14.564 16.362C14.5631 16.1936 14.4265 16.057 14.2573 16.057",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.24746 16.0566C7.07912 16.0566 6.94246 16.1932 6.94412 16.3616C6.94246 16.5307 7.07996 16.6674 7.24829 16.6674C7.41662 16.6674 7.55329 16.5307 7.55329 16.3624C7.55329 16.1932 7.41662 16.0566 7.24746 16.0566",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SingleUserIcon.tsx


var SingleUserIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de usu\xe1rio" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 20V19.25C20 16.9028 18.0972 15 15.75 15H8.25C5.90279 15 4 16.9028 4 19.25V20",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "7",
                r: "4",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SocialMedia.tsx


var SocialMedia = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.55286 10.1142C9.59439 11.1557 9.59439 12.8443 8.55286 13.8859C7.51133 14.9274 5.82268 14.9274 4.78115 13.8859C3.73962 12.8443 3.73962 11.1557 4.78115 10.1142C5.82268 9.07263 7.51133 9.07263 8.55286 10.1142",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.2189 4.78115C20.2604 5.82268 20.2604 7.51133 19.2189 8.55286C18.1774 9.59439 16.4887 9.59439 15.4472 8.55286C14.4057 7.51133 14.4057 5.82268 15.4472 4.78115C16.4887 3.73962 18.1774 3.73962 19.2189 4.78115",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.2189 15.4472C20.2604 16.4887 20.2604 18.1773 19.2189 19.2189C18.1774 20.2604 16.4887 20.2604 15.4472 19.2189C14.4057 18.1773 14.4057 16.4887 15.4472 15.4472C16.4887 14.4056 18.1774 14.4056 19.2189 15.4472",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.03999 10.8101L14.96 7.8501",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.03999 13.1899L14.96 16.1499",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Spotify.tsx


var Spotify = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.280 */.rS.colors.neutral[280] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9 0C4.05 0 0 4.05 0 9C0 13.95 4.05 18 9 18C13.95 18 18 13.95 18 9C18 4.05 13.95 0 9 0ZM12.5483 13.5C12.3833 13.5 12.3007 13.4175 12.1357 13.335C10.8982 12.5918 9.33075 12.18 7.68075 12.18C6.77325 12.18 5.78325 12.345 4.95825 12.51C4.79325 12.51 4.62825 12.5925 4.54575 12.5925C4.21575 12.5925 3.96825 12.345 3.96825 12.015C3.96825 11.685 4.13325 11.4375 4.46325 11.4375C5.53575 11.19 6.609 11.025 7.764 11.025C9.6615 11.025 11.394 11.52 12.879 12.345C13.044 12.51 13.209 12.5925 13.209 12.9225C13.0425 13.335 12.795 13.5 12.5483 13.5ZM13.455 11.1907C13.29 11.1907 13.125 11.1082 12.96 11.0257C11.5575 10.1182 9.57675 9.62325 7.4325 9.62325C6.36 9.62325 5.36925 9.78825 4.6275 9.95325C4.4625 10.0357 4.38 10.0357 4.215 10.0357C3.8025 10.0357 3.55425 9.70575 3.55425 9.375C3.55425 8.9625 3.71925 8.7975 4.13175 8.63175C5.12175 8.38425 6.1125 8.13675 7.515 8.13675C9.825 8.13675 11.97 8.71425 13.7857 9.78675C14.0332 9.95175 14.1982 10.1992 14.1982 10.4475C14.115 10.86 13.8682 11.1907 13.455 11.1907ZM14.5275 8.55C14.3625 8.55 14.28 8.4675 14.0325 8.385C12.3825 7.4775 9.99 6.9 7.68 6.9C6.525 6.9 5.2875 7.065 4.21425 7.3125C4.04925 7.3125 3.96675 7.395 3.71925 7.395C3.22425 7.47825 2.89425 7.065 2.89425 6.57075C2.89425 6.0765 3.14175 5.8275 3.47175 5.74575C4.7925 5.415 6.195 5.25 7.68 5.25C10.2375 5.25 12.8775 5.8275 14.9407 6.9C15.1882 7.065 15.4357 7.3125 15.4357 7.725C15.3532 8.22 15.0225 8.55 14.5275 8.55Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SpotifyIconFooter.tsx


var SpotifyIconFooter = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xcdcone do Spotify" : _alt, _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.150 */.rS.colors.neutral[150] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12 3C7.05 3 3 7.05 3 12C3 16.95 7.05 21 12 21C16.95 21 21 16.95 21 12C21 7.05 16.95 3 12 3ZM15.5483 16.5C15.3833 16.5 15.3007 16.4175 15.1357 16.335C13.8982 15.5918 12.3307 15.18 10.6808 15.18C9.77325 15.18 8.78325 15.345 7.95825 15.51C7.79325 15.51 7.62825 15.5925 7.54575 15.5925C7.21575 15.5925 6.96825 15.345 6.96825 15.015C6.96825 14.685 7.13325 14.4375 7.46325 14.4375C8.53575 14.19 9.609 14.025 10.764 14.025C12.6615 14.025 14.394 14.52 15.879 15.345C16.044 15.51 16.209 15.5925 16.209 15.9225C16.0425 16.335 15.795 16.5 15.5483 16.5ZM16.455 14.1907C16.29 14.1907 16.125 14.1082 15.96 14.0257C14.5575 13.1182 12.5767 12.6232 10.4325 12.6232C9.36 12.6232 8.36925 12.7882 7.6275 12.9532C7.4625 13.0357 7.38 13.0357 7.215 13.0357C6.8025 13.0357 6.55425 12.7057 6.55425 12.375C6.55425 11.9625 6.71925 11.7975 7.13175 11.6317C8.12175 11.3842 9.1125 11.1367 10.515 11.1367C12.825 11.1367 14.97 11.7142 16.7857 12.7867C17.0332 12.9517 17.1982 13.1992 17.1982 13.4475C17.115 13.86 16.8682 14.1907 16.455 14.1907ZM17.5275 11.55C17.3625 11.55 17.28 11.4675 17.0325 11.385C15.3825 10.4775 12.99 9.9 10.68 9.9C9.525 9.9 8.2875 10.065 7.21425 10.3125C7.04925 10.3125 6.96675 10.395 6.71925 10.395C6.22425 10.4782 5.89425 10.065 5.89425 9.57075C5.89425 9.0765 6.14175 8.8275 6.47175 8.74575C7.7925 8.415 9.195 8.25 10.68 8.25C13.2375 8.25 15.8775 8.8275 17.9407 9.9C18.1882 10.065 18.4357 10.3125 18.4357 10.725C18.3532 11.22 18.0225 11.55 17.5275 11.55Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Star.tsx


var Star = function(param) {
    var _width = param.width, width = _width === void 0 ? 12 : _width, _height = param.height, height = _height === void 0 ? 12.5 : _height, _color = param.color, color = _color === void 0 ? "".concat(themes/* theme.colors.secondary.265 */.rS.colors.secondary[265]) : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 11.49L4.11933 13.3333L4.92533 9.25333L2 6.26133L6.11933 5.74733L8 2L9.88067 5.74733L14 6.26133L11.0747 9.25333L11.8807 13.3333L8 11.49Z",
            fill: color,
            stroke: color
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/StarIcon.tsx


var StarIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 35 : _width, _height = param.height, height = _height === void 0 ? 35 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.200 */.rS.colors.primary[200] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 8V16",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 12H8",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/StatusIcon.tsx


var StatusIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.155 */.rS.colors.primary[155] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de status" : _alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.49835 19.7913C6.13361 19.0007 4.99957 17.8667 4.20898 16.502",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5019 4.20909C15.1346 3.41459 13.5813 2.99625 12 2.99658",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 21.0038C15.2135 20.9977 18.1811 19.2829 19.7912 16.502",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.49797 4.20898C4.71698 5.81909 3.00222 8.78678 2.99609 12.0002",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12.0001",
                cy: "12.0001",
                r: "5.00208",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Store.tsx


var Store = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 13H8V16H10",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 20.0001L11 20",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.22 20V9.98706",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.7243 6.47765C22.0194 7.03345 22.078 7.68474 21.887 8.28433C21.5565 9.32453 20.5804 10.0228 19.4892 9.99943C18.398 9.9761 17.4526 9.23678 17.1669 8.18341C17.1488 8.12223 17.0926 8.08025 17.0288 8.08025C16.965 8.08025 16.9088 8.12223 16.8907 8.18341C16.5989 9.25555 15.6253 9.99951 14.5142 9.99939C13.4031 9.99927 12.4296 9.2551 12.1381 8.1829C12.12 8.12169 12.0638 8.07968 12 8.07968C11.9362 8.07968 11.88 8.12169 11.8619 8.1829C11.5702 9.2551 10.5967 9.99918 9.48551 9.99914C8.37435 9.9991 7.40085 9.25495 7.10926 8.18273C7.09113 8.12156 7.03493 8.0796 6.97113 8.0796C6.90734 8.0796 6.85113 8.12156 6.833 8.18273C6.54727 9.23599 5.60193 9.97521 4.51085 9.99858C3.41977 10.0219 2.44365 9.32387 2.11308 8.28381C1.92195 7.68412 1.98061 7.0327 2.2758 6.47681L3.98252 3.09822C4.32276 2.4247 5.0131 2 5.76768 2H18.232C18.9866 2 19.6769 2.4247 20.0172 3.09822L21.7243 6.47765Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14 21.5V21.094C14.0033 19.9389 14.9389 19.0033 16.094 19H18.906C20.0611 19.0033 20.9967 19.9389 21 21.094V21.5C21 21.7761 20.7761 22 20.5 22H14.5C14.3674 22 14.2402 21.9473 14.1464 21.8536C14.0527 21.7598 14 21.6326 14 21.5Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "17.5",
                cy: "14.5",
                r: "2",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SuccessIcon.tsx


var SuccessIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xedcone de sucesso" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.230 */.rS.colors.secondary[230] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.680 */.rS.colors.neutral[680] : _secondColor, _height = param.height, height = _height === void 0 ? 25 : _height, _width = param.width, width = _width === void 0 ? 25 : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.238281",
                y: "0.5",
                width: "24",
                height: "24",
                rx: "8",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5719 8.83398L10.2386 16.1673L6.90527 12.834",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SuccessSyncIcon.tsx

var SuccessSyncIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 120 : _width, _height = param.height, height = _height === void 0 ? 121 : _height, _alt = param.alt, alt = _alt === void 0 ? "Sucesso ao sincronizar" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-labelledby": alt,
        "aria-label": alt,
        viewBox: "0 0 120 121",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                y: "0.5",
                width: "120",
                height: "120",
                rx: "12.1582",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M98.6575 69.605C96.9142 69.605 95.5 70.9248 95.5 72.5527C95.5 74.1806 96.9142 75.4997 98.6575 75.4997H107.342C109.086 75.4997 110.5 74.1798 110.5 72.5527C110.5 70.9256 109.086 69.6057 107.342 69.6057C107.342 67.3673 105.398 65.5527 103 65.5527C100.602 65.5527 98.6575 67.3665 98.6575 69.605Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.8318 12.7932C9.6511 12.7932 8.69336 13.6871 8.69336 14.7896C8.69336 15.8921 9.6511 16.7854 10.8318 16.7854H16.7131C17.8943 16.7854 18.8521 15.8915 18.8521 14.7896C18.8521 13.6876 17.8943 12.7937 16.7137 12.7937C16.7137 11.2777 15.397 10.0488 13.7727 10.0488C12.1485 10.0488 10.8318 11.2772 10.8318 12.7932Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M105.324 28.6947C103.992 28.6947 102.911 29.7035 102.911 30.9477C102.911 32.1918 103.992 33.2 105.324 33.2H111.962C113.295 33.2 114.375 32.1912 114.375 30.9477C114.375 29.7041 113.295 28.6953 111.962 28.6953C111.962 26.9845 110.476 25.5977 108.643 25.5977C106.81 25.5977 105.324 26.9839 105.324 28.6947Z",
                    stroke: "#8F9194",
                    strokeWidth: "0.509524",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M99.8318 107.793C98.6511 107.793 97.6934 108.687 97.6934 109.79C97.6934 110.892 98.6511 111.785 99.8318 111.785H105.713C106.894 111.785 107.852 110.892 107.852 109.79C107.852 108.688 106.894 107.794 105.714 107.794C105.714 106.278 104.397 105.049 102.773 105.049C101.148 105.049 99.8318 106.277 99.8318 107.793Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M79.2461 11.0157C77.6296 11.0157 76.3184 12.2396 76.3184 13.749C76.3184 15.2585 77.6296 16.4816 79.2461 16.4816H87.2985C88.9158 16.4816 90.2271 15.2578 90.2271 13.749C90.2271 12.2403 88.9158 11.0164 87.2993 11.0164C87.2993 8.94084 85.4966 7.2583 83.2727 7.2583C81.0489 7.2583 79.2461 8.94012 79.2461 11.0157Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M38.2246 51.9855C36.6146 51.9855 35.3086 53.2044 35.3086 54.7078C35.3086 56.2112 36.6146 57.4294 38.2246 57.4294H46.2446C47.8554 57.4294 49.1614 56.2105 49.1614 54.7078C49.1614 53.2051 47.8554 51.9862 46.2454 51.9862C46.2454 49.9189 44.4499 48.2432 42.235 48.2432C40.0201 48.2432 38.2246 49.9182 38.2246 51.9855Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M82.2246 45.9855C80.6146 45.9855 79.3086 47.2044 79.3086 48.7078C79.3086 50.2112 80.6146 51.4294 82.2246 51.4294H90.2446C91.8554 51.4294 93.1614 50.2105 93.1614 48.7078C93.1614 47.2051 91.8554 45.9862 90.2454 45.9862C90.2454 43.9189 88.4499 42.2432 86.235 42.2432C84.0201 42.2432 82.2246 43.9182 82.2246 45.9855Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M37.8318 78.9885C36.6511 78.9885 35.6934 79.8824 35.6934 80.9849C35.6934 82.0874 36.6511 82.9807 37.8318 82.9807H43.7131C44.8943 82.9807 45.8521 82.0868 45.8521 80.9849C45.8521 79.8829 44.8943 78.989 43.7137 78.989C43.7137 77.473 42.397 76.2441 40.7727 76.2441C39.1485 76.2441 37.8318 77.4725 37.8318 78.9885Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.8318 101.553C10.6511 101.553 9.69336 102.447 9.69336 103.549C9.69336 104.652 10.6511 105.545 11.8318 105.545H17.7131C18.8943 105.545 19.8521 104.651 19.8521 103.549C19.8521 102.447 18.8943 101.553 17.7137 101.553C17.7137 100.037 16.397 98.8086 14.7727 98.8086C13.1485 98.8086 11.8318 100.037 11.8318 101.553Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M49.2246 105.985C47.6146 105.985 46.3086 107.204 46.3086 108.708C46.3086 110.211 47.6146 111.429 49.2246 111.429H57.2446C58.8554 111.429 60.1614 110.21 60.1614 108.708C60.1614 107.205 58.8554 105.986 57.2454 105.986C57.2454 103.919 55.4499 102.243 53.235 102.243C51.0201 102.243 49.2246 103.918 49.2246 105.985Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.22461 58.3224C6.61461 58.3224 5.30859 59.5413 5.30859 61.0447C5.30859 62.5481 6.61461 63.7663 8.22461 63.7663H16.2446C17.8554 63.7663 19.1614 62.5474 19.1614 61.0447C19.1614 59.5421 17.8554 58.3231 16.2454 58.3231C16.2454 56.2559 14.4499 54.5801 12.235 54.5801C10.0201 54.5801 8.22461 56.2551 8.22461 58.3224Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.9818 96.263V94.0448C95.9818 89.1444 92.0093 85.1719 87.1089 85.1719H69.3631C64.4628 85.1719 60.4902 89.1444 60.4902 94.0448V96.263",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M95.9818 96.263V94.0448C95.9818 89.1444 92.0093 85.1719 87.1089 85.1719H69.3631C64.4628 85.1719 60.4902 89.1444 60.4902 94.0448V96.263",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "78.2362",
                cy: "67.4256",
                r: "8.8729",
                fill: "white",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.6689 20.9189H89.3392C93.6808 20.9189 97.2055 24.4436 97.2055 28.7852V43.8661",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46.7212 96.1854H27.0509C22.7093 96.1854 19.1846 92.6607 19.1846 88.3191V73.2383",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.7985 21.9987C18.0921 22.7605 13.6777 27.506 13.6777 33.3116C13.6777 39.6496 18.9207 44.7852 25.3808 44.7852H51.1275C56.3002 44.7852 60.4899 40.6777 60.4899 35.6063C60.4899 30.535 56.3002 26.4275 51.1275 26.4275C51.1275 18.8228 44.8406 12.6592 37.0838 12.6592C30.914 12.6592 25.6804 16.5694 23.7985 21.9987Z",
                fill: "#F6F7F7",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "35.714",
                cy: "30.5465",
                r: "9.9777",
                fill: "#7AC143"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.7715 30.9219L34.1739 33.3243L34.1584 33.3088L39.5785 27.8887",
                stroke: "white",
                strokeWidth: "1.13983",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TelephoneAuthenticationIcon.tsx


var TelephoneAuthenticationIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 144 : _width, _height = param.height, height = _height === void 0 ? 120 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.750 */.rS.colors.neutral[750] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 144 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4146_9395)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M56.4105 13.3111C61.4008 4.57583 73.996 4.57581 78.9863 13.3111L128.354 99.7263C133.305 108.393 127.047 119.175 117.066 119.175H18.3308C8.34975 119.175 2.09192 108.393 7.04296 99.7263L56.4105 13.3111Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M57.6048 37.1367H79.5254C85.3975 37.1367 90.1536 41.8928 90.1536 47.7649V95.5917C90.1536 101.464 85.3975 106.22 79.5254 106.22H57.6048C51.7327 106.22 46.9766 101.464 46.9766 95.5917V47.7649C46.9766 41.8928 51.7327 37.1367 57.6048 37.1367Z",
                fill: color,
                stroke: secondColor,
                strokeWidth: "4.63085",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.668",
                y: "54.0312",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: "#B6DD98"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.668",
                y: "42.7686",
                width: "33.7907",
                height: "5.63178",
                rx: "2.54473",
                fill: "url(#paint0_linear_4146_9395)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.668",
                y: "85.9453",
                width: "33.7907",
                height: "15.0181",
                rx: "7.50904",
                fill: "url(#paint1_linear_4146_9395)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.668",
                y: "67.1729",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: "#B6DD98"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.668",
                y: "73.7432",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: "#B6DD98"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "64.8086",
                y: "60.6025",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: "#D0E9BD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "64.8086",
                y: "80.3145",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: "#D0E9BD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M46.3287 33.5937C45.4571 33.5937 44.75 34.3008 44.75 35.1729C44.75 36.0449 45.4571 36.7516 46.3287 36.7516H50.6708C51.5429 36.7516 52.25 36.0445 52.25 35.1729C52.25 34.3012 51.5429 33.5941 50.6712 33.5941C50.6712 32.3949 49.6992 31.4229 48.5 31.4229C47.3008 31.4229 46.3287 32.3945 46.3287 33.5937Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M110.451 84.7628C108.047 78.8326 110.574 72.0484 116.273 69.1373C121.971 66.2262 128.95 68.154 132.346 73.5776C135.742 79.0011 134.428 86.1208 129.321 89.9758C124.213 93.8309 117.006 93.1422 112.722 88.3895L108.737 88.3603L110.451 84.7628Z",
                fill: "#68A439",
                stroke: secondColor,
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.851 72.3812L126.194 73.6096C127.178 73.8358 127.792 74.8161 127.566 75.8L125.109 86.4859C124.883 87.4698 123.902 88.0836 122.918 87.8573L117.575 86.6289C116.591 86.4027 115.978 85.4225 116.204 84.4385L118.661 73.7526C118.887 72.7687 119.867 72.1549 120.851 72.3812Z",
                fill: color,
                stroke: secondColor,
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121.742 72.5859L121.374 74.1888C121.306 74.4836 121.45 74.769 121.696 74.8255L124.368 75.4397C124.613 75.4962 124.868 75.3025 124.936 75.0078L125.304 73.4049",
                stroke: secondColor,
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.761 84.788L121.756 85.2466",
                stroke: "#5C5E62",
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.9449 64.6327C35.6847 58.8499 33.5496 51.9322 28.0272 48.6995C22.5047 45.4669 15.4274 46.9919 11.7265 52.2121C8.02549 57.4323 8.92888 64.6154 13.8072 68.7566C18.6855 72.8978 25.92 72.623 30.47 68.1235L34.4503 68.3225L32.9449 64.6327Z",
                fill: "#68A439",
                stroke: secondColor,
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.2766 51.676L17.8721 52.5964C16.8768 52.7659 16.2079 53.7094 16.3775 54.7047L18.2184 65.5137C18.3879 66.509 19.3314 67.1779 20.3267 67.0084L25.7312 66.0879C26.7265 65.9184 27.3954 64.9749 27.2259 63.9796L25.3849 53.1706C25.2154 52.1753 24.272 51.5064 23.2766 51.676Z",
                fill: color,
                stroke: secondColor,
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.375 51.8291L22.6511 53.4504C22.7019 53.7486 22.5414 54.0253 22.2928 54.0676L19.5906 54.5278C19.342 54.5702 19.0989 54.3622 19.0481 54.0641L18.772 52.4427",
                stroke: secondColor,
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.6548 64.1252L21.6372 64.4688",
                stroke: "#5C5E62",
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M66.7431 13.3312C65.4356 13.3312 64.375 14.3211 64.375 15.542C64.375 16.7629 65.4356 17.7522 66.7431 17.7522H73.2562C74.5644 17.7522 75.625 16.7623 75.625 15.542C75.625 14.3217 74.5644 13.3317 73.2569 13.3317C73.2569 11.6529 71.7987 10.292 70 10.292C68.2012 10.292 66.7431 11.6523 66.7431 13.3312Z",
                    stroke: "#8F9194",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M72.3287 25.5937C71.4571 25.5937 70.75 26.3008 70.75 27.1729C70.75 28.0449 71.4571 28.7516 72.3287 28.7516H76.6708C77.5429 28.7516 78.25 28.0445 78.25 27.1729C78.25 26.3012 77.5429 25.5941 76.6712 25.5941C76.6712 24.3949 75.6992 23.4229 74.5 23.4229C73.3008 23.4229 72.3287 24.3945 72.3287 25.5937Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M58.7431 26.8963C57.4356 26.8963 56.375 27.8155 56.375 28.9492C56.375 30.0829 57.4356 31.0016 58.7431 31.0016H65.2562C66.5644 31.0016 67.625 30.0824 67.625 28.9492C67.625 27.8161 66.5644 26.8968 65.2569 26.8968C65.2569 25.3379 63.7987 24.0742 62 24.0742C60.2012 24.0742 58.7431 25.3374 58.7431 26.8963Z",
                    stroke: "#A0A2A4",
                    strokeWidth: "0.62",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M30.4602 86.8963C29.2399 86.8963 28.25 87.8155 28.25 88.9492C28.25 90.0829 29.2399 91.0016 30.4602 91.0016H36.5392C37.7601 91.0016 38.75 90.0824 38.75 88.9492C38.75 87.8161 37.7601 86.8968 36.5397 86.8968C36.5397 85.3379 35.1788 84.0742 33.5 84.0742C31.8212 84.0742 30.4602 85.3374 30.4602 86.8963Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M98.3287 78.5937C97.4571 78.5937 96.75 79.3008 96.75 80.1729C96.75 81.0449 97.4571 81.7516 98.3287 81.7516H102.671C103.543 81.7516 104.25 81.0445 104.25 80.1729C104.25 79.3012 103.543 78.5941 102.671 78.5941C102.671 77.3949 101.699 76.4229 100.5 76.4229C99.3008 76.4229 98.3287 77.3945 98.3287 78.5937Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M96.4602 62.3312C95.2399 62.3312 94.25 63.3211 94.25 64.542C94.25 65.7629 95.2399 66.7522 96.4602 66.7522H102.539C103.76 66.7522 104.75 65.7623 104.75 64.542C104.75 63.3217 103.76 62.3317 102.54 62.3317C102.54 60.6529 101.179 59.292 99.5 59.292C97.8212 59.292 96.4602 60.6523 96.4602 62.3312Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M33.3287 109.594C32.4571 109.594 31.75 110.301 31.75 111.173C31.75 112.045 32.4571 112.752 33.3287 112.752H37.6708C38.5429 112.752 39.25 112.045 39.25 111.173C39.25 110.301 38.5429 109.594 37.6712 109.594C37.6712 108.395 36.6992 107.423 35.5 107.423C34.3008 107.423 33.3287 108.395 33.3287 109.594Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M104.612 106.594C103.653 106.594 102.875 107.301 102.875 108.173C102.875 109.045 103.653 109.752 104.612 109.752H109.388C110.347 109.752 111.125 109.045 111.125 108.173C111.125 107.301 110.347 106.594 109.388 106.594C109.388 105.395 108.319 104.423 107 104.423C105.681 104.423 104.612 105.395 104.612 106.594Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.6116 103.594C12.6528 103.594 11.875 104.301 11.875 105.173C11.875 106.045 12.6528 106.752 13.6116 106.752H18.3879C19.3472 106.752 20.125 106.045 20.125 105.173C20.125 104.301 19.3472 103.594 18.3884 103.594C18.3884 102.395 17.3191 101.423 16 101.423C14.6809 101.423 13.6116 102.395 13.6116 103.594Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M111.743 97.3312C110.436 97.3312 109.375 98.3211 109.375 99.542C109.375 100.763 110.436 101.752 111.743 101.752H118.256C119.564 101.752 120.625 100.762 120.625 99.542C120.625 98.3217 119.564 97.3317 118.257 97.3317C118.257 95.6529 116.799 94.292 115 94.292C113.201 94.292 111.743 95.6523 111.743 97.3312Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "71",
                cy: "113.252",
                rx: "23.5",
                ry: "1",
                fill: "#B2B3B5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_4146_9395",
                        x1: "84",
                        y1: "41.7515",
                        x2: "56",
                        y2: "47.2515",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#68A439",
                                stopOpacity: "0.7"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#68A439",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_4146_9395",
                        x1: "82",
                        y1: "86.2512",
                        x2: "54.5",
                        y2: "100.251",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#68A439",
                                stopOpacity: "0.7"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#68A439",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_4146_9395",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "135",
                            height: "118.77",
                            fill: "white",
                            transform: "translate(0.5 0.251953)"
                        })
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../packages/ui/Icons/TelephoneErrorIcon.tsx


var TelephoneErrorIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 143 : _width, _height = param.height, height = _height === void 0 ? 119 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.750 */.rS.colors.neutral[750] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.primary.60 */.rS.colors.primary[60] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.primary.77 */.rS.colors.primary[77] : _fourthColor, _fifthColor = param.fifthColor, fifthColor = _fifthColor === void 0 ? themes/* theme.colors.neutral.740 */.rS.colors.neutral[740] : _fifthColor, _sixthColor = param.sixthColor, sixthColor = _sixthColor === void 0 ? themes/* theme.colors.primary.360 */.rS.colors.primary[360] : _sixthColor, _seventhColor = param.seventhColor, seventhColor = _seventhColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _seventhColor, _octaveColor = param.octaveColor, octaveColor = _octaveColor === void 0 ? themes/* theme.colors.neutral.240 */.rS.colors.neutral[240] : _octaveColor, _ninthColor = param.ninthColor, ninthColor = _ninthColor === void 0 ? themes/* theme.colors.neutral.760 */.rS.colors.neutral[760] : _ninthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 143 119",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4106_87462)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M55.9105 13.0589C60.9008 4.32363 73.496 4.32362 78.4863 13.0589L127.854 99.4741C132.805 108.141 126.547 118.923 116.566 118.923H17.8308C7.84975 118.923 1.59192 108.141 6.54296 99.4741L55.9105 13.0589Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M57.1048 36.8853H79.0254C84.8975 36.8853 89.6536 41.6414 89.6536 47.5134V95.3403C89.6536 101.212 84.8975 105.968 79.0254 105.968H57.1048C51.2327 105.968 46.4766 101.212 46.4766 95.3403V47.5134C46.4766 41.6414 51.2327 36.8853 57.1048 36.8853Z",
                fill: color,
                stroke: secondColor,
                strokeWidth: "4.63085",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.168",
                y: "53.7805",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.168",
                y: "42.5171",
                width: "33.7907",
                height: "5.63178",
                rx: "2.54473",
                fill: "url(#paint0_linear_4106_87462)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.168",
                y: "85.6941",
                width: "33.7907",
                height: "15.0181",
                rx: "7.50904",
                fill: "url(#paint1_linear_4106_87462)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.168",
                y: "66.9211",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.168",
                y: "73.4917",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "64.3105",
                y: "60.3511",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "64.3105",
                y: "80.0623",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: fourthColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M45.8287 33.342C44.9571 33.342 44.25 34.0491 44.25 34.9211C44.25 35.7932 44.9571 36.4999 45.8287 36.4999H50.1708C51.0429 36.4999 51.75 35.7928 51.75 34.9211C51.75 34.0495 51.0429 33.3424 50.1712 33.3424C50.1712 32.1432 49.1992 31.1711 48 31.1711C46.8008 31.1711 45.8287 32.1428 45.8287 33.342Z",
                    fill: ninthColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M109.951 84.5113C107.547 78.5811 110.074 71.797 115.773 68.8859C121.471 65.9747 128.45 67.9026 131.846 73.3261C135.242 78.7497 133.928 85.8693 128.821 89.7244C123.713 93.5794 116.506 92.8907 112.222 88.1381L108.237 88.1088L109.951 84.5113Z",
                fill: "#EB3E53",
                stroke: secondColor,
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.351 72.1294L125.694 73.3579C126.678 73.5841 127.292 74.5643 127.066 75.5483L124.609 86.2341C124.383 87.2181 123.402 87.8319 122.418 87.6056L117.075 86.3772C116.091 86.151 115.478 85.1707 115.704 84.1868L118.161 73.5009C118.387 72.517 119.367 71.9032 120.351 72.1294Z",
                fill: color,
                stroke: secondColor,
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121.24 72.3342L120.872 73.9371C120.804 74.2319 120.948 74.5173 121.194 74.5738L123.866 75.188C124.111 75.2445 124.366 75.0508 124.434 74.7561L124.802 73.1532",
                stroke: secondColor,
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.261 84.5358L121.256 84.9944",
                stroke: "#5C5E62",
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.4449 64.3805C35.1847 58.5977 33.0496 51.68 27.5272 48.4473C22.0047 45.2147 14.9274 46.7397 11.2265 51.9599C7.52549 57.1801 8.42888 64.3632 13.3072 68.5044C18.1855 72.6456 25.42 72.3708 29.97 67.8713L33.9503 68.0703L32.4449 64.3805Z",
                fill: "#EB3E53",
                stroke: secondColor,
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.7747 51.4235L17.3702 52.344C16.3749 52.5135 15.706 53.457 15.8755 54.4523L17.7164 65.2613C17.8859 66.2566 18.8294 66.9255 19.8247 66.7559L25.2292 65.8355C26.2245 65.666 26.8934 64.7225 26.7239 63.7272L24.883 52.9182C24.7135 51.9229 23.77 51.254 22.7747 51.4235Z",
                fill: color,
                stroke: secondColor,
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.873 51.5769L22.1492 53.1983C22.2 53.4964 22.0395 53.7731 21.7909 53.8154L19.0886 54.2756C18.84 54.318 18.597 54.11 18.5462 53.8119L18.2701 52.1905",
                stroke: secondColor,
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.1529 63.8722L21.1352 64.2159",
                stroke: "#5C5E62",
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M66.2431 13.079C64.9356 13.079 63.875 14.0689 63.875 15.2898C63.875 16.5107 64.9356 17.5 66.2431 17.5H72.7562C74.0644 17.5 75.125 16.5101 75.125 15.2898C75.125 14.0695 74.0644 13.0795 72.7569 13.0795C72.7569 11.4007 71.2987 10.0398 69.5 10.0398C67.7012 10.0398 66.2431 11.4001 66.2431 13.079Z",
                    stroke: "#8F9194",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M71.8287 25.342C70.9571 25.342 70.25 26.0491 70.25 26.9211C70.25 27.7932 70.9571 28.4999 71.8287 28.4999H76.1708C77.0429 28.4999 77.75 27.7928 77.75 26.9211C77.75 26.0495 77.0429 25.3424 76.1712 25.3424C76.1712 24.1432 75.1992 23.1711 74 23.1711C72.8008 23.1711 71.8287 24.1428 71.8287 25.342Z",
                    fill: ninthColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M58.2431 26.6446C56.9356 26.6446 55.875 27.5638 55.875 28.6975C55.875 29.8312 56.9356 30.7499 58.2431 30.7499H64.7562C66.0644 30.7499 67.125 29.8307 67.125 28.6975C67.125 27.5643 66.0644 26.6451 64.7569 26.6451C64.7569 25.0862 63.2987 23.8225 61.5 23.8225C59.7012 23.8225 58.2431 25.0857 58.2431 26.6446Z",
                    stroke: ninthColor,
                    strokeWidth: "0.62",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M29.9602 86.6446C28.7399 86.6446 27.75 87.5638 27.75 88.6975C27.75 89.8312 28.7399 90.7499 29.9602 90.7499H36.0392C37.2601 90.7499 38.25 89.8307 38.25 88.6975C38.25 87.5643 37.2601 86.6451 36.0397 86.6451C36.0397 85.0862 34.6788 83.8225 33 83.8225C31.3212 83.8225 29.9602 85.0857 29.9602 86.6446Z",
                    fill: ninthColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M97.8287 78.342C96.9571 78.342 96.25 79.0491 96.25 79.9211C96.25 80.7932 96.9571 81.4999 97.8287 81.4999H102.171C103.043 81.4999 103.75 80.7928 103.75 79.9211C103.75 79.0495 103.043 78.3424 102.171 78.3424C102.171 77.1432 101.199 76.1711 100 76.1711C98.8008 76.1711 97.8287 77.1428 97.8287 78.342Z",
                    fill: ninthColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M95.9602 62.079C94.7399 62.079 93.75 63.0689 93.75 64.2898C93.75 65.5107 94.7399 66.5 95.9602 66.5H102.039C103.26 66.5 104.25 65.5101 104.25 64.2898C104.25 63.0695 103.26 62.0795 102.04 62.0795C102.04 60.4007 100.679 59.0398 99 59.0398C97.3212 59.0398 95.9602 60.4001 95.9602 62.079Z",
                    stroke: octaveColor,
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M32.8287 109.342C31.9571 109.342 31.25 110.049 31.25 110.921C31.25 111.793 31.9571 112.5 32.8287 112.5H37.1708C38.0429 112.5 38.75 111.793 38.75 110.921C38.75 110.049 38.0429 109.342 37.1712 109.342C37.1712 108.143 36.1992 107.171 35 107.171C33.8008 107.171 32.8287 108.143 32.8287 109.342Z",
                    fill: ninthColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M104.112 106.342C103.153 106.342 102.375 107.049 102.375 107.921C102.375 108.793 103.153 109.5 104.112 109.5H108.888C109.847 109.5 110.625 108.793 110.625 107.921C110.625 107.049 109.847 106.342 108.888 106.342C108.888 105.143 107.819 104.171 106.5 104.171C105.181 104.171 104.112 105.143 104.112 106.342Z",
                    fill: ninthColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.1116 103.342C12.1528 103.342 11.375 104.049 11.375 104.921C11.375 105.793 12.1528 106.5 13.1116 106.5H17.8879C18.8472 106.5 19.625 105.793 19.625 104.921C19.625 104.049 18.8472 103.342 17.8884 103.342C17.8884 102.143 16.8191 101.171 15.5 101.171C14.1809 101.171 13.1116 102.143 13.1116 103.342Z",
                    fill: ninthColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M111.243 97.079C109.936 97.079 108.875 98.0689 108.875 99.2898C108.875 100.511 109.936 101.5 111.243 101.5H117.756C119.064 101.5 120.125 100.51 120.125 99.2898C120.125 98.0695 119.064 97.0795 117.757 97.0795C117.757 95.4007 116.299 94.0398 114.5 94.0398C112.701 94.0398 111.243 95.4001 111.243 97.079Z",
                    stroke: octaveColor,
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "70.5",
                cy: "113",
                rx: "23.5",
                ry: "1",
                fill: octaveColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_4106_87462",
                        x1: "83.5",
                        y1: "41.5",
                        x2: "55.5",
                        y2: "47",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: fifthColor,
                                stopOpacity: "0.7"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: fifthColor,
                                stopOpacity: "0.17"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_4106_87462",
                        x1: "81.5",
                        y1: "86",
                        x2: "54",
                        y2: "100",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: fifthColor,
                                stopOpacity: "0.7"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: sixthColor,
                                stopOpacity: "0.06"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_4106_87462",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "135",
                            height: "118.77",
                            fill: seventhColor
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ThreeDotsHorizontal.tsx


var ThreeDotsHorizontal = function(param) {
    var _width = param.width, width = _width === void 0 ? 37 : _width, _height = param.height, height = _height === void 0 ? 6 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.720 */.rS.colors.neutral[720] : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de tr\xeas pontos na horizontal" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 37 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.5696 3.00006C35.5696 3.72523 34.9817 4.3131 34.2566 4.3131C33.5314 4.3131 32.9435 3.72523 32.9435 3.00006C32.9435 2.27488 33.5314 1.68701 34.2566 1.68701C34.9817 1.68701 35.5696 2.27488 35.5696 3.00006",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.813 3.00006C19.813 3.72523 19.2252 4.3131 18.5 4.3131C17.7748 4.3131 17.187 3.72523 17.187 3.00006C17.187 2.27488 17.7748 1.68701 18.5 1.68701C19.2252 1.68701 19.813 2.27488 19.813 3.00006",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.05648 3.00006C4.05648 3.72523 3.46861 4.3131 2.74344 4.3131C2.01826 4.3131 1.43039 3.72523 1.43039 3.00006C1.43039 2.27488 2.01826 1.68701 2.74344 1.68701C3.46861 1.68701 4.05648 2.27488 4.05648 3.00006",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Truck.tsx


var Truck = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 4L8 2L6 4",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.00002 11.3333V2",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 12L8 14L10 12",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.00002 4.66663V14",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TruckFC.tsx


var TruckFC = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.200 */.rS.colors.primary[200] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.97617 18.5027H15.5015",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "17.0021",
                cy: "18.5027",
                r: "1.50063",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "5.47555",
                cy: "18.5027",
                r: "1.50063",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 18V13.8617L15.0013 13.3615V6.99792C15.0013 5.89289 14.1054 4.99709 13.0004 4.99709H3.99667C2.89164 4.99709 1.99583 5.89289 1.99583 6.99792V17.5023C1.99583 18.0548 2.44374 18.5027 2.99625 18.5027H3.97492",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.0013 6.99792H18.2492C19.302 6.99792 20.2422 7.65729 20.6007 8.64722L21.8846 12.1918C21.9637 12.4102 22.0042 12.6408 22.0042 12.8731V17.0021C22.0042 17.8309 21.3323 18.5027 20.5035 18.5027H18.5027",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.5 12H19H18.5H17.5881H15.0013",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 8.90532H5.27661C5.42747 8.90532 5.47778 8.95563 5.47778 9.10649V12.7531H6.55922V10.8921H8.11844V10.0119H6.55922V8.90532H8.44501V8H5V8.90532Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0559 12.7175C9.0559 11.8122 9.65949 11.3092 10.4393 11.3092C10.9674 11.3092 11.3949 11.4601 11.8476 11.7619V10.8062C11.3827 10.5071 10.8409 10.3498 10.2881 10.3535C8.87985 10.3535 7.94934 11.3343 7.94934 12.7426C7.94934 14.1509 8.93016 15.1066 10.3636 15.1066C10.9205 15.1141 11.4657 14.947 11.9228 14.6288V13.648C11.4198 13.9749 10.942 14.1258 10.439 14.1258C9.65942 14.1007 9.0559 13.5977 9.0559 12.7175Z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TwoStepVerificationIcon.tsx


var TwoStepVerificationIcon = function(param) {
    var width = param.width, height = param.height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, alt = param.alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": alt,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.752 17.002H17.2505C16.5599 17.002 16 17.5618 16 18.2525V20.7535C16 21.4442 16.5599 22.004 17.2505 22.004H20.752C21.4426 22.004 22.0025 21.4442 22.0025 20.7535V18.2525C22.0025 17.5618 21.4426 17.002 20.752 17.002Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.7534 17.0022V15.7517C20.7534 14.7848 19.9696 14.001 19.0027 14.001V14.001C18.0358 14.001 17.252 14.7848 17.252 15.7517V17.0022",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5001 10.7148L11.3761 13.8389L9.49805 11.9669",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.945 11C20.4062 6.18818 16.158 2.66443 11.3295 3.0243C6.501 3.38417 2.82203 7.49873 3.00246 12.3372C3.18288 17.1757 7.15808 21.0049 12 21.0041",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/UnavailableIcon.tsx


var UnavailableIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.200 */.rS.colors.primary[200] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.5027 16.6343L21.0038 19.1353",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0038 16.6343L18.5027 19.1353",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5002 12.0673V8.99902",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5002 15.6777C12.4574 15.6777 12.4164 15.6948 12.3863 15.7253C12.3562 15.7557 12.3396 15.797 12.3401 15.8398C12.3407 15.9283 12.4117 16.0002 12.5002 16.0018C12.5897 16.0018 12.6623 15.9293 12.6623 15.8398C12.6623 15.7503 12.5897 15.6777 12.5002 15.6777Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.5496 13.5187L15.8206 5.39727C15.1307 4.21768 13.8667 3.49268 12.5002 3.49268C11.1337 3.49268 9.86974 4.21768 9.17983 5.39727L3.47745 15.1793C2.83852 16.2785 2.8374 17.6357 3.47454 18.7359C4.11167 19.8361 5.28939 20.5107 6.56073 20.5036H15.5375",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/UniqueClientImage.tsx

var UniqueClientImage = function(param) {
    var _width = param.width, width = _width === void 0 ? 116 : _width, _height = param.height, height = _height === void 0 ? 99 : _height, _dataTestId = param.dataTestId, dataTestId = _dataTestId === void 0 ? "unique-client-banner-image" : _dataTestId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "data-testid": dataTestId,
        viewBox: "0 0 116 99",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            borderRadius: "8px 0 0 8px",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M54 0H0V54H54V0Z",
                fill: "#C1D82F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.8347 40.9088H13.8816C12.1205 40.9088 10.6875 39.4753 10.6875 37.7137V16.3152C10.6875 14.5536 12.1205 13.1201 13.8816 13.1201H29.8347C31.5957 13.1201 33.0287 14.5536 33.0287 16.3152V20.9668C33.0287 21.4561 32.6316 21.8533 32.1425 21.8533C31.6533 21.8533 31.2562 21.4561 31.2562 20.9668V16.3152C31.2562 15.5322 30.6174 14.899 29.8404 14.899H13.8873C13.1046 14.899 12.4716 15.5322 12.4716 16.3152V37.7137C12.4716 38.4966 13.1046 39.1299 13.8873 39.1299H29.8404C30.6231 39.1299 31.2562 38.4966 31.2562 37.7137V33.3096C31.2562 32.8203 31.6533 32.4231 32.1425 32.4231C32.6316 32.4231 33.0287 32.8203 33.0287 33.3096V37.7137C33.0287 39.4753 31.5957 40.9088 29.8347 40.9088Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.2401 19.4758H15.4638C14.9746 19.4758 14.5775 19.0786 14.5775 18.5892C14.5775 18.0999 14.9746 17.6969 15.4638 17.6969H28.2401C28.7293 17.6969 29.1264 18.0941 29.1264 18.5892C29.1264 19.0843 28.7293 19.4758 28.2401 19.4758Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.6719 25.0829H15.4638C14.9746 25.0829 14.5775 24.6857 14.5775 24.1964C14.5775 23.707 14.9746 23.3098 15.4638 23.3098H24.6719C25.1611 23.3098 25.5582 23.707 25.5582 24.1964C25.5582 24.6857 25.1611 25.0829 24.6719 25.0829Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.5339 30.6959H15.4697C14.9805 30.6959 14.5834 30.2987 14.5834 29.8093C14.5834 29.32 14.9805 28.9228 15.4697 28.9228H24.5339C25.0231 28.9228 25.4202 29.32 25.4202 29.8093C25.4202 30.2987 25.0231 30.6959 24.5339 30.6959Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.2401 36.3032H15.4638C14.9746 36.3032 14.5775 35.906 14.5775 35.4167C14.5775 34.9273 14.9746 34.5301 15.4638 34.5301H28.2401C28.7293 34.5301 29.1264 34.9273 29.1264 35.4167C29.1264 35.906 28.7293 36.3032 28.2401 36.3032Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.0106 40.1316C40.3948 40.1316 39.8136 39.8898 39.3819 39.458L33.4484 33.5226C32.2514 34.1041 30.9047 34.3401 29.5753 34.1962C27.9811 34.0235 26.479 33.3039 25.3453 32.1698C24.0101 30.8341 23.2734 29.0553 23.2734 27.1612C23.2734 25.2672 24.0101 23.4883 25.3453 22.1527C26.6804 20.8171 28.4588 20.0802 30.3522 20.0802C32.2456 20.0802 34.0182 20.8171 35.3591 22.1527C36.4929 23.2868 37.2123 24.7894 37.3849 26.384C37.5288 27.7139 37.2928 29.0668 36.7116 30.2585L42.6451 36.1938C43.0824 36.6314 43.3242 37.2071 43.3242 37.8288C43.3242 38.4506 43.0824 39.0263 42.6451 39.4638C42.2077 39.9013 41.6322 40.1373 41.0106 40.1373M33.5981 31.5365C33.8283 31.5365 34.0527 31.6228 34.2254 31.7956L40.6308 38.203C40.7286 38.3009 40.861 38.3585 41.0049 38.3585C41.1487 38.3585 41.2811 38.3009 41.3789 38.203C41.4768 38.1051 41.5343 37.9727 41.5343 37.8288C41.5343 37.6849 41.4768 37.5525 41.3789 37.4546L34.9735 31.0472C34.68 30.7535 34.6282 30.2987 34.8469 29.9476C35.4685 28.9459 35.739 27.7484 35.6066 26.574C35.4742 25.3651 34.9505 24.2712 34.0872 23.4077C33.0859 22.406 31.7564 21.8533 30.3407 21.8533C28.9249 21.8533 27.5898 22.406 26.5884 23.4077C25.587 24.4094 25.0345 25.7393 25.0345 27.1555C25.0345 28.5717 25.587 29.9073 26.5884 30.909C27.4516 31.7725 28.5451 32.2964 29.7537 32.4288C30.9277 32.5555 32.1248 32.2849 33.1261 31.6631C33.27 31.5768 33.4312 31.5307 33.5923 31.5307L33.5981 31.5365Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M92 60H54V98H92V60Z",
                fill: "#7AC143"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.3484 80.4828C80.1864 80.4828 80.0284 80.4221 79.9069 80.3005C78.0642 78.4572 75.61 77.4404 73.0019 77.4404C70.3938 77.4404 67.9396 78.4572 66.0969 80.3005C65.8539 80.5436 65.457 80.5436 65.214 80.3005C64.971 80.0575 64.971 79.6604 65.214 79.4174C67.2956 77.3351 70.0617 76.1886 73.0019 76.1886C75.9421 76.1886 78.7122 77.3351 80.7939 79.4174C81.0369 79.6604 81.0369 80.0575 80.7939 80.3005C80.6724 80.4221 80.5104 80.4828 80.3524 80.4828",
                fill: "#DEF0D0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.2597 83.2457C69.0977 83.2457 68.9397 83.1849 68.8182 83.0634C68.5752 82.8203 68.5752 82.4233 68.8182 82.1803C71.1267 79.8711 74.8809 79.8711 77.1893 82.1803C77.4323 82.4233 77.4323 82.8203 77.1893 83.0634C76.9463 83.3065 76.5494 83.3065 76.3065 83.0634C74.4881 81.2444 71.5276 81.2444 69.7052 83.0634C69.5837 83.1849 69.4217 83.2457 69.2637 83.2457",
                fill: "#DEF0D0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.0378 77.2337C83.8758 77.2337 83.7178 77.173 83.5963 77.0514C80.7655 74.2197 77.0031 72.664 73.0059 72.664C69.0087 72.664 65.2423 74.2237 62.4114 77.0514C62.1684 77.2945 61.7716 77.2945 61.5286 77.0514C61.2856 76.8084 61.2856 76.4113 61.5286 76.1683C64.5943 73.1015 68.6685 71.4122 73.0059 71.4122C77.3433 71.4122 81.4175 73.1015 84.4833 76.1683C84.7263 76.4113 84.7263 76.8084 84.4833 77.0514C84.3618 77.173 84.1998 77.2337 84.0418 77.2337",
                fill: "#DEF0D0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M74.1035 85.486C74.1035 86.0936 73.6094 86.5879 73.002 86.5879C72.3945 86.5879 71.9004 86.0936 71.9004 85.486C71.9004 84.8783 72.3945 84.384 73.002 84.384C73.6094 84.384 74.1035 84.8783 74.1035 85.486Z",
                fill: "#DEF0D0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M115.29 0H54.6111V60H115.29V0Z",
                fill: "#AA0E27"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.278 48.2434H67.7136C66.8343 48.2434 66.1213 47.5384 66.1213 46.6689V25.2837C66.1213 24.6178 66.6679 24.0773 67.3413 24.0773H79.9136C80.587 24.0773 81.1336 24.6178 81.1336 25.2837V46.1597C81.3633 46.379 81.5059 46.6846 81.5059 47.0292C81.5059 47.6951 80.9593 48.2434 80.2859 48.2434M68.5692 45.8229H78.6936V26.4979H68.5692V45.8229Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M100.772 48.2434H88.2078C87.5344 48.2434 86.9878 47.7029 86.9878 47.0292C86.9878 46.6924 87.1304 46.3869 87.3601 46.1597V25.2837C87.3601 24.6178 87.9067 24.0773 88.5801 24.0773H101.145C101.818 24.0773 102.365 24.6178 102.365 25.2837V46.6689C102.365 47.5384 101.652 48.2434 100.772 48.2434ZM89.8001 45.8229H99.9245V26.4979H89.8001V45.8229Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M103.181 26.4978H88.5724C87.8991 26.4978 87.3524 25.9573 87.3524 25.2914V17.5912C87.1227 17.3718 86.9801 17.0663 86.9801 16.7217C86.9801 16.0558 87.5267 15.5153 88.2001 15.5153H103.181C104.06 15.5153 104.773 16.2203 104.773 17.0898V24.9232C104.773 25.7928 104.06 26.4978 103.181 26.4978ZM89.8004 24.0772H102.333V17.928H89.8004V24.0772Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M79.9136 26.4978H65.3053C64.4259 26.4978 63.713 25.7928 63.713 24.9232V17.0898C63.713 16.2203 64.4259 15.5153 65.3053 15.5153H80.2859C80.9593 15.5153 81.5059 16.0558 81.5059 16.7217C81.5059 17.0585 81.3633 17.3718 81.1336 17.5912V25.2914C81.1336 25.9573 80.5869 26.4978 79.9136 26.4978ZM66.1609 24.0772H78.6936V17.928H66.1609V24.0772Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.643 17.9279H75.1049C72.2133 17.9279 69.3693 15.335 69.3614 12.6952C69.3614 11.6925 69.6307 9.89863 71.4211 9.23279C73.164 8.58261 75.8496 9.29545 79.4145 11.3556C82.211 12.9693 84.6668 14.912 85.562 15.9225C85.8789 16.2829 85.9502 16.7842 85.7521 17.2229C85.5541 17.6537 85.1184 17.9357 84.6351 17.9357M72.8313 11.4261C72.6015 11.4261 72.4193 11.4575 72.2767 11.5045C72.15 11.5515 71.8014 11.6846 71.8014 12.703C71.8014 14.019 73.5601 15.5152 75.097 15.5152H81.3316C80.4364 14.8572 79.3511 14.1365 78.1786 13.455C75.5723 11.951 73.8057 11.4261 72.8313 11.4261Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M93.3731 17.928H83.835C83.3597 17.928 82.9239 17.6539 82.718 17.2152C82.5199 16.7844 82.5912 16.2752 82.9081 15.9149C83.7954 14.9044 86.2591 12.9617 89.0556 11.3558C92.6205 9.30346 95.3061 8.58279 97.049 9.23296C98.8394 9.8988 99.1087 11.6848 99.1087 12.6953C99.1087 15.3352 96.2647 17.928 93.3652 17.928M87.1306 15.5075H93.3652C94.9021 15.5075 96.6608 14.0113 96.6608 12.6953C96.6608 11.677 96.3202 11.5517 96.1855 11.5047C95.4408 11.2305 93.4999 11.5987 90.2835 13.4552C89.1032 14.1367 88.0258 14.8573 87.1306 15.5154V15.5075Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M88.1683 48.2435H80.3175C79.4223 48.2435 78.6855 47.5228 78.6855 46.6298V17.1213C78.6855 16.2283 79.4144 15.5077 80.3175 15.5077H88.1683C89.0634 15.5077 89.8002 16.2283 89.8002 17.1213V46.6298C89.8002 47.515 89.0714 48.2435 88.1683 48.2435ZM81.1335 45.823H87.3523V17.9282H81.1335V45.823Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.11461 57.3938C3.71769 57.3938 4.20658 56.8579 4.20658 56.1969C4.20658 55.5359 3.71769 55 3.11461 55C2.51154 55 2.02264 55.5359 2.02264 56.1969C2.02264 56.8579 2.51154 57.3938 3.11461 57.3938Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.52819 57.3938C8.13127 57.3938 8.62016 56.8579 8.62016 56.1969C8.62016 55.5358 8.13127 54.9999 7.52819 54.9999C6.92511 54.9999 6.43622 55.5358 6.43622 56.1969C6.43622 56.8579 6.92511 57.3938 7.52819 57.3938Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9413 57.3938C12.5444 57.3938 13.0332 56.8579 13.0332 56.1969C13.0332 55.5358 12.5444 54.9999 11.9413 54.9999C11.3382 54.9999 10.8493 55.5358 10.8493 56.1969C10.8493 56.8579 11.3382 57.3938 11.9413 57.3938Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3548 57.3938C16.9579 57.3938 17.4468 56.8579 17.4468 56.1969C17.4468 55.5358 16.9579 54.9999 16.3548 54.9999C15.7518 54.9999 15.2629 55.5358 15.2629 56.1969C15.2629 56.8579 15.7518 57.3938 16.3548 57.3938Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.7625 57.3938C21.3656 57.3938 21.8545 56.8579 21.8545 56.1969C21.8545 55.5358 21.3656 54.9999 20.7625 54.9999C20.1594 54.9999 19.6705 55.5358 19.6705 56.1969C19.6705 56.8579 20.1594 57.3938 20.7625 57.3938Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.1761 57.3938C25.7792 57.3938 26.268 56.8579 26.268 56.1969C26.268 55.5358 25.7792 54.9999 25.1761 54.9999C24.573 54.9999 24.0841 55.5358 24.0841 56.1969C24.0841 56.8579 24.573 57.3938 25.1761 57.3938Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.5891 57.3938C30.1922 57.3938 30.6811 56.8579 30.6811 56.1969C30.6811 55.5358 30.1922 54.9999 29.5891 54.9999C28.986 54.9999 28.4971 55.5358 28.4971 56.1969C28.4971 56.8579 28.986 57.3938 29.5891 57.3938Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0027 57.3938C34.6058 57.3938 35.0947 56.8579 35.0947 56.1969C35.0947 55.5358 34.6058 54.9999 34.0027 54.9999C33.3997 54.9999 32.9108 55.5358 32.9108 56.1969C32.9108 56.8579 33.3997 57.3938 34.0027 57.3938Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.416 57.3938C39.0191 57.3938 39.508 56.8579 39.508 56.1969C39.508 55.5358 39.0191 54.9999 38.416 54.9999C37.8129 54.9999 37.324 55.5358 37.324 56.1969C37.324 56.8579 37.8129 57.3938 38.416 57.3938Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.8294 57.3938C43.4325 57.3938 43.9214 56.8579 43.9214 56.1969C43.9214 55.5358 43.4325 54.9999 42.8294 54.9999C42.2263 54.9999 41.7374 55.5358 41.7374 56.1969C41.7374 56.8579 42.2263 57.3938 42.8294 57.3938Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.2427 57.3938C47.8458 57.3938 48.3347 56.8579 48.3347 56.1969C48.3347 55.5358 47.8458 54.9999 47.2427 54.9999C46.6397 54.9999 46.1508 55.5358 46.1508 56.1969C46.1508 56.8579 46.6397 57.3938 47.2427 57.3938Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.656 57.3938C52.2591 57.3938 52.748 56.8579 52.748 56.1969C52.748 55.5358 52.2591 54.9999 51.656 54.9999C51.0529 54.9999 50.564 55.5358 50.564 56.1969C50.564 56.8579 51.0529 57.3938 51.656 57.3938Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.11461 62.0258C3.71769 62.0258 4.20658 61.4899 4.20658 60.8289C4.20658 60.1678 3.71769 59.632 3.11461 59.632C2.51154 59.632 2.02264 60.1678 2.02264 60.8289C2.02264 61.4899 2.51154 62.0258 3.11461 62.0258Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.52819 62.0258C8.13127 62.0258 8.62016 61.49 8.62016 60.8289C8.62016 60.1679 8.13127 59.632 7.52819 59.632C6.92511 59.632 6.43622 60.1679 6.43622 60.8289C6.43622 61.49 6.92511 62.0258 7.52819 62.0258Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9413 62.0258C12.5444 62.0258 13.0332 61.49 13.0332 60.8289C13.0332 60.1679 12.5444 59.632 11.9413 59.632C11.3382 59.632 10.8493 60.1679 10.8493 60.8289C10.8493 61.49 11.3382 62.0258 11.9413 62.0258Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3548 62.0258C16.9579 62.0258 17.4468 61.49 17.4468 60.8289C17.4468 60.1679 16.9579 59.632 16.3548 59.632C15.7518 59.632 15.2629 60.1679 15.2629 60.8289C15.2629 61.49 15.7518 62.0258 16.3548 62.0258Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.7625 62.0258C21.3656 62.0258 21.8545 61.49 21.8545 60.8289C21.8545 60.1679 21.3656 59.632 20.7625 59.632C20.1594 59.632 19.6705 60.1679 19.6705 60.8289C19.6705 61.49 20.1594 62.0258 20.7625 62.0258Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.1761 62.0258C25.7792 62.0258 26.268 61.49 26.268 60.8289C26.268 60.1679 25.7792 59.632 25.1761 59.632C24.573 59.632 24.0841 60.1679 24.0841 60.8289C24.0841 61.49 24.573 62.0258 25.1761 62.0258Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.5891 62.0258C30.1922 62.0258 30.6811 61.49 30.6811 60.8289C30.6811 60.1679 30.1922 59.632 29.5891 59.632C28.986 59.632 28.4971 60.1679 28.4971 60.8289C28.4971 61.49 28.986 62.0258 29.5891 62.0258Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0025 62.0258C34.6056 62.0258 35.0945 61.49 35.0945 60.8289C35.0945 60.1679 34.6056 59.632 34.0025 59.632C33.3994 59.632 32.9105 60.1679 32.9105 60.8289C32.9105 61.49 33.3994 62.0258 34.0025 62.0258Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.416 62.0258C39.0191 62.0258 39.508 61.49 39.508 60.8289C39.508 60.1679 39.0191 59.632 38.416 59.632C37.8129 59.632 37.324 60.1679 37.324 60.8289C37.324 61.49 37.8129 62.0258 38.416 62.0258Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.8294 62.0258C43.4325 62.0258 43.9214 61.49 43.9214 60.8289C43.9214 60.1679 43.4325 59.632 42.8294 59.632C42.2263 59.632 41.7374 60.1679 41.7374 60.8289C41.7374 61.49 42.2263 62.0258 42.8294 62.0258Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.2427 62.0258C47.8458 62.0258 48.3347 61.49 48.3347 60.8289C48.3347 60.1679 47.8458 59.632 47.2427 59.632C46.6397 59.632 46.1508 60.1679 46.1508 60.8289C46.1508 61.49 46.6397 62.0258 47.2427 62.0258Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.656 62.0258C52.2591 62.0258 52.748 61.49 52.748 60.8289C52.748 60.1679 52.2591 59.632 51.656 59.632C51.0529 59.632 50.564 60.1679 50.564 60.8289C50.564 61.49 51.0529 62.0258 51.656 62.0258Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.11461 66.6579C3.71769 66.6579 4.20658 66.122 4.20658 65.461C4.20658 64.7999 3.71769 64.2641 3.11461 64.2641C2.51154 64.2641 2.02264 64.7999 2.02264 65.461C2.02264 66.122 2.51154 66.6579 3.11461 66.6579Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.52819 66.6579C8.13127 66.6579 8.62016 66.122 8.62016 65.461C8.62016 64.7999 8.13127 64.264 7.52819 64.264C6.92511 64.264 6.43622 64.7999 6.43622 65.461C6.43622 66.122 6.92511 66.6579 7.52819 66.6579Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9413 66.6579C12.5444 66.6579 13.0332 66.122 13.0332 65.461C13.0332 64.7999 12.5444 64.264 11.9413 64.264C11.3382 64.264 10.8493 64.7999 10.8493 65.461C10.8493 66.122 11.3382 66.6579 11.9413 66.6579Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3548 66.6579C16.9579 66.6579 17.4468 66.122 17.4468 65.461C17.4468 64.7999 16.9579 64.264 16.3548 64.264C15.7518 64.264 15.2629 64.7999 15.2629 65.461C15.2629 66.122 15.7518 66.6579 16.3548 66.6579Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.7625 66.6579C21.3656 66.6579 21.8545 66.122 21.8545 65.461C21.8545 64.7999 21.3656 64.264 20.7625 64.264C20.1594 64.264 19.6705 64.7999 19.6705 65.461C19.6705 66.122 20.1594 66.6579 20.7625 66.6579Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.1761 66.6579C25.7792 66.6579 26.268 66.122 26.268 65.461C26.268 64.7999 25.7792 64.264 25.1761 64.264C24.573 64.264 24.0841 64.7999 24.0841 65.461C24.0841 66.122 24.573 66.6579 25.1761 66.6579Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.5891 66.6579C30.1922 66.6579 30.6811 66.122 30.6811 65.461C30.6811 64.7999 30.1922 64.264 29.5891 64.264C28.986 64.264 28.4971 64.7999 28.4971 65.461C28.4971 66.122 28.986 66.6579 29.5891 66.6579Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0025 66.6579C34.6056 66.6579 35.0945 66.122 35.0945 65.461C35.0945 64.7999 34.6056 64.264 34.0025 64.264C33.3994 64.264 32.9105 64.7999 32.9105 65.461C32.9105 66.122 33.3994 66.6579 34.0025 66.6579Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.416 66.6579C39.0191 66.6579 39.508 66.122 39.508 65.461C39.508 64.7999 39.0191 64.264 38.416 64.264C37.8129 64.264 37.324 64.7999 37.324 65.461C37.324 66.122 37.8129 66.6579 38.416 66.6579Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.8294 66.6579C43.4325 66.6579 43.9214 66.122 43.9214 65.461C43.9214 64.7999 43.4325 64.264 42.8294 64.264C42.2263 64.264 41.7374 64.7999 41.7374 65.461C41.7374 66.122 42.2263 66.6579 42.8294 66.6579Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.2427 66.6579C47.8458 66.6579 48.3347 66.122 48.3347 65.461C48.3347 64.7999 47.8458 64.264 47.2427 64.264C46.6397 64.264 46.1508 64.7999 46.1508 65.461C46.1508 66.122 46.6397 66.6579 47.2427 66.6579Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.656 66.6579C52.2591 66.6579 52.748 66.122 52.748 65.461C52.748 64.7999 52.2591 64.264 51.656 64.264C51.0529 64.264 50.564 64.7999 50.564 65.461C50.564 66.122 51.0529 66.6579 51.656 66.6579Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.11461 71.2891C3.71769 71.2891 4.20658 70.7532 4.20658 70.0922C4.20658 69.4312 3.71769 68.8953 3.11461 68.8953C2.51154 68.8953 2.02264 69.4312 2.02264 70.0922C2.02264 70.7532 2.51154 71.2891 3.11461 71.2891Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.52819 71.2891C8.13127 71.2891 8.62016 70.7532 8.62016 70.0922C8.62016 69.4311 8.13127 68.8953 7.52819 68.8953C6.92511 68.8953 6.43622 69.4311 6.43622 70.0922C6.43622 70.7532 6.92511 71.2891 7.52819 71.2891Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9413 71.2891C12.5444 71.2891 13.0332 70.7532 13.0332 70.0922C13.0332 69.4311 12.5444 68.8953 11.9413 68.8953C11.3382 68.8953 10.8493 69.4311 10.8493 70.0922C10.8493 70.7532 11.3382 71.2891 11.9413 71.2891Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3548 71.2891C16.9579 71.2891 17.4468 70.7532 17.4468 70.0922C17.4468 69.4311 16.9579 68.8953 16.3548 68.8953C15.7518 68.8953 15.2629 69.4311 15.2629 70.0922C15.2629 70.7532 15.7518 71.2891 16.3548 71.2891Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.7625 71.2891C21.3656 71.2891 21.8545 70.7532 21.8545 70.0922C21.8545 69.4311 21.3656 68.8953 20.7625 68.8953C20.1594 68.8953 19.6705 69.4311 19.6705 70.0922C19.6705 70.7532 20.1594 71.2891 20.7625 71.2891Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.1761 71.2891C25.7792 71.2891 26.268 70.7532 26.268 70.0922C26.268 69.4311 25.7792 68.8953 25.1761 68.8953C24.573 68.8953 24.0841 69.4311 24.0841 70.0922C24.0841 70.7532 24.573 71.2891 25.1761 71.2891Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.5891 71.2891C30.1922 71.2891 30.6811 70.7532 30.6811 70.0922C30.6811 69.4311 30.1922 68.8953 29.5891 68.8953C28.986 68.8953 28.4971 69.4311 28.4971 70.0922C28.4971 70.7532 28.986 71.2891 29.5891 71.2891Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0025 71.2891C34.6056 71.2891 35.0945 70.7532 35.0945 70.0922C35.0945 69.4311 34.6056 68.8953 34.0025 68.8953C33.3994 68.8953 32.9105 69.4311 32.9105 70.0922C32.9105 70.7532 33.3994 71.2891 34.0025 71.2891Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.416 71.2891C39.0191 71.2891 39.508 70.7532 39.508 70.0922C39.508 69.4311 39.0191 68.8953 38.416 68.8953C37.8129 68.8953 37.324 69.4311 37.324 70.0922C37.324 70.7532 37.8129 71.2891 38.416 71.2891Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.8294 71.2891C43.4325 71.2891 43.9214 70.7532 43.9214 70.0922C43.9214 69.4311 43.4325 68.8953 42.8294 68.8953C42.2263 68.8953 41.7374 69.4311 41.7374 70.0922C41.7374 70.7532 42.2263 71.2891 42.8294 71.2891Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.2427 71.2891C47.8458 71.2891 48.3347 70.7532 48.3347 70.0922C48.3347 69.4311 47.8458 68.8953 47.2427 68.8953C46.6397 68.8953 46.1508 69.4311 46.1508 70.0922C46.1508 70.7532 46.6397 71.2891 47.2427 71.2891Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.656 71.2891C52.2591 71.2891 52.748 70.7532 52.748 70.0922C52.748 69.4311 52.2591 68.8953 51.656 68.8953C51.0529 68.8953 50.564 69.4311 50.564 70.0922C50.564 70.7532 51.0529 71.2891 51.656 71.2891Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.11461 75.9212C3.71769 75.9212 4.20658 75.3854 4.20658 74.7243C4.20658 74.0633 3.71769 73.5274 3.11461 73.5274C2.51154 73.5274 2.02264 74.0633 2.02264 74.7243C2.02264 75.3854 2.51154 75.9212 3.11461 75.9212Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.52819 75.9212C8.13127 75.9212 8.62016 75.3854 8.62016 74.7243C8.62016 74.0633 8.13127 73.5274 7.52819 73.5274C6.92511 73.5274 6.43622 74.0633 6.43622 74.7243C6.43622 75.3854 6.92511 75.9212 7.52819 75.9212Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9413 75.9212C12.5444 75.9212 13.0332 75.3854 13.0332 74.7243C13.0332 74.0633 12.5444 73.5274 11.9413 73.5274C11.3382 73.5274 10.8493 74.0633 10.8493 74.7243C10.8493 75.3854 11.3382 75.9212 11.9413 75.9212Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3548 75.9212C16.9579 75.9212 17.4468 75.3854 17.4468 74.7243C17.4468 74.0633 16.9579 73.5274 16.3548 73.5274C15.7518 73.5274 15.2629 74.0633 15.2629 74.7243C15.2629 75.3854 15.7518 75.9212 16.3548 75.9212Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.7625 75.9212C21.3656 75.9212 21.8545 75.3854 21.8545 74.7243C21.8545 74.0633 21.3656 73.5274 20.7625 73.5274C20.1594 73.5274 19.6705 74.0633 19.6705 74.7243C19.6705 75.3854 20.1594 75.9212 20.7625 75.9212Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.1761 75.9212C25.7792 75.9212 26.268 75.3854 26.268 74.7243C26.268 74.0633 25.7792 73.5274 25.1761 73.5274C24.573 73.5274 24.0841 74.0633 24.0841 74.7243C24.0841 75.3854 24.573 75.9212 25.1761 75.9212Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.5891 75.9212C30.1922 75.9212 30.6811 75.3854 30.6811 74.7243C30.6811 74.0633 30.1922 73.5274 29.5891 73.5274C28.986 73.5274 28.4971 74.0633 28.4971 74.7243C28.4971 75.3854 28.986 75.9212 29.5891 75.9212Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0025 75.9212C34.6056 75.9212 35.0945 75.3854 35.0945 74.7243C35.0945 74.0633 34.6056 73.5274 34.0025 73.5274C33.3994 73.5274 32.9105 74.0633 32.9105 74.7243C32.9105 75.3854 33.3994 75.9212 34.0025 75.9212Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.416 75.9212C39.0191 75.9212 39.508 75.3854 39.508 74.7243C39.508 74.0633 39.0191 73.5274 38.416 73.5274C37.8129 73.5274 37.324 74.0633 37.324 74.7243C37.324 75.3854 37.8129 75.9212 38.416 75.9212Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.8294 75.9212C43.4325 75.9212 43.9214 75.3854 43.9214 74.7243C43.9214 74.0633 43.4325 73.5274 42.8294 73.5274C42.2263 73.5274 41.7374 74.0633 41.7374 74.7243C41.7374 75.3854 42.2263 75.9212 42.8294 75.9212Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.2427 75.9212C47.8458 75.9212 48.3347 75.3854 48.3347 74.7243C48.3347 74.0633 47.8458 73.5274 47.2427 73.5274C46.6397 73.5274 46.1508 74.0633 46.1508 74.7243C46.1508 75.3854 46.6397 75.9212 47.2427 75.9212Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.656 75.9212C52.2591 75.9212 52.748 75.3854 52.748 74.7243C52.748 74.0633 52.2591 73.5274 51.656 73.5274C51.0529 73.5274 50.564 74.0633 50.564 74.7243C50.564 75.3854 51.0529 75.9212 51.656 75.9212Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.11461 80.5525C3.71769 80.5525 4.20658 80.0166 4.20658 79.3555C4.20658 78.6945 3.71769 78.1586 3.11461 78.1586C2.51154 78.1586 2.02264 78.6945 2.02264 79.3555C2.02264 80.0166 2.51154 80.5525 3.11461 80.5525Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.52819 80.5525C8.13127 80.5525 8.62016 80.0166 8.62016 79.3555C8.62016 78.6945 8.13127 78.1586 7.52819 78.1586C6.92511 78.1586 6.43622 78.6945 6.43622 79.3555C6.43622 80.0166 6.92511 80.5525 7.52819 80.5525Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9413 80.5525C12.5444 80.5525 13.0332 80.0166 13.0332 79.3555C13.0332 78.6945 12.5444 78.1586 11.9413 78.1586C11.3382 78.1586 10.8493 78.6945 10.8493 79.3555C10.8493 80.0166 11.3382 80.5525 11.9413 80.5525Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3548 80.5525C16.9579 80.5525 17.4468 80.0166 17.4468 79.3555C17.4468 78.6945 16.9579 78.1586 16.3548 78.1586C15.7518 78.1586 15.2629 78.6945 15.2629 79.3555C15.2629 80.0166 15.7518 80.5525 16.3548 80.5525Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.7625 80.5525C21.3656 80.5525 21.8545 80.0166 21.8545 79.3555C21.8545 78.6945 21.3656 78.1586 20.7625 78.1586C20.1594 78.1586 19.6705 78.6945 19.6705 79.3555C19.6705 80.0166 20.1594 80.5525 20.7625 80.5525Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.1761 80.5525C25.7792 80.5525 26.268 80.0166 26.268 79.3555C26.268 78.6945 25.7792 78.1586 25.1761 78.1586C24.573 78.1586 24.0841 78.6945 24.0841 79.3555C24.0841 80.0166 24.573 80.5525 25.1761 80.5525Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.5891 80.5525C30.1922 80.5525 30.6811 80.0166 30.6811 79.3555C30.6811 78.6945 30.1922 78.1586 29.5891 78.1586C28.986 78.1586 28.4971 78.6945 28.4971 79.3555C28.4971 80.0166 28.986 80.5525 29.5891 80.5525Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0025 80.5525C34.6056 80.5525 35.0945 80.0166 35.0945 79.3555C35.0945 78.6945 34.6056 78.1586 34.0025 78.1586C33.3994 78.1586 32.9105 78.6945 32.9105 79.3555C32.9105 80.0166 33.3994 80.5525 34.0025 80.5525Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.416 80.5525C39.0191 80.5525 39.508 80.0166 39.508 79.3555C39.508 78.6945 39.0191 78.1586 38.416 78.1586C37.8129 78.1586 37.324 78.6945 37.324 79.3555C37.324 80.0166 37.8129 80.5525 38.416 80.5525Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.8294 80.5525C43.4325 80.5525 43.9214 80.0166 43.9214 79.3555C43.9214 78.6945 43.4325 78.1586 42.8294 78.1586C42.2263 78.1586 41.7374 78.6945 41.7374 79.3555C41.7374 80.0166 42.2263 80.5525 42.8294 80.5525Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.2427 80.5525C47.8458 80.5525 48.3347 80.0166 48.3347 79.3555C48.3347 78.6945 47.8458 78.1586 47.2427 78.1586C46.6397 78.1586 46.1508 78.6945 46.1508 79.3555C46.1508 80.0166 46.6397 80.5525 47.2427 80.5525Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.656 80.5525C52.2591 80.5525 52.748 80.0166 52.748 79.3555C52.748 78.6945 52.2591 78.1586 51.656 78.1586C51.0529 78.1586 50.564 78.6945 50.564 79.3555C50.564 80.0166 51.0529 80.5525 51.656 80.5525Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.11461 85.1842C3.71769 85.1842 4.20658 84.6483 4.20658 83.9873C4.20658 83.3263 3.71769 82.7904 3.11461 82.7904C2.51154 82.7904 2.02264 83.3263 2.02264 83.9873C2.02264 84.6483 2.51154 85.1842 3.11461 85.1842Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.52819 85.1843C8.13127 85.1843 8.62016 84.6484 8.62016 83.9874C8.62016 83.3263 8.13127 82.7904 7.52819 82.7904C6.92511 82.7904 6.43622 83.3263 6.43622 83.9874C6.43622 84.6484 6.92511 85.1843 7.52819 85.1843Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9413 85.1843C12.5444 85.1843 13.0332 84.6484 13.0332 83.9874C13.0332 83.3263 12.5444 82.7904 11.9413 82.7904C11.3382 82.7904 10.8493 83.3263 10.8493 83.9874C10.8493 84.6484 11.3382 85.1843 11.9413 85.1843Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3548 85.1843C16.9579 85.1843 17.4468 84.6484 17.4468 83.9874C17.4468 83.3263 16.9579 82.7904 16.3548 82.7904C15.7518 82.7904 15.2629 83.3263 15.2629 83.9874C15.2629 84.6484 15.7518 85.1843 16.3548 85.1843Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.7625 85.1843C21.3656 85.1843 21.8545 84.6484 21.8545 83.9874C21.8545 83.3263 21.3656 82.7904 20.7625 82.7904C20.1594 82.7904 19.6705 83.3263 19.6705 83.9874C19.6705 84.6484 20.1594 85.1843 20.7625 85.1843Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.1761 85.1843C25.7792 85.1843 26.268 84.6484 26.268 83.9874C26.268 83.3263 25.7792 82.7904 25.1761 82.7904C24.573 82.7904 24.0841 83.3263 24.0841 83.9874C24.0841 84.6484 24.573 85.1843 25.1761 85.1843Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.5891 85.1843C30.1922 85.1843 30.6811 84.6484 30.6811 83.9874C30.6811 83.3263 30.1922 82.7904 29.5891 82.7904C28.986 82.7904 28.4971 83.3263 28.4971 83.9874C28.4971 84.6484 28.986 85.1843 29.5891 85.1843Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0025 85.1843C34.6056 85.1843 35.0945 84.6484 35.0945 83.9874C35.0945 83.3263 34.6056 82.7904 34.0025 82.7904C33.3994 82.7904 32.9105 83.3263 32.9105 83.9874C32.9105 84.6484 33.3994 85.1843 34.0025 85.1843Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.416 85.1843C39.0191 85.1843 39.508 84.6484 39.508 83.9874C39.508 83.3263 39.0191 82.7904 38.416 82.7904C37.8129 82.7904 37.324 83.3263 37.324 83.9874C37.324 84.6484 37.8129 85.1843 38.416 85.1843Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.8294 85.1843C43.4325 85.1843 43.9214 84.6484 43.9214 83.9874C43.9214 83.3263 43.4325 82.7904 42.8294 82.7904C42.2263 82.7904 41.7374 83.3263 41.7374 83.9874C41.7374 84.6484 42.2263 85.1843 42.8294 85.1843Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.2427 85.1843C47.8458 85.1843 48.3347 84.6484 48.3347 83.9874C48.3347 83.3263 47.8458 82.7904 47.2427 82.7904C46.6397 82.7904 46.1508 83.3263 46.1508 83.9874C46.1508 84.6484 46.6397 85.1843 47.2427 85.1843Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.656 85.1843C52.2591 85.1843 52.748 84.6484 52.748 83.9874C52.748 83.3263 52.2591 82.7904 51.656 82.7904C51.0529 82.7904 50.564 83.3263 50.564 83.9874C50.564 84.6484 51.0529 85.1843 51.656 85.1843Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.11461 89.8163C3.71769 89.8163 4.20658 89.2805 4.20658 88.6194C4.20658 87.9584 3.71769 87.4225 3.11461 87.4225C2.51154 87.4225 2.02264 87.9584 2.02264 88.6194C2.02264 89.2805 2.51154 89.8163 3.11461 89.8163Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.52819 89.8163C8.13127 89.8163 8.62016 89.2804 8.62016 88.6194C8.62016 87.9584 8.13127 87.4225 7.52819 87.4225C6.92511 87.4225 6.43622 87.9584 6.43622 88.6194C6.43622 89.2804 6.92511 89.8163 7.52819 89.8163Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9413 89.8163C12.5444 89.8163 13.0332 89.2804 13.0332 88.6194C13.0332 87.9584 12.5444 87.4225 11.9413 87.4225C11.3382 87.4225 10.8493 87.9584 10.8493 88.6194C10.8493 89.2804 11.3382 89.8163 11.9413 89.8163Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3548 89.8163C16.9579 89.8163 17.4468 89.2804 17.4468 88.6194C17.4468 87.9584 16.9579 87.4225 16.3548 87.4225C15.7518 87.4225 15.2629 87.9584 15.2629 88.6194C15.2629 89.2804 15.7518 89.8163 16.3548 89.8163Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.7625 89.8163C21.3656 89.8163 21.8545 89.2804 21.8545 88.6194C21.8545 87.9584 21.3656 87.4225 20.7625 87.4225C20.1594 87.4225 19.6705 87.9584 19.6705 88.6194C19.6705 89.2804 20.1594 89.8163 20.7625 89.8163Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.1761 89.8163C25.7792 89.8163 26.268 89.2804 26.268 88.6194C26.268 87.9584 25.7792 87.4225 25.1761 87.4225C24.573 87.4225 24.0841 87.9584 24.0841 88.6194C24.0841 89.2804 24.573 89.8163 25.1761 89.8163Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.5891 89.8163C30.1922 89.8163 30.6811 89.2804 30.6811 88.6194C30.6811 87.9584 30.1922 87.4225 29.5891 87.4225C28.986 87.4225 28.4971 87.9584 28.4971 88.6194C28.4971 89.2804 28.986 89.8163 29.5891 89.8163Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0025 89.8163C34.6056 89.8163 35.0945 89.2804 35.0945 88.6194C35.0945 87.9584 34.6056 87.4225 34.0025 87.4225C33.3994 87.4225 32.9105 87.9584 32.9105 88.6194C32.9105 89.2804 33.3994 89.8163 34.0025 89.8163Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.416 89.8163C39.0191 89.8163 39.508 89.2804 39.508 88.6194C39.508 87.9584 39.0191 87.4225 38.416 87.4225C37.8129 87.4225 37.324 87.9584 37.324 88.6194C37.324 89.2804 37.8129 89.8163 38.416 89.8163Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.8294 89.8163C43.4325 89.8163 43.9214 89.2804 43.9214 88.6194C43.9214 87.9584 43.4325 87.4225 42.8294 87.4225C42.2263 87.4225 41.7374 87.9584 41.7374 88.6194C41.7374 89.2804 42.2263 89.8163 42.8294 89.8163Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.2427 89.8163C47.8458 89.8163 48.3347 89.2804 48.3347 88.6194C48.3347 87.9584 47.8458 87.4225 47.2427 87.4225C46.6397 87.4225 46.1508 87.9584 46.1508 88.6194C46.1508 89.2804 46.6397 89.8163 47.2427 89.8163Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.656 89.8163C52.2591 89.8163 52.748 89.2804 52.748 88.6194C52.748 87.9584 52.2591 87.4225 51.656 87.4225C51.0529 87.4225 50.564 87.9584 50.564 88.6194C50.564 89.2804 51.0529 89.8163 51.656 89.8163Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.11461 94.4483C3.71769 94.4483 4.20658 93.9124 4.20658 93.2514C4.20658 92.5903 3.71769 92.0545 3.11461 92.0545C2.51154 92.0545 2.02264 92.5903 2.02264 93.2514C2.02264 93.9124 2.51154 94.4483 3.11461 94.4483Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.52819 94.4482C8.13127 94.4482 8.62016 93.9124 8.62016 93.2513C8.62016 92.5903 8.13127 92.0544 7.52819 92.0544C6.92511 92.0544 6.43622 92.5903 6.43622 93.2513C6.43622 93.9124 6.92511 94.4482 7.52819 94.4482Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9413 94.4482C12.5444 94.4482 13.0332 93.9124 13.0332 93.2513C13.0332 92.5903 12.5444 92.0544 11.9413 92.0544C11.3382 92.0544 10.8493 92.5903 10.8493 93.2513C10.8493 93.9124 11.3382 94.4482 11.9413 94.4482Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3548 94.4482C16.9579 94.4482 17.4468 93.9124 17.4468 93.2513C17.4468 92.5903 16.9579 92.0544 16.3548 92.0544C15.7518 92.0544 15.2629 92.5903 15.2629 93.2513C15.2629 93.9124 15.7518 94.4482 16.3548 94.4482Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.7625 94.4482C21.3656 94.4482 21.8545 93.9124 21.8545 93.2513C21.8545 92.5903 21.3656 92.0544 20.7625 92.0544C20.1594 92.0544 19.6705 92.5903 19.6705 93.2513C19.6705 93.9124 20.1594 94.4482 20.7625 94.4482Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.1761 94.4482C25.7792 94.4482 26.268 93.9124 26.268 93.2513C26.268 92.5903 25.7792 92.0544 25.1761 92.0544C24.573 92.0544 24.0841 92.5903 24.0841 93.2513C24.0841 93.9124 24.573 94.4482 25.1761 94.4482Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.5891 94.4482C30.1922 94.4482 30.6811 93.9124 30.6811 93.2513C30.6811 92.5903 30.1922 92.0544 29.5891 92.0544C28.986 92.0544 28.4971 92.5903 28.4971 93.2513C28.4971 93.9124 28.986 94.4482 29.5891 94.4482Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0025 94.4482C34.6056 94.4482 35.0945 93.9124 35.0945 93.2513C35.0945 92.5903 34.6056 92.0544 34.0025 92.0544C33.3994 92.0544 32.9105 92.5903 32.9105 93.2513C32.9105 93.9124 33.3994 94.4482 34.0025 94.4482Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.416 94.4482C39.0191 94.4482 39.508 93.9124 39.508 93.2513C39.508 92.5903 39.0191 92.0544 38.416 92.0544C37.8129 92.0544 37.324 92.5903 37.324 93.2513C37.324 93.9124 37.8129 94.4482 38.416 94.4482Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.8294 94.4482C43.4325 94.4482 43.9214 93.9124 43.9214 93.2513C43.9214 92.5903 43.4325 92.0544 42.8294 92.0544C42.2263 92.0544 41.7374 92.5903 41.7374 93.2513C41.7374 93.9124 42.2263 94.4482 42.8294 94.4482Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.2427 94.4482C47.8458 94.4482 48.3347 93.9124 48.3347 93.2513C48.3347 92.5903 47.8458 92.0544 47.2427 92.0544C46.6397 92.0544 46.1508 92.5903 46.1508 93.2513C46.1508 93.9124 46.6397 94.4482 47.2427 94.4482Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.656 94.4482C52.2591 94.4482 52.748 93.9124 52.748 93.2513C52.748 92.5903 52.2591 92.0544 51.656 92.0544C51.0529 92.0544 50.564 92.5903 50.564 93.2513C50.564 93.9124 51.0529 94.4482 51.656 94.4482Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.11461 99.0804C3.71769 99.0804 4.20658 98.5445 4.20658 97.8835C4.20658 97.2225 3.71769 96.6866 3.11461 96.6866C2.51154 96.6866 2.02264 97.2225 2.02264 97.8835C2.02264 98.5445 2.51154 99.0804 3.11461 99.0804Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.52819 99.0804C8.13127 99.0804 8.62016 98.5445 8.62016 97.8835C8.62016 97.2225 8.13127 96.6866 7.52819 96.6866C6.92511 96.6866 6.43622 97.2225 6.43622 97.8835C6.43622 98.5445 6.92511 99.0804 7.52819 99.0804Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9413 99.0804C12.5444 99.0804 13.0332 98.5445 13.0332 97.8835C13.0332 97.2225 12.5444 96.6866 11.9413 96.6866C11.3382 96.6866 10.8493 97.2225 10.8493 97.8835C10.8493 98.5445 11.3382 99.0804 11.9413 99.0804Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3548 99.0804C16.9579 99.0804 17.4468 98.5445 17.4468 97.8835C17.4468 97.2225 16.9579 96.6866 16.3548 96.6866C15.7518 96.6866 15.2629 97.2225 15.2629 97.8835C15.2629 98.5445 15.7518 99.0804 16.3548 99.0804Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.7625 99.0804C21.3656 99.0804 21.8545 98.5445 21.8545 97.8835C21.8545 97.2225 21.3656 96.6866 20.7625 96.6866C20.1594 96.6866 19.6705 97.2225 19.6705 97.8835C19.6705 98.5445 20.1594 99.0804 20.7625 99.0804Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.1761 99.0804C25.7792 99.0804 26.268 98.5445 26.268 97.8835C26.268 97.2225 25.7792 96.6866 25.1761 96.6866C24.573 96.6866 24.0841 97.2225 24.0841 97.8835C24.0841 98.5445 24.573 99.0804 25.1761 99.0804Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.5891 99.0804C30.1922 99.0804 30.6811 98.5445 30.6811 97.8835C30.6811 97.2225 30.1922 96.6866 29.5891 96.6866C28.986 96.6866 28.4971 97.2225 28.4971 97.8835C28.4971 98.5445 28.986 99.0804 29.5891 99.0804Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0025 99.0804C34.6056 99.0804 35.0945 98.5445 35.0945 97.8835C35.0945 97.2225 34.6056 96.6866 34.0025 96.6866C33.3994 96.6866 32.9105 97.2225 32.9105 97.8835C32.9105 98.5445 33.3994 99.0804 34.0025 99.0804Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.416 99.0804C39.0191 99.0804 39.508 98.5445 39.508 97.8835C39.508 97.2225 39.0191 96.6866 38.416 96.6866C37.8129 96.6866 37.324 97.2225 37.324 97.8835C37.324 98.5445 37.8129 99.0804 38.416 99.0804Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.8294 99.0804C43.4325 99.0804 43.9214 98.5445 43.9214 97.8835C43.9214 97.2225 43.4325 96.6866 42.8294 96.6866C42.2263 96.6866 41.7374 97.2225 41.7374 97.8835C41.7374 98.5445 42.2263 99.0804 42.8294 99.0804Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.2427 99.0804C47.8458 99.0804 48.3347 98.5445 48.3347 97.8835C48.3347 97.2225 47.8458 96.6866 47.2427 96.6866C46.6397 96.6866 46.1508 97.2225 46.1508 97.8835C46.1508 98.5445 46.6397 99.0804 47.2427 99.0804Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.656 99.0804C52.2591 99.0804 52.748 98.5445 52.748 97.8835C52.748 97.2225 52.2591 96.6866 51.656 96.6866C51.0529 96.6866 50.564 97.2225 50.564 97.8835C50.564 98.5445 51.0529 99.0804 51.656 99.0804Z",
                fill: "#E5E6E6"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/UniqueClientMobileImage.tsx

var UniqueClientMobileImage = function(param) {
    var _width = param.width, width = _width === void 0 ? 47 : _width, _height = param.height, height = _height === void 0 ? 93 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 47 93",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            borderRadius: "8px 0 0 8px",
            height: "100%",
            width: "100%",
            maxHeight: "93px",
            maxWidth: "47px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.993642 2.20292C1.54242 2.20292 1.98728 1.70978 1.98728 1.10146C1.98728 0.493141 1.54242 0 0.993642 0C0.444869 0 0 0.493141 0 1.10146C0 1.70978 0.444869 2.20292 0.993642 2.20292Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00976 2.20292C5.55853 2.20292 6.0034 1.70978 6.0034 1.10146C6.0034 0.493141 5.55853 0 5.00976 0C4.46098 0 4.01611 0.493141 4.01611 1.10146C4.01611 1.70978 4.46098 2.20292 5.00976 2.20292Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0255 2.20292C9.57428 2.20292 10.0191 1.70978 10.0191 1.10146C10.0191 0.493141 9.57428 0 9.0255 0C8.47673 0 8.03186 0.493141 8.03186 1.10146C8.03186 1.70978 8.47673 2.20292 9.0255 2.20292Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0416 2.20292C13.5904 2.20292 14.0353 1.70978 14.0353 1.10146C14.0353 0.493141 13.5904 0 13.0416 0C12.4928 0 12.048 0.493141 12.048 1.10146C12.048 1.70978 12.4928 2.20292 13.0416 2.20292Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0524 2.20292C17.6011 2.20292 18.046 1.70978 18.046 1.10146C18.046 0.493141 17.6011 0 17.0524 0C16.5036 0 16.0587 0.493141 16.0587 1.10146C16.0587 1.70978 16.5036 2.20292 17.0524 2.20292Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0685 2.20292C21.6172 2.20292 22.0621 1.70978 22.0621 1.10146C22.0621 0.493141 21.6172 0 21.0685 0C20.5197 0 20.0748 0.493141 20.0748 1.10146C20.0748 1.70978 20.5197 2.20292 21.0685 2.20292Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.0842 2.20292C25.633 2.20292 26.0779 1.70978 26.0779 1.10146C26.0779 0.493141 25.633 0 25.0842 0C24.5354 0 24.0906 0.493141 24.0906 1.10146C24.0906 1.70978 24.5354 2.20292 25.0842 2.20292Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1003 2.20292C29.6491 2.20292 30.094 1.70978 30.094 1.10146C30.094 0.493141 29.6491 0 29.1003 0C28.5516 0 28.1067 0.493141 28.1067 1.10146C28.1067 1.70978 28.5516 2.20292 29.1003 2.20292Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1163 2.20292C33.6651 2.20292 34.11 1.70978 34.11 1.10146C34.11 0.493141 33.6651 0 33.1163 0C32.5676 0 32.1227 0.493141 32.1227 1.10146C32.1227 1.70978 32.5676 2.20292 33.1163 2.20292Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.1322 2.20292C37.681 2.20292 38.1258 1.70978 38.1258 1.10146C38.1258 0.493141 37.681 0 37.1322 0C36.5834 0 36.1385 0.493141 36.1385 1.10146C36.1385 1.70978 36.5834 2.20292 37.1322 2.20292Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.1482 2.20292C41.697 2.20292 42.1418 1.70978 42.1418 1.10146C42.1418 0.493141 41.697 0 41.1482 0C40.5994 0 40.1545 0.493141 40.1545 1.10146C40.1545 1.70978 40.5994 2.20292 41.1482 2.20292Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.1641 2.20292C45.7128 2.20292 46.1577 1.70978 46.1577 1.10146C46.1577 0.493141 45.7128 0 45.1641 0C44.6153 0 44.1704 0.493141 44.1704 1.10146C44.1704 1.70978 44.6153 2.20292 45.1641 2.20292Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.993642 6.46544C1.54242 6.46544 1.98728 5.9723 1.98728 5.36398C1.98728 4.75566 1.54242 4.26251 0.993642 4.26251C0.444869 4.26251 0 4.75566 0 5.36398C0 5.9723 0.444869 6.46544 0.993642 6.46544Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00976 6.46544C5.55853 6.46544 6.0034 5.9723 6.0034 5.36398C6.0034 4.75566 5.55853 4.26252 5.00976 4.26252C4.46098 4.26252 4.01611 4.75566 4.01611 5.36398C4.01611 5.9723 4.46098 6.46544 5.00976 6.46544Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0255 6.46544C9.57428 6.46544 10.0191 5.9723 10.0191 5.36398C10.0191 4.75566 9.57428 4.26252 9.0255 4.26252C8.47673 4.26252 8.03186 4.75566 8.03186 5.36398C8.03186 5.9723 8.47673 6.46544 9.0255 6.46544Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0416 6.46544C13.5904 6.46544 14.0353 5.9723 14.0353 5.36398C14.0353 4.75566 13.5904 4.26252 13.0416 4.26252C12.4928 4.26252 12.048 4.75566 12.048 5.36398C12.048 5.9723 12.4928 6.46544 13.0416 6.46544Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0524 6.46544C17.6011 6.46544 18.046 5.9723 18.046 5.36398C18.046 4.75566 17.6011 4.26252 17.0524 4.26252C16.5036 4.26252 16.0587 4.75566 16.0587 5.36398C16.0587 5.9723 16.5036 6.46544 17.0524 6.46544Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0685 6.46544C21.6172 6.46544 22.0621 5.9723 22.0621 5.36398C22.0621 4.75566 21.6172 4.26252 21.0685 4.26252C20.5197 4.26252 20.0748 4.75566 20.0748 5.36398C20.0748 5.9723 20.5197 6.46544 21.0685 6.46544Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.0842 6.46544C25.633 6.46544 26.0779 5.9723 26.0779 5.36398C26.0779 4.75566 25.633 4.26252 25.0842 4.26252C24.5354 4.26252 24.0906 4.75566 24.0906 5.36398C24.0906 5.9723 24.5354 6.46544 25.0842 6.46544Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1002 6.46544C29.649 6.46544 30.0939 5.9723 30.0939 5.36398C30.0939 4.75566 29.649 4.26252 29.1002 4.26252C28.5514 4.26252 28.1066 4.75566 28.1066 5.36398C28.1066 5.9723 28.5514 6.46544 29.1002 6.46544Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1163 6.46544C33.6651 6.46544 34.11 5.9723 34.11 5.36398C34.11 4.75566 33.6651 4.26252 33.1163 4.26252C32.5676 4.26252 32.1227 4.75566 32.1227 5.36398C32.1227 5.9723 32.5676 6.46544 33.1163 6.46544Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.1322 6.46544C37.681 6.46544 38.1258 5.9723 38.1258 5.36398C38.1258 4.75566 37.681 4.26252 37.1322 4.26252C36.5834 4.26252 36.1385 4.75566 36.1385 5.36398C36.1385 5.9723 36.5834 6.46544 37.1322 6.46544Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.1482 6.46544C41.697 6.46544 42.1418 5.9723 42.1418 5.36398C42.1418 4.75566 41.697 4.26252 41.1482 4.26252C40.5994 4.26252 40.1545 4.75566 40.1545 5.36398C40.1545 5.9723 40.5994 6.46544 41.1482 6.46544Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.1641 6.46544C45.7128 6.46544 46.1577 5.9723 46.1577 5.36398C46.1577 4.75566 45.7128 4.26252 45.1641 4.26252C44.6153 4.26252 44.1704 4.75566 44.1704 5.36398C44.1704 5.9723 44.6153 6.46544 45.1641 6.46544Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.993642 10.7282C1.54242 10.7282 1.98728 10.2351 1.98728 9.62674C1.98728 9.01842 1.54242 8.52528 0.993642 8.52528C0.444869 8.52528 0 9.01842 0 9.62674C0 10.2351 0.444869 10.7282 0.993642 10.7282Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00976 10.7282C5.55853 10.7282 6.0034 10.2351 6.0034 9.62674C6.0034 9.01842 5.55853 8.52528 5.00976 8.52528C4.46098 8.52528 4.01611 9.01842 4.01611 9.62674C4.01611 10.2351 4.46098 10.7282 5.00976 10.7282Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0255 10.7282C9.57428 10.7282 10.0191 10.2351 10.0191 9.62674C10.0191 9.01842 9.57428 8.52528 9.0255 8.52528C8.47673 8.52528 8.03186 9.01842 8.03186 9.62674C8.03186 10.2351 8.47673 10.7282 9.0255 10.7282Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0416 10.7282C13.5904 10.7282 14.0353 10.2351 14.0353 9.62674C14.0353 9.01842 13.5904 8.52528 13.0416 8.52528C12.4928 8.52528 12.048 9.01842 12.048 9.62674C12.048 10.2351 12.4928 10.7282 13.0416 10.7282Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0524 10.7282C17.6011 10.7282 18.046 10.2351 18.046 9.62674C18.046 9.01842 17.6011 8.52528 17.0524 8.52528C16.5036 8.52528 16.0587 9.01842 16.0587 9.62674C16.0587 10.2351 16.5036 10.7282 17.0524 10.7282Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0685 10.7282C21.6172 10.7282 22.0621 10.2351 22.0621 9.62674C22.0621 9.01842 21.6172 8.52528 21.0685 8.52528C20.5197 8.52528 20.0748 9.01842 20.0748 9.62674C20.0748 10.2351 20.5197 10.7282 21.0685 10.7282Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.0842 10.7282C25.633 10.7282 26.0779 10.2351 26.0779 9.62674C26.0779 9.01842 25.633 8.52528 25.0842 8.52528C24.5354 8.52528 24.0906 9.01842 24.0906 9.62674C24.0906 10.2351 24.5354 10.7282 25.0842 10.7282Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1002 10.7282C29.649 10.7282 30.0939 10.2351 30.0939 9.62674C30.0939 9.01842 29.649 8.52528 29.1002 8.52528C28.5514 8.52528 28.1066 9.01842 28.1066 9.62674C28.1066 10.2351 28.5514 10.7282 29.1002 10.7282Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1163 10.7282C33.6651 10.7282 34.11 10.2351 34.11 9.62674C34.11 9.01842 33.6651 8.52528 33.1163 8.52528C32.5676 8.52528 32.1227 9.01842 32.1227 9.62674C32.1227 10.2351 32.5676 10.7282 33.1163 10.7282Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.1322 10.7282C37.681 10.7282 38.1258 10.2351 38.1258 9.62674C38.1258 9.01842 37.681 8.52528 37.1322 8.52528C36.5834 8.52528 36.1385 9.01842 36.1385 9.62674C36.1385 10.2351 36.5834 10.7282 37.1322 10.7282Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.1482 10.7282C41.697 10.7282 42.1418 10.2351 42.1418 9.62674C42.1418 9.01842 41.697 8.52528 41.1482 8.52528C40.5994 8.52528 40.1545 9.01842 40.1545 9.62674C40.1545 10.2351 40.5994 10.7282 41.1482 10.7282Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.1641 10.7282C45.7128 10.7282 46.1577 10.2351 46.1577 9.62674C46.1577 9.01842 45.7128 8.52528 45.1641 8.52528C44.6153 8.52528 44.1704 9.01842 44.1704 9.62674C44.1704 10.2351 44.6153 10.7282 45.1641 10.7282Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.993642 14.9901C1.54242 14.9901 1.98728 14.497 1.98728 13.8887C1.98728 13.2803 1.54242 12.7872 0.993642 12.7872C0.444869 12.7872 0 13.2803 0 13.8887C0 14.497 0.444869 14.9901 0.993642 14.9901Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00976 14.9901C5.55853 14.9901 6.0034 14.497 6.0034 13.8887C6.0034 13.2803 5.55853 12.7872 5.00976 12.7872C4.46098 12.7872 4.01611 13.2803 4.01611 13.8887C4.01611 14.497 4.46098 14.9901 5.00976 14.9901Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0255 14.9901C9.57428 14.9901 10.0191 14.497 10.0191 13.8887C10.0191 13.2803 9.57428 12.7872 9.0255 12.7872C8.47673 12.7872 8.03186 13.2803 8.03186 13.8887C8.03186 14.497 8.47673 14.9901 9.0255 14.9901Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0416 14.9901C13.5904 14.9901 14.0353 14.497 14.0353 13.8887C14.0353 13.2803 13.5904 12.7872 13.0416 12.7872C12.4928 12.7872 12.048 13.2803 12.048 13.8887C12.048 14.497 12.4928 14.9901 13.0416 14.9901Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0524 14.9901C17.6011 14.9901 18.046 14.497 18.046 13.8887C18.046 13.2803 17.6011 12.7872 17.0524 12.7872C16.5036 12.7872 16.0587 13.2803 16.0587 13.8887C16.0587 14.497 16.5036 14.9901 17.0524 14.9901Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0685 14.9901C21.6172 14.9901 22.0621 14.497 22.0621 13.8887C22.0621 13.2803 21.6172 12.7872 21.0685 12.7872C20.5197 12.7872 20.0748 13.2803 20.0748 13.8887C20.0748 14.497 20.5197 14.9901 21.0685 14.9901Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.0842 14.9901C25.633 14.9901 26.0779 14.497 26.0779 13.8887C26.0779 13.2803 25.633 12.7872 25.0842 12.7872C24.5354 12.7872 24.0906 13.2803 24.0906 13.8887C24.0906 14.497 24.5354 14.9901 25.0842 14.9901Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1002 14.9901C29.649 14.9901 30.0939 14.497 30.0939 13.8887C30.0939 13.2803 29.649 12.7872 29.1002 12.7872C28.5514 12.7872 28.1066 13.2803 28.1066 13.8887C28.1066 14.497 28.5514 14.9901 29.1002 14.9901Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1163 14.9901C33.6651 14.9901 34.11 14.497 34.11 13.8887C34.11 13.2803 33.6651 12.7872 33.1163 12.7872C32.5676 12.7872 32.1227 13.2803 32.1227 13.8887C32.1227 14.497 32.5676 14.9901 33.1163 14.9901Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.1322 14.9901C37.681 14.9901 38.1258 14.497 38.1258 13.8887C38.1258 13.2803 37.681 12.7872 37.1322 12.7872C36.5834 12.7872 36.1385 13.2803 36.1385 13.8887C36.1385 14.497 36.5834 14.9901 37.1322 14.9901Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.1482 14.9901C41.697 14.9901 42.1418 14.497 42.1418 13.8887C42.1418 13.2803 41.697 12.7872 41.1482 12.7872C40.5994 12.7872 40.1545 13.2803 40.1545 13.8887C40.1545 14.497 40.5994 14.9901 41.1482 14.9901Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.1641 14.9901C45.7128 14.9901 46.1577 14.497 46.1577 13.8887C46.1577 13.2803 45.7128 12.7872 45.1641 12.7872C44.6153 12.7872 44.1704 13.2803 44.1704 13.8887C44.1704 14.497 44.6153 14.9901 45.1641 14.9901Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.993642 19.2528C1.54242 19.2528 1.98728 18.7596 1.98728 18.1513C1.98728 17.543 1.54242 17.0498 0.993642 17.0498C0.444869 17.0498 0 17.543 0 18.1513C0 18.7596 0.444869 19.2528 0.993642 19.2528Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00976 19.2528C5.55853 19.2528 6.0034 18.7596 6.0034 18.1513C6.0034 17.543 5.55853 17.0498 5.00976 17.0498C4.46098 17.0498 4.01611 17.543 4.01611 18.1513C4.01611 18.7596 4.46098 19.2528 5.00976 19.2528Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0255 19.2528C9.57428 19.2528 10.0191 18.7596 10.0191 18.1513C10.0191 17.543 9.57428 17.0498 9.0255 17.0498C8.47673 17.0498 8.03186 17.543 8.03186 18.1513C8.03186 18.7596 8.47673 19.2528 9.0255 19.2528Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0416 19.2528C13.5904 19.2528 14.0353 18.7596 14.0353 18.1513C14.0353 17.543 13.5904 17.0498 13.0416 17.0498C12.4928 17.0498 12.048 17.543 12.048 18.1513C12.048 18.7596 12.4928 19.2528 13.0416 19.2528Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0524 19.2528C17.6011 19.2528 18.046 18.7596 18.046 18.1513C18.046 17.543 17.6011 17.0498 17.0524 17.0498C16.5036 17.0498 16.0587 17.543 16.0587 18.1513C16.0587 18.7596 16.5036 19.2528 17.0524 19.2528Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0685 19.2528C21.6172 19.2528 22.0621 18.7596 22.0621 18.1513C22.0621 17.543 21.6172 17.0498 21.0685 17.0498C20.5197 17.0498 20.0748 17.543 20.0748 18.1513C20.0748 18.7596 20.5197 19.2528 21.0685 19.2528Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.0842 19.2528C25.633 19.2528 26.0779 18.7596 26.0779 18.1513C26.0779 17.543 25.633 17.0498 25.0842 17.0498C24.5354 17.0498 24.0906 17.543 24.0906 18.1513C24.0906 18.7596 24.5354 19.2528 25.0842 19.2528Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1002 19.2528C29.649 19.2528 30.0939 18.7596 30.0939 18.1513C30.0939 17.543 29.649 17.0498 29.1002 17.0498C28.5514 17.0498 28.1066 17.543 28.1066 18.1513C28.1066 18.7596 28.5514 19.2528 29.1002 19.2528Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1163 19.2528C33.6651 19.2528 34.11 18.7596 34.11 18.1513C34.11 17.543 33.6651 17.0498 33.1163 17.0498C32.5676 17.0498 32.1227 17.543 32.1227 18.1513C32.1227 18.7596 32.5676 19.2528 33.1163 19.2528Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.1322 19.2528C37.681 19.2528 38.1258 18.7596 38.1258 18.1513C38.1258 17.543 37.681 17.0498 37.1322 17.0498C36.5834 17.0498 36.1385 17.543 36.1385 18.1513C36.1385 18.7596 36.5834 19.2528 37.1322 19.2528Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.1482 19.2528C41.697 19.2528 42.1418 18.7596 42.1418 18.1513C42.1418 17.543 41.697 17.0498 41.1482 17.0498C40.5994 17.0498 40.1545 17.543 40.1545 18.1513C40.1545 18.7596 40.5994 19.2528 41.1482 19.2528Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.1641 19.2528C45.7128 19.2528 46.1577 18.7596 46.1577 18.1513C46.1577 17.543 45.7128 17.0498 45.1641 17.0498C44.6153 17.0498 44.1704 17.543 44.1704 18.1513C44.1704 18.7596 44.6153 19.2528 45.1641 19.2528Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.993642 23.5147C1.54242 23.5147 1.98728 23.0215 1.98728 22.4132C1.98728 21.8049 1.54242 21.3118 0.993642 21.3118C0.444869 21.3118 0 21.8049 0 22.4132C0 23.0215 0.444869 23.5147 0.993642 23.5147Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00976 23.5147C5.55853 23.5147 6.0034 23.0215 6.0034 22.4132C6.0034 21.8049 5.55853 21.3118 5.00976 21.3118C4.46098 21.3118 4.01611 21.8049 4.01611 22.4132C4.01611 23.0215 4.46098 23.5147 5.00976 23.5147Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0255 23.5147C9.57428 23.5147 10.0191 23.0215 10.0191 22.4132C10.0191 21.8049 9.57428 21.3118 9.0255 21.3118C8.47673 21.3118 8.03186 21.8049 8.03186 22.4132C8.03186 23.0215 8.47673 23.5147 9.0255 23.5147Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0416 23.5147C13.5904 23.5147 14.0353 23.0215 14.0353 22.4132C14.0353 21.8049 13.5904 21.3118 13.0416 21.3118C12.4928 21.3118 12.048 21.8049 12.048 22.4132C12.048 23.0215 12.4928 23.5147 13.0416 23.5147Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0524 23.5147C17.6011 23.5147 18.046 23.0215 18.046 22.4132C18.046 21.8049 17.6011 21.3118 17.0524 21.3118C16.5036 21.3118 16.0587 21.8049 16.0587 22.4132C16.0587 23.0215 16.5036 23.5147 17.0524 23.5147Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0685 23.5147C21.6172 23.5147 22.0621 23.0215 22.0621 22.4132C22.0621 21.8049 21.6172 21.3118 21.0685 21.3118C20.5197 21.3118 20.0748 21.8049 20.0748 22.4132C20.0748 23.0215 20.5197 23.5147 21.0685 23.5147Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.0842 23.5147C25.633 23.5147 26.0779 23.0215 26.0779 22.4132C26.0779 21.8049 25.633 21.3118 25.0842 21.3118C24.5354 21.3118 24.0906 21.8049 24.0906 22.4132C24.0906 23.0215 24.5354 23.5147 25.0842 23.5147Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1002 23.5147C29.649 23.5147 30.0939 23.0215 30.0939 22.4132C30.0939 21.8049 29.649 21.3118 29.1002 21.3118C28.5514 21.3118 28.1066 21.8049 28.1066 22.4132C28.1066 23.0215 28.5514 23.5147 29.1002 23.5147Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1163 23.5147C33.6651 23.5147 34.11 23.0215 34.11 22.4132C34.11 21.8049 33.6651 21.3118 33.1163 21.3118C32.5676 21.3118 32.1227 21.8049 32.1227 22.4132C32.1227 23.0215 32.5676 23.5147 33.1163 23.5147Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.1322 23.5147C37.681 23.5147 38.1258 23.0215 38.1258 22.4132C38.1258 21.8049 37.681 21.3118 37.1322 21.3118C36.5834 21.3118 36.1385 21.8049 36.1385 22.4132C36.1385 23.0215 36.5834 23.5147 37.1322 23.5147Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.1482 23.5147C41.697 23.5147 42.1418 23.0215 42.1418 22.4132C42.1418 21.8049 41.697 21.3118 41.1482 21.3118C40.5994 21.3118 40.1545 21.8049 40.1545 22.4132C40.1545 23.0215 40.5994 23.5147 41.1482 23.5147Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.1641 23.5147C45.7128 23.5147 46.1577 23.0215 46.1577 22.4132C46.1577 21.8049 45.7128 21.3118 45.1641 21.3118C44.6153 21.3118 44.1704 21.8049 44.1704 22.4132C44.1704 23.0215 44.6153 23.5147 45.1641 23.5147Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.993642 27.7772C1.54242 27.7772 1.98728 27.284 1.98728 26.6757C1.98728 26.0674 1.54242 25.5743 0.993642 25.5743C0.444869 25.5743 0 26.0674 0 26.6757C0 27.284 0.444869 27.7772 0.993642 27.7772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00976 27.7772C5.55853 27.7772 6.0034 27.2841 6.0034 26.6757C6.0034 26.0674 5.55853 25.5743 5.00976 25.5743C4.46098 25.5743 4.01611 26.0674 4.01611 26.6757C4.01611 27.2841 4.46098 27.7772 5.00976 27.7772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0255 27.7772C9.57428 27.7772 10.0191 27.2841 10.0191 26.6757C10.0191 26.0674 9.57428 25.5743 9.0255 25.5743C8.47673 25.5743 8.03186 26.0674 8.03186 26.6757C8.03186 27.2841 8.47673 27.7772 9.0255 27.7772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0416 27.7772C13.5904 27.7772 14.0353 27.2841 14.0353 26.6757C14.0353 26.0674 13.5904 25.5743 13.0416 25.5743C12.4928 25.5743 12.048 26.0674 12.048 26.6757C12.048 27.2841 12.4928 27.7772 13.0416 27.7772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0524 27.7772C17.6011 27.7772 18.046 27.2841 18.046 26.6757C18.046 26.0674 17.6011 25.5743 17.0524 25.5743C16.5036 25.5743 16.0587 26.0674 16.0587 26.6757C16.0587 27.2841 16.5036 27.7772 17.0524 27.7772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0685 27.7772C21.6172 27.7772 22.0621 27.2841 22.0621 26.6757C22.0621 26.0674 21.6172 25.5743 21.0685 25.5743C20.5197 25.5743 20.0748 26.0674 20.0748 26.6757C20.0748 27.2841 20.5197 27.7772 21.0685 27.7772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.0842 27.7772C25.633 27.7772 26.0779 27.2841 26.0779 26.6757C26.0779 26.0674 25.633 25.5743 25.0842 25.5743C24.5354 25.5743 24.0906 26.0674 24.0906 26.6757C24.0906 27.2841 24.5354 27.7772 25.0842 27.7772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1002 27.7772C29.649 27.7772 30.0939 27.2841 30.0939 26.6757C30.0939 26.0674 29.649 25.5743 29.1002 25.5743C28.5514 25.5743 28.1066 26.0674 28.1066 26.6757C28.1066 27.2841 28.5514 27.7772 29.1002 27.7772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1163 27.7772C33.6651 27.7772 34.11 27.2841 34.11 26.6757C34.11 26.0674 33.6651 25.5743 33.1163 25.5743C32.5676 25.5743 32.1227 26.0674 32.1227 26.6757C32.1227 27.2841 32.5676 27.7772 33.1163 27.7772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.1322 27.7772C37.681 27.7772 38.1258 27.2841 38.1258 26.6757C38.1258 26.0674 37.681 25.5743 37.1322 25.5743C36.5834 25.5743 36.1385 26.0674 36.1385 26.6757C36.1385 27.2841 36.5834 27.7772 37.1322 27.7772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.1482 27.7772C41.697 27.7772 42.1418 27.2841 42.1418 26.6757C42.1418 26.0674 41.697 25.5743 41.1482 25.5743C40.5994 25.5743 40.1545 26.0674 40.1545 26.6757C40.1545 27.2841 40.5994 27.7772 41.1482 27.7772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.1641 27.7772C45.7128 27.7772 46.1577 27.2841 46.1577 26.6757C46.1577 26.0674 45.7128 25.5743 45.1641 25.5743C44.6153 25.5743 44.1704 26.0674 44.1704 26.6757C44.1704 27.2841 44.6153 27.7772 45.1641 27.7772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.993642 32.0397C1.54242 32.0397 1.98728 31.5466 1.98728 30.9382C1.98728 30.3299 1.54242 29.8368 0.993642 29.8368C0.444869 29.8368 0 30.3299 0 30.9382C0 31.5466 0.444869 32.0397 0.993642 32.0397Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00976 32.0397C5.55853 32.0397 6.0034 31.5466 6.0034 30.9383C6.0034 30.3299 5.55853 29.8368 5.00976 29.8368C4.46098 29.8368 4.01611 30.3299 4.01611 30.9383C4.01611 31.5466 4.46098 32.0397 5.00976 32.0397Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0255 32.0397C9.57428 32.0397 10.0191 31.5466 10.0191 30.9383C10.0191 30.3299 9.57428 29.8368 9.0255 29.8368C8.47673 29.8368 8.03186 30.3299 8.03186 30.9383C8.03186 31.5466 8.47673 32.0397 9.0255 32.0397Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0416 32.0397C13.5904 32.0397 14.0353 31.5466 14.0353 30.9383C14.0353 30.3299 13.5904 29.8368 13.0416 29.8368C12.4928 29.8368 12.048 30.3299 12.048 30.9383C12.048 31.5466 12.4928 32.0397 13.0416 32.0397Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0524 32.0397C17.6011 32.0397 18.046 31.5466 18.046 30.9383C18.046 30.3299 17.6011 29.8368 17.0524 29.8368C16.5036 29.8368 16.0587 30.3299 16.0587 30.9383C16.0587 31.5466 16.5036 32.0397 17.0524 32.0397Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0685 32.0397C21.6172 32.0397 22.0621 31.5466 22.0621 30.9383C22.0621 30.3299 21.6172 29.8368 21.0685 29.8368C20.5197 29.8368 20.0748 30.3299 20.0748 30.9383C20.0748 31.5466 20.5197 32.0397 21.0685 32.0397Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.0842 32.0397C25.633 32.0397 26.0779 31.5466 26.0779 30.9383C26.0779 30.3299 25.633 29.8368 25.0842 29.8368C24.5354 29.8368 24.0906 30.3299 24.0906 30.9383C24.0906 31.5466 24.5354 32.0397 25.0842 32.0397Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1002 32.0397C29.649 32.0397 30.0939 31.5466 30.0939 30.9383C30.0939 30.3299 29.649 29.8368 29.1002 29.8368C28.5514 29.8368 28.1066 30.3299 28.1066 30.9383C28.1066 31.5466 28.5514 32.0397 29.1002 32.0397Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1163 32.0397C33.6651 32.0397 34.11 31.5466 34.11 30.9383C34.11 30.3299 33.6651 29.8368 33.1163 29.8368C32.5676 29.8368 32.1227 30.3299 32.1227 30.9383C32.1227 31.5466 32.5676 32.0397 33.1163 32.0397Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.1322 32.0397C37.681 32.0397 38.1258 31.5466 38.1258 30.9383C38.1258 30.3299 37.681 29.8368 37.1322 29.8368C36.5834 29.8368 36.1385 30.3299 36.1385 30.9383C36.1385 31.5466 36.5834 32.0397 37.1322 32.0397Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.1482 32.0397C41.697 32.0397 42.1418 31.5466 42.1418 30.9383C42.1418 30.3299 41.697 29.8368 41.1482 29.8368C40.5994 29.8368 40.1545 30.3299 40.1545 30.9383C40.1545 31.5466 40.5994 32.0397 41.1482 32.0397Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.1641 32.0397C45.7128 32.0397 46.1577 31.5466 46.1577 30.9383C46.1577 30.3299 45.7128 29.8368 45.1641 29.8368C44.6153 29.8368 44.1704 30.3299 44.1704 30.9383C44.1704 31.5466 44.6153 32.0397 45.1641 32.0397Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.993642 36.3024C1.54242 36.3024 1.98728 35.8093 1.98728 35.201C1.98728 34.5927 1.54242 34.0995 0.993642 34.0995C0.444869 34.0995 0 34.5927 0 35.201C0 35.8093 0.444869 36.3024 0.993642 36.3024Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00976 36.3024C5.55853 36.3024 6.0034 35.8093 6.0034 35.201C6.0034 34.5927 5.55853 34.0995 5.00976 34.0995C4.46098 34.0995 4.01611 34.5927 4.01611 35.201C4.01611 35.8093 4.46098 36.3024 5.00976 36.3024Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0255 36.3024C9.57428 36.3024 10.0191 35.8093 10.0191 35.201C10.0191 34.5927 9.57428 34.0995 9.0255 34.0995C8.47673 34.0995 8.03186 34.5927 8.03186 35.201C8.03186 35.8093 8.47673 36.3024 9.0255 36.3024Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0416 36.3024C13.5904 36.3024 14.0353 35.8093 14.0353 35.201C14.0353 34.5927 13.5904 34.0995 13.0416 34.0995C12.4928 34.0995 12.048 34.5927 12.048 35.201C12.048 35.8093 12.4928 36.3024 13.0416 36.3024Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0524 36.3024C17.6011 36.3024 18.046 35.8093 18.046 35.201C18.046 34.5927 17.6011 34.0995 17.0524 34.0995C16.5036 34.0995 16.0587 34.5927 16.0587 35.201C16.0587 35.8093 16.5036 36.3024 17.0524 36.3024Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0685 36.3024C21.6172 36.3024 22.0621 35.8093 22.0621 35.201C22.0621 34.5927 21.6172 34.0995 21.0685 34.0995C20.5197 34.0995 20.0748 34.5927 20.0748 35.201C20.0748 35.8093 20.5197 36.3024 21.0685 36.3024Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.0842 36.3024C25.633 36.3024 26.0779 35.8093 26.0779 35.201C26.0779 34.5927 25.633 34.0995 25.0842 34.0995C24.5354 34.0995 24.0906 34.5927 24.0906 35.201C24.0906 35.8093 24.5354 36.3024 25.0842 36.3024Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1002 36.3024C29.649 36.3024 30.0939 35.8093 30.0939 35.201C30.0939 34.5927 29.649 34.0995 29.1002 34.0995C28.5514 34.0995 28.1066 34.5927 28.1066 35.201C28.1066 35.8093 28.5514 36.3024 29.1002 36.3024Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1163 36.3024C33.6651 36.3024 34.11 35.8093 34.11 35.201C34.11 34.5927 33.6651 34.0995 33.1163 34.0995C32.5676 34.0995 32.1227 34.5927 32.1227 35.201C32.1227 35.8093 32.5676 36.3024 33.1163 36.3024Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.1322 36.3024C37.681 36.3024 38.1258 35.8093 38.1258 35.201C38.1258 34.5927 37.681 34.0995 37.1322 34.0995C36.5834 34.0995 36.1385 34.5927 36.1385 35.201C36.1385 35.8093 36.5834 36.3024 37.1322 36.3024Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.1482 36.3024C41.697 36.3024 42.1418 35.8093 42.1418 35.201C42.1418 34.5927 41.697 34.0995 41.1482 34.0995C40.5994 34.0995 40.1545 34.5927 40.1545 35.201C40.1545 35.8093 40.5994 36.3024 41.1482 36.3024Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.1641 36.3024C45.7128 36.3024 46.1577 35.8093 46.1577 35.201C46.1577 34.5927 45.7128 34.0995 45.1641 34.0995C44.6153 34.0995 44.1704 34.5927 44.1704 35.201C44.1704 35.8093 44.6153 36.3024 45.1641 36.3024Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.993642 40.5651C1.54242 40.5651 1.98728 40.0719 1.98728 39.4636C1.98728 38.8553 1.54242 38.3621 0.993642 38.3621C0.444869 38.3621 0 38.8553 0 39.4636C0 40.0719 0.444869 40.5651 0.993642 40.5651Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00976 40.5651C5.55853 40.5651 6.0034 40.0719 6.0034 39.4636C6.0034 38.8553 5.55853 38.3622 5.00976 38.3622C4.46098 38.3622 4.01611 38.8553 4.01611 39.4636C4.01611 40.0719 4.46098 40.5651 5.00976 40.5651Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0255 40.5651C9.57428 40.5651 10.0191 40.0719 10.0191 39.4636C10.0191 38.8553 9.57428 38.3622 9.0255 38.3622C8.47673 38.3622 8.03186 38.8553 8.03186 39.4636C8.03186 40.0719 8.47673 40.5651 9.0255 40.5651Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0416 40.5651C13.5904 40.5651 14.0353 40.0719 14.0353 39.4636C14.0353 38.8553 13.5904 38.3622 13.0416 38.3622C12.4928 38.3622 12.048 38.8553 12.048 39.4636C12.048 40.0719 12.4928 40.5651 13.0416 40.5651Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0524 40.5651C17.6011 40.5651 18.046 40.0719 18.046 39.4636C18.046 38.8553 17.6011 38.3622 17.0524 38.3622C16.5036 38.3622 16.0587 38.8553 16.0587 39.4636C16.0587 40.0719 16.5036 40.5651 17.0524 40.5651Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0685 40.5651C21.6172 40.5651 22.0621 40.0719 22.0621 39.4636C22.0621 38.8553 21.6172 38.3622 21.0685 38.3622C20.5197 38.3622 20.0748 38.8553 20.0748 39.4636C20.0748 40.0719 20.5197 40.5651 21.0685 40.5651Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.0842 40.5651C25.633 40.5651 26.0779 40.0719 26.0779 39.4636C26.0779 38.8553 25.633 38.3622 25.0842 38.3622C24.5354 38.3622 24.0906 38.8553 24.0906 39.4636C24.0906 40.0719 24.5354 40.5651 25.0842 40.5651Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1002 40.5651C29.649 40.5651 30.0939 40.0719 30.0939 39.4636C30.0939 38.8553 29.649 38.3622 29.1002 38.3622C28.5514 38.3622 28.1066 38.8553 28.1066 39.4636C28.1066 40.0719 28.5514 40.5651 29.1002 40.5651Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1163 40.5651C33.6651 40.5651 34.11 40.0719 34.11 39.4636C34.11 38.8553 33.6651 38.3622 33.1163 38.3622C32.5676 38.3622 32.1227 38.8553 32.1227 39.4636C32.1227 40.0719 32.5676 40.5651 33.1163 40.5651Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.1322 40.5651C37.681 40.5651 38.1258 40.0719 38.1258 39.4636C38.1258 38.8553 37.681 38.3622 37.1322 38.3622C36.5834 38.3622 36.1385 38.8553 36.1385 39.4636C36.1385 40.0719 36.5834 40.5651 37.1322 40.5651Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.1482 40.5651C41.697 40.5651 42.1418 40.0719 42.1418 39.4636C42.1418 38.8553 41.697 38.3622 41.1482 38.3622C40.5994 38.3622 40.1545 38.8553 40.1545 39.4636C40.1545 40.0719 40.5994 40.5651 41.1482 40.5651Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.1641 40.5651C45.7128 40.5651 46.1577 40.0719 46.1577 39.4636C46.1577 38.8553 45.7128 38.3622 45.1641 38.3622C44.6153 38.3622 44.1704 38.8553 44.1704 39.4636C44.1704 40.0719 44.6153 40.5651 45.1641 40.5651Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.993642 44.827C1.54242 44.827 1.98728 44.3339 1.98728 43.7255C1.98728 43.1172 1.54242 42.6241 0.993642 42.6241C0.444869 42.6241 0 43.1172 0 43.7255C0 44.3339 0.444869 44.827 0.993642 44.827Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00976 44.827C5.55853 44.827 6.0034 44.3339 6.0034 43.7255C6.0034 43.1172 5.55853 42.6241 5.00976 42.6241C4.46098 42.6241 4.01611 43.1172 4.01611 43.7255C4.01611 44.3339 4.46098 44.827 5.00976 44.827Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0255 44.827C9.57428 44.827 10.0191 44.3339 10.0191 43.7255C10.0191 43.1172 9.57428 42.6241 9.0255 42.6241C8.47673 42.6241 8.03186 43.1172 8.03186 43.7255C8.03186 44.3339 8.47673 44.827 9.0255 44.827Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0416 44.827C13.5904 44.827 14.0353 44.3339 14.0353 43.7255C14.0353 43.1172 13.5904 42.6241 13.0416 42.6241C12.4928 42.6241 12.048 43.1172 12.048 43.7255C12.048 44.3339 12.4928 44.827 13.0416 44.827Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0524 44.827C17.6011 44.827 18.046 44.3339 18.046 43.7255C18.046 43.1172 17.6011 42.6241 17.0524 42.6241C16.5036 42.6241 16.0587 43.1172 16.0587 43.7255C16.0587 44.3339 16.5036 44.827 17.0524 44.827Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0685 44.827C21.6172 44.827 22.0621 44.3339 22.0621 43.7255C22.0621 43.1172 21.6172 42.6241 21.0685 42.6241C20.5197 42.6241 20.0748 43.1172 20.0748 43.7255C20.0748 44.3339 20.5197 44.827 21.0685 44.827Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.0842 44.827C25.633 44.827 26.0779 44.3339 26.0779 43.7255C26.0779 43.1172 25.633 42.6241 25.0842 42.6241C24.5354 42.6241 24.0906 43.1172 24.0906 43.7255C24.0906 44.3339 24.5354 44.827 25.0842 44.827Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1002 44.827C29.649 44.827 30.0939 44.3339 30.0939 43.7255C30.0939 43.1172 29.649 42.6241 29.1002 42.6241C28.5514 42.6241 28.1066 43.1172 28.1066 43.7255C28.1066 44.3339 28.5514 44.827 29.1002 44.827Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1163 44.827C33.6651 44.827 34.11 44.3339 34.11 43.7255C34.11 43.1172 33.6651 42.6241 33.1163 42.6241C32.5676 42.6241 32.1227 43.1172 32.1227 43.7255C32.1227 44.3339 32.5676 44.827 33.1163 44.827Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.1322 44.827C37.681 44.827 38.1258 44.3339 38.1258 43.7255C38.1258 43.1172 37.681 42.6241 37.1322 42.6241C36.5834 42.6241 36.1385 43.1172 36.1385 43.7255C36.1385 44.3339 36.5834 44.827 37.1322 44.827Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.1482 44.827C41.697 44.827 42.1418 44.3339 42.1418 43.7255C42.1418 43.1172 41.697 42.6241 41.1482 42.6241C40.5994 42.6241 40.1545 43.1172 40.1545 43.7255C40.1545 44.3339 40.5994 44.827 41.1482 44.827Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.1641 44.827C45.7128 44.827 46.1577 44.3339 46.1577 43.7255C46.1577 43.1172 45.7128 42.6241 45.1641 42.6241C44.6153 42.6241 44.1704 43.1172 44.1704 43.7255C44.1704 44.3339 44.6153 44.827 45.1641 44.827Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.993642 49.0898C1.54242 49.0898 1.98728 48.5966 1.98728 47.9883C1.98728 47.38 1.54242 46.8868 0.993642 46.8868C0.444869 46.8868 0 47.38 0 47.9883C0 48.5966 0.444869 49.0898 0.993642 49.0898Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00976 49.0898C5.55853 49.0898 6.0034 48.5966 6.0034 47.9883C6.0034 47.38 5.55853 46.8868 5.00976 46.8868C4.46098 46.8868 4.01611 47.38 4.01611 47.9883C4.01611 48.5966 4.46098 49.0898 5.00976 49.0898Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.0255 49.0898C9.57428 49.0898 10.0191 48.5966 10.0191 47.9883C10.0191 47.38 9.57428 46.8868 9.0255 46.8868C8.47673 46.8868 8.03186 47.38 8.03186 47.9883C8.03186 48.5966 8.47673 49.0898 9.0255 49.0898Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0416 49.0898C13.5904 49.0898 14.0353 48.5966 14.0353 47.9883C14.0353 47.38 13.5904 46.8868 13.0416 46.8868C12.4928 46.8868 12.048 47.38 12.048 47.9883C12.048 48.5966 12.4928 49.0898 13.0416 49.0898Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0524 49.0898C17.6011 49.0898 18.046 48.5966 18.046 47.9883C18.046 47.38 17.6011 46.8868 17.0524 46.8868C16.5036 46.8868 16.0587 47.38 16.0587 47.9883C16.0587 48.5966 16.5036 49.0898 17.0524 49.0898Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0685 49.0898C21.6172 49.0898 22.0621 48.5966 22.0621 47.9883C22.0621 47.38 21.6172 46.8868 21.0685 46.8868C20.5197 46.8868 20.0748 47.38 20.0748 47.9883C20.0748 48.5966 20.5197 49.0898 21.0685 49.0898Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.0842 49.0898C25.633 49.0898 26.0779 48.5966 26.0779 47.9883C26.0779 47.38 25.633 46.8868 25.0842 46.8868C24.5354 46.8868 24.0906 47.38 24.0906 47.9883C24.0906 48.5966 24.5354 49.0898 25.0842 49.0898Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1002 49.0898C29.649 49.0898 30.0939 48.5966 30.0939 47.9883C30.0939 47.38 29.649 46.8868 29.1002 46.8868C28.5514 46.8868 28.1066 47.38 28.1066 47.9883C28.1066 48.5966 28.5514 49.0898 29.1002 49.0898Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1163 49.0898C33.6651 49.0898 34.11 48.5966 34.11 47.9883C34.11 47.38 33.6651 46.8868 33.1163 46.8868C32.5676 46.8868 32.1227 47.38 32.1227 47.9883C32.1227 48.5966 32.5676 49.0898 33.1163 49.0898Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.1322 49.0898C37.681 49.0898 38.1258 48.5966 38.1258 47.9883C38.1258 47.38 37.681 46.8868 37.1322 46.8868C36.5834 46.8868 36.1385 47.38 36.1385 47.9883C36.1385 48.5966 36.5834 49.0898 37.1322 49.0898Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.1482 49.0898C41.697 49.0898 42.1418 48.5966 42.1418 47.9883C42.1418 47.38 41.697 46.8868 41.1482 46.8868C40.5994 46.8868 40.1545 47.38 40.1545 47.9883C40.1545 48.5966 40.5994 49.0898 41.1482 49.0898Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.1641 49.0898C45.7128 49.0898 46.1577 48.5966 46.1577 47.9883C46.1577 47.38 45.7128 46.8868 45.1641 46.8868C44.6153 46.8868 44.1704 47.38 44.1704 47.9883C44.1704 48.5966 44.6153 49.0898 45.1641 49.0898Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.2797 49.8402H0V92.2736H38.2797V49.8402Z",
                fill: "#7AC143"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.5424 72.7127C26.3792 72.7127 26.2201 72.6448 26.0977 72.5091C24.2415 70.4508 21.7692 69.3153 19.1419 69.3153C16.5145 69.3153 14.0423 70.4508 12.186 72.5091C11.9412 72.7805 11.5414 72.7805 11.2966 72.5091C11.0518 72.2377 11.0518 71.7943 11.2966 71.5229C13.3936 69.1977 16.18 67.9174 19.1419 67.9174C22.1037 67.9174 24.8942 69.1977 26.9912 71.5229C27.236 71.7943 27.236 72.2377 26.9912 72.5091C26.8688 72.6448 26.7056 72.7127 26.5465 72.7127",
                fill: "#DEF0D0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.372 75.7979C15.2089 75.7979 15.0498 75.7301 14.9274 75.5944C14.6826 75.3229 14.6826 74.8796 14.9274 74.6082C17.2528 72.0296 21.0346 72.0296 23.3601 74.6082C23.6049 74.8796 23.6049 75.3229 23.3601 75.5944C23.1153 75.8658 22.7155 75.8658 22.4707 75.5944C20.6389 73.5632 17.6567 73.5632 15.8208 75.5944C15.6984 75.7301 15.5352 75.7979 15.3761 75.7979",
                fill: "#DEF0D0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.2589 69.0845C30.0957 69.0845 29.9366 69.0167 29.8142 68.881C26.9625 65.7188 23.1725 63.9817 19.1458 63.9817C15.1192 63.9817 11.325 65.7233 8.47335 68.881C8.22857 69.1524 7.82876 69.1524 7.58398 68.881C7.3392 68.6095 7.3392 68.1662 7.58398 67.8948C10.6723 64.4702 14.7765 62.5838 19.1458 62.5838C23.5151 62.5838 27.6193 64.4702 30.7076 67.8948C30.9524 68.1662 30.9524 68.6095 30.7076 68.881C30.5852 69.0167 30.4221 69.0845 30.2629 69.0845",
                fill: "#DEF0D0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.2515 78.2996C20.2515 78.9781 19.7537 79.53 19.1418 79.53C18.5298 79.53 18.0321 78.9781 18.0321 78.2996C18.0321 77.621 18.5298 77.0691 19.1418 77.0691C19.7537 77.0691 20.2515 77.621 20.2515 78.2996Z",
                fill: "#DEF0D0"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/UniqueClientSecondaryMobileImage.tsx

var UniqueClientSecondaryMobileImage = function(param) {
    var _width = param.width, width = _width === void 0 ? 47 : _width, _height = param.height, height = _height === void 0 ? 93 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 47 93",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            borderRadius: "0 8px 8px 0",
            height: "100%",
            width: "100%",
            maxHeight: "93px",
            maxWidth: "47px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46.8422 0H0.842224V46H46.8422V0Z",
                fill: "#AA0E27"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.3 36.9866H10.7751C10.1085 36.9866 9.56799 36.4461 9.56799 35.7794V19.3841C9.56799 18.8736 9.98238 18.4593 10.4929 18.4593H20.0238C20.5342 18.4593 20.9486 18.8736 20.9486 19.3841V35.3891C21.1228 35.5572 21.2309 35.7915 21.2309 36.0557C21.2309 36.5662 20.8165 36.9866 20.306 36.9866M11.4237 35.1308H19.0989V20.315H11.4237V35.1308Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.8364 36.9866H26.3115C25.801 36.9866 25.3867 36.5722 25.3867 36.0557C25.3867 35.7975 25.4948 35.5632 25.6689 35.3891V19.3841C25.6689 18.8736 26.0833 18.4593 26.5938 18.4593H36.1187C36.6292 18.4593 37.0436 18.8736 37.0436 19.3841V35.7794C37.0436 36.4461 36.503 36.9866 35.8364 36.9866ZM27.5186 35.1308H35.1938V20.315H27.5186V35.1308Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.6623 20.3149H26.5879C26.0775 20.3149 25.6631 19.9005 25.6631 19.39V13.4865C25.4889 13.3184 25.3808 13.0841 25.3808 12.8199C25.3808 12.3094 25.7952 11.895 26.3057 11.895H37.6623C38.3289 11.895 38.8694 12.4355 38.8694 13.1021V19.1078C38.8694 19.7744 38.3289 20.3149 37.6623 20.3149ZM27.5188 18.4592H37.0197V13.7447H27.5188V18.4592Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.0237 20.3149H8.94938C8.28276 20.3149 7.74225 19.7744 7.74225 19.1078V13.1022C7.74225 12.4355 8.28276 11.895 8.94938 11.895H20.306C20.8165 11.895 21.2309 12.3094 21.2309 12.8199C21.2309 13.0781 21.1228 13.3184 20.9486 13.4865V19.39C20.9486 19.9005 20.5342 20.3149 20.0237 20.3149ZM9.59798 18.4592H19.0989V13.7448H9.59798V18.4592Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.6091 13.7447H16.3784C14.1863 13.7447 12.0303 11.7569 12.0243 9.73297C12.0243 8.96425 12.2285 7.58897 13.5858 7.07849C14.907 6.58002 16.9429 7.12653 19.6454 8.70601C21.7654 9.94317 23.6271 11.4326 24.3058 12.2073C24.546 12.4835 24.6 12.8679 24.4499 13.2042C24.2998 13.5345 23.9695 13.7507 23.6031 13.7507M14.6548 8.76006C14.4806 8.76006 14.3425 8.78408 14.2344 8.82012C14.1383 8.85615 13.874 8.95825 13.874 9.73898C13.874 10.7479 15.2073 11.895 16.3724 11.895H21.0988C20.4201 11.3905 19.5974 10.838 18.7085 10.3155C16.7327 9.16244 15.3934 8.76006 14.6548 8.76006Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.2272 13.7448H22.9965C22.6361 13.7448 22.3058 13.5346 22.1497 13.1983C21.9996 12.8679 22.0536 12.4776 22.2938 12.2013C22.9665 11.4266 24.8342 9.9372 26.9542 8.70605C29.6567 7.13258 31.6926 6.58007 33.0138 7.07853C34.3711 7.58901 34.5753 8.95829 34.5753 9.73301C34.5753 11.7569 32.4193 13.7448 30.2212 13.7448M25.4948 11.889H30.2212C31.3863 11.889 32.7196 10.742 32.7196 9.73301C32.7196 8.95228 32.4613 8.85619 32.3592 8.82016C31.7947 8.60996 30.3233 8.89223 27.8851 10.3156C26.9902 10.838 26.1735 11.3906 25.4948 11.895V11.889Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.2816 36.9866H20.33C19.6514 36.9866 19.0928 36.4341 19.0928 35.7495V13.1263C19.0928 12.4417 19.6453 11.8892 20.33 11.8892H26.2816C26.9602 11.8892 27.5187 12.4417 27.5187 13.1263V35.7495C27.5187 36.4281 26.9662 36.9866 26.2816 36.9866ZM20.9486 35.1309H25.663V13.7449H20.9486V35.1309Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47 46H0.842224V92.1578H47V46Z",
                fill: "#C1D82F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.3439 80.9678H12.7076C11.2023 80.9678 9.97736 79.7425 9.97736 78.2367V59.9458C9.97736 58.44 11.2023 57.2147 12.7076 57.2147H26.3439C27.8492 57.2147 29.0741 58.44 29.0741 59.9458V63.9219C29.0741 64.3401 28.7346 64.6797 28.3165 64.6797C27.8984 64.6797 27.5589 64.3401 27.5589 63.9219V59.9458C27.5589 59.2766 27.0129 58.7353 26.3488 58.7353H12.7125C12.0435 58.7353 11.5023 59.2766 11.5023 59.9458V78.2367C11.5023 78.9059 12.0435 79.4472 12.7125 79.4472H26.3488C27.0178 79.4472 27.5589 78.9059 27.5589 78.2367V74.4722C27.5589 74.054 27.8984 73.7144 28.3165 73.7144C28.7346 73.7144 29.0741 74.054 29.0741 74.4722V78.2367C29.0741 79.7425 27.8492 80.9678 26.3439 80.9678Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.9811 62.6474H14.0603C13.6422 62.6474 13.3027 62.3079 13.3027 61.8896C13.3027 61.4713 13.6422 61.1268 14.0603 61.1268H24.9811C25.3993 61.1268 25.7387 61.4664 25.7387 61.8896C25.7387 62.3128 25.3993 62.6474 24.9811 62.6474Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.9312 67.4403H14.0603C13.6422 67.4403 13.3027 67.1007 13.3027 66.6825C13.3027 66.2642 13.6422 65.9246 14.0603 65.9246H21.9312C22.3493 65.9246 22.6888 66.2642 22.6888 66.6825C22.6888 67.1007 22.3493 67.4403 21.9312 67.4403Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.8132 72.2381H14.0653C13.6472 72.2381 13.3077 71.8985 13.3077 71.4803C13.3077 71.062 13.6472 70.7225 14.0653 70.7225H21.8132C22.2313 70.7225 22.5708 71.062 22.5708 71.4803C22.5708 71.8985 22.2313 72.2381 21.8132 72.2381Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.9811 77.0311H14.0603C13.6422 77.0311 13.3027 76.6915 13.3027 76.2732C13.3027 75.855 13.6422 75.5154 14.0603 75.5154H24.9811C25.3993 75.5154 25.7387 75.855 25.7387 76.2732C25.7387 76.6915 25.3993 77.0311 24.9811 77.0311Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.8971 80.3034C35.3707 80.3034 34.8738 80.0968 34.5049 79.7277L29.4331 74.6543C28.4099 75.1513 27.2588 75.3531 26.1224 75.23C24.7598 75.0824 23.4758 74.4673 22.5067 73.4979C21.3654 72.3562 20.7358 70.8357 20.7358 69.2167C20.7358 67.5978 21.3654 66.0772 22.5067 64.9356C23.648 63.7939 25.1681 63.1641 26.7865 63.1641C28.405 63.1641 29.9201 63.7939 31.0663 64.9356C32.0354 65.905 32.6503 67.1893 32.7979 68.5524C32.9209 69.6891 32.7192 70.8455 32.2223 71.8642L37.2941 76.9376C37.668 77.3116 37.8746 77.8036 37.8746 78.3351C37.8746 78.8666 37.668 79.3586 37.2941 79.7326C36.9203 80.1066 36.4283 80.3084 35.8971 80.3084M29.561 72.9566C29.7578 72.9566 29.9496 73.0304 30.0972 73.178L35.5724 78.655C35.656 78.7386 35.7692 78.7878 35.8921 78.7878C36.0151 78.7878 36.1283 78.7386 36.2119 78.655C36.2955 78.5713 36.3447 78.4581 36.3447 78.3351C36.3447 78.2121 36.2955 78.0989 36.2119 78.0152L30.7367 72.5383C30.4858 72.2874 30.4415 71.8986 30.6285 71.5984C31.1598 70.7422 31.391 69.7187 31.2778 68.7148C31.1647 67.6814 30.717 66.7464 29.9791 66.0083C29.1232 65.1521 27.9868 64.6797 26.7767 64.6797C25.5665 64.6797 24.4252 65.1521 23.5693 66.0083C22.7133 66.8645 22.2411 68.0013 22.2411 69.2118C22.2411 70.4223 22.7133 71.564 23.5693 72.4202C24.3072 73.1583 25.2419 73.6061 26.2749 73.7193C27.2784 73.8276 28.3017 73.5963 29.1576 73.0648C29.2806 72.991 29.4183 72.9517 29.5561 72.9517L29.561 72.9566Z",
                fill: "#E3EDA1"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/UniqueClientXSMobileImage.tsx

var UniqueClientXSMobileImage = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 93 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            borderRadius: "8px 0 0 8px",
            height: "100%",
            width: "100%",
            maxHeight: "93px",
            maxWidth: "32px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 0H0V32H32V0Z",
                fill: "#AA0E27"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.5359 25.7298H6.90987C6.44613 25.7298 6.07013 25.3538 6.07013 24.89V13.4846C6.07013 13.1295 6.3584 12.8412 6.71351 12.8412H13.3437C13.6988 12.8412 13.9871 13.1295 13.9871 13.4846V24.6185C14.1083 24.7355 14.1835 24.8984 14.1835 25.0822C14.1835 25.4373 13.8952 25.7298 13.5401 25.7298M7.36108 24.4388H12.7003V14.1322H7.36108V24.4388V24.4388Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.3438 25.7298H17.7178C17.3627 25.7298 17.0744 25.4415 17.0744 25.0822C17.0744 24.9026 17.1496 24.7396 17.2708 24.6185V13.4846C17.2708 13.1295 17.559 12.8412 17.9141 12.8412H24.5402C24.8953 12.8412 25.1835 13.1295 25.1835 13.4846V24.89C25.1835 25.3538 24.8075 25.7298 24.3438 25.7298ZM18.5575 24.4388H23.8968V14.1322H18.5575V24.4388Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.614 14.1321H17.9101C17.5549 14.1321 17.2667 13.8438 17.2667 13.4887V9.3819C17.1455 9.26492 17.0703 9.10199 17.0703 8.91816C17.0703 8.56305 17.3586 8.27478 17.7137 8.27478H25.614C26.0777 8.27478 26.4537 8.65078 26.4537 9.11452V13.2923C26.4537 13.7561 26.0777 14.1321 25.614 14.1321ZM18.5576 12.8411H25.1669V9.56155H18.5576V12.8411Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3437 14.1321H5.63979C5.17605 14.1321 4.80005 13.7561 4.80005 13.2923V9.11452C4.80005 8.65078 5.17605 8.27478 5.63979 8.27478H13.54C13.8952 8.27478 14.1834 8.56305 14.1834 8.91816C14.1834 9.09781 14.1082 9.26492 13.9871 9.3819V13.4887C13.9871 13.8438 13.6988 14.1321 13.3437 14.1321ZM6.09099 12.8411H12.7003V9.56155H6.09099V12.8411V12.8411Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.8379 9.56154H10.8078C9.28289 9.56154 7.78305 8.17868 7.77887 6.77075C7.77887 6.23599 7.92092 5.27927 8.8651 4.92416C9.78422 4.5774 11.2005 4.95758 13.0805 6.05635C14.5553 6.91698 15.8504 7.95308 16.3225 8.49201C16.4896 8.68419 16.5272 8.95158 16.4228 9.18553C16.3183 9.41531 16.0886 9.56571 15.8337 9.56571M9.60875 6.09395C9.4876 6.09395 9.39151 6.11066 9.31631 6.13573C9.24946 6.16079 9.06564 6.23182 9.06564 6.77493C9.06564 7.47681 9.99311 8.27477 10.8036 8.27477H14.0916C13.6195 7.92383 13.0471 7.53947 12.4288 7.176C11.0543 6.37386 10.1226 6.09395 9.60875 6.09395Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.4418 9.56157H15.4117C15.161 9.56157 14.9313 9.41535 14.8226 9.18139C14.7182 8.95161 14.7558 8.68005 14.9229 8.48787C15.3908 7.94894 16.6901 6.91284 18.1649 6.05638C20.0449 4.96179 21.4612 4.57744 22.3803 4.92419C23.3245 5.27931 23.4665 6.23185 23.4665 6.77079C23.4665 8.17872 21.9667 9.56157 20.4376 9.56157M17.1497 8.27063H20.4376C21.2481 8.27063 22.1756 7.47266 22.1756 6.77079C22.1756 6.22767 21.996 6.16083 21.9249 6.13576C21.5322 5.98954 20.5087 6.1859 18.8125 7.17604C18.19 7.53951 17.6218 7.92387 17.1497 8.27481V8.27063Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.697 25.7298H13.5567C13.0846 25.7298 12.6961 25.3455 12.6961 24.8692V9.13135C12.6961 8.65508 13.0805 8.27072 13.5567 8.27072H17.697C18.169 8.27072 18.5576 8.65508 18.5576 9.13135V24.8692C18.5576 25.3413 18.1732 25.7298 17.697 25.7298ZM13.9871 24.4389H17.2666V9.56167H13.9871V24.4389Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 32H0V64H32V32Z",
                fill: "#C1D82F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.6796 56.2422H8.22591C7.18232 56.2422 6.33313 55.3928 6.33313 54.3489V41.6683C6.33313 40.6243 7.18232 39.7749 8.22591 39.7749H17.6796C18.7232 39.7749 19.5724 40.6243 19.5724 41.6683V44.4248C19.5724 44.7147 19.3371 44.9501 19.0472 44.9501C18.7573 44.9501 18.522 44.7147 18.522 44.4248V41.6683C18.522 41.2043 18.1434 40.829 17.683 40.829H8.22932C7.76551 40.829 7.39036 41.2043 7.39036 41.6683V54.3489C7.39036 54.8128 7.76551 55.1881 8.22932 55.1881H17.683C18.1468 55.1881 18.522 54.8128 18.522 54.3489V51.739C18.522 51.4491 18.7573 51.2137 19.0472 51.2137C19.3371 51.2137 19.5724 51.4491 19.5724 51.739V54.3489C19.5724 55.3928 18.7232 56.2422 17.6796 56.2422Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.7348 43.5412H9.16369C8.87381 43.5412 8.63849 43.3058 8.63849 43.0158C8.63849 42.7259 8.87381 42.487 9.16369 42.487H16.7348C17.0247 42.487 17.26 42.7224 17.26 43.0158C17.26 43.3092 17.0247 43.5412 16.7348 43.5412Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6204 46.864H9.16369C8.87381 46.864 8.63849 46.6286 8.63849 46.3386C8.63849 46.0486 8.87381 45.8132 9.16369 45.8132H14.6204C14.9103 45.8132 15.1456 46.0486 15.1456 46.3386C15.1456 46.6286 14.9103 46.864 14.6204 46.864Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5386 50.1902H9.16717C8.87729 50.1902 8.64197 49.9548 8.64197 49.6648C8.64197 49.3748 8.87729 49.1394 9.16717 49.1394H14.5386C14.8285 49.1394 15.0638 49.3748 15.0638 49.6648C15.0638 49.9548 14.8285 50.1902 14.5386 50.1902Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.7348 53.513H9.16369C8.87381 53.513 8.63849 53.2776 8.63849 52.9877C8.63849 52.6977 8.87381 52.4623 9.16369 52.4623H16.7348C17.0247 52.4623 17.26 52.6977 17.26 52.9877C17.26 53.2776 17.0247 53.513 16.7348 53.513Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.3026 55.7817C23.9377 55.7817 23.5932 55.6384 23.3375 55.3825L19.8213 51.8653C19.1119 52.2098 18.3139 52.3497 17.5261 52.2644C16.5814 52.1621 15.6913 51.7356 15.0194 51.0636C14.2282 50.2721 13.7917 49.2179 13.7917 48.0955C13.7917 46.9732 14.2282 45.919 15.0194 45.1275C15.8107 44.3361 16.8645 43.8994 17.9865 43.8994C19.1085 43.8994 20.1589 44.3361 20.9536 45.1275C21.6254 45.7996 22.0517 46.69 22.154 47.635C22.2393 48.4231 22.0995 49.2248 21.755 49.9309L25.2712 53.4482C25.5304 53.7075 25.6736 54.0486 25.6736 54.4171C25.6736 54.7855 25.5304 55.1267 25.2712 55.386C25.012 55.6452 24.6709 55.7851 24.3026 55.7851M19.91 50.6883C20.0464 50.6883 20.1794 50.7395 20.2817 50.8418L24.0775 54.6388C24.1355 54.6968 24.2139 54.7309 24.2992 54.7309C24.3845 54.7309 24.4629 54.6968 24.5209 54.6388C24.5789 54.5808 24.613 54.5024 24.613 54.4171C24.613 54.3318 24.5789 54.2533 24.5209 54.1953L20.7251 50.3983C20.5511 50.2243 20.5204 49.9548 20.65 49.7467C21.0184 49.1531 21.1787 48.4435 21.1002 47.7476C21.0218 47.0312 20.7114 46.383 20.1999 45.8712C19.6065 45.2776 18.8186 44.9501 17.9797 44.9501C17.1407 44.9501 16.3495 45.2776 15.7561 45.8712C15.1627 46.4648 14.8353 47.2529 14.8353 48.0921C14.8353 48.9314 15.1627 49.7228 15.7561 50.3164C16.2677 50.8282 16.9156 51.1386 17.6318 51.2171C18.3275 51.2921 19.0369 51.1318 19.6303 50.7633C19.7156 50.7122 19.8111 50.6849 19.9066 50.6849L19.91 50.6883Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 65.436C1.06932 65.436 1.37773 65.1146 1.37773 64.718C1.37773 64.3215 1.06932 64 0.688866 64C0.308416 64 0 64.3215 0 64.718C0 65.1146 0.308416 65.436 0.688866 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 65.436C3.85362 65.436 4.16203 65.1146 4.16203 64.718C4.16203 64.3215 3.85362 64 3.47317 64C3.09272 64 2.7843 64.3215 2.7843 64.718C2.7843 65.1146 3.09272 65.436 3.47317 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 65.436C6.63762 65.436 6.94603 65.1146 6.94603 64.718C6.94603 64.3215 6.63762 64 6.25716 64C5.87671 64 5.5683 64.3215 5.5683 64.718C5.5683 65.1146 5.87671 65.436 6.25716 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 65.436C9.42192 65.436 9.73033 65.1146 9.73033 64.718C9.73033 64.3215 9.42192 64 9.04147 64C8.66102 64 8.3526 64.3215 8.3526 64.718C8.3526 65.1146 8.66102 65.436 9.04147 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 65.436C12.2024 65.436 12.5108 65.1146 12.5108 64.718C12.5108 64.3215 12.2024 64 11.822 64C11.4415 64 11.1331 64.3215 11.1331 64.718C11.1331 65.1146 11.4415 65.436 11.822 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 65.436C14.9867 65.436 15.2951 65.1146 15.2951 64.718C15.2951 64.3215 14.9867 64 14.6062 64C14.2258 64 13.9174 64.3215 13.9174 64.718C13.9174 65.1146 14.2258 65.436 14.6062 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 65.436C17.7707 65.436 18.0791 65.1146 18.0791 64.718C18.0791 64.3215 17.7707 64 17.3902 64C17.0098 64 16.7014 64.3215 16.7014 64.718C16.7014 65.1146 17.0098 65.436 17.3902 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1745 65.436C20.555 65.436 20.8634 65.1146 20.8634 64.718C20.8634 64.3215 20.555 64 20.1745 64C19.7941 64 19.4857 64.3215 19.4857 64.718C19.4857 65.1146 19.7941 65.436 20.1745 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 65.436C23.3392 65.436 23.6476 65.1146 23.6476 64.718C23.6476 64.3215 23.3392 64 22.9587 64C22.5783 64 22.2698 64.3215 22.2698 64.718C22.2698 65.1146 22.5783 65.436 22.9587 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 65.436C26.1233 65.436 26.4317 65.1146 26.4317 64.718C26.4317 64.3215 26.1233 64 25.7428 64C25.3624 64 25.054 64.3215 25.054 64.718C25.054 65.1146 25.3624 65.436 25.7428 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 65.436C28.9075 65.436 29.2159 65.1146 29.2159 64.718C29.2159 64.3215 28.9075 64 28.527 64C28.1466 64 27.8381 64.3215 27.8381 64.718C27.8381 65.1146 28.1466 65.436 28.527 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 65.436C31.6916 65.436 32 65.1146 32 64.718C32 64.3215 31.6916 64 31.3111 64C30.9307 64 30.6223 64.3215 30.6223 64.718C30.6223 65.1146 30.9307 65.436 31.3111 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 68.2146C1.06932 68.2146 1.37773 67.8931 1.37773 67.4966C1.37773 67.1001 1.06932 66.7786 0.688866 66.7786C0.308416 66.7786 0 67.1001 0 67.4966C0 67.8931 0.308416 68.2146 0.688866 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 68.2146C3.85362 68.2146 4.16203 67.8931 4.16203 67.4966C4.16203 67.1001 3.85362 66.7786 3.47317 66.7786C3.09272 66.7786 2.7843 67.1001 2.7843 67.4966C2.7843 67.8931 3.09272 68.2146 3.47317 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 68.2146C6.63762 68.2146 6.94603 67.8931 6.94603 67.4966C6.94603 67.1001 6.63762 66.7786 6.25716 66.7786C5.87671 66.7786 5.5683 67.1001 5.5683 67.4966C5.5683 67.8931 5.87671 68.2146 6.25716 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 68.2146C9.42192 68.2146 9.73033 67.8931 9.73033 67.4966C9.73033 67.1001 9.42192 66.7786 9.04147 66.7786C8.66102 66.7786 8.3526 67.1001 8.3526 67.4966C8.3526 67.8931 8.66102 68.2146 9.04147 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 68.2146C12.2024 68.2146 12.5108 67.8931 12.5108 67.4966C12.5108 67.1001 12.2024 66.7786 11.822 66.7786C11.4415 66.7786 11.1331 67.1001 11.1331 67.4966C11.1331 67.8931 11.4415 68.2146 11.822 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 68.2146C14.9867 68.2146 15.2951 67.8931 15.2951 67.4966C15.2951 67.1001 14.9867 66.7786 14.6062 66.7786C14.2258 66.7786 13.9174 67.1001 13.9174 67.4966C13.9174 67.8931 14.2258 68.2146 14.6062 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 68.2146C17.7707 68.2146 18.0791 67.8931 18.0791 67.4966C18.0791 67.1001 17.7707 66.7786 17.3902 66.7786C17.0098 66.7786 16.7014 67.1001 16.7014 67.4966C16.7014 67.8931 17.0098 68.2146 17.3902 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 68.2146C20.5549 68.2146 20.8633 67.8931 20.8633 67.4966C20.8633 67.1001 20.5549 66.7786 20.1744 66.7786C19.7939 66.7786 19.4855 67.1001 19.4855 67.4966C19.4855 67.8931 19.7939 68.2146 20.1744 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 68.2146C23.3392 68.2146 23.6476 67.8931 23.6476 67.4966C23.6476 67.1001 23.3392 66.7786 22.9587 66.7786C22.5783 66.7786 22.2698 67.1001 22.2698 67.4966C22.2698 67.8931 22.5783 68.2146 22.9587 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 68.2146C26.1233 68.2146 26.4317 67.8931 26.4317 67.4966C26.4317 67.1001 26.1233 66.7786 25.7428 66.7786C25.3624 66.7786 25.054 67.1001 25.054 67.4966C25.054 67.8931 25.3624 68.2146 25.7428 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 68.2146C28.9075 68.2146 29.2159 67.8931 29.2159 67.4966C29.2159 67.1001 28.9075 66.7786 28.527 66.7786C28.1466 66.7786 27.8381 67.1001 27.8381 67.4966C27.8381 67.8931 28.1466 68.2146 28.527 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 68.2146C31.6916 68.2146 32 67.8931 32 67.4966C32 67.1001 31.6916 66.7786 31.3111 66.7786C30.9307 66.7786 30.6223 67.1001 30.6223 67.4966C30.6223 67.8931 30.9307 68.2146 31.3111 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 70.9934C1.06932 70.9934 1.37773 70.6719 1.37773 70.2754C1.37773 69.8788 1.06932 69.5574 0.688866 69.5574C0.308416 69.5574 0 69.8788 0 70.2754C0 70.6719 0.308416 70.9934 0.688866 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 70.9934C3.85362 70.9934 4.16203 70.6719 4.16203 70.2754C4.16203 69.8788 3.85362 69.5574 3.47317 69.5574C3.09272 69.5574 2.7843 69.8788 2.7843 70.2754C2.7843 70.6719 3.09272 70.9934 3.47317 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 70.9934C6.63762 70.9934 6.94603 70.6719 6.94603 70.2754C6.94603 69.8788 6.63762 69.5574 6.25716 69.5574C5.87671 69.5574 5.5683 69.8788 5.5683 70.2754C5.5683 70.6719 5.87671 70.9934 6.25716 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 70.9934C9.42192 70.9934 9.73033 70.6719 9.73033 70.2754C9.73033 69.8788 9.42192 69.5574 9.04147 69.5574C8.66102 69.5574 8.3526 69.8788 8.3526 70.2754C8.3526 70.6719 8.66102 70.9934 9.04147 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 70.9934C12.2024 70.9934 12.5108 70.6719 12.5108 70.2754C12.5108 69.8788 12.2024 69.5574 11.822 69.5574C11.4415 69.5574 11.1331 69.8788 11.1331 70.2754C11.1331 70.6719 11.4415 70.9934 11.822 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 70.9934C14.9867 70.9934 15.2951 70.6719 15.2951 70.2754C15.2951 69.8788 14.9867 69.5574 14.6062 69.5574C14.2258 69.5574 13.9174 69.8788 13.9174 70.2754C13.9174 70.6719 14.2258 70.9934 14.6062 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 70.9934C17.7707 70.9934 18.0791 70.6719 18.0791 70.2754C18.0791 69.8788 17.7707 69.5574 17.3902 69.5574C17.0098 69.5574 16.7014 69.8788 16.7014 70.2754C16.7014 70.6719 17.0098 70.9934 17.3902 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 70.9934C20.5549 70.9934 20.8633 70.6719 20.8633 70.2754C20.8633 69.8788 20.5549 69.5574 20.1744 69.5574C19.7939 69.5574 19.4855 69.8788 19.4855 70.2754C19.4855 70.6719 19.7939 70.9934 20.1744 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 70.9934C23.3392 70.9934 23.6476 70.6719 23.6476 70.2754C23.6476 69.8788 23.3392 69.5574 22.9587 69.5574C22.5783 69.5574 22.2698 69.8788 22.2698 70.2754C22.2698 70.6719 22.5783 70.9934 22.9587 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 70.9934C26.1233 70.9934 26.4317 70.6719 26.4317 70.2754C26.4317 69.8788 26.1233 69.5574 25.7428 69.5574C25.3624 69.5574 25.054 69.8788 25.054 70.2754C25.054 70.6719 25.3624 70.9934 25.7428 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 70.9934C28.9075 70.9934 29.2159 70.6719 29.2159 70.2754C29.2159 69.8788 28.9075 69.5574 28.527 69.5574C28.1466 69.5574 27.8381 69.8788 27.8381 70.2754C27.8381 70.6719 28.1466 70.9934 28.527 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 70.9934C31.6916 70.9934 32 70.6719 32 70.2754C32 69.8788 31.6916 69.5574 31.3111 69.5574C30.9307 69.5574 30.6223 69.8788 30.6223 70.2754C30.6223 70.6719 30.9307 70.9934 31.3111 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 73.7716C1.06932 73.7716 1.37773 73.4501 1.37773 73.0536C1.37773 72.657 1.06932 72.3356 0.688866 72.3356C0.308416 72.3356 0 72.657 0 73.0536C0 73.4501 0.308416 73.7716 0.688866 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 73.7716C3.85362 73.7716 4.16203 73.4501 4.16203 73.0536C4.16203 72.657 3.85362 72.3356 3.47317 72.3356C3.09272 72.3356 2.7843 72.657 2.7843 73.0536C2.7843 73.4501 3.09272 73.7716 3.47317 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 73.7716C6.63762 73.7716 6.94603 73.4501 6.94603 73.0536C6.94603 72.657 6.63762 72.3356 6.25716 72.3356C5.87671 72.3356 5.5683 72.657 5.5683 73.0536C5.5683 73.4501 5.87671 73.7716 6.25716 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 73.7716C9.42192 73.7716 9.73033 73.4501 9.73033 73.0536C9.73033 72.657 9.42192 72.3356 9.04147 72.3356C8.66102 72.3356 8.3526 72.657 8.3526 73.0536C8.3526 73.4501 8.66102 73.7716 9.04147 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 73.7716C12.2024 73.7716 12.5108 73.4501 12.5108 73.0536C12.5108 72.657 12.2024 72.3356 11.822 72.3356C11.4415 72.3356 11.1331 72.657 11.1331 73.0536C11.1331 73.4501 11.4415 73.7716 11.822 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 73.7716C14.9867 73.7716 15.2951 73.4501 15.2951 73.0536C15.2951 72.657 14.9867 72.3356 14.6062 72.3356C14.2258 72.3356 13.9174 72.657 13.9174 73.0536C13.9174 73.4501 14.2258 73.7716 14.6062 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 73.7716C17.7707 73.7716 18.0791 73.4501 18.0791 73.0536C18.0791 72.657 17.7707 72.3356 17.3902 72.3356C17.0098 72.3356 16.7014 72.657 16.7014 73.0536C16.7014 73.4501 17.0098 73.7716 17.3902 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 73.7716C20.5549 73.7716 20.8633 73.4501 20.8633 73.0536C20.8633 72.657 20.5549 72.3356 20.1744 72.3356C19.7939 72.3356 19.4855 72.657 19.4855 73.0536C19.4855 73.4501 19.7939 73.7716 20.1744 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 73.7716C23.3392 73.7716 23.6476 73.4501 23.6476 73.0536C23.6476 72.657 23.3392 72.3356 22.9587 72.3356C22.5783 72.3356 22.2698 72.657 22.2698 73.0536C22.2698 73.4501 22.5783 73.7716 22.9587 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 73.7716C26.1233 73.7716 26.4317 73.4501 26.4317 73.0536C26.4317 72.657 26.1233 72.3356 25.7428 72.3356C25.3624 72.3356 25.054 72.657 25.054 73.0536C25.054 73.4501 25.3624 73.7716 25.7428 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 73.7716C28.9075 73.7716 29.2159 73.4501 29.2159 73.0536C29.2159 72.657 28.9075 72.3356 28.527 72.3356C28.1466 72.3356 27.8381 72.657 27.8381 73.0536C27.8381 73.4501 28.1466 73.7716 28.527 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 73.7716C31.6916 73.7716 32 73.4501 32 73.0536C32 72.657 31.6916 72.3356 31.3111 72.3356C30.9307 72.3356 30.6223 72.657 30.6223 73.0536C30.6223 73.4501 30.9307 73.7716 31.3111 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 76.5503C1.06932 76.5503 1.37773 76.2288 1.37773 75.8323C1.37773 75.4357 1.06932 75.1143 0.688866 75.1143C0.308416 75.1143 0 75.4357 0 75.8323C0 76.2288 0.308416 76.5503 0.688866 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 76.5503C3.85362 76.5503 4.16203 76.2288 4.16203 75.8323C4.16203 75.4357 3.85362 75.1143 3.47317 75.1143C3.09272 75.1143 2.7843 75.4357 2.7843 75.8323C2.7843 76.2288 3.09272 76.5503 3.47317 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 76.5503C6.63762 76.5503 6.94603 76.2288 6.94603 75.8323C6.94603 75.4357 6.63762 75.1143 6.25716 75.1143C5.87671 75.1143 5.5683 75.4357 5.5683 75.8323C5.5683 76.2288 5.87671 76.5503 6.25716 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 76.5503C9.42192 76.5503 9.73033 76.2288 9.73033 75.8323C9.73033 75.4357 9.42192 75.1143 9.04147 75.1143C8.66102 75.1143 8.3526 75.4357 8.3526 75.8323C8.3526 76.2288 8.66102 76.5503 9.04147 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 76.5503C12.2024 76.5503 12.5108 76.2288 12.5108 75.8323C12.5108 75.4357 12.2024 75.1143 11.822 75.1143C11.4415 75.1143 11.1331 75.4357 11.1331 75.8323C11.1331 76.2288 11.4415 76.5503 11.822 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 76.5503C14.9867 76.5503 15.2951 76.2288 15.2951 75.8323C15.2951 75.4357 14.9867 75.1143 14.6062 75.1143C14.2258 75.1143 13.9174 75.4357 13.9174 75.8323C13.9174 76.2288 14.2258 76.5503 14.6062 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 76.5503C17.7707 76.5503 18.0791 76.2288 18.0791 75.8323C18.0791 75.4357 17.7707 75.1143 17.3902 75.1143C17.0098 75.1143 16.7014 75.4357 16.7014 75.8323C16.7014 76.2288 17.0098 76.5503 17.3902 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 76.5503C20.5549 76.5503 20.8633 76.2288 20.8633 75.8323C20.8633 75.4357 20.5549 75.1143 20.1744 75.1143C19.7939 75.1143 19.4855 75.4357 19.4855 75.8323C19.4855 76.2288 19.7939 76.5503 20.1744 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 76.5503C23.3392 76.5503 23.6476 76.2288 23.6476 75.8323C23.6476 75.4357 23.3392 75.1143 22.9587 75.1143C22.5783 75.1143 22.2698 75.4357 22.2698 75.8323C22.2698 76.2288 22.5783 76.5503 22.9587 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 76.5503C26.1233 76.5503 26.4317 76.2288 26.4317 75.8323C26.4317 75.4357 26.1233 75.1143 25.7428 75.1143C25.3624 75.1143 25.054 75.4357 25.054 75.8323C25.054 76.2288 25.3624 76.5503 25.7428 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 76.5503C28.9075 76.5503 29.2159 76.2288 29.2159 75.8323C29.2159 75.4357 28.9075 75.1143 28.527 75.1143C28.1466 75.1143 27.8381 75.4357 27.8381 75.8323C27.8381 76.2288 28.1466 76.5503 28.527 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 76.5503C31.6916 76.5503 32 76.2288 32 75.8323C32 75.4357 31.6916 75.1143 31.3111 75.1143C30.9307 75.1143 30.6223 75.4357 30.6223 75.8323C30.6223 76.2288 30.9307 76.5503 31.3111 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 79.3285C1.06932 79.3285 1.37773 79.007 1.37773 78.6105C1.37773 78.2139 1.06932 77.8925 0.688866 77.8925C0.308416 77.8925 0 78.2139 0 78.6105C0 79.007 0.308416 79.3285 0.688866 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 79.3285C3.85362 79.3285 4.16203 79.007 4.16203 78.6105C4.16203 78.2139 3.85362 77.8925 3.47317 77.8925C3.09272 77.8925 2.7843 78.2139 2.7843 78.6105C2.7843 79.007 3.09272 79.3285 3.47317 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 79.3285C6.63762 79.3285 6.94603 79.007 6.94603 78.6105C6.94603 78.2139 6.63762 77.8925 6.25716 77.8925C5.87671 77.8925 5.5683 78.2139 5.5683 78.6105C5.5683 79.007 5.87671 79.3285 6.25716 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 79.3285C9.42192 79.3285 9.73033 79.007 9.73033 78.6105C9.73033 78.2139 9.42192 77.8925 9.04147 77.8925C8.66102 77.8925 8.3526 78.2139 8.3526 78.6105C8.3526 79.007 8.66102 79.3285 9.04147 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 79.3285C12.2024 79.3285 12.5108 79.007 12.5108 78.6105C12.5108 78.2139 12.2024 77.8925 11.822 77.8925C11.4415 77.8925 11.1331 78.2139 11.1331 78.6105C11.1331 79.007 11.4415 79.3285 11.822 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 79.3285C14.9867 79.3285 15.2951 79.007 15.2951 78.6105C15.2951 78.2139 14.9867 77.8925 14.6062 77.8925C14.2258 77.8925 13.9174 78.2139 13.9174 78.6105C13.9174 79.007 14.2258 79.3285 14.6062 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 79.3285C17.7707 79.3285 18.0791 79.007 18.0791 78.6105C18.0791 78.2139 17.7707 77.8925 17.3902 77.8925C17.0098 77.8925 16.7014 78.2139 16.7014 78.6105C16.7014 79.007 17.0098 79.3285 17.3902 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 79.3285C20.5549 79.3285 20.8633 79.007 20.8633 78.6105C20.8633 78.2139 20.5549 77.8925 20.1744 77.8925C19.7939 77.8925 19.4855 78.2139 19.4855 78.6105C19.4855 79.007 19.7939 79.3285 20.1744 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 79.3285C23.3392 79.3285 23.6476 79.007 23.6476 78.6105C23.6476 78.2139 23.3392 77.8925 22.9587 77.8925C22.5783 77.8925 22.2698 78.2139 22.2698 78.6105C22.2698 79.007 22.5783 79.3285 22.9587 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 79.3285C26.1233 79.3285 26.4317 79.007 26.4317 78.6105C26.4317 78.2139 26.1233 77.8925 25.7428 77.8925C25.3624 77.8925 25.054 78.2139 25.054 78.6105C25.054 79.007 25.3624 79.3285 25.7428 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 79.3285C28.9075 79.3285 29.2159 79.007 29.2159 78.6105C29.2159 78.2139 28.9075 77.8925 28.527 77.8925C28.1466 77.8925 27.8381 78.2139 27.8381 78.6105C27.8381 79.007 28.1466 79.3285 28.527 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 79.3285C31.6916 79.3285 32 79.007 32 78.6105C32 78.2139 31.6916 77.8925 31.3111 77.8925C30.9307 77.8925 30.6223 78.2139 30.6223 78.6105C30.6223 79.007 30.9307 79.3285 31.3111 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 82.1071C1.06932 82.1071 1.37773 81.7856 1.37773 81.3891C1.37773 80.9925 1.06932 80.6711 0.688866 80.6711C0.308416 80.6711 0 80.9925 0 81.3891C0 81.7856 0.308416 82.1071 0.688866 82.1071Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 82.1071C3.85362 82.1071 4.16203 81.7856 4.16203 81.3891C4.16203 80.9925 3.85362 80.6711 3.47317 80.6711C3.09272 80.6711 2.7843 80.9925 2.7843 81.3891C2.7843 81.7856 3.09272 82.1071 3.47317 82.1071Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 82.1071C6.63762 82.1071 6.94603 81.7856 6.94603 81.3891C6.94603 80.9925 6.63762 80.6711 6.25716 80.6711C5.87671 80.6711 5.5683 80.9925 5.5683 81.3891C5.5683 81.7856 5.87671 82.1071 6.25716 82.1071Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 82.1071C9.42192 82.1071 9.73033 81.7856 9.73033 81.3891C9.73033 80.9925 9.42192 80.6711 9.04147 80.6711C8.66102 80.6711 8.3526 80.9925 8.3526 81.3891C8.3526 81.7856 8.66102 82.1071 9.04147 82.1071Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 82.1071C12.2024 82.1071 12.5108 81.7856 12.5108 81.3891C12.5108 80.9925 12.2024 80.6711 11.822 80.6711C11.4415 80.6711 11.1331 80.9925 11.1331 81.3891C11.1331 81.7856 11.4415 82.1071 11.822 82.1071Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 82.1071C14.9867 82.1071 15.2951 81.7856 15.2951 81.3891C15.2951 80.9925 14.9867 80.6711 14.6062 80.6711C14.2258 80.6711 13.9174 80.9925 13.9174 81.3891C13.9174 81.7856 14.2258 82.1071 14.6062 82.1071Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 82.1071C17.7707 82.1071 18.0791 81.7856 18.0791 81.3891C18.0791 80.9925 17.7707 80.6711 17.3902 80.6711C17.0098 80.6711 16.7014 80.9925 16.7014 81.3891C16.7014 81.7856 17.0098 82.1071 17.3902 82.1071Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 82.1071C20.5549 82.1071 20.8633 81.7856 20.8633 81.3891C20.8633 80.9925 20.5549 80.6711 20.1744 80.6711C19.7939 80.6711 19.4855 80.9925 19.4855 81.3891C19.4855 81.7856 19.7939 82.1071 20.1744 82.1071Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 82.1071C23.3392 82.1071 23.6476 81.7856 23.6476 81.3891C23.6476 80.9925 23.3392 80.6711 22.9587 80.6711C22.5783 80.6711 22.2698 80.9925 22.2698 81.3891C22.2698 81.7856 22.5783 82.1071 22.9587 82.1071Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 82.1071C26.1233 82.1071 26.4317 81.7856 26.4317 81.3891C26.4317 80.9925 26.1233 80.6711 25.7428 80.6711C25.3624 80.6711 25.054 80.9925 25.054 81.3891C25.054 81.7856 25.3624 82.1071 25.7428 82.1071Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 82.1071C28.9075 82.1071 29.2159 81.7856 29.2159 81.3891C29.2159 80.9925 28.9075 80.6711 28.527 80.6711C28.1466 80.6711 27.8381 80.9925 27.8381 81.3891C27.8381 81.7856 28.1466 82.1071 28.527 82.1071Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 82.1071C31.6916 82.1071 32 81.7856 32 81.3891C32 80.9925 31.6916 80.6711 31.3111 80.6711C30.9307 80.6711 30.6223 80.9925 30.6223 81.3891C30.6223 81.7856 30.9307 82.1071 31.3111 82.1071Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 84.8857C1.06932 84.8857 1.37773 84.5642 1.37773 84.1677C1.37773 83.7711 1.06932 83.4497 0.688866 83.4497C0.308416 83.4497 0 83.7711 0 84.1677C0 84.5642 0.308416 84.8857 0.688866 84.8857Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 84.8857C3.85362 84.8857 4.16203 84.5642 4.16203 84.1677C4.16203 83.7711 3.85362 83.4497 3.47317 83.4497C3.09272 83.4497 2.7843 83.7711 2.7843 84.1677C2.7843 84.5642 3.09272 84.8857 3.47317 84.8857Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 84.8857C6.63762 84.8857 6.94603 84.5642 6.94603 84.1677C6.94603 83.7711 6.63762 83.4497 6.25716 83.4497C5.87671 83.4497 5.5683 83.7711 5.5683 84.1677C5.5683 84.5642 5.87671 84.8857 6.25716 84.8857Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 84.8857C9.42192 84.8857 9.73033 84.5642 9.73033 84.1677C9.73033 83.7711 9.42192 83.4497 9.04147 83.4497C8.66102 83.4497 8.3526 83.7711 8.3526 84.1677C8.3526 84.5642 8.66102 84.8857 9.04147 84.8857Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 84.8857C12.2024 84.8857 12.5108 84.5642 12.5108 84.1677C12.5108 83.7711 12.2024 83.4497 11.822 83.4497C11.4415 83.4497 11.1331 83.7711 11.1331 84.1677C11.1331 84.5642 11.4415 84.8857 11.822 84.8857Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 84.8857C14.9867 84.8857 15.2951 84.5642 15.2951 84.1677C15.2951 83.7711 14.9867 83.4497 14.6062 83.4497C14.2258 83.4497 13.9174 83.7711 13.9174 84.1677C13.9174 84.5642 14.2258 84.8857 14.6062 84.8857Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 84.8857C17.7707 84.8857 18.0791 84.5642 18.0791 84.1677C18.0791 83.7711 17.7707 83.4497 17.3902 83.4497C17.0098 83.4497 16.7014 83.7711 16.7014 84.1677C16.7014 84.5642 17.0098 84.8857 17.3902 84.8857Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 84.8857C20.5549 84.8857 20.8633 84.5642 20.8633 84.1677C20.8633 83.7711 20.5549 83.4497 20.1744 83.4497C19.7939 83.4497 19.4855 83.7711 19.4855 84.1677C19.4855 84.5642 19.7939 84.8857 20.1744 84.8857Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 84.8857C23.3392 84.8857 23.6476 84.5642 23.6476 84.1677C23.6476 83.7711 23.3392 83.4497 22.9587 83.4497C22.5783 83.4497 22.2698 83.7711 22.2698 84.1677C22.2698 84.5642 22.5783 84.8857 22.9587 84.8857Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 84.8857C26.1233 84.8857 26.4317 84.5642 26.4317 84.1677C26.4317 83.7711 26.1233 83.4497 25.7428 83.4497C25.3624 83.4497 25.054 83.7711 25.054 84.1677C25.054 84.5642 25.3624 84.8857 25.7428 84.8857Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 84.8857C28.9075 84.8857 29.2159 84.5642 29.2159 84.1677C29.2159 83.7711 28.9075 83.4497 28.527 83.4497C28.1466 83.4497 27.8381 83.7711 27.8381 84.1677C27.8381 84.5642 28.1466 84.8857 28.527 84.8857Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 84.8857C31.6916 84.8857 32 84.5642 32 84.1677C32 83.7711 31.6916 83.4497 31.3111 83.4497C30.9307 83.4497 30.6223 83.7711 30.6223 84.1677C30.6223 84.5642 30.9307 84.8857 31.3111 84.8857Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 87.6644C1.06932 87.6644 1.37773 87.343 1.37773 86.9464C1.37773 86.5499 1.06932 86.2284 0.688866 86.2284C0.308416 86.2284 0 86.5499 0 86.9464C0 87.343 0.308416 87.6644 0.688866 87.6644Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 87.6644C3.85362 87.6644 4.16203 87.343 4.16203 86.9464C4.16203 86.5499 3.85362 86.2284 3.47317 86.2284C3.09272 86.2284 2.7843 86.5499 2.7843 86.9464C2.7843 87.343 3.09272 87.6644 3.47317 87.6644Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 87.6644C6.63762 87.6644 6.94603 87.343 6.94603 86.9464C6.94603 86.5499 6.63762 86.2284 6.25716 86.2284C5.87671 86.2284 5.5683 86.5499 5.5683 86.9464C5.5683 87.343 5.87671 87.6644 6.25716 87.6644Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 87.6644C9.42192 87.6644 9.73033 87.343 9.73033 86.9464C9.73033 86.5499 9.42192 86.2284 9.04147 86.2284C8.66102 86.2284 8.3526 86.5499 8.3526 86.9464C8.3526 87.343 8.66102 87.6644 9.04147 87.6644Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 87.6644C12.2024 87.6644 12.5108 87.343 12.5108 86.9464C12.5108 86.5499 12.2024 86.2284 11.822 86.2284C11.4415 86.2284 11.1331 86.5499 11.1331 86.9464C11.1331 87.343 11.4415 87.6644 11.822 87.6644Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 87.6644C14.9867 87.6644 15.2951 87.343 15.2951 86.9464C15.2951 86.5499 14.9867 86.2284 14.6062 86.2284C14.2258 86.2284 13.9174 86.5499 13.9174 86.9464C13.9174 87.343 14.2258 87.6644 14.6062 87.6644Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 87.6644C17.7707 87.6644 18.0791 87.343 18.0791 86.9464C18.0791 86.5499 17.7707 86.2284 17.3902 86.2284C17.0098 86.2284 16.7014 86.5499 16.7014 86.9464C16.7014 87.343 17.0098 87.6644 17.3902 87.6644Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 87.6644C20.5549 87.6644 20.8633 87.343 20.8633 86.9464C20.8633 86.5499 20.5549 86.2284 20.1744 86.2284C19.7939 86.2284 19.4855 86.5499 19.4855 86.9464C19.4855 87.343 19.7939 87.6644 20.1744 87.6644Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 87.6644C23.3392 87.6644 23.6476 87.343 23.6476 86.9464C23.6476 86.5499 23.3392 86.2284 22.9587 86.2284C22.5783 86.2284 22.2698 86.5499 22.2698 86.9464C22.2698 87.343 22.5783 87.6644 22.9587 87.6644Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 87.6644C26.1233 87.6644 26.4317 87.343 26.4317 86.9464C26.4317 86.5499 26.1233 86.2284 25.7428 86.2284C25.3624 86.2284 25.054 86.5499 25.054 86.9464C25.054 87.343 25.3624 87.6644 25.7428 87.6644Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 87.6644C28.9075 87.6644 29.2159 87.343 29.2159 86.9464C29.2159 86.5499 28.9075 86.2284 28.527 86.2284C28.1466 86.2284 27.8381 86.5499 27.8381 86.9464C27.8381 87.343 28.1466 87.6644 28.527 87.6644Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 87.6644C31.6916 87.6644 32 87.343 32 86.9464C32 86.5499 31.6916 86.2284 31.3111 86.2284C30.9307 86.2284 30.6223 86.5499 30.6223 86.9464C30.6223 87.343 30.9307 87.6644 31.3111 87.6644Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 90.4431C1.06932 90.4431 1.37773 90.1217 1.37773 89.7251C1.37773 89.3286 1.06932 89.0071 0.688866 89.0071C0.308416 89.0071 0 89.3286 0 89.7251C0 90.1217 0.308416 90.4431 0.688866 90.4431Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 90.4431C3.85362 90.4431 4.16203 90.1217 4.16203 89.7251C4.16203 89.3286 3.85362 89.0071 3.47317 89.0071C3.09272 89.0071 2.7843 89.3286 2.7843 89.7251C2.7843 90.1217 3.09272 90.4431 3.47317 90.4431Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 90.4431C6.63762 90.4431 6.94603 90.1217 6.94603 89.7251C6.94603 89.3286 6.63762 89.0071 6.25716 89.0071C5.87671 89.0071 5.5683 89.3286 5.5683 89.7251C5.5683 90.1217 5.87671 90.4431 6.25716 90.4431Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 90.4431C9.42192 90.4431 9.73033 90.1217 9.73033 89.7251C9.73033 89.3286 9.42192 89.0071 9.04147 89.0071C8.66102 89.0071 8.3526 89.3286 8.3526 89.7251C8.3526 90.1217 8.66102 90.4431 9.04147 90.4431Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 90.4431C12.2024 90.4431 12.5108 90.1217 12.5108 89.7251C12.5108 89.3286 12.2024 89.0071 11.822 89.0071C11.4415 89.0071 11.1331 89.3286 11.1331 89.7251C11.1331 90.1217 11.4415 90.4431 11.822 90.4431Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 90.4431C14.9867 90.4431 15.2951 90.1217 15.2951 89.7251C15.2951 89.3286 14.9867 89.0071 14.6062 89.0071C14.2258 89.0071 13.9174 89.3286 13.9174 89.7251C13.9174 90.1217 14.2258 90.4431 14.6062 90.4431Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 90.4431C17.7707 90.4431 18.0791 90.1217 18.0791 89.7251C18.0791 89.3286 17.7707 89.0071 17.3902 89.0071C17.0098 89.0071 16.7014 89.3286 16.7014 89.7251C16.7014 90.1217 17.0098 90.4431 17.3902 90.4431Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 90.4431C20.5549 90.4431 20.8633 90.1217 20.8633 89.7251C20.8633 89.3286 20.5549 89.0071 20.1744 89.0071C19.7939 89.0071 19.4855 89.3286 19.4855 89.7251C19.4855 90.1217 19.7939 90.4431 20.1744 90.4431Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 90.4431C23.3392 90.4431 23.6476 90.1217 23.6476 89.7251C23.6476 89.3286 23.3392 89.0071 22.9587 89.0071C22.5783 89.0071 22.2698 89.3286 22.2698 89.7251C22.2698 90.1217 22.5783 90.4431 22.9587 90.4431Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 90.4431C26.1233 90.4431 26.4317 90.1217 26.4317 89.7251C26.4317 89.3286 26.1233 89.0071 25.7428 89.0071C25.3624 89.0071 25.054 89.3286 25.054 89.7251C25.054 90.1217 25.3624 90.4431 25.7428 90.4431Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 90.4431C28.9075 90.4431 29.2159 90.1217 29.2159 89.7251C29.2159 89.3286 28.9075 89.0071 28.527 89.0071C28.1466 89.0071 27.8381 89.3286 27.8381 89.7251C27.8381 90.1217 28.1466 90.4431 28.527 90.4431Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 90.4431C31.6916 90.4431 32 90.1217 32 89.7251C32 89.3286 31.6916 89.0071 31.3111 89.0071C30.9307 89.0071 30.6223 89.3286 30.6223 89.7251C30.6223 90.1217 30.9307 90.4431 31.3111 90.4431Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 93.2213C1.06932 93.2213 1.37773 92.8999 1.37773 92.5033C1.37773 92.1068 1.06932 91.7853 0.688866 91.7853C0.308416 91.7853 0 92.1068 0 92.5033C0 92.8999 0.308416 93.2213 0.688866 93.2213Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 93.2213C3.85362 93.2213 4.16203 92.8999 4.16203 92.5033C4.16203 92.1068 3.85362 91.7853 3.47317 91.7853C3.09272 91.7853 2.7843 92.1068 2.7843 92.5033C2.7843 92.8999 3.09272 93.2213 3.47317 93.2213Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 93.2213C6.63762 93.2213 6.94603 92.8999 6.94603 92.5033C6.94603 92.1068 6.63762 91.7853 6.25716 91.7853C5.87671 91.7853 5.5683 92.1068 5.5683 92.5033C5.5683 92.8999 5.87671 93.2213 6.25716 93.2213Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 93.2213C9.42192 93.2213 9.73033 92.8999 9.73033 92.5033C9.73033 92.1068 9.42192 91.7853 9.04147 91.7853C8.66102 91.7853 8.3526 92.1068 8.3526 92.5033C8.3526 92.8999 8.66102 93.2213 9.04147 93.2213Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 93.2213C12.2024 93.2213 12.5108 92.8999 12.5108 92.5033C12.5108 92.1068 12.2024 91.7853 11.822 91.7853C11.4415 91.7853 11.1331 92.1068 11.1331 92.5033C11.1331 92.8999 11.4415 93.2213 11.822 93.2213Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 93.2213C14.9867 93.2213 15.2951 92.8999 15.2951 92.5033C15.2951 92.1068 14.9867 91.7853 14.6062 91.7853C14.2258 91.7853 13.9174 92.1068 13.9174 92.5033C13.9174 92.8999 14.2258 93.2213 14.6062 93.2213Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 93.2213C17.7707 93.2213 18.0791 92.8999 18.0791 92.5033C18.0791 92.1068 17.7707 91.7853 17.3902 91.7853C17.0098 91.7853 16.7014 92.1068 16.7014 92.5033C16.7014 92.8999 17.0098 93.2213 17.3902 93.2213Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 93.2213C20.5549 93.2213 20.8633 92.8999 20.8633 92.5033C20.8633 92.1068 20.5549 91.7853 20.1744 91.7853C19.7939 91.7853 19.4855 92.1068 19.4855 92.5033C19.4855 92.8999 19.7939 93.2213 20.1744 93.2213Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 93.2213C23.3392 93.2213 23.6476 92.8999 23.6476 92.5033C23.6476 92.1068 23.3392 91.7853 22.9587 91.7853C22.5783 91.7853 22.2698 92.1068 22.2698 92.5033C22.2698 92.8999 22.5783 93.2213 22.9587 93.2213Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 93.2213C26.1233 93.2213 26.4317 92.8999 26.4317 92.5033C26.4317 92.1068 26.1233 91.7853 25.7428 91.7853C25.3624 91.7853 25.054 92.1068 25.054 92.5033C25.054 92.8999 25.3624 93.2213 25.7428 93.2213Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 93.2213C28.9075 93.2213 29.2159 92.8999 29.2159 92.5033C29.2159 92.1068 28.9075 91.7853 28.527 91.7853C28.1466 91.7853 27.8381 92.1068 27.8381 92.5033C27.8381 92.8999 28.1466 93.2213 28.527 93.2213Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 93.2213C31.6916 93.2213 32 92.8999 32 92.5033C32 92.1068 31.6916 91.7853 31.3111 91.7853C30.9307 91.7853 30.6223 92.1068 30.6223 92.5033C30.6223 92.8999 30.9307 93.2213 31.3111 93.2213Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 96.0001C1.06932 96.0001 1.37773 95.6786 1.37773 95.2821C1.37773 94.8855 1.06932 94.5641 0.688866 94.5641C0.308416 94.5641 0 94.8855 0 95.2821C0 95.6786 0.308416 96.0001 0.688866 96.0001Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 96.0001C3.85362 96.0001 4.16203 95.6786 4.16203 95.2821C4.16203 94.8855 3.85362 94.5641 3.47317 94.5641C3.09272 94.5641 2.7843 94.8855 2.7843 95.2821C2.7843 95.6786 3.09272 96.0001 3.47317 96.0001Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 96.0001C6.63762 96.0001 6.94603 95.6786 6.94603 95.2821C6.94603 94.8855 6.63762 94.5641 6.25716 94.5641C5.87671 94.5641 5.5683 94.8855 5.5683 95.2821C5.5683 95.6786 5.87671 96.0001 6.25716 96.0001Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 96.0001C9.42192 96.0001 9.73033 95.6786 9.73033 95.2821C9.73033 94.8855 9.42192 94.5641 9.04147 94.5641C8.66102 94.5641 8.3526 94.8855 8.3526 95.2821C8.3526 95.6786 8.66102 96.0001 9.04147 96.0001Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 96.0001C12.2024 96.0001 12.5108 95.6786 12.5108 95.2821C12.5108 94.8855 12.2024 94.5641 11.822 94.5641C11.4415 94.5641 11.1331 94.8855 11.1331 95.2821C11.1331 95.6786 11.4415 96.0001 11.822 96.0001Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 96.0001C14.9867 96.0001 15.2951 95.6786 15.2951 95.2821C15.2951 94.8855 14.9867 94.5641 14.6062 94.5641C14.2258 94.5641 13.9174 94.8855 13.9174 95.2821C13.9174 95.6786 14.2258 96.0001 14.6062 96.0001Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 96.0001C17.7707 96.0001 18.0791 95.6786 18.0791 95.2821C18.0791 94.8855 17.7707 94.5641 17.3902 94.5641C17.0098 94.5641 16.7014 94.8855 16.7014 95.2821C16.7014 95.6786 17.0098 96.0001 17.3902 96.0001Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 96.0001C20.5549 96.0001 20.8633 95.6786 20.8633 95.2821C20.8633 94.8855 20.5549 94.5641 20.1744 94.5641C19.7939 94.5641 19.4855 94.8855 19.4855 95.2821C19.4855 95.6786 19.7939 96.0001 20.1744 96.0001Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 96.0001C23.3392 96.0001 23.6476 95.6786 23.6476 95.2821C23.6476 94.8855 23.3392 94.5641 22.9587 94.5641C22.5783 94.5641 22.2698 94.8855 22.2698 95.2821C22.2698 95.6786 22.5783 96.0001 22.9587 96.0001Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 96.0001C26.1233 96.0001 26.4317 95.6786 26.4317 95.2821C26.4317 94.8855 26.1233 94.5641 25.7428 94.5641C25.3624 94.5641 25.054 94.8855 25.054 95.2821C25.054 95.6786 25.3624 96.0001 25.7428 96.0001Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 96.0001C28.9075 96.0001 29.2159 95.6786 29.2159 95.2821C29.2159 94.8855 28.9075 94.5641 28.527 94.5641C28.1466 94.5641 27.8381 94.8855 27.8381 95.2821C27.8381 95.6786 28.1466 96.0001 28.527 96.0001Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 96.0001C31.6916 96.0001 32 95.6786 32 95.2821C32 94.8855 31.6916 94.5641 31.3111 94.5641C30.9307 94.5641 30.6223 94.8855 30.6223 95.2821C30.6223 95.6786 30.9307 96.0001 31.3111 96.0001Z",
                fill: "#E5E6E6"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/UniqueClientXSMobileInfo.tsx

var UniqueClientXSMobileInfo = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 80 : _height, _dataTestId = param.dataTestId, dataTestId = _dataTestId === void 0 ? "unique-client-banner-xs-image" : _dataTestId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "data-testid": dataTestId,
        width: width,
        height: height,
        viewBox: "0 0 32 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            borderRadius: "8px 0 0 8px",
            height: "100%",
            width: "100%",
            maxHeight: "80px",
            maxWidth: "32px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 0H0V32H32V0Z",
                fill: "#AA0E27"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.4151 24.7656H8.79096C8.39734 24.7656 8.07819 24.4465 8.07819 24.0529V14.3719C8.07819 14.0705 8.32287 13.8258 8.62429 13.8258H14.252C14.5534 13.8258 14.7981 14.0705 14.7981 14.3719V23.8224C14.901 23.9217 14.9648 24.06 14.9648 24.216C14.9648 24.5174 14.7201 24.7656 14.4187 24.7656M9.17394 23.6699H13.7059V14.9216H9.17394V23.6699Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.5896 24.7656H17.9654C17.664 24.7656 17.4193 24.5209 17.4193 24.216C17.4193 24.0635 17.4831 23.9252 17.586 23.8224V14.3719C17.586 14.0705 17.8307 13.8258 18.1321 13.8258H23.7563C24.0577 13.8258 24.3024 14.0705 24.3024 14.3719V24.0529C24.3024 24.4465 23.9832 24.7656 23.5896 24.7656ZM18.6782 23.6699H23.2101V14.9216H18.6782V23.6699Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.6677 14.9214H18.1284C17.827 14.9214 17.5823 14.6767 17.5823 14.3753V10.8893C17.4794 10.79 17.4156 10.6517 17.4156 10.4957C17.4156 10.1943 17.6603 9.94958 17.9617 9.94958H24.6677C25.0613 9.94958 25.3805 10.2687 25.3805 10.6624V14.2086C25.3805 14.6023 25.0613 14.9214 24.6677 14.9214ZM18.6781 13.8256H24.2882V11.0418H18.6781V13.8256Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.2522 14.9214H7.71292C7.31929 14.9214 7.00012 14.6023 7.00012 14.2086V10.6624C7.00012 10.2687 7.31929 9.94958 7.71292 9.94958H14.4189C14.7203 9.94958 14.965 10.1943 14.965 10.4957C14.965 10.6482 14.9012 10.79 14.7983 10.8893V14.3753C14.7983 14.6767 14.5536 14.9214 14.2522 14.9214ZM8.09591 13.8256H13.7061V11.0418H8.09591V13.8256Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3693 11.0417H12.0997C10.8053 11.0417 9.53217 9.86793 9.52863 8.67284C9.52863 8.21892 9.6492 7.40683 10.4507 7.1054C11.2308 6.81106 12.433 7.13377 14.0288 8.06643C15.2806 8.79696 16.38 9.67643 16.7807 10.1339C16.9226 10.297 16.9545 10.524 16.8658 10.7226C16.7772 10.9176 16.5821 11.0453 16.3658 11.0453M11.0819 8.09835C10.979 8.09835 10.8975 8.11254 10.8336 8.13381C10.7769 8.15509 10.6209 8.21538 10.6209 8.67639C10.6209 9.27216 11.4081 9.9495 12.0961 9.9495H14.887C14.4863 9.65161 14.0005 9.32536 13.4756 9.01683C12.3089 8.33595 11.5181 8.09835 11.0819 8.09835Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.2775 11.0418H16.0078C15.795 11.0418 15.5999 10.9176 15.5077 10.7191C15.4191 10.524 15.451 10.2935 15.5929 10.1304C15.99 9.67292 17.0929 8.79344 18.3447 8.06646C19.9406 7.13734 21.1427 6.81109 21.9229 7.10543C22.7244 7.40686 22.8449 8.2154 22.8449 8.67287C22.8449 9.86796 21.5718 11.0418 20.2739 11.0418M17.483 9.94598H20.2739C20.9619 9.94598 21.7492 9.26864 21.7492 8.67287C21.7492 8.21186 21.5967 8.15512 21.5364 8.13384C21.203 8.00972 20.3342 8.1764 18.8944 9.01686C18.366 9.32538 17.8837 9.65164 17.483 9.94952V9.94598Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.9471 24.7651H14.433C14.0323 24.7651 13.7025 24.4388 13.7025 24.0346V10.6767C13.7025 10.2724 14.0287 9.94617 14.433 9.94617H17.9471C18.3478 9.94617 18.6776 10.2724 18.6776 10.6767V24.0346C18.6776 24.4353 18.3514 24.7651 17.9471 24.7651ZM14.7982 23.6693H17.5819V11.0419H14.7982V23.6693Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "32",
                height: "32",
                transform: "translate(0 32)",
                fill: "#C1D82F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.542 56.7511H9.9254C8.86383 56.7511 8 55.8354 8 54.7101V41.041C8 39.9157 8.86383 39 9.9254 39H19.542C20.6036 39 21.4674 39.9157 21.4674 41.041V44.0124C21.4674 44.325 21.228 44.5787 20.9331 44.5787C20.6382 44.5787 20.3989 44.325 20.3989 44.0124V41.041C20.3989 40.5409 20.0138 40.1363 19.5455 40.1363H9.92887C9.45706 40.1363 9.07545 40.5409 9.07545 41.041V54.7101C9.07545 55.2103 9.45706 55.6148 9.92887 55.6148H19.5455C20.0173 55.6148 20.3989 55.2103 20.3989 54.7101V51.8969C20.3989 51.5843 20.6382 51.3305 20.9331 51.3305C21.228 51.3305 21.4674 51.5843 21.4674 51.8969V54.7101C21.4674 55.8354 20.6036 56.7511 19.542 56.7511Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.5811 43.0599H10.8795C10.5846 43.0599 10.3452 42.8062 10.3452 42.4936C10.3452 42.181 10.5846 41.9236 10.8795 41.9236H18.5811C18.8759 41.9236 19.1153 42.1773 19.1153 42.4936C19.1153 42.8099 18.8759 43.0599 18.5811 43.0599Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.4302 46.6417H10.8795C10.5846 46.6417 10.3452 46.3879 10.3452 46.0754C10.3452 45.7628 10.5846 45.509 10.8795 45.509H16.4302C16.7251 45.509 16.9644 45.7628 16.9644 46.0754C16.9644 46.3879 16.7251 46.6417 16.4302 46.6417Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3469 50.2273H10.8829C10.588 50.2273 10.3486 49.9735 10.3486 49.6609C10.3486 49.3483 10.588 49.0946 10.8829 49.0946H16.3469C16.6417 49.0946 16.8811 49.3483 16.8811 49.6609C16.8811 49.9735 16.6417 50.2273 16.3469 50.2273Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.5811 53.8092H10.8795C10.5846 53.8092 10.3452 53.5554 10.3452 53.2428C10.3452 52.9303 10.5846 52.6765 10.8795 52.6765H18.5811C18.8759 52.6765 19.1153 52.9303 19.1153 53.2428C19.1153 53.5554 18.8759 53.8092 18.5811 53.8092Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.2792 56.2546C25.908 56.2546 25.5576 56.1002 25.2974 55.8244L21.7207 52.0329C20.9991 52.4043 20.1873 52.5551 19.3859 52.4632C18.425 52.3529 17.5195 51.8932 16.8361 51.1687C16.0312 50.3155 15.5872 49.1792 15.5872 47.9693C15.5872 46.7594 16.0312 45.6231 16.8361 44.7699C17.6409 43.9168 18.7129 43.446 19.8543 43.446C20.9956 43.446 22.0641 43.9168 22.8724 44.7699C23.5559 45.4944 23.9895 46.4542 24.0936 47.4729C24.1803 48.3224 24.0381 49.1866 23.6877 49.9478L27.2644 53.7393C27.5281 54.0188 27.6738 54.3865 27.6738 54.7837C27.6738 55.1808 27.5281 55.5486 27.2644 55.8281C27.0008 56.1076 26.6539 56.2583 26.2792 56.2583M21.8109 50.7642C21.9496 50.7642 22.0849 50.8194 22.189 50.9297L26.0502 55.0227C26.1092 55.0852 26.189 55.122 26.2757 55.122C26.3624 55.122 26.4422 55.0852 26.5012 55.0227C26.5602 54.9602 26.5949 54.8756 26.5949 54.7837C26.5949 54.6917 26.5602 54.6071 26.5012 54.5446L22.64 50.4516C22.4631 50.2641 22.4319 49.9735 22.5637 49.7492C22.9384 49.1093 23.1014 48.3444 23.0216 47.5942C22.9418 46.822 22.6261 46.1232 22.1058 45.5716C21.5021 44.9317 20.7007 44.5787 19.8473 44.5787C18.9939 44.5787 18.189 44.9317 17.5854 45.5716C16.9818 46.2115 16.6487 47.061 16.6487 47.9656C16.6487 48.8703 16.9818 49.7235 17.5854 50.3634C18.1058 50.915 18.7649 51.2496 19.4935 51.3342C20.2012 51.4151 20.9228 51.2423 21.5264 50.8451C21.6131 50.7899 21.7103 50.7605 21.8074 50.7605L21.8109 50.7642Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 65.436C1.06932 65.436 1.37773 65.1146 1.37773 64.718C1.37773 64.3215 1.06932 64 0.688866 64C0.308416 64 0 64.3215 0 64.718C0 65.1146 0.308416 65.436 0.688866 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 65.436C3.85362 65.436 4.16203 65.1146 4.16203 64.718C4.16203 64.3215 3.85362 64 3.47317 64C3.09272 64 2.7843 64.3215 2.7843 64.718C2.7843 65.1146 3.09272 65.436 3.47317 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 65.436C6.63762 65.436 6.94603 65.1146 6.94603 64.718C6.94603 64.3215 6.63762 64 6.25716 64C5.87671 64 5.5683 64.3215 5.5683 64.718C5.5683 65.1146 5.87671 65.436 6.25716 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 65.436C9.42192 65.436 9.73033 65.1146 9.73033 64.718C9.73033 64.3215 9.42192 64 9.04147 64C8.66102 64 8.3526 64.3215 8.3526 64.718C8.3526 65.1146 8.66102 65.436 9.04147 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 65.436C12.2024 65.436 12.5108 65.1146 12.5108 64.718C12.5108 64.3215 12.2024 64 11.822 64C11.4415 64 11.1331 64.3215 11.1331 64.718C11.1331 65.1146 11.4415 65.436 11.822 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 65.436C14.9867 65.436 15.2951 65.1146 15.2951 64.718C15.2951 64.3215 14.9867 64 14.6062 64C14.2258 64 13.9174 64.3215 13.9174 64.718C13.9174 65.1146 14.2258 65.436 14.6062 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 65.436C17.7707 65.436 18.0791 65.1146 18.0791 64.718C18.0791 64.3215 17.7707 64 17.3902 64C17.0098 64 16.7014 64.3215 16.7014 64.718C16.7014 65.1146 17.0098 65.436 17.3902 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1745 65.436C20.555 65.436 20.8634 65.1146 20.8634 64.718C20.8634 64.3215 20.555 64 20.1745 64C19.7941 64 19.4857 64.3215 19.4857 64.718C19.4857 65.1146 19.7941 65.436 20.1745 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 65.436C23.3392 65.436 23.6476 65.1146 23.6476 64.718C23.6476 64.3215 23.3392 64 22.9587 64C22.5783 64 22.2698 64.3215 22.2698 64.718C22.2698 65.1146 22.5783 65.436 22.9587 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 65.436C26.1233 65.436 26.4317 65.1146 26.4317 64.718C26.4317 64.3215 26.1233 64 25.7428 64C25.3624 64 25.054 64.3215 25.054 64.718C25.054 65.1146 25.3624 65.436 25.7428 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 65.436C28.9075 65.436 29.2159 65.1146 29.2159 64.718C29.2159 64.3215 28.9075 64 28.527 64C28.1466 64 27.8381 64.3215 27.8381 64.718C27.8381 65.1146 28.1466 65.436 28.527 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 65.436C31.6916 65.436 32 65.1146 32 64.718C32 64.3215 31.6916 64 31.3111 64C30.9307 64 30.6223 64.3215 30.6223 64.718C30.6223 65.1146 30.9307 65.436 31.3111 65.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 68.2146C1.06932 68.2146 1.37773 67.8931 1.37773 67.4966C1.37773 67.1 1.06932 66.7786 0.688866 66.7786C0.308416 66.7786 0 67.1 0 67.4966C0 67.8931 0.308416 68.2146 0.688866 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 68.2146C3.85362 68.2146 4.16203 67.8931 4.16203 67.4966C4.16203 67.1 3.85362 66.7786 3.47317 66.7786C3.09272 66.7786 2.7843 67.1 2.7843 67.4966C2.7843 67.8931 3.09272 68.2146 3.47317 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 68.2146C6.63762 68.2146 6.94603 67.8931 6.94603 67.4966C6.94603 67.1 6.63762 66.7786 6.25716 66.7786C5.87671 66.7786 5.5683 67.1 5.5683 67.4966C5.5683 67.8931 5.87671 68.2146 6.25716 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 68.2146C9.42192 68.2146 9.73033 67.8931 9.73033 67.4966C9.73033 67.1 9.42192 66.7786 9.04147 66.7786C8.66102 66.7786 8.3526 67.1 8.3526 67.4966C8.3526 67.8931 8.66102 68.2146 9.04147 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 68.2146C12.2024 68.2146 12.5108 67.8931 12.5108 67.4966C12.5108 67.1 12.2024 66.7786 11.822 66.7786C11.4415 66.7786 11.1331 67.1 11.1331 67.4966C11.1331 67.8931 11.4415 68.2146 11.822 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 68.2146C14.9867 68.2146 15.2951 67.8931 15.2951 67.4966C15.2951 67.1 14.9867 66.7786 14.6062 66.7786C14.2258 66.7786 13.9174 67.1 13.9174 67.4966C13.9174 67.8931 14.2258 68.2146 14.6062 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 68.2146C17.7707 68.2146 18.0791 67.8931 18.0791 67.4966C18.0791 67.1 17.7707 66.7786 17.3902 66.7786C17.0098 66.7786 16.7014 67.1 16.7014 67.4966C16.7014 67.8931 17.0098 68.2146 17.3902 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 68.2146C20.5549 68.2146 20.8633 67.8931 20.8633 67.4966C20.8633 67.1 20.5549 66.7786 20.1744 66.7786C19.7939 66.7786 19.4855 67.1 19.4855 67.4966C19.4855 67.8931 19.7939 68.2146 20.1744 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 68.2146C23.3392 68.2146 23.6476 67.8931 23.6476 67.4966C23.6476 67.1 23.3392 66.7786 22.9587 66.7786C22.5783 66.7786 22.2698 67.1 22.2698 67.4966C22.2698 67.8931 22.5783 68.2146 22.9587 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 68.2146C26.1233 68.2146 26.4317 67.8931 26.4317 67.4966C26.4317 67.1 26.1233 66.7786 25.7428 66.7786C25.3624 66.7786 25.054 67.1 25.054 67.4966C25.054 67.8931 25.3624 68.2146 25.7428 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 68.2146C28.9075 68.2146 29.2159 67.8931 29.2159 67.4966C29.2159 67.1 28.9075 66.7786 28.527 66.7786C28.1466 66.7786 27.8381 67.1 27.8381 67.4966C27.8381 67.8931 28.1466 68.2146 28.527 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 68.2146C31.6916 68.2146 32 67.8931 32 67.4966C32 67.1 31.6916 66.7786 31.3111 66.7786C30.9307 66.7786 30.6223 67.1 30.6223 67.4966C30.6223 67.8931 30.9307 68.2146 31.3111 68.2146Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 70.9934C1.06932 70.9934 1.37773 70.6719 1.37773 70.2754C1.37773 69.8788 1.06932 69.5574 0.688866 69.5574C0.308416 69.5574 0 69.8788 0 70.2754C0 70.6719 0.308416 70.9934 0.688866 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 70.9934C3.85362 70.9934 4.16203 70.6719 4.16203 70.2754C4.16203 69.8788 3.85362 69.5574 3.47317 69.5574C3.09272 69.5574 2.7843 69.8788 2.7843 70.2754C2.7843 70.6719 3.09272 70.9934 3.47317 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 70.9934C6.63762 70.9934 6.94603 70.6719 6.94603 70.2754C6.94603 69.8788 6.63762 69.5574 6.25716 69.5574C5.87671 69.5574 5.5683 69.8788 5.5683 70.2754C5.5683 70.6719 5.87671 70.9934 6.25716 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 70.9934C9.42192 70.9934 9.73033 70.6719 9.73033 70.2754C9.73033 69.8788 9.42192 69.5574 9.04147 69.5574C8.66102 69.5574 8.3526 69.8788 8.3526 70.2754C8.3526 70.6719 8.66102 70.9934 9.04147 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 70.9934C12.2024 70.9934 12.5108 70.6719 12.5108 70.2754C12.5108 69.8788 12.2024 69.5574 11.822 69.5574C11.4415 69.5574 11.1331 69.8788 11.1331 70.2754C11.1331 70.6719 11.4415 70.9934 11.822 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 70.9934C14.9867 70.9934 15.2951 70.6719 15.2951 70.2754C15.2951 69.8788 14.9867 69.5574 14.6062 69.5574C14.2258 69.5574 13.9174 69.8788 13.9174 70.2754C13.9174 70.6719 14.2258 70.9934 14.6062 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 70.9934C17.7707 70.9934 18.0791 70.6719 18.0791 70.2754C18.0791 69.8788 17.7707 69.5574 17.3902 69.5574C17.0098 69.5574 16.7014 69.8788 16.7014 70.2754C16.7014 70.6719 17.0098 70.9934 17.3902 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 70.9934C20.5549 70.9934 20.8633 70.6719 20.8633 70.2754C20.8633 69.8788 20.5549 69.5574 20.1744 69.5574C19.7939 69.5574 19.4855 69.8788 19.4855 70.2754C19.4855 70.6719 19.7939 70.9934 20.1744 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 70.9934C23.3392 70.9934 23.6476 70.6719 23.6476 70.2754C23.6476 69.8788 23.3392 69.5574 22.9587 69.5574C22.5783 69.5574 22.2698 69.8788 22.2698 70.2754C22.2698 70.6719 22.5783 70.9934 22.9587 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 70.9934C26.1233 70.9934 26.4317 70.6719 26.4317 70.2754C26.4317 69.8788 26.1233 69.5574 25.7428 69.5574C25.3624 69.5574 25.054 69.8788 25.054 70.2754C25.054 70.6719 25.3624 70.9934 25.7428 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 70.9934C28.9075 70.9934 29.2159 70.6719 29.2159 70.2754C29.2159 69.8788 28.9075 69.5574 28.527 69.5574C28.1466 69.5574 27.8381 69.8788 27.8381 70.2754C27.8381 70.6719 28.1466 70.9934 28.527 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 70.9934C31.6916 70.9934 32 70.6719 32 70.2754C32 69.8788 31.6916 69.5574 31.3111 69.5574C30.9307 69.5574 30.6223 69.8788 30.6223 70.2754C30.6223 70.6719 30.9307 70.9934 31.3111 70.9934Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 73.7716C1.06932 73.7716 1.37773 73.4501 1.37773 73.0536C1.37773 72.657 1.06932 72.3356 0.688866 72.3356C0.308416 72.3356 0 72.657 0 73.0536C0 73.4501 0.308416 73.7716 0.688866 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 73.7716C3.85362 73.7716 4.16203 73.4501 4.16203 73.0536C4.16203 72.657 3.85362 72.3356 3.47317 72.3356C3.09272 72.3356 2.7843 72.657 2.7843 73.0536C2.7843 73.4501 3.09272 73.7716 3.47317 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 73.7716C6.63762 73.7716 6.94603 73.4501 6.94603 73.0536C6.94603 72.657 6.63762 72.3356 6.25716 72.3356C5.87671 72.3356 5.5683 72.657 5.5683 73.0536C5.5683 73.4501 5.87671 73.7716 6.25716 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 73.7716C9.42192 73.7716 9.73033 73.4501 9.73033 73.0536C9.73033 72.657 9.42192 72.3356 9.04147 72.3356C8.66102 72.3356 8.3526 72.657 8.3526 73.0536C8.3526 73.4501 8.66102 73.7716 9.04147 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 73.7716C12.2024 73.7716 12.5108 73.4501 12.5108 73.0536C12.5108 72.657 12.2024 72.3356 11.822 72.3356C11.4415 72.3356 11.1331 72.657 11.1331 73.0536C11.1331 73.4501 11.4415 73.7716 11.822 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 73.7716C14.9867 73.7716 15.2951 73.4501 15.2951 73.0536C15.2951 72.657 14.9867 72.3356 14.6062 72.3356C14.2258 72.3356 13.9174 72.657 13.9174 73.0536C13.9174 73.4501 14.2258 73.7716 14.6062 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 73.7716C17.7707 73.7716 18.0791 73.4501 18.0791 73.0536C18.0791 72.657 17.7707 72.3356 17.3902 72.3356C17.0098 72.3356 16.7014 72.657 16.7014 73.0536C16.7014 73.4501 17.0098 73.7716 17.3902 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 73.7716C20.5549 73.7716 20.8633 73.4501 20.8633 73.0536C20.8633 72.657 20.5549 72.3356 20.1744 72.3356C19.7939 72.3356 19.4855 72.657 19.4855 73.0536C19.4855 73.4501 19.7939 73.7716 20.1744 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 73.7716C23.3392 73.7716 23.6476 73.4501 23.6476 73.0536C23.6476 72.657 23.3392 72.3356 22.9587 72.3356C22.5783 72.3356 22.2698 72.657 22.2698 73.0536C22.2698 73.4501 22.5783 73.7716 22.9587 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 73.7716C26.1233 73.7716 26.4317 73.4501 26.4317 73.0536C26.4317 72.657 26.1233 72.3356 25.7428 72.3356C25.3624 72.3356 25.054 72.657 25.054 73.0536C25.054 73.4501 25.3624 73.7716 25.7428 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 73.7716C28.9075 73.7716 29.2159 73.4501 29.2159 73.0536C29.2159 72.657 28.9075 72.3356 28.527 72.3356C28.1466 72.3356 27.8381 72.657 27.8381 73.0536C27.8381 73.4501 28.1466 73.7716 28.527 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 73.7716C31.6916 73.7716 32 73.4501 32 73.0536C32 72.657 31.6916 72.3356 31.3111 72.3356C30.9307 72.3356 30.6223 72.657 30.6223 73.0536C30.6223 73.4501 30.9307 73.7716 31.3111 73.7716Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 76.5503C1.06932 76.5503 1.37773 76.2288 1.37773 75.8323C1.37773 75.4357 1.06932 75.1143 0.688866 75.1143C0.308416 75.1143 0 75.4357 0 75.8323C0 76.2288 0.308416 76.5503 0.688866 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 76.5503C3.85362 76.5503 4.16203 76.2288 4.16203 75.8323C4.16203 75.4357 3.85362 75.1143 3.47317 75.1143C3.09272 75.1143 2.7843 75.4357 2.7843 75.8323C2.7843 76.2288 3.09272 76.5503 3.47317 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 76.5503C6.63762 76.5503 6.94603 76.2288 6.94603 75.8323C6.94603 75.4357 6.63762 75.1143 6.25716 75.1143C5.87671 75.1143 5.5683 75.4357 5.5683 75.8323C5.5683 76.2288 5.87671 76.5503 6.25716 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 76.5503C9.42192 76.5503 9.73033 76.2288 9.73033 75.8323C9.73033 75.4357 9.42192 75.1143 9.04147 75.1143C8.66102 75.1143 8.3526 75.4357 8.3526 75.8323C8.3526 76.2288 8.66102 76.5503 9.04147 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 76.5503C12.2024 76.5503 12.5108 76.2288 12.5108 75.8323C12.5108 75.4357 12.2024 75.1143 11.822 75.1143C11.4415 75.1143 11.1331 75.4357 11.1331 75.8323C11.1331 76.2288 11.4415 76.5503 11.822 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 76.5503C14.9867 76.5503 15.2951 76.2288 15.2951 75.8323C15.2951 75.4357 14.9867 75.1143 14.6062 75.1143C14.2258 75.1143 13.9174 75.4357 13.9174 75.8323C13.9174 76.2288 14.2258 76.5503 14.6062 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 76.5503C17.7707 76.5503 18.0791 76.2288 18.0791 75.8323C18.0791 75.4357 17.7707 75.1143 17.3902 75.1143C17.0098 75.1143 16.7014 75.4357 16.7014 75.8323C16.7014 76.2288 17.0098 76.5503 17.3902 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 76.5503C20.5549 76.5503 20.8633 76.2288 20.8633 75.8323C20.8633 75.4357 20.5549 75.1143 20.1744 75.1143C19.7939 75.1143 19.4855 75.4357 19.4855 75.8323C19.4855 76.2288 19.7939 76.5503 20.1744 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 76.5503C23.3392 76.5503 23.6476 76.2288 23.6476 75.8323C23.6476 75.4357 23.3392 75.1143 22.9587 75.1143C22.5783 75.1143 22.2698 75.4357 22.2698 75.8323C22.2698 76.2288 22.5783 76.5503 22.9587 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 76.5503C26.1233 76.5503 26.4317 76.2288 26.4317 75.8323C26.4317 75.4357 26.1233 75.1143 25.7428 75.1143C25.3624 75.1143 25.054 75.4357 25.054 75.8323C25.054 76.2288 25.3624 76.5503 25.7428 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 76.5503C28.9075 76.5503 29.2159 76.2288 29.2159 75.8323C29.2159 75.4357 28.9075 75.1143 28.527 75.1143C28.1466 75.1143 27.8381 75.4357 27.8381 75.8323C27.8381 76.2288 28.1466 76.5503 28.527 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 76.5503C31.6916 76.5503 32 76.2288 32 75.8323C32 75.4357 31.6916 75.1143 31.3111 75.1143C30.9307 75.1143 30.6223 75.4357 30.6223 75.8323C30.6223 76.2288 30.9307 76.5503 31.3111 76.5503Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 79.3285C1.06932 79.3285 1.37773 79.007 1.37773 78.6105C1.37773 78.2139 1.06932 77.8925 0.688866 77.8925C0.308416 77.8925 0 78.2139 0 78.6105C0 79.007 0.308416 79.3285 0.688866 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47317 79.3285C3.85362 79.3285 4.16203 79.007 4.16203 78.6105C4.16203 78.2139 3.85362 77.8925 3.47317 77.8925C3.09272 77.8925 2.7843 78.2139 2.7843 78.6105C2.7843 79.007 3.09272 79.3285 3.47317 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25716 79.3285C6.63762 79.3285 6.94603 79.007 6.94603 78.6105C6.94603 78.2139 6.63762 77.8925 6.25716 77.8925C5.87671 77.8925 5.5683 78.2139 5.5683 78.6105C5.5683 79.007 5.87671 79.3285 6.25716 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04147 79.3285C9.42192 79.3285 9.73033 79.007 9.73033 78.6105C9.73033 78.2139 9.42192 77.8925 9.04147 77.8925C8.66102 77.8925 8.3526 78.2139 8.3526 78.6105C8.3526 79.007 8.66102 79.3285 9.04147 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 79.3285C12.2024 79.3285 12.5108 79.007 12.5108 78.6105C12.5108 78.2139 12.2024 77.8925 11.822 77.8925C11.4415 77.8925 11.1331 78.2139 11.1331 78.6105C11.1331 79.007 11.4415 79.3285 11.822 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6062 79.3285C14.9867 79.3285 15.2951 79.007 15.2951 78.6105C15.2951 78.2139 14.9867 77.8925 14.6062 77.8925C14.2258 77.8925 13.9174 78.2139 13.9174 78.6105C13.9174 79.007 14.2258 79.3285 14.6062 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 79.3285C17.7707 79.3285 18.0791 79.007 18.0791 78.6105C18.0791 78.2139 17.7707 77.8925 17.3902 77.8925C17.0098 77.8925 16.7014 78.2139 16.7014 78.6105C16.7014 79.007 17.0098 79.3285 17.3902 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 79.3285C20.5549 79.3285 20.8633 79.007 20.8633 78.6105C20.8633 78.2139 20.5549 77.8925 20.1744 77.8925C19.7939 77.8925 19.4855 78.2139 19.4855 78.6105C19.4855 79.007 19.7939 79.3285 20.1744 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 79.3285C23.3392 79.3285 23.6476 79.007 23.6476 78.6105C23.6476 78.2139 23.3392 77.8925 22.9587 77.8925C22.5783 77.8925 22.2698 78.2139 22.2698 78.6105C22.2698 79.007 22.5783 79.3285 22.9587 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 79.3285C26.1233 79.3285 26.4317 79.007 26.4317 78.6105C26.4317 78.2139 26.1233 77.8925 25.7428 77.8925C25.3624 77.8925 25.054 78.2139 25.054 78.6105C25.054 79.007 25.3624 79.3285 25.7428 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 79.3285C28.9075 79.3285 29.2159 79.007 29.2159 78.6105C29.2159 78.2139 28.9075 77.8925 28.527 77.8925C28.1466 77.8925 27.8381 78.2139 27.8381 78.6105C27.8381 79.007 28.1466 79.3285 28.527 79.3285Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 79.3285C31.6916 79.3285 32 79.007 32 78.6105C32 78.2139 31.6916 77.8925 31.3111 77.8925C30.9307 77.8925 30.6223 78.2139 30.6223 78.6105C30.6223 79.007 30.9307 79.3285 31.3111 79.3285Z",
                fill: "#E5E6E6"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/UnsatisfiedFaceIcon.tsx


var UnsatisfiedFaceIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de Avalia\xe7\xe3o - Insatisfeito" : _alt, _width = param.width, width = _width === void 0 ? 40 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.77 */.rS.colors.primary[77] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.primary.350 */.rS.colors.primary[350] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 40 40",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "20",
                cy: "20",
                r: "19",
                fill: color,
                stroke: secondColor,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.3252 28.4187C26.3252 28.4187 23.7941 25.8027 19.763 25.7847C16.7397 25.7713 13.5489 28.5479 13.5489 28.5479",
                stroke: secondColor,
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.49988 15.8642L11.6668 14.0358C12.6234 13.4835 13.8466 13.8112 14.3989 14.7678L16.2273 17.9347",
                stroke: secondColor,
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.5363 17.934L24.3647 14.7671C24.917 13.8105 26.1401 13.4828 27.0967 14.035L30.2637 15.8635",
                stroke: secondColor,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/UserCardIcon.tsx


var UserCardIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 106 : _height, _width = param.width, width = _width === void 0 ? 106 : _width, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white-075 */.rS.colors.neutral["white-075"] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.neutral.240 */.rS.colors.neutral[240] : _fourthColor, _alt = param.alt, alt = _alt === void 0 ? "cart\xe3o com \xedcone de perfil do usu\xe1rio" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 106 106",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "52.6071",
                cy: "53.4364",
                r: "52.0973",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.5971 37.5713L23.5768 36.9687C23.5132 35.0827 21.9328 33.6053 20.0468 33.6689L14.0204 33.872C12.1344 33.9355 10.657 35.516 10.7206 37.402L10.7409 38.0046",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "16.8165",
                        cy: "27.3423",
                        r: "3.21588",
                        transform: "rotate(-1.93037 16.8165 27.3423)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.6225 58.3543L17.6022 57.7516C17.5386 55.8656 15.9582 54.3882 14.0722 54.4518L8.0458 54.6549C6.15978 54.7185 4.68239 56.2989 4.74596 58.185L4.76627 58.7876",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "10.8419",
                        cy: "48.1253",
                        r: "3.21588",
                        transform: "rotate(-1.93037 10.8419 48.1253)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M28.6811 77.8138L28.6608 77.2111C28.5972 75.3251 27.0168 73.8477 25.1307 73.9113L19.1044 74.1144C17.2184 74.178 15.741 75.7584 15.8046 77.6444L15.8249 78.2471",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "21.9005",
                        cy: "67.5847",
                        r: "3.21588",
                        transform: "rotate(-1.93037 21.9005 67.5847)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M46.2475 36.0564L46.2272 35.4538C46.1636 33.5678 44.5832 32.0904 42.6972 32.154L36.6708 32.3571C34.7848 32.4206 33.3074 34.0011 33.371 35.8871L33.3913 36.4897",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "39.4669",
                        cy: "25.8274",
                        r: "3.21588",
                        transform: "rotate(-1.93037 39.4669 25.8274)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M66.0737 17.135L66.0534 16.5324C65.9898 14.6464 64.4093 13.169 62.5233 13.2326L56.497 13.4357C54.611 13.4993 53.1336 15.0797 53.1971 16.9657L53.2174 17.5684",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "59.2931",
                        cy: "6.90602",
                        r: "3.21588",
                        transform: "rotate(-1.93037 59.2931 6.90602)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M61.4545 96.3206L61.4342 95.718C61.3706 93.8319 59.7902 92.3546 57.9042 92.4181L51.8778 92.6212C49.9918 92.6848 48.5144 94.2652 48.578 96.1513L48.5983 96.7539",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "54.6739",
                        cy: "86.0916",
                        r: "3.21588",
                        transform: "rotate(-1.93037 54.6739 86.0916)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M67.5834 33.4192L67.5631 32.8166C67.4996 30.9306 65.9191 29.4532 64.0331 29.5168L58.0067 29.7199C56.1207 29.7834 54.6433 31.3639 54.7069 33.2499L54.7272 33.8525",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "60.8029",
                        cy: "23.1902",
                        r: "3.21588",
                        transform: "rotate(-1.93037 60.8029 23.1902)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M43.0522 20.1473L43.0319 19.5446C42.9683 17.6586 41.3879 16.1812 39.5018 16.2448L33.4755 16.4479C31.5895 16.5115 30.1121 18.0919 30.1756 19.9779L30.196 20.5806",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "36.2716",
                        cy: "9.91823",
                        r: "3.21588",
                        transform: "rotate(-1.93037 36.2716 9.91823)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M41.0502 95.2132L41.0299 94.6105C40.9664 92.7245 39.3859 91.2471 37.4999 91.3107L31.4735 91.5138C29.5875 91.5774 28.1101 93.1578 28.1737 95.0438L28.194 95.6465",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "34.2696",
                        cy: "84.9841",
                        r: "3.21588",
                        transform: "rotate(-1.93037 34.2696 84.9841)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M87.8002 32.0935L87.7799 31.4909C87.7164 29.6049 86.1359 28.1275 84.2499 28.1911L78.2235 28.3942C76.3375 28.4577 74.8601 30.0382 74.9237 31.9242L74.944 32.5268",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "81.0197",
                        cy: "21.8645",
                        r: "3.21588",
                        transform: "rotate(-1.93037 81.0197 21.8645)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M99.6069 51.7393L99.5866 51.1367C99.523 49.2506 97.9425 47.7733 96.0565 47.8368L90.0302 48.0399C88.1442 48.1035 86.6668 49.6839 86.7303 51.57L86.7506 52.1726",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "92.8282",
                        cy: "41.5105",
                        r: "3.21588",
                        transform: "rotate(-1.93037 92.8282 41.5105)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M93.0737 71.5872L93.0534 70.9846C92.9898 69.0985 91.4093 67.6212 89.5233 67.6847L83.497 67.8878C81.611 67.9514 80.1336 69.5318 80.1971 71.4179L80.2174 72.0205",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "86.2931",
                        cy: "61.3582",
                        r: "3.21588",
                        transform: "rotate(-1.93037 86.2931 61.3582)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M80.1127 91.9305L80.0924 91.3278C80.0289 89.4418 78.4484 87.9644 76.5624 88.028L70.536 88.2311C68.65 88.2947 67.1726 89.8751 67.2362 91.7611L67.2565 92.3638",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "73.3322",
                        cy: "81.7014",
                        r: "3.21588",
                        transform: "rotate(-1.93037 73.3322 81.7014)",
                        stroke: secondColor,
                        strokeWidth: "1.06018",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46.515 44.5402C48.8007 46.8259 48.8007 50.5318 46.515 52.8175C44.2293 55.1032 40.5234 55.1032 38.2377 52.8175C35.952 50.5318 35.952 46.8259 38.2377 44.5402C40.5234 42.2545 44.2293 42.2545 46.515 44.5402",
                stroke: secondColor,
                strokeWidth: "2.31544",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M61.3965 46.9432H73.1023",
                stroke: secondColor,
                strokeWidth: "3.08725",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M70.1758 57.1859H61.3965",
                stroke: secondColor,
                strokeWidth: "3.08725",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M52.618 67.5484C52.1205 66.2988 51.3508 65.175 50.3617 64.2591V64.2591C48.6907 62.711 46.4958 61.8477 44.2161 61.8477H40.5347C38.255 61.8477 36.0601 62.708 34.3891 64.2591V64.2591C33.4 65.1721 32.6303 66.2959 32.1328 67.5484",
                stroke: secondColor,
                strokeWidth: "3.08725",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M55.545 35.2375H49.6921C48.0767 35.2375 46.7656 33.9264 46.7656 32.311V23.5317C46.7656 21.9163 48.0767 20.6052 49.6921 20.6052H55.545C57.1604 20.6052 58.4714 21.9163 58.4714 23.5317V32.311C58.4714 33.9264 57.1604 35.2375 55.545 35.2375Z",
                fill: thirdColor,
                stroke: secondColor,
                strokeWidth: "3.08725",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M46.7651 29.3845H29.3264C26.0283 29.3845 23.3535 32.0593 23.3535 35.3574V70.3549C23.3535 73.5886 25.9727 76.2078 29.2064 76.2078H76.0297C79.2634 76.2078 81.8826 73.5886 81.8826 70.3549V35.2374C81.8826 32.0037 79.2634 29.3845 76.0297 29.3845H58.471",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46.7651 29.3845H29.3264C26.0283 29.3845 23.3535 32.0593 23.3535 35.3574V70.3549C23.3535 73.5886 25.9727 76.2078 29.2064 76.2078H76.0297C79.2634 76.2078 81.8826 73.5886 81.8826 70.3549V35.2374C81.8826 32.0037 79.2634 29.3845 76.0297 29.3845H58.471",
                stroke: secondColor,
                strokeWidth: "3.08725",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M55.6075 35.559H49.7546C48.1392 35.559 46.8281 34.248 46.8281 32.6326V23.8532C46.8281 22.2378 48.1392 20.9268 49.7546 20.9268H55.6075C57.2229 20.9268 58.5339 22.2378 58.5339 23.8532V32.6326C58.5339 34.248 57.2229 35.559 55.6075 35.559Z",
                fill: thirdColor,
                stroke: secondColor,
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46.515 44.5397C48.8007 46.8254 48.8007 50.5313 46.515 52.817C44.2293 55.1027 40.5234 55.1027 38.2377 52.817C35.952 50.5313 35.952 46.8254 38.2377 44.5397C40.5234 42.254 44.2293 42.254 46.515 44.5397",
                stroke: secondColor,
                strokeWidth: "2.31544",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M61.3965 46.943H73.1023",
                stroke: secondColor,
                strokeWidth: "3.08725",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M70.1758 57.1854H61.3965",
                stroke: secondColor,
                strokeWidth: "3.08725",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M52.618 67.5481C52.1205 66.2985 51.3508 65.1748 50.3617 64.2588V64.2588C48.6907 62.7107 46.4958 61.8474 44.2161 61.8474H40.5347C38.255 61.8474 36.0601 62.7078 34.3891 64.2588V64.2588C33.4 65.1719 32.6303 66.2956 32.1328 67.5481",
                stroke: secondColor,
                strokeWidth: "3.08725",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "42.1976",
                cy: "48.7118",
                r: "5.40268",
                fill: thirdColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "54",
                cy: "83.252",
                rx: "22.5",
                ry: "1.5",
                fill: fourthColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/UserIcon.tsx


var UserIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 36 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.25" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "https://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        strokeWidth: strokeWidth,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                fill: "none",
                stroke: color,
                strokeMiterlimit: 10,
                cx: "12.02",
                cy: "7.24",
                r: "5.12"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: color,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                d: "M3.56,21.95c.02-7.23,3.17-8.72,5.86-8.97,.98-.09,4.24-.09,5.23,0,2.7,.26,5.79,1.75,5.82,8.99"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ValidIcon.tsx


var ValidIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 18 : _width, _height = param.height, height = _height === void 0 ? 18 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "9",
                cy: "9.00006",
                r: "6.0025",
                fill: color,
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.6283 9.22613L8.07356 10.6714L8.06423 10.6621L11.3249 7.40137",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/VerySatisfiedFaceIcon.tsx


var VerySatisfiedFaceIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de Avalia\xe7\xe3o - Muito Satisfeito" : _alt, _width = param.width, width = _width === void 0 ? 40 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.250 */.rS.colors.secondary[250] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.secondary.425 */.rS.colors.secondary[425] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 40 40",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "20",
                cy: "20",
                r: "19",
                fill: color,
                stroke: secondColor,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.595 24L26.5856 24C28.1141 24 29.0282 25.6186 28.1055 26.8371C26.4201 29.063 23.8097 31.8149 21.1064 31.9909C18.1336 32.1844 15.0846 29.2605 13.1242 26.8955C12.1235 25.6883 13.027 24 14.595 24Z",
                fill: color,
                stroke: secondColor,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.11804 16.8969L12.285 15.0685C13.2416 14.5162 14.4647 14.8439 15.017 15.8005L16.8455 18.9675",
                stroke: secondColor,
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.1544 18.9667L24.9828 15.7998C25.5351 14.8432 26.7583 14.5155 27.7149 15.0678L30.8818 16.8962",
                stroke: secondColor,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/VeryUnsatisfiedFaceIcon.tsx


var VeryUnsatisfiedFaceIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de Avalia\xe7\xe3o - Muito Insatisfeito" : _alt, _width = param.width, width = _width === void 0 ? 40 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.95 */.rS.colors.primary[95] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.primary.550 */.rS.colors.primary[550] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 40 40",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "20",
                cy: "20",
                r: "19",
                fill: color,
                stroke: secondColor,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.405 32H14.4144C12.8859 32 11.9718 30.3814 12.8945 29.1629C14.5799 26.937 17.1903 24.1851 19.8936 24.0091C22.8664 23.8156 25.9154 26.7395 27.8758 29.1045C28.8765 30.3117 27.973 32 26.405 32Z",
                fill: color,
                stroke: secondColor,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.11804 16.8969L12.285 15.0685C13.2416 14.5162 14.4647 14.8439 15.017 15.8005L16.8455 18.9675",
                stroke: secondColor,
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.1544 18.9667L24.9828 15.7998C25.5351 14.8432 26.7583 14.5155 27.7149 15.0678L30.8818 16.8962",
                stroke: secondColor,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Visa.tsx


var Visa = function(param) {
    var _width = param.width, width = _width === void 0 ? 65 : _width, _height = param.height, height = _height === void 0 ? 40 : _height, _alt = param.alt, alt = _alt === void 0 ? "Visa" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.tertiary.700 */.rS.colors.tertiary[700] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.yellow.200 */.rS.colors.yellow[200] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 48 19",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.2912 16.8043H17.4731L19.8613 2.24283H23.6791L21.2912 16.8043Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.1322 2.59879C34.3791 2.30416 33.1846 1.97886 31.7077 1.97886C27.9372 1.97886 25.282 3.96159 25.2657 6.7963C25.2344 8.88774 27.1667 10.0494 28.612 10.7467C30.0891 11.4593 30.5913 11.9244 30.5913 12.5596C30.5762 13.5351 29.3976 13.9848 28.2984 13.9848C26.774 13.9848 25.9572 13.7529 24.716 13.2102L24.2132 12.9776L23.679 16.2463C24.5744 16.6486 26.2243 17.0056 27.9372 17.0213C31.9434 17.0213 34.5516 15.0692 34.5825 12.0484C34.5977 10.3907 33.5773 9.1206 31.3776 8.08271C30.0422 7.41644 29.2243 6.96719 29.2243 6.28548C29.24 5.66575 29.9161 5.03099 31.4235 5.03099C32.6647 4.9999 33.5767 5.29412 34.2676 5.58854L34.6129 5.74316L35.1322 2.59879Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40.2068 11.6457C40.5212 10.8091 41.7311 7.5715 41.7311 7.5715C41.7153 7.60259 42.0449 6.71952 42.2335 6.17741L42.5003 7.43211C42.5003 7.43211 43.2233 10.9176 43.3803 11.6457C42.7836 11.6457 40.9609 11.6457 40.2068 11.6457ZM44.9197 2.24283H41.9664C41.0557 2.24283 40.3638 2.50596 39.9708 3.451L34.2996 16.8041H38.3058C38.3058 16.8041 38.9653 15.0068 39.1071 14.6198C39.5466 14.6198 43.4438 14.6198 44.0092 14.6198C44.1188 15.131 44.4648 16.8041 44.4648 16.8041H48L44.9197 2.24283Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.2841 2.24283L10.545 12.1723L10.1364 10.1585C9.44508 7.83483 7.27703 5.3102 4.8576 4.05488L8.28255 16.7888H12.3201L18.3215 2.24283H14.2841Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.07285 2.24283H0.92991L0.867065 2.53705C5.65894 3.74542 8.83251 6.65816 10.1364 10.1591L8.80098 3.46685C8.58113 2.53684 7.90549 2.27351 7.07285 2.24283Z",
                fill: secondColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Wallet.tsx


var Wallet = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "carteira" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 15.5H18C16.895 15.5 16 14.605 16 13.5V13.5C16 12.395 16.895 11.5 18 11.5H20C20.552 11.5 21 11.948 21 12.5V14.5C21 15.052 20.552 15.5 20 15.5Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 11.5V8.5C20 7.395 19.105 6.5 18 6.5H4.5C3.672 6.5 3 5.828 3 5V5C3 4.172 3.672 3.5 4.5 3.5H17",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 15.5V18.5C20 19.605 19.105 20.5 18 20.5H5C3.895 20.5 3 19.605 3 18.5V5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/WarningIcon.tsx


var WarningIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.yellow.45 */.rS.colors.yellow[45] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.35258 2.75913L14.4586 11.6951C15.0519 12.7338 14.3019 14.0265 13.1059 14.0265H2.89391C1.69725 14.0265 0.947246 12.7338 1.54125 11.6951L6.64725 2.75913C7.24525 1.7118 8.75458 1.7118 9.35258 2.75913Z",
                fill: color,
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 8.74675V6.25342",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.99933 10.7502C7.90733 10.7502 7.83266 10.8248 7.83333 10.9168C7.83333 11.0088 7.90799 11.0835 7.99999 11.0835C8.09199 11.0835 8.16666 11.0088 8.16666 10.9168C8.16666 10.8248 8.09199 10.7502 7.99933 10.7502",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/WarningRevalidationIcon.tsx


var WarningRevalidationIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.yellow.1050 */.rS.colors.yellow[1050] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white-010 */.rS.colors.neutral["white-010"] : _secondColor, alt = param.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.029 4.13919L21.688 17.5432C22.578 19.1012 21.453 21.0402 19.659 21.0402H4.34101C2.54601 21.0402 1.42101 19.1012 2.31201 17.5432L9.97101 4.13919C10.868 2.56819 13.132 2.56819 14.029 4.13919Z",
                fill: secondColor,
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 13.12V9.38",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.999 16.125C11.861 16.125 11.749 16.237 11.75 16.375C11.75 16.513 11.862 16.625 12 16.625C12.138 16.625 12.25 16.513 12.25 16.375C12.25 16.237 12.138 16.125 11.999 16.125",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/WarningValidateIcon.tsx


var WarningValidateIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.yellow.1050 */.rS.colors.yellow[1050] : _color, alt = param.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        "aria-label": alt,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 2.25C12.7283 2.25 15.75 5.27175 15.75 9C15.75 12.7283 12.7283 15.75 9 15.75C5.27175 15.75 2.25 12.7283 2.25 9C2.25 5.27175 5.27175 2.25 9 2.25Z",
                fill: color,
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 9.375V5.625",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.99925 12C8.89575 12 8.81175 12.084 8.8125 12.1875C8.8125 12.291 8.8965 12.375 9 12.375C9.1035 12.375 9.1875 12.291 9.1875 12.1875C9.1875 12.084 9.1035 12 8.99925 12",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/WeddingRingsDefaultIcon.tsx

var WeddingRingsDefaultIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "auto" : _width, _height = param.height, height = _height === void 0 ? "auto" : _height, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone padr\xe3o de alian\xe7as de casamento" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 215 215",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "107.5",
                cy: "107.5",
                r: "106.5",
                fill: "#CDCDCD",
                stroke: "white",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M147.409 105.925C158.864 117.38 158.864 135.953 147.409 147.408C135.953 158.864 117.38 158.864 105.925 147.408C94.4696 135.953 94.4696 117.38 105.925 105.925C117.38 94.4693 135.953 94.4693 147.409 105.925",
                stroke: "#53565A",
                strokeWidth: "6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.075 105.925C121.531 117.38 121.531 135.953 110.075 147.408C98.62 158.864 80.0471 158.864 68.5918 147.408C57.1364 135.953 57.1364 117.38 68.5918 105.925C80.0471 94.4693 98.62 94.4693 110.075 105.925",
                stroke: "#53565A",
                strokeWidth: "6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M124 63.664C124 66 122.992 68.2453 121.195 69.92L109.403 80.928C108.613 81.664 107.387 81.664 106.592 80.928L94.8055 69.9253C93.0081 68.2453 92.0001 66 92.0001 63.664V63.664C92.0001 58.6933 96.0268 54.6666 100.997 54.6666H115.003C119.973 54.6666 124 58.6933 124 63.664V63.664V63.664Z",
                stroke: "#53565A",
                strokeWidth: "6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/WeddingRingsIcon.tsx


var WeddingRingsIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 25 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone de alian\xe7as de casamento" : _alt, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.5 6.5L16 9.5L12.5 6.5L13.375 4.5H18.625L19.5 6.5Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.74156 9.75931C7.03116 8.93128 4.11039 10.107 2.72954 12.5819C1.34869 15.0568 1.88218 18.1598 4.01033 20.0314C6.13847 21.903 9.28419 22.0357 11.5624 20.35C13.8406 18.6643 14.6336 15.6172 13.466 13.0348",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.2583 21.2414C16.9687 22.0695 19.8894 20.8937 21.2703 18.4188C22.6511 15.9439 22.1176 12.841 19.9895 10.9694C17.8613 9.09776 14.7156 8.96505 12.4374 10.6508C10.1592 12.3365 9.36626 15.3835 10.5338 17.9659",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/WeighIcon.tsx


var WeighIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5213 6.00005L14.2427 10.9847C14.5993 11.9007 13.924 12.8887 12.9413 12.8887H3.05935C2.07668 12.8887 1.40068 11.9007 1.75802 10.9847L4.47868 6.00005C4.68801 5.46405 5.20468 5.11072 5.78001 5.11072H10.2193C10.7953 5.11072 11.312 5.46405 11.5213 6.00005Z",
                stroke: color,
                strokeWidth: "1",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "8.00002",
                cy: "3.7734",
                rx: "1.33334",
                ry: "1.33333",
                stroke: color,
                strokeWidth: "1"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/WhatsApp.tsx


var WhatsApp = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.270 */.rS.colors.secondary[270] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.secondary.365 */.rS.colors.secondary[365] : _secondColor, _thirdColor = param.thirdColor, thirdColor = _thirdColor === void 0 ? themes/* theme.colors.neutral.55 */.rS.colors.neutral[55] : _thirdColor, _fourthColor = param.fourthColor, fourthColor = _fourthColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _fourthColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "https://www.w3.org/2000/svg",
        height: height,
        width: width,
        viewBox: "-93.2412 -156.2325 808.0904 937.395",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: ".5",
                        y1: "0",
                        x2: ".5",
                        y2: "1",
                        id: "a",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: color,
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: secondColor,
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: ".5",
                        y1: "0",
                        x2: ".5",
                        y2: "1",
                        id: "b",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: thirdColor,
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: fourthColor,
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("linearGradient", {
                        xlinkHref: "#a",
                        id: "f",
                        x1: "270.265",
                        y1: "1.184",
                        x2: "270.265",
                        y2: "541.56",
                        gradientTransform: "scale(.99775 1.00225)",
                        gradientUnits: "userSpaceOnUse"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("linearGradient", {
                        xlinkHref: "#b",
                        id: "g",
                        x1: "279.952",
                        y1: ".811",
                        x2: "279.952",
                        y2: "560.571",
                        gradientTransform: "scale(.99777 1.00224)",
                        gradientUnits: "userSpaceOnUse"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("filter", {
                        x: "-.056",
                        y: "-.062",
                        width: "1.112",
                        height: "1.11",
                        filterUnits: "objectBoundingBox",
                        id: "c",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: "2",
                            in: "SourceGraphic"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        x: "-.082",
                        y: "-.088",
                        width: "1.164",
                        height: "1.162",
                        filterUnits: "objectBoundingBox",
                        id: "d",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "-4",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "12.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in: "shadowBlurOuter1",
                                in2: "SourceAlpha",
                                operator: "out",
                                result: "shadowBlurOuter1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M576.337 707.516c-.018-49.17 12.795-97.167 37.15-139.475L574 423.48l147.548 38.792c40.652-22.23 86.423-33.944 133.002-33.962h.12c153.395 0 278.265 125.166 278.33 278.98.025 74.548-28.9 144.642-81.446 197.373C999 957.393 929.12 986.447 854.67 986.48c-153.42 0-278.272-125.146-278.333-278.964z",
                        id: "e"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "matrix(1 0 0 -1 -542.696 1013.504)",
                        fill: "#000",
                        fillRule: "nonzero",
                        filter: "url(#c)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                filter: "url(#d)",
                                xlinkHref: "#e",
                                width: "100%",
                                height: "100%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                fillOpacity: ".2",
                                xlinkHref: "#e",
                                width: "100%",
                                height: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        transform: "matrix(1 0 0 -1 41.304 577.504)",
                        fillRule: "nonzero",
                        fill: "url(#f)",
                        d: "M2.325 274.421c-.014-47.29 12.342-93.466 35.839-134.166L.077 1.187l142.314 37.316C181.6 17.133 225.745 5.856 270.673 5.84h.12c147.95 0 268.386 120.396 268.447 268.372.03 71.707-27.87 139.132-78.559 189.858-50.68 50.726-118.084 78.676-189.898 78.708-147.968 0-268.398-120.386-268.458-268.358"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        transform: "matrix(1 0 0 -1 31.637 586.837)",
                        fillRule: "nonzero",
                        fill: "url(#g)",
                        d: "M2.407 283.847c-.018-48.996 12.784-96.824 37.117-138.983L.072.814l147.419 38.654c40.616-22.15 86.346-33.824 132.885-33.841h.12c153.26 0 278.02 124.724 278.085 277.994.026 74.286-28.874 144.132-81.374 196.678-52.507 52.544-122.326 81.494-196.711 81.528-153.285 0-278.028-124.704-278.09-277.98zm87.789-131.724l-5.503 8.74C61.555 197.653 49.34 240.17 49.36 283.828c.049 127.399 103.73 231.044 231.224 231.044 61.74-.025 119.765-24.09 163.409-67.763 43.639-43.67 67.653-101.726 67.635-163.469-.054-127.403-103.739-231.063-231.131-231.063h-.09c-41.482.022-82.162 11.159-117.642 32.214l-8.444 5.004L66.84 66.86z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M242.63 186.78c-5.205-11.57-10.684-11.803-15.636-12.006-4.05-.173-8.687-.162-13.316-.162-4.632 0-12.161 1.74-18.527 8.693-6.37 6.953-24.322 23.761-24.322 57.947 0 34.19 24.901 67.222 28.372 71.862 3.474 4.634 48.07 77.028 118.694 104.88 58.696 23.146 70.64 18.542 83.38 17.384 12.74-1.158 41.11-16.805 46.9-33.03 5.791-16.223 5.791-30.128 4.054-33.035-1.738-2.896-6.37-4.633-13.319-8.108-6.95-3.475-41.11-20.287-47.48-22.603-6.37-2.316-11.003-3.474-15.635 3.482-4.633 6.95-17.94 22.596-21.996 27.23-4.053 4.643-8.106 5.222-15.056 1.747-6.949-3.485-29.328-10.815-55.876-34.485-20.656-18.416-34.6-41.16-38.656-48.116-4.053-6.95-.433-10.714 3.052-14.178 3.12-3.113 6.95-8.11 10.424-12.168 3.467-4.057 4.626-6.953 6.942-11.586 2.316-4.64 1.158-8.698-.579-12.172-1.737-3.475-15.241-37.838-21.42-51.576",
                        fill: "#FFF"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/WhatsappIcon.tsx


var WhatsappIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 25 : _height, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de whatsapp" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.750 */.rS.colors.secondary[750] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: '\xf0\x9f\xa6\x86 icon "Whatsapp"',
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Vector",
                    d: "M24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5C18.6274 24.5 24 19.1274 24 12.5Z",
                    fill: color
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "Group",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_2",
                            d: "M6 18.0556L6.86098 14.8543C6.16663 13.6072 5.94603 12.152 6.23965 10.7557C6.53328 9.3593 7.32144 8.11549 8.45951 7.25247C9.59757 6.38947 11.0092 5.96513 12.4354 6.05732C13.8615 6.1495 15.2066 6.75206 16.2237 7.7544C17.2407 8.75674 17.8617 10.0916 17.9725 11.5141C18.0832 12.9366 17.6765 14.3513 16.8268 15.4985C15.9772 16.6458 14.7416 17.4487 13.3469 17.7599C11.9521 18.0711 10.4918 17.8697 9.23375 17.1927L6 18.0556ZM9.38966 15.9947L9.58965 16.1131C10.5009 16.6523 11.5651 16.8755 12.6166 16.7478C13.6681 16.62 14.6478 16.1487 15.4029 15.4071C16.158 14.6655 16.6462 13.6954 16.7914 12.6479C16.9366 11.6003 16.7306 10.5343 16.2056 9.61586C15.6805 8.69742 14.8659 7.97817 13.8887 7.57018C12.9114 7.16222 11.8265 7.08844 10.8028 7.36036C9.77919 7.63225 8.87441 8.2346 8.22947 9.07348C7.58453 9.91237 7.23565 10.9407 7.23722 11.9981C7.23638 12.875 7.47926 13.7349 7.93889 14.482L8.06431 14.6885L7.58298 16.4753L9.38966 15.9947Z",
                            fill: secondColor
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_3",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M14.2432 12.8197C14.126 12.7253 13.9887 12.6589 13.8419 12.6254C13.695 12.592 13.5425 12.5925 13.3958 12.6268C13.1755 12.7182 13.0331 13.0634 12.8908 13.236C12.8607 13.2773 12.8166 13.3063 12.7667 13.3176C12.7168 13.3288 12.6645 13.3214 12.6196 13.2969C11.813 12.9815 11.1368 12.4031 10.7011 11.6556C10.6639 11.609 10.6463 11.5497 10.652 11.4904C10.6577 11.4311 10.6862 11.3763 10.7315 11.3375C10.8903 11.1806 11.0069 10.9862 11.0705 10.7724C11.0846 10.5365 11.0305 10.3016 10.9146 10.0956C10.825 9.80676 10.6544 9.54959 10.4231 9.35447C10.3038 9.3009 10.1715 9.28294 10.0422 9.30276C9.91286 9.32257 9.79205 9.3793 9.69431 9.46614C9.52464 9.61227 9.38999 9.79454 9.30024 9.99952C9.21047 10.2045 9.16792 10.427 9.17571 10.6505C9.17621 10.7761 9.19217 10.9011 9.22315 11.0228C9.30187 11.3151 9.42291 11.5945 9.58246 11.8519C9.69756 12.0491 9.82317 12.24 9.95871 12.4238C10.3992 13.0275 10.9529 13.5401 11.5891 13.9331C11.9084 14.1328 12.2496 14.2952 12.606 14.417C12.9763 14.5845 13.3851 14.6489 13.789 14.6031C14.0192 14.5683 14.2372 14.4776 14.424 14.3389C14.6108 14.2003 14.7606 14.0179 14.8602 13.8079C14.9187 13.681 14.9364 13.5391 14.911 13.4018C14.85 13.1209 14.4737 12.9551 14.2432 12.8197Z",
                            fill: secondColor
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/YoutubeIcon.tsx


var YoutubeIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 29 : _width, _height = param.height, height = _height === void 0 ? 29 : _height, _alt = param.alt, alt = _alt === void 0 ? "\xcdcone do Youtube" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.560 */.rS.colors.neutral[560] : _secondColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 29 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1527_13316)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.2542 3.6709H14.4099C15.8484 3.67615 23.1372 3.72865 25.1024 4.25715C25.6965 4.41844 26.2379 4.73284 26.6724 5.16891C27.107 5.60499 27.4195 6.14747 27.5787 6.74215C27.7554 7.40715 27.8797 8.2874 27.9637 9.19565L27.9812 9.37765L28.0197 9.83265L28.0337 10.0146C28.1474 11.6141 28.1614 13.1121 28.1632 13.4394V13.5706C28.1614 13.9101 28.1457 15.5096 28.0197 17.1756L28.0057 17.3594L27.9899 17.5414C27.9024 18.5424 27.7729 19.5364 27.5787 20.2679C27.42 20.8628 27.1076 21.4056 26.673 21.8417C26.2384 22.2779 25.6968 22.5921 25.1024 22.7529C23.0724 23.2989 15.3567 23.3374 14.2874 23.3391H14.0389C13.4982 23.3391 11.2617 23.3286 8.91667 23.2481L8.61917 23.2376L8.46692 23.2306L8.16767 23.2184L7.86842 23.2061C5.92592 23.1204 4.07617 22.9821 3.22392 22.7512C2.62977 22.5905 2.08828 22.2765 1.65368 21.8407C1.21909 21.4049 0.906649 20.8625 0.747667 20.2679C0.553417 19.5381 0.423917 18.5424 0.336417 17.5414L0.322417 17.3576L0.308417 17.1756C0.22205 15.9898 0.174192 14.8016 0.164917 13.6126L0.164917 13.3974C0.168417 13.0211 0.182417 11.7209 0.276917 10.2859L0.289167 10.1056L0.294417 10.0146L0.308417 9.83265L0.346917 9.37765L0.364417 9.19565C0.448417 8.2874 0.572667 7.4054 0.749417 6.74215C0.908131 6.14723 1.22045 5.60449 1.65507 5.16834C2.08968 4.73219 2.63131 4.41796 3.22567 4.25715C4.07792 4.02965 5.92767 3.88965 7.87017 3.80215L8.16767 3.7899L8.46867 3.7794L8.61917 3.77415L8.91842 3.7619C10.5839 3.7083 12.2501 3.67855 13.9164 3.67265H14.2542V3.6709ZM11.3649 9.2884V17.7199L18.6397 13.5059L11.3649 9.2884Z",
                    fill: secondColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1527_13316",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "28",
                        height: "28",
                        fill: color,
                        transform: "translate(0.164917 0.172852)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ShoppingFlowIcon.tsx

var ShoppingFlowIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "121" : _width, _height = param.height, height = _height === void 0 ? "121" : _height, _alt = param.alt, alt = _alt === void 0 ? "\xedcone de fluxo de compras" : _alt, _opacity = param.opacity, opacity = _opacity === void 0 ? "0.2" : _opacity;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        "aria-labelledby": alt,
        viewBox: "0 0 121 121",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.486816",
                width: "120",
                height: "120",
                rx: "12.1582",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M99.1575 69.5918C97.4142 69.5918 96 70.9117 96 72.5396C96 74.1674 97.4142 75.4866 99.1575 75.4866H107.842C109.586 75.4866 111 74.1667 111 72.5396C111 70.9124 109.586 69.5926 107.842 69.5926C107.842 67.3541 105.898 65.5396 103.5 65.5396C101.102 65.5396 99.1575 67.3533 99.1575 69.5918Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.3315 12.78C10.1509 12.78 9.19312 13.6739 9.19312 14.7764C9.19312 15.8789 10.1509 16.7722 11.3315 16.7722H17.2129C18.3941 16.7722 19.3518 15.8783 19.3518 14.7764C19.3518 13.6744 18.3941 12.7805 17.2134 12.7805C17.2134 11.2645 15.8967 10.0356 14.2725 10.0356C12.6482 10.0356 11.3315 11.264 11.3315 12.78Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M105.824 28.6815C104.491 28.6815 103.411 29.6903 103.411 30.9345C103.411 32.1786 104.491 33.1868 105.824 33.1868H112.461C113.794 33.1868 114.875 32.1781 114.875 30.9345C114.875 29.6909 113.794 28.6821 112.462 28.6821C112.462 26.9713 110.976 25.5845 109.143 25.5845C107.31 25.5845 105.824 26.9707 105.824 28.6815Z",
                    stroke: "#8F9194",
                    strokeWidth: "0.509524",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M100.332 107.78C99.1509 107.78 98.1931 108.673 98.1931 109.776C98.1931 110.878 99.1509 111.772 100.332 111.772H106.213C107.394 111.772 108.352 110.878 108.352 109.776C108.352 108.674 107.394 107.78 106.213 107.78C106.213 106.264 104.897 105.035 103.272 105.035C101.648 105.035 100.332 106.264 100.332 107.78Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M79.7459 11.0025C78.1294 11.0025 76.8181 12.2264 76.8181 13.7359C76.8181 15.2453 78.1294 16.4685 79.7459 16.4685H87.7983C89.4156 16.4685 90.7268 15.2446 90.7268 13.7359C90.7268 12.2271 89.4156 11.0033 87.7991 11.0033C87.7991 8.92766 85.9963 7.24512 83.7725 7.24512C81.5486 7.24512 79.7459 8.92694 79.7459 11.0025Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M38.7249 51.9723C37.1148 51.9723 35.8088 53.1912 35.8088 54.6946C35.8088 56.198 37.1148 57.4162 38.7249 57.4162H46.7449C48.3556 57.4162 49.6616 56.1973 49.6616 54.6946C49.6616 53.192 48.3556 51.973 46.7456 51.973C46.7456 49.9058 44.9501 48.23 42.7352 48.23C40.5203 48.23 38.7249 49.905 38.7249 51.9723Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M82.7249 45.9723C81.1148 45.9723 79.8088 47.1912 79.8088 48.6946C79.8088 50.198 81.1148 51.4162 82.7249 51.4162H90.7449C92.3556 51.4162 93.6616 50.1973 93.6616 48.6946C93.6616 47.192 92.3556 45.973 90.7456 45.973C90.7456 43.9058 88.9501 42.23 86.7352 42.23C84.5203 42.23 82.7249 43.905 82.7249 45.9723Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M38.3315 78.9758C37.1509 78.9758 36.1931 79.8697 36.1931 80.9722C36.1931 82.0747 37.1509 82.968 38.3315 82.968H44.2129C45.3941 82.968 46.3518 82.0741 46.3518 80.9722C46.3518 79.8702 45.3941 78.9763 44.2134 78.9763C44.2134 77.4604 42.8967 76.2314 41.2725 76.2314C39.6482 76.2314 38.3315 77.4598 38.3315 78.9758Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.3315 101.539C11.1509 101.539 10.1931 102.433 10.1931 103.536C10.1931 104.638 11.1509 105.532 12.3315 105.532H18.2129C19.3941 105.532 20.3518 104.638 20.3518 103.536C20.3518 102.434 19.3941 101.54 18.2134 101.54C18.2134 100.024 16.8967 98.7949 15.2725 98.7949C13.6482 98.7949 12.3315 100.023 12.3315 101.539Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M49.7249 105.972C48.1148 105.972 46.8088 107.191 46.8088 108.694C46.8088 110.198 48.1148 111.416 49.7249 111.416H57.7449C59.3556 111.416 60.6616 110.197 60.6616 108.694C60.6616 107.191 59.3556 105.973 57.7456 105.973C57.7456 103.905 55.9501 102.229 53.7352 102.229C51.5203 102.229 49.7249 103.905 49.7249 105.972Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.72485 58.3092C7.11485 58.3092 5.80884 59.5281 5.80884 61.0315C5.80884 62.5349 7.11485 63.7532 8.72485 63.7532H16.7449C18.3556 63.7532 19.6616 62.5342 19.6616 61.0315C19.6616 59.5289 18.3556 58.3099 16.7456 58.3099C16.7456 56.2427 14.9501 54.5669 12.7352 54.5669C10.5203 54.5669 8.72485 56.242 8.72485 58.3092Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.5 24.4868H28.4987C24.084 24.4868 20.5 28.1298 20.5 32.6172V75.9868",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M86.5 24.4868H92.5013C96.916 24.4868 100.5 28.1298 100.5 32.6172V75.9868",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M55.1666 19.1535V17.8201V17.8201C55.1666 14.8748 57.5546 12.4868 60.5 12.4868V12.4868C63.4453 12.4868 65.8333 14.8748 65.8333 17.8201V17.8201V19.1535",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M68.2867 36.4867H52.7134C51.16 36.4867 49.936 35.164 50.0547 33.616L51.072 20.3853C51.1254 19.6893 51.704 19.1533 52.4014 19.1533H68.5987C69.296 19.1533 69.8747 19.6893 69.928 20.384L70.9454 33.6147C71.0654 35.164 69.84 36.4867 68.2867 36.4867Z",
                fill: "white",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M51.4184 57.8794C47.516 58.4027 44.5 61.654 44.5 65.6297C44.5 69.9684 48.0824 73.4868 52.5 73.4868H70.1C73.6344 73.4868 76.5 70.6724 76.5 67.2011C76.5 63.7298 73.6344 60.9154 70.1 60.9154C70.1 55.7077 65.8024 51.4868 60.5 51.4868C56.2808 51.4868 52.7064 54.163 51.4184 57.8794Z",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M60.75 58.4868L63.6667 61.4035H55.5",
                stroke: "#68A439",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58.4167 68.987L55.5 66.0703H63.6667",
                stroke: "#68A439",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M37.25 103.153H13.25C12.5136 103.153 11.9166 102.556 11.9166 101.82V85.8197C11.9166 85.0833 12.5136 84.4863 13.25 84.4863H37.25C37.9863 84.4863 38.5833 85.0833 38.5833 85.8197V101.82C38.5833 102.556 37.9863 103.153 37.25 103.153Z",
                fill: "white",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "21.25",
                y: "103.153",
                width: "8",
                height: "5.33333",
                fill: "white",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.5833 99.1533H11.9166",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.25 108.486H31.25",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M47.25 96.4863C47.25 95.934 47.5924 95.4863 48.0147 95.4863H72.4853C72.9076 95.4863 73.25 95.934 73.25 96.4863C73.25 97.0386 72.9076 97.4863 72.4853 97.4863H48.0147C47.5924 97.4863 47.25 97.0386 47.25 96.4863Z",
                fill: "#53565A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M103.25 87.153V105.82C103.25 107.292 102.056 108.486 100.583 108.486H89.9167C88.4439 108.486 87.25 107.292 87.25 105.82V87.153C87.25 85.6802 88.4439 84.4863 89.9167 84.4863H100.583C102.056 84.4863 103.25 85.6802 103.25 87.153Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M103.25 87.153V105.82C103.25 107.292 102.056 108.486 100.583 108.486H89.9167C88.4439 108.486 87.25 107.292 87.25 105.82V87.153C87.25 85.6802 88.4439 84.4863 89.9167 84.4863H100.583C102.056 84.4863 103.25 85.6802 103.25 87.153",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M92.5834 104.486H97.9167",
                stroke: "#53565A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowLeftCategoriesIcon.tsx

var ArrowLeftCategoriesIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "9",
        height: "8",
        "data-testid": "arrow-left-icon",
        viewBox: "0 0 9 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.97586 7.97587L4.74291 7.21735L2.07956 4.554H8.7699V3.44605H2.07956L4.74291 0.786954L3.97586 0.0241699L1.14441e-05 4.00002L3.97586 7.97587Z",
            fill: "black"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/MyOrdersIcon.tsx


var MyOrdersIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "20" : _width, _height = param.height, height = _height === void 0 ? "20" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _testId = param.testId, testId = _testId === void 0 ? "my-orders-icon" : _testId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "data-testid": testId,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.4392 13.3329V6.6679C17.4392 6.07207 17.1217 5.52207 16.6058 5.22457L10.8342 1.89207C10.3183 1.59457 9.68333 1.59457 9.1675 1.89207L3.39583 5.22457C2.88 5.52207 2.5625 6.0729 2.5625 6.6679V13.3321C2.5625 13.9279 2.88 14.4779 3.39583 14.7754L9.1675 18.1087C9.68333 18.4062 10.3183 18.4062 10.8342 18.1087L16.6058 14.7762C17.1217 14.4787 17.4392 13.9279 17.4392 13.3329Z",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.14258 10.5254L7.64258 11.9754",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.78516 5.83398L10.0002 9.99982L17.2152 5.83398",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.0007 18.3333V10",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.39258 7.91667L13.8342 3.625",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/MyAccountIcon.tsx


var MyAccountIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "20" : _width, _height = param.height, height = _height === void 0 ? "20" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _testId = param.testId, testId = _testId === void 0 ? "my-account-icon" : _testId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "data-testid": testId,
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.2612 8.4823C8.91207 9.13317 8.91207 10.1884 8.2612 10.8393C7.61032 11.4902 6.55505 11.4902 5.90417 10.8393C5.2533 10.1884 5.2533 9.13317 5.90417 8.4823C6.55505 7.83142 7.61032 7.83142 8.2612 8.4823",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 9.16667H15.8333",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 12.0837H12.5",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.99935 15.0345C9.85768 14.6786 9.63852 14.3586 9.35685 14.0978V14.0978C8.88102 13.657 8.25602 13.4111 7.60685 13.4111H6.55852C5.90935 13.4111 5.28435 13.6561 4.80852 14.0978V14.0978C4.52685 14.3578 4.30768 14.6778 4.16602 15.0345",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.832 5.83366H9.16536C8.70536 5.83366 8.33203 5.46033 8.33203 5.00033V2.50033C8.33203 2.04033 8.70536 1.66699 9.16536 1.66699H10.832C11.292 1.66699 11.6654 2.04033 11.6654 2.50033V5.00033C11.6654 5.46033 11.292 5.83366 10.832 5.83366Z",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.33268 4.16699H3.36685C2.42768 4.16699 1.66602 4.92866 1.66602 5.86783V15.8337C1.66602 16.7545 2.41185 17.5003 3.33268 17.5003H16.666C17.5868 17.5003 18.3327 16.7545 18.3327 15.8337V5.83366C18.3327 4.91283 17.5868 4.16699 16.666 4.16699H11.666",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/MyDataIcon.tsx


var MyDataIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "20" : _width, _height = param.height, height = _height === void 0 ? "20" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _testId = param.testId, testId = _testId === void 0 ? "my-data-icon" : _testId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "data-testid": testId,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.4069 12.1768V13.0101",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.9069 12.1768V13.0101",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.834 5.94792H15.0111",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.41667 5.53125V6.36458",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.91667 5.53125V6.36458",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2.5",
                y: "2.60449",
                width: "15",
                height: "6.66667",
                rx: "1.5",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.16667 15.9372H3.75C3.05964 15.9372 2.5 15.3775 2.5 14.6872V10.5205C2.5 9.83015 3.05964 9.27051 3.75 9.27051",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0857 14.9697L11.895 16.1638C11.7487 16.3113 11.6664 16.5105 11.666 16.7183V17.5492C11.666 17.9824 12.0172 18.3336 12.4504 18.3337H13.2849C13.4931 18.3339 13.6928 18.2508 13.8394 18.1029L15.0261 16.9128",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.087 14.9691C12.7976 13.806 13.3196 12.5928 14.363 12.0032C15.4065 11.4137 16.7151 11.5926 17.5619 12.4407C18.4088 13.2887 18.5859 14.5976 17.9949 15.6402C17.4039 16.6828 16.19 17.2032 15.0273 16.9121",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.7083 14.3337C15.7083 14.3567 15.6896 14.3753 15.6666 14.3753C15.6436 14.3753 15.625 14.3567 15.625 14.3337C15.625 14.3107 15.6436 14.292 15.6666 14.292C15.6777 14.292 15.6883 14.2964 15.6961 14.3042C15.704 14.312 15.7084 14.3226 15.7083 14.3337",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/MySecurityIcon.tsx


var MySecurityIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "20" : _width, _height = param.height, height = _height === void 0 ? "20" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _testId = param.testId, testId = _testId === void 0 ? "my-security-icon" : _testId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        "data-testid": testId,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.166 17.5H5.83268C4.91185 17.5 4.16602 16.7542 4.16602 15.8333V9.16667C4.16602 8.24583 4.91185 7.5 5.83268 7.5H14.166C15.0868 7.5 15.8327 8.24583 15.8327 9.16667V15.8333C15.8327 16.7542 15.0868 17.5 14.166 17.5Z",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.9987 14.2413V12.083",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.4419 11.0161C10.686 11.2601 10.686 11.6559 10.4419 11.8999C10.1979 12.144 9.80214 12.144 9.55806 11.8999C9.31398 11.6559 9.31398 11.2601 9.55806 11.0161C9.80214 10.772 10.1979 10.772 10.4419 11.0161",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.66602 7.5V5.83333V5.83333C6.66602 3.9925 8.15852 2.5 9.99935 2.5V2.5C11.8402 2.5 13.3327 3.9925 13.3327 5.83333V5.83333V7.5",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/MyCardsIcon.tsx


var MyCardsIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "20" : _width, _height = param.height, height = _height === void 0 ? "20" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _testId = param.testId, testId = _testId === void 0 ? "my-cards-icon" : _testId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "data-testid": testId,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.00065 13.333H4.16732C3.01672 13.333 2.08398 12.4003 2.08398 11.2497V5.41634C2.08398 4.26575 3.01672 3.33301 4.16732 3.33301H13.334C14.4846 3.33301 15.4173 4.26575 15.4173 5.41634V6.66634",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "5.41602",
                y: "6.66699",
                width: "12.5",
                height: "10",
                rx: "2.5",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.41602 9.99967H17.916",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.0007 13.3337H8.33398",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/WeddingRingIcon.tsx


var WeddingRingIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "20" : _width, _height = param.height, height = _height === void 0 ? "20" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.1576 9.6758C17.9475 11.4657 17.9475 14.3677 16.1576 16.1576C14.3677 17.9475 11.4657 17.9475 9.6758 16.1576C7.8859 14.3677 7.8859 11.4657 9.6758 9.6758C11.4657 7.8859 14.3677 7.8859 16.1576 9.6758",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.3242 9.6758C12.1141 11.4657 12.1141 14.3677 10.3242 16.1576C8.53433 17.9475 5.63233 17.9475 3.84243 16.1576C2.05252 14.3677 2.05252 11.4657 3.84243 9.6758C5.63233 7.8859 8.53433 7.8859 10.3242 9.6758",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.5 3.07252C12.5 3.43752 12.3425 3.78835 12.0617 4.05002L10.2192 5.77002C10.0958 5.88502 9.90417 5.88502 9.78 5.77002L7.93833 4.05085C7.6575 3.78835 7.5 3.43752 7.5 3.07252V3.07252C7.5 2.29585 8.12917 1.66669 8.90583 1.66669H11.0942C11.8708 1.66669 12.5 2.29585 12.5 3.07252V3.07252V3.07252Z",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/MyListsIcon.tsx


var MyListsIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "20" : _width, _height = param.height, height = _height === void 0 ? "20" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.49902 5.36392H16.6695",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.6695 10H7.49902",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.49902 14.6361H16.6695",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.74741 4.94708C3.51719 4.94708 3.33057 5.13371 3.33057 5.36392C3.33057 5.59414 3.51719 5.78076 3.74741 5.78076C3.97762 5.78076 4.16425 5.59414 4.16425 5.36392C4.16425 5.13371 3.97762 4.94708 3.74741 4.94708",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.74741 9.58319C3.51719 9.58319 3.33057 9.76982 3.33057 10C3.33057 10.2302 3.51719 10.4169 3.74741 10.4169C3.97762 10.4169 4.16425 10.2302 4.16425 10C4.16425 9.76982 3.97762 9.58319 3.74741 9.58319",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.74741 14.2193C3.51719 14.2193 3.33057 14.4059 3.33057 14.6361C3.33057 14.8664 3.51719 15.053 3.74741 15.053C3.97762 15.053 4.16425 14.8664 4.16425 14.6361C4.16425 14.4059 3.97762 14.2193 3.74741 14.2193",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AddressListIcon.tsx


var AddressListIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _alt = param.alt, alt = _alt === void 0 ? "meus endere\xe7os" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _testId = param.testId, testId = _testId === void 0 ? "address-list-icon" : _testId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        "data-testid": testId,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.6663 28H7.99967C7.29262 28.0002 6.61445 27.7195 6.11436 27.2197C5.61426 26.7199 5.3332 26.0419 5.33301 25.3348V6.66667C5.33281 5.95962 5.6135 5.28145 6.11332 4.78135C6.61314 4.28125 7.29116 4.00019 7.99821 4H23.9997C24.7067 3.9998 25.3849 4.28049 25.885 4.78031C26.3851 5.28013 26.6661 5.95815 26.6663 6.6652V13.3333",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.16309 10.6667H7.33315",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.16309 15.9997H7.33315",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 21.3337H7.33333",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.667 19.9997V25.333C14.667 26.8058 15.8609 27.9997 17.3337 27.9997H25.3337C26.8064 27.9997 28.0003 26.8058 28.0003 25.333V19.9997C28.0003 18.5269 26.8064 17.333 25.3337 17.333H17.3337C15.8609 17.333 14.667 18.5269 14.667 19.9997Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.333 21.333L20.7405 22.5274C21.1138 22.7127 21.5523 22.7127 21.9257 22.5274L24.333 21.333",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/automotivo.tsx

var AutomotivoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.3335 7.5L16.1501 8.33333",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.85841 8.33333L1.66675 7.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.2083 11.6667H13.125",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.87508 11.6667H4.79175",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.1493 8.33337L15.4501 4.99004C15.2476 4.02504 14.3968 3.33337 13.4101 3.33337H6.67679C5.70929 3.33337 4.86846 4.00004 4.64846 4.94254L3.85596 8.33337",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.70841 16.6667H4.58341C5.27341 16.6667 5.83341 16.1067 5.83341 15.4167V14.5834H14.1667V15.4167C14.1667 16.1067 14.7267 16.6667 15.4167 16.6667H17.2917C17.8667 16.6667 18.3334 16.2 18.3334 15.625V10.8334C18.3334 9.45254 17.2142 8.33337 15.8334 8.33337H4.16675C2.78591 8.33337 1.66675 9.45254 1.66675 10.8334V15.625C1.66675 16.2 2.13341 16.6667 2.70841 16.6667Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/cama-mesa-e-banho.tsx

var CamaMesaEBanhoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.33341 10H16.6667C17.5872 10 18.3334 10.7462 18.3334 11.6667V15C18.3334 15.4602 17.9603 15.8333 17.5001 15.8333H2.50008C2.03984 15.8333 1.66675 15.4602 1.66675 15V11.6667C1.66675 10.7462 2.41294 10 3.33341 10Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.33325 10V5.83337C3.33325 4.45266 4.45254 3.33337 5.83325 3.33337H14.1666C15.5473 3.33337 16.6666 4.45266 16.6666 5.83337V10",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "5.83325",
                y: "6.66663",
                width: "8.33333",
                height: "3.33333",
                rx: "1.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.4999 15.8334V17.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.49992 15.8334V17.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/eletro-e-eletronicos.tsx

var EletronicosIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "11.6667",
                y: "7.5",
                width: "6.66667",
                height: "10",
                rx: "1.75",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "15",
                cy: "13.75",
                r: "1.25",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.2593 9.72221H15.7408",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.16667 13.3333H4.16667C3.24619 13.3333 2.5 12.5871 2.5 11.6667V4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H15.8333C16.7538 2.5 17.5 3.24619 17.5 4.16667V5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 15.8333H9.16667",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/loucas-metais-e-acessorios.tsx

var LoucasMetaisEAcessoriosIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.3033 3.59835C18.2322 5.06282 18.2322 7.43718 15.3033 8.90165C12.3744 10.3661 7.62562 10.3661 4.6967 8.90165C1.76777 7.43718 1.76777 5.06282 4.6967 3.59835C7.62563 2.13388 12.3744 2.13388 15.3033 3.59835",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0832 11.2509C15.574 12.4134 12.9798 13.19 9.99984 13.19C7.01984 13.19 4.42567 12.4134 2.9165 11.2509",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0832 14.7275C15.574 15.89 12.9798 16.6667 9.99984 16.6667C7.01984 16.6667 4.42567 15.89 2.9165 14.7275",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.95654 5.83333C7.60488 5.33417 8.71988 5 9.99988 5C11.2799 5 12.3949 5.33417 13.0432 5.83333",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/materiais-eletricos.tsx

var MateriaisEletricosIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.99985 11.7317V13.4632",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.11386 7.69165V9.4232",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.8861 7.69165V9.4232",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "9.99995",
                cy: "10.0001",
                r: "7.50312",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/materiais-hidraulicos.tsx

var MateriaisHidraulicosIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.93095 4V5.42857V6.85713H8.74992M3.33325 4C3.33325 4 3.33325 7.87998 3.33325 9.14284C3.33325 10.4057 4.36199 11.4285 5.6321 11.4285H8.74992M12.0689 15.9999V11.4285H11.6666M16.6666 15.9999C16.6666 14.4761 16.6666 10.9714 16.6666 9.14284C16.6666 7.31427 15.134 6.85713 14.3677 6.85713H13.908H11.8514",
                stroke: "black",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.8333 6.16663C11.1094 6.16663 11.3333 6.39048 11.3333 6.66663L11.3333 11.6666C11.3333 11.9428 11.1094 12.1666 10.8333 12.1666L9.99992 12.1666C9.72378 12.1666 9.49992 11.9428 9.49992 11.6666L9.49992 6.66663C9.49992 6.39048 9.72378 6.16663 9.99992 6.16663L10.8333 6.16663Z",
                stroke: "black",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.83333 2.40002C8.83333 2.12388 8.60948 1.90002 8.33333 1.90002L2.5 1.90002C2.22386 1.90002 2 2.12388 2 2.40002V3.20002C2 3.47616 2.22386 3.70002 2.5 3.70002L8.33333 3.70002C8.60948 3.70002 8.83333 3.47616 8.83333 3.20002V2.40002Z",
                stroke: "black",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.0001 16.7999C18.0001 16.5238 17.7762 16.2999 17.5001 16.2999H11.6667C11.3906 16.2999 11.1667 16.5238 11.1667 16.7999V17.5999C11.1667 17.8761 11.3906 18.0999 11.6667 18.0999H17.5001C17.7762 18.0999 18.0001 17.8761 18.0001 17.5999V16.7999Z",
                stroke: "black",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/moveis-e-decoracao.tsx

var MoveisEDecoracaoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 2.50004H2.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2.5",
                y: "2.5",
                width: "15",
                height: "3.33333",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 5.83337H17.5V16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H10.8333C10.3731 17.5 10 17.1269 10 16.6667V5.83337Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.49992 17.5V5.83337",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 11.6667H10",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.9167 8.33329H14.5834",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.3334 2.50004H1.66675",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.9167 14.1667H14.5834",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/pisos-e-revestimentos.tsx

var PisosERevestimentosIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.3475 16.875H4.6525C3.80833 16.875 3.125 16.1908 3.125 15.3475V4.6525C3.125 3.80833 3.80917 3.125 4.6525 3.125H15.3467C16.1908 3.125 16.8742 3.80917 16.8742 4.6525V15.3467C16.875 16.1908 16.1908 16.875 15.3475 16.875Z",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/portas-janelas-e-fechaduras.tsx

var PortasJanelasEFechadurasIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.35093 9.99997C8.89343 10.5083 8.2376 10.8333 7.5001 10.8333C5.9726 10.8333 4.7651 9.46331 5.03927 7.88414C5.2151 6.87414 6.04593 6.04831 7.05593 5.87164C7.97177 5.71247 8.80343 6.05831 9.35093 6.66664H16.6668C17.1268 6.66664 17.5001 7.03997 17.5001 7.49997V9.16664C17.5001 9.62664 17.1268 9.99997 16.6668 9.99997H9.35093Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 10V15.8333C12.5 16.7542 11.7542 17.5 10.8333 17.5H4.16667C3.24583 17.5 2.5 16.7542 2.5 15.8333V4.16667C2.5 3.24583 3.24583 2.5 4.16667 2.5H10.8333C11.7542 2.5 12.5 3.24583 12.5 4.16667V6.66667",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.99992 14.1583C4.99742 14.1583 4.99575 14.16 4.99575 14.1625C4.99575 14.165 4.99742 14.1667 4.99992 14.1667C5.00242 14.1667 5.00409 14.165 5.00409 14.1625C5.00409 14.16 5.00242 14.1583 4.99992 14.1583",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.50407 14.1583C7.50157 14.1583 7.4999 14.16 7.4999 14.1625C7.4999 14.165 7.5024 14.1667 7.50407 14.1667C7.50657 14.1667 7.50824 14.165 7.50824 14.1625C7.50824 14.16 7.50657 14.1583 7.50407 14.1583",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.99992 14.1583C9.99742 14.1583 9.99575 14.16 9.99575 14.1625C9.99575 14.165 9.99742 14.1667 9.99992 14.1667C10.0024 14.1667 10.0041 14.165 10.0041 14.1625C10.0041 14.16 10.0024 14.1583 9.99992 14.1583",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/tintas-e-quimicos.tsx

var TintasEQuimicosIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.9792 7.5H3.52083C2.95667 7.5 2.5 7.04333 2.5 6.47917V3.52083C2.5 2.95667 2.95667 2.5 3.52083 2.5H13.98C14.5433 2.5 15 2.95667 15 3.52083V6.48C15 7.04333 14.5433 7.5 13.9792 7.5V7.5Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 18.3333H8.33333C7.87333 18.3333 7.5 17.96 7.5 17.5V13.3333C7.5 12.8733 7.87333 12.5 8.33333 12.5H10C10.46 12.5 10.8333 12.8733 10.8333 13.3333V17.5C10.8333 17.96 10.46 18.3333 10 18.3333Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.16675 12.5V10.8333C9.16675 10.3733 9.54008 10 10.0001 10H16.6667C17.1267 10 17.5001 9.62667 17.5001 9.16667V5.83333C17.5001 5.37333 17.1267 5 16.6667 5H15.0001",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/utilidades-domesticas.tsx

var UtilidadesDomesticasIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.8337 16.6694H16.8084C17.242 16.6694 17.6032 16.3371 17.6392 15.905L18.3339 7.5682C18.3533 7.33586 18.2745 7.10604 18.1166 6.93447C17.9588 6.76291 17.7363 6.66528 17.5031 6.66528H7.49902",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.66633 14.1685H2.83073C2.43334 14.1685 2.09118 14.449 2.01324 14.8386L1.67977 16.506C1.63079 16.7509 1.69419 17.0049 1.85254 17.198C2.01089 17.3912 2.2475 17.5032 2.49725 17.5032H9.9998C10.2496 17.5032 10.4862 17.3912 10.6445 17.198C10.8029 17.0049 10.8663 16.7509 10.8173 16.506L10.4838 14.8386C10.4059 14.4489 10.0637 14.1685 9.66633 14.1685Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.8358 6.6653V5.77677C15.8358 4.16527 14.5294 2.85889 12.9179 2.85889V2.85889C11.3064 2.85889 10 4.16527 10 5.77677V6.6653",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.24857 1.66321V1.66321C6.93921 1.66321 7.49909 2.22309 7.49909 2.91373V13.7516C7.49909 13.9818 7.31246 14.1684 7.08225 14.1684H5.41489C5.18467 14.1684 4.99805 13.9818 4.99805 13.7516V2.91373C4.99805 2.22309 5.55792 1.66321 6.24857 1.66321Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/ferramentas-e-epi.tsx

var FerramentasEEPIIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.1667 4.16667V7.5C14.1667 8.42047 13.4205 9.16667 12.5 9.16667H5.83333C3.99238 9.16667 2.5 7.67428 2.5 5.83333V5.83333C2.5 3.99238 3.99238 2.5 5.83333 2.5H12.5C13.4205 2.5 14.1667 3.24619 14.1667 4.16667Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.114 3.75H15.8334C16.2936 3.75 16.6667 4.1231 16.6667 4.58333V6.25C16.6667 6.71024 16.2936 7.08333 15.8334 7.08333H14.1667",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.6667 5.41667H18.3334",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.83325 5.83329H7.99865",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.58341 9.16663L7.91675 14.1666",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 9.16663V10.3553C12.5 11.0795 11.9129 11.6666 11.1886 11.6666H8.75",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75 14.1667L5.42495 9.14185",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2.5",
                y: "14.1666",
                width: "6.66667",
                height: "3.33333",
                rx: "1",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/iluminacao.tsx

var IluminacaoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 12.6584H7.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.11745 12.4134C5.63745 11.3675 4.74995 9.5417 5.06245 7.5317C5.40078 5.3592 7.21161 3.62504 9.39578 3.3692C12.4274 3.01337 14.9999 5.37337 14.9999 8.33337C14.9999 10.0209 14.1616 11.51 12.8808 12.415C12.6508 12.5775 12.4999 12.8292 12.4999 13.1109V15.4167C12.4999 16.5675 11.5674 17.5 10.4166 17.5H9.58328C8.43245 17.5 7.49995 16.5675 7.49995 15.4167V13.1142C7.49995 12.83 7.34828 12.5767 7.11745 12.4134Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.6665 4.16672L17.6582 3.17505",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.33322 12.5L2.34155 13.4917",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.16647 3.33334L3.1748 2.34167",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.6665 12.5L17.6582 13.4917",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 8.33329H18.9083",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.09155 8.33329H2.49989",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 15H12.3917",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/construcao.tsx

var ConstrucaoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.94517 8.88215L4.21864 16.3801C4.10801 16.6844 4.18362 17.0252 4.41256 17.2541C4.64149 17.4831 4.98231 17.5587 5.28658 17.448L12.7845 14.7215C13.0522 14.6242 13.2516 14.3969 13.3133 14.1188C13.375 13.8408 13.2904 13.5505 13.089 13.3491L8.31755 8.57769C8.11616 8.37631 7.82587 8.29173 7.54783 8.35341C7.26979 8.4151 7.04251 8.6145 6.94517 8.88215Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4775 8.14408L15.394 4.22748C15.9799 3.64165 15.9799 2.69183 15.394 2.106V2.106C15.1127 1.82467 14.7312 1.66663 14.3333 1.66663C13.9355 1.66663 13.5539 1.82467 13.2726 2.106L9.94525 5.43332C9.61981 5.75875 9.61981 6.28639 9.94525 6.61182L11.4775 8.14408Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.94523 6.61182L11.9108 8.57741C12.0671 8.73369 12.1549 8.94565 12.1549 9.16667C12.1549 9.38768 12.0671 9.59964 11.9108 9.75592L9.16675 12.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SubCategoriesIcons/index.tsx















;// CONCATENATED MODULE: ../../packages/ui/Icons/AlertWithDetail.tsx


var AlertWithDetail = function(param) {
    var _width = param.width, width = _width === void 0 ? 28 : _width, _height = param.height, height = _height === void 0 ? 28 : _height, _alt = param.alt, alt = _alt === void 0 ? "aten\xe7\xe3o" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.00033 3.48633V3.48633C10.4937 3.48633 12.5143 5.50699 12.5143 8.00033V8.00033C12.5143 10.4937 10.4937 12.5143 8.00033 12.5143V12.5143C5.50699 12.5143 3.48633 10.4937 3.48633 8.00033V8.00033C3.48633 5.50699 5.50699 3.48633 8.00033 3.48633Z",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.00033 8.25147V5.74414",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.99966 10.0312C7.94433 10.0312 7.89966 10.0759 7.90033 10.1312C7.90033 10.1865 7.945 10.2312 8.00033 10.2312C8.05566 10.2312 8.10033 10.1865 8.10033 10.1312C8.10033 10.0765 8.05566 10.0312 7.99966 10.0312",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.5508 3.83789C15.4028 6.29922 15.4028 9.69989 13.5508 12.1612",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.44466 12.1622C0.592664 9.70087 0.592664 6.3002 2.44466 3.83887",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowDownCircle.tsx


var ArrowDownCircle = function(param) {
    var _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.100 */.rS.colors.neutral[100] : _color, _height = param.height, height = _height === void 0 ? 56 : _height, _width = param.width, width = _width === void 0 ? 56 : _width, _alt = param.alt, alt = _alt === void 0 ? "Seta para cima" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: color,
        viewBox: "0 0 256 256",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm37.66,117.66-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,148.69V88a8,8,0,0,1,16,0v60.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ArrowUpCircle.tsx


var ArrowUpCircle = function(param) {
    var _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.100 */.rS.colors.neutral[100] : _color, _height = param.height, height = _height === void 0 ? 56 : _height, _width = param.width, width = _width === void 0 ? 56 : _width, _alt = param.alt, alt = _alt === void 0 ? "Seta para cima" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "aria-label": alt,
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: color,
        viewBox: "0 0 256 256",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm37.66,101.66a8,8,0,0,1-11.32,0L136,107.31V168a8,8,0,0,1-16,0V107.31l-18.34,18.35a8,8,0,0,1-11.32-11.32l32-32a8,8,0,0,1,11.32,0l32,32A8,8,0,0,1,165.66,125.66Z"
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthMethodsIcons/AppAuthenticationIcon.tsx


var AppAuthenticationIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? themes/* theme.space.x15 */.rS.space.x15 : _width, _height = param.height, height = _height === void 0 ? themes/* theme.space.x15 */.rS.space.x15 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _alt = param.alt, alt = _alt === void 0 ? "Autentica\xe7\xe3o por Aplicativo" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 61 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                width: "60",
                height: "60",
                rx: "30",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "30.7227",
                cy: "31.1866",
                r: "2.96296",
                fill: "#6D6F73",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M40.2042 33.5816C40.2042 38.0553 34.6992 41.3786 32.0739 42.713C31.2269 43.146 30.2237 43.1468 29.3759 42.7153C26.7525 41.3822 21.2412 38.0508 21.2412 33.5816V27.1205C21.2499 26.5151 21.7084 26.011 22.3104 25.9452C24.8252 25.7541 27.2363 24.8624 29.2704 23.3712C30.1323 22.7298 31.313 22.7298 32.175 23.3712C34.209 24.8624 36.6201 25.7541 39.135 25.9452C39.7369 26.011 40.1955 26.515 40.2042 27.1205V33.5816Z",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.9819 24.6679V21.1123V21.1123C25.9819 18.4942 28.1046 16.3716 30.7227 16.3716V16.3716C33.3407 16.3716 35.4634 18.4942 35.4634 21.1123V21.1123V24.6679",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M36.5312 39.84L35.9863 38.7502C35.4844 37.7464 34.4584 37.1123 33.3361 37.1123H28.1096C26.9873 37.1123 25.9614 37.7464 25.4595 38.7502L31.3157 43.0382",
                fill: "#6D6F73"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.5312 39.84L35.9863 38.7502C35.4844 37.7464 34.4584 37.1123 33.3361 37.1123H28.1096C26.9873 37.1123 25.9614 37.7464 25.4595 38.7502L31.3157 43.0382",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthMethodsIcons/EmailAuthenticationIcon.tsx


var EmailAuthenticationIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? themes/* theme.space.x15 */.rS.space.x15 : _width, _height = param.height, height = _height === void 0 ? themes/* theme.space.x15 */.rS.space.x15 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _alt = param.alt, alt = _alt === void 0 ? "Autentica\xe7\xe3o por E-mail" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 61 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                width: "60",
                height: "60",
                rx: "30",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.5005 23.0675V23.0675C18.5005 23.8675 18.9005 24.5341 19.5672 25.0675L27.5672 30.5341C29.4338 31.7341 31.7005 31.7341 33.5672 30.5341L41.5672 25.2008C42.1005 24.5341 42.5005 23.8675 42.5005 23.0675V23.0675C42.5005 21.7341 41.4338 20.6675 40.1005 20.6675H20.9005C19.5672 20.6675 18.5005 21.7341 18.5005 23.0675Z",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.5005 23.334V36.6673C18.5005 38.134 19.7005 39.334 21.1672 39.334H39.8338C41.3005 39.334 42.5005 38.134 42.5005 36.6673V23.334",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.2847 38.5501L27.41 30.4248",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.647 30.481L41.7163 38.5503",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthMethodsIcons/FaceAuthenticationIcon.tsx


var FaceAuthenticationIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? themes/* theme.space.x15 */.rS.space.x15 : _width, _height = param.height, height = _height === void 0 ? themes/* theme.space.x15 */.rS.space.x15 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _alt = param.alt, alt = _alt === void 0 ? "Autentica\xe7\xe3o por Biometria Facial" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 61 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                width: "60",
                height: "60",
                rx: "30",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.5007 26.1074V28.1074",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.5007 26.1074V28.1074",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.167 32.1304H29.8337C30.5697 32.1304 31.167 31.533 31.167 30.797V26.1304",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.8232 35.5435C32.4365 37.9301 28.5659 37.9301 26.1792 35.5435",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.6178 18.001H21.1672C19.6938 18.001 18.5005 19.1943 18.5005 20.6676V24.1183",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.3833 42.0011H39.834C41.3073 42.0011 42.5006 40.8078 42.5006 39.3345V35.8838",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.5005 35.8838V39.3345C18.5005 40.8078 19.6938 42.0011 21.1672 42.0011H24.6178",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.5006 24.1183V20.6676C42.5006 19.1943 41.3073 18.001 39.834 18.001H36.3833",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthMethodsIcons/PhoneAuthenticationIcon.tsx


var PhoneAuthenticationIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? themes/* theme.space.x15 */.rS.space.x15 : _width, _height = param.height, height = _height === void 0 ? themes/* theme.space.x15 */.rS.space.x15 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _alt = param.alt, alt = _alt === void 0 ? "Autentica\xe7\xe3o por Telefone" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 61 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                width: "60",
                height: "60",
                rx: "30",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M40.9658 35.8623C41.9392 34.129 42.5005 32.1316 42.5005 30.001C42.5005 23.373 37.1285 18.001 30.5005 18.001C23.8725 18.001 18.5005 23.373 18.5005 30.001C18.5005 36.629 23.8725 42.001 30.5005 42.001C32.6312 42.001 34.6285 41.4396 36.3618 40.4663L42.5005 42.001L40.9658 35.8623Z",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.2646 30.4316C30.3953 30.301 30.606 30.301 30.7366 30.4316C30.8673 30.5623 30.8673 30.773 30.7366 30.9036C30.606 31.0343 30.3953 31.0343 30.2646 30.9036C30.1353 30.773 30.1353 30.5623 30.2646 30.4316",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.9311 30.4316C25.0618 30.301 25.2725 30.301 25.4031 30.4316C25.5338 30.5623 25.5338 30.773 25.4031 30.9036C25.2725 31.0343 25.0618 31.0343 24.9311 30.9036C24.8018 30.773 24.8018 30.5623 24.9311 30.4316",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.5976 30.4316C35.7283 30.301 35.939 30.301 36.0696 30.4316C36.2003 30.5623 36.2003 30.773 36.0696 30.9036C35.939 31.0343 35.7283 31.0343 35.5976 30.9036C35.4683 30.773 35.4683 30.5623 35.5976 30.4316",
                stroke: "#6D6F73",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthMethodsIcons/DeviceComputerIcon.tsx


var DeviceComputerIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? themes/* theme.space.x11.75 */.rS.space["x11.75"] : _width, _height = param.height, height = _height === void 0 ? themes/* theme.space.x11.75 */.rS.space["x11.75"] : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _alt = param.alt, alt = _alt === void 0 ? "Icone de computador" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": alt,
        "data-testeid": "device-icon",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "6.49268",
                y: "8.43799",
                width: "35.0146",
                height: "25.2883",
                rx: "2.33333",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.2463 39.5621H32.7536",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthMethodsIcons/DeviceSmartphoneIcon.tsx


var DeviceSmartphoneIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? themes/* theme.space.x11.75 */.rS.space["x11.75"] : _width, _height = param.height, height = _height === void 0 ? themes/* theme.space.x11.75 */.rS.space["x11.75"] : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _alt = param.alt, alt = _alt === void 0 ? "Icone de computador" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": alt,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1111 8.02783V11.5278C20.1111 12.1714 20.5466 12.6945 21.0833 12.6945H26.9166C27.4533 12.6945 27.8889 12.1714 27.8889 11.5278V8.02783",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.8221 34.2779H26.1777",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.1666 8.02783H29.8333C31.9819 8.02783 33.7222 9.76811 33.7222 11.9167V35.2501C33.7222 37.3987 31.9819 39.1389 29.8333 39.1389H18.1666C16.018 39.1389 14.2777 37.3987 14.2777 35.2501V11.9167C14.2777 9.76811 16.018 8.02783 18.1666 8.02783Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthMethodsIcons/Browsers/BrowserDefaultIcon.tsx


var BrowserDefault = function(param) {
    var _width = param.width, width = _width === void 0 ? themes/* theme.space.x15 */.rS.space.x15 : _width, _height = param.height, height = _height === void 0 ? themes/* theme.space.x15 */.rS.space.x15 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _alt = param.alt, alt = _alt === void 0 ? "Autentica\xe7\xe3o por Aplicativo" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.560 */.rS.colors.neutral[560] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 6.2002C33.334 16.0542 33.334 31.9462 24 41.8002",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.9995 41.8002C14.6655 31.9462 14.6655 16.0542 23.9995 6.2002",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 6C33.964 6 42 14.036 42 24C42 33.964 33.964 42 24 42",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 42C14.036 42 6 33.964 6 24C6 14.036 14.036 6 24 6",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.01953 18H40.9795",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.01953 30H40.9795",
                stroke: color,
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthMethodsIcons/Browsers/MozilaFirefoxIcon.tsx

var MozilaFirefoxIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2.74268",
                y: "2.05713",
                width: "42.2316",
                height: "43.8857",
                fill: "url(#pattern0_1114_7735)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0_1114_7735",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_1114_7735",
                            transform: "scale(0.000833333 0.000801925)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_1114_7735",
                        width: "1200",
                        height: "1247",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthMethodsIcons/Browsers/AppFcIcon.tsx

var AppFcIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "2",
                width: "46",
                height: "44",
                fill: "url(#pattern0_1114_7726)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0_1114_7726",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_1114_7726",
                            transform: "matrix(0.00186335 0 0 0.00194805 0.0199078 0.00129838)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_1114_7726",
                        width: "512",
                        height: "512",
                        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAACAKADAAQAAAABAAACAAAAAAAL+LWFAABAAElEQVR4Aey9ba9t2XUmtM+591bduvV2k9iJXUnZ1+WyXR3b5KI0IEAiFSHxkbh/Qdy/wO5fYPMLKmmQGhRBdUiLhgBy+EJ/gjJIgPjQihE0Ei2EjbpFPqTTKXW6bce37jmMZ8zxjPXMseZae5+3+7bXqtp7jjnGM54x5phz7rn2Pvuce7LbrgtV4KP7D+/vdj+1x52H5nj/bHf+YHd2/vndycn9E+vvdicPTI/L5HN7bNfzVoFXv/zO7t5X3nne0r5Qvj/50T/ePf4XP06fV77w9u7WvVey/yIJ548+2f3Zf/c/7c4fPXqRhnVEYzn52AaLh13nP/Lnc2tPT/7f3e7049Pd2Q9M//FvfvwPrN2ui1Tg9kXAx4b96P57D+ygf9/G/Wtn5+cPTnYnD8/PPzEdynZuDzvu/cmfvU99dLbmOasADsEX/fB/zqbkyume3Lm9e+Wdt3c//r/+nytzbQRPowL+Rup+RH6A9uTEXnP9JdjegrnhZPffv/k1SD+w/o/shfl/O92d2A3B2Y+2GwMv0PBJT64h4JiUH93/2vtnu9OHu/Oz37DD/n1bYVx0x1SGox7r6w+/urv79mdf+Boc0ycAmEx8CvDn/+P/unv845+88HO7DbBW4OTj893593cnp/8DPi34zY//j+9XxLH2j/oGoH2c//gbZ2d24J+cfmM78I91G7Rx493/z//b/+ZRFOHYbgAwqT/9R3+y+4sf/IOjmN9tkGsV4A3ByX9zurv1/d/8+Ac/WkO/yLajuwHAoX+2O/vmye7st+yzo/df5MndxnaxChzLu39U5RhvADDuf2rfBdg+BUAltssr4D9KOP/++cnJ7x/jzcBR3AB8zw79V3aPvnl6vvst++nR+6c286dt4rddsFXAK3BM7/4x4HoDcPdzb+1uv/7aC78aHv3Zn+8+/p///gs/zm2AF6iAnQX2HS97P4j/dt9/fLL7/Z/u7vzRX/v4Bx9fgOW5hL7QNwB/z36mb1OKd/rfvLXzb+n7l/YwaNwEbNdWAVbgmN79Y8w//oc/3J3Jt+Lv/vJndrfvv8FyvNDtx//L3989+id//kKPcRvcxSqALxKe2QO3AGjtjeLHj8/P/+jO6e53/50X+LcLXsgbgP/2/te/8fj87Ft2yL+PAfLAx7v+E5tp1+EJs75dR1+B22++vvu5f+tfO6o6HPMNwPYpwFEt9YMGe2bngX0I4EcCbwLaTcE5zosfPD47+d1/9y/+wd8+iOw5AuEYfCGu791/cP/07N637JD/tk3gff+Y36YOA8QDffQovxCD3gZxLRW4/2/8+u7OL/zctXA9LyTHfAOAOdo+BXheVuoTytMOhsf+hhCfAJz4JwHtBiA+FcDNwcnuR2dnJ//eX3uBbgSe+0/CcfB/7433vrM7u/dDm6Dv4vDHIa9X69szBD4UsMlHW4GXPvPpozv8j3ayZeD4Y0/btVUgK2AHPL4W1t4m+p2Am1wFrQn26fGDk5OzD//ojb/yw++9/tVvOuA5f3qubwC+98Zf+dbZ2St28J989+RkOvj1jM8JxCRiknEHMM3vcz59W/pXrcBrX/3KVSk2/+ewAvjE586njutTn+dwmp5oyu3z4Smknh2uNYX/AaLd7sHu9OzD//qN9374h6+/983J4/mTnssbgP/y/nvv/+Gb7/3w8e78d+w8v8+DnROGacBkat91mED8oGe7tgpYBe6+/Zb9+du7Wy2OtALbpwBHOvFLw7azAWdGOzv09ChnCUx+jJw8OD3ZffhfPcc3As/VDcDftT/N+5+/+d5H52e7j/zjGExXHug2I/Y/pw1f5ODVTV/7nIemrT3iCtw74o+Bz88edzNf+53xBe3gUwDcBG7XVgGvgB0ePD/Q8oGDxeU4Uvw8MQV0eDb1A2s+/C9e/8r3cEa5+jl5ei5uAPBz/r/7xpe/c3K2+6Ed/O9rbf1uDTORk4Mv/LUjH+ru8AcmbxiUZZOPrQLH/u7//HH7ZSfOe+1T/6K3x3wT+KLP7UXHh0+S68UzBCb/HgBaPPK8wc0BNFCefMP+oMAPcVY1xbP//MzfAPyBfdz/47OX/9iq+12Us01Ia9nHme5TEPPQ9K2D+7P0ETsw23W8Fdhe+I937nXk+BHQ9o8/aUWOXLYzwg/6OCvwM3+eH34TYOU5jwNnOk7aGYPKBfq7/9kbX/nhH7z23vvQPcvXM3sDgHf9f+eNL31w8vj8Iyv0AxRxKniT2fe/6hcTxU8CpqI3lD5Ptk06xgoc+7v/Y5zztTHf+8Lndid37qxBNtuRVMAPcJz0/qbS3j7GJ8Y4P3hYTv8SIW4WeArxfGq3Ceb2wH5j4KO/88ZXPmj/5syzWUCO6ZnK7sNXv/TwL85e+uPz85NvT+VtKaJPXXenFnpOSMU9UwPcknlqFfB/7veIf/b/1Ar/DAfmPxf8DKe4pfakKmAnt58rFg8tfpzcrtb6s2Pae/36hhN2/9TZBJxFdjvw7X909uM//vAZ/W7AM3cD8PtvfOVbp6cnf2yVszuoqehNwt0Vf9xvmtbNlpjWYiKmSXJd3M05yfZ0lBW4+yuf3b75f5Qzvz7o7VOA9focpdXPl+lHyK0Gdqb4uWTGcj61c0efDYIzx86y07OzH/7+M/jdgGfmBuBD+8j/P339Kx9ZtX4Hdc3DH/X0iWgHOiahlZjTMfUBo60d/c3R54mG5rY9H2EF8O7/5e1b30c48/uHvH0KsL9Gx4LgF/ww3jh6fOjdmeInDW8OYGn/aY1w5OAc8/PMiOxe4Lt/8PqXv/csfRrwTNwA/OH9rz7c2Uf+Z7vz97Pi+JiF1bdKorx6TT1IbSJg12kgxn3JpSSbfFQVwBf/tt/7t91SfgMAi2CkO6rFYYPdPgU4thlfGK8dHDg78Gi/UcaTpD+H9Hxqx9N0Q+DMPHOiBYv97ZpvnD9+/NGzchPw1G8A/pPXv/zbf/H4Zx/Z7dEDL5o9obDtU4A2CSw/Wjzy1/ys07ANMf28pvkDbX+oIb/IQf6tPb4K4N3/3bc/e3wDH4x49Dv/52f9rwUO3F54FT4F2P440As/zfsHyIPbkBD9LBKvfJOJ8wdHD0DuM71NhZo2/0fo0t8xD84eP/5j+02Bb6f6KQlP9Qbg91579zv2B3v+thXrPg5rFM0vE9DjPECmbZKAGV+ux89eIEQzRm7aY6nA9mt/xzLTVxvnK++8bZ8SvXI1ks37+a+An952hMQZggFB9C/4pdxOJtfbE1pcDdd68G+/NsiTK/9E3f0fn599gDOweT2d56d2A/B79it+Vt3vTsPGcR8f5UO0qxUS2qZoJeXHLAaA2pQN1wrcMM3bP6KJiYRmu46zAtu7/+Oc98uOertZvGzlXhw/fHnPzxU5i9rooG0nkkt4o4nLmzi/msb9IbbbhKZ0Tte0cwtn4Iev2Vn4lK7bTzouvux39vj2h2fnu2+0YrRC8ON76jIvK6x/kSIVJgDkF++qRJUWEwy3/e3/KMgRN9sL+hFP/iWGjh8V/fQf/3+7R//kzy/hvbm8KBXAMYNzXds2tnbu2HfW/GyCDu/yocWtAfEN25759wTIBgyvRyfn3/6PX3/3wemtT/76X//4Rx9T/yTaJ/oJAA7/n53d/sj+Cvk34pYpx8hCQ8ED3++c7B28Fkt7eZcWLMDx4TzobZ8ARHWOs9ne/R/nvF911Nt3Aa5aweff38+kOHz8LIqTCHqcX9NZ02RoeT41t9bDEeT+aENuDNC36xN7Q/yzT27blwMf2I/Dn9z1xG4Avmd/CAGHv/1DPg+tdl2hUIR8oEL8+AVAf9DOclnfZ6F9T6CVuU0LS+fnPj6e4Uc0NGztUVXg9Ye/elTj3QZ7PRXY/rng66nj88wynUkYRTuLmq692+dp1M6i+Uj9dIpjyQ/+RjGddeHCmwMzP8QZibNyznYzmidyA4AB/enZYz/8/WCOyrGA0+0AB9kO9tZrx3u7BZhuBPL3Kw3UPnZpbO3Tg+YDebuOtwL+Im7/4tt2lQoMfg1w97j/1wGLx1F2t08BjnLau0H7+W1PepbwDacf3IHGSeOHPNpkMIR1pj4Nzpo3AtC6v7X2fvXhnz5+9MRuAm78BgAfafzJJz/73uOzswdeDBRTBszBo82LRQss9O4Tjvlz/VZHs7UpgRk3annub+/+UZGjvV5/+NWjHfvawEe/8z/SrXEcg237FOAYZnnPGPOMwRnUzhl4NKkZ8+YgsM0eZ5Yh2efBJKfVZAMOUON4bH858E/Ofva9D57AjwNu9AYAh/+PPzn9yEb2EEXS81hq5UXwIkUN/Hf7UeI4yVsJW3G8eKaHDuYmJYXrUcTtOu4KbP/gz3HP/3WNfvsU4Loq+Xzy4Jzxf2zOz5T20T9GwjPJzyH0cSaFEmcS7TjRXTZ/tM5V/K3rNtgbh0lnJw9fsrPzpm8CbvQG4C8/uf2hFeYhBojLD2wbGwvU2lasdtib0e4SWhFa4VAUXi7jLkIOeOj4cJx1PI5r6bm1x1aB7Zv/xzbjNzNefArw8md+8WbIN9bnpALTgcNv+SNxP49iBPhUGkeTnkVNbig/0/zsihuCuDEgfvotARDiDHTLw1c+ufVhhLiR5sZuAP7D19794BP82cMoSs2+lSUOe3QM6N/qb6d/X1z2DNcOdxYRrJOc912YLwTerqOswPbu/yin/cYG/epXv3xj3Bvxc1CBOMP8XX6cRe38as8+AjuYpFcGRXQgvOnRjbu5ORPOQ+t+Yr8x9x+89s6N/Z2AG7kB+Pdfe+c7j3bn3/bDGqOI4rQhT4Xyvh/WgFiv4FAOovEnfe2sj2tioh0Gp0gMsVt7bBXY3v0f24zf7Hjx70fce+dzNxtkY3+2K4DjCTcCaC1THjOQ88HzyzE4mWCZ7Oj6OWfOfp65VezAMoYHagx2K/BtnKkBv9bm2m8APnzjS9+yDL+L/FElNK0Mc5kWt8cdTxtd82jPRhIX78Cc23TkhdlLFe/6vcjhszXHVYHt3f9xzfeTGi1uKk/u3HlS4bY4z1gF/KzBU5wx+e/R8BTiMaWHUt4mtMG4Kc5E0LRbhMmBNwyOBl8DGQ4/eNh993df/+JvN6bre77WGwD7wsKDvzh7/F2k177I51L7aB9iXNOQ28cc2cegcdnAU2dd/j5l/8uBjnTchI0SxiQ1xPZ8TBXY3v3vn+3RN/7tXyjb73jEiO2fCz7iycfQ7Wxq5wyP6TysWmHMiDOPZz6w7YCnX+s7mJ8UBLhhG87f+APUggVfMJ2f/86Hr9q/nHuN17XdAPwtO/xPH51+ZLnZXzKajur2K3sczTSuNqSmR93ajwBgt//iLT4L41rrRBmsxdWeXcqCdmqYtuuIKoBvbG//3O8BE342OOxHfxvgAKpjgmz/XPAxzfZgrHZQ+ZnUnU/9adQ+pabv9AYXKP8CoQn5a+zO1r/ZpSfuDfivCEY4oO//s91PrvXXA6/tBuD88S37x312DzBQJOwtBm2dqQ9ts/FWCbb2axYsBG4H6N+OfGD8gqmZkx8mfoPS44S9OWzPx1IB/Mnfl99+61iGu43zKVRg+xTgKRT9WQxZPmH2f8cG546cU3lmZf44ywzi5xPORJ6LeLNMRzn3qEJrPsl3snvw8ie3v5e0VxSu5QbAv/R3fu7/uI/nkx/hn+w0gBcgE24FYdd7GKj/51UyU7Ro8DACFKIVkZ7hA3JcWanW3Z6PowLtn3G9exyD3Ub51CqwfQrw1Er/1APru/t2Tk0p+blk3fzRt51XDdMOpul4Mi07wJt8GufchIxzL/g8SvBBfrQ7e/9vvvrOt11/xSc9ny9FhZ/7n9kXFCbnWhoUohWDGEVA5jUVJrShaHdLgjSXxknPuIdC3crdGRFb++JWAO/+X/nC9i3tF3eGn52RbZ8CPDtz8cQzwdmCs2c6qPT0amdSHEyOgcw3sSbhBOPfEfAbBT+vgJjONncBFqHwsFgIx5D8V3PN5YMPXv3Slb8PcKUbgI/uP7wfP/e3fCxJPDiCkFt3Uk7ShIXOB0kOa8HWCmAiPlHIgx3Fmljc1/qopU4MGLbrOCqwffHvOOb5WRklPgXATed2HWEF4tBu504bv8rQ8IRyvR1stLPNqpmCOrbN30kS5gLi2uW/D+AtfB9f+fsAV7oB+N8/+WffsSweILF22WBx12Idv3OJpHkXNA1yescO3XS1XqcDH+8qnDt8zanxTQWeeDbpWCqw/XO/xzLTz8448SnAdtP57MzHk8yknTkRMQ53xu/PrTz8aPa2nVY406wbEMipT1Ro/MxrzHjmA67m9+DWJ6ffcZdLPl36BuCD195935Lofg4xffffssl37G1wbQhtzDlYjNwHGNnjnX6IzmUd72O0KBGN3kMBQgEcMBITHtv14ldgeyG++ByPfuXvfPSbARenPhqPu29/dvsU4GhmuwwU542p/MxBK2bXo29nEzGpCxzxeX75+VZ52sHoR1wT4/xr3uQw07c/eO3B+0F94ebSNwCn548/1GhMC62/+0fmzDJuddymTjiwA+M28zFNqEzjnSikdR0T/q6NGwboz/G0XUdVge3d/+Wm+/zMvrVTrtHfBiiQrVsq8PrDXy2arXsMFeDBP51VPJvWD6HJ2s40vGHlPw6EupGv4YgxblP4zYIBJo6p0qcnpx9e9h8NutQNgP9ZwpOTB1MKkCI1v2VpPWgwjBiKw9lrtvRKTPuSA1Dt0wDH2RNavsF32e38zMHwqN52HVUFtnf/RzXdz9xgt38u+JmbkieWkJ9LEQ1yXnEO9XaeejzvGgiHOn6F3bH21PEEYRynfvhRJlseefbPB+8+Oe0+jc989ggXvgHQb/0zAU+IA8CAaLDgHBQCAecKYm1EsLdnZgpnPEwLY5z6rnE8lI1GW1duT0dTAbz44mPY7doq8DQrsP1zwU+z+k8/dj27/NNvpOVnYJxh6LdjC1KceS5aJwzEx2kILV1cBs4w1JEnWPDr9t/5W/ffe8D+oe3tQ4HE3frk1gf8JiJ1nhSSM4EJUgdF09FiXhgsB+4kuAuaSplFBAx2w+MfTyCDYsHjePJlEnBoTs6c9t3uzunp7pYR3r11urtt+ju3bu1uGfR26BHyDgJav/lCw6txtvxDhgn8hvcbFhP98r6Z8l9+AMYeuKlhPsDgYh++sFtOO3xUixzSFsQn5hNi+pEDWLdFG7VOCuODyq9UBhn6zA8kVp82V4QHzscVLJ6/B2ljAMR5TXA5xgciy9sZWA/HQe/AaFss5IFxexS3NzqO9/StX9rd+qVPU2lOjX93jo+3jQ8t/EAQ/q0DfsRzZnRMNNnH1LrhBIM9DOs8gc+5Cxtd0HpMGa/bkINhPYfgyPiwIU/6OIk9MT9tnazPxVWaB+JgzqCjXls4kNOdo08ZLfFVxz78cQGHy/pr43PMiNMN8mSYGWwQC3XEvqBJ43POwepcACkpZbYwm1zXB8y4Ut+6jctkdye3/V72W7YOcRn+/MyM4HRe06HF5TprmT/1bqTdXlmhBwf2CP46o+/HsCNw0DW+6Dg3DcDifzzZA1y8rO97CnVyH2DDzhYq9zE9ck2c+aDWXnvqxZf+UJkZflRZp/n5XAUPjWzNpcUyrOtAArHEQBf5sz6Ogi7S5Y+3UDvPw2zWPkLfuB6Bz/7/meE+scejx6az9qemP7PW4yEGrsC2tKGEbzO2N7nmY33Inm0zAeWlcwrI8ASuSW4Prf+dHFQEJvAEBTQmu2eTI+4I5wB7evTJow+t+U32D2kvdAPwwetf/KYN5BsgRmq4WtsWFjVMG3PUhkR0GyR6XrRQozBEuKRVsEVIG9ggw4wW67PZmoZ617rhfPfS6a3dPTvdX7YD9a4ldPf2LVs7cIyH8fQyFHbBjqKDx4kh1MsMauMkRVadDa7OBU5wW78VyAR0ovHD3ezYhHEw+OLxg7bBuAi7HN0v7N6YP2h9nNFa45GQJ/nMjhsU3/SeH5xNQG6eQ2unmxjY7QJvXiajqzrwmu48XpTbTYzFbcoeG66++WAHVyMEATqOB5fzAAN74oCxDr7I5rboh18UomG8AsHpBIGlinOhrdsCl/wgx0V/a9PmiZkNLfXARh86uPm5TywUkImh3lR5hZ87Q6l464Ii6g1ruwzj65i80Co3OBkbJtqg40Vf2kzvLtGnuotTfSSG02rfZPeNm5fMAXGAs4u15ZpsCYStNVPHfIBnPt6alf0Kzz7Hw9xqm8AmRGro4C+etlwRO3DuDr0jmtIOmZzigLmf5ZbrH+sCuWIPwpf5+0kRffgiJvgYBzrwQOF+wEBpV2DQuMwkjMNvCvTfgnAfxHa0tQxsvogJe5hA167Qw+C22P/IDwqvD5DC67pG5JSMB31DTq9LUHBtmx3/ec1dD36YS56w2UED2tv+Wmtv+MBh/VfQP7Hjz+sH/xO/Afip3Sjg8WN7/OUnj+2GAXjPDmx2IZDhccENLfIJHSyua2aT8SYm8GGDDhee3UKHUFBPNagpu4N16s0C+CzO+/hy/t/45//399E/5LrQDYC9d/wOSachITnLKBXIlkMMmzlhAByEmRM/ISdm6BzvQOqnFiUNhLUWzyYIcwT4qU3s63bI38PDDn7cAARZI3BOsMsFnVcZrekFk8WHi+Nol76JHgNg37StBliwJycWH5fzSusLEn0Y4rIY7Q4d/tDB5qdEAKAyHX2p9RsF0wPe5QiFXN61Jx7+Pjirnfj5zQBz8hzM3+L5n3QGDrHxIuw5uGOL6WHQt4sbxusYKkJbV55bEH/x87wYFBvXnJwjbjAxzuDxF4NW9IkrbpgcJLGjmA3nHCDhw0SEzFiM3+DTs4MCTBnWwHfxqGey6JcLeKaA3cyxuBicDphMiXEq5kBs9L1LPgAho7GWNsbgmDN3GALvPvYEm1P7ExQNg4aX81nHeYgLpXcVTCdtzc4c2Ha5MSfgIDMgRHuBdh/T0VepgfXw8O0M0aGSnGzDjDxw6RxpPOYJmGONDznhYh85kDboMlce4O5gr2rG7eseyTK22+LJxxs3SrT7nmwH23iM9I3gyJ++Zsq9h1zMxn+/JQ8uH68BefOlBy2o3c6BOSG0oXehxUNMlJtQzSFiA+25ma3t/9Y/sX17jtcH5OCqqLHXNgg5Lo/DQDgpwNXG7DxcM4wPP4tvX6azc+PEz46fh80e+OQANwM/tpuBf+E3BKZ3aonpOUXfs2tPmYEJJ/6aOA0diHaGtbMMY/UyulPLuaFNjrXn84EwHirG1ULl88n52YfW+UIq9gjldFlG/01792+BHwDBoSLXNghoW138HRplr1TTpx0C9HBuUqKaKgwwoiiBgUOTezv0+Lj+0y/f3n3ulZd3X7738u6zL9/ZvWm/q3sHL/aAZ8LiCwMmGZdNPvP2vvuYLeI7BwyAKwV02HycOW9Fh0ULJ/WjP3T1Mv92FxsOyN8vcOBhHcYIi+fjGxLE9nA5jMyL48zYILKrcplKN13DABazHP7+aYBzQhG5heh1DN4GgYE4Z5yemJdRYGP6+MgHnfsxRP+CMJEIv/vyhYEIjBUPu5CXb37vuKrlBlt0vREf92W/A4VDcDMGafwQAN7sLtNAt8izUnqO5ITRHuwmhemixm0NAwcQgejjij6wULkP5LBH41Bg6d7AzYd6zpWDzdGxwp/O0JHYZPeDLrDeCoa8bJ3f7KTwlh3SsA+cyaSGL3i07zo84YIfjOGvufleU98gAdThxZccUUs0be0D7524SWZI+Iee+XHMMMFqryW+/5mi8zRbq6OjmiJ9zZkHs4nt9YOEgVe+oPMGsIAmv/HiVdc/uaPRx2hAtGaffRrIXCyO71mMw6Gu0IgS0ETkhcs547UOXOSzeHwN8Hxcz4Sba5vO0NHX8w1ychkc84P6+DxF3GBpY2NCqGf44Wx5886t3Wfu3tl98dW7u8/Z+fLzfrZYZhbWz2ZwR62QSXu0nKqMeMRkASxcphxpT94N736Oa5aepzF5tU52Dz64wJ8J5gkDvtXLfj7yHQKmFKBph7TbMAorHO1oVXZM6GjDcmtjhl8roxfWACwqJfi05XliP7M/2X3KDvrPv/LS7l2bmE/hj3PYRLVKAmh8kU8mgQR8Yi1iuQv0gw92BPENFTI48mqZZhcC+PzQDRsawlrCjRPEHjt8AEI/byBM73eS1jJh2OlDtR+UpufYTEzZMQxqHdjM/wR3zsml44GDXRrD+/bEcZsNPx7w+oDPrq5Wmqv5OAR87m9tU3jfVXhywYjYGkfjB3iyc2U4znMsubs/fMLPfbGkgQs9Gl7gQD/rDAMUhnccnqKfHCUmXHDlzVnrtr6TNAUPFM+J+bjj3J6xDef1CU5tfPymyBAhZHoQshOe1k9u+KKTBD0eaq8nOUyRurDNXAXrsdFHTAG6CJ2Z/Cp2rgG2wLg/uCDjgZslFyLHkD0WQHbRJ3kMAxlQvbwf/sR6FzEM7z7qFHnMiEhqWIuN8O7leZiNFOhnHCphDxm2sLefvbc0Grth0iXy4F4mJ4AwOV9weczG4AR4jQEPY4ppqIeS/PDDfoFv8CYN4hIHToSBzgDTazcMwWc2h9PH/eE33v/gaa8BIEYiTg5Cv7qDHJx4+KeIAYB/pA0NX7f8JglUmQc6dgXYeWnzQcXZZDB8qvyLdu68+/q93efv3d3dtzPnJdTXrmBxqeXtaudtNoxhulgjPwKscAxJHrbwcJkA9ieqqEzjN77vHPprgQfdAODdvxXlgcRL0Qdh2SE33A21Q9faKAcSTxmduJre5susfMmGCXrMQ/NhwTAB7cLH+zj0v/zqy7tfeskOfeu34IZwuDu7Ch5++EGATV/4pZgwe1Bv7cltjAi+kNkCh8sTNZtvyqbyQMSZvdWj5UREyzN6yAsXfPwB2TX+1N1tOzYcGJux2NK1FdG52rsC8IK4+feLHE6mT7vJ8HdoJAMb83J9UDEPGCHHiwWh6WN6d9NPKIC3K89SxHAd9M3mDcg8t9I6NiNNPia1ZM0Gc1C5kFxQegfgJmo/nQyX/g3qijyUwGFXjKXZwgEN9N4N3JzMYkcejgWYWIqmo4ptxmNsDxIOkKPv86Y7zEy8GA8Yf+EkRwAQS1WM7WY10hBxZybT+xiDLG+OrO/jCD1l2HV8rA+LAHi4OG+OEYmZwdOJnPzVNfTKSS6YNF/3hyL8YU9ZgUzCdDG29PC+uQGC+IibRuhL31TgcDc8ib/vU9jzAungch/arIVIHr7use8miUM62OGXDwhxIX88cHkdPUDb7+SFHvub43N8OLreTJoLcPZ/jtF5wNsuDwPRKeKoYizT+YEefQ/lfOEPvT1S75Rhw1pnHtAzELmhg93hzcdfvcDnGNxYnO/u2dy+dRdn0d3dr1j7mp1FiOcPc0vZ/UDa/D0ndC0AMkQE8EOebA7wPrV+voIXfGamviG75/unB/5aYI3XsbDzO69+4YcW9QHBU8tEcJAjoZZcfHc+koSt4RwTyUOmHnFQOvcPDvwcCu/ycQF334r76Zfu7F7DN9NDnxPnqHjCZNKuepNRON4FFtO4i5nhYEcIxOHiWYk7cu11CIJgcjH2obwVZ7k5K/TFNq+DxGdcpqJjhC76cw46tHZmrzyAeV5YCTH2yLmZQoeOXsFz+90Hu9tf+oJa5jLHzRYIleceF9dche8qvhfP9Po8biLvuu4um+1Vcqu+B+b007/30RXXlew/jpuxa06017biYi/5612xzfZme6VojIxL/rpvoz/noENrZ/bKA5jndbn930eb9zw+bjoYFy0v6qzvOOgtF+bMlnBvxSc5O0Dr/MRuHP70Zz/b/dmjxzv7nQJ/ZUNJ8dsCaF1G36XWpj4w7fOuhqfsrQGhPbOhuI890d6id88fn90++8Lf+PhHH3fa0kH1Vy+++5fyRertbITebSiQPUCIexrq3Qadm6dDXoP2mMaHScD1C/bR/ldfe2X3Bfv5vh/+UGLh4KFX4D2Q6kXef/gzk3CKnL1HfuHrcujsPY+PpbMHSY6hjYVjbvECM/LTHCjrR1/QYTGRfy9HW/xOhdSBpy9bNzZeiMmtdpkS2LvxKI5cnlfn5LzJbXblcJk8e8dkQYhhi7gqM49DW8ZW/FX4ruKrOVxEHo3hIv7AruV9Wf5+y1w0owm/ltuEGkvV9yI5db69o6/bzh7hs1bb/veKWD2w9w/a/+agrw3uLzV2DvbZRtktAKUplmkYl20DyVzSj22yTLngtws+d/dlP7M+dedOIjJXp2vn44y/naSxvaa4ODXbydni+CcBxOZpnKEoHPQpwN4bAJuO75Cxb6cEoa899jN1q7lx4cmxzT7dKCS32XHhZ/pff/WV3QMr5kt1Ahukfx5MSg+wnvBgQnJSElgOLdPnYjiEX3iaGKOE78i/5JCxkKfk6lyoi+oosx3xZz69wDg6fteRC3DI2idF1Xm/jbNNbMiGB2eLMelIc1Br/swVuaQM50PGewjmoEQCVMd+EV/FxhpP1XXmuY9raQz7/DLZPcIS/x63g8y1bgc5PQ0QE23r3tftqL5Wq9keRLqoYa3jtv/7/W9l6l4PULdRjaHfc3WvTlJ3nxsawV3fZAlvzQVn1uftxwL/0qv3dp+2s4wX6PBr6GinRwuC0B7eQnkLLB0Dj67nJWNtbA0IJq4++1T9W027/Kz8M5R+839mjJO8pd6sKvt6dXVLBzYkyoFFb0aLn/G/Z1+u+AIO/ih4bhJzTnnmqdHDyGBSLLphwuqkwZY6+tJhoV3Ox9nmi7LwZjzyY4zuymkMA5Q6Dsps6T9qFzDdz+M0L+LZKudIl0uu5Iiu+9qz8kM35HFw95T1rfjK13lF5xDMyI+6MgVUH9zWnOlYl+pV8yQv2jWupXz2+Sn/knzVWi3xqr7WjbZ9sdfGTY4baS2xGrvMz7b/1wu/uP+X3Ep9l/ZD8hrPbA6CO18f0Qcv57LGCPwsluHxBUG8if01ezPLT7ARL17l22s96MER/E5vS0eXO2TqAcXlOnsmDtsAD/Yf787v/0evf9H/bg/wo2v1BuD0/Hx2B8Gg/vN7rG9jZUBtJzkStOypQyJVvmP2L75yd/er9u9sv4G/ggcMfOyBGH5ZgYaThcINf9UqPI2D/k1Yf/a46xAkF5QRIyZv5ha4XHBLODoujZH2URucGaNiOH7ROxZfULLLn8EhuS1yuYN5DDidDHy0oeWXbSo3MXQKXvimv+m8uiOs+u2TJfY+aGdv5YkkxBJTLpqxuC/vQ3nG7BfX7svnEMalWrJWh3BcO6ZfuzP66xj3jLQoFuvSCpNreglHOrMPX+NoH7XBmTEqZjB+x74o+1/HV+uLftVZfVZrDD5/OLDtf60xX9NQ51Fs6pLH/hCdvZn9mn0a8MW7d+0P0uHYbZ9+OwWe7MKc8JSMVeP9aWshL/8/02ueoWPHWr60/OX52ewMF1j3CYPqdx+8+qWH9nfVHqYSdZSOLVPv8Q7Ck5wAbuNg0OExDtz0u5Mt8c+89NLuX34NH5VMPzOBDyZpNlF1MqXI8Fm+PMOBOfSS+zAuJ3XA4Cra2Racp71gK9DWXcKKPjd86LJWCDaqkwRybGDST7hTJz4pjvhhLHl4ZQdlX+Q2Xtg6+1KsTOYAQcZ1AHoOqWOo/bnHYRrlwTifh+uqtbzqGEd1Qk5Xzeuq5Wd8tmWcnvaCrUBbdwkr+m3/W6lQj9GakKLmb4KJLkWpp+uMy7clOGHThwF8mTggGDR25UIfdsHgxwFftTe5vxhnXaOaPhFoOdgzQls0/IcLOD5cBXVzhnl20WTM/tcBZ4BQ8Pye2W+dPu7vHIKxxW13Kj5ee+JCRJ/f7GcCUyu3A6aEHndCX7e7onfsIxL8Tf4slhNHStQzw/ixALta3NSJwNxi6sRCsRV4VMzJ17BlIjOu5TfDgVrH4KEsTuVwfTzN8NCzegIER2C7g1IgbicfW1mEzkw9WsqGybEUfE8/yAsc6qOyOSdvEHmfcZX8ELnGOsSn5HOIyxPBMK9ai1iWe3Og/17gEwJcNZ99/rVOGNY+n0OGPljSM7eFON3aJmaW57b/tZ5X3v8k4z6xeoOzm4vAjF4nE8f5Ip+1wLsdNrezdWND1vlFn1y1FW6I+DTgXfu0G58I4AxsJyNuAux10kKBqi3HZnF9cLgMO8ZqWHyIgxsFxQTUG4PYmXy2+GOA4Q0A/oiAjWHm1ILguQXUQLQhIK7Wbz3IemFYv2zv+h9aAfBxf04GQFpI9FlMyLjQx+CB0wv9qnM4M1KwyYktPALjwslY6aMgpDSIMdA5DznYEhfjyrxc38Yq0ZpIn5lhoFjAZsawC4Zj6e6aLdesgYUgposmHK43H8VVs9o6nkM6IGP9FJ+DUmXII/wA9sRVS3ktL8s+xSX/HvVkeqj/VfO5jP9lfC5TkYU4w7VcF7yXRl6jyEUc13SnX1rnawu9DIz8Vc0+7ILhWJ6f/R+1sDHgZ/bMn8MbtlZjx7HWAJk8e41Tu0NiU0LPmhHD/jAg6Ocb+k07+75mnwb8kn0agDPRL2sgo9c0oXcjxjr1ndOHP+kcJk+wGOS3l/4w0PAG4NbjWzj87wuPiFMSSBMEGh5y63MY0UeB7H/8ed4v2jv+d+wOyN/1G/6gSZMMUPzZBAa/w1RWP8puxzjs0uS9b3nrZJk8yy9ch/6gVH8HtaeOBzngUqzmRRtxDr7Gp8qLPCQXz9VSbIusbqxatEPy0qIFvuagNJFP1lJyU1gnXyatjsA6azlV7IvWv8zY1Yf1V93TqBHiD5ZbpnLV/Na4LUiu2QzYhG3/zwpSFNLdt/9Hc8j1B5q11wv6so2w7TVPJrfYMzvoyb+ESXDLxbnDR9cHPgH4it0E4EzEecgheBbWwbv7vCBGPP7jQ7A1H3omOgWz3N89Ov1mKkQY3gBYzN8WTCciTHx3xJPx9OxpKTz1GDQG++v2rh/v/n0gLGIXwTqqV5k46lh89lks9BE49eFofS++2yMzcpDb+rlRYat24DgoyGbXCW0qrwrEdo04aFtonZN+hc5daKM/+nW8aqO81lZOG+co9JI2qStPGkQouXY1hA0c9ujmQtzdrv3rkkte10W7ynNIvVYJivGyfJcZ+8hnpCsp3mjX45eVqzU5ND/10YR1/5u+W7vWzzVLnyUe2gfttv/37P9BzTrVqOY67yrDkXjT1/nsXlfpR3wXdKFDbLR1faCPM/Gvvvrq7m78WVTcCvD3/bHc/OG5tRhcH00f9u5g6nOxP6r3W72m9WY3APZRwQN72X1/BGYSOBVYByYAvMvhCJkXkr1vH3f8K6+/1r4BSWcWhkC2qg+5mxS1w6f2qat662fxq42xmZv1u4/BaNc2sM5JP7YDHFU+FuLY0hht5gm7Fpm46oe+jknliiXHIa1+4/UQPDD74iE3zc9ccrxLMer49sVY4tmnL3ntg++1K5/KdMQ5dVNjYYznoR3V5jrzvkyND/TZ9n+ZqH11w1yX+b7w/i8h24vkTNkUzEdjQqZe3Uw/yyX8XK8c6rcka5w9vniD/Fdfe3X36du3u6OcZ58fA2ZB6xfyt4eGgJ4I5IuXF1w400c/BpjdAOwe7d53j6Unf8Fq5fbE0Ectp7RSjvx2b+Nb/nZ3k38OYa0QZVJ4WO4tPjj5QC6FpxuO2lQGiLmZvlsIFadYyl4LPOmV05XKHAs4GS+tRXD7Cm6UFyiqvqZVwgy74JinP4QuKmseADrvgJg5jmoC3YhrMbAYRnxi7sTLxuhIpKN8KhMyKANNl25HcfaRsfb7cDdlPyTntXmEjQ/kWPmqb+1fdVwe20hmvPMJ3va/1aTOD+rPNTirYdR15AM/19MZinLpvz+iJsZRXpN54CpU5X12x4ITDzvUsSZ4jinPSMaPAb5+797uCy+/HD5GY0A89EqdcfshbsOnLo99jEWcbg1+DDC7Abh1cuu3xSfFRt7olBQRME5caPSBCX3n5bu7L9nvPo6uWSFRKAA5MS7GxCIIH2MysYfPCAed8Hcy8YijmPCZ5Us8Ws9NFSs6co/eXYMnrmnRyI8ZxO4wctFpqSVt8UcMj0MetYeO42a7FML1xZ9hm4/0jNv5FC/mxRjAq88iUAwXxYvrUxX3LONrze2Q2l9rwAEZ1+DSuNfmketiCVP1tT9I50Iqj188lnQc57b/+718yBr0mi4DZ68pmJIlH+hxcT5az7py5oROG1jra2H2lRM8wbWPs76m4QbAbwKSYjrMdfQcb9Ph/JyslGI0SHr2Y4DuBuCDu8sf/7cC8IC2nrEiQCNgqIbi81dfsb/hbwPpLhbIlFkUAszmOsG4SQrJgroeuIol10qbkzXCgI8LAHbhn+Ub/s5HH7awad6BdR05S9k6HnfP2bdvuNo/++C5keiSreZnfBhTjsv5c7lkAM5J4mDhGBIVwoA/IRiv+HkkxSewCPRhfof4FArvwm8+vBHyyepG44GurI8nm9RTiJbz/BRiXyFkt291Ln29lQXn8xoTW+a347F8fL8F37b/rSBL+19qrjXrppSYMh0dJtafzwMM9OlATd+9FroqiJd8yDGyQzfQv2Nn56/aGVqWSfarni8Yc30LPvoxQHcDcOvOrfeZ56jl3QUCtMXaUN4PB/ydY1z49YbP4st+uLixIQ8GCvXSlZMxApBL+B0v/c4t9HXyOgw41d9j2JhU1znERqWOOLZ79Do+X0IcE/3Ygs8/yoqFRv1lWuZWY7HPVrlNp7lO89jmW6GdrFx4x6N9leHEvDoC64xwVVd9Rn3w70nX3Sr3vv4o1kV0o3GPdBfh3IetY9qHP9R+Dcvz0FCruJsa3yBo93rCeWNLPPtsQ697atv/C5uzziVriJYy67yv1RCVN/p5s0Uuwfl8SZ+QWbuUF3NmC0eVpY9Yb9kZij8chLRx/qJF+O4sjj2nQwMNL9XHb/jRFG/g2T3fzT4ioEkDps6ZPSVXuWTJfM1+hvHZO3H4w1ILhgEfePnmWsOD2x7cSI6PgszieuVsJJVP+5Brvva2MTNWbDeGQNAuHN2iiZ9HMYfuxSPy62i1Y9z0Y+uLhxjGZn+pldwcUv1qP3i6XJObxU5FLyhXFjEgajNVZxabjxV95q0t5T7q1XoS24m0j3jav0qkPaW7CvVe32sbQxlEN4l7s7g5AMZ3E2tjMeMYOOsqsX39sr/t/6mCrFVouqUjtsX9j1pGPSfSFUk4O1TVo8/5AlDs/hqIn+svXcTSn33ioedDfwREPHBh5+vtW3aWfs0+CcCFGvG1n2cylFq71LtHeTo7/w3VdCOxf6P4fTVSbuRyCNLgLfRTyK+/cm/3Fv/MoQ9eUmMxZLAcjBcZdmI0BvG0sRUMi9VU8aI0wKG4+ZJFO/nhrPKIH/YkmACkGvl3uQUwdQvxsi5TCM+Nfmy7eM4l9e58tTPJHidycDkHMmFcGulHuuLWdREHPhwz2wDlmDonwFHzqeiZJ7gumkPhvnD3MvEk9y7ewlR1mIt0NI7KlWPNRuwhGGB1Pun7orfTUsyR5rIY1K1b1wFM3QAP0m3/Z2nH+78VqX3JboKmtFS/+nrhuNEc5IQmpQuLeMLApb7oCz/z8nZl/xNH2rfsxwH4ciBc+DBilyOx/FcGm35Mfn7S/4G/vAH4vfvvvW8u/sd/BuvbAjVCD24D9NaTaXok4Yf/S9Pf82+LXNikEJ60PXUbYaFYxGY74Fm16YQACH/oGK/Yp+LbOB2X7E2YhpyTneMo0G4xwFZitTzEKewdH33YOo0mIf5YFIJzC8ersJC7ONAt1Xakr7oaN9ZMjpl2toinMvq8Krfpu3EN7HRdbGUpLmJuwrA0RsZay+si49Q4KjMO2zXbRTCXwdLnplqt1yHjVPxSTnV+Bltvto/IVXMY9ZU/7B0ffdgad7cXGMvbI9n/HPPC/HX1S6wJBT/EAQ8c6i01b+rQo6OX4koM5WA8tkqhctqZh7V4Y/21e6/yVdXathD92ez4jxr7dlfSQQJfaO7/3v1336cxbwB+8uhnD6lsJOxZDZLWdDAaWcV8yb7t/8svlS/8gUILM/OCWZiYM3QmZxEU45QDH8TCVbCus3zzgt35Q6dygDKuJeGyhOvyTVIRJJRrNTYUtQ9d/mUlSw19Xpabxxv4TDkSPLVpQy7wxRg5/RNskmC3h/slPnyJco7Ih7razvJsxejGVDG1Xzmlz3E5q+cjxkPELpFDHJ4QZi2vy4zzCaV97WHacmm0Kq8FqriL1ov4yqMx1+ZHcZArT13ftQ+fbf+jCnuvbv9XNOex6qV/InUWtYuj13Wf9jpfiANdjWe65Ci21NegB/T9b9EwB+P9ZbsJePcuvxg4ncM4o/Mf2fPEp0ULCTlQ85NHZ3nW5w2AIX5jlE9zilVNhqDyoOaEw/9d/1U/4hrQBy7Jd7sjisRJbUWNDLzAkg2LG1z0cf7MSfAjkZMCjuDJdoSHjj60W99HSH/YKSeGwgVa4+AiiQo2Z9O3sQ4GWXMbhYPbCBc5MyYGlRHi51uttqnNcbL2CJf+o9jUaX1Upp0tbJqrysRQt8ZD7CHtRXgugj0k9qGYbkEc6mS468j3kNiHYA5JG/nKcrMBHOJVfA5zSZTWqIudiLGgfhVxER76Gh/3Ujdq02/7n0Wydm3/s3CGYS3F00V97QpFYmc2A4x0viyRB9cAc1I8bR5kgSds642dN4PvCeCs/by92eaR7ksu1h2a9hcE+62B8nA85yfTj/rzBsCE91lDtlNyKCoI23+4kYp4/g8Z4Pf8uwMjFnTHU4pC/4whhRzpWvIzL4FONuQyWwQlvjuOvsxBXJd8hmkTz1yJFfNMJI9i6S9gTk4uLNocSxIqrVU+Ubs44O8gYfeYJqPbxbcv1mS/c+zz6DA1JvvWJi7+zGVHiQ6wxNM4Gt9IR/xSu+ZTYy5xQH8R7BqP2tZyI25a1tQc1l5HvkuxNe8Rpl8ml8tX89d4h7EdhtIY9GCstTGM/OhfW/KQF/aBf+4RxSWWJEJecWIa8auZdo9puSCdLv7ztP+zllEjq0uOBYNGnRIjVYDOHh02zHl2hF/23W58XvtY+JyHpRgSciT23BOi6ZF71VnfYuLXA3/e/2JgA+AZPot8TtOwdrv5G2T1G4APX/3Sw8e78/uMxRYgo2w5WC7dZf1X7AD9NfvSHy7/1QkWg8CVb2iOCk+3bCufvisok6d8SNX7M38z6ESt2XGXAzvxbJGcyujzEr6cCBQTePeJyhIXPI4tOlK2xZa9lhO78KcfdWhHOrWrbNisXeTjf71KMZBpq3o3xbjUNszB6jnSc50UW9bwQjE0CXcsimeou1LTa8my1PNaOEEyyltjcTmo7irBR/EO4btMfMbiGA6JQ4zEy7ULHnA6b5ASF7G2/W/f5sfFurSelWyaBJXD3PDFJ23kwJu8EabqGMvafD0MTPY7cpwydtFP+Ua6hm7PtGssp5rG6+zEqa/Iv27fB3jFMO4FB8shczVlnt30CXpr7n9w/70HUPsNwD8/PfMOFHoF3gNgAvgzBpzDd6yw//prr3nrPiXZ2QBcYciC03jrMrOPVguu3JBhQ5xRLNrWgsGP/NqqPPIXP58I5kW/cgPDGI5lrokdBTAdcIpln7oFN8YamX1u4c/YbCtYY4jcxsrBipPyEM9WYDke0+lGV8auRvAFN7gUpJzPoqz1GOW3zz70GSlDN6r1CvxKplGske5KQRacdQ2ofNPx63whXui2/W9zpfXhXLDVqRTdwfsf/uKndCr7PKhiSY5cbQYPuxhbxwhP6KGjPdmmtZGq4tvlWmzg49L2Glm/ncGv278ieDqd0RbGx4AULBB9ENP1Efzu48fvQ/QbgLPz8/xSQNi94R0EHBneZXv6sv3c/xUL3CWtzrMBhFH0OdksVm2VT7NXPWR+uQPcKgsuY0EnOTikxjW74lVOX62sxOkmfi3nmsOAT+OqnDkwb3AVvg6P/IjVXGOcmEO6z/yIJ2CpT722GlP9oUdfdeE3rafAKJ/iyb1WY/WtsnJV2030EY85j/gx/2v2kQ90dfzg4fWkx8i4T7rVGqh8E3mwpkvzpXO4lgt5mKPOW+h0L6qc+4axwFX4Ojz4iGU8tOYD3PO4/2fj03EdIqNeg5pMrz8rJPAr9U409WxpOI+/5Io+bRp/MP+Jow/9pI9P4b9iZzFfB/zzAOP1pWdPkNQNrrh+dv7Yz3y/ATDcr0GpOTgBlHY1vVGF8lfsCwj5J36pbNAGrjra2EYgLzawzFBaTjBbxyivy5GQ+XU4xpGWE5s42MgncelCPPoquw/86EuHaDv+YlvtxlCUV+OqnDzIW/LQ2EM8Helj7YTT2ScwWuJZp2KedUc4chCMftXR5qms5EPcRVvNi7FVd1G+i+AZjz41LuefdrSHlGCNp8ZU7puSD8r5poI/AV7WdDRfFl734IWyIR/5zXnam72cvJh7wWts9U08BfpYO+FWJo74utbIV9sRjhzEol91tHkqK/kYbsqbTtYu8QECm+bFvuqEqrlwUiaD15g+Gg+y9ieXJlUbOMjjwcKh4sgj+hw7dMaBsxj/5o6/Xlj/hLwWAiMQV7JZe/4AHb8BMJx3AK5XEoDU/n/19NbuK/ZrCMnKYHQ0B+dB1BqZfQeYA/rqL7KF8isHC3jowmBNoIxHcQpLr4jd4SRe42yeupFcw7xJ7H7MkEpr1/KoHOLWicyp4msfTtARb91ubB1p6YhPWowL404OcOOBC/j06WZhwjRke8bP3eir/uRgS5+KLSEIyxwGpU9MFTQW44x01e+m+8xlLQ7rsDZe5dFxLfGucS35XETPnNd8ljCH5L/Ge1XbVWtjc5H7p+ai81Rt2mcNKr724QMd8dZdjK38kMUnTcb1Qu1/1EbrgzGjj0vHH+Nuhv4Z9fSzgH7uKouEdriBEw/B9myldyiObuCuV8RDjvhE/rVbtzI+RhqjzbZzPznxN/1+A2CG/BEAw+CjAxLA0WV7emhf+sMXD9YG6wuRBdGoo0GoXYsywI6+aOgTNMBOtDGiVUygY8Cev46RvtBpjnDTPnFTcKtTdEY2xUEeccEP+pH/SFc51/rqb3K+gDCe2jM3DmiFGH7VF/7JUXwrtpizS39+QTMNKwJ9liAaewnztPWxLvemsW+sIDiUa2+wGwDsy/+m56rW5qLxRnhul5GtllDHTzxa6NlXn5FO7ftk9Tf5udr/o7HJeHwq0Y+a+jmx4JPjhp1zYC183CY8SRG4zhdGySGxFxFG/pLTiApL7I5hfi3+UiDGkC5m40nOpegc57sHH91/eP/0A/sNgEra9sEE974xvm0f/f/C7TteGB/oWrIIzCxqAPbDf4Qb6uydZeqde+WOmzFqOw2rWvo+ckMMHaPKHJvqwEA92Vox2ZvyT40I5FKOmoPAZ6L4ZZ1mIFHgnTov8e3GTLu0HTdzFvtQ5Df91Xior/pcRF6aax2rypW75lf7FX+d/aXcrzPGVbieZC2Y59pcEbOvvUhdLxOv+mz7v83IE97/7eCeFkN3UOscUWbLdW1t948CQU8baFVmGHJYv3uNpN1bWxDE1VZxuk4RC9gak/6h/4Vbt3fvvGS/kg9f+5u/9aqaH+x+ev/09sn5fQUSxAGgjzuIe/yygfW9mAxOZybHZKk/oO0mB3jj1vFz4D6uLs5B5Jaw4DhADyMdgfSiYepYAdBxqp35OcmcfzTWPl5wz5S9IueHsdEytsmzOL176xGP3tJ4Bn7D+QeOuQx8hrY1fOUwLMec4ySmLQz2pnZe/sl2iFTzq/1DOC6LuWrul417qF+tha6lQzkOxV2FG74L+//Q8HtxWosu1/kkzval+jJQx0Fl33IvsPX9RT/jnMXp3VuPePQgMxe2Ix+HClYxa34j20infCobNseqeRMz0s3L39CjuOpPO1vGQJ8P6KqdHFXvUCaD9RgLsraM49zaMZlYU96txQAAQABJREFUVUMXsbw2Jn/F/ibPHXxCancBMDEqW3XfPX708PST8+nPAnYgI0efRX/Pfu5/Dz9j6HZTsxOT5JHsbBGyMGwRIeX0boIO2EdiWOpKfxYfDOT1thW84mb5lRQikSkuFMwBMv9Kk+qgz2uaoFRVYeQ70qmf2Zk72y6vNf9Ye0oH2WtDG9sKIg56jcFaqy6X3oAEKvqoeaSjPcfcrdJmbQuVyGe37eoTaa7UenUgIy46rNmIGbWX9RtxXadubV3si+O+ly3yHnLSLtbNAPtyH/mOdJqK2bnv2Xb7cc2fOSufyc/1/sdY6veOOL5af/TX6gO/NTtstLNlLLamz3kJnfeX8PQbtD4vMQaVHSpj8Wk1fvwo4Ot38Y8GYZyGsgZvp71f+O00v39qNwv5CUDDBxTk9j+uN+2Lf2/jn/cdDAAD88FFks1Dnou+LTRP10DWmr/rxGUUx1PxnExCHv5oTrXYroWdV+QwxHGQxC61ZRwOi/o0OTrMEUrm6YD+KcdM3mhnk9y7tR59rJc8gev8BZc01LENQ6sNa8Y2vVIY1lBrPSFTGgrVB/lUXXHMsZbcC2x/dzS8PbH3kx6AGOWta2iU1xKt12vBOIqzAO3Ul/UDyVV8uyQu0Dm0XjeVm84dY6CljDW1sK5mazl8uv27VArye9k1iXg9oJ2t8lDHNmwvxP4f1brqfE60IFmAgdJUwJdaEZhzSIW2I5+RDj5LejP5vMQYfLlzPPDR3Kg3n7dfemn3KftxgF/uhFsAFyaVSY/Pzx/gF/kfuDafAmgN/6bwv/rqa2ldFTgQtgBLYpDzABFM6kguNldZXwuRBePv/ANEH7bkclNskoHNEhTkkhjFVrNygYLjREtZMfQN3WzM4TPTmx8W2nCxmb5m39WJeTC2t+ExtHmwCT3KH9Yl/eQ5lLoxVI5ZPv0LGwhbbaS+wygDZeWeU7cxVdyA6sZUiD3Kay2g4utCWPN7UWw6/qc5JtSeawct5brGkWPoZvs8fGZ6d9n2P0o32/9a36jf8DWmzof6gRhXfB+q82+WxW05mqtwmdZAKjD1CwsW+TFHxhxhFUM5WwlkIn5T79Q4ELE94o199IG+dXLyecOcfh4dXhWMd/74+f9BVyaDHWHXYBBZBGJH5Q2bY0FFLFo+wE+9yqqD3q6cqIGtIeS5YFq+FlfHAhk4YvVGRKhmIv3UQA7ysxUM8scja0cbfPEY+BByUEt/azH/qxewFrK76N8po7NkQ95y9WNDFr1doG28S7wdMDoVu0RdcSOukvcIcpCu8uyLvZQzg+2dOAKfQFtzrWO9SArKdRWeQ2NeJAax2/5fru7SumbtwvPC+x9+hQOvg6rKLcEcaGQ7yDrPCrF1uiVfxqBf7Xu6spjBoxiVKxac4oru7MrBNsun7N8JwNnNuhZ6B52fn/1cnuzgbxzTM5zws//u2pOIB2S0QbG6YrY0OvrsGIdjdWDkTdBFBCVa8ePNjsXCWFoO5itjSSbmI7Zkpk7rRV2CRIANfCuYee3CX32Yk1CviT5f9Le2i4Fv7sKmnN4XRrWZmgtOEOnfcQMgvr1Ni9YxtU7mO7AdosoJPAR8QxgZ+0ERnoWckeieqfGx1FwvOlYtiHLt4+G6UP+LyvtiKB+xo7jUab2oUw7KsIFvBdPvETpaqz7MScxr4nO9/+vAvIaTclYv1kbXFOALdffawGYPyMPXNobTOYBO++CoF3SCWeSmr1BU7FL/Pfw7PRrDTnjQUHWyO33z1P5pwAfIrfHr8273OfuVgtm7f0kEfl48JmldL7ou+jJQ9znkybKsA4Ob6iBr32kllwzjI9aknCjNnQBs5Oy/BgIjdR3QOqNYxMCGh7w7mHKtRWxOYy0JS+tjCl3k6z3Vq1zc2Z1tEhgyd7s/7LjDprwma94zPmAVPwW2L1HaDcYBl9cNedg11RAdV93sk+aOJRR5HHQQXiazskwvQ3GjPpepudbwJpPj3NQYl41/WT/ERy54bPv/Zvb/ZeZ6aT5VL7z+WhZvgiD7P81Le92n1Ne1h77yo08sW4cEoTXda5z6Bt6R1bf2jfOe6T6HfzbYWv47PvAlFGe/L88I7a+nboxN/h7+vKA7xGKmp2vjCQni0dnIaJiZTZ2XZSQ9O0ycrnHT3mEkbMfc5RYWLWwH9iBNo36Cz5iiSwr6wOaPtMh4JFHiPazoJzeXclEQAj/6WpwT++TCMdSZF3SJKXxLXefI3Bks0FgXsEkMWLIeAcum4FIPATa1q+xmsyOWXf5M+cCbBne8jifNC+PnpTJ119GCt5T9IFr1iVod5qeOB3lcHKQ1vLj34R5LQ7ls/Mv40Qdz4I8p/WmfSKLEG2yyTz6Utv3fata9KWNxrrOte8fmJ2uve54y56/6RU7pqzkSy1ZtxjtbBzUG/Ozh3NWmXCbjE3ymak4iN+Cp/SZb/hYAAPgfHxR83u4c+O7fE4qg5J8NrNiJ8zaSnPl0oOgEdlYEmIUn7W1dNGeMFHnoxQJBB1n7iruIvMaB+F2ckk+NU/OFvfCjbjneaTbbWAMLu2OEL31qzNqPnD1O2IZzxbyAlziVLvuG6XhQCnIABJk8aMXmubNPDHz4IxroVA/bZa7Lctykn87xoWNSH6+rOK7lyhoL/NJ1XYuj/NcpY03x0hpQ96Rb1AA1zbpqgoNkRjVL34bf9r/UkPsfpRnVjiUuNaR61o44iu/wdZTzrP7FD7FmvoqfJTNQgHPBx7kXbHwTgTP8s/7H+2xJGj3O9twmdvbjOwD3JyVN57svxrt/TUlfzGVKJsigAG6MJGfFmDxlw1DJXNi3VnkYy0c1YTVH99QCQcaDvqSufeqXWnK63xQ74bSn4oJC8V+tW8FmJI5pya56YK2vC2o4v9Ungw2EiN/ljlKRg/lpS9uALlXEwI++aTxQIAfgl+V4kn7DyShj1TH5uMR+0VwvimeofX41R/pdpR1sv6vQXYvvVcdZ/Ls9VBMs2DRzLpbsqgfW+s/V/sdAOcYcdAgxnqrOfh17GkJQu6lmZwpgoxjwW8opqPfaiWMLztz/C695o5iyL3iWt6MfZGm87z8CsPeXeWcA06dv3dm9Gf+wgA4+80ByWiSVNRnKaCnDd3SxeMnVojE+W/CkTB76mG1ps6QP8iC++me/CelDfW2dp6sKHVs7MFWKcOjVrBVbWmt/qI/JjTFOYyjj1jtp8libeNYIMTUu9VhEqlcZfIZzrqpnLPAkV8PTdCOtxlrKCYEPnrMbyXJMGlO6mtvamMas16fV2q6xPs0c1/KqtquuAY7zYB5OcCRCf7bMr/aH+uCKOcn9jP2q8/Qi7f+lurA+aHXsS3joB3O2dKYofdaZcZZiqNOarP65PCw58qtv6DIH2MQfvxHwKTvTXe2H/zTI/C2ANvL2MwJ8ccAvI87Be3HCcfJvOF1MmWAsOPqNkvSMcnTzwZlvuyuFKYLaz4Av848CpT95Wubj50gpfUYoKbCbtc8Y4KGsHDNdKSjtbOELWfvki/pOk99zTWMw/SjHwjvhLUBwd3GTYyEf5uUpr2OmnAEOx+QXIoq0saX+kHbkM6ynkY30h8S4LgxrUflkq1TTE+3X/Ea1vc6ENF5Zr9cZJrmW9m0CBoLWgOtniYf2pNEBmpJ2tsBB1j59Edf0017quab9bPpRjoV3wluA4O7iJsdCPszLU17HTDkDHI7JL0QUaast60I98dZmjIGtGxd8wMM5E3xyCC9F2ph+1pg5EYhWOFXtstqSbIZqCsUKpHMr8d+1T/TdzcY3feJvP1Gd/DFy/M3/W/bNQfurf7wYTAkB1cttvZJutci+wNJoJMLLYiZ12E7km7Q+CrnhaD7L7/yTy4U+x952sV4ycSwyjo6JdrYwmjwba+c06KR/Rm6giNttXHVPP1WKDLvUs62SsC+NKczdGPZgJWKKXc4cFnmQV82dNrSUk+0SQuUnRdXXWLVPvyU97Ye2rMWh+CeNu0p+l6mRxhuti5sYf10D+2IsjYs8bMFjcrd39nGHT4NpMUwTcbu9pHwaV/WUYX8e97/lXyoRB7hpZS4W64LxL9Wm6POLh6zZiJ86tMWfbprXLHv6wxcDYz+dQ4C9xmC8JR9zxacAd07si+LdXULcAPCOAOfspw3YDaCSRjBfwAzsufXMq4WvnDE29VF+1bdQU6xmm/pBtdCMccPN2I3N6Eo/c9LJAGZhbJoQ4qW/GtbkjN+PIXOnnS25Dsiny3mAzxjkjHZpDEv44j7rdn6DPDoHjlPLAXmfX0dyYIexCK/9fXraa8tcdQwV8yT6zONJxFqq3ZOIfWiMi9aDY0J7gC/W+dLeWUyRMfKtckPmnqGdLYkOyKfLeYDPGOSMdmkMS/jiPut2foM8qsMsPvbR2m8J1drUvgZAfNrZ0l771LNdyz19jZ843f/Ukau2tLOFHXLyVofWx78R8Dn8OX+/2o/8IcYnAJGBNZ972T7+V/LmYfy2uHGFbVb8Ym/gCzzTP1ycv+ahGJXXwlSc9XMsGqty1Ni1r3j9R4F4N13jiv+sdsoFufpCVTHRTy7ys4WdC2vAlzbhRV20NpQzhmCHOUacDj+KXXki5/Sjj4yFuaQrbVoYyPRN4DMsMFcdA8d11bTBo1wqV27mUfWX6a/FuQzfdfocmttF67Htf58l7tHcx9DuqyXsMS/pRx+ZL3KvLQf/pBivv/TX+BLHOWo/iLs4Er/j7JLQzdsZxp0Rp1LQrmMwpi4vMIvdbfTTqKoz+S3/y4DmGqcJwvpxxU8A8PH/9I8I8PRQxj4wJ84RGcxoJbn0Dt1sIADAlv7pMRcUA3kUZ+7V48zPF9pseDILwjvLV2wZSlxTB2GEJYBjGWHMVuPm5ljgdXzlWsoL/PpjlcgJMTTOrETMHS3zF536pnqAS5sJnqLmDXngM+NWHxAOfDSOy3VA2ld55vgEFXVclw0NHuVS+RDOQ+oJnlndlhbdIUEviZnlsMCjNTjUZ4GqUy8NWeN1DtZhfUcYs237vy/YbP/jlSNq57WymiWGtQUFZbakRV/XQMjJEbicB+ARzx6pc8x8rhiia0fz3AGiQ1zJt8sLGNpNdhv9lFN1Jn/qzh3740DyU3/D4vN+a9og3nqpfVPQOXBrYEE42C4BDVJl0PFCAkw02hmPYujHttq0D3nhQs4+n4jJ+IZ1PfruG23a3aPZUifu6VeCak5OETzkWPKL+mp+yjyrU+ZvArnpgPFWHW1oaUNqKNs+PHw4rqX8FQN5DQf7whXVmqzkYc6TpUlhP/uzP999Ak3FM2+2wEDGRc5DbPShH/usoRPGE3MgFm3izYHxqCNO+9Sh5VX9Do0Df3LrmKEnx6iN14L0BZ4X8ehTZksdWo1LGXpe8OGlduqhU5nYtfaieHDBR+NXnXJS9kNnwdf982kawygOYNv+RxW6M7gpZL+4ojxlPQ0XS8kbziXnqq4j6kFHmx4hlMPGsyJfV00PCPrnwMiVGNHNRPMjp7f41AhvwjSvmdNAUWKnP3lQjD69FiPyx9/3+T9/+pMk9n8zkB8JfPZ2/IwAQYJwNjgGSoqBQAxacrEFHDIu2Iltmv45/IFuf4ZRzCt+s5zDLfX0ZSu0mQ8L6cEtZduw9OdEuptyjCaUYzXwop/GZ51qa5hhfPhqDspV5Sh7Vbu/xdP8YtjTXA3ySQwIYSdmFiDsWPQOkxuWmnvH0UVorLDbdfZPP/ZHU5Znw7hncOu4HAm9x7Feo5sIuvhUD/IgByEHtou5uP8gziG8w5wPcVzAXCcfudgiJGRcde6btn82rFflsi+YPdvhvdz/Ft3yzHljPqPct/2/PKeY82vc/91E1rngHAXI14864HsCyIdzrLaQ+Vrbum0NAO4X4uEBjgtc4JzWkTnOeGaZztnhUy8fS+hHKUWeiP8p/FGg3U9474R7kOZ478Q+/scXAHHVIBccKCgwUDySSzkhax8OuAZjA84nw2szApgf82PrZJd40pywmfOyKvnibePh4vDxJcYE9aecLczI3zjW8kx8jJV9xjFfxqdq2C7FqHxwxrsRu5RXZR8X/dgC717TU1exGh9+AOzLH3XOS+VU7hckR4C7sUAR4/V80Lcr57L4NptDct4cW8enZAGfNaOxdzzTJ24j36qrOWc/gLUP9UhXeX2+VdnlqIZlGXE8FuvJFi6QtU+a0XQbzucPa2fkA1/mx5Z8F22Vf9v/U/VQF9aGrVnrdG37fyrZULL1OXst6tbsze//T9uPAV6y178W1v45INs9/v+n78ThH5l3LxQy6cOBDZQYaDfYGGjHq36w6woy2yK22pgfW+VVecGecXQyiPXWljpyo045i+xcwPl4MKY2KP7M3btLPMRGW6hb1w7IzLcC6Me22tEf2fbkkwdm9S9+Ot8qd2kUH7dBx7zKGnB72sQYuqVaLMYH4SCHRbzFSVv4+c2gJ6ZP9eXQbMhR1YO4ygA5Y7m7jFd9Y+yKnXwnH7cHFnZc1Qe6UQ07ncaGwwEX4nSxIo+OV3lgn1J3yyLWrJ2N+bFVXpUX7MmltSLWW6xPI6JOOYvsXMD5eDCmNqht/0ehRjVkvQApa8C9OC9sHRd1VZ2D21O39kTv4iCHRbzxpy38nu39Pw3W8y71ge4z9ikALlTQ3/rhQzb+pSC32FMOWgh8caMvOuIXW2JZPC3+khxkyCE3Zwkwyi8hSy+6eOenMSO35EoCEUbjXfFzLvogVsRzvXc1uRJHsWLqRCv/LN/Ih7Ha1hAv5iMqFYc1ho/nwzY8IkfvMa6SHSDP4mWsubNjGZMtYPHrPrNazClmmln8GUIUo+maFdjwo1og3xHW6RcNGXw2NsZgHdiHR8qSMHDEJutcmMUxSOqSFyEsZz7mNGMN/SOP5AVac1M5mIBdmqvkIb9GlxJ0Mbb9r1VKeVhj1NXnhG1OSvpNa25SHSLN4mWsubdjuTbYArbtf9nzVo/hPhjvf/yqP1992gddVlh8NKDXbJLM6JsOk8CJsKAdjknQDkKVaWfLj2I9MFPyTj55TOKplf7MCzZVWj9zRC7hmwtLuGhjGG/ho2OAkn2PpcHEUzFUL0DdTDyxaDU3s+c4FAPZfadx5jwRN+Kmzd1tjLwsZtbGdJqCQ3TM4N3DTVolyhdvGOEPzgWeDptkJnhiCwWVpH0s0m8hZbzkHMRv9R5g6dPIpvwZh63iqny+8E8hL/lCzxzZKmfVAV+5KsbzbyR1bdW+Q+HPBxTG3+EYT+OoTDvbbf+34rfiTjIl1insXa2JCZtNRs7Ftv+n1wWvmdbR6jV8TdF1GrVt9X7x9n/7HgBWDL6HaM+v2t/9f6UWKYqQLzpqp2xF64qZRZwmgDTe0l7bZuygLb1QEU+E9Lv4yCtsulk6TFLGxAoXfRlmseWagC8erMeiw4Jhn59yG3Y0jomZSZlGeLMOOs7JqUmCx3g0TrISAx7lor5ysk+7+tCGlna2tC3haRdXV6k/fU3nY2GfvoqFDvaqc3XRDzDuR/7aMt6oHXEBBw7yqJ/rQ4G/6AX/ilPOaoMr7IpxXePUOYfGsmgXedSPstk6P2K7O3ASWUt7bR2SEcNBXkOIJ5X0u/jIK2y57j1s5QYsdGzBrTJjjVrSAY8H6zHCrun2+Sm3YTPnISeTMqPwZh3WxiZ4jEfjJCsx4FEu6oc5SS7qo1j6s6VtCU+7ULtK/elrOh8L+/RVLHSwV52ri36AcT/y15bxRu2ICzhwkEf9XB+KK+5//AuB+HVApODfAXjTfv9/VoCahPZV1iQpY+/qAEP2xVj10s/F6jwoBGjaCwFbhshW/LNwptNFnFgXGl+XXw+Y9Wre/HleozM+n5yyWGYsA8WsjpGbQmcYNfayZdAu92lcrMNUv+UYE4ZE1mp8nYvUD/jEHf7gde5MUAElBk06r9SVlmNzNfI5wCexylX8ulxznOag8oL/rIaFW90WZfFJPuhYasujGzuJIr+Wv9VjlO9IB3+J6XQVp32VGVtb5Kl8IXteVS/9HGtLwPIHTRs0Ww3jsvjneE03rE9zaBTqNyPtFTXvbf/bnOQa4KLsa5Y9w6F+XsNt/2dZVgVZm7nuoWOprabD9R1z0mq9vv/xKQD2F363rf3533DuEpNEUn+oriZjBJ501Uvc2aB8nbUFNLMhIfiKf+Y40k3GJq1iEuyCr1vBM5csNFCoi2FywnqKA3seaR2LPJbmoIvfczFnS7LxDzgmzCAFxI3Yjkt/yQf2wQV88zHjCJJcsI8AhRR49aFcfaV/kXnJXBE2uFf9JY77arpu485VA6jbmum10rNSZDUkRr4QCFTFln+pkQJM7sYDbuUnlnVlH+2huuDTMXpeVS9xZ7Xz8mz7X8vPPdjpOC9Wy2lec+U4dKpt6AfzOGFm7G19YK7Mz3Hp33QRZOAI123/jwqje2Nkx+aP2er35/jlJClyfnKO0pTCm/gegPH4lwDfuIXfABiwyubMja860sXCYPeQdvYPLKw4oQherDIg/G7+tOBBMBjDgDd9wJcVLkCNNRqzwbPQcA2866SfsaAbXPvs7qK5eM6DpCNHzWmVezCmDq8xNe/B39rOqptPx6F+lBNMhbWay1JcgTtefdS2IOe8LNgX1VpXyIfkR7LE6gszjVw/vgUnpUqo1aDegHR1Zhy0lJVnIOs6aT6DidEak1d15L1oXcxv2/+teN08sp61Ze2hh7w0B2bWeV3lHnB0eI2p+QzWY64c8+k41I9ygqmwVnNZiivwbf9fff/7p/5WU/8S4Jv+ZZzBoVKLrn2VlxalYRZfeA+Z6IiBNeM8ulBC1/PvGQP4jCN9wCcLslu8jIU8a67aJ865ggz2A76liniei/Ihx3oxBvRLWOrRRi45zsq30Hc8SkiOgvP6MI7YdAwas6sn8fumSMdKn31t9UGMqlOOOobaV6zJOY6FuizOieQwG3bGNIvgSujF+dY6p7/yJP+McVIQ7+0swwkHidhe23pLdXG3Bd5D8otY2FVtbfZc0HV1WLybDyI06oMxxZaFKec5cGh8bmuu2mddnCvIYN/2f19PL6Y99VNI7dSynpNmv1R9EKPqlEXnD/raV6ybZV5HvEv+gp0NO33MIrgSejG3bt3Tny1Ikn/G6Io37Xt/mItT/FGAO34DUIBKIHK3SYrL6kAqdq1v8TTOrHjiqzhRN5F5jwpDmzh1RaUevrzrpY/yEYeWerTEqr3IGY9+xT7sBnY2bnJY6zb2leSAnPwFkRyJbxvA802dEps8iJfjA5R+sZeaSjpQgIM49AfXbNyBUb3/jBZrOrjcRl60mmvtD2IOx6E45ytjUTtkjcm+5lTxh/ThTw7iGQet/e8XdcRYq/WacQCnvCJ3fsLn4iBOhRzUt3gah8MY+SpuZmfemhd1bMWpm2fq4bvtf6/Gtv+tDIN10/b287X/ce7jy/+n/CiA6z0HqJtGZQK1ELSrDrjap+9Kyw3dbUbwj7hM1+Eqb81LOWhTH9fJRBLPVnyYp7p3Mn3QUu4ApbOAWYqztBmBX3rBlJG14DaeVf4crzCmruS/rzvw07nzPLQGKgu3+jR1qy/0zmGtyzBGTPdhfLbkRF+G18nARB5ZJ+Chs0fqnEtqqXyMw/Gwhb7mQuxFWnKQly04OOGqc/3KviGWvMCrjD4u4iDTrrqKQf+AizXt5hn8lRtcputwlb/mpRy0qY/rWLTG72b6iQ/zVPdOpg9ayh2gdBYwS3F83AMf4EfLD9FkZC24jWeVP8crjKkr+e/rDvx07jwPHY/Kwq0+Td3qC71zWOsyjBHTfRifLTnRl+F1MjCRR9YJeOjskTrnkloqH+NwPGyhr7kQe5GWHORlCw5OuOpc3/YNfvH/9N6t8jNIEgI4uLyYIIxBZhFGfqNCgFOxJblusgbxO5XydAbrdLxRiTU8/P2TEEuaOLawKZ/JvshUB4yOl75oKQNTL3IAQ5mYiAN91hk24PAgL+TQewrUN+1kq3rz83orzuQuVrHt7TKXJeAob8N2eShHyjHGygt1jMs54p0/+RbHkrzmr9SUaVduxobOHowxqb36Pd9kbFLwUa1tl+sKLn0iD+8Tz5ag2od+pFvD0+ausU451FIngVqcrjd1ND79w+o1VfvkNZfWcB1vTOoaHuzb/vcad+twXvV1TVf3ARR2zoNgu70ken+da1kNyEyFqQ0+59j2f18n1lq1ocN3/07rPw+ouEXZCdruXtrjzVesnFS0lBcDDAwW0xemUeYC1cGtcrrTgLSoyKdcHELYWg4LfPE6s298zD+5mAbjo48c0I922iChNxt56O54+qQyBOWuNvR1zGKfxQib6lXOnIVjLrZCsVwzu+aaMifC0KkLWXOHDQ/oVG/QWZ6zwKLQGKKeiftw++wkVNwgd8JmbRnjhe0zhwMUnmubD5mVgaNYmedFxqaMFtPnz6c2Vk6tmeI72Z06zbBDPuYKEIcQtpbDAh8XtPoPAnEdJhcxjI8+ONCPdtv/nAirjdaJNdIaUlfmgXV3qHLQV9t9dmL34fbZRzzIu+RO2Kzdh1ux+48A7uFvAIyuFccOjgECu4SnjYVg25GUjsy1WnwT+L4IgMY03tUJPiQugynW4k1XvGNGXMNwU3ZxAVZ/OouOfmwJ6Vri0eo4JZ/0N0yXA32NsNMrD4NRJz7JaxiVdVyq99kgD2KSG7LoXe3jaQDlEBcaJ1XlqH3JPZ2gK/pZvMqTzgsC8WwBW5JJoXbqugqF0nCZn+etVUzHeT3NVGtc+5P3JO3FDPOe/FNCrsAu4WnjXLBNgoHgC2qu9/pYqKyTxjTebkw1Tu3P6SeNYrtp2PY/i5RzYIpt/0dVdD2yUCPdM7L/8eb/FH8ViNdoA7luOAh6DVrFYzNxQ8nGzlhhyz58ZdNBT5u3ym2haUMWQt/pZxkyn2ogN9tqZ4Tir3HTRTkgR5/5sk38SCBHiUdochhONyTtaLvcRjwjnRKozHxMl7FhB4fwaC5dfOUaycLRmVMvC4OAUleqmY/mkjYKyUvFSos4xNeWbtSzjxZ+UrdmOqAqMlSt9Wg8Vdf6QlDzsX71AUTjcKyum+WvhANZ8agJ6yLDzlhhy77Xa+KEnjZvlbvkLPTpMzGJxHxE5SK52VY7d1Px17jpohyQo9+NJcELAjlKPKLJBe7RfALX5TbiGekYoLbMx/QZGxhwCI/m0sWvfLUvHJ0p9YM1XeqafuGjuaSNQvJSsdIiDvG1pRv17KOFn9StmQ6oigxVaz0aT9XVvqbDXIC5YzFOZ6mUQThZ0XlCOqhi90KpnRlgUKGvSWa/cEGPB2I6ZmB3evCKrWEZ2Fqx+c/6tE/YSEcb2jom9kd+1DGv6Hvj+2VW+RaJnOiRo1nac+iyHopTX9PrwnFn2AtGY8zwcEo8Jm+6vL7sJoYKaUdjEHMnrvC03KJmilv6dSvFdEEu2RlN1yjGSLdaA6mr+opPV2ukrzjIo/7SvzUgvMNKFPtoz/lcaMzi42tK7QyEoYa+jin7hQt6PBDTMQO704NXbA3LwNaKbdv/47ps+1/qUsXnbv+PEu73AT79ty8BTj8C8E1TNm4uCtHPNqLYsm664VLZJ5DqkX8amzDKjS8mnmONB0684PDSGMBG330dK+CKJUeNEf3kIE5b+iQnYiugyMSrOn2bEvG8HoqB7L4T+WyeYC/8+GNKvDpOxgw8u8R6/agsnImBQIwrLbeu7wC3NLPZF7i63BTjfCNeY5RYqJnP0xRtkpRP5UA0v4UNRRb6oWVctoZZji3/KBA5yOntNJ+pVhzkUV9ipx8FxQvOayx9wDNv0c/WldgYossplSZobOpH/rRFO8qNdfYcKy84tXQaA9jou69jBVyxzKXGiH5yEKctfZITsRVQZOJVnb5NiXjdfiDWfSfy2TzBXvi3/W/F05qoHHX1+e0/S2HFp5Z+aDlfbA3VOCZ4SnqjTo40QpjmM9WKgzzqS+z0oxD424bxPwVM/ag1+nYxiBDnoGgjFhjBUb3YVv8OyAJYW3HRn20GxCZ2Tx65SYjvYltnjz/gXiP4H4Ct9OhnHas/+yW32Xg70vKzUNrIxX60i1w1ZvHz+iqGC6XGIcb1BmI/+egYiuqfuDVhxGt4xjJOjHNxrBpT5QgJv5yjpTTUj3HRhrwam/ghd6kPMKm64D4b8a/GllDEyTizJrSRHxjBUb3YVv8OaFx+yZ6mPfxmtUVscu7Jw32BJZ7cbPf4A+bTAf8DsKTVNutY/dkvuc3Gq2SWTfKpnlyqM3mRq8Ysfl4vxXBN1jjEuH5UZzpGgOpf4w77I14DSmyMc3GsGlPliAW/YU01F/VjXLQhr8YmXvlSLvWBPlUX3GfJ2QTsrO47AMXeujU56S8OChjitDAaYElvmL7Y4IKy6TubcHR6jU1ZY7uM4dslHE1hz5o/labzGIqnDDzkkR/9R234Zx3hrxd5VTe6I+zsSEN5YpzUMefi03VHGPoDGHavB/URpp93KqM27kqddegLTly137SHPTNntJThqTKZRjrYSnxdU31NSdS3iu8te3pL+Sy5ZQltnkvO6pL5CMZ1F4knvs4t/cWaAEPcUqwlvQXJvFtA44Ky6TubcHR6jU3ZufQpiigcadX8qTTdrHb0BR7yyI/+ozb8s47w14u8qtv2f1eN7HAu0FKGUWWCRzrYSv11TeUckWPQKn5gXlYt5bPkEUvXN0bJWV0yH8HoGn7FPv21TwDEhUAkdOGkMishNDE4MxlYwa2xeg8zaVLA28N00Ha2s8DBBp+ac+Xp4ky+nZqdymV99yBntS/pg68bP2McYMO4cU3+kXdTljFP8zbEw4d5Ql66ljAcM+qOegBHHbgopz9zZVvmj3jmgT51yUHj1HJsbN2HuaBV39J3H9oZa6LupG6t0bLiM8TTz1ssZLumcrS+60bKMKtpJf5E1qTMR3xSR7Bya13Eh9DVdgkfnDlXIAFWYxXiWY4om+GRamfb9v+0X7yG0/6Z6q0T3Oro0LUnzk3FcI63/V8r4/1ubQ4Rz97+t39NxzLlxKLl5ty3COoAiSdXtUs/yoDA05/ZFPua6AubMYIo/1Eg5qB3yambs06bxGxlnyQ6Y1kw5YKsfcWlswnUq45y+GPhdLnQLq0vLuWCXHPAIIST7vu4iWPb4TVmcFuQ4bzFdExriISHtjoejVv8udHYcswFNuymD6w5noCOYlYdc1R95amRE8t3kRVgffuVnNlaoR8Kyxg89EhBDPqU0VImbqkFN7H04xhHPsRWG/Nbsgs+18m2/70qWJPdnpNaUfR1q7WFPJunbf+zXkvttv/7yrRvgHHzzhaUgXXRodv7z3vkKpZzeeGaJsEWbOEvbn3XuN23xIBu4jQXTZL8bIXRfagXn24zMhZb4oWnE4mDEtjod/m5aQqIeNVOzlkujM847E8OTRL9EjddatvhGYcg4/UvDgk/TelXbbVPB20HmG7swBJjy2Z41VwriP5sq33UH3HCf6RX/4UYXqOhbXrxdhrGIJZf1pyWTYumeVBmq/msycSjpUw840e/hics2+ofhm3/94tW1/a2/22RlHWGZaM18mVETF9KN/nTwtpLAP3ZpmFFGHHCf6RXmoUYz9r+P+2KvJC0josv8p0fAfTX4lDe+8pBEmmNr4tDfkKk3+EYU3HQ4SE+k7lPjmOkPdsVjuGC0DxKXI2hcsYKwW3qG5wcb5+5OTEmWyXkxlE+tQ9kxmmmtvBnOcGonDU2+2gVF/E8RmBUntWFPJZGn1cQeRpTRRyDeBHTLZBHeQzymlgHkuJV5t0nc4WryqN+5x+x6FPbMHcN/JUDMv0UONB1dVQO9ROZc9L50U5/jUPZi0/gga3xdXHIT3fpdzjGVBx0eIjPZO6T4xhpz3aFY2+9S1yNoXLGCsFt6htj43j7zM0p7Nkq4bb/2/yP1oHWWGu2JCte5eds/5+uLT7fLFxQKIQMdK8fCwcf8aP60LaLo7mAQCayw1Vy+uFdFGVirJ++2CCRKzcYYd5yLMHhGI6NrVPMtmWX64yzUww6mjPiSM6Z+8DNVZIX1+asBgbsxis+PT9fQcyBORHL/jCPqEfkXiF9DE9mgpB/0rikPpm7YVUP2SNHbm7jEGq++HsCnH+1qaw5LOmNJPMJfO1zjXk8YDouWTsLY7fZ0kyav3JQrv7xKULmU+rVk1oP/uSCUfi0zkM/KuEjflQf2nZxNBcQoB/cHa6S02/b/60yrIfUKdcEdDJffV25eQxDDmLZF85JjPUK7ADXx+jjay4TH2imXDJ341c9ZI8cWLfRTfyd90j3//RL4FpdyrVI1Hdtm1yfhCU8i975WYd4tFxIiqFddRU3wihe5aU8+IKKoQRfWyyLDo5zq+Fz7JFbftxZ3Ue5UlfHpXlTNoxXm1i0lIGhTD1a8gsHRW1149AnN5YCqxz869haCCNhroWvQyomZa9A5+W5L4yV45ry6yJMecCfHBnLVPzovYsYnVrbVPcxmENS0G8+FIPIDQRwxIZzG0fP7ybFMX/VCVfmo/ZMToR9doe2QXheS/hBul3O8GPOEr6OvYUrRVuKqTyUl/LY9r+VWooT8rRnWMBBexBWuEkxmm+zdUjFpFzmHz7IAXYdA+KYjuOaxtJFmNYd/MmBNq4Xff+PbwCkACyEt7XATSnPHVo6pehm8QmJOF5kcnMyxftS4owHkzrPoy2agR5BR3WIPHVhpDfHwDjTOlodwvDFcyE2F7QTIp49cnEzPvWjqLA5tyQ3imW+XSxyASt45o4aZB5hz77ayMNc0Rc+nw/2OQ70Ex/VJib5JH7qYqwVSzva5PWOWlLWcUCZ/crreabbfsHwyUW05dPVnTFagcc2+CbOgN2Ygph2xllrl7Aj3ljrMSsLrHOrjzvibPtf1/fKfNW1gfmwR64hzg/1o9mAzeu+7X8vD2vWOqOKTfUNa9a77hP050t9yOlKwycXUZbPk9z/7QagDkSLQhtbJsoWejxGPsRYmwMNnvP4E66AzAasXORg/JGNGGsRx2PVnJZmhrzCkeJKLM+ZdrZ0JCdb6ketYbrxE1M5qR+06c940S6uRXDL/ve5o++Av1PBF3PHGOjXj1advx9X5qhk4MAj8GlCn5fJQ1/FAOs04sfxAAcO8jFm9HNd0l70iF3jJ1fx8SCsq4/LAMyjYtEfcLd/knYABi/Gwsv5pa/6kJfG5matQ82xxoFDxUQM19dcBtjMJWzb/o8CWj3q+nKLzgFrvdCmP+vOGi/gfR1xnQKDWPRd8qEe2G3/sxp9i+3IuqKe3qeih3rPaplzR/PSJ46g0TXh/AhQLpnH3HMF4l3g7OE3AC3FKdHO8f9n7/1htuuWs773nGMbOzk2kdMAsdOBBOlAiaAKVSwFWixFSglRlComUsqIpIwEdAQJSJOCyLRBCVSEItCEDiKZEhLThAiOiY2Nz8lcs+c3+1qz1973/b7fR/BnP1vf/cysmWuu+bPWup/7e95/lfT0Djb5KYzkcx0h3ejwLbkCN9edLeLwpSRXAfApz2YsTbMo1LIYYwE3cvrv1hMvfreZTr13VIvd4hY7C/w0vusLDDETM9fgdtK+4Wcf1WfvsWIm38wPBhwSu6SeXdzh2X7tucK3k9iCe6nZGO/sCSEefK/ZgHDIpkvTvtBf9SJ/4+vG3cU0jiKuUj30PKZb8cVxZKp8Weapr5hJEmvj6f6Kt9cJq9kM36xvrjtjxOFLOeaCTz3bLnT4VqGW6YQbOf1364kXv9tMp947qsVucYudBX4a3/UFhpiJmWtwO/lx/9ep9OzYgHDLpmvUvtDnHqwsh7/xdQfvYho3Sc71O/c/PwAcb3Zn8cf6JJLmn9i13h7gWZTWuwbMNnPNtXLxqAblTYz9BEH+/nV3cc86IJjSDvK2zom/W9PPLq/bTO8+zXbQ25sv+YQhBzaXzRG4wub+lP2yV09cznundz6lq3OD3MawJ9ab1aD6vEb/5ZVL3xa3+Oo8dD3UYXjPkbGPNUPwWna9lmupDQo7s0st+Jd63plrBC4xB1HPM+q5zINcJg9M5UvKUwf2cf+ZxEay75u9WPbH/L0vZjuY7Y6QShhyYHPZHIErbJ6vsl/O2hOX897pne/j/mtE3+T7v/89AGpqHJLZZB9gPySKGXHLBchp8c3gDOxcHus60LBlXvncn+sC2eFMi+PgQdZlEVdeu+Sx+p5i4ZD0i/ZujMcv+vXNN93Uatiem9lyLoH1/Um9amwujwl9yyWMZmM9uZ4U8pk/bZcvvIFVbwOv+pbyFI8BCaevXU/Om1oqn/Ko/uzBY+F2ufFfei98z1oxeikfUhhyIsPUMcXR/bK+yOD0Rzni6XtpvmOeVovlNdijOnvtPJX3Ur/Y5Ct/k885yj9snctjXYcsbJlXPvfnukCDe8HBg2SPIj6nCS8cnoOYnSx89vFuzI4nbXVHpp9azd5zM1v2G1jfn9TpSVjXK3bLJZ9mYz25nqHymb/ohqg7wc9mBl71eUk5AQxIGH3tenLe1FL5lEf1Zw8eC7fLjf/Se+F71orRS/mQwpATGaaOKY5lANgWmSf0tChHPH0vT09yJz81WF6DpXr7AWAWmGslFel8qpj0PflnXK07l8e6/tBAUjjWcvRGU5/5lriI74GJC/wNb/sHX3MM+9e2HPX0nigBNX9hst6DGc9syr7gwpfHcNQ1KXLtGOm+PgBHmPqQ7wv6yZALb9CaTfUvPRxZz68P+TPuVV3+UyX6sJy3uRX3+Ni9o8bA3/LBVb077u6NjBBJx/fa8jq290q5Kt/WvxjPRefyWNcj72PNjj1pjxj57vaMuJBZg9aOx2+cqd7wNcfEf13rUU/moxbkF+bqPZjxkdN9rmtWH/d/DOwbdv/v33V2B2ocQLXe32THHJal4uAzjv2lziO1hOug9Y8gg2eDOPHkCUtkPR7LiSnrEdbw7XM8uuOwKcDtTRBKYPb9Och0OMXXhdd8A3bLRRzSKN9SZ/2+dn1HFv5+E7rL7xymv+zHsLvUO9vy5vR8So7wXQ71MexLrd7nwCWp+2WY6yPz9eu7uDvOUcttzVmSHbBrJYdl8KVxU2Pm2dgXWvnhM+xSYwdsbnfEfNz/zVw0M+aJ7Dm+qbAvwH3tOn6X4f+4/z6Q0Oc+zPWA9/JdnAJ22LFXy90aeH+f3H8AUIBeIh3EXXApThbggD8fVPcvb0Mdt1jPdPijrgvCDdStSNdPpkOTTw/yWF2/Wt52yoZdRnRk2dbZdPSqUHvE5myy5hMCB9Ln1yjPm8azvi2+A0OZ/fvadY9BV+3KnTXbvlPPjLc1/UC1SOJlZD4L4FjQG3Ldh4fACM8Y6vF8osZ+pImlcYGVdHth70TXuAPAufPd2o55N69qMZ6l5vwwZPtzy1kOccFnnLuwmafrmeCalfttqlb7Yj1ZqCN4Lgg3ULciXT+ZDq3qebmHlrcpZMMuIzqybOtsOnpVqD1iczZZ8wmBA+nza5TnTeNZ3xbfgaEwB2y+dh2/S9Wu3FmznS/qmfG2ph+na514GZhPO0+F3pDrPjwEBkXGUI/nEz32SrXUClZy4Aq+FV3jzgvnzndrO+bdvKrFeJaaH+5//GNAQRQvETVZ2bJBmpTNnsaaTbvFJ/XTv8atcNsk/QYpcpBzAdemCYMfvKXIvDWM1uEBz3rIs+ZwTCxrSfFTw9QH54XH/eL69lm8Nu2o2UGrvm5s+bKWk0f7QH2Np96V7nHV87iLVUr31YyykuwtPl9u/JnU7bMK+fB7WwNHb0i5VXOG2NHKN5GqLSmS3gCdq5I1dq6tAK/RzD0zs+kMeI3uyvNB/nSMhlVL1+ORR/0L78Izsdavu4o/50YecnqP+Cp22+fH/ffJHvqY2wKQ7+P+LyPJxXLurm4snH2k7B/3n+m41N3f3//454DDES8NsQfpG+A87+h14JtrJO7frT+5FKe8em4uTXKCEc51rePpvOG7tLzBH1HxNXJ2bNWyvMkRi+zAoXjtxbP04/7BpXxZw/gekBk8Toa5nt3in3KU+7Q857H5QZF44Yak+sm40ZsgS1szFo6NXPYhiYppbnDkVO7LDAW334Hvb7pLukvNlcDtrm966JlR5waTObHDx9r3UenlB7MU++aieQOf+ti34u+5ifar5Kx85xzWTfq4/3YLxr5+3P/9mf64/+sd2k/pxvri/l/f2XUoPQheDmtJLnhuzg6vuF3ddv6hfkve5SB4+LMuah4+QqbsgzZ6nLjHNTkFkq7cSGxOYHhm6u7WDZc24+y6GxxK+JcZuK/0bZzh8KsF9MNdPVkNFnaqo+bH/s6oi5Y/VfI9hNfO0lpfUCS+AEcDzXtYLbg9pXiu6XtnTbzqpNYZJzs4+Xa4UeKlx8lpPI1NXu848tq/zHmhmHUBoL6S7GXm8T7AZy2+KH30tEHsTXc5QA9/1kXNw0fIlOvMtCUxq899PEa6ciPF5f6xfsy3i6u+um6vNfDLDNxX+jbOcPiVBv1wV0/el8W1Omp+7K+DrsrH/T9msu7BdU5pqZk3NtfHpTu+rvf/+gFgd1nyEFfC0Js8TLmpbDSS/9c7MnalHtfGB2XBN7cFeK3D34cta3+4yMSF3KGWGpbU1pxyWC1LjPFb+BerO+7uNVnPutJudXXSsl36DbvzwyuJPlJc39A6yY1CPchb2NlHzpY53uBVn9d+vNFWh4q1fAf2hkhmciE30CUXfnLMONb4wWNn/UIueyDs5JOt/jTBOo9jDh2v0e5iFb+zy8ZhCd17T076QH7cf03yeJgJEvsXSp8957T3NTnPe5P2u/0MLFvapez2VriofclxpjjvSpO8UKgHeQNf+hT2xfxU3xKT+OpQuuU7sDeJZSYXcgNdcuEnx4xjjR88dtYv5LIHwk4+2T7z/l8/AIhkPirUNp2Dsw4hAF0QiJXoZb+Z50x0adjplOslYQRMTNZ45lDN3Qdldx8KD+OoS2U0LQpSPgH8uRjcOXTLPTy5zHomJtf0FMke/UFDP1Xz2f+46LsCZLNeJ6S5poM1schZa+HOkUVfwoBD+oEkRpztJ6FMER++lOW/nC3ZCxfKOaOimX1d4oVT/qe+qr7JRaUXe9WK/yLJ5Y7KIVPO8BWHx97pyXk62Zu1Xtuj6w3I4F25J2toVrvs2xkT0HuF4UbOpDmPqJUn1t3H2Rjeo4ZRl5xNi4KUr6NLuRgmwNYv9uvj/rN3yHN229mEO/c39idlzfdytmTXK/expO1Fn5FKd4mXXbGcA4utkMMX9smF/2LfcQCWJNe0VVweuxcczx8ARnAXWInXIRynvDFeVOt1E0rI7Pj8Sw28qZG/aVBe+Xe45LcCApN9uN1rEMc2T/Vrf367e7nEU8izzPhL7PWgXza+at/mD9/BsPacHNVX7+O2z5v+hZ34yKUsXUf5e+0+RuH9OqfsGR9SerzO+agjZYpnU8PhuH499/nweV3kSD6vqWh6RgvtZm+oZ8NBvuQCZ3yXHHAICz4kPG4TTduJk0S3PKne2R1HzrJN/rXeYz8a4zyt156VkNnxH/c/9nnuy9iDHOXE5LruhwDuD/04pTZ0MMXd+7jLJezOLtu0Ry5l6T0tf6/dJ149Xqtzyp7xIaXHK3kSr46UKZ5NDYfj+jX7zPjD53WRI/kMA0vPCEPKY7KrqWwbDvIl16w7SC454PC5hA5P915cbSdOEn0pMpOlZf0AMIvy4PBdCnS89IlxfxWQRWpG5eNPDch94ff8Hn+A19/YVX6E8lwGgnMnN7U2bDdI6jffpX4InHv2VOf4MjtiJx77lJGj83u+wJFihlwOh+e60yGR3//khuz+l2BoLYzXlaZNNapXL89JvKSe8HV/3tGMGb0foZucSTnsxNr5VPzlcdzFOQxgw3zWn4sBfFiqR/r0OZhN0clv+ZLx1drTTiz8woRvqb9sHa7YiZl8SSPcwafYj/uvKcQzZ3dYz31nfSc9fsx9nPKTwfdXVl/f6UTL/3H/mca9tL1Y7o/P9z768AgLPmTzmE3AL7n/6weAp0JIJgxNuU26r4VjDT5NdRw3PoXkY3hMW/mAO8qpXNvgMjoHNbVL71TxgEHK5li3J7zihJuPsIb/Fn8MyPkqpj/ACB/+Xk9OrfUbu+CFy9fSWe/ip+0JD48kufixefD0ARVn+0MnTvb5gEsZvDzEILHfScUHNmel7VfcjL2zUcMdNzzgkOBZF+6oweoRDkyod/u52NXD7nE7dQln/Nk3613PO947Gzzyk89t0n0tHGvwaarCNz6F5GN4TFv5gDvK8SFtGc5e5KamgvY+kAc5sW4PX8cVzyKENfzH/a/pMPuUH/e/z8zdEXa7naflDMvOXMe5g//4Y4Csnn53MBhJSKV78vTpy3gcP1zb5Q1eF2v55qLgG2z93GtDb4eLeHoYMqmxgYVxY+firzWOTRg8C3b00j7ZI1+vxeH5c60v14ea5BmdX8HTMupp99buJ7KRq7KNC0jZqXVpTb4bavBrkoMvZ6WGM35DMGuZayelIP+jhO5HH78cdNRw7P+yd4Xf2eRa7NlDB5QSwjdTtVPjiei5pu+dOXzc/2N6Ncs8Ej5XPyMbO+dx2T/7YNx7ZDwL1uwqpH2yR75ey+n5c60v14ea5PEjc0VuLKOeRmztmzvWAaVs48JXdmpdWpPvhhr8TCO+nFXeHcVvCKZtrp2Ugn4T3v/jLwKi+c0JmUPuNUMhloGJQz782Kd0f+kXbsUYbrkA+Mzv2MumN+7hMAQma1BPia/D07HWxOw7XNSXHB1j+TYxxrj0utjnQtxdo8Jq4yZ/rKlJ+Nadj1i37fTAdZ7wu55w8TjXrAVOx2ArSX0piZes9hb+iAE/aM6l5wq9a4b7RK61p91mCh4+pMdLz1ojLmTXRizYXezOJjx2lSI911XX4BtWvIekrohvHMdSnNTYzjO8Z1amXmctYSSWEHHIhx/7lO4v/cKtGMP1TOGSz/yLfqmL5mgckpBggytr0Dp5Q7ZueKnEmJn6kqPrsnybGAtfe1kcYyFuq6vnNvljTU3Ct+50XacbN3rgOk+4XU+0eJxr1gKlY7CVpL6UxEuydSMW/KA5l44PvWuG+0Sutae9kgoLHj6kx0vPWo+96dqIBbuL3dmEx65SpOe66hp8w4r3kNQV8Y2rY3n8EgCJ1rBcZSPmv23MY5VwNh7+3gBh3V96c/snLcdlDgYxOCanaq66M694rI+k8i/yx6trIK9i0ufgQ1/6Me7kID6gC+5Kc7XAhQTBGu6Sytc5wCCJldzZxHGx9zE5owPXswmr/9ptgsSjF09xZl3SyeEYsDsJHinMLtb9xdOzcHzoXv8lJdjmq156XRHC6SX79Amy8NgcweIXNmxZa9oMK58ex7ZuMzbMY29JdvA1LsuvnNQGzmTizd/xXY+BUeXb+HtfhHN/6c39cf+PSdrc08Ca2dncerZgkAfTnk9WcVyw+7PY+6Mw3yN4qEvr4sy6pJPDMcLdPeCRwu1i3V9cPQvHh+71X9KCbb66Z72uCOH0kn36BFl4bI5g8Qsbtqw1bYaVT49jW6+6DkRjHnszbOOy/G99ev17AFR4J4fpKnvoV1dbMjmDaKvmMJrXetrA/yD+ymDVE/5LHBhk1d0j2/VBHvvxLeEpiaFE8OHsYS4BsTDMO7NbwpVPL3H0j2TPg9I9ew6vhXqRTr6ziYd8ja38rEeuNN/ZRo6ckWzYI657gP+rSHjFUTVt92VX7y6v8w1/1g2P9zRwuUye6FsPMeha6xWYs9bCZsBX+OK5MvWZa7KeuafH1lWnWbbqO3ua+UZ9IrvECrPBZeKP+3/Mf8yn95LzizzQx9edTTyyL3xjvfiK8M42cmRdsmGPuMt+e42fq8OruKqpZ+Fcu3rdj+582Er+Zrz/rz8AaCBvDG879DHA5GHAxnmJFcZxhu1a8M8crMPfB+0Jiw9J/E6qDnHxdW0AAEAASURBVMd5XW53PTD5aRmbx9zlkF2fsCPd8ZzfKHJWzoEu/tC7Z0IlhQGHnTV1IaddeHzE3sgsl3hhdnpwXfbbccV96SPau3028Rfsmz0sNQ+Sy+zlf8qNT7krf87o3Vo8/7sxA5c1t03ZN2fB80xdsfQxfba+7Kn5WhUPtRjnJVYYxxm2a8Hf5EMJf5+hJyw+5KBZll6/HF6Xx7semI/7b7OK2Vz22+dYA++9q/Xd7wNI9yaesJa+J23cKA9cWff0z7VT4lPuyv8b7f7vPwBQOM08DU/YiSdO0n3O47rjZSdGOi/D6HBcDoj5UfugwYfjldzhqUM+/F4rth23frqAXzF6WKdanO/wKY5axDP4WMp1eYhFXgBheCTYBZQt4pYLEjmi0vN54t34eu9gcDLVrwdJPPLwhvvAIcu8CjiwDg7MLd2vWF8L1NvrBavUY919KS5e2LuXTrQq+WfkZ60r5I2VijvyPoJnntmjBws78dPP2nlcxy8pO3zSeRlGM+u5mX2qPWv4JuBuvcNTh3z4vVZsO86P+3/s4242smmO4+m9w+7XiVkjiUdWDGcECdUi4cA4ODC3dL9ifS1QtTJzsu6+FBcv7H2mOtGq/Mu6//sPADSF9FrGwHJfHFf+bsx9znPd88Pr/K5brIaYL7N9bapyUrP3Qi3y6eVrJXeb1vil88gGN7aQfSjK37MzzK1KnuYeg217Jjrq2tTwyP8KrxzUAVHELH1hl5xY972jv6onU5y/azrrYCyvYj+nth1XXojaU/zBmeknN3b1bNgeAbYIPnqgiUa8r3hudORk6bybfCMm2wUvnvL3GXaf59lQp9v5XbdYzSJfZvvaVOWkZu+FWuTTy9dK7jat8UvnkQ1ubCFzb7Uuf8/OMLcqeZp7DLbtwUCNmxoe+V/hlYM6IIqYpS/skhPrvnf0V/Vkio/7v4zSZ44e8vwAUMbl8PHr4gSI0Ycf9ssml7/tSxW2yHcOW7+rqhbq8VoUj31yTdz0+9qxT704jni3oasmdMmq8dI+mODazo57bbhMy9q4KSeSZe7c0/mbdk7QqV3mF/H5SxFHteJJromjBjG5Ds5tjsF/VnDRlvN4xxNRCy7WzLDtDNz/b0zZHjjl3j7sxda5MSoHr42bM5GuwJ01R9GakWr3OmV7twZmnPEiMq7JGa7OLdzH/dcU+izlgi8+u50Nf+5VbZZstR+1E0Qu+8vZPZ2hsd/w4mRt3Ljy4IQ99/Tj/h9j+bj/51mLs3F+AKiDtBy+si1vPhxEjRP/ovvRdv2Yv74ubzKn+VYTvmOU0/MehEfstDsjb4Ruc/0pNnFv9KIcM88N7zJnr+NW98HfzHDJpVoOsszFm/mOn5qJZ613HfTwiSe5LrgdadjAXdw1J/nhv2AOwzKnB6zj8qwU1u3JqJy3dd0WsTpqrjL2uXTEQ50Jkx/Mpp6lZmoFLwLZrIbm2tVAfPoi7u4p3Da3czjFYsexFLbNtp3ZFnkYhe8Y5fS8gjCbaXdOMG5z/Sk2cd7XGdh1yaQcM88N7zLnk+5BY74HZMlL1JJLtRyOzPVx/xnG9fwwvzu5zDVAdhS2+zDPwOT1cyLuwb+cDXzOKZvVcDlzygee+KxhPUMynR8AMsZYCYQoCQRCMQkmpSdx3fBD3Q7RMBqID8XxqVOrxWgAjmsXtcrwpF98b/SiOna1dHLL6fzud70w2cfA97+rTlnIjh8G6ho8CZfP7WCbKxT3y671xE1Mxav+3ovEWG2v/s+kOevg9TrIye+2NBt/1eD1r7UAMDn4trEF93PZDKrrprbEuD8M1DNl88162lEKudyO7SaWXB6y2O7iP+6/j2zVx76uzlqxH8gtaMXmvgz8x/2PGd2c0e2dtPn1OTfbsg3TbuuOrYBtLj8HFts53B9GOKds/I6jnaEwh53tJpZcyweAbkZBBAY5YGTm8fdYCkAKYPHURXznKYd+lyw+sIuEK4zCeXyWUf6FI2px3OOQSEYe9eG9uF418CO5zkGsuFyHW5+cZIcL2f6NUpjMMfG8EfNXCSNFs81f9v6jhbWGF6n4d54dHhvSeLIH7x+fbHf1CtNcsScznrjGQOpxZROm8L1nFbecG8F3fE2TJ65WCDaDdciH2jIf/pDUwz6zbjbqIaYcXTf2km0X7ib2kiOh1Zt44Ix4+JCZ3sdADqQAFp/4NB1zmrk/7j8TGrLmyblYvBw57j1SIGa/BJT94/73feNuLOdaM/NzPGY4z+7hZjMMzB5suDIf/pBwss+smw0OYsrRdWMv2XbhbmLJ0R8AlqI686EATtnJDIRNJul6eeLyw3PAamiFzz8qY5TLIYYr/HB0k/LV/0Xic5ollxbGNXGPPovNPFy46m2J3ebwd8yHOnaxNaOul5xWU+eXb+GoORPsS+GefjRIzCu55AtwcWqP9Op9cdydvv0RUxXgMa9q8hmBvYnv+sDtYvG5BOczdb/pfV7DtuSbNcFpsa0ObPNgL5n2Jx4RDn/WN2zkJc/C6z17nHS9qIl1kMFzpC+C8n/c/5o2c2P4x7DW/dLMeMAjffaJMazWvlTMx/1fzuUxMh9SWvZf2Ic34L9R739+AMg3aX0T5RAhL21Hp+5jAG6Trhc+cZifQfSbQeID4/hL3qs/MhyP4uIFL2aXnSuMT7iOiZoc13rVmGt6Qjo3vVRtzqta80l56jPHGRPa/DF55qzYBpbi2MT1pM59oAaFWP2TarteYmueYaN+n43m7rNvPji2ua1eBQQG7o6/KJtZiFt59IKSvMTPteyJJwDgjaR+JDDW8IfUHNRH9wKGGLCsQzbWbG+rzi9u1uRhXXnyGzA25CWZ8ci34co8iscnnPHRU58L+TRuxytmPsPfOyR7vOCdYVp3rtCfcB0bNTmu9aoh1/SEdG5qrdqcV7Xmk/LUZ44zJjS/03JkzoptYCmOTVxP6twHamiuSfKwXmJrnmGjfp+N5u6zb1Y4bHbt68talsDAfWKmtpmFuJVHL0ZAXsLnWvbEEwDwRlI/Ehhr+ENqDuqjewFDDFjWIRtrtrdV5xc3a/LUOj8A5CbhUIbb/ssBFlLFYJOux3/UdFjy6/5AGADVuWWzdQ6GdcnL/0HAM+SZf3No6CGkz4RUUJ0cYSEm1LYTIIkOTmt0Bh22jlUSYqSrzMbLwGOb5H7pvi54Hyb54N/gHmPF5bFJddRB/Uiq3PGtHGpwfag1ZdTYnNbyGnHjUK16KYX3TTC9sJbc2fAzryeMsPZ/VX1Wq4/uBU7khjOxbqdNt1ETPHMtO3j5XK+YzONx5IGzZTnAwiU/NrAf9/+YNTNiPlqjf9x/mwUHR6bjPeHj/sdZ4fxoPNxLt/VZqvnNdcbZvSW2cN9m2OehjIjre/K6UZAgRVb6yXcU1OuqbxFerOJ7PQpou2qzbwiQya8XAyp75/b49h1cucRPP4U5xSA+Hd23m9CVv2twbtcBu7RvIG5unXoxOJ98vi5Mm6QQ30aZauZmO+nX/hO7wYFvfhl2OHLt/JGKb5KXb4BV4sLfSW8U5dLL6uheFeK13FC0mW9qr2KUq3LSi+dvvqnAG7Jr1FmQPV8VAE5L+sLGenKDbdwB6DzYZWbOBwTguSIHUrGln3yE7ciKynMqvtcjpu0RF3rPlIrk12s9pmEqHiT4g+bMh59+DHeog9j9tzGit310nOvOhf5x/3MSH/c/xvAv+f5/uy/Tq0MpPxeFg8raYpuvMHNNaEqLOy4wF60kfqSCWrc3CWxmOqDwZbblDWE5XMQv/JaLPg+at78u2f3N4BWD17PDTr/Vt44gVvJl7iACN+PD9bhPXkM09RK74c8346rl3EMnLp3fW4GLmllLbvi7N8NlTmEHvusX9/B1+C6vDzfjzvl2HAq8yWOBW976RgFnyK5RNl5w72TG7hx3tuN0LnnuoLKLf9bO2nI3X3HN9ZLC4pK710dtvTdtrzqSxGaK30yCzNz+gSB9xCGPoGTPL9jp8/S8pVUXBzY4Ov+raPLe4abf6ltHECv5MneQgZvx4ZqzukutD1kvsRv+j/tfE2UPfMC5P7FPObdD9oxl4+UxU9/MfELW9XE6+zcB4nw8pE9JqrFt/HITyLSRczhzTUjaT9JLzhlXdS9DnZiFm0VJfl3tqX9CnDfwnvOsGPCNdI4bSJuFtbo6XwIqI3UYbonvxUaZRUe6t56RK+uSDXvU3fvmOZj1W0kCxKzgVVzZ1lkchORM6TGH+/z65BMqc1Q/jvVehEufGQub+a32s1bDKv5LH7grXvle9hzYxNzl9D4npvJt499tadTMPs5UPftyXHJOnqq7Z6z1xJBkZ+dMPvW/iw+853x3DLe1kcOl6rW6Ol9iKiN1GK4pdv22M5RZ9Mf9P6aTc4vhaKY+1zmv9JmxsHlmmX3Yzn0zrO/D5+pwV5zyZU6vNXyXDwCdvpU3Mxfx2Uhnjstm+hPdKG4LVV0Dd8k5/HueNxpkiJL+2hLujcubU9S1rBVCDg+n/p3PcdLBDnvnmf53OJ2LvXPbK51Z7XDkj7p63zzHLpaYHZ/394SrWHIim5JYZDtMsVw9X3On6r1cfKczT987fJPj3bW4rZdLv7qU5oe2b0UreF7I6uWSRzloe5NvYbV5LHZfqK6Bu+Qcfg9v/R0M9WYPNS9sTfSsLOckci5rhe74qG3nm+nADnvnmf53OJ2LvXPbK1057vJgj7p63zzHLpaYXV7v7wlXseRENiWxyHaYYrl6vuZO1Xu5+E5nXq93+CbHu2txWy+Xfuv+Xz4A9OVSrUbwMq+wOzxNyof+kiwAjnX9nGHm00b0Zsz8Wk/bU27HKicvxVADvw58xwOu/Mvggz83/ia2+4ADucEn9oHsIfScl3gF9L43udL0DgY+Tx5x3Rf+uxzYPf4pZtZEHLL4yI8kzVynfcSCTWn5ln1dQLWovckcitMruDun53Hdcuxok+cVhkDnDdtacxQ4/BmGTffs3TwKFHaHb76j/8zxzhfihHVddfFEPs2zZzrzaz1txO6kY5WTl7DU8HH/d5M7bT4zWWOmvT9aM0fpd8/EzDVxvl+ygUMWjvzIM9wPU1lHLNiUlm+9SwvqWHxD7v/1A4D3Modh6znM5bKIg2EhLdZTXHTwSOdysPzF2ZvhOfCHrWt1TudCn/GeO2KThzNTXM0Nx0USEA7xew5hbd19vKozw4LLqEWVT9eFwaR8ka/z4LIa+hPKrMExxCEdi470fNgyblc8hCXB3+XGDm6Es6RfZNqrrt4/uAh6wQnsVlZ7mVPcehVn5yQ47F3brEMYt8FF7OfKyNX5X/XoeUcdzUH+WRfcyMlF3JTgkfK7Dl624tzODn9gutYdD3ySXiNYk8nDsS17czvPohNQ/J5DOFt3H+RceNZFYo26vV1XW05FvsjXefBYDR/3v4byxh4wvq2svclZa7569d6MjQt774nvBcRugwvf58rI1Wc29OsHgCpy+e6CDRlJu2AVYPYmp2jku4W+wE/+pQ5yqJ4clEqz/+u+cI+NIB7p+NCXXPV/AovN5gBFFHKqoXX9i/XNxZZ/xFbNXteS03saobnUSJif+0fcS07HU7fbfC74PZ908OFf8t3hwn6Hu9jrd9f6nBZaci/GsVi3djg3y+BUvm1OzeBuDnf93+E3qZs78xdg12Nz2t3AhozwpQez95zhRu5q2tle4Cf/Ugd8qkc8+Z77cf97ZprPi/nm/1QwP+a5iXvJ6Xk4H277uP8+3ePuM6fVk75l3vjv8Phdgo096G0I5foB4PSe4W07TXfa9kIWeGkiOJc1Bd4Ryx6Yt/68v+oVX74P6I2g1hfusD89u5qw2ftjUsi+m1PYs0/547XMZ4f3ehTjzwU//IFdZlrr7lLxT3/EiHzkYa0a0IvM+5g5BV8e+DAWV89FfvjBDOn52tWNtWWZb/OH+xKvnLOuk+Y9zce/q39nc2b3v6jnUr943qmfHMKWjslLab05bbhta9Stsq2z0Ms5Cc5l/VhUE3zc/2XyfgAPxzLTMGndO6l9/Lj/x6A0i88418vYWfj4d+d3ZyNW0v0v6tneq3fqJ4ewpWNSCccHALd4YW53XRh/vJDA+SFsPTBqItdWTNM4RxtL4QSPuOTqumw3ZHviE23HzWT368zH7wieMM9X3PSamyf/jL2pIePE75wzX651iFfHPCidWzCfyy638rl9l9/GfFCODzXkkdw8zER5llrnbDaxF9OoZak9wAs/wfSXrQYBa/wtJ3k79spuVm7b5XF/sPa+g0XuM75nJYe4Sr/MZeZhjVQm12dmchSu+8iwmmNglNf3f6FxjsURC864MFZHcvXa9ku2Jz7xd9xMdr/OfHfn1PMVN73mvOWfsTc1ZJzKcM5tWcHJbMo/97Zzy+9z2eVWPrfv8tuYD8pxj8kjuXmYifIstc7ZbGIvplHLUnuAF36C6S9bDQLW+FtO8nbsld2s3LbL4/5g7X0Hi9xnfM9KDnGV7nM5PgAAgnKuZQ8bBSITPg6gcJ7g6j4PmeNIvXCfxkOLJtyf8VWr+mvfTf3QpRQmB1wbnXp4kPwCe68req7JhV0ybF0LdoWjI4syhdl2c2ko+TBU+Sw7hwxwIonV2n8zk9b4kE14Vbq3cG1rFYdzFoXiEr/xJV72r/Lsap82asuWo07ze1/h+IJKHuq3PBBnPnpmNnIKywuwS2LK1nVjL9l24cgPJmOrXnzF11jWkoGBD5nuOabA+Zm4usNSNTiOVAv3aTy0iHN/xlftomzf7EfR06Z11lEzqJqoLZyd81DqKziM8GKXDFvXgl14dCQc7gt9N5eGkg9Dlcmyc8hAHiSxWn/c/2POzCTH5cOcJ7cn/KB4/IBZHjx5RtibkL3vwvIC7JKYsl3OWvnbLhz5l1h+DwDO2TP2CqJAZOan54U4PKwHR8bYl6XIsDe3alFs8lRhsW6/cUiVPX2Vd/IKc7FlbSe3MJnzUPLruT5dzaNcvKi1ZNeTOQ6q/iqb28Xh6waGUv2Eclh77T4LgCc5zU58mb7lf+GOYpx3CWODCbSD6ripi7N+3Kh56dV7R42KudNHvdf6Rl0zP+vZl9aeE1yWUmfBbO+oeR4yz038rKFIcx7UErLPlfw3MRlKjPNIx14y/8nYJx4+5HRcESKwFwf7h0wY2zDzsB4cUCOXnsPY3BqlYpOn5hrr9kNQUvb0Vd7JK9jFlrWd3EmVNmnDLkuZmke5eMkpvWTXQ1CS1xfZ3E6cY9Dly6dkr8PoeqGaNzkxSsJz2D7uv8/m0O/O1hW5WvI85F7UAVnd+30KTObjHITsc6X43d7CS0ytu27sJd+5/+cvAUTCPBSQkExyZwvzUrBj8vDdDMN5k9pwpuZ53fFUniU3nDa0Hgq+kWsbb9hUI9eKOwpsbnoecr1qwWR1dQq30XfY1nyBdm50SHJ9yXZ480dqRZw4khyc2YPXAOeU25wB8tigpu5FVqxy9cycH46ZIzFWr9bRD9wHxfCncTMLcTNXhdT64Kiv1OFGbNvaHDgusrtmbHGqj7WXI+huT3ZYT3PRqV3j8BpkZw1GwdLj9XH/xyRjVuvsjzPXZ5lZDnk5hT5rUriNo6w9cLuwzo0OR64v2Q7vx/0/5qAZMdeP+3+epzpn528CjB8J3b0Bcd5S2gG9w/eRNKxiL4d7IRZgGjbr4uxL6BBtdr7cGDp1IMO0xJs9I1mHXHCD9m7ZMfDkRS20bNiboN4BApex7kfXbNA7TkrFSnX/02/2EVaP6lKMxx2e11/zDaZiQ9DzlE3kOdCZy00NOi99ZkKHu1uGhySa0e7pue6ch63zAPHasO2kjX9xqzbfA61r3uqje1mCYkFe7N43tp30WQTHpR/FwE0tzvNx/89pMMt3Z39GptZ7Cw9zl1c27B33cf+vM9GYPu6/5tLnqc/LRvEz9Rn3//wA4G+eTtZ6ATjM2FlbTVmw/PlN4nBoM99qxHi+WK0fb1/eBDe1Zo5pn2sv5MmXOBtkYbMOn9crDvyKQfcaXIdXNseiS9o3qWUm8IN13qEvceLLvOI2co/xumR3nOvEbGw6L31m3M+I3eY5PDd6yO6h4nzdeYKn7dQmCY/lTBy14CdGuHglpvR0WXyuZ5yMbmO8YRPXtbYqAN6K9X4yj3/RvfQcmdMA7mt9n2fZ16LI3Ir7uP85keOc2PzYKxv5ouLXDNEXgC16f8LmWHRJzlBAlvMDP1ijneoSJ77MK24j9yCvS3bHuU7MxqZz1OfY/TXKhdNzeG70kN1Dcfm68wRP26lNEh6rI3HUgp8Y4eKVmNLTZfG5nnEyuo3xhk1c19rsXFms95N5/Ivd//MDgAO8yNZVyZGsm9r8L3v61IDi7P+AsiBvjHzTNtfCdQ0EmXzA9xBmPDFIo2vVYpahP8VkMDvWTHn/OCeyLnwn7KpZDVdnWcCMujqH7LwgAUss9gfZsxRGzcw24YTjhrvPx8QTh8Q/Jf47KbznDj1zhlx6iPhek6M42641PjhZE4/dsdLraa6M81PQAKCZi1qPIctVg676m6+jxkZ4PY0Zimp5wrmvdeU56r/WePL3/iru4/7nYM7JHXPKGZ0ju9d69veQ3kc7l0J3Dtl5QQP2Hf6KWc6djsE4dn1PyHHD3eeDGsBPiX/KiZtr4T136Jkz5NJDxPWaHMXVdq3xwcmaeOyOlV5Pc2XccX/wpRzx1Mpd60FX/c3XJGMjnK8xQ1Ethdt/ABDeGj3Dj2RnEZa88OkL8j6AZ/D6O0+xz4J3sdtaIDilcjLAM7+Gvhm8wmbuk2rpv/sFL4luMWfOMHrNgW0OpbWYR9U5HoEiXVk9n2dkf17RLf7sd7EsI2XmA3Esd3UlX9XLngntLfB/jyN+m0NGZuX4sq2zOBjYq8faBXW+I3T96nkd6700zzSq7DibxnHWesWuid9cwV3wJd8TxYg7oEdN2xoLz/livksK/53nOHxmssX6ErutBYJTKi5jF46P++8Xi/05p/aGpj2ax9HeUpn5lmnsb+fHzp4p2HN83P/tOD/bOO5O7pXZjg8AZugEbFAbXijgi+t8k6g42e3QpNXzogfPJdZTg8NG3lgrLmMDgzxO1XGysnnFETO54JwSnCQv+78b4Je6iQtA5xY48i9r2QyrZT6fWydxO5lctgEz31w7h3wW6i7pl74BZJwFeg70qKvjDdpzhkuSGLehM6tXuMKTEwlN53gz12UfIfJesCGNO0+m1b7wGY7Qz5biNp7s1/Iln/mbf2LacaOAL67tXOdMPC968FxiPSU4bOSNteIyNjDIsMqT6J4tMZMLzinBSfL6uP89pdv9YlYgmaPW6OxZ2gCWHwzmucYuyZ5Kf8LJHw81Iw9rfCUW2Q5TLFefKXOnOs+6+437X/X9Pz4A7BqyIr32l7pxLZsi++ScWPknZib0GPMtGwGHYeW/bLbFLyrxMorDeFp3m3Ae43Fln7lz42eM4uLpXsiBPNzL18Yu1s3iOGmLY4lVjpt6wrHE3eNWWM9qmLfLrG94Zt9zPeC9BIcsB/0iG79TPHbOxda9r+CRgzNzEueYoS9jcJ/xLVxmf08de6kgy9Ozodb3SE+UcTlv6pNzYuWfmJP50DzGfF23bHAYVv7eK4vbqsTLKQ7jad1twnmMx5V95s59njGKi6d7IQfycC9fG7tYN4tMuJyuM4/gynFTTzhWwlvcCutZDfN2uZZ2QGbfc70lCiM4ZOGYFfIuPO0eO/u1de8reOQgz5zEOWboyxjcZ3wLl9nfU9e9vPwSwNLQUs179BdUNP12wTcNXzg3hq5bPufR0OMl/2XjC3dnzzQV3ym15vE8d7NqjMUpXvb21bp4uxfPVb6OKV9iJ87XpS9/7le2yH2J9XrIl/GjuR0O/JRei8e1fuzPfI9ZaODomMV7LsCdlkVjrkh39hmYOcQ5bRbYceRGGkZq5oRHmHh1LFjZwWDbyIVL/lcxi7/2cpc/qcqvmLHtm1Jem8ij3l49S52vwKt/2VPnUd54yX+Zd+Hu7Jmh4jub9+F57mbVmNG/7O0LdtO7F89FAeDKl9iJ83XpH/dfIz42CclIJfsMMF+cmt+04fM4Zo40jNTMCY8w8eqcYGUHg20jFy75X8Us/jqolf/yAWDJN87speAFfF0kPpJnShVBIchryNuWbS0aoD8MNH7tUfhq3RGpvyxHvx4FCKnI5IfO2GcdRxaAKbf1LwhbzJxyuc31G99x6G0+xCAtXavMrw2hDPxtH8zA8dicT7sCZuu3nOHPfOAXHsOFelfXxa6c8dq9KST9Xa7KfVzGWrwrxBmvbc6qx6mWmuWfz+bH0RPSa+Lv8jcwlJFqqcNxN3rilUf+6jmh0r/is62F3uDWWrk+7n+dNdtQ9gDJzFwyP7cN/HYfhGcvHI/N+T7u/zKNnNuY0zLj4cvgr3D/6wOAHQwvZyS7vGENf4aajWue7Ga/NCkfL89/pwd2+48CzcPGOv5Y4PFGHRV5HfDftI/7sTb/G/UUIH7yNsGh5EZW/sssM/SmkF3Ng3vf1+Bjqfo4NE/c9LHD1Obu+sjSiPU6p614ey7y73IZR+Z7gRH8UlfFXOzKOeuyfG+pzNXBNR83tT7r9/WmnqXm8C9vCCKd9TsfSbE5Ftv8Tj9jar3UIVvHE7DaGEGOx7HSd2u3GeVFDdzH/R9T2c1u2jinOgMf9/8YoGbhd2KM9a0lc3Uwh99t6Jd9MYJNPcu9C//Xef+PDwCV/0JMwXdyNzi3SddllXS7+NymYfn6Nl85hLUh9jeQtFUzjpHO47psipk2sDdymdOM9XXVCL7n4BjLsWx0lkYvBrpTd5w7m+Lf6blqz3TOg71Koxx6ZJ0S7GI8FokXb2CWvvndv5uYt00PeZsDTJYQzbBuQCnT7rMAu7ON+fQZE98On1xHHa9m2fOatT3VQ05ivI6qdZsXzp2E031ukx55+txPHFhdT+msHee6cHqK91goxTG3Yw+rGcc4r+si8DlA+EIuc5p8vhZ3POB7Do6xXL2vZSPu9keXFrud3U2et3qu2jOF82CvMVNC14pBEqzbSk+8eAOz9P1x//u8LGOzWfa8zLZgfb9wYCNGMmzfzsNVzia+Cyr7ZbOLNO0kCGxvMnzz/zQay81u4HUIqhE8suBZt/yJOTm2l8LcqRZv9wR3SexIxVzmNDlZi7sej7/rI6Hkj0XnGZctcdlvkX+uoC7l8j+aZbnfmp3l7VrNlhzOKV+sNYvEy0ctxE089s+RuzeRmSfWuSdZQp2dXY4Zt8NkH+7YbFhgMt+GL9HZt+qofZ+4ufZ0pfcZe5ph8Cx16IgW92UPyTn4Og81lD/thl3yJHbMpbEqYn0uOVQLeGSFZN3yJ8Z4qN9MF7V4Ox/cJbEjFX+Z04W0DJbf4+/6yCjye54xtsSJ+zq2SvxCUJdyfdz/Yz+ZyRzdnd1xmuOyF5sNC0yegQ1fonPfjz3t8+w5NnHult5nLLmmt9bB43V8O78nPwUobiS/XIDyz8LzHyNY6ogGb3J18V2nTVT8DGhTz5rC4tIxNkM81IAM/u6JXr2n4Gm/OInjA02vM+HxxWyqaIlPRNRBLsIUM23u8zhh4z89c3aH1b5aLWY9VP8ljMjdXMSUbDsE+FnfSe8nYlRyz8J9d/E06f5dbt9282fdWvOCJ9ZdB7YpjaddO5ucmaIu+fpu0KGez+eZ9p5FNXKXp9gyvmMOY/9YfNi7gFIyH/zaEPQJZD34vI+ElH/tI/bZv7kcwNtcPg9BlxzizxprNqOepObLxacG7REP/SIjpvMRXxI7MpmI42z2euSppape4g8SGS0gVPFMG4jOURit4z89c3aH1b52rNlQP+4/k7jK3dx2NkVqO8J37MXY12L2M+B7lvbe94q9y1NcGd8xh/FL7n98AKgDVcQSXpyZb9VbvB8uokfRp9mGZmr6d8Monm1u4TtmkCmOGkJu4ykKOXHE80bfawJCug29axKu6nIbpYbtUhccyCUVgWZEFZ6YCcNnNVwOkTDh98Ob1HBarFqadS/riLnwiEwc1ELdLUfRd7igOJ9z0Zer6s16RKm1134Gn1rFpMH1E3FoxaNc2/7Aky+kcMtswCDBspY0W+cx2+E/e/fQRVcM/bheoMe6FqJjcYv/uP/HgHzWPb86175/HPWwXWYKB7J5tJUEmhFVPvwThs9q+Lj/DC4kc5PJdYOkWvPTPjzuBXMOKdxlj50X7I2t8zgu9c+7//FLAPNUPLzZg1WIJc5ibN01g3ef6wLOtWy7Nw7Z/am4HoT7lHf3Y+DC5OA38ZcNobaQ2zye80t1ZpTxtRdhW/IJ07UEEH2Xc/r0m33aVjy9LgJqkH36tMa/y+e+hFYPTb2udxTNv8sfAcu+eH2i9vyQ6w7s7GE7zmoBJya4l1zwSXpet0sXz+TatS2MeAq77PHkn3zk2eXGlxxr4m0/1EHcwrk569TSMgKs3mOmGvp4wBvW4xLtPsI/7v9xTpmH75fGvJsZ2On7uP9MJu/dx/2Pcdh52vwxQHsD4TBJ8sqfdRSJRguGyy7bfOyb8eVtYhe3s03OV+uuVyVW1pJ5CDY5ljdk8W8wr9Ke/kunx0/sqOUEvtZ0id+tZeK05qVMpfdMZKOmGQtesp4lzo4K/ouE++K4MWxqWPbF/Rqx+GcOYXZ2pQz70kOazr3yXImb3PzcVVz0v8t1Ugp55vT601Nf4HL+S+6Dp+uCi35ZG2/Tmi3VDfaAWAT56S/XmncgiQfDeubR+uP+51TySDCv3ZzubB/3/5yMnzMNlLN5Io6zubMLE/aP+x9zqDluPgDYJH3YrdsbhKBtt7g5fB1gPWH3N9jcvMPz3tddrqfIwnfOz42f3OqLx3Vsixxzonev4SVHEdobaFoG9ZJ2LPqwZ66ov3LmTMjvNY34uexZyqFxvKrlhru/iVHDTHS33uFvcmzPZmD7x5xzFoMne8XWeWnYmgfj37xH/cu83XfhPfhzPsHb+1cx4um6iEXC6+uuLZxuB/skPbZ1+q/AthuR8niuj/uf8+h9Y1Q+I2w7+XH/z6nsZrY7g4rY2cP2cf/PcT5/ADhx72vaIA3+ZvhvEwXFfPNb3lQgqjwLdndIHt6coXop6Yn+WCtwm9MYHYsZ26vY6df3Hj3EH6vt13zTac/YlzfiO3Qq1KRa0OeM2z6DVXrVQg2B7T0M1xc/DzmbE4xyl54jxd5AU6hTptTP2BP1onDnIAibclt+mNb9I8ikxbQVzjaEIpzZc9a7WI/5Ep08lqtpdrZ2DiXHm7tyOnb1FmefHaF3uHk2T9b3NeqX5EX0NifOkMSaqW2vYqefsew4nT/TcpLkqLrBvBEP9CKpSbWgzxm3/RIdrY8ZBrb30Eu+hj5bHnJ2IBjVUHqOFHsDTfFZpX7GnqgXhTsHQdiU2/LD9C/7/h+/CZBirABMny29IQVPTl+D9STtr//TcZ/r4Eoug5q8iWGkKokb5IRv6MRJ+kuhMyd04FjvpMeSY4ebvrnexWxtZ/+XWbzL6TW3fs4402KfnL5GD2zv4VneUT0Yeplr7JLklP6Ek19P4fsN6bA+x254L3OEx+UmLt2yqw6v3XU4xnjTvMOBdymc5e9+zeZ+D/0snXrgRULia7D4JNtv58H96OBK9tmRf/Im5hzeW3tFHpeeUzqvXU7iHINtSq+XHBOj9fTN9S5mazsv2GUW73J6za2fM8602Cenr9ED23t4lndUD4Ze5hq7JDmlP+Hk11P4vg+H9Tl2w3uZIzwuN3Hpll11eO2uwzHGm+YdDrxL4Sw//a4/AVjIahcsyPle6nBJoitI+hMn2InBTuK5xr6TYEv2Qdth3fZUw+D0sEUXTq/iuhwU2WceCLC/kevCC8dWRj31XGZhtYL5ypL6IdJ6Z8M/5QZ76XdixMGPTjVH/MwbKRxzlv6FT88x8lxqg1M17HLNGGolDllXkiXyNh8A5B3v1v9x/y975fNDRzLDKeXXq/b9sld+DmcsZ4UcyImL9YV3gzlNUU89fW5PQ9eK6SvLWbfWO9tdog320u/EiOvj/q8T3cxo86cAiKlDoqDzvOD8fBmHOTeNQ/25DF8aRx7F169FXg5PYS72OTCvwfUFd/MuXTm2F87jd7rnoh9w5UveHQ78rkfhiUEKB7fHut/t7+ozXmu9yPWt9bPoK9rLHJ0fHakcrmvNS4n059Wrjj4Dte46FD9t7TQlcJfazL1wiDNeyrnEyP7OU/dyiZ1xr7hue2ry6HuSfsG6+ux9+FyKV3284lP8x/3Ps9aj0kyYK1LO3ZlwfxN8hjLjtdaLXB/3/xzmnNXpWbW+og8X9AXX+ksAK/25in3yp98k3fhKj43OvdYX6kW+in3ye4Ouz5jMGwkLs+vh8Y1UfHyilJ7NSIlnybtpSn7wjT2GuqvjIH3xFR54BXedcHAljx5rQ4UnBkmcS8Xu/HAHdtuH+Zd47AunzQ2/13CnK2zh2ayJFW+8LrVqHOXrMzBrUA63oc/c5HpHKjZenXPGkGPaY509qG7Lf+lLcebXkqexDznAXn9pV4k/88k+I0b1aM/0II/Vl331+l2fbJk3Eham+zfc7T6A+bj/TOKQNu/dPJl1gv0cEuc2Pwz412z7lc7QwrNZEyneeF1q/S18/8dPAG4u9tiQy0UZ/py320pPoS+kYfBjg5aDg28nxXV3Ke/wcVhU//a9p+rchabtyT99vvYDGnoewJrBZZa3yd90eF6FKLdsXkPlTkbwyF0aYh0jW76OgLWPbm7HttYihPNKF6/b9iyHVanewcIb3EutHqu8PHf69Hs8vpDLm4zRNkS2GTvXXkMHHkr3YDFtG9hlWfjGLjn8YFiU5ZC1Y4EMf5rdVnoKfSHN3Lv0yQ+ABDdSuI/7vw5nzk77K5vvs48XPHJlO1bEOka2fAHxQ14JiJuc0+680uV324z3tVK9g4U3uJfz67Fe151Obvwejy9LsiH7aMDINmPnmhzEmOweLKZthruohQebP3ftN6uquddEPxSSkJ3fbaVnUum5rmTgVBg+bLvBUZOkcMTF8vjGyuCR6RC68h7q5avxXHw3hszXtY5iqW0Tm0jiNv421WZd9qMBG2XHu7MR+uQTpmpIuGOx25gTk/YxC7AJGF/kC156bDp/YyfEeMDjWups4+cpyRk5brktfzLbesZwwSauK9JfduPzbMepTM65PpFvasqnl+re1V7Dv+R5Uee2D48p/eP+H/v0cf/tvOocxvngzNURXD/YAd+d2Y0P0+fKrCFyUEvHkxeJw9Yz5pty//OXANaLqf0Yb+A0PGQ3zSBKtt3xYGST3jtdoF1OYTxOUMfhK9l9COf8HiOfHmxw1HpbewY4YRqOORF/mNav5Fitr1dwVvzjfghzs12XXsQL96zirtY7+4xnPfHKN21gJctHj93KrlZhq37wTTVzzD7Nf86lanPOwC01dIKNYpyXehZ4My7WZRE16ISdtWk0Fqe6fL0Ev7lgJuKBK2zJa7Z383St8JZsu5cFRjbpatYf6nHbMRC3nHXLCmfJ7iN9FrbjxgZHrbe1J9UsuPaHeEvXKjna8KYCZ8U/7ocwdkw8w6UX8cLtQOl3td7ZZzzriVe+aQMrWT567FZ2tQpb9YNvqplj9mn+cy5Vm3MGbqmhE2wU47zUs8CbcbEui6hBJ+ysTaOxONXl6yX4zQUzEU9xfbt/hCYngDf5uiAKK9l2eNQHGNlcB1PSB5AmsHB4jfgGxxLXeI3XHvodHJfaO8Q2A9sdd/mzl8aEEX3khO4tCYeOi3i0rtbm7C69CL/LnRxjPpCOomaO4V6XMx+1h3yLZ6m16ltsa7plNXC+F+dcan5Zp0Wz1YNjOzsL26pw0btA0ge3ulNdXZv8M4ZYl9L1kEe6x2mth5zTx09aZJ++I/L261KrUNVT24lUbd6v62BKXs4FWDi8RnyDI5f4Gl/nByz9giv7pXbwy4DLeMfd7jFT8CNnp3hHgePj/j9Pa8z44/7HWdRM+vwc48ufAPSlG0Ob4OeJh3eQN/6dv9u7wH0BJ5fu77R1ArnGBcfXPfk7ZCcDdco7HiGCa8kzuUeK7EUYOMGzPrOemMqDa8m3+Iy3wEc+Ih8kdQDRetp2b3iB7/0hFjl6yrrNtvQRuZpHGMNd6yDBZbg49tI5A9F74Wgos4adw2zJZ5do8BtyVTmWPmNm/cQhHzhnDFvOcvrII6x89KY1XEjZ9Ggdr96bC6eTHiGPX8W3ez7u/zEV5rubk9vARVTvDXNtX2ywx4T/4/4zpBycLZiNXwoNrCCa43J0cRhFzjpAmn/ilwADDhWY4tg75Ni/JVI+cO4I29d5//P3APSbsSeSPgtgLm73JmT3NXzgdz4w03fHBX7I2x4GrpfBn4N8Jy+YkI952OxOUgr9T7vWcBvGL/2S752ZUAO8SM+F7j7ZeNzuOv6dpP7CL3UHPtdgPF62nd0x0oOXuVz2jXPpMW9xRsAuP7m89+Sr872LUe5NTmrOfeavxA1o2g2/zEt5Pbe47Vmwss/+tdY5wB55ug7heSr/hW/4WTpf27xO8fkaEH3ufGCm744L/JC3PQxcL4P/co7k3OWltpCPebh7naQU+p92reE2jO/Vkm9X2+SkBniRngvdfc7jdtcdM3XqL/xSd2BzDcZjZdvZHSM9eJnLZd845x7zFmcE7PKTy3tPvjrfuxjl3uSk5tzn34D3/60/fH02EU1qKJfBqPt6NkPA1b/cIINvmvgU94q7iT5DsVq7jwpfDqXhLhv51NOTL/NwI8+aZelDvImfl6cjdYB8bnJ43fDKDq+kXsLpx725lv/AzJko1PfpWn0iLnnLeuZtg+FHrelxGzrSOaJu5rLsmzC3RTrBRt/lEaxyvaSd8XMdhVHzMfdz87Bf5i+O3KMTO/eYTjp2FspasmoiH7GHBLha52rJIz7vU7X6M9fu45cbZPMwen7F7Vzv6lZr91GxyzkyXM7f+Z96evIlx3XGx7bUHDfx+70Kso/7nxNd9k2W64gT9/KL77mDY0+U4yXtjJ/rb8D9Pz4AXAr3aej9yG6r68BexAPLN47GGicAccPfOJx633m5JScYDb5YL33ID5+kcKyJdVnlZg2Os091Dj/1a5+qI2t5lfMkObTsZfClLdxV06VHRXp/0jVGidATX7GC5pMYgWIs+XXzhby4boEFEH7GECupnE9+x4KftnfW3utNPs7ZtaVjJp3mJr79A952KVVH75fXVUDqOOZyJevYhfiNhXJlvupwk9tZljy7nl/EN1fnleU63ewT/g1nz6MJ31DgU0bTM5IckvKx3tH2qJhdgT7u/zGIzXYuY9R85/wdwB647Ul/2qt3427q4ZxdWxp38Ca+0w9426VU/X0mN/1QxzG3K1nHLsRvLJQr8/3g0/EBQI1sCniD6oDsBrHjk22HfbJlaUfzjw0XRw9Nle1q8KbIO6Vj0Gv+WYPjpbMW1nIutcAzpf9fkcVOWK6f/F7DNngYA9/z3MViQ47wy7Lmc9iXRc8k5zH5WEuqv3iN6EuqLzaIv/JkLTZP36v7uUSNl6eqpQ/372zud72wZ+/204PE7XI7QejWTywO564G2dwufYkdvK+WzgV2xyfbDvtky9KOXnpfyOGyOHwfX/ZE3imdF73HabNTHK/GFTDWSy34p/y4/8dENEedj3idE5zD+oprzp9yVC4Yfa/6nHEuAO0+tFLtBRtBO1tzDaWwZ+///9z/85cAPqfYUft2KT4fsoZuwN4AYfQMbK7TrjkG193j8YFZsE9x8BHP+h1JDDWzVqzlXGpx3sD3gbuJdXjrcHuMnA/jIbbnfRqyhm0dYL5YjoKq7pyHaudl/FmH4/B5r67j/xIZebIW5hkct3sF/23u6FXtuv9Oh0vScnts18FlEZfzOcfUnfOdQ+HxS6w7vlAXn9ceOi2Jsc8jvQ1s9xxBPZNdKR4f/gX7Tk/E77jvbMRQM2vhLedSi3MFfnvvLNbhreP3fHKO69Z4U3re2KqGbR1gvliOgqrunIdq52X8WYfj8HmvruP/Ehl5shbmGRy3ewX/be7oVe26/06HS9Jye2zXwWURl/M5x9Sd851DEfHnB4BJ1uuq5N0iOi4UFURRIbu5dNUhMb9jW3c+6eCxzzX2J+kxrt/FzN4VQxzyLnZnj5hzFjZf5XmHb2KKQqn6Qi9569Okx1UNZx2bWNUze194M+G0vF6rDq8lcnQdbhcT63dn49mpHQ4k9h3WbdLBEjv9iRlGx0pnDRdw1vixTyk/2OnTOnz7fd+BD/yNZ2O287nxPpq899B7jyOodXof2J7ZTAAe+1xjf5Ie4/pdzJy9YohD3sXu7BHT/fOxSDn0eodvYmqLlGp/Dj7uf24Dc5v7eQwuIZcvYIm9AMJg80+3Y6WzhgsO1vixTyk/2OnTOnz7fd+BDzye+w8AnTCS63lV5IF6/bV5r9CliUp7QT3EX7A7g+IHR+cd9g6fvcOBBDhxbQ8FbiQ+PqkRe/E38KpsZpRvLMHRPWVUAOGHxfNID3+/KeFTzIwjHvnKDw4Jt9alz/uDnZCUnsc5FtBmIezEB9c6n4hz/li2f9g3Ge5N5EVOLtb4kWLEN+UuW2CWvSNmh3XuO7/sXUsdslecT1zua143HnrPXMvN2U7UQ/zB8uKr4gdH5x32Zpq9w4EEOHFtDwVuJD4aJfbib+BV2czo4/6PMc09kjtm3XsOnPnXuv3DDvwtyV4iJxdr/EiR45tylzgwX3r/1w8AswBfk9gOXQ8J35OEKxuqt/zRnJqA81uf8WeH83LB/1SDfOSUHjHK18Nr3+Vb0nmBnUP4jjn45F5sWosOHFL18hJEevqO3MxB4bfPAb26g6d7Eq8epHTtYWAyR+c1DDUK649zuN11x+x43FZ61wqP7M6DHfnK77jKMefZOXd5wib/jIH2VlIXd6Ry3+LlUP4nnNeHjszw2l84qGGTNPuhto1/mfkdj8V/1nyoOevc1Bz1+Mw/7n/NaLdP2O4gMePL+Wb+itUeBib3T/bck7CBYS2sP/jdNnXH7HjcVnrXCpfszoMd+crvuMoxz2rn3OUJm59F6F5K6uKOVO7HOOV/wnl96Mgg7r7goIZN0sRSW/nXDwCQkIC1k9mh6yHiJ461JDYvTByy4zM9OWONdKpH3X8zjQF7QGbrvFHTmEehykp9su5m4Zzo1otM2/yyyynOmss5y8O29O91KG6uZbt7vG7iag+zS/zyob/DVSNqKGvn2P0O6a6himiCUMq3zAy846R7nunbrM/5DqfzkKtstzGDopfEqzXprAEwI9aSnh/d47BNbHF0jR5TvhblO85UWXd4cuFj3USh2LZ1bvzEsZbEJi70OR/Zy3fU+HH/mUOOkrkx17nGvpO+h8TVHuZxxC8f+o5HNvfPs8zaMR/3f50kM3KrzwudfbrM/ErQd9BjnF96+Y4zVc6yHR8AtIjX8sabcXVSKgYilhdJA+5wG7okL95R8KkW9JZOuNGFq4bkzT5q3QM6HEcwvMIelvOr8XQd8mr2FncGlIYP2ebrpqnWpa754YUaBlf36HawsyCllc/Te5zwvkaHDwnvZY0jpHxjkLkH4pxx5EFmuOJV61HsOhtvwHK+o5Jj1vAU+066Jz72UrnJT74xI8wX2XE1l5HvXZrmbb62rLWJP14f9z/m47P2uelc+NpGmSo+ZPmXs0xM5FjsnBnzL5xPdq8XnKTqlc/P86ht6QcffEg4L2sclWccyo/7/824/9/ujYoDkIdSB6EOw3JItd8cEtt7qf3GwSEp2XbHgzkCI9idoe9y5PvTACaubM6ZFGcPtxe60t726JzSlcptFd9i+vziNehGIRY5YcwE6X5sSHyqV7YaEeaW7+RyzORvIuXxhcZk/wdH3I4rbI3NWq3YjgtuxXq80rEGt5ZwrN7BeFzW4AZorC6ZZk7vn5xXmr3FY0EEx3F3yun5Qr+cWeKG3N4/YazGxIgf3tIFu+SRb/N0HnhLtt1jwMgmfYz2MtvECTqAWUvZhi/rplb3YbN6bnv0OOlK5TbjSHX69qOaUceaWOREUTfS/diQ+FSvbDUizC3fyeWYyd9EyuOLY69yroonbscVNu1r79cWE9yyu0/pWMO/lnCs3sF43M289mfPAr1/cpr7UfVYgMFx5Cyn9xj65cwSN+SlbvxW47ebLJvfDJogSQt088IhRxWcdo+ZzXpjjnPy0psLjsRvBuSxwpADfqThNChebSZOBtcLsAy3ONumdfzHk3bPu+FLrNsdD1HLzT4ZvutovCngPJe5pwoXsv3igWu8A1zOg4I8X8cdbM3tGLkcN32sHZN0NviD/vwa2M4lK7HIE7lo3c9itcVMaXxLPgtJVbiKXXDRW+dUn8a36AQH2RJfeZpj5mV2YW8MeTzXjLvxLRyKKf60ewx3F16rY+0LwCmbC47k/bj/PSGb8+4sXHA++3ZeFbiQjVC+zsmmHN7LeZDZ83XcgW9ux8jluOlj7Zikm5fxyHG4Pu5/zoHZxeKHejwapBzIdoQi2/e1yetGO2TRncOSffJ/A90xCgY37Docy4F62F/RXPCH8eQnD73KH0/nGPkP74uvxdkc5Kiwtr+gSTf5kyOaVb+hL31pH3wrhFVcPft8SXT8Nb+GJWZK8pHmwjl67Hjql0FlxZ57LLyJDw74O14KHORALqBaXHLAWP16zMjXCPHr5XNB3+buyIOdej3XOzrcEe8zuoRSG/gG0KvKL/1zanEsOrJzhCLbV7j/3/6JH//0I3/o93/6zk//zk8/9Pt+TzL/+j/4xU/f/973Pv3a3/o7n37t7/7CMX95Rv55XuwzT/LMLxf85GROzLQIvmh+JC/O5iDH5Ab/JOk/OWLuedQ+7v/tyHRtl/cY7sS4oyKImeLVshGatV6aPQ967gNGZEceBvYM97sS7ojvs7OLpTbwjTm76fjPqSWw3/rFn/p3T5YmfqEoImdgQ5uJ59op3ee6MHOdphcDcu5XOrUXbnnDeBX7Nfk7p/Xatq8px0JjeXbzbWzgjm2tNxw5Loeu0aviOVZPrcalAeNxrsuvtZ5Rw+2sxt4ewfX1yQdw5g/7NtcGB8Wt3OW/6e+W43Mduzp3ts/lpRfemBQ/eWP9nX/rd3z61//4f/TpR//YH/mkDwF3z6//w1/89Et/9i98+uWf/5+uPEn9cf/vZveW3ffG9Rkcvo/7r8N9Pr/Z7/+3fvGn/z39vPHsWNrNIdkOg0h/M8B2J4XV7xDNvDffGCL2R3/mD3/61k98NzTecURIrcTVN4kFIxxP4LOfuzX2IaG/8JIfPECk7Oin1Jvcr/6t/52gU1Jbzu80P2rE9CwMzd4hzbWoY7/YW0k9/YnSgzacxB1B8fUI96hD9y28el9bNrkz6DN4l1o9o3O77pjQb+PBVS0L7oGPsGfJGRooeEM2Iu+T4XazIQ7YXMu+s6X54RvxOE8/9sf+6Kcf/1M/9/iNnxKQ/yJ+EvD//In/8tOv/4P/C9P7cuT3wN6P6qvXAn1Jr07+tt67tEZk/jBl/avrdkXMx/1fvzXcDuxwLPvuWD8Drjsm9Nt4cN/A+7/+BOCheXp8lG/G5yBFNN+wRvxP/vyfzx8dPub8hjh/NX7U+Y9/9j+9VNuHKnrvt4g5l0vUMOze6B/eEJdo8jr+3fxjv5KXWpxvSbhf9JmQ+yF/z2tPs7XexlD/pdbeiS2fjLecS8QDD7kX/P2i872Ku/Ryz3n55veK+4EqXRWvD+7/xl/8b1+ht359UP6/f+Y//vT9f/q9w7+raWebbMLoeThLB0BfH/ZJ3uDKD8RztrscnP+T/FFr7uDqKt6q2Wh3OWetBl9U8jr+3fzqf2KpxfmWhPtFzgHX5MQesudltlfqbQz1X2rtnbilvuVcIh54yL3g7xed71XcpZd7Tt3/408BgHkYPJBsHpGDAABAAElEQVSWKmQ+u/gNri/TO/ET801fj3nkLMp2O5dXPftW6ALqIQ/ysK5f5Ys9y7zyaP92e+hRzgdWNuzUEmsd2ncf3jfW/BVPT1miLd4hjxq6v4n3+vFl3Vo8137LCU/KqpU8slG+2+7mZPbO53FLrlrs/uz1Difu4Fr26BW381htbY747/zU74z/8//P2/S5iuK/+3N//AyzmrpWs53A0txXescBnrWz1dPelLVp+H0PlYOcks4FnrySw5b7WrbU4fKYVzo5haM28iB3HPJFvuVsvcrvfGBlw04tsb7MfVdD2VR2hsKZ9iKjp7B1rRX3UkQdtzHkonaRZd2pPFLfci5RVTh55KMXt3l+jzd75/M4x6J/5v3/NvUQ//amvSoEQnDWTB8WMCXfzj3ivsnL7Fkz2s3pVWM+08aOHRXvFhcBS05ubhMdyoyNmGWflE48cFl4H1rZJo/hmMGCT3/VHqUtOR+4jPZQVddn4o861Nj1WeqYbgtZcH4pN2O+mKjXZ4pt5pxrj5k+XxfOSk7vUrfjp36T57s/9yfiQ8DvmujPWv9r8fsGdr9n4Ho+NrTMyeq7xJkvGVgj4djQp4m/pRRcyJwba4HEBd8dT9gzzrHO8RCXri127Ki4t7hgoL70X07hkX3GRsxyRpTO6z+i8usy98ljOGaw4A+Go/aP+3+/hzbHGvq07Ne199/uQ1Cw3oS7DTP7ehDGwZtpOWyyu661OOPVuWX7zfZwv+i95njpGX/1v8yY2YNB+qzASLIljsPvMekH7I7Q5RsxS830NcIuS68Bp3jjtWQeuTgrS84dF5zIxFRxO7zbyDklXJLlW+pwf2JOg+MeRxS8S/9QUIvWXiv+B7mcmQdc9jS4u27P7xxmX/IUzw//O8fv8veQL9F/7Gf/yBlmOU/jv0KNmSGjlJ7bq7KIqZ4ucfiLZ5kxcwCD9JxgJDlYjsPvMekH7I7Q5RsxS82Ph9u4vAbM4o3Xknnk4uwvOXdccCITU8Xt8G4j55RwSZZvqcP9iTkNjnscUfAu/UNBLVp7rfgf5HJmHnDqaf2rgB18l9Ts3iQDcopXehcqTnjVuDf/iuSb4t/u8qb40fsyY+ADg3mRMc/t36fuc1bAHVfYl/1ZyC3uLn7id2vVKDs1TV3czu+6x+y4E/sw9B0XnPNvZvO6iEPucstm/ocqjt7JC5fWesEhOTGZIqdHVMvtmWmvKRvO9t75zL7kiRr1f+0/9DV9AOCPC+YMLGfX947yFKeZMt93uBwDr8e77tjP1QfPMmO4BgbzIqPGj/v/cPN8huwn8rfQ/b//AKDTtJsfgzNff6NYTuB+4Vjm3UhxytgOS9Kg3wSKZtg90s/xZr68pQfO53WNIXYv33rziDo6B3srurBv40lF/S4rPvmMq/mJNZk7bFhzjbMQHnIJdBcjn+O0vnvEEa9LfXAjFY8ONxJu/Kzd7zp+yRnjPukzbuB9f7oHi2nb5H13vbt+1GA+8hx/Yudd8jdx1s87EdSSWGrdBYoX7sAtcdh3cbLB6zh05F0s8Rfcx/2/jEwz8jm5zh5cgsLguJ0fmzjm3ssHN9JtcCOdC13S/a47xvndjj7jBv7ruP/1AWD5tkP6GMSppqYCYk/yspjPCxkR51Kx8UosjRjHwX/A+zKCO1m+uZr3utvY8i+zDNyy/jq7pwbfE9lq5r0H7+ZUXHFmzfBHvKlXNjkngH2XRL9G5lncmR9jCKDeyH2ZMTnD9/YcZg/kkQy+5nFctP78+KEJpMeOwO6B2hP+MkGxjDxwT3POTO1oXwCprCPPD/7pL53Gf0UatXT6h5lpX/IJDJPqfZID/4E6vgJ0m+u7GPndPmuSr0uxBKprYj3XV9HhjdyZQzXIVnUuc3gnD/GBTT74c/1AIJxhE1k1ZC3oOwob1eJ+igFIvZH7MmPiw/f2HGYP5JEMvuZx3F39HVuHgrXHYivZPVB72Ns2sL6sDwBHJRSJTOCl+M3AYHxqSMU/NNA3IPJ14Y94kn5D5N1stGHR59jqS1O5J7a5F8C7hrs6mHXJ3oN3eQO3nJuKO2x3SQc5/WUN9YYExCg6z6uhzanCL07l8DV58Nk68zEfs9/GO6b4cp6dk8KtqRmjdcHoF5nQqH2udxTv2Y464ENe8uQM7u//9//J9z79+j/8gj/DvylSf1Pg5dntwQV0GLIH7W/tca8dv+Fbzv3Gz544zVv6jkuBqi98nIg7rm39d+An+92Ro76Syxye+My3nJuyH7a7pBYstfYq76YmQk3yGUXneTW0OVX4ky8IfS0bj+cNW+YbtoTexcODjNjfqPf/+GOAaiRebDoy66d4mnmSc0NqQL1hxGqY8i1D1Q6XreJyTcxvBtl9jWbCvsx8uLXsA2S+y1zv+BUTvsTPPWIv4H3iAHMjdz1cbDt+bJfzEImwqe7CXThv6lneNYSBC3ytzznO4Rxz573nxEGwkSf46qRPfze7ok6L6osY+kUmIHy9Fu/s7WR51I4zEfHv5HlkCmfQ/PP/5W++Qr3l/9W/vf9Ls273wPtnNrKVPWflGJXLfvj8sHWV1zPRrqE037D38sJdnrD3XjZ4VR7rB3rHL3/4jr0GXFIz8TjXB/TVctfDxbbjx7bsT10kbNqGwl04bwsrDvxwjfW5b9e9Vi5YThwEG3mCr076bMYrZLGo3oihX2RiVBf9iBd9IXi9OH4CoGAIkIrtggfRnX3A4MxCZ4zn6bia3tbXoN9cinp91e+cXU1gnevmEHhc5OgDMyfo+dE9duJt3Zfi3Tjhapv7fIWteYz7opIjHfOyzvUlejFkvuqx5/KD7591UKNFNY7/s1jqAViB0zfn6WvXi4Z5dFeTj3SSTz7Hua6cxEm6Dm5TV7ru7OH8lb/+N4j+Ynn8rZl/Zxt/7kG52Sevaeq+rjDNt7nofZ/xtD7izhF2AHmR7TDFZ2/mRb2Jz/rbZ/tJcPvCEHm6X/xI7wvdY8FtJOe0z8+ruOy3iMCGrXk2OdpEbWnomwFZw95RMl/l77n8Frz/+QFgGT6bIqmBs9ZU0ZeN2IwbP3hBsEmX3X2y/VZ4NAOfQ/d8nceyJzPGZ9c+3gmb9MzlrsYbbqriL5xflN2e9eWhplv+4OTJdo8c9AnPki/xFqc1efpTBKTjrGJGdtxhyHyz1sBQB9/jEz1xnbtqE7e96InUWw7ndN2CxHPWczeHCFDuz32Us+KWeuGSNEzS47upVxj9jZf/71/8Hz+3mgX/S3/mLxxrzi1yQdXirnVqFWxTb86VHne8boML6b5Ft0KVk7wu0Ze4aGJwL3syYxzbPssNNz53YQOzk+IvXNZBPqTFXM7nLb9tVLZ75KBPeJZ8mcfitO4avCk5Yt0+rcczfJlv1hoY6vitcv/znwPupjUzDUovhoOUz/XdWjY9DHviD+/BM33EgJlr7N90uetLZ3zMY9mT2fPATvdlLf5NXi5f4uUHY/xLHfbHY5bYS8KNQTXYk7yRb+EPf64tf1gsKgHHOmK7hk3dHUS4OMG1M5SdTf5pn+vkKHJxazZVd/e09JEBIkYZOcweCHE0j3LP/M5t+3KSbzRmES5mt+RRCLngR8rn+m4tWzz6h32+9PcC5D8K9FfqHwViJC1RjjznV7MzJ2plDRi71tLtL2nKmbifmCkn5/RrfYfZ2VX+yNt7v+Me2B1ksYl/k5czkFj5wRj/UoedsyV2SXazsC0SInkj38KP3fIHciXEF7Fdw6buDiJcceDaGcrOJv+0z3VyFLm4v6H3v34TYHZzfFEzDNnMrl4Gn86xw9uBOcuqd3TN9FUNa/Q3aLWZi3rPmW58l84c4zrAYeu98j2VHrgfcGg183zd/CiOix8x8M2Le7kw1IP0/Nh2ctS/g6Qt+LoGcav+3dMHK5y7Gtzmud0uXlszgyWdYj1ezrnOb/5WqHHSwJZbOMfCO+Q21os8Dlpaenbulz5zTX+sOw/5E3MOWn+P/z/+2f/s0y/rG/mbj2L+6X/9Zz790p/m//5tTuTxGSy8hp0YW2fdyXXUqvVZNTuwEB8L40jDXG9Cbk30YoBjW+LrxmewQ3WM6wCHrffKa5YeuI/7H0Pzufjs3K7Z2rpnyswlFevx2BzzG/D+v/7XANVUHZj8N8F1Wr/KAx8cvnY9/Ppbxb61/DOiuujf+vRj8c+L6l8b+yqP/mW+X/qzfzEoDs6TizcTbajctj5BHZclx+pbAQN5cspyDOwH8QaX/+75wiF3+Jlv5xIoky9oHbzbN+4FqfDinXZfO0a6nm0tYXdsAl98OVu/BT7287n5Mst1ZrfJ7xybuu/r/Ix8n9nPNufdHm1qPsaxOQOzjrlWoNvQJb8fidTyZzy6pz/2s3/004/8wd+/jdI3/l/5+b/66Z/9pb/86df/z390nL8tcmOkNrnuZrAJe9vk/DdBuU/hy5Ow3N+bgGkmB7L9ydgrKdszsSBsceEzH6pjpOv5uP+XM34/9+seHUPcfPVZb9zTtM15t0d3Z3+Xc9j6AwAHOQ/ArObVepBe4O53HSCHDh8y/WPIeg+Kv4v73/yf/4ev9LeO/fJf+auf/sl/8d8sbziXoS91UOznyQvnDH/K8eSbPLF+zCUuPV/yJnVE3n9l/0Bc6h57WP7bej0+9Iyedc+c5HbpPG7f6LOWZf0ZPBvqr2Q66xgzdNa7+u7sxMqvJ2aZeUpP2+d8eSdP5PiRP/QHkvU7P/U74pcIfjFe/+j4p3/ZS3iQiR591/1/+UH47k3R+1rybO7P8Hvou/q5fzcRTzmefBu6x1zi0qNZf90P+wfvpe6xh+W/rdfjQ8/oWffMSW6XzuP2jT5rWdafwbOh/kqms44xQ2e9q+/OTmz4f4gDkRdKAcvzkNRxc3PcJx3/XUH263AZyuZmXBxY1nJGSar11/7eL3ylDwDJmfyZsdLeXY4Xc7jrK1gf36gs7txoBcUrU97Vk+WeX4rnkgv+0WcG4kOebM/aDp+2CFPNei75Rh/lz3qlK94fbJLxGtEH0mN2NQlV8Rd+clncnN2y9no2sZhaquDRUvteKeQq3FlHTYG+heNxHZvknR2M+TMP3PiPQ9irW8V4tpjy/+rfjt/Zv8N+wf3PPYVLo9A/0KM1e6r5s94WVX7znbM2Y6pJNo3nmpynpbV7zoBY3Mf975Gd+6b9i5ed9BPkZ9XmeAJCq/iP+79M5VzEfNY/BaCB6ZHMAdvoa+A6qMvja4NvMfAvzljIPn2+9hzE3uXC/0rCiQQf6+6xaxjJiMGPFIfrcCKJY23YM0PMt0bcdQg/Y+GQNB43n/axZ8Qo6V1suMiPTO47/CZF4l992fSV+e7yOB+xhl1qFRaMxxX+seRdnPNZTqdOfUcMHnkJKoPlXXox+9OeiWWJu8tj9sZTm2TmO08lc2ws8UtdGIcEA/9wZz/T52viPW7xh0NrP8+KsbhL3XAZJk2xbmznsDkIRAx+pHyua+0PcdgMe2ZQ3Qeg69ByxsIhaTxuPu2bA6kYn9cSeCzIj0zrXa5Nig3l1bTpK/Pd5XEGYg271CosGI8r/GPJuzjns5xOnfqOGDzyElQGy7v0YvZzX/ckS9we0tYf0oD49K+60S9JqvDLJ1pvyBvX4WLtmE6tvYncWrs/bLd1aAiONa7PVzPzylf85TnqU76ZN2xd+/Rp7Y/IMO1qJ759ZK+9gKv9GOJ/euL3R3z7p3/npx/+fb8n/x3274TeT+XV36j2L/7e38/fld2/B0E59Rv7Zq0dHEr42GtkzyFrFvis1UO/qq58Od/quWeNPVNH7s1MutanIqpvx3q+DJ3cc/3Ev/Mxa+QGM2ugvsVudej3yPzIH/r9n/QP5+gMfOu3/3ieg0mdP27XOfi7v5A/OdPvf5Etn6gn84TUMUW/zLbyUlPnsHr6nMtZ5y9xjulAHbGv+f5zzzL/ejYvdVOH16a9iTWRPfeyEyJM1z59Wvvzag7Edx1kr72Aq/0YXkjPGyV1LwpTzo/7f5z1GuMyH9nmvOe64t4WnAvkJnDWwJld7G/UQVym4Hxt8snUvwTgB7+xM9jX6H7QOjCUcQ+WN4TEnd9g8kDSWPxGo7yC8MPpa+mTH9y7Uhy7x/L0IKnN8BefMHAax8s6FacXPwYtHlWXOZwrbPp1VP2GqpTx5v85j37D1a/Fn9P+lb/+v3765Z+//g7tPGgipKaRO+2dsPoV1h59KNE3onyqF+J+8E9+6dP3v/c9Q9+rPd+AMIfv/PTv+vTDv/d3n9/o2EIrQX+MbPds6yrgD+KvsNVsXj3LRQQcM/rOT8WHsN+rb8DfPb8B5wYGqORdXdBIds/MvWTbA6N9/9Gf+fc//Wj8Rlj19M6j+vTShwWef/F3//6nf/bf/+VPv/q/1YeB2Csb4wGjDoJ8ja4g9gFcyO/827/rOEfC6RlngTuvfz/g+9+Lf0OAc/Tu/Q987ulPfPe8d0emI92be2ohh1p95Z7mhyrtafSihz6jZ/2m3n/2l+LvO6Bu+gvYT/ypP/npt8Uenc8cktZ6jLD1w6OveV8ij/5IZX6Q1we4/+MXUj9RNxrU5eYM9RlmXyz867j/RneonBOt5hgu4NNAvRlms3V7op3/DL/Vuv+BuPAOv5bb2Ff5X/ktT9dATMm2G3apB7z7mRnn032lq5/8CUAf4gmawb5GHwctKeRTUTypc+gxnmshfwA+wyxW8PaFXdz5gudrlLPuz6HWN3DF64GH9WE9vqqXaZ+28CdT2fVG96Px76P/6M/84dvfTe0p7nTx6I1Jr+/+3J/IDwH6o1r832DmjNz+RrA99Kp/1lxJf+j3/e5PP/lX/vxdCZkr/wRG/GUv5E3whu/bv/0n4k97/Iefftt/8Ifj93v87re+4W2/0Ua5+mdqf/Ln/7vXdcWfDPn1f1B/n/2oKS9i2L7949+N39n+Rz79cH0Qe+cbcdY1+O767iLtnOhD33f/5H+yfBNv3Bcomudv/9P/Ve6BPgz6OWg6y582X6OPqwruJ3/+z53fOJtwr+gnVPpTAPqNucf3wUGquelhfpX7/bMWe8q/UVAc81xrD7WnP/IH/8CnH44PSq/2VGc3PwAclR0f4Kuub8X50AeIr/z8FAznBzdZlFt36J//tb/56Vf+2t845wL8Qd59M1HI13H/L6k5J5L5HtmZVih769adTX63w+9xU1djdYRu+3dO4oeN+7+8f7+T/4YvzSMH0JQvuLuXHU688SznXLiyy6f48ycAstizBD4VaTGtWpK0zQIHXzeSYBWeR7HploGf1q+ujTpEeMm+wWwTzx7vfsQ2cZk0su7sYdMfo/run/zjb7+Z/n/svU3MddlVHvh+VV+5yvVrlyEi2PSoSashk5DuFmaAmbQLyUjQ6sZx1J0JFBFkRJVFeoRdNqMGUc4oRu0ik9ANLjMApR25LEWyiQQeNPQkdgu7ZyRgyYnj+rFd5Srq6/WsvZ51nr3O3ueee+/7vfV+pra+99trr59n/ey9zzn33HvPHcY2YOIA9eCTv+Bf0cKT1/w72xFDPx9hrHUwelWngY8RC36REy5C3O+/+KQvRM0fb2XgAuXcr3qmfwR7oGlcLz71sa4ebmo548R//89/4OL+xz9w8AQxdDeZ45Wu6CGuR57+8KWd+Kuv4TowpUvd/9VpGeNEjouRB37uA/78gNdfeKHXkHr0gu3R1pz6Gr+MOWUIJ8ZI82N65oX94Rciz/yfF6989t+2C1fdpwBFXM4zWveBnBTTd+Rw9v6vMcDBiOfsuBM8qp/z4kijp4TMSZlzH13es1im/mFgjfGP9JrG8r/WVs8DI9u9PEfH51Pi7DiyWyJIius810FKGtE9CAibnq0rLZztdNjsFxzidfxNrM5zb36Zo0lOufhZi4hVa7MrDNpTeSutQT1wEnz02d+yg/+HLv3kz5DQtxPMhy7e/sxvXOAWe21ZDxVYvCs+82Wv+gMar7D8Vul7fzzXFl7xP/zhJy++94//8PST/6CWA/dTFuJCzXG3RdsDP/cPLr7nT/7AL5oOvTpUu6R31kX32QN2sfGO537ntp38MzYjuA5w4YXWLVfU9Ki6zva/Q0//w12atz3zv03lK8HOmnJO+TVE4pw9pwSq/WnpV5RdY8zbw0990O9u+QVznSfWCDGRBnKNETKVh/fVPgfffKz4altiyGOn6ig+9UsMzc7WntvJisSYNoHjHXgjvuqA3qNzrI3mprUln33FreNJbKyFV0F1lAbWyE/VEZ/LBYAZdpNajUbAAtSTMlmdoPAxrLgcs+/sL3MQszTw48W2/HPhmtuuNoMwVJc0e89RFoXz4XfgG9A4+bzjM1dz4GcqeEWOW+SjiwDXwXoYxas8pQl8oH/YTrY48eNA9ugn/7m/uj5gsi1exRCFr+t5G+Xi4ad/1V/l4+SBC7GH7H3dk0789BP+c02Qrz1itz+esM72qdg7adwVwsUg7nZ0bVXXTloGZZ8X6dYwP9tylL8txEWGCzvU9tLmdIG2aZMNLvyrInkB114w9G8/eGyYktEeYNwjmQYPOXWVrzylRSePnTMftDM5qsharuyoJ9im3Y3WMRa5ahsefbkd8dmr7iF6lhvsgBfy9DfCgx59sw+9rhYqUxq12ONHfC8XAIMEEOww4M6poM3ImT7mZuDXYWZ8YJ1+fJEIA4R+2HtIbbF70TV2pQUJpIbEyWJfc3S++UP6tT34xOP2KujXzzvZVNCdYz8J4yLATsa1deuAdUDNWDfSHFeAyRgHY9xSx+cG8Arw7OZTp5WNmWHMOx0wrnc89y8v7xW41SbXxCgOk7eT08dPvwMywj2Sh4vBh556wvd+N+/EObKWNNvb41sNua6qEXxzsx251rCu8RTRS53TiI8h+bAb1ARu7xh3AbCXdA/7mtMt4SEEY2cNu3XA+Yct7ZXWFKkbPOKwzxNeyBHrao8QQ32lj1JsGya264ScGGlnhPoiNuSgdRw2PW4wrVvxqy+GqP4W84VSn0ovGo0y2cqnS+gI4SOHahhjkS0XAAPd4WTwKkMDVHqAg2J2AVf9LNhqlS5XRMQFFh76cW6rxYkYPM6Mx5xorEpX/1uyqhvjutBx+xUf9Hojm18E2AEEJyKbtHX9ERxz1Tpl0MfPDfLWA1ZCnUKY+1pXh2HMR2C2uNZvixwB0asO67Wo8OR/KRdCC+xJFE4kD33olwe19AIvawDoJ9R2Kyh8vTFbrZn5yv1fZWk0J3BXJT/VP1c7XnLJNTg+gMUi97DdWRs2r1s7AA6Py6wretIKxFxHMtMbYsLe7Lg38/BLLMWvNHX2+Dtn/9MP/A98IfbMTeSZC+NWHIUSG6oe1Ys960j7jEt9Wy26Rnv0Idu8AOiM68BA0imBqbOqSDsor/RpZx+UaDIzrLaaUODX5On2qN6L0KqQcRmAu4fP4ld10k+NlYJiS3bXM/dg4sNluP16HRoOIG+z28BeA8sFuXvNa14lB4+9LrqrTghzMorrquM4wR/edrgOJ3+Gfv/j/3D1WQjKUOPcE7Xes32RxtsEvv6Wra45E1zK/k8HZxBn5nmG54Omvoc/YZ+n4Nywh6XUNGspPJdDHzz7O2b/p+4oQmJCht+VQNO4Gmf1f64zj3E5wJCfOTj+Pkw4of3A4YpFRvqKujjf4woNzUf5BLiUfqkB4XIp2jctpnmx5jSyPi8Apkai3Mh0ZWtjoTs1xqfFMIWVPu0t6EUmmMXefYx4nfO9A/MT/hffHuQQoNNhDMwTFsbLGkJOHUmnA2buxsRBHx+Iu04N3xl/wG7No3W5a5CSA9iZv+pcNY05KXF5CJyPq47nkL9YH7jbUD94eMj0KuT8LMTia1nQ03Wh+2Ix3E3lMxlGczbi7Ua+ZEXN0+K6FutfUsTnKe63D696G+0J0c3jFesL/aCn81wwkf9Ul76A6X/BED9UQQ8sryd0pelw5cuxTLnE1cwXHGKv7OkHn9zvWsQMngSg9h4r5Oo7dFUPKl1btlPHzoH4W7DlTgQV6df6qb+lBLRaLgBoNCp6am8RGij1GBTHs556tRjkm92wwDO8I/mJTbtRLpCRL3G5CeI2ntcQOpBTh0WnrRss/+FDd2+39/yvY3vATkr+VgCDG+UgPE+ZedPmuvTXKS6NxdYHXq1dl7s/dbow/7g4OdhkHRzU3asgdco9Kry9MLddr+7/2+5wvwOsq+4DnaN54nEXMq2v0nA5shVeqhtvNV8pNBylJ6nwfATdpO2+9UKLocQg3EIySbgXzJGt8kDjGE7zSezDuEoEOVQMYGtz38JUXehBbrEwHDUd0prLQCHvAKDQaJ4InZpxTuTAuGPRpmMeMUCgkne1PKrA1fjAeIUduWTuXkQUflJ2fiYBetAZ1a3aOuaFf/f5trwneSDnPWIc/PHWRLbILccgPC9O3KQ+ncEVD6LOV+x15c7XEmNhH1pbD05aAb0BjF3PPajr+5LjXO3RS8Y/C67u/7PALtfY97C9lZNtNE9cjynjfk6rRkBOXYrchvqx/42X80V99mGXx1aM0y9BrTf9xEi2vPJVPNorjzYHeIyc6qse2I4fuVW8Ol4BNMbW/u9MzNcmJGI5GLQgeuwyLuRNH488gmfGkXYxw/wMJihsXNkDPSJSDVRx0jOwZBKOgE4IIW7YI0Tr94J9ouGbbZYDi+IhcWBGErf/8hlxRr1h49U/Dq7nNjwVDA/y+Y495pdP18PGx1sLeIIcnnB26kUG4vuWPfI0H9fKmuh8cV7OTeR22Hdx3g4H+zDzYKb1s/WCD9vhDsA5DbfMX3720xdYc6/Zr2S+Fk8y5BrAJ9/9O+JnOMGFoD5l8eD+P8PX+ABX9v81mVdPM2KRCM/J/tJtfQ/bA7def748YCk9yTEM5A0Z85jGXtfvyD55wLGKTOYp94PqK82aGobqKq3qTo98kYce8aAJzzPVOFUn+N1apy1tiEt+87D6P+NWffoq2qkLPv3UfuKvi1Xtiw8O2wUAR9pPHLiKBdMFSTu18eQ2tgQToq2OHWex7ZKinqxRQhzT4/3W2/WeK07CX3v3Tx8MB1/5O6fhhP/8Bz+6PLpWwHBSwHPecXGAEzhuBXav5kV3i8RJBBcQ3/rtT/pi9LLrPFdjn/fKvLwx8nrVTnSv2zPk85G9XAuxv1feIL+CuDAfeEZ8i6sEw3XLOKLHUx7PaZhbPFERden2iYH6GrD5x4UBTt5v/8RvnPwhw7wQND+o5cH9f05SPp8H9v85+DttW/0wp7HWOKUWH2TZsB9Qk2C8+NF/dvHSP3umnWg433XPgB92iWNEuxi0R7Taxft977VHf8vvN6jeMTT28Ft+9O/Zb4D80XLymwEwR8ojbmczx5oLdWu/V0/tWJfgsaY+ZC1tgHj88fF7fACEttAnzV4xBvRwrXtAgas25Ncevka+q14dE7v2Vc/Gdf+7Cn3Svti1C4CJMHUZfIB58VMYBB11/G76WuHxSUQHaDIPGjYegyALiQnI5FzP9CG/k5qni9xb4Hj1f86rMhzQX7Ln1re6TQoRNcLB6oWnnjbdi5PuONz73vdcfPMZ++GT0nJOuD6K/LKGiB8nOpxgcUHjNeQ6qE4YC3vIb9Na6eIqv3Wftanxybi9+j/9a4a+BuzkzwPL8EAVdcKPyXz9/b/kD3s65ZsGfjfBHtmLiwmUs+1eSQZ+Ym0L93RSnAz3/+nIm5acU/xo1itYa2i6lhqn/x9y0fFX2vXVthdMamT6nmJZx7yo/c4X/p+Lb9meu2nHiQfshcI5xwoEe6+94Hn5uc8vcdf5kvhz7QpvtLZGeouDhYIeWiuB/78IK8W4WBf2DhC2hjeKx6EYM3swm3ubouUizdlbODCjXLFgqI3xFZ20pS71OL6Mnj6BzVgrbvWLEkY9oNouAEARrNIYEwQ6PlwmIma12bt04z8PNOSKFXR3ZKHPUPcJ1xgjhA1v10vkpVsqf86rfxwY8Krv2PbCR55ubwsc+aoCb5XgaX31FmJuQp2rS54Xf4VrFzruG/Ova6AWwH1fcgDVR4z1lfdIJWszEhoPB4hzDup58kc9tprIcXLDRQAeaYwT+rENd8xwAZC5+VwAxWoufo7FXekjJV1TPgwfyld6BXI8YzSn3YHc8y3rC8NBvCvvPk39XE3Dl1ri7Zznn/yoX/ziKX+ntnsfs0dua6MP5sRgbNwda0Pe1SFwch3QVvGFTr3kecFytCIqHmNEj1bljevLMP4jp+trHHXsyvRlg5F8VAe3KzGNbDWYxIEd8+pOgKEt8cRCW2A624XdUYlNvE5q3wKggiZAOmQINpvROXa9siFS8QABW/wBm/46k/Cp8qFeZ3THDPC0tVMa3l7AwT/nwECUPoQJ21PavXhm/6524noYYOPAhzsX7cIj1gnXgLjJ/GWZjtfUwMkJLLzt4nHpbWDg6D45gHvXO7/v5Nu7vgbsAtDzZj10X27E4q9wB3dzDoTr4nt/0tas+nHfMhF7QPboOOTV7v/ZnHYHctZac9A1p/xDtNQu1y9s4nhXYfEZnxc/8rFDqFM5LviGnzUZTV/E4GCRc1eHqZe9gpHTDVuPwSqCPuLRW1BZPy0a9TZgu/2KnDVvtQss+un2nerBfmfLeroN7aQuxNI8Qm0Yh+mT7yHQ/kA89gX8gQaM8RfOM1joGi/HA9OjWZqg0nxVAR5+RhJNk2LNmuR6/q/xSoR4JXXKKzBAvPT0/35xy34/3ecg8HM+Jv7Etd9C99voytxB53uRIx8d73Im5kW7W+G/UEjsCotxyG6tvrdbEiJGYZ8yxF0U/HwuWrfhjgTLeh5pB3Xe/fF59z1pzLovdS+V/PFKFxcCxzacQPCVslxvxwIcpW+JIe7Z/j8Ka1sZF3Oc06kma8h+poj5YDukG3pdPWPeOl7offOZ380P+dLFMX33hEUzbOvXAta14utJkygeRjmNeMWsG27Ad3oYEPvc/U8cdcC8IQPtf6ogtOlgTvgHyTn7X5CNLAXxeHoNH5l/+OTa8B6m/lfOy8iFDXiTZhcA7aEHTAa9qysAjU3gehuAXkTqb/VbGLCDHDGwV6xDtqr7RtKjGlo8q9txO2PEK79v//6/XrQL/nyaFxNQeC/92HYPns/etfBW52dvEB1WP8CJ3z90CDZzZA8e5x88/HEM2aip7Ui+k+dx+avnliQ3YpqHH+6l5JOQOPGe7CnN14DVJxtCsT/dlyv/rFMY4eT/2he/nBDHEH7hInmsbC+p1rnv4ati0j/7VRD7GW2t2edbDmEhhhpLjcvc5mOKEcJAvorskF8ahJ5fFJN3ZF/vAOSFcxeD5bmrtT2wqkmHVYBYjzAt0m6Ya5g27KFFH+Dhj+MOQQbUE1ZHmjz9ldiSD4xsTemc/Z+4iSmExzs4L1ueGoVbIBT7c7yowwp7I/+bLB6SoeEqMXgCuOl4AAAUXhvE/1uTERiuSYwZDuXsoUcaHyRcVcJRr+9/iD1qU6/E9waNzV83cdqyNlpjCHXs9IW9ivjLNNtL4OeJvTEP7RWEcSjvSBofbuQaxJr0qU7ctg4dEvlsNc097bcMtmXL2yezxYd4Yo8wNvPrOcC/xHDqHQDcvfFfbCQW/SB05bWitYRUx/XsU+x2F+mU5uug81NqUX2d4sRjDFz6Ul75IPGpLmDnH6QlNmKP32/POQOPMbCnw0GuXLdUyR62A336Sz0nzKcvJbNBGTg00i/en+i1947yq8CBOYxnBFZrwDF7tak1Upnkn/UNOcfsWUcfQydxZT4ET90kPYqPwiKjP4rZj/ko4Kj5pLXjFWOzuJnTkgPSmWEEbtiv9CZ2jhayITLjKWEvHwI0wcqZKtNxbL5MSnVIl+KSrQVI3opoRVyz5VOzULnuDbPgRY/piAlon6aur6b3JYMnsu16Kts+uKO0buA9RPtEMj6lnDOE33DoHuPMnI+C7pRxgHvd7nTwwHcL640PWnFNWd5ck+CP1hzkI37ncd8AceGT9Nq6PaB+NC4zqPvKb6Wf8CE8+MYHB8/58KDGfwp99zvbtxa63CtQrPXKPmtsmL7ufE4D6Uw/bU7jYtiXFdaavd0Y8zfL0fkIocxzt9aA5/E5cNARt3Y1B4yBG2Z+8jeeryHjnXrnBi5vPBI/8WwupjkwNsaBMfMM3ub+pz16xVC+0XVP+Djy9NjiPHPb9j9zKnFtxbxWXW7Hd3YFu+ZacXKMeqH5RaitQy90WwhjDEyk6cMfL4phX/yD5W0wH90FAPVC2zquwuBggoLnExPxrjaKBgCaifUOlhH1XTfYNViTMRr488QXhOtHeW0Y8RLeKV/BWqzfWOoue3jSX1sIuRixHjh3DK2Oyd/Z4xWuY+KkDyz2Zp/rrK6NOlZfZ8ZDqO98Ib4SBob5i6WftMcMX4ilNiwDsCPO6V2cancNxzyJ7N7/p+ZQ59Rqy92U6+DMue3nFNPD9Rw957LEslrzyLHotAXCiOdFwEU1Hkp2j33FEhfZ/tkgWyv+ah1rhmsqcx2srzl8kSy2wxygvfLXIJbaHNj/9Ih66EmJ/K0+cryy/c9cNSbyIhYVJW25ZSWDPmb/J04l6BO1w2o/uHyajs8NlWEbOTgKMeFL6fDd3gJQAQEICMXgeZKUR4yoxHQx0TacDTviUZfjSGIUdCv2EO3aM+/og/+eV62YvzManmTnjWuSveHmOiOPfuqYfN+msYvOjau8Z56xmK/cpzf6q/YuDAwizlPfAkq8N5DID6/u3f+nxopa8VhQMLL2Z86p304X7MTljHJdsRfdRrIINgqddjBexmqC2uErtW+xp3Pe/OEf9K/kZj1V8TbRNx5+4DAya8o+5mGpzWEI13A70cUmOXBo0IsM1jN7iydjqPNRx+lW5id5QjBHYTmpeJO4MxYzOHb/uw/4Vj81hiLvakPdiN9joT4wPSB5K5J+qEN76296ECoI5VzIUCZApTmhaq809A81xYYuxvgznJy+YzEP+XwD5XfyBcBVxP7685NPp+O2GL8NEgt8NY1YJ2i5htoweTI8lsTT4LxxLbJXIF+wHpxwcxUnD6/07tTWxR7l7k7Uo7qcmGxWboRZjxsn+Lg1WmsjXyMe/GWAi3M9MYDrJ3074eOnlU/93MeCfh6FZ3nsblpfpQ8BlFot55G6LwQobLx28IVxbefu/4p3YJwn3AhlGRuDMda6+HqoeTpz7W1lG7hrTedwXbGezZX4UjwI0XQulG5Sl0+fBAiHmTQNRiseMnWudNpNiFFQUI0DvaTXJwMfTHICfW3YJcerOIleae4lv3N941PuwybvzQ7lYHLtIabaRryqszF+jXHRR9Wd1sHWKhayhPRdtwa0JkrXGu0do1ZWz+39D6VOYy966g0/CDm6bc2c6hyTT0TKo8ejt/3X+K7LBR/LhbgRI+NF/KTRo9XcGnf9P+0ooR18GRRPXBQvvcwfbRbhmjp3/xORuXOsveRS487xLFaxVUhfo1GLnl9GFbeOQ51xcCrbvEGYnAVYMZSmhvFurk/ylMrkwXjPBMB0WogFN3VGQUGt8usYPs5s+CpUvqo7Gmt7RruTWI39aF/XyCDK3q2Zml8dHxu+zq2upUO4tIOe6Gaswjs2pEU/Dlr0BQFj3MI/f7kuIbzB1OsvzH5QJgJjPc6NU+upNHCz/rehsBXSfPmsI4YaB3Nkzv7hrRv2fv5/efHIb37Yb/FT5br0bT9ENJoPafaDgLmX2LvKUN8qpj8oNMCyYg65y9yamHWF5tCPQHBNQE90u1ihTj0xdX3j+zwrX2mPBQzDVwzn9z7VzOm6phzGbHBOjTVTbbq4w8eKl7aGtdE6u6J3068omASERmchWEiVF4DVkDZVgBhZiImOBwo7yOGTLfS3EqHq3v4Vey42njS3apqr0qa45T9ltKn9ytEdyIh1xqtQnyPOlctC4TJSQ/2iobZo9Ou1bgznZxxt1P1Pm249dRo7B74GswA7jSZqS2oThevLPnjRHHv1rAxQZpl/HtBzj50FfsCY+xZqQXNVT/1bzlyTb33/T1089OEnTn7Q14Hozha34305liHPPJlMXJgO9xJ71qf1sGOl2E+w9rARUzTUFo1+WWuui4wj9LWjjfJWdMGHfDXXuq6VXoHtZDA/9sUMcWcM4Y+5JB+2O2KhnbsoNnYJYg0gDMRoN5gAw7k39KTBULpp9P+HWVNF4L0Yo84v/PNvrXr7OJo3aMmrK2SJwGWi67FDxzCyZhhLHTC841vWKyZUa3BucoGNTmvfrRP4yBjOdbhhr3mRtn44nZTP4KJUM/F15ufdLeSoeSp9GQm0SZ/ObbenTvU3WjfKAy156RqsLiHDyf+R3/zQtT35a8y5h5BfPfnnVh6uboWR+dle1NP5kvr2wDaKuUCntc/YaRB6HO7qNdwSA2JVfys86ls/rBDlK8NgMF72Ez2PYYA1im2pr8WkNqTpi334bBcAGJigM9wKKvQ5Qa5agHXjEIr4ngC/280AqYQ+eNSnKBMf2VBpd1+nTsbEZ7/ChK7oU44a4K/YZdwup/Kd2XdzwlzRo7Fvo5P+z6p2WIGvdXXatNErX72GmbM6PFXaScOevohlfc4tYaBDOXnfRX1+Dx05ap5Kn5tvLIJurRlm1tpqnPS5vtI+nGLM9cQ+dUhAV/RthM914OR/J7SsK9cqev4hgUjNa+w1WHJNW+hhzonBMfpBm86XrhvDSnzl89WixxLgjAu98tW37n/lg15S6texiaax0hdjs36lCx3Kq0+OI97MFfyZjfE7PWKUfomjxERc1oh92C8XAB5DVKwoQbcLYiAPvKWj44XTF4ty9qLHYrSkdKZCaWSj9rvoujpiMcPW8dtErrx77rCt9uJ0FB94e+omMNeRzKw1F6N9fSjvEoPPtad19UDsP3xoS/nqlxeZyjuVZm70xXHFo1z5WTRjmvzgbXS1vWY0fp3uqtbx7d3/tbA2SZxTn8Pj9v+jn/p4Bby2Y69rXaezfeR6yx7LpcxaIUujN/e/6kZVck+rrMZUdVXugdh/s7hhu3f/awzhc9oxhpkN5QqQRTOmyJeTtvFneG6iAAp8oO6qShr+xVf7FgAYEhhpTJIHyR4g1CUQx3Qw7HEanSVRDCpemHosUDW/vnh2whX09VD9aQ0i3m6S1taNAwy0zr6x8v/QyVuoKdhP4Idobj1fH+GKQoR/h2JhlAdB5dvYYsJndShxcx9V2ybxHxFijuwd2k5qTWW7BtTZ6BMHOjE3Oge5JumRoYZuQtdxCk4kLF+4yvg0/0O+GCNcm+5rJzyKmVG3NYCvSioopegRoc1rUOC01iKHpM0WNYjDzMhvKOQS5bX/9/9rc4z8kfeh3Gl4TK9OI5y6/31N6Bwcg0/dGn+H14LQtUez2uPJjPmY3Sq8jmPkHS3308KiqO85z6wRe2gZrVPWG0K+4rTzCtiK40NRDp86BxkvQRk346OrOgYsdJOPQfgqMRCCPX2KRR93YtKi9IwRbOh669AaHp4jwpigswM3a1N0GbO7kv8qf/U1QCqwF9tGslhMhONQHNvJpBbAql/K0hc6fGXSBeuooYVUfU/tLVdOW+ebRa/voU2BTnsOP+Fe++JX/Nf8OJ71w7y4AWiEWuockqacfeTe5S2y3MCsxQyHNsf0ZW3BdBRHly/jCFuXHeNzpmu4I9+uPojT+YylYL7+779aOPuH3Row/Nwvmi/jEf9djTbcUY+9qwpOmoKHRl9ttH9Phf6w42aDUPGDznlgDEOQw0x3o/gzE/PDkNI3dKMuDz75+MxyFx/fSHr1C3928eq/+7L/2h9fJLBXkPse+3H7kOGTyjqeRs74s/g9n6CHQJF7lzcVI38fKg1GN8bBJxr49XjZ6VLR+sHcjOIYrtWwdZlDRgyJKTGJy9RPPQsjvho68t2gx1h9DcQJSCwoM1tiD4bLjIZ/iWHRg8LSarzU81ilrh1/MbcHAZWWhsqPQACCtiqEOFrJFIf0hv7KPnQzLikK4U7qvcaTiauA5vMWY2YPHcYCXmkseGFfvPalr1TW7vF9733P+gIg4lF/qxoizhqjjp1GDlGPwOQCHlXJ/TFy6sMPa0LZ7ejpL7C7fIt/bF7/hTbP8YxgWEPB15onsvnxSkKPuiXefNphGu0n8BS5/Dlnw+fcMJZZLZwP5fVS7Zy7Xq1V5AEfaJ0PMCS/lQzyYxuTgl1gZ1ys6bGYA311MxAvLNSZObKH1Ph4tPepr/5x4v+W/bokf56Zc7g4vo0U8mBz2ldt4zDH6Ed18ljVHvOCP+KCnjXqmJw5s+d8z0ydz/hCqVtzxS/3v0ej8RUM+uuwqOOlMYTyVfiMmcbozaapmz5jIU7oqV36k+lIO8FNPeFBj1UmZqdH/2bjfCirHxvmZwAAoJNHIOeHU/DcoQDvmrCw9w629ue4jF7loBFL1yI29dvJL3FAH4zB+hZrBEs5XYoeWagy67fwGoUflMHGP6Xd9/73rT9hHPGkP8ajDkY8kbc5lslgjuypKziuTTl6yPhH/VP6xFwbe5zwQR2JZ60dHFeX3KaKBwTmy6C6xpojrlZDE1ts5Kcy4w0G3kc/dQ3c//gHHCX9BeYqw1FtagIZIKbOhLSRHNQP8urmHfawKfkJ7GnkKs6I7bL9jKKjD9bCeq8B+ezD9t53/8gI5SAP8/+fHvtH9muEn8i14OuGfoGgdCDeeOiMp0iu6tpA2xzLCmKO7MO3xtOtA+gh1kG8xqR16wsm9wr7XEsSDgFyjRJj6I/a0Zv7xNZYiFHUcwhs1bFxySRxEVeroVmbzeIv0BTHVZbk0o6OS04reehV/oKYCkRc+pqASfICwIMugcJymIwGKTY1qMWzUGEL3O63s6FCXLtFlFiemf0nfhxtkIx42UEKAP2itz/3Lf5WNfBQw5566HMWkmhxUMdG2Pj5SeodUaoKHiva/RpgxKs6XifPJ+JzutNoA+GP8lvX2/AsD9Sm1scBkaNgDjzuYxEjwlcjjzNiSJ9UYFwcoycWaJkDDE9prFOuzQABH3+V7+JBDNA7Zw3gCXOMJfOY5TeqC41kmTreAGPoZ5ATIIf509cxvdbSY7T/BrHJhjsGfa3LfNCzXuJvVQNDYK73/OjfX+Pt4OCVf/ez3IxB/I5yxm8JnNxkvpEn2yi/lW/ox7x47hongDAWTGIPWBT1PWOjwRJe6nGNsvZdjGaXfFoQK8ckxn1nr/kFDuvU6RkU+PirfPeiMQRm6pmMmBkR/RafKQ9ialcVDSf9VZnVPC8AXAbnGnA14Dh0EngUrOCkHu2jnyZhtouMK6Mal/HRQ8Fl3lH8xbeAMp+tXLloOYk0h439sQ71R0iotqfHK0AcBBwLfvB+GhrjA+3+TYa+xkL5iO8wkYTiCY3aSOWAtrQJ5qJwIiX+geDvyVUoxBX+WWdOR1U9d0w/FSf5Jd7UCz70Xvns55N9LPHQk7/gXzsb2nFyuC50TmpcdQzdyhs5CR3WmTaZ/8jmKN6O/e94Z84wa8O8YzzMg3WJnjo37et/p7SXP/u53oyx9NxuhGf5X8rvCcDXxF+dUw+AudsAeXOJdcFhAEzRdRb+KzywVo1TOYqr2F/q/i/Yq7jAKDFx7qtu8meYwXc90AW3w9uSdYplwMnZuf/7CwAGNUuAviK4THgUrPAyYdrv6HMh7tA9S4W5SrwdHvisCwQjvcojpgKZDuv17U/9Xyo5mn77M79+cRcPPPRVYwAq3rMqzetKmyLDEDFCh/XHXYeb9lOlm03xRnFsGu8QApM+0PNgoaaUG491vsVNAD2Rq9ml0YofNfAaRj3dDzenDV7+zOdPdo0f5Hn7M7+xvB2UvqM2GPPPvLAeRoRPFpBjso2vtQ62rwF7rztb4KxxU+NsguvvbKBDAKxd1qYYsB6Usw81/jxysTo4fO1L9m0KtILXmO3/WoN77QOA5zbHZM4DsLr/XWUjRpcrXtXFuPIGfpOlWGTCnnz0XL6Uo6fcSK7Lbv+7Sm/I/cm9wtwBd3QT/8yX+DmPut1YE7NL+cgp9UYy8tJ31AZj/pkO68G4lgLeKncATHkVDIA0cDrd28PWMQgSwdEeMmn0n0EPZMI6nWSBDhTY4zmgwyAYu483bPDp3nPuAuAE8OizH7+4x35SdNW0nozBeIzN6xo65FUM3wgPPehvN3zPn/zBBT58mIsH00hcGtYx+ZfZ0wf7wM4cwGfutYdusbuU0Oinw1/WMw9AXMv6ltdf/4evLh/mOyEYfPjs0Wd/6wK/J7/kFnuMubJf4Yfeit/vf77llGtgoH+7WKyZ4udcK/McGvM3rVEDdp8bOt2vIx4TCzG5htgLhs4S4njwifO+bQDovft/VX/Gi6BIM9Y6rnzm5v2yP6jmPXUOYRV5rgnwiVH7cFRzylrIswS05l18owH9QJZxLflt7f+M1ey6uBQTuIMXcWB3LX1H9Byz75QxWLL0l4hZxNGlFUCWnJYiE5QBoydNGXrYSiCuEuPR5lpCE5DQzwkjrqgcTQJT4kr7Lg+9FZkaayLyzvhQsjpxrE34/Pan/tUa5wgOnjz2js/8H/5rY50ZFnNt5rNbZBFD8hib2b3FPmX+NrvDgIP++JfMGv6yZsIZMdjXGC5x7L5Hfjif6Ku8jo+NB5iKb/a+LYK31EPqX3yKxLG+/alPHxtFp4/flMeFIL6HvrctcS4WC88uFO3iEmsAFxd/64v/ZlkDPAaUnLLO4FfZ4uI8Kmqc+wtot8tXl8fO/X9Cdqv38vVuFfG43mz8wC8/fvK3DQiXP+Sk9YRQa0mf3WIlAvomWNZMyBSDNPvEhO0a2LFMZ4UZ0LVzPWKrUP0U+RQbNlzbwCKG4pKmLPpz9z9hN3v6NKVp3psAvbDWwb8GmCcCmxzx1xYGGCwm6E7BwDnGiYdPXoI++Uq7uumhGT/9qg7tmlb7n3L24AaMqp1KoygZS+d/5ATT3hZrZ2N2OOk3XtQRWIgZDRscdIxx8McJ9tSvEDXQC3+VjhPAt5/9Vxff/v1/ffG63V3IuKiEnnEwpsgTFxI4GOG9xXsfe89yW1ltWWximMwrg3HgZN/ZXcJAfQQc8+vmrbrSuCTuqnbUGBd1Ub/0HQ/vYExDPOaAPRLLAXp4K+ihp8774Rh/BO3TH7KLgPc53ivP/VF+qnwUS8aJPCyfu+xOz13v+r6Lt/zY37+41z7Qdo+tA7zynzbWlQoc1/1P+Sm91MjNWT/2YNLvKfi0CYycyxWur3JqR4/glv1/C9/o2apXseYQ85Vf5wRzY43ig784Vpzb7rV9jrn1n0HW+inNODgHWnPKLJDp/qd+7Rk8+QCgj5CNqu110fjgezRvxGdPG/TmkzYVr5t7tUWctV3y/k941gQMxg1a+S4aVqjp8fwCu42WdYAfy2f1HIDOlsGw74RtkAX0fREBqr7QqTvA6VglcZcZb7d9B3Z4kEWpqqM4sPSNv7JJnhWCawf2bEF7DsF76elnLh6xg/e5DSeBB5/8x/6HtxfwCfNXv/Tli9efx08e2wHKArr7B+zDShY6+hsPP3hx813vvLjrB75v+2CfgUUemEvkYT04WQPwdi7AhDxEhJ9uQ7iNe3Yq/dtoujai7ofcHZa3vKHX+4o1vwXAPWAQnH/Pwkxf+tgzFw/br8ed29pFXPuEON5ewifM/SunL9oasKdHYs55YscaAI07CLsvQCdpZi2YEBJhvqcmNfJl85i+TsWtdrE2dB11KlyDHdOCMz5tTn2sMy7asU+/+du/t6AjxxgBH3OEkz+/+rkonkbh7s47nvudi288/isXr5rvVRvlq3MJOnTadMdEgcf9T/3oXU9xKWeiFoTXUnUQGMfUz2Ad0Uecg6a+zEmqNkE3rGvTP1AosbiJnRhzCap/5mSxLb5Ts/ejI2KYn7r/LftlvzBn2tKO49LnfoAeL06Kjg7p22sQ+tMLgARXBKMrfzh5xcaHFiRKDpSatQAAQABJREFUVe0pU5M2xctEu0yLjkLdjoZCxiu6Ps4llp4/CgIYps/JU9rUl4VjrwB//9N++/ZSPtkboeBiAH94NX9pjeWWXDQPrw5kIj/b96R+M1yNZ6hDvKFwDxOr15rluPIFEe5+wQf+TGe2TmgbaPYgmN+9uP9/et+l/nZ8W0+nfT/dcxz9F2ug5uX5XOa8w7f7wn+sEnhSd/o7e07hTJrPHd4VXV7hN+kSS80fT++7+UPyAUmBO0Q+9NSTPu8vPf0JfwIg1g4yvsc+33Hve9/jJ35etB3C2ivHseEdn/mdTh0XjF9//y/m2vU13GnEgHW3IdcxJF4dyPDHC4HQVb1AGXc5l1FrjsXn2LBxd/sREJ9LXWMh28SyeFZyTNqJ+99d+rqzvJmzxLgiWQ/T9YdTydjtMUYjv438/y7u8DW9AOiUZyDkMwGMZ0kgIPtL3HI7VDdW2/ay+bdwGcNl9F68kfclFo8fw6jz0O2sBqocE/SiPd+/bkhVu1b0IC+dt24Bnho41xJ9sU88K37UjqwuBmPWsev73NLi+B6Y7VixrIWMQ9dC+Ml1DlddvNgH4T9yfeEjH/P38o+P6uoturzonnOG8Wq+qHRsL3Ue4aKmUetjkaf6jtf89t6XUd3/3/nCn/rPAE8xDwhwJwB/eD4I7ibgBH3ljesRjjl/3ZqNiCiTALu9dinrwGqtvlc+i9xi6WIYjDs8iV3Xco8Re1R8uxznLL1gYJxaP19DKOOyZnr/gY04tF4SV5KAgLphJh5x6ZvK4ZfDnMdkBFHs1t8Tg56AwXk20DpOgREIjMEpX2mVR2IUS7mOwyHAsb3lkblpXMRRXslZP81N9VHv+IqjSsHHrbgXnnpaJdeP5uQM5j8XJqOe5Uv5ob7UOtUZAxgHfLSYZN0myOmEu+dnXAiDOBjvVkydzGwwJs96vBeMJ8Jd64YCDOY/Y9acknkiAV9b7ZJ85QrhXKhP5XGOQ677H5+5uIyGV/pvyMkfwY/qjfxL3qP5X+3/rWIIXh57Q9/HIl/BaIw6NytFbC0o5+x2GtVvE8oJFpYwLT4c8zbt/y7AHFgQkcKwxloPKJZ4E6YSRW98ASBK+CpDVzTItibKZJ1+DQDjsO8So8+KPcOL4ozgd/EsjawhfbIXAM+FsQW/i1t0K+l6ikmafRjgWeD4u/YNdSi16MbIq+R2dE4jHwAp861rLOexcybcGnOnd8QAODU/42ksh9BmurgN3H0o7BDQlcujnqMaaCxWn1mOqrZJ61xfBt7EWa4Qzil70fdcyvrR/Y9X7td73iSZY0m/SyuTgTqUWnTjWr86Flt+Ra7bT5Sz13glDLB1jeU8qv5ydO9ixtzRlr2cCRxhjGcixDXIacHpAhgODuoC331EFNUfUbUeSkM+qh/tSh8XAJNNG8Hkgicw+wLGYeqDERhIPJOn/Si5KrOx49VZqWM6390bAH3RBu9fHdtGOQCD8cEHdeiPvfjCXYBzHxAkcFdC+nwyN3oc5EbRrr7imVGumwDAuFtj9Ml+5GhLNtKf8QY4q/XJua8YErfmRPobv/C/nvyI4Orq8sd2lGHu7CdOurmZ6Bxkcx2Yr1V9aXwgDqrt7k/c//gg553dJgsWJ5aNGvu65TyNCqC2SkOXdsHfWjPcH3SBcadPbPZUHPVi22GoruIwTspVFrzV+pyUEznTp+ZE2nvD787n6k9pxoMefI1TadUD7bLFQ1wAxCaryiOHM/DgOzRp9MCwPyTO5NMNZDO8VApiiblKThtXvxbL6rv7hryKmeHQ3t8XKiFgAWi8yDMaJ5tj7Z9/8qN31EVA1obzKHlqXkfTrG0Ypp/BuKun2fmY9uxhp3TgHNUxRzVSTMw3xq6nSkJLfTwnt7eDQqi8/o3nL77+s790jS8CIkdJKcmohS97rUsqnEnofiLUZfqxuTl1/+MOwMvPfY5R3YF9FJcLkRkcqG/uS+4NWd8OQXv0pIfYzX/u3aKbfsJWx0fv/xoj4yk9cB1b9UtcXU5IAXKvRQHjULBG+9/vitgcaH409b76N2bmL9gzXee73jLR7QKAgbsG/msT4lR1Wh1BW+w9+NBZJVKx4ABN+UYrXlNY/s+ElxAX4TGUxZhYsDO/XbwaE3GFlyUcxUEe9dkbTucj/BIe/fMf/LXr934w8xnE67EjP64LydVlp/xHrJk/wcx6hl8f85Wc4ojNyWRdM7kIBFHy9/WVYykiePhDfGAzTuO9/tJL9onsX7p45bnPC+g1IhmrhKT71es/0BH1feQEo9uzE519DlrpU9dqn2sJTMxPbcLLqQ+1F578tf7HfartJY5xpxBvGV16qylnfUUgNUj/4IUu54e960BW7RIbGk2ea0dl1S6dNiLnLPR8PNr/xNzCExlwHEt4yLHPqwSDoei7bo5LDcFHTGBrbPycQdoVH4Wf+btr8UFMmBcbRVw+AwAl/sWEQFEdqCFpJJmbAUw6Y09F6fsimrUGa/TKJxwEXk5K51TAjyBXEBqzxkRMN4gij+TUQw8s6rBXOekqszE2N+4GdL8WRv0r7tuvF37FvB7KO+SXEV+dBx3vwM9XcrRjv8N2psI16+svF04SNtdmWeay6YaOlgd61GVPxza+9eJLF//Zvqt9XT4Y6GvgS1gD6zbd/2vV0zkoYcxh7n+gnTmvMTNLXIpX5wVabjDeB6jRNx7/p5sPYVocnU7h5I9jAz4zBJ9X03wCmqtRXVzS6uLzY2MvleoqPQpa5XUedDyyLbzN/U8/I8yRLHhXuf/dF2MpueVxo/JH+VCHWAMduwCwiaMCDEizpxF7gkbfHeRG9qofmFwkKnJ64iOvkrhjgaMH1BXQTobhcGLdQsbks2/x4X8G4Zz1f8whcl0r7ONgo3/9/f/kDX1LwL8f/JP/qN3eLPXu6uIpRV3OzLtBscbhdA+m6OT6Io/9vtIPtRiRC7UWnG+si6QLBPgaQ+hlDYsd48eF4Nfe/dNv6IXgd77wZxf/6Sf/l4uXJ79eON3/pQRHDbVWMES9weMkVPlR4KJsODkHYMuYfPZu5fPOIAQnSHyj5z/b3Rs8jOt2NJz0cfJHw8kfdx0upel6VkBbl5l/0Ul+6pe6zOaorHWf3MpL23Ca43S2JkSH+yf3HGTVhyBkLqFTUnXNxMRIFRJ3wwd0JD7GUv0ypM4XmewNK+3IQ2/4tEs5Y2OvMbjtDfwYkEzcSqEBu+5IZoJ05kryH52yF92pDX2YTeqIfReruDqVhA8WjRgc197ljI/K3utqMMZQJwyQS5dPB9QPTA8HEmz4r/3Yz1zphQDe08RtaDwc5LW/+MsWl+e15Or1qbkek1+f7WQka7No5Pogf7OuS9xUP7qPXFd+wWferAd7OpmMuca21gzWwNfe/TNXfkeID4f5+s/+oj9RcBbjqh7M+Zze6pm43byW9VDreqRP+Mg5CFuOa+/iob9+beEiADW7zA/04mSP40D9ujA+d3Db7jqg7pYv69Dmf8nV+bUe3VxFQSsPNuR5b+OKk/NY5jv5g/MOMUVnIVsuOYau+OxzhOgIv8xHMav9ZJx+qjwDHRCmm3YqlvxTTlzvl7nL+tu53x8ElBuBSdReHYEOedp1cjgaTCqCgJ39NTLeOmCQimG8nAKVw/4SWxZqC7MFu6GRkQ51eCBzLc9Fcog6piHzg7Lk/dd2EsYBAJ82xi+C4Ulvux/hmuDbBE40eN/5Zfubf63JAtOYGS+hJWaybktvYfgK0Vimvifr8cTAhmvGfHd7gXXR+Lb8oaz23t8QG3aGgxMK/jD3fHjMFuQpMrzax9x/67c/aY+RfqHN9Qgo8upyTr2od45PIDC/nE/2gGFdCVnH5O/s08eWPvxv+jF5abxwx0XUA49/4OQnBeLE718RfiZu90fd1R3uzLz62J/7bwXMf8tDLeZ0N59a9zSJWlBW60J+6hthvMQ1fV8d0BvkMuQpFmkzP3r/0xb9KE7KD8Q1XDOaI3BYlxEW/WiPchzY/5sxo6qGsd1EQeK1CwA58LAwta/IIc9iYMykZ5GYHPq+GDB9Eo/D7y1WjeWMcS5Mw1C6g0Rc+MMHS9AfaBWHOS8JW+LIHVC1COqj1sPGvBBACPhhj7t/6Acv7nvsJ/yZ7sc8MhQHltf/4q/s9wK+cvHal/7cTvx/1F7pMy44iFbz8ZhrbFS2HjEur348SZHqmLUMpzHsnq2u60p94oMytXbqxXRzbcZ6xEF5iQvKjIW9ACS5yLq43LzFwPq4v1q/jRgbRMTpUDBeGnEXTqNwUsHfi099rP2Ik/1y382/+3fsJPOD+az/ajMaox6vfvHP7cejvurPhcfFH9ZF12bxBz9rjDHmx1vL45XP/NHFjUcebPwOZ6np4qu3fW3yeYNFv1HdWmP5CKXrJedaEEz/1ovfTMas3p4XsHRvptWaUBxetN1j8/PW//GnfJ7eYvO11TAHyP+V5z5nP/D16WVOunxQ1lg7VltecAAXPxN9l/3uQ2usNYti3G6umlb7vRATlaezQpp+mupi380pheN+WSdmHvux7t/0o3lqrMo/Yf8PIwO+PkN/ltOIH/Ew7qva/8M8WFOtERVHPJMx3ht/9a7/lluHJq2noU5CaDDp3mAZHZIvmkdQpeD4dSz8AApz9z0OuHE2tpJDFv0rn/3cxTef+eSGAcAGjXUx0a48B/ppVxcg3cEGDXLkI/s3+dRxhq1jPEnMf+iHTxRbDLHBX7fHjOJAcct+ICgP9IyNqhwH5mZXdeu4GnMduR6EcGqt2mGMBn22qkP+pM/6Um72Pu2KSdmB3rGgo7azeEwHH0DKA94BbBc7ljvotFc5dNJloPHhSXI3/4vv91DbU+U4sXbYfeGbNu8v+AkfPxKVa2CB6inmiLxBSzsU2yG5QO0nIx7FVtqBGPMIdSjzVTHSnvMEZ+V/ZDXQx7P+8cM8d9uvMHJz4wITP+CFi5qsN2rPKVTswZyo2O0HJ/NOBwPGRh8crxQHjKpbx9WEMbsehHBqrdphjAZ9tqpD/qRfzYvZ/03Y/yjHKvdSoyofXgBUpYKxOOHCqQox7nBEt+PTlguEY/ZHTj7Nsj/WvtNfHyCGsdOZ5OgsYKExN+2bZPm/87uwd1HqhwYbeJoDafY0P6ZP2+LT+QBiXXRTH3CQmNAz3OkGpk/WVnEpcwi9KxAbBbo1JrFRqI7e0OniptFIf8Sjfu2rbhkvdY47bPXVatGv8HU8zEGUUs55FZmSqQem6HZ8GozmD7IjYydc9sfad/pv7v+s4waR89nVTveYGbcNvIHSixITbMN9c/9jA0Wb1vn4/b98DTCxl1tL9Oc9nKJZn6EEqwnK/6bUvRISXecDLzAx2aQLynKADt2U1/EiSMoJHuBdvwXh/nqtyagVdCJsbI0jc0xiiZ9x4OA8apSPZMbbjBm21R5jjU1wdV5Is3e1iZ1AdGTaMoawd77zBvEBQf0obaLEhJ5hdGPw2NRnwXAVjYU21gMvZ8nCs2BSullr4NFnWgShcWosod/hFoxONsDtWGar+kudo27p22LdircDbQPgKl6qEBNyMpeSkbP0PuWpqeVt+MALTM+F+AtCo1inKq/jtCtBdfZNprVLsyHR13moonGk6ySWtcI43tz/Sxm72knNTKPb71a7brwgLPUFluJRJ3jVHuP0+Dd4/99Vi5aFqsXkAkavNApddZ3HGRj0xAic9FlUc6NSH3I5pnTqGcNEwX01mU9+6ncoS27BrrE1hFw6oS9j2HEY+XUx4z2nvY0xGg6zypoUjCGf/okTNkNdxaOd8kA7DpPDMGj21J/ZU85e9ZSmHH3FVhlp2qLHH204pl7pc249jTjYm43ziQEbpYE5a6qnB/rgp7+B/ZZspW544yiWuWk2UY8VgDA0ZmNnHIXf7XnWgH3VBXwNRVw6FmzDPn2qDiCIK7qTxGWOxpVpvpoM/hK7+GRMZNfYGoIk5znIGIYcRn5dzG/uf5Y2598ZrNUibRTXQOXrmLbo8UcbjlVX6Jxbn6+/mfsfb1h6wXRDKC31WgpLphY6eGlLWdFt8tghVYe60S8TxB1lApKIG0NixNiZ5Jss5SHgOLFpsKN3W/fTfPtCc/8xJgZjYWyIGTT+KKOu9tQnj7q0s7HGzVyAq3yaZw8cwd7STcw0NoK2Hs+Sa+IwTrUJGniOSQz2kIOmfGCbfkcy8mAfB9X0sxEPzbzPacQEYWqW3Lp5Ur5r2n+ax4jHvKA3sqfNrIdd9cEx8AaYLpYUZtDOVyyjdd6V7jBoQybHEkvaUlZ0m7zVe5UfdaPP+VCsMGX+6U9igLnzzS7lgclxYgd/T+e27icXTsxRKTpjYdyIGTT+KBs5pD5l1KWdjTVu5gJc5dM8e+AI9pZuYqaxEbT1eJZcE4dxqk3QwHNMYrCHHDTlA9v0O5KRB/s3979Xw0u7TA8rNO5d2T475tKysHxiQ6Gzzlc1WNHRit50UcQiQXz5c5q6cBh4waObvm/+sbDSnyqQz7wEc6hPW9EjS/uVLeLXHKhMHJF5xDJ2VeZMuyoPfm5K4oJvdP6iVs4LgdJwYUywUwHYwCx6voGhpL7TCOxYC+xdFjyjgeeYgus20AePcsFMEh9kYm6KTzp6lrHG7jjiN3GNaDE0ztBOlSsNh4abuVPu+XBgKoi/+mfsoaYYSjv+AtUoYrGvcozxCek9TTGM1ho4XeJ0SM5FXoUbt+gljuLDOMYo3Zv7HwWxxoXbRlkjDtnnutBaG/3m/m9rnWXMtcfCoa/rMGRe09gqQzvFqDQcGm7OC+XwxWCgcgfs//45AEwE/ahwuQA1S6PBpz761AtAkaPmeYChjfHye5DCC+vsUPA2Wa34To/8VQzVqbJEHxDMY2YzkqsvgeQiW3IwYSvGUi/FE5rV7mzVD3XFn5OMG3LSVYfjKg8bxk21rjcbxtbjB3fkN22QfGmqD9rRQ0/jI83eNLva6Nhxmh/V2cyrqfv/apPs+BpS5p4CEMa9gedrWT/6upLEHNpp3dYzubbWkbrWhJp4xQMcyrwHaxwRzbynjTCHOY6wYOtN/GgckHHcFNv/4tNnlTri4839b6VifVkfVM9oVrubJ9WhXav28j/rK/VfhIWibrDxLav2TRIwfNakD57HoHLQaDfsuSUfWdZnY7b/zablw7UkQo3Tc4Jm6Gl8pNlDy/R1/efYcZqP5NlQdZt0/L/apMZ30f4ffgsgE91NcIGEAYseEzQsYsF2Hf3qCmwDZ2UPPicfNF6Z0GfB9aHqY02NDswjuwlvFc9EL9n0X/tUEII6zJ9jUbl0Ej6s9n4QBjhre4wjxsn+GNuZrmIpPdO/FH5ZyxPMtl6XdZdrwmo3+ipgyiveRl5pM9IpPNcFNvybrDvAFd0awvnjUjP4Q4t1tIqnSbv/XefN/d+OY6gb/lDH2z53Ng3wUfb/o89+vH3Nupul/YOv/sB/t195pqm5Kz3TvxR+WcsTzLZe7/z9728BIBlfBJGsjyeJJxs22XBWlcYFDJbprQ5Gokqy6QiOfFjGb6UEluvHgSU3RxcLEaUXfb/9aONdOQrELnIWBw5saIwjesbAvinF/8SiDYXkc7zRD3FH+vBh0+lz4LTO7chgwGOc7KlyRLyYzy5mjYW4x+AhBtVX2kWjPGUNQp9/JR+vleDlGjdeyiZyQvlLIc0xBYVg7souvJw71XHaJ3bhFjsIvOYSazcHi2VPib6tnF4GH/TDelCjsyMz1p7ivLn/W3FYR5ZqUj+Ktd81jzCAD18mMW/uY7Q3FH0nfUS82GtdzB5XxME6HIOHEFVfaReNcpS1DH3+Md3AyD0e/Dt1//sFQAbPZJjsrr5MWrXhxJFfx+Sj1wlSPc6T8qBv43rwAnvaTJ8Txz516Zu9C5rjflGa2zQyQgcaH3HQA0bHYV/r7mzFCL3sgLElhyL9GDnEJxj12JOP/pAP0c3ajHBGWFUvxsRZxVxjwbjyGA+wKr7qKo00/RUnJkca7dHTl9opbWaMWxAaSdsqUHu6Jo++w2ZVC8Fyv0Wf4t5OFij0+Udl63t9G4vsMPnm/s8acR7B4Nx4vcs4DGrdna0YoZcdsLbkUKRfI4f4BKMee/LRu4/jVoGadw+ZqvFWfzHmPlrFXO0xrjw6B1bFV12lkeab+//iJgrvRdfigEYhladFBj9lOKlCaPp66OBEpB4BWt/8gnbjXujsiGEWh+lk7GvrNQdx1JgYG3v6TesWW7coPU2JGeOau+IQu/bpA6UMPOaKMWMVvaw5ZbQb6Siv0rQHf4TBONSOPPYhy9hHOKHTbe6qF+PEUZ+giz8Xg6eNOsRGHzqba0TfCqqYxFI/pOnPxhm38Ki2u6ctfXK8AZB+N3QguvsHvv/inh+yx8PaU+fwBLq7Hnno4sZDD/mTI/1RvWF/6/mX/OmAOHi/bk+MxE9Rv/rFr/iT6fAEyWyMjbHa/m3km/s/awSC9Zn1opxzqbUFXRuxKONY9UY8lYOmPeiRvssH/qG/o9XHZr+5/w8UDfXGPHAuON4wyzWzobMSAV+xjb45ApoeNMW40yEfPRqT4bhxF+fGT7+0pQ77GT/knX/abPUZC2K0QmiDzP5cwklQOehBPBnDALIzL7ZuB4Xqi2PoD5rb+dsJEr9gZzwD245FPx3zwIA27A+oqzjnWpmjiybIga/5V3+Sbw9nNaOu2LvvEWbFcduYyCrrHEWM5FGXvsmX/uC8iG2uDbHfTVos+ODWve/9cf/RIDwqe/dvRLxr7gUXBfj9gVe/8Kett1+863JiDdCjIR/8cdy4yx4yfq4J2lKH/Ywf8s4/bbb6jCXmWHUhsz+XyFyoiudSZBnDAHLLNue44I3Wr+K43Ru1/zWQI+mc685uUrS6bmqNZutC+aCj/U3b/5trGDXRehrt3wJgsby34o0nrDce6iR4TC7GOjEh76Y+bSIK1Qddx6Hv/lWmScz4rmMxaZMYb8EObWRf4zS1rIHJ6qbOgwPw1NawFzv4ggJcCr+xVv+7nb5qhYZjLxWd4mhOSqsX8jVelRe6+tKx0sXMhi1e6rCH3voDdKZ7a/mwTVdLvYjYihl5MTd3Av+jhrUBf2WNVFXFUhn5AUPREI268Gg01wR7tzXDgx/MNNu7Hnrw4r73v+/ivve+56wPbjHe2uMi4r7H3uN/kOGOwCuf+fzFN3/7d51O/awb6mvBYyx5sq4hbWZpEyiqD7qOQ9/rpLIMwogZ33XKbEiMb+7/WPt1TrS2O2ld02uTtgKowx56b+5/WZ/YPna8d85sTnStm46vYeWx+COeydYXACNHE2PHThneC8SeR7hLEj7VqdOi6Q5yYKm8+q/jLd0G3w48pNmrHXnowWeDL4TuLI+cks1eFzAVpzlqPnRtMbg+ZPjw06FvNdBJ9q3eK58pbyk1LWNqDNAxgS+0yhf7EZkxaw1DcQiVc9DHq3ErnetC8RMDjjKj5hWyWe0QkMl9VofBReCCOZpX11L7EW1OOlvVoRuJM7PocjNFrg/aAAc60XB7/4Gf+4Cf/He/0qfxGT3uMtxvP3OLP9wZaL969+mYLmSTGbV6l7y6OUYcKq+1quMtXeZUbaoP6pHPMewQupcY/y15UGXUd3MdCtMcNTZOpeXk+pBdm/2/L/dRPfCDY5pm6uTcNWzWiD30lM51ATu2xACjxAiZ7CuaeI+ATO6zOgyO2gvmaF4TK9UX/UzanHS2I38SZyJ0uZkDSTv9Qiea+nAa/PClMupnL378Q4ApmBGjBEwXTugQk9FNXmCBt4Q8cTDBX2lDb6QrRXGbrKggwK7qidhJyBGs+xiBiAGxTLfPW7KlDsxq3EXmtQwen2xV17d7DxzXl3AO5dbH2Azb/BltIadc41L8GT3Sd57UjzpgkZ7hKR+5qr7RUt1Fk3rsF4lTWSuTS1S9rNhgmDUZyFbzaTrph/oaO3g6VpoyxF+ax0B+2OBk/8jTH7r43j/+Az8JX+XJv4TnbzV4LH/yBxf3/ez7qthrOJwz1WR+yhvR0Bvp1lquy9jsql71ATmCdR8jEDEglun260SypQ7MatxF5msneNdj/0sekvYe8vUXX0LCiypzBYv0Ip1TqJnqGz2MinrsC2LuS5NLVK6VsmKDYT+vRQG+SlthaezQ1bHSlA0wR/ufbjUC6K1qo3hK4+IjWnsUMEfRMxH2nVgC9+Bk3OnJYLOQO+wFakxqctBYVSLMit6h/MbOClbE71g+I/Yf/bDvgCw42Axlpmj8rFfNA3bhL3WIPcHrcgzbNAEBH8ZPvQnOZswByJgybPpLzKgN+WHnHXnsRzKtjcpBh4/MI+QYI67kZyxNwWOGz4HftAmsrhvoM3/oOQ1fqjeJ0WOfyGoM9//8By6+x062b/3Zn+rCeaMHuCvwyG/aRcmf/OEqNq3LKk6tz0q4k1Hm9M39v9StWz+l1n642rv/F8j9FP3l/Ly5/1G8bk7AQH127n+oZ4MNa2xM3WdOi0z1lO5/DCgMCMQ+HYKQqwfn18DVaWd4aJCnjZXiqmDpY26zAjFGxemKFHn4RAA/fayRHKfIG1boFlmHAD/0JQLjtqa2lVZbldEWfeEPc6x6hptzbfZdnYgH36SrPcZoIU+sQZ6uN+KTV/1gXHkAob4DLv91+bpafD5jpM986CNgmH/mQfjUJyMNCkOG6rfWR9RWtQsZY8AJ9tFnf+vi4aee3P/BPsW/ItovBHB3wi4E8BbF/jbfy5yPxOI8TM/0qdkRFadbK5wn9MBPHx2EDxynyBtW6BZZh1DWGmXXb/9nRAzx+J41rZYjPnnotX4YVx7wqF+wuzl1te+O/V/SXIZen2XY1S7Ztp6lXroPlgcBQVmU0rYSmBydIJMDsB2o4CgMQkeduaTYLj5pKA4jnoa95rsz6Bim+xlAaKyJwxigz5zBI81eXCrpOKoDW2JSkfLKN1Vvla8XVpQRAwakRcbasl/F0DzZRdugMMAjJvXCD/JLTNWh79BTM6dVtwgTT/mKp7TikGZv9o5FfenTh+jCXc67++YEuMA5/I/2TV/0qEDcKkq+CRAPY6IdevCop3wX9bKaHz7N/47nfsdvtxfTazvEhcCDT/xCmyuNstYmazJZo2bbz58zAjHWsGF6zQYQOheJwxigT/86P+SFl9o5jurAlphUprzyTdVb5V+z/b/Kh3md2HNvdeZaA6VZOyiTZm+suj8c0+zTh+g2CF0YnADBdoDAdTb0RS/kGUsV0R9y4B9t2INPPfKib2t3iXGVH2y1rcYiNB9Zh2Qv2GDlPjB6eQ6ADWDoQg1WaVijlURgk7ZNI3X8ByuAQZxim3zaaa925Ne5gY61FncoGQ9c56k/jQH8sA0rH6vdKifaLwbwkrkmHrDxYR71nTZGBE6HDx7jYWwje+FxrlqecIDiWKtxthI1mYt5wZasFeGYwu1iFX5HWmz9p3i9mq5S8cB0KWOVvDpM1kSYHVa1I57od6R+o8AEmlcPFbUMY9UDS8dJ9wBhGV2RuQ1Exvd8JG54ZuXu/7l/4K/6A+UO6yw3nNiQG/MrdUj+KDO1o5zF4Rg61loNg2k8fC7ixsMPWv+gPffgQX/Gwa0Xv3mBD6j5g2oQR9iGlY+97pDZX84rFaDfxe/aC4940LnD9z8PJUz9mP71518I9aiPjbo9q1LWtKureGNNhdVhVTviiX5H3mH7v19vkonmqbSo7CG75wB0hVVrTgKLHQ51g7QNKCde2ldb8tFD5k9jWpiK6Vz6pArWVG2qA9pwNZfEVD3GpVgmN+u2oW0DJwZ0YUt7jnnyxzh5Aaj66oP44aYTuY1xkCN9dQqDQR5gmwy5onke1mfuQnOuOh8waKZGSIu8WAvFE61G4qDXtcFBFHLkZrgZh9F0nbyaf8TRwevA9D0FxVU5aeBIY16NxaqJQpCpN4ijWnmNbF1vfbMi8YDPmIgdueAVNH6U5c5tVmvmVueTeV/C/sfdhrf86N/zr0D6Q49+4G9vvk2CC4DX7CFHr9nzDF790pftmwx/2r7OGHX39fkG7/+73/l9ng9yw1spd9uDnLBB77bc+sbV169rOQL06m2XOO+v/+KvLr7+/l9sct88qkpc5e2jb77r+/t1u4IyBtdFgURM3/79T6+Pf6aPr7viMzCbDWVY+YMFmK1GfLAVelysvP7vv9ouCseGMG7HKhDco6CjVXeXtf+J7z39ch+hB8/+mDKPzXlsoU0H1A/WXwOEnE4qTdvYtHTEhFHkrhgSgOtUvGVOiNx68PF9d57ceun2SHxSkXGOJg86LBz1tajOY7FZF/bNuJkpL4D6V8PBRAfd2SuEtkZF+QCJfKVlrsHTcTc3EW/mDhhg1ZqXvBQv3cY8AsJJw3FfZjvU15iBD331E7xch9BXeToOQuQNB5HM23AtQl1wbGAMz6IHijgYb9ZPtJrMKyHcDXKQ251/8ke+S/2GNZ+VCPwD+x+v8HEyeMu7f8RPlBvVXYlg2+x+JGW4IMBzDb7zhT/zpx92s1/Xo84X1gya8hqn3A0LJnUH+x9v9bzVvklxrz1z4aq+2ZHrF2kgl9z/kZeEvZe8aU+cfND+Tmn8Wmm3F2Nf4o7O7bog5kUhLgaxBhCHrt/MJeb5du9/zZ9zlHsIwci64y7zmISPGaSsmZTjrDHHFwDQ5qIHzRYT4cdG0iZrjqkkfRSLCWTQqaLhOVA8yCAUmEzqbxDuy1LeWreaU8QGRMTfxWhjTnB6FP3kTQkLAhhafqnXug4Iwv7qQ35gU14huS1iUTzGMeNBDhvmQD3ruzyJS7mZZV3oY9Sj5sCCzDC8B8bsJAo9NPphXI3b/ifPcUTAGIWVeZEH1xuty1n16NN5nkWTMk7VNXqzNmaTfib2BS6HD9iJ7XYd6NLJlRBtIrJOdS51fyAeq397kEkEt9K/sFf6P2K1+cd+Ar/MFG7+8A/6VyuBiecavPT0JyYPOdrj1fJGLpqfroGSFy728EyFqzrpawa5RsHk3irxqf6V0dyLVxRLvSjE3QFcDLz0sWfy7lDNPdd1FWBscWdtkQPzGelWXtHn8XSFx9oodjsIO2LqY6TxUN949Z5thpLfRU2OETRETxpyBjKhMxC1gW5twKEO+6rDcfpsBxmPIUiqZJ+6FiqYA+yM0Y0GQMSovZwn0p9v/F6wQqwxmELq0AcAkxnotGO/OB3m5blWXRljEbMpzTnt60LNde8ogttq3NdgZaX6FCIeiWkVv8poU/uKUeWjccXlGD3jJC/stTZd7So+7ZVfsCjCLd+H7JP+300t6zSqgyaqtS66qAu+Zvjop37r0k/+GgJofMUS32KAv/wmA+er9sMlDmYvWHZZeLP8cDHzvfaVTlzsvREnf0Si61bpiPLqOxSKNYZ3rIOyFq4iKKw3Xwf2rI1HfvNX/RHbXVwe2jLHm7Ubxa85Hkqo1oB47IFFuqy7hE65cXD3yf37BUBZmhFYbtpEEMJ0uoQVfEaLuZIdjghm/FShH/arM2VqSnFALpO2FM10I+9mFTrKo13to3wt3hwseKN6SggS5RJb9aFKl0xrPZKmf82ffpUndNpSb9CjRpvzCjz4pn/FEF/KHtLEEJxNvwChbvVDPnRwN2bSlvwHa6DaML7Cx0ng0U99vHDv5OG8XsxqNi/Kx61+fAvire+/2mcfwN+jz368+eU6qH1ON4gcHNz/eNWPi5m77f3yN7It61aOjczxjQgMS2bkv+7LK4wNFwJYf/hA7qwtdRysgWqE/EY5Um9LFjq5P4g1q8+In/j+WwBlk6YQnpCMyQFifDh1baOXhCMidlCIGpC11c9wOr7HZKDExZjvoZGH3oMLbxGzj0jDDnRjLngYuw/plQc6mtcAuoKVPCpRpnrKyxCCgKw2xgy+0j6M20uFv0AsxVjFtigtOY9wRjHBVvOY6Ax9mu4gSwNcYs050BhJV1+jmCsP42jdelqYsh6MqfbuT2KDGM/l1jhUP+nIUvXCX9ZF4mIo6B966okrOSHg/U784p//2p/96p83To6lfJf9WuAN+9VAvArCrfHb+eq0q2eLpIVj9YNf1OSNfOgR7zzc/c6/bbeDP9GOgZhb/MU85rwyfspUT3h4xX+t3uLJtcsErmGP+r2BDWsRz+C4aXvihY98rEWidUs64hzEm+sk1s1WOtBF29ofK3vGwL4BDNSW8/jqMwAZpJvFIo9kZsE01dBdjrnGjoEv/lUc/QG3ijUJ0PhDAxZP/o3j/0MapW9c92lc9PhDI4YPOu2mE3KvAT4MI35Yl6wBsaxPnrtYiutuoEf/7F1g/+kY4USKLu5kfazpT3VgRAzDwWdDoee6GgNp9m7X47v/wX+sQRc39BSr2KUNdEqjDD1b5kbGrO9yh73lAN5GLA6lcvHbFo/WITDFf41trSHKA7LaZzxG4Id8bueJDh9q+s4X/vTi5ec+759+H4QX4fTrGfXEp6/xwa72Y0M/4vTMvuejQvbn89JLfKRzUcS49f72T/z6Eb4KwCUPccLGxdALT/7axS27gMpjieWg8+prGr65PjVH413LD3cy1kuu2Xcj3P2P/0O/OH7+yY/64VqPGIfy1XWSulgfaDYHPB624THIjrCsOcwn1x37UKnYN1MRElNeBTlaHAoKGrdG5WS5+IokIsfV5hhh01iTAC90tUhUbWLzRRsKFF9jplx7yKO1GnCMfuuOR+QIW8M4WL9VHA2/+wAg4kY9+YncalPHEbevSNBmL1Fl7SAKbx0P/GzEZgxSw8yNOjSCDv7At5Z6oJ1T/gt76rGnPbVzrqs/KHS85qXTZ+0Ixl7yIQv9+le3lsg7XLHPuAlksvrNj7SlTu0jzoee+uUquZQxf6gHH2gaNq2j0aOccMfAPx0dGDg53/vYj1/gw4rbt7BRQ/try8KmzPARBGvIvgSGV92PPvvPD2AXoysY3vfYT1zcfPb77atzvxRfG5Nc4H9SP4aGvK7VK38Gpn2uh2X9q/gq6dw7GdNVep/7woU6nieRdwKoesb+z1yJhX6QN/TQun3knPbf3j1Gk/ZbANyI7Ckd9RoUaT+rWEgH7FdLypOJo4PaRpIjPD9AUT6Kb8YDvvqoesBUXOY0PoVV6zYe4VfcqhPpe2yUwQY04yGfXuuYfOpzPOhXc2A6XFSuTmy9oCNvgJes6tvGjjuyJU9sVroiy1rQDjGn44Xwh85g6HoDDcWEnox9XQk+xGyjmlGWPWwNr55Au7H4g53nbDwcULZPpOllN4FX/DhRPf/BX/OTdzfHioK4mTd7lVfa4v3rv/jLi28983sXX/ux/8F94K7Cnraqo9cj5il8+8n/Grw3PssHd0Le9syvj8Wj+iFHz/Pi2n6+o1sbzCFiHid6BVz1j5h8vFpBVxDI2AXuBOCCMFvE2O13E3Zjzclk3P/IzfUgVx3ORTppeK5LmerTn5Yp5N0cC177FkABSXkAdcZ0DCXS0APGAIe23lOfDnycTtb2Azw3JU6VT2Kgu1F8LoMdMIkLZsWe8Rxg8h8xFbeqqsx8sl5VLeNRfSox1pGMOuxdx/KV5jMQGEP/xIcNaPqJqROohaTOwtmkVhvA7HXzeMQSh8oSGBctbDAQfcbd5VdjhD7/iAMY0OBXfddxqVOz/9znwJ45PPjk4zPTk/j4Chse8OKv+iNm+kpAxMOmNHnoc2uKrtbAaPj4xs//il0M/Ix/fU7NUTnW23u1dXw4SCde47c/8xv+2YMe53qN8H39hz/8xOGgkG/83Y6LvMMB7NPwGYg1wPnitOxDuEQtLjWrm65ZZ8/W6SW6Pwbq4ad/1T6n8vBBk0P7P48rXC8FMe01f9KwQePYB8EDHXKtpauEvh8xc9Jdwv+s5DEZK2OoiI/5wRH+myJ7BtQFzOCZjPQZG3SoxxCpx7HHNSqIKgxow0k/EMPPLmyJqcY2irfq1FBMnnWiPW0YD8dqSxl4SqsO6LSVyQMPNmGX/n1sMtrR1vhZqxA3JaouNUksVVA6fILlmBhXXugfxIJesVcs0PABnIw/sLOjPXpp7jt5NWnRZY1gC/0Y+52JtA/gGF/miQG36vHeJD6s1rWII/PGWOJJfm9k8TfGsPaSNvLEXQH4/sbjv2Lfm44PFtpBgrbs02/E5B6CfvCXH7827/l3pRgM8hUg82BPXYyFh3m+lg0xYi3Eesh5ugbB6rr0uHTNXYP48MHA+39evhkg8+31jPHW/p+mIVgt92WOsK5iay7mMocLM6jAynpiHPPtFwCrSXeDVu00qqhdBKYbTlzt0ESF87TBWO3FV5c87USeZMXY0k2jIMx9VwO1HcWVcjfsNlBCp45xiKE8KlKGscpB84+66KnPXmVYFiM+eaOvsdEndTo8iwGtxNHVqti5BfQLvwGB3S0cspf6i7zzk5oL0WHRDncBSC+qThHPe9VR2jQ7XN1qrtdq0uuEDfOGnr6FUvA9mODhffTLai888dHBq3BDjzlm/hzTb/LJ2MiTKloWc5A1x9sBX/vRn/EH6XQvEtLQiIgn58nGeFV97d8f1xyM9leA9gFJz4c5UUfGd9k3KvDkwWvZGGddo+NtevtTaNvL/azW5e33frQHPsDJjweoJeqIv537vzrM48poXjhHlK2NK6eNQz/rKfb+LQA6pQLmnvPQeFwN5A78CGh/cBjoIhHVH6gki0k76Ib/CSZyY16JWQmmp3ziIU7SKicNWW2qT5o9dJEGzYjv/MiPmCZbxc+6sVdczhoxKUtdOGltikuFvT2xqY+x/Tk+eejBt3h8LiQ/iLpYKh4UtDEn4yUW/GEMPdqLHthdqzLadEocxJzEkLHmmgqsHM+wqk/Dw/vJ+LuM9uJHnr54+bOf79dq+GTMnR+JB3I05pC1TF6TR4Vdd/Wf5m3qq7sQaiC+yX7EbqfeaY1fU8Sdj65pfkbf/K/Pm2Pc2Xn52U/b7xb8ud1d+aq54prUeREa4pjTFpcz+hBtBNxsOn9g0kUq7Cf8KXr2ON3ci9idwGeIXh91EgLrcCdp1m698JJd4NrvBKDBJGMEtjFqDukQis0An7W56xH7VssPnTcnCAENa+Ct73/fxTftMzHeVjE09ji+kEnHPUhWn2YmnHuVetlrHYLe2v/+LYDqtI6z0gT3yURobEuY6Yy6VNnqoVsfeUv9LOiSfC7ulFHZ+hKb5pKxifqUBE6uG/GtBpqj+tW4SLOHvZYOY4cXH9DF0PTy19SgN2rERY940NDbH0aOqjIX14ui1Ey/gPGmOYIR481aQqc2vSLuYu5/dImWOm8VqhsHVtX3jJg3+86wDTwPkKZzMCfT8XpqTYA9awf0Hvi5y3n1j4Pi+gBkFYi8u9owJsZt407upag5xVhtQWfzavsoa0jd1JkTl/02CE6W+MojfugHPy7Dds/f/TsXd7+zfYPhsm7JAwf1/84f/9/L/mNt4dhofH3w1IaTKT7MuXVidOyY6/Rj9c89UGQ5R4uyUTHH6HRqU2c/gc+FvGAfPu3W1Wg9eFy4Cb2sL7hex9d8+1tcH7SLLdgdaI7BbwKV/HkMw4f48G2Wc9fCve/9iWX/aVya8yjmGhdtxS5rKDzkhpYy2jVmjEwn8Ds94kQ8qP7+xiRuVLM2IVl0IFK3oiOASCBFg0XHJFe6xK74xGSf4AvRFWJhC9UKmwwPNXgjXI2hk/c4nksnDw9pv9RPfTs9skslIXCC1WbYme9BjHbyc3OEDn3Gxp7YMU5slcu+hDznELaqRyyPqzPymBPb5IrhtOCozCElT8fgmD39Ckb68hBbLMrrjoa0Y08861exQFb1GEf0b/mx828L4wQxerVNV6sYcFA8tTGfS97/l3Xr/1u//XsX//HdP2Nfz7K7IfZWhJ78kfKr/+7Lxv+cf1bha+/+6fHbJSfU5sEn7EOcWXAA9PsfbwGc2nAyPXjyB/hl73+elE8MHHuo2xNcO4rnNXvj9j/Xgl9g5edWNMB9tD8s65HBhwFrzlwj2pOGK9JqN+ChYv0xah0nzQ7t//Y1wLX9AY5MWtVMz1UQB0kkpwm62hovE1zprnEbxBpjpSmxYXF2CzTiqLyj4wic5rsdCBxjlEeJIX0hTok1IZVHmv0IvwWx+p9+NFfnEQsWoHVMlMrzcRzw0IkcmM1HyImxtzd7xgrcpMO+jtfrap+jLjqJ32OnEPWtB1mBX8UishVpd7tw6/8yvvrnP1qjt01jHUzjkfw8rtBfxbjJ2NhrFV9wvJ7wJz7x63f46t+5DbfhX3jq6f62dgWV2F7/D1/1V6mji6dqdmiMzy/gVvDSWJ9YPBwuCrupW8+/1HSBIfEnTZ7U9BA418bm/i8XMYcwR3L4uRP2/6v2dsXXf1ae7TBKZoOHub/5Q0fc5dHPYul+4BxyTuGTPPqHLOqq80cx9TnHySeh2MZbXjYWAfVH/dixxRXKQ7nJPKj0wyNr8ZDyhZ94Jkt6EQc1wCNWLaJZIJZRkZJH25WfnjGPB3pWkeq74KY/wiJHN2U1QwCmYpFmT/tRP9G5xYWImDQu6rNXzBEvZ77EiKHb2v+KD94Qx5W7/7K+O/VXfqrfQE9cD6XUOnSyPhgDhzFMMFe+qR94sHe/BoXfrz+34dU/HvTTNY1NaSjVeNSw6qqs0Fq7FFkJWcWh3BR9racfLOiLiwfs+9TnNpz8871hBaOvQd6IBX+4gLqMi4Dx79SjKKyKBrafvvcn39MukFAuxSLNfgtyopPrG3VirYAz0d9yMZO17O1/xT/CR66lvTFVP3UcgSaujbEOsJdwB+nU5hcA1VeN2cbuty39xZXagaad8GHntpAZ7et3QVgosdlT87wAqDEtiIWyAOA8Gx0CIPidPBWDSFvBUJ2UI8+WdGqabIgNm1uDW5vEYowcq78B7X4H/I4VmBnPDDv0fPIAMNMjuMkTk7xDfWCmj6rP/IXvuvj5YWv+PzAktimWG5jFANPBgEcZel5kVGzq0ChwYZv2xvO5H+kWuxyKH+eVvKi3WWP48z/TdvvorfPYmBPANDb6Ji9xvMLQzrl9y4/9Nz4+57/ViYt+Ccp4MI5YsrZFd4mQxpPeMLvaEQcA4a+TV5iM6Zaf2M79MBZO4N9+9l+Z79P3PzD8mQk11iPG0x8qsvp0H7Y7AhOqfDDS5vvUUdOc2+qDcyR8193Y/2fdAKA/9NwrOe+xh6gjMWGNIi7N4yr3Px5udepc3YMP8zJH5oaef5Hn5t6ADjG0LmoLvJkO/dJW9SKOrG3o5gVABiYgVdlxAygTUyd0fGovvgGBmDIuYlZ/Gg91hj2OUKMWfF9pTT70W2JbIVHOvih42BNZUW3Dma7w6/xkreBsVCdx5Lqhk3aCnTyxSXKED2HY09YrOyg75YlHwnAh6+QzX7SBT+hstOFPW1NfcnaWYXnIwIRM/0zBPWlO6rtiYQy56oTfe465ZchYS/+qPe2va/TDONhDKWRZW+oGQPLFpq4vV4Vc/wpOwO3q7n3sPbv0Zkr+qu1ffHKJZ6bofJ00VWx8XASc03Ci9p8OlvoRDz+8dE4D9iNPf8h/olgvNOr85BxiTuq8lLhcN3TSTnV8oZ8YdeB6ZQdlT38V3uwg6+TACryq7mPEvCU3pb37Hyd/PEHzlHbjYfs6qNYPIIztQHwrOwZgdphj/GVNBGtVWsoYB3vghazi5AUAdHxBEcRtYhUID3oOBl7lU+ZKh/5bhb/gauCg1U99H1ZlA5e5SfIGZVWKHAfhLLZmU/OlX4tvpQcXmoO7jHrRznny30ofskFQsA/dnEyBcRJy4rEvfjNm1TWd5Bd9dZE6PbOfp2JfbXzM2BRnD612MX3IF5jVD+BGdUq9Eif1XQ6Zy9k7GFSW+rZRGxOr9tSJHu8Znvv+/2tf/PLFa3jvn77UB3nsIdOaqa7QmXPwsm6KAxnG/BN7J6tulef4hj1K9T05OoXAHZDXn39h0zTn+cD+/469D3zqwZ8B3PfeH1/mQ+p9Li7x/ULgN9uFwMMffvLirnd+H0V9D9/0z77MS9ZFdU0n+dN69a6mo5m/MHA/jG0KMhGonS1Fb8YD5hL/YpvreGEteiVO7KtT2j0//F8tc09M9luA0BnpRV6IfRS/JdD4Q9s0XjxrzRaufQYgBCjc0JEo92ScnMwuJxN+6wm6N1oKL+e2btIQjyalNLAwpk/Fhh3+SpvmlLprG0LQNuNLG2pYb+FQT7h9DiHIOmFMLOYXefX8lmuHiwFtVoIBY6KLqfIGuegwl+6q2WLNGpgRdQJhwVGG2aieuHAtlanZLhpgrB8PVMbDe5q7cBlbYphXo1c5qtxVYq2Az4Sow/EkAcW+jO/+44Tljf6L326tQTaLL+yhv6t26WepRfrCojpi/59bh+62PfIY1GKaU+pGHhb6K5/9XGZ3CtHlI/U+55XlKA5cCOABNN/7J3/odwb8zsNIETyJQ1UO7f9RLdX+IF3WUw1jOi8HgU0BYDl/kYnx9ux/v/i2H7O6K+7Y8M4Naoi/Wy/KsxH2xLJTR/d/Z5J5BJfjZVlKrmLJCaS+iEDmniS/TkDwb3KB+IR0haXloIdTAtrXim5h7H/WmbpjMTDVpaxAHr0YMNnAUGyPJ6pGOobF3RK7Y9h/LKaP7UQAFvMzH0lDjgZ9Yruyc/O/2cG0wxH8NCSPDM2PvMvqR76AHXyP1fL0X8kznpYoZvnISHoEN64xKCJyt5ZzUWsxsuWcuKENRjqQkc8ePGstZyQdQEXetFyx6UA+00llIwzPsSOHc74WRtju5Eem9N1aAz98r9ZmxL/KXbBWZGA5/8T9f489iKX/5PzKyyYDr9TaQ3FCzfPQeTM6hisgnTPoxNJ8+TOfv3jIXlmf2vBtALRVjY2HD5jdjqcB4rMB+MNdhm8987vtYVAexYH/tAZQxZyikT/Yrk3h1P8HgPQ1gox4fHqgp2sO+iNbU/ZP5Nv78ffYsxfwAKYb9hVMvD+PW/TnrLdRiMq7C28BzJrFrvu/ro8cM0frc1kiz1GuXLQTn3v3vz8JMDEQwJ5mAXVBwyaC9GlGAvbnNIMHNmnqVx59K1/pKide6rjHZTEnPwxtnIWljBjEtnGg9PFSjl7LZPpZi9BZFR8+4O+I1mEioGpeMTHGqy/0tVXdKue42prPAZppj7mE8RgO5cv6h1GXr8jSU40tnU2Ikb7g+nyoDmnT6WIB/MiO+hP3HZu60R/1laEOaBng/e9hQ6x8AIoqhO/V2lQd2O5phpU1og3xYW88l4MOfldDY+OV1znN74CssGO1MCb01IEzxGWda1EmctQUr9ZPPVH4+8DAF0y4RQz4zjlO0rfjIgAugIs/5OAfjNRvhyAe1gTKs1bjnukd4sc0bKqx/qGU6wljkSXURmyYL3wLAxdgt6u+m7kg5O5roEWbsUdf10eOQ+5rlDYClXsKvIHcVVG7I/b/+jMA4jABK8/GGXSVaZIaJGguQvYqVxzlB43ks6kczDomr/JtnHFXGcHFT3cbnHLtQ9cxacd+oEeW50I99hRGn3FCjtSr3misOSlddYuvzSE/xbupVISH/CE2jc/MM98ClUNgFpuUOSHroxcstVN70KM4jb+KJeycrxjVz2isfmibR7WRwT7eq3iv0uLv9sWhGkW+aVPyT76GUHQoWtVoETi1qpXWwTDvetfk/WviHOj98w/UYV05Rg9e5ds4466ysD3nA3s4Ed01eiBM1PD5D37k5E+Za2pbtH9OgB8Y5A8QTeZwC+cs2SF/g7nJeZk5BmaZM5zwH332ty7+1hf/jf+OxBt18p+F7HzEzHqU+Gd2qEXuRdqacu4p4pgs9QA2qFHnI7DSxsbdBcBqEhQwjDvAMnDgLT0Gzr7Y+7DYEzOTH9mAB0z+4YxZcDozlSlNHPTG7+pR9VSXNA7sq9zWJ6bMBZgrfYBJc/mG3igumFc+Yju2AWMd/nEoNQ5YO+4AmDGOagLeCIt4W3clcEU8avSjuE7QrWgAAEAASURBVEbnBhnZGO+Q3M2YY9yV4TqG7NxXv46P/yz+bo2O8knlpt/MotDUD50OCzzkQB2tUejXTnOsMh8Ty/pz3wZ57Utf6V0Am39n7H88LfCcduOhB4r5ss7xZMJvPP5Pi/z2DHkh8LZnfr2tN+6t3e6ONhBksR2tG+4NsXCSZlwnKgcvsPBePU78jz778TfsFb+GNqSZ42D/D/ULc7UXVc6aWk06PdaNcrUBHfK0sXF3AeD6ZpwHOFNQ2magQnZjB2YQnWQ8SGyK4Q80FwJI4rGgs+Q6uQAQW3tigqc0dYBV+TZexUt99O5fGRs8Yo9eXUt+7s/H4lvk7o1YxfVqyKkr9vDhfoij8uAxb/YrbGUUe7ptKjIybMdTfRErZEdDX206IUQD+YgHO+Iw98Dq1lzBxxCrq9Yix4oJ3MA+hDlwM2VNb/+rBeMQXsYovBVpdqnHOYKS57E9Qcfs/7vfed5bAKO4fT497zP3/wp8P6O7sEEspWR46+I/PvY/2636+Y/e7Pd2WBPPu3/Hc79jD1yK350o6wJz7fMd69RreBj2gEYkjfXTacqIa0vjEXFnJgN8DfIdn/mX1/vEj3hRT/75MNak5it5TesODM4R9cE71AZ+cl+LbbsAoDJ6A8+DlSkqbaNmSn0BWoEPdFxd+D22SU3mvLoQpJCILxuwBC/5B4hVrKoPvOoj5Kt4g99tILXVuOkDPMZc8uxwTN/9BV7+KJCkT8ijeo3P4oCPzKvmHsAuD930xRySkcoLZ2VjIrHzVDSexbKnaIMe+tVGxlqzDoQ6W/ULP7k+aNMB2cD4WbOQ5XhmQ4xDcurt6jfWP/2wdoaXMVZs6kR9VU9pQ2iW1BecrBl5Ax0Xzfi0O6YH1gl4q1jVZ9mTKtpD38DPA7NhDjgPwsPdCzx69qouAvDWxENPPXnx4BO/0MdjtcP85hyjljVexn1KH/hpitrKfPlq2uMvbPDT2Y/Y1yBP/YxGxnE7iUP5jOTgjfiM02TdHJGPyyupZ7JBEE/kiSGK7QIAylCkERWM55slQHLjVD34g41joCtYYe+wA1vnT/5LnyM5sQRf412ZhN6oEKkLTMFrNdkotBl2eLRlT2CO2Qdf8/MaMifasYed38p2LXJP6xlD9cUxe0U3nsa6rBWLa6spFu546FhpYDCuijfTg/7MpmJwrOFW3BjnxRZtRM9rIGOqrPpZXB7zSvtERqnnCGUj1pxP6CCuqms814lcOv3iy1elYwCqYIW9m1QfBeeoIbEEX+NdYYVet1+rkidSmfvHeXdGYnJrjqOH3tfsh4te/MjHruxCAD+65BcBjIX1Y3oce68bhQp7eykiMWF6xv7HnQxcxNwxjTWuAYOvf5BzTN0Y536jDnqtJ8663ZgA0m/Igb+8BTBSNJ5vlpANNw7t0ONvtG6ow7iQ4M7mPrf0wy+L1eIN8OrX45NbnIxB8UFXOyt0Rqy6tPc+NCgXDI+N43g/uouXOBEfh6vesGnH3hcPFemb41nPWCivdnUcesP556tCYtVesbKIoaQyY3VikXmuGDNu9qjl7P39GgfGgtmJK199FTuvwdZ33YnFGDmmQ/Dt3zlNnzqWtTkKsFW6m0/GqzjGa/upBdzpU492ntf+/Z8nSuIc2d/FV9rhl/uhxRtgjI3YGNt8UJdsXRc33qY/6pMa+wnOt/h2fxyX/f9N++re19//T9a/6bDf41GauAi477+3BxZpY8zk+fjMRdphxaDb4MYrfjuxyG7ae/4PPfXLRLzePePmfHPMqMHnn74FTH3ohbzbbyqHTuCeu//9QUCrDcEg0M+aBTBzzsAbrkwriyHJpG/I+Fd9Up/27EWPPhsrFu9AD8XNpU058WGs9Agf8gRYFAg1su9iC8XkTfxlXRYXHhvt2Hf+HEvq3dnqYKHdT8Tg9P/P3vvEWLdmZ33fvX3b3THtbiA0AtrNLFgCT0gCeIRHYCRPMVEURomjwJBIMEPgZAixZyEKTkaJkGMkyMCRHSmKnEHjQeyMHCnKLLjtVhL/6/af7nb7XtbvWetZe73v2ftU1ffVd/t2U++9Z69/z3rWetfe+5yq+k6d6o0cGGln/jPflraY1CHHe7YsUO9pSQLOzI+h92zgungxbszkgmPree5/QnecY5d4A/YaV70b/xpS7zavF8BlNmNGc143Jebn5sc8Lmd1kzgcztvmCcLnMXnH9Whs9Pm6n7nuDj72J9f3ELhmxutacT0nIaN2X0mOj7n1FxYz5wn62Z/uXXqrmu2L2uTwB434E8V8uuHb/qeBT//Y8WP0eT1L90zWL8efMIE7UOYMv+dtWSk9k43iD8SfW37TT87cKN+e6T26AvbYp++1nLVBt9K4jvR5YYTHDDUz81uSNPUmKWXc//ogoL4hIg65SOvdi3uu7Gpg5i0n1nX2JnY7cH3ST2Ldy97ECbYhxMaw5B8Dk20Mkse216MuT44B4Su18Ty26nkyeh/dSCl77VM7sOav+MLnHGTT1nmyo2X+qH7J1375YU/sY1sLjhjYs3Xm333us/Ppl9nljPq8jH10rHNK2bnDfZyXAT7BEb3Zl5x9QNE6xRGB132OGsJ7P0mRx+kbeAXNI9r8y2Mz9XX0j33+j796/xe3Ty0bddT77MlFCtOzjF7nGW//dk84XbJ4Z97ZebyZ7ZjL+7/0pYXyqcbHPvcnzlOoMecAap+DMUgeY6/Lp/mdV7j0nn6M7F771KbHV/HCH7/D/2M/rt/j58N9+DfvN+nnqlG+gOT35vli4945usp/0N/zf/P7n99muPuHkB5sJufKB2fxWxjM+IP4rIf8ArT605NvvCM+5vIHf/wfPILxAQjX1Fw9j+N56WbuEx96x7frk2tZsf06In/UkX4H4/t8/SCgvTCky6qB7RsEI58HOpKWJm7jbkQZzA0IOfGi209NCwfh8eLnHJcEu6/Zr+P2bdyk9vDpYONfau91lByH2YLrGLvb+PmrXOUntS+f6E32Sc7Ro4kP2TERxUF7btYDaK1mojxq+QkRvWKSZTa/8y1v+syay552zG6b60S6brJuAPp8gMufarhlyjw7r6ezdx1Lk0Xt5thi7S/sc3zcKH9FT58F4Pr35NYPUM9yT2v/6SzrTJ7F5FvOdFIvtY/47/3i/7WXfpLNn8l99SM/mjcLtF7U29fs13H7Rn98YtybvMHsG7yzn4tztuA67mm38Z/c//yZ59/9pz/16hPx4T6f/Ks/+MYvgi5vyUcJ8+mEeiGsmejc0x/3/5us3mPeqcdZD9KOVYHd3ur60xU396NMPnyJPfpvMez34SQhdvm3FSbwjt7845oC3v47uVchPoum78nJ+8DcFr6ZVwFz3p5pwF55/o4XAa7uGQdnjHLKKAwb7xMu3wAXxo0I59Jszrpq1BvQatPOEf/EqYeLQ9VTHQ/P8iLlZq/BoR04D07r5nhsP8Yjg0N7Qd38udcTUu9n4nedtDNc9eyaOq3OrZs/ZzvqVo5nD7zznXsm53ymvmOJzV6nbqx9ZzweXGCu+pq9izJ4jL2JBeDMpxNEH+7BPU28Y9X3zvP7//LNvvuFVn9+tPhPBT24D8tT4OYc++mLsX3bOSLVcxdNGYXXbF1bvgP8+1/80hv9MwDfGfJvw8vzxLaVxfQe7szl49/3by8pTzX0E4Bxyzw6P3rq63Amhf9rX/j5+OeB/1z/PMAXBc+1+ELn498bf8KWxWlN7Xjxb4cDT5Ej2eef9KnvdMR8joiV/rrf/fPTDT5zwS/+UO73If303EO/+zcVIHhgNf+2z/Y/kH8bjtebs/cJzDndJqWHHtyH5Qm2/xhQxwC7QHxl6gG1L8JNTFKda+GcFxzYQHttTYxLJCHO7YRQhi+HeJPV6O5TaaNvI7b6cp99pWvc0rxJQhJ3X8aO8I1qnol1/gD3RTJxxIU1yZIwjE094V8QFVfN0DGX+vFGpbaXxLWPBbPXtB2yce/cfr0perDGu94+B/xnvs6r3gLT9ZzTGJOHrJoLtsJ9LVVe24pHHfVR16J7uqoxSlp90+9+4dGf0j2r6SKnvUfQ/W44m4qb9y3f/6c/Mu9GHlY++UM/2KB5jtCnLdC+b5zb/d+/K9+sT1O+/nP/x22Cb5lZ3/Md6L4OJ464sPnPRn6fwHN9IfCJv/T94qfEUp83Krrv0eNjVf2pa+8xZHO/xv3/Xnym/1MX8+k/78w83cskwjd7i9hz/InuWeK07gKghXoeOfXT+xForK+Ri1xlVKxzTOPcsvn5gkOHtC9knzx8IrUM+GhAvzrlPDPdeYd28xp7Jne+eVVG7cmx6MEl+yY/AqPn07077h/L2bakz6lje416PXhOIHjl1Nk0rniE3XymvOnROADkT9tJZz7HdhnYnl31sz8xKsWxPT/s3uuMnfYQ186Z39fJFpu8U+8y4LecjpWij3M+w+w+7y9kz6MwbS/kUZvlvMl35ku0jm/63S8kfAf8Hd/3ZwdrqdQe9bP3uu5u0efz815C9t7xidcyyFwn1Ne5/7/6Mz971tGjffw7tn9k333SCw/69T4m4+h5xvlO803eaMaP0r/+hf+9K/X1yuipqbp1HtxX9SLs5msi+8vhNwzyHe6brnc/Hx/HHPw9O89GXxgxxddbvD9lzvZguTgnF/c/P+Hx+T04Htb4sb/XU+7/T8SvGj7L8hy3c9fcjofs2Uewr5nQNX3jOnFTzvjJcV6f27rutnTMi2/JBhIyF0KaHEjY3fT0EyK++XCd+hR46FCbMKd7Ik3FQhJDd5/GgvFyzPaZFE+Rug5y6g/k5RNQgZzXjYZ/1BDWvTb2rEDlTSy6Hxcpct/h5RwuT0JXWNeFcOi5V5+E0cTkMd5ywCZXX08Rn4zLjJx7xuVYSeVtvlOzeq2r7BSyOF177hEAfnyOd1L5y34/3pD0puv030ep7Z66h7N+Hlnd+wG+7yvsPl9dK3l17jafIsP31Z/8qQS/5pEXh0/FO8T7QlGvQeY+R60u4Vg7UuHX495kfY0vZlRfO48WOA/FiK5lGcaOda+NrZRdgIsH3+H2d7k75pH2e9+db6Q8u/95w9zrLv4wjj6Xf+7F+7Oc5MPX11PE+ZO9T128wW++N+ax9//HPvfHnufTBdkL+x57yj2s9798cz7hWHrdYvD56tGM4L+pIZKsT4GOn/UD4DFfAOyNbPbSdHLmccN1aPj7ZLvRXXZSKLHfy8V36yy4p55eHbuWcSPWg3L94Jn4qauGOCbB0M2B617PYw7K9tldqA6C0x5cC66Nb8Grl4OrS9Q+OYdOv8kz2IAr2/4p3R++mY8fe/oq77ieCjP5Bv6yz4m/p8M1+7upfyfZ/Z9B3KOlMfzqjetFbP7bpCFPlfM74J7HvI5mD1N3H5b3Cs88cJt9nK+NZMN1dPg/+MpvxRx+vkOvo3znD//7x8fcwv0a9/+n4wNm+InKm6zf9Rczc6Z1y/G59XyE7bLGHOSf562AfU7DnrrPwe/8tz+xUD7V4E/lwnt2/3/w5d96Kt2CXz5wiMjcLzPCnr7KPq6nGt7C+rDx/mP7pvY4V2/6BWB35j1ZOrDd/3KP+v3qbjxycqDfsfv6mNfRjje364a8+xMAkRo8k6dv6mo6DrvPuZbVpE42WDc6pDdkKczklV4XSeQtONcZ0hdW44iZb9R1ivHYU1cOec51QsmFf4vdNX29D95Zd+rNQ98DP2uf4p3onJAHbl45BpY03nPawjfmGc4cBmPvPsfUyp1+Anf07aSQV3xAiM2+bE/foMoUn5QjoBk7Z9ZDn/aRktoW4x3Kb7r4Dvg7/6N/TzRuafmic6vZ10eBb3e3diT8xqE9Tt/USee07b6VNjFAow9+7e1Nlz7m1t/B9yBWVl8vPQPC0ScvVHwh9SaLXy3zFzILf5F+LH7UzkfYfvZf/I+vPhN/qe/0zWY+GWN27hmaqbvX93/zy1ZfS/Jd/sG73m+/93++2R9F4qdT+iLAnY19yYW9+4xVKxzWnhy+J/0nmW8w1JrXhu3wPcevGqre1X4I7jF6WfqpjndcuWd+nzPvITBN5euIvI2rr80CAz2+ABhg3/gqZGbHr2wKsjivkijS5NbBtt3Y5gMwdJ/63myEnSYuYQsVPBOneB8qq2ovuFEvOTOpB2UO92171rYPea+PnWPmTd097fjdrnrLzJw7+c70M1zws++eD/VcE3znLGfhwMw6/Buic/E73xyWztmxWwnDugdfHB04Udy/ayFdxz7SwndzvouOWfhecIWeDw7HS1d/ruGEC8nnwb/ph+FAzXfA+YJS5+hOfffu/dpWiyPPe1bcs3L8yvY+uWzQwTunY3ViSxDnhdMvnoa9juTF5jM/+vdOXlxdM6X3zJP+H/6Jf6Q/I/s69WZO/yg+9mP+GbfuF5rPfuGfv/ojP/3fv+InDzf/jLPP18n7LMP/3p/5HkffXAY/59393/y1xdeowHfVfMHz3p+ON/KxL+/N0pxzb8R8fRyKkQ9KvijWTOHk4VriLWL7gk1/WfAn/9GDvI8B6EOk5l7uJT0WZ47Rs13aW/Dk/fx69/87v/Ldfy4yH1hzkBN65Z+Ye/pT8+dJLN550d4r9eQYvfHmFF7MPHx8LNvoD+2B6VYa8LvrjItas4e7BE8MnsxTDGd9XFE/FvtY3FWd6X8E135dLPbc99SpYe6QnDY/IbbffRhn+zVk/jnTf+c1MteUb/zi//3q//8r/8HhdG+WEVn2fyAfpw2eJeHKv4DuGJXPEzazeK7Fu8C/9jP/mz5Rb/57ME/23xG/6scb/p7rb8fz3T+f4He54vb97M/987tvMOQLQc7hN+K7bvqFU4/4hEA912z3Py9yfEDQZ370797lveypAr8TH0P85fhbBDerzssf/cX/5bXehHfDFw7vMTYU1u0T4q/9tb9xk8avuv6bP/3f3fgfcjC7X/9rf/PVN5hfreX6r3ue6+5NZ2h+5OU8J+h1dN9nljvH7rdtGfhl/yP/8gsAJyBZPm0teXGs2OBLHwOOZY4lfmKc4a58pOtJWZuTdcJ4x+UN3IHcDXmoljv4yl+4s33tFJprzfAmds8xaj+5zsi9V4LYo7h3kv2FlviZb887sx/b61PO9Rkn/c0n34f6HRzXM4r7Kb+yeMUfOOHvtT/HevDJh95Y7OERy/0jWR5ly0fe//xu/UPf4VPjD/3Ef3n73fAj+vxmQ34tXmiW/Y1rwL199l/c/wLAuA9b/sYP/+1X/ZsYJ33zzxY37114S01+6fN//oaZL3T4IuR1Fl8E8JMZ3mszP1rZXzzxE6Pn+iJw9kddXQ89z3ficxx+ZEDifuKW8nPJlAPVN5x9zWdHyDPfCC8qWNZ2/19+AZDos6O6vw14I0SqMT+J3IIf8OzNmnvf8G6f0WrDNfQt/rj+KteDmzWtW278daZvvIvjMndB3Rju3dIzF/A1OZvjMflnmDPfTeev6QhuXXk+DzuNr5Hdf2Y/1OeMTx0ubJbrnfUTmL3XPk+ZrSNPRn8kXhyQz7H0znB+PWzv+TnIm0M7a6sVzwNH1Oc7bf8b8Nl3d51XCj8e5+/WP9csdv63YfPrZl/++/FphJfzzll9VL8A4CcXvGD18j5KPvdPZrrOiXL2BQCw55jdsUf+vf/iI6RPenouF3s7u/+fhb/Olfgh9H149rx0UvB4D8BJsF0UYUmu30FQmMeyqnj/+NRB4yx5mmzdoJJzA2B42LfZN/WhMK9k9rzjbvrbWkgzcl0Xx9T9KU3Tt3BErvtY/MM4yz3zjRR6cO+WS1/38tfT16yajWOWHT2UnuGs4T1On14Cj7wbzTkzcOZzvPe8XWuO8536Wf7uw176NMGQ9+LEHLccqVLD3+elYrI3PD8W/Z0fP35nead5qs2/uerdzFudG559JjeAzWG85HpxcD30NRFpvIB/5h/+Xf1IP7/DGviFhxp1X4fGk/RX/v7Jj6OBfQQX/f7Wf1G/i38579i79/wR2wP/THK8MNIm90U1WZLvZJefbrztPZzM6utf+IU3rsoXl/n48F/83fzZ/e/YPanzUnOZunJ0zvJk6ejr0PKKeMz5/hcAAEeRfuIbT+5sTJsbpEvdzZ8X2rjSIl++mXSygegke3E/YIpG9Wc++uSoHk5xYy87xWJv+1BMTRXKcaR19ei9LmzHno0teXOS17S0nBPWPrslf+Caxj7LCuRs3KtlZ7VyOsM56wPZ2qmy59DP7tsSe69b7w07y9992Gfb23EmxX9Rr/sxdsqznBNffx77zH0Dne+6+bUzvTHQ9SzNe7VXxy3J42G85bhnuB54vPuZT+s7fn6isfzYeKutmTUP5+K4//UJbs/wATdu/21JvnDjR//vf2X8MSbv0zOjOPvsvb6tbl6Pd//ti6v7f8e9XrVHZM3rbMD5ewjfNsvXyL6hK3/gdF7qGtLTlq8nz8u59k9uxywdG9jLLwC4UePWv7iA1YrpDulClnt+FM4LLQID0z4zjZhcYc9BdK5/5xeQcyzNpZB2cmBGLDa4WOfGeBI0YNaBwkNFWp+YLe9mz5Vz4488nYsLrr37ZU7uw7UlK+M0pmIH+qwm0Sv/kXmqLS+YO8dNP3XOBlPO5mK+lX9aw9yuaTm4/emHS37FbzvJwNm5akrXbEeex2FKfe6fAkDKd968qe4P/If5K4J7/9rj2QxGc2CUd7KPec9Qi3d688LPTx/u/gg/uHpmo377oj7/jMEXAh/VxfniDWbzu2c9hXhOSOtjjx+l/ei7//EGuaW32XPo/ATgOX9KtdSahmfWvrxqqc/Mvx3W2XOL9jWvmdroKXbOyHrLkwlV7N79v3wBMItyU84b84T+1tXN1IvMvJj2jRk7vptoQjdOPlTGIv0AbP/Upw9/rN7HSSwR47hhciZRd+5FfVUvpM4vRAbVjeq8GXA981sOjM/FPD8Kk8vjJGekP6w6P+R+sdwkg42Sy3L+4izjKuZ9N2xWRt+LDHJzbhzMYbqaccdP0KBF7Wtl+BffVa5rOG+3d254CvPcPwWgBX7kye/H87vn/DW5+cK87Mf9hpzXl6+5EW4VLv6aHF9k6ENu4l31k7+BKNtp7Bo9xz5LncZn3s+Pc+3AN1nJ7/z/xqvfi1/h1IXmPTz2/v8m9095/dPF/tkLvlZD3p6N+KIsfioz30j3NrbR14XI1/v/Q/spxNvY2OBc7rtx/+eW18kvWADbfTRoU13Tl/DONe3lzwHPgBi4MHyRm5JG7hTzk9pygzg35E2Nq51FbWFnLV+og+/xKkQPTTEgftd31ep+9zlQ2P2cxTwnS/BnOPwsYvDdwXQvmXEcZ84DHEdSaRMfPMuE/Bndngkp3WfN0zMw8eTbfDf9D+waW7owyyHnfg/v6C2dK2f4XG9eU0Dtz7TjiH9f92pP7MSd8Q8fLyw8yX367/2tyfAsOl8I8B06NfjVOD6ylj9GtHwHW5Wu5sWLO28I4419fMf/Jn+j/qbGesX1nvn1tPd/8yvP8nv6TfoGCvP69XjXPL+u1/e9r495rl3D9/0Dl7LhH4bML2Dipxfzu/9xHXJvL+3W/f9+fGLjr/3Q33z1h38y/mkprqe3sdbrYulCv173yb/8F3UNvo3aOyc/deB6f7Y1Z2zS3bfbO248FfHF0jKvPde2ZXDd5NQ1u/4WgBKovJ4A93IqyQG/pJSPBFTeLCccjiessYHOmj5zzhtwxp1E3Fj7znCOWZ7lEXtMrjhi8xpFDafzxnxc66ly9gbv2a9lTcxT+OHzgsMLnS8GzmoZ81hp3lnrKrfnFgDrllc5z+WfM2QUHs3UqfU6/Ww5z/W5AI/ZOi9k73/5y/G75yHjE+V4kmfxYv/ud8VHxH7mU/HX0b7nFX8w5vK7+0cU+vrP/cKrX/ur/0nO5xH4BRLz+Tfipxef+k9/+Jvy7m33wl8t/PX/+O8cL5zbeTPuVsbFEv9/9gv/7JvaP30dX8A84hP+2J+X79OwefH/Qz/+D97oC0DT7vLqtwCEi374rP4P47dE+OcRfgL1nPfi5d7OriOeV/iJ0pj7MSvOSwB8fibmjOtIvNTe+ZXP/bu8C+cSoIDJLc/Q92Jn+Df1ndXT8IIY+dAC88C2H6I4jbuv+cJxCixnndN7EMWMu+KlrpcvDPtsE7/Kd677t30mH4Mh77G4Myy5/kJj8jzU/1m/b+qb9Z/K5fP2iDyeYD+MJ7lHtPJsEH4P+zG/BnivIHPh/QWv+7fh73Hfi/EdM/8U0Z/0dw/smK+VcZ3SP59SmL8VYeCHJ5cvYEZfpx24/9NgOvXbJvFm0+dcX/qTf2F90aOP7f7nTwPzT05v8gXpvZ75pw6f63wfzX91D/7o2OUXAA8x+DXq6pxc+R/iHfF3b178g3T58QJgLpop0Sk+V2Bu8mYcfc/Z4w/ZLjk2vtSsJ9vl9X/WXPTbYjNv6iDbRpk8ReN49xMY+wpyKjza06Cd1DNZ1bZpiM4RZJNw0Qu59Z4pxfaYOtBEkvd500c3lDjPSrjqB1121INH/3GzzwXWvY689sGh3Jk0dOcOl2oOG9X7kL7HiCtwZFpT3kmNjaIIDq/yTHK4pfFd2m/+rf9s834bmdu8LsZws2HNJb4r4zuzt/1v0S7OTy5+9Qf+er8g2K8LYttHx0Lp6ykw3h/980UQvznwYb7BMf9p6R/Hp0T+9Ve////Up+JtvXNrzZ676Q0398iL5P8bnyHAXqjxHOsD/0q1yU7uf35q9avs5ZeOT/gz/E0ke/iNH/47y7nmC9fn+JPLe1/37v8dq29Q9ZrmK2lD1POivRPV5zSCU9+x+icAJ+r1lQs3iOu11Pj8ZrliOB1XTtjmcAzJmv4g1pP6zGke1+XCGxtb8oPPuea2Dc46Ma+ZT1y4bR9kas+DwHzKjwNteckXxs2/q0yA8ZXrHEOQA1KNpQ8ssStJLmuP24dU/j7vmRDZ6l9JEfAGC/NQ/YUKjlgzB3tiiJ0tY8jmC4G5nLN6s45xM7bXNwbpOsLXXPA7xzpyYt0D/rNlLLEzXfVGouqN+iT16Et/G99hjRY+VJV/T/3VeOHT2q/HcHr+vpeQD93//CTgOT/O1wPhhYD3SPCX/b4Wfbu3eY7A+py6Z+e3BEAyq86pc3DxHewnfuAvvvoE76uIBz8heM7FPvSTi3/8T17xFxe7FfelZp7n/udP/7IXPtWS75pf97vzL33+L8So5pSWES7jocZ3xU+E3vSPOEH62/E5HLzQM7OeU/h97r8zrjXuxzc5R78yPuVQvA/c//M07fj9mjvrmX3Zj045HOLCEcv6O7/8wN8CUEH9G34lubvkyePYkIlnGF1PcpFLOusMJ9/WrJ8PvHEwrNlGcwb47Ksd8N6H+fCpCSnbwU9UF3xnvW8MaY65OH43d6+7NGuGknMAd3BzXroSwMa66sNz9oBvcCd7qo5WEf29U/+WRUoXdEMr+smW+gpi+mX5Grgk2vrufbm3SDRnvyJfkmWgOZz7AP5R4eqHJzh/kt6j8j6iIL6T+tX47lenKfbm8zRn59Zz/mGF4rgvbV+X+FnwvBcvnJ/4K9//6pN/OV98FHjigSd+vrP86s/8r/HC/z/ld7R1rbjmTunedv+NvV1zxM9y+cz79/70n4r3XMQDPX7U/dQXUn7K8NWf/tlXX/2ff3b58J45rw/j/v949M6n7bEXvjh4N95L8phP3+MaecpiX+/G+ec+4QuPx9QwP+f8d/+Hn3r12//NP4n3dcQnIdaQdG5Ozhl53/lDPxjn5nt0nswjqaTQiqMv8AF60t7q/h/pd1WXB3R1vV4RkPvgFwCnyQyJVU++adTxYoAHZrZcHOY7QKumeOQp9aK2nynWzA/f2ve/23Rk31NOtnMudnR58h/IUy9wnp3Li1qn7ofmX6etb5SdZPaJDpDz/Zi1z/ExvfhaOts39cdvPlzONnq7F3tM66eYmsW3wxcB/gLg2KcGP8ywdb4P1402rwdjt/PGBxHxV+f0AvS5PxEfhPTH9SL67qc/FW9ozI9a5smeHx/z2wW//0U+s/0X9Md3buq9iaPOXVPsNgH79uu2k/KnBOyBF9H87vOD+IInP8mOFzD+7v0HIXnh/wYvYvGd/uk3P641uBeVOGubZzqfcHzMPac6F5yzT/UU1wWXymNWbOHj3/tv5U9T4tx//Hv/lL5CZH4sn3f+0BK/wvn1L/x8cs+asw7+j8D9P1t6nL7dWzPp4lp755c//+fjJy91EcyEx+hnpPZdXRCXQ4+CVyf8imvv0bV3/5n9FOxZ/lN9Z3t42z2Yf5d77+5tu/B32I3tvJvAHcfrnH/3P2nxXb5bNmJnOTPf+hlu9+0973ZzRSIzecbFjx+/65nfcPWM7T1IdfMFwOXsgupqdI+9zvbzdq+7p2Dv8Tw2draHt92D+Xe59+zeODfjhW+H3djOuwnccbzO+Xf/kxbfvwb3/9zyo/WzeV0kv6sXf07KveWwpbH7DTsL72/q6Jw9qQK46QOOvc7sz7Hpa+7isG0s9o53vcYuYHufLvc6ZjjzX4zipldzTOl2uQmvlkO7NN498QY8+J56QzvffPeksVf90qP73HnO/PjgNC85095zJm7y7zhiu2/vebfNd+UnflbfPkvzWIafN1x9+UfiD858u6yrGfX5jI362vae53wcmz7jzGHbWOwdf4NdwGZ4utzrmOHMv19n97COWbrdq3mCM/8um6NIXu5/TySl52XvPuPdvsLZjzw7//ZZTvxVjvwb0NeC3Xv/9p/I/CTAqw05wYSW9k8JB3FvZsfSpGMzbzZvjj134h276vmef69vLD20LuOo6Bz3aWkEcWPwwWOMY7ZnjvUz2b2cBcvHHMxvmOu0tAK2QEjnuQ5ynysY+8z/FEn+vTXD7mf6nHvmcwzpPVif9hXO2Bmf+kO9T+zU7+XR1x53r5ZwGcPsy88blXjXNT/u/VZa9PuVH/uvs2XOo/c2NzHPL/vVvidg04mz5szSk8d7/r2+sfTQuoyD0Tnu09II4sbgg8cYx2zPHOtnsns5C5aPOZjfMNdpaQVsgZDOcx3kPlcw9pn/KZL8e2uG3c/0OffM5xjSe7A+7SucsTM+9Yd6n9ip38ujrz3uXi3hMobZT/+ss5+X3TbWXNhT73j8EKUvDDstzxKIUWzGrO+/xmUeJCdxbmae1KvmZ/6ZPjncw47bud0DuTNn4oyBa/ZtjKVrgXeOezLGMdvmZIjUnz0ohq/qYs887H25rv3Gt7RSAOrZRS615po9ncUn1vrMmT4XcvyqV3KIqd7eEDGTljyBKKI6GxZz4ieGn1BhG2Md273KtzegjPND523h5j7hmv2RZo75W5GRz4spXwR8JX4i8K2wfjt+f/7/i1+j458AlvuI5ueeT0byqP1Njp7vlrlze7bkzpyJMwYqcLaNsSTOIm6MezLGMdvghQkH9WcPiuEzJuTMI74v17Xf+JZWCkA9u8il1lyzp7P4xFqfOdPnQo5f9UoOMdXbGyJm0pInEEVUZ8NiTvzEfIvd/70z9vDYNWc+decz9v4tAIh1EiK6D90JT5HmO8u5FzvFl/M5+hIVRCeDxHVV46xn4x1rWTwqEYez4dOH863jeAwW/Oss+mPpPFfxHsVFbe8pM6+P4g6yy/lRd0uvFnoOO4fjM23vZ8dMe9HDmLNVLXqqpibv1Kk9eWYv1ne8/VOaw1jLiUFvXOj7vArLX/rjY4M/+QPfX56PjuAF/zf4ff1/+cVjtnt7V3vfcbaZCetiHhl8yhEik448z364Wj3r2XjHWkZWlwiQr7EmK8X5mOgcHoMF+jqL/ljUkB7yoT69p8y8Pk6+M9Tcq+P2tSyFnlj2p5XHvZ8dM+1FD2POVv0GpX2Td+pUnTzZxXrc8Ws0LXMYa7ljGxcBz2HH0LP/iX3HnPFOn/WS7/zy5/4cJY8LwYRuZBaPJD4hQBAOZxjc4U8aFBMWkRuYvI/RRx4qBTbmlQUMC5Bzw9c7cLJjAo/DlX9AHlLVZvV6iX1EnYcoLrkJ7Mll5+ce5BCmfnBpcIcprkj2+XTfLQPgma5ZY/5VvHBL3Qh9EH6FzLnzPNEWP4xVz+ldN+pkRwWYuAd6aA6TTkkua85qtyvWPDUa5XFwfVENPvsDwq8/8QbBZ/3c8m7gacpX4/fn+bUqvgBQi0qPvj0D043+7XqUHHmoJ6d1pamR6dw7N3wv93/Orq+7MKd+DJGbwUMsr+eIab1l+Ob9UykSjVlP3FKXcxP5ojB+cryGLv6TC6XrRp3sqBqf/T/QQ3Oc9UUuy9f+mf0M9z8llj6ueh71d4i+AOjBwxhrktYp6/OdiMCUsswsfNh7EaDmkR6A5e9OFUnXLbB5Zm4T7Rg4GWolLTkU3dYSby4UztvcVSYevQUm4raR7HpPSX/m+lfFJq/SVCsxHKv1wyHf8bvuDog7CmrW5Zwdz96ytlrWSdATIM1G27nbld+5PefqofeY283kKjr77nw3W/nr3rPmTqV+gmxioZn8u61ZhFP7RALYlurEQbf7mJuwbmLLmfvfQ9j0pBUkrmmXG8bvecwymVvo6geuBRth7kutmsnCEQGH+TUxflvgE0/8fehif23Br6Pxo37eo8CvpLm//XxRwDHp7Ke7D09txPs32Dwz1zHLxsCp6zrQIZccim5riZcxr6UN3ufG59a9Zs7L/c/oWZ5LWnncfbZ9DqZkvi/3f1zCMZTH3v9z1uie5+63zT3je+6dL8bfAnjnHd4KgDfWOAG6uOvM+slGKBjCj08YNBnhSCdMtSqGVdxVyQClKFwYkaxpiW3uvOHgkSujOg7I4XVd+mb5ak3r4Kh9lbu2su7VLzSMC5pidMqSI2dxuk+kV+dWf/YjFSu/21p9eaPs58j2ModI3LZc/LWHJI6qkTUbTM+yR/HSIMuNpZXH8plG1IXV7Eatnl/v82hUdeyv/OWai+SlRqXm9ci+8kVAzRdQnEuvIk4sfdf+s3bG5uDSrw0c/IPP/Isc8yh1mSeG5mCZXei+mnsA45UdhIVSftfkiwA+Je9tfTHA58p/Lb7L9wfOvNz/PispdR58onHN8x/mOI3HdRAYzvVcOsflN93qe7n/PbGci+8jWcf9iVlAREZr0pWYz0sFDJBwFdPNWfD0J0PfmxVDmH+R8/xHqu71kfPc9z+1WbWb1qXsB66vL159EuANQ11wQdKDmBctGyWSwUJtGzam2/NE9mLF41ohtWqYnW6/pWlcZ+ll1Jp9k9u8ENQqDBSsEUnHPDp/Aru2gXKMgVSzVaCiVWiNLf3pCtq6mb7Qm0v9BLb2snWSZoXFeBzWnH1/1bP5TuXMMaB83d9ubzjMHWvIMZMFlEYkKc89IL08H1wJyr0agm9fxj7GL544+Jxss18our/wzrqup77VZPKRPPllVy10lnMi7WPf/cf06WXf8X3xkbPxCXN8KM5T/pQvbzzkw1P4oJnfi4/G/Vp8Pj7f9asj955Vl7rdQ8Q0hh3TN/CYUw+gNl/zqN0ng2sWxLQt7R8zOHoZtfZz0rwQ1CpMtfFy/3tmnrHndCU90xkvX5/T3TZ25O5YQ17u/7oyx6w0G2zuJQ2urvkeWrmnzU8A9hcIrvblxh0Jre4XwrRvmiLLpJtUqHxN/ghl1jOHN/6I9AUCV/cXqq+6mrHu/n2g+x6LAqF8KeNwhidsv+X0TX2JR2D25t4nXnrh5qzgOZvTmX/WhO9sGWMJxjrSjXa/Gna4wyE1DtI3udcy9i5fcYxcnbZhL6r6C4/rE0Tfl/dz5sfn/Cl3rG1zzdqOTdm4cO4tOTbxV/rElv7ud30qPqI1PqZVnyzHzEjOSemjUcN6P178NfJL3kpxHLD7nDWJi4g6AXDMUvGKoT92zXrkwEcD7uGxPMqtg/pLGvVsLtd6qGdwLOellceZe+af8TN98Y0aqhkHemed4dy/42dzIm/3Ty5yz5YxlmCsIz0Mz0Q+3OEgzOHquiDsZexdvuJyTkjKKnX4Wl16KZTn2CAIbnkV3vPnPmb+1M01c2fceuPC4dntMdv3pHnAWHftIH7vdPh9bk42zpzUUCtZfm8yvetRhSEnd6w59I1WKPtahjJzANn2Jgf9orqHeYfT+/EPLpAdKV0Td/lnjak7yz7Vch77bkAq5pN1wo2/MeTXvgvaad37xKMLEQdvouLqq/iAdA2MWOqzmz3qLvtJ6HHc+Nyr+Kq+67ovycVIulnHvdCjdXGGTerSO5iqRSyWUhYljIrhlrH3Omst/Jmho8oMonu4TkChRwQyFNeefUtX0tqr/a7VuUmrDPsqfZ1POt+Pj43l8cqfg+4cS+fuNn71viiJHqNIx8kRPu0fOZb3g6v5R9y+lqHMHKC2z3oeVH19zEL03veQi1SSTcna5KwxddexD8lSb5zvNFtxzwnKoHMNbQz5QYBdbXRa9x6exqObRM2nQVx9WW45oNRnN3vUXfaTdMdx43Ov4qv6ruu+JBcj6WYd96K+RVaYyCN17revrYpFuHfRCjlJkccw9l5nrYV/5GlLg+geTmlugHrhUI1QXHvOxvsnb5TI81a5xDp34Owjzjrry74ov30OQDWXqaPJcojcwRPJxmYD6PjYBEX1IK90VBa4uZRHbvnJn8sbsM847BkjXY/i6XjYwpUfcVODXHAkxUK6r1nDurHCjyTijokILsfLMePGG4skPte0Z64xhhND3+t5U/hnjLbM7Zi54LYPfeKwKeS4c24whXNfkgEWrqT6qfnYv/crDCVdCN5YSnNuuvpYblNpLhj44XMvnQA3/nbcKsQct3RvoOGEv1cYu92xUIjBYw7vb3J3rzOx9D23801gXNjChr2EooFp77Vu9rP1QK4wtUl0fJhw6UFO6ags95lW2sqtZorO4Z6PHTOfGl7qJ4ybeASEK37ESFM6Nnn225bPTvJKN1am4yGJOybikWN7xo13DEl8rmnPXGMMJ4buHh33pvDPGG2b2zFzkWsf+sRhU8hx59xgCue+JAMsXEn1QyOx7N/7FcZxIfOgNOcOP2q5W6rHcOKHz710GgD87bhViDlu6d5Awwl/rzB2u2OhEIPHHNp/+UIc8w2Q6+H32nM7fwNrr5EU9fKTACEQOIBuwsk47OvGSAiniDZyQixi4JUbumFIfCzlp3ocDSDXQEfhKaJZG5z9QKeuVOL4ZcRh4F2ic+wAO3DOvekpYMod2C4USeR1f2GYXr6KhdByDYOw5Ysk8szjHohZF4EPJqo83HbRq3uYfnOLIjDGYy8xAY6DcQumnPIF1JgjK3sgPh/EfR6mn353Dnxg5vLeNnfnmgeuiZEdDvGFVC1s41Bi4VcspFxhVKilMd4HeeLhEEHnu1fiwkZcEkw8lr2VD3/8n4SFUU5xVAkQPVfr5DVnAIUVGYijtjnMC9A+57sH9TM4kimPxMArN3TDkPhYyk/1OBpAroGOwlNEszY4+4FOXanE8cuIw8C7ROfYAXbgnHvTU8CUO7BdKJLI6/7CML18FQuh5RoGYcsXSeSZxz0Qsy4CH0xUebjtolf3MP3mFkVgjMdeYgIcB+MWTDnlC6gxR1b2QHw+iPs8TD/97hz4wMzlvW3uzjUPXBMjOxziC6la2MahxMKvWEi5wqhQS2O8D/LEwyGCznevxIWNuCSYeCx7Kx/++D8JC6Oc4qgSIHqu1slrzgAKG39gKpURFCGAeMxGSFiWGwinccIYaElS6G1GHs2wVGNIOX0AV0nOdU/edG+oOEh1zD2ZzrL9RWq8e1FzLlhJM0d44rV/IO5j7uvMfwyB6FjBp9zas8tXmTVtYGHQjKqw+/BezANOXIXzntOZwd4jnMaH9DJnNhreIneNma+cESfmc0lMXFVEfZnOhhsQ0XFwDSTL+0VXSuRXCJeWbcXDoxJhuB9zEZAeUpjAdgymcs6aPRPirOC1b+K6NjUSafiyB9UYcVR6EGdJ+eJgfkvz0iZLNgdvxoEKKlS+Ra+cveZMh2Lu1T0KY6Al2NDbDH5KsFRjSDl9AFdJznVPPi/eOynWHXNPprNsf5Ea717UnAtW0swRnnj055qWc1+k7v5jCEVsEXzKrT27fJVZ0waW9Jf7P4fI/PocpktHnxPFwcSDc+hry+efgM+t594xmMrpcyoXOSheYbiHievaG15+eL2mXj56EGdJ3DPPdfCxTCFbwHBaCpG2XO/wTwBCJsYDMA5JuCByS49DNxVe6wDgaM7SaUr+woJjmasNHALLU4DUCcHhDRfiqEUcJ/k1BeXgD8X1gcgvMFaswIs7rQMbGOppfxWTXbqF+MKYuKVm8YCfftrsutWPfcbukrgWisBlduAIw80qkXjnFV49AwjbvRFyrvIjXhDMnElIfH7Ac7kiRtgYcatIZrQKGSsc5rVLjghhw2Mu4MZYOllYALWwqe1c6rKwlYsjFHRU4UJx3DJCLoEqLA7hbYf0PAXGjod1YeUYOOKxnCcMvbmhDPdRuLYKV/n0n41lX9jQiErBst0DsZM6zomwluBx0CyQ4bUOwL1PXbUDS672RDAWdh5KCrD5wMQiBPfMl18kFcehhlAOn3sqaHMlKo6RI+5yCI9e9bS/iqFTYi54eUzcUrN4yJl+eLouBLHsQye2y66NInBi9rksPAlJvPOQsdSzmj96m7lg1DNYjFieAWl+7PUF9CESyTVG+1KRBLRa+wVsXrvkCDi26pNUyxhLJwtrUEhszbtyTQGfcnGE4jz1Gz7HLaEUF0os8YRDeNshNbcBRM1ChZVj4IjHcp7r97wy3Efh2so8TPzqSYeshepW3GfY8U8ABRKP9WosYvnhKZUMBogJkGouff4ddOJmICUbKm7jISpXg8UbmUjpVR+Oxo64NloBxyGTHgdkPNSLuWlHmAzEr0AUxsAsdnwuAu3DIJbUew/ljlTHVTML4oyVeSnQAfOICuKhbvrVS0S0Km3JZw+TYhrGW4qk8OAqL/eVIB27NgnMOx74dA7wlY5mP4nSQ7IV8YtNqvdHBNycpXwcyNN+Io9UtxpqMnFMLZRDI4/aPHqF7j5AqvdwGIt03DWdKxsDPufaLF5CLO8ZuzkVyZrqq3DqbweBxVeE7gWJH7dqYOdy6UxrK2Chkwe0dTgKI5m6sKiEKSJdienMUkPPPBKENxQcuvot6XrhO3oibyz3h8t4iOBiGSzeMLQvFcr6YBo74pPXccikxwEZD9GbW+WKI8TL/c90fL6Q8zxGSPPUQI/zS4pmr9TE+LwS0+ClCPdy/zMTL2ZZs+Ga7Gu4LtS2E1/IGmlbx7kQXfh9z/R5AJv4e/f/u/pJSCRzkvpm183ihpNHVE1ezSV/NhOu7CVYhAvppoiET/wrrTBqlR7Ic22ckXZ83As2DqrUck5gyU3+ERcxl/TBjQuOAx9ZkQut8sUv1FJLTxThFhcYcbgRkWrezSu+rCVsqOJQSnaKipY9wZ11OR5+9kO98Gk+xPKhpgmziJeUHQcxyw8ouYmZXxr7iP+axgrzHITiUrJ5mCEO83mmYYvjsD1/OKiUs4xk7Qc71/HhGuFRX0EU/2vfgiSn54lLuT4Xyjnw7k+4MhDkaD/o4ZA+c8vnqWQ885TsGZmHAqzg6PMQ5pGXCYdNUJ3nPdL1hMietKfqFF5hjrzQtERDPFZeH8c81b9aIs5maVEO4Wn25f6PmccQNeIcUM6KCdVcUfOaZWLMjBlyLRLxCh8j1nli0DKTA2zAfD2hORVNuk5LehNrfwQgg4+CSHHhTn9o7SfuJQbhcSY3MfNLU29HZ1BqsQ+lpKO6iRTzHPtPPuxEvdz/NUIm3fNn2rYjXnPUtaS5Ea35YXNehEkdvCYvX/JzlFknLa+PvNYUo7j+5xxGNuXBYmrF1fxL/lsA9qlMJRgUZjZTaTSHKsL0fRB/nGA+geeNAgZkV8wkUmiEmCQOFhfisQH7kOL25iNHHTr9pEb3stSgF5FVX2l2fya1O6sc+6r62cuxhYbnVG72RPzo50Brvz3LMb9qs8prRMoKP6Ee2bKdMAiw5K9gepaknvG9/fZM4Slece12RnXTR8i9OSOvGxWKWJ1b/pBF6MJC57mJP7CdHA6l1myiJ/WedEITL0hmY8Sirq6SsOu0LbzUpmzdVsopppHnDanJwIhx5BQJEfZWM0svOaHJKF1VrJtTTh3MYVnJBYCINfOyUvo5JsZzTTnrXXEcDMk/eX2ejrp9HsOlOUb6y/3PDGtGGrxnmr45M0fAH/6pF6JOg2cMPWxNP8tx7RkofwVdbCTpHsIv/onLgrfXH34v8NMumkzt3ozwPbHs9eX+jxnOuedsPXfLmmwNvidaNqKG3p7E6FQHfUqfL0vAR+34JwAbyHjoIkKHLAl1EuUPO6RsPdnl06efYM0UicnaDnjLa555wRJSRnAb1325B0qnzjGpo755Oi+C9ChKjhEQBketTC7DbOHURrD9SIjcVUcnBze0GR7HmUeUR/ryRmgzczRLYMm08JGmminIV5y6KHHIcfgljAD+eJDbe8ComNw1G3StiouskzukmYuv4OI9aqsgcTWV5UFi9p4rtSDVn/umJqv6YAN2Dd25CtmoeMODRXVF52sJA0ShLAKYHdTmev+FVo2IWYqTGATu1bRRS+7kqhIZ7Hy8R6SGED5W9ZDGQBlPfOYXXoLDtGk58yyLtjiwCq+AaxR/z+HgFY/84QspWzVyGlVu9F07NTURlUQWL0nS1UQcAPucofNgKVHzfbn/cxw5+uMezEnFnDw2jazmrPlVTOOMGSN7FU7ngoiSMxrqy/0/ZqIx2q45aZjfuvd/vgdgnPN8JvN1oN3lxWBVVx8J9djmIXBfTBFE59HPEiQUmX22SW6fjAMrisw7noDAEEDGcl04mofgqC9g+ebF3rpzQ0Zach6yn1S7RuHUBLzOpxAE5cOUSrwMS9eePStWe4OmuUoNu5+YyRNGSclv25Ki6Kph3JZHmVjHHksH3rkg6oLPormdnj1xViXZX9iMcQxC9QKxyENWX4Sl4o8lDilxcDO2ceHzo+wyEZlPPQwd0gevShALv+rIUTp4VuWkUTllCE7cvPjRiwdzWeG/CSU+5x7B7sWJxY05Z2G3+Cpvx5iii5IUj8kz+9EsqUOiCwxVcYL1AGIzVC1xjzrY5pUsXvuWOqOm/GWLInXNqXMJbHWJdZzgqC9o+XKTTi7p3JCR1nOqeR33xobrXu2HDoKw3aBU4sSGdB+zZ2Fqb9A0V6lhqxfPVhglJb9tS+qhq4Zx5XN/lIl17LF04J0L4uX+Zwpac7442paSmOUY/ptQDjjnHkHOUV1vmUq8VvvB2YesPKkuYFlxhJIO/vwJgC6KAIucpHiIHB8mBxZOdKQfofY68cGNu1dxmdMx25bGY/MAZ109ACBWQPPIrBzrSPECjoewHJxUJMbIBBdxQ3ZdhSsPfi3seoirkqUbUjntM0fl6VwYW1I+NxI+23CgWxZcwv7d5/7kr3z0pm+lnNUf7lIFbh1YBJVmrDksB1i9YzsWUuE4yOWY48UfYqmPzXKu5ulcuMiPRwlhu2aGjtioZafmR5YKhDAnEj/c8VBd7Fj4e3/yZLwo5EEXpuKHMzQFSxLAjkfvLUzVJsZSwYPPvdzwJ1rHG0xwuOeuEzVVh9qR5Rw5cVTdBA1y+6cL/mGLMGxzOmbb0inYPMBZN4dmU0DzyKwc60jx0ntx9R4U5HBggAkXpOZlRlNXDwICrlX86gu9ElTbkMppnzkqd547h+RzcWjR4wEHumWVkLB/9y19Vz6Ypm+lnNUEbvej2iTVopbSjDWHZSdmvyJyLKTCcZALA8Vx1NKbZsScq3k6N6RyAge04a0cfrmG3wmaX+R60z1juPHHQRg1gKM4CQ4fecOU7v0oiQMA51naTz7xIiHcCyMe5hMO1wJqtJQNE18AbEvJRUwIu31yZEPaWDWu+GwLVk7+AABAAElEQVQyclxI9PBVXPuIg3KKr0XVmrmkOl29GAxR4XGV2UrzE4zFvzuJKOS71MdJEktGiJLTJ70OgnOovE4nDwO5cbGXpe+AgFEt4yuHkPZeXI1xIVILa15ypq97GDndb/jaPWq69zl3A4UP7J7nmgQ6z5yAy984GmUR23DGNM/EFVZp1jFq6byGbg65A8c5Vg84XE/BYeMfsYUj8mVXfMCSJeI6B+ZEBqj3MBKaF05w9MYqDjnRy4fdOeGbfagGuOKnnmqSE2441BeGHaF64eq6dg7ZtQTM2u0DF37X7Lquow1kjmLmHXHvsffnOsWNf+YSdjox9MORtXDBq1gpzU8w1sv9X+ctx1HDKqNmNueeF2POlcHqvAHXkI+5L9dSxQSOBPj286DYhjPmpj64wqpF691MnVdg5qweX+7/mt2YVY1GJ7Nm/W7ebJpuDlF4J8VQfVIk8ceDWfsBqWI+AQPjCwGME3SijMUfeNfAZAlTPL4ASGkcsWFjNmUpjRVSZfIQYPgdV5k4IHVwTI7qBc6wu3fseMgm5PzQzYGqnJJF1znCCVSHyYl+tiChVjwaYuII9dzIpT/7CkxcatkYmgM2nPZTA45Y7cPAWYG5Z6c5lkUyt/mpdaTDVs2kypH4sgcnhJx9qB4HOMHE6jppCi++skVVWLlEQmK1IUDpleP9LNzOq/qGtjsUlYmDewMzdeVUgr+AwWcOEYhEyCIsfeJK79kEARzYnW5SZDmJ262+8OOLhyBOxi69cWGT60eo6+zBF0Zkle8E9UqyV8Rdwy5hikd5ESClccVpG7MpS3HMnEopTu3THMXb8chXbsW737Bbp0Y8ZM98ipFXPcw5FF3nCAfea3I63zFLSOJBfw0xcYTUj+0AiFKHJCCO2clhaK844VQw9aaxjzycFSCvMcRYmwO+5kcfEOEnd8WWPTghZPcWOKVxgLNqdh0RJ56QS4iqsIKMgFQBDrwwhV+4nYe0PlTtmeTIdW8yZ20clftNvv/rg4Boxg0ibQ+fTkD47QJjfZ4c9oZfMXh4sAze9Ygb0hiw5ZxD7DrEyCuMROlwkCMTnXoYUjBq4YsHHFI5zFW26pOLPTmsl4Sne8XHgxw/Ql3y8ddynqX9C971Iuh9d3zEyF16lmP0hs2qHLXhfCSPcHYNsF5jL0Nd8KbSviNPPMW75MBZtdyLXT2zPaF4wPUCE2vWSc+xB+YhqsI67rrQuqZ02wWEu88NAHiQQ++Zh09l4oB0X5JyVH4IAKZIcMUmDp3levAPH+6bdea0z7kkmQuf40jbw+f+7XLv0HQ/GLHACAeP63WigyFZETfkpocI99yBGogkr2yJ0uHw+ZYeUBWY9e0rDlLNRUir+Pq8Yk8O6yXJ717x8RBxyRBLfvHLXRydj5NV/l3vXh23FLD6wOcaoV9xC+J8ZOV1jeKU8H6K2vTzXJjKtcVTvCM9WavW3KfyDbR0D8VjU7KamHUc9x7Yu6gK67jrzprSAQwsPD0/AMSQQ1e8fEqNA9J9ScpR+SEAmCLBFZs4dJbrhfS+8OG+WWdO+8xHEp8E2AwzMBjlHrG2g9CbG3BtCr9wgenB4aCJaqT9I9l5BTm4IlepcegYupxJMPlUu3KkA0FpI3QTIe1Hhh0iZ+wYjkrpOnY4PfMykZgXHKzkmpGejZ3LPKu26gHwQ2Rln+kzBEfx5IYqAR+rYtIHf+/RmMB1fuiOK508fCI5cMLYWbGiI0OrOav2zf4b6AQ7QsJt/sjvOeEeMUOUWf6OV13HujEcgZ253avA26F4Jr6TcS7Eyd3xMhdGcvwg4PySs//ua+KLTDhOSfUHDz6gWvhtFHdFWsg9Ym1H3nK+nBEA/MJRa/Kjl91+54V0nlMgkS+kUuPQMXQ5k2DyqXblSAeC0kboJkLajww7hLYmDD4cldJ17HB65mUiMa+1zoz0bOxU0RWfGAB+mNdJ2FOfJlw8Ip4bCp211ZBv8PcejQ1854fuuKjJwyeSAyeMnRUruu62Oav2zf6d5wzLIjqKVk8Vn7WXFjDi0fGqqzLhn/RzT8S7V4G3Q/Hc1AKGcyEu3wAPlYzMwemA80vO/ruviRdJ7ZPWqz/6INe0Yb/b7/iMHHCyVQCS/DWfoitRTXTMmGYduIipuJurRsJsv2rBQXORik0fsyh+NYd0IDLq3/XEpTqEiwuYfJ2gRNVZNMcpwsKOR5lphVEzoZYyekZK0kGRgBZD+9SG+Px75IlJooBV7GBKTTwqhi1QpcS7cLHTNdKGr2MmwMHDttgr1z54A+E9KuoYRpJq7qZKV/YjvN8hjHFMu+tqGALWr3yiFwnSfN0DDsfBRj82JSuuNtGjpmrgCBtRdp+fGReZiAQNdK1IFK5m3UWLstFZX+UD7/+SRMVNGLHCdj85K7cojkCrT/GjzXlGUFsKvzhMDW9mZ25ZcvF7/MRZSk7VVQYPqngbb7ZKkVi7dLfHSTEWnPukvnsMP22obiiqRZ30v9z/nh/TY062mV/6GODL/R/D0Eg4xENzQvc1h6P8GuJxjS3PDyIhz7OVmlZdo75vR4QqZZLL+YgVeP+XQbzGoRW2+/nm3//v6f6LQ974sRXp2o32QMts4XjpSk/6jpgHoicbDQIcKyPUYd/J40hIXsTVhLE5prQS56NgKnz0K1Nv+Eh+KmQukVhNnycpj3KPXqLHbC5z+ij2wKUEk+xZH72qiEsxmow9ab8RZ78fvJMoJgFGOOUWn2rDGc5mdC17sgcsIuLPBJJqBUYcEY+Y1MYCSc8hnZcy98npiA5FFZVCzxsm833++ouAcOd+IsFYy4Uedtc/OkiP9xoIQzwkcRxOcQhEj/YD8kxSpwLRtSop6QU1+8FmI5OxXCE2ZIA0l6qgPrZc87CN3B0eHtlnKLEgSo3ZtdoxSBOT12fYvraYsZiPHYbLJUKp3HKJUvWzJJ2wlANX1cnzTSQRB+WhESN6eGYPWddntLHpjhyycqnCy/0fI4pJ6Bwwl5w70pNKD0c8ddY1T2PJY4UtV0w5ODOa1xslKjgkvmNxFlkv9/+cCbpnWf4Y07fL/a/fAsjvpLXPfCKoC0EXXF2FjECXBxfeMYfQjptfel94gA6ka4gnr8aMB19eeMeQnQWDF08cPEmt+RmVX5xk3mbLo31kDSPEpf2oCZfKG0BMJDmHrOhBz5gJNY8s8QSaPqRzA3s22Ts4cnRrNw+1j7i4dCA3Fi2wZESm8qIn2QQMQI/luPzEwGZVxU8OZjCl5ww0c50UPQVYPTip9yiwgYuc1Z3GbJbFDOQ4/L7JOt8hAVc0IfVasYzmuTtmZIIa59LAuZE8R0wMcTDzwXRwz3p7vvK81y1IzP/BwX48J593xua90dWk8Lk65uCZwnb0N3PEwYuwlOBbrpXIqbTsK0Bd37WpYcbs2ZYRyJf7P6fC8eX+X69HXXu+J3zBcanJl1eXpudLWEbO0y7kcd37irScKFXrKzat62NWOeJiioOZ0XK5Bpb14/4rUOZ5r06tIJz+Dw724/v2bd3/7+bFWB24b3eb7baFkk8QAYxNHGvT58asA5E+sclgyMFnDWzic+CHLYR6KL7up+wEZDoD54ltr4/No1NSyT1C4Bz0WOLITpIr3RkS+ajByS8fkv5sEtETLa74z0/ATdcNJY7cch3zL/ABTYd4cVKsC1YsRZOVuaEMSum5GhT8/HdwOLBf7Ftjml10VHzef/LU+XHlojwwGWhb1HEInKtb5q//BV4OgKMP53WWC0bA+7RLkoRmlif3HmrjySUEDsU5Ydc5XjnYK/hYyrNipyLBlrZnbTujzkGCc137s4eZI71LdOHIDt2mJTRak6E8ap6cCd70rhM51oFIn9jiTHFyBJv47OSwBVYPxdf9lJ2AGk1dX3t9bB6dkkpfZwSVI7LQsWsm0w+NT6r88HA/GBSS/mwSKTyYl/v/5f4fF4cuNl87Kee1VNdiX7RcVHm9ZcS6riyDucpGCTC58oOAbDWpHVy0fdWG04lF1qFWAhO6YNNXebpJ7TeXa1nab2m848iKuTcg1rXRLcexfpIoLtEEVvEwLBWuGiUOF47IkZ+DAaW366SH+qcKcc08U2Qg+d0zvqmTh22fZefuyiBvdfZmpyX51kOKP6RcM6/0fmLbY9jmKRXT/XYI3Ak2vLkKOOk9g+YopXuJTLkiyRIy1xZxxJozFL4Ikx0JSOn4pCijD4rbb0lUgZDuxxllyxz4Vls5coV1XsSBNAx/G6UXZgE6X2TRVtnt3nk64IQoM+s4XrU61Er2Itj0VZ7q22+uKtXCfkvjGxBKxdwbEOvsv/XKse39m0o0xochnOuWtEmOdA6R07oByHiUEIYcL7hf7v/j3Hhsfb22o2brwZU/xnes8DHPTinl5f6PETEoD6sHlKPz9d9u/RYAMXucmPiDyPaU8wTgN8fEDLeoJ3/oNiWdP53WzWnbEn/oSnX+rGnciHVRcu1Hmsc5Ia02jpxaxJRupcH5YgJsuJTlJyIlOmgJWTymqaR5UMGjbfGUT7BdxzaheXYM/vB1b4Vb0qax5feNaL/lA/XmzSrorHGS64vXs1MZ16pc7WHyRLz3ZSzc6PGQa/hVI/KH69U7/qysckLvvOaGc6z2B1DtdFKB5FzrlCsT3EA47bfLPcKkWAXQjZEy/NjCFpn6I152J9qGnLXb6c1jxLoensU4gHaLavKFblNyAUY+TgNMZ9sSf+hKdX64rM7zYIqF00Ckecwd0moTNknGlA6o8h32T/Q6vwJLPw5awhGPaZqvpQoe+1Pd8gmz69gmNMmOwR++7q1wS9o0tnzy5LLf8oF6L/f/OI8xqx4ximcYuv12PfP9X89urnJ20uxD7rjytTuU1rc8bYBD7YSNoILXV8aVKFG4havyRBt6x8qvC7jywBDXsNoIXyV1bijWLYF7dckZLL2/mm9QZE1cmF3fhEjwG6599o99zFTlGUMAnYd7cMx+MPsy3n1Ujinci+yKlTiYDC4ux9lvn4dAN0cANAsDQ/pciNR8GGCmjQ+bHHTHy4er155HAN/0k+8HcZFWieIuQTTTXSuk9lH2zfkN/8zFAKpFgFUO4dDLNk4wY49w8gbILy6iIqmwne/ckMxYfkslcYhl3K5jmwx9rpljf/jaPXXHkeEXJYfiZnao5L7c/zUID3LMKSLHIm4MXts1047Zf2QeGjHzD5wpfFJkE49VIg2OBheX45zTl/v/GA+D86h6iOXQ6NDLNk6z9ECPsNKZ7zPf//UFgKtbjgZoUKZjXABzhV9PhJUj2MSGTmhiSPdGgEqvHAkSig/sssLvJzbBsA2wUlzLi0zEcAOp8KGPmKmQ5IPn0UnosRQj7ke6dTT/cB08IstI85YPoVyU4Zs8ex+KBVZwF7asRMeKsrmbl0DkILxnxypkU/KD90MUniSf28aWgvCCdy5B6BOewnfc2JCKlQ1cC9uYqYK3DdjGwGp+TRQY6yFbRSlD83C++SJ8tcxBvtLaURnFhVvXfdiTdsIXP4FwlDiUkQDe54Jq0lG8KhmciJy7SwEqKWKNN8+UEV9qEjNf6XtfuF/u/zHXmrfmxHBQhg9XrzlbOwMruGOWFXesKJvb6UqOHOK63juQvo0u3rQQgMKT5PNPvrClILx0H9sIKQhgeDqxAE4MqVjZ4gaCbcxUwdsGbGNg1WATBcZ6yFZRytA8nG++CF8tc5CvtHZURnHh/gjc//75ZnRDR25uNh0+mxWunZTA6UAApU679L4Ayu5yoYh/5LiA/DaQ5dAF57xy95MdPPEAepO/+wLnshE68E6sGjILOPHoxPw4CGCLNcDCxMEu+sU3124Tk68CyjVBJcqMuHN3DLZjlkrdeK5mtuSQGHn6sTgSm0MV6XOMH188ShxNEPMiDoBVUvih39QvqNNInRi+m5Q9OKQ6AWmdZOsl1c+OARfL0ENJ35kfzOxLBJvDJlK6HYBDl9++LlJY25YqsB60F+cTKqxc6DMXp+Nbjs0Jh05r8gRQGAOxS7fsGpGsUGDEP3KKOf02kAKGQDqv3C/3PwPa5l92jc3jE87nIY0E1ljbheLcdsZ5ern/exoaoy/dZabM6YCltjlsIqXbATp0+e3rIoW1bZkVluMj7v/4KGBS4gC4uPSuVPSyhSBOL+1zY5ZCVXPoLHIiPiHyh6N4/G5HuXXoQLq6XiD9lWckpx4Qc/cTjB2DURzpH3SRy/btWfPsPVhKm7DWeRcr8S1rmujdY+j+Dggf/ze2SSGsRTD8DjU23UkA1LsByCOAynEiGNZmwzc4+VW/yyVsHBpvJWQ/CY9suPBrg0VMSvicmXlg8POIr0ut40A/wMKkWXyEdW1IObDmaFgpzRX4Skktjo1tz6EQG7m9pd73TA5d2EoI0T2KcWCBTKzilUdgqB0q33HdHLAaYoitYcqYS0Q4UOJAoGIv93+PwlM65Dhtx7Xycv9rYn0fHOPK+5l7gYurhif15f7vKTEP3Xs6lNt6yKEqiF2+eT8b9pT7P/4YUHEh6zzpPHKI/73ydzLD6pPscpYgScikw5svSofNzeIXqoAr4EIjd3GVodokxG9Hdh9hUtP4msx4PquWs4OGSQmfeOxF8gi/yqQfdQ46TK32tZL5Npe8CC0vrEmd5TJNJfvXg6oFCiUfbBjJk5ZJituQSGgeJ4ld6aEBzFy41VfMAW9R9H71a2IDy7wSL2LxOOfIdswyEOTRFy7NPCRGtHH40QEQSqz2MeaTSQEgj/8CLxpxJhDb/oMv8Up0fdUZ7VTtcGdPw8aXuQf3QZNA7UMFtanq0Xm+Zt2jc4Jv24tKzYPicUCSFtIz9H2Jn36QNTntocCVdGCgVwfkYCArP0cZRvzv5TquW1kRVnbBSMikw+tumilna9PFZY9c15YsQ42R4FmaJOLGVz85h4znecqOGiYlfLnZIsLJI/wqk2hUzb1QFu1rJfNtLnkR0n3j5KTOcpmmkrreqx75rOQrK0ReL0RMUtyGRELzAEvmoQHMXLjVV8wBb1H0fl/uf42tDjGz+F8zY4I9/pzat+L9/16fcO+TDUp3JAN5ebDjfNJl80bwYQXLbR6BYzjkH4iemfMDS24xS5IBd/rSguGoODQBOdQKVbUDvlZNjFkkdWdF7/VJfTDgV6Z8Y68ZUF+CzEPFtBP1U/05x+2FvTwJFFZUxoQhdeaS53qhE8LmgvN5kM8xgqE7x9IUBLTnkD5Pef6KuICM552Yg8aET5wkkw+W+ihySapoutJpnYBycGffztMeVIx6vpaOMx6ZvdRLcYrOnCGdqTrOoFdKV473WWlCwV9hOouE+jdO1MGDJR6DI+a4XHHIX6yhYCYi9GSsGHhnHLlyaQiZ03sEKgL8kYnOIw7mQZMn/NIUTz0p2VGgRKrUMeOjh+7KPMUrcqUdzXiezjnus/KE8Lwz/0BUe9qH0HFgL/gtySGWvrSOqwH76DuBYuqAz9FaNTHmlKxBv9z/Oft1sOGLkb3c/3lZ6TqLg6+t8qY7DK4nDt9q9/94D0BsYNxH2o3tkPn84aedgnKBxH+HtzhiEKTqwUGIdPrJEK9uak0uEMKl18ntgoEn5XBMH+ggWRdlCnT0dWQpJh4S45HPkkksP2pmZtYZS5WklvYfduV2P2Hnk1aWmf7KvhXVElxeeoGdXBHw/sAYap+l8xdpMHVqdf/YxN0DNvuzD9vL+TG7fmHZuTvPYJJDb/PQlRomUnyVu9RWsBpQQuLlKc7TvRMzd6VTqCjsGfuMCNcEeYAwMbDjoTwd0HHmKpf6R6cXPQgXTP01MPPMW1YK005pPRBz5uYUrbkDk/cl4IGHAzudYWxr5B+bDYw4wG73QvizzkhEjToIPRQiL50v9z9zvFicnzpHRrzc/zUJX1CYuqZa5Mxwl78yUtRMZzr5O1S5YIn8a3T/13sAct85MXQmVIPA6QsTnclpUCn7CZsYi+HNZVN8xOMBxyHSKFw/uTkvo8lbuf00BI8ecbAO3rn4MByTXXGdceJ2lh8Xq91F1jZBfMVrYMGIahF2Ded6BgCmD3vPL4z2qlKR4JyKLTnkE0cuXMMYKhTCzR73+KynhO0w97OFFm5i4irCqHNzDp1PD+qjmqEGafZbCl+YTNj2HYAqJ+hDB6iMnzXldgCSALqsZ4fbyzHsqe/xJVYGglIud6WbC0mOuSzD1fN13DFLJ81a8LG0/wj4XjaHYnEwR8iX+78G6JkwI5Zng94zZqY4Yk0ftv3oXoF5uf81hJwPM/JDM/LQStoc87P6oCR3nhP04ut7SSThdJ1vg/tf7wHwvnpjKLr5ayI9mGMoPQWG4YFAVN+pr04CscyTVtiD3/oO3HNmrX6Cmk6Th8Q9ebHlK7nr3gg1HQtVy7UwxBmgHZPI40h84ZQj46hw+g1v6S18cLuH9lfI9qCyS5K8+fDQ5xyIsyzTyuP0qT9w5UTMOHuzT/2U7T1rZgFYcqoYnPjJ43GDsUPElTSEwoUxV4fpw/lwD12Y3QYTj+7jETUnD7l+QGJ6S7Dopj3rx1gwxu06PCz8k0/OOphnl4Tx+TFrEJu1MHzuiE0u57nJJQ9s/qTu2AQEtczTdjnU0wwOfahK6/phqcchzWsJds7avcJ5pntPjs/argW3OCMofhwXi/jCKUeCVT8OL/f/xRw9/DGzOWaFC8P5MFyYyJnnfeqKL+BkxUUphR5Rc/KQ4wck4jCXgOkz7Vk/zgFj3K4XVfdpnP1I8+zSMfw8Knf7J4CRNYc6C5kAlgGHP4kDDN6bNB6f/UjWIm3gD93c4KxPKb0c9kNh3RKfqMNh3+Rc9AIIT56VAjkf99QJs+SLoGPyhQF+o0oMwIqDZTE31yXcq3gVL+cSD9+sAce0MSYenTgP66F2jvyV4H7wseQOA9sP+SMgTMhKxd2chxK+ylfexOCoJa7QXb85K+BrFNNYpQI0pvJ9PRI3H7rXzLfuepb2d045EB0LsHVLHOjwiAujgpPbcfvcs+3I6rlWOi4t57qO47aJo/tB0uSVbUdIzxa/uYSJg2BgcMSa0ud19k7cdfGbb5E2wIZuzp3ftuIFMhYK65b4RB0O+8yBZLW/FOHDv1wnI3/WMbZ5wtF8cIcBZscJw6Hi5LOEL7Aw6RaB4AO/xAM3a/g8OJ3gxKOD52EdrDnkrwTPwTG5w8D2g1zvFcJKxd2chxK+yicOFp592ef6zVkB6jnXWHHYGYbUCIL1Mp9t5My37hRL+51nHvwdC7B1Sxzo8IgLo4KT23H73LPtyMr8Ix2XlnNdp+iXui7rWOSs/wTAhlQ0pEGwuwH5wkDikx0HSYBjCVPYGXcN8ufDqRNLnGXflLuODb79pZiDQMcKN/EKGlBczGK4Fj0gWnD4IWzlLL6BLVVcxkwJBzZy1paT5HAav8SJjeXziAv8suwoLnjM6RB4+60jWaobQGFlpH8/3nA5J4COWTrXNrJ13pQ3lwPh6x5DsRvJdUaMB0vXXUhj8KFPG1/jS58cE++86SPffvPgs9NcigEMZcEJnD6FI1gwRdgDyzUs8Zlnv2ZnzCBdG5VjDtWhnpSDj3xjVCMMZMFkuDZYL2EKO+Mv939OyDNkjvNhP3LObZ4E45e4B1/S5xET/LLsCAJUeMzpEHj7rSNZqhtAYWWkfz/ecDkngI5ZOtc2svWX+1/jeQv3f/4TgAdNlbMiuhACJBxGnXRsP5mQC0AYGbdc5JmjKEzVUpyR7zJI+yZ3lZBwfPrci/dDbMeJO5zqZQRR5VsIj705jmSBPcMTM62x+FjmSCuPcMx5nuXOWjec4Vj6KMCSAyYcwm0EwimQ/RDGRNIXD4fdp2VmJNa6sdjmMp+lsRMzsYoXkXOI22+segvAtA1rfDlkB7Zoc28jRlyPOFg3l3tghsS80Ik5br+lsZb46dk2klyW9ZvZGjwwSigb3X0NqCDqK5zyu1Hw8ZhY3y/2Ia9yiS09hsN5Ebp5LoFI8ZBwsnYpzvIT42Hf5A53L8fbgRJO/N5PubI+RixxB0g9DBLlJWQ54mc5btt9ZnQ9gvFjRswxfe7HPuchvWat6Seue8BAOdJYciKJmeBbhhGmcApkHvyYSF2r5Gaoz/ty/gtbkMZim8t8lsZOzMQqXkWdQ9x+Y7X3AEzbsMaXQ3Zgizb3NmLE9YiDdXO5B99n9oMj5rj9lsRZltLDsI3sfkq/ma3BxWO8uDjEcl8Dmv446hwKBFDu/AnAJJJ7O6i5FST+1ZWk9rkBS1EOw6olcZ3EpGm445PXPqR14sYo2YcAgHHcmM4th3mMnbZPBFDHTT8dxJwnWhuWnXSuAOPfBFWncqq9WUbJ+OPh1tLHu/LTL/v0QBIBywLBx4KAOAIftmJx8MUFrp9EMGqBw88qkbU2mxg1Co/aNrpXY3BsvOafXJDYTwr54gjnwhVm/1s11BFXXv1Gi3QnEI+HiXGzPHjF0kUNvSnOeLDyVRxhPDHpKF4VRChucMXbrByEH6ZQXhiNHRj7JAPoXPvNsUtxriBcSw3lBMYwAcJpqfgwrFoS97U2ORw/8xGbcWNUy4cAgCHmB6HOrSTzGDvtea4dh0NrOFCdJ1oblpVyJYC93P/HdDQPZoKrzlMJm5LGMXzHScGvWDiNqfjL/R8Dif/f3X8v3dc68+theqiWAZLqoTJndK2IJPcydIUL43e2JjzwpEDgFw/nUyTpkosEfF6KFSk+8soc3pVjYEyT/Y4MMBVEnv26VwO4Yb2qX8c6z/sibmLrzpGMAxvg/8jpc0OM5VwkmHiI2v5wG9qKY0joQ7CWc2Cn/QAgkr8Z0x4msE4NJX/rAc/49UBALpwheZR3HOSbB53H6kGwo1L35vmYxuc+B1Ns6rfexxtA8+av9kWwakBP//q1tpBZszgwSAzsMrfKFRY9Hv61LZBa8oVFvJZ7UM0kdSRlpFa2U9oPXC8SeMw5ZemqAYmJ8Fu3DN/sS/04dsWPP8hVBuysRwxH+EXjeLrKiYhA5fmLr5f7n9ExqBzey/2fl1JfS3lFcYHltcOY6hriMhNOCnoofX1lcMFE7OX+j7nEHN7TXENhQH6d8rAYnRbzBMONL6X8ShD6yPXwRZjnQmjVID9eMDMlRXwnppMRR/MrPDFussrqxBsUPVDSnCgfBECtVc/aae2xKBoe7mJHGzTKVab6qqc8ObTFilNcI6l+RdJEOAeve1Y8e9QTHxMApo1oB6/eiT0s2yInMHw+kWiwY7kX6emBLTEAyQEnQJ4/5RSPYwcvuRUsnsQUmYiCM5x9vsrHC1P6qg7lSU5GFPUiJQ6uo2sKW7Os3uE/gMKCqy4yFoZs9WIwMnBODkkP2UdiHGoQPbq28JWPP0OS+myo2gEcSoMbDAjlHjouzgUezzf3yjWaYKIs9SuStNVv2HIpWMh0JKvxIcEX5Y1MxuQSrgsWJ7nh84yqhNMUTP48r9mUE7KJzlUTERNhiAxrSJzvl/u/BlLPUboOuEo4FTUszenl/u/LDCWvnZf7P4cS99Fxuehey/vz/HkgoFq6Jetez2stP7bI8UJp2iPjIOUuhiSuzZS+YEmpB4n5RJk+EalbRQKXb+joJ4bi1I5KzyeTICRPi7r8N5Zi1chwOwnsUcPeBZiGeJI9b8bCUB564sIMGerELn0Bc04oe0xkuUHFjhe/4NR/QaA58GSJHkuyTrocgzViOfvDp32H6Xwi0uPgmRgtCYd4fQhHYDvfoBFOntof/fHACVeIrtP6bayaEmvzBSz3C5/aUBynMMXn3gi6lnTsbB+tucDE/00tpfsmMGYDMJZyJjl4+ZNXocKKPBwyize/YBk+54olvzRIPpWXlwN7U23V4zqowo2oKyXcRIzHcLtI++nJfUkSA0zyvlS4nICBNW+e75f7nzlrkhrUoeXcdLqYbSh7rAcaYY1X4DxvL/d/3YO+LmNANR6Gmdd2+Hxt57TTbp251jUbmsZNzJe1qXXt6xwRjAfnChlrynmefb/IF7nCVY44wiGzeL8V7n99O66NaEOaRE6BTbDYlDeJD33YUoUNraReNMn1AkRMD4EcqZzDRMt6+80TefG/YvCZ081stAdjBpY9DKz8uspwVqAEJdqH6rpymyScCWzo3uNS2zwlO4bdKwj7giz+tgFFbZfvHDuQ2ZDbwmy90jsNpYOlFMVpbwd9UpDix1ksUXEkyArwUMujSPqrBwvJMpwXUh7ZFUuG7iV7T2DqgeP/CceQI2Pdl7nEHwckVGDtg0f68POXCPHX6iePorffssuHQ20oMO43cfHEVKSWFOaaLV656aVgVhoOLzHH3absqoeviQILHyt8zeMaO4+w4Sz5cv8zt3rETJb5aaYcYgWmY+mpI7P0CxKgcLcNJEg164JL2IEkwcdU0iP3bW4HSymK094O+iQjxY+zWJU8igYYHKvKlSj/6sweyue8kPLI7uyDM1yZl8DmaH9CBVKQQPjMX+G0w4kfKrDCYBz49n8L3v9+x1luiN1pg7E5NsjiiWYum5bgNAw7SiLsIt+45i2nhyqOwjnPPqD2obNs0x/6xBJvGyWW8Zjlar9tMJNL2DjsMyCRmDhNjJMFPoTd4Lymbp/lwhWG5+L4zAWLPSW4xogsOexDTh08q6BNaM6MxrGS8M9Y5xVwt3VjNclRh1l2rLgl4iA/cfIqJgl52VYx5QoHPpZlWqvt64TYzFVSceA3hyVg+iJGcGLkw11+x5CKxUHSdlLE8agDgFpdj2AltS8UYUoOyJpXgbPrVfnEY4nejREIXeYZP/GxbFqSx6NrVgBhDOnGqY5jYTBbcPinDLN96JNr2j6vzifGahsllvMxy9V+22BmD8LGofemjDwQE6eJHQPvWEhwXlO3z3LhCsNzcXzmgsWeElxjRJYc9iGnDp5V0CY0Z0bjWEn4Z6zzCrjbupeb5KjDLDtW3BJxkJ84eRWThLxsq5hyhQMfyzKt1fZ1QmzmKqk48JvDEjB9ESM4MfLhLr9jSMXiIGk7KeJ41AFAra5HsJLaF4owJQdkzavA2fWqfOKxRJ816h1sRGuNoDxs3mFimZeyT2T5OxbKxBZ188BnLE7rSMWGY6jCEXc+MT9CPS6swuADbE7k1fJJnvXAuhaFLvMrptwAmcN4y6va+J3TdU6S7DJ2SscWaaP2YdPSdWXHwX5L4nZSy/Vw+88Zozsw477h4DKfZ9wXaAUk4tB+OLGnRI9FDfllpa66cfD16Lj92OiOV+oilhhclaNiJiwOYrjsxvYMUFmKG1A2fmFLGmMf8Uk8/eovHO0rxbYkhyC1T3xxsI3sfQau22ulsE4ovMPKL9KFq2o4jRoTWyldDz5jZ7/4FHMw5FClE3c+MT9CPfZWGHyAzYm8WnvPrutaFLrMr5hyAjRzqXeZN5pxTtc5SbLL2CkdW6SN6sGmJeXhkB0H+y2J2wnO9XC/3P89mpzLHE6NbT6feaaGIfGBsS/Mckpb/G/p/q8vAKpull2NmwYblM3LjB14g7IXoxIC4037ScgD0iAMK9AZBRAuPPJnTqX2C4hzoeoVzsVejPh9CJLss+zkVHCbG0/DpnNgFG8QGWNd+QNCSO2EwozQ2y4K7KOBdApTcc+4TEFd0vMj5hxLfDNOomoRYBWJz518AcAtnIsUFLNdAVi4lHzEGzeTQpe/amDI1uHIhdg9Eeo6lSe7nbe9qhVzD5z9SNyzxjKnyqm21KP1pguHOIqLuDBxkAxbaxjOVV0bgKYOnkf4ptswfE1pQDtAbXnG4A99gwqvHOMCYFXBxSh4YOAh5GvTs8TnFMXCsF3ZLV7u/xyF5rOdGHx2ecYeHP4Z83ydYwl+ua4jyVhxFYnPnXwBwC2ci8AzHsYtXHKOvsruROwgEWXVaLvqlFBx94Sv61Se7Hbe9qrSkSi+gbMfiXvWWOZUOe4Hab3pwiGO4mpMKMZGaDGcq7o2wEzdROGbbsPwNb8B6agvAMKQzSED5ErvTU5/Ro8coCfxgrXoRkKRXjkIp7NRuMwHjocBHoTxhLzsQ/JQHvoMGBxB4grFQbIdBpUfc+IrDNzLJRYbZ4D8pEVMOeUXFr2SFStS9WzdkLBnqnuCx1+RV0r3Swxf+9GHUaXdAnCBVb+Cy/xGboKvjzfQ4HM9Z4H5V+y9z69vWZLd9V5W2bRkhJoJdDOiJLclJgzofwD+H/4Jj5nAiAkDtwQjJjBHoiwBEsKGUouZ1SgtNaJs8aNA8gTofKzPilhx4uzvufe9rCojV/nuznMiYsWKFbH3Oefmq8x8r83bCQF+DyBFJPnEsYsCPSv0WwzYCZulkUMydBY3j3O4lSQ4+c3bWqZE5zaUAuGRSspWRXkOt2ew+8U/tVuI9KZAM1W34Dj2uQ1Y/ux540qxpgb/IW/SutHXNDn2uwaT8o/vvw7M58khac35KMZv2E78j+/fRzW3vE8BHM9BXu9h8j5UHabP8yzuQ55voYvm5+jJV0zJ1jIlOmmaOuGdSqas8n4PYkGpSV1i7KkNprXpUHLhKKdfAMDo4mQdpkkRLw6qa3EIPohopK45gQl3yv5ONoEXOQcLJ1dmpCQXJa+iRo27h0LrJYilND6C8cOXnaUc3LwAGTsxvGD4I9W6/NOFvSfI5jeRHLH3jgDLhOpZQN2BKUuP2OhvrnMhKOHajhd8Exwc8r4QJn5j+XyUyxxD3f0anB7i4ztOweafvToXaiy9WTa6BT/t7KfovofjQLXWuIF3cnoU8ZXvWXa9fGoCuV5xbPDpsskk+8o78iIUTgTTa8XR9jMSfksRZIj0oiAkYXbDiVhbz9V1hlKX/OLv1KOmwI/v/35webdzjBw1Z5ezjM13Fx7WuRAUu7bjBd8EB88zjUUQ/43ld0u5zDHU3a/B6SE+vuMUbP7Zq3OhxuaMnNYt+GmdCNjat1C11riBawjh6VHOK9+z7PquCeT67Fk2+HSBEBDb1z+l71+/ADj/a3v17E3UM83EPaHm0X8XDKmB7a7hs4c8HG9k1yx/lFSUFwj++CGohrIarME0Why7hbuLb8Qn94yhCDN/0ffhp396hIsdOQXjx2lszsMCVRSN9E5JesxAqcF2UbhYoGgliGZKdgzmRXGEGrKRmOD6r8MjXDaRG7r8qIdgkvBbSuAtptGl9pDsSSjqwk13dt/EIQ/VPN2wPnf+i3aDLrg8h7qpyC2SectC0pV0yrGcL4ucLn8rDZV2kthalslcqVdqZiU3etREsOrrvjALEtsp6zQ3XfbLJQhLSC3PUv8Ven3rSciq9uP7z4n5MPrM6mwmyBnPYasGLM+5iFU0cq03tZBcNOzL6aJwQ4tWXpj9vZPb8YhRHKEB5ahA8Mf3n0ON7fNKuI8s3y85Xf+sf//fMacffZ5/B8b978X37mpT/B5i8i60E07hQLw0lbowCoaug4KRuPwLuTJ1iNFyT9fSpPpOlQ//6ndpZz7smqHh6tXzjKaS8Xsv08dDdHHTrJGG9IjPecr37+IHyzl3nYxyJuDi9Q2nFrX5mwG6cMzDtmP7ot11wr/kHxG2JubaT4Ndf+GqV139PnQlyXPG5hXL7TMMmhmoJXfe+/ReSFbR1asKQPdVvYp/akMM96our+U9r3toZrif/U9jitPbUECmtew6I6RsZcnrPOD1Hu2nTvZp+VuBH7JJd12/ttkovGkvB5/3fZ+rsEgiR0lW/LIlVO9PMfwMlPSZSASeWUWdwPjH9+9D4+w5D5+ZkRyWg8nZ6fw8Lqg+bzlz2FcdntXJ2c/NoW8f3z/HoFOaQ+2z8bnWsRbSh1j0gvh2+L8c/8f37wPzmeg8P3//r/2pTu3+QvfxyuRAK8/dD2HoRoQOcJW6tv6wk6iUnrAu23j9ogLkVevOr6riVzvy93fjQUec/GlsGbLHcMfa12vv4vIJ1g//1Jwajh963HmZq/TI1W7CWoipax42iL7nUD0vtjd9ceLxcM0D6AZxY/Ms6Hidn5t2XIXosK7nXvGuN+F2K500n5kzO5r6q7fUI6bG3XRL56gIcsFb/WteqlN5IaBbn7gWapyXBxrbSccmVJqhe40n5/4cXp9t9VgdutiPz3qZdFSFZiZc+U4ln1zZ1+/jzktEKyruK1p3tKKwS4H79R7AMNKWeK+eTVBUytPT6bKN5x3pjW6hg19VxS/a9f6mrHonslXPj+//emJ5FpzNdX51bhVf5wzneu48PNbDGVdi5S6N+ZmkOn+fkslrXaytV/7uZOmP779POGfV58RBySW6P5fOG69bcS7g+n8HzIPJiZP3TycBC7yKIW7yJXh5la8frkGvmgunb/3NdV5P96amt6R4977+5peX98pWp+pzdSspsxaYKqvPPoUuTvRqAu5U5ZI7XGH1V+ersu5VdZG1X9Whcl8gCOpiHlzt3aPhE/quev8veoE5qz6jyQ+5kLqnnmQLyrOEQ26aNWRxcB3O+QgAucWFXVC0seXPD2yRRlNe/c2T+tRc/uaBmmKaJ+rBnVnJrZ/cfd5rzt6bhVuTkumBo2sVxOWJer7r8MQF6f7G6QtqZtsa+zpj5KtPtMuCsdCofMXckyuEM6weyVW/8BJdnPWtk/RaGHH2laGAzON2zjOJ5dSMV8/UFeXCP77/69A44T5bzh1Xz2E//noGesc+vv9+R3N6fW46NM7oelfJK1rv8XKb54OOUJ27M625CuLy/rpPvhNXg/xuff/6fwfMJmt5L30kfvmAAU1hc1rhm1wbrsS+NxetuDjdqvqkb7/MCSGlRwrGVo/61WgVXFqXfppO66fRjIUxzYXKn70lD/nkWEBUOLo8s6zjzV21Gx7p1ISXOHaNs2fIGZ22xuqZojlgixH3AHWAHTbmHMMmTn0w2dQNR88xdDsJSsUR5f7BpShA5neLqyYdy3ZfuNNEPrDXW3XBqbu41y86GrPOiF2zpWSK9dFbR7fRG5KcpeF9pS94rs0vOJr+oa5gtmhqNNNwWfcgTp9on71SA1789Ly+NWVMa+60VWw/eCdMBgsxvbHNxcbF2aUJZL3vkZEz70TA2Orx8f3rHHJGp60jqmfgY7uf3fVy9YPJy+YwDwtLXeKIBpNN3XA+vv95wTkuPxfOyQFAX8RrzVHqu+dno851jtY06lh5Fsu6B3H6mFix+yVODVrFrx5f+F0ArBapoO9p3OlTMBuEvajlB5DNCwpvdqZ+pvRgcPw3Bkham1dI3QdH18SFC7BcazrAf4qDIRK/pOpucbmxrTNUOfvw4Xk22ZRsXeemuFoMRk2KxIE28fKnH72RiF4s2FtrcUa7e04sztDIJcC2z8yBZ6Piei/07qT/3bHwbkHGi7T7PSWcbOKTUc28I6nfdgZbxeTBc5ECS13XZH7TGstebFOTOln2sUKUrxUNEIteKXsrn96IWTOilC4edY533mIkepaDn/QMCkB9eNEijg+HtWLTV+x+xI3tlP0AsvN+iT77kaApPQecebYHT+GsqUcXtOtzLg4bcw7/KQ6GSHz0siyuILZ1hirH+wKAoyszpGTrOjfF1WQwFcwZiWPJEbly008Ep6MXW7LP98WZXt1jYnGGRi4Btn1mDjxnI673QudOfnz/HEYvzmQObWFxk9M58izmeVCW3ObybBIvx/DBT3qeFQDE8PL/DIimZ7PH4oBbZOkhbG3dPBD8q5lB4/SLFhT4Kdi1YItoDrEuw12DSbnca+1E/FhYiOzCaC/c59I1pu56fA9SOsnbCsry3AJDxQk3YOLZIwA14nqGKW6dzlkouXC7sWFuaIXTORuwXOJAq9uiGzT7ekFby8+NksWB6XmxBKz0kE0ObPxiXfcUNifysUMMD4Ak8cYaN6S863c+gm3Zx20v4crOrAvz37RUE4h2rMSWPTUhOIGj1f6G0osfpPHhzbtRldWIwn0l9yMsutPnrEP7XGDZ5HaFGdZtysID0GVct8BI03vOfddCXsTZvzDDFivNdpG7FmAS8WNhIZJ8YrQXPr54pu56fA9SOsnbotfLcwsMFSfcgIlnjwDUiOsZprh1Omeh5MLtvoa5oRVO52zAcokDrW6LbtBsP6OZj1LVkjZWFN89L/lg6SGbHMnxw4tNYXMyQmxoVwMhJKlLbUjCDcm6fucNdC0GTjDqw5WdWRf2e/D9158DwJ7mweoA2GwuzuGtg33Bc3iy8yv6YK2T87Nu5+bQPYgyu8ZE3XZh8sEUP/ZL7bapAUPnjIGjf/imbr7yM6vw5G2Xxq0HyZ3rGfKC+dzR1cJnFs8Db9cRJsa2rvkKWdZsznCdIKmLnC5cr+YC2CUXHoQQm4em88GhPPGppUbXnmP71RCB4kRn93Cb7o3k1FB29jXZrOkJxzC3lTdObmNV2gIryJ6zl1UTTe8LvS4b3QYmJg+2uPjZ8/DI98WeB299G+VZczzhF/xyv/GoA0Cj9acfleCtT+gV/sYjKvv4PYq76RnWvREliUZ0wLJ2YfLB3uqX2m1TA4bOGQNH//BN3XzlZ1bhydsujVsPkjvXM+SZ+tzR1cJnFs8Db9cRJsa2rvkKWdZsznCdIKmLnC5cr+YC2CUXHoQQm4em88GhPPGppUbXnmP71RCB4kRn93Cb7o3k1FB29jXZrOkJxzC3lTdObmNV2gIryJ6zl1UTTe8LvS4b3QYmJg+2uPjZ8/DI98WeB299G+VZczzhF/xyb57/HIBLsFHM7eFQHuVuBGQ3OICWQyViC9UdcnOzgSlVzhiARafq1UnR0oOUQ5sC8UIFs35rp7/xKYC0g+ULpyZnsrWGdcyeHnsGuNMiCQD8junhPuk3BVSv+goHgJae2FvZGacfuK7sy5IU9iyI7Byp2xJgDD5OZifs2PzoBQcUNvMSW6gMf/Ogr/cRndZOjUu6Bn/P6flXT/LRh2fuyuMO3lynF8dw97vBBOCZc/metXH7zXU9OOsmdsXM41LyujwffK2Zn9zqR86hblObfJLY1i6SuHBY6LVxjwrr3jnXNO6y4I05VCJ2JCA3N/2mVLl9PlPz5KRo6UHzeYFliRcqkPU7n/7Gw38JVqLny5lsrWHRbPVPjz3DrUUS1OB3TA/3ER5LXdZqUVADmPTE3nhnnH7gurIvC1LYsyCyc6RuS4Ax+DiZnbBj86MXHFDYzEtsoTIf33+du4+Qs+tzzTH6mTTuc1tnjZvnP+9Pn23O2GdfZ97/DUAF3P0EzE8RmJq9PCzl83IkRwOX9XAjgZPpcduf/MLM64R10zv1KUqs2hxCNhxKLBRyzsd2MrPAWQfjcG5dczvY3b+JlgSXE93BmhO8DkpgdCDmgts6Zz71c+ZdD54cNWeM5F6pd7mH7GzroWE4OVk0XQfW+NTjHNz0Sy9iz5jaqvlizEL3uW97iNiyWyuwR8scDdLfUM84/+uUPInu7TC1zU3Os0DQgrL3FE5yic99TS+0u6d10j+9Y0cQp/eQXOzSKlZJuzdAtLdPLdfORU/WbuKuy34nJyc9kqPQ+Z7JPvU4q9fUkesVzLwuzNnEmhrRpWd94daQDSWWOnLOx3Zy+pr0sPfG4TEHZdEhtZclmUtOdAdrYvAZEj4LYi7i1plz61zq58y7Hjw5as4Yyb1S73IP2dnWQ8NwcrJoug6s8anHObjpl17EnjG1VfPx/fsQ7+eXs5szTXqdsTnUpr6LDAWLJRcfDS7/NwBygpuj/5rTD0mW2Hf9l4n2ZJ0TKqDQYphZBbi1xIVTz5+Cg+AYjAGuXPjphVj+a3v9phjCWqMHFg3ZnnFoaMN1i/QpPrq1D3Bdgk2NNvnmmEE+wqeHpFYrVXDerQujyaORODacmg4+e69ZVrn1r4kqVNxzO54eK5ozoh9X7bMYF8/jOuy5XupSvytpz0w9V5feGYmUvJpc+6N67wEOV2tdz6zesaj5/xf9zJj+KhpM/Ns8daaeteeYd8zlOX/690zMNhoGewuLy3l6qLq7eIYMJmDm2oy9p2nUXMWeE/zokTPKIfUEMdVeNdMeR9dqwTwf3z9H3IckW99cnfX9t+/OQdYR9zn2qdZxn3frwsihRyNxbDh5xrwT9a66IjTrR6Ob0aPnLuSer/oIYLlqn61gA8/jOmr+vK+pi92VOb/u26V3RiIlryZ91pX7+P45h3V4PvucF3jejT7nfu5XTfA6z7rznBN/+fRT+9wQV8Z/SINfhqY3Oc/dD0XU+r3LNcD8Pn5LSCNkZNkAfwIHS7g/LOeFyfJaBxOztpR6zdOV1nTE9OiQaV7VuUO9TLSk7yzxdyi8Qu50aD34I9sFu4cgVzBXZnRN9tw1YoVXZ1M9EE9c+5Ze9hIKevBs5TWeM2LPV45hTa+bE5VFlx4s1KamkSosdFozixuKpJRC96+n0ArKF569lJJl3THd0pv8vQ8t0GC5d4KChu2z6Xnq+dVApqvQz8Bi6KRvC1srz7XqWthNS69q6hmoQLSqrh33ODYwKQzXUc7CRXV25GtVxSh6z/VEbhqjTl3lgerpddc+gxqu9Xvf3iGHyEkqlbrymquZ9vnMiK7iIGkoLvtxE7GtaQjx63kpwdnVPuucsh9KeX+uM6gpPr5/H7BOsc6mnkWdcZ1dnoGPunjt+jn0ufoh6Dkp9KqfCXL9rHRzorLo5m3KU6XI1HrgiooLVqWqyIMX0K+E2MPgATeevUQF9f2e7U73PrRAm2XlBAXNVD6bnufj+9fh1EOqU/Ih9on7qDlU/qpnUF4fss633jliMRpG6Kf9BPxgbxmx4OWF8IMC6eL0JM4LkuaVywviyI1peC5nPVFGrJcQ/PYCHIXVa8bx/Ob3H/f1xb/o6GF3rYUzs5t0tvfLbjyUbpQPv2jOGe88hD5Rn0PzXSyc0L4fWM2Tc6LOeUtULrEte+izSQ8PZ6yHg1ill7N088eflR5UyHXG1tRcPjdwzxhObb1+eOdsKGVm5uq8IGv7XqA/1ubRjVU/rI7aPhPrFa24LtBN+6/ZqsN06jq09y/Ebj0Ysc+peIxc0/hvYO50nYM5xhDVBeB6wAaEMWs9P3DF4RJ4zzha7l+u75279Un6kncn4NtebnPQps9RdZRec6ZOELhW6eBR06ufsyP3ZmNypg/0fubeYPUx0sLWci25cupc+mmqbuZ0o0zUM7SxjvvmZOuZWJF9rv67Ms9gVNPv4/v3s/O5+hB1q794Bfzucs/7xXOv56QkZz2ceuYf3z9vnQ/SZ5O3FITl1zMvIe9rwS7xa524c1CHk9wlP7k8H39NI1SV810pNDJ55hHiZ1jiif3Mp19xCPUHAenuXZTtz5ecxCGipkuuxaql81OrHCtDW081BdPAybIdekrjBVfc3adk9beaEq1rbc2Nta+UrXePAEBliZK1CzNFk5OWD6/YxZPfe6/5OkctuA+gMNcOnm5uIp5sSj1z4/RzTxi993DN180cJLom+3ed8sMTh9peBfteSPNgmJWU7JwimJLDcSWENVvmMAkyjpZN/LaGu9bnZaZuaZ4Y60EaUL0p/Q5ZrmvQ4fJMJK5eVdyxz6l833VjkvJls6fRQmrPWj16oGX6hyeIZ1mpcdWl+9MvPUnbNy/ThLt5hflsKfAZp7LrElqLmwB4zKTDKxZxpWCUjmxznHS+xbz/9qGj6T1yFpSTu/KlTUIwmfRvWzANnCzbYQ0GXnDF7niloud5IapYPp7LlB+/RhyOudSLUS1doZgl32GGKd7MXyTdq9/FbT70fYYo0mvwlq9CspaSY17vkqAuyYJRjueB3YoEHBc6O/sH97MBtgCk4hRS+SCtZykwx2XnFMFEGA48a6/Z6MsyCfKK0z+YaV3r83KlbmmeGCuspeyY8vH9zznP4XCenPs+O3wwXf1eFou4Umbnuax3t34XQB7OSrjg8UGRObpT5+ZVVUP0QOGG05QxHhA9rtaJfGo8eOdSOJtNH4S0ssmKdO+XKHtxP8PDqBGV8P7TXGlrKR4cv8umz+JnXpPAH5pZC43u55pTgg4m6QAAQABJREFUUznKZ4+dt1FicPzNy3BQmkf+sUfXoQnHq2ey3/Uk974yfyxcz4Oz9+TGhZGCk2Uf3eBykh9dJ5c2xW/xyEUfzo7xtbwH2Zc+nYMzC4Gez2LMUlA5HUTLYdfAx63b6gcUDnk0o+sCwJqzvMv3mTTfVPkO21q3/dSONpoNztkqnlmoa8Lu45IUdv2YNS8YdeiFbh3F02NxRqMdaobXOpGPrvOdS737ubjr8bXMLbfuH9//vPvn+eSsct48QD87E6/nkuew88MT18+Cmq7f/LwU6WVpGury48OXk/zoOrm0KXyLRy6bgLNjfC3PJPvSp3NwZiGgixEsZqd1Q1I+WqZ1DXzcul0cJMx3UgFAdIMBNSZ3fGPNN1W+w7bWbZ86Lwha8NsdPeMkbn8SIHGBY182IaUMANc+amtFg640bkkzZiPUdjFm49QQG3NV+fDB3BdfOfvwm4ex39rE6YO/11BaN7ngngHQjdomXmHymTdzQfXKcLEC0yOzuVZ57498z+Q4ZMTkJ3Rt16T3JEUNNpZ6rcTMzUjoYffa2uQzJ5zxlYgW1nOZfCmZK2xqqNc1fGagViA2vhWog0vAjUDLLrnOG2x/15vuYjGab25rWM+k0oq+uRCp7Xr3Enfrm7I4zglEMm1xwKNtn0KtfSamZEZs530uizs13cRxmoGxqO+LMHNlBrCX1bXWSy3YxhWOlnq6x4tQ4a4Tx/u6ZOosGnSvzvlcGscQG2t999UssdSaLsuI+Fn2AXulT+LYocjZvYKDWYsboIPLJqxBLg3TI0KzEGMFJZ3Z3F9574+8CO4vLBykKLzVdo3rO2+ebsHGdiIxc+mv29ZS656tTb89w/g9IzVoei6To9J1wqYGrc1PD4FoWAcCizoZwXVrnBg9X+RY4SqZXqa7uPNdD90wcWOuSV7WLqSuT7/bfKQXx7mW7DLXm9Pa9sVhZU58+OmRvSRODt7UoKeE4zTrHq6XH27myl7RWUv/DYDIe0hrt3gGdo9uZJNmSyluahyLHL77AAp4KReQvtlA9LBT24XWRCpO43vT1DnNzeKXnf8+QLhLdQstdXMuKWuN9CjxJNsmlNhtZg9yYZnbtnVV2sPc9/XEsdyhOeW9F+Zrykg7ph+rkzf9niXzFbHuYLOnrp0ziuYqGN20Wv2mrvlb+1bXPXlIlE8dcefA9nJ9AHIU6rrVCxot0k7K0UpJRVfsNkcvyAPJQYYFFs3kM28Iyddgze9i50yUFroStgXrJhtv6syS7bh314eDpda2bzOLYlLTr3vZbL/rKT/Xnp1ZXSb+nv+lnLyEMkfmi/bUdmGPUnxIjacuM5jHzeKX/fj+dRZ9iDlzx31OOT+xZoHNc+haxznfYZYzugpN75rR6Rj2YO3neQYndhusnasmzxwdlvPlXs9dNbd65Wf21LB3rT6CClbsdHN2ciA59GCBZc7kZy9NSL4GW3OjEyG0OraltnMbB2ZNr/YdH3rmNVGm/hwAxFirbwG6Jze2iQyZQT1MKtDqKzVbOJh7dd821Qvd1sL60s0cWXq2vPnWgwS3rQORXMONmiN2UvjU4C8N97GA1eYGxwu91pwZWo9469YgpZ/yYG7afdp48GjDA3ePIQDU5Xk8ePX03DQhL9x15Q62cecXz31VG4se8sS28lkTdx9yJmB7keI68ZwtGrfVDQInb+2WcV8Bb+VyLlv3xo24CMY7xnivaK/crfcWhdNxOOwzWKjk0GXFx7p34zkfsPS2HzFZU3VzndUQKcfnKTd9opf9wNp6wcOPZsYp1bonNxZYxGgQkptaZuorNVeyuNSY3/O3mTOJFtaXbubI0rflrz1BgtvWgUiu4UbNETspfGrwl4b7WMBqc4PjhV5rep8uLj3irVuDlH7Kg7lp92njwaMND9w9hgBQl+dZvT03TcgLd125g23c+cVzX9XGooc8sa181sTdh5wJ2F6kuE48Z4vGbXWDwMlbu2XcV8BbuZzL1r1xIy6C8Y4x3ivaK3frvUXhdBwO+wwWKjl0WfGx7t14zgcsve1HTNZU3VxnNUTK8XnKTZ/oZT+wtl5w2fUHAUGKSAtTlMYRwdaUJUo4HAbsNKAHEmCdzsFnhWeO4lgPakZx0AHzai18wbOST5/aSKVdqhv6XMTpYWvC6kG+ObceJVfSrWNN4dZdOmccPVt05AyGgx62V1z37yEye4fFpE7e7KMLd1003aO5YKN36A9/OchuPv0yh60JIsniZi/UcM1ycqLJbb3Jdt2Ur9h8xcntHrQ4zxMeNcnhgGVP6W9O55BhuWbZ9ERg+sanFt+VV611lItWp8uA95Va6qORGU1uAc+7SQuHt/eTuug5Nql4E8tBxntaeq7rYnS9sLoSD0dOp7yBaGXelKMRnjmKY+GGZ4vmAuL3SEhNPn0s0ASX6oY+F3F62LZ2dK3XnFsPElrQo2PNxEvH+RXjTk/5iAyGw1zYXnHdv4eYniFhqZOZfXThrhv64rq0Y3R3XNH9juz0p05Al5U1QSRZ3OyFmuhb0Ul7viW39SabuQKs2Hy0OxcdQlr4XOwQFI+a5HCopQ4s/c3pHHUs1yybnghM3/jU4rvyqrWOctHq9Jjp2zrURyMzmtwCnneTFg5v7yd10XNsknn1uwCIPbhYFGdR5FC39BtMuTkAeLsuOgvL0NRDL1N11mwEfx8iPGNxOp4TIrbANY+lopdixeeMSLLSc9eBtwTuLLdSIpZEdL3HZs5MirMfarzkOJ848IHTf2tDMxbLHP0fOXme5u861wiIDnFWZiR35jPz4P1f86aWA6APKxZs72vrRgdufNdOceGE3kvj5pPqRMPW2P7uvfXpsXOJU+t96gwnfuAnRyr+FIAFvBGayma0uk8H93OCouu+RwE+S2ljdwv47tkgBsw92gYzr+ujZzEK4JaZ+fZeyLmFbvi5jBGnGF7Axvd8gpzPfIRgLHju04h76Lakp29A5xYh+8o8looePC7F54z0Z5mi264DbwncWZZSIpZEdLMXsJmpffcgwVKQWQuoO9jG6b+1YRmLZY6P77/OaJ1dzozz8lq5xJwjq898SkQV+PocgFmpmwKwgDdCUy04fWDc9XmGBdX3L99ymYG8/N0Cvns2iLEGNfi6BTMvMUkSSepfAZA31ILll6Bz1BrsOncIpgTNGjORkNU4pV6Ou04cfi9jymae1Lhh/utdVUukZtDfhFq/fpuDcMVzcCLi17iql96Vc1P39EzwqK3hqgHaANSB28oD52o2PvOYAzx5AnI1RxcV2QndvEeTZi9JTV33v2agrvth41O4F9qdnz7Ko1NabRups6Gm9huO94OugNSyXz8zHFJffnAdDc3xgazz5wwgSt6HxWwAxJlTQHEM2nfsW3jKkdby+WD78tzhllLfYWuZWATvFZ2e3+meGd97S3rhrt7nA5klLaaf9nhF7hb6nere82Kkd/QdW2jGagnPOc9HPOO6YVPmOeZWh+QctzXz7H1x5yxH08o3fWTq+6JpX/0wdp/1gMalPwFlXo6v2T++fz3TemQ+Hh+vDrWe1f4e+wzrNfH5fnz/9Tr6HZ8XrJwJOdU61DpffxNgF8Nn3fE/r9//T306fcvZ1GHk98/qBdR/NOMIwu3A8oOpDpX3udKK1w8/spUrnjn9B3ZMf6cqT38/HPT6R4i/FYuAtSBWQfrmh0p6WacoHqzLi5/5ALvLjNR7vGZgO9dMVGQxy+5fO8i9rOcSz3uRtlvr9rn7RAsh/wEn4Shiht17noP1qjf1SGVL1uOZVXuHF+fah+cSadPQryNBEOEqzwzpseM08A80yixQfTxXN0cq2i07ezPeQsm9bKDzmcF63cunq2aE8ycE0s/DiFlD9ZOuDt4DHNBp6iLFAq6ymvPg+Vm1on03p0ilLZhzkmrN1rY4jYmfUnhEeSozVs9fvDXvHEYxvV/1dtTFl3bUZFNXDX3PGeTMqPMsH99/Pf8ckM+lbpxozjfvk18c4XmGdZ4dS8NHr9vH989rWD8n6l27ztTew3mD59X12bvQT8DfnL0QzK2cixTXM6nvIM/rn+fv//P/9Md/WqfByX5l1YHV3yLqIHW4x0PKoXLU/jSS5znUp1Jd0jUPy/nmUNPPbWxVXfjETYxe8G23lvEFZD5wYNbWEuYf7pnpIZ+tuhYRcbOt0kQBWQmzNSXdIr0r+bq3EvwmPM/mKrn+JlICDMBcq3f6pggbLHbn3vNnw016o376Q3vvTPcgw2vR/XzQSS/ZuHXAJIWx55y1Ad2iQQFV6REcWOtWa67AG4dACfbP2n2IUzOO+KknFx9qa3jW8zzRem9NH5GW5ktJeO9xXooKqGf38f3fzjfPMOfa79I8PuMf339eqXqHOso3R7jfxz6zAhUMj4SIm0ttw9i4m3P7hjc/fj+zq5hErVst4qxbfwIad/J37Pu//RMAby6bPE+Dc+/N+W9k8PZmHXM2EDmTEbJsHRqJY0XDNcoRz9dDrKu1XfkgUdrwuqf/8TT/fWOKyclPbUZ76uUm6+ayLvSs6SEs/YauXO+HH5NXQ50KEimF37wbDZzVPDvhVaZyPU4g7HXuDvxPbWa/OD2reRRMDwKtxFv7xBJXxbW9fQ5wtka4XXub07lO7OcDzjNkqE6X5iFMDoiLGXRW9UcDNy8YZ2idFDS/Cl2XemVua84LtGVvhMy4n9Nqc9UcxeHM2anT1tg+DT3/vfOlLTzymxefXPqNUAoOzdRcBUUQPfP5TKy3NFrfOfcboam/hlw9s0/XCCfu52bW4F1DfK5gOcuP7//j++cd+fj+60u5fUP5Luujqd8FwEFtnBwfoi1+6dzuJ0YcDaw/7CZZv5PhIJYPNj509z3Ed7hrqPMPDBytqVUT929rXPnU3mKJZ6ZYi/UNbC458b/D0cpsWPeU7VS9gM2h93DpedTf8l0TvRFsXMYregTxT1vMms09M9yqMbTmix5aXClJHAuP5fMExNcVfvYYnETThuQ9DliwQ3F9Jgqe9NDcK2dlm4ImEKLpOU8/vdvSE35mT1rQzLF9zwiwVmr2GDdfAZxgmR2J9I0fDjE1+wI7V3qDh7s1fQZKbF3yiVNzO6uzSWtvmLpoYL0nQC3rdzKc4CY0x7112+dBvmVM3XtxTsloZm8A1mhrXOTU3uJVHx036hvYXHLif3z/1ynNuQviWXFGrJw3vp+hErZOcuvnNGDVhks92k96VX3d4bFsU1CQ60l7Tuz2uy6D0ZPyzJ60oJlj+54RYK3U7DFuvgI4wTI7EukbPxxiavYFdq70Bg93a/oMlGjd688BSGHIsWeDxHuwYNg0jW8rkMZopk9wLCv5p7671z6sqizN1MGNv7nu3c1Hj7noHSFqVz0wGuGclnxWejqWiOtUEHzP8lgTUPaseaqFfs66JB7dzMQ+KJ4+Csmh97hW4uzp+Ciac3KjnvPg7DB8sC6pdAcY+pzncONWhe/hxSaV/WIzd+xoycH3eZDUSt1whMWfHgJMT2JxjOsWnRSb2nWrbJ4D2sFj0fL8FlWw1gM02alnDqGJIew+mTF2BA7nrV7oRnusnJxnMOTm7Nr/ln3tGjRYaGZe5oq/uWCJZ3bm6noZr10PQE04p62Kuqeno+5FbfD0frNmJc6ap1ro56xL4tH1Xno/FE8fsT3rY5VAGvU6ezpOsu2cE47WE6cydQ+fqEuuRGNonOdw41aF7+HFJpX9YjNT7GjJwfd5kNRK3XCExZ8eAkxPYnGM6xadFJvadatsjhvt4LFoeX6LKljrAZrs1DOH0I75BcCvhoSTDcXekiuI4IIiaijDYM+Bk0tt4rd6PvVKbWxq4ca/9VYiD+DU83zU5doEiaSOXpkVPxs2tmrS35TGt0bwJ15y2LMGjJV9eV7dwstsic1t8MTozbVx9PaaPiuBe5ubeBcdPvqu6brMGA3ymSG5SER3NAKEcNjoHPA1X9en98ylgtTeWihwb+wp2nHqILi2iZsPTs/0hUudtcktbfOivfC4L1pJyG6dBV99AZlDJv03z+kWmVlPQsdPvTaW/WPPXslFOvFbPbduak6bWrjxb72VYA7Wqef5Gt/1JqsmdcSZ1bkWMrZE0x9O/K0RPLnEWFbws6ayNQO5zBpeZksMP35sMHpwbXxtwa3QI595ANPThMQJHqzrw6Nfc6JJPjMkF5nMMxoBQjhsdA74et5dn96EuVJ7a6HAvbGnaMepg+DaJm4+OD3TFy511u4ZIm9etAMu+6J15FY47vQFYQ6Z6v+r+gXAHnaqHpzZLAKdjz3paTI4jQG1fmib2g4rqXvwADuO/ziLksm7VoEPlAYkjkY73H76xv6gfx+NzotEN6N21+/ZopG9J96clknqvodGT87Wi58ZMiulk+v502TjwWLp5X66hZfcGe99hIPNvJsPlhnDJb85wbdNnl7WOEWaHB5h+t90wDsRCWsK27WphxM8/K2Hn/wLfgKKMxM1uU5a5tl4ZgYbfw00GPlVuP0F29393+Ptuqc+b9Uy3ubz4HNWH9///WzOMzxjnsGJ5SzJxc8rQRz+5BZ2q0kRYC9qXa9b6pM749szDin1spuP5tmO/OYsiXGTp5c1TpFmhkcI71yUZd5IWFPkXUud+8gGD5/cXslvDP+Jn5moyXXWZZ6NZ2aw8VeDwcivwu0v2G719y8AztQVnwJ7s/Sn8ZrDhbcaNhq5laBu1ybGsqamwltMDhp/U84K35tqEE7mjZ/a1D3ZHuGWynzps5OZORhx+gaLjQ7x5kQ3WolTZ/4Kkt+znj6c6E1pk+idf4f5whGZWl/ctLZ2Idd97+NCq37H+C03etHNuZAPltozNucEQ142vQKlZM8LRryx8Hd9apP7JrsEUh/oPPPk0d3zhL/nw3f9KrrlpRH91KP7Hkb+aa0WTj/12T0g3WqUnPxKMAtXcomfZkQzvPhIfXz/97Nex+tnwJnlPDk3rybxHD++/zo/zmK/1zmq/c7ts03+q3YJpD7Q+VySR3PPE/6eD9/1q+iWl0b0U4/uI6bX4LtPX/5X8l4hJZa1hnptrUnvxgEX0WnmlJP/gji0O6YiyPCGcHcK7ztGsw6XuX2BV131TrC0pqgxUW6zdf6kwQYzTk2Xe+74WDduIOfZYzjHHjfnrVrwrvepROPGr8CzzEDC4r/06fNFNxw5427t3U+E4WRPm4u/Z01O2NQFwwKibxunwi/6X4epse0gGOVvreHs2UUefBfmDDgj/KNmqM3LVHl2aEY3GDXBEBxfznCsN5lpMw5zPM0ibKryXNFaK/nptXK8e86nBBud8A494NREO1Tbs34KiuV093mZiXmmXur4YLcGV1B43zGadbjM7Qu8aiyd/QxRue1DFf+a48qfNKhgxqkBYM0eKrzF6d8zOccez5ouvdWCdb1PJRrhYnsImxnowl/0VGAausN/48x3P3GHnj3tOfD3rMkJm7pgWED0beNU+PH999nI3NbtkfWpHs8iZ/34fvHeIZjn6mP//P13f/Xp81/mfaRwRCAn6DrCEqkHe8XBm9g85kPbNcL22johhJccfHzHnq367t9L6jy5bmSuarw/sK4PnnisEj5HZgVsOz3yEiOY1WKYdy/P3EW7fjQvMDrp7xZT30PtfuR6f3Qw/w072hBZoytXf8NlCtd3G/N1S51zzTn94fQs/jMT6MESlnOcOprRB4BzYBYnaw74ULJSt7GdIx/O4PlHzDsn0o1HU+a4zVCc8GxrOFGvCZIP4j02jxnIcyUP5peseznWja8tWj4LsC7Ot5h85DvddZUNxhxeq3HqwYGtI+fSy/mDXfO4bhW7lnoLfXz/HANn8e61zvP2MvAe9DliWNGBN/7UN7h49d1YZeqjc9rRM1O30ZX78f3Xe99Huc/KkM6K9fv6/X+nd/H/zM+N2mi9gPh9JvPDAozFy7cXoX9AAOvCOO6XK1zwvODBsIVTca39w8gDrCHP/qmyjm62AWVvygqQCgfL/NlSbEB6uT4F8Ft7dNdspILHUuAeXRdO9hg98OmPD5ClHhNDQryx/OBPHks68czRWsH9J/fpHwWGjzPcdhKnBxKuP/KDrx7w8qyg8zdbl3WfnXuqbyn3K630XmchkrX7OdVsV565M7vc1tLf6FxUHTyTXNd2U/yLn7oGF2dqIPNXxMQhl8twP1zXmFhkw51DmvzM3DH4knZ+lZDWD/Mfag8SSF/jzrYuPCXRch95e+bgtzqIa+W5BRq9blq60v/4/uuIdCCcEeeS5XMWCLZxeFnL9Ys1cQ5cDw4s70ryxoQn3u8N2sE/vn9O4/quci5gPkMdHHZf+2MJDt+4+PtbSh7rZ9APl7iI9WQMrwdvfgvBMD8a1GrxzFeJsR/7/X/+/OX77/S3t+8RShPbvQtLX/kO74ZhDl7p6F8w3JkvQyd9+6Fy7uxhnhF6yunU6g+EqbkzA9Z7DZDmD9aU1ma2KVmzPWFIBT/tU+6htd+WfNTJz/lM/3p5rDlYOl4zsOGgQxtROZ3E+App4by9vFy3tfNJUHs+jx7TdGaRg++46+p/hQO+/kCMtC1a1tjVraW+d7RwP7voQmA+rK79jlj/uDHrrFsgdMX+QQqkv+EteEpx3DJnw6wHcbcyv7kbTx/nuz57AHs5e4N1i86L9Sw1H0znM+dD/YIuF42Obvbzx/fPseRMtr+xPrrL6BX9+P6v4xjv4/ufo8jPj9/k+//h0+d/qP/998P13wBE/vjhND/VgmN5GFmOFxDe7dVv8qIZOWPAhx9AXX2ZcOg1/TrN13X+DeuqfNuLZhiJY8G3T+wv2Tei387ylpbm3h/9zxmm60OO/9jn5BNvzamX88IVxignnpqtI05ezKSfXoHJxYnGWz02vn3qUhut2PfwaLzFica2qQm2Y84HrRsGeKz0iz3St/CJ8yA5+3f/m0IFe6aH9NTv3Nk78bZ6hWa59wLCe3r4i+b6Mwb82sybQ6/pZ8V6Xz++/zqMj++/X4q8G+s7Pd+bO/Mene/kjvku0bphgMdKv9gjfQufOA+S8+67/02hgj3Tmf7y6Vff6VcBf3niL3FEtj2H2QOHF6GdCxZ76gT/MfbsR+3Gnn7IPM10Yme8Z0rO2k8NNrn9b6S9VO69vCQPIHMF5nzBNq7/pcp//vlN63w+exY0d/wkOPlT6In8BrZn3z7avh7qpu835MKNfSh5hDxL7+usTbw5jyI/EuQdumkrpgfY0xHv8/qRrYaeftuevXaf8CKwc8FiT53gP8ae/ajd2NN39zTTiZ3xnik5az812OT2v5H2Urn38pI8gMwVmPMF2/jH95/TKZvzjb1n3458pv0Cn7WJN+dtpW/P8A7dtBXTA6xHuYnt535L6G8BXz794ruf/PBXv7i9HJD20PjviByaz2EGZvgfOeRNMHPE3pLvBLzw58pMJ36LH+qSn/p3OOecJ/VbfyC86JxCGeodm3mxfg6HBj3OPqfcEyc1sU81xt7Y7BvwKTNx9jGAnGMrO/Xo538dpjezP53JLg53Y/Y78db+N+dNjRfRtwH2unt59iWcvTwpLNotvfVIOO5DxT/zt+JvCPLM6N+yt6pv1Q8v9ibyTvDx/V9/0/j4/q9/OpzvgffJ7+bTy9nvVbgvr1kn3n0nm/Omxovo2wAj7l6efQlnL08Ki+b0Tz7rzwH4g+NPAiTjDzZDy+YDfhIF2wNtzonv891+9De2NxKd8GLBJ7cbH/7mH6n3w5zY6kNBetqKk/gUS98TT7z3G+zJnjqJ6ftWb+s8NHiLj2Z0M8PJ5Tg2tmvO2mh8zWZEtLlYu0ch1/293MV638us6Q375u+gpTb0NEM0rbXIN7y1flsG7fOf5ICt9rez3Ph7M3jmfhj4jt8peDoP6Ce++28/+hujtkcYnfBi4aRHuE9jbv5T/k0soqsP3PS0FSfxqZO+J5547zfYkz11EtP3rd7WeWjwFh/N6GaGk8txbGzXnLXR+JrNiGhzsXaPQq77e7mL9b6XWdMb9s3fQUtt6GmGaFprkW94a/22DNq/wff/s//5v/vFdz/7/he/0sF//zjT3uj42tz4qsLfm9xCb+Fw8rD3yQeLfs5x65BzTzRUkFy4u//muiYNNulb/NUHenrGXpv5FrFv4zDvuRh/43v/cHfO/q+7326M/tb8dff5tTHowXaz5TnXY0+M9TUtOL/pOs/11PN8GnbPuefa+Fmb+HauAb9iU7Mt/zQj8VkO/rVZmPstztYdX5rjq/a9Hm/pMuecVx76wqKf1NYh557wJZJcuGhnba5rpmkY32hXHyrSM/bazDfqfQONec/F+Bvf+4e7c/Z/3f12Y/S35q+7z6+NQQ+2my3PuR57YqyvacH5Tdd5rqee59Owe84918bP2sS3cw34FZuabX/97/8XdOt/EfzZwUv7vZHxtVP589+WB89QLyIHkIc88D65BtGMLhDa0U/uRWcEL2dz8aNxMZ6xnY+/a9M7c2ULm5O6r9nUnrzsPz3I0zd44t1z58ifa3PP3LfGX+tx6nj+BnNuhHsWNHe8NV76HQeWuthdu7Htb85b/lf5xxz8Y2b2R917+0m/l30l0RqE53mdNcS5zF8FuCcfzrlWyZm61Y9W9fz4/nVaPGs/7z65r74zLyesZ/SAAeW80wPsfKbEu2dq4D6tzX3Kfwv2tR6nhudvcL9rexY0d7w1XvodB5a62F27se1vzlv+V/nHHL9r3/+XL/8bW/cvAPQx/8Pbs1HC71Yfzv4vuwfv35M0detBmaMDTN1w0DvODWh+mNgHqZX6/UNuMFEyS2zqYm99ATVjYbGFkdq6xHvxLtx/u0Vn2TOa7BVon0GwLXT4rjv//eQaOpr0Dpw5bTnL1fN2thtP38aiEfi09Jp+h05ynh2eAPvljJR5YLt+P/uNU3XGYNRj+rIv7Da/6irf4lVSM23N7UcUXfFnfnCtlqhg3d2X/sF6Pofo53mAr37wpya1hx0Ojmodv3Fe0bqdA3pdh7t/yyAxK+NOfcHVq33z4PblOIUb//j+6xlz5jofn+l+5sE4wDeW6z6+/zqddXZzXP3ene/i7b3vd77/tJb50Hy2W3P7NOiPgBbmdq+VmjHiuO9+rqvG3/vv0Pevf274X7Gv+icA3336RX7W+Fz2xmD1IeOyzO0CTJ+lc+Or5uX3si4uPB+8LH88THxEnMPpvrcH9DBLZqeElRkyW2Jy5n6u18UPFL726z9YoWv5nFNTtu/r4YPkkosIf5Wre/a+e4wPHeY6oy71gOFlX2VrpujO2bSWZ9HNFm0ta0akIGP3vV41uzb1lAfP/rxRZofErffhX6isM8qsqYee5dk6yH6xvoTbStdrGtNKWOPWJccl2Jpd0tIze+KxN/71rqIRCXxfFiah91TXLb9mu83etTK3BSfr8oLIMldzeptOeg55riHBX8wj7pIcLs6rfr1DJq0b++FiueYUpE+lfTe3CzA7N75q8vxTSi55+8wujBPN2cEdXvetPXblwyyZnVpWM72n0apU7fPj+58zzvls20fVz+Z6HvNa4PB8IXLrZ/3x/df7nHeZMz0XuazLCyKr8wxHxzoLbi7OG95v8v1//q7+qb9/AfCTv/rh5yNOy9V5Dxk/A2ajzDn1xwanBlm0tYz1S5T4/GFhYm7e8P2H0G2G7pl5opneiWNnROma0zbz8WrHv/107XPZuh6x56PoJSdCenCu+GhbX4MQz14W13jnXN8TzR6ziVhxWZm7atAu3HrLL/SaI/EUNOCSrrM4guxXtnKVDGV05IClP3hmv9WJ4BcZgnTnPaCHls9m+ekT61k6bz41OMEYoGcFn6txqOwrsxGGg18rf6PqyJK6ZS7B1DhGV/jV3mQXhoP1vrB9QWDH4RDXHyx0P2f24pxMeYqYH37nwjEP3P8Hr840eGz2fum98sK1nRmuc3H/SnL3GkwRflTdp88JonNrNrDbIqfLdZ3IXj37MQ8UuDd+6sCTiGbbzPfx/fdh5QznvPrweB46RMM5+6tkPPJz1var5lYnwsf3X0fG++ez4Xzx9U+H8m3OQea8RTQXIo8Dfg47FsxXP6vWFfTph8/ffY+tTnL+4o//9P8Q+Q8BvRDxg1Y0rM7FhJM4NgP0izI/eMI/beqwOxc8OjuOj03Nxp78r/GSx7LWgfkkcw7hwXnigmeFi2Tqk/sW+7W6M59+36St4r3H31bNnmH77+hzNH6BMw91rMQVvT7rt3jh/6b2a/rfuL/Hd9Ta3nlNuff6lu4TfmJ5J17wN8706YxSG633OGeOWhb7iQ5x/NOSy9q5YNHZcXxsajb25H+NlzyWdXsexEbv/Z64TbMZzVW/81/z3zt/as98+n1N17Uq3nv8bdXsGbb/jv7H96/D2c/irXN7wk8s78QLTsJ9fvU3/5e//y/j9n8E6Pfo5wCzMsx+6Ukimiuc4CkGTy6WHP4eaud27fY3J376bx5YVvzY4Kknhp587M5vH369oV2TQwHvvUYD7vbJO+5zI3+uzd858LTCD2/7bCQ4tefcO7e1T254seEmjp39NCH45m/Ongeu/npaltlcNp541wSLCHGw8DJTLNz4p43O5mxs62/8LX4406eBzJg81tqxedBNCB+dXKlpyuwp3OCRAudMfOnmfkmG3DbzBo5m6MlnFmw41CSPv/tsDv6u2znqWBvDP2M4mQGfBWf3jx9brLtWzoRceE+9prZ55uZQhGXGaMDf/symhhuHl/UenlZwwtv+x/d/PVeeKWufUyGvWDjJ77qN5fluLP6TxpnLTPvdCsfaCp56hJ9nnV7B0XjCwPPOwKW/L926j7y/C401vwDQP/YacITTwFTELhFDuYUXu/E0D7Y3ALZrtn/ywj1xarjA0yuc2PTeVvSqSS06TbBWB5jMBe5rYTvX5SJdNWBTR1Ot1FRU+fjJYaljxU8Mhh+uOdx6bfzkhYM9eWC7R+L0J84CC/6WzsapQ7u3ZJmd37i5ZtTtzCWVeixXeNnz3kv8WDRSH991Lb5zyW/btHoOCsKPtZZmmpcqBW3hhXukHCaHTq6T9zRv6uDSnhvnMvMAOVE2PvmsYLHGlSd+miW82K1Dq43vPvB2bvsnL9wTp4YLPL3CiaX2XPtMXItOkxITRhMf3Bd4k2PBZzFLxAROXXN2jppdmxw2ePzEqQmXeLV76b15cLM2Hu3YcIjTPxgWLPhbOhunBq0+AsL7nEau2+Zt/2Jc9TNLJ59mzr5ioe758F3XGju3uSeemuCxxnko+8G0dvTCXfC4yaGTa5LtpDdh+LHG+sb5zTzGfs6dNb8A0L9uuH4rIGTWbpDYCQdXU3i5Ji/HWNvgDLjPBA4LPH4hlz78nbPumnFyDxrR2vbsP71XYjS7t+de+f0mk2OZY8fh7YdHIa/7TK3LpEPfYLGZJe03J7qxqYme8T6rcJKL7saTo1f6JZ+YulzJTZ1ImSH6qdtc/ORdu5KpN76KwRPi7/rtJwfXV4qI2998t+5zn6Max9lbr0Lq7l4bWH56pCc2FzmuxKus3M694A1M3bmfranczKC6+Omb+OwR3LyVDG5ozQeea9ELE7DrPPciJQceP2kwFmbn8BNvH2JwF75xa1ln4U/vldg64WSeKrzEg2Mt0TqY5MIm3to7n1yw2PBb1vXJRTd24+Nrj+ciF92nnGc/Ers/tWc9mrkoTT51h9zkwTdn5gZfCWu3CH70gbafHKW+Do2TT8zPc9c5qDgudutv/FazE6sGDgubCz2uxMVY984t5OZOXWvPfFtTueDQxv9u/l4v9rX+4o//Lf13AJ//8PYSpwgaTYmxWcknF9yU5oOd+eFBlOZtkiQP29TqT8HWh7vio3T6vzWHyx/qd8/s9dROLXZzUvvE3xg8lrd0zJB5seaItLH0e+r1rRi64UbbmMDoE+914ymxn9/OUYN2Gmwe8Hvr1IG7saeZzdEtfeDXwZLRUiK5Ap41d85lq8iaSAm7zfPOeUVv210L/hILS9s5wyWQ/kB5Tplt0SYXLEdCvHvG372iu7m7R/Kp3T3293jmh9fDZJ/Bn2zmdn8KBEx/ClZ81qd/7Jl3+UP97pleb9WCb05qn/gbg8fylo4ZMq/3DEekjaXfU69vxegdbrSNHbOAZd14Avfz2zn4aKfB5gG/t04duBt7mtkc3dIHfh0sGS0lkivgWXPnXLaKrImUsNs875xX9LbdteAvsbC0nTNcAukPNO+BiYu0coXOv/8nnH8CULnP/0VZ3UdwkAtL7mkA6Bk2+czEBvGxLFvtMJss9OKEF+6NJ43RxxcpcfjRw5KL7faOPdMCzpiBMwc0XwffQseNmj3vaKzalJgn3DVdFP6ee/vOh4vQoWutbhAt2+6T3rGZdZ9h+oUTS6vNS+/0gbd9tOGnB/lzbT45x12Anyt9iaMXbDQZsNet7zszuF+KlnW96pJ3Xxp38/QOTutwkckoG49PbRZY4tRMMTmIuplD0LXEXOmZGDrL/HIt5zkVb36nb9zUzSxLKznsk45rdEs+GnDxU2PL/BmgbTjhAePfeMTdP7nE4becDTmWOeX6Tu3ZZ8cMnFjubX4EkrPYuoHvecOLXdTidZ/MGV5i7Pad7wbM5cGWKPn0j5Zt91lUu+HSI/z0O7n027z0Th387aMNPz3In2vzyTnuAvxc6UscvWCjyYC9bn3fmcH9UrSs61WXvPvSuJund3Bah4tMRtl4fGqzwBKnZorJQdTNHIKuJeZKz8TQWeaXi9yXTz/83Y5sbr8A+PL5SydrAv3TAJGoqt+O4CYzXMukAXiGIBV8W3wkWXB3HMz6yYWsZHQohUscDWKDwQE6n5nI47sGHw5LvGh7nhUr6zLz+qb08IEyx5MPpjX/dXvPm9+ukdFM8gw9M0BmWnN7fHKenTnjC8gcJnUMlxUtbK7KMFx524YfLNyxqlGO3/frWWSzx+xtqHKesDrY1Ts9VyF/1kx0b3PDDZ8ZmSV1mRlg/MouVtiXRQ++jFdqCbafvsNTuipEowMaSSqBG93gYOmXYvNaCOOa1pn+RZ59NH473+F2jyVpd2aQNnLpT3Jq06eHEu4e5DefmuiBT/3Ck8f6okgL7o6DWT+53j+56FCaOBrEBmXhFaF6ZCYwfNcs/sf3r8PgPPoAfT597sGKse51jh/fP+fmv3w2vwvf/5cvn/+z9SDv/wTgJ3/9h/84SV4HfuetfxGgj8q/V7M/WL8q/tDqR5F/OPR3Vz+MzJiXan5gIZ4XTPW4PjQ7NJRIvl9hqJTe5gmlllyTy7+6EJP1C+o+1AhKnWeActVQ4SWqZyKAl+Va8ddcMxtULuvSqGLbbu08uDg+S3D2Sk39dcxItVJ9HtTDdyNjPTsYszGXZ4QCqIUuOC4329pDcqm1Jd9aJtsvDde6XjFWV3chJb+ivCczAznpZHm/CqIRm3xs/XBRNnuSC5eNeE+9L/Ks9DDHgKiZn9nkh+OC3DiY1qD2qldNem0cn5qs3poReuj/nBcQHrnCAC88fSNVT0oRrXsmFV5+MAroq9i64Mlhs6f0iqVGixpBuur/DDqOR44W5Es7z9WzQes+1nG/qqk9g2qBY6xmt7Cel7RnsaO8cfgUVVXpbZ6y4sHxbGjYv7oQg/oM4aLP3lOXuHuYnht6weFluVaanbPtPCxfxOKxUmkoeawAn2VTiSGbf5sRFeHCyHFZ2g5x7zc10vH7bm7NQNE1rxLk4KUnln3Fkk8M2X7VENK6S+13F1I63orynnx8/+e5+WH4EH3ePrR9gqQ4YS3B/7S+/7/26Yefu0ff7hMI/Ad/9Kf/pdr/237bPI9uvHk8+axbjMTKmcMP25BfLeyd7vfPRA7HLxFR98wHM0VuVz0rd/Tv+R5z9Fb+VpG9ZV/n8MlrgKRSn93rDxe7HiCD1l/Vh/posy/5U+dtRo1krZfZU59azxQValbP1S862TMVb609RXjzPJame80JDlOyNQP6oK6VZ91ORQ8Ofs4icc3rSKlot5bi1GccxPPhpLaOqrTd/JKBXI+iGq5AgIcmUbC1u9Yp1ZpzmdoDBUqscYW3hjLXzBc4rUTM3B6OBvXX1KFO64juWuBa1d9nmiGryunqsb4toVvHeZgMzvIh4vTMwSfXvEuFTK/7WQSNpZLeWY9nRbJ7zvmkyK2rf/YVLdt6AfpcM+fFmL0Gyt667vYg4SSvqfOMo5oz/Pj+ORGdRj8jn4vOTSdWb2Gn8i3UsapGB9olOub7t8BzyrpyF8dpSXx8/5xSvZvvf/+ffv4nv/z7/07OFHv7VwBOfP7yn/stz0vPKfvZ9sPIQ4mtpB/kfB0SosSXdMZvDIBBk4dZvgjSxfdH5x71Q99vCTNxMUpycFnExiq0DkIb77wPCZ231k6Jd72ImlOx09TjExjD6TOCYSwNhDvtwe27jlIomTHzy9aDdBICTi10R0tOakoprLY5O6wgass4Lh+9wt3FxJqLPPrXLAbWOKroLdUeEIdDKznUAsChx2BX3nildb/38lxHnUilgzI5Dw0aTdkK+66IvrngkeHG2Qn3EfaM2Y+1o0Q5NUcv7we8E3CqjT353r0Z5nY/AOs5E18Iec8RrOxwPWjnaJSBhJd0a1g3PoI5V55HrzWb88DRLLEi2peLZZ3WiszdV7GM0itnYJ+YvG6Du2edU7XvGQncq2enPZhx+cmhxzr6E0evuM2R8bNwksKH5SEbF+/j+98HwnPOmbVP7POXbWredz9Z8jrHC+tnQA14pREpjjyW35GjLriylUe7V+mT2UuRNOZSynlu3R/jPcFr372jRDmSRy/3A+8EnGplr+ZzHlxY9wOyXnK2naeH3OSx8V2fGL0MJN2SFubNKEWV/dpQ7+fPyOz18guAn/4LP/wdd6TYw9BIFwagdlg2SuYlKNrwgF2DJdCCn+U+DVgnpCZsbmoyg+eCLxLGh7Ls5udgYsmlxthqtFy060EHbJu5HSbXszAPeUIvOaHYdpx54YxPXQrlw+cyhNMrFOyaf140aKGba2IXr5x5IirtttYSCN1X6m5iLdBFFPpCTGvmr/AxTp89ZFrYcsuFZmtRN7XBmweeWZp+44JBhWNbJJ9ZZnY9PBGil+aZwfUIcLE6EY3UYr3aOi/fPSLWlJho7Dh8Sm5l6YvkTlx4yXTMGNHK3lLmehOqh/fQfJqat2bf/bqseum++wC6J5ZAi3xWzoo4dckF2zF+9uC5EFUhJjPFwmUR51nEGt+5NdRy0f74/jmQHMp+iPLzLGw5VK2n869M3ffz2LppYZueDU5bxecztEbjmSf9NhcMOffHAhD2PioonDouckOEoOV6hLhYI1Rhaqd386zVmvaLfrufOPFcV6uqSV8o7Ttx4Zv3V8c//if38guAn33/i18J/znJa7EBiWa/cbJBmpuCDSkWFfkJezZrz8YEZgPUw7Fd5ORdGLHmEfpqfGZAlwLh2NFQDAf69IELCVAL37FsuJXonAP5bccAnKA00zsWfuaEnjkyk3NKjJScHm2BqxdcOPQCXrFCF1Pv/hB6pS/h5AksEnD1JrXqKULDV9NlvMzrXIYHgztLMXIbcwwBpxcl1AKNRuvYkNOVWSgzF0fL+iKCMYtt8yePo9WyFWxA/NQP3OTUYD1ncz3TpTQe86A1+46OBa5c9mM71RRWMPWtNfO1TtN2pXsy16z24Vpv5yCdWi2a3tmjbRrGdn3CLQ1/X6aKCAdtclnbz97JwUPbFzf8tghZQjF2NBRPHTkn23YtWPBwLd44JazYiho4wfQgvXKZEwifHO3dD0fx0DsndIHLhwsHHeAVU4KwJZ00UjB8MK3JE4RnsHLArPAdKJ95oXJlmdf5JMDgz1JMq405hoDTixJqgUajdWzI6coslJmLo2V9EcGYxbb5k8fRatkKNiB+6gducmqwnrO5nulSGo950Jp9R8cCVy77sZ1qCiuY+taa+VqnaeL//N/45S++r6Lr/vILAKf41wAMPsuT9uYDStmc7uCNginv0q73gPLPg8jGRq5riZEcva1DTknyXtR0Hmu/sfjmKpcacPzhy/eMgE1ybePkaBHMHGFQwWd1rbUGLKdT1vD8DVhXFGsxlxz65P9F6KnlfuIYbz4dZjZ8A8WJHtBtdX+w1A7EDDdyz7W4Tocki4tObM6R/uimB3V7psGppbjXzKIYf2pWAn5Cl3aAP1pL05iT3aSNcdVaD43oiLt14odCbAzNrk8t0tm7cwC9XA+f2LdOoNcQtQSOseuaGpJFKwdfGKXDadd6d7jeoc1lpu4z502eRa/MbKDjxoHcuznAmWH2ItCzkdMCz1yJXUdO1+g1GK7rKGDRr/OZPZhxesBbva0LJMwcZCDl6pzMzEiLcMOD3q2hdqPWKmTunkGReyvIXqzbpclhP77/Obo6bp2Zzz8HmbNsmp9D53ymBiBdOq538sLwooud96Bx50xqnnzacJFzHk0B9nsGIfXu2FEO28v18Il3Qj4hl+dIjF3X1EDUalO+Ao+wQFzp6V+Y/Jk5x+3xFwD+1wCfP/FPAtaKeENuxO1o5nhjnuCuszfEZr1hKF3nw7xCFw8mTvzhm3HdRnNxPQbz6qLePYm1tl5Dg1OXPgX6XjUk90XY2qPZmKu6N755Bstv14bZ3JdoHI8+L5853ct7iQD81ccwmC6MVzu3GZWYmZTP+XAegysIXkK6g2FMrJhGe6bksJkhvcFyJTfacuAZR5+1SDOXsKR3Pnz37z7GokNRCmOjH37wLkzaYTgNQs0PbyDvMQWHTuYMzzOGq1qfSWxqY4XXocseNYQ3LQE563B9piZ2H+ki7TrZxyX+2d4AOr3sctsY/i5UnP5Y7zP5rsu8HVp9sK4v0PfdzsBoLi5a3p96pW/mijZCGQUhcOpuDQxUzjhxrq6hz2g2JmPx4Nj0CmYONOoTjFN8alzbPWavm9+5QJlvpNrZfYFmJgU5q+mHmILgow1GysTi0M9xk5LDdus5H7BcyY22HGYyjj5rkW7zVvaWD9/9u09o1kEzurHRDz94FybtMJwGof6z+f3/P5//7792/Rk/vRXM4y8A+NcA2sufXQfPzrh64frlycY7F4oPXJw82NRBz8MAC28/5OFAaP3hTgOQqz6wQdVYr2vTA609c3xbF95vU7f63Bkd0TxXQzN2eqZwEl0THLs2ETf0zIjdPjUbmzm6ELPPe86zG8we0xC9NQtwNNxXQezM64Kuo1YL3T3nTUN5l4iT/sTmUKzlPeEwQJt2pyb78gfX/aI3RV2cmTPTNFNT63qgnks14VsHjkijrZj8xCbVDZkbnqFJk+w1c5BvfLCQlt056COFw2zNDR7+bRY4TQyeOlLUTH1zHUPKBa5F6B5dcOpNLGJ86qA7RiC+7PQWPhwIrY+7697bBzXW69rp33g0M78tDY41dcK3f9CUhNBXJ2fs9EzRJO58p/tM8OOGnhn3voyJuLGZowsxt3OLYDeYfaUhemsA4Gi4n4LYc8hIuxydBjxfzzFY90h/qFwZIzUBwJNLTfb18f1fZ5NnkHPus9LR/Sd/8r//t3/JqZ/r8RcAkL58+U5/YIAUc/D1ZlS9G0zi/rCrePEM6AY/E4IpzqAdvuSv5sWdlv22ZI6tg1YWB5Dc+eKEQw9yaG9+6ph5/OZSG705I84KEXJl5m59NyjIx4AuIbejgH4HVIXclRg9eCFi0dqYfM8O3it8cPdBj9zi4LtOsGUVpy6DgRuTs3uYjx44tlf0PB/YSloLKBiAlk376TEcCHsuwiOGshfzzj6aOzXEIe+e8pWq2YbQ8Ym3hntQpDX9Khwdz2JCJYanOmai3FaOc/SOj1VoXP7eA2rRUupab8wOh3qWKeE50RjJJWZ+eKQ695Z1LfylQbPwkbfckS+QbHGnJbzUx5p1v3EO6ZEzsR2h0gED2vzUMfP48Lo2lrwhbHL3MYw713nGt27bvU9D0SQ4lzTQst7qaQ2ENybfs4P3yozgXNYitzierWNGDs8SvQeMteTsHuZDBHdB3czBpWfbylTsuhSY0Lz202N0otV5h2ivOPqx3mvyzUXPNdghluNeApWqPQ6h4xNvjeihcs4TTc9iArfFkwac9Jz56I1+bGqaH3xrocH64bv/qJzX+5u/APiTX/69n6vbz/1fF/YZeKg5JdT5dwtZDNbXbJpCMRT7N3uApwBq1uACwX1IEKsWmiPjV0/9Bp3OkG98ercMnMHku3/91hN0Z3W7mhUUbUzbxJphV7ccxG6oOTynq+tGfGLRGxocZOjXWna5ARXu3qMHr6SvmcAQKjk73HofX/gVsyVLz9yiu6J0lIM/fZzyeFBNV672SUVpjUwzreW+ZOBg2nqPii2oW89cHO6XfuVWndNWhzXSSFkPbf3luMsqp7v7RIsCiKVVBS3CnDM72FrG0bDq9Ddj7aNVuxB+vaM1C+V4utAzCEdr+laNeZ0iXfW6Ty/qjdYspMzjXhqJsbWE3/q0hPtUnb8pdJGnyDcTOri+xfSxtS4FFFIPr2xpVAqGF/xoI++9AHRNeYLBrp4f33+dG8dyvWt95n1mMrX6mXx8//UO5VjyjoLOu5n3zmfmzEXHM+4XtXDcLL+jFVzPhBjS///fv/5AoV/8zX/89/7rmuj1/uYvAEz9/MW/crj+hsZh1Lbs9WZ9RH0IzoLrkHIA1Dst2JgCKI3iGA+/DqoE3btfXmYKRyUTxXedhIkLa76C7IFscvD5a+c82Cj3oBOnVnvrPvwxFkGrb9TR1uU8c4QHTuyUrev7vEq3FO1nP7alXX3Q6F6W5LZ6oK9VfZiXSNN+V35qS6sj1dcfkhJd9Eqjkd5N605kaRrMuThw3PW95zprBWv20q75fV45W87Pe4JdM/r3/TfG2Vup+UjOvrzh7BVWz9Geey6+YdHAfaGJhnt171GvPvVMqyh1NX9poFn7LZvZjNMl+/OspVn1qFVMjSPmaaxy3OHUvXL3PvX714sRZj3f1m7NiuiM4NWnnj7Q1kj+wp2tI65p4fe5leTH9//x/fOW5Z3hZel3qj4fxXL4HmR538j6/fV7BLvfO1Pqzfz4/nOK92+yoj6/L1/+Ax3lm4vjfHf9A/4/BH759IeQ/MNjfhgcZX5ihfFgMsTBqhCu/kbEDxseeLZRyf6h7oD889o97KPl3Zx6mVs6TulT5KXqfWyd3WlzNv7qv/Y7OdUD9NyPMl3ueRxsHskd57SEu+7UA66z3/MHK600VJTmVAlmBurcsc8Hvyucq3MLgsR1lt5elVvjugls7Zr4de6L+4ZXA74mkXrpuebr86Bwz3o7k9FW3ZRG+Jp111tvtLuoSzZv+9R8bV1zleZVT8yqeQbX7NfI16xDZW/7vZu9wrie+7XxpbfrYKs23w3Vt9V7B7v2cGNcAdyP779Oqh/Px/d/vR6P3u29XYz13l3o9c7vd3G/vxvXi+2fT/4GpjTC2Fq7HuTSyEM0ePtOzppSevt+al719GDVPINr9mvka9bifvr+b/3yv/9Z+4/m/X8CoBL9E+P5FcSbHz/SHCKXxnn3b/6My8c/aw3t+myx8caGjiNsVVW/kVx10fPfzIT339T2PmrWKZ42m5N93ZqaqbopbWcP1moFPSRa0BnOBInRozg1FzhaSXWPFGY//kd9LRasqBTSC035WP1VR8MPePy7eEX7h3/neQ6b25Luc5NQQA/vhwRErrU8xwMenvs85L2P6ETzau6ezdmzXrhqfvghAjkIxdHaqUu33sHEvacuufoc5zNSInqmhx7zzEt7tEztPtIZXOdiP8/BZa171Lh9ydYkyo9O3gW05zkVLfeLG2TZ9fyqfuVurpp+fP99Iv2MiT6+/ze+iX6XP75/vSQ/8vv/9Olv94v2pvnqLwD++h/88O/rz7nu3xLYD4Mfji8/wDScH1J+wizurT089hLeSk79ym1e/wvtZNUAAEAASURBVCC/16ZP66zS4aXOlMxOcNTeYnKdz1wOdZsecshlRvAuqb+xEnBNwSbIp1S51FjLsG4Dwgp44OGstKnRxIazNfC5lJv5g23e0p0ZoodEc+mRPkljjQU4tdKn82l/60NOCVPbH5noksQ/8yEK95zhB5ed+ddn4L0sjs8ocTSiGRzrITdwYTtlXzf37kTO7latHhs3lf5dc3IdK++/uT5xUpBc72E/oz1T6DdLf5bsrjMm3Vv94jqfGzz5OfvA2KnPjMGalPO41aZPc1bp9EidKZmd4Ki9xeQ6n7kc6jY95JDLPOBd4vOZM5qCTZBPqXKpsZZh3QaEFfDAw1lpU6OJDWdr4HMpN/MH27ylOzNED4nm0iN9ksbO/rcOfnrhd8FA6W+B4hoiTm7VZR/W2Xk4LNV5zu5TYN1n/t/L7//7f+lf+X//073dJ3/t/Cn96RO/JfCHz/mnADlgWR9e4ufaQuHkYW7ewwPJS2TaQz4PzPn0jm1+yjY3lNRNHCcWAgIj4oorTph82899jIGh0X/P0KWX6Z7sGTdcNJzq/MwS8eDiBbLowh23jnVvxGSbQEj+LU7wWPrElyWcvQYXxnLv5r/5bKOH3cvCAqSJ7EgLt1b4JBZ3S9gnF06SIyYgteTkz14WPnRh6U16VhOM4esyr/G994amFO5oJYkVuJ+dUyGGFxW4+KkJHpu6xFgw6aQuqT13sLHRkZ1nO8k3nO7jZ7Ap5x6U2+f0wlfePaOxZjHUepHd3FDNY/a3NMARGJEmJk6YuO3H99/PJufS5zTviPA3ny0Pg7p5KClujNqmOCOetcJPbXS6fEzw8ElQkwWenCwzz9yND11xeneqVJpgDF+XeY3vvTeU7uaOVpJYgZ4jGlSEGF5U4HbeNfrfAZ8+/Yd/9Od//k/CeMt+9RcAFPqfAswfDLSa741lthxuD1KNSYbQm5sYBpiulxpyrNWzgL5vPPrfyr8JKUCr57Ts1gt3cQLZPnFDIJc5U0+uMe951Zse/kWr2VJDvdacV/ixJLe/9G84PBb5k5N6D3Tkw5UNDRlrANzAwjOrS1P/xH2ojTSWlfKXQInkbKMVkAKwxTPUc8xH2zG5EWwt70N+h6aEY6x77ec63HGqjDvQwOecJHrWnaLO8Sqeb3Fh8N5b03eRrMvtKQlv4dNT8MzX+TxvSpwMgTx+YvJgul5qyLFas4J13/ipt2jjbv6A7ZDruUzbeuEuTiDbJ24I5NI39eQa2+8JsOnhX7ROwCjXNn3DjyW5/fBOnJhF/uSkHhx/5+PLhiZGcQBuYOF5ti5N/RP3oTbSWFbKXwIlkrONVkAKwBbPUM/xe/P9f/r+X/wbf/B32NrX1jf9AqD//wP8eyW2DjMPlUTOOk9g4nOEVT8/QMAan4eQun5gCW92aT3hk44TKzJ9pj/FKzduNhGgbcJbz/eCFMSKG+nHssV7OuOX2vBlJyd//l3rgNpmuMFiM8iO46cmHOYnl2vh/rjEfyjZrPJD2jZ+a9+ekTCndQsNoe1TxsKy151z4gUoHkT/oSJdN4WrJ/WeB400AjzXkZ+WB06ZZ9y4BydxibrVismBBXcqeWz8S+LR87twchPHnpULn3dJHM8Ct/MTv1M/z5aa1M3GupB49bzJfQWfdJxYidB7+iO6cuNmEwHaJrzN8l6QglhxI/1YtnhPZ/xSG77s5OR/fP+3x1pHnbNaB5/v4Pfm+//0t//oL/6bf7x2+KY7r8ubjE788l/9N//G//X5p/+j3rB/3afKOaaaD2m/qEq9vSjKQ9h+w9FEwD0ODvi768fyJeb5ZdnD7v9unzeSOZfYR5qa5LymX899O0thhhH7ynq336od/e7n1FPvVYNr/V1z5kXwPwrdg8gn5AdR9nuUXQcO8WFFLvaB8gI9cZ8wDne2BOFck1QifuwD93x/0jP2LBnNl8QdSP08u3vaUXLhAgZ7ob+1h4O4tSbVtTv3Zp8pWs7uvX1RtiYVjg/OUnp2fyxfKp6ffmpI+W+ysofYRy01yfcw/Xru21kKM4zYV9a7/Vbt6Hc/p556rxpc6++aMy/Cx/d/f3/yTGKPI+uH+4K+AKmfZ/fCkJSeDe/Uly/f/61/9D/87IHxCH3TPwGg8o/+0Z//k5/85PO/Wyr6r5t5F7Tcs3/lxJznAiucgh7yra+sNecU2VRXn7ovcTf3f4G8Bnn3v1zOHLePcYaoeY9Gpk6vKzktUx4bivcSUGzchM4pRiSzOBTQ8ZFSthcJVrQqevsevprZnTOWgHthL8EZx/pT/KJfv9M7//03vOZS93ZZJ0W4cdxMOdmcTeyWu9UokZXyxNgXDIC+iLRQ9LqXdzN9k5SN+/+1d76xuqbVWd97MzAD/QNJpUBFOkagpUSEwT9R+4emtf3SRBtTmxijrbYarbUlTWqiHxhsjLHWpNgvpv1i6AdN2piosUnrh1K0GmNhhhpACYkDITCAiUNokYE5+3X9rrWu9aznft/3zGGYgTl133Pe515/ruta676f+3nfvc85+wy6HuhUjU6Hn1sahnU6aWLNJ+MlWFP/DgWUFR+FFDIWyNnnMsmbxCBN7SXcC4yF3jz/+1vQe+k988x+MnT/HQw0pt15NnRgxIj7Gbjy0R+pBHB1YWttmdOW8alefREMARVghpqCXVNuk4+0b57/2Jvcsr4l25ZGYt7jo92LwMmtLcGa7uz5v3zrKflzMUufyx/FP/DSN/56dPsmEu7ZIhwW1ul4kwkUSJNADhodbyrx3/ipxqbb4MP8sr/KzGirlIF+mlkwH6Ior+9C4biecalDg1nffs5Cx8Utr/fR9UBP236q5NX741j6Znl2dp3JM871X1nSAZVaQec9Od7fWLca2fp3JVebflapWguAn03lTcQdJi/3FeheB89IstugnXxguN+lOdaCUp6Ffe8o5J5aK2tITqG1pnWMz45A9ajNy3oZbb3IKd7gE/zKqf0i5s/6ahW7fnPdQRCYLXC/USf+816kZHZ59swGyOvwnpTsLo5WLTHiVUeIPdp31Zrw9ojwI2At8j0AFlGTQA5uKrkWEI61goy8B3zPsuVbpQyz85yDjET8unn+cy9vnn8Oisfvref/6vLwm6/82EPf7NXdyXzHvwNgsXufd/0jbKHerCqI7W31nKl86vU+Zqy4oPLNBis5W0y5cJ3zrHeXkJRf+dRJcT/8NMebhZDMcPTdUL6NVUZvqGlnL6jwJQgxBjMPDG+8irm24iASkxZXOqgRBDh6le209otEj+x8xbcfODrP/zbd7U0uYtILndGC7PCzVK6DkqtuftBkM2jO/MTLjqTzMkY99pzcHHkfItK8JKxrsSZznpdUan7Q+j4gpnXlTL1Em+seq59Iknd/ssUJS+3EmoVxbyhunPS4Zh4LDYYj1iShHGembPkDnF1VbyWQHElq/exB7hH3IxXUf2sSyzgseZU76illG24sNXJPYYw6VCyt7AFGrlXcsMl7GIs/wuFlJ3k/Ey2+yFnPesl0DzFHwjnPuTEVr3z2ndpUAws5zw2geEXi5vm/ef5/rz//nz8c/lI+CXd+/YK/APj6Dz/0vnikfqbf+aiVz/k2E+NJ1IOe5j5JDMA20osrv+qh3bKblQ92+H7awULmITdM72zl690nkjMvXLzJ+C99bMxUKEn1Ehf1initR/Eu5qLUMzFi9JeXmFycN7gKkyccmlUhGwYgLsAzA4xKwSztqKH6RVEdC8mJrGrtAHLMy61M5qkmnClSQaq+94ZkATV5LZ7psoU6GJ2WzkZXmSHX60v6hk9g7i056cvAiZfLeBYBJwNefxyI7ANaFhFf+YAyZ1hO76diXNqAHw7yisXMaAxO1s5w2YXNKWM6vgniOmkt3SX2MokvjjDkDQ671zgbG/ldMajO0XvVUhHbngmCLULSZpJ0i0kivbjyy3unzP6iHCHkIIFlDp9Jg02zrw0cvjEBuHn+czN8L3IrvYuxZ8twRuHa897outedC0N4y3iO6AbtYNyNsKvAro51NGcmrxteNbmfhZV+OxF0Gc8i4GTA67+bn/9YyT95zaMPP6KlfQGXL/gLALTvve/6H8bdemRXxxtOkDuw7W/BAHjkxtvzjZc/eaZsJ6YpO+wil6AZtNCk02NgzmlPKItBrt+NsXeAzXHcp1ClXT9mm2YY3zVGAuyKJ61ejAuANGI21nMHCqt4JbuudUq33RYZiSDBI9X8cLDn3oS7G5JqwsbVHmVcD6FMiQ364I2omtildk1VT0VY68vnEi/ZYVbtfjOwtmfjJBlO4bNCOPjsgfZByU6lQb5e0ipBJp9B8iMcXqQiQMySld8CoCJJvHPEzoxRw7Qd0nVUcBYOFGtTjROFCDlMz+i0FhWcxN4ljlNOm+L9gTqHaxg/c7saFpoAegziOe0JRUu1RqFhrlD50o0aKu369gejdcLAnj40UwdljwuAOEO7OW0kW27Fus4Q3sUm14mYMUk5hIOtcz+0pimpJmxc7VHGb57/2tPa9pru8Pm/eOSrD0+8dW75ndpP6QsA/eNAF8/5QT087nRW7DeKEdzhhoOpMzAOiGkdauP0A2H8kD37YO8e+CD4H/Gwhg80fpedwsQ70axjIzC9ttKa/hGhanSpMChzrhQ4Yz1bc+XY92zckfgRoGpUgfgOWeMErHsBcCqfzO2KpHBL86oxY8MeZgqthQrgsNy4rHWcR2TeS8eP6hSOuF9wvWjO1Kk3/N1ZEyEvroOHvfpCoRkGr3N54cDEfbEO+DmsQUx9xiw9ixZhxyMXAcVGYl2P9dCe4+b5j92IPWTrvM21pe3P/ZJd+9zbHQYc81c8OGM9G7Ny7Hs27kj8CLA/AzfPf+5H73cZeg6w46XQiPdeD2NuM/bqC1paSJ3Ll+TVxeVP8pf0y/2Cpqf0BQAVXhP/u+D47ee3dXNeiN8UZtPnWloXh2/+5KClXMyndMkxVpzj5GQHYL7hNwFADdfBnfyZd+Jc3vG1V/kVNEa6AzhMlxFkh48IOK/FHM3lrPjps8cMHug+vPjELQYgBq7xrkd86uGfetMn7mEN+7NXx5j9Bdmqr1wByelVoGkXRHlqnOurqPuFLGu3luYiSDMCzacGr+IyOedYhJ50mDOBruXYEaZq9j0L3yFzrOF72/lFrOMQKzdjhs8Y67PPzIs6YB0P8+xYcfjmT5J0ycXrlC5xxopznJzsAOzuiQkAaoAzz7NzzIpV4lze8bVX+RU0RtoDOMzuo+sKnBdwXos5msvZ6Qd2+n4Wb57/ZWO8kbnF+2ttIBBecz8VK+7M+f7shU57U88I6dqJ+QgTgMPFL7zq0Xc96T/5O1R25lP+AgCVex+/fjCmR+K1NTffFJSoS+3PDOXDXAkOpRYcl3NYx3sjHKB+BIkTGmHVcxwANi+GH4T0jq/oTPxEEFedpdjiTkrWDWJznT0KZGJquRZQvzCwPRSv2OQSn74PJh+2sivJ5D2xrriVd4x6U0/xuOxiBZ4ceIwZm/ZM0tdRToCsQy3Xk10OHF7OQZk2vnRPiOsMRXzFw2Gci2f2+EqJLjPIu3jRSDf2WOpoTUB8r0xsf2hZs5/L0ceJMh2aPWLrnJSYNT1Dst11WimNU2UVqwS9Y96Obw3XmjdE9w5+vbJqXsGLGwa2+XO/Jt42nIl3nJm4NHXZMou7JYoDsbnOHgUyMbVcC6hf1poycx9mfKdVzs3z7x3KWXsXmzv3aiLOxSdm2n2fCA7yLl4E0sTPDXJDImGHR573/OufPEe5k/gX9QXAH3zs4ccOV1f5Nw+9gHURq09XM7bb9BBRblnpitebETqVEDwuk0bOvmfgtumjdXBqkN9hTvhTR/0Hhhgvj9ZoY9MltOJ35Mpby/OpNVnePeGv+sIYOLWDNHu2hmfX9TwkFGpuG0ZuewvHL2enzrR3MnYKgOsXOr73ji1wlzpaHwn1ExdzPKtU1dsdglZLw/glfOSqTkSFj8vkkbPvecZWMbdlLHnHfI7Fn4DCEHJ47hsa6zBuxlWHRBXsugOk2uGv/NWHMmN6fiIgzbgo5wKlv+K9Xq/F3EkjZ98zOraRbp2qoxjxJ/GnjvoPPDFeHq3RxqZLaMXvyJW3ludTa7K8e8Jf9YUxcGoHafZsDc+u63lIKNTcNozc9haOX85OnWnvZOwUANcvdHzvHVvgLnW0PhLqJy7meFapqrc7BK2WhvFL+MhVnYgKH5fJI2ff84ytYm7L2MhfXdz6nvpXelf0Hftf1BcAVPnGj/7Wb8a9eHNXnI3OAzsa3+0teD2ItXrxJxjl8jUVjrBN1+k8uUgSJ+aXtIsXkxLiyMmLfc0mJNRtnOwfqOGepREXa44yMo1z3Dj6ZjA5psBy6fwqVDjtARoNXATCBWM6M1D7oKeN72EcM6C514ROlRSWZAzZcTEvoyeuYCJMH36B0plZYsSli+FRAWs4b3/CnCPme+D8nGcfk9O8CM44eIZnbOc9E9OowFG80l43+ZOYKDLjttfa0y9pNeg4s+1TGnAcb/7CYQ9XDbCO2daaCBq/CpevqXDmEnOdzkcMTZ8tYYhBiuGZeuJkWFf7mhuYOOdGWFrUIua4Z+HjYt4oI9M4x43z2cN3zJg5d34VKpD2AI0GTnba7h0PGaBTbtpgPIxjhjD3mtCpksKSjCE7LuZl9MQVTITpwy9Q9K0ZO01dpTv8LLRpOG9NQ/GdI+Z74PycZx+T07wIzrj78yxcCU6cQhU4ihe+1h1/ePvWVz36nvdW9ClPs6WnLAKRfyDo+nD9Jt+YFmYj47ea+FueHQs868NXOgzPnYgctv7FMSSKvPFCz0GwMfgb04oZpGBcxFU1ItsQjh8f2fe2AYZlTc+Ryh9J0g+wlEZqUdAlWRejWx18JVafYMdCT2sS8vgSOEGjmObiZc1woqhWPfcFeTWHwbrDGXwkGNnvifoGCCQoMqqTl4qhgQkeY+EdcSJvSN7X+vv4EZQOWjWEi+BJfTUe3OKxVnDtV5VctzKW1SychONi0g5xwqGhLiKyqEKGG/877aiaZ1Nnpg6DkOZa1r5nx28zC2q858Bva6H+GOFwUrdDCThe2Xrw6DW+Nzi5fkA7ta5ztDZKSuPm+a9bvttntmfuu/xd7MTz16Dk6rbFLdFc95AtVySK6m7pfhaIDEEGcRCVynOaqez3RH1pJ0biKZOmdYnFS66NhadjgYw5kTfk5vmfG8gm7cfl4fAf4p/7/a599Kl5X/TvALjscz9763vDfkQPPDcz7jA3lCOmW4uvuLy6xP2vA+C5DwTCkSPduQxJh6DecMD55BSZAz5rqQ8CQN0DrmoTUKov03UNYpIQp6HZW8Q4tPqwiZl+G49VnHyDRCj5mrSO0ouA+jM+gGitA15yMyMbs7Dm8EAr3IHECBaF3LMwfUkMLv1CVU8EokDXJS6Mwlq7ffB6M5GROvTmNx7CGjQy7fCzXgZJq3UZOPnycqQTMfq0DIIdBx8JfJni65K9wCNpcs0K+W/Wh4Tzhtkn5SGOmncke68WtNfKBIaYNeZZHWGncy0i5jqyt7SNdw1yisXcvUZAcRMTEld1IRxY3xsCegMOvDRKSHRp7fdMZ2RqFtD35Ob5Z0Nzg3TWfLPYS8JxHtgyjZi1fcYHwme9EIYVt2lpFM+cm+c/tqX2VNvORZuT79Vs9l33/MeP39+6PPz1vOFf/LWOzBcvhMIHXvzHXn+4uvXr8WbyIinGButDBkenPMrpTuR98LlXCKcNCIkt+JYiwNiRM6Rr0jqtun4iXCOA0rVG0YF1qI29tjzrzBlmCWgy3/1CXPHqohJLj+pPxZLXmpFYc2tg2/NuqReWuWrOPVKndDF9q7B3PbvwUQ9emBi5DdKu+991CocOw/HV917eDqNeQqD2vPdAcalvlxGb+yiAF1t62p9qs/sL4Lw9ySt5eOfGkc4IuG9zh0610ksTxNRwlB+zJXzjco1BcI0gmJNaKeZ0821UreaM2oaQY+SHWnjGeM5ktFBfNO72eWsNmOqYJ1xFI6HciiENnmFAevJ3IfRYKMM1whTGGkomrENtVJKpZFrHesLGpTZUk/nmwF/xU3DpUf3BYVi6+GtuvwfzPbdb6v26ef5jK3wftLdzU8f71W6Tcx/rVjD1fvYtzOj+6jrMGiNQZ8WZqaPSAd1B0v/c9cX1NzyVf/Cn6yzG0/Y7AOi++pP/7eHry/j7AOyw1loPv4qyrBjEmWqWzaXSMvwwgCMXQ/O8KcaTsK28v3OJhB9+MBJAKQaptPJa/FOxCWtbdfBKCH/tWZqluBO2ShU11xh8ZO0XHFclyBHzHlc+J6GSm+amozpwxU54tWAJMqqreCZdU3tcmuCl4h4alJmuEPFNL6LgkAVgkH2oDoKbeTAMYtj2beA7F+YeEwk1QQKzhJlkBtl6s19yHU8JU7dapSXh0nPIMzkGWl4/jvOKC5FFwnTKc2V78nct6geQX+giLWLVQD98hbyA6sOuhAUoLXOIzbj9mGVKYF8ntQrAfirABdEYFZi1Faq0cPRXw/zGOGAIvm3mEBaEArzQIqDgJjpd80/FirGfVIdQMCDhrz0Tc9GdMHGGABvXmNKe+wNaZZxTICLm4GsIlfc/zToLkYQbr5vnvzaNSWZsCnvD4LzWvuWGZ1j7FvG+J8bMG0DML2jYc2j/XStm5xUvYBVwyrNl4hvrv/t0fvijS/mnfbz/pQ88GL/99BapexVUmvas6jgxdzRjEyuRAk1N4n7YV3zHLTr4O2w5wKxd0OzdNUqndYtnjlzXQisSw000gRI3r9yVbljHJ966kwtQ8Uqq/qjnZog3Ns2j66rbADdRAT85xs++XNozlNW2rvkTY+yd1BDPhHCWNlVm1lAgLoOys8nvctOJ3NS3rvsUEYFIrDhkLNy8hDqc9AD6/BgHdQ5pRWCtcQozY9ZzL/M8ODfxxqnQkphcp9Z+Zp/GMDuO7bozRrwHiQJNfUS8T43FmHGLDv4OW45LeC6ZTat01nprP9ZecYoPcfOqrU4330bMps2Z9OTiq0Vdal9M6GTGh4t5NFbdBrjpCvjMG1+l1ZdLe4ay2tY1f2KMvZMa4pkQztKmyswaCsRlUHY2+V1uOpGb+tZ1nyIiEIkVh4yFm5dQh5MewDg/cX3rax5994Owns7h0k+nprTe/5IHfj76/mF92aQHIBfShbQB7aUxN4nI7G7Fr9hFKl2TDJ6CJwlbcEKRsQQI51b5jX2M16GYZINDZL5BuM6sYRuKa5regRVUPpM5OwjBSlLfgz6nT9xQYxSbweIQ0pi5CKjMwLjcxM+aC30nueZaIyurWe/nrKMeRi+CG2Bu5e2u2lMDTOfD2PVPosC7eAlbB/fINrew3nzjPJvL/8+C2Kk1W+LcDM/j1H0nRzsM8vwfNWXHZfaR0brSTyThCWO/ZmPJr2PVxPdY8SvWuN1sksFTcAc8diYUGUuAdG6Vnyor/ub5358L9sr7h7E+J95j7+m8BzPXGgM4z5/r+H5oNmkKFX+GDLP01LCucgHc9Q+xwLt4CVkH98g2t7D5IL3tGz/+7h935OmcKf+MjQ+85IFfjR9X2P9txVlxvul4s70hxikeF9/U2W1jnAdcwc6ZMHKEyDvE7GGe/ZlzbM4Tr4c8AjvtEFh733FCzHjr7vJucuIcq9n4GZbWyLu3XnQVW7nuofEOxLxiff9cFyj2HOY4ttOdxAJMvLWIrdBdzsmY/cDt8sG3hvtgdi3Tidk+NZOf45Qm+RmfNdbcqoWvvuNy6swoF5hVE94acw8z7tjEY3uttpkZ5mI/WV/GWsv4nciqGaDb3a/b1SXXNUtnnq3OAWS4sfTEdYjZwzz7M+fYnCfe9Ym1dhin7qU1GudAzKc0SVt3E8+g8UdaFRBvJk0YtZymDsNrSS+vphkLxmubuVMcx3a6FnIyZusQIs0gtkJ3OSdjvt15MkeipYtt+rQdmzP5OdzXjGHPuNfj2jM3eTtcgGtfL68Ov/kNX+D/4nfKPpn9tP4dgLXYcx+//v7Y3YePbiqboY2NVcvmsgxjHDZEG1UOh8kHyodx4necIDbXiQC3WQZTx8I2h9mvMHe2enAwZvhgpRNG58FEkPiMCRcxOEkqDH4LZUyYuDDPw24NzSoAedBFzBg17Jo3fcWWQLvFNa/nMGxXlZ6I6xUX9cxMNi7M1ibUWJwxwJzKEZOAjMDUPKhnTbCGewYsewSsqT4j7tnC+Io5wFx8c5WK2JDdOcQ7Z7EIDFMS+K1ZhBUDUKm4MBdMPGGJ1wusAcYpNi5g4fm8uR4Qc6RXHPUHp4ArHg4v8rK5LMMYhw2RVjm9BnQi5npwJl+cuDTXYoVTDWvOWNjmMPsFftpar4MxI0VekmF0HkwEic+YcBGDk6TC4LdQxoSJC7PXKz2wMaQ1Ak0XMTGA7Aof4ekrtgTaLa55PYdhu6r0RFyvuKhnZrJxYbY2ocbijAHmVI6YBGQEpuZBPWuCNdwzYNkjYE31GXHPFsZXzAHm4purVMSG7M4h3jmLHR5+3r2H7xH1Gbq40jMkf3Hxv170+hd97nmX//VwdflqLZCK2hSXjlX7jWCEuiHh20vjVEwZdnAmLbjwuxHi5hR1QvuGVHBKT9y0jzAl4ocV7NRtfASNId/xKW7bgHN+8Unv9rrwaDOmDLaHa5/FTaJJjsXs+7krAM6YMFUDHzscp071m6j9nrhHiOYbN+eJ81PatcPo/CA55pmUbWYPer2Te2auefJr7e6JnLV7Lyo2obat5blrrGQDIr7bpxJybNY2pTUdiFmx4KrMJNkGW7Vknqizu8eFlR6EGEWRfbYHZZeLRSwwe5pQ44gNe4VbxtRTvTjn+QhTIj4n4KZu4yNoDPmOW3jOBji2+sUnvdvrwqPNmDRsD9c+i5tEkxyL2WdqVwCcMWGqBj52OE6d6jdR+z1xjxDNN27OE+cHrGuH0flBcswzKdvMHs/g8395efjA85+4+PZX/O+HPupyz8T8jP4OAA3zzwVfXx2+O+7wI9tNr13UFBf/OWadhzwNp5YLIF46JM4Xad4Y32hDyPnlA9N+GNgM168yuwAYSguYl/wbtQZvmfyb5unntf52qaBx6dpoJkJBm8jbdm/EmudggXgAnHPKGuQQ63hxNKVNC7Nn1S5a29ZjDk2tvTUVrB4iWCVGUQAa29/CBxTY+fA2r8CeXKcoKZT0+MGdrZ5wATKeRvSQwqggE2HVTptsDgqM0a4ImXCM2b33PSRWL6EBmaBAXhyCr7YqoBsBJHxjPAsXKevXvPtb3VCtybwb4XefZg0MdXiN0JHfegFyHcUmqUC9FjQjb231UHhNcbl5/tmk7Z6zhet9J8Z+ec/wDfK96LyStecEQ0y8wZF+FtGt0n2pokxF6/s2qNzPm+efPYpNYq+0d2xQDPZtt9e1p0rWxSHfN4lETjcC/uGR64vDdz/TH/50063iPJPj/S99/f2X15e/eriM3wmIQWH+8RE3wNoVi82ofyrFgdoedq3+kR1t4ClcYrgrrUEdmCmedsViqppYaTOrL9XASz6zeq2G3S9xIVQgrOAZh53sLJ7UuMYv5+hzlMozhUaCEQgsiFqR44OkLPGECT/XL41KJiz2Jwp0rwBiTJ3N5lG3eK7Nu1vlXNbJ8BNBfg63PuSSW/Lbx1IEGlwKFos4+7Gur+sonx57KGzfmxRh7RrWDMc9EzeHtJAFz2YFBtZDODA7vUw7PGcTE36btQA0MUz3o161uFlyy0KBOPfT68uYEQLmZdRxzfkc7LX26u7MEj2Hkee89jEqeYuEiQszw2fRfSookDm5vrynYgS32I2be2Dl5OuWR3pDqIKX2uWkHFT/IzpZacO6pPvNTKjWmep4aOTat4rZEeJbjjWA8PD6Sk7hm+c/tsGbpL27zTPTe5u3xM8yG5n7SDxACuSU5qZpju+c7/nR4Sm6cEi6x2E6POeiFXyrS5zv/Pnwf7p/3M8117l2Yg0/M/6Hf98bvu4zz7n497Hk188K3pxtB7eInpYA+8FIXt6avo/h7hYSTj985ACWZN6j5KMl3sDrTaV85QLT6MZlF1smb6JwYOI7Gn3ACpZs9Yo5hlyKhLFf3wCNvA9YKkLbrGRE97NHvxsJhtCsQxCfLwTS3siJpYLfZPXGLHG16+0syp7vB0y6keoa8Hc9Vx2Hq15/CETcrakX9aq2dSl2/at+hOjDUUGOLi7Vcxh64INXq+i1Qa4lpw5rCSv3XdmM93U7B/telr5YFH+j3gUnnzXia+G5+4ZRmwa0r91YnjVIxhVMvmAzUSiU+YDfkcLZ7h0qx2NS1E9AJF8J5z1vCqm93c8ts2Hd6Bbx/dyvA1yedVTQhNEjnKwTCXKQSxJmdpwMXeNivHa8/EQMdONcCTVQ231XnzfPvzbo5vk/OkF5cDhsJ57/+Cd+H773BYdv/2L/Bz9Z5M6u7vDO0E8D6qH4OwEvuO/q38Uz8s0plw/R/gE/Vygf3y17m/bzuawSwaOARtYrR9Pp2sWZcOxTw7U8B2avaRELBHC2o7fQCrRGYvPDk6LWQLxcwnMoPmooN3jSIFi17KvZIXSkPzS6hjVKzmWHzK7nXXzdHyfXOmt8+xDZ9vccp7i9FuNinuvt/HGt/UbXelf86see6sNVcq4ZTtG95Vlt5F2+cc55NiDnXD85RpPKdnzmsOewbu2pfht+0QmXiN7IuwYaG3fbo+KK4Druo3IKmzsx+WGeH8KOn5qt59zUdazm2QfCbJjGWj9Tx7WLM+HYp4ZreQ7Mdj4hWMQCAZztdB5iweug3Dz/+/3zfmz7672dewenxm4/yxF5zZtgvTmTqxvWeuf5T+X5D9lfu/f519//pfzwH6uqxXwJp/e95IGfjUX/2MmSu032jTAy/HkDHWZuXnHanyDbq27FdxwwMVyPHKPC6TgQSXGdnEK2mT2W+oYg7npATSm4YP1uVSTlDFz1ScaYmgpUvAsQjJi0sEvbvHIFUMzAc/Mmse3L2iN1zMeeo+Kqa4znwO3i8EbuyJ7p0YM+GNCKmPcUm2G5Oc+E6ivQW5UkYk56HjHpRdy1hS2dU5MkgnR0H06BIzZLAtn5XgwJ20O7YytvwSO60yUfo2OhKXkHmNfh+ms8fNOUWnHhey9WavOK0/4KxF91C7PjgInheuQYFU7HgUiK6+QUss3ssdQ3BHHXA2pKwQXzWfVGKWfgqk8yxtRUoOJdgGDEpIVdDZlXrgCKGXhu3iRSyji053iSeC44CG6A2e7k3s4OfKeLj4afwV4PupU3fs5wLOR2CLUNmOGA5xGTXsRdO7BXVxc//w0fe/ffEPVLfKHDL9vgXwyMjXiLNmzu1drRydzRnRksEzyTwvYw177nGbft2ZgTs27m0O+ycBkjl4E7uM66T1FnHDIV7L5m+Vlnxhd7LkHt3I43+7VtPQudiZ/ssbimWoqZNR7tr2NVQ24Jty1ycQtHaKc140vOfWqWaACMd6OOw12Hc0/GWfPoOIY9GjnqpXJ+E2+e+4Mfo3npHu+B8VW33zBLf/YgCfdnHkFixmOGrXtHLuyRIrIbJ3OL3knCJGJ7mGvf84zb9mzMifnm+V82hT1jzP3PSMawjVnipygLxK7mu/35v7yOf+Hv4Qd3a/oSOvOp+BKW3Uq972UP/PjV4fCP4z4+b3dg+k2rsLuD4YfSh8hJL8f54DrVJUdOsfJXnPw1Z65ni4bfb2gneuCwQ2GA05xTxq3nOXKuv+5D0U5PXSTS057oqnHyTas4rukeRPe6plbZwmGX9g4SMa9ZkKrRN+aEbuvthM7oT8yZ+qoVuFW3ffM8l6byjnlec/YDDMQD7qnfVj+3R+K5IeZTwz3UbPh6LydVOQeC0FhrOefZi7B4xH0ezFVq4a91LDdneNoTByPQZaxX9V1zQLf9XbAtghjD+TBbX4l9TqHCrjj5a866noem+p3xxcZl+FmYrXa/g+P66z6kyplrF4n8tCe8avheOuV6+K45Y9pIg5dZOGKj/4ZEzGsWZPZ1Ch+g1muRMs7gG3YqP2KrbvvGeC5B5R3zvObsBxiIB9zbPP8BfSy25c3xz/v+C1O+HDNtftkHPyEQfyPp1+PO37/t4u1a881Y57mUmSOOXsQUntoEGBETZPgV7u8yS0JwX3iQGH3IVSBjZ6+B8UPWGPMqR1zaVdRpNalkM9MAxwDImL4bdywRx9eq7Vp+k+gZRifDXvVmzuq3w8y+4DIcG7b3ylJzX8QprPvsGIZ1C9O5J+vVvCiqlgo/2/NeHNW1tuu7cdqJHOuxjvy1txM81yLVw3WYPUYthWbOGGY3cArvWOm7591eIhG4li/sFqga1GKsedfI7Ha14Ln8qgXO2pvKFpt6YQs6tUdeUsNHrmNhyJ41wmZvGOyFhgqUfW4KzG7vwJlXOYVGzKaaMJ7ZY9YnNn037pg561y1Xcv3vWfwnQx71Zs5a98OM/uCy3Bs2N4rS2nPJ66w7hO3h3UJWAD7yXo1LzgqVfhd2Yod1bX2rIMdQ9iLR66vD9/72k8+/HAGv3zXZ/zfAbiTpelHHi4P335xdfFrifeNio3szWdT/SpV3B6V0+HoYBgIlB4HSQ9qYDvcRt6cLZEiqlF82bpErmbRueDzKmxYORyffmCKrmhTit8U6wYK0703qYiKK2ignVFnaG3ZYY3aRNVfcHbzgB+tk9ysgc2L0QsKe2KUrMvEEzI3ZvUQIe5t9+Pg4LEPuv/OlbQmcMTXnPnMczgeeFMMYVYdGdFqJZzvNZrIXLax7lOcJpZuwIUrXq+7+hM8ctaiHnb7hdM0tHtPR95ahNY6XkfrLnW0pFpXayNYNbXG0kV/N2ptHWM9dmxUzHu13j+XFq30XNNSEi293qPSVZhL5cUdPhqq4XwHnEiq9qfqWwuohuPTDz3pVqzkM1i5rltAMF0HngIp0PdnieN2HfDtkFkGuapNRlD7nicFvXUQcw1sY4jNuO3Jn3ji5sZsOPdHNjEHB499UNy5VZ/4mjOfeQ7HA2+KIcx9ViLp/XdevUMycdiXF++47/mHNzwbPvxZbbeM82wY8bsBD14crt6iXrzRvrGaybChStY8Y9iMwBjWy3TAcyI3IHFGbQs3WTd3xYNxzJzineQsGKDiF6dt+8wM83ybqqaXnqC8dl0HCys3bLnLuqTjnHmuhT81hj9rtQ3Www2uWpE3TKkTee/9Hrjd7tmTy3QP1HfPniPkMq4tPFiPEnK+7/nMYzcgE6K5jmdzCq/wbKBqdVMTX5yz53zU8JqZGSrhOuHv1uh4Ybu29da59Ai7Dms3bMcPTI+q07VnXewWaMZxbGBECV/74RmqMZ5nzNKR6/ST9WEgM6Pwc+2OJSCuK6d4JznWLYw0HPO+KBgX94o/MfYjv1KUCqzOLQ4DrrXCllu+e5SOcyINDv7UGL75CgXm5PNyiluS8NSK+5MQlxiOwWeUz6TQ0HVs9tM9LzikLCk8AY8Scv7kesA2IImiuY5naxZeYYDBvrp48zd97N0/K+dZcsnOniXNuI0PvOyB19w6XPxK/PjR/fq53N3GrxvdPzVuesyB4VfcyPyp6m2Z/EiTfi4YVNsB5qbHn9nkP0604SW0O4Rbff14VECzx618drT5m2XdTWPLZYwrNTfN/Klz9czBdS+BmT9wJhprCIjXlbMy4m0Vsg/jco3GwWc7wMDYxuxqi2IZFxxoJ//sC5iEC589hDP8WFNJ9T2qVWaNySlmEPa9BiZi+3tfokySWE9FxrUfjUHf9Yov34AlpjB457HYsTmibvdrpO8jOHNzH3QLFoVswbjUlkLde0XUBhhG9sS+ek8zzrXqYM6fS/YyiMfYOpRItpmpurqfc31Hnl/R434/4Hm46IbY1RXsGDO7s1IWcz33ltnd/ve9CAz7d/P8a5O2szLvD7u63j/vuHGxh9yim+c/91E7JvORew4Xf/FVn3jov3jHni3zs+KPANbNePXH3v3+z372+g1xmn6BXB4v3rSx8k2UKF7msP0fjDyInMXG4ITHm2AigSlINIH1Jkg+Q7BdNyA8GXMkvfUym49JQgHAh5tEaRNTIDwnKFiDx8yVSOuxi5lY9y48HtjCB5j/lCot54yUhmtq2WLAipFa3pfuXYLZX+JKXKHkNxZA7Wui0EwWX1xhuXyuJmNgkxqr7fuCaq2t8olDMTXxcyROmeoLNkM10eHehwOGEqmSWX0wCEMcLbCugZ94CZYmdvYRYllKOGOyd3KlR0K4ZOGqQtRJ/ayJnefU+iBrRDKx2T3eej4A5DrN3/pTZNRTnUhva406FKip16cIQCnIE6a1QG73TiiaiMHVH/7ZteO5r7kpxPC3/+AyEp05YaQLzrmNYyz7HL82DE54N89/7ELdFzYody73KfefjdNmxX7l/eG+5m4ax17GECzvQ2N1G81PkBH/nz7/b+O3/J+NH/59CzGereMDL3vDn791ffEzcQjv51jlYZoHzJ3no4+nh5yvQtPJmUPfB7tSMem8MisfRn4y5NmufEzD0tvtxutc9eQ6nidSxXIVou0u25oSUf0HJj9Iwo9fWlto+40sJc7U9ppUF2T1Dj++2CGtIdzsy71kzdyMrUZyM5d9oJx7id60HfUa9jPorUbmiu+e6FUfoDRr5TmnhnUTU7pi5JtY9hE86YLKDxTNFctbtWljeVB9v5bZJzmUkA9kETftY6ViQ+zWsid8r7mlorXsYF8na0pCdV1n7JVN95eLhBIj6sR/aHuu8CxctlZXvWbd7VmMIlt7m5ZqG5syCSu82t3yeW+qjhqxLWDoUkaiyu4vqUxM5+Xm+Y/Nij3ZbWHtNefr5vnXWWJH+pnV0do2LE9dnrI8XXkVh3MWr+aGt/cvHol/1vcH4++3vSMVnp3XucZnZ4fR1eHlf/L5//OJxx+8Phx+MredYN6MeNqz76M3QMK6JTXj6w5jJN/cDMR1xQs44gKm74erIcVVieqJeqNk997xwnktQ76x5PQ7Ewgxhnb7uyKK7gubW6meRn194VM42y7VNSFOLQCuvc6kIuY97v0KzrCtgPLROOIbPebGLPU7jio5BrwxRh/bOkZe5sqtNTkcGHWDFkMlRn/Edr3YZyYZo+EiR4BEB8uPqWPTLs5cS9XzbWy92Qe2ZNY6J/zJc9Ojd33gyq8gk+57GLKz1NZ/1JCm42qkYs7RB8Masy/CCMfYna/ByWRcZwPD3q0JsHOeJbDEHXOP5YtS/bVNLpyd3Ohv4ryWIZ97hUQAb57/3AefqX4OfB9q70/G6z5ob73/tdE6A9iTX7meuFEMc8PXg5VRZ/SFQDlXl5c/fe991//oS/2v+m0d3bnlVd0548uI5McFry6u3n7rcPiWbKNu3HyYSPiB0uoKI4KX65uaKv2QTh0djlP6AhWRyX5pLodDwCfrpw8i6KopndC0fB9AMB3MtXqJ5qzLtG9tJNru5F5XGC5Vy/vhWXlyDGtMrONrTIS6LDxFrRmOqIGh5sk3QWtVDffq8E5v1iJhHzv4roXrQV0G+3oOI8DKl5gyeSlfe0fkRG2FZzwCu70GUP3A3+Vcr/LTde/Qj3gKDq0dMZKl17xFw/ujsHtaMLga1saxLjZrnjli4Su07AepU9wV675Etz5c60EYQ/zwp07vbwRnPJ0z5AjrGRxpzCfrR7XMqX79LLu37l2Ccam1mOse7RvG7GXLAMioOlsyYl1MiLxUTLrB8azk1CIwsfijxuyLlIYbm3WtGQCFq+Zd8fxfvOO5lxc/8qpHH3pfLfBZP/kOPOsbnQ3GFwI/cDhcviUO2P196ADc0SGLU+UzptV/AVvQ+guHOGO+2bpGx8MQv7g7LcDETbL+iNts3MSoSPEdJzaHBVyDXGC794E1tENozuCwj9ZU9WdcOoNj3VN7cKof8KKPtTWX5IgLCziG7gdG+OY3z2sSMDGY3pO+l4XD3/3lJiiugw3VfcjJ/C4WGI3SLNjGPcMzbl1nEkOxAaXP5JjnkVIO3/1iB07QiGmPllzvy+RN7WmDYRAbw/pZaNQZ3N5T1x+5lorYqkWu720Dw1h1igtEKecn54zd+gtn1zONxahJts+A+MXdaWkxg2T9EbeppttZODOuyuPiHLNH1OneHYvZ0A7RzwwO+2hNc31eB0KDY91Te3Cqn6YPveaSHHFhqRXD+05tlQ9c8+AUrvdUpMI4XzNa55//R+J/H/kj3/Tow7+Cwt00WN1dO7YvBC7u3x8C3e1Y15zHMvu+z+UX1gdkUnWQHCgd4eBbjLj9qVt4cJbQHBjXOsdz3viuZX0SMazbtvsgYNvzxI8YuF4TvBruQToOel4LO15auJQ4OVzbgNLqepCcKwHnBD3Fd6HIGeuQZ3OVt4aTxbPrGRhjLle97QIFAGgCITAxFKp41yYR+YLgaTS2cvhgir4ZM2iRBqWW9X2GG1Y49+K5C63aU7dFqgZTxEQBV9yp2ZTK77DwrV9cQhqrH0HrMjNENZ+AOXMmXqNo2wcE8cJKe3OP1lQS3YMADtbaei2OM4f+bIf74VrCOzk4zitlbfJeK4kYk3oSa8CKXzRVz9opve+xYj1Zl0BpKxcaaDEWuQw6sfKL15w2knZyP4w5Ud+prWjtVSR6rSd4E+9WmWe7LOxweOzyOVc//buXF2/7ox9912dW2t3gn9qiu6Hv7vEjv/+Pf83v3vr8D8SPDf7tCN6fN4llxd3SDdONioPopfqGF0ZKE9/SZUze5FTaNXDnoXeZgvWD4LjfAMirxKyDFvGK9WEFrARGjeHP+mSt0fFVLwDGYGAz3Ep6AxMB99KaxMyBaOeUWMSUDpx0Au7R8KVH1xOu+Obs+pw8A5irVpmZqRgU11V+xHsT1HDSjq7OeQYQNq7HvIfEZk2fAWIn61nIfe3ItYciB3/pAUkN58PpvRy6hTrPhxcvrWPyVvtEnb7Ho++dluPmRlL5qtm9LfWN2W9mkqa+7V43ggQZrj3s1hWgLqO3HafSroFLHcaUzsj+9goToIkXiURprLo+R71BFhYwnZ1eSfmMgbBG70dwu07ZwnEZozERM3fWUh68F+7ZMWZG1XBPwDzQYKw9up6SxZcN1gZzOcIv8dmrUoE1znUlMeLWO9pvgIfH4qda3vaC+65/9m74c34t+cxlt4VnMHdF+Le+7o0v+IrrW38h/2jg4n41zc3VgRoHRyseN9oHwHGIPhx9oAkKUDlsE8/ljPE8KCUFU0N9YjkxtRNy8hx2f7fhNWbVcV/FPbtm92J86KjfySu796Swva7i0MKQ2dnKOWk9grcbS2/uyw881Ja0EbGmjRjYyfe5Ic5QDmNwjvAGDpwxLdBCgGLge5R2Q8L3fekYWHAx5jrxK7zrkTij+aMG8d0brgJcagTJPGZG1yjHPSgeF/dLenKmDjUbB9FJSE82VqyLBM+meinf93GXG/XXOOWPeiNYosq5Z+KMUzljPAdsV0vEvBCXROk08BRmxERqciRc4BSmYg13X1Xz7JqtaXyV2Z2bte/Cdq3R2pDp9t2u75X30/Gz89Kb6kUB1uLheq0dCadnDPzkn8rFv99/uPq98cE/t8f23Txf8rcw+dvIMS5/+6UP/JX4Hwz9nbBfT4Afcqq7qznvf1zrhuePcnBwMgQnR/zQUWiGuKDJc64RYaiuMIqCz1CB0Q72ZcTzXxrK0pFNZYz8cSy9IdNHYK0Llz5A65e1gaBADv3oQ3Ux5SsUiOIKnapZl5piNWbDZs46W43STCJLuriOkBrTnLVIe6S9NX2cA0l0csPWuq1SkG3aEtorEq4Rtk32wXvXwQhFeMI3Mawii1vACt2W5yVYbPrYrLHOEzUUQlfGKVLEvA6nmcEfxS3kRNzJwHmNaRszxFzbtKnfezfwKmxSxG2aHxz9mFT7W6uGeg/yrBINcOGZKLuNcHy+dR+dCeQEihg5C4hTvinrPOtMvnFuLWbvY+89bQXOEtkakYhr32TWhfcQJZIQYJDJz/1qNDmvK0VLL7UpWOEu3r6ruamqkYQ8Dyb3kx+y8V4ZstkT+Xy/iwS/3IvyWkS3mvnNxaIXnTVsBeLC5uUvnMyEbr1fg4rRHaTb9cJFlHXTS+sAC0d6afnqDLMGawLXfbAXEYFeY5iqnGF6jXF5+I3D9cUv/Ou/9ef+ZQYuLh588EG93vKWtxQoYPFzf87fLfOz8h8CutPNiw/uvm8cprgp8n/qW/7Q23/5b/7ZNz7nOff86UC8/fLi+nEdFB9m3aaABmd/x8JrRex0tiqjsyMuueBQg7+xGqOlIo4GR3wEqzY98Krawc96k4105FcyEHrsHPUjZq2WUDBTmYUIMEbUy3RYjhGuICHtQ/i2SWEHhl4xE6MgXgxF05QUFxkZw45fA6X41sOJZIC1N5DmK/4nEgpIDF68iGiCFE7egLJzEmheWLM4zDJQmYi6NxHq/C69OdD31A6Qknqdrz2uSGreyFqD1YG4vnv2jHLl8hwlSXZzSgh518mGMmH9PltoRkqvskHic6mW8TgHCmNj0HrUyPsWjrA+44CKXP1HJkOElYqL+vYMJwYx5cOes2qCFShn7NInqpxw8ipgu8SGfu5d5btWrBOb/VOMS9jB44tl5HNUXPscEd3zzOZ1YiMPX4LBAxAv4ehnDlykgWE77dlYMCWS30RkQu85xbO06qr+xukiUgkx60kzBORHMtbl1K4FOXGRLnPWF9h2hXKy4Eh6gdo79j1fWTDwFU9+8SxDEL7CscJaX36DNWqITB4ol8Nj1xfX/+z64vI7/sG3vOo7furbXvWv3vve917yyjoXBz78/UWM58rdNZMXc9c0fKpRvhCoG3Dpr8yYfbN+4j9/+GXPe+Jz3/Xci4u/HLf223Rq6yBIb+xC/m4AUR7MQHPKdADrDI2T2/lAbfa0ELbP7ELxJUl8SUnPqhco1aFU/Nc1Cw4PXKplWjChIwqv/4Yq/G1sNVNZmRLSsiyKRtMCa2f0qBVc8mFbWgGabyqbQOVLz1LpSiXMKMgHQyfNcUNGM2dMUOMnDFvFw5iL0htDpppWvOwi77HeuuoNmq8poWm/zUc+BhoqJY9L1nNcs/TDmlwSK1tCxVQ+5UB6sBSd6zgr2VRlVCPsrpECXhOliPQ6tNfJ9bpy3zkd7EFglQ6FIGk/VDw5FjvE7/UoR9j7XL3k3Yvs8PN8p7b7kRb8xrk2Mc55rtXfhVoPilalQJrWqExvR7deNSZONpfcAKijgbC3zVCKi589AdFkgGO4Bia9lW62uYFtdbHA+flnzjzXFJ74jG5PMgvN41rNCpB60MVtAWtXw+TVXBh8BZO/WEkN8HU3ja0NRSF+xj3X6DnQkkOINaHCBXCMLBUBfbKCJSFUw9JLwqW+mLedMrmC1J7s5KlMXLx+I/Dzvcq9gNzfI85b8vIpuLi4dbh8Z5zzf/M/7vm/b//5V3/dY3Be/OIXZ0Nhv/a1r22bXH0RsIsRv1vGXf07ALXJcU91FPThv278L/3SL1380z/1io898PGH3v6jr3nhd370+nOveuLi1l+LrwB/Q8crqBwChmb5cpTmUCvHhVwcYEXCzoMcXtvEcoAppAK8dTKQI149J5f+9YDkJJDWxAFNEmxMjTYiGgD3PxDCJiyutQYLpBvxbEmzNETgQj9BIx/gbAWHxyTeoEtPU14UY136TzoRgh4viWmeF3TwE8GVCum7VsyFSRSgiJGuQKWjJYIxnGcmyasoDiUs8X0f4JcGSyLO7L1VDDnFUEA6/0M3Bz6DfbKdGfpSjjIVYnKs3tFVwDWyt0BU460ISTXDENiCKc4yxBVVwASU7zWRkRQ0weKtlgD3uHw8bQ11MkhIo7ZLYeqJEoqpiahlKlMSrsWsvUtoaNabdtWqZUtPQIEpXXsZOFVDPkuQVJZS7E3PuTCiEWZ9G7fPvupdXYFDAAAJWElEQVSKRiv1ip7Eimv8UhgcQXxqlG1Y49SdOsg+kJSbzz9mL0nkxKZOiko/2Hh5pagQcclo+jOeENfK+135miQB3aM1MTLBurb9rY/hFE2WOFziVXF5ihcE23XY886l4RRrw1a9pIa9nSlC8nvDgh9iLeci+tAPsA4PmBRDW6F0w45I5Jjje6d3PnG4/Infuvydr33DJx76jgc+8Z6f48P/He94x0W8Dp/85Ccv+Rzx4JtLBjP82N/4ejVPtRJ30eWu/wJAD0ieKt1qbkrEDv7u//u+7/su4uZdvulNb9Jt+fuvuO9DD3z8Pb/4Y6950Xd+/HkXr/7cxcUPxXc9/zYo+moPkG4qByRGPgRhy48DyXfaxPvwcZCIcRiZk8eMRYqZ9x+yTgtNQMFK6E0JmxGIJidMh3aTT2r8cYNDyQps9S4ffQNinq686j0xkdWvnKGlFsR4/DIQEH+YRW2CbFLtDzXRArMNqubQQxxZaxjF/kSwUXK8foc1J6ihEVN5yPlL+5b3IpLRF1g9nujxi6IEVVx3Iu3we487H8Hqg5CG7hNC4aEvMy5hax2EVSSMggFNQs7yM5jhwKsT9pG+KKsvtpJmuVxPrg4698c5fdcMX5Rrxd1bl6q15AdgAFUnssTh4ctkXaGhaLZUpmJ9xgIMXi+tgDOBH0Fm71XY8SsCMQsfJ4A5okAraAWVUpiUiKJKF23dJxRZP0BdwBQLTuSY6NV/5ktWg4XyYSF4aERQuZSMXGrl/kZeTRAMVNUUNYD8GToja5dOxHUWLBpzmgPrnLihrVlT1oFBXeqhBwQXSFySLi8CpUtcwMKVRPYNkThqMCKZmxccpXTJePFBote/w5iVRIs490GfffB3GqUXMZ0F2lMvCqiD3DYSQa28HF9qX+0iIC0FfE8QJRAzv2o95Wbv9FiQAGA/Fsv55Seurn/0PRe3XhIf+n/mh//A1c/91Uc/+Ngb3/jGy3jxwX/BZwafHzHHV4wXfI4wafA5U5818mMfVKLSd810z13T6W0aZfNjcAwOcVMu3/rWt/IV2yFuno4G8XjJ/qqv+qoDN/nTn/705Ztf+PkP3XfffW9/17ve9Yvk/9PXvv5bn3c4vC425VsD/K0RexFMCYfD0JtJBPMRQnh/3+VHKLvZuPb7IZkBHdr1QEexKgxU5nggbGb1yPKlnHqleHRBAhKvGMbjN2fXO0CvJuw4z3rTIZaETTOQQutShQKUCiR587NW+DEk0VD0VSLfrMAGxwWSWYAmS0YXbZ3hKPNLNSmkSlE/H/pL//Z5gIKi+zI/KGslKS6puLB2+onhtnacLKFkxiEmvqahh4gk1YHa0wcP7ynmIBg25PzFksLXLyyN2NUIRdBNCZyg7BcWL6bUTgdt4sSwmXx3w3bvYWqEvlSAw8PX+xtx+HwHTXKOxBERN3C+j1ApkWXIzvMRiqpHDciwShubOuohedSVnnqgGrsSEEz3SrRqElayJOUHQ/i4StV1HM9k66Z+YrN+9YW02sseUjtrQ5Z2B6cRGdUwQk6E0LGdePkRUg9KZTfAjCbCFzOkE59ni96Ui7hycck9Bmh2tQIz9iE/x+LNJDaw+2ke+VDMQprzAze5V1ldRdl/jZibgk6FbakGcRqtJJP6rlJQ5Fci+yJqQjMilPdGeEG0jscCEb+1f/nO37k4/PYPffXvvJPUvffemwIfx8sRnwUy+PD34DMlXvqmkg/9OXR2OXd36eh9ukv759D2GvjgZx189z+/AOB3AJb16au8z372s4rHFwEH7Mcff/ySQwH//vvvv/znn37h677y6uL+515dvu6ew+WfiKP0tUF4XR48HjUfvG3WWeDEV1Z1w1U8YMpwiZHHRgc0nreYFXcSP2zigAknQUab5GrwYKCBFsMYzwXruoClXv02BwKlTZDDd5T1VYbzMXsXqD0ZreU1FKfj5YulNarxrkhx31lB5bsapSJQ2moWpt51UExT/MBlZ/mG1x/s0kM5RgATY80Mq5r2Bgy5WL9meMFwD2LDiTgpj4CgC851ExD1BI1La4ZJLBtJBZHhx8vxXiOBeKMnR5Jf8PHCVpgUltcHpXqWqbQYSTLLIVERqw/8jnNqYg1n6tCLPhh679Se1jbPuWx01CXi4GLXCTB2+xsV5z4qB8jgso96DRlSPbyICoSr+nHR1kbYX+yIOOWhSAzSPiGPnlCLnJ7BgmiFyimbeUslozwIuR9ZCD/PbzJVfF1xpVwsa5cX/BqSQtu9s5+p77U0p5YBM2PFwxMlAcrpPhRKuayXEQTC8tptFw7VxFXBcNJPjXnNd57Mag0k2efxOxPCX1586Nb14bcj9+HPX16850Of+cx//Htf87lHYly88pWvpJBGvc/b5ZtC2fUFgL5JDPvAFwL8MQBJfjeAvwMwvgggHkc9nu679HcAzu23NuMuvXhN/guB/Pb/JX+Rgz/L4bd2YjQmbvzhU5/61NUHP/hBDoiW/MQTT1zec889B2ZeH/nIRxTn8vKXv/zibZ/5qj/yFfc+90Vf+fmLPxxn8EVXh8uvf87VxSvy2bp8RZyKOKOHF0buhXo+gsez1nap1duo3nDyMQ9m/srnRm0SoF19VOvQ55urQkMpFxVoJGKYMwo7B0DpROaHU9lQY/jDJKMEUqc/yGIx1VHl3GZES18lioemPxRak+AYqcfWFUICCWgObUTzvAko5gTYGP0Bw57xK/KChOHfltd2AtYNQTBy0WfqcTWXGmmnStgazEKXBl8Y5Ifk0YdIMcBvueg/amovq4f2A6+eKRsltAzmqaPqBaA/krTEhK577jiYcMAwg9N9mdTJA1uCo3KeQ8jxSpnNFNzrooLXG4n4VWXDZN2kiZPgu9Ua1VNiyEVcMfoxKE2l4qI5UsweyY/vR7UXEaWUbBmbLik0hnZqRCDwhDtXBdyO+xImqrOfvr/SiMT0zQOvhqpj3QfF8tIc+EHiWeC0syZ42rY0tQ50vU5Q/CqlmJLrzVeKi/j06zV2sOlXgem1S7B6oCADDenHFDH1Ta7vp7pRznsJI0fg+EX94KgdXSpdcTx0A/Wp6OUxvgiIvzz9yVtXlx+/vHXx2K3Lw4cOVxefePz6+tEP3zr8909ePfHYz933u/8n3q9p8sB7Ne/j6DDii4AD7/F+r4+5c3wO8E1gfPN37e/+/cGfbLXZ+BEr8+6c/h9xqdLrPl9CZwAAAABJRU5ErkJggg=="
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthMethodsIcons/Browsers/ChromeIcon.tsx

var ChromeIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2",
                y: "2",
                width: "44",
                height: "44",
                fill: "url(#pattern0_1114_7744)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0_1114_7744",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_1114_7744",
                            transform: "scale(0.0015625)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_1114_7744",
                        width: "640",
                        height: "640",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthMethodsIcons/Browsers/SafariIcon.tsx

var SafariIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2",
                y: "2",
                width: "44",
                height: "44",
                fill: "url(#pattern0_1114_7753)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0_1114_7753",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_1114_7753",
                            transform: "scale(0.00277778)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_1114_7753",
                        width: "360",
                        height: "360",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/AuthMethodsIcons/index.tsx












;// CONCATENATED MODULE: ../../packages/ui/Icons/Banknote.tsx


var Banknote = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _alt = param.alt, alt = _alt === void 0 ? "Dinheiro" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 14.3882C13.1046 14.3882 14 13.4928 14 12.3882C14 11.2837 13.1046 10.3882 12 10.3882C10.8954 10.3882 10 11.2837 10 12.3882C10 13.4928 10.8954 14.3882 12 14.3882Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.5 14.4783V11.4783",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 13.4783V10.4783",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.804 18.6913V18.6913C17.299 18.1903 14.715 18.2523 12.237 18.8713L12 18.9313C9.366 19.5893 6.619 19.6553 3.957 19.1223L3.804 19.0913C3.336 18.9983 3 18.5873 3 18.1113V7.27229C3 6.64129 3.577 6.16829 4.196 6.29129V6.29129C6.701 6.79229 9.285 6.73029 11.763 6.11129L12.236 5.99329C14.714 5.37429 17.299 5.31229 19.803 5.81329L20.195 5.89129C20.664 5.98529 21 6.39529 21 6.87229V17.7113C21 18.3423 20.423 18.8153 19.804 18.6913V18.6913Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/BanknoteInput.tsx


var BanknoteInput = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _alt = param.alt, alt = _alt === void 0 ? "dep\xf3sito" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5851 16.8943C10.0129 16.3221 9.84169 15.4615 10.1514 14.7138C10.4611 13.9661 11.1906 13.4786 11.9999 13.4786C12.8092 13.4786 13.5388 13.9661 13.8485 14.7138C14.1581 15.4615 13.9869 16.3221 13.4147 16.8943C13.0395 17.2696 12.5306 17.4804 11.9999 17.4804C11.4693 17.4804 10.9604 17.2696 10.5851 16.8943",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5022 17.4804V13.4787",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.49826 17.4804V13.4787",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.0002 3.47449V8.47657",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.99902 6.47577L11.9999 8.4766L14.0007 6.47577",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.0015 9.47699H19.0028C19.5335 9.47684 20.0425 9.6876 20.4177 10.0629C20.793 10.4381 21.0036 10.9471 21.0036 11.4778V19.4812C21.0036 20.0119 20.793 20.5209 20.4177 20.8961C20.0425 21.2714 19.5335 21.4821 19.0028 21.482H4.99693C4.46623 21.4821 3.95722 21.2714 3.58196 20.8961C3.2067 20.5209 2.99609 20.0119 2.99609 19.4812V11.4778C2.99609 10.9471 3.2067 10.4381 3.58196 10.0629C3.95722 9.6876 4.46623 9.47684 4.99693 9.47699H7.99818",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Barcode.tsx


var Barcode = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _alt = param.alt, alt = _alt === void 0 ? "boleto" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 3.47827V21.4783",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 3.47827V21.4783",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 3.47827V17.8783",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 3.47827V17.8783",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 3.47827V14.4783",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 3.47827V17.8783",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CPF.tsx


var CPF = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "cpf" : _alt, _color = param.color, color = _color === void 0 ? "#53565A" : _color, _height = param.height, height = _height === void 0 ? themes/* theme.space.x6 */.rS.space.x6 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _width = param.width, width = _width === void 0 ? themes/* theme.space.x6 */.rS.space.x6 : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.091 8.15901C10.9697 9.03769 10.9697 10.4623 10.091 11.341C9.21231 12.2197 7.78769 12.2197 6.90901 11.341C6.03033 10.4623 6.03033 9.03769 6.90901 8.15901C7.78769 7.28033 9.21231 7.28033 10.091 8.15901",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2 18.5V5.541C2 4.414 2.914 3.5 4.041 3.5H20C21.105 3.5 22 4.395 22 5.5V18.5C22 19.605 21.105 20.5 20 20.5H4C2.895 20.5 2 19.605 2 18.5Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 9.5H19",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.4 13.5H15",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.0943 16.5C11.9193 16.061 11.6493 15.667 11.3023 15.346V15.346C10.7153 14.802 9.9453 14.5 9.1453 14.5H7.8533C7.0533 14.5 6.2833 14.802 5.6963 15.346V15.346C5.3493 15.667 5.0793 16.061 4.9043 16.5",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CallIcon.tsx

var CallIcon = function(param) {
    var alt = param.alt, color = param.color, height = param.height, width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.287 22.147L23.723 20.5829C22.9417 19.8016 21.675 19.8016 20.895 20.5829L19.6657 21.8123C19.391 22.0869 18.975 22.1789 18.6204 22.0229C16.839 21.2429 15.079 20.0603 13.5097 18.4909C11.947 16.9283 10.7684 15.1763 9.98702 13.4016C9.82436 13.0349 9.91902 12.6043 10.203 12.3203L11.3044 11.219C12.199 10.3243 12.199 9.05895 11.4177 8.27762L9.85369 6.71362C8.81236 5.67228 7.12436 5.67228 6.08303 6.71362L5.21369 7.58162C4.22569 8.56962 3.81369 9.99495 4.08036 11.4083C4.73903 14.8923 6.76302 18.7069 10.0284 21.9723C13.2937 25.2376 17.1084 27.2616 20.5924 27.9203C22.0057 28.1869 23.431 27.7749 24.419 26.7869L25.287 25.9189C26.3284 24.8776 26.3284 23.1896 25.287 22.147V22.147Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.334 9.32178C18.7087 9.30312 20.09 9.81245 21.1393 10.8618",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.91 7.09082C22.818 4.99882 20.0753 3.95215 17.334 3.95215",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.6787 14.6667C22.6973 13.292 22.188 11.9107 21.1387 10.8613",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.9102 7.09082C27.0022 9.18282 28.0488 11.9255 28.0488 14.6668",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CenteredUserIcon.tsx


var CenteredUserIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 36 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.999 */.rS.colors.neutral[999] : _color, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.25" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16.0001",
                cy: "16.0001",
                r: "12.005",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8164 22.0025H11.183C10.7738 22.0018 10.4421 21.6701 10.4414 21.2609V20.6593C10.4465 18.9473 11.8334 17.561 13.5454 17.5566H18.4541C20.166 17.561 21.5529 18.9473 21.558 20.6593V21.2609C21.5573 21.6701 21.2257 22.0018 20.8164 22.0025Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.0003 14.6656C14.3443 14.6656 13.0012 13.3243 12.999 11.6683C12.9968 10.0124 14.3363 8.66752 15.9923 8.6631C17.6483 8.6587 18.9949 9.99638 19.0015 11.6523C19.004 12.4502 18.689 13.2162 18.1259 13.7815C17.5629 14.3468 16.7981 14.6649 16.0003 14.6656V14.6656Z",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/CheckPayment.tsx


var CheckPayment = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _alt = param.alt, alt = _alt === void 0 ? "cheque" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.062 3.48228C16.734 2.81028 17.824 2.80928 18.496 3.48228V3.48228C19.168 4.15428 19.168 5.24428 18.496 5.91628L10.722 13.6853C10.534 13.8723 10.28 13.9783 10.015 13.9783H8V11.9633C8 11.6983 8.105 11.4443 8.293 11.2563L16.062 3.48228V3.48228Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 13.9783H17",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 17.9783H17",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 10.9783V10.9783C20.105 10.9783 21 11.8733 21 12.9783V19.9783C21 21.0833 20.105 21.9783 19 21.9783H5C3.895 21.9783 3 21.0833 3 19.9783V12.9783C3 11.8733 3.895 10.9783 5 10.9783V10.9783",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.0703 5.47827L16.5003 7.90827",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.0664 6.04429L11.7074 4.40329C12.1814 3.92929 12.9504 3.92929 13.4254 4.40329V4.40329C13.8994 4.87729 13.8994 5.64629 13.4254 6.12129L12.2844 7.26229",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/DownPayment.tsx


var DownPayment = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 25 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _alt = param.alt, alt = _alt === void 0 ? "Entrada" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "https://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.99609 16.4799L5.5477 12.2273C5.84137 11.7378 6.26852 11.3423 6.77905 11.087L7.36448 10.7943C7.78122 10.5859 8.24075 10.4774 8.70668 10.4774H9.99901",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.002 5.47534C18.107 5.47534 19.0028 6.37115 19.0028 7.47618",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.0007 3.97473H13.0003C11.3427 3.97473 9.99902 5.31844 9.99902 6.97598V15.4795",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.5041 10.4774V16.4799C20.5041 18.1375 19.1604 19.4812 17.5029 19.4812H13.001",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.002 2.47409C19.7645 2.47409 22.004 4.7136 22.004 7.47617",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.99873 15.4795H10.9996L13.191 13.2889C13.7897 12.6905 14.7445 12.6435 15.399 13.1803C16.0535 13.717 16.1944 14.6626 15.7248 15.3668L12.7307 19.8566C12.2561 20.5684 11.5659 21.1093 10.7613 21.4L7.76562 22.4824",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/EmailValidationError.tsx

var EmailValidationErrorIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Erro na valida\xe7\xe3o por email" : _alt, _height = param.height, height = _height === void 0 ? 121 : _height, _width = param.width, width = _width === void 0 ? 121 : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 121 121",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "60.5",
                cy: "60.5",
                r: "59.875",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M90.0003 76.4409L94.1726 69.2069",
                stroke: "#B2B3B5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M87.449 74.9697L89.9996 76.4408",
                stroke: "#B2B3B5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M89.1404 72.0378L91.691 73.5089",
                stroke: "#B2B3B5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.7818 69.549C94.9472 70.0415 93.0607 68.9535 92.5683 67.1189C92.0758 65.2843 93.1639 63.3978 94.9984 62.9054C96.833 62.4129 98.7195 63.5009 99.2119 65.3355C99.7044 67.1701 98.6164 69.0566 96.7818 69.549",
                stroke: "#B2B3B5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M113.778 78.2856L110.621 74.3484",
                stroke: "#C3C4C5",
                strokeWidth: "1.04397",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M112.391 79.3989L113.779 78.2856",
                stroke: "#C3C4C5",
                strokeWidth: "1.04397",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M111.112 77.8033L112.5 76.69",
                stroke: "#C3C4C5",
                strokeWidth: "1.04397",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M111.388 72.9539C111.262 74.095 110.236 74.9184 109.094 74.793C107.953 74.6676 107.13 73.6409 107.255 72.4998C107.381 71.3587 108.407 70.5354 109.549 70.6607C110.69 70.7861 111.513 71.8128 111.388 72.9539",
                stroke: "#C3C4C5",
                strokeWidth: "1.04397",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M86.9067 40.1106L81.3091 33.9133",
                stroke: "#C3C4C5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.7215 42.0845L86.9066 40.1108",
                stroke: "#C3C4C5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.452 39.5729L84.6371 37.5992",
                stroke: "#C3C4C5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M82.438 31.5355C82.3416 33.4326 80.7255 34.8923 78.8284 34.7958C76.9313 34.6994 75.4716 33.0833 75.568 31.1862C75.6645 29.2891 77.2806 27.8294 79.1777 27.9259C81.0748 28.0223 82.5345 29.6384 82.438 31.5355",
                stroke: "#C3C4C5",
                strokeWidth: "1.72747",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.6689 73.2703L29.1242 67.2794",
                stroke: "#B2B3B5",
                strokeWidth: "1.4306",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.5564 72.052L25.6687 73.2703",
                stroke: "#B2B3B5",
                strokeWidth: "1.4306",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.9568 69.6239L27.0691 70.8422",
                stroke: "#B2B3B5",
                strokeWidth: "1.4306",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.2855 67.5627C29.7662 67.9706 28.2039 67.0695 27.7961 65.5502C27.3882 64.0309 28.2893 62.4686 29.8086 62.0608C31.3279 61.653 32.8902 62.554 33.298 64.0733C33.7058 65.5926 32.8048 67.1549 31.2855 67.5627",
                stroke: "#B2B3B5",
                strokeWidth: "1.4306",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M100.379 35.9988L102.481 32.3543",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M99.0948 35.2577L100.38 35.9988",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M99.9464 33.7804L101.231 34.5215",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M103.797 32.5268C102.873 32.7749 101.923 32.2268 101.675 31.3025C101.426 30.3783 101.975 29.4279 102.899 29.1798C103.823 28.9317 104.774 29.4798 105.022 30.4041C105.27 31.3284 104.722 32.2787 103.797 32.5268",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M71.1392 19.2894L73.2412 15.6449",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.8546 18.5482L71.1396 19.2894",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M70.7062 17.0711L71.9912 17.8122",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M74.5571 15.8174C73.6328 16.0655 72.6825 15.5173 72.4344 14.5931C72.1863 13.6688 72.7344 12.7184 73.6587 12.4703C74.5829 12.2222 75.5333 12.7704 75.7814 13.6946C76.0295 14.6189 75.4814 15.5693 74.5571 15.8174",
                stroke: "#C3C4C5",
                strokeWidth: "0.870292",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.8511 26.2654L39.227 18.6783",
                stroke: "#B2B3B5",
                strokeWidth: "1.81175",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.1775 24.7226L34.8525 26.2655",
                stroke: "#B2B3B5",
                strokeWidth: "1.81175",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.9509 21.6475L36.626 23.1904",
                stroke: "#B2B3B5",
                strokeWidth: "1.81175",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.9652 19.0375C40.0411 19.554 38.0626 18.4129 37.5461 16.4888C37.0296 14.5647 38.1708 12.5862 40.0949 12.0697C42.019 11.5532 43.9975 12.6943 44.5139 14.6184C45.0304 16.5425 43.8893 18.521 41.9652 19.0375",
                stroke: "#B2B3B5",
                strokeWidth: "1.81175",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.7855 45.3665L19.6329 47.0622C18.9531 47.2495 18.2506 46.8507 18.0633 46.1708L16.8763 41.8639C16.6889 41.1841 17.0878 40.4817 17.7676 40.2943L23.9203 38.5986C24.6001 38.4112 25.3026 38.8101 25.4899 39.49L26.6769 43.7968C26.8643 44.4767 26.4654 45.1791 25.7855 45.3665Z",
                stroke: "#C3C4C5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.3823 40.1247L17.8736 38.2789V38.2789C17.499 36.9198 18.2972 35.5142 19.6564 35.1396V35.1396C21.0155 34.765 22.4211 35.5632 22.7957 36.9224V36.9224L23.3044 38.7681",
                stroke: "#C3C4C5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M96.8324 95.8263L91.6904 92.046C91.1223 91.6283 91.0004 90.8298 91.4181 90.2616L94.0643 86.6622C94.482 86.094 95.2805 85.9721 95.8487 86.3898L100.991 90.1701C101.559 90.5878 101.681 91.3863 101.263 91.9545L98.6169 95.5539C98.1992 96.1221 97.4006 96.244 96.8324 95.8263Z",
                stroke: "#C3C4C5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.3636 86.7678L97.4977 85.2253V85.2253C98.3327 84.0894 99.9307 83.8455 101.067 84.6806V84.6806C102.202 85.5156 102.446 87.1136 101.611 88.2494V88.2494L100.477 89.792",
                stroke: "#C3C4C5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M109.332 55.1134L103.18 56.8091C102.5 56.9965 101.798 56.5976 101.61 55.9177L100.423 51.6109C100.236 50.931 100.635 50.2286 101.315 50.0412L107.467 48.3455C108.147 48.1581 108.849 48.557 109.037 49.2369L110.224 53.5437C110.411 54.2236 110.012 54.926 109.332 55.1134Z",
                stroke: "#B2B3B5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M101.929 49.8715L101.42 48.0257V48.0257C101.046 46.6666 101.844 45.261 103.203 44.8864V44.8864C104.562 44.5118 105.968 45.3101 106.343 46.6692V46.6692L106.851 48.515",
                stroke: "#B2B3B5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M94.293 55.5513L90.3366 58.4938C89.8994 58.8189 89.282 58.7282 88.9568 58.291L86.8971 55.5215C86.5719 55.0843 86.6627 54.4669 87.0999 54.1417L91.0563 51.1993C91.4935 50.8741 92.1109 50.9649 92.4361 51.4021L94.4958 54.1716C94.821 54.6087 94.7302 55.2262 94.293 55.5513Z",
                stroke: "#C3C4C5",
                strokeWidth: "1.00668",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M87.4953 53.8475L86.6125 52.6606V52.6606C85.9625 51.7866 86.1441 50.551 87.0181 49.901V49.901C87.8921 49.251 89.1277 49.4326 89.7777 50.3066V50.3066L90.6604 51.4935",
                stroke: "#C3C4C5",
                strokeWidth: "1.00668",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.7097 64.2546L6.64156 62.976C6.19203 62.8348 5.94236 62.3562 6.08365 61.9067L6.97866 59.059C7.11994 58.6095 7.59847 58.3598 8.048 58.5011L12.1162 59.7797C12.5657 59.9209 12.8153 60.3995 12.6741 60.849L11.7791 63.6967C11.6378 64.1462 11.1592 64.3959 10.7097 64.2546Z",
                stroke: "#B2B3B5",
                strokeWidth: "0.870636",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.4546 58.6288L8.83818 57.4084V57.4084C9.12061 56.5097 10.0782 56.0101 10.9769 56.2926V56.2926C11.8755 56.575 12.3751 57.5326 12.0927 58.4313V58.4313L11.7091 59.6517",
                stroke: "#B2B3B5",
                strokeWidth: "0.870636",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M36.4744 53.9527L33.4019 55.274C33.0624 55.42 32.6692 55.2633 32.5232 54.9238L31.5982 52.7731C31.4522 52.4336 31.609 52.0403 31.9485 51.8943L35.0209 50.573C35.3605 50.427 35.7537 50.5837 35.8997 50.9232L36.8246 53.074C36.9706 53.4135 36.8139 53.8067 36.4744 53.9527Z",
                stroke: "#C3C4C5",
                strokeWidth: "0.682843",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.255 51.7622L31.8586 50.8404V50.8404C31.5667 50.1617 31.8804 49.3748 32.5591 49.0829V49.0829C33.2378 48.791 34.0247 49.1047 34.3166 49.7834V49.7834L34.713 50.7051",
                stroke: "#C3C4C5",
                strokeWidth: "0.682843",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M87.4003 23.5915L82.2582 21.24C81.69 20.9802 81.4402 20.3095 81.7001 19.7413L83.3461 16.1418C83.6059 15.5736 84.2766 15.3239 84.8448 15.5837L89.9869 17.9352C90.5551 18.195 90.8049 18.8657 90.545 19.4339L88.899 23.0333C88.6392 23.6015 87.9685 23.8513 87.4003 23.5915Z",
                stroke: "#B2B3B5",
                strokeWidth: "1.15441",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M85.3598 15.8187L86.0653 14.2761V14.2761C86.5847 13.1402 87.9268 12.6404 89.0627 13.1598V13.1598C90.1986 13.6793 90.6984 15.0214 90.1789 16.1573V16.1573L89.4735 17.6999",
                stroke: "#B2B3B5",
                strokeWidth: "1.15441",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.1781 94.1016L21.0255 95.7973C20.3456 95.9847 19.6432 95.5858 19.4558 94.9059L18.2688 90.5991C18.0815 89.9192 18.4803 89.2168 19.1602 89.0294L25.3128 87.3337C25.9927 87.1463 26.6951 87.5452 26.8825 88.2251L28.0695 92.5319C28.2569 93.2118 27.858 93.9142 27.1781 94.1016Z",
                stroke: "#B2B3B5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.7749 88.8598L19.2662 87.014V87.014C18.8916 85.6549 19.6898 84.2493 21.0489 83.8747V83.8747C22.4081 83.5001 23.8137 84.2983 24.1883 85.6575V85.6575L24.697 87.5032",
                stroke: "#B2B3B5",
                strokeWidth: "1.303",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "59.8034",
                cy: "105.197",
                rx: "22.9753",
                ry: "1.53169",
                fill: "#C3C4C5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M57.4447 87.5354H77.9122C83.7328 87.5354 88.4514 82.8168 88.4514 76.9962V52.8438C88.4514 49.21 86.5794 45.8324 83.4979 43.9065L65.9326 32.9282C62.515 30.7922 58.1786 30.7922 54.761 32.9282L37.1956 43.9065C34.1141 45.8324 32.2422 49.21 32.2422 52.8438L32.2422 65.6932",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M57.4447 87.5354H77.9122C83.7328 87.5354 88.4514 82.8168 88.4514 76.9962V52.8438C88.4514 49.21 86.5794 45.8324 83.4979 43.9065L65.9326 32.9282C62.515 30.7922 58.1786 30.7922 54.761 32.9282L37.1956 43.9065C34.1141 45.8324 32.2422 49.21 32.2422 52.8438L32.2422 65.6932",
                stroke: "#47494D",
                strokeWidth: "3.32639",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M59.3265 32.2449C65.9071 31.5996 86.5892 47.4085 86.2758 48.699C85.9623 49.9895 62.1469 59.6684 60.2666 59.6684C58.3863 59.6684 51.0273 56.3124 45.8519 54.1837C40.8671 52.1335 33.1607 50.3122 33.944 48.699C34.7273 47.0859 40.5247 42.8917 47.1054 39.0201C51.9701 35.7548 56.4287 32.5291 59.3265 32.2449Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M85.4466 48.8577L64.5131 58.8209C62.4811 59.951 60.0955 59.951 58.0635 58.8209L35.5508 48.8577",
                stroke: "#47494D",
                strokeWidth: "3.32639",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "46.7538",
                cy: "74.247",
                r: "15.5203",
                fill: "#BE0F2C",
                stroke: "white",
                strokeWidth: "3.32639"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40.541 67.9845L53.2922 80.7357",
                stroke: "#F6F7F7",
                strokeWidth: "2.8429",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M53.2922 67.9845L40.541 80.7357",
                stroke: "#F6F7F7",
                strokeWidth: "2.8429",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ExclusionAccountFailedIcon.tsx

var ExclusionAccountFailedIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Exclus\xe3o de conta falhou" : _alt, _height = param.height, height = _height === void 0 ? "151" : _height, _width = param.width, width = _width === void 0 ? "164" : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 164 151",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M70.7138 11.7437C75.7049 3.01241 88.2951 3.01242 93.2862 11.7437L157.483 124.048C162.437 132.715 156.18 143.5 146.197 143.5H17.8028C7.82021 143.5 1.56254 132.715 6.51663 124.048L70.7138 11.7437Z",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M79.447 23.6647C81.531 23.6647 83.2211 22.0873 83.2211 20.1421C83.2211 18.197 81.5318 16.6196 79.447 16.6196C77.3621 16.6196 75.6729 18.197 75.6729 20.1421",
                        stroke: "#040405",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M79.4509 23.6682C78.883 23.6682 78.345 23.5511 77.8617 23.3421L75.5391 23.8025L76.0247 21.6304C75.7992 21.1779 75.673 20.6736 75.673 20.1421",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M79.0459 16.6397C78.7703 16.05 78.6172 15.4072 78.6172 14.7327C78.6172 11.8473 81.3862 9.53223 84.774 9.53223C88.1618 9.53223 90.9308 11.8473 90.9308 14.7327C90.9308 16.4379 89.9596 17.9391 88.4688 18.8858C88.4696 19.4289 88.4681 20.1608 88.4681 20.9294L86.0523 19.8189C85.639 19.8929 85.2119 19.9331 84.774 19.9331C84.2299 19.9331 83.7019 19.8728 83.1986 19.76",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M52.7703 124.152H50.8455C50.4371 124.152 50.0454 124.304 49.7565 124.573C49.4677 124.843 49.3056 125.208 49.3057 125.59V127.386",
                        stroke: "#040405",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M49.3057 133.854V135.65C49.3056 136.031 49.4677 136.397 49.7565 136.666C50.0454 136.936 50.4371 137.087 50.8455 137.087H52.7703",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M59.6992 137.087H61.624C62.0324 137.087 62.4242 136.936 62.713 136.666C63.0018 136.397 63.164 136.031 63.1639 135.65V133.854",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.1639 127.386V125.59C63.164 125.208 63.0018 124.843 62.713 124.573C62.4242 124.304 62.0324 124.152 61.624 124.152H59.6992",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M52.3857 127.746H60.085",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M52.3857 130.62H60.085",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M52.3857 133.494H56.2353",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M88.7703 32.1523H86.8455C86.4371 32.1522 86.0454 32.3036 85.7565 32.5732C85.4677 32.8427 85.3056 33.2083 85.3057 33.5895V35.386",
                        stroke: "#040405",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M85.3057 41.8535V43.65C85.3056 44.0312 85.4677 44.3968 85.7565 44.6664C86.0454 44.9359 86.4371 45.0873 86.8455 45.0872H88.7703",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M95.6992 45.0872H97.624C98.0324 45.0873 98.4242 44.9359 98.713 44.6664C99.0018 44.3968 99.164 44.0312 99.1639 43.65V41.8535",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M99.1639 35.386V33.5895C99.164 33.2083 99.0018 32.8427 98.713 32.5732C98.4242 32.3036 98.0324 32.1522 97.624 32.1523H95.6992",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M88.3857 35.7455H96.085",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M88.3857 38.6196H96.085",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M88.3857 41.4941H92.2353",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M137.447 135.665C139.531 135.665 141.221 134.087 141.221 132.142C141.221 130.197 139.532 128.62 137.447 128.62C135.362 128.62 133.673 130.197 133.673 132.142",
                        stroke: "#040405",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M137.451 135.668C136.883 135.668 136.345 135.551 135.862 135.342L133.539 135.803L134.025 133.63C133.799 133.178 133.673 132.674 133.673 132.142",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M137.046 128.64C136.77 128.05 136.617 127.407 136.617 126.733C136.617 123.847 139.386 121.532 142.774 121.532C146.162 121.532 148.931 123.847 148.931 126.733C148.931 128.438 147.96 129.939 146.469 130.886C146.47 131.429 146.468 132.161 146.468 132.929L144.052 131.819C143.639 131.893 143.212 131.933 142.774 131.933C142.23 131.933 141.702 131.873 141.199 131.76",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M58 70C58 65.0294 62.0294 61 67 61H109C113.971 61 118 65.0294 118 70V88.9991C118 90.6354 117.554 92.2407 116.71 93.6424L107.477 108.972C106.726 110.22 105.683 111.266 104.438 112.022L90.1523 120.694C88.7444 121.548 87.1291 122 85.4823 122H67C62.0294 122 58 117.971 58 113V70Z",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M78.9109 121.638H63.9488C59.8172 121.638 56.4678 118.54 56.4678 114.718V66.2814C56.4678 62.4598 59.8172 59.3618 63.9488 59.3618H108.835C112.967 59.3618 116.316 62.4598 116.316 66.2814V76.6607",
                stroke: "#47494D",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M90.1328 121.638L99.948 120.517C100.639 120.438 101.281 120.148 101.773 119.693L125.556 97.6959C128.19 95.2698 128.2 91.3283 125.578 88.8908L125.556 88.8735C122.933 86.437 118.671 86.4277 116.036 88.8527V88.8735L92.4706 110.67C91.9913 111.11 91.6812 111.684 91.5879 112.303L90.1328 121.638Z",
                fill: "#D4D5D6",
                stroke: "#47494D",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.5596 73.2011H99.4838",
                stroke: "#B2B3B5",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.5596 85.31H84.5217",
                stroke: "#B2B3B5",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.5596 99.6996H84.5217",
                stroke: "#B2B3B5",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M61.447 52.6647C63.531 52.6647 65.2211 51.0873 65.2211 49.1421C65.2211 47.197 63.5318 45.6196 61.447 45.6196C59.3621 45.6196 57.6729 47.197 57.6729 49.1421",
                        stroke: "#040405",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M61.4509 52.6682C60.883 52.6682 60.345 52.5511 59.8617 52.3421L57.5391 52.8025L58.0247 50.6304C57.7992 50.1779 57.673 49.6736 57.673 49.1421",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M61.0459 45.6397C60.7703 45.05 60.6172 44.4072 60.6172 43.7327C60.6172 40.8473 63.3862 38.5322 66.774 38.5322C70.1618 38.5322 72.9308 40.8473 72.9308 43.7327C72.9308 45.4379 71.9596 46.9391 70.4688 47.8858C70.4696 48.4289 70.4681 49.1608 70.4681 49.9294L68.0523 48.8189C67.639 48.8929 67.2119 48.9331 66.774 48.9331C66.2299 48.9331 65.7019 48.8728 65.1986 48.76",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M127.77 103.152H125.846C125.437 103.152 125.045 103.304 124.757 103.573C124.468 103.843 124.306 104.208 124.306 104.59V106.386",
                        stroke: "#040405",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M124.306 112.854V114.65C124.306 115.031 124.468 115.397 124.757 115.666C125.045 115.936 125.437 116.087 125.846 116.087H127.77",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M134.699 116.087H136.624C137.032 116.087 137.424 115.936 137.713 115.666C138.002 115.397 138.164 115.031 138.164 114.65V112.854",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M138.164 106.386V104.59C138.164 104.208 138.002 103.843 137.713 103.573C137.424 103.304 137.032 103.152 136.624 103.152H134.699",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M127.386 106.746H135.085",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M127.386 109.62H135.085",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M127.386 112.494H131.235",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M63.1224 108.743C66.9487 100.675 63.9669 91.0246 56.2544 86.5148C48.5419 82.0049 38.658 84.1325 33.4893 91.4151C28.3206 98.6977 29.5823 108.719 36.3952 114.496C43.2081 120.274 53.3116 119.89 59.666 113.613L65.2247 113.891L63.1224 108.743Z",
                fill: "#F28290",
                stroke: "#47494D",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.9648 102.016L47.9648 90.5",
                stroke: "#47494D",
                strokeWidth: "5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M47.9605 110.098C47.6165 110.098 47.3361 110.358 47.3398 110.676C47.3398 110.99 47.6202 111.25 47.9642 111.25C48.3082 111.25 48.5886 110.99 48.5886 110.672C48.5886 110.354 48.3082 110.098 47.9605 110.098Z",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.9605 110.098C47.6165 110.098 47.3361 110.358 47.3398 110.676C47.3398 110.99 47.6202 111.25 47.9642 111.25C48.3082 111.25 48.5886 110.99 48.5886 110.672C48.5886 110.354 48.3082 110.098 47.9605 110.098",
                stroke: "#47494D",
                strokeWidth: "5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.447 136.665C20.531 136.665 22.2211 135.087 22.2211 133.142C22.2211 131.197 20.5318 129.62 18.447 129.62C16.3621 129.62 14.6729 131.197 14.6729 133.142",
                        stroke: "#040405",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.4509 136.668C17.883 136.668 17.345 136.551 16.8617 136.342L14.5391 136.803L15.0247 134.63C14.7992 134.178 14.673 133.674 14.673 133.142",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.0459 129.64C17.7703 129.05 17.6172 128.407 17.6172 127.733C17.6172 124.847 20.3862 122.532 23.774 122.532C27.1618 122.532 29.9308 124.847 29.9308 127.733C29.9308 129.438 28.9596 130.939 27.4688 131.886C27.4696 132.429 27.4681 133.161 27.4681 133.929L25.0523 132.819C24.639 132.893 24.2119 132.933 23.774 132.933C23.2299 132.933 22.7019 132.873 22.1986 132.76",
                        stroke: "black",
                        strokeWidth: "0.84656",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "86.5",
                cy: "132",
                rx: "29.5",
                ry: "2",
                fill: "#B2B3B5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ExclusionAccountSuccessIcon.tsx

var ExclusionAccountSucceedIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Exclus\xe3o de conta" : _alt, _height = param.height, height = _height === void 0 ? "151" : _height, _width = param.width, width = _width === void 0 ? "174" : _width, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "0.84656" : _strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 174 151",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M75.7138 11.7437C80.7049 3.01241 93.2951 3.01242 98.2862 11.7437L162.483 124.048C167.437 132.715 161.18 143.5 151.197 143.5H22.8028C12.8202 143.5 6.56254 132.715 11.5166 124.048L75.7138 11.7437Z",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M84.447 23.6651C86.531 23.6651 88.2211 22.0878 88.2211 20.1426C88.2211 18.1975 86.5318 16.6201 84.447 16.6201C82.3621 16.6201 80.6729 18.1975 80.6729 20.1426",
                        stroke: "#040405",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M84.4509 23.6687C83.883 23.6687 83.345 23.5516 82.8617 23.3426L80.5391 23.803L81.0247 21.6309C80.7992 21.1784 80.673 20.6741 80.673 20.1426",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M84.0463 16.6397C83.7708 16.05 83.6177 15.4072 83.6177 14.7327C83.6177 11.8473 86.3867 9.53223 89.7745 9.53223C93.1623 9.53223 95.9313 11.8473 95.9313 14.7327C95.9313 16.4379 94.96 17.9391 93.4693 18.8858C93.4701 19.4289 93.4686 20.1608 93.4686 20.9294L91.0528 19.8189C90.6395 19.8929 90.2124 19.9331 89.7745 19.9331C89.2304 19.9331 88.7024 19.8728 88.1991 19.76",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M57.7708 124.152H55.846C55.4376 124.152 55.0458 124.304 54.757 124.573C54.4682 124.843 54.306 125.208 54.3062 125.59V127.386",
                        stroke: "#040405",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M54.3062 133.854V135.65C54.306 136.031 54.4682 136.397 54.757 136.666C55.0458 136.936 55.4376 137.087 55.846 137.087H57.7708",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M64.7002 137.087H66.625C67.0334 137.087 67.4252 136.936 67.714 136.666C68.0028 136.397 68.165 136.031 68.1648 135.65V133.854",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M68.1648 127.386V125.59C68.165 125.208 68.0028 124.843 67.714 124.573C67.4252 124.304 67.0334 124.152 66.625 124.152H64.7002",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M57.3857 127.745H65.085",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M57.3857 130.62H65.085",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M57.3857 133.494H61.2353",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M93.7708 32.1523H91.846C91.4376 32.1522 91.0458 32.3036 90.757 32.5732C90.4682 32.8427 90.306 33.2083 90.3062 33.5895V35.386",
                        stroke: "#040405",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M90.3062 41.8535V43.65C90.306 44.0312 90.4682 44.3968 90.757 44.6664C91.0458 44.9359 91.4376 45.0873 91.846 45.0872H93.7708",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M100.7 45.0872H102.625C103.033 45.0873 103.425 44.9359 103.714 44.6664C104.003 44.3968 104.165 44.0312 104.165 43.65V41.8535",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M104.165 35.386V33.5895C104.165 33.2083 104.003 32.8427 103.714 32.5732C103.425 32.3036 103.033 32.1522 102.625 32.1523H100.7",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M93.3857 35.745H101.085",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M93.3857 38.62H101.085",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M93.3857 41.4941H97.2353",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M142.447 135.664C144.531 135.664 146.221 134.087 146.221 132.142C146.221 130.197 144.532 128.619 142.447 128.619C140.362 128.619 138.673 130.197 138.673 132.142",
                        stroke: "#040405",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M142.451 135.669C141.883 135.669 141.345 135.552 140.862 135.343L138.539 135.803L139.025 133.631C138.799 133.178 138.673 132.674 138.673 132.143",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M142.046 128.64C141.771 128.05 141.618 127.407 141.618 126.733C141.618 123.847 144.387 121.532 147.774 121.532C151.162 121.532 153.931 123.847 153.931 126.733C153.931 128.438 152.96 129.939 151.469 130.886C151.47 131.429 151.469 132.161 151.469 132.929L149.053 131.819C148.64 131.893 148.212 131.933 147.774 131.933C147.23 131.933 146.702 131.873 146.199 131.76",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M63 70C63 65.0294 67.0294 61 72 61H114C118.971 61 123 65.0294 123 70V88.9991C123 90.6354 122.554 92.2407 121.71 93.6424L112.477 108.972C111.726 110.22 110.683 111.266 109.438 112.022L95.1523 120.694C93.7444 121.548 92.1291 122 90.4823 122H72C67.0294 122 63 117.971 63 113V70Z",
                fill: "#F6F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M83.9105 121.638H68.9483C64.8167 121.638 61.4673 118.54 61.4673 114.719V66.2819C61.4673 62.4603 64.8167 59.3623 68.9483 59.3623H113.835C117.966 59.3623 121.316 62.4603 121.316 66.2819V76.6612",
                stroke: "#47494D",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.1318 121.638L104.947 120.518C105.638 120.439 106.28 120.149 106.772 119.694L130.555 97.6969C133.189 95.2708 133.199 91.3292 130.577 88.8917L130.555 88.8744C127.932 86.438 123.67 86.4287 121.035 88.8537V88.8744L97.4697 110.671C96.9903 111.111 96.6802 111.685 96.5869 112.304L95.1318 121.638Z",
                fill: "#D4D5D6",
                stroke: "#47494D",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M74.5591 73.2016H104.483",
                stroke: "#B2B3B5",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M74.5591 85.3109H89.5212",
                stroke: "#B2B3B5",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M74.5591 99.7006H89.5212",
                stroke: "#B2B3B5",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M66.447 52.6651C68.531 52.6651 70.2211 51.0878 70.2211 49.1426C70.2211 47.1975 68.5318 45.6201 66.447 45.6201C64.3621 45.6201 62.6729 47.1975 62.6729 49.1426",
                        stroke: "#040405",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M66.4509 52.6687C65.883 52.6687 65.345 52.5516 64.8617 52.3426L62.5391 52.803L63.0247 50.6309C62.7992 50.1784 62.673 49.6741 62.673 49.1426",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M66.0463 45.6397C65.7708 45.05 65.6177 44.4072 65.6177 43.7327C65.6177 40.8473 68.3867 38.5322 71.7745 38.5322C75.1623 38.5322 77.9313 40.8473 77.9313 43.7327C77.9313 45.4379 76.96 46.9391 75.4693 47.8858C75.4701 48.4289 75.4686 49.1608 75.4686 49.9294L73.0528 48.8189C72.6395 48.8929 72.2124 48.9331 71.7745 48.9331C71.2304 48.9331 70.7024 48.8728 70.1991 48.76",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M132.771 103.152H130.846C130.438 103.152 130.046 103.304 129.757 103.573C129.468 103.843 129.306 104.208 129.306 104.59V106.386",
                        stroke: "#040405",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M129.306 112.854V114.65C129.306 115.031 129.468 115.397 129.757 115.666C130.046 115.936 130.438 116.087 130.846 116.087H132.771",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M139.7 116.087H141.625C142.033 116.087 142.425 115.936 142.714 115.666C143.003 115.397 143.165 115.031 143.165 114.65V112.854",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M143.165 106.386V104.59C143.165 104.208 143.003 103.843 142.714 103.573C142.425 103.304 142.033 103.152 141.625 103.152H139.7",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M132.386 106.745H140.085",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M132.386 109.62H140.085",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M132.386 112.494H136.235",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M68.1229 108.743C71.9492 100.676 68.9674 91.0251 61.2549 86.5153C53.5424 82.0054 43.6585 84.133 38.4898 91.4156C33.3211 98.6982 34.5828 108.719 41.3957 114.497C48.2086 120.274 58.3121 119.891 64.6665 113.613L70.2252 113.891L68.1229 108.743Z",
                fill: "#FFC700",
                stroke: "#47494D",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M52.9653 102.016L52.9653 90.5",
                stroke: "#47494D",
                strokeWidth: "5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M52.9615 110.099C52.6175 110.099 52.3371 110.358 52.3408 110.676C52.3408 110.991 52.6212 111.25 52.9652 111.25C53.3092 111.25 53.5896 110.991 53.5896 110.673C53.5896 110.355 53.3092 110.099 52.9615 110.099Z",
                fill: "#68A439"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M52.9615 110.099C52.6175 110.099 52.3371 110.358 52.3408 110.676C52.3408 110.991 52.6212 111.25 52.9652 111.25C53.3092 111.25 53.5896 110.991 53.5896 110.673C53.5896 110.355 53.3092 110.099 52.9615 110.099",
                stroke: "#47494D",
                strokeWidth: "5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.447 136.664C25.531 136.664 27.2211 135.087 27.2211 133.142C27.2211 131.197 25.5318 129.619 23.447 129.619C21.3621 129.619 19.6729 131.197 19.6729 133.142",
                        stroke: "#040405",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.4509 136.669C22.883 136.669 22.345 136.552 21.8617 136.343L19.5391 136.803L20.0247 134.631C19.7992 134.178 19.673 133.674 19.673 133.143",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.0463 129.64C22.7708 129.05 22.6177 128.407 22.6177 127.733C22.6177 124.847 25.3867 122.532 28.7745 122.532C32.1623 122.532 34.9313 124.847 34.9313 127.733C34.9313 129.438 33.96 130.939 32.4693 131.886C32.4701 132.429 32.4686 133.161 32.4686 133.929L30.0528 132.819C29.6395 132.893 29.2124 132.933 28.7745 132.933C28.2304 132.933 27.7024 132.873 27.1991 132.76",
                        stroke: "black",
                        strokeWidth: strokeWidth,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "91.5",
                cy: "132",
                rx: "29.5",
                ry: "2",
                fill: "#B2B3B5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/FCCredit.tsx


var FCCredit = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 25 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, _alt = param.alt, alt = _alt === void 0 ? "cr\xe9dito fc" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "12.4783",
                r: "9.25",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.33301 8.92754H7.70481C7.9076 8.92754 7.97523 8.99516 7.97523 9.19795V14.0996H9.42887V11.5981H11.5247V10.4149H9.42887V8.92754H11.9637V7.71063H7.33301V8.92754Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.7853 14.0518C12.7853 12.8349 13.5966 12.1588 14.6448 12.1588C15.3546 12.1588 15.9293 12.3616 16.5377 12.7672V11.4826C15.9129 11.0805 15.1846 10.8691 14.4416 10.8742C12.5486 10.8742 11.2979 12.1926 11.2979 14.0855C11.2979 15.9785 12.6162 17.2631 14.543 17.2631C15.2915 17.2731 16.0244 17.0485 16.6388 16.6208V15.3024C15.9628 15.7419 15.3205 15.9448 14.6444 15.9448C13.5965 15.911 12.7853 15.2349 12.7853 14.0518Z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/ListIcon.tsx

var ListIcon = function(param) {
    var alt = param.alt, color = param.color, height = param.height, width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.3335 21.99C17.3981 23.3247 17.9303 24.5942 18.8368 25.576C19.5608 26.417 20.4247 27.1265 21.3904 27.6732C22.2313 28.1423 23.2619 28.112 24.0737 27.5941C24.949 27.0347 25.736 26.3478 26.4088 25.5562C27.332 24.5844 27.8951 23.326 28.0047 21.99C28.011 21.1952 27.7138 20.4279 27.1737 19.8447C26.6547 19.2792 25.9242 18.9546 25.1566 18.9483C24.1929 18.8809 23.2615 19.3106 22.6874 20.0877L22.6692 20.1144L22.6507 20.0877C22.1283 19.3525 21.2744 18.9254 20.3728 18.9483C19.5622 18.9345 18.7807 19.2507 18.2077 19.8242C17.6346 20.3977 17.3191 21.1794 17.3335 21.99Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.334 13.332H22.6695",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.33008 12.9664L10.5559 14.0709L13.0236 11.8486",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3323 28.0051H10.6646C6.98113 28.0051 3.99512 25.0191 3.99512 21.3357V10.6646C3.99512 6.98113 6.98113 3.99512 10.6646 3.99512H21.3357C25.0191 3.99512 28.0051 6.98113 28.0051 10.6646V14.6662",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.33008 19.6364L10.5559 20.7408L13.0236 18.5186",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/OrthersPayments.tsx


var OthersPayments = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _alt = param.alt, alt = _alt === void 0 ? "Outros pagamentos" : _alt, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.5 19.4783L12 20.4783L9.5 19.4783L7 20.4783V7.47827H17V20.4783L14.5 19.4783Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 10.4783H14",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 13.4783H10",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 16.4783H13",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 11.4783H19C20.105 11.4783 21 10.5833 21 9.47827V5.47827C21 4.37327 20.105 3.47827 19 3.47827H5C3.895 3.47827 3 4.37327 3 5.47827V9.47827C3 10.5833 3.895 11.4783 5 11.4783H7",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PackageOutlined.tsx


var PackageOutlined = function(param) {
    var alt = param.alt, click = param.click, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.550 */.rS.colors.neutral[550] : _color, strokeWidth = param.strokeWidth, height = param.height, width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        onClick: click,
        "aria-label": alt || "pacote",
        "aria-labelledby": alt || "pacote",
        width: width || "32",
        height: height || "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.0051 10.7833V25.3373C28.0051 26.8107 26.8107 28.0051 25.3373 28.0051H6.6629C5.18953 28.0051 3.99512 26.8107 3.99512 25.3373V10.7833C3.99461 10.4215 4.06768 10.0635 4.20988 9.73084L5.97061 5.61046C6.39161 4.62985 7.35647 3.99447 8.42363 3.99512H23.5766C24.6447 3.99512 25.6099 4.63228 26.0296 5.61446L27.7904 9.73084C27.9324 10.0635 28.0054 10.4216 28.0051 10.7833Z",
                stroke: color,
                strokeWidth: strokeWidth || "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.99512 10.664H27.9918",
                stroke: color,
                strokeWidth: strokeWidth || "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.6675 3.99512L20.0014 10.6646V14.9664C19.9684 15.5678 19.4558 16.0296 18.8542 16.0001H13.1452C12.5436 16.0296 12.0311 15.5678 11.998 14.9664V10.6646L13.3319 3.99512",
                stroke: color,
                strokeWidth: strokeWidth || "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.99609 24.0029H10.6639",
                stroke: color,
                strokeWidth: strokeWidth || "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PhoneNumberValidationError.tsx


var PhoneNumberValidationError = function(param) {
    var _width = param.width, width = _width === void 0 ? 143 : _width, _height = param.height, height = _height === void 0 ? 119 : _height, _alt = param.alt, alt = _alt === void 0 ? "Erro na valida\xe7\xe3o por n\xfamero de telefone" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": alt,
        viewBox: "0 0 143 119",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_6332_1844)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M55.9105 13.059C60.9008 4.32371 73.496 4.32369 78.4863 13.0589L127.854 99.4742C132.805 108.141 126.547 118.923 116.566 118.923H17.8308C7.84975 118.923 1.59192 108.141 6.54296 99.4742L55.9105 13.059Z",
                    fill: "#F6F7F7"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M57.1048 36.8851H79.0254C84.8975 36.8851 89.6536 41.6413 89.6536 47.5133V95.3402C89.6536 101.212 84.8975 105.968 79.0254 105.968H57.1048C51.2327 105.968 46.4766 101.212 46.4766 95.3402V47.5133C46.4766 41.6413 51.2327 36.8851 57.1048 36.8851Z",
                fill: "#F6F7F7",
                stroke: "#47494D",
                strokeWidth: "4.63085",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.168",
                y: "53.7803",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: "#FBDDE1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.168",
                y: "42.5169",
                width: "33.7907",
                height: "5.63178",
                rx: "2.54473",
                fill: "url(#paint0_linear_6332_1844)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.168",
                y: "85.694",
                width: "33.7907",
                height: "15.0181",
                rx: "7.50904",
                fill: "url(#paint1_linear_6332_1844)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.168",
                y: "66.9212",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: "#FBDDE1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "51.168",
                y: "73.4917",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: "#FBDDE1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "64.3105",
                y: "60.3509",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: "#F499A4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "64.3105",
                y: "80.0623",
                width: "19.7112",
                height: "2.81589",
                rx: "1.40794",
                fill: "#F499A4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M45.8287 33.3421C44.9571 33.3421 44.25 34.0491 44.25 34.9212C44.25 35.7933 44.9571 36.5 45.8287 36.5H50.1708C51.0429 36.5 51.75 35.7929 51.75 34.9212C51.75 34.0496 51.0429 33.3425 50.1712 33.3425C50.1712 32.1433 49.1992 31.1712 48 31.1712C46.8008 31.1712 45.8287 32.1429 45.8287 33.3421Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M109.951 84.5114C107.547 78.5812 110.074 71.7971 115.773 68.8859C121.471 65.9748 128.45 67.9027 131.846 73.3262C135.242 78.7497 133.928 85.8694 128.821 89.7244C123.713 93.5795 116.506 92.8908 112.222 88.1382L108.237 88.1089L109.951 84.5114Z",
                fill: "#EB3E53",
                stroke: "#47494D",
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.351 72.1295L125.694 73.3579C126.678 73.5842 127.292 74.5644 127.066 75.5484L124.609 86.2342C124.383 87.2182 123.402 87.8319 122.418 87.6057L117.075 86.3773C116.091 86.151 115.478 85.1708 115.704 84.1868L118.161 73.501C118.387 72.517 119.367 71.9033 120.351 72.1295Z",
                fill: "#F6F7F7",
                stroke: "#47494D",
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121.24 72.3342L120.872 73.9371C120.804 74.2318 120.948 74.5172 121.194 74.5737L123.866 75.1879C124.111 75.2445 124.366 75.0508 124.434 74.756L124.802 73.1532",
                stroke: "#47494D",
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.261 84.5359L121.256 84.9945",
                stroke: "#5C5E62",
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.4449 64.3807C35.1847 58.5979 33.0496 51.6801 27.5272 48.4475C22.0047 45.2148 14.9274 46.7398 11.2265 51.96C7.52549 57.1802 8.42888 64.3633 13.3072 68.5045C18.1855 72.6457 25.42 72.3709 29.97 67.8714L33.9503 68.0704L32.4449 64.3807Z",
                fill: "#EB3E53",
                stroke: "#47494D",
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.7747 51.4235L17.3702 52.344C16.3749 52.5135 15.706 53.457 15.8755 54.4523L17.7164 65.2613C17.8859 66.2566 18.8294 66.9254 19.8247 66.7559L25.2292 65.8355C26.2245 65.666 26.8934 64.7225 26.7239 63.7272L24.883 52.9182C24.7135 51.9229 23.77 51.254 22.7747 51.4235Z",
                fill: "#F6F7F7",
                stroke: "#47494D",
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.873 51.577L22.1492 53.1983C22.2 53.4964 22.0395 53.7731 21.7909 53.8155L19.0886 54.2757C18.84 54.318 18.597 54.1101 18.5462 53.8119L18.2701 52.1906",
                stroke: "#47494D",
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.1529 63.8721L21.1352 64.2158",
                stroke: "#5C5E62",
                strokeWidth: "1.02793",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M66.2431 13.0789C64.9356 13.0789 63.875 14.0688 63.875 15.2897C63.875 16.5106 64.9356 17.5 66.2431 17.5H72.7562C74.0644 17.5 75.125 16.51 75.125 15.2897C75.125 14.0694 74.0644 13.0795 72.7569 13.0795C72.7569 11.4006 71.2987 10.0397 69.5 10.0397C67.7012 10.0397 66.2431 11.4 66.2431 13.0789Z",
                    stroke: "#8F9194",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M71.8287 25.3421C70.9571 25.3421 70.25 26.0491 70.25 26.9212C70.25 27.7933 70.9571 28.5 71.8287 28.5H76.1708C77.0429 28.5 77.75 27.7929 77.75 26.9212C77.75 26.0496 77.0429 25.3425 76.1712 25.3425C76.1712 24.1433 75.1992 23.1712 74 23.1712C72.8008 23.1712 71.8287 24.1429 71.8287 25.3421Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M58.2431 26.6447C56.9356 26.6447 55.875 27.5639 55.875 28.6976C55.875 29.8313 56.9356 30.75 58.2431 30.75H64.7562C66.0644 30.75 67.125 29.8307 67.125 28.6976C67.125 27.5644 66.0644 26.6452 64.7569 26.6452C64.7569 25.0863 63.2987 23.8226 61.5 23.8226C59.7012 23.8226 58.2431 25.0857 58.2431 26.6447Z",
                    stroke: "#A0A2A4",
                    strokeWidth: "0.62",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M29.9602 86.6447C28.7399 86.6447 27.75 87.5639 27.75 88.6976C27.75 89.8313 28.7399 90.75 29.9602 90.75H36.0392C37.2601 90.75 38.25 89.8308 38.25 88.6976C38.25 87.5644 37.2601 86.6452 36.0397 86.6452C36.0397 85.0863 34.6788 83.8226 33 83.8226C31.3212 83.8226 29.9602 85.0858 29.9602 86.6447Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M97.8287 78.3421C96.9571 78.3421 96.25 79.0491 96.25 79.9212C96.25 80.7933 96.9571 81.5 97.8287 81.5H102.171C103.043 81.5 103.75 80.7929 103.75 79.9212C103.75 79.0496 103.043 78.3425 102.171 78.3425C102.171 77.1433 101.199 76.1712 100 76.1712C98.8008 76.1712 97.8287 77.1429 97.8287 78.3421Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M95.9602 62.0789C94.7399 62.0789 93.75 63.0688 93.75 64.2897C93.75 65.5106 94.7399 66.5 95.9602 66.5H102.039C103.26 66.5 104.25 65.51 104.25 64.2897C104.25 63.0694 103.26 62.0795 102.04 62.0795C102.04 60.4006 100.679 59.0397 99 59.0397C97.3212 59.0397 95.9602 60.4 95.9602 62.0789Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M32.8287 109.342C31.9571 109.342 31.25 110.049 31.25 110.921C31.25 111.793 31.9571 112.5 32.8287 112.5H37.1708C38.0429 112.5 38.75 111.793 38.75 110.921C38.75 110.05 38.0429 109.342 37.1712 109.342C37.1712 108.143 36.1992 107.171 35 107.171C33.8008 107.171 32.8287 108.143 32.8287 109.342Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M104.112 106.342C103.153 106.342 102.375 107.049 102.375 107.921C102.375 108.793 103.153 109.5 104.112 109.5H108.888C109.847 109.5 110.625 108.793 110.625 107.921C110.625 107.05 109.847 106.342 108.888 106.342C108.888 105.143 107.819 104.171 106.5 104.171C105.181 104.171 104.112 105.143 104.112 106.342Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.1116 103.342C12.1528 103.342 11.375 104.049 11.375 104.921C11.375 105.793 12.1528 106.5 13.1116 106.5H17.8879C18.8472 106.5 19.625 105.793 19.625 104.921C19.625 104.05 18.8472 103.342 17.8884 103.342C17.8884 102.143 16.8191 101.171 15.5 101.171C14.1809 101.171 13.1116 102.143 13.1116 103.342Z",
                    fill: "#A0A2A4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M111.243 97.0789C109.936 97.0789 108.875 98.0688 108.875 99.2897C108.875 100.511 109.936 101.5 111.243 101.5H117.756C119.064 101.5 120.125 100.51 120.125 99.2897C120.125 98.0694 119.064 97.0795 117.757 97.0795C117.757 95.4006 116.299 94.0397 114.5 94.0397C112.701 94.0397 111.243 95.4 111.243 97.0789Z",
                    stroke: "#B2B3B5",
                    strokeWidth: "0.61568",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "70.5",
                cy: "113",
                rx: "23.5",
                ry: "1",
                fill: "#B2B3B5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_6332_1844",
                        x1: "83.5",
                        y1: "41.4998",
                        x2: "55.5",
                        y2: "46.9998",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#A43939",
                                stopOpacity: "0.7"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A43939",
                                stopOpacity: "0.17"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_6332_1844",
                        x1: "81.5",
                        y1: "85.9999",
                        x2: "54",
                        y2: "99.9999",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#A43939",
                                stopOpacity: "0.7"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B53535",
                                stopOpacity: "0.06"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_6332_1844",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "135",
                            height: "118.77",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/PixIconWithBG.tsx


var PixIconWithBG = function(param) {
    var _width = param.width, width = _width === void 0 ? "24" : _width, _height = param.height, height = _height === void 0 ? "24" : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.neutral.88 */.rS.colors.neutral[88] : _color, _alt = param.alt, alt = _alt === void 0 ? "pix" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.5 11.7391C23.5 17.936 18.3617 22.9783 12 22.9783C5.63831 22.9783 0.5 17.936 0.5 11.7391C0.5 5.54223 5.63831 0.5 12 0.5C18.3617 0.5 23.5 5.54223 23.5 11.7391Z",
                fill: "white",
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "4",
                y: "4",
                width: "15",
                height: "15",
                fill: "url(#pattern0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_1104_67425",
                            transform: "scale(0.005)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_1104_67425",
                        width: "200",
                        height: "200",
                        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAIAAAAiOjnJAAAgAElEQVR4nOy9aZMcR5Il+FTVzI+IyMhE4iJIggDvKnbtVFXPdkvPftiVFdl/tdtT/Gcru9M9O3Wxi0eRBIk7kTfyjMMPM1PdD+6RSBAAq7IbaACcUQmJjIj0cPcwf66mpvpUlcwMr7MoHp0/nfop9NSfpYTU/RvJoWWE/r1mIAYYClNLRkQgArsIIYABMZCBDDBAAeoeqoRESARAAXgDGbg7unL/TCfbwxbbd5vkAD33QXkFxL3sE/j3le7qWn8xqf+r3WsGoKZJATAzs9fFAEm3ZQcBAwSICiiYiMkROZiCAZApnT5c9+XFwQwwAgDujvrTFfqpaqxnfdLpFhASIzEiEqAEICZnxEQCApBgaqQwLxkZzDrdBIBABFPECFJ0io0IbGACEVKPpw5ABhixAkT8g3MhA2gB2Z+c/HemsYBuljLYidJiAwFePBmDCGYAEWAwgxGfKDZ+tBNjZeFe3xlUYYoIwOAyAEYwIHE/bZ5AihaqsX820E8SVj8BYD3dllqIPX7ZqJ9/1BZqgs3IWAzEgmQhtEGTElvmxAtAUzNVTSlFVSNAICJMyJ0niAACZRipkRrUQAzAgERIgC6ARTBaYJNADGMj4CeLrNceWH9RjEC2eAaIkhEMqji50DBwVQVmJp+RgxJqQ20pmjqWxNaaJmhimIMDMwhoBJSDPSwDZyyOycFgBKjRMxWVQHsTq0eUvIxReeHyEwTWD7SUAkz9MwCDAqqgBDaokYAYoCiOPCmjBY7UHlaTvdnxrKn3Dg6jpjqG1pIS4FkyL0KDLM/ZjSRbKvIVX46yYujznGiZM+kP1SPJQbv1Jj86IwC9ycan8P1Tkp8gsE5ET72wU28NiN1sBU7gzofQ5jRr0t50uj093JgcPKwmR/W8Smk+r0PSOoWgKYjBictERBBT6bLlorgwHF8erVwYjpcH5YDd9VHmAQcI0L3wymInWkoBGGtCt2gi+h/G+6spnY1lT1ycNkYzc87Rwug58TAkIIJaIIEJ1AC7s/nO4eH2wcGd7a0HB7v77XwuFnNiyVJDMFZGYInQpGZNC2B5MNo6msjD/SW/71uVqG9euPDB1bcnb4XLy+MV5IKU1WFFciFCa4BCA5BMKDlKQpE7Y0t+knPhaw+sp4oC3nmFUacigDa1qsqOiKyFKRDgZrBjrTd29+5sbN3f3K5Mp7E9EpuUvpYUM2EWJGJ1SkiMyJoYSsqGyjhIRpypL5JoM6s3JrPm/trW4d5Kmb9z4dL7F668XY60c6h6QTAwQYzEnCPAFGZ4vX09PyI/EWA9VW+pqZmBGQCYmMUIlYVIpPBHCPf2D9f29u5v797f3tk9nlKea+4awZyoIgRTn3TIBRsTdaaQkEJZ2dDOGkQzcGQIMZybh9QcHm0e7o6HxcPj46PD6WT10vWVC1zkAwaYINI560+mZfppToPATwZYJ3KCLQNSrxLUwTlioHeGVkiHcXZ7++EXd++s7R9Ok86AsLSUhBKjJquBQJSIGZwIQuh9o9YBg8nUjJnM1Oq6TsQiEJIASnCZyx4cTzbWd+6Nz/3DR5+kK2+PWc6X3veOewpJVfp16k/Qbgfw0wPWaXHkjB4FFgxWIbXwG/PjO9s7364/+HZjc79NNByiLI2lSTGkqBDnyPlc2cSYoqkYek8BAO20o/NOSDSm0DaVBm/ivAOYfTlVS/Mq1bMqRVu7OeV0deXce8NLS4AHjBJC8swZ8U9WX/1UgbUw1aEwAxikQESatfVW23y79uDG+tqDyfGRUSgLzYpGk7AkkBExeyfGQIwxxpBYzHrPah9dJgMQU0pExIaMiaBMSUAkItnB3j6rrV6+HFP4cnt9v53/zfV329K9MRydR5aBcucykn4+JP5Jzoc/TWABSJaUToDFAOqmPpzNPr9z68bD3c3jyZSQ8jx63zLPQsqSMcQLeTOKCdpKislCKrPAiaxnN7CBoGRQjSFGAFJkLpNEaCmJkjbBIJpT8K4Wm3CcTh5O7qdjrT+8/MaH5y9epDynRexbDf7ljtOLktcZWN0kd2JVEYys1wKAIzEgAC1Sg1ir7k6n944O/uX+ve22bYS1KFvTOoVkxkwhNN4xERsMKcHUs3jvZqSd5d5FEM1AIBhGo6Xj6aRqG58SVBLFGBSpxVTH5ZKRbh3sEdF4PGbC2vFBXAtEtFQMipEv4UuwKLSesxuAFl4uMKD2hL/0ddRorxy74fTZPDag+rTzNNKjhl2GAUEQgHloPFPusmY+LweDBEyBGbBRT/5087vP19ZuV9O5c0acCIlIiZVw4vtmU7JHXBrAlHvL/YSccDo6eYJqJQWYDayP4YJMGcqmVNUX8sEv3r76Dx/+/MPxhVHUUcLAc1tX3hP5rANWsmgki/hTv2xcRBhfJ0P/ddZYAAAuctgCjwQR6Sh0LvNNTFEkELaq2e9v3vji/r2tUM+8a065JAmdaX6KHEWnwU3dJPgsOQGZWL9PI0s9FMHGRqzGIE0kx224t/tw5O+5t+29lYulQwQ482A1JABJg5kZG3ekQ3Shx9dRYb0+wLLFgv8xIaCAac/oZCBnZ2ZqiKCGMI3hwezoy/W1rx6sbcwnM8eJXqxRY52KMQBItGBwGXOWtWoP59Nv1u5R06S32nD+0op3S47VLMVkZo5YxAmxqp4iPRgRoY9yvjZ667UB1lPFCEpQhimoYw8TiCgBrZMWtFVP/9t3337x4P7MM42H9bx6ofe/YTFvoodYP8+SgpmEGsXDevbn9QdN07SWPrj8huNMKHVfZmJPDgYmQBXAglTz+rFrXjlg/fj4/cC3nshqVWIRhhhMjYiUEYAa9CDMPt968NXO5u3JPq8si8sqWPair5CR9c6JHl0KNkIEBUsmoiTW1Glv1y8tFeNhtjQegZ0T0qQkAGBAEyEO6PQwAWqwTonxa2LLv3LA+otyml8FIGryzAQys6SqxJXpMdmD+fE/3/j6293tfda4NGySSh3EF/8OZ0iGhcHNMBjDwMVwVFezuSWXZWy821Y3djYUSd5978pwOJZBxtyqOYMLlproC99x6qGGHm+v1jLrx+U1ANYPvAo/4Fd5JoEJyNQScUO63zYbYf7buzf/252bO7HOzq8qSgtJSBgvdg1MANsCUgCMdXEbKDGcV+W5aSQTYG1yNJvPOcaP3njr3TeujCUvgYzghXxWwgjEUAV3To7XQk89ktcAWCfyVH5VwZ4BU0QjFarB+xoe1LMbBw8PMrTloDGr23aYlQPJDw8P82GRXqT523slTrskjAw4PDz0WZaLNDHEGAvhmmg/1H+6c5tIivGSDR2zlIA6CBECemzBANjrhq1XD1hqeNyW6l5PZrOyLIXl5MIREGMoSEBMBAjNzNZnR59t3P1sc+3WdH+au4YdQHlRusDUxHPZoHqRaVdknSeMT5xeiUAGYozLkZEByt5lzDBT0wSetOHLe/fqmP72w5/n51YJMMMSgzwQTsg1BiJDoteHx/zqAetpokBRFGBK0KAJADMbWERgrG2MIsHTzmT6h5vf/WFrbQPNzEvtOIHJCGAG2BSn/JwvSAg4camSKRl3TvWeBU8ggxITVI0DY8Yc6rlurJM4XP/ovfPnSsIMKAVC6APfBEJSVbMkUr7YH/Cc5BUF1pP8KicuQWOMCiOiqInZhBwntKBZjFuz+ecb97/cWn8wOzoqXOOzSAxAtM9gZuv84y9WjPp8CjKwsZI6ZXQOkS5T54TY0xleeV4bbU6neu8emwPeC8vLQ6NVTwXDAbww28VI7Umq7CsqryiwTuSUzW5BE5g8ewIpLCEFS1EkOdk8mv72u28+31rfRUjDQaOtgsmoi8+waWK0PevlxZ6tGsAmCuoVJCupGKsBpArAOt1p3ckEcVQwO3+U9LutdbMU33n3+vnzSFgSygHWxClljoXF8f+YCp+32MIBTX2yOwlkTtoCO6H5fOfB5zsbd2eHTZlX5qOyKLExGQiqhMiWPADYizWBTVmtDydz5+Q04q6Kg9ljPqjOj96ESMal997Rfmi+397IirwY5JcGAwdHAFkSS45eH0wBeF2A1VFfHHFArFPjxXfG0lzjndnhH+/c/Hpt7chiHA8Pmio0WgyHemrSM7JGNBEY8InlhWktIyTWLq8QQGdmdS8AANpPx9RhTA2MLKuboClJlqnR9nwqD+62zfzvP/m5H4w8nBehPmLYVxp5LdLFXg9gAVAowAyOsTEz7/JZM9uaHH22sfbH+3fXDvf9ytiKQUpJ1XKXh7rp7PTEaBmtoPYqipG+wFtfCZEVAFSJAbAouuiMUh+A6qx4XhiR5tgiB7UqdZqVNo8Pp0dHS2URLl2W8+eW2eUiHbC0DZzlL+z0n6e8SsDqbsi0CLYREtmJv6pumzIrGQxxrVAL2mmbWwd7Nw8Pjh3HQTkPEdSS916tqWoHEoOSnsStyUAvnmJOxkYdcrhfhRqdUjNKiwmx411VszkJE1HU4IR9kbUtDmazz+/eUo1FkfHSUo7cAwKk1P2Ax5Ygjy9zH/uBL9HSf+F8rLPVr0qEqYIYQ8ChIdRQg2WQNlQDX0ZgllIrcmey99tv/vztw917bdXxqxQwogV95tH+F/U5LDHI4NMLNLKsm+2wyIIFnT4NPJ50331sIJB161YxsIFNvWoWw+XR+Pq51Z9feet/euPqpSwvIwqCpYagxAwRnLrxFgxHWYQkgJcaWHyVNFYnjhGBFuaRgAQYNIFKXyoQABXZjs0f7t76bPPBMaN2LvJpflUvp9flBDgl9+ILUhHwAwPuiaokP/wGwdCV1CIYOBHUWBkq2X4McXcntmkpH4wuv+kdZk0aZTkQYWaWYEiUVDXBnOTo+Vsn5LReT74UbL00YD2dX8VAAbQIlFJkcpSBE0xTMuEETDStT4++3F7/4v69e9NDGw7gBy/j9J+bPJO/xZglnU8m9WR2riyXByNdGpeOC4IDg5BSSikSERG7xYXsLLeOA2svdSp8xTQWAQ6JEBa1YBgQSBJpgQCsHx/+07d//mJr/SFFOrdUqfnXxWP4NPkR/paZUea5KI+r6tutTefc7Oq1989f8kAJFiCCABIWJw4wJANA/MOY/cuSFw6sM9WvMrIWpA4AEzp2EgQwYJp0fXr0xYN7X21v3JsfxeVRHJahDRzpR6jDr4E8g7+lIHbkBrmSbsyPqzu3pjEq4YOVc+fYZwAkIyMmhjFMe4SaET+qA/YSB+bla6zT/KoEBJihr9fYmQuN4TjGnXr+++9vfLG9Mc8c+fFRDG3dZD63pC9z/J6HPJW/ZcxVjJRi7hxSnE0P4wNTi/mHH+toecXlAnIiCcTJrA3UEwMFoA5bL3dUXgKwfrx+FfWpEZRUmSQA+/Nqu5r+eXP9s7W7a9WEL64mKpKqKeipqTuvj/wIfyuomXX6zDj3bMVOW8vW5jjPqwtXrr5xecx+SJL3X+XeUDMCwQxsCC91NnyZGutJfpUCDqxdsFlhjmvQXqjvT45+f/fW2vz4SCg1TUtU5qXL8rZu6BVLXzurPIu/FWKb5TkTW4pKcANOMR7F9usHD4RcNhpiadmTBEAYkueIj42DvVzT/d/DxjqpS/W4zJuamb333f+a1ArIi6+aqsgL53xjNk26PZt8dvf2H+7d3gjzOBqQcyosIIqgNuRP2/NrJD/C3ypdbmoASFiTtiAvUpve29+LbTqczT+5dh2XrgTQIMRzecaOkOxRObeXnbj/cjSWAkVexN4+IgAi0nlmRnkZDUYwou1q9vtb3/9p/f5GM5vlbu64FTaQKLPBqwII/PJXQP8WORN/KxKkHByZ3t3bh7hhPixWzxWSTYGhQHhBylk4Y/87cDec+OxOiZBEjcTUFbZT0mhGRhGYqK5Pjr54cO+L7fW1ejL13IiL3JfkYINXuAQl5b4rxOsqZ+JvJebgZGY2Oz6um2aQF1nurgyXlrp7leAWm1tP5Hpp8u+tsU4VFUIXmiUY98X0GWTHIVDm7x8c/Jevv/x6a+M44zgeVW2dhHWRlyymZH1A97WWs/K3EiFaMnbmeK9pvn6wFmP7s6vvfHDxjdZSIsmAriq4ZxZ+mSyIl+d57wv1d20fOk1kAQiZ322bP+9sfLWzeWd6YMtLwXgWtRDirjiCKYDEtpgsXmtwnY2/xYTkXENOcgou7cyn8zuTeVOD7b3zlxfqSiklNifML7FBwcsBlgFJE7hrzmAKU1i0eBzTnuof7976/N7dIwc9v3wQmjBL3mcAO+1rCSW2yBoFAEQ7VvtrKWflb6kxF0VVB1aVzDWJ6skhba6x6NLSgLKRgwgzi4GZFKrK7uWorZemsRw7BRLU+hK0Op/Pd+azP2ysf7bx4N7xflwqU1mmOWlMLis4wSlE+xkwCiqnAMrA7rV1OJydv0WqCGZmMTP43GnI95vq5sb6eDB4/9Ilu3BphbOBk44sH9NLG5oXCawfeGieUCsGKCyCCNyCD2Pcnk2/uHN7L4XatJ5XalRmuTqztmXKjKDUN31Q4DT36FHviacpr2eWRnoFhKyrN8gdPUsJfTOUbpnSzYDWkSAYhKqqmIXgokFB4rMUwuF8/vk3X9u8GrDPVlZL1920OAuf+cSr+Hw03JmBddb6VSf9ATsCh7F1mxosmAVQItcAW9Xky/v3/3zv9t50Gr1b8kUpEpTaOgTTZBQ5tjASEhE450xjE2IIIAcWIe5u9UfA4v74WAR6O4uF9RUyykSJzQHo8j660emChkgKImEWkJmZJUuqhKEfABBm1pTqIEaFG3iNIL51b40adR//zF/w8xALliXvtSccAqdjHv2LLunnNKGrG7bngK1/16mwy9jE4ncxzJELwPbhwZe3vv/q9s2tgwMVJ8mcc5kzZYmMliiQgiWYVm2sUyJin2fjosgGS/PpzBETkWqKKZoZCYsInRpHtm75Cbx6GosXtbQAnNRsY4CInIiIQFPUNiU1U6fkrLWklJRShJmAhDk30hiPprO7dVj22ZD44njMTgw/5nLoUKUnq4bnyqV/bsB6Or8Kj8rR2SlPJkNhFtsowqVzY5JVyd5dvfTW6kXzPoqAKDGCIWiqNLXQo6pKQhFUxXZS1fO6aedVIzRYWpk3dQiBnWR5LiJBU0yJqXdnd2zSzg7rVderBK7HCkMu0h4VGI6GbTWfz6ZIKfNSOg8wq7mm9cS598WgHObFKMuGzpVMA+Lm+KhQG/ssMyvF5cRkT7mRTlfBQG+QcFd866Rx7L9dzkxNftZU2O3nKcDqwqJ9gVDtFtIEEKhtmtCaHw6N6TCkWQiROSsyQ9+QrTE0KTYp1Gb3tzYmbbs3Pd49OtyfHs9Dkwjm/cx4HkI09XkmzikhmSaYgKhn+vaU346N/sp56hcW1UK0uxNSaIWQi8uFMwBqGiM37S/f/3jsi/HSaHlpPB4OhnlRMHuzVNferDAMRQbOl+KdgRXuVGzH8Ij10OUCGB5BGVAGuy4B+98sz43z/qz9UB+fQVr07pN+jUMw0qpVYlcWiRCB2tCGxMxEpAQzJLXWUgtQ5o5Duz+f7EyOdw73Nw/3dg/296r6wCz4jLyDkzq2s6aGSFGWDGFAFGzIUpcPzUbaOH2hRUHOKtZPhicmjvXNf5smd1KCKEYJujQo37pw6cryyrvnLozIl2VRlmXuM9dNBppy5iHcSX8oNpAazBzzIrhjRrSwq07UleKU3Q4ge2WB9YP6Vd1pp75FIDpgCWBNYPGAIBmI4TgAIVnmeyYWFrNoSF3xY0A6whYeIt7ZXLtx9/bdh7uHvtg4nkybSsrcDQYttDY1wLmsc9M7RZZYFGJQoHEa5cWz3/86MUCJFxa0ESCqBPUWSxKrKm7aZZ+9feHyB+9cf//tq1fy5QugDI+qri56ICItINV1Hes+12h8ui/s45aALp5O5yu+Qhpr4VV4hKOT0tLoS3Fo1z3+ZIEoQD2bZeSzLAc7AFHVhIn6IFfnOYUCSbXVaBrJIJwyCUItrEacpXYC+sP99a/ur91ZX2sFfnkcHdWqtWnXTESMReGUXYIYjNC4mPgVAlZgNgJB2UwQnapTzTRlMY3Fv71y/m/euf7za+9d4QEDltpVybjju1tHO2XH2Ql41NQTn1TGBUBmfS+7Hx78B1Nwr7fcc1rePM9V4ZP8Kn7sv9wZT132SDZcCaEJSQsHAJMmaEKR51WomZGTZCSOiYiYXKaWmcIJpEvhoQwyknIFguvvjfPhpbJ8cLC7MZnMmjkG5bnV1eP53IiNtKu8DYEp2WM95l++LE5GARNTZ+o15VGLFN+7fOWd1Qs/u/L21ZXVFSoKWAHKJJOUCGogYzEmWwTHDDBQ53ZRIEQltSyThXOlv9l5cVmoT1B7ZBYzHot5/xvl7MB6Rv2qeV0TUZZlp/sDGjCfzwfDoQGtxsBE8IrO2QfyOXVzHJDK3IAJQL7oLPcWJjAx8wDBvHMANCbAGDYUBkkOXCbnL79xPs8vbA7KrY31IzuKsTnY91kRUpQsJ5GmDqSWiVd9pXAFAEQUU0IIDC0IA6Jl50bifvnm1Y/efPt6cb4AJMSlLjQTgFzMTFVBRHDWj5XGR/55AERCEGrNPFEX4zcYVJms6+BIBlOFmoCo60V8Uvr7eYzR89FYCpRFaYBCu+cQAxHl4svhUhtDQ2SSReDQ6mA65EF4lJ/S9/TTPovQAPOg7pEze4YDZnWbiXPSFenXFI0oscggIXOydP5CQYYYLASZT2ZqBp7BQmgbtaQoigE5H+Zz/yrVTWeDWbIQM7ORd3mIRWqvX3rzF+9c+5ur75zjvEDKFZkyp/56x6SRoeISLFqMoM4JHfuo62KSIHQ5O4TkwAQkVVF45zyAmAZOuij1owBJMkDhn08Fgn8lsJ7aHzBZSikZExGRMBMrqAEq4kloDqbH25PjrclRrZoVeZZlABYqGolgbIlwXE2YuRQ/8PnQ5yPJhiI5ZGU4yJAyYzGwKYMcyBkGZAIaAYPViw4QkN9a35weT2cz75jEK1m3IlTumwW8OkIARS1JciAPaRly/fzqr669/8t3rp9HLkiFUclMHtaAFOoxZe54aRX0cDY9nM6qpm5ShPPKJ9bIYv4zwDQXhhKlWLpsdby0OhoPnMwMOSHvbjO1k1Xi85J/q8Y6wVbQGE2JSdhRH5VAACahNZ89rPWP339/Y32tEY7MB5MJi+AR1RFG2sUBI0xESp8VWT7KipH3A5cVxB9de3fAspIPlsvhkvMERCBGHbg+l4CA91cvCoihbou/21oXET/2WZZPY2qbVmHsRFN6ddBFBg5xKc+ziDLau+fP/8PPPvn48hsjI0+JozI4CsyQBMRIDg8V0xhm1Xzv6HD38PBgcjyrq9ZSk2KXOvaDQ3iRFCJFzZiGPr+0svLh1XeuXXrDp5icU4BilJQyErDg+TW6e27Gu2O3qD23CETB5pqOCNvHB7e3Nr9+uH1/OpHxKBFtNvW5c+e6Agfc+7dImQE0bYCmSWqoaYVmnsgTO9V7x8erw+E75y+/e/mNK6PlpW72jDpwbGgtmZdsDHpndQV27dxo3Fb1+vS4ntXOuUQUQzAi9u5Fl4o8k7CB6ihRl4v8+uVLv752/WdvvHURjlIsRSDchNSGJvkcGVrgWPHt7s7uZLK9u7N7sD9tqgSjjE14Op+dDmA/OoR388mU1UZZ5qKWu1u78+k0tR9eeUt6M15ZIxhZ/8XnA4nns5cTNCVoMvXkFVBYS3oQw3/95uvv1tfmzM1oUINCSvPcpxAZYFXGCV9BGcj8QAnBOr9wghlpEMPu1vqyL7YOjtYf7l87f/Gt1YsXl5ZXCheRHDQTSUgGtwS5fv7SxfMXY9TP79y6s7dfzSrJskI4ElIML5Wv+0MRMwcUrb19cfXvP/7FxxcvDy2J6pI4ApTIvEuZC8AhcHtn97uNjbXDw6O2mUxn86ZKDGUyo0RKLE9Sao1gTHNh70BljqY5mM6wu8WZXz63gmIgcOLYkkBYyVTV0fOBhHz66adn+8YPYjr06LMETZrUjJgAqkO9O5v9y4O13938fn1y1BbFlHGkaUZUG8mgNHEksng4iICdRiRDMiSmKByYVTiyNNBomNf1w72Dnd2Hs3nls3xpNPBoHSXq67uYwQTiQeXSEomEpPO6qttWnBfHbWjkVWoa7wznffnBpcv/4f0PP77y1nkgV8qjFo41WWuITDWwAf18fe2339/4cn1tYzI9DKEiDrmL3jeCGXRulrw0QoEpMAVB96JlnjHVTOrFnCPnyDEIbd3EGGBaFF6YvLhMPDElTU6el8Z6IpnjR+5o6lIi7QRS/bbdDjyEWSIsAHOLO8fHd44Of3fz+4ca5dy51rvjaiZlORyOMKtYhBlkBJXOeqQu25yNwARTQqKkZt16SLICzsWEo0k1mRzNQToqg7dfXTofNXqKOTmPzMxC29ShXR0tffT224Fs0s4PdnZFOOOybiM5p0R0yiHypFlBp1gBZ6I+9y1YF6IE6/LlCUbabwBzqmJgxSDGK0ujv/3g/U/eeqdUtWhLmTi47Z39lUurc9MJ6KG2X6yv//7Gtw/292KWz4WSEKApaULizOXDpVHuJrPZo2jHIphtADEcSWzDcV0l8eNiUIW4PjmefXejaRrv/dvnVjLOIwCAOz/9o0F5umf1rxkR+fQ3C4210D2dezPBdJFEuvC/gY0wjYgMARhRbV43wuRZUhO8SBtSHWJ0br2a/eH2zd+t3b9Tzed51jIFwHnPgMboCGSJNUHVoIakMO3bg0PJjEzJCERMTMxg57ODo6N502TLSzHzD44PN+vZXJOIeF/mfpTBZaAclJF4L8Rc+CxfHVPGKWmoqjSroGaZzFIrwi7LUkxBzYkT51WNrC9VxTA2ZUpsMNBfzxsXg1fzCmfU1clS4iAUhHiprC0GjaQhD+0opjez7L2lpf/1Fz/74NL5NzgfEkpVT8wCFMWh6YRlM9Rfrj/4/Pat9Yf7dTJltkzUAQJ2xLSca1QAACAASURBVI6ZoJpi24gZwZyZmEmfcgIicxY9pYJcISLEmhCNzGUh0bRu6pCc87l3TPCwQrLQtELUrScBTZaMzGC6WDraIlf0xwflMb1nT7w4/bbfUe46dxMAInau3wMzh5gSkRbZejX/7Y1v/njn9sTz3HN7KvpEgNipiMqpmbSTH0RbTvzCTdMoCI6jk3w4GA7yadv+eXMjS1p8PCwLpIiYdCVjx5QbGdIMYQj6+OrVtomzo+M4rc6NR1OXtVE1plYrU/aZZ5eFGDunsyg/igf35bvPHLJeqA3u0ue7GHxV121TD5jHZVYmHbTNteGl//nDjz6+fGUMKaCsURQkSACEEmQ7zD+7c+tfbt3cnc1pUOQs87ZNpD8wpE7ePbnaFQVIYUqmXYA7ESuzGiz3+zF9v70DNW8YvHFlRK5KKffZibpK1t32tKBEdOUJF2PyVG2/kKdMqPzE1T353AiUAYrUFU8nZOKIyIAWUC+zpGvHB1+u3//s7p37R/s6HqX8+RS8994zc9u2s9kspZTnuZnN69nXa/eW8tz0+tXBKMsGgeAVGTilOFQ470ecp+vX5/P5rbX1wxipbbM+E4bajqRl1mpi5o5p192rTFDjHx+7J6UrInrSsrVLeBSFkVqIpaFM5lNYAr+9evGTa+9+8ua7Q2AIzkHMGTwSIQENsB2b33391R9v3TyGaeEnbZUMviz0rDQnWtwYhsQLhWMQplmM4XiamllJNipyOXd+IMR9TcqoFh2hM1jUOvNhsctTf541PPLpbz59ktxFi0fHxOaFo8hAXSvb7pkBZiJCJMyggfl+Pfn/bnzz2b07+xbDIKuITNzZzJRnfO6c67DVNE1d16oqIrn3TVsdHR9NppOl4fDy8nIGxBAckSTLvWdChJVSnLt8Ho73J8fT6SxFK7wvilJV66ZNBggbUfc4KQpAROgKxf/1p09QQiLWzq4CgZRgbJobRsxZ0xRVe2353N9/9PP/8M675yjTej50XkAEtEkDYQLa0/hfvvr883u3N+cTXlnSwj+cTeYh5IPyTLDqswT6lHsGuhxyViIwW+c/TaFpmhijK/JhOXKgBCTTZCrMjphARETa1bMk6hibi2v6zOt1ut7NYxs9HqHsP2Obp8TiXO+xRQISoQHmIg/mh3+6f/fz7fW1+hjDYcqKpqrlOVHM67r23nvvl5eXm6ZpmkZVLfNc5ntNG3Y3nOM8c5+cv3jeiRp1TSuK1LakPis9leHa1YTEt+5v7B208zbLypxkrm2MUXyeiEG6SMdgaF8d6UyswAVbgaVrzKnaPYuZpcbFtMJy/eLFX19/72/evHqZihwGyXIwgEndBkJgt3589P3u5h+/vzEvHK0Md+tJ05AsDRzJNLYlnbXUHPeOUyMQG1gZBrB3hmhlJkk2q9n83s0KKRD9/NzlISDiiFi7nH1TtA36vAzqcxfsL/RPlN+ccjeceDbRRb+fHDjCPAYIOxADahZBU4sHGjdj9U83vv79/TuHbJWXwzbM2qjEZ22m8KxRY+YQgqpmWea9V9UYoxoS03hlOapub23OZ9PRaLBUlpxS4RzqlqOWZQ6iCoGY3lx903nXVE01namqdd1ZHZtIYlIiI6PO2uqWpz9eNu4JUUIQ0T4hQdngTL1arrFoU9GED85f+N9/+etfv/XuGJRrGrHLSLoqTtFJdLLXtv9y67v/54vPH1qYilVMrQjluct9IkoxOpazGH1kRD2FFwwTEJTIiJx387pqQyteUorTal63bd00K8srzrsujcAMAqIQY92IeOhCUTF3+8GPAOsfP/30xJA45UAA8IQN3wVBSR2fOP+pIn3Y1GvV5E/bD35799b9+VE7KFqSeRvYyItjPpvx+yNTYepoSGZmRkTMTMJqlpVFVJ3MZ/O6DhodS5FlA3FsJM4xCSzGFHORIVwxGkkijbFpm6qNLELet6boCXdEXc5Hx784I7aU0QorAdSjKlPLUyyTvjFY+mD14t9ef/8Xb1+7AB4AWUQuYoYGaAk1sFlXX9y78/vb33+3t+POn9tvmoq0HC/7Ip9VTWzrzOf8yGj6qwZzMcEz9f2qepcRhOq2TppYhMV1hua8qikZgGw4YmIGOYKHSE+io77THQHdXp8NLHeaPfiYPA1VAEr2AHWhukRowHvartXTP67d3YzVvMwspdimPCuWs2EKsbXwXDjms9nMe5/nOQBVBcDMqpr74uhwCkqDC6tNDF9sPGDYeDzKo7taDqGwulFLF4aDBthL9UUpPrryJlIKTTuZ7iQqitw3qokVyl1UpBsPJf1XlRxWEEjBUDHzGoukZUjXr6z+8vq7H1y6nDdBmUvvnZejo0mxvDQD5mp7TfXFvTu/++6btflk9OYbjZc8W1YNR5OpmXnv86J0IItnU6Kd1wOnCtwbwQwhBBbPxMpsTI5HMcaDEP50+xZBivEKRiMmKgAVSJ4hWN95u9vJX+qfKP/np785ra5oQaKI84pZIIwO7kRgIqJYN9QVrGCaAvemh//11o3/+5svH4TZNHNtlilLRi5X8bVxUuOzcet+RGMRdRl2j0ZWIGJczaugUXIfBVVsJ/V872D/4sULRuQhzrssy9gMKZYud8BSnq2ev5AVWdXUh8dHbUrlcBBSdM4JYCnCzImQIbSNO8vMo4SYVGNyZrnBNbWv24t5+f6FS//p5598ePHyJZcVLGgDmTEhZe6ILYDvzY//6as/fXbn1gFZlfnt6TQ638IA8ixenANJUiQ9Uxf7roING5yRGMToZFkGQJhFmAiUVA0EZnAK8fDoaF7VZVkWRRFC0miFMBNBDZo61nxXJdUMQk/Hl/xfn/7m9BoQ6HUV+wzCJ+vDoLGJIaVU5IWIqFAD3Dk6+OcbX3+2fn/H2mkmlefEQkY+caYoorEhyPMB1jM2ppy9JYUTNyjMSWMxaGpTnE+ng3I4XhqTKowck5A4QlW3zkm3pCBiM2vbdjKdLY/H1WzeNnXhcy8uNK2pDkYDS/EM52NwmaMUS/CIydVt0YYPL1z+uw8/ur6yusyuZM6JCu+ciDJXzFPw3fr4q7U732xubM6nR0CbORoMAmAkZNx7OxXS50GdwWFLAPfVbokAtoUHhRREvXK1fo8EAsj5PKk2IajpoCjHo1HpOAGmSgRiIcckwswgYqInPAq9PDswRNAY2hhdkYEkCkUihnQOsqni/tHBZ3dvfrl2f72dzEZFyy5Rz3nlE2fdC+4PSAZLyhAyxKjIiPOilXAQ9Y/ra+y8gt4fn7tSjBzBGcjgNTGUwW8tL7G7Wgxyvn1n/mCNJlURozjyQEzRNIpzIpLOdD6wIqFklpiobsYs77311q8++OBnV6+uQkrr+w9qx/kBZsDdav/LB3e/vHdnaz6dCCqoqfkisyaSoV9dmnLfwuLMxcAWDQW079jYXXJTM9Dp7PUuRZ0Q2bUx1seTlNYci3OOx+MhIToqibNO+/R0PFNVeUZs8dGnTxqpUTX2tj8UrAyCPGxaybMH06N//vbPn6+vHTmVpaVGW6O+q5YYyFQJ6cVn8BkBRC7zQSk00dTYsZO8RfClfLm5PptV7YeflG+NosE1abmUMheCMhCAN0Yj730Kqil9defucGVFsmIeYtRYOGFxdT0/09JDDKhmo8whtFy377759v/26//48+XLhak3y5kYqJM1QhE4srDdTn/3/Te3drc2ZscxzyQvkLRurZo1hfOsXR8UXTgR/zXjo1AA0texYYaqQUw7TPUJ0ItdKzDTxOKSx8O6+frBWohtc+3auxcujqhTdIBGitGLcEdAfYY8u8gNweeZwYEkAi20RTJQk7u9ev7F+r3PNx/cr46xMg7iQ9NkGUmfeqtsj/oDPh8G9TNECSrOeS7NI1RtG1OIxkia8rLcn8zCzo7zuc+Kd89dWMkcA0vChKTQLAV2ZZ4P0pU3vXPV8XwvNtPJzOW+zFwga1PQM9byFFNpGx9CKXLl8uVff/Dhx8uXlwAyldZ87lNPI8YUuH289+W9O1+v3T1KoSVKzNEJiWOz0ASYkEEssTEIhqRYuM7POERGBu2ynTu7SAFjOx0aWtQjAYMlQinPgqat2aS+Ow2pjRquX7hI7A0MSwJ15BzLj9h78o+f/gb9UvLUEHYhPIYSRSCBItAiTZB2Q/PZne//cPvmTls1ZT6H1WqZz52JUziFmCmbsgaxKAaiH3LPflTOBEMDzZrWmMWJEyfGpIakBlRNWw5HEdg72K+bdjBaKgdDNi0sOEoCJoIQO7DP8kE5HC8vHx4ePtzfy8qiGJaTqmpiWwxLS2eYzZ3aOVCZ4jsXL/7dL37xyZVrA3ABHZNzasKcgIYwJ9rW+k93b/7hu69nmhrmhjFLVqmBHUnm2LOymDkDwUCW2FJfMuBZVs1TxwepWzzR4vp21hWpUW+tGfpoAwFGxEXRRFWo86KmdT1v26auZ5cvXcydyyHEEJgjFiJLSs9wJz1tgiQAaEILJy1bAzUSBc+s2ZxMP7u/9vXGxtrxfiy8FVmIBqDwhTahy/2I3LcIbJwyULYvsD+gESqkJtSl+oHzA/HRKBknxizMIzN5V9f1zYc77vsbdd3+7PzKuZJyJAAFucYMpAPwhSJ3196ZVlUUethU03lNlpiR0tlMGlGsDodvDy5+eP36B5feWoZn1IgkTpxwV7mwiu3d44MvNu9/vbF2HINlLnZVcpjM0EZ1MIawKRvD+tIEaWFadC2u/0pRQmSAFN23uGcAKOmi/hZ3zIW+ZxmhVYugZOqUitwR/EEzj+vzCyvj5tIlWr20zD4XERJSxBC4c3I9ORSffvqPDKOuWH2XbEYGMnEezIFonkJgNKCH0+ObO9v/7zff7iHVTipDC3F5zkR11WQsZOiK0yXu2rgZGXsleXEai8gPClWjkMTAUE2x83INx6N5NQ8pjUYjNdvcfdikeOnSxTeLsQcZvIGjaohKxJ6oDen8xdUs99u72zsPd7Msy4qimc9FXGc102Jt1QXBugtDHaHMzFtyqoPUXisHv3rv3Z+9c30I8pZWqCjZzea1y33DmBO2mvb3t27885+/2JocDy9cmDRNHVWdy8sRZ1lsU9u0FqJ30tlIRmodj2hx8f/64KVR7+dl5UXorqt/SNYX1Oj7QvUBZaI6NMRdNnRkGDtWS3VVPdzbA6gsyiLLh1JkoM7//GSguTuM40duIetdFH1SMyUQwN4N9kO1trP1/YO1mwcPD4EZODkHgIhSjABcJqH/4VACK+VgpwzAn3EZcyZ7n6DShgGDMjakYF3wkwmIoQltK8SJGD6rfPhy/+H097/LfvV318rh8sA7wIkrBAAq02VvYzj/zjukbfatu7+/1yY7Pyz36qkrciEmYyIJUdsULZM6hLLMgYi2djFKaFd8/tZo8H/8x19cW145h8x3zLBuWItiywDC3ab556+++PP926EcDAj7B8dpUBizgds2GlJOnOfCxmTBuCt4gS4noAsVnakuJhtcIhB3YWc7xVux3st1KpZMStCBs0XFEFVDYypesqXh1rziza0ITlepuJQV7JwBjaJgEFLQEIJz7DKv0Ca28ul//s9YZJcZQWEgJKKOCGrgBthp6u83129tbKwdT44zXzsxesKb0t8B/XTORmIkL770LPfuuu6uePQQEU0qInlRmHBrWlmKycLxvChGw/EoAUiaMQngCYghYydgcswixNw27dF8MhgPwbBkKURLJj5n55sYwWyW2FLJVMZQhvjB+Qv/yyefvHvu3Ir4IVwBzsAMRKAmzAi36uaze7e/3dk4iE1wnIBAFFyWmDvLiXofeed97B52ErUlnEFXdUIdM8UWCqnfx8Jvhcf8pQAAY0RC7IbUyIxgkMikzPOqSimNh0vnBksZZR5wiyxN6xQrE4sYLEIdmGGpLyhnpkQGJHCtKTE3wE6s7uxufb+z+WByfJhC4uJ5YeKFSoyxyxhu29Z7n2VZSilE/XpjjWGt0/cvXLzkfAIyQEC8aJT51mjV3stkWNQWH64fhRDqmLxkJD60OhApyoFWohY9G4c2j815Wbp2ZfzLd9/79ZUPxwhDsAczKCkSoSY0wPq8/uruza/u396pJoE5mMKSZe6VqqlEhkUNbz4pg9i5J9m5xGFrevzl/Ts5kV55x0ZLS93odV4tJkFPZROQU1Bn2SckEC9IyRSIImQ/NTfWH3x+7/b946NJRsrla1Stv4tbN02TUuroXGANQl9s3p+0c/nlr8YXr0iKFuI4Lzw7AwK0AF3ww/rixePZtNb4YD6tYuu9z33+cHZwsLdfDtomhuWl4chn2qSs5Y+uvvmfPv75e6sXx6DCUkmOwG1KdRsDuynTIewP3/759v72w2bWeIpMVUig5MW/am2mTlqRMTidhG6IQTZePdfOZze2NyymYlD6YTlTXGA3MDAxUV+MngAxuAACWGHUtXUhGEkCJaIA7FSzrzfWvt3emjLZoKhUX5VCLX9JRMR730VsQggpJRFpYDwsZ7PjZm9z6fawMLy7NM4l60tqEJymTDAm90Y+jG+9WQ4LvXtvNqusavNssFwMqzaULhtnZaoba8Iw4vrqG3/79kefrF4+B1ALTupKNjARkHESbP//1L1pl1xHciV4zcz9LbHlCiQS+0YQXGtTqzXdZ2b6T82n6elmT/+o+Txz1JKOVF1iVZGsIlkEsRNb7rG899zdbD74i0igxCoJJaFI2gGTichEZsQLe+7m167de3j8m2ePP3349SHSnBGcRIE6b0mimePX5ea80SCAs7JmVnJQIBEbKTk/F5KiULe4e3Iwfnifh4Pb6+dqVQ/2AhipWe4QMMglgEACMjWAyWCgREjgE9g3J8ePjo9fdK2O6sB00raTYvCDWLPyCIpzriiKGGNPuWF6enI8mAy7Nn3y4C7mC/f2O+PtHQntWEoQKucN6kAevh5tT0bjNnJ7PH/2Yh/shiyVc56pEJ7PujLZhbX1v7h2673d81UHCRhWiMkDrEBijsBBTF8+++bnX/72KIVjthlSlyC+cL6MMXaLzn1Pr+YSycyiecTeu/3jI2+2tbkZFs1nj+5X4+Gl9XMj1Ujks2/pstfMRK6v3RRsTEaKXkpiYfbg4NlXjx69mE8756P3HSiwJMafwbX73yQyMdA5l2cJzSwJtUEL7xK7g6b54tnT2juL6eraeqxsyKUHOZBBBVxBKgzo6rVK6Ysvv3xxeLgITZNSPDlWovMb2+c3N9/ePX9799ymQ7lApQplKXxnaAgnKT04Pvrs8cNfPbj/8OSgG9QLWNeXLKQxafw+XkfLZOq+xjoFP1WhxmAYSwOeN7P7L158+fzhZGOnI/IA9+MCmctNLpMa2MBGpH3P0oAmxm9eHNx/+uyw6VLpEzt1rnIjhPQHhi2+X7G2tjafz0MIZsbMfS0PHk3W26Zhs7W18XQ6//jBPZj62+/QoEwUaziNHVKfjgJOKMqLl7bUfnf//uF8HkwhrnR+WBZ/+f47N9a3JCi1aVQJIqcmpLGfAg3wrGt/ef/u3/zm148XM9lYO0mxE3DpfVnEGBfzOdTqov5eKaIafctbm1kFoY1r44mYzmdzmy8mvpw27a8++80H/+FsyJrrDErcs7QsOTE46k2SEE3JuOKTJh4189/dvff08NCNBsRQIyK3mM0q/927/f5LYj6fA/C+b1jmT5RYI7p5l2Ln6kq9dLH79d6T6W/jv3vr1vWtsxf9uHIltPVBXSQH2y1l4IrJufOXJuNZCIGMxIvI1tpk7OsRUHoeZFhI0Hk70njCchjbf/jdZx/fvdMOa6mKw9jRoBTiZEhNJGDoa2Tthu/wGn1bZDSSlpKIbL2ucykc552Z1q4sR47a9uTw5LFN7zy8f+bazRYoAeepWbR1WYDIiYJWrc1c3BOC6eMXz467RWROxAaIeM+FcveDdjQlg0tWsLAvqayUEaAvoJgdtV99HpjLs6MxUqUYuDJf0VKxBanreqP0DUEdE4TBCaGAlpCsCNrB1LppQZHd7w6f/u7xw88eP3zSLUJVtF6kHEaoLoWcc/3yrVJQ323YUmSQV5imsSxXIQcSI1YjJYYw1MyOm+YgdPAF5/5ghszMHMx6sioTBMwIwCx1Xzy4u9/OgqMkRMaexZEYO7bwXb70f10QUJKoVIpk4MiIpW+7dt7M9mcziAD8zpmd3apKgMSslheFachU+mIIDoD2tlxekRQxgAIoInUS53B3mr2/v/PlvWdP97tmUUgDnXbR+YKZX3Yv62eu0XsJfV+CLEsB5OUqE6Z6gNaItGeDrpQEjPDscP/J0b7b3CrYFwALmxlpbkKv8FeBMubAQTP7+vk3xxa1KrOeiSQ4qEtGxG+avvfmIl+UyvlOOcbUWVIScz4ELevy0wcPdBGHP642NqpDoIg69pktbpm6mChJ7oWYFeQ6Q0xpwQb2AXwCe96d/M1nn3728OHcNJW+Ncy70MRYOKng2CDaI5BKCiMl+x5lFQD0tolkIONsKwyogTUZkYmRmSmMmJQoJDw7Ovpm78X6aDypfAS8ODVjqDNSkCQkgSSmBjhK7ZPp/n6YLuoqFhIlD06oxUAhkf/hurgBQNN03nsRUdOobKTMHg5SD2fT5nfPnq99+YVes4vj9XVXmqA0FkOEJYUyEZnPGFXmRzgXkBrIDOnu9PDzx4/vvHix3zTRubYLrZp5X4oriopCf0giaO5AJcZ3Zyf47UGWp680g5xsTKZGeVm1LL7fmRqZOlIjNn0+P356tH85nO+qYQIKhiUYkVMxQCNiAil4Dt1vTx6d7DeeQoFWUiRhIouqQTNt67XYut+rUELTNAZydeGpNEtBg6bIyifzbjRej4v2H7/88ujg+Ge3333rwsU2yjnHBRCXq/SqzWY9jwkKOUZ8MD/81YOHn969OzfMVRUWDeZ9ORiELmlMYiL9kAsrVImzCoPo96t+J1OCSp6AX6LwIFUDC5SQVBVaMCUQ1GZduz87aTRlCf4a0GVLxwwaKSmgcAukg3b+5HjPKheEGo1KVLIY1BK8k/hDwBr+SEhZRJiGKIVjEBtDic2lLqHycH6qizsvntOd3x2Gdqcays6FgTEXvd0y5aoogRIWIU41Hlp37+Tg0ycPv3j+6MV8wUWRTNmJL0thMTNLCRE9vdagrEaIjJjfMvoWMY/vMGQps9j73FlG3s1giSUzYBPBBGSAaAdddG0yy0T+npoj7BicfZnNLECD2SLEWRPYl3kIFkLsmEiJ4ZxEvMbUyvctDBiOB/Nm0YWFM8fMnJQMjsWX7ng2q8Wtnz2D0H365OHj6cHNnfPTZrHmi/XReDwcDQrvjSiqpkjETw7399vZocWv9p796v6dvbgYbmyAxKQR9iBu2jYmZXaT8TjMu0T9JIUy26mOzffoRl01CmE9RmpLGpeZMRGTRTOYGTkijaBOuCEEstgDoJRVVSh05jySIuayHen/+cXff/zNo68Xi2nhGueUWEBe1ScwNMoPu8bKBF/JndXVdQQSMo1OCSYpiamkxNDSF1fO7e6ubVZqa+I3RyNRHJ0cH4fuoJ1/c3L0ZHZy0C7mZCpORArukbNESIRsX5DLKaVcteS6uF+oyPR7dRgiO51t7ZUsjFYilLb6QsZuVDE9euvMzgfnL//ltVs3q9FYMQTQRic5v5aSMvnfwYTNkXo26fEygnFS0yU//gcZK8NEAP1SDYVxygq7PYSDCBZDZsTux8Xs4NnDo33fxLHJ+qA2s+P5SSjcHHaCtGBt69LAwk6INenKzk6ABM2OCpl7bqoEdvmCZy2ul0RZvh/xUprT6Uey0wdeBkhM3CKFWdt1KS6/CpBzSsicdP39RTk/IC//9Qe9Vq1iOXXe91kzAqxklpngBqEVVMiuGrYJe81CujQzOkhtSmnWNlaVnSAwJ2IiYTCnPA0qSsrLIT4B94JGPS+XaWlz973aBP/kWImWhRD6DUABWQ5T/JGbZkXQVHpFYPMHGUZLIhtpdsok7kn6gBEbwZa+kFnPSI1UzbGXygfiVmOCNVVRjIYRGtU0GRuTicARkULzj0CPXEMIRFl+rX8WpzwZUvs+7YN/QmQVoKZpYuyL79zdcrZsPdor6dV/qr0Pdr7rsknjn//J/5vGS6uuLs/UecVSUgBMSLkyMLAhxkQQYQmMYBbMkjCqsiFVA1gY7MwVkMKcMOapNQKsV4DNP73fE7ILFyHboWGpePuDjn7MxH5/0XF9Vr18tV9KMDZEViFDX8f94PMKGWhRNjAtJY17Ab7cwui3/x6AHhUVjMksWgwhKJQKJ4WbzxdMIuI9ixhTgqYUo5lQIiaAl7lFRrnByv3ar2mVWz/w+5QBaKyKalAVKzVaI1CCU1oJmPRrVoYxej4/hC3fW6akArxUdf1Ag1cf+xkMWtY/+Qtm2XRHDGLquySkACSGwswcwSwtunVySiA1aIdESSnmkRpXJKKl2Cdg+ZTQz27psk7NEgSAiX6/wPfXjqSlL0aDYeFdxo0BJIsrMr++NCWClZvy773m19e4+0GEEcCmCu1l+FSdqqgVCa6d175wLMzOFyLOdbGbLuZFWXWamhjapGpE4lxRwElj1rOaiNhgzE6Ra1ruZfWgnLUt+tv4ewWQvlaQAUkrJ8Oy8HJKhlVV55hni8WwrgMiwA6ysbY+PjrkRcMKDR1XZeF9iq2qVlUV2x/sZQAAqKr26hZLv2rLR2zT2BGpZy5UOYQByVpRrZfFyPnJcDQeDerSM7MljZpOZrOjZnbcxYZpqvGobeZprskpKCb4oiLnQhtAKr40NY3Ix2pdNgojg+zf1In0u4iCWZKdWdvYrIcGSJY8FnEEiBBBoYnYBK5y4kkcSAgMSprQD89a17RMxXf9Wv61kY/6uW9PBgEMWjrXdKkUXis8LVKaN5vj9dvnzr+9e3Hk/KisB3VZe+eMsnyP8/6omT06Pry39/zL508XJ0ezbh5YBmsbbURIbYptNKmqGsLt8WqyjAAAIABJREFUvPOcQYfMQOktxRlqK6r4DzDIQFFLwIEE5FajYGYOpr1ealIGFUyjsh6WBWsSk0KkM2iIRAmmIYay+GEnFmXUmEBmpwcZM46hUqtSKhHWpdg4d/6t85dvXbp4fjipQaX4ClIs3bwJCNAzg42zg9G58dq5ra3zB8/vPH/y5OiwbRsQi/gFmZkaFRESEJn8kjsAfNsx6ocYbHCKil1FTtC3UwGQqTMzL7JiZDlgPBhOBkOEBFbvRQldDMxwIq8lvfL9DTIYZRWWJUpuHNPQSRHTKKSrO9s/fev2jZ3dMbgCeSA7oAjMmXkjAjho6diL1MPNreHGuTPbI++lDQ+ev4CTYsiuLDXEpp07ySiD2rK4ZYMoZQbdD7pmJaBgGVV17b3vLxSykrkjgzCbRg9mcAAm9XBjNPFMrEmodIQ2JjjzhQiV37cBy9cN6o+DRJxpd8pZ3EzjwHirGlze2vzwwtW3N89swxdAnvvOqiyGlGACsKn3DoqwCN7xuvdO1mjn6oSLovvkm5Oj2WJGnitGF2MEvFRYVnWCHnLP9dYPfd0aD+rN0WRU1Xm5Ysu8QHZCDKiGTpwIUwLqwm+MJxuTtelikZI65xgEVUesrCF+n6i0rxunvcKecZuRBWfKITrgwrnz//H9H98YbdJihvZkMhrnAr8DFJRARGhNBeDQCaRiJwmB4QTleGt3vFlo/MXXX9zZ3zuZTaUsS++V2DQhC1jnszYxZ7of/dtZmn4XwYaN0eTMxsZ4MPSZcpMdt7zkKTpLMRZFkRGHAjwa1Od3d58+eDALkUrnWPpvCxHkv+uX86+KpSsXiMEKp8SAMxoNhxfX1t69eu3yaHMCiPO1JYp9M5n61qkkwFjFbFCWYgxFCZTAYgEm+ILeu3ApoTMvvzs8nLYLPxRzZTsPRC7zm8Vg1JMlc/P7B3yjAhtraxvjtZHzGaXK9m0AOSM2i0mxHPfRmnnsi/MbG188frjftM5KL5TAKVnXxaJUNcESXVzFyxfHXioc3jTJZvW7Xv5F+aGVWjNbzyEgAycHUjZmUzYlqFeUKd08f/EnN27cPnO+RBTQxBfE2p6cxKIMjqPjwGhhAcksUdItVyAlH23oHRNqh9rQMWbF6Mb5Ky38yeKLk709pcQDICmJKnEUTZYxMwBE9jJUaMgTFkarJ583ynwvLFWi3igVYDlMseyoAjjViCfNnns9hG4oU9zwfqOsRoDLnTGz7JPiZoCwK4cTqEJRMYNxuRpMz+18+vXn+4tEok1Ks/lsNJpsbJ5tpjMxy11bpfxuMp0On1hvDESa+4w+uTeXW0aWeGUwybQkLChnLhTyxidmkvUrzbnk2iawp7KqYpgvjk82xpN3rlz58eVrN9Y3L4AdiLrOnJGwTeqG3Rx2uJg/2n++NztuAee9E9nd3F4rq+1qEIFCURgkWWxNiurC4Nzg5lmdU93dPYhhOk2xDa1PNiij8yEE0uSd82BLyU7nKXrXAiNe9ZfISBROWZSdZksVpDfYYVTjDmS5klQ4GGUrDAIW01ld+HHpbTEvmSrnqnb27vbZC2VVA4A1XTssC1DZdY2z0/ZzTx30Cs9YL/zty5f3u/mT2bQsimFVd123IHcKAi1bE1m5BsYEpb4Bqwlq1I98/HmClu4HpxhC34xbElYMYpqaWLL34ix0FNL2eHzr4qX3Ll7+4NzlLaACOJqBFBTM5kxH0PtHe/efPHm09/zBi6d7xyeuLCaTydm1jQ9vvlVtDwgoTNeEPZGFOCQ+AYaRf3L57TK6n3/5m/litrU+Wgzcs2Y2D/OqHjgu2qZTo2FVL7p2NdWZ//snsvgMMAFkzG+YaWOUa09lozxRaEAiKDGAajTW0DShmXihxWJA9sHV62fqegBzQIKKkBEnIBE79/IuxsDyhdWuePvylYeHey/ufOV8wUV1OJ/H2BWvKuWyce7k59ZElg5XZcpSJfbKN7+JkP60xX3TzTgRc84l7QcVMv8pu+WSmIiaNqRxs65unjv33tVrN7fPDZYYlTgGigRE2Bzp/uzw7776/Hdf3wnMyXNb+bklC92jz3/bdR1u6Vvb57ZdkYAkqMR7IDUYOGyuD+jGzYNmtnj64MRhqgHQpTkmssOGqYq9ypsjVpD07NOea6rZ+lDUviXt/o3DIACxsiiLkhEHQmQsrBuMB82sQUhcVLKwtar+0e3bG6OJc1l7O2cTADCz/Nf/+pFbbfSUlZKhhMYiOT9vu+PZtA1JYRBmFlZQ3gRBSpwVIFbqD9wXNETL2bSVXO+biJVAnSiRMYOoF6/uaY/Ug0Z5NzQxqsoydS1ic2Y4vH3l8odXr13f3N6Ct0VTkzgmKCIhACeavllMf/HNg08e3b9/uN95seGwY8xjmqcAlv3Dg+nx8aCu19fWsxiRJ3jFUOAMCpS1X9veUpEXJ4dPDvZkUBWD2tRiCI5FQLHrPJwosUl/AftXQQTiUz3E3lkpsWbS6ZsKoqVyrPgkhTIrg1gJCwsoRS2xhbHxVlG8c+7CT6/dPCODkrIkIYGgpgCERf7v//zRaqp1xSHJqGEIoSprZn6+dzCdzVxZqGkWgszVlRIBTMbUq0JavhbL3OKV1PObDMpVAOfbArziCOUREYY5g5g5NTFjDdrM1svi3StXfnrjrbfGZ7YhY2AibiBEhlkb5qATwd3nz39+76u/vvPbp9ppVXZeDmN73DWdMJwbTtaaRTOdzrouOpayrMU7t1zrnCK20Rc89J5Hgw5p1jURKcZABMdsSTWqwAll4c1c8hJbzqf80TJLIotfRjalN7tgKZEys7HX/g8ZKyEJtOAutWRJNAxieHvn/F9dv3W53hiD/OoNNksxERETux6443xD9GwsBoYkHctgskmX5fGzvWmzaELQGH0x6EUECSvySSaMy8qpxQAoI0tJ/1nCeJlVAMBLaxBa2m47VacQU+ra7aq4cWH3R1evvDXYXANGwAC9MkoixMLPBU8W048f3fvr3/z6Ecc4quB8SDERu8mkdKUzenZ4OB7W7Tx8dv9ubDv2Ti5cZsOIgGBgjCrXGBaEs/XgP77z/nhz8jefffrVs2+GkwkX/nB6rIrJ2jA1mohf0tHLNFeDgRhmAGskJO75W5ze8H1qoj3HkVfnQ1EMyyLOF550Qm5nUL51dvf6xs4ItOIHAch2f1mI2UGXh0pAodr3dtgBW64MQBqtfXj1+iKFrw9fNKanXtOvaEjkW8l6T2XKBDrNqnBvNoytV51bFe+kL+MdMLKeX1Uk3RoPrp49+961mzcmW7larxUFoV0k9tJ6zARfHx/88sHXv3784JnFYmMjIC5C7KJK4RnupGm7RUNd9JWnqoox3js6qL6+0zDdmGwMi3powbkCkhUjuzXvJuTdzuV4Mi9i2uuaZtFWROo4qUY+rbGyYBArsykDqgzWVw4lZEr0Jmk2uZbhRIic4VxTgKDctBOgVlwar/3lhatv75wfgSsghU7FUW96Rd55BpIm+ej//Cgj0Kt7IpNmw6KtvWMgAfVwNG8WT/de9LQ4ouxHqtzbdfZiWyCgl7vIlfSb1iYwQHt7R7IllNVPw5HmoV5ncJa8aaFWpfj+pYvvXrjw1tndbSqHoNrAQdtZU4+KTjAF7s/nf/35Z//fp7963C6G53dOmjYaQcT5EsSqCrATGY0mbdOxyPrGZrT08Ok3x/PFcFCv1VVROniXb8FKxBMZzNr2zNpmKfLim2cHB4eDwcDX1XS+gCsiU2IkztVFDyBxf1MSCMqv6Ly/uQORESkEK3lmghLAKhbTdLrh/KbyO9s7/+ndDy/5Ec1nI1/EEJDJSKpOHAACuq6Tj/6vj7JbV554y7ePgMXMc2/obMKjyXgwrKPa0Xw2b1sSJuemTdMldWVJ/f3U//ucT8pmRG96uinyqSI+lrr4IBURTclSKIDSFPPFyPub53b/w+133j27e4bqEUhCrJSE2EhmihOhLw/3//rzT39+/84+pTAaLghmcBAxZjCTEJghTCTkMsypQLDUaZqG9vne862dLXWIzhGEAQFc1CHxkP2m9xtrW4v5bL5YsGMwt5pOQsODgr2bp9BpktKz8ylGBjNy9Z4H9Pry1r1JximBknGIajBXFknQtIsUFqXhjCvPueLfX77+v99+74oblhrLpI6sLEonkv+sjmnOOfnov3yUq14j6HJagmHaBMdMxGpgInKeCMT8/OCgicGJKweVgsDkvfe+SDH2ax1lr+XcC8MbXbOUoEy27CsbWT9pBW3m88qzN+PQlknPDoY3L1z60ZWrb5/ZWSdXwTgmb8yOITBPC0efv3j2D19/9du9p3uWpoU0Xkycj+Y0S6Vzf/DMq7JZTIHAUjrnXSSL0AA9PDnw40E9GkcogSpwSUQKHxIlONB4vMbO7R8dHs6mXLpiPJx1zbSdkxcuy5iSWvJFiZTtlYhgxqakIBDpikr/ZoKceANCik3XGGldSgnys/nNza0Pdy7+7OKVK8PJEHAh1M555/9QteN6U/KM9+SfDRUgTy3lbnwFbIBoY9v5ok362yePnp0ctV1bAwpFDFHzwn+KsqzQ5DfPkM+nj/xbgf5MqILkzUlM0oYz48ntSxffuXjt1vbOmlqZICDPngVGmBumao+a+S8efPXze3f2kNq66gxdghMWJVEoOAMbiTLlGCyIahEpmUbH5iUgTqEfP3podbkgvra2xeWoAEsyD4aaj3GtLt9aX6Py7XlqwoP7LzSkbu4sFsLGqgiJDeqEomMwwKl/Rbn2edMnITIUjrvQwGJZiGND1w2JdtfXPtg9/+Nzl25tbw4UsW0Kx+ScmS0ZbqfR59J//m8fLfEFCIyhPefdSXbsjaYgYsCDnHOb21tmODk6Pj46CiGKExjFGIVoaQKvuYBe+sG/jtfsa8Zy4zMCsZmY5Y/ObOCcS0Ga5mw9+PDylQ+v3ryyvrnBrgipFl8ImSEADfC8WdybHvz9nS8+efL40WLalEVwfhETwANXSoxsOC0i+zIS3knSBDWDqlrSSCJSeHLu6GR2cjwdDOqt8QZBqe0GhQcxOceMoCZlsb69LSJHxwfP957Vg2pQlTHGNkXnPVjCoi2Yc4tzabqRlwZ7Leve1w4yJ24xnRaOttcmRUrp6PDKaO1/u/3e++cuXBmO15ipi56MCjHS6Xxa+IJ+b9EiAHDtcrheViN2WCJB0AiLlqDiWRxA7Dzce2d3w/FJmM2eNPPoJJWuEOm0l33K+k9Z9q5/G95YsMHMABVlVmSfJlaIqVP1Ka1X9XsXLv7k2ltX1jeGoMqsLop8IpnGGB23xA+ak18/vvfzB1/taerqInqnhoo8w/mUDbSsb+SdXn+kEBkkzhE0hUiWWITJFXXdnpw8eL4/Ku5NivrW1nZV+wZWOUICGGmxGLjBZV/Hq9fabq5hcZzsZDYbMMP5TkNKkfi0Xfhnjq6dFwKvCceHdRd3B6Mfn7/w4aVLF/ygDil1wRPgHcg6TVgaZv9T2Uv5Pz76yHKNmQcqzbKici8+Q6owBnmSAiiAtk1rg8FkMiGipLZoFl2ITD2+h96Dpf+M7E0Xm/mQAO6BdfOq3syb0qI5NxrfOn/xw6s33to6swFXJx2xZGlGBTrhjuhpXPzy3p2/+eLTPUsngjmhMxKTgasH5ClZREwMpV59r3cBg7Zty0ylE++ETQGFJTO00zAajGE4PNgPXbs2HI4GNcHYVKBMXJYFcp6KbG1srA2r2dH+3v6+LwpXVfOmjTGN6xElk779a0aUx/9Br22n85phqWuGpfchpIPD3XLwv77z3l9cu7ntyk2WIksJeAZZk4IKKlfxyw4/dPrRBcCvGre2hLsM0ZIKGVhYGCwGUjjCmMQAPxzj1u16PElf/rZ5/iwxO+eImPO4nCJxNiF+471CNuWlGoL0TpzwitFwdPPSpQ8vXbu6tjGB1KZVMiYsEtTDgAVw/2D/Vw+++sWDrx7Pjm1zfaHa9Z5I7KL5pMl0USBIf0ey9dQRMlCe7lJVgxAxi6ohJGvBBRP5EHHv6dOS0F44urF15mI9jkZDYYIIQKoTlrViNDh/2dqZmT1smq5ZVETivCG9eQDwDwRFUhoIn906+7NL1//q2u2LZaVt6xzAZqAOarBAxmB9dcp0SfkBALfyVs1TK/kbQBB21PMbWcCmCZFgPCqwUAjSpWror145OHh+fHTQMc9SjMyRGD3j9lXO7UsZ9k8u2GlJ+rJIRO4or77590CL/DibghyZkiHvgGJaJC1Turaz8+7O+ZsbZ8ZAYVYak1nXJaqkAVrgwcnh337+yd/+9pMDSsPdc3tdo4lFpJTKKTdNGxVcSu5xrZSsMrnDCFVdaOi6LgDmhZxjEa+EalIdzU8IujaZhLD49ZdfNsfT4Y8G68O1gqoOlFI0s6HzBnRAHfXDa7fMV4e//Pj53tH69raW9d7RybAYafamNTaowcFexn2/Ne90dRmXn9iK17XEY/r35SWuzunCL6bCjOl0c7T+72+/91fXb+2yLwBfljk5Wg0KI2ZhZ7BOO0/l7z2JnF7y3z/6qOztrwjEYEKGbIhzf5fBAjAzhOBAFD2rkBpCSby1ueaI9p4/05QWizk59lUZkoHY+SKpIqsFUe5GCxmzCZmwMWejPsOyHWMGdA6aG4z9NwgZk/XMAyNZHvvhlNh4UI4XsxBiLIrCUttNjzcLeefC+R9fvPze2d1zUg6MikShi02nWvuDMJ1J/Pr4+d9++en/fHh3jyzWo1aFURZUluazmnEsbFGhdYn6X4TTUpoMZAYlInbCzhlzAidwYo4VZtaSUDUoBRSasJg2z57tjyfrcAV5b0AhLtcVzWLBzk/8ZGNjp2m646MTjeogQhJCBwbEKVPPYoZ4LtSIIARZXhnuzR+WOMiyDAHBEmuQECUBxMitbs6XMRJ1phFmpJZa6+YS2ip0W+zOSvHTa7f+4u13trgkBSs0JRYGiMgJCUMY5MCenJCcWtXRMkDy3z/66LTHllu3p2Z2xCBe3RwEkCI2kCwUaAxzTsS5uq4Xi3kXooGcL6NalxIzE4kiGS1Pbv3x4aVjRN+w6HcgJc3mBqK93aEYZeaXvVzMUs5FJVDTdETsRDS0iM3Z0eC9K5c/vHT5p5dunJGyMhSJnAM7tlIS40TS58/u/+PXv/ty78WepabwSUoTz+rI2CkRTBlBUudUGWIky8Lq9xeJ1aPLy5oY8OhSgGnBjo1NAXYkrk2ps1TWg7oofS5qDZXzTnwLRItrk8lwOGznzfTkhIicL8DUpdSFAGJfViIuxHTKziWsLmc+aWkPIpqR9cAkp8gGwBmLkhiTieWuvRB7b0ia2pppra5KTXZy8tbWzju7l9+/euNcvVYCPmntqJSXEgQkAIMkd8r/QAn92oO4UZPDUgTcUk3Fpa2d0foGxNu9e/cP9trplMQVzKbGrIFMKeUlOWVnasuaGeh55HnAYcmKFMtlE2faJxkvUyvLl2nfCTRVMzFVRVk4jRGhWa/rd65e+cm1m9cn6xN4DYsU2RdlMgRCqzhI8e5s/+O7d3957+4RcRyNOuWkKLyPqk5Pz8SiK6bXa1wcNpCSJ0eampjAjmufkh5o+PTZw4NummB05Wrh65xYwnCAhDBwdH24Ub01StG6eOfpbGoWzLvcNzOygAiSKGn5PuYtLrd5cl3f87GX2hD99XQKWZKrskdrLqQL59vQsqVSitISt11NvLZ55sa5ix9cuX55sl0CXlELe4OnXpRhpU236mAC374rv3ZisXc9p1HVopJPQypYip+8dVvBi0X78Gifi7IeDhQ0jxHe0GshMSip9fPt1pd0+au63OxVlMUgqmQs5gBNubYh1YwlwBhIpGJqylXtOUaOYVzV71y8+JMbt66MtkYwB0O0wnsSNIpAWBCeNrN/+PKLL17s7SVNozo4N22DGRMzZw5UT6VdjRwq22tAvGRknRbG5iQqWjJyDKYmxRYWjg/twdcQFBeuXSwqx7AuidCa9x0wha6T+/DadTP7+Os7D44OUyrKqizqagGbtQtj9t6z9fKD+W1NvdJebyGen4YtHyGDV+bkxIiNydiIyJgARzxdzB3peFzTrGsOD3Z3dv7qnfdvrJ+9ONkuAYQ49K4EUmttTFXtVinUp1R/F377pXjtxCJ2eQt3RhW5lKRlVdiuVB9cuhrbSHe/etE0ydCGji14x6k3ZuGl5kiOU70k6pkXyitybA+BRRiDGH2Zkan+mghialAQc4BLNqmrGzs7H167cX10ZhtcpDgQMikZPO/SUeq6wj2fzT95fPeTJ9+8sBhHo1CWDTiIM5I2xoIpz8/kCyW6wmheL7RLzgmLBE1zTSQML+w4mjWhTccHdI+8kbt0fdcXhTDH6IQJaLpuKO5aPaYr10ituH//wfT4aL7whU8ixxa7CFc7xPiq64wCyJg820vSSJYfYZecqFBPK1oOBZHG0BWAU8N07rt2e7T23oXLH1y5toVqCCCmQqnOy1KX/JIUvdQizy3kPyZqJR999NHrXDdTJEPmk0ohvmDnwQTShElVjdbWvXMGNN2ia1ta4u49f836og0EUQLljc9o5aluL7sUU7/iEkVGEiwXfKMsCwPzar7pztaDty9c+tHVqze3zmyRWwPGzBSNiI2xYDpmfTg9/J9fff43n31y6HjuXEtuQdSxiCtAkkL0lF0oqK/NeXVceo38IoPFJMTEbOAExKyR7GjetcRioK5pYtMSrKpHo8IXwgIl4kJcwSyA9+XW+nrhfdM0xyfHCYDjYKqEyjsfk5iyGedSqh9UzBYlxsbLkxAxSIxFhSwXRVjSMw2w2DajwldqMp9fHE3+6t33f3L95qYUm1SWQAUeORYDWjCIyp5p9/uVJgF/AFl7vRXLgKhmZmLquIfVC2SNRCNA69ouX6uGg/RlbKdzZqa0FIpYnoZX+sGamSCnNJA8o4LIUOV8Gs1HbqMltGsAwWvPYS8jdoejWzvn37989crW9iZcnawECQFK8NmPmZ537ceP7v7iwVdPUsM86BQdzIhJPMBkaSlp/hLXbJkor3d9COR8NLOQ2HkmUlNLIKKklByr8MLi3f29GGNStkuXLlW+iq13JcPlCaoJ0bCs5dIVTUlVH85OjhZtLRAmF1MZe3RwBc0AMFthIr83keAMnE2ds9t33xcydTAXw4jp3PaZn1y++rPrt3bcwLStCVAtiR2ADtAEL8CSTcX9p3j5/98Wr70VZgdvMtJkQoK8HxHWPM0UEvRsPaCzu8+ffPPiyTcLhaZcFLGBE7OBFJyFQNl6oU5kPMIA0siqBAGL8pLdzZYLalMQS4IzOIVXHcR0c+fsu2fO3Vjf2oSrolVRHYmZKVNr2NN4f3H8jw+//n8//fhxMz178er+cRsTxPuirAPQNJ0mK8XRsm4/xYLI/oQ+pzjXtq0qCrZSvGiKUckw8gPWBCFzcticdC+e+3pQDny9c/aM8wZKqUXSsqgHQAds+vLtnd2u69L9e83xQRTxVUGmohDLPs2WiBimlPn+WfkSAJ8+aSPN8y5LblweCRSLA+/SwcFoOPzR1Rs/u/7WWVdW0AGXDLQx5NrMQhDvwUiLIAO//DmZt/DPALivvRWCScR5EWaBLeFVAwJE4DwJoXbuzPmd0rm9w/1ZjBFM4pKiaTtjqQZDLso2hAQkUD4QmgFGEZjFoCwihTjHJLAMFkloQ2y7QjGQogyJFu1WUb+1fe4n5y+9t3vxrC8rxUDJKZBUKp4pjhkPFid/99Xn/+OLz55Z0MnouO1KGhRUMoslo2RCrmBxRmJLgVXqRxCt71K9BgJuQGSwiBfvQC7BGZXG3rhg7uZzDcGXpROZh/ZgOts/PhxUngrxvo6sRijJMdB17dC5cVXXwyERQtulrqMQLaXYRuc8Ox9NIcJeDNyEyM736NBLf4x40XWRLLElUhJiAVLQZr7m/IXJ5GfXbv67t96+6qsa5JtYioDgRDwzE9hLTiL2krKbxlJY9PRE+AduvddNLFrqWYBspWidMTljIRACDESOuCz9aDw+CGEWQ+iieM/OGWV792AixnmKJyNrkkE+KUsCNJiGhAgyEpAYJNnQ+bF4HxKm800pP7hy/X+5/f6Pdy+eca4ESkXJEEfkOTCmgk+fPPqHe199efD8mYZFIbHwyr5IXpTz/AUB3Is1LrcUUiO1HrMmyyqlrxOJyKhHv7ySTxAjp7BkKURmLquCvAtkkaBIXdsoaTEelDwQ4jwqWooPMQlzVZR1VY3q2pN089nJ4fFobR1OkloXU0gxqAZThbG4RKTL8ai+ZAWtba0bNGkSgWmM7aJE2hkOzxTV7XPnP7h46cJgXJn5Ng6JnWR3k75wOj0JcJ4uPBVBXtJb8YfYYX+aoNxyp+XloQQES4DzhCJZIp2wVJPt8WTjceoO7naz2R4zkS8zeydmOvcy7Zny1LbBrGDpuqBdsqSOzZOwJVOtwdwG0jgWd/7s+VsXLr179frVUb0FUJcEVHiGIQBzxX4Xn4T539/76uNH9489Gi+BOJH4njvbH5CIenpjP4ZI/YuxZaL9KQSD5ZmfjSXXgtovfgVJhMaY1AsKFzgepvDZs6ez0LVSvHvZX6BhrhtqoHBCgAAXJ2t1Ua7Vw7G4gS/vzmdzskQEJ+RIyUio8EUbAqxvnS09LwDo/PhoenLMjMF4rEiLxXRQVDvr1dtndj+8cPnt8fYQcF2omVkESclR/6b2azUbIVHeW/Dy+P0frz//RKVCXR4IVrllsJzmpbCmkMuTCej9y5ebmIoQ92ezpovsnPfO1Bwc8kAKVIxAKnkdXLSFgcHeOU/OAUhmZgWz9zKS8tLW9vtXb7x96cI6wEHFMzSVVWFAABrCgdq9+fHPv/7yN8+fvdBorg7MMQQzkIjBEivbcv5j+QryIdxOc4n/NI3/peCW9kcb64WZWYTFk4V51yKReGYnkTHVdP/4JN27ZyC5dOUCDx3UtBu2Y0dKAAAeUklEQVRymZ9bDWxXVX323NgXZ86ckXt3nodm3iw6sqC20MjkPJemHUBAyq4qSwzTBp6dEBENLMUQKqLzdX1lvPbTK9cv1eMJ4A2lc44Ihq5r2b0qrEf6rYXmP1tjvT6OhVe6mIS+wU09Pg4PKFFSZdMC+k65WdzkHe++uPP1w+d7EQriadd5y5sMAdlWRTPSnWLjRTyJkDmDELwU3ruN8WhnY3N3a+vMcHB2ON4ESoOF1vvaCklACxx1Ye7o/vToHx/d++U3D56mLg5q+DLF6NR5c4iamBKyuMUrSaO9gnL+G/MKWX4doQQCxIys30ATqTKAbFCQ4MWAGFuzZFGdEJMk549D0BcHnKg0Li5d2ZXKyBrtCnYMrgABKsduc7Osq51LFx4c7H3z7Omzw/0Xx0cni5BC9D5y2xplEQ2mpTAxmw4FA+IQgh0ejZzsbJ/54PK127sXr9frNcxFrYikhwzMBHluj1/Nm4xfGHoXz142549Ozv7p2qoZ58lbLBnICfozYyyECWxgAUrgbb+2deHKerAdV7VE5suj+dyVVY9yL2HunF7EyiCoIakYF4UbDcZ1XW5urJ3b2DgzmFRAhTSEDoikLmLqjCQBDWzO+uDo+B++/vLvfvfFfFBPGYnYklLigauqRLO2ibVFUVGlPJ6/pHosT+/5uLpqWfAKxf6XhTld8YU09ZMEHBmLGIRNPHNRWIgWo4YUITGZg1BKj/cPBqDS4M7vniuHSlnpSBWWlIx5JMzD0RnCmXO7h6PxwfR47+Rofzqddk0Ezeqh9eosRIBonlXUNkxdXRmZapwMhld2d2+dv3ix3lgDfEyFkjiGWQjBhKQsbTncT0vWJxGwnABGf/Mg7/LAy2OFr8Sfklj00v6agDz0zSCFQvNwA2XMaUhw2tVk68Vgc/fyteF6FDFfzEL0ZWW9mEEPfIrBSLnklFIKEUmZpa7Kqh4UhSdoCalgJTAClVCHBGIlNfYJaIC9dvHJg68/eXhvHyFKPY1qpqW50riIVEeKRo1Y66yvfhiiuhL5UwJMlwZdEGMj1X+umHjlyhic9sWNESeiyJqtCTvPRiqmBbNjJoCjElEyTyQm3Kb46PkLHzrXLeTCxZ3RyCESLIQYjJ0vPfE6Yb7ohp7Pj9a60WRxZmcawkm7mLUdOzFQljXgVWKRttZJIWBTi17cuCgn7Fwzq4uhzzdPsj59xQmYETmLvqwWcENvFGMr8uay4KI/KPv/eom1qqn60valL0WNZibI7W6GJiQAqXSuVE2gwWR9czAKRM57Bdqckn192P8QJWO2YFFTIkjhvEMvxm9gARUAAw4paBe6TmGpLFt0h137dDb91YOH/+PTX30Tuo2b17/e32uilsLee1aLTdcpi9BLBrG5BfkKCvpSXcX/Gj+SvuAlJOr7oIPBYN4suq5lEgaxGZiYfeWqEGI0TuKPF92dFy+8d1KUJm5SlmP2zpcVJI+xEzCqewLqLIQatF0OtBq2GpeVFbCcbmCDEpKlSMlMHbsCPV3HexRQJAMSUoT3hS87ICEJiFYOVnRKpKOsKfTyJfmjRRaZ/ctvyOVV+yM/DljC15nSrNDMh2EFVtPhDFgCMwSIhqhZTWW1FkZVVQXAzOzAjhDaRAznMpiPBA3oEuzF/EgGwyez+d/99rNf3L27l7Sr6jm7JL7fGtAP17PCSFvXC6wz8nnjdCl/ZVFfcgxfN71keT01Dznmz1/i/NCK2mUASFzRta2ABs5R7Gw2H5GcHQx+euvWzbM7lza2hqqVYuS9V22aZjioFblyQ4pqqkTE5JqurQcDBRZRQ4rknTAbUPyTHgyvnAHtlS8sGw+vykO8irW/9Pjyev2B9PpTEuv1QvsJE10+EzZiQ1zEfnlzDIfEvXOrAEDSbKIFJrBQPkACQDRMQ5c8SHyLeILmuJl+9eTxr+7cvbN/cEzcVfWC3CIquwogySPEABB7Ubg3rjH4esGgruuYeVjVDojzhqOOmIq2/fGNW39x69bltY0J8aiX2e1Lwdzv6pMjGVQ1BGMR7+AkazBFJKgN2H8nL/e7MUYwgisdEswMAjCyVXVIaSxCkKUIXH9TJSAmOIcEdOQjI4BepOnDvWdfPXx45+njRweHrS+7spyG1EK5qH/vN36fcuk0yCAMMrWkponEw0tKuoBx6e/uPUufx8dbmxfW1rdHo6H3FcuYS4aRkSdyABOCxRTiaDjoutiFWDlBpgTD8bcABX+2l/bnXbGQ+4LLcsAUakiCSGgBNRsS5TooAul0W0UTIQ4JmKkexfnz6cH9Z9/ce/7k84d3F8Soah6NT6IdzBYmfjje0Dbm6R2GLu1xzUgV8v1ZschQOdc0TUrJOSfikJQJJbtuOrXFrAR219evnTt7Zff8pZ2dc9VmackbeeYSyDLD0SyFMCkKAjSac32XpS+4vrOX9uYTC8ti9uXEWmmdR0NrGsg0s6pzx235JwC6nAA+OmkOZieHi+Nvjl/cf/547+RoinhMGpwkdoEkKCcSJ1XhCu1C1lvrq2fSbGBmf+gY810EmTmYpaQAkaTMHBEpy5JVSVMJePz/7X35c1zHkeaXmVXv6G40ThKEAPAAKVIHddiUPYrxbuz/vP/E7MbGhmdjZzzW2BpZlnVQJEgQR/d7r6oy54d63WiIpMJ0DAlAcv6AAAJAv+7X2VlVmd9h2kxZ08bK8vW1qw9uvDOWcjCsau/9TIUwYy/LTA5NWhAXDBi6pivr83ESec1L4eKBa/E8RsgqCAYkxUnTHDaTSeyCgZ1PxJGpA0VDZ9YlKOzZs6PHB08PTp5NYrc/efbw4PHEIo/qUBRalVF52gVV804ACm1bmBPL3fy8d7Z0YQrVYnRN4xw7X5KwRkuaEjTFbjptmaxyrnJiTrSNx8dHh0EnE10tBkuj0WBQVb4onau9qx2VipLIdYHadlSUV1fWBl4yh/Fc4g3tseaMM511dXvqOABGE8P3T/e/fvTw8fGxLI0DSxLpiDpYm7SLiKb7+08nzbTTxKVEpjRagsbO8VFMXkWKwpOPMdfAhAgRiJ1eN/X+gODXqbT4N4T1qPWsdiZMkj9OG9e2JtPjdtqEmISFiuK4afcPHh0/C7X4qijqsqhLXzqpnNTAej1wXahUN6rBztr6aowozrM2n9PmHWjbyCLO5b2PNW27v7//xePv2+FgKi6JtIzOuE3axJTMyrKMZAmmMfi6knrsLLWhrQvfhNg2jXNF7UsGUaew6PrexilpK5GdwSpdjCirKqYuhkaJyXl2nuHU9NGTfSISEjgBsStKXw/dMk5OwiRFTIO0J5VzpUBSKmIsk9Ypbi+vrd3aG64uc+knXaCkdf1D3t+biXOzy0spFaXLbZWlpaXt7e2Trnmk3Z+fPv4+dlzXrq6Pk0KcGw5CSJ0wMbM5JURD6oIRwJ4i16jgYEQUEiuLwZHL+CqjrEe/4MxLF8h40ggBCmGRXl1GzQwmIHEl+qaXkkKTIp9phIq6tpS0ayPitEvcdQNYiOnKlY3rN25t7myXo4ERG9nZhuYbjfNJLAKyhnN+i53IyvLy9vb2SeX+9FlHJ4cdmQoScSDzDlyUXVDW06alUj4sskvMdqr5yqaiPMdXzfk/M9mFC5NTszg9olovmt9jLhbUmeYwmMRQz1r72GjXRF8WS6OBHh81Tw9u7d7Yuba5vb21srziwMmiYyqL8iWjvNcebyix5rdvPjavC0FuKER1jkfk3rqyaUvDxwXT119+vb/fMYQpkgRNmlTIGeeRz/xRmQ1eQdktd37/SG1Gg1u8NHDBeqPouzB9wtOp2g9Zj5FmAFCZDZoSwKVEdIpQlq4QtratiMYbG/fv3NlZWd1aWRtDPEC9FuCLQS9vIF5zYi3UiMWiPHebJstcQ2Khkty4Gvzq9n0eVKS//+bZAQk77xvFSdf4coA86Z49gtKMPg3k8ZHNgLOzyfyp2IFopt3ohbVxmz8xsuz+2gN7aIGDAgKzm0yPfbRRUbq2aw8Ot9aufnr//Xd2dsckA8ABHhCIWtfFVPsf9orfTLyJinWGHX82BChI0gxOVhNtwd2/+lY8OKJp933TdKSOhcix6nyZADDnOeRHjoxEOq9bbEgZ2kEAIMqgvp1I57fteD7IeoQTjBeo8z1QRzNbEJZI52Tx1IUKxprsJBQR66PxB9s7H+3e3HBVhVQZlT3bS8l+nPn3euNN77FoXq7yaJDhPTlCACqA4CfQWzLG9k1tOvnu4beTo05RF4Ulm0OHM1EsP1wigJBYY2/MZHm873L+KPOsGLBCMwLvNZocvXIssooXcBZ5ETcAqe/u9nIEadKsjZcRp3Y42Vy78um9997fur5mMjYbkniCAJqCaiy8o8I/R2l7Q3FOm/f5FNB67LkwDKgBSQQBRquyd3dptPLb//jDF4/3I7F5ymLuhmx/1b8JGUwXGJGRGEqZmw9kO3XTjFMQA5SNNFwwb+9FlMGMDTc7bWStfKhxVDIDxNQh+dCVQhtXNh7cufeL229vceXbbqRzPSHllPmp57W/At5wYp0py/nKCTBEs2iqTMxcpdSFVJO9vXxldXk9tNOjo6MJ0Mz0txLznH007yBkcIsRZpTg00+/knK+x5RdAi9QuQJgFGduVqwzjHzWxFpwAOmBYl51yI6fHS1Xow/v7T24c2+DKm+6WhbOgC5a1xIDhYcITLs2FuVPdY/Fi6x5AHP+/+n1HZGD9AdjZm8gWIBdAX96954j+ufP//j14cE0JVkas69OJpNAVlZ1VPXCgIoyGBwB0Fzab+5/mVgTh0QwYlG+OGdDI1UJ/WplAnO9vAWxuCKFhoxK72GIzZRgY5Hy2eT2+uZH9957/+beFaqdKWLqhIVAXshV/UJPBiJfnpsd7purWD98M597c/uRT4jEVolka4b1orq7tVUUxT9//scvnzyZtB17PyyLBgCRaeaNQSmrDhEAUc65xVAgG1Ro3oQBKnpu47MXBGnG1IsyKSjLMxsnYohjK7quSZOmFhoXtaTgjqbvbd24tXpld7y64uoh4Ii94ywz1GNMgdmwAXjBbX5DcW6d95dFMhUR7p3KrIbfXbu2srZpzPr55188ftRNW1cWlUgkMiIxnVMiFADmInd9pnLm0up5NnVeGr0kn/OJXWLR7AuEjmFAG0NCrCvnVNF2Q2B9NP7g9ttvjdc219eGIM7NhR9z7ju32nzREoul8DNxZ9WUQDwQ54D3dve6iK5NXx086UKguipKz0RkRr3XVw/5X3w06rtZnMkaetESCwwIKbnERXRFEgUHQSK0XThpTsrKLy8vucPjePh0fXXt12+/t7e5vTYcLkGQEUl5HxYXSA3ERnruY4aLllj9FozAPrvHKFpTON4s6vvbN2IbU0rfnRx1MUVTArF3oKw1kve5nMchRBDrSxSbmrEpM1245jvMkUESF4l86jVZHWHKoSqcF4nNtE66vbr+8fW9BzfvrFTDIcgBauBk4qjXz3jByneer/TCJZZllpEZE9UsJaNUtAZW7IxG8fotIvqPxw+/Pnqyf3wczMSN8j8qgazvR4Bg1itTzpgSCgK9blTjq4YRkPsfnHEzwEwQRnV1NEqxCU+frQ1XfvPeu7/a3lvzZQ3Km0QisFDG+mXVnxmjoKex9BuDl6orvN64WIllgIJjimLJictLV2UoDALUQFoeO7c3Xh3T5581x8fMgCqIjcGW++9AtmticLZ6AXpfeOiMdHmhgg2IzCx9YiVWAB5WdLFQrC2t/HL31i9u3tlGKWZF5mUZHEHorBbo2Yd9gy/hBXGxEmsemfwFA6LBiD1GDi0wJrjRSDw//Par74nqqjxOaqIpi35DZ35/MIIaieXZj+bcApTPb8rxomCAE6MzTgRHM+I/xTJaPDpYHg0+2bv7q727GygFqIkApE5h8CWTIUXEmESETlF9md9/zu261495f5Ww2aTHndG8BQhISAWmgikwBb637re//9f/8/t/e9yFExHU1VT1oOtkMGBfHBwcjEfjnjwIAKfar15ftw/8K4SByRdNiABK52EpTqfOdCxFneLOaOmD3Rsf37y1Ww0LTbXZQJzNFADwPDcQudFgc7AuADmnIn3RTkl92A9+MMAgQGFggwdWyb+zvf2bDz/aXFpOR8fN04NRUYyHg66ZdF2zdmUjW5ImgpJq9lTml87CzzGyyVQTmscnT47ChCoWQXdyeK0e3NvYfH9jc8tVS8ASiyfE0Mmsk/KSrMLinp3/3sd6QdACpR/I7emz+ltX18ar06htCH852E+TY3HOaTJNpAkzH8OzN/9izXMA9Y7bqOKsKCpHTLEbOd5cW3lva+cXOzfura0PFRK08qzsmnZSSrEgp3fmsRYwg/3x+Pm/eWNxQSuWzg53fW4xzAwEMpRCpalHqpDGkI9u7P3j/Q/3Nja7/aft04O1wWBclodPn2QBuoyYy+bQM1+ZCxQEdM3J9PgZp7A2qGrE9PTpGPTLvdsf37x1e219BSiCUgj5qOi9nJaphUnijwCTzisuXMWa9/V6WYrZz1RwzrNF/S2veq0ayvZumE6aycnD0DCs0VSaOp0Xpx4oN+smXqh3wCyGIVNh5o9O6ph2RssPdm98cuP29WI0BgQwaDEz8ebMBaGeqtl/95zt9o97RryZuHCb93RWnGMmkNdvQbP+FgkTyGAt0EKOgK+ODz97+M3vHn77b99+9ahp3GgI52f2IKcv0C5Yg5TMBN2oKLgLenSyu7z66Xvvf7y7t8HVEuCTFklL1++/k4aUkvc9OsYILytTZ0zCzmlNunAVCwskRABzlikDagqNWRA4w45r6m3xtkZjX1c8HDw5Pjw4OXFmpkoLNzXjatReVav29QZDLXSWYhVtbTD8xbXdB9du7HJlMZQiQkqOEiXJpgvUOyKdvoRePHxht76YUufFowBw0RKL5mB2AD/Q30rRzLIDOgCoIcHQMYrSowpxBLuxvPL+9k7Xtk/aaTRE5h4bSFDLeqcQxSLOyeZ73H4kMgOpzj71r1jhbCZ7xKfXQNbvB2awqv76BjEtlXB4tDwcP9i79w+3722WQw8UzotlTQ9tu65VLX0hIsz8IwvMD+H85/oRulhLYY4feUIL92o2uOgSF74DniG0cE/Q/d8//uGffvcvhxqfTBsejpL3B5NjKStfVc8ODsbVgA2JOPUQTZ6JKwEAmRqpcpYPAQCvzH/1pt8oJemMjExgnB2+YKzE4nzXtQQtvbDGrpkK4iq7jUBXXfHOzb0H77y/U9QMSIhD7xzmwhPAzNMLAGV1nhfdq4tUiy9Yxcrx192gXks3dm0h5sUNQB4kKN956y0m+l//+i+H7VGnxxjUiClwKOp6aWmJu9i3D3NWkWovkHzadWTTTM3IVeaVnvyMJkrSqy0iEQNE7MhrF9puOhkKj6pSIuF4cm3pyt2r1+5tXx8XZQIoaSHZJrcXQc1PFYDBnh9JXahkWoyLmFivFEVVQgiAg0QogzcGy35vdNI0nf7hm6PDFJI3ilFj2xLRTHxmfrzqnQQyk4xhsKz6luXy+SWTuJeHCYGKHl9FWdk2MIy0SV1CHJTOqXHTDomuDMd3dnbf3b25u7pRAmbqhQucJ7vmvyoue2IxHIAZtzMl1Vg6WaXiwd33QyL505/2u4aYO2FNqYsBPh/RZ7mVVXAIIGKzrKTFfWJl7yN9qYDrC58PmI1FuYjilBXMTOYw7UI7mfpaVsfL7ug4HB1dWd749M677+7sXhstDwADSuISICA0wVUZVayLcNBLFJc9sZBSMjMiYkbFjoFAZAD76oOdm579Hx5+8/XhwbGlkBR5F5VNn2ZycMDcN+vUgbQ3rfgb6oY5GDiRUy4yUAFICsRYFq5k0uakDGFnef3B7t4nN29fqQa56VkCBfoNlBC/CF91meLSJ5bCDMZmAi5BhSBLc1cRt9fWRqNxWZbh83+fPv0+mLmSDawzmRCdi89m/4geC3UabFB7pT1WvxsCWMGwzGo0MjjVjWGtsY1Pnq0Px//93fd+vXN7zZfVjHxb5uIZlEBlKZgdqua1aj6OvxTJdrkTywCWAgCbZaAuAQ5wAUPBECgLF7d3pt20C9OHh88iqOlHRf2/Z65VbjNkHRrNLTMooH8LlDnr4TCEuXFgQ2IwtLRUdOxVN0YrD67f+OTm7etcUjISykrXkp+EmjC/ZOW7FBnVx+VOLAAxRRFRVW2TM6FCYKjUhKlNcIK3BoNw/UY7PaIUTxw9il1kZstyD6xgQJjy2Q0zg515/wGvZCuXLVoNHLMafepVPQixTJb2n6wOB5/cu/UPe3c2uHSGgokABSyB1BwTFwIFNJ1xHTy9AF/Y8e4P4tInFolTwJH4/JZkOUohH+E8slLSztKK/+Dj8XD42y8+PyFV4xhS1NSJkvNgVkDbWDkvrmRQTF1KIcEE5OTFEE1mjjHGGAGIiHMO+TRHZMzHYYKkdVV5M51OfQhXy8HW1a0Pd3Z+uXfnRjmoAY4RIHbC+WjK2WUkY2Jy9szHnZcjmRbj0idWjh/itwCNkdUVggAMgavlIL71lvP+f/7T/0bhhlU1Who0oKO2bbso3tfDJailGKKZGREXnHGYZi8E2zRNIyLe+zwYVlUzU5ipScl1XSoMZLELdSFXhvWVJO9sbH60tXu9GAwADlFMmeat9OdJNfr8dPkc8VWvGj+JxMpsMVq0uQMLZWygKArGGrhavjoer7RU/O6rv3z+7TcnkwOtK0fkxLui6tpoSQF4YS4cGF2KGtLLrqmqIiIiRBRjVFUiEmKzxKmDQLxjWBcm2gT21Yd3P/jw2s7dldURYF1kGDs2M5DibCP07Ms6jctVtS5/YuX6lGkFp6M5wAk4712CAzE7AhLJr2+/XbuyUPv28OAQOIG2sYtHgUksz3nBSClpspSSBsiLVUSKosgp1ZtkE4lI4eTk2YHBVKgoXOF4CN7d2Li/ufObd96/Sq6KZjEKmRQCsmQLZ77ZgfKcCYH/RXHpE2sRv5VZOP2WiDMJzBxMsvK3Rd91K1J+/NbWeun//5df/vt33yIEJy4yjFSZzTR0XZdiYiVmLy9deUQkpZRSAsDMuXRpTOPCexiSSpvKLm5Ug0+2b/23d+5vwXszm05FWJxLFoGseH/GzHWuwbNYoc5s8i7JWnjpE2se2Ss8j5RpJo9MZEWPZzJPDJIR8xq7euNKaCaAjqfHjyeTxyfHh83EVXVZVWUpwdBpSFCQ0BwgeDZyrcqFKu/cY4zaNUOYD8GpXhsv39rc2h2v3lhZXzVUBOta51gKB6BrgxKqosLZlMJPolzhYqIb/vrI9DDYWcRb/l4TEUlvnoheeQrcNp2VxYT5GeL3Gv/05NH/++KLz/785TRFFI68g5cIi9CQUjKoFS9MrBACEfEszCyl5GIYTifrXq6Nlu9fv/lg7+5OPa4Ap9FCJyLOMYEiNKQAQIg9n5kXLeCrGHPbkn5GngcEl6NkXe7EApD0dPCy0PuExiAijgCzFCNSdFLAEYwVemypET4CHoXpw6Pjp930Lw+/f3Jy+N3T/YOj46lG8k5KT75oIyU67R7NMU/Zz40MqtFiIiLv/Yj0/sbGu1e3bm5c3RqN111dZ9cug2pgoWRoQkPChRQENF1TF2d02Gfnz9Oswt8T67zilfBbSYMhu9hxB47gCOqA3/75s8O23T969vDw2ZPjo+Nm2qTQAscGdSLss8GnxZSSWdJSmAAPVIUb1fV4OFoaDdZY/sf1W1ddPSyLkl3lfEFEQNd1RVFkopGdbV78IE1mr4Wf/9Xlip9CYr1KaNKQMQzZrVmBBBeBBjhBPGgmj44Ovtnf/+7Jk8cHB4fNpGHqAEswg5kRxDEzSNtQe7c8HK6ujLfW1zevrG+srm5QsXxyssreOTdfKAGEELw/Nw20c4mfY2LlQ72hh48myomlCZKAFpggHrWTo2nTdF0bQhdT17QhJBg754uiKJ23pKVI7V1dFUtVMazKit0QGAHztS3v7gGoKl84s5XXGz+7xDKNfWJRL/ip4ETcW9jNvs4Ir3BAArqgbUhm5JwrSxRAMjBQUG/slnnJlNLQSd6Nm+UWfs+A+LnFT6fd8KrBM11+BoRQMhLQARJSBKkQM2UxfkRE48RsBgY4gBkpwQkcwxM4M4sUar02h85MrXM/4vxe5bnFz69iIQE28wHn2TgFSNZDtRhgUK+0DE4zgcHsg2dQwAzMEALRTEMhWYqdavSDYUxxce3LvdNzer3nFj+vimW9BBdxzgld+AUxzda1njiriAr2yBiJbNup1HcBQkQCCJCcYWzsmVH0CmizQpWH039PrJ9+6OKBf9Y6BWZJh9lXzQrGCidZHzBmkXhGxuGJ6/825d0UQm5xOZZcq3IyEf3c1oQ+/hNkVFd4+88nHwAAAABJRU5ErkJggg=="
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/SecurityIcon.tsx

var SecurityIcon = function(param) {
    var color = param.color, secondColor = param.secondColor, width = param.width, height = param.height, alt = param.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.667 16H13.3337C11.8603 16 10.667 14.8067 10.667 13.3333V10.6667C10.667 9.19333 11.8603 8 13.3337 8H18.667C20.1403 8 21.3337 9.19333 21.3337 10.6667V13.3333C21.3337 14.8067 20.1403 16 18.667 16Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.6663 28H9.33301C7.12367 28 5.33301 26.2093 5.33301 24V24C5.33301 21.7907 7.12367 20 9.33301 20H22.6663C24.8757 20 26.6663 21.7907 26.6663 24V24C26.6663 26.2093 24.8757 28 22.6663 28Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.99967 23.9871C9.99567 23.9871 9.99301 23.9898 9.99301 23.9938C9.99301 23.9978 9.99567 24.0005 9.99967 24.0005C10.0037 24.0005 10.0063 23.9978 10.0063 23.9938C10.0063 23.9898 10.0037 23.9871 9.99967 23.9871",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.9997 23.9998C13.9957 23.9998 13.993 24.0025 13.993 24.0065C13.993 24.0105 13.9957 24.0132 13.9997 24.0132C14.0037 24.0132 14.0063 24.0105 14.0063 24.0065C14.0063 24.0025 14.0037 23.9998 13.9997 23.9998",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.9938 23.993C17.9898 23.993 17.9871 23.9957 17.9871 23.9997C17.9871 24.0037 17.9898 24.0063 17.9938 24.0063C17.9978 24.0063 18.0005 24.0037 18.0005 23.9997C18.0005 23.9957 17.9978 23.993 17.9938 23.993",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.9938 23.993C21.9898 23.993 21.9871 23.9957 21.9871 23.9997C21.9871 24.0037 21.9898 24.0063 21.9938 24.0063C21.9978 24.0063 22.0005 24.0037 22.0005 23.9997C22.0005 23.9957 21.9978 23.993 21.9938 23.993",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.6663 8.00033V5.16699C18.6663 3.78566 17.473 2.66699 15.9997 2.66699C14.5263 2.66699 13.333 3.78566 13.333 5.16699V8.00033",
                stroke: secondColor,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/Smartphone.tsx

var Smartphone = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "Smartphone" : _alt, _color = param.color, color = _color === void 0 ? "#53565A" : _color, height = param.height, width = param.width, strokeWidth = param.strokeWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.498 2.99622V4.79697C9.47304 5.10001 9.69563 5.36713 9.99821 5.39722H13.9999C14.3025 5.36713 14.5251 5.10001 14.5001 4.79697V2.99622",
                stroke: color,
                strokeWidth: strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.99805 18.0025H13.9997",
                stroke: color,
                strokeWidth: strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.0003 21.0037H7.99693C6.8919 21.0037 5.99609 20.1079 5.99609 19.0029V4.99705C5.99609 3.89202 6.8919 2.99622 7.99693 2.99622H16.0003C17.1053 2.99622 18.0011 3.89202 18.0011 4.99705V19.0029C18.0011 20.1079 17.1053 21.0037 16.0003 21.0037Z",
                stroke: color,
                strokeWidth: strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TrackingStatusDeliveryManArrivedStore.tsx


var TrackingStatusDeliveryManArrivedStore = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Entregador chegou \xe0 Loja" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 36 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27 14V11.2004C27 10.0926 26.3894 9.07485 25.4119 8.55344L19.4119 5.35302C18.5295 4.88233 17.4705 4.88233 16.5881 5.35302L10.5881 8.55344C9.61057 9.07485 8.99999 10.0926 9 11.2004V14",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.6254 20.2016H13.0742C12.7011 18.8216 10.7861 18.2943 9.69569 19.4693C9.43281 19.7526 9.17509 20.279 9.17509 20.8142C9.17509 21.0523 9.26957 21.4112 9.34713 21.5938C9.62512 22.248 10.3285 22.7896 11.0004 22.7896C11.0453 22.7896 11.0879 22.7899 11.1285 22.7902C11.4533 22.7925 11.6592 22.794 11.979 22.6332C12.4925 22.375 12.9178 22.002 13.0742 21.4268H10.6254H10.5754V21.3768V20.2516V20.2016H10.6254ZM7.94984 20.7272L7.94989 20.7256C7.98791 19.4912 8.72645 18.336 9.7853 17.8848C10.8891 17.4144 11.9504 17.4567 12.9759 18.1108C13.0535 18.1603 13.1178 18.2117 13.1807 18.2644C13.1963 18.2775 13.2118 18.2906 13.2272 18.3037C13.2747 18.3439 13.3229 18.3847 13.3782 18.4273L13.3477 18.4669L13.3782 18.4273C13.5804 18.5829 13.7853 18.8483 13.9538 19.137C14.1227 19.4263 14.2582 19.7443 14.3188 20.0089C14.3245 20.0342 14.3294 20.0584 14.3336 20.0792C14.3359 20.0907 14.3381 20.1013 14.34 20.1103C14.3459 20.138 14.3509 20.1555 14.3569 20.1678C14.3621 20.1785 14.3676 20.1844 14.3758 20.1893C14.3854 20.195 14.4015 20.2007 14.4309 20.2049C14.4907 20.2134 14.5861 20.2129 14.747 20.2099C14.7691 20.2095 14.7924 20.209 14.8169 20.2085C14.9584 20.2057 15.1405 20.2021 15.3753 20.2016C15.3636 19.9079 15.2515 19.5345 15.0932 19.1723C14.9262 18.79 14.7106 18.4268 14.5166 18.1914C14.164 17.7636 13.9399 17.5586 13.4857 17.255C12.7824 16.7851 12.1071 16.6275 11.1838 16.5507L11.138 16.5469V16.5008V15.3756V15.3256H11.188H17.0766C17.0948 15.3256 17.1051 15.322 17.1119 15.3178C17.1192 15.3134 17.127 15.3058 17.1361 15.2909C17.1455 15.2756 17.1547 15.2555 17.166 15.2284C17.169 15.2211 17.1722 15.2134 17.1756 15.2052C17.1843 15.1839 17.1942 15.1599 17.2055 15.1344C17.2702 14.989 17.3867 14.7875 17.6945 14.558C17.985 14.3414 18.3032 14.1968 18.8018 14.1999C19.4442 14.204 20.0872 14.2028 20.7303 14.2016C21.0137 14.201 21.297 14.2005 21.5804 14.2004C21.5683 14.1649 21.5542 14.1203 21.5391 14.0707C21.5093 13.9735 21.4742 13.8521 21.4403 13.7301C21.4064 13.608 21.3736 13.485 21.3485 13.3843C21.3316 13.3159 21.3175 13.2556 21.3095 13.2127L19.7773 13.2128C19.7773 13.2128 19.7772 13.2128 19.7772 13.2128C19.7088 13.2133 19.6505 13.2165 19.6 13.2193L19.597 13.2195C19.5486 13.2222 19.5052 13.2246 19.4687 13.223C19.4316 13.2214 19.3948 13.2155 19.3633 13.1965C19.33 13.1764 19.3087 13.1458 19.2953 13.1073C19.2823 13.0703 19.2757 13.0238 19.2722 12.9674C19.2686 12.9105 19.268 12.8399 19.2688 12.7534C19.2693 12.6954 19.2704 12.6301 19.2716 12.5562C19.274 12.4082 19.2771 12.226 19.2771 12V11.95H19.3271H22.2151H22.2533L22.2634 11.9868L23.6059 16.908L23.6059 16.908C23.6206 16.9619 23.6382 17.0343 23.6571 17.1121C23.6703 17.1667 23.6842 17.224 23.6982 17.2794C23.7284 17.3988 23.7588 17.5086 23.7857 17.5761C24.7312 17.5805 25.5613 17.7742 26.2175 18.4243L26.1823 18.4599L26.2175 18.4243C26.2253 18.4321 26.233 18.4397 26.2406 18.4472C26.3789 18.5841 26.47 18.6744 26.5959 18.8442C26.9969 19.3851 27.2171 20.0108 27.2535 20.6397L27.2536 20.6397V20.6426V21.0081H27.2537L27.2535 21.011C27.2145 21.6911 26.9588 22.3561 26.4828 22.9016L26.4829 22.9017L26.4804 22.9041L26.0859 23.2972L26.0859 23.2973L26.0839 23.2991C25.8466 23.5111 25.6569 23.6182 25.3632 23.7604C24.7078 24.0776 23.9842 24.1177 23.27 23.9607C22.6774 23.8305 22.1624 23.5145 21.7578 23.1093C20.6204 21.9704 20.4665 20.3826 21.3024 19.0545L21.3447 19.0811L21.3024 19.0545C21.3733 18.9418 21.476 18.8023 21.569 18.7064C21.6233 18.6503 21.6647 18.6056 21.7006 18.5667C21.8 18.4592 21.8578 18.3967 22.0351 18.2617C22.0577 18.2445 22.0817 18.2255 22.1069 18.2056C22.1631 18.1612 22.2252 18.1121 22.2906 18.0677C22.3756 18.0099 22.4705 17.9568 22.5755 17.9257C22.5672 17.8309 22.5376 17.7026 22.5017 17.5694C22.4813 17.4939 22.4593 17.4183 22.4386 17.348C22.4362 17.3396 22.4338 17.3314 22.4314 17.3232C22.4136 17.2626 22.3971 17.2064 22.3842 17.1594C22.3623 17.079 22.3379 16.9938 22.3128 16.9062C22.271 16.7602 22.2273 16.6076 22.1901 16.4598C22.1802 16.4733 22.1702 16.4879 22.1597 16.5046C22.1336 16.5463 22.1203 16.5738 22.1016 16.6124C22.0964 16.6231 22.0908 16.6346 22.0844 16.6475L22.0845 16.6475L22.0838 16.6488L21.7462 17.2864L21.7462 17.2864L21.7457 17.2874C21.721 17.3315 21.7007 17.3662 21.6819 17.3983C21.6464 17.4589 21.6163 17.5103 21.5726 17.5985L21.5727 17.5986L21.5717 17.6003L20.1966 20.1246C20.1466 20.2262 20.0486 20.3991 19.9429 20.5856C19.9036 20.655 19.8633 20.7262 19.8239 20.7963C19.7508 20.9267 19.6808 21.0538 19.6265 21.1598C19.5711 21.2679 19.5351 21.3483 19.5258 21.3881L19.5168 21.4268H19.4771H14.3501C14.3364 21.7645 14.187 22.1072 13.9923 22.415C13.7875 22.7388 13.5294 23.029 13.315 23.2415C12.7956 23.7562 12.0351 24.0245 11.2676 24.0428C10.5001 24.061 9.71921 23.8293 9.15862 23.3356C8.76121 22.9856 8.5384 22.7552 8.27977 22.2372C8.06885 21.8148 7.96453 21.3711 7.94989 20.9334L7.94987 20.9334V20.9317L7.94984 20.7272ZM24.6268 20.6528L24.6359 20.6919L24.5997 20.7092C24.5851 20.7162 24.5578 20.7257 24.5248 20.7363C24.4904 20.7473 24.4464 20.7606 24.3961 20.7753C24.2952 20.8048 24.168 20.8402 24.04 20.8745C23.912 20.9088 23.7828 20.9422 23.6781 20.9677C23.5756 20.9926 23.4914 21.0112 23.457 21.014L23.4041 21.0184L23.4029 20.9653C23.4024 20.9411 23.3956 20.8974 23.3824 20.8356C23.3695 20.7748 23.3512 20.7 23.3291 20.6153C23.285 20.4459 23.2264 20.2391 23.1671 20.0308C23.1623 20.0138 23.1574 19.9967 23.1526 19.9797C23.0982 19.7888 23.0442 19.5992 23.0016 19.4398C22.9696 19.3201 22.9432 19.2148 22.9281 19.138C22.4614 19.4746 22.0401 20.0416 22.0401 20.6266C22.0401 20.6569 22.04 20.6859 22.04 20.7138C22.0396 20.8997 22.0393 21.0348 22.0582 21.1681C22.0796 21.3194 22.1261 21.4696 22.2292 21.6865C22.3398 21.9195 22.4313 22.0288 22.6161 22.2135C22.793 22.3904 22.8812 22.4697 23.1189 22.5886C23.7677 22.9133 24.6458 22.8565 25.2115 22.4141C25.2501 22.3839 25.2812 22.3598 25.3066 22.3401C25.3744 22.2876 25.4014 22.2666 25.423 22.2449C25.4369 22.2309 25.4485 22.2165 25.4692 22.1899C25.4721 22.1862 25.4751 22.1823 25.4783 22.1782C25.4979 22.1528 25.5244 22.1186 25.5639 22.0699C26.3114 21.1474 26.056 19.8651 25.3357 19.3159L25.3357 19.3159C25.2884 19.2799 25.2686 19.2616 25.2418 19.237C25.2284 19.2247 25.2132 19.2108 25.1921 19.1922C25.0738 19.0887 24.8839 18.9984 24.6726 18.9298C24.4875 18.8698 24.2901 18.8278 24.1178 18.808C24.1884 19.0999 24.2757 19.396 24.3635 19.6936L24.3637 19.6942C24.4581 20.0142 24.5529 20.3358 24.6268 20.6528ZM21.3066 15.4253C21.2352 15.4249 21.1415 15.424 21.0319 15.4231C20.9688 15.4225 20.9004 15.4219 20.8281 15.4213C20.5723 15.4191 20.266 15.417 19.963 15.4171C19.66 15.4173 19.3606 15.4198 19.1187 15.4268C18.9977 15.4303 18.8915 15.4349 18.8065 15.4409C18.7204 15.447 18.6595 15.4543 18.6272 15.4624C18.5084 15.4918 18.4288 15.5401 18.3744 15.6002C18.3196 15.6606 18.2868 15.7368 18.2679 15.828C18.2489 15.9196 18.2446 16.0239 18.2453 16.1384C18.2457 16.1904 18.247 16.2437 18.2484 16.2986L18.2489 16.3152C18.2504 16.3757 18.2519 16.438 18.2519 16.5008V16.5508H18.2019H14.6493L15.2838 17.1675L15.2838 17.1675L15.2849 17.1686C15.6165 17.512 15.9492 18.0482 16.2016 18.6133C16.4451 19.1588 16.6165 19.7372 16.6374 20.2016C17.1413 20.202 17.525 20.2085 17.819 20.2135C17.8973 20.2148 17.9693 20.2161 18.0354 20.217C18.3603 20.2218 18.5398 20.2202 18.6499 20.1975C18.7033 20.1866 18.7364 20.1713 18.7607 20.1521C18.7853 20.1328 18.8048 20.1064 18.8264 20.0661C18.8408 20.0391 18.8547 20.0088 18.8714 19.9725C18.8805 19.9527 18.8904 19.9312 18.9017 19.9074C18.9328 19.8417 18.9722 19.7637 19.0283 19.6714L21.3066 15.4253Z",
                fill: color,
                stroke: color,
                strokeWidth: "0.1"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TrackingStatusDeliveryManAtPlace.tsx


var TrackingStatusDeliveryManAtPlace = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Entregador no local de entrega" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 36 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M33.2801 11.5884C33.7503 13.015 33.993 14.5026 34 16C34 24.2843 27.0604 31 18.5 31C9.93959 31 3 24.2843 3 16C3 7.71573 9.93959 1 18.5 1C20.0473 1.00676 21.5845 1.24168 23.0587 1.69666",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.2801 11.5884C33.7503 13.015 33.993 14.5026 34 16C34 24.2843 27.0604 31 18.5 31C9.93959 31 3 24.2843 3 16C3 7.71573 9.93959 1 18.5 1C20.0473 1.00676 21.5845 1.24168 23.0587 1.69666",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.7002 5.36442L28.5018 7.11442L31.5002 4.19775",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.8527 15.7321C15.2895 15.7321 15.666 14.4757 16.269 13.9C16.3535 13.8193 16.2779 13.8897 16.3642 13.8205C16.9677 13.337 17.2963 13.2576 18.0849 13.1678C18.6738 13.1007 19.3886 13.3943 19.8544 13.7342C20.6785 14.3358 21.0192 15.7321 20.4541 15.7321C20.0344 15.7321 20.4206 15.0477 19.7137 14.3012C19.6331 14.2161 19.5231 14.1464 19.4183 14.0722C19.2898 13.9814 19.2026 13.937 19.054 13.8671C18.2336 13.4809 17.1301 13.7349 16.5931 14.3012C15.8933 15.0392 16.3093 15.7321 15.8527 15.7321ZM17.0031 11.1725C17.0031 9.55681 19.3038 9.5454 19.3038 11.1725C19.3038 11.4441 19.1215 11.7323 18.9692 11.8795C18.2451 12.5794 17.0031 12.0746 17.0031 11.1725ZM16.2067 9.66694C16.2067 10.0053 15.5283 10.3777 15.8527 11.7317C14.1604 11.8686 14.4507 13.4931 14.4387 14.4433C14.4352 14.7158 14.3791 15.1032 14.3361 15.376C14.156 16.5189 13.7733 16.9147 13.7733 18.1409C13.7733 19.3351 14.4891 20.616 15.3403 21.263C16.3138 22.0031 16.0297 21.6143 16.0297 21.367C16.0297 20.1124 15.9372 18.94 17.3872 18.3423C18.3323 17.9528 19.5159 18.3647 20.0421 19.3157C20.3639 19.8973 20.2771 20.8385 20.2771 21.7111C21.7162 20.9708 22.5336 19.5416 22.5336 17.8828C22.5336 16.6806 21.8599 16.0437 21.8693 14.4422C21.8731 13.7991 21.943 13.0148 21.7237 12.562C21.4977 12.0955 21.0849 11.7827 20.4541 11.7317C20.6827 10.7777 20.457 10.447 20.0559 9.70995L20.7008 8.74537C20.9182 8.45172 20.8754 8.37165 21.3371 8.37467C21.8562 8.37807 23.2857 8.57872 23.2857 7.68825C23.2857 7.29949 22.9777 7 22.5778 7H20.4099C20.1453 7 19.9043 7.43226 19.702 7.73126C19.6035 7.8768 19.2032 8.50553 19.0383 8.50553C16.7231 8.50553 17.2897 8.70522 16.5539 7.73778C16.4479 7.59833 16.3633 7.47732 16.2575 7.33779C15.942 6.9221 15.9237 7.05693 15.0978 7.04373C14.9787 7.04182 14.8368 7.02936 14.7975 7.02991C14.1104 7.03966 13.4333 6.94997 13.1641 7.26812C12.9141 7.56374 12.9578 8.02627 13.2404 8.24931C13.5191 8.46924 14.0214 8.41955 14.5254 8.4195C15.5361 8.4194 15.2193 8.36516 15.897 9.23679C15.9303 9.27972 16.2067 9.64472 16.2067 9.66694Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.6489 20.1197V22.7436C16.6489 23.5068 17.3652 24.1631 18.1532 24.1631C18.9412 24.1631 19.6575 23.5068 19.6575 22.7436V20.1197C19.6575 19.3617 18.9254 18.7002 18.1532 18.7002C17.3811 18.7002 16.6489 19.3617 16.6489 20.1197Z",
                fill: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TrackingStatusDeliveryManOnTheWay.tsx


var TrackingStatusDeliveryManOnTheWay = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Entregador a caminho" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 36 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 10.4167H11.1667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 12.9167H9.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.83333 15.4167H7",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.6254 18.2016H14.0742C13.7011 16.8216 11.7861 16.2943 10.6957 17.4693C10.4328 17.7526 10.1751 18.279 10.1751 18.8142C10.1751 19.0523 10.2696 19.4112 10.3471 19.5938C10.6251 20.248 11.3285 20.7896 12.0004 20.7896C12.0453 20.7896 12.0879 20.7899 12.1285 20.7902C12.4533 20.7925 12.6592 20.794 12.979 20.6332C13.4925 20.375 13.9178 20.002 14.0742 19.4268H11.6254H11.5754V19.3768V18.2516V18.2016H11.6254ZM8.94984 18.7272L8.94989 18.7256C8.98791 17.4912 9.72645 16.336 10.7853 15.8848C11.8891 15.4144 12.9504 15.4567 13.9759 16.1108C14.0535 16.1603 14.1178 16.2117 14.1807 16.2644C14.1963 16.2775 14.2118 16.2906 14.2272 16.3037C14.2747 16.3439 14.3229 16.3847 14.3782 16.4273L14.3477 16.4669L14.3782 16.4273C14.5804 16.5829 14.7853 16.8483 14.9538 17.137C15.1227 17.4263 15.2582 17.7443 15.3188 18.0089C15.3245 18.0342 15.3294 18.0584 15.3336 18.0792C15.3359 18.0907 15.3381 18.1013 15.34 18.1103C15.3459 18.138 15.3509 18.1555 15.3569 18.1678C15.3621 18.1785 15.3676 18.1844 15.3758 18.1893C15.3854 18.195 15.4015 18.2007 15.4309 18.2049C15.4907 18.2134 15.5861 18.2129 15.747 18.2099C15.7691 18.2095 15.7924 18.209 15.8169 18.2085C15.9584 18.2057 16.1405 18.2021 16.3753 18.2016C16.3636 17.9079 16.2515 17.5345 16.0932 17.1723C15.9262 16.79 15.7106 16.4268 15.5166 16.1914C15.164 15.7636 14.9399 15.5586 14.4857 15.255C13.7824 14.7851 13.1071 14.6275 12.1838 14.5507L12.138 14.5469V14.5008V13.3756V13.3256H12.188H18.0766C18.0948 13.3256 18.1051 13.322 18.1119 13.3178C18.1192 13.3134 18.127 13.3058 18.1361 13.2909C18.1455 13.2756 18.1547 13.2555 18.166 13.2284C18.169 13.2211 18.1722 13.2134 18.1756 13.2052C18.1843 13.1839 18.1942 13.1599 18.2055 13.1344C18.2702 12.989 18.3867 12.7875 18.6945 12.558C18.985 12.3414 19.3032 12.1968 19.8018 12.1999C20.4442 12.204 21.0872 12.2028 21.7303 12.2016C22.0137 12.201 22.297 12.2005 22.5804 12.2004C22.5683 12.1649 22.5542 12.1203 22.5391 12.0707C22.5093 11.9735 22.4742 11.8521 22.4403 11.7301C22.4064 11.608 22.3736 11.485 22.3485 11.3843C22.3316 11.3159 22.3175 11.2556 22.3095 11.2127L20.7773 11.2128C20.7773 11.2128 20.7772 11.2128 20.7772 11.2128C20.7088 11.2133 20.6505 11.2165 20.6 11.2193L20.597 11.2195C20.5486 11.2222 20.5052 11.2246 20.4687 11.223C20.4316 11.2214 20.3948 11.2155 20.3633 11.1965C20.33 11.1764 20.3087 11.1458 20.2953 11.1073C20.2823 11.0703 20.2757 11.0238 20.2722 10.9674C20.2686 10.9105 20.268 10.8399 20.2688 10.7534C20.2693 10.6954 20.2704 10.6301 20.2716 10.5562C20.274 10.4082 20.2771 10.226 20.2771 10V9.95H20.3271H23.2151H23.2533L23.2634 9.98684L24.6059 14.908L24.6059 14.908C24.6206 14.9619 24.6382 15.0343 24.6571 15.1121C24.6703 15.1667 24.6842 15.224 24.6982 15.2794C24.7284 15.3988 24.7588 15.5086 24.7857 15.5761C25.7312 15.5805 26.5613 15.7742 27.2175 16.4243L27.1823 16.4599L27.2175 16.4243C27.2253 16.4321 27.233 16.4397 27.2406 16.4472C27.3789 16.5841 27.47 16.6744 27.5959 16.8442C27.9969 17.3851 28.2171 18.0108 28.2535 18.6397L28.2536 18.6397V18.6426V19.0081H28.2537L28.2535 19.011C28.2145 19.6911 27.9588 20.3561 27.4828 20.9016L27.4829 20.9017L27.4804 20.9041L27.0859 21.2972L27.0859 21.2973L27.0839 21.2991C26.8466 21.5111 26.6569 21.6182 26.3632 21.7604C25.7078 22.0776 24.9842 22.1177 24.27 21.9607C23.6774 21.8305 23.1624 21.5145 22.7578 21.1093C21.6204 19.9704 21.4665 18.3826 22.3024 17.0545L22.3447 17.0811L22.3024 17.0545C22.3733 16.9418 22.476 16.8023 22.569 16.7064C22.6233 16.6503 22.6647 16.6056 22.7006 16.5667C22.8 16.4592 22.8578 16.3967 23.0351 16.2617C23.0577 16.2445 23.0817 16.2255 23.1069 16.2056C23.1631 16.1612 23.2252 16.1121 23.2906 16.0677C23.3756 16.0099 23.4705 15.9568 23.5755 15.9257C23.5672 15.8309 23.5376 15.7026 23.5017 15.5694C23.4813 15.4939 23.4593 15.4183 23.4386 15.348C23.4362 15.3396 23.4338 15.3314 23.4314 15.3232C23.4136 15.2626 23.3971 15.2064 23.3842 15.1594C23.3623 15.079 23.3379 14.9938 23.3128 14.9062C23.271 14.7602 23.2273 14.6076 23.1901 14.4598C23.1802 14.4733 23.1702 14.4879 23.1597 14.5046C23.1336 14.5463 23.1203 14.5738 23.1016 14.6124C23.0964 14.6231 23.0908 14.6346 23.0844 14.6475L23.0845 14.6475L23.0838 14.6488L22.7462 15.2864L22.7462 15.2864L22.7457 15.2874C22.721 15.3315 22.7007 15.3662 22.6819 15.3983C22.6464 15.4589 22.6163 15.5103 22.5726 15.5985L22.5727 15.5986L22.5717 15.6003L21.1966 18.1246C21.1466 18.2262 21.0486 18.3991 20.9429 18.5856C20.9036 18.655 20.8633 18.7262 20.8239 18.7963C20.7508 18.9267 20.6808 19.0538 20.6265 19.1598C20.5711 19.2679 20.5351 19.3483 20.5258 19.3881L20.5168 19.4268H20.4771H15.3501C15.3364 19.7645 15.187 20.1072 14.9923 20.415C14.7875 20.7388 14.5294 21.029 14.315 21.2415C13.7956 21.7562 13.0351 22.0245 12.2676 22.0428C11.5001 22.061 10.7192 21.8293 10.1586 21.3356C9.76121 20.9856 9.5384 20.7552 9.27977 20.2372C9.06885 19.8148 8.96453 19.3711 8.94989 18.9334L8.94987 18.9334V18.9317L8.94984 18.7272ZM25.6268 18.6528L25.6359 18.6919L25.5997 18.7092C25.5851 18.7162 25.5578 18.7257 25.5248 18.7363C25.4904 18.7473 25.4464 18.7606 25.3961 18.7753C25.2952 18.8048 25.168 18.8402 25.04 18.8745C24.912 18.9088 24.7828 18.9422 24.6781 18.9677C24.5756 18.9926 24.4914 19.0112 24.457 19.014L24.4041 19.0184L24.4029 18.9653C24.4024 18.9411 24.3956 18.8974 24.3824 18.8356C24.3695 18.7748 24.3512 18.7 24.3291 18.6153C24.285 18.4459 24.2264 18.2391 24.1671 18.0308C24.1623 18.0138 24.1574 17.9967 24.1526 17.9797C24.0982 17.7888 24.0442 17.5992 24.0016 17.4398C23.9696 17.3201 23.9432 17.2148 23.9281 17.138C23.4614 17.4746 23.0401 18.0416 23.0401 18.6266C23.0401 18.6569 23.04 18.6859 23.04 18.7138C23.0396 18.8997 23.0393 19.0348 23.0582 19.1681C23.0796 19.3194 23.1261 19.4696 23.2292 19.6865C23.3398 19.9195 23.4313 20.0288 23.6161 20.2135C23.793 20.3904 23.8812 20.4697 24.1189 20.5886C24.7677 20.9133 25.6458 20.8565 26.2115 20.4141C26.2501 20.3839 26.2812 20.3598 26.3066 20.3401C26.3744 20.2876 26.4014 20.2666 26.423 20.2449C26.4369 20.2309 26.4485 20.2165 26.4692 20.1899C26.4721 20.1862 26.4751 20.1823 26.4783 20.1782C26.4979 20.1528 26.5244 20.1186 26.5639 20.0699C27.3114 19.1474 27.056 17.8651 26.3357 17.3159L26.3357 17.3159C26.2884 17.2799 26.2686 17.2616 26.2418 17.237C26.2284 17.2247 26.2132 17.2108 26.1921 17.1922C26.0738 17.0887 25.8839 16.9984 25.6726 16.9298C25.4875 16.8698 25.2901 16.8278 25.1178 16.808C25.1884 17.0999 25.2757 17.396 25.3635 17.6936L25.3637 17.6942C25.4581 18.0142 25.5529 18.3358 25.6268 18.6528ZM22.3066 13.4253C22.2352 13.4249 22.1415 13.424 22.0319 13.4231C21.9688 13.4225 21.9004 13.4219 21.8281 13.4213C21.5723 13.4191 21.266 13.417 20.963 13.4171C20.66 13.4173 20.3606 13.4198 20.1187 13.4268C19.9977 13.4303 19.8915 13.4349 19.8065 13.4409C19.7204 13.447 19.6595 13.4543 19.6272 13.4624C19.5084 13.4918 19.4288 13.5401 19.3744 13.6002C19.3196 13.6606 19.2868 13.7368 19.2679 13.828C19.2489 13.9196 19.2446 14.0239 19.2453 14.1384C19.2457 14.1904 19.247 14.2437 19.2484 14.2986L19.2489 14.3152C19.2504 14.3757 19.2519 14.438 19.2519 14.5008V14.5508H19.2019H15.6493L16.2838 15.1675L16.2838 15.1675L16.2849 15.1686C16.6165 15.512 16.9492 16.0482 17.2016 16.6133C17.4451 17.1588 17.6165 17.7372 17.6374 18.2016C18.1413 18.202 18.525 18.2085 18.819 18.2135C18.8973 18.2148 18.9693 18.2161 19.0354 18.217C19.3603 18.2218 19.5398 18.2202 19.6499 18.1975C19.7033 18.1866 19.7364 18.1713 19.7607 18.1521C19.7853 18.1328 19.8048 18.1064 19.8264 18.0661C19.8408 18.0391 19.8547 18.0088 19.8714 17.9725C19.8805 17.9527 19.8904 17.9312 19.9017 17.9074C19.9328 17.8417 19.9722 17.7637 20.0283 17.6714L22.3066 13.4253Z",
                fill: color,
                stroke: color,
                strokeWidth: "0.1"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TrackingStatusOrderBeignSeparated.tsx


var TrackingStatusOrderBeignSeparated = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Produto sendo separado" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 36 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.6183 8.6829L25.67 13.8709C25.9454 14.013 26.1193 14.2962 26.1214 14.6061C26.1235 14.916 25.9535 15.2015 25.68 15.3473L21.9285 17.3482C21.4452 17.606 20.8662 17.61 20.3795 17.359L10.3303 12.1694C10.0549 12.0272 9.88104 11.7441 9.87893 11.4342C9.87684 11.1242 10.0468 10.8387 10.3203 10.6929L14.0718 8.69207C14.5547 8.43568 15.1325 8.43225 15.6183 8.6829Z",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.382 8.6829L10.3303 13.8709C10.0549 14.013 9.88104 14.2962 9.87893 14.6061C9.87684 14.916 10.0468 15.2015 10.3203 15.3473L14.0718 17.3482C14.5551 17.606 15.1341 17.61 15.6208 17.359L25.67 12.1694C25.9454 12.0272 26.1193 11.7441 26.1214 11.4342C26.1235 11.1242 25.9535 10.8387 25.68 10.6929L21.9285 8.69207C21.4456 8.43568 20.8678 8.43225 20.382 8.6829Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.9232 16.2844V19.5658C23.9232 20.1817 23.5838 20.7475 23.0404 21.0372L18.7886 23.3073C18.2983 23.5688 17.7099 23.5688 17.2196 23.3073L12.9678 21.0372C12.4244 20.7475 12.085 20.1817 12.085 19.5658V16.2844",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.0003 23.5032V16.1284",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TrackingStatusOrderCanceled.tsx


var TrackingStatusOrderCanceled = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.primary.150 */.rS.colors.primary[150] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Pedido cancelado" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 36 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.5 8.5V12.6667C20.5 13.1267 20.1267 13.5 19.6667 13.5H16.3333C15.8733 13.5 15.5 13.1267 15.5 12.6667V8.5",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.5 16V10.1667C25.5 9.24583 24.7542 8.5 23.8333 8.5H12.1667C11.2458 8.5 10.5 9.24583 10.5 10.1667V21.8333C10.5 22.7542 11.2458 23.5 12.1667 23.5H18",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.3333 21.4167C26.3333 23.0308 25.0308 24.3333 23.4167 24.3333C21.8025 24.3333 20.5 23.0308 20.5 21.4167C20.5 19.8025 21.8025 18.5 23.4167 18.5C25.0308 18.5 26.3333 19.8025 26.3333 21.4167Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.355 23.4783L25.4783 19.355",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TrackingStatusOrderInvoiced.tsx


var TrackingStatusOrderInvoiced = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Pedido faturado" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 36 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.8335 23.5H22.1668C23.5475 23.5 24.6668 22.3807 24.6668 21V12.9764C24.6668 12.3134 24.4034 11.6775 23.9346 11.2086L21.9582 9.23223C21.4894 8.76339 20.8535 8.5 20.1904 8.5H13.8335C12.4528 8.5 11.3335 9.61929 11.3335 11V21C11.3335 22.3807 12.4528 23.5 13.8335 23.5Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.3332 20.1667H14.6665",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.3332 17.2499H14.6665",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.1665 14.3334H14.6665",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TrackingStatusOrderNewDeliveryMan.tsx


var TrackingStatusOrderNewDeliveryMan = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Novo entregador foi designado" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 36 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 10.4167H11.1667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 12.9167H9.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.83333 15.4167H7",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.6254 18.2016H14.0742C13.7011 16.8216 11.7861 16.2943 10.6957 17.4693C10.4328 17.7526 10.1751 18.279 10.1751 18.8142C10.1751 19.0523 10.2696 19.4112 10.3471 19.5938C10.6251 20.248 11.3285 20.7896 12.0004 20.7896C12.0453 20.7896 12.0879 20.7899 12.1285 20.7902C12.4533 20.7925 12.6592 20.794 12.979 20.6332C13.4925 20.375 13.9178 20.002 14.0742 19.4268H11.6254H11.5754V19.3768V18.2516V18.2016H11.6254ZM8.94984 18.7272L8.94989 18.7256C8.98791 17.4912 9.72645 16.336 10.7853 15.8848C11.8891 15.4144 12.9504 15.4567 13.9759 16.1108C14.0535 16.1603 14.1178 16.2117 14.1807 16.2644C14.1963 16.2775 14.2118 16.2906 14.2272 16.3037C14.2747 16.3439 14.3229 16.3847 14.3782 16.4273L14.3477 16.4669L14.3782 16.4273C14.5804 16.5829 14.7853 16.8483 14.9538 17.137C15.1227 17.4263 15.2582 17.7443 15.3188 18.0089C15.3245 18.0342 15.3294 18.0584 15.3336 18.0792C15.3359 18.0907 15.3381 18.1013 15.34 18.1103C15.3459 18.138 15.3509 18.1555 15.3569 18.1678C15.3621 18.1785 15.3676 18.1844 15.3758 18.1893C15.3854 18.195 15.4015 18.2007 15.4309 18.2049C15.4907 18.2134 15.5861 18.2129 15.747 18.2099C15.7691 18.2095 15.7924 18.209 15.8169 18.2085C15.9584 18.2057 16.1405 18.2021 16.3753 18.2016C16.3636 17.9079 16.2515 17.5345 16.0932 17.1723C15.9262 16.79 15.7106 16.4268 15.5166 16.1914C15.164 15.7636 14.9399 15.5586 14.4857 15.255C13.7824 14.7851 13.1071 14.6275 12.1838 14.5507L12.138 14.5469V14.5008V13.3756V13.3256H12.188H18.0766C18.0948 13.3256 18.1051 13.322 18.1119 13.3178C18.1192 13.3134 18.127 13.3058 18.1361 13.2909C18.1455 13.2756 18.1547 13.2555 18.166 13.2284C18.169 13.2211 18.1722 13.2134 18.1756 13.2052C18.1843 13.1839 18.1942 13.1599 18.2055 13.1344C18.2702 12.989 18.3867 12.7875 18.6945 12.558C18.985 12.3414 19.3032 12.1968 19.8018 12.1999C20.4442 12.204 21.0872 12.2028 21.7303 12.2016C22.0137 12.201 22.297 12.2005 22.5804 12.2004C22.5683 12.1649 22.5542 12.1203 22.5391 12.0707C22.5093 11.9735 22.4742 11.8521 22.4403 11.7301C22.4064 11.608 22.3736 11.485 22.3485 11.3843C22.3316 11.3159 22.3175 11.2556 22.3095 11.2127L20.7773 11.2128C20.7773 11.2128 20.7772 11.2128 20.7772 11.2128C20.7088 11.2133 20.6505 11.2165 20.6 11.2193L20.597 11.2195C20.5486 11.2222 20.5052 11.2246 20.4687 11.223C20.4316 11.2214 20.3948 11.2155 20.3633 11.1965C20.33 11.1764 20.3087 11.1458 20.2953 11.1073C20.2823 11.0703 20.2757 11.0238 20.2722 10.9674C20.2686 10.9105 20.268 10.8399 20.2688 10.7534C20.2693 10.6954 20.2704 10.6301 20.2716 10.5562C20.274 10.4082 20.2771 10.226 20.2771 10V9.95H20.3271H23.2151H23.2533L23.2634 9.98684L24.6059 14.908L24.6059 14.908C24.6206 14.9619 24.6382 15.0343 24.6571 15.1121C24.6703 15.1667 24.6842 15.224 24.6982 15.2794C24.7284 15.3988 24.7588 15.5086 24.7857 15.5761C25.7312 15.5805 26.5613 15.7742 27.2175 16.4243L27.1823 16.4599L27.2175 16.4243C27.2253 16.4321 27.233 16.4397 27.2406 16.4472C27.3789 16.5841 27.47 16.6744 27.5959 16.8442C27.9969 17.3851 28.2171 18.0108 28.2535 18.6397L28.2536 18.6397V18.6426V19.0081H28.2537L28.2535 19.011C28.2145 19.6911 27.9588 20.3561 27.4828 20.9016L27.4829 20.9017L27.4804 20.9041L27.0859 21.2972L27.0859 21.2973L27.0839 21.2991C26.8466 21.5111 26.6569 21.6182 26.3632 21.7604C25.7078 22.0776 24.9842 22.1177 24.27 21.9607C23.6774 21.8305 23.1624 21.5145 22.7578 21.1093C21.6204 19.9704 21.4665 18.3826 22.3024 17.0545L22.3447 17.0811L22.3024 17.0545C22.3733 16.9418 22.476 16.8023 22.569 16.7064C22.6233 16.6503 22.6647 16.6056 22.7006 16.5667C22.8 16.4592 22.8578 16.3967 23.0351 16.2617C23.0577 16.2445 23.0817 16.2255 23.1069 16.2056C23.1631 16.1612 23.2252 16.1121 23.2906 16.0677C23.3756 16.0099 23.4705 15.9568 23.5755 15.9257C23.5672 15.8309 23.5376 15.7026 23.5017 15.5694C23.4813 15.4939 23.4593 15.4183 23.4386 15.348C23.4362 15.3396 23.4338 15.3314 23.4314 15.3232C23.4136 15.2626 23.3971 15.2064 23.3842 15.1594C23.3623 15.079 23.3379 14.9938 23.3128 14.9062C23.271 14.7602 23.2273 14.6076 23.1901 14.4598C23.1802 14.4733 23.1702 14.4879 23.1597 14.5046C23.1336 14.5463 23.1203 14.5738 23.1016 14.6124C23.0964 14.6231 23.0908 14.6346 23.0844 14.6475L23.0845 14.6475L23.0838 14.6488L22.7462 15.2864L22.7462 15.2864L22.7457 15.2874C22.721 15.3315 22.7007 15.3662 22.6819 15.3983C22.6464 15.4589 22.6163 15.5103 22.5726 15.5985L22.5727 15.5986L22.5717 15.6003L21.1966 18.1246C21.1466 18.2262 21.0486 18.3991 20.9429 18.5856C20.9036 18.655 20.8633 18.7262 20.8239 18.7963C20.7508 18.9267 20.6808 19.0538 20.6265 19.1598C20.5711 19.2679 20.5351 19.3483 20.5258 19.3881L20.5168 19.4268H20.4771H15.3501C15.3364 19.7645 15.187 20.1072 14.9923 20.415C14.7875 20.7388 14.5294 21.029 14.315 21.2415C13.7956 21.7562 13.0351 22.0245 12.2676 22.0428C11.5001 22.061 10.7192 21.8293 10.1586 21.3356C9.76121 20.9856 9.5384 20.7552 9.27977 20.2372C9.06885 19.8148 8.96453 19.3711 8.94989 18.9334L8.94987 18.9334V18.9317L8.94984 18.7272ZM25.6268 18.6528L25.6359 18.6919L25.5997 18.7092C25.5851 18.7162 25.5578 18.7257 25.5248 18.7363C25.4904 18.7473 25.4464 18.7606 25.3961 18.7753C25.2952 18.8048 25.168 18.8402 25.04 18.8745C24.912 18.9088 24.7828 18.9422 24.6781 18.9677C24.5756 18.9926 24.4914 19.0112 24.457 19.014L24.4041 19.0184L24.4029 18.9653C24.4024 18.9411 24.3956 18.8974 24.3824 18.8356C24.3695 18.7748 24.3512 18.7 24.3291 18.6153C24.285 18.4459 24.2264 18.2391 24.1671 18.0308C24.1623 18.0138 24.1574 17.9967 24.1526 17.9797C24.0982 17.7888 24.0442 17.5992 24.0016 17.4398C23.9696 17.3201 23.9432 17.2148 23.9281 17.138C23.4614 17.4746 23.0401 18.0416 23.0401 18.6266C23.0401 18.6569 23.04 18.6859 23.04 18.7138C23.0396 18.8997 23.0393 19.0348 23.0582 19.1681C23.0796 19.3194 23.1261 19.4696 23.2292 19.6865C23.3398 19.9195 23.4313 20.0288 23.6161 20.2135C23.793 20.3904 23.8812 20.4697 24.1189 20.5886C24.7677 20.9133 25.6458 20.8565 26.2115 20.4141C26.2501 20.3839 26.2812 20.3598 26.3066 20.3401C26.3744 20.2876 26.4014 20.2666 26.423 20.2449C26.4369 20.2309 26.4485 20.2165 26.4692 20.1899C26.4721 20.1862 26.4751 20.1823 26.4783 20.1782C26.4979 20.1528 26.5244 20.1186 26.5639 20.0699C27.3114 19.1474 27.056 17.8651 26.3357 17.3159L26.3357 17.3159C26.2884 17.2799 26.2686 17.2616 26.2418 17.237C26.2284 17.2247 26.2132 17.2108 26.1921 17.1922C26.0738 17.0887 25.8839 16.9984 25.6726 16.9298C25.4875 16.8698 25.2901 16.8278 25.1178 16.808C25.1884 17.0999 25.2757 17.396 25.3635 17.6936L25.3637 17.6942C25.4581 18.0142 25.5529 18.3358 25.6268 18.6528ZM22.3066 13.4253C22.2352 13.4249 22.1415 13.424 22.0319 13.4231C21.9688 13.4225 21.9004 13.4219 21.8281 13.4213C21.5723 13.4191 21.266 13.417 20.963 13.4171C20.66 13.4173 20.3606 13.4198 20.1187 13.4268C19.9977 13.4303 19.8915 13.4349 19.8065 13.4409C19.7204 13.447 19.6595 13.4543 19.6272 13.4624C19.5084 13.4918 19.4288 13.5401 19.3744 13.6002C19.3196 13.6606 19.2868 13.7368 19.2679 13.828C19.2489 13.9196 19.2446 14.0239 19.2453 14.1384C19.2457 14.1904 19.247 14.2437 19.2484 14.2986L19.2489 14.3152C19.2504 14.3757 19.2519 14.438 19.2519 14.5008V14.5508H19.2019H15.6493L16.2838 15.1675L16.2838 15.1675L16.2849 15.1686C16.6165 15.512 16.9492 16.0482 17.2016 16.6133C17.4451 17.1588 17.6165 17.7372 17.6374 18.2016C18.1413 18.202 18.525 18.2085 18.819 18.2135C18.8973 18.2148 18.9693 18.2161 19.0354 18.217C19.3603 18.2218 19.5398 18.2202 19.6499 18.1975C19.7033 18.1866 19.7364 18.1713 19.7607 18.1521C19.7853 18.1328 19.8048 18.1064 19.8264 18.0661C19.8408 18.0391 19.8547 18.0088 19.8714 17.9725C19.8805 17.9527 19.8904 17.9312 19.9017 17.9074C19.9328 17.8417 19.9722 17.7637 20.0283 17.6714L22.3066 13.4253Z",
                fill: color,
                stroke: color,
                strokeWidth: "0.1"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TrackingStatusOrderOnTheCarrier.tsx


var TrackingStatusOrderOnTheCarrier = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Pedido na transportadora" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 36 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.0712 17.7261H19.6268C19.1666 17.7261 18.7935 17.353 18.7935 16.8928V14.3333",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "23.4165",
                cy: "22.25",
                rx: "1.25",
                ry: "1.25",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3335 14.3333H19.1807C20.3611 14.3333 21.4725 14.889 22.1807 15.8333L23.0816 17.0344C23.2368 17.2414 23.4381 17.4094 23.6695 17.5251L25.4122 18.3964C25.9768 18.6787 26.3335 19.2558 26.3335 19.8871V21.2083C26.3335 21.7835 25.8671 22.2499 25.2918 22.2499H24.6668",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.1665 22.2499H19.6665",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.3318 23.5001H14.2484C14.0274 23.5001 13.8155 23.4122 13.6594 23.2559C13.5032 23.0995 13.4157 22.8875 13.416 22.6665V20.5831C13.416 20.3621 13.5039 20.1502 13.6602 19.9941C13.8166 19.8379 14.0287 19.7504 14.2496 19.7507H16.333C16.554 19.7507 16.7659 19.8386 16.922 19.995C17.0782 20.1513 17.1657 20.3634 17.1654 20.5843V22.6678C17.1654 22.8887 17.0775 23.1006 16.9212 23.2568C16.7648 23.4129 16.5528 23.5004 16.3318 23.5001Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.5823 23.5001H10.5001C10.2789 23.5004 10.0668 23.4126 9.91037 23.2562C9.75398 23.0999 9.66624 22.8877 9.6665 22.6665V20.5831C9.6665 20.3621 9.75437 20.1502 9.91074 19.9941C10.0671 19.8379 10.2791 19.7504 10.5001 19.7507H12.5835C12.8045 19.7507 13.0164 19.8386 13.1725 19.995C13.3287 20.1513 13.4162 20.3634 13.4159 20.5843V22.6678C13.4159 22.8887 13.328 23.1006 13.1716 23.2568C13.0153 23.4129 12.8032 23.5004 12.5823 23.5001V23.5001Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.457 19.7506H12.3736C12.1525 19.7507 11.9405 19.6629 11.7841 19.5065C11.6278 19.3502 11.54 19.1381 11.54 18.917V16.8336C11.54 16.6125 11.6278 16.4004 11.7841 16.2441C11.9405 16.0878 12.1525 15.9999 12.3736 16H14.457C14.6782 15.9999 14.8902 16.0878 15.0466 16.2441C15.2029 16.4004 15.2907 16.6125 15.2907 16.8336V18.917C15.2909 19.1382 15.2032 19.3504 15.0468 19.5068C14.8904 19.6632 14.6782 19.7509 14.457 19.7506V19.7506Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.5 14.3334V12.6993C25.5 11.9427 25.0898 11.2456 24.4285 10.8781L19.2146 7.98139C18.4595 7.56187 17.5413 7.56187 16.7863 7.98139L11.5715 10.8786C10.9102 11.246 10.5 11.9432 10.5 12.6997V13.5001",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TrackingStatusOrderOutForDelivery.tsx


var TrackingStatusOrderOutForDelivery = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Pedido saiu pra entrega" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 36 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.5865 21.2467C24.1024 21.7626 24.1024 22.5984 23.5865 23.1134C23.0707 23.6292 22.2349 23.6292 21.7199 23.1134C21.204 22.5976 21.204 21.7617 21.7199 21.2467C22.2357 20.7309 23.0715 20.7309 23.5865 21.2467",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.4197 21.2467C14.9356 21.7625 14.9356 22.5983 14.4197 23.1133C13.9039 23.6292 13.0681 23.6292 12.5531 23.1133C12.0381 22.5975 12.0372 21.7617 12.5531 21.2467C13.0689 20.7317 13.9039 20.7308 14.4197 21.2467",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3332 9.3335H19.6665C20.1265 9.3335 20.4998 9.70683 20.4998 10.1668V18.5002H9.6665",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.1665 22.1802H10.4998C10.0398 22.1802 9.6665 21.8068 9.6665 21.3468V16.8335",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.5 11.8335H24.1025C24.4433 11.8335 24.75 12.041 24.8758 12.3577L26.2142 15.7027C26.2925 15.8993 26.3333 16.1093 26.3333 16.321V21.2777C26.3333 21.7377 25.96 22.111 25.5 22.111H23.9742",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.3331 22.1835H14.8081",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.3333 17.6668H23V14.3335H25.6667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.6665 9.33341H13.8332",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.6665 11.8334H12.1665",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.4998 14.3334H9.6665",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TrackingStatusOrderReceived.tsx


var TrackingStatusOrderReceived = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Recebemos seu pedido" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 36 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.0003 8.49683V12.6652",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.832 20.1683H15.4994",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.5033 14.3326C25.5033 13.4118 24.7568 12.6653 23.836 12.6653H12.1644C11.2436 12.6653 10.4971 13.4118 10.4971 14.3326",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.836 23.5031H12.3729C11.3369 23.5031 10.4971 22.6633 10.4971 21.6273V13.0821C10.4968 12.6318 10.5881 12.1862 10.7655 11.7724L11.6776 9.63563C11.9725 8.94478 12.6513 8.49663 13.4024 8.49683H22.5971C23.3483 8.49663 24.0271 8.94478 24.322 9.63563L25.239 11.7724C25.4149 12.1865 25.5048 12.6321 25.5033 13.0821V21.8357C25.5033 22.7566 24.7568 23.5031 23.836 23.5031Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TrackingStatusPickingAvailable.tsx


var TrackingStatusPickingAvailable = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.secondary.380 */.rS.colors.secondary[380] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Pode vir buscar" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 36 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.9999 18.4793V17.6459C18.0122 16.9792 17.7527 16.3362 17.2812 15.8647C16.8097 15.3932 16.1666 15.1337 15.4999 15.1459H12.9999C12.3332 15.1337 11.6902 15.3932 11.2187 15.8647C10.7472 16.3362 10.4877 16.9792 10.4999 17.6459V18.4793",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.8335 10.1667H23.8335C24.754 10.1667 25.5002 10.9129 25.5002 11.8334V16.0001C25.5002 16.9206 24.754 17.6667 23.8335 17.6667H20.5002",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "14.2152",
                cy: "10.5833",
                r: "2.08333",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.1667 12.6667H20.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.1599 20.1667H13",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0002 20.1667V22.2968",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3174 20.1667C13.822 21.1085 14.5877 21.8847 15.5225 22.402C16.808 23.1093 18.3236 23.271 19.7294 22.8507C21.1351 22.4305 22.3134 21.4635 22.9998 20.1667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TrackingStatusRescheduledOrder.tsx


var TrackingStatusRescheduledOrder = function(param) {
    var _width = param.width, width = _width === void 0 ? 36 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? themes/* theme.colors.yellow.170 */.rS.colors.yellow[170] : _color, _secondColor = param.secondColor, secondColor = _secondColor === void 0 ? themes/* theme.colors.neutral.white */.rS.colors.neutral.white : _secondColor, _alt = param.alt, alt = _alt === void 0 ? "Entrega reprogramada" : _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        width: width,
        height: height,
        viewBox: "0 0 36 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                fill: secondColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.25",
                y: "1.25",
                width: "29.5",
                height: "29.5",
                rx: "14.75",
                stroke: color,
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.4987 23.5031H12.3724C11.3364 23.5031 10.4966 22.6633 10.4966 21.6273V12.7819C10.4966 12.5286 10.548 12.278 10.6475 12.045L11.6771 9.63563C11.9725 8.94522 12.651 8.49729 13.402 8.49683H22.5966C23.3477 8.49707 24.0262 8.94507 24.3215 9.63563L25.3511 12.045C25.4511 12.2778 25.5028 12.5285 25.5028 12.7819V16",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.9998 8.49683V12.6652",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.8315 20.1683H15.4989",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.5028 14.3326C25.5028 13.4118 24.7563 12.6653 23.8355 12.6653H12.1639C11.2431 12.6653 10.4966 13.4118 10.4966 14.3326",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.5804 17.338L26.1198 21.8507C26.4106 22.3666 26.4058 22.9981 26.1073 23.5097C25.8089 24.0212 25.2614 24.336 24.6692 24.3367H19.5879C18.9954 24.3367 18.4474 24.0224 18.1484 23.511C17.8494 22.9995 17.8442 22.3678 18.1348 21.8515L20.6742 17.338C20.9695 16.8131 21.525 16.4883 22.1273 16.4883C22.7295 16.4883 23.285 16.8131 23.5804 17.338Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.1273 20.5186V18.9888",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.1265 22.2067C22.1064 22.2067 22.0872 22.2147 22.0731 22.229C22.059 22.2432 22.0512 22.2625 22.0514 22.2826C22.0514 22.3133 22.07 22.341 22.0985 22.3527C22.1269 22.3644 22.1596 22.3578 22.1812 22.3359C22.2029 22.314 22.2091 22.2813 22.1971 22.253C22.1851 22.2246 22.1572 22.2064 22.1265 22.2067",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/TwoCardsIcon.tsx

var TwoCardsIcon = function(param) {
    var width = param.width, height = param.height, alt = param.alt, color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        "aria-label": alt,
        "aria-labelledby": alt,
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.99967 21.333H6.66634C4.82539 21.333 3.33301 19.8406 3.33301 17.9997V8.66634C3.33301 6.82539 4.82539 5.33301 6.66634 5.33301H21.333C23.174 5.33301 24.6663 6.82539 24.6663 8.66634V10.6663",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "8.66699",
                y: "10.667",
                width: "20",
                height: "16",
                rx: "2.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.66699 15.9997H28.667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.9997 21.3337H13.333",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/UniqueClientMediumMobileInfo.tsx

var UniqueClientMediumSMobileInfo = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 114 : _height, _dataTestId = param.dataTestId, dataTestId = _dataTestId === void 0 ? "unique-client-banner-xs-image" : _dataTestId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        "data-testid": dataTestId,
        viewBox: "0 0 32 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 0H0V32H32V0Z",
                fill: "#AA0E27"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.4151 24.7656H8.79097C8.39735 24.7656 8.0782 24.4464 8.0782 24.0528V14.3719C8.0782 14.0704 8.32288 13.8258 8.6243 13.8258H14.252C14.5534 13.8258 14.7981 14.0704 14.7981 14.3719V23.8223C14.901 23.9216 14.9648 24.0599 14.9648 24.2159C14.9648 24.5174 14.7201 24.7656 14.4187 24.7656M9.17395 23.6698H13.7059V14.9215H9.17395V23.6698Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.5896 24.7656H17.9654C17.664 24.7656 17.4193 24.5209 17.4193 24.2159C17.4193 24.0635 17.4831 23.9252 17.586 23.8223V14.3719C17.586 14.0704 17.8307 13.8258 18.1321 13.8258H23.7562C24.0577 13.8258 24.3024 14.0704 24.3024 14.3719V24.0528C24.3024 24.4464 23.9832 24.7656 23.5896 24.7656ZM18.6782 23.6698H23.2101V14.9215H18.6782V23.6698Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.6677 14.9214H18.1284C17.827 14.9214 17.5823 14.6767 17.5823 14.3753V10.8893C17.4794 10.79 17.4156 10.6517 17.4156 10.4957C17.4156 10.1943 17.6603 9.94957 17.9617 9.94957H24.6677C25.0613 9.94957 25.3805 10.2687 25.3805 10.6624V14.2086C25.3805 14.6023 25.0613 14.9214 24.6677 14.9214ZM18.6781 13.8256H24.2882V11.0418H18.6781V13.8256Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.2522 14.9214H7.71291C7.31927 14.9214 7.00011 14.6023 7.00011 14.2086V10.6624C7.00011 10.2687 7.31927 9.94957 7.71291 9.94957H14.4189C14.7203 9.94957 14.965 10.1943 14.965 10.4957C14.965 10.6482 14.9012 10.79 14.7983 10.8893V14.3753C14.7983 14.6767 14.5536 14.9214 14.2522 14.9214ZM8.0959 13.8256H13.7061V11.0418H8.0959V13.8256Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3693 11.0417H12.0996C10.8053 11.0417 9.53216 9.86793 9.52861 8.67284C9.52861 8.21892 9.64919 7.40683 10.4506 7.1054C11.2308 6.81106 12.433 7.13377 14.0288 8.06643C15.2806 8.79696 16.38 9.67643 16.7807 10.1339C16.9226 10.297 16.9545 10.524 16.8658 10.7226C16.7772 10.9176 16.5821 11.0453 16.3658 11.0453M11.0819 8.09835C10.979 8.09835 10.8975 8.11254 10.8336 8.13381C10.7769 8.15509 10.6209 8.21538 10.6209 8.67639C10.6209 9.27216 11.4081 9.9495 12.0961 9.9495H14.887C14.4863 9.65161 14.0004 9.32536 13.4756 9.01683C12.3089 8.33595 11.5181 8.09835 11.0819 8.09835Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.2775 11.0418H16.0078C15.795 11.0418 15.6 10.9176 15.5078 10.7191C15.4191 10.524 15.451 10.2935 15.5929 10.1304C15.9901 9.67291 17.0929 8.79344 18.3448 8.06646C19.9406 7.13734 21.1428 6.81108 21.9229 7.10542C22.7244 7.40685 22.845 8.2154 22.845 8.67287C22.845 9.86796 21.5719 11.0418 20.2739 11.0418M17.483 9.94597H20.2739C20.9619 9.94597 21.7492 9.26864 21.7492 8.67287C21.7492 8.21186 21.5967 8.15512 21.5364 8.13384C21.203 8.00972 20.3342 8.17639 18.8944 9.01686C18.366 9.32538 17.8838 9.65163 17.483 9.94952V9.94597Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.9471 24.765H14.433C14.0323 24.765 13.7025 24.4388 13.7025 24.0345V10.6766C13.7025 10.2724 14.0287 9.94612 14.433 9.94612H17.9471C18.3478 9.94612 18.6776 10.2724 18.6776 10.6766V24.0345C18.6776 24.4352 18.3514 24.765 17.9471 24.765ZM14.7982 23.6693H17.5819V11.0418H14.7982V23.6693Z",
                fill: "#ED5568"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "32",
                height: "32",
                transform: "translate(0 32)",
                fill: "#C1D82F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.542 56.7511H9.9254C8.86383 56.7511 8 55.8354 8 54.7101V41.041C8 39.9157 8.86383 39 9.9254 39H19.542C20.6036 39 21.4674 39.9157 21.4674 41.041V44.0124C21.4674 44.325 21.228 44.5787 20.9331 44.5787C20.6382 44.5787 20.3989 44.325 20.3989 44.0124V41.041C20.3989 40.5409 20.0138 40.1363 19.5455 40.1363H9.92887C9.45706 40.1363 9.07545 40.5409 9.07545 41.041V54.7101C9.07545 55.2103 9.45706 55.6148 9.92887 55.6148H19.5455C20.0173 55.6148 20.3989 55.2103 20.3989 54.7101V51.8969C20.3989 51.5843 20.6382 51.3305 20.9331 51.3305C21.228 51.3305 21.4674 51.5843 21.4674 51.8969V54.7101C21.4674 55.8354 20.6036 56.7511 19.542 56.7511Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.5809 43.0599H10.8793C10.5845 43.0599 10.3451 42.8062 10.3451 42.4936C10.3451 42.181 10.5845 41.9236 10.8793 41.9236H18.5809C18.8758 41.9236 19.1152 42.1773 19.1152 42.4936C19.1152 42.8099 18.8758 43.0599 18.5809 43.0599Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.43 46.6417H10.8793C10.5845 46.6417 10.3451 46.388 10.3451 46.0754C10.3451 45.7628 10.5845 45.5091 10.8793 45.5091H16.43C16.7249 45.5091 16.9643 45.7628 16.9643 46.0754C16.9643 46.388 16.7249 46.6417 16.43 46.6417Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3469 50.2272H10.8829C10.588 50.2272 10.3486 49.9735 10.3486 49.6609C10.3486 49.3483 10.588 49.0946 10.8829 49.0946H16.3469C16.6417 49.0946 16.8811 49.3483 16.8811 49.6609C16.8811 49.9735 16.6417 50.2272 16.3469 50.2272Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.5809 53.8091H10.8793C10.5845 53.8091 10.3451 53.5554 10.3451 53.2428C10.3451 52.9302 10.5845 52.6765 10.8793 52.6765H18.5809C18.8758 52.6765 19.1152 52.9302 19.1152 53.2428C19.1152 53.5554 18.8758 53.8091 18.5809 53.8091Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.2793 56.2546C25.9081 56.2546 25.5577 56.1002 25.2975 55.8244L21.7208 52.0329C20.9992 52.4043 20.1874 52.5551 19.386 52.4632C18.4251 52.3528 17.5196 51.8932 16.8362 51.1687C16.0313 50.3155 15.5873 49.1792 15.5873 47.9693C15.5873 46.7594 16.0313 45.6231 16.8362 44.7699C17.641 43.9167 18.713 43.446 19.8544 43.446C20.9957 43.446 22.0643 43.9167 22.8726 44.7699C23.556 45.4944 23.9896 46.4542 24.0937 47.4728C24.1805 48.3223 24.0382 49.1865 23.6878 49.9478L27.2646 53.7392C27.5282 54.0187 27.6739 54.3865 27.6739 54.7836C27.6739 55.1808 27.5282 55.5486 27.2646 55.828C27.0009 56.1075 26.654 56.2583 26.2793 56.2583M21.811 50.7642C21.9498 50.7642 22.0851 50.8193 22.1891 50.9297L26.0503 55.0227C26.1093 55.0852 26.1891 55.122 26.2758 55.122C26.3626 55.122 26.4424 55.0852 26.5013 55.0227C26.5603 54.9602 26.595 54.8756 26.595 54.7836C26.595 54.6917 26.5603 54.6071 26.5013 54.5446L22.6401 50.4516C22.4632 50.264 22.432 49.9735 22.5638 49.7492C22.9385 49.1093 23.1015 48.3444 23.0217 47.5942C22.942 46.8219 22.6263 46.1232 22.1059 45.5716C21.5022 44.9317 20.7009 44.5787 19.8474 44.5787C18.994 44.5787 18.1892 44.9317 17.5855 45.5716C16.9819 46.2115 16.6489 47.061 16.6489 47.9656C16.6489 48.8703 16.9819 49.7235 17.5855 50.3633C18.1059 50.915 18.7651 51.2496 19.4936 51.3342C20.2013 51.4151 20.9229 51.2422 21.5265 50.8451C21.6133 50.7899 21.7104 50.7605 21.8075 50.7605L21.811 50.7642Z",
                fill: "#E3EDA1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "32",
                height: "32",
                transform: "translate(0 64)",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.1878 81.2487C22.0513 81.2487 21.9183 81.1975 21.816 81.0951C20.2643 79.5429 18.1976 78.6866 16.0012 78.6866C13.8049 78.6866 11.7382 79.5429 10.1865 81.0951C9.98185 81.2998 9.64763 81.2998 9.443 81.0951C9.23838 80.8904 9.23838 80.5561 9.443 80.3514C11.196 78.5979 13.5253 77.6324 16.0012 77.6324C18.4772 77.6324 20.8099 78.5979 22.5629 80.3514C22.7675 80.5561 22.7675 80.8904 22.5629 81.0951C22.4606 81.1975 22.3242 81.2487 22.1912 81.2487",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.8507 83.5753C12.7143 83.5753 12.5813 83.5242 12.479 83.4218C12.2744 83.2171 12.2744 82.8828 12.479 82.6781C14.4229 80.7335 17.5844 80.7335 19.5283 82.6781C19.733 82.8828 19.733 83.2171 19.5283 83.4218C19.3237 83.6265 18.9895 83.6265 18.7849 83.4218C17.2536 81.89 14.7606 81.89 13.2259 83.4218C13.1236 83.5242 12.9871 83.5753 12.8541 83.5753",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.2949 78.5126C25.1585 78.5126 25.0255 78.4614 24.9232 78.3591C22.5393 75.9745 19.371 74.6644 16.0049 74.6644C12.6388 74.6644 9.46714 75.9779 7.08326 78.3591C6.87863 78.5638 6.54441 78.5638 6.33979 78.3591C6.13516 78.1544 6.13516 77.8201 6.33979 77.6154C8.92148 75.0329 12.3524 73.6103 16.0049 73.6103C19.6575 73.6103 23.0884 75.0329 25.6701 77.6154C25.8747 77.8201 25.8747 78.1544 25.6701 78.3591C25.5678 78.4614 25.4313 78.5126 25.2983 78.5126",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.9296 85.4619C16.9296 85.9736 16.5135 86.3898 16.002 86.3898C15.4904 86.3898 15.0743 85.9736 15.0743 85.4619C15.0743 84.9501 15.4904 84.5339 16.002 84.5339C16.5135 84.5339 16.9296 84.9501 16.9296 85.4619Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 97.436C1.06932 97.436 1.37773 97.1146 1.37773 96.718C1.37773 96.3215 1.06932 96 0.688866 96C0.308416 96 0 96.3215 0 96.718C0 97.1146 0.308416 97.436 0.688866 97.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47316 97.436C3.85361 97.436 4.16202 97.1146 4.16202 96.718C4.16202 96.3215 3.85361 96 3.47316 96C3.09271 96 2.78429 96.3215 2.78429 96.718C2.78429 97.1146 3.09271 97.436 3.47316 97.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25715 97.436C6.6376 97.436 6.94602 97.1146 6.94602 96.718C6.94602 96.3215 6.6376 96 6.25715 96C5.8767 96 5.56828 96.3215 5.56828 96.718C5.56828 97.1146 5.8767 97.436 6.25715 97.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04144 97.436C9.42189 97.436 9.73031 97.1146 9.73031 96.718C9.73031 96.3215 9.42189 96 9.04144 96C8.66099 96 8.35257 96.3215 8.35257 96.718C8.35257 97.1146 8.66099 97.436 9.04144 97.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 97.436C12.2024 97.436 12.5108 97.1146 12.5108 96.718C12.5108 96.3215 12.2024 96 11.822 96C11.4415 96 11.1331 96.3215 11.1331 96.718C11.1331 97.1146 11.4415 97.436 11.822 97.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6063 97.436C14.9867 97.436 15.2951 97.1146 15.2951 96.718C15.2951 96.3215 14.9867 96 14.6063 96C14.2258 96 13.9174 96.3215 13.9174 96.718C13.9174 97.1146 14.2258 97.436 14.6063 97.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 97.436C17.7707 97.436 18.0791 97.1146 18.0791 96.718C18.0791 96.3215 17.7707 96 17.3902 96C17.0098 96 16.7014 96.3215 16.7014 96.718C16.7014 97.1146 17.0098 97.436 17.3902 97.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1745 97.436C20.555 97.436 20.8634 97.1146 20.8634 96.718C20.8634 96.3215 20.555 96 20.1745 96C19.7941 96 19.4857 96.3215 19.4857 96.718C19.4857 97.1146 19.7941 97.436 20.1745 97.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 97.436C23.3391 97.436 23.6476 97.1146 23.6476 96.718C23.6476 96.3215 23.3391 96 22.9587 96C22.5782 96 22.2698 96.3215 22.2698 96.718C22.2698 97.1146 22.5782 97.436 22.9587 97.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 97.436C26.1233 97.436 26.4317 97.1146 26.4317 96.718C26.4317 96.3215 26.1233 96 25.7428 96C25.3624 96 25.054 96.3215 25.054 96.718C25.054 97.1146 25.3624 97.436 25.7428 97.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 97.436C28.9074 97.436 29.2158 97.1146 29.2158 96.718C29.2158 96.3215 28.9074 96 28.527 96C28.1465 96 27.8381 96.3215 27.8381 96.718C27.8381 97.1146 28.1465 97.436 28.527 97.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 97.436C31.6916 97.436 32 97.1146 32 96.718C32 96.3215 31.6916 96 31.3111 96C30.9307 96 30.6223 96.3215 30.6223 96.718C30.6223 97.1146 30.9307 97.436 31.3111 97.436Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 100.215C1.06932 100.215 1.37773 99.8932 1.37773 99.4966C1.37773 99.1001 1.06932 98.7786 0.688866 98.7786C0.308416 98.7786 0 99.1001 0 99.4966C0 99.8932 0.308416 100.215 0.688866 100.215Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47316 100.215C3.85361 100.215 4.16202 99.8932 4.16202 99.4966C4.16202 99.1001 3.85361 98.7786 3.47316 98.7786C3.09271 98.7786 2.78429 99.1001 2.78429 99.4966C2.78429 99.8932 3.09271 100.215 3.47316 100.215Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25715 100.215C6.6376 100.215 6.94602 99.8932 6.94602 99.4966C6.94602 99.1001 6.6376 98.7786 6.25715 98.7786C5.8767 98.7786 5.56828 99.1001 5.56828 99.4966C5.56828 99.8932 5.8767 100.215 6.25715 100.215Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04144 100.215C9.42189 100.215 9.73031 99.8932 9.73031 99.4966C9.73031 99.1001 9.42189 98.7786 9.04144 98.7786C8.66099 98.7786 8.35257 99.1001 8.35257 99.4966C8.35257 99.8932 8.66099 100.215 9.04144 100.215Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 100.215C12.2024 100.215 12.5108 99.8932 12.5108 99.4966C12.5108 99.1001 12.2024 98.7786 11.822 98.7786C11.4415 98.7786 11.1331 99.1001 11.1331 99.4966C11.1331 99.8932 11.4415 100.215 11.822 100.215Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6063 100.215C14.9867 100.215 15.2951 99.8932 15.2951 99.4966C15.2951 99.1001 14.9867 98.7786 14.6063 98.7786C14.2258 98.7786 13.9174 99.1001 13.9174 99.4966C13.9174 99.8932 14.2258 100.215 14.6063 100.215Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 100.215C17.7707 100.215 18.0791 99.8932 18.0791 99.4966C18.0791 99.1001 17.7707 98.7786 17.3902 98.7786C17.0098 98.7786 16.7014 99.1001 16.7014 99.4966C16.7014 99.8932 17.0098 100.215 17.3902 100.215Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 100.215C20.5549 100.215 20.8633 99.8932 20.8633 99.4966C20.8633 99.1001 20.5549 98.7786 20.1744 98.7786C19.794 98.7786 19.4855 99.1001 19.4855 99.4966C19.4855 99.8932 19.794 100.215 20.1744 100.215Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 100.215C23.3391 100.215 23.6476 99.8932 23.6476 99.4966C23.6476 99.1001 23.3391 98.7786 22.9587 98.7786C22.5782 98.7786 22.2698 99.1001 22.2698 99.4966C22.2698 99.8932 22.5782 100.215 22.9587 100.215Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 100.215C26.1233 100.215 26.4317 99.8932 26.4317 99.4966C26.4317 99.1001 26.1233 98.7786 25.7428 98.7786C25.3624 98.7786 25.054 99.1001 25.054 99.4966C25.054 99.8932 25.3624 100.215 25.7428 100.215Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 100.215C28.9074 100.215 29.2158 99.8932 29.2158 99.4966C29.2158 99.1001 28.9074 98.7786 28.527 98.7786C28.1465 98.7786 27.8381 99.1001 27.8381 99.4966C27.8381 99.8932 28.1465 100.215 28.527 100.215Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 100.215C31.6916 100.215 32 99.8932 32 99.4966C32 99.1001 31.6916 98.7786 31.3111 98.7786C30.9307 98.7786 30.6223 99.1001 30.6223 99.4966C30.6223 99.8932 30.9307 100.215 31.3111 100.215Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 102.993C1.06932 102.993 1.37773 102.672 1.37773 102.275C1.37773 101.879 1.06932 101.557 0.688866 101.557C0.308416 101.557 0 101.879 0 102.275C0 102.672 0.308416 102.993 0.688866 102.993Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47316 102.993C3.85361 102.993 4.16202 102.672 4.16202 102.275C4.16202 101.879 3.85361 101.557 3.47316 101.557C3.09271 101.557 2.78429 101.879 2.78429 102.275C2.78429 102.672 3.09271 102.993 3.47316 102.993Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25715 102.993C6.6376 102.993 6.94602 102.672 6.94602 102.275C6.94602 101.879 6.6376 101.557 6.25715 101.557C5.8767 101.557 5.56828 101.879 5.56828 102.275C5.56828 102.672 5.8767 102.993 6.25715 102.993Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04144 102.993C9.42189 102.993 9.73031 102.672 9.73031 102.275C9.73031 101.879 9.42189 101.557 9.04144 101.557C8.66099 101.557 8.35257 101.879 8.35257 102.275C8.35257 102.672 8.66099 102.993 9.04144 102.993Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 102.993C12.2024 102.993 12.5108 102.672 12.5108 102.275C12.5108 101.879 12.2024 101.557 11.822 101.557C11.4415 101.557 11.1331 101.879 11.1331 102.275C11.1331 102.672 11.4415 102.993 11.822 102.993Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6063 102.993C14.9867 102.993 15.2951 102.672 15.2951 102.275C15.2951 101.879 14.9867 101.557 14.6063 101.557C14.2258 101.557 13.9174 101.879 13.9174 102.275C13.9174 102.672 14.2258 102.993 14.6063 102.993Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 102.993C17.7707 102.993 18.0791 102.672 18.0791 102.275C18.0791 101.879 17.7707 101.557 17.3902 101.557C17.0098 101.557 16.7014 101.879 16.7014 102.275C16.7014 102.672 17.0098 102.993 17.3902 102.993Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 102.993C20.5549 102.993 20.8633 102.672 20.8633 102.275C20.8633 101.879 20.5549 101.557 20.1744 101.557C19.794 101.557 19.4855 101.879 19.4855 102.275C19.4855 102.672 19.794 102.993 20.1744 102.993Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 102.993C23.3391 102.993 23.6476 102.672 23.6476 102.275C23.6476 101.879 23.3391 101.557 22.9587 101.557C22.5782 101.557 22.2698 101.879 22.2698 102.275C22.2698 102.672 22.5782 102.993 22.9587 102.993Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 102.993C26.1233 102.993 26.4317 102.672 26.4317 102.275C26.4317 101.879 26.1233 101.557 25.7428 101.557C25.3624 101.557 25.054 101.879 25.054 102.275C25.054 102.672 25.3624 102.993 25.7428 102.993Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 102.993C28.9074 102.993 29.2158 102.672 29.2158 102.275C29.2158 101.879 28.9074 101.557 28.527 101.557C28.1465 101.557 27.8381 101.879 27.8381 102.275C27.8381 102.672 28.1465 102.993 28.527 102.993Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 102.993C31.6916 102.993 32 102.672 32 102.275C32 101.879 31.6916 101.557 31.3111 101.557C30.9307 101.557 30.6223 101.879 30.6223 102.275C30.6223 102.672 30.9307 102.993 31.3111 102.993Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 105.772C1.06932 105.772 1.37773 105.45 1.37773 105.054C1.37773 104.657 1.06932 104.336 0.688866 104.336C0.308416 104.336 0 104.657 0 105.054C0 105.45 0.308416 105.772 0.688866 105.772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47316 105.772C3.85361 105.772 4.16202 105.45 4.16202 105.054C4.16202 104.657 3.85361 104.336 3.47316 104.336C3.09271 104.336 2.78429 104.657 2.78429 105.054C2.78429 105.45 3.09271 105.772 3.47316 105.772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25715 105.772C6.6376 105.772 6.94602 105.45 6.94602 105.054C6.94602 104.657 6.6376 104.336 6.25715 104.336C5.8767 104.336 5.56828 104.657 5.56828 105.054C5.56828 105.45 5.8767 105.772 6.25715 105.772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04144 105.772C9.42189 105.772 9.73031 105.45 9.73031 105.054C9.73031 104.657 9.42189 104.336 9.04144 104.336C8.66099 104.336 8.35257 104.657 8.35257 105.054C8.35257 105.45 8.66099 105.772 9.04144 105.772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 105.772C12.2024 105.772 12.5108 105.45 12.5108 105.054C12.5108 104.657 12.2024 104.336 11.822 104.336C11.4415 104.336 11.1331 104.657 11.1331 105.054C11.1331 105.45 11.4415 105.772 11.822 105.772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6063 105.772C14.9867 105.772 15.2951 105.45 15.2951 105.054C15.2951 104.657 14.9867 104.336 14.6063 104.336C14.2258 104.336 13.9174 104.657 13.9174 105.054C13.9174 105.45 14.2258 105.772 14.6063 105.772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 105.772C17.7707 105.772 18.0791 105.45 18.0791 105.054C18.0791 104.657 17.7707 104.336 17.3902 104.336C17.0098 104.336 16.7014 104.657 16.7014 105.054C16.7014 105.45 17.0098 105.772 17.3902 105.772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 105.772C20.5549 105.772 20.8633 105.45 20.8633 105.054C20.8633 104.657 20.5549 104.336 20.1744 104.336C19.794 104.336 19.4855 104.657 19.4855 105.054C19.4855 105.45 19.794 105.772 20.1744 105.772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 105.772C23.3391 105.772 23.6476 105.45 23.6476 105.054C23.6476 104.657 23.3391 104.336 22.9587 104.336C22.5782 104.336 22.2698 104.657 22.2698 105.054C22.2698 105.45 22.5782 105.772 22.9587 105.772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 105.772C26.1233 105.772 26.4317 105.45 26.4317 105.054C26.4317 104.657 26.1233 104.336 25.7428 104.336C25.3624 104.336 25.054 104.657 25.054 105.054C25.054 105.45 25.3624 105.772 25.7428 105.772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 105.772C28.9074 105.772 29.2158 105.45 29.2158 105.054C29.2158 104.657 28.9074 104.336 28.527 104.336C28.1465 104.336 27.8381 104.657 27.8381 105.054C27.8381 105.45 28.1465 105.772 28.527 105.772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 105.772C31.6916 105.772 32 105.45 32 105.054C32 104.657 31.6916 104.336 31.3111 104.336C30.9307 104.336 30.6223 104.657 30.6223 105.054C30.6223 105.45 30.9307 105.772 31.3111 105.772Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 108.55C1.06932 108.55 1.37773 108.229 1.37773 107.832C1.37773 107.436 1.06932 107.114 0.688866 107.114C0.308416 107.114 0 107.436 0 107.832C0 108.229 0.308416 108.55 0.688866 108.55Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47316 108.55C3.85361 108.55 4.16202 108.229 4.16202 107.832C4.16202 107.436 3.85361 107.114 3.47316 107.114C3.09271 107.114 2.78429 107.436 2.78429 107.832C2.78429 108.229 3.09271 108.55 3.47316 108.55Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25715 108.55C6.6376 108.55 6.94602 108.229 6.94602 107.832C6.94602 107.436 6.6376 107.114 6.25715 107.114C5.8767 107.114 5.56828 107.436 5.56828 107.832C5.56828 108.229 5.8767 108.55 6.25715 108.55Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04144 108.55C9.42189 108.55 9.73031 108.229 9.73031 107.832C9.73031 107.436 9.42189 107.114 9.04144 107.114C8.66099 107.114 8.35257 107.436 8.35257 107.832C8.35257 108.229 8.66099 108.55 9.04144 108.55Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 108.55C12.2024 108.55 12.5108 108.229 12.5108 107.832C12.5108 107.436 12.2024 107.114 11.822 107.114C11.4415 107.114 11.1331 107.436 11.1331 107.832C11.1331 108.229 11.4415 108.55 11.822 108.55Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6063 108.55C14.9867 108.55 15.2951 108.229 15.2951 107.832C15.2951 107.436 14.9867 107.114 14.6063 107.114C14.2258 107.114 13.9174 107.436 13.9174 107.832C13.9174 108.229 14.2258 108.55 14.6063 108.55Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 108.55C17.7707 108.55 18.0791 108.229 18.0791 107.832C18.0791 107.436 17.7707 107.114 17.3902 107.114C17.0098 107.114 16.7014 107.436 16.7014 107.832C16.7014 108.229 17.0098 108.55 17.3902 108.55Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 108.55C20.5549 108.55 20.8633 108.229 20.8633 107.832C20.8633 107.436 20.5549 107.114 20.1744 107.114C19.794 107.114 19.4855 107.436 19.4855 107.832C19.4855 108.229 19.794 108.55 20.1744 108.55Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 108.55C23.3391 108.55 23.6476 108.229 23.6476 107.832C23.6476 107.436 23.3391 107.114 22.9587 107.114C22.5782 107.114 22.2698 107.436 22.2698 107.832C22.2698 108.229 22.5782 108.55 22.9587 108.55Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 108.55C26.1233 108.55 26.4317 108.229 26.4317 107.832C26.4317 107.436 26.1233 107.114 25.7428 107.114C25.3624 107.114 25.054 107.436 25.054 107.832C25.054 108.229 25.3624 108.55 25.7428 108.55Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 108.55C28.9074 108.55 29.2158 108.229 29.2158 107.832C29.2158 107.436 28.9074 107.114 28.527 107.114C28.1465 107.114 27.8381 107.436 27.8381 107.832C27.8381 108.229 28.1465 108.55 28.527 108.55Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 108.55C31.6916 108.55 32 108.229 32 107.832C32 107.436 31.6916 107.114 31.3111 107.114C30.9307 107.114 30.6223 107.436 30.6223 107.832C30.6223 108.229 30.9307 108.55 31.3111 108.55Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 111.329C1.06932 111.329 1.37773 111.007 1.37773 110.61C1.37773 110.214 1.06932 109.892 0.688866 109.892C0.308416 109.892 0 110.214 0 110.61C0 111.007 0.308416 111.329 0.688866 111.329Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47316 111.329C3.85361 111.329 4.16202 111.007 4.16202 110.61C4.16202 110.214 3.85361 109.892 3.47316 109.892C3.09271 109.892 2.78429 110.214 2.78429 110.61C2.78429 111.007 3.09271 111.329 3.47316 111.329Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25715 111.329C6.6376 111.329 6.94602 111.007 6.94602 110.61C6.94602 110.214 6.6376 109.892 6.25715 109.892C5.8767 109.892 5.56828 110.214 5.56828 110.61C5.56828 111.007 5.8767 111.329 6.25715 111.329Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04144 111.329C9.42189 111.329 9.73031 111.007 9.73031 110.61C9.73031 110.214 9.42189 109.892 9.04144 109.892C8.66099 109.892 8.35257 110.214 8.35257 110.61C8.35257 111.007 8.66099 111.329 9.04144 111.329Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 111.329C12.2024 111.329 12.5108 111.007 12.5108 110.61C12.5108 110.214 12.2024 109.892 11.822 109.892C11.4415 109.892 11.1331 110.214 11.1331 110.61C11.1331 111.007 11.4415 111.329 11.822 111.329Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6063 111.329C14.9867 111.329 15.2951 111.007 15.2951 110.61C15.2951 110.214 14.9867 109.892 14.6063 109.892C14.2258 109.892 13.9174 110.214 13.9174 110.61C13.9174 111.007 14.2258 111.329 14.6063 111.329Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 111.329C17.7707 111.329 18.0791 111.007 18.0791 110.61C18.0791 110.214 17.7707 109.892 17.3902 109.892C17.0098 109.892 16.7014 110.214 16.7014 110.61C16.7014 111.007 17.0098 111.329 17.3902 111.329Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 111.329C20.5549 111.329 20.8633 111.007 20.8633 110.61C20.8633 110.214 20.5549 109.892 20.1744 109.892C19.794 109.892 19.4855 110.214 19.4855 110.61C19.4855 111.007 19.794 111.329 20.1744 111.329Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 111.329C23.3391 111.329 23.6476 111.007 23.6476 110.61C23.6476 110.214 23.3391 109.892 22.9587 109.892C22.5782 109.892 22.2698 110.214 22.2698 110.61C22.2698 111.007 22.5782 111.329 22.9587 111.329Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 111.329C26.1233 111.329 26.4317 111.007 26.4317 110.61C26.4317 110.214 26.1233 109.892 25.7428 109.892C25.3624 109.892 25.054 110.214 25.054 110.61C25.054 111.007 25.3624 111.329 25.7428 111.329Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 111.329C28.9074 111.329 29.2158 111.007 29.2158 110.61C29.2158 110.214 28.9074 109.892 28.527 109.892C28.1465 109.892 27.8381 110.214 27.8381 110.61C27.8381 111.007 28.1465 111.329 28.527 111.329Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 111.329C31.6916 111.329 32 111.007 32 110.61C32 110.214 31.6916 109.892 31.3111 109.892C30.9307 109.892 30.6223 110.214 30.6223 110.61C30.6223 111.007 30.9307 111.329 31.3111 111.329Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 114.107C1.06932 114.107 1.37773 113.786 1.37773 113.389C1.37773 112.993 1.06932 112.671 0.688866 112.671C0.308416 112.671 0 112.993 0 113.389C0 113.786 0.308416 114.107 0.688866 114.107Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47316 114.107C3.85361 114.107 4.16202 113.786 4.16202 113.389C4.16202 112.993 3.85361 112.671 3.47316 112.671C3.09271 112.671 2.78429 112.993 2.78429 113.389C2.78429 113.786 3.09271 114.107 3.47316 114.107Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25715 114.107C6.6376 114.107 6.94602 113.786 6.94602 113.389C6.94602 112.993 6.6376 112.671 6.25715 112.671C5.8767 112.671 5.56828 112.993 5.56828 113.389C5.56828 113.786 5.8767 114.107 6.25715 114.107Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04144 114.107C9.42189 114.107 9.73031 113.786 9.73031 113.389C9.73031 112.993 9.42189 112.671 9.04144 112.671C8.66099 112.671 8.35257 112.993 8.35257 113.389C8.35257 113.786 8.66099 114.107 9.04144 114.107Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 114.107C12.2024 114.107 12.5108 113.786 12.5108 113.389C12.5108 112.993 12.2024 112.671 11.822 112.671C11.4415 112.671 11.1331 112.993 11.1331 113.389C11.1331 113.786 11.4415 114.107 11.822 114.107Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6063 114.107C14.9867 114.107 15.2951 113.786 15.2951 113.389C15.2951 112.993 14.9867 112.671 14.6063 112.671C14.2258 112.671 13.9174 112.993 13.9174 113.389C13.9174 113.786 14.2258 114.107 14.6063 114.107Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 114.107C17.7707 114.107 18.0791 113.786 18.0791 113.389C18.0791 112.993 17.7707 112.671 17.3902 112.671C17.0098 112.671 16.7014 112.993 16.7014 113.389C16.7014 113.786 17.0098 114.107 17.3902 114.107Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 114.107C20.5549 114.107 20.8633 113.786 20.8633 113.389C20.8633 112.993 20.5549 112.671 20.1744 112.671C19.794 112.671 19.4855 112.993 19.4855 113.389C19.4855 113.786 19.794 114.107 20.1744 114.107Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 114.107C23.3391 114.107 23.6476 113.786 23.6476 113.389C23.6476 112.993 23.3391 112.671 22.9587 112.671C22.5782 112.671 22.2698 112.993 22.2698 113.389C22.2698 113.786 22.5782 114.107 22.9587 114.107Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 114.107C26.1233 114.107 26.4317 113.786 26.4317 113.389C26.4317 112.993 26.1233 112.671 25.7428 112.671C25.3624 112.671 25.054 112.993 25.054 113.389C25.054 113.786 25.3624 114.107 25.7428 114.107Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 114.107C28.9074 114.107 29.2158 113.786 29.2158 113.389C29.2158 112.993 28.9074 112.671 28.527 112.671C28.1465 112.671 27.8381 112.993 27.8381 113.389C27.8381 113.786 28.1465 114.107 28.527 114.107Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 114.107C31.6916 114.107 32 113.786 32 113.389C32 112.993 31.6916 112.671 31.3111 112.671C30.9307 112.671 30.6223 112.993 30.6223 113.389C30.6223 113.786 30.9307 114.107 31.3111 114.107Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 116.886C1.06932 116.886 1.37773 116.564 1.37773 116.168C1.37773 115.771 1.06932 115.45 0.688866 115.45C0.308416 115.45 0 115.771 0 116.168C0 116.564 0.308416 116.886 0.688866 116.886Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47316 116.886C3.85361 116.886 4.16202 116.564 4.16202 116.168C4.16202 115.771 3.85361 115.45 3.47316 115.45C3.09271 115.45 2.78429 115.771 2.78429 116.168C2.78429 116.564 3.09271 116.886 3.47316 116.886Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25715 116.886C6.6376 116.886 6.94602 116.564 6.94602 116.168C6.94602 115.771 6.6376 115.45 6.25715 115.45C5.8767 115.45 5.56828 115.771 5.56828 116.168C5.56828 116.564 5.8767 116.886 6.25715 116.886Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04144 116.886C9.42189 116.886 9.73031 116.564 9.73031 116.168C9.73031 115.771 9.42189 115.45 9.04144 115.45C8.66099 115.45 8.35257 115.771 8.35257 116.168C8.35257 116.564 8.66099 116.886 9.04144 116.886Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 116.886C12.2024 116.886 12.5108 116.564 12.5108 116.168C12.5108 115.771 12.2024 115.45 11.822 115.45C11.4415 115.45 11.1331 115.771 11.1331 116.168C11.1331 116.564 11.4415 116.886 11.822 116.886Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6063 116.886C14.9867 116.886 15.2951 116.564 15.2951 116.168C15.2951 115.771 14.9867 115.45 14.6063 115.45C14.2258 115.45 13.9174 115.771 13.9174 116.168C13.9174 116.564 14.2258 116.886 14.6063 116.886Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 116.886C17.7707 116.886 18.0791 116.564 18.0791 116.168C18.0791 115.771 17.7707 115.45 17.3902 115.45C17.0098 115.45 16.7014 115.771 16.7014 116.168C16.7014 116.564 17.0098 116.886 17.3902 116.886Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 116.886C20.5549 116.886 20.8633 116.564 20.8633 116.168C20.8633 115.771 20.5549 115.45 20.1744 115.45C19.794 115.45 19.4855 115.771 19.4855 116.168C19.4855 116.564 19.794 116.886 20.1744 116.886Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 116.886C23.3391 116.886 23.6476 116.564 23.6476 116.168C23.6476 115.771 23.3391 115.45 22.9587 115.45C22.5782 115.45 22.2698 115.771 22.2698 116.168C22.2698 116.564 22.5782 116.886 22.9587 116.886Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 116.886C26.1233 116.886 26.4317 116.564 26.4317 116.168C26.4317 115.771 26.1233 115.45 25.7428 115.45C25.3624 115.45 25.054 115.771 25.054 116.168C25.054 116.564 25.3624 116.886 25.7428 116.886Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 116.886C28.9074 116.886 29.2158 116.564 29.2158 116.168C29.2158 115.771 28.9074 115.45 28.527 115.45C28.1465 115.45 27.8381 115.771 27.8381 116.168C27.8381 116.564 28.1465 116.886 28.527 116.886Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 116.886C31.6916 116.886 32 116.564 32 116.168C32 115.771 31.6916 115.45 31.3111 115.45C30.9307 115.45 30.6223 115.771 30.6223 116.168C30.6223 116.564 30.9307 116.886 31.3111 116.886Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 119.664C1.06932 119.664 1.37773 119.343 1.37773 118.946C1.37773 118.55 1.06932 118.228 0.688866 118.228C0.308416 118.228 0 118.55 0 118.946C0 119.343 0.308416 119.664 0.688866 119.664Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47316 119.664C3.85361 119.664 4.16202 119.343 4.16202 118.946C4.16202 118.55 3.85361 118.228 3.47316 118.228C3.09271 118.228 2.78429 118.55 2.78429 118.946C2.78429 119.343 3.09271 119.664 3.47316 119.664Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25715 119.664C6.6376 119.664 6.94602 119.343 6.94602 118.946C6.94602 118.55 6.6376 118.228 6.25715 118.228C5.8767 118.228 5.56828 118.55 5.56828 118.946C5.56828 119.343 5.8767 119.664 6.25715 119.664Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04144 119.664C9.42189 119.664 9.73031 119.343 9.73031 118.946C9.73031 118.55 9.42189 118.228 9.04144 118.228C8.66099 118.228 8.35257 118.55 8.35257 118.946C8.35257 119.343 8.66099 119.664 9.04144 119.664Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 119.664C12.2024 119.664 12.5108 119.343 12.5108 118.946C12.5108 118.55 12.2024 118.228 11.822 118.228C11.4415 118.228 11.1331 118.55 11.1331 118.946C11.1331 119.343 11.4415 119.664 11.822 119.664Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6063 119.664C14.9867 119.664 15.2951 119.343 15.2951 118.946C15.2951 118.55 14.9867 118.228 14.6063 118.228C14.2258 118.228 13.9174 118.55 13.9174 118.946C13.9174 119.343 14.2258 119.664 14.6063 119.664Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 119.664C17.7707 119.664 18.0791 119.343 18.0791 118.946C18.0791 118.55 17.7707 118.228 17.3902 118.228C17.0098 118.228 16.7014 118.55 16.7014 118.946C16.7014 119.343 17.0098 119.664 17.3902 119.664Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 119.664C20.5549 119.664 20.8633 119.343 20.8633 118.946C20.8633 118.55 20.5549 118.228 20.1744 118.228C19.794 118.228 19.4855 118.55 19.4855 118.946C19.4855 119.343 19.794 119.664 20.1744 119.664Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 119.664C23.3391 119.664 23.6476 119.343 23.6476 118.946C23.6476 118.55 23.3391 118.228 22.9587 118.228C22.5782 118.228 22.2698 118.55 22.2698 118.946C22.2698 119.343 22.5782 119.664 22.9587 119.664Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 119.664C26.1233 119.664 26.4317 119.343 26.4317 118.946C26.4317 118.55 26.1233 118.228 25.7428 118.228C25.3624 118.228 25.054 118.55 25.054 118.946C25.054 119.343 25.3624 119.664 25.7428 119.664Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 119.664C28.9074 119.664 29.2158 119.343 29.2158 118.946C29.2158 118.55 28.9074 118.228 28.527 118.228C28.1465 118.228 27.8381 118.55 27.8381 118.946C27.8381 119.343 28.1465 119.664 28.527 119.664Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 119.664C31.6916 119.664 32 119.343 32 118.946C32 118.55 31.6916 118.228 31.3111 118.228C30.9307 118.228 30.6223 118.55 30.6223 118.946C30.6223 119.343 30.9307 119.664 31.3111 119.664Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 122.443C1.06932 122.443 1.37773 122.122 1.37773 121.725C1.37773 121.329 1.06932 121.007 0.688866 121.007C0.308416 121.007 0 121.329 0 121.725C0 122.122 0.308416 122.443 0.688866 122.443Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47316 122.443C3.85361 122.443 4.16202 122.122 4.16202 121.725C4.16202 121.329 3.85361 121.007 3.47316 121.007C3.09271 121.007 2.78429 121.329 2.78429 121.725C2.78429 122.122 3.09271 122.443 3.47316 122.443Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25715 122.443C6.6376 122.443 6.94602 122.122 6.94602 121.725C6.94602 121.329 6.6376 121.007 6.25715 121.007C5.8767 121.007 5.56828 121.329 5.56828 121.725C5.56828 122.122 5.8767 122.443 6.25715 122.443Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04144 122.443C9.42189 122.443 9.73031 122.122 9.73031 121.725C9.73031 121.329 9.42189 121.007 9.04144 121.007C8.66099 121.007 8.35257 121.329 8.35257 121.725C8.35257 122.122 8.66099 122.443 9.04144 122.443Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 122.443C12.2024 122.443 12.5108 122.122 12.5108 121.725C12.5108 121.329 12.2024 121.007 11.822 121.007C11.4415 121.007 11.1331 121.329 11.1331 121.725C11.1331 122.122 11.4415 122.443 11.822 122.443Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6063 122.443C14.9867 122.443 15.2951 122.122 15.2951 121.725C15.2951 121.329 14.9867 121.007 14.6063 121.007C14.2258 121.007 13.9174 121.329 13.9174 121.725C13.9174 122.122 14.2258 122.443 14.6063 122.443Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 122.443C17.7707 122.443 18.0791 122.122 18.0791 121.725C18.0791 121.329 17.7707 121.007 17.3902 121.007C17.0098 121.007 16.7014 121.329 16.7014 121.725C16.7014 122.122 17.0098 122.443 17.3902 122.443Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 122.443C20.5549 122.443 20.8633 122.122 20.8633 121.725C20.8633 121.329 20.5549 121.007 20.1744 121.007C19.794 121.007 19.4855 121.329 19.4855 121.725C19.4855 122.122 19.794 122.443 20.1744 122.443Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 122.443C23.3391 122.443 23.6476 122.122 23.6476 121.725C23.6476 121.329 23.3391 121.007 22.9587 121.007C22.5782 121.007 22.2698 121.329 22.2698 121.725C22.2698 122.122 22.5782 122.443 22.9587 122.443Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 122.443C26.1233 122.443 26.4317 122.122 26.4317 121.725C26.4317 121.329 26.1233 121.007 25.7428 121.007C25.3624 121.007 25.054 121.329 25.054 121.725C25.054 122.122 25.3624 122.443 25.7428 122.443Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 122.443C28.9074 122.443 29.2158 122.122 29.2158 121.725C29.2158 121.329 28.9074 121.007 28.527 121.007C28.1465 121.007 27.8381 121.329 27.8381 121.725C27.8381 122.122 28.1465 122.443 28.527 122.443Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 122.443C31.6916 122.443 32 122.122 32 121.725C32 121.329 31.6916 121.007 31.3111 121.007C30.9307 121.007 30.6223 121.329 30.6223 121.725C30.6223 122.122 30.9307 122.443 31.3111 122.443Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 125.221C1.06932 125.221 1.37773 124.9 1.37773 124.503C1.37773 124.107 1.06932 123.785 0.688866 123.785C0.308416 123.785 0 124.107 0 124.503C0 124.9 0.308416 125.221 0.688866 125.221Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47316 125.221C3.85361 125.221 4.16202 124.9 4.16202 124.503C4.16202 124.107 3.85361 123.785 3.47316 123.785C3.09271 123.785 2.78429 124.107 2.78429 124.503C2.78429 124.9 3.09271 125.221 3.47316 125.221Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25715 125.221C6.6376 125.221 6.94602 124.9 6.94602 124.503C6.94602 124.107 6.6376 123.785 6.25715 123.785C5.8767 123.785 5.56828 124.107 5.56828 124.503C5.56828 124.9 5.8767 125.221 6.25715 125.221Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04144 125.221C9.42189 125.221 9.73031 124.9 9.73031 124.503C9.73031 124.107 9.42189 123.785 9.04144 123.785C8.66099 123.785 8.35257 124.107 8.35257 124.503C8.35257 124.9 8.66099 125.221 9.04144 125.221Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 125.221C12.2024 125.221 12.5108 124.9 12.5108 124.503C12.5108 124.107 12.2024 123.785 11.822 123.785C11.4415 123.785 11.1331 124.107 11.1331 124.503C11.1331 124.9 11.4415 125.221 11.822 125.221Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6063 125.221C14.9867 125.221 15.2951 124.9 15.2951 124.503C15.2951 124.107 14.9867 123.785 14.6063 123.785C14.2258 123.785 13.9174 124.107 13.9174 124.503C13.9174 124.9 14.2258 125.221 14.6063 125.221Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 125.221C17.7707 125.221 18.0791 124.9 18.0791 124.503C18.0791 124.107 17.7707 123.785 17.3902 123.785C17.0098 123.785 16.7014 124.107 16.7014 124.503C16.7014 124.9 17.0098 125.221 17.3902 125.221Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 125.221C20.5549 125.221 20.8633 124.9 20.8633 124.503C20.8633 124.107 20.5549 123.785 20.1744 123.785C19.794 123.785 19.4855 124.107 19.4855 124.503C19.4855 124.9 19.794 125.221 20.1744 125.221Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 125.221C23.3391 125.221 23.6476 124.9 23.6476 124.503C23.6476 124.107 23.3391 123.785 22.9587 123.785C22.5782 123.785 22.2698 124.107 22.2698 124.503C22.2698 124.9 22.5782 125.221 22.9587 125.221Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 125.221C26.1233 125.221 26.4317 124.9 26.4317 124.503C26.4317 124.107 26.1233 123.785 25.7428 123.785C25.3624 123.785 25.054 124.107 25.054 124.503C25.054 124.9 25.3624 125.221 25.7428 125.221Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 125.221C28.9074 125.221 29.2158 124.9 29.2158 124.503C29.2158 124.107 28.9074 123.785 28.527 123.785C28.1465 123.785 27.8381 124.107 27.8381 124.503C27.8381 124.9 28.1465 125.221 28.527 125.221Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 125.221C31.6916 125.221 32 124.9 32 124.503C32 124.107 31.6916 123.785 31.3111 123.785C30.9307 123.785 30.6223 124.107 30.6223 124.503C30.6223 124.9 30.9307 125.221 31.3111 125.221Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.688866 128C1.06932 128 1.37773 127.679 1.37773 127.282C1.37773 126.886 1.06932 126.564 0.688866 126.564C0.308416 126.564 0 126.886 0 127.282C0 127.679 0.308416 128 0.688866 128Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.47316 128C3.85361 128 4.16202 127.679 4.16202 127.282C4.16202 126.886 3.85361 126.564 3.47316 126.564C3.09271 126.564 2.78429 126.886 2.78429 127.282C2.78429 127.679 3.09271 128 3.47316 128Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25715 128C6.6376 128 6.94602 127.679 6.94602 127.282C6.94602 126.886 6.6376 126.564 6.25715 126.564C5.8767 126.564 5.56828 126.886 5.56828 127.282C5.56828 127.679 5.8767 128 6.25715 128Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04144 128C9.42189 128 9.73031 127.679 9.73031 127.282C9.73031 126.886 9.42189 126.564 9.04144 126.564C8.66099 126.564 8.35257 126.886 8.35257 127.282C8.35257 127.679 8.66099 128 9.04144 128Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.822 128C12.2024 128 12.5108 127.679 12.5108 127.282C12.5108 126.886 12.2024 126.564 11.822 126.564C11.4415 126.564 11.1331 126.886 11.1331 127.282C11.1331 127.679 11.4415 128 11.822 128Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.6063 128C14.9867 128 15.2951 127.679 15.2951 127.282C15.2951 126.886 14.9867 126.564 14.6063 126.564C14.2258 126.564 13.9174 126.886 13.9174 127.282C13.9174 127.679 14.2258 128 14.6063 128Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3902 128C17.7707 128 18.0791 127.679 18.0791 127.282C18.0791 126.886 17.7707 126.564 17.3902 126.564C17.0098 126.564 16.7014 126.886 16.7014 127.282C16.7014 127.679 17.0098 128 17.3902 128Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1744 128C20.5549 128 20.8633 127.679 20.8633 127.282C20.8633 126.886 20.5549 126.564 20.1744 126.564C19.794 126.564 19.4855 126.886 19.4855 127.282C19.4855 127.679 19.794 128 20.1744 128Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9587 128C23.3391 128 23.6476 127.679 23.6476 127.282C23.6476 126.886 23.3391 126.564 22.9587 126.564C22.5782 126.564 22.2698 126.886 22.2698 127.282C22.2698 127.679 22.5782 128 22.9587 128Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.7428 128C26.1233 128 26.4317 127.679 26.4317 127.282C26.4317 126.886 26.1233 126.564 25.7428 126.564C25.3624 126.564 25.054 126.886 25.054 127.282C25.054 127.679 25.3624 128 25.7428 128Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.527 128C28.9074 128 29.2158 127.679 29.2158 127.282C29.2158 126.886 28.9074 126.564 28.527 126.564C28.1465 126.564 27.8381 126.886 27.8381 127.282C27.8381 127.679 28.1465 128 28.527 128Z",
                fill: "#E5E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.3111 128C31.6916 128 32 127.679 32 127.282C32 126.886 31.6916 126.564 31.3111 126.564C30.9307 126.564 30.6223 126.886 30.6223 127.282C30.6223 127.679 30.9307 128 31.3111 128Z",
                fill: "#E5E6E6"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/Icons/index.tsx














































































































































































































































































































var mappedIcons = function(title, iconProps, multipleColorsIconProps) {
    var iconsTable = {
        arrowDown: ArrowDown(iconProps),
        arrowDownSolid: ArrowDownSolid(iconProps),
        arrowUp: ArrowUp(iconProps),
        defaultProduct: DefaultProductImage(iconProps),
        arrowLeft: ArrowLeft(iconProps),
        arrowRight: ArrowRight(iconProps),
        bin: Bin(iconProps),
        phone: Phone(iconProps),
        headPhone: HeadPhone(iconProps),
        share: Share(iconProps),
        facebook: Facebook(iconProps),
        instagram: Instagram(iconProps),
        spotify: Spotify(iconProps),
        linkedIn: LinkedIn(iconProps),
        store: Store(iconProps),
        imageCardVirtualMyCards: ImageCardVirtualMyCards(iconProps),
        settings: Settings(iconProps),
        apple: Apple(iconProps),
        google: Google(iconProps),
        search: Search(iconProps),
        lock: Lock(iconProps),
        question: Question(iconProps),
        coinPig: Coinpig(iconProps),
        creditCard: CreditCard(iconProps),
        gift: Gift(iconProps),
        close: Close(iconProps),
        user: UserIcon(iconProps),
        dollarCircle: DollarCircle(iconProps),
        eyeOpen: EyeOpen(iconProps),
        eyeClose: EyeClose(iconProps),
        interrogation: Interrogation(iconProps),
        alert: Alert(iconProps),
        filter: Filter(iconProps),
        bag: Bag(iconProps),
        house: House(iconProps),
        cart: Cart(iconProps),
        card: Card(iconProps),
        alertWithStroke: AlertWithStroke(iconProps),
        checkDone: CheckDone(iconProps),
        whatsApp: WhatsApp(iconProps),
        home: Home(iconProps),
        percentageDiscount: PercentageDiscount(iconProps),
        saleTagIcon: SaleTagIcon(iconProps),
        myListThumbsUp: MyListThumbsUp(iconProps),
        myListFingerPoiting: MyListFingerPoiting(iconProps),
        myListFingerOnPhone: MyListFingerOnPhone(iconProps),
        pencil: Pencil(iconProps),
        giftIconActivityHistory: GiftIconActivityHistory(iconProps),
        clock: Clock(iconProps),
        unavailable: UnavailableIcon(iconProps),
        geometricBox: GeometricBoxIcon(iconProps),
        validIcon: ValidIcon(iconProps),
        warningIcon: WarningIcon(iconProps),
        phoneCallIcon: PhoneCallIcon(iconProps),
        atEmailIcon: AtEmailIcon(iconProps),
        youtube: YoutubeIcon(multipleColorsIconProps),
        pinterest: PinterestIcon(multipleColorsIconProps),
        pickupStore: PickupStore(iconProps),
        pinLocationOutline: PinLocationOutline(iconProps),
        calendarOutlineIcon: CalendarOutlineIcon(iconProps),
        infoOutlineIcon: InfoOutlineIcon(iconProps),
        giftOutlineIcon: GiftOutlineIcon(iconProps),
        cartOutlineIcon: CartOutlineIcon(iconProps)
    };
    return iconsTable["".concat(title)] || null;
};


/***/ }),

/***/ 26365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Accordion": function() { return /* reexport */ Accordion; },
  "AccountDeletionIcon": function() { return /* reexport */ Icons/* AccountDeletionIcon */.wc$; },
  "AddCard": function() { return /* reexport */ Icons/* AddCard */.GST; },
  "AddNewEnvironment": function() { return /* reexport */ Icons/* AddNewEnvironment */.Boy; },
  "AddressListIcon": function() { return /* reexport */ Icons/* AddressListIcon */.YSu; },
  "Aggregator": function() { return /* reexport */ Aggregator; },
  "Alert": function() { return /* reexport */ Icons/* Alert */.bZj; },
  "AlertWithDetail": function() { return /* reexport */ Icons/* AlertWithDetail */.kb0; },
  "AlertWithStroke": function() { return /* reexport */ Icons/* AlertWithStroke */.Wg4; },
  "Alliances": function() { return /* reexport */ Icons/* Alliances */.Xvm; },
  "Amex": function() { return /* reexport */ Icons/* Amex */.iqj; },
  "AppAuthenticationIcon": function() { return /* reexport */ Icons/* AppAuthenticationIcon */.PK3; },
  "AppFcIcon": function() { return /* reexport */ Icons/* AppFcIcon */.KGf; },
  "Apple": function() { return /* reexport */ Icons/* Apple */.ACs; },
  "ArrowCarouselLeft": function() { return /* reexport */ Icons/* ArrowCarouselLeft */.HiE; },
  "ArrowCarouselRight": function() { return /* reexport */ Icons/* ArrowCarouselRight */.aYg; },
  "ArrowDown": function() { return /* reexport */ Icons/* ArrowDown */.K5e; },
  "ArrowDownCircle": function() { return /* reexport */ Icons/* ArrowDownCircle */.oHn; },
  "ArrowDownSolid": function() { return /* reexport */ Icons/* ArrowDownSolid */.obG; },
  "ArrowFilledDown": function() { return /* reexport */ Icons/* ArrowFilledDown */.SDF; },
  "ArrowLeft": function() { return /* reexport */ Icons/* ArrowLeft */.XdH; },
  "ArrowLeftCategoriesIcon": function() { return /* reexport */ Icons/* ArrowLeftCategoriesIcon */.dFl; },
  "ArrowLeftIcon": function() { return /* reexport */ Icons/* ArrowLeftIcon */.Y4O; },
  "ArrowLength": function() { return /* reexport */ Icons/* ArrowLength */.qGl; },
  "ArrowRight": function() { return /* reexport */ Icons/* ArrowRight */.olP; },
  "ArrowUp": function() { return /* reexport */ Icons/* ArrowUp */.a2Z; },
  "ArrowUpCircle": function() { return /* reexport */ Icons/* ArrowUpCircle */.kpN; },
  "ArrowWidth": function() { return /* reexport */ Icons/* ArrowWidth */.Wc5; },
  "AtEmailIcon": function() { return /* reexport */ Icons/* AtEmailIcon */.v44; },
  "AuthenticationIcon": function() { return /* reexport */ Icons/* AuthenticationIcon */.GmG; },
  "AutomotivoIcon": function() { return /* reexport */ Icons/* AutomotivoIcon */.niG; },
  "Bag": function() { return /* reexport */ Icons/* Bag */.Nh5; },
  "BagIcon": function() { return /* reexport */ Icons/* BagIcon */.LnD; },
  "Banknote": function() { return /* reexport */ Icons/* Banknote */.iZZ; },
  "BanknoteInput": function() { return /* reexport */ Icons/* BanknoteInput */.vwY; },
  "Barcode": function() { return /* reexport */ Icons/* Barcode */.S2I; },
  "Bin": function() { return /* reexport */ Icons/* Bin */.Dlc; },
  "BlackFridayBag": function() { return /* reexport */ Icons/* BlackFridayBag */._1e; },
  "BoxButtonAuth": function() { return /* reexport */ BoxButtonAuth; },
  "BoxGift": function() { return /* reexport */ Icons/* BoxGift */.hj4; },
  "BreadcrumbArrowIcon": function() { return /* reexport */ Icons/* BreadcrumbArrowIcon */.Jmn; },
  "BrowserDefault": function() { return /* reexport */ Icons/* BrowserDefault */.IfH; },
  "Button": function() { return /* reexport */ Button; },
  "CPF": function() { return /* reexport */ Icons/* CPF */.Ncw; },
  "CalendarChecklistIcon": function() { return /* reexport */ Icons/* CalendarChecklistIcon */.D2G; },
  "CalendarIcon": function() { return /* reexport */ Icons/* CalendarIcon */.Que; },
  "CalendarOutlineIcon": function() { return /* reexport */ Icons/* CalendarOutlineIcon */.lHO; },
  "CallIcon": function() { return /* reexport */ Icons/* CallIcon */.o8m; },
  "CamaMesaEBanhoIcon": function() { return /* reexport */ Icons/* CamaMesaEBanhoIcon */.QL2; },
  "Camera": function() { return /* reexport */ Icons/* Camera */.V1s; },
  "CancellationIcon": function() { return /* reexport */ Icons/* CancellationIcon */.B_A; },
  "Card": function() { return /* reexport */ Icons/* Card */.Zbd; },
  "CardHeart": function() { return /* reexport */ Icons/* CardHeart */.Hue; },
  "CardIcon": function() { return /* reexport */ Icons/* CardIcon */._Kv; },
  "Cart": function() { return /* reexport */ Icons/* Cart */.APc; },
  "CartIcon": function() { return /* reexport */ Icons/* CartIcon */.w7_; },
  "CartLogoFCBlack": function() { return /* reexport */ Icons/* CartLogoFCBlack */.Bbg; },
  "CartOutlineIcon": function() { return /* reexport */ Icons/* CartOutlineIcon */.pMC; },
  "CenteredUserIcon": function() { return /* reexport */ Icons/* CenteredUserIcon */.FWC; },
  "ChangeAddressIcon": function() { return /* reexport */ Icons/* ChangeAddressIcon */.AML; },
  "ChangePasswordIcon": function() { return /* reexport */ Icons/* ChangePasswordIcon */.IaT; },
  "Check": function() { return /* reexport */ Icons/* Check */.JrY; },
  "CheckDone": function() { return /* reexport */ Icons/* CheckDone */.GcA; },
  "CheckIcon": function() { return /* reexport */ Icons/* CheckIcon */.nQG; },
  "CheckPayment": function() { return /* reexport */ Icons/* CheckPayment */.DQr; },
  "CheckValidateIcon": function() { return /* reexport */ Icons/* CheckValidateIcon */.jg9; },
  "CheckmarkCircle": function() { return /* reexport */ Icons/* CheckmarkCircle */.Zgy; },
  "ChromeIcon": function() { return /* reexport */ Icons/* ChromeIcon */.eLj; },
  "CircleCheckIcon": function() { return /* reexport */ Icons/* CircleCheckIcon */.owK; },
  "CircleErrorIcon": function() { return /* reexport */ Icons/* CircleErrorIcon */.Mgn; },
  "CircularTelephoneIcon": function() { return /* reexport */ Icons/* CircularTelephoneIcon */.ODY; },
  "ClientIcon": function() { return /* reexport */ Icons/* ClientIcon */.NSo; },
  "Clock": function() { return /* reexport */ Icons/* Clock */.SUY; },
  "ClockIcon": function() { return /* reexport */ Icons/* ClockIcon */.T39; },
  "Close": function() { return /* reexport */ Icons/* Close */.x8P; },
  "CloseIcon": function() { return /* reexport */ Icons/* CloseIcon */.Two; },
  "Coinpig": function() { return /* reexport */ Icons/* Coinpig */.MA4; },
  "Column": function() { return /* reexport */ Column; },
  "ConstrucaoIcon": function() { return /* reexport */ Icons/* ConstrucaoIcon */.vZk; },
  "Container": function() { return /* reexport */ Container; },
  "Copy": function() { return /* reexport */ Icons/* Copy */.CKM; },
  "CopyIcon": function() { return /* reexport */ Icons/* CopyIcon */.TIy; },
  "CouponTag": function() { return /* reexport */ Icons/* CouponTag */.Xtd; },
  "CouponTicket": function() { return /* reexport */ Icons/* CouponTicket */.U9w; },
  "CreditCard": function() { return /* reexport */ Icons/* CreditCard */.aBT; },
  "DefaultCard": function() { return /* reexport */ Icons/* DefaultCard */.eZD; },
  "DefaultProductImage": function() { return /* reexport */ Icons/* DefaultProductImage */.T54; },
  "DeliveredPackageTrackingStatusIcon": function() { return /* reexport */ Icons/* DeliveredPackageTrackingStatusIcon */.uoG; },
  "DeliveringTrackingStatusIcon": function() { return /* reexport */ Icons/* DeliveringTrackingStatusIcon */.VPl; },
  "DeliveryTruckPinIcon": function() { return /* reexport */ Icons/* DeliveryTruckPinIcon */.Reo; },
  "Desk": function() { return /* reexport */ Desk; },
  "DeskInfo": function() { return /* reexport */ DeskInfo; },
  "DeviceAccountIcon": function() { return /* reexport */ Icons/* DeviceAccountIcon */.Iq3; },
  "DeviceCheck": function() { return /* reexport */ Icons/* DeviceCheck */.x5s; },
  "DeviceCheckError": function() { return /* reexport */ Icons/* DeviceCheckError */.saf; },
  "DeviceComputerIcon": function() { return /* reexport */ Icons/* DeviceComputerIcon */.NQD; },
  "DevicePasswordChange": function() { return /* reexport */ Icons/* DevicePasswordChange */.qHj; },
  "DevicePasswordChanged": function() { return /* reexport */ Icons/* DevicePasswordChanged */.LAI; },
  "DeviceSmartphoneIcon": function() { return /* reexport */ Icons/* DeviceSmartphoneIcon */.X91; },
  "DevicesIcon": function() { return /* reexport */ Icons/* DevicesIcon */.Uoy; },
  "Diners": function() { return /* reexport */ Icons/* Diners */.Xiq; },
  "DisconnectIcon": function() { return /* reexport */ Icons/* DisconnectIcon */.RN8; },
  "DiscountContainer": function() { return /* reexport */ DiscountContainer; },
  "DiscountPercentageContainer": function() { return /* reexport */ DiscountPercentageContainer; },
  "DiscountTagContainer": function() { return /* reexport */ DiscountTagContainer; },
  "DiscountTagDot": function() { return /* reexport */ DiscountTagDot; },
  "DiscountTagText": function() { return /* reexport */ DiscountTagText; },
  "DollarCircle": function() { return /* reexport */ Icons/* DollarCircle */.RFQ; },
  "DollarIcon": function() { return /* reexport */ Icons/* DollarIcon */.teY; },
  "DoubleArrowDown": function() { return /* reexport */ Icons/* DoubleArrowDown */.kfl; },
  "DoubleCard": function() { return /* reexport */ Icons/* DoubleCard */.$m7; },
  "DoubtsIcon": function() { return /* reexport */ Icons/* DoubtsIcon */.W0f; },
  "DownPayment": function() { return /* reexport */ Icons/* DownPayment */.eQy; },
  "Edit": function() { return /* reexport */ Icons/* Edit */.I8b; },
  "EditPencilIcon": function() { return /* reexport */ Icons/* EditPencilIcon */.mOM; },
  "EditRight": function() { return /* reexport */ Icons/* EditRight */.lts; },
  "EletronicosIcon": function() { return /* reexport */ Icons/* EletronicosIcon */.DEN; },
  "Elo": function() { return /* reexport */ Icons/* Elo */.oPg; },
  "EmailAuthenticationIcon": function() { return /* reexport */ Icons/* EmailAuthenticationIcon */.GEH; },
  "EmailFailureIcon": function() { return /* reexport */ Icons/* EmailFailureIcon */.XlC; },
  "EmailIcon": function() { return /* reexport */ Icons/* EmailIcon */.LQS; },
  "EmailLetterMessage": function() { return /* reexport */ Icons/* EmailLetterMessage */.jN3; },
  "EmailValidationErrorIcon": function() { return /* reexport */ Icons/* EmailValidationErrorIcon */.AIT; },
  "EmailValidationIcon": function() { return /* reexport */ Icons/* EmailValidationIcon */.MN3; },
  "EmployeeIcon": function() { return /* reexport */ Icons/* EmployeeIcon */.K4G; },
  "EraseIcon": function() { return /* reexport */ Icons/* EraseIcon */.KM_; },
  "ErrorIcon": function() { return /* reexport */ Icons/* ErrorIcon */.Pz_; },
  "ExclusionAccountFailedIcon": function() { return /* reexport */ Icons/* ExclusionAccountFailedIcon */.u5P; },
  "ExclusionAccountSucceedIcon": function() { return /* reexport */ Icons/* ExclusionAccountSucceedIcon */.rI4; },
  "EyeClose": function() { return /* reexport */ Icons/* EyeClose */.Wif; },
  "EyeOpen": function() { return /* reexport */ Icons/* EyeOpen */.YyG; },
  "FCCredit": function() { return /* reexport */ Icons/* FCCredit */.rEg; },
  "FCLogoBlackFriday": function() { return /* reexport */ Icons/* FCLogoBlackFriday */.l2y; },
  "FaceAuthenticationIcon": function() { return /* reexport */ Icons/* FaceAuthenticationIcon */.EPk; },
  "Facebook": function() { return /* reexport */ Icons/* Facebook */.s1S; },
  "FacebookIconFooter": function() { return /* reexport */ Icons/* FacebookIconFooter */.GKd; },
  "FailureIcon": function() { return /* reexport */ Icons/* FailureIcon */.dgZ; },
  "FailurePaperAirplaneIcon": function() { return /* reexport */ Icons/* FailurePaperAirplaneIcon */.slo; },
  "FerramentasEEPIIcon": function() { return /* reexport */ Icons/* FerramentasEEPIIcon */.q4I; },
  "File": function() { return /* reexport */ Icons/* File */.$BE; },
  "Filter": function() { return /* reexport */ Icons/* Filter */.wn$; },
  "FlexContainer": function() { return /* reexport */ FlexContainer; },
  "FurnitureGiftIcon": function() { return /* reexport */ Icons/* FurnitureGiftIcon */.wG3; },
  "FurnitureGiftSmallIcon": function() { return /* reexport */ Icons/* FurnitureGiftSmallIcon */.NC6; },
  "GeometricBoxIcon": function() { return /* reexport */ Icons/* GeometricBoxIcon */.r5N; },
  "Gift": function() { return /* reexport */ Icons/* Gift */.ncs; },
  "GiftCardWeddingListHome": function() { return /* reexport */ Icons/* GiftCardWeddingListHome */.s6A; },
  "GiftIcon": function() { return /* reexport */ Icons/* GiftIcon */.OgN; },
  "GiftIconActivityHistory": function() { return /* reexport */ Icons/* GiftIconActivityHistory */.D5x; },
  "GiftIconNew": function() { return /* reexport */ Icons/* GiftIconNew */.LzI; },
  "GiftOutlineIcon": function() { return /* reexport */ Icons/* GiftOutlineIcon */.qPd; },
  "Google": function() { return /* reexport */ Icons/* Google */.ieO; },
  "GoogleColored": function() { return /* reexport */ Icons/* GoogleColored */.fCp; },
  "GreenAddIcon": function() { return /* reexport */ Icons/* GreenAddIcon */.cvE; },
  "H1": function() { return /* reexport */ H1; },
  "H2": function() { return /* reexport */ H2; },
  "H3": function() { return /* reexport */ H3; },
  "HamburgerIcon": function() { return /* reexport */ Icons/* HamburgerIcon */.Uq7; },
  "HandPackageDeliveryIcon": function() { return /* reexport */ Icons/* HandPackageDeliveryIcon */.dZ4; },
  "HeadPhone": function() { return /* reexport */ Icons/* HeadPhone */.fJl; },
  "HeaderSearchbarFlexContainer": function() { return /* reexport */ HeaderSearchbarFlexContainer; },
  "Heart": function() { return /* reexport */ Icons/* Heart */.Xdw; },
  "HeartIcon": function() { return /* reexport */ Icons/* HeartIcon */.h_8; },
  "Help": function() { return /* reexport */ Icons/* Help */.WWB; },
  "Hiper": function() { return /* reexport */ Icons/* Hiper */.E4Q; },
  "Hipercard": function() { return /* reexport */ Icons/* Hipercard */.RAr; },
  "Home": function() { return /* reexport */ Icons/* Home */.SK8; },
  "HomeIcon": function() { return /* reexport */ Icons/* HomeIcon */.tvw; },
  "HomeImprovementsIcon": function() { return /* reexport */ Icons/* HomeImprovementsIcon */.vEO; },
  "HomeImprovementsSmallIcon": function() { return /* reexport */ Icons/* HomeImprovementsSmallIcon */.uDo; },
  "House": function() { return /* reexport */ Icons/* House */.TXp; },
  "HouseIcon": function() { return /* reexport */ Icons/* HouseIcon */.K2o; },
  "IconLeftBottom": function() { return /* reexport */ Icons/* IconLeftBottom */.Dc$; },
  "IconLeftBottomMobile": function() { return /* reexport */ Icons/* IconLeftBottomMobile */.t2y; },
  "IconRightTop": function() { return /* reexport */ Icons/* IconRightTop */.rI_; },
  "IconRightTopMobile": function() { return /* reexport */ Icons/* IconRightTopMobile */.rqA; },
  "IconStore": function() { return /* reexport */ Icons/* IconStore */.kot; },
  "IconWrapper": function() { return /* reexport */ IconWrapper; },
  "IllustrationSendEmail": function() { return /* reexport */ Icons/* IllustrationSendEmail */.fW_; },
  "IluminacaoIcon": function() { return /* reexport */ Icons/* IluminacaoIcon */.OIN; },
  "ImageCardVirtualMyCards": function() { return /* reexport */ Icons/* ImageCardVirtualMyCards */.HW3; },
  "ImageCircle": function() { return /* reexport */ ImageCircle; },
  "ImagePhoneWhereToUse": function() { return /* reexport */ Icons/* ImagePhoneWhereToUse */.l_; },
  "IndifferentFaceIcon": function() { return /* reexport */ Icons/* IndifferentFaceIcon */.FM; },
  "InfoOutlineIcon": function() { return /* reexport */ Icons/* InfoOutlineIcon */.hQ6; },
  "InputSearch": function() { return /* reexport */ InputSearch; },
  "InputSearchFlexContainer": function() { return /* reexport */ InputSearchFlexContainer; },
  "Instagram": function() { return /* reexport */ Icons/* Instagram */.mre; },
  "InstagramIconFooter": function() { return /* reexport */ Icons/* InstagramIconFooter */.ozo; },
  "Interrogation": function() { return /* reexport */ Icons/* Interrogation */.iPI; },
  "InvoicedTrackingStatusIcon": function() { return /* reexport */ Icons/* InvoicedTrackingStatusIcon */.$Iz; },
  "Jcb": function() { return /* reexport */ Icons/* Jcb */.xnI; },
  "LinkedIn": function() { return /* reexport */ Icons/* LinkedIn */.yhk; },
  "LinkedinIconFooter": function() { return /* reexport */ Icons/* LinkedinIconFooter */.hhm; },
  "ListIcon": function() { return /* reexport */ Icons/* ListIcon */.DE2; },
  "Lock": function() { return /* reexport */ Icons/* Lock */.HEZ; },
  "LockIcon": function() { return /* reexport */ Icons/* LockIcon */.mBM; },
  "LogoFCBlack": function() { return /* reexport */ Icons/* LogoFCBlack */.V6C; },
  "LogoFerreiraCosta": function() { return /* reexport */ Icons/* LogoFerreiraCosta */.dSO; },
  "LoucasMetaisEAcessoriosIcon": function() { return /* reexport */ Icons/* LoucasMetaisEAcessoriosIcon */.CsV; },
  "Map": function() { return /* reexport */ Icons/* Map */.D5R; },
  "MapPin": function() { return /* reexport */ Icons/* MapPin */.$td; },
  "Mastercard": function() { return /* reexport */ Icons/* Mastercard */.ffk; },
  "MateriaisEletricosIcon": function() { return /* reexport */ Icons/* MateriaisEletricosIcon */.oH9; },
  "MateriaisHidraulicosIcon": function() { return /* reexport */ Icons/* MateriaisHidraulicosIcon */.YPk; },
  "MessagesIcon": function() { return /* reexport */ Icons/* MessagesIcon */.wW5; },
  "MockCard": function() { return /* reexport */ MockCard; },
  "MockFullWidthBanner": function() { return /* reexport */ MockFullWidthBanner; },
  "MockStory": function() { return /* reexport */ MockStory; },
  "MoveisEDecoracaoIcon": function() { return /* reexport */ Icons/* MoveisEDecoracaoIcon */.hiG; },
  "MozilaFirefoxIcon": function() { return /* reexport */ Icons/* MozilaFirefoxIcon */.Yf9; },
  "MyAccountIcon": function() { return /* reexport */ Icons/* MyAccountIcon */.$h5; },
  "MyCardsIcon": function() { return /* reexport */ Icons/* MyCardsIcon */.WD5; },
  "MyDataIcon": function() { return /* reexport */ Icons/* MyDataIcon */.RrJ; },
  "MyListFingerOnPhone": function() { return /* reexport */ Icons/* MyListFingerOnPhone */.WVy; },
  "MyListFingerPoiting": function() { return /* reexport */ Icons/* MyListFingerPoiting */.Zj$; },
  "MyListThumbsUp": function() { return /* reexport */ Icons/* MyListThumbsUp */.b$w; },
  "MyListsIcon": function() { return /* reexport */ Icons/* MyListsIcon */.i4T; },
  "MyOrdersIcon": function() { return /* reexport */ Icons/* MyOrdersIcon */.NJL; },
  "MySecurityIcon": function() { return /* reexport */ Icons/* MySecurityIcon */.aSj; },
  "NavBar": function() { return /* reexport */ NavBar; },
  "NewEyeCloseIcon": function() { return /* reexport */ Icons/* NewEyeCloseIcon */.pB$; },
  "NewEyeOpenIcon": function() { return /* reexport */ Icons/* NewEyeOpenIcon */.TPX; },
  "NewGiftIcon": function() { return /* reexport */ Icons/* NewGiftIcon */.Bl$; },
  "NewShareIcon": function() { return /* reexport */ Icons/* NewShareIcon */.I3k; },
  "NoAddress": function() { return /* reexport */ Icons/* NoAddress */.$6R; },
  "NoOrder": function() { return /* reexport */ Icons/* NoOrder */.dIr; },
  "NoOrderIcon": function() { return /* reexport */ Icons/* NoOrderIcon */.lM8; },
  "NoPackages": function() { return /* reexport */ Icons/* NoPackages */.wy_; },
  "OfflineIcon": function() { return /* reexport */ Icons/* OfflineIcon */._Jb; },
  "OldPrice": function() { return /* reexport */ OldPrice; },
  "OpsIcon": function() { return /* reexport */ Icons/* OpsIcon */.GOp; },
  "OrderApproved": function() { return /* reexport */ Icons/* OrderApproved */.btc; },
  "OrderCancelled": function() { return /* reexport */ Icons/* OrderCancelled */.byi; },
  "OrderCancelledIcon": function() { return /* reexport */ Icons/* OrderCancelledIcon */.agT; },
  "OrderCancelling": function() { return /* reexport */ Icons/* OrderCancelling */.DTl; },
  "OrderDelivered": function() { return /* reexport */ Icons/* OrderDelivered */.orY; },
  "OrderDelivering": function() { return /* reexport */ Icons/* OrderDelivering */.apP; },
  "OrderWaitingPayment": function() { return /* reexport */ Icons/* OrderWaitingPayment */.Uyx; },
  "OrderWithdrawAvailable": function() { return /* reexport */ Icons/* OrderWithdrawAvailable */.SHC; },
  "OthersPayments": function() { return /* reexport */ Icons/* OthersPayments */.PAp; },
  "OutForDeliveryTrackingStatusIcon": function() { return /* reexport */ Icons/* OutForDeliveryTrackingStatusIcon */.oCG; },
  "OverlayContainer": function() { return /* reexport */ OverlayContainer; },
  "OverlayDynamic": function() { return /* reexport */ OverlayDynamic; },
  "Package": function() { return /* reexport */ Icons/* Package */.GLc; },
  "PackageIcon": function() { return /* reexport */ Icons/* PackageIcon */.jtq; },
  "PackageOutlined": function() { return /* reexport */ Icons/* PackageOutlined */.N8c; },
  "PackageThumbsUpIcon": function() { return /* reexport */ Icons/* PackageThumbsUpIcon */.MAY; },
  "PasteIcon": function() { return /* reexport */ Icons/* PasteIcon */.TuS; },
  "PaymentCancelledIcon": function() { return /* reexport */ Icons/* PaymentCancelledIcon */.TlF; },
  "PaymentDoneIcon": function() { return /* reexport */ Icons/* PaymentDoneIcon */.Tfr; },
  "PaymentMethods": function() { return /* reexport */ Icons/* PaymentMethods */.A6c; },
  "Pencil": function() { return /* reexport */ Icons/* Pencil */.zaA; },
  "PercentageDiscount": function() { return /* reexport */ Icons/* PercentageDiscount */.eCG; },
  "Phone": function() { return /* reexport */ Icons/* Phone */.LPZ; },
  "PhoneAuthenticationIcon": function() { return /* reexport */ Icons/* PhoneAuthenticationIcon */.QoR; },
  "PhoneCallIcon": function() { return /* reexport */ Icons/* PhoneCallIcon */.Csw; },
  "PhoneNumberValidationError": function() { return /* reexport */ Icons/* PhoneNumberValidationError */.dUP; },
  "PickupStore": function() { return /* reexport */ Icons/* PickupStore */.XqY; },
  "PigIcon": function() { return /* reexport */ Icons/* PigIcon */.zun; },
  "PinLocation": function() { return /* reexport */ Icons/* PinLocation */.rUJ; },
  "PinLocationOutline": function() { return /* reexport */ Icons/* PinLocationOutline */.ij4; },
  "PinterestIcon": function() { return /* reexport */ Icons/* PinterestIcon */.cHF; },
  "PisosERevestimentosIcon": function() { return /* reexport */ Icons/* PisosERevestimentosIcon */.rdS; },
  "PixIcon": function() { return /* reexport */ Icons/* PixIcon */.WEt; },
  "PixIconWithBG": function() { return /* reexport */ Icons/* PixIconWithBG */.A34; },
  "PlusInCircleIcon": function() { return /* reexport */ Icons/* PlusInCircleIcon */.yB6; },
  "PortasJanelasEFechadurasIcon": function() { return /* reexport */ Icons/* PortasJanelasEFechadurasIcon */.gkv; },
  "PreparingTrackingStatusIcon": function() { return /* reexport */ Icons/* PreparingTrackingStatusIcon */.wSx; },
  "PriceInstallments": function() { return /* reexport */ PriceInstallments; },
  "PriceMainContainer": function() { return /* reexport */ PriceMainContainer; },
  "PriceValue": function() { return /* reexport */ PriceValue; },
  "PriceValueDetail": function() { return /* reexport */ PriceValueDetail; },
  "PriceValueText": function() { return /* reexport */ PriceValueText; },
  "PrintedInvoiceIcon": function() { return /* reexport */ Icons/* PrintedInvoiceIcon */.rJM; },
  "ProfileIcon": function() { return /* reexport */ Icons/* ProfileIcon */.m26; },
  "QrCode": function() { return /* reexport */ Icons/* QrCode */.UHX; },
  "Question": function() { return /* reexport */ Icons/* Question */.HNF; },
  "ReadyForPickupTrackingStatusIcon": function() { return /* reexport */ Icons/* ReadyForPickupTrackingStatusIcon */.vl4; },
  "ReportSecurityProblemIcon": function() { return /* reexport */ Icons/* ReportSecurityProblemIcon */.MGt; },
  "RequestErrorIcon": function() { return /* reexport */ Icons/* RequestErrorIcon */.D94; },
  "ResumeOrder": function() { return /* reexport */ Icons/* ResumeOrder */.O7B; },
  "RightArrowProduct": function() { return /* reexport */ Icons/* RightArrowProduct */.KMc; },
  "RotateIcon": function() { return /* reexport */ Icons/* RotateIcon */.Vk2; },
  "Row": function() { return /* reexport */ Row; },
  "SafariIcon": function() { return /* reexport */ Icons/* SafariIcon */.wSs; },
  "SaleTagCircle": function() { return /* reexport */ SaleTagCircle; },
  "SaleTagContainer": function() { return /* reexport */ SaleTagContainer; },
  "SaleTagIcon": function() { return /* reexport */ Icons/* SaleTagIcon */.Gg0; },
  "SaleTagTextContainer": function() { return /* reexport */ SaleTagTextContainer; },
  "SatisfiedFaceIcon": function() { return /* reexport */ Icons/* SatisfiedFaceIcon */.zuy; },
  "Search": function() { return /* reexport */ Icons/* Search */.olm; },
  "SearchBagIcon": function() { return /* reexport */ Icons/* SearchBagIcon */.tWk; },
  "SearchBoxIcon": function() { return /* reexport */ Icons/* SearchBoxIcon */.FTV; },
  "SearchIcon": function() { return /* reexport */ Icons/* SearchIcon */.W1M; },
  "SecurityIcon": function() { return /* reexport */ Icons/* SecurityIcon */.J8y; },
  "SecurityLockIcon": function() { return /* reexport */ Icons/* SecurityLockIcon */.cjT; },
  "Separator": function() { return /* reexport */ Separator; },
  "Settings": function() { return /* reexport */ Icons/* Settings */.Zrf; },
  "SettingsIcon": function() { return /* reexport */ Icons/* SettingsIcon */.ewm; },
  "Share": function() { return /* reexport */ Icons/* Share */.mBz; },
  "ShieldUserProtection": function() { return /* reexport */ Icons/* ShieldUserProtection */.Op7; },
  "ShopIcon": function() { return /* reexport */ Icons/* ShopIcon */.EOn; },
  "ShoppingBagIcon": function() { return /* reexport */ Icons/* ShoppingBagIcon */.b_c; },
  "ShoppingCartIcon": function() { return /* reexport */ Icons/* ShoppingCartIcon */.Q1y; },
  "ShoppingFlowIcon": function() { return /* reexport */ Icons/* ShoppingFlowIcon */.cqj; },
  "SingleUserIcon": function() { return /* reexport */ Icons/* SingleUserIcon */.CFw; },
  "Smartphone": function() { return /* reexport */ Icons/* Smartphone */.rpN; },
  "SocialMedia": function() { return /* reexport */ Icons/* SocialMedia */.usK; },
  "SpaceWrapper": function() { return /* reexport */ SpaceWrapper; },
  "SpotPriceText": function() { return /* reexport */ SpotPriceText; },
  "Spotify": function() { return /* reexport */ Icons/* Spotify */.yFx; },
  "SpotifyIconFooter": function() { return /* reexport */ Icons/* SpotifyIconFooter */.RlD; },
  "Star": function() { return /* reexport */ Icons/* Star */.Uxw; },
  "StarIcon": function() { return /* reexport */ Icons/* StarIcon */.r7p; },
  "StatusIcon": function() { return /* reexport */ Icons/* StatusIcon */.Jj5; },
  "Store": function() { return /* reexport */ Icons/* Store */.yh4; },
  "SuccessIcon": function() { return /* reexport */ Icons/* SuccessIcon */.tmp; },
  "SuccessSyncIcon": function() { return /* reexport */ Icons/* SuccessSyncIcon */.h29; },
  "TelephoneAuthenticationIcon": function() { return /* reexport */ Icons/* TelephoneAuthenticationIcon */.sUU; },
  "TelephoneErrorIcon": function() { return /* reexport */ Icons/* TelephoneErrorIcon */.ow7; },
  "Text": function() { return /* reexport */ Text; },
  "ThreeDotsHorizontal": function() { return /* reexport */ Icons/* ThreeDotsHorizontal */.nMY; },
  "TintasEQuimicosIcon": function() { return /* reexport */ Icons/* TintasEQuimicosIcon */.TzQ; },
  "Title": function() { return /* reexport */ Title; },
  "TrackingStatusDeliveryManArrivedStore": function() { return /* reexport */ Icons/* TrackingStatusDeliveryManArrivedStore */.LAV; },
  "TrackingStatusDeliveryManAtPlace": function() { return /* reexport */ Icons/* TrackingStatusDeliveryManAtPlace */.SYV; },
  "TrackingStatusDeliveryManOnTheWay": function() { return /* reexport */ Icons/* TrackingStatusDeliveryManOnTheWay */.iA1; },
  "TrackingStatusOrderBeignSeparated": function() { return /* reexport */ Icons/* TrackingStatusOrderBeignSeparated */.oI5; },
  "TrackingStatusOrderCanceled": function() { return /* reexport */ Icons/* TrackingStatusOrderCanceled */.utO; },
  "TrackingStatusOrderInvoiced": function() { return /* reexport */ Icons/* TrackingStatusOrderInvoiced */.TgP; },
  "TrackingStatusOrderNewDeliveryMan": function() { return /* reexport */ Icons/* TrackingStatusOrderNewDeliveryMan */.Yql; },
  "TrackingStatusOrderOnTheCarrier": function() { return /* reexport */ Icons/* TrackingStatusOrderOnTheCarrier */.vhD; },
  "TrackingStatusOrderOutForDelivery": function() { return /* reexport */ Icons/* TrackingStatusOrderOutForDelivery */.W72; },
  "TrackingStatusOrderReceived": function() { return /* reexport */ Icons/* TrackingStatusOrderReceived */.ufH; },
  "TrackingStatusPickingAvailable": function() { return /* reexport */ Icons/* TrackingStatusPickingAvailable */.Nvd; },
  "TrackingStatusRescheduledOrder": function() { return /* reexport */ Icons/* TrackingStatusRescheduledOrder */.sXz; },
  "Truck": function() { return /* reexport */ Icons/* Truck */._DY; },
  "TruckFC": function() { return /* reexport */ Icons/* TruckFC */.Rt9; },
  "TwoCardsIcon": function() { return /* reexport */ Icons/* TwoCardsIcon */.WOT; },
  "TwoStepVerificationIcon": function() { return /* reexport */ Icons/* TwoStepVerificationIcon */.mYL; },
  "UnavailableIcon": function() { return /* reexport */ Icons/* UnavailableIcon */.Jcv; },
  "UniqueClientImage": function() { return /* reexport */ Icons/* UniqueClientImage */._ju; },
  "UniqueClientMediumSMobileInfo": function() { return /* reexport */ Icons/* UniqueClientMediumSMobileInfo */.T_Y; },
  "UniqueClientMobileImage": function() { return /* reexport */ Icons/* UniqueClientMobileImage */.ZPv; },
  "UniqueClientSecondaryMobileImage": function() { return /* reexport */ Icons/* UniqueClientSecondaryMobileImage */.xMg; },
  "UniqueClientXSMobileImage": function() { return /* reexport */ Icons/* UniqueClientXSMobileImage */.t95; },
  "UniqueClientXSMobileInfo": function() { return /* reexport */ Icons/* UniqueClientXSMobileInfo */.zeW; },
  "UnsatisfiedFaceIcon": function() { return /* reexport */ Icons/* UnsatisfiedFaceIcon */.PN2; },
  "UserAuthenticatedImageCircle": function() { return /* reexport */ UserAuthenticatedImageCircle; },
  "UserCardIcon": function() { return /* reexport */ Icons/* UserCardIcon */.Oww; },
  "UserFirstCharacterFromName": function() { return /* reexport */ UserFirstCharacterFromName; },
  "UserFullName": function() { return /* reexport */ UserFullName; },
  "UserIcon": function() { return /* reexport */ Icons/* UserIcon */.tBG; },
  "UserInitials": function() { return /* reexport */ UserInitials; },
  "UserWrapper": function() { return /* reexport */ UserWrapper; },
  "UtilidadesDomesticasIcon": function() { return /* reexport */ Icons/* UtilidadesDomesticasIcon */.KgO; },
  "ValidIcon": function() { return /* reexport */ Icons/* ValidIcon */.XGw; },
  "VerySatisfiedFaceIcon": function() { return /* reexport */ Icons/* VerySatisfiedFaceIcon */.CvM; },
  "VeryUnsatisfiedFaceIcon": function() { return /* reexport */ Icons/* VeryUnsatisfiedFaceIcon */.Z2X; },
  "Visa": function() { return /* reexport */ Icons/* Visa */.aB9; },
  "Wallet": function() { return /* reexport */ Icons/* Wallet */.w5x; },
  "WarningIcon": function() { return /* reexport */ Icons/* WarningIcon */.aNP; },
  "WarningRevalidationIcon": function() { return /* reexport */ Icons/* WarningRevalidationIcon */.FB0; },
  "WarningValidateIcon": function() { return /* reexport */ Icons/* WarningValidateIcon */.AHd; },
  "WeddingRingIcon": function() { return /* reexport */ Icons/* WeddingRingIcon */.pZu; },
  "WeddingRingsDefaultIcon": function() { return /* reexport */ Icons/* WeddingRingsDefaultIcon */.Wge; },
  "WeddingRingsIcon": function() { return /* reexport */ Icons/* WeddingRingsIcon */.lxD; },
  "WeighIcon": function() { return /* reexport */ Icons/* WeighIcon */.Kvs; },
  "WhatsApp": function() { return /* reexport */ Icons/* WhatsApp */.w26; },
  "WhatsappIcon": function() { return /* reexport */ Icons/* WhatsappIcon */.udp; },
  "YoutubeIcon": function() { return /* reexport */ Icons/* YoutubeIcon */.LKl; },
  "blackFridayCarouselTheme": function() { return /* reexport */ themes/* blackFridayCarouselTheme */.LM; },
  "blackFridayProductListTheme": function() { return /* reexport */ themes/* blackFridayProductListTheme */.WW; },
  "mappedIcons": function() { return /* reexport */ Icons/* mappedIcons */.aZq; },
  "oficialTheme": function() { return /* reexport */ themes/* oficialTheme */.N3; },
  "theme": function() { return /* reexport */ themes/* theme */.rS; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63356);
// EXTERNAL MODULE: ../../packages/ui/themes/index.ts + 15 modules
var themes = __webpack_require__(27814);
;// CONCATENATED MODULE: ../../packages/ui/Accordion/index.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  visibility: ",
        ";\n  overflow: hidden;\n  transition: all 0.4s ease-in-out, visibility 0.4s;\n  height: auto;\n  background-color: ",
        ";\n  max-height: ",
        ";\n\n  &.active {\n    visibility: visible;\n    transition: max-height 0.4s ease-in-out, visibility 0.4s;\n    max-height: ",
        ";\n  }\n\n  @media ",
        " {\n    ",
        "\n  }\n\n  @media ",
        " {\n    ",
        "\n  }\n\n  @media ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Accordion = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Accordion",
    componentId: "sc-d8f1d5fd-0"
})(_templateObject(), function(param) {
    var show = param.show;
    return show ? "visible" : "hidden";
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || "transparent";
}, function(param) {
    var show = param.show, maxHeight = param.maxHeight;
    return show ? maxHeight : "0";
}, function(param) {
    var show = param.show, maxHeight = param.maxHeight;
    return show ? maxHeight : "0";
}, themes/* theme.device.desktopFirst.laptop */.rS.device.desktopFirst.laptop, function(param) {
    var laptop = param.laptop;
    return (laptop === null || laptop === void 0 ? void 0 : laptop.display) && "display: ".concat(laptop.display, ";");
}, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, function(param) {
    var tablet = param.tablet;
    return (tablet === null || tablet === void 0 ? void 0 : tablet.display) && "display: ".concat(tablet.display, ";");
}, themes/* theme.device.desktopFirst.mobileL */.rS.device.desktopFirst.mobileL, function(param) {
    var mobile = param.mobile;
    return (mobile === null || mobile === void 0 ? void 0 : mobile.display) && "display: ".concat(mobile.display, ";");
});

;// CONCATENATED MODULE: ../../packages/ui/Aggregator/index.ts
/**
 * @deprecated This Component shall not be used
 */ 
function Aggregator_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: ",
        ";\n  display: ",
        ";\n  flex-direction: ",
        ";\n  justify-content: ",
        ";\n  align-items: ",
        ";\n  text-align: ",
        ";\n  padding: ",
        ";\n\n  ",
        ";\n  ",
        "\n  ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n\n    @media ",
        " {\n    ",
        "\n    ",
        "\n        ",
        "\n  }\n\n  @media ",
        " {\n    ",
        "\n    ",
        "\n        ",
        "\n  }\n\n  @media ",
        " {\n    ",
        "\n    ",
        "\n        ",
        "\n        border: none;\n  }\n\n  @media ",
        " {\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    border: none;\n  }\n\n  @media ",
        " {\n    max-height: 100%;\n  }\n\n  @media ",
        " {\n    ",
        "\n    ",
        "\n    ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n  }\n"
    ]);
    Aggregator_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Aggregator = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "Aggregator",
    componentId: "sc-e3ce3a8-0"
})(Aggregator_templateObject(), function(param) {
    var background = param.background;
    return background || "transparent";
}, function(param) {
    var color = param.color;
    return color || themes/* theme.colors.neutral.999 */.rS.colors.neutral[999];
}, function(param) {
    var display = param.display;
    return display || "block";
}, function(param) {
    var flexDirection = param.flexDirection;
    return flexDirection || "row";
}, function(param) {
    var justifyContent = param.justifyContent;
    return justifyContent || "left";
}, function(param) {
    var alignItems = param.alignItems;
    return alignItems || "center";
}, function(param) {
    var textAlign = param.textAlign;
    return textAlign || "start";
}, function(param) {
    var padding = param.padding;
    return padding || themes/* theme.space.x0 */.rS.space.x0;
}, function(param) {
    var margin = param.margin;
    return "margin: ".concat(margin || themes/* theme.space.x0 */.rS.space.x0, ";");
}, function(param) {
    var border = param.border;
    return border && "border: ".concat(border, ";");
}, function(param) {
    var borderTop = param.borderTop;
    return borderTop && "border-top: ".concat(borderTop, ";");
}, function(param) {
    var borderBottom = param.borderBottom;
    return borderBottom && "border-bottom: ".concat(borderBottom, ";");
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius && "border-radius: ".concat(borderRadius, ";");
}, function(param) {
    var width = param.width;
    return width && "width: ".concat(width, ";");
}, function(param) {
    var gap = param.gap;
    return gap && "gap: ".concat(gap, ";");
}, function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight && "max-height: ".concat(maxHeight, ";");
}, function(param) {
    var flexWrap = param.flexWrap;
    return flexWrap && "flex-wrap: ".concat(flexWrap, ";");
}, themes/* theme.device.desktopFirst.desktop */.rS.device.desktopFirst.desktop, function(param) {
    var desktop = param.desktop;
    return desktop && desktop.display && "display: ".concat(desktop.display, ";");
}, function(param) {
    var desktop = param.desktop;
    return desktop && desktop.padding && "padding: ".concat(desktop.padding, ";");
}, function(param) {
    var desktop = param.desktop;
    return desktop && desktop.margin && "margin: ".concat(desktop.margin, ";");
}, themes/* theme.device.desktopFirst.laptopL */.rS.device.desktopFirst.laptopL, function(param) {
    var laptopL = param.laptopL;
    return laptopL && laptopL.display && "display: ".concat(laptopL.display, ";");
}, function(param) {
    var laptopL = param.laptopL;
    return laptopL && laptopL.padding && "padding: ".concat(laptopL.padding, ";");
}, function(param) {
    var laptopL = param.laptopL;
    return laptopL && laptopL.margin && "margin: ".concat(laptopL.margin, ";");
}, themes/* theme.device.desktopFirst.laptop */.rS.device.desktopFirst.laptop, function(param) {
    var laptop = param.laptop;
    return laptop && laptop.display && "display: ".concat(laptop.display, ";");
}, function(param) {
    var laptop = param.laptop;
    return laptop && laptop.padding && "padding: ".concat(laptop.padding, ";");
}, function(param) {
    var laptop = param.laptop;
    return laptop && laptop.margin && "margin: ".concat(laptop.margin, ";");
}, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, function(param) {
    var tablet = param.tablet;
    return tablet && tablet.display && "display: ".concat(tablet.display, ";");
}, function(param) {
    var tablet = param.tablet;
    return tablet && tablet.alignItems && "align-items: ".concat(tablet.alignItems, ";");
}, function(param) {
    var tablet = param.tablet;
    return tablet && tablet.padding && "padding: ".concat(tablet.padding, ";");
}, function(param) {
    var tablet = param.tablet;
    return "margin: ".concat((tablet === null || tablet === void 0 ? void 0 : tablet.margin) || "15px 0", ";");
}, themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS, themes/* theme.device.desktopFirst.mobileL */.rS.device.desktopFirst.mobileL, function(param) {
    var mobile = param.mobile;
    return mobile && mobile.display && "display: ".concat(mobile.display, ";");
}, function(param) {
    var mobile = param.mobile;
    return mobile && mobile.flexDirection && "flex-direction: ".concat(mobile.flexDirection, ";");
}, function(param) {
    var mobile = param.mobile;
    return mobile && mobile.justifyContent && "justify-content: ".concat(mobile.justifyContent, ";");
}, function(param) {
    var mobile = param.mobile;
    return mobile && mobile.alignItems && "align-items: ".concat(mobile.alignItems, ";");
}, function(param) {
    var mobile = param.mobile;
    return mobile && mobile.padding && "padding: ".concat(mobile.padding, ";");
}, function(param) {
    var mobile = param.mobile;
    return mobile && mobile.margin && "margin: ".concat(mobile.margin, ";");
});

;// CONCATENATED MODULE: ../../packages/ui/Backoffice/Custom.ts

function Custom_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 250px;\n  height: 350px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 5px;\n"
    ]);
    Custom_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 151px;\n  height: 151px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 100%;\n\n  @media ",
        " {\n    width: 76px;\n    height: 76px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-height: 50vh;\n  background-color: ",
        ";\n\n  @media ",
        " {\n    min-height: 76.5px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var MockCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Custom__MockCard",
    componentId: "sc-a558a71a-0"
})(Custom_templateObject(), themes/* theme.colors.neutral.white */.rS.colors.neutral.white, themes/* theme.colors.neutral.500 */.rS.colors.neutral[500]);
var MockStory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Custom__MockStory",
    componentId: "sc-a558a71a-1"
})(_templateObject1(), themes/* theme.colors.neutral.25 */.rS.colors.neutral[25], themes/* theme.colors.neutral.500 */.rS.colors.neutral[500], themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet);
var MockFullWidthBanner = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "Custom__MockFullWidthBanner",
    componentId: "sc-a558a71a-2"
})(_templateObject2(), themes/* theme.colors.neutral.75 */.rS.colors.neutral[75], themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet);

;// CONCATENATED MODULE: ../../packages/ui/Backoffice/index.tsx


;// CONCATENATED MODULE: ../../packages/ui/Button/index.ts

function Button_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      pointer-events: none;\n    "
    ]);
    Button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Button_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  cursor: pointer;\n  border: ",
        ";\n\n  ",
        "\n  ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n\n    &:hover {\n    ",
        "\n  }\n"
    ]);
    Button_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "Button",
    componentId: "sc-1c1867f5-0"
})(Button_templateObject1(), function(param) {
    var width = param.width;
    return width || themes/* theme.space.x32 */.rS.space.x32;
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || themes/* theme.colors.primary.200 */.rS.colors.primary[200];
}, function(param) {
    var color = param.color;
    return color || themes/* theme.colors.neutral.white */.rS.colors.neutral.white;
}, function(param) {
    var rounded = param.rounded, _fill = param.fill, fill = _fill === void 0 ? "solid" : _fill;
    return rounded || fill === "outline" ? themes/* theme.space.x1 */.rS.space.x1 : themes/* theme.space.x0 */.rS.space.x0;
}, "".concat(themes/* theme.space.x1 */.rS.space.x1, " ").concat(themes/* theme.space.x3 */.rS.space.x3), function(param) {
    var border = param.border, color = param.color, _fill = param.fill, fill = _fill === void 0 ? "solid" : _fill;
    return fill === "outline" ? "".concat(themes/* theme.space.xpx */.rS.space.xpx, " solid ").concat(color || themes/* theme.colors.neutral.white */.rS.colors.neutral.white, "}") : border || "none";
}, function(param) {
    var height = param.height;
    return height && "height: ".concat(height, ";");
}, function(param) {
    var fill = param.fill;
    return fill && (fill === "clear" || fill === "outline") && "background: none;";
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize && "font-size: ".concat(fontSize, ";");
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight && "font-weight: ".concat(fontWeight, ";");
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(Button_templateObject());
}, function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "solid" : _fill, mouseOverColor = param.mouseOverColor, backgroundColor = param.backgroundColor, color = param.color;
    return fill === "solid" && "background-color: ".concat(mouseOverColor || backgroundColor || color || themes/* theme.colors.neutral.300 */.rS.colors.neutral[300], ";");
});

;// CONCATENATED MODULE: ../../packages/ui/Column/index.tsx

function Column_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      @media ",
        " {\n        justify-content: space-between;\n      }\n    "
    ]);
    Column_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Column_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  padding: ",
        ";\n  float: left;\n  ",
        ";\n\n  @media only screen and (min-width: 768px) {\n    ",
        ";\n  }\n\n  @media only screen and (min-width: 992px) {\n    ",
        ";\n  }\n\n  @media only screen and (min-width: 1200px) {\n    ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    Column_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var getWidthString = function(span) {
    if (!span) {
        return null;
    }
    var width = Number(span) / 12 * 100;
    return "width: ".concat(width, "%;");
};
var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Column",
    componentId: "sc-e19eb5b9-0"
})(Column_templateObject1(), function(param) {
    var display = param.display;
    return display && "display: ".concat(display, ";");
}, function(param) {
    var flexDirection = param.flexDirection;
    return flexDirection && "flex-direction: ".concat(flexDirection, ";");
}, function(param) {
    var justifyContent = param.justifyContent;
    return justifyContent && "justify-content: ".concat(justifyContent, ";");
}, function(param) {
    var flexWrap = param.flexWrap;
    return flexWrap && "flex-wrap: ".concat(flexWrap, ";");
}, function(param) {
    var alignItems = param.alignItems;
    return alignItems && "align-items: ".concat(alignItems, ";");
}, function(param) {
    var padding = param.padding;
    return padding || themes/* theme.space.x0 */.rS.space.x0;
}, function(param) {
    var xs = param.xs;
    return xs ? getWidthString(xs) : "width: 100%";
}, function(param) {
    var sm = param.sm;
    return sm && getWidthString(sm);
}, function(param) {
    var md = param.md;
    return md && getWidthString(md);
}, function(param) {
    var lg = param.lg;
    return lg && getWidthString(lg);
}, function(param) {
    var isPayment = param.isPayment;
    return isPayment && (0,styled_components_browser_esm/* css */.iv)(Column_templateObject(), themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL);
});

;// CONCATENATED MODULE: ../../packages/ui/Container/Flex/index.ts

function Flex_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: ",
        ";\n  display: ",
        ";\n  flex-direction: ",
        ";\n  flex-wrap: ",
        ";\n  justify-content: ",
        ";\n  align-items: ",
        ";\n  align-content: ",
        ";\n  gap: ",
        ";\n  text-align: ",
        ";\n  ",
        "\n  margin: ",
        ";\n  background-color: ",
        ";\n  white-space: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    Flex_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var FlexContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Flex__FlexContainer",
    componentId: "sc-f7173ba1-0"
})(Flex_templateObject(), function(param) {
    var position = param.position;
    return position || "static";
}, function(param) {
    var display = param.display;
    return display || "flex";
}, function(param) {
    var flexDirection = param.flexDirection;
    return flexDirection || "row";
}, function(param) {
    var flexWrap = param.flexWrap;
    return flexWrap || "nowrap";
}, function(param) {
    var justifyContent = param.justifyContent;
    return justifyContent || "flex-start";
}, function(param) {
    var alignItems = param.alignItems;
    return alignItems || "stretch";
}, function(param) {
    var alignContent = param.alignContent;
    return alignContent || "stretch";
}, function(param) {
    var gap = param.gap;
    return gap || themes/* theme.space.x0 */.rS.space.x0;
}, function(param) {
    var textAlign = param.textAlign;
    return textAlign || "initial";
}, function(param) {
    var alignSelf = param.alignSelf;
    return alignSelf && "align-self: ".concat(alignSelf, ";");
}, function(param) {
    var margin = param.margin;
    return margin || "0px";
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || "transparent";
}, function(param) {
    var whiteSpace = param.whiteSpace;
    return whiteSpace || "normal";
}, function(param) {
    var width = param.width;
    return width || "100%";
}, function(param) {
    var height = param.height;
    return height || "auto";
});

;// CONCATENATED MODULE: ../../packages/ui/Container/OverlayDynamic/index.ts

function OverlayDynamic_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      top: ",
        ";\n    "
    ]);
    OverlayDynamic_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OverlayDynamic_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: ",
        ";\n  width: 100%;\n  height: ",
        ";\n  background-color: ",
        ";\n  z-index: 50;\n  visibility: ",
        ";\n  opacity: ",
        ";\n  overflow: hidden;\n  transition: all 1s ease;\n  ",
        "\n"
    ]);
    OverlayDynamic_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var OverlayDynamic = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OverlayDynamic",
    componentId: "sc-dd82c761-0"
})(OverlayDynamic_templateObject1(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "absolute" : "fixed";
}, function(param) {
    var height = param.height;
    return height;
}, themes/* theme.colors.neutral.999-opacity-50 */.rS.colors.neutral["999-opacity-50"], function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "visible" : "hidden";
}, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "1.0" : "0";
}, function(param) {
    var top = param.top;
    return top && (0,styled_components_browser_esm/* css */.iv)(OverlayDynamic_templateObject(), top);
});

;// CONCATENATED MODULE: ../../packages/ui/Container/index.ts

function Container_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  max-width: 1310px;\n  padding: 0 1.25rem;\n\n  @media ",
        " {\n    max-width: 1280px;\n    width: ",
        ";\n    padding: 0 1.34rem;\n  }\n\n  @media ",
        " {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  @media ",
        " {\n    background-color: ",
        ";\n  }\n\n  @media ",
        " {\n    padding: 0;\n  }\n\n  @media ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    Container_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Container",
    componentId: "sc-fdbdbc37-0"
})(Container_templateObject(), themes/* theme.device.desktopFirst.laptopL */.rS.device.desktopFirst.laptopL, function(param) {
    var widthLaptopL = param.widthLaptopL;
    return widthLaptopL ? "100%" : "";
}, themes/* theme.device.desktopFirst.laptop */.rS.device.desktopFirst.laptop, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "transparent";
}, themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS, themes/* theme.device.desktopFirst.mobileM */.rS.device.desktopFirst.mobileM, function(param) {
    var hasNoMobilePadding = param.hasNoMobilePadding;
    return hasNoMobilePadding ? "0" : "0 1.34rem";
});

;// CONCATENATED MODULE: ../../packages/ui/Desk/index.ts

function Desk_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  ",
        "\n  ",
        "\n  ",
        "\n\n  ",
        ";\n\n  padding: ",
        ";\n  margin: ",
        ";\n\n  @media ",
        " {\n    max-height: ",
        ";\n    border: none;\n    width: ",
        ";\n    padding: 0 ",
        ";\n  }\n\n  @media ",
        " {\n    padding: 0 ",
        ";\n    ",
        "\n  }\n"
    ]);
    Desk_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Desk_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Desk_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Desk = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Desk",
    componentId: "sc-6a5bc20f-0"
})(Desk_templateObject(), function(param) {
    var justifyContent = param.justifyContent;
    return justifyContent && "justify-content: ".concat(justifyContent, ";");
}, function(param) {
    var alignItems = param.alignItems;
    return "align-items: ".concat(alignItems || "center", ";");
}, function(param) {
    var gap = param.gap;
    return gap && "gap: ".concat(gap, ";");
}, function(param) {
    var hasRightBorder = param.hasRightBorder;
    return "\n      ".concat(hasRightBorder ? "border-right: 1px solid ".concat(themes/* theme.colors.neutral.750 */.rS.colors.neutral[750]) : "", ";\n      width: ").concat(themes/* theme.space.x1/1 */.rS.space["x1/1"], ";\n  ");
}, function(param) {
    var padding = param.padding;
    return padding || "0 ".concat(themes/* theme.space.x6 */.rS.space.x6);
}, function(param) {
    var margin = param.margin;
    return margin || "0";
}, themes/* theme.device.desktopFirst.laptop */.rS.device.desktopFirst.laptop, themes/* theme.space.x1/1 */.rS.space["x1/1"], themes/* theme.space.x1/1 */.rS.space["x1/1"], themes/* theme.space.x4 */.rS.space.x4, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.space.x1 */.rS.space.x1, function(param) {
    var alignItems = param.alignItems;
    return "align-items: ".concat(alignItems || "flex-start", ";");
});
var DeskInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Desk__DeskInfo",
    componentId: "sc-6a5bc20f-1"
})(Desk_templateObject1());

// EXTERNAL MODULE: ../../packages/ui/Icons/index.tsx + 326 modules
var Icons = __webpack_require__(39927);
;// CONCATENATED MODULE: ../../packages/ui/IconWrapper/index.ts

function IconWrapper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      svg *:hover {\n        fill: ",
        " !important;\n      }\n\n      @media ",
        " {\n        margin-right: 4px;\n      }\n    "
    ]);
    IconWrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IconWrapper_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: ",
        ";\n  max-width: ",
        ";\n  min-height: ",
        ";\n  max-height: ",
        ";\n  margin-right: ",
        ";\n  border-radius: ",
        ";\n  cursor: ",
        ";\n  background-color: ",
        ";\n\n  ",
        "\n  @media ",
        " {\n    min-width: ",
        ";\n    max-width: ",
        ";\n    min-height: ",
        ";\n    max-height: ",
        ";\n    margin-right: 10px;\n  }\n\n  svg > path:hover {\n    fill: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    IconWrapper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-825ec423-0"
})(IconWrapper_templateObject1(), function(param) {
    var width = param.width;
    return width || themes/* theme.space.x16 */.rS.space.x16;
}, function(param) {
    var width = param.width;
    return width || themes/* theme.space.x16 */.rS.space.x16;
}, function(param) {
    var height = param.height;
    return height || themes/* theme.space.x16 */.rS.space.x16;
}, function(param) {
    var height = param.height;
    return height || themes/* theme.space.x16 */.rS.space.x16;
}, function(param) {
    var marginRight = param.marginRight;
    return marginRight || "20px";
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius || themes/* theme.space.x1/1 */.rS.space["x1/1"];
}, function(param) {
    var clickable = param.clickable;
    return clickable ? "pointer" : "default";
}, function(param) {
    var color = param.color;
    return color || themes/* theme.colors.secondary.300 */.rS.colors.secondary[300];
}, function(param) {
    var lineHeight = param.lineHeight;
    return lineHeight && "line-height: ".concat(lineHeight, ";");
}, themes/* theme.device.desktopFirst.laptop */.rS.device.desktopFirst.laptop, function(param) {
    var width = param.width;
    return width ? "".concat(Number(width.replace(/\D/g, "")) / 1.25, "px") : themes/* theme.space.x10 */.rS.space.x10;
}, function(param) {
    var width = param.width;
    return width ? "".concat(Number(width.replace(/\D/g, "")) / 1.25, "px") : themes/* theme.space.x10 */.rS.space.x10;
}, function(param) {
    var height = param.height;
    return height ? "".concat(Number(height.replace(/\D/g, "")) / 1.25, "px") : themes/* theme.space.x10 */.rS.space.x10;
}, function(param) {
    var height = param.height;
    return height ? "".concat(Number(height.replace(/\D/g, "")) / 1.25, "px") : themes/* theme.space.x10 */.rS.space.x10;
}, function(param) {
    var mouseOverColor = param.mouseOverColor, color = param.color;
    return mouseOverColor || color || themes/* theme.colors.secondary.300 */.rS.colors.secondary[300];
}, function(param) {
    var isBlackTheme = param.isBlackTheme;
    return isBlackTheme && (0,styled_components_browser_esm/* css */.iv)(IconWrapper_templateObject(), themes/* theme.colors.neutral.white */.rS.colors.neutral.white, themes/* theme.device.desktopFirst.laptop */.rS.device.desktopFirst.laptop);
});

;// CONCATENATED MODULE: ../../packages/ui/InputSearch/index.ts

function InputSearch_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: -1;\n  opacity: 0;\n  display: flex;\n  visibility: hidden;\n  background: ",
        ";\n  transition: opacity 0.2s ease;\n"
    ]);
    InputSearch_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InputSearch_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  width: ",
        ";\n\n  @media ",
        " {\n    max-width: 690px !important;\n  }\n\n  @media ",
        " {\n    max-width: 440px;\n  }\n\n  @media ",
        " {\n    max-width: 440px;\n  }\n"
    ]);
    InputSearch_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function InputSearch_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: row;\n"
    ]);
    InputSearch_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  margin-top: 0;\n  height: ",
        ";\n  padding: 1.8rem;\n  background: ",
        ";\n  border: ",
        ';\n  border-radius: 4px 0 0 4px;\n  font-family: "Chivo", Arial, Helvetica, sans-serif;\n  font-size: ',
        ";\n  font-weight: ",
        ";\n  z-index: ",
        ";\n  order: 0;\n  transition: border 0.2s ease;\n\n  &:focus ~ ",
        " {\n    z-index: 5;\n    opacity: 1;\n    visibility: visible;\n    border-color: ",
        ";\n    box-shadow: 0 4px 8px 0 ",
        ",\n      0 6px 20px 0 ",
        ";\n  }\n\n  &::placeholder {\n    color: ",
        ";\n    padding-left: ",
        ";\n    font-size: 1.5rem;\n  }\n\n  &::-webkit-calendar-picker-indicator {\n    display: none !important;\n  }\n\n  @media ",
        " {\n    font-size: ",
        ";\n    /* max-width: 690px !important; */\n  }\n\n  @media ",
        " {\n    height: 3.75rem;\n    /* max-width: 440px; */\n  }\n\n  @media ",
        " {\n    order: 2;\n    border-radius: 0 4px 4px 0;\n  }\n\n  @media ",
        " {\n    height: 3rem;\n    /* max-width: 440px; */\n    padding: 1.1rem 1rem 1rem 0.7rem;\n    border-radius: 0 4px 4px 0;\n    font-size: 1.2rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var OverlayContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InputSearch__OverlayContainer",
    componentId: "sc-f28b3ac7-0"
})(InputSearch_templateObject(), themes/* theme.colors.neutral.999-opacity-50 */.rS.colors.neutral["999-opacity-50"]);
var HeaderSearchbarFlexContainer = (0,styled_components_browser_esm/* default */.ZP)(FlexContainer).withConfig({
    displayName: "InputSearch__HeaderSearchbarFlexContainer",
    componentId: "sc-f28b3ac7-1"
})(InputSearch_templateObject1(), themes/* theme.space.x1/1 */.rS.space["x1/1"], themes/* theme.device.desktopFirst.laptop */.rS.device.desktopFirst.laptop, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.device.desktopFirst.mobileL */.rS.device.desktopFirst.mobileL);
var InputSearchFlexContainer = (0,styled_components_browser_esm/* default */.ZP)(FlexContainer).withConfig({
    displayName: "InputSearch__InputSearchFlexContainer",
    componentId: "sc-f28b3ac7-2"
})(InputSearch_templateObject2());
var InputSearch = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "InputSearch",
    componentId: "sc-f28b3ac7-3"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : themes/* theme.space.x1/1 */.rS.space["x1/1"];
}, function(param) {
    var height = param.height;
    return height !== null && height !== void 0 ? height : "4.17rem";
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : themes/* theme.colors.neutral.white */.rS.colors.neutral.white;
}, function(param) {
    var hideBorder = param.hideBorder;
    return hideBorder ? "1px solid ".concat(themes/* theme.colors.neutral.white */.rS.colors.neutral.white) : "1px solid ".concat(themes/* theme.colors.neutral.100 */.rS.colors.neutral[100]);
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize || "1.5rem";
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight || "500";
}, function(param) {
    var hasFocusOnInputSearch = param.hasFocusOnInputSearch;
    return hasFocusOnInputSearch ? 6 : 0;
}, OverlayContainer, function(param) {
    var onFocusProps = param.onFocusProps;
    return (onFocusProps === null || onFocusProps === void 0 ? void 0 : onFocusProps.borderColor) || "none";
}, themes/* theme.colors.neutral.999-opacity-20 */.rS.colors.neutral["999-opacity-20"], themes/* theme.colors.neutral.999-opacity-19 */.rS.colors.neutral["999-opacity-19"], function(param) {
    var fontColor = param.fontColor;
    return fontColor || themes/* theme.colors.neutral.400 */.rS.colors.neutral[400];
}, themes/* theme.space.x0.5 */.rS.space["x0.5"], themes/* theme.device.desktopFirst.laptop */.rS.device.desktopFirst.laptop, function(param) {
    var fontSize = param.fontSize;
    return fontSize || "1.2rem";
}, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS, themes/* theme.device.desktopFirst.mobileL */.rS.device.desktopFirst.mobileL);

;// CONCATENATED MODULE: ../../packages/ui/NavBar/index.ts

function NavBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  padding: 0.5rem 0;\n  z-index: 6;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n  color: ",
        ";\n\n  @media ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    NavBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var NavBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NavBar",
    componentId: "sc-36f1490e-0"
})(NavBar_templateObject(), themes/* theme.colors.neutral.99 */.rS.colors.neutral[99], themes/* theme.colors.neutral.white */.rS.colors.neutral.white, themes/* theme.device.desktopFirst.mobileM */.rS.device.desktopFirst.mobileM);

;// CONCATENATED MODULE: ../../packages/ui/Product/index.ts

function Product_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  text-decoration: line-through;\n  margin-right: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n\n  display: ",
        ";\n  user-select: none;\n"
    ]);
    Product_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Product_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 5.875rem;\n  height: 1.75rem;\n  padding: 0 0.35rem 0 0;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: center;\n  gap: 0.25rem;\n\n  border-radius: 1rem 0.35rem 0.35rem 1rem;\n  background: ",
        ";\n"
    ]);
    Product_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Product_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 0.5rem;\n  height: 0.5rem;\n  border-radius: 50%;\n  background: ",
        ";\n  padding: 0.265rem;\n  margin-left: 4px;\n"
    ]);
    Product_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Product_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  color: ",
        ";\n\n  white-space: nowrap;\n\n  @media ",
        " {\n    display: flex;\n    justify-content: center;\n  }\n  line-height: 150%;\n  letter-spacing: -0.0235rem;\n  user-select: none;\n"
    ]);
    Product_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  width: fit-content;\n  padding: 0 ",
        " 0 ",
        ";\n  border-radius: 12px 4px 4px 12px;\n  background: ",
        ";\n  gap: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  margin-top: ",
        ";\n  gap: ",
        ";\n\n  @media ",
        " {\n    margin-top: ",
        ";\n  }\n\n  @media ",
        " {\n    margin-top: 0px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      gap: ",
        ";\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      @media ",
        " {\n        font-size: ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      @media ",
        " {\n        font-size: ",
        ";\n      }\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      @media ",
        " {\n        font-size: ",
        ";\n      }\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      @media ",
        " {\n        font-size: ",
        ";\n      }\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  ",
        "\n\n  ",
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  flex-direction: ",
        ";\n\n  ",
        "\n  ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  white-space: nowrap;\n  align-self: flex-end;\n  font-weight: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  @media ",
        " {\n    align-self: flex-start;\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      @media ",
        " {\n        flex-direction: column;\n        gap: ",
        ";\n\n        ",
        " {\n          flex-direction: row;\n        }\n      }\n\n      @media ",
        " {\n        gap: ",
        ";\n      }\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-self: flex-start;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  font-size: ",
        ";\n  color: ",
        ";\n  line-height: 17px;\n  letter-spacing: 0;\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n\n  @media ",
        " {\n    font-size: ",
        ";\n    line-height: ",
        ";\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  border: 2px solid ",
        ";\n  border-radius: 100%;\n  background-color: ",
        ";\n  z-index: 2;\n\n  @media ",
        " {\n    width: 30px;\n    height: 30px;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  color: ",
        ";\n  width: 135px;\n  height: 30px;\n  border: 1px solid ",
        ";\n  border-radius: 15px;\n  margin-left: -40px;\n  padding-left: 15px;\n\n  @media ",
        " {\n    width: 83px;\n    height: 20px;\n    margin-left: -20px;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}



var OldPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Product__OldPrice",
    componentId: "sc-74b1d902-0"
})(Product_templateObject(), function(param) {
    var fontSizeDiscount = param.fontSizeDiscount;
    return fontSizeDiscount !== null && fontSizeDiscount !== void 0 ? fontSizeDiscount : "1.15rem";
}, themes/* theme.colors.neutral.350 */.rS.colors.neutral[350], function(param) {
    var marginRight = param.marginRight;
    return marginRight || "".concat(themes/* theme.space.x2 */.rS.space.x2);
}, themes/* theme.typography.fontWeight.500 */.rS.typography.fontWeight[500], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, function(param) {
    var notShouldShowOldPrice = param.notShouldShowOldPrice;
    return notShouldShowOldPrice ? "none" : "initial";
});
var DiscountTagContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "Product__DiscountTagContainer",
    componentId: "sc-74b1d902-1"
})(Product_templateObject1(), themes/* theme.colors.tertiary.930 */.rS.colors.tertiary[930]);
var DiscountTagDot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Product__DiscountTagDot",
    componentId: "sc-74b1d902-2"
})(Product_templateObject2(), themes/* theme.colors.neutral.white */.rS.colors.neutral.white);
var DiscountTagText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Product__DiscountTagText",
    componentId: "sc-74b1d902-3"
})(Product_templateObject3(), function(param) {
    var fontSizeDiscount = param.fontSizeDiscount;
    return fontSizeDiscount !== null && fontSizeDiscount !== void 0 ? fontSizeDiscount : "1.15rem";
}, themes/* theme.typography.fontWeight.600 */.rS.typography.fontWeight[600], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, themes/* theme.colors.tertiary.150 */.rS.colors.tertiary[150], themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS);
var DiscountPercentageContainer = (0,styled_components_browser_esm/* default */.ZP)(FlexContainer).withConfig({
    displayName: "Product__DiscountPercentageContainer",
    componentId: "sc-74b1d902-4"
})(_templateObject4(), themes/* theme.space.x2 */.rS.space.x2, themes/* theme.space.x1 */.rS.space.x1, themes/* theme.colors.tertiary.930 */.rS.colors.tertiary[930], themes/* theme.space.x1 */.rS.space.x1);
var PriceValueDetail = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Product__PriceValueDetail",
    componentId: "sc-74b1d902-5"
})(_templateObject5(), themes/* theme.colors.primary.200 */.rS.colors.primary[200], themes/* theme.typography.fontFamily.chivo */.rS.typography.fontFamily.chivo, function(param) {
    var fontSize = param.fontSize;
    return fontSize || "1.15rem";
}, themes/* theme.typography.fontWeight.500 */.rS.typography.fontWeight[500]);
var DiscountContainer = (0,styled_components_browser_esm/* default */.ZP)(FlexContainer).withConfig({
    displayName: "Product__DiscountContainer",
    componentId: "sc-74b1d902-6"
})(_templateObject6(), themes/* theme.space.x2 */.rS.space.x2, themes/* theme.space.x2 */.rS.space.x2, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.space.x0.5 */.rS.space["x0.5"], themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL);
var PriceValue = styled_components_browser_esm/* default.text.withConfig */.ZP.text.withConfig({
    displayName: "Product__PriceValue",
    componentId: "sc-74b1d902-7"
})(_templateObject13(), function(param) {
    var display = param.display, isFlexDirectionColumn = param.isFlexDirectionColumn;
    return isFlexDirectionColumn ? "flex" : display || "block";
}, function(param) {
    var margin = param.margin;
    return margin && (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), margin);
}, function(param) {
    var gap = param.gap;
    return gap && (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), gap);
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "3rem";
}, themes/* theme.typography.fontWeight.700 */.rS.typography.fontWeight[700], themes/* theme.colors.primary.200 */.rS.colors.primary[200], function(param) {
    var isFlexDirectionColumn = param.isFlexDirectionColumn;
    return isFlexDirectionColumn ? "column" : "row";
}, function(param) {
    var fontSizeLaptop = param.fontSizeLaptop;
    return fontSizeLaptop && (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), themes/* theme.device.desktopFirst.laptop */.rS.device.desktopFirst.laptop, fontSizeLaptop);
}, function(param) {
    var fontSizeTablet = param.fontSizeTablet;
    return fontSizeTablet && (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, fontSizeTablet);
}, function(param) {
    var fontSizeMobileLarge = param.fontSizeMobileLarge;
    return fontSizeMobileLarge && (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL, fontSizeMobileLarge);
}, function(param) {
    var fontSizeMobile = param.fontSizeMobile;
    return fontSizeMobile && (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), themes/* theme.device.desktopFirst.mobileL */.rS.device.desktopFirst.mobileL, fontSizeMobile);
});
var SpotPriceText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Product__SpotPriceText",
    componentId: "sc-74b1d902-8"
})(_templateObject14(), themes/* theme.typography.fontSize.sm.x5 */.rS.typography.fontSize.sm.x5, themes/* theme.typography.fontWeight.400 */.rS.typography.fontWeight[400], themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.typography.fontSize.sm.x3 */.rS.typography.fontSize.sm.x3, themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL, themes/* theme.typography.fontSize.sm.x1 */.rS.typography.fontSize.sm.x1);
var PriceValueText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Product__PriceValueText",
    componentId: "sc-74b1d902-9"
})(_templateObject15());
var PriceMainContainer = (0,styled_components_browser_esm/* default */.ZP)(FlexContainer).withConfig({
    displayName: "Product__PriceMainContainer",
    componentId: "sc-74b1d902-10"
})(_templateObject17(), themes/* theme.space.x2 */.rS.space.x2, function(param) {
    var childrenQuantity = param.childrenQuantity;
    return childrenQuantity > 1 && (0,styled_components_browser_esm/* css */.iv)(_templateObject16(), themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.space.x1 */.rS.space.x1, DiscountContainer, themes/* theme.device.desktopFirst.mobileL */.rS.device.desktopFirst.mobileL, themes/* theme.space.x1 */.rS.space.x1);
});
var PriceInstallments = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Product__PriceInstallments",
    componentId: "sc-74b1d902-11"
})(_templateObject18(), themes/* theme.typography.fontSize.sm.x5 */.rS.typography.fontSize.sm.x5, function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : themes/* theme.colors.neutral.999 */.rS.colors.neutral[999];
}, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, themes/* theme.typography.fontSize.sm.x3 */.rS.typography.fontSize.sm.x3, themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS, themes/* theme.typography.fontSize.sm.x3 */.rS.typography.fontSize.sm.x3, themes/* theme.typography.fontSize.sm.x5 */.rS.typography.fontSize.sm.x5);
var SaleTagContainer = (0,styled_components_browser_esm/* default */.ZP)(FlexContainer).withConfig({
    displayName: "Product__SaleTagContainer",
    componentId: "sc-74b1d902-12"
})(_templateObject19());
var SaleTagCircle = (0,styled_components_browser_esm/* default */.ZP)(FlexContainer).withConfig({
    displayName: "Product__SaleTagCircle",
    componentId: "sc-74b1d902-13"
})(_templateObject20(), themes/* theme.colors.neutral.white */.rS.colors.neutral.white, themes/* theme.colors.primary.200 */.rS.colors.primary[200], themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS);
var SaleTagTextContainer = (0,styled_components_browser_esm/* default */.ZP)(FlexContainer).withConfig({
    displayName: "Product__SaleTagTextContainer",
    componentId: "sc-74b1d902-14"
})(_templateObject21(), themes/* theme.colors.primary.200 */.rS.colors.primary[200], themes/* theme.colors.neutral.white */.rS.colors.neutral.white, themes/* theme.colors.neutral.100 */.rS.colors.neutral[100], themes/* theme.device.desktopFirst.tabletS */.rS.device.desktopFirst.tabletS);

;// CONCATENATED MODULE: ../../packages/ui/Row/index.ts

function Row_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        '\n\n    width: auto;\n\n  /* margin-left: -15px;\n  margin-right: -15px; */\n\n  &::after {\n    content: "";\n    clear: both;\n    display: table;\n  }\n'
    ]);
    Row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Row",
    componentId: "sc-db9305a2-0"
})(Row_templateObject(), function(param) {
    var display = param.display;
    return display && "display: ".concat(display, ";");
}, function(param) {
    var flexDirection = param.flexDirection;
    return flexDirection && "flex-direction: ".concat(flexDirection, ";");
}, function(param) {
    var justifyContent = param.justifyContent;
    return justifyContent && "justify-content: ".concat(justifyContent, ";");
}, function(param) {
    var flexWrap = param.flexWrap;
    return flexWrap && "flex-wrap: ".concat(flexWrap, ";");
}, function(param) {
    var alignItems = param.alignItems;
    return alignItems && "align-items: ".concat(alignItems, ";");
}, function(param) {
    var gap = param.gap;
    return gap && "gap: ".concat(gap, ";");
});

;// CONCATENATED MODULE: ../../packages/ui/Separator/index.ts

function Separator_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  height: ",
        ";\n  width: 100%;\n  margin: 0 auto;\n  background-color: ",
        ";\n  border: none;\n"
    ]);
    Separator_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Separator = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    displayName: "Separator",
    componentId: "sc-8777219a-0"
})(Separator_templateObject(), function(param) {
    var height = param.height;
    return height || themes/* theme.space.xpx */.rS.space.xpx;
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || themes/* theme.colors.neutral.100 */.rS.colors.neutral[100];
});

;// CONCATENATED MODULE: ../../packages/ui/SpaceWrapper/index.ts

function SpaceWrapper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  padding: ",
        ";\n  border-top: ",
        ";\n  border-right: ",
        ";\n  border-bottom: ",
        ";\n  border-left: ",
        ";\n"
    ]);
    SpaceWrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SpaceWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SpaceWrapper",
    componentId: "sc-177787e2-0"
})(SpaceWrapper_templateObject(), function(param) {
    var margin = param.margin;
    return margin || themes/* theme.space.x0 */.rS.space.x0;
}, function(param) {
    var padding = param.padding;
    return padding || themes/* theme.space.x0 */.rS.space.x0;
}, function(param) {
    var borderTop = param.borderTop, borderColor = param.borderColor;
    return borderTop ? "".concat(themes/* theme.space.xpx */.rS.space.xpx, " solid ").concat(borderColor || themes/* theme.colors.neutral.100 */.rS.colors.neutral[100]) : "".concat(themes/* theme.space.x0 */.rS.space.x0);
}, function(param) {
    var borderRight = param.borderRight, borderColor = param.borderColor;
    return borderRight ? "".concat(themes/* theme.space.xpx */.rS.space.xpx, " solid ").concat(borderColor || themes/* theme.colors.neutral.100 */.rS.colors.neutral[100]) : "".concat(themes/* theme.space.x0 */.rS.space.x0);
}, function(param) {
    var borderBottom = param.borderBottom, borderColor = param.borderColor;
    return borderBottom ? "".concat(themes/* theme.space.xpx */.rS.space.xpx, " solid ").concat(borderColor || themes/* theme.colors.neutral.100 */.rS.colors.neutral[100]) : "".concat(themes/* theme.space.x0 */.rS.space.x0);
}, function(param) {
    var borderLeft = param.borderLeft, borderColor = param.borderColor;
    return borderLeft ? "".concat(themes/* theme.space.xpx */.rS.space.xpx, " solid ").concat(borderColor || themes/* theme.colors.neutral.100 */.rS.colors.neutral[100]) : "".concat(themes/* theme.space.x0 */.rS.space.x0);
});

;// CONCATENATED MODULE: ../../packages/ui/Typography/Text/index.ts

function Text_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin: ",
        ";\n  ",
        "\n  ",
        "\n  text-align: ",
        ";\n  letter-spacing: ",
        ";\n  background-color: transparent !important;\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    Text_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Text = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Text",
    componentId: "sc-976d25ce-0"
})(Text_templateObject(), function(param) {
    var fontSize = param.fontSize;
    return fontSize || themes/* theme.typography.fontSize.sm.x5 */.rS.typography.fontSize.sm.x5;
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight || themes/* theme.typography.fontWeight.normal */.rS.typography.fontWeight.normal;
}, function(param) {
    var margin = param.margin;
    return margin || "".concat(themes/* theme.space.x2.5 */.rS.space["x2.5"], " ").concat(themes/* theme.space.x0 */.rS.space.x0, " ").concat(themes/* theme.space.x2 */.rS.space.x2);
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var fontFamily = param.fontFamily;
    return fontFamily && "font-family: ".concat(fontFamily, ";");
}, function(param) {
    var textAlign = param.textAlign;
    return textAlign || "start";
}, function(param) {
    var letterSpacing = param.letterSpacing;
    return letterSpacing || "0";
}, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, function(param) {
    var fontSize = param.fontSize;
    return fontSize || themes/* theme.typography.fontSize.sm.x3 */.rS.typography.fontSize.sm.x3;
});

;// CONCATENATED MODULE: ../../packages/ui/Typography/Title/index.ts

function Title_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n    @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    Title_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "Title",
    componentId: "sc-2533d338-0"
})(Title_templateObject(), function(param) {
    var fontSize = param.fontSize;
    return fontSize || themes/* theme.typography.fontSize.sm.x9 */.rS.typography.fontSize.sm.x9;
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight && "font-weight: ".concat(fontWeight, ";");
}, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, function(param) {
    var fontSize = param.fontSize;
    return fontSize || themes/* theme.typography.fontSize.sm.x7 */.rS.typography.fontSize.sm.x7;
});

;// CONCATENATED MODULE: ../../packages/ui/Typography/H1/index.ts

function H1_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n    @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    H1_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var H1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    displayName: "",
    componentId: "sc-367aa6e0-0"
})(H1_templateObject(), function(param) {
    var fontSize = param.fontSize;
    return fontSize || themes/* theme.typography.fontSize.sm.x9 */.rS.typography.fontSize.sm.x9;
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight && "font-weight: ".concat(fontWeight, ";");
}, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, function(param) {
    var fontSize = param.fontSize;
    return fontSize || themes/* theme.typography.fontSize.sm.x7 */.rS.typography.fontSize.sm.x7;
});

;// CONCATENATED MODULE: ../../packages/ui/Typography/H2/index.ts

function H2_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n    @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    H2_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var H2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "",
    componentId: "sc-7210927a-0"
})(H2_templateObject(), function(param) {
    var fontSize = param.fontSize;
    return fontSize || themes/* theme.typography.fontSize.sm.x9 */.rS.typography.fontSize.sm.x9;
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight && "font-weight: ".concat(fontWeight, ";");
}, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, function(param) {
    var fontSize = param.fontSize;
    return fontSize || themes/* theme.typography.fontSize.sm.x7 */.rS.typography.fontSize.sm.x7;
});

;// CONCATENATED MODULE: ../../packages/ui/Typography/H3/index.ts

function H3_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n    @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    H3_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var H3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "",
    componentId: "sc-b6289480-0"
})(H3_templateObject(), function(param) {
    var fontSize = param.fontSize;
    return fontSize || themes/* theme.typography.fontSize.sm.x9 */.rS.typography.fontSize.sm.x9;
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var fontWeight = param.fontWeight;
    return fontWeight && "font-weight: ".concat(fontWeight, ";");
}, themes/* theme.device.desktopFirst.tablet */.rS.device.desktopFirst.tablet, function(param) {
    var fontSize = param.fontSize;
    return fontSize || themes/* theme.typography.fontSize.sm.x7 */.rS.typography.fontSize.sm.x7;
});

;// CONCATENATED MODULE: ../../packages/ui/Typography/index.ts






;// CONCATENATED MODULE: ../../packages/ui/User/index.ts

function User_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  align-self: center;\n  font-size: 1.5rem;\n  color: ",
        ";\n"
    ]);
    User_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function User_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 50%;\n  text-align: center;\n  background: ",
        ";\n  border: 0;\n  padding: 0 1rem;\n\n  ",
        " {\n    padding: 0 !important;\n    text-decoration: none;\n    align-self: center;\n    font-size: ",
        " !important;\n    color: ",
        " !important;\n  }\n"
    ]);
    User_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function User_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  border: 0;\n"
    ]);
    User_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function User_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.6rem;\n  color: ",
        ";\n  font-weight: bold;\n"
    ]);
    User_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function User_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: ",
        " !important;\n\n  @media ",
        " {\n    display: flex;\n    align-items: center;\n    gap: ",
        " !important;\n  }\n"
    ]);
    User_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function User_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    User_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function User_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  padding: 0;\n  text-decoration: none;\n  align-self: center;\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    User_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
var ref, ref1, ref2, ref3, ref4, ref5;


var UserFirstCharacterFromName = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    displayName: "User__UserFirstCharacterFromName",
    componentId: "sc-5affbd81-0"
})(User_templateObject(), themes/* theme.colors.neutral.white */.rS.colors.neutral.white);
var ImageCircle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "User__ImageCircle",
    componentId: "sc-5affbd81-1"
})(User_templateObject1(), function(param) {
    var width = param.width;
    return width || "3.25rem";
}, function(param) {
    var height = param.height;
    return height || "3.25rem";
}, themes/* theme.colors.secondary.200 */.rS.colors.secondary[200], UserFirstCharacterFromName, themes/* theme */.rS === null || themes/* theme */.rS === void 0 ? void 0 : (ref = themes/* theme.typography */.rS.typography) === null || ref === void 0 ? void 0 : (ref1 = ref.fontSize) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sm) === null || ref2 === void 0 ? void 0 : ref2.x6, themes/* theme.colors.neutral.white */.rS.colors.neutral.white);
var UserAuthenticatedImageCircle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "User__UserAuthenticatedImageCircle",
    componentId: "sc-5affbd81-2"
})(User_templateObject2(), themes/* theme.colors.secondary.350 */.rS.colors.secondary[350]);
var UserFullName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "User__UserFullName",
    componentId: "sc-5affbd81-3"
})(User_templateObject3(), themes/* theme.colors.neutral.520 */.rS.colors.neutral[520]);
var UserWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "User__UserWrapper",
    componentId: "sc-5affbd81-4"
})(User_templateObject4(), themes/* theme.space.x2 */.rS.space.x2, themes/* theme.device.desktopFirst.mobileXL */.rS.device.desktopFirst.mobileXL, themes/* theme.space.x3 */.rS.space.x3);
/**
 * não utilizar valores negativos para o z-index abaixo,
 * no caso de de um valor negativo o dropdown de usuário autenticado
 * NÃO IRÁ ABRIR!!!
 */ var BoxButtonAuth = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "User__BoxButtonAuth",
    componentId: "sc-5affbd81-5"
})(User_templateObject5());
var UserInitials = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "User__UserInitials",
    componentId: "sc-5affbd81-6"
})(User_templateObject6(), themes/* theme */.rS === null || themes/* theme */.rS === void 0 ? void 0 : (ref3 = themes/* theme.typography */.rS.typography) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fontSize) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sm) === null || ref5 === void 0 ? void 0 : ref5.x6, themes/* theme.colors.neutral.white */.rS.colors.neutral.white);

;// CONCATENATED MODULE: ../../packages/ui/index.tsx




















/***/ }),

/***/ 27814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LM": function() { return /* reexport */ blackFridayCarouselTheme; },
  "WW": function() { return /* reexport */ blackFridayProductListTheme; },
  "N3": function() { return /* reexport */ oficialTheme; },
  "rS": function() { return /* reexport */ theme; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ../../packages/ui/themes/attributes/themes.tsx


var x1bar3 = "33.333333%";
var x1bar2 = "50%";
var x2bar3 = "66.666667%";
var x1bar6 = "16.666667%";
var partition = {
    "x1/1": "100%",
    "x1/2": x1bar2,
    "x1/3": x1bar3,
    "x2/3": x2bar3,
    "x1/4": "25%",
    "x2/4": x1bar2,
    "x3/4": "75%",
    "x1/5": "20%",
    "x2/5": "40%",
    "x3/5": "60%",
    "x4/5": "80%",
    "x1/6": x1bar6,
    "x2/6": x1bar3,
    "x3/6": x1bar2,
    "x4/6": x2bar3,
    "x5/6": "83.333333%",
    "x1/12": "8.333333%",
    "x2/12": x1bar6,
    "x3/12": "25%",
    "x4/12": x1bar3,
    "x5/12": "41.666667%",
    "x6/12": x1bar2,
    "x7/12": "58.333333%",
    "x8/12": x2bar3,
    "x9/12": "75%",
    "x10/12": "83.333333%",
    "x11/12": "91.666667%"
};
var space = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, partition), {
    x0: "0",
    xpx: "1px",
    "x0.5": "2px",
    x1: "4px",
    "x1.25": "5px",
    "x1.5": "6px",
    x2: "8px",
    "x2.5": "10px",
    x3: "12px",
    "x3.5": "14px",
    x4: "16px",
    "4.25": "17px",
    "x4.5": "18px",
    x5: "20px",
    "x5.5": "22px",
    x6: "24px",
    x7: "28px",
    "x7.5": "30px",
    x8: "32px",
    x9: "36px",
    x10: "40px",
    "x10.5": "42px",
    "x10.75": "43px",
    x11: "44px",
    "x11.5": "45px",
    "x11.75": "47px",
    x12: "48px",
    "x13.5": "54px",
    x14: "56px",
    x15: "60px",
    x16: "64px",
    x17: "68px",
    "x17.5": "70px",
    x18: "72px",
    "x18.5": "74px",
    "x19.5": "78px",
    x20: "80px",
    "x22.5": "90px",
    x24: "96px",
    x28: "112px",
    "x31.5": "126px",
    x32: "128px",
    x36: "144px",
    x39: "156px",
    x40: "160px",
    x42: "168px",
    x44: "176px",
    x46: "188px",
    x48: "192px",
    x52: "208px",
    x56: "224px",
    x60: "240px",
    x63: "252px",
    x64: "256px",
    x72: "288px",
    x78: "305px",
    x80: "320px",
    x88: "352px",
    x90: "360px",
    x96: "384px",
    x104: "412px",
    x111: "444px",
    x112: "448px",
    x118: "489px",
    x128: "512px",
    x144: "576px",
    x155: "600px",
    x160: "640px",
    x166: "668px",
    x188: "752px",
    x192: "768px",
    x194: "778px",
    x208: "832px",
    x212: "848px",
    x216: "864px",
    x224: "896px",
    x228: "912px",
    x244: "928px",
    x260: "944px",
    x308: "1232px",
    x312: "1248px"
});
var size = {
    mobileS: "320px",
    mobileM: "375px",
    mobileL: "425px",
    mobileXL: "480px",
    tabletS: "576px",
    tabletSM: "560px",
    tabletM: "600px",
    tabletML: "678px",
    tabletXM: "700px",
    tablet: "768px",
    tabletL: "826px",
    tabletXL: "850px",
    laptopS: "900px",
    laptop: "1024px",
    laptopM: "1330px",
    laptopL: "1440px",
    laptopXL: "1600px",
    desktopS: "1980px",
    desktop: "2560px"
};
var getDevices = function() {
    var mobileFirst = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var mobileFirstAsString = mobileFirst ? "min-width" : "max-width";
    return {
        mobileS: "(".concat(mobileFirstAsString, ": ").concat(size.mobileS, ")"),
        mobileM: "(".concat(mobileFirstAsString, ": ").concat(size.mobileM, ")"),
        mobileL: "(".concat(mobileFirstAsString, ": ").concat(size.mobileL, ")"),
        mobileXL: "(".concat(mobileFirstAsString, ": ").concat(size.mobileXL, ")"),
        tabletS: "(".concat(mobileFirstAsString, ": ").concat(size.tabletS, ")"),
        tabletSM: "(".concat(mobileFirstAsString, ": ").concat(size.tabletSM, ")"),
        tabletM: "(".concat(mobileFirstAsString, ": ").concat(size.tabletM, ")"),
        tabletXM: "(".concat(mobileFirstAsString, ": ").concat(size.tabletXM, ")"),
        tablet: "(".concat(mobileFirstAsString, ": ").concat(size.tablet, ")"),
        tabletL: "(".concat(mobileFirstAsString, ": ").concat(size.tabletL, ")"),
        tabletML: "(".concat(mobileFirstAsString, ": ").concat(size.tabletML, ")"),
        tabletXL: "(".concat(mobileFirstAsString, ": ").concat(size.tabletXL, ")"),
        laptopS: "(".concat(mobileFirstAsString, ": ").concat(size.laptopS, ")"),
        laptop: "(".concat(mobileFirstAsString, ": ").concat(size.laptop, ")"),
        laptopM: "(".concat(mobileFirstAsString, ": ").concat(size.laptopM, ")"),
        laptopL: "(".concat(mobileFirstAsString, ": ").concat(size.laptopL, ")"),
        laptopXL: "(".concat(mobileFirstAsString, ": ").concat(size.laptopXL, ")"),
        desktopS: "(".concat(mobileFirstAsString, ": ").concat(size.desktopS, ")"),
        desktop: "(".concat(mobileFirstAsString, ": ").concat(size.desktop, ")")
    };
};
var theme = {
    breakpoints: {
        "Breakpoints.xs": "0",
        "Breakpoints.sm": 480,
        "Breakpoints.md": 768,
        "Breakpoints.lg": 992,
        "Breakpoints.xl": 1200
    },
    colors: {
        primary: {
            alert: "#E8273F",
            "10": "#FFE6E7",
            "25": "#ff0000",
            "50": "#FF0915",
            "60": "#FBDDE1",
            "75": "#FEF4F5",
            "77": "#F499A4",
            "80": "#C65555",
            "85": "#D13241",
            "95": "#ED5568",
            "100": "#EE0813",
            "150": "#E71C35",
            "155": "#AA0E27",
            "180": "#E3132F",
            "190": "#EA4335",
            "200": "#DA0812",
            "225": "#DB071E",
            "250": "#DF2D36",
            "300": "#C50710",
            "300-rgb": "rgb(197,7,16)",
            "330": "#CA020C",
            "350": "#BE0F2C",
            "355": "#460610",
            "360": "#B53535",
            "380": "#E8273F",
            "390": "#BA0F2B",
            "400": "#B1060E",
            "500": "#9C050C",
            "550": "#960C23",
            "600": "#88050B",
            "700": "#EB001B",
            "705": "#E3132F",
            "710": "#AE1D2F",
            "725": "#da1f31",
            "730": "#D23A52",
            "750": "#BE1833",
            "800": "#B82126",
            "850": "#EE4023",
            "855": "#CD0027",
            "900": "#AE1D2F",
            "200-opacity-15": "rgba(218,8,18,0.15)"
        },
        secondary: {
            "20": "#f2fbf5",
            "25": "#EBF4EE",
            "28": "#EBF6E3",
            "30": "#f8fcf2",
            "33": "#D0E9BD",
            "35": "#f2f9e9",
            "37": "#A9D785",
            "38": "#5DAA53",
            "39": "#c3e3aa",
            "40": "#c1d82f",
            "45": "#C1D910",
            "50": "#00EF45",
            "100": "#00DA3F",
            "200": "#00C639",
            "225": "#1c9f40",
            "230": "#7AC143",
            "250": "#74B740",
            "255": "#78BE20",
            "260": "#6cb33f",
            "265": "#00B233",
            "270": "#04B437",
            "275": "#00BB23",
            "300": "#00B234",
            "310": "#00B233",
            "315": "#048729",
            "325": "#04892a",
            "340": "#20B038",
            "345": "#5d9233",
            "350": "#5f9834",
            "355": "#5CBE1D",
            "357": "#5A8F19",
            "360": "#629C1B",
            "365": "#60D66A",
            "370": "#6AB760",
            "380": "#68A439",
            "385": "#7AB740",
            "390": "#7ac143",
            "395": "#7FD899",
            "400": "#009D2E",
            "410": "#5CBE1D",
            "415": "#5A8F19",
            "420": "#5A9018",
            "425": "#4F7D2C",
            "430": "#40b770",
            "435": "#4A6538",
            "440": "#34A853",
            "450": "#32bcad",
            "500": "#008928",
            "600": "#007422",
            "650": "#40A737",
            "700": "#048729",
            "750": "#00D95F",
            "755": "rgba(116,183,64,0.25)",
            "760": "rgba(104,164,57,0.2)",
            "850": "#F6F9E0",
            "920": "#def0d0",
            "930": "#C3E3AA",
            "950": "#7D8C1F",
            "960": "#548f19"
        },
        tertiary: {
            "50": "#00A2A2",
            "55": "#7F86DF",
            "100": "#1E90FF",
            "105": "#1478DD",
            "110": "#2196F3",
            "115": "#3E90FD",
            "150": "#48A4F9",
            "200": "#187DE9",
            "205": "#5B5B76",
            "210": "#455A64",
            "250": "#4688f1",
            "260": "#4285F4",
            "280": "#4498E5",
            "300": "#126AD2",
            "400": "#0C56BC",
            "500": "#0643A5",
            "600": "#00308F",
            "700": "#00579F",
            "750": "#0079BE",
            "800": "#26A6D1",
            "850": "#0066B1",
            "900": "#00A3DF",
            "930": "rgba(72,164,249,0.15)",
            "950": "#12122c"
        },
        neutral: {
            "gray-opacity-23": "rgba(160,162,164,0.23)",
            "gray-opacity-35": "#70707059",
            "gray-opacity-50": "rgba(206,206,206,0.5)",
            white: "#FFFFFF",
            // Em Alinhamento com Wellington não colocar espaço nos rgba para não quebrar os testes
            "white-opacity-20": "rgba(255,255,255,0.2)",
            "white-opacity-25": "rgba(255,255,255,0.25)",
            "white-opacity-50": "rgba(255,255,255,0.5)",
            "white-010": "#FFFCF2",
            "white-050": "#F7F7F7",
            "white-075": "#F6F7F7",
            "13": "#FFFCF2",
            "15": "#FDFDFD",
            "25": "#FBFBFB",
            "30": "#F2F2F2",
            "35": "#F2F9F9",
            "40": "#FAFAFA",
            "45": "#F4F4F4",
            "50": "#F8F8F8",
            "55": "#F9F9F9",
            "60": "#F2F2F2",
            "70": "#E0E0E0",
            "75": "#EFEFEF",
            "80": "#F8F8F8",
            "85": "#DAD7D7",
            "88": "#D4D5D6",
            "89": "#D4D4D4",
            "90": "#DFE0E0",
            "95": "#DDDDDD",
            "98": "#DBDBDB",
            "99": "#E5E5E5",
            "100": "#E4E4E4",
            "105": "#E5E5E6",
            "110": "#5C5E62",
            "125": "#EBEBEB",
            "130": "#2E2E2E",
            "150": "#E5E6E6",
            "155": "#EDEDED",
            "170": "#E3E6E4",
            "174": "#EEEEEE",
            "175": "#CBCBCB",
            "200": "#CFCFCF",
            "225": "#C6C7C9",
            "230": "#C4C4C4",
            "240": "#B2B3B5",
            "245": "#F5F5F5",
            "250": "#BBBBBB",
            "255": "#F3F3F3",
            "260": "#DFE0E0",
            "275": "#D8D8D8",
            "278": "#C4C4C4",
            "280": "#B4B4B4",
            "300": "#B1B1B1",
            "305": "#DADADA",
            "310": "#E5E5E5",
            "315": "#BDBDBD",
            "320": "#CCCCCC",
            "325": "#505050",
            "330": "#7E8083",
            "335": "#E7E7E7",
            "340": "#484848",
            "345": "#4F4F4F",
            "350": "#8F9194",
            "375": "#AEB0B2",
            "385": "#8D8D8D",
            "390": "#888888",
            "400": "#9E9E9E",
            "425": "#808080",
            "450": "#9B9B9B",
            "465": "#727578",
            "475": "#979797",
            "480": "#818181",
            "485": "#333333",
            "490": "#36383B",
            "495": "#3D3D3D",
            "500": "#7E7E7E",
            "510": "#727578",
            "520": "#4A4A4A",
            "525": "#4C4A44",
            "530": "#4D4D4D",
            "550": "#53565A",
            "555": "#E5E6E6",
            "560": "#C3C4C5",
            "565": "#433430",
            "570": "#444444",
            "580": "#D4D5D6",
            "585": "#6D6F73",
            "590": "#606060",
            "600": "#626262",
            "625": "#606060",
            "630": "#727578",
            "650": "#777777",
            "655": "#535659",
            "665": "#838383",
            "670": "#252728",
            "675": "#222235",
            "680": "#2E2F32",
            "690": "#36383B",
            "695": "#3E4144",
            "700": "#565656",
            "705": "#1D1D1B",
            "710": "#575757",
            "715": "#1D1E1F",
            "720": "#4F5256",
            "730": "#5c5e62",
            "740": "#A43939",
            "750": "#47494D",
            "760": "#A0A2A4",
            "805": "#0A0A0A",
            "810": "#00000066",
            "815": "#484848",
            "820": "#00000060",
            "825": "#45454591",
            "830": "#00000095",
            "835": "#0000001A",
            "850": "#222235",
            "875": "#00000012",
            "900": "#161616",
            "925": "#373738",
            "930": "#0C0C0C",
            "940": "#040405",
            "999": "#000000",
            // Em Alinhamento com Wellington não colocar espaço nos rgba para não quebrar os testes
            "999-opacity-05": "rgba(0,0,0,0.05)",
            "760-opacity-23": "rgba(160,162,164,0.23)",
            "900-opacity-25": "rgba(21,22,23,0.25)",
            "900-opacity-32": "rgba(83,86,90,0.32)",
            "999-opacity-025": "rgba(0,0,0,0.025)",
            "999-opacity-10": "rgba(0,0,0,0.1)",
            "999-opacity-11": "rgba(0,0,0,0.11)",
            "999-opacity-12": "rgba(0,0,0,0.12)",
            "999-opacity-15": "rgba(0,0,0,0.15)",
            "999-opacity-19": "rgba(0,0,0,0.19)",
            "999-opacity-20": "rgba(0,0,0,0.2)",
            "999-opacity-25": "rgba(0,0,0,0.25)",
            "999-opacity-50": "rgba(0,0,0,0.5)",
            "999-opacity-55": "rgba(0,0,0,.7)",
            "999-opacity-60": "rgba(0,0,0,.25)",
            "999-opacity-65": "rgba(0,0,0,0.06)",
            "999-opacity-70": "rgba(151,151,151,0.47)",
            "999-opacity-75": "rgba(113,113,113)"
        },
        orange: {
            "100": "#DC841B",
            "200": "#d34836",
            "300": "#b33e2f",
            "400": "#FF5F00"
        },
        yellow: {
            "40": "#FFA51E",
            "45": "#FFD540",
            "50": "#F5A623",
            "55": "#F8D35E",
            "70": "#FBBC05",
            "80": "#bf9500",
            "100": "#c78517",
            "110": "#EFD912",
            "150": "#E58604",
            "170": "#E7A807",
            "200": "#FAA61A",
            "300": "#F07C00",
            "400": "#FFEC00",
            "500": "#FFF100",
            "600": "#F0D04E",
            "650": "#F2BD00",
            "850": "#FFF7D9",
            "950": "#F79E1B",
            "1000": "#E8B227",
            "1020": "#D9A900",
            "1040": "#A68100",
            "1050": "#BF9500",
            "1100": "#C1D910",
            "1150": "#8C6D00",
            "1200": "#BF9500"
        },
        pink: {
            "50": "#ffe6e7",
            "55": "#ffd4d4",
            "60": "#faf9fa",
            "65": "#F6D6DB",
            "70": "#EBA6B1"
        },
        blackFriday: {
            white: "#FFFFFF",
            black: "#000000",
            "5": "#F8F8F8",
            "10": "#FBFBFB",
            "15": "#F6F7F7",
            "17": "#EBF6E3",
            "20": "#E5E6E6",
            "25": "#D4D5D6",
            "30": "#DDDDDD",
            "33": "#CFCFCF",
            "35": "#B2B3B5",
            "40": "#A0A2A4",
            "45": "#8F9194",
            "50": "#6D6F73",
            "75": "#5C5E62",
            "85": "#53565A",
            "80": "#7E7E7E",
            "100": "#47494D",
            "110": "#3E4144",
            "115": "#4A4A4A",
            "120": "#4D4D4D",
            "125": "#36383B",
            "150": "#2E2F32",
            "175": "#252728",
            "185": "#1D1E1F",
            "200": "#151617",
            "210": "#0C0D0E",
            "230": "#0A0A0A",
            "300": "#81C44C",
            "320": "#74B740",
            "400": "#FEF4F5",
            "420": "#E71C35",
            "480": "#DA0812"
        }
    },
    device: {
        mobileFirst: getDevices(true),
        desktopFirst: getDevices(false),
        size: size
    },
    typography: {
        fontFamily: {
            barlow: "Barlow",
            openSans: "Open Sans",
            roboto: "Roboto",
            chivo: "Chivo",
            playfairDisplay: "Playfair Display",
            inter: "Inter"
        },
        fontSize: {
            /**
       * sm - medidas entre 10px e 18px
       */ sm: {
                x1: "10px",
                x2: "11px",
                x3: "12px",
                x4: "13px",
                x5: "14px",
                x6: "15px",
                x7: "16px",
                x8: "17px",
                x9: "18px"
            },
            /**
       * md - medidas entre 20px e 28px
       */ md: {
                x1: "20px",
                x2: "22px",
                x3: "24px",
                x4: "26px",
                x5: "28px"
            },
            /**
       * lg - medidas entre 30px e 64px
       */ lg: {
                x1: "30px",
                x2: "32px",
                x3: "36px",
                x4: "40px",
                x5: "50px",
                x6: "56px",
                x7: "60px",
                x8: "64px"
            }
        },
        fontWeight: {
            "100": 100,
            "200": 200,
            "300": 300,
            "400": 400,
            "500": 500,
            "600": 600,
            "700": 700,
            "800": 800,
            "900": 900,
            bold: "bold",
            bolder: "bolder",
            normal: "normal"
        }
    },
    space: space
};

;// CONCATENATED MODULE: ../../packages/ui/themes/componentsThemes/blackFriday/CustomProductList/index.ts

var blackFridayProductListTheme = {
    horizontal: {
        titleColor: theme.colors.blackFriday.white,
        descriptionColor: theme.colors.blackFriday[115],
        oldPriceColor: theme.colors.blackFriday[45],
        priceColor: theme.colors.blackFriday[175],
        staleText: theme.colors.blackFriday[230],
        sliderButton: {
            backgroundColor: {
                default: theme.colors.blackFriday[50],
                disabled: theme.colors.blackFriday[110],
                hover: theme.colors.blackFriday[420]
            },
            arrowColor: {
                default: theme.colors.blackFriday[20],
                disabled: theme.colors.blackFriday[40],
                hover: theme.colors.blackFriday.white
            }
        },
        ctaButton: {
            backgroundColor: {
                default: theme.colors.blackFriday[320],
                disabled: "",
                hover: ""
            },
            textColor: {
                default: theme.colors.blackFriday.white,
                disabled: "",
                hover: ""
            }
        },
        tagCta: {
            backgroundColor: {
                default: theme.colors.blackFriday[17]
            },
            textColor: {
                default: theme.colors.blackFriday[320]
            }
        }
    },
    vertical: {
        titleColor: theme.colors.blackFriday.white,
        descriptionColor: "#4A4A4A",
        oldPriceColor: "#8F9194",
        priceColor: theme.colors.blackFriday[480],
        staleText: "#0A0A0A",
        ctaButton: {
            backgroundColor: {
                default: theme.colors.blackFriday[320],
                disabled: "",
                hover: ""
            },
            textColor: {
                default: theme.colors.blackFriday.white,
                disabled: "",
                hover: ""
            }
        },
        tagCta: {
            backgroundColor: {
                default: theme.colors.blackFriday[17]
            },
            textColor: {
                default: theme.colors.blackFriday[320]
            }
        },
        seeMoreButton: {
            backgroundColor: {
                default: theme.colors.blackFriday[480],
                disabled: "",
                hover: ""
            },
            textColor: {
                default: theme.colors.blackFriday[20],
                disabled: ""
            }
        }
    }
};

;// CONCATENATED MODULE: ../../packages/ui/themes/componentsThemes/blackFriday/CustomCarousel/index.ts

var blackFridayCarouselTheme = {
    textColor: theme.colors.blackFriday[15],
    container: theme.colors.blackFriday[185],
    sliderButton: {
        backgroundColor: {
            default: theme.colors.blackFriday[50],
            disabled: theme.colors.blackFriday[110],
            hover: theme.colors.blackFriday[420]
        },
        arrowColor: {
            default: theme.colors.blackFriday[20],
            disabled: theme.colors.blackFriday[40],
            hover: theme.colors.blackFriday.white
        }
    },
    dots: {
        activated: theme.colors.blackFriday[420],
        deactivated: theme.colors.blackFriday[25]
    }
};

;// CONCATENATED MODULE: ../../packages/ui/themes/componentsThemes/blackFriday/index.ts



;// CONCATENATED MODULE: ../../packages/ui/themes/componentsThemes/index.ts


;// CONCATENATED MODULE: ../../packages/ui/themes/oficial/tokens/colors.ts
var colors = {
    common: {
        white: "#FFFFFF",
        black: "#000000",
        transparent: "transparent"
    },
    primary: {
        red: {
            light: {
                50: "#E8273F",
                150: "#EB3E53",
                250: "#ED5568",
                350: "#EF6B7C",
                450: "#F28290",
                550: "#F499A4",
                650: "#F7B0B8",
                750: "#F9C6CD",
                850: "#FBDDE1",
                950: "#FEF4F5"
            },
            dark: {
                50: "#BE0F2C",
                150: "#AA0E27",
                250: "#960C23",
                350: "#820A1E",
                450: "#6E0919",
                550: "#5A0715",
                650: "#460610",
                750: "#32040C",
                850: "#1E0207",
                950: "#0A0102"
            }
        },
        green: {
            light: {
                50: "#81C44C",
                150: "#8ECA5F",
                250: "#9BD172",
                350: "#A9D785",
                450: "#B6DD98",
                550: "#C3E3AA",
                650: "#D0E9BD",
                750: "#DEF0D0",
                850: "#EBF6E3",
                950: "#F8FCF6"
            },
            dark: {
                50: "#74B740",
                150: "#68A439",
                250: "#5A8F19",
                350: "#4F7D2C",
                450: "#436A25",
                550: "#37571E",
                650: "#2B4417",
                750: "#1F3011",
                850: "#121D0A",
                950: "#060A03"
            }
        },
        pear: {
            light: {
                50: "#C4DA39",
                150: "#CADE4E",
                250: "#D1E263",
                350: "#D7E678",
                450: "#DDEA8D",
                550: "#E3EDA1",
                650: "#E9F1B6",
                750: "#F0F5CB",
                850: "#F6F9E0",
                950: "#FCFDF5"
            },
            dark: {
                50: "#B7CD2D",
                150: "#A4B828",
                250: "#91A223",
                350: "#7D8C1F",
                450: "#6A771A",
                550: "#576115",
                650: "#444C10",
                750: "#30360C",
                850: "#1D2007",
                950: "#0A0B02"
            }
        },
        gray: {
            light: {
                50: "#5C5E62",
                150: "#6D6F73",
                250: "#7E8083",
                350: "#8F9194",
                450: "#A0A2A4",
                550: "#B2B3B5",
                650: "#C3C4C5",
                750: "#D4D5D6",
                850: "#E5E6E6",
                950: "#F6F7F7"
            },
            dark: {
                50: "#4F5256",
                150: "#47494D",
                250: "#3E4144",
                350: "#36383B",
                450: "#2E2F32",
                550: "#252728",
                650: "#1D1E1F",
                750: "#151617",
                850: "#0C0D0E",
                950: "#040405"
            }
        }
    },
    secondary: {
        yellow: {
            light: {
                50: "#FFCA0D",
                150: "#FFCF26",
                250: "#FFD540",
                350: "#FFDB59",
                450: "#FFE073",
                550: "#FFE68C",
                650: "#FFEBA6",
                750: "#FFF1BF",
                850: "#FFF7D9",
                950: "#FFFCF2"
            },
            dark: {
                50: "#F2BD00",
                150: "#D9A900",
                250: "#BF9500",
                350: "#A68100",
                450: "#8C6D00",
                550: "#735A00",
                650: "#594600",
                750: "#403200",
                850: "#261E00",
                950: "#0D0A00"
            }
        }
    },
    variants: {
        blackFriday: {
            "5": "#F8F8F8",
            "10": "#FBFBFB",
            "15": "#F6F7F7",
            "17": "#EBF6E3",
            "20": "#E5E6E6",
            "25": "#D4D5D6",
            "30": "#DDDDDD",
            "33": "#CFCFCF",
            "35": "#B2B3B5",
            "40": "#A0A2A4",
            "45": "#8F9194",
            "50": "#6D6F73",
            "75": "#5C5E62",
            "85": "#53565A",
            "80": "#7E7E7E",
            "100": "#47494D",
            "110": "#3E4144",
            "115": "#4A4A4A",
            "120": "#4D4D4D",
            "125": "#36383B",
            "150": "#2E2F32",
            "175": "#252728",
            "185": "#1D1E1F",
            "200": "#151617",
            "210": "#0C0D0E",
            "230": "#0A0A0A",
            "300": "#81C44C",
            "320": "#74B740",
            "400": "#FEF4F5",
            "420": "#E71C35",
            "480": "#DA0812"
        },
        opacity: {}
    }
};

;// CONCATENATED MODULE: ../../packages/ui/themes/oficial/tokens/font-family.ts
var fontFamily = {
    barlow: "Barlow",
    openSans: "Open Sans",
    roboto: "Roboto",
    chivo: "Chivo",
    playfairDisplay: "Playfair Display",
    inter: "Inter"
};

;// CONCATENATED MODULE: ../../packages/ui/themes/oficial/tokens/font-size.ts
var fontSize = {
    sm: {
        1: "0.625rem",
        2: "0.75rem",
        3: "0.875rem"
    },
    md: {
        1: "1rem",
        2: "1.125rem",
        3: "1.25rem"
    },
    lg: {
        1: "1.5rem",
        2: "1.75rem",
        3: "2rem"
    },
    xlg: {
        1: "2.5rem",
        2: "2.625rem",
        3: "3rem",
        4: "3.375rem"
    }
};

;// CONCATENATED MODULE: ../../packages/ui/themes/oficial/tokens/font-weight.ts
var fontWeight = {
    100: 100,
    200: 200,
    300: 300,
    400: 400,
    500: 500,
    600: 600,
    700: 700,
    800: 800,
    900: 900,
    bold: "bold",
    bolder: "bolder",
    normal: "normal"
};

;// CONCATENATED MODULE: ../../packages/ui/themes/oficial/tokens/line-height.ts

var lineHeight = {
    sm: {
        1: "calc(1 / ".concat(fontSize.sm[1].replace("rem", ""), ")"),
        2: "calc(1.25 / ".concat(fontSize.sm[2].replace("rem", ""), ")"),
        3: "calc(1.375 / ".concat(fontSize.sm[3].replace("rem", ""), ")")
    },
    md: {
        1: "calc(1.5 / ".concat(fontSize.md[1].replace("rem", ""), ")"),
        2: "calc(1.625 / ".concat(fontSize.md[2].replace("rem", ""), ")"),
        3: "calc(1.75 / ".concat(fontSize.md[3].replace("rem", ""), ")")
    },
    lg: {
        1: "calc(2 / ".concat(fontSize.lg[1].replace("rem", ""), ")"),
        2: "calc(2.25 / ".concat(fontSize.lg[2].replace("rem", ""), ")"),
        3: "calc(2.5 / ".concat(fontSize.lg[3].replace("rem", ""), ")")
    },
    xlg: {
        1: "calc(3 / ".concat(fontSize.xlg[1].replace("rem", ""), ")"),
        2: "calc(3.25 / ".concat(fontSize.xlg[2].replace("rem", ""), ")"),
        3: "calc(3.5 / ".concat(fontSize.xlg[3].replace("rem", ""), ")"),
        4: "calc(3.75 / ".concat(fontSize.xlg[4].replace("rem", ""), ")")
    }
};

;// CONCATENATED MODULE: ../../packages/ui/themes/oficial/tokens/space.ts
var space_space = {
    xs: {
        1: "0.25rem",
        2: "0.5rem",
        3: "0.625rem",
        4: "0.75rem",
        5: "1rem"
    },
    sm: {
        1: "1.25rem",
        2: "1.5rem",
        3: "1.75rem",
        4: "2rem",
        5: "2.5rem"
    },
    md: {
        1: "3rem",
        2: "3.5rem",
        3: "4rem",
        4: "5rem",
        5: "6rem"
    },
    lg: {
        1: "7rem",
        2: "8rem",
        3: "10rem",
        4: "12rem",
        5: "14rem"
    },
    xl: {
        1: "16rem",
        2: "18rem",
        3: "20rem",
        4: "22rem",
        5: "24rem"
    },
    xxl: {
        1: "28rem",
        2: "32rem",
        3: "36rem",
        4: "40rem",
        5: "44rem"
    },
    percent: {
        1: "10%",
        2: "25%",
        3: "50%",
        4: "75%",
        5: "100%"
    }
};

;// CONCATENATED MODULE: ../../packages/ui/themes/oficial/tokens/breakpoints.ts
var breakpoints = {
    mobile: {
        S: "320px",
        M: "375px",
        L: "425px",
        XL: "480px"
    },
    tablet: {
        XS: "560px",
        SM: "576px",
        MD: "600px",
        LG: "678px",
        XL: "700px",
        "2XL": "768px",
        "3XL": "826px",
        "4XL": "850px"
    },
    laptop: {
        XS: "900px",
        SM: "1024px",
        M: "1330px",
        L: "1440px",
        XL: "1600px"
    },
    desktop: {
        S: "1980px",
        M: "2560px"
    }
};

;// CONCATENATED MODULE: ../../packages/ui/themes/oficial/tokens/index.ts








;// CONCATENATED MODULE: ../../packages/ui/themes/oficial/helpers/getDevices.ts

var getDevices_getDevices = function() {
    var mobileFirst = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var mobileFirstAsString = mobileFirst ? "min-width" : "max-width";
    return {
        mobileS: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.mobile.S, ")"),
        mobileM: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.mobile.M, ")"),
        mobileL: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.mobile.L, ")"),
        mobileXL: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.mobile.XL, ")"),
        tabletXS: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.tablet.XS, ")"),
        tabletSM: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.tablet.SM, ")"),
        tabletMD: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.tablet.MD, ")"),
        tabletLG: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.tablet.LG, ")"),
        tabletXL: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.tablet.XL, ")"),
        tablet2XL: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.tablet["2XL"], ")"),
        tablet3XL: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.tablet["3XL"], ")"),
        tablet4XL: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.tablet["4XL"], ")"),
        laptopXS: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.laptop.XS, ")"),
        laptopSM: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.laptop.SM, ")"),
        laptopM: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.laptop.M, ")"),
        laptopL: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.laptop.L, ")"),
        laptopXL: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.laptop.XL, ")"),
        desktopS: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.desktop.S, ")"),
        desktopM: "(".concat(mobileFirstAsString, ": ").concat(breakpoints.desktop.M, ")")
    };
};

;// CONCATENATED MODULE: ../../packages/ui/themes/oficial/themes.tsx


var oficialTheme = {
    device: {
        mobileFirst: getDevices_getDevices(true),
        desktopFirst: getDevices_getDevices(false),
        breakpoints: breakpoints
    },
    breakpoints: breakpoints,
    colors: colors,
    lineHeight: lineHeight,
    typography: {
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeight: fontWeight
    },
    space: space_space
};

;// CONCATENATED MODULE: ../../packages/ui/themes/index.ts





/***/ }),

/***/ 71941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(48834)["Buffer"];
/* provided dependency */ var process = __webpack_require__(34406);
(function(){var e={7160:function(e,t,r){var i=t;i.bignum=r(711);i.define=r(495).define;i.base=r(853);i.constants=r(7335);i.decoders=r(6701);i.encoders=r(3418)},495:function(e,t,r){var i=r(7160);var n=r(3782);var a=t;a.define=function define(e,t){return new Entity(e,t)};function Entity(e,t){this.name=e;this.body=t;this.decoders={};this.encoders={}}Entity.prototype._createNamed=function createNamed(e){var t;try{t=r(6144).runInThisContext("(function "+this.name+"(entity) {\n"+"  this._initNamed(entity);\n"+"})")}catch(e){t=function(e){this._initNamed(e)}}n(t,e);t.prototype._initNamed=function initnamed(t){e.call(this,t)};return new t(this)};Entity.prototype._getDecoder=function _getDecoder(e){e=e||"der";if(!this.decoders.hasOwnProperty(e))this.decoders[e]=this._createNamed(i.decoders[e]);return this.decoders[e]};Entity.prototype.decode=function decode(e,t,r){return this._getDecoder(t).decode(e,r)};Entity.prototype._getEncoder=function _getEncoder(e){e=e||"der";if(!this.encoders.hasOwnProperty(e))this.encoders[e]=this._createNamed(i.encoders[e]);return this.encoders[e]};Entity.prototype.encode=function encode(e,t,r){return this._getEncoder(t).encode(e,r)}},6483:function(e,t,r){var i=r(3782);var n=r(853).Reporter;var a=r(4300).Buffer;function DecoderBuffer(e,t){n.call(this,t);if(!a.isBuffer(e)){this.error("Input not Buffer");return}this.base=e;this.offset=0;this.length=e.length}i(DecoderBuffer,n);t.C=DecoderBuffer;DecoderBuffer.prototype.save=function save(){return{offset:this.offset,reporter:n.prototype.save.call(this)}};DecoderBuffer.prototype.restore=function restore(e){var t=new DecoderBuffer(this.base);t.offset=e.offset;t.length=this.offset;this.offset=e.offset;n.prototype.restore.call(this,e.reporter);return t};DecoderBuffer.prototype.isEmpty=function isEmpty(){return this.offset===this.length};DecoderBuffer.prototype.readUInt8=function readUInt8(e){if(this.offset+1<=this.length)return this.base.readUInt8(this.offset++,true);else return this.error(e||"DecoderBuffer overrun")};DecoderBuffer.prototype.skip=function skip(e,t){if(!(this.offset+e<=this.length))return this.error(t||"DecoderBuffer overrun");var r=new DecoderBuffer(this.base);r._reporterState=this._reporterState;r.offset=this.offset;r.length=this.offset+e;this.offset+=e;return r};DecoderBuffer.prototype.raw=function raw(e){return this.base.slice(e?e.offset:this.offset,this.length)};function EncoderBuffer(e,t){if(Array.isArray(e)){this.length=0;this.value=e.map((function(e){if(!(e instanceof EncoderBuffer))e=new EncoderBuffer(e,t);this.length+=e.length;return e}),this)}else if(typeof e==="number"){if(!(0<=e&&e<=255))return t.error("non-byte EncoderBuffer value");this.value=e;this.length=1}else if(typeof e==="string"){this.value=e;this.length=a.byteLength(e)}else if(a.isBuffer(e)){this.value=e;this.length=e.length}else{return t.error("Unsupported type: "+typeof e)}}t.R=EncoderBuffer;EncoderBuffer.prototype.join=function join(e,t){if(!e)e=new a(this.length);if(!t)t=0;if(this.length===0)return e;if(Array.isArray(this.value)){this.value.forEach((function(r){r.join(e,t);t+=r.length}))}else{if(typeof this.value==="number")e[t]=this.value;else if(typeof this.value==="string")e.write(this.value,t);else if(a.isBuffer(this.value))this.value.copy(e,t);t+=this.length}return e}},853:function(e,t,r){var i=t;i.Reporter=r(1293).b;i.DecoderBuffer=r(6483).C;i.EncoderBuffer=r(6483).R;i.Node=r(9374)},9374:function(e,t,r){var i=r(853).Reporter;var n=r(853).EncoderBuffer;var a=r(853).DecoderBuffer;var s=r(3523);var o=["seq","seqof","set","setof","objid","bool","gentime","utctime","null_","enum","int","objDesc","bitstr","bmpstr","charstr","genstr","graphstr","ia5str","iso646str","numstr","octstr","printstr","t61str","unistr","utf8str","videostr"];var h=["key","obj","use","optional","explicit","implicit","def","choice","any","contains"].concat(o);var u=["_peekTag","_decodeTag","_use","_decodeStr","_decodeObjid","_decodeTime","_decodeNull","_decodeInt","_decodeBool","_decodeList","_encodeComposite","_encodeStr","_encodeObjid","_encodeTime","_encodeNull","_encodeInt","_encodeBool"];function Node(e,t){var r={};this._baseState=r;r.enc=e;r.parent=t||null;r.children=null;r.tag=null;r.args=null;r.reverseArgs=null;r.choice=null;r.optional=false;r.any=false;r.obj=false;r.use=null;r.useDecoder=null;r.key=null;r["default"]=null;r.explicit=null;r.implicit=null;r.contains=null;if(!r.parent){r.children=[];this._wrap()}}e.exports=Node;var d=["enc","parent","children","tag","args","reverseArgs","choice","optional","any","obj","use","alteredUse","key","default","explicit","implicit","contains"];Node.prototype.clone=function clone(){var e=this._baseState;var t={};d.forEach((function(r){t[r]=e[r]}));var r=new this.constructor(t.parent);r._baseState=t;return r};Node.prototype._wrap=function wrap(){var e=this._baseState;h.forEach((function(t){this[t]=function _wrappedMethod(){var r=new this.constructor(this);e.children.push(r);return r[t].apply(r,arguments)}}),this)};Node.prototype._init=function init(e){var t=this._baseState;s(t.parent===null);e.call(this);t.children=t.children.filter((function(e){return e._baseState.parent===this}),this);s.equal(t.children.length,1,"Root node can have only one child")};Node.prototype._useArgs=function useArgs(e){var t=this._baseState;var r=e.filter((function(e){return e instanceof this.constructor}),this);e=e.filter((function(e){return!(e instanceof this.constructor)}),this);if(r.length!==0){s(t.children===null);t.children=r;r.forEach((function(e){e._baseState.parent=this}),this)}if(e.length!==0){s(t.args===null);t.args=e;t.reverseArgs=e.map((function(e){if(typeof e!=="object"||e.constructor!==Object)return e;var t={};Object.keys(e).forEach((function(r){if(r==(r|0))r|=0;var i=e[r];t[i]=r}));return t}))}};u.forEach((function(e){Node.prototype[e]=function _overrided(){var t=this._baseState;throw new Error(e+" not implemented for encoding: "+t.enc)}}));o.forEach((function(e){Node.prototype[e]=function _tagMethod(){var t=this._baseState;var r=Array.prototype.slice.call(arguments);s(t.tag===null);t.tag=e;this._useArgs(r);return this}}));Node.prototype.use=function use(e){s(e);var t=this._baseState;s(t.use===null);t.use=e;return this};Node.prototype.optional=function optional(){var e=this._baseState;e.optional=true;return this};Node.prototype.def=function def(e){var t=this._baseState;s(t["default"]===null);t["default"]=e;t.optional=true;return this};Node.prototype.explicit=function explicit(e){var t=this._baseState;s(t.explicit===null&&t.implicit===null);t.explicit=e;return this};Node.prototype.implicit=function implicit(e){var t=this._baseState;s(t.explicit===null&&t.implicit===null);t.implicit=e;return this};Node.prototype.obj=function obj(){var e=this._baseState;var t=Array.prototype.slice.call(arguments);e.obj=true;if(t.length!==0)this._useArgs(t);return this};Node.prototype.key=function key(e){var t=this._baseState;s(t.key===null);t.key=e;return this};Node.prototype.any=function any(){var e=this._baseState;e.any=true;return this};Node.prototype.choice=function choice(e){var t=this._baseState;s(t.choice===null);t.choice=e;this._useArgs(Object.keys(e).map((function(t){return e[t]})));return this};Node.prototype.contains=function contains(e){var t=this._baseState;s(t.use===null);t.contains=e;return this};Node.prototype._decode=function decode(e,t){var r=this._baseState;if(r.parent===null)return e.wrapResult(r.children[0]._decode(e,t));var i=r["default"];var n=true;var s=null;if(r.key!==null)s=e.enterKey(r.key);if(r.optional){var o=null;if(r.explicit!==null)o=r.explicit;else if(r.implicit!==null)o=r.implicit;else if(r.tag!==null)o=r.tag;if(o===null&&!r.any){var h=e.save();try{if(r.choice===null)this._decodeGeneric(r.tag,e,t);else this._decodeChoice(e,t);n=true}catch(e){n=false}e.restore(h)}else{n=this._peekTag(e,o,r.any);if(e.isError(n))return n}}var u;if(r.obj&&n)u=e.enterObject();if(n){if(r.explicit!==null){var d=this._decodeTag(e,r.explicit);if(e.isError(d))return d;e=d}var c=e.offset;if(r.use===null&&r.choice===null){if(r.any)var h=e.save();var l=this._decodeTag(e,r.implicit!==null?r.implicit:r.tag,r.any);if(e.isError(l))return l;if(r.any)i=e.raw(h);else e=l}if(t&&t.track&&r.tag!==null)t.track(e.path(),c,e.length,"tagged");if(t&&t.track&&r.tag!==null)t.track(e.path(),e.offset,e.length,"content");if(r.any)i=i;else if(r.choice===null)i=this._decodeGeneric(r.tag,e,t);else i=this._decodeChoice(e,t);if(e.isError(i))return i;if(!r.any&&r.choice===null&&r.children!==null){r.children.forEach((function decodeChildren(r){r._decode(e,t)}))}if(r.contains&&(r.tag==="octstr"||r.tag==="bitstr")){var p=new a(i);i=this._getUse(r.contains,e._reporterState.obj)._decode(p,t)}}if(r.obj&&n)i=e.leaveObject(u);if(r.key!==null&&(i!==null||n===true))e.leaveKey(s,r.key,i);else if(s!==null)e.exitKey(s);return i};Node.prototype._decodeGeneric=function decodeGeneric(e,t,r){var i=this._baseState;if(e==="seq"||e==="set")return null;if(e==="seqof"||e==="setof")return this._decodeList(t,e,i.args[0],r);else if(/str$/.test(e))return this._decodeStr(t,e,r);else if(e==="objid"&&i.args)return this._decodeObjid(t,i.args[0],i.args[1],r);else if(e==="objid")return this._decodeObjid(t,null,null,r);else if(e==="gentime"||e==="utctime")return this._decodeTime(t,e,r);else if(e==="null_")return this._decodeNull(t,r);else if(e==="bool")return this._decodeBool(t,r);else if(e==="objDesc")return this._decodeStr(t,e,r);else if(e==="int"||e==="enum")return this._decodeInt(t,i.args&&i.args[0],r);if(i.use!==null){return this._getUse(i.use,t._reporterState.obj)._decode(t,r)}else{return t.error("unknown tag: "+e)}};Node.prototype._getUse=function _getUse(e,t){var r=this._baseState;r.useDecoder=this._use(e,t);s(r.useDecoder._baseState.parent===null);r.useDecoder=r.useDecoder._baseState.children[0];if(r.implicit!==r.useDecoder._baseState.implicit){r.useDecoder=r.useDecoder.clone();r.useDecoder._baseState.implicit=r.implicit}return r.useDecoder};Node.prototype._decodeChoice=function decodeChoice(e,t){var r=this._baseState;var i=null;var n=false;Object.keys(r.choice).some((function(a){var s=e.save();var o=r.choice[a];try{var h=o._decode(e,t);if(e.isError(h))return false;i={type:a,value:h};n=true}catch(t){e.restore(s);return false}return true}),this);if(!n)return e.error("Choice not matched");return i};Node.prototype._createEncoderBuffer=function createEncoderBuffer(e){return new n(e,this.reporter)};Node.prototype._encode=function encode(e,t,r){var i=this._baseState;if(i["default"]!==null&&i["default"]===e)return;var n=this._encodeValue(e,t,r);if(n===undefined)return;if(this._skipDefault(n,t,r))return;return n};Node.prototype._encodeValue=function encode(e,t,r){var n=this._baseState;if(n.parent===null)return n.children[0]._encode(e,t||new i);var a=null;this.reporter=t;if(n.optional&&e===undefined){if(n["default"]!==null)e=n["default"];else return}var s=null;var o=false;if(n.any){a=this._createEncoderBuffer(e)}else if(n.choice){a=this._encodeChoice(e,t)}else if(n.contains){s=this._getUse(n.contains,r)._encode(e,t);o=true}else if(n.children){s=n.children.map((function(r){if(r._baseState.tag==="null_")return r._encode(null,t,e);if(r._baseState.key===null)return t.error("Child should have a key");var i=t.enterKey(r._baseState.key);if(typeof e!=="object")return t.error("Child expected, but input is not object");var n=r._encode(e[r._baseState.key],t,e);t.leaveKey(i);return n}),this).filter((function(e){return e}));s=this._createEncoderBuffer(s)}else{if(n.tag==="seqof"||n.tag==="setof"){if(!(n.args&&n.args.length===1))return t.error("Too many args for : "+n.tag);if(!Array.isArray(e))return t.error("seqof/setof, but data is not Array");var h=this.clone();h._baseState.implicit=null;s=this._createEncoderBuffer(e.map((function(r){var i=this._baseState;return this._getUse(i.args[0],e)._encode(r,t)}),h))}else if(n.use!==null){a=this._getUse(n.use,r)._encode(e,t)}else{s=this._encodePrimitive(n.tag,e);o=true}}var a;if(!n.any&&n.choice===null){var u=n.implicit!==null?n.implicit:n.tag;var d=n.implicit===null?"universal":"context";if(u===null){if(n.use===null)t.error("Tag could be omitted only for .use()")}else{if(n.use===null)a=this._encodeComposite(u,o,d,s)}}if(n.explicit!==null)a=this._encodeComposite(n.explicit,false,"context",a);return a};Node.prototype._encodeChoice=function encodeChoice(e,t){var r=this._baseState;var i=r.choice[e.type];if(!i){s(false,e.type+" not found in "+JSON.stringify(Object.keys(r.choice)))}return i._encode(e.value,t)};Node.prototype._encodePrimitive=function encodePrimitive(e,t){var r=this._baseState;if(/str$/.test(e))return this._encodeStr(t,e);else if(e==="objid"&&r.args)return this._encodeObjid(t,r.reverseArgs[0],r.args[1]);else if(e==="objid")return this._encodeObjid(t,null,null);else if(e==="gentime"||e==="utctime")return this._encodeTime(t,e);else if(e==="null_")return this._encodeNull();else if(e==="int"||e==="enum")return this._encodeInt(t,r.args&&r.reverseArgs[0]);else if(e==="bool")return this._encodeBool(t);else if(e==="objDesc")return this._encodeStr(t,e);else throw new Error("Unsupported tag: "+e)};Node.prototype._isNumstr=function isNumstr(e){return/^[0-9 ]*$/.test(e)};Node.prototype._isPrintstr=function isPrintstr(e){return/^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(e)}},1293:function(e,t,r){var i=r(3782);function Reporter(e){this._reporterState={obj:null,path:[],options:e||{},errors:[]}}t.b=Reporter;Reporter.prototype.isError=function isError(e){return e instanceof ReporterError};Reporter.prototype.save=function save(){var e=this._reporterState;return{obj:e.obj,pathLen:e.path.length}};Reporter.prototype.restore=function restore(e){var t=this._reporterState;t.obj=e.obj;t.path=t.path.slice(0,e.pathLen)};Reporter.prototype.enterKey=function enterKey(e){return this._reporterState.path.push(e)};Reporter.prototype.exitKey=function exitKey(e){var t=this._reporterState;t.path=t.path.slice(0,e-1)};Reporter.prototype.leaveKey=function leaveKey(e,t,r){var i=this._reporterState;this.exitKey(e);if(i.obj!==null)i.obj[t]=r};Reporter.prototype.path=function path(){return this._reporterState.path.join("/")};Reporter.prototype.enterObject=function enterObject(){var e=this._reporterState;var t=e.obj;e.obj={};return t};Reporter.prototype.leaveObject=function leaveObject(e){var t=this._reporterState;var r=t.obj;t.obj=e;return r};Reporter.prototype.error=function error(e){var t;var r=this._reporterState;var i=e instanceof ReporterError;if(i){t=e}else{t=new ReporterError(r.path.map((function(e){return"["+JSON.stringify(e)+"]"})).join(""),e.message||e,e.stack)}if(!r.options.partial)throw t;if(!i)r.errors.push(t);return t};Reporter.prototype.wrapResult=function wrapResult(e){var t=this._reporterState;if(!t.options.partial)return e;return{result:this.isError(e)?null:e,errors:t.errors}};function ReporterError(e,t){this.path=e;this.rethrow(t)}i(ReporterError,Error);ReporterError.prototype.rethrow=function rethrow(e){this.message=e+" at: "+(this.path||"(shallow)");if(Error.captureStackTrace)Error.captureStackTrace(this,ReporterError);if(!this.stack){try{throw new Error(this.message)}catch(e){this.stack=e.stack}}return this}},9791:function(e,t,r){var i=r(7335);t.tagClass={0:"universal",1:"application",2:"context",3:"private"};t.tagClassByName=i._reverse(t.tagClass);t.tag={0:"end",1:"bool",2:"int",3:"bitstr",4:"octstr",5:"null_",6:"objid",7:"objDesc",8:"external",9:"real",10:"enum",11:"embed",12:"utf8str",13:"relativeOid",16:"seq",17:"set",18:"numstr",19:"printstr",20:"t61str",21:"videostr",22:"ia5str",23:"utctime",24:"gentime",25:"graphstr",26:"iso646str",27:"genstr",28:"unistr",29:"charstr",30:"bmpstr"};t.tagByName=i._reverse(t.tag)},7335:function(e,t,r){var i=t;i._reverse=function reverse(e){var t={};Object.keys(e).forEach((function(r){if((r|0)==r)r=r|0;var i=e[r];t[i]=r}));return t};i.der=r(9791)},2259:function(e,t,r){var i=r(3782);var n=r(7160);var a=n.base;var s=n.bignum;var o=n.constants.der;function DERDecoder(e){this.enc="der";this.name=e.name;this.entity=e;this.tree=new DERNode;this.tree._init(e.body)}e.exports=DERDecoder;DERDecoder.prototype.decode=function decode(e,t){if(!(e instanceof a.DecoderBuffer))e=new a.DecoderBuffer(e,t);return this.tree._decode(e,t)};function DERNode(e){a.Node.call(this,"der",e)}i(DERNode,a.Node);DERNode.prototype._peekTag=function peekTag(e,t,r){if(e.isEmpty())return false;var i=e.save();var n=derDecodeTag(e,'Failed to peek tag: "'+t+'"');if(e.isError(n))return n;e.restore(i);return n.tag===t||n.tagStr===t||n.tagStr+"of"===t||r};DERNode.prototype._decodeTag=function decodeTag(e,t,r){var i=derDecodeTag(e,'Failed to decode tag of "'+t+'"');if(e.isError(i))return i;var n=derDecodeLen(e,i.primitive,'Failed to get length of "'+t+'"');if(e.isError(n))return n;if(!r&&i.tag!==t&&i.tagStr!==t&&i.tagStr+"of"!==t){return e.error('Failed to match tag: "'+t+'"')}if(i.primitive||n!==null)return e.skip(n,'Failed to match body of: "'+t+'"');var a=e.save();var s=this._skipUntilEnd(e,'Failed to skip indefinite length body: "'+this.tag+'"');if(e.isError(s))return s;n=e.offset-a.offset;e.restore(a);return e.skip(n,'Failed to match body of: "'+t+'"')};DERNode.prototype._skipUntilEnd=function skipUntilEnd(e,t){while(true){var r=derDecodeTag(e,t);if(e.isError(r))return r;var i=derDecodeLen(e,r.primitive,t);if(e.isError(i))return i;var n;if(r.primitive||i!==null)n=e.skip(i);else n=this._skipUntilEnd(e,t);if(e.isError(n))return n;if(r.tagStr==="end")break}};DERNode.prototype._decodeList=function decodeList(e,t,r,i){var n=[];while(!e.isEmpty()){var a=this._peekTag(e,"end");if(e.isError(a))return a;var s=r.decode(e,"der",i);if(e.isError(s)&&a)break;n.push(s)}return n};DERNode.prototype._decodeStr=function decodeStr(e,t){if(t==="bitstr"){var r=e.readUInt8();if(e.isError(r))return r;return{unused:r,data:e.raw()}}else if(t==="bmpstr"){var i=e.raw();if(i.length%2===1)return e.error("Decoding of string type: bmpstr length mismatch");var n="";for(var a=0;a<i.length/2;a++){n+=String.fromCharCode(i.readUInt16BE(a*2))}return n}else if(t==="numstr"){var s=e.raw().toString("ascii");if(!this._isNumstr(s)){return e.error("Decoding of string type: "+"numstr unsupported characters")}return s}else if(t==="octstr"){return e.raw()}else if(t==="objDesc"){return e.raw()}else if(t==="printstr"){var o=e.raw().toString("ascii");if(!this._isPrintstr(o)){return e.error("Decoding of string type: "+"printstr unsupported characters")}return o}else if(/str$/.test(t)){return e.raw().toString()}else{return e.error("Decoding of string type: "+t+" unsupported")}};DERNode.prototype._decodeObjid=function decodeObjid(e,t,r){var i;var n=[];var a=0;while(!e.isEmpty()){var s=e.readUInt8();a<<=7;a|=s&127;if((s&128)===0){n.push(a);a=0}}if(s&128)n.push(a);var o=n[0]/40|0;var h=n[0]%40;if(r)i=n;else i=[o,h].concat(n.slice(1));if(t){var u=t[i.join(" ")];if(u===undefined)u=t[i.join(".")];if(u!==undefined)i=u}return i};DERNode.prototype._decodeTime=function decodeTime(e,t){var r=e.raw().toString();if(t==="gentime"){var i=r.slice(0,4)|0;var n=r.slice(4,6)|0;var a=r.slice(6,8)|0;var s=r.slice(8,10)|0;var o=r.slice(10,12)|0;var h=r.slice(12,14)|0}else if(t==="utctime"){var i=r.slice(0,2)|0;var n=r.slice(2,4)|0;var a=r.slice(4,6)|0;var s=r.slice(6,8)|0;var o=r.slice(8,10)|0;var h=r.slice(10,12)|0;if(i<70)i=2e3+i;else i=1900+i}else{return e.error("Decoding "+t+" time is not supported yet")}return Date.UTC(i,n-1,a,s,o,h,0)};DERNode.prototype._decodeNull=function decodeNull(e){return null};DERNode.prototype._decodeBool=function decodeBool(e){var t=e.readUInt8();if(e.isError(t))return t;else return t!==0};DERNode.prototype._decodeInt=function decodeInt(e,t){var r=e.raw();var i=new s(r);if(t)i=t[i.toString(10)]||i;return i};DERNode.prototype._use=function use(e,t){if(typeof e==="function")e=e(t);return e._getDecoder("der").tree};function derDecodeTag(e,t){var r=e.readUInt8(t);if(e.isError(r))return r;var i=o.tagClass[r>>6];var n=(r&32)===0;if((r&31)===31){var a=r;r=0;while((a&128)===128){a=e.readUInt8(t);if(e.isError(a))return a;r<<=7;r|=a&127}}else{r&=31}var s=o.tag[r];return{cls:i,primitive:n,tag:r,tagStr:s}}function derDecodeLen(e,t,r){var i=e.readUInt8(r);if(e.isError(i))return i;if(!t&&i===128)return null;if((i&128)===0){return i}var n=i&127;if(n>4)return e.error("length octect is too long");i=0;for(var a=0;a<n;a++){i<<=8;var s=e.readUInt8(r);if(e.isError(s))return s;i|=s}return i}},6701:function(e,t,r){var i=t;i.der=r(2259);i.pem=r(8527)},8527:function(e,t,r){var i=r(3782);var n=r(4300).Buffer;var a=r(2259);function PEMDecoder(e){a.call(this,e);this.enc="pem"}i(PEMDecoder,a);e.exports=PEMDecoder;PEMDecoder.prototype.decode=function decode(e,t){var r=e.toString().split(/[\r\n]+/g);var i=t.label.toUpperCase();var s=/^-----(BEGIN|END) ([^-]+)-----$/;var o=-1;var h=-1;for(var u=0;u<r.length;u++){var d=r[u].match(s);if(d===null)continue;if(d[2]!==i)continue;if(o===-1){if(d[1]!=="BEGIN")break;o=u}else{if(d[1]!=="END")break;h=u;break}}if(o===-1||h===-1)throw new Error("PEM section not found for: "+i);var c=r.slice(o+1,h).join("");c.replace(/[^a-z0-9\+\/=]+/gi,"");var l=new n(c,"base64");return a.prototype.decode.call(this,l,t)}},7804:function(e,t,r){var i=r(3782);var n=r(4300).Buffer;var a=r(7160);var s=a.base;var o=a.constants.der;function DEREncoder(e){this.enc="der";this.name=e.name;this.entity=e;this.tree=new DERNode;this.tree._init(e.body)}e.exports=DEREncoder;DEREncoder.prototype.encode=function encode(e,t){return this.tree._encode(e,t).join()};function DERNode(e){s.Node.call(this,"der",e)}i(DERNode,s.Node);DERNode.prototype._encodeComposite=function encodeComposite(e,t,r,i){var a=encodeTag(e,t,r,this.reporter);if(i.length<128){var s=new n(2);s[0]=a;s[1]=i.length;return this._createEncoderBuffer([s,i])}var o=1;for(var h=i.length;h>=256;h>>=8)o++;var s=new n(1+1+o);s[0]=a;s[1]=128|o;for(var h=1+o,u=i.length;u>0;h--,u>>=8)s[h]=u&255;return this._createEncoderBuffer([s,i])};DERNode.prototype._encodeStr=function encodeStr(e,t){if(t==="bitstr"){return this._createEncoderBuffer([e.unused|0,e.data])}else if(t==="bmpstr"){var r=new n(e.length*2);for(var i=0;i<e.length;i++){r.writeUInt16BE(e.charCodeAt(i),i*2)}return this._createEncoderBuffer(r)}else if(t==="numstr"){if(!this._isNumstr(e)){return this.reporter.error("Encoding of string type: numstr supports "+"only digits and space")}return this._createEncoderBuffer(e)}else if(t==="printstr"){if(!this._isPrintstr(e)){return this.reporter.error("Encoding of string type: printstr supports "+"only latin upper and lower case letters, "+"digits, space, apostrophe, left and rigth "+"parenthesis, plus sign, comma, hyphen, "+"dot, slash, colon, equal sign, "+"question mark")}return this._createEncoderBuffer(e)}else if(/str$/.test(t)){return this._createEncoderBuffer(e)}else if(t==="objDesc"){return this._createEncoderBuffer(e)}else{return this.reporter.error("Encoding of string type: "+t+" unsupported")}};DERNode.prototype._encodeObjid=function encodeObjid(e,t,r){if(typeof e==="string"){if(!t)return this.reporter.error("string objid given, but no values map found");if(!t.hasOwnProperty(e))return this.reporter.error("objid not found in values map");e=t[e].split(/[\s\.]+/g);for(var i=0;i<e.length;i++)e[i]|=0}else if(Array.isArray(e)){e=e.slice();for(var i=0;i<e.length;i++)e[i]|=0}if(!Array.isArray(e)){return this.reporter.error("objid() should be either array or string, "+"got: "+JSON.stringify(e))}if(!r){if(e[1]>=40)return this.reporter.error("Second objid identifier OOB");e.splice(0,2,e[0]*40+e[1])}var a=0;for(var i=0;i<e.length;i++){var s=e[i];for(a++;s>=128;s>>=7)a++}var o=new n(a);var h=o.length-1;for(var i=e.length-1;i>=0;i--){var s=e[i];o[h--]=s&127;while((s>>=7)>0)o[h--]=128|s&127}return this._createEncoderBuffer(o)};function two(e){if(e<10)return"0"+e;else return e}DERNode.prototype._encodeTime=function encodeTime(e,t){var r;var i=new Date(e);if(t==="gentime"){r=[two(i.getFullYear()),two(i.getUTCMonth()+1),two(i.getUTCDate()),two(i.getUTCHours()),two(i.getUTCMinutes()),two(i.getUTCSeconds()),"Z"].join("")}else if(t==="utctime"){r=[two(i.getFullYear()%100),two(i.getUTCMonth()+1),two(i.getUTCDate()),two(i.getUTCHours()),two(i.getUTCMinutes()),two(i.getUTCSeconds()),"Z"].join("")}else{this.reporter.error("Encoding "+t+" time is not supported yet")}return this._encodeStr(r,"octstr")};DERNode.prototype._encodeNull=function encodeNull(){return this._createEncoderBuffer("")};DERNode.prototype._encodeInt=function encodeInt(e,t){if(typeof e==="string"){if(!t)return this.reporter.error("String int or enum given, but no values map");if(!t.hasOwnProperty(e)){return this.reporter.error("Values map doesn't contain: "+JSON.stringify(e))}e=t[e]}if(typeof e!=="number"&&!n.isBuffer(e)){var r=e.toArray();if(!e.sign&&r[0]&128){r.unshift(0)}e=new n(r)}if(n.isBuffer(e)){var i=e.length;if(e.length===0)i++;var a=new n(i);e.copy(a);if(e.length===0)a[0]=0;return this._createEncoderBuffer(a)}if(e<128)return this._createEncoderBuffer(e);if(e<256)return this._createEncoderBuffer([0,e]);var i=1;for(var s=e;s>=256;s>>=8)i++;var a=new Array(i);for(var s=a.length-1;s>=0;s--){a[s]=e&255;e>>=8}if(a[0]&128){a.unshift(0)}return this._createEncoderBuffer(new n(a))};DERNode.prototype._encodeBool=function encodeBool(e){return this._createEncoderBuffer(e?255:0)};DERNode.prototype._use=function use(e,t){if(typeof e==="function")e=e(t);return e._getEncoder("der").tree};DERNode.prototype._skipDefault=function skipDefault(e,t,r){var i=this._baseState;var n;if(i["default"]===null)return false;var a=e.join();if(i.defaultBuffer===undefined)i.defaultBuffer=this._encodeValue(i["default"],t,r).join();if(a.length!==i.defaultBuffer.length)return false;for(n=0;n<a.length;n++)if(a[n]!==i.defaultBuffer[n])return false;return true};function encodeTag(e,t,r,i){var n;if(e==="seqof")e="seq";else if(e==="setof")e="set";if(o.tagByName.hasOwnProperty(e))n=o.tagByName[e];else if(typeof e==="number"&&(e|0)===e)n=e;else return i.error("Unknown tag: "+e);if(n>=31)return i.error("Multi-octet tag encoding unsupported");if(!t)n|=32;n|=o.tagClassByName[r||"universal"]<<6;return n}},3418:function(e,t,r){var i=t;i.der=r(7804);i.pem=r(1564)},1564:function(e,t,r){var i=r(3782);var n=r(7804);function PEMEncoder(e){n.call(this,e);this.enc="pem"}i(PEMEncoder,n);e.exports=PEMEncoder;PEMEncoder.prototype.encode=function encode(e,t){var r=n.prototype.encode.call(this,e);var i=r.toString("base64");var a=["-----BEGIN "+t.label+"-----"];for(var s=0;s<i.length;s+=64)a.push(i.slice(s,s+64));a.push("-----END "+t.label+"-----");return a.join("\n")}},711:function(e,t,r){e=r.nmd(e);(function(e,t){"use strict";function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}function inherits(e,t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}function BN(e,t,r){if(BN.isBN(e)){return e}this.negative=0;this.words=null;this.length=0;this.red=null;if(e!==null){if(t==="le"||t==="be"){r=t;t=10}this._init(e||0,t||10,r||"be")}}if(typeof e==="object"){e.exports=BN}else{t.BN=BN}BN.BN=BN;BN.wordSize=26;var i;try{i=r(4300).Buffer}catch(e){}BN.isBN=function isBN(e){if(e instanceof BN){return true}return e!==null&&typeof e==="object"&&e.constructor.wordSize===BN.wordSize&&Array.isArray(e.words)};BN.max=function max(e,t){if(e.cmp(t)>0)return e;return t};BN.min=function min(e,t){if(e.cmp(t)<0)return e;return t};BN.prototype._init=function init(e,t,r){if(typeof e==="number"){return this._initNumber(e,t,r)}if(typeof e==="object"){return this._initArray(e,t,r)}if(t==="hex"){t=16}assert(t===(t|0)&&t>=2&&t<=36);e=e.toString().replace(/\s+/g,"");var i=0;if(e[0]==="-"){i++}if(t===16){this._parseHex(e,i)}else{this._parseBase(e,t,i)}if(e[0]==="-"){this.negative=1}this.strip();if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initNumber=function _initNumber(e,t,r){if(e<0){this.negative=1;e=-e}if(e<67108864){this.words=[e&67108863];this.length=1}else if(e<4503599627370496){this.words=[e&67108863,e/67108864&67108863];this.length=2}else{assert(e<9007199254740992);this.words=[e&67108863,e/67108864&67108863,1];this.length=3}if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initArray=function _initArray(e,t,r){assert(typeof e.length==="number");if(e.length<=0){this.words=[0];this.length=1;return this}this.length=Math.ceil(e.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0}var n,a;var s=0;if(r==="be"){for(i=e.length-1,n=0;i>=0;i-=3){a=e[i]|e[i-1]<<8|e[i-2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}else if(r==="le"){for(i=0,n=0;i<e.length;i+=3){a=e[i]|e[i+1]<<8|e[i+2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}return this.strip()};function parseHex(e,t,r){var i=0;var n=Math.min(e.length,r);for(var a=t;a<n;a++){var s=e.charCodeAt(a)-48;i<<=4;if(s>=49&&s<=54){i|=s-49+10}else if(s>=17&&s<=22){i|=s-17+10}else{i|=s&15}}return i}BN.prototype._parseHex=function _parseHex(e,t){this.length=Math.ceil((e.length-t)/6);this.words=new Array(this.length);for(var r=0;r<this.length;r++){this.words[r]=0}var i,n;var a=0;for(r=e.length-6,i=0;r>=t;r-=6){n=parseHex(e,r,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303;a+=24;if(a>=26){a-=26;i++}}if(r+6!==t){n=parseHex(e,t,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303}this.strip()};function parseBase(e,t,r,i){var n=0;var a=Math.min(e.length,r);for(var s=t;s<a;s++){var o=e.charCodeAt(s)-48;n*=i;if(o>=49){n+=o-49+10}else if(o>=17){n+=o-17+10}else{n+=o}}return n}BN.prototype._parseBase=function _parseBase(e,t,r){this.words=[0];this.length=1;for(var i=0,n=1;n<=67108863;n*=t){i++}i--;n=n/t|0;var a=e.length-r;var s=a%i;var o=Math.min(a,a-s)+r;var h=0;for(var u=r;u<o;u+=i){h=parseBase(e,u,u+i,t);this.imuln(n);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}if(s!==0){var d=1;h=parseBase(e,u,e.length,t);for(u=0;u<s;u++){d*=t}this.imuln(d);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}};BN.prototype.copy=function copy(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++){e.words[t]=this.words[t]}e.length=this.length;e.negative=this.negative;e.red=this.red};BN.prototype.clone=function clone(){var e=new BN(null);this.copy(e);return e};BN.prototype._expand=function _expand(e){while(this.length<e){this.words[this.length++]=0}return this};BN.prototype.strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--}return this._normSign()};BN.prototype._normSign=function _normSign(){if(this.length===1&&this.words[0]===0){this.negative=0}return this};BN.prototype.inspect=function inspect(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"};var n=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"];var a=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var s=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(e,t){e=e||10;t=t|0||1;var r;if(e===16||e==="hex"){r="";var i=0;var o=0;for(var h=0;h<this.length;h++){var u=this.words[h];var d=((u<<i|o)&16777215).toString(16);o=u>>>24-i&16777215;if(o!==0||h!==this.length-1){r=n[6-d.length]+d+r}else{r=d+r}i+=2;if(i>=26){i-=26;h--}}if(o!==0){r=o.toString(16)+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}if(e===(e|0)&&e>=2&&e<=36){var c=a[e];var l=s[e];r="";var p=this.clone();p.negative=0;while(!p.isZero()){var v=p.modn(l).toString(e);p=p.idivn(l);if(!p.isZero()){r=n[c-v.length]+v+r}else{r=v+r}}if(this.isZero()){r="0"+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}assert(false,"Base should be between 2 and 36")};BN.prototype.toNumber=function toNumber(){var e=this.words[0];if(this.length===2){e+=this.words[1]*67108864}else if(this.length===3&&this.words[2]===1){e+=4503599627370496+this.words[1]*67108864}else if(this.length>2){assert(false,"Number can only safely store up to 53 bits")}return this.negative!==0?-e:e};BN.prototype.toJSON=function toJSON(){return this.toString(16)};BN.prototype.toBuffer=function toBuffer(e,t){assert(typeof i!=="undefined");return this.toArrayLike(i,e,t)};BN.prototype.toArray=function toArray(e,t){return this.toArrayLike(Array,e,t)};BN.prototype.toArrayLike=function toArrayLike(e,t,r){var i=this.byteLength();var n=r||Math.max(1,i);assert(i<=n,"byte array longer than desired length");assert(n>0,"Requested array length <= 0");this.strip();var a=t==="le";var s=new e(n);var o,h;var u=this.clone();if(!a){for(h=0;h<n-i;h++){s[h]=0}for(h=0;!u.isZero();h++){o=u.andln(255);u.iushrn(8);s[n-h-1]=o}}else{for(h=0;!u.isZero();h++){o=u.andln(255);u.iushrn(8);s[h]=o}for(;h<n;h++){s[h]=0}}return s};if(Math.clz32){BN.prototype._countBits=function _countBits(e){return 32-Math.clz32(e)}}else{BN.prototype._countBits=function _countBits(e){var t=e;var r=0;if(t>=4096){r+=13;t>>>=13}if(t>=64){r+=7;t>>>=7}if(t>=8){r+=4;t>>>=4}if(t>=2){r+=2;t>>>=2}return r+t}}BN.prototype._zeroBits=function _zeroBits(e){if(e===0)return 26;var t=e;var r=0;if((t&8191)===0){r+=13;t>>>=13}if((t&127)===0){r+=7;t>>>=7}if((t&15)===0){r+=4;t>>>=4}if((t&3)===0){r+=2;t>>>=2}if((t&1)===0){r++}return r};BN.prototype.bitLength=function bitLength(){var e=this.words[this.length-1];var t=this._countBits(e);return(this.length-1)*26+t};function toBitArray(e){var t=new Array(e.bitLength());for(var r=0;r<t.length;r++){var i=r/26|0;var n=r%26;t[r]=(e.words[i]&1<<n)>>>n}return t}BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var e=0;for(var t=0;t<this.length;t++){var r=this._zeroBits(this.words[t]);e+=r;if(r!==26)break}return e};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8)};BN.prototype.toTwos=function toTwos(e){if(this.negative!==0){return this.abs().inotn(e).iaddn(1)}return this.clone()};BN.prototype.fromTwos=function fromTwos(e){if(this.testn(e-1)){return this.notn(e).iaddn(1).ineg()}return this.clone()};BN.prototype.isNeg=function isNeg(){return this.negative!==0};BN.prototype.neg=function neg(){return this.clone().ineg()};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1}return this};BN.prototype.iuor=function iuor(e){while(this.length<e.length){this.words[this.length++]=0}for(var t=0;t<e.length;t++){this.words[t]=this.words[t]|e.words[t]}return this.strip()};BN.prototype.ior=function ior(e){assert((this.negative|e.negative)===0);return this.iuor(e)};BN.prototype.or=function or(e){if(this.length>e.length)return this.clone().ior(e);return e.clone().ior(this)};BN.prototype.uor=function uor(e){if(this.length>e.length)return this.clone().iuor(e);return e.clone().iuor(this)};BN.prototype.iuand=function iuand(e){var t;if(this.length>e.length){t=e}else{t=this}for(var r=0;r<t.length;r++){this.words[r]=this.words[r]&e.words[r]}this.length=t.length;return this.strip()};BN.prototype.iand=function iand(e){assert((this.negative|e.negative)===0);return this.iuand(e)};BN.prototype.and=function and(e){if(this.length>e.length)return this.clone().iand(e);return e.clone().iand(this)};BN.prototype.uand=function uand(e){if(this.length>e.length)return this.clone().iuand(e);return e.clone().iuand(this)};BN.prototype.iuxor=function iuxor(e){var t;var r;if(this.length>e.length){t=this;r=e}else{t=e;r=this}for(var i=0;i<r.length;i++){this.words[i]=t.words[i]^r.words[i]}if(this!==t){for(;i<t.length;i++){this.words[i]=t.words[i]}}this.length=t.length;return this.strip()};BN.prototype.ixor=function ixor(e){assert((this.negative|e.negative)===0);return this.iuxor(e)};BN.prototype.xor=function xor(e){if(this.length>e.length)return this.clone().ixor(e);return e.clone().ixor(this)};BN.prototype.uxor=function uxor(e){if(this.length>e.length)return this.clone().iuxor(e);return e.clone().iuxor(this)};BN.prototype.inotn=function inotn(e){assert(typeof e==="number"&&e>=0);var t=Math.ceil(e/26)|0;var r=e%26;this._expand(t);if(r>0){t--}for(var i=0;i<t;i++){this.words[i]=~this.words[i]&67108863}if(r>0){this.words[i]=~this.words[i]&67108863>>26-r}return this.strip()};BN.prototype.notn=function notn(e){return this.clone().inotn(e)};BN.prototype.setn=function setn(e,t){assert(typeof e==="number"&&e>=0);var r=e/26|0;var i=e%26;this._expand(r+1);if(t){this.words[r]=this.words[r]|1<<i}else{this.words[r]=this.words[r]&~(1<<i)}return this.strip()};BN.prototype.iadd=function iadd(e){var t;if(this.negative!==0&&e.negative===0){this.negative=0;t=this.isub(e);this.negative^=1;return this._normSign()}else if(this.negative===0&&e.negative!==0){e.negative=0;t=this.isub(e);e.negative=1;return t._normSign()}var r,i;if(this.length>e.length){r=this;i=e}else{r=e;i=this}var n=0;for(var a=0;a<i.length;a++){t=(r.words[a]|0)+(i.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}for(;n!==0&&a<r.length;a++){t=(r.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}this.length=r.length;if(n!==0){this.words[this.length]=n;this.length++}else if(r!==this){for(;a<r.length;a++){this.words[a]=r.words[a]}}return this};BN.prototype.add=function add(e){var t;if(e.negative!==0&&this.negative===0){e.negative=0;t=this.sub(e);e.negative^=1;return t}else if(e.negative===0&&this.negative!==0){this.negative=0;t=e.sub(this);this.negative=1;return t}if(this.length>e.length)return this.clone().iadd(e);return e.clone().iadd(this)};BN.prototype.isub=function isub(e){if(e.negative!==0){e.negative=0;var t=this.iadd(e);e.negative=1;return t._normSign()}else if(this.negative!==0){this.negative=0;this.iadd(e);this.negative=1;return this._normSign()}var r=this.cmp(e);if(r===0){this.negative=0;this.length=1;this.words[0]=0;return this}var i,n;if(r>0){i=this;n=e}else{i=e;n=this}var a=0;for(var s=0;s<n.length;s++){t=(i.words[s]|0)-(n.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}for(;a!==0&&s<i.length;s++){t=(i.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}if(a===0&&s<i.length&&i!==this){for(;s<i.length;s++){this.words[s]=i.words[s]}}this.length=Math.max(this.length,s);if(i!==this){this.negative=1}return this.strip()};BN.prototype.sub=function sub(e){return this.clone().isub(e)};function smallMulTo(e,t,r){r.negative=t.negative^e.negative;var i=e.length+t.length|0;r.length=i;i=i-1|0;var n=e.words[0]|0;var a=t.words[0]|0;var s=n*a;var o=s&67108863;var h=s/67108864|0;r.words[0]=o;for(var u=1;u<i;u++){var d=h>>>26;var c=h&67108863;var l=Math.min(u,t.length-1);for(var p=Math.max(0,u-e.length+1);p<=l;p++){var v=u-p|0;n=e.words[v]|0;a=t.words[p]|0;s=n*a+c;d+=s/67108864|0;c=s&67108863}r.words[u]=c|0;h=d|0}if(h!==0){r.words[u]=h|0}else{r.length--}return r.strip()}var o=function comb10MulTo(e,t,r){var i=e.words;var n=t.words;var a=r.words;var s=0;var o;var h;var u;var d=i[0]|0;var c=d&8191;var l=d>>>13;var p=i[1]|0;var v=p&8191;var b=p>>>13;var m=i[2]|0;var y=m&8191;var g=m>>>13;var _=i[3]|0;var w=_&8191;var M=_>>>13;var B=i[4]|0;var E=B&8191;var k=B>>>13;var A=i[5]|0;var N=A&8191;var P=A>>>13;var x=i[6]|0;var I=x&8191;var C=x>>>13;var D=i[7]|0;var T=D&8191;var j=D>>>13;var q=i[8]|0;var O=q&8191;var H=q>>>13;var L=i[9]|0;var z=L&8191;var F=L>>>13;var U=n[0]|0;var W=U&8191;var V=U>>>13;var G=n[1]|0;var J=G&8191;var Z=G>>>13;var X=n[2]|0;var Y=X&8191;var $=X>>>13;var Q=n[3]|0;var ee=Q&8191;var te=Q>>>13;var re=n[4]|0;var ie=re&8191;var ne=re>>>13;var ae=n[5]|0;var fe=ae&8191;var se=ae>>>13;var oe=n[6]|0;var he=oe&8191;var ue=oe>>>13;var de=n[7]|0;var ce=de&8191;var le=de>>>13;var pe=n[8]|0;var ve=pe&8191;var be=pe>>>13;var me=n[9]|0;var ye=me&8191;var ge=me>>>13;r.negative=e.negative^t.negative;r.length=19;o=Math.imul(c,W);h=Math.imul(c,V);h=h+Math.imul(l,W)|0;u=Math.imul(l,V);var _e=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(_e>>>26)|0;_e&=67108863;o=Math.imul(v,W);h=Math.imul(v,V);h=h+Math.imul(b,W)|0;u=Math.imul(b,V);o=o+Math.imul(c,J)|0;h=h+Math.imul(c,Z)|0;h=h+Math.imul(l,J)|0;u=u+Math.imul(l,Z)|0;var we=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(we>>>26)|0;we&=67108863;o=Math.imul(y,W);h=Math.imul(y,V);h=h+Math.imul(g,W)|0;u=Math.imul(g,V);o=o+Math.imul(v,J)|0;h=h+Math.imul(v,Z)|0;h=h+Math.imul(b,J)|0;u=u+Math.imul(b,Z)|0;o=o+Math.imul(c,Y)|0;h=h+Math.imul(c,$)|0;h=h+Math.imul(l,Y)|0;u=u+Math.imul(l,$)|0;var Me=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Me>>>26)|0;Me&=67108863;o=Math.imul(w,W);h=Math.imul(w,V);h=h+Math.imul(M,W)|0;u=Math.imul(M,V);o=o+Math.imul(y,J)|0;h=h+Math.imul(y,Z)|0;h=h+Math.imul(g,J)|0;u=u+Math.imul(g,Z)|0;o=o+Math.imul(v,Y)|0;h=h+Math.imul(v,$)|0;h=h+Math.imul(b,Y)|0;u=u+Math.imul(b,$)|0;o=o+Math.imul(c,ee)|0;h=h+Math.imul(c,te)|0;h=h+Math.imul(l,ee)|0;u=u+Math.imul(l,te)|0;var Se=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Se>>>26)|0;Se&=67108863;o=Math.imul(E,W);h=Math.imul(E,V);h=h+Math.imul(k,W)|0;u=Math.imul(k,V);o=o+Math.imul(w,J)|0;h=h+Math.imul(w,Z)|0;h=h+Math.imul(M,J)|0;u=u+Math.imul(M,Z)|0;o=o+Math.imul(y,Y)|0;h=h+Math.imul(y,$)|0;h=h+Math.imul(g,Y)|0;u=u+Math.imul(g,$)|0;o=o+Math.imul(v,ee)|0;h=h+Math.imul(v,te)|0;h=h+Math.imul(b,ee)|0;u=u+Math.imul(b,te)|0;o=o+Math.imul(c,ie)|0;h=h+Math.imul(c,ne)|0;h=h+Math.imul(l,ie)|0;u=u+Math.imul(l,ne)|0;var Be=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Be>>>26)|0;Be&=67108863;o=Math.imul(N,W);h=Math.imul(N,V);h=h+Math.imul(P,W)|0;u=Math.imul(P,V);o=o+Math.imul(E,J)|0;h=h+Math.imul(E,Z)|0;h=h+Math.imul(k,J)|0;u=u+Math.imul(k,Z)|0;o=o+Math.imul(w,Y)|0;h=h+Math.imul(w,$)|0;h=h+Math.imul(M,Y)|0;u=u+Math.imul(M,$)|0;o=o+Math.imul(y,ee)|0;h=h+Math.imul(y,te)|0;h=h+Math.imul(g,ee)|0;u=u+Math.imul(g,te)|0;o=o+Math.imul(v,ie)|0;h=h+Math.imul(v,ne)|0;h=h+Math.imul(b,ie)|0;u=u+Math.imul(b,ne)|0;o=o+Math.imul(c,fe)|0;h=h+Math.imul(c,se)|0;h=h+Math.imul(l,fe)|0;u=u+Math.imul(l,se)|0;var Ee=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ee>>>26)|0;Ee&=67108863;o=Math.imul(I,W);h=Math.imul(I,V);h=h+Math.imul(C,W)|0;u=Math.imul(C,V);o=o+Math.imul(N,J)|0;h=h+Math.imul(N,Z)|0;h=h+Math.imul(P,J)|0;u=u+Math.imul(P,Z)|0;o=o+Math.imul(E,Y)|0;h=h+Math.imul(E,$)|0;h=h+Math.imul(k,Y)|0;u=u+Math.imul(k,$)|0;o=o+Math.imul(w,ee)|0;h=h+Math.imul(w,te)|0;h=h+Math.imul(M,ee)|0;u=u+Math.imul(M,te)|0;o=o+Math.imul(y,ie)|0;h=h+Math.imul(y,ne)|0;h=h+Math.imul(g,ie)|0;u=u+Math.imul(g,ne)|0;o=o+Math.imul(v,fe)|0;h=h+Math.imul(v,se)|0;h=h+Math.imul(b,fe)|0;u=u+Math.imul(b,se)|0;o=o+Math.imul(c,he)|0;h=h+Math.imul(c,ue)|0;h=h+Math.imul(l,he)|0;u=u+Math.imul(l,ue)|0;var ke=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(ke>>>26)|0;ke&=67108863;o=Math.imul(T,W);h=Math.imul(T,V);h=h+Math.imul(j,W)|0;u=Math.imul(j,V);o=o+Math.imul(I,J)|0;h=h+Math.imul(I,Z)|0;h=h+Math.imul(C,J)|0;u=u+Math.imul(C,Z)|0;o=o+Math.imul(N,Y)|0;h=h+Math.imul(N,$)|0;h=h+Math.imul(P,Y)|0;u=u+Math.imul(P,$)|0;o=o+Math.imul(E,ee)|0;h=h+Math.imul(E,te)|0;h=h+Math.imul(k,ee)|0;u=u+Math.imul(k,te)|0;o=o+Math.imul(w,ie)|0;h=h+Math.imul(w,ne)|0;h=h+Math.imul(M,ie)|0;u=u+Math.imul(M,ne)|0;o=o+Math.imul(y,fe)|0;h=h+Math.imul(y,se)|0;h=h+Math.imul(g,fe)|0;u=u+Math.imul(g,se)|0;o=o+Math.imul(v,he)|0;h=h+Math.imul(v,ue)|0;h=h+Math.imul(b,he)|0;u=u+Math.imul(b,ue)|0;o=o+Math.imul(c,ce)|0;h=h+Math.imul(c,le)|0;h=h+Math.imul(l,ce)|0;u=u+Math.imul(l,le)|0;var Ae=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ae>>>26)|0;Ae&=67108863;o=Math.imul(O,W);h=Math.imul(O,V);h=h+Math.imul(H,W)|0;u=Math.imul(H,V);o=o+Math.imul(T,J)|0;h=h+Math.imul(T,Z)|0;h=h+Math.imul(j,J)|0;u=u+Math.imul(j,Z)|0;o=o+Math.imul(I,Y)|0;h=h+Math.imul(I,$)|0;h=h+Math.imul(C,Y)|0;u=u+Math.imul(C,$)|0;o=o+Math.imul(N,ee)|0;h=h+Math.imul(N,te)|0;h=h+Math.imul(P,ee)|0;u=u+Math.imul(P,te)|0;o=o+Math.imul(E,ie)|0;h=h+Math.imul(E,ne)|0;h=h+Math.imul(k,ie)|0;u=u+Math.imul(k,ne)|0;o=o+Math.imul(w,fe)|0;h=h+Math.imul(w,se)|0;h=h+Math.imul(M,fe)|0;u=u+Math.imul(M,se)|0;o=o+Math.imul(y,he)|0;h=h+Math.imul(y,ue)|0;h=h+Math.imul(g,he)|0;u=u+Math.imul(g,ue)|0;o=o+Math.imul(v,ce)|0;h=h+Math.imul(v,le)|0;h=h+Math.imul(b,ce)|0;u=u+Math.imul(b,le)|0;o=o+Math.imul(c,ve)|0;h=h+Math.imul(c,be)|0;h=h+Math.imul(l,ve)|0;u=u+Math.imul(l,be)|0;var Ne=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ne>>>26)|0;Ne&=67108863;o=Math.imul(z,W);h=Math.imul(z,V);h=h+Math.imul(F,W)|0;u=Math.imul(F,V);o=o+Math.imul(O,J)|0;h=h+Math.imul(O,Z)|0;h=h+Math.imul(H,J)|0;u=u+Math.imul(H,Z)|0;o=o+Math.imul(T,Y)|0;h=h+Math.imul(T,$)|0;h=h+Math.imul(j,Y)|0;u=u+Math.imul(j,$)|0;o=o+Math.imul(I,ee)|0;h=h+Math.imul(I,te)|0;h=h+Math.imul(C,ee)|0;u=u+Math.imul(C,te)|0;o=o+Math.imul(N,ie)|0;h=h+Math.imul(N,ne)|0;h=h+Math.imul(P,ie)|0;u=u+Math.imul(P,ne)|0;o=o+Math.imul(E,fe)|0;h=h+Math.imul(E,se)|0;h=h+Math.imul(k,fe)|0;u=u+Math.imul(k,se)|0;o=o+Math.imul(w,he)|0;h=h+Math.imul(w,ue)|0;h=h+Math.imul(M,he)|0;u=u+Math.imul(M,ue)|0;o=o+Math.imul(y,ce)|0;h=h+Math.imul(y,le)|0;h=h+Math.imul(g,ce)|0;u=u+Math.imul(g,le)|0;o=o+Math.imul(v,ve)|0;h=h+Math.imul(v,be)|0;h=h+Math.imul(b,ve)|0;u=u+Math.imul(b,be)|0;o=o+Math.imul(c,ye)|0;h=h+Math.imul(c,ge)|0;h=h+Math.imul(l,ye)|0;u=u+Math.imul(l,ge)|0;var Re=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Re>>>26)|0;Re&=67108863;o=Math.imul(z,J);h=Math.imul(z,Z);h=h+Math.imul(F,J)|0;u=Math.imul(F,Z);o=o+Math.imul(O,Y)|0;h=h+Math.imul(O,$)|0;h=h+Math.imul(H,Y)|0;u=u+Math.imul(H,$)|0;o=o+Math.imul(T,ee)|0;h=h+Math.imul(T,te)|0;h=h+Math.imul(j,ee)|0;u=u+Math.imul(j,te)|0;o=o+Math.imul(I,ie)|0;h=h+Math.imul(I,ne)|0;h=h+Math.imul(C,ie)|0;u=u+Math.imul(C,ne)|0;o=o+Math.imul(N,fe)|0;h=h+Math.imul(N,se)|0;h=h+Math.imul(P,fe)|0;u=u+Math.imul(P,se)|0;o=o+Math.imul(E,he)|0;h=h+Math.imul(E,ue)|0;h=h+Math.imul(k,he)|0;u=u+Math.imul(k,ue)|0;o=o+Math.imul(w,ce)|0;h=h+Math.imul(w,le)|0;h=h+Math.imul(M,ce)|0;u=u+Math.imul(M,le)|0;o=o+Math.imul(y,ve)|0;h=h+Math.imul(y,be)|0;h=h+Math.imul(g,ve)|0;u=u+Math.imul(g,be)|0;o=o+Math.imul(v,ye)|0;h=h+Math.imul(v,ge)|0;h=h+Math.imul(b,ye)|0;u=u+Math.imul(b,ge)|0;var Pe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Pe>>>26)|0;Pe&=67108863;o=Math.imul(z,Y);h=Math.imul(z,$);h=h+Math.imul(F,Y)|0;u=Math.imul(F,$);o=o+Math.imul(O,ee)|0;h=h+Math.imul(O,te)|0;h=h+Math.imul(H,ee)|0;u=u+Math.imul(H,te)|0;o=o+Math.imul(T,ie)|0;h=h+Math.imul(T,ne)|0;h=h+Math.imul(j,ie)|0;u=u+Math.imul(j,ne)|0;o=o+Math.imul(I,fe)|0;h=h+Math.imul(I,se)|0;h=h+Math.imul(C,fe)|0;u=u+Math.imul(C,se)|0;o=o+Math.imul(N,he)|0;h=h+Math.imul(N,ue)|0;h=h+Math.imul(P,he)|0;u=u+Math.imul(P,ue)|0;o=o+Math.imul(E,ce)|0;h=h+Math.imul(E,le)|0;h=h+Math.imul(k,ce)|0;u=u+Math.imul(k,le)|0;o=o+Math.imul(w,ve)|0;h=h+Math.imul(w,be)|0;h=h+Math.imul(M,ve)|0;u=u+Math.imul(M,be)|0;o=o+Math.imul(y,ye)|0;h=h+Math.imul(y,ge)|0;h=h+Math.imul(g,ye)|0;u=u+Math.imul(g,ge)|0;var xe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(xe>>>26)|0;xe&=67108863;o=Math.imul(z,ee);h=Math.imul(z,te);h=h+Math.imul(F,ee)|0;u=Math.imul(F,te);o=o+Math.imul(O,ie)|0;h=h+Math.imul(O,ne)|0;h=h+Math.imul(H,ie)|0;u=u+Math.imul(H,ne)|0;o=o+Math.imul(T,fe)|0;h=h+Math.imul(T,se)|0;h=h+Math.imul(j,fe)|0;u=u+Math.imul(j,se)|0;o=o+Math.imul(I,he)|0;h=h+Math.imul(I,ue)|0;h=h+Math.imul(C,he)|0;u=u+Math.imul(C,ue)|0;o=o+Math.imul(N,ce)|0;h=h+Math.imul(N,le)|0;h=h+Math.imul(P,ce)|0;u=u+Math.imul(P,le)|0;o=o+Math.imul(E,ve)|0;h=h+Math.imul(E,be)|0;h=h+Math.imul(k,ve)|0;u=u+Math.imul(k,be)|0;o=o+Math.imul(w,ye)|0;h=h+Math.imul(w,ge)|0;h=h+Math.imul(M,ye)|0;u=u+Math.imul(M,ge)|0;var Ie=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ie>>>26)|0;Ie&=67108863;o=Math.imul(z,ie);h=Math.imul(z,ne);h=h+Math.imul(F,ie)|0;u=Math.imul(F,ne);o=o+Math.imul(O,fe)|0;h=h+Math.imul(O,se)|0;h=h+Math.imul(H,fe)|0;u=u+Math.imul(H,se)|0;o=o+Math.imul(T,he)|0;h=h+Math.imul(T,ue)|0;h=h+Math.imul(j,he)|0;u=u+Math.imul(j,ue)|0;o=o+Math.imul(I,ce)|0;h=h+Math.imul(I,le)|0;h=h+Math.imul(C,ce)|0;u=u+Math.imul(C,le)|0;o=o+Math.imul(N,ve)|0;h=h+Math.imul(N,be)|0;h=h+Math.imul(P,ve)|0;u=u+Math.imul(P,be)|0;o=o+Math.imul(E,ye)|0;h=h+Math.imul(E,ge)|0;h=h+Math.imul(k,ye)|0;u=u+Math.imul(k,ge)|0;var Ce=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ce>>>26)|0;Ce&=67108863;o=Math.imul(z,fe);h=Math.imul(z,se);h=h+Math.imul(F,fe)|0;u=Math.imul(F,se);o=o+Math.imul(O,he)|0;h=h+Math.imul(O,ue)|0;h=h+Math.imul(H,he)|0;u=u+Math.imul(H,ue)|0;o=o+Math.imul(T,ce)|0;h=h+Math.imul(T,le)|0;h=h+Math.imul(j,ce)|0;u=u+Math.imul(j,le)|0;o=o+Math.imul(I,ve)|0;h=h+Math.imul(I,be)|0;h=h+Math.imul(C,ve)|0;u=u+Math.imul(C,be)|0;o=o+Math.imul(N,ye)|0;h=h+Math.imul(N,ge)|0;h=h+Math.imul(P,ye)|0;u=u+Math.imul(P,ge)|0;var De=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(De>>>26)|0;De&=67108863;o=Math.imul(z,he);h=Math.imul(z,ue);h=h+Math.imul(F,he)|0;u=Math.imul(F,ue);o=o+Math.imul(O,ce)|0;h=h+Math.imul(O,le)|0;h=h+Math.imul(H,ce)|0;u=u+Math.imul(H,le)|0;o=o+Math.imul(T,ve)|0;h=h+Math.imul(T,be)|0;h=h+Math.imul(j,ve)|0;u=u+Math.imul(j,be)|0;o=o+Math.imul(I,ye)|0;h=h+Math.imul(I,ge)|0;h=h+Math.imul(C,ye)|0;u=u+Math.imul(C,ge)|0;var Te=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Te>>>26)|0;Te&=67108863;o=Math.imul(z,ce);h=Math.imul(z,le);h=h+Math.imul(F,ce)|0;u=Math.imul(F,le);o=o+Math.imul(O,ve)|0;h=h+Math.imul(O,be)|0;h=h+Math.imul(H,ve)|0;u=u+Math.imul(H,be)|0;o=o+Math.imul(T,ye)|0;h=h+Math.imul(T,ge)|0;h=h+Math.imul(j,ye)|0;u=u+Math.imul(j,ge)|0;var je=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(je>>>26)|0;je&=67108863;o=Math.imul(z,ve);h=Math.imul(z,be);h=h+Math.imul(F,ve)|0;u=Math.imul(F,be);o=o+Math.imul(O,ye)|0;h=h+Math.imul(O,ge)|0;h=h+Math.imul(H,ye)|0;u=u+Math.imul(H,ge)|0;var qe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(qe>>>26)|0;qe&=67108863;o=Math.imul(z,ye);h=Math.imul(z,ge);h=h+Math.imul(F,ye)|0;u=Math.imul(F,ge);var Oe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Oe>>>26)|0;Oe&=67108863;a[0]=_e;a[1]=we;a[2]=Me;a[3]=Se;a[4]=Be;a[5]=Ee;a[6]=ke;a[7]=Ae;a[8]=Ne;a[9]=Re;a[10]=Pe;a[11]=xe;a[12]=Ie;a[13]=Ce;a[14]=De;a[15]=Te;a[16]=je;a[17]=qe;a[18]=Oe;if(s!==0){a[19]=s;r.length++}return r};if(!Math.imul){o=smallMulTo}function bigMulTo(e,t,r){r.negative=t.negative^e.negative;r.length=e.length+t.length;var i=0;var n=0;for(var a=0;a<r.length-1;a++){var s=n;n=0;var o=i&67108863;var h=Math.min(a,t.length-1);for(var u=Math.max(0,a-e.length+1);u<=h;u++){var d=a-u;var c=e.words[d]|0;var l=t.words[u]|0;var p=c*l;var v=p&67108863;s=s+(p/67108864|0)|0;v=v+o|0;o=v&67108863;s=s+(v>>>26)|0;n+=s>>>26;s&=67108863}r.words[a]=o;i=s;s=n}if(i!==0){r.words[a]=i}else{r.length--}return r.strip()}function jumboMulTo(e,t,r){var i=new FFTM;return i.mulp(e,t,r)}BN.prototype.mulTo=function mulTo(e,t){var r;var i=this.length+e.length;if(this.length===10&&e.length===10){r=o(this,e,t)}else if(i<63){r=smallMulTo(this,e,t)}else if(i<1024){r=bigMulTo(this,e,t)}else{r=jumboMulTo(this,e,t)}return r};function FFTM(e,t){this.x=e;this.y=t}FFTM.prototype.makeRBT=function makeRBT(e){var t=new Array(e);var r=BN.prototype._countBits(e)-1;for(var i=0;i<e;i++){t[i]=this.revBin(i,r,e)}return t};FFTM.prototype.revBin=function revBin(e,t,r){if(e===0||e===r-1)return e;var i=0;for(var n=0;n<t;n++){i|=(e&1)<<t-n-1;e>>=1}return i};FFTM.prototype.permute=function permute(e,t,r,i,n,a){for(var s=0;s<a;s++){i[s]=t[e[s]];n[s]=r[e[s]]}};FFTM.prototype.transform=function transform(e,t,r,i,n,a){this.permute(a,e,t,r,i,n);for(var s=1;s<n;s<<=1){var o=s<<1;var h=Math.cos(2*Math.PI/o);var u=Math.sin(2*Math.PI/o);for(var d=0;d<n;d+=o){var c=h;var l=u;for(var p=0;p<s;p++){var v=r[d+p];var b=i[d+p];var m=r[d+p+s];var y=i[d+p+s];var g=c*m-l*y;y=c*y+l*m;m=g;r[d+p]=v+m;i[d+p]=b+y;r[d+p+s]=v-m;i[d+p+s]=b-y;if(p!==o){g=h*c-u*l;l=h*l+u*c;c=g}}}}};FFTM.prototype.guessLen13b=function guessLen13b(e,t){var r=Math.max(t,e)|1;var i=r&1;var n=0;for(r=r/2|0;r;r=r>>>1){n++}return 1<<n+1+i};FFTM.prototype.conjugate=function conjugate(e,t,r){if(r<=1)return;for(var i=0;i<r/2;i++){var n=e[i];e[i]=e[r-i-1];e[r-i-1]=n;n=t[i];t[i]=-t[r-i-1];t[r-i-1]=-n}};FFTM.prototype.normalize13b=function normalize13b(e,t){var r=0;for(var i=0;i<t/2;i++){var n=Math.round(e[2*i+1]/t)*8192+Math.round(e[2*i]/t)+r;e[i]=n&67108863;if(n<67108864){r=0}else{r=n/67108864|0}}return e};FFTM.prototype.convert13b=function convert13b(e,t,r,i){var n=0;for(var a=0;a<t;a++){n=n+(e[a]|0);r[2*a]=n&8191;n=n>>>13;r[2*a+1]=n&8191;n=n>>>13}for(a=2*t;a<i;++a){r[a]=0}assert(n===0);assert((n&~8191)===0)};FFTM.prototype.stub=function stub(e){var t=new Array(e);for(var r=0;r<e;r++){t[r]=0}return t};FFTM.prototype.mulp=function mulp(e,t,r){var i=2*this.guessLen13b(e.length,t.length);var n=this.makeRBT(i);var a=this.stub(i);var s=new Array(i);var o=new Array(i);var h=new Array(i);var u=new Array(i);var d=new Array(i);var c=new Array(i);var l=r.words;l.length=i;this.convert13b(e.words,e.length,s,i);this.convert13b(t.words,t.length,u,i);this.transform(s,a,o,h,i,n);this.transform(u,a,d,c,i,n);for(var p=0;p<i;p++){var v=o[p]*d[p]-h[p]*c[p];h[p]=o[p]*c[p]+h[p]*d[p];o[p]=v}this.conjugate(o,h,i);this.transform(o,h,l,a,i,n);this.conjugate(l,a,i);this.normalize13b(l,i);r.negative=e.negative^t.negative;r.length=e.length+t.length;return r.strip()};BN.prototype.mul=function mul(e){var t=new BN(null);t.words=new Array(this.length+e.length);return this.mulTo(e,t)};BN.prototype.mulf=function mulf(e){var t=new BN(null);t.words=new Array(this.length+e.length);return jumboMulTo(this,e,t)};BN.prototype.imul=function imul(e){return this.clone().mulTo(e,this)};BN.prototype.imuln=function imuln(e){assert(typeof e==="number");assert(e<67108864);var t=0;for(var r=0;r<this.length;r++){var i=(this.words[r]|0)*e;var n=(i&67108863)+(t&67108863);t>>=26;t+=i/67108864|0;t+=n>>>26;this.words[r]=n&67108863}if(t!==0){this.words[r]=t;this.length++}return this};BN.prototype.muln=function muln(e){return this.clone().imuln(e)};BN.prototype.sqr=function sqr(){return this.mul(this)};BN.prototype.isqr=function isqr(){return this.imul(this.clone())};BN.prototype.pow=function pow(e){var t=toBitArray(e);if(t.length===0)return new BN(1);var r=this;for(var i=0;i<t.length;i++,r=r.sqr()){if(t[i]!==0)break}if(++i<t.length){for(var n=r.sqr();i<t.length;i++,n=n.sqr()){if(t[i]===0)continue;r=r.mul(n)}}return r};BN.prototype.iushln=function iushln(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=67108863>>>26-t<<26-t;var n;if(t!==0){var a=0;for(n=0;n<this.length;n++){var s=this.words[n]&i;var o=(this.words[n]|0)-s<<t;this.words[n]=o|a;a=s>>>26-t}if(a){this.words[n]=a;this.length++}}if(r!==0){for(n=this.length-1;n>=0;n--){this.words[n+r]=this.words[n]}for(n=0;n<r;n++){this.words[n]=0}this.length+=r}return this.strip()};BN.prototype.ishln=function ishln(e){assert(this.negative===0);return this.iushln(e)};BN.prototype.iushrn=function iushrn(e,t,r){assert(typeof e==="number"&&e>=0);var i;if(t){i=(t-t%26)/26}else{i=0}var n=e%26;var a=Math.min((e-n)/26,this.length);var s=67108863^67108863>>>n<<n;var o=r;i-=a;i=Math.max(0,i);if(o){for(var h=0;h<a;h++){o.words[h]=this.words[h]}o.length=a}if(a===0){}else if(this.length>a){this.length-=a;for(h=0;h<this.length;h++){this.words[h]=this.words[h+a]}}else{this.words[0]=0;this.length=1}var u=0;for(h=this.length-1;h>=0&&(u!==0||h>=i);h--){var d=this.words[h]|0;this.words[h]=u<<26-n|d>>>n;u=d&s}if(o&&u!==0){o.words[o.length++]=u}if(this.length===0){this.words[0]=0;this.length=1}return this.strip()};BN.prototype.ishrn=function ishrn(e,t,r){assert(this.negative===0);return this.iushrn(e,t,r)};BN.prototype.shln=function shln(e){return this.clone().ishln(e)};BN.prototype.ushln=function ushln(e){return this.clone().iushln(e)};BN.prototype.shrn=function shrn(e){return this.clone().ishrn(e)};BN.prototype.ushrn=function ushrn(e){return this.clone().iushrn(e)};BN.prototype.testn=function testn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r)return false;var n=this.words[r];return!!(n&i)};BN.prototype.imaskn=function imaskn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;assert(this.negative===0,"imaskn works only with positive numbers");if(this.length<=r){return this}if(t!==0){r++}this.length=Math.min(r,this.length);if(t!==0){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i}return this.strip()};BN.prototype.maskn=function maskn(e){return this.clone().imaskn(e)};BN.prototype.iaddn=function iaddn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.isubn(-e);if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<e){this.words[0]=e-(this.words[0]|0);this.negative=0;return this}this.negative=0;this.isubn(e);this.negative=1;return this}return this._iaddn(e)};BN.prototype._iaddn=function _iaddn(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++){this.words[t]-=67108864;if(t===this.length-1){this.words[t+1]=1}else{this.words[t+1]++}}this.length=Math.max(this.length,t+1);return this};BN.prototype.isubn=function isubn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.iaddn(-e);if(this.negative!==0){this.negative=0;this.iaddn(e);this.negative=1;return this}this.words[0]-=e;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1}else{for(var t=0;t<this.length&&this.words[t]<0;t++){this.words[t]+=67108864;this.words[t+1]-=1}}return this.strip()};BN.prototype.addn=function addn(e){return this.clone().iaddn(e)};BN.prototype.subn=function subn(e){return this.clone().isubn(e)};BN.prototype.iabs=function iabs(){this.negative=0;return this};BN.prototype.abs=function abs(){return this.clone().iabs()};BN.prototype._ishlnsubmul=function _ishlnsubmul(e,t,r){var i=e.length+r;var n;this._expand(i);var a;var s=0;for(n=0;n<e.length;n++){a=(this.words[n+r]|0)+s;var o=(e.words[n]|0)*t;a-=o&67108863;s=(a>>26)-(o/67108864|0);this.words[n+r]=a&67108863}for(;n<this.length-r;n++){a=(this.words[n+r]|0)+s;s=a>>26;this.words[n+r]=a&67108863}if(s===0)return this.strip();assert(s===-1);s=0;for(n=0;n<this.length;n++){a=-(this.words[n]|0)+s;s=a>>26;this.words[n]=a&67108863}this.negative=1;return this.strip()};BN.prototype._wordDiv=function _wordDiv(e,t){var r=this.length-e.length;var i=this.clone();var n=e;var a=n.words[n.length-1]|0;var s=this._countBits(a);r=26-s;if(r!==0){n=n.ushln(r);i.iushln(r);a=n.words[n.length-1]|0}var o=i.length-n.length;var h;if(t!=="mod"){h=new BN(null);h.length=o+1;h.words=new Array(h.length);for(var u=0;u<h.length;u++){h.words[u]=0}}var d=i.clone()._ishlnsubmul(n,1,o);if(d.negative===0){i=d;if(h){h.words[o]=1}}for(var c=o-1;c>=0;c--){var l=(i.words[n.length+c]|0)*67108864+(i.words[n.length+c-1]|0);l=Math.min(l/a|0,67108863);i._ishlnsubmul(n,l,c);while(i.negative!==0){l--;i.negative=0;i._ishlnsubmul(n,1,c);if(!i.isZero()){i.negative^=1}}if(h){h.words[c]=l}}if(h){h.strip()}i.strip();if(t!=="div"&&r!==0){i.iushrn(r)}return{div:h||null,mod:i}};BN.prototype.divmod=function divmod(e,t,r){assert(!e.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)}}var i,n,a;if(this.negative!==0&&e.negative===0){a=this.neg().divmod(e,t);if(t!=="mod"){i=a.div.neg()}if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.iadd(e)}}return{div:i,mod:n}}if(this.negative===0&&e.negative!==0){a=this.divmod(e.neg(),t);if(t!=="mod"){i=a.div.neg()}return{div:i,mod:a.mod}}if((this.negative&e.negative)!==0){a=this.neg().divmod(e.neg(),t);if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.isub(e)}}return{div:a.div,mod:n}}if(e.length>this.length||this.cmp(e)<0){return{div:new BN(0),mod:this}}if(e.length===1){if(t==="div"){return{div:this.divn(e.words[0]),mod:null}}if(t==="mod"){return{div:null,mod:new BN(this.modn(e.words[0]))}}return{div:this.divn(e.words[0]),mod:new BN(this.modn(e.words[0]))}}return this._wordDiv(e,t)};BN.prototype.div=function div(e){return this.divmod(e,"div",false).div};BN.prototype.mod=function mod(e){return this.divmod(e,"mod",false).mod};BN.prototype.umod=function umod(e){return this.divmod(e,"mod",true).mod};BN.prototype.divRound=function divRound(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var r=t.div.negative!==0?t.mod.isub(e):t.mod;var i=e.ushrn(1);var n=e.andln(1);var a=r.cmp(i);if(a<0||n===1&&a===0)return t.div;return t.div.negative!==0?t.div.isubn(1):t.div.iaddn(1)};BN.prototype.modn=function modn(e){assert(e<=67108863);var t=(1<<26)%e;var r=0;for(var i=this.length-1;i>=0;i--){r=(t*r+(this.words[i]|0))%e}return r};BN.prototype.idivn=function idivn(e){assert(e<=67108863);var t=0;for(var r=this.length-1;r>=0;r--){var i=(this.words[r]|0)+t*67108864;this.words[r]=i/e|0;t=i%e}return this.strip()};BN.prototype.divn=function divn(e){return this.clone().idivn(e)};BN.prototype.egcd=function egcd(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=new BN(0);var s=new BN(1);var o=0;while(t.isEven()&&r.isEven()){t.iushrn(1);r.iushrn(1);++o}var h=r.clone();var u=t.clone();while(!t.isZero()){for(var d=0,c=1;(t.words[0]&c)===0&&d<26;++d,c<<=1);if(d>0){t.iushrn(d);while(d-- >0){if(i.isOdd()||n.isOdd()){i.iadd(h);n.isub(u)}i.iushrn(1);n.iushrn(1)}}for(var l=0,p=1;(r.words[0]&p)===0&&l<26;++l,p<<=1);if(l>0){r.iushrn(l);while(l-- >0){if(a.isOdd()||s.isOdd()){a.iadd(h);s.isub(u)}a.iushrn(1);s.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(a);n.isub(s)}else{r.isub(t);a.isub(i);s.isub(n)}}return{a:a,b:s,gcd:r.iushln(o)}};BN.prototype._invmp=function _invmp(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=r.clone();while(t.cmpn(1)>0&&r.cmpn(1)>0){for(var s=0,o=1;(t.words[0]&o)===0&&s<26;++s,o<<=1);if(s>0){t.iushrn(s);while(s-- >0){if(i.isOdd()){i.iadd(a)}i.iushrn(1)}}for(var h=0,u=1;(r.words[0]&u)===0&&h<26;++h,u<<=1);if(h>0){r.iushrn(h);while(h-- >0){if(n.isOdd()){n.iadd(a)}n.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(n)}else{r.isub(t);n.isub(i)}}var d;if(t.cmpn(1)===0){d=i}else{d=n}if(d.cmpn(0)<0){d.iadd(e)}return d};BN.prototype.gcd=function gcd(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone();var r=e.clone();t.negative=0;r.negative=0;for(var i=0;t.isEven()&&r.isEven();i++){t.iushrn(1);r.iushrn(1)}do{while(t.isEven()){t.iushrn(1)}while(r.isEven()){r.iushrn(1)}var n=t.cmp(r);if(n<0){var a=t;t=r;r=a}else if(n===0||r.cmpn(1)===0){break}t.isub(r)}while(true);return r.iushln(i)};BN.prototype.invm=function invm(e){return this.egcd(e).a.umod(e)};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1};BN.prototype.andln=function andln(e){return this.words[0]&e};BN.prototype.bincn=function bincn(e){assert(typeof e==="number");var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r){this._expand(r+1);this.words[r]|=i;return this}var n=i;for(var a=r;n!==0&&a<this.length;a++){var s=this.words[a]|0;s+=n;n=s>>>26;s&=67108863;this.words[a]=s}if(n!==0){this.words[a]=n;this.length++}return this};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0};BN.prototype.cmpn=function cmpn(e){var t=e<0;if(this.negative!==0&&!t)return-1;if(this.negative===0&&t)return 1;this.strip();var r;if(this.length>1){r=1}else{if(t){e=-e}assert(e<=67108863,"Number is too big");var i=this.words[0]|0;r=i===e?0:i<e?-1:1}if(this.negative!==0)return-r|0;return r};BN.prototype.cmp=function cmp(e){if(this.negative!==0&&e.negative===0)return-1;if(this.negative===0&&e.negative!==0)return 1;var t=this.ucmp(e);if(this.negative!==0)return-t|0;return t};BN.prototype.ucmp=function ucmp(e){if(this.length>e.length)return 1;if(this.length<e.length)return-1;var t=0;for(var r=this.length-1;r>=0;r--){var i=this.words[r]|0;var n=e.words[r]|0;if(i===n)continue;if(i<n){t=-1}else if(i>n){t=1}break}return t};BN.prototype.gtn=function gtn(e){return this.cmpn(e)===1};BN.prototype.gt=function gt(e){return this.cmp(e)===1};BN.prototype.gten=function gten(e){return this.cmpn(e)>=0};BN.prototype.gte=function gte(e){return this.cmp(e)>=0};BN.prototype.ltn=function ltn(e){return this.cmpn(e)===-1};BN.prototype.lt=function lt(e){return this.cmp(e)===-1};BN.prototype.lten=function lten(e){return this.cmpn(e)<=0};BN.prototype.lte=function lte(e){return this.cmp(e)<=0};BN.prototype.eqn=function eqn(e){return this.cmpn(e)===0};BN.prototype.eq=function eq(e){return this.cmp(e)===0};BN.red=function red(e){return new Red(e)};BN.prototype.toRed=function toRed(e){assert(!this.red,"Already a number in reduction context");assert(this.negative===0,"red works only with positives");return e.convertTo(this)._forceRed(e)};BN.prototype.fromRed=function fromRed(){assert(this.red,"fromRed works only with numbers in reduction context");return this.red.convertFrom(this)};BN.prototype._forceRed=function _forceRed(e){this.red=e;return this};BN.prototype.forceRed=function forceRed(e){assert(!this.red,"Already a number in reduction context");return this._forceRed(e)};BN.prototype.redAdd=function redAdd(e){assert(this.red,"redAdd works only with red numbers");return this.red.add(this,e)};BN.prototype.redIAdd=function redIAdd(e){assert(this.red,"redIAdd works only with red numbers");return this.red.iadd(this,e)};BN.prototype.redSub=function redSub(e){assert(this.red,"redSub works only with red numbers");return this.red.sub(this,e)};BN.prototype.redISub=function redISub(e){assert(this.red,"redISub works only with red numbers");return this.red.isub(this,e)};BN.prototype.redShl=function redShl(e){assert(this.red,"redShl works only with red numbers");return this.red.shl(this,e)};BN.prototype.redMul=function redMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.mul(this,e)};BN.prototype.redIMul=function redIMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.imul(this,e)};BN.prototype.redSqr=function redSqr(){assert(this.red,"redSqr works only with red numbers");this.red._verify1(this);return this.red.sqr(this)};BN.prototype.redISqr=function redISqr(){assert(this.red,"redISqr works only with red numbers");this.red._verify1(this);return this.red.isqr(this)};BN.prototype.redSqrt=function redSqrt(){assert(this.red,"redSqrt works only with red numbers");this.red._verify1(this);return this.red.sqrt(this)};BN.prototype.redInvm=function redInvm(){assert(this.red,"redInvm works only with red numbers");this.red._verify1(this);return this.red.invm(this)};BN.prototype.redNeg=function redNeg(){assert(this.red,"redNeg works only with red numbers");this.red._verify1(this);return this.red.neg(this)};BN.prototype.redPow=function redPow(e){assert(this.red&&!e.red,"redPow(normalNum)");this.red._verify1(this);return this.red.pow(this,e)};var h={k256:null,p224:null,p192:null,p25519:null};function MPrime(e,t){this.name=e;this.p=new BN(t,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp()}MPrime.prototype._tmp=function _tmp(){var e=new BN(null);e.words=new Array(Math.ceil(this.n/13));return e};MPrime.prototype.ireduce=function ireduce(e){var t=e;var r;do{this.split(t,this.tmp);t=this.imulK(t);t=t.iadd(this.tmp);r=t.bitLength()}while(r>this.n);var i=r<this.n?-1:t.ucmp(this.p);if(i===0){t.words[0]=0;t.length=1}else if(i>0){t.isub(this.p)}else{if(t.strip!==undefined){t.strip()}else{t._strip()}}return t};MPrime.prototype.split=function split(e,t){e.iushrn(this.n,0,t)};MPrime.prototype.imulK=function imulK(e){return e.imul(this.k)};function K256(){MPrime.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}inherits(K256,MPrime);K256.prototype.split=function split(e,t){var r=4194303;var i=Math.min(e.length,9);for(var n=0;n<i;n++){t.words[n]=e.words[n]}t.length=i;if(e.length<=9){e.words[0]=0;e.length=1;return}var a=e.words[9];t.words[t.length++]=a&r;for(n=10;n<e.length;n++){var s=e.words[n]|0;e.words[n-10]=(s&r)<<4|a>>>22;a=s}a>>>=22;e.words[n-10]=a;if(a===0&&e.length>10){e.length-=10}else{e.length-=9}};K256.prototype.imulK=function imulK(e){e.words[e.length]=0;e.words[e.length+1]=0;e.length+=2;var t=0;for(var r=0;r<e.length;r++){var i=e.words[r]|0;t+=i*977;e.words[r]=t&67108863;t=i*64+(t/67108864|0)}if(e.words[e.length-1]===0){e.length--;if(e.words[e.length-1]===0){e.length--}}return e};function P224(){MPrime.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}inherits(P224,MPrime);function P192(){MPrime.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}inherits(P192,MPrime);function P25519(){MPrime.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(e){var t=0;for(var r=0;r<e.length;r++){var i=(e.words[r]|0)*19+t;var n=i&67108863;i>>>=26;e.words[r]=n;t=i}if(t!==0){e.words[e.length++]=t}return e};BN._prime=function prime(e){if(h[e])return h[e];var prime;if(e==="k256"){prime=new K256}else if(e==="p224"){prime=new P224}else if(e==="p192"){prime=new P192}else if(e==="p25519"){prime=new P25519}else{throw new Error("Unknown prime "+e)}h[e]=prime;return prime};function Red(e){if(typeof e==="string"){var t=BN._prime(e);this.m=t.p;this.prime=t}else{assert(e.gtn(1),"modulus must be greater than 1");this.m=e;this.prime=null}}Red.prototype._verify1=function _verify1(e){assert(e.negative===0,"red works only with positives");assert(e.red,"red works only with red numbers")};Red.prototype._verify2=function _verify2(e,t){assert((e.negative|t.negative)===0,"red works only with positives");assert(e.red&&e.red===t.red,"red works only with red numbers")};Red.prototype.imod=function imod(e){if(this.prime)return this.prime.ireduce(e)._forceRed(this);return e.umod(this.m)._forceRed(this)};Red.prototype.neg=function neg(e){if(e.isZero()){return e.clone()}return this.m.sub(e)._forceRed(this)};Red.prototype.add=function add(e,t){this._verify2(e,t);var r=e.add(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r._forceRed(this)};Red.prototype.iadd=function iadd(e,t){this._verify2(e,t);var r=e.iadd(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r};Red.prototype.sub=function sub(e,t){this._verify2(e,t);var r=e.sub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r._forceRed(this)};Red.prototype.isub=function isub(e,t){this._verify2(e,t);var r=e.isub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r};Red.prototype.shl=function shl(e,t){this._verify1(e);return this.imod(e.ushln(t))};Red.prototype.imul=function imul(e,t){this._verify2(e,t);return this.imod(e.imul(t))};Red.prototype.mul=function mul(e,t){this._verify2(e,t);return this.imod(e.mul(t))};Red.prototype.isqr=function isqr(e){return this.imul(e,e.clone())};Red.prototype.sqr=function sqr(e){return this.mul(e,e)};Red.prototype.sqrt=function sqrt(e){if(e.isZero())return e.clone();var t=this.m.andln(3);assert(t%2===1);if(t===3){var r=this.m.add(new BN(1)).iushrn(2);return this.pow(e,r)}var i=this.m.subn(1);var n=0;while(!i.isZero()&&i.andln(1)===0){n++;i.iushrn(1)}assert(!i.isZero());var a=new BN(1).toRed(this);var s=a.redNeg();var o=this.m.subn(1).iushrn(1);var h=this.m.bitLength();h=new BN(2*h*h).toRed(this);while(this.pow(h,o).cmp(s)!==0){h.redIAdd(s)}var u=this.pow(h,i);var d=this.pow(e,i.addn(1).iushrn(1));var c=this.pow(e,i);var l=n;while(c.cmp(a)!==0){var p=c;for(var v=0;p.cmp(a)!==0;v++){p=p.redSqr()}assert(v<l);var b=this.pow(u,new BN(1).iushln(l-v-1));d=d.redMul(b);u=b.redSqr();c=c.redMul(u);l=v}return d};Red.prototype.invm=function invm(e){var t=e._invmp(this.m);if(t.negative!==0){t.negative=0;return this.imod(t).redNeg()}else{return this.imod(t)}};Red.prototype.pow=function pow(e,t){if(t.isZero())return new BN(1).toRed(this);if(t.cmpn(1)===0)return e.clone();var r=4;var i=new Array(1<<r);i[0]=new BN(1).toRed(this);i[1]=e;for(var n=2;n<i.length;n++){i[n]=this.mul(i[n-1],e)}var a=i[0];var s=0;var o=0;var h=t.bitLength()%26;if(h===0){h=26}for(n=t.length-1;n>=0;n--){var u=t.words[n];for(var d=h-1;d>=0;d--){var c=u>>d&1;if(a!==i[0]){a=this.sqr(a)}if(c===0&&s===0){o=0;continue}s<<=1;s|=c;o++;if(o!==r&&(n!==0||d!==0))continue;a=this.mul(a,i[s]);o=0;s=0}h=26}return a};Red.prototype.convertTo=function convertTo(e){var t=e.umod(this.m);return t===e?t.clone():t};Red.prototype.convertFrom=function convertFrom(e){var t=e.clone();t.red=null;return t};BN.mont=function mont(e){return new Mont(e)};function Mont(e){Red.call(this,e);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv)}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(e){return this.imod(e.ushln(this.shift))};Mont.prototype.convertFrom=function convertFrom(e){var t=this.imod(e.mul(this.rinv));t.red=null;return t};Mont.prototype.imul=function imul(e,t){if(e.isZero()||t.isZero()){e.words[0]=0;e.length=1;return e}var r=e.imul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.mul=function mul(e,t){if(e.isZero()||t.isZero())return new BN(0)._forceRed(this);var r=e.mul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.invm=function invm(e){var t=this.imod(e._invmp(this.m).mul(this.r2));return t._forceRed(this)}})( false||e,this)},1670:function(e,t,r){e=r.nmd(e);(function(e,t){"use strict";function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}function inherits(e,t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}function BN(e,t,r){if(BN.isBN(e)){return e}this.negative=0;this.words=null;this.length=0;this.red=null;if(e!==null){if(t==="le"||t==="be"){r=t;t=10}this._init(e||0,t||10,r||"be")}}if(typeof e==="object"){e.exports=BN}else{t.BN=BN}BN.BN=BN;BN.wordSize=26;var i;try{i=r(4300).Buffer}catch(e){}BN.isBN=function isBN(e){if(e instanceof BN){return true}return e!==null&&typeof e==="object"&&e.constructor.wordSize===BN.wordSize&&Array.isArray(e.words)};BN.max=function max(e,t){if(e.cmp(t)>0)return e;return t};BN.min=function min(e,t){if(e.cmp(t)<0)return e;return t};BN.prototype._init=function init(e,t,r){if(typeof e==="number"){return this._initNumber(e,t,r)}if(typeof e==="object"){return this._initArray(e,t,r)}if(t==="hex"){t=16}assert(t===(t|0)&&t>=2&&t<=36);e=e.toString().replace(/\s+/g,"");var i=0;if(e[0]==="-"){i++}if(t===16){this._parseHex(e,i)}else{this._parseBase(e,t,i)}if(e[0]==="-"){this.negative=1}this._strip();if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initNumber=function _initNumber(e,t,r){if(e<0){this.negative=1;e=-e}if(e<67108864){this.words=[e&67108863];this.length=1}else if(e<4503599627370496){this.words=[e&67108863,e/67108864&67108863];this.length=2}else{assert(e<9007199254740992);this.words=[e&67108863,e/67108864&67108863,1];this.length=3}if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initArray=function _initArray(e,t,r){assert(typeof e.length==="number");if(e.length<=0){this.words=[0];this.length=1;return this}this.length=Math.ceil(e.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0}var n,a;var s=0;if(r==="be"){for(i=e.length-1,n=0;i>=0;i-=3){a=e[i]|e[i-1]<<8|e[i-2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}else if(r==="le"){for(i=0,n=0;i<e.length;i+=3){a=e[i]|e[i+1]<<8|e[i+2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}return this._strip()};function parseHex(e,t,r){var i=0;var n=Math.min(e.length,r);var a=0;for(var s=t;s<n;s++){var o=e.charCodeAt(s)-48;i<<=4;var h;if(o>=49&&o<=54){h=o-49+10}else if(o>=17&&o<=22){h=o-17+10}else{h=o}i|=h;a|=h}assert(!(a&240),"Invalid character in "+e);return i}BN.prototype._parseHex=function _parseHex(e,t){this.length=Math.ceil((e.length-t)/6);this.words=new Array(this.length);for(var r=0;r<this.length;r++){this.words[r]=0}var i,n;var a=0;for(r=e.length-6,i=0;r>=t;r-=6){n=parseHex(e,r,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303;a+=24;if(a>=26){a-=26;i++}}if(r+6!==t){n=parseHex(e,t,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303}this._strip()};function parseBase(e,t,r,i){var n=0;var a=0;var s=Math.min(e.length,r);for(var o=t;o<s;o++){var h=e.charCodeAt(o)-48;n*=i;if(h>=49){a=h-49+10}else if(h>=17){a=h-17+10}else{a=h}assert(h>=0&&a<i,"Invalid character");n+=a}return n}BN.prototype._parseBase=function _parseBase(e,t,r){this.words=[0];this.length=1;for(var i=0,n=1;n<=67108863;n*=t){i++}i--;n=n/t|0;var a=e.length-r;var s=a%i;var o=Math.min(a,a-s)+r;var h=0;for(var u=r;u<o;u+=i){h=parseBase(e,u,u+i,t);this.imuln(n);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}if(s!==0){var d=1;h=parseBase(e,u,e.length,t);for(u=0;u<s;u++){d*=t}this.imuln(d);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}};BN.prototype.copy=function copy(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++){e.words[t]=this.words[t]}e.length=this.length;e.negative=this.negative;e.red=this.red};function move(e,t){e.words=t.words;e.length=t.length;e.negative=t.negative;e.red=t.red}BN.prototype._move=function _move(e){move(e,this)};BN.prototype.clone=function clone(){var e=new BN(null);this.copy(e);return e};BN.prototype._expand=function _expand(e){while(this.length<e){this.words[this.length++]=0}return this};BN.prototype._strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--}return this._normSign()};BN.prototype._normSign=function _normSign(){if(this.length===1&&this.words[0]===0){this.negative=0}return this};if(typeof Symbol!=="undefined"&&typeof Symbol.for==="function"){BN.prototype[Symbol.for("nodejs.util.inspect.custom")]=inspect}else{BN.prototype.inspect=inspect}function inspect(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"}var n=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"];var a=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var s=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(e,t){e=e||10;t=t|0||1;var r;if(e===16||e==="hex"){r="";var i=0;var o=0;for(var h=0;h<this.length;h++){var u=this.words[h];var d=((u<<i|o)&16777215).toString(16);o=u>>>24-i&16777215;if(o!==0||h!==this.length-1){r=n[6-d.length]+d+r}else{r=d+r}i+=2;if(i>=26){i-=26;h--}}if(o!==0){r=o.toString(16)+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}if(e===(e|0)&&e>=2&&e<=36){var c=a[e];var l=s[e];r="";var p=this.clone();p.negative=0;while(!p.isZero()){var v=p.modrn(l).toString(e);p=p.idivn(l);if(!p.isZero()){r=n[c-v.length]+v+r}else{r=v+r}}if(this.isZero()){r="0"+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}assert(false,"Base should be between 2 and 36")};BN.prototype.toNumber=function toNumber(){var e=this.words[0];if(this.length===2){e+=this.words[1]*67108864}else if(this.length===3&&this.words[2]===1){e+=4503599627370496+this.words[1]*67108864}else if(this.length>2){assert(false,"Number can only safely store up to 53 bits")}return this.negative!==0?-e:e};BN.prototype.toJSON=function toJSON(){return this.toString(16,2)};if(i){BN.prototype.toBuffer=function toBuffer(e,t){return this.toArrayLike(i,e,t)}}BN.prototype.toArray=function toArray(e,t){return this.toArrayLike(Array,e,t)};var o=function allocate(e,t){if(e.allocUnsafe){return e.allocUnsafe(t)}return new e(t)};BN.prototype.toArrayLike=function toArrayLike(e,t,r){this._strip();var i=this.byteLength();var n=r||Math.max(1,i);assert(i<=n,"byte array longer than desired length");assert(n>0,"Requested array length <= 0");var a=o(e,n);var s=t==="le"?"LE":"BE";this["_toArrayLike"+s](a,i);return a};BN.prototype._toArrayLikeLE=function _toArrayLikeLE(e,t){var r=0;var i=0;for(var n=0,a=0;n<this.length;n++){var s=this.words[n]<<a|i;e[r++]=s&255;if(r<e.length){e[r++]=s>>8&255}if(r<e.length){e[r++]=s>>16&255}if(a===6){if(r<e.length){e[r++]=s>>24&255}i=0;a=0}else{i=s>>>24;a+=2}}if(r<e.length){e[r++]=i;while(r<e.length){e[r++]=0}}};BN.prototype._toArrayLikeBE=function _toArrayLikeBE(e,t){var r=e.length-1;var i=0;for(var n=0,a=0;n<this.length;n++){var s=this.words[n]<<a|i;e[r--]=s&255;if(r>=0){e[r--]=s>>8&255}if(r>=0){e[r--]=s>>16&255}if(a===6){if(r>=0){e[r--]=s>>24&255}i=0;a=0}else{i=s>>>24;a+=2}}if(r>=0){e[r--]=i;while(r>=0){e[r--]=0}}};if(Math.clz32){BN.prototype._countBits=function _countBits(e){return 32-Math.clz32(e)}}else{BN.prototype._countBits=function _countBits(e){var t=e;var r=0;if(t>=4096){r+=13;t>>>=13}if(t>=64){r+=7;t>>>=7}if(t>=8){r+=4;t>>>=4}if(t>=2){r+=2;t>>>=2}return r+t}}BN.prototype._zeroBits=function _zeroBits(e){if(e===0)return 26;var t=e;var r=0;if((t&8191)===0){r+=13;t>>>=13}if((t&127)===0){r+=7;t>>>=7}if((t&15)===0){r+=4;t>>>=4}if((t&3)===0){r+=2;t>>>=2}if((t&1)===0){r++}return r};BN.prototype.bitLength=function bitLength(){var e=this.words[this.length-1];var t=this._countBits(e);return(this.length-1)*26+t};function toBitArray(e){var t=new Array(e.bitLength());for(var r=0;r<t.length;r++){var i=r/26|0;var n=r%26;t[r]=e.words[i]>>>n&1}return t}BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var e=0;for(var t=0;t<this.length;t++){var r=this._zeroBits(this.words[t]);e+=r;if(r!==26)break}return e};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8)};BN.prototype.toTwos=function toTwos(e){if(this.negative!==0){return this.abs().inotn(e).iaddn(1)}return this.clone()};BN.prototype.fromTwos=function fromTwos(e){if(this.testn(e-1)){return this.notn(e).iaddn(1).ineg()}return this.clone()};BN.prototype.isNeg=function isNeg(){return this.negative!==0};BN.prototype.neg=function neg(){return this.clone().ineg()};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1}return this};BN.prototype.iuor=function iuor(e){while(this.length<e.length){this.words[this.length++]=0}for(var t=0;t<e.length;t++){this.words[t]=this.words[t]|e.words[t]}return this._strip()};BN.prototype.ior=function ior(e){assert((this.negative|e.negative)===0);return this.iuor(e)};BN.prototype.or=function or(e){if(this.length>e.length)return this.clone().ior(e);return e.clone().ior(this)};BN.prototype.uor=function uor(e){if(this.length>e.length)return this.clone().iuor(e);return e.clone().iuor(this)};BN.prototype.iuand=function iuand(e){var t;if(this.length>e.length){t=e}else{t=this}for(var r=0;r<t.length;r++){this.words[r]=this.words[r]&e.words[r]}this.length=t.length;return this._strip()};BN.prototype.iand=function iand(e){assert((this.negative|e.negative)===0);return this.iuand(e)};BN.prototype.and=function and(e){if(this.length>e.length)return this.clone().iand(e);return e.clone().iand(this)};BN.prototype.uand=function uand(e){if(this.length>e.length)return this.clone().iuand(e);return e.clone().iuand(this)};BN.prototype.iuxor=function iuxor(e){var t;var r;if(this.length>e.length){t=this;r=e}else{t=e;r=this}for(var i=0;i<r.length;i++){this.words[i]=t.words[i]^r.words[i]}if(this!==t){for(;i<t.length;i++){this.words[i]=t.words[i]}}this.length=t.length;return this._strip()};BN.prototype.ixor=function ixor(e){assert((this.negative|e.negative)===0);return this.iuxor(e)};BN.prototype.xor=function xor(e){if(this.length>e.length)return this.clone().ixor(e);return e.clone().ixor(this)};BN.prototype.uxor=function uxor(e){if(this.length>e.length)return this.clone().iuxor(e);return e.clone().iuxor(this)};BN.prototype.inotn=function inotn(e){assert(typeof e==="number"&&e>=0);var t=Math.ceil(e/26)|0;var r=e%26;this._expand(t);if(r>0){t--}for(var i=0;i<t;i++){this.words[i]=~this.words[i]&67108863}if(r>0){this.words[i]=~this.words[i]&67108863>>26-r}return this._strip()};BN.prototype.notn=function notn(e){return this.clone().inotn(e)};BN.prototype.setn=function setn(e,t){assert(typeof e==="number"&&e>=0);var r=e/26|0;var i=e%26;this._expand(r+1);if(t){this.words[r]=this.words[r]|1<<i}else{this.words[r]=this.words[r]&~(1<<i)}return this._strip()};BN.prototype.iadd=function iadd(e){var t;if(this.negative!==0&&e.negative===0){this.negative=0;t=this.isub(e);this.negative^=1;return this._normSign()}else if(this.negative===0&&e.negative!==0){e.negative=0;t=this.isub(e);e.negative=1;return t._normSign()}var r,i;if(this.length>e.length){r=this;i=e}else{r=e;i=this}var n=0;for(var a=0;a<i.length;a++){t=(r.words[a]|0)+(i.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}for(;n!==0&&a<r.length;a++){t=(r.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}this.length=r.length;if(n!==0){this.words[this.length]=n;this.length++}else if(r!==this){for(;a<r.length;a++){this.words[a]=r.words[a]}}return this};BN.prototype.add=function add(e){var t;if(e.negative!==0&&this.negative===0){e.negative=0;t=this.sub(e);e.negative^=1;return t}else if(e.negative===0&&this.negative!==0){this.negative=0;t=e.sub(this);this.negative=1;return t}if(this.length>e.length)return this.clone().iadd(e);return e.clone().iadd(this)};BN.prototype.isub=function isub(e){if(e.negative!==0){e.negative=0;var t=this.iadd(e);e.negative=1;return t._normSign()}else if(this.negative!==0){this.negative=0;this.iadd(e);this.negative=1;return this._normSign()}var r=this.cmp(e);if(r===0){this.negative=0;this.length=1;this.words[0]=0;return this}var i,n;if(r>0){i=this;n=e}else{i=e;n=this}var a=0;for(var s=0;s<n.length;s++){t=(i.words[s]|0)-(n.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}for(;a!==0&&s<i.length;s++){t=(i.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}if(a===0&&s<i.length&&i!==this){for(;s<i.length;s++){this.words[s]=i.words[s]}}this.length=Math.max(this.length,s);if(i!==this){this.negative=1}return this._strip()};BN.prototype.sub=function sub(e){return this.clone().isub(e)};function smallMulTo(e,t,r){r.negative=t.negative^e.negative;var i=e.length+t.length|0;r.length=i;i=i-1|0;var n=e.words[0]|0;var a=t.words[0]|0;var s=n*a;var o=s&67108863;var h=s/67108864|0;r.words[0]=o;for(var u=1;u<i;u++){var d=h>>>26;var c=h&67108863;var l=Math.min(u,t.length-1);for(var p=Math.max(0,u-e.length+1);p<=l;p++){var v=u-p|0;n=e.words[v]|0;a=t.words[p]|0;s=n*a+c;d+=s/67108864|0;c=s&67108863}r.words[u]=c|0;h=d|0}if(h!==0){r.words[u]=h|0}else{r.length--}return r._strip()}var h=function comb10MulTo(e,t,r){var i=e.words;var n=t.words;var a=r.words;var s=0;var o;var h;var u;var d=i[0]|0;var c=d&8191;var l=d>>>13;var p=i[1]|0;var v=p&8191;var b=p>>>13;var m=i[2]|0;var y=m&8191;var g=m>>>13;var _=i[3]|0;var w=_&8191;var M=_>>>13;var B=i[4]|0;var E=B&8191;var k=B>>>13;var A=i[5]|0;var N=A&8191;var P=A>>>13;var x=i[6]|0;var I=x&8191;var C=x>>>13;var D=i[7]|0;var T=D&8191;var j=D>>>13;var q=i[8]|0;var O=q&8191;var H=q>>>13;var L=i[9]|0;var z=L&8191;var F=L>>>13;var U=n[0]|0;var W=U&8191;var V=U>>>13;var G=n[1]|0;var J=G&8191;var Z=G>>>13;var X=n[2]|0;var Y=X&8191;var $=X>>>13;var Q=n[3]|0;var ee=Q&8191;var te=Q>>>13;var re=n[4]|0;var ie=re&8191;var ne=re>>>13;var ae=n[5]|0;var fe=ae&8191;var se=ae>>>13;var oe=n[6]|0;var he=oe&8191;var ue=oe>>>13;var de=n[7]|0;var ce=de&8191;var le=de>>>13;var pe=n[8]|0;var ve=pe&8191;var be=pe>>>13;var me=n[9]|0;var ye=me&8191;var ge=me>>>13;r.negative=e.negative^t.negative;r.length=19;o=Math.imul(c,W);h=Math.imul(c,V);h=h+Math.imul(l,W)|0;u=Math.imul(l,V);var _e=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(_e>>>26)|0;_e&=67108863;o=Math.imul(v,W);h=Math.imul(v,V);h=h+Math.imul(b,W)|0;u=Math.imul(b,V);o=o+Math.imul(c,J)|0;h=h+Math.imul(c,Z)|0;h=h+Math.imul(l,J)|0;u=u+Math.imul(l,Z)|0;var we=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(we>>>26)|0;we&=67108863;o=Math.imul(y,W);h=Math.imul(y,V);h=h+Math.imul(g,W)|0;u=Math.imul(g,V);o=o+Math.imul(v,J)|0;h=h+Math.imul(v,Z)|0;h=h+Math.imul(b,J)|0;u=u+Math.imul(b,Z)|0;o=o+Math.imul(c,Y)|0;h=h+Math.imul(c,$)|0;h=h+Math.imul(l,Y)|0;u=u+Math.imul(l,$)|0;var Me=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Me>>>26)|0;Me&=67108863;o=Math.imul(w,W);h=Math.imul(w,V);h=h+Math.imul(M,W)|0;u=Math.imul(M,V);o=o+Math.imul(y,J)|0;h=h+Math.imul(y,Z)|0;h=h+Math.imul(g,J)|0;u=u+Math.imul(g,Z)|0;o=o+Math.imul(v,Y)|0;h=h+Math.imul(v,$)|0;h=h+Math.imul(b,Y)|0;u=u+Math.imul(b,$)|0;o=o+Math.imul(c,ee)|0;h=h+Math.imul(c,te)|0;h=h+Math.imul(l,ee)|0;u=u+Math.imul(l,te)|0;var Se=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Se>>>26)|0;Se&=67108863;o=Math.imul(E,W);h=Math.imul(E,V);h=h+Math.imul(k,W)|0;u=Math.imul(k,V);o=o+Math.imul(w,J)|0;h=h+Math.imul(w,Z)|0;h=h+Math.imul(M,J)|0;u=u+Math.imul(M,Z)|0;o=o+Math.imul(y,Y)|0;h=h+Math.imul(y,$)|0;h=h+Math.imul(g,Y)|0;u=u+Math.imul(g,$)|0;o=o+Math.imul(v,ee)|0;h=h+Math.imul(v,te)|0;h=h+Math.imul(b,ee)|0;u=u+Math.imul(b,te)|0;o=o+Math.imul(c,ie)|0;h=h+Math.imul(c,ne)|0;h=h+Math.imul(l,ie)|0;u=u+Math.imul(l,ne)|0;var Be=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Be>>>26)|0;Be&=67108863;o=Math.imul(N,W);h=Math.imul(N,V);h=h+Math.imul(P,W)|0;u=Math.imul(P,V);o=o+Math.imul(E,J)|0;h=h+Math.imul(E,Z)|0;h=h+Math.imul(k,J)|0;u=u+Math.imul(k,Z)|0;o=o+Math.imul(w,Y)|0;h=h+Math.imul(w,$)|0;h=h+Math.imul(M,Y)|0;u=u+Math.imul(M,$)|0;o=o+Math.imul(y,ee)|0;h=h+Math.imul(y,te)|0;h=h+Math.imul(g,ee)|0;u=u+Math.imul(g,te)|0;o=o+Math.imul(v,ie)|0;h=h+Math.imul(v,ne)|0;h=h+Math.imul(b,ie)|0;u=u+Math.imul(b,ne)|0;o=o+Math.imul(c,fe)|0;h=h+Math.imul(c,se)|0;h=h+Math.imul(l,fe)|0;u=u+Math.imul(l,se)|0;var Ee=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ee>>>26)|0;Ee&=67108863;o=Math.imul(I,W);h=Math.imul(I,V);h=h+Math.imul(C,W)|0;u=Math.imul(C,V);o=o+Math.imul(N,J)|0;h=h+Math.imul(N,Z)|0;h=h+Math.imul(P,J)|0;u=u+Math.imul(P,Z)|0;o=o+Math.imul(E,Y)|0;h=h+Math.imul(E,$)|0;h=h+Math.imul(k,Y)|0;u=u+Math.imul(k,$)|0;o=o+Math.imul(w,ee)|0;h=h+Math.imul(w,te)|0;h=h+Math.imul(M,ee)|0;u=u+Math.imul(M,te)|0;o=o+Math.imul(y,ie)|0;h=h+Math.imul(y,ne)|0;h=h+Math.imul(g,ie)|0;u=u+Math.imul(g,ne)|0;o=o+Math.imul(v,fe)|0;h=h+Math.imul(v,se)|0;h=h+Math.imul(b,fe)|0;u=u+Math.imul(b,se)|0;o=o+Math.imul(c,he)|0;h=h+Math.imul(c,ue)|0;h=h+Math.imul(l,he)|0;u=u+Math.imul(l,ue)|0;var ke=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(ke>>>26)|0;ke&=67108863;o=Math.imul(T,W);h=Math.imul(T,V);h=h+Math.imul(j,W)|0;u=Math.imul(j,V);o=o+Math.imul(I,J)|0;h=h+Math.imul(I,Z)|0;h=h+Math.imul(C,J)|0;u=u+Math.imul(C,Z)|0;o=o+Math.imul(N,Y)|0;h=h+Math.imul(N,$)|0;h=h+Math.imul(P,Y)|0;u=u+Math.imul(P,$)|0;o=o+Math.imul(E,ee)|0;h=h+Math.imul(E,te)|0;h=h+Math.imul(k,ee)|0;u=u+Math.imul(k,te)|0;o=o+Math.imul(w,ie)|0;h=h+Math.imul(w,ne)|0;h=h+Math.imul(M,ie)|0;u=u+Math.imul(M,ne)|0;o=o+Math.imul(y,fe)|0;h=h+Math.imul(y,se)|0;h=h+Math.imul(g,fe)|0;u=u+Math.imul(g,se)|0;o=o+Math.imul(v,he)|0;h=h+Math.imul(v,ue)|0;h=h+Math.imul(b,he)|0;u=u+Math.imul(b,ue)|0;o=o+Math.imul(c,ce)|0;h=h+Math.imul(c,le)|0;h=h+Math.imul(l,ce)|0;u=u+Math.imul(l,le)|0;var Ae=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ae>>>26)|0;Ae&=67108863;o=Math.imul(O,W);h=Math.imul(O,V);h=h+Math.imul(H,W)|0;u=Math.imul(H,V);o=o+Math.imul(T,J)|0;h=h+Math.imul(T,Z)|0;h=h+Math.imul(j,J)|0;u=u+Math.imul(j,Z)|0;o=o+Math.imul(I,Y)|0;h=h+Math.imul(I,$)|0;h=h+Math.imul(C,Y)|0;u=u+Math.imul(C,$)|0;o=o+Math.imul(N,ee)|0;h=h+Math.imul(N,te)|0;h=h+Math.imul(P,ee)|0;u=u+Math.imul(P,te)|0;o=o+Math.imul(E,ie)|0;h=h+Math.imul(E,ne)|0;h=h+Math.imul(k,ie)|0;u=u+Math.imul(k,ne)|0;o=o+Math.imul(w,fe)|0;h=h+Math.imul(w,se)|0;h=h+Math.imul(M,fe)|0;u=u+Math.imul(M,se)|0;o=o+Math.imul(y,he)|0;h=h+Math.imul(y,ue)|0;h=h+Math.imul(g,he)|0;u=u+Math.imul(g,ue)|0;o=o+Math.imul(v,ce)|0;h=h+Math.imul(v,le)|0;h=h+Math.imul(b,ce)|0;u=u+Math.imul(b,le)|0;o=o+Math.imul(c,ve)|0;h=h+Math.imul(c,be)|0;h=h+Math.imul(l,ve)|0;u=u+Math.imul(l,be)|0;var Ne=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ne>>>26)|0;Ne&=67108863;o=Math.imul(z,W);h=Math.imul(z,V);h=h+Math.imul(F,W)|0;u=Math.imul(F,V);o=o+Math.imul(O,J)|0;h=h+Math.imul(O,Z)|0;h=h+Math.imul(H,J)|0;u=u+Math.imul(H,Z)|0;o=o+Math.imul(T,Y)|0;h=h+Math.imul(T,$)|0;h=h+Math.imul(j,Y)|0;u=u+Math.imul(j,$)|0;o=o+Math.imul(I,ee)|0;h=h+Math.imul(I,te)|0;h=h+Math.imul(C,ee)|0;u=u+Math.imul(C,te)|0;o=o+Math.imul(N,ie)|0;h=h+Math.imul(N,ne)|0;h=h+Math.imul(P,ie)|0;u=u+Math.imul(P,ne)|0;o=o+Math.imul(E,fe)|0;h=h+Math.imul(E,se)|0;h=h+Math.imul(k,fe)|0;u=u+Math.imul(k,se)|0;o=o+Math.imul(w,he)|0;h=h+Math.imul(w,ue)|0;h=h+Math.imul(M,he)|0;u=u+Math.imul(M,ue)|0;o=o+Math.imul(y,ce)|0;h=h+Math.imul(y,le)|0;h=h+Math.imul(g,ce)|0;u=u+Math.imul(g,le)|0;o=o+Math.imul(v,ve)|0;h=h+Math.imul(v,be)|0;h=h+Math.imul(b,ve)|0;u=u+Math.imul(b,be)|0;o=o+Math.imul(c,ye)|0;h=h+Math.imul(c,ge)|0;h=h+Math.imul(l,ye)|0;u=u+Math.imul(l,ge)|0;var Re=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Re>>>26)|0;Re&=67108863;o=Math.imul(z,J);h=Math.imul(z,Z);h=h+Math.imul(F,J)|0;u=Math.imul(F,Z);o=o+Math.imul(O,Y)|0;h=h+Math.imul(O,$)|0;h=h+Math.imul(H,Y)|0;u=u+Math.imul(H,$)|0;o=o+Math.imul(T,ee)|0;h=h+Math.imul(T,te)|0;h=h+Math.imul(j,ee)|0;u=u+Math.imul(j,te)|0;o=o+Math.imul(I,ie)|0;h=h+Math.imul(I,ne)|0;h=h+Math.imul(C,ie)|0;u=u+Math.imul(C,ne)|0;o=o+Math.imul(N,fe)|0;h=h+Math.imul(N,se)|0;h=h+Math.imul(P,fe)|0;u=u+Math.imul(P,se)|0;o=o+Math.imul(E,he)|0;h=h+Math.imul(E,ue)|0;h=h+Math.imul(k,he)|0;u=u+Math.imul(k,ue)|0;o=o+Math.imul(w,ce)|0;h=h+Math.imul(w,le)|0;h=h+Math.imul(M,ce)|0;u=u+Math.imul(M,le)|0;o=o+Math.imul(y,ve)|0;h=h+Math.imul(y,be)|0;h=h+Math.imul(g,ve)|0;u=u+Math.imul(g,be)|0;o=o+Math.imul(v,ye)|0;h=h+Math.imul(v,ge)|0;h=h+Math.imul(b,ye)|0;u=u+Math.imul(b,ge)|0;var Pe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Pe>>>26)|0;Pe&=67108863;o=Math.imul(z,Y);h=Math.imul(z,$);h=h+Math.imul(F,Y)|0;u=Math.imul(F,$);o=o+Math.imul(O,ee)|0;h=h+Math.imul(O,te)|0;h=h+Math.imul(H,ee)|0;u=u+Math.imul(H,te)|0;o=o+Math.imul(T,ie)|0;h=h+Math.imul(T,ne)|0;h=h+Math.imul(j,ie)|0;u=u+Math.imul(j,ne)|0;o=o+Math.imul(I,fe)|0;h=h+Math.imul(I,se)|0;h=h+Math.imul(C,fe)|0;u=u+Math.imul(C,se)|0;o=o+Math.imul(N,he)|0;h=h+Math.imul(N,ue)|0;h=h+Math.imul(P,he)|0;u=u+Math.imul(P,ue)|0;o=o+Math.imul(E,ce)|0;h=h+Math.imul(E,le)|0;h=h+Math.imul(k,ce)|0;u=u+Math.imul(k,le)|0;o=o+Math.imul(w,ve)|0;h=h+Math.imul(w,be)|0;h=h+Math.imul(M,ve)|0;u=u+Math.imul(M,be)|0;o=o+Math.imul(y,ye)|0;h=h+Math.imul(y,ge)|0;h=h+Math.imul(g,ye)|0;u=u+Math.imul(g,ge)|0;var xe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(xe>>>26)|0;xe&=67108863;o=Math.imul(z,ee);h=Math.imul(z,te);h=h+Math.imul(F,ee)|0;u=Math.imul(F,te);o=o+Math.imul(O,ie)|0;h=h+Math.imul(O,ne)|0;h=h+Math.imul(H,ie)|0;u=u+Math.imul(H,ne)|0;o=o+Math.imul(T,fe)|0;h=h+Math.imul(T,se)|0;h=h+Math.imul(j,fe)|0;u=u+Math.imul(j,se)|0;o=o+Math.imul(I,he)|0;h=h+Math.imul(I,ue)|0;h=h+Math.imul(C,he)|0;u=u+Math.imul(C,ue)|0;o=o+Math.imul(N,ce)|0;h=h+Math.imul(N,le)|0;h=h+Math.imul(P,ce)|0;u=u+Math.imul(P,le)|0;o=o+Math.imul(E,ve)|0;h=h+Math.imul(E,be)|0;h=h+Math.imul(k,ve)|0;u=u+Math.imul(k,be)|0;o=o+Math.imul(w,ye)|0;h=h+Math.imul(w,ge)|0;h=h+Math.imul(M,ye)|0;u=u+Math.imul(M,ge)|0;var Ie=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ie>>>26)|0;Ie&=67108863;o=Math.imul(z,ie);h=Math.imul(z,ne);h=h+Math.imul(F,ie)|0;u=Math.imul(F,ne);o=o+Math.imul(O,fe)|0;h=h+Math.imul(O,se)|0;h=h+Math.imul(H,fe)|0;u=u+Math.imul(H,se)|0;o=o+Math.imul(T,he)|0;h=h+Math.imul(T,ue)|0;h=h+Math.imul(j,he)|0;u=u+Math.imul(j,ue)|0;o=o+Math.imul(I,ce)|0;h=h+Math.imul(I,le)|0;h=h+Math.imul(C,ce)|0;u=u+Math.imul(C,le)|0;o=o+Math.imul(N,ve)|0;h=h+Math.imul(N,be)|0;h=h+Math.imul(P,ve)|0;u=u+Math.imul(P,be)|0;o=o+Math.imul(E,ye)|0;h=h+Math.imul(E,ge)|0;h=h+Math.imul(k,ye)|0;u=u+Math.imul(k,ge)|0;var Ce=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ce>>>26)|0;Ce&=67108863;o=Math.imul(z,fe);h=Math.imul(z,se);h=h+Math.imul(F,fe)|0;u=Math.imul(F,se);o=o+Math.imul(O,he)|0;h=h+Math.imul(O,ue)|0;h=h+Math.imul(H,he)|0;u=u+Math.imul(H,ue)|0;o=o+Math.imul(T,ce)|0;h=h+Math.imul(T,le)|0;h=h+Math.imul(j,ce)|0;u=u+Math.imul(j,le)|0;o=o+Math.imul(I,ve)|0;h=h+Math.imul(I,be)|0;h=h+Math.imul(C,ve)|0;u=u+Math.imul(C,be)|0;o=o+Math.imul(N,ye)|0;h=h+Math.imul(N,ge)|0;h=h+Math.imul(P,ye)|0;u=u+Math.imul(P,ge)|0;var De=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(De>>>26)|0;De&=67108863;o=Math.imul(z,he);h=Math.imul(z,ue);h=h+Math.imul(F,he)|0;u=Math.imul(F,ue);o=o+Math.imul(O,ce)|0;h=h+Math.imul(O,le)|0;h=h+Math.imul(H,ce)|0;u=u+Math.imul(H,le)|0;o=o+Math.imul(T,ve)|0;h=h+Math.imul(T,be)|0;h=h+Math.imul(j,ve)|0;u=u+Math.imul(j,be)|0;o=o+Math.imul(I,ye)|0;h=h+Math.imul(I,ge)|0;h=h+Math.imul(C,ye)|0;u=u+Math.imul(C,ge)|0;var Te=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Te>>>26)|0;Te&=67108863;o=Math.imul(z,ce);h=Math.imul(z,le);h=h+Math.imul(F,ce)|0;u=Math.imul(F,le);o=o+Math.imul(O,ve)|0;h=h+Math.imul(O,be)|0;h=h+Math.imul(H,ve)|0;u=u+Math.imul(H,be)|0;o=o+Math.imul(T,ye)|0;h=h+Math.imul(T,ge)|0;h=h+Math.imul(j,ye)|0;u=u+Math.imul(j,ge)|0;var je=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(je>>>26)|0;je&=67108863;o=Math.imul(z,ve);h=Math.imul(z,be);h=h+Math.imul(F,ve)|0;u=Math.imul(F,be);o=o+Math.imul(O,ye)|0;h=h+Math.imul(O,ge)|0;h=h+Math.imul(H,ye)|0;u=u+Math.imul(H,ge)|0;var qe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(qe>>>26)|0;qe&=67108863;o=Math.imul(z,ye);h=Math.imul(z,ge);h=h+Math.imul(F,ye)|0;u=Math.imul(F,ge);var Oe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Oe>>>26)|0;Oe&=67108863;a[0]=_e;a[1]=we;a[2]=Me;a[3]=Se;a[4]=Be;a[5]=Ee;a[6]=ke;a[7]=Ae;a[8]=Ne;a[9]=Re;a[10]=Pe;a[11]=xe;a[12]=Ie;a[13]=Ce;a[14]=De;a[15]=Te;a[16]=je;a[17]=qe;a[18]=Oe;if(s!==0){a[19]=s;r.length++}return r};if(!Math.imul){h=smallMulTo}function bigMulTo(e,t,r){r.negative=t.negative^e.negative;r.length=e.length+t.length;var i=0;var n=0;for(var a=0;a<r.length-1;a++){var s=n;n=0;var o=i&67108863;var h=Math.min(a,t.length-1);for(var u=Math.max(0,a-e.length+1);u<=h;u++){var d=a-u;var c=e.words[d]|0;var l=t.words[u]|0;var p=c*l;var v=p&67108863;s=s+(p/67108864|0)|0;v=v+o|0;o=v&67108863;s=s+(v>>>26)|0;n+=s>>>26;s&=67108863}r.words[a]=o;i=s;s=n}if(i!==0){r.words[a]=i}else{r.length--}return r._strip()}function jumboMulTo(e,t,r){return bigMulTo(e,t,r)}BN.prototype.mulTo=function mulTo(e,t){var r;var i=this.length+e.length;if(this.length===10&&e.length===10){r=h(this,e,t)}else if(i<63){r=smallMulTo(this,e,t)}else if(i<1024){r=bigMulTo(this,e,t)}else{r=jumboMulTo(this,e,t)}return r};function FFTM(e,t){this.x=e;this.y=t}FFTM.prototype.makeRBT=function makeRBT(e){var t=new Array(e);var r=BN.prototype._countBits(e)-1;for(var i=0;i<e;i++){t[i]=this.revBin(i,r,e)}return t};FFTM.prototype.revBin=function revBin(e,t,r){if(e===0||e===r-1)return e;var i=0;for(var n=0;n<t;n++){i|=(e&1)<<t-n-1;e>>=1}return i};FFTM.prototype.permute=function permute(e,t,r,i,n,a){for(var s=0;s<a;s++){i[s]=t[e[s]];n[s]=r[e[s]]}};FFTM.prototype.transform=function transform(e,t,r,i,n,a){this.permute(a,e,t,r,i,n);for(var s=1;s<n;s<<=1){var o=s<<1;var h=Math.cos(2*Math.PI/o);var u=Math.sin(2*Math.PI/o);for(var d=0;d<n;d+=o){var c=h;var l=u;for(var p=0;p<s;p++){var v=r[d+p];var b=i[d+p];var m=r[d+p+s];var y=i[d+p+s];var g=c*m-l*y;y=c*y+l*m;m=g;r[d+p]=v+m;i[d+p]=b+y;r[d+p+s]=v-m;i[d+p+s]=b-y;if(p!==o){g=h*c-u*l;l=h*l+u*c;c=g}}}}};FFTM.prototype.guessLen13b=function guessLen13b(e,t){var r=Math.max(t,e)|1;var i=r&1;var n=0;for(r=r/2|0;r;r=r>>>1){n++}return 1<<n+1+i};FFTM.prototype.conjugate=function conjugate(e,t,r){if(r<=1)return;for(var i=0;i<r/2;i++){var n=e[i];e[i]=e[r-i-1];e[r-i-1]=n;n=t[i];t[i]=-t[r-i-1];t[r-i-1]=-n}};FFTM.prototype.normalize13b=function normalize13b(e,t){var r=0;for(var i=0;i<t/2;i++){var n=Math.round(e[2*i+1]/t)*8192+Math.round(e[2*i]/t)+r;e[i]=n&67108863;if(n<67108864){r=0}else{r=n/67108864|0}}return e};FFTM.prototype.convert13b=function convert13b(e,t,r,i){var n=0;for(var a=0;a<t;a++){n=n+(e[a]|0);r[2*a]=n&8191;n=n>>>13;r[2*a+1]=n&8191;n=n>>>13}for(a=2*t;a<i;++a){r[a]=0}assert(n===0);assert((n&~8191)===0)};FFTM.prototype.stub=function stub(e){var t=new Array(e);for(var r=0;r<e;r++){t[r]=0}return t};FFTM.prototype.mulp=function mulp(e,t,r){var i=2*this.guessLen13b(e.length,t.length);var n=this.makeRBT(i);var a=this.stub(i);var s=new Array(i);var o=new Array(i);var h=new Array(i);var u=new Array(i);var d=new Array(i);var c=new Array(i);var l=r.words;l.length=i;this.convert13b(e.words,e.length,s,i);this.convert13b(t.words,t.length,u,i);this.transform(s,a,o,h,i,n);this.transform(u,a,d,c,i,n);for(var p=0;p<i;p++){var v=o[p]*d[p]-h[p]*c[p];h[p]=o[p]*c[p]+h[p]*d[p];o[p]=v}this.conjugate(o,h,i);this.transform(o,h,l,a,i,n);this.conjugate(l,a,i);this.normalize13b(l,i);r.negative=e.negative^t.negative;r.length=e.length+t.length;return r._strip()};BN.prototype.mul=function mul(e){var t=new BN(null);t.words=new Array(this.length+e.length);return this.mulTo(e,t)};BN.prototype.mulf=function mulf(e){var t=new BN(null);t.words=new Array(this.length+e.length);return jumboMulTo(this,e,t)};BN.prototype.imul=function imul(e){return this.clone().mulTo(e,this)};BN.prototype.imuln=function imuln(e){var t=e<0;if(t)e=-e;assert(typeof e==="number");assert(e<67108864);var r=0;for(var i=0;i<this.length;i++){var n=(this.words[i]|0)*e;var a=(n&67108863)+(r&67108863);r>>=26;r+=n/67108864|0;r+=a>>>26;this.words[i]=a&67108863}if(r!==0){this.words[i]=r;this.length++}return t?this.ineg():this};BN.prototype.muln=function muln(e){return this.clone().imuln(e)};BN.prototype.sqr=function sqr(){return this.mul(this)};BN.prototype.isqr=function isqr(){return this.imul(this.clone())};BN.prototype.pow=function pow(e){var t=toBitArray(e);if(t.length===0)return new BN(1);var r=this;for(var i=0;i<t.length;i++,r=r.sqr()){if(t[i]!==0)break}if(++i<t.length){for(var n=r.sqr();i<t.length;i++,n=n.sqr()){if(t[i]===0)continue;r=r.mul(n)}}return r};BN.prototype.iushln=function iushln(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=67108863>>>26-t<<26-t;var n;if(t!==0){var a=0;for(n=0;n<this.length;n++){var s=this.words[n]&i;var o=(this.words[n]|0)-s<<t;this.words[n]=o|a;a=s>>>26-t}if(a){this.words[n]=a;this.length++}}if(r!==0){for(n=this.length-1;n>=0;n--){this.words[n+r]=this.words[n]}for(n=0;n<r;n++){this.words[n]=0}this.length+=r}return this._strip()};BN.prototype.ishln=function ishln(e){assert(this.negative===0);return this.iushln(e)};BN.prototype.iushrn=function iushrn(e,t,r){assert(typeof e==="number"&&e>=0);var i;if(t){i=(t-t%26)/26}else{i=0}var n=e%26;var a=Math.min((e-n)/26,this.length);var s=67108863^67108863>>>n<<n;var o=r;i-=a;i=Math.max(0,i);if(o){for(var h=0;h<a;h++){o.words[h]=this.words[h]}o.length=a}if(a===0){}else if(this.length>a){this.length-=a;for(h=0;h<this.length;h++){this.words[h]=this.words[h+a]}}else{this.words[0]=0;this.length=1}var u=0;for(h=this.length-1;h>=0&&(u!==0||h>=i);h--){var d=this.words[h]|0;this.words[h]=u<<26-n|d>>>n;u=d&s}if(o&&u!==0){o.words[o.length++]=u}if(this.length===0){this.words[0]=0;this.length=1}return this._strip()};BN.prototype.ishrn=function ishrn(e,t,r){assert(this.negative===0);return this.iushrn(e,t,r)};BN.prototype.shln=function shln(e){return this.clone().ishln(e)};BN.prototype.ushln=function ushln(e){return this.clone().iushln(e)};BN.prototype.shrn=function shrn(e){return this.clone().ishrn(e)};BN.prototype.ushrn=function ushrn(e){return this.clone().iushrn(e)};BN.prototype.testn=function testn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r)return false;var n=this.words[r];return!!(n&i)};BN.prototype.imaskn=function imaskn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;assert(this.negative===0,"imaskn works only with positive numbers");if(this.length<=r){return this}if(t!==0){r++}this.length=Math.min(r,this.length);if(t!==0){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i}return this._strip()};BN.prototype.maskn=function maskn(e){return this.clone().imaskn(e)};BN.prototype.iaddn=function iaddn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.isubn(-e);if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<=e){this.words[0]=e-(this.words[0]|0);this.negative=0;return this}this.negative=0;this.isubn(e);this.negative=1;return this}return this._iaddn(e)};BN.prototype._iaddn=function _iaddn(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++){this.words[t]-=67108864;if(t===this.length-1){this.words[t+1]=1}else{this.words[t+1]++}}this.length=Math.max(this.length,t+1);return this};BN.prototype.isubn=function isubn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.iaddn(-e);if(this.negative!==0){this.negative=0;this.iaddn(e);this.negative=1;return this}this.words[0]-=e;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1}else{for(var t=0;t<this.length&&this.words[t]<0;t++){this.words[t]+=67108864;this.words[t+1]-=1}}return this._strip()};BN.prototype.addn=function addn(e){return this.clone().iaddn(e)};BN.prototype.subn=function subn(e){return this.clone().isubn(e)};BN.prototype.iabs=function iabs(){this.negative=0;return this};BN.prototype.abs=function abs(){return this.clone().iabs()};BN.prototype._ishlnsubmul=function _ishlnsubmul(e,t,r){var i=e.length+r;var n;this._expand(i);var a;var s=0;for(n=0;n<e.length;n++){a=(this.words[n+r]|0)+s;var o=(e.words[n]|0)*t;a-=o&67108863;s=(a>>26)-(o/67108864|0);this.words[n+r]=a&67108863}for(;n<this.length-r;n++){a=(this.words[n+r]|0)+s;s=a>>26;this.words[n+r]=a&67108863}if(s===0)return this._strip();assert(s===-1);s=0;for(n=0;n<this.length;n++){a=-(this.words[n]|0)+s;s=a>>26;this.words[n]=a&67108863}this.negative=1;return this._strip()};BN.prototype._wordDiv=function _wordDiv(e,t){var r=this.length-e.length;var i=this.clone();var n=e;var a=n.words[n.length-1]|0;var s=this._countBits(a);r=26-s;if(r!==0){n=n.ushln(r);i.iushln(r);a=n.words[n.length-1]|0}var o=i.length-n.length;var h;if(t!=="mod"){h=new BN(null);h.length=o+1;h.words=new Array(h.length);for(var u=0;u<h.length;u++){h.words[u]=0}}var d=i.clone()._ishlnsubmul(n,1,o);if(d.negative===0){i=d;if(h){h.words[o]=1}}for(var c=o-1;c>=0;c--){var l=(i.words[n.length+c]|0)*67108864+(i.words[n.length+c-1]|0);l=Math.min(l/a|0,67108863);i._ishlnsubmul(n,l,c);while(i.negative!==0){l--;i.negative=0;i._ishlnsubmul(n,1,c);if(!i.isZero()){i.negative^=1}}if(h){h.words[c]=l}}if(h){h._strip()}i._strip();if(t!=="div"&&r!==0){i.iushrn(r)}return{div:h||null,mod:i}};BN.prototype.divmod=function divmod(e,t,r){assert(!e.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)}}var i,n,a;if(this.negative!==0&&e.negative===0){a=this.neg().divmod(e,t);if(t!=="mod"){i=a.div.neg()}if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.iadd(e)}}return{div:i,mod:n}}if(this.negative===0&&e.negative!==0){a=this.divmod(e.neg(),t);if(t!=="mod"){i=a.div.neg()}return{div:i,mod:a.mod}}if((this.negative&e.negative)!==0){a=this.neg().divmod(e.neg(),t);if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.isub(e)}}return{div:a.div,mod:n}}if(e.length>this.length||this.cmp(e)<0){return{div:new BN(0),mod:this}}if(e.length===1){if(t==="div"){return{div:this.divn(e.words[0]),mod:null}}if(t==="mod"){return{div:null,mod:new BN(this.modrn(e.words[0]))}}return{div:this.divn(e.words[0]),mod:new BN(this.modrn(e.words[0]))}}return this._wordDiv(e,t)};BN.prototype.div=function div(e){return this.divmod(e,"div",false).div};BN.prototype.mod=function mod(e){return this.divmod(e,"mod",false).mod};BN.prototype.umod=function umod(e){return this.divmod(e,"mod",true).mod};BN.prototype.divRound=function divRound(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var r=t.div.negative!==0?t.mod.isub(e):t.mod;var i=e.ushrn(1);var n=e.andln(1);var a=r.cmp(i);if(a<0||n===1&&a===0)return t.div;return t.div.negative!==0?t.div.isubn(1):t.div.iaddn(1)};BN.prototype.modrn=function modrn(e){var t=e<0;if(t)e=-e;assert(e<=67108863);var r=(1<<26)%e;var i=0;for(var n=this.length-1;n>=0;n--){i=(r*i+(this.words[n]|0))%e}return t?-i:i};BN.prototype.modn=function modn(e){return this.modrn(e)};BN.prototype.idivn=function idivn(e){var t=e<0;if(t)e=-e;assert(e<=67108863);var r=0;for(var i=this.length-1;i>=0;i--){var n=(this.words[i]|0)+r*67108864;this.words[i]=n/e|0;r=n%e}this._strip();return t?this.ineg():this};BN.prototype.divn=function divn(e){return this.clone().idivn(e)};BN.prototype.egcd=function egcd(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=new BN(0);var s=new BN(1);var o=0;while(t.isEven()&&r.isEven()){t.iushrn(1);r.iushrn(1);++o}var h=r.clone();var u=t.clone();while(!t.isZero()){for(var d=0,c=1;(t.words[0]&c)===0&&d<26;++d,c<<=1);if(d>0){t.iushrn(d);while(d-- >0){if(i.isOdd()||n.isOdd()){i.iadd(h);n.isub(u)}i.iushrn(1);n.iushrn(1)}}for(var l=0,p=1;(r.words[0]&p)===0&&l<26;++l,p<<=1);if(l>0){r.iushrn(l);while(l-- >0){if(a.isOdd()||s.isOdd()){a.iadd(h);s.isub(u)}a.iushrn(1);s.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(a);n.isub(s)}else{r.isub(t);a.isub(i);s.isub(n)}}return{a:a,b:s,gcd:r.iushln(o)}};BN.prototype._invmp=function _invmp(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=r.clone();while(t.cmpn(1)>0&&r.cmpn(1)>0){for(var s=0,o=1;(t.words[0]&o)===0&&s<26;++s,o<<=1);if(s>0){t.iushrn(s);while(s-- >0){if(i.isOdd()){i.iadd(a)}i.iushrn(1)}}for(var h=0,u=1;(r.words[0]&u)===0&&h<26;++h,u<<=1);if(h>0){r.iushrn(h);while(h-- >0){if(n.isOdd()){n.iadd(a)}n.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(n)}else{r.isub(t);n.isub(i)}}var d;if(t.cmpn(1)===0){d=i}else{d=n}if(d.cmpn(0)<0){d.iadd(e)}return d};BN.prototype.gcd=function gcd(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone();var r=e.clone();t.negative=0;r.negative=0;for(var i=0;t.isEven()&&r.isEven();i++){t.iushrn(1);r.iushrn(1)}do{while(t.isEven()){t.iushrn(1)}while(r.isEven()){r.iushrn(1)}var n=t.cmp(r);if(n<0){var a=t;t=r;r=a}else if(n===0||r.cmpn(1)===0){break}t.isub(r)}while(true);return r.iushln(i)};BN.prototype.invm=function invm(e){return this.egcd(e).a.umod(e)};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1};BN.prototype.andln=function andln(e){return this.words[0]&e};BN.prototype.bincn=function bincn(e){assert(typeof e==="number");var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r){this._expand(r+1);this.words[r]|=i;return this}var n=i;for(var a=r;n!==0&&a<this.length;a++){var s=this.words[a]|0;s+=n;n=s>>>26;s&=67108863;this.words[a]=s}if(n!==0){this.words[a]=n;this.length++}return this};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0};BN.prototype.cmpn=function cmpn(e){var t=e<0;if(this.negative!==0&&!t)return-1;if(this.negative===0&&t)return 1;this._strip();var r;if(this.length>1){r=1}else{if(t){e=-e}assert(e<=67108863,"Number is too big");var i=this.words[0]|0;r=i===e?0:i<e?-1:1}if(this.negative!==0)return-r|0;return r};BN.prototype.cmp=function cmp(e){if(this.negative!==0&&e.negative===0)return-1;if(this.negative===0&&e.negative!==0)return 1;var t=this.ucmp(e);if(this.negative!==0)return-t|0;return t};BN.prototype.ucmp=function ucmp(e){if(this.length>e.length)return 1;if(this.length<e.length)return-1;var t=0;for(var r=this.length-1;r>=0;r--){var i=this.words[r]|0;var n=e.words[r]|0;if(i===n)continue;if(i<n){t=-1}else if(i>n){t=1}break}return t};BN.prototype.gtn=function gtn(e){return this.cmpn(e)===1};BN.prototype.gt=function gt(e){return this.cmp(e)===1};BN.prototype.gten=function gten(e){return this.cmpn(e)>=0};BN.prototype.gte=function gte(e){return this.cmp(e)>=0};BN.prototype.ltn=function ltn(e){return this.cmpn(e)===-1};BN.prototype.lt=function lt(e){return this.cmp(e)===-1};BN.prototype.lten=function lten(e){return this.cmpn(e)<=0};BN.prototype.lte=function lte(e){return this.cmp(e)<=0};BN.prototype.eqn=function eqn(e){return this.cmpn(e)===0};BN.prototype.eq=function eq(e){return this.cmp(e)===0};BN.red=function red(e){return new Red(e)};BN.prototype.toRed=function toRed(e){assert(!this.red,"Already a number in reduction context");assert(this.negative===0,"red works only with positives");return e.convertTo(this)._forceRed(e)};BN.prototype.fromRed=function fromRed(){assert(this.red,"fromRed works only with numbers in reduction context");return this.red.convertFrom(this)};BN.prototype._forceRed=function _forceRed(e){this.red=e;return this};BN.prototype.forceRed=function forceRed(e){assert(!this.red,"Already a number in reduction context");return this._forceRed(e)};BN.prototype.redAdd=function redAdd(e){assert(this.red,"redAdd works only with red numbers");return this.red.add(this,e)};BN.prototype.redIAdd=function redIAdd(e){assert(this.red,"redIAdd works only with red numbers");return this.red.iadd(this,e)};BN.prototype.redSub=function redSub(e){assert(this.red,"redSub works only with red numbers");return this.red.sub(this,e)};BN.prototype.redISub=function redISub(e){assert(this.red,"redISub works only with red numbers");return this.red.isub(this,e)};BN.prototype.redShl=function redShl(e){assert(this.red,"redShl works only with red numbers");return this.red.shl(this,e)};BN.prototype.redMul=function redMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.mul(this,e)};BN.prototype.redIMul=function redIMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.imul(this,e)};BN.prototype.redSqr=function redSqr(){assert(this.red,"redSqr works only with red numbers");this.red._verify1(this);return this.red.sqr(this)};BN.prototype.redISqr=function redISqr(){assert(this.red,"redISqr works only with red numbers");this.red._verify1(this);return this.red.isqr(this)};BN.prototype.redSqrt=function redSqrt(){assert(this.red,"redSqrt works only with red numbers");this.red._verify1(this);return this.red.sqrt(this)};BN.prototype.redInvm=function redInvm(){assert(this.red,"redInvm works only with red numbers");this.red._verify1(this);return this.red.invm(this)};BN.prototype.redNeg=function redNeg(){assert(this.red,"redNeg works only with red numbers");this.red._verify1(this);return this.red.neg(this)};BN.prototype.redPow=function redPow(e){assert(this.red&&!e.red,"redPow(normalNum)");this.red._verify1(this);return this.red.pow(this,e)};var u={k256:null,p224:null,p192:null,p25519:null};function MPrime(e,t){this.name=e;this.p=new BN(t,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp()}MPrime.prototype._tmp=function _tmp(){var e=new BN(null);e.words=new Array(Math.ceil(this.n/13));return e};MPrime.prototype.ireduce=function ireduce(e){var t=e;var r;do{this.split(t,this.tmp);t=this.imulK(t);t=t.iadd(this.tmp);r=t.bitLength()}while(r>this.n);var i=r<this.n?-1:t.ucmp(this.p);if(i===0){t.words[0]=0;t.length=1}else if(i>0){t.isub(this.p)}else{if(t.strip!==undefined){t.strip()}else{t._strip()}}return t};MPrime.prototype.split=function split(e,t){e.iushrn(this.n,0,t)};MPrime.prototype.imulK=function imulK(e){return e.imul(this.k)};function K256(){MPrime.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}inherits(K256,MPrime);K256.prototype.split=function split(e,t){var r=4194303;var i=Math.min(e.length,9);for(var n=0;n<i;n++){t.words[n]=e.words[n]}t.length=i;if(e.length<=9){e.words[0]=0;e.length=1;return}var a=e.words[9];t.words[t.length++]=a&r;for(n=10;n<e.length;n++){var s=e.words[n]|0;e.words[n-10]=(s&r)<<4|a>>>22;a=s}a>>>=22;e.words[n-10]=a;if(a===0&&e.length>10){e.length-=10}else{e.length-=9}};K256.prototype.imulK=function imulK(e){e.words[e.length]=0;e.words[e.length+1]=0;e.length+=2;var t=0;for(var r=0;r<e.length;r++){var i=e.words[r]|0;t+=i*977;e.words[r]=t&67108863;t=i*64+(t/67108864|0)}if(e.words[e.length-1]===0){e.length--;if(e.words[e.length-1]===0){e.length--}}return e};function P224(){MPrime.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}inherits(P224,MPrime);function P192(){MPrime.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}inherits(P192,MPrime);function P25519(){MPrime.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(e){var t=0;for(var r=0;r<e.length;r++){var i=(e.words[r]|0)*19+t;var n=i&67108863;i>>>=26;e.words[r]=n;t=i}if(t!==0){e.words[e.length++]=t}return e};BN._prime=function prime(e){if(u[e])return u[e];var prime;if(e==="k256"){prime=new K256}else if(e==="p224"){prime=new P224}else if(e==="p192"){prime=new P192}else if(e==="p25519"){prime=new P25519}else{throw new Error("Unknown prime "+e)}u[e]=prime;return prime};function Red(e){if(typeof e==="string"){var t=BN._prime(e);this.m=t.p;this.prime=t}else{assert(e.gtn(1),"modulus must be greater than 1");this.m=e;this.prime=null}}Red.prototype._verify1=function _verify1(e){assert(e.negative===0,"red works only with positives");assert(e.red,"red works only with red numbers")};Red.prototype._verify2=function _verify2(e,t){assert((e.negative|t.negative)===0,"red works only with positives");assert(e.red&&e.red===t.red,"red works only with red numbers")};Red.prototype.imod=function imod(e){if(this.prime)return this.prime.ireduce(e)._forceRed(this);move(e,e.umod(this.m)._forceRed(this));return e};Red.prototype.neg=function neg(e){if(e.isZero()){return e.clone()}return this.m.sub(e)._forceRed(this)};Red.prototype.add=function add(e,t){this._verify2(e,t);var r=e.add(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r._forceRed(this)};Red.prototype.iadd=function iadd(e,t){this._verify2(e,t);var r=e.iadd(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r};Red.prototype.sub=function sub(e,t){this._verify2(e,t);var r=e.sub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r._forceRed(this)};Red.prototype.isub=function isub(e,t){this._verify2(e,t);var r=e.isub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r};Red.prototype.shl=function shl(e,t){this._verify1(e);return this.imod(e.ushln(t))};Red.prototype.imul=function imul(e,t){this._verify2(e,t);return this.imod(e.imul(t))};Red.prototype.mul=function mul(e,t){this._verify2(e,t);return this.imod(e.mul(t))};Red.prototype.isqr=function isqr(e){return this.imul(e,e.clone())};Red.prototype.sqr=function sqr(e){return this.mul(e,e)};Red.prototype.sqrt=function sqrt(e){if(e.isZero())return e.clone();var t=this.m.andln(3);assert(t%2===1);if(t===3){var r=this.m.add(new BN(1)).iushrn(2);return this.pow(e,r)}var i=this.m.subn(1);var n=0;while(!i.isZero()&&i.andln(1)===0){n++;i.iushrn(1)}assert(!i.isZero());var a=new BN(1).toRed(this);var s=a.redNeg();var o=this.m.subn(1).iushrn(1);var h=this.m.bitLength();h=new BN(2*h*h).toRed(this);while(this.pow(h,o).cmp(s)!==0){h.redIAdd(s)}var u=this.pow(h,i);var d=this.pow(e,i.addn(1).iushrn(1));var c=this.pow(e,i);var l=n;while(c.cmp(a)!==0){var p=c;for(var v=0;p.cmp(a)!==0;v++){p=p.redSqr()}assert(v<l);var b=this.pow(u,new BN(1).iushln(l-v-1));d=d.redMul(b);u=b.redSqr();c=c.redMul(u);l=v}return d};Red.prototype.invm=function invm(e){var t=e._invmp(this.m);if(t.negative!==0){t.negative=0;return this.imod(t).redNeg()}else{return this.imod(t)}};Red.prototype.pow=function pow(e,t){if(t.isZero())return new BN(1).toRed(this);if(t.cmpn(1)===0)return e.clone();var r=4;var i=new Array(1<<r);i[0]=new BN(1).toRed(this);i[1]=e;for(var n=2;n<i.length;n++){i[n]=this.mul(i[n-1],e)}var a=i[0];var s=0;var o=0;var h=t.bitLength()%26;if(h===0){h=26}for(n=t.length-1;n>=0;n--){var u=t.words[n];for(var d=h-1;d>=0;d--){var c=u>>d&1;if(a!==i[0]){a=this.sqr(a)}if(c===0&&s===0){o=0;continue}s<<=1;s|=c;o++;if(o!==r&&(n!==0||d!==0))continue;a=this.mul(a,i[s]);o=0;s=0}h=26}return a};Red.prototype.convertTo=function convertTo(e){var t=e.umod(this.m);return t===e?t.clone():t};Red.prototype.convertFrom=function convertFrom(e){var t=e.clone();t.red=null;return t};BN.mont=function mont(e){return new Mont(e)};function Mont(e){Red.call(this,e);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv)}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(e){return this.imod(e.ushln(this.shift))};Mont.prototype.convertFrom=function convertFrom(e){var t=this.imod(e.mul(this.rinv));t.red=null;return t};Mont.prototype.imul=function imul(e,t){if(e.isZero()||t.isZero()){e.words[0]=0;e.length=1;return e}var r=e.imul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.mul=function mul(e,t){if(e.isZero()||t.isZero())return new BN(0)._forceRed(this);var r=e.mul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.invm=function invm(e){var t=this.imod(e._invmp(this.m).mul(this.r2));return t._forceRed(this)}})( false||e,this)},3500:function(e,t,r){var i;e.exports=function rand(e){if(!i)i=new Rand(null);return i.generate(e)};function Rand(e){this.rand=e}e.exports.Rand=Rand;Rand.prototype.generate=function generate(e){return this._rand(e)};Rand.prototype._rand=function _rand(e){if(this.rand.getBytes)return this.rand.getBytes(e);var t=new Uint8Array(e);for(var r=0;r<t.length;r++)t[r]=this.rand.getByte();return t};if(typeof self==="object"){if(self.crypto&&self.crypto.getRandomValues){Rand.prototype._rand=function _rand(e){var t=new Uint8Array(e);self.crypto.getRandomValues(t);return t}}else if(self.msCrypto&&self.msCrypto.getRandomValues){Rand.prototype._rand=function _rand(e){var t=new Uint8Array(e);self.msCrypto.getRandomValues(t);return t}}else if(typeof window==="object"){Rand.prototype._rand=function(){throw new Error("Not implemented yet")}}}else{try{var n=r(6113);if(typeof n.randomBytes!=="function")throw new Error("Not supported");Rand.prototype._rand=function _rand(e){return n.randomBytes(e)}}catch(e){}}},1387:function(e,t,r){var i=r(5055).Buffer;function asUInt32Array(e){if(!i.isBuffer(e))e=i.from(e);var t=e.length/4|0;var r=new Array(t);for(var n=0;n<t;n++){r[n]=e.readUInt32BE(n*4)}return r}function scrubVec(e){for(var t=0;t<e.length;e++){e[t]=0}}function cryptBlock(e,t,r,i,n){var a=r[0];var s=r[1];var o=r[2];var h=r[3];var u=e[0]^t[0];var d=e[1]^t[1];var c=e[2]^t[2];var l=e[3]^t[3];var p,v,b,m;var y=4;for(var g=1;g<n;g++){p=a[u>>>24]^s[d>>>16&255]^o[c>>>8&255]^h[l&255]^t[y++];v=a[d>>>24]^s[c>>>16&255]^o[l>>>8&255]^h[u&255]^t[y++];b=a[c>>>24]^s[l>>>16&255]^o[u>>>8&255]^h[d&255]^t[y++];m=a[l>>>24]^s[u>>>16&255]^o[d>>>8&255]^h[c&255]^t[y++];u=p;d=v;c=b;l=m}p=(i[u>>>24]<<24|i[d>>>16&255]<<16|i[c>>>8&255]<<8|i[l&255])^t[y++];v=(i[d>>>24]<<24|i[c>>>16&255]<<16|i[l>>>8&255]<<8|i[u&255])^t[y++];b=(i[c>>>24]<<24|i[l>>>16&255]<<16|i[u>>>8&255]<<8|i[d&255])^t[y++];m=(i[l>>>24]<<24|i[u>>>16&255]<<16|i[d>>>8&255]<<8|i[c&255])^t[y++];p=p>>>0;v=v>>>0;b=b>>>0;m=m>>>0;return[p,v,b,m]}var n=[0,1,2,4,8,16,32,64,128,27,54];var a=function(){var e=new Array(256);for(var t=0;t<256;t++){if(t<128){e[t]=t<<1}else{e[t]=t<<1^283}}var r=[];var i=[];var n=[[],[],[],[]];var a=[[],[],[],[]];var s=0;var o=0;for(var h=0;h<256;++h){var u=o^o<<1^o<<2^o<<3^o<<4;u=u>>>8^u&255^99;r[s]=u;i[u]=s;var d=e[s];var c=e[d];var l=e[c];var p=e[u]*257^u*16843008;n[0][s]=p<<24|p>>>8;n[1][s]=p<<16|p>>>16;n[2][s]=p<<8|p>>>24;n[3][s]=p;p=l*16843009^c*65537^d*257^s*16843008;a[0][u]=p<<24|p>>>8;a[1][u]=p<<16|p>>>16;a[2][u]=p<<8|p>>>24;a[3][u]=p;if(s===0){s=o=1}else{s=d^e[e[e[l^d]]];o^=e[e[o]]}}return{SBOX:r,INV_SBOX:i,SUB_MIX:n,INV_SUB_MIX:a}}();function AES(e){this._key=asUInt32Array(e);this._reset()}AES.blockSize=4*4;AES.keySize=256/8;AES.prototype.blockSize=AES.blockSize;AES.prototype.keySize=AES.keySize;AES.prototype._reset=function(){var e=this._key;var t=e.length;var r=t+6;var i=(r+1)*4;var s=[];for(var o=0;o<t;o++){s[o]=e[o]}for(o=t;o<i;o++){var h=s[o-1];if(o%t===0){h=h<<8|h>>>24;h=a.SBOX[h>>>24]<<24|a.SBOX[h>>>16&255]<<16|a.SBOX[h>>>8&255]<<8|a.SBOX[h&255];h^=n[o/t|0]<<24}else if(t>6&&o%t===4){h=a.SBOX[h>>>24]<<24|a.SBOX[h>>>16&255]<<16|a.SBOX[h>>>8&255]<<8|a.SBOX[h&255]}s[o]=s[o-t]^h}var u=[];for(var d=0;d<i;d++){var c=i-d;var l=s[c-(d%4?0:4)];if(d<4||c<=4){u[d]=l}else{u[d]=a.INV_SUB_MIX[0][a.SBOX[l>>>24]]^a.INV_SUB_MIX[1][a.SBOX[l>>>16&255]]^a.INV_SUB_MIX[2][a.SBOX[l>>>8&255]]^a.INV_SUB_MIX[3][a.SBOX[l&255]]}}this._nRounds=r;this._keySchedule=s;this._invKeySchedule=u};AES.prototype.encryptBlockRaw=function(e){e=asUInt32Array(e);return cryptBlock(e,this._keySchedule,a.SUB_MIX,a.SBOX,this._nRounds)};AES.prototype.encryptBlock=function(e){var t=this.encryptBlockRaw(e);var r=i.allocUnsafe(16);r.writeUInt32BE(t[0],0);r.writeUInt32BE(t[1],4);r.writeUInt32BE(t[2],8);r.writeUInt32BE(t[3],12);return r};AES.prototype.decryptBlock=function(e){e=asUInt32Array(e);var t=e[1];e[1]=e[3];e[3]=t;var r=cryptBlock(e,this._invKeySchedule,a.INV_SUB_MIX,a.INV_SBOX,this._nRounds);var n=i.allocUnsafe(16);n.writeUInt32BE(r[0],0);n.writeUInt32BE(r[3],4);n.writeUInt32BE(r[2],8);n.writeUInt32BE(r[1],12);return n};AES.prototype.scrub=function(){scrubVec(this._keySchedule);scrubVec(this._invKeySchedule);scrubVec(this._key)};e.exports.AES=AES},6624:function(e,t,r){var i=r(1387);var n=r(5055).Buffer;var a=r(1043);var s=r(3782);var o=r(7225);var h=r(4734);var u=r(598);function xorTest(e,t){var r=0;if(e.length!==t.length)r++;var i=Math.min(e.length,t.length);for(var n=0;n<i;++n){r+=e[n]^t[n]}return r}function calcIv(e,t,r){if(t.length===12){e._finID=n.concat([t,n.from([0,0,0,1])]);return n.concat([t,n.from([0,0,0,2])])}var i=new o(r);var a=t.length;var s=a%16;i.update(t);if(s){s=16-s;i.update(n.alloc(s,0))}i.update(n.alloc(8,0));var h=a*8;var d=n.alloc(8);d.writeUIntBE(h,0,8);i.update(d);e._finID=i.state;var c=n.from(e._finID);u(c);return c}function StreamCipher(e,t,r,s){a.call(this);var h=n.alloc(4,0);this._cipher=new i.AES(t);var u=this._cipher.encryptBlock(h);this._ghash=new o(u);r=calcIv(this,r,u);this._prev=n.from(r);this._cache=n.allocUnsafe(0);this._secCache=n.allocUnsafe(0);this._decrypt=s;this._alen=0;this._len=0;this._mode=e;this._authTag=null;this._called=false}s(StreamCipher,a);StreamCipher.prototype._update=function(e){if(!this._called&&this._alen){var t=16-this._alen%16;if(t<16){t=n.alloc(t,0);this._ghash.update(t)}}this._called=true;var r=this._mode.encrypt(this,e);if(this._decrypt){this._ghash.update(e)}else{this._ghash.update(r)}this._len+=e.length;return r};StreamCipher.prototype._final=function(){if(this._decrypt&&!this._authTag)throw new Error("Unsupported state or unable to authenticate data");var e=h(this._ghash.final(this._alen*8,this._len*8),this._cipher.encryptBlock(this._finID));if(this._decrypt&&xorTest(e,this._authTag))throw new Error("Unsupported state or unable to authenticate data");this._authTag=e;this._cipher.scrub()};StreamCipher.prototype.getAuthTag=function getAuthTag(){if(this._decrypt||!n.isBuffer(this._authTag))throw new Error("Attempting to get auth tag in unsupported state");return this._authTag};StreamCipher.prototype.setAuthTag=function setAuthTag(e){if(!this._decrypt)throw new Error("Attempting to set auth tag in unsupported state");this._authTag=e};StreamCipher.prototype.setAAD=function setAAD(e){if(this._called)throw new Error("Attempting to set AAD in unsupported state");this._ghash.update(e);this._alen+=e.length};e.exports=StreamCipher},6594:function(e,t,r){var i=r(2);var n=r(2598);var a=r(5866);function getCiphers(){return Object.keys(a)}t.createCipher=t.Cipher=i.createCipher;t.createCipheriv=t.Cipheriv=i.createCipheriv;t.createDecipher=t.Decipher=n.createDecipher;t.createDecipheriv=t.Decipheriv=n.createDecipheriv;t.listCiphers=t.getCiphers=getCiphers},2598:function(e,t,r){var i=r(6624);var n=r(5055).Buffer;var a=r(6370);var s=r(126);var o=r(1043);var h=r(1387);var u=r(8368);var d=r(3782);function Decipher(e,t,r){o.call(this);this._cache=new Splitter;this._last=void 0;this._cipher=new h.AES(t);this._prev=n.from(r);this._mode=e;this._autopadding=true}d(Decipher,o);Decipher.prototype._update=function(e){this._cache.add(e);var t;var r;var i=[];while(t=this._cache.get(this._autopadding)){r=this._mode.decrypt(this,t);i.push(r)}return n.concat(i)};Decipher.prototype._final=function(){var e=this._cache.flush();if(this._autopadding){return unpad(this._mode.decrypt(this,e))}else if(e){throw new Error("data not multiple of block length")}};Decipher.prototype.setAutoPadding=function(e){this._autopadding=!!e;return this};function Splitter(){this.cache=n.allocUnsafe(0)}Splitter.prototype.add=function(e){this.cache=n.concat([this.cache,e])};Splitter.prototype.get=function(e){var t;if(e){if(this.cache.length>16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);return t}}else{if(this.cache.length>=16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);return t}}return null};Splitter.prototype.flush=function(){if(this.cache.length)return this.cache};function unpad(e){var t=e[15];if(t<1||t>16){throw new Error("unable to decrypt data")}var r=-1;while(++r<t){if(e[r+(16-t)]!==t){throw new Error("unable to decrypt data")}}if(t===16)return;return e.slice(0,16-t)}function createDecipheriv(e,t,r){var o=a[e.toLowerCase()];if(!o)throw new TypeError("invalid suite type");if(typeof r==="string")r=n.from(r);if(o.mode!=="GCM"&&r.length!==o.iv)throw new TypeError("invalid iv length "+r.length);if(typeof t==="string")t=n.from(t);if(t.length!==o.key/8)throw new TypeError("invalid key length "+t.length);if(o.type==="stream"){return new s(o.module,t,r,true)}else if(o.type==="auth"){return new i(o.module,t,r,true)}return new Decipher(o.module,t,r)}function createDecipher(e,t){var r=a[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");var i=u(t,false,r.key,r.iv);return createDecipheriv(e,i.key,i.iv)}t.createDecipher=createDecipher;t.createDecipheriv=createDecipheriv},2:function(e,t,r){var i=r(6370);var n=r(6624);var a=r(5055).Buffer;var s=r(126);var o=r(1043);var h=r(1387);var u=r(8368);var d=r(3782);function Cipher(e,t,r){o.call(this);this._cache=new Splitter;this._cipher=new h.AES(t);this._prev=a.from(r);this._mode=e;this._autopadding=true}d(Cipher,o);Cipher.prototype._update=function(e){this._cache.add(e);var t;var r;var i=[];while(t=this._cache.get()){r=this._mode.encrypt(this,t);i.push(r)}return a.concat(i)};var c=a.alloc(16,16);Cipher.prototype._final=function(){var e=this._cache.flush();if(this._autopadding){e=this._mode.encrypt(this,e);this._cipher.scrub();return e}if(!e.equals(c)){this._cipher.scrub();throw new Error("data not multiple of block length")}};Cipher.prototype.setAutoPadding=function(e){this._autopadding=!!e;return this};function Splitter(){this.cache=a.allocUnsafe(0)}Splitter.prototype.add=function(e){this.cache=a.concat([this.cache,e])};Splitter.prototype.get=function(){if(this.cache.length>15){var e=this.cache.slice(0,16);this.cache=this.cache.slice(16);return e}return null};Splitter.prototype.flush=function(){var e=16-this.cache.length;var t=a.allocUnsafe(e);var r=-1;while(++r<e){t.writeUInt8(e,r)}return a.concat([this.cache,t])};function createCipheriv(e,t,r){var o=i[e.toLowerCase()];if(!o)throw new TypeError("invalid suite type");if(typeof t==="string")t=a.from(t);if(t.length!==o.key/8)throw new TypeError("invalid key length "+t.length);if(typeof r==="string")r=a.from(r);if(o.mode!=="GCM"&&r.length!==o.iv)throw new TypeError("invalid iv length "+r.length);if(o.type==="stream"){return new s(o.module,t,r)}else if(o.type==="auth"){return new n(o.module,t,r)}return new Cipher(o.module,t,r)}function createCipher(e,t){var r=i[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");var n=u(t,false,r.key,r.iv);return createCipheriv(e,n.key,n.iv)}t.createCipheriv=createCipheriv;t.createCipher=createCipher},7225:function(e,t,r){var i=r(5055).Buffer;var n=i.alloc(16,0);function toArray(e){return[e.readUInt32BE(0),e.readUInt32BE(4),e.readUInt32BE(8),e.readUInt32BE(12)]}function fromArray(e){var t=i.allocUnsafe(16);t.writeUInt32BE(e[0]>>>0,0);t.writeUInt32BE(e[1]>>>0,4);t.writeUInt32BE(e[2]>>>0,8);t.writeUInt32BE(e[3]>>>0,12);return t}function GHASH(e){this.h=e;this.state=i.alloc(16,0);this.cache=i.allocUnsafe(0)}GHASH.prototype.ghash=function(e){var t=-1;while(++t<e.length){this.state[t]^=e[t]}this._multiply()};GHASH.prototype._multiply=function(){var e=toArray(this.h);var t=[0,0,0,0];var r,i,n;var a=-1;while(++a<128){i=(this.state[~~(a/8)]&1<<7-a%8)!==0;if(i){t[0]^=e[0];t[1]^=e[1];t[2]^=e[2];t[3]^=e[3]}n=(e[3]&1)!==0;for(r=3;r>0;r--){e[r]=e[r]>>>1|(e[r-1]&1)<<31}e[0]=e[0]>>>1;if(n){e[0]=e[0]^225<<24}}this.state=fromArray(t)};GHASH.prototype.update=function(e){this.cache=i.concat([this.cache,e]);var t;while(this.cache.length>=16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);this.ghash(t)}};GHASH.prototype.final=function(e,t){if(this.cache.length){this.ghash(i.concat([this.cache,n],16))}this.ghash(fromArray([0,e,0,t]));return this.state};e.exports=GHASH},598:function(e){function incr32(e){var t=e.length;var r;while(t--){r=e.readUInt8(t);if(r===255){e.writeUInt8(0,t)}else{r++;e.writeUInt8(r,t);break}}}e.exports=incr32},9825:function(e,t,r){var i=r(4734);t.encrypt=function(e,t){var r=i(t,e._prev);e._prev=e._cipher.encryptBlock(r);return e._prev};t.decrypt=function(e,t){var r=e._prev;e._prev=t;var n=e._cipher.decryptBlock(t);return i(n,r)}},321:function(e,t,r){var i=r(5055).Buffer;var n=r(4734);function encryptStart(e,t,r){var a=t.length;var s=n(t,e._cache);e._cache=e._cache.slice(a);e._prev=i.concat([e._prev,r?t:s]);return s}t.encrypt=function(e,t,r){var n=i.allocUnsafe(0);var a;while(t.length){if(e._cache.length===0){e._cache=e._cipher.encryptBlock(e._prev);e._prev=i.allocUnsafe(0)}if(e._cache.length<=t.length){a=e._cache.length;n=i.concat([n,encryptStart(e,t.slice(0,a),r)]);t=t.slice(a)}else{n=i.concat([n,encryptStart(e,t,r)]);break}}return n}},3147:function(e,t,r){var i=r(5055).Buffer;function encryptByte(e,t,r){var i;var n=-1;var a=8;var s=0;var o,h;while(++n<a){i=e._cipher.encryptBlock(e._prev);o=t&1<<7-n?128:0;h=i[0]^o;s+=(h&128)>>n%8;e._prev=shiftIn(e._prev,r?o:h)}return s}function shiftIn(e,t){var r=e.length;var n=-1;var a=i.allocUnsafe(e.length);e=i.concat([e,i.from([t])]);while(++n<r){a[n]=e[n]<<1|e[n+1]>>7}return a}t.encrypt=function(e,t,r){var n=t.length;var a=i.allocUnsafe(n);var s=-1;while(++s<n){a[s]=encryptByte(e,t[s],r)}return a}},2430:function(e,t,r){var i=r(5055).Buffer;function encryptByte(e,t,r){var n=e._cipher.encryptBlock(e._prev);var a=n[0]^t;e._prev=i.concat([e._prev.slice(1),i.from([r?t:a])]);return a}t.encrypt=function(e,t,r){var n=t.length;var a=i.allocUnsafe(n);var s=-1;while(++s<n){a[s]=encryptByte(e,t[s],r)}return a}},3361:function(e,t,r){var i=r(4734);var n=r(5055).Buffer;var a=r(598);function getBlock(e){var t=e._cipher.encryptBlockRaw(e._prev);a(e._prev);return t}var s=16;t.encrypt=function(e,t){var r=Math.ceil(t.length/s);var a=e._cache.length;e._cache=n.concat([e._cache,n.allocUnsafe(r*s)]);for(var o=0;o<r;o++){var h=getBlock(e);var u=a+o*s;e._cache.writeUInt32BE(h[0],u+0);e._cache.writeUInt32BE(h[1],u+4);e._cache.writeUInt32BE(h[2],u+8);e._cache.writeUInt32BE(h[3],u+12)}var d=e._cache.slice(0,t.length);e._cache=e._cache.slice(t.length);return i(t,d)}},1590:function(e,t){t.encrypt=function(e,t){return e._cipher.encryptBlock(t)};t.decrypt=function(e,t){return e._cipher.decryptBlock(t)}},6370:function(e,t,r){var i={ECB:r(1590),CBC:r(9825),CFB:r(321),CFB8:r(2430),CFB1:r(3147),OFB:r(3412),CTR:r(3361),GCM:r(3361)};var n=r(5866);for(var a in n){n[a].module=i[n[a].mode]}e.exports=n},3412:function(e,t,r){var i=r(4734);function getBlock(e){e._prev=e._cipher.encryptBlock(e._prev);return e._prev}t.encrypt=function(e,t){while(e._cache.length<t.length){e._cache=Buffer.concat([e._cache,getBlock(e)])}var r=e._cache.slice(0,t.length);e._cache=e._cache.slice(t.length);return i(t,r)}},126:function(e,t,r){var i=r(1387);var n=r(5055).Buffer;var a=r(1043);var s=r(3782);function StreamCipher(e,t,r,s){a.call(this);this._cipher=new i.AES(t);this._prev=n.from(r);this._cache=n.allocUnsafe(0);this._secCache=n.allocUnsafe(0);this._decrypt=s;this._mode=e}s(StreamCipher,a);StreamCipher.prototype._update=function(e){return this._mode.encrypt(this,e,this._decrypt)};StreamCipher.prototype._final=function(){this._cipher.scrub()};e.exports=StreamCipher},8996:function(e,t,r){var i=r(5238);var n=r(6594);var a=r(6370);var s=r(6280);var o=r(8368);function createCipher(e,t){e=e.toLowerCase();var r,i;if(a[e]){r=a[e].key;i=a[e].iv}else if(s[e]){r=s[e].key*8;i=s[e].iv}else{throw new TypeError("invalid suite type")}var n=o(t,false,r,i);return createCipheriv(e,n.key,n.iv)}function createDecipher(e,t){e=e.toLowerCase();var r,i;if(a[e]){r=a[e].key;i=a[e].iv}else if(s[e]){r=s[e].key*8;i=s[e].iv}else{throw new TypeError("invalid suite type")}var n=o(t,false,r,i);return createDecipheriv(e,n.key,n.iv)}function createCipheriv(e,t,r){e=e.toLowerCase();if(a[e])return n.createCipheriv(e,t,r);if(s[e])return new i({key:t,iv:r,mode:e});throw new TypeError("invalid suite type")}function createDecipheriv(e,t,r){e=e.toLowerCase();if(a[e])return n.createDecipheriv(e,t,r);if(s[e])return new i({key:t,iv:r,mode:e,decrypt:true});throw new TypeError("invalid suite type")}function getCiphers(){return Object.keys(s).concat(n.getCiphers())}t.createCipher=t.Cipher=createCipher;t.createCipheriv=t.Cipheriv=createCipheriv;t.createDecipher=t.Decipher=createDecipher;t.createDecipheriv=t.Decipheriv=createDecipheriv;t.listCiphers=t.getCiphers=getCiphers},5238:function(e,t,r){var i=r(1043);var n=r(9536);var a=r(3782);var s=r(5055).Buffer;var o={"des-ede3-cbc":n.CBC.instantiate(n.EDE),"des-ede3":n.EDE,"des-ede-cbc":n.CBC.instantiate(n.EDE),"des-ede":n.EDE,"des-cbc":n.CBC.instantiate(n.DES),"des-ecb":n.DES};o.des=o["des-cbc"];o.des3=o["des-ede3-cbc"];e.exports=DES;a(DES,i);function DES(e){i.call(this);var t=e.mode.toLowerCase();var r=o[t];var n;if(e.decrypt){n="decrypt"}else{n="encrypt"}var a=e.key;if(!s.isBuffer(a)){a=s.from(a)}if(t==="des-ede"||t==="des-ede-cbc"){a=s.concat([a,a.slice(0,8)])}var h=e.iv;if(!s.isBuffer(h)){h=s.from(h)}this._des=r.create({key:a,iv:h,type:n})}DES.prototype._update=function(e){return s.from(this._des.update(e))};DES.prototype._final=function(){return s.from(this._des.final())}},6280:function(e,t){t["des-ecb"]={key:8,iv:0};t["des-cbc"]=t.des={key:8,iv:8};t["des-ede3-cbc"]=t.des3={key:24,iv:8};t["des-ede3"]={key:24,iv:0};t["des-ede-cbc"]={key:16,iv:8};t["des-ede"]={key:16,iv:0}},7166:function(e,t,r){var i=r(711);var n=r(7223);e.exports=crt;function blind(e){var t=getr(e);var r=t.toRed(i.mont(e.modulus)).redPow(new i(e.publicExponent)).fromRed();return{blinder:r,unblinder:t.invm(e.modulus)}}function crt(e,t){var r=blind(t);var n=t.modulus.byteLength();var a=i.mont(t.modulus);var s=new i(e).mul(r.blinder).umod(t.modulus);var o=s.toRed(i.mont(t.prime1));var h=s.toRed(i.mont(t.prime2));var u=t.coefficient;var d=t.prime1;var c=t.prime2;var l=o.redPow(t.exponent1);var p=h.redPow(t.exponent2);l=l.fromRed();p=p.fromRed();var v=l.isub(p).imul(u).umod(d);v.imul(c);p.iadd(v);return new Buffer(p.imul(r.unblinder).umod(t.modulus).toArray(false,n))}crt.getr=getr;function getr(e){var t=e.modulus.byteLength();var r=new i(n(t));while(r.cmp(e.modulus)>=0||!r.umod(e.prime1)||!r.umod(e.prime2)){r=new i(n(t))}return r}},9276:function(e,t,r){e.exports=r(2908)},4078:function(e,t,r){var i=r(5055).Buffer;var n=r(9739);var a=r(3726);var s=r(3782);var o=r(9807);var h=r(4013);var u=r(2908);Object.keys(u).forEach((function(e){u[e].id=i.from(u[e].id,"hex");u[e.toLowerCase()]=u[e]}));function Sign(e){a.Writable.call(this);var t=u[e];if(!t)throw new Error("Unknown message digest");this._hashType=t.hash;this._hash=n(t.hash);this._tag=t.id;this._signType=t.sign}s(Sign,a.Writable);Sign.prototype._write=function _write(e,t,r){this._hash.update(e);r()};Sign.prototype.update=function update(e,t){if(typeof e==="string")e=i.from(e,t);this._hash.update(e);return this};Sign.prototype.sign=function signMethod(e,t){this.end();var r=this._hash.digest();var i=o(r,e,this._hashType,this._signType,this._tag);return t?i.toString(t):i};function Verify(e){a.Writable.call(this);var t=u[e];if(!t)throw new Error("Unknown message digest");this._hash=n(t.hash);this._tag=t.id;this._signType=t.sign}s(Verify,a.Writable);Verify.prototype._write=function _write(e,t,r){this._hash.update(e);r()};Verify.prototype.update=function update(e,t){if(typeof e==="string")e=i.from(e,t);this._hash.update(e);return this};Verify.prototype.verify=function verifyMethod(e,t,r){if(typeof t==="string")t=i.from(t,r);this.end();var n=this._hash.digest();return h(t,n,e,this._signType,this._tag)};function createSign(e){return new Sign(e)}function createVerify(e){return new Verify(e)}e.exports={Sign:createSign,Verify:createVerify,createSign:createSign,createVerify:createVerify}},9807:function(e,t,r){var i=r(5055).Buffer;var n=r(4873);var a=r(7166);var s=r(949).ec;var o=r(1670);var h=r(9902);var u=r(9267);function sign(e,t,r,n,s){var o=h(t);if(o.curve){if(n!=="ecdsa"&&n!=="ecdsa/rsa")throw new Error("wrong private key type");return ecSign(e,o)}else if(o.type==="dsa"){if(n!=="dsa")throw new Error("wrong private key type");return dsaSign(e,o,r)}else{if(n!=="rsa"&&n!=="ecdsa/rsa")throw new Error("wrong private key type")}e=i.concat([s,e]);var u=o.modulus.byteLength();var d=[0,1];while(e.length+d.length+1<u)d.push(255);d.push(0);var c=-1;while(++c<e.length)d.push(e[c]);var l=a(d,o);return l}function ecSign(e,t){var r=u[t.curve.join(".")];if(!r)throw new Error("unknown curve "+t.curve.join("."));var n=new s(r);var a=n.keyFromPrivate(t.privateKey);var o=a.sign(e);return i.from(o.toDER())}function dsaSign(e,t,r){var i=t.params.priv_key;var n=t.params.p;var a=t.params.q;var s=t.params.g;var h=new o(0);var u;var d=bits2int(e,a).mod(a);var c=false;var l=getKey(i,a,e,r);while(c===false){u=makeKey(a,l,r);h=makeR(s,u,n,a);c=u.invm(a).imul(d.add(i.mul(h))).mod(a);if(c.cmpn(0)===0){c=false;h=new o(0)}}return toDER(h,c)}function toDER(e,t){e=e.toArray();t=t.toArray();if(e[0]&128)e=[0].concat(e);if(t[0]&128)t=[0].concat(t);var r=e.length+t.length+4;var n=[48,r,2,e.length];n=n.concat(e,[2,t.length],t);return i.from(n)}function getKey(e,t,r,a){e=i.from(e.toArray());if(e.length<t.byteLength()){var s=i.alloc(t.byteLength()-e.length);e=i.concat([s,e])}var o=r.length;var h=bits2octets(r,t);var u=i.alloc(o);u.fill(1);var d=i.alloc(o);d=n(a,d).update(u).update(i.from([0])).update(e).update(h).digest();u=n(a,d).update(u).digest();d=n(a,d).update(u).update(i.from([1])).update(e).update(h).digest();u=n(a,d).update(u).digest();return{k:d,v:u}}function bits2int(e,t){var r=new o(e);var i=(e.length<<3)-t.bitLength();if(i>0)r.ishrn(i);return r}function bits2octets(e,t){e=bits2int(e,t);e=e.mod(t);var r=i.from(e.toArray());if(r.length<t.byteLength()){var n=i.alloc(t.byteLength()-r.length);r=i.concat([n,r])}return r}function makeKey(e,t,r){var a;var s;do{a=i.alloc(0);while(a.length*8<e.bitLength()){t.v=n(r,t.k).update(t.v).digest();a=i.concat([a,t.v])}s=bits2int(a,e);t.k=n(r,t.k).update(t.v).update(i.from([0])).digest();t.v=n(r,t.k).update(t.v).digest()}while(s.cmp(e)!==-1);return s}function makeR(e,t,r,i){return e.toRed(o.mont(r)).redPow(t).fromRed().mod(i)}e.exports=sign;e.exports.getKey=getKey;e.exports.makeKey=makeKey},4013:function(e,t,r){var i=r(5055).Buffer;var n=r(1670);var a=r(949).ec;var s=r(9902);var o=r(9267);function verify(e,t,r,a,o){var h=s(r);if(h.type==="ec"){if(a!=="ecdsa"&&a!=="ecdsa/rsa")throw new Error("wrong public key type");return ecVerify(e,t,h)}else if(h.type==="dsa"){if(a!=="dsa")throw new Error("wrong public key type");return dsaVerify(e,t,h)}else{if(a!=="rsa"&&a!=="ecdsa/rsa")throw new Error("wrong public key type")}t=i.concat([o,t]);var u=h.modulus.byteLength();var d=[1];var c=0;while(t.length+d.length+2<u){d.push(255);c++}d.push(0);var l=-1;while(++l<t.length){d.push(t[l])}d=i.from(d);var p=n.mont(h.modulus);e=new n(e).toRed(p);e=e.redPow(new n(h.publicExponent));e=i.from(e.fromRed().toArray());var v=c<8?1:0;u=Math.min(e.length,d.length);if(e.length!==d.length)v=1;l=-1;while(++l<u)v|=e[l]^d[l];return v===0}function ecVerify(e,t,r){var i=o[r.data.algorithm.curve.join(".")];if(!i)throw new Error("unknown curve "+r.data.algorithm.curve.join("."));var n=new a(i);var s=r.data.subjectPrivateKey.data;return n.verify(t,e,s)}function dsaVerify(e,t,r){var i=r.data.p;var a=r.data.q;var o=r.data.g;var h=r.data.pub_key;var u=s.signature.decode(e,"der");var d=u.s;var c=u.r;checkValue(d,a);checkValue(c,a);var l=n.mont(i);var p=d.invm(a);var v=o.toRed(l).redPow(new n(t).mul(p).mod(a)).fromRed().mul(h.toRed(l).redPow(c.mul(p).mod(a)).fromRed()).mod(i).mod(a);return v.cmp(c)===0}function checkValue(e,t){if(e.cmpn(0)<=0)throw new Error("invalid sig");if(e.cmp(t)>=t)throw new Error("invalid sig")}e.exports=verify},4734:function(e){e.exports=function xor(e,t){var r=Math.min(e.length,t.length);var i=new Buffer(r);for(var n=0;n<r;++n){i[n]=e[n]^t[n]}return i}},1043:function(e,t,r){var i=r(5055).Buffer;var n=r(2781).Transform;var a=r(1576).StringDecoder;var s=r(3782);function CipherBase(e){n.call(this);this.hashMode=typeof e==="string";if(this.hashMode){this[e]=this._finalOrDigest}else{this.final=this._finalOrDigest}if(this._final){this.__final=this._final;this._final=null}this._decoder=null;this._encoding=null}s(CipherBase,n);CipherBase.prototype.update=function(e,t,r){if(typeof e==="string"){e=i.from(e,t)}var n=this._update(e);if(this.hashMode)return this;if(r){n=this._toString(n,r)}return n};CipherBase.prototype.setAutoPadding=function(){};CipherBase.prototype.getAuthTag=function(){throw new Error("trying to get auth tag in unsupported state")};CipherBase.prototype.setAuthTag=function(){throw new Error("trying to set auth tag in unsupported state")};CipherBase.prototype.setAAD=function(){throw new Error("trying to set aad in unsupported state")};CipherBase.prototype._transform=function(e,t,r){var i;try{if(this.hashMode){this._update(e)}else{this.push(this._update(e))}}catch(e){i=e}finally{r(i)}};CipherBase.prototype._flush=function(e){var t;try{this.push(this.__final())}catch(e){t=e}e(t)};CipherBase.prototype._finalOrDigest=function(e){var t=this.__final()||i.alloc(0);if(e){t=this._toString(t,e,true)}return t};CipherBase.prototype._toString=function(e,t,r){if(!this._decoder){this._decoder=new a(t);this._encoding=t}if(this._encoding!==t)throw new Error("can't switch encodings");var i=this._decoder.write(e);if(r){i+=this._decoder.end()}return i};e.exports=CipherBase},9942:function(e,t,r){var i=r(949);var n=r(711);e.exports=function createECDH(e){return new ECDH(e)};var a={secp256k1:{name:"secp256k1",byteLength:32},secp224r1:{name:"p224",byteLength:28},prime256v1:{name:"p256",byteLength:32},prime192v1:{name:"p192",byteLength:24},ed25519:{name:"ed25519",byteLength:32},secp384r1:{name:"p384",byteLength:48},secp521r1:{name:"p521",byteLength:66}};a.p224=a.secp224r1;a.p256=a.secp256r1=a.prime256v1;a.p192=a.secp192r1=a.prime192v1;a.p384=a.secp384r1;a.p521=a.secp521r1;function ECDH(e){this.curveType=a[e];if(!this.curveType){this.curveType={name:e}}this.curve=new i.ec(this.curveType.name);this.keys=void 0}ECDH.prototype.generateKeys=function(e,t){this.keys=this.curve.genKeyPair();return this.getPublicKey(e,t)};ECDH.prototype.computeSecret=function(e,t,r){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}var i=this.curve.keyFromPublic(e).getPublic();var n=i.mul(this.keys.getPrivate()).getX();return formatReturnValue(n,r,this.curveType.byteLength)};ECDH.prototype.getPublicKey=function(e,t){var r=this.keys.getPublic(t==="compressed",true);if(t==="hybrid"){if(r[r.length-1]%2){r[0]=7}else{r[0]=6}}return formatReturnValue(r,e)};ECDH.prototype.getPrivateKey=function(e){return formatReturnValue(this.keys.getPrivate(),e)};ECDH.prototype.setPublicKey=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this.keys._importPublic(e);return this};ECDH.prototype.setPrivateKey=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}var r=new n(e);r=r.toString(16);this.keys=this.curve.genKeyPair();this.keys._importPrivate(r);return this};function formatReturnValue(e,t,r){if(!Array.isArray(e)){e=e.toArray()}var i=new Buffer(e);if(r&&i.length<r){var n=new Buffer(r-i.length);n.fill(0);i=Buffer.concat([n,i])}if(!t){return i}else{return i.toString(t)}}},9739:function(e,t,r){"use strict";var i=r(3782);var n=r(3533);var a=r(3225);var s=r(4371);var o=r(1043);function Hash(e){o.call(this,"digest");this._hash=e}i(Hash,o);Hash.prototype._update=function(e){this._hash.update(e)};Hash.prototype._final=function(){return this._hash.digest()};e.exports=function createHash(e){e=e.toLowerCase();if(e==="md5")return new n;if(e==="rmd160"||e==="ripemd160")return new a;return new Hash(s(e))}},450:function(e,t,r){var i=r(3533);e.exports=function(e){return(new i).update(e).digest()}},4873:function(e,t,r){"use strict";var i=r(3782);var n=r(8119);var a=r(1043);var s=r(5055).Buffer;var o=r(450);var h=r(3225);var u=r(4371);var d=s.alloc(128);function Hmac(e,t){a.call(this,"digest");if(typeof t==="string"){t=s.from(t)}var r=e==="sha512"||e==="sha384"?128:64;this._alg=e;this._key=t;if(t.length>r){var i=e==="rmd160"?new h:u(e);t=i.update(t).digest()}else if(t.length<r){t=s.concat([t,d],r)}var n=this._ipad=s.allocUnsafe(r);var o=this._opad=s.allocUnsafe(r);for(var c=0;c<r;c++){n[c]=t[c]^54;o[c]=t[c]^92}this._hash=e==="rmd160"?new h:u(e);this._hash.update(n)}i(Hmac,a);Hmac.prototype._update=function(e){this._hash.update(e)};Hmac.prototype._final=function(){var e=this._hash.digest();var t=this._alg==="rmd160"?new h:u(this._alg);return t.update(this._opad).update(e).digest()};e.exports=function createHmac(e,t){e=e.toLowerCase();if(e==="rmd160"||e==="ripemd160"){return new Hmac("rmd160",t)}if(e==="md5"){return new n(o,t)}return new Hmac(e,t)}},8119:function(e,t,r){"use strict";var i=r(3782);var n=r(5055).Buffer;var a=r(1043);var s=n.alloc(128);var o=64;function Hmac(e,t){a.call(this,"digest");if(typeof t==="string"){t=n.from(t)}this._alg=e;this._key=t;if(t.length>o){t=e(t)}else if(t.length<o){t=n.concat([t,s],o)}var r=this._ipad=n.allocUnsafe(o);var i=this._opad=n.allocUnsafe(o);for(var h=0;h<o;h++){r[h]=t[h]^54;i[h]=t[h]^92}this._hash=[r]}i(Hmac,a);Hmac.prototype._update=function(e){this._hash.push(e)};Hmac.prototype._final=function(){var e=this._alg(n.concat(this._hash));return this._alg(n.concat([this._opad,e]))};e.exports=Hmac},9536:function(e,t,r){"use strict";t.utils=r(5334);t.Cipher=r(9876);t.DES=r(1016);t.CBC=r(8641);t.EDE=r(6159)},8641:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a={};function CBCState(e){i.equal(e.length,8,"Invalid IV length");this.iv=new Array(8);for(var t=0;t<this.iv.length;t++)this.iv[t]=e[t]}function instantiate(e){function CBC(t){e.call(this,t);this._cbcInit()}n(CBC,e);var t=Object.keys(a);for(var r=0;r<t.length;r++){var i=t[r];CBC.prototype[i]=a[i]}CBC.create=function create(e){return new CBC(e)};return CBC}t.instantiate=instantiate;a._cbcInit=function _cbcInit(){var e=new CBCState(this.options.iv);this._cbcState=e};a._update=function _update(e,t,r,i){var n=this._cbcState;var a=this.constructor.super_.prototype;var s=n.iv;if(this.type==="encrypt"){for(var o=0;o<this.blockSize;o++)s[o]^=e[t+o];a._update.call(this,s,0,r,i);for(var o=0;o<this.blockSize;o++)s[o]=r[i+o]}else{a._update.call(this,e,t,r,i);for(var o=0;o<this.blockSize;o++)r[i+o]^=s[o];for(var o=0;o<this.blockSize;o++)s[o]=e[t+o]}}},9876:function(e,t,r){"use strict";var i=r(3523);function Cipher(e){this.options=e;this.type=this.options.type;this.blockSize=8;this._init();this.buffer=new Array(this.blockSize);this.bufferOff=0}e.exports=Cipher;Cipher.prototype._init=function _init(){};Cipher.prototype.update=function update(e){if(e.length===0)return[];if(this.type==="decrypt")return this._updateDecrypt(e);else return this._updateEncrypt(e)};Cipher.prototype._buffer=function _buffer(e,t){var r=Math.min(this.buffer.length-this.bufferOff,e.length-t);for(var i=0;i<r;i++)this.buffer[this.bufferOff+i]=e[t+i];this.bufferOff+=r;return r};Cipher.prototype._flushBuffer=function _flushBuffer(e,t){this._update(this.buffer,0,e,t);this.bufferOff=0;return this.blockSize};Cipher.prototype._updateEncrypt=function _updateEncrypt(e){var t=0;var r=0;var i=(this.bufferOff+e.length)/this.blockSize|0;var n=new Array(i*this.blockSize);if(this.bufferOff!==0){t+=this._buffer(e,t);if(this.bufferOff===this.buffer.length)r+=this._flushBuffer(n,r)}var a=e.length-(e.length-t)%this.blockSize;for(;t<a;t+=this.blockSize){this._update(e,t,n,r);r+=this.blockSize}for(;t<e.length;t++,this.bufferOff++)this.buffer[this.bufferOff]=e[t];return n};Cipher.prototype._updateDecrypt=function _updateDecrypt(e){var t=0;var r=0;var i=Math.ceil((this.bufferOff+e.length)/this.blockSize)-1;var n=new Array(i*this.blockSize);for(;i>0;i--){t+=this._buffer(e,t);r+=this._flushBuffer(n,r)}t+=this._buffer(e,t);return n};Cipher.prototype.final=function final(e){var t;if(e)t=this.update(e);var r;if(this.type==="encrypt")r=this._finalEncrypt();else r=this._finalDecrypt();if(t)return t.concat(r);else return r};Cipher.prototype._pad=function _pad(e,t){if(t===0)return false;while(t<e.length)e[t++]=0;return true};Cipher.prototype._finalEncrypt=function _finalEncrypt(){if(!this._pad(this.buffer,this.bufferOff))return[];var e=new Array(this.blockSize);this._update(this.buffer,0,e,0);return e};Cipher.prototype._unpad=function _unpad(e){return e};Cipher.prototype._finalDecrypt=function _finalDecrypt(){i.equal(this.bufferOff,this.blockSize,"Not enough data to decrypt");var e=new Array(this.blockSize);this._flushBuffer(e,0);return this._unpad(e)}},1016:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a=r(5334);var s=r(9876);function DESState(){this.tmp=new Array(2);this.keys=null}function DES(e){s.call(this,e);var t=new DESState;this._desState=t;this.deriveKeys(t,e.key)}n(DES,s);e.exports=DES;DES.create=function create(e){return new DES(e)};var o=[1,1,2,2,2,2,2,2,1,2,2,2,2,2,2,1];DES.prototype.deriveKeys=function deriveKeys(e,t){e.keys=new Array(16*2);i.equal(t.length,this.blockSize,"Invalid key length");var r=a.readUInt32BE(t,0);var n=a.readUInt32BE(t,4);a.pc1(r,n,e.tmp,0);r=e.tmp[0];n=e.tmp[1];for(var s=0;s<e.keys.length;s+=2){var h=o[s>>>1];r=a.r28shl(r,h);n=a.r28shl(n,h);a.pc2(r,n,e.keys,s)}};DES.prototype._update=function _update(e,t,r,i){var n=this._desState;var s=a.readUInt32BE(e,t);var o=a.readUInt32BE(e,t+4);a.ip(s,o,n.tmp,0);s=n.tmp[0];o=n.tmp[1];if(this.type==="encrypt")this._encrypt(n,s,o,n.tmp,0);else this._decrypt(n,s,o,n.tmp,0);s=n.tmp[0];o=n.tmp[1];a.writeUInt32BE(r,s,i);a.writeUInt32BE(r,o,i+4)};DES.prototype._pad=function _pad(e,t){var r=e.length-t;for(var i=t;i<e.length;i++)e[i]=r;return true};DES.prototype._unpad=function _unpad(e){var t=e[e.length-1];for(var r=e.length-t;r<e.length;r++)i.equal(e[r],t);return e.slice(0,e.length-t)};DES.prototype._encrypt=function _encrypt(e,t,r,i,n){var s=t;var o=r;for(var h=0;h<e.keys.length;h+=2){var u=e.keys[h];var d=e.keys[h+1];a.expand(o,e.tmp,0);u^=e.tmp[0];d^=e.tmp[1];var c=a.substitute(u,d);var l=a.permute(c);var p=o;o=(s^l)>>>0;s=p}a.rip(o,s,i,n)};DES.prototype._decrypt=function _decrypt(e,t,r,i,n){var s=r;var o=t;for(var h=e.keys.length-2;h>=0;h-=2){var u=e.keys[h];var d=e.keys[h+1];a.expand(s,e.tmp,0);u^=e.tmp[0];d^=e.tmp[1];var c=a.substitute(u,d);var l=a.permute(c);var p=s;s=(o^l)>>>0;o=p}a.rip(s,o,i,n)}},6159:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a=r(9876);var s=r(1016);function EDEState(e,t){i.equal(t.length,24,"Invalid key length");var r=t.slice(0,8);var n=t.slice(8,16);var a=t.slice(16,24);if(e==="encrypt"){this.ciphers=[s.create({type:"encrypt",key:r}),s.create({type:"decrypt",key:n}),s.create({type:"encrypt",key:a})]}else{this.ciphers=[s.create({type:"decrypt",key:a}),s.create({type:"encrypt",key:n}),s.create({type:"decrypt",key:r})]}}function EDE(e){a.call(this,e);var t=new EDEState(this.type,this.options.key);this._edeState=t}n(EDE,a);e.exports=EDE;EDE.create=function create(e){return new EDE(e)};EDE.prototype._update=function _update(e,t,r,i){var n=this._edeState;n.ciphers[0]._update(e,t,r,i);n.ciphers[1]._update(r,i,r,i);n.ciphers[2]._update(r,i,r,i)};EDE.prototype._pad=s.prototype._pad;EDE.prototype._unpad=s.prototype._unpad},5334:function(e,t){"use strict";t.readUInt32BE=function readUInt32BE(e,t){var r=e[0+t]<<24|e[1+t]<<16|e[2+t]<<8|e[3+t];return r>>>0};t.writeUInt32BE=function writeUInt32BE(e,t,r){e[0+r]=t>>>24;e[1+r]=t>>>16&255;e[2+r]=t>>>8&255;e[3+r]=t&255};t.ip=function ip(e,t,r,i){var n=0;var a=0;for(var s=6;s>=0;s-=2){for(var o=0;o<=24;o+=8){n<<=1;n|=t>>>o+s&1}for(var o=0;o<=24;o+=8){n<<=1;n|=e>>>o+s&1}}for(var s=6;s>=0;s-=2){for(var o=1;o<=25;o+=8){a<<=1;a|=t>>>o+s&1}for(var o=1;o<=25;o+=8){a<<=1;a|=e>>>o+s&1}}r[i+0]=n>>>0;r[i+1]=a>>>0};t.rip=function rip(e,t,r,i){var n=0;var a=0;for(var s=0;s<4;s++){for(var o=24;o>=0;o-=8){n<<=1;n|=t>>>o+s&1;n<<=1;n|=e>>>o+s&1}}for(var s=4;s<8;s++){for(var o=24;o>=0;o-=8){a<<=1;a|=t>>>o+s&1;a<<=1;a|=e>>>o+s&1}}r[i+0]=n>>>0;r[i+1]=a>>>0};t.pc1=function pc1(e,t,r,i){var n=0;var a=0;for(var s=7;s>=5;s--){for(var o=0;o<=24;o+=8){n<<=1;n|=t>>o+s&1}for(var o=0;o<=24;o+=8){n<<=1;n|=e>>o+s&1}}for(var o=0;o<=24;o+=8){n<<=1;n|=t>>o+s&1}for(var s=1;s<=3;s++){for(var o=0;o<=24;o+=8){a<<=1;a|=t>>o+s&1}for(var o=0;o<=24;o+=8){a<<=1;a|=e>>o+s&1}}for(var o=0;o<=24;o+=8){a<<=1;a|=e>>o+s&1}r[i+0]=n>>>0;r[i+1]=a>>>0};t.r28shl=function r28shl(e,t){return e<<t&268435455|e>>>28-t};var r=[14,11,17,4,27,23,25,0,13,22,7,18,5,9,16,24,2,20,12,21,1,8,15,26,15,4,25,19,9,1,26,16,5,11,23,8,12,7,17,0,22,3,10,14,6,20,27,24];t.pc2=function pc2(e,t,i,n){var a=0;var s=0;var o=r.length>>>1;for(var h=0;h<o;h++){a<<=1;a|=e>>>r[h]&1}for(var h=o;h<r.length;h++){s<<=1;s|=t>>>r[h]&1}i[n+0]=a>>>0;i[n+1]=s>>>0};t.expand=function expand(e,t,r){var i=0;var n=0;i=(e&1)<<5|e>>>27;for(var a=23;a>=15;a-=4){i<<=6;i|=e>>>a&63}for(var a=11;a>=3;a-=4){n|=e>>>a&63;n<<=6}n|=(e&31)<<1|e>>>31;t[r+0]=i>>>0;t[r+1]=n>>>0};var i=[14,0,4,15,13,7,1,4,2,14,15,2,11,13,8,1,3,10,10,6,6,12,12,11,5,9,9,5,0,3,7,8,4,15,1,12,14,8,8,2,13,4,6,9,2,1,11,7,15,5,12,11,9,3,7,14,3,10,10,0,5,6,0,13,15,3,1,13,8,4,14,7,6,15,11,2,3,8,4,14,9,12,7,0,2,1,13,10,12,6,0,9,5,11,10,5,0,13,14,8,7,10,11,1,10,3,4,15,13,4,1,2,5,11,8,6,12,7,6,12,9,0,3,5,2,14,15,9,10,13,0,7,9,0,14,9,6,3,3,4,15,6,5,10,1,2,13,8,12,5,7,14,11,12,4,11,2,15,8,1,13,1,6,10,4,13,9,0,8,6,15,9,3,8,0,7,11,4,1,15,2,14,12,3,5,11,10,5,14,2,7,12,7,13,13,8,14,11,3,5,0,6,6,15,9,0,10,3,1,4,2,7,8,2,5,12,11,1,12,10,4,14,15,9,10,3,6,15,9,0,0,6,12,10,11,1,7,13,13,8,15,9,1,4,3,5,14,11,5,12,2,7,8,2,4,14,2,14,12,11,4,2,1,12,7,4,10,7,11,13,6,1,8,5,5,0,3,15,15,10,13,3,0,9,14,8,9,6,4,11,2,8,1,12,11,7,10,1,13,14,7,2,8,13,15,6,9,15,12,0,5,9,6,10,3,4,0,5,14,3,12,10,1,15,10,4,15,2,9,7,2,12,6,9,8,5,0,6,13,1,3,13,4,14,14,0,7,11,5,3,11,8,9,4,14,3,15,2,5,12,2,9,8,5,12,15,3,10,7,11,0,14,4,1,10,7,1,6,13,0,11,8,6,13,4,13,11,0,2,11,14,7,15,4,0,9,8,1,13,10,3,14,12,3,9,5,7,12,5,2,10,15,6,8,1,6,1,6,4,11,11,13,13,8,12,1,3,4,7,10,14,7,10,9,15,5,6,0,8,15,0,14,5,2,9,3,2,12,13,1,2,15,8,13,4,8,6,10,15,3,11,7,1,4,10,12,9,5,3,6,14,11,5,0,0,14,12,9,7,2,7,2,11,1,4,14,1,7,9,4,12,10,14,8,2,13,0,15,6,12,10,9,13,0,15,3,3,5,5,6,8,11];t.substitute=function substitute(e,t){var r=0;for(var n=0;n<4;n++){var a=e>>>18-n*6&63;var s=i[n*64+a];r<<=4;r|=s}for(var n=0;n<4;n++){var a=t>>>18-n*6&63;var s=i[4*64+n*64+a];r<<=4;r|=s}return r>>>0};var n=[16,25,12,11,3,20,4,15,31,17,9,6,27,14,1,22,30,24,8,18,0,5,29,23,13,19,2,26,10,21,28,7];t.permute=function permute(e){var t=0;for(var r=0;r<n.length;r++){t<<=1;t|=e>>>n[r]&1}return t>>>0};t.padSplit=function padSplit(e,t,r){var i=e.toString(2);while(i.length<t)i="0"+i;var n=[];for(var a=0;a<t;a+=r)n.push(i.slice(a,a+r));return n.join(" ")}},6587:function(e,t,r){var i=r(296);var n=r(7992);var a=r(373);function getDiffieHellman(e){var t=new Buffer(n[e].prime,"hex");var r=new Buffer(n[e].gen,"hex");return new a(t,r)}var s={binary:true,hex:true,base64:true};function createDiffieHellman(e,t,r,n){if(Buffer.isBuffer(t)||s[t]===undefined){return createDiffieHellman(e,"binary",t,r)}t=t||"binary";n=n||"binary";r=r||new Buffer([2]);if(!Buffer.isBuffer(r)){r=new Buffer(r,n)}if(typeof e==="number"){return new a(i(e,r),r,true)}if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}return new a(e,r,true)}t.DiffieHellmanGroup=t.createDiffieHellmanGroup=t.getDiffieHellman=getDiffieHellman;t.createDiffieHellman=t.DiffieHellman=createDiffieHellman},373:function(e,t,r){var i=r(711);var n=r(1354);var a=new n;var s=new i(24);var o=new i(11);var h=new i(10);var u=new i(3);var d=new i(7);var c=r(296);var l=r(7223);e.exports=DH;function setPublicKey(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this._pub=new i(e);return this}function setPrivateKey(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this._priv=new i(e);return this}var p={};function checkPrime(e,t){var r=t.toString("hex");var i=[r,e.toString(16)].join("_");if(i in p){return p[i]}var n=0;if(e.isEven()||!c.simpleSieve||!c.fermatTest(e)||!a.test(e)){n+=1;if(r==="02"||r==="05"){n+=8}else{n+=4}p[i]=n;return n}if(!a.test(e.shrn(1))){n+=2}var l;switch(r){case"02":if(e.mod(s).cmp(o)){n+=8}break;case"05":l=e.mod(h);if(l.cmp(u)&&l.cmp(d)){n+=8}break;default:n+=4}p[i]=n;return n}function DH(e,t,r){this.setGenerator(t);this.__prime=new i(e);this._prime=i.mont(this.__prime);this._primeLen=e.length;this._pub=undefined;this._priv=undefined;this._primeCode=undefined;if(r){this.setPublicKey=setPublicKey;this.setPrivateKey=setPrivateKey}else{this._primeCode=8}}Object.defineProperty(DH.prototype,"verifyError",{enumerable:true,get:function(){if(typeof this._primeCode!=="number"){this._primeCode=checkPrime(this.__prime,this.__gen)}return this._primeCode}});DH.prototype.generateKeys=function(){if(!this._priv){this._priv=new i(l(this._primeLen))}this._pub=this._gen.toRed(this._prime).redPow(this._priv).fromRed();return this.getPublicKey()};DH.prototype.computeSecret=function(e){e=new i(e);e=e.toRed(this._prime);var t=e.redPow(this._priv).fromRed();var r=new Buffer(t.toArray());var n=this.getPrime();if(r.length<n.length){var a=new Buffer(n.length-r.length);a.fill(0);r=Buffer.concat([a,r])}return r};DH.prototype.getPublicKey=function getPublicKey(e){return formatReturnValue(this._pub,e)};DH.prototype.getPrivateKey=function getPrivateKey(e){return formatReturnValue(this._priv,e)};DH.prototype.getPrime=function(e){return formatReturnValue(this.__prime,e)};DH.prototype.getGenerator=function(e){return formatReturnValue(this._gen,e)};DH.prototype.setGenerator=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this.__gen=e;this._gen=new i(e);return this};function formatReturnValue(e,t){var r=new Buffer(e.toArray());if(!t){return r}else{return r.toString(t)}}},296:function(e,t,r){var i=r(7223);e.exports=findPrime;findPrime.simpleSieve=simpleSieve;findPrime.fermatTest=fermatTest;var n=r(711);var a=new n(24);var s=r(1354);var o=new s;var h=new n(1);var u=new n(2);var d=new n(5);var c=new n(16);var l=new n(8);var p=new n(10);var v=new n(3);var b=new n(7);var m=new n(11);var y=new n(4);var g=new n(12);var _=null;function _getPrimes(){if(_!==null)return _;var e=1048576;var t=[];t[0]=2;for(var r=1,i=3;i<e;i+=2){var n=Math.ceil(Math.sqrt(i));for(var a=0;a<r&&t[a]<=n;a++)if(i%t[a]===0)break;if(r!==a&&t[a]<=n)continue;t[r++]=i}_=t;return t}function simpleSieve(e){var t=_getPrimes();for(var r=0;r<t.length;r++)if(e.modn(t[r])===0){if(e.cmpn(t[r])===0){return true}else{return false}}return true}function fermatTest(e){var t=n.mont(e);return u.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1)===0}function findPrime(e,t){if(e<16){if(t===2||t===5){return new n([140,123])}else{return new n([140,39])}}t=new n(t);var r,s;while(true){r=new n(i(Math.ceil(e/8)));while(r.bitLength()>e){r.ishrn(1)}if(r.isEven()){r.iadd(h)}if(!r.testn(1)){r.iadd(u)}if(!t.cmp(u)){while(r.mod(a).cmp(m)){r.iadd(y)}}else if(!t.cmp(d)){while(r.mod(p).cmp(v)){r.iadd(y)}}s=r.shrn(1);if(simpleSieve(s)&&simpleSieve(r)&&fermatTest(s)&&fermatTest(r)&&o.test(s)&&o.test(r)){return r}}}},949:function(e,t,r){"use strict";var i=t;i.version=r(2531).i8;i.utils=r(4401);i.rand=r(3500);i.curve=r(9359);i.curves=r(6226);i.ec=r(4088);i.eddsa=r(8511)},2727:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.getNAF;var s=n.getJSF;var o=n.assert;function BaseCurve(e,t){this.type=e;this.p=new i(t.p,16);this.red=t.prime?i.red(t.prime):i.mont(this.p);this.zero=new i(0).toRed(this.red);this.one=new i(1).toRed(this.red);this.two=new i(2).toRed(this.red);this.n=t.n&&new i(t.n,16);this.g=t.g&&this.pointFromJSON(t.g,t.gRed);this._wnafT1=new Array(4);this._wnafT2=new Array(4);this._wnafT3=new Array(4);this._wnafT4=new Array(4);this._bitLength=this.n?this.n.bitLength():0;var r=this.n&&this.p.div(this.n);if(!r||r.cmpn(100)>0){this.redN=null}else{this._maxwellTrick=true;this.redN=this.n.toRed(this.red)}}e.exports=BaseCurve;BaseCurve.prototype.point=function point(){throw new Error("Not implemented")};BaseCurve.prototype.validate=function validate(){throw new Error("Not implemented")};BaseCurve.prototype._fixedNafMul=function _fixedNafMul(e,t){o(e.precomputed);var r=e._getDoubles();var i=a(t,1,this._bitLength);var n=(1<<r.step+1)-(r.step%2===0?2:1);n/=3;var s=[];for(var h=0;h<i.length;h+=r.step){var u=0;for(var t=h+r.step-1;t>=h;t--)u=(u<<1)+i[t];s.push(u)}var d=this.jpoint(null,null,null);var c=this.jpoint(null,null,null);for(var l=n;l>0;l--){for(var h=0;h<s.length;h++){var u=s[h];if(u===l)c=c.mixedAdd(r.points[h]);else if(u===-l)c=c.mixedAdd(r.points[h].neg())}d=d.add(c)}return d.toP()};BaseCurve.prototype._wnafMul=function _wnafMul(e,t){var r=4;var i=e._getNAFPoints(r);r=i.wnd;var n=i.points;var s=a(t,r,this._bitLength);var h=this.jpoint(null,null,null);for(var u=s.length-1;u>=0;u--){for(var t=0;u>=0&&s[u]===0;u--)t++;if(u>=0)t++;h=h.dblp(t);if(u<0)break;var d=s[u];o(d!==0);if(e.type==="affine"){if(d>0)h=h.mixedAdd(n[d-1>>1]);else h=h.mixedAdd(n[-d-1>>1].neg())}else{if(d>0)h=h.add(n[d-1>>1]);else h=h.add(n[-d-1>>1].neg())}}return e.type==="affine"?h.toP():h};BaseCurve.prototype._wnafMulAdd=function _wnafMulAdd(e,t,r,i,n){var o=this._wnafT1;var h=this._wnafT2;var u=this._wnafT3;var d=0;for(var c=0;c<i;c++){var l=t[c];var p=l._getNAFPoints(e);o[c]=p.wnd;h[c]=p.points}for(var c=i-1;c>=1;c-=2){var v=c-1;var b=c;if(o[v]!==1||o[b]!==1){u[v]=a(r[v],o[v],this._bitLength);u[b]=a(r[b],o[b],this._bitLength);d=Math.max(u[v].length,d);d=Math.max(u[b].length,d);continue}var m=[t[v],null,null,t[b]];if(t[v].y.cmp(t[b].y)===0){m[1]=t[v].add(t[b]);m[2]=t[v].toJ().mixedAdd(t[b].neg())}else if(t[v].y.cmp(t[b].y.redNeg())===0){m[1]=t[v].toJ().mixedAdd(t[b]);m[2]=t[v].add(t[b].neg())}else{m[1]=t[v].toJ().mixedAdd(t[b]);m[2]=t[v].toJ().mixedAdd(t[b].neg())}var y=[-3,-1,-5,-7,0,7,5,1,3];var g=s(r[v],r[b]);d=Math.max(g[0].length,d);u[v]=new Array(d);u[b]=new Array(d);for(var _=0;_<d;_++){var w=g[0][_]|0;var M=g[1][_]|0;u[v][_]=y[(w+1)*3+(M+1)];u[b][_]=0;h[v]=m}}var B=this.jpoint(null,null,null);var E=this._wnafT4;for(var c=d;c>=0;c--){var k=0;while(c>=0){var A=true;for(var _=0;_<i;_++){E[_]=u[_][c]|0;if(E[_]!==0)A=false}if(!A)break;k++;c--}if(c>=0)k++;B=B.dblp(k);if(c<0)break;for(var _=0;_<i;_++){var N=E[_];var l;if(N===0)continue;else if(N>0)l=h[_][N-1>>1];else if(N<0)l=h[_][-N-1>>1].neg();if(l.type==="affine")B=B.mixedAdd(l);else B=B.add(l)}}for(var c=0;c<i;c++)h[c]=null;if(n)return B;else return B.toP()};function BasePoint(e,t){this.curve=e;this.type=t;this.precomputed=null}BaseCurve.BasePoint=BasePoint;BasePoint.prototype.eq=function eq(){throw new Error("Not implemented")};BasePoint.prototype.validate=function validate(){return this.curve.validate(this)};BaseCurve.prototype.decodePoint=function decodePoint(e,t){e=n.toArray(e,t);var r=this.p.byteLength();if((e[0]===4||e[0]===6||e[0]===7)&&e.length-1===2*r){if(e[0]===6)o(e[e.length-1]%2===0);else if(e[0]===7)o(e[e.length-1]%2===1);var i=this.point(e.slice(1,1+r),e.slice(1+r,1+2*r));return i}else if((e[0]===2||e[0]===3)&&e.length-1===r){return this.pointFromX(e.slice(1,1+r),e[0]===3)}throw new Error("Unknown point format")};BasePoint.prototype.encodeCompressed=function encodeCompressed(e){return this.encode(e,true)};BasePoint.prototype._encode=function _encode(e){var t=this.curve.p.byteLength();var r=this.getX().toArray("be",t);if(e)return[this.getY().isEven()?2:3].concat(r);return[4].concat(r,this.getY().toArray("be",t))};BasePoint.prototype.encode=function encode(e,t){return n.encode(this._encode(t),e)};BasePoint.prototype.precompute=function precompute(e){if(this.precomputed)return this;var t={doubles:null,naf:null,beta:null};t.naf=this._getNAFPoints(8);t.doubles=this._getDoubles(4,e);t.beta=this._getBeta();this.precomputed=t;return this};BasePoint.prototype._hasDoubles=function _hasDoubles(e){if(!this.precomputed)return false;var t=this.precomputed.doubles;if(!t)return false;return t.points.length>=Math.ceil((e.bitLength()+1)/t.step)};BasePoint.prototype._getDoubles=function _getDoubles(e,t){if(this.precomputed&&this.precomputed.doubles)return this.precomputed.doubles;var r=[this];var i=this;for(var n=0;n<t;n+=e){for(var a=0;a<e;a++)i=i.dbl();r.push(i)}return{step:e,points:r}};BasePoint.prototype._getNAFPoints=function _getNAFPoints(e){if(this.precomputed&&this.precomputed.naf)return this.precomputed.naf;var t=[this];var r=(1<<e)-1;var i=r===1?null:this.dbl();for(var n=1;n<r;n++)t[n]=t[n-1].add(i);return{wnd:e,points:t}};BasePoint.prototype._getBeta=function _getBeta(){return null};BasePoint.prototype.dblp=function dblp(e){var t=this;for(var r=0;r<e;r++)t=t.dbl();return t}},2705:function(e,t,r){"use strict";var i=r(4401);var n=r(711);var a=r(3782);var s=r(2727);var o=i.assert;function EdwardsCurve(e){this.twisted=(e.a|0)!==1;this.mOneA=this.twisted&&(e.a|0)===-1;this.extended=this.mOneA;s.call(this,"edwards",e);this.a=new n(e.a,16).umod(this.red.m);this.a=this.a.toRed(this.red);this.c=new n(e.c,16).toRed(this.red);this.c2=this.c.redSqr();this.d=new n(e.d,16).toRed(this.red);this.dd=this.d.redAdd(this.d);o(!this.twisted||this.c.fromRed().cmpn(1)===0);this.oneC=(e.c|0)===1}a(EdwardsCurve,s);e.exports=EdwardsCurve;EdwardsCurve.prototype._mulA=function _mulA(e){if(this.mOneA)return e.redNeg();else return this.a.redMul(e)};EdwardsCurve.prototype._mulC=function _mulC(e){if(this.oneC)return e;else return this.c.redMul(e)};EdwardsCurve.prototype.jpoint=function jpoint(e,t,r,i){return this.point(e,t,r,i)};EdwardsCurve.prototype.pointFromX=function pointFromX(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr();var i=this.c2.redSub(this.a.redMul(r));var a=this.one.redSub(this.c2.redMul(this.d).redMul(r));var s=i.redMul(a.redInvm());var o=s.redSqrt();if(o.redSqr().redSub(s).cmp(this.zero)!==0)throw new Error("invalid point");var h=o.fromRed().isOdd();if(t&&!h||!t&&h)o=o.redNeg();return this.point(e,o)};EdwardsCurve.prototype.pointFromY=function pointFromY(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr();var i=r.redSub(this.c2);var a=r.redMul(this.d).redMul(this.c2).redSub(this.a);var s=i.redMul(a.redInvm());if(s.cmp(this.zero)===0){if(t)throw new Error("invalid point");else return this.point(this.zero,e)}var o=s.redSqrt();if(o.redSqr().redSub(s).cmp(this.zero)!==0)throw new Error("invalid point");if(o.fromRed().isOdd()!==t)o=o.redNeg();return this.point(o,e)};EdwardsCurve.prototype.validate=function validate(e){if(e.isInfinity())return true;e.normalize();var t=e.x.redSqr();var r=e.y.redSqr();var i=t.redMul(this.a).redAdd(r);var n=this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));return i.cmp(n)===0};function Point(e,t,r,i,a){s.BasePoint.call(this,e,"projective");if(t===null&&r===null&&i===null){this.x=this.curve.zero;this.y=this.curve.one;this.z=this.curve.one;this.t=this.curve.zero;this.zOne=true}else{this.x=new n(t,16);this.y=new n(r,16);this.z=i?new n(i,16):this.curve.one;this.t=a&&new n(a,16);if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red);if(this.t&&!this.t.red)this.t=this.t.toRed(this.curve.red);this.zOne=this.z===this.curve.one;if(this.curve.extended&&!this.t){this.t=this.x.redMul(this.y);if(!this.zOne)this.t=this.t.redMul(this.z.redInvm())}}}a(Point,s.BasePoint);EdwardsCurve.prototype.pointFromJSON=function pointFromJSON(e){return Point.fromJSON(this,e)};EdwardsCurve.prototype.point=function point(e,t,r,i){return new Point(this,e,t,r,i)};Point.fromJSON=function fromJSON(e,t){return new Point(e,t[0],t[1],t[2])};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.x.cmpn(0)===0&&(this.y.cmp(this.z)===0||this.zOne&&this.y.cmp(this.curve.c)===0)};Point.prototype._extDbl=function _extDbl(){var e=this.x.redSqr();var t=this.y.redSqr();var r=this.z.redSqr();r=r.redIAdd(r);var i=this.curve._mulA(e);var n=this.x.redAdd(this.y).redSqr().redISub(e).redISub(t);var a=i.redAdd(t);var s=a.redSub(r);var o=i.redSub(t);var h=n.redMul(s);var u=a.redMul(o);var d=n.redMul(o);var c=s.redMul(a);return this.curve.point(h,u,c,d)};Point.prototype._projDbl=function _projDbl(){var e=this.x.redAdd(this.y).redSqr();var t=this.x.redSqr();var r=this.y.redSqr();var i;var n;var a;if(this.curve.twisted){var s=this.curve._mulA(t);var o=s.redAdd(r);if(this.zOne){i=e.redSub(t).redSub(r).redMul(o.redSub(this.curve.two));n=o.redMul(s.redSub(r));a=o.redSqr().redSub(o).redSub(o)}else{var h=this.z.redSqr();var u=o.redSub(h).redISub(h);i=e.redSub(t).redISub(r).redMul(u);n=o.redMul(s.redSub(r));a=o.redMul(u)}}else{var s=t.redAdd(r);var h=this.curve._mulC(this.z).redSqr();var u=s.redSub(h).redSub(h);i=this.curve._mulC(e.redISub(s)).redMul(u);n=this.curve._mulC(s).redMul(t.redISub(r));a=s.redMul(u)}return this.curve.point(i,n,a)};Point.prototype.dbl=function dbl(){if(this.isInfinity())return this;if(this.curve.extended)return this._extDbl();else return this._projDbl()};Point.prototype._extAdd=function _extAdd(e){var t=this.y.redSub(this.x).redMul(e.y.redSub(e.x));var r=this.y.redAdd(this.x).redMul(e.y.redAdd(e.x));var i=this.t.redMul(this.curve.dd).redMul(e.t);var n=this.z.redMul(e.z.redAdd(e.z));var a=r.redSub(t);var s=n.redSub(i);var o=n.redAdd(i);var h=r.redAdd(t);var u=a.redMul(s);var d=o.redMul(h);var c=a.redMul(h);var l=s.redMul(o);return this.curve.point(u,d,l,c)};Point.prototype._projAdd=function _projAdd(e){var t=this.z.redMul(e.z);var r=t.redSqr();var i=this.x.redMul(e.x);var n=this.y.redMul(e.y);var a=this.curve.d.redMul(i).redMul(n);var s=r.redSub(a);var o=r.redAdd(a);var h=this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(i).redISub(n);var u=t.redMul(s).redMul(h);var d;var c;if(this.curve.twisted){d=t.redMul(o).redMul(n.redSub(this.curve._mulA(i)));c=s.redMul(o)}else{d=t.redMul(o).redMul(n.redSub(i));c=this.curve._mulC(s).redMul(o)}return this.curve.point(u,d,c)};Point.prototype.add=function add(e){if(this.isInfinity())return e;if(e.isInfinity())return this;if(this.curve.extended)return this._extAdd(e);else return this._projAdd(e)};Point.prototype.mul=function mul(e){if(this._hasDoubles(e))return this.curve._fixedNafMul(this,e);else return this.curve._wnafMul(this,e)};Point.prototype.mulAdd=function mulAdd(e,t,r){return this.curve._wnafMulAdd(1,[this,t],[e,r],2,false)};Point.prototype.jmulAdd=function jmulAdd(e,t,r){return this.curve._wnafMulAdd(1,[this,t],[e,r],2,true)};Point.prototype.normalize=function normalize(){if(this.zOne)return this;var e=this.z.redInvm();this.x=this.x.redMul(e);this.y=this.y.redMul(e);if(this.t)this.t=this.t.redMul(e);this.z=this.curve.one;this.zOne=true;return this};Point.prototype.neg=function neg(){return this.curve.point(this.x.redNeg(),this.y,this.z,this.t&&this.t.redNeg())};Point.prototype.getX=function getX(){this.normalize();return this.x.fromRed()};Point.prototype.getY=function getY(){this.normalize();return this.y.fromRed()};Point.prototype.eq=function eq(e){return this===e||this.getX().cmp(e.getX())===0&&this.getY().cmp(e.getY())===0};Point.prototype.eqXToP=function eqXToP(e){var t=e.toRed(this.curve.red).redMul(this.z);if(this.x.cmp(t)===0)return true;var r=e.clone();var i=this.curve.redN.redMul(this.z);for(;;){r.iadd(this.curve.n);if(r.cmp(this.curve.p)>=0)return false;t.redIAdd(i);if(this.x.cmp(t)===0)return true}};Point.prototype.toP=Point.prototype.normalize;Point.prototype.mixedAdd=Point.prototype.add},9359:function(e,t,r){"use strict";var i=t;i.base=r(2727);i.short=r(4720);i.mont=r(6653);i.edwards=r(2705)},6653:function(e,t,r){"use strict";var i=r(711);var n=r(3782);var a=r(2727);var s=r(4401);function MontCurve(e){a.call(this,"mont",e);this.a=new i(e.a,16).toRed(this.red);this.b=new i(e.b,16).toRed(this.red);this.i4=new i(4).toRed(this.red).redInvm();this.two=new i(2).toRed(this.red);this.a24=this.i4.redMul(this.a.redAdd(this.two))}n(MontCurve,a);e.exports=MontCurve;MontCurve.prototype.validate=function validate(e){var t=e.normalize().x;var r=t.redSqr();var i=r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);var n=i.redSqrt();return n.redSqr().cmp(i)===0};function Point(e,t,r){a.BasePoint.call(this,e,"projective");if(t===null&&r===null){this.x=this.curve.one;this.z=this.curve.zero}else{this.x=new i(t,16);this.z=new i(r,16);if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red)}}n(Point,a.BasePoint);MontCurve.prototype.decodePoint=function decodePoint(e,t){return this.point(s.toArray(e,t),1)};MontCurve.prototype.point=function point(e,t){return new Point(this,e,t)};MontCurve.prototype.pointFromJSON=function pointFromJSON(e){return Point.fromJSON(this,e)};Point.prototype.precompute=function precompute(){};Point.prototype._encode=function _encode(){return this.getX().toArray("be",this.curve.p.byteLength())};Point.fromJSON=function fromJSON(e,t){return new Point(e,t[0],t[1]||e.one)};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.z.cmpn(0)===0};Point.prototype.dbl=function dbl(){var e=this.x.redAdd(this.z);var t=e.redSqr();var r=this.x.redSub(this.z);var i=r.redSqr();var n=t.redSub(i);var a=t.redMul(i);var s=n.redMul(i.redAdd(this.curve.a24.redMul(n)));return this.curve.point(a,s)};Point.prototype.add=function add(){throw new Error("Not supported on Montgomery curve")};Point.prototype.diffAdd=function diffAdd(e,t){var r=this.x.redAdd(this.z);var i=this.x.redSub(this.z);var n=e.x.redAdd(e.z);var a=e.x.redSub(e.z);var s=a.redMul(r);var o=n.redMul(i);var h=t.z.redMul(s.redAdd(o).redSqr());var u=t.x.redMul(s.redISub(o).redSqr());return this.curve.point(h,u)};Point.prototype.mul=function mul(e){var t=e.clone();var r=this;var i=this.curve.point(null,null);var n=this;for(var a=[];t.cmpn(0)!==0;t.iushrn(1))a.push(t.andln(1));for(var s=a.length-1;s>=0;s--){if(a[s]===0){r=r.diffAdd(i,n);i=i.dbl()}else{i=r.diffAdd(i,n);r=r.dbl()}}return i};Point.prototype.mulAdd=function mulAdd(){throw new Error("Not supported on Montgomery curve")};Point.prototype.jumlAdd=function jumlAdd(){throw new Error("Not supported on Montgomery curve")};Point.prototype.eq=function eq(e){return this.getX().cmp(e.getX())===0};Point.prototype.normalize=function normalize(){this.x=this.x.redMul(this.z.redInvm());this.z=this.curve.one;return this};Point.prototype.getX=function getX(){this.normalize();return this.x.fromRed()}},4720:function(e,t,r){"use strict";var i=r(4401);var n=r(711);var a=r(3782);var s=r(2727);var o=i.assert;function ShortCurve(e){s.call(this,"short",e);this.a=new n(e.a,16).toRed(this.red);this.b=new n(e.b,16).toRed(this.red);this.tinv=this.two.redInvm();this.zeroA=this.a.fromRed().cmpn(0)===0;this.threeA=this.a.fromRed().sub(this.p).cmpn(-3)===0;this.endo=this._getEndomorphism(e);this._endoWnafT1=new Array(4);this._endoWnafT2=new Array(4)}a(ShortCurve,s);e.exports=ShortCurve;ShortCurve.prototype._getEndomorphism=function _getEndomorphism(e){if(!this.zeroA||!this.g||!this.n||this.p.modn(3)!==1)return;var t;var r;if(e.beta){t=new n(e.beta,16).toRed(this.red)}else{var i=this._getEndoRoots(this.p);t=i[0].cmp(i[1])<0?i[0]:i[1];t=t.toRed(this.red)}if(e.lambda){r=new n(e.lambda,16)}else{var a=this._getEndoRoots(this.n);if(this.g.mul(a[0]).x.cmp(this.g.x.redMul(t))===0){r=a[0]}else{r=a[1];o(this.g.mul(r).x.cmp(this.g.x.redMul(t))===0)}}var s;if(e.basis){s=e.basis.map((function(e){return{a:new n(e.a,16),b:new n(e.b,16)}}))}else{s=this._getEndoBasis(r)}return{beta:t,lambda:r,basis:s}};ShortCurve.prototype._getEndoRoots=function _getEndoRoots(e){var t=e===this.p?this.red:n.mont(e);var r=new n(2).toRed(t).redInvm();var i=r.redNeg();var a=new n(3).toRed(t).redNeg().redSqrt().redMul(r);var s=i.redAdd(a).fromRed();var o=i.redSub(a).fromRed();return[s,o]};ShortCurve.prototype._getEndoBasis=function _getEndoBasis(e){var t=this.n.ushrn(Math.floor(this.n.bitLength()/2));var r=e;var i=this.n.clone();var a=new n(1);var s=new n(0);var o=new n(0);var h=new n(1);var u;var d;var c;var l;var p;var v;var b;var m=0;var y;var g;while(r.cmpn(0)!==0){var _=i.div(r);y=i.sub(_.mul(r));g=o.sub(_.mul(a));var w=h.sub(_.mul(s));if(!c&&y.cmp(t)<0){u=b.neg();d=a;c=y.neg();l=g}else if(c&&++m===2){break}b=y;i=r;r=y;o=a;a=g;h=s;s=w}p=y.neg();v=g;var M=c.sqr().add(l.sqr());var B=p.sqr().add(v.sqr());if(B.cmp(M)>=0){p=u;v=d}if(c.negative){c=c.neg();l=l.neg()}if(p.negative){p=p.neg();v=v.neg()}return[{a:c,b:l},{a:p,b:v}]};ShortCurve.prototype._endoSplit=function _endoSplit(e){var t=this.endo.basis;var r=t[0];var i=t[1];var n=i.b.mul(e).divRound(this.n);var a=r.b.neg().mul(e).divRound(this.n);var s=n.mul(r.a);var o=a.mul(i.a);var h=n.mul(r.b);var u=a.mul(i.b);var d=e.sub(s).sub(o);var c=h.add(u).neg();return{k1:d,k2:c}};ShortCurve.prototype.pointFromX=function pointFromX(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b);var i=r.redSqrt();if(i.redSqr().redSub(r).cmp(this.zero)!==0)throw new Error("invalid point");var a=i.fromRed().isOdd();if(t&&!a||!t&&a)i=i.redNeg();return this.point(e,i)};ShortCurve.prototype.validate=function validate(e){if(e.inf)return true;var t=e.x;var r=e.y;var i=this.a.redMul(t);var n=t.redSqr().redMul(t).redIAdd(i).redIAdd(this.b);return r.redSqr().redISub(n).cmpn(0)===0};ShortCurve.prototype._endoWnafMulAdd=function _endoWnafMulAdd(e,t,r){var i=this._endoWnafT1;var n=this._endoWnafT2;for(var a=0;a<e.length;a++){var s=this._endoSplit(t[a]);var o=e[a];var h=o._getBeta();if(s.k1.negative){s.k1.ineg();o=o.neg(true)}if(s.k2.negative){s.k2.ineg();h=h.neg(true)}i[a*2]=o;i[a*2+1]=h;n[a*2]=s.k1;n[a*2+1]=s.k2}var u=this._wnafMulAdd(1,i,n,a*2,r);for(var d=0;d<a*2;d++){i[d]=null;n[d]=null}return u};function Point(e,t,r,i){s.BasePoint.call(this,e,"affine");if(t===null&&r===null){this.x=null;this.y=null;this.inf=true}else{this.x=new n(t,16);this.y=new n(r,16);if(i){this.x.forceRed(this.curve.red);this.y.forceRed(this.curve.red)}if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);this.inf=false}}a(Point,s.BasePoint);ShortCurve.prototype.point=function point(e,t,r){return new Point(this,e,t,r)};ShortCurve.prototype.pointFromJSON=function pointFromJSON(e,t){return Point.fromJSON(this,e,t)};Point.prototype._getBeta=function _getBeta(){if(!this.curve.endo)return;var e=this.precomputed;if(e&&e.beta)return e.beta;var t=this.curve.point(this.x.redMul(this.curve.endo.beta),this.y);if(e){var r=this.curve;var endoMul=function(e){return r.point(e.x.redMul(r.endo.beta),e.y)};e.beta=t;t.precomputed={beta:null,naf:e.naf&&{wnd:e.naf.wnd,points:e.naf.points.map(endoMul)},doubles:e.doubles&&{step:e.doubles.step,points:e.doubles.points.map(endoMul)}}}return t};Point.prototype.toJSON=function toJSON(){if(!this.precomputed)return[this.x,this.y];return[this.x,this.y,this.precomputed&&{doubles:this.precomputed.doubles&&{step:this.precomputed.doubles.step,points:this.precomputed.doubles.points.slice(1)},naf:this.precomputed.naf&&{wnd:this.precomputed.naf.wnd,points:this.precomputed.naf.points.slice(1)}}]};Point.fromJSON=function fromJSON(e,t,r){if(typeof t==="string")t=JSON.parse(t);var i=e.point(t[0],t[1],r);if(!t[2])return i;function obj2point(t){return e.point(t[0],t[1],r)}var n=t[2];i.precomputed={beta:null,doubles:n.doubles&&{step:n.doubles.step,points:[i].concat(n.doubles.points.map(obj2point))},naf:n.naf&&{wnd:n.naf.wnd,points:[i].concat(n.naf.points.map(obj2point))}};return i};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.inf};Point.prototype.add=function add(e){if(this.inf)return e;if(e.inf)return this;if(this.eq(e))return this.dbl();if(this.neg().eq(e))return this.curve.point(null,null);if(this.x.cmp(e.x)===0)return this.curve.point(null,null);var t=this.y.redSub(e.y);if(t.cmpn(0)!==0)t=t.redMul(this.x.redSub(e.x).redInvm());var r=t.redSqr().redISub(this.x).redISub(e.x);var i=t.redMul(this.x.redSub(r)).redISub(this.y);return this.curve.point(r,i)};Point.prototype.dbl=function dbl(){if(this.inf)return this;var e=this.y.redAdd(this.y);if(e.cmpn(0)===0)return this.curve.point(null,null);var t=this.curve.a;var r=this.x.redSqr();var i=e.redInvm();var n=r.redAdd(r).redIAdd(r).redIAdd(t).redMul(i);var a=n.redSqr().redISub(this.x.redAdd(this.x));var s=n.redMul(this.x.redSub(a)).redISub(this.y);return this.curve.point(a,s)};Point.prototype.getX=function getX(){return this.x.fromRed()};Point.prototype.getY=function getY(){return this.y.fromRed()};Point.prototype.mul=function mul(e){e=new n(e,16);if(this.isInfinity())return this;else if(this._hasDoubles(e))return this.curve._fixedNafMul(this,e);else if(this.curve.endo)return this.curve._endoWnafMulAdd([this],[e]);else return this.curve._wnafMul(this,e)};Point.prototype.mulAdd=function mulAdd(e,t,r){var i=[this,t];var n=[e,r];if(this.curve.endo)return this.curve._endoWnafMulAdd(i,n);else return this.curve._wnafMulAdd(1,i,n,2)};Point.prototype.jmulAdd=function jmulAdd(e,t,r){var i=[this,t];var n=[e,r];if(this.curve.endo)return this.curve._endoWnafMulAdd(i,n,true);else return this.curve._wnafMulAdd(1,i,n,2,true)};Point.prototype.eq=function eq(e){return this===e||this.inf===e.inf&&(this.inf||this.x.cmp(e.x)===0&&this.y.cmp(e.y)===0)};Point.prototype.neg=function neg(e){if(this.inf)return this;var t=this.curve.point(this.x,this.y.redNeg());if(e&&this.precomputed){var r=this.precomputed;var negate=function(e){return e.neg()};t.precomputed={naf:r.naf&&{wnd:r.naf.wnd,points:r.naf.points.map(negate)},doubles:r.doubles&&{step:r.doubles.step,points:r.doubles.points.map(negate)}}}return t};Point.prototype.toJ=function toJ(){if(this.inf)return this.curve.jpoint(null,null,null);var e=this.curve.jpoint(this.x,this.y,this.curve.one);return e};function JPoint(e,t,r,i){s.BasePoint.call(this,e,"jacobian");if(t===null&&r===null&&i===null){this.x=this.curve.one;this.y=this.curve.one;this.z=new n(0)}else{this.x=new n(t,16);this.y=new n(r,16);this.z=new n(i,16)}if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red);this.zOne=this.z===this.curve.one}a(JPoint,s.BasePoint);ShortCurve.prototype.jpoint=function jpoint(e,t,r){return new JPoint(this,e,t,r)};JPoint.prototype.toP=function toP(){if(this.isInfinity())return this.curve.point(null,null);var e=this.z.redInvm();var t=e.redSqr();var r=this.x.redMul(t);var i=this.y.redMul(t).redMul(e);return this.curve.point(r,i)};JPoint.prototype.neg=function neg(){return this.curve.jpoint(this.x,this.y.redNeg(),this.z)};JPoint.prototype.add=function add(e){if(this.isInfinity())return e;if(e.isInfinity())return this;var t=e.z.redSqr();var r=this.z.redSqr();var i=this.x.redMul(t);var n=e.x.redMul(r);var a=this.y.redMul(t.redMul(e.z));var s=e.y.redMul(r.redMul(this.z));var o=i.redSub(n);var h=a.redSub(s);if(o.cmpn(0)===0){if(h.cmpn(0)!==0)return this.curve.jpoint(null,null,null);else return this.dbl()}var u=o.redSqr();var d=u.redMul(o);var c=i.redMul(u);var l=h.redSqr().redIAdd(d).redISub(c).redISub(c);var p=h.redMul(c.redISub(l)).redISub(a.redMul(d));var v=this.z.redMul(e.z).redMul(o);return this.curve.jpoint(l,p,v)};JPoint.prototype.mixedAdd=function mixedAdd(e){if(this.isInfinity())return e.toJ();if(e.isInfinity())return this;var t=this.z.redSqr();var r=this.x;var i=e.x.redMul(t);var n=this.y;var a=e.y.redMul(t).redMul(this.z);var s=r.redSub(i);var o=n.redSub(a);if(s.cmpn(0)===0){if(o.cmpn(0)!==0)return this.curve.jpoint(null,null,null);else return this.dbl()}var h=s.redSqr();var u=h.redMul(s);var d=r.redMul(h);var c=o.redSqr().redIAdd(u).redISub(d).redISub(d);var l=o.redMul(d.redISub(c)).redISub(n.redMul(u));var p=this.z.redMul(s);return this.curve.jpoint(c,l,p)};JPoint.prototype.dblp=function dblp(e){if(e===0)return this;if(this.isInfinity())return this;if(!e)return this.dbl();if(this.curve.zeroA||this.curve.threeA){var t=this;for(var r=0;r<e;r++)t=t.dbl();return t}var i=this.curve.a;var n=this.curve.tinv;var a=this.x;var s=this.y;var o=this.z;var h=o.redSqr().redSqr();var u=s.redAdd(s);for(var r=0;r<e;r++){var d=a.redSqr();var c=u.redSqr();var l=c.redSqr();var p=d.redAdd(d).redIAdd(d).redIAdd(i.redMul(h));var v=a.redMul(c);var b=p.redSqr().redISub(v.redAdd(v));var m=v.redISub(b);var y=p.redMul(m);y=y.redIAdd(y).redISub(l);var g=u.redMul(o);if(r+1<e)h=h.redMul(l);a=b;o=g;u=y}return this.curve.jpoint(a,u.redMul(n),o)};JPoint.prototype.dbl=function dbl(){if(this.isInfinity())return this;if(this.curve.zeroA)return this._zeroDbl();else if(this.curve.threeA)return this._threeDbl();else return this._dbl()};JPoint.prototype._zeroDbl=function _zeroDbl(){var e;var t;var r;if(this.zOne){var i=this.x.redSqr();var n=this.y.redSqr();var a=n.redSqr();var s=this.x.redAdd(n).redSqr().redISub(i).redISub(a);s=s.redIAdd(s);var o=i.redAdd(i).redIAdd(i);var h=o.redSqr().redISub(s).redISub(s);var u=a.redIAdd(a);u=u.redIAdd(u);u=u.redIAdd(u);e=h;t=o.redMul(s.redISub(h)).redISub(u);r=this.y.redAdd(this.y)}else{var d=this.x.redSqr();var c=this.y.redSqr();var l=c.redSqr();var p=this.x.redAdd(c).redSqr().redISub(d).redISub(l);p=p.redIAdd(p);var v=d.redAdd(d).redIAdd(d);var b=v.redSqr();var m=l.redIAdd(l);m=m.redIAdd(m);m=m.redIAdd(m);e=b.redISub(p).redISub(p);t=v.redMul(p.redISub(e)).redISub(m);r=this.y.redMul(this.z);r=r.redIAdd(r)}return this.curve.jpoint(e,t,r)};JPoint.prototype._threeDbl=function _threeDbl(){var e;var t;var r;if(this.zOne){var i=this.x.redSqr();var n=this.y.redSqr();var a=n.redSqr();var s=this.x.redAdd(n).redSqr().redISub(i).redISub(a);s=s.redIAdd(s);var o=i.redAdd(i).redIAdd(i).redIAdd(this.curve.a);var h=o.redSqr().redISub(s).redISub(s);e=h;var u=a.redIAdd(a);u=u.redIAdd(u);u=u.redIAdd(u);t=o.redMul(s.redISub(h)).redISub(u);r=this.y.redAdd(this.y)}else{var d=this.z.redSqr();var c=this.y.redSqr();var l=this.x.redMul(c);var p=this.x.redSub(d).redMul(this.x.redAdd(d));p=p.redAdd(p).redIAdd(p);var v=l.redIAdd(l);v=v.redIAdd(v);var b=v.redAdd(v);e=p.redSqr().redISub(b);r=this.y.redAdd(this.z).redSqr().redISub(c).redISub(d);var m=c.redSqr();m=m.redIAdd(m);m=m.redIAdd(m);m=m.redIAdd(m);t=p.redMul(v.redISub(e)).redISub(m)}return this.curve.jpoint(e,t,r)};JPoint.prototype._dbl=function _dbl(){var e=this.curve.a;var t=this.x;var r=this.y;var i=this.z;var n=i.redSqr().redSqr();var a=t.redSqr();var s=r.redSqr();var o=a.redAdd(a).redIAdd(a).redIAdd(e.redMul(n));var h=t.redAdd(t);h=h.redIAdd(h);var u=h.redMul(s);var d=o.redSqr().redISub(u.redAdd(u));var c=u.redISub(d);var l=s.redSqr();l=l.redIAdd(l);l=l.redIAdd(l);l=l.redIAdd(l);var p=o.redMul(c).redISub(l);var v=r.redAdd(r).redMul(i);return this.curve.jpoint(d,p,v)};JPoint.prototype.trpl=function trpl(){if(!this.curve.zeroA)return this.dbl().add(this);var e=this.x.redSqr();var t=this.y.redSqr();var r=this.z.redSqr();var i=t.redSqr();var n=e.redAdd(e).redIAdd(e);var a=n.redSqr();var s=this.x.redAdd(t).redSqr().redISub(e).redISub(i);s=s.redIAdd(s);s=s.redAdd(s).redIAdd(s);s=s.redISub(a);var o=s.redSqr();var h=i.redIAdd(i);h=h.redIAdd(h);h=h.redIAdd(h);h=h.redIAdd(h);var u=n.redIAdd(s).redSqr().redISub(a).redISub(o).redISub(h);var d=t.redMul(u);d=d.redIAdd(d);d=d.redIAdd(d);var c=this.x.redMul(o).redISub(d);c=c.redIAdd(c);c=c.redIAdd(c);var l=this.y.redMul(u.redMul(h.redISub(u)).redISub(s.redMul(o)));l=l.redIAdd(l);l=l.redIAdd(l);l=l.redIAdd(l);var p=this.z.redAdd(s).redSqr().redISub(r).redISub(o);return this.curve.jpoint(c,l,p)};JPoint.prototype.mul=function mul(e,t){e=new n(e,t);return this.curve._wnafMul(this,e)};JPoint.prototype.eq=function eq(e){if(e.type==="affine")return this.eq(e.toJ());if(this===e)return true;var t=this.z.redSqr();var r=e.z.redSqr();if(this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)!==0)return false;var i=t.redMul(this.z);var n=r.redMul(e.z);return this.y.redMul(n).redISub(e.y.redMul(i)).cmpn(0)===0};JPoint.prototype.eqXToP=function eqXToP(e){var t=this.z.redSqr();var r=e.toRed(this.curve.red).redMul(t);if(this.x.cmp(r)===0)return true;var i=e.clone();var n=this.curve.redN.redMul(t);for(;;){i.iadd(this.curve.n);if(i.cmp(this.curve.p)>=0)return false;r.redIAdd(n);if(this.x.cmp(r)===0)return true}};JPoint.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC JPoint Infinity>";return"<EC JPoint x: "+this.x.toString(16,2)+" y: "+this.y.toString(16,2)+" z: "+this.z.toString(16,2)+">"};JPoint.prototype.isInfinity=function isInfinity(){return this.z.cmpn(0)===0}},6226:function(e,t,r){"use strict";var i=t;var n=r(7028);var a=r(9359);var s=r(4401);var o=s.assert;function PresetCurve(e){if(e.type==="short")this.curve=new a.short(e);else if(e.type==="edwards")this.curve=new a.edwards(e);else this.curve=new a.mont(e);this.g=this.curve.g;this.n=this.curve.n;this.hash=e.hash;o(this.g.validate(),"Invalid curve");o(this.g.mul(this.n).isInfinity(),"Invalid curve, G*N != O")}i.PresetCurve=PresetCurve;function defineCurve(e,t){Object.defineProperty(i,e,{configurable:true,enumerable:true,get:function(){var r=new PresetCurve(t);Object.defineProperty(i,e,{configurable:true,enumerable:true,value:r});return r}})}defineCurve("p192",{type:"short",prime:"p192",p:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",a:"ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",b:"64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",n:"ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",hash:n.sha256,gRed:false,g:["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012","07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]});defineCurve("p224",{type:"short",prime:"p224",p:"ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",a:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",b:"b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",n:"ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",hash:n.sha256,gRed:false,g:["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21","bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]});defineCurve("p256",{type:"short",prime:null,p:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",a:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",b:"5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",n:"ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",hash:n.sha256,gRed:false,g:["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296","4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]});defineCurve("p384",{type:"short",prime:null,p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"fffffffe ffffffff 00000000 00000000 ffffffff",a:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"fffffffe ffffffff 00000000 00000000 fffffffc",b:"b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f "+"5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",n:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 "+"f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",hash:n.sha384,gRed:false,g:["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 "+"5502f25d bf55296c 3a545e38 72760ab7","3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 "+"0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]});defineCurve("p521",{type:"short",prime:null,p:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff",a:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff fffffffc",b:"00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b "+"99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd "+"3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",n:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 "+"f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",hash:n.sha512,gRed:false,g:["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 "+"053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 "+"a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66","00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 "+"579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 "+"3fad0761 353c7086 a272c240 88be9476 9fd16650"]});defineCurve("curve25519",{type:"mont",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"76d06",b:"1",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:n.sha256,gRed:false,g:["9"]});defineCurve("ed25519",{type:"edwards",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"-1",c:"1",d:"52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:n.sha256,gRed:false,g:["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a","6666666666666666666666666666666666666666666666666666666666666658"]});var h;try{h=r(9702)}catch(e){h=undefined}defineCurve("secp256k1",{type:"short",prime:"k256",p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",a:"0",b:"7",n:"ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",h:"1",hash:n.sha256,beta:"7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",lambda:"5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",basis:[{a:"3086d221a7d46bcde86c90e49284eb15",b:"-e4437ed6010e88286f547fa90abfe4c3"},{a:"114ca50f7a8e2f3f657c1108d9d44cfd8",b:"3086d221a7d46bcde86c90e49284eb15"}],gRed:false,g:["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798","483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",h]})},4088:function(e,t,r){"use strict";var i=r(711);var n=r(4910);var a=r(4401);var s=r(6226);var o=r(3500);var h=a.assert;var u=r(4724);var d=r(7526);function EC(e){if(!(this instanceof EC))return new EC(e);if(typeof e==="string"){h(s.hasOwnProperty(e),"Unknown curve "+e);e=s[e]}if(e instanceof s.PresetCurve)e={curve:e};this.curve=e.curve.curve;this.n=this.curve.n;this.nh=this.n.ushrn(1);this.g=this.curve.g;this.g=e.curve.g;this.g.precompute(e.curve.n.bitLength()+1);this.hash=e.hash||e.curve.hash}e.exports=EC;EC.prototype.keyPair=function keyPair(e){return new u(this,e)};EC.prototype.keyFromPrivate=function keyFromPrivate(e,t){return u.fromPrivate(this,e,t)};EC.prototype.keyFromPublic=function keyFromPublic(e,t){return u.fromPublic(this,e,t)};EC.prototype.genKeyPair=function genKeyPair(e){if(!e)e={};var t=new n({hash:this.hash,pers:e.pers,persEnc:e.persEnc||"utf8",entropy:e.entropy||o(this.hash.hmacStrength),entropyEnc:e.entropy&&e.entropyEnc||"utf8",nonce:this.n.toArray()});var r=this.n.byteLength();var a=this.n.sub(new i(2));do{var s=new i(t.generate(r));if(s.cmp(a)>0)continue;s.iaddn(1);return this.keyFromPrivate(s)}while(true)};EC.prototype._truncateToN=function truncateToN(e,t){var r=e.byteLength()*8-this.n.bitLength();if(r>0)e=e.ushrn(r);if(!t&&e.cmp(this.n)>=0)return e.sub(this.n);else return e};EC.prototype.sign=function sign(e,t,r,a){if(typeof r==="object"){a=r;r=null}if(!a)a={};t=this.keyFromPrivate(t,r);e=this._truncateToN(new i(e,16));var s=this.n.byteLength();var o=t.getPrivate().toArray("be",s);var h=e.toArray("be",s);var u=new n({hash:this.hash,entropy:o,nonce:h,pers:a.pers,persEnc:a.persEnc||"utf8"});var c=this.n.sub(new i(1));for(var l=0;true;l++){var p=a.k?a.k(l):new i(u.generate(this.n.byteLength()));p=this._truncateToN(p,true);if(p.cmpn(1)<=0||p.cmp(c)>=0)continue;var v=this.g.mul(p);if(v.isInfinity())continue;var b=v.getX();var m=b.umod(this.n);if(m.cmpn(0)===0)continue;var y=p.invm(this.n).mul(m.mul(t.getPrivate()).iadd(e));y=y.umod(this.n);if(y.cmpn(0)===0)continue;var g=(v.getY().isOdd()?1:0)|(b.cmp(m)!==0?2:0);if(a.canonical&&y.cmp(this.nh)>0){y=this.n.sub(y);g^=1}return new d({r:m,s:y,recoveryParam:g})}};EC.prototype.verify=function verify(e,t,r,n){e=this._truncateToN(new i(e,16));r=this.keyFromPublic(r,n);t=new d(t,"hex");var a=t.r;var s=t.s;if(a.cmpn(1)<0||a.cmp(this.n)>=0)return false;if(s.cmpn(1)<0||s.cmp(this.n)>=0)return false;var o=s.invm(this.n);var h=o.mul(e).umod(this.n);var u=o.mul(a).umod(this.n);if(!this.curve._maxwellTrick){var c=this.g.mulAdd(h,r.getPublic(),u);if(c.isInfinity())return false;return c.getX().umod(this.n).cmp(a)===0}var c=this.g.jmulAdd(h,r.getPublic(),u);if(c.isInfinity())return false;return c.eqXToP(a)};EC.prototype.recoverPubKey=function(e,t,r,n){h((3&r)===r,"The recovery param is more than two bits");t=new d(t,n);var a=this.n;var s=new i(e);var o=t.r;var u=t.s;var c=r&1;var l=r>>1;if(o.cmp(this.curve.p.umod(this.curve.n))>=0&&l)throw new Error("Unable to find sencond key candinate");if(l)o=this.curve.pointFromX(o.add(this.curve.n),c);else o=this.curve.pointFromX(o,c);var p=t.r.invm(a);var v=a.sub(s).mul(p).umod(a);var b=u.mul(p).umod(a);return this.g.mulAdd(v,o,b)};EC.prototype.getKeyRecoveryParam=function(e,t,r,i){t=new d(t,i);if(t.recoveryParam!==null)return t.recoveryParam;for(var n=0;n<4;n++){var a;try{a=this.recoverPubKey(e,t,n)}catch(e){continue}if(a.eq(r))return n}throw new Error("Unable to find valid recovery factor")}},4724:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;function KeyPair(e,t){this.ec=e;this.priv=null;this.pub=null;if(t.priv)this._importPrivate(t.priv,t.privEnc);if(t.pub)this._importPublic(t.pub,t.pubEnc)}e.exports=KeyPair;KeyPair.fromPublic=function fromPublic(e,t,r){if(t instanceof KeyPair)return t;return new KeyPair(e,{pub:t,pubEnc:r})};KeyPair.fromPrivate=function fromPrivate(e,t,r){if(t instanceof KeyPair)return t;return new KeyPair(e,{priv:t,privEnc:r})};KeyPair.prototype.validate=function validate(){var e=this.getPublic();if(e.isInfinity())return{result:false,reason:"Invalid public key"};if(!e.validate())return{result:false,reason:"Public key is not a point"};if(!e.mul(this.ec.curve.n).isInfinity())return{result:false,reason:"Public key * N != O"};return{result:true,reason:null}};KeyPair.prototype.getPublic=function getPublic(e,t){if(typeof e==="string"){t=e;e=null}if(!this.pub)this.pub=this.ec.g.mul(this.priv);if(!t)return this.pub;return this.pub.encode(t,e)};KeyPair.prototype.getPrivate=function getPrivate(e){if(e==="hex")return this.priv.toString(16,2);else return this.priv};KeyPair.prototype._importPrivate=function _importPrivate(e,t){this.priv=new i(e,t||16);this.priv=this.priv.umod(this.ec.curve.n)};KeyPair.prototype._importPublic=function _importPublic(e,t){if(e.x||e.y){if(this.ec.curve.type==="mont"){a(e.x,"Need x coordinate")}else if(this.ec.curve.type==="short"||this.ec.curve.type==="edwards"){a(e.x&&e.y,"Need both x and y coordinate")}this.pub=this.ec.curve.point(e.x,e.y);return}this.pub=this.ec.curve.decodePoint(e,t)};KeyPair.prototype.derive=function derive(e){return e.mul(this.priv).getX()};KeyPair.prototype.sign=function sign(e,t,r){return this.ec.sign(e,this,t,r)};KeyPair.prototype.verify=function verify(e,t){return this.ec.verify(e,t,this)};KeyPair.prototype.inspect=function inspect(){return"<Key priv: "+(this.priv&&this.priv.toString(16,2))+" pub: "+(this.pub&&this.pub.inspect())+" >"}},7526:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;function Signature(e,t){if(e instanceof Signature)return e;if(this._importDER(e,t))return;a(e.r&&e.s,"Signature without r or s");this.r=new i(e.r,16);this.s=new i(e.s,16);if(e.recoveryParam===undefined)this.recoveryParam=null;else this.recoveryParam=e.recoveryParam}e.exports=Signature;function Position(){this.place=0}function getLength(e,t){var r=e[t.place++];if(!(r&128)){return r}var i=r&15;if(i===0||i>4){return false}var n=0;for(var a=0,s=t.place;a<i;a++,s++){n<<=8;n|=e[s];n>>>=0}if(n<=127){return false}t.place=s;return n}function rmPadding(e){var t=0;var r=e.length-1;while(!e[t]&&!(e[t+1]&128)&&t<r){t++}if(t===0){return e}return e.slice(t)}Signature.prototype._importDER=function _importDER(e,t){e=n.toArray(e,t);var r=new Position;if(e[r.place++]!==48){return false}var a=getLength(e,r);if(a===false){return false}if(a+r.place!==e.length){return false}if(e[r.place++]!==2){return false}var s=getLength(e,r);if(s===false){return false}var o=e.slice(r.place,s+r.place);r.place+=s;if(e[r.place++]!==2){return false}var h=getLength(e,r);if(h===false){return false}if(e.length!==h+r.place){return false}var u=e.slice(r.place,h+r.place);if(o[0]===0){if(o[1]&128){o=o.slice(1)}else{return false}}if(u[0]===0){if(u[1]&128){u=u.slice(1)}else{return false}}this.r=new i(o);this.s=new i(u);this.recoveryParam=null;return true};function constructLength(e,t){if(t<128){e.push(t);return}var r=1+(Math.log(t)/Math.LN2>>>3);e.push(r|128);while(--r){e.push(t>>>(r<<3)&255)}e.push(t)}Signature.prototype.toDER=function toDER(e){var t=this.r.toArray();var r=this.s.toArray();if(t[0]&128)t=[0].concat(t);if(r[0]&128)r=[0].concat(r);t=rmPadding(t);r=rmPadding(r);while(!r[0]&&!(r[1]&128)){r=r.slice(1)}var i=[2];constructLength(i,t.length);i=i.concat(t);i.push(2);constructLength(i,r.length);var a=i.concat(r);var s=[48];constructLength(s,a.length);s=s.concat(a);return n.encode(s,e)}},8511:function(e,t,r){"use strict";var i=r(7028);var n=r(6226);var a=r(4401);var s=a.assert;var o=a.parseBytes;var h=r(9917);var u=r(9314);function EDDSA(e){s(e==="ed25519","only tested with ed25519 so far");if(!(this instanceof EDDSA))return new EDDSA(e);var e=n[e].curve;this.curve=e;this.g=e.g;this.g.precompute(e.n.bitLength()+1);this.pointClass=e.point().constructor;this.encodingLength=Math.ceil(e.n.bitLength()/8);this.hash=i.sha512}e.exports=EDDSA;EDDSA.prototype.sign=function sign(e,t){e=o(e);var r=this.keyFromSecret(t);var i=this.hashInt(r.messagePrefix(),e);var n=this.g.mul(i);var a=this.encodePoint(n);var s=this.hashInt(a,r.pubBytes(),e).mul(r.priv());var h=i.add(s).umod(this.curve.n);return this.makeSignature({R:n,S:h,Rencoded:a})};EDDSA.prototype.verify=function verify(e,t,r){e=o(e);t=this.makeSignature(t);var i=this.keyFromPublic(r);var n=this.hashInt(t.Rencoded(),i.pubBytes(),e);var a=this.g.mul(t.S());var s=t.R().add(i.pub().mul(n));return s.eq(a)};EDDSA.prototype.hashInt=function hashInt(){var e=this.hash();for(var t=0;t<arguments.length;t++)e.update(arguments[t]);return a.intFromLE(e.digest()).umod(this.curve.n)};EDDSA.prototype.keyFromPublic=function keyFromPublic(e){return h.fromPublic(this,e)};EDDSA.prototype.keyFromSecret=function keyFromSecret(e){return h.fromSecret(this,e)};EDDSA.prototype.makeSignature=function makeSignature(e){if(e instanceof u)return e;return new u(this,e)};EDDSA.prototype.encodePoint=function encodePoint(e){var t=e.getY().toArray("le",this.encodingLength);t[this.encodingLength-1]|=e.getX().isOdd()?128:0;return t};EDDSA.prototype.decodePoint=function decodePoint(e){e=a.parseBytes(e);var t=e.length-1;var r=e.slice(0,t).concat(e[t]&~128);var i=(e[t]&128)!==0;var n=a.intFromLE(r);return this.curve.pointFromY(n,i)};EDDSA.prototype.encodeInt=function encodeInt(e){return e.toArray("le",this.encodingLength)};EDDSA.prototype.decodeInt=function decodeInt(e){return a.intFromLE(e)};EDDSA.prototype.isPoint=function isPoint(e){return e instanceof this.pointClass}},9917:function(e,t,r){"use strict";var i=r(4401);var n=i.assert;var a=i.parseBytes;var s=i.cachedProperty;function KeyPair(e,t){this.eddsa=e;this._secret=a(t.secret);if(e.isPoint(t.pub))this._pub=t.pub;else this._pubBytes=a(t.pub)}KeyPair.fromPublic=function fromPublic(e,t){if(t instanceof KeyPair)return t;return new KeyPair(e,{pub:t})};KeyPair.fromSecret=function fromSecret(e,t){if(t instanceof KeyPair)return t;return new KeyPair(e,{secret:t})};KeyPair.prototype.secret=function secret(){return this._secret};s(KeyPair,"pubBytes",(function pubBytes(){return this.eddsa.encodePoint(this.pub())}));s(KeyPair,"pub",(function pub(){if(this._pubBytes)return this.eddsa.decodePoint(this._pubBytes);return this.eddsa.g.mul(this.priv())}));s(KeyPair,"privBytes",(function privBytes(){var e=this.eddsa;var t=this.hash();var r=e.encodingLength-1;var i=t.slice(0,e.encodingLength);i[0]&=248;i[r]&=127;i[r]|=64;return i}));s(KeyPair,"priv",(function priv(){return this.eddsa.decodeInt(this.privBytes())}));s(KeyPair,"hash",(function hash(){return this.eddsa.hash().update(this.secret()).digest()}));s(KeyPair,"messagePrefix",(function messagePrefix(){return this.hash().slice(this.eddsa.encodingLength)}));KeyPair.prototype.sign=function sign(e){n(this._secret,"KeyPair can only verify");return this.eddsa.sign(e,this)};KeyPair.prototype.verify=function verify(e,t){return this.eddsa.verify(e,t,this)};KeyPair.prototype.getSecret=function getSecret(e){n(this._secret,"KeyPair is public only");return i.encode(this.secret(),e)};KeyPair.prototype.getPublic=function getPublic(e){return i.encode(this.pubBytes(),e)};e.exports=KeyPair},9314:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;var s=n.cachedProperty;var o=n.parseBytes;function Signature(e,t){this.eddsa=e;if(typeof t!=="object")t=o(t);if(Array.isArray(t)){t={R:t.slice(0,e.encodingLength),S:t.slice(e.encodingLength)}}a(t.R&&t.S,"Signature without R or S");if(e.isPoint(t.R))this._R=t.R;if(t.S instanceof i)this._S=t.S;this._Rencoded=Array.isArray(t.R)?t.R:t.Rencoded;this._Sencoded=Array.isArray(t.S)?t.S:t.Sencoded}s(Signature,"S",(function S(){return this.eddsa.decodeInt(this.Sencoded())}));s(Signature,"R",(function R(){return this.eddsa.decodePoint(this.Rencoded())}));s(Signature,"Rencoded",(function Rencoded(){return this.eddsa.encodePoint(this.R())}));s(Signature,"Sencoded",(function Sencoded(){return this.eddsa.encodeInt(this.S())}));Signature.prototype.toBytes=function toBytes(){return this.Rencoded().concat(this.Sencoded())};Signature.prototype.toHex=function toHex(){return n.encode(this.toBytes(),"hex").toUpperCase()};e.exports=Signature},9702:function(e){e.exports={doubles:{step:4,points:[["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a","f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"],["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508","11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"],["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739","d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"],["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640","4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"],["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c","4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"],["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda","96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"],["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa","5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"],["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0","cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"],["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d","9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"],["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d","e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"],["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1","9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"],["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0","5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"],["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047","10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"],["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862","283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"],["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7","7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"],["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd","56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"],["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83","7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"],["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a","53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"],["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8","bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"],["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d","4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"],["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725","7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"],["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754","4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"],["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c","17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"],["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6","6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"],["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39","c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"],["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891","893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"],["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b","febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"],["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03","2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"],["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d","eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"],["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070","7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"],["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4","e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"],["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da","662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"],["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11","1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"],["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e","efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"],["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41","2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"],["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef","67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"],["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8","db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"],["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d","648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"],["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96","35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"],["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd","ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"],["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5","9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"],["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266","40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"],["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71","34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"],["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac","c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"],["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751","1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"],["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e","493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"],["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241","c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"],["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3","be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"],["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f","4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"],["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19","aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"],["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be","b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"],["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9","6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"],["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2","8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"],["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13","7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"],["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c","ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"],["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba","2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"],["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151","e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"],["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073","d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"],["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458","38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"],["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b","69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"],["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366","d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"],["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa","40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"],["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0","620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"],["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787","7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"],["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e","ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]},naf:{wnd:7,points:[["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9","388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"],["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4","d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"],["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc","6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"],["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe","cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"],["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb","d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"],["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8","ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"],["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e","581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"],["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34","4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"],["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c","85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"],["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5","321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"],["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f","2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"],["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714","73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"],["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729","a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"],["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db","2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"],["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4","e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"],["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5","b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"],["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479","2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"],["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d","80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"],["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f","1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"],["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb","d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"],["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9","eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"],["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963","758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"],["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74","958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"],["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530","e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"],["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b","5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"],["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247","cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"],["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1","cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"],["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120","4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"],["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435","91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"],["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18","673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"],["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8","59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"],["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb","3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"],["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f","55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"],["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143","efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"],["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba","e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"],["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45","f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"],["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a","744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"],["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e","c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"],["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8","e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"],["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c","30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"],["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519","e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"],["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab","100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"],["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca","ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"],["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf","8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"],["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610","68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"],["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4","f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"],["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c","d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"],["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940","edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"],["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980","a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"],["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3","66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"],["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf","9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"],["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63","4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"],["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448","fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"],["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf","5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"],["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5","8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"],["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6","8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"],["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5","5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"],["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99","f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"],["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51","f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"],["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5","42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"],["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5","204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"],["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997","4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"],["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881","73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"],["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5","39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"],["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66","d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"],["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726","ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"],["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede","6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"],["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94","60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"],["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31","3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"],["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51","b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"],["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252","ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"],["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5","cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"],["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b","6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"],["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4","322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"],["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f","6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"],["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889","2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"],["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246","b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"],["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984","998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"],["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a","b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"],["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030","bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"],["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197","6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"],["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593","c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"],["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef","21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"],["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38","60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"],["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a","49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"],["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111","5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"],["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502","7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"],["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea","be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"],["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26","8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"],["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986","39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"],["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e","62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"],["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4","25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"],["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda","ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"],["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859","cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"],["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f","f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"],["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c","6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"],["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942","fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"],["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a","1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"],["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80","5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"],["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d","438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"],["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1","cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"],["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63","c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"],["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352","6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"],["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193","ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"],["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00","9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"],["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58","ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"],["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7","d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"],["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8","c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"],["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e","67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"],["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d","cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"],["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b","299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"],["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f","f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"],["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6","462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"],["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297","62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"],["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a","7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"],["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c","ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"],["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52","4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"],["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb","bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"],["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065","bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"],["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917","603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"],["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9","cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"],["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3","553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"],["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57","712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"],["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66","ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"],["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8","9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"],["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721","9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"],["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180","4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]}}},4401:function(e,t,r){"use strict";var i=t;var n=r(711);var a=r(3523);var s=r(6545);i.assert=a;i.toArray=s.toArray;i.zero2=s.zero2;i.toHex=s.toHex;i.encode=s.encode;function getNAF(e,t,r){var i=new Array(Math.max(e.bitLength(),r)+1);i.fill(0);var n=1<<t+1;var a=e.clone();for(var s=0;s<i.length;s++){var o;var h=a.andln(n-1);if(a.isOdd()){if(h>(n>>1)-1)o=(n>>1)-h;else o=h;a.isubn(o)}else{o=0}i[s]=o;a.iushrn(1)}return i}i.getNAF=getNAF;function getJSF(e,t){var r=[[],[]];e=e.clone();t=t.clone();var i=0;var n=0;while(e.cmpn(-i)>0||t.cmpn(-n)>0){var a=e.andln(3)+i&3;var s=t.andln(3)+n&3;if(a===3)a=-1;if(s===3)s=-1;var o;if((a&1)===0){o=0}else{var h=e.andln(7)+i&7;if((h===3||h===5)&&s===2)o=-a;else o=a}r[0].push(o);var u;if((s&1)===0){u=0}else{var h=t.andln(7)+n&7;if((h===3||h===5)&&a===2)u=-s;else u=s}r[1].push(u);if(2*i===o+1)i=1-i;if(2*n===u+1)n=1-n;e.iushrn(1);t.iushrn(1)}return r}i.getJSF=getJSF;function cachedProperty(e,t,r){var i="_"+t;e.prototype[t]=function cachedProperty(){return this[i]!==undefined?this[i]:this[i]=r.call(this)}}i.cachedProperty=cachedProperty;function parseBytes(e){return typeof e==="string"?i.toArray(e,"hex"):e}i.parseBytes=parseBytes;function intFromLE(e){return new n(e,"hex","le")}i.intFromLE=intFromLE},8368:function(e,t,r){var i=r(5055).Buffer;var n=r(3533);function EVP_BytesToKey(e,t,r,a){if(!i.isBuffer(e))e=i.from(e,"binary");if(t){if(!i.isBuffer(t))t=i.from(t,"binary");if(t.length!==8)throw new RangeError("salt should be Buffer with 8 byte length")}var s=r/8;var o=i.alloc(s);var h=i.alloc(a||0);var u=i.alloc(0);while(s>0||a>0){var d=new n;d.update(u);d.update(e);if(t)d.update(t);u=d.digest();var c=0;if(s>0){var l=o.length-s;c=Math.min(s,u.length);u.copy(o,l,0,c);s-=c}if(c<u.length&&a>0){var p=h.length-a;var v=Math.min(a,u.length-c);u.copy(h,p,c,c+v);a-=v}}u.fill(0);return{key:o,iv:h}}e.exports=EVP_BytesToKey},9029:function(e,t,r){"use strict";var i=r(5055).Buffer;var n=r(3726).Transform;var a=r(3782);function throwIfNotStringOrBuffer(e,t){if(!i.isBuffer(e)&&typeof e!=="string"){throw new TypeError(t+" must be a string or a buffer")}}function HashBase(e){n.call(this);this._block=i.allocUnsafe(e);this._blockSize=e;this._blockOffset=0;this._length=[0,0,0,0];this._finalized=false}a(HashBase,n);HashBase.prototype._transform=function(e,t,r){var i=null;try{this.update(e,t)}catch(e){i=e}r(i)};HashBase.prototype._flush=function(e){var t=null;try{this.push(this.digest())}catch(e){t=e}e(t)};HashBase.prototype.update=function(e,t){throwIfNotStringOrBuffer(e,"Data");if(this._finalized)throw new Error("Digest already called");if(!i.isBuffer(e))e=i.from(e,t);var r=this._block;var n=0;while(this._blockOffset+e.length-n>=this._blockSize){for(var a=this._blockOffset;a<this._blockSize;)r[a++]=e[n++];this._update();this._blockOffset=0}while(n<e.length)r[this._blockOffset++]=e[n++];for(var s=0,o=e.length*8;o>0;++s){this._length[s]+=o;o=this._length[s]/4294967296|0;if(o>0)this._length[s]-=4294967296*o}return this};HashBase.prototype._update=function(){throw new Error("_update is not implemented")};HashBase.prototype.digest=function(e){if(this._finalized)throw new Error("Digest already called");this._finalized=true;var t=this._digest();if(e!==undefined)t=t.toString(e);this._block.fill(0);this._blockOffset=0;for(var r=0;r<4;++r)this._length[r]=0;return t};HashBase.prototype._digest=function(){throw new Error("_digest is not implemented")};e.exports=HashBase},7028:function(e,t,r){var i=t;i.utils=r(263);i.common=r(1330);i.sha=r(301);i.ripemd=r(3079);i.hmac=r(3092);i.sha1=i.sha.sha1;i.sha256=i.sha.sha256;i.sha224=i.sha.sha224;i.sha384=i.sha.sha384;i.sha512=i.sha.sha512;i.ripemd160=i.ripemd.ripemd160},1330:function(e,t,r){"use strict";var i=r(263);var n=r(3523);function BlockHash(){this.pending=null;this.pendingTotal=0;this.blockSize=this.constructor.blockSize;this.outSize=this.constructor.outSize;this.hmacStrength=this.constructor.hmacStrength;this.padLength=this.constructor.padLength/8;this.endian="big";this._delta8=this.blockSize/8;this._delta32=this.blockSize/32}t.BlockHash=BlockHash;BlockHash.prototype.update=function update(e,t){e=i.toArray(e,t);if(!this.pending)this.pending=e;else this.pending=this.pending.concat(e);this.pendingTotal+=e.length;if(this.pending.length>=this._delta8){e=this.pending;var r=e.length%this._delta8;this.pending=e.slice(e.length-r,e.length);if(this.pending.length===0)this.pending=null;e=i.join32(e,0,e.length-r,this.endian);for(var n=0;n<e.length;n+=this._delta32)this._update(e,n,n+this._delta32)}return this};BlockHash.prototype.digest=function digest(e){this.update(this._pad());n(this.pending===null);return this._digest(e)};BlockHash.prototype._pad=function pad(){var e=this.pendingTotal;var t=this._delta8;var r=t-(e+this.padLength)%t;var i=new Array(r+this.padLength);i[0]=128;for(var n=1;n<r;n++)i[n]=0;e<<=3;if(this.endian==="big"){for(var a=8;a<this.padLength;a++)i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=e>>>24&255;i[n++]=e>>>16&255;i[n++]=e>>>8&255;i[n++]=e&255}else{i[n++]=e&255;i[n++]=e>>>8&255;i[n++]=e>>>16&255;i[n++]=e>>>24&255;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;for(a=8;a<this.padLength;a++)i[n++]=0}return i}},3092:function(e,t,r){"use strict";var i=r(263);var n=r(3523);function Hmac(e,t,r){if(!(this instanceof Hmac))return new Hmac(e,t,r);this.Hash=e;this.blockSize=e.blockSize/8;this.outSize=e.outSize/8;this.inner=null;this.outer=null;this._init(i.toArray(t,r))}e.exports=Hmac;Hmac.prototype._init=function init(e){if(e.length>this.blockSize)e=(new this.Hash).update(e).digest();n(e.length<=this.blockSize);for(var t=e.length;t<this.blockSize;t++)e.push(0);for(t=0;t<e.length;t++)e[t]^=54;this.inner=(new this.Hash).update(e);for(t=0;t<e.length;t++)e[t]^=106;this.outer=(new this.Hash).update(e)};Hmac.prototype.update=function update(e,t){this.inner.update(e,t);return this};Hmac.prototype.digest=function digest(e){this.outer.update(this.inner.digest());return this.outer.digest(e)}},3079:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=i.rotl32;var s=i.sum32;var o=i.sum32_3;var h=i.sum32_4;var u=n.BlockHash;function RIPEMD160(){if(!(this instanceof RIPEMD160))return new RIPEMD160;u.call(this);this.h=[1732584193,4023233417,2562383102,271733878,3285377520];this.endian="little"}i.inherits(RIPEMD160,u);t.ripemd160=RIPEMD160;RIPEMD160.blockSize=512;RIPEMD160.outSize=160;RIPEMD160.hmacStrength=192;RIPEMD160.padLength=64;RIPEMD160.prototype._update=function update(e,t){var r=this.h[0];var i=this.h[1];var n=this.h[2];var u=this.h[3];var v=this.h[4];var b=r;var m=i;var y=n;var g=u;var _=v;for(var w=0;w<80;w++){var M=s(a(h(r,f(w,i,n,u),e[d[w]+t],K(w)),l[w]),v);r=v;v=u;u=a(n,10);n=i;i=M;M=s(a(h(b,f(79-w,m,y,g),e[c[w]+t],Kh(w)),p[w]),_);b=_;_=g;g=a(y,10);y=m;m=M}M=o(this.h[1],n,g);this.h[1]=o(this.h[2],u,_);this.h[2]=o(this.h[3],v,b);this.h[3]=o(this.h[4],r,m);this.h[4]=o(this.h[0],i,y);this.h[0]=M};RIPEMD160.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"little");else return i.split32(this.h,"little")};function f(e,t,r,i){if(e<=15)return t^r^i;else if(e<=31)return t&r|~t&i;else if(e<=47)return(t|~r)^i;else if(e<=63)return t&i|r&~i;else return t^(r|~i)}function K(e){if(e<=15)return 0;else if(e<=31)return 1518500249;else if(e<=47)return 1859775393;else if(e<=63)return 2400959708;else return 2840853838}function Kh(e){if(e<=15)return 1352829926;else if(e<=31)return 1548603684;else if(e<=47)return 1836072691;else if(e<=63)return 2053994217;else return 0}var d=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13];var c=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11];var l=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6];var p=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11]},301:function(e,t,r){"use strict";t.sha1=r(2742);t.sha224=r(7105);t.sha256=r(1525);t.sha384=r(9948);t.sha512=r(1319)},2742:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(2975);var s=i.rotl32;var o=i.sum32;var h=i.sum32_5;var u=a.ft_1;var d=n.BlockHash;var c=[1518500249,1859775393,2400959708,3395469782];function SHA1(){if(!(this instanceof SHA1))return new SHA1;d.call(this);this.h=[1732584193,4023233417,2562383102,271733878,3285377520];this.W=new Array(80)}i.inherits(SHA1,d);e.exports=SHA1;SHA1.blockSize=512;SHA1.outSize=160;SHA1.hmacStrength=80;SHA1.padLength=64;SHA1.prototype._update=function _update(e,t){var r=this.W;for(var i=0;i<16;i++)r[i]=e[t+i];for(;i<r.length;i++)r[i]=s(r[i-3]^r[i-8]^r[i-14]^r[i-16],1);var n=this.h[0];var a=this.h[1];var d=this.h[2];var l=this.h[3];var p=this.h[4];for(i=0;i<r.length;i++){var v=~~(i/20);var b=h(s(n,5),u(v,a,d,l),p,r[i],c[v]);p=l;l=d;d=s(a,30);a=n;n=b}this.h[0]=o(this.h[0],n);this.h[1]=o(this.h[1],a);this.h[2]=o(this.h[2],d);this.h[3]=o(this.h[3],l);this.h[4]=o(this.h[4],p)};SHA1.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")}},7105:function(e,t,r){"use strict";var i=r(263);var n=r(1525);function SHA224(){if(!(this instanceof SHA224))return new SHA224;n.call(this);this.h=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428]}i.inherits(SHA224,n);e.exports=SHA224;SHA224.blockSize=512;SHA224.outSize=224;SHA224.hmacStrength=192;SHA224.padLength=64;SHA224.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h.slice(0,7),"big");else return i.split32(this.h.slice(0,7),"big")}},1525:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(2975);var s=r(3523);var o=i.sum32;var h=i.sum32_4;var u=i.sum32_5;var d=a.ch32;var c=a.maj32;var l=a.s0_256;var p=a.s1_256;var v=a.g0_256;var b=a.g1_256;var m=n.BlockHash;var y=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function SHA256(){if(!(this instanceof SHA256))return new SHA256;m.call(this);this.h=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];this.k=y;this.W=new Array(64)}i.inherits(SHA256,m);e.exports=SHA256;SHA256.blockSize=512;SHA256.outSize=256;SHA256.hmacStrength=192;SHA256.padLength=64;SHA256.prototype._update=function _update(e,t){var r=this.W;for(var i=0;i<16;i++)r[i]=e[t+i];for(;i<r.length;i++)r[i]=h(b(r[i-2]),r[i-7],v(r[i-15]),r[i-16]);var n=this.h[0];var a=this.h[1];var m=this.h[2];var y=this.h[3];var g=this.h[4];var _=this.h[5];var w=this.h[6];var M=this.h[7];s(this.k.length===r.length);for(i=0;i<r.length;i++){var B=u(M,p(g),d(g,_,w),this.k[i],r[i]);var E=o(l(n),c(n,a,m));M=w;w=_;_=g;g=o(y,B);y=m;m=a;a=n;n=o(B,E)}this.h[0]=o(this.h[0],n);this.h[1]=o(this.h[1],a);this.h[2]=o(this.h[2],m);this.h[3]=o(this.h[3],y);this.h[4]=o(this.h[4],g);this.h[5]=o(this.h[5],_);this.h[6]=o(this.h[6],w);this.h[7]=o(this.h[7],M)};SHA256.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")}},9948:function(e,t,r){"use strict";var i=r(263);var n=r(1319);function SHA384(){if(!(this instanceof SHA384))return new SHA384;n.call(this);this.h=[3418070365,3238371032,1654270250,914150663,2438529370,812702999,355462360,4144912697,1731405415,4290775857,2394180231,1750603025,3675008525,1694076839,1203062813,3204075428]}i.inherits(SHA384,n);e.exports=SHA384;SHA384.blockSize=1024;SHA384.outSize=384;SHA384.hmacStrength=192;SHA384.padLength=128;SHA384.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h.slice(0,12),"big");else return i.split32(this.h.slice(0,12),"big")}},1319:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(3523);var s=i.rotr64_hi;var o=i.rotr64_lo;var h=i.shr64_hi;var u=i.shr64_lo;var d=i.sum64;var c=i.sum64_hi;var l=i.sum64_lo;var p=i.sum64_4_hi;var v=i.sum64_4_lo;var b=i.sum64_5_hi;var m=i.sum64_5_lo;var y=n.BlockHash;var g=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];function SHA512(){if(!(this instanceof SHA512))return new SHA512;y.call(this);this.h=[1779033703,4089235720,3144134277,2227873595,1013904242,4271175723,2773480762,1595750129,1359893119,2917565137,2600822924,725511199,528734635,4215389547,1541459225,327033209];this.k=g;this.W=new Array(160)}i.inherits(SHA512,y);e.exports=SHA512;SHA512.blockSize=1024;SHA512.outSize=512;SHA512.hmacStrength=192;SHA512.padLength=128;SHA512.prototype._prepareBlock=function _prepareBlock(e,t){var r=this.W;for(var i=0;i<32;i++)r[i]=e[t+i];for(;i<r.length;i+=2){var n=g1_512_hi(r[i-4],r[i-3]);var a=g1_512_lo(r[i-4],r[i-3]);var s=r[i-14];var o=r[i-13];var h=g0_512_hi(r[i-30],r[i-29]);var u=g0_512_lo(r[i-30],r[i-29]);var d=r[i-32];var c=r[i-31];r[i]=p(n,a,s,o,h,u,d,c);r[i+1]=v(n,a,s,o,h,u,d,c)}};SHA512.prototype._update=function _update(e,t){this._prepareBlock(e,t);var r=this.W;var i=this.h[0];var n=this.h[1];var s=this.h[2];var o=this.h[3];var h=this.h[4];var u=this.h[5];var p=this.h[6];var v=this.h[7];var y=this.h[8];var g=this.h[9];var _=this.h[10];var w=this.h[11];var M=this.h[12];var B=this.h[13];var E=this.h[14];var k=this.h[15];a(this.k.length===r.length);for(var A=0;A<r.length;A+=2){var N=E;var P=k;var x=s1_512_hi(y,g);var I=s1_512_lo(y,g);var C=ch64_hi(y,g,_,w,M,B);var D=ch64_lo(y,g,_,w,M,B);var T=this.k[A];var j=this.k[A+1];var q=r[A];var O=r[A+1];var H=b(N,P,x,I,C,D,T,j,q,O);var L=m(N,P,x,I,C,D,T,j,q,O);N=s0_512_hi(i,n);P=s0_512_lo(i,n);x=maj64_hi(i,n,s,o,h,u);I=maj64_lo(i,n,s,o,h,u);var z=c(N,P,x,I);var F=l(N,P,x,I);E=M;k=B;M=_;B=w;_=y;w=g;y=c(p,v,H,L);g=l(v,v,H,L);p=h;v=u;h=s;u=o;s=i;o=n;i=c(H,L,z,F);n=l(H,L,z,F)}d(this.h,0,i,n);d(this.h,2,s,o);d(this.h,4,h,u);d(this.h,6,p,v);d(this.h,8,y,g);d(this.h,10,_,w);d(this.h,12,M,B);d(this.h,14,E,k)};SHA512.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")};function ch64_hi(e,t,r,i,n){var a=e&r^~e&n;if(a<0)a+=4294967296;return a}function ch64_lo(e,t,r,i,n,a){var s=t&i^~t&a;if(s<0)s+=4294967296;return s}function maj64_hi(e,t,r,i,n){var a=e&r^e&n^r&n;if(a<0)a+=4294967296;return a}function maj64_lo(e,t,r,i,n,a){var s=t&i^t&a^i&a;if(s<0)s+=4294967296;return s}function s0_512_hi(e,t){var r=s(e,t,28);var i=s(t,e,2);var n=s(t,e,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function s0_512_lo(e,t){var r=o(e,t,28);var i=o(t,e,2);var n=o(t,e,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function s1_512_hi(e,t){var r=s(e,t,14);var i=s(e,t,18);var n=s(t,e,9);var a=r^i^n;if(a<0)a+=4294967296;return a}function s1_512_lo(e,t){var r=o(e,t,14);var i=o(e,t,18);var n=o(t,e,9);var a=r^i^n;if(a<0)a+=4294967296;return a}function g0_512_hi(e,t){var r=s(e,t,1);var i=s(e,t,8);var n=h(e,t,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function g0_512_lo(e,t){var r=o(e,t,1);var i=o(e,t,8);var n=u(e,t,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function g1_512_hi(e,t){var r=s(e,t,19);var i=s(t,e,29);var n=h(e,t,6);var a=r^i^n;if(a<0)a+=4294967296;return a}function g1_512_lo(e,t){var r=o(e,t,19);var i=o(t,e,29);var n=u(e,t,6);var a=r^i^n;if(a<0)a+=4294967296;return a}},2975:function(e,t,r){"use strict";var i=r(263);var n=i.rotr32;function ft_1(e,t,r,i){if(e===0)return ch32(t,r,i);if(e===1||e===3)return p32(t,r,i);if(e===2)return maj32(t,r,i)}t.ft_1=ft_1;function ch32(e,t,r){return e&t^~e&r}t.ch32=ch32;function maj32(e,t,r){return e&t^e&r^t&r}t.maj32=maj32;function p32(e,t,r){return e^t^r}t.p32=p32;function s0_256(e){return n(e,2)^n(e,13)^n(e,22)}t.s0_256=s0_256;function s1_256(e){return n(e,6)^n(e,11)^n(e,25)}t.s1_256=s1_256;function g0_256(e){return n(e,7)^n(e,18)^e>>>3}t.g0_256=g0_256;function g1_256(e){return n(e,17)^n(e,19)^e>>>10}t.g1_256=g1_256},263:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);t.inherits=n;function isSurrogatePair(e,t){if((e.charCodeAt(t)&64512)!==55296){return false}if(t<0||t+1>=e.length){return false}return(e.charCodeAt(t+1)&64512)===56320}function toArray(e,t){if(Array.isArray(e))return e.slice();if(!e)return[];var r=[];if(typeof e==="string"){if(!t){var i=0;for(var n=0;n<e.length;n++){var a=e.charCodeAt(n);if(a<128){r[i++]=a}else if(a<2048){r[i++]=a>>6|192;r[i++]=a&63|128}else if(isSurrogatePair(e,n)){a=65536+((a&1023)<<10)+(e.charCodeAt(++n)&1023);r[i++]=a>>18|240;r[i++]=a>>12&63|128;r[i++]=a>>6&63|128;r[i++]=a&63|128}else{r[i++]=a>>12|224;r[i++]=a>>6&63|128;r[i++]=a&63|128}}}else if(t==="hex"){e=e.replace(/[^a-z0-9]+/gi,"");if(e.length%2!==0)e="0"+e;for(n=0;n<e.length;n+=2)r.push(parseInt(e[n]+e[n+1],16))}}else{for(n=0;n<e.length;n++)r[n]=e[n]|0}return r}t.toArray=toArray;function toHex(e){var t="";for(var r=0;r<e.length;r++)t+=zero2(e[r].toString(16));return t}t.toHex=toHex;function htonl(e){var t=e>>>24|e>>>8&65280|e<<8&16711680|(e&255)<<24;return t>>>0}t.htonl=htonl;function toHex32(e,t){var r="";for(var i=0;i<e.length;i++){var n=e[i];if(t==="little")n=htonl(n);r+=zero8(n.toString(16))}return r}t.toHex32=toHex32;function zero2(e){if(e.length===1)return"0"+e;else return e}t.zero2=zero2;function zero8(e){if(e.length===7)return"0"+e;else if(e.length===6)return"00"+e;else if(e.length===5)return"000"+e;else if(e.length===4)return"0000"+e;else if(e.length===3)return"00000"+e;else if(e.length===2)return"000000"+e;else if(e.length===1)return"0000000"+e;else return e}t.zero8=zero8;function join32(e,t,r,n){var a=r-t;i(a%4===0);var s=new Array(a/4);for(var o=0,h=t;o<s.length;o++,h+=4){var u;if(n==="big")u=e[h]<<24|e[h+1]<<16|e[h+2]<<8|e[h+3];else u=e[h+3]<<24|e[h+2]<<16|e[h+1]<<8|e[h];s[o]=u>>>0}return s}t.join32=join32;function split32(e,t){var r=new Array(e.length*4);for(var i=0,n=0;i<e.length;i++,n+=4){var a=e[i];if(t==="big"){r[n]=a>>>24;r[n+1]=a>>>16&255;r[n+2]=a>>>8&255;r[n+3]=a&255}else{r[n+3]=a>>>24;r[n+2]=a>>>16&255;r[n+1]=a>>>8&255;r[n]=a&255}}return r}t.split32=split32;function rotr32(e,t){return e>>>t|e<<32-t}t.rotr32=rotr32;function rotl32(e,t){return e<<t|e>>>32-t}t.rotl32=rotl32;function sum32(e,t){return e+t>>>0}t.sum32=sum32;function sum32_3(e,t,r){return e+t+r>>>0}t.sum32_3=sum32_3;function sum32_4(e,t,r,i){return e+t+r+i>>>0}t.sum32_4=sum32_4;function sum32_5(e,t,r,i,n){return e+t+r+i+n>>>0}t.sum32_5=sum32_5;function sum64(e,t,r,i){var n=e[t];var a=e[t+1];var s=i+a>>>0;var o=(s<i?1:0)+r+n;e[t]=o>>>0;e[t+1]=s}t.sum64=sum64;function sum64_hi(e,t,r,i){var n=t+i>>>0;var a=(n<t?1:0)+e+r;return a>>>0}t.sum64_hi=sum64_hi;function sum64_lo(e,t,r,i){var n=t+i;return n>>>0}t.sum64_lo=sum64_lo;function sum64_4_hi(e,t,r,i,n,a,s,o){var h=0;var u=t;u=u+i>>>0;h+=u<t?1:0;u=u+a>>>0;h+=u<a?1:0;u=u+o>>>0;h+=u<o?1:0;var d=e+r+n+s+h;return d>>>0}t.sum64_4_hi=sum64_4_hi;function sum64_4_lo(e,t,r,i,n,a,s,o){var h=t+i+a+o;return h>>>0}t.sum64_4_lo=sum64_4_lo;function sum64_5_hi(e,t,r,i,n,a,s,o,h,u){var d=0;var c=t;c=c+i>>>0;d+=c<t?1:0;c=c+a>>>0;d+=c<a?1:0;c=c+o>>>0;d+=c<o?1:0;c=c+u>>>0;d+=c<u?1:0;var l=e+r+n+s+h+d;return l>>>0}t.sum64_5_hi=sum64_5_hi;function sum64_5_lo(e,t,r,i,n,a,s,o,h,u){var d=t+i+a+o+u;return d>>>0}t.sum64_5_lo=sum64_5_lo;function rotr64_hi(e,t,r){var i=t<<32-r|e>>>r;return i>>>0}t.rotr64_hi=rotr64_hi;function rotr64_lo(e,t,r){var i=e<<32-r|t>>>r;return i>>>0}t.rotr64_lo=rotr64_lo;function shr64_hi(e,t,r){return e>>>r}t.shr64_hi=shr64_hi;function shr64_lo(e,t,r){var i=e<<32-r|t>>>r;return i>>>0}t.shr64_lo=shr64_lo},4910:function(e,t,r){"use strict";var i=r(7028);var n=r(6545);var a=r(3523);function HmacDRBG(e){if(!(this instanceof HmacDRBG))return new HmacDRBG(e);this.hash=e.hash;this.predResist=!!e.predResist;this.outLen=this.hash.outSize;this.minEntropy=e.minEntropy||this.hash.hmacStrength;this._reseed=null;this.reseedInterval=null;this.K=null;this.V=null;var t=n.toArray(e.entropy,e.entropyEnc||"hex");var r=n.toArray(e.nonce,e.nonceEnc||"hex");var i=n.toArray(e.pers,e.persEnc||"hex");a(t.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits");this._init(t,r,i)}e.exports=HmacDRBG;HmacDRBG.prototype._init=function init(e,t,r){var i=e.concat(t).concat(r);this.K=new Array(this.outLen/8);this.V=new Array(this.outLen/8);for(var n=0;n<this.V.length;n++){this.K[n]=0;this.V[n]=1}this._update(i);this._reseed=1;this.reseedInterval=281474976710656};HmacDRBG.prototype._hmac=function hmac(){return new i.hmac(this.hash,this.K)};HmacDRBG.prototype._update=function update(e){var t=this._hmac().update(this.V).update([0]);if(e)t=t.update(e);this.K=t.digest();this.V=this._hmac().update(this.V).digest();if(!e)return;this.K=this._hmac().update(this.V).update([1]).update(e).digest();this.V=this._hmac().update(this.V).digest()};HmacDRBG.prototype.reseed=function reseed(e,t,r,i){if(typeof t!=="string"){i=r;r=t;t=null}e=n.toArray(e,t);r=n.toArray(r,i);a(e.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits");this._update(e.concat(r||[]));this._reseed=1};HmacDRBG.prototype.generate=function generate(e,t,r,i){if(this._reseed>this.reseedInterval)throw new Error("Reseed is required");if(typeof t!=="string"){i=r;r=t;t=null}if(r){r=n.toArray(r,i||"hex");this._update(r)}var a=[];while(a.length<e){this.V=this._hmac().update(this.V).digest();a=a.concat(this.V)}var s=a.slice(0,e);this._update(r);this._reseed++;return n.encode(s,t)}},3782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},3533:function(e,t,r){"use strict";var i=r(3782);var n=r(9029);var a=r(5055).Buffer;var s=new Array(16);function MD5(){n.call(this,64);this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878}i(MD5,n);MD5.prototype._update=function(){var e=s;for(var t=0;t<16;++t)e[t]=this._block.readInt32LE(t*4);var r=this._a;var i=this._b;var n=this._c;var a=this._d;r=fnF(r,i,n,a,e[0],3614090360,7);a=fnF(a,r,i,n,e[1],3905402710,12);n=fnF(n,a,r,i,e[2],606105819,17);i=fnF(i,n,a,r,e[3],3250441966,22);r=fnF(r,i,n,a,e[4],4118548399,7);a=fnF(a,r,i,n,e[5],1200080426,12);n=fnF(n,a,r,i,e[6],2821735955,17);i=fnF(i,n,a,r,e[7],4249261313,22);r=fnF(r,i,n,a,e[8],1770035416,7);a=fnF(a,r,i,n,e[9],2336552879,12);n=fnF(n,a,r,i,e[10],4294925233,17);i=fnF(i,n,a,r,e[11],2304563134,22);r=fnF(r,i,n,a,e[12],1804603682,7);a=fnF(a,r,i,n,e[13],4254626195,12);n=fnF(n,a,r,i,e[14],2792965006,17);i=fnF(i,n,a,r,e[15],1236535329,22);r=fnG(r,i,n,a,e[1],4129170786,5);a=fnG(a,r,i,n,e[6],3225465664,9);n=fnG(n,a,r,i,e[11],643717713,14);i=fnG(i,n,a,r,e[0],3921069994,20);r=fnG(r,i,n,a,e[5],3593408605,5);a=fnG(a,r,i,n,e[10],38016083,9);n=fnG(n,a,r,i,e[15],3634488961,14);i=fnG(i,n,a,r,e[4],3889429448,20);r=fnG(r,i,n,a,e[9],568446438,5);a=fnG(a,r,i,n,e[14],3275163606,9);n=fnG(n,a,r,i,e[3],4107603335,14);i=fnG(i,n,a,r,e[8],1163531501,20);r=fnG(r,i,n,a,e[13],2850285829,5);a=fnG(a,r,i,n,e[2],4243563512,9);n=fnG(n,a,r,i,e[7],1735328473,14);i=fnG(i,n,a,r,e[12],2368359562,20);r=fnH(r,i,n,a,e[5],4294588738,4);a=fnH(a,r,i,n,e[8],2272392833,11);n=fnH(n,a,r,i,e[11],1839030562,16);i=fnH(i,n,a,r,e[14],4259657740,23);r=fnH(r,i,n,a,e[1],2763975236,4);a=fnH(a,r,i,n,e[4],1272893353,11);n=fnH(n,a,r,i,e[7],4139469664,16);i=fnH(i,n,a,r,e[10],3200236656,23);r=fnH(r,i,n,a,e[13],681279174,4);a=fnH(a,r,i,n,e[0],3936430074,11);n=fnH(n,a,r,i,e[3],3572445317,16);i=fnH(i,n,a,r,e[6],76029189,23);r=fnH(r,i,n,a,e[9],3654602809,4);a=fnH(a,r,i,n,e[12],3873151461,11);n=fnH(n,a,r,i,e[15],530742520,16);i=fnH(i,n,a,r,e[2],3299628645,23);r=fnI(r,i,n,a,e[0],4096336452,6);a=fnI(a,r,i,n,e[7],1126891415,10);n=fnI(n,a,r,i,e[14],2878612391,15);i=fnI(i,n,a,r,e[5],4237533241,21);r=fnI(r,i,n,a,e[12],1700485571,6);a=fnI(a,r,i,n,e[3],2399980690,10);n=fnI(n,a,r,i,e[10],4293915773,15);i=fnI(i,n,a,r,e[1],2240044497,21);r=fnI(r,i,n,a,e[8],1873313359,6);a=fnI(a,r,i,n,e[15],4264355552,10);n=fnI(n,a,r,i,e[6],2734768916,15);i=fnI(i,n,a,r,e[13],1309151649,21);r=fnI(r,i,n,a,e[4],4149444226,6);a=fnI(a,r,i,n,e[11],3174756917,10);n=fnI(n,a,r,i,e[2],718787259,15);i=fnI(i,n,a,r,e[9],3951481745,21);this._a=this._a+r|0;this._b=this._b+i|0;this._c=this._c+n|0;this._d=this._d+a|0};MD5.prototype._digest=function(){this._block[this._blockOffset++]=128;if(this._blockOffset>56){this._block.fill(0,this._blockOffset,64);this._update();this._blockOffset=0}this._block.fill(0,this._blockOffset,56);this._block.writeUInt32LE(this._length[0],56);this._block.writeUInt32LE(this._length[1],60);this._update();var e=a.allocUnsafe(16);e.writeInt32LE(this._a,0);e.writeInt32LE(this._b,4);e.writeInt32LE(this._c,8);e.writeInt32LE(this._d,12);return e};function rotl(e,t){return e<<t|e>>>32-t}function fnF(e,t,r,i,n,a,s){return rotl(e+(t&r|~t&i)+n+a|0,s)+t|0}function fnG(e,t,r,i,n,a,s){return rotl(e+(t&i|r&~i)+n+a|0,s)+t|0}function fnH(e,t,r,i,n,a,s){return rotl(e+(t^r^i)+n+a|0,s)+t|0}function fnI(e,t,r,i,n,a,s){return rotl(e+(r^(t|~i))+n+a|0,s)+t|0}e.exports=MD5},1354:function(e,t,r){var i=r(711);var n=r(3500);function MillerRabin(e){this.rand=e||new n.Rand}e.exports=MillerRabin;MillerRabin.create=function create(e){return new MillerRabin(e)};MillerRabin.prototype._randbelow=function _randbelow(e){var t=e.bitLength();var r=Math.ceil(t/8);do{var n=new i(this.rand.generate(r))}while(n.cmp(e)>=0);return n};MillerRabin.prototype._randrange=function _randrange(e,t){var r=t.sub(e);return e.add(this._randbelow(r))};MillerRabin.prototype.test=function test(e,t,r){var n=e.bitLength();var a=i.mont(e);var s=new i(1).toRed(a);if(!t)t=Math.max(1,n/48|0);var o=e.subn(1);for(var h=0;!o.testn(h);h++){}var u=e.shrn(h);var d=o.toRed(a);var c=true;for(;t>0;t--){var l=this._randrange(new i(2),o);if(r)r(l);var p=l.toRed(a).redPow(u);if(p.cmp(s)===0||p.cmp(d)===0)continue;for(var v=1;v<h;v++){p=p.redSqr();if(p.cmp(s)===0)return false;if(p.cmp(d)===0)break}if(v===h)return false}return c};MillerRabin.prototype.getDivisor=function getDivisor(e,t){var r=e.bitLength();var n=i.mont(e);var a=new i(1).toRed(n);if(!t)t=Math.max(1,r/48|0);var s=e.subn(1);for(var o=0;!s.testn(o);o++){}var h=e.shrn(o);var u=s.toRed(n);for(;t>0;t--){var d=this._randrange(new i(2),s);var c=e.gcd(d);if(c.cmpn(1)!==0)return c;var l=d.toRed(n).redPow(h);if(l.cmp(a)===0||l.cmp(u)===0)continue;for(var p=1;p<o;p++){l=l.redSqr();if(l.cmp(a)===0)return l.fromRed().subn(1).gcd(e);if(l.cmp(u)===0)break}if(p===o){l=l.redSqr();return l.fromRed().subn(1).gcd(e)}}return false}},3523:function(e){e.exports=assert;function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}assert.equal=function assertEqual(e,t,r){if(e!=t)throw new Error(r||"Assertion failed: "+e+" != "+t)}},6545:function(e,t){"use strict";var r=t;function toArray(e,t){if(Array.isArray(e))return e.slice();if(!e)return[];var r=[];if(typeof e!=="string"){for(var i=0;i<e.length;i++)r[i]=e[i]|0;return r}if(t==="hex"){e=e.replace(/[^a-z0-9]+/gi,"");if(e.length%2!==0)e="0"+e;for(var i=0;i<e.length;i+=2)r.push(parseInt(e[i]+e[i+1],16))}else{for(var i=0;i<e.length;i++){var n=e.charCodeAt(i);var a=n>>8;var s=n&255;if(a)r.push(a,s);else r.push(s)}}return r}r.toArray=toArray;function zero2(e){if(e.length===1)return"0"+e;else return e}r.zero2=zero2;function toHex(e){var t="";for(var r=0;r<e.length;r++)t+=zero2(e[r].toString(16));return t}r.toHex=toHex;r.encode=function encode(e,t){if(t==="hex")return toHex(e);else return e}},8687:function(e,t,r){"use strict";var i=r(7160);t.certificate=r(8782);var n=i.define("RSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("modulus").int(),this.key("publicExponent").int(),this.key("privateExponent").int(),this.key("prime1").int(),this.key("prime2").int(),this.key("exponent1").int(),this.key("exponent2").int(),this.key("coefficient").int())}));t.RSAPrivateKey=n;var a=i.define("RSAPublicKey",(function(){this.seq().obj(this.key("modulus").int(),this.key("publicExponent").int())}));t.RSAPublicKey=a;var s=i.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(o),this.key("subjectPublicKey").bitstr())}));t.PublicKey=s;var o=i.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("none").null_().optional(),this.key("curve").objid().optional(),this.key("params").seq().obj(this.key("p").int(),this.key("q").int(),this.key("g").int()).optional())}));var h=i.define("PrivateKeyInfo",(function(){this.seq().obj(this.key("version").int(),this.key("algorithm").use(o),this.key("subjectPrivateKey").octstr())}));t.PrivateKey=h;var u=i.define("EncryptedPrivateKeyInfo",(function(){this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(),this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(),this.key("kdeparams").seq().obj(this.key("salt").octstr(),this.key("iters").int())),this.key("cipher").seq().obj(this.key("algo").objid(),this.key("iv").octstr()))),this.key("subjectPrivateKey").octstr())}));t.EncryptedPrivateKey=u;var d=i.define("DSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("p").int(),this.key("q").int(),this.key("g").int(),this.key("pub_key").int(),this.key("priv_key").int())}));t.DSAPrivateKey=d;t.DSAparam=i.define("DSAparam",(function(){this.int()}));var c=i.define("ECPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("privateKey").octstr(),this.key("parameters").optional().explicit(0).use(l),this.key("publicKey").optional().explicit(1).bitstr())}));t.ECPrivateKey=c;var l=i.define("ECParameters",(function(){this.choice({namedCurve:this.objid()})}));t.signature=i.define("signature",(function(){this.seq().obj(this.key("r").int(),this.key("s").int())}))},8782:function(e,t,r){"use strict";var i=r(7160);var n=i.define("Time",(function(){this.choice({utcTime:this.utctime(),generalTime:this.gentime()})}));var a=i.define("AttributeTypeValue",(function(){this.seq().obj(this.key("type").objid(),this.key("value").any())}));var s=i.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("parameters").optional(),this.key("curve").objid().optional())}));var o=i.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(s),this.key("subjectPublicKey").bitstr())}));var h=i.define("RelativeDistinguishedName",(function(){this.setof(a)}));var u=i.define("RDNSequence",(function(){this.seqof(h)}));var d=i.define("Name",(function(){this.choice({rdnSequence:this.use(u)})}));var c=i.define("Validity",(function(){this.seq().obj(this.key("notBefore").use(n),this.key("notAfter").use(n))}));var l=i.define("Extension",(function(){this.seq().obj(this.key("extnID").objid(),this.key("critical").bool().def(false),this.key("extnValue").octstr())}));var p=i.define("TBSCertificate",(function(){this.seq().obj(this.key("version").explicit(0).int().optional(),this.key("serialNumber").int(),this.key("signature").use(s),this.key("issuer").use(d),this.key("validity").use(c),this.key("subject").use(d),this.key("subjectPublicKeyInfo").use(o),this.key("issuerUniqueID").implicit(1).bitstr().optional(),this.key("subjectUniqueID").implicit(2).bitstr().optional(),this.key("extensions").explicit(3).seqof(l).optional())}));var v=i.define("X509Certificate",(function(){this.seq().obj(this.key("tbsCertificate").use(p),this.key("signatureAlgorithm").use(s),this.key("signatureValue").bitstr())}));e.exports=v},6501:function(e,t,r){var i=/Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m;var n=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;var a=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m;var s=r(8368);var o=r(6594);var h=r(5055).Buffer;e.exports=function(e,t){var r=e.toString();var u=r.match(i);var d;if(!u){var c=r.match(a);d=new h(c[2].replace(/[\r\n]/g,""),"base64")}else{var l="aes"+u[1];var p=h.from(u[2],"hex");var v=h.from(u[3].replace(/[\r\n]/g,""),"base64");var b=s(t,p.slice(0,8),parseInt(u[1],10)).key;var m=[];var y=o.createDecipheriv(l,b,p);m.push(y.update(v));m.push(y.final());d=h.concat(m)}var g=r.match(n)[1];return{tag:g,data:d}}},9902:function(e,t,r){var i=r(8687);var n=r(2510);var a=r(6501);var s=r(6594);var o=r(4978);var h=r(5055).Buffer;e.exports=parseKeys;function parseKeys(e){var t;if(typeof e==="object"&&!h.isBuffer(e)){t=e.passphrase;e=e.key}if(typeof e==="string"){e=h.from(e)}var r=a(e,t);var n=r.tag;var s=r.data;var o,u;switch(n){case"CERTIFICATE":u=i.certificate.decode(s,"der").tbsCertificate.subjectPublicKeyInfo;case"PUBLIC KEY":if(!u){u=i.PublicKey.decode(s,"der")}o=u.algorithm.algorithm.join(".");switch(o){case"1.2.840.113549.1.1.1":return i.RSAPublicKey.decode(u.subjectPublicKey.data,"der");case"1.2.840.10045.2.1":u.subjectPrivateKey=u.subjectPublicKey;return{type:"ec",data:u};case"1.2.840.10040.4.1":u.algorithm.params.pub_key=i.DSAparam.decode(u.subjectPublicKey.data,"der");return{type:"dsa",data:u.algorithm.params};default:throw new Error("unknown key id "+o)}throw new Error("unknown key type "+n);case"ENCRYPTED PRIVATE KEY":s=i.EncryptedPrivateKey.decode(s,"der");s=decrypt(s,t);case"PRIVATE KEY":u=i.PrivateKey.decode(s,"der");o=u.algorithm.algorithm.join(".");switch(o){case"1.2.840.113549.1.1.1":return i.RSAPrivateKey.decode(u.subjectPrivateKey,"der");case"1.2.840.10045.2.1":return{curve:u.algorithm.curve,privateKey:i.ECPrivateKey.decode(u.subjectPrivateKey,"der").privateKey};case"1.2.840.10040.4.1":u.algorithm.params.priv_key=i.DSAparam.decode(u.subjectPrivateKey,"der");return{type:"dsa",params:u.algorithm.params};default:throw new Error("unknown key id "+o)}throw new Error("unknown key type "+n);case"RSA PUBLIC KEY":return i.RSAPublicKey.decode(s,"der");case"RSA PRIVATE KEY":return i.RSAPrivateKey.decode(s,"der");case"DSA PRIVATE KEY":return{type:"dsa",params:i.DSAPrivateKey.decode(s,"der")};case"EC PRIVATE KEY":s=i.ECPrivateKey.decode(s,"der");return{curve:s.parameters.value,privateKey:s.privateKey};default:throw new Error("unknown key type "+n)}}parseKeys.signature=i.signature;function decrypt(e,t){var r=e.algorithm.decrypt.kde.kdeparams.salt;var i=parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(),10);var a=n[e.algorithm.decrypt.cipher.algo.join(".")];var u=e.algorithm.decrypt.cipher.iv;var d=e.subjectPrivateKey;var c=parseInt(a.split("-")[1],10)/8;var l=o.pbkdf2Sync(t,r,i,c,"sha1");var p=s.createDecipheriv(a,l,u);var v=[];v.push(p.update(d));v.push(p.final());return h.concat(v)}},4978:function(e,t,r){var i=r(6113);var n=r(5349);var a=r(7007);var s=r(5407);function nativePBKDF2(e,t,r,o,h,u){n(r,o);e=s(e,a,"Password");t=s(t,a,"Salt");if(typeof h==="function"){u=h;h="sha1"}if(typeof u!=="function")throw new Error("No callback provided to pbkdf2");return i.pbkdf2(e,t,r,o,h,u)}function nativePBKDF2Sync(e,t,r,o,h){n(r,o);e=s(e,a,"Password");t=s(t,a,"Salt");h=h||"sha1";return i.pbkdf2Sync(e,t,r,o,h)}if(!i.pbkdf2Sync||i.pbkdf2Sync.toString().indexOf("keylen, digest")===-1){t.pbkdf2Sync=r(2127);t.pbkdf2=r(9601)}else{t.pbkdf2Sync=nativePBKDF2Sync;t.pbkdf2=nativePBKDF2}},9601:function(e,t,r){var i=r(5055).Buffer;var n=r(5349);var a=r(7007);var s=r(2127);var o=r(5407);var h;var u=__webpack_require__.g.crypto&&__webpack_require__.g.crypto.subtle;var d={sha:"SHA-1","sha-1":"SHA-1",sha1:"SHA-1",sha256:"SHA-256","sha-256":"SHA-256",sha384:"SHA-384","sha-384":"SHA-384","sha-512":"SHA-512",sha512:"SHA-512"};var c=[];function checkNative(e){if(__webpack_require__.g.process&&!__webpack_require__.g.process.browser){return Promise.resolve(false)}if(!u||!u.importKey||!u.deriveBits){return Promise.resolve(false)}if(c[e]!==undefined){return c[e]}h=h||i.alloc(8);var t=browserPbkdf2(h,h,10,128,e).then((function(){return true})).catch((function(){return false}));c[e]=t;return t}function browserPbkdf2(e,t,r,n,a){return u.importKey("raw",e,{name:"PBKDF2"},false,["deriveBits"]).then((function(e){return u.deriveBits({name:"PBKDF2",salt:t,iterations:r,hash:{name:a}},e,n<<3)})).then((function(e){return i.from(e)}))}function resolvePromise(e,t){e.then((function(e){process.nextTick((function(){t(null,e)}))}),(function(e){process.nextTick((function(){t(e)}))}))}e.exports=function(e,t,r,i,h,u){if(typeof h==="function"){u=h;h=undefined}h=h||"sha1";var c=d[h.toLowerCase()];if(!c||typeof __webpack_require__.g.Promise!=="function"){return process.nextTick((function(){var n;try{n=s(e,t,r,i,h)}catch(e){return u(e)}u(null,n)}))}n(r,i);e=o(e,a,"Password");t=o(t,a,"Salt");if(typeof u!=="function")throw new Error("No callback provided to pbkdf2");resolvePromise(checkNative(c).then((function(n){if(n)return browserPbkdf2(e,t,r,i,c);return s(e,t,r,i,h)})),u)}},7007:function(e){var t;if(true){t="utf-8"}else { var r; }e.exports=t},5349:function(e){var t=Math.pow(2,30)-1;e.exports=function(e,r){if(typeof e!=="number"){throw new TypeError("Iterations not a number")}if(e<0){throw new TypeError("Bad iterations")}if(typeof r!=="number"){throw new TypeError("Key length not a number")}if(r<0||r>t||r!==r){throw new TypeError("Bad key length")}}},2127:function(e,t,r){var i={md5:16,sha1:20,sha224:28,sha256:32,sha384:48,sha512:64,rmd160:20,ripemd160:20};var n=r(4873);var a=r(5055).Buffer;var s=r(5349);var o=r(7007);var h=r(5407);function pbkdf2(e,t,r,u,d){s(r,u);e=h(e,o,"Password");t=h(t,o,"Salt");d=d||"sha1";var c=a.allocUnsafe(u);var l=a.allocUnsafe(t.length+4);t.copy(l,0,0,t.length);var p=0;var v=i[d];var b=Math.ceil(u/v);for(var m=1;m<=b;m++){l.writeUInt32BE(m,t.length);var y=n(d,e).update(l).digest();var g=y;for(var _=1;_<r;_++){g=n(d,e).update(g).digest();for(var w=0;w<v;w++)y[w]^=g[w]}y.copy(c,p);p+=v}return c}e.exports=pbkdf2},5407:function(e,t,r){var i=r(5055).Buffer;e.exports=function(e,t,r){if(i.isBuffer(e)){return e}else if(typeof e==="string"){return i.from(e,t)}else if(ArrayBuffer.isView(e)){return i.from(e.buffer)}else{throw new TypeError(r+" must be a string, a Buffer, a typed array or a DataView")}}},9783:function(e,t,r){t.publicEncrypt=r(3995);t.privateDecrypt=r(4366);t.privateEncrypt=function privateEncrypt(e,r){return t.publicEncrypt(e,r,true)};t.publicDecrypt=function publicDecrypt(e,r){return t.privateDecrypt(e,r,true)}},5520:function(e,t,r){var i=r(9739);var n=r(5055).Buffer;e.exports=function(e,t){var r=n.alloc(0);var a=0;var s;while(r.length<t){s=i2ops(a++);r=n.concat([r,i("sha1").update(e).update(s).digest()])}return r.slice(0,t)};function i2ops(e){var t=n.allocUnsafe(4);t.writeUInt32BE(e,0);return t}},4366:function(e,t,r){var i=r(9902);var n=r(5520);var a=r(6386);var s=r(711);var o=r(7166);var h=r(9739);var u=r(1607);var d=r(5055).Buffer;e.exports=function privateDecrypt(e,t,r){var n;if(e.padding){n=e.padding}else if(r){n=1}else{n=4}var a=i(e);var h=a.modulus.byteLength();if(t.length>h||new s(t).cmp(a.modulus)>=0){throw new Error("decryption error")}var c;if(r){c=u(new s(t),a)}else{c=o(t,a)}var l=d.alloc(h-c.length);c=d.concat([l,c],h);if(n===4){return oaep(a,c)}else if(n===1){return pkcs1(a,c,r)}else if(n===3){return c}else{throw new Error("unknown padding")}};function oaep(e,t){var r=e.modulus.byteLength();var i=h("sha1").update(d.alloc(0)).digest();var s=i.length;if(t[0]!==0){throw new Error("decryption error")}var o=t.slice(1,s+1);var u=t.slice(s+1);var c=a(o,n(u,s));var l=a(u,n(c,r-s-1));if(compare(i,l.slice(0,s))){throw new Error("decryption error")}var p=s;while(l[p]===0){p++}if(l[p++]!==1){throw new Error("decryption error")}return l.slice(p)}function pkcs1(e,t,r){var i=t.slice(0,2);var n=2;var a=0;while(t[n++]!==0){if(n>=t.length){a++;break}}var s=t.slice(2,n-1);if(i.toString("hex")!=="0002"&&!r||i.toString("hex")!=="0001"&&r){a++}if(s.length<8){a++}if(a){throw new Error("decryption error")}return t.slice(n)}function compare(e,t){e=d.from(e);t=d.from(t);var r=0;var i=e.length;if(e.length!==t.length){r++;i=Math.min(e.length,t.length)}var n=-1;while(++n<i){r+=e[n]^t[n]}return r}},3995:function(e,t,r){var i=r(9902);var n=r(7223);var a=r(9739);var s=r(5520);var o=r(6386);var h=r(711);var u=r(1607);var d=r(7166);var c=r(5055).Buffer;e.exports=function publicEncrypt(e,t,r){var n;if(e.padding){n=e.padding}else if(r){n=1}else{n=4}var a=i(e);var s;if(n===4){s=oaep(a,t)}else if(n===1){s=pkcs1(a,t,r)}else if(n===3){s=new h(t);if(s.cmp(a.modulus)>=0){throw new Error("data too long for modulus")}}else{throw new Error("unknown padding")}if(r){return d(s,a)}else{return u(s,a)}};function oaep(e,t){var r=e.modulus.byteLength();var i=t.length;var u=a("sha1").update(c.alloc(0)).digest();var d=u.length;var l=2*d;if(i>r-l-2){throw new Error("message too long")}var p=c.alloc(r-i-l-2);var v=r-d-1;var b=n(d);var m=o(c.concat([u,p,c.alloc(1,1),t],v),s(b,v));var y=o(b,s(m,d));return new h(c.concat([c.alloc(1),y,m],r))}function pkcs1(e,t,r){var i=t.length;var n=e.modulus.byteLength();if(i>n-11){throw new Error("message too long")}var a;if(r){a=c.alloc(n-i-3,255)}else{a=nonZero(n-i-3)}return new h(c.concat([c.from([0,r?1:2]),a,c.alloc(1),t],n))}function nonZero(e){var t=c.allocUnsafe(e);var r=0;var i=n(e*2);var a=0;var s;while(r<e){if(a===i.length){i=n(e*2);a=0}s=i[a++];if(s){t[r++]=s}}return t}},1607:function(e,t,r){var i=r(711);var n=r(5055).Buffer;function withPublic(e,t){return n.from(e.toRed(i.mont(t.modulus)).redPow(new i(t.publicExponent)).fromRed().toArray())}e.exports=withPublic},6386:function(e){e.exports=function xor(e,t){var r=e.length;var i=-1;while(++i<r){e[i]^=t[i]}return e}},7223:function(e,t,r){"use strict";var i=65536;var n=4294967295;function oldBrowser(){throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11")}var a=r(5055).Buffer;var s=__webpack_require__.g.crypto||__webpack_require__.g.msCrypto;if(s&&s.getRandomValues){e.exports=randomBytes}else{e.exports=oldBrowser}function randomBytes(e,t){if(e>n)throw new RangeError("requested too many random bytes");var r=a.allocUnsafe(e);if(e>0){if(e>i){for(var o=0;o<e;o+=i){s.getRandomValues(r.slice(o,o+i))}}else{s.getRandomValues(r)}}if(typeof t==="function"){return process.nextTick((function(){t(null,r)}))}return r}},6445:function(e,t,r){"use strict";function oldBrowser(){throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11")}var i=r(5055);var n=r(7223);var a=i.Buffer;var s=i.kMaxLength;var o=__webpack_require__.g.crypto||__webpack_require__.g.msCrypto;var h=Math.pow(2,32)-1;function assertOffset(e,t){if(typeof e!=="number"||e!==e){throw new TypeError("offset must be a number")}if(e>h||e<0){throw new TypeError("offset must be a uint32")}if(e>s||e>t){throw new RangeError("offset out of range")}}function assertSize(e,t,r){if(typeof e!=="number"||e!==e){throw new TypeError("size must be a number")}if(e>h||e<0){throw new TypeError("size must be a uint32")}if(e+t>r||e>s){throw new RangeError("buffer too small")}}if(o&&o.getRandomValues||!true){t.randomFill=randomFill;t.randomFillSync=randomFillSync}else{t.randomFill=oldBrowser;t.randomFillSync=oldBrowser}function randomFill(e,t,r,i){if(!a.isBuffer(e)&&!(e instanceof __webpack_require__.g.Uint8Array)){throw new TypeError('"buf" argument must be a Buffer or Uint8Array')}if(typeof t==="function"){i=t;t=0;r=e.length}else if(typeof r==="function"){i=r;r=e.length-t}else if(typeof i!=="function"){throw new TypeError('"cb" argument must be a function')}assertOffset(t,e.length);assertSize(r,t,e.length);return actualFill(e,t,r,i)}function actualFill(e,t,r,i){if(true){var a=e.buffer;var s=new Uint8Array(a,t,r);o.getRandomValues(s);if(i){process.nextTick((function(){i(null,e)}));return}return e}if(i){n(r,(function(r,n){if(r){return i(r)}n.copy(e,t);i(null,e)}));return}var h=n(r);h.copy(e,t);return e}function randomFillSync(e,t,r){if(typeof t==="undefined"){t=0}if(!a.isBuffer(e)&&!(e instanceof __webpack_require__.g.Uint8Array)){throw new TypeError('"buf" argument must be a Buffer or Uint8Array')}assertOffset(t,e.length);if(r===undefined)r=e.length-t;assertSize(r,t,e.length);return actualFill(e,t,r)}},4646:function(e){"use strict";const t={};function createErrorType(e,r,i){if(!i){i=Error}function getMessage(e,t,i){if(typeof r==="string"){return r}else{return r(e,t,i)}}class NodeError extends i{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=i.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let i;if(typeof t==="string"&&startsWith(t,"not ")){i="must not be";t=t.replace(/^not /,"")}else{i="must be"}let n;if(endsWith(e," argument")){n=`The ${e} ${i} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";n=`The "${e}" ${r} ${i} ${oneOf(t,"type")}`}n+=`. Received type ${typeof r}`;return n}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},2403:function(e,t,r){"use strict";var i=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var n=r(1709);var a=r(7337);r(3782)(Duplex,n);{var s=i(a.prototype);for(var o=0;o<s.length;o++){var h=s[o];if(!Duplex.prototype[h])Duplex.prototype[h]=a.prototype[h]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);n.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},7889:function(e,t,r){"use strict";e.exports=PassThrough;var i=r(1170);r(3782)(PassThrough,i);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);i.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},1709:function(e,t,r){"use strict";e.exports=Readable;var i;Readable.ReadableState=ReadableState;var n=r(2361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var s=r(4678);var o=r(4300).Buffer;var h=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof h}var u=r(3837);var d;if(u&&u.debuglog){d=u.debuglog("stream")}else{d=function debug(){}}var c=r(4379);var l=r(7025);var p=r(6776),v=p.getHighWaterMark;var b=r(4646).q,m=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,g=b.ERR_METHOD_NOT_IMPLEMENTED,_=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var M;var B;r(3782)(Readable,s);var E=l.errorOrDestroy;var k=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,n){i=i||r(2403);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=v(this,e,"readableHighWaterMark",n);this.buffer=new c;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(3704).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){i=i||r(2403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof i;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}s.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=l.destroy;Readable.prototype._undestroy=l.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var i;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=o.from(e,t);t=""}i=true}}else{i=true}return readableAddChunk(this,e,t,false,i)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,i,n){d("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var s;if(!n)s=chunkInvalid(a,t);if(s){E(e,s)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==o.prototype){t=_uint8ArrayToBuffer(t)}if(i){if(a.endEmitted)E(e,new _);else addChunk(e,a,t,true)}else if(a.ended){E(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!i){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,i){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(i)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new m("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(3704).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var i=this._readableState.buffer.head;var n="";while(i!==null){n+=t.write(i.data);i=i.next}this._readableState.buffer.clear();if(n!=="")this._readableState.buffer.push(n);this._readableState.length=n.length;return this};var A=1073741824;function computeNewHighWaterMark(e){if(e>=A){e=A}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){d("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){d("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var i=t.needReadable;d("need readable",i);if(t.length===0||t.length-e<t.highWaterMark){i=true;d("length less than watermark",i)}if(t.ended||t.reading){i=false;d("reading or ended",i)}else if(i){d("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var n;if(e>0)n=fromList(e,t);else n=null;if(n===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(n!==null)this.emit("data",n);return n};function onEofChunk(e,t){d("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;d("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){d("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;d("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;d("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){E(this,new g("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var i=this._readableState;switch(i.pipesCount){case 0:i.pipes=e;break;case 1:i.pipes=[i.pipes,e];break;default:i.pipes.push(e);break}i.pipesCount+=1;d("pipe count=%d opts=%j",i.pipesCount,t);var n=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var s=n?onend:unpipe;if(i.endEmitted)process.nextTick(s);else r.once("end",s);e.on("unpipe",onunpipe);function onunpipe(e,t){d("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){d("onend");e.end()}var o=pipeOnDrain(r);e.on("drain",o);var h=false;function cleanup(){d("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",o);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);h=true;if(i.awaitDrain&&(!e._writableState||e._writableState.needDrain))o()}r.on("data",ondata);function ondata(t){d("ondata");var n=e.write(t);d("dest.write",n);if(n===false){if((i.pipesCount===1&&i.pipes===e||i.pipesCount>1&&indexOf(i.pipes,e)!==-1)&&!h){d("false write response, pause",i.awaitDrain);i.awaitDrain++}r.pause()}}function onerror(t){d("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)E(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){d("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){d("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!i.flowing){d("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;d("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var i=t.pipes;var n=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<n;a++){i[a].emit("unpipe",this,{hasUnpiped:false})}return this}var s=indexOf(t.pipes,e);if(s===-1)return this;t.pipes.splice(s,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=s.prototype.on.call(this,e,t);var i=this._readableState;if(e==="data"){i.readableListening=this.listenerCount("readable")>0;if(i.flowing!==false)this.resume()}else if(e==="readable"){if(!i.endEmitted&&!i.readableListening){i.readableListening=i.needReadable=true;i.flowing=false;i.emittedReadable=false;d("on readable",i.length,i.reading);if(i.length){emitReadable(this)}else if(!i.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=s.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=s.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){d("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){d("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){d("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){d("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){d("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;d("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var i=false;e.on("end",(function(){d("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(n){d("wrapped data");if(r.decoder)n=r.decoder.write(n);if(r.objectMode&&(n===null||n===undefined))return;else if(!r.objectMode&&(!n||!n.length))return;var a=t.push(n);if(!a){i=true;e.pause()}}));for(var n in e){if(this[n]===undefined&&typeof e[n]==="function"){this[n]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(n)}}for(var a=0;a<k.length;a++){e.on(k[a],this.emit.bind(this,k[a]))}this._read=function(t){d("wrapped _read",t);if(i){i=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(M===undefined){M=r(6871)}return M(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;d("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){d("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(B===undefined){B=r(9727)}return B(Readable,e,t)}}function indexOf(e,t){for(var r=0,i=e.length;r<i;r++){if(e[r]===t)return r}return-1}},1170:function(e,t,r){"use strict";e.exports=Transform;var i=r(4646).q,n=i.ERR_METHOD_NOT_IMPLEMENTED,a=i.ERR_MULTIPLE_CALLBACK,s=i.ERR_TRANSFORM_ALREADY_TRANSFORMING,o=i.ERR_TRANSFORM_WITH_LENGTH_0;var h=r(2403);r(3782)(Transform,h);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var i=r.writecb;if(i===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);i(e);var n=this._readableState;n.reading=false;if(n.needReadable||n.length<n.highWaterMark){this._read(n.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);h.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return h.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new n("_transform()"))};Transform.prototype._write=function(e,t,r){var i=this._transformState;i.writecb=r;i.writechunk=e;i.writeencoding=t;if(!i.transforming){var n=this._readableState;if(i.needTransform||n.needReadable||n.length<n.highWaterMark)this._read(n.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){h.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new o;if(e._transformState.transforming)throw new s;return e.push(null)}},7337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var i;Writable.WritableState=WritableState;var n={deprecate:r(6769)};var a=r(4678);var s=r(4300).Buffer;var o=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof o}var h=r(7025);var u=r(6776),d=u.getHighWaterMark;var c=r(4646).q,l=c.ERR_INVALID_ARG_TYPE,p=c.ERR_METHOD_NOT_IMPLEMENTED,v=c.ERR_MULTIPLE_CALLBACK,b=c.ERR_STREAM_CANNOT_PIPE,m=c.ERR_STREAM_DESTROYED,y=c.ERR_STREAM_NULL_VALUES,g=c.ERR_STREAM_WRITE_AFTER_END,_=c.ERR_UNKNOWN_ENCODING;var w=h.errorOrDestroy;r(3782)(Writable,a);function nop(){}function WritableState(e,t,n){i=i||r(2403);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=d(this,e,"writableHighWaterMark",n);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:n.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var M;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){M=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(M.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{M=function realHasInstance(e){return e instanceof this}}function Writable(e){i=i||r(2403);var t=this instanceof i;if(!t&&!M.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new g;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,i){var n;if(r===null){n=new y}else if(typeof r!=="string"&&!t.objectMode){n=new l("chunk",["string","Buffer"],r)}if(n){w(e,n);process.nextTick(i,n);return false}return true}Writable.prototype.write=function(e,t,r){var i=this._writableState;var n=false;var a=!i.objectMode&&_isUint8Array(e);if(a&&!s.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=i.defaultEncoding;if(typeof r!=="function")r=nop;if(i.ending)writeAfterEnd(this,r);else if(a||validChunk(this,i,e,r)){i.pendingcb++;n=writeOrBuffer(this,i,a,e,t,r)}return n};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new _(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=s.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,i,n,a){if(!r){var s=decodeChunk(t,i,n);if(i!==s){r=true;n="buffer";i=s}}var o=t.objectMode?1:i.length;t.length+=o;var h=t.length<t.highWaterMark;if(!h)t.needDrain=true;if(t.writing||t.corked){var u=t.lastBufferedRequest;t.lastBufferedRequest={chunk:i,encoding:n,isBuf:r,callback:a,next:null};if(u){u.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,o,i,n,a)}return h}function doWrite(e,t,r,i,n,a,s){t.writelen=i;t.writecb=s;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new m("write"));else if(r)e._writev(n,t.onwrite);else e._write(n,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,i,n){--t.pendingcb;if(r){process.nextTick(n,i);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,i)}else{n(i);e._writableState.errorEmitted=true;w(e,i);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var i=r.sync;var n=r.writecb;if(typeof n!=="function")throw new v;onwriteStateUpdate(r);if(t)onwriteError(e,r,i,t,n);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(i){process.nextTick(afterWrite,e,r,a,n)}else{afterWrite(e,r,a,n)}}}function afterWrite(e,t,r,i){if(!r)onwriteDrain(e,t);t.pendingcb--;i();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var i=t.bufferedRequestCount;var n=new Array(i);var a=t.corkedRequestsFree;a.entry=r;var s=0;var o=true;while(r){n[s]=r;if(!r.isBuf)o=false;r=r.next;s+=1}n.allBuffers=o;doWrite(e,t,true,t.length,n,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var h=r.chunk;var u=r.encoding;var d=r.callback;var c=t.objectMode?1:h.length;doWrite(e,t,false,c,h,u,d);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new p("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var i=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(i.corked){i.corked=1;this.uncork()}if(!i.ending)endWritable(this,i,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var i=e._readableState;if(!i||i.autoDestroy&&i.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var i=e.entry;e.entry=null;while(i){var n=i.callback;t.pendingcb--;n(r);i=i.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=h.destroy;Writable.prototype._undestroy=h.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},6871:function(e,t,r){"use strict";var i;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(9698);var a=Symbol("lastResolve");var s=Symbol("lastReject");var o=Symbol("error");var h=Symbol("ended");var u=Symbol("lastPromise");var d=Symbol("handlePromise");var c=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[c].read();if(r!==null){e[u]=null;e[a]=null;e[s]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,i){e.then((function(){if(t[h]){r(createIterResult(undefined,true));return}t[d](r,i)}),i)}}var l=Object.getPrototypeOf((function(){}));var p=Object.setPrototypeOf((i={get stream(){return this[c]},next:function next(){var e=this;var t=this[o];if(t!==null){return Promise.reject(t)}if(this[h]){return Promise.resolve(createIterResult(undefined,true))}if(this[c].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[o]){r(e[o])}else{t(createIterResult(undefined,true))}}))}))}var r=this[u];var i;if(r){i=new Promise(wrapForNext(r,this))}else{var n=this[c].read();if(n!==null){return Promise.resolve(createIterResult(n,false))}i=new Promise(this[d])}this[u]=i;return i}},_defineProperty(i,Symbol.asyncIterator,(function(){return this})),_defineProperty(i,"return",(function _return(){var e=this;return new Promise((function(t,r){e[c].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),i),l);var v=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(p,(t={},_defineProperty(t,c,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,h,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,d,{value:function value(e,t){var i=r[c].read();if(i){r[u]=null;r[a]=null;r[s]=null;e(createIterResult(i,false))}else{r[a]=e;r[s]=t}},writable:true}),t));r[u]=null;n(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[s];if(t!==null){r[u]=null;r[a]=null;r[s]=null;t(e)}r[o]=e;return}var i=r[a];if(i!==null){r[u]=null;r[a]=null;r[s]=null;i(createIterResult(undefined,true))}r[h]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=v},4379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var i=t[r];i.enumerable=i.enumerable||false;i.configurable=true;if("value"in i)i.writable=true;Object.defineProperty(e,i.key,i)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var i=r(4300),n=i.Buffer;var a=r(3837),s=a.inspect;var o=s&&s.custom||"inspect";function copyBuffer(e,t,r){n.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return n.alloc(0);var t=n.allocUnsafe(e>>>0);var r=this.head;var i=0;while(r){copyBuffer(r.data,t,i);i+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var i=t.data;e-=i.length;while(t=t.next){var n=t.data;var a=e>n.length?n.length:e;if(a===n.length)i+=n;else i+=n.slice(0,e);e-=a;if(e===0){if(a===n.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=n.slice(a)}break}++r}this.length-=r;return i}},{key:"_getBuffer",value:function _getBuffer(e){var t=n.allocUnsafe(e);var r=this.head;var i=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var s=e>a.length?a.length:e;a.copy(t,t.length-e,0,s);e-=s;if(e===0){if(s===a.length){++i;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(s)}break}++i}this.length-=i;return t}},{key:o,value:function value(e,t){return s(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},7025:function(e){"use strict";function destroy(e,t){var r=this;var i=this._readableState&&this._readableState.destroyed;var n=this._writableState&&this._writableState.destroyed;if(i||n){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var i=e._writableState;if(r&&r.autoDestroy||i&&i.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},9698:function(e,t,r){"use strict";var i=r(4646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,i=new Array(r),n=0;n<r;n++){i[n]=arguments[n]}e.apply(this,i)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var n=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var s=function onlegacyfinish(){if(!e.writable)h()};var o=e._writableState&&e._writableState.finished;var h=function onfinish(){a=false;o=true;if(!n)r.call(e)};var u=e._readableState&&e._readableState.endEmitted;var d=function onend(){n=false;u=true;if(!a)r.call(e)};var c=function onerror(t){r.call(e,t)};var l=function onclose(){var t;if(n&&!u){if(!e._readableState||!e._readableState.ended)t=new i;return r.call(e,t)}if(a&&!o){if(!e._writableState||!e._writableState.ended)t=new i;return r.call(e,t)}};var p=function onrequest(){e.req.on("finish",h)};if(isRequest(e)){e.on("complete",h);e.on("abort",l);if(e.req)p();else e.on("request",p)}else if(a&&!e._writableState){e.on("end",s);e.on("close",s)}e.on("end",d);e.on("finish",h);if(t.error!==false)e.on("error",c);e.on("close",l);return function(){e.removeListener("complete",h);e.removeListener("abort",l);e.removeListener("request",p);if(e.req)e.req.removeListener("finish",h);e.removeListener("end",s);e.removeListener("close",s);e.removeListener("finish",h);e.removeListener("end",d);e.removeListener("error",c);e.removeListener("close",l)}}e.exports=eos},9727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,i,n,a,s){try{var o=e[a](s);var h=o.value}catch(e){r(e);return}if(o.done){t(h)}else{Promise.resolve(h).then(i,n)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(i,n){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,i,n,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,i,n,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(4646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var n;if(t&&typeof t.next==="function"){n=t}else if(t&&t[Symbol.asyncIterator])n=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])n=t[Symbol.iterator]();else throw new i("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var s=false;a._read=function(){if(!s){s=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield n.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{s=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},8442:function(e,t,r){"use strict";var i;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var n=r(4646).q,a=n.ERR_MISSING_ARGS,s=n.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,n,a){a=once(a);var o=false;e.on("close",(function(){o=true}));if(i===undefined)i=r(9698);i(e,{readable:t,writable:n},(function(e){if(e)return a(e);o=true;a()}));var h=false;return function(t){if(o)return;if(h)return;h=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new s("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var i=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var n;var s=t.map((function(e,r){var a=r<t.length-1;var o=r>0;return destroyer(e,a,o,(function(e){if(!n)n=e;if(e)s.forEach(call);if(a)return;s.forEach(call);i(n)}))}));return t.reduce(pipe)}e.exports=pipeline},6776:function(e,t,r){"use strict";var i=r(4646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,n){var a=highWaterMarkFrom(t,n,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var s=n?r:"highWaterMark";throw new i(s,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},4678:function(e,t,r){e.exports=r(2781)},3726:function(e,t,r){var i=r(2781);if(process.env.READABLE_STREAM==="disable"&&i){e.exports=i.Readable;Object.assign(e.exports,i);e.exports.Stream=i}else{t=e.exports=r(1709);t.Stream=i||t;t.Readable=t;t.Writable=r(7337);t.Duplex=r(2403);t.Transform=r(1170);t.PassThrough=r(7889);t.finished=r(9698);t.pipeline=r(8442)}},3225:function(e,t,r){"use strict";var i=r(4300).Buffer;var n=r(3782);var a=r(9029);var s=new Array(16);var o=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13];var h=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11];var u=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6];var d=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11];var c=[0,1518500249,1859775393,2400959708,2840853838];var l=[1352829926,1548603684,1836072691,2053994217,0];function RIPEMD160(){a.call(this,64);this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520}n(RIPEMD160,a);RIPEMD160.prototype._update=function(){var e=s;for(var t=0;t<16;++t)e[t]=this._block.readInt32LE(t*4);var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var p=this._e|0;var v=this._a|0;var b=this._b|0;var m=this._c|0;var y=this._d|0;var g=this._e|0;for(var _=0;_<80;_+=1){var w;var M;if(_<16){w=fn1(r,i,n,a,p,e[o[_]],c[0],u[_]);M=fn5(v,b,m,y,g,e[h[_]],l[0],d[_])}else if(_<32){w=fn2(r,i,n,a,p,e[o[_]],c[1],u[_]);M=fn4(v,b,m,y,g,e[h[_]],l[1],d[_])}else if(_<48){w=fn3(r,i,n,a,p,e[o[_]],c[2],u[_]);M=fn3(v,b,m,y,g,e[h[_]],l[2],d[_])}else if(_<64){w=fn4(r,i,n,a,p,e[o[_]],c[3],u[_]);M=fn2(v,b,m,y,g,e[h[_]],l[3],d[_])}else{w=fn5(r,i,n,a,p,e[o[_]],c[4],u[_]);M=fn1(v,b,m,y,g,e[h[_]],l[4],d[_])}r=p;p=a;a=rotl(n,10);n=i;i=w;v=g;g=y;y=rotl(m,10);m=b;b=M}var B=this._b+n+y|0;this._b=this._c+a+g|0;this._c=this._d+p+v|0;this._d=this._e+r+b|0;this._e=this._a+i+m|0;this._a=B};RIPEMD160.prototype._digest=function(){this._block[this._blockOffset++]=128;if(this._blockOffset>56){this._block.fill(0,this._blockOffset,64);this._update();this._blockOffset=0}this._block.fill(0,this._blockOffset,56);this._block.writeUInt32LE(this._length[0],56);this._block.writeUInt32LE(this._length[1],60);this._update();var e=i.alloc?i.alloc(20):new i(20);e.writeInt32LE(this._a,0);e.writeInt32LE(this._b,4);e.writeInt32LE(this._c,8);e.writeInt32LE(this._d,12);e.writeInt32LE(this._e,16);return e};function rotl(e,t){return e<<t|e>>>32-t}function fn1(e,t,r,i,n,a,s,o){return rotl(e+(t^r^i)+a+s|0,o)+n|0}function fn2(e,t,r,i,n,a,s,o){return rotl(e+(t&r|~t&i)+a+s|0,o)+n|0}function fn3(e,t,r,i,n,a,s,o){return rotl(e+((t|~r)^i)+a+s|0,o)+n|0}function fn4(e,t,r,i,n,a,s,o){return rotl(e+(t&i|r&~i)+a+s|0,o)+n|0}function fn5(e,t,r,i,n,a,s,o){return rotl(e+(t^(r|~i))+a+s|0,o)+n|0}e.exports=RIPEMD160},5055:function(e,t,r){var i=r(4300);var n=i.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(n.from&&n.alloc&&n.allocUnsafe&&n.allocUnsafeSlow){e.exports=i}else{copyProps(i,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return n(e,t,r)}SafeBuffer.prototype=Object.create(n.prototype);copyProps(n,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return n(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var i=n(e);if(t!==undefined){if(typeof r==="string"){i.fill(t,r)}else{i.fill(t)}}else{i.fill(0)}return i};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i.SlowBuffer(e)}},2858:function(e,t,r){var i=r(5055).Buffer;function Hash(e,t){this._block=i.alloc(e);this._finalSize=t;this._blockSize=e;this._len=0}Hash.prototype.update=function(e,t){if(typeof e==="string"){t=t||"utf8";e=i.from(e,t)}var r=this._block;var n=this._blockSize;var a=e.length;var s=this._len;for(var o=0;o<a;){var h=s%n;var u=Math.min(a-o,n-h);for(var d=0;d<u;d++){r[h+d]=e[o+d]}s+=u;o+=u;if(s%n===0){this._update(r)}}this._len+=a;return this};Hash.prototype.digest=function(e){var t=this._len%this._blockSize;this._block[t]=128;this._block.fill(0,t+1);if(t>=this._finalSize){this._update(this._block);this._block.fill(0)}var r=this._len*8;if(r<=4294967295){this._block.writeUInt32BE(r,this._blockSize-4)}else{var i=(r&4294967295)>>>0;var n=(r-i)/4294967296;this._block.writeUInt32BE(n,this._blockSize-8);this._block.writeUInt32BE(i,this._blockSize-4)}this._update(this._block);var a=this._hash();return e?a.toString(e):a};Hash.prototype._update=function(){throw new Error("_update must be implemented by subclass")};e.exports=Hash},4371:function(e,t,r){var i=e.exports=function SHA(e){e=e.toLowerCase();var t=i[e];if(!t)throw new Error(e+" is not supported (we accept pull requests)");return new t};i.sha=r(4018);i.sha1=r(4179);i.sha224=r(532);i.sha256=r(1843);i.sha384=r(7455);i.sha512=r(9934)},4018:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1518500249,1859775393,2400959708|0,3395469782|0];var o=new Array(80);function Sha(){this.init();this._w=o;n.call(this,64,56)}i(Sha,n);Sha.prototype.init=function(){this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520;return this};function rotl5(e){return e<<5|e>>>27}function rotl30(e){return e<<30|e>>>2}function ft(e,t,r,i){if(e===0)return t&r|~t&i;if(e===2)return t&r|t&i|r&i;return t^r^i}Sha.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;for(var h=0;h<16;++h)t[h]=e.readInt32BE(h*4);for(;h<80;++h)t[h]=t[h-3]^t[h-8]^t[h-14]^t[h-16];for(var u=0;u<80;++u){var d=~~(u/20);var c=rotl5(r)+ft(d,i,n,a)+o+t[u]+s[d]|0;o=a;a=n;n=rotl30(i);i=r;r=c}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0};Sha.prototype._hash=function(){var e=a.allocUnsafe(20);e.writeInt32BE(this._a|0,0);e.writeInt32BE(this._b|0,4);e.writeInt32BE(this._c|0,8);e.writeInt32BE(this._d|0,12);e.writeInt32BE(this._e|0,16);return e};e.exports=Sha},4179:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1518500249,1859775393,2400959708|0,3395469782|0];var o=new Array(80);function Sha1(){this.init();this._w=o;n.call(this,64,56)}i(Sha1,n);Sha1.prototype.init=function(){this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520;return this};function rotl1(e){return e<<1|e>>>31}function rotl5(e){return e<<5|e>>>27}function rotl30(e){return e<<30|e>>>2}function ft(e,t,r,i){if(e===0)return t&r|~t&i;if(e===2)return t&r|t&i|r&i;return t^r^i}Sha1.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;for(var h=0;h<16;++h)t[h]=e.readInt32BE(h*4);for(;h<80;++h)t[h]=rotl1(t[h-3]^t[h-8]^t[h-14]^t[h-16]);for(var u=0;u<80;++u){var d=~~(u/20);var c=rotl5(r)+ft(d,i,n,a)+o+t[u]+s[d]|0;o=a;a=n;n=rotl30(i);i=r;r=c}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0};Sha1.prototype._hash=function(){var e=a.allocUnsafe(20);e.writeInt32BE(this._a|0,0);e.writeInt32BE(this._b|0,4);e.writeInt32BE(this._c|0,8);e.writeInt32BE(this._d|0,12);e.writeInt32BE(this._e|0,16);return e};e.exports=Sha1},532:function(e,t,r){var i=r(3782);var n=r(1843);var a=r(2858);var s=r(5055).Buffer;var o=new Array(64);function Sha224(){this.init();this._w=o;a.call(this,64,56)}i(Sha224,n);Sha224.prototype.init=function(){this._a=3238371032;this._b=914150663;this._c=812702999;this._d=4144912697;this._e=4290775857;this._f=1750603025;this._g=1694076839;this._h=3204075428;return this};Sha224.prototype._hash=function(){var e=s.allocUnsafe(28);e.writeInt32BE(this._a,0);e.writeInt32BE(this._b,4);e.writeInt32BE(this._c,8);e.writeInt32BE(this._d,12);e.writeInt32BE(this._e,16);e.writeInt32BE(this._f,20);e.writeInt32BE(this._g,24);return e};e.exports=Sha224},1843:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];var o=new Array(64);function Sha256(){this.init();this._w=o;n.call(this,64,56)}i(Sha256,n);Sha256.prototype.init=function(){this._a=1779033703;this._b=3144134277;this._c=1013904242;this._d=2773480762;this._e=1359893119;this._f=2600822924;this._g=528734635;this._h=1541459225;return this};function ch(e,t,r){return r^e&(t^r)}function maj(e,t,r){return e&t|r&(e|t)}function sigma0(e){return(e>>>2|e<<30)^(e>>>13|e<<19)^(e>>>22|e<<10)}function sigma1(e){return(e>>>6|e<<26)^(e>>>11|e<<21)^(e>>>25|e<<7)}function gamma0(e){return(e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3}function gamma1(e){return(e>>>17|e<<15)^(e>>>19|e<<13)^e>>>10}Sha256.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;var h=this._f|0;var u=this._g|0;var d=this._h|0;for(var c=0;c<16;++c)t[c]=e.readInt32BE(c*4);for(;c<64;++c)t[c]=gamma1(t[c-2])+t[c-7]+gamma0(t[c-15])+t[c-16]|0;for(var l=0;l<64;++l){var p=d+sigma1(o)+ch(o,h,u)+s[l]+t[l]|0;var v=sigma0(r)+maj(r,i,n)|0;d=u;u=h;h=o;o=a+p|0;a=n;n=i;i=r;r=p+v|0}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0;this._f=h+this._f|0;this._g=u+this._g|0;this._h=d+this._h|0};Sha256.prototype._hash=function(){var e=a.allocUnsafe(32);e.writeInt32BE(this._a,0);e.writeInt32BE(this._b,4);e.writeInt32BE(this._c,8);e.writeInt32BE(this._d,12);e.writeInt32BE(this._e,16);e.writeInt32BE(this._f,20);e.writeInt32BE(this._g,24);e.writeInt32BE(this._h,28);return e};e.exports=Sha256},7455:function(e,t,r){var i=r(3782);var n=r(9934);var a=r(2858);var s=r(5055).Buffer;var o=new Array(160);function Sha384(){this.init();this._w=o;a.call(this,128,112)}i(Sha384,n);Sha384.prototype.init=function(){this._ah=3418070365;this._bh=1654270250;this._ch=2438529370;this._dh=355462360;this._eh=1731405415;this._fh=2394180231;this._gh=3675008525;this._hh=1203062813;this._al=3238371032;this._bl=914150663;this._cl=812702999;this._dl=4144912697;this._el=4290775857;this._fl=1750603025;this._gl=1694076839;this._hl=3204075428;return this};Sha384.prototype._hash=function(){var e=s.allocUnsafe(48);function writeInt64BE(t,r,i){e.writeInt32BE(t,i);e.writeInt32BE(r,i+4)}writeInt64BE(this._ah,this._al,0);writeInt64BE(this._bh,this._bl,8);writeInt64BE(this._ch,this._cl,16);writeInt64BE(this._dh,this._dl,24);writeInt64BE(this._eh,this._el,32);writeInt64BE(this._fh,this._fl,40);return e};e.exports=Sha384},9934:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];var o=new Array(160);function Sha512(){this.init();this._w=o;n.call(this,128,112)}i(Sha512,n);Sha512.prototype.init=function(){this._ah=1779033703;this._bh=3144134277;this._ch=1013904242;this._dh=2773480762;this._eh=1359893119;this._fh=2600822924;this._gh=528734635;this._hh=1541459225;this._al=4089235720;this._bl=2227873595;this._cl=4271175723;this._dl=1595750129;this._el=2917565137;this._fl=725511199;this._gl=4215389547;this._hl=327033209;return this};function Ch(e,t,r){return r^e&(t^r)}function maj(e,t,r){return e&t|r&(e|t)}function sigma0(e,t){return(e>>>28|t<<4)^(t>>>2|e<<30)^(t>>>7|e<<25)}function sigma1(e,t){return(e>>>14|t<<18)^(e>>>18|t<<14)^(t>>>9|e<<23)}function Gamma0(e,t){return(e>>>1|t<<31)^(e>>>8|t<<24)^e>>>7}function Gamma0l(e,t){return(e>>>1|t<<31)^(e>>>8|t<<24)^(e>>>7|t<<25)}function Gamma1(e,t){return(e>>>19|t<<13)^(t>>>29|e<<3)^e>>>6}function Gamma1l(e,t){return(e>>>19|t<<13)^(t>>>29|e<<3)^(e>>>6|t<<26)}function getCarry(e,t){return e>>>0<t>>>0?1:0}Sha512.prototype._update=function(e){var t=this._w;var r=this._ah|0;var i=this._bh|0;var n=this._ch|0;var a=this._dh|0;var o=this._eh|0;var h=this._fh|0;var u=this._gh|0;var d=this._hh|0;var c=this._al|0;var l=this._bl|0;var p=this._cl|0;var v=this._dl|0;var b=this._el|0;var m=this._fl|0;var y=this._gl|0;var g=this._hl|0;for(var _=0;_<32;_+=2){t[_]=e.readInt32BE(_*4);t[_+1]=e.readInt32BE(_*4+4)}for(;_<160;_+=2){var w=t[_-15*2];var M=t[_-15*2+1];var B=Gamma0(w,M);var E=Gamma0l(M,w);w=t[_-2*2];M=t[_-2*2+1];var k=Gamma1(w,M);var A=Gamma1l(M,w);var N=t[_-7*2];var P=t[_-7*2+1];var x=t[_-16*2];var I=t[_-16*2+1];var C=E+P|0;var D=B+N+getCarry(C,E)|0;C=C+A|0;D=D+k+getCarry(C,A)|0;C=C+I|0;D=D+x+getCarry(C,I)|0;t[_]=D;t[_+1]=C}for(var T=0;T<160;T+=2){D=t[T];C=t[T+1];var j=maj(r,i,n);var q=maj(c,l,p);var O=sigma0(r,c);var H=sigma0(c,r);var L=sigma1(o,b);var z=sigma1(b,o);var F=s[T];var U=s[T+1];var W=Ch(o,h,u);var V=Ch(b,m,y);var G=g+z|0;var J=d+L+getCarry(G,g)|0;G=G+V|0;J=J+W+getCarry(G,V)|0;G=G+U|0;J=J+F+getCarry(G,U)|0;G=G+C|0;J=J+D+getCarry(G,C)|0;var Z=H+q|0;var X=O+j+getCarry(Z,H)|0;d=u;g=y;u=h;y=m;h=o;m=b;b=v+G|0;o=a+J+getCarry(b,v)|0;a=n;v=p;n=i;p=l;i=r;l=c;c=G+Z|0;r=J+X+getCarry(c,G)|0}this._al=this._al+c|0;this._bl=this._bl+l|0;this._cl=this._cl+p|0;this._dl=this._dl+v|0;this._el=this._el+b|0;this._fl=this._fl+m|0;this._gl=this._gl+y|0;this._hl=this._hl+g|0;this._ah=this._ah+r+getCarry(this._al,c)|0;this._bh=this._bh+i+getCarry(this._bl,l)|0;this._ch=this._ch+n+getCarry(this._cl,p)|0;this._dh=this._dh+a+getCarry(this._dl,v)|0;this._eh=this._eh+o+getCarry(this._el,b)|0;this._fh=this._fh+h+getCarry(this._fl,m)|0;this._gh=this._gh+u+getCarry(this._gl,y)|0;this._hh=this._hh+d+getCarry(this._hl,g)|0};Sha512.prototype._hash=function(){var e=a.allocUnsafe(64);function writeInt64BE(t,r,i){e.writeInt32BE(t,i);e.writeInt32BE(r,i+4)}writeInt64BE(this._ah,this._al,0);writeInt64BE(this._bh,this._bl,8);writeInt64BE(this._ch,this._cl,16);writeInt64BE(this._dh,this._dl,24);writeInt64BE(this._eh,this._el,32);writeInt64BE(this._fh,this._fl,40);writeInt64BE(this._gh,this._gl,48);writeInt64BE(this._hh,this._hl,56);return e};e.exports=Sha512},3704:function(e,t,r){"use strict";var i=r(5055).Buffer;var n=i.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(i.isEncoding===n||!n(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=i.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var i=t.length-1;if(i<r)return 0;var n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-1;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-2;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0){if(n===2)n=0;else e.lastNeed=n-3}return n}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var i=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,i);return e.toString("utf8",t,i)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var i=r.charCodeAt(r.length-1);if(i>=55296&&i<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},6769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},4300:function(e){"use strict";e.exports=__webpack_require__(48834)},6113:function(e){"use strict";e.exports=__webpack_require__(71941)},2361:function(e){"use strict";e.exports=__webpack_require__(34987)},2781:function(e){"use strict";e.exports=__webpack_require__(37518)},1576:function(e){"use strict";e.exports=__webpack_require__(30214)},3837:function(e){"use strict";e.exports=__webpack_require__(97653)},6144:function(e){"use strict";e.exports=__webpack_require__(64339)},5866:function(e){"use strict";e.exports=JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}')},2908:function(e){"use strict";e.exports=JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}')},9267:function(e){"use strict";e.exports=JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}')},7992:function(e){"use strict";e.exports=JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}')},2531:function(e){"use strict";e.exports={i8:"6.5.3"}},2510:function(e){"use strict";e.exports=JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}')}};var t={};function __nccwpck_require__(r){var i=t[r];if(i!==undefined){return i.exports}var n=t[r]={id:r,loaded:false,exports:{}};var a=true;try{e[r].call(n.exports,n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}n.loaded=true;return n.exports}!function(){__nccwpck_require__.nmd=function(e){e.paths=[];if(!e.children)e.children=[];return e}}();if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r={};!function(){"use strict";var e=r;e.randomBytes=e.rng=e.pseudoRandomBytes=e.prng=__nccwpck_require__(7223);e.createHash=e.Hash=__nccwpck_require__(9739);e.createHmac=e.Hmac=__nccwpck_require__(4873);var t=__nccwpck_require__(9276);var i=Object.keys(t);var n=["sha1","sha224","sha256","sha384","sha512","md5","rmd160"].concat(i);e.getHashes=function(){return n};var a=__nccwpck_require__(4978);e.pbkdf2=a.pbkdf2;e.pbkdf2Sync=a.pbkdf2Sync;var s=__nccwpck_require__(8996);e.Cipher=s.Cipher;e.createCipher=s.createCipher;e.Cipheriv=s.Cipheriv;e.createCipheriv=s.createCipheriv;e.Decipher=s.Decipher;e.createDecipher=s.createDecipher;e.Decipheriv=s.Decipheriv;e.createDecipheriv=s.createDecipheriv;e.getCiphers=s.getCiphers;e.listCiphers=s.listCiphers;var o=__nccwpck_require__(6587);e.DiffieHellmanGroup=o.DiffieHellmanGroup;e.createDiffieHellmanGroup=o.createDiffieHellmanGroup;e.getDiffieHellman=o.getDiffieHellman;e.createDiffieHellman=o.createDiffieHellman;e.DiffieHellman=o.DiffieHellman;var h=__nccwpck_require__(4078);e.createSign=h.createSign;e.Sign=h.Sign;e.createVerify=h.createVerify;e.Verify=h.Verify;e.createECDH=__nccwpck_require__(9942);var u=__nccwpck_require__(9783);e.publicEncrypt=u.publicEncrypt;e.privateEncrypt=u.privateEncrypt;e.publicDecrypt=u.publicDecrypt;e.privateDecrypt=u.privateDecrypt;var d=__nccwpck_require__(6445);e.randomFill=d.randomFill;e.randomFillSync=d.randomFillSync;e.createCredentials=function(){throw new Error(["sorry, createCredentials is not implemented yet","we accept pull requests","https://github.com/crypto-browserify/crypto-browserify"].join("\n"))};e.constants={DH_CHECK_P_NOT_SAFE_PRIME:2,DH_CHECK_P_NOT_PRIME:1,DH_UNABLE_TO_CHECK_GENERATOR:4,DH_NOT_SUITABLE_GENERATOR:8,NPN_ENABLED:1,ALPN_ENABLED:1,RSA_PKCS1_PADDING:1,RSA_SSLV23_PADDING:2,RSA_NO_PADDING:3,RSA_PKCS1_OAEP_PADDING:4,RSA_X931_PADDING:5,RSA_PKCS1_PSS_PADDING:6,POINT_CONVERSION_COMPRESSED:2,POINT_CONVERSION_UNCOMPRESSED:4,POINT_CONVERSION_HYBRID:6}}();module.exports=r})();

/***/ }),

/***/ 34987:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={864:function(e){var t=typeof Reflect==="object"?Reflect:null;var n=t&&typeof t.apply==="function"?t.apply:function ReflectApply(e,t,n){return Function.prototype.apply.call(e,t,n)};var r;if(t&&typeof t.ownKeys==="function"){r=t.ownKeys}else if(Object.getOwnPropertySymbols){r=function ReflectOwnKeys(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}}else{r=function ReflectOwnKeys(e){return Object.getOwnPropertyNames(e)}}function ProcessEmitWarning(e){if(console&&console.warn)console.warn(e)}var i=Number.isNaN||function NumberIsNaN(e){return e!==e};function EventEmitter(){EventEmitter.init.call(this)}e.exports=EventEmitter;e.exports.once=once;EventEmitter.EventEmitter=EventEmitter;EventEmitter.prototype._events=undefined;EventEmitter.prototype._eventsCount=0;EventEmitter.prototype._maxListeners=undefined;var s=10;function checkListener(e){if(typeof e!=="function"){throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof e)}}Object.defineProperty(EventEmitter,"defaultMaxListeners",{enumerable:true,get:function(){return s},set:function(e){if(typeof e!=="number"||e<0||i(e)){throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+e+".")}s=e}});EventEmitter.init=function(){if(this._events===undefined||this._events===Object.getPrototypeOf(this)._events){this._events=Object.create(null);this._eventsCount=0}this._maxListeners=this._maxListeners||undefined};EventEmitter.prototype.setMaxListeners=function setMaxListeners(e){if(typeof e!=="number"||e<0||i(e)){throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+e+".")}this._maxListeners=e;return this};function _getMaxListeners(e){if(e._maxListeners===undefined)return EventEmitter.defaultMaxListeners;return e._maxListeners}EventEmitter.prototype.getMaxListeners=function getMaxListeners(){return _getMaxListeners(this)};EventEmitter.prototype.emit=function emit(e){var t=[];for(var r=1;r<arguments.length;r++)t.push(arguments[r]);var i=e==="error";var s=this._events;if(s!==undefined)i=i&&s.error===undefined;else if(!i)return false;if(i){var o;if(t.length>0)o=t[0];if(o instanceof Error){throw o}var f=new Error("Unhandled error."+(o?" ("+o.message+")":""));f.context=o;throw f}var u=s[e];if(u===undefined)return false;if(typeof u==="function"){n(u,this,t)}else{var a=u.length;var c=arrayClone(u,a);for(var r=0;r<a;++r)n(c[r],this,t)}return true};function _addListener(e,t,n,r){var i;var s;var o;checkListener(n);s=e._events;if(s===undefined){s=e._events=Object.create(null);e._eventsCount=0}else{if(s.newListener!==undefined){e.emit("newListener",t,n.listener?n.listener:n);s=e._events}o=s[t]}if(o===undefined){o=s[t]=n;++e._eventsCount}else{if(typeof o==="function"){o=s[t]=r?[n,o]:[o,n]}else if(r){o.unshift(n)}else{o.push(n)}i=_getMaxListeners(e);if(i>0&&o.length>i&&!o.warned){o.warned=true;var f=new Error("Possible EventEmitter memory leak detected. "+o.length+" "+String(t)+" listeners "+"added. Use emitter.setMaxListeners() to "+"increase limit");f.name="MaxListenersExceededWarning";f.emitter=e;f.type=t;f.count=o.length;ProcessEmitWarning(f)}}return e}EventEmitter.prototype.addListener=function addListener(e,t){return _addListener(this,e,t,false)};EventEmitter.prototype.on=EventEmitter.prototype.addListener;EventEmitter.prototype.prependListener=function prependListener(e,t){return _addListener(this,e,t,true)};function onceWrapper(){if(!this.fired){this.target.removeListener(this.type,this.wrapFn);this.fired=true;if(arguments.length===0)return this.listener.call(this.target);return this.listener.apply(this.target,arguments)}}function _onceWrap(e,t,n){var r={fired:false,wrapFn:undefined,target:e,type:t,listener:n};var i=onceWrapper.bind(r);i.listener=n;r.wrapFn=i;return i}EventEmitter.prototype.once=function once(e,t){checkListener(t);this.on(e,_onceWrap(this,e,t));return this};EventEmitter.prototype.prependOnceListener=function prependOnceListener(e,t){checkListener(t);this.prependListener(e,_onceWrap(this,e,t));return this};EventEmitter.prototype.removeListener=function removeListener(e,t){var n,r,i,s,o;checkListener(t);r=this._events;if(r===undefined)return this;n=r[e];if(n===undefined)return this;if(n===t||n.listener===t){if(--this._eventsCount===0)this._events=Object.create(null);else{delete r[e];if(r.removeListener)this.emit("removeListener",e,n.listener||t)}}else if(typeof n!=="function"){i=-1;for(s=n.length-1;s>=0;s--){if(n[s]===t||n[s].listener===t){o=n[s].listener;i=s;break}}if(i<0)return this;if(i===0)n.shift();else{spliceOne(n,i)}if(n.length===1)r[e]=n[0];if(r.removeListener!==undefined)this.emit("removeListener",e,o||t)}return this};EventEmitter.prototype.off=EventEmitter.prototype.removeListener;EventEmitter.prototype.removeAllListeners=function removeAllListeners(e){var t,n,r;n=this._events;if(n===undefined)return this;if(n.removeListener===undefined){if(arguments.length===0){this._events=Object.create(null);this._eventsCount=0}else if(n[e]!==undefined){if(--this._eventsCount===0)this._events=Object.create(null);else delete n[e]}return this}if(arguments.length===0){var i=Object.keys(n);var s;for(r=0;r<i.length;++r){s=i[r];if(s==="removeListener")continue;this.removeAllListeners(s)}this.removeAllListeners("removeListener");this._events=Object.create(null);this._eventsCount=0;return this}t=n[e];if(typeof t==="function"){this.removeListener(e,t)}else if(t!==undefined){for(r=t.length-1;r>=0;r--){this.removeListener(e,t[r])}}return this};function _listeners(e,t,n){var r=e._events;if(r===undefined)return[];var i=r[t];if(i===undefined)return[];if(typeof i==="function")return n?[i.listener||i]:[i];return n?unwrapListeners(i):arrayClone(i,i.length)}EventEmitter.prototype.listeners=function listeners(e){return _listeners(this,e,true)};EventEmitter.prototype.rawListeners=function rawListeners(e){return _listeners(this,e,false)};EventEmitter.listenerCount=function(e,t){if(typeof e.listenerCount==="function"){return e.listenerCount(t)}else{return listenerCount.call(e,t)}};EventEmitter.prototype.listenerCount=listenerCount;function listenerCount(e){var t=this._events;if(t!==undefined){var n=t[e];if(typeof n==="function"){return 1}else if(n!==undefined){return n.length}}return 0}EventEmitter.prototype.eventNames=function eventNames(){return this._eventsCount>0?r(this._events):[]};function arrayClone(e,t){var n=new Array(t);for(var r=0;r<t;++r)n[r]=e[r];return n}function spliceOne(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop()}function unwrapListeners(e){var t=new Array(e.length);for(var n=0;n<t.length;++n){t[n]=e[n].listener||e[n]}return t}function once(e,t){return new Promise((function(n,r){function errorListener(n){e.removeListener(t,resolver);r(n)}function resolver(){if(typeof e.removeListener==="function"){e.removeListener("error",errorListener)}n([].slice.call(arguments))}eventTargetAgnosticAddListener(e,t,resolver,{once:true});if(t!=="error"){addErrorHandlerIfEventEmitter(e,errorListener,{once:true})}}))}function addErrorHandlerIfEventEmitter(e,t,n){if(typeof e.on==="function"){eventTargetAgnosticAddListener(e,"error",t,n)}}function eventTargetAgnosticAddListener(e,t,n,r){if(typeof e.on==="function"){if(r.once){e.once(t,n)}else{e.on(t,n)}}else if(typeof e.addEventListener==="function"){e.addEventListener(t,(function wrapListener(i){if(r.once){e.removeEventListener(t,wrapListener)}n(i)}))}else{throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type '+typeof e)}}}};var t={};function __nccwpck_require__(n){var r=t[n];if(r!==undefined){return r.exports}var i=t[n]={exports:{}};var s=true;try{e[n](i,i.exports,__nccwpck_require__);s=false}finally{if(s)delete t[n]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n=__nccwpck_require__(864);module.exports=n})();

/***/ }),

/***/ 79192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7925:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 95818:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 83619:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 16789:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 26047:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 84988:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 26895:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 38942:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 37518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(34406);
(function(){var e={782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},646:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},403:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(709);var a=r(337);r(782)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},889:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(170);r(782)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},709:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(678);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(379);var c=r(25);var h=r(776),p=h.getHighWaterMark;var b=r(646).q,g=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var m;var S;r(782)(Readable,o);var R=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(704).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){R(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)R(e,new v);else addChunk(e,a,t,true)}else if(a.ended){R(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new g("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(704).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){R(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)R(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(m===undefined){m=r(871)}return m(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(S===undefined){S=r(727)}return S(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},170:function(e,t,r){"use strict";e.exports=Transform;var n=r(646).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(403);r(782)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(769)};var a=r(678);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(25);var l=r(776),u=l.getHighWaterMark;var d=r(646).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,g=d.ERR_STREAM_DESTROYED,y=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var w=f.errorOrDestroy;r(782)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var m;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){m=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(m.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{m=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(403);var t=this instanceof n;if(!t&&!m.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new _;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new y}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){w(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new g("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,n)}else{i(n);e._writableState.errorEmitted=true;w(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},871:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(698);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},25:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},698:function(e,t,r){"use strict";var n=r(646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},442:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(646).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(698);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},776:function(e,t,r){"use strict";var n=r(646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},678:function(e,t,r){e.exports=r(781)},55:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},173:function(e,t,r){e.exports=Stream;var n=r(361).EventEmitter;var i=r(782);i(Stream,n);Stream.Readable=r(709);Stream.Writable=r(337);Stream.Duplex=r(403);Stream.Transform=r(170);Stream.PassThrough=r(889);Stream.finished=r(698);Stream.pipeline=r(442);Stream.Stream=Stream;function Stream(){n.call(this)}Stream.prototype.pipe=function(e,t){var r=this;function ondata(t){if(e.writable){if(false===e.write(t)&&r.pause){r.pause()}}}r.on("data",ondata);function ondrain(){if(r.readable&&r.resume){r.resume()}}e.on("drain",ondrain);if(!e._isStdio&&(!t||t.end!==false)){r.on("end",onend);r.on("close",onclose)}var i=false;function onend(){if(i)return;i=true;e.end()}function onclose(){if(i)return;i=true;if(typeof e.destroy==="function")e.destroy()}function onerror(e){cleanup();if(n.listenerCount(this,"error")===0){throw e}}r.on("error",onerror);e.on("error",onerror);function cleanup(){r.removeListener("data",ondata);e.removeListener("drain",ondrain);r.removeListener("end",onend);r.removeListener("close",onclose);r.removeListener("error",onerror);e.removeListener("error",onerror);r.removeListener("end",cleanup);r.removeListener("close",cleanup);e.removeListener("close",cleanup)}r.on("end",cleanup);r.on("close",cleanup);e.on("close",cleanup);e.emit("pipe",r);return e}},704:function(e,t,r){"use strict";var n=r(55).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},300:function(e){"use strict";e.exports=__webpack_require__(48834)},361:function(e){"use strict";e.exports=__webpack_require__(34987)},781:function(e){"use strict";e.exports=(__webpack_require__(34987).EventEmitter)},837:function(e){"use strict";e.exports=__webpack_require__(97653)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(173);module.exports=r})();

/***/ }),

/***/ 97653:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(48834)["Buffer"];
/* provided dependency */ var process = __webpack_require__(34406);
(function(){var r={992:function(r){r.exports=function(r,t,n){if(r.filter)return r.filter(t,n);if(void 0===r||null===r)throw new TypeError;if("function"!=typeof t)throw new TypeError;var o=[];for(var i=0;i<r.length;i++){if(!e.call(r,i))continue;var a=r[i];if(t.call(n,a,i,r))o.push(a)}return o};var e=Object.prototype.hasOwnProperty},256:function(r,e,t){"use strict";var n=t(838);var o=t(139);var i=o(n("String.prototype.indexOf"));r.exports=function callBoundIntrinsic(r,e){var t=n(r,!!e);if(typeof t==="function"&&i(r,".prototype.")>-1){return o(t)}return t}},139:function(r,e,t){"use strict";var n=t(174);var o=t(838);var i=o("%Function.prototype.apply%");var a=o("%Function.prototype.call%");var f=o("%Reflect.apply%",true)||n.call(a,i);var u=o("%Object.getOwnPropertyDescriptor%",true);var s=o("%Object.defineProperty%",true);var y=o("%Math.max%");if(s){try{s({},"a",{value:1})}catch(r){s=null}}r.exports=function callBind(r){var e=f(n,a,arguments);if(u&&s){var t=u(e,"length");if(t.configurable){s(e,"length",{value:1+y(0,r.length-(arguments.length-1))})}}return e};var c=function applyBind(){return f(n,i,arguments)};if(s){s(r.exports,"apply",{value:c})}else{r.exports.apply=c}},144:function(r){var e=Object.prototype.hasOwnProperty;var t=Object.prototype.toString;r.exports=function forEach(r,n,o){if(t.call(n)!=="[object Function]"){throw new TypeError("iterator must be a function")}var i=r.length;if(i===+i){for(var a=0;a<i;a++){n.call(o,r[a],a,r)}}else{for(var f in r){if(e.call(r,f)){n.call(o,r[f],f,r)}}}}},426:function(r){"use strict";var e="Function.prototype.bind called on incompatible ";var t=Array.prototype.slice;var n=Object.prototype.toString;var o="[object Function]";r.exports=function bind(r){var i=this;if(typeof i!=="function"||n.call(i)!==o){throw new TypeError(e+i)}var a=t.call(arguments,1);var f;var binder=function(){if(this instanceof f){var e=i.apply(this,a.concat(t.call(arguments)));if(Object(e)===e){return e}return this}else{return i.apply(r,a.concat(t.call(arguments)))}};var u=Math.max(0,i.length-a.length);var s=[];for(var y=0;y<u;y++){s.push("$"+y)}f=Function("binder","return function ("+s.join(",")+"){ return binder.apply(this,arguments); }")(binder);if(i.prototype){var c=function Empty(){};c.prototype=i.prototype;f.prototype=new c;c.prototype=null}return f}},174:function(r,e,t){"use strict";var n=t(426);r.exports=Function.prototype.bind||n},838:function(r,e,t){"use strict";var n;var o=SyntaxError;var i=Function;var a=TypeError;var getEvalledConstructor=function(r){try{return i('"use strict"; return ('+r+").constructor;")()}catch(r){}};var f=Object.getOwnPropertyDescriptor;if(f){try{f({},"")}catch(r){f=null}}var throwTypeError=function(){throw new a};var u=f?function(){try{arguments.callee;return throwTypeError}catch(r){try{return f(arguments,"callee").get}catch(r){return throwTypeError}}}():throwTypeError;var s=t(115)();var y=Object.getPrototypeOf||function(r){return r.__proto__};var c={};var p=typeof Uint8Array==="undefined"?n:y(Uint8Array);var l={"%AggregateError%":typeof AggregateError==="undefined"?n:AggregateError,"%Array%":Array,"%ArrayBuffer%":typeof ArrayBuffer==="undefined"?n:ArrayBuffer,"%ArrayIteratorPrototype%":s?y([][Symbol.iterator]()):n,"%AsyncFromSyncIteratorPrototype%":n,"%AsyncFunction%":c,"%AsyncGenerator%":c,"%AsyncGeneratorFunction%":c,"%AsyncIteratorPrototype%":c,"%Atomics%":typeof Atomics==="undefined"?n:Atomics,"%BigInt%":typeof BigInt==="undefined"?n:BigInt,"%Boolean%":Boolean,"%DataView%":typeof DataView==="undefined"?n:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":typeof Float32Array==="undefined"?n:Float32Array,"%Float64Array%":typeof Float64Array==="undefined"?n:Float64Array,"%FinalizationRegistry%":typeof FinalizationRegistry==="undefined"?n:FinalizationRegistry,"%Function%":i,"%GeneratorFunction%":c,"%Int8Array%":typeof Int8Array==="undefined"?n:Int8Array,"%Int16Array%":typeof Int16Array==="undefined"?n:Int16Array,"%Int32Array%":typeof Int32Array==="undefined"?n:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":s?y(y([][Symbol.iterator]())):n,"%JSON%":typeof JSON==="object"?JSON:n,"%Map%":typeof Map==="undefined"?n:Map,"%MapIteratorPrototype%":typeof Map==="undefined"||!s?n:y((new Map)[Symbol.iterator]()),"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":typeof Promise==="undefined"?n:Promise,"%Proxy%":typeof Proxy==="undefined"?n:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":typeof Reflect==="undefined"?n:Reflect,"%RegExp%":RegExp,"%Set%":typeof Set==="undefined"?n:Set,"%SetIteratorPrototype%":typeof Set==="undefined"||!s?n:y((new Set)[Symbol.iterator]()),"%SharedArrayBuffer%":typeof SharedArrayBuffer==="undefined"?n:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":s?y(""[Symbol.iterator]()):n,"%Symbol%":s?Symbol:n,"%SyntaxError%":o,"%ThrowTypeError%":u,"%TypedArray%":p,"%TypeError%":a,"%Uint8Array%":typeof Uint8Array==="undefined"?n:Uint8Array,"%Uint8ClampedArray%":typeof Uint8ClampedArray==="undefined"?n:Uint8ClampedArray,"%Uint16Array%":typeof Uint16Array==="undefined"?n:Uint16Array,"%Uint32Array%":typeof Uint32Array==="undefined"?n:Uint32Array,"%URIError%":URIError,"%WeakMap%":typeof WeakMap==="undefined"?n:WeakMap,"%WeakRef%":typeof WeakRef==="undefined"?n:WeakRef,"%WeakSet%":typeof WeakSet==="undefined"?n:WeakSet};var g=function doEval(r){var e;if(r==="%AsyncFunction%"){e=getEvalledConstructor("async function () {}")}else if(r==="%GeneratorFunction%"){e=getEvalledConstructor("function* () {}")}else if(r==="%AsyncGeneratorFunction%"){e=getEvalledConstructor("async function* () {}")}else if(r==="%AsyncGenerator%"){var t=doEval("%AsyncGeneratorFunction%");if(t){e=t.prototype}}else if(r==="%AsyncIteratorPrototype%"){var n=doEval("%AsyncGenerator%");if(n){e=y(n.prototype)}}l[r]=e;return e};var b={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]};var d=t(174);var v=t(101);var m=d.call(Function.call,Array.prototype.concat);var S=d.call(Function.apply,Array.prototype.splice);var A=d.call(Function.call,String.prototype.replace);var h=d.call(Function.call,String.prototype.slice);var O=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;var j=/\\(\\)?/g;var w=function stringToPath(r){var e=h(r,0,1);var t=h(r,-1);if(e==="%"&&t!=="%"){throw new o("invalid intrinsic syntax, expected closing `%`")}else if(t==="%"&&e!=="%"){throw new o("invalid intrinsic syntax, expected opening `%`")}var n=[];A(r,O,(function(r,e,t,o){n[n.length]=t?A(o,j,"$1"):e||r}));return n};var P=function getBaseIntrinsic(r,e){var t=r;var n;if(v(b,t)){n=b[t];t="%"+n[0]+"%"}if(v(l,t)){var i=l[t];if(i===c){i=g(t)}if(typeof i==="undefined"&&!e){throw new a("intrinsic "+r+" exists, but is not available. Please file an issue!")}return{alias:n,name:t,value:i}}throw new o("intrinsic "+r+" does not exist!")};r.exports=function GetIntrinsic(r,e){if(typeof r!=="string"||r.length===0){throw new a("intrinsic name must be a non-empty string")}if(arguments.length>1&&typeof e!=="boolean"){throw new a('"allowMissing" argument must be a boolean')}var t=w(r);var i=t.length>0?t[0]:"";var u=P("%"+i+"%",e);var s=u.name;var y=u.value;var c=false;var p=u.alias;if(p){i=p[0];S(t,m([0,1],p))}for(var g=1,b=true;g<t.length;g+=1){var d=t[g];var A=h(d,0,1);var O=h(d,-1);if((A==='"'||A==="'"||A==="`"||(O==='"'||O==="'"||O==="`"))&&A!==O){throw new o("property names with quotes must have matching quotes")}if(d==="constructor"||!b){c=true}i+="."+d;s="%"+i+"%";if(v(l,s)){y=l[s]}else if(y!=null){if(!(d in y)){if(!e){throw new a("base intrinsic for "+r+" exists, but the property is not available.")}return void n}if(f&&g+1>=t.length){var j=f(y,d);b=!!j;if(b&&"get"in j&&!("originalValue"in j.get)){y=j.get}else{y=y[d]}}else{b=v(y,d);y=y[d]}if(b&&!c){l[s]=y}}}return y}},942:function(r,e,t){"use strict";var n=typeof Symbol!=="undefined"&&Symbol;var o=t(773);r.exports=function hasNativeSymbols(){if(typeof n!=="function"){return false}if(typeof Symbol!=="function"){return false}if(typeof n("foo")!=="symbol"){return false}if(typeof Symbol("bar")!=="symbol"){return false}return o()}},773:function(r){"use strict";r.exports=function hasSymbols(){if(typeof Symbol!=="function"||typeof Object.getOwnPropertySymbols!=="function"){return false}if(typeof Symbol.iterator==="symbol"){return true}var r={};var e=Symbol("test");var t=Object(e);if(typeof e==="string"){return false}if(Object.prototype.toString.call(e)!=="[object Symbol]"){return false}if(Object.prototype.toString.call(t)!=="[object Symbol]"){return false}var n=42;r[e]=n;for(e in r){return false}if(typeof Object.keys==="function"&&Object.keys(r).length!==0){return false}if(typeof Object.getOwnPropertyNames==="function"&&Object.getOwnPropertyNames(r).length!==0){return false}var o=Object.getOwnPropertySymbols(r);if(o.length!==1||o[0]!==e){return false}if(!Object.prototype.propertyIsEnumerable.call(r,e)){return false}if(typeof Object.getOwnPropertyDescriptor==="function"){var i=Object.getOwnPropertyDescriptor(r,e);if(i.value!==n||i.enumerable!==true){return false}}return true}},115:function(r,e,t){"use strict";var n=typeof Symbol!=="undefined"&&Symbol;var o=t(832);r.exports=function hasNativeSymbols(){if(typeof n!=="function"){return false}if(typeof Symbol!=="function"){return false}if(typeof n("foo")!=="symbol"){return false}if(typeof Symbol("bar")!=="symbol"){return false}return o()}},832:function(r){"use strict";r.exports=function hasSymbols(){if(typeof Symbol!=="function"||typeof Object.getOwnPropertySymbols!=="function"){return false}if(typeof Symbol.iterator==="symbol"){return true}var r={};var e=Symbol("test");var t=Object(e);if(typeof e==="string"){return false}if(Object.prototype.toString.call(e)!=="[object Symbol]"){return false}if(Object.prototype.toString.call(t)!=="[object Symbol]"){return false}var n=42;r[e]=n;for(e in r){return false}if(typeof Object.keys==="function"&&Object.keys(r).length!==0){return false}if(typeof Object.getOwnPropertyNames==="function"&&Object.getOwnPropertyNames(r).length!==0){return false}var o=Object.getOwnPropertySymbols(r);if(o.length!==1||o[0]!==e){return false}if(!Object.prototype.propertyIsEnumerable.call(r,e)){return false}if(typeof Object.getOwnPropertyDescriptor==="function"){var i=Object.getOwnPropertyDescriptor(r,e);if(i.value!==n||i.enumerable!==true){return false}}return true}},101:function(r,e,t){"use strict";var n=t(174);r.exports=n.call(Function.call,Object.prototype.hasOwnProperty)},782:function(r){if(typeof Object.create==="function"){r.exports=function inherits(r,e){if(e){r.super_=e;r.prototype=Object.create(e.prototype,{constructor:{value:r,enumerable:false,writable:true,configurable:true}})}}}else{r.exports=function inherits(r,e){if(e){r.super_=e;var TempCtor=function(){};TempCtor.prototype=e.prototype;r.prototype=new TempCtor;r.prototype.constructor=r}}}},157:function(r){"use strict";var e=typeof Symbol==="function"&&typeof Symbol.toStringTag==="symbol";var t=Object.prototype.toString;var n=function isArguments(r){if(e&&r&&typeof r==="object"&&Symbol.toStringTag in r){return false}return t.call(r)==="[object Arguments]"};var o=function isArguments(r){if(n(r)){return true}return r!==null&&typeof r==="object"&&typeof r.length==="number"&&r.length>=0&&t.call(r)!=="[object Array]"&&t.call(r.callee)==="[object Function]"};var i=function(){return n(arguments)}();n.isLegacyArguments=o;r.exports=i?n:o},391:function(r){"use strict";var e=Object.prototype.toString;var t=Function.prototype.toString;var n=/^\s*(?:function)?\*/;var o=typeof Symbol==="function"&&typeof Symbol.toStringTag==="symbol";var i=Object.getPrototypeOf;var getGeneratorFunc=function(){if(!o){return false}try{return Function("return function*() {}")()}catch(r){}};var a=getGeneratorFunc();var f=a?i(a):{};r.exports=function isGeneratorFunction(r){if(typeof r!=="function"){return false}if(n.test(t.call(r))){return true}if(!o){var a=e.call(r);return a==="[object GeneratorFunction]"}return i(r)===f}},994:function(r,e,t){"use strict";var n=t(144);var o=t(349);var i=t(256);var a=i("Object.prototype.toString");var f=t(942)();var u=f&&typeof Symbol.toStringTag==="symbol";var s=o();var y=i("Array.prototype.indexOf",true)||function indexOf(r,e){for(var t=0;t<r.length;t+=1){if(r[t]===e){return t}}return-1};var c=i("String.prototype.slice");var p={};var l=t(466);var g=Object.getPrototypeOf;if(u&&l&&g){n(s,(function(r){var e=new __webpack_require__.g[r];if(!(Symbol.toStringTag in e)){throw new EvalError("this engine has support for Symbol.toStringTag, but "+r+" does not have the property! Please report this.")}var t=g(e);var n=l(t,Symbol.toStringTag);if(!n){var o=g(t);n=l(o,Symbol.toStringTag)}p[r]=n.get}))}var b=function tryAllTypedArrays(r){var e=false;n(p,(function(t,n){if(!e){try{e=t.call(r)===n}catch(r){}}}));return e};r.exports=function isTypedArray(r){if(!r||typeof r!=="object"){return false}if(!u){var e=c(a(r),8,-1);return y(s,e)>-1}if(!l){return false}return b(r)}},369:function(r){r.exports=function isBuffer(r){return r instanceof Buffer}},584:function(r,e,t){"use strict";var n=t(157);var o=t(391);var i=t(490);var a=t(994);function uncurryThis(r){return r.call.bind(r)}var f=typeof BigInt!=="undefined";var u=typeof Symbol!=="undefined";var s=uncurryThis(Object.prototype.toString);var y=uncurryThis(Number.prototype.valueOf);var c=uncurryThis(String.prototype.valueOf);var p=uncurryThis(Boolean.prototype.valueOf);if(f){var l=uncurryThis(BigInt.prototype.valueOf)}if(u){var g=uncurryThis(Symbol.prototype.valueOf)}function checkBoxedPrimitive(r,e){if(typeof r!=="object"){return false}try{e(r);return true}catch(r){return false}}e.isArgumentsObject=n;e.isGeneratorFunction=o;e.isTypedArray=a;function isPromise(r){return typeof Promise!=="undefined"&&r instanceof Promise||r!==null&&typeof r==="object"&&typeof r.then==="function"&&typeof r.catch==="function"}e.isPromise=isPromise;function isArrayBufferView(r){if(typeof ArrayBuffer!=="undefined"&&ArrayBuffer.isView){return ArrayBuffer.isView(r)}return a(r)||isDataView(r)}e.isArrayBufferView=isArrayBufferView;function isUint8Array(r){return i(r)==="Uint8Array"}e.isUint8Array=isUint8Array;function isUint8ClampedArray(r){return i(r)==="Uint8ClampedArray"}e.isUint8ClampedArray=isUint8ClampedArray;function isUint16Array(r){return i(r)==="Uint16Array"}e.isUint16Array=isUint16Array;function isUint32Array(r){return i(r)==="Uint32Array"}e.isUint32Array=isUint32Array;function isInt8Array(r){return i(r)==="Int8Array"}e.isInt8Array=isInt8Array;function isInt16Array(r){return i(r)==="Int16Array"}e.isInt16Array=isInt16Array;function isInt32Array(r){return i(r)==="Int32Array"}e.isInt32Array=isInt32Array;function isFloat32Array(r){return i(r)==="Float32Array"}e.isFloat32Array=isFloat32Array;function isFloat64Array(r){return i(r)==="Float64Array"}e.isFloat64Array=isFloat64Array;function isBigInt64Array(r){return i(r)==="BigInt64Array"}e.isBigInt64Array=isBigInt64Array;function isBigUint64Array(r){return i(r)==="BigUint64Array"}e.isBigUint64Array=isBigUint64Array;function isMapToString(r){return s(r)==="[object Map]"}isMapToString.working=typeof Map!=="undefined"&&isMapToString(new Map);function isMap(r){if(typeof Map==="undefined"){return false}return isMapToString.working?isMapToString(r):r instanceof Map}e.isMap=isMap;function isSetToString(r){return s(r)==="[object Set]"}isSetToString.working=typeof Set!=="undefined"&&isSetToString(new Set);function isSet(r){if(typeof Set==="undefined"){return false}return isSetToString.working?isSetToString(r):r instanceof Set}e.isSet=isSet;function isWeakMapToString(r){return s(r)==="[object WeakMap]"}isWeakMapToString.working=typeof WeakMap!=="undefined"&&isWeakMapToString(new WeakMap);function isWeakMap(r){if(typeof WeakMap==="undefined"){return false}return isWeakMapToString.working?isWeakMapToString(r):r instanceof WeakMap}e.isWeakMap=isWeakMap;function isWeakSetToString(r){return s(r)==="[object WeakSet]"}isWeakSetToString.working=typeof WeakSet!=="undefined"&&isWeakSetToString(new WeakSet);function isWeakSet(r){return isWeakSetToString(r)}e.isWeakSet=isWeakSet;function isArrayBufferToString(r){return s(r)==="[object ArrayBuffer]"}isArrayBufferToString.working=typeof ArrayBuffer!=="undefined"&&isArrayBufferToString(new ArrayBuffer);function isArrayBuffer(r){if(typeof ArrayBuffer==="undefined"){return false}return isArrayBufferToString.working?isArrayBufferToString(r):r instanceof ArrayBuffer}e.isArrayBuffer=isArrayBuffer;function isDataViewToString(r){return s(r)==="[object DataView]"}isDataViewToString.working=typeof ArrayBuffer!=="undefined"&&typeof DataView!=="undefined"&&isDataViewToString(new DataView(new ArrayBuffer(1),0,1));function isDataView(r){if(typeof DataView==="undefined"){return false}return isDataViewToString.working?isDataViewToString(r):r instanceof DataView}e.isDataView=isDataView;var b=typeof SharedArrayBuffer!=="undefined"?SharedArrayBuffer:undefined;function isSharedArrayBufferToString(r){return s(r)==="[object SharedArrayBuffer]"}function isSharedArrayBuffer(r){if(typeof b==="undefined"){return false}if(typeof isSharedArrayBufferToString.working==="undefined"){isSharedArrayBufferToString.working=isSharedArrayBufferToString(new b)}return isSharedArrayBufferToString.working?isSharedArrayBufferToString(r):r instanceof b}e.isSharedArrayBuffer=isSharedArrayBuffer;function isAsyncFunction(r){return s(r)==="[object AsyncFunction]"}e.isAsyncFunction=isAsyncFunction;function isMapIterator(r){return s(r)==="[object Map Iterator]"}e.isMapIterator=isMapIterator;function isSetIterator(r){return s(r)==="[object Set Iterator]"}e.isSetIterator=isSetIterator;function isGeneratorObject(r){return s(r)==="[object Generator]"}e.isGeneratorObject=isGeneratorObject;function isWebAssemblyCompiledModule(r){return s(r)==="[object WebAssembly.Module]"}e.isWebAssemblyCompiledModule=isWebAssemblyCompiledModule;function isNumberObject(r){return checkBoxedPrimitive(r,y)}e.isNumberObject=isNumberObject;function isStringObject(r){return checkBoxedPrimitive(r,c)}e.isStringObject=isStringObject;function isBooleanObject(r){return checkBoxedPrimitive(r,p)}e.isBooleanObject=isBooleanObject;function isBigIntObject(r){return f&&checkBoxedPrimitive(r,l)}e.isBigIntObject=isBigIntObject;function isSymbolObject(r){return u&&checkBoxedPrimitive(r,g)}e.isSymbolObject=isSymbolObject;function isBoxedPrimitive(r){return isNumberObject(r)||isStringObject(r)||isBooleanObject(r)||isBigIntObject(r)||isSymbolObject(r)}e.isBoxedPrimitive=isBoxedPrimitive;function isAnyArrayBuffer(r){return typeof Uint8Array!=="undefined"&&(isArrayBuffer(r)||isSharedArrayBuffer(r))}e.isAnyArrayBuffer=isAnyArrayBuffer;["isProxy","isExternal","isModuleNamespaceObject"].forEach((function(r){Object.defineProperty(e,r,{enumerable:false,value:function(){throw new Error(r+" is not supported in userland")}})}))},177:function(r,e,t){var n=Object.getOwnPropertyDescriptors||function getOwnPropertyDescriptors(r){var e=Object.keys(r);var t={};for(var n=0;n<e.length;n++){t[e[n]]=Object.getOwnPropertyDescriptor(r,e[n])}return t};var o=/%[sdj%]/g;e.format=function(r){if(!isString(r)){var e=[];for(var t=0;t<arguments.length;t++){e.push(inspect(arguments[t]))}return e.join(" ")}var t=1;var n=arguments;var i=n.length;var a=String(r).replace(o,(function(r){if(r==="%%")return"%";if(t>=i)return r;switch(r){case"%s":return String(n[t++]);case"%d":return Number(n[t++]);case"%j":try{return JSON.stringify(n[t++])}catch(r){return"[Circular]"}default:return r}}));for(var f=n[t];t<i;f=n[++t]){if(isNull(f)||!isObject(f)){a+=" "+f}else{a+=" "+inspect(f)}}return a};e.deprecate=function(r,t){if(typeof process!=="undefined"&&process.noDeprecation===true){return r}if(typeof process==="undefined"){return function(){return e.deprecate(r,t).apply(this,arguments)}}var n=false;function deprecated(){if(!n){if(process.throwDeprecation){throw new Error(t)}else if(process.traceDeprecation){console.trace(t)}else{console.error(t)}n=true}return r.apply(this,arguments)}return deprecated};var i={};var a=/^$/;if(process.env.NODE_DEBUG){var f=process.env.NODE_DEBUG;f=f.replace(/[|\\{}()[\]^$+?.]/g,"\\$&").replace(/\*/g,".*").replace(/,/g,"$|^").toUpperCase();a=new RegExp("^"+f+"$","i")}e.debuglog=function(r){r=r.toUpperCase();if(!i[r]){if(a.test(r)){var t=process.pid;i[r]=function(){var n=e.format.apply(e,arguments);console.error("%s %d: %s",r,t,n)}}else{i[r]=function(){}}}return i[r]};function inspect(r,t){var n={seen:[],stylize:stylizeNoColor};if(arguments.length>=3)n.depth=arguments[2];if(arguments.length>=4)n.colors=arguments[3];if(isBoolean(t)){n.showHidden=t}else if(t){e._extend(n,t)}if(isUndefined(n.showHidden))n.showHidden=false;if(isUndefined(n.depth))n.depth=2;if(isUndefined(n.colors))n.colors=false;if(isUndefined(n.customInspect))n.customInspect=true;if(n.colors)n.stylize=stylizeWithColor;return formatValue(n,r,n.depth)}e.inspect=inspect;inspect.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]};inspect.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey",null:"bold",string:"green",date:"magenta",regexp:"red"};function stylizeWithColor(r,e){var t=inspect.styles[e];if(t){return"["+inspect.colors[t][0]+"m"+r+"["+inspect.colors[t][1]+"m"}else{return r}}function stylizeNoColor(r,e){return r}function arrayToHash(r){var e={};r.forEach((function(r,t){e[r]=true}));return e}function formatValue(r,t,n){if(r.customInspect&&t&&isFunction(t.inspect)&&t.inspect!==e.inspect&&!(t.constructor&&t.constructor.prototype===t)){var o=t.inspect(n,r);if(!isString(o)){o=formatValue(r,o,n)}return o}var i=formatPrimitive(r,t);if(i){return i}var a=Object.keys(t);var f=arrayToHash(a);if(r.showHidden){a=Object.getOwnPropertyNames(t)}if(isError(t)&&(a.indexOf("message")>=0||a.indexOf("description")>=0)){return formatError(t)}if(a.length===0){if(isFunction(t)){var u=t.name?": "+t.name:"";return r.stylize("[Function"+u+"]","special")}if(isRegExp(t)){return r.stylize(RegExp.prototype.toString.call(t),"regexp")}if(isDate(t)){return r.stylize(Date.prototype.toString.call(t),"date")}if(isError(t)){return formatError(t)}}var s="",y=false,c=["{","}"];if(isArray(t)){y=true;c=["[","]"]}if(isFunction(t)){var p=t.name?": "+t.name:"";s=" [Function"+p+"]"}if(isRegExp(t)){s=" "+RegExp.prototype.toString.call(t)}if(isDate(t)){s=" "+Date.prototype.toUTCString.call(t)}if(isError(t)){s=" "+formatError(t)}if(a.length===0&&(!y||t.length==0)){return c[0]+s+c[1]}if(n<0){if(isRegExp(t)){return r.stylize(RegExp.prototype.toString.call(t),"regexp")}else{return r.stylize("[Object]","special")}}r.seen.push(t);var l;if(y){l=formatArray(r,t,n,f,a)}else{l=a.map((function(e){return formatProperty(r,t,n,f,e,y)}))}r.seen.pop();return reduceToSingleString(l,s,c)}function formatPrimitive(r,e){if(isUndefined(e))return r.stylize("undefined","undefined");if(isString(e)){var t="'"+JSON.stringify(e).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return r.stylize(t,"string")}if(isNumber(e))return r.stylize(""+e,"number");if(isBoolean(e))return r.stylize(""+e,"boolean");if(isNull(e))return r.stylize("null","null")}function formatError(r){return"["+Error.prototype.toString.call(r)+"]"}function formatArray(r,e,t,n,o){var i=[];for(var a=0,f=e.length;a<f;++a){if(hasOwnProperty(e,String(a))){i.push(formatProperty(r,e,t,n,String(a),true))}else{i.push("")}}o.forEach((function(o){if(!o.match(/^\d+$/)){i.push(formatProperty(r,e,t,n,o,true))}}));return i}function formatProperty(r,e,t,n,o,i){var a,f,u;u=Object.getOwnPropertyDescriptor(e,o)||{value:e[o]};if(u.get){if(u.set){f=r.stylize("[Getter/Setter]","special")}else{f=r.stylize("[Getter]","special")}}else{if(u.set){f=r.stylize("[Setter]","special")}}if(!hasOwnProperty(n,o)){a="["+o+"]"}if(!f){if(r.seen.indexOf(u.value)<0){if(isNull(t)){f=formatValue(r,u.value,null)}else{f=formatValue(r,u.value,t-1)}if(f.indexOf("\n")>-1){if(i){f=f.split("\n").map((function(r){return"  "+r})).join("\n").substr(2)}else{f="\n"+f.split("\n").map((function(r){return"   "+r})).join("\n")}}}else{f=r.stylize("[Circular]","special")}}if(isUndefined(a)){if(i&&o.match(/^\d+$/)){return f}a=JSON.stringify(""+o);if(a.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)){a=a.substr(1,a.length-2);a=r.stylize(a,"name")}else{a=a.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'");a=r.stylize(a,"string")}}return a+": "+f}function reduceToSingleString(r,e,t){var n=0;var o=r.reduce((function(r,e){n++;if(e.indexOf("\n")>=0)n++;return r+e.replace(/\u001b\[\d\d?m/g,"").length+1}),0);if(o>60){return t[0]+(e===""?"":e+"\n ")+" "+r.join(",\n  ")+" "+t[1]}return t[0]+e+" "+r.join(", ")+" "+t[1]}e.types=t(584);function isArray(r){return Array.isArray(r)}e.isArray=isArray;function isBoolean(r){return typeof r==="boolean"}e.isBoolean=isBoolean;function isNull(r){return r===null}e.isNull=isNull;function isNullOrUndefined(r){return r==null}e.isNullOrUndefined=isNullOrUndefined;function isNumber(r){return typeof r==="number"}e.isNumber=isNumber;function isString(r){return typeof r==="string"}e.isString=isString;function isSymbol(r){return typeof r==="symbol"}e.isSymbol=isSymbol;function isUndefined(r){return r===void 0}e.isUndefined=isUndefined;function isRegExp(r){return isObject(r)&&objectToString(r)==="[object RegExp]"}e.isRegExp=isRegExp;e.types.isRegExp=isRegExp;function isObject(r){return typeof r==="object"&&r!==null}e.isObject=isObject;function isDate(r){return isObject(r)&&objectToString(r)==="[object Date]"}e.isDate=isDate;e.types.isDate=isDate;function isError(r){return isObject(r)&&(objectToString(r)==="[object Error]"||r instanceof Error)}e.isError=isError;e.types.isNativeError=isError;function isFunction(r){return typeof r==="function"}e.isFunction=isFunction;function isPrimitive(r){return r===null||typeof r==="boolean"||typeof r==="number"||typeof r==="string"||typeof r==="symbol"||typeof r==="undefined"}e.isPrimitive=isPrimitive;e.isBuffer=t(369);function objectToString(r){return Object.prototype.toString.call(r)}function pad(r){return r<10?"0"+r.toString(10):r.toString(10)}var u=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];function timestamp(){var r=new Date;var e=[pad(r.getHours()),pad(r.getMinutes()),pad(r.getSeconds())].join(":");return[r.getDate(),u[r.getMonth()],e].join(" ")}e.log=function(){console.log("%s - %s",timestamp(),e.format.apply(e,arguments))};e.inherits=t(782);e._extend=function(r,e){if(!e||!isObject(e))return r;var t=Object.keys(e);var n=t.length;while(n--){r[t[n]]=e[t[n]]}return r};function hasOwnProperty(r,e){return Object.prototype.hasOwnProperty.call(r,e)}var s=typeof Symbol!=="undefined"?Symbol("util.promisify.custom"):undefined;e.promisify=function promisify(r){if(typeof r!=="function")throw new TypeError('The "original" argument must be of type Function');if(s&&r[s]){var e=r[s];if(typeof e!=="function"){throw new TypeError('The "util.promisify.custom" argument must be of type Function')}Object.defineProperty(e,s,{value:e,enumerable:false,writable:false,configurable:true});return e}function e(){var e,t;var n=new Promise((function(r,n){e=r;t=n}));var o=[];for(var i=0;i<arguments.length;i++){o.push(arguments[i])}o.push((function(r,n){if(r){t(r)}else{e(n)}}));try{r.apply(this,o)}catch(r){t(r)}return n}Object.setPrototypeOf(e,Object.getPrototypeOf(r));if(s)Object.defineProperty(e,s,{value:e,enumerable:false,writable:false,configurable:true});return Object.defineProperties(e,n(r))};e.promisify.custom=s;function callbackifyOnRejected(r,e){if(!r){var t=new Error("Promise was rejected with a falsy value");t.reason=r;r=t}return e(r)}function callbackify(r){if(typeof r!=="function"){throw new TypeError('The "original" argument must be of type Function')}function callbackified(){var e=[];for(var t=0;t<arguments.length;t++){e.push(arguments[t])}var n=e.pop();if(typeof n!=="function"){throw new TypeError("The last argument must be of type Function")}var o=this;var cb=function(){return n.apply(o,arguments)};r.apply(this,e).then((function(r){process.nextTick(cb.bind(null,null,r))}),(function(r){process.nextTick(callbackifyOnRejected.bind(null,r,cb))}))}Object.setPrototypeOf(callbackified,Object.getPrototypeOf(r));Object.defineProperties(callbackified,n(r));return callbackified}e.callbackify=callbackify},490:function(r,e,t){"use strict";var n=t(144);var o=t(349);var i=t(256);var a=i("Object.prototype.toString");var f=t(942)();var u=f&&typeof Symbol.toStringTag==="symbol";var s=o();var y=i("String.prototype.slice");var c={};var p=t(466);var l=Object.getPrototypeOf;if(u&&p&&l){n(s,(function(r){if(typeof __webpack_require__.g[r]==="function"){var e=new __webpack_require__.g[r];if(!(Symbol.toStringTag in e)){throw new EvalError("this engine has support for Symbol.toStringTag, but "+r+" does not have the property! Please report this.")}var t=l(e);var n=p(t,Symbol.toStringTag);if(!n){var o=l(t);n=p(o,Symbol.toStringTag)}c[r]=n.get}}))}var g=function tryAllTypedArrays(r){var e=false;n(c,(function(t,n){if(!e){try{var o=t.call(r);if(o===n){e=o}}catch(r){}}}));return e};var b=t(994);r.exports=function whichTypedArray(r){if(!b(r)){return false}if(!u){return y(a(r),8,-1)}return g(r)}},349:function(r,e,t){"use strict";var n=t(992);r.exports=function availableTypedArrays(){return n(["BigInt64Array","BigUint64Array","Float32Array","Float64Array","Int16Array","Int32Array","Int8Array","Uint16Array","Uint32Array","Uint8Array","Uint8ClampedArray"],(function(r){return typeof __webpack_require__.g[r]==="function"}))}},466:function(r,e,t){"use strict";var n=t(838);var o=n("%Object.getOwnPropertyDescriptor%",true);if(o){try{o([],"length")}catch(r){o=null}}r.exports=o}};var e={};function __nccwpck_require__(t){var n=e[t];if(n!==undefined){return n.exports}var o=e[t]={exports:{}};var i=true;try{r[t](o,o.exports,__nccwpck_require__);i=false}finally{if(i)delete e[t]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(177);module.exports=t})();

/***/ }),

/***/ 64339:
/***/ (function(module) {

var __dirname = "/";
(function(){var __webpack_modules__={950:function(__unused_webpack_module,exports){var indexOf=function(e,t){if(e.indexOf)return e.indexOf(t);else for(var r=0;r<e.length;r++){if(e[r]===t)return r}return-1};var Object_keys=function(e){if(Object.keys)return Object.keys(e);else{var t=[];for(var r in e)t.push(r);return t}};var forEach=function(e,t){if(e.forEach)return e.forEach(t);else for(var r=0;r<e.length;r++){t(e[r],r,e)}};var defineProp=function(){try{Object.defineProperty({},"_",{});return function(e,t,r){Object.defineProperty(e,t,{writable:true,enumerable:false,configurable:true,value:r})}}catch(e){return function(e,t,r){e[t]=r}}}();var globals=["Array","Boolean","Date","Error","EvalError","Function","Infinity","JSON","Math","NaN","Number","Object","RangeError","ReferenceError","RegExp","String","SyntaxError","TypeError","URIError","decodeURI","decodeURIComponent","encodeURI","encodeURIComponent","escape","eval","isFinite","isNaN","parseFloat","parseInt","undefined","unescape"];function Context(){}Context.prototype={};var Script=exports.Script=function NodeScript(e){if(!(this instanceof Script))return new Script(e);this.code=e};Script.prototype.runInContext=function(e){if(!(e instanceof Context)){throw new TypeError("needs a 'context' argument.")}var t=document.createElement("iframe");if(!t.style)t.style={};t.style.display="none";document.body.appendChild(t);var r=t.contentWindow;var n=r.eval,o=r.execScript;if(!n&&o){o.call(r,"null");n=r.eval}forEach(Object_keys(e),(function(t){r[t]=e[t]}));forEach(globals,(function(t){if(e[t]){r[t]=e[t]}}));var c=Object_keys(r);var i=n.call(r,this.code);forEach(Object_keys(r),(function(t){if(t in e||indexOf(c,t)===-1){e[t]=r[t]}}));forEach(globals,(function(t){if(!(t in e)){defineProp(e,t,r[t])}}));document.body.removeChild(t);return i};Script.prototype.runInThisContext=function(){return eval(this.code)};Script.prototype.runInNewContext=function(e){var t=Script.createContext(e);var r=this.runInContext(t);if(e){forEach(Object_keys(t),(function(r){e[r]=t[r]}))}return r};forEach(Object_keys(Script.prototype),(function(e){exports[e]=Script[e]=function(t){var r=Script(t);return r[e].apply(r,[].slice.call(arguments,1))}}));exports.isContext=function(e){return e instanceof Context};exports.createScript=function(e){return exports.Script(e)};exports.createContext=Script.createContext=function(e){var t=new Context;if(typeof e==="object"){forEach(Object_keys(e),(function(r){t[r]=e[r]}))}return t}}};if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var __webpack_exports__={};__webpack_modules__[950](0,__webpack_exports__);module.exports=__webpack_exports__})();

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ }),

/***/ 70689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72918)


/***/ }),

/***/ 97729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(75913)


/***/ }),

/***/ 96577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(33718)


/***/ }),

/***/ 39097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(39296)


/***/ }),

/***/ 5632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(93642)


/***/ }),

/***/ 45847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20747)


/***/ }),

/***/ 13000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/*!
 * object.omit <https://github.com/jonschlinkert/object.omit>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(88919);

module.exports = function omit(obj, props, fn) {
  if (!isObject(obj)) return {};

  if (typeof props === 'function') {
    fn = props;
    props = [];
  }

  if (typeof props === 'string') {
    props = [props];
  }

  var isFunction = typeof fn === 'function';
  var keys = Object.keys(obj);
  var res = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];

    if (!props || (props.indexOf(key) === -1 && (!isFunction || fn(val, key, obj)))) {
      res[key] = val;
    }
  }
  return res;
};


/***/ }),

/***/ 88919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/*!
 * is-extendable <https://github.com/jonschlinkert/is-extendable>
 *
 * Copyright (c) 2015-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isPlainObject = __webpack_require__(15690);

module.exports = function isExtendable(val) {
  return isPlainObject(val) || typeof val === 'function' || Array.isArray(val);
};


/***/ }),

/***/ 34406:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 68262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(23586);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 13980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(68262)();
}


/***/ }),

/***/ 23586:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 37726:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/*!
  react-datepicker v7.5.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
!function(e,t){ true?t(exports,__webpack_require__(87944),__webpack_require__(2784),__webpack_require__(25155),__webpack_require__(83978),__webpack_require__(41278),__webpack_require__(5157),__webpack_require__(48991),__webpack_require__(53893),__webpack_require__(41488),__webpack_require__(75978),__webpack_require__(83366),__webpack_require__(45672),__webpack_require__(96719),__webpack_require__(66393),__webpack_require__(85878),__webpack_require__(48443),__webpack_require__(92335),__webpack_require__(67786),__webpack_require__(53689),__webpack_require__(24173),__webpack_require__(44172),__webpack_require__(49288),__webpack_require__(71544),__webpack_require__(69513),__webpack_require__(57552),__webpack_require__(98825),__webpack_require__(23350),__webpack_require__(73701),__webpack_require__(97013),__webpack_require__(50227),__webpack_require__(2129),__webpack_require__(78),__webpack_require__(43215),__webpack_require__(13195),__webpack_require__(10098),__webpack_require__(29548),__webpack_require__(45154),__webpack_require__(55033),__webpack_require__(74390),__webpack_require__(18901),__webpack_require__(25518),__webpack_require__(55463),__webpack_require__(86103),__webpack_require__(14485),__webpack_require__(53304),__webpack_require__(24269),__webpack_require__(14728),__webpack_require__(82650),__webpack_require__(3646),__webpack_require__(24562),__webpack_require__(22490),__webpack_require__(72274),__webpack_require__(23266),__webpack_require__(6831),__webpack_require__(83877),__webpack_require__(90821),__webpack_require__(86584),__webpack_require__(10260),__webpack_require__(4286),__webpack_require__(35619),__webpack_require__(26663),__webpack_require__(44724),__webpack_require__(60710),__webpack_require__(28316)):0}(this,(function(e,t,r,n,a,o,s,i,l,c,p,d,u,f,h,m,v,g,D,y,k,w,S,b,M,C,_,E,Y,P,x,N,O,T,I,R,L,F,A,H,W,Q,q,K,B,V,j,U,$,z,X,G,J,Z,ee,te,re,ne,ae,oe,se,ie,le,ce,pe){"use strict";function de(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var ue=de(r),fe=de(pe),he=function(e,t){return he=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])},he(e,t)};function me(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Class extends value "+String(t)+" is not a constructor or null");function r(){this.constructor=e}he(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}var ve=function(){return ve=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var a in t=arguments[r])Object.prototype.hasOwnProperty.call(t,a)&&(e[a]=t[a]);return e},ve.apply(this,arguments)};function ge(e,t,r){if(r||2===arguments.length)for(var n,a=0,o=t.length;a<o;a++)!n&&a in t||(n||(n=Array.prototype.slice.call(t,0,a)),n[a]=t[a]);return e.concat(n||Array.prototype.slice.call(t))}"function"==typeof SuppressedError&&SuppressedError;var De,ye=function(e){var t=e.showTimeSelectOnly,r=void 0!==t&&t,n=e.showTime,a=void 0!==n&&n,o=e.className,s=e.children,i=r?"Choose Time":"Choose Date".concat(a?" and Time":"");return ue.default.createElement("div",{className:o,role:"dialog","aria-label":i,"aria-modal":"true"},s)},ke=function(e){var t=e.children,n=e.onClickOutside,a=e.className,o=e.containerRef,s=e.style,i=function(e,t){var n=r.useRef(null),a=r.useRef(e);a.current=e;var o=r.useCallback((function(e){var r;n.current&&!n.current.contains(e.target)&&(t&&e.target instanceof HTMLElement&&e.target.classList.contains(t)||null===(r=a.current)||void 0===r||r.call(a,e))}),[t]);return r.useEffect((function(){return document.addEventListener("mousedown",o),function(){document.removeEventListener("mousedown",o)}}),[o]),n}(n,e.ignoreClass);return ue.default.createElement("div",{className:a,style:s,ref:function(e){i.current=e,o&&(o.current=e)}},t)};function we(){return"undefined"!=typeof window?window:globalThis}!function(e){e.ArrowUp="ArrowUp",e.ArrowDown="ArrowDown",e.ArrowLeft="ArrowLeft",e.ArrowRight="ArrowRight",e.PageUp="PageUp",e.PageDown="PageDown",e.Home="Home",e.End="End",e.Enter="Enter",e.Space=" ",e.Tab="Tab",e.Escape="Escape",e.Backspace="Backspace",e.X="x"}(De||(De={}));var Se=12,be=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function Me(e){if(null==e)return new Date;var t="string"==typeof e?B.parseISO(e):le.toDate(e);return _e(t)?t:new Date}function Ce(e,t,r,n,a){var o,s=null,i=Ve(r)||Ve(Be()),l=!0;if(Array.isArray(t))return t.forEach((function(t){var o=K.parse(e,t,new Date,{locale:i,useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0});n&&(l=_e(o,a)&&e===Ee(o,t,r)),_e(o,a)&&l&&(s=o)})),s;if(s=K.parse(e,t,new Date,{locale:i,useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0}),n)l=_e(s)&&e===Ee(s,t,r);else if(!_e(s)){var c=(null!==(o=t.match(be))&&void 0!==o?o:[]).map((function(e){var t=e[0];if("p"===t||"P"===t){var r=k.longFormatters[t];return i?r(e,i.formatLong):t}return e})).join("");e.length>0&&(s=K.parse(e,c.slice(0,e.length),new Date,{useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0})),_e(s)||(s=new Date(e))}return _e(s)&&l?s:null}function _e(e,t){return H.isValid(e)&&!O.isBefore(e,null!=t?t:new Date("1/1/1800"))}function Ee(e,t,r){if("en"===r)return k.format(e,t,{useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0});var n=r?Ve(r):void 0;return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&Be()&&Ve(Be())&&(n=Ve(Be())),k.format(e,t,{locale:n,useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0})}function Ye(e,t){var r=t.dateFormat,n=t.locale,a=Array.isArray(r)&&r.length>0?r[0]:r;return e&&Ee(e,a,n)||""}function Pe(e,t){var r=t.hour,n=void 0===r?0:r,a=t.minute,o=void 0===a?0:a,s=t.second,i=void 0===s?0:s;return j.setHours(U.setMinutes(X.setSeconds(e,i),o),n)}function xe(e){return J.startOfDay(e)}function Ne(e,t,r){var n=Ve(t||Be());return te.startOfWeek(e,{locale:n,weekStartsOn:r})}function Oe(e){return Z.startOfMonth(e)}function Te(e){return re.startOfYear(e)}function Ie(e){return ee.startOfQuarter(e)}function Re(){return J.startOfDay(Me())}function Le(e){return v.endOfDay(e)}function Fe(e){return g.endOfMonth(e)}function Ae(e,t){return e&&t?A.isSameYear(e,t):!e&&!t}function He(e,t){return e&&t?L.isSameMonth(e,t):!e&&!t}function We(e,t){return e&&t?F.isSameQuarter(e,t):!e&&!t}function Qe(e,t){return e&&t?R.isSameDay(e,t):!e&&!t}function qe(e,t){return e&&t?I.isEqual(e,t):!e&&!t}function Ke(e,t,r){var n,a=J.startOfDay(t),o=v.endOfDay(r);try{n=W.isWithinInterval(e,{start:a,end:o})}catch(e){n=!1}return n}function Be(){return we().__localeId__}function Ve(e){if("string"==typeof e){var t=we();return t.__localeData__?t.__localeData__[e]:void 0}return e}function je(e,t){return Ee($.setMonth(Me(),e),"LLLL",t)}function Ue(e,t){return Ee($.setMonth(Me(),e),"LLL",t)}function $e(e,t){var r=void 0===t?{}:t,n=r.minDate,a=r.maxDate,o=r.excludeDates,s=r.excludeDateIntervals,i=r.includeDates,l=r.includeDateIntervals,c=r.filterDate;return nt(e,{minDate:n,maxDate:a})||o&&o.some((function(t){return t instanceof Date?Qe(e,t):Qe(e,t.date)}))||s&&s.some((function(t){var r=t.start,n=t.end;return W.isWithinInterval(e,{start:r,end:n})}))||i&&!i.some((function(t){return Qe(e,t)}))||l&&!l.some((function(t){var r=t.start,n=t.end;return W.isWithinInterval(e,{start:r,end:n})}))||c&&!c(Me(e))||!1}function ze(e,t){var r=void 0===t?{}:t,n=r.excludeDates,a=r.excludeDateIntervals;return a&&a.length>0?a.some((function(t){var r=t.start,n=t.end;return W.isWithinInterval(e,{start:r,end:n})})):n&&n.some((function(t){var r;return t instanceof Date?Qe(e,t):Qe(e,null!==(r=t.date)&&void 0!==r?r:new Date)}))||!1}function Xe(e,t){var r=void 0===t?{}:t,n=r.minDate,a=r.maxDate,o=r.excludeDates,s=r.includeDates,i=r.filterDate;return nt(e,{minDate:n?Z.startOfMonth(n):void 0,maxDate:a?g.endOfMonth(a):void 0})||(null==o?void 0:o.some((function(t){return He(e,t instanceof Date?t:t.date)})))||s&&!s.some((function(t){return He(e,t)}))||i&&!i(Me(e))||!1}function Ge(e,t,r,n){var a=x.getYear(e),o=_.getMonth(e),s=x.getYear(t),i=_.getMonth(t),l=x.getYear(n);return a===s&&a===l?o<=r&&r<=i:a<s&&(l===a&&o<=r||l===s&&i>=r||l<s&&l>a)}function Je(e,t){var r=void 0===t?{}:t,n=r.minDate,a=r.maxDate,o=r.excludeDates,s=r.includeDates;return nt(e,{minDate:n,maxDate:a})||o&&o.some((function(t){return He(t instanceof Date?t:t.date,e)}))||s&&!s.some((function(t){return He(t,e)}))||!1}function Ze(e,t){var r=void 0===t?{}:t,n=r.minDate,a=r.maxDate,o=r.excludeDates,s=r.includeDates,i=r.filterDate;return nt(e,{minDate:n,maxDate:a})||(null==o?void 0:o.some((function(t){return We(e,t instanceof Date?t:t.date)})))||s&&!s.some((function(t){return We(e,t)}))||i&&!i(Me(e))||!1}function et(e,t,r){if(!t||!r)return!1;if(!H.isValid(t)||!H.isValid(r))return!1;var n=x.getYear(t),a=x.getYear(r);return n<=e&&a>=e}function tt(e,t){var r=void 0===t?{}:t,n=r.minDate,a=r.maxDate,o=r.excludeDates,s=r.includeDates,i=r.filterDate,l=new Date(e,0,1);return nt(l,{minDate:n?re.startOfYear(n):void 0,maxDate:a?y.endOfYear(a):void 0})||(null==o?void 0:o.some((function(e){return Ae(l,e instanceof Date?e:e.date)})))||s&&!s.some((function(e){return Ae(l,e)}))||i&&!i(Me(l))||!1}function rt(e,t,r,n){var a=x.getYear(e),o=E.getQuarter(e),s=x.getYear(t),i=E.getQuarter(t),l=x.getYear(n);return a===s&&a===l?o<=r&&r<=i:a<s&&(l===a&&o<=r||l===s&&i>=r||l<s&&l>a)}function nt(e,t){var r,n=void 0===t?{}:t,a=n.minDate,o=n.maxDate;return null!==(r=a&&u.differenceInCalendarDays(e,a)<0||o&&u.differenceInCalendarDays(e,o)>0)&&void 0!==r&&r}function at(e,t){return t.some((function(t){return b.getHours(t)===b.getHours(e)&&C.getMinutes(t)===C.getMinutes(e)&&Y.getSeconds(t)===Y.getSeconds(e)}))}function ot(e,t){var r=void 0===t?{}:t,n=r.excludeTimes,a=r.includeTimes,o=r.filterTime;return n&&at(e,n)||a&&!at(e,a)||o&&!o(e)||!1}function st(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var a=Me();a=j.setHours(a,b.getHours(e)),a=U.setMinutes(a,C.getMinutes(e)),a=X.setSeconds(a,Y.getSeconds(e));var o=Me();o=j.setHours(o,b.getHours(r)),o=U.setMinutes(o,C.getMinutes(r)),o=X.setSeconds(o,Y.getSeconds(r));var s,i=Me();i=j.setHours(i,b.getHours(n)),i=U.setMinutes(i,C.getMinutes(n)),i=X.setSeconds(i,Y.getSeconds(n));try{s=!W.isWithinInterval(a,{start:o,end:i})}catch(e){s=!1}return s}function it(e,t){var r=void 0===t?{}:t,n=r.minDate,a=r.includeDates,o=ae.subMonths(e,1);return n&&f.differenceInCalendarMonths(n,o)>0||a&&a.every((function(e){return f.differenceInCalendarMonths(e,o)>0}))||!1}function lt(e,t){var r=void 0===t?{}:t,n=r.maxDate,a=r.includeDates,o=i.addMonths(e,1);return n&&f.differenceInCalendarMonths(o,n)>0||a&&a.every((function(e){return f.differenceInCalendarMonths(o,e)>0}))||!1}function ct(e,t){var r=void 0===t?{}:t,n=r.minDate,a=r.includeDates,o=ie.subYears(e,1);return n&&m.differenceInCalendarYears(n,o)>0||a&&a.every((function(e){return m.differenceInCalendarYears(e,o)>0}))||!1}function pt(e,t){var r=void 0===t?{}:t,n=r.maxDate,a=r.includeDates,o=d.addYears(e,1);return n&&m.differenceInCalendarYears(o,n)>0||a&&a.every((function(e){return m.differenceInCalendarYears(o,e)>0}))||!1}function dt(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return u.differenceInCalendarDays(e,t)>=0}));return q.min(n)}return r?q.min(r):t}function ut(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return u.differenceInCalendarDays(e,t)<=0}));return Q.max(n)}return r?Q.max(r):t}function ft(e,t){var r;void 0===e&&(e=[]),void 0===t&&(t="react-datepicker__day--highlighted");for(var n=new Map,a=0,o=e.length;a<o;a++){var s=e[a];if(T.isDate(s)){var i=Ee(s,"MM.dd.yyyy");(f=n.get(i)||[]).includes(t)||(f.push(t),n.set(i,f))}else if("object"==typeof s){var l=null!==(r=Object.keys(s)[0])&&void 0!==r?r:"",c=s[l];if("string"==typeof l&&Array.isArray(c))for(var p=0,d=c.length;p<d;p++){var u=c[p];if(u){var f;i=Ee(u,"MM.dd.yyyy");(f=n.get(i)||[]).includes(l)||(f.push(l),n.set(i,f))}}}}return n}function ht(e,t){void 0===e&&(e=[]),void 0===t&&(t="react-datepicker__day--holidays");var r=new Map;return e.forEach((function(e){var n=e.date,a=e.holidayName;if(T.isDate(n)){var o=Ee(n,"MM.dd.yyyy"),s=r.get(o)||{className:"",holidayNames:[]};if(!("className"in s)||s.className!==t||(i=s.holidayNames,l=[a],i.length!==l.length||!i.every((function(e,t){return e===l[t]})))){var i,l;s.className=t;var c=s.holidayNames;s.holidayNames=c?ge(ge([],c,!0),[a],!1):[a],r.set(o,s)}}})),r}function mt(e,t,r,n,a){for(var i=a.length,l=[],p=0;p<i;p++){var d=e,u=a[p];u&&(d=o.addHours(d,b.getHours(u)),d=s.addMinutes(d,C.getMinutes(u)),d=c.addSeconds(d,Y.getSeconds(u)));var f=s.addMinutes(e,(r+1)*n);N.isAfter(d,t)&&O.isBefore(d,f)&&null!=u&&l.push(u)}return l}function vt(e){return e<10?"0".concat(e):"".concat(e)}function gt(e,t){void 0===t&&(t=Se);var r=Math.ceil(x.getYear(e)/t)*t;return{startPeriod:r-(t-1),endPeriod:r}}function Dt(e){var t=e.getSeconds(),r=e.getMilliseconds();return le.toDate(e.getTime()-1e3*t-r)}function yt(e){if(!T.isDate(e))throw new Error("Invalid date");var t=new Date(e);return t.setHours(0,0,0,0),t}function kt(e,t){if(!T.isDate(e)||!T.isDate(t))throw new Error("Invalid date received");var r=yt(e),n=yt(t);return O.isBefore(r,n)}function wt(e){return e.key===De.Space}var St,bt=function(e){function t(t){var n=e.call(this,t)||this;return n.inputRef=ue.default.createRef(),n.onTimeChange=function(e){var t,r;n.setState({time:e});var a=n.props.date,o=a instanceof Date&&!isNaN(+a)?a:new Date;if(null==e?void 0:e.includes(":")){var s=e.split(":"),i=s[0],l=s[1];o.setHours(Number(i)),o.setMinutes(Number(l))}null===(r=(t=n.props).onChange)||void 0===r||r.call(t,o)},n.renderTimeInput=function(){var e=n.state.time,t=n.props,a=t.date,o=t.timeString,s=t.customTimeInput;return s?r.cloneElement(s,{date:a,value:e,onChange:n.onTimeChange}):ue.default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",ref:n.inputRef,onClick:function(){var e;null===(e=n.inputRef.current)||void 0===e||e.focus()},required:!0,value:e,onChange:function(e){n.onTimeChange(e.target.value||o)}})},n.state={time:n.props.timeString},n}return me(t,e),t.getDerivedStateFromProps=function(e,t){return e.timeString!==t.time?{time:e.timeString}:null},t.prototype.render=function(){return ue.default.createElement("div",{className:"react-datepicker__input-time-container"},ue.default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),ue.default.createElement("div",{className:"react-datepicker-time__input-container"},ue.default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))},t}(r.Component),Mt=function(e){function n(){var n=null!==e&&e.apply(this,arguments)||this;return n.dayEl=r.createRef(),n.handleClick=function(e){!n.isDisabled()&&n.props.onClick&&n.props.onClick(e)},n.handleMouseEnter=function(e){!n.isDisabled()&&n.props.onMouseEnter&&n.props.onMouseEnter(e)},n.handleOnKeyDown=function(e){var t,r;e.key===De.Space&&(e.preventDefault(),e.key=De.Enter),null===(r=(t=n.props).handleOnKeyDown)||void 0===r||r.call(t,e)},n.isSameDay=function(e){return Qe(n.props.day,e)},n.isKeyboardSelected=function(){var e;if(n.props.disabledKeyboardNavigation)return!1;var t=n.props.selectsMultiple?null===(e=n.props.selectedDates)||void 0===e?void 0:e.some((function(e){return n.isSameDayOrWeek(e)})):n.isSameDayOrWeek(n.props.selected),r=n.props.preSelection&&n.isDisabled(n.props.preSelection);return!t&&n.isSameDayOrWeek(n.props.preSelection)&&!r},n.isDisabled=function(e){return void 0===e&&(e=n.props.day),$e(e,{minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,excludeDateIntervals:n.props.excludeDateIntervals,includeDateIntervals:n.props.includeDateIntervals,includeDates:n.props.includeDates,filterDate:n.props.filterDate})},n.isExcluded=function(){return ze(n.props.day,{excludeDates:n.props.excludeDates,excludeDateIntervals:n.props.excludeDateIntervals})},n.isStartOfWeek=function(){return Qe(n.props.day,Ne(n.props.day,n.props.locale,n.props.calendarStartDay))},n.isSameWeek=function(e){return n.props.showWeekPicker&&Qe(e,Ne(n.props.day,n.props.locale,n.props.calendarStartDay))},n.isSameDayOrWeek=function(e){return n.isSameDay(e)||n.isSameWeek(e)},n.getHighLightedClass=function(){var e=n.props,t=e.day,r=e.highlightDates;if(!r)return!1;var a=Ee(t,"MM.dd.yyyy");return r.get(a)},n.getHolidaysClass=function(){var e,t=n.props,r=t.day,a=t.holidays;if(!a)return[void 0];var o=Ee(r,"MM.dd.yyyy");return a.has(o)?[null===(e=a.get(o))||void 0===e?void 0:e.className]:[void 0]},n.isInRange=function(){var e=n.props,t=e.day,r=e.startDate,a=e.endDate;return!(!r||!a)&&Ke(t,r,a)},n.isInSelectingRange=function(){var e,t=n.props,r=t.day,a=t.selectsStart,o=t.selectsEnd,s=t.selectsRange,i=t.selectsDisabledDaysInRange,l=t.startDate,c=t.endDate,p=null!==(e=n.props.selectingDate)&&void 0!==e?e:n.props.preSelection;return!(!(a||o||s)||!p||!i&&n.isDisabled())&&(a&&c&&(O.isBefore(p,c)||qe(p,c))?Ke(r,p,c):(o&&l&&(N.isAfter(p,l)||qe(p,l))||!(!s||!l||c||!N.isAfter(p,l)&&!qe(p,l)))&&Ke(r,l,p))},n.isSelectingRangeStart=function(){var e;if(!n.isInSelectingRange())return!1;var t=n.props,r=t.day,a=t.startDate,o=t.selectsStart,s=null!==(e=n.props.selectingDate)&&void 0!==e?e:n.props.preSelection;return Qe(r,o?s:a)},n.isSelectingRangeEnd=function(){var e;if(!n.isInSelectingRange())return!1;var t=n.props,r=t.day,a=t.endDate,o=t.selectsEnd,s=t.selectsRange,i=null!==(e=n.props.selectingDate)&&void 0!==e?e:n.props.preSelection;return Qe(r,o||s?i:a)},n.isRangeStart=function(){var e=n.props,t=e.day,r=e.startDate,a=e.endDate;return!(!r||!a)&&Qe(r,t)},n.isRangeEnd=function(){var e=n.props,t=e.day,r=e.startDate,a=e.endDate;return!(!r||!a)&&Qe(a,t)},n.isWeekend=function(){var e=S.getDay(n.props.day);return 0===e||6===e},n.isAfterMonth=function(){return void 0!==n.props.month&&(n.props.month+1)%12===_.getMonth(n.props.day)},n.isBeforeMonth=function(){return void 0!==n.props.month&&(_.getMonth(n.props.day)+1)%12===n.props.month},n.isCurrentDay=function(){return n.isSameDay(Me())},n.isSelected=function(){var e;return n.props.selectsMultiple?null===(e=n.props.selectedDates)||void 0===e?void 0:e.some((function(e){return n.isSameDayOrWeek(e)})):n.isSameDayOrWeek(n.props.selected)},n.getClassNames=function(e){var r,a=n.props.dayClassName?n.props.dayClassName(e):void 0;return t.clsx("react-datepicker__day",a,"react-datepicker__day--"+Ee(n.props.day,"ddd",r),{"react-datepicker__day--disabled":n.isDisabled(),"react-datepicker__day--excluded":n.isExcluded(),"react-datepicker__day--selected":n.isSelected(),"react-datepicker__day--keyboard-selected":n.isKeyboardSelected(),"react-datepicker__day--range-start":n.isRangeStart(),"react-datepicker__day--range-end":n.isRangeEnd(),"react-datepicker__day--in-range":n.isInRange(),"react-datepicker__day--in-selecting-range":n.isInSelectingRange(),"react-datepicker__day--selecting-range-start":n.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":n.isSelectingRangeEnd(),"react-datepicker__day--today":n.isCurrentDay(),"react-datepicker__day--weekend":n.isWeekend(),"react-datepicker__day--outside-month":n.isAfterMonth()||n.isBeforeMonth()},n.getHighLightedClass(),n.getHolidaysClass())},n.getAriaLabel=function(){var e=n.props,t=e.day,r=e.ariaLabelPrefixWhenEnabled,a=void 0===r?"Choose":r,o=e.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,i=n.isDisabled()||n.isExcluded()?s:a;return"".concat(i," ").concat(Ee(t,"PPPP",n.props.locale))},n.getTitle=function(){var e=n.props,t=e.day,r=e.holidays,a=void 0===r?new Map:r,o=e.excludeDates,s=Ee(t,"MM.dd.yyyy"),i=[];return a.has(s)&&i.push.apply(i,a.get(s).holidayNames),n.isExcluded()&&i.push(null==o?void 0:o.filter((function(e){return e instanceof Date?Qe(e,t):Qe(null==e?void 0:e.date,t)})).map((function(e){if(!(e instanceof Date))return null==e?void 0:e.message}))),i.join(", ")},n.getTabIndex=function(){var e=n.props.selected,t=n.props.preSelection;return(!n.props.showWeekPicker||!n.props.showWeekNumber&&n.isStartOfWeek())&&(n.isKeyboardSelected()||n.isSameDay(e)&&Qe(t,e))?0:-1},n.handleFocusDay=function(){var e;n.shouldFocusDay()&&(null===(e=n.dayEl.current)||void 0===e||e.focus({preventScroll:!0}))},n.renderDayContents=function(){return n.props.monthShowsDuplicateDaysEnd&&n.isAfterMonth()||n.props.monthShowsDuplicateDaysStart&&n.isBeforeMonth()?null:n.props.renderDayContents?n.props.renderDayContents(w.getDate(n.props.day),n.props.day):w.getDate(n.props.day)},n.render=function(){return ue.default.createElement("div",{ref:n.dayEl,className:n.getClassNames(n.props.day),onKeyDown:n.handleOnKeyDown,onClick:n.handleClick,onMouseEnter:n.props.usePointerEvent?void 0:n.handleMouseEnter,onPointerEnter:n.props.usePointerEvent?n.handleMouseEnter:void 0,tabIndex:n.getTabIndex(),"aria-label":n.getAriaLabel(),role:"option",title:n.getTitle(),"aria-disabled":n.isDisabled(),"aria-current":n.isCurrentDay()?"date":void 0,"aria-selected":n.isSelected()||n.isInRange()},n.renderDayContents(),""!==n.getTitle()&&ue.default.createElement("span",{className:"overlay"},n.getTitle()))},n}return me(n,e),n.prototype.componentDidMount=function(){this.handleFocusDay()},n.prototype.componentDidUpdate=function(){this.handleFocusDay()},n.prototype.shouldFocusDay=function(){var e=!1;return 0===this.getTabIndex()&&this.isSameDay(this.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(e=!0),this.props.inline&&!this.props.shouldFocusDayInline&&(e=!1),this.isDayActiveElement()&&(e=!0),this.isDuplicateDay()&&(e=!1)),e},n.prototype.isDayActiveElement=function(){var e,t,r;return(null===(t=null===(e=this.props.containerRef)||void 0===e?void 0:e.current)||void 0===t?void 0:t.contains(document.activeElement))&&(null===(r=document.activeElement)||void 0===r?void 0:r.classList.contains("react-datepicker__day"))},n.prototype.isDuplicateDay=function(){return this.props.monthShowsDuplicateDaysEnd&&this.isAfterMonth()||this.props.monthShowsDuplicateDaysStart&&this.isBeforeMonth()},n}(r.Component),Ct=function(e){function n(){var t=null!==e&&e.apply(this,arguments)||this;return t.weekNumberEl=r.createRef(),t.handleClick=function(e){t.props.onClick&&t.props.onClick(e)},t.handleOnKeyDown=function(e){var r,n;e.key===De.Space&&(e.preventDefault(),e.key=De.Enter),null===(n=(r=t.props).handleOnKeyDown)||void 0===n||n.call(r,e)},t.isKeyboardSelected=function(){return!t.props.disabledKeyboardNavigation&&!Qe(t.props.date,t.props.selected)&&Qe(t.props.date,t.props.preSelection)},t.getTabIndex=function(){return t.props.showWeekPicker&&t.props.showWeekNumber&&(t.isKeyboardSelected()||Qe(t.props.date,t.props.selected)&&Qe(t.props.preSelection,t.props.selected))?0:-1},t.handleFocusWeekNumber=function(e){var r=!1;0===t.getTabIndex()&&!(null==e?void 0:e.isInputFocused)&&Qe(t.props.date,t.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),t.props.inline&&!t.props.shouldFocusDayInline&&(r=!1),t.props.containerRef&&t.props.containerRef.current&&t.props.containerRef.current.contains(document.activeElement)&&document.activeElement&&document.activeElement.classList.contains("react-datepicker__week-number")&&(r=!0)),r&&t.weekNumberEl.current&&t.weekNumberEl.current.focus({preventScroll:!0})},t}return me(n,e),Object.defineProperty(n,"defaultProps",{get:function(){return{ariaLabelPrefix:"week "}},enumerable:!1,configurable:!0}),n.prototype.componentDidMount=function(){this.handleFocusWeekNumber()},n.prototype.componentDidUpdate=function(e){this.handleFocusWeekNumber(e)},n.prototype.render=function(){var e=this.props,r=e.weekNumber,a=e.ariaLabelPrefix,o=void 0===a?n.defaultProps.ariaLabelPrefix:a,s=e.onClick,i={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!s,"react-datepicker__week-number--selected":!!s&&Qe(this.props.date,this.props.selected),"react-datepicker__week-number--keyboard-selected":this.isKeyboardSelected()};return ue.default.createElement("div",{ref:this.weekNumberEl,className:t.clsx(i),"aria-label":"".concat(o," ").concat(this.props.weekNumber),onClick:this.handleClick,onKeyDown:this.handleOnKeyDown,tabIndex:this.getTabIndex()},r)},n}(r.Component),_t=function(e){function r(){var t=null!==e&&e.apply(this,arguments)||this;return t.isDisabled=function(e){return $e(e,{minDate:t.props.minDate,maxDate:t.props.maxDate,excludeDates:t.props.excludeDates,excludeDateIntervals:t.props.excludeDateIntervals,includeDateIntervals:t.props.includeDateIntervals,includeDates:t.props.includeDates,filterDate:t.props.filterDate})},t.handleDayClick=function(e,r){t.props.onDayClick&&t.props.onDayClick(e,r)},t.handleDayMouseEnter=function(e){t.props.onDayMouseEnter&&t.props.onDayMouseEnter(e)},t.handleWeekClick=function(e,n,a){for(var o,s,i,l=new Date(e),c=0;c<7;c++){var p=new Date(e);if(p.setDate(p.getDate()+c),!t.isDisabled(p)){l=p;break}}"function"==typeof t.props.onWeekSelect&&t.props.onWeekSelect(l,n,a),t.props.showWeekPicker&&t.handleDayClick(l,a),(null!==(o=t.props.shouldCloseOnSelect)&&void 0!==o?o:r.defaultProps.shouldCloseOnSelect)&&(null===(i=(s=t.props).setOpen)||void 0===i||i.call(s,!1))},t.formatWeekNumber=function(e){return t.props.formatWeekNumber?t.props.formatWeekNumber(e):function(e){return M.getISOWeek(e)}(e)},t.renderDays=function(){var e=t.startOfWeek(),n=[],o=t.formatWeekNumber(e);if(t.props.showWeekNumber){var s=t.props.onWeekSelect||t.props.showWeekPicker?t.handleWeekClick.bind(t,e,o):void 0;n.push(ue.default.createElement(Ct,ve({key:"W"},r.defaultProps,t.props,{weekNumber:o,date:e,onClick:s})))}return n.concat([0,1,2,3,4,5,6].map((function(n){var o=a.addDays(e,n);return ue.default.createElement(Mt,ve({},r.defaultProps,t.props,{ariaLabelPrefixWhenEnabled:t.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:t.props.disabledDayAriaLabelPrefix,key:o.valueOf(),day:o,onClick:t.handleDayClick.bind(t,o),onMouseEnter:t.handleDayMouseEnter.bind(t,o)}))})))},t.startOfWeek=function(){return Ne(t.props.day,t.props.locale,t.props.calendarStartDay)},t.isKeyboardSelected=function(){return!t.props.disabledKeyboardNavigation&&!Qe(t.startOfWeek(),t.props.selected)&&Qe(t.startOfWeek(),t.props.preSelection)},t}return me(r,e),Object.defineProperty(r,"defaultProps",{get:function(){return{shouldCloseOnSelect:!0}},enumerable:!1,configurable:!0}),r.prototype.render=function(){var e={"react-datepicker__week":!0,"react-datepicker__week--selected":Qe(this.startOfWeek(),this.props.selected),"react-datepicker__week--keyboard-selected":this.isKeyboardSelected()};return ue.default.createElement("div",{className:t.clsx(e)},this.renderDays())},r}(r.Component),Et="two_columns",Yt="three_columns",Pt="four_columns",xt=((St={})[Et]={grid:[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]],verticalNavigationOffset:2},St[Yt]={grid:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]],verticalNavigationOffset:3},St[Pt]={grid:[[0,1,2,3],[4,5,6,7],[8,9,10,11]],verticalNavigationOffset:4},St);function Nt(e,t){return e?Pt:t?Et:Yt}var Ot=function(e){function n(){var n=null!==e&&e.apply(this,arguments)||this;return n.MONTH_REFS=ge([],Array(12),!0).map((function(){return r.createRef()})),n.QUARTER_REFS=ge([],Array(4),!0).map((function(){return r.createRef()})),n.isDisabled=function(e){return $e(e,{minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,excludeDateIntervals:n.props.excludeDateIntervals,includeDateIntervals:n.props.includeDateIntervals,includeDates:n.props.includeDates,filterDate:n.props.filterDate})},n.isExcluded=function(e){return ze(e,{excludeDates:n.props.excludeDates,excludeDateIntervals:n.props.excludeDateIntervals})},n.handleDayClick=function(e,t){var r,a;null===(a=(r=n.props).onDayClick)||void 0===a||a.call(r,e,t,n.props.orderInDisplay)},n.handleDayMouseEnter=function(e){var t,r;null===(r=(t=n.props).onDayMouseEnter)||void 0===r||r.call(t,e)},n.handleMouseLeave=function(){var e,t;null===(t=(e=n.props).onMouseLeave)||void 0===t||t.call(e)},n.isRangeStartMonth=function(e){var t=n.props,r=t.day,a=t.startDate,o=t.endDate;return!(!a||!o)&&He($.setMonth(r,e),a)},n.isRangeStartQuarter=function(e){var t=n.props,r=t.day,a=t.startDate,o=t.endDate;return!(!a||!o)&&We(z.setQuarter(r,e),a)},n.isRangeEndMonth=function(e){var t=n.props,r=t.day,a=t.startDate,o=t.endDate;return!(!a||!o)&&He($.setMonth(r,e),o)},n.isRangeEndQuarter=function(e){var t=n.props,r=t.day,a=t.startDate,o=t.endDate;return!(!a||!o)&&We(z.setQuarter(r,e),o)},n.isInSelectingRangeMonth=function(e){var t,r=n.props,a=r.day,o=r.selectsStart,s=r.selectsEnd,i=r.selectsRange,l=r.startDate,c=r.endDate,p=null!==(t=n.props.selectingDate)&&void 0!==t?t:n.props.preSelection;return!(!(o||s||i)||!p)&&(o&&c?Ge(p,c,e,a):(s&&l||!(!i||!l||c))&&Ge(l,p,e,a))},n.isSelectingMonthRangeStart=function(e){var t;if(!n.isInSelectingRangeMonth(e))return!1;var r=n.props,a=r.day,o=r.startDate,s=r.selectsStart,i=$.setMonth(a,e),l=null!==(t=n.props.selectingDate)&&void 0!==t?t:n.props.preSelection;return He(i,s?l:o)},n.isSelectingMonthRangeEnd=function(e){var t;if(!n.isInSelectingRangeMonth(e))return!1;var r=n.props,a=r.day,o=r.endDate,s=r.selectsEnd,i=r.selectsRange,l=$.setMonth(a,e),c=null!==(t=n.props.selectingDate)&&void 0!==t?t:n.props.preSelection;return He(l,s||i?c:o)},n.isInSelectingRangeQuarter=function(e){var t,r=n.props,a=r.day,o=r.selectsStart,s=r.selectsEnd,i=r.selectsRange,l=r.startDate,c=r.endDate,p=null!==(t=n.props.selectingDate)&&void 0!==t?t:n.props.preSelection;return!(!(o||s||i)||!p)&&(o&&c?rt(p,c,e,a):(s&&l||!(!i||!l||c))&&rt(l,p,e,a))},n.isWeekInMonth=function(e){var t=n.props.day,r=a.addDays(e,6);return He(e,t)||He(r,t)},n.isCurrentMonth=function(e,t){return x.getYear(e)===x.getYear(Me())&&t===_.getMonth(Me())},n.isCurrentQuarter=function(e,t){return x.getYear(e)===x.getYear(Me())&&t===E.getQuarter(Me())},n.isSelectedMonth=function(e,t,r){return _.getMonth(r)===t&&x.getYear(e)===x.getYear(r)},n.isSelectMonthInList=function(e,t,r){return r.some((function(r){return n.isSelectedMonth(e,t,r)}))},n.isSelectedQuarter=function(e,t,r){return E.getQuarter(e)===t&&x.getYear(e)===x.getYear(r)},n.renderWeeks=function(){for(var e=[],t=n.props.fixedHeight,r=0,a=!1,o=Ne(Oe(n.props.day),n.props.locale,n.props.calendarStartDay),s=n.props.selected?function(e){return n.props.showWeekPicker?Ne(e,n.props.locale,n.props.calendarStartDay):n.props.selected}(n.props.selected):void 0,i=n.props.preSelection?function(e){return n.props.showWeekPicker?Ne(e,n.props.locale,n.props.calendarStartDay):n.props.preSelection}(n.props.preSelection):void 0;e.push(ue.default.createElement(_t,ve({},n.props,{ariaLabelPrefix:n.props.weekAriaLabelPrefix,key:r,day:o,month:_.getMonth(n.props.day),onDayClick:n.handleDayClick,onDayMouseEnter:n.handleDayMouseEnter,selected:s,preSelection:i,showWeekNumber:n.props.showWeekNumbers}))),!a;){r++,o=p.addWeeks(o,1);var l=t&&r>=6,c=!t&&!n.isWeekInMonth(o);if(l||c){if(!n.props.peekNextMonth)break;a=!0}}return e},n.onMonthClick=function(e,t){var r=n.isMonthDisabledForLabelDate(t),a=r.isDisabled,o=r.labelDate;a||n.handleDayClick(Oe(o),e)},n.onMonthMouseEnter=function(e){var t=n.isMonthDisabledForLabelDate(e),r=t.isDisabled,a=t.labelDate;r||n.handleDayMouseEnter(Oe(a))},n.handleMonthNavigation=function(e,t){var r,a,o,s;null===(a=(r=n.props).setPreSelection)||void 0===a||a.call(r,t),null===(s=null===(o=n.MONTH_REFS[e])||void 0===o?void 0:o.current)||void 0===s||s.focus()},n.handleKeyboardNavigation=function(e,t,r){var a,o=n.props,s=o.selected,l=o.preSelection,c=o.setPreSelection,p=o.minDate,d=o.maxDate,u=o.showFourColumnMonthYearPicker,f=o.showTwoColumnMonthYearPicker;if(l){var h=Nt(u,f),m=n.getVerticalOffset(h),v=null===(a=xt[h])||void 0===a?void 0:a.grid,g=function(e,t,r){var n,a,o=t,s=r;switch(e){case De.ArrowRight:o=i.addMonths(t,1),s=11===r?0:r+1;break;case De.ArrowLeft:o=ae.subMonths(t,1),s=0===r?11:r-1;break;case De.ArrowUp:o=ae.subMonths(t,m),s=(null===(n=null==v?void 0:v[0])||void 0===n?void 0:n.includes(r))?r+12-m:r-m;break;case De.ArrowDown:o=i.addMonths(t,m),s=(null===(a=null==v?void 0:v[v.length-1])||void 0===a?void 0:a.includes(r))?r-12+m:r+m}return{newCalculatedDate:o,newCalculatedMonth:s}};if(t!==De.Enter){var D=function(e,t,r){for(var a=e,o=!1,s=0,i=g(a,t,r),l=i.newCalculatedDate,c=i.newCalculatedMonth;!o;){if(s>=40){l=t,c=r;break}var u;if(p&&l<p)a=De.ArrowRight,l=(u=g(a,l,c)).newCalculatedDate,c=u.newCalculatedMonth;if(d&&l>d)a=De.ArrowLeft,l=(u=g(a,l,c)).newCalculatedDate,c=u.newCalculatedMonth;if(Je(l,n.props))l=(u=g(a,l,c)).newCalculatedDate,c=u.newCalculatedMonth;else o=!0;s++}return{newCalculatedDate:l,newCalculatedMonth:c}}(t,l,r),y=D.newCalculatedDate,k=D.newCalculatedMonth;switch(t){case De.ArrowRight:case De.ArrowLeft:case De.ArrowUp:case De.ArrowDown:n.handleMonthNavigation(k,y)}}else n.isMonthDisabled(r)||(n.onMonthClick(e,r),null==c||c(s))}},n.getVerticalOffset=function(e){var t,r;return null!==(r=null===(t=xt[e])||void 0===t?void 0:t.verticalNavigationOffset)&&void 0!==r?r:0},n.onMonthKeyDown=function(e,t){var r=n.props,a=r.disabledKeyboardNavigation,o=r.handleOnMonthKeyDown,s=e.key;s!==De.Tab&&e.preventDefault(),a||n.handleKeyboardNavigation(e,s,t),o&&o(e)},n.onQuarterClick=function(e,t){var r=z.setQuarter(n.props.day,t);Ze(r,n.props)||n.handleDayClick(Ie(r),e)},n.onQuarterMouseEnter=function(e){var t=z.setQuarter(n.props.day,e);Ze(t,n.props)||n.handleDayMouseEnter(Ie(t))},n.handleQuarterNavigation=function(e,t){var r,a,o,s;n.isDisabled(t)||n.isExcluded(t)||(null===(a=(r=n.props).setPreSelection)||void 0===a||a.call(r,t),null===(s=null===(o=n.QUARTER_REFS[e-1])||void 0===o?void 0:o.current)||void 0===s||s.focus())},n.onQuarterKeyDown=function(e,t){var r,a,o=e.key;if(!n.props.disabledKeyboardNavigation)switch(o){case De.Enter:n.onQuarterClick(e,t),null===(a=(r=n.props).setPreSelection)||void 0===a||a.call(r,n.props.selected);break;case De.ArrowRight:if(!n.props.preSelection)break;n.handleQuarterNavigation(4===t?1:t+1,l.addQuarters(n.props.preSelection,1));break;case De.ArrowLeft:if(!n.props.preSelection)break;n.handleQuarterNavigation(1===t?4:t-1,oe.subQuarters(n.props.preSelection,1))}},n.isMonthDisabledForLabelDate=function(e){var t,r=n.props,a=r.day,o=r.minDate,s=r.maxDate,i=r.excludeDates,l=r.includeDates,c=$.setMonth(a,e);return{isDisabled:null!==(t=(o||s||i||l)&&Xe(c,n.props))&&void 0!==t&&t,labelDate:c}},n.isMonthDisabled=function(e){return n.isMonthDisabledForLabelDate(e).isDisabled},n.getMonthClassNames=function(e){var r=n.props,a=r.day,o=r.startDate,s=r.endDate,i=r.preSelection,l=r.monthClassName,c=l?l($.setMonth(a,e)):void 0,p=n.getSelection();return t.clsx("react-datepicker__month-text","react-datepicker__month-".concat(e),c,{"react-datepicker__month-text--disabled":n.isMonthDisabled(e),"react-datepicker__month-text--selected":p?n.isSelectMonthInList(a,e,p):void 0,"react-datepicker__month-text--keyboard-selected":!n.props.disabledKeyboardNavigation&&i&&n.isSelectedMonth(a,e,i)&&!n.isMonthDisabled(e),"react-datepicker__month-text--in-selecting-range":n.isInSelectingRangeMonth(e),"react-datepicker__month-text--in-range":o&&s?Ge(o,s,e,a):void 0,"react-datepicker__month-text--range-start":n.isRangeStartMonth(e),"react-datepicker__month-text--range-end":n.isRangeEndMonth(e),"react-datepicker__month-text--selecting-range-start":n.isSelectingMonthRangeStart(e),"react-datepicker__month-text--selecting-range-end":n.isSelectingMonthRangeEnd(e),"react-datepicker__month-text--today":n.isCurrentMonth(a,e)})},n.getTabIndex=function(e){if(null==n.props.preSelection)return"-1";var t=_.getMonth(n.props.preSelection),r=n.isMonthDisabledForLabelDate(t).isDisabled;return e!==t||r||n.props.disabledKeyboardNavigation?"-1":"0"},n.getQuarterTabIndex=function(e){if(null==n.props.preSelection)return"-1";var t=E.getQuarter(n.props.preSelection),r=Ze(n.props.day,n.props);return e!==t||r||n.props.disabledKeyboardNavigation?"-1":"0"},n.getAriaLabel=function(e){var t=n.props,r=t.chooseDayAriaLabelPrefix,a=void 0===r?"Choose":r,o=t.disabledDayAriaLabelPrefix,s=void 0===o?"Not available":o,i=t.day,l=t.locale,c=$.setMonth(i,e),p=n.isDisabled(c)||n.isExcluded(c)?s:a;return"".concat(p," ").concat(Ee(c,"MMMM yyyy",l))},n.getQuarterClassNames=function(e){var r=n.props,a=r.day,o=r.startDate,s=r.endDate,i=r.selected,l=r.minDate,c=r.maxDate,p=r.excludeDates,d=r.includeDates,u=r.filterDate,f=r.preSelection,h=r.disabledKeyboardNavigation,m=(l||c||p||d||u)&&Ze(z.setQuarter(a,e),n.props);return t.clsx("react-datepicker__quarter-text","react-datepicker__quarter-".concat(e),{"react-datepicker__quarter-text--disabled":m,"react-datepicker__quarter-text--selected":i?n.isSelectedQuarter(a,e,i):void 0,"react-datepicker__quarter-text--keyboard-selected":!h&&f&&n.isSelectedQuarter(a,e,f)&&!m,"react-datepicker__quarter-text--in-selecting-range":n.isInSelectingRangeQuarter(e),"react-datepicker__quarter-text--in-range":o&&s?rt(o,s,e,a):void 0,"react-datepicker__quarter-text--range-start":n.isRangeStartQuarter(e),"react-datepicker__quarter-text--range-end":n.isRangeEndQuarter(e)})},n.getMonthContent=function(e){var t=n.props,r=t.showFullMonthYearPicker,a=t.renderMonthContent,o=t.locale,s=t.day,i=Ue(e,o),l=je(e,o);return a?a(e,i,l,s):r?l:i},n.getQuarterContent=function(e){var t,r=n.props,a=r.renderQuarterContent,o=function(e,t){return Ee(z.setQuarter(Me(),e),"QQQ",t)}(e,r.locale);return null!==(t=null==a?void 0:a(e,o))&&void 0!==t?t:o},n.renderMonths=function(){var e,t=n.props,r=t.showTwoColumnMonthYearPicker,a=t.showFourColumnMonthYearPicker,o=t.day,s=t.selected,i=null===(e=xt[Nt(a,r)])||void 0===e?void 0:e.grid;return null==i?void 0:i.map((function(e,t){return ue.default.createElement("div",{className:"react-datepicker__month-wrapper",key:t},e.map((function(e,t){return ue.default.createElement("div",{ref:n.MONTH_REFS[e],key:t,onClick:function(t){n.onMonthClick(t,e)},onKeyDown:function(t){wt(t)&&(t.preventDefault(),t.key=De.Enter),n.onMonthKeyDown(t,e)},onMouseEnter:n.props.usePointerEvent?void 0:function(){return n.onMonthMouseEnter(e)},onPointerEnter:n.props.usePointerEvent?function(){return n.onMonthMouseEnter(e)}:void 0,tabIndex:Number(n.getTabIndex(e)),className:n.getMonthClassNames(e),"aria-disabled":n.isMonthDisabled(e),role:"option","aria-label":n.getAriaLabel(e),"aria-current":n.isCurrentMonth(o,e)?"date":void 0,"aria-selected":s?n.isSelectedMonth(o,e,s):void 0},n.getMonthContent(e))})))}))},n.renderQuarters=function(){var e=n.props,t=e.day,r=e.selected;return ue.default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(e,a){return ue.default.createElement("div",{key:a,ref:n.QUARTER_REFS[a],role:"option",onClick:function(t){n.onQuarterClick(t,e)},onKeyDown:function(t){n.onQuarterKeyDown(t,e)},onMouseEnter:n.props.usePointerEvent?void 0:function(){return n.onQuarterMouseEnter(e)},onPointerEnter:n.props.usePointerEvent?function(){return n.onQuarterMouseEnter(e)}:void 0,className:n.getQuarterClassNames(e),"aria-selected":r?n.isSelectedQuarter(t,e,r):void 0,tabIndex:Number(n.getQuarterTabIndex(e)),"aria-current":n.isCurrentQuarter(t,e)?"date":void 0},n.getQuarterContent(e))})))},n.getClassNames=function(){var e=n.props,r=e.selectingDate,a=e.selectsStart,o=e.selectsEnd,s=e.showMonthYearPicker,i=e.showQuarterYearPicker,l=e.showWeekPicker;return t.clsx("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(a||o)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":i},{"react-datepicker__weekPicker":l})},n}return me(n,e),n.prototype.getSelection=function(){var e=this.props,t=e.selected,r=e.selectedDates;return e.selectsMultiple?r:t?[t]:void 0},n.prototype.render=function(){var e=this.props,t=e.showMonthYearPicker,r=e.showQuarterYearPicker,n=e.day,a=e.ariaLabelPrefix,o=void 0===a?"Month ":a,s=o?o.trim()+" ":"";return ue.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.props.usePointerEvent?void 0:this.handleMouseLeave,onPointerLeave:this.props.usePointerEvent?this.handleMouseLeave:void 0,"aria-label":"".concat(s).concat(Ee(n,"MMMM, yyyy",this.props.locale)),role:"listbox"},t?this.renderMonths():r?this.renderQuarters():this.renderWeeks())},n}(r.Component),Tt=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.isSelectedMonth=function(e){return t.props.month===e},t.renderOptions=function(){return t.props.monthNames.map((function(e,r){return ue.default.createElement("div",{className:t.isSelectedMonth(r)?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:e,onClick:t.onChange.bind(t,r),"aria-selected":t.isSelectedMonth(r)?"true":void 0},t.isSelectedMonth(r)?ue.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",e)}))},t.onChange=function(e){return t.props.onChange(e)},t.handleClickOutside=function(){return t.props.onCancel()},t}return me(t,e),t.prototype.render=function(){return ue.default.createElement(ke,{className:"react-datepicker__month-dropdown",onClickOutside:this.handleClickOutside},this.renderOptions())},t}(r.Component),It=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={dropdownVisible:!1},t.renderSelectOptions=function(e){return e.map((function(e,t){return ue.default.createElement("option",{key:e,value:t},e)}))},t.renderSelectMode=function(e){return ue.default.createElement("select",{value:t.props.month,className:"react-datepicker__month-select",onChange:function(e){return t.onChange(parseInt(e.target.value))}},t.renderSelectOptions(e))},t.renderReadView=function(e,r){return ue.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:t.toggleDropdown},ue.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),ue.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[t.props.month]))},t.renderDropdown=function(e){return ue.default.createElement(Tt,ve({key:"dropdown"},t.props,{monthNames:e,onChange:t.onChange,onCancel:t.toggleDropdown}))},t.renderScrollMode=function(e){var r=t.state.dropdownVisible,n=[t.renderReadView(!r,e)];return r&&n.unshift(t.renderDropdown(e)),n},t.onChange=function(e){t.toggleDropdown(),e!==t.props.month&&t.props.onChange(e)},t.toggleDropdown=function(){return t.setState({dropdownVisible:!t.state.dropdownVisible})},t}return me(t,e),t.prototype.render=function(){var e,t=this,r=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Ue(e,t.props.locale)}:function(e){return je(e,t.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(r);break;case"select":e=this.renderSelectMode(r)}return ue.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)},t}(r.Component);function Rt(e,t){for(var r=[],n=Oe(e),a=Oe(t);!N.isAfter(n,a);)r.push(Me(n)),n=i.addMonths(n,1);return r}var Lt=function(e){function r(t){var r=e.call(this,t)||this;return r.renderOptions=function(){return r.state.monthYearsList.map((function(e){var t=P.getTime(e),n=Ae(r.props.date,e)&&He(r.props.date,e);return ue.default.createElement("div",{className:n?"react-datepicker__month-year-option--selected_month-year":"react-datepicker__month-year-option",key:t,onClick:r.onChange.bind(r,t),"aria-selected":n?"true":void 0},n?ue.default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Ee(e,r.props.dateFormat,r.props.locale))}))},r.onChange=function(e){return r.props.onChange(e)},r.handleClickOutside=function(){r.props.onCancel()},r.state={monthYearsList:Rt(r.props.minDate,r.props.maxDate)},r}return me(r,e),r.prototype.render=function(){var e=t.clsx({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return ue.default.createElement(ke,{className:e,onClickOutside:this.handleClickOutside},this.renderOptions())},r}(r.Component),Ft=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={dropdownVisible:!1},t.renderSelectOptions=function(){for(var e=Oe(t.props.minDate),r=Oe(t.props.maxDate),n=[];!N.isAfter(e,r);){var a=P.getTime(e);n.push(ue.default.createElement("option",{key:a,value:a},Ee(e,t.props.dateFormat,t.props.locale))),e=i.addMonths(e,1)}return n},t.onSelectChange=function(e){t.onChange(parseInt(e.target.value))},t.renderSelectMode=function(){return ue.default.createElement("select",{value:P.getTime(Oe(t.props.date)),className:"react-datepicker__month-year-select",onChange:t.onSelectChange},t.renderSelectOptions())},t.renderReadView=function(e){var r=Ee(t.props.date,t.props.dateFormat,t.props.locale);return ue.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:t.toggleDropdown},ue.default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),ue.default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))},t.renderDropdown=function(){return ue.default.createElement(Lt,ve({key:"dropdown"},t.props,{onChange:t.onChange,onCancel:t.toggleDropdown}))},t.renderScrollMode=function(){var e=t.state.dropdownVisible,r=[t.renderReadView(!e)];return e&&r.unshift(t.renderDropdown()),r},t.onChange=function(e){t.toggleDropdown();var r=Me(e);Ae(t.props.date,r)&&He(t.props.date,r)||t.props.onChange(r)},t.toggleDropdown=function(){return t.setState({dropdownVisible:!t.state.dropdownVisible})},t}return me(t,e),t.prototype.render=function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return ue.default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)},t}(r.Component),At=function(e){function t(){var r=null!==e&&e.apply(this,arguments)||this;return r.state={height:null},r.scrollToTheSelectedTime=function(){requestAnimationFrame((function(){var e,n,a;r.list&&(r.list.scrollTop=null!==(a=r.centerLi&&t.calcCenterPosition(r.props.monthRef?r.props.monthRef.clientHeight-(null!==(n=null===(e=r.header)||void 0===e?void 0:e.clientHeight)&&void 0!==n?n:0):r.list.clientHeight,r.centerLi))&&void 0!==a?a:0)}))},r.handleClick=function(e){var t,n;(r.props.minTime||r.props.maxTime)&&st(e,r.props)||(r.props.excludeTimes||r.props.includeTimes||r.props.filterTime)&&ot(e,r.props)||null===(n=(t=r.props).onChange)||void 0===n||n.call(t,e)},r.isSelectedTime=function(e){return r.props.selected&&(t=r.props.selected,n=e,Dt(t).getTime()===Dt(n).getTime());var t,n},r.isDisabledTime=function(e){return(r.props.minTime||r.props.maxTime)&&st(e,r.props)||(r.props.excludeTimes||r.props.includeTimes||r.props.filterTime)&&ot(e,r.props)},r.liClasses=function(e){var n,a=["react-datepicker__time-list-item",r.props.timeClassName?r.props.timeClassName(e):void 0];return r.isSelectedTime(e)&&a.push("react-datepicker__time-list-item--selected"),r.isDisabledTime(e)&&a.push("react-datepicker__time-list-item--disabled"),r.props.injectTimes&&(3600*b.getHours(e)+60*C.getMinutes(e)+Y.getSeconds(e))%(60*(null!==(n=r.props.intervals)&&void 0!==n?n:t.defaultProps.intervals))!=0&&a.push("react-datepicker__time-list-item--injected"),a.join(" ")},r.handleOnKeyDown=function(e,t){var n,a;e.key===De.Space&&(e.preventDefault(),e.key=De.Enter),(e.key===De.ArrowUp||e.key===De.ArrowLeft)&&e.target instanceof HTMLElement&&e.target.previousSibling&&(e.preventDefault(),e.target.previousSibling instanceof HTMLElement&&e.target.previousSibling.focus()),(e.key===De.ArrowDown||e.key===De.ArrowRight)&&e.target instanceof HTMLElement&&e.target.nextSibling&&(e.preventDefault(),e.target.nextSibling instanceof HTMLElement&&e.target.nextSibling.focus()),e.key===De.Enter&&r.handleClick(t),null===(a=(n=r.props).handleOnKeyDown)||void 0===a||a.call(n,e)},r.renderTimes=function(){for(var e,n=[],a="string"==typeof r.props.format?r.props.format:"p",o=null!==(e=r.props.intervals)&&void 0!==e?e:t.defaultProps.intervals,i=r.props.selected||r.props.openToDate||Me(),l=xe(i),c=r.props.injectTimes&&r.props.injectTimes.sort((function(e,t){return e.getTime()-t.getTime()})),p=60*function(e){var t=new Date(e.getFullYear(),e.getMonth(),e.getDate()),r=new Date(e.getFullYear(),e.getMonth(),e.getDate(),24);return Math.round((+r-+t)/36e5)}(i),d=p/o,u=0;u<d;u++){var f=s.addMinutes(l,u*o);if(n.push(f),c){var h=mt(l,f,u,o,c);n=n.concat(h)}}var m=n.reduce((function(e,t){return t.getTime()<=i.getTime()?t:e}),n[0]);return n.map((function(e){return ue.default.createElement("li",{key:e.valueOf(),onClick:r.handleClick.bind(r,e),className:r.liClasses(e),ref:function(t){e===m&&(r.centerLi=t)},onKeyDown:function(t){r.handleOnKeyDown(t,e)},tabIndex:e===m?0:-1,role:"option","aria-selected":r.isSelectedTime(e)?"true":void 0,"aria-disabled":r.isDisabledTime(e)?"true":void 0},Ee(e,a,r.props.locale))}))},r.renderTimeCaption=function(){return!1===r.props.showTimeCaption?ue.default.createElement(ue.default.Fragment,null):ue.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(r.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(e){r.header=e}},ue.default.createElement("div",{className:"react-datepicker-time__header"},r.props.timeCaption))},r}return me(t,e),Object.defineProperty(t,"defaultProps",{get:function(){return{intervals:30,todayButton:null,timeCaption:"Time",showTimeCaption:!0}},enumerable:!1,configurable:!0}),t.prototype.componentDidMount=function(){this.scrollToTheSelectedTime(),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})},t.prototype.render=function(){var e,r=this,n=this.state.height;return ue.default.createElement("div",{className:"react-datepicker__time-container ".concat((null!==(e=this.props.todayButton)&&void 0!==e?e:t.defaultProps.todayButton)?"react-datepicker__time-container--with-today-button":"")},this.renderTimeCaption(),ue.default.createElement("div",{className:"react-datepicker__time"},ue.default.createElement("div",{className:"react-datepicker__time-box"},ue.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(e){r.list=e},style:n?{height:n}:{},role:"listbox","aria-label":this.props.timeCaption},this.renderTimes()))))},t.calcCenterPosition=function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)},t}(r.Component),Ht=function(e){function n(n){var a=e.call(this,n)||this;return a.YEAR_REFS=ge([],Array(a.props.yearItemNumber),!0).map((function(){return r.createRef()})),a.isDisabled=function(e){return $e(e,{minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,includeDates:a.props.includeDates,filterDate:a.props.filterDate})},a.isExcluded=function(e){return ze(e,{excludeDates:a.props.excludeDates})},a.selectingDate=function(){var e;return null!==(e=a.props.selectingDate)&&void 0!==e?e:a.props.preSelection},a.updateFocusOnPaginate=function(e){window.requestAnimationFrame((function(){var t,r;null===(r=null===(t=a.YEAR_REFS[e])||void 0===t?void 0:t.current)||void 0===r||r.focus()}))},a.handleYearClick=function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t)},a.handleYearNavigation=function(e,t){var r,n,o,s,i=a.props,l=i.date,c=i.yearItemNumber;if(void 0!==l&&void 0!==c){var p=gt(l,c).startPeriod;a.isDisabled(t)||a.isExcluded(t)||(null===(n=(r=a.props).setPreSelection)||void 0===n||n.call(r,t),e-p<0?a.updateFocusOnPaginate(c-(p-e)):e-p>=c?a.updateFocusOnPaginate(Math.abs(c-(e-p))):null===(s=null===(o=a.YEAR_REFS[e-p])||void 0===o?void 0:o.current)||void 0===s||s.focus())}},a.isSameDay=function(e,t){return Qe(e,t)},a.isCurrentYear=function(e){return e===x.getYear(Me())},a.isRangeStart=function(e){return a.props.startDate&&a.props.endDate&&Ae(G.setYear(Me(),e),a.props.startDate)},a.isRangeEnd=function(e){return a.props.startDate&&a.props.endDate&&Ae(G.setYear(Me(),e),a.props.endDate)},a.isInRange=function(e){return et(e,a.props.startDate,a.props.endDate)},a.isInSelectingRange=function(e){var t=a.props,r=t.selectsStart,n=t.selectsEnd,o=t.selectsRange,s=t.startDate,i=t.endDate;return!(!(r||n||o)||!a.selectingDate())&&(r&&i?et(e,a.selectingDate(),i):(n&&s||!(!o||!s||i))&&et(e,s,a.selectingDate()))},a.isSelectingRangeStart=function(e){var t;if(!a.isInSelectingRange(e))return!1;var r=a.props,n=r.startDate,o=r.selectsStart,s=G.setYear(Me(),e);return Ae(s,o?null!==(t=a.selectingDate())&&void 0!==t?t:null:null!=n?n:null)},a.isSelectingRangeEnd=function(e){var t;if(!a.isInSelectingRange(e))return!1;var r=a.props,n=r.endDate,o=r.selectsEnd,s=r.selectsRange,i=G.setYear(Me(),e);return Ae(i,o||s?null!==(t=a.selectingDate())&&void 0!==t?t:null:null!=n?n:null)},a.isKeyboardSelected=function(e){if(void 0!==a.props.date&&null!=a.props.selected&&null!=a.props.preSelection){var t=a.props,r=t.minDate,n=t.maxDate,o=t.excludeDates,s=t.includeDates,i=t.filterDate,l=Te(G.setYear(a.props.date,e)),c=(r||n||o||s||i)&&tt(e,a.props);return!a.props.disabledKeyboardNavigation&&!a.props.inline&&!Qe(l,Te(a.props.selected))&&Qe(l,Te(a.props.preSelection))&&!c}},a.onYearClick=function(e,t){var r=a.props.date;void 0!==r&&a.handleYearClick(Te(G.setYear(r,t)),e)},a.onYearKeyDown=function(e,t){var r,n,o=e.key,s=a.props,i=s.date,l=s.yearItemNumber,c=s.handleOnKeyDown;if(o!==De.Tab&&e.preventDefault(),!a.props.disabledKeyboardNavigation)switch(o){case De.Enter:if(null==a.props.selected)break;a.onYearClick(e,t),null===(n=(r=a.props).setPreSelection)||void 0===n||n.call(r,a.props.selected);break;case De.ArrowRight:if(null==a.props.preSelection)break;a.handleYearNavigation(t+1,d.addYears(a.props.preSelection,1));break;case De.ArrowLeft:if(null==a.props.preSelection)break;a.handleYearNavigation(t-1,ie.subYears(a.props.preSelection,1));break;case De.ArrowUp:if(void 0===i||void 0===l||null==a.props.preSelection)break;var p=gt(i,l).startPeriod;if((h=t-(f=3))<p){var u=l%f;t>=p&&t<p+u?f=u:f+=u,h=t-f}a.handleYearNavigation(h,ie.subYears(a.props.preSelection,f));break;case De.ArrowDown:if(void 0===i||void 0===l||null==a.props.preSelection)break;var f,h,m=gt(i,l).endPeriod;if((h=t+(f=3))>m){u=l%f;t<=m&&t>m-u?f=u:f+=u,h=t+f}a.handleYearNavigation(h,d.addYears(a.props.preSelection,f))}c&&c(e)},a.getYearClassNames=function(e){var r=a.props,n=r.date,o=r.minDate,s=r.maxDate,i=r.selected,l=r.excludeDates,c=r.includeDates,p=r.filterDate,d=r.yearClassName;return t.clsx("react-datepicker__year-text","react-datepicker__year-".concat(e),n?null==d?void 0:d(G.setYear(n,e)):void 0,{"react-datepicker__year-text--selected":i?e===x.getYear(i):void 0,"react-datepicker__year-text--disabled":(o||s||l||c||p)&&tt(e,a.props),"react-datepicker__year-text--keyboard-selected":a.isKeyboardSelected(e),"react-datepicker__year-text--range-start":a.isRangeStart(e),"react-datepicker__year-text--range-end":a.isRangeEnd(e),"react-datepicker__year-text--in-range":a.isInRange(e),"react-datepicker__year-text--in-selecting-range":a.isInSelectingRange(e),"react-datepicker__year-text--selecting-range-start":a.isSelectingRangeStart(e),"react-datepicker__year-text--selecting-range-end":a.isSelectingRangeEnd(e),"react-datepicker__year-text--today":a.isCurrentYear(e)})},a.getYearTabIndex=function(e){if(a.props.disabledKeyboardNavigation||null==a.props.preSelection)return"-1";var t=x.getYear(a.props.preSelection),r=tt(e,a.props);return e!==t||r?"-1":"0"},a.getYearContainerClassNames=function(){var e=a.props,r=e.selectingDate,n=e.selectsStart,o=e.selectsEnd,s=e.selectsRange;return t.clsx("react-datepicker__year",{"react-datepicker__year--selecting-range":r&&(n||o||s)})},a.getYearContent=function(e){return a.props.renderYearContent?a.props.renderYearContent(e):e},a}return me(n,e),n.prototype.render=function(){var e=this,t=[],r=this.props,n=r.date,a=r.yearItemNumber,o=r.onYearMouseEnter,s=r.onYearMouseLeave;if(void 0===n)return null;for(var i=gt(n,a),l=i.startPeriod,c=i.endPeriod,p=function(r){t.push(ue.default.createElement("div",{ref:d.YEAR_REFS[r-l],onClick:function(t){e.onYearClick(t,r)},onKeyDown:function(t){wt(t)&&(t.preventDefault(),t.key=De.Enter),e.onYearKeyDown(t,r)},tabIndex:Number(d.getYearTabIndex(r)),className:d.getYearClassNames(r),onMouseEnter:d.props.usePointerEvent?void 0:function(e){return o(e,r)},onPointerEnter:d.props.usePointerEvent?function(e){return o(e,r)}:void 0,onMouseLeave:d.props.usePointerEvent?void 0:function(e){return s(e,r)},onPointerLeave:d.props.usePointerEvent?function(e){return s(e,r)}:void 0,key:r,"aria-current":d.isCurrentYear(r)?"date":void 0},d.getYearContent(r)))},d=this,u=l;u<=c;u++)p(u);return ue.default.createElement("div",{className:this.getYearContainerClassNames()},ue.default.createElement("div",{className:"react-datepicker__year-wrapper",onMouseLeave:this.props.usePointerEvent?void 0:this.props.clearSelectingDate,onPointerLeave:this.props.usePointerEvent?this.props.clearSelectingDate:void 0},t))},n}(r.Component);function Wt(e,t,r,n){for(var a=[],o=0;o<2*t+1;o++){var s=e+t-o,i=!0;r&&(i=x.getYear(r)<=s),n&&i&&(i=x.getYear(n)>=s),i&&a.push(s)}return a}var Qt=function(e){function n(t){var n=e.call(this,t)||this;n.renderOptions=function(){var e=n.props.year,t=n.state.yearsList.map((function(t){return ue.default.createElement("div",{className:e===t?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:t,onClick:n.onChange.bind(n,t),"aria-selected":e===t?"true":void 0},e===t?ue.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)})),r=n.props.minDate?x.getYear(n.props.minDate):null,a=n.props.maxDate?x.getYear(n.props.maxDate):null;return a&&n.state.yearsList.find((function(e){return e===a}))||t.unshift(ue.default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:n.incrementYears},ue.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),r&&n.state.yearsList.find((function(e){return e===r}))||t.push(ue.default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:n.decrementYears},ue.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t},n.onChange=function(e){n.props.onChange(e)},n.handleClickOutside=function(){n.props.onCancel()},n.shiftYears=function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t})},n.incrementYears=function(){return n.shiftYears(1)},n.decrementYears=function(){return n.shiftYears(-1)};var a=t.yearDropdownItemNumber,o=t.scrollableYearDropdown,s=a||(o?10:5);return n.state={yearsList:Wt(n.props.year,s,n.props.minDate,n.props.maxDate)},n.dropdownRef=r.createRef(),n}return me(n,e),n.prototype.componentDidMount=function(){var e=this.dropdownRef.current;if(e){var t=e.children?Array.from(e.children):null,r=t?t.find((function(e){return e.ariaSelected})):null;e.scrollTop=r&&r instanceof HTMLElement?r.offsetTop+(r.clientHeight-e.clientHeight)/2:(e.scrollHeight-e.clientHeight)/2}},n.prototype.render=function(){var e=t.clsx({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return ue.default.createElement(ke,{className:e,containerRef:this.dropdownRef,onClickOutside:this.handleClickOutside},this.renderOptions())},n}(r.Component),qt=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={dropdownVisible:!1},t.renderSelectOptions=function(){for(var e=t.props.minDate?x.getYear(t.props.minDate):1900,r=t.props.maxDate?x.getYear(t.props.maxDate):2100,n=[],a=e;a<=r;a++)n.push(ue.default.createElement("option",{key:a,value:a},a));return n},t.onSelectChange=function(e){t.onChange(parseInt(e.target.value))},t.renderSelectMode=function(){return ue.default.createElement("select",{value:t.props.year,className:"react-datepicker__year-select",onChange:t.onSelectChange},t.renderSelectOptions())},t.renderReadView=function(e){return ue.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(e){return t.toggleDropdown(e)}},ue.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),ue.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},t.props.year))},t.renderDropdown=function(){return ue.default.createElement(Qt,ve({key:"dropdown"},t.props,{onChange:t.onChange,onCancel:t.toggleDropdown}))},t.renderScrollMode=function(){var e=t.state.dropdownVisible,r=[t.renderReadView(!e)];return e&&r.unshift(t.renderDropdown()),r},t.onChange=function(e){t.toggleDropdown(),e!==t.props.year&&t.props.onChange(e)},t.toggleDropdown=function(e){t.setState({dropdownVisible:!t.state.dropdownVisible},(function(){t.props.adjustDateOnChange&&t.handleYearChange(t.props.date,e)}))},t.handleYearChange=function(e,r){var n;null===(n=t.onSelect)||void 0===n||n.call(t,e,r),t.setOpen()},t.onSelect=function(e,r){var n,a;null===(a=(n=t.props).onSelect)||void 0===a||a.call(n,e,r)},t.setOpen=function(){var e,r;null===(r=(e=t.props).setOpen)||void 0===r||r.call(e,!0)},t}return me(t,e),t.prototype.render=function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return ue.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)},t}(r.Component),Kt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Bt=function(e){function o(s){var c=e.call(this,s)||this;return c.monthContainer=void 0,c.handleClickOutside=function(e){c.props.onClickOutside(e)},c.setClickOutsideRef=function(){return c.containerRef.current},c.handleDropdownFocus=function(e){var t,r,n,a;n=e.target,a=(n.className||"").split(/\s+/),Kt.some((function(e){return a.indexOf(e)>=0}))&&(null===(r=(t=c.props).onDropdownFocus)||void 0===r||r.call(t,e))},c.getDateInView=function(){var e=c.props,t=e.preSelection,r=e.selected,n=e.openToDate,a=dt(c.props),o=ut(c.props),s=Me(),i=n||r||t;return i||(a&&O.isBefore(s,a)?a:o&&N.isAfter(s,o)?o:s)},c.increaseMonth=function(){c.setState((function(e){var t=e.date;return{date:i.addMonths(t,1)}}),(function(){return c.handleMonthChange(c.state.date)}))},c.decreaseMonth=function(){c.setState((function(e){var t=e.date;return{date:ae.subMonths(t,1)}}),(function(){return c.handleMonthChange(c.state.date)}))},c.handleDayClick=function(e,t,r){c.props.onSelect(e,t,r),c.props.setPreSelection&&c.props.setPreSelection(e)},c.handleDayMouseEnter=function(e){c.setState({selectingDate:e}),c.props.onDayMouseEnter&&c.props.onDayMouseEnter(e)},c.handleMonthMouseLeave=function(){c.setState({selectingDate:void 0}),c.props.onMonthMouseLeave&&c.props.onMonthMouseLeave()},c.handleYearMouseEnter=function(e,t){c.setState({selectingDate:G.setYear(Me(),t)}),c.props.onYearMouseEnter&&c.props.onYearMouseEnter(e,t)},c.handleYearMouseLeave=function(e,t){c.props.onYearMouseLeave&&c.props.onYearMouseLeave(e,t)},c.handleYearChange=function(e){var t,r,n,a;null===(r=(t=c.props).onYearChange)||void 0===r||r.call(t,e),c.setState({isRenderAriaLiveMessage:!0}),c.props.adjustDateOnChange&&(c.props.onSelect(e),null===(a=(n=c.props).setOpen)||void 0===a||a.call(n,!0)),c.props.setPreSelection&&c.props.setPreSelection(e)},c.getEnabledPreSelectionDateForMonth=function(e){if(!$e(e,c.props))return e;for(var t=Oe(e),r=Fe(e),o=n.differenceInDays(r,t),s=null,i=0;i<=o;i++){var l=a.addDays(t,i);if(!$e(l,c.props)){s=l;break}}return s},c.handleMonthChange=function(e){var t,r,n,a=null!==(t=c.getEnabledPreSelectionDateForMonth(e))&&void 0!==t?t:e;c.handleCustomMonthChange(a),c.props.adjustDateOnChange&&(c.props.onSelect(a),null===(n=(r=c.props).setOpen)||void 0===n||n.call(r,!0)),c.props.setPreSelection&&c.props.setPreSelection(a)},c.handleCustomMonthChange=function(e){var t,r;null===(r=(t=c.props).onMonthChange)||void 0===r||r.call(t,e),c.setState({isRenderAriaLiveMessage:!0})},c.handleMonthYearChange=function(e){c.handleYearChange(e),c.handleMonthChange(e)},c.changeYear=function(e){c.setState((function(t){var r=t.date;return{date:G.setYear(r,Number(e))}}),(function(){return c.handleYearChange(c.state.date)}))},c.changeMonth=function(e){c.setState((function(t){var r=t.date;return{date:$.setMonth(r,Number(e))}}),(function(){return c.handleMonthChange(c.state.date)}))},c.changeMonthYear=function(e){c.setState((function(t){var r=t.date;return{date:G.setYear($.setMonth(r,_.getMonth(e)),x.getYear(e))}}),(function(){return c.handleMonthYearChange(c.state.date)}))},c.header=function(e){void 0===e&&(e=c.state.date);var r=Ne(e,c.props.locale,c.props.calendarStartDay),n=[];return c.props.showWeekNumbers&&n.push(ue.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},c.props.weekLabel||"#")),n.concat([0,1,2,3,4,5,6].map((function(e){var n=a.addDays(r,e),o=c.formatWeekday(n,c.props.locale),s=c.props.weekDayClassName?c.props.weekDayClassName(n):void 0;return ue.default.createElement("div",{key:e,"aria-label":Ee(n,"EEEE",c.props.locale),className:t.clsx("react-datepicker__day-name",s)},o)})))},c.formatWeekday=function(e,t){return c.props.formatWeekDay?function(e,t,r){return t(Ee(e,"EEEE",r))}(e,c.props.formatWeekDay,t):c.props.useWeekdaysShort?function(e,t){return Ee(e,"EEE",t)}(e,t):function(e,t){return Ee(e,"EEEEEE",t)}(e,t)},c.decreaseYear=function(){c.setState((function(e){var t,r=e.date;return{date:ie.subYears(r,c.props.showYearPicker?null!==(t=c.props.yearItemNumber)&&void 0!==t?t:o.defaultProps.yearItemNumber:1)}}),(function(){return c.handleYearChange(c.state.date)}))},c.clearSelectingDate=function(){c.setState({selectingDate:void 0})},c.renderPreviousButton=function(){var e;if(!c.props.renderCustomHeader){var t;switch(!0){case c.props.showMonthYearPicker:t=ct(c.state.date,c.props);break;case c.props.showYearPicker:t=function(e,t){var r=void 0===t?{}:t,n=r.minDate,a=r.yearItemNumber,o=void 0===a?Se:a,s=gt(Te(ie.subYears(e,o)),o).endPeriod,i=n&&x.getYear(n);return i&&i>s||!1}(c.state.date,c.props);break;case c.props.showQuarterYearPicker:t=function(e,t){var r=void 0===t?{}:t,n=r.minDate,a=r.includeDates,o=re.startOfYear(e),s=oe.subQuarters(o,1);return n&&h.differenceInCalendarQuarters(n,s)>0||a&&a.every((function(e){return h.differenceInCalendarQuarters(e,s)>0}))||!1}(c.state.date,c.props);break;default:t=it(c.state.date,c.props)}if(((null!==(e=c.props.forceShowMonthNavigation)&&void 0!==e?e:o.defaultProps.forceShowMonthNavigation)||c.props.showDisabledMonthNavigation||!t)&&!c.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--previous"],n=c.decreaseMonth;(c.props.showMonthYearPicker||c.props.showQuarterYearPicker||c.props.showYearPicker)&&(n=c.decreaseYear),t&&c.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--previous--disabled"),n=void 0);var a=c.props.showMonthYearPicker||c.props.showQuarterYearPicker||c.props.showYearPicker,s=c.props,i=s.previousMonthButtonLabel,l=void 0===i?o.defaultProps.previousMonthButtonLabel:i,p=s.previousYearButtonLabel,d=void 0===p?o.defaultProps.previousYearButtonLabel:p,u=c.props,f=u.previousMonthAriaLabel,m=void 0===f?"string"==typeof l?l:"Previous Month":f,v=u.previousYearAriaLabel,g=void 0===v?"string"==typeof d?d:"Previous Year":v;return ue.default.createElement("button",{type:"button",className:r.join(" "),onClick:n,onKeyDown:c.props.handleOnKeyDown,"aria-label":a?g:m},ue.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--previous"].join(" ")},a?d:l))}}},c.increaseYear=function(){c.setState((function(e){var t,r=e.date;return{date:d.addYears(r,c.props.showYearPicker?null!==(t=c.props.yearItemNumber)&&void 0!==t?t:o.defaultProps.yearItemNumber:1)}}),(function(){return c.handleYearChange(c.state.date)}))},c.renderNextButton=function(){var e;if(!c.props.renderCustomHeader){var t;switch(!0){case c.props.showMonthYearPicker:t=pt(c.state.date,c.props);break;case c.props.showYearPicker:t=function(e,t){var r=void 0===t?{}:t,n=r.maxDate,a=r.yearItemNumber,o=void 0===a?Se:a,s=gt(d.addYears(e,o),o).startPeriod,i=n&&x.getYear(n);return i&&i<s||!1}(c.state.date,c.props);break;case c.props.showQuarterYearPicker:t=function(e,t){var r=void 0===t?{}:t,n=r.maxDate,a=r.includeDates,o=y.endOfYear(e),s=l.addQuarters(o,1);return n&&h.differenceInCalendarQuarters(s,n)>0||a&&a.every((function(e){return h.differenceInCalendarQuarters(s,e)>0}))||!1}(c.state.date,c.props);break;default:t=lt(c.state.date,c.props)}if(((null!==(e=c.props.forceShowMonthNavigation)&&void 0!==e?e:o.defaultProps.forceShowMonthNavigation)||c.props.showDisabledMonthNavigation||!t)&&!c.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--next"];c.props.showTimeSelect&&r.push("react-datepicker__navigation--next--with-time"),c.props.todayButton&&r.push("react-datepicker__navigation--next--with-today-button");var n=c.increaseMonth;(c.props.showMonthYearPicker||c.props.showQuarterYearPicker||c.props.showYearPicker)&&(n=c.increaseYear),t&&c.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--next--disabled"),n=void 0);var a=c.props.showMonthYearPicker||c.props.showQuarterYearPicker||c.props.showYearPicker,s=c.props,i=s.nextMonthButtonLabel,p=void 0===i?o.defaultProps.nextMonthButtonLabel:i,u=s.nextYearButtonLabel,f=void 0===u?o.defaultProps.nextYearButtonLabel:u,m=c.props,v=m.nextMonthAriaLabel,g=void 0===v?"string"==typeof p?p:"Next Month":v,D=m.nextYearAriaLabel,k=void 0===D?"string"==typeof f?f:"Next Year":D;return ue.default.createElement("button",{type:"button",className:r.join(" "),onClick:n,onKeyDown:c.props.handleOnKeyDown,"aria-label":a?k:g},ue.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--next"].join(" ")},a?f:p))}}},c.renderCurrentMonth=function(e){void 0===e&&(e=c.state.date);var t=["react-datepicker__current-month"];return c.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),c.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),c.props.showMonthYearDropdown&&t.push("react-datepicker__current-month--hasMonthYearDropdown"),ue.default.createElement("h2",{className:t.join(" ")},Ee(e,c.props.dateFormat,c.props.locale))},c.renderYearDropdown=function(e){if(void 0===e&&(e=!1),c.props.showYearDropdown&&!e)return ue.default.createElement(qt,ve({},o.defaultProps,c.props,{date:c.state.date,onChange:c.changeYear,year:x.getYear(c.state.date)}))},c.renderMonthDropdown=function(e){if(void 0===e&&(e=!1),c.props.showMonthDropdown&&!e)return ue.default.createElement(It,ve({},o.defaultProps,c.props,{month:_.getMonth(c.state.date),onChange:c.changeMonth}))},c.renderMonthYearDropdown=function(e){if(void 0===e&&(e=!1),c.props.showMonthYearDropdown&&!e)return ue.default.createElement(Ft,ve({},o.defaultProps,c.props,{date:c.state.date,onChange:c.changeMonthYear}))},c.handleTodayButtonClick=function(e){c.props.onSelect(Re(),e),c.props.setPreSelection&&c.props.setPreSelection(Re())},c.renderTodayButton=function(){if(c.props.todayButton&&!c.props.showTimeSelectOnly)return ue.default.createElement("div",{className:"react-datepicker__today-button",onClick:c.handleTodayButtonClick},c.props.todayButton)},c.renderDefaultHeader=function(e){var t=e.monthDate,r=e.i;return ue.default.createElement("div",{className:"react-datepicker__header ".concat(c.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},c.renderCurrentMonth(t),ue.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(c.props.dropdownMode),onFocus:c.handleDropdownFocus},c.renderMonthDropdown(0!==r),c.renderMonthYearDropdown(0!==r),c.renderYearDropdown(0!==r)),ue.default.createElement("div",{className:"react-datepicker__day-names"},c.header(t)))},c.renderCustomHeader=function(e){var t,r,n=e.monthDate,a=e.i;if(c.props.showTimeSelect&&!c.state.monthContainer||c.props.showTimeSelectOnly)return null;var o=it(c.state.date,c.props),s=lt(c.state.date,c.props),i=ct(c.state.date,c.props),l=pt(c.state.date,c.props),p=!c.props.showMonthYearPicker&&!c.props.showQuarterYearPicker&&!c.props.showYearPicker;return ue.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:c.props.onDropdownFocus},null===(r=(t=c.props).renderCustomHeader)||void 0===r?void 0:r.call(t,ve(ve({},c.state),{customHeaderCount:a,monthDate:n,changeMonth:c.changeMonth,changeYear:c.changeYear,decreaseMonth:c.decreaseMonth,increaseMonth:c.increaseMonth,decreaseYear:c.decreaseYear,increaseYear:c.increaseYear,prevMonthButtonDisabled:o,nextMonthButtonDisabled:s,prevYearButtonDisabled:i,nextYearButtonDisabled:l})),p&&ue.default.createElement("div",{className:"react-datepicker__day-names"},c.header(n)))},c.renderYearHeader=function(e){var t=e.monthDate,r=c.props,n=r.showYearPicker,a=r.yearItemNumber,s=gt(t,void 0===a?o.defaultProps.yearItemNumber:a),i=s.startPeriod,l=s.endPeriod;return ue.default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},n?"".concat(i," - ").concat(l):x.getYear(t))},c.renderHeader=function(e){var t=e.monthDate,r=e.i,n={monthDate:t,i:void 0===r?0:r};switch(!0){case void 0!==c.props.renderCustomHeader:return c.renderCustomHeader(n);case c.props.showMonthYearPicker||c.props.showQuarterYearPicker||c.props.showYearPicker:return c.renderYearHeader(n);default:return c.renderDefaultHeader(n)}},c.renderMonths=function(){var e,t;if(!c.props.showTimeSelectOnly&&!c.props.showYearPicker){for(var r=[],n=null!==(e=c.props.monthsShown)&&void 0!==e?e:o.defaultProps.monthsShown,a=c.props.showPreviousMonths?n-1:0,s=c.props.showMonthYearPicker||c.props.showQuarterYearPicker?d.addYears(c.state.date,a):ae.subMonths(c.state.date,a),l=null!==(t=c.props.monthSelectedIn)&&void 0!==t?t:a,p=0;p<n;++p){var u=p-l+a,f=c.props.showMonthYearPicker||c.props.showQuarterYearPicker?d.addYears(s,u):i.addMonths(s,u),h="month-".concat(p),m=p<n-1,v=p>0;r.push(ue.default.createElement("div",{key:h,ref:function(e){c.monthContainer=null!=e?e:void 0},className:"react-datepicker__month-container"},c.renderHeader({monthDate:f,i:p}),ue.default.createElement(Ot,ve({},o.defaultProps,c.props,{ariaLabelPrefix:c.props.monthAriaLabelPrefix,day:f,onDayClick:c.handleDayClick,handleOnKeyDown:c.props.handleOnDayKeyDown,handleOnMonthKeyDown:c.props.handleOnKeyDown,onDayMouseEnter:c.handleDayMouseEnter,onMouseLeave:c.handleMonthMouseLeave,orderInDisplay:p,selectingDate:c.state.selectingDate,monthShowsDuplicateDaysEnd:m,monthShowsDuplicateDaysStart:v}))))}return r}},c.renderYears=function(){if(!c.props.showTimeSelectOnly)return c.props.showYearPicker?ue.default.createElement("div",{className:"react-datepicker__year--container"},c.renderHeader({monthDate:c.state.date}),ue.default.createElement(Ht,ve({},o.defaultProps,c.props,{selectingDate:c.state.selectingDate,date:c.state.date,onDayClick:c.handleDayClick,clearSelectingDate:c.clearSelectingDate,onYearMouseEnter:c.handleYearMouseEnter,onYearMouseLeave:c.handleYearMouseLeave}))):void 0},c.renderTimeSection=function(){if(c.props.showTimeSelect&&(c.state.monthContainer||c.props.showTimeSelectOnly))return ue.default.createElement(At,ve({},o.defaultProps,c.props,{onChange:c.props.onTimeChange,format:c.props.timeFormat,intervals:c.props.timeIntervals,monthRef:c.state.monthContainer}))},c.renderInputTimeSection=function(){var e=c.props.selected?new Date(c.props.selected):void 0,t=e&&_e(e)&&Boolean(c.props.selected)?"".concat(vt(e.getHours()),":").concat(vt(e.getMinutes())):"";if(c.props.showTimeInput)return ue.default.createElement(bt,ve({},o.defaultProps,c.props,{date:e,timeString:t,onChange:c.props.onTimeChange}))},c.renderAriaLiveRegion=function(){var e,t,r=gt(c.state.date,null!==(e=c.props.yearItemNumber)&&void 0!==e?e:o.defaultProps.yearItemNumber),n=r.startPeriod,a=r.endPeriod;return t=c.props.showYearPicker?"".concat(n," - ").concat(a):c.props.showMonthYearPicker||c.props.showQuarterYearPicker?x.getYear(c.state.date):"".concat(je(_.getMonth(c.state.date),c.props.locale)," ").concat(x.getYear(c.state.date)),ue.default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},c.state.isRenderAriaLiveMessage&&t)},c.renderChildren=function(){if(c.props.children)return ue.default.createElement("div",{className:"react-datepicker__children-container"},c.props.children)},c.containerRef=r.createRef(),c.state={date:c.getDateInView(),selectingDate:void 0,monthContainer:void 0,isRenderAriaLiveMessage:!1},c}return me(o,e),Object.defineProperty(o,"defaultProps",{get:function(){return{monthsShown:1,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",yearItemNumber:Se}},enumerable:!1,configurable:!0}),o.prototype.componentDidMount=function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))},o.prototype.componentDidUpdate=function(e){var t=this;if(!this.props.preSelection||Qe(this.props.preSelection,e.preSelection)&&this.props.monthSelectedIn===e.monthSelectedIn)this.props.openToDate&&!Qe(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate});else{var r=!He(this.state.date,this.props.preSelection);this.setState({date:this.props.preSelection},(function(){return r&&t.handleCustomMonthChange(t.state.date)}))}},o.prototype.render=function(){var e=this.props.container||ye;return ue.default.createElement(ke,{onClickOutside:this.handleClickOutside,style:{display:"contents"},containerRef:this.containerRef,ignoreClass:this.props.outsideClickIgnoreClass},ue.default.createElement(e,{className:t.clsx("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showTime:this.props.showTimeSelect||this.props.showTimeInput,showTimeSelectOnly:this.props.showTimeSelectOnly},this.renderAriaLiveRegion(),this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.renderChildren()))},o}(r.Component),Vt=function(e){var t=e.icon,r=e.className,n=void 0===r?"":r,a=e.onClick,o="react-datepicker__calendar-icon";return"string"==typeof t?ue.default.createElement("i",{className:"".concat(o," ").concat(t," ").concat(n),"aria-hidden":"true",onClick:a}):ue.default.isValidElement(t)?ue.default.cloneElement(t,{className:"".concat(t.props.className||""," ").concat(o," ").concat(n),onClick:function(e){"function"==typeof t.props.onClick&&t.props.onClick(e),"function"==typeof a&&a(e)}}):ue.default.createElement("svg",{className:"".concat(o," ").concat(n),xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 448 512",onClick:a},ue.default.createElement("path",{d:"M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"}))},jt=function(e){function t(t){var r=e.call(this,t)||this;return r.portalRoot=null,r.el=document.createElement("div"),r}return me(t,e),t.prototype.componentDidMount=function(){this.portalRoot=(this.props.portalHost||document).getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),(this.props.portalHost||document.body).appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el)},t.prototype.componentWillUnmount=function(){this.portalRoot&&this.portalRoot.removeChild(this.el)},t.prototype.render=function(){return fe.default.createPortal(this.props.children,this.el)},t}(r.Component),Ut=function(e){return(e instanceof HTMLAnchorElement||!e.disabled)&&-1!==e.tabIndex},$t=function(e){function t(t){var n=e.call(this,t)||this;return n.getTabChildren=function(){var e;return Array.prototype.slice.call(null===(e=n.tabLoopRef.current)||void 0===e?void 0:e.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(Ut)},n.handleFocusStart=function(){var e=n.getTabChildren();e&&e.length>1&&e[e.length-1].focus()},n.handleFocusEnd=function(){var e=n.getTabChildren();e&&e.length>1&&e[0].focus()},n.tabLoopRef=r.createRef(),n}return me(t,e),t.prototype.render=function(){var e;return(null!==(e=this.props.enableTabLoop)&&void 0!==e?e:t.defaultProps.enableTabLoop)?ue.default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},ue.default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:0,onFocus:this.handleFocusStart}),this.props.children,ue.default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:0,onFocus:this.handleFocusEnd})):this.props.children},t.defaultProps={enableTabLoop:!0},t}(r.Component);var zt,Xt=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return me(n,e),Object.defineProperty(n,"defaultProps",{get:function(){return{hidePopper:!0}},enumerable:!1,configurable:!0}),n.prototype.render=function(){var e=this.props,a=e.className,o=e.wrapperClassName,s=e.hidePopper,i=void 0===s?n.defaultProps.hidePopper:s,l=e.popperComponent,c=e.targetComponent,p=e.enableTabLoop,d=e.popperOnKeyDown,u=e.portalId,f=e.portalHost,h=e.popperProps,m=e.showArrow,v=void 0;if(!i){var g=t.clsx("react-datepicker-popper",a);v=ue.default.createElement($t,{enableTabLoop:p},ue.default.createElement("div",{ref:h.refs.setFloating,style:h.floatingStyles,className:g,"data-placement":h.placement,onKeyDown:d},l,m&&ue.default.createElement(ce.FloatingArrow,{ref:h.arrowRef,context:h.context,fill:"currentColor",strokeWidth:1,height:8,width:16,style:{transform:"translateY(-1px)"},className:"react-datepicker__triangle"})))}this.props.popperContainer&&(v=r.createElement(this.props.popperContainer,{},v)),u&&!i&&(v=ue.default.createElement(jt,{portalId:u,portalHost:f},v));var D=t.clsx("react-datepicker-wrapper",o);return ue.default.createElement(ue.default.Fragment,null,ue.default.createElement("div",{ref:h.refs.setReference,className:D},c),v)},n}(r.Component),Gt=(zt=Xt,function(e){var t,n="boolean"!=typeof e.hidePopper||e.hidePopper,a=r.useRef(null),o=ce.useFloating(ve({open:!n,whileElementsMounted:ce.autoUpdate,placement:e.popperPlacement,middleware:ge([ce.flip({padding:15}),ce.offset(10),ce.arrow({element:a})],null!==(t=e.popperModifiers)&&void 0!==t?t:[],!0)},e.popperProps)),s=ve(ve({},e),{hidePopper:n,popperProps:ve(ve({},o),{arrowRef:a})});return ue.default.createElement(zt,ve({},s))}),Jt="react-datepicker-ignore-onclickoutside";var Zt="Date input not valid.",er=function(e){function n(o){var s=e.call(this,o)||this;return s.calendar=null,s.input=null,s.getPreSelection=function(){return s.props.openToDate?s.props.openToDate:s.props.selectsEnd&&s.props.startDate?s.props.startDate:s.props.selectsStart&&s.props.endDate?s.props.endDate:Me()},s.modifyHolidays=function(){var e;return null===(e=s.props.holidays)||void 0===e?void 0:e.reduce((function(e,t){var r=new Date(t.date);return _e(r)?ge(ge([],e,!0),[ve(ve({},t),{date:r})],!1):e}),[])},s.calcInitialState=function(){var e,t=s.getPreSelection(),r=dt(s.props),n=ut(s.props),a=r&&O.isBefore(t,xe(r))?r:n&&N.isAfter(t,Le(n))?n:t;return{open:s.props.startOpen||!1,preventFocus:!1,inputValue:null,preSelection:null!==(e=s.props.selectsRange?s.props.startDate:s.props.selected)&&void 0!==e?e:a,highlightDates:ft(s.props.highlightDates),focused:!1,shouldFocusDayInline:!1,isRenderAriaLiveMessage:!1,wasHidden:!1}},s.resetHiddenStatus=function(){s.setState(ve(ve({},s.state),{wasHidden:!1}))},s.setHiddenStatus=function(){s.setState(ve(ve({},s.state),{wasHidden:!0}))},s.setHiddenStateOnVisibilityHidden=function(){"hidden"===document.visibilityState&&s.setHiddenStatus()},s.clearPreventFocusTimeout=function(){s.preventFocusTimeout&&clearTimeout(s.preventFocusTimeout)},s.setFocus=function(){s.input&&s.input.focus&&s.input.focus({preventScroll:!0})},s.setBlur=function(){s.input&&s.input.blur&&s.input.blur(),s.cancelFocusInput()},s.setOpen=function(e,t){void 0===t&&(t=!1),s.setState({open:e,preSelection:e&&s.state.open?s.state.preSelection:s.calcInitialState().preSelection,lastPreSelectChange:rr},(function(){e||s.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&s.setBlur(),s.setState({inputValue:null})}))}))},s.inputOk=function(){return T.isDate(s.state.preSelection)},s.isCalendarOpen=function(){return void 0===s.props.open?s.state.open&&!s.props.disabled&&!s.props.readOnly:s.props.open},s.handleFocus=function(e){var t,r,n=s.state.wasHidden,a=!n||s.state.open;n&&s.resetHiddenStatus(),!s.state.preventFocus&&a&&(null===(r=(t=s.props).onFocus)||void 0===r||r.call(t,e),s.props.preventOpenOnFocus||s.props.readOnly||s.setOpen(!0)),s.setState({focused:!0})},s.sendFocusBackToInput=function(){s.preventFocusTimeout&&s.clearPreventFocusTimeout(),s.setState({preventFocus:!0},(function(){s.preventFocusTimeout=setTimeout((function(){s.setFocus(),s.setState({preventFocus:!1})}))}))},s.cancelFocusInput=function(){clearTimeout(s.inputFocusTimeout),s.inputFocusTimeout=void 0},s.deferFocusInput=function(){s.cancelFocusInput(),s.inputFocusTimeout=setTimeout((function(){return s.setFocus()}),1)},s.handleDropdownFocus=function(){s.cancelFocusInput()},s.handleBlur=function(e){var t,r;(!s.state.open||s.props.withPortal||s.props.showTimeInput)&&(null===(r=(t=s.props).onBlur)||void 0===r||r.call(t,e)),s.setState({focused:!1})},s.handleCalendarClickOutside=function(e){var t,r;s.props.inline||s.setOpen(!1),null===(r=(t=s.props).onClickOutside)||void 0===r||r.call(t,e),s.props.withPortal&&e.preventDefault()},s.handleChange=function(){for(var e,t,r=[],a=0;a<arguments.length;a++)r[a]=arguments[a];var o=r[0];if(!s.props.onChangeRaw||(s.props.onChangeRaw.apply(s,r),o&&"function"==typeof o.isDefaultPrevented&&!o.isDefaultPrevented())){s.setState({inputValue:(null==o?void 0:o.target)instanceof HTMLInputElement?o.target.value:null,lastPreSelectChange:tr});var i=s.props,l=i.dateFormat,c=void 0===l?n.defaultProps.dateFormat:l,p=i.strictParsing,d=void 0===p?n.defaultProps.strictParsing:p,u=i.selectsRange,f=i.startDate,h=i.endDate,m=(null==o?void 0:o.target)instanceof HTMLInputElement?o.target.value:"";if(u){var v=m.split("-",2).map((function(e){return e.trim()})),g=v[0],D=v[1],y=Ce(null!=g?g:"",c,s.props.locale,d),k=Ce(null!=D?D:"",c,s.props.locale,d),w=(null==f?void 0:f.getTime())!==(null==y?void 0:y.getTime()),S=(null==h?void 0:h.getTime())!==(null==k?void 0:k.getTime());if(!w&&!S)return;if(y&&$e(y,s.props))return;if(k&&$e(k,s.props))return;null===(t=(e=s.props).onChange)||void 0===t||t.call(e,[y,k],o)}else{var M=Ce(m,c,s.props.locale,d,s.props.minDate);s.props.showTimeSelectOnly&&s.props.selected&&M&&!Qe(M,s.props.selected)&&(M=V.set(s.props.selected,{hours:b.getHours(M),minutes:C.getMinutes(M),seconds:Y.getSeconds(M)})),!M&&m||s.setSelected(M,o,!0)}}},s.handleSelect=function(e,t,r){if(s.props.shouldCloseOnSelect&&!s.props.showTimeSelect&&s.sendFocusBackToInput(),s.props.onChangeRaw&&s.props.onChangeRaw(t),s.setSelected(e,t,!1,r),s.props.showDateSelect&&s.setState({isRenderAriaLiveMessage:!0}),!s.props.shouldCloseOnSelect||s.props.showTimeSelect)s.setPreSelection(e);else if(!s.props.inline){s.props.selectsRange||s.setOpen(!1);var n=s.props,a=n.startDate,o=n.endDate;!a||o||!s.props.swapRange&&kt(e,a)||s.setOpen(!1)}},s.setSelected=function(e,t,r,n){var a,o,i=e;if(s.props.showYearPicker){if(null!==i&&tt(x.getYear(i),s.props))return}else if(s.props.showMonthYearPicker){if(null!==i&&Xe(i,s.props))return}else if(null!==i&&$e(i,s.props))return;var l=s.props,c=l.onChange,p=l.selectsRange,d=l.startDate,u=l.endDate,f=l.selectsMultiple,h=l.selectedDates,m=l.minTime,v=l.swapRange;if(!qe(s.props.selected,i)||s.props.allowSameDay||p||f)if(null!==i&&(!s.props.selected||r&&(s.props.showTimeSelect||s.props.showTimeSelectOnly||s.props.showTimeInput)||(i=Pe(i,{hour:b.getHours(s.props.selected),minute:C.getMinutes(s.props.selected),second:Y.getSeconds(s.props.selected)})),r||!s.props.showTimeSelect&&!s.props.showTimeSelectOnly||m&&(i=Pe(i,{hour:m.getHours(),minute:m.getMinutes(),second:m.getSeconds()})),s.props.inline||s.setState({preSelection:i}),s.props.focusSelectedMonth||s.setState({monthSelectedIn:n})),p){var g=d&&!u,D=d&&u;!d&&!u?null==c||c([i,null],t):g&&(null===i?null==c||c([null,null],t):kt(i,d)?v?null==c||c([i,d],t):null==c||c([i,null],t):null==c||c([d,i],t)),D&&(null==c||c([i,null],t))}else if(f){if(null!==i)if(null==h?void 0:h.length)if(h.some((function(e){return Qe(e,i)}))){var y=h.filter((function(e){return!Qe(e,i)}));null==c||c(y,t)}else null==c||c(ge(ge([],h,!0),[i],!1),t);else null==c||c([i],t)}else null==c||c(i,t);r||(null===(o=(a=s.props).onSelect)||void 0===o||o.call(a,i,t),s.setState({inputValue:null}))},s.setPreSelection=function(e){var t=T.isDate(s.props.minDate),r=T.isDate(s.props.maxDate),n=!0;if(e){var a=xe(e);if(t&&r)n=Ke(e,s.props.minDate,s.props.maxDate);else if(t){var o=xe(s.props.minDate);n=N.isAfter(e,o)||qe(a,o)}else if(r){var i=Le(s.props.maxDate);n=O.isBefore(e,i)||qe(a,i)}}n&&s.setState({preSelection:e})},s.toggleCalendar=function(){s.setOpen(!s.state.open)},s.handleTimeChange=function(e){var t,r;if(!s.props.selectsRange&&!s.props.selectsMultiple){var n=s.props.selected?s.props.selected:s.getPreSelection(),a=s.props.selected?e:Pe(n,{hour:b.getHours(e),minute:C.getMinutes(e)});s.setState({preSelection:a}),null===(r=(t=s.props).onChange)||void 0===r||r.call(t,a),s.props.shouldCloseOnSelect&&!s.props.showTimeInput&&(s.sendFocusBackToInput(),s.setOpen(!1)),s.props.showTimeInput&&s.setOpen(!0),(s.props.showTimeSelectOnly||s.props.showTimeSelect)&&s.setState({isRenderAriaLiveMessage:!0}),s.setState({inputValue:null})}},s.onInputClick=function(){var e,t;s.props.disabled||s.props.readOnly||s.setOpen(!0),null===(t=(e=s.props).onInputClick)||void 0===t||t.call(e)},s.onInputKeyDown=function(e){var t,r,n,a,o,i;null===(r=(t=s.props).onKeyDown)||void 0===r||r.call(t,e);var l=e.key;if(s.state.open||s.props.inline||s.props.preventOpenOnFocus){if(s.state.open){if(l===De.ArrowDown||l===De.ArrowUp){e.preventDefault();var c=s.props.showTimeSelectOnly?".react-datepicker__time-list-item[tabindex='0']":s.props.showWeekPicker&&s.props.showWeekNumbers?'.react-datepicker__week-number[tabindex="0"]':s.props.showFullMonthYearPicker||s.props.showMonthYearPicker?'.react-datepicker__month-text[tabindex="0"]':'.react-datepicker__day[tabindex="0"]',p=(null===(a=s.calendar)||void 0===a?void 0:a.containerRef.current)instanceof Element&&s.calendar.containerRef.current.querySelector(c);return void(p instanceof HTMLElement&&p.focus({preventScroll:!0}))}var d=Me(s.state.preSelection);l===De.Enter?(e.preventDefault(),s.inputOk()&&s.state.lastPreSelectChange===rr?(s.handleSelect(d,e),!s.props.shouldCloseOnSelect&&s.setPreSelection(d)):s.setOpen(!1)):l===De.Escape?(e.preventDefault(),s.sendFocusBackToInput(),s.setOpen(!1)):l===De.Tab&&s.setOpen(!1),s.inputOk()||null===(i=(o=s.props).onInputError)||void 0===i||i.call(o,{code:1,msg:Zt})}}else l!==De.ArrowDown&&l!==De.ArrowUp&&l!==De.Enter||null===(n=s.onInputClick)||void 0===n||n.call(s)},s.onPortalKeyDown=function(e){e.key===De.Escape&&(e.preventDefault(),s.setState({preventFocus:!0},(function(){s.setOpen(!1),setTimeout((function(){s.setFocus(),s.setState({preventFocus:!1})}))})))},s.onDayKeyDown=function(e){var t,r,n,o,l,c,u=s.props,f=u.minDate,h=u.maxDate,m=u.disabledKeyboardNavigation,v=u.showWeekPicker,g=u.shouldCloseOnSelect,y=u.locale,k=u.calendarStartDay,w=u.adjustDateOnChange,S=u.inline;if(null===(r=(t=s.props).onKeyDown)||void 0===r||r.call(t,e),!m){var b=e.key,M=e.shiftKey,C=Me(s.state.preSelection),E=function(e,t){var r=t;switch(e){case De.ArrowRight:r=v?p.addWeeks(t,1):a.addDays(t,1);break;case De.ArrowLeft:r=v?se.subWeeks(t,1):ne.subDays(t,1);break;case De.ArrowUp:r=se.subWeeks(t,1);break;case De.ArrowDown:r=p.addWeeks(t,1);break;case De.PageUp:r=M?ie.subYears(t,1):ae.subMonths(t,1);break;case De.PageDown:r=M?d.addYears(t,1):i.addMonths(t,1);break;case De.Home:r=Ne(t,y,k);break;case De.End:r=function(e){return D.endOfWeek(e)}(t)}return r};if(b===De.Enter)return e.preventDefault(),s.handleSelect(C,e),void(!g&&s.setPreSelection(C));if(b===De.Escape)return e.preventDefault(),s.setOpen(!1),void(s.inputOk()||null===(o=(n=s.props).onInputError)||void 0===o||o.call(n,{code:1,msg:Zt}));var Y=null;switch(b){case De.ArrowLeft:case De.ArrowRight:case De.ArrowUp:case De.ArrowDown:case De.PageUp:case De.PageDown:case De.Home:case De.End:Y=function(e,t){for(var r=e,n=!1,a=0,o=E(e,t);!n;){if(a>=40){o=t;break}f&&o<f&&(r=De.ArrowRight,o=$e(f,s.props)?E(r,o):f),h&&o>h&&(r=De.ArrowLeft,o=$e(h,s.props)?E(r,o):h),$e(o,s.props)?(r!==De.PageUp&&r!==De.Home||(r=De.ArrowRight),r!==De.PageDown&&r!==De.End||(r=De.ArrowLeft),o=E(r,o)):n=!0,a++}return o}(b,C)}if(Y){if(e.preventDefault(),s.setState({lastPreSelectChange:rr}),w&&s.setSelected(Y),s.setPreSelection(Y),S){var P=_.getMonth(C),N=_.getMonth(Y),O=x.getYear(C),T=x.getYear(Y);P!==N||O!==T?s.setState({shouldFocusDayInline:!0}):s.setState({shouldFocusDayInline:!1})}}else null===(c=(l=s.props).onInputError)||void 0===c||c.call(l,{code:1,msg:Zt})}},s.onPopperKeyDown=function(e){e.key===De.Escape&&(e.preventDefault(),s.sendFocusBackToInput())},s.onClearClick=function(e){e&&e.preventDefault&&e.preventDefault(),s.sendFocusBackToInput();var t=s.props,r=t.selectsRange,n=t.onChange;r?null==n||n([null,null],e):null==n||n(null,e),s.setState({inputValue:null})},s.clear=function(){s.onClearClick()},s.onScroll=function(e){"boolean"==typeof s.props.closeOnScroll&&s.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||s.setOpen(!1):"function"==typeof s.props.closeOnScroll&&s.props.closeOnScroll(e)&&s.setOpen(!1)},s.renderCalendar=function(){var e,t;return s.props.inline||s.isCalendarOpen()?ue.default.createElement(Bt,ve({showMonthYearDropdown:void 0,ref:function(e){s.calendar=e}},s.props,s.state,{setOpen:s.setOpen,dateFormat:null!==(e=s.props.dateFormatCalendar)&&void 0!==e?e:n.defaultProps.dateFormatCalendar,onSelect:s.handleSelect,onClickOutside:s.handleCalendarClickOutside,holidays:ht(s.modifyHolidays()),outsideClickIgnoreClass:Jt,onDropdownFocus:s.handleDropdownFocus,onTimeChange:s.handleTimeChange,className:s.props.calendarClassName,container:s.props.calendarContainer,handleOnKeyDown:s.props.onKeyDown,handleOnDayKeyDown:s.onDayKeyDown,setPreSelection:s.setPreSelection,dropdownMode:null!==(t=s.props.dropdownMode)&&void 0!==t?t:n.defaultProps.dropdownMode}),s.props.children):null},s.renderAriaLiveRegion=function(){var e,t=s.props,r=t.dateFormat,a=void 0===r?n.defaultProps.dateFormat:r,o=t.locale,i=s.props.showTimeInput||s.props.showTimeSelect?"PPPPp":"PPPP";return e=s.props.selectsRange?"Selected start date: ".concat(Ye(s.props.startDate,{dateFormat:i,locale:o}),". ").concat(s.props.endDate?"End date: "+Ye(s.props.endDate,{dateFormat:i,locale:o}):""):s.props.showTimeSelectOnly?"Selected time: ".concat(Ye(s.props.selected,{dateFormat:a,locale:o})):s.props.showYearPicker?"Selected year: ".concat(Ye(s.props.selected,{dateFormat:"yyyy",locale:o})):s.props.showMonthYearPicker?"Selected month: ".concat(Ye(s.props.selected,{dateFormat:"MMMM yyyy",locale:o})):s.props.showQuarterYearPicker?"Selected quarter: ".concat(Ye(s.props.selected,{dateFormat:"yyyy, QQQ",locale:o})):"Selected date: ".concat(Ye(s.props.selected,{dateFormat:i,locale:o})),ue.default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},e)},s.renderDateInput=function(){var e,a,o,i=t.clsx(s.props.className,((e={})[Jt]=s.state.open,e)),l=s.props.customInput||ue.default.createElement("input",{type:"text"}),c=s.props.customInputRef||"ref",p=s.props,d=p.dateFormat,u=void 0===d?n.defaultProps.dateFormat:d,f=p.locale,h="string"==typeof s.props.value?s.props.value:"string"==typeof s.state.inputValue?s.state.inputValue:s.props.selectsRange?function(e,t,r){if(!e)return"";var n=Ye(e,r),a=t?Ye(t,r):"";return"".concat(n," - ").concat(a)}(s.props.startDate,s.props.endDate,{dateFormat:u,locale:f}):s.props.selectsMultiple?function(e,t){if(!(null==e?void 0:e.length))return"";var r=e[0]?Ye(e[0],t):"";if(1===e.length)return r;if(2===e.length&&e[1]){var n=Ye(e[1],t);return"".concat(r,", ").concat(n)}var a=e.length-1;return"".concat(r," (+").concat(a,")")}(null!==(o=s.props.selectedDates)&&void 0!==o?o:[],{dateFormat:u,locale:f}):Ye(s.props.selected,{dateFormat:u,locale:f});return r.cloneElement(l,((a={})[c]=function(e){s.input=e},a.value=h,a.onBlur=s.handleBlur,a.onChange=s.handleChange,a.onClick=s.onInputClick,a.onFocus=s.handleFocus,a.onKeyDown=s.onInputKeyDown,a.id=s.props.id,a.name=s.props.name,a.form=s.props.form,a.autoFocus=s.props.autoFocus,a.placeholder=s.props.placeholderText,a.disabled=s.props.disabled,a.autoComplete=s.props.autoComplete,a.className=t.clsx(l.props.className,i),a.title=s.props.title,a.readOnly=s.props.readOnly,a.required=s.props.required,a.tabIndex=s.props.tabIndex,a["aria-describedby"]=s.props.ariaDescribedBy,a["aria-invalid"]=s.props.ariaInvalid,a["aria-labelledby"]=s.props.ariaLabelledBy,a["aria-required"]=s.props.ariaRequired,a))},s.renderClearButton=function(){var e=s.props,r=e.isClearable,n=e.disabled,a=e.selected,o=e.startDate,i=e.endDate,l=e.clearButtonTitle,c=e.clearButtonClassName,p=void 0===c?"":c,d=e.ariaLabelClose,u=void 0===d?"Close":d,f=e.selectedDates;return r&&(null!=a||null!=o||null!=i||(null==f?void 0:f.length))?ue.default.createElement("button",{type:"button",className:t.clsx("react-datepicker__close-icon",p,{"react-datepicker__close-icon--disabled":n}),disabled:n,"aria-label":u,onClick:s.onClearClick,title:l,tabIndex:-1}):null},s.state=s.calcInitialState(),s.preventFocusTimeout=void 0,s}return me(n,e),Object.defineProperty(n,"defaultProps",{get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",preventOpenOnFocus:!1,monthsShown:1,readOnly:!1,withPortal:!1,selectsDisabledDaysInRange:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,showWeekPicker:!1,strictParsing:!1,swapRange:!1,timeIntervals:30,timeCaption:"Time",previousMonthAriaLabel:"Previous Month",previousMonthButtonLabel:"Previous Month",nextMonthAriaLabel:"Next Month",nextMonthButtonLabel:"Next Month",previousYearAriaLabel:"Previous Year",previousYearButtonLabel:"Previous Year",nextYearAriaLabel:"Next Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:Se,focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null,calendarStartDay:void 0,toggleCalendarOnIconClick:!1,usePointerEvent:!1}},enumerable:!1,configurable:!0}),n.prototype.componentDidMount=function(){window.addEventListener("scroll",this.onScroll,!0),document.addEventListener("visibilitychange",this.setHiddenStateOnVisibilityHidden)},n.prototype.componentDidUpdate=function(e,t){var r,n,a,o,s,i;e.inline&&(s=e.selected,i=this.props.selected,s&&i?_.getMonth(s)!==_.getMonth(i)||x.getYear(s)!==x.getYear(i):s!==i)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:ft(this.props.highlightDates)}),t.focused||qe(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&(null===(n=(r=this.props).onCalendarOpen)||void 0===n||n.call(r)),!0===t.open&&!1===this.state.open&&(null===(o=(a=this.props).onCalendarClose)||void 0===o||o.call(a)))},n.prototype.componentWillUnmount=function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0),document.removeEventListener("visibilitychange",this.setHiddenStateOnVisibilityHidden)},n.prototype.renderInputContainer=function(){var e=this.props,r=e.showIcon,n=e.icon,a=e.calendarIconClassname,o=e.calendarIconClassName,s=e.toggleCalendarOnIconClick,i=this.state.open;return a&&console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."),ue.default.createElement("div",{className:"react-datepicker__input-container".concat(r?" react-datepicker__view-calendar-icon":"")},r&&ue.default.createElement(Vt,ve({icon:n,className:t.clsx(o,!o&&a,i&&"react-datepicker-ignore-onclickoutside")},s?{onClick:this.toggleCalendar}:null)),this.state.isRenderAriaLiveMessage&&this.renderAriaLiveRegion(),this.renderDateInput(),this.renderClearButton())},n.prototype.render=function(){var e=this.renderCalendar();if(this.props.inline)return e;if(this.props.withPortal){var t=this.state.open?ue.default.createElement($t,{enableTabLoop:this.props.enableTabLoop},ue.default.createElement("div",{className:"react-datepicker__portal",tabIndex:-1,onKeyDown:this.onPortalKeyDown},e)):null;return this.state.open&&this.props.portalId&&(t=ue.default.createElement(jt,ve({portalId:this.props.portalId},this.props),t)),ue.default.createElement("div",null,this.renderInputContainer(),t)}return ue.default.createElement(Gt,ve({},this.props,{className:this.props.popperClassName,hidePopper:!this.isCalendarOpen(),targetComponent:this.renderInputContainer(),popperComponent:e,popperOnKeyDown:this.onPopperKeyDown,showArrow:this.props.showPopperArrow}))},n}(r.Component),tr="input",rr="navigate";e.CalendarContainer=ye,e.default=er,e.getDefaultLocale=Be,e.registerLocale=function(e,t){var r=we();r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){we().__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));


/***/ }),

/***/ 46075:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(31543)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _reactSwipe) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _reactSwipe2.default;
});

/***/ }),

/***/ 31543:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2784), __webpack_require__(13980)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var supportsCaptureOption = false;
  function setHasSupportToCaptureOption(hasSupport) {
    supportsCaptureOption = hasSupport;
  }

  try {
    addEventListener('test', null, Object.defineProperty({}, 'capture', { get: function get() {
        setHasSupportToCaptureOption(true);
      } }));
  } catch (e) {} // eslint-disable-line no-empty

  function getSafeEventHandlerOpts() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };

    return supportsCaptureOption ? options : options.capture;
  }

  /**
   * [getPosition returns a position element that works for mouse or touch events]
   * @param  {[Event]} event [the received event]
   * @return {[Object]}      [x and y coords]
   */
  function getPosition(event) {
    if ('touches' in event) {
      var _event$touches$ = event.touches[0],
          pageX = _event$touches$.pageX,
          pageY = _event$touches$.pageY;

      return { x: pageX, y: pageY };
    }

    var screenX = event.screenX,
        screenY = event.screenY;

    return { x: screenX, y: screenY };
  }

  var ReactSwipe = function (_Component) {
    _inherits(ReactSwipe, _Component);

    function ReactSwipe() {
      var _ref;

      _classCallCheck(this, ReactSwipe);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));

      _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
      _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
      _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);

      _this._onMouseDown = _this._onMouseDown.bind(_this);
      _this._onMouseMove = _this._onMouseMove.bind(_this);
      _this._onMouseUp = _this._onMouseUp.bind(_this);

      _this._setSwiperRef = _this._setSwiperRef.bind(_this);
      return _this;
    }

    _createClass(ReactSwipe, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.swiper) {
          this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
            capture: true,
            passive: false
          }));
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.swiper) {
          this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
            capture: true,
            passive: false
          }));
        }
      }
    }, {
      key: '_onMouseDown',
      value: function _onMouseDown(event) {
        if (!this.props.allowMouseEvents) {
          return;
        }

        this.mouseDown = true;

        document.addEventListener('mouseup', this._onMouseUp);
        document.addEventListener('mousemove', this._onMouseMove);

        this._handleSwipeStart(event);
      }
    }, {
      key: '_onMouseMove',
      value: function _onMouseMove(event) {
        if (!this.mouseDown) {
          return;
        }

        this._handleSwipeMove(event);
      }
    }, {
      key: '_onMouseUp',
      value: function _onMouseUp(event) {
        this.mouseDown = false;

        document.removeEventListener('mouseup', this._onMouseUp);
        document.removeEventListener('mousemove', this._onMouseMove);

        this._handleSwipeEnd(event);
      }
    }, {
      key: '_handleSwipeStart',
      value: function _handleSwipeStart(event) {
        var _getPosition = getPosition(event),
            x = _getPosition.x,
            y = _getPosition.y;

        this.moveStart = { x: x, y: y };
        this.props.onSwipeStart(event);
      }
    }, {
      key: '_handleSwipeMove',
      value: function _handleSwipeMove(event) {
        if (!this.moveStart) {
          return;
        }

        var _getPosition2 = getPosition(event),
            x = _getPosition2.x,
            y = _getPosition2.y;

        var deltaX = x - this.moveStart.x;
        var deltaY = y - this.moveStart.y;
        this.moving = true;

        // handling the responsability of cancelling the scroll to
        // the component handling the event
        var shouldPreventDefault = this.props.onSwipeMove({
          x: deltaX,
          y: deltaY
        }, event);

        if (shouldPreventDefault && event.cancelable) {
          event.preventDefault();
        }

        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
      }
    }, {
      key: '_handleSwipeEnd',
      value: function _handleSwipeEnd(event) {
        this.props.onSwipeEnd(event);

        var tolerance = this.props.tolerance;


        if (this.moving && this.movePosition) {
          if (this.movePosition.deltaX < -tolerance) {
            this.props.onSwipeLeft(1, event);
          } else if (this.movePosition.deltaX > tolerance) {
            this.props.onSwipeRight(1, event);
          }
          if (this.movePosition.deltaY < -tolerance) {
            this.props.onSwipeUp(1, event);
          } else if (this.movePosition.deltaY > tolerance) {
            this.props.onSwipeDown(1, event);
          }
        }

        this.moveStart = null;
        this.moving = false;
        this.movePosition = null;
      }
    }, {
      key: '_setSwiperRef',
      value: function _setSwiperRef(node) {
        this.swiper = node;
        this.props.innerRef(node);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            tagName = _props.tagName,
            className = _props.className,
            style = _props.style,
            children = _props.children,
            allowMouseEvents = _props.allowMouseEvents,
            onSwipeUp = _props.onSwipeUp,
            onSwipeDown = _props.onSwipeDown,
            onSwipeLeft = _props.onSwipeLeft,
            onSwipeRight = _props.onSwipeRight,
            onSwipeStart = _props.onSwipeStart,
            onSwipeMove = _props.onSwipeMove,
            onSwipeEnd = _props.onSwipeEnd,
            innerRef = _props.innerRef,
            tolerance = _props.tolerance,
            props = _objectWithoutProperties(_props, ['tagName', 'className', 'style', 'children', 'allowMouseEvents', 'onSwipeUp', 'onSwipeDown', 'onSwipeLeft', 'onSwipeRight', 'onSwipeStart', 'onSwipeMove', 'onSwipeEnd', 'innerRef', 'tolerance']);

        return _react2.default.createElement(
          this.props.tagName,
          _extends({
            ref: this._setSwiperRef,
            onMouseDown: this._onMouseDown,
            onTouchStart: this._handleSwipeStart,
            onTouchEnd: this._handleSwipeEnd,
            className: className,
            style: style
          }, props),
          children
        );
      }
    }]);

    return ReactSwipe;
  }(_react.Component);

  ReactSwipe.displayName = 'ReactSwipe';
  ReactSwipe.propTypes = {
    tagName: _propTypes2.default.string,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    children: _propTypes2.default.node,
    allowMouseEvents: _propTypes2.default.bool,
    onSwipeUp: _propTypes2.default.func,
    onSwipeDown: _propTypes2.default.func,
    onSwipeLeft: _propTypes2.default.func,
    onSwipeRight: _propTypes2.default.func,
    onSwipeStart: _propTypes2.default.func,
    onSwipeMove: _propTypes2.default.func,
    onSwipeEnd: _propTypes2.default.func,
    innerRef: _propTypes2.default.func,
    tolerance: _propTypes2.default.number.isRequired
  };
  ReactSwipe.defaultProps = {
    tagName: 'div',
    allowMouseEvents: false,
    onSwipeUp: function onSwipeUp() {},
    onSwipeDown: function onSwipeDown() {},
    onSwipeLeft: function onSwipeLeft() {},
    onSwipeRight: function onSwipeRight() {},
    onSwipeStart: function onSwipeStart() {},
    onSwipeMove: function onSwipeMove() {},
    onSwipeEnd: function onSwipeEnd() {},
    innerRef: function innerRef() {},

    tolerance: 0
  };
  exports.default = ReactSwipe;
});

/***/ }),

/***/ 78435:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 31496:
/***/ (function(module) {

"use strict";


module.exports = function equal(a, b) {
  if (a === b) return true;

  var arrA = Array.isArray(a)
    , arrB = Array.isArray(b)
    , i;

  if (arrA && arrB) {
    if (a.length != b.length) return false;
    for (i = 0; i < a.length; i++)
      if (!equal(a[i], b[i])) return false;
    return true;
  }

  if (arrA != arrB) return false;

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    var keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA && dateB) return a.getTime() == b.getTime();
    if (dateA != dateB) return false;

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA && regexpB) return a.toString() == b.toString();
    if (regexpA != regexpB) return false;

    for (i = 0; i < keys.length; i++)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = 0; i < keys.length; i++)
      if(!equal(a[keys[i]], b[keys[i]])) return false;

    return true;
  }

  return false;
};


/***/ }),

/***/ 87665:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(87201);
var invariant = __webpack_require__(14983);
var ReactPropTypesSecret = __webpack_require__(56396);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 23406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, isValidElement, REACT_ELEMENT_TYPE; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(87665)();
}


/***/ }),

/***/ 56396:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 98738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(417);
} else {}


/***/ }),

/***/ 417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React=_interopDefault(__webpack_require__(2784)),reactDom=__webpack_require__(28316);function _defaults2(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r)}return e}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_defaults2(e.prototype.constructor=e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation"}throw l.framesToPop=1,l}},invariant_1=invariant;function setInputSelection(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else{var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select()}}function getInputSelection(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else{var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length))}return{start:t,end:n,length:n-t}}var defaultFormatChars={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar="_";function parseMask(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar),null==n&&(n=defaultFormatChars),!e||"string"!=typeof e)return{maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1)}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter(e,t){return-1!==e.permanents.indexOf(t)}function isAllowedCharacter(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return!1;if(isPermanentCharacter(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty(n,e){return e.split("").every(function(e,t){return isPermanentCharacter(n,t)||!isAllowedCharacter(n,t,e)})}function getFilledLength(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter(e,r)&&isAllowedCharacter(e,r,o)){i=r+1;break}}return i}function isFilled(e,t){return getFilledLength(e,t)===e.mask.length}function formatValue(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter(e,t.length);)t+=a[t.length];return t}if(t)return insertString(e,formatValue(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter(e,r)?t+=a[r]:t+=n;return t}function clearRange(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue(n,e)}function insertString(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled(r,o);return!u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter(r,n)&&t===u)return!0;if(++s>=l.length)return!1}var t,n,a,i;return!isAllowedCharacter(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter(a,t=i)&&n!==r[t];)if(++i>=r.length)return!1;var t,n;return(isAllowedCharacter(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter(e,n))return n;return null}function getRightEditablePosition(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter(e,a))return a;return null}function getStringValue(e){return e||0===e?e+"":""}function processChange(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition(e,n.start):getLeftEditablePosition(e,n.start);l=clearRange(e,l,f,h)}return l=insertString(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition(e,f)),u||(u=null),{value:l=formatValue(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction(e){return"function"==typeof e}function getRequestAnimationFrame(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer(e){return(!!getCancelAnimationFrame()?getRequestAnimationFrame():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer(e){(getCancelAnimationFrame()||clearTimeout)(e)}var InputElement=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer(f.saveSelectionLoop)},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop()},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null)},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=reactDom.findDOMNode(_assertThisInitialized(_assertThisInitialized(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e)},f.setCursorToEnd=function(){var e=getFilledLength(f.maskOptions,f.value),t=getRightEditablePosition(f.maskOptions,e);null!==t&&f.setCursorPosition(t)},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection(a,e,t),null!==f.selectionDeferId&&cancelDefer(f.selectionDeferId),f.selectionDeferId=defer(function(){f.selectionDeferId=null,setInputSelection(a,e,t)}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)})},f.getSelection=function(){return getInputSelection(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e)},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return{mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return!0}catch(r){}return!f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized(_assertThisInitialized(f)).beforePasteState,n=_assertThisInitialized(_assertThisInitialized(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection}f.setInputValue(c),isFunction(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end)},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else{var r=formatValue(f.maskOptions,i),o=formatValue(f.maskOptions,r),s=getFilledLength(f.maskOptions,o),l=getRightEditablePosition(f.maskOptions,s),u={start:l,end:l};if(isFunction(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end)}f.runSaveSelectionLoop()}isFunction(f.props.onFocus)&&f.props.onFocus(e)},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty(f.maskOptions,f.value)){var a="";if(isFunction(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction(f.props.onChange)&&f.props.onChange(e)}isFunction(f.props.onBlur)&&f.props.onBlur(e)},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd()}};document.addEventListener("mouseup",r)}isFunction(f.props.onMouseDown)&&f.props.onMouseDown(e)},f.onPaste=function(e){isFunction(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""))},f.handleRef=function(e){null==f.props.children&&isFunction(f.props.inputRef)&&f.props.inputRef(e)};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue(f.maskOptions,l),isFunction(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value}return f.value=l,f}_inheritsLoose(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value))},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue(this.maskOptions,c)),f){var p=getFilledLength(this.maskOptions,c);(null===h||p<h)&&(h=isFilled(this.maskOptions,c)?p:getRightEditablePosition(this.maskOptions,p))}!this.maskOptions.mask||!isEmpty(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end)}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate())},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer(this.selectionDeferId),this.stopSaveSelectionLoop()},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction(n)||invariant_1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1)}else t=React.createElement("input",_extends({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React.cloneElement(t,o)},e}(React.Component);module.exports=InputElement;


/***/ }),

/***/ 66866:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};exports.typeOf=v;


/***/ }),

/***/ 48570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(66866);
} else {}


/***/ }),

/***/ 46847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 42901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28316);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(10742);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(66941);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(6259);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(46847);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (false) {}

exports["default"] = Modal;

/***/ }),

/***/ 10742:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(77194);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(90026);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(66941);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(95853);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(6259);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(66638);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(26736);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports["default"] = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ 66941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(45982);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(6259);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (false) { var check; }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),

/***/ 26736:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(66638);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),

/***/ 95853:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (false) { var _x, x, buffer, classes; }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ 77194:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(93970);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (false) {}
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ 66638:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports["default"] = portalOpenInstances;

/***/ }),

/***/ 6259:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(85978);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports["default"] = SafeHTMLElement;

/***/ }),

/***/ 90026:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = scopeTab;

var _tabbable = __webpack_require__(93970);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),

/***/ 93970:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

var tabbableNode = /input|select|textarea|button|object|iframe/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ 37149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _Modal = __webpack_require__(42901);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ 60409:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReactMultiEmail = void 0;
const React = __importStar(__webpack_require__(2784));
const isEmail_1 = __webpack_require__(52607);
function ReactMultiEmail(props) {
    const { id, style, getLabel, className = '', noClass, placeholder, autoFocus, enable, onDisabled, validateEmail, onChange, onChangeInput, onFocus, onBlur, onKeyDown, onKeyUp, spinner, delimiter = '[ ,;]', initialInputValue = '', } = props;
    const emailInputRef = React.useRef(null);
    const [focused, setFocused] = React.useState(false);
    const [emails, setEmails] = React.useState([]);
    const [inputValue, setInputValue] = React.useState(initialInputValue);
    const [spinning, setSpinning] = React.useState(false);
    const findEmailAddress = React.useCallback((value, isEnter) => __awaiter(this, void 0, void 0, function* () {
        const validEmails = [];
        let inputValue = '';
        const re = new RegExp(delimiter, 'g');
        const isEmail = validateEmail || isEmail_1.isEmail;
        const addEmails = (email) => {
            for (let i = 0, l = emails.length; i < l; i++) {
                if (emails[i] === email) {
                    return false;
                }
            }
            validEmails.push(email);
            return true;
        };
        if (value !== '') {
            if (re.test(value)) {
                const splitData = value.split(re).filter(n => {
                    return n !== '' && n !== undefined && n !== null;
                });
                const setArr = new Set(splitData);
                const arr = [...setArr];
                do {
                    const validateResult = isEmail('' + arr[0]);
                    if (typeof validateResult === 'boolean') {
                        if (validateResult) {
                            addEmails('' + arr.shift());
                        }
                        else {
                            if (arr.length === 1) {
                                inputValue = '' + arr.shift();
                            }
                            else {
                                arr.shift();
                            }
                        }
                    }
                    else {
                        // handle promise
                        setSpinning(true);
                        if ((yield (validateEmail === null || validateEmail === void 0 ? void 0 : validateEmail(value))) === true) {
                            addEmails('' + arr.shift());
                            setSpinning(false);
                        }
                        else {
                            if (arr.length === 1) {
                                inputValue = '' + arr.shift();
                            }
                            else {
                                arr.shift();
                            }
                        }
                    }
                } while (arr.length);
            }
            else {
                if (enable && !enable({ emailCnt: emails.length })) {
                    onDisabled === null || onDisabled === void 0 ? void 0 : onDisabled();
                    return;
                }
                if (isEnter) {
                    const validateResult = isEmail(value);
                    if (typeof validateResult === 'boolean') {
                        if (validateResult) {
                            addEmails(value);
                        }
                        else {
                            inputValue = value;
                        }
                    }
                    else {
                        // handle promise
                        setSpinning(true);
                        if ((yield (validateEmail === null || validateEmail === void 0 ? void 0 : validateEmail(value))) === true) {
                            addEmails(value);
                            setSpinning(false);
                        }
                        else {
                            inputValue = value;
                        }
                    }
                }
                else {
                    inputValue = value;
                }
            }
        }
        setEmails([...emails, ...validEmails]);
        setInputValue(inputValue);
        if (validEmails.length) {
            onChange === null || onChange === void 0 ? void 0 : onChange([...emails, ...validEmails]);
        }
        if (inputValue !== inputValue) {
            onChangeInput === null || onChangeInput === void 0 ? void 0 : onChangeInput(inputValue);
        }
    }), [delimiter, emails, enable, onChange, onChangeInput, onDisabled, validateEmail]);
    const onChangeInputValue = React.useCallback((value) => __awaiter(this, void 0, void 0, function* () {
        yield findEmailAddress(value);
    }), [findEmailAddress, onChangeInput]);
    const removeEmail = React.useCallback((index, isDisabled) => {
        if (isDisabled) {
            return;
        }
        const _emails = [...emails.slice(0, index), ...emails.slice(index + 1)];
        setEmails(_emails);
        onChange === null || onChange === void 0 ? void 0 : onChange(_emails);
    }, [emails, onChange]);
    const handleOnKeydown = React.useCallback((e) => {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
        switch (e.key) {
            case 'Enter':
                e.preventDefault();
                break;
            case 'Backspace':
                if (!e.currentTarget.value) {
                    removeEmail(emails.length - 1, false);
                }
                break;
            default:
        }
    }, [emails.length, onKeyDown, removeEmail]);
    const handleOnKeyup = React.useCallback((e) => __awaiter(this, void 0, void 0, function* () {
        onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(e);
        switch (e.key) {
            case 'Enter':
            case 'Backspace':
                yield findEmailAddress(e.currentTarget.value, true);
                break;
            default:
        }
    }), [findEmailAddress, onKeyUp]);
    const handleOnChange = React.useCallback((e) => __awaiter(this, void 0, void 0, function* () { return yield onChangeInputValue(e.currentTarget.value); }), [onChangeInputValue]);
    const handleOnBlur = React.useCallback((e) => __awaiter(this, void 0, void 0, function* () {
        setFocused(false);
        yield findEmailAddress(e.currentTarget.value, true);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    }), [findEmailAddress, onBlur]);
    const handleOnFocus = React.useCallback(() => {
        setFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    }, [onFocus]);
    React.useEffect(() => {
        var _a;
        setEmails((_a = props.emails) !== null && _a !== void 0 ? _a : []);
    }, [props.emails]);
    return (React.createElement("div", { className: `${className} ${noClass ? '' : 'react-multi-email'} ${focused ? 'focused' : ''} ${inputValue === '' && emails.length === 0 ? 'empty' : ''}`, style: style, onClick: () => { var _a; return (_a = emailInputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); } },
        spinning && (spinner === null || spinner === void 0 ? void 0 : spinner()),
        placeholder ? React.createElement("span", { "data-placeholder": true }, placeholder) : null,
        React.createElement("div", { className: 'data-labels', style: { opacity: spinning ? 0.45 : 1.0, display: 'contents', flexWrap: 'inherit' } }, emails.map((email, index) => getLabel(email, index, removeEmail))),
        React.createElement("input", { id: id, style: { opacity: spinning ? 0.45 : 1.0 }, ref: emailInputRef, type: 'text', value: inputValue, onFocus: handleOnFocus, onBlur: handleOnBlur, onChange: handleOnChange, onKeyDown: handleOnKeydown, onKeyUp: handleOnKeyup, autoFocus: autoFocus })));
}
exports.ReactMultiEmail = ReactMultiEmail;


/***/ }),

/***/ 35293:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(52607), exports);
__exportStar(__webpack_require__(60409), exports);


/***/ }),

/***/ 52607:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// forked from https://github.com/chriso/validator.js
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isEmail = void 0;
const defaultFqdnOptions = {
    requireTld: true,
    allowUnderscores: false,
    allowTrailingDot: false,
};
const defaultEmailOptions = {
    allowDisplayName: false,
    requireDisplayName: false,
    allowUtf8LocalPart: true,
    requireTld: true,
};
const displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
const emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
const quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
const emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
const quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
    let min = 0;
    let max;
    const len = encodeURI(str).split(/%..|./).length - 1;
    if (options) {
        min = Number(options.min) || 0;
        max = Number(options.max);
    }
    return len >= min && (typeof max === 'undefined' || len <= max);
}
function isFQDN(str, options) {
    options = Object.assign(Object.assign({}, defaultFqdnOptions), options);
    /* Remove the optional trailing dot before checking validity */
    if (options.allowTrailingDot && str[str.length - 1] === '.') {
        str = str.substring(0, str.length - 1);
    }
    const parts = str.split('.');
    if (options.requireTld) {
        const tld = '' + parts.pop();
        if (!parts.length ||
            !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
            return false;
        }
        // disallow spaces
        if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
            return false;
        }
    }
    for (let part, i = 0; i < parts.length; i++) {
        part = parts[i];
        if (options.allowUnderscores) {
            part = part.replace(/_/g, '');
        }
        if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
            return false;
        }
        // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) {
            return false;
        }
        if (part[0] === '-' || part[part.length - 1] === '-') {
            return false;
        }
    }
    return true;
}
function isEmail(str, options) {
    options = Object.assign(Object.assign({}, defaultEmailOptions), options);
    if (options.requireDisplayName || options.allowDisplayName) {
        const displayEmail = str.match(displayName);
        if (displayEmail) {
            str = displayEmail[1];
        }
        else if (options.requireDisplayName) {
            return false;
        }
    }
    const parts = str.split('@');
    const domain = '' + parts.pop();
    const lowerDomain = domain.toLowerCase();
    let user = parts.join('@');
    if (lowerDomain === 'gmail.com' || lowerDomain === 'googlemail.com') {
        user = user.replace(/\./g, '').toLowerCase();
    }
    if (!isByteLength(user, { max: 64 }) || !isByteLength(domain, { max: 254 })) {
        return false;
    }
    if (!isFQDN(domain, { requireTld: options.requireTld })) {
        return false;
    }
    if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allowUtf8LocalPart
            ? quotedEmailUserUtf8.test(user)
            : quotedEmailUser.test(user);
    }
    const pattern = options.allowUtf8LocalPart
        ? emailUserUtf8Part
        : emailUserPart;
    const userParts = user.split('.');
    for (let i = 0; i < userParts.length; i++) {
        if (!pattern.test(userParts[i])) {
            return false;
        }
    }
    return true;
}
exports.isEmail = isEmail;


/***/ }),

/***/ 16403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var Player_exports = {};
__export(Player_exports, {
  default: () => Player
});
module.exports = __toCommonJS(Player_exports);
var import_react = __toESM(__webpack_require__(2784));
var import_react_fast_compare = __toESM(__webpack_require__(78435));
var import_props = __webpack_require__(29090);
var import_utils = __webpack_require__(77838);
const SEEK_ON_PLAY_EXPIRY = 5e3;
class Player extends import_react.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "mounted", false);
    __publicField(this, "isReady", false);
    __publicField(this, "isPlaying", false);
    // Track playing state internally to prevent bugs
    __publicField(this, "isLoading", true);
    // Use isLoading to prevent onPause when switching URL
    __publicField(this, "loadOnReady", null);
    __publicField(this, "startOnPlay", true);
    __publicField(this, "seekOnPlay", null);
    __publicField(this, "onDurationCalled", false);
    __publicField(this, "handlePlayerMount", (player) => {
      if (this.player) {
        this.progress();
        return;
      }
      this.player = player;
      this.player.load(this.props.url);
      this.progress();
    });
    __publicField(this, "getInternalPlayer", (key) => {
      if (!this.player)
        return null;
      return this.player[key];
    });
    __publicField(this, "progress", () => {
      if (this.props.url && this.player && this.isReady) {
        const playedSeconds = this.getCurrentTime() || 0;
        const loadedSeconds = this.getSecondsLoaded();
        const duration = this.getDuration();
        if (duration) {
          const progress = {
            playedSeconds,
            played: playedSeconds / duration
          };
          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          }
          if (progress.playedSeconds !== this.prevPlayed || progress.loadedSeconds !== this.prevLoaded) {
            this.props.onProgress(progress);
          }
          this.prevPlayed = progress.playedSeconds;
          this.prevLoaded = progress.loadedSeconds;
        }
      }
      this.progressTimeout = setTimeout(this.progress, this.props.progressFrequency || this.props.progressInterval);
    });
    __publicField(this, "handleReady", () => {
      if (!this.mounted)
        return;
      this.isReady = true;
      this.isLoading = false;
      const { onReady, playing, volume, muted } = this.props;
      onReady();
      if (!muted && volume !== null) {
        this.player.setVolume(volume);
      }
      if (this.loadOnReady) {
        this.player.load(this.loadOnReady, true);
        this.loadOnReady = null;
      } else if (playing) {
        this.player.play();
      }
      this.handleDurationCheck();
    });
    __publicField(this, "handlePlay", () => {
      this.isPlaying = true;
      this.isLoading = false;
      const { onStart, onPlay, playbackRate } = this.props;
      if (this.startOnPlay) {
        if (this.player.setPlaybackRate && playbackRate !== 1) {
          this.player.setPlaybackRate(playbackRate);
        }
        onStart();
        this.startOnPlay = false;
      }
      onPlay();
      if (this.seekOnPlay) {
        this.seekTo(this.seekOnPlay);
        this.seekOnPlay = null;
      }
      this.handleDurationCheck();
    });
    __publicField(this, "handlePause", (e) => {
      this.isPlaying = false;
      if (!this.isLoading) {
        this.props.onPause(e);
      }
    });
    __publicField(this, "handleEnded", () => {
      const { activePlayer, loop, onEnded } = this.props;
      if (activePlayer.loopOnEnded && loop) {
        this.seekTo(0);
      }
      if (!loop) {
        this.isPlaying = false;
        onEnded();
      }
    });
    __publicField(this, "handleError", (...args) => {
      this.isLoading = false;
      this.props.onError(...args);
    });
    __publicField(this, "handleDurationCheck", () => {
      clearTimeout(this.durationCheckTimeout);
      const duration = this.getDuration();
      if (duration) {
        if (!this.onDurationCalled) {
          this.props.onDuration(duration);
          this.onDurationCalled = true;
        }
      } else {
        this.durationCheckTimeout = setTimeout(this.handleDurationCheck, 100);
      }
    });
    __publicField(this, "handleLoaded", () => {
      this.isLoading = false;
    });
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    clearTimeout(this.progressTimeout);
    clearTimeout(this.durationCheckTimeout);
    if (this.isReady && this.props.stopOnUnmount) {
      this.player.stop();
      if (this.player.disablePIP) {
        this.player.disablePIP();
      }
    }
    this.mounted = false;
  }
  componentDidUpdate(prevProps) {
    if (!this.player) {
      return;
    }
    const { url, playing, volume, muted, playbackRate, pip, loop, activePlayer, disableDeferredLoading } = this.props;
    if (!(0, import_react_fast_compare.default)(prevProps.url, url)) {
      if (this.isLoading && !activePlayer.forceLoad && !disableDeferredLoading && !(0, import_utils.isMediaStream)(url)) {
        console.warn(`ReactPlayer: the attempt to load ${url} is being deferred until the player has loaded`);
        this.loadOnReady = url;
        return;
      }
      this.isLoading = true;
      this.startOnPlay = true;
      this.onDurationCalled = false;
      this.player.load(url, this.isReady);
    }
    if (!prevProps.playing && playing && !this.isPlaying) {
      this.player.play();
    }
    if (prevProps.playing && !playing && this.isPlaying) {
      this.player.pause();
    }
    if (!prevProps.pip && pip && this.player.enablePIP) {
      this.player.enablePIP();
    }
    if (prevProps.pip && !pip && this.player.disablePIP) {
      this.player.disablePIP();
    }
    if (prevProps.volume !== volume && volume !== null) {
      this.player.setVolume(volume);
    }
    if (prevProps.muted !== muted) {
      if (muted) {
        this.player.mute();
      } else {
        this.player.unmute();
        if (volume !== null) {
          setTimeout(() => this.player.setVolume(volume));
        }
      }
    }
    if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
      this.player.setPlaybackRate(playbackRate);
    }
    if (prevProps.loop !== loop && this.player.setLoop) {
      this.player.setLoop(loop);
    }
  }
  getDuration() {
    if (!this.isReady)
      return null;
    return this.player.getDuration();
  }
  getCurrentTime() {
    if (!this.isReady)
      return null;
    return this.player.getCurrentTime();
  }
  getSecondsLoaded() {
    if (!this.isReady)
      return null;
    return this.player.getSecondsLoaded();
  }
  seekTo(amount, type, keepPlaying) {
    if (!this.isReady) {
      if (amount !== 0) {
        this.seekOnPlay = amount;
        setTimeout(() => {
          this.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
      }
      return;
    }
    const isFraction = !type ? amount > 0 && amount < 1 : type === "fraction";
    if (isFraction) {
      const duration = this.player.getDuration();
      if (!duration) {
        console.warn("ReactPlayer: could not seek using fraction \u2013\xA0duration not yet available");
        return;
      }
      this.player.seekTo(duration * amount, keepPlaying);
      return;
    }
    this.player.seekTo(amount, keepPlaying);
  }
  render() {
    const Player2 = this.props.activePlayer;
    if (!Player2) {
      return null;
    }
    return /* @__PURE__ */ import_react.default.createElement(
      Player2,
      {
        ...this.props,
        onMount: this.handlePlayerMount,
        onReady: this.handleReady,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onEnded: this.handleEnded,
        onLoaded: this.handleLoaded,
        onError: this.handleError
      }
    );
  }
}
__publicField(Player, "displayName", "Player");
__publicField(Player, "propTypes", import_props.propTypes);
__publicField(Player, "defaultProps", import_props.defaultProps);


/***/ }),

/***/ 52055:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var ReactPlayer_exports = {};
__export(ReactPlayer_exports, {
  createReactPlayer: () => createReactPlayer
});
module.exports = __toCommonJS(ReactPlayer_exports);
var import_react = __toESM(__webpack_require__(2784));
var import_deepmerge = __toESM(__webpack_require__(39714));
var import_memoize_one = __toESM(__webpack_require__(36631));
var import_react_fast_compare = __toESM(__webpack_require__(78435));
var import_props = __webpack_require__(29090);
var import_utils = __webpack_require__(77838);
var import_Player = __toESM(__webpack_require__(16403));
const Preview = (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerPreview */ 7664).then(__webpack_require__.t.bind(__webpack_require__, 27296, 23)));
const IS_BROWSER = typeof window !== "undefined" && window.document;
const IS_GLOBAL = typeof __webpack_require__.g !== "undefined" && __webpack_require__.g.window && __webpack_require__.g.window.document;
const SUPPORTED_PROPS = Object.keys(import_props.propTypes);
const UniversalSuspense = IS_BROWSER || IS_GLOBAL ? import_react.Suspense : () => null;
const customPlayers = [];
const createReactPlayer = (players, fallback) => {
  var _a;
  return _a = class extends import_react.Component {
    constructor() {
      super(...arguments);
      __publicField(this, "state", {
        showPreview: !!this.props.light
      });
      // Use references, as refs is used by React
      __publicField(this, "references", {
        wrapper: (wrapper) => {
          this.wrapper = wrapper;
        },
        player: (player) => {
          this.player = player;
        }
      });
      __publicField(this, "handleClickPreview", (e) => {
        this.setState({ showPreview: false });
        this.props.onClickPreview(e);
      });
      __publicField(this, "showPreview", () => {
        this.setState({ showPreview: true });
      });
      __publicField(this, "getDuration", () => {
        if (!this.player)
          return null;
        return this.player.getDuration();
      });
      __publicField(this, "getCurrentTime", () => {
        if (!this.player)
          return null;
        return this.player.getCurrentTime();
      });
      __publicField(this, "getSecondsLoaded", () => {
        if (!this.player)
          return null;
        return this.player.getSecondsLoaded();
      });
      __publicField(this, "getInternalPlayer", (key = "player") => {
        if (!this.player)
          return null;
        return this.player.getInternalPlayer(key);
      });
      __publicField(this, "seekTo", (fraction, type, keepPlaying) => {
        if (!this.player)
          return null;
        this.player.seekTo(fraction, type, keepPlaying);
      });
      __publicField(this, "handleReady", () => {
        this.props.onReady(this);
      });
      __publicField(this, "getActivePlayer", (0, import_memoize_one.default)((url) => {
        for (const player of [...customPlayers, ...players]) {
          if (player.canPlay(url)) {
            return player;
          }
        }
        if (fallback) {
          return fallback;
        }
        return null;
      }));
      __publicField(this, "getConfig", (0, import_memoize_one.default)((url, key) => {
        const { config } = this.props;
        return import_deepmerge.default.all([
          import_props.defaultProps.config,
          import_props.defaultProps.config[key] || {},
          config,
          config[key] || {}
        ]);
      }));
      __publicField(this, "getAttributes", (0, import_memoize_one.default)((url) => {
        return (0, import_utils.omit)(this.props, SUPPORTED_PROPS);
      }));
      __publicField(this, "renderActivePlayer", (url) => {
        if (!url)
          return null;
        const player = this.getActivePlayer(url);
        if (!player)
          return null;
        const config = this.getConfig(url, player.key);
        return /* @__PURE__ */ import_react.default.createElement(
          import_Player.default,
          {
            ...this.props,
            key: player.key,
            ref: this.references.player,
            config,
            activePlayer: player.lazyPlayer || player,
            onReady: this.handleReady
          }
        );
      });
    }
    shouldComponentUpdate(nextProps, nextState) {
      return !(0, import_react_fast_compare.default)(this.props, nextProps) || !(0, import_react_fast_compare.default)(this.state, nextState);
    }
    componentDidUpdate(prevProps) {
      const { light } = this.props;
      if (!prevProps.light && light) {
        this.setState({ showPreview: true });
      }
      if (prevProps.light && !light) {
        this.setState({ showPreview: false });
      }
    }
    renderPreview(url) {
      if (!url)
        return null;
      const { light, playIcon, previewTabIndex, oEmbedUrl } = this.props;
      return /* @__PURE__ */ import_react.default.createElement(
        Preview,
        {
          url,
          light,
          playIcon,
          previewTabIndex,
          oEmbedUrl,
          onClick: this.handleClickPreview
        }
      );
    }
    render() {
      const { url, style, width, height, fallback: fallback2, wrapper: Wrapper } = this.props;
      const { showPreview } = this.state;
      const attributes = this.getAttributes(url);
      const wrapperRef = typeof Wrapper === "string" ? this.references.wrapper : void 0;
      return /* @__PURE__ */ import_react.default.createElement(Wrapper, { ref: wrapperRef, style: { ...style, width, height }, ...attributes }, /* @__PURE__ */ import_react.default.createElement(UniversalSuspense, { fallback: fallback2 }, showPreview ? this.renderPreview(url) : this.renderActivePlayer(url)));
    }
  }, __publicField(_a, "displayName", "ReactPlayer"), __publicField(_a, "propTypes", import_props.propTypes), __publicField(_a, "defaultProps", import_props.defaultProps), __publicField(_a, "addCustomPlayer", (player) => {
    customPlayers.push(player);
  }), __publicField(_a, "removeCustomPlayers", () => {
    customPlayers.length = 0;
  }), __publicField(_a, "canPlay", (url) => {
    for (const Player2 of [...customPlayers, ...players]) {
      if (Player2.canPlay(url)) {
        return true;
      }
    }
    return false;
  }), __publicField(_a, "canEnablePIP", (url) => {
    for (const Player2 of [...customPlayers, ...players]) {
      if (Player2.canEnablePIP && Player2.canEnablePIP(url)) {
        return true;
      }
    }
    return false;
  }), _a;
};


/***/ }),

/***/ 84372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  default: () => src_default
});
module.exports = __toCommonJS(src_exports);
var import_players = __toESM(__webpack_require__(18350));
var import_ReactPlayer = __webpack_require__(52055);
const fallback = import_players.default[import_players.default.length - 1];
var src_default = (0, import_ReactPlayer.createReactPlayer)(import_players.default, fallback);


/***/ }),

/***/ 842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var patterns_exports = {};
__export(patterns_exports, {
  AUDIO_EXTENSIONS: () => AUDIO_EXTENSIONS,
  DASH_EXTENSIONS: () => DASH_EXTENSIONS,
  FLV_EXTENSIONS: () => FLV_EXTENSIONS,
  HLS_EXTENSIONS: () => HLS_EXTENSIONS,
  MATCH_URL_DAILYMOTION: () => MATCH_URL_DAILYMOTION,
  MATCH_URL_FACEBOOK: () => MATCH_URL_FACEBOOK,
  MATCH_URL_FACEBOOK_WATCH: () => MATCH_URL_FACEBOOK_WATCH,
  MATCH_URL_KALTURA: () => MATCH_URL_KALTURA,
  MATCH_URL_MIXCLOUD: () => MATCH_URL_MIXCLOUD,
  MATCH_URL_SOUNDCLOUD: () => MATCH_URL_SOUNDCLOUD,
  MATCH_URL_STREAMABLE: () => MATCH_URL_STREAMABLE,
  MATCH_URL_TWITCH_CHANNEL: () => MATCH_URL_TWITCH_CHANNEL,
  MATCH_URL_TWITCH_VIDEO: () => MATCH_URL_TWITCH_VIDEO,
  MATCH_URL_VIDYARD: () => MATCH_URL_VIDYARD,
  MATCH_URL_VIMEO: () => MATCH_URL_VIMEO,
  MATCH_URL_WISTIA: () => MATCH_URL_WISTIA,
  MATCH_URL_YOUTUBE: () => MATCH_URL_YOUTUBE,
  VIDEO_EXTENSIONS: () => VIDEO_EXTENSIONS,
  canPlay: () => canPlay
});
module.exports = __toCommonJS(patterns_exports);
var import_utils = __webpack_require__(77838);
const MATCH_URL_YOUTUBE = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
const MATCH_URL_SOUNDCLOUD = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
const MATCH_URL_VIMEO = /vimeo\.com\/(?!progressive_redirect).+/;
const MATCH_URL_FACEBOOK = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
const MATCH_URL_FACEBOOK_WATCH = /^https?:\/\/fb\.watch\/.+$/;
const MATCH_URL_STREAMABLE = /streamable\.com\/([a-z0-9]+)$/;
const MATCH_URL_WISTIA = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/;
const MATCH_URL_TWITCH_VIDEO = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
const MATCH_URL_TWITCH_CHANNEL = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/;
const MATCH_URL_DAILYMOTION = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/;
const MATCH_URL_MIXCLOUD = /mixcloud\.com\/([^/]+\/[^/]+)/;
const MATCH_URL_VIDYARD = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/;
const MATCH_URL_KALTURA = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/;
const AUDIO_EXTENSIONS = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
const VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
const HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
const DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
const FLV_EXTENSIONS = /\.(flv)($|\?)/i;
const canPlayFile = (url) => {
  if (url instanceof Array) {
    for (const item of url) {
      if (typeof item === "string" && canPlayFile(item)) {
        return true;
      }
      if (canPlayFile(item.src)) {
        return true;
      }
    }
    return false;
  }
  if ((0, import_utils.isMediaStream)(url) || (0, import_utils.isBlobUrl)(url)) {
    return true;
  }
  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url) || FLV_EXTENSIONS.test(url);
};
const canPlay = {
  youtube: (url) => {
    if (url instanceof Array) {
      return url.every((item) => MATCH_URL_YOUTUBE.test(item));
    }
    return MATCH_URL_YOUTUBE.test(url);
  },
  soundcloud: (url) => MATCH_URL_SOUNDCLOUD.test(url) && !AUDIO_EXTENSIONS.test(url),
  vimeo: (url) => MATCH_URL_VIMEO.test(url) && !VIDEO_EXTENSIONS.test(url) && !HLS_EXTENSIONS.test(url),
  facebook: (url) => MATCH_URL_FACEBOOK.test(url) || MATCH_URL_FACEBOOK_WATCH.test(url),
  streamable: (url) => MATCH_URL_STREAMABLE.test(url),
  wistia: (url) => MATCH_URL_WISTIA.test(url),
  twitch: (url) => MATCH_URL_TWITCH_VIDEO.test(url) || MATCH_URL_TWITCH_CHANNEL.test(url),
  dailymotion: (url) => MATCH_URL_DAILYMOTION.test(url),
  mixcloud: (url) => MATCH_URL_MIXCLOUD.test(url),
  vidyard: (url) => MATCH_URL_VIDYARD.test(url),
  kaltura: (url) => MATCH_URL_KALTURA.test(url),
  file: canPlayFile
};


/***/ }),

/***/ 18350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var players_exports = {};
__export(players_exports, {
  default: () => players_default
});
module.exports = __toCommonJS(players_exports);
var import_utils = __webpack_require__(77838);
var import_patterns = __webpack_require__(842);
var players_default = [
  {
    key: "youtube",
    name: "YouTube",
    canPlay: import_patterns.canPlay.youtube,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerYouTube */ 4439).then(__webpack_require__.t.bind(__webpack_require__, 56250, 23)))
  },
  {
    key: "soundcloud",
    name: "SoundCloud",
    canPlay: import_patterns.canPlay.soundcloud,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerSoundCloud */ 6125).then(__webpack_require__.t.bind(__webpack_require__, 71323, 23)))
  },
  {
    key: "vimeo",
    name: "Vimeo",
    canPlay: import_patterns.canPlay.vimeo,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerVimeo */ 3743).then(__webpack_require__.t.bind(__webpack_require__, 22127, 23)))
  },
  {
    key: "facebook",
    name: "Facebook",
    canPlay: import_patterns.canPlay.facebook,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerFacebook */ 2121).then(__webpack_require__.t.bind(__webpack_require__, 1027, 23)))
  },
  {
    key: "streamable",
    name: "Streamable",
    canPlay: import_patterns.canPlay.streamable,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerStreamable */ 2546).then(__webpack_require__.t.bind(__webpack_require__, 69788, 23)))
  },
  {
    key: "wistia",
    name: "Wistia",
    canPlay: import_patterns.canPlay.wistia,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerWistia */ 8055).then(__webpack_require__.t.bind(__webpack_require__, 5337, 23)))
  },
  {
    key: "twitch",
    name: "Twitch",
    canPlay: import_patterns.canPlay.twitch,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerTwitch */ 6216).then(__webpack_require__.t.bind(__webpack_require__, 13691, 23)))
  },
  {
    key: "dailymotion",
    name: "DailyMotion",
    canPlay: import_patterns.canPlay.dailymotion,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerDailyMotion */ 7596).then(__webpack_require__.t.bind(__webpack_require__, 82353, 23)))
  },
  {
    key: "mixcloud",
    name: "Mixcloud",
    canPlay: import_patterns.canPlay.mixcloud,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerMixcloud */ 4667).then(__webpack_require__.t.bind(__webpack_require__, 96123, 23)))
  },
  {
    key: "vidyard",
    name: "Vidyard",
    canPlay: import_patterns.canPlay.vidyard,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerVidyard */ 8888).then(__webpack_require__.t.bind(__webpack_require__, 85987, 23)))
  },
  {
    key: "kaltura",
    name: "Kaltura",
    canPlay: import_patterns.canPlay.kaltura,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerKaltura */ 261).then(__webpack_require__.t.bind(__webpack_require__, 2630, 23)))
  },
  {
    key: "file",
    name: "FilePlayer",
    canPlay: import_patterns.canPlay.file,
    canEnablePIP: (url) => {
      return import_patterns.canPlay.file(url) && (document.pictureInPictureEnabled || (0, import_utils.supportsWebKitPresentationMode)()) && !import_patterns.AUDIO_EXTENSIONS.test(url);
    },
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerFilePlayer */ 6011).then(__webpack_require__.t.bind(__webpack_require__, 53377, 23)))
  }
];


/***/ }),

/***/ 29090:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var props_exports = {};
__export(props_exports, {
  defaultProps: () => defaultProps,
  propTypes: () => propTypes
});
module.exports = __toCommonJS(props_exports);
var import_prop_types = __toESM(__webpack_require__(13980));
const { string, bool, number, array, oneOfType, shape, object, func, node } = import_prop_types.default;
const propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  stopOnUnmount: bool,
  light: oneOfType([bool, string, object]),
  playIcon: node,
  previewTabIndex: number,
  fallback: node,
  oEmbedUrl: string,
  wrapper: oneOfType([
    string,
    func,
    shape({ render: func.isRequired })
  ]),
  config: shape({
    soundcloud: shape({
      options: object
    }),
    youtube: shape({
      playerVars: object,
      embedOptions: object,
      onUnstarted: func
    }),
    facebook: shape({
      appId: string,
      version: string,
      playerId: string,
      attributes: object
    }),
    dailymotion: shape({
      params: object
    }),
    vimeo: shape({
      playerOptions: object,
      title: string
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceSafariHLS: bool,
      forceDisableHls: bool,
      forceDASH: bool,
      forceFLV: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string,
      flvVersion: string
    }),
    wistia: shape({
      options: object,
      playerId: string,
      customControls: array
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object,
      playerId: string
    }),
    vidyard: shape({
      options: object
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onBufferEnd: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onPlaybackRateChange: func,
  onPlaybackQualityChange: func,
  onProgress: func,
  onClickPreview: func,
  onEnablePIP: func,
  onDisablePIP: func
};
const noop = () => {
};
const defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: "640px",
  height: "360px",
  style: {},
  progressInterval: 1e3,
  playsinline: false,
  pip: false,
  stopOnUnmount: true,
  light: false,
  fallback: null,
  wrapper: "div",
  previewTabIndex: 0,
  oEmbedUrl: "https://noembed.com/embed?url={url}",
  config: {
    soundcloud: {
      options: {
        visual: true,
        // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      onUnstarted: noop
    },
    facebook: {
      appId: "1309697205772819",
      version: "v3.3",
      playerId: null,
      attributes: {}
    },
    dailymotion: {
      params: {
        api: 1,
        "endscreen-enable": false
      }
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      },
      title: null
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      forceFLV: false,
      hlsOptions: {},
      hlsVersion: "1.1.4",
      dashVersion: "3.1.3",
      flvVersion: "1.5.0",
      forceDisableHls: false
    },
    wistia: {
      options: {},
      playerId: null,
      customControls: null
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    },
    vidyard: {
      options: {}
    }
  },
  onReady: noop,
  onStart: noop,
  onPlay: noop,
  onPause: noop,
  onBuffer: noop,
  onBufferEnd: noop,
  onEnded: noop,
  onError: noop,
  onDuration: noop,
  onSeek: noop,
  onPlaybackRateChange: noop,
  onPlaybackQualityChange: noop,
  onProgress: noop,
  onClickPreview: noop,
  onEnablePIP: noop,
  onDisablePIP: noop
};


/***/ }),

/***/ 77838:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  callPlayer: () => callPlayer,
  getConfig: () => getConfig,
  getSDK: () => getSDK,
  isBlobUrl: () => isBlobUrl,
  isMediaStream: () => isMediaStream,
  lazy: () => lazy,
  omit: () => omit,
  parseEndTime: () => parseEndTime,
  parseStartTime: () => parseStartTime,
  queryString: () => queryString,
  randomString: () => randomString,
  supportsWebKitPresentationMode: () => supportsWebKitPresentationMode
});
module.exports = __toCommonJS(utils_exports);
var import_react = __toESM(__webpack_require__(2784));
var import_load_script = __toESM(__webpack_require__(9599));
var import_deepmerge = __toESM(__webpack_require__(39714));
const lazy = (componentImportFn) => import_react.default.lazy(async () => {
  const obj = await componentImportFn();
  return typeof obj.default === "function" ? obj : obj.default;
});
const MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
const MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
const MATCH_START_STAMP = /(\d+)(h|m|s)/g;
const MATCH_NUMERIC = /^\d+$/;
function parseTimeParam(url, pattern) {
  if (url instanceof Array) {
    return void 0;
  }
  const match = url.match(pattern);
  if (match) {
    const stamp = match[1];
    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }
    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }
  return void 0;
}
function parseTimeString(stamp) {
  let seconds = 0;
  let array = MATCH_START_STAMP.exec(stamp);
  while (array !== null) {
    const [, count, period] = array;
    if (period === "h")
      seconds += parseInt(count, 10) * 60 * 60;
    if (period === "m")
      seconds += parseInt(count, 10) * 60;
    if (period === "s")
      seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }
  return seconds;
}
function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}
function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
}
function randomString() {
  return Math.random().toString(36).substr(2, 5);
}
function queryString(object) {
  return Object.keys(object).map((key) => `${key}=${object[key]}`).join("&");
}
function getGlobal(key) {
  if (window[key]) {
    return window[key];
  }
  if (window.exports && window.exports[key]) {
    return window.exports[key];
  }
  if (window.module && window.module.exports && window.module.exports[key]) {
    return window.module.exports[key];
  }
  return null;
}
const requests = {};
const getSDK = enableStubOn(function getSDK2(url, sdkGlobal, sdkReady = null, isLoaded = () => true, fetchScript = import_load_script.default) {
  const existingGlobal = getGlobal(sdkGlobal);
  if (existingGlobal && isLoaded(existingGlobal)) {
    return Promise.resolve(existingGlobal);
  }
  return new Promise((resolve, reject) => {
    if (requests[url]) {
      requests[url].push({ resolve, reject });
      return;
    }
    requests[url] = [{ resolve, reject }];
    const onLoaded = (sdk) => {
      requests[url].forEach((request) => request.resolve(sdk));
    };
    if (sdkReady) {
      const previousOnReady = window[sdkReady];
      window[sdkReady] = function() {
        if (previousOnReady)
          previousOnReady();
        onLoaded(getGlobal(sdkGlobal));
      };
    }
    fetchScript(url, (err) => {
      if (err) {
        requests[url].forEach((request) => request.reject(err));
        requests[url] = null;
      } else if (!sdkReady) {
        onLoaded(getGlobal(sdkGlobal));
      }
    });
  });
});
function getConfig(props, defaultProps) {
  return (0, import_deepmerge.default)(defaultProps.config, props.config);
}
function omit(object, ...arrays) {
  const omitKeys = [].concat(...arrays);
  const output = {};
  const keys = Object.keys(object);
  for (const key of keys) {
    if (omitKeys.indexOf(key) === -1) {
      output[key] = object[key];
    }
  }
  return output;
}
function callPlayer(method, ...args) {
  if (!this.player || !this.player[method]) {
    let message = `ReactPlayer: ${this.constructor.displayName} player could not call %c${method}%c \u2013 `;
    if (!this.player) {
      message += "The player was not available";
    } else if (!this.player[method]) {
      message += "The method was not available";
    }
    console.warn(message, "font-weight: bold", "");
    return null;
  }
  return this.player[method](...args);
}
function isMediaStream(url) {
  return typeof window !== "undefined" && typeof window.MediaStream !== "undefined" && url instanceof window.MediaStream;
}
function isBlobUrl(url) {
  return /^blob:/.test(url);
}
function supportsWebKitPresentationMode(video = document.createElement("video")) {
  const notMobile = /iPhone|iPod/.test(navigator.userAgent) === false;
  return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === "function" && notMobile;
}
function enableStubOn(fn) {
  if (false) {}
  return fn;
}


/***/ }),

/***/ 33606:
/***/ (function(module) {

module.exports = function requiredIf(type, condition) {
  return function(props) {
    var test = condition(props) ? type.isRequired : type;
    return test.apply(this, arguments);
  };
};


/***/ }),

/***/ 84581:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _default = function _default(position, metric, axis) {
  var positionPercent = position === 0 ? position : position + metric;
  var positionCss = axis === 'horizontal' ? [positionPercent, 0, 0] : [0, positionPercent, 0];
  var transitionProp = 'translate3d';
  var translatedPosition = '(' + positionCss.join(',') + ')';
  return transitionProp + translatedPosition;
};

exports["default"] = _default;

/***/ }),

/***/ 12151:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.fadeAnimationHandler = exports.slideStopSwipingHandler = exports.slideSwipeAnimationHandler = exports.slideAnimationHandler = void 0;

var _react = __webpack_require__(2784);

var _CSSTranslate = _interopRequireDefault(__webpack_require__(84581));

var _utils = __webpack_require__(78011);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Main animation handler for the default 'sliding' style animation
 * @param props
 * @param state
 */
var slideAnimationHandler = function slideAnimationHandler(props, state) {
  var returnStyles = {};
  var selectedItem = state.selectedItem;
  var previousItem = selectedItem;
  var lastPosition = _react.Children.count(props.children) - 1;
  var needClonedSlide = props.infiniteLoop && (selectedItem < 0 || selectedItem > lastPosition); // Handle list position if it needs a clone

  if (needClonedSlide) {
    if (previousItem < 0) {
      if (props.centerMode && props.centerSlidePercentage && props.axis === 'horizontal') {
        returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * props.centerSlidePercentage - (100 - props.centerSlidePercentage) / 2, props.axis);
      } else {
        returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * 100, props.axis);
      }
    } else if (previousItem > lastPosition) {
      returnStyles.itemListStyle = (0, _utils.setPosition)(0, props.axis);
    }

    return returnStyles;
  }

  var currentPosition = (0, _utils.getPosition)(selectedItem, props); // if 3d is available, let's take advantage of the performance of transform

  var transformProp = (0, _CSSTranslate.default)(currentPosition, '%', props.axis);
  var transitionTime = props.transitionTime + 'ms';
  returnStyles.itemListStyle = {
    WebkitTransform: transformProp,
    msTransform: transformProp,
    OTransform: transformProp,
    transform: transformProp
  };

  if (!state.swiping) {
    returnStyles.itemListStyle = _objectSpread(_objectSpread({}, returnStyles.itemListStyle), {}, {
      WebkitTransitionDuration: transitionTime,
      MozTransitionDuration: transitionTime,
      OTransitionDuration: transitionTime,
      transitionDuration: transitionTime,
      msTransitionDuration: transitionTime
    });
  }

  return returnStyles;
};
/**
 * Swiping animation handler for the default 'sliding' style animation
 * @param delta
 * @param props
 * @param state
 * @param setState
 */


exports.slideAnimationHandler = slideAnimationHandler;

var slideSwipeAnimationHandler = function slideSwipeAnimationHandler(delta, props, state, setState) {
  var returnStyles = {};
  var isHorizontal = props.axis === 'horizontal';

  var childrenLength = _react.Children.count(props.children);

  var initialBoundry = 0;
  var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
  var finalBoundry = props.infiniteLoop ? (0, _utils.getPosition)(childrenLength - 1, props) - 100 : (0, _utils.getPosition)(childrenLength - 1, props);
  var axisDelta = isHorizontal ? delta.x : delta.y;
  var handledDelta = axisDelta; // prevent user from swiping left out of boundaries

  if (currentPosition === initialBoundry && axisDelta > 0) {
    handledDelta = 0;
  } // prevent user from swiping right out of boundaries


  if (currentPosition === finalBoundry && axisDelta < 0) {
    handledDelta = 0;
  }

  var position = currentPosition + 100 / (state.itemSize / handledDelta);
  var hasMoved = Math.abs(axisDelta) > props.swipeScrollTolerance;

  if (props.infiniteLoop && hasMoved) {
    // When allowing infinite loop, if we slide left from position 0 we reveal the cloned last slide that appears before it
    // if we slide even further we need to jump to other side so it can continue - and vice versa for the last slide
    if (state.selectedItem === 0 && position > -100) {
      position -= childrenLength * 100;
    } else if (state.selectedItem === childrenLength - 1 && position < -childrenLength * 100) {
      position += childrenLength * 100;
    }
  }

  if (!props.preventMovementUntilSwipeScrollTolerance || hasMoved || state.swipeMovementStarted) {
    if (!state.swipeMovementStarted) {
      setState({
        swipeMovementStarted: true
      });
    }

    returnStyles.itemListStyle = (0, _utils.setPosition)(position, props.axis);
  } //allows scroll if the swipe was within the tolerance


  if (hasMoved && !state.cancelClick) {
    setState({
      cancelClick: true
    });
  }

  return returnStyles;
};
/**
 * Default 'sliding' style animination handler for when a swipe action stops.
 * @param props
 * @param state
 */


exports.slideSwipeAnimationHandler = slideSwipeAnimationHandler;

var slideStopSwipingHandler = function slideStopSwipingHandler(props, state) {
  var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
  var itemListStyle = (0, _utils.setPosition)(currentPosition, props.axis);
  return {
    itemListStyle: itemListStyle
  };
};
/**
 * Main animation handler for the default 'fade' style animation
 * @param props
 * @param state
 */


exports.slideStopSwipingHandler = slideStopSwipingHandler;

var fadeAnimationHandler = function fadeAnimationHandler(props, state) {
  var transitionTime = props.transitionTime + 'ms';
  var transitionTimingFunction = 'ease-in-out';
  var slideStyle = {
    position: 'absolute',
    display: 'block',
    zIndex: -2,
    minHeight: '100%',
    opacity: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transitionTimingFunction: transitionTimingFunction,
    msTransitionTimingFunction: transitionTimingFunction,
    MozTransitionTimingFunction: transitionTimingFunction,
    WebkitTransitionTimingFunction: transitionTimingFunction,
    OTransitionTimingFunction: transitionTimingFunction
  };

  if (!state.swiping) {
    slideStyle = _objectSpread(_objectSpread({}, slideStyle), {}, {
      WebkitTransitionDuration: transitionTime,
      MozTransitionDuration: transitionTime,
      OTransitionDuration: transitionTime,
      transitionDuration: transitionTime,
      msTransitionDuration: transitionTime
    });
  }

  return {
    slideStyle: slideStyle,
    selectedStyle: _objectSpread(_objectSpread({}, slideStyle), {}, {
      opacity: 1,
      position: 'relative'
    }),
    prevStyle: _objectSpread({}, slideStyle)
  };
};

exports.fadeAnimationHandler = fadeAnimationHandler;

/***/ }),

/***/ 91634:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(2784));

var _reactEasySwipe = _interopRequireDefault(__webpack_require__(46075));

var _cssClasses = _interopRequireDefault(__webpack_require__(72222));

var _Thumbs = _interopRequireDefault(__webpack_require__(6578));

var _document = _interopRequireDefault(__webpack_require__(81081));

var _window = _interopRequireDefault(__webpack_require__(60694));

var _utils = __webpack_require__(78011);

var _animations = __webpack_require__(12151);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);

  var _super = _createSuper(Carousel);

  // @ts-ignore
  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "carouselWrapperRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "listRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "itemsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "timer", void 0);

    _defineProperty(_assertThisInitialized(_this), "animationHandler", void 0);

    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node) {
      _this.thumbsRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setCarouselWrapperRef", function (node) {
      _this.carouselWrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setListRef", function (node) {
      _this.listRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setItemsRef", function (node, index) {
      if (!_this.itemsRef) {
        _this.itemsRef = [];
      }

      _this.itemsRef[index] = node;
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function () {
      if (_react.Children.count(_this.props.children) <= 1) {
        return;
      }

      _this.clearAutoPlay();

      if (!_this.props.autoPlay) {
        return;
      }

      _this.timer = setTimeout(function () {
        _this.increment();
      }, _this.props.interval);
    });

    _defineProperty(_assertThisInitialized(_this), "clearAutoPlay", function () {
      if (_this.timer) clearTimeout(_this.timer);
    });

    _defineProperty(_assertThisInitialized(_this), "resetAutoPlay", function () {
      _this.clearAutoPlay();

      _this.autoPlay();
    });

    _defineProperty(_assertThisInitialized(_this), "stopOnHover", function () {
      _this.setState({
        isMouseEntered: true
      }, _this.clearAutoPlay);
    });

    _defineProperty(_assertThisInitialized(_this), "startOnLeave", function () {
      _this.setState({
        isMouseEntered: false
      }, _this.autoPlay);
    });

    _defineProperty(_assertThisInitialized(_this), "isFocusWithinTheCarousel", function () {
      if (!_this.carouselWrapperRef) {
        return false;
      }

      if ((0, _document.default)().activeElement === _this.carouselWrapperRef || _this.carouselWrapperRef.contains((0, _document.default)().activeElement)) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "navigateWithKeyboard", function (e) {
      if (!_this.isFocusWithinTheCarousel()) {
        return;
      }

      var axis = _this.props.axis;
      var isHorizontal = axis === 'horizontal';
      var keyNames = {
        ArrowUp: 38,
        ArrowRight: 39,
        ArrowDown: 40,
        ArrowLeft: 37
      };
      var nextKey = isHorizontal ? keyNames.ArrowRight : keyNames.ArrowDown;
      var prevKey = isHorizontal ? keyNames.ArrowLeft : keyNames.ArrowUp;

      if (nextKey === e.keyCode) {
        _this.increment();
      } else if (prevKey === e.keyCode) {
        _this.decrement();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
      if (!_this.state.initialized || !_this.itemsRef || _this.itemsRef.length === 0) {
        return;
      }

      var isHorizontal = _this.props.axis === 'horizontal';
      var firstItem = _this.itemsRef[0];

      if (!firstItem) {
        return;
      }

      var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;

      _this.setState({
        itemSize: itemSize
      });

      if (_this.thumbsRef) {
        _this.thumbsRef.updateSizes();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setMountState", function () {
      _this.setState({
        hasMount: true
      });

      _this.updateSizes();
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item) {
      if (_react.Children.count(_this.props.children) === 0) {
        return;
      }

      if (_this.state.cancelClick) {
        _this.setState({
          cancelClick: false
        });

        return;
      }

      _this.props.onClickItem(index, item);

      if (index !== _this.state.selectedItem) {
        _this.setState({
          selectedItem: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (index, item) {
      if (_react.Children.count(_this.props.children) <= 1) {
        return;
      }

      _this.props.onChange(index, item);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickThumb", function (index, item) {
      _this.props.onClickThumb(index, item);

      _this.moveTo(index);
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function (event) {
      _this.setState({
        swiping: true
      });

      _this.props.onSwipeStart(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function (event) {
      _this.setState({
        swiping: false,
        cancelClick: false,
        swipeMovementStarted: false
      });

      _this.props.onSwipeEnd(event);

      _this.clearAutoPlay();

      if (_this.state.autoPlay) {
        _this.autoPlay();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta, event) {
      _this.props.onSwipeMove(event);

      var animationHandlerResponse = _this.props.swipeAnimationHandler(delta, _this.props, _this.state, _this.setState.bind(_assertThisInitialized(_this)));

      _this.setState(_objectSpread({}, animationHandlerResponse)); // If we have not moved, we should have an empty object returned
      // Return false to allow scrolling when not swiping


      return !!Object.keys(animationHandlerResponse).length;
    });

    _defineProperty(_assertThisInitialized(_this), "decrement", function () {
      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      _this.moveTo(_this.state.selectedItem - (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "increment", function () {
      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      _this.moveTo(_this.state.selectedItem + (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
      if (typeof position !== 'number') {
        return;
      }

      var lastPosition = _react.Children.count(_this.props.children) - 1;

      if (position < 0) {
        position = _this.props.infiniteLoop ? lastPosition : 0;
      }

      if (position > lastPosition) {
        position = _this.props.infiniteLoop ? 0 : lastPosition;
      }

      _this.selectItem({
        // if it's not a slider, we don't need to set position here
        selectedItem: position
      }); // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
      // and will result in the interval function not being cleared correctly.


      if (_this.state.autoPlay && _this.state.isMouseEntered === false) {
        _this.resetAutoPlay();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickNext", function () {
      _this.increment(1);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickPrev", function () {
      _this.decrement(1);
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeForward", function () {
      _this.increment(1);

      if (_this.props.emulateTouch) {
        _this.setState({
          cancelClick: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeBackwards", function () {
      _this.decrement(1);

      if (_this.props.emulateTouch) {
        _this.setState({
          cancelClick: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeItem", function (newIndex) {
      return function (e) {
        if (!(0, _utils.isKeyboardEvent)(e) || e.key === 'Enter') {
          _this.moveTo(newIndex);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "selectItem", function (state) {
      // Merge in the new state while updating updating previous item
      _this.setState(_objectSpread({
        previousItem: _this.state.selectedItem
      }, state), function () {
        // Run animation handler and update styles based on it
        _this.setState(_this.animationHandler(_this.props, _this.state));
      });

      _this.handleOnChange(state.selectedItem, _react.Children.toArray(_this.props.children)[state.selectedItem]);
    });

    _defineProperty(_assertThisInitialized(_this), "getInitialImage", function () {
      var selectedItem = _this.props.selectedItem;
      var item = _this.itemsRef && _this.itemsRef[selectedItem];
      var images = item && item.getElementsByTagName('img') || [];
      return images[0];
    });

    _defineProperty(_assertThisInitialized(_this), "getVariableItemHeight", function (position) {
      var item = _this.itemsRef && _this.itemsRef[position];

      if (_this.state.hasMount && item && item.children.length) {
        var slideImages = item.children[0].getElementsByTagName('img') || [];

        if (slideImages.length > 0) {
          var image = slideImages[0];

          if (!image.complete) {
            // if the image is still loading, the size won't be available so we trigger a new render after it's done
            var onImageLoad = function onImageLoad() {
              _this.forceUpdate();

              image.removeEventListener('load', onImageLoad);
            };

            image.addEventListener('load', onImageLoad);
          }
        } // try to get img first, if img not there find first display tag


        var displayItem = slideImages[0] || item.children[0];
        var height = displayItem.clientHeight;
        return height > 0 ? height : null;
      }

      return null;
    });

    var initState = {
      initialized: false,
      previousItem: props.selectedItem,
      selectedItem: props.selectedItem,
      hasMount: false,
      isMouseEntered: false,
      autoPlay: props.autoPlay,
      swiping: false,
      swipeMovementStarted: false,
      cancelClick: false,
      itemSize: 1,
      itemListStyle: {},
      slideStyle: {},
      selectedStyle: {},
      prevStyle: {}
    };
    _this.animationHandler = typeof props.animationHandler === 'function' && props.animationHandler || props.animationHandler === 'fade' && _animations.fadeAnimationHandler || _animations.slideAnimationHandler;
    _this.state = _objectSpread(_objectSpread({}, initState), _this.animationHandler(props, initState));
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.children) {
        return;
      }

      this.setupCarousel();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevProps.children && this.props.children && !this.state.initialized) {
        this.setupCarousel();
      }

      if (!prevProps.autoFocus && this.props.autoFocus) {
        this.forceFocus();
      }

      if (prevState.swiping && !this.state.swiping) {
        // We stopped swiping, ensure we are heading to the new/current slide and not stuck
        this.setState(_objectSpread({}, this.props.stopSwipingHandler(this.props, this.state)));
      }

      if (prevProps.selectedItem !== this.props.selectedItem || prevProps.centerMode !== this.props.centerMode) {
        this.updateSizes();
        this.moveTo(this.props.selectedItem);
      }

      if (prevProps.autoPlay !== this.props.autoPlay) {
        if (this.props.autoPlay) {
          this.setupAutoPlay();
        } else {
          this.destroyAutoPlay();
        }

        this.setState({
          autoPlay: this.props.autoPlay
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyCarousel();
    }
  }, {
    key: "setupCarousel",
    value: function setupCarousel() {
      var _this2 = this;

      this.bindEvents();

      if (this.state.autoPlay && _react.Children.count(this.props.children) > 1) {
        this.setupAutoPlay();
      }

      if (this.props.autoFocus) {
        this.forceFocus();
      }

      this.setState({
        initialized: true
      }, function () {
        var initialImage = _this2.getInitialImage();

        if (initialImage && !initialImage.complete) {
          // if it's a carousel of images, we set the mount state after the first image is loaded
          initialImage.addEventListener('load', _this2.setMountState);
        } else {
          _this2.setMountState();
        }
      });
    }
  }, {
    key: "destroyCarousel",
    value: function destroyCarousel() {
      if (this.state.initialized) {
        this.unbindEvents();
        this.destroyAutoPlay();
      }
    }
  }, {
    key: "setupAutoPlay",
    value: function setupAutoPlay() {
      this.autoPlay();
      var carouselWrapper = this.carouselWrapperRef;

      if (this.props.stopOnHover && carouselWrapper) {
        carouselWrapper.addEventListener('mouseenter', this.stopOnHover);
        carouselWrapper.addEventListener('mouseleave', this.startOnLeave);
      }
    }
  }, {
    key: "destroyAutoPlay",
    value: function destroyAutoPlay() {
      this.clearAutoPlay();
      var carouselWrapper = this.carouselWrapperRef;

      if (this.props.stopOnHover && carouselWrapper) {
        carouselWrapper.removeEventListener('mouseenter', this.stopOnHover);
        carouselWrapper.removeEventListener('mouseleave', this.startOnLeave);
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      // as the widths are calculated, we need to resize
      // the carousel when the window is resized
      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes);

      if (this.props.useKeyboardArrows) {
        (0, _document.default)().addEventListener('keydown', this.navigateWithKeyboard);
      }
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      // removing listeners
      (0, _window.default)().removeEventListener('resize', this.updateSizes);
      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
      var initialImage = this.getInitialImage();

      if (initialImage) {
        initialImage.removeEventListener('load', this.setMountState);
      }

      if (this.props.useKeyboardArrows) {
        (0, _document.default)().removeEventListener('keydown', this.navigateWithKeyboard);
      }
    }
  }, {
    key: "forceFocus",
    value: function forceFocus() {
      var _this$carouselWrapper;

      (_this$carouselWrapper = this.carouselWrapperRef) === null || _this$carouselWrapper === void 0 ? void 0 : _this$carouselWrapper.focus();
    }
  }, {
    key: "renderItems",
    value: function renderItems(isClone) {
      var _this3 = this;

      if (!this.props.children) {
        return [];
      }

      return _react.Children.map(this.props.children, function (item, index) {
        var isSelected = index === _this3.state.selectedItem;
        var isPrevious = index === _this3.state.previousItem;
        var style = isSelected && _this3.state.selectedStyle || isPrevious && _this3.state.prevStyle || _this3.state.slideStyle || {};

        if (_this3.props.centerMode && _this3.props.axis === 'horizontal') {
          style = _objectSpread(_objectSpread({}, style), {}, {
            minWidth: _this3.props.centerSlidePercentage + '%'
          });
        }

        if (_this3.state.swiping && _this3.state.swipeMovementStarted) {
          style = _objectSpread(_objectSpread({}, style), {}, {
            pointerEvents: 'none'
          });
        }

        var slideProps = {
          ref: function ref(e) {
            return _this3.setItemsRef(e, index);
          },
          key: 'itemKey' + index + (isClone ? 'clone' : ''),
          className: _cssClasses.default.ITEM(true, index === _this3.state.selectedItem, index === _this3.state.previousItem),
          onClick: _this3.handleClickItem.bind(_this3, index, item),
          style: style
        };
        return /*#__PURE__*/_react.default.createElement("li", slideProps, _this3.props.renderItem(item, {
          isSelected: index === _this3.state.selectedItem,
          isPrevious: index === _this3.state.previousItem
        }));
      });
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      var _this4 = this;

      var _this$props = this.props,
          showIndicators = _this$props.showIndicators,
          labels = _this$props.labels,
          renderIndicator = _this$props.renderIndicator,
          children = _this$props.children;

      if (!showIndicators) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "control-dots"
      }, _react.Children.map(children, function (_, index) {
        return renderIndicator && renderIndicator(_this4.changeItem(index), index === _this4.state.selectedItem, index, labels.item);
      }));
    }
  }, {
    key: "renderStatus",
    value: function renderStatus() {
      if (!this.props.showStatus) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("p", {
        className: "carousel-status"
      }, this.props.statusFormatter(this.state.selectedItem + 1, _react.Children.count(this.props.children)));
    }
  }, {
    key: "renderThumbs",
    value: function renderThumbs() {
      if (!this.props.showThumbs || !this.props.children || _react.Children.count(this.props.children) === 0) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_Thumbs.default, {
        ref: this.setThumbsRef,
        onSelectItem: this.handleClickThumb,
        selectedItem: this.state.selectedItem,
        transitionTime: this.props.transitionTime,
        thumbWidth: this.props.thumbWidth,
        labels: this.props.labels,
        emulateTouch: this.props.emulateTouch
      }, this.props.renderThumbs(this.props.children));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (!this.props.children || _react.Children.count(this.props.children) === 0) {
        return null;
      }

      var isSwipeable = this.props.swipeable && _react.Children.count(this.props.children) > 1;
      var isHorizontal = this.props.axis === 'horizontal';
      var canShowArrows = this.props.showArrows && _react.Children.count(this.props.children) > 1; // show left arrow?

      var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop) || false; // show right arrow

      var hasNext = canShowArrows && (this.state.selectedItem < _react.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || false;
      var itemsClone = this.renderItems(true);
      var firstClone = itemsClone.shift();
      var lastClone = itemsClone.pop();
      var swiperProps = {
        className: _cssClasses.default.SLIDER(true, this.state.swiping),
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: this.state.itemListStyle,
        tolerance: this.props.swipeScrollTolerance
      };
      var containerStyles = {};

      if (isHorizontal) {
        swiperProps.onSwipeLeft = this.onSwipeForward;
        swiperProps.onSwipeRight = this.onSwipeBackwards;

        if (this.props.dynamicHeight) {
          var itemHeight = this.getVariableItemHeight(this.state.selectedItem); // swiperProps.style.height = itemHeight || 'auto';

          containerStyles.height = itemHeight || 'auto';
        }
      } else {
        swiperProps.onSwipeUp = this.props.verticalSwipe === 'natural' ? this.onSwipeBackwards : this.onSwipeForward;
        swiperProps.onSwipeDown = this.props.verticalSwipe === 'natural' ? this.onSwipeForward : this.onSwipeBackwards;
        swiperProps.style = _objectSpread(_objectSpread({}, swiperProps.style), {}, {
          height: this.state.itemSize
        });
        containerStyles.height = this.state.itemSize;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        "aria-label": this.props.ariaLabel,
        className: _cssClasses.default.ROOT(this.props.className),
        ref: this.setCarouselWrapperRef,
        tabIndex: this.props.useKeyboardArrows ? 0 : undefined
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.CAROUSEL(true),
        style: {
          width: this.props.width
        }
      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, hasPrev, this.props.labels.leftArrow), /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.WRAPPER(true, this.props.axis),
        style: containerStyles
      }, isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, _extends({
        tagName: "ul",
        innerRef: this.setListRef
      }, swiperProps, {
        allowMouseEvents: this.props.emulateTouch
      }), this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone) : /*#__PURE__*/_react.default.createElement("ul", {
        className: _cssClasses.default.SLIDER(true, this.state.swiping),
        ref: function ref(node) {
          return _this5.setListRef(node);
        },
        style: this.state.itemListStyle || {}
      }, this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone)), this.props.renderArrowNext(this.onClickNext, hasNext, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
    }
  }]);

  return Carousel;
}(_react.default.Component);

exports["default"] = Carousel;

_defineProperty(Carousel, "displayName", 'Carousel');

_defineProperty(Carousel, "defaultProps", {
  ariaLabel: undefined,
  axis: 'horizontal',
  centerSlidePercentage: 80,
  interval: 3000,
  labels: {
    leftArrow: 'previous slide / item',
    rightArrow: 'next slide / item',
    item: 'slide item'
  },
  onClickItem: _utils.noop,
  onClickThumb: _utils.noop,
  onChange: _utils.noop,
  onSwipeStart: function onSwipeStart() {},
  onSwipeEnd: function onSwipeEnd() {},
  onSwipeMove: function onSwipeMove() {
    return false;
  },
  preventMovementUntilSwipeScrollTolerance: false,
  renderArrowPrev: function renderArrowPrev(onClickHandler, hasPrev, label) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": label,
      className: _cssClasses.default.ARROW_PREV(!hasPrev),
      onClick: onClickHandler
    });
  },
  renderArrowNext: function renderArrowNext(onClickHandler, hasNext, label) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": label,
      className: _cssClasses.default.ARROW_NEXT(!hasNext),
      onClick: onClickHandler
    });
  },
  renderIndicator: function renderIndicator(onClickHandler, isSelected, index, label) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: _cssClasses.default.DOT(isSelected),
      onClick: onClickHandler,
      onKeyDown: onClickHandler,
      value: index,
      key: index,
      role: "button",
      tabIndex: 0,
      "aria-label": "".concat(label, " ").concat(index + 1)
    });
  },
  renderItem: function renderItem(item) {
    return item;
  },
  renderThumbs: function renderThumbs(children) {
    var images = _react.Children.map(children, function (item) {
      var img = item; // if the item is not an image, try to find the first image in the item's children.

      if (item.type !== 'img') {
        img = _react.Children.toArray(item.props.children).find(function (children) {
          return children.type === 'img';
        });
      }

      if (!img) {
        return undefined;
      }

      return img;
    });

    if (images.filter(function (image) {
      return image;
    }).length === 0) {
      console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md");
      return [];
    }

    return images;
  },
  statusFormatter: _utils.defaultStatusFormatter,
  selectedItem: 0,
  showArrows: true,
  showIndicators: true,
  showStatus: true,
  showThumbs: true,
  stopOnHover: true,
  swipeScrollTolerance: 5,
  swipeable: true,
  transitionTime: 350,
  verticalSwipe: 'standard',
  width: '100%',
  animationHandler: 'slide',
  swipeAnimationHandler: _animations.slideSwipeAnimationHandler,
  stopSwipingHandler: _animations.slideStopSwipingHandler
});

/***/ }),

/***/ 12768:
/***/ (function() {

"use strict";


/***/ }),

/***/ 78011:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.setPosition = exports.getPosition = exports.isKeyboardEvent = exports.defaultStatusFormatter = exports.noop = void 0;

var _react = __webpack_require__(2784);

var _CSSTranslate = _interopRequireDefault(__webpack_require__(84581));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

exports.noop = noop;

var defaultStatusFormatter = function defaultStatusFormatter(current, total) {
  return "".concat(current, " of ").concat(total);
};

exports.defaultStatusFormatter = defaultStatusFormatter;

var isKeyboardEvent = function isKeyboardEvent(e) {
  return e ? e.hasOwnProperty('key') : false;
};
/**
 * Gets the list 'position' relative to a current index
 * @param index
 */


exports.isKeyboardEvent = isKeyboardEvent;

var getPosition = function getPosition(index, props) {
  if (props.infiniteLoop) {
    // index has to be added by 1 because of the first cloned slide
    ++index;
  }

  if (index === 0) {
    return 0;
  }

  var childrenLength = _react.Children.count(props.children);

  if (props.centerMode && props.axis === 'horizontal') {
    var currentPosition = -index * props.centerSlidePercentage;
    var lastPosition = childrenLength - 1;

    if (index && (index !== lastPosition || props.infiniteLoop)) {
      currentPosition += (100 - props.centerSlidePercentage) / 2;
    } else if (index === lastPosition) {
      currentPosition += 100 - props.centerSlidePercentage;
    }

    return currentPosition;
  }

  return -index * 100;
};
/**
 * Sets the 'position' transform for sliding animations
 * @param position
 * @param forceReflow
 */


exports.getPosition = getPosition;

var setPosition = function setPosition(position, axis) {
  var style = {};
  ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
    // @ts-ignore
    style[prop] = (0, _CSSTranslate.default)(position, '%', axis);
  });
  return style;
};

exports.setPosition = setPosition;

/***/ }),

/***/ 6578:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(2784));

var _cssClasses = _interopRequireDefault(__webpack_require__(72222));

var _dimensions = __webpack_require__(26014);

var _CSSTranslate = _interopRequireDefault(__webpack_require__(84581));

var _reactEasySwipe = _interopRequireDefault(__webpack_require__(46075));

var _window = _interopRequireDefault(__webpack_require__(60694));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isKeyboardEvent = function isKeyboardEvent(e) {
  return e.hasOwnProperty('key');
};

var Thumbs = /*#__PURE__*/function (_Component) {
  _inherits(Thumbs, _Component);

  var _super = _createSuper(Thumbs);

  function Thumbs(_props) {
    var _this;

    _classCallCheck(this, Thumbs);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "itemsWrapperRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "itemsListRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "setItemsWrapperRef", function (node) {
      _this.itemsWrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setItemsListRef", function (node) {
      _this.itemsListRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node, index) {
      if (!_this.thumbsRef) {
        _this.thumbsRef = [];
      }

      _this.thumbsRef[index] = node;
    });

    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
      if (!_this.props.children || !_this.itemsWrapperRef || !_this.thumbsRef) {
        return;
      }

      var total = _react.Children.count(_this.props.children);

      var wrapperSize = _this.itemsWrapperRef.clientWidth;
      var itemSize = _this.props.thumbWidth ? _this.props.thumbWidth : (0, _dimensions.outerWidth)(_this.thumbsRef[0]);
      var visibleItems = Math.floor(wrapperSize / itemSize);
      var showArrows = visibleItems < total;
      var lastPosition = showArrows ? total - visibleItems : 0;

      _this.setState(function (_state, props) {
        return {
          itemSize: itemSize,
          visibleItems: visibleItems,
          firstItem: showArrows ? _this.getFirstItem(props.selectedItem) : 0,
          lastPosition: lastPosition,
          showArrows: showArrows
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item, e) {
      if (!isKeyboardEvent(e) || e.key === 'Enter') {
        var handler = _this.props.onSelectItem;

        if (typeof handler === 'function') {
          handler(index, item);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function () {
      _this.setState({
        swiping: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function () {
      _this.setState({
        swiping: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta) {
      var deltaX = delta.x;

      if (!_this.state.itemSize || !_this.itemsWrapperRef || !_this.state.visibleItems) {
        return false;
      }

      var leftBoundary = 0;

      var childrenLength = _react.Children.count(_this.props.children);

      var currentPosition = -(_this.state.firstItem * 100) / _this.state.visibleItems;
      var lastLeftItem = Math.max(childrenLength - _this.state.visibleItems, 0);
      var lastLeftBoundary = -lastLeftItem * 100 / _this.state.visibleItems; // prevent user from swiping left out of boundaries

      if (currentPosition === leftBoundary && deltaX > 0) {
        deltaX = 0;
      } // prevent user from swiping right out of boundaries


      if (currentPosition === lastLeftBoundary && deltaX < 0) {
        deltaX = 0;
      }

      var wrapperSize = _this.itemsWrapperRef.clientWidth;
      var position = currentPosition + 100 / (wrapperSize / deltaX); // if 3d isn't available we will use left to move

      if (_this.itemsListRef) {
        ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
          _this.itemsListRef.style[prop] = (0, _CSSTranslate.default)(position, '%', _this.props.axis);
        });
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "slideRight", function (positions) {
      _this.moveTo(_this.state.firstItem - (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "slideLeft", function (positions) {
      _this.moveTo(_this.state.firstItem + (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
      // position can't be lower than 0
      position = position < 0 ? 0 : position; // position can't be higher than last postion

      position = position >= _this.state.lastPosition ? _this.state.lastPosition : position;

      _this.setState({
        firstItem: position
      });
    });

    _this.state = {
      selectedItem: _props.selectedItem,
      swiping: false,
      showArrows: false,
      firstItem: 0,
      visibleItems: 0,
      lastPosition: 0
    };
    return _this;
  }

  _createClass(Thumbs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupThumbs();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.selectedItem !== this.state.selectedItem) {
        this.setState({
          selectedItem: this.props.selectedItem,
          firstItem: this.getFirstItem(this.props.selectedItem)
        });
      }

      if (this.props.children === prevProps.children) {
        return;
      } // This will capture any size changes for arrow adjustments etc.
      // usually in the same render cycle so we don't see any flickers


      this.updateSizes();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyThumbs();
    }
  }, {
    key: "setupThumbs",
    value: function setupThumbs() {
      // as the widths are calculated, we need to resize
      // the carousel when the window is resized
      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes); // when the component is rendered we need to calculate
      // the container size to adjust the responsive behaviour

      this.updateSizes();
    }
  }, {
    key: "destroyThumbs",
    value: function destroyThumbs() {
      // removing listeners
      (0, _window.default)().removeEventListener('resize', this.updateSizes);
      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
    }
  }, {
    key: "getFirstItem",
    value: function getFirstItem(selectedItem) {
      var firstItem = selectedItem;

      if (selectedItem >= this.state.lastPosition) {
        firstItem = this.state.lastPosition;
      }

      if (selectedItem < this.state.firstItem + this.state.visibleItems) {
        firstItem = this.state.firstItem;
      }

      if (selectedItem < this.state.firstItem) {
        firstItem = selectedItem;
      }

      return firstItem;
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      return this.props.children.map(function (img, index) {
        var itemClass = _cssClasses.default.ITEM(false, index === _this2.state.selectedItem);

        var thumbProps = {
          key: index,
          ref: function ref(e) {
            return _this2.setThumbsRef(e, index);
          },
          className: itemClass,
          onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
          onKeyDown: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
          'aria-label': "".concat(_this2.props.labels.item, " ").concat(index + 1),
          style: {
            width: _this2.props.thumbWidth
          }
        };
        return /*#__PURE__*/_react.default.createElement("li", _extends({}, thumbProps, {
          role: "button",
          tabIndex: 0
        }), img);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (!this.props.children) {
        return null;
      }

      var isSwipeable = _react.Children.count(this.props.children) > 1; // show left arrow?

      var hasPrev = this.state.showArrows && this.state.firstItem > 0; // show right arrow

      var hasNext = this.state.showArrows && this.state.firstItem < this.state.lastPosition; // obj to hold the transformations and styles

      var itemListStyles = {};
      var currentPosition = -this.state.firstItem * (this.state.itemSize || 0);
      var transformProp = (0, _CSSTranslate.default)(currentPosition, 'px', this.props.axis);
      var transitionTime = this.props.transitionTime + 'ms';
      itemListStyles = {
        WebkitTransform: transformProp,
        MozTransform: transformProp,
        MsTransform: transformProp,
        OTransform: transformProp,
        transform: transformProp,
        msTransform: transformProp,
        WebkitTransitionDuration: transitionTime,
        MozTransitionDuration: transitionTime,
        MsTransitionDuration: transitionTime,
        OTransitionDuration: transitionTime,
        transitionDuration: transitionTime,
        msTransitionDuration: transitionTime
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.CAROUSEL(false)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.WRAPPER(false),
        ref: this.setItemsWrapperRef
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: _cssClasses.default.ARROW_PREV(!hasPrev),
        onClick: function onClick() {
          return _this3.slideRight();
        },
        "aria-label": this.props.labels.leftArrow
      }), isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, {
        tagName: "ul",
        className: _cssClasses.default.SLIDER(false, this.state.swiping),
        onSwipeLeft: this.slideLeft,
        onSwipeRight: this.slideRight,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: itemListStyles,
        innerRef: this.setItemsListRef,
        allowMouseEvents: this.props.emulateTouch
      }, this.renderItems()) : /*#__PURE__*/_react.default.createElement("ul", {
        className: _cssClasses.default.SLIDER(false, this.state.swiping),
        ref: function ref(node) {
          return _this3.setItemsListRef(node);
        },
        style: itemListStyles
      }, this.renderItems()), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: _cssClasses.default.ARROW_NEXT(!hasNext),
        onClick: function onClick() {
          return _this3.slideLeft();
        },
        "aria-label": this.props.labels.rightArrow
      })));
    }
  }]);

  return Thumbs;
}(_react.Component);

exports["default"] = Thumbs;

_defineProperty(Thumbs, "displayName", 'Thumbs');

_defineProperty(Thumbs, "defaultProps", {
  axis: 'horizontal',
  labels: {
    leftArrow: 'previous slide / item',
    rightArrow: 'next slide / item',
    item: 'slide item'
  },
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 350
});

/***/ }),

/***/ 72222:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _classnames = _interopRequireDefault(__webpack_require__(72779));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  ROOT: function ROOT(customClassName) {
    return (0, _classnames.default)(_defineProperty({
      'carousel-root': true
    }, customClassName || '', !!customClassName));
  },
  CAROUSEL: function CAROUSEL(isSlider) {
    return (0, _classnames.default)({
      carousel: true,
      'carousel-slider': isSlider
    });
  },
  WRAPPER: function WRAPPER(isSlider, axis) {
    return (0, _classnames.default)({
      'thumbs-wrapper': !isSlider,
      'slider-wrapper': isSlider,
      'axis-horizontal': axis === 'horizontal',
      'axis-vertical': axis !== 'horizontal'
    });
  },
  SLIDER: function SLIDER(isSlider, isSwiping) {
    return (0, _classnames.default)({
      thumbs: !isSlider,
      slider: isSlider,
      animated: !isSwiping
    });
  },
  ITEM: function ITEM(isSlider, selected, previous) {
    return (0, _classnames.default)({
      thumb: !isSlider,
      slide: isSlider,
      selected: selected,
      previous: previous
    });
  },
  ARROW_PREV: function ARROW_PREV(disabled) {
    return (0, _classnames.default)({
      'control-arrow control-prev': true,
      'control-disabled': disabled
    });
  },
  ARROW_NEXT: function ARROW_NEXT(disabled) {
    return (0, _classnames.default)({
      'control-arrow control-next': true,
      'control-disabled': disabled
    });
  },
  DOT: function DOT(selected) {
    return (0, _classnames.default)({
      dot: true,
      selected: selected
    });
  }
};
exports["default"] = _default;

/***/ }),

/***/ 26014:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.outerWidth = void 0;

var outerWidth = function outerWidth(el) {
  var width = el.offsetWidth;
  var style = getComputedStyle(el);
  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return width;
};

exports.outerWidth = outerWidth;

/***/ }),

/***/ 11445:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _Carousel.default;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _types.CarouselProps;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _Thumbs.default;
  }
});

var _Carousel = _interopRequireDefault(__webpack_require__(91634));

var _types = __webpack_require__(12768);

var _Thumbs = _interopRequireDefault(__webpack_require__(6578));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 81081:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _default = function _default() {
  return document;
};

exports["default"] = _default;

/***/ }),

/***/ 60694:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _default = function _default() {
  return window;
};

exports["default"] = _default;

/***/ }),

/***/ 55497:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(90679);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports["default"] = (0, _scrollLink2.default)(ButtonElement);

/***/ }),

/***/ 92276:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(29942);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports["default"] = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),

/***/ 98824:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(90679);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports["default"] = (0, _scrollLink2.default)(LinkElement);

/***/ }),

/***/ 70423:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.NY = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.rU = undefined;

var _Link = __webpack_require__(98824);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(55497);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(92276);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(73123);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(90496);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(70752);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(27793);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(90679);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(29942);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(9465);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.rU = _Link2.default;
__webpack_unused_export__ = _Button2.default;
__webpack_unused_export__ = _Element2.default;
__webpack_unused_export__ = _scroller2.default;
__webpack_unused_export__ = _scrollEvents2.default;
__webpack_unused_export__ = _scrollSpy2.default;
exports.NY = _animateScroll2.default;
__webpack_unused_export__ = _scrollLink2.default;
__webpack_unused_export__ = _scrollElement2.default;
__webpack_unused_export__ = _Helpers2.default;
__webpack_unused_export__ = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),

/***/ 9465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(2784);
var ReactDOM = __webpack_require__(28316);

var utils = __webpack_require__(40659);
var scrollSpy = __webpack_require__(70752);
var defaultScroller = __webpack_require__(73123);
var PropTypes = __webpack_require__(13980);
var scrollHash = __webpack_require__(67654);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool,
  spyThrottle: PropTypes.number
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),

/***/ 27793:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(40659);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(32684);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(7050);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(90496);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

exports["default"] = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),

/***/ 7050:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(32165);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports["default"] = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),

/***/ 32165:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),

/***/ 29942:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28316);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(73123);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports["default"] = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),

/***/ 90496:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
	value: true
}));

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports["default"] = Events;

/***/ }),

/***/ 67654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(32165);

var _utils = __webpack_require__(40659);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports["default"] = scrollHash;

/***/ }),

/***/ 90679:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(70752);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(73123);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(67654);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  activeStyle: _propTypes2.default.object,
  spy: _propTypes2.default.bool,
  horizontal: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool,
  saveHashHistory: _propTypes2.default.bool,
  spyThrottle: _propTypes2.default.number
};

exports["default"] = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var style = {};

        if (this.state && this.state.active) {
          style = _extends({}, this.props.style, this.props.activeStyle);
        } else {
          style = _extends({}, this.props.style);
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.style = style;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();
          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;
        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),

/***/ 70752:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _lodash = __webpack_require__(98357);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(32165);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
  var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
  return (0, _lodash2.default)(eventHandler, throttleAmount);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer, throttle) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      }, throttle);
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageYOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length && scrollSpy.spySetState.indexOf(stateHandler) > -1) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports["default"] = scrollSpy;

/***/ }),

/***/ 73123:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(40659);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(27793);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(90496);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports["default"] = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),

/***/ 32684:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

exports["default"] = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),

/***/ 86748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ react_select_esm; }
});

// UNUSED EXPORTS: NonceProvider, components, createFilter, defaultTheme, mergeStyles, useStateManager

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function objectSpread2_objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,objectWithoutPropertiesLoose/* default */.Z)(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
;// CONCATENATED MODULE: ../../node_modules/react-select/dist/useStateManager-7e1e8489.esm.js





var _excluded = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref) {
  var _ref$defaultInputValu = _ref.defaultInputValue,
    defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
    _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
    defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    propsInputValue = _ref.inputValue,
    propsMenuIsOpen = _ref.menuIsOpen,
    propsOnChange = _ref.onChange,
    propsOnInputChange = _ref.onInputChange,
    propsOnMenuClose = _ref.onMenuClose,
    propsOnMenuOpen = _ref.onMenuOpen,
    propsValue = _ref.value,
    restSelectProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
    _useState2 = _slicedToArray(_useState, 2),
    stateInputValue = _useState2[0],
    setStateInputValue = _useState2[1];
  var _useState3 = (0,react.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
    _useState4 = _slicedToArray(_useState3, 2),
    stateMenuIsOpen = _useState4[0],
    setStateMenuIsOpen = _useState4[1];
  var _useState5 = (0,react.useState)(propsValue !== undefined ? propsValue : defaultValue),
    _useState6 = _slicedToArray(_useState5, 2),
    stateValue = _useState6[0],
    setStateValue = _useState6[1];
  var onChange = (0,react.useCallback)(function (value, actionMeta) {
    if (typeof propsOnChange === 'function') {
      propsOnChange(value, actionMeta);
    }
    setStateValue(value);
  }, [propsOnChange]);
  var onInputChange = (0,react.useCallback)(function (value, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === 'function') {
      newValue = propsOnInputChange(value, actionMeta);
    }
    setStateInputValue(newValue !== undefined ? newValue : value);
  }, [propsOnInputChange]);
  var onMenuOpen = (0,react.useCallback)(function () {
    if (typeof propsOnMenuOpen === 'function') {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = (0,react.useCallback)(function () {
    if (typeof propsOnMenuClose === 'function') {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== undefined ? propsValue : stateValue;
  return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}



// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/createSuper.js



function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
;// CONCATENATED MODULE: ../../node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ../../node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset: if (ampersand == -1) characters = Utility_replace(characters, /\f/g, '')
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ../../node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var emotion_cache_browser_esm_createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (emotion_cache_browser_esm_createCache);

;// CONCATENATED MODULE: ../../node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function emotion_utils_browser_esm_getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var emotion_utils_browser_esm_registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var emotion_utils_browser_esm_insertStyles = function insertStyles(cache, serialized, isStringTag) {
  emotion_utils_browser_esm_registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ../../node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var emotion_hash_esm = (murmur2);

;// CONCATENATED MODULE: ../../node_modules/@emotion/serialize/node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var emotion_unitless_esm = (unitlessKeys);

// EXTERNAL MODULE: ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(86894);
;// CONCATENATED MODULE: ../../node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (emotion_unitless_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var emotion_serialize_browser_esm_serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = emotion_hash_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ../../node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js



var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = react_namespaceObject['useInsertion' + 'Effect'] ? react_namespaceObject['useInsertion' + 'Effect'] : false;
var emotion_use_insertion_effect_with_fallbacks_browser_esm_useInsertionEffectAlwaysWithSyncFallback =  useInsertionEffect || syncFallback;
var emotion_use_insertion_effect_with_fallbacks_browser_esm_useInsertionEffectWithLayoutFallback = useInsertionEffect || react.useLayoutEffect;



;// CONCATENATED MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js









var emotion_element_6a883da9_browser_esm_hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */emotion_cache_browser_esm({
  key: 'css'
}) : null);

if (false) {}

var emotion_element_6a883da9_browser_esm_CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var emotion_element_6a883da9_browser_esm_withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var emotion_element_6a883da9_browser_esm_ThemeContext = /* #__PURE__ */(0,react.createContext)({});

if (false) {}

var useTheme = function useTheme() {
  return useContext(emotion_element_6a883da9_browser_esm_ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = useContext(emotion_element_6a883da9_browser_esm_ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/createElement(emotion_element_6a883da9_browser_esm_ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = useContext(emotion_element_6a883da9_browser_esm_ThemeContext);
    return /*#__PURE__*/createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_6a883da9_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  emotion_utils_browser_esm_registerStyles(cache, serialized, isStringTag);
  var rules = emotion_use_insertion_effect_with_fallbacks_browser_esm_useInsertionEffectAlwaysWithSyncFallback(function () {
    return emotion_utils_browser_esm_insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */emotion_element_6a883da9_browser_esm_withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = emotion_utils_browser_esm_getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = emotion_serialize_browser_esm_serializeStyles(registeredStyles, undefined, (0,react.useContext)(emotion_element_6a883da9_browser_esm_ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_6a883da9_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, /*#__PURE__*/(0,react.createElement)(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/(0,react.createElement)(WrappedComponent, newProps));
});

if (false) {}



// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
;// CONCATENATED MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js












var pkg = {
	name: "@emotion/react",
	version: "11.10.8",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": "./macro.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.10.8",
		"@emotion/cache": "^11.10.8",
		"@emotion/serialize": "^1.1.1",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
		"@emotion/utils": "^1.2.0",
		"@emotion/weak-memoize": "^0.3.0",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.10.8",
		"@emotion/css-prettifier": "1.1.2",
		"@emotion/server": "11.10.0",
		"@emotion/styled": "11.10.8",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": "./macro.js"
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !emotion_element_6a883da9_browser_esm_hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return react.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, useContext(ThemeContext));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = useRef();
  useInsertionEffectWithLayoutFallback(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
})));

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return emotion_serialize_browser_esm_serializeStyles(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var emotion_react_browser_esm_Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(emotion_react_browser_esm_Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));

if (false) {}

if (false) { var globalKey, globalContext, isTestEnv, emotion_react_browser_esm_isBrowser; }



;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
function t(t){return t.split("-")[1]}function floating_ui_core_browser_min_e(t){return"y"===t?"height":"width"}function n(t){return t.split("-")[0]}function o(t){return["top","bottom"].includes(n(t))?"x":"y"}function i(i,r,a){let{reference:l,floating:s}=i;const c=l.x+l.width/2-s.width/2,f=l.y+l.height/2-s.height/2,m=o(r),u=floating_ui_core_browser_min_e(m),g=l[u]/2-s[u]/2,d="x"===m;let p;switch(n(r)){case"top":p={x:c,y:l.y-s.height};break;case"bottom":p={x:c,y:l.y+l.height};break;case"right":p={x:l.x+l.width,y:f};break;case"left":p={x:l.x-s.width,y:f};break;default:p={x:l.x,y:l.y}}switch(t(r)){case"start":p[m]-=g*(a&&d?-1:1);break;case"end":p[m]+=g*(a&&d?-1:1)}return p}const r=async(t,e,n)=>{const{placement:o="bottom",strategy:r="absolute",middleware:a=[],platform:l}=n,s=a.filter(Boolean),c=await(null==l.isRTL?void 0:l.isRTL(e));let f=await l.getElementRects({reference:t,floating:e,strategy:r}),{x:m,y:u}=i(f,o,c),g=o,d={},p=0;for(let n=0;n<s.length;n++){const{name:a,fn:h}=s[n],{x:y,y:x,data:w,reset:v}=await h({x:m,y:u,initialPlacement:o,placement:g,strategy:r,middlewareData:d,rects:f,platform:l,elements:{reference:t,floating:e}});m=null!=y?y:m,u=null!=x?x:u,d={...d,[a]:{...d[a],...w}},v&&p<=50&&(p++,"object"==typeof v&&(v.placement&&(g=v.placement),v.rects&&(f=!0===v.rects?await l.getElementRects({reference:t,floating:e,strategy:r}):v.rects),({x:m,y:u}=i(f,g,c))),n=-1)}return{x:m,y:u,placement:g,strategy:r,middlewareData:d}};function a(t){return"number"!=typeof t?function(t){return{top:0,right:0,bottom:0,left:0,...t}}(t):{top:t,right:t,bottom:t,left:t}}function floating_ui_core_browser_min_l(t){return{...t,top:t.y,left:t.x,right:t.x+t.width,bottom:t.y+t.height}}async function s(t,e){var n;void 0===e&&(e={});const{x:o,y:i,platform:r,rects:s,elements:c,strategy:f}=t,{boundary:m="clippingAncestors",rootBoundary:u="viewport",elementContext:g="floating",altBoundary:d=!1,padding:p=0}=e,h=a(p),y=c[d?"floating"===g?"reference":"floating":g],x=floating_ui_core_browser_min_l(await r.getClippingRect({element:null==(n=await(null==r.isElement?void 0:r.isElement(y)))||n?y:y.contextElement||await(null==r.getDocumentElement?void 0:r.getDocumentElement(c.floating)),boundary:m,rootBoundary:u,strategy:f})),w="floating"===g?{...s.floating,x:o,y:i}:s.reference,v=await(null==r.getOffsetParent?void 0:r.getOffsetParent(c.floating)),b=await(null==r.isElement?void 0:r.isElement(v))&&await(null==r.getScale?void 0:r.getScale(v))||{x:1,y:1},A=floating_ui_core_browser_min_l(r.convertOffsetParentRelativeRectToViewportRelativeRect?await r.convertOffsetParentRelativeRectToViewportRelativeRect({rect:w,offsetParent:v,strategy:f}):w);return{top:(x.top-A.top+h.top)/b.y,bottom:(A.bottom-x.bottom+h.bottom)/b.y,left:(x.left-A.left+h.left)/b.x,right:(A.right-x.right+h.right)/b.x}}const c=Math.min,f=Math.max;function m(t,e,n){return f(t,c(e,n))}const u=n=>({name:"arrow",options:n,async fn(i){const{element:r,padding:l=0}=n||{},{x:s,y:c,placement:f,rects:u,platform:g,elements:d}=i;if(null==r)return{};const p=a(l),h={x:s,y:c},y=o(f),x=floating_ui_core_browser_min_e(y),w=await g.getDimensions(r),v="y"===y,b=v?"top":"left",A=v?"bottom":"right",R=v?"clientHeight":"clientWidth",P=u.reference[x]+u.reference[y]-h[y]-u.floating[x],E=h[y]-u.reference[y],T=await(null==g.getOffsetParent?void 0:g.getOffsetParent(r));let D=T?T[R]:0;D&&await(null==g.isElement?void 0:g.isElement(T))||(D=d.floating[R]||u.floating[x]);const L=P/2-E/2,k=p[b],O=D-w[x]-p[A],B=D/2-w[x]/2+L,C=m(k,B,O),H=null!=t(f)&&B!=C&&u.reference[x]/2-(B<k?p[b]:p[A])-w[x]/2<0;return{[y]:h[y]-(H?B<k?k-B:O-B:0),data:{[y]:C,centerOffset:B-C}}}}),g=["top","right","bottom","left"],d=g.reduce(((t,e)=>t.concat(e,e+"-start",e+"-end")),[]),p={left:"right",right:"left",bottom:"top",top:"bottom"};function h(t){return t.replace(/left|right|bottom|top/g,(t=>p[t]))}function y(n,i,r){void 0===r&&(r=!1);const a=t(n),l=o(n),s=floating_ui_core_browser_min_e(l);let c="x"===l?a===(r?"end":"start")?"right":"left":"start"===a?"bottom":"top";return i.reference[s]>i.floating[s]&&(c=h(c)),{main:c,cross:h(c)}}const x={start:"end",end:"start"};function w(t){return t.replace(/start|end/g,(t=>x[t]))}const v=function(e){return void 0===e&&(e={}),{name:"autoPlacement",options:e,async fn(o){var i,r,a;const{rects:l,middlewareData:c,placement:f,platform:m,elements:u}=o,{crossAxis:g=!1,alignment:p,allowedPlacements:h=d,autoAlignment:x=!0,...v}=e,b=void 0!==p||h===d?function(e,o,i){return(e?[...i.filter((n=>t(n)===e)),...i.filter((n=>t(n)!==e))]:i.filter((t=>n(t)===t))).filter((n=>!e||t(n)===e||!!o&&w(n)!==n))}(p||null,x,h):h,A=await s(o,v),R=(null==(i=c.autoPlacement)?void 0:i.index)||0,P=b[R];if(null==P)return{};const{main:E,cross:T}=y(P,l,await(null==m.isRTL?void 0:m.isRTL(u.floating)));if(f!==P)return{reset:{placement:b[0]}};const D=[A[n(P)],A[E],A[T]],L=[...(null==(r=c.autoPlacement)?void 0:r.overflows)||[],{placement:P,overflows:D}],k=b[R+1];if(k)return{data:{index:R+1,overflows:L},reset:{placement:k}};const O=L.map((e=>{const n=t(e.placement);return[e.placement,n&&g?e.overflows.slice(0,2).reduce(((t,e)=>t+e),0):e.overflows[0],e.overflows]})).sort(((t,e)=>t[1]-e[1])),B=(null==(a=O.filter((e=>e[2].slice(0,t(e[0])?2:3).every((t=>t<=0))))[0])?void 0:a[0])||O[0][0];return B!==f?{data:{index:R+1,overflows:L},reset:{placement:B}}:{}}}};const b=function(e){return void 0===e&&(e={}),{name:"flip",options:e,async fn(o){var i;const{placement:r,middlewareData:a,rects:l,initialPlacement:c,platform:f,elements:m}=o,{mainAxis:u=!0,crossAxis:g=!0,fallbackPlacements:d,fallbackStrategy:p="bestFit",fallbackAxisSideDirection:x="none",flipAlignment:v=!0,...b}=e,A=n(r),R=n(c)===c,P=await(null==f.isRTL?void 0:f.isRTL(m.floating)),E=d||(R||!v?[h(c)]:function(t){const e=h(t);return[w(t),e,w(e)]}(c));d||"none"===x||E.push(...function(e,o,i,r){const a=t(e);let l=function(t,e,n){const o=["left","right"],i=["right","left"],r=["top","bottom"],a=["bottom","top"];switch(t){case"top":case"bottom":return n?e?i:o:e?o:i;case"left":case"right":return e?r:a;default:return[]}}(n(e),"start"===i,r);return a&&(l=l.map((t=>t+"-"+a)),o&&(l=l.concat(l.map(w)))),l}(c,v,x,P));const T=[c,...E],D=await s(o,b),L=[];let k=(null==(i=a.flip)?void 0:i.overflows)||[];if(u&&L.push(D[A]),g){const{main:t,cross:e}=y(r,l,P);L.push(D[t],D[e])}if(k=[...k,{placement:r,overflows:L}],!L.every((t=>t<=0))){var O,B;const t=((null==(O=a.flip)?void 0:O.index)||0)+1,e=T[t];if(e)return{data:{index:t,overflows:k},reset:{placement:e}};let n=null==(B=k.filter((t=>t.overflows[0]<=0)).sort(((t,e)=>t.overflows[1]-e.overflows[1]))[0])?void 0:B.placement;if(!n)switch(p){case"bestFit":{var C;const t=null==(C=k.map((t=>[t.placement,t.overflows.filter((t=>t>0)).reduce(((t,e)=>t+e),0)])).sort(((t,e)=>t[1]-e[1]))[0])?void 0:C[0];t&&(n=t);break}case"initialPlacement":n=c}if(r!==n)return{reset:{placement:n}}}return{}}}};function A(t,e){return{top:t.top-e.height,right:t.right-e.width,bottom:t.bottom-e.height,left:t.left-e.width}}function R(t){return g.some((e=>t[e]>=0))}const P=function(t){return void 0===t&&(t={}),{name:"hide",options:t,async fn(e){const{strategy:n="referenceHidden",...o}=t,{rects:i}=e;switch(n){case"referenceHidden":{const t=A(await s(e,{...o,elementContext:"reference"}),i.reference);return{data:{referenceHiddenOffsets:t,referenceHidden:R(t)}}}case"escaped":{const t=A(await s(e,{...o,altBoundary:!0}),i.floating);return{data:{escapedOffsets:t,escaped:R(t)}}}default:return{}}}}};function E(t){const e=c(...t.map((t=>t.left))),n=c(...t.map((t=>t.top)));return{x:e,y:n,width:f(...t.map((t=>t.right)))-e,height:f(...t.map((t=>t.bottom)))-n}}const T=function(t){return void 0===t&&(t={}),{name:"inline",options:t,async fn(e){const{placement:i,elements:r,rects:s,platform:m,strategy:u}=e,{padding:g=2,x:d,y:p}=t,h=Array.from(await(null==m.getClientRects?void 0:m.getClientRects(r.reference))||[]),y=function(t){const e=t.slice().sort(((t,e)=>t.y-e.y)),n=[];let o=null;for(let t=0;t<e.length;t++){const i=e[t];!o||i.y-o.y>o.height/2?n.push([i]):n[n.length-1].push(i),o=i}return n.map((t=>floating_ui_core_browser_min_l(E(t))))}(h),x=floating_ui_core_browser_min_l(E(h)),w=a(g);const v=await m.getElementRects({reference:{getBoundingClientRect:function(){if(2===y.length&&y[0].left>y[1].right&&null!=d&&null!=p)return y.find((t=>d>t.left-w.left&&d<t.right+w.right&&p>t.top-w.top&&p<t.bottom+w.bottom))||x;if(y.length>=2){if("x"===o(i)){const t=y[0],e=y[y.length-1],o="top"===n(i),r=t.top,a=e.bottom,l=o?t.left:e.left,s=o?t.right:e.right;return{top:r,bottom:a,left:l,right:s,width:s-l,height:a-r,x:l,y:r}}const t="left"===n(i),e=f(...y.map((t=>t.right))),r=c(...y.map((t=>t.left))),a=y.filter((n=>t?n.left===r:n.right===e)),l=a[0].top,s=a[a.length-1].bottom;return{top:l,bottom:s,left:r,right:e,width:e-r,height:s-l,x:r,y:l}}return x}},floating:r.floating,strategy:u});return s.reference.x!==v.reference.x||s.reference.y!==v.reference.y||s.reference.width!==v.reference.width||s.reference.height!==v.reference.height?{reset:{rects:v}}:{}}}};const D=function(e){return void 0===e&&(e=0),{name:"offset",options:e,async fn(i){const{x:r,y:a}=i,l=await async function(e,i){const{placement:r,platform:a,elements:l}=e,s=await(null==a.isRTL?void 0:a.isRTL(l.floating)),c=n(r),f=t(r),m="x"===o(r),u=["left","top"].includes(c)?-1:1,g=s&&m?-1:1,d="function"==typeof i?i(e):i;let{mainAxis:p,crossAxis:h,alignmentAxis:y}="number"==typeof d?{mainAxis:d,crossAxis:0,alignmentAxis:null}:{mainAxis:0,crossAxis:0,alignmentAxis:null,...d};return f&&"number"==typeof y&&(h="end"===f?-1*y:y),m?{x:h*g,y:p*u}:{x:p*u,y:h*g}}(i,e);return{x:r+l.x,y:a+l.y,data:l}}}};function L(t){return"x"===t?"y":"x"}const k=function(t){return void 0===t&&(t={}),{name:"shift",options:t,async fn(e){const{x:i,y:r,placement:a}=e,{mainAxis:l=!0,crossAxis:c=!1,limiter:f={fn:t=>{let{x:e,y:n}=t;return{x:e,y:n}}},...u}=t,g={x:i,y:r},d=await s(e,u),p=o(n(a)),h=L(p);let y=g[p],x=g[h];if(l){const t="y"===p?"bottom":"right";y=m(y+d["y"===p?"top":"left"],y,y-d[t])}if(c){const t="y"===h?"bottom":"right";x=m(x+d["y"===h?"top":"left"],x,x-d[t])}const w=f.fn({...e,[p]:y,[h]:x});return{...w,data:{x:w.x-i,y:w.y-r}}}}},O=function(t){return void 0===t&&(t={}),{options:t,fn(e){const{x:i,y:r,placement:a,rects:l,middlewareData:s}=e,{offset:c=0,mainAxis:f=!0,crossAxis:m=!0}=t,u={x:i,y:r},g=o(a),d=L(g);let p=u[g],h=u[d];const y="function"==typeof c?c(e):c,x="number"==typeof y?{mainAxis:y,crossAxis:0}:{mainAxis:0,crossAxis:0,...y};if(f){const t="y"===g?"height":"width",e=l.reference[g]-l.floating[t]+x.mainAxis,n=l.reference[g]+l.reference[t]-x.mainAxis;p<e?p=e:p>n&&(p=n)}if(m){var w,v;const t="y"===g?"width":"height",e=["top","left"].includes(n(a)),o=l.reference[d]-l.floating[t]+(e&&(null==(w=s.offset)?void 0:w[d])||0)+(e?0:x.crossAxis),i=l.reference[d]+l.reference[t]+(e?0:(null==(v=s.offset)?void 0:v[d])||0)-(e?x.crossAxis:0);h<o?h=o:h>i&&(h=i)}return{[g]:p,[d]:h}}}},B=function(e){return void 0===e&&(e={}),{name:"size",options:e,async fn(i){const{placement:r,rects:a,platform:l,elements:m}=i,{apply:u=(()=>{}),...g}=e,d=await s(i,g),p=n(r),h=t(r),y="x"===o(r),{width:x,height:w}=a.floating;let v,b;"top"===p||"bottom"===p?(v=p,b=h===(await(null==l.isRTL?void 0:l.isRTL(m.floating))?"start":"end")?"left":"right"):(b=p,v="end"===h?"top":"bottom");const A=w-d[v],R=x-d[b],P=!i.middlewareData.shift;let E=A,T=R;if(y){const t=x-d.left-d.right;T=h||P?c(R,t):t}else{const t=w-d.top-d.bottom;E=h||P?c(A,t):t}if(P&&!h){const t=f(d.left,0),e=f(d.right,0),n=f(d.top,0),o=f(d.bottom,0);y?T=x-2*(0!==t||0!==e?t+e:f(d.left,d.right)):E=w-2*(0!==n||0!==o?n+o:f(d.top,d.bottom))}await u({...i,availableWidth:T,availableHeight:E});const D=await l.getDimensions(m.floating);return x!==D.width||w!==D.height?{reset:{rects:!0}}:{}}}};

;// CONCATENATED MODULE: ../../node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
function floating_ui_dom_browser_min_n(t){var e;return(null==(e=t.ownerDocument)?void 0:e.defaultView)||window}function floating_ui_dom_browser_min_o(t){return floating_ui_dom_browser_min_n(t).getComputedStyle(t)}function floating_ui_dom_browser_min_i(t){return t instanceof floating_ui_dom_browser_min_n(t).Node}function floating_ui_dom_browser_min_r(t){return floating_ui_dom_browser_min_i(t)?(t.nodeName||"").toLowerCase():""}let l;function floating_ui_dom_browser_min_c(){if(l)return l;const t=navigator.userAgentData;return t&&Array.isArray(t.brands)?(l=t.brands.map((t=>t.brand+"/"+t.version)).join(" "),l):navigator.userAgent}function floating_ui_dom_browser_min_s(t){return t instanceof floating_ui_dom_browser_min_n(t).HTMLElement}function floating_ui_dom_browser_min_f(t){return t instanceof floating_ui_dom_browser_min_n(t).Element}function floating_ui_dom_browser_min_u(t){if("undefined"==typeof ShadowRoot)return!1;return t instanceof floating_ui_dom_browser_min_n(t).ShadowRoot||t instanceof ShadowRoot}function floating_ui_dom_browser_min_a(t){const{overflow:e,overflowX:n,overflowY:i,display:r}=floating_ui_dom_browser_min_o(t);return/auto|scroll|overlay|hidden|clip/.test(e+i+n)&&!["inline","contents"].includes(r)}function floating_ui_dom_browser_min_d(t){return["table","td","th"].includes(floating_ui_dom_browser_min_r(t))}function floating_ui_dom_browser_min_h(t){const e=/firefox/i.test(floating_ui_dom_browser_min_c()),n=floating_ui_dom_browser_min_o(t),i=n.backdropFilter||n.WebkitBackdropFilter;return"none"!==n.transform||"none"!==n.perspective||!!i&&"none"!==i||e&&"filter"===n.willChange||e&&!!n.filter&&"none"!==n.filter||["transform","perspective"].some((t=>n.willChange.includes(t)))||["paint","layout","strict","content"].some((t=>{const e=n.contain;return null!=e&&e.includes(t)}))}function floating_ui_dom_browser_min_p(){return/^((?!chrome|android).)*safari/i.test(floating_ui_dom_browser_min_c())}function floating_ui_dom_browser_min_g(t){return["html","body","#document"].includes(floating_ui_dom_browser_min_r(t))}const floating_ui_dom_browser_min_m=Math.min,floating_ui_dom_browser_min_y=Math.max,floating_ui_dom_browser_min_x=Math.round;function floating_ui_dom_browser_min_w(t){const e=floating_ui_dom_browser_min_o(t);let n=parseFloat(e.width),i=parseFloat(e.height);const r=floating_ui_dom_browser_min_s(t),l=r?t.offsetWidth:n,c=r?t.offsetHeight:i,f=floating_ui_dom_browser_min_x(n)!==l||floating_ui_dom_browser_min_x(i)!==c;return f&&(n=l,i=c),{width:n,height:i,fallback:f}}function floating_ui_dom_browser_min_v(t){return floating_ui_dom_browser_min_f(t)?t:t.contextElement}const floating_ui_dom_browser_min_b={x:1,y:1};function floating_ui_dom_browser_min_L(t){const e=floating_ui_dom_browser_min_v(t);if(!floating_ui_dom_browser_min_s(e))return floating_ui_dom_browser_min_b;const n=e.getBoundingClientRect(),{width:o,height:i,fallback:r}=floating_ui_dom_browser_min_w(e);let l=(r?floating_ui_dom_browser_min_x(n.width):n.width)/o,c=(r?floating_ui_dom_browser_min_x(n.height):n.height)/i;return l&&Number.isFinite(l)||(l=1),c&&Number.isFinite(c)||(c=1),{x:l,y:c}}function floating_ui_dom_browser_min_E(e,o,i,r){var l,c;void 0===o&&(o=!1),void 0===i&&(i=!1);const s=e.getBoundingClientRect(),u=floating_ui_dom_browser_min_v(e);let a=floating_ui_dom_browser_min_b;o&&(r?floating_ui_dom_browser_min_f(r)&&(a=floating_ui_dom_browser_min_L(r)):a=floating_ui_dom_browser_min_L(e));const d=u?floating_ui_dom_browser_min_n(u):window,h=floating_ui_dom_browser_min_p()&&i;let g=(s.left+(h&&(null==(l=d.visualViewport)?void 0:l.offsetLeft)||0))/a.x,m=(s.top+(h&&(null==(c=d.visualViewport)?void 0:c.offsetTop)||0))/a.y,y=s.width/a.x,x=s.height/a.y;if(u){const t=floating_ui_dom_browser_min_n(u),e=r&&floating_ui_dom_browser_min_f(r)?floating_ui_dom_browser_min_n(r):r;let o=t.frameElement;for(;o&&r&&e!==t;){const t=floating_ui_dom_browser_min_L(o),e=o.getBoundingClientRect(),i=getComputedStyle(o);e.x+=(o.clientLeft+parseFloat(i.paddingLeft))*t.x,e.y+=(o.clientTop+parseFloat(i.paddingTop))*t.y,g*=t.x,m*=t.y,y*=t.x,x*=t.y,g+=e.x,m+=e.y,o=floating_ui_dom_browser_min_n(o).frameElement}}return floating_ui_core_browser_min_l({width:y,height:x,x:g,y:m})}function floating_ui_dom_browser_min_T(t){return((floating_ui_dom_browser_min_i(t)?t.ownerDocument:t.document)||window.document).documentElement}function floating_ui_dom_browser_min_R(t){return floating_ui_dom_browser_min_f(t)?{scrollLeft:t.scrollLeft,scrollTop:t.scrollTop}:{scrollLeft:t.pageXOffset,scrollTop:t.pageYOffset}}function C(t){return floating_ui_dom_browser_min_E(floating_ui_dom_browser_min_T(t)).left+floating_ui_dom_browser_min_R(t).scrollLeft}function F(t){if("html"===floating_ui_dom_browser_min_r(t))return t;const e=t.assignedSlot||t.parentNode||floating_ui_dom_browser_min_u(t)&&t.host||floating_ui_dom_browser_min_T(t);return floating_ui_dom_browser_min_u(e)?e.host:e}function S(t){const e=F(t);return floating_ui_dom_browser_min_g(e)?e.ownerDocument.body:floating_ui_dom_browser_min_s(e)&&floating_ui_dom_browser_min_a(e)?e:S(e)}function W(t,e){var o;void 0===e&&(e=[]);const i=S(t),r=i===(null==(o=t.ownerDocument)?void 0:o.body),l=floating_ui_dom_browser_min_n(i);return r?e.concat(l,l.visualViewport||[],floating_ui_dom_browser_min_a(i)?i:[]):e.concat(i,W(i))}function floating_ui_dom_browser_min_D(e,i,r){let l;if("viewport"===i)l=function(t,e){const o=floating_ui_dom_browser_min_n(t),i=floating_ui_dom_browser_min_T(t),r=o.visualViewport;let l=i.clientWidth,c=i.clientHeight,s=0,f=0;if(r){l=r.width,c=r.height;const t=floating_ui_dom_browser_min_p();(!t||t&&"fixed"===e)&&(s=r.offsetLeft,f=r.offsetTop)}return{width:l,height:c,x:s,y:f}}(e,r);else if("document"===i)l=function(t){const e=floating_ui_dom_browser_min_T(t),n=floating_ui_dom_browser_min_R(t),i=t.ownerDocument.body,r=floating_ui_dom_browser_min_y(e.scrollWidth,e.clientWidth,i.scrollWidth,i.clientWidth),l=floating_ui_dom_browser_min_y(e.scrollHeight,e.clientHeight,i.scrollHeight,i.clientHeight);let c=-n.scrollLeft+C(t);const s=-n.scrollTop;return"rtl"===floating_ui_dom_browser_min_o(i).direction&&(c+=floating_ui_dom_browser_min_y(e.clientWidth,i.clientWidth)-r),{width:r,height:l,x:c,y:s}}(floating_ui_dom_browser_min_T(e));else if(floating_ui_dom_browser_min_f(i))l=function(t,e){const n=floating_ui_dom_browser_min_E(t,!0,"fixed"===e),o=n.top+t.clientTop,i=n.left+t.clientLeft,r=floating_ui_dom_browser_min_s(t)?floating_ui_dom_browser_min_L(t):{x:1,y:1};return{width:t.clientWidth*r.x,height:t.clientHeight*r.y,x:i*r.x,y:o*r.y}}(i,r);else{const t={...i};if(floating_ui_dom_browser_min_p()){var c,u;const o=floating_ui_dom_browser_min_n(e);t.x-=(null==(c=o.visualViewport)?void 0:c.offsetLeft)||0,t.y-=(null==(u=o.visualViewport)?void 0:u.offsetTop)||0}l=t}return floating_ui_core_browser_min_l(l)}function V(t,e){const n=F(t);return!(n===e||!floating_ui_dom_browser_min_f(n)||floating_ui_dom_browser_min_g(n))&&("fixed"===floating_ui_dom_browser_min_o(n).position||V(n,e))}function floating_ui_dom_browser_min_A(t,e){return floating_ui_dom_browser_min_s(t)&&"fixed"!==floating_ui_dom_browser_min_o(t).position?e?e(t):t.offsetParent:null}function H(t,e){const i=floating_ui_dom_browser_min_n(t);if(!floating_ui_dom_browser_min_s(t))return i;let l=floating_ui_dom_browser_min_A(t,e);for(;l&&floating_ui_dom_browser_min_d(l)&&"static"===floating_ui_dom_browser_min_o(l).position;)l=floating_ui_dom_browser_min_A(l,e);return l&&("html"===floating_ui_dom_browser_min_r(l)||"body"===floating_ui_dom_browser_min_r(l)&&"static"===floating_ui_dom_browser_min_o(l).position&&!floating_ui_dom_browser_min_h(l))?i:l||function(t){let e=F(t);for(;floating_ui_dom_browser_min_s(e)&&!floating_ui_dom_browser_min_g(e);){if(floating_ui_dom_browser_min_h(e))return e;e=F(e)}return null}(t)||i}function floating_ui_dom_browser_min_O(t,e,n){const o=floating_ui_dom_browser_min_s(e),i=floating_ui_dom_browser_min_T(e),l=floating_ui_dom_browser_min_E(t,!0,"fixed"===n,e);let c={scrollLeft:0,scrollTop:0};const f={x:0,y:0};if(o||!o&&"fixed"!==n)if(("body"!==floating_ui_dom_browser_min_r(e)||floating_ui_dom_browser_min_a(i))&&(c=floating_ui_dom_browser_min_R(e)),floating_ui_dom_browser_min_s(e)){const t=floating_ui_dom_browser_min_E(e,!0);f.x=t.x+e.clientLeft,f.y=t.y+e.clientTop}else i&&(f.x=C(i));return{x:l.left+c.scrollLeft-f.x,y:l.top+c.scrollTop-f.y,width:l.width,height:l.height}}const floating_ui_dom_browser_min_P={getClippingRect:function(t){let{element:e,boundary:n,rootBoundary:i,strategy:l}=t;const c="clippingAncestors"===n?function(t,e){const n=e.get(t);if(n)return n;let i=W(t).filter((t=>floating_ui_dom_browser_min_f(t)&&"body"!==floating_ui_dom_browser_min_r(t))),l=null;const c="fixed"===floating_ui_dom_browser_min_o(t).position;let s=c?F(t):t;for(;floating_ui_dom_browser_min_f(s)&&!floating_ui_dom_browser_min_g(s);){const e=floating_ui_dom_browser_min_o(s),n=floating_ui_dom_browser_min_h(s);n||"fixed"!==e.position||(l=null),(c?!n&&!l:!n&&"static"===e.position&&l&&["absolute","fixed"].includes(l.position)||floating_ui_dom_browser_min_a(s)&&!n&&V(t,s))?i=i.filter((t=>t!==s)):l=e,s=F(s)}return e.set(t,i),i}(e,this._c):[].concat(n),s=[...c,i],u=s[0],d=s.reduce(((t,n)=>{const o=floating_ui_dom_browser_min_D(e,n,l);return t.top=floating_ui_dom_browser_min_y(o.top,t.top),t.right=floating_ui_dom_browser_min_m(o.right,t.right),t.bottom=floating_ui_dom_browser_min_m(o.bottom,t.bottom),t.left=floating_ui_dom_browser_min_y(o.left,t.left),t}),floating_ui_dom_browser_min_D(e,u,l));return{width:d.right-d.left,height:d.bottom-d.top,x:d.left,y:d.top}},convertOffsetParentRelativeRectToViewportRelativeRect:function(t){let{rect:e,offsetParent:n,strategy:o}=t;const i=floating_ui_dom_browser_min_s(n),l=floating_ui_dom_browser_min_T(n);if(n===l)return e;let c={scrollLeft:0,scrollTop:0},f={x:1,y:1};const u={x:0,y:0};if((i||!i&&"fixed"!==o)&&(("body"!==floating_ui_dom_browser_min_r(n)||floating_ui_dom_browser_min_a(l))&&(c=floating_ui_dom_browser_min_R(n)),floating_ui_dom_browser_min_s(n))){const t=floating_ui_dom_browser_min_E(n);f=floating_ui_dom_browser_min_L(n),u.x=t.x+n.clientLeft,u.y=t.y+n.clientTop}return{width:e.width*f.x,height:e.height*f.y,x:e.x*f.x-c.scrollLeft*f.x+u.x,y:e.y*f.y-c.scrollTop*f.y+u.y}},isElement:floating_ui_dom_browser_min_f,getDimensions:function(t){return floating_ui_dom_browser_min_w(t)},getOffsetParent:H,getDocumentElement:floating_ui_dom_browser_min_T,getScale:floating_ui_dom_browser_min_L,async getElementRects(t){let{reference:e,floating:n,strategy:o}=t;const i=this.getOffsetParent||H,r=this.getDimensions;return{reference:floating_ui_dom_browser_min_O(e,await i(n),o),floating:{x:0,y:0,...await r(n)}}},getClientRects:t=>Array.from(t.getClientRects()),isRTL:t=>"rtl"===floating_ui_dom_browser_min_o(t).direction};function z(t,e,n,o){void 0===o&&(o={});const{ancestorScroll:i=!0,ancestorResize:r=!0,elementResize:l=!0,animationFrame:c=!1}=o,s=i||r?[...floating_ui_dom_browser_min_f(t)?W(t):t.contextElement?W(t.contextElement):[],...W(e)]:[];s.forEach((t=>{const e=!floating_ui_dom_browser_min_f(t)&&t.toString().includes("V");!i||c&&!e||t.addEventListener("scroll",n,{passive:!0}),r&&t.addEventListener("resize",n)}));let u,a=null;l&&(a=new ResizeObserver((()=>{n()})),floating_ui_dom_browser_min_f(t)&&!c&&a.observe(t),floating_ui_dom_browser_min_f(t)||!t.contextElement||c||a.observe(t.contextElement),a.observe(e));let d=c?floating_ui_dom_browser_min_E(t):null;return c&&function e(){const o=floating_ui_dom_browser_min_E(t);!d||o.x===d.x&&o.y===d.y&&o.width===d.width&&o.height===d.height||n();d=o,u=requestAnimationFrame(e)}(),n(),()=>{var t;s.forEach((t=>{i&&t.removeEventListener("scroll",n),r&&t.removeEventListener("resize",n)})),null==(t=a)||t.disconnect(),a=null,c&&cancelAnimationFrame(u)}}const floating_ui_dom_browser_min_k=(t,n,o)=>{const i=new Map,r={platform:floating_ui_dom_browser_min_P,...o},l={...r.platform,_c:i};return e(t,n,{...r,platform:l})};

// EXTERNAL MODULE: ../../node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.js
var use_isomorphic_layout_effect_browser_esm = __webpack_require__(84337);
;// CONCATENATED MODULE: ../../node_modules/react-select/dist/index-a86253bb.esm.js













var _excluded$3 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================

var noop = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}
function classNames(prefix, state) {
  for (var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classNameList[_key - 2] = arguments[_key];
  }
  var arr = [].concat(classNameList);
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }
  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = _objectWithoutProperties(props, _excluded$3);
  return objectSpread2_objectSpread2({}, innerProps);
};

// ==============================
// Get Style Props
// ==============================

var getStyleProps = function getStyleProps(props, name, classNamesState) {
  var cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    className = props.className;
  return {
    css: getStyles(name, props),
    className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
  };
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var _newValue = onInputChange(inputValue, actionMeta);
    if (typeof _newValue === 'string') return _newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

// ==============================
// Passive Event Detector
// ==============================

// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
// check for SSR
var index_a86253bb_esm_w = typeof window !== 'undefined' ? window : {};
if (index_a86253bb_esm_w.addEventListener && index_a86253bb_esm_w.removeEventListener) {
  index_a86253bb_esm_w.addEventListener('p', noop, options);
  index_a86253bb_esm_w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps(propsObj) {
  for (var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties[_key2 - 1] = arguments[_key2];
  }
  var propsMap = Object.entries(propsObj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};

function getMenuPlacement(_ref) {
  var preferredMaxHeight = _ref.maxHeight,
    menuEl = _ref.menuEl,
    minHeight = _ref.minHeight,
    preferredPlacement = _ref.placement,
    shouldScroll = _ref.shouldScroll,
    isFixedPosition = _ref.isFixedPosition,
    controlHeight = _ref.controlHeight;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: preferredMaxHeight
  };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
    scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
    menuBottom = _menuEl$getBoundingCl.bottom,
    menuHeight = _menuEl$getBoundingCl.height,
    menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
    containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (preferredPlacement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (preferredPlacement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
  }
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
  var _objectSpread2;
  var placement = _ref2.placement,
    _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    spacing = _ref2$theme.spacing,
    colors = _ref2$theme.colors;
  return objectSpread2_objectSpread2((_objectSpread2 = {
    label: 'menu'
  }, _defineProperty(_objectSpread2, alignToControl(placement), '100%'), _defineProperty(_objectSpread2, "position", 'absolute'), _defineProperty(_objectSpread2, "width", '100%'), _defineProperty(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
    backgroundColor: colors.neutral0,
    borderRadius: borderRadius,
    boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
    marginBottom: spacing.menuGutter,
    marginTop: spacing.menuGutter
  });
};
var PortalPlacementContext = /*#__PURE__*/(0,react.createContext)(null);

// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
  var children = props.children,
    minMenuHeight = props.minMenuHeight,
    maxMenuHeight = props.maxMenuHeight,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition,
    menuShouldScrollIntoView = props.menuShouldScrollIntoView,
    theme = props.theme;
  var _ref3 = (0,react.useContext)(PortalPlacementContext) || {},
    setPortalPlacement = _ref3.setPortalPlacement;
  var ref = (0,react.useRef)(null);
  var _useState = (0,react.useState)(maxMenuHeight),
    _useState2 = _slicedToArray(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];
  var _useState3 = (0,react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    placement = _useState4[0],
    setPlacement = _useState4[1];
  var controlHeight = theme.spacing.controlHeight;
  (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
    var menuEl = ref.current;
    if (!menuEl) return;

    // DO NOT scroll if position is fixed
    var isFixedPosition = menuPosition === 'fixed';
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl: menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll: shouldScroll,
      isFixedPosition: isFixedPosition,
      controlHeight: controlHeight
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight]);
  return children({
    ref: ref,
    placerProps: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight: maxHeight
    })
  });
};
var Menu = function Menu(props) {
  var children = props.children,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'menu', {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4, unstyled) {
  var maxHeight = _ref4.maxHeight,
    baseUnit = _ref4.theme.spacing.baseUnit;
  return objectSpread2_objectSpread2({
    maxHeight: maxHeight,
    overflowY: 'auto',
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  }, unstyled ? {} : {
    paddingBottom: baseUnit,
    paddingTop: baseUnit
  });
};
var MenuList = function MenuList(props) {
  var children = props.children,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    isMulti = props.isMulti;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'menuList', {
    'menu-list': true,
    'menu-list--is-multi': isMulti
  }), {
    ref: innerRef
  }, innerProps), children);
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5, unstyled) {
  var _ref5$theme = _ref5.theme,
    baseUnit = _ref5$theme.spacing.baseUnit,
    colors = _ref5$theme.colors;
  return objectSpread2_objectSpread2({
    textAlign: 'center'
  }, unstyled ? {} : {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
  });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'noOptionsMessage', {
    'menu-notice': true,
    'menu-notice--no-options': true
  }), innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'loadingMessage', {
    'menu-notice': true,
    'menu-notice--loading': true
  }), innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
    offset = _ref6.offset,
    position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal(props) {
  var appendTo = props.appendTo,
    children = props.children,
    controlElement = props.controlElement,
    innerProps = props.innerProps,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition;
  var menuPortalRef = (0,react.useRef)(null);
  var cleanupRef = (0,react.useRef)(null);
  var _useState5 = (0,react.useState)(coercePlacement(menuPlacement)),
    _useState6 = _slicedToArray(_useState5, 2),
    placement = _useState6[0],
    setPortalPlacement = _useState6[1];
  var portalPlacementContext = (0,react.useMemo)(function () {
    return {
      setPortalPlacement: setPortalPlacement
    };
  }, []);
  var _useState7 = (0,react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    computedPosition = _useState8[0],
    setComputedPosition = _useState8[1];
  var updateComputedPosition = (0,react.useCallback)(function () {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
    var offset = rect[placement] + scrollDistance;
    if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset,
        rect: rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = (0,react.useCallback)(function () {
    if (typeof cleanupRef.current === 'function') {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = z(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: 'ResizeObserver' in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = (0,react.useCallback)(function (menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);

  // bail early if required elements aren't present
  if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;

  // same wrapper element whether fixed or portalled
  var menuWrapper = jsx("div", (0,esm_extends/* default */.Z)({
    ref: setMenuPortalElement
  }, getStyleProps(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, props), {}, {
    offset: computedPosition.offset,
    position: menuPosition,
    rect: computedPosition.rect
  }), 'menuPortal', {
    'menu-portal': true
  }), innerProps), children);
  return jsx(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /*#__PURE__*/(0,react_dom.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

// ==============================
// Root Container
// ==============================

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    isRtl = props.isRtl;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'container', {
    '--is-disabled': isDisabled,
    '--is-rtl': isRtl
  }), innerProps), children);
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
  var spacing = _ref2.theme.spacing,
    isMulti = _ref2.isMulti,
    hasValue = _ref2.hasValue,
    controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return objectSpread2_objectSpread2({
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  }, unstyled ? {} : {
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
  });
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isMulti = props.isMulti,
    hasValue = props.hasValue;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'valueContainer', {
    'value-container': true,
    'value-container--is-multi': isMulti,
    'value-container--has-value': hasValue
  }), innerProps), children);
};

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'indicatorsContainer', {
    indicators: true
  }), innerProps), children);
};

var _templateObject;
var _excluded$2 = ["size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2 =  true ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : 0;
var Svg = function Svg(_ref) {
  var size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return jsx("svg", (0,esm_extends/* default */.Z)({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};
var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return jsx(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3, unstyled) {
  var isFocused = _ref3.isFocused,
    _ref3$theme = _ref3.theme,
    baseUnit = _ref3$theme.spacing.baseUnit,
    colors = _ref3$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'indicatorContainer',
    display: 'flex',
    transition: 'color 150ms'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2,
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'dropdownIndicator', {
    indicator: true,
    'dropdown-indicator': true
  }), innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'clearIndicator', {
    indicator: true,
    'clear-indicator': true
  }), innerProps), children || jsx(CrossIcon, null));
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
  var isDisabled = _ref4.isDisabled,
    _ref4$theme = _ref4.theme,
    baseUnit = _ref4$theme.spacing.baseUnit,
    colors = _ref4$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    width: 1
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2
  });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var innerProps = props.innerProps;
  return jsx("span", (0,esm_extends/* default */.Z)({}, innerProps, getStyleProps(props, 'indicatorSeparator', {
    'indicator-separator': true
  })));
};

// ==============================
// Loading
// ==============================

var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
  var isFocused = _ref5.isFocused,
    size = _ref5.size,
    _ref5$theme = _ref5.theme,
    colors = _ref5$theme.colors,
    baseUnit = _ref5$theme.spacing.baseUnit;
  return objectSpread2_objectSpread2({
    label: 'loadingIndicator',
    display: 'flex',
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2
  });
};
var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
    offset = _ref6.offset;
  return jsx("span", {
    css: /*#__PURE__*/css({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    },  true ? "" : 0,  true ? "" : 0)
  });
};
var LoadingIndicator = function LoadingIndicator(props) {
  var innerProps = props.innerProps,
    isRtl = props.isRtl;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'loadingIndicator', {
    indicator: true,
    'loading-indicator': true
  }), innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    _ref$theme = _ref.theme,
    colors = _ref$theme.colors,
    borderRadius = _ref$theme.borderRadius,
    spacing = _ref$theme.spacing;
  return objectSpread2_objectSpread2({
    label: 'control',
    alignItems: 'center',
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms'
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  });
};
var Control = function Control(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    menuIsOpen = props.menuIsOpen;
  return jsx("div", (0,esm_extends/* default */.Z)({
    ref: innerRef
  }, getStyleProps(props, 'control', {
    control: true,
    'control--is-disabled': isDisabled,
    'control--is-focused': isFocused,
    'control--menu-is-open': menuIsOpen
  }), innerProps), children);
};

var _excluded$1 = ["data"];
var groupCSS = function groupCSS(_ref, unstyled) {
  var spacing = _ref.theme.spacing;
  return unstyled ? {} : {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};
var Group = function Group(props) {
  var children = props.children,
    cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    Heading = props.Heading,
    headingProps = props.headingProps,
    innerProps = props.innerProps,
    label = props.label,
    theme = props.theme,
    selectProps = props.selectProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'group', {
    group: true
  }), innerProps), jsx(Heading, (0,esm_extends/* default */.Z)({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    getClassNames: getClassNames,
    cx: cx
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    colors = _ref2$theme.colors,
    spacing = _ref2$theme.spacing;
  return objectSpread2_objectSpread2({
    label: 'group',
    cursor: 'default',
    display: 'block'
  }, unstyled ? {} : {
    color: colors.neutral40,
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  });
};
var GroupHeading = function GroupHeading(props) {
  var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1);
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'groupHeading', {
    'group-heading': true
  }), innerProps));
};

var index_a86253bb_esm_excluded = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    value = _ref.value,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2(objectSpread2_objectSpread2({
    visibility: isDisabled ? 'hidden' : 'visible',
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle), unstyled ? {} : {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    color: colors.neutral80
  });
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': objectSpread2_objectSpread2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
  return objectSpread2_objectSpread2({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};
var Input = function Input(props) {
  var cx = props.cx,
    value = props.value;
  var _cleanCommonProps = cleanCommonProps(props),
    innerRef = _cleanCommonProps.innerRef,
    isDisabled = _cleanCommonProps.isDisabled,
    isHidden = _cleanCommonProps.isHidden,
    inputClassName = _cleanCommonProps.inputClassName,
    innerProps = _objectWithoutProperties(_cleanCommonProps, index_a86253bb_esm_excluded);
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'input', {
    'input-container': true
  }), {
    "data-value": value || ''
  }), jsx("input", (0,esm_extends/* default */.Z)({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};

var multiValueCSS = function multiValueCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    borderRadius = _ref$theme.borderRadius,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'multiValue',
    display: 'flex',
    minWidth: 0
  }, unstyled ? {} : {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    margin: spacing.baseUnit / 2
  });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    colors = _ref2$theme.colors,
    cropWithEllipsis = _ref2.cropWithEllipsis;
  return objectSpread2_objectSpread2({
    overflow: 'hidden',
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    padding: 3,
    paddingLeft: 6
  });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
  var _ref3$theme = _ref3.theme,
    spacing = _ref3$theme.spacing,
    borderRadius = _ref3$theme.borderRadius,
    colors = _ref3$theme.colors,
    isFocused = _ref3.isFocused;
  return objectSpread2_objectSpread2({
    alignItems: 'center',
    display: 'flex'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
    innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
    innerProps = _ref5.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue(props) {
  var children = props.children,
    components = props.components,
    data = props.data,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    removeProps = props.removeProps,
    selectProps = props.selectProps;
  var Container = components.Container,
    Label = components.Label,
    Remove = components.Remove;
  return jsx(Container, {
    data: data,
    innerProps: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, getStyleProps(props, 'multiValue', {
      'multi-value': true,
      'multi-value--is-disabled': isDisabled
    })), innerProps),
    selectProps: selectProps
  }, jsx(Label, {
    data: data,
    innerProps: objectSpread2_objectSpread2({}, getStyleProps(props, 'multiValueLabel', {
      'multi-value__label': true
    })),
    selectProps: selectProps
  }, children), jsx(Remove, {
    data: data,
    innerProps: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, getStyleProps(props, 'multiValueRemove', {
      'multi-value__remove': true
    })), {}, {
      'aria-label': "Remove ".concat(children || 'option')
    }, removeProps),
    selectProps: selectProps
  }));
};

var optionCSS = function optionCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'option',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
  }, unstyled ? {} : {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  });
};
var Option = function Option(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'option', {
    option: true,
    'option--is-disabled': isDisabled,
    'option--is-focused': isFocused,
    'option--is-selected': isSelected
  }), {
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'placeholder',
    gridArea: '1 / 1 / 2 / 3'
  }, unstyled ? {} : {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var Placeholder = function Placeholder(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'placeholder', {
    placeholder: true
  }), innerProps), children);
};

var index_a86253bb_esm_css = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'singleValue',
    gridArea: '1 / 1 / 2 / 3',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var SingleValue = function SingleValue(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    innerProps = props.innerProps;
  return jsx("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'singleValue', {
    'single-value': true,
    'single-value--is-disabled': isDisabled
  }), innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, components), props.components);
};



;// CONCATENATED MODULE: ../../node_modules/react-select/node_modules/memoize-one/dist/memoize-one.esm.js
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var cache = null;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) {
            return cache.lastResult;
        }
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this,
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



;// CONCATENATED MODULE: ../../node_modules/react-select/dist/Select-457c486b.esm.js














function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// Assistive text to describe visual elements. Hidden for sighted users.
var _ref =  true ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : 0;
var A11yText = function A11yText(props) {
  return jsx("span", (0,esm_extends/* default */.Z)({
    css: _ref
  }, props));
};

var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
      isMulti = props.isMulti,
      isDisabled = props.isDisabled,
      tabSelectsValue = props.tabSelectsValue,
      context = props.context;
    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
      case 'input':
        return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      labels = props.labels,
      isDisabled = props.isDisabled;
    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");
      case 'clear':
        return 'All selected options have been cleared.';
      case 'initial-input-focus':
        return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
      focused = props.focused,
      options = props.options,
      _props$label2 = props.label,
      label = _props$label2 === void 0 ? '' : _props$label2,
      selectValue = props.selectValue,
      isDisabled = props.isDisabled,
      isSelected = props.isSelected;
    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };
    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === 'menu') {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }
    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
      resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};

var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
    focusedOption = props.focusedOption,
    focusedValue = props.focusedValue,
    focusableOptions = props.focusableOptions,
    isFocused = props.isFocused,
    selectValue = props.selectValue,
    selectProps = props.selectProps,
    id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
    getOptionLabel = selectProps.getOptionLabel,
    inputValue = selectProps.inputValue,
    isMulti = selectProps.isMulti,
    isOptionDisabled = selectProps.isOptionDisabled,
    isSearchable = selectProps.isSearchable,
    menuIsOpen = selectProps.menuIsOpen,
    options = selectProps.options,
    screenReaderStatus = selectProps.screenReaderStatus,
    tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live'];

  // Update aria live message configuration when prop changes
  var messages = (0,react.useMemo)(function () {
    return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);

  // Update aria live selected option when prop changes
  var ariaSelected = (0,react.useMemo)(function () {
    var message = '';
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
        selectedOptions = ariaSelection.options,
        removedValue = ariaSelection.removedValue,
        removedValues = ariaSelection.removedValues,
        value = ariaSelection.value;
      // select-option when !isMulti does not return option so we assume selected option is value
      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      };

      // If there is just one item from the action then get its label
      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel(selected) : '';

      // If there are multiple items from the action then return an array of labels
      var multiSelected = selectedOptions || removedValues || undefined;
      var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
      var onChangeProps = objectSpread2_objectSpread2({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
  var ariaFocused = (0,react.useMemo)(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused, selectValue),
        isSelected: isSelected,
        options: focusableOptions,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, focusableOptions, selectValue]);
  var ariaResults = (0,react.useMemo)(function () {
    var resultsMsg = '';
    if (menuIsOpen && options.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus]);
  var ariaGuidance = (0,react.useMemo)(function () {
    var guidanceMsg = '';
    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = jsx(react.Fragment, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
  return jsx(react.Fragment, null, jsx(A11yText, {
    id: id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for (var Select_457c486b_esm_i = 0; Select_457c486b_esm_i < diacritics.length; Select_457c486b_esm_i++) {
  var diacritic = diacritics[Select_457c486b_esm_i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    // eslint-disable-next-line no-underscore-dangle
    if (option.data.__isNew__) return true;
    var _ignoreCase$ignoreAcc = objectSpread2_objectSpread2({
        ignoreCase: true,
        ignoreAccents: true,
        stringify: defaultStringify,
        trim: true,
        matchFrom: 'any'
      }, config),
      ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
      ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
      stringify = _ignoreCase$ignoreAcc.stringify,
      trim = _ignoreCase$ignoreAcc.trim,
      matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var Select_457c486b_esm_excluded = ["innerRef"];
function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
    props = _objectWithoutProperties(_ref, Select_457c486b_esm_excluded);
  // Remove animation props not meant for HTML elements
  var filteredProps = removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
  return jsx("input", (0,esm_extends/* default */.Z)({
    ref: innerRef
  }, filteredProps, {
    css: /*#__PURE__*/css({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: 'transparent',
      fontSize: 'inherit',
      gridArea: '1 / 1 / 2 / 3',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(.01)'
    },  true ? "" : 0,  true ? "" : 0)
  }));
}

var cancelScroll = function cancelScroll(event) {
  event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var isBottom = (0,react.useRef)(false);
  var isTop = (0,react.useRef)(false);
  var touchStart = (0,react.useRef)(0);
  var scrollTarget = (0,react.useRef)(null);
  var handleEventDelta = (0,react.useCallback)(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
      scrollTop = _scrollTarget$current.scrollTop,
      scrollHeight = _scrollTarget$current.scrollHeight,
      clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;

    // reset bottom/top flags
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    }

    // bottom limit
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;

      // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }

    // cancel scroll
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = (0,react.useCallback)(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = (0,react.useCallback)(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = (0,react.useCallback)(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = (0,react.useCallback)(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener('wheel', onWheel, notPassive);
    el.addEventListener('touchstart', onTouchStart, notPassive);
    el.addEventListener('touchmove', onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = (0,react.useCallback)(function (el) {
    // bail early if no element is available to detach from
    if (!el) return;
    el.removeEventListener('wheel', onWheel, false);
    el.removeEventListener('touchstart', onTouchStart, false);
    el.removeEventListener('touchmove', onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  (0,react.useEffect)(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};
function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
    _ref$accountForScroll = _ref.accountForScrollbars,
    accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = (0,react.useRef)({});
  var scrollTarget = (0,react.useRef)(null);
  var addScrollLock = (0,react.useCallback)(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }

    // apply the lock styles and padding if this is the first scroll lock
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }

    // account for touch devices
    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions);

      // Allow scroll on provided target
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }

    // increment active scroll locks
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = (0,react.useCallback)(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;

    // safely decrement active scroll locks
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

    // reapply original body styles, if any
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }

    // remove touch listeners
    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  (0,react.useEffect)(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var blurSelectInput = function blurSelectInput() {
  return document.activeElement && document.activeElement.blur();
};
var _ref2$1 =  true ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : 0;
function ScrollManager(_ref) {
  var children = _ref.children,
    lockEnabled = _ref.lockEnabled,
    _ref$captureEnabled = _ref.captureEnabled,
    captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(react.Fragment, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}

function Select_457c486b_esm_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Select_457c486b_esm_ref2 =  true ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : 0;
var RequiredInput = function RequiredInput(_ref) {
  var name = _ref.name,
    onFocus = _ref.onFocus;
  return jsx("input", {
    required: true,
    name: name,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: onFocus,
    css: Select_457c486b_esm_ref2
    // Prevent `Switching from uncontrolled to controlled` error
    ,
    value: "",
    onChange: function onChange() {}
  });
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: index_a86253bb_esm_css,
  valueContainer: valueContainerCSS
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // initialize with source styles
  var styles = _objectSpread({}, source);

  // massage in target styles
  Object.keys(target).forEach(function (keyAsString) {
    var key = keyAsString;
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  classNames: {},
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true,
  unstyled: false
};
function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel(props, option);
  var value = getOptionValue(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ('options' in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
    inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
    isSelected = categorizedOption.isSelected,
    label = categorizedOption.label,
    value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
    lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getOptionLabel = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;
  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue(props, option);
  return selectValue.some(function (i) {
    return getOptionValue(props, i) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
    isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);
  var _super = _createSuper(Select);
  // Misc. Instance Properties
  // ------------------------------

  // TODO

  // Refs
  // ------------------------------

  // Lifecycle
  // ------------------------------

  function Select(_props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;
    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange(newValue, actionMeta);
    };
    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
        closeMenuOnSelect = _this$props2.closeMenuOnSelect,
        isMulti = _this$props2.isMulti,
        inputValue = _this$props2.inputValue;
      _this.onInputChange('', {
        action: 'set-value',
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      // when the select value should change, we should reset focusedValue
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };
    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
        blurInputOnSelect = _this$props3.blurInputOnSelect,
        isMulti = _this$props3.isMulti,
        name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), 'select-option', newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), 'select-option');
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: 'select-option',
          option: newValue,
          name: name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: 'clear',
        removedValues: selectValue
      });
    };
    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };
    _this.getValue = function () {
      return _this.state.selectValue;
    };
    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function (data) {
      return getOptionLabel(_this.props, data);
    };
    _this.getOptionValue = function (data) {
      return getOptionValue(_this.props, data);
    };
    _this.getStyles = function (key, props) {
      var unstyled = _this.props.unstyled;
      var base = defaultStyles[key](props, unstyled);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getClassNames = function (key, props) {
      var _this$props$className, _this$props$className2;
      return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
    };
    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function () {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: objectSpread2_objectSpread2({
          value: value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function (event) {
      // Event captured by dropdown indicator
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
        isMulti = _this$props4.isMulti,
        menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };
    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }

      // reset move vars
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: 'input-change',
        prevInputValue: prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange('', {
        action: 'input-blur',
        prevInputValue: prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      _this.setState({
        focusedOption: focusedOption
      });
    };
    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onValueInputFocus = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.focus();
    };
    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
        isMulti = _this$props5.isMulti,
        backspaceRemovesValue = _this$props5.backspaceRemovesValue,
        escapeClearsValue = _this$props5.escapeClearsValue,
        inputValue = _this$props5.inputValue,
        isClearable = _this$props5.isClearable,
        isDisabled = _this$props5.isDisabled,
        menuIsOpen = _this$props5.menuIsOpen,
        onKeyDown = _this$props5.onKeyDown,
        tabSelectsValue = _this$props5.tabSelectsValue,
        openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
        focusedOption = _this$state.focusedOption,
        focusedValue = _this$state.focusedValue,
        selectValue = _this$state.selectValue;
      if (isDisabled) return;
      if (typeof onKeyDown === 'function') {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }

      // Block option hover events when the user has just pressed a key
      _this.blockOptionHover = true;
      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;
          _this.focusValue('previous');
          break;
        case 'ArrowRight':
          if (!isMulti || inputValue) return;
          _this.focusValue('next');
          break;
        case 'Delete':
        case 'Backspace':
          if (inputValue) return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case 'Tab':
          if (_this.isComposing) return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
          // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange('', {
              action: 'menu-close',
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case ' ':
          // space
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu('first');
            break;
          }
          if (!focusedOption) return;
          _this.selectOption(focusedOption);
          break;
        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }
          break;
        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }
          break;
        case 'PageUp':
          if (!menuIsOpen) return;
          _this.focusOption('pageup');
          break;
        case 'PageDown':
          if (!menuIsOpen) return;
          _this.focusOption('pagedown');
          break;
        case 'Home':
          if (!menuIsOpen) return;
          _this.focusOption('first');
          break;
        case 'End':
          if (!menuIsOpen) return;
          _this.focusOption('last');
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);

    // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptions = _this.buildFocusableOptions();
      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusedOption = focusableOptions[optionIndex];
    }
    return _this;
  }
  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }

      // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
        isDisabled = _this$props6.isDisabled,
        menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: true
        });
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }

    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close',
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state,
        selectValue = _this$state2.selectValue,
        isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      // only scroll if the menu isn't already open
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
        selectValue = _this$state3.selectValue,
        focusedValue = _this$state3.focusedValue;

      // Only multiselects support value focusing
      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;
      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value:
    // ==============================
    // Getters
    // ==============================

    function getTheme() {
      // Use the default theme if there are no customisations.
      if (!this.props.theme) {
        return defaultTheme;
      }
      // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.
      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      }
      // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.
      return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
        cx = this.cx,
        getStyles = this.getStyles,
        getClassNames = this.getClassNames,
        getValue = this.getValue,
        selectOption = this.selectOption,
        setValue = this.setValue,
        props = this.props;
      var isMulti = props.isMulti,
        isRtl = props.isRtl,
        options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getClassNames: getClassNames,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
        isClearable = _this$props7.isClearable,
        isMulti = _this$props7.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable
      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value:
    // ==============================
    // Composition Handlers
    // ==============================

    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value:
    // ==============================
    // Touch Handlers
    // ==============================

    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value:
    // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
        isDisabled = _this$props8.isDisabled,
        isSearchable = _this$props8.isSearchable,
        inputId = _this$props8.inputId,
        inputValue = _this$props8.inputValue,
        tabIndex = _this$props8.tabIndex,
        form = _this$props8.form,
        menuIsOpen = _this$props8.menuIsOpen,
        required = _this$props8.required;
      var _this$getComponents = this.getComponents(),
        Input = _this$getComponents.Input;
      var _this$state4 = this.state,
        inputIsHidden = _this$state4.inputIsHidden,
        ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input');

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = objectSpread2_objectSpread2(objectSpread2_objectSpread2(objectSpread2_objectSpread2({
        'aria-autocomplete': 'list',
        'aria-expanded': menuIsOpen,
        'aria-haspopup': true,
        'aria-errormessage': this.props['aria-errormessage'],
        'aria-invalid': this.props['aria-invalid'],
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        'aria-required': required,
        role: 'combobox'
      }, menuIsOpen && {
        'aria-controls': this.getElementId('listbox'),
        'aria-owns': this.getElementId('listbox')
      }), !isSearchable && {
        'aria-readonly': true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
        'aria-describedby': this.getElementId('live-region')
      } : {
        'aria-describedby': this.getElementId('placeholder')
      });
      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/react.createElement(DummyInput, (0,esm_extends/* default */.Z)({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex: tabIndex,
          inputMode: "none",
          form: form,
          value: ""
        }, ariaAttributes));
      }
      return /*#__PURE__*/react.createElement(Input, (0,esm_extends/* default */.Z)({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(),
        MultiValue = _this$getComponents2.MultiValue,
        MultiValueContainer = _this$getComponents2.MultiValueContainer,
        MultiValueLabel = _this$getComponents2.MultiValueLabel,
        MultiValueRemove = _this$getComponents2.MultiValueRemove,
        SingleValue = _this$getComponents2.SingleValue,
        Placeholder = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props,
        controlShouldRenderValue = _this$props9.controlShouldRenderValue,
        isDisabled = _this$props9.isDisabled,
        isMulti = _this$props9.isMulti,
        inputValue = _this$props9.inputValue,
        placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
        selectValue = _this$state5.selectValue,
        focusedValue = _this$state5.focusedValue,
        isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/react.createElement(Placeholder, (0,esm_extends/* default */.Z)({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId('placeholder')
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /*#__PURE__*/react.createElement(MultiValue, (0,esm_extends/* default */.Z)({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: key,
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /*#__PURE__*/react.createElement(SingleValue, (0,esm_extends/* default */.Z)({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
        ClearIndicator = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props,
        isDisabled = _this$props10.isDisabled,
        isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(ClearIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
        LoadingIndicator = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props,
        isDisabled = _this$props11.isDisabled,
        isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(LoadingIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
        DropdownIndicator = _this$getComponents5.DropdownIndicator,
        IndicatorSeparator = _this$getComponents5.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator
      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/react.createElement(IndicatorSeparator, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
        DropdownIndicator = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(DropdownIndicator, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(),
        Group = _this$getComponents7.Group,
        GroupHeading = _this$getComponents7.GroupHeading,
        Menu = _this$getComponents7.Menu,
        MenuList = _this$getComponents7.MenuList,
        MenuPortal = _this$getComponents7.MenuPortal,
        LoadingMessage = _this$getComponents7.LoadingMessage,
        NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
        Option = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
        captureMenuScroll = _this$props12.captureMenuScroll,
        inputValue = _this$props12.inputValue,
        isLoading = _this$props12.isLoading,
        loadingMessage = _this$props12.loadingMessage,
        minMenuHeight = _this$props12.minMenuHeight,
        maxMenuHeight = _this$props12.maxMenuHeight,
        menuIsOpen = _this$props12.menuIsOpen,
        menuPlacement = _this$props12.menuPlacement,
        menuPosition = _this$props12.menuPosition,
        menuPortalTarget = _this$props12.menuPortalTarget,
        menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
        menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
        noOptionsMessage = _this$props12.noOptionsMessage,
        onMenuScrollToTop = _this$props12.onMenuScrollToTop,
        onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props, id) {
        var type = props.type,
          data = props.data,
          isDisabled = props.isDisabled,
          isSelected = props.isSelected,
          label = props.label,
          value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /*#__PURE__*/react.createElement(Option, (0,esm_extends/* default */.Z)({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var _data = item.data,
              options = item.options,
              groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/react.createElement(Group, (0,esm_extends/* default */.Z)({}, commonProps, {
              key: groupId,
              data: _data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/react.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });
        if (_message === null) return null;
        menuUI = /*#__PURE__*/react.createElement(NoOptionsMessage, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/react.createElement(MenuPlacer, (0,esm_extends/* default */.Z)({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
          _ref4$placerProps = _ref4.placerProps,
          placement = _ref4$placerProps.placement,
          maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/react.createElement(Menu, (0,esm_extends/* default */.Z)({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove,
            id: _this4.getElementId('listbox')
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/react.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/react.createElement(MenuList, (0,esm_extends/* default */.Z)({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      });

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/react.createElement(MenuPortal, (0,esm_extends/* default */.Z)({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props,
        delimiter = _this$props13.delimiter,
        isDisabled = _this$props13.isDisabled,
        isMulti = _this$props13.isMulti,
        name = _this$props13.name,
        required = _this$props13.required;
      var selectValue = this.state.selectValue;
      if (required && !this.hasValue() && !isDisabled) {
        return /*#__PURE__*/react.createElement(RequiredInput, {
          name: name,
          onFocus: this.onValueInputFocus
        });
      }
      if (!name || isDisabled) return;
      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/react.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/react.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/react.createElement("input", {
            name: name,
            type: "hidden",
            value: ""
          });
          return /*#__PURE__*/react.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return /*#__PURE__*/react.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
        ariaSelection = _this$state6.ariaSelection,
        focusedOption = _this$state6.focusedOption,
        focusedValue = _this$state6.focusedValue,
        isFocused = _this$state6.isFocused,
        selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/react.createElement(LiveRegion, (0,esm_extends/* default */.Z)({}, commonProps, {
        id: this.getElementId('live-region'),
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
        Control = _this$getComponents8.Control,
        IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
        SelectContainer = _this$getComponents8.SelectContainer,
        ValueContainer = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props,
        className = _this$props14.className,
        id = _this$props14.id,
        isDisabled = _this$props14.isDisabled,
        menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/react.createElement(SelectContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/react.createElement(Control, (0,esm_extends/* default */.Z)({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/react.createElement(ValueContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/react.createElement(IndicatorsContainer, (0,esm_extends/* default */.Z)({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
        clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
        inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
        ariaSelection = state.ariaSelection,
        isFocused = state.isFocused,
        prevWasFocused = state.prevWasFocused;
      var options = props.options,
        value = props.value,
        menuIsOpen = props.menuIsOpen,
        inputValue = props.inputValue,
        isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      // some updates should toggle the state of the input visibility
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        // If `value` or `defaultValue` props are not empty then announce them
        // when the Select is initially focused
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: 'initial-input-focus'
        };
        hasKeptFocus = !prevWasFocused;
      }

      // If the 'initial-input-focus' action has been set already
      // then reset the ariaSelection to null
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
        newAriaSelection = null;
      }
      return objectSpread2_objectSpread2(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select;
}(react.Component);
Select.defaultProps = defaultProps;



;// CONCATENATED MODULE: ../../node_modules/react-select/dist/react-select.esm.js


























var StateManagedSelect = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var baseSelectProps = useStateManager(props);
  return /*#__PURE__*/react.createElement(Select, (0,esm_extends/* default */.Z)({
    ref: ref
  }, baseSelectProps));
});

var NonceProvider = (function (_ref) {
  var nonce = _ref.nonce,
    children = _ref.children,
    cacheKey = _ref.cacheKey;
  var emotionCache = useMemo(function () {
    return createCache({
      key: cacheKey,
      nonce: nonce
    });
  }, [cacheKey, nonce]);
  return /*#__PURE__*/React.createElement(CacheProvider, {
    value: emotionCache
  }, children);
});

/* harmony default export */ var react_select_esm = (StateManagedSelect);



/***/ }),

/***/ 51835:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PrevArrow = exports.NextArrow = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _classnames = _interopRequireDefault(__webpack_require__(72779));

var _innerSliderUtils = __webpack_require__(70257);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  var _super = _createSuper(PrevArrow);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _super.apply(this, arguments);
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  var _super2 = _createSuper(NextArrow);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _super2.apply(this, arguments);
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;

/***/ }),

/***/ 45629:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;

/***/ }),

/***/ 18804:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Dots = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _classnames = _interopRequireDefault(__webpack_require__(72779));

var _innerSliderUtils = __webpack_require__(70257);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  var _super = _createSuper(Dots);

  function Dots() {
    _classCallCheck(this, Dots);

    return _super.apply(this, arguments);
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave,
          infinite = _this$props.infinite,
          slidesToScroll = _this$props.slidesToScroll,
          slidesToShow = _this$props.slidesToShow,
          slideCount = _this$props.slideCount,
          currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];

      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;

        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);

        var _leftBound = rightBound - (slidesToScroll - 1);

        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }

      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;

/***/ }),

/***/ 23467:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _slider = _interopRequireDefault(__webpack_require__(40737));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports.Z = _default;

/***/ }),

/***/ 39140:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
var _default = initialState;
exports["default"] = _default;

/***/ }),

/***/ 20644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _initialState = _interopRequireDefault(__webpack_require__(39140));

var _lodash = _interopRequireDefault(__webpack_require__(80594));

var _classnames = _interopRequireDefault(__webpack_require__(72779));

var _innerSliderUtils = __webpack_require__(70257);

var _track = __webpack_require__(1167);

var _dots = __webpack_require__(18804);

var _arrows = __webpack_require__(51835);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(97209));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  var _super = _createSuper(InnerSlider);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      _this.ro.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      var setTrackStyle = _this.didPropsChange(prevProps);

      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (_this.props.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)

      if (!isTrackMounted) return;

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }

        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        return {
          trackStyle: _trackStyle
        };
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
        index: index
      }, _this.props), _this.state), {}, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }

      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }

        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }

      _this.props.autoplay && _this.autoPlay("update");

      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");

        nodes[0] && nodes[0].focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;

    var ssrState = _this.ssrInit();

    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }

  _createClass(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;

      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];

        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
          continue;
        }

        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);

  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;

/***/ }),

/***/ 40737:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _innerSlider = __webpack_require__(20644);

var _json2mq = _interopRequireDefault(__webpack_require__(5546));

var _defaultProps = _interopRequireDefault(__webpack_require__(45629));

var _innerSliderUtils = __webpack_require__(70257);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(40746);

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
      } else {
        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {}

        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: className
        }, children);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;

/***/ }),

/***/ 1167:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Track = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _classnames = _interopRequireDefault(__webpack_require__(72779));

var _innerSliderUtils = __webpack_require__(70257);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var focusedSlide;

  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }

  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;

    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread(_objectSpread({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  var _super = _createSuper(Track);

  function Track() {
    var _this;

    _classCallCheck(this, Track);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "node", null);

    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
      _this.node = ref;
    });

    return _this;
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;

/***/ }),

/***/ 70257:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.checkSpecKeys = exports.checkNavigable = exports.changeSlide = exports.canUseDOM = exports.canGoNext = void 0;
exports.clamp = clamp;
exports.swipeStart = exports.swipeMove = exports.swipeEnd = exports.slidesOnRight = exports.slidesOnLeft = exports.slideHandler = exports.siblingDirection = exports.safePreventDefault = exports.lazyStartIndex = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.keyHandler = exports.initializedState = exports.getWidth = exports.getTrackLeft = exports.getTrackCSS = exports.getTrackAnimateCSS = exports.getTotalSlides = exports.getSwipeDirection = exports.getSlideCount = exports.getRequiredLazySlides = exports.getPreClones = exports.getPostClones = exports.getOnDemandLazySlides = exports.getNavigableIndexes = exports.getHeight = exports.extractObject = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}

var safePreventDefault = function safePreventDefault(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];

  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};

exports.safePreventDefault = safePreventDefault;

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }

    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      previousTargetSlide = spec.targetSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (infinite) {
      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && safePreventDefault(e);
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return safePreventDefault(e);
  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread(_objectSpread({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e);
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe,
      targetSlide = spec.targetSlide,
      currentSlide = spec.currentSlide,
      infinite = spec.infinite;

  if (!dragging) {
    if (swipe) safePreventDefault(e);
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e);

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = activeSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread(_objectSpread({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),

/***/ 41527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var is = __webpack_require__(91197);

function getClientIpFromXForwardedFor(value) {
  if (!is.existy(value)) {
    return null;
  }

  if (is.not.string(value)) {
    throw new TypeError("Expected a string, got \"".concat(_typeof(value), "\""));
  }

  var forwardedIps = value.split(',').map(function (e) {
    var ip = e.trim();

    if (ip.includes(':')) {
      var splitted = ip.split(':');

      if (splitted.length === 2) {
        return splitted[0];
      }
    }

    return ip;
  });

  for (var i = 0; i < forwardedIps.length; i++) {
    if (is.ip(forwardedIps[i])) {
      return forwardedIps[i];
    }
  }

  return null;
}

function getClientIp(req) {
  if (req.headers) {
    if (is.ip(req.headers['x-client-ip'])) {
      return req.headers['x-client-ip'];
    }

    var xForwardedFor = getClientIpFromXForwardedFor(req.headers['x-forwarded-for']);

    if (is.ip(xForwardedFor)) {
      return xForwardedFor;
    }

    if (is.ip(req.headers['cf-connecting-ip'])) {
      return req.headers['cf-connecting-ip'];
    }

    if (is.ip(req.headers['fastly-client-ip'])) {
      return req.headers['fastly-client-ip'];
    }

    if (is.ip(req.headers['true-client-ip'])) {
      return req.headers['true-client-ip'];
    }

    if (is.ip(req.headers['x-real-ip'])) {
      return req.headers['x-real-ip'];
    }

    if (is.ip(req.headers['x-cluster-client-ip'])) {
      return req.headers['x-cluster-client-ip'];
    }

    if (is.ip(req.headers['x-forwarded'])) {
      return req.headers['x-forwarded'];
    }

    if (is.ip(req.headers['forwarded-for'])) {
      return req.headers['forwarded-for'];
    }

    if (is.ip(req.headers.forwarded)) {
      return req.headers.forwarded;
    }

    if (is.ip(req.headers['x-appengine-user-ip'])) {
      return req.headers['x-appengine-user-ip'];
    }
  }

  if (is.existy(req.connection)) {
    if (is.ip(req.connection.remoteAddress)) {
      return req.connection.remoteAddress;
    }

    if (is.existy(req.connection.socket) && is.ip(req.connection.socket.remoteAddress)) {
      return req.connection.socket.remoteAddress;
    }
  }

  if (is.existy(req.socket) && is.ip(req.socket.remoteAddress)) {
    return req.socket.remoteAddress;
  }

  if (is.existy(req.info) && is.ip(req.info.remoteAddress)) {
    return req.info.remoteAddress;
  }

  if (is.existy(req.requestContext) && is.existy(req.requestContext.identity) && is.ip(req.requestContext.identity.sourceIp)) {
    return req.requestContext.identity.sourceIp;
  }

  if (req.headers) {
    if (is.ip(req.headers['Cf-Pseudo-IPv4'])) {
      return req.headers['Cf-Pseudo-IPv4'];
    }
  }

  if (is.existy(req.raw)) {
    return getClientIp(req.raw);
  }

  return null;
}

function mw(options) {
  var configuration = is.not.existy(options) ? {} : options;

  if (is.not.object(configuration)) {
    throw new TypeError('Options must be an object!');
  }

  var attributeName = configuration.attributeName || 'clientIp';
  return function (req, res, next) {
    var ip = getClientIp(req);
    Object.defineProperty(req, attributeName, {
      get: function get() {
        return ip;
      },
      configurable: true
    });
    next();
  };
}

module.exports = {
  getClientIpFromXForwardedFor: getClientIpFromXForwardedFor,
  getClientIp: getClientIp,
  mw: mw
};

/***/ }),

/***/ 91197:
/***/ (function(module) {

"use strict";


var regexes = {
  ipv4: /^(?:(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])$/,
  ipv6: /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i
};

function not(func) {
  return function () {
    return !func.apply(null, Array.prototype.slice.call(arguments));
  };
}

function existy(value) {
  return value != null;
}

function ip(value) {
  return existy(value) && regexes.ipv4.test(value) || regexes.ipv6.test(value);
}

function object(value) {
  return Object(value) === value;
}

function string(value) {
  return Object.prototype.toString.call(value) === '[object String]';
}

var is = {
  existy: existy,
  ip: ip,
  object: object,
  string: string,
  not: {
    existy: not(existy),
    ip: not(ip),
    object: not(object),
    string: not(string)
  }
};
module.exports = is;

/***/ }),

/***/ 97209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),

/***/ 77834:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48834)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 88665:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 30627:
/***/ (function(module) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ 30214:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(77834).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 63356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f6": function() { return /* binding */ Le; },
  "vJ": function() { return /* binding */ $e; },
  "iv": function() { return /* binding */ Ae; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; },
  "F4": function() { return /* binding */ We; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, __PRIVATE__, isStyledComponent, useTheme, version, withTheme

// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(48570);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(88665);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ../../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

// EXTERNAL MODULE: ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(86894);
;// CONCATENATED MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_esm = (isPropValid);

// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(34406);
function y(){return(y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return"function"==typeof e}function b(e){return false||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A="5.3.11",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&(void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production")),P={},O= false?0:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return false&&0,T.set(e,t),x.set(t,e),t},B=function(e){return x.get(e)},z=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e)},M="style["+N+'][data-styled-version="5.3.11"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},Y=function(){return true?__webpack_require__.nc:0},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.11");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=B(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return(K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return!1}return!0}var re=te("5.3.11"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_browser_esm(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=react.createContext(),ue=ce.Consumer,le=react.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return (0,react.useContext)(ce)||de}function fe(){return (0,react.useContext)(le)||he}function me(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ce.Provider,{value:u},react.createElement(le.Provider,{value:l}, false?0:e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return"-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return"";if(_(e))return"."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if(false){ var o, n, r; }},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return"string"==typeof e&&( true||0)}var ke=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Be(e,t,n){var r=e[n];ke(t)&&ke(r)?ze(r,t):e[n]=t}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&Be(e,i[a],a)}return e}var Me=react.createContext(),Ge=Me.Consumer;function Le(e){var t=(0,react.useContext)(Me),n=(0,react.useMemo)((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?react.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.11"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,p=void 0===h?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):h,v=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||d,g=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new oe(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,p=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Oe(t,(0,react.useContext)(Me),a)||w,t,o),m=p[0],v=p[1],g=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return false&&0,i}(i,r,m, false?0:void 0),S=n,b=v.$as||t.$as||v.as||t.as||h,_=xe(b),N=v!==t?y({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,emotion_is_prop_valid_esm,b):!_||emotion_is_prop_valid_esm(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=y({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=S,(0,react.createElement)(b,A)}(A,e,t,I)};return P.displayName=p,(A=react.forwardRef(P)).attrs=g,A.componentStyle=C,A.displayName=p,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:g,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t}}), false&&(0),Object.defineProperty(A,"toString",{value:function(){return"."+A.styledComponentId}}),i&&hoist_non_react_statics_cjs_default()(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!(0,react_is.isValidElementType)(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e)}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function d(e){var t=pe(),n=fe(),o=(0,react.useContext)(Me),d=(0,react.useRef)(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(d,e,t,o,n),(0,react.useLayoutEffect)((function(){if(!t.server)return h(d,e,t,o,n),function(){return u.removeStyles(d,t)}}),[d,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else{var s=y({},t,{theme:Oe(t,r,d.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,react.memo(d)}function We(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Y();return"<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[react.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new X({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):react.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return D(3)},e}(),Je=function(e){var t=r.forwardRef((function(t,n){var o=s(Me),i=e.defaultProps,a=Oe(t,o,i);return false&&0,r.createElement(e,y({},t,{theme:a,ref:n}))}));return m(t,e),t.displayName="WithTheme("+b(e)+")",t},Xe=function(){return s(Me)},Ze={StyleSheet:X,masterSheet:de}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (qe);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 84337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var index =  react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect ;

/* harmony default export */ __webpack_exports__["Z"] = (index);


/***/ }),

/***/ 20452:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(2784);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 80402:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(2784),n=__webpack_require__(43100);function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
exports.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return[function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d},[d]);w(d);return d};


/***/ }),

/***/ 43100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(20452);
} else {}


/***/ }),

/***/ 41110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(80402);
} else {}


/***/ }),

/***/ 45982:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 4468:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
exports.q = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var dec = opt.decode || decode;

  var index = 0
  while (index < str.length) {
    var eqIdx = str.indexOf('=', index)

    // no more cookie pairs
    if (eqIdx === -1) {
      break
    }

    var endIdx = str.indexOf(';', index)

    if (endIdx === -1) {
      endIdx = str.length
    } else if (endIdx < eqIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1
      continue
    }

    var key = str.slice(index, eqIdx).trim()

    // only assign once
    if (undefined === obj[key]) {
      var val = str.slice(eqIdx + 1, endIdx).trim()

      // quoted values
      if (val.charCodeAt(0) === 0x22) {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString()
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority

    switch (priority) {
      case 'low':
        str += '; Priority=Low'
        break
      case 'medium':
        str += '; Priority=Medium'
        break
      case 'high':
        str += '; Priority=High'
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} str
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 85748:
/***/ (function(module) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 96314:
/***/ (function(module) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 85297:
/***/ (function(module) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 91461:
/***/ (function(module) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 53100:
/***/ (function(module) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 73419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(78560);
var isNativeReflectConstruct = __webpack_require__(37028);
function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    module.exports = _construct = Reflect.construct.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
  } else {
    module.exports = _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) setPrototypeOf(instance, Class.prototype);
      return instance;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  }
  return _construct.apply(null, arguments);
}
module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 98870:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(47739);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 26290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(47739);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1147:
/***/ (function(module) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 68230:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(78560);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 71600:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 19549:
/***/ (function(module) {

function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 37028:
/***/ (function(module) {

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 66193:
/***/ (function(module) {

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 16147:
/***/ (function(module) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 60421:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(67425)["default"]);
var assertThisInitialized = __webpack_require__(85297);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 27609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(67425)["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 78560:
/***/ (function(module) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 43681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(96314);
var iterableToArrayLimit = __webpack_require__(66193);
var unsupportedIterableToArray = __webpack_require__(60121);
var nonIterableRest = __webpack_require__(16147);
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 68064:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(67425)["default"]);
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 47739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(67425)["default"]);
var toPrimitive = __webpack_require__(68064);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 67425:
/***/ (function(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 60121:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(85748);
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 78365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(1147);
var setPrototypeOf = __webpack_require__(78560);
var isNativeFunction = __webpack_require__(19549);
var construct = __webpack_require__(73419);
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return construct(Class, arguments, getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return setPrototypeOf(Wrapper, Class);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _wrapNativeSuper(Class);
}
module.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 82841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(27609)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 7896:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 31461:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 88883:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
;// CONCATENATED MODULE: ../../node_modules/@hookform/resolvers/dist/resolvers.mjs
const s=(e,s,o)=>{if(e&&"reportValidity"in e){const r=(0,index_esm/* get */.U2)(o,s);e.setCustomValidity(r&&r.message||""),e.reportValidity()}},resolvers_o=(t,e)=>{for(const o in e.fields){const r=e.fields[o];r&&r.ref&&"reportValidity"in r.ref?s(r.ref,o,t):r.refs&&r.refs.forEach(e=>s(e,o,t))}},resolvers_r=(s,r)=>{r.shouldUseNativeValidation&&resolvers_o(s,r);const f={};for(const o in s){const n=(0,index_esm/* get */.U2)(r.fields,o),a=Object.assign(s[o]||{},{ref:n&&n.ref});if(i(r.names||Object.keys(s),o)){const s=Object.assign({},(0,index_esm/* get */.U2)(f,o));(0,index_esm/* set */.t8)(s,"root",a),(0,index_esm/* set */.t8)(f,o,s)}else (0,index_esm/* set */.t8)(f,o,a)}return f},i=(t,e)=>t.some(t=>t.startsWith(e+"."));
//# sourceMappingURL=resolvers.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs
var n=function(r,e){for(var n={};r.length;){var t=r[0],s=t.code,i=t.message,a=t.path.join(".");if(!n[a])if("unionErrors"in t){var u=t.unionErrors[0].errors[0];n[a]={message:u.message,type:u.code}}else n[a]={message:i,type:s};if("unionErrors"in t&&t.unionErrors.forEach(function(e){return e.errors.forEach(function(e){return r.push(e)})}),e){var c=n[a].types,f=c&&c[t.code];n[a]=(0,index_esm/* appendErrors */.KN)(a,e,n,s,f?[].concat(f,t.message):t.message)}r.shift()}return n},t=function(o,t,s){return void 0===s&&(s={}),function(i,a,u){try{return Promise.resolve(function(e,n){try{var a=Promise.resolve(o["sync"===s.mode?"parse":"parseAsync"](i,t)).then(function(e){return u.shouldUseNativeValidation&&resolvers_o({},u),{errors:{},values:s.raw?i:e}})}catch(r){return n(r)}return a&&a.then?a.then(void 0,n):a}(0,function(r){if(function(r){return Array.isArray(null==r?void 0:r.errors)}(r))return{values:{},errors:resolvers_r(n(r.errors,!u.shouldUseNativeValidation&&"all"===u.criteriaMode),u)};throw r}))}catch(r){return Promise.reject(r)}}};
//# sourceMappingURL=zod.module.js.map


/***/ }),

/***/ 30630:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 18770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 98788:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 90581:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 47842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 58013:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 33579:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 93520:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 70865:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47842);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 96670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 26297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 87394:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18770);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33579);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93520);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15459);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 92228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 77149:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18770);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33579);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93520);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15459);





function _toArray(arr) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 50930:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(30630);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 15459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30630);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 90162:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_axios; }
});

// NAMESPACE OBJECT: ../../node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": function() { return hasBrowserEnv; },
  "hasStandardBrowserEnv": function() { return hasStandardBrowserEnv; },
  "hasStandardBrowserWebWorkerEnv": function() { return hasStandardBrowserWebWorkerEnv; }
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(48834)["Buffer"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = (
  (product) => {
    return hasBrowserEnv && ['ReactNative', 'NativeScript', 'NS'].indexOf(product) < 0
  })(typeof navigator !== 'undefined' && navigator.product);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();



;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/index.js



/* harmony default export */ var platform = ({
  ...common_utils_namespaceObject,
  ...browser
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ var lib_defaults = (defaults);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ var cookies = (platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils.isString(path) && cookie.push('path=' + path);

      utils.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });


;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ var isURLSameOrigin = (platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/adapters/xhr.js
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    let {responseType, withXSRFToken} = config;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    let contentType;

    if (utils.isFormData(requestData)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else if ((contentType = requestHeaders.getContentType()) !== false) {
        // fix semicolon duplication issue for ReactNative FormData implementation
        const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
        requestHeaders.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if(platform.hasStandardBrowserEnv) {
      withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));

      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

        if (xsrfValue) {
          requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr
}

utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils.isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ var adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new core_AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/env/data.js
const VERSION = "1.6.8";
;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;

        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';

        if (!err.stack) {
          err.stack = stack;
          // match without the 2 top stack lines
        } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
          err.stack += '\n' + stack
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);


/***/ }),

/***/ 63955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KN": function() { return /* binding */ appendErrors; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "bc": function() { return /* binding */ useController; },
/* harmony export */   "cI": function() { return /* binding */ useForm; },
/* harmony export */   "qo": function() { return /* binding */ useWatch; },
/* harmony export */   "t8": function() { return /* binding */ set; }
/* harmony export */ });
/* unused harmony exports Controller, FormProvider, useFieldArray, useFormContext, useFormState */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var isPlainObject = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!Array.isArray(data) && !isPlainObject(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                copy[key] = cloneObject(data[key]);
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (!path || !isObject(obj)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
    return isUndefined(result) || result === obj
        ? isUndefined(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = (props) => {
    const { children, ...data } = props;
    return (React.createElement(HookFormContext.Provider, { value: data }, children));
};

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => exact && signalName
    ? name === signalName
    : !name ||
        !signalName ||
        name === signalName ||
        convertToArrayPayload(name).some((currentName) => currentName &&
            (currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = react__WEBPACK_IMPORTED_MODULE_0__.useRef(props);
    _props.current = props;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const subscription = !props.disabled &&
            _props.current.subject &&
            _props.current.subject.subscribe({
                next: _props.current.next,
            });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._formState);
    const _mounted = react__WEBPACK_IMPORTED_MODULE_0__.useRef(true);
    const _localProxyFormState = react__WEBPACK_IMPORTED_MODULE_0__.useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        next: (value) => _mounted.current &&
            shouldSubscribeByName(_name.current, value.name, exact) &&
            shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) &&
            updateFormState({
                ...control._formState,
                ...value,
            }),
        subject: control._subjects.state,
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return () => {
            _mounted.current = false;
        };
    }, [control]);
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.values,
        next: (formState) => {
            if (shouldSubscribeByName(_name.current, formState.name, exact)) {
                updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
            }
        },
    });
    const [value, updateValue] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._getWatch(name, defaultValue));
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => control._removeUnmounted());
    return value;
}

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(control.register(name, {
        ...props.rules,
        value,
    }));
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value = cloneObject(get(control._options.defaultValues, name));
            set(control._defaultValues, name, value);
            if (isUndefined(get(control._formValues, name))) {
                set(control._formValues, name, value);
            }
        }
        return () => {
            (isArrayField
                ? _shouldUnregisterField && !control._state.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    return {
        field: {
            name,
            value,
            onChange: react__WEBPACK_IMPORTED_MODULE_0__.useCallback((event) => _registerProps.current.onChange({
                target: {
                    value: getEventValue(event),
                    name: name,
                },
                type: EVENTS.CHANGE,
            }), [name]),
            onBlur: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => _registerProps.current.onBlur({
                target: {
                    value: get(control._formValues, name),
                    name: name,
                },
                type: EVENTS.BLUR,
            }), [name, control]),
            ref: (elm) => {
                const field = get(control._fields, name);
                if (field && elm) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            },
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                enumerable: true,
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                enumerable: true,
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                enumerable: true,
                get: () => get(formState.errors, name),
            },
        }),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                }
                else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject(currentField)) {
                focusFieldBy(currentField, callback);
            }
        }
    }
};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isBoolean = (value) => typeof value === 'boolean';

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isHTMLElement = (value) => {
    if (!isWeb) {
        return false;
    }
    const owner = value ? value.ownerDocument : 0;
    return (value instanceof
        (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement));
};

var isMessage = (value) => isString(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) &&
        isUndefined(ref.value) &&
        isUndefined(inputValue)) ||
        (isHTMLElement(ref) && ref.value === '') ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber ||
                (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) {
                exceedMax = isTime
                    ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                    : isWeek
                        ? inputValue > maxOutput.value
                        : valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value) && inputValue) {
                exceedMin = isTime
                    ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                    : isWeek
                        ? inputValue < minOutput.value
                        : valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

function append(data, value) {
    return [...data, ...convertToArrayPayload(value)];
}

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

function prepend(data, value) {
    return [...convertToArrayPayload(value), ...convertToArrayPayload(data)];
}

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    data[indexA] = [data[indexB], (data[indexB] = data[indexA])][0];
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (!isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path)
        ? path
        : isKey(path)
            ? [path]
            : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) {
        delete childObject[key];
    }
    if (index !== 0 &&
        ((isObject(childObject) && isEmptyObject(childObject)) ||
            (Array.isArray(childObject) && isEmptyArray(childObject)))) {
        unset(object, paths.slice(0, -1));
    }
    return object;
}

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = React.useState(control._getFieldArray(name));
    const ids = React.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = React.useRef(fields);
    const _name = React.useRef(name);
    const _actioned = React.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules &&
        control.register(name, props.rules);
    useSubscribe({
        next: ({ values, name: fieldArrayName, }) => {
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = get(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map(generateId);
                }
            }
        },
        subject: control._subjects.array,
    });
    const updateValues = React.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append$1 = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = append(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = append(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, append, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend$1 = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prepend(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prepend(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prepend, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    React.useEffect(() => {
        control._state.action = false;
        isWatched(name, control._names) &&
            control._subjects.state.next({
                ...control._formState,
            });
        if (_actioned.current &&
            (!getValidationModes(control._options.mode).isOnSubmit ||
                control._formState.isSubmitted)) {
            if (control._options.resolver) {
                control._executeSchema([name]).then((result) => {
                    const error = get(result.errors, name);
                    const existingError = get(control._formState.errors, name);
                    if (existingError ? !error && existingError.type : error && error.type) {
                        error
                            ? set(control._formState.errors, name, error)
                            : unset(control._formState.errors, name);
                        control._subjects.state.next({
                            errors: control._formState.errors,
                        });
                    }
                });
            }
            else {
                const field = get(control._fields, name);
                if (field && field._f) {
                    validateField(field, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error) => !isEmptyObject(error) &&
                        control._subjects.state.next({
                            errors: updateFieldArrayRootError(control._formState.errors, error, name),
                        }));
                }
            }
        }
        control._subjects.values.next({
            name,
            values: { ...control._formValues },
        });
        control._names.focus &&
            focusFieldBy(control._fields, (key) => !!key && key.startsWith(control._names.focus || ''));
        control._names.focus = '';
        control._updateValid();
    }, [fields, name, control]);
    React.useEffect(() => {
        !get(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: React.useCallback(swap, [updateValues, name, control]),
        move: React.useCallback(move, [updateValues, name, control]),
        prepend: React.useCallback(prepend$1, [updateValues, name, control]),
        append: React.useCallback(append$1, [updateValues, name, control]),
        remove: React.useCallback(remove, [updateValues, name, control]),
        insert: React.useCallback(insert$1, [updateValues, name, control]),
        update: React.useCallback(update, [updateValues, name, control]),
        replace: React.useCallback(replace, [updateValues, name, control]),
        fields: React.useMemo(() => fields.map((field, index) => ({
            ...field,
            [keyName]: ids.current[index] || generateId(),
        })), [fields, keyName]),
    };
}

function createSubject() {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next && observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : value
                ? +value
                : value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? rule
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {},
    };
    let _fields = {};
    let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values)
        ? cloneObject(_options.defaultValues || _options.values) || {}
        : {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        values: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = setTimeout(callback, wait);
    };
    const _updateValid = async (shouldUpdateValid) => {
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) {
                _subjects.state.next({
                    isValid,
                });
            }
        }
    };
    const _updateIsValidating = (value) => _proxyFormState.isValidating &&
        _subjects.state.next({
            isValidating: value,
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name,
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
            isPreviousDirty = get(_formState.dirtyFields, name);
            isCurrentFieldPristine
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField =
                shouldUpdateField ||
                    (_proxyFormState.dirtyFields &&
                        isPreviousDirty !== !isCurrentFieldPristine);
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = get(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                set(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField =
                    shouldUpdateField ||
                        (_proxyFormState.touchedFields &&
                            isPreviousFieldTouched !== isBlurEvent);
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid &&
            isBoolean(isValid) &&
            _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name) => _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema();
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
        ...(_state.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue),
    }, isGlobal, defaultValue);
    const _getFieldArray = (name) => compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.values.next({
                            name,
                            values: { ..._formValues },
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: { ..._formValues },
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _subjects.state.next({
                    name,
                    dirtyFields: getDirtyFields(_defaultValues, _formValues),
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({ ..._formState });
        _subjects.values.next({
            name,
            values: { ..._formValues },
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.values.next({
                    name,
                    type: event.type,
                    values: { ..._formValues },
                });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({ ..._formState });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = isEmptyObject(errors);
            }
            else {
                error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isFieldValueUpdated =
                    isNaN(fieldValue) ||
                        fieldValue === get(_formValues, name, fieldValue);
                if (isFieldValueUpdated) {
                    if (error) {
                        isValid = false;
                    }
                    else if (_proxyFormState.isValid) {
                        isValid = await executeBuiltInValidation(_fields, true);
                    }
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps &&
                    trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver || !name ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            focusFieldBy(_fields, (key) => key && get(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_state.mount ? _formValues : {}),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name &&
            convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {},
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.values.subscribe({
            next: (payload) => name(_getWatch(undefined, defaultValue), payload),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister &&
                !options.keepDefaultValue &&
                unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: { ..._formValues },
        });
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            ...(field || {}),
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        field
            ? disabledIsDefined &&
                set(_formValues, name, options.disabled
                    ? undefined
                    : get(_formValues, name, getFieldValue(field._f)))
            : updateValidAndValue(name, true, options.value);
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.shouldUseNativeValidation
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(Array.isArray(get(_defaultValues, name)) ? [{}] : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _state.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const _focusError = () => _options.shouldFocusError &&
        focusFieldBy(_fields, (key) => key && get(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        if (_options.resolver) {
            const { errors, values } = await _executeSchema();
            _formState.errors = errors;
            fieldValues = values;
        }
        else {
            await executeBuiltInValidation(_fields);
        }
        unset(_formState.errors, 'root');
        if (isEmptyObject(_formState.errors)) {
            _subjects.state.next({
                errors: {},
            });
            await onValid(fieldValues, e);
        }
        else {
            if (onInvalid) {
                await onInvalid({ ..._formState.errors }, e);
            }
            _focusError();
            setTimeout(_focusError);
        }
        _subjects.state.next({
            isSubmitted: true,
            isSubmitting: false,
            isSubmitSuccessful: isEmptyObject(_formState.errors),
            submitCount: _formState.submitCount + 1,
            errors: _formState.errors,
        });
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, get(_defaultValues, name));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, get(_defaultValues, name))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            if (isHTMLElement(fieldReference)) {
                                const form = fieldReference.closest('form');
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneUpdatedValues;
            _subjects.array.next({
                values: { ...values },
            });
            _subjects.values.next({
                values: { ...values },
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirtyValues
                ? _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
        ? formValues(_formValues)
        : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs
                ? fieldReference.refs[0]
                : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState) => {
        _formState = {
            ..._formState,
            ...updatedFormState,
        };
    };
    const _resetDefaultValues = () => isFunction(_options.defaultValues) &&
        _options.defaultValues().then((values) => {
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false,
            });
        });
    return {
        control: {
            register,
            unregister,
            getFieldState,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _updateFormState,
            _subjects,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _state() {
                return _state;
            },
            set _state(value) {
                _state = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        isDirty: false,
        isValidating: false,
        isLoading: isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: isFunction(props.defaultValues)
            ? undefined
            : props.defaultValues,
    });
    if (!_formControl.current) {
        _formControl.current = {
            ...createFormControl(props, () => updateFormState((formState) => ({ ...formState }))),
            formState,
        };
    }
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        next: (value) => {
            if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
                updateFormState({ ...control._formState });
            }
        },
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (props.values && !deepEqual(props.values, control._defaultValues)) {
            control._reset(props.values, control._options.resetOptions);
        }
        else {
            control._resetDefaultValues();
        }
    }, [props.values, control]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({ ...control._formState });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}


//# sourceMappingURL=index.esm.mjs.map


/***/ }),

/***/ 14080:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* unused harmony export SkeletonTheme */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
'use client';


/**
 * @internal
 */
const SkeletonThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: i },
                skeletonSpan,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null)));
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { key: i }, el))
        : elements));
}

function SkeletonTheme({ children, ...styleOptions }) {
    return (React.createElement(SkeletonThemeContext.Provider, { value: styleOptions }, children));
}




/***/ }),

/***/ 49857:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ useSWR; }
/* harmony export */ });
/* unused harmony exports SWRConfig, mutate, unstable_serialize, useSWRConfig */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var noop = function () { };
// Using noop() as the undefined value as undefined can possibly be replaced
// by something else.  Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var UNDEFINED = ( /*#__NOINLINE__*/noop());
var OBJECT = Object;
var isUndefined = function (v) { return v === UNDEFINED; };
var isFunction = function (v) { return typeof v == 'function'; };
var mergeObjects = function (a, b) { return OBJECT.assign({}, a, b); };
var STR_UNDEFINED = 'undefined';
// NOTE: Use function to guarantee it's re-evaluated between jsdom and node runtime for tests.
var hasWindow = function () { return typeof window != STR_UNDEFINED; };
var hasDocument = function () { return typeof document != STR_UNDEFINED; };
var hasRequestAnimationFrame = function () {
    return hasWindow() && typeof window['requestAnimationFrame'] != STR_UNDEFINED;
};

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var table = new WeakMap();
// counter of the key
var counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsible.
var stableHash = function (arg) {
    var type = typeof arg;
    var constructor = arg && arg.constructor;
    var isDate = constructor == Date;
    var result;
    var index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result)
            return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for (index = 0; index < arg.length; index++) {
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            var keys = OBJECT.keys(arg).sort();
            while (!isUndefined((index = keys.pop()))) {
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    }
    else {
        result = isDate
            ? arg.toJSON()
            : type == 'symbol'
                ? arg.toString()
                : type == 'string'
                    ? JSON.stringify(arg)
                    : '' + arg;
    }
    return result;
};

/**
 * Due to bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a work around, we always assume it's online on first load, and change
 * the status upon `online` or `offline` events.
 */
var online = true;
var isOnline = function () { return online; };
var hasWin = hasWindow();
var hasDoc = hasDocument();
// For node and React Native, `add/removeEventListener` doesn't exist on window.
var onWindowEvent = hasWin && window.addEventListener
    ? window.addEventListener.bind(window)
    : noop;
var onDocumentEvent = hasDoc ? document.addEventListener.bind(document) : noop;
var offWindowEvent = hasWin && window.removeEventListener
    ? window.removeEventListener.bind(window)
    : noop;
var offDocumentEvent = hasDoc
    ? document.removeEventListener.bind(document)
    : noop;
var isVisible = function () {
    var visibilityState = hasDoc && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
var initFocus = function (callback) {
    // focus revalidate
    onDocumentEvent('visibilitychange', callback);
    onWindowEvent('focus', callback);
    return function () {
        offDocumentEvent('visibilitychange', callback);
        offWindowEvent('focus', callback);
    };
};
var initReconnect = function (callback) {
    // revalidate on reconnected
    var onOnline = function () {
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    var onOffline = function () {
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return function () {
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
var preset = {
    isOnline: isOnline,
    isVisible: isVisible
};
var defaultConfigOptions = {
    initFocus: initFocus,
    initReconnect: initReconnect
};

var IS_SERVER = !hasWindow() || 'Deno' in window;
// Polyfill requestAnimationFrame
var rAF = function (f) {
    return hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var useIsomorphicLayoutEffect = IS_SERVER ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
var navigatorConnection = typeof navigator !== 'undefined' &&
    navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
var slowConnection = !IS_SERVER &&
    navigatorConnection &&
    (['slow-2g', '2g'].includes(navigatorConnection.effectiveType) ||
        navigatorConnection.saveData);

var serialize = function (key) {
    if (isFunction(key)) {
        try {
            key = key();
        }
        catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    var args = [].concat(key);
    // If key is not falsy, or not an empty array, hash it.
    key =
        typeof key == 'string'
            ? key
            : (Array.isArray(key) ? key.length : key)
                ? stableHash(key)
                : '';
    var infoKey = key ? '$swr$' + key : '';
    return [key, args, infoKey];
};

// Global state used to deduplicate requests and store listeners
var SWRGlobalState = new WeakMap();

var FOCUS_EVENT = 0;
var RECONNECT_EVENT = 1;
var MUTATE_EVENT = 2;

var broadcastState = function (cache, key, data, error, isValidating, revalidate, broadcast) {
    if (broadcast === void 0) { broadcast = true; }
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], FETCH = _a[3];
    var revalidators = EVENT_REVALIDATORS[key];
    var updaters = STATE_UPDATERS[key];
    // Cache was populated, update states of all hooks.
    if (broadcast && updaters) {
        for (var i = 0; i < updaters.length; ++i) {
            updaters[i](data, error, isValidating);
        }
    }
    // If we also need to revalidate, only do it for the first hook.
    if (revalidate) {
        // Invalidate the key by deleting the concurrent request markers so new
        // requests will not be deduped.
        delete FETCH[key];
        if (revalidators && revalidators[0]) {
            return revalidators[0](MUTATE_EVENT).then(function () {
                return cache.get(key);
            });
        }
    }
    return cache.get(key);
};

// Global timestamp.
var __timestamp = 0;
var getTimestamp = function () { return ++__timestamp; };

var internalMutate = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var cache, _key, _data, _opts, options, populateCache, revalidate, rollbackOnError, customOptimisticData, _a, key, keyInfo, _b, MUTATION, data, error, beforeMutationTs, hasCustomOptimisticData, rollbackData, optimisticData, res;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    cache = args[0], _key = args[1], _data = args[2], _opts = args[3];
                    options = typeof _opts === 'boolean' ? { revalidate: _opts } : _opts || {};
                    populateCache = isUndefined(options.populateCache)
                        ? true
                        : options.populateCache;
                    revalidate = options.revalidate !== false;
                    rollbackOnError = options.rollbackOnError !== false;
                    customOptimisticData = options.optimisticData;
                    _a = serialize(_key), key = _a[0], keyInfo = _a[2];
                    if (!key)
                        return [2 /*return*/];
                    _b = SWRGlobalState.get(cache), MUTATION = _b[2];
                    // If there is no new data provided, revalidate the key with current state.
                    if (args.length < 3) {
                        // Revalidate and broadcast state.
                        return [2 /*return*/, broadcastState(cache, key, cache.get(key), UNDEFINED, UNDEFINED, revalidate, true)];
                    }
                    data = _data;
                    beforeMutationTs = getTimestamp();
                    MUTATION[key] = [beforeMutationTs, 0];
                    hasCustomOptimisticData = !isUndefined(customOptimisticData);
                    rollbackData = cache.get(key);
                    // Do optimistic data update.
                    if (hasCustomOptimisticData) {
                        optimisticData = isFunction(customOptimisticData)
                            ? customOptimisticData(rollbackData)
                            : customOptimisticData;
                        cache.set(key, optimisticData);
                        broadcastState(cache, key, optimisticData);
                    }
                    if (isFunction(data)) {
                        // `data` is a function, call it passing current cache value.
                        try {
                            data = data(cache.get(key));
                        }
                        catch (err) {
                            // If it throws an error synchronously, we shouldn't update the cache.
                            error = err;
                        }
                    }
                    if (!(data && isFunction(data.then))) return [3 /*break*/, 2];
                    return [4 /*yield*/, data.catch(function (err) {
                            error = err;
                        })
                        // Check if other mutations have occurred since we've started this mutation.
                        // If there's a race we don't update cache or broadcast the change,
                        // just return the data.
                    ];
                case 1:
                    // This means that the mutation is async, we need to check timestamps to
                    // avoid race conditions.
                    data = _c.sent();
                    // Check if other mutations have occurred since we've started this mutation.
                    // If there's a race we don't update cache or broadcast the change,
                    // just return the data.
                    if (beforeMutationTs !== MUTATION[key][0]) {
                        if (error)
                            throw error;
                        return [2 /*return*/, data];
                    }
                    else if (error && hasCustomOptimisticData && rollbackOnError) {
                        // Rollback. Always populate the cache in this case but without
                        // transforming the data.
                        populateCache = true;
                        data = rollbackData;
                        cache.set(key, rollbackData);
                    }
                    _c.label = 2;
                case 2:
                    // If we should write back the cache after request.
                    if (populateCache) {
                        if (!error) {
                            // Transform the result into data.
                            if (isFunction(populateCache)) {
                                data = populateCache(data, rollbackData);
                            }
                            // Only update cached data if there's no error. Data can be `undefined` here.
                            cache.set(key, data);
                        }
                        // Always update or reset the error.
                        cache.set(keyInfo, mergeObjects(cache.get(keyInfo), { error: error }));
                    }
                    // Reset the timestamp to mark the mutation has ended.
                    MUTATION[key][1] = getTimestamp();
                    return [4 /*yield*/, broadcastState(cache, key, data, error, UNDEFINED, revalidate, !!populateCache)
                        // Throw error or return data
                    ];
                case 3:
                    res = _c.sent();
                    // Throw error or return data
                    if (error)
                        throw error;
                    return [2 /*return*/, populateCache ? res : data];
            }
        });
    });
};

var revalidateAllKeys = function (revalidators, type) {
    for (var key in revalidators) {
        if (revalidators[key][0])
            revalidators[key][0](type);
    }
};
var initCache = function (provider, options) {
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that bound to
    // the cache.
    // Provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        var opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        var EVENT_REVALIDATORS = {};
        var mutate = internalMutate.bind(UNDEFINED, provider);
        var unmount = noop;
        // Update the state if it's new, or the provider has been extended.
        SWRGlobalState.set(provider, [EVENT_REVALIDATORS, {}, {}, {}, mutate]);
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        if (!IS_SERVER) {
            // When listening to the native events for auto revalidations,
            // we intentionally put a delay (setTimeout) here to make sure they are
            // fired after immediate JavaScript executions, which can possibly be
            // React's state updates.
            // This avoids some unnecessary revalidations such as
            // https://github.com/vercel/swr/issues/1680.
            var releaseFocus_1 = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
            var releaseReconnect_1 = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
            unmount = function () {
                releaseFocus_1 && releaseFocus_1();
                releaseReconnect_1 && releaseReconnect_1();
                // When un-mounting, we need to remove the cache provider from the state
                // storage too because it's a side-effect. Otherwise when re-mounting we
                // will not re-register those event listeners.
                SWRGlobalState.delete(provider);
            };
        }
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [provider, mutate, unmount];
    }
    return [provider, SWRGlobalState.get(provider)[4]];
};

// error retry
var onErrorRetry = function (_, __, config, revalidate, opts) {
    var maxRetryCount = config.errorRetryCount;
    var currentRetryCount = opts.retryCount;
    // Exponential backoff
    var timeout = ~~((Math.random() + 0.5) *
        (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
// Default cache provider
var _a = initCache(new Map()), cache = _a[0], mutate = _a[1];
// Default config
var defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry: onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare: function (currentData, newData) {
        return stableHash(currentData) == stableHash(newData);
    },
    isPaused: function () { return false; },
    cache: cache,
    mutate: mutate,
    fallback: {}
}, 
// use web preset by default
preset);

var mergeConfigs = function (a, b) {
    // Need to create a new object to avoid mutating the original here.
    var v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        var u1 = a.use, f1 = a.fallback;
        var u2 = b.use, f2 = b.fallback;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

var SWRConfigContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var SWRConfig$1 = function (props) {
    var value = props.value;
    // Extend parent context values and middleware.
    var extendedConfig = mergeConfigs((0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext), value);
    // Should not use the inherited provider.
    var provider = value && value.provider;
    // Use a lazy initialized state to create the cache on first access.
    var cacheContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
        return provider
            ? initCache(provider(extendedConfig.cache || cache), value)
            : UNDEFINED;
    })[0];
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(function () { return (cacheContext ? cacheContext[2] : UNDEFINED); }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

/**
 * An implementation of state with dependency-tracking.
 */
var useStateWithDeps = function (state, unmountedRef) {
    var rerender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({})[1];
    var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(state);
    // If a state property (data, error or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    var stateDependenciesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
     * @param payload To change stateRef, pass the values explicitly to setState:
     * @example
     * ```js
     * setState({
     *   isValidating: false
     *   data: newData // set data to newData
     *   error: undefined // set error to undefined
     * })
     *
     * setState({
     *   isValidating: false
     *   data: undefined // set data to undefined
     *   error: err // set error to err
     * })
     * ```
     */
    var setState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (payload) {
        var shouldRerender = false;
        var currentState = stateRef.current;
        for (var _ in payload) {
            var k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            rerender({});
        }
    }, 
    // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update the state reference.
    useIsomorphicLayoutEffect(function () {
        stateRef.current = state;
    });
    return [stateRef, stateDependenciesRef.current, setState];
};

var normalize = function (args) {
    return isFunction(args[1])
        ? [args[0], args[1], args[2] || {}]
        : [args[0], null, (args[1] === null ? args[2] : args[1]) || {}];
};

var useSWRConfig = function () {
    return mergeObjects(defaultConfig, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext));
};

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
var withArgs = function (hook) {
    return function useSWRArgs() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Get the default and inherited configuration.
        var fallbackConfig = useSWRConfig();
        // Normalize arguments.
        var _a = normalize(args), key = _a[0], fn = _a[1], _config = _a[2];
        // Merge configurations.
        var config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        var next = hook;
        var use = config.use;
        if (use) {
            for (var i = use.length; i-- > 0;) {
                next = use[i](next);
            }
        }
        return next(key, fn || config.fetcher, config);
    };
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
var subscribeCallback = function (key, callbacks, callback) {
    var keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return function () {
        var index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

var WITH_DEDUPE = { dedupe: true };
var useSWRHandler = function (_key, fetcher, config) {
    var cache = config.cache, compare = config.compare, fallbackData = config.fallbackData, suspense = config.suspense, revalidateOnMount = config.revalidateOnMount, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline;
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], MUTATION = _a[2], FETCH = _a[3];
    // `key` is the identifier of the SWR `data` state, `keyInfo` holds extra
    // states such as `error` and `isValidating` inside,
    // all of them are derived from `_key`.
    // `fnArgs` is an array of arguments parsed from the key, which will be passed
    // to the fetcher.
    var _b = serialize(_key), key = _b[0], fnArgs = _b[1], keyInfo = _b[2];
    // If it's the initial render of this hook.
    var initialMountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    var unmountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // Refs to keep the key and config.
    var keyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(key);
    var fetcherRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fetcher);
    var configRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(config);
    var getConfig = function () { return configRef.current; };
    var isActive = function () { return getConfig().isVisible() && getConfig().isOnline(); };
    var patchFetchInfo = function (info) {
        return cache.set(keyInfo, mergeObjects(cache.get(keyInfo), info));
    };
    // Get the current state that SWR should return.
    var cached = cache.get(key);
    var fallback = isUndefined(fallbackData)
        ? config.fallback[key]
        : fallbackData;
    var data = isUndefined(cached) ? fallback : cached;
    var info = cache.get(keyInfo) || {};
    var error = info.error;
    var isInitialMount = !initialMountedRef.current;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    var shouldRevalidate = function () {
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !isUndefined(revalidateOnMount))
            return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused())
            return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately on mount again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense)
            return isUndefined(data) ? false : config.revalidateIfStale;
        // If there is no stale data, we need to revalidate on mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return isUndefined(data) || config.revalidateIfStale;
    };
    // Resolve the current validating state.
    var resolveValidating = function () {
        if (!key || !fetcher)
            return false;
        if (info.isValidating)
            return true;
        // If it's not mounted yet and it should revalidate on mount, revalidate.
        return isInitialMount && shouldRevalidate();
    };
    var isValidating = resolveValidating();
    var _c = useStateWithDeps({
        data: data,
        error: error,
        isValidating: isValidating
    }, unmountedRef), stateRef = _c[0], stateDependencies = _c[1], setState = _c[2];
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    var revalidate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (revalidateOpts) { return __awaiter(void 0, void 0, void 0, function () {
        var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, isCurrentKeyMounted, cleanupState, newState, finishRequestAndUpdateState, mutationInfo, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentFetcher = fetcherRef.current;
                    if (!key ||
                        !currentFetcher ||
                        unmountedRef.current ||
                        getConfig().isPaused()) {
                        return [2 /*return*/, false];
                    }
                    loading = true;
                    opts = revalidateOpts || {};
                    shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
                    isCurrentKeyMounted = function () {
                        return !unmountedRef.current &&
                            key === keyRef.current &&
                            initialMountedRef.current;
                    };
                    cleanupState = function () {
                        // Check if it's still the same request before deleting.
                        var requestInfo = FETCH[key];
                        if (requestInfo && requestInfo[1] === startAt) {
                            delete FETCH[key];
                        }
                    };
                    newState = { isValidating: false };
                    finishRequestAndUpdateState = function () {
                        patchFetchInfo({ isValidating: false });
                        // We can only set state if it's safe (still mounted with the same key).
                        if (isCurrentKeyMounted()) {
                            setState(newState);
                        }
                    };
                    // Start fetching. Change the `isValidating` state, update the cache.
                    patchFetchInfo({
                        isValidating: true
                    });
                    setState({ isValidating: true });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    if (shouldStartNewRequest) {
                        // Tell all other hooks to change the `isValidating` state.
                        broadcastState(cache, key, stateRef.current.data, stateRef.current.error, true);
                        // If no cache being rendered currently (it shows a blank page),
                        // we trigger the loading slow event.
                        if (config.loadingTimeout && !cache.get(key)) {
                            setTimeout(function () {
                                if (loading && isCurrentKeyMounted()) {
                                    getConfig().onLoadingSlow(key, config);
                                }
                            }, config.loadingTimeout);
                        }
                        // Start the request and save the timestamp.
                        FETCH[key] = [currentFetcher.apply(void 0, fnArgs), getTimestamp()];
                    }
                    _a = FETCH[key], newData = _a[0], startAt = _a[1];
                    return [4 /*yield*/, newData];
                case 2:
                    newData = _b.sent();
                    if (shouldStartNewRequest) {
                        // If the request isn't interrupted, clean it up after the
                        // deduplication interval.
                        setTimeout(cleanupState, config.dedupingInterval);
                    }
                    // If there're other ongoing request(s), started after the current one,
                    // we need to ignore the current one to avoid possible race conditions:
                    //   req1------------------>res1        (current one)
                    //        req2---------------->res2
                    // the request that fired later will always be kept.
                    // The timestamp maybe be `undefined` or a number
                    if (!FETCH[key] || FETCH[key][1] !== startAt) {
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Clear error.
                    patchFetchInfo({
                        error: UNDEFINED
                    });
                    newState.error = UNDEFINED;
                    mutationInfo = MUTATION[key];
                    if (!isUndefined(mutationInfo) &&
                        // case 1
                        (startAt <= mutationInfo[0] ||
                            // case 2
                            startAt <= mutationInfo[1] ||
                            // case 3
                            mutationInfo[1] === 0)) {
                        finishRequestAndUpdateState();
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Deep compare with latest state to avoid extra re-renders.
                    // For local state, compare and assign.
                    if (!compare(stateRef.current.data, newData)) {
                        newState.data = newData;
                    }
                    else {
                        // data and newData are deeply equal
                        // it should be safe to broadcast the stale data
                        newState.data = stateRef.current.data;
                        // At the end of this function, `brocastState` invokes the `onStateUpdate` function,
                        // which takes care of avoiding the re-render
                    }
                    // For global state, it's possible that the key has changed.
                    // https://github.com/vercel/swr/pull/1058
                    if (!compare(cache.get(key), newData)) {
                        cache.set(key, newData);
                    }
                    // Trigger the successful callback if it's the original request.
                    if (shouldStartNewRequest) {
                        if (isCurrentKeyMounted()) {
                            getConfig().onSuccess(newData, key, config);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    cleanupState();
                    // Not paused, we continue handling the error. Otherwise discard it.
                    if (!getConfig().isPaused()) {
                        // Get a new error, don't use deep comparison for errors.
                        patchFetchInfo({ error: err_1 });
                        newState.error = err_1;
                        // Error event and retry logic. Only for the actual request, not
                        // deduped ones.
                        if (shouldStartNewRequest && isCurrentKeyMounted()) {
                            getConfig().onError(err_1, key, config);
                            if ((typeof config.shouldRetryOnError === 'boolean' &&
                                config.shouldRetryOnError) ||
                                (isFunction(config.shouldRetryOnError) &&
                                    config.shouldRetryOnError(err_1))) {
                                // When retrying, dedupe is always enabled
                                if (isActive()) {
                                    // If it's active, stop. It will auto revalidate when refocusing
                                    // or reconnecting.
                                    getConfig().onErrorRetry(err_1, key, config, revalidate, {
                                        retryCount: (opts.retryCount || 0) + 1,
                                        dedupe: true
                                    });
                                }
                            }
                        }
                    }
                    return [3 /*break*/, 4];
                case 4:
                    // Mark loading as stopped.
                    loading = false;
                    // Update the current hook's state.
                    finishRequestAndUpdateState();
                    // Here is the source of the request, need to tell all other hooks to
                    // update their states.
                    if (isCurrentKeyMounted() && shouldStartNewRequest) {
                        broadcastState(cache, key, newState.data, newState.error, false);
                    }
                    return [2 /*return*/, true];
            }
        });
    }); }, 
    // `setState` is immutable, and `eventsCallback`, `fnArgs`, `keyInfo`,
    // and `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [key]);
    // Similar to the global mutate, but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var boundMutate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    // By using `bind` we don't need to modify the size of the rest arguments.
    // Due to https://github.com/microsoft/TypeScript/issues/37181, we have to
    // cast it to any for now.
    internalMutate.bind(UNDEFINED, cache, function () { return keyRef.current; }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update fetcher and config refs.
    useIsomorphicLayoutEffect(function () {
        fetcherRef.current = fetcher;
        configRef.current = config;
    });
    // After mounted or key changed.
    useIsomorphicLayoutEffect(function () {
        if (!key)
            return;
        var keyChanged = key !== keyRef.current;
        var softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
        // Expose state updater to global event listeners. So we can update hook's
        // internal state from the outside.
        var onStateUpdate = function (updatedData, updatedError, updatedIsValidating) {
            setState(mergeObjects({
                error: updatedError,
                isValidating: updatedIsValidating
            }, 
            // Since `setState` only shallowly compares states, we do a deep
            // comparison here.
            compare(stateRef.current.data, updatedData)
                ? UNDEFINED
                : {
                    data: updatedData
                }));
        };
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        var nextFocusRevalidatedAt = 0;
        var onRevalidate = function (type) {
            if (type == FOCUS_EVENT) {
                var now = Date.now();
                if (getConfig().revalidateOnFocus &&
                    now > nextFocusRevalidatedAt &&
                    isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            }
            else if (type == RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            }
            else if (type == MUTATE_EVENT) {
                return revalidate();
            }
            return;
        };
        var unsubUpdate = subscribeCallback(key, STATE_UPDATERS, onStateUpdate);
        var unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // When `key` updates, reset the state to the initial value
        // and trigger a rerender if necessary.
        if (keyChanged) {
            setState({
                data: data,
                error: error,
                isValidating: isValidating
            });
        }
        // Trigger a revalidation.
        if (shouldRevalidate()) {
            if (isUndefined(data) || IS_SERVER) {
                // Revalidate immediately.
                softRevalidate();
            }
            else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                rAF(softRevalidate);
            }
        }
        return function () {
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubUpdate();
            unsubEvents();
        };
    }, [key, revalidate]);
    // Polling
    useIsomorphicLayoutEffect(function () {
        var timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            var interval = isFunction(refreshInterval)
                ? refreshInterval(data)
                : refreshInterval;
            // We only start next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online and not errored.
            if (!stateRef.current.error &&
                (refreshWhenHidden || getConfig().isVisible()) &&
                (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            }
            else {
                // Schedule next interval to check again.
                next();
            }
        }
        next();
        return function () {
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [refreshInterval, refreshWhenHidden, refreshWhenOffline, revalidate]);
    // Display debug info in React DevTools.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useDebugValue)(data);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && isUndefined(data) && key) {
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        throw isUndefined(error) ? revalidate(WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data() {
            stateDependencies.data = true;
            return data;
        },
        get error() {
            stateDependencies.error = true;
            return error;
        },
        get isValidating() {
            stateDependencies.isValidating = true;
            return isValidating;
        }
    };
};
var SWRConfig = OBJECT.defineProperty(SWRConfig$1, 'default', {
    value: defaultConfig
});
var unstable_serialize = function (key) { return serialize(key)[0]; };
var useSWR = withArgs(useSWRHandler);

// useSWR




/***/ }),

/***/ 30195:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O7": function() { return /* binding */ booleanType; },
/* harmony export */   "Ry": function() { return /* binding */ objectType; },
/* harmony export */   "Z_": function() { return /* binding */ stringType; },
/* harmony export */   "i0": function() { return /* binding */ literalType; },
/* harmony export */   "z": function() { return /* binding */ z; }
/* harmony export */ });
/* unused harmony exports BRAND, DIRTY, EMPTY_PATH, INVALID, NEVER, OK, ParseStatus, Schema, ZodAny, ZodArray, ZodBigInt, ZodBoolean, ZodBranded, ZodCatch, ZodDate, ZodDefault, ZodDiscriminatedUnion, ZodEffects, ZodEnum, ZodError, ZodFirstPartyTypeKind, ZodFunction, ZodIntersection, ZodIssueCode, ZodLazy, ZodLiteral, ZodMap, ZodNaN, ZodNativeEnum, ZodNever, ZodNull, ZodNullable, ZodNumber, ZodObject, ZodOptional, ZodParsedType, ZodPipeline, ZodPromise, ZodReadonly, ZodRecord, ZodSchema, ZodSet, ZodString, ZodSymbol, ZodTransformer, ZodTuple, ZodType, ZodUndefined, ZodUnion, ZodUnknown, ZodVoid, addIssueToContext, any, array, bigint, coerce, custom, date, datetimeRegex, default, defaultErrorMap, discriminatedUnion, effect, enum, function, getErrorMap, getParsedType, instanceof, intersection, isAborted, isAsync, isDirty, isValid, late, lazy, makeIssue, map, nan, nativeEnum, never, null, nullable, number, objectUtil, oboolean, onumber, optional, ostring, pipeline, preprocess, promise, quotelessJson, record, set, setErrorMap, strictObject, symbol, transformer, tuple, undefined, union, unknown, util, void */
var util;
(function (util) {
    util.assertEqual = (val) => val;
    function assertIs(_arg) { }
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
            obj[item] = item;
        }
        return obj;
    };
    util.getValidEnumValues = (obj) => {
        const validKeys = util.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys) {
            filtered[k] = obj[k];
        }
        return util.objectValues(filtered);
    };
    util.objectValues = (obj) => {
        return util.objectKeys(obj).map(function (e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
        ? (obj) => Object.keys(obj) // eslint-disable-line ban/ban
        : (object) => {
            const keys = [];
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    keys.push(key);
                }
            }
            return keys;
        };
    util.find = (arr, checker) => {
        for (const item of arr) {
            if (checker(item))
                return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function"
        ? (val) => Number.isInteger(val) // eslint-disable-line ban/ban
        : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array
            .map((val) => (typeof val === "string" ? `'${val}'` : val))
            .join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
            return value.toString();
        }
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function (objectUtil) {
    objectUtil.mergeShapes = (first, second) => {
        return {
            ...first,
            ...second, // second overwrites first
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set",
]);
const getParsedType = (data) => {
    const t = typeof data;
    switch (t) {
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) {
                return ZodParsedType.array;
            }
            if (data === null) {
                return ZodParsedType.null;
            }
            if (data.then &&
                typeof data.then === "function" &&
                data.catch &&
                typeof data.catch === "function") {
                return ZodParsedType.promise;
            }
            if (typeof Map !== "undefined" && data instanceof Map) {
                return ZodParsedType.map;
            }
            if (typeof Set !== "undefined" && data instanceof Set) {
                return ZodParsedType.set;
            }
            if (typeof Date !== "undefined" && data instanceof Date) {
                return ZodParsedType.date;
            }
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

const ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite",
]);
const quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub) => {
            this.issues = [...this.issues, sub];
        };
        this.addIssues = (subs = []) => {
            this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            // eslint-disable-next-line ban/ban
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper ||
            function (issue) {
                return issue.message;
            };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
            for (const issue of error.issues) {
                if (issue.code === "invalid_union") {
                    issue.unionErrors.map(processError);
                }
                else if (issue.code === "invalid_return_type") {
                    processError(issue.returnTypeError);
                }
                else if (issue.code === "invalid_arguments") {
                    processError(issue.argumentsError);
                }
                else if (issue.path.length === 0) {
                    fieldErrors._errors.push(mapper(issue));
                }
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while (i < issue.path.length) {
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) {
                            curr[el] = curr[el] || { _errors: [] };
                            // if (typeof el === "string") {
                            //   curr[el] = curr[el] || { _errors: [] };
                            // } else if (typeof el === "number") {
                            //   const errorArray: any = [];
                            //   errorArray._errors = [];
                            //   curr[el] = curr[el] || errorArray;
                            // }
                        }
                        else {
                            curr[el] = curr[el] || { _errors: [] };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof ZodError)) {
            throw new Error(`Not a ZodError: ${value}`);
        }
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues) {
            if (sub.path.length > 0) {
                fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                fieldErrors[sub.path[0]].push(mapper(sub));
            }
            else {
                formErrors.push(mapper(sub));
            }
        }
        return { formErrors, fieldErrors };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
};

const errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) {
                message = "Required";
            }
            else {
                message = `Expected ${issue.expected}, received ${issue.received}`;
            }
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") {
                        message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                    }
                }
                else if ("startsWith" in issue.validation) {
                    message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                }
                else if ("endsWith" in issue.validation) {
                    message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                }
                else {
                    util.assertNever(issue.validation);
                }
            }
            else if (issue.validation !== "regex") {
                message = `Invalid ${issue.validation}`;
            }
            else {
                message = "Invalid";
            }
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${issue.minimum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${new Date(Number(issue.minimum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint")
                message = `BigInt must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `smaller than or equal to`
                        : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return { message };
};

let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

const makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...(issueData.path || [])];
    const fullIssue = {
        ...issueData,
        path: fullPath,
    };
    if (issueData.message !== undefined) {
        return {
            ...issueData,
            path: fullPath,
            message: issueData.message,
        };
    }
    let errorMessage = "";
    const maps = errorMaps
        .filter((m) => !!m)
        .slice()
        .reverse();
    for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage,
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const overrideMap = getErrorMap();
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === errorMap ? undefined : errorMap, // then global default map
        ].filter((x) => !!x),
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor() {
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid")
            this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted")
            this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results) {
            if (s.status === "aborted")
                return INVALID;
            if (s.status === "dirty")
                status.dirty();
            arrayValue.push(s.value);
        }
        return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key,
                value,
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
            const { key, value } = pair;
            if (key.status === "aborted")
                return INVALID;
            if (value.status === "aborted")
                return INVALID;
            if (key.status === "dirty")
                status.dirty();
            if (value.status === "dirty")
                status.dirty();
            if (key.value !== "__proto__" &&
                (typeof value.value !== "undefined" || pair.alwaysSet)) {
                finalObject[key.value] = value.value;
            }
        }
        return { status: status.value, value: finalObject };
    }
}
const INVALID = Object.freeze({
    status: "aborted",
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));

var _ZodEnum_cache, _ZodNativeEnum_cache;
class ParseInputLazyPath {
    constructor(parent, value, path, key) {
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) {
                this._cachedPath.push(...this._path, ...this._key);
            }
            else {
                this._cachedPath.push(...this._path, this._key);
            }
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result) => {
    if (isValid(result)) {
        return { success: true, data: result.value };
    }
    else {
        if (!ctx.common.issues.length) {
            throw new Error("Validation failed but no issues detected.");
        }
        return {
            success: false,
            get error() {
                if (this._error)
                    return this._error;
                const error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            },
        };
    }
};
function processCreateParams(params) {
    if (!params)
        return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap)
        return { errorMap: errorMap, description };
    const customMap = (iss, ctx) => {
        var _a, _b;
        const { message } = params;
        if (iss.code === "invalid_enum_value") {
            return { message: message !== null && message !== void 0 ? message : ctx.defaultError };
        }
        if (typeof ctx.data === "undefined") {
            return { message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError };
        }
        if (iss.code !== "invalid_type")
            return { message: ctx.defaultError };
        return { message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError };
    };
    return { errorMap: customMap, description };
}
class ZodType {
    constructor(def) {
        /** Alias of safeParseAsync */
        this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return (ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent,
        });
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent,
            },
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) {
            throw new Error("Synchronous parse encountered promise.");
        }
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
        const result = await (isAsync(maybeAsyncResult)
            ? maybeAsyncResult
            : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val) => {
            if (typeof message === "string" || typeof message === "undefined") {
                return { message };
            }
            else if (typeof message === "function") {
                return message(val);
            }
            else {
                return message;
            }
        };
        return this._refinement((val, ctx) => {
            const result = check(val);
            const setError = () => ctx.addIssue({
                code: ZodIssueCode.custom,
                ...getIssueProperties(val),
            });
            if (typeof Promise !== "undefined" && result instanceof Promise) {
                return result.then((data) => {
                    if (!data) {
                        setError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!result) {
                setError();
                return false;
            }
            else {
                return true;
            }
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx) => {
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function"
                    ? refinementData(val, ctx)
                    : refinementData);
                return false;
            }
            else {
                return true;
            }
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "refinement", refinement },
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this, this._def);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([this, option], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "transform", transform },
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault,
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def),
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : () => def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch,
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description,
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
// faster, simpler, safer
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) {
        regex = `${regex}\\.\\d{${args.precision}}`;
    }
    else if (args.precision == null) {
        regex = `${regex}(\\.\\d+)?`;
    }
    return regex;
}
function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset)
        opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
        return true;
    }
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
        return true;
    }
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = String(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    else if (tooSmall) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    status.dirty();
                }
            }
            else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "emoji") {
                if (!emojiRegex) {
                    emojiRegex = new RegExp(_emojiRegex, "u");
                }
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "emoji",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "nanoid") {
                if (!nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "nanoid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid2",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ulid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "url") {
                try {
                    new URL(input.data);
                }
                catch (_a) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "url",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "trim") {
                input.data = input.data.trim();
            }
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { includes: check.value, position: check.position },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "toLowerCase") {
                input.data = input.data.toLowerCase();
            }
            else if (check.kind === "toUpperCase") {
                input.data = input.data.toUpperCase();
            }
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { startsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { endsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "date") {
                const regex = dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "date",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "time") {
                const regex = timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "time",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "duration") {
                if (!durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "duration",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ip",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "base64") {
                if (!base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "base64",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _regex(regex, validation, message) {
        return this.refinement((data) => regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message),
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    email(message) {
        return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
        return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    emoji(message) {
        return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    nanoid(message) {
        return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    cuid2(message) {
        return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
    }
    ulid(message) {
        return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
    }
    base64(message) {
        return this._addCheck({ kind: "base64", ...errorUtil.errToObj(message) });
    }
    ip(options) {
        return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") {
            return this._addCheck({
                kind: "datetime",
                precision: null,
                offset: false,
                local: false,
                message: options,
            });
        }
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    date(message) {
        return this._addCheck({ kind: "date", message });
    }
    time(options) {
        if (typeof options === "string") {
            return this._addCheck({
                kind: "time",
                precision: null,
                message: options,
            });
        }
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    duration(message) {
        return this._addCheck({ kind: "duration", ...errorUtil.errToObj(message) });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message),
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message),
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message),
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil.errToObj(message),
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */
    nonempty(message) {
        return this.min(1, errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "trim" }],
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toLowerCase" }],
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toUpperCase" }],
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch) => ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch) => ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch) => ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch) => ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch) => ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params) => {
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return (valInt % stepInt) / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = Number(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "int") {
                if (!util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_finite,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message),
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message),
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil.toString(message),
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil.toString(message),
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int" ||
            (ch.kind === "multipleOf" && util.isInteger(ch.value)));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "finite" ||
                ch.kind === "int" ||
                ch.kind === "multipleOf") {
                return true;
            }
            else if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
            else if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params) => {
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodBigInt extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = BigInt(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.bigint,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params) => {
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = Boolean(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params) => {
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = new Date(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime()),
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params) => {
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params),
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.symbol,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodSymbol.create = (params) => {
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params),
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params) => {
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params),
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params) => {
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params),
    });
};
class ZodAny extends ZodType {
    constructor() {
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params) => {
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params),
    });
};
class ZodUnknown extends ZodType {
    constructor() {
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params) => {
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params),
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType,
        });
        return INVALID;
    }
}
ZodNever.create = (params) => {
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params),
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params) => {
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params),
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                addIssueToContext(ctx, {
                    code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                    minimum: (tooSmall ? def.exactLength.value : undefined),
                    maximum: (tooBig ? def.exactLength.value : undefined),
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message,
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message,
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message,
                });
                status.dirty();
            }
        }
        if (ctx.common.async) {
            return Promise.all([...ctx.data].map((item, i) => {
                return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
            })).then((result) => {
                return ParseStatus.mergeArray(status, result);
            });
        }
        const result = [...ctx.data].map((item, i) => {
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: { value: minLength, message: errorUtil.toString(message) },
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: { value: maxLength, message: errorUtil.toString(message) },
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: { value: len, message: errorUtil.toString(message) },
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params) => {
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params),
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: () => newShape,
        });
    }
    else if (schema instanceof ZodArray) {
        return new ZodArray({
            ...schema._def,
            type: deepPartialify(schema.element),
        });
    }
    else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    }
    else {
        return schema;
    }
}
class ZodObject extends ZodType {
    constructor() {
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */
        this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */
        this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null)
            return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        return (this._cached = { shape, keys });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever &&
            this._def.unknownKeys === "strip")) {
            for (const key in ctx.data) {
                if (!shapeKeys.includes(key)) {
                    extraKeys.push(key);
                }
            }
        }
        const pairs = [];
        for (const key of shapeKeys) {
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: { status: "valid", value: key },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") {
                for (const key of extraKeys) {
                    pairs.push({
                        key: { status: "valid", value: key },
                        value: { status: "valid", value: ctx.data[key] },
                    });
                }
            }
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys,
                    });
                    status.dirty();
                }
            }
            else if (unknownKeys === "strip") ;
            else {
                throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
            }
        }
        else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys) {
                const value = ctx.data[key];
                pairs.push({
                    key: { status: "valid", value: key },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data,
                });
            }
        }
        if (ctx.common.async) {
            return Promise.resolve()
                .then(async () => {
                const syncPairs = [];
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    syncPairs.push({
                        key,
                        value,
                        alwaysSet: pair.alwaysSet,
                    });
                }
                return syncPairs;
            })
                .then((syncPairs) => {
                return ParseStatus.mergeObjectSync(status, syncPairs);
            });
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...(message !== undefined
                ? {
                    errorMap: (issue, ctx) => {
                        var _a, _b, _c, _d;
                        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys")
                            return {
                                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError,
                            };
                        return {
                            message: defaultError,
                        };
                    },
                }
                : {}),
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip",
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough",
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: () => ({
                ...this._def.shape(),
                ...augmentation,
            }),
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: () => ({
                ...this._def.shape(),
                ...merging._def.shape(),
            }),
            typeName: ZodFirstPartyTypeKind.ZodObject,
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index,
        });
    }
    pick(mask) {
        const shape = {};
        util.objectKeys(mask).forEach((key) => {
            if (mask[key] && this.shape[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    omit(mask) {
        const shape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (!mask[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    /**
     * @deprecated
     */
    deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) {
                newShape[key] = fieldSchema;
            }
            else {
                newShape[key] = fieldSchema.optional();
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    required(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (mask && !mask[key]) {
                newShape[key] = this.shape[key];
            }
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while (newField instanceof ZodOptional) {
                    newField = newField._def.innerType;
                }
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    keyof() {
        return createZodEnum(util.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results) {
                if (result.result.status === "valid") {
                    return result.result;
                }
            }
            for (const result of results) {
                if (result.result.status === "dirty") {
                    // add issues from dirty option
                    ctx.common.issues.push(...result.ctx.common.issues);
                    return result.result;
                }
            }
            // return invalid
            const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return Promise.all(options.map(async (option) => {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                return {
                    result: await option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx,
                    }),
                    ctx: childCtx,
                };
            })).then(handleResults);
        }
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options) {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx,
                });
                if (result.status === "valid") {
                    return result;
                }
                else if (result.status === "dirty" && !dirty) {
                    dirty = { result, ctx: childCtx };
                }
                if (childCtx.common.issues.length) {
                    issues.push(childCtx.common.issues);
                }
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues) => new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params) => {
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params),
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
        return getDiscriminator(type.schema);
    }
    else if (type instanceof ZodEffects) {
        return getDiscriminator(type.innerType());
    }
    else if (type instanceof ZodLiteral) {
        return [type.value];
    }
    else if (type instanceof ZodEnum) {
        return type.options;
    }
    else if (type instanceof ZodNativeEnum) {
        // eslint-disable-next-line ban/ban
        return util.objectValues(type.enum);
    }
    else if (type instanceof ZodDefault) {
        return getDiscriminator(type._def.innerType);
    }
    else if (type instanceof ZodUndefined) {
        return [undefined];
    }
    else if (type instanceof ZodNull) {
        return [null];
    }
    else if (type instanceof ZodOptional) {
        return [undefined, ...getDiscriminator(type.unwrap())];
    }
    else if (type instanceof ZodNullable) {
        return [null, ...getDiscriminator(type.unwrap())];
    }
    else if (type instanceof ZodBranded) {
        return getDiscriminator(type.unwrap());
    }
    else if (type instanceof ZodReadonly) {
        return getDiscriminator(type.unwrap());
    }
    else if (type instanceof ZodCatch) {
        return getDiscriminator(type._def.innerType);
    }
    else {
        return [];
    }
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [discriminator],
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
        else {
            return option._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options) {
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) {
                throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            }
            for (const value of discriminatorValues) {
                if (optionsMap.has(value)) {
                    throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                }
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params),
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
        return { valid: true, data: a };
    }
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b);
        const sharedKeys = util
            .objectKeys(a)
            .filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
    }
    else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) {
            return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
    }
    else if (aType === ZodParsedType.date &&
        bType === ZodParsedType.date &&
        +a === +b) {
        return { valid: true, data: a };
    }
    else {
        return { valid: false };
    }
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
            if (isAborted(parsedLeft) || isAborted(parsedRight)) {
                return INVALID;
            }
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types,
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) {
                status.dirty();
            }
            return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
            return Promise.all([
                this._def.left._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
                this._def.right._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
            ]).then(([left, right]) => handleParsed(left, right));
        }
        else {
            return handleParsed(this._def.left._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }), this._def.right._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }));
        }
    }
}
ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params),
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            status.dirty();
        }
        const items = [...ctx.data]
            .map((item, itemIndex) => {
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema)
                return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        })
            .filter((x) => !!x); // filter nulls
        if (ctx.common.async) {
            return Promise.all(items).then((results) => {
                return ParseStatus.mergeArray(status, results);
            });
        }
        else {
            return ParseStatus.mergeArray(status, items);
        }
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest,
        });
    }
}
ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params),
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
            pairs.push({
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (ctx.common.async) {
            return ParseStatus.mergeObjectAsync(status, pairs);
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) {
            return new ZodRecord({
                keyType: first,
                valueType: second,
                typeName: ZodFirstPartyTypeKind.ZodRecord,
                ...processCreateParams(third),
            });
        }
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second),
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"])),
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async () => {
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") {
                        return INVALID;
                    }
                    if (key.status === "dirty" || value.status === "dirty") {
                        status.dirty();
                    }
                    finalMap.set(key.value, value.value);
                }
                return { status: status.value, value: finalMap };
            });
        }
        else {
            const finalMap = new Map();
            for (const pair of pairs) {
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") {
                    return INVALID;
                }
                if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                }
                finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
        }
    }
}
ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params),
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message,
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message,
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements) {
                if (element.status === "aborted")
                    return INVALID;
                if (element.status === "dirty")
                    status.dirty();
                parsedSet.add(element.value);
            }
            return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) {
            return Promise.all(elements).then((elements) => finalizeSet(elements));
        }
        else {
            return finalizeSet(elements);
        }
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: { value: minSize, message: errorUtil.toString(message) },
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: { value: maxSize, message: errorUtil.toString(message) },
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params) => {
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params),
    });
};
class ZodFunction extends ZodType {
    constructor() {
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error,
                },
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error,
                },
            });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(async function (...args) {
                const error = new ZodError([]);
                const parsedArgs = await me._def.args
                    .parseAsync(args, params)
                    .catch((e) => {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type
                    .parseAsync(result, params)
                    .catch((e) => {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        }
        else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(function (...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) {
                    throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
                }
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) {
                    throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
                }
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create()),
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType,
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: (args
                ? args
                : ZodTuple.create([]).rest(ZodUnknown.create())),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params),
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
}
ZodLazy.create = (getter, params) => {
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params),
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params),
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params),
    });
}
class ZodEnum extends ZodType {
    constructor() {
        super(...arguments);
        _ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f")) {
            __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values), "f");
        }
        if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return ZodEnum.create(values, {
            ...this._def,
            ...newDef,
        });
    }
    exclude(values, newDef = this._def) {
        return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)), {
            ...this._def,
            ...newDef,
        });
    }
}
_ZodEnum_cache = new WeakMap();
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    constructor() {
        super(...arguments);
        _ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string &&
            ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f")) {
            __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util.getValidEnumValues(this._def.values)), "f");
        }
        if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
_ZodNativeEnum_cache = new WeakMap();
ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params),
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise &&
            ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise
            ? ctx.data
            : Promise.resolve(ctx.data);
        return OK(promisified.then((data) => {
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap,
            });
        }));
    }
}
ZodPromise.create = (schema, params) => {
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params),
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects
            ? this._def.schema.sourceType()
            : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg) => {
                addIssueToContext(ctx, arg);
                if (arg.fatal) {
                    status.abort();
                }
                else {
                    status.dirty();
                }
            },
            get path() {
                return ctx.path;
            },
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) {
                return Promise.resolve(processed).then(async (processed) => {
                    if (status.value === "aborted")
                        return INVALID;
                    const result = await this._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx,
                    });
                    if (result.status === "aborted")
                        return INVALID;
                    if (result.status === "dirty")
                        return DIRTY(result.value);
                    if (status.value === "dirty")
                        return DIRTY(result.value);
                    return result;
                });
            }
            else {
                if (status.value === "aborted")
                    return INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx,
                });
                if (result.status === "aborted")
                    return INVALID;
                if (result.status === "dirty")
                    return DIRTY(result.value);
                if (status.value === "dirty")
                    return DIRTY(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc) => {
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) {
                    return Promise.resolve(result);
                }
                if (result instanceof Promise) {
                    throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                }
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inner.status === "aborted")
                    return INVALID;
                if (inner.status === "dirty")
                    status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return { status: status.value, value: inner.value };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((inner) => {
                    if (inner.status === "aborted")
                        return INVALID;
                    if (inner.status === "dirty")
                        status.dirty();
                    return executeRefinement(inner.value).then(() => {
                        return { status: status.value, value: inner.value };
                    });
                });
            }
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (!isValid(base))
                    return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) {
                    throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                }
                return { status: status.value, value: result };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((base) => {
                    if (!isValid(base))
                        return base;
                    return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
                });
            }
        }
        util.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params),
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params),
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) {
            return OK(undefined);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) {
            return OK(null);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params) => {
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params),
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) {
            data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params) => {
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function"
            ? params.default
            : () => params.default,
        ...processCreateParams(params),
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: [],
            },
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx,
            },
        });
        if (isAsync(result)) {
            return result.then((result) => {
                return {
                    status: "valid",
                    value: result.status === "valid"
                        ? result.value
                        : this._def.catchValue({
                            get error() {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data,
                        }),
                };
            });
        }
        else {
            return {
                status: "valid",
                value: result.status === "valid"
                    ? result.value
                    : this._def.catchValue({
                        get error() {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data,
                    }),
            };
        }
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params) => {
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
        ...processCreateParams(params),
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
}
ZodNaN.create = (params) => {
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params),
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async () => {
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inResult.status === "aborted")
                    return INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return DIRTY(inResult.value);
                }
                else {
                    return this._def.out._parseAsync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx,
                    });
                }
            };
            return handleAsync();
        }
        else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
            if (inResult.status === "aborted")
                return INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value,
                };
            }
            else {
                return this._def.out._parseSync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline,
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data) => {
            if (isValid(data)) {
                data.value = Object.freeze(data.value);
            }
            return data;
        };
        return isAsync(result)
            ? result.then((data) => freeze(data))
            : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodReadonly.create = (type, params) => {
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params),
    });
};
function custom(check, params = {}, 
/**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */
fatal) {
    if (check)
        return ZodAny.create().superRefine((data, ctx) => {
            var _a, _b;
            if (!check(data)) {
                const p = typeof params === "function"
                    ? params(data)
                    : typeof params === "string"
                        ? { message: params }
                        : params;
                const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                const p2 = typeof p === "string" ? { message: p } : p;
                ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
            }
        });
    return ZodAny.create();
}
const late = {
    object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (
// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`,
}) => custom((data) => data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce = {
    string: ((arg) => ZodString.create({ ...arg, coerce: true })),
    number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
    boolean: ((arg) => ZodBoolean.create({
        ...arg,
        coerce: true,
    })),
    bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
    date: ((arg) => ZodDate.create({ ...arg, coerce: true })),
};
const NEVER = INVALID;

var z = /*#__PURE__*/Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () { return util; },
    get objectUtil () { return objectUtil; },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    datetimeRegex: datetimeRegex,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () { return ZodFirstPartyTypeKind; },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});




/***/ }),

/***/ 40624:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ue": function() { return /* binding */ create; }
});

// UNUSED EXPORTS: createStore, default, useStore

;// CONCATENATED MODULE: ../../node_modules/zustand/esm/vanilla.mjs
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState = () => initialState;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if (( false ? 0 : void 0) !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners.clear();
  };
  const api = { setState, getState, getInitialState, subscribe, destroy };
  const initialState = state = createState(setState, getState, api);
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;
var vanilla = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'."
    );
  }
  return createStore(createState);
};



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(41110);
;// CONCATENATED MODULE: ../../node_modules/zustand/esm/index.mjs





const { useDebugValue } = react;
const { useSyncExternalStoreWithSelector } = with_selector;
let didWarnAboutEqualityFn = false;
const identity = (arg) => arg;
function useStore(api, selector = identity, equalityFn) {
  if (( false ? 0 : void 0) !== "production" && equalityFn && !didWarnAboutEqualityFn) {
    console.warn(
      "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
    );
    didWarnAboutEqualityFn = true;
  }
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getInitialState,
    selector,
    equalityFn
  );
  useDebugValue(slice);
  return slice;
}
const createImpl = (createState) => {
  if (( false ? 0 : void 0) !== "production" && typeof createState !== "function") {
    console.warn(
      "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
    );
  }
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var esm_react = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`."
    );
  }
  return create(createState);
};




/***/ }),

/***/ 94534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useShallow; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function shallow(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  if (objA instanceof Map && objB instanceof Map) {
    if (objA.size !== objB.size)
      return false;
    for (const [key, value] of objA) {
      if (!Object.is(value, objB.get(key))) {
        return false;
      }
    }
    return true;
  }
  if (objA instanceof Set && objB instanceof Set) {
    if (objA.size !== objB.size)
      return false;
    for (const value of objA) {
      if (!objB.has(value)) {
        return false;
      }
    }
    return true;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}

const { useRef } = react__WEBPACK_IMPORTED_MODULE_0__;
function useShallow(selector) {
  const prev = useRef();
  return (state) => {
    const next = selector(state);
    return shallow(prev.current, next) ? prev.current : prev.current = next;
  };
}




/***/ }),

/***/ 4147:
/***/ (function(module) {

"use strict";
module.exports = {"i8":"1.164.0"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(24458), __webpack_exec__(26011), __webpack_exec__(86570), __webpack_exec__(93642); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);